var eoe = Object.defineProperty;
var toe = (e, t, n) => t in e ? eoe(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var ap = (e, t, n) => toe(e, typeof t != "symbol" ? t + "" : t, n);
import * as V from "react";
import se, { forwardRef as w6, useContext as Rm, useMemo as vn, Component as noe, useRef as rs, useState as Et, useEffect as rn, useReducer as zR, useCallback as Cn, Children as roe, isValidElement as Fx, cloneElement as $x, Fragment as P6, createContext as BC, createElement as DD, createRef as ou, memo as k6, useImperativeHandle as ioe } from "react";
import * as ooe from "react-dom";
import T1 from "react-dom";
function soe(e, t) {
  for (var n = 0; n < t.length; n++) {
    const r = t[n];
    if (typeof r != "string" && !Array.isArray(r)) {
      for (const i in r)
        if (i !== "default" && !(i in e)) {
          const o = Object.getOwnPropertyDescriptor(r, i);
          o && Object.defineProperty(e, i, o.get ? o : {
            enumerable: !0,
            get: () => r[i]
          });
        }
    }
  }
  return Object.freeze(Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }));
}
var Kr = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Ln(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function Tl(e) {
  if (e.__esModule) return e;
  var t = e.default;
  if (typeof t == "function") {
    var n = function r() {
      return this instanceof r ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    n.prototype = t.prototype;
  } else n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(e).forEach(function(r) {
    var i = Object.getOwnPropertyDescriptor(e, r);
    Object.defineProperty(n, r, i.get ? i : {
      enumerable: !0,
      get: function() {
        return e[r];
      }
    });
  }), n;
}
var dP = { exports: {} }, gy = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var UR;
function aoe() {
  if (UR) return gy;
  UR = 1;
  var e = se, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, i = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function s(a, u, c) {
    var d, f = {}, h = null, m = null;
    c !== void 0 && (h = "" + c), u.key !== void 0 && (h = "" + u.key), u.ref !== void 0 && (m = u.ref);
    for (d in u) r.call(u, d) && !o.hasOwnProperty(d) && (f[d] = u[d]);
    if (a && a.defaultProps) for (d in u = a.defaultProps, u) f[d] === void 0 && (f[d] = u[d]);
    return { $$typeof: t, type: a, key: h, ref: m, props: f, _owner: i.current };
  }
  return gy.Fragment = n, gy.jsx = s, gy.jsxs = s, gy;
}
var yy = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var WR;
function loe() {
  return WR || (WR = 1, process.env.NODE_ENV !== "production" && function() {
    var e = se, t = Symbol.for("react.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), a = Symbol.for("react.context"), u = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), m = Symbol.for("react.offscreen"), v = Symbol.iterator, x = "@@iterator";
    function C(ve) {
      if (ve === null || typeof ve != "object")
        return null;
      var tt = v && ve[v] || ve[x];
      return typeof tt == "function" ? tt : null;
    }
    var E = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function S(ve) {
      {
        for (var tt = arguments.length, xt = new Array(tt > 1 ? tt - 1 : 0), Oe = 1; Oe < tt; Oe++)
          xt[Oe - 1] = arguments[Oe];
        w("error", ve, xt);
      }
    }
    function w(ve, tt, xt) {
      {
        var Oe = E.ReactDebugCurrentFrame, Fe = Oe.getStackAddendum();
        Fe !== "" && (tt += "%s", xt = xt.concat([Fe]));
        var et = xt.map(function(Ke) {
          return String(Ke);
        });
        et.unshift("Warning: " + tt), Function.prototype.apply.call(console[ve], console, et);
      }
    }
    var O = !1, A = !1, I = !1, $ = !1, L = !1, B;
    B = Symbol.for("react.module.reference");
    function H(ve) {
      return !!(typeof ve == "string" || typeof ve == "function" || ve === r || ve === o || L || ve === i || ve === c || ve === d || $ || ve === m || O || A || I || typeof ve == "object" && ve !== null && (ve.$$typeof === h || ve.$$typeof === f || ve.$$typeof === s || ve.$$typeof === a || ve.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      ve.$$typeof === B || ve.getModuleId !== void 0));
    }
    function q(ve, tt, xt) {
      var Oe = ve.displayName;
      if (Oe)
        return Oe;
      var Fe = tt.displayName || tt.name || "";
      return Fe !== "" ? xt + "(" + Fe + ")" : xt;
    }
    function J(ve) {
      return ve.displayName || "Context";
    }
    function X(ve) {
      if (ve == null)
        return null;
      if (typeof ve.tag == "number" && S("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof ve == "function")
        return ve.displayName || ve.name || null;
      if (typeof ve == "string")
        return ve;
      switch (ve) {
        case r:
          return "Fragment";
        case n:
          return "Portal";
        case o:
          return "Profiler";
        case i:
          return "StrictMode";
        case c:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof ve == "object")
        switch (ve.$$typeof) {
          case a:
            var tt = ve;
            return J(tt) + ".Consumer";
          case s:
            var xt = ve;
            return J(xt._context) + ".Provider";
          case u:
            return q(ve, ve.render, "ForwardRef");
          case f:
            var Oe = ve.displayName || null;
            return Oe !== null ? Oe : X(ve.type) || "Memo";
          case h: {
            var Fe = ve, et = Fe._payload, Ke = Fe._init;
            try {
              return X(Ke(et));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var j = Object.assign, U = 0, G, K, ee, te, M, Z, ne;
    function R() {
    }
    R.__reactDisabledLog = !0;
    function _() {
      {
        if (U === 0) {
          G = console.log, K = console.info, ee = console.warn, te = console.error, M = console.group, Z = console.groupCollapsed, ne = console.groupEnd;
          var ve = {
            configurable: !0,
            enumerable: !0,
            value: R,
            writable: !0
          };
          Object.defineProperties(console, {
            info: ve,
            log: ve,
            warn: ve,
            error: ve,
            group: ve,
            groupCollapsed: ve,
            groupEnd: ve
          });
        }
        U++;
      }
    }
    function W() {
      {
        if (U--, U === 0) {
          var ve = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: j({}, ve, {
              value: G
            }),
            info: j({}, ve, {
              value: K
            }),
            warn: j({}, ve, {
              value: ee
            }),
            error: j({}, ve, {
              value: te
            }),
            group: j({}, ve, {
              value: M
            }),
            groupCollapsed: j({}, ve, {
              value: Z
            }),
            groupEnd: j({}, ve, {
              value: ne
            })
          });
        }
        U < 0 && S("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Q = E.ReactCurrentDispatcher, oe;
    function ae(ve, tt, xt) {
      {
        if (oe === void 0)
          try {
            throw Error();
          } catch (Fe) {
            var Oe = Fe.stack.trim().match(/\n( *(at )?)/);
            oe = Oe && Oe[1] || "";
          }
        return `
` + oe + ve;
      }
    }
    var pe = !1, me;
    {
      var xe = typeof WeakMap == "function" ? WeakMap : Map;
      me = new xe();
    }
    function le(ve, tt) {
      if (!ve || pe)
        return "";
      {
        var xt = me.get(ve);
        if (xt !== void 0)
          return xt;
      }
      var Oe;
      pe = !0;
      var Fe = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var et;
      et = Q.current, Q.current = null, _();
      try {
        if (tt) {
          var Ke = function() {
            throw Error();
          };
          if (Object.defineProperty(Ke.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(Ke, []);
            } catch (Ki) {
              Oe = Ki;
            }
            Reflect.construct(ve, [], Ke);
          } else {
            try {
              Ke.call();
            } catch (Ki) {
              Oe = Ki;
            }
            ve.call(Ke.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Ki) {
            Oe = Ki;
          }
          ve();
        }
      } catch (Ki) {
        if (Ki && Oe && typeof Ki.stack == "string") {
          for (var ct = Ki.stack.split(`
`), gt = Oe.stack.split(`
`), Ht = ct.length - 1, Pn = gt.length - 1; Ht >= 1 && Pn >= 0 && ct[Ht] !== gt[Pn]; )
            Pn--;
          for (; Ht >= 1 && Pn >= 0; Ht--, Pn--)
            if (ct[Ht] !== gt[Pn]) {
              if (Ht !== 1 || Pn !== 1)
                do
                  if (Ht--, Pn--, Pn < 0 || ct[Ht] !== gt[Pn]) {
                    var tr = `
` + ct[Ht].replace(" at new ", " at ");
                    return ve.displayName && tr.includes("<anonymous>") && (tr = tr.replace("<anonymous>", ve.displayName)), typeof ve == "function" && me.set(ve, tr), tr;
                  }
                while (Ht >= 1 && Pn >= 0);
              break;
            }
        }
      } finally {
        pe = !1, Q.current = et, W(), Error.prepareStackTrace = Fe;
      }
      var Uo = ve ? ve.displayName || ve.name : "", Oo = Uo ? ae(Uo) : "";
      return typeof ve == "function" && me.set(ve, Oo), Oo;
    }
    function ye(ve, tt, xt) {
      return le(ve, !1);
    }
    function be(ve) {
      var tt = ve.prototype;
      return !!(tt && tt.isReactComponent);
    }
    function Re(ve, tt, xt) {
      if (ve == null)
        return "";
      if (typeof ve == "function")
        return le(ve, be(ve));
      if (typeof ve == "string")
        return ae(ve);
      switch (ve) {
        case c:
          return ae("Suspense");
        case d:
          return ae("SuspenseList");
      }
      if (typeof ve == "object")
        switch (ve.$$typeof) {
          case u:
            return ye(ve.render);
          case f:
            return Re(ve.type, tt, xt);
          case h: {
            var Oe = ve, Fe = Oe._payload, et = Oe._init;
            try {
              return Re(et(Fe), tt, xt);
            } catch {
            }
          }
        }
      return "";
    }
    var Te = Object.prototype.hasOwnProperty, Xe = {}, Ne = E.ReactDebugCurrentFrame;
    function Qe(ve) {
      if (ve) {
        var tt = ve._owner, xt = Re(ve.type, ve._source, tt ? tt.type : null);
        Ne.setExtraStackFrame(xt);
      } else
        Ne.setExtraStackFrame(null);
    }
    function Ee(ve, tt, xt, Oe, Fe) {
      {
        var et = Function.call.bind(Te);
        for (var Ke in ve)
          if (et(ve, Ke)) {
            var ct = void 0;
            try {
              if (typeof ve[Ke] != "function") {
                var gt = Error((Oe || "React class") + ": " + xt + " type `" + Ke + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof ve[Ke] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw gt.name = "Invariant Violation", gt;
              }
              ct = ve[Ke](tt, Ke, Oe, xt, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Ht) {
              ct = Ht;
            }
            ct && !(ct instanceof Error) && (Qe(Fe), S("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", Oe || "React class", xt, Ke, typeof ct), Qe(null)), ct instanceof Error && !(ct.message in Xe) && (Xe[ct.message] = !0, Qe(Fe), S("Failed %s type: %s", xt, ct.message), Qe(null));
          }
      }
    }
    var Ie = Array.isArray;
    function Je(ve) {
      return Ie(ve);
    }
    function vt(ve) {
      {
        var tt = typeof Symbol == "function" && Symbol.toStringTag, xt = tt && ve[Symbol.toStringTag] || ve.constructor.name || "Object";
        return xt;
      }
    }
    function St(ve) {
      try {
        return Lt(ve), !1;
      } catch {
        return !0;
      }
    }
    function Lt(ve) {
      return "" + ve;
    }
    function ke(ve) {
      if (St(ve))
        return S("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", vt(ve)), Lt(ve);
    }
    var Le = E.ReactCurrentOwner, Pe = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Ae, We, At;
    At = {};
    function Ft(ve) {
      if (Te.call(ve, "ref")) {
        var tt = Object.getOwnPropertyDescriptor(ve, "ref").get;
        if (tt && tt.isReactWarning)
          return !1;
      }
      return ve.ref !== void 0;
    }
    function Ct(ve) {
      if (Te.call(ve, "key")) {
        var tt = Object.getOwnPropertyDescriptor(ve, "key").get;
        if (tt && tt.isReactWarning)
          return !1;
      }
      return ve.key !== void 0;
    }
    function ht(ve, tt) {
      if (typeof ve.ref == "string" && Le.current && tt && Le.current.stateNode !== tt) {
        var xt = X(Le.current.type);
        At[xt] || (S('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', X(Le.current.type), ve.ref), At[xt] = !0);
      }
    }
    function He(ve, tt) {
      {
        var xt = function() {
          Ae || (Ae = !0, S("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", tt));
        };
        xt.isReactWarning = !0, Object.defineProperty(ve, "key", {
          get: xt,
          configurable: !0
        });
      }
    }
    function qe(ve, tt) {
      {
        var xt = function() {
          We || (We = !0, S("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", tt));
        };
        xt.isReactWarning = !0, Object.defineProperty(ve, "ref", {
          get: xt,
          configurable: !0
        });
      }
    }
    var wt = function(ve, tt, xt, Oe, Fe, et, Ke) {
      var ct = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: ve,
        key: tt,
        ref: xt,
        props: Ke,
        // Record the component responsible for creating this element.
        _owner: et
      };
      return ct._store = {}, Object.defineProperty(ct._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(ct, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Oe
      }), Object.defineProperty(ct, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Fe
      }), Object.freeze && (Object.freeze(ct.props), Object.freeze(ct)), ct;
    };
    function Ut(ve, tt, xt, Oe, Fe) {
      {
        var et, Ke = {}, ct = null, gt = null;
        xt !== void 0 && (ke(xt), ct = "" + xt), Ct(tt) && (ke(tt.key), ct = "" + tt.key), Ft(tt) && (gt = tt.ref, ht(tt, Fe));
        for (et in tt)
          Te.call(tt, et) && !Pe.hasOwnProperty(et) && (Ke[et] = tt[et]);
        if (ve && ve.defaultProps) {
          var Ht = ve.defaultProps;
          for (et in Ht)
            Ke[et] === void 0 && (Ke[et] = Ht[et]);
        }
        if (ct || gt) {
          var Pn = typeof ve == "function" ? ve.displayName || ve.name || "Unknown" : ve;
          ct && He(Ke, Pn), gt && qe(Ke, Pn);
        }
        return wt(ve, ct, gt, Fe, Oe, Le.current, Ke);
      }
    }
    var an = E.ReactCurrentOwner, wn = E.ReactDebugCurrentFrame;
    function En(ve) {
      if (ve) {
        var tt = ve._owner, xt = Re(ve.type, ve._source, tt ? tt.type : null);
        wn.setExtraStackFrame(xt);
      } else
        wn.setExtraStackFrame(null);
    }
    var sr;
    sr = !1;
    function er(ve) {
      return typeof ve == "object" && ve !== null && ve.$$typeof === t;
    }
    function pn() {
      {
        if (an.current) {
          var ve = X(an.current.type);
          if (ve)
            return `

Check the render method of \`` + ve + "`.";
        }
        return "";
      }
    }
    function Pr(ve) {
      return "";
    }
    var bi = {};
    function Wr(ve) {
      {
        var tt = pn();
        if (!tt) {
          var xt = typeof ve == "string" ? ve : ve.displayName || ve.name;
          xt && (tt = `

Check the top-level render call using <` + xt + ">.");
        }
        return tt;
      }
    }
    function Po(ve, tt) {
      {
        if (!ve._store || ve._store.validated || ve.key != null)
          return;
        ve._store.validated = !0;
        var xt = Wr(tt);
        if (bi[xt])
          return;
        bi[xt] = !0;
        var Oe = "";
        ve && ve._owner && ve._owner !== an.current && (Oe = " It was passed a child from " + X(ve._owner.type) + "."), En(ve), S('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', xt, Oe), En(null);
      }
    }
    function _r(ve, tt) {
      {
        if (typeof ve != "object")
          return;
        if (Je(ve))
          for (var xt = 0; xt < ve.length; xt++) {
            var Oe = ve[xt];
            er(Oe) && Po(Oe, tt);
          }
        else if (er(ve))
          ve._store && (ve._store.validated = !0);
        else if (ve) {
          var Fe = C(ve);
          if (typeof Fe == "function" && Fe !== ve.entries)
            for (var et = Fe.call(ve), Ke; !(Ke = et.next()).done; )
              er(Ke.value) && Po(Ke.value, tt);
        }
      }
    }
    function Lr(ve) {
      {
        var tt = ve.type;
        if (tt == null || typeof tt == "string")
          return;
        var xt;
        if (typeof tt == "function")
          xt = tt.propTypes;
        else if (typeof tt == "object" && (tt.$$typeof === u || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        tt.$$typeof === f))
          xt = tt.propTypes;
        else
          return;
        if (xt) {
          var Oe = X(tt);
          Ee(xt, ve.props, "prop", Oe, ve);
        } else if (tt.PropTypes !== void 0 && !sr) {
          sr = !0;
          var Fe = X(tt);
          S("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", Fe || "Unknown");
        }
        typeof tt.getDefaultProps == "function" && !tt.getDefaultProps.isReactClassApproved && S("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Gn(ve) {
      {
        for (var tt = Object.keys(ve.props), xt = 0; xt < tt.length; xt++) {
          var Oe = tt[xt];
          if (Oe !== "children" && Oe !== "key") {
            En(ve), S("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", Oe), En(null);
            break;
          }
        }
        ve.ref !== null && (En(ve), S("Invalid attribute `ref` supplied to `React.Fragment`."), En(null));
      }
    }
    var Hr = {};
    function Qn(ve, tt, xt, Oe, Fe, et) {
      {
        var Ke = H(ve);
        if (!Ke) {
          var ct = "";
          (ve === void 0 || typeof ve == "object" && ve !== null && Object.keys(ve).length === 0) && (ct += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var gt = Pr();
          gt ? ct += gt : ct += pn();
          var Ht;
          ve === null ? Ht = "null" : Je(ve) ? Ht = "array" : ve !== void 0 && ve.$$typeof === t ? (Ht = "<" + (X(ve.type) || "Unknown") + " />", ct = " Did you accidentally export a JSX literal instead of a component?") : Ht = typeof ve, S("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Ht, ct);
        }
        var Pn = Ut(ve, tt, xt, Fe, et);
        if (Pn == null)
          return Pn;
        if (Ke) {
          var tr = tt.children;
          if (tr !== void 0)
            if (Oe)
              if (Je(tr)) {
                for (var Uo = 0; Uo < tr.length; Uo++)
                  _r(tr[Uo], ve);
                Object.freeze && Object.freeze(tr);
              } else
                S("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              _r(tr, ve);
        }
        if (Te.call(tt, "key")) {
          var Oo = X(ve), Ki = Object.keys(tt).filter(function(Ce) {
            return Ce !== "key";
          }), Vd = Ki.length > 0 ? "{key: someKey, " + Ki.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Hr[Oo + Vd]) {
            var $g = Ki.length > 0 ? "{" + Ki.join(": ..., ") + ": ...}" : "{}";
            S(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Vd, Oo, $g, Oo), Hr[Oo + Vd] = !0;
          }
        }
        return ve === r ? Gn(Pn) : Lr(Pn), Pn;
      }
    }
    function ao(ve, tt, xt) {
      return Qn(ve, tt, xt, !0);
    }
    function Ls(ve, tt, xt) {
      return Qn(ve, tt, xt, !1);
    }
    var Mi = Ls, ko = ao;
    yy.Fragment = r, yy.jsx = Mi, yy.jsxs = ko;
  }()), yy;
}
process.env.NODE_ENV === "production" ? dP.exports = aoe() : dP.exports = loe();
var P = dP.exports, uoe = !1;
function coe(e) {
  if (e.sheet)
    return e.sheet;
  for (var t = 0; t < document.styleSheets.length; t++)
    if (document.styleSheets[t].ownerNode === e)
      return document.styleSheets[t];
}
function doe(e) {
  var t = document.createElement("style");
  return t.setAttribute("data-emotion", e.key), e.nonce !== void 0 && t.setAttribute("nonce", e.nonce), t.appendChild(document.createTextNode("")), t.setAttribute("data-s", ""), t;
}
var poe = /* @__PURE__ */ function() {
  function e(n) {
    var r = this;
    this._insertTag = function(i) {
      var o;
      r.tags.length === 0 ? r.insertionPoint ? o = r.insertionPoint.nextSibling : r.prepend ? o = r.container.firstChild : o = r.before : o = r.tags[r.tags.length - 1].nextSibling, r.container.insertBefore(i, o), r.tags.push(i);
    }, this.isSpeedy = n.speedy === void 0 ? !uoe : n.speedy, this.tags = [], this.ctr = 0, this.nonce = n.nonce, this.key = n.key, this.container = n.container, this.prepend = n.prepend, this.insertionPoint = n.insertionPoint, this.before = null;
  }
  var t = e.prototype;
  return t.hydrate = function(r) {
    r.forEach(this._insertTag);
  }, t.insert = function(r) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(doe(this));
    var i = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var o = coe(i);
      try {
        o.insertRule(r, o.cssRules.length);
      } catch {
      }
    } else
      i.appendChild(document.createTextNode(r));
    this.ctr++;
  }, t.flush = function() {
    this.tags.forEach(function(r) {
      var i;
      return (i = r.parentNode) == null ? void 0 : i.removeChild(r);
    }), this.tags = [], this.ctr = 0;
  }, e;
}(), $o = "-ms-", CD = "-moz-", hr = "-webkit-", O6 = "comm", NO = "rule", MO = "decl", foe = "@import", I6 = "@keyframes", hoe = "@layer", moe = Math.abs, jC = String.fromCharCode, goe = Object.assign;
function yoe(e, t) {
  return fo(e, 0) ^ 45 ? (((t << 2 ^ fo(e, 0)) << 2 ^ fo(e, 1)) << 2 ^ fo(e, 2)) << 2 ^ fo(e, 3) : 0;
}
function F6(e) {
  return e.trim();
}
function boe(e, t) {
  return (e = t.exec(e)) ? e[0] : e;
}
function mr(e, t, n) {
  return e.replace(t, n);
}
function pP(e, t) {
  return e.indexOf(t);
}
function fo(e, t) {
  return e.charCodeAt(t) | 0;
}
function P0(e, t, n) {
  return e.slice(t, n);
}
function Hl(e) {
  return e.length;
}
function RO(e) {
  return e.length;
}
function S1(e, t) {
  return t.push(e), e;
}
function voe(e, t) {
  return e.map(t).join("");
}
var VC = 1, sm = 1, $6 = 0, Is = 0, $i = 0, _m = "";
function zC(e, t, n, r, i, o, s) {
  return { value: e, root: t, parent: n, type: r, props: i, children: o, line: VC, column: sm, length: s, return: "" };
}
function by(e, t) {
  return goe(zC("", null, null, "", null, null, 0), e, { length: -e.length }, t);
}
function xoe() {
  return $i;
}
function Doe() {
  return $i = Is > 0 ? fo(_m, --Is) : 0, sm--, $i === 10 && (sm = 1, VC--), $i;
}
function na() {
  return $i = Is < $6 ? fo(_m, Is++) : 0, sm++, $i === 10 && (sm = 1, VC++), $i;
}
function su() {
  return fo(_m, Is);
}
function Nx() {
  return Is;
}
function vb(e, t) {
  return P0(_m, e, t);
}
function k0(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function N6(e) {
  return VC = sm = 1, $6 = Hl(_m = e), Is = 0, [];
}
function M6(e) {
  return _m = "", e;
}
function Mx(e) {
  return F6(vb(Is - 1, fP(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function Coe(e) {
  for (; ($i = su()) && $i < 33; )
    na();
  return k0(e) > 2 || k0($i) > 3 ? "" : " ";
}
function Eoe(e, t) {
  for (; --t && na() && !($i < 48 || $i > 102 || $i > 57 && $i < 65 || $i > 70 && $i < 97); )
    ;
  return vb(e, Nx() + (t < 6 && su() == 32 && na() == 32));
}
function fP(e) {
  for (; na(); )
    switch ($i) {
      case e:
        return Is;
      case 34:
      case 39:
        e !== 34 && e !== 39 && fP($i);
        break;
      case 40:
        e === 41 && fP(e);
        break;
      case 92:
        na();
        break;
    }
  return Is;
}
function Toe(e, t) {
  for (; na() && e + $i !== 57; )
    if (e + $i === 84 && su() === 47)
      break;
  return "/*" + vb(t, Is - 1) + "*" + jC(e === 47 ? e : na());
}
function Soe(e) {
  for (; !k0(su()); )
    na();
  return vb(e, Is);
}
function Aoe(e) {
  return M6(Rx("", null, null, null, [""], e = N6(e), 0, [0], e));
}
function Rx(e, t, n, r, i, o, s, a, u) {
  for (var c = 0, d = 0, f = s, h = 0, m = 0, v = 0, x = 1, C = 1, E = 1, S = 0, w = "", O = i, A = o, I = r, $ = w; C; )
    switch (v = S, S = na()) {
      case 40:
        if (v != 108 && fo($, f - 1) == 58) {
          pP($ += mr(Mx(S), "&", "&\f"), "&\f") != -1 && (E = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        $ += Mx(S);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        $ += Coe(v);
        break;
      case 92:
        $ += Eoe(Nx() - 1, 7);
        continue;
      case 47:
        switch (su()) {
          case 42:
          case 47:
            S1(woe(Toe(na(), Nx()), t, n), u);
            break;
          default:
            $ += "/";
        }
        break;
      case 123 * x:
        a[c++] = Hl($) * E;
      case 125 * x:
      case 59:
      case 0:
        switch (S) {
          case 0:
          case 125:
            C = 0;
          case 59 + d:
            E == -1 && ($ = mr($, /\f/g, "")), m > 0 && Hl($) - f && S1(m > 32 ? qR($ + ";", r, n, f - 1) : qR(mr($, " ", "") + ";", r, n, f - 2), u);
            break;
          case 59:
            $ += ";";
          default:
            if (S1(I = HR($, t, n, c, d, i, a, w, O = [], A = [], f), o), S === 123)
              if (d === 0)
                Rx($, t, I, I, O, o, f, a, A);
              else
                switch (h === 99 && fo($, 3) === 110 ? 100 : h) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    Rx(e, I, I, r && S1(HR(e, I, I, 0, 0, i, a, w, i, O = [], f), A), i, A, f, a, r ? O : A);
                    break;
                  default:
                    Rx($, I, I, I, [""], A, 0, a, A);
                }
        }
        c = d = m = 0, x = E = 1, w = $ = "", f = s;
        break;
      case 58:
        f = 1 + Hl($), m = v;
      default:
        if (x < 1) {
          if (S == 123)
            --x;
          else if (S == 125 && x++ == 0 && Doe() == 125)
            continue;
        }
        switch ($ += jC(S), S * x) {
          case 38:
            E = d > 0 ? 1 : ($ += "\f", -1);
            break;
          case 44:
            a[c++] = (Hl($) - 1) * E, E = 1;
            break;
          case 64:
            su() === 45 && ($ += Mx(na())), h = su(), d = f = Hl(w = $ += Soe(Nx())), S++;
            break;
          case 45:
            v === 45 && Hl($) == 2 && (x = 0);
        }
    }
  return o;
}
function HR(e, t, n, r, i, o, s, a, u, c, d) {
  for (var f = i - 1, h = i === 0 ? o : [""], m = RO(h), v = 0, x = 0, C = 0; v < r; ++v)
    for (var E = 0, S = P0(e, f + 1, f = moe(x = s[v])), w = e; E < m; ++E)
      (w = F6(x > 0 ? h[E] + " " + S : mr(S, /&\f/g, h[E]))) && (u[C++] = w);
  return zC(e, t, n, i === 0 ? NO : a, u, c, d);
}
function woe(e, t, n) {
  return zC(e, t, n, O6, jC(xoe()), P0(e, 2, -2), 0);
}
function qR(e, t, n, r) {
  return zC(e, t, n, MO, P0(e, 0, r), P0(e, r + 1, -1), r);
}
function Uh(e, t) {
  for (var n = "", r = RO(e), i = 0; i < r; i++)
    n += t(e[i], i, e, t) || "";
  return n;
}
function Poe(e, t, n, r) {
  switch (e.type) {
    case hoe:
      if (e.children.length) break;
    case foe:
    case MO:
      return e.return = e.return || e.value;
    case O6:
      return "";
    case I6:
      return e.return = e.value + "{" + Uh(e.children, r) + "}";
    case NO:
      e.value = e.props.join(",");
  }
  return Hl(n = Uh(e.children, r)) ? e.return = e.value + "{" + n + "}" : "";
}
function koe(e) {
  var t = RO(e);
  return function(n, r, i, o) {
    for (var s = "", a = 0; a < t; a++)
      s += e[a](n, r, i, o) || "";
    return s;
  };
}
function Ooe(e) {
  return function(t) {
    t.root || (t = t.return) && e(t);
  };
}
var GR = function(t) {
  var n = /* @__PURE__ */ new WeakMap();
  return function(r) {
    if (n.has(r))
      return n.get(r);
    var i = t(r);
    return n.set(r, i), i;
  };
};
function R6(e) {
  var t = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return t[n] === void 0 && (t[n] = e(n)), t[n];
  };
}
var Ioe = function(t, n, r) {
  for (var i = 0, o = 0; i = o, o = su(), i === 38 && o === 12 && (n[r] = 1), !k0(o); )
    na();
  return vb(t, Is);
}, Foe = function(t, n) {
  var r = -1, i = 44;
  do
    switch (k0(i)) {
      case 0:
        i === 38 && su() === 12 && (n[r] = 1), t[r] += Ioe(Is - 1, n, r);
        break;
      case 2:
        t[r] += Mx(i);
        break;
      case 4:
        if (i === 44) {
          t[++r] = su() === 58 ? "&\f" : "", n[r] = t[r].length;
          break;
        }
      default:
        t[r] += jC(i);
    }
  while (i = na());
  return t;
}, $oe = function(t, n) {
  return M6(Foe(N6(t), n));
}, YR = /* @__PURE__ */ new WeakMap(), Noe = function(t) {
  if (!(t.type !== "rule" || !t.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  t.length < 1)) {
    for (var n = t.value, r = t.parent, i = t.column === r.column && t.line === r.line; r.type !== "rule"; )
      if (r = r.parent, !r) return;
    if (!(t.props.length === 1 && n.charCodeAt(0) !== 58 && !YR.get(r)) && !i) {
      YR.set(t, !0);
      for (var o = [], s = $oe(n, o), a = r.props, u = 0, c = 0; u < s.length; u++)
        for (var d = 0; d < a.length; d++, c++)
          t.props[c] = o[u] ? s[u].replace(/&\f/g, a[d]) : a[d] + " " + s[u];
    }
  }
}, Moe = function(t) {
  if (t.type === "decl") {
    var n = t.value;
    // charcode for l
    n.charCodeAt(0) === 108 && // charcode for b
    n.charCodeAt(2) === 98 && (t.return = "", t.value = "");
  }
};
function _6(e, t) {
  switch (yoe(e, t)) {
    case 5103:
      return hr + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return hr + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return hr + e + CD + e + $o + e + e;
    case 6828:
    case 4268:
      return hr + e + $o + e + e;
    case 6165:
      return hr + e + $o + "flex-" + e + e;
    case 5187:
      return hr + e + mr(e, /(\w+).+(:[^]+)/, hr + "box-$1$2" + $o + "flex-$1$2") + e;
    case 5443:
      return hr + e + $o + "flex-item-" + mr(e, /flex-|-self/, "") + e;
    case 4675:
      return hr + e + $o + "flex-line-pack" + mr(e, /align-content|flex-|-self/, "") + e;
    case 5548:
      return hr + e + $o + mr(e, "shrink", "negative") + e;
    case 5292:
      return hr + e + $o + mr(e, "basis", "preferred-size") + e;
    case 6060:
      return hr + "box-" + mr(e, "-grow", "") + hr + e + $o + mr(e, "grow", "positive") + e;
    case 4554:
      return hr + mr(e, /([^-])(transform)/g, "$1" + hr + "$2") + e;
    case 6187:
      return mr(mr(mr(e, /(zoom-|grab)/, hr + "$1"), /(image-set)/, hr + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return mr(e, /(image-set\([^]*)/, hr + "$1$`$1");
    case 4968:
      return mr(mr(e, /(.+:)(flex-)?(.*)/, hr + "box-pack:$3" + $o + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + hr + e + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return mr(e, /(.+)-inline(.+)/, hr + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (Hl(e) - 1 - t > 6) switch (fo(e, t + 1)) {
        case 109:
          if (fo(e, t + 4) !== 45) break;
        case 102:
          return mr(e, /(.+:)(.+)-([^]+)/, "$1" + hr + "$2-$3$1" + CD + (fo(e, t + 3) == 108 ? "$3" : "$2-$3")) + e;
        case 115:
          return ~pP(e, "stretch") ? _6(mr(e, "stretch", "fill-available"), t) + e : e;
      }
      break;
    case 4949:
      if (fo(e, t + 1) !== 115) break;
    case 6444:
      switch (fo(e, Hl(e) - 3 - (~pP(e, "!important") && 10))) {
        case 107:
          return mr(e, ":", ":" + hr) + e;
        case 101:
          return mr(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + hr + (fo(e, 14) === 45 ? "inline-" : "") + "box$3$1" + hr + "$2$3$1" + $o + "$2box$3") + e;
      }
      break;
    case 5936:
      switch (fo(e, t + 11)) {
        case 114:
          return hr + e + $o + mr(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return hr + e + $o + mr(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return hr + e + $o + mr(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return hr + e + $o + e + e;
  }
  return e;
}
var Roe = function(t, n, r, i) {
  if (t.length > -1 && !t.return) switch (t.type) {
    case MO:
      t.return = _6(t.value, t.length);
      break;
    case I6:
      return Uh([by(t, {
        value: mr(t.value, "@", "@" + hr)
      })], i);
    case NO:
      if (t.length) return voe(t.props, function(o) {
        switch (boe(o, /(::plac\w+|:read-\w+)/)) {
          case ":read-only":
          case ":read-write":
            return Uh([by(t, {
              props: [mr(o, /:(read-\w+)/, ":" + CD + "$1")]
            })], i);
          case "::placeholder":
            return Uh([by(t, {
              props: [mr(o, /:(plac\w+)/, ":" + hr + "input-$1")]
            }), by(t, {
              props: [mr(o, /:(plac\w+)/, ":" + CD + "$1")]
            }), by(t, {
              props: [mr(o, /:(plac\w+)/, $o + "input-$1")]
            })], i);
        }
        return "";
      });
  }
}, _oe = [Roe], L6 = function(t) {
  var n = t.key;
  if (n === "css") {
    var r = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(r, function(x) {
      var C = x.getAttribute("data-emotion");
      C.indexOf(" ") !== -1 && (document.head.appendChild(x), x.setAttribute("data-s", ""));
    });
  }
  var i = t.stylisPlugins || _oe, o = {}, s, a = [];
  s = t.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + n + ' "]'),
    function(x) {
      for (var C = x.getAttribute("data-emotion").split(" "), E = 1; E < C.length; E++)
        o[C[E]] = !0;
      a.push(x);
    }
  );
  var u, c = [Noe, Moe];
  {
    var d, f = [Poe, Ooe(function(x) {
      d.insert(x);
    })], h = koe(c.concat(i, f)), m = function(C) {
      return Uh(Aoe(C), h);
    };
    u = function(C, E, S, w) {
      d = S, m(C ? C + "{" + E.styles + "}" : E.styles), w && (v.inserted[E.name] = !0);
    };
  }
  var v = {
    key: n,
    sheet: new poe({
      key: n,
      container: s,
      nonce: t.nonce,
      speedy: t.speedy,
      prepend: t.prepend,
      insertionPoint: t.insertionPoint
    }),
    nonce: t.nonce,
    inserted: o,
    registered: {},
    insert: u
  };
  return v.sheet.hydrate(a), v;
};
function N() {
  return N = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, N.apply(null, arguments);
}
const Loe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get default() {
    return N;
  }
}, Symbol.toStringTag, { value: "Module" }));
var hP = { exports: {} }, br = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var KR;
function Boe() {
  if (KR) return br;
  KR = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, o = e ? Symbol.for("react.profiler") : 60114, s = e ? Symbol.for("react.provider") : 60109, a = e ? Symbol.for("react.context") : 60110, u = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, f = e ? Symbol.for("react.suspense") : 60113, h = e ? Symbol.for("react.suspense_list") : 60120, m = e ? Symbol.for("react.memo") : 60115, v = e ? Symbol.for("react.lazy") : 60116, x = e ? Symbol.for("react.block") : 60121, C = e ? Symbol.for("react.fundamental") : 60117, E = e ? Symbol.for("react.responder") : 60118, S = e ? Symbol.for("react.scope") : 60119;
  function w(A) {
    if (typeof A == "object" && A !== null) {
      var I = A.$$typeof;
      switch (I) {
        case t:
          switch (A = A.type, A) {
            case u:
            case c:
            case r:
            case o:
            case i:
            case f:
              return A;
            default:
              switch (A = A && A.$$typeof, A) {
                case a:
                case d:
                case v:
                case m:
                case s:
                  return A;
                default:
                  return I;
              }
          }
        case n:
          return I;
      }
    }
  }
  function O(A) {
    return w(A) === c;
  }
  return br.AsyncMode = u, br.ConcurrentMode = c, br.ContextConsumer = a, br.ContextProvider = s, br.Element = t, br.ForwardRef = d, br.Fragment = r, br.Lazy = v, br.Memo = m, br.Portal = n, br.Profiler = o, br.StrictMode = i, br.Suspense = f, br.isAsyncMode = function(A) {
    return O(A) || w(A) === u;
  }, br.isConcurrentMode = O, br.isContextConsumer = function(A) {
    return w(A) === a;
  }, br.isContextProvider = function(A) {
    return w(A) === s;
  }, br.isElement = function(A) {
    return typeof A == "object" && A !== null && A.$$typeof === t;
  }, br.isForwardRef = function(A) {
    return w(A) === d;
  }, br.isFragment = function(A) {
    return w(A) === r;
  }, br.isLazy = function(A) {
    return w(A) === v;
  }, br.isMemo = function(A) {
    return w(A) === m;
  }, br.isPortal = function(A) {
    return w(A) === n;
  }, br.isProfiler = function(A) {
    return w(A) === o;
  }, br.isStrictMode = function(A) {
    return w(A) === i;
  }, br.isSuspense = function(A) {
    return w(A) === f;
  }, br.isValidElementType = function(A) {
    return typeof A == "string" || typeof A == "function" || A === r || A === c || A === o || A === i || A === f || A === h || typeof A == "object" && A !== null && (A.$$typeof === v || A.$$typeof === m || A.$$typeof === s || A.$$typeof === a || A.$$typeof === d || A.$$typeof === C || A.$$typeof === E || A.$$typeof === S || A.$$typeof === x);
  }, br.typeOf = w, br;
}
var vr = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var JR;
function joe() {
  return JR || (JR = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, o = e ? Symbol.for("react.profiler") : 60114, s = e ? Symbol.for("react.provider") : 60109, a = e ? Symbol.for("react.context") : 60110, u = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, f = e ? Symbol.for("react.suspense") : 60113, h = e ? Symbol.for("react.suspense_list") : 60120, m = e ? Symbol.for("react.memo") : 60115, v = e ? Symbol.for("react.lazy") : 60116, x = e ? Symbol.for("react.block") : 60121, C = e ? Symbol.for("react.fundamental") : 60117, E = e ? Symbol.for("react.responder") : 60118, S = e ? Symbol.for("react.scope") : 60119;
    function w(le) {
      return typeof le == "string" || typeof le == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      le === r || le === c || le === o || le === i || le === f || le === h || typeof le == "object" && le !== null && (le.$$typeof === v || le.$$typeof === m || le.$$typeof === s || le.$$typeof === a || le.$$typeof === d || le.$$typeof === C || le.$$typeof === E || le.$$typeof === S || le.$$typeof === x);
    }
    function O(le) {
      if (typeof le == "object" && le !== null) {
        var ye = le.$$typeof;
        switch (ye) {
          case t:
            var be = le.type;
            switch (be) {
              case u:
              case c:
              case r:
              case o:
              case i:
              case f:
                return be;
              default:
                var Re = be && be.$$typeof;
                switch (Re) {
                  case a:
                  case d:
                  case v:
                  case m:
                  case s:
                    return Re;
                  default:
                    return ye;
                }
            }
          case n:
            return ye;
        }
      }
    }
    var A = u, I = c, $ = a, L = s, B = t, H = d, q = r, J = v, X = m, j = n, U = o, G = i, K = f, ee = !1;
    function te(le) {
      return ee || (ee = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), M(le) || O(le) === u;
    }
    function M(le) {
      return O(le) === c;
    }
    function Z(le) {
      return O(le) === a;
    }
    function ne(le) {
      return O(le) === s;
    }
    function R(le) {
      return typeof le == "object" && le !== null && le.$$typeof === t;
    }
    function _(le) {
      return O(le) === d;
    }
    function W(le) {
      return O(le) === r;
    }
    function Q(le) {
      return O(le) === v;
    }
    function oe(le) {
      return O(le) === m;
    }
    function ae(le) {
      return O(le) === n;
    }
    function pe(le) {
      return O(le) === o;
    }
    function me(le) {
      return O(le) === i;
    }
    function xe(le) {
      return O(le) === f;
    }
    vr.AsyncMode = A, vr.ConcurrentMode = I, vr.ContextConsumer = $, vr.ContextProvider = L, vr.Element = B, vr.ForwardRef = H, vr.Fragment = q, vr.Lazy = J, vr.Memo = X, vr.Portal = j, vr.Profiler = U, vr.StrictMode = G, vr.Suspense = K, vr.isAsyncMode = te, vr.isConcurrentMode = M, vr.isContextConsumer = Z, vr.isContextProvider = ne, vr.isElement = R, vr.isForwardRef = _, vr.isFragment = W, vr.isLazy = Q, vr.isMemo = oe, vr.isPortal = ae, vr.isProfiler = pe, vr.isStrictMode = me, vr.isSuspense = xe, vr.isValidElementType = w, vr.typeOf = O;
  }()), vr;
}
process.env.NODE_ENV === "production" ? hP.exports = Boe() : hP.exports = joe();
var Voe = hP.exports, B6 = Voe, zoe = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, Uoe = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, j6 = {};
j6[B6.ForwardRef] = zoe;
j6[B6.Memo] = Uoe;
var Woe = !0;
function Hoe(e, t, n) {
  var r = "";
  return n.split(" ").forEach(function(i) {
    e[i] !== void 0 ? t.push(e[i] + ";") : r += i + " ";
  }), r;
}
var V6 = function(t, n, r) {
  var i = t.key + "-" + n.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (r === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  Woe === !1) && t.registered[i] === void 0 && (t.registered[i] = n.styles);
}, z6 = function(t, n, r) {
  V6(t, n, r);
  var i = t.key + "-" + n.name;
  if (t.inserted[n.name] === void 0) {
    var o = n;
    do
      t.insert(n === o ? "." + i : "", o, t.sheet, !0), o = o.next;
    while (o !== void 0);
  }
};
function qoe(e) {
  for (var t = 0, n, r = 0, i = e.length; i >= 4; ++r, i -= 4)
    n = e.charCodeAt(r) & 255 | (e.charCodeAt(++r) & 255) << 8 | (e.charCodeAt(++r) & 255) << 16 | (e.charCodeAt(++r) & 255) << 24, n = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16), n ^= /* k >>> r: */
    n >>> 24, t = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  switch (i) {
    case 3:
      t ^= (e.charCodeAt(r + 2) & 255) << 16;
    case 2:
      t ^= (e.charCodeAt(r + 1) & 255) << 8;
    case 1:
      t ^= e.charCodeAt(r) & 255, t = /* Math.imul(h, m): */
      (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  }
  return t ^= t >>> 13, t = /* Math.imul(h, m): */
  (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), ((t ^ t >>> 15) >>> 0).toString(36);
}
var Goe = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, Yoe = !1, Koe = /[A-Z]|^ms/g, Joe = /_EMO_([^_]+?)_([^]*?)_EMO_/g, U6 = function(t) {
  return t.charCodeAt(1) === 45;
}, XR = function(t) {
  return t != null && typeof t != "boolean";
}, lA = /* @__PURE__ */ R6(function(e) {
  return U6(e) ? e : e.replace(Koe, "-$&").toLowerCase();
}), QR = function(t, n) {
  switch (t) {
    case "animation":
    case "animationName":
      if (typeof n == "string")
        return n.replace(Joe, function(r, i, o) {
          return ql = {
            name: i,
            styles: o,
            next: ql
          }, i;
        });
  }
  return Goe[t] !== 1 && !U6(t) && typeof n == "number" && n !== 0 ? n + "px" : n;
}, Xoe = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function O0(e, t, n) {
  if (n == null)
    return "";
  var r = n;
  if (r.__emotion_styles !== void 0)
    return r;
  switch (typeof n) {
    case "boolean":
      return "";
    case "object": {
      var i = n;
      if (i.anim === 1)
        return ql = {
          name: i.name,
          styles: i.styles,
          next: ql
        }, i.name;
      var o = n;
      if (o.styles !== void 0) {
        var s = o.next;
        if (s !== void 0)
          for (; s !== void 0; )
            ql = {
              name: s.name,
              styles: s.styles,
              next: ql
            }, s = s.next;
        var a = o.styles + ";";
        return a;
      }
      return Qoe(e, t, n);
    }
    case "function": {
      if (e !== void 0) {
        var u = ql, c = n(e);
        return ql = u, O0(e, t, c);
      }
      break;
    }
  }
  var d = n;
  if (t == null)
    return d;
  var f = t[d];
  return f !== void 0 ? f : d;
}
function Qoe(e, t, n) {
  var r = "";
  if (Array.isArray(n))
    for (var i = 0; i < n.length; i++)
      r += O0(e, t, n[i]) + ";";
  else
    for (var o in n) {
      var s = n[o];
      if (typeof s != "object") {
        var a = s;
        t != null && t[a] !== void 0 ? r += o + "{" + t[a] + "}" : XR(a) && (r += lA(o) + ":" + QR(o, a) + ";");
      } else {
        if (o === "NO_COMPONENT_SELECTOR" && Yoe)
          throw new Error(Xoe);
        if (Array.isArray(s) && typeof s[0] == "string" && (t == null || t[s[0]] === void 0))
          for (var u = 0; u < s.length; u++)
            XR(s[u]) && (r += lA(o) + ":" + QR(o, s[u]) + ";");
        else {
          var c = O0(e, t, s);
          switch (o) {
            case "animation":
            case "animationName": {
              r += lA(o) + ":" + c + ";";
              break;
            }
            default:
              r += o + "{" + c + "}";
          }
        }
      }
    }
  return r;
}
var ZR = /label:\s*([^\s;\n{]+)\s*(;|$)/g, ql;
function _O(e, t, n) {
  if (e.length === 1 && typeof e[0] == "object" && e[0] !== null && e[0].styles !== void 0)
    return e[0];
  var r = !0, i = "";
  ql = void 0;
  var o = e[0];
  if (o == null || o.raw === void 0)
    r = !1, i += O0(n, t, o);
  else {
    var s = o;
    i += s[0];
  }
  for (var a = 1; a < e.length; a++)
    if (i += O0(n, t, e[a]), r) {
      var u = o;
      i += u[a];
    }
  ZR.lastIndex = 0;
  for (var c = "", d; (d = ZR.exec(i)) !== null; )
    c += "-" + d[1];
  var f = qoe(i) + c;
  return {
    name: f,
    styles: i,
    next: ql
  };
}
var Zoe = function(t) {
  return t();
}, W6 = V.useInsertionEffect ? V.useInsertionEffect : !1, ese = W6 || Zoe, e_ = W6 || V.useLayoutEffect, H6 = /* @__PURE__ */ V.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ L6({
    key: "css"
  }) : null
), tse = H6.Provider, q6 = function(t) {
  return /* @__PURE__ */ w6(function(n, r) {
    var i = Rm(H6);
    return t(n, i, r);
  });
}, am = /* @__PURE__ */ V.createContext({}), nse = function(t, n) {
  if (typeof n == "function") {
    var r = n(t);
    return r;
  }
  return N({}, t, n);
}, rse = /* @__PURE__ */ GR(function(e) {
  return GR(function(t) {
    return nse(e, t);
  });
}), ise = function(t) {
  var n = V.useContext(am);
  return t.theme !== n && (n = rse(n)(t.theme)), /* @__PURE__ */ V.createElement(am.Provider, {
    value: n
  }, t.children);
}, ose = /* @__PURE__ */ q6(function(e, t) {
  var n = e.styles, r = _O([n], void 0, V.useContext(am)), i = V.useRef();
  return e_(function() {
    var o = t.key + "-global", s = new t.sheet.constructor({
      key: o,
      nonce: t.sheet.nonce,
      container: t.sheet.container,
      speedy: t.sheet.isSpeedy
    }), a = !1, u = document.querySelector('style[data-emotion="' + o + " " + r.name + '"]');
    return t.sheet.tags.length && (s.before = t.sheet.tags[0]), u !== null && (a = !0, u.setAttribute("data-emotion", o), s.hydrate([u])), i.current = [s, a], function() {
      s.flush();
    };
  }, [t]), e_(function() {
    var o = i.current, s = o[0], a = o[1];
    if (a) {
      o[1] = !1;
      return;
    }
    if (r.next !== void 0 && z6(t, r.next, !0), s.tags.length) {
      var u = s.tags[s.tags.length - 1].nextElementSibling;
      s.before = u, s.flush();
    }
    t.insert("", r, s, !1);
  }, [t, r.name]), null;
});
function G6() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return _O(t);
}
var UC = function() {
  var t = G6.apply(void 0, arguments), n = "animation-" + t.name;
  return {
    name: n,
    styles: "@keyframes " + n + "{" + t.styles + "}",
    anim: 1,
    toString: function() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
}, sse = Object.prototype;
function ase(e) {
  var t = e && e.constructor, n = typeof t == "function" && t.prototype || sse;
  return e === n;
}
var WC = ase;
function lse(e, t) {
  return function(n) {
    return e(t(n));
  };
}
var Y6 = lse, use = Y6, cse = use(Object.keys, Object), dse = cse, pse = WC, fse = dse, hse = Object.prototype, mse = hse.hasOwnProperty;
function gse(e) {
  if (!pse(e))
    return fse(e);
  var t = [];
  for (var n in Object(e))
    mse.call(e, n) && n != "constructor" && t.push(n);
  return t;
}
var LO = gse, yse = typeof Kr == "object" && Kr && Kr.Object === Object && Kr, K6 = yse, bse = K6, vse = typeof self == "object" && self && self.Object === Object && self, xse = bse || vse || Function("return this")(), cs = xse, Dse = cs, Cse = Dse.Symbol, Lm = Cse, t_ = Lm, J6 = Object.prototype, Ese = J6.hasOwnProperty, Tse = J6.toString, vy = t_ ? t_.toStringTag : void 0;
function Sse(e) {
  var t = Ese.call(e, vy), n = e[vy];
  try {
    e[vy] = void 0;
    var r = !0;
  } catch {
  }
  var i = Tse.call(e);
  return r && (t ? e[vy] = n : delete e[vy]), i;
}
var Ase = Sse, wse = Object.prototype, Pse = wse.toString;
function kse(e) {
  return Pse.call(e);
}
var Ose = kse, n_ = Lm, Ise = Ase, Fse = Ose, $se = "[object Null]", Nse = "[object Undefined]", r_ = n_ ? n_.toStringTag : void 0;
function Mse(e) {
  return e == null ? e === void 0 ? Nse : $se : r_ && r_ in Object(e) ? Ise(e) : Fse(e);
}
var Cd = Mse;
function Rse(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var la = Rse, _se = Cd, Lse = la, Bse = "[object AsyncFunction]", jse = "[object Function]", Vse = "[object GeneratorFunction]", zse = "[object Proxy]";
function Use(e) {
  if (!Lse(e))
    return !1;
  var t = _se(e);
  return t == jse || t == Vse || t == Bse || t == zse;
}
var HC = Use, Wse = cs, Hse = Wse["__core-js_shared__"], qse = Hse, uA = qse, i_ = function() {
  var e = /[^.]+$/.exec(uA && uA.keys && uA.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function Gse(e) {
  return !!i_ && i_ in e;
}
var Yse = Gse, Kse = Function.prototype, Jse = Kse.toString;
function Xse(e) {
  if (e != null) {
    try {
      return Jse.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var X6 = Xse, Qse = HC, Zse = Yse, eae = la, tae = X6, nae = /[\\^$.*+?()[\]{}|]/g, rae = /^\[object .+?Constructor\]$/, iae = Function.prototype, oae = Object.prototype, sae = iae.toString, aae = oae.hasOwnProperty, lae = RegExp(
  "^" + sae.call(aae).replace(nae, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function uae(e) {
  if (!eae(e) || Zse(e))
    return !1;
  var t = Qse(e) ? lae : rae;
  return t.test(tae(e));
}
var cae = uae;
function dae(e, t) {
  return e == null ? void 0 : e[t];
}
var pae = dae, fae = cae, hae = pae;
function mae(e, t) {
  var n = hae(e, t);
  return fae(n) ? n : void 0;
}
var uf = mae, gae = uf, yae = cs, bae = gae(yae, "DataView"), vae = bae, xae = uf, Dae = cs, Cae = xae(Dae, "Map"), BO = Cae, Eae = uf, Tae = cs, Sae = Eae(Tae, "Promise"), Aae = Sae, wae = uf, Pae = cs, kae = wae(Pae, "Set"), Q6 = kae, Oae = uf, Iae = cs, Fae = Oae(Iae, "WeakMap"), Z6 = Fae, mP = vae, gP = BO, yP = Aae, bP = Q6, vP = Z6, e9 = Cd, Bm = X6, o_ = "[object Map]", $ae = "[object Object]", s_ = "[object Promise]", a_ = "[object Set]", l_ = "[object WeakMap]", u_ = "[object DataView]", Nae = Bm(mP), Mae = Bm(gP), Rae = Bm(yP), _ae = Bm(bP), Lae = Bm(vP), hp = e9;
(mP && hp(new mP(new ArrayBuffer(1))) != u_ || gP && hp(new gP()) != o_ || yP && hp(yP.resolve()) != s_ || bP && hp(new bP()) != a_ || vP && hp(new vP()) != l_) && (hp = function(e) {
  var t = e9(e), n = t == $ae ? e.constructor : void 0, r = n ? Bm(n) : "";
  if (r)
    switch (r) {
      case Nae:
        return u_;
      case Mae:
        return o_;
      case Rae:
        return s_;
      case _ae:
        return a_;
      case Lae:
        return l_;
    }
  return t;
});
var cf = hp;
function Bae(e) {
  return e != null && typeof e == "object";
}
var ua = Bae, jae = Cd, Vae = ua, zae = "[object Arguments]";
function Uae(e) {
  return Vae(e) && jae(e) == zae;
}
var Wae = Uae, c_ = Wae, Hae = ua, t9 = Object.prototype, qae = t9.hasOwnProperty, Gae = t9.propertyIsEnumerable, Yae = c_(/* @__PURE__ */ function() {
  return arguments;
}()) ? c_ : function(e) {
  return Hae(e) && qae.call(e, "callee") && !Gae.call(e, "callee");
}, xb = Yae, Kae = Array.isArray, yi = Kae;
const n9 = /* @__PURE__ */ Ln(yi);
var Jae = 9007199254740991;
function Xae(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= Jae;
}
var jO = Xae, Qae = HC, Zae = jO;
function ele(e) {
  return e != null && Zae(e.length) && !Qae(e);
}
var gc = ele, ED = { exports: {} };
function tle() {
  return !1;
}
var nle = tle;
ED.exports;
(function(e, t) {
  var n = cs, r = nle, i = t && !t.nodeType && t, o = i && !0 && e && !e.nodeType && e, s = o && o.exports === i, a = s ? n.Buffer : void 0, u = a ? a.isBuffer : void 0, c = u || r;
  e.exports = c;
})(ED, ED.exports);
var Db = ED.exports, rle = Cd, ile = jO, ole = ua, sle = "[object Arguments]", ale = "[object Array]", lle = "[object Boolean]", ule = "[object Date]", cle = "[object Error]", dle = "[object Function]", ple = "[object Map]", fle = "[object Number]", hle = "[object Object]", mle = "[object RegExp]", gle = "[object Set]", yle = "[object String]", ble = "[object WeakMap]", vle = "[object ArrayBuffer]", xle = "[object DataView]", Dle = "[object Float32Array]", Cle = "[object Float64Array]", Ele = "[object Int8Array]", Tle = "[object Int16Array]", Sle = "[object Int32Array]", Ale = "[object Uint8Array]", wle = "[object Uint8ClampedArray]", Ple = "[object Uint16Array]", kle = "[object Uint32Array]", qr = {};
qr[Dle] = qr[Cle] = qr[Ele] = qr[Tle] = qr[Sle] = qr[Ale] = qr[wle] = qr[Ple] = qr[kle] = !0;
qr[sle] = qr[ale] = qr[vle] = qr[lle] = qr[xle] = qr[ule] = qr[cle] = qr[dle] = qr[ple] = qr[fle] = qr[hle] = qr[mle] = qr[gle] = qr[yle] = qr[ble] = !1;
function Ole(e) {
  return ole(e) && ile(e.length) && !!qr[rle(e)];
}
var Ile = Ole;
function Fle(e) {
  return function(t) {
    return e(t);
  };
}
var VO = Fle, TD = { exports: {} };
TD.exports;
(function(e, t) {
  var n = K6, r = t && !t.nodeType && t, i = r && !0 && e && !e.nodeType && e, o = i && i.exports === r, s = o && n.process, a = function() {
    try {
      var u = i && i.require && i.require("util").types;
      return u || s && s.binding && s.binding("util");
    } catch {
    }
  }();
  e.exports = a;
})(TD, TD.exports);
var zO = TD.exports, $le = Ile, Nle = VO, d_ = zO, p_ = d_ && d_.isTypedArray, Mle = p_ ? Nle(p_) : $le, qC = Mle, Rle = LO, _le = cf, Lle = xb, Ble = yi, jle = gc, Vle = Db, zle = WC, Ule = qC, Wle = "[object Map]", Hle = "[object Set]", qle = Object.prototype, Gle = qle.hasOwnProperty;
function Yle(e) {
  if (e == null)
    return !0;
  if (jle(e) && (Ble(e) || typeof e == "string" || typeof e.splice == "function" || Vle(e) || Ule(e) || Lle(e)))
    return !e.length;
  var t = _le(e);
  if (t == Wle || t == Hle)
    return !e.size;
  if (zle(e))
    return !Rle(e).length;
  for (var n in e)
    if (Gle.call(e, n))
      return !1;
  return !0;
}
var Kle = Yle;
const xn = /* @__PURE__ */ Ln(Kle);
function Jle(e, t, n, r) {
  var i = -1, o = e == null ? 0 : e.length;
  for (r && o && (n = e[++i]); ++i < o; )
    n = t(n, e[i], i, e);
  return n;
}
var r9 = Jle;
function Xle(e) {
  return function(t) {
    return e == null ? void 0 : e[t];
  };
}
var Qle = Xle, Zle = Qle, eue = {
  // Latin-1 Supplement block.
  À: "A",
  Á: "A",
  Â: "A",
  Ã: "A",
  Ä: "A",
  Å: "A",
  à: "a",
  á: "a",
  â: "a",
  ã: "a",
  ä: "a",
  å: "a",
  Ç: "C",
  ç: "c",
  Ð: "D",
  ð: "d",
  È: "E",
  É: "E",
  Ê: "E",
  Ë: "E",
  è: "e",
  é: "e",
  ê: "e",
  ë: "e",
  Ì: "I",
  Í: "I",
  Î: "I",
  Ï: "I",
  ì: "i",
  í: "i",
  î: "i",
  ï: "i",
  Ñ: "N",
  ñ: "n",
  Ò: "O",
  Ó: "O",
  Ô: "O",
  Õ: "O",
  Ö: "O",
  Ø: "O",
  ò: "o",
  ó: "o",
  ô: "o",
  õ: "o",
  ö: "o",
  ø: "o",
  Ù: "U",
  Ú: "U",
  Û: "U",
  Ü: "U",
  ù: "u",
  ú: "u",
  û: "u",
  ü: "u",
  Ý: "Y",
  ý: "y",
  ÿ: "y",
  Æ: "Ae",
  æ: "ae",
  Þ: "Th",
  þ: "th",
  ß: "ss",
  // Latin Extended-A block.
  Ā: "A",
  Ă: "A",
  Ą: "A",
  ā: "a",
  ă: "a",
  ą: "a",
  Ć: "C",
  Ĉ: "C",
  Ċ: "C",
  Č: "C",
  ć: "c",
  ĉ: "c",
  ċ: "c",
  č: "c",
  Ď: "D",
  Đ: "D",
  ď: "d",
  đ: "d",
  Ē: "E",
  Ĕ: "E",
  Ė: "E",
  Ę: "E",
  Ě: "E",
  ē: "e",
  ĕ: "e",
  ė: "e",
  ę: "e",
  ě: "e",
  Ĝ: "G",
  Ğ: "G",
  Ġ: "G",
  Ģ: "G",
  ĝ: "g",
  ğ: "g",
  ġ: "g",
  ģ: "g",
  Ĥ: "H",
  Ħ: "H",
  ĥ: "h",
  ħ: "h",
  Ĩ: "I",
  Ī: "I",
  Ĭ: "I",
  Į: "I",
  İ: "I",
  ĩ: "i",
  ī: "i",
  ĭ: "i",
  į: "i",
  ı: "i",
  Ĵ: "J",
  ĵ: "j",
  Ķ: "K",
  ķ: "k",
  ĸ: "k",
  Ĺ: "L",
  Ļ: "L",
  Ľ: "L",
  Ŀ: "L",
  Ł: "L",
  ĺ: "l",
  ļ: "l",
  ľ: "l",
  ŀ: "l",
  ł: "l",
  Ń: "N",
  Ņ: "N",
  Ň: "N",
  Ŋ: "N",
  ń: "n",
  ņ: "n",
  ň: "n",
  ŋ: "n",
  Ō: "O",
  Ŏ: "O",
  Ő: "O",
  ō: "o",
  ŏ: "o",
  ő: "o",
  Ŕ: "R",
  Ŗ: "R",
  Ř: "R",
  ŕ: "r",
  ŗ: "r",
  ř: "r",
  Ś: "S",
  Ŝ: "S",
  Ş: "S",
  Š: "S",
  ś: "s",
  ŝ: "s",
  ş: "s",
  š: "s",
  Ţ: "T",
  Ť: "T",
  Ŧ: "T",
  ţ: "t",
  ť: "t",
  ŧ: "t",
  Ũ: "U",
  Ū: "U",
  Ŭ: "U",
  Ů: "U",
  Ű: "U",
  Ų: "U",
  ũ: "u",
  ū: "u",
  ŭ: "u",
  ů: "u",
  ű: "u",
  ų: "u",
  Ŵ: "W",
  ŵ: "w",
  Ŷ: "Y",
  ŷ: "y",
  Ÿ: "Y",
  Ź: "Z",
  Ż: "Z",
  Ž: "Z",
  ź: "z",
  ż: "z",
  ž: "z",
  Ĳ: "IJ",
  ĳ: "ij",
  Œ: "Oe",
  œ: "oe",
  ŉ: "'n",
  ſ: "s"
}, tue = Zle(eue), nue = tue;
function rue(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length, i = Array(r); ++n < r; )
    i[n] = t(e[n], n, e);
  return i;
}
var jm = rue, iue = Cd, oue = ua, sue = "[object Symbol]";
function aue(e) {
  return typeof e == "symbol" || oue(e) && iue(e) == sue;
}
var Vm = aue, f_ = Lm, lue = jm, uue = yi, cue = Vm, due = 1 / 0, h_ = f_ ? f_.prototype : void 0, m_ = h_ ? h_.toString : void 0;
function i9(e) {
  if (typeof e == "string")
    return e;
  if (uue(e))
    return lue(e, i9) + "";
  if (cue(e))
    return m_ ? m_.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -due ? "-0" : t;
}
var pue = i9, fue = pue;
function hue(e) {
  return e == null ? "" : fue(e);
}
var Cb = hue, mue = nue, gue = Cb, yue = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, bue = "\\u0300-\\u036f", vue = "\\ufe20-\\ufe2f", xue = "\\u20d0-\\u20ff", Due = bue + vue + xue, Cue = "[" + Due + "]", Eue = RegExp(Cue, "g");
function Tue(e) {
  return e = gue(e), e && e.replace(yue, mue).replace(Eue, "");
}
var Sue = Tue, Aue = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
function wue(e) {
  return e.match(Aue) || [];
}
var Pue = wue, kue = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
function Oue(e) {
  return kue.test(e);
}
var Iue = Oue, o9 = "\\ud800-\\udfff", Fue = "\\u0300-\\u036f", $ue = "\\ufe20-\\ufe2f", Nue = "\\u20d0-\\u20ff", Mue = Fue + $ue + Nue, s9 = "\\u2700-\\u27bf", a9 = "a-z\\xdf-\\xf6\\xf8-\\xff", Rue = "\\xac\\xb1\\xd7\\xf7", _ue = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", Lue = "\\u2000-\\u206f", Bue = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", l9 = "A-Z\\xc0-\\xd6\\xd8-\\xde", jue = "\\ufe0e\\ufe0f", u9 = Rue + _ue + Lue + Bue, c9 = "['’]", g_ = "[" + u9 + "]", Vue = "[" + Mue + "]", d9 = "\\d+", zue = "[" + s9 + "]", p9 = "[" + a9 + "]", f9 = "[^" + o9 + u9 + d9 + s9 + a9 + l9 + "]", Uue = "\\ud83c[\\udffb-\\udfff]", Wue = "(?:" + Vue + "|" + Uue + ")", Hue = "[^" + o9 + "]", h9 = "(?:\\ud83c[\\udde6-\\uddff]){2}", m9 = "[\\ud800-\\udbff][\\udc00-\\udfff]", Th = "[" + l9 + "]", que = "\\u200d", y_ = "(?:" + p9 + "|" + f9 + ")", Gue = "(?:" + Th + "|" + f9 + ")", b_ = "(?:" + c9 + "(?:d|ll|m|re|s|t|ve))?", v_ = "(?:" + c9 + "(?:D|LL|M|RE|S|T|VE))?", g9 = Wue + "?", y9 = "[" + jue + "]?", Yue = "(?:" + que + "(?:" + [Hue, h9, m9].join("|") + ")" + y9 + g9 + ")*", Kue = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", Jue = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", Xue = y9 + g9 + Yue, Que = "(?:" + [zue, h9, m9].join("|") + ")" + Xue, Zue = RegExp([
  Th + "?" + p9 + "+" + b_ + "(?=" + [g_, Th, "$"].join("|") + ")",
  Gue + "+" + v_ + "(?=" + [g_, Th + y_, "$"].join("|") + ")",
  Th + "?" + y_ + "+" + b_,
  Th + "+" + v_,
  Jue,
  Kue,
  d9,
  Que
].join("|"), "g");
function ece(e) {
  return e.match(Zue) || [];
}
var tce = ece, nce = Pue, rce = Iue, ice = Cb, oce = tce;
function sce(e, t, n) {
  return e = ice(e), t = n ? void 0 : t, t === void 0 ? rce(e) ? oce(e) : nce(e) : e.match(t) || [];
}
var ace = sce, lce = r9, uce = Sue, cce = ace, dce = "['’]", pce = RegExp(dce, "g");
function fce(e) {
  return function(t) {
    return lce(cce(uce(t).replace(pce, "")), e, "");
  };
}
var hce = fce;
function mce(e, t, n) {
  var r = -1, i = e.length;
  t < 0 && (t = -t > i ? 0 : i + t), n = n > i ? i : n, n < 0 && (n += i), i = t > n ? 0 : n - t >>> 0, t >>>= 0;
  for (var o = Array(i); ++r < i; )
    o[r] = e[r + t];
  return o;
}
var b9 = mce, gce = b9;
function yce(e, t, n) {
  var r = e.length;
  return n = n === void 0 ? r : n, !t && n >= r ? e : gce(e, t, n);
}
var bce = yce, vce = "\\ud800-\\udfff", xce = "\\u0300-\\u036f", Dce = "\\ufe20-\\ufe2f", Cce = "\\u20d0-\\u20ff", Ece = xce + Dce + Cce, Tce = "\\ufe0e\\ufe0f", Sce = "\\u200d", Ace = RegExp("[" + Sce + vce + Ece + Tce + "]");
function wce(e) {
  return Ace.test(e);
}
var v9 = wce;
function Pce(e) {
  return e.split("");
}
var kce = Pce, x9 = "\\ud800-\\udfff", Oce = "\\u0300-\\u036f", Ice = "\\ufe20-\\ufe2f", Fce = "\\u20d0-\\u20ff", $ce = Oce + Ice + Fce, Nce = "\\ufe0e\\ufe0f", Mce = "[" + x9 + "]", xP = "[" + $ce + "]", DP = "\\ud83c[\\udffb-\\udfff]", Rce = "(?:" + xP + "|" + DP + ")", D9 = "[^" + x9 + "]", C9 = "(?:\\ud83c[\\udde6-\\uddff]){2}", E9 = "[\\ud800-\\udbff][\\udc00-\\udfff]", _ce = "\\u200d", T9 = Rce + "?", S9 = "[" + Nce + "]?", Lce = "(?:" + _ce + "(?:" + [D9, C9, E9].join("|") + ")" + S9 + T9 + ")*", Bce = S9 + T9 + Lce, jce = "(?:" + [D9 + xP + "?", xP, C9, E9, Mce].join("|") + ")", Vce = RegExp(DP + "(?=" + DP + ")|" + jce + Bce, "g");
function zce(e) {
  return e.match(Vce) || [];
}
var Uce = zce, Wce = kce, Hce = v9, qce = Uce;
function Gce(e) {
  return Hce(e) ? qce(e) : Wce(e);
}
var Yce = Gce, Kce = bce, Jce = v9, Xce = Yce, Qce = Cb;
function Zce(e) {
  return function(t) {
    t = Qce(t);
    var n = Jce(t) ? Xce(t) : void 0, r = n ? n[0] : t.charAt(0), i = n ? Kce(n, 1).join("") : t.slice(1);
    return r[e]() + i;
  };
}
var ede = Zce, tde = ede, nde = tde("toUpperCase"), rde = nde, ide = hce, ode = rde, sde = ide(function(e, t, n) {
  return e + (n ? " " : "") + ode(t);
}), ade = sde;
const UO = /* @__PURE__ */ Ln(ade);
function lde(e, t) {
  for (var n = -1, r = Array(e); ++n < e; )
    r[n] = t(n);
  return r;
}
var ude = lde, cde = 9007199254740991, dde = /^(?:0|[1-9]\d*)$/;
function pde(e, t) {
  var n = typeof e;
  return t = t ?? cde, !!t && (n == "number" || n != "symbol" && dde.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
var Eb = pde, fde = ude, hde = xb, mde = yi, gde = Db, yde = Eb, bde = qC, vde = Object.prototype, xde = vde.hasOwnProperty;
function Dde(e, t) {
  var n = mde(e), r = !n && hde(e), i = !n && !r && gde(e), o = !n && !r && !i && bde(e), s = n || r || i || o, a = s ? fde(e.length, String) : [], u = a.length;
  for (var c in e)
    (t || xde.call(e, c)) && !(s && // Safari 9 has enumerable `arguments.length` in strict mode.
    (c == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    i && (c == "offset" || c == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    o && (c == "buffer" || c == "byteLength" || c == "byteOffset") || // Skip index properties.
    yde(c, u))) && a.push(c);
  return a;
}
var A9 = Dde, Cde = A9, Ede = LO, Tde = gc;
function Sde(e) {
  return Tde(e) ? Cde(e) : Ede(e);
}
var yc = Sde;
const Ade = /* @__PURE__ */ Ln(yc);
var wde = Math.ceil, Pde = Math.max;
function kde(e, t, n, r) {
  for (var i = -1, o = Pde(wde((t - e) / (n || 1)), 0), s = Array(o); o--; )
    s[r ? o : ++i] = e, e += n;
  return s;
}
var Ode = kde;
function Ide(e, t) {
  return e === t || e !== e && t !== t;
}
var Tb = Ide, Fde = Tb, $de = gc, Nde = Eb, Mde = la;
function Rde(e, t, n) {
  if (!Mde(n))
    return !1;
  var r = typeof t;
  return (r == "number" ? $de(n) && Nde(t, n.length) : r == "string" && t in n) ? Fde(n[t], e) : !1;
}
var GC = Rde, _de = /\s/;
function Lde(e) {
  for (var t = e.length; t-- && _de.test(e.charAt(t)); )
    ;
  return t;
}
var Bde = Lde, jde = Bde, Vde = /^\s+/;
function zde(e) {
  return e && e.slice(0, jde(e) + 1).replace(Vde, "");
}
var Ude = zde, Wde = Ude, x_ = la, Hde = Vm, D_ = NaN, qde = /^[-+]0x[0-9a-f]+$/i, Gde = /^0b[01]+$/i, Yde = /^0o[0-7]+$/i, Kde = parseInt;
function Jde(e) {
  if (typeof e == "number")
    return e;
  if (Hde(e))
    return D_;
  if (x_(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = x_(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = Wde(e);
  var n = Gde.test(e);
  return n || Yde.test(e) ? Kde(e.slice(2), n ? 2 : 8) : qde.test(e) ? D_ : +e;
}
var w9 = Jde, Xde = w9, C_ = 1 / 0, Qde = 17976931348623157e292;
function Zde(e) {
  if (!e)
    return e === 0 ? e : 0;
  if (e = Xde(e), e === C_ || e === -C_) {
    var t = e < 0 ? -1 : 1;
    return t * Qde;
  }
  return e === e ? e : 0;
}
var P9 = Zde, epe = Ode, tpe = GC, cA = P9;
function npe(e) {
  return function(t, n, r) {
    return r && typeof r != "number" && tpe(t, n, r) && (n = r = void 0), t = cA(t), n === void 0 ? (n = t, t = 0) : n = cA(n), r = r === void 0 ? t < n ? 1 : -1 : cA(r), epe(t, n, r, e);
  };
}
var rpe = npe, ipe = rpe, ope = ipe(), spe = ope;
const Sb = /* @__PURE__ */ Ln(spe);
var ape = yi, lpe = Vm, upe = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, cpe = /^\w*$/;
function dpe(e, t) {
  if (ape(e))
    return !1;
  var n = typeof e;
  return n == "number" || n == "symbol" || n == "boolean" || e == null || lpe(e) ? !0 : cpe.test(e) || !upe.test(e) || t != null && e in Object(t);
}
var WO = dpe, ppe = uf, fpe = ppe(Object, "create"), YC = fpe, E_ = YC;
function hpe() {
  this.__data__ = E_ ? E_(null) : {}, this.size = 0;
}
var mpe = hpe;
function gpe(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var ype = gpe, bpe = YC, vpe = "__lodash_hash_undefined__", xpe = Object.prototype, Dpe = xpe.hasOwnProperty;
function Cpe(e) {
  var t = this.__data__;
  if (bpe) {
    var n = t[e];
    return n === vpe ? void 0 : n;
  }
  return Dpe.call(t, e) ? t[e] : void 0;
}
var Epe = Cpe, Tpe = YC, Spe = Object.prototype, Ape = Spe.hasOwnProperty;
function wpe(e) {
  var t = this.__data__;
  return Tpe ? t[e] !== void 0 : Ape.call(t, e);
}
var Ppe = wpe, kpe = YC, Ope = "__lodash_hash_undefined__";
function Ipe(e, t) {
  var n = this.__data__;
  return this.size += this.has(e) ? 0 : 1, n[e] = kpe && t === void 0 ? Ope : t, this;
}
var Fpe = Ipe, $pe = mpe, Npe = ype, Mpe = Epe, Rpe = Ppe, _pe = Fpe;
function zm(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
zm.prototype.clear = $pe;
zm.prototype.delete = Npe;
zm.prototype.get = Mpe;
zm.prototype.has = Rpe;
zm.prototype.set = _pe;
var Lpe = zm;
function Bpe() {
  this.__data__ = [], this.size = 0;
}
var jpe = Bpe, Vpe = Tb;
function zpe(e, t) {
  for (var n = e.length; n--; )
    if (Vpe(e[n][0], t))
      return n;
  return -1;
}
var KC = zpe, Upe = KC, Wpe = Array.prototype, Hpe = Wpe.splice;
function qpe(e) {
  var t = this.__data__, n = Upe(t, e);
  if (n < 0)
    return !1;
  var r = t.length - 1;
  return n == r ? t.pop() : Hpe.call(t, n, 1), --this.size, !0;
}
var Gpe = qpe, Ype = KC;
function Kpe(e) {
  var t = this.__data__, n = Ype(t, e);
  return n < 0 ? void 0 : t[n][1];
}
var Jpe = Kpe, Xpe = KC;
function Qpe(e) {
  return Xpe(this.__data__, e) > -1;
}
var Zpe = Qpe, efe = KC;
function tfe(e, t) {
  var n = this.__data__, r = efe(n, e);
  return r < 0 ? (++this.size, n.push([e, t])) : n[r][1] = t, this;
}
var nfe = tfe, rfe = jpe, ife = Gpe, ofe = Jpe, sfe = Zpe, afe = nfe;
function Um(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
Um.prototype.clear = rfe;
Um.prototype.delete = ife;
Um.prototype.get = ofe;
Um.prototype.has = sfe;
Um.prototype.set = afe;
var JC = Um, T_ = Lpe, lfe = JC, ufe = BO;
function cfe() {
  this.size = 0, this.__data__ = {
    hash: new T_(),
    map: new (ufe || lfe)(),
    string: new T_()
  };
}
var dfe = cfe;
function pfe(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
var ffe = pfe, hfe = ffe;
function mfe(e, t) {
  var n = e.__data__;
  return hfe(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
}
var XC = mfe, gfe = XC;
function yfe(e) {
  var t = gfe(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
var bfe = yfe, vfe = XC;
function xfe(e) {
  return vfe(this, e).get(e);
}
var Dfe = xfe, Cfe = XC;
function Efe(e) {
  return Cfe(this, e).has(e);
}
var Tfe = Efe, Sfe = XC;
function Afe(e, t) {
  var n = Sfe(this, e), r = n.size;
  return n.set(e, t), this.size += n.size == r ? 0 : 1, this;
}
var wfe = Afe, Pfe = dfe, kfe = bfe, Ofe = Dfe, Ife = Tfe, Ffe = wfe;
function Wm(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.clear(); ++t < n; ) {
    var r = e[t];
    this.set(r[0], r[1]);
  }
}
Wm.prototype.clear = Pfe;
Wm.prototype.delete = kfe;
Wm.prototype.get = Ofe;
Wm.prototype.has = Ife;
Wm.prototype.set = Ffe;
var HO = Wm, k9 = HO, $fe = "Expected a function";
function qO(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError($fe);
  var n = function() {
    var r = arguments, i = t ? t.apply(this, r) : r[0], o = n.cache;
    if (o.has(i))
      return o.get(i);
    var s = e.apply(this, r);
    return n.cache = o.set(i, s) || o, s;
  };
  return n.cache = new (qO.Cache || k9)(), n;
}
qO.Cache = k9;
var Nfe = qO, Mfe = Nfe, Rfe = 500;
function _fe(e) {
  var t = Mfe(e, function(r) {
    return n.size === Rfe && n.clear(), r;
  }), n = t.cache;
  return t;
}
var Lfe = _fe, Bfe = Lfe, jfe = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Vfe = /\\(\\)?/g, zfe = Bfe(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(jfe, function(n, r, i, o) {
    t.push(i ? o.replace(Vfe, "$1") : r || n);
  }), t;
}), O9 = zfe, Ufe = yi, Wfe = WO, Hfe = O9, qfe = Cb;
function Gfe(e, t) {
  return Ufe(e) ? e : Wfe(e, t) ? [e] : Hfe(qfe(e));
}
var Ab = Gfe, Yfe = Vm, Kfe = 1 / 0;
function Jfe(e) {
  if (typeof e == "string" || Yfe(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -Kfe ? "-0" : t;
}
var df = Jfe, Xfe = Ab, Qfe = df;
function Zfe(e, t) {
  t = Xfe(t, e);
  for (var n = 0, r = t.length; e != null && n < r; )
    e = e[Qfe(t[n++])];
  return n && n == r ? e : void 0;
}
var GO = Zfe, ehe = GO;
function the(e, t, n) {
  var r = e == null ? void 0 : ehe(e, t);
  return r === void 0 ? n : r;
}
var I9 = the;
const mn = /* @__PURE__ */ Ln(I9);
var nhe = Object.prototype, rhe = nhe.hasOwnProperty;
function ihe(e, t) {
  return e != null && rhe.call(e, t);
}
var ohe = ihe, she = Ab, ahe = xb, lhe = yi, uhe = Eb, che = jO, dhe = df;
function phe(e, t, n) {
  t = she(t, e);
  for (var r = -1, i = t.length, o = !1; ++r < i; ) {
    var s = dhe(t[r]);
    if (!(o = e != null && n(e, s)))
      break;
    e = e[s];
  }
  return o || ++r != i ? o : (i = e == null ? 0 : e.length, !!i && che(i) && uhe(s, i) && (lhe(e) || ahe(e)));
}
var F9 = phe, fhe = ohe, hhe = F9;
function mhe(e, t) {
  return e != null && hhe(e, t, fhe);
}
var ghe = mhe;
const rr = /* @__PURE__ */ Ln(ghe);
var yhe = JC;
function bhe() {
  this.__data__ = new yhe(), this.size = 0;
}
var vhe = bhe;
function xhe(e) {
  var t = this.__data__, n = t.delete(e);
  return this.size = t.size, n;
}
var Dhe = xhe;
function Che(e) {
  return this.__data__.get(e);
}
var Ehe = Che;
function The(e) {
  return this.__data__.has(e);
}
var She = The, Ahe = JC, whe = BO, Phe = HO, khe = 200;
function Ohe(e, t) {
  var n = this.__data__;
  if (n instanceof Ahe) {
    var r = n.__data__;
    if (!whe || r.length < khe - 1)
      return r.push([e, t]), this.size = ++n.size, this;
    n = this.__data__ = new Phe(r);
  }
  return n.set(e, t), this.size = n.size, this;
}
var Ihe = Ohe, Fhe = JC, $he = vhe, Nhe = Dhe, Mhe = Ehe, Rhe = She, _he = Ihe;
function Hm(e) {
  var t = this.__data__ = new Fhe(e);
  this.size = t.size;
}
Hm.prototype.clear = $he;
Hm.prototype.delete = Nhe;
Hm.prototype.get = Mhe;
Hm.prototype.has = Rhe;
Hm.prototype.set = _he;
var QC = Hm, Lhe = "__lodash_hash_undefined__";
function Bhe(e) {
  return this.__data__.set(e, Lhe), this;
}
var jhe = Bhe;
function Vhe(e) {
  return this.__data__.has(e);
}
var zhe = Vhe, Uhe = HO, Whe = jhe, Hhe = zhe;
function SD(e) {
  var t = -1, n = e == null ? 0 : e.length;
  for (this.__data__ = new Uhe(); ++t < n; )
    this.add(e[t]);
}
SD.prototype.add = SD.prototype.push = Whe;
SD.prototype.has = Hhe;
var $9 = SD;
function qhe(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length; ++n < r; )
    if (t(e[n], n, e))
      return !0;
  return !1;
}
var N9 = qhe;
function Ghe(e, t) {
  return e.has(t);
}
var M9 = Ghe, Yhe = $9, Khe = N9, Jhe = M9, Xhe = 1, Qhe = 2;
function Zhe(e, t, n, r, i, o) {
  var s = n & Xhe, a = e.length, u = t.length;
  if (a != u && !(s && u > a))
    return !1;
  var c = o.get(e), d = o.get(t);
  if (c && d)
    return c == t && d == e;
  var f = -1, h = !0, m = n & Qhe ? new Yhe() : void 0;
  for (o.set(e, t), o.set(t, e); ++f < a; ) {
    var v = e[f], x = t[f];
    if (r)
      var C = s ? r(x, v, f, t, e, o) : r(v, x, f, e, t, o);
    if (C !== void 0) {
      if (C)
        continue;
      h = !1;
      break;
    }
    if (m) {
      if (!Khe(t, function(E, S) {
        if (!Jhe(m, S) && (v === E || i(v, E, n, r, o)))
          return m.push(S);
      })) {
        h = !1;
        break;
      }
    } else if (!(v === x || i(v, x, n, r, o))) {
      h = !1;
      break;
    }
  }
  return o.delete(e), o.delete(t), h;
}
var R9 = Zhe, eme = cs, tme = eme.Uint8Array, _9 = tme;
function nme(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(r, i) {
    n[++t] = [i, r];
  }), n;
}
var L9 = nme;
function rme(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(r) {
    n[++t] = r;
  }), n;
}
var YO = rme, S_ = Lm, A_ = _9, ime = Tb, ome = R9, sme = L9, ame = YO, lme = 1, ume = 2, cme = "[object Boolean]", dme = "[object Date]", pme = "[object Error]", fme = "[object Map]", hme = "[object Number]", mme = "[object RegExp]", gme = "[object Set]", yme = "[object String]", bme = "[object Symbol]", vme = "[object ArrayBuffer]", xme = "[object DataView]", w_ = S_ ? S_.prototype : void 0, dA = w_ ? w_.valueOf : void 0;
function Dme(e, t, n, r, i, o, s) {
  switch (n) {
    case xme:
      if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
        return !1;
      e = e.buffer, t = t.buffer;
    case vme:
      return !(e.byteLength != t.byteLength || !o(new A_(e), new A_(t)));
    case cme:
    case dme:
    case hme:
      return ime(+e, +t);
    case pme:
      return e.name == t.name && e.message == t.message;
    case mme:
    case yme:
      return e == t + "";
    case fme:
      var a = sme;
    case gme:
      var u = r & lme;
      if (a || (a = ame), e.size != t.size && !u)
        return !1;
      var c = s.get(e);
      if (c)
        return c == t;
      r |= ume, s.set(e, t);
      var d = ome(a(e), a(t), r, i, o, s);
      return s.delete(e), d;
    case bme:
      if (dA)
        return dA.call(e) == dA.call(t);
  }
  return !1;
}
var Cme = Dme;
function Eme(e, t) {
  for (var n = -1, r = t.length, i = e.length; ++n < r; )
    e[i + n] = t[n];
  return e;
}
var KO = Eme, Tme = KO, Sme = yi;
function Ame(e, t, n) {
  var r = t(e);
  return Sme(e) ? r : Tme(r, n(e));
}
var B9 = Ame;
function wme(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length, i = 0, o = []; ++n < r; ) {
    var s = e[n];
    t(s, n, e) && (o[i++] = s);
  }
  return o;
}
var j9 = wme;
function Pme() {
  return [];
}
var V9 = Pme, kme = j9, Ome = V9, Ime = Object.prototype, Fme = Ime.propertyIsEnumerable, P_ = Object.getOwnPropertySymbols, $me = P_ ? function(e) {
  return e == null ? [] : (e = Object(e), kme(P_(e), function(t) {
    return Fme.call(e, t);
  }));
} : Ome, JO = $me, Nme = B9, Mme = JO, Rme = yc;
function _me(e) {
  return Nme(e, Rme, Mme);
}
var z9 = _me, k_ = z9, Lme = 1, Bme = Object.prototype, jme = Bme.hasOwnProperty;
function Vme(e, t, n, r, i, o) {
  var s = n & Lme, a = k_(e), u = a.length, c = k_(t), d = c.length;
  if (u != d && !s)
    return !1;
  for (var f = u; f--; ) {
    var h = a[f];
    if (!(s ? h in t : jme.call(t, h)))
      return !1;
  }
  var m = o.get(e), v = o.get(t);
  if (m && v)
    return m == t && v == e;
  var x = !0;
  o.set(e, t), o.set(t, e);
  for (var C = s; ++f < u; ) {
    h = a[f];
    var E = e[h], S = t[h];
    if (r)
      var w = s ? r(S, E, h, t, e, o) : r(E, S, h, e, t, o);
    if (!(w === void 0 ? E === S || i(E, S, n, r, o) : w)) {
      x = !1;
      break;
    }
    C || (C = h == "constructor");
  }
  if (x && !C) {
    var O = e.constructor, A = t.constructor;
    O != A && "constructor" in e && "constructor" in t && !(typeof O == "function" && O instanceof O && typeof A == "function" && A instanceof A) && (x = !1);
  }
  return o.delete(e), o.delete(t), x;
}
var zme = Vme, pA = QC, Ume = R9, Wme = Cme, Hme = zme, O_ = cf, I_ = yi, F_ = Db, qme = qC, Gme = 1, $_ = "[object Arguments]", N_ = "[object Array]", A1 = "[object Object]", Yme = Object.prototype, M_ = Yme.hasOwnProperty;
function Kme(e, t, n, r, i, o) {
  var s = I_(e), a = I_(t), u = s ? N_ : O_(e), c = a ? N_ : O_(t);
  u = u == $_ ? A1 : u, c = c == $_ ? A1 : c;
  var d = u == A1, f = c == A1, h = u == c;
  if (h && F_(e)) {
    if (!F_(t))
      return !1;
    s = !0, d = !1;
  }
  if (h && !d)
    return o || (o = new pA()), s || qme(e) ? Ume(e, t, n, r, i, o) : Wme(e, t, u, n, r, i, o);
  if (!(n & Gme)) {
    var m = d && M_.call(e, "__wrapped__"), v = f && M_.call(t, "__wrapped__");
    if (m || v) {
      var x = m ? e.value() : e, C = v ? t.value() : t;
      return o || (o = new pA()), i(x, C, n, r, o);
    }
  }
  return h ? (o || (o = new pA()), Hme(e, t, n, r, i, o)) : !1;
}
var Jme = Kme, Xme = Jme, R_ = ua;
function U9(e, t, n, r, i) {
  return e === t ? !0 : e == null || t == null || !R_(e) && !R_(t) ? e !== e && t !== t : Xme(e, t, n, r, U9, i);
}
var XO = U9, Qme = QC, Zme = XO, ege = 1, tge = 2;
function nge(e, t, n, r) {
  var i = n.length, o = i, s = !r;
  if (e == null)
    return !o;
  for (e = Object(e); i--; ) {
    var a = n[i];
    if (s && a[2] ? a[1] !== e[a[0]] : !(a[0] in e))
      return !1;
  }
  for (; ++i < o; ) {
    a = n[i];
    var u = a[0], c = e[u], d = a[1];
    if (s && a[2]) {
      if (c === void 0 && !(u in e))
        return !1;
    } else {
      var f = new Qme();
      if (r)
        var h = r(c, d, u, e, t, f);
      if (!(h === void 0 ? Zme(d, c, ege | tge, r, f) : h))
        return !1;
    }
  }
  return !0;
}
var rge = nge, ige = la;
function oge(e) {
  return e === e && !ige(e);
}
var W9 = oge, sge = W9, age = yc;
function lge(e) {
  for (var t = age(e), n = t.length; n--; ) {
    var r = t[n], i = e[r];
    t[n] = [r, i, sge(i)];
  }
  return t;
}
var uge = lge;
function cge(e, t) {
  return function(n) {
    return n == null ? !1 : n[e] === t && (t !== void 0 || e in Object(n));
  };
}
var H9 = cge, dge = rge, pge = uge, fge = H9;
function hge(e) {
  var t = pge(e);
  return t.length == 1 && t[0][2] ? fge(t[0][0], t[0][1]) : function(n) {
    return n === e || dge(n, e, t);
  };
}
var mge = hge;
function gge(e, t) {
  return e != null && t in Object(e);
}
var yge = gge, bge = yge, vge = F9;
function xge(e, t) {
  return e != null && vge(e, t, bge);
}
var Dge = xge, Cge = XO, Ege = I9, Tge = Dge, Sge = WO, Age = W9, wge = H9, Pge = df, kge = 1, Oge = 2;
function Ige(e, t) {
  return Sge(e) && Age(t) ? wge(Pge(e), t) : function(n) {
    var r = Ege(n, e);
    return r === void 0 && r === t ? Tge(n, e) : Cge(t, r, kge | Oge);
  };
}
var Fge = Ige;
function $ge(e) {
  return e;
}
var ZC = $ge;
function Nge(e) {
  return function(t) {
    return t == null ? void 0 : t[e];
  };
}
var Mge = Nge, Rge = GO;
function _ge(e) {
  return function(t) {
    return Rge(t, e);
  };
}
var Lge = _ge, Bge = Mge, jge = Lge, Vge = WO, zge = df;
function Uge(e) {
  return Vge(e) ? Bge(zge(e)) : jge(e);
}
var Wge = Uge, Hge = mge, qge = Fge, Gge = ZC, Yge = yi, Kge = Wge;
function Jge(e) {
  return typeof e == "function" ? e : e == null ? Gge : typeof e == "object" ? Yge(e) ? qge(e[0], e[1]) : Hge(e) : Kge(e);
}
var bc = Jge, Xge = bc, Qge = gc, Zge = yc;
function eye(e) {
  return function(t, n, r) {
    var i = Object(t);
    if (!Qge(t)) {
      var o = Xge(n);
      t = Zge(t), n = function(a) {
        return o(i[a], a, i);
      };
    }
    var s = e(t, n, r);
    return s > -1 ? i[o ? t[s] : s] : void 0;
  };
}
var tye = eye;
function nye(e, t, n, r) {
  for (var i = e.length, o = n + (r ? 1 : -1); r ? o-- : ++o < i; )
    if (t(e[o], o, e))
      return o;
  return -1;
}
var q9 = nye, rye = P9;
function iye(e) {
  var t = rye(e), n = t % 1;
  return t === t ? n ? t - n : t : 0;
}
var eE = iye, oye = q9, sye = bc, aye = eE, lye = Math.max;
function uye(e, t, n) {
  var r = e == null ? 0 : e.length;
  if (!r)
    return -1;
  var i = n == null ? 0 : aye(n);
  return i < 0 && (i = lye(r + i, 0)), oye(e, sye(t), i);
}
var cye = uye, dye = tye, pye = cye, fye = dye(pye), hye = fye;
const G9 = /* @__PURE__ */ Ln(hye);
function mye(e) {
  return e !== e;
}
var gye = mye;
function yye(e, t, n) {
  for (var r = n - 1, i = e.length; ++r < i; )
    if (e[r] === t)
      return r;
  return -1;
}
var bye = yye, vye = q9, xye = gye, Dye = bye;
function Cye(e, t, n) {
  return t === t ? Dye(e, t, n) : vye(e, xye, n);
}
var Y9 = Cye, Eye = Cd, Tye = yi, Sye = ua, Aye = "[object String]";
function wye(e) {
  return typeof e == "string" || !Tye(e) && Sye(e) && Eye(e) == Aye;
}
var Pye = wye, kye = jm;
function Oye(e, t) {
  return kye(t, function(n) {
    return e[n];
  });
}
var Iye = Oye, Fye = Iye, $ye = yc;
function Nye(e) {
  return e == null ? [] : Fye(e, $ye(e));
}
var Mye = Nye, Rye = Y9, _ye = gc, Lye = Pye, Bye = eE, jye = Mye, Vye = Math.max;
function zye(e, t, n, r) {
  e = _ye(e) ? e : jye(e), n = n && !r ? Bye(n) : 0;
  var i = e.length;
  return n < 0 && (n = Vye(i + n, 0)), Lye(e) ? n <= i && e.indexOf(t, n) > -1 : !!i && Rye(e, t, n) > -1;
}
var Uye = zye;
const K9 = /* @__PURE__ */ Ln(Uye);
var CP = { exports: {} }, J9 = {}, Na = {}, lm = {}, qm = {}, $n = {}, um = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.regexpCode = e.getEsmExportName = e.getProperty = e.safeStringify = e.stringify = e.strConcat = e.addCodeArg = e.str = e._ = e.nil = e._Code = e.Name = e.IDENTIFIER = e._CodeOrName = void 0;
  class t {
  }
  e._CodeOrName = t, e.IDENTIFIER = /^[a-z$_][a-z$_0-9]*$/i;
  class n extends t {
    constructor(S) {
      if (super(), !e.IDENTIFIER.test(S))
        throw new Error("CodeGen: name must be a valid identifier");
      this.str = S;
    }
    toString() {
      return this.str;
    }
    emptyStr() {
      return !1;
    }
    get names() {
      return { [this.str]: 1 };
    }
  }
  e.Name = n;
  class r extends t {
    constructor(S) {
      super(), this._items = typeof S == "string" ? [S] : S;
    }
    toString() {
      return this.str;
    }
    emptyStr() {
      if (this._items.length > 1)
        return !1;
      const S = this._items[0];
      return S === "" || S === '""';
    }
    get str() {
      var S;
      return (S = this._str) !== null && S !== void 0 ? S : this._str = this._items.reduce((w, O) => `${w}${O}`, "");
    }
    get names() {
      var S;
      return (S = this._names) !== null && S !== void 0 ? S : this._names = this._items.reduce((w, O) => (O instanceof n && (w[O.str] = (w[O.str] || 0) + 1), w), {});
    }
  }
  e._Code = r, e.nil = new r("");
  function i(E, ...S) {
    const w = [E[0]];
    let O = 0;
    for (; O < S.length; )
      a(w, S[O]), w.push(E[++O]);
    return new r(w);
  }
  e._ = i;
  const o = new r("+");
  function s(E, ...S) {
    const w = [m(E[0])];
    let O = 0;
    for (; O < S.length; )
      w.push(o), a(w, S[O]), w.push(o, m(E[++O]));
    return u(w), new r(w);
  }
  e.str = s;
  function a(E, S) {
    S instanceof r ? E.push(...S._items) : S instanceof n ? E.push(S) : E.push(f(S));
  }
  e.addCodeArg = a;
  function u(E) {
    let S = 1;
    for (; S < E.length - 1; ) {
      if (E[S] === o) {
        const w = c(E[S - 1], E[S + 1]);
        if (w !== void 0) {
          E.splice(S - 1, 3, w);
          continue;
        }
        E[S++] = "+";
      }
      S++;
    }
  }
  function c(E, S) {
    if (S === '""')
      return E;
    if (E === '""')
      return S;
    if (typeof E == "string")
      return S instanceof n || E[E.length - 1] !== '"' ? void 0 : typeof S != "string" ? `${E.slice(0, -1)}${S}"` : S[0] === '"' ? E.slice(0, -1) + S.slice(1) : void 0;
    if (typeof S == "string" && S[0] === '"' && !(E instanceof n))
      return `"${E}${S.slice(1)}`;
  }
  function d(E, S) {
    return S.emptyStr() ? E : E.emptyStr() ? S : s`${E}${S}`;
  }
  e.strConcat = d;
  function f(E) {
    return typeof E == "number" || typeof E == "boolean" || E === null ? E : m(Array.isArray(E) ? E.join(",") : E);
  }
  function h(E) {
    return new r(m(E));
  }
  e.stringify = h;
  function m(E) {
    return JSON.stringify(E).replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029");
  }
  e.safeStringify = m;
  function v(E) {
    return typeof E == "string" && e.IDENTIFIER.test(E) ? new r(`.${E}`) : i`[${E}]`;
  }
  e.getProperty = v;
  function x(E) {
    if (typeof E == "string" && e.IDENTIFIER.test(E))
      return new r(`${E}`);
    throw new Error(`CodeGen: invalid export name: ${E}, use explicit $id name mapping`);
  }
  e.getEsmExportName = x;
  function C(E) {
    return new r(E.toString());
  }
  e.regexpCode = C;
})(um);
var EP = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.ValueScope = e.ValueScopeName = e.Scope = e.varKinds = e.UsedValueState = void 0;
  const t = um;
  class n extends Error {
    constructor(c) {
      super(`CodeGen: "code" for ${c} not defined`), this.value = c.value;
    }
  }
  var r;
  (function(u) {
    u[u.Started = 0] = "Started", u[u.Completed = 1] = "Completed";
  })(r || (e.UsedValueState = r = {})), e.varKinds = {
    const: new t.Name("const"),
    let: new t.Name("let"),
    var: new t.Name("var")
  };
  class i {
    constructor({ prefixes: c, parent: d } = {}) {
      this._names = {}, this._prefixes = c, this._parent = d;
    }
    toName(c) {
      return c instanceof t.Name ? c : this.name(c);
    }
    name(c) {
      return new t.Name(this._newName(c));
    }
    _newName(c) {
      const d = this._names[c] || this._nameGroup(c);
      return `${c}${d.index++}`;
    }
    _nameGroup(c) {
      var d, f;
      if (!((f = (d = this._parent) === null || d === void 0 ? void 0 : d._prefixes) === null || f === void 0) && f.has(c) || this._prefixes && !this._prefixes.has(c))
        throw new Error(`CodeGen: prefix "${c}" is not allowed in this scope`);
      return this._names[c] = { prefix: c, index: 0 };
    }
  }
  e.Scope = i;
  class o extends t.Name {
    constructor(c, d) {
      super(d), this.prefix = c;
    }
    setValue(c, { property: d, itemIndex: f }) {
      this.value = c, this.scopePath = (0, t._)`.${new t.Name(d)}[${f}]`;
    }
  }
  e.ValueScopeName = o;
  const s = (0, t._)`\n`;
  class a extends i {
    constructor(c) {
      super(c), this._values = {}, this._scope = c.scope, this.opts = { ...c, _n: c.lines ? s : t.nil };
    }
    get() {
      return this._scope;
    }
    name(c) {
      return new o(c, this._newName(c));
    }
    value(c, d) {
      var f;
      if (d.ref === void 0)
        throw new Error("CodeGen: ref must be passed in value");
      const h = this.toName(c), { prefix: m } = h, v = (f = d.key) !== null && f !== void 0 ? f : d.ref;
      let x = this._values[m];
      if (x) {
        const S = x.get(v);
        if (S)
          return S;
      } else
        x = this._values[m] = /* @__PURE__ */ new Map();
      x.set(v, h);
      const C = this._scope[m] || (this._scope[m] = []), E = C.length;
      return C[E] = d.ref, h.setValue(d, { property: m, itemIndex: E }), h;
    }
    getValue(c, d) {
      const f = this._values[c];
      if (f)
        return f.get(d);
    }
    scopeRefs(c, d = this._values) {
      return this._reduceValues(d, (f) => {
        if (f.scopePath === void 0)
          throw new Error(`CodeGen: name "${f}" has no value`);
        return (0, t._)`${c}${f.scopePath}`;
      });
    }
    scopeCode(c = this._values, d, f) {
      return this._reduceValues(c, (h) => {
        if (h.value === void 0)
          throw new Error(`CodeGen: name "${h}" has no value`);
        return h.value.code;
      }, d, f);
    }
    _reduceValues(c, d, f = {}, h) {
      let m = t.nil;
      for (const v in c) {
        const x = c[v];
        if (!x)
          continue;
        const C = f[v] = f[v] || /* @__PURE__ */ new Map();
        x.forEach((E) => {
          if (C.has(E))
            return;
          C.set(E, r.Started);
          let S = d(E);
          if (S) {
            const w = this.opts.es5 ? e.varKinds.var : e.varKinds.const;
            m = (0, t._)`${m}${w} ${E} = ${S};${this.opts._n}`;
          } else if (S = h == null ? void 0 : h(E))
            m = (0, t._)`${m}${S}${this.opts._n}`;
          else
            throw new n(E);
          C.set(E, r.Completed);
        });
      }
      return m;
    }
  }
  e.ValueScope = a;
})(EP);
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.or = e.and = e.not = e.CodeGen = e.operators = e.varKinds = e.ValueScopeName = e.ValueScope = e.Scope = e.Name = e.regexpCode = e.stringify = e.getProperty = e.nil = e.strConcat = e.str = e._ = void 0;
  const t = um, n = EP;
  var r = um;
  Object.defineProperty(e, "_", { enumerable: !0, get: function() {
    return r._;
  } }), Object.defineProperty(e, "str", { enumerable: !0, get: function() {
    return r.str;
  } }), Object.defineProperty(e, "strConcat", { enumerable: !0, get: function() {
    return r.strConcat;
  } }), Object.defineProperty(e, "nil", { enumerable: !0, get: function() {
    return r.nil;
  } }), Object.defineProperty(e, "getProperty", { enumerable: !0, get: function() {
    return r.getProperty;
  } }), Object.defineProperty(e, "stringify", { enumerable: !0, get: function() {
    return r.stringify;
  } }), Object.defineProperty(e, "regexpCode", { enumerable: !0, get: function() {
    return r.regexpCode;
  } }), Object.defineProperty(e, "Name", { enumerable: !0, get: function() {
    return r.Name;
  } });
  var i = EP;
  Object.defineProperty(e, "Scope", { enumerable: !0, get: function() {
    return i.Scope;
  } }), Object.defineProperty(e, "ValueScope", { enumerable: !0, get: function() {
    return i.ValueScope;
  } }), Object.defineProperty(e, "ValueScopeName", { enumerable: !0, get: function() {
    return i.ValueScopeName;
  } }), Object.defineProperty(e, "varKinds", { enumerable: !0, get: function() {
    return i.varKinds;
  } }), e.operators = {
    GT: new t._Code(">"),
    GTE: new t._Code(">="),
    LT: new t._Code("<"),
    LTE: new t._Code("<="),
    EQ: new t._Code("==="),
    NEQ: new t._Code("!=="),
    NOT: new t._Code("!"),
    OR: new t._Code("||"),
    AND: new t._Code("&&"),
    ADD: new t._Code("+")
  };
  class o {
    optimizeNodes() {
      return this;
    }
    optimizeNames(_, W) {
      return this;
    }
  }
  class s extends o {
    constructor(_, W, Q) {
      super(), this.varKind = _, this.name = W, this.rhs = Q;
    }
    render({ es5: _, _n: W }) {
      const Q = _ ? n.varKinds.var : this.varKind, oe = this.rhs === void 0 ? "" : ` = ${this.rhs}`;
      return `${Q} ${this.name}${oe};` + W;
    }
    optimizeNames(_, W) {
      if (_[this.name.str])
        return this.rhs && (this.rhs = j(this.rhs, _, W)), this;
    }
    get names() {
      return this.rhs instanceof t._CodeOrName ? this.rhs.names : {};
    }
  }
  class a extends o {
    constructor(_, W, Q) {
      super(), this.lhs = _, this.rhs = W, this.sideEffects = Q;
    }
    render({ _n: _ }) {
      return `${this.lhs} = ${this.rhs};` + _;
    }
    optimizeNames(_, W) {
      if (!(this.lhs instanceof t.Name && !_[this.lhs.str] && !this.sideEffects))
        return this.rhs = j(this.rhs, _, W), this;
    }
    get names() {
      const _ = this.lhs instanceof t.Name ? {} : { ...this.lhs.names };
      return X(_, this.rhs);
    }
  }
  class u extends a {
    constructor(_, W, Q, oe) {
      super(_, Q, oe), this.op = W;
    }
    render({ _n: _ }) {
      return `${this.lhs} ${this.op}= ${this.rhs};` + _;
    }
  }
  class c extends o {
    constructor(_) {
      super(), this.label = _, this.names = {};
    }
    render({ _n: _ }) {
      return `${this.label}:` + _;
    }
  }
  class d extends o {
    constructor(_) {
      super(), this.label = _, this.names = {};
    }
    render({ _n: _ }) {
      return `break${this.label ? ` ${this.label}` : ""};` + _;
    }
  }
  class f extends o {
    constructor(_) {
      super(), this.error = _;
    }
    render({ _n: _ }) {
      return `throw ${this.error};` + _;
    }
    get names() {
      return this.error.names;
    }
  }
  class h extends o {
    constructor(_) {
      super(), this.code = _;
    }
    render({ _n: _ }) {
      return `${this.code};` + _;
    }
    optimizeNodes() {
      return `${this.code}` ? this : void 0;
    }
    optimizeNames(_, W) {
      return this.code = j(this.code, _, W), this;
    }
    get names() {
      return this.code instanceof t._CodeOrName ? this.code.names : {};
    }
  }
  class m extends o {
    constructor(_ = []) {
      super(), this.nodes = _;
    }
    render(_) {
      return this.nodes.reduce((W, Q) => W + Q.render(_), "");
    }
    optimizeNodes() {
      const { nodes: _ } = this;
      let W = _.length;
      for (; W--; ) {
        const Q = _[W].optimizeNodes();
        Array.isArray(Q) ? _.splice(W, 1, ...Q) : Q ? _[W] = Q : _.splice(W, 1);
      }
      return _.length > 0 ? this : void 0;
    }
    optimizeNames(_, W) {
      const { nodes: Q } = this;
      let oe = Q.length;
      for (; oe--; ) {
        const ae = Q[oe];
        ae.optimizeNames(_, W) || (U(_, ae.names), Q.splice(oe, 1));
      }
      return Q.length > 0 ? this : void 0;
    }
    get names() {
      return this.nodes.reduce((_, W) => J(_, W.names), {});
    }
  }
  class v extends m {
    render(_) {
      return "{" + _._n + super.render(_) + "}" + _._n;
    }
  }
  class x extends m {
  }
  class C extends v {
  }
  C.kind = "else";
  class E extends v {
    constructor(_, W) {
      super(W), this.condition = _;
    }
    render(_) {
      let W = `if(${this.condition})` + super.render(_);
      return this.else && (W += "else " + this.else.render(_)), W;
    }
    optimizeNodes() {
      super.optimizeNodes();
      const _ = this.condition;
      if (_ === !0)
        return this.nodes;
      let W = this.else;
      if (W) {
        const Q = W.optimizeNodes();
        W = this.else = Array.isArray(Q) ? new C(Q) : Q;
      }
      if (W)
        return _ === !1 ? W instanceof E ? W : W.nodes : this.nodes.length ? this : new E(G(_), W instanceof E ? [W] : W.nodes);
      if (!(_ === !1 || !this.nodes.length))
        return this;
    }
    optimizeNames(_, W) {
      var Q;
      if (this.else = (Q = this.else) === null || Q === void 0 ? void 0 : Q.optimizeNames(_, W), !!(super.optimizeNames(_, W) || this.else))
        return this.condition = j(this.condition, _, W), this;
    }
    get names() {
      const _ = super.names;
      return X(_, this.condition), this.else && J(_, this.else.names), _;
    }
  }
  E.kind = "if";
  class S extends v {
  }
  S.kind = "for";
  class w extends S {
    constructor(_) {
      super(), this.iteration = _;
    }
    render(_) {
      return `for(${this.iteration})` + super.render(_);
    }
    optimizeNames(_, W) {
      if (super.optimizeNames(_, W))
        return this.iteration = j(this.iteration, _, W), this;
    }
    get names() {
      return J(super.names, this.iteration.names);
    }
  }
  class O extends S {
    constructor(_, W, Q, oe) {
      super(), this.varKind = _, this.name = W, this.from = Q, this.to = oe;
    }
    render(_) {
      const W = _.es5 ? n.varKinds.var : this.varKind, { name: Q, from: oe, to: ae } = this;
      return `for(${W} ${Q}=${oe}; ${Q}<${ae}; ${Q}++)` + super.render(_);
    }
    get names() {
      const _ = X(super.names, this.from);
      return X(_, this.to);
    }
  }
  class A extends S {
    constructor(_, W, Q, oe) {
      super(), this.loop = _, this.varKind = W, this.name = Q, this.iterable = oe;
    }
    render(_) {
      return `for(${this.varKind} ${this.name} ${this.loop} ${this.iterable})` + super.render(_);
    }
    optimizeNames(_, W) {
      if (super.optimizeNames(_, W))
        return this.iterable = j(this.iterable, _, W), this;
    }
    get names() {
      return J(super.names, this.iterable.names);
    }
  }
  class I extends v {
    constructor(_, W, Q) {
      super(), this.name = _, this.args = W, this.async = Q;
    }
    render(_) {
      return `${this.async ? "async " : ""}function ${this.name}(${this.args})` + super.render(_);
    }
  }
  I.kind = "func";
  class $ extends m {
    render(_) {
      return "return " + super.render(_);
    }
  }
  $.kind = "return";
  class L extends v {
    render(_) {
      let W = "try" + super.render(_);
      return this.catch && (W += this.catch.render(_)), this.finally && (W += this.finally.render(_)), W;
    }
    optimizeNodes() {
      var _, W;
      return super.optimizeNodes(), (_ = this.catch) === null || _ === void 0 || _.optimizeNodes(), (W = this.finally) === null || W === void 0 || W.optimizeNodes(), this;
    }
    optimizeNames(_, W) {
      var Q, oe;
      return super.optimizeNames(_, W), (Q = this.catch) === null || Q === void 0 || Q.optimizeNames(_, W), (oe = this.finally) === null || oe === void 0 || oe.optimizeNames(_, W), this;
    }
    get names() {
      const _ = super.names;
      return this.catch && J(_, this.catch.names), this.finally && J(_, this.finally.names), _;
    }
  }
  class B extends v {
    constructor(_) {
      super(), this.error = _;
    }
    render(_) {
      return `catch(${this.error})` + super.render(_);
    }
  }
  B.kind = "catch";
  class H extends v {
    render(_) {
      return "finally" + super.render(_);
    }
  }
  H.kind = "finally";
  class q {
    constructor(_, W = {}) {
      this._values = {}, this._blockStarts = [], this._constants = {}, this.opts = { ...W, _n: W.lines ? `
` : "" }, this._extScope = _, this._scope = new n.Scope({ parent: _ }), this._nodes = [new x()];
    }
    toString() {
      return this._root.render(this.opts);
    }
    // returns unique name in the internal scope
    name(_) {
      return this._scope.name(_);
    }
    // reserves unique name in the external scope
    scopeName(_) {
      return this._extScope.name(_);
    }
    // reserves unique name in the external scope and assigns value to it
    scopeValue(_, W) {
      const Q = this._extScope.value(_, W);
      return (this._values[Q.prefix] || (this._values[Q.prefix] = /* @__PURE__ */ new Set())).add(Q), Q;
    }
    getScopeValue(_, W) {
      return this._extScope.getValue(_, W);
    }
    // return code that assigns values in the external scope to the names that are used internally
    // (same names that were returned by gen.scopeName or gen.scopeValue)
    scopeRefs(_) {
      return this._extScope.scopeRefs(_, this._values);
    }
    scopeCode() {
      return this._extScope.scopeCode(this._values);
    }
    _def(_, W, Q, oe) {
      const ae = this._scope.toName(W);
      return Q !== void 0 && oe && (this._constants[ae.str] = Q), this._leafNode(new s(_, ae, Q)), ae;
    }
    // `const` declaration (`var` in es5 mode)
    const(_, W, Q) {
      return this._def(n.varKinds.const, _, W, Q);
    }
    // `let` declaration with optional assignment (`var` in es5 mode)
    let(_, W, Q) {
      return this._def(n.varKinds.let, _, W, Q);
    }
    // `var` declaration with optional assignment
    var(_, W, Q) {
      return this._def(n.varKinds.var, _, W, Q);
    }
    // assignment code
    assign(_, W, Q) {
      return this._leafNode(new a(_, W, Q));
    }
    // `+=` code
    add(_, W) {
      return this._leafNode(new u(_, e.operators.ADD, W));
    }
    // appends passed SafeExpr to code or executes Block
    code(_) {
      return typeof _ == "function" ? _() : _ !== t.nil && this._leafNode(new h(_)), this;
    }
    // returns code for object literal for the passed argument list of key-value pairs
    object(..._) {
      const W = ["{"];
      for (const [Q, oe] of _)
        W.length > 1 && W.push(","), W.push(Q), (Q !== oe || this.opts.es5) && (W.push(":"), (0, t.addCodeArg)(W, oe));
      return W.push("}"), new t._Code(W);
    }
    // `if` clause (or statement if `thenBody` and, optionally, `elseBody` are passed)
    if(_, W, Q) {
      if (this._blockNode(new E(_)), W && Q)
        this.code(W).else().code(Q).endIf();
      else if (W)
        this.code(W).endIf();
      else if (Q)
        throw new Error('CodeGen: "else" body without "then" body');
      return this;
    }
    // `else if` clause - invalid without `if` or after `else` clauses
    elseIf(_) {
      return this._elseNode(new E(_));
    }
    // `else` clause - only valid after `if` or `else if` clauses
    else() {
      return this._elseNode(new C());
    }
    // end `if` statement (needed if gen.if was used only with condition)
    endIf() {
      return this._endBlockNode(E, C);
    }
    _for(_, W) {
      return this._blockNode(_), W && this.code(W).endFor(), this;
    }
    // a generic `for` clause (or statement if `forBody` is passed)
    for(_, W) {
      return this._for(new w(_), W);
    }
    // `for` statement for a range of values
    forRange(_, W, Q, oe, ae = this.opts.es5 ? n.varKinds.var : n.varKinds.let) {
      const pe = this._scope.toName(_);
      return this._for(new O(ae, pe, W, Q), () => oe(pe));
    }
    // `for-of` statement (in es5 mode replace with a normal for loop)
    forOf(_, W, Q, oe = n.varKinds.const) {
      const ae = this._scope.toName(_);
      if (this.opts.es5) {
        const pe = W instanceof t.Name ? W : this.var("_arr", W);
        return this.forRange("_i", 0, (0, t._)`${pe}.length`, (me) => {
          this.var(ae, (0, t._)`${pe}[${me}]`), Q(ae);
        });
      }
      return this._for(new A("of", oe, ae, W), () => Q(ae));
    }
    // `for-in` statement.
    // With option `ownProperties` replaced with a `for-of` loop for object keys
    forIn(_, W, Q, oe = this.opts.es5 ? n.varKinds.var : n.varKinds.const) {
      if (this.opts.ownProperties)
        return this.forOf(_, (0, t._)`Object.keys(${W})`, Q);
      const ae = this._scope.toName(_);
      return this._for(new A("in", oe, ae, W), () => Q(ae));
    }
    // end `for` loop
    endFor() {
      return this._endBlockNode(S);
    }
    // `label` statement
    label(_) {
      return this._leafNode(new c(_));
    }
    // `break` statement
    break(_) {
      return this._leafNode(new d(_));
    }
    // `return` statement
    return(_) {
      const W = new $();
      if (this._blockNode(W), this.code(_), W.nodes.length !== 1)
        throw new Error('CodeGen: "return" should have one node');
      return this._endBlockNode($);
    }
    // `try` statement
    try(_, W, Q) {
      if (!W && !Q)
        throw new Error('CodeGen: "try" without "catch" and "finally"');
      const oe = new L();
      if (this._blockNode(oe), this.code(_), W) {
        const ae = this.name("e");
        this._currNode = oe.catch = new B(ae), W(ae);
      }
      return Q && (this._currNode = oe.finally = new H(), this.code(Q)), this._endBlockNode(B, H);
    }
    // `throw` statement
    throw(_) {
      return this._leafNode(new f(_));
    }
    // start self-balancing block
    block(_, W) {
      return this._blockStarts.push(this._nodes.length), _ && this.code(_).endBlock(W), this;
    }
    // end the current self-balancing block
    endBlock(_) {
      const W = this._blockStarts.pop();
      if (W === void 0)
        throw new Error("CodeGen: not in self-balancing block");
      const Q = this._nodes.length - W;
      if (Q < 0 || _ !== void 0 && Q !== _)
        throw new Error(`CodeGen: wrong number of nodes: ${Q} vs ${_} expected`);
      return this._nodes.length = W, this;
    }
    // `function` heading (or definition if funcBody is passed)
    func(_, W = t.nil, Q, oe) {
      return this._blockNode(new I(_, W, Q)), oe && this.code(oe).endFunc(), this;
    }
    // end function definition
    endFunc() {
      return this._endBlockNode(I);
    }
    optimize(_ = 1) {
      for (; _-- > 0; )
        this._root.optimizeNodes(), this._root.optimizeNames(this._root.names, this._constants);
    }
    _leafNode(_) {
      return this._currNode.nodes.push(_), this;
    }
    _blockNode(_) {
      this._currNode.nodes.push(_), this._nodes.push(_);
    }
    _endBlockNode(_, W) {
      const Q = this._currNode;
      if (Q instanceof _ || W && Q instanceof W)
        return this._nodes.pop(), this;
      throw new Error(`CodeGen: not in block "${W ? `${_.kind}/${W.kind}` : _.kind}"`);
    }
    _elseNode(_) {
      const W = this._currNode;
      if (!(W instanceof E))
        throw new Error('CodeGen: "else" without "if"');
      return this._currNode = W.else = _, this;
    }
    get _root() {
      return this._nodes[0];
    }
    get _currNode() {
      const _ = this._nodes;
      return _[_.length - 1];
    }
    set _currNode(_) {
      const W = this._nodes;
      W[W.length - 1] = _;
    }
  }
  e.CodeGen = q;
  function J(R, _) {
    for (const W in _)
      R[W] = (R[W] || 0) + (_[W] || 0);
    return R;
  }
  function X(R, _) {
    return _ instanceof t._CodeOrName ? J(R, _.names) : R;
  }
  function j(R, _, W) {
    if (R instanceof t.Name)
      return Q(R);
    if (!oe(R))
      return R;
    return new t._Code(R._items.reduce((ae, pe) => (pe instanceof t.Name && (pe = Q(pe)), pe instanceof t._Code ? ae.push(...pe._items) : ae.push(pe), ae), []));
    function Q(ae) {
      const pe = W[ae.str];
      return pe === void 0 || _[ae.str] !== 1 ? ae : (delete _[ae.str], pe);
    }
    function oe(ae) {
      return ae instanceof t._Code && ae._items.some((pe) => pe instanceof t.Name && _[pe.str] === 1 && W[pe.str] !== void 0);
    }
  }
  function U(R, _) {
    for (const W in _)
      R[W] = (R[W] || 0) - (_[W] || 0);
  }
  function G(R) {
    return typeof R == "boolean" || typeof R == "number" || R === null ? !R : (0, t._)`!${ne(R)}`;
  }
  e.not = G;
  const K = Z(e.operators.AND);
  function ee(...R) {
    return R.reduce(K);
  }
  e.and = ee;
  const te = Z(e.operators.OR);
  function M(...R) {
    return R.reduce(te);
  }
  e.or = M;
  function Z(R) {
    return (_, W) => _ === t.nil ? W : W === t.nil ? _ : (0, t._)`${ne(_)} ${R} ${ne(W)}`;
  }
  function ne(R) {
    return R instanceof t.Name ? R : (0, t._)`(${R})`;
  }
})($n);
var jt = {};
Object.defineProperty(jt, "__esModule", { value: !0 });
jt.checkStrictMode = jt.getErrorPath = jt.Type = jt.useFunc = jt.setEvaluated = jt.evaluatedPropsToName = jt.mergeEvaluated = jt.eachItem = jt.unescapeJsonPointer = jt.escapeJsonPointer = jt.escapeFragment = jt.unescapeFragment = jt.schemaRefOrVal = jt.schemaHasRulesButRef = jt.schemaHasRules = jt.checkUnknownRules = jt.alwaysValidSchema = jt.toHash = void 0;
const Fr = $n, Wye = um;
function Hye(e) {
  const t = {};
  for (const n of e)
    t[n] = !0;
  return t;
}
jt.toHash = Hye;
function qye(e, t) {
  return typeof t == "boolean" ? t : Object.keys(t).length === 0 ? !0 : (X9(e, t), !Q9(t, e.self.RULES.all));
}
jt.alwaysValidSchema = qye;
function X9(e, t = e.schema) {
  const { opts: n, self: r } = e;
  if (!n.strictSchema || typeof t == "boolean")
    return;
  const i = r.RULES.keywords;
  for (const o in t)
    i[o] || t7(e, `unknown keyword: "${o}"`);
}
jt.checkUnknownRules = X9;
function Q9(e, t) {
  if (typeof e == "boolean")
    return !e;
  for (const n in e)
    if (t[n])
      return !0;
  return !1;
}
jt.schemaHasRules = Q9;
function Gye(e, t) {
  if (typeof e == "boolean")
    return !e;
  for (const n in e)
    if (n !== "$ref" && t.all[n])
      return !0;
  return !1;
}
jt.schemaHasRulesButRef = Gye;
function Yye({ topSchemaRef: e, schemaPath: t }, n, r, i) {
  if (!i) {
    if (typeof n == "number" || typeof n == "boolean")
      return n;
    if (typeof n == "string")
      return (0, Fr._)`${n}`;
  }
  return (0, Fr._)`${e}${t}${(0, Fr.getProperty)(r)}`;
}
jt.schemaRefOrVal = Yye;
function Kye(e) {
  return Z9(decodeURIComponent(e));
}
jt.unescapeFragment = Kye;
function Jye(e) {
  return encodeURIComponent(QO(e));
}
jt.escapeFragment = Jye;
function QO(e) {
  return typeof e == "number" ? `${e}` : e.replace(/~/g, "~0").replace(/\//g, "~1");
}
jt.escapeJsonPointer = QO;
function Z9(e) {
  return e.replace(/~1/g, "/").replace(/~0/g, "~");
}
jt.unescapeJsonPointer = Z9;
function Xye(e, t) {
  if (Array.isArray(e))
    for (const n of e)
      t(n);
  else
    t(e);
}
jt.eachItem = Xye;
function __({ mergeNames: e, mergeToName: t, mergeValues: n, resultToName: r }) {
  return (i, o, s, a) => {
    const u = s === void 0 ? o : s instanceof Fr.Name ? (o instanceof Fr.Name ? e(i, o, s) : t(i, o, s), s) : o instanceof Fr.Name ? (t(i, s, o), o) : n(o, s);
    return a === Fr.Name && !(u instanceof Fr.Name) ? r(i, u) : u;
  };
}
jt.mergeEvaluated = {
  props: __({
    mergeNames: (e, t, n) => e.if((0, Fr._)`${n} !== true && ${t} !== undefined`, () => {
      e.if((0, Fr._)`${t} === true`, () => e.assign(n, !0), () => e.assign(n, (0, Fr._)`${n} || {}`).code((0, Fr._)`Object.assign(${n}, ${t})`));
    }),
    mergeToName: (e, t, n) => e.if((0, Fr._)`${n} !== true`, () => {
      t === !0 ? e.assign(n, !0) : (e.assign(n, (0, Fr._)`${n} || {}`), ZO(e, n, t));
    }),
    mergeValues: (e, t) => e === !0 ? !0 : { ...e, ...t },
    resultToName: e7
  }),
  items: __({
    mergeNames: (e, t, n) => e.if((0, Fr._)`${n} !== true && ${t} !== undefined`, () => e.assign(n, (0, Fr._)`${t} === true ? true : ${n} > ${t} ? ${n} : ${t}`)),
    mergeToName: (e, t, n) => e.if((0, Fr._)`${n} !== true`, () => e.assign(n, t === !0 ? !0 : (0, Fr._)`${n} > ${t} ? ${n} : ${t}`)),
    mergeValues: (e, t) => e === !0 ? !0 : Math.max(e, t),
    resultToName: (e, t) => e.var("items", t)
  })
};
function e7(e, t) {
  if (t === !0)
    return e.var("props", !0);
  const n = e.var("props", (0, Fr._)`{}`);
  return t !== void 0 && ZO(e, n, t), n;
}
jt.evaluatedPropsToName = e7;
function ZO(e, t, n) {
  Object.keys(n).forEach((r) => e.assign((0, Fr._)`${t}${(0, Fr.getProperty)(r)}`, !0));
}
jt.setEvaluated = ZO;
const L_ = {};
function Qye(e, t) {
  return e.scopeValue("func", {
    ref: t,
    code: L_[t.code] || (L_[t.code] = new Wye._Code(t.code))
  });
}
jt.useFunc = Qye;
var TP;
(function(e) {
  e[e.Num = 0] = "Num", e[e.Str = 1] = "Str";
})(TP || (jt.Type = TP = {}));
function Zye(e, t, n) {
  if (e instanceof Fr.Name) {
    const r = t === TP.Num;
    return n ? r ? (0, Fr._)`"[" + ${e} + "]"` : (0, Fr._)`"['" + ${e} + "']"` : r ? (0, Fr._)`"/" + ${e}` : (0, Fr._)`"/" + ${e}.replace(/~/g, "~0").replace(/\\//g, "~1")`;
  }
  return n ? (0, Fr.getProperty)(e).toString() : "/" + QO(e);
}
jt.getErrorPath = Zye;
function t7(e, t, n = e.opts.strictSchema) {
  if (n) {
    if (t = `strict mode: ${t}`, n === !0)
      throw new Error(t);
    e.self.logger.warn(t);
  }
}
jt.checkStrictMode = t7;
var Sl = {};
Object.defineProperty(Sl, "__esModule", { value: !0 });
const Fo = $n, e0e = {
  // validation function arguments
  data: new Fo.Name("data"),
  // data passed to validation function
  // args passed from referencing schema
  valCxt: new Fo.Name("valCxt"),
  // validation/data context - should not be used directly, it is destructured to the names below
  instancePath: new Fo.Name("instancePath"),
  parentData: new Fo.Name("parentData"),
  parentDataProperty: new Fo.Name("parentDataProperty"),
  rootData: new Fo.Name("rootData"),
  // root data - same as the data passed to the first/top validation function
  dynamicAnchors: new Fo.Name("dynamicAnchors"),
  // used to support recursiveRef and dynamicRef
  // function scoped variables
  vErrors: new Fo.Name("vErrors"),
  // null or array of validation errors
  errors: new Fo.Name("errors"),
  // counter of validation errors
  this: new Fo.Name("this"),
  // "globals"
  self: new Fo.Name("self"),
  scope: new Fo.Name("scope"),
  // JTD serialize/parse name for JSON string and position
  json: new Fo.Name("json"),
  jsonPos: new Fo.Name("jsonPos"),
  jsonLen: new Fo.Name("jsonLen"),
  jsonPart: new Fo.Name("jsonPart")
};
Sl.default = e0e;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.extendErrors = e.resetErrorsCount = e.reportExtraError = e.reportError = e.keyword$DataError = e.keywordError = void 0;
  const t = $n, n = jt, r = Sl;
  e.keywordError = {
    message: ({ keyword: C }) => (0, t.str)`must pass "${C}" keyword validation`
  }, e.keyword$DataError = {
    message: ({ keyword: C, schemaType: E }) => E ? (0, t.str)`"${C}" keyword must be ${E} ($data)` : (0, t.str)`"${C}" keyword is invalid ($data)`
  };
  function i(C, E = e.keywordError, S, w) {
    const { it: O } = C, { gen: A, compositeRule: I, allErrors: $ } = O, L = f(C, E, S);
    w ?? (I || $) ? u(A, L) : c(O, (0, t._)`[${L}]`);
  }
  e.reportError = i;
  function o(C, E = e.keywordError, S) {
    const { it: w } = C, { gen: O, compositeRule: A, allErrors: I } = w, $ = f(C, E, S);
    u(O, $), A || I || c(w, r.default.vErrors);
  }
  e.reportExtraError = o;
  function s(C, E) {
    C.assign(r.default.errors, E), C.if((0, t._)`${r.default.vErrors} !== null`, () => C.if(E, () => C.assign((0, t._)`${r.default.vErrors}.length`, E), () => C.assign(r.default.vErrors, null)));
  }
  e.resetErrorsCount = s;
  function a({ gen: C, keyword: E, schemaValue: S, data: w, errsCount: O, it: A }) {
    if (O === void 0)
      throw new Error("ajv implementation error");
    const I = C.name("err");
    C.forRange("i", O, r.default.errors, ($) => {
      C.const(I, (0, t._)`${r.default.vErrors}[${$}]`), C.if((0, t._)`${I}.instancePath === undefined`, () => C.assign((0, t._)`${I}.instancePath`, (0, t.strConcat)(r.default.instancePath, A.errorPath))), C.assign((0, t._)`${I}.schemaPath`, (0, t.str)`${A.errSchemaPath}/${E}`), A.opts.verbose && (C.assign((0, t._)`${I}.schema`, S), C.assign((0, t._)`${I}.data`, w));
    });
  }
  e.extendErrors = a;
  function u(C, E) {
    const S = C.const("err", E);
    C.if((0, t._)`${r.default.vErrors} === null`, () => C.assign(r.default.vErrors, (0, t._)`[${S}]`), (0, t._)`${r.default.vErrors}.push(${S})`), C.code((0, t._)`${r.default.errors}++`);
  }
  function c(C, E) {
    const { gen: S, validateName: w, schemaEnv: O } = C;
    O.$async ? S.throw((0, t._)`new ${C.ValidationError}(${E})`) : (S.assign((0, t._)`${w}.errors`, E), S.return(!1));
  }
  const d = {
    keyword: new t.Name("keyword"),
    schemaPath: new t.Name("schemaPath"),
    // also used in JTD errors
    params: new t.Name("params"),
    propertyName: new t.Name("propertyName"),
    message: new t.Name("message"),
    schema: new t.Name("schema"),
    parentSchema: new t.Name("parentSchema")
  };
  function f(C, E, S) {
    const { createErrors: w } = C.it;
    return w === !1 ? (0, t._)`{}` : h(C, E, S);
  }
  function h(C, E, S = {}) {
    const { gen: w, it: O } = C, A = [
      m(O, S),
      v(C, S)
    ];
    return x(C, E, A), w.object(...A);
  }
  function m({ errorPath: C }, { instancePath: E }) {
    const S = E ? (0, t.str)`${C}${(0, n.getErrorPath)(E, n.Type.Str)}` : C;
    return [r.default.instancePath, (0, t.strConcat)(r.default.instancePath, S)];
  }
  function v({ keyword: C, it: { errSchemaPath: E } }, { schemaPath: S, parentSchema: w }) {
    let O = w ? E : (0, t.str)`${E}/${C}`;
    return S && (O = (0, t.str)`${O}${(0, n.getErrorPath)(S, n.Type.Str)}`), [d.schemaPath, O];
  }
  function x(C, { params: E, message: S }, w) {
    const { keyword: O, data: A, schemaValue: I, it: $ } = C, { opts: L, propertyName: B, topSchemaRef: H, schemaPath: q } = $;
    w.push([d.keyword, O], [d.params, typeof E == "function" ? E(C) : E || (0, t._)`{}`]), L.messages && w.push([d.message, typeof S == "function" ? S(C) : S]), L.verbose && w.push([d.schema, I], [d.parentSchema, (0, t._)`${H}${q}`], [r.default.data, A]), B && w.push([d.propertyName, B]);
  }
})(qm);
Object.defineProperty(lm, "__esModule", { value: !0 });
lm.boolOrEmptySchema = lm.topBoolOrEmptySchema = void 0;
const t0e = qm, n0e = $n, r0e = Sl, i0e = {
  message: "boolean schema is false"
};
function o0e(e) {
  const { gen: t, schema: n, validateName: r } = e;
  n === !1 ? n7(e, !1) : typeof n == "object" && n.$async === !0 ? t.return(r0e.default.data) : (t.assign((0, n0e._)`${r}.errors`, null), t.return(!0));
}
lm.topBoolOrEmptySchema = o0e;
function s0e(e, t) {
  const { gen: n, schema: r } = e;
  r === !1 ? (n.var(t, !1), n7(e)) : n.var(t, !0);
}
lm.boolOrEmptySchema = s0e;
function n7(e, t) {
  const { gen: n, data: r } = e, i = {
    gen: n,
    keyword: "false schema",
    data: r,
    schema: !1,
    schemaCode: !1,
    schemaValue: !1,
    params: {},
    it: e
  };
  (0, t0e.reportError)(i, i0e, void 0, t);
}
var zi = {}, zp = {};
Object.defineProperty(zp, "__esModule", { value: !0 });
zp.getRules = zp.isJSONType = void 0;
const a0e = ["string", "number", "integer", "boolean", "null", "object", "array"], l0e = new Set(a0e);
function u0e(e) {
  return typeof e == "string" && l0e.has(e);
}
zp.isJSONType = u0e;
function c0e() {
  const e = {
    number: { type: "number", rules: [] },
    string: { type: "string", rules: [] },
    array: { type: "array", rules: [] },
    object: { type: "object", rules: [] }
  };
  return {
    types: { ...e, integer: !0, boolean: !0, null: !0 },
    rules: [{ rules: [] }, e.number, e.string, e.array, e.object],
    post: { rules: [] },
    all: {},
    keywords: {}
  };
}
zp.getRules = c0e;
var tc = {};
Object.defineProperty(tc, "__esModule", { value: !0 });
tc.shouldUseRule = tc.shouldUseGroup = tc.schemaHasRulesForType = void 0;
function d0e({ schema: e, self: t }, n) {
  const r = t.RULES.types[n];
  return r && r !== !0 && r7(e, r);
}
tc.schemaHasRulesForType = d0e;
function r7(e, t) {
  return t.rules.some((n) => i7(e, n));
}
tc.shouldUseGroup = r7;
function i7(e, t) {
  var n;
  return e[t.keyword] !== void 0 || ((n = t.definition.implements) === null || n === void 0 ? void 0 : n.some((r) => e[r] !== void 0));
}
tc.shouldUseRule = i7;
Object.defineProperty(zi, "__esModule", { value: !0 });
zi.reportTypeError = zi.checkDataTypes = zi.checkDataType = zi.coerceAndCheckDataType = zi.getJSONTypes = zi.getSchemaTypes = zi.DataType = void 0;
const p0e = zp, f0e = tc, h0e = qm, In = $n, o7 = jt;
var Wh;
(function(e) {
  e[e.Correct = 0] = "Correct", e[e.Wrong = 1] = "Wrong";
})(Wh || (zi.DataType = Wh = {}));
function m0e(e) {
  const t = s7(e.type);
  if (t.includes("null")) {
    if (e.nullable === !1)
      throw new Error("type: null contradicts nullable: false");
  } else {
    if (!t.length && e.nullable !== void 0)
      throw new Error('"nullable" cannot be used without "type"');
    e.nullable === !0 && t.push("null");
  }
  return t;
}
zi.getSchemaTypes = m0e;
function s7(e) {
  const t = Array.isArray(e) ? e : e ? [e] : [];
  if (t.every(p0e.isJSONType))
    return t;
  throw new Error("type must be JSONType or JSONType[]: " + t.join(","));
}
zi.getJSONTypes = s7;
function g0e(e, t) {
  const { gen: n, data: r, opts: i } = e, o = y0e(t, i.coerceTypes), s = t.length > 0 && !(o.length === 0 && t.length === 1 && (0, f0e.schemaHasRulesForType)(e, t[0]));
  if (s) {
    const a = e2(t, r, i.strictNumbers, Wh.Wrong);
    n.if(a, () => {
      o.length ? b0e(e, t, o) : t2(e);
    });
  }
  return s;
}
zi.coerceAndCheckDataType = g0e;
const a7 = /* @__PURE__ */ new Set(["string", "number", "integer", "boolean", "null"]);
function y0e(e, t) {
  return t ? e.filter((n) => a7.has(n) || t === "array" && n === "array") : [];
}
function b0e(e, t, n) {
  const { gen: r, data: i, opts: o } = e, s = r.let("dataType", (0, In._)`typeof ${i}`), a = r.let("coerced", (0, In._)`undefined`);
  o.coerceTypes === "array" && r.if((0, In._)`${s} == 'object' && Array.isArray(${i}) && ${i}.length == 1`, () => r.assign(i, (0, In._)`${i}[0]`).assign(s, (0, In._)`typeof ${i}`).if(e2(t, i, o.strictNumbers), () => r.assign(a, i))), r.if((0, In._)`${a} !== undefined`);
  for (const c of n)
    (a7.has(c) || c === "array" && o.coerceTypes === "array") && u(c);
  r.else(), t2(e), r.endIf(), r.if((0, In._)`${a} !== undefined`, () => {
    r.assign(i, a), v0e(e, a);
  });
  function u(c) {
    switch (c) {
      case "string":
        r.elseIf((0, In._)`${s} == "number" || ${s} == "boolean"`).assign(a, (0, In._)`"" + ${i}`).elseIf((0, In._)`${i} === null`).assign(a, (0, In._)`""`);
        return;
      case "number":
        r.elseIf((0, In._)`${s} == "boolean" || ${i} === null
              || (${s} == "string" && ${i} && ${i} == +${i})`).assign(a, (0, In._)`+${i}`);
        return;
      case "integer":
        r.elseIf((0, In._)`${s} === "boolean" || ${i} === null
              || (${s} === "string" && ${i} && ${i} == +${i} && !(${i} % 1))`).assign(a, (0, In._)`+${i}`);
        return;
      case "boolean":
        r.elseIf((0, In._)`${i} === "false" || ${i} === 0 || ${i} === null`).assign(a, !1).elseIf((0, In._)`${i} === "true" || ${i} === 1`).assign(a, !0);
        return;
      case "null":
        r.elseIf((0, In._)`${i} === "" || ${i} === 0 || ${i} === false`), r.assign(a, null);
        return;
      case "array":
        r.elseIf((0, In._)`${s} === "string" || ${s} === "number"
              || ${s} === "boolean" || ${i} === null`).assign(a, (0, In._)`[${i}]`);
    }
  }
}
function v0e({ gen: e, parentData: t, parentDataProperty: n }, r) {
  e.if((0, In._)`${t} !== undefined`, () => e.assign((0, In._)`${t}[${n}]`, r));
}
function SP(e, t, n, r = Wh.Correct) {
  const i = r === Wh.Correct ? In.operators.EQ : In.operators.NEQ;
  let o;
  switch (e) {
    case "null":
      return (0, In._)`${t} ${i} null`;
    case "array":
      o = (0, In._)`Array.isArray(${t})`;
      break;
    case "object":
      o = (0, In._)`${t} && typeof ${t} == "object" && !Array.isArray(${t})`;
      break;
    case "integer":
      o = s((0, In._)`!(${t} % 1) && !isNaN(${t})`);
      break;
    case "number":
      o = s();
      break;
    default:
      return (0, In._)`typeof ${t} ${i} ${e}`;
  }
  return r === Wh.Correct ? o : (0, In.not)(o);
  function s(a = In.nil) {
    return (0, In.and)((0, In._)`typeof ${t} == "number"`, a, n ? (0, In._)`isFinite(${t})` : In.nil);
  }
}
zi.checkDataType = SP;
function e2(e, t, n, r) {
  if (e.length === 1)
    return SP(e[0], t, n, r);
  let i;
  const o = (0, o7.toHash)(e);
  if (o.array && o.object) {
    const s = (0, In._)`typeof ${t} != "object"`;
    i = o.null ? s : (0, In._)`!${t} || ${s}`, delete o.null, delete o.array, delete o.object;
  } else
    i = In.nil;
  o.number && delete o.integer;
  for (const s in o)
    i = (0, In.and)(i, SP(s, t, n, r));
  return i;
}
zi.checkDataTypes = e2;
const x0e = {
  message: ({ schema: e }) => `must be ${e}`,
  params: ({ schema: e, schemaValue: t }) => typeof e == "string" ? (0, In._)`{type: ${e}}` : (0, In._)`{type: ${t}}`
};
function t2(e) {
  const t = D0e(e);
  (0, h0e.reportError)(t, x0e);
}
zi.reportTypeError = t2;
function D0e(e) {
  const { gen: t, data: n, schema: r } = e, i = (0, o7.schemaRefOrVal)(e, r, "type");
  return {
    gen: t,
    keyword: "type",
    data: n,
    schema: r.type,
    schemaCode: i,
    schemaValue: i,
    parentSchema: r,
    params: {},
    it: e
  };
}
var tE = {};
Object.defineProperty(tE, "__esModule", { value: !0 });
tE.assignDefaults = void 0;
const ch = $n, C0e = jt;
function E0e(e, t) {
  const { properties: n, items: r } = e.schema;
  if (t === "object" && n)
    for (const i in n)
      B_(e, i, n[i].default);
  else t === "array" && Array.isArray(r) && r.forEach((i, o) => B_(e, o, i.default));
}
tE.assignDefaults = E0e;
function B_(e, t, n) {
  const { gen: r, compositeRule: i, data: o, opts: s } = e;
  if (n === void 0)
    return;
  const a = (0, ch._)`${o}${(0, ch.getProperty)(t)}`;
  if (i) {
    (0, C0e.checkStrictMode)(e, `default is ignored for: ${a}`);
    return;
  }
  let u = (0, ch._)`${a} === undefined`;
  s.useDefaults === "empty" && (u = (0, ch._)`${u} || ${a} === null || ${a} === ""`), r.if(u, (0, ch._)`${a} = ${(0, ch.stringify)(n)}`);
}
var eu = {}, Bn = {};
Object.defineProperty(Bn, "__esModule", { value: !0 });
Bn.validateUnion = Bn.validateArray = Bn.usePattern = Bn.callValidateCode = Bn.schemaProperties = Bn.allSchemaProperties = Bn.noPropertyInData = Bn.propertyInData = Bn.isOwnProperty = Bn.hasPropFunc = Bn.reportMissingProp = Bn.checkMissingProp = Bn.checkReportMissingProp = void 0;
const Yr = $n, n2 = jt, zc = Sl, T0e = jt;
function S0e(e, t) {
  const { gen: n, data: r, it: i } = e;
  n.if(i2(n, r, t, i.opts.ownProperties), () => {
    e.setParams({ missingProperty: (0, Yr._)`${t}` }, !0), e.error();
  });
}
Bn.checkReportMissingProp = S0e;
function A0e({ gen: e, data: t, it: { opts: n } }, r, i) {
  return (0, Yr.or)(...r.map((o) => (0, Yr.and)(i2(e, t, o, n.ownProperties), (0, Yr._)`${i} = ${o}`)));
}
Bn.checkMissingProp = A0e;
function w0e(e, t) {
  e.setParams({ missingProperty: t }, !0), e.error();
}
Bn.reportMissingProp = w0e;
function l7(e) {
  return e.scopeValue("func", {
    // eslint-disable-next-line @typescript-eslint/unbound-method
    ref: Object.prototype.hasOwnProperty,
    code: (0, Yr._)`Object.prototype.hasOwnProperty`
  });
}
Bn.hasPropFunc = l7;
function r2(e, t, n) {
  return (0, Yr._)`${l7(e)}.call(${t}, ${n})`;
}
Bn.isOwnProperty = r2;
function P0e(e, t, n, r) {
  const i = (0, Yr._)`${t}${(0, Yr.getProperty)(n)} !== undefined`;
  return r ? (0, Yr._)`${i} && ${r2(e, t, n)}` : i;
}
Bn.propertyInData = P0e;
function i2(e, t, n, r) {
  const i = (0, Yr._)`${t}${(0, Yr.getProperty)(n)} === undefined`;
  return r ? (0, Yr.or)(i, (0, Yr.not)(r2(e, t, n))) : i;
}
Bn.noPropertyInData = i2;
function u7(e) {
  return e ? Object.keys(e).filter((t) => t !== "__proto__") : [];
}
Bn.allSchemaProperties = u7;
function k0e(e, t) {
  return u7(t).filter((n) => !(0, n2.alwaysValidSchema)(e, t[n]));
}
Bn.schemaProperties = k0e;
function O0e({ schemaCode: e, data: t, it: { gen: n, topSchemaRef: r, schemaPath: i, errorPath: o }, it: s }, a, u, c) {
  const d = c ? (0, Yr._)`${e}, ${t}, ${r}${i}` : t, f = [
    [zc.default.instancePath, (0, Yr.strConcat)(zc.default.instancePath, o)],
    [zc.default.parentData, s.parentData],
    [zc.default.parentDataProperty, s.parentDataProperty],
    [zc.default.rootData, zc.default.rootData]
  ];
  s.opts.dynamicRef && f.push([zc.default.dynamicAnchors, zc.default.dynamicAnchors]);
  const h = (0, Yr._)`${d}, ${n.object(...f)}`;
  return u !== Yr.nil ? (0, Yr._)`${a}.call(${u}, ${h})` : (0, Yr._)`${a}(${h})`;
}
Bn.callValidateCode = O0e;
const I0e = (0, Yr._)`new RegExp`;
function F0e({ gen: e, it: { opts: t } }, n) {
  const r = t.unicodeRegExp ? "u" : "", { regExp: i } = t.code, o = i(n, r);
  return e.scopeValue("pattern", {
    key: o.toString(),
    ref: o,
    code: (0, Yr._)`${i.code === "new RegExp" ? I0e : (0, T0e.useFunc)(e, i)}(${n}, ${r})`
  });
}
Bn.usePattern = F0e;
function $0e(e) {
  const { gen: t, data: n, keyword: r, it: i } = e, o = t.name("valid");
  if (i.allErrors) {
    const a = t.let("valid", !0);
    return s(() => t.assign(a, !1)), a;
  }
  return t.var(o, !0), s(() => t.break()), o;
  function s(a) {
    const u = t.const("len", (0, Yr._)`${n}.length`);
    t.forRange("i", 0, u, (c) => {
      e.subschema({
        keyword: r,
        dataProp: c,
        dataPropType: n2.Type.Num
      }, o), t.if((0, Yr.not)(o), a);
    });
  }
}
Bn.validateArray = $0e;
function N0e(e) {
  const { gen: t, schema: n, keyword: r, it: i } = e;
  if (!Array.isArray(n))
    throw new Error("ajv implementation error");
  if (n.some((u) => (0, n2.alwaysValidSchema)(i, u)) && !i.opts.unevaluated)
    return;
  const s = t.let("valid", !1), a = t.name("_valid");
  t.block(() => n.forEach((u, c) => {
    const d = e.subschema({
      keyword: r,
      schemaProp: c,
      compositeRule: !0
    }, a);
    t.assign(s, (0, Yr._)`${s} || ${a}`), e.mergeValidEvaluated(d, a) || t.if((0, Yr.not)(s));
  })), e.result(s, () => e.reset(), () => e.error(!0));
}
Bn.validateUnion = N0e;
Object.defineProperty(eu, "__esModule", { value: !0 });
eu.validateKeywordUsage = eu.validSchemaType = eu.funcKeywordCode = eu.macroKeywordCode = void 0;
const Xo = $n, xp = Sl, M0e = Bn, R0e = qm;
function _0e(e, t) {
  const { gen: n, keyword: r, schema: i, parentSchema: o, it: s } = e, a = t.macro.call(s.self, i, o, s), u = c7(n, r, a);
  s.opts.validateSchema !== !1 && s.self.validateSchema(a, !0);
  const c = n.name("valid");
  e.subschema({
    schema: a,
    schemaPath: Xo.nil,
    errSchemaPath: `${s.errSchemaPath}/${r}`,
    topSchemaRef: u,
    compositeRule: !0
  }, c), e.pass(c, () => e.error(!0));
}
eu.macroKeywordCode = _0e;
function L0e(e, t) {
  var n;
  const { gen: r, keyword: i, schema: o, parentSchema: s, $data: a, it: u } = e;
  j0e(u, t);
  const c = !a && t.compile ? t.compile.call(u.self, o, s, u) : t.validate, d = c7(r, i, c), f = r.let("valid");
  e.block$data(f, h), e.ok((n = t.valid) !== null && n !== void 0 ? n : f);
  function h() {
    if (t.errors === !1)
      x(), t.modifying && j_(e), C(() => e.error());
    else {
      const E = t.async ? m() : v();
      t.modifying && j_(e), C(() => B0e(e, E));
    }
  }
  function m() {
    const E = r.let("ruleErrs", null);
    return r.try(() => x((0, Xo._)`await `), (S) => r.assign(f, !1).if((0, Xo._)`${S} instanceof ${u.ValidationError}`, () => r.assign(E, (0, Xo._)`${S}.errors`), () => r.throw(S))), E;
  }
  function v() {
    const E = (0, Xo._)`${d}.errors`;
    return r.assign(E, null), x(Xo.nil), E;
  }
  function x(E = t.async ? (0, Xo._)`await ` : Xo.nil) {
    const S = u.opts.passContext ? xp.default.this : xp.default.self, w = !("compile" in t && !a || t.schema === !1);
    r.assign(f, (0, Xo._)`${E}${(0, M0e.callValidateCode)(e, d, S, w)}`, t.modifying);
  }
  function C(E) {
    var S;
    r.if((0, Xo.not)((S = t.valid) !== null && S !== void 0 ? S : f), E);
  }
}
eu.funcKeywordCode = L0e;
function j_(e) {
  const { gen: t, data: n, it: r } = e;
  t.if(r.parentData, () => t.assign(n, (0, Xo._)`${r.parentData}[${r.parentDataProperty}]`));
}
function B0e(e, t) {
  const { gen: n } = e;
  n.if((0, Xo._)`Array.isArray(${t})`, () => {
    n.assign(xp.default.vErrors, (0, Xo._)`${xp.default.vErrors} === null ? ${t} : ${xp.default.vErrors}.concat(${t})`).assign(xp.default.errors, (0, Xo._)`${xp.default.vErrors}.length`), (0, R0e.extendErrors)(e);
  }, () => e.error());
}
function j0e({ schemaEnv: e }, t) {
  if (t.async && !e.$async)
    throw new Error("async keyword in sync schema");
}
function c7(e, t, n) {
  if (n === void 0)
    throw new Error(`keyword "${t}" failed to compile`);
  return e.scopeValue("keyword", typeof n == "function" ? { ref: n } : { ref: n, code: (0, Xo.stringify)(n) });
}
function V0e(e, t, n = !1) {
  return !t.length || t.some((r) => r === "array" ? Array.isArray(e) : r === "object" ? e && typeof e == "object" && !Array.isArray(e) : typeof e == r || n && typeof e > "u");
}
eu.validSchemaType = V0e;
function z0e({ schema: e, opts: t, self: n, errSchemaPath: r }, i, o) {
  if (Array.isArray(i.keyword) ? !i.keyword.includes(o) : i.keyword !== o)
    throw new Error("ajv implementation error");
  const s = i.dependencies;
  if (s != null && s.some((a) => !Object.prototype.hasOwnProperty.call(e, a)))
    throw new Error(`parent schema must have dependencies of ${o}: ${s.join(",")}`);
  if (i.validateSchema && !i.validateSchema(e[o])) {
    const u = `keyword "${o}" value is invalid at path "${r}": ` + n.errorsText(i.validateSchema.errors);
    if (t.validateSchema === "log")
      n.logger.error(u);
    else
      throw new Error(u);
  }
}
eu.validateKeywordUsage = z0e;
var ld = {};
Object.defineProperty(ld, "__esModule", { value: !0 });
ld.extendSubschemaMode = ld.extendSubschemaData = ld.getSubschema = void 0;
const Gl = $n, d7 = jt;
function U0e(e, { keyword: t, schemaProp: n, schema: r, schemaPath: i, errSchemaPath: o, topSchemaRef: s }) {
  if (t !== void 0 && r !== void 0)
    throw new Error('both "keyword" and "schema" passed, only one allowed');
  if (t !== void 0) {
    const a = e.schema[t];
    return n === void 0 ? {
      schema: a,
      schemaPath: (0, Gl._)`${e.schemaPath}${(0, Gl.getProperty)(t)}`,
      errSchemaPath: `${e.errSchemaPath}/${t}`
    } : {
      schema: a[n],
      schemaPath: (0, Gl._)`${e.schemaPath}${(0, Gl.getProperty)(t)}${(0, Gl.getProperty)(n)}`,
      errSchemaPath: `${e.errSchemaPath}/${t}/${(0, d7.escapeFragment)(n)}`
    };
  }
  if (r !== void 0) {
    if (i === void 0 || o === void 0 || s === void 0)
      throw new Error('"schemaPath", "errSchemaPath" and "topSchemaRef" are required with "schema"');
    return {
      schema: r,
      schemaPath: i,
      topSchemaRef: s,
      errSchemaPath: o
    };
  }
  throw new Error('either "keyword" or "schema" must be passed');
}
ld.getSubschema = U0e;
function W0e(e, t, { dataProp: n, dataPropType: r, data: i, dataTypes: o, propertyName: s }) {
  if (i !== void 0 && n !== void 0)
    throw new Error('both "data" and "dataProp" passed, only one allowed');
  const { gen: a } = t;
  if (n !== void 0) {
    const { errorPath: c, dataPathArr: d, opts: f } = t, h = a.let("data", (0, Gl._)`${t.data}${(0, Gl.getProperty)(n)}`, !0);
    u(h), e.errorPath = (0, Gl.str)`${c}${(0, d7.getErrorPath)(n, r, f.jsPropertySyntax)}`, e.parentDataProperty = (0, Gl._)`${n}`, e.dataPathArr = [...d, e.parentDataProperty];
  }
  if (i !== void 0) {
    const c = i instanceof Gl.Name ? i : a.let("data", i, !0);
    u(c), s !== void 0 && (e.propertyName = s);
  }
  o && (e.dataTypes = o);
  function u(c) {
    e.data = c, e.dataLevel = t.dataLevel + 1, e.dataTypes = [], t.definedProperties = /* @__PURE__ */ new Set(), e.parentData = t.data, e.dataNames = [...t.dataNames, c];
  }
}
ld.extendSubschemaData = W0e;
function H0e(e, { jtdDiscriminator: t, jtdMetadata: n, compositeRule: r, createErrors: i, allErrors: o }) {
  r !== void 0 && (e.compositeRule = r), i !== void 0 && (e.createErrors = i), o !== void 0 && (e.allErrors = o), e.jtdDiscriminator = t, e.jtdMetadata = n;
}
ld.extendSubschemaMode = H0e;
var ho = {}, p7 = function e(t, n) {
  if (t === n) return !0;
  if (t && n && typeof t == "object" && typeof n == "object") {
    if (t.constructor !== n.constructor) return !1;
    var r, i, o;
    if (Array.isArray(t)) {
      if (r = t.length, r != n.length) return !1;
      for (i = r; i-- !== 0; )
        if (!e(t[i], n[i])) return !1;
      return !0;
    }
    if (t.constructor === RegExp) return t.source === n.source && t.flags === n.flags;
    if (t.valueOf !== Object.prototype.valueOf) return t.valueOf() === n.valueOf();
    if (t.toString !== Object.prototype.toString) return t.toString() === n.toString();
    if (o = Object.keys(t), r = o.length, r !== Object.keys(n).length) return !1;
    for (i = r; i-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(n, o[i])) return !1;
    for (i = r; i-- !== 0; ) {
      var s = o[i];
      if (!e(t[s], n[s])) return !1;
    }
    return !0;
  }
  return t !== t && n !== n;
}, f7 = { exports: {} }, ed = f7.exports = function(e, t, n) {
  typeof t == "function" && (n = t, t = {}), n = t.cb || n;
  var r = typeof n == "function" ? n : n.pre || function() {
  }, i = n.post || function() {
  };
  _x(t, r, i, e, "", e);
};
ed.keywords = {
  additionalItems: !0,
  items: !0,
  contains: !0,
  additionalProperties: !0,
  propertyNames: !0,
  not: !0,
  if: !0,
  then: !0,
  else: !0
};
ed.arrayKeywords = {
  items: !0,
  allOf: !0,
  anyOf: !0,
  oneOf: !0
};
ed.propsKeywords = {
  $defs: !0,
  definitions: !0,
  properties: !0,
  patternProperties: !0,
  dependencies: !0
};
ed.skipKeywords = {
  default: !0,
  enum: !0,
  const: !0,
  required: !0,
  maximum: !0,
  minimum: !0,
  exclusiveMaximum: !0,
  exclusiveMinimum: !0,
  multipleOf: !0,
  maxLength: !0,
  minLength: !0,
  pattern: !0,
  format: !0,
  maxItems: !0,
  minItems: !0,
  uniqueItems: !0,
  maxProperties: !0,
  minProperties: !0
};
function _x(e, t, n, r, i, o, s, a, u, c) {
  if (r && typeof r == "object" && !Array.isArray(r)) {
    t(r, i, o, s, a, u, c);
    for (var d in r) {
      var f = r[d];
      if (Array.isArray(f)) {
        if (d in ed.arrayKeywords)
          for (var h = 0; h < f.length; h++)
            _x(e, t, n, f[h], i + "/" + d + "/" + h, o, i, d, r, h);
      } else if (d in ed.propsKeywords) {
        if (f && typeof f == "object")
          for (var m in f)
            _x(e, t, n, f[m], i + "/" + d + "/" + q0e(m), o, i, d, r, m);
      } else (d in ed.keywords || e.allKeys && !(d in ed.skipKeywords)) && _x(e, t, n, f, i + "/" + d, o, i, d, r);
    }
    n(r, i, o, s, a, u, c);
  }
}
function q0e(e) {
  return e.replace(/~/g, "~0").replace(/\//g, "~1");
}
var G0e = f7.exports;
Object.defineProperty(ho, "__esModule", { value: !0 });
ho.getSchemaRefs = ho.resolveUrl = ho.normalizeId = ho._getFullPath = ho.getFullPath = ho.inlineRef = void 0;
const Y0e = jt, K0e = p7, J0e = G0e, X0e = /* @__PURE__ */ new Set([
  "type",
  "format",
  "pattern",
  "maxLength",
  "minLength",
  "maxProperties",
  "minProperties",
  "maxItems",
  "minItems",
  "maximum",
  "minimum",
  "uniqueItems",
  "multipleOf",
  "required",
  "enum",
  "const"
]);
function Q0e(e, t = !0) {
  return typeof e == "boolean" ? !0 : t === !0 ? !AP(e) : t ? h7(e) <= t : !1;
}
ho.inlineRef = Q0e;
const Z0e = /* @__PURE__ */ new Set([
  "$ref",
  "$recursiveRef",
  "$recursiveAnchor",
  "$dynamicRef",
  "$dynamicAnchor"
]);
function AP(e) {
  for (const t in e) {
    if (Z0e.has(t))
      return !0;
    const n = e[t];
    if (Array.isArray(n) && n.some(AP) || typeof n == "object" && AP(n))
      return !0;
  }
  return !1;
}
function h7(e) {
  let t = 0;
  for (const n in e) {
    if (n === "$ref")
      return 1 / 0;
    if (t++, !X0e.has(n) && (typeof e[n] == "object" && (0, Y0e.eachItem)(e[n], (r) => t += h7(r)), t === 1 / 0))
      return 1 / 0;
  }
  return t;
}
function m7(e, t = "", n) {
  n !== !1 && (t = Hh(t));
  const r = e.parse(t);
  return g7(e, r);
}
ho.getFullPath = m7;
function g7(e, t) {
  return e.serialize(t).split("#")[0] + "#";
}
ho._getFullPath = g7;
const ebe = /#\/?$/;
function Hh(e) {
  return e ? e.replace(ebe, "") : "";
}
ho.normalizeId = Hh;
function tbe(e, t, n) {
  return n = Hh(n), e.resolve(t, n);
}
ho.resolveUrl = tbe;
const nbe = /^[a-z_][-a-z0-9._]*$/i;
function rbe(e, t) {
  if (typeof e == "boolean")
    return {};
  const { schemaId: n, uriResolver: r } = this.opts, i = Hh(e[n] || t), o = { "": i }, s = m7(r, i, !1), a = {}, u = /* @__PURE__ */ new Set();
  return J0e(e, { allKeys: !0 }, (f, h, m, v) => {
    if (v === void 0)
      return;
    const x = s + h;
    let C = o[v];
    typeof f[n] == "string" && (C = E.call(this, f[n])), S.call(this, f.$anchor), S.call(this, f.$dynamicAnchor), o[h] = C;
    function E(w) {
      const O = this.opts.uriResolver.resolve;
      if (w = Hh(C ? O(C, w) : w), u.has(w))
        throw d(w);
      u.add(w);
      let A = this.refs[w];
      return typeof A == "string" && (A = this.refs[A]), typeof A == "object" ? c(f, A.schema, w) : w !== Hh(x) && (w[0] === "#" ? (c(f, a[w], w), a[w] = f) : this.refs[w] = x), w;
    }
    function S(w) {
      if (typeof w == "string") {
        if (!nbe.test(w))
          throw new Error(`invalid anchor "${w}"`);
        E.call(this, `#${w}`);
      }
    }
  }), a;
  function c(f, h, m) {
    if (h !== void 0 && !K0e(f, h))
      throw d(m);
  }
  function d(f) {
    return new Error(`reference "${f}" resolves to more than one schema`);
  }
}
ho.getSchemaRefs = rbe;
Object.defineProperty(Na, "__esModule", { value: !0 });
Na.getData = Na.KeywordCxt = Na.validateFunctionCode = void 0;
const y7 = lm, V_ = zi, o2 = tc, AD = zi, ibe = tE, t0 = eu, fA = ld, Zt = $n, bn = Sl, obe = ho, nc = jt, xy = qm;
function sbe(e) {
  if (x7(e) && (D7(e), v7(e))) {
    ube(e);
    return;
  }
  b7(e, () => (0, y7.topBoolOrEmptySchema)(e));
}
Na.validateFunctionCode = sbe;
function b7({ gen: e, validateName: t, schema: n, schemaEnv: r, opts: i }, o) {
  i.code.es5 ? e.func(t, (0, Zt._)`${bn.default.data}, ${bn.default.valCxt}`, r.$async, () => {
    e.code((0, Zt._)`"use strict"; ${z_(n, i)}`), lbe(e, i), e.code(o);
  }) : e.func(t, (0, Zt._)`${bn.default.data}, ${abe(i)}`, r.$async, () => e.code(z_(n, i)).code(o));
}
function abe(e) {
  return (0, Zt._)`{${bn.default.instancePath}="", ${bn.default.parentData}, ${bn.default.parentDataProperty}, ${bn.default.rootData}=${bn.default.data}${e.dynamicRef ? (0, Zt._)`, ${bn.default.dynamicAnchors}={}` : Zt.nil}}={}`;
}
function lbe(e, t) {
  e.if(bn.default.valCxt, () => {
    e.var(bn.default.instancePath, (0, Zt._)`${bn.default.valCxt}.${bn.default.instancePath}`), e.var(bn.default.parentData, (0, Zt._)`${bn.default.valCxt}.${bn.default.parentData}`), e.var(bn.default.parentDataProperty, (0, Zt._)`${bn.default.valCxt}.${bn.default.parentDataProperty}`), e.var(bn.default.rootData, (0, Zt._)`${bn.default.valCxt}.${bn.default.rootData}`), t.dynamicRef && e.var(bn.default.dynamicAnchors, (0, Zt._)`${bn.default.valCxt}.${bn.default.dynamicAnchors}`);
  }, () => {
    e.var(bn.default.instancePath, (0, Zt._)`""`), e.var(bn.default.parentData, (0, Zt._)`undefined`), e.var(bn.default.parentDataProperty, (0, Zt._)`undefined`), e.var(bn.default.rootData, bn.default.data), t.dynamicRef && e.var(bn.default.dynamicAnchors, (0, Zt._)`{}`);
  });
}
function ube(e) {
  const { schema: t, opts: n, gen: r } = e;
  b7(e, () => {
    n.$comment && t.$comment && E7(e), hbe(e), r.let(bn.default.vErrors, null), r.let(bn.default.errors, 0), n.unevaluated && cbe(e), C7(e), ybe(e);
  });
}
function cbe(e) {
  const { gen: t, validateName: n } = e;
  e.evaluated = t.const("evaluated", (0, Zt._)`${n}.evaluated`), t.if((0, Zt._)`${e.evaluated}.dynamicProps`, () => t.assign((0, Zt._)`${e.evaluated}.props`, (0, Zt._)`undefined`)), t.if((0, Zt._)`${e.evaluated}.dynamicItems`, () => t.assign((0, Zt._)`${e.evaluated}.items`, (0, Zt._)`undefined`));
}
function z_(e, t) {
  const n = typeof e == "object" && e[t.schemaId];
  return n && (t.code.source || t.code.process) ? (0, Zt._)`/*# sourceURL=${n} */` : Zt.nil;
}
function dbe(e, t) {
  if (x7(e) && (D7(e), v7(e))) {
    pbe(e, t);
    return;
  }
  (0, y7.boolOrEmptySchema)(e, t);
}
function v7({ schema: e, self: t }) {
  if (typeof e == "boolean")
    return !e;
  for (const n in e)
    if (t.RULES.all[n])
      return !0;
  return !1;
}
function x7(e) {
  return typeof e.schema != "boolean";
}
function pbe(e, t) {
  const { schema: n, gen: r, opts: i } = e;
  i.$comment && n.$comment && E7(e), mbe(e), gbe(e);
  const o = r.const("_errs", bn.default.errors);
  C7(e, o), r.var(t, (0, Zt._)`${o} === ${bn.default.errors}`);
}
function D7(e) {
  (0, nc.checkUnknownRules)(e), fbe(e);
}
function C7(e, t) {
  if (e.opts.jtd)
    return U_(e, [], !1, t);
  const n = (0, V_.getSchemaTypes)(e.schema), r = (0, V_.coerceAndCheckDataType)(e, n);
  U_(e, n, !r, t);
}
function fbe(e) {
  const { schema: t, errSchemaPath: n, opts: r, self: i } = e;
  t.$ref && r.ignoreKeywordsWithRef && (0, nc.schemaHasRulesButRef)(t, i.RULES) && i.logger.warn(`$ref: keywords ignored in schema at path "${n}"`);
}
function hbe(e) {
  const { schema: t, opts: n } = e;
  t.default !== void 0 && n.useDefaults && n.strictSchema && (0, nc.checkStrictMode)(e, "default is ignored in the schema root");
}
function mbe(e) {
  const t = e.schema[e.opts.schemaId];
  t && (e.baseId = (0, obe.resolveUrl)(e.opts.uriResolver, e.baseId, t));
}
function gbe(e) {
  if (e.schema.$async && !e.schemaEnv.$async)
    throw new Error("async schema in sync schema");
}
function E7({ gen: e, schemaEnv: t, schema: n, errSchemaPath: r, opts: i }) {
  const o = n.$comment;
  if (i.$comment === !0)
    e.code((0, Zt._)`${bn.default.self}.logger.log(${o})`);
  else if (typeof i.$comment == "function") {
    const s = (0, Zt.str)`${r}/$comment`, a = e.scopeValue("root", { ref: t.root });
    e.code((0, Zt._)`${bn.default.self}.opts.$comment(${o}, ${s}, ${a}.schema)`);
  }
}
function ybe(e) {
  const { gen: t, schemaEnv: n, validateName: r, ValidationError: i, opts: o } = e;
  n.$async ? t.if((0, Zt._)`${bn.default.errors} === 0`, () => t.return(bn.default.data), () => t.throw((0, Zt._)`new ${i}(${bn.default.vErrors})`)) : (t.assign((0, Zt._)`${r}.errors`, bn.default.vErrors), o.unevaluated && bbe(e), t.return((0, Zt._)`${bn.default.errors} === 0`));
}
function bbe({ gen: e, evaluated: t, props: n, items: r }) {
  n instanceof Zt.Name && e.assign((0, Zt._)`${t}.props`, n), r instanceof Zt.Name && e.assign((0, Zt._)`${t}.items`, r);
}
function U_(e, t, n, r) {
  const { gen: i, schema: o, data: s, allErrors: a, opts: u, self: c } = e, { RULES: d } = c;
  if (o.$ref && (u.ignoreKeywordsWithRef || !(0, nc.schemaHasRulesButRef)(o, d))) {
    i.block(() => A7(e, "$ref", d.all.$ref.definition));
    return;
  }
  u.jtd || vbe(e, t), i.block(() => {
    for (const h of d.rules)
      f(h);
    f(d.post);
  });
  function f(h) {
    (0, o2.shouldUseGroup)(o, h) && (h.type ? (i.if((0, AD.checkDataType)(h.type, s, u.strictNumbers)), W_(e, h), t.length === 1 && t[0] === h.type && n && (i.else(), (0, AD.reportTypeError)(e)), i.endIf()) : W_(e, h), a || i.if((0, Zt._)`${bn.default.errors} === ${r || 0}`));
  }
}
function W_(e, t) {
  const { gen: n, schema: r, opts: { useDefaults: i } } = e;
  i && (0, ibe.assignDefaults)(e, t.type), n.block(() => {
    for (const o of t.rules)
      (0, o2.shouldUseRule)(r, o) && A7(e, o.keyword, o.definition, t.type);
  });
}
function vbe(e, t) {
  e.schemaEnv.meta || !e.opts.strictTypes || (xbe(e, t), e.opts.allowUnionTypes || Dbe(e, t), Cbe(e, e.dataTypes));
}
function xbe(e, t) {
  if (t.length) {
    if (!e.dataTypes.length) {
      e.dataTypes = t;
      return;
    }
    t.forEach((n) => {
      T7(e.dataTypes, n) || s2(e, `type "${n}" not allowed by context "${e.dataTypes.join(",")}"`);
    }), Tbe(e, t);
  }
}
function Dbe(e, t) {
  t.length > 1 && !(t.length === 2 && t.includes("null")) && s2(e, "use allowUnionTypes to allow union type keyword");
}
function Cbe(e, t) {
  const n = e.self.RULES.all;
  for (const r in n) {
    const i = n[r];
    if (typeof i == "object" && (0, o2.shouldUseRule)(e.schema, i)) {
      const { type: o } = i.definition;
      o.length && !o.some((s) => Ebe(t, s)) && s2(e, `missing type "${o.join(",")}" for keyword "${r}"`);
    }
  }
}
function Ebe(e, t) {
  return e.includes(t) || t === "number" && e.includes("integer");
}
function T7(e, t) {
  return e.includes(t) || t === "integer" && e.includes("number");
}
function Tbe(e, t) {
  const n = [];
  for (const r of e.dataTypes)
    T7(t, r) ? n.push(r) : t.includes("integer") && r === "number" && n.push("integer");
  e.dataTypes = n;
}
function s2(e, t) {
  const n = e.schemaEnv.baseId + e.errSchemaPath;
  t += ` at "${n}" (strictTypes)`, (0, nc.checkStrictMode)(e, t, e.opts.strictTypes);
}
class S7 {
  constructor(t, n, r) {
    if ((0, t0.validateKeywordUsage)(t, n, r), this.gen = t.gen, this.allErrors = t.allErrors, this.keyword = r, this.data = t.data, this.schema = t.schema[r], this.$data = n.$data && t.opts.$data && this.schema && this.schema.$data, this.schemaValue = (0, nc.schemaRefOrVal)(t, this.schema, r, this.$data), this.schemaType = n.schemaType, this.parentSchema = t.schema, this.params = {}, this.it = t, this.def = n, this.$data)
      this.schemaCode = t.gen.const("vSchema", w7(this.$data, t));
    else if (this.schemaCode = this.schemaValue, !(0, t0.validSchemaType)(this.schema, n.schemaType, n.allowUndefined))
      throw new Error(`${r} value must be ${JSON.stringify(n.schemaType)}`);
    ("code" in n ? n.trackErrors : n.errors !== !1) && (this.errsCount = t.gen.const("_errs", bn.default.errors));
  }
  result(t, n, r) {
    this.failResult((0, Zt.not)(t), n, r);
  }
  failResult(t, n, r) {
    this.gen.if(t), r ? r() : this.error(), n ? (this.gen.else(), n(), this.allErrors && this.gen.endIf()) : this.allErrors ? this.gen.endIf() : this.gen.else();
  }
  pass(t, n) {
    this.failResult((0, Zt.not)(t), void 0, n);
  }
  fail(t) {
    if (t === void 0) {
      this.error(), this.allErrors || this.gen.if(!1);
      return;
    }
    this.gen.if(t), this.error(), this.allErrors ? this.gen.endIf() : this.gen.else();
  }
  fail$data(t) {
    if (!this.$data)
      return this.fail(t);
    const { schemaCode: n } = this;
    this.fail((0, Zt._)`${n} !== undefined && (${(0, Zt.or)(this.invalid$data(), t)})`);
  }
  error(t, n, r) {
    if (n) {
      this.setParams(n), this._error(t, r), this.setParams({});
      return;
    }
    this._error(t, r);
  }
  _error(t, n) {
    (t ? xy.reportExtraError : xy.reportError)(this, this.def.error, n);
  }
  $dataError() {
    (0, xy.reportError)(this, this.def.$dataError || xy.keyword$DataError);
  }
  reset() {
    if (this.errsCount === void 0)
      throw new Error('add "trackErrors" to keyword definition');
    (0, xy.resetErrorsCount)(this.gen, this.errsCount);
  }
  ok(t) {
    this.allErrors || this.gen.if(t);
  }
  setParams(t, n) {
    n ? Object.assign(this.params, t) : this.params = t;
  }
  block$data(t, n, r = Zt.nil) {
    this.gen.block(() => {
      this.check$data(t, r), n();
    });
  }
  check$data(t = Zt.nil, n = Zt.nil) {
    if (!this.$data)
      return;
    const { gen: r, schemaCode: i, schemaType: o, def: s } = this;
    r.if((0, Zt.or)((0, Zt._)`${i} === undefined`, n)), t !== Zt.nil && r.assign(t, !0), (o.length || s.validateSchema) && (r.elseIf(this.invalid$data()), this.$dataError(), t !== Zt.nil && r.assign(t, !1)), r.else();
  }
  invalid$data() {
    const { gen: t, schemaCode: n, schemaType: r, def: i, it: o } = this;
    return (0, Zt.or)(s(), a());
    function s() {
      if (r.length) {
        if (!(n instanceof Zt.Name))
          throw new Error("ajv implementation error");
        const u = Array.isArray(r) ? r : [r];
        return (0, Zt._)`${(0, AD.checkDataTypes)(u, n, o.opts.strictNumbers, AD.DataType.Wrong)}`;
      }
      return Zt.nil;
    }
    function a() {
      if (i.validateSchema) {
        const u = t.scopeValue("validate$data", { ref: i.validateSchema });
        return (0, Zt._)`!${u}(${n})`;
      }
      return Zt.nil;
    }
  }
  subschema(t, n) {
    const r = (0, fA.getSubschema)(this.it, t);
    (0, fA.extendSubschemaData)(r, this.it, t), (0, fA.extendSubschemaMode)(r, t);
    const i = { ...this.it, ...r, items: void 0, props: void 0 };
    return dbe(i, n), i;
  }
  mergeEvaluated(t, n) {
    const { it: r, gen: i } = this;
    r.opts.unevaluated && (r.props !== !0 && t.props !== void 0 && (r.props = nc.mergeEvaluated.props(i, t.props, r.props, n)), r.items !== !0 && t.items !== void 0 && (r.items = nc.mergeEvaluated.items(i, t.items, r.items, n)));
  }
  mergeValidEvaluated(t, n) {
    const { it: r, gen: i } = this;
    if (r.opts.unevaluated && (r.props !== !0 || r.items !== !0))
      return i.if(n, () => this.mergeEvaluated(t, Zt.Name)), !0;
  }
}
Na.KeywordCxt = S7;
function A7(e, t, n, r) {
  const i = new S7(e, n, t);
  "code" in n ? n.code(i, r) : i.$data && n.validate ? (0, t0.funcKeywordCode)(i, n) : "macro" in n ? (0, t0.macroKeywordCode)(i, n) : (n.compile || n.validate) && (0, t0.funcKeywordCode)(i, n);
}
const Sbe = /^\/(?:[^~]|~0|~1)*$/, Abe = /^([0-9]+)(#|\/(?:[^~]|~0|~1)*)?$/;
function w7(e, { dataLevel: t, dataNames: n, dataPathArr: r }) {
  let i, o;
  if (e === "")
    return bn.default.rootData;
  if (e[0] === "/") {
    if (!Sbe.test(e))
      throw new Error(`Invalid JSON-pointer: ${e}`);
    i = e, o = bn.default.rootData;
  } else {
    const c = Abe.exec(e);
    if (!c)
      throw new Error(`Invalid JSON-pointer: ${e}`);
    const d = +c[1];
    if (i = c[2], i === "#") {
      if (d >= t)
        throw new Error(u("property/index", d));
      return r[t - d];
    }
    if (d > t)
      throw new Error(u("data", d));
    if (o = n[t - d], !i)
      return o;
  }
  let s = o;
  const a = i.split("/");
  for (const c of a)
    c && (o = (0, Zt._)`${o}${(0, Zt.getProperty)((0, nc.unescapeJsonPointer)(c))}`, s = (0, Zt._)`${s} && ${o}`);
  return s;
  function u(c, d) {
    return `Cannot access ${c} ${d} levels up, current level is ${t}`;
  }
}
Na.getData = w7;
var w1 = {}, H_;
function a2() {
  if (H_) return w1;
  H_ = 1, Object.defineProperty(w1, "__esModule", { value: !0 });
  class e extends Error {
    constructor(n) {
      super("validation failed"), this.errors = n, this.ajv = this.validation = !0;
    }
  }
  return w1.default = e, w1;
}
var Gm = {};
Object.defineProperty(Gm, "__esModule", { value: !0 });
const hA = ho;
class wbe extends Error {
  constructor(t, n, r, i) {
    super(i || `can't resolve reference ${r} from id ${n}`), this.missingRef = (0, hA.resolveUrl)(t, n, r), this.missingSchema = (0, hA.normalizeId)((0, hA.getFullPath)(t, this.missingRef));
  }
}
Gm.default = wbe;
var Es = {};
Object.defineProperty(Es, "__esModule", { value: !0 });
Es.resolveSchema = Es.getCompilingSchema = Es.resolveRef = Es.compileSchema = Es.SchemaEnv = void 0;
const ul = $n, Pbe = a2(), lp = Sl, hl = ho, q_ = jt, kbe = Na;
class nE {
  constructor(t) {
    var n;
    this.refs = {}, this.dynamicAnchors = {};
    let r;
    typeof t.schema == "object" && (r = t.schema), this.schema = t.schema, this.schemaId = t.schemaId, this.root = t.root || this, this.baseId = (n = t.baseId) !== null && n !== void 0 ? n : (0, hl.normalizeId)(r == null ? void 0 : r[t.schemaId || "$id"]), this.schemaPath = t.schemaPath, this.localRefs = t.localRefs, this.meta = t.meta, this.$async = r == null ? void 0 : r.$async, this.refs = {};
  }
}
Es.SchemaEnv = nE;
function l2(e) {
  const t = P7.call(this, e);
  if (t)
    return t;
  const n = (0, hl.getFullPath)(this.opts.uriResolver, e.root.baseId), { es5: r, lines: i } = this.opts.code, { ownProperties: o } = this.opts, s = new ul.CodeGen(this.scope, { es5: r, lines: i, ownProperties: o });
  let a;
  e.$async && (a = s.scopeValue("Error", {
    ref: Pbe.default,
    code: (0, ul._)`require("ajv/dist/runtime/validation_error").default`
  }));
  const u = s.scopeName("validate");
  e.validateName = u;
  const c = {
    gen: s,
    allErrors: this.opts.allErrors,
    data: lp.default.data,
    parentData: lp.default.parentData,
    parentDataProperty: lp.default.parentDataProperty,
    dataNames: [lp.default.data],
    dataPathArr: [ul.nil],
    // TODO can its length be used as dataLevel if nil is removed?
    dataLevel: 0,
    dataTypes: [],
    definedProperties: /* @__PURE__ */ new Set(),
    topSchemaRef: s.scopeValue("schema", this.opts.code.source === !0 ? { ref: e.schema, code: (0, ul.stringify)(e.schema) } : { ref: e.schema }),
    validateName: u,
    ValidationError: a,
    schema: e.schema,
    schemaEnv: e,
    rootId: n,
    baseId: e.baseId || n,
    schemaPath: ul.nil,
    errSchemaPath: e.schemaPath || (this.opts.jtd ? "" : "#"),
    errorPath: (0, ul._)`""`,
    opts: this.opts,
    self: this
  };
  let d;
  try {
    this._compilations.add(e), (0, kbe.validateFunctionCode)(c), s.optimize(this.opts.code.optimize);
    const f = s.toString();
    d = `${s.scopeRefs(lp.default.scope)}return ${f}`, this.opts.code.process && (d = this.opts.code.process(d, e));
    const m = new Function(`${lp.default.self}`, `${lp.default.scope}`, d)(this, this.scope.get());
    if (this.scope.value(u, { ref: m }), m.errors = null, m.schema = e.schema, m.schemaEnv = e, e.$async && (m.$async = !0), this.opts.code.source === !0 && (m.source = { validateName: u, validateCode: f, scopeValues: s._values }), this.opts.unevaluated) {
      const { props: v, items: x } = c;
      m.evaluated = {
        props: v instanceof ul.Name ? void 0 : v,
        items: x instanceof ul.Name ? void 0 : x,
        dynamicProps: v instanceof ul.Name,
        dynamicItems: x instanceof ul.Name
      }, m.source && (m.source.evaluated = (0, ul.stringify)(m.evaluated));
    }
    return e.validate = m, e;
  } catch (f) {
    throw delete e.validate, delete e.validateName, d && this.logger.error("Error compiling schema, function code:", d), f;
  } finally {
    this._compilations.delete(e);
  }
}
Es.compileSchema = l2;
function Obe(e, t, n) {
  var r;
  n = (0, hl.resolveUrl)(this.opts.uriResolver, t, n);
  const i = e.refs[n];
  if (i)
    return i;
  let o = $be.call(this, e, n);
  if (o === void 0) {
    const s = (r = e.localRefs) === null || r === void 0 ? void 0 : r[n], { schemaId: a } = this.opts;
    s && (o = new nE({ schema: s, schemaId: a, root: e, baseId: t }));
  }
  if (o !== void 0)
    return e.refs[n] = Ibe.call(this, o);
}
Es.resolveRef = Obe;
function Ibe(e) {
  return (0, hl.inlineRef)(e.schema, this.opts.inlineRefs) ? e.schema : e.validate ? e : l2.call(this, e);
}
function P7(e) {
  for (const t of this._compilations)
    if (Fbe(t, e))
      return t;
}
Es.getCompilingSchema = P7;
function Fbe(e, t) {
  return e.schema === t.schema && e.root === t.root && e.baseId === t.baseId;
}
function $be(e, t) {
  let n;
  for (; typeof (n = this.refs[t]) == "string"; )
    t = n;
  return n || this.schemas[t] || rE.call(this, e, t);
}
function rE(e, t) {
  const n = this.opts.uriResolver.parse(t), r = (0, hl._getFullPath)(this.opts.uriResolver, n);
  let i = (0, hl.getFullPath)(this.opts.uriResolver, e.baseId, void 0);
  if (Object.keys(e.schema).length > 0 && r === i)
    return mA.call(this, n, e);
  const o = (0, hl.normalizeId)(r), s = this.refs[o] || this.schemas[o];
  if (typeof s == "string") {
    const a = rE.call(this, e, s);
    return typeof (a == null ? void 0 : a.schema) != "object" ? void 0 : mA.call(this, n, a);
  }
  if (typeof (s == null ? void 0 : s.schema) == "object") {
    if (s.validate || l2.call(this, s), o === (0, hl.normalizeId)(t)) {
      const { schema: a } = s, { schemaId: u } = this.opts, c = a[u];
      return c && (i = (0, hl.resolveUrl)(this.opts.uriResolver, i, c)), new nE({ schema: a, schemaId: u, root: e, baseId: i });
    }
    return mA.call(this, n, s);
  }
}
Es.resolveSchema = rE;
const Nbe = /* @__PURE__ */ new Set([
  "properties",
  "patternProperties",
  "enum",
  "dependencies",
  "definitions"
]);
function mA(e, { baseId: t, schema: n, root: r }) {
  var i;
  if (((i = e.fragment) === null || i === void 0 ? void 0 : i[0]) !== "/")
    return;
  for (const a of e.fragment.slice(1).split("/")) {
    if (typeof n == "boolean")
      return;
    const u = n[(0, q_.unescapeFragment)(a)];
    if (u === void 0)
      return;
    n = u;
    const c = typeof n == "object" && n[this.opts.schemaId];
    !Nbe.has(a) && c && (t = (0, hl.resolveUrl)(this.opts.uriResolver, t, c));
  }
  let o;
  if (typeof n != "boolean" && n.$ref && !(0, q_.schemaHasRulesButRef)(n, this.RULES)) {
    const a = (0, hl.resolveUrl)(this.opts.uriResolver, t, n.$ref);
    o = rE.call(this, r, a);
  }
  const { schemaId: s } = this.opts;
  if (o = o || new nE({ schema: n, schemaId: s, root: r, baseId: t }), o.schema !== o.root.schema)
    return o;
}
const Mbe = "https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#", Rbe = "Meta-schema for $data reference (JSON AnySchema extension proposal)", _be = "object", Lbe = [
  "$data"
], Bbe = {
  $data: {
    type: "string",
    anyOf: [
      {
        format: "relative-json-pointer"
      },
      {
        format: "json-pointer"
      }
    ]
  }
}, jbe = !1, Vbe = {
  $id: Mbe,
  description: Rbe,
  type: _be,
  required: Lbe,
  properties: Bbe,
  additionalProperties: jbe
};
var u2 = {}, iE = { exports: {} };
const zbe = {
  0: 0,
  1: 1,
  2: 2,
  3: 3,
  4: 4,
  5: 5,
  6: 6,
  7: 7,
  8: 8,
  9: 9,
  a: 10,
  A: 10,
  b: 11,
  B: 11,
  c: 12,
  C: 12,
  d: 13,
  D: 13,
  e: 14,
  E: 14,
  f: 15,
  F: 15
};
var Ube = {
  HEX: zbe
};
const { HEX: Wbe } = Ube;
function k7(e) {
  if (I7(e, ".") < 3)
    return { host: e, isIPV4: !1 };
  const t = e.match(/^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/u) || [], [n] = t;
  return n ? { host: qbe(n, "."), isIPV4: !0 } : { host: e, isIPV4: !1 };
}
function wP(e, t = !1) {
  let n = "", r = !0;
  for (const i of e) {
    if (Wbe[i] === void 0) return;
    i !== "0" && r === !0 && (r = !1), r || (n += i);
  }
  return t && n.length === 0 && (n = "0"), n;
}
function Hbe(e) {
  let t = 0;
  const n = { error: !1, address: "", zone: "" }, r = [], i = [];
  let o = !1, s = !1, a = !1;
  function u() {
    if (i.length) {
      if (o === !1) {
        const c = wP(i);
        if (c !== void 0)
          r.push(c);
        else
          return n.error = !0, !1;
      }
      i.length = 0;
    }
    return !0;
  }
  for (let c = 0; c < e.length; c++) {
    const d = e[c];
    if (!(d === "[" || d === "]"))
      if (d === ":") {
        if (s === !0 && (a = !0), !u())
          break;
        if (t++, r.push(":"), t > 7) {
          n.error = !0;
          break;
        }
        c - 1 >= 0 && e[c - 1] === ":" && (s = !0);
        continue;
      } else if (d === "%") {
        if (!u())
          break;
        o = !0;
      } else {
        i.push(d);
        continue;
      }
  }
  return i.length && (o ? n.zone = i.join("") : a ? r.push(i.join("")) : r.push(wP(i))), n.address = r.join(""), n;
}
function O7(e, t = {}) {
  if (I7(e, ":") < 2)
    return { host: e, isIPV6: !1 };
  const n = Hbe(e);
  if (n.error)
    return { host: e, isIPV6: !1 };
  {
    let r = n.address, i = n.address;
    return n.zone && (r += "%" + n.zone, i += "%25" + n.zone), { host: r, escapedHost: i, isIPV6: !0 };
  }
}
function qbe(e, t) {
  let n = "", r = !0;
  const i = e.length;
  for (let o = 0; o < i; o++) {
    const s = e[o];
    s === "0" && r ? (o + 1 <= i && e[o + 1] === t || o + 1 === i) && (n += s, r = !1) : (s === t ? r = !0 : r = !1, n += s);
  }
  return n;
}
function I7(e, t) {
  let n = 0;
  for (let r = 0; r < e.length; r++)
    e[r] === t && n++;
  return n;
}
const G_ = /^\.\.?\//u, Y_ = /^\/\.(?:\/|$)/u, K_ = /^\/\.\.(?:\/|$)/u, Gbe = /^\/?(?:.|\n)*?(?=\/|$)/u;
function Ybe(e) {
  const t = [];
  for (; e.length; )
    if (e.match(G_))
      e = e.replace(G_, "");
    else if (e.match(Y_))
      e = e.replace(Y_, "/");
    else if (e.match(K_))
      e = e.replace(K_, "/"), t.pop();
    else if (e === "." || e === "..")
      e = "";
    else {
      const n = e.match(Gbe);
      if (n) {
        const r = n[0];
        e = e.slice(r.length), t.push(r);
      } else
        throw new Error("Unexpected dot segment condition");
    }
  return t.join("");
}
function Kbe(e, t) {
  const n = t !== !0 ? escape : unescape;
  return e.scheme !== void 0 && (e.scheme = n(e.scheme)), e.userinfo !== void 0 && (e.userinfo = n(e.userinfo)), e.host !== void 0 && (e.host = n(e.host)), e.path !== void 0 && (e.path = n(e.path)), e.query !== void 0 && (e.query = n(e.query)), e.fragment !== void 0 && (e.fragment = n(e.fragment)), e;
}
function Jbe(e, t) {
  const n = [];
  if (e.userinfo !== void 0 && (n.push(e.userinfo), n.push("@")), e.host !== void 0) {
    let r = unescape(e.host);
    const i = k7(r);
    if (i.isIPV4)
      r = i.host;
    else {
      const o = O7(i.host, { isIPV4: !1 });
      o.isIPV6 === !0 ? r = `[${o.escapedHost}]` : r = e.host;
    }
    n.push(r);
  }
  return (typeof e.port == "number" || typeof e.port == "string") && (n.push(":"), n.push(String(e.port))), n.length ? n.join("") : void 0;
}
var Xbe = {
  recomposeAuthority: Jbe,
  normalizeComponentEncoding: Kbe,
  removeDotSegments: Ybe,
  normalizeIPv4: k7,
  normalizeIPv6: O7,
  stringArrayToHexStripped: wP
};
const Qbe = /^[\da-f]{8}\b-[\da-f]{4}\b-[\da-f]{4}\b-[\da-f]{4}\b-[\da-f]{12}$/iu, Zbe = /([\da-z][\d\-a-z]{0,31}):((?:[\w!$'()*+,\-.:;=@]|%[\da-f]{2})+)/iu;
function F7(e) {
  return typeof e.secure == "boolean" ? e.secure : String(e.scheme).toLowerCase() === "wss";
}
function $7(e) {
  return e.host || (e.error = e.error || "HTTP URIs must have a host."), e;
}
function N7(e) {
  const t = String(e.scheme).toLowerCase() === "https";
  return (e.port === (t ? 443 : 80) || e.port === "") && (e.port = void 0), e.path || (e.path = "/"), e;
}
function eve(e) {
  return e.secure = F7(e), e.resourceName = (e.path || "/") + (e.query ? "?" + e.query : ""), e.path = void 0, e.query = void 0, e;
}
function tve(e) {
  if ((e.port === (F7(e) ? 443 : 80) || e.port === "") && (e.port = void 0), typeof e.secure == "boolean" && (e.scheme = e.secure ? "wss" : "ws", e.secure = void 0), e.resourceName) {
    const [t, n] = e.resourceName.split("?");
    e.path = t && t !== "/" ? t : void 0, e.query = n, e.resourceName = void 0;
  }
  return e.fragment = void 0, e;
}
function nve(e, t) {
  if (!e.path)
    return e.error = "URN can not be parsed", e;
  const n = e.path.match(Zbe);
  if (n) {
    const r = t.scheme || e.scheme || "urn";
    e.nid = n[1].toLowerCase(), e.nss = n[2];
    const i = `${r}:${t.nid || e.nid}`, o = c2[i];
    e.path = void 0, o && (e = o.parse(e, t));
  } else
    e.error = e.error || "URN can not be parsed.";
  return e;
}
function rve(e, t) {
  const n = t.scheme || e.scheme || "urn", r = e.nid.toLowerCase(), i = `${n}:${t.nid || r}`, o = c2[i];
  o && (e = o.serialize(e, t));
  const s = e, a = e.nss;
  return s.path = `${r || t.nid}:${a}`, t.skipEscape = !0, s;
}
function ive(e, t) {
  const n = e;
  return n.uuid = n.nss, n.nss = void 0, !t.tolerant && (!n.uuid || !Qbe.test(n.uuid)) && (n.error = n.error || "UUID is not valid."), n;
}
function ove(e) {
  const t = e;
  return t.nss = (e.uuid || "").toLowerCase(), t;
}
const M7 = {
  scheme: "http",
  domainHost: !0,
  parse: $7,
  serialize: N7
}, sve = {
  scheme: "https",
  domainHost: M7.domainHost,
  parse: $7,
  serialize: N7
}, Lx = {
  scheme: "ws",
  domainHost: !0,
  parse: eve,
  serialize: tve
}, ave = {
  scheme: "wss",
  domainHost: Lx.domainHost,
  parse: Lx.parse,
  serialize: Lx.serialize
}, lve = {
  scheme: "urn",
  parse: nve,
  serialize: rve,
  skipNormalize: !0
}, uve = {
  scheme: "urn:uuid",
  parse: ive,
  serialize: ove,
  skipNormalize: !0
}, c2 = {
  http: M7,
  https: sve,
  ws: Lx,
  wss: ave,
  urn: lve,
  "urn:uuid": uve
};
var cve = c2;
const { normalizeIPv6: dve, normalizeIPv4: pve, removeDotSegments: zy, recomposeAuthority: fve, normalizeComponentEncoding: P1 } = Xbe, d2 = cve;
function hve(e, t) {
  return typeof e == "string" ? e = tu(oc(e, t), t) : typeof e == "object" && (e = oc(tu(e, t), t)), e;
}
function mve(e, t, n) {
  const r = Object.assign({ scheme: "null" }, n), i = R7(oc(e, r), oc(t, r), r, !0);
  return tu(i, { ...r, skipEscape: !0 });
}
function R7(e, t, n, r) {
  const i = {};
  return r || (e = oc(tu(e, n), n), t = oc(tu(t, n), n)), n = n || {}, !n.tolerant && t.scheme ? (i.scheme = t.scheme, i.userinfo = t.userinfo, i.host = t.host, i.port = t.port, i.path = zy(t.path || ""), i.query = t.query) : (t.userinfo !== void 0 || t.host !== void 0 || t.port !== void 0 ? (i.userinfo = t.userinfo, i.host = t.host, i.port = t.port, i.path = zy(t.path || ""), i.query = t.query) : (t.path ? (t.path.charAt(0) === "/" ? i.path = zy(t.path) : ((e.userinfo !== void 0 || e.host !== void 0 || e.port !== void 0) && !e.path ? i.path = "/" + t.path : e.path ? i.path = e.path.slice(0, e.path.lastIndexOf("/") + 1) + t.path : i.path = t.path, i.path = zy(i.path)), i.query = t.query) : (i.path = e.path, t.query !== void 0 ? i.query = t.query : i.query = e.query), i.userinfo = e.userinfo, i.host = e.host, i.port = e.port), i.scheme = e.scheme), i.fragment = t.fragment, i;
}
function gve(e, t, n) {
  return typeof e == "string" ? (e = unescape(e), e = tu(P1(oc(e, n), !0), { ...n, skipEscape: !0 })) : typeof e == "object" && (e = tu(P1(e, !0), { ...n, skipEscape: !0 })), typeof t == "string" ? (t = unescape(t), t = tu(P1(oc(t, n), !0), { ...n, skipEscape: !0 })) : typeof t == "object" && (t = tu(P1(t, !0), { ...n, skipEscape: !0 })), e.toLowerCase() === t.toLowerCase();
}
function tu(e, t) {
  const n = {
    host: e.host,
    scheme: e.scheme,
    userinfo: e.userinfo,
    port: e.port,
    path: e.path,
    query: e.query,
    nid: e.nid,
    nss: e.nss,
    uuid: e.uuid,
    fragment: e.fragment,
    reference: e.reference,
    resourceName: e.resourceName,
    secure: e.secure,
    error: ""
  }, r = Object.assign({}, t), i = [], o = d2[(r.scheme || n.scheme || "").toLowerCase()];
  o && o.serialize && o.serialize(n, r), n.path !== void 0 && (r.skipEscape ? n.path = unescape(n.path) : (n.path = escape(n.path), n.scheme !== void 0 && (n.path = n.path.split("%3A").join(":")))), r.reference !== "suffix" && n.scheme && (i.push(n.scheme), i.push(":"));
  const s = fve(n, r);
  if (s !== void 0 && (r.reference !== "suffix" && i.push("//"), i.push(s), n.path && n.path.charAt(0) !== "/" && i.push("/")), n.path !== void 0) {
    let a = n.path;
    !r.absolutePath && (!o || !o.absolutePath) && (a = zy(a)), s === void 0 && (a = a.replace(/^\/\//u, "/%2F")), i.push(a);
  }
  return n.query !== void 0 && (i.push("?"), i.push(n.query)), n.fragment !== void 0 && (i.push("#"), i.push(n.fragment)), i.join("");
}
const yve = Array.from({ length: 127 }, (e, t) => /[^!"$&'()*+,\-.;=_`a-z{}~]/u.test(String.fromCharCode(t)));
function bve(e) {
  let t = 0;
  for (let n = 0, r = e.length; n < r; ++n)
    if (t = e.charCodeAt(n), t > 126 || yve[t])
      return !0;
  return !1;
}
const vve = /^(?:([^#/:?]+):)?(?:\/\/((?:([^#/?@]*)@)?(\[[^#/?\]]+\]|[^#/:?]*)(?::(\d*))?))?([^#?]*)(?:\?([^#]*))?(?:#((?:.|[\n\r])*))?/u;
function oc(e, t) {
  const n = Object.assign({}, t), r = {
    scheme: void 0,
    userinfo: void 0,
    host: "",
    port: void 0,
    path: "",
    query: void 0,
    fragment: void 0
  }, i = e.indexOf("%") !== -1;
  let o = !1;
  n.reference === "suffix" && (e = (n.scheme ? n.scheme + ":" : "") + "//" + e);
  const s = e.match(vve);
  if (s) {
    if (r.scheme = s[1], r.userinfo = s[3], r.host = s[4], r.port = parseInt(s[5], 10), r.path = s[6] || "", r.query = s[7], r.fragment = s[8], isNaN(r.port) && (r.port = s[5]), r.host) {
      const u = pve(r.host);
      if (u.isIPV4 === !1) {
        const c = dve(u.host, { isIPV4: !1 });
        r.host = c.host.toLowerCase(), o = c.isIPV6;
      } else
        r.host = u.host, o = !0;
    }
    r.scheme === void 0 && r.userinfo === void 0 && r.host === void 0 && r.port === void 0 && !r.path && r.query === void 0 ? r.reference = "same-document" : r.scheme === void 0 ? r.reference = "relative" : r.fragment === void 0 ? r.reference = "absolute" : r.reference = "uri", n.reference && n.reference !== "suffix" && n.reference !== r.reference && (r.error = r.error || "URI is not a " + n.reference + " reference.");
    const a = d2[(n.scheme || r.scheme || "").toLowerCase()];
    if (!n.unicodeSupport && (!a || !a.unicodeSupport) && r.host && (n.domainHost || a && a.domainHost) && o === !1 && bve(r.host))
      try {
        r.host = URL.domainToASCII(r.host.toLowerCase());
      } catch (u) {
        r.error = r.error || "Host's domain name can not be converted to ASCII: " + u;
      }
    (!a || a && !a.skipNormalize) && (i && r.scheme !== void 0 && (r.scheme = unescape(r.scheme)), i && r.userinfo !== void 0 && (r.userinfo = unescape(r.userinfo)), i && r.host !== void 0 && (r.host = unescape(r.host)), r.path !== void 0 && r.path.length && (r.path = escape(unescape(r.path))), r.fragment !== void 0 && r.fragment.length && (r.fragment = encodeURI(decodeURIComponent(r.fragment)))), a && a.parse && a.parse(r, n);
  } else
    r.error = r.error || "URI can not be parsed.";
  return r;
}
const p2 = {
  SCHEMES: d2,
  normalize: hve,
  resolve: mve,
  resolveComponents: R7,
  equal: gve,
  serialize: tu,
  parse: oc
};
iE.exports = p2;
iE.exports.default = p2;
iE.exports.fastUri = p2;
var xve = iE.exports;
Object.defineProperty(u2, "__esModule", { value: !0 });
const _7 = xve;
_7.code = 'require("ajv/dist/runtime/uri").default';
u2.default = _7;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.CodeGen = e.Name = e.nil = e.stringify = e.str = e._ = e.KeywordCxt = void 0;
  var t = Na;
  Object.defineProperty(e, "KeywordCxt", { enumerable: !0, get: function() {
    return t.KeywordCxt;
  } });
  var n = $n;
  Object.defineProperty(e, "_", { enumerable: !0, get: function() {
    return n._;
  } }), Object.defineProperty(e, "str", { enumerable: !0, get: function() {
    return n.str;
  } }), Object.defineProperty(e, "stringify", { enumerable: !0, get: function() {
    return n.stringify;
  } }), Object.defineProperty(e, "nil", { enumerable: !0, get: function() {
    return n.nil;
  } }), Object.defineProperty(e, "Name", { enumerable: !0, get: function() {
    return n.Name;
  } }), Object.defineProperty(e, "CodeGen", { enumerable: !0, get: function() {
    return n.CodeGen;
  } });
  const r = a2(), i = Gm, o = zp, s = Es, a = $n, u = ho, c = zi, d = jt, f = Vbe, h = u2, m = (M, Z) => new RegExp(M, Z);
  m.code = "new RegExp";
  const v = ["removeAdditional", "useDefaults", "coerceTypes"], x = /* @__PURE__ */ new Set([
    "validate",
    "serialize",
    "parse",
    "wrapper",
    "root",
    "schema",
    "keyword",
    "pattern",
    "formats",
    "validate$data",
    "func",
    "obj",
    "Error"
  ]), C = {
    errorDataPath: "",
    format: "`validateFormats: false` can be used instead.",
    nullable: '"nullable" keyword is supported by default.',
    jsonPointers: "Deprecated jsPropertySyntax can be used instead.",
    extendRefs: "Deprecated ignoreKeywordsWithRef can be used instead.",
    missingRefs: "Pass empty schema with $id that should be ignored to ajv.addSchema.",
    processCode: "Use option `code: {process: (code, schemaEnv: object) => string}`",
    sourceCode: "Use option `code: {source: true}`",
    strictDefaults: "It is default now, see option `strict`.",
    strictKeywords: "It is default now, see option `strict`.",
    uniqueItems: '"uniqueItems" keyword is always validated.',
    unknownFormats: "Disable strict mode or pass `true` to `ajv.addFormat` (or `formats` option).",
    cache: "Map is used as cache, schema object as key.",
    serialize: "Map is used as cache, schema object as key.",
    ajvErrors: "It is default now."
  }, E = {
    ignoreKeywordsWithRef: "",
    jsPropertySyntax: "",
    unicode: '"minLength"/"maxLength" account for unicode characters by default.'
  }, S = 200;
  function w(M) {
    var Z, ne, R, _, W, Q, oe, ae, pe, me, xe, le, ye, be, Re, Te, Xe, Ne, Qe, Ee, Ie, Je, vt, St, Lt;
    const ke = M.strict, Le = (Z = M.code) === null || Z === void 0 ? void 0 : Z.optimize, Pe = Le === !0 || Le === void 0 ? 1 : Le || 0, Ae = (R = (ne = M.code) === null || ne === void 0 ? void 0 : ne.regExp) !== null && R !== void 0 ? R : m, We = (_ = M.uriResolver) !== null && _ !== void 0 ? _ : h.default;
    return {
      strictSchema: (Q = (W = M.strictSchema) !== null && W !== void 0 ? W : ke) !== null && Q !== void 0 ? Q : !0,
      strictNumbers: (ae = (oe = M.strictNumbers) !== null && oe !== void 0 ? oe : ke) !== null && ae !== void 0 ? ae : !0,
      strictTypes: (me = (pe = M.strictTypes) !== null && pe !== void 0 ? pe : ke) !== null && me !== void 0 ? me : "log",
      strictTuples: (le = (xe = M.strictTuples) !== null && xe !== void 0 ? xe : ke) !== null && le !== void 0 ? le : "log",
      strictRequired: (be = (ye = M.strictRequired) !== null && ye !== void 0 ? ye : ke) !== null && be !== void 0 ? be : !1,
      code: M.code ? { ...M.code, optimize: Pe, regExp: Ae } : { optimize: Pe, regExp: Ae },
      loopRequired: (Re = M.loopRequired) !== null && Re !== void 0 ? Re : S,
      loopEnum: (Te = M.loopEnum) !== null && Te !== void 0 ? Te : S,
      meta: (Xe = M.meta) !== null && Xe !== void 0 ? Xe : !0,
      messages: (Ne = M.messages) !== null && Ne !== void 0 ? Ne : !0,
      inlineRefs: (Qe = M.inlineRefs) !== null && Qe !== void 0 ? Qe : !0,
      schemaId: (Ee = M.schemaId) !== null && Ee !== void 0 ? Ee : "$id",
      addUsedSchema: (Ie = M.addUsedSchema) !== null && Ie !== void 0 ? Ie : !0,
      validateSchema: (Je = M.validateSchema) !== null && Je !== void 0 ? Je : !0,
      validateFormats: (vt = M.validateFormats) !== null && vt !== void 0 ? vt : !0,
      unicodeRegExp: (St = M.unicodeRegExp) !== null && St !== void 0 ? St : !0,
      int32range: (Lt = M.int32range) !== null && Lt !== void 0 ? Lt : !0,
      uriResolver: We
    };
  }
  class O {
    constructor(Z = {}) {
      this.schemas = {}, this.refs = {}, this.formats = {}, this._compilations = /* @__PURE__ */ new Set(), this._loading = {}, this._cache = /* @__PURE__ */ new Map(), Z = this.opts = { ...Z, ...w(Z) };
      const { es5: ne, lines: R } = this.opts.code;
      this.scope = new a.ValueScope({ scope: {}, prefixes: x, es5: ne, lines: R }), this.logger = J(Z.logger);
      const _ = Z.validateFormats;
      Z.validateFormats = !1, this.RULES = (0, o.getRules)(), A.call(this, C, Z, "NOT SUPPORTED"), A.call(this, E, Z, "DEPRECATED", "warn"), this._metaOpts = H.call(this), Z.formats && L.call(this), this._addVocabularies(), this._addDefaultMetaSchema(), Z.keywords && B.call(this, Z.keywords), typeof Z.meta == "object" && this.addMetaSchema(Z.meta), $.call(this), Z.validateFormats = _;
    }
    _addVocabularies() {
      this.addKeyword("$async");
    }
    _addDefaultMetaSchema() {
      const { $data: Z, meta: ne, schemaId: R } = this.opts;
      let _ = f;
      R === "id" && (_ = { ...f }, _.id = _.$id, delete _.$id), ne && Z && this.addMetaSchema(_, _[R], !1);
    }
    defaultMeta() {
      const { meta: Z, schemaId: ne } = this.opts;
      return this.opts.defaultMeta = typeof Z == "object" ? Z[ne] || Z : void 0;
    }
    validate(Z, ne) {
      let R;
      if (typeof Z == "string") {
        if (R = this.getSchema(Z), !R)
          throw new Error(`no schema with key or ref "${Z}"`);
      } else
        R = this.compile(Z);
      const _ = R(ne);
      return "$async" in R || (this.errors = R.errors), _;
    }
    compile(Z, ne) {
      const R = this._addSchema(Z, ne);
      return R.validate || this._compileSchemaEnv(R);
    }
    compileAsync(Z, ne) {
      if (typeof this.opts.loadSchema != "function")
        throw new Error("options.loadSchema should be a function");
      const { loadSchema: R } = this.opts;
      return _.call(this, Z, ne);
      async function _(me, xe) {
        await W.call(this, me.$schema);
        const le = this._addSchema(me, xe);
        return le.validate || Q.call(this, le);
      }
      async function W(me) {
        me && !this.getSchema(me) && await _.call(this, { $ref: me }, !0);
      }
      async function Q(me) {
        try {
          return this._compileSchemaEnv(me);
        } catch (xe) {
          if (!(xe instanceof i.default))
            throw xe;
          return oe.call(this, xe), await ae.call(this, xe.missingSchema), Q.call(this, me);
        }
      }
      function oe({ missingSchema: me, missingRef: xe }) {
        if (this.refs[me])
          throw new Error(`AnySchema ${me} is loaded but ${xe} cannot be resolved`);
      }
      async function ae(me) {
        const xe = await pe.call(this, me);
        this.refs[me] || await W.call(this, xe.$schema), this.refs[me] || this.addSchema(xe, me, ne);
      }
      async function pe(me) {
        const xe = this._loading[me];
        if (xe)
          return xe;
        try {
          return await (this._loading[me] = R(me));
        } finally {
          delete this._loading[me];
        }
      }
    }
    // Adds schema to the instance
    addSchema(Z, ne, R, _ = this.opts.validateSchema) {
      if (Array.isArray(Z)) {
        for (const Q of Z)
          this.addSchema(Q, void 0, R, _);
        return this;
      }
      let W;
      if (typeof Z == "object") {
        const { schemaId: Q } = this.opts;
        if (W = Z[Q], W !== void 0 && typeof W != "string")
          throw new Error(`schema ${Q} must be string`);
      }
      return ne = (0, u.normalizeId)(ne || W), this._checkUnique(ne), this.schemas[ne] = this._addSchema(Z, R, ne, _, !0), this;
    }
    // Add schema that will be used to validate other schemas
    // options in META_IGNORE_OPTIONS are alway set to false
    addMetaSchema(Z, ne, R = this.opts.validateSchema) {
      return this.addSchema(Z, ne, !0, R), this;
    }
    //  Validate schema against its meta-schema
    validateSchema(Z, ne) {
      if (typeof Z == "boolean")
        return !0;
      let R;
      if (R = Z.$schema, R !== void 0 && typeof R != "string")
        throw new Error("$schema must be a string");
      if (R = R || this.opts.defaultMeta || this.defaultMeta(), !R)
        return this.logger.warn("meta-schema not available"), this.errors = null, !0;
      const _ = this.validate(R, Z);
      if (!_ && ne) {
        const W = "schema is invalid: " + this.errorsText();
        if (this.opts.validateSchema === "log")
          this.logger.error(W);
        else
          throw new Error(W);
      }
      return _;
    }
    // Get compiled schema by `key` or `ref`.
    // (`key` that was passed to `addSchema` or full schema reference - `schema.$id` or resolved id)
    getSchema(Z) {
      let ne;
      for (; typeof (ne = I.call(this, Z)) == "string"; )
        Z = ne;
      if (ne === void 0) {
        const { schemaId: R } = this.opts, _ = new s.SchemaEnv({ schema: {}, schemaId: R });
        if (ne = s.resolveSchema.call(this, _, Z), !ne)
          return;
        this.refs[Z] = ne;
      }
      return ne.validate || this._compileSchemaEnv(ne);
    }
    // Remove cached schema(s).
    // If no parameter is passed all schemas but meta-schemas are removed.
    // If RegExp is passed all schemas with key/id matching pattern but meta-schemas are removed.
    // Even if schema is referenced by other schemas it still can be removed as other schemas have local references.
    removeSchema(Z) {
      if (Z instanceof RegExp)
        return this._removeAllSchemas(this.schemas, Z), this._removeAllSchemas(this.refs, Z), this;
      switch (typeof Z) {
        case "undefined":
          return this._removeAllSchemas(this.schemas), this._removeAllSchemas(this.refs), this._cache.clear(), this;
        case "string": {
          const ne = I.call(this, Z);
          return typeof ne == "object" && this._cache.delete(ne.schema), delete this.schemas[Z], delete this.refs[Z], this;
        }
        case "object": {
          const ne = Z;
          this._cache.delete(ne);
          let R = Z[this.opts.schemaId];
          return R && (R = (0, u.normalizeId)(R), delete this.schemas[R], delete this.refs[R]), this;
        }
        default:
          throw new Error("ajv.removeSchema: invalid parameter");
      }
    }
    // add "vocabulary" - a collection of keywords
    addVocabulary(Z) {
      for (const ne of Z)
        this.addKeyword(ne);
      return this;
    }
    addKeyword(Z, ne) {
      let R;
      if (typeof Z == "string")
        R = Z, typeof ne == "object" && (this.logger.warn("these parameters are deprecated, see docs for addKeyword"), ne.keyword = R);
      else if (typeof Z == "object" && ne === void 0) {
        if (ne = Z, R = ne.keyword, Array.isArray(R) && !R.length)
          throw new Error("addKeywords: keyword must be string or non-empty array");
      } else
        throw new Error("invalid addKeywords parameters");
      if (j.call(this, R, ne), !ne)
        return (0, d.eachItem)(R, (W) => U.call(this, W)), this;
      K.call(this, ne);
      const _ = {
        ...ne,
        type: (0, c.getJSONTypes)(ne.type),
        schemaType: (0, c.getJSONTypes)(ne.schemaType)
      };
      return (0, d.eachItem)(R, _.type.length === 0 ? (W) => U.call(this, W, _) : (W) => _.type.forEach((Q) => U.call(this, W, _, Q))), this;
    }
    getKeyword(Z) {
      const ne = this.RULES.all[Z];
      return typeof ne == "object" ? ne.definition : !!ne;
    }
    // Remove keyword
    removeKeyword(Z) {
      const { RULES: ne } = this;
      delete ne.keywords[Z], delete ne.all[Z];
      for (const R of ne.rules) {
        const _ = R.rules.findIndex((W) => W.keyword === Z);
        _ >= 0 && R.rules.splice(_, 1);
      }
      return this;
    }
    // Add format
    addFormat(Z, ne) {
      return typeof ne == "string" && (ne = new RegExp(ne)), this.formats[Z] = ne, this;
    }
    errorsText(Z = this.errors, { separator: ne = ", ", dataVar: R = "data" } = {}) {
      return !Z || Z.length === 0 ? "No errors" : Z.map((_) => `${R}${_.instancePath} ${_.message}`).reduce((_, W) => _ + ne + W);
    }
    $dataMetaSchema(Z, ne) {
      const R = this.RULES.all;
      Z = JSON.parse(JSON.stringify(Z));
      for (const _ of ne) {
        const W = _.split("/").slice(1);
        let Q = Z;
        for (const oe of W)
          Q = Q[oe];
        for (const oe in R) {
          const ae = R[oe];
          if (typeof ae != "object")
            continue;
          const { $data: pe } = ae.definition, me = Q[oe];
          pe && me && (Q[oe] = te(me));
        }
      }
      return Z;
    }
    _removeAllSchemas(Z, ne) {
      for (const R in Z) {
        const _ = Z[R];
        (!ne || ne.test(R)) && (typeof _ == "string" ? delete Z[R] : _ && !_.meta && (this._cache.delete(_.schema), delete Z[R]));
      }
    }
    _addSchema(Z, ne, R, _ = this.opts.validateSchema, W = this.opts.addUsedSchema) {
      let Q;
      const { schemaId: oe } = this.opts;
      if (typeof Z == "object")
        Q = Z[oe];
      else {
        if (this.opts.jtd)
          throw new Error("schema must be object");
        if (typeof Z != "boolean")
          throw new Error("schema must be object or boolean");
      }
      let ae = this._cache.get(Z);
      if (ae !== void 0)
        return ae;
      R = (0, u.normalizeId)(Q || R);
      const pe = u.getSchemaRefs.call(this, Z, R);
      return ae = new s.SchemaEnv({ schema: Z, schemaId: oe, meta: ne, baseId: R, localRefs: pe }), this._cache.set(ae.schema, ae), W && !R.startsWith("#") && (R && this._checkUnique(R), this.refs[R] = ae), _ && this.validateSchema(Z, !0), ae;
    }
    _checkUnique(Z) {
      if (this.schemas[Z] || this.refs[Z])
        throw new Error(`schema with key or id "${Z}" already exists`);
    }
    _compileSchemaEnv(Z) {
      if (Z.meta ? this._compileMetaSchema(Z) : s.compileSchema.call(this, Z), !Z.validate)
        throw new Error("ajv implementation error");
      return Z.validate;
    }
    _compileMetaSchema(Z) {
      const ne = this.opts;
      this.opts = this._metaOpts;
      try {
        s.compileSchema.call(this, Z);
      } finally {
        this.opts = ne;
      }
    }
  }
  O.ValidationError = r.default, O.MissingRefError = i.default, e.default = O;
  function A(M, Z, ne, R = "error") {
    for (const _ in M) {
      const W = _;
      W in Z && this.logger[R](`${ne}: option ${_}. ${M[W]}`);
    }
  }
  function I(M) {
    return M = (0, u.normalizeId)(M), this.schemas[M] || this.refs[M];
  }
  function $() {
    const M = this.opts.schemas;
    if (M)
      if (Array.isArray(M))
        this.addSchema(M);
      else
        for (const Z in M)
          this.addSchema(M[Z], Z);
  }
  function L() {
    for (const M in this.opts.formats) {
      const Z = this.opts.formats[M];
      Z && this.addFormat(M, Z);
    }
  }
  function B(M) {
    if (Array.isArray(M)) {
      this.addVocabulary(M);
      return;
    }
    this.logger.warn("keywords option as map is deprecated, pass array");
    for (const Z in M) {
      const ne = M[Z];
      ne.keyword || (ne.keyword = Z), this.addKeyword(ne);
    }
  }
  function H() {
    const M = { ...this.opts };
    for (const Z of v)
      delete M[Z];
    return M;
  }
  const q = { log() {
  }, warn() {
  }, error() {
  } };
  function J(M) {
    if (M === !1)
      return q;
    if (M === void 0)
      return console;
    if (M.log && M.warn && M.error)
      return M;
    throw new Error("logger must implement log, warn and error methods");
  }
  const X = /^[a-z_$][a-z0-9_$:-]*$/i;
  function j(M, Z) {
    const { RULES: ne } = this;
    if ((0, d.eachItem)(M, (R) => {
      if (ne.keywords[R])
        throw new Error(`Keyword ${R} is already defined`);
      if (!X.test(R))
        throw new Error(`Keyword ${R} has invalid name`);
    }), !!Z && Z.$data && !("code" in Z || "validate" in Z))
      throw new Error('$data keyword must have "code" or "validate" function');
  }
  function U(M, Z, ne) {
    var R;
    const _ = Z == null ? void 0 : Z.post;
    if (ne && _)
      throw new Error('keyword with "post" flag cannot have "type"');
    const { RULES: W } = this;
    let Q = _ ? W.post : W.rules.find(({ type: ae }) => ae === ne);
    if (Q || (Q = { type: ne, rules: [] }, W.rules.push(Q)), W.keywords[M] = !0, !Z)
      return;
    const oe = {
      keyword: M,
      definition: {
        ...Z,
        type: (0, c.getJSONTypes)(Z.type),
        schemaType: (0, c.getJSONTypes)(Z.schemaType)
      }
    };
    Z.before ? G.call(this, Q, oe, Z.before) : Q.rules.push(oe), W.all[M] = oe, (R = Z.implements) === null || R === void 0 || R.forEach((ae) => this.addKeyword(ae));
  }
  function G(M, Z, ne) {
    const R = M.rules.findIndex((_) => _.keyword === ne);
    R >= 0 ? M.rules.splice(R, 0, Z) : (M.rules.push(Z), this.logger.warn(`rule ${ne} is not defined`));
  }
  function K(M) {
    let { metaSchema: Z } = M;
    Z !== void 0 && (M.$data && this.opts.$data && (Z = te(Z)), M.validateSchema = this.compile(Z, !0));
  }
  const ee = {
    $ref: "https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#"
  };
  function te(M) {
    return { anyOf: [M, ee] };
  }
})(J9);
var f2 = {}, h2 = {}, m2 = {};
Object.defineProperty(m2, "__esModule", { value: !0 });
const Dve = {
  keyword: "id",
  code() {
    throw new Error('NOT SUPPORTED: keyword "id", use "$id" for schema ID');
  }
};
m2.default = Dve;
var Up = {};
Object.defineProperty(Up, "__esModule", { value: !0 });
Up.callRef = Up.getValidate = void 0;
const Cve = Gm, J_ = Bn, ys = $n, dh = Sl, X_ = Es, k1 = jt, Eve = {
  keyword: "$ref",
  schemaType: "string",
  code(e) {
    const { gen: t, schema: n, it: r } = e, { baseId: i, schemaEnv: o, validateName: s, opts: a, self: u } = r, { root: c } = o;
    if ((n === "#" || n === "#/") && i === c.baseId)
      return f();
    const d = X_.resolveRef.call(u, c, i, n);
    if (d === void 0)
      throw new Cve.default(r.opts.uriResolver, i, n);
    if (d instanceof X_.SchemaEnv)
      return h(d);
    return m(d);
    function f() {
      if (o === c)
        return Bx(e, s, o, o.$async);
      const v = t.scopeValue("root", { ref: c });
      return Bx(e, (0, ys._)`${v}.validate`, c, c.$async);
    }
    function h(v) {
      const x = L7(e, v);
      Bx(e, x, v, v.$async);
    }
    function m(v) {
      const x = t.scopeValue("schema", a.code.source === !0 ? { ref: v, code: (0, ys.stringify)(v) } : { ref: v }), C = t.name("valid"), E = e.subschema({
        schema: v,
        dataTypes: [],
        schemaPath: ys.nil,
        topSchemaRef: x,
        errSchemaPath: n
      }, C);
      e.mergeEvaluated(E), e.ok(C);
    }
  }
};
function L7(e, t) {
  const { gen: n } = e;
  return t.validate ? n.scopeValue("validate", { ref: t.validate }) : (0, ys._)`${n.scopeValue("wrapper", { ref: t })}.validate`;
}
Up.getValidate = L7;
function Bx(e, t, n, r) {
  const { gen: i, it: o } = e, { allErrors: s, schemaEnv: a, opts: u } = o, c = u.passContext ? dh.default.this : ys.nil;
  r ? d() : f();
  function d() {
    if (!a.$async)
      throw new Error("async schema referenced by sync schema");
    const v = i.let("valid");
    i.try(() => {
      i.code((0, ys._)`await ${(0, J_.callValidateCode)(e, t, c)}`), m(t), s || i.assign(v, !0);
    }, (x) => {
      i.if((0, ys._)`!(${x} instanceof ${o.ValidationError})`, () => i.throw(x)), h(x), s || i.assign(v, !1);
    }), e.ok(v);
  }
  function f() {
    e.result((0, J_.callValidateCode)(e, t, c), () => m(t), () => h(t));
  }
  function h(v) {
    const x = (0, ys._)`${v}.errors`;
    i.assign(dh.default.vErrors, (0, ys._)`${dh.default.vErrors} === null ? ${x} : ${dh.default.vErrors}.concat(${x})`), i.assign(dh.default.errors, (0, ys._)`${dh.default.vErrors}.length`);
  }
  function m(v) {
    var x;
    if (!o.opts.unevaluated)
      return;
    const C = (x = n == null ? void 0 : n.validate) === null || x === void 0 ? void 0 : x.evaluated;
    if (o.props !== !0)
      if (C && !C.dynamicProps)
        C.props !== void 0 && (o.props = k1.mergeEvaluated.props(i, C.props, o.props));
      else {
        const E = i.var("props", (0, ys._)`${v}.evaluated.props`);
        o.props = k1.mergeEvaluated.props(i, E, o.props, ys.Name);
      }
    if (o.items !== !0)
      if (C && !C.dynamicItems)
        C.items !== void 0 && (o.items = k1.mergeEvaluated.items(i, C.items, o.items));
      else {
        const E = i.var("items", (0, ys._)`${v}.evaluated.items`);
        o.items = k1.mergeEvaluated.items(i, E, o.items, ys.Name);
      }
  }
}
Up.callRef = Bx;
Up.default = Eve;
Object.defineProperty(h2, "__esModule", { value: !0 });
const Tve = m2, Sve = Up, Ave = [
  "$schema",
  "$id",
  "$defs",
  "$vocabulary",
  { keyword: "$comment" },
  "definitions",
  Tve.default,
  Sve.default
];
h2.default = Ave;
var g2 = {}, y2 = {};
Object.defineProperty(y2, "__esModule", { value: !0 });
const wD = $n, Uc = wD.operators, PD = {
  maximum: { okStr: "<=", ok: Uc.LTE, fail: Uc.GT },
  minimum: { okStr: ">=", ok: Uc.GTE, fail: Uc.LT },
  exclusiveMaximum: { okStr: "<", ok: Uc.LT, fail: Uc.GTE },
  exclusiveMinimum: { okStr: ">", ok: Uc.GT, fail: Uc.LTE }
}, wve = {
  message: ({ keyword: e, schemaCode: t }) => (0, wD.str)`must be ${PD[e].okStr} ${t}`,
  params: ({ keyword: e, schemaCode: t }) => (0, wD._)`{comparison: ${PD[e].okStr}, limit: ${t}}`
}, Pve = {
  keyword: Object.keys(PD),
  type: "number",
  schemaType: "number",
  $data: !0,
  error: wve,
  code(e) {
    const { keyword: t, data: n, schemaCode: r } = e;
    e.fail$data((0, wD._)`${n} ${PD[t].fail} ${r} || isNaN(${n})`);
  }
};
y2.default = Pve;
var b2 = {};
Object.defineProperty(b2, "__esModule", { value: !0 });
const n0 = $n, kve = {
  message: ({ schemaCode: e }) => (0, n0.str)`must be multiple of ${e}`,
  params: ({ schemaCode: e }) => (0, n0._)`{multipleOf: ${e}}`
}, Ove = {
  keyword: "multipleOf",
  type: "number",
  schemaType: "number",
  $data: !0,
  error: kve,
  code(e) {
    const { gen: t, data: n, schemaCode: r, it: i } = e, o = i.opts.multipleOfPrecision, s = t.let("res"), a = o ? (0, n0._)`Math.abs(Math.round(${s}) - ${s}) > 1e-${o}` : (0, n0._)`${s} !== parseInt(${s})`;
    e.fail$data((0, n0._)`(${r} === 0 || (${s} = ${n}/${r}, ${a}))`);
  }
};
b2.default = Ove;
var v2 = {}, x2 = {};
Object.defineProperty(x2, "__esModule", { value: !0 });
function B7(e) {
  const t = e.length;
  let n = 0, r = 0, i;
  for (; r < t; )
    n++, i = e.charCodeAt(r++), i >= 55296 && i <= 56319 && r < t && (i = e.charCodeAt(r), (i & 64512) === 56320 && r++);
  return n;
}
x2.default = B7;
B7.code = 'require("ajv/dist/runtime/ucs2length").default';
Object.defineProperty(v2, "__esModule", { value: !0 });
const Dp = $n, Ive = jt, Fve = x2, $ve = {
  message({ keyword: e, schemaCode: t }) {
    const n = e === "maxLength" ? "more" : "fewer";
    return (0, Dp.str)`must NOT have ${n} than ${t} characters`;
  },
  params: ({ schemaCode: e }) => (0, Dp._)`{limit: ${e}}`
}, Nve = {
  keyword: ["maxLength", "minLength"],
  type: "string",
  schemaType: "number",
  $data: !0,
  error: $ve,
  code(e) {
    const { keyword: t, data: n, schemaCode: r, it: i } = e, o = t === "maxLength" ? Dp.operators.GT : Dp.operators.LT, s = i.opts.unicode === !1 ? (0, Dp._)`${n}.length` : (0, Dp._)`${(0, Ive.useFunc)(e.gen, Fve.default)}(${n})`;
    e.fail$data((0, Dp._)`${s} ${o} ${r}`);
  }
};
v2.default = Nve;
var D2 = {};
Object.defineProperty(D2, "__esModule", { value: !0 });
const Mve = Bn, kD = $n, Rve = {
  message: ({ schemaCode: e }) => (0, kD.str)`must match pattern "${e}"`,
  params: ({ schemaCode: e }) => (0, kD._)`{pattern: ${e}}`
}, _ve = {
  keyword: "pattern",
  type: "string",
  schemaType: "string",
  $data: !0,
  error: Rve,
  code(e) {
    const { data: t, $data: n, schema: r, schemaCode: i, it: o } = e, s = o.opts.unicodeRegExp ? "u" : "", a = n ? (0, kD._)`(new RegExp(${i}, ${s}))` : (0, Mve.usePattern)(e, r);
    e.fail$data((0, kD._)`!${a}.test(${t})`);
  }
};
D2.default = _ve;
var C2 = {};
Object.defineProperty(C2, "__esModule", { value: !0 });
const r0 = $n, Lve = {
  message({ keyword: e, schemaCode: t }) {
    const n = e === "maxProperties" ? "more" : "fewer";
    return (0, r0.str)`must NOT have ${n} than ${t} properties`;
  },
  params: ({ schemaCode: e }) => (0, r0._)`{limit: ${e}}`
}, Bve = {
  keyword: ["maxProperties", "minProperties"],
  type: "object",
  schemaType: "number",
  $data: !0,
  error: Lve,
  code(e) {
    const { keyword: t, data: n, schemaCode: r } = e, i = t === "maxProperties" ? r0.operators.GT : r0.operators.LT;
    e.fail$data((0, r0._)`Object.keys(${n}).length ${i} ${r}`);
  }
};
C2.default = Bve;
var E2 = {};
Object.defineProperty(E2, "__esModule", { value: !0 });
const Dy = Bn, i0 = $n, jve = jt, Vve = {
  message: ({ params: { missingProperty: e } }) => (0, i0.str)`must have required property '${e}'`,
  params: ({ params: { missingProperty: e } }) => (0, i0._)`{missingProperty: ${e}}`
}, zve = {
  keyword: "required",
  type: "object",
  schemaType: "array",
  $data: !0,
  error: Vve,
  code(e) {
    const { gen: t, schema: n, schemaCode: r, data: i, $data: o, it: s } = e, { opts: a } = s;
    if (!o && n.length === 0)
      return;
    const u = n.length >= a.loopRequired;
    if (s.allErrors ? c() : d(), a.strictRequired) {
      const m = e.parentSchema.properties, { definedProperties: v } = e.it;
      for (const x of n)
        if ((m == null ? void 0 : m[x]) === void 0 && !v.has(x)) {
          const C = s.schemaEnv.baseId + s.errSchemaPath, E = `required property "${x}" is not defined at "${C}" (strictRequired)`;
          (0, jve.checkStrictMode)(s, E, s.opts.strictRequired);
        }
    }
    function c() {
      if (u || o)
        e.block$data(i0.nil, f);
      else
        for (const m of n)
          (0, Dy.checkReportMissingProp)(e, m);
    }
    function d() {
      const m = t.let("missing");
      if (u || o) {
        const v = t.let("valid", !0);
        e.block$data(v, () => h(m, v)), e.ok(v);
      } else
        t.if((0, Dy.checkMissingProp)(e, n, m)), (0, Dy.reportMissingProp)(e, m), t.else();
    }
    function f() {
      t.forOf("prop", r, (m) => {
        e.setParams({ missingProperty: m }), t.if((0, Dy.noPropertyInData)(t, i, m, a.ownProperties), () => e.error());
      });
    }
    function h(m, v) {
      e.setParams({ missingProperty: m }), t.forOf(m, r, () => {
        t.assign(v, (0, Dy.propertyInData)(t, i, m, a.ownProperties)), t.if((0, i0.not)(v), () => {
          e.error(), t.break();
        });
      }, i0.nil);
    }
  }
};
E2.default = zve;
var T2 = {};
Object.defineProperty(T2, "__esModule", { value: !0 });
const o0 = $n, Uve = {
  message({ keyword: e, schemaCode: t }) {
    const n = e === "maxItems" ? "more" : "fewer";
    return (0, o0.str)`must NOT have ${n} than ${t} items`;
  },
  params: ({ schemaCode: e }) => (0, o0._)`{limit: ${e}}`
}, Wve = {
  keyword: ["maxItems", "minItems"],
  type: "array",
  schemaType: "number",
  $data: !0,
  error: Uve,
  code(e) {
    const { keyword: t, data: n, schemaCode: r } = e, i = t === "maxItems" ? o0.operators.GT : o0.operators.LT;
    e.fail$data((0, o0._)`${n}.length ${i} ${r}`);
  }
};
T2.default = Wve;
var S2 = {}, wb = {};
Object.defineProperty(wb, "__esModule", { value: !0 });
const j7 = p7;
j7.code = 'require("ajv/dist/runtime/equal").default';
wb.default = j7;
Object.defineProperty(S2, "__esModule", { value: !0 });
const gA = zi, co = $n, Hve = jt, qve = wb, Gve = {
  message: ({ params: { i: e, j: t } }) => (0, co.str)`must NOT have duplicate items (items ## ${t} and ${e} are identical)`,
  params: ({ params: { i: e, j: t } }) => (0, co._)`{i: ${e}, j: ${t}}`
}, Yve = {
  keyword: "uniqueItems",
  type: "array",
  schemaType: "boolean",
  $data: !0,
  error: Gve,
  code(e) {
    const { gen: t, data: n, $data: r, schema: i, parentSchema: o, schemaCode: s, it: a } = e;
    if (!r && !i)
      return;
    const u = t.let("valid"), c = o.items ? (0, gA.getSchemaTypes)(o.items) : [];
    e.block$data(u, d, (0, co._)`${s} === false`), e.ok(u);
    function d() {
      const v = t.let("i", (0, co._)`${n}.length`), x = t.let("j");
      e.setParams({ i: v, j: x }), t.assign(u, !0), t.if((0, co._)`${v} > 1`, () => (f() ? h : m)(v, x));
    }
    function f() {
      return c.length > 0 && !c.some((v) => v === "object" || v === "array");
    }
    function h(v, x) {
      const C = t.name("item"), E = (0, gA.checkDataTypes)(c, C, a.opts.strictNumbers, gA.DataType.Wrong), S = t.const("indices", (0, co._)`{}`);
      t.for((0, co._)`;${v}--;`, () => {
        t.let(C, (0, co._)`${n}[${v}]`), t.if(E, (0, co._)`continue`), c.length > 1 && t.if((0, co._)`typeof ${C} == "string"`, (0, co._)`${C} += "_"`), t.if((0, co._)`typeof ${S}[${C}] == "number"`, () => {
          t.assign(x, (0, co._)`${S}[${C}]`), e.error(), t.assign(u, !1).break();
        }).code((0, co._)`${S}[${C}] = ${v}`);
      });
    }
    function m(v, x) {
      const C = (0, Hve.useFunc)(t, qve.default), E = t.name("outer");
      t.label(E).for((0, co._)`;${v}--;`, () => t.for((0, co._)`${x} = ${v}; ${x}--;`, () => t.if((0, co._)`${C}(${n}[${v}], ${n}[${x}])`, () => {
        e.error(), t.assign(u, !1).break(E);
      })));
    }
  }
};
S2.default = Yve;
var A2 = {};
Object.defineProperty(A2, "__esModule", { value: !0 });
const PP = $n, Kve = jt, Jve = wb, Xve = {
  message: "must be equal to constant",
  params: ({ schemaCode: e }) => (0, PP._)`{allowedValue: ${e}}`
}, Qve = {
  keyword: "const",
  $data: !0,
  error: Xve,
  code(e) {
    const { gen: t, data: n, $data: r, schemaCode: i, schema: o } = e;
    r || o && typeof o == "object" ? e.fail$data((0, PP._)`!${(0, Kve.useFunc)(t, Jve.default)}(${n}, ${i})`) : e.fail((0, PP._)`${o} !== ${n}`);
  }
};
A2.default = Qve;
var w2 = {};
Object.defineProperty(w2, "__esModule", { value: !0 });
const Uy = $n, Zve = jt, e1e = wb, t1e = {
  message: "must be equal to one of the allowed values",
  params: ({ schemaCode: e }) => (0, Uy._)`{allowedValues: ${e}}`
}, n1e = {
  keyword: "enum",
  schemaType: "array",
  $data: !0,
  error: t1e,
  code(e) {
    const { gen: t, data: n, $data: r, schema: i, schemaCode: o, it: s } = e;
    if (!r && i.length === 0)
      throw new Error("enum must have non-empty array");
    const a = i.length >= s.opts.loopEnum;
    let u;
    const c = () => u ?? (u = (0, Zve.useFunc)(t, e1e.default));
    let d;
    if (a || r)
      d = t.let("valid"), e.block$data(d, f);
    else {
      if (!Array.isArray(i))
        throw new Error("ajv implementation error");
      const m = t.const("vSchema", o);
      d = (0, Uy.or)(...i.map((v, x) => h(m, x)));
    }
    e.pass(d);
    function f() {
      t.assign(d, !1), t.forOf("v", o, (m) => t.if((0, Uy._)`${c()}(${n}, ${m})`, () => t.assign(d, !0).break()));
    }
    function h(m, v) {
      const x = i[v];
      return typeof x == "object" && x !== null ? (0, Uy._)`${c()}(${n}, ${m}[${v}])` : (0, Uy._)`${n} === ${x}`;
    }
  }
};
w2.default = n1e;
Object.defineProperty(g2, "__esModule", { value: !0 });
const r1e = y2, i1e = b2, o1e = v2, s1e = D2, a1e = C2, l1e = E2, u1e = T2, c1e = S2, d1e = A2, p1e = w2, f1e = [
  // number
  r1e.default,
  i1e.default,
  // string
  o1e.default,
  s1e.default,
  // object
  a1e.default,
  l1e.default,
  // array
  u1e.default,
  c1e.default,
  // any
  { keyword: "type", schemaType: ["string", "array"] },
  { keyword: "nullable", schemaType: "boolean" },
  d1e.default,
  p1e.default
];
g2.default = f1e;
var P2 = {}, Ym = {};
Object.defineProperty(Ym, "__esModule", { value: !0 });
Ym.validateAdditionalItems = void 0;
const Cp = $n, kP = jt, h1e = {
  message: ({ params: { len: e } }) => (0, Cp.str)`must NOT have more than ${e} items`,
  params: ({ params: { len: e } }) => (0, Cp._)`{limit: ${e}}`
}, m1e = {
  keyword: "additionalItems",
  type: "array",
  schemaType: ["boolean", "object"],
  before: "uniqueItems",
  error: h1e,
  code(e) {
    const { parentSchema: t, it: n } = e, { items: r } = t;
    if (!Array.isArray(r)) {
      (0, kP.checkStrictMode)(n, '"additionalItems" is ignored when "items" is not an array of schemas');
      return;
    }
    V7(e, r);
  }
};
function V7(e, t) {
  const { gen: n, schema: r, data: i, keyword: o, it: s } = e;
  s.items = !0;
  const a = n.const("len", (0, Cp._)`${i}.length`);
  if (r === !1)
    e.setParams({ len: t.length }), e.pass((0, Cp._)`${a} <= ${t.length}`);
  else if (typeof r == "object" && !(0, kP.alwaysValidSchema)(s, r)) {
    const c = n.var("valid", (0, Cp._)`${a} <= ${t.length}`);
    n.if((0, Cp.not)(c), () => u(c)), e.ok(c);
  }
  function u(c) {
    n.forRange("i", t.length, a, (d) => {
      e.subschema({ keyword: o, dataProp: d, dataPropType: kP.Type.Num }, c), s.allErrors || n.if((0, Cp.not)(c), () => n.break());
    });
  }
}
Ym.validateAdditionalItems = V7;
Ym.default = m1e;
var k2 = {}, Km = {};
Object.defineProperty(Km, "__esModule", { value: !0 });
Km.validateTuple = void 0;
const Q_ = $n, jx = jt, g1e = Bn, y1e = {
  keyword: "items",
  type: "array",
  schemaType: ["object", "array", "boolean"],
  before: "uniqueItems",
  code(e) {
    const { schema: t, it: n } = e;
    if (Array.isArray(t))
      return z7(e, "additionalItems", t);
    n.items = !0, !(0, jx.alwaysValidSchema)(n, t) && e.ok((0, g1e.validateArray)(e));
  }
};
function z7(e, t, n = e.schema) {
  const { gen: r, parentSchema: i, data: o, keyword: s, it: a } = e;
  d(i), a.opts.unevaluated && n.length && a.items !== !0 && (a.items = jx.mergeEvaluated.items(r, n.length, a.items));
  const u = r.name("valid"), c = r.const("len", (0, Q_._)`${o}.length`);
  n.forEach((f, h) => {
    (0, jx.alwaysValidSchema)(a, f) || (r.if((0, Q_._)`${c} > ${h}`, () => e.subschema({
      keyword: s,
      schemaProp: h,
      dataProp: h
    }, u)), e.ok(u));
  });
  function d(f) {
    const { opts: h, errSchemaPath: m } = a, v = n.length, x = v === f.minItems && (v === f.maxItems || f[t] === !1);
    if (h.strictTuples && !x) {
      const C = `"${s}" is ${v}-tuple, but minItems or maxItems/${t} are not specified or different at path "${m}"`;
      (0, jx.checkStrictMode)(a, C, h.strictTuples);
    }
  }
}
Km.validateTuple = z7;
Km.default = y1e;
Object.defineProperty(k2, "__esModule", { value: !0 });
const b1e = Km, v1e = {
  keyword: "prefixItems",
  type: "array",
  schemaType: ["array"],
  before: "uniqueItems",
  code: (e) => (0, b1e.validateTuple)(e, "items")
};
k2.default = v1e;
var O2 = {};
Object.defineProperty(O2, "__esModule", { value: !0 });
const Z_ = $n, x1e = jt, D1e = Bn, C1e = Ym, E1e = {
  message: ({ params: { len: e } }) => (0, Z_.str)`must NOT have more than ${e} items`,
  params: ({ params: { len: e } }) => (0, Z_._)`{limit: ${e}}`
}, T1e = {
  keyword: "items",
  type: "array",
  schemaType: ["object", "boolean"],
  before: "uniqueItems",
  error: E1e,
  code(e) {
    const { schema: t, parentSchema: n, it: r } = e, { prefixItems: i } = n;
    r.items = !0, !(0, x1e.alwaysValidSchema)(r, t) && (i ? (0, C1e.validateAdditionalItems)(e, i) : e.ok((0, D1e.validateArray)(e)));
  }
};
O2.default = T1e;
var I2 = {};
Object.defineProperty(I2, "__esModule", { value: !0 });
const Ta = $n, O1 = jt, S1e = {
  message: ({ params: { min: e, max: t } }) => t === void 0 ? (0, Ta.str)`must contain at least ${e} valid item(s)` : (0, Ta.str)`must contain at least ${e} and no more than ${t} valid item(s)`,
  params: ({ params: { min: e, max: t } }) => t === void 0 ? (0, Ta._)`{minContains: ${e}}` : (0, Ta._)`{minContains: ${e}, maxContains: ${t}}`
}, A1e = {
  keyword: "contains",
  type: "array",
  schemaType: ["object", "boolean"],
  before: "uniqueItems",
  trackErrors: !0,
  error: S1e,
  code(e) {
    const { gen: t, schema: n, parentSchema: r, data: i, it: o } = e;
    let s, a;
    const { minContains: u, maxContains: c } = r;
    o.opts.next ? (s = u === void 0 ? 1 : u, a = c) : s = 1;
    const d = t.const("len", (0, Ta._)`${i}.length`);
    if (e.setParams({ min: s, max: a }), a === void 0 && s === 0) {
      (0, O1.checkStrictMode)(o, '"minContains" == 0 without "maxContains": "contains" keyword ignored');
      return;
    }
    if (a !== void 0 && s > a) {
      (0, O1.checkStrictMode)(o, '"minContains" > "maxContains" is always invalid'), e.fail();
      return;
    }
    if ((0, O1.alwaysValidSchema)(o, n)) {
      let x = (0, Ta._)`${d} >= ${s}`;
      a !== void 0 && (x = (0, Ta._)`${x} && ${d} <= ${a}`), e.pass(x);
      return;
    }
    o.items = !0;
    const f = t.name("valid");
    a === void 0 && s === 1 ? m(f, () => t.if(f, () => t.break())) : s === 0 ? (t.let(f, !0), a !== void 0 && t.if((0, Ta._)`${i}.length > 0`, h)) : (t.let(f, !1), h()), e.result(f, () => e.reset());
    function h() {
      const x = t.name("_valid"), C = t.let("count", 0);
      m(x, () => t.if(x, () => v(C)));
    }
    function m(x, C) {
      t.forRange("i", 0, d, (E) => {
        e.subschema({
          keyword: "contains",
          dataProp: E,
          dataPropType: O1.Type.Num,
          compositeRule: !0
        }, x), C();
      });
    }
    function v(x) {
      t.code((0, Ta._)`${x}++`), a === void 0 ? t.if((0, Ta._)`${x} >= ${s}`, () => t.assign(f, !0).break()) : (t.if((0, Ta._)`${x} > ${a}`, () => t.assign(f, !1).break()), s === 1 ? t.assign(f, !0) : t.if((0, Ta._)`${x} >= ${s}`, () => t.assign(f, !0)));
    }
  }
};
I2.default = A1e;
var U7 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.validateSchemaDeps = e.validatePropertyDeps = e.error = void 0;
  const t = $n, n = jt, r = Bn;
  e.error = {
    message: ({ params: { property: u, depsCount: c, deps: d } }) => {
      const f = c === 1 ? "property" : "properties";
      return (0, t.str)`must have ${f} ${d} when property ${u} is present`;
    },
    params: ({ params: { property: u, depsCount: c, deps: d, missingProperty: f } }) => (0, t._)`{property: ${u},
    missingProperty: ${f},
    depsCount: ${c},
    deps: ${d}}`
    // TODO change to reference
  };
  const i = {
    keyword: "dependencies",
    type: "object",
    schemaType: "object",
    error: e.error,
    code(u) {
      const [c, d] = o(u);
      s(u, c), a(u, d);
    }
  };
  function o({ schema: u }) {
    const c = {}, d = {};
    for (const f in u) {
      if (f === "__proto__")
        continue;
      const h = Array.isArray(u[f]) ? c : d;
      h[f] = u[f];
    }
    return [c, d];
  }
  function s(u, c = u.schema) {
    const { gen: d, data: f, it: h } = u;
    if (Object.keys(c).length === 0)
      return;
    const m = d.let("missing");
    for (const v in c) {
      const x = c[v];
      if (x.length === 0)
        continue;
      const C = (0, r.propertyInData)(d, f, v, h.opts.ownProperties);
      u.setParams({
        property: v,
        depsCount: x.length,
        deps: x.join(", ")
      }), h.allErrors ? d.if(C, () => {
        for (const E of x)
          (0, r.checkReportMissingProp)(u, E);
      }) : (d.if((0, t._)`${C} && (${(0, r.checkMissingProp)(u, x, m)})`), (0, r.reportMissingProp)(u, m), d.else());
    }
  }
  e.validatePropertyDeps = s;
  function a(u, c = u.schema) {
    const { gen: d, data: f, keyword: h, it: m } = u, v = d.name("valid");
    for (const x in c)
      (0, n.alwaysValidSchema)(m, c[x]) || (d.if(
        (0, r.propertyInData)(d, f, x, m.opts.ownProperties),
        () => {
          const C = u.subschema({ keyword: h, schemaProp: x }, v);
          u.mergeValidEvaluated(C, v);
        },
        () => d.var(v, !0)
        // TODO var
      ), u.ok(v));
  }
  e.validateSchemaDeps = a, e.default = i;
})(U7);
var F2 = {};
Object.defineProperty(F2, "__esModule", { value: !0 });
const W7 = $n, w1e = jt, P1e = {
  message: "property name must be valid",
  params: ({ params: e }) => (0, W7._)`{propertyName: ${e.propertyName}}`
}, k1e = {
  keyword: "propertyNames",
  type: "object",
  schemaType: ["object", "boolean"],
  error: P1e,
  code(e) {
    const { gen: t, schema: n, data: r, it: i } = e;
    if ((0, w1e.alwaysValidSchema)(i, n))
      return;
    const o = t.name("valid");
    t.forIn("key", r, (s) => {
      e.setParams({ propertyName: s }), e.subschema({
        keyword: "propertyNames",
        data: s,
        dataTypes: ["string"],
        propertyName: s,
        compositeRule: !0
      }, o), t.if((0, W7.not)(o), () => {
        e.error(!0), i.allErrors || t.break();
      });
    }), e.ok(o);
  }
};
F2.default = k1e;
var oE = {};
Object.defineProperty(oE, "__esModule", { value: !0 });
const I1 = Bn, cl = $n, O1e = Sl, F1 = jt, I1e = {
  message: "must NOT have additional properties",
  params: ({ params: e }) => (0, cl._)`{additionalProperty: ${e.additionalProperty}}`
}, F1e = {
  keyword: "additionalProperties",
  type: ["object"],
  schemaType: ["boolean", "object"],
  allowUndefined: !0,
  trackErrors: !0,
  error: I1e,
  code(e) {
    const { gen: t, schema: n, parentSchema: r, data: i, errsCount: o, it: s } = e;
    if (!o)
      throw new Error("ajv implementation error");
    const { allErrors: a, opts: u } = s;
    if (s.props = !0, u.removeAdditional !== "all" && (0, F1.alwaysValidSchema)(s, n))
      return;
    const c = (0, I1.allSchemaProperties)(r.properties), d = (0, I1.allSchemaProperties)(r.patternProperties);
    f(), e.ok((0, cl._)`${o} === ${O1e.default.errors}`);
    function f() {
      t.forIn("key", i, (C) => {
        !c.length && !d.length ? v(C) : t.if(h(C), () => v(C));
      });
    }
    function h(C) {
      let E;
      if (c.length > 8) {
        const S = (0, F1.schemaRefOrVal)(s, r.properties, "properties");
        E = (0, I1.isOwnProperty)(t, S, C);
      } else c.length ? E = (0, cl.or)(...c.map((S) => (0, cl._)`${C} === ${S}`)) : E = cl.nil;
      return d.length && (E = (0, cl.or)(E, ...d.map((S) => (0, cl._)`${(0, I1.usePattern)(e, S)}.test(${C})`))), (0, cl.not)(E);
    }
    function m(C) {
      t.code((0, cl._)`delete ${i}[${C}]`);
    }
    function v(C) {
      if (u.removeAdditional === "all" || u.removeAdditional && n === !1) {
        m(C);
        return;
      }
      if (n === !1) {
        e.setParams({ additionalProperty: C }), e.error(), a || t.break();
        return;
      }
      if (typeof n == "object" && !(0, F1.alwaysValidSchema)(s, n)) {
        const E = t.name("valid");
        u.removeAdditional === "failing" ? (x(C, E, !1), t.if((0, cl.not)(E), () => {
          e.reset(), m(C);
        })) : (x(C, E), a || t.if((0, cl.not)(E), () => t.break()));
      }
    }
    function x(C, E, S) {
      const w = {
        keyword: "additionalProperties",
        dataProp: C,
        dataPropType: F1.Type.Str
      };
      S === !1 && Object.assign(w, {
        compositeRule: !0,
        createErrors: !1,
        allErrors: !1
      }), e.subschema(w, E);
    }
  }
};
oE.default = F1e;
var $2 = {};
Object.defineProperty($2, "__esModule", { value: !0 });
const $1e = Na, eL = Bn, yA = jt, tL = oE, N1e = {
  keyword: "properties",
  type: "object",
  schemaType: "object",
  code(e) {
    const { gen: t, schema: n, parentSchema: r, data: i, it: o } = e;
    o.opts.removeAdditional === "all" && r.additionalProperties === void 0 && tL.default.code(new $1e.KeywordCxt(o, tL.default, "additionalProperties"));
    const s = (0, eL.allSchemaProperties)(n);
    for (const f of s)
      o.definedProperties.add(f);
    o.opts.unevaluated && s.length && o.props !== !0 && (o.props = yA.mergeEvaluated.props(t, (0, yA.toHash)(s), o.props));
    const a = s.filter((f) => !(0, yA.alwaysValidSchema)(o, n[f]));
    if (a.length === 0)
      return;
    const u = t.name("valid");
    for (const f of a)
      c(f) ? d(f) : (t.if((0, eL.propertyInData)(t, i, f, o.opts.ownProperties)), d(f), o.allErrors || t.else().var(u, !0), t.endIf()), e.it.definedProperties.add(f), e.ok(u);
    function c(f) {
      return o.opts.useDefaults && !o.compositeRule && n[f].default !== void 0;
    }
    function d(f) {
      e.subschema({
        keyword: "properties",
        schemaProp: f,
        dataProp: f
      }, u);
    }
  }
};
$2.default = N1e;
var N2 = {};
Object.defineProperty(N2, "__esModule", { value: !0 });
const nL = Bn, $1 = $n, rL = jt, iL = jt, M1e = {
  keyword: "patternProperties",
  type: "object",
  schemaType: "object",
  code(e) {
    const { gen: t, schema: n, data: r, parentSchema: i, it: o } = e, { opts: s } = o, a = (0, nL.allSchemaProperties)(n), u = a.filter((x) => (0, rL.alwaysValidSchema)(o, n[x]));
    if (a.length === 0 || u.length === a.length && (!o.opts.unevaluated || o.props === !0))
      return;
    const c = s.strictSchema && !s.allowMatchingProperties && i.properties, d = t.name("valid");
    o.props !== !0 && !(o.props instanceof $1.Name) && (o.props = (0, iL.evaluatedPropsToName)(t, o.props));
    const { props: f } = o;
    h();
    function h() {
      for (const x of a)
        c && m(x), o.allErrors ? v(x) : (t.var(d, !0), v(x), t.if(d));
    }
    function m(x) {
      for (const C in c)
        new RegExp(x).test(C) && (0, rL.checkStrictMode)(o, `property ${C} matches pattern ${x} (use allowMatchingProperties)`);
    }
    function v(x) {
      t.forIn("key", r, (C) => {
        t.if((0, $1._)`${(0, nL.usePattern)(e, x)}.test(${C})`, () => {
          const E = u.includes(x);
          E || e.subschema({
            keyword: "patternProperties",
            schemaProp: x,
            dataProp: C,
            dataPropType: iL.Type.Str
          }, d), o.opts.unevaluated && f !== !0 ? t.assign((0, $1._)`${f}[${C}]`, !0) : !E && !o.allErrors && t.if((0, $1.not)(d), () => t.break());
        });
      });
    }
  }
};
N2.default = M1e;
var M2 = {};
Object.defineProperty(M2, "__esModule", { value: !0 });
const R1e = jt, _1e = {
  keyword: "not",
  schemaType: ["object", "boolean"],
  trackErrors: !0,
  code(e) {
    const { gen: t, schema: n, it: r } = e;
    if ((0, R1e.alwaysValidSchema)(r, n)) {
      e.fail();
      return;
    }
    const i = t.name("valid");
    e.subschema({
      keyword: "not",
      compositeRule: !0,
      createErrors: !1,
      allErrors: !1
    }, i), e.failResult(i, () => e.reset(), () => e.error());
  },
  error: { message: "must NOT be valid" }
};
M2.default = _1e;
var R2 = {};
Object.defineProperty(R2, "__esModule", { value: !0 });
const L1e = Bn, B1e = {
  keyword: "anyOf",
  schemaType: "array",
  trackErrors: !0,
  code: L1e.validateUnion,
  error: { message: "must match a schema in anyOf" }
};
R2.default = B1e;
var _2 = {};
Object.defineProperty(_2, "__esModule", { value: !0 });
const Vx = $n, j1e = jt, V1e = {
  message: "must match exactly one schema in oneOf",
  params: ({ params: e }) => (0, Vx._)`{passingSchemas: ${e.passing}}`
}, z1e = {
  keyword: "oneOf",
  schemaType: "array",
  trackErrors: !0,
  error: V1e,
  code(e) {
    const { gen: t, schema: n, parentSchema: r, it: i } = e;
    if (!Array.isArray(n))
      throw new Error("ajv implementation error");
    if (i.opts.discriminator && r.discriminator)
      return;
    const o = n, s = t.let("valid", !1), a = t.let("passing", null), u = t.name("_valid");
    e.setParams({ passing: a }), t.block(c), e.result(s, () => e.reset(), () => e.error(!0));
    function c() {
      o.forEach((d, f) => {
        let h;
        (0, j1e.alwaysValidSchema)(i, d) ? t.var(u, !0) : h = e.subschema({
          keyword: "oneOf",
          schemaProp: f,
          compositeRule: !0
        }, u), f > 0 && t.if((0, Vx._)`${u} && ${s}`).assign(s, !1).assign(a, (0, Vx._)`[${a}, ${f}]`).else(), t.if(u, () => {
          t.assign(s, !0), t.assign(a, f), h && e.mergeEvaluated(h, Vx.Name);
        });
      });
    }
  }
};
_2.default = z1e;
var L2 = {};
Object.defineProperty(L2, "__esModule", { value: !0 });
const U1e = jt, W1e = {
  keyword: "allOf",
  schemaType: "array",
  code(e) {
    const { gen: t, schema: n, it: r } = e;
    if (!Array.isArray(n))
      throw new Error("ajv implementation error");
    const i = t.name("valid");
    n.forEach((o, s) => {
      if ((0, U1e.alwaysValidSchema)(r, o))
        return;
      const a = e.subschema({ keyword: "allOf", schemaProp: s }, i);
      e.ok(i), e.mergeEvaluated(a);
    });
  }
};
L2.default = W1e;
var B2 = {};
Object.defineProperty(B2, "__esModule", { value: !0 });
const OD = $n, H7 = jt, H1e = {
  message: ({ params: e }) => (0, OD.str)`must match "${e.ifClause}" schema`,
  params: ({ params: e }) => (0, OD._)`{failingKeyword: ${e.ifClause}}`
}, q1e = {
  keyword: "if",
  schemaType: ["object", "boolean"],
  trackErrors: !0,
  error: H1e,
  code(e) {
    const { gen: t, parentSchema: n, it: r } = e;
    n.then === void 0 && n.else === void 0 && (0, H7.checkStrictMode)(r, '"if" without "then" and "else" is ignored');
    const i = oL(r, "then"), o = oL(r, "else");
    if (!i && !o)
      return;
    const s = t.let("valid", !0), a = t.name("_valid");
    if (u(), e.reset(), i && o) {
      const d = t.let("ifClause");
      e.setParams({ ifClause: d }), t.if(a, c("then", d), c("else", d));
    } else i ? t.if(a, c("then")) : t.if((0, OD.not)(a), c("else"));
    e.pass(s, () => e.error(!0));
    function u() {
      const d = e.subschema({
        keyword: "if",
        compositeRule: !0,
        createErrors: !1,
        allErrors: !1
      }, a);
      e.mergeEvaluated(d);
    }
    function c(d, f) {
      return () => {
        const h = e.subschema({ keyword: d }, a);
        t.assign(s, a), e.mergeValidEvaluated(h, s), f ? t.assign(f, (0, OD._)`${d}`) : e.setParams({ ifClause: d });
      };
    }
  }
};
function oL(e, t) {
  const n = e.schema[t];
  return n !== void 0 && !(0, H7.alwaysValidSchema)(e, n);
}
B2.default = q1e;
var j2 = {};
Object.defineProperty(j2, "__esModule", { value: !0 });
const G1e = jt, Y1e = {
  keyword: ["then", "else"],
  schemaType: ["object", "boolean"],
  code({ keyword: e, parentSchema: t, it: n }) {
    t.if === void 0 && (0, G1e.checkStrictMode)(n, `"${e}" without "if" is ignored`);
  }
};
j2.default = Y1e;
Object.defineProperty(P2, "__esModule", { value: !0 });
const K1e = Ym, J1e = k2, X1e = Km, Q1e = O2, Z1e = I2, exe = U7, txe = F2, nxe = oE, rxe = $2, ixe = N2, oxe = M2, sxe = R2, axe = _2, lxe = L2, uxe = B2, cxe = j2;
function dxe(e = !1) {
  const t = [
    // any
    oxe.default,
    sxe.default,
    axe.default,
    lxe.default,
    uxe.default,
    cxe.default,
    // object
    txe.default,
    nxe.default,
    exe.default,
    rxe.default,
    ixe.default
  ];
  return e ? t.push(J1e.default, Q1e.default) : t.push(K1e.default, X1e.default), t.push(Z1e.default), t;
}
P2.default = dxe;
var V2 = {}, z2 = {};
Object.defineProperty(z2, "__esModule", { value: !0 });
const Ti = $n, pxe = {
  message: ({ schemaCode: e }) => (0, Ti.str)`must match format "${e}"`,
  params: ({ schemaCode: e }) => (0, Ti._)`{format: ${e}}`
}, fxe = {
  keyword: "format",
  type: ["number", "string"],
  schemaType: "string",
  $data: !0,
  error: pxe,
  code(e, t) {
    const { gen: n, data: r, $data: i, schema: o, schemaCode: s, it: a } = e, { opts: u, errSchemaPath: c, schemaEnv: d, self: f } = a;
    if (!u.validateFormats)
      return;
    i ? h() : m();
    function h() {
      const v = n.scopeValue("formats", {
        ref: f.formats,
        code: u.code.formats
      }), x = n.const("fDef", (0, Ti._)`${v}[${s}]`), C = n.let("fType"), E = n.let("format");
      n.if((0, Ti._)`typeof ${x} == "object" && !(${x} instanceof RegExp)`, () => n.assign(C, (0, Ti._)`${x}.type || "string"`).assign(E, (0, Ti._)`${x}.validate`), () => n.assign(C, (0, Ti._)`"string"`).assign(E, x)), e.fail$data((0, Ti.or)(S(), w()));
      function S() {
        return u.strictSchema === !1 ? Ti.nil : (0, Ti._)`${s} && !${E}`;
      }
      function w() {
        const O = d.$async ? (0, Ti._)`(${x}.async ? await ${E}(${r}) : ${E}(${r}))` : (0, Ti._)`${E}(${r})`, A = (0, Ti._)`(typeof ${E} == "function" ? ${O} : ${E}.test(${r}))`;
        return (0, Ti._)`${E} && ${E} !== true && ${C} === ${t} && !${A}`;
      }
    }
    function m() {
      const v = f.formats[o];
      if (!v) {
        S();
        return;
      }
      if (v === !0)
        return;
      const [x, C, E] = w(v);
      x === t && e.pass(O());
      function S() {
        if (u.strictSchema === !1) {
          f.logger.warn(A());
          return;
        }
        throw new Error(A());
        function A() {
          return `unknown format "${o}" ignored in schema at path "${c}"`;
        }
      }
      function w(A) {
        const I = A instanceof RegExp ? (0, Ti.regexpCode)(A) : u.code.formats ? (0, Ti._)`${u.code.formats}${(0, Ti.getProperty)(o)}` : void 0, $ = n.scopeValue("formats", { key: o, ref: A, code: I });
        return typeof A == "object" && !(A instanceof RegExp) ? [A.type || "string", A.validate, (0, Ti._)`${$}.validate`] : ["string", A, $];
      }
      function O() {
        if (typeof v == "object" && !(v instanceof RegExp) && v.async) {
          if (!d.$async)
            throw new Error("async format in sync schema");
          return (0, Ti._)`await ${E}(${r})`;
        }
        return typeof C == "function" ? (0, Ti._)`${E}(${r})` : (0, Ti._)`${E}.test(${r})`;
      }
    }
  }
};
z2.default = fxe;
Object.defineProperty(V2, "__esModule", { value: !0 });
const hxe = z2, mxe = [hxe.default];
V2.default = mxe;
var cm = {};
Object.defineProperty(cm, "__esModule", { value: !0 });
cm.contentVocabulary = cm.metadataVocabulary = void 0;
cm.metadataVocabulary = [
  "title",
  "description",
  "default",
  "deprecated",
  "readOnly",
  "writeOnly",
  "examples"
];
cm.contentVocabulary = [
  "contentMediaType",
  "contentEncoding",
  "contentSchema"
];
Object.defineProperty(f2, "__esModule", { value: !0 });
const gxe = h2, yxe = g2, bxe = P2, vxe = V2, sL = cm, xxe = [
  gxe.default,
  yxe.default,
  (0, bxe.default)(),
  vxe.default,
  sL.metadataVocabulary,
  sL.contentVocabulary
];
f2.default = xxe;
var U2 = {}, sE = {};
Object.defineProperty(sE, "__esModule", { value: !0 });
sE.DiscrError = void 0;
var aL;
(function(e) {
  e.Tag = "tag", e.Mapping = "mapping";
})(aL || (sE.DiscrError = aL = {}));
Object.defineProperty(U2, "__esModule", { value: !0 });
const Sh = $n, OP = sE, lL = Es, Dxe = Gm, Cxe = jt, Exe = {
  message: ({ params: { discrError: e, tagName: t } }) => e === OP.DiscrError.Tag ? `tag "${t}" must be string` : `value of tag "${t}" must be in oneOf`,
  params: ({ params: { discrError: e, tag: t, tagName: n } }) => (0, Sh._)`{error: ${e}, tag: ${n}, tagValue: ${t}}`
}, Txe = {
  keyword: "discriminator",
  type: "object",
  schemaType: "object",
  error: Exe,
  code(e) {
    const { gen: t, data: n, schema: r, parentSchema: i, it: o } = e, { oneOf: s } = i;
    if (!o.opts.discriminator)
      throw new Error("discriminator: requires discriminator option");
    const a = r.propertyName;
    if (typeof a != "string")
      throw new Error("discriminator: requires propertyName");
    if (r.mapping)
      throw new Error("discriminator: mapping is not supported");
    if (!s)
      throw new Error("discriminator: requires oneOf keyword");
    const u = t.let("valid", !1), c = t.const("tag", (0, Sh._)`${n}${(0, Sh.getProperty)(a)}`);
    t.if((0, Sh._)`typeof ${c} == "string"`, () => d(), () => e.error(!1, { discrError: OP.DiscrError.Tag, tag: c, tagName: a })), e.ok(u);
    function d() {
      const m = h();
      t.if(!1);
      for (const v in m)
        t.elseIf((0, Sh._)`${c} === ${v}`), t.assign(u, f(m[v]));
      t.else(), e.error(!1, { discrError: OP.DiscrError.Mapping, tag: c, tagName: a }), t.endIf();
    }
    function f(m) {
      const v = t.name("valid"), x = e.subschema({ keyword: "oneOf", schemaProp: m }, v);
      return e.mergeEvaluated(x, Sh.Name), v;
    }
    function h() {
      var m;
      const v = {}, x = E(i);
      let C = !0;
      for (let O = 0; O < s.length; O++) {
        let A = s[O];
        if (A != null && A.$ref && !(0, Cxe.schemaHasRulesButRef)(A, o.self.RULES)) {
          const $ = A.$ref;
          if (A = lL.resolveRef.call(o.self, o.schemaEnv.root, o.baseId, $), A instanceof lL.SchemaEnv && (A = A.schema), A === void 0)
            throw new Dxe.default(o.opts.uriResolver, o.baseId, $);
        }
        const I = (m = A == null ? void 0 : A.properties) === null || m === void 0 ? void 0 : m[a];
        if (typeof I != "object")
          throw new Error(`discriminator: oneOf subschemas (or referenced schemas) must have "properties/${a}"`);
        C = C && (x || E(A)), S(I, O);
      }
      if (!C)
        throw new Error(`discriminator: "${a}" must be required`);
      return v;
      function E({ required: O }) {
        return Array.isArray(O) && O.includes(a);
      }
      function S(O, A) {
        if (O.const)
          w(O.const, A);
        else if (O.enum)
          for (const I of O.enum)
            w(I, A);
        else
          throw new Error(`discriminator: "properties/${a}" must have "const" or "enum"`);
      }
      function w(O, A) {
        if (typeof O != "string" || O in v)
          throw new Error(`discriminator: "${a}" values must be unique strings`);
        v[O] = A;
      }
    }
  }
};
U2.default = Txe;
const Sxe = "http://json-schema.org/draft-07/schema#", Axe = "http://json-schema.org/draft-07/schema#", wxe = "Core schema meta-schema", Pxe = {
  schemaArray: {
    type: "array",
    minItems: 1,
    items: {
      $ref: "#"
    }
  },
  nonNegativeInteger: {
    type: "integer",
    minimum: 0
  },
  nonNegativeIntegerDefault0: {
    allOf: [
      {
        $ref: "#/definitions/nonNegativeInteger"
      },
      {
        default: 0
      }
    ]
  },
  simpleTypes: {
    enum: [
      "array",
      "boolean",
      "integer",
      "null",
      "number",
      "object",
      "string"
    ]
  },
  stringArray: {
    type: "array",
    items: {
      type: "string"
    },
    uniqueItems: !0,
    default: []
  }
}, kxe = [
  "object",
  "boolean"
], Oxe = {
  $id: {
    type: "string",
    format: "uri-reference"
  },
  $schema: {
    type: "string",
    format: "uri"
  },
  $ref: {
    type: "string",
    format: "uri-reference"
  },
  $comment: {
    type: "string"
  },
  title: {
    type: "string"
  },
  description: {
    type: "string"
  },
  default: !0,
  readOnly: {
    type: "boolean",
    default: !1
  },
  examples: {
    type: "array",
    items: !0
  },
  multipleOf: {
    type: "number",
    exclusiveMinimum: 0
  },
  maximum: {
    type: "number"
  },
  exclusiveMaximum: {
    type: "number"
  },
  minimum: {
    type: "number"
  },
  exclusiveMinimum: {
    type: "number"
  },
  maxLength: {
    $ref: "#/definitions/nonNegativeInteger"
  },
  minLength: {
    $ref: "#/definitions/nonNegativeIntegerDefault0"
  },
  pattern: {
    type: "string",
    format: "regex"
  },
  additionalItems: {
    $ref: "#"
  },
  items: {
    anyOf: [
      {
        $ref: "#"
      },
      {
        $ref: "#/definitions/schemaArray"
      }
    ],
    default: !0
  },
  maxItems: {
    $ref: "#/definitions/nonNegativeInteger"
  },
  minItems: {
    $ref: "#/definitions/nonNegativeIntegerDefault0"
  },
  uniqueItems: {
    type: "boolean",
    default: !1
  },
  contains: {
    $ref: "#"
  },
  maxProperties: {
    $ref: "#/definitions/nonNegativeInteger"
  },
  minProperties: {
    $ref: "#/definitions/nonNegativeIntegerDefault0"
  },
  required: {
    $ref: "#/definitions/stringArray"
  },
  additionalProperties: {
    $ref: "#"
  },
  definitions: {
    type: "object",
    additionalProperties: {
      $ref: "#"
    },
    default: {}
  },
  properties: {
    type: "object",
    additionalProperties: {
      $ref: "#"
    },
    default: {}
  },
  patternProperties: {
    type: "object",
    additionalProperties: {
      $ref: "#"
    },
    propertyNames: {
      format: "regex"
    },
    default: {}
  },
  dependencies: {
    type: "object",
    additionalProperties: {
      anyOf: [
        {
          $ref: "#"
        },
        {
          $ref: "#/definitions/stringArray"
        }
      ]
    }
  },
  propertyNames: {
    $ref: "#"
  },
  const: !0,
  enum: {
    type: "array",
    items: !0,
    minItems: 1,
    uniqueItems: !0
  },
  type: {
    anyOf: [
      {
        $ref: "#/definitions/simpleTypes"
      },
      {
        type: "array",
        items: {
          $ref: "#/definitions/simpleTypes"
        },
        minItems: 1,
        uniqueItems: !0
      }
    ]
  },
  format: {
    type: "string"
  },
  contentMediaType: {
    type: "string"
  },
  contentEncoding: {
    type: "string"
  },
  if: {
    $ref: "#"
  },
  then: {
    $ref: "#"
  },
  else: {
    $ref: "#"
  },
  allOf: {
    $ref: "#/definitions/schemaArray"
  },
  anyOf: {
    $ref: "#/definitions/schemaArray"
  },
  oneOf: {
    $ref: "#/definitions/schemaArray"
  },
  not: {
    $ref: "#"
  }
}, Ixe = {
  $schema: Sxe,
  $id: Axe,
  title: wxe,
  definitions: Pxe,
  type: kxe,
  properties: Oxe,
  default: !0
};
(function(e, t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.MissingRefError = t.ValidationError = t.CodeGen = t.Name = t.nil = t.stringify = t.str = t._ = t.KeywordCxt = t.Ajv = void 0;
  const n = J9, r = f2, i = U2, o = Ixe, s = ["/properties"], a = "http://json-schema.org/draft-07/schema";
  class u extends n.default {
    _addVocabularies() {
      super._addVocabularies(), r.default.forEach((v) => this.addVocabulary(v)), this.opts.discriminator && this.addKeyword(i.default);
    }
    _addDefaultMetaSchema() {
      if (super._addDefaultMetaSchema(), !this.opts.meta)
        return;
      const v = this.opts.$data ? this.$dataMetaSchema(o, s) : o;
      this.addMetaSchema(v, a, !1), this.refs["http://json-schema.org/schema"] = a;
    }
    defaultMeta() {
      return this.opts.defaultMeta = super.defaultMeta() || (this.getSchema(a) ? a : void 0);
    }
  }
  t.Ajv = u, e.exports = t = u, e.exports.Ajv = u, Object.defineProperty(t, "__esModule", { value: !0 }), t.default = u;
  var c = Na;
  Object.defineProperty(t, "KeywordCxt", { enumerable: !0, get: function() {
    return c.KeywordCxt;
  } });
  var d = $n;
  Object.defineProperty(t, "_", { enumerable: !0, get: function() {
    return d._;
  } }), Object.defineProperty(t, "str", { enumerable: !0, get: function() {
    return d.str;
  } }), Object.defineProperty(t, "stringify", { enumerable: !0, get: function() {
    return d.stringify;
  } }), Object.defineProperty(t, "nil", { enumerable: !0, get: function() {
    return d.nil;
  } }), Object.defineProperty(t, "Name", { enumerable: !0, get: function() {
    return d.Name;
  } }), Object.defineProperty(t, "CodeGen", { enumerable: !0, get: function() {
    return d.CodeGen;
  } });
  var f = a2();
  Object.defineProperty(t, "ValidationError", { enumerable: !0, get: function() {
    return f.default;
  } });
  var h = Gm;
  Object.defineProperty(t, "MissingRefError", { enumerable: !0, get: function() {
    return h.default;
  } });
})(CP, CP.exports);
var W2 = CP.exports;
const Fxe = /* @__PURE__ */ Ln(W2);
var IP = { exports: {} }, q7 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.formatNames = e.fastFormats = e.fullFormats = void 0;
  function t(B, H) {
    return { validate: B, compare: H };
  }
  e.fullFormats = {
    // date: http://tools.ietf.org/html/rfc3339#section-5.6
    date: t(o, s),
    // date-time: http://tools.ietf.org/html/rfc3339#section-5.6
    time: t(u, c),
    "date-time": t(f, h),
    // duration: https://tools.ietf.org/html/rfc3339#appendix-A
    duration: /^P(?!$)((\d+Y)?(\d+M)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+S)?)?|(\d+W)?)$/,
    uri: x,
    "uri-reference": /^(?:[a-z][a-z0-9+\-.]*:)?(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'"()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?(?:\?(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i,
    // uri-template: https://tools.ietf.org/html/rfc6570
    "uri-template": /^(?:(?:[^\x00-\x20"'<>%\\^`{|}]|%[0-9a-f]{2})|\{[+#./;?&=,!@|]?(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?(?:,(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?)*\})*$/i,
    // For the source: https://gist.github.com/dperini/729294
    // For test cases: https://mathiasbynens.be/demo/url-regex
    url: /^(?:https?|ftp):\/\/(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z0-9\u{00a1}-\u{ffff}]+-)*[a-z0-9\u{00a1}-\u{ffff}]+)(?:\.(?:[a-z0-9\u{00a1}-\u{ffff}]+-)*[a-z0-9\u{00a1}-\u{ffff}]+)*(?:\.(?:[a-z\u{00a1}-\u{ffff}]{2,})))(?::\d{2,5})?(?:\/[^\s]*)?$/iu,
    email: /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i,
    hostname: /^(?=.{1,253}\.?$)[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[-0-9a-z]{0,61}[0-9a-z])?)*\.?$/i,
    // optimized https://www.safaribooksonline.com/library/view/regular-expressions-cookbook/9780596802837/ch07s16.html
    ipv4: /^(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)$/,
    ipv6: /^((([0-9a-f]{1,4}:){7}([0-9a-f]{1,4}|:))|(([0-9a-f]{1,4}:){6}(:[0-9a-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9a-f]{1,4}:){5}(((:[0-9a-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9a-f]{1,4}:){4}(((:[0-9a-f]{1,4}){1,3})|((:[0-9a-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9a-f]{1,4}:){3}(((:[0-9a-f]{1,4}){1,4})|((:[0-9a-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9a-f]{1,4}:){2}(((:[0-9a-f]{1,4}){1,5})|((:[0-9a-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9a-f]{1,4}:){1}(((:[0-9a-f]{1,4}){1,6})|((:[0-9a-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9a-f]{1,4}){1,7})|((:[0-9a-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))$/i,
    regex: L,
    // uuid: http://tools.ietf.org/html/rfc4122
    uuid: /^(?:urn:uuid:)?[0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12}$/i,
    // JSON-pointer: https://tools.ietf.org/html/rfc6901
    // uri fragment: https://tools.ietf.org/html/rfc3986#appendix-A
    "json-pointer": /^(?:\/(?:[^~/]|~0|~1)*)*$/,
    "json-pointer-uri-fragment": /^#(?:\/(?:[a-z0-9_\-.!$&'()*+,;:=@]|%[0-9a-f]{2}|~0|~1)*)*$/i,
    // relative JSON-pointer: http://tools.ietf.org/html/draft-luff-relative-json-pointer-00
    "relative-json-pointer": /^(?:0|[1-9][0-9]*)(?:#|(?:\/(?:[^~/]|~0|~1)*)*)$/,
    // the following formats are used by the openapi specification: https://spec.openapis.org/oas/v3.0.0#data-types
    // byte: https://github.com/miguelmota/is-base64
    byte: E,
    // signed 32 bit integer
    int32: { type: "number", validate: O },
    // signed 64 bit integer
    int64: { type: "number", validate: A },
    // C-type float
    float: { type: "number", validate: I },
    // C-type double
    double: { type: "number", validate: I },
    // hint to the UI to hide input strings
    password: !0,
    // unchecked string payload
    binary: !0
  }, e.fastFormats = {
    ...e.fullFormats,
    date: t(/^\d\d\d\d-[0-1]\d-[0-3]\d$/, s),
    time: t(/^(?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d(?::?\d\d)?)?$/i, c),
    "date-time": t(/^\d\d\d\d-[0-1]\d-[0-3]\d[t\s](?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d(?::?\d\d)?)$/i, h),
    // uri: https://github.com/mafintosh/is-my-json-valid/blob/master/formats.js
    uri: /^(?:[a-z][a-z0-9+\-.]*:)(?:\/?\/)?[^\s]*$/i,
    "uri-reference": /^(?:(?:[a-z][a-z0-9+\-.]*:)?\/?\/)?(?:[^\\\s#][^\s#]*)?(?:#[^\\\s]*)?$/i,
    // email (sources from jsen validator):
    // http://stackoverflow.com/questions/201323/using-a-regular-expression-to-validate-an-email-address#answer-8829363
    // http://www.w3.org/TR/html5/forms.html#valid-e-mail-address (search for 'wilful violation')
    email: /^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)*$/i
  }, e.formatNames = Object.keys(e.fullFormats);
  function n(B) {
    return B % 4 === 0 && (B % 100 !== 0 || B % 400 === 0);
  }
  const r = /^(\d\d\d\d)-(\d\d)-(\d\d)$/, i = [0, 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  function o(B) {
    const H = r.exec(B);
    if (!H)
      return !1;
    const q = +H[1], J = +H[2], X = +H[3];
    return J >= 1 && J <= 12 && X >= 1 && X <= (J === 2 && n(q) ? 29 : i[J]);
  }
  function s(B, H) {
    if (B && H)
      return B > H ? 1 : B < H ? -1 : 0;
  }
  const a = /^(\d\d):(\d\d):(\d\d)(\.\d+)?(z|[+-]\d\d(?::?\d\d)?)?$/i;
  function u(B, H) {
    const q = a.exec(B);
    if (!q)
      return !1;
    const J = +q[1], X = +q[2], j = +q[3], U = q[5];
    return (J <= 23 && X <= 59 && j <= 59 || J === 23 && X === 59 && j === 60) && (!H || U !== "");
  }
  function c(B, H) {
    if (!(B && H))
      return;
    const q = a.exec(B), J = a.exec(H);
    if (q && J)
      return B = q[1] + q[2] + q[3] + (q[4] || ""), H = J[1] + J[2] + J[3] + (J[4] || ""), B > H ? 1 : B < H ? -1 : 0;
  }
  const d = /t|\s/i;
  function f(B) {
    const H = B.split(d);
    return H.length === 2 && o(H[0]) && u(H[1], !0);
  }
  function h(B, H) {
    if (!(B && H))
      return;
    const [q, J] = B.split(d), [X, j] = H.split(d), U = s(q, X);
    if (U !== void 0)
      return U || c(J, j);
  }
  const m = /\/|:/, v = /^(?:[a-z][a-z0-9+\-.]*:)(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)(?:\?(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i;
  function x(B) {
    return m.test(B) && v.test(B);
  }
  const C = /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/gm;
  function E(B) {
    return C.lastIndex = 0, C.test(B);
  }
  const S = -(2 ** 31), w = 2 ** 31 - 1;
  function O(B) {
    return Number.isInteger(B) && B <= w && B >= S;
  }
  function A(B) {
    return Number.isInteger(B);
  }
  function I() {
    return !0;
  }
  const $ = /[^\\]\\Z/;
  function L(B) {
    if ($.test(B))
      return !1;
    try {
      return new RegExp(B), !0;
    } catch {
      return !1;
    }
  }
})(q7);
var G7 = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.formatLimitDefinition = void 0;
  const t = W2, n = $n, r = n.operators, i = {
    formatMaximum: { okStr: "<=", ok: r.LTE, fail: r.GT },
    formatMinimum: { okStr: ">=", ok: r.GTE, fail: r.LT },
    formatExclusiveMaximum: { okStr: "<", ok: r.LT, fail: r.GTE },
    formatExclusiveMinimum: { okStr: ">", ok: r.GT, fail: r.LTE }
  }, o = {
    message: ({ keyword: a, schemaCode: u }) => n.str`should be ${i[a].okStr} ${u}`,
    params: ({ keyword: a, schemaCode: u }) => n._`{comparison: ${i[a].okStr}, limit: ${u}}`
  };
  e.formatLimitDefinition = {
    keyword: Object.keys(i),
    type: "string",
    schemaType: "string",
    $data: !0,
    error: o,
    code(a) {
      const { gen: u, data: c, schemaCode: d, keyword: f, it: h } = a, { opts: m, self: v } = h;
      if (!m.validateFormats)
        return;
      const x = new t.KeywordCxt(h, v.RULES.all.format.definition, "format");
      x.$data ? C() : E();
      function C() {
        const w = u.scopeValue("formats", {
          ref: v.formats,
          code: m.code.formats
        }), O = u.const("fmt", n._`${w}[${x.schemaCode}]`);
        a.fail$data(n.or(n._`typeof ${O} != "object"`, n._`${O} instanceof RegExp`, n._`typeof ${O}.compare != "function"`, S(O)));
      }
      function E() {
        const w = x.schema, O = v.formats[w];
        if (!O || O === !0)
          return;
        if (typeof O != "object" || O instanceof RegExp || typeof O.compare != "function")
          throw new Error(`"${f}": format "${w}" does not define "compare" function`);
        const A = u.scopeValue("formats", {
          key: w,
          ref: O,
          code: m.code.formats ? n._`${m.code.formats}${n.getProperty(w)}` : void 0
        });
        a.fail$data(S(A));
      }
      function S(w) {
        return n._`${w}.compare(${c}, ${d}) ${i[f].fail} 0`;
      }
    },
    dependencies: ["format"]
  };
  const s = (a) => (a.addKeyword(e.formatLimitDefinition), a);
  e.default = s;
})(G7);
(function(e, t) {
  Object.defineProperty(t, "__esModule", { value: !0 });
  const n = q7, r = G7, i = $n, o = new i.Name("fullFormats"), s = new i.Name("fastFormats"), a = (c, d = { keywords: !0 }) => {
    if (Array.isArray(d))
      return u(c, d, n.fullFormats, o), c;
    const [f, h] = d.mode === "fast" ? [n.fastFormats, s] : [n.fullFormats, o], m = d.formats || n.formatNames;
    return u(c, m, f, h), d.keywords && r.default(c), c;
  };
  a.get = (c, d = "full") => {
    const h = (d === "fast" ? n.fastFormats : n.fullFormats)[c];
    if (!h)
      throw new Error(`Unknown format "${c}"`);
    return h;
  };
  function u(c, d, f, h) {
    var m, v;
    (m = (v = c.opts.code).formats) !== null && m !== void 0 || (v.formats = i._`require("ajv-formats/dist/formats").${h}`);
    for (const x of d)
      c.addFormat(x, f[x]);
  }
  e.exports = t = a, Object.defineProperty(t, "__esModule", { value: !0 }), t.default = a;
})(IP, IP.exports);
var $xe = IP.exports;
const Nxe = /* @__PURE__ */ Ln($xe);
function Mxe(e) {
  return function(t, n, r) {
    for (var i = -1, o = Object(t), s = r(t), a = s.length; a--; ) {
      var u = s[e ? a : ++i];
      if (n(o[u], u, o) === !1)
        break;
    }
    return t;
  };
}
var Rxe = Mxe, _xe = Rxe, Lxe = _xe(), Y7 = Lxe, Bxe = Y7, jxe = yc;
function Vxe(e, t) {
  return e && Bxe(e, t, jxe);
}
var zxe = Vxe, Uxe = gc;
function Wxe(e, t) {
  return function(n, r) {
    if (n == null)
      return n;
    if (!Uxe(n))
      return e(n, r);
    for (var i = n.length, o = t ? i : -1, s = Object(n); (t ? o-- : ++o < i) && r(s[o], o, s) !== !1; )
      ;
    return n;
  };
}
var Hxe = Wxe, qxe = zxe, Gxe = Hxe, Yxe = Gxe(qxe), Pb = Yxe, Kxe = Pb;
function Jxe(e, t) {
  var n = [];
  return Kxe(e, function(r, i, o) {
    t(r, i, o) && n.push(r);
  }), n;
}
var Xxe = Jxe, Qxe = j9, Zxe = Xxe, eDe = bc, tDe = yi;
function nDe(e, t) {
  var n = tDe(e) ? Qxe : Zxe;
  return n(e, eDe(t));
}
var rDe = nDe;
const uL = /* @__PURE__ */ Ln(rDe);
var iDe = XO;
function oDe(e, t) {
  return iDe(e, t);
}
var sDe = oDe;
const K7 = /* @__PURE__ */ Ln(sDe);
var aDe = uf, lDe = function() {
  try {
    var e = aDe(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), J7 = lDe, cL = J7;
function uDe(e, t, n) {
  t == "__proto__" && cL ? cL(e, t, {
    configurable: !0,
    enumerable: !0,
    value: n,
    writable: !0
  }) : e[t] = n;
}
var H2 = uDe, cDe = H2, dDe = Tb;
function pDe(e, t, n) {
  (n !== void 0 && !dDe(e[t], n) || n === void 0 && !(t in e)) && cDe(e, t, n);
}
var X7 = pDe, ID = { exports: {} };
ID.exports;
(function(e, t) {
  var n = cs, r = t && !t.nodeType && t, i = r && !0 && e && !e.nodeType && e, o = i && i.exports === r, s = o ? n.Buffer : void 0, a = s ? s.allocUnsafe : void 0;
  function u(c, d) {
    if (d)
      return c.slice();
    var f = c.length, h = a ? a(f) : new c.constructor(f);
    return c.copy(h), h;
  }
  e.exports = u;
})(ID, ID.exports);
var Q7 = ID.exports, dL = _9;
function fDe(e) {
  var t = new e.constructor(e.byteLength);
  return new dL(t).set(new dL(e)), t;
}
var q2 = fDe, hDe = q2;
function mDe(e, t) {
  var n = t ? hDe(e.buffer) : e.buffer;
  return new e.constructor(n, e.byteOffset, e.length);
}
var Z7 = mDe;
function gDe(e, t) {
  var n = -1, r = e.length;
  for (t || (t = Array(r)); ++n < r; )
    t[n] = e[n];
  return t;
}
var kb = gDe, yDe = la, pL = Object.create, bDe = /* @__PURE__ */ function() {
  function e() {
  }
  return function(t) {
    if (!yDe(t))
      return {};
    if (pL)
      return pL(t);
    e.prototype = t;
    var n = new e();
    return e.prototype = void 0, n;
  };
}(), aE = bDe, vDe = Y6, xDe = vDe(Object.getPrototypeOf, Object), G2 = xDe, DDe = aE, CDe = G2, EDe = WC;
function TDe(e) {
  return typeof e.constructor == "function" && !EDe(e) ? DDe(CDe(e)) : {};
}
var eV = TDe, SDe = gc, ADe = ua;
function wDe(e) {
  return ADe(e) && SDe(e);
}
var tV = wDe, PDe = Cd, kDe = G2, ODe = ua, IDe = "[object Object]", FDe = Function.prototype, $De = Object.prototype, nV = FDe.toString, NDe = $De.hasOwnProperty, MDe = nV.call(Object);
function RDe(e) {
  if (!ODe(e) || PDe(e) != IDe)
    return !1;
  var t = kDe(e);
  if (t === null)
    return !0;
  var n = NDe.call(t, "constructor") && t.constructor;
  return typeof n == "function" && n instanceof n && nV.call(n) == MDe;
}
var Y2 = RDe;
function _De(e, t) {
  if (!(t === "constructor" && typeof e[t] == "function") && t != "__proto__")
    return e[t];
}
var rV = _De, LDe = H2, BDe = Tb, jDe = Object.prototype, VDe = jDe.hasOwnProperty;
function zDe(e, t, n) {
  var r = e[t];
  (!(VDe.call(e, t) && BDe(r, n)) || n === void 0 && !(t in e)) && LDe(e, t, n);
}
var K2 = zDe, UDe = K2, WDe = H2;
function HDe(e, t, n, r) {
  var i = !n;
  n || (n = {});
  for (var o = -1, s = t.length; ++o < s; ) {
    var a = t[o], u = r ? r(n[a], e[a], a, n, e) : void 0;
    u === void 0 && (u = e[a]), i ? WDe(n, a, u) : UDe(n, a, u);
  }
  return n;
}
var Jm = HDe;
function qDe(e) {
  var t = [];
  if (e != null)
    for (var n in Object(e))
      t.push(n);
  return t;
}
var GDe = qDe, YDe = la, KDe = WC, JDe = GDe, XDe = Object.prototype, QDe = XDe.hasOwnProperty;
function ZDe(e) {
  if (!YDe(e))
    return JDe(e);
  var t = KDe(e), n = [];
  for (var r in e)
    r == "constructor" && (t || !QDe.call(e, r)) || n.push(r);
  return n;
}
var eCe = ZDe, tCe = A9, nCe = eCe, rCe = gc;
function iCe(e) {
  return rCe(e) ? tCe(e, !0) : nCe(e);
}
var Ob = iCe, oCe = Jm, sCe = Ob;
function aCe(e) {
  return oCe(e, sCe(e));
}
var lCe = aCe, fL = X7, uCe = Q7, cCe = Z7, dCe = kb, pCe = eV, hL = xb, mL = yi, fCe = tV, hCe = Db, mCe = HC, gCe = la, yCe = Y2, bCe = qC, gL = rV, vCe = lCe;
function xCe(e, t, n, r, i, o, s) {
  var a = gL(e, n), u = gL(t, n), c = s.get(u);
  if (c) {
    fL(e, n, c);
    return;
  }
  var d = o ? o(a, u, n + "", e, t, s) : void 0, f = d === void 0;
  if (f) {
    var h = mL(u), m = !h && hCe(u), v = !h && !m && bCe(u);
    d = u, h || m || v ? mL(a) ? d = a : fCe(a) ? d = dCe(a) : m ? (f = !1, d = uCe(u, !0)) : v ? (f = !1, d = cCe(u, !0)) : d = [] : yCe(u) || hL(u) ? (d = a, hL(a) ? d = vCe(a) : (!gCe(a) || mCe(a)) && (d = pCe(u))) : f = !1;
  }
  f && (s.set(u, d), i(d, u, r, o, s), s.delete(u)), fL(e, n, d);
}
var DCe = xCe, CCe = QC, ECe = X7, TCe = Y7, SCe = DCe, ACe = la, wCe = Ob, PCe = rV;
function iV(e, t, n, r, i) {
  e !== t && TCe(t, function(o, s) {
    if (i || (i = new CCe()), ACe(o))
      SCe(e, t, s, n, iV, r, i);
    else {
      var a = r ? r(PCe(e, s), o, s + "", e, t, i) : void 0;
      a === void 0 && (a = o), ECe(e, s, a);
    }
  }, wCe);
}
var kCe = iV;
function OCe(e, t, n) {
  switch (n.length) {
    case 0:
      return e.call(t);
    case 1:
      return e.call(t, n[0]);
    case 2:
      return e.call(t, n[0], n[1]);
    case 3:
      return e.call(t, n[0], n[1], n[2]);
  }
  return e.apply(t, n);
}
var J2 = OCe, ICe = J2, yL = Math.max;
function FCe(e, t, n) {
  return t = yL(t === void 0 ? e.length - 1 : t, 0), function() {
    for (var r = arguments, i = -1, o = yL(r.length - t, 0), s = Array(o); ++i < o; )
      s[i] = r[t + i];
    i = -1;
    for (var a = Array(t + 1); ++i < t; )
      a[i] = r[i];
    return a[t] = n(s), ICe(e, this, a);
  };
}
var oV = FCe;
function $Ce(e) {
  return function() {
    return e;
  };
}
var NCe = $Ce, MCe = NCe, bL = J7, RCe = ZC, _Ce = bL ? function(e, t) {
  return bL(e, "toString", {
    configurable: !0,
    enumerable: !1,
    value: MCe(t),
    writable: !0
  });
} : RCe, LCe = _Ce, BCe = 800, jCe = 16, VCe = Date.now;
function zCe(e) {
  var t = 0, n = 0;
  return function() {
    var r = VCe(), i = jCe - (r - n);
    if (n = r, i > 0) {
      if (++t >= BCe)
        return arguments[0];
    } else
      t = 0;
    return e.apply(void 0, arguments);
  };
}
var sV = zCe, UCe = LCe, WCe = sV, HCe = WCe(UCe), X2 = HCe, qCe = ZC, GCe = oV, YCe = X2;
function KCe(e, t) {
  return YCe(GCe(e, t, qCe), e + "");
}
var aV = KCe, JCe = aV, XCe = GC;
function QCe(e) {
  return JCe(function(t, n) {
    var r = -1, i = n.length, o = i > 1 ? n[i - 1] : void 0, s = i > 2 ? n[2] : void 0;
    for (o = e.length > 3 && typeof o == "function" ? (i--, o) : void 0, s && XCe(n[0], n[1], s) && (o = i < 3 ? void 0 : o, i = 1), t = Object(t); ++r < i; ) {
      var a = n[r];
      a && e(t, a, r, o);
    }
    return t;
  });
}
var ZCe = QCe, eEe = kCe, tEe = ZCe, nEe = tEe(function(e, t, n) {
  eEe(e, t, n);
}), rEe = nEe;
const qn = /* @__PURE__ */ Ln(rEe);
function iEe(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length; ++n < r && t(e[n], n, e) !== !1; )
    ;
  return e;
}
var Q2 = iEe, oEe = Jm, sEe = yc;
function aEe(e, t) {
  return e && oEe(t, sEe(t), e);
}
var lV = aEe, lEe = Jm, uEe = Ob;
function cEe(e, t) {
  return e && lEe(t, uEe(t), e);
}
var dEe = cEe, pEe = Jm, fEe = JO;
function hEe(e, t) {
  return pEe(e, fEe(e), t);
}
var mEe = hEe, gEe = KO, yEe = G2, bEe = JO, vEe = V9, xEe = Object.getOwnPropertySymbols, DEe = xEe ? function(e) {
  for (var t = []; e; )
    gEe(t, bEe(e)), e = yEe(e);
  return t;
} : vEe, uV = DEe, CEe = Jm, EEe = uV;
function TEe(e, t) {
  return CEe(e, EEe(e), t);
}
var SEe = TEe, AEe = B9, wEe = uV, PEe = Ob;
function kEe(e) {
  return AEe(e, PEe, wEe);
}
var cV = kEe, OEe = Object.prototype, IEe = OEe.hasOwnProperty;
function FEe(e) {
  var t = e.length, n = new e.constructor(t);
  return t && typeof e[0] == "string" && IEe.call(e, "index") && (n.index = e.index, n.input = e.input), n;
}
var $Ee = FEe, NEe = q2;
function MEe(e, t) {
  var n = t ? NEe(e.buffer) : e.buffer;
  return new e.constructor(n, e.byteOffset, e.byteLength);
}
var REe = MEe, _Ee = /\w*$/;
function LEe(e) {
  var t = new e.constructor(e.source, _Ee.exec(e));
  return t.lastIndex = e.lastIndex, t;
}
var BEe = LEe, vL = Lm, xL = vL ? vL.prototype : void 0, DL = xL ? xL.valueOf : void 0;
function jEe(e) {
  return DL ? Object(DL.call(e)) : {};
}
var VEe = jEe, zEe = q2, UEe = REe, WEe = BEe, HEe = VEe, qEe = Z7, GEe = "[object Boolean]", YEe = "[object Date]", KEe = "[object Map]", JEe = "[object Number]", XEe = "[object RegExp]", QEe = "[object Set]", ZEe = "[object String]", eTe = "[object Symbol]", tTe = "[object ArrayBuffer]", nTe = "[object DataView]", rTe = "[object Float32Array]", iTe = "[object Float64Array]", oTe = "[object Int8Array]", sTe = "[object Int16Array]", aTe = "[object Int32Array]", lTe = "[object Uint8Array]", uTe = "[object Uint8ClampedArray]", cTe = "[object Uint16Array]", dTe = "[object Uint32Array]";
function pTe(e, t, n) {
  var r = e.constructor;
  switch (t) {
    case tTe:
      return zEe(e);
    case GEe:
    case YEe:
      return new r(+e);
    case nTe:
      return UEe(e, n);
    case rTe:
    case iTe:
    case oTe:
    case sTe:
    case aTe:
    case lTe:
    case uTe:
    case cTe:
    case dTe:
      return qEe(e, n);
    case KEe:
      return new r();
    case JEe:
    case ZEe:
      return new r(e);
    case XEe:
      return WEe(e);
    case QEe:
      return new r();
    case eTe:
      return HEe(e);
  }
}
var fTe = pTe, hTe = cf, mTe = ua, gTe = "[object Map]";
function yTe(e) {
  return mTe(e) && hTe(e) == gTe;
}
var bTe = yTe, vTe = bTe, xTe = VO, CL = zO, EL = CL && CL.isMap, DTe = EL ? xTe(EL) : vTe, CTe = DTe, ETe = cf, TTe = ua, STe = "[object Set]";
function ATe(e) {
  return TTe(e) && ETe(e) == STe;
}
var wTe = ATe, PTe = wTe, kTe = VO, TL = zO, SL = TL && TL.isSet, OTe = SL ? kTe(SL) : PTe, ITe = OTe, FTe = QC, $Te = Q2, NTe = K2, MTe = lV, RTe = dEe, _Te = Q7, LTe = kb, BTe = mEe, jTe = SEe, VTe = z9, zTe = cV, UTe = cf, WTe = $Ee, HTe = fTe, qTe = eV, GTe = yi, YTe = Db, KTe = CTe, JTe = la, XTe = ITe, QTe = yc, ZTe = Ob, eSe = 1, tSe = 2, nSe = 4, dV = "[object Arguments]", rSe = "[object Array]", iSe = "[object Boolean]", oSe = "[object Date]", sSe = "[object Error]", pV = "[object Function]", aSe = "[object GeneratorFunction]", lSe = "[object Map]", uSe = "[object Number]", fV = "[object Object]", cSe = "[object RegExp]", dSe = "[object Set]", pSe = "[object String]", fSe = "[object Symbol]", hSe = "[object WeakMap]", mSe = "[object ArrayBuffer]", gSe = "[object DataView]", ySe = "[object Float32Array]", bSe = "[object Float64Array]", vSe = "[object Int8Array]", xSe = "[object Int16Array]", DSe = "[object Int32Array]", CSe = "[object Uint8Array]", ESe = "[object Uint8ClampedArray]", TSe = "[object Uint16Array]", SSe = "[object Uint32Array]", jr = {};
jr[dV] = jr[rSe] = jr[mSe] = jr[gSe] = jr[iSe] = jr[oSe] = jr[ySe] = jr[bSe] = jr[vSe] = jr[xSe] = jr[DSe] = jr[lSe] = jr[uSe] = jr[fV] = jr[cSe] = jr[dSe] = jr[pSe] = jr[fSe] = jr[CSe] = jr[ESe] = jr[TSe] = jr[SSe] = !0;
jr[sSe] = jr[pV] = jr[hSe] = !1;
function zx(e, t, n, r, i, o) {
  var s, a = t & eSe, u = t & tSe, c = t & nSe;
  if (n && (s = i ? n(e, r, i, o) : n(e)), s !== void 0)
    return s;
  if (!JTe(e))
    return e;
  var d = GTe(e);
  if (d) {
    if (s = WTe(e), !a)
      return LTe(e, s);
  } else {
    var f = UTe(e), h = f == pV || f == aSe;
    if (YTe(e))
      return _Te(e, a);
    if (f == fV || f == dV || h && !i) {
      if (s = u || h ? {} : qTe(e), !a)
        return u ? jTe(e, RTe(s, e)) : BTe(e, MTe(s, e));
    } else {
      if (!jr[f])
        return i ? e : {};
      s = HTe(e, f, a);
    }
  }
  o || (o = new FTe());
  var m = o.get(e);
  if (m)
    return m;
  o.set(e, s), XTe(e) ? e.forEach(function(C) {
    s.add(zx(C, t, n, C, e, o));
  }) : KTe(e) && e.forEach(function(C, E) {
    s.set(E, zx(C, t, n, E, e, o));
  });
  var v = c ? u ? zTe : VTe : u ? ZTe : QTe, x = d ? void 0 : v(e);
  return $Te(x || e, function(C, E) {
    x && (E = C, C = e[E]), NTe(s, E, zx(C, t, n, E, e, o));
  }), s;
}
var lE = zx, ASe = lE, wSe = 1, PSe = 4;
function kSe(e) {
  return ASe(e, wSe | PSe);
}
var OSe = kSe;
const FD = /* @__PURE__ */ Ln(OSe);
var hV = {};
(function(e) {
  e.aliasToReal = {
    // Lodash aliases.
    each: "forEach",
    eachRight: "forEachRight",
    entries: "toPairs",
    entriesIn: "toPairsIn",
    extend: "assignIn",
    extendAll: "assignInAll",
    extendAllWith: "assignInAllWith",
    extendWith: "assignInWith",
    first: "head",
    // Methods that are curried variants of others.
    conforms: "conformsTo",
    matches: "isMatch",
    property: "get",
    // Ramda aliases.
    __: "placeholder",
    F: "stubFalse",
    T: "stubTrue",
    all: "every",
    allPass: "overEvery",
    always: "constant",
    any: "some",
    anyPass: "overSome",
    apply: "spread",
    assoc: "set",
    assocPath: "set",
    complement: "negate",
    compose: "flowRight",
    contains: "includes",
    dissoc: "unset",
    dissocPath: "unset",
    dropLast: "dropRight",
    dropLastWhile: "dropRightWhile",
    equals: "isEqual",
    identical: "eq",
    indexBy: "keyBy",
    init: "initial",
    invertObj: "invert",
    juxt: "over",
    omitAll: "omit",
    nAry: "ary",
    path: "get",
    pathEq: "matchesProperty",
    pathOr: "getOr",
    paths: "at",
    pickAll: "pick",
    pipe: "flow",
    pluck: "map",
    prop: "get",
    propEq: "matchesProperty",
    propOr: "getOr",
    props: "at",
    symmetricDifference: "xor",
    symmetricDifferenceBy: "xorBy",
    symmetricDifferenceWith: "xorWith",
    takeLast: "takeRight",
    takeLastWhile: "takeRightWhile",
    unapply: "rest",
    unnest: "flatten",
    useWith: "overArgs",
    where: "conformsTo",
    whereEq: "isMatch",
    zipObj: "zipObject"
  }, e.aryMethod = {
    1: [
      "assignAll",
      "assignInAll",
      "attempt",
      "castArray",
      "ceil",
      "create",
      "curry",
      "curryRight",
      "defaultsAll",
      "defaultsDeepAll",
      "floor",
      "flow",
      "flowRight",
      "fromPairs",
      "invert",
      "iteratee",
      "memoize",
      "method",
      "mergeAll",
      "methodOf",
      "mixin",
      "nthArg",
      "over",
      "overEvery",
      "overSome",
      "rest",
      "reverse",
      "round",
      "runInContext",
      "spread",
      "template",
      "trim",
      "trimEnd",
      "trimStart",
      "uniqueId",
      "words",
      "zipAll"
    ],
    2: [
      "add",
      "after",
      "ary",
      "assign",
      "assignAllWith",
      "assignIn",
      "assignInAllWith",
      "at",
      "before",
      "bind",
      "bindAll",
      "bindKey",
      "chunk",
      "cloneDeepWith",
      "cloneWith",
      "concat",
      "conformsTo",
      "countBy",
      "curryN",
      "curryRightN",
      "debounce",
      "defaults",
      "defaultsDeep",
      "defaultTo",
      "delay",
      "difference",
      "divide",
      "drop",
      "dropRight",
      "dropRightWhile",
      "dropWhile",
      "endsWith",
      "eq",
      "every",
      "filter",
      "find",
      "findIndex",
      "findKey",
      "findLast",
      "findLastIndex",
      "findLastKey",
      "flatMap",
      "flatMapDeep",
      "flattenDepth",
      "forEach",
      "forEachRight",
      "forIn",
      "forInRight",
      "forOwn",
      "forOwnRight",
      "get",
      "groupBy",
      "gt",
      "gte",
      "has",
      "hasIn",
      "includes",
      "indexOf",
      "intersection",
      "invertBy",
      "invoke",
      "invokeMap",
      "isEqual",
      "isMatch",
      "join",
      "keyBy",
      "lastIndexOf",
      "lt",
      "lte",
      "map",
      "mapKeys",
      "mapValues",
      "matchesProperty",
      "maxBy",
      "meanBy",
      "merge",
      "mergeAllWith",
      "minBy",
      "multiply",
      "nth",
      "omit",
      "omitBy",
      "overArgs",
      "pad",
      "padEnd",
      "padStart",
      "parseInt",
      "partial",
      "partialRight",
      "partition",
      "pick",
      "pickBy",
      "propertyOf",
      "pull",
      "pullAll",
      "pullAt",
      "random",
      "range",
      "rangeRight",
      "rearg",
      "reject",
      "remove",
      "repeat",
      "restFrom",
      "result",
      "sampleSize",
      "some",
      "sortBy",
      "sortedIndex",
      "sortedIndexOf",
      "sortedLastIndex",
      "sortedLastIndexOf",
      "sortedUniqBy",
      "split",
      "spreadFrom",
      "startsWith",
      "subtract",
      "sumBy",
      "take",
      "takeRight",
      "takeRightWhile",
      "takeWhile",
      "tap",
      "throttle",
      "thru",
      "times",
      "trimChars",
      "trimCharsEnd",
      "trimCharsStart",
      "truncate",
      "union",
      "uniqBy",
      "uniqWith",
      "unset",
      "unzipWith",
      "without",
      "wrap",
      "xor",
      "zip",
      "zipObject",
      "zipObjectDeep"
    ],
    3: [
      "assignInWith",
      "assignWith",
      "clamp",
      "differenceBy",
      "differenceWith",
      "findFrom",
      "findIndexFrom",
      "findLastFrom",
      "findLastIndexFrom",
      "getOr",
      "includesFrom",
      "indexOfFrom",
      "inRange",
      "intersectionBy",
      "intersectionWith",
      "invokeArgs",
      "invokeArgsMap",
      "isEqualWith",
      "isMatchWith",
      "flatMapDepth",
      "lastIndexOfFrom",
      "mergeWith",
      "orderBy",
      "padChars",
      "padCharsEnd",
      "padCharsStart",
      "pullAllBy",
      "pullAllWith",
      "rangeStep",
      "rangeStepRight",
      "reduce",
      "reduceRight",
      "replace",
      "set",
      "slice",
      "sortedIndexBy",
      "sortedLastIndexBy",
      "transform",
      "unionBy",
      "unionWith",
      "update",
      "xorBy",
      "xorWith",
      "zipWith"
    ],
    4: [
      "fill",
      "setWith",
      "updateWith"
    ]
  }, e.aryRearg = {
    2: [1, 0],
    3: [2, 0, 1],
    4: [3, 2, 0, 1]
  }, e.iterateeAry = {
    dropRightWhile: 1,
    dropWhile: 1,
    every: 1,
    filter: 1,
    find: 1,
    findFrom: 1,
    findIndex: 1,
    findIndexFrom: 1,
    findKey: 1,
    findLast: 1,
    findLastFrom: 1,
    findLastIndex: 1,
    findLastIndexFrom: 1,
    findLastKey: 1,
    flatMap: 1,
    flatMapDeep: 1,
    flatMapDepth: 1,
    forEach: 1,
    forEachRight: 1,
    forIn: 1,
    forInRight: 1,
    forOwn: 1,
    forOwnRight: 1,
    map: 1,
    mapKeys: 1,
    mapValues: 1,
    partition: 1,
    reduce: 2,
    reduceRight: 2,
    reject: 1,
    remove: 1,
    some: 1,
    takeRightWhile: 1,
    takeWhile: 1,
    times: 1,
    transform: 2
  }, e.iterateeRearg = {
    mapKeys: [1],
    reduceRight: [1, 0]
  }, e.methodRearg = {
    assignInAllWith: [1, 0],
    assignInWith: [1, 2, 0],
    assignAllWith: [1, 0],
    assignWith: [1, 2, 0],
    differenceBy: [1, 2, 0],
    differenceWith: [1, 2, 0],
    getOr: [2, 1, 0],
    intersectionBy: [1, 2, 0],
    intersectionWith: [1, 2, 0],
    isEqualWith: [1, 2, 0],
    isMatchWith: [2, 1, 0],
    mergeAllWith: [1, 0],
    mergeWith: [1, 2, 0],
    padChars: [2, 1, 0],
    padCharsEnd: [2, 1, 0],
    padCharsStart: [2, 1, 0],
    pullAllBy: [2, 1, 0],
    pullAllWith: [2, 1, 0],
    rangeStep: [1, 2, 0],
    rangeStepRight: [1, 2, 0],
    setWith: [3, 1, 2, 0],
    sortedIndexBy: [2, 1, 0],
    sortedLastIndexBy: [2, 1, 0],
    unionBy: [1, 2, 0],
    unionWith: [1, 2, 0],
    updateWith: [3, 1, 2, 0],
    xorBy: [1, 2, 0],
    xorWith: [1, 2, 0],
    zipWith: [1, 2, 0]
  }, e.methodSpread = {
    assignAll: { start: 0 },
    assignAllWith: { start: 0 },
    assignInAll: { start: 0 },
    assignInAllWith: { start: 0 },
    defaultsAll: { start: 0 },
    defaultsDeepAll: { start: 0 },
    invokeArgs: { start: 2 },
    invokeArgsMap: { start: 2 },
    mergeAll: { start: 0 },
    mergeAllWith: { start: 0 },
    partial: { start: 1 },
    partialRight: { start: 1 },
    without: { start: 1 },
    zipAll: { start: 0 }
  }, e.mutate = {
    array: {
      fill: !0,
      pull: !0,
      pullAll: !0,
      pullAllBy: !0,
      pullAllWith: !0,
      pullAt: !0,
      remove: !0,
      reverse: !0
    },
    object: {
      assign: !0,
      assignAll: !0,
      assignAllWith: !0,
      assignIn: !0,
      assignInAll: !0,
      assignInAllWith: !0,
      assignInWith: !0,
      assignWith: !0,
      defaults: !0,
      defaultsAll: !0,
      defaultsDeep: !0,
      defaultsDeepAll: !0,
      merge: !0,
      mergeAll: !0,
      mergeAllWith: !0,
      mergeWith: !0
    },
    set: {
      set: !0,
      setWith: !0,
      unset: !0,
      update: !0,
      updateWith: !0
    }
  }, e.realToAlias = function() {
    var t = Object.prototype.hasOwnProperty, n = e.aliasToReal, r = {};
    for (var i in n) {
      var o = n[i];
      t.call(r, o) ? r[o].push(i) : r[o] = [i];
    }
    return r;
  }(), e.remap = {
    assignAll: "assign",
    assignAllWith: "assignWith",
    assignInAll: "assignIn",
    assignInAllWith: "assignInWith",
    curryN: "curry",
    curryRightN: "curryRight",
    defaultsAll: "defaults",
    defaultsDeepAll: "defaultsDeep",
    findFrom: "find",
    findIndexFrom: "findIndex",
    findLastFrom: "findLast",
    findLastIndexFrom: "findLastIndex",
    getOr: "get",
    includesFrom: "includes",
    indexOfFrom: "indexOf",
    invokeArgs: "invoke",
    invokeArgsMap: "invokeMap",
    lastIndexOfFrom: "lastIndexOf",
    mergeAll: "merge",
    mergeAllWith: "mergeWith",
    padChars: "pad",
    padCharsEnd: "padEnd",
    padCharsStart: "padStart",
    propertyOf: "get",
    rangeStep: "range",
    rangeStepRight: "rangeRight",
    restFrom: "rest",
    spreadFrom: "spread",
    trimChars: "trim",
    trimCharsEnd: "trimEnd",
    trimCharsStart: "trimStart",
    zipAll: "zip"
  }, e.skipFixed = {
    castArray: !0,
    flow: !0,
    flowRight: !0,
    iteratee: !0,
    mixin: !0,
    rearg: !0,
    runInContext: !0
  }, e.skipRearg = {
    add: !0,
    assign: !0,
    assignIn: !0,
    bind: !0,
    bindKey: !0,
    concat: !0,
    difference: !0,
    divide: !0,
    eq: !0,
    gt: !0,
    gte: !0,
    isEqual: !0,
    lt: !0,
    lte: !0,
    matchesProperty: !0,
    merge: !0,
    multiply: !0,
    overArgs: !0,
    partial: !0,
    partialRight: !0,
    propertyOf: !0,
    random: !0,
    range: !0,
    rangeRight: !0,
    subtract: !0,
    zip: !0,
    zipObject: !0,
    zipObjectDeep: !0
  };
})(hV);
var bA, AL;
function Ib() {
  return AL || (AL = 1, bA = {}), bA;
}
var Li = hV, ISe = Ib(), wL = Array.prototype.push;
function FSe(e, t) {
  return t == 2 ? function(n, r) {
    return e.apply(void 0, arguments);
  } : function(n) {
    return e.apply(void 0, arguments);
  };
}
function vA(e, t) {
  return t == 2 ? function(n, r) {
    return e(n, r);
  } : function(n) {
    return e(n);
  };
}
function PL(e) {
  for (var t = e ? e.length : 0, n = Array(t); t--; )
    n[t] = e[t];
  return n;
}
function $Se(e) {
  return function(t) {
    return e({}, t);
  };
}
function NSe(e, t) {
  return function() {
    for (var n = arguments.length, r = n - 1, i = Array(n); n--; )
      i[n] = arguments[n];
    var o = i[t], s = i.slice(0, t);
    return o && wL.apply(s, o), t != r && wL.apply(s, i.slice(t + 1)), e.apply(this, s);
  };
}
function xA(e, t) {
  return function() {
    var n = arguments.length;
    if (n) {
      for (var r = Array(n); n--; )
        r[n] = arguments[n];
      var i = r[0] = t.apply(void 0, r);
      return e.apply(void 0, r), i;
    }
  };
}
function FP(e, t, n, r) {
  var i = typeof t == "function", o = t === Object(t);
  if (o && (r = n, n = t, t = void 0), n == null)
    throw new TypeError();
  r || (r = {});
  var s = {
    cap: "cap" in r ? r.cap : !0,
    curry: "curry" in r ? r.curry : !0,
    fixed: "fixed" in r ? r.fixed : !0,
    immutable: "immutable" in r ? r.immutable : !0,
    rearg: "rearg" in r ? r.rearg : !0
  }, a = i ? n : ISe, u = "curry" in r && r.curry, c = "fixed" in r && r.fixed, d = "rearg" in r && r.rearg, f = i ? n.runInContext() : void 0, h = i ? n : {
    ary: e.ary,
    assign: e.assign,
    clone: e.clone,
    curry: e.curry,
    forEach: e.forEach,
    isArray: e.isArray,
    isError: e.isError,
    isFunction: e.isFunction,
    isWeakMap: e.isWeakMap,
    iteratee: e.iteratee,
    keys: e.keys,
    rearg: e.rearg,
    toInteger: e.toInteger,
    toPath: e.toPath
  }, m = h.ary, v = h.assign, x = h.clone, C = h.curry, E = h.forEach, S = h.isArray, w = h.isError, O = h.isFunction, A = h.isWeakMap, I = h.keys, $ = h.rearg, L = h.toInteger, B = h.toPath, H = I(Li.aryMethod), q = {
    castArray: function(W) {
      return function() {
        var Q = arguments[0];
        return S(Q) ? W(PL(Q)) : W.apply(void 0, arguments);
      };
    },
    iteratee: function(W) {
      return function() {
        var Q = arguments[0], oe = arguments[1], ae = W(Q, oe), pe = ae.length;
        return s.cap && typeof oe == "number" ? (oe = oe > 2 ? oe - 2 : 1, pe && pe <= oe ? ae : vA(ae, oe)) : ae;
      };
    },
    mixin: function(W) {
      return function(Q) {
        var oe = this;
        if (!O(oe))
          return W(oe, Object(Q));
        var ae = [];
        return E(I(Q), function(pe) {
          O(Q[pe]) && ae.push([pe, oe.prototype[pe]]);
        }), W(oe, Object(Q)), E(ae, function(pe) {
          var me = pe[1];
          O(me) ? oe.prototype[pe[0]] = me : delete oe.prototype[pe[0]];
        }), oe;
      };
    },
    nthArg: function(W) {
      return function(Q) {
        var oe = Q < 0 ? 1 : L(Q) + 1;
        return C(W(Q), oe);
      };
    },
    rearg: function(W) {
      return function(Q, oe) {
        var ae = oe ? oe.length : 0;
        return C(W(Q, oe), ae);
      };
    },
    runInContext: function(W) {
      return function(Q) {
        return FP(e, W(Q), r);
      };
    }
  };
  function J(W, Q) {
    if (s.cap) {
      var oe = Li.iterateeRearg[W];
      if (oe)
        return M(Q, oe);
      var ae = !i && Li.iterateeAry[W];
      if (ae)
        return te(Q, ae);
    }
    return Q;
  }
  function X(W, Q, oe) {
    return u || s.curry && oe > 1 ? C(Q, oe) : Q;
  }
  function j(W, Q, oe) {
    if (s.fixed && (c || !Li.skipFixed[W])) {
      var ae = Li.methodSpread[W], pe = ae && ae.start;
      return pe === void 0 ? m(Q, oe) : NSe(Q, pe);
    }
    return Q;
  }
  function U(W, Q, oe) {
    return s.rearg && oe > 1 && (d || !Li.skipRearg[W]) ? $(Q, Li.methodRearg[W] || Li.aryRearg[oe]) : Q;
  }
  function G(W, Q) {
    Q = B(Q);
    for (var oe = -1, ae = Q.length, pe = ae - 1, me = x(Object(W)), xe = me; xe != null && ++oe < ae; ) {
      var le = Q[oe], ye = xe[le];
      ye != null && !(O(ye) || w(ye) || A(ye)) && (xe[le] = x(oe == pe ? ye : Object(ye))), xe = xe[le];
    }
    return me;
  }
  function K(W) {
    return R.runInContext.convert(W)(void 0);
  }
  function ee(W, Q) {
    var oe = Li.aliasToReal[W] || W, ae = Li.remap[oe] || oe, pe = r;
    return function(me) {
      var xe = i ? f : h, le = i ? f[ae] : Q, ye = v(v({}, pe), me);
      return FP(xe, oe, le, ye);
    };
  }
  function te(W, Q) {
    return Z(W, function(oe) {
      return typeof oe == "function" ? vA(oe, Q) : oe;
    });
  }
  function M(W, Q) {
    return Z(W, function(oe) {
      var ae = Q.length;
      return FSe($(vA(oe, ae), Q), ae);
    });
  }
  function Z(W, Q) {
    return function() {
      var oe = arguments.length;
      if (!oe)
        return W();
      for (var ae = Array(oe); oe--; )
        ae[oe] = arguments[oe];
      var pe = s.rearg ? 0 : oe - 1;
      return ae[pe] = Q(ae[pe]), W.apply(void 0, ae);
    };
  }
  function ne(W, Q, oe) {
    var ae, pe = Li.aliasToReal[W] || W, me = Q, xe = q[pe];
    return xe ? me = xe(Q) : s.immutable && (Li.mutate.array[pe] ? me = xA(Q, PL) : Li.mutate.object[pe] ? me = xA(Q, $Se(Q)) : Li.mutate.set[pe] && (me = xA(Q, G))), E(H, function(le) {
      return E(Li.aryMethod[le], function(ye) {
        if (pe == ye) {
          var be = Li.methodSpread[pe], Re = be && be.afterRearg;
          return ae = Re ? j(pe, U(pe, me, le), le) : U(pe, j(pe, me, le), le), ae = J(pe, ae), ae = X(pe, ae, le), !1;
        }
      }), !ae;
    }), ae || (ae = me), ae == Q && (ae = u ? C(ae, 1) : function() {
      return Q.apply(this, arguments);
    }), ae.convert = ee(pe, Q), ae.placeholder = Q.placeholder = oe, ae;
  }
  if (!o)
    return ne(t, n, a);
  var R = n, _ = [];
  return E(H, function(W) {
    E(Li.aryMethod[W], function(Q) {
      var oe = R[Li.remap[Q] || Q];
      oe && _.push([Q, ne(Q, oe, R)]);
    });
  }), E(I(R), function(W) {
    var Q = R[W];
    if (typeof Q == "function") {
      for (var oe = _.length; oe--; )
        if (_[oe][0] == W)
          return;
      Q.convert = ee(W, Q), _.push([W, Q]);
    }
  }), E(_, function(W) {
    R[W[0]] = W[1];
  }), R.convert = K, R.placeholder = R, E(I(R), function(W) {
    E(Li.realToAlias[W] || [], function(Q) {
      R[Q] = R[W];
    });
  }), R;
}
var MSe = FP, kL = Z6, RSe = kL && new kL(), mV = RSe, _Se = ZC, OL = mV, LSe = OL ? function(e, t) {
  return OL.set(e, t), e;
} : _Se, gV = LSe, BSe = aE, jSe = la;
function VSe(e) {
  return function() {
    var t = arguments;
    switch (t.length) {
      case 0:
        return new e();
      case 1:
        return new e(t[0]);
      case 2:
        return new e(t[0], t[1]);
      case 3:
        return new e(t[0], t[1], t[2]);
      case 4:
        return new e(t[0], t[1], t[2], t[3]);
      case 5:
        return new e(t[0], t[1], t[2], t[3], t[4]);
      case 6:
        return new e(t[0], t[1], t[2], t[3], t[4], t[5]);
      case 7:
        return new e(t[0], t[1], t[2], t[3], t[4], t[5], t[6]);
    }
    var n = BSe(e.prototype), r = e.apply(n, t);
    return jSe(r) ? r : n;
  };
}
var uE = VSe, zSe = uE, USe = cs, WSe = 1;
function HSe(e, t, n) {
  var r = t & WSe, i = zSe(e);
  function o() {
    var s = this && this !== USe && this instanceof o ? i : e;
    return s.apply(r ? n : this, arguments);
  }
  return o;
}
var qSe = HSe, GSe = Math.max;
function YSe(e, t, n, r) {
  for (var i = -1, o = e.length, s = n.length, a = -1, u = t.length, c = GSe(o - s, 0), d = Array(u + c), f = !r; ++a < u; )
    d[a] = t[a];
  for (; ++i < s; )
    (f || i < o) && (d[n[i]] = e[i]);
  for (; c--; )
    d[a++] = e[i++];
  return d;
}
var yV = YSe, KSe = Math.max;
function JSe(e, t, n, r) {
  for (var i = -1, o = e.length, s = -1, a = n.length, u = -1, c = t.length, d = KSe(o - a, 0), f = Array(d + c), h = !r; ++i < d; )
    f[i] = e[i];
  for (var m = i; ++u < c; )
    f[m + u] = t[u];
  for (; ++s < a; )
    (h || i < o) && (f[m + n[s]] = e[i++]);
  return f;
}
var bV = JSe;
function XSe(e, t) {
  for (var n = e.length, r = 0; n--; )
    e[n] === t && ++r;
  return r;
}
var QSe = XSe;
function ZSe() {
}
var Z2 = ZSe, eAe = aE, tAe = Z2, nAe = 4294967295;
function $D(e) {
  this.__wrapped__ = e, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = nAe, this.__views__ = [];
}
$D.prototype = eAe(tAe.prototype);
$D.prototype.constructor = $D;
var eI = $D;
function rAe() {
}
var vV = rAe, IL = mV, iAe = vV, oAe = IL ? function(e) {
  return IL.get(e);
} : iAe, xV = oAe, sAe = {}, aAe = sAe, FL = aAe, lAe = Object.prototype, uAe = lAe.hasOwnProperty;
function cAe(e) {
  for (var t = e.name + "", n = FL[t], r = uAe.call(FL, t) ? n.length : 0; r--; ) {
    var i = n[r], o = i.func;
    if (o == null || o == e)
      return i.name;
  }
  return t;
}
var dAe = cAe, pAe = aE, fAe = Z2;
function ND(e, t) {
  this.__wrapped__ = e, this.__actions__ = [], this.__chain__ = !!t, this.__index__ = 0, this.__values__ = void 0;
}
ND.prototype = pAe(fAe.prototype);
ND.prototype.constructor = ND;
var DV = ND, hAe = eI, mAe = DV, gAe = kb;
function yAe(e) {
  if (e instanceof hAe)
    return e.clone();
  var t = new mAe(e.__wrapped__, e.__chain__);
  return t.__actions__ = gAe(e.__actions__), t.__index__ = e.__index__, t.__values__ = e.__values__, t;
}
var bAe = yAe, vAe = eI, $L = DV, xAe = Z2, DAe = yi, CAe = ua, EAe = bAe, TAe = Object.prototype, SAe = TAe.hasOwnProperty;
function MD(e) {
  if (CAe(e) && !DAe(e) && !(e instanceof vAe)) {
    if (e instanceof $L)
      return e;
    if (SAe.call(e, "__wrapped__"))
      return EAe(e);
  }
  return new $L(e);
}
MD.prototype = xAe.prototype;
MD.prototype.constructor = MD;
var AAe = MD, wAe = eI, PAe = xV, kAe = dAe, OAe = AAe;
function IAe(e) {
  var t = kAe(e), n = OAe[t];
  if (typeof n != "function" || !(t in wAe.prototype))
    return !1;
  if (e === n)
    return !0;
  var r = PAe(n);
  return !!r && e === r[0];
}
var FAe = IAe, $Ae = gV, NAe = sV, MAe = NAe($Ae), CV = MAe, RAe = /\{\n\/\* \[wrapped with (.+)\] \*/, _Ae = /,? & /;
function LAe(e) {
  var t = e.match(RAe);
  return t ? t[1].split(_Ae) : [];
}
var BAe = LAe, jAe = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;
function VAe(e, t) {
  var n = t.length;
  if (!n)
    return e;
  var r = n - 1;
  return t[r] = (n > 1 ? "& " : "") + t[r], t = t.join(n > 2 ? ", " : " "), e.replace(jAe, `{
/* [wrapped with ` + t + `] */
`);
}
var zAe = VAe, UAe = Y9;
function WAe(e, t) {
  var n = e == null ? 0 : e.length;
  return !!n && UAe(e, t, 0) > -1;
}
var EV = WAe, HAe = Q2, qAe = EV, GAe = 1, YAe = 2, KAe = 8, JAe = 16, XAe = 32, QAe = 64, ZAe = 128, ewe = 256, twe = 512, nwe = [
  ["ary", ZAe],
  ["bind", GAe],
  ["bindKey", YAe],
  ["curry", KAe],
  ["curryRight", JAe],
  ["flip", twe],
  ["partial", XAe],
  ["partialRight", QAe],
  ["rearg", ewe]
];
function rwe(e, t) {
  return HAe(nwe, function(n) {
    var r = "_." + n[0];
    t & n[1] && !qAe(e, r) && e.push(r);
  }), e.sort();
}
var iwe = rwe, owe = BAe, swe = zAe, awe = X2, lwe = iwe;
function uwe(e, t, n) {
  var r = t + "";
  return awe(e, swe(r, lwe(owe(r), n)));
}
var TV = uwe, cwe = FAe, dwe = CV, pwe = TV, fwe = 1, hwe = 2, mwe = 4, gwe = 8, NL = 32, ML = 64;
function ywe(e, t, n, r, i, o, s, a, u, c) {
  var d = t & gwe, f = d ? s : void 0, h = d ? void 0 : s, m = d ? o : void 0, v = d ? void 0 : o;
  t |= d ? NL : ML, t &= ~(d ? ML : NL), t & mwe || (t &= ~(fwe | hwe));
  var x = [
    e,
    t,
    i,
    m,
    f,
    v,
    h,
    a,
    u,
    c
  ], C = n.apply(void 0, x);
  return cwe(e) && dwe(C, x), C.placeholder = r, pwe(C, e, t);
}
var SV = ywe;
function bwe(e) {
  var t = e;
  return t.placeholder;
}
var AV = bwe, vwe = kb, xwe = Eb, Dwe = Math.min;
function Cwe(e, t) {
  for (var n = e.length, r = Dwe(t.length, n), i = vwe(e); r--; ) {
    var o = t[r];
    e[r] = xwe(o, n) ? i[o] : void 0;
  }
  return e;
}
var Ewe = Cwe, RL = "__lodash_placeholder__";
function Twe(e, t) {
  for (var n = -1, r = e.length, i = 0, o = []; ++n < r; ) {
    var s = e[n];
    (s === t || s === RL) && (e[n] = RL, o[i++] = n);
  }
  return o;
}
var tI = Twe, Swe = yV, Awe = bV, wwe = QSe, _L = uE, Pwe = SV, kwe = AV, Owe = Ewe, Iwe = tI, Fwe = cs, $we = 1, Nwe = 2, Mwe = 8, Rwe = 16, _we = 128, Lwe = 512;
function wV(e, t, n, r, i, o, s, a, u, c) {
  var d = t & _we, f = t & $we, h = t & Nwe, m = t & (Mwe | Rwe), v = t & Lwe, x = h ? void 0 : _L(e);
  function C() {
    for (var E = arguments.length, S = Array(E), w = E; w--; )
      S[w] = arguments[w];
    if (m)
      var O = kwe(C), A = wwe(S, O);
    if (r && (S = Swe(S, r, i, m)), o && (S = Awe(S, o, s, m)), E -= A, m && E < c) {
      var I = Iwe(S, O);
      return Pwe(
        e,
        t,
        wV,
        C.placeholder,
        n,
        S,
        I,
        a,
        u,
        c - E
      );
    }
    var $ = f ? n : this, L = h ? $[e] : e;
    return E = S.length, a ? S = Owe(S, a) : v && E > 1 && S.reverse(), d && u < E && (S.length = u), this && this !== Fwe && this instanceof C && (L = x || _L(L)), L.apply($, S);
  }
  return C;
}
var PV = wV, Bwe = J2, jwe = uE, Vwe = PV, zwe = SV, Uwe = AV, Wwe = tI, Hwe = cs;
function qwe(e, t, n) {
  var r = jwe(e);
  function i() {
    for (var o = arguments.length, s = Array(o), a = o, u = Uwe(i); a--; )
      s[a] = arguments[a];
    var c = o < 3 && s[0] !== u && s[o - 1] !== u ? [] : Wwe(s, u);
    if (o -= c.length, o < n)
      return zwe(
        e,
        t,
        Vwe,
        i.placeholder,
        void 0,
        s,
        c,
        void 0,
        void 0,
        n - o
      );
    var d = this && this !== Hwe && this instanceof i ? r : e;
    return Bwe(d, this, s);
  }
  return i;
}
var Gwe = qwe, Ywe = J2, Kwe = uE, Jwe = cs, Xwe = 1;
function Qwe(e, t, n, r) {
  var i = t & Xwe, o = Kwe(e);
  function s() {
    for (var a = -1, u = arguments.length, c = -1, d = r.length, f = Array(d + u), h = this && this !== Jwe && this instanceof s ? o : e; ++c < d; )
      f[c] = r[c];
    for (; u--; )
      f[c++] = arguments[++a];
    return Ywe(h, i ? n : this, f);
  }
  return s;
}
var Zwe = Qwe, ePe = yV, tPe = bV, LL = tI, BL = "__lodash_placeholder__", DA = 1, nPe = 2, rPe = 4, jL = 8, Cy = 128, VL = 256, iPe = Math.min;
function oPe(e, t) {
  var n = e[1], r = t[1], i = n | r, o = i < (DA | nPe | Cy), s = r == Cy && n == jL || r == Cy && n == VL && e[7].length <= t[8] || r == (Cy | VL) && t[7].length <= t[8] && n == jL;
  if (!(o || s))
    return e;
  r & DA && (e[2] = t[2], i |= n & DA ? 0 : rPe);
  var a = t[3];
  if (a) {
    var u = e[3];
    e[3] = u ? ePe(u, a, t[4]) : a, e[4] = u ? LL(e[3], BL) : t[4];
  }
  return a = t[5], a && (u = e[5], e[5] = u ? tPe(u, a, t[6]) : a, e[6] = u ? LL(e[5], BL) : t[6]), a = t[7], a && (e[7] = a), r & Cy && (e[8] = e[8] == null ? t[8] : iPe(e[8], t[8])), e[9] == null && (e[9] = t[9]), e[0] = t[0], e[1] = i, e;
}
var sPe = oPe, aPe = gV, lPe = qSe, uPe = Gwe, cPe = PV, dPe = Zwe, pPe = xV, fPe = sPe, hPe = CV, mPe = TV, zL = eE, gPe = "Expected a function", UL = 1, yPe = 2, CA = 8, EA = 16, TA = 32, WL = 64, HL = Math.max;
function bPe(e, t, n, r, i, o, s, a) {
  var u = t & yPe;
  if (!u && typeof e != "function")
    throw new TypeError(gPe);
  var c = r ? r.length : 0;
  if (c || (t &= ~(TA | WL), r = i = void 0), s = s === void 0 ? s : HL(zL(s), 0), a = a === void 0 ? a : zL(a), c -= i ? i.length : 0, t & WL) {
    var d = r, f = i;
    r = i = void 0;
  }
  var h = u ? void 0 : pPe(e), m = [
    e,
    t,
    n,
    r,
    i,
    d,
    f,
    o,
    s,
    a
  ];
  if (h && fPe(m, h), e = m[0], t = m[1], n = m[2], r = m[3], i = m[4], a = m[9] = m[9] === void 0 ? u ? 0 : e.length : HL(m[9] - c, 0), !a && t & (CA | EA) && (t &= ~(CA | EA)), !t || t == UL)
    var v = lPe(e, t, n);
  else t == CA || t == EA ? v = uPe(e, t, a) : (t == TA || t == (UL | TA)) && !i.length ? v = dPe(e, t, n, r) : v = cPe.apply(void 0, m);
  var x = h ? aPe : hPe;
  return mPe(x(v, m), e, t);
}
var nI = bPe, vPe = nI, xPe = 128;
function DPe(e, t, n) {
  return t = n ? void 0 : t, t = e && t == null ? e.length : t, vPe(e, xPe, void 0, void 0, void 0, void 0, t);
}
var CPe = DPe, EPe = lE, TPe = 4;
function SPe(e) {
  return EPe(e, TPe);
}
var APe = SPe, wPe = nI, PPe = 8;
function rI(e, t, n) {
  t = n ? void 0 : t;
  var r = wPe(e, PPe, void 0, void 0, void 0, void 0, void 0, t);
  return r.placeholder = rI.placeholder, r;
}
rI.placeholder = {};
var kPe = rI, OPe = Cd, IPe = ua, FPe = Y2, $Pe = "[object DOMException]", NPe = "[object Error]";
function MPe(e) {
  if (!IPe(e))
    return !1;
  var t = OPe(e);
  return t == NPe || t == $Pe || typeof e.message == "string" && typeof e.name == "string" && !FPe(e);
}
var RPe = MPe, _Pe = cf, LPe = ua, BPe = "[object WeakMap]";
function jPe(e) {
  return LPe(e) && _Pe(e) == BPe;
}
var VPe = jPe, zPe = lE, UPe = bc, WPe = 1;
function HPe(e) {
  return UPe(typeof e == "function" ? e : zPe(e, WPe));
}
var qPe = HPe, qL = Lm, GPe = xb, YPe = yi, GL = qL ? qL.isConcatSpreadable : void 0;
function KPe(e) {
  return YPe(e) || GPe(e) || !!(GL && e && e[GL]);
}
var JPe = KPe, XPe = KO, QPe = JPe;
function kV(e, t, n, r, i) {
  var o = -1, s = e.length;
  for (n || (n = QPe), i || (i = []); ++o < s; ) {
    var a = e[o];
    t > 0 && n(a) ? t > 1 ? kV(a, t - 1, n, r, i) : XPe(i, a) : r || (i[i.length] = a);
  }
  return i;
}
var OV = kV, ZPe = OV;
function eke(e) {
  var t = e == null ? 0 : e.length;
  return t ? ZPe(e, 1) : [];
}
var tke = eke, nke = tke, rke = oV, ike = X2;
function oke(e) {
  return ike(rke(e, void 0, nke), e + "");
}
var IV = oke, ske = nI, ake = IV, lke = 256, uke = ake(function(e, t) {
  return ske(e, lke, void 0, void 0, void 0, t);
}), cke = uke, dke = jm, pke = kb, fke = yi, hke = Vm, mke = O9, gke = df, yke = Cb;
function bke(e) {
  return fke(e) ? dke(e, gke) : hke(e) ? [e] : pke(mke(yke(e)));
}
var vke = bke, xke = {
  ary: CPe,
  assign: lV,
  clone: APe,
  curry: kPe,
  forEach: Q2,
  isArray: yi,
  isError: RPe,
  isFunction: HC,
  isWeakMap: VPe,
  iteratee: qPe,
  keys: LO,
  rearg: cke,
  toInteger: eE,
  toPath: vke
}, Dke = MSe, Cke = xke;
function Eke(e, t, n) {
  return Dke(Cke, e, t, n);
}
var cE = Eke, SA, YL;
function Tke() {
  if (YL) return SA;
  YL = 1;
  var e = K2, t = Ab, n = Eb, r = la, i = df;
  function o(s, a, u, c) {
    if (!r(s))
      return s;
    a = t(a, s);
    for (var d = -1, f = a.length, h = f - 1, m = s; m != null && ++d < f; ) {
      var v = i(a[d]), x = u;
      if (v === "__proto__" || v === "constructor" || v === "prototype")
        return s;
      if (d != h) {
        var C = m[v];
        x = c ? c(C, v, m) : void 0, x === void 0 && (x = r(C) ? C : n(a[d + 1]) ? [] : {});
      }
      e(m, v, x), m = m[v];
    }
    return s;
  }
  return SA = o, SA;
}
var AA, KL;
function Ske() {
  if (KL) return AA;
  KL = 1;
  var e = Tke();
  function t(n, r, i) {
    return n == null ? n : e(n, r, i);
  }
  return AA = t, AA;
}
var Ake = cE, FV = Ake("set", Ske());
FV.placeholder = Ib();
var wke = FV;
const Pke = /* @__PURE__ */ Ln(wke);
function kke(e) {
  var t = e == null ? 0 : e.length;
  return t ? e[t - 1] : void 0;
}
var Oke = kke, Ike = GO, Fke = b9;
function $ke(e, t) {
  return t.length < 2 ? e : Ike(e, Fke(t, 0, -1));
}
var Nke = $ke, Mke = Ab, Rke = Oke, _ke = Nke, Lke = df;
function Bke(e, t) {
  return t = Mke(t, e), e = _ke(e, t), e == null || delete e[Lke(Rke(t))];
}
var $V = Bke, wA, JL;
function jke() {
  if (JL) return wA;
  JL = 1;
  var e = $V;
  function t(n, r) {
    return n == null ? !0 : e(n, r);
  }
  return wA = t, wA;
}
var Vke = cE, NV = Vke("unset", jke());
NV.placeholder = Ib();
var zke = NV;
const Uke = /* @__PURE__ */ Ln(zke);
var RD = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
RD.exports;
(function(e, t) {
  (function() {
    var n, r = "4.17.21", i = 200, o = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", s = "Expected a function", a = "Invalid `variable` option passed into `_.template`", u = "__lodash_hash_undefined__", c = 500, d = "__lodash_placeholder__", f = 1, h = 2, m = 4, v = 1, x = 2, C = 1, E = 2, S = 4, w = 8, O = 16, A = 32, I = 64, $ = 128, L = 256, B = 512, H = 30, q = "...", J = 800, X = 16, j = 1, U = 2, G = 3, K = 1 / 0, ee = 9007199254740991, te = 17976931348623157e292, M = NaN, Z = 4294967295, ne = Z - 1, R = Z >>> 1, _ = [
      ["ary", $],
      ["bind", C],
      ["bindKey", E],
      ["curry", w],
      ["curryRight", O],
      ["flip", B],
      ["partial", A],
      ["partialRight", I],
      ["rearg", L]
    ], W = "[object Arguments]", Q = "[object Array]", oe = "[object AsyncFunction]", ae = "[object Boolean]", pe = "[object Date]", me = "[object DOMException]", xe = "[object Error]", le = "[object Function]", ye = "[object GeneratorFunction]", be = "[object Map]", Re = "[object Number]", Te = "[object Null]", Xe = "[object Object]", Ne = "[object Promise]", Qe = "[object Proxy]", Ee = "[object RegExp]", Ie = "[object Set]", Je = "[object String]", vt = "[object Symbol]", St = "[object Undefined]", Lt = "[object WeakMap]", ke = "[object WeakSet]", Le = "[object ArrayBuffer]", Pe = "[object DataView]", Ae = "[object Float32Array]", We = "[object Float64Array]", At = "[object Int8Array]", Ft = "[object Int16Array]", Ct = "[object Int32Array]", ht = "[object Uint8Array]", He = "[object Uint8ClampedArray]", qe = "[object Uint16Array]", wt = "[object Uint32Array]", Ut = /\b__p \+= '';/g, an = /\b(__p \+=) '' \+/g, wn = /(__e\(.*?\)|\b__t\)) \+\n'';/g, En = /&(?:amp|lt|gt|quot|#39);/g, sr = /[&<>"']/g, er = RegExp(En.source), pn = RegExp(sr.source), Pr = /<%-([\s\S]+?)%>/g, bi = /<%([\s\S]+?)%>/g, Wr = /<%=([\s\S]+?)%>/g, Po = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, _r = /^\w*$/, Lr = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Gn = /[\\^$.*+?()[\]{}|]/g, Hr = RegExp(Gn.source), Qn = /^\s+/, ao = /\s/, Ls = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, Mi = /\{\n\/\* \[wrapped with (.+)\] \*/, ko = /,? & /, ve = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, tt = /[()=,{}\[\]\/\s]/, xt = /\\(\\)?/g, Oe = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, Fe = /\w*$/, et = /^[-+]0x[0-9a-f]+$/i, Ke = /^0b[01]+$/i, ct = /^\[object .+?Constructor\]$/, gt = /^0o[0-7]+$/i, Ht = /^(?:0|[1-9]\d*)$/, Pn = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, tr = /($^)/, Uo = /['\n\r\u2028\u2029\\]/g, Oo = "\\ud800-\\udfff", Ki = "\\u0300-\\u036f", Vd = "\\ufe20-\\ufe2f", $g = "\\u20d0-\\u20ff", Ce = Ki + Vd + $g, Ve = "\\u2700-\\u27bf", pt = "a-z\\xdf-\\xf6\\xf8-\\xff", bt = "\\xac\\xb1\\xd7\\xf7", dt = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", on = "\\u2000-\\u206f", nn = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", ri = "A-Z\\xc0-\\xd6\\xd8-\\xde", lo = "\\ufe0e\\ufe0f", Vf = bt + dt + on + nn, Ng = "['’]", LT = "[" + Oo + "]", Ov = "[" + Vf + "]", zf = "[" + Ce + "]", Iv = "\\d+", Fv = "[" + Ve + "]", $v = "[" + pt + "]", ga = "[^" + Oo + Vf + Iv + Ve + pt + ri + "]", Se = "\\ud83c[\\udffb-\\udfff]", BT = "(?:" + zf + "|" + Se + ")", Mg = "[^" + Oo + "]", Iu = "(?:\\ud83c[\\udde6-\\uddff]){2}", Rg = "[\\ud800-\\udbff][\\udc00-\\udfff]", ya = "[" + ri + "]", ar = "\\u200d", Tn = "(?:" + $v + "|" + ga + ")", Tt = "(?:" + ya + "|" + ga + ")", Uf = "(?:" + Ng + "(?:d|ll|m|re|s|t|ve))?", Oc = "(?:" + Ng + "(?:D|LL|M|RE|S|T|VE))?", tl = BT + "?", Nv = "[" + lo + "]?", Mv = "(?:" + ar + "(?:" + [Mg, Iu, Rg].join("|") + ")" + Nv + tl + ")*", _g = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", zn = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", Ji = Nv + tl + Mv, zd = "(?:" + [Fv, Iu, Rg].join("|") + ")" + Ji, nl = "(?:" + [Mg + zf + "?", zf, Iu, Rg, LT].join("|") + ")", Lg = RegExp(Ng, "g"), Bg = RegExp(zf, "g"), Ud = RegExp(Se + "(?=" + Se + ")|" + nl + Ji, "g"), jg = RegExp([
      ya + "?" + $v + "+" + Uf + "(?=" + [Ov, ya, "$"].join("|") + ")",
      Tt + "+" + Oc + "(?=" + [Ov, ya + Tn, "$"].join("|") + ")",
      ya + "?" + Tn + "+" + Uf,
      ya + "+" + Oc,
      zn,
      _g,
      Iv,
      zd
    ].join("|"), "g"), Vg = RegExp("[" + ar + Oo + Ce + lo + "]"), Kt = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, kn = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ], jT = -1, Qt = {};
    Qt[Ae] = Qt[We] = Qt[At] = Qt[Ft] = Qt[Ct] = Qt[ht] = Qt[He] = Qt[qe] = Qt[wt] = !0, Qt[W] = Qt[Q] = Qt[Le] = Qt[ae] = Qt[Pe] = Qt[pe] = Qt[xe] = Qt[le] = Qt[be] = Qt[Re] = Qt[Xe] = Qt[Ee] = Qt[Ie] = Qt[Je] = Qt[Lt] = !1;
    var kr = {};
    kr[W] = kr[Q] = kr[Le] = kr[Pe] = kr[ae] = kr[pe] = kr[Ae] = kr[We] = kr[At] = kr[Ft] = kr[Ct] = kr[be] = kr[Re] = kr[Xe] = kr[Ee] = kr[Ie] = kr[Je] = kr[vt] = kr[ht] = kr[He] = kr[qe] = kr[wt] = !0, kr[xe] = kr[le] = kr[Lt] = !1;
    var Bs = {
      // Latin-1 Supplement block.
      À: "A",
      Á: "A",
      Â: "A",
      Ã: "A",
      Ä: "A",
      Å: "A",
      à: "a",
      á: "a",
      â: "a",
      ã: "a",
      ä: "a",
      å: "a",
      Ç: "C",
      ç: "c",
      Ð: "D",
      ð: "d",
      È: "E",
      É: "E",
      Ê: "E",
      Ë: "E",
      è: "e",
      é: "e",
      ê: "e",
      ë: "e",
      Ì: "I",
      Í: "I",
      Î: "I",
      Ï: "I",
      ì: "i",
      í: "i",
      î: "i",
      ï: "i",
      Ñ: "N",
      ñ: "n",
      Ò: "O",
      Ó: "O",
      Ô: "O",
      Õ: "O",
      Ö: "O",
      Ø: "O",
      ò: "o",
      ó: "o",
      ô: "o",
      õ: "o",
      ö: "o",
      ø: "o",
      Ù: "U",
      Ú: "U",
      Û: "U",
      Ü: "U",
      ù: "u",
      ú: "u",
      û: "u",
      ü: "u",
      Ý: "Y",
      ý: "y",
      ÿ: "y",
      Æ: "Ae",
      æ: "ae",
      Þ: "Th",
      þ: "th",
      ß: "ss",
      // Latin Extended-A block.
      Ā: "A",
      Ă: "A",
      Ą: "A",
      ā: "a",
      ă: "a",
      ą: "a",
      Ć: "C",
      Ĉ: "C",
      Ċ: "C",
      Č: "C",
      ć: "c",
      ĉ: "c",
      ċ: "c",
      č: "c",
      Ď: "D",
      Đ: "D",
      ď: "d",
      đ: "d",
      Ē: "E",
      Ĕ: "E",
      Ė: "E",
      Ę: "E",
      Ě: "E",
      ē: "e",
      ĕ: "e",
      ė: "e",
      ę: "e",
      ě: "e",
      Ĝ: "G",
      Ğ: "G",
      Ġ: "G",
      Ģ: "G",
      ĝ: "g",
      ğ: "g",
      ġ: "g",
      ģ: "g",
      Ĥ: "H",
      Ħ: "H",
      ĥ: "h",
      ħ: "h",
      Ĩ: "I",
      Ī: "I",
      Ĭ: "I",
      Į: "I",
      İ: "I",
      ĩ: "i",
      ī: "i",
      ĭ: "i",
      į: "i",
      ı: "i",
      Ĵ: "J",
      ĵ: "j",
      Ķ: "K",
      ķ: "k",
      ĸ: "k",
      Ĺ: "L",
      Ļ: "L",
      Ľ: "L",
      Ŀ: "L",
      Ł: "L",
      ĺ: "l",
      ļ: "l",
      ľ: "l",
      ŀ: "l",
      ł: "l",
      Ń: "N",
      Ņ: "N",
      Ň: "N",
      Ŋ: "N",
      ń: "n",
      ņ: "n",
      ň: "n",
      ŋ: "n",
      Ō: "O",
      Ŏ: "O",
      Ő: "O",
      ō: "o",
      ŏ: "o",
      ő: "o",
      Ŕ: "R",
      Ŗ: "R",
      Ř: "R",
      ŕ: "r",
      ŗ: "r",
      ř: "r",
      Ś: "S",
      Ŝ: "S",
      Ş: "S",
      Š: "S",
      ś: "s",
      ŝ: "s",
      ş: "s",
      š: "s",
      Ţ: "T",
      Ť: "T",
      Ŧ: "T",
      ţ: "t",
      ť: "t",
      ŧ: "t",
      Ũ: "U",
      Ū: "U",
      Ŭ: "U",
      Ů: "U",
      Ű: "U",
      Ų: "U",
      ũ: "u",
      ū: "u",
      ŭ: "u",
      ů: "u",
      ű: "u",
      ų: "u",
      Ŵ: "W",
      ŵ: "w",
      Ŷ: "Y",
      ŷ: "y",
      Ÿ: "Y",
      Ź: "Z",
      Ż: "Z",
      Ž: "Z",
      ź: "z",
      ż: "z",
      ž: "z",
      Ĳ: "IJ",
      ĳ: "ij",
      Œ: "Oe",
      œ: "oe",
      ŉ: "'n",
      ſ: "s"
    }, Rv = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }, VT = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    }, zg = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    }, zT = parseFloat, _v = parseInt, Lv = typeof Kr == "object" && Kr && Kr.Object === Object && Kr, Ug = typeof self == "object" && self && self.Object === Object && self, Ri = Lv || Ug || Function("return this")(), Wg = t && !t.nodeType && t, Fu = Wg && !0 && e && !e.nodeType && e, Bv = Fu && Fu.exports === Wg, Hg = Bv && Lv.process, vi = function() {
      try {
        var $e = Fu && Fu.require && Fu.require("util").types;
        return $e || Hg && Hg.binding && Hg.binding("util");
      } catch {
      }
    }(), Wd = vi && vi.isArrayBuffer, jv = vi && vi.isDate, Hd = vi && vi.isMap, ba = vi && vi.isRegExp, Wf = vi && vi.isSet, qg = vi && vi.isTypedArray;
    function Wo($e, Ye, ze) {
      switch (ze.length) {
        case 0:
          return $e.call(Ye);
        case 1:
          return $e.call(Ye, ze[0]);
        case 2:
          return $e.call(Ye, ze[0], ze[1]);
        case 3:
          return $e.call(Ye, ze[0], ze[1], ze[2]);
      }
      return $e.apply(Ye, ze);
    }
    function UT($e, Ye, ze, _t) {
      for (var fn = -1, Yn = $e == null ? 0 : $e.length; ++fn < Yn; ) {
        var xi = $e[fn];
        Ye(_t, xi, ze(xi), $e);
      }
      return _t;
    }
    function Ho($e, Ye) {
      for (var ze = -1, _t = $e == null ? 0 : $e.length; ++ze < _t && Ye($e[ze], ze, $e) !== !1; )
        ;
      return $e;
    }
    function WT($e, Ye) {
      for (var ze = $e == null ? 0 : $e.length; ze-- && Ye($e[ze], ze, $e) !== !1; )
        ;
      return $e;
    }
    function Hf($e, Ye) {
      for (var ze = -1, _t = $e == null ? 0 : $e.length; ++ze < _t; )
        if (!Ye($e[ze], ze, $e))
          return !1;
      return !0;
    }
    function Xi($e, Ye) {
      for (var ze = -1, _t = $e == null ? 0 : $e.length, fn = 0, Yn = []; ++ze < _t; ) {
        var xi = $e[ze];
        Ye(xi, ze, $e) && (Yn[fn++] = xi);
      }
      return Yn;
    }
    function rl($e, Ye) {
      var ze = $e == null ? 0 : $e.length;
      return !!ze && Ic($e, Ye, 0) > -1;
    }
    function qd($e, Ye, ze) {
      for (var _t = -1, fn = $e == null ? 0 : $e.length; ++_t < fn; )
        if (ze(Ye, $e[_t]))
          return !0;
      return !1;
    }
    function Br($e, Ye) {
      for (var ze = -1, _t = $e == null ? 0 : $e.length, fn = Array(_t); ++ze < _t; )
        fn[ze] = Ye($e[ze], ze, $e);
      return fn;
    }
    function Ol($e, Ye) {
      for (var ze = -1, _t = Ye.length, fn = $e.length; ++ze < _t; )
        $e[fn + ze] = Ye[ze];
      return $e;
    }
    function Gg($e, Ye, ze, _t) {
      var fn = -1, Yn = $e == null ? 0 : $e.length;
      for (_t && Yn && (ze = $e[++fn]); ++fn < Yn; )
        ze = Ye(ze, $e[fn], fn, $e);
      return ze;
    }
    function Vv($e, Ye, ze, _t) {
      var fn = $e == null ? 0 : $e.length;
      for (_t && fn && (ze = $e[--fn]); fn--; )
        ze = Ye(ze, $e[fn], fn, $e);
      return ze;
    }
    function qf($e, Ye) {
      for (var ze = -1, _t = $e == null ? 0 : $e.length; ++ze < _t; )
        if (Ye($e[ze], ze, $e))
          return !0;
      return !1;
    }
    var zv = Kg("length");
    function Uv($e) {
      return $e.split("");
    }
    function HT($e) {
      return $e.match(ve) || [];
    }
    function Wv($e, Ye, ze) {
      var _t;
      return ze($e, function(fn, Yn, xi) {
        if (Ye(fn, Yn, xi))
          return _t = Yn, !1;
      }), _t;
    }
    function Gf($e, Ye, ze, _t) {
      for (var fn = $e.length, Yn = ze + (_t ? 1 : -1); _t ? Yn-- : ++Yn < fn; )
        if (Ye($e[Yn], Yn, $e))
          return Yn;
      return -1;
    }
    function Ic($e, Ye, ze) {
      return Ye === Ye ? Fl($e, Ye, ze) : Gf($e, Yf, ze);
    }
    function Yg($e, Ye, ze, _t) {
      for (var fn = ze - 1, Yn = $e.length; ++fn < Yn; )
        if (_t($e[fn], Ye))
          return fn;
      return -1;
    }
    function Yf($e) {
      return $e !== $e;
    }
    function Hv($e, Ye) {
      var ze = $e == null ? 0 : $e.length;
      return ze ? $u($e, Ye) / ze : M;
    }
    function Kg($e) {
      return function(Ye) {
        return Ye == null ? n : Ye[$e];
      };
    }
    function Jg($e) {
      return function(Ye) {
        return $e == null ? n : $e[Ye];
      };
    }
    function Xg($e, Ye, ze, _t, fn) {
      return fn($e, function(Yn, xi, Un) {
        ze = _t ? (_t = !1, Yn) : Ye(ze, Yn, xi, Un);
      }), ze;
    }
    function qT($e, Ye) {
      var ze = $e.length;
      for ($e.sort(Ye); ze--; )
        $e[ze] = $e[ze].value;
      return $e;
    }
    function $u($e, Ye) {
      for (var ze, _t = -1, fn = $e.length; ++_t < fn; ) {
        var Yn = Ye($e[_t]);
        Yn !== n && (ze = ze === n ? Yn : ze + Yn);
      }
      return ze;
    }
    function Nu($e, Ye) {
      for (var ze = -1, _t = Array($e); ++ze < $e; )
        _t[ze] = Ye(ze);
      return _t;
    }
    function GT($e, Ye) {
      return Br(Ye, function(ze) {
        return [ze, $e[ze]];
      });
    }
    function Qg($e) {
      return $e && $e.slice(0, Kd($e) + 1).replace(Qn, "");
    }
    function Qi($e) {
      return function(Ye) {
        return $e(Ye);
      };
    }
    function Mu($e, Ye) {
      return Br(Ye, function(ze) {
        return $e[ze];
      });
    }
    function Ru($e, Ye) {
      return $e.has(Ye);
    }
    function Gd($e, Ye) {
      for (var ze = -1, _t = $e.length; ++ze < _t && Ic(Ye, $e[ze], 0) > -1; )
        ;
      return ze;
    }
    function Zg($e, Ye) {
      for (var ze = $e.length; ze-- && Ic(Ye, $e[ze], 0) > -1; )
        ;
      return ze;
    }
    function YT($e, Ye) {
      for (var ze = $e.length, _t = 0; ze--; )
        $e[ze] === Ye && ++_t;
      return _t;
    }
    var KT = Jg(Bs), JT = Jg(Rv);
    function qv($e) {
      return "\\" + zg[$e];
    }
    function Kf($e, Ye) {
      return $e == null ? n : $e[Ye];
    }
    function _u($e) {
      return Vg.test($e);
    }
    function XT($e) {
      return Kt.test($e);
    }
    function QT($e) {
      for (var Ye, ze = []; !(Ye = $e.next()).done; )
        ze.push(Ye.value);
      return ze;
    }
    function Yd($e) {
      var Ye = -1, ze = Array($e.size);
      return $e.forEach(function(_t, fn) {
        ze[++Ye] = [fn, _t];
      }), ze;
    }
    function ey($e, Ye) {
      return function(ze) {
        return $e(Ye(ze));
      };
    }
    function il($e, Ye) {
      for (var ze = -1, _t = $e.length, fn = 0, Yn = []; ++ze < _t; ) {
        var xi = $e[ze];
        (xi === Ye || xi === d) && ($e[ze] = d, Yn[fn++] = ze);
      }
      return Yn;
    }
    function Il($e) {
      var Ye = -1, ze = Array($e.size);
      return $e.forEach(function(_t) {
        ze[++Ye] = _t;
      }), ze;
    }
    function ZT($e) {
      var Ye = -1, ze = Array($e.size);
      return $e.forEach(function(_t) {
        ze[++Ye] = [_t, _t];
      }), ze;
    }
    function Fl($e, Ye, ze) {
      for (var _t = ze - 1, fn = $e.length; ++_t < fn; )
        if ($e[_t] === Ye)
          return _t;
      return -1;
    }
    function eS($e, Ye, ze) {
      for (var _t = ze + 1; _t--; )
        if ($e[_t] === Ye)
          return _t;
      return _t;
    }
    function Fc($e) {
      return _u($e) ? tS($e) : zv($e);
    }
    function js($e) {
      return _u($e) ? nS($e) : Uv($e);
    }
    function Kd($e) {
      for (var Ye = $e.length; Ye-- && ao.test($e.charAt(Ye)); )
        ;
      return Ye;
    }
    var Gv = Jg(VT);
    function tS($e) {
      for (var Ye = Ud.lastIndex = 0; Ud.test($e); )
        ++Ye;
      return Ye;
    }
    function nS($e) {
      return $e.match(Ud) || [];
    }
    function rS($e) {
      return $e.match(jg) || [];
    }
    var iS = function $e(Ye) {
      Ye = Ye == null ? Ri : Lu.defaults(Ri.Object(), Ye, Lu.pick(Ri, kn));
      var ze = Ye.Array, _t = Ye.Date, fn = Ye.Error, Yn = Ye.Function, xi = Ye.Math, Un = Ye.Object, ty = Ye.RegExp, oS = Ye.String, ds = Ye.TypeError, Jt = ze.prototype, sS = Yn.prototype, Bu = Un.prototype, Jf = Ye["__core-js_shared__"], Xf = sS.toString, fr = Bu.hasOwnProperty, aS = 0, $l = function() {
        var g = /[^.]+$/.exec(Jf && Jf.keys && Jf.keys.IE_PROTO || "");
        return g ? "Symbol(src)_1." + g : "";
      }(), Vs = Bu.toString, $c = Xf.call(Un), lS = Ri._, uS = ty(
        "^" + Xf.call(fr).replace(Gn, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      ), Qf = Bv ? Ye.Buffer : n, Nl = Ye.Symbol, Jd = Ye.Uint8Array, Yv = Qf ? Qf.allocUnsafe : n, Zf = ey(Un.getPrototypeOf, Un), Kv = Un.create, ny = Bu.propertyIsEnumerable, Bt = Jt.splice, Jv = Nl ? Nl.isConcatSpreadable : n, Nc = Nl ? Nl.iterator : n, ju = Nl ? Nl.toStringTag : n, eh = function() {
        try {
          var g = ip(Un, "defineProperty");
          return g({}, "", {}), g;
        } catch {
        }
      }(), cS = Ye.clearTimeout !== Ri.clearTimeout && Ye.clearTimeout, dS = _t && _t.now !== Ri.Date.now && _t.now, Xv = Ye.setTimeout !== Ri.setTimeout && Ye.setTimeout, th = xi.ceil, Xd = xi.floor, nh = Un.getOwnPropertySymbols, pS = Qf ? Qf.isBuffer : n, Qv = Ye.isFinite, ui = Jt.join, Vu = ey(Un.keys, Un), ci = xi.max, _i = xi.min, fS = _t.now, Zv = Ye.parseInt, e1 = xi.random, ry = Jt.reverse, iy = ip(Ye, "DataView"), Qd = ip(Ye, "Map"), Zd = ip(Ye, "Promise"), Mc = ip(Ye, "Set"), ep = ip(Ye, "WeakMap"), zu = ip(Un, "create"), rh = ep && new ep(), Rc = {}, t1 = op(iy), hS = op(Qd), mS = op(Zd), gS = op(Mc), yS = op(ep), ih = Nl ? Nl.prototype : n, ol = ih ? ih.valueOf : n, oy = ih ? ih.toString : n;
      function ue(g) {
        if (di(g) && !Dn(g) && !(g instanceof T)) {
          if (g instanceof b)
            return g;
          if (fr.call(g, "__wrapped__"))
            return aR(g);
        }
        return new b(g);
      }
      var y = /* @__PURE__ */ function() {
        function g() {
        }
        return function(D) {
          if (!oi(D))
            return {};
          if (Kv)
            return Kv(D);
          g.prototype = D;
          var k = new g();
          return g.prototype = n, k;
        };
      }();
      function p() {
      }
      function b(g, D) {
        this.__wrapped__ = g, this.__actions__ = [], this.__chain__ = !!D, this.__index__ = 0, this.__values__ = n;
      }
      ue.templateSettings = {
        /**
         * Used to detect `data` property values to be HTML-escaped.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        escape: Pr,
        /**
         * Used to detect code to be evaluated.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        evaluate: bi,
        /**
         * Used to detect `data` property values to inject.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        interpolate: Wr,
        /**
         * Used to reference the data object in the template text.
         *
         * @memberOf _.templateSettings
         * @type {string}
         */
        variable: "",
        /**
         * Used to import variables into the compiled template.
         *
         * @memberOf _.templateSettings
         * @type {Object}
         */
        imports: {
          /**
           * A reference to the `lodash` function.
           *
           * @memberOf _.templateSettings.imports
           * @type {Function}
           */
          _: ue
        }
      }, ue.prototype = p.prototype, ue.prototype.constructor = ue, b.prototype = y(p.prototype), b.prototype.constructor = b;
      function T(g) {
        this.__wrapped__ = g, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = Z, this.__views__ = [];
      }
      function F() {
        var g = new T(this.__wrapped__);
        return g.__actions__ = ps(this.__actions__), g.__dir__ = this.__dir__, g.__filtered__ = this.__filtered__, g.__iteratees__ = ps(this.__iteratees__), g.__takeCount__ = this.__takeCount__, g.__views__ = ps(this.__views__), g;
      }
      function Y() {
        if (this.__filtered__) {
          var g = new T(this);
          g.__dir__ = -1, g.__filtered__ = !0;
        } else
          g = this.clone(), g.__dir__ *= -1;
        return g;
      }
      function ie() {
        var g = this.__wrapped__.value(), D = this.__dir__, k = Dn(g), z = D < 0, re = k ? g.length : 0, ce = wee(0, re, this.__views__), ge = ce.start, we = ce.end, Me = we - ge, nt = z ? we : ge - 1, rt = this.__iteratees__, ut = rt.length, Nt = 0, Xt = _i(Me, this.__takeCount__);
        if (!k || !z && re == Me && Xt == Me)
          return OM(g, this.__actions__);
        var ln = [];
        e:
          for (; Me-- && Nt < Xt; ) {
            nt += D;
            for (var Mn = -1, un = g[nt]; ++Mn < ut; ) {
              var Wn = rt[Mn], Kn = Wn.iteratee, Hs = Wn.type, Ko = Kn(un);
              if (Hs == U)
                un = Ko;
              else if (!Ko) {
                if (Hs == j)
                  continue e;
                break e;
              }
            }
            ln[Nt++] = un;
          }
        return ln;
      }
      T.prototype = y(p.prototype), T.prototype.constructor = T;
      function de(g) {
        var D = -1, k = g == null ? 0 : g.length;
        for (this.clear(); ++D < k; ) {
          var z = g[D];
          this.set(z[0], z[1]);
        }
      }
      function he() {
        this.__data__ = zu ? zu(null) : {}, this.size = 0;
      }
      function fe(g) {
        var D = this.has(g) && delete this.__data__[g];
        return this.size -= D ? 1 : 0, D;
      }
      function Ze(g) {
        var D = this.__data__;
        if (zu) {
          var k = D[g];
          return k === u ? n : k;
        }
        return fr.call(D, g) ? D[g] : n;
      }
      function Dt(g) {
        var D = this.__data__;
        return zu ? D[g] !== n : fr.call(D, g);
      }
      function $t(g, D) {
        var k = this.__data__;
        return this.size += this.has(g) ? 0 : 1, k[g] = zu && D === n ? u : D, this;
      }
      de.prototype.clear = he, de.prototype.delete = fe, de.prototype.get = Ze, de.prototype.has = Dt, de.prototype.set = $t;
      function It(g) {
        var D = -1, k = g == null ? 0 : g.length;
        for (this.clear(); ++D < k; ) {
          var z = g[D];
          this.set(z[0], z[1]);
        }
      }
      function nr() {
        this.__data__ = [], this.size = 0;
      }
      function Di(g) {
        var D = this.__data__, k = n1(D, g);
        if (k < 0)
          return !1;
        var z = D.length - 1;
        return k == z ? D.pop() : Bt.call(D, k, 1), --this.size, !0;
      }
      function Sr(g) {
        var D = this.__data__, k = n1(D, g);
        return k < 0 ? n : D[k][1];
      }
      function ii(g) {
        return n1(this.__data__, g) > -1;
      }
      function qo(g, D) {
        var k = this.__data__, z = n1(k, g);
        return z < 0 ? (++this.size, k.push([g, D])) : k[z][1] = D, this;
      }
      It.prototype.clear = nr, It.prototype.delete = Di, It.prototype.get = Sr, It.prototype.has = ii, It.prototype.set = qo;
      function zs(g) {
        var D = -1, k = g == null ? 0 : g.length;
        for (this.clear(); ++D < k; ) {
          var z = g[D];
          this.set(z[0], z[1]);
        }
      }
      function sy() {
        this.size = 0, this.__data__ = {
          hash: new de(),
          map: new (Qd || It)(),
          string: new de()
        };
      }
      function wZ(g) {
        var D = h1(this, g).delete(g);
        return this.size -= D ? 1 : 0, D;
      }
      function PZ(g) {
        return h1(this, g).get(g);
      }
      function kZ(g) {
        return h1(this, g).has(g);
      }
      function OZ(g, D) {
        var k = h1(this, g), z = k.size;
        return k.set(g, D), this.size += k.size == z ? 0 : 1, this;
      }
      zs.prototype.clear = sy, zs.prototype.delete = wZ, zs.prototype.get = PZ, zs.prototype.has = kZ, zs.prototype.set = OZ;
      function tp(g) {
        var D = -1, k = g == null ? 0 : g.length;
        for (this.__data__ = new zs(); ++D < k; )
          this.add(g[D]);
      }
      function IZ(g) {
        return this.__data__.set(g, u), this;
      }
      function FZ(g) {
        return this.__data__.has(g);
      }
      tp.prototype.add = tp.prototype.push = IZ, tp.prototype.has = FZ;
      function sl(g) {
        var D = this.__data__ = new It(g);
        this.size = D.size;
      }
      function $Z() {
        this.__data__ = new It(), this.size = 0;
      }
      function NZ(g) {
        var D = this.__data__, k = D.delete(g);
        return this.size = D.size, k;
      }
      function MZ(g) {
        return this.__data__.get(g);
      }
      function RZ(g) {
        return this.__data__.has(g);
      }
      function _Z(g, D) {
        var k = this.__data__;
        if (k instanceof It) {
          var z = k.__data__;
          if (!Qd || z.length < i - 1)
            return z.push([g, D]), this.size = ++k.size, this;
          k = this.__data__ = new zs(z);
        }
        return k.set(g, D), this.size = k.size, this;
      }
      sl.prototype.clear = $Z, sl.prototype.delete = NZ, sl.prototype.get = MZ, sl.prototype.has = RZ, sl.prototype.set = _Z;
      function aM(g, D) {
        var k = Dn(g), z = !k && sp(g), re = !k && !z && Vc(g), ce = !k && !z && !re && lh(g), ge = k || z || re || ce, we = ge ? Nu(g.length, oS) : [], Me = we.length;
        for (var nt in g)
          (D || fr.call(g, nt)) && !(ge && // Safari 9 has enumerable `arguments.length` in strict mode.
          (nt == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
          re && (nt == "offset" || nt == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
          ce && (nt == "buffer" || nt == "byteLength" || nt == "byteOffset") || // Skip index properties.
          qu(nt, Me))) && we.push(nt);
        return we;
      }
      function lM(g) {
        var D = g.length;
        return D ? g[PS(0, D - 1)] : n;
      }
      function LZ(g, D) {
        return m1(ps(g), np(D, 0, g.length));
      }
      function BZ(g) {
        return m1(ps(g));
      }
      function bS(g, D, k) {
        (k !== n && !al(g[D], k) || k === n && !(D in g)) && Uu(g, D, k);
      }
      function ay(g, D, k) {
        var z = g[D];
        (!(fr.call(g, D) && al(z, k)) || k === n && !(D in g)) && Uu(g, D, k);
      }
      function n1(g, D) {
        for (var k = g.length; k--; )
          if (al(g[k][0], D))
            return k;
        return -1;
      }
      function jZ(g, D, k, z) {
        return _c(g, function(re, ce, ge) {
          D(z, re, k(re), ge);
        }), z;
      }
      function uM(g, D) {
        return g && Rl(D, Zi(D), g);
      }
      function VZ(g, D) {
        return g && Rl(D, hs(D), g);
      }
      function Uu(g, D, k) {
        D == "__proto__" && eh ? eh(g, D, {
          configurable: !0,
          enumerable: !0,
          value: k,
          writable: !0
        }) : g[D] = k;
      }
      function vS(g, D) {
        for (var k = -1, z = D.length, re = ze(z), ce = g == null; ++k < z; )
          re[k] = ce ? n : ZS(g, D[k]);
        return re;
      }
      function np(g, D, k) {
        return g === g && (k !== n && (g = g <= k ? g : k), D !== n && (g = g >= D ? g : D)), g;
      }
      function va(g, D, k, z, re, ce) {
        var ge, we = D & f, Me = D & h, nt = D & m;
        if (k && (ge = re ? k(g, z, re, ce) : k(g)), ge !== n)
          return ge;
        if (!oi(g))
          return g;
        var rt = Dn(g);
        if (rt) {
          if (ge = kee(g), !we)
            return ps(g, ge);
        } else {
          var ut = Io(g), Nt = ut == le || ut == ye;
          if (Vc(g))
            return $M(g, we);
          if (ut == Xe || ut == W || Nt && !re) {
            if (ge = Me || Nt ? {} : QM(g), !we)
              return Me ? bee(g, VZ(ge, g)) : yee(g, uM(ge, g));
          } else {
            if (!kr[ut])
              return re ? g : {};
            ge = Oee(g, ut, we);
          }
        }
        ce || (ce = new sl());
        var Xt = ce.get(g);
        if (Xt)
          return Xt;
        ce.set(g, ge), wR(g) ? g.forEach(function(un) {
          ge.add(va(un, D, k, un, g, ce));
        }) : SR(g) && g.forEach(function(un, Wn) {
          ge.set(Wn, va(un, D, k, Wn, g, ce));
        });
        var ln = nt ? Me ? BS : LS : Me ? hs : Zi, Mn = rt ? n : ln(g);
        return Ho(Mn || g, function(un, Wn) {
          Mn && (Wn = un, un = g[Wn]), ay(ge, Wn, va(un, D, k, Wn, g, ce));
        }), ge;
      }
      function zZ(g) {
        var D = Zi(g);
        return function(k) {
          return cM(k, g, D);
        };
      }
      function cM(g, D, k) {
        var z = k.length;
        if (g == null)
          return !z;
        for (g = Un(g); z--; ) {
          var re = k[z], ce = D[re], ge = g[re];
          if (ge === n && !(re in g) || !ce(ge))
            return !1;
        }
        return !0;
      }
      function dM(g, D, k) {
        if (typeof g != "function")
          throw new ds(s);
        return hy(function() {
          g.apply(n, k);
        }, D);
      }
      function ly(g, D, k, z) {
        var re = -1, ce = rl, ge = !0, we = g.length, Me = [], nt = D.length;
        if (!we)
          return Me;
        k && (D = Br(D, Qi(k))), z ? (ce = qd, ge = !1) : D.length >= i && (ce = Ru, ge = !1, D = new tp(D));
        e:
          for (; ++re < we; ) {
            var rt = g[re], ut = k == null ? rt : k(rt);
            if (rt = z || rt !== 0 ? rt : 0, ge && ut === ut) {
              for (var Nt = nt; Nt--; )
                if (D[Nt] === ut)
                  continue e;
              Me.push(rt);
            } else ce(D, ut, z) || Me.push(rt);
          }
        return Me;
      }
      var _c = LM(Ml), pM = LM(DS, !0);
      function UZ(g, D) {
        var k = !0;
        return _c(g, function(z, re, ce) {
          return k = !!D(z, re, ce), k;
        }), k;
      }
      function r1(g, D, k) {
        for (var z = -1, re = g.length; ++z < re; ) {
          var ce = g[z], ge = D(ce);
          if (ge != null && (we === n ? ge === ge && !Ws(ge) : k(ge, we)))
            var we = ge, Me = ce;
        }
        return Me;
      }
      function WZ(g, D, k, z) {
        var re = g.length;
        for (k = On(k), k < 0 && (k = -k > re ? 0 : re + k), z = z === n || z > re ? re : On(z), z < 0 && (z += re), z = k > z ? 0 : kR(z); k < z; )
          g[k++] = D;
        return g;
      }
      function fM(g, D) {
        var k = [];
        return _c(g, function(z, re, ce) {
          D(z, re, ce) && k.push(z);
        }), k;
      }
      function uo(g, D, k, z, re) {
        var ce = -1, ge = g.length;
        for (k || (k = Fee), re || (re = []); ++ce < ge; ) {
          var we = g[ce];
          D > 0 && k(we) ? D > 1 ? uo(we, D - 1, k, z, re) : Ol(re, we) : z || (re[re.length] = we);
        }
        return re;
      }
      var xS = BM(), hM = BM(!0);
      function Ml(g, D) {
        return g && xS(g, D, Zi);
      }
      function DS(g, D) {
        return g && hM(g, D, Zi);
      }
      function i1(g, D) {
        return Xi(D, function(k) {
          return Gu(g[k]);
        });
      }
      function rp(g, D) {
        D = Bc(D, g);
        for (var k = 0, z = D.length; g != null && k < z; )
          g = g[_l(D[k++])];
        return k && k == z ? g : n;
      }
      function mM(g, D, k) {
        var z = D(g);
        return Dn(g) ? z : Ol(z, k(g));
      }
      function Go(g) {
        return g == null ? g === n ? St : Te : ju && ju in Un(g) ? Aee(g) : Bee(g);
      }
      function CS(g, D) {
        return g > D;
      }
      function HZ(g, D) {
        return g != null && fr.call(g, D);
      }
      function qZ(g, D) {
        return g != null && D in Un(g);
      }
      function GZ(g, D, k) {
        return g >= _i(D, k) && g < ci(D, k);
      }
      function ES(g, D, k) {
        for (var z = k ? qd : rl, re = g[0].length, ce = g.length, ge = ce, we = ze(ce), Me = 1 / 0, nt = []; ge--; ) {
          var rt = g[ge];
          ge && D && (rt = Br(rt, Qi(D))), Me = _i(rt.length, Me), we[ge] = !k && (D || re >= 120 && rt.length >= 120) ? new tp(ge && rt) : n;
        }
        rt = g[0];
        var ut = -1, Nt = we[0];
        e:
          for (; ++ut < re && nt.length < Me; ) {
            var Xt = rt[ut], ln = D ? D(Xt) : Xt;
            if (Xt = k || Xt !== 0 ? Xt : 0, !(Nt ? Ru(Nt, ln) : z(nt, ln, k))) {
              for (ge = ce; --ge; ) {
                var Mn = we[ge];
                if (!(Mn ? Ru(Mn, ln) : z(g[ge], ln, k)))
                  continue e;
              }
              Nt && Nt.push(ln), nt.push(Xt);
            }
          }
        return nt;
      }
      function YZ(g, D, k, z) {
        return Ml(g, function(re, ce, ge) {
          D(z, k(re), ce, ge);
        }), z;
      }
      function uy(g, D, k) {
        D = Bc(D, g), g = nR(g, D);
        var z = g == null ? g : g[_l(Da(D))];
        return z == null ? n : Wo(z, g, k);
      }
      function gM(g) {
        return di(g) && Go(g) == W;
      }
      function KZ(g) {
        return di(g) && Go(g) == Le;
      }
      function JZ(g) {
        return di(g) && Go(g) == pe;
      }
      function cy(g, D, k, z, re) {
        return g === D ? !0 : g == null || D == null || !di(g) && !di(D) ? g !== g && D !== D : XZ(g, D, k, z, cy, re);
      }
      function XZ(g, D, k, z, re, ce) {
        var ge = Dn(g), we = Dn(D), Me = ge ? Q : Io(g), nt = we ? Q : Io(D);
        Me = Me == W ? Xe : Me, nt = nt == W ? Xe : nt;
        var rt = Me == Xe, ut = nt == Xe, Nt = Me == nt;
        if (Nt && Vc(g)) {
          if (!Vc(D))
            return !1;
          ge = !0, rt = !1;
        }
        if (Nt && !rt)
          return ce || (ce = new sl()), ge || lh(g) ? KM(g, D, k, z, re, ce) : Tee(g, D, Me, k, z, re, ce);
        if (!(k & v)) {
          var Xt = rt && fr.call(g, "__wrapped__"), ln = ut && fr.call(D, "__wrapped__");
          if (Xt || ln) {
            var Mn = Xt ? g.value() : g, un = ln ? D.value() : D;
            return ce || (ce = new sl()), re(Mn, un, k, z, ce);
          }
        }
        return Nt ? (ce || (ce = new sl()), See(g, D, k, z, re, ce)) : !1;
      }
      function QZ(g) {
        return di(g) && Io(g) == be;
      }
      function TS(g, D, k, z) {
        var re = k.length, ce = re, ge = !z;
        if (g == null)
          return !ce;
        for (g = Un(g); re--; ) {
          var we = k[re];
          if (ge && we[2] ? we[1] !== g[we[0]] : !(we[0] in g))
            return !1;
        }
        for (; ++re < ce; ) {
          we = k[re];
          var Me = we[0], nt = g[Me], rt = we[1];
          if (ge && we[2]) {
            if (nt === n && !(Me in g))
              return !1;
          } else {
            var ut = new sl();
            if (z)
              var Nt = z(nt, rt, Me, g, D, ut);
            if (!(Nt === n ? cy(rt, nt, v | x, z, ut) : Nt))
              return !1;
          }
        }
        return !0;
      }
      function yM(g) {
        if (!oi(g) || Nee(g))
          return !1;
        var D = Gu(g) ? uS : ct;
        return D.test(op(g));
      }
      function ZZ(g) {
        return di(g) && Go(g) == Ee;
      }
      function eee(g) {
        return di(g) && Io(g) == Ie;
      }
      function tee(g) {
        return di(g) && D1(g.length) && !!Qt[Go(g)];
      }
      function bM(g) {
        return typeof g == "function" ? g : g == null ? ms : typeof g == "object" ? Dn(g) ? DM(g[0], g[1]) : xM(g) : jR(g);
      }
      function SS(g) {
        if (!fy(g))
          return Vu(g);
        var D = [];
        for (var k in Un(g))
          fr.call(g, k) && k != "constructor" && D.push(k);
        return D;
      }
      function nee(g) {
        if (!oi(g))
          return Lee(g);
        var D = fy(g), k = [];
        for (var z in g)
          z == "constructor" && (D || !fr.call(g, z)) || k.push(z);
        return k;
      }
      function AS(g, D) {
        return g < D;
      }
      function vM(g, D) {
        var k = -1, z = fs(g) ? ze(g.length) : [];
        return _c(g, function(re, ce, ge) {
          z[++k] = D(re, ce, ge);
        }), z;
      }
      function xM(g) {
        var D = VS(g);
        return D.length == 1 && D[0][2] ? eR(D[0][0], D[0][1]) : function(k) {
          return k === g || TS(k, g, D);
        };
      }
      function DM(g, D) {
        return US(g) && ZM(D) ? eR(_l(g), D) : function(k) {
          var z = ZS(k, g);
          return z === n && z === D ? eA(k, g) : cy(D, z, v | x);
        };
      }
      function o1(g, D, k, z, re) {
        g !== D && xS(D, function(ce, ge) {
          if (re || (re = new sl()), oi(ce))
            ree(g, D, ge, k, o1, z, re);
          else {
            var we = z ? z(HS(g, ge), ce, ge + "", g, D, re) : n;
            we === n && (we = ce), bS(g, ge, we);
          }
        }, hs);
      }
      function ree(g, D, k, z, re, ce, ge) {
        var we = HS(g, k), Me = HS(D, k), nt = ge.get(Me);
        if (nt) {
          bS(g, k, nt);
          return;
        }
        var rt = ce ? ce(we, Me, k + "", g, D, ge) : n, ut = rt === n;
        if (ut) {
          var Nt = Dn(Me), Xt = !Nt && Vc(Me), ln = !Nt && !Xt && lh(Me);
          rt = Me, Nt || Xt || ln ? Dn(we) ? rt = we : Ci(we) ? rt = ps(we) : Xt ? (ut = !1, rt = $M(Me, !0)) : ln ? (ut = !1, rt = NM(Me, !0)) : rt = [] : my(Me) || sp(Me) ? (rt = we, sp(we) ? rt = OR(we) : (!oi(we) || Gu(we)) && (rt = QM(Me))) : ut = !1;
        }
        ut && (ge.set(Me, rt), re(rt, Me, z, ce, ge), ge.delete(Me)), bS(g, k, rt);
      }
      function CM(g, D) {
        var k = g.length;
        if (k)
          return D += D < 0 ? k : 0, qu(D, k) ? g[D] : n;
      }
      function EM(g, D, k) {
        D.length ? D = Br(D, function(ce) {
          return Dn(ce) ? function(ge) {
            return rp(ge, ce.length === 1 ? ce[0] : ce);
          } : ce;
        }) : D = [ms];
        var z = -1;
        D = Br(D, Qi(sn()));
        var re = vM(g, function(ce, ge, we) {
          var Me = Br(D, function(nt) {
            return nt(ce);
          });
          return { criteria: Me, index: ++z, value: ce };
        });
        return qT(re, function(ce, ge) {
          return gee(ce, ge, k);
        });
      }
      function iee(g, D) {
        return TM(g, D, function(k, z) {
          return eA(g, z);
        });
      }
      function TM(g, D, k) {
        for (var z = -1, re = D.length, ce = {}; ++z < re; ) {
          var ge = D[z], we = rp(g, ge);
          k(we, ge) && dy(ce, Bc(ge, g), we);
        }
        return ce;
      }
      function oee(g) {
        return function(D) {
          return rp(D, g);
        };
      }
      function wS(g, D, k, z) {
        var re = z ? Yg : Ic, ce = -1, ge = D.length, we = g;
        for (g === D && (D = ps(D)), k && (we = Br(g, Qi(k))); ++ce < ge; )
          for (var Me = 0, nt = D[ce], rt = k ? k(nt) : nt; (Me = re(we, rt, Me, z)) > -1; )
            we !== g && Bt.call(we, Me, 1), Bt.call(g, Me, 1);
        return g;
      }
      function SM(g, D) {
        for (var k = g ? D.length : 0, z = k - 1; k--; ) {
          var re = D[k];
          if (k == z || re !== ce) {
            var ce = re;
            qu(re) ? Bt.call(g, re, 1) : IS(g, re);
          }
        }
        return g;
      }
      function PS(g, D) {
        return g + Xd(e1() * (D - g + 1));
      }
      function see(g, D, k, z) {
        for (var re = -1, ce = ci(th((D - g) / (k || 1)), 0), ge = ze(ce); ce--; )
          ge[z ? ce : ++re] = g, g += k;
        return ge;
      }
      function kS(g, D) {
        var k = "";
        if (!g || D < 1 || D > ee)
          return k;
        do
          D % 2 && (k += g), D = Xd(D / 2), D && (g += g);
        while (D);
        return k;
      }
      function _n(g, D) {
        return qS(tR(g, D, ms), g + "");
      }
      function aee(g) {
        return lM(uh(g));
      }
      function lee(g, D) {
        var k = uh(g);
        return m1(k, np(D, 0, k.length));
      }
      function dy(g, D, k, z) {
        if (!oi(g))
          return g;
        D = Bc(D, g);
        for (var re = -1, ce = D.length, ge = ce - 1, we = g; we != null && ++re < ce; ) {
          var Me = _l(D[re]), nt = k;
          if (Me === "__proto__" || Me === "constructor" || Me === "prototype")
            return g;
          if (re != ge) {
            var rt = we[Me];
            nt = z ? z(rt, Me, we) : n, nt === n && (nt = oi(rt) ? rt : qu(D[re + 1]) ? [] : {});
          }
          ay(we, Me, nt), we = we[Me];
        }
        return g;
      }
      var AM = rh ? function(g, D) {
        return rh.set(g, D), g;
      } : ms, uee = eh ? function(g, D) {
        return eh(g, "toString", {
          configurable: !0,
          enumerable: !1,
          value: nA(D),
          writable: !0
        });
      } : ms;
      function cee(g) {
        return m1(uh(g));
      }
      function xa(g, D, k) {
        var z = -1, re = g.length;
        D < 0 && (D = -D > re ? 0 : re + D), k = k > re ? re : k, k < 0 && (k += re), re = D > k ? 0 : k - D >>> 0, D >>>= 0;
        for (var ce = ze(re); ++z < re; )
          ce[z] = g[z + D];
        return ce;
      }
      function dee(g, D) {
        var k;
        return _c(g, function(z, re, ce) {
          return k = D(z, re, ce), !k;
        }), !!k;
      }
      function s1(g, D, k) {
        var z = 0, re = g == null ? z : g.length;
        if (typeof D == "number" && D === D && re <= R) {
          for (; z < re; ) {
            var ce = z + re >>> 1, ge = g[ce];
            ge !== null && !Ws(ge) && (k ? ge <= D : ge < D) ? z = ce + 1 : re = ce;
          }
          return re;
        }
        return OS(g, D, ms, k);
      }
      function OS(g, D, k, z) {
        var re = 0, ce = g == null ? 0 : g.length;
        if (ce === 0)
          return 0;
        D = k(D);
        for (var ge = D !== D, we = D === null, Me = Ws(D), nt = D === n; re < ce; ) {
          var rt = Xd((re + ce) / 2), ut = k(g[rt]), Nt = ut !== n, Xt = ut === null, ln = ut === ut, Mn = Ws(ut);
          if (ge)
            var un = z || ln;
          else nt ? un = ln && (z || Nt) : we ? un = ln && Nt && (z || !Xt) : Me ? un = ln && Nt && !Xt && (z || !Mn) : Xt || Mn ? un = !1 : un = z ? ut <= D : ut < D;
          un ? re = rt + 1 : ce = rt;
        }
        return _i(ce, ne);
      }
      function wM(g, D) {
        for (var k = -1, z = g.length, re = 0, ce = []; ++k < z; ) {
          var ge = g[k], we = D ? D(ge) : ge;
          if (!k || !al(we, Me)) {
            var Me = we;
            ce[re++] = ge === 0 ? 0 : ge;
          }
        }
        return ce;
      }
      function PM(g) {
        return typeof g == "number" ? g : Ws(g) ? M : +g;
      }
      function Us(g) {
        if (typeof g == "string")
          return g;
        if (Dn(g))
          return Br(g, Us) + "";
        if (Ws(g))
          return oy ? oy.call(g) : "";
        var D = g + "";
        return D == "0" && 1 / g == -K ? "-0" : D;
      }
      function Lc(g, D, k) {
        var z = -1, re = rl, ce = g.length, ge = !0, we = [], Me = we;
        if (k)
          ge = !1, re = qd;
        else if (ce >= i) {
          var nt = D ? null : Cee(g);
          if (nt)
            return Il(nt);
          ge = !1, re = Ru, Me = new tp();
        } else
          Me = D ? [] : we;
        e:
          for (; ++z < ce; ) {
            var rt = g[z], ut = D ? D(rt) : rt;
            if (rt = k || rt !== 0 ? rt : 0, ge && ut === ut) {
              for (var Nt = Me.length; Nt--; )
                if (Me[Nt] === ut)
                  continue e;
              D && Me.push(ut), we.push(rt);
            } else re(Me, ut, k) || (Me !== we && Me.push(ut), we.push(rt));
          }
        return we;
      }
      function IS(g, D) {
        return D = Bc(D, g), g = nR(g, D), g == null || delete g[_l(Da(D))];
      }
      function kM(g, D, k, z) {
        return dy(g, D, k(rp(g, D)), z);
      }
      function a1(g, D, k, z) {
        for (var re = g.length, ce = z ? re : -1; (z ? ce-- : ++ce < re) && D(g[ce], ce, g); )
          ;
        return k ? xa(g, z ? 0 : ce, z ? ce + 1 : re) : xa(g, z ? ce + 1 : 0, z ? re : ce);
      }
      function OM(g, D) {
        var k = g;
        return k instanceof T && (k = k.value()), Gg(D, function(z, re) {
          return re.func.apply(re.thisArg, Ol([z], re.args));
        }, k);
      }
      function FS(g, D, k) {
        var z = g.length;
        if (z < 2)
          return z ? Lc(g[0]) : [];
        for (var re = -1, ce = ze(z); ++re < z; )
          for (var ge = g[re], we = -1; ++we < z; )
            we != re && (ce[re] = ly(ce[re] || ge, g[we], D, k));
        return Lc(uo(ce, 1), D, k);
      }
      function IM(g, D, k) {
        for (var z = -1, re = g.length, ce = D.length, ge = {}; ++z < re; ) {
          var we = z < ce ? D[z] : n;
          k(ge, g[z], we);
        }
        return ge;
      }
      function $S(g) {
        return Ci(g) ? g : [];
      }
      function NS(g) {
        return typeof g == "function" ? g : ms;
      }
      function Bc(g, D) {
        return Dn(g) ? g : US(g, D) ? [g] : sR(yr(g));
      }
      var pee = _n;
      function jc(g, D, k) {
        var z = g.length;
        return k = k === n ? z : k, !D && k >= z ? g : xa(g, D, k);
      }
      var FM = cS || function(g) {
        return Ri.clearTimeout(g);
      };
      function $M(g, D) {
        if (D)
          return g.slice();
        var k = g.length, z = Yv ? Yv(k) : new g.constructor(k);
        return g.copy(z), z;
      }
      function MS(g) {
        var D = new g.constructor(g.byteLength);
        return new Jd(D).set(new Jd(g)), D;
      }
      function fee(g, D) {
        var k = D ? MS(g.buffer) : g.buffer;
        return new g.constructor(k, g.byteOffset, g.byteLength);
      }
      function hee(g) {
        var D = new g.constructor(g.source, Fe.exec(g));
        return D.lastIndex = g.lastIndex, D;
      }
      function mee(g) {
        return ol ? Un(ol.call(g)) : {};
      }
      function NM(g, D) {
        var k = D ? MS(g.buffer) : g.buffer;
        return new g.constructor(k, g.byteOffset, g.length);
      }
      function MM(g, D) {
        if (g !== D) {
          var k = g !== n, z = g === null, re = g === g, ce = Ws(g), ge = D !== n, we = D === null, Me = D === D, nt = Ws(D);
          if (!we && !nt && !ce && g > D || ce && ge && Me && !we && !nt || z && ge && Me || !k && Me || !re)
            return 1;
          if (!z && !ce && !nt && g < D || nt && k && re && !z && !ce || we && k && re || !ge && re || !Me)
            return -1;
        }
        return 0;
      }
      function gee(g, D, k) {
        for (var z = -1, re = g.criteria, ce = D.criteria, ge = re.length, we = k.length; ++z < ge; ) {
          var Me = MM(re[z], ce[z]);
          if (Me) {
            if (z >= we)
              return Me;
            var nt = k[z];
            return Me * (nt == "desc" ? -1 : 1);
          }
        }
        return g.index - D.index;
      }
      function RM(g, D, k, z) {
        for (var re = -1, ce = g.length, ge = k.length, we = -1, Me = D.length, nt = ci(ce - ge, 0), rt = ze(Me + nt), ut = !z; ++we < Me; )
          rt[we] = D[we];
        for (; ++re < ge; )
          (ut || re < ce) && (rt[k[re]] = g[re]);
        for (; nt--; )
          rt[we++] = g[re++];
        return rt;
      }
      function _M(g, D, k, z) {
        for (var re = -1, ce = g.length, ge = -1, we = k.length, Me = -1, nt = D.length, rt = ci(ce - we, 0), ut = ze(rt + nt), Nt = !z; ++re < rt; )
          ut[re] = g[re];
        for (var Xt = re; ++Me < nt; )
          ut[Xt + Me] = D[Me];
        for (; ++ge < we; )
          (Nt || re < ce) && (ut[Xt + k[ge]] = g[re++]);
        return ut;
      }
      function ps(g, D) {
        var k = -1, z = g.length;
        for (D || (D = ze(z)); ++k < z; )
          D[k] = g[k];
        return D;
      }
      function Rl(g, D, k, z) {
        var re = !k;
        k || (k = {});
        for (var ce = -1, ge = D.length; ++ce < ge; ) {
          var we = D[ce], Me = z ? z(k[we], g[we], we, k, g) : n;
          Me === n && (Me = g[we]), re ? Uu(k, we, Me) : ay(k, we, Me);
        }
        return k;
      }
      function yee(g, D) {
        return Rl(g, zS(g), D);
      }
      function bee(g, D) {
        return Rl(g, JM(g), D);
      }
      function l1(g, D) {
        return function(k, z) {
          var re = Dn(k) ? UT : jZ, ce = D ? D() : {};
          return re(k, g, sn(z, 2), ce);
        };
      }
      function oh(g) {
        return _n(function(D, k) {
          var z = -1, re = k.length, ce = re > 1 ? k[re - 1] : n, ge = re > 2 ? k[2] : n;
          for (ce = g.length > 3 && typeof ce == "function" ? (re--, ce) : n, ge && Yo(k[0], k[1], ge) && (ce = re < 3 ? n : ce, re = 1), D = Un(D); ++z < re; ) {
            var we = k[z];
            we && g(D, we, z, ce);
          }
          return D;
        });
      }
      function LM(g, D) {
        return function(k, z) {
          if (k == null)
            return k;
          if (!fs(k))
            return g(k, z);
          for (var re = k.length, ce = D ? re : -1, ge = Un(k); (D ? ce-- : ++ce < re) && z(ge[ce], ce, ge) !== !1; )
            ;
          return k;
        };
      }
      function BM(g) {
        return function(D, k, z) {
          for (var re = -1, ce = Un(D), ge = z(D), we = ge.length; we--; ) {
            var Me = ge[g ? we : ++re];
            if (k(ce[Me], Me, ce) === !1)
              break;
          }
          return D;
        };
      }
      function vee(g, D, k) {
        var z = D & C, re = py(g);
        function ce() {
          var ge = this && this !== Ri && this instanceof ce ? re : g;
          return ge.apply(z ? k : this, arguments);
        }
        return ce;
      }
      function jM(g) {
        return function(D) {
          D = yr(D);
          var k = _u(D) ? js(D) : n, z = k ? k[0] : D.charAt(0), re = k ? jc(k, 1).join("") : D.slice(1);
          return z[g]() + re;
        };
      }
      function sh(g) {
        return function(D) {
          return Gg(LR(_R(D).replace(Lg, "")), g, "");
        };
      }
      function py(g) {
        return function() {
          var D = arguments;
          switch (D.length) {
            case 0:
              return new g();
            case 1:
              return new g(D[0]);
            case 2:
              return new g(D[0], D[1]);
            case 3:
              return new g(D[0], D[1], D[2]);
            case 4:
              return new g(D[0], D[1], D[2], D[3]);
            case 5:
              return new g(D[0], D[1], D[2], D[3], D[4]);
            case 6:
              return new g(D[0], D[1], D[2], D[3], D[4], D[5]);
            case 7:
              return new g(D[0], D[1], D[2], D[3], D[4], D[5], D[6]);
          }
          var k = y(g.prototype), z = g.apply(k, D);
          return oi(z) ? z : k;
        };
      }
      function xee(g, D, k) {
        var z = py(g);
        function re() {
          for (var ce = arguments.length, ge = ze(ce), we = ce, Me = ah(re); we--; )
            ge[we] = arguments[we];
          var nt = ce < 3 && ge[0] !== Me && ge[ce - 1] !== Me ? [] : il(ge, Me);
          if (ce -= nt.length, ce < k)
            return HM(
              g,
              D,
              u1,
              re.placeholder,
              n,
              ge,
              nt,
              n,
              n,
              k - ce
            );
          var rt = this && this !== Ri && this instanceof re ? z : g;
          return Wo(rt, this, ge);
        }
        return re;
      }
      function VM(g) {
        return function(D, k, z) {
          var re = Un(D);
          if (!fs(D)) {
            var ce = sn(k, 3);
            D = Zi(D), k = function(we) {
              return ce(re[we], we, re);
            };
          }
          var ge = g(D, k, z);
          return ge > -1 ? re[ce ? D[ge] : ge] : n;
        };
      }
      function zM(g) {
        return Hu(function(D) {
          var k = D.length, z = k, re = b.prototype.thru;
          for (g && D.reverse(); z--; ) {
            var ce = D[z];
            if (typeof ce != "function")
              throw new ds(s);
            if (re && !ge && f1(ce) == "wrapper")
              var ge = new b([], !0);
          }
          for (z = ge ? z : k; ++z < k; ) {
            ce = D[z];
            var we = f1(ce), Me = we == "wrapper" ? jS(ce) : n;
            Me && WS(Me[0]) && Me[1] == ($ | w | A | L) && !Me[4].length && Me[9] == 1 ? ge = ge[f1(Me[0])].apply(ge, Me[3]) : ge = ce.length == 1 && WS(ce) ? ge[we]() : ge.thru(ce);
          }
          return function() {
            var nt = arguments, rt = nt[0];
            if (ge && nt.length == 1 && Dn(rt))
              return ge.plant(rt).value();
            for (var ut = 0, Nt = k ? D[ut].apply(this, nt) : rt; ++ut < k; )
              Nt = D[ut].call(this, Nt);
            return Nt;
          };
        });
      }
      function u1(g, D, k, z, re, ce, ge, we, Me, nt) {
        var rt = D & $, ut = D & C, Nt = D & E, Xt = D & (w | O), ln = D & B, Mn = Nt ? n : py(g);
        function un() {
          for (var Wn = arguments.length, Kn = ze(Wn), Hs = Wn; Hs--; )
            Kn[Hs] = arguments[Hs];
          if (Xt)
            var Ko = ah(un), qs = YT(Kn, Ko);
          if (z && (Kn = RM(Kn, z, re, Xt)), ce && (Kn = _M(Kn, ce, ge, Xt)), Wn -= qs, Xt && Wn < nt) {
            var Ei = il(Kn, Ko);
            return HM(
              g,
              D,
              u1,
              un.placeholder,
              k,
              Kn,
              Ei,
              we,
              Me,
              nt - Wn
            );
          }
          var ll = ut ? k : this, Ku = Nt ? ll[g] : g;
          return Wn = Kn.length, we ? Kn = jee(Kn, we) : ln && Wn > 1 && Kn.reverse(), rt && Me < Wn && (Kn.length = Me), this && this !== Ri && this instanceof un && (Ku = Mn || py(Ku)), Ku.apply(ll, Kn);
        }
        return un;
      }
      function UM(g, D) {
        return function(k, z) {
          return YZ(k, g, D(z), {});
        };
      }
      function c1(g, D) {
        return function(k, z) {
          var re;
          if (k === n && z === n)
            return D;
          if (k !== n && (re = k), z !== n) {
            if (re === n)
              return z;
            typeof k == "string" || typeof z == "string" ? (k = Us(k), z = Us(z)) : (k = PM(k), z = PM(z)), re = g(k, z);
          }
          return re;
        };
      }
      function RS(g) {
        return Hu(function(D) {
          return D = Br(D, Qi(sn())), _n(function(k) {
            var z = this;
            return g(D, function(re) {
              return Wo(re, z, k);
            });
          });
        });
      }
      function d1(g, D) {
        D = D === n ? " " : Us(D);
        var k = D.length;
        if (k < 2)
          return k ? kS(D, g) : D;
        var z = kS(D, th(g / Fc(D)));
        return _u(D) ? jc(js(z), 0, g).join("") : z.slice(0, g);
      }
      function Dee(g, D, k, z) {
        var re = D & C, ce = py(g);
        function ge() {
          for (var we = -1, Me = arguments.length, nt = -1, rt = z.length, ut = ze(rt + Me), Nt = this && this !== Ri && this instanceof ge ? ce : g; ++nt < rt; )
            ut[nt] = z[nt];
          for (; Me--; )
            ut[nt++] = arguments[++we];
          return Wo(Nt, re ? k : this, ut);
        }
        return ge;
      }
      function WM(g) {
        return function(D, k, z) {
          return z && typeof z != "number" && Yo(D, k, z) && (k = z = n), D = Yu(D), k === n ? (k = D, D = 0) : k = Yu(k), z = z === n ? D < k ? 1 : -1 : Yu(z), see(D, k, z, g);
        };
      }
      function p1(g) {
        return function(D, k) {
          return typeof D == "string" && typeof k == "string" || (D = Ca(D), k = Ca(k)), g(D, k);
        };
      }
      function HM(g, D, k, z, re, ce, ge, we, Me, nt) {
        var rt = D & w, ut = rt ? ge : n, Nt = rt ? n : ge, Xt = rt ? ce : n, ln = rt ? n : ce;
        D |= rt ? A : I, D &= ~(rt ? I : A), D & S || (D &= ~(C | E));
        var Mn = [
          g,
          D,
          re,
          Xt,
          ut,
          ln,
          Nt,
          we,
          Me,
          nt
        ], un = k.apply(n, Mn);
        return WS(g) && rR(un, Mn), un.placeholder = z, iR(un, g, D);
      }
      function _S(g) {
        var D = xi[g];
        return function(k, z) {
          if (k = Ca(k), z = z == null ? 0 : _i(On(z), 292), z && Qv(k)) {
            var re = (yr(k) + "e").split("e"), ce = D(re[0] + "e" + (+re[1] + z));
            return re = (yr(ce) + "e").split("e"), +(re[0] + "e" + (+re[1] - z));
          }
          return D(k);
        };
      }
      var Cee = Mc && 1 / Il(new Mc([, -0]))[1] == K ? function(g) {
        return new Mc(g);
      } : oA;
      function qM(g) {
        return function(D) {
          var k = Io(D);
          return k == be ? Yd(D) : k == Ie ? ZT(D) : GT(D, g(D));
        };
      }
      function Wu(g, D, k, z, re, ce, ge, we) {
        var Me = D & E;
        if (!Me && typeof g != "function")
          throw new ds(s);
        var nt = z ? z.length : 0;
        if (nt || (D &= ~(A | I), z = re = n), ge = ge === n ? ge : ci(On(ge), 0), we = we === n ? we : On(we), nt -= re ? re.length : 0, D & I) {
          var rt = z, ut = re;
          z = re = n;
        }
        var Nt = Me ? n : jS(g), Xt = [
          g,
          D,
          k,
          z,
          re,
          rt,
          ut,
          ce,
          ge,
          we
        ];
        if (Nt && _ee(Xt, Nt), g = Xt[0], D = Xt[1], k = Xt[2], z = Xt[3], re = Xt[4], we = Xt[9] = Xt[9] === n ? Me ? 0 : g.length : ci(Xt[9] - nt, 0), !we && D & (w | O) && (D &= ~(w | O)), !D || D == C)
          var ln = vee(g, D, k);
        else D == w || D == O ? ln = xee(g, D, we) : (D == A || D == (C | A)) && !re.length ? ln = Dee(g, D, k, z) : ln = u1.apply(n, Xt);
        var Mn = Nt ? AM : rR;
        return iR(Mn(ln, Xt), g, D);
      }
      function GM(g, D, k, z) {
        return g === n || al(g, Bu[k]) && !fr.call(z, k) ? D : g;
      }
      function YM(g, D, k, z, re, ce) {
        return oi(g) && oi(D) && (ce.set(D, g), o1(g, D, n, YM, ce), ce.delete(D)), g;
      }
      function Eee(g) {
        return my(g) ? n : g;
      }
      function KM(g, D, k, z, re, ce) {
        var ge = k & v, we = g.length, Me = D.length;
        if (we != Me && !(ge && Me > we))
          return !1;
        var nt = ce.get(g), rt = ce.get(D);
        if (nt && rt)
          return nt == D && rt == g;
        var ut = -1, Nt = !0, Xt = k & x ? new tp() : n;
        for (ce.set(g, D), ce.set(D, g); ++ut < we; ) {
          var ln = g[ut], Mn = D[ut];
          if (z)
            var un = ge ? z(Mn, ln, ut, D, g, ce) : z(ln, Mn, ut, g, D, ce);
          if (un !== n) {
            if (un)
              continue;
            Nt = !1;
            break;
          }
          if (Xt) {
            if (!qf(D, function(Wn, Kn) {
              if (!Ru(Xt, Kn) && (ln === Wn || re(ln, Wn, k, z, ce)))
                return Xt.push(Kn);
            })) {
              Nt = !1;
              break;
            }
          } else if (!(ln === Mn || re(ln, Mn, k, z, ce))) {
            Nt = !1;
            break;
          }
        }
        return ce.delete(g), ce.delete(D), Nt;
      }
      function Tee(g, D, k, z, re, ce, ge) {
        switch (k) {
          case Pe:
            if (g.byteLength != D.byteLength || g.byteOffset != D.byteOffset)
              return !1;
            g = g.buffer, D = D.buffer;
          case Le:
            return !(g.byteLength != D.byteLength || !ce(new Jd(g), new Jd(D)));
          case ae:
          case pe:
          case Re:
            return al(+g, +D);
          case xe:
            return g.name == D.name && g.message == D.message;
          case Ee:
          case Je:
            return g == D + "";
          case be:
            var we = Yd;
          case Ie:
            var Me = z & v;
            if (we || (we = Il), g.size != D.size && !Me)
              return !1;
            var nt = ge.get(g);
            if (nt)
              return nt == D;
            z |= x, ge.set(g, D);
            var rt = KM(we(g), we(D), z, re, ce, ge);
            return ge.delete(g), rt;
          case vt:
            if (ol)
              return ol.call(g) == ol.call(D);
        }
        return !1;
      }
      function See(g, D, k, z, re, ce) {
        var ge = k & v, we = LS(g), Me = we.length, nt = LS(D), rt = nt.length;
        if (Me != rt && !ge)
          return !1;
        for (var ut = Me; ut--; ) {
          var Nt = we[ut];
          if (!(ge ? Nt in D : fr.call(D, Nt)))
            return !1;
        }
        var Xt = ce.get(g), ln = ce.get(D);
        if (Xt && ln)
          return Xt == D && ln == g;
        var Mn = !0;
        ce.set(g, D), ce.set(D, g);
        for (var un = ge; ++ut < Me; ) {
          Nt = we[ut];
          var Wn = g[Nt], Kn = D[Nt];
          if (z)
            var Hs = ge ? z(Kn, Wn, Nt, D, g, ce) : z(Wn, Kn, Nt, g, D, ce);
          if (!(Hs === n ? Wn === Kn || re(Wn, Kn, k, z, ce) : Hs)) {
            Mn = !1;
            break;
          }
          un || (un = Nt == "constructor");
        }
        if (Mn && !un) {
          var Ko = g.constructor, qs = D.constructor;
          Ko != qs && "constructor" in g && "constructor" in D && !(typeof Ko == "function" && Ko instanceof Ko && typeof qs == "function" && qs instanceof qs) && (Mn = !1);
        }
        return ce.delete(g), ce.delete(D), Mn;
      }
      function Hu(g) {
        return qS(tR(g, n, cR), g + "");
      }
      function LS(g) {
        return mM(g, Zi, zS);
      }
      function BS(g) {
        return mM(g, hs, JM);
      }
      var jS = rh ? function(g) {
        return rh.get(g);
      } : oA;
      function f1(g) {
        for (var D = g.name + "", k = Rc[D], z = fr.call(Rc, D) ? k.length : 0; z--; ) {
          var re = k[z], ce = re.func;
          if (ce == null || ce == g)
            return re.name;
        }
        return D;
      }
      function ah(g) {
        var D = fr.call(ue, "placeholder") ? ue : g;
        return D.placeholder;
      }
      function sn() {
        var g = ue.iteratee || rA;
        return g = g === rA ? bM : g, arguments.length ? g(arguments[0], arguments[1]) : g;
      }
      function h1(g, D) {
        var k = g.__data__;
        return $ee(D) ? k[typeof D == "string" ? "string" : "hash"] : k.map;
      }
      function VS(g) {
        for (var D = Zi(g), k = D.length; k--; ) {
          var z = D[k], re = g[z];
          D[k] = [z, re, ZM(re)];
        }
        return D;
      }
      function ip(g, D) {
        var k = Kf(g, D);
        return yM(k) ? k : n;
      }
      function Aee(g) {
        var D = fr.call(g, ju), k = g[ju];
        try {
          g[ju] = n;
          var z = !0;
        } catch {
        }
        var re = Vs.call(g);
        return z && (D ? g[ju] = k : delete g[ju]), re;
      }
      var zS = nh ? function(g) {
        return g == null ? [] : (g = Un(g), Xi(nh(g), function(D) {
          return ny.call(g, D);
        }));
      } : sA, JM = nh ? function(g) {
        for (var D = []; g; )
          Ol(D, zS(g)), g = Zf(g);
        return D;
      } : sA, Io = Go;
      (iy && Io(new iy(new ArrayBuffer(1))) != Pe || Qd && Io(new Qd()) != be || Zd && Io(Zd.resolve()) != Ne || Mc && Io(new Mc()) != Ie || ep && Io(new ep()) != Lt) && (Io = function(g) {
        var D = Go(g), k = D == Xe ? g.constructor : n, z = k ? op(k) : "";
        if (z)
          switch (z) {
            case t1:
              return Pe;
            case hS:
              return be;
            case mS:
              return Ne;
            case gS:
              return Ie;
            case yS:
              return Lt;
          }
        return D;
      });
      function wee(g, D, k) {
        for (var z = -1, re = k.length; ++z < re; ) {
          var ce = k[z], ge = ce.size;
          switch (ce.type) {
            case "drop":
              g += ge;
              break;
            case "dropRight":
              D -= ge;
              break;
            case "take":
              D = _i(D, g + ge);
              break;
            case "takeRight":
              g = ci(g, D - ge);
              break;
          }
        }
        return { start: g, end: D };
      }
      function Pee(g) {
        var D = g.match(Mi);
        return D ? D[1].split(ko) : [];
      }
      function XM(g, D, k) {
        D = Bc(D, g);
        for (var z = -1, re = D.length, ce = !1; ++z < re; ) {
          var ge = _l(D[z]);
          if (!(ce = g != null && k(g, ge)))
            break;
          g = g[ge];
        }
        return ce || ++z != re ? ce : (re = g == null ? 0 : g.length, !!re && D1(re) && qu(ge, re) && (Dn(g) || sp(g)));
      }
      function kee(g) {
        var D = g.length, k = new g.constructor(D);
        return D && typeof g[0] == "string" && fr.call(g, "index") && (k.index = g.index, k.input = g.input), k;
      }
      function QM(g) {
        return typeof g.constructor == "function" && !fy(g) ? y(Zf(g)) : {};
      }
      function Oee(g, D, k) {
        var z = g.constructor;
        switch (D) {
          case Le:
            return MS(g);
          case ae:
          case pe:
            return new z(+g);
          case Pe:
            return fee(g, k);
          case Ae:
          case We:
          case At:
          case Ft:
          case Ct:
          case ht:
          case He:
          case qe:
          case wt:
            return NM(g, k);
          case be:
            return new z();
          case Re:
          case Je:
            return new z(g);
          case Ee:
            return hee(g);
          case Ie:
            return new z();
          case vt:
            return mee(g);
        }
      }
      function Iee(g, D) {
        var k = D.length;
        if (!k)
          return g;
        var z = k - 1;
        return D[z] = (k > 1 ? "& " : "") + D[z], D = D.join(k > 2 ? ", " : " "), g.replace(Ls, `{
/* [wrapped with ` + D + `] */
`);
      }
      function Fee(g) {
        return Dn(g) || sp(g) || !!(Jv && g && g[Jv]);
      }
      function qu(g, D) {
        var k = typeof g;
        return D = D ?? ee, !!D && (k == "number" || k != "symbol" && Ht.test(g)) && g > -1 && g % 1 == 0 && g < D;
      }
      function Yo(g, D, k) {
        if (!oi(k))
          return !1;
        var z = typeof D;
        return (z == "number" ? fs(k) && qu(D, k.length) : z == "string" && D in k) ? al(k[D], g) : !1;
      }
      function US(g, D) {
        if (Dn(g))
          return !1;
        var k = typeof g;
        return k == "number" || k == "symbol" || k == "boolean" || g == null || Ws(g) ? !0 : _r.test(g) || !Po.test(g) || D != null && g in Un(D);
      }
      function $ee(g) {
        var D = typeof g;
        return D == "string" || D == "number" || D == "symbol" || D == "boolean" ? g !== "__proto__" : g === null;
      }
      function WS(g) {
        var D = f1(g), k = ue[D];
        if (typeof k != "function" || !(D in T.prototype))
          return !1;
        if (g === k)
          return !0;
        var z = jS(k);
        return !!z && g === z[0];
      }
      function Nee(g) {
        return !!$l && $l in g;
      }
      var Mee = Jf ? Gu : aA;
      function fy(g) {
        var D = g && g.constructor, k = typeof D == "function" && D.prototype || Bu;
        return g === k;
      }
      function ZM(g) {
        return g === g && !oi(g);
      }
      function eR(g, D) {
        return function(k) {
          return k == null ? !1 : k[g] === D && (D !== n || g in Un(k));
        };
      }
      function Ree(g) {
        var D = v1(g, function(z) {
          return k.size === c && k.clear(), z;
        }), k = D.cache;
        return D;
      }
      function _ee(g, D) {
        var k = g[1], z = D[1], re = k | z, ce = re < (C | E | $), ge = z == $ && k == w || z == $ && k == L && g[7].length <= D[8] || z == ($ | L) && D[7].length <= D[8] && k == w;
        if (!(ce || ge))
          return g;
        z & C && (g[2] = D[2], re |= k & C ? 0 : S);
        var we = D[3];
        if (we) {
          var Me = g[3];
          g[3] = Me ? RM(Me, we, D[4]) : we, g[4] = Me ? il(g[3], d) : D[4];
        }
        return we = D[5], we && (Me = g[5], g[5] = Me ? _M(Me, we, D[6]) : we, g[6] = Me ? il(g[5], d) : D[6]), we = D[7], we && (g[7] = we), z & $ && (g[8] = g[8] == null ? D[8] : _i(g[8], D[8])), g[9] == null && (g[9] = D[9]), g[0] = D[0], g[1] = re, g;
      }
      function Lee(g) {
        var D = [];
        if (g != null)
          for (var k in Un(g))
            D.push(k);
        return D;
      }
      function Bee(g) {
        return Vs.call(g);
      }
      function tR(g, D, k) {
        return D = ci(D === n ? g.length - 1 : D, 0), function() {
          for (var z = arguments, re = -1, ce = ci(z.length - D, 0), ge = ze(ce); ++re < ce; )
            ge[re] = z[D + re];
          re = -1;
          for (var we = ze(D + 1); ++re < D; )
            we[re] = z[re];
          return we[D] = k(ge), Wo(g, this, we);
        };
      }
      function nR(g, D) {
        return D.length < 2 ? g : rp(g, xa(D, 0, -1));
      }
      function jee(g, D) {
        for (var k = g.length, z = _i(D.length, k), re = ps(g); z--; ) {
          var ce = D[z];
          g[z] = qu(ce, k) ? re[ce] : n;
        }
        return g;
      }
      function HS(g, D) {
        if (!(D === "constructor" && typeof g[D] == "function") && D != "__proto__")
          return g[D];
      }
      var rR = oR(AM), hy = Xv || function(g, D) {
        return Ri.setTimeout(g, D);
      }, qS = oR(uee);
      function iR(g, D, k) {
        var z = D + "";
        return qS(g, Iee(z, Vee(Pee(z), k)));
      }
      function oR(g) {
        var D = 0, k = 0;
        return function() {
          var z = fS(), re = X - (z - k);
          if (k = z, re > 0) {
            if (++D >= J)
              return arguments[0];
          } else
            D = 0;
          return g.apply(n, arguments);
        };
      }
      function m1(g, D) {
        var k = -1, z = g.length, re = z - 1;
        for (D = D === n ? z : D; ++k < D; ) {
          var ce = PS(k, re), ge = g[ce];
          g[ce] = g[k], g[k] = ge;
        }
        return g.length = D, g;
      }
      var sR = Ree(function(g) {
        var D = [];
        return g.charCodeAt(0) === 46 && D.push(""), g.replace(Lr, function(k, z, re, ce) {
          D.push(re ? ce.replace(xt, "$1") : z || k);
        }), D;
      });
      function _l(g) {
        if (typeof g == "string" || Ws(g))
          return g;
        var D = g + "";
        return D == "0" && 1 / g == -K ? "-0" : D;
      }
      function op(g) {
        if (g != null) {
          try {
            return Xf.call(g);
          } catch {
          }
          try {
            return g + "";
          } catch {
          }
        }
        return "";
      }
      function Vee(g, D) {
        return Ho(_, function(k) {
          var z = "_." + k[0];
          D & k[1] && !rl(g, z) && g.push(z);
        }), g.sort();
      }
      function aR(g) {
        if (g instanceof T)
          return g.clone();
        var D = new b(g.__wrapped__, g.__chain__);
        return D.__actions__ = ps(g.__actions__), D.__index__ = g.__index__, D.__values__ = g.__values__, D;
      }
      function zee(g, D, k) {
        (k ? Yo(g, D, k) : D === n) ? D = 1 : D = ci(On(D), 0);
        var z = g == null ? 0 : g.length;
        if (!z || D < 1)
          return [];
        for (var re = 0, ce = 0, ge = ze(th(z / D)); re < z; )
          ge[ce++] = xa(g, re, re += D);
        return ge;
      }
      function Uee(g) {
        for (var D = -1, k = g == null ? 0 : g.length, z = 0, re = []; ++D < k; ) {
          var ce = g[D];
          ce && (re[z++] = ce);
        }
        return re;
      }
      function Wee() {
        var g = arguments.length;
        if (!g)
          return [];
        for (var D = ze(g - 1), k = arguments[0], z = g; z--; )
          D[z - 1] = arguments[z];
        return Ol(Dn(k) ? ps(k) : [k], uo(D, 1));
      }
      var Hee = _n(function(g, D) {
        return Ci(g) ? ly(g, uo(D, 1, Ci, !0)) : [];
      }), qee = _n(function(g, D) {
        var k = Da(D);
        return Ci(k) && (k = n), Ci(g) ? ly(g, uo(D, 1, Ci, !0), sn(k, 2)) : [];
      }), Gee = _n(function(g, D) {
        var k = Da(D);
        return Ci(k) && (k = n), Ci(g) ? ly(g, uo(D, 1, Ci, !0), n, k) : [];
      });
      function Yee(g, D, k) {
        var z = g == null ? 0 : g.length;
        return z ? (D = k || D === n ? 1 : On(D), xa(g, D < 0 ? 0 : D, z)) : [];
      }
      function Kee(g, D, k) {
        var z = g == null ? 0 : g.length;
        return z ? (D = k || D === n ? 1 : On(D), D = z - D, xa(g, 0, D < 0 ? 0 : D)) : [];
      }
      function Jee(g, D) {
        return g && g.length ? a1(g, sn(D, 3), !0, !0) : [];
      }
      function Xee(g, D) {
        return g && g.length ? a1(g, sn(D, 3), !0) : [];
      }
      function Qee(g, D, k, z) {
        var re = g == null ? 0 : g.length;
        return re ? (k && typeof k != "number" && Yo(g, D, k) && (k = 0, z = re), WZ(g, D, k, z)) : [];
      }
      function lR(g, D, k) {
        var z = g == null ? 0 : g.length;
        if (!z)
          return -1;
        var re = k == null ? 0 : On(k);
        return re < 0 && (re = ci(z + re, 0)), Gf(g, sn(D, 3), re);
      }
      function uR(g, D, k) {
        var z = g == null ? 0 : g.length;
        if (!z)
          return -1;
        var re = z - 1;
        return k !== n && (re = On(k), re = k < 0 ? ci(z + re, 0) : _i(re, z - 1)), Gf(g, sn(D, 3), re, !0);
      }
      function cR(g) {
        var D = g == null ? 0 : g.length;
        return D ? uo(g, 1) : [];
      }
      function Zee(g) {
        var D = g == null ? 0 : g.length;
        return D ? uo(g, K) : [];
      }
      function ete(g, D) {
        var k = g == null ? 0 : g.length;
        return k ? (D = D === n ? 1 : On(D), uo(g, D)) : [];
      }
      function tte(g) {
        for (var D = -1, k = g == null ? 0 : g.length, z = {}; ++D < k; ) {
          var re = g[D];
          z[re[0]] = re[1];
        }
        return z;
      }
      function dR(g) {
        return g && g.length ? g[0] : n;
      }
      function nte(g, D, k) {
        var z = g == null ? 0 : g.length;
        if (!z)
          return -1;
        var re = k == null ? 0 : On(k);
        return re < 0 && (re = ci(z + re, 0)), Ic(g, D, re);
      }
      function rte(g) {
        var D = g == null ? 0 : g.length;
        return D ? xa(g, 0, -1) : [];
      }
      var ite = _n(function(g) {
        var D = Br(g, $S);
        return D.length && D[0] === g[0] ? ES(D) : [];
      }), ote = _n(function(g) {
        var D = Da(g), k = Br(g, $S);
        return D === Da(k) ? D = n : k.pop(), k.length && k[0] === g[0] ? ES(k, sn(D, 2)) : [];
      }), ste = _n(function(g) {
        var D = Da(g), k = Br(g, $S);
        return D = typeof D == "function" ? D : n, D && k.pop(), k.length && k[0] === g[0] ? ES(k, n, D) : [];
      });
      function ate(g, D) {
        return g == null ? "" : ui.call(g, D);
      }
      function Da(g) {
        var D = g == null ? 0 : g.length;
        return D ? g[D - 1] : n;
      }
      function lte(g, D, k) {
        var z = g == null ? 0 : g.length;
        if (!z)
          return -1;
        var re = z;
        return k !== n && (re = On(k), re = re < 0 ? ci(z + re, 0) : _i(re, z - 1)), D === D ? eS(g, D, re) : Gf(g, Yf, re, !0);
      }
      function ute(g, D) {
        return g && g.length ? CM(g, On(D)) : n;
      }
      var cte = _n(pR);
      function pR(g, D) {
        return g && g.length && D && D.length ? wS(g, D) : g;
      }
      function dte(g, D, k) {
        return g && g.length && D && D.length ? wS(g, D, sn(k, 2)) : g;
      }
      function pte(g, D, k) {
        return g && g.length && D && D.length ? wS(g, D, n, k) : g;
      }
      var fte = Hu(function(g, D) {
        var k = g == null ? 0 : g.length, z = vS(g, D);
        return SM(g, Br(D, function(re) {
          return qu(re, k) ? +re : re;
        }).sort(MM)), z;
      });
      function hte(g, D) {
        var k = [];
        if (!(g && g.length))
          return k;
        var z = -1, re = [], ce = g.length;
        for (D = sn(D, 3); ++z < ce; ) {
          var ge = g[z];
          D(ge, z, g) && (k.push(ge), re.push(z));
        }
        return SM(g, re), k;
      }
      function GS(g) {
        return g == null ? g : ry.call(g);
      }
      function mte(g, D, k) {
        var z = g == null ? 0 : g.length;
        return z ? (k && typeof k != "number" && Yo(g, D, k) ? (D = 0, k = z) : (D = D == null ? 0 : On(D), k = k === n ? z : On(k)), xa(g, D, k)) : [];
      }
      function gte(g, D) {
        return s1(g, D);
      }
      function yte(g, D, k) {
        return OS(g, D, sn(k, 2));
      }
      function bte(g, D) {
        var k = g == null ? 0 : g.length;
        if (k) {
          var z = s1(g, D);
          if (z < k && al(g[z], D))
            return z;
        }
        return -1;
      }
      function vte(g, D) {
        return s1(g, D, !0);
      }
      function xte(g, D, k) {
        return OS(g, D, sn(k, 2), !0);
      }
      function Dte(g, D) {
        var k = g == null ? 0 : g.length;
        if (k) {
          var z = s1(g, D, !0) - 1;
          if (al(g[z], D))
            return z;
        }
        return -1;
      }
      function Cte(g) {
        return g && g.length ? wM(g) : [];
      }
      function Ete(g, D) {
        return g && g.length ? wM(g, sn(D, 2)) : [];
      }
      function Tte(g) {
        var D = g == null ? 0 : g.length;
        return D ? xa(g, 1, D) : [];
      }
      function Ste(g, D, k) {
        return g && g.length ? (D = k || D === n ? 1 : On(D), xa(g, 0, D < 0 ? 0 : D)) : [];
      }
      function Ate(g, D, k) {
        var z = g == null ? 0 : g.length;
        return z ? (D = k || D === n ? 1 : On(D), D = z - D, xa(g, D < 0 ? 0 : D, z)) : [];
      }
      function wte(g, D) {
        return g && g.length ? a1(g, sn(D, 3), !1, !0) : [];
      }
      function Pte(g, D) {
        return g && g.length ? a1(g, sn(D, 3)) : [];
      }
      var kte = _n(function(g) {
        return Lc(uo(g, 1, Ci, !0));
      }), Ote = _n(function(g) {
        var D = Da(g);
        return Ci(D) && (D = n), Lc(uo(g, 1, Ci, !0), sn(D, 2));
      }), Ite = _n(function(g) {
        var D = Da(g);
        return D = typeof D == "function" ? D : n, Lc(uo(g, 1, Ci, !0), n, D);
      });
      function Fte(g) {
        return g && g.length ? Lc(g) : [];
      }
      function $te(g, D) {
        return g && g.length ? Lc(g, sn(D, 2)) : [];
      }
      function Nte(g, D) {
        return D = typeof D == "function" ? D : n, g && g.length ? Lc(g, n, D) : [];
      }
      function YS(g) {
        if (!(g && g.length))
          return [];
        var D = 0;
        return g = Xi(g, function(k) {
          if (Ci(k))
            return D = ci(k.length, D), !0;
        }), Nu(D, function(k) {
          return Br(g, Kg(k));
        });
      }
      function fR(g, D) {
        if (!(g && g.length))
          return [];
        var k = YS(g);
        return D == null ? k : Br(k, function(z) {
          return Wo(D, n, z);
        });
      }
      var Mte = _n(function(g, D) {
        return Ci(g) ? ly(g, D) : [];
      }), Rte = _n(function(g) {
        return FS(Xi(g, Ci));
      }), _te = _n(function(g) {
        var D = Da(g);
        return Ci(D) && (D = n), FS(Xi(g, Ci), sn(D, 2));
      }), Lte = _n(function(g) {
        var D = Da(g);
        return D = typeof D == "function" ? D : n, FS(Xi(g, Ci), n, D);
      }), Bte = _n(YS);
      function jte(g, D) {
        return IM(g || [], D || [], ay);
      }
      function Vte(g, D) {
        return IM(g || [], D || [], dy);
      }
      var zte = _n(function(g) {
        var D = g.length, k = D > 1 ? g[D - 1] : n;
        return k = typeof k == "function" ? (g.pop(), k) : n, fR(g, k);
      });
      function hR(g) {
        var D = ue(g);
        return D.__chain__ = !0, D;
      }
      function Ute(g, D) {
        return D(g), g;
      }
      function g1(g, D) {
        return D(g);
      }
      var Wte = Hu(function(g) {
        var D = g.length, k = D ? g[0] : 0, z = this.__wrapped__, re = function(ce) {
          return vS(ce, g);
        };
        return D > 1 || this.__actions__.length || !(z instanceof T) || !qu(k) ? this.thru(re) : (z = z.slice(k, +k + (D ? 1 : 0)), z.__actions__.push({
          func: g1,
          args: [re],
          thisArg: n
        }), new b(z, this.__chain__).thru(function(ce) {
          return D && !ce.length && ce.push(n), ce;
        }));
      });
      function Hte() {
        return hR(this);
      }
      function qte() {
        return new b(this.value(), this.__chain__);
      }
      function Gte() {
        this.__values__ === n && (this.__values__ = PR(this.value()));
        var g = this.__index__ >= this.__values__.length, D = g ? n : this.__values__[this.__index__++];
        return { done: g, value: D };
      }
      function Yte() {
        return this;
      }
      function Kte(g) {
        for (var D, k = this; k instanceof p; ) {
          var z = aR(k);
          z.__index__ = 0, z.__values__ = n, D ? re.__wrapped__ = z : D = z;
          var re = z;
          k = k.__wrapped__;
        }
        return re.__wrapped__ = g, D;
      }
      function Jte() {
        var g = this.__wrapped__;
        if (g instanceof T) {
          var D = g;
          return this.__actions__.length && (D = new T(this)), D = D.reverse(), D.__actions__.push({
            func: g1,
            args: [GS],
            thisArg: n
          }), new b(D, this.__chain__);
        }
        return this.thru(GS);
      }
      function Xte() {
        return OM(this.__wrapped__, this.__actions__);
      }
      var Qte = l1(function(g, D, k) {
        fr.call(g, k) ? ++g[k] : Uu(g, k, 1);
      });
      function Zte(g, D, k) {
        var z = Dn(g) ? Hf : UZ;
        return k && Yo(g, D, k) && (D = n), z(g, sn(D, 3));
      }
      function ene(g, D) {
        var k = Dn(g) ? Xi : fM;
        return k(g, sn(D, 3));
      }
      var tne = VM(lR), nne = VM(uR);
      function rne(g, D) {
        return uo(y1(g, D), 1);
      }
      function ine(g, D) {
        return uo(y1(g, D), K);
      }
      function one(g, D, k) {
        return k = k === n ? 1 : On(k), uo(y1(g, D), k);
      }
      function mR(g, D) {
        var k = Dn(g) ? Ho : _c;
        return k(g, sn(D, 3));
      }
      function gR(g, D) {
        var k = Dn(g) ? WT : pM;
        return k(g, sn(D, 3));
      }
      var sne = l1(function(g, D, k) {
        fr.call(g, k) ? g[k].push(D) : Uu(g, k, [D]);
      });
      function ane(g, D, k, z) {
        g = fs(g) ? g : uh(g), k = k && !z ? On(k) : 0;
        var re = g.length;
        return k < 0 && (k = ci(re + k, 0)), C1(g) ? k <= re && g.indexOf(D, k) > -1 : !!re && Ic(g, D, k) > -1;
      }
      var lne = _n(function(g, D, k) {
        var z = -1, re = typeof D == "function", ce = fs(g) ? ze(g.length) : [];
        return _c(g, function(ge) {
          ce[++z] = re ? Wo(D, ge, k) : uy(ge, D, k);
        }), ce;
      }), une = l1(function(g, D, k) {
        Uu(g, k, D);
      });
      function y1(g, D) {
        var k = Dn(g) ? Br : vM;
        return k(g, sn(D, 3));
      }
      function cne(g, D, k, z) {
        return g == null ? [] : (Dn(D) || (D = D == null ? [] : [D]), k = z ? n : k, Dn(k) || (k = k == null ? [] : [k]), EM(g, D, k));
      }
      var dne = l1(function(g, D, k) {
        g[k ? 0 : 1].push(D);
      }, function() {
        return [[], []];
      });
      function pne(g, D, k) {
        var z = Dn(g) ? Gg : Xg, re = arguments.length < 3;
        return z(g, sn(D, 4), k, re, _c);
      }
      function fne(g, D, k) {
        var z = Dn(g) ? Vv : Xg, re = arguments.length < 3;
        return z(g, sn(D, 4), k, re, pM);
      }
      function hne(g, D) {
        var k = Dn(g) ? Xi : fM;
        return k(g, x1(sn(D, 3)));
      }
      function mne(g) {
        var D = Dn(g) ? lM : aee;
        return D(g);
      }
      function gne(g, D, k) {
        (k ? Yo(g, D, k) : D === n) ? D = 1 : D = On(D);
        var z = Dn(g) ? LZ : lee;
        return z(g, D);
      }
      function yne(g) {
        var D = Dn(g) ? BZ : cee;
        return D(g);
      }
      function bne(g) {
        if (g == null)
          return 0;
        if (fs(g))
          return C1(g) ? Fc(g) : g.length;
        var D = Io(g);
        return D == be || D == Ie ? g.size : SS(g).length;
      }
      function vne(g, D, k) {
        var z = Dn(g) ? qf : dee;
        return k && Yo(g, D, k) && (D = n), z(g, sn(D, 3));
      }
      var xne = _n(function(g, D) {
        if (g == null)
          return [];
        var k = D.length;
        return k > 1 && Yo(g, D[0], D[1]) ? D = [] : k > 2 && Yo(D[0], D[1], D[2]) && (D = [D[0]]), EM(g, uo(D, 1), []);
      }), b1 = dS || function() {
        return Ri.Date.now();
      };
      function Dne(g, D) {
        if (typeof D != "function")
          throw new ds(s);
        return g = On(g), function() {
          if (--g < 1)
            return D.apply(this, arguments);
        };
      }
      function yR(g, D, k) {
        return D = k ? n : D, D = g && D == null ? g.length : D, Wu(g, $, n, n, n, n, D);
      }
      function bR(g, D) {
        var k;
        if (typeof D != "function")
          throw new ds(s);
        return g = On(g), function() {
          return --g > 0 && (k = D.apply(this, arguments)), g <= 1 && (D = n), k;
        };
      }
      var KS = _n(function(g, D, k) {
        var z = C;
        if (k.length) {
          var re = il(k, ah(KS));
          z |= A;
        }
        return Wu(g, z, D, k, re);
      }), vR = _n(function(g, D, k) {
        var z = C | E;
        if (k.length) {
          var re = il(k, ah(vR));
          z |= A;
        }
        return Wu(D, z, g, k, re);
      });
      function xR(g, D, k) {
        D = k ? n : D;
        var z = Wu(g, w, n, n, n, n, n, D);
        return z.placeholder = xR.placeholder, z;
      }
      function DR(g, D, k) {
        D = k ? n : D;
        var z = Wu(g, O, n, n, n, n, n, D);
        return z.placeholder = DR.placeholder, z;
      }
      function CR(g, D, k) {
        var z, re, ce, ge, we, Me, nt = 0, rt = !1, ut = !1, Nt = !0;
        if (typeof g != "function")
          throw new ds(s);
        D = Ca(D) || 0, oi(k) && (rt = !!k.leading, ut = "maxWait" in k, ce = ut ? ci(Ca(k.maxWait) || 0, D) : ce, Nt = "trailing" in k ? !!k.trailing : Nt);
        function Xt(Ei) {
          var ll = z, Ku = re;
          return z = re = n, nt = Ei, ge = g.apply(Ku, ll), ge;
        }
        function ln(Ei) {
          return nt = Ei, we = hy(Wn, D), rt ? Xt(Ei) : ge;
        }
        function Mn(Ei) {
          var ll = Ei - Me, Ku = Ei - nt, VR = D - ll;
          return ut ? _i(VR, ce - Ku) : VR;
        }
        function un(Ei) {
          var ll = Ei - Me, Ku = Ei - nt;
          return Me === n || ll >= D || ll < 0 || ut && Ku >= ce;
        }
        function Wn() {
          var Ei = b1();
          if (un(Ei))
            return Kn(Ei);
          we = hy(Wn, Mn(Ei));
        }
        function Kn(Ei) {
          return we = n, Nt && z ? Xt(Ei) : (z = re = n, ge);
        }
        function Hs() {
          we !== n && FM(we), nt = 0, z = Me = re = we = n;
        }
        function Ko() {
          return we === n ? ge : Kn(b1());
        }
        function qs() {
          var Ei = b1(), ll = un(Ei);
          if (z = arguments, re = this, Me = Ei, ll) {
            if (we === n)
              return ln(Me);
            if (ut)
              return FM(we), we = hy(Wn, D), Xt(Me);
          }
          return we === n && (we = hy(Wn, D)), ge;
        }
        return qs.cancel = Hs, qs.flush = Ko, qs;
      }
      var Cne = _n(function(g, D) {
        return dM(g, 1, D);
      }), Ene = _n(function(g, D, k) {
        return dM(g, Ca(D) || 0, k);
      });
      function Tne(g) {
        return Wu(g, B);
      }
      function v1(g, D) {
        if (typeof g != "function" || D != null && typeof D != "function")
          throw new ds(s);
        var k = function() {
          var z = arguments, re = D ? D.apply(this, z) : z[0], ce = k.cache;
          if (ce.has(re))
            return ce.get(re);
          var ge = g.apply(this, z);
          return k.cache = ce.set(re, ge) || ce, ge;
        };
        return k.cache = new (v1.Cache || zs)(), k;
      }
      v1.Cache = zs;
      function x1(g) {
        if (typeof g != "function")
          throw new ds(s);
        return function() {
          var D = arguments;
          switch (D.length) {
            case 0:
              return !g.call(this);
            case 1:
              return !g.call(this, D[0]);
            case 2:
              return !g.call(this, D[0], D[1]);
            case 3:
              return !g.call(this, D[0], D[1], D[2]);
          }
          return !g.apply(this, D);
        };
      }
      function Sne(g) {
        return bR(2, g);
      }
      var Ane = pee(function(g, D) {
        D = D.length == 1 && Dn(D[0]) ? Br(D[0], Qi(sn())) : Br(uo(D, 1), Qi(sn()));
        var k = D.length;
        return _n(function(z) {
          for (var re = -1, ce = _i(z.length, k); ++re < ce; )
            z[re] = D[re].call(this, z[re]);
          return Wo(g, this, z);
        });
      }), JS = _n(function(g, D) {
        var k = il(D, ah(JS));
        return Wu(g, A, n, D, k);
      }), ER = _n(function(g, D) {
        var k = il(D, ah(ER));
        return Wu(g, I, n, D, k);
      }), wne = Hu(function(g, D) {
        return Wu(g, L, n, n, n, D);
      });
      function Pne(g, D) {
        if (typeof g != "function")
          throw new ds(s);
        return D = D === n ? D : On(D), _n(g, D);
      }
      function kne(g, D) {
        if (typeof g != "function")
          throw new ds(s);
        return D = D == null ? 0 : ci(On(D), 0), _n(function(k) {
          var z = k[D], re = jc(k, 0, D);
          return z && Ol(re, z), Wo(g, this, re);
        });
      }
      function One(g, D, k) {
        var z = !0, re = !0;
        if (typeof g != "function")
          throw new ds(s);
        return oi(k) && (z = "leading" in k ? !!k.leading : z, re = "trailing" in k ? !!k.trailing : re), CR(g, D, {
          leading: z,
          maxWait: D,
          trailing: re
        });
      }
      function Ine(g) {
        return yR(g, 1);
      }
      function Fne(g, D) {
        return JS(NS(D), g);
      }
      function $ne() {
        if (!arguments.length)
          return [];
        var g = arguments[0];
        return Dn(g) ? g : [g];
      }
      function Nne(g) {
        return va(g, m);
      }
      function Mne(g, D) {
        return D = typeof D == "function" ? D : n, va(g, m, D);
      }
      function Rne(g) {
        return va(g, f | m);
      }
      function _ne(g, D) {
        return D = typeof D == "function" ? D : n, va(g, f | m, D);
      }
      function Lne(g, D) {
        return D == null || cM(g, D, Zi(D));
      }
      function al(g, D) {
        return g === D || g !== g && D !== D;
      }
      var Bne = p1(CS), jne = p1(function(g, D) {
        return g >= D;
      }), sp = gM(/* @__PURE__ */ function() {
        return arguments;
      }()) ? gM : function(g) {
        return di(g) && fr.call(g, "callee") && !ny.call(g, "callee");
      }, Dn = ze.isArray, Vne = Wd ? Qi(Wd) : KZ;
      function fs(g) {
        return g != null && D1(g.length) && !Gu(g);
      }
      function Ci(g) {
        return di(g) && fs(g);
      }
      function zne(g) {
        return g === !0 || g === !1 || di(g) && Go(g) == ae;
      }
      var Vc = pS || aA, Une = jv ? Qi(jv) : JZ;
      function Wne(g) {
        return di(g) && g.nodeType === 1 && !my(g);
      }
      function Hne(g) {
        if (g == null)
          return !0;
        if (fs(g) && (Dn(g) || typeof g == "string" || typeof g.splice == "function" || Vc(g) || lh(g) || sp(g)))
          return !g.length;
        var D = Io(g);
        if (D == be || D == Ie)
          return !g.size;
        if (fy(g))
          return !SS(g).length;
        for (var k in g)
          if (fr.call(g, k))
            return !1;
        return !0;
      }
      function qne(g, D) {
        return cy(g, D);
      }
      function Gne(g, D, k) {
        k = typeof k == "function" ? k : n;
        var z = k ? k(g, D) : n;
        return z === n ? cy(g, D, n, k) : !!z;
      }
      function XS(g) {
        if (!di(g))
          return !1;
        var D = Go(g);
        return D == xe || D == me || typeof g.message == "string" && typeof g.name == "string" && !my(g);
      }
      function Yne(g) {
        return typeof g == "number" && Qv(g);
      }
      function Gu(g) {
        if (!oi(g))
          return !1;
        var D = Go(g);
        return D == le || D == ye || D == oe || D == Qe;
      }
      function TR(g) {
        return typeof g == "number" && g == On(g);
      }
      function D1(g) {
        return typeof g == "number" && g > -1 && g % 1 == 0 && g <= ee;
      }
      function oi(g) {
        var D = typeof g;
        return g != null && (D == "object" || D == "function");
      }
      function di(g) {
        return g != null && typeof g == "object";
      }
      var SR = Hd ? Qi(Hd) : QZ;
      function Kne(g, D) {
        return g === D || TS(g, D, VS(D));
      }
      function Jne(g, D, k) {
        return k = typeof k == "function" ? k : n, TS(g, D, VS(D), k);
      }
      function Xne(g) {
        return AR(g) && g != +g;
      }
      function Qne(g) {
        if (Mee(g))
          throw new fn(o);
        return yM(g);
      }
      function Zne(g) {
        return g === null;
      }
      function ere(g) {
        return g == null;
      }
      function AR(g) {
        return typeof g == "number" || di(g) && Go(g) == Re;
      }
      function my(g) {
        if (!di(g) || Go(g) != Xe)
          return !1;
        var D = Zf(g);
        if (D === null)
          return !0;
        var k = fr.call(D, "constructor") && D.constructor;
        return typeof k == "function" && k instanceof k && Xf.call(k) == $c;
      }
      var QS = ba ? Qi(ba) : ZZ;
      function tre(g) {
        return TR(g) && g >= -ee && g <= ee;
      }
      var wR = Wf ? Qi(Wf) : eee;
      function C1(g) {
        return typeof g == "string" || !Dn(g) && di(g) && Go(g) == Je;
      }
      function Ws(g) {
        return typeof g == "symbol" || di(g) && Go(g) == vt;
      }
      var lh = qg ? Qi(qg) : tee;
      function nre(g) {
        return g === n;
      }
      function rre(g) {
        return di(g) && Io(g) == Lt;
      }
      function ire(g) {
        return di(g) && Go(g) == ke;
      }
      var ore = p1(AS), sre = p1(function(g, D) {
        return g <= D;
      });
      function PR(g) {
        if (!g)
          return [];
        if (fs(g))
          return C1(g) ? js(g) : ps(g);
        if (Nc && g[Nc])
          return QT(g[Nc]());
        var D = Io(g), k = D == be ? Yd : D == Ie ? Il : uh;
        return k(g);
      }
      function Yu(g) {
        if (!g)
          return g === 0 ? g : 0;
        if (g = Ca(g), g === K || g === -K) {
          var D = g < 0 ? -1 : 1;
          return D * te;
        }
        return g === g ? g : 0;
      }
      function On(g) {
        var D = Yu(g), k = D % 1;
        return D === D ? k ? D - k : D : 0;
      }
      function kR(g) {
        return g ? np(On(g), 0, Z) : 0;
      }
      function Ca(g) {
        if (typeof g == "number")
          return g;
        if (Ws(g))
          return M;
        if (oi(g)) {
          var D = typeof g.valueOf == "function" ? g.valueOf() : g;
          g = oi(D) ? D + "" : D;
        }
        if (typeof g != "string")
          return g === 0 ? g : +g;
        g = Qg(g);
        var k = Ke.test(g);
        return k || gt.test(g) ? _v(g.slice(2), k ? 2 : 8) : et.test(g) ? M : +g;
      }
      function OR(g) {
        return Rl(g, hs(g));
      }
      function are(g) {
        return g ? np(On(g), -ee, ee) : g === 0 ? g : 0;
      }
      function yr(g) {
        return g == null ? "" : Us(g);
      }
      var lre = oh(function(g, D) {
        if (fy(D) || fs(D)) {
          Rl(D, Zi(D), g);
          return;
        }
        for (var k in D)
          fr.call(D, k) && ay(g, k, D[k]);
      }), IR = oh(function(g, D) {
        Rl(D, hs(D), g);
      }), E1 = oh(function(g, D, k, z) {
        Rl(D, hs(D), g, z);
      }), ure = oh(function(g, D, k, z) {
        Rl(D, Zi(D), g, z);
      }), cre = Hu(vS);
      function dre(g, D) {
        var k = y(g);
        return D == null ? k : uM(k, D);
      }
      var pre = _n(function(g, D) {
        g = Un(g);
        var k = -1, z = D.length, re = z > 2 ? D[2] : n;
        for (re && Yo(D[0], D[1], re) && (z = 1); ++k < z; )
          for (var ce = D[k], ge = hs(ce), we = -1, Me = ge.length; ++we < Me; ) {
            var nt = ge[we], rt = g[nt];
            (rt === n || al(rt, Bu[nt]) && !fr.call(g, nt)) && (g[nt] = ce[nt]);
          }
        return g;
      }), fre = _n(function(g) {
        return g.push(n, YM), Wo(FR, n, g);
      });
      function hre(g, D) {
        return Wv(g, sn(D, 3), Ml);
      }
      function mre(g, D) {
        return Wv(g, sn(D, 3), DS);
      }
      function gre(g, D) {
        return g == null ? g : xS(g, sn(D, 3), hs);
      }
      function yre(g, D) {
        return g == null ? g : hM(g, sn(D, 3), hs);
      }
      function bre(g, D) {
        return g && Ml(g, sn(D, 3));
      }
      function vre(g, D) {
        return g && DS(g, sn(D, 3));
      }
      function xre(g) {
        return g == null ? [] : i1(g, Zi(g));
      }
      function Dre(g) {
        return g == null ? [] : i1(g, hs(g));
      }
      function ZS(g, D, k) {
        var z = g == null ? n : rp(g, D);
        return z === n ? k : z;
      }
      function Cre(g, D) {
        return g != null && XM(g, D, HZ);
      }
      function eA(g, D) {
        return g != null && XM(g, D, qZ);
      }
      var Ere = UM(function(g, D, k) {
        D != null && typeof D.toString != "function" && (D = Vs.call(D)), g[D] = k;
      }, nA(ms)), Tre = UM(function(g, D, k) {
        D != null && typeof D.toString != "function" && (D = Vs.call(D)), fr.call(g, D) ? g[D].push(k) : g[D] = [k];
      }, sn), Sre = _n(uy);
      function Zi(g) {
        return fs(g) ? aM(g) : SS(g);
      }
      function hs(g) {
        return fs(g) ? aM(g, !0) : nee(g);
      }
      function Are(g, D) {
        var k = {};
        return D = sn(D, 3), Ml(g, function(z, re, ce) {
          Uu(k, D(z, re, ce), z);
        }), k;
      }
      function wre(g, D) {
        var k = {};
        return D = sn(D, 3), Ml(g, function(z, re, ce) {
          Uu(k, re, D(z, re, ce));
        }), k;
      }
      var Pre = oh(function(g, D, k) {
        o1(g, D, k);
      }), FR = oh(function(g, D, k, z) {
        o1(g, D, k, z);
      }), kre = Hu(function(g, D) {
        var k = {};
        if (g == null)
          return k;
        var z = !1;
        D = Br(D, function(ce) {
          return ce = Bc(ce, g), z || (z = ce.length > 1), ce;
        }), Rl(g, BS(g), k), z && (k = va(k, f | h | m, Eee));
        for (var re = D.length; re--; )
          IS(k, D[re]);
        return k;
      });
      function Ore(g, D) {
        return $R(g, x1(sn(D)));
      }
      var Ire = Hu(function(g, D) {
        return g == null ? {} : iee(g, D);
      });
      function $R(g, D) {
        if (g == null)
          return {};
        var k = Br(BS(g), function(z) {
          return [z];
        });
        return D = sn(D), TM(g, k, function(z, re) {
          return D(z, re[0]);
        });
      }
      function Fre(g, D, k) {
        D = Bc(D, g);
        var z = -1, re = D.length;
        for (re || (re = 1, g = n); ++z < re; ) {
          var ce = g == null ? n : g[_l(D[z])];
          ce === n && (z = re, ce = k), g = Gu(ce) ? ce.call(g) : ce;
        }
        return g;
      }
      function $re(g, D, k) {
        return g == null ? g : dy(g, D, k);
      }
      function Nre(g, D, k, z) {
        return z = typeof z == "function" ? z : n, g == null ? g : dy(g, D, k, z);
      }
      var NR = qM(Zi), MR = qM(hs);
      function Mre(g, D, k) {
        var z = Dn(g), re = z || Vc(g) || lh(g);
        if (D = sn(D, 4), k == null) {
          var ce = g && g.constructor;
          re ? k = z ? new ce() : [] : oi(g) ? k = Gu(ce) ? y(Zf(g)) : {} : k = {};
        }
        return (re ? Ho : Ml)(g, function(ge, we, Me) {
          return D(k, ge, we, Me);
        }), k;
      }
      function Rre(g, D) {
        return g == null ? !0 : IS(g, D);
      }
      function _re(g, D, k) {
        return g == null ? g : kM(g, D, NS(k));
      }
      function Lre(g, D, k, z) {
        return z = typeof z == "function" ? z : n, g == null ? g : kM(g, D, NS(k), z);
      }
      function uh(g) {
        return g == null ? [] : Mu(g, Zi(g));
      }
      function Bre(g) {
        return g == null ? [] : Mu(g, hs(g));
      }
      function jre(g, D, k) {
        return k === n && (k = D, D = n), k !== n && (k = Ca(k), k = k === k ? k : 0), D !== n && (D = Ca(D), D = D === D ? D : 0), np(Ca(g), D, k);
      }
      function Vre(g, D, k) {
        return D = Yu(D), k === n ? (k = D, D = 0) : k = Yu(k), g = Ca(g), GZ(g, D, k);
      }
      function zre(g, D, k) {
        if (k && typeof k != "boolean" && Yo(g, D, k) && (D = k = n), k === n && (typeof D == "boolean" ? (k = D, D = n) : typeof g == "boolean" && (k = g, g = n)), g === n && D === n ? (g = 0, D = 1) : (g = Yu(g), D === n ? (D = g, g = 0) : D = Yu(D)), g > D) {
          var z = g;
          g = D, D = z;
        }
        if (k || g % 1 || D % 1) {
          var re = e1();
          return _i(g + re * (D - g + zT("1e-" + ((re + "").length - 1))), D);
        }
        return PS(g, D);
      }
      var Ure = sh(function(g, D, k) {
        return D = D.toLowerCase(), g + (k ? RR(D) : D);
      });
      function RR(g) {
        return tA(yr(g).toLowerCase());
      }
      function _R(g) {
        return g = yr(g), g && g.replace(Pn, KT).replace(Bg, "");
      }
      function Wre(g, D, k) {
        g = yr(g), D = Us(D);
        var z = g.length;
        k = k === n ? z : np(On(k), 0, z);
        var re = k;
        return k -= D.length, k >= 0 && g.slice(k, re) == D;
      }
      function Hre(g) {
        return g = yr(g), g && pn.test(g) ? g.replace(sr, JT) : g;
      }
      function qre(g) {
        return g = yr(g), g && Hr.test(g) ? g.replace(Gn, "\\$&") : g;
      }
      var Gre = sh(function(g, D, k) {
        return g + (k ? "-" : "") + D.toLowerCase();
      }), Yre = sh(function(g, D, k) {
        return g + (k ? " " : "") + D.toLowerCase();
      }), Kre = jM("toLowerCase");
      function Jre(g, D, k) {
        g = yr(g), D = On(D);
        var z = D ? Fc(g) : 0;
        if (!D || z >= D)
          return g;
        var re = (D - z) / 2;
        return d1(Xd(re), k) + g + d1(th(re), k);
      }
      function Xre(g, D, k) {
        g = yr(g), D = On(D);
        var z = D ? Fc(g) : 0;
        return D && z < D ? g + d1(D - z, k) : g;
      }
      function Qre(g, D, k) {
        g = yr(g), D = On(D);
        var z = D ? Fc(g) : 0;
        return D && z < D ? d1(D - z, k) + g : g;
      }
      function Zre(g, D, k) {
        return k || D == null ? D = 0 : D && (D = +D), Zv(yr(g).replace(Qn, ""), D || 0);
      }
      function eie(g, D, k) {
        return (k ? Yo(g, D, k) : D === n) ? D = 1 : D = On(D), kS(yr(g), D);
      }
      function tie() {
        var g = arguments, D = yr(g[0]);
        return g.length < 3 ? D : D.replace(g[1], g[2]);
      }
      var nie = sh(function(g, D, k) {
        return g + (k ? "_" : "") + D.toLowerCase();
      });
      function rie(g, D, k) {
        return k && typeof k != "number" && Yo(g, D, k) && (D = k = n), k = k === n ? Z : k >>> 0, k ? (g = yr(g), g && (typeof D == "string" || D != null && !QS(D)) && (D = Us(D), !D && _u(g)) ? jc(js(g), 0, k) : g.split(D, k)) : [];
      }
      var iie = sh(function(g, D, k) {
        return g + (k ? " " : "") + tA(D);
      });
      function oie(g, D, k) {
        return g = yr(g), k = k == null ? 0 : np(On(k), 0, g.length), D = Us(D), g.slice(k, k + D.length) == D;
      }
      function sie(g, D, k) {
        var z = ue.templateSettings;
        k && Yo(g, D, k) && (D = n), g = yr(g), D = E1({}, D, z, GM);
        var re = E1({}, D.imports, z.imports, GM), ce = Zi(re), ge = Mu(re, ce), we, Me, nt = 0, rt = D.interpolate || tr, ut = "__p += '", Nt = ty(
          (D.escape || tr).source + "|" + rt.source + "|" + (rt === Wr ? Oe : tr).source + "|" + (D.evaluate || tr).source + "|$",
          "g"
        ), Xt = "//# sourceURL=" + (fr.call(D, "sourceURL") ? (D.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++jT + "]") + `
`;
        g.replace(Nt, function(un, Wn, Kn, Hs, Ko, qs) {
          return Kn || (Kn = Hs), ut += g.slice(nt, qs).replace(Uo, qv), Wn && (we = !0, ut += `' +
__e(` + Wn + `) +
'`), Ko && (Me = !0, ut += `';
` + Ko + `;
__p += '`), Kn && (ut += `' +
((__t = (` + Kn + `)) == null ? '' : __t) +
'`), nt = qs + un.length, un;
        }), ut += `';
`;
        var ln = fr.call(D, "variable") && D.variable;
        if (!ln)
          ut = `with (obj) {
` + ut + `
}
`;
        else if (tt.test(ln))
          throw new fn(a);
        ut = (Me ? ut.replace(Ut, "") : ut).replace(an, "$1").replace(wn, "$1;"), ut = "function(" + (ln || "obj") + `) {
` + (ln ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (we ? ", __e = _.escape" : "") + (Me ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + ut + `return __p
}`;
        var Mn = BR(function() {
          return Yn(ce, Xt + "return " + ut).apply(n, ge);
        });
        if (Mn.source = ut, XS(Mn))
          throw Mn;
        return Mn;
      }
      function aie(g) {
        return yr(g).toLowerCase();
      }
      function lie(g) {
        return yr(g).toUpperCase();
      }
      function uie(g, D, k) {
        if (g = yr(g), g && (k || D === n))
          return Qg(g);
        if (!g || !(D = Us(D)))
          return g;
        var z = js(g), re = js(D), ce = Gd(z, re), ge = Zg(z, re) + 1;
        return jc(z, ce, ge).join("");
      }
      function cie(g, D, k) {
        if (g = yr(g), g && (k || D === n))
          return g.slice(0, Kd(g) + 1);
        if (!g || !(D = Us(D)))
          return g;
        var z = js(g), re = Zg(z, js(D)) + 1;
        return jc(z, 0, re).join("");
      }
      function die(g, D, k) {
        if (g = yr(g), g && (k || D === n))
          return g.replace(Qn, "");
        if (!g || !(D = Us(D)))
          return g;
        var z = js(g), re = Gd(z, js(D));
        return jc(z, re).join("");
      }
      function pie(g, D) {
        var k = H, z = q;
        if (oi(D)) {
          var re = "separator" in D ? D.separator : re;
          k = "length" in D ? On(D.length) : k, z = "omission" in D ? Us(D.omission) : z;
        }
        g = yr(g);
        var ce = g.length;
        if (_u(g)) {
          var ge = js(g);
          ce = ge.length;
        }
        if (k >= ce)
          return g;
        var we = k - Fc(z);
        if (we < 1)
          return z;
        var Me = ge ? jc(ge, 0, we).join("") : g.slice(0, we);
        if (re === n)
          return Me + z;
        if (ge && (we += Me.length - we), QS(re)) {
          if (g.slice(we).search(re)) {
            var nt, rt = Me;
            for (re.global || (re = ty(re.source, yr(Fe.exec(re)) + "g")), re.lastIndex = 0; nt = re.exec(rt); )
              var ut = nt.index;
            Me = Me.slice(0, ut === n ? we : ut);
          }
        } else if (g.indexOf(Us(re), we) != we) {
          var Nt = Me.lastIndexOf(re);
          Nt > -1 && (Me = Me.slice(0, Nt));
        }
        return Me + z;
      }
      function fie(g) {
        return g = yr(g), g && er.test(g) ? g.replace(En, Gv) : g;
      }
      var hie = sh(function(g, D, k) {
        return g + (k ? " " : "") + D.toUpperCase();
      }), tA = jM("toUpperCase");
      function LR(g, D, k) {
        return g = yr(g), D = k ? n : D, D === n ? XT(g) ? rS(g) : HT(g) : g.match(D) || [];
      }
      var BR = _n(function(g, D) {
        try {
          return Wo(g, n, D);
        } catch (k) {
          return XS(k) ? k : new fn(k);
        }
      }), mie = Hu(function(g, D) {
        return Ho(D, function(k) {
          k = _l(k), Uu(g, k, KS(g[k], g));
        }), g;
      });
      function gie(g) {
        var D = g == null ? 0 : g.length, k = sn();
        return g = D ? Br(g, function(z) {
          if (typeof z[1] != "function")
            throw new ds(s);
          return [k(z[0]), z[1]];
        }) : [], _n(function(z) {
          for (var re = -1; ++re < D; ) {
            var ce = g[re];
            if (Wo(ce[0], this, z))
              return Wo(ce[1], this, z);
          }
        });
      }
      function yie(g) {
        return zZ(va(g, f));
      }
      function nA(g) {
        return function() {
          return g;
        };
      }
      function bie(g, D) {
        return g == null || g !== g ? D : g;
      }
      var vie = zM(), xie = zM(!0);
      function ms(g) {
        return g;
      }
      function rA(g) {
        return bM(typeof g == "function" ? g : va(g, f));
      }
      function Die(g) {
        return xM(va(g, f));
      }
      function Cie(g, D) {
        return DM(g, va(D, f));
      }
      var Eie = _n(function(g, D) {
        return function(k) {
          return uy(k, g, D);
        };
      }), Tie = _n(function(g, D) {
        return function(k) {
          return uy(g, k, D);
        };
      });
      function iA(g, D, k) {
        var z = Zi(D), re = i1(D, z);
        k == null && !(oi(D) && (re.length || !z.length)) && (k = D, D = g, g = this, re = i1(D, Zi(D)));
        var ce = !(oi(k) && "chain" in k) || !!k.chain, ge = Gu(g);
        return Ho(re, function(we) {
          var Me = D[we];
          g[we] = Me, ge && (g.prototype[we] = function() {
            var nt = this.__chain__;
            if (ce || nt) {
              var rt = g(this.__wrapped__), ut = rt.__actions__ = ps(this.__actions__);
              return ut.push({ func: Me, args: arguments, thisArg: g }), rt.__chain__ = nt, rt;
            }
            return Me.apply(g, Ol([this.value()], arguments));
          });
        }), g;
      }
      function Sie() {
        return Ri._ === this && (Ri._ = lS), this;
      }
      function oA() {
      }
      function Aie(g) {
        return g = On(g), _n(function(D) {
          return CM(D, g);
        });
      }
      var wie = RS(Br), Pie = RS(Hf), kie = RS(qf);
      function jR(g) {
        return US(g) ? Kg(_l(g)) : oee(g);
      }
      function Oie(g) {
        return function(D) {
          return g == null ? n : rp(g, D);
        };
      }
      var Iie = WM(), Fie = WM(!0);
      function sA() {
        return [];
      }
      function aA() {
        return !1;
      }
      function $ie() {
        return {};
      }
      function Nie() {
        return "";
      }
      function Mie() {
        return !0;
      }
      function Rie(g, D) {
        if (g = On(g), g < 1 || g > ee)
          return [];
        var k = Z, z = _i(g, Z);
        D = sn(D), g -= Z;
        for (var re = Nu(z, D); ++k < g; )
          D(k);
        return re;
      }
      function _ie(g) {
        return Dn(g) ? Br(g, _l) : Ws(g) ? [g] : ps(sR(yr(g)));
      }
      function Lie(g) {
        var D = ++aS;
        return yr(g) + D;
      }
      var Bie = c1(function(g, D) {
        return g + D;
      }, 0), jie = _S("ceil"), Vie = c1(function(g, D) {
        return g / D;
      }, 1), zie = _S("floor");
      function Uie(g) {
        return g && g.length ? r1(g, ms, CS) : n;
      }
      function Wie(g, D) {
        return g && g.length ? r1(g, sn(D, 2), CS) : n;
      }
      function Hie(g) {
        return Hv(g, ms);
      }
      function qie(g, D) {
        return Hv(g, sn(D, 2));
      }
      function Gie(g) {
        return g && g.length ? r1(g, ms, AS) : n;
      }
      function Yie(g, D) {
        return g && g.length ? r1(g, sn(D, 2), AS) : n;
      }
      var Kie = c1(function(g, D) {
        return g * D;
      }, 1), Jie = _S("round"), Xie = c1(function(g, D) {
        return g - D;
      }, 0);
      function Qie(g) {
        return g && g.length ? $u(g, ms) : 0;
      }
      function Zie(g, D) {
        return g && g.length ? $u(g, sn(D, 2)) : 0;
      }
      return ue.after = Dne, ue.ary = yR, ue.assign = lre, ue.assignIn = IR, ue.assignInWith = E1, ue.assignWith = ure, ue.at = cre, ue.before = bR, ue.bind = KS, ue.bindAll = mie, ue.bindKey = vR, ue.castArray = $ne, ue.chain = hR, ue.chunk = zee, ue.compact = Uee, ue.concat = Wee, ue.cond = gie, ue.conforms = yie, ue.constant = nA, ue.countBy = Qte, ue.create = dre, ue.curry = xR, ue.curryRight = DR, ue.debounce = CR, ue.defaults = pre, ue.defaultsDeep = fre, ue.defer = Cne, ue.delay = Ene, ue.difference = Hee, ue.differenceBy = qee, ue.differenceWith = Gee, ue.drop = Yee, ue.dropRight = Kee, ue.dropRightWhile = Jee, ue.dropWhile = Xee, ue.fill = Qee, ue.filter = ene, ue.flatMap = rne, ue.flatMapDeep = ine, ue.flatMapDepth = one, ue.flatten = cR, ue.flattenDeep = Zee, ue.flattenDepth = ete, ue.flip = Tne, ue.flow = vie, ue.flowRight = xie, ue.fromPairs = tte, ue.functions = xre, ue.functionsIn = Dre, ue.groupBy = sne, ue.initial = rte, ue.intersection = ite, ue.intersectionBy = ote, ue.intersectionWith = ste, ue.invert = Ere, ue.invertBy = Tre, ue.invokeMap = lne, ue.iteratee = rA, ue.keyBy = une, ue.keys = Zi, ue.keysIn = hs, ue.map = y1, ue.mapKeys = Are, ue.mapValues = wre, ue.matches = Die, ue.matchesProperty = Cie, ue.memoize = v1, ue.merge = Pre, ue.mergeWith = FR, ue.method = Eie, ue.methodOf = Tie, ue.mixin = iA, ue.negate = x1, ue.nthArg = Aie, ue.omit = kre, ue.omitBy = Ore, ue.once = Sne, ue.orderBy = cne, ue.over = wie, ue.overArgs = Ane, ue.overEvery = Pie, ue.overSome = kie, ue.partial = JS, ue.partialRight = ER, ue.partition = dne, ue.pick = Ire, ue.pickBy = $R, ue.property = jR, ue.propertyOf = Oie, ue.pull = cte, ue.pullAll = pR, ue.pullAllBy = dte, ue.pullAllWith = pte, ue.pullAt = fte, ue.range = Iie, ue.rangeRight = Fie, ue.rearg = wne, ue.reject = hne, ue.remove = hte, ue.rest = Pne, ue.reverse = GS, ue.sampleSize = gne, ue.set = $re, ue.setWith = Nre, ue.shuffle = yne, ue.slice = mte, ue.sortBy = xne, ue.sortedUniq = Cte, ue.sortedUniqBy = Ete, ue.split = rie, ue.spread = kne, ue.tail = Tte, ue.take = Ste, ue.takeRight = Ate, ue.takeRightWhile = wte, ue.takeWhile = Pte, ue.tap = Ute, ue.throttle = One, ue.thru = g1, ue.toArray = PR, ue.toPairs = NR, ue.toPairsIn = MR, ue.toPath = _ie, ue.toPlainObject = OR, ue.transform = Mre, ue.unary = Ine, ue.union = kte, ue.unionBy = Ote, ue.unionWith = Ite, ue.uniq = Fte, ue.uniqBy = $te, ue.uniqWith = Nte, ue.unset = Rre, ue.unzip = YS, ue.unzipWith = fR, ue.update = _re, ue.updateWith = Lre, ue.values = uh, ue.valuesIn = Bre, ue.without = Mte, ue.words = LR, ue.wrap = Fne, ue.xor = Rte, ue.xorBy = _te, ue.xorWith = Lte, ue.zip = Bte, ue.zipObject = jte, ue.zipObjectDeep = Vte, ue.zipWith = zte, ue.entries = NR, ue.entriesIn = MR, ue.extend = IR, ue.extendWith = E1, iA(ue, ue), ue.add = Bie, ue.attempt = BR, ue.camelCase = Ure, ue.capitalize = RR, ue.ceil = jie, ue.clamp = jre, ue.clone = Nne, ue.cloneDeep = Rne, ue.cloneDeepWith = _ne, ue.cloneWith = Mne, ue.conformsTo = Lne, ue.deburr = _R, ue.defaultTo = bie, ue.divide = Vie, ue.endsWith = Wre, ue.eq = al, ue.escape = Hre, ue.escapeRegExp = qre, ue.every = Zte, ue.find = tne, ue.findIndex = lR, ue.findKey = hre, ue.findLast = nne, ue.findLastIndex = uR, ue.findLastKey = mre, ue.floor = zie, ue.forEach = mR, ue.forEachRight = gR, ue.forIn = gre, ue.forInRight = yre, ue.forOwn = bre, ue.forOwnRight = vre, ue.get = ZS, ue.gt = Bne, ue.gte = jne, ue.has = Cre, ue.hasIn = eA, ue.head = dR, ue.identity = ms, ue.includes = ane, ue.indexOf = nte, ue.inRange = Vre, ue.invoke = Sre, ue.isArguments = sp, ue.isArray = Dn, ue.isArrayBuffer = Vne, ue.isArrayLike = fs, ue.isArrayLikeObject = Ci, ue.isBoolean = zne, ue.isBuffer = Vc, ue.isDate = Une, ue.isElement = Wne, ue.isEmpty = Hne, ue.isEqual = qne, ue.isEqualWith = Gne, ue.isError = XS, ue.isFinite = Yne, ue.isFunction = Gu, ue.isInteger = TR, ue.isLength = D1, ue.isMap = SR, ue.isMatch = Kne, ue.isMatchWith = Jne, ue.isNaN = Xne, ue.isNative = Qne, ue.isNil = ere, ue.isNull = Zne, ue.isNumber = AR, ue.isObject = oi, ue.isObjectLike = di, ue.isPlainObject = my, ue.isRegExp = QS, ue.isSafeInteger = tre, ue.isSet = wR, ue.isString = C1, ue.isSymbol = Ws, ue.isTypedArray = lh, ue.isUndefined = nre, ue.isWeakMap = rre, ue.isWeakSet = ire, ue.join = ate, ue.kebabCase = Gre, ue.last = Da, ue.lastIndexOf = lte, ue.lowerCase = Yre, ue.lowerFirst = Kre, ue.lt = ore, ue.lte = sre, ue.max = Uie, ue.maxBy = Wie, ue.mean = Hie, ue.meanBy = qie, ue.min = Gie, ue.minBy = Yie, ue.stubArray = sA, ue.stubFalse = aA, ue.stubObject = $ie, ue.stubString = Nie, ue.stubTrue = Mie, ue.multiply = Kie, ue.nth = ute, ue.noConflict = Sie, ue.noop = oA, ue.now = b1, ue.pad = Jre, ue.padEnd = Xre, ue.padStart = Qre, ue.parseInt = Zre, ue.random = zre, ue.reduce = pne, ue.reduceRight = fne, ue.repeat = eie, ue.replace = tie, ue.result = Fre, ue.round = Jie, ue.runInContext = $e, ue.sample = mne, ue.size = bne, ue.snakeCase = nie, ue.some = vne, ue.sortedIndex = gte, ue.sortedIndexBy = yte, ue.sortedIndexOf = bte, ue.sortedLastIndex = vte, ue.sortedLastIndexBy = xte, ue.sortedLastIndexOf = Dte, ue.startCase = iie, ue.startsWith = oie, ue.subtract = Xie, ue.sum = Qie, ue.sumBy = Zie, ue.template = sie, ue.times = Rie, ue.toFinite = Yu, ue.toInteger = On, ue.toLength = kR, ue.toLower = aie, ue.toNumber = Ca, ue.toSafeInteger = are, ue.toString = yr, ue.toUpper = lie, ue.trim = uie, ue.trimEnd = cie, ue.trimStart = die, ue.truncate = pie, ue.unescape = fie, ue.uniqueId = Lie, ue.upperCase = hie, ue.upperFirst = tA, ue.each = mR, ue.eachRight = gR, ue.first = dR, iA(ue, function() {
        var g = {};
        return Ml(ue, function(D, k) {
          fr.call(ue.prototype, k) || (g[k] = D);
        }), g;
      }(), { chain: !1 }), ue.VERSION = r, Ho(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(g) {
        ue[g].placeholder = ue;
      }), Ho(["drop", "take"], function(g, D) {
        T.prototype[g] = function(k) {
          k = k === n ? 1 : ci(On(k), 0);
          var z = this.__filtered__ && !D ? new T(this) : this.clone();
          return z.__filtered__ ? z.__takeCount__ = _i(k, z.__takeCount__) : z.__views__.push({
            size: _i(k, Z),
            type: g + (z.__dir__ < 0 ? "Right" : "")
          }), z;
        }, T.prototype[g + "Right"] = function(k) {
          return this.reverse()[g](k).reverse();
        };
      }), Ho(["filter", "map", "takeWhile"], function(g, D) {
        var k = D + 1, z = k == j || k == G;
        T.prototype[g] = function(re) {
          var ce = this.clone();
          return ce.__iteratees__.push({
            iteratee: sn(re, 3),
            type: k
          }), ce.__filtered__ = ce.__filtered__ || z, ce;
        };
      }), Ho(["head", "last"], function(g, D) {
        var k = "take" + (D ? "Right" : "");
        T.prototype[g] = function() {
          return this[k](1).value()[0];
        };
      }), Ho(["initial", "tail"], function(g, D) {
        var k = "drop" + (D ? "" : "Right");
        T.prototype[g] = function() {
          return this.__filtered__ ? new T(this) : this[k](1);
        };
      }), T.prototype.compact = function() {
        return this.filter(ms);
      }, T.prototype.find = function(g) {
        return this.filter(g).head();
      }, T.prototype.findLast = function(g) {
        return this.reverse().find(g);
      }, T.prototype.invokeMap = _n(function(g, D) {
        return typeof g == "function" ? new T(this) : this.map(function(k) {
          return uy(k, g, D);
        });
      }), T.prototype.reject = function(g) {
        return this.filter(x1(sn(g)));
      }, T.prototype.slice = function(g, D) {
        g = On(g);
        var k = this;
        return k.__filtered__ && (g > 0 || D < 0) ? new T(k) : (g < 0 ? k = k.takeRight(-g) : g && (k = k.drop(g)), D !== n && (D = On(D), k = D < 0 ? k.dropRight(-D) : k.take(D - g)), k);
      }, T.prototype.takeRightWhile = function(g) {
        return this.reverse().takeWhile(g).reverse();
      }, T.prototype.toArray = function() {
        return this.take(Z);
      }, Ml(T.prototype, function(g, D) {
        var k = /^(?:filter|find|map|reject)|While$/.test(D), z = /^(?:head|last)$/.test(D), re = ue[z ? "take" + (D == "last" ? "Right" : "") : D], ce = z || /^find/.test(D);
        re && (ue.prototype[D] = function() {
          var ge = this.__wrapped__, we = z ? [1] : arguments, Me = ge instanceof T, nt = we[0], rt = Me || Dn(ge), ut = function(Wn) {
            var Kn = re.apply(ue, Ol([Wn], we));
            return z && Nt ? Kn[0] : Kn;
          };
          rt && k && typeof nt == "function" && nt.length != 1 && (Me = rt = !1);
          var Nt = this.__chain__, Xt = !!this.__actions__.length, ln = ce && !Nt, Mn = Me && !Xt;
          if (!ce && rt) {
            ge = Mn ? ge : new T(this);
            var un = g.apply(ge, we);
            return un.__actions__.push({ func: g1, args: [ut], thisArg: n }), new b(un, Nt);
          }
          return ln && Mn ? g.apply(this, we) : (un = this.thru(ut), ln ? z ? un.value()[0] : un.value() : un);
        });
      }), Ho(["pop", "push", "shift", "sort", "splice", "unshift"], function(g) {
        var D = Jt[g], k = /^(?:push|sort|unshift)$/.test(g) ? "tap" : "thru", z = /^(?:pop|shift)$/.test(g);
        ue.prototype[g] = function() {
          var re = arguments;
          if (z && !this.__chain__) {
            var ce = this.value();
            return D.apply(Dn(ce) ? ce : [], re);
          }
          return this[k](function(ge) {
            return D.apply(Dn(ge) ? ge : [], re);
          });
        };
      }), Ml(T.prototype, function(g, D) {
        var k = ue[D];
        if (k) {
          var z = k.name + "";
          fr.call(Rc, z) || (Rc[z] = []), Rc[z].push({ name: D, func: k });
        }
      }), Rc[u1(n, E).name] = [{
        name: "wrapper",
        func: n
      }], T.prototype.clone = F, T.prototype.reverse = Y, T.prototype.value = ie, ue.prototype.at = Wte, ue.prototype.chain = Hte, ue.prototype.commit = qte, ue.prototype.next = Gte, ue.prototype.plant = Kte, ue.prototype.reverse = Jte, ue.prototype.toJSON = ue.prototype.valueOf = ue.prototype.value = Xte, ue.prototype.first = ue.prototype.head, Nc && (ue.prototype[Nc] = Yte), ue;
    }, Lu = iS();
    Fu ? ((Fu.exports = Lu)._ = Lu, Wg._ = Lu) : Ri._ = Lu;
  }).call(Kr);
})(RD, RD.exports);
var vo = RD.exports, Wke = Vm;
function Hke(e, t, n) {
  for (var r = -1, i = e.length; ++r < i; ) {
    var o = e[r], s = t(o);
    if (s != null && (a === void 0 ? s === s && !Wke(s) : n(s, a)))
      var a = s, u = o;
  }
  return u;
}
var qke = Hke;
function Gke(e, t) {
  return e > t;
}
var Yke = Gke, Kke = qke, Jke = Yke, Xke = bc;
function Qke(e, t) {
  return e && e.length ? Kke(e, Xke(t), Jke) : void 0;
}
var Zke = Qke;
const iI = /* @__PURE__ */ Ln(Zke);
function eOe(e, t, n, r, i) {
  return i(e, function(o, s, a) {
    n = r ? (r = !1, o) : t(n, o, s, a);
  }), n;
}
var tOe = eOe, nOe = r9, rOe = Pb, iOe = bc, oOe = tOe, sOe = yi;
function aOe(e, t, n) {
  var r = sOe(e) ? nOe : oOe, i = arguments.length < 3;
  return r(e, iOe(t), n, i, rOe);
}
var lOe = aOe;
const XL = /* @__PURE__ */ Ln(lOe);
var uOe = jm;
function cOe(e, t) {
  return uOe(t, function(n) {
    return [n, e[n]];
  });
}
var dOe = cOe;
function pOe(e) {
  var t = -1, n = Array(e.size);
  return e.forEach(function(r) {
    n[++t] = [r, r];
  }), n;
}
var fOe = pOe, hOe = dOe, mOe = cf, gOe = L9, yOe = fOe, bOe = "[object Map]", vOe = "[object Set]";
function xOe(e) {
  return function(t) {
    var n = mOe(t);
    return n == bOe ? gOe(t) : n == vOe ? yOe(t) : hOe(t, e(t));
  };
}
var DOe = xOe, COe = DOe, EOe = yc, TOe = COe(EOe), SOe = TOe;
const AOe = /* @__PURE__ */ Ln(SOe);
var PA, QL;
function wOe() {
  if (QL) return PA;
  QL = 1;
  var e = Pb;
  function t(n, r) {
    var i;
    return e(n, function(o, s, a) {
      return i = r(o, s, a), !i;
    }), !!i;
  }
  return PA = t, PA;
}
var kA, ZL;
function POe() {
  if (ZL) return kA;
  ZL = 1;
  var e = N9, t = bc, n = wOe(), r = yi, i = GC;
  function o(s, a, u) {
    var c = r(s) ? e : n;
    return u && i(s, a, u) && (a = void 0), c(s, t(a));
  }
  return kA = o, kA;
}
var kOe = cE, MV = kOe("some", POe());
MV.placeholder = Ib();
var OOe = MV, IOe = OOe;
const RV = /* @__PURE__ */ Ln(IOe);
var OA, eB;
function FOe() {
  if (eB) return OA;
  eB = 1;
  function e(t, n) {
    for (var r = -1, i = t == null ? 0 : t.length; ++r < i; )
      if (!n(t[r], r, t))
        return !1;
    return !0;
  }
  return OA = e, OA;
}
var IA, tB;
function $Oe() {
  if (tB) return IA;
  tB = 1;
  var e = Pb;
  function t(n, r) {
    var i = !0;
    return e(n, function(o, s, a) {
      return i = !!r(o, s, a), i;
    }), i;
  }
  return IA = t, IA;
}
var FA, nB;
function NOe() {
  if (nB) return FA;
  nB = 1;
  var e = FOe(), t = $Oe(), n = bc, r = yi, i = GC;
  function o(s, a, u) {
    var c = r(s) ? e : t;
    return u && i(s, a, u) && (a = void 0), c(s, n(a));
  }
  return FA = o, FA;
}
var MOe = cE, _V = MOe("every", NOe());
_V.placeholder = Ib();
var ROe = _V, _Oe = ROe;
const Ux = /* @__PURE__ */ Ln(_Oe), Wx = "additionalProperties", Hx = "required", LOe = (e, t) => {
  const n = {};
  return e.filter((r) => {
    const i = t(r);
    return Object.prototype.hasOwnProperty.call(n, i) ? !1 : (n[i] = !0, !0);
  });
};
class BOe {
  constructor(t) {
    this.findOption = t, this.schemaObject = (n) => {
      const r = this.properties(n), i = {
        type: "object",
        properties: r,
        additionalProperties: this.findOption(r)(Wx)
      }, o = this.findOption(r)(Hx);
      return o.length > 0 && (i.required = o), i;
    }, this.properties = (n) => {
      const r = {};
      return Object.keys(n).reduce((i, o) => (i[o] = this.property(n[o]), i), r);
    }, this.property = (n) => {
      switch (typeof n) {
        case "string":
          return { type: "string" };
        case "boolean":
          return { type: "boolean" };
        case "number":
          return Number.isInteger(n) ? { type: "integer" } : { type: "number" };
        case "object":
          return n == null ? { type: "null" } : this.schemaObjectOrArray(n);
        default:
          return {};
      }
    }, this.schemaObjectOrArray = (n) => n instanceof Array ? this.schemaArray(n) : this.schemaObject(n), this.schemaArray = (n) => {
      if (n.length > 0) {
        const r = n.map(this.property), i = LOe(r, (o) => JSON.stringify(o));
        return i.length === 1 ? {
          type: "array",
          items: i[0]
        } : {
          type: "array",
          items: {
            oneOf: i
          }
        };
      } else
        return {
          type: "array",
          items: {}
        };
    };
  }
}
const LV = (e, t = {}) => {
  const n = (i) => (o) => {
    switch (o) {
      case Wx:
        return Object.prototype.hasOwnProperty.call(t, Wx) ? t[Wx] : !0;
      case Hx:
        return Object.prototype.hasOwnProperty.call(t, Hx) ? t[Hx](i) : Object.keys(i);
      default:
        return;
    }
  };
  return new BOe(n).schemaObject(e);
}, oI = /* @__PURE__ */ new Set(), BV = (e, t) => t <= 1 ? e : e + t.toString(), jOe = (e, t) => {
  const n = BV(e, t);
  return !oI.has(n);
}, $P = (e) => {
  e === void 0 && (e = "undefined");
  let t = 0;
  for (; !jOe(e, t); )
    t++;
  const n = BV(e, t);
  return oI.add(n), n;
}, NP = (e) => oI.delete(e), pf = (e, t) => {
  let n = e;
  return !xn(e) && !xn(t) && !t.startsWith("[") && (n = e + "."), xn(n) ? t : xn(t) ? n : `${n}${t}`;
}, dE = (e) => {
  const r = e.replace(/(anyOf|allOf|oneOf)\/[\d]+\//g, "").replace(/(then|else)\//g, "").split("/").map(Fb), o = r[0] === "#" || r[0] === "" ? 2 : 1;
  return Sb(o, r.length, 2).map((s) => r[s]);
}, _D = (e) => e == null ? void 0 : e.replace(/~/g, "~0").replace(/\//g, "~1"), Fb = (e) => e == null ? void 0 : e.replace(/~1/g, "/").replace(/~0/, "~"), LD = (e) => `/properties/${e.split(".").map((t) => _D(t)).join("/properties/")}`, $A = (e, t) => {
  if (t && typeof t.title == "string")
    return t.title;
  if (typeof e.scope == "string") {
    const n = e.scope, r = Fb(n.substr(n.lastIndexOf("/") + 1));
    return UO(r);
  }
  return "";
}, VOe = (e, t) => {
  const n = e.label;
  if (typeof n == "boolean")
    return N1($A(e, t), n);
  if (typeof n == "string")
    return N1(n, !0);
  if (typeof n == "object") {
    const r = typeof n.text == "string" ? n.text : $A(e, t), i = typeof n.show == "boolean" ? n.show : !0;
    return N1(r, i);
  }
  return N1($A(e, t), !0);
}, N1 = (e, t) => ({
  text: e,
  show: t
}), MP = (e, t) => xn(t) ? e : t.split(".").reduce((r, i) => {
  if (!(!r || !Object.prototype.hasOwnProperty.call(r, i)))
    return r[i];
}, e), zOe = (e) => e === "#" || e === void 0 || e === "", ls = (e, t, n) => {
  const r = t == null ? void 0 : t.split("/").map(Fb);
  return qx(e, r, n);
}, qx = (e, t, n) => {
  if (xn(e))
    return;
  if (e.$ref && (e = ls(n, e.$ref, n)), !t || t.length === 0)
    return e;
  const [r, ...i] = t;
  if (zOe(r))
    return qx(e, i, n);
  const o = mn(e, r), s = qx(o, i, n);
  if (s)
    return s;
  if (r === "properties" || r === "items") {
    let a;
    const u = [].concat(e.oneOf ?? [], e.allOf ?? [], e.anyOf ?? [], e.then ?? [], e.else ?? []);
    for (const c of u)
      if (a = qx(c, [r, ...i], n), a)
        break;
    return a;
  }
};
var hu;
(function(e) {
  e.HIDE = "HIDE", e.SHOW = "SHOW", e.ENABLE = "ENABLE", e.DISABLE = "DISABLE";
})(hu || (hu = {}));
const RP = (e, t) => {
  var n;
  if (qOe(e)) {
    if (zV(e) && e.scope.endsWith(LD(t)))
      return e;
    if ((n = e.options) != null && n.detail)
      return RP(e.options.detail, t);
  }
  if (sI(e))
    for (const r of e.elements) {
      const i = RP(r, t);
      if (i !== void 0)
        return i;
    }
}, jV = (e, t) => {
  if (!zV(e))
    return t ?? "";
  const n = dE(e.scope);
  return xn(n) ? t ?? "" : pf(t, n.join("."));
}, VV = (e) => typeof e == "object" && e !== null && typeof e.i18n == "string", UOe = (e) => e.type === "Group", sI = (e) => e.elements !== void 0, WOe = (e) => !!e && typeof e == "object", zV = (e) => WOe(e) && typeof e.scope == "string", HOe = (e) => !!e && typeof e == "object", qOe = (e) => e.type === "Control", GOe = (e) => e.type === "OR", YOe = (e) => e.type === "AND", KOe = (e) => e.type === "LEAF", JOe = (e) => rr(e, "schema"), rB = (e, t) => jV(e, t), _P = (e, t, n, r) => {
  if (YOe(t))
    return t.conditions.reduce((i, o) => i && _P(e, o, n, r), !0);
  if (GOe(t))
    return t.conditions.reduce((i, o) => i || _P(e, o, n, r), !1);
  if (KOe(t))
    return MP(e, rB(t, n)) === t.expectedValue;
  if (JOe(t)) {
    const i = MP(e, rB(t, n));
    return t.failWhenUndefined && i === void 0 ? !1 : r.validate(t.schema, i);
  } else
    return !0;
}, UV = (e, t, n, r) => {
  const i = e.rule.condition;
  return _P(t, i, n, r);
}, XOe = (e, t, n = void 0, r) => {
  const i = UV(e, t, n, r);
  switch (e.rule.effect) {
    case hu.HIDE:
      return !i;
    case hu.SHOW:
      return i;
    default:
      return !0;
  }
}, QOe = (e, t, n = void 0, r) => {
  const i = UV(e, t, n, r);
  switch (e.rule.effect) {
    case hu.DISABLE:
      return !i;
    case hu.ENABLE:
      return i;
    default:
      return !0;
  }
}, aI = (e) => !!(e.rule && (e.rule.effect === hu.SHOW || e.rule.effect === hu.HIDE)), ZOe = (e) => !!(e.rule && (e.rule.effect === hu.ENABLE || e.rule.effect === hu.DISABLE)), Ed = (e, t, n = void 0, r) => e.rule ? XOe(e, t, n, r) : !0, e2e = (e, t, n = void 0, r) => e.rule ? QOe(e, t, n, r) : !0, t2e = (e) => {
  if (e && typeof e == "object" && "properties" in e && e.properties)
    return G9(Object.keys(e.properties), (t) => {
      const n = e.properties[t];
      return n && typeof n == "object" && "type" in n && (n.type === "string" || n.type === "number" || n.type === "integer");
    });
}, I0 = (e) => !!e && Object.prototype.hasOwnProperty.call(e, "oneOf") && e.oneOf && e.oneOf.every((t) => t.const !== void 0), WV = (e) => !!e && typeof e == "object" && (Object.prototype.hasOwnProperty.call(e, "enum") || Object.prototype.hasOwnProperty.call(e, "const")), n2e = (e, t) => {
  const n = e.toISOString();
  return t === "date-time" ? n : t === "date" ? n.split("T")[0] : t === "time" ? n.split("T")[1].split(".")[0] : n;
}, to = (e, t) => K9(Np(e), t), Np = (e) => {
  if (xn(e))
    return [];
  if (!xn(e.type) && typeof e.type == "string")
    return [e.type];
  if (n9(e.type))
    return e.type;
  if (!xn(e.properties) || !xn(e.additionalProperties))
    return ["object"];
  if (!xn(e.items))
    return ["array"];
  if (!xn(e.enum)) {
    const t = /* @__PURE__ */ new Set();
    return e.enum.forEach((n) => {
      typeof n == "string" ? t.add("string") : Np(n).forEach((r) => t.add(r));
    }), Array.from(t);
  }
  if (!xn(e.allOf)) {
    const t = G9(e.allOf, (n) => Np(n).length !== 0);
    if (t)
      return Np(t);
  }
  return [];
}, xo = {
  schema: ls,
  data: MP
}, r2e = (e) => dE(e.scope).join("."), Xm = {
  compose: pf,
  fromScoped: r2e
}, LP = (e) => {
  const t = new Fxe({
    allErrors: !0,
    verbose: !0,
    strict: !1,
    addUsedSchema: !1,
    ...e
  });
  return Nxe(t), t;
}, Ju = (e, t) => e === void 0 ? [] : e(t) ? [] : e.errors, lI = "YYYY-MM-DD", i2e = "HH:mm:ss", o2e = "YYYY-MM-DDTHH:mm:ss.sssZ", s2e = (e) => {
  switch (e.keyword) {
    case "required":
    case "dependencies":
      return e.params.missingProperty;
    case "additionalProperties":
      return e.params.additionalProperty;
    default:
      return;
  }
}, F0 = (e) => {
  let t = e.dataPath || e.instancePath || "";
  t = t.replace(/\//g, ".");
  const n = s2e(e);
  return n !== void 0 && !t.endsWith(n) && (t = `${t}.${n}`), t = t.replace(/^./, ""), t = Fb(t), t;
}, HV = (e, t, n) => (r) => {
  const i = uL(r, (o) => o.keyword === "oneOf" || o.keyword === "anyOf").map((o) => F0(o));
  return uL(r, (o) => {
    if (l2e.indexOf(o.keyword) !== -1 && !I0(o.parentSchema))
      return !1;
    const s = F0(o);
    let a = n(s);
    const u = o.parentSchema;
    return a && !a2e(u) && !I0(u) && i.findIndex((c) => e.startsWith(c)) !== -1 && (a = a && K7(u, t)), a;
  });
}, a2e = (e) => (e == null ? void 0 : e.type) === "object" || !!(e != null && e.properties), l2e = [
  "additionalProperties",
  "allOf",
  "anyOf",
  "oneOf"
], qV = (e) => e == null ? "" : e.join(`
`), GV = (e) => ({
  type: e,
  elements: []
}), Gx = (e) => ({
  type: "Control",
  scope: e
}), u2e = (e, t) => {
  if (!xn(e) && !sI(e)) {
    const n = GV(t);
    return n.elements.push(e), n;
  }
  return e;
}, c2e = (e, t) => {
  if (!xn(t)) {
    const n = UO(t);
    if (UOe(e))
      e.label = n;
    else {
      const r = {
        type: "Label",
        text: n
      };
      e.elements.push(r);
    }
  }
}, d2e = (e) => !xn(e) && (!xn(e.oneOf) || !xn(e.anyOf) || !xn(e.allOf)), BP = (e, t, n, r, i, o) => {
  if (!xn(e) && e.$ref !== void 0)
    return BP(ls(o, e.$ref, o), t, n, r, i, o);
  if (d2e(e)) {
    const a = Gx(n);
    return t.push(a), a;
  }
  const s = Np(e);
  if (s.length === 0)
    return null;
  if (s.length > 1) {
    const a = Gx(n);
    return t.push(a), a;
  }
  if (n === "#" && s[0] === "object") {
    const a = GV(i);
    if (t.push(a), e.properties && Ade(e.properties).length > 1 && c2e(a, r), !xn(e.properties)) {
      const u = n + "/properties";
      Object.keys(e.properties).map((c) => {
        let d = e.properties[c];
        const f = `${u}/${_D(c)}`;
        d.$ref !== void 0 && (d = ls(o, d.$ref, o)), BP(d, a.elements, f, c, i, o);
      });
    }
    return a;
  }
  switch (s[0]) {
    case "object":
    case "array":
    case "string":
    case "number":
    case "integer":
    case "null":
    case "boolean": {
      const a = Gx(n);
      return t.push(a), a;
    }
    default:
      throw new Error("Unknown type: " + JSON.stringify(e));
  }
}, YV = (e, t = "VerticalLayout", n = "#", r = e) => u2e(BP(e, [], n, "", t, r), t), Wp = {
  jsonSchema: LV,
  uiSchema: YV,
  controlElement: Gx
}, uI = "jsonforms/INIT", cI = "jsonforms/UPDATE_CORE", dI = "jsonforms/SET_AJV", pI = "jsonforms/UPDATE", fI = "jsonforms/UPDATE_ERRORS", p2e = "jsonforms/VALIDATE", KV = "jsonforms/ADD_RENDERER", JV = "jsonforms/REMOVE_RENDERER", XV = "jsonforms/ADD_CELL", QV = "jsonforms/REMOVE_CELL", hI = "jsonforms/SET_CONFIG", ZV = "jsonforms/ADD_UI_SCHEMA", ez = "jsonforms/REMOVE_UI_SCHEMA", mI = "jsonforms/SET_SCHEMA", gI = "jsonforms/SET_UISCHEMA", yI = "jsonforms/SET_VALIDATION_MODE", bI = "jsonforms/SET_LOCALE", vI = "jsonforms/SET_TRANSLATOR", xI = "jsonforms/UPDATE_I18N", tz = "jsonforms/ADD_DEFAULT_DATA", nz = "jsonforms/REMOVE_DEFAULT_DATA", f2e = (e) => {
  if (!("type" in e) || typeof e.type != "string")
    return !1;
  switch (e.type) {
    case "ADD":
      return "values" in e && Array.isArray(e.values) && e.values.length > 0;
    case "REMOVE":
      return "indices" in e && Array.isArray(e.indices) && e.indices.length > 0 && e.indices.every((t) => typeof t == "number");
    case "MOVE":
      return "moves" in e && Array.isArray(e.moves) && e.moves.length > 0 && e.moves.every((t) => typeof t == "object" && t !== null && "from" in t && "to" in t && typeof t.from == "number" && typeof t.to == "number");
    default:
      return !1;
  }
}, h2e = (e, t = LV(e), n, r) => ({
  type: uI,
  data: e,
  schema: t,
  uischema: typeof n == "object" ? n : YV(t),
  options: r
}), m2e = (e, t, n, r) => ({
  type: cI,
  data: e,
  schema: t,
  uischema: n,
  options: r
}), g2e = (e, t) => ({
  type: tz,
  schemaPath: e,
  data: t
}), y2e = (e) => ({
  type: nz,
  schemaPath: e
}), b2e = (e) => ({
  type: dI,
  ajv: e
}), Oa = (e, t, n) => ({
  type: pI,
  path: e,
  updater: t,
  context: n
}), v2e = (e) => ({
  type: fI,
  errors: e
}), x2e = (e, t) => ({
  type: KV,
  tester: e,
  renderer: t
}), D2e = (e, t) => ({
  type: XV,
  tester: e,
  cell: t
}), C2e = (e, t) => ({
  type: QV,
  tester: e,
  cell: t
}), E2e = (e, t) => ({
  type: JV,
  tester: e,
  renderer: t
}), T2e = (e) => ({
  type: hI,
  config: e
}), S2e = (e) => ({
  type: yI,
  validationMode: e
}), A2e = (e, t) => ({
  type: ZV,
  tester: e,
  uischema: t
}), w2e = (e) => ({
  type: ez,
  tester: e
}), P2e = (e) => ({
  type: bI,
  locale: e
}), k2e = (e) => ({
  type: mI,
  schema: e
}), O2e = (e, t) => ({
  type: vI,
  translator: e,
  errorTranslator: t
}), I2e = (e, t, n) => ({
  type: xI,
  locale: e,
  translator: t,
  errorTranslator: n
}), F2e = (e) => ({
  type: gI,
  uischema: e
});
var ph = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  INIT: uI,
  UPDATE_CORE: cI,
  SET_AJV: dI,
  UPDATE_DATA: pI,
  UPDATE_ERRORS: fI,
  VALIDATE: p2e,
  ADD_RENDERER: KV,
  REMOVE_RENDERER: JV,
  ADD_CELL: XV,
  REMOVE_CELL: QV,
  SET_CONFIG: hI,
  ADD_UI_SCHEMA: ZV,
  REMOVE_UI_SCHEMA: ez,
  SET_SCHEMA: mI,
  SET_UISCHEMA: gI,
  SET_VALIDATION_MODE: yI,
  SET_LOCALE: bI,
  SET_TRANSLATOR: vI,
  UPDATE_I18N: xI,
  ADD_DEFAULT_DATA: tz,
  REMOVE_DEFAULT_DATA: nz,
  isUpdateArrayContext: f2e,
  init: h2e,
  updateCore: m2e,
  registerDefaultData: g2e,
  unregisterDefaultData: y2e,
  setAjv: b2e,
  update: Oa,
  updateErrors: v2e,
  registerRenderer: x2e,
  registerCell: D2e,
  unregisterCell: C2e,
  unregisterRenderer: E2e,
  setConfig: T2e,
  setValidationMode: S2e,
  registerUISchema: A2e,
  unregisterUISchema: w2e,
  setLocale: P2e,
  setSchema: k2e,
  setTranslator: O2e,
  updateI18n: I2e,
  setUISchema: F2e
});
const $2e = {
  restrict: !1,
  trim: !1,
  showUnfocusedDescription: !1,
  hideRequiredAsterisk: !1,
  allowDynamicCheck: !1
}, iB = (e = {}) => qn({}, $2e, e), oB = (e = iB(), t) => {
  switch (t.type) {
    case hI:
      return iB(t.config);
    default:
      return e;
  }
}, N2e = {
  data: {},
  schema: {},
  uischema: void 0,
  errors: [],
  validator: void 0,
  ajv: void 0,
  validationMode: "ValidateAndShow",
  additionalErrors: []
}, sB = (e, t) => t && M2e(t.options) ? t.options.validationMode : e.validationMode, M2e = (e) => e ? e.validationMode !== void 0 : !1, R2e = (e) => e ? e.additionalErrors !== void 0 : !1, aB = (e, t) => t && R2e(t.options) ? t.options.additionalErrors : e.additionalErrors, lB = (e, t) => {
  if (t) {
    if (_2e(t.options))
      return t.options.ajv;
    if (t.options !== void 0 && vo.isFunction(t.options.compile))
      return t.options;
  }
  return e.ajv ? e.ajv : LP();
}, _2e = (e) => e ? e.ajv !== void 0 : !1, NA = (e = N2e, t) => {
  switch (t.type) {
    case uI: {
      const n = lB(e, t), r = sB(e, t), i = r === "NoValidation" ? void 0 : n.compile(t.schema), o = Ju(i, t.data), s = aB(e, t);
      return {
        ...e,
        data: t.data,
        schema: t.schema,
        uischema: t.uischema,
        additionalErrors: s,
        errors: o,
        validator: i,
        ajv: n,
        validationMode: r
      };
    }
    case cI: {
      const n = lB(e, t), r = sB(e, t);
      let i = e.validator, o = e.errors;
      e.schema !== t.schema || e.validationMode !== r || e.ajv !== n ? (i = r === "NoValidation" ? void 0 : n.compile(t.schema), o = Ju(i, t.data)) : e.data !== t.data && (o = Ju(i, t.data));
      const s = aB(e, t);
      return e.data !== t.data || e.schema !== t.schema || e.uischema !== t.uischema || e.ajv !== n || e.errors !== o || e.validator !== i || e.validationMode !== r || e.additionalErrors !== s ? {
        ...e,
        data: t.data,
        schema: t.schema,
        uischema: t.uischema,
        ajv: n,
        errors: K7(o, e.errors) ? e.errors : o,
        validator: i,
        validationMode: r,
        additionalErrors: s
      } : e;
    }
    case dI: {
      const n = t.ajv, r = e.validationMode === "NoValidation" ? void 0 : n.compile(e.schema), i = Ju(r, e.data);
      return {
        ...e,
        validator: r,
        errors: i
      };
    }
    case mI: {
      const r = t.schema && e.ajv && e.validationMode !== "NoValidation" ? e.ajv.compile(t.schema) : e.validator, i = Ju(r, e.data);
      return {
        ...e,
        validator: r,
        schema: t.schema,
        errors: i
      };
    }
    case gI:
      return {
        ...e,
        uischema: t.uischema
      };
    case pI: {
      if (t.path === void 0 || t.path === null)
        return e;
      if (t.path === "") {
        const n = t.updater(FD(e.data)), r = Ju(e.validator, n);
        return {
          ...e,
          data: n,
          errors: r
        };
      } else {
        const n = mn(e.data, t.path), r = t.updater(FD(n));
        let i;
        r !== void 0 ? i = Pke(t.path, r, e.data === void 0 ? {} : e.data) : i = Uke(t.path, e.data === void 0 ? {} : e.data);
        const o = Ju(e.validator, i);
        return {
          ...e,
          data: i,
          errors: o
        };
      }
    }
    case fI:
      return {
        ...e,
        errors: t.errors
      };
    case yI: {
      if (e.validationMode === t.validationMode)
        return e;
      if (t.validationMode === "NoValidation") {
        const n = Ju(void 0, e.data);
        return {
          ...e,
          errors: n,
          validationMode: t.validationMode
        };
      }
      if (e.validationMode === "NoValidation") {
        const n = e.ajv.compile(e.schema), r = Ju(n, e.data);
        return {
          ...e,
          validator: n,
          errors: r,
          validationMode: t.validationMode
        };
      }
      return {
        ...e,
        validationMode: t.validationMode
      };
    }
    default:
      return e;
  }
};
var No;
(function(e) {
  e.addTooltip = "addTooltip", e.addAriaLabel = "addAriaLabel", e.removeTooltip = "removeTooltip", e.upAriaLabel = "upAriaLabel", e.downAriaLabel = "downAriaLabel", e.noSelection = "noSelection", e.removeAriaLabel = "removeAriaLabel", e.noDataMessage = "noDataMessage", e.deleteDialogTitle = "deleteDialogTitle", e.deleteDialogMessage = "deleteDialogMessage", e.deleteDialogAccept = "deleteDialogAccept", e.deleteDialogDecline = "deleteDialogDecline", e.up = "up", e.down = "down";
})(No || (No = {}));
const L2e = [
  {
    key: No.addTooltip,
    default: (e) => e ? `Add to ${e}` : "Add"
  },
  {
    key: No.addAriaLabel,
    default: (e) => e ? `Add to ${e} button` : "Add button"
  },
  { key: No.removeTooltip, default: () => "Delete" },
  { key: No.removeAriaLabel, default: () => "Delete button" },
  { key: No.upAriaLabel, default: () => "Move item up" },
  { key: No.up, default: () => "Up" },
  { key: No.down, default: () => "Down" },
  { key: No.downAriaLabel, default: () => "Move item down" },
  { key: No.noDataMessage, default: () => "No data" },
  { key: No.noSelection, default: () => "No selection" },
  {
    key: No.deleteDialogTitle,
    default: () => "Confirm Deletion"
  },
  {
    key: No.deleteDialogMessage,
    default: () => "Are you sure you want to delete the selected entry?"
  },
  { key: No.deleteDialogAccept, default: () => "Yes" },
  { key: No.deleteDialogDecline, default: () => "No" }
];
var Fh;
(function(e) {
  e.clearDialogTitle = "clearDialogTitle", e.clearDialogMessage = "clearDialogMessage", e.clearDialogAccept = "clearDialogAccept", e.clearDialogDecline = "clearDialogDecline";
})(Fh || (Fh = {}));
Fh.clearDialogTitle, Fh.clearDialogMessage, Fh.clearDialogAccept, Fh.clearDialogDecline;
const DI = (e, t) => VV(t) ? t.i18n : (e == null ? void 0 : e.i18n) ?? void 0, B2e = (e) => (e == null ? void 0 : e.split(".").filter((t) => !/^\d+$/.test(t)).join(".")) || "root", Ba = (e, t, n) => DI(e, t) ?? B2e(n), BD = (e, t, n, r) => `${Ba(e, t, n)}.${r}`, j2e = (e, t) => `${e}.${t}`, CI = (e, t) => t, EI = (e, t, n) => {
  var a;
  const r = BD(e.parentSchema, n, F0(e), `error.${e.keyword}`), i = t(r, void 0, { error: e });
  if (i !== void 0)
    return i;
  const o = t(`error.${e.keyword}`, void 0, {
    error: e
  });
  if (o !== void 0)
    return o;
  const s = t(e.message, void 0, { error: e });
  return s !== void 0 ? s : e.keyword === "required" && ((a = e.message) != null && a.startsWith("must have required property")) ? t("is a required property", "is a required property", { error: e }) : e.message;
}, TI = (e, t, n, r, i, o) => {
  if (e.length > 0 && n) {
    const s = BD(r, i, o, "error.custom"), a = n(s, void 0, {
      schema: r,
      uischema: i,
      path: o,
      errors: e
    });
    if (a !== void 0)
      return a;
  }
  return qV(e.map((s) => t(s, n, i)));
}, SI = (e, t) => {
  if (e.label === !1 || (e.label === void 0 || e.label === null || e.label === !0) && !VV(e))
    return;
  const n = typeof e.label == "string" ? e.label : JSON.stringify(e.label), r = DI(void 0, e), i = typeof r == "string" ? `${r}.label` : n;
  return t(i, n, { uischema: e });
}, V2e = (e, t, n, r) => {
  const i = {};
  return t.forEach((o) => {
    const s = j2e(n, o.key);
    i[o.key] = e(s, o.default(r));
  }), i;
}, z2e = (e) => e === void 0 ? CI : e.translate, U2e = (e) => e === void 0 ? EI : e.translateError, bl = () => (e) => z2e(mn(e, "jsonforms.i18n")), AI = () => (e) => U2e(mn(e, "jsonforms.i18n")), $h = {
  locale: "en",
  translate: CI,
  translateError: EI
}, uB = (e = $h, t) => {
  switch (t.type) {
    case xI: {
      const n = t.locale ?? $h.locale, r = t.translator ?? $h.translate, i = t.errorTranslator ?? $h.translateError;
      return n !== e.locale || r !== e.translate || i !== e.translateError ? {
        ...e,
        locale: n,
        translate: r,
        translateError: i
      } : e;
    }
    case vI:
      return {
        ...e,
        translate: t.translator ?? CI,
        translateError: t.errorTranslator ?? EI
      };
    case bI:
      return {
        ...e,
        locale: t.locale ?? navigator.languages[0]
      };
    default:
      return e;
  }
}, jD = -1, Mp = (e) => !xn(e) && e.scope !== void 0, ca = (e) => (t, n, r) => {
  if (xn(t) || !Mp(t) || xn(n))
    return !1;
  const i = t.scope;
  if (xn(i))
    return !1;
  let o = n;
  return to(n, "object") && (o = ls(n, i, r == null ? void 0 : r.rootSchema)), o === void 0 ? !1 : e(o, r == null ? void 0 : r.rootSchema);
}, pE = (e, t) => (n, r, i) => {
  if (xn(n) || !Mp(n))
    return !1;
  const o = n.scope;
  let s = r;
  return to(r, "object") && (s = ls(r, o, i == null ? void 0 : i.rootSchema)), s = mn(s, e), s === void 0 ? !1 : t(s, i == null ? void 0 : i.rootSchema);
}, dd = (e) => ca((t) => !xn(t) && to(t, e)), wI = (e) => ca((t) => !xn(t) && t.format === e && to(t, "string")), dn = (e) => (t) => !xn(t) && t.type === e, Al = (e, t) => (n) => {
  if (xn(n))
    return !1;
  const r = n.options;
  return !xn(r) && r[e] === t;
}, pr = (...e) => (t, n, r) => e.reduce((i, o) => i && o(t, n, r), !0), Qm = (...e) => (t, n, r) => e.reduce((i, o) => i || o(t, n, r), !1), Gt = (e, t) => (n, r, i) => t(n, r, i) ? e : jD, W2e = (e, t) => (n, r, i) => {
  const o = t(n, r, i);
  return o === jD ? jD : o + e;
}, fE = pr(dn("Control"), dd("boolean")), H2e = pr(dn("Control"), dd("object")), q2e = pr(dn("Control"), ca((e) => Object.prototype.hasOwnProperty.call(e, "allOf"))), G2e = pr(dn("Control"), ca((e) => Object.prototype.hasOwnProperty.call(e, "anyOf"))), Y2e = pr(dn("Control"), ca((e) => Object.prototype.hasOwnProperty.call(e, "oneOf"))), hE = pr(dn("Control"), ca((e) => WV(e))), PI = pr(dn("Control"), ca((e) => I0(e))), rz = pr(dn("Control"), dd("integer")), iz = pr(dn("Control"), dd("number")), oz = pr(dn("Control"), dd("string")), kI = pr(dn("Control"), Qm(wI("date"), Al("format", "date"))), OI = pr(dn("Control"), Qm(wI("time"), Al("format", "time"))), K2e = pr(dn("Control"), Qm(wI("date-time"), Al("format", "date-time"))), II = pr(ca(
  (e, t) => to(e, "array") && !Array.isArray(ls(e, "items", t))
), pE("items", (e, t) => {
  const n = e.$ref ? ls(t, e.$ref, t) : e;
  return to(n, "object");
})), J2e = pr(dn("Control"), II), Wy = (e, t, n) => {
  if (n9(e))
    return XL(e, (r, i) => r || Wy(i, t, n), !1);
  if (t(e))
    return !0;
  if (e.$ref) {
    const r = ls(n, e.$ref, n);
    if (r && !r.$ref)
      return Wy(r, t, n);
  }
  return e.items ? Wy(e.items, t, n) : e.properties ? XL(AOe(e.properties), (r, [i, o]) => r || Wy(o, t, n), !1) : !1;
}, X2e = (e, t, n) => {
  if (!dn("Control")(e, t, n))
    return !1;
  const r = e.scope, i = ls(t, r, (n == null ? void 0 : n.rootSchema) ?? t);
  let o = 0;
  if (i !== void 0 && i.items !== void 0) {
    if (Wy(i.items, (s) => s === t || s.$ref !== void 0 ? !1 : !!(s.anyOf || s.allOf || s.oneOf && !I0(s) || to(s, "object") && (o++, o === 2) || to(s, "array")), n == null ? void 0 : n.rootSchema))
      return !0;
    if (e.options && e.options.detail) {
      if (typeof e.options.detail == "string")
        return e.options.detail.toUpperCase() !== "DEFAULT";
      if (typeof e.options.detail == "object" && e.options.detail.type)
        return !0;
    }
  }
  return !1;
}, Q2e = pr(dn("Control"), ca(
  (e, t) => Np(e).length !== 0 && !Array.isArray(ls(e, "items", t))
), pE("items", (e, t) => {
  const n = e.$ref ? ls(t, e.$ref, t) : e, r = Np(n);
  return r.length === 1 && K9(["integer", "number", "boolean", "string"], r[0]);
})), Z2e = pr(dn("Control"), Qm(dd("number"), dd("integer")), ca((e) => Object.prototype.hasOwnProperty.call(e, "maximum") && Object.prototype.hasOwnProperty.call(e, "minimum") && Object.prototype.hasOwnProperty.call(e, "default")), Al("slider", !0)), eIe = pr(dn("Control"), dd("integer"), Al("format", !0)), tIe = (e) => e.type === "Categorization", nIe = (e) => e.type === "Category", sz = (e) => xn(e.elements) ? !1 : e.elements.map((t) => tIe(t) ? sz(t) : nIe(t)).reduce((t, n) => t && n, !0), rIe = (e) => sz(e), az = (e) => (t, n, r) => {
  const i = iI(e, (o) => o.tester(t, n, r));
  if (i !== void 0 && i.tester(t, n, r) !== jD)
    return i.uischema;
}, $b = (e, t, n, r, i = "VerticalLayout", o, s) => {
  if (o && o.options && o.options.detail) {
    if (typeof o.options.detail == "string") {
      if (o.options.detail.toUpperCase() === "GENERATE")
        return typeof i == "function" ? i() : Wp.uiSchema(t, i, void 0, s);
    } else if (typeof o.options.detail == "object" && o.options.detail.type && typeof o.options.detail.type == "string")
      return o.options.detail;
  }
  const a = az(e)(t, n, r);
  return a === void 0 ? typeof i == "function" ? i() : Wp.uiSchema(t, i, "#", s) : a;
}, cB = (e, t, n) => n(e, t), lz = (e, t, n) => (r) => {
  const i = r.errors ?? [], o = r.additionalErrors ?? [];
  return HV(e, t, n)(r.validationMode === "ValidateAndHide" ? o : [...i, ...o]);
}, iIe = (e, t) => lz(e, t, (n) => n === e), oIe = (e, t) => lz(e, t, (n) => n.startsWith(e + ".")), uz = (e, t) => (n) => iIe(e, t)(n.jsonforms.core), sIe = (e, t) => (n) => oIe(e, t)(n.jsonforms.core), Nb = (e) => uIe(mn(e, "jsonforms.core")), $0 = (e) => cIe(mn(e, "jsonforms.core")), aIe = (e) => dIe(mn(e, "jsonforms.core")), Zm = (e) => pIe(mn(e, "jsonforms.core")), cz = (e) => mn(e, "jsonforms.renderers"), dz = (e) => mn(e, "jsonforms.cells"), lIe = (e) => mn(e, "jsonforms.uischemas"), uIe = (e) => mn(e, "data"), cIe = (e) => mn(e, "schema"), dIe = (e) => mn(e, "uischema"), pIe = (e) => mn(e, "ajv"), Hp = (e) => e.jsonforms.config, FI = (e, t, n, r, i, o) => {
  var s, a, u;
  return (s = e == null ? void 0 : e.jsonforms) != null && s.readonly ? !1 : n && ZOe(n) ? e2e(n, i, t == null ? void 0 : t.path, Zm(e)) : typeof ((a = n == null ? void 0 : n.options) == null ? void 0 : a.readonly) == "boolean" ? !n.options.readonly : typeof ((u = n == null ? void 0 : n.options) == null ? void 0 : u.readOnly) == "boolean" ? !n.options.readOnly : typeof (o == null ? void 0 : o.readonly) == "boolean" ? !o.readonly : typeof (o == null ? void 0 : o.readOnly) == "boolean" ? !o.readOnly : (r == null ? void 0 : r.readOnly) === !0 ? !1 : typeof (t == null ? void 0 : t.enabled) == "boolean" ? t.enabled : !0;
}, pz = (e, t, n) => {
  const r = t + n;
  if (r < 0 || r >= e.length)
    return;
  const i = [t, r].sort((o, s) => o - s);
  e.splice(i[0], 2, e[i[1]], e[i[0]]);
}, fIe = (e) => {
  const t = e.split(".");
  let n = "#";
  return t.forEach((r) => {
    r.match(/^\d+$/) ? n += "/items" : n += `/properties/${r}`;
  }), n;
}, dB = (e, t, n) => {
  if (rr(e, "const"))
    return rr(n, t) && vo.isEqual(n[t], mn(e, "const"));
  if (rr(e, "enum"))
    return rr(n, t) && mn(e, "enum").find((r) => vo.isEqual(r, n[t])) !== void 0;
  if (rr(e, "pattern")) {
    const r = new RegExp(mn(e, "pattern"));
    return rr(n, t) && typeof n[t] == "string" && r.test(n[t]);
  } else if (rr(e, "contains")) {
    const r = mn(e, "contains");
    if (rr(n, t) && rr(r, "const") && Array.isArray(n[t]))
      return n[t].includes(mn(r, "const"));
  }
  return !1;
}, fz = (e, t, n) => {
  if (rr(e[t], "not"))
    return !dB(mn(e[t], "not"), t, n);
  if (rr(e[t], "properties") && rr(n, t)) {
    const r = mn(e[t], "properties");
    return Ux((i) => fz(r, i, n[t]), Object.keys(r));
  }
  return dB(e[t], t, n);
}, Yx = (e, t) => {
  if (rr(e, "allOf"))
    return Ux((i) => Yx(i, t), mn(e, "allOf"));
  if (rr(e, "anyOf"))
    return RV((i) => Yx(i, t), mn(e, "anyOf"));
  if (rr(e, "oneOf")) {
    const i = mn(e, "oneOf");
    let o = !1;
    for (let s = 0; s < i.length; s++) {
      const a = Yx(i[s], t);
      if (a && o)
        return !1;
      a && !o && (o = !0);
    }
    return o;
  }
  let n = [];
  rr(e, "required") && (n = mn(e, "required"));
  const r = Ux((i) => rr(t, i), n);
  if (rr(e, "properties")) {
    const i = mn(e, "properties"), o = Ux((s) => fz(i, s, t), Object.keys(i));
    return r && o;
  }
  return r;
}, pB = (e, t, n) => {
  let r = 0, i = e;
  for (; r < n.length && (rr(i, n[r]) || rr(i, "properties") && rr(mn(i, "properties"), n[r])); )
    rr(i, "properties") && (i = mn(i, "properties")), i = mn(i, n[r]), ++r;
  return r < n.length ? !1 : rr(i, "required") && mn(i, "required").includes(t);
}, N0 = (e, t, n, r) => {
  const i = mn(e, "if"), o = Yx(i, r), s = rr(mn(e, "then"), "if"), a = rr(mn(e, "else"), "if"), u = rr(mn(e, "then"), "allOf"), c = rr(mn(e, "else"), "allOf");
  return rr(e, "then") && o && pB(mn(e, "then"), t, n) || rr(e, "else") && !o && pB(mn(e, "else"), t, n) || s && o && N0(mn(e, "then"), t, n, r) || a && !o && N0(mn(e, "else"), t, n, r) || u && o && M0(mn(e, "then"), t, n, r) || c && !o && M0(mn(e, "else"), t, n, r);
}, M0 = (e, t, n, r) => {
  const i = mn(e, "allOf");
  return RV((o) => rr(o, "if") && N0(o, t, n, r) || M0(o, t, n, r), i);
}, hz = (e) => {
  const t = e.split("/"), r = t[t.length - 1] === "items" ? 1 : 2;
  return t.slice(0, t.length - r).join("/");
}, mz = (e) => {
  const t = e.split(".");
  return t.slice(0, t.length - 1).join(".");
}, gz = (e, t, n, r, i, o) => {
  const s = t.split("/"), a = s[s.length - 1], u = hz(t);
  if (!u)
    return !1;
  const c = xo.schema(e, u, e), d = mz(o), f = xo.data(i, d);
  return M0(c, n, [a, ...r], f) || rr(c, "if") && N0(c, n, [a, ...r], f) || gz(e, u, n, [a, ...r], i, d);
}, hIe = (e, t) => e !== void 0 && e.required !== void 0 && e.required.indexOf(t) !== -1, yz = (e, t) => {
  pz(e, t, -1);
}, bz = (e, t) => {
  pz(e, t, 1);
}, mIe = (e, t, n) => {
  const r = t.split("/"), i = Fb(r[r.length - 1]), s = r.slice(0, r.length - 2).join("/"), a = xo.schema(e, s, n);
  return hIe(a, i);
}, gIe = (e, t, n, r) => {
  const i = t.split("/"), o = i[i.length - 1], s = hz(t), a = xo.schema(e, s, e), u = mz(r), c = xo.data(n, u), d = rr(a, "if") && N0(a, o, [], c), f = M0(a, o, [], c), h = gz(e, s, o, [], n, u);
  return d || f || h;
}, $I = (e, t, n) => `${e ?? ""}${t && !n ? "*" : ""}`, da = (e, t) => e && !t, au = (e, t) => {
  const n = xo.schema(e, e.$ref, t);
  return n.default !== void 0 ? fB(n, t) : to(n, "string") ? n.format === "date-time" || n.format === "date" || n.format === "time" ? n2e(/* @__PURE__ */ new Date(), n.format) : "" : to(n, "integer") || to(n, "number") ? 0 : to(n, "boolean") ? !1 : to(n, "array") ? [] : to(n, "object") ? fB(n, t) : to(n, "null") ? null : {};
}, fB = (e, t) => {
  if (to(e, "object") && e.default === void 0) {
    const n = {};
    for (const r in e.properties) {
      const i = e.properties[r], o = i.$ref ? xo.schema(t, i.$ref, t) : i;
      o.default !== void 0 && (n[r] = FD(o.default));
    }
    return n;
  }
  return FD(e.default);
}, Do = (e, t, n, r) => t === void 0 || t !== void 0 && !e || !r && !n, dm = (e, t, n) => {
  let r = typeof e == "string" ? e : JSON.stringify(e);
  return t && (n ? r = t(`${n}.${r}`, r) : r = t(r, r)), { label: r, value: e };
}, mE = (e, t, n) => {
  let r = e.title ?? (typeof e.const == "string" ? e.const : JSON.stringify(e.const));
  return t && (e.i18n ? r = t(e.i18n, r) : n ? r = t(`${n}.${r}`, r) : r = t(r, r)), {
    label: r,
    value: e.const
  };
}, eg = (e, t) => {
  const { uischema: n } = t, r = Nb(e), i = jV(n, t.path), o = t.visible === void 0 || aI(n) ? Ed(n, r, t.path, Zm(e)) : t.visible, s = n, a = t.id, u = $0(e), c = Hp(e), d = s.scope !== void 0 && !!(mIe(t.schema, s.scope, u) || c != null && c.allowDynamicCheck && gIe(u, fIe(i), r, i)), f = xo.schema(t.schema || u, s.scope, u), h = uz(i, f)(e), m = f !== void 0 ? f.description : "", v = xo.data(r, i), x = VOe(n, f), C = x.show ? x.text : "", E = FI(e, t, n, f || u, r, c), S = f ?? u, w = bl()(e), O = AI()(e), A = Ba(S, n, i), I = w(BD(S, n, i, "label"), C, {
    schema: S,
    uischema: n,
    path: i,
    errors: h
  }), $ = w(BD(S, n, i, "description"), m, { schema: S, uischema: n, path: i, errors: h }), L = TI(h, O, w, S, n, i);
  return {
    data: v,
    description: $,
    errors: L,
    label: I,
    visible: o,
    enabled: E,
    id: a,
    path: i,
    required: d,
    uischema: n,
    schema: S,
    config: Hp(e),
    cells: t.cells || e.jsonforms.cells,
    rootSchema: u,
    i18nKeyPrefix: A
  };
}, yIe = (e) => ({
  handleChange(t, n) {
    e(Oa(t, () => n));
  }
}), bIe = (e, t) => {
  var i;
  const n = eg(e, t), r = t.options || ((i = n.schema.enum) == null ? void 0 : i.map((o) => dm(o, bl()(e), Ba(n.schema, n.uischema, n.path)))) || n.schema.const && [
    dm(n.schema.const, bl()(e), Ba(n.schema, n.uischema, n.path))
  ];
  return {
    ...n,
    options: r
  };
}, vIe = (e, t) => {
  var i;
  const n = eg(e, t), r = t.options || ((i = n.schema.oneOf) == null ? void 0 : i.map((o) => mE(o, bl()(e), Ba(n.schema, n.uischema, n.path))));
  return {
    ...n,
    options: r
  };
}, xIe = (e, t) => {
  var o;
  const n = eg(e, t);
  let r = n.schema.items;
  r = r && r.$ref ? ls(n.rootSchema, r.$ref, n.rootSchema) : r;
  const i = t.options || (r == null ? void 0 : r.oneOf) && r.oneOf.map((s) => {
    var a;
    return mE(s, (a = e.jsonforms.i18n) == null ? void 0 : a.translate, Ba(n.schema, n.uischema, n.path));
  }) || ((o = r == null ? void 0 : r.enum) == null ? void 0 : o.map((s) => {
    var a;
    return dm(s, (a = e.jsonforms.i18n) == null ? void 0 : a.translate, Ba(n.schema, n.uischema, n.path));
  }));
  return {
    ...n,
    options: i
  };
}, DIe = (e, t) => {
  const { schema: n, path: r, uischema: i, childLabelProp: o, index: s } = t, a = pf(r, `${s}`), u = Dz(Nb(e), a, o, n, $0(e), e.jsonforms.i18n.translate, i);
  return {
    ...t,
    childLabel: u
  };
}, vz = (e, t) => {
  const { ...n } = eg(e, t);
  return {
    ...n,
    uischemas: e.jsonforms.uischemas
  };
}, CIe = (e) => ({
  addItem: (t, n) => () => {
    e(Oa(t, (r) => r == null ? [n] : (r.push(n), r), { type: "ADD", values: [n] }));
  },
  removeItems: (t, n) => () => {
    e(Oa(t, (r) => (n.sort((i, o) => i - o).reverse().forEach((i) => r.splice(i, 1)), r), { type: "REMOVE", indices: n }));
  },
  moveUp: (t, n) => () => {
    e(Oa(t, (r) => (yz(r, n), r), {
      type: "MOVE",
      moves: [{ from: n, to: n - 1 }]
    }));
  },
  moveDown: (t, n) => () => {
    e(Oa(t, (r) => (bz(r, n), r), {
      type: "MOVE",
      moves: [{ from: n, to: n + 1 }]
    }));
  }
}), EIe = (e) => ({
  addItem: (t, n) => {
    e(Oa(t, (r) => r == null ? [n] : (r.push(n), r)));
  },
  removeItem: (t, n) => {
    e(Oa(t, (r) => {
      const i = r.indexOf(n);
      return r.splice(i, 1), r;
    }));
  }
}), xz = {
  visible: !0,
  enabled: !0,
  path: "",
  direction: "column"
}, TIe = (e) => e.type === "HorizontalLayout" ? "row" : e.type === "VerticalLayout" ? "column" : xz.direction, SIe = (e, t) => {
  const n = Nb(e), { uischema: r } = t, i = t.visible === void 0 || aI(r) ? Ed(t.uischema, n, t.path, Zm(e)) : t.visible, o = xo.data(n, t.path), s = Hp(e), a = FI(
    e,
    t,
    r,
    void 0,
    n,
    s
  ), u = bl()(e), c = HOe(r) ? SI(r, u) : void 0;
  return {
    ...xz,
    renderers: t.renderers || cz(e),
    cells: t.cells || dz(e),
    visible: i,
    enabled: a,
    path: t.path,
    data: o,
    uischema: t.uischema,
    schema: t.schema,
    direction: t.direction ?? TIe(r),
    config: s,
    label: c
  };
}, AIe = (e, t) => ({
  renderers: t.renderers || mn(e.jsonforms, "renderers"),
  cells: t.cells || mn(e.jsonforms, "cells"),
  schema: t.schema || $0(e),
  rootSchema: $0(e),
  uischema: t.uischema || aIe(e),
  path: t.path,
  enabled: t.enabled,
  config: Hp(e)
}), NI = (e, t, n) => {
  var m;
  const { data: r, schema: i, rootSchema: o, i18nKeyPrefix: s, label: a, ...u } = eg(e, t), c = e.jsonforms.core.ajv, d = [
    "required",
    "additionalProperties",
    "type",
    "enum",
    "const"
  ], f = (v) => !v || v.length === 0 || !v.find((x) => d.indexOf(x.keyword) !== -1);
  let h;
  for (let v = 0; v < ((m = i[n]) == null ? void 0 : m.length); v++)
    try {
      let x = i[n][v];
      x.$ref && (x = xo.schema(o, x.$ref, o));
      const C = c.compile(x);
      if (C(r), f(C.errors)) {
        h = v;
        break;
      }
    } catch {
      console.debug("Combinator subschema is not self contained, can't hand it over to AJV");
    }
  return {
    data: r,
    schema: i,
    rootSchema: o,
    ...u,
    i18nKeyPrefix: s,
    label: a,
    indexOfFittingSchema: h,
    uischemas: lIe(e)
  };
}, wIe = (e, t) => NI(e, t, "allOf"), PIe = (e, t) => NI(e, t, "anyOf"), kIe = (e, t) => NI(e, t, "oneOf"), OIe = (e, t) => {
  const { path: n, schema: r, uischema: i, errors: o, label: s, ...a } = vz(e, t), u = xo.schema(r, "items", a.rootSchema), c = bl()(e), d = TI(sIe(n, u)(e), AI()(e), c, void 0, void 0, void 0), f = o + (o.length > 0 && d.length > 0 ? `
` : "") + d;
  return {
    ...a,
    label: s,
    path: n,
    uischema: i,
    schema: u,
    data: a.data ? a.data.length : 0,
    errors: f,
    minItems: r.minItems
  };
}, IIe = (e, t) => {
  const { uischema: n } = t, r = t.visible === void 0 || aI(n) ? Ed(t.uischema, Nb(e), t.path, Zm(e)) : t.visible, i = n.text, o = bl()(e), s = DI(void 0, n), a = s ? `${s}.text` : i ?? "";
  return {
    text: o(a, i, { uischema: n }),
    visible: r,
    config: Hp(e),
    renderers: t.renderers || cz(e),
    cells: t.cells || dz(e),
    uischema: n
  };
}, Dz = (e, t, n, r, i, o, s) => {
  const a = xo.data(e, t);
  if (n || (n = t2e(r)), !n)
    return "";
  const u = mn(a, n);
  if (u === void 0)
    return "";
  const c = xo.schema(r, "#" + LD(n), i);
  let d;
  if (WV(c))
    d = dm(u, o, Ba(c, RP(s, n), t + "." + n));
  else if (I0(c)) {
    const h = c.oneOf.find((m) => vo.isEqual(m.const, u));
    h && (d = mE(h, o, Ba(h, void 0, t + "." + n)));
  }
  return d ? d.label : u;
}, gE = (e, t) => {
  const { id: n, schema: r, path: i, uischema: o, renderers: s, cells: a } = t, u = Nb(e), c = t.visible !== void 0 ? t.visible : Ed(o, u, void 0, Zm(e)), d = $0(e), f = Hp(e);
  let h;
  e.jsonforms.readonly === !0 ? h = !1 : typeof t.enabled == "boolean" ? h = t.enabled : h = FI(e, t, o, r || d, u, f);
  const m = bl()(e), v = AI()(e), x = TI(uz(i, r)(e), v, m, r, o, i), C = xn(x);
  return {
    data: xo.data(u, i),
    visible: c,
    enabled: h,
    id: n,
    path: i,
    errors: x,
    isValid: C,
    schema: r,
    uischema: o,
    config: Hp(e),
    rootSchema: d,
    renderers: s,
    cells: a
  };
}, FIe = (e, t) => {
  const n = gE(e, t), { renderers: r, cells: i, ...o } = t;
  return {
    ...n,
    ...o,
    cells: i || e.jsonforms.cells || []
  };
}, $Ie = (e, t) => {
  var i;
  const n = gE(e, t), r = t.options || ((i = n.schema.enum) == null ? void 0 : i.map((o) => dm(o, bl()(e), Ba(n.schema, n.uischema, n.path)))) || n.schema.const && [
    dm(n.schema.const, bl()(e), Ba(n.schema, n.uischema, n.path))
  ];
  return {
    ...n,
    options: r
  };
}, NIe = (e, t) => {
  var i;
  const n = gE(e, t), r = t.options || ((i = n.schema.oneOf) == null ? void 0 : i.map((o) => mE(o, bl()(e), Ba(n.schema, n.uischema, n.path))));
  return {
    ...n,
    options: r
  };
}, MI = (e, t, n, r, i, o) => e.map((s, a) => {
  const u = s.$ref && xo.schema(t, s.$ref, t), c = u ?? s;
  return {
    schema: c,
    uischema: $b(o, c, r.scope, i, void 0, r, t),
    label: s.title ?? (u == null ? void 0 : u.title) ?? `${n}-${a}`
  };
});
var MIe = cs, RIe = function() {
  return MIe.Date.now();
}, _Ie = RIe, LIe = la, MA = _Ie, hB = w9, BIe = "Expected a function", jIe = Math.max, VIe = Math.min;
function zIe(e, t, n) {
  var r, i, o, s, a, u, c = 0, d = !1, f = !1, h = !0;
  if (typeof e != "function")
    throw new TypeError(BIe);
  t = hB(t) || 0, LIe(n) && (d = !!n.leading, f = "maxWait" in n, o = f ? jIe(hB(n.maxWait) || 0, t) : o, h = "trailing" in n ? !!n.trailing : h);
  function m(I) {
    var $ = r, L = i;
    return r = i = void 0, c = I, s = e.apply(L, $), s;
  }
  function v(I) {
    return c = I, a = setTimeout(E, t), d ? m(I) : s;
  }
  function x(I) {
    var $ = I - u, L = I - c, B = t - $;
    return f ? VIe(B, o - L) : B;
  }
  function C(I) {
    var $ = I - u, L = I - c;
    return u === void 0 || $ >= t || $ < 0 || f && L >= o;
  }
  function E() {
    var I = MA();
    if (C(I))
      return S(I);
    a = setTimeout(E, x(I));
  }
  function S(I) {
    return a = void 0, h && r ? m(I) : (r = i = void 0, s);
  }
  function w() {
    a !== void 0 && clearTimeout(a), c = 0, r = u = i = a = void 0;
  }
  function O() {
    return a === void 0 ? s : S(MA());
  }
  function A() {
    var I = MA(), $ = C(I);
    if (r = arguments, i = this, u = I, $) {
      if (a === void 0)
        return v(u);
      if (f)
        return clearTimeout(a), a = setTimeout(E, t), m(u);
    }
    return a === void 0 && (a = setTimeout(E, t)), s;
  }
  return A.cancel = w, A.flush = O, A;
}
var UIe = zIe;
const Cz = /* @__PURE__ */ Ln(UIe);
class WIe extends se.Component {
  constructor(t) {
    super(t);
  }
}
class HIe extends WIe {
  constructor(t) {
    super(t), this.handleChange = (n) => {
      this.setState({ value: n }), this.updateData(n);
    }, this.onFocus = () => {
      this.setState({ isFocused: !0 });
    }, this.onBlur = () => {
      this.setState({ isFocused: !1 });
    }, this.updateData = (n) => {
      this.props.handleChange(this.props.path, n);
    }, this.state = {
      value: t.data ? t.data : "",
      isFocused: !1
    };
  }
}
class Ez extends noe {
  render() {
    return se.createElement(
      "div",
      { style: { color: "red" } },
      "No applicable ",
      this.props.type,
      " found."
    );
  }
}
const qIe = {
  data: {},
  schema: {},
  uischema: void 0,
  errors: [],
  additionalErrors: [],
  validator: void 0,
  ajv: void 0
}, Tz = se.createContext({
  core: qIe,
  renderers: []
}), GIe = (e, t) => {
  const n = rs(!0);
  rn(() => {
    if (n.current) {
      n.current = !1;
      return;
    }
    e();
  }, t);
}, YIe = ({ children: e, initState: t, onChange: n, middleware: r }) => {
  var A, I, $;
  const { data: i, schema: o, uischema: s, ajv: a, validationMode: u, additionalErrors: c } = t.core, d = rs(r ?? cB);
  d.current = r ?? cB;
  const [f, h] = Et(() => d.current(t.core, ph.init(i, o, s, {
    ajv: a,
    validationMode: u,
    additionalErrors: c
  }), NA));
  rn(() => h((L) => d.current(L, ph.updateCore(i, o, s, {
    ajv: a,
    validationMode: u,
    additionalErrors: c
  }), NA)), [i, o, s, a, u, c]);
  const [m, v] = zR(oB, void 0, () => oB(void 0, ph.setConfig(t.config)));
  GIe(() => {
    v(ph.setConfig(t.config));
  }, [t.config]);
  const [x, C] = zR(uB, void 0, () => {
    var L, B, H;
    return uB(t.i18n, ph.updateI18n((L = t.i18n) == null ? void 0 : L.locale, (B = t.i18n) == null ? void 0 : B.translate, (H = t.i18n) == null ? void 0 : H.translateError));
  });
  rn(() => {
    var L, B, H;
    C(ph.updateI18n((L = t.i18n) == null ? void 0 : L.locale, (B = t.i18n) == null ? void 0 : B.translate, (H = t.i18n) == null ? void 0 : H.translateError));
  }, [
    (A = t.i18n) == null ? void 0 : A.locale,
    (I = t.i18n) == null ? void 0 : I.translate,
    ($ = t.i18n) == null ? void 0 : $.translateError
  ]);
  const E = Cn((L) => {
    h((B) => d.current(B, L, NA));
  }, []), S = vn(() => ({
    core: f,
    renderers: t.renderers,
    cells: t.cells,
    config: m,
    uischemas: t.uischemas,
    readonly: t.readonly,
    i18n: x,
    dispatch: E
  }), [
    f,
    t.renderers,
    t.cells,
    m,
    t.uischemas,
    t.readonly,
    x
  ]), w = rs(n);
  rn(() => {
    w.current = n;
  }, [n]);
  const O = Cn(Cz((...L) => {
    var B;
    return (B = w.current) == null ? void 0 : B.call(w, ...L);
  }, 10), []);
  return rn(() => {
    O({ data: f.data, errors: f.errors });
  }, [f.data, f.errors]), se.createElement(Tz.Provider, { value: S }, e);
}, So = () => Rm(Tz), KIe = (e, t) => OIe({ jsonforms: { ...e } }, t), JIe = (e, t) => SIe({ jsonforms: { ...e } }, t), XIe = (e, t) => eg({ jsonforms: { ...e } }, t), QIe = (e, t) => {
  var i;
  const n = bIe({ jsonforms: { ...e } }, t), r = vn(() => n.options, [t.options, n.schema, (i = e.i18n) == null ? void 0 : i.translate]);
  return { ...n, options: r };
}, ZIe = (e, t) => {
  var i;
  const n = vIe({ jsonforms: { ...e } }, t), r = vn(() => n.options, [t.options, n.schema, (i = e.i18n) == null ? void 0 : i.translate]);
  return { ...n, options: r };
}, eFe = (e, t) => {
  var i;
  const n = xIe({ jsonforms: { ...e } }, t), r = vn(() => n.options, [n.schema, (i = e.i18n) == null ? void 0 : i.translate]);
  return { ...n, options: r };
}, tFe = (e, t) => vz({ jsonforms: { ...e } }, t), nFe = (e, t) => ({
  ...wIe({ jsonforms: { ...e } }, t)
}), _s = (e) => vn(() => yIe(e), [e]), rFe = (e, t) => {
  const n = PIe({ jsonforms: { ...e } }, t), r = _s(e.dispatch);
  return {
    ...n,
    ...r
  };
}, iFe = (e, t) => {
  const n = kIe({ jsonforms: { ...e } }, t), r = _s(e.dispatch);
  return {
    ...n,
    ...r
  };
}, oFe = (e, t) => AIe({ jsonforms: { ...e } }, t), sFe = (e) => ({
  ..._s(e),
  ...vn(() => CIe(e), [e])
}), aFe = (e, t) => DIe({ jsonforms: { ...e } }, t), lFe = (e, t) => gE({ jsonforms: { ...e } }, t), uFe = (e, t) => {
  var i;
  const n = $Ie({ jsonforms: { ...e } }, t), r = vn(() => n.options, [t.options, n.schema, (i = e.i18n) == null ? void 0 : i.translate]);
  return { ...n, options: r };
}, cFe = (e, t) => {
  var i;
  const n = NIe({ jsonforms: { ...e } }, t), r = vn(() => n.options, [t.options, n.schema, (i = e.i18n) == null ? void 0 : i.translate]);
  return { ...n, options: r };
}, dFe = (e, t) => FIe({ jsonforms: { ...e } }, t), pFe = (e) => ({
  ..._s(e),
  ...vn(() => EIe(e), [e])
}), fFe = (e, t) => IIe({ jsonforms: { ...e } }, t), so = (e) => function(n) {
  const r = So();
  return se.createElement(e, { ctx: r, props: n });
}, hFe = (e) => function({ ctx: n, props: r }) {
  const i = oFe(n, r);
  return se.createElement(e, { ...r, ...i });
}, mFe = (e) => function({ ctx: n, props: r }) {
  const i = XIe(n, r), o = _s(n.dispatch);
  return se.createElement(e, { ...r, ...i, ...o });
}, gFe = (e) => function({ ctx: n, props: r }) {
  const i = JIe(n, r);
  return se.createElement(e, { ...r, ...i });
}, yFe = (e) => function({ ctx: n, props: r }) {
  const i = iFe(n, r), o = _s(n.dispatch);
  return se.createElement(e, { ...r, ...i, ...o });
}, bFe = (e) => function({ ctx: n, props: r }) {
  const i = rFe(n, r), o = _s(n.dispatch);
  return se.createElement(e, { ...r, ...i, ...o });
}, vFe = (e) => function({ ctx: n, props: r }) {
  const i = nFe(n, r), o = _s(n.dispatch);
  return se.createElement(e, { ...r, ...i, ...o });
}, xFe = (e) => function({ ctx: n, props: r }) {
  const i = tFe(n, r);
  return se.createElement(e, { ...r, ...i });
}, DFe = (e) => function({ ctx: n, props: r }) {
  const i = KIe(n, r), o = sFe(n.dispatch);
  return se.createElement(e, { ...r, ...i, ...o });
}, CFe = (e) => function({ ctx: n, props: r }) {
  const i = aFe(n, r);
  return se.createElement(e, { ...r, ...i });
}, EFe = (e) => function({ ctx: n, props: r }) {
  const i = lFe(n, r), o = _s(n.dispatch);
  return se.createElement(e, { ...r, ...o, ...i });
}, TFe = (e) => function({ ctx: n, props: r }) {
  const i = dFe(n, r), o = _s(n.dispatch);
  return se.createElement(e, { ...r, ...o, ...i });
}, SFe = (e) => function({ ctx: n, props: r }) {
  const i = uFe(n, r), o = _s(n.dispatch);
  return se.createElement(e, { ...r, ...o, ...i });
}, AFe = (e) => function({ ctx: n, props: r }) {
  const i = QIe(n, r), o = _s(n.dispatch);
  return se.createElement(e, { ...r, ...o, ...i });
}, wFe = (e) => function({ ctx: n, props: r }) {
  const i = cFe(n, r), o = _s(n.dispatch);
  return se.createElement(e, { ...r, ...o, ...i });
}, PFe = (e) => function({ ctx: n, props: r }) {
  const i = ZIe(n, r), o = _s(n.dispatch);
  return se.createElement(e, { ...r, ...o, ...i });
}, kFe = (e) => function({ ctx: n, props: r }) {
  const i = eFe(n, r), o = pFe(n.dispatch);
  return se.createElement(e, { ...r, ...o, ...i });
}, OFe = (e) => function({ ctx: n, props: r }) {
  const i = fFe(n, r);
  return se.createElement(e, { ...r, ...i });
}, Sz = (e, t = !0) => so(hFe(t ? se.memo(e) : e)), li = (e, t = !0) => so(mFe(t ? se.memo(e) : e)), wl = (e, t = !0) => so(gFe(t ? se.memo(e) : e)), IFe = (e, t = !0) => so(yFe(t ? se.memo(e) : e)), FFe = (e, t = !0) => so(bFe(t ? se.memo(e) : e)), $Fe = (e, t = !0) => so(vFe(t ? se.memo(e) : e)), NFe = (e, t = !0) => so(xFe(t ? se.memo(e) : e)), yE = (e, t = !0) => so(DFe(t ? se.memo(e) : e)), Az = (e, t = !0) => so(CFe(t ? se.memo(e) : e)), Td = (e, t = !0) => so(EFe(t ? se.memo(e) : e)), MFe = (e, t = !0) => so(TFe(t ? se.memo(e) : e)), RFe = (e, t = !0) => so(SFe(t ? se.memo(e) : e)), Mb = (e, t = !0) => so(AFe(t ? se.memo(e) : e)), _Fe = (e, t = !0) => so(wFe(t ? se.memo(e) : e)), wz = (e, t = !0) => so(PFe(t ? se.memo(e) : e)), bE = (e, t = !0) => so(kFe(t ? se.memo(e) : e)), LFe = (e, t = !0) => so(OFe(t ? se.memo(e) : e)), Ka = (e) => function(n) {
  var s, a;
  const r = So(), i = ((s = r.i18n) == null ? void 0 : s.locale) ?? $h.locale, o = ((a = r.i18n) == null ? void 0 : a.translate) ?? $h.translate;
  return se.createElement(e, { ...n, locale: i, t: o });
}, vE = (e) => function(n) {
  const r = vn(() => V2e(n.t, L2e, n.i18nKeyPrefix, n.label), [n.t, n.i18nKeyPrefix, n.label]);
  return se.createElement(e, { ...n, translations: r });
};
class Pz extends se.Component {
  constructor(t) {
    super(t), this.state = {
      id: Mp(t.uischema) ? $P(t.uischema.scope) : void 0
    };
  }
  componentWillUnmount() {
    Mp(this.props.uischema) && NP(this.state.id);
  }
  componentDidUpdate(t) {
    t.schema !== this.props.schema && (NP(this.state.id), this.setState({
      id: Mp(this.props.uischema) ? $P(this.props.uischema.scope) : void 0
    }));
  }
  render() {
    const { schema: t, rootSchema: n, uischema: r, path: i, enabled: o, renderers: s, cells: a, config: u } = this.props;
    return se.createElement(BFe, { uischema: r, schema: t, rootSchema: n, path: i, enabled: o, renderers: s, cells: a, id: this.state.id, config: u });
  }
}
const BFe = se.memo(function(t) {
  const n = vn(() => ({
    rootSchema: t.rootSchema,
    config: t.config
  }), [t.rootSchema, t.config]), r = vn(() => iI(t.renderers, (i) => i.tester(t.uischema, t.schema, n)), [t.renderers, t.uischema, t.schema, n]);
  if (r === void 0 || r.tester(t.uischema, t.schema, n) === -1)
    return se.createElement(Ez, { type: "renderer" });
  {
    const i = r.renderer;
    return se.createElement(i, { uischema: t.uischema, schema: t.schema, path: t.path, enabled: t.enabled, renderers: t.renderers, cells: t.cells, id: t.id });
  }
});
class jFe extends Pz {
  constructor(t) {
    super(t);
  }
}
const vl = Sz(Pz);
Sz(jFe);
const VFe = (e) => {
  const { ajv: t, data: n, schema: r, uischema: i, renderers: o, cells: s, onChange: a, config: u, uischemas: c, readonly: d, validationMode: f, i18n: h, additionalErrors: m, middleware: v } = e, x = vn(() => r !== void 0 ? r : Wp.jsonSchema(n), [r, n]), C = vn(() => typeof i == "object" ? i : Wp.uiSchema(x, void 0, void 0, x), [i, x]);
  return se.createElement(
    YIe,
    { initState: {
      core: {
        ajv: t,
        data: n,
        schema: x,
        uischema: C,
        validationMode: f,
        additionalErrors: m
      },
      config: u,
      uischemas: c,
      renderers: o,
      cells: s,
      readonly: d,
      i18n: h
    }, onChange: a, middleware: v },
    se.createElement(vl, null)
  );
}, zFe = ({ uischema: e, schema: t, rootSchema: n, path: r, cells: i, id: o, enabled: s, renderers: a, config: u }) => {
  const c = vn(() => ({
    rootSchema: n,
    config: u
  }), [n, u]), d = vn(() => iI(i, (f) => f.tester(e, t, c)), [i, e, t, c]);
  if (d === void 0 || d.tester(e, t, c) === -1)
    return se.createElement(Ez, { type: "cell" });
  {
    const f = d.cell;
    return se.createElement(f, { uischema: e, schema: t, enabled: s, path: r, id: o, renderers: a, cells: i });
  }
}, mB = MFe(zFe), mu = {
  black: "#000",
  white: "#fff"
}, fh = {
  50: "#ffebee",
  100: "#ffcdd2",
  200: "#ef9a9a",
  300: "#e57373",
  400: "#ef5350",
  500: "#f44336",
  600: "#e53935",
  700: "#d32f2f",
  800: "#c62828",
  900: "#b71c1c",
  A100: "#ff8a80",
  A200: "#ff5252",
  A400: "#ff1744",
  A700: "#d50000"
}, hh = {
  50: "#f3e5f5",
  100: "#e1bee7",
  200: "#ce93d8",
  300: "#ba68c8",
  400: "#ab47bc",
  500: "#9c27b0",
  600: "#8e24aa",
  700: "#7b1fa2",
  800: "#6a1b9a",
  900: "#4a148c",
  A100: "#ea80fc",
  A200: "#e040fb",
  A400: "#d500f9",
  A700: "#aa00ff"
}, mh = {
  50: "#e3f2fd",
  100: "#bbdefb",
  200: "#90caf9",
  300: "#64b5f6",
  400: "#42a5f5",
  500: "#2196f3",
  600: "#1e88e5",
  700: "#1976d2",
  800: "#1565c0",
  900: "#0d47a1",
  A100: "#82b1ff",
  A200: "#448aff",
  A400: "#2979ff",
  A700: "#2962ff"
}, gh = {
  50: "#e1f5fe",
  100: "#b3e5fc",
  200: "#81d4fa",
  300: "#4fc3f7",
  400: "#29b6f6",
  500: "#03a9f4",
  600: "#039be5",
  700: "#0288d1",
  800: "#0277bd",
  900: "#01579b",
  A100: "#80d8ff",
  A200: "#40c4ff",
  A400: "#00b0ff",
  A700: "#0091ea"
}, yh = {
  50: "#e8f5e9",
  100: "#c8e6c9",
  200: "#a5d6a7",
  300: "#81c784",
  400: "#66bb6a",
  500: "#4caf50",
  600: "#43a047",
  700: "#388e3c",
  800: "#2e7d32",
  900: "#1b5e20",
  A100: "#b9f6ca",
  A200: "#69f0ae",
  A400: "#00e676",
  A700: "#00c853"
}, Ey = {
  50: "#fff3e0",
  100: "#ffe0b2",
  200: "#ffcc80",
  300: "#ffb74d",
  400: "#ffa726",
  500: "#ff9800",
  600: "#fb8c00",
  700: "#f57c00",
  800: "#ef6c00",
  900: "#e65100",
  A100: "#ffd180",
  A200: "#ffab40",
  A400: "#ff9100",
  A700: "#ff6d00"
}, UFe = {
  50: "#fafafa",
  100: "#f5f5f5",
  200: "#eeeeee",
  300: "#e0e0e0",
  400: "#bdbdbd",
  500: "#9e9e9e",
  600: "#757575",
  700: "#616161",
  800: "#424242",
  900: "#212121",
  A100: "#f5f5f5",
  A200: "#eeeeee",
  A400: "#bdbdbd",
  A700: "#616161"
};
function gu(e) {
  let t = "https://mui.com/production-error/?code=" + e;
  for (let n = 1; n < arguments.length; n += 1)
    t += "&args[]=" + encodeURIComponent(arguments[n]);
  return "Minified MUI error #" + e + "; visit " + t + " for the full message.";
}
const WFe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: gu
}, Symbol.toStringTag, { value: "Module" })), Rb = "$$material";
function _e(e, t) {
  if (e == null) return {};
  var n = {};
  for (var r in e) if ({}.hasOwnProperty.call(e, r)) {
    if (t.indexOf(r) !== -1) continue;
    n[r] = e[r];
  }
  return n;
}
var HFe = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, qFe = /* @__PURE__ */ R6(
  function(e) {
    return HFe.test(e) || e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && e.charCodeAt(2) < 91;
  }
  /* Z+1 */
), GFe = qFe, YFe = function(t) {
  return t !== "theme";
}, gB = function(t) {
  return typeof t == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  t.charCodeAt(0) > 96 ? GFe : YFe;
}, yB = function(t, n, r) {
  var i;
  if (n) {
    var o = n.shouldForwardProp;
    i = t.__emotion_forwardProp && o ? function(s) {
      return t.__emotion_forwardProp(s) && o(s);
    } : o;
  }
  return typeof i != "function" && r && (i = t.__emotion_forwardProp), i;
}, KFe = !1, JFe = function(t) {
  var n = t.cache, r = t.serialized, i = t.isStringTag;
  return V6(n, r, i), ese(function() {
    return z6(n, r, i);
  }), null;
}, XFe = function e(t, n) {
  var r = t.__emotion_real === t, i = r && t.__emotion_base || t, o, s;
  n !== void 0 && (o = n.label, s = n.target);
  var a = yB(t, n, r), u = a || gB(i), c = !u("as");
  return function() {
    var d = arguments, f = r && t.__emotion_styles !== void 0 ? t.__emotion_styles.slice(0) : [];
    if (o !== void 0 && f.push("label:" + o + ";"), d[0] == null || d[0].raw === void 0)
      f.push.apply(f, d);
    else {
      f.push(d[0][0]);
      for (var h = d.length, m = 1; m < h; m++)
        f.push(d[m], d[0][m]);
    }
    var v = q6(function(x, C, E) {
      var S = c && x.as || i, w = "", O = [], A = x;
      if (x.theme == null) {
        A = {};
        for (var I in x)
          A[I] = x[I];
        A.theme = V.useContext(am);
      }
      typeof x.className == "string" ? w = Hoe(C.registered, O, x.className) : x.className != null && (w = x.className + " ");
      var $ = _O(f.concat(O), C.registered, A);
      w += C.key + "-" + $.name, s !== void 0 && (w += " " + s);
      var L = c && a === void 0 ? gB(S) : u, B = {};
      for (var H in x)
        c && H === "as" || L(H) && (B[H] = x[H]);
      return B.className = w, E && (B.ref = E), /* @__PURE__ */ V.createElement(V.Fragment, null, /* @__PURE__ */ V.createElement(JFe, {
        cache: C,
        serialized: $,
        isStringTag: typeof S == "string"
      }), /* @__PURE__ */ V.createElement(S, B));
    });
    return v.displayName = o !== void 0 ? o : "Styled(" + (typeof i == "string" ? i : i.displayName || i.name || "Component") + ")", v.defaultProps = t.defaultProps, v.__emotion_real = v, v.__emotion_base = i, v.__emotion_styles = f, v.__emotion_forwardProp = a, Object.defineProperty(v, "toString", {
      value: function() {
        return s === void 0 && KFe ? "NO_COMPONENT_SELECTOR" : "." + s;
      }
    }), v.withComponent = function(x, C) {
      return e(x, N({}, n, C, {
        shouldForwardProp: yB(v, C, !0)
      })).apply(void 0, f);
    }, v;
  };
}, QFe = [
  "a",
  "abbr",
  "address",
  "area",
  "article",
  "aside",
  "audio",
  "b",
  "base",
  "bdi",
  "bdo",
  "big",
  "blockquote",
  "body",
  "br",
  "button",
  "canvas",
  "caption",
  "cite",
  "code",
  "col",
  "colgroup",
  "data",
  "datalist",
  "dd",
  "del",
  "details",
  "dfn",
  "dialog",
  "div",
  "dl",
  "dt",
  "em",
  "embed",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hgroup",
  "hr",
  "html",
  "i",
  "iframe",
  "img",
  "input",
  "ins",
  "kbd",
  "keygen",
  "label",
  "legend",
  "li",
  "link",
  "main",
  "map",
  "mark",
  "marquee",
  "menu",
  "menuitem",
  "meta",
  "meter",
  "nav",
  "noscript",
  "object",
  "ol",
  "optgroup",
  "option",
  "output",
  "p",
  "param",
  "picture",
  "pre",
  "progress",
  "q",
  "rp",
  "rt",
  "ruby",
  "s",
  "samp",
  "script",
  "section",
  "select",
  "small",
  "source",
  "span",
  "strong",
  "style",
  "sub",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "time",
  "title",
  "tr",
  "track",
  "u",
  "ul",
  "var",
  "video",
  "wbr",
  // SVG
  "circle",
  "clipPath",
  "defs",
  "ellipse",
  "foreignObject",
  "g",
  "image",
  "line",
  "linearGradient",
  "mask",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "radialGradient",
  "rect",
  "stop",
  "svg",
  "text",
  "tspan"
], jP = XFe.bind();
QFe.forEach(function(e) {
  jP[e] = jP(e);
});
var VP = { exports: {} }, M1 = { exports: {} }, xr = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var bB;
function ZFe() {
  if (bB) return xr;
  bB = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, o = e ? Symbol.for("react.profiler") : 60114, s = e ? Symbol.for("react.provider") : 60109, a = e ? Symbol.for("react.context") : 60110, u = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, f = e ? Symbol.for("react.suspense") : 60113, h = e ? Symbol.for("react.suspense_list") : 60120, m = e ? Symbol.for("react.memo") : 60115, v = e ? Symbol.for("react.lazy") : 60116, x = e ? Symbol.for("react.block") : 60121, C = e ? Symbol.for("react.fundamental") : 60117, E = e ? Symbol.for("react.responder") : 60118, S = e ? Symbol.for("react.scope") : 60119;
  function w(A) {
    if (typeof A == "object" && A !== null) {
      var I = A.$$typeof;
      switch (I) {
        case t:
          switch (A = A.type, A) {
            case u:
            case c:
            case r:
            case o:
            case i:
            case f:
              return A;
            default:
              switch (A = A && A.$$typeof, A) {
                case a:
                case d:
                case v:
                case m:
                case s:
                  return A;
                default:
                  return I;
              }
          }
        case n:
          return I;
      }
    }
  }
  function O(A) {
    return w(A) === c;
  }
  return xr.AsyncMode = u, xr.ConcurrentMode = c, xr.ContextConsumer = a, xr.ContextProvider = s, xr.Element = t, xr.ForwardRef = d, xr.Fragment = r, xr.Lazy = v, xr.Memo = m, xr.Portal = n, xr.Profiler = o, xr.StrictMode = i, xr.Suspense = f, xr.isAsyncMode = function(A) {
    return O(A) || w(A) === u;
  }, xr.isConcurrentMode = O, xr.isContextConsumer = function(A) {
    return w(A) === a;
  }, xr.isContextProvider = function(A) {
    return w(A) === s;
  }, xr.isElement = function(A) {
    return typeof A == "object" && A !== null && A.$$typeof === t;
  }, xr.isForwardRef = function(A) {
    return w(A) === d;
  }, xr.isFragment = function(A) {
    return w(A) === r;
  }, xr.isLazy = function(A) {
    return w(A) === v;
  }, xr.isMemo = function(A) {
    return w(A) === m;
  }, xr.isPortal = function(A) {
    return w(A) === n;
  }, xr.isProfiler = function(A) {
    return w(A) === o;
  }, xr.isStrictMode = function(A) {
    return w(A) === i;
  }, xr.isSuspense = function(A) {
    return w(A) === f;
  }, xr.isValidElementType = function(A) {
    return typeof A == "string" || typeof A == "function" || A === r || A === c || A === o || A === i || A === f || A === h || typeof A == "object" && A !== null && (A.$$typeof === v || A.$$typeof === m || A.$$typeof === s || A.$$typeof === a || A.$$typeof === d || A.$$typeof === C || A.$$typeof === E || A.$$typeof === S || A.$$typeof === x);
  }, xr.typeOf = w, xr;
}
var Dr = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var vB;
function e$e() {
  return vB || (vB = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, o = e ? Symbol.for("react.profiler") : 60114, s = e ? Symbol.for("react.provider") : 60109, a = e ? Symbol.for("react.context") : 60110, u = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, f = e ? Symbol.for("react.suspense") : 60113, h = e ? Symbol.for("react.suspense_list") : 60120, m = e ? Symbol.for("react.memo") : 60115, v = e ? Symbol.for("react.lazy") : 60116, x = e ? Symbol.for("react.block") : 60121, C = e ? Symbol.for("react.fundamental") : 60117, E = e ? Symbol.for("react.responder") : 60118, S = e ? Symbol.for("react.scope") : 60119;
    function w(le) {
      return typeof le == "string" || typeof le == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      le === r || le === c || le === o || le === i || le === f || le === h || typeof le == "object" && le !== null && (le.$$typeof === v || le.$$typeof === m || le.$$typeof === s || le.$$typeof === a || le.$$typeof === d || le.$$typeof === C || le.$$typeof === E || le.$$typeof === S || le.$$typeof === x);
    }
    function O(le) {
      if (typeof le == "object" && le !== null) {
        var ye = le.$$typeof;
        switch (ye) {
          case t:
            var be = le.type;
            switch (be) {
              case u:
              case c:
              case r:
              case o:
              case i:
              case f:
                return be;
              default:
                var Re = be && be.$$typeof;
                switch (Re) {
                  case a:
                  case d:
                  case v:
                  case m:
                  case s:
                    return Re;
                  default:
                    return ye;
                }
            }
          case n:
            return ye;
        }
      }
    }
    var A = u, I = c, $ = a, L = s, B = t, H = d, q = r, J = v, X = m, j = n, U = o, G = i, K = f, ee = !1;
    function te(le) {
      return ee || (ee = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), M(le) || O(le) === u;
    }
    function M(le) {
      return O(le) === c;
    }
    function Z(le) {
      return O(le) === a;
    }
    function ne(le) {
      return O(le) === s;
    }
    function R(le) {
      return typeof le == "object" && le !== null && le.$$typeof === t;
    }
    function _(le) {
      return O(le) === d;
    }
    function W(le) {
      return O(le) === r;
    }
    function Q(le) {
      return O(le) === v;
    }
    function oe(le) {
      return O(le) === m;
    }
    function ae(le) {
      return O(le) === n;
    }
    function pe(le) {
      return O(le) === o;
    }
    function me(le) {
      return O(le) === i;
    }
    function xe(le) {
      return O(le) === f;
    }
    Dr.AsyncMode = A, Dr.ConcurrentMode = I, Dr.ContextConsumer = $, Dr.ContextProvider = L, Dr.Element = B, Dr.ForwardRef = H, Dr.Fragment = q, Dr.Lazy = J, Dr.Memo = X, Dr.Portal = j, Dr.Profiler = U, Dr.StrictMode = G, Dr.Suspense = K, Dr.isAsyncMode = te, Dr.isConcurrentMode = M, Dr.isContextConsumer = Z, Dr.isContextProvider = ne, Dr.isElement = R, Dr.isForwardRef = _, Dr.isFragment = W, Dr.isLazy = Q, Dr.isMemo = oe, Dr.isPortal = ae, Dr.isProfiler = pe, Dr.isStrictMode = me, Dr.isSuspense = xe, Dr.isValidElementType = w, Dr.typeOf = O;
  }()), Dr;
}
var xB;
function kz() {
  return xB || (xB = 1, process.env.NODE_ENV === "production" ? M1.exports = ZFe() : M1.exports = e$e()), M1.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var RA, DB;
function t$e() {
  if (DB) return RA;
  DB = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(o) {
    if (o == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(o);
  }
  function i() {
    try {
      if (!Object.assign)
        return !1;
      var o = new String("abc");
      if (o[5] = "de", Object.getOwnPropertyNames(o)[0] === "5")
        return !1;
      for (var s = {}, a = 0; a < 10; a++)
        s["_" + String.fromCharCode(a)] = a;
      var u = Object.getOwnPropertyNames(s).map(function(d) {
        return s[d];
      });
      if (u.join("") !== "0123456789")
        return !1;
      var c = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(d) {
        c[d] = d;
      }), Object.keys(Object.assign({}, c)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return RA = i() ? Object.assign : function(o, s) {
    for (var a, u = r(o), c, d = 1; d < arguments.length; d++) {
      a = Object(arguments[d]);
      for (var f in a)
        t.call(a, f) && (u[f] = a[f]);
      if (e) {
        c = e(a);
        for (var h = 0; h < c.length; h++)
          n.call(a, c[h]) && (u[c[h]] = a[c[h]]);
      }
    }
    return u;
  }, RA;
}
var _A, CB;
function RI() {
  if (CB) return _A;
  CB = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return _A = e, _A;
}
var LA, EB;
function Oz() {
  return EB || (EB = 1, LA = Function.call.bind(Object.prototype.hasOwnProperty)), LA;
}
var BA, TB;
function n$e() {
  if (TB) return BA;
  TB = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = RI(), n = {}, r = Oz();
    e = function(o) {
      var s = "Warning: " + o;
      typeof console < "u" && console.error(s);
      try {
        throw new Error(s);
      } catch {
      }
    };
  }
  function i(o, s, a, u, c) {
    if (process.env.NODE_ENV !== "production") {
      for (var d in o)
        if (r(o, d)) {
          var f;
          try {
            if (typeof o[d] != "function") {
              var h = Error(
                (u || "React class") + ": " + a + " type `" + d + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof o[d] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw h.name = "Invariant Violation", h;
            }
            f = o[d](s, d, u, a, null, t);
          } catch (v) {
            f = v;
          }
          if (f && !(f instanceof Error) && e(
            (u || "React class") + ": type specification of " + a + " `" + d + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof f + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), f instanceof Error && !(f.message in n)) {
            n[f.message] = !0;
            var m = c ? c() : "";
            e(
              "Failed " + a + " type: " + f.message + (m ?? "")
            );
          }
        }
    }
  }
  return i.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, BA = i, BA;
}
var jA, SB;
function r$e() {
  if (SB) return jA;
  SB = 1;
  var e = kz(), t = t$e(), n = RI(), r = Oz(), i = n$e(), o = function() {
  };
  process.env.NODE_ENV !== "production" && (o = function(a) {
    var u = "Warning: " + a;
    typeof console < "u" && console.error(u);
    try {
      throw new Error(u);
    } catch {
    }
  });
  function s() {
    return null;
  }
  return jA = function(a, u) {
    var c = typeof Symbol == "function" && Symbol.iterator, d = "@@iterator";
    function f(M) {
      var Z = M && (c && M[c] || M[d]);
      if (typeof Z == "function")
        return Z;
    }
    var h = "<<anonymous>>", m = {
      array: E("array"),
      bigint: E("bigint"),
      bool: E("boolean"),
      func: E("function"),
      number: E("number"),
      object: E("object"),
      string: E("string"),
      symbol: E("symbol"),
      any: S(),
      arrayOf: w,
      element: O(),
      elementType: A(),
      instanceOf: I,
      node: H(),
      objectOf: L,
      oneOf: $,
      oneOfType: B,
      shape: J,
      exact: X
    };
    function v(M, Z) {
      return M === Z ? M !== 0 || 1 / M === 1 / Z : M !== M && Z !== Z;
    }
    function x(M, Z) {
      this.message = M, this.data = Z && typeof Z == "object" ? Z : {}, this.stack = "";
    }
    x.prototype = Error.prototype;
    function C(M) {
      if (process.env.NODE_ENV !== "production")
        var Z = {}, ne = 0;
      function R(W, Q, oe, ae, pe, me, xe) {
        if (ae = ae || h, me = me || oe, xe !== n) {
          if (u) {
            var le = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw le.name = "Invariant Violation", le;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var ye = ae + ":" + oe;
            !Z[ye] && // Avoid spamming the console because they are often not actionable except for lib authors
            ne < 3 && (o(
              "You are manually calling a React.PropTypes validation function for the `" + me + "` prop on `" + ae + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), Z[ye] = !0, ne++);
          }
        }
        return Q[oe] == null ? W ? Q[oe] === null ? new x("The " + pe + " `" + me + "` is marked as required " + ("in `" + ae + "`, but its value is `null`.")) : new x("The " + pe + " `" + me + "` is marked as required in " + ("`" + ae + "`, but its value is `undefined`.")) : null : M(Q, oe, ae, pe, me);
      }
      var _ = R.bind(null, !1);
      return _.isRequired = R.bind(null, !0), _;
    }
    function E(M) {
      function Z(ne, R, _, W, Q, oe) {
        var ae = ne[R], pe = G(ae);
        if (pe !== M) {
          var me = K(ae);
          return new x(
            "Invalid " + W + " `" + Q + "` of type " + ("`" + me + "` supplied to `" + _ + "`, expected ") + ("`" + M + "`."),
            { expectedType: M }
          );
        }
        return null;
      }
      return C(Z);
    }
    function S() {
      return C(s);
    }
    function w(M) {
      function Z(ne, R, _, W, Q) {
        if (typeof M != "function")
          return new x("Property `" + Q + "` of component `" + _ + "` has invalid PropType notation inside arrayOf.");
        var oe = ne[R];
        if (!Array.isArray(oe)) {
          var ae = G(oe);
          return new x("Invalid " + W + " `" + Q + "` of type " + ("`" + ae + "` supplied to `" + _ + "`, expected an array."));
        }
        for (var pe = 0; pe < oe.length; pe++) {
          var me = M(oe, pe, _, W, Q + "[" + pe + "]", n);
          if (me instanceof Error)
            return me;
        }
        return null;
      }
      return C(Z);
    }
    function O() {
      function M(Z, ne, R, _, W) {
        var Q = Z[ne];
        if (!a(Q)) {
          var oe = G(Q);
          return new x("Invalid " + _ + " `" + W + "` of type " + ("`" + oe + "` supplied to `" + R + "`, expected a single ReactElement."));
        }
        return null;
      }
      return C(M);
    }
    function A() {
      function M(Z, ne, R, _, W) {
        var Q = Z[ne];
        if (!e.isValidElementType(Q)) {
          var oe = G(Q);
          return new x("Invalid " + _ + " `" + W + "` of type " + ("`" + oe + "` supplied to `" + R + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return C(M);
    }
    function I(M) {
      function Z(ne, R, _, W, Q) {
        if (!(ne[R] instanceof M)) {
          var oe = M.name || h, ae = te(ne[R]);
          return new x("Invalid " + W + " `" + Q + "` of type " + ("`" + ae + "` supplied to `" + _ + "`, expected ") + ("instance of `" + oe + "`."));
        }
        return null;
      }
      return C(Z);
    }
    function $(M) {
      if (!Array.isArray(M))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? o(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : o("Invalid argument supplied to oneOf, expected an array.")), s;
      function Z(ne, R, _, W, Q) {
        for (var oe = ne[R], ae = 0; ae < M.length; ae++)
          if (v(oe, M[ae]))
            return null;
        var pe = JSON.stringify(M, function(xe, le) {
          var ye = K(le);
          return ye === "symbol" ? String(le) : le;
        });
        return new x("Invalid " + W + " `" + Q + "` of value `" + String(oe) + "` " + ("supplied to `" + _ + "`, expected one of " + pe + "."));
      }
      return C(Z);
    }
    function L(M) {
      function Z(ne, R, _, W, Q) {
        if (typeof M != "function")
          return new x("Property `" + Q + "` of component `" + _ + "` has invalid PropType notation inside objectOf.");
        var oe = ne[R], ae = G(oe);
        if (ae !== "object")
          return new x("Invalid " + W + " `" + Q + "` of type " + ("`" + ae + "` supplied to `" + _ + "`, expected an object."));
        for (var pe in oe)
          if (r(oe, pe)) {
            var me = M(oe, pe, _, W, Q + "." + pe, n);
            if (me instanceof Error)
              return me;
          }
        return null;
      }
      return C(Z);
    }
    function B(M) {
      if (!Array.isArray(M))
        return process.env.NODE_ENV !== "production" && o("Invalid argument supplied to oneOfType, expected an instance of array."), s;
      for (var Z = 0; Z < M.length; Z++) {
        var ne = M[Z];
        if (typeof ne != "function")
          return o(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + ee(ne) + " at index " + Z + "."
          ), s;
      }
      function R(_, W, Q, oe, ae) {
        for (var pe = [], me = 0; me < M.length; me++) {
          var xe = M[me], le = xe(_, W, Q, oe, ae, n);
          if (le == null)
            return null;
          le.data && r(le.data, "expectedType") && pe.push(le.data.expectedType);
        }
        var ye = pe.length > 0 ? ", expected one of type [" + pe.join(", ") + "]" : "";
        return new x("Invalid " + oe + " `" + ae + "` supplied to " + ("`" + Q + "`" + ye + "."));
      }
      return C(R);
    }
    function H() {
      function M(Z, ne, R, _, W) {
        return j(Z[ne]) ? null : new x("Invalid " + _ + " `" + W + "` supplied to " + ("`" + R + "`, expected a ReactNode."));
      }
      return C(M);
    }
    function q(M, Z, ne, R, _) {
      return new x(
        (M || "React class") + ": " + Z + " type `" + ne + "." + R + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + _ + "`."
      );
    }
    function J(M) {
      function Z(ne, R, _, W, Q) {
        var oe = ne[R], ae = G(oe);
        if (ae !== "object")
          return new x("Invalid " + W + " `" + Q + "` of type `" + ae + "` " + ("supplied to `" + _ + "`, expected `object`."));
        for (var pe in M) {
          var me = M[pe];
          if (typeof me != "function")
            return q(_, W, Q, pe, K(me));
          var xe = me(oe, pe, _, W, Q + "." + pe, n);
          if (xe)
            return xe;
        }
        return null;
      }
      return C(Z);
    }
    function X(M) {
      function Z(ne, R, _, W, Q) {
        var oe = ne[R], ae = G(oe);
        if (ae !== "object")
          return new x("Invalid " + W + " `" + Q + "` of type `" + ae + "` " + ("supplied to `" + _ + "`, expected `object`."));
        var pe = t({}, ne[R], M);
        for (var me in pe) {
          var xe = M[me];
          if (r(M, me) && typeof xe != "function")
            return q(_, W, Q, me, K(xe));
          if (!xe)
            return new x(
              "Invalid " + W + " `" + Q + "` key `" + me + "` supplied to `" + _ + "`.\nBad object: " + JSON.stringify(ne[R], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(M), null, "  ")
            );
          var le = xe(oe, me, _, W, Q + "." + me, n);
          if (le)
            return le;
        }
        return null;
      }
      return C(Z);
    }
    function j(M) {
      switch (typeof M) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !M;
        case "object":
          if (Array.isArray(M))
            return M.every(j);
          if (M === null || a(M))
            return !0;
          var Z = f(M);
          if (Z) {
            var ne = Z.call(M), R;
            if (Z !== M.entries) {
              for (; !(R = ne.next()).done; )
                if (!j(R.value))
                  return !1;
            } else
              for (; !(R = ne.next()).done; ) {
                var _ = R.value;
                if (_ && !j(_[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function U(M, Z) {
      return M === "symbol" ? !0 : Z ? Z["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && Z instanceof Symbol : !1;
    }
    function G(M) {
      var Z = typeof M;
      return Array.isArray(M) ? "array" : M instanceof RegExp ? "object" : U(Z, M) ? "symbol" : Z;
    }
    function K(M) {
      if (typeof M > "u" || M === null)
        return "" + M;
      var Z = G(M);
      if (Z === "object") {
        if (M instanceof Date)
          return "date";
        if (M instanceof RegExp)
          return "regexp";
      }
      return Z;
    }
    function ee(M) {
      var Z = K(M);
      switch (Z) {
        case "array":
        case "object":
          return "an " + Z;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + Z;
        default:
          return Z;
      }
    }
    function te(M) {
      return !M.constructor || !M.constructor.name ? h : M.constructor.name;
    }
    return m.checkPropTypes = i, m.resetWarningCache = i.resetWarningCache, m.PropTypes = m, m;
  }, jA;
}
var VA, AB;
function i$e() {
  if (AB) return VA;
  AB = 1;
  var e = RI();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, VA = function() {
    function r(s, a, u, c, d, f) {
      if (f !== e) {
        var h = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw h.name = "Invariant Violation", h;
      }
    }
    r.isRequired = r;
    function i() {
      return r;
    }
    var o = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: i,
      element: r,
      elementType: r,
      instanceOf: i,
      node: r,
      objectOf: i,
      oneOf: i,
      oneOfType: i,
      shape: i,
      exact: i,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return o.PropTypes = o, o;
  }, VA;
}
if (process.env.NODE_ENV !== "production") {
  var o$e = kz(), s$e = !0;
  VP.exports = r$e()(o$e.isElement, s$e);
} else
  VP.exports = i$e()();
var a$e = VP.exports;
const l = /* @__PURE__ */ Ln(a$e);
let zP;
typeof document == "object" && (zP = L6({
  key: "css",
  prepend: !0
}));
function Iz(e) {
  const {
    injectFirst: t,
    children: n
  } = e;
  return t && zP ? /* @__PURE__ */ P.jsx(tse, {
    value: zP,
    children: n
  }) : n;
}
process.env.NODE_ENV !== "production" && (Iz.propTypes = {
  /**
   * Your component tree.
   */
  children: l.node,
  /**
   * By default, the styles are injected last in the <head> element of the page.
   * As a result, they gain more specificity than any other style sheet.
   * If you want to override MUI's styles, set this prop.
   */
  injectFirst: l.bool
});
function l$e(e) {
  return e == null || Object.keys(e).length === 0;
}
function _I(e) {
  const {
    styles: t,
    defaultTheme: n = {}
  } = e, r = typeof t == "function" ? (i) => t(l$e(i) ? n : i) : t;
  return /* @__PURE__ */ P.jsx(ose, {
    styles: r
  });
}
process.env.NODE_ENV !== "production" && (_I.propTypes = {
  defaultTheme: l.object,
  styles: l.oneOfType([l.array, l.string, l.object, l.func])
});
/**
 * @mui/styled-engine v5.16.6
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function LI(e, t) {
  const n = jP(e, t);
  return process.env.NODE_ENV !== "production" ? (...r) => {
    const i = typeof e == "string" ? `"${e}"` : "component";
    return r.length === 0 ? console.error([`MUI: Seems like you called \`styled(${i})()\` without a \`style\` argument.`, 'You must provide a `styles` argument: `styled("div")(styleYouForgotToPass)`.'].join(`
`)) : r.some((o) => o === void 0) && console.error(`MUI: the styled(${i})(...args) API requires all its args to be defined.`), n(...r);
  } : n;
}
const Fz = (e, t) => {
  Array.isArray(e.__emotion_styles) && (e.__emotion_styles = t(e.__emotion_styles));
}, u$e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  GlobalStyles: _I,
  StyledEngineProvider: Iz,
  ThemeContext: am,
  css: G6,
  default: LI,
  internal_processStyles: Fz,
  keyframes: UC
}, Symbol.toStringTag, { value: "Module" }));
function Zu(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const t = Object.getPrototypeOf(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function $z(e) {
  if (!Zu(e))
    return e;
  const t = {};
  return Object.keys(e).forEach((n) => {
    t[n] = $z(e[n]);
  }), t;
}
function is(e, t, n = {
  clone: !0
}) {
  const r = n.clone ? N({}, e) : e;
  return Zu(e) && Zu(t) && Object.keys(t).forEach((i) => {
    Zu(t[i]) && // Avoid prototype pollution
    Object.prototype.hasOwnProperty.call(e, i) && Zu(e[i]) ? r[i] = is(e[i], t[i], n) : n.clone ? r[i] = Zu(t[i]) ? $z(t[i]) : t[i] : r[i] = t[i];
  }), r;
}
const c$e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: is,
  isPlainObject: Zu
}, Symbol.toStringTag, { value: "Module" })), d$e = ["values", "unit", "step"], p$e = (e) => {
  const t = Object.keys(e).map((n) => ({
    key: n,
    val: e[n]
  })) || [];
  return t.sort((n, r) => n.val - r.val), t.reduce((n, r) => N({}, n, {
    [r.key]: r.val
  }), {});
};
function Nz(e) {
  const {
    // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values: t = {
      xs: 0,
      // phone
      sm: 600,
      // tablet
      md: 900,
      // small laptop
      lg: 1200,
      // desktop
      xl: 1536
      // large screen
    },
    unit: n = "px",
    step: r = 5
  } = e, i = _e(e, d$e), o = p$e(t), s = Object.keys(o);
  function a(h) {
    return `@media (min-width:${typeof t[h] == "number" ? t[h] : h}${n})`;
  }
  function u(h) {
    return `@media (max-width:${(typeof t[h] == "number" ? t[h] : h) - r / 100}${n})`;
  }
  function c(h, m) {
    const v = s.indexOf(m);
    return `@media (min-width:${typeof t[h] == "number" ? t[h] : h}${n}) and (max-width:${(v !== -1 && typeof t[s[v]] == "number" ? t[s[v]] : m) - r / 100}${n})`;
  }
  function d(h) {
    return s.indexOf(h) + 1 < s.length ? c(h, s[s.indexOf(h) + 1]) : a(h);
  }
  function f(h) {
    const m = s.indexOf(h);
    return m === 0 ? a(s[1]) : m === s.length - 1 ? u(s[m]) : c(h, s[s.indexOf(h) + 1]).replace("@media", "@media not all and");
  }
  return N({
    keys: s,
    values: o,
    up: a,
    down: u,
    between: c,
    only: d,
    not: f,
    unit: n
  }, i);
}
const f$e = {
  borderRadius: 4
}, Sd = process.env.NODE_ENV !== "production" ? l.oneOfType([l.number, l.string, l.object, l.array]) : {};
function s0(e, t) {
  return t ? is(e, t, {
    clone: !1
    // No need to clone deep, it's way faster.
  }) : e;
}
const BI = {
  xs: 0,
  // phone
  sm: 600,
  // tablet
  md: 900,
  // small laptop
  lg: 1200,
  // desktop
  xl: 1536
  // large screen
}, wB = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ["xs", "sm", "md", "lg", "xl"],
  up: (e) => `@media (min-width:${BI[e]}px)`
};
function Fs(e, t, n) {
  const r = e.theme || {};
  if (Array.isArray(t)) {
    const o = r.breakpoints || wB;
    return t.reduce((s, a, u) => (s[o.up(o.keys[u])] = n(t[u]), s), {});
  }
  if (typeof t == "object") {
    const o = r.breakpoints || wB;
    return Object.keys(t).reduce((s, a) => {
      if (Object.keys(o.values || BI).indexOf(a) !== -1) {
        const u = o.up(a);
        s[u] = n(t[a], a);
      } else {
        const u = a;
        s[u] = t[u];
      }
      return s;
    }, {});
  }
  return n(t);
}
function Mz(e = {}) {
  var t;
  return ((t = e.keys) == null ? void 0 : t.reduce((r, i) => {
    const o = e.up(i);
    return r[o] = {}, r;
  }, {})) || {};
}
function Rz(e, t) {
  return e.reduce((n, r) => {
    const i = n[r];
    return (!i || Object.keys(i).length === 0) && delete n[r], n;
  }, t);
}
function h$e(e, ...t) {
  const n = Mz(e), r = [n, ...t].reduce((i, o) => is(i, o), {});
  return Rz(Object.keys(n), r);
}
function m$e(e, t) {
  if (typeof e != "object")
    return {};
  const n = {}, r = Object.keys(t);
  return Array.isArray(e) ? r.forEach((i, o) => {
    o < e.length && (n[i] = !0);
  }) : r.forEach((i) => {
    e[i] != null && (n[i] = !0);
  }), n;
}
function Rp({
  values: e,
  breakpoints: t,
  base: n
}) {
  const r = n || m$e(e, t), i = Object.keys(r);
  if (i.length === 0)
    return e;
  let o;
  return i.reduce((s, a, u) => (Array.isArray(e) ? (s[a] = e[u] != null ? e[u] : e[o], o = u) : typeof e == "object" ? (s[a] = e[a] != null ? e[a] : e[o], o = a) : s[a] = e, s), {});
}
function Ue(e) {
  if (typeof e != "string")
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `capitalize(string)` expects a string argument." : gu(7));
  return e.charAt(0).toUpperCase() + e.slice(1);
}
const g$e = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ue
}, Symbol.toStringTag, { value: "Module" }));
function xE(e, t, n = !0) {
  if (!t || typeof t != "string")
    return null;
  if (e && e.vars && n) {
    const r = `vars.${t}`.split(".").reduce((i, o) => i && i[o] ? i[o] : null, e);
    if (r != null)
      return r;
  }
  return t.split(".").reduce((r, i) => r && r[i] != null ? r[i] : null, e);
}
function VD(e, t, n, r = n) {
  let i;
  return typeof e == "function" ? i = e(n) : Array.isArray(e) ? i = e[n] || r : i = xE(e, n) || r, t && (i = t(i, r, e)), i;
}
function ki(e) {
  const {
    prop: t,
    cssProperty: n = e.prop,
    themeKey: r,
    transform: i
  } = e, o = (s) => {
    if (s[t] == null)
      return null;
    const a = s[t], u = s.theme, c = xE(u, r) || {};
    return Fs(s, a, (f) => {
      let h = VD(c, i, f);
      return f === h && typeof f == "string" && (h = VD(c, i, `${t}${f === "default" ? "" : Ue(f)}`, f)), n === !1 ? h : {
        [n]: h
      };
    });
  };
  return o.propTypes = process.env.NODE_ENV !== "production" ? {
    [t]: Sd
  } : {}, o.filterProps = [t], o;
}
function y$e(e) {
  const t = {};
  return (n) => (t[n] === void 0 && (t[n] = e(n)), t[n]);
}
const b$e = {
  m: "margin",
  p: "padding"
}, v$e = {
  t: "Top",
  r: "Right",
  b: "Bottom",
  l: "Left",
  x: ["Left", "Right"],
  y: ["Top", "Bottom"]
}, PB = {
  marginX: "mx",
  marginY: "my",
  paddingX: "px",
  paddingY: "py"
}, x$e = y$e((e) => {
  if (e.length > 2)
    if (PB[e])
      e = PB[e];
    else
      return [e];
  const [t, n] = e.split(""), r = b$e[t], i = v$e[n] || "";
  return Array.isArray(i) ? i.map((o) => r + o) : [r + i];
}), DE = ["m", "mt", "mr", "mb", "ml", "mx", "my", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "marginInline", "marginInlineStart", "marginInlineEnd", "marginBlock", "marginBlockStart", "marginBlockEnd"], CE = ["p", "pt", "pr", "pb", "pl", "px", "py", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingX", "paddingY", "paddingInline", "paddingInlineStart", "paddingInlineEnd", "paddingBlock", "paddingBlockStart", "paddingBlockEnd"], D$e = [...DE, ...CE];
function _b(e, t, n, r) {
  var i;
  const o = (i = xE(e, t, !1)) != null ? i : n;
  return typeof o == "number" ? (s) => typeof s == "string" ? s : (process.env.NODE_ENV !== "production" && typeof s != "number" && console.error(`MUI: Expected ${r} argument to be a number or a string, got ${s}.`), o * s) : Array.isArray(o) ? (s) => typeof s == "string" ? s : (process.env.NODE_ENV !== "production" && (Number.isInteger(s) ? s > o.length - 1 && console.error([`MUI: The value provided (${s}) overflows.`, `The supported values are: ${JSON.stringify(o)}.`, `${s} > ${o.length - 1}, you need to add the missing values.`].join(`
`)) : console.error([`MUI: The \`theme.${t}\` array type cannot be combined with non integer values.You should either use an integer value that can be used as index, or define the \`theme.${t}\` as a number.`].join(`
`))), o[s]) : typeof o == "function" ? o : (process.env.NODE_ENV !== "production" && console.error([`MUI: The \`theme.${t}\` value (${o}) is invalid.`, "It should be a number, an array or a function."].join(`
`)), () => {
  });
}
function jI(e) {
  return _b(e, "spacing", 8, "spacing");
}
function qp(e, t) {
  if (typeof t == "string" || t == null)
    return t;
  const n = Math.abs(t), r = e(n);
  return t >= 0 ? r : typeof r == "number" ? -r : `-${r}`;
}
function C$e(e, t) {
  return (n) => e.reduce((r, i) => (r[i] = qp(t, n), r), {});
}
function E$e(e, t, n, r) {
  if (t.indexOf(n) === -1)
    return null;
  const i = x$e(n), o = C$e(i, r), s = e[n];
  return Fs(e, s, o);
}
function _z(e, t) {
  const n = jI(e.theme);
  return Object.keys(e).map((r) => E$e(e, t, r, n)).reduce(s0, {});
}
function pi(e) {
  return _z(e, DE);
}
pi.propTypes = process.env.NODE_ENV !== "production" ? DE.reduce((e, t) => (e[t] = Sd, e), {}) : {};
pi.filterProps = DE;
function fi(e) {
  return _z(e, CE);
}
fi.propTypes = process.env.NODE_ENV !== "production" ? CE.reduce((e, t) => (e[t] = Sd, e), {}) : {};
fi.filterProps = CE;
process.env.NODE_ENV !== "production" && D$e.reduce((e, t) => (e[t] = Sd, e), {});
function T$e(e = 8) {
  if (e.mui)
    return e;
  const t = jI({
    spacing: e
  }), n = (...r) => (process.env.NODE_ENV !== "production" && (r.length <= 4 || console.error(`MUI: Too many arguments provided, expected between 0 and 4, got ${r.length}`)), (r.length === 0 ? [1] : r).map((o) => {
    const s = t(o);
    return typeof s == "number" ? `${s}px` : s;
  }).join(" "));
  return n.mui = !0, n;
}
function EE(...e) {
  const t = e.reduce((r, i) => (i.filterProps.forEach((o) => {
    r[o] = i;
  }), r), {}), n = (r) => Object.keys(r).reduce((i, o) => t[o] ? s0(i, t[o](r)) : i, {});
  return n.propTypes = process.env.NODE_ENV !== "production" ? e.reduce((r, i) => Object.assign(r, i.propTypes), {}) : {}, n.filterProps = e.reduce((r, i) => r.concat(i.filterProps), []), n;
}
function wa(e) {
  return typeof e != "number" ? e : `${e}px solid`;
}
function Ja(e, t) {
  return ki({
    prop: e,
    themeKey: "borders",
    transform: t
  });
}
const S$e = Ja("border", wa), A$e = Ja("borderTop", wa), w$e = Ja("borderRight", wa), P$e = Ja("borderBottom", wa), k$e = Ja("borderLeft", wa), O$e = Ja("borderColor"), I$e = Ja("borderTopColor"), F$e = Ja("borderRightColor"), $$e = Ja("borderBottomColor"), N$e = Ja("borderLeftColor"), M$e = Ja("outline", wa), R$e = Ja("outlineColor"), TE = (e) => {
  if (e.borderRadius !== void 0 && e.borderRadius !== null) {
    const t = _b(e.theme, "shape.borderRadius", 4, "borderRadius"), n = (r) => ({
      borderRadius: qp(t, r)
    });
    return Fs(e, e.borderRadius, n);
  }
  return null;
};
TE.propTypes = process.env.NODE_ENV !== "production" ? {
  borderRadius: Sd
} : {};
TE.filterProps = ["borderRadius"];
EE(S$e, A$e, w$e, P$e, k$e, O$e, I$e, F$e, $$e, N$e, TE, M$e, R$e);
const SE = (e) => {
  if (e.gap !== void 0 && e.gap !== null) {
    const t = _b(e.theme, "spacing", 8, "gap"), n = (r) => ({
      gap: qp(t, r)
    });
    return Fs(e, e.gap, n);
  }
  return null;
};
SE.propTypes = process.env.NODE_ENV !== "production" ? {
  gap: Sd
} : {};
SE.filterProps = ["gap"];
const AE = (e) => {
  if (e.columnGap !== void 0 && e.columnGap !== null) {
    const t = _b(e.theme, "spacing", 8, "columnGap"), n = (r) => ({
      columnGap: qp(t, r)
    });
    return Fs(e, e.columnGap, n);
  }
  return null;
};
AE.propTypes = process.env.NODE_ENV !== "production" ? {
  columnGap: Sd
} : {};
AE.filterProps = ["columnGap"];
const wE = (e) => {
  if (e.rowGap !== void 0 && e.rowGap !== null) {
    const t = _b(e.theme, "spacing", 8, "rowGap"), n = (r) => ({
      rowGap: qp(t, r)
    });
    return Fs(e, e.rowGap, n);
  }
  return null;
};
wE.propTypes = process.env.NODE_ENV !== "production" ? {
  rowGap: Sd
} : {};
wE.filterProps = ["rowGap"];
const _$e = ki({
  prop: "gridColumn"
}), L$e = ki({
  prop: "gridRow"
}), B$e = ki({
  prop: "gridAutoFlow"
}), j$e = ki({
  prop: "gridAutoColumns"
}), V$e = ki({
  prop: "gridAutoRows"
}), z$e = ki({
  prop: "gridTemplateColumns"
}), U$e = ki({
  prop: "gridTemplateRows"
}), W$e = ki({
  prop: "gridTemplateAreas"
}), H$e = ki({
  prop: "gridArea"
});
EE(SE, AE, wE, _$e, L$e, B$e, j$e, V$e, z$e, U$e, W$e, H$e);
function qh(e, t) {
  return t === "grey" ? t : e;
}
const q$e = ki({
  prop: "color",
  themeKey: "palette",
  transform: qh
}), G$e = ki({
  prop: "bgcolor",
  cssProperty: "backgroundColor",
  themeKey: "palette",
  transform: qh
}), Y$e = ki({
  prop: "backgroundColor",
  themeKey: "palette",
  transform: qh
});
EE(q$e, G$e, Y$e);
function Zs(e) {
  return e <= 1 && e !== 0 ? `${e * 100}%` : e;
}
const K$e = ki({
  prop: "width",
  transform: Zs
}), VI = (e) => {
  if (e.maxWidth !== void 0 && e.maxWidth !== null) {
    const t = (n) => {
      var r, i;
      const o = ((r = e.theme) == null || (r = r.breakpoints) == null || (r = r.values) == null ? void 0 : r[n]) || BI[n];
      return o ? ((i = e.theme) == null || (i = i.breakpoints) == null ? void 0 : i.unit) !== "px" ? {
        maxWidth: `${o}${e.theme.breakpoints.unit}`
      } : {
        maxWidth: o
      } : {
        maxWidth: Zs(n)
      };
    };
    return Fs(e, e.maxWidth, t);
  }
  return null;
};
VI.filterProps = ["maxWidth"];
const J$e = ki({
  prop: "minWidth",
  transform: Zs
}), X$e = ki({
  prop: "height",
  transform: Zs
}), Q$e = ki({
  prop: "maxHeight",
  transform: Zs
}), Z$e = ki({
  prop: "minHeight",
  transform: Zs
});
ki({
  prop: "size",
  cssProperty: "width",
  transform: Zs
});
ki({
  prop: "size",
  cssProperty: "height",
  transform: Zs
});
const eNe = ki({
  prop: "boxSizing"
});
EE(K$e, VI, J$e, X$e, Q$e, Z$e, eNe);
const Lb = {
  // borders
  border: {
    themeKey: "borders",
    transform: wa
  },
  borderTop: {
    themeKey: "borders",
    transform: wa
  },
  borderRight: {
    themeKey: "borders",
    transform: wa
  },
  borderBottom: {
    themeKey: "borders",
    transform: wa
  },
  borderLeft: {
    themeKey: "borders",
    transform: wa
  },
  borderColor: {
    themeKey: "palette"
  },
  borderTopColor: {
    themeKey: "palette"
  },
  borderRightColor: {
    themeKey: "palette"
  },
  borderBottomColor: {
    themeKey: "palette"
  },
  borderLeftColor: {
    themeKey: "palette"
  },
  outline: {
    themeKey: "borders",
    transform: wa
  },
  outlineColor: {
    themeKey: "palette"
  },
  borderRadius: {
    themeKey: "shape.borderRadius",
    style: TE
  },
  // palette
  color: {
    themeKey: "palette",
    transform: qh
  },
  bgcolor: {
    themeKey: "palette",
    cssProperty: "backgroundColor",
    transform: qh
  },
  backgroundColor: {
    themeKey: "palette",
    transform: qh
  },
  // spacing
  p: {
    style: fi
  },
  pt: {
    style: fi
  },
  pr: {
    style: fi
  },
  pb: {
    style: fi
  },
  pl: {
    style: fi
  },
  px: {
    style: fi
  },
  py: {
    style: fi
  },
  padding: {
    style: fi
  },
  paddingTop: {
    style: fi
  },
  paddingRight: {
    style: fi
  },
  paddingBottom: {
    style: fi
  },
  paddingLeft: {
    style: fi
  },
  paddingX: {
    style: fi
  },
  paddingY: {
    style: fi
  },
  paddingInline: {
    style: fi
  },
  paddingInlineStart: {
    style: fi
  },
  paddingInlineEnd: {
    style: fi
  },
  paddingBlock: {
    style: fi
  },
  paddingBlockStart: {
    style: fi
  },
  paddingBlockEnd: {
    style: fi
  },
  m: {
    style: pi
  },
  mt: {
    style: pi
  },
  mr: {
    style: pi
  },
  mb: {
    style: pi
  },
  ml: {
    style: pi
  },
  mx: {
    style: pi
  },
  my: {
    style: pi
  },
  margin: {
    style: pi
  },
  marginTop: {
    style: pi
  },
  marginRight: {
    style: pi
  },
  marginBottom: {
    style: pi
  },
  marginLeft: {
    style: pi
  },
  marginX: {
    style: pi
  },
  marginY: {
    style: pi
  },
  marginInline: {
    style: pi
  },
  marginInlineStart: {
    style: pi
  },
  marginInlineEnd: {
    style: pi
  },
  marginBlock: {
    style: pi
  },
  marginBlockStart: {
    style: pi
  },
  marginBlockEnd: {
    style: pi
  },
  // display
  displayPrint: {
    cssProperty: !1,
    transform: (e) => ({
      "@media print": {
        display: e
      }
    })
  },
  display: {},
  overflow: {},
  textOverflow: {},
  visibility: {},
  whiteSpace: {},
  // flexbox
  flexBasis: {},
  flexDirection: {},
  flexWrap: {},
  justifyContent: {},
  alignItems: {},
  alignContent: {},
  order: {},
  flex: {},
  flexGrow: {},
  flexShrink: {},
  alignSelf: {},
  justifyItems: {},
  justifySelf: {},
  // grid
  gap: {
    style: SE
  },
  rowGap: {
    style: wE
  },
  columnGap: {
    style: AE
  },
  gridColumn: {},
  gridRow: {},
  gridAutoFlow: {},
  gridAutoColumns: {},
  gridAutoRows: {},
  gridTemplateColumns: {},
  gridTemplateRows: {},
  gridTemplateAreas: {},
  gridArea: {},
  // positions
  position: {},
  zIndex: {
    themeKey: "zIndex"
  },
  top: {},
  right: {},
  bottom: {},
  left: {},
  // shadows
  boxShadow: {
    themeKey: "shadows"
  },
  // sizing
  width: {
    transform: Zs
  },
  maxWidth: {
    style: VI
  },
  minWidth: {
    transform: Zs
  },
  height: {
    transform: Zs
  },
  maxHeight: {
    transform: Zs
  },
  minHeight: {
    transform: Zs
  },
  boxSizing: {},
  // typography
  fontFamily: {
    themeKey: "typography"
  },
  fontSize: {
    themeKey: "typography"
  },
  fontStyle: {
    themeKey: "typography"
  },
  fontWeight: {
    themeKey: "typography"
  },
  letterSpacing: {},
  textTransform: {},
  lineHeight: {},
  textAlign: {},
  typography: {
    cssProperty: !1,
    themeKey: "typography"
  }
};
function tNe(...e) {
  const t = e.reduce((r, i) => r.concat(Object.keys(i)), []), n = new Set(t);
  return e.every((r) => n.size === Object.keys(r).length);
}
function nNe(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Lz() {
  function e(n, r, i, o) {
    const s = {
      [n]: r,
      theme: i
    }, a = o[n];
    if (!a)
      return {
        [n]: r
      };
    const {
      cssProperty: u = n,
      themeKey: c,
      transform: d,
      style: f
    } = a;
    if (r == null)
      return null;
    if (c === "typography" && r === "inherit")
      return {
        [n]: r
      };
    const h = xE(i, c) || {};
    return f ? f(s) : Fs(s, r, (v) => {
      let x = VD(h, d, v);
      return v === x && typeof v == "string" && (x = VD(h, d, `${n}${v === "default" ? "" : Ue(v)}`, v)), u === !1 ? x : {
        [u]: x
      };
    });
  }
  function t(n) {
    var r;
    const {
      sx: i,
      theme: o = {}
    } = n || {};
    if (!i)
      return null;
    const s = (r = o.unstable_sxConfig) != null ? r : Lb;
    function a(u) {
      let c = u;
      if (typeof u == "function")
        c = u(o);
      else if (typeof u != "object")
        return u;
      if (!c)
        return null;
      const d = Mz(o.breakpoints), f = Object.keys(d);
      let h = d;
      return Object.keys(c).forEach((m) => {
        const v = nNe(c[m], o);
        if (v != null)
          if (typeof v == "object")
            if (s[m])
              h = s0(h, e(m, v, o, s));
            else {
              const x = Fs({
                theme: o
              }, v, (C) => ({
                [m]: C
              }));
              tNe(x, v) ? h[m] = t({
                sx: v,
                theme: o
              }) : h = s0(h, x);
            }
          else
            h = s0(h, e(m, v, o, s));
      }), Rz(f, h);
    }
    return Array.isArray(i) ? i.map(a) : a(i);
  }
  return t;
}
const tg = Lz();
tg.filterProps = ["sx"];
function Bz(e, t) {
  const n = this;
  return n.vars && typeof n.getColorSchemeSelector == "function" ? {
    [n.getColorSchemeSelector(e).replace(/(\[[^\]]+\])/, "*:where($1)")]: t
  } : n.palette.mode === e ? t : {};
}
const rNe = ["breakpoints", "palette", "spacing", "shape"];
function ng(e = {}, ...t) {
  const {
    breakpoints: n = {},
    palette: r = {},
    spacing: i,
    shape: o = {}
  } = e, s = _e(e, rNe), a = Nz(n), u = T$e(i);
  let c = is({
    breakpoints: a,
    direction: "ltr",
    components: {},
    // Inject component definitions.
    palette: N({
      mode: "light"
    }, r),
    spacing: u,
    shape: N({}, f$e, o)
  }, s);
  return c.applyStyles = Bz, c = t.reduce((d, f) => is(d, f), c), c.unstable_sxConfig = N({}, Lb, s == null ? void 0 : s.unstable_sxConfig), c.unstable_sx = function(f) {
    return tg({
      sx: f,
      theme: this
    });
  }, c;
}
const iNe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ng,
  private_createBreakpoints: Nz,
  unstable_applyStyles: Bz
}, Symbol.toStringTag, { value: "Module" }));
function oNe(e) {
  return Object.keys(e).length === 0;
}
function jz(e = null) {
  const t = V.useContext(am);
  return !t || oNe(t) ? e : t;
}
const sNe = ng();
function rg(e = sNe) {
  return jz(e);
}
function Vz({
  styles: e,
  themeId: t,
  defaultTheme: n = {}
}) {
  const r = rg(n), i = typeof e == "function" ? e(t && r[t] || r) : e;
  return /* @__PURE__ */ P.jsx(_I, {
    styles: i
  });
}
process.env.NODE_ENV !== "production" && (Vz.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  defaultTheme: l.object,
  /**
   * @ignore
   */
  styles: l.oneOfType([l.array, l.func, l.number, l.object, l.string, l.bool]),
  /**
   * @ignore
   */
  themeId: l.string
});
const aNe = ["sx"], lNe = (e) => {
  var t, n;
  const r = {
    systemProps: {},
    otherProps: {}
  }, i = (t = e == null || (n = e.theme) == null ? void 0 : n.unstable_sxConfig) != null ? t : Lb;
  return Object.keys(e).forEach((o) => {
    i[o] ? r.systemProps[o] = e[o] : r.otherProps[o] = e[o];
  }), r;
};
function Bb(e) {
  const {
    sx: t
  } = e, n = _e(e, aNe), {
    systemProps: r,
    otherProps: i
  } = lNe(n);
  let o;
  return Array.isArray(t) ? o = [r, ...t] : typeof t == "function" ? o = (...s) => {
    const a = t(...s);
    return Zu(a) ? N({}, r, a) : r;
  } : o = N({}, r, t), N({}, i, {
    sx: o
  });
}
const uNe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: tg,
  extendSxProp: Bb,
  unstable_createStyleFunctionSx: Lz,
  unstable_defaultSxConfig: Lb
}, Symbol.toStringTag, { value: "Module" })), kB = (e) => e, cNe = () => {
  let e = kB;
  return {
    configure(t) {
      e = t;
    },
    generate(t) {
      return e(t);
    },
    reset() {
      e = kB;
    }
  };
}, zI = cNe();
function zz(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number") r += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var i = e.length;
    for (t = 0; t < i; t++) e[t] && (n = zz(e[t])) && (r && (r += " "), r += n);
  } else for (n in e) e[n] && (r && (r += " "), r += n);
  return r;
}
function Be() {
  for (var e, t, n = 0, r = "", i = arguments.length; n < i; n++) (e = arguments[n]) && (t = zz(e)) && (r && (r += " "), r += t);
  return r;
}
const dNe = ["className", "component"];
function pNe(e = {}) {
  const {
    themeId: t,
    defaultTheme: n,
    defaultClassName: r = "MuiBox-root",
    generateClassName: i
  } = e, o = LI("div", {
    shouldForwardProp: (a) => a !== "theme" && a !== "sx" && a !== "as"
  })(tg);
  return /* @__PURE__ */ V.forwardRef(function(u, c) {
    const d = rg(n), f = Bb(u), {
      className: h,
      component: m = "div"
    } = f, v = _e(f, dNe);
    return /* @__PURE__ */ P.jsx(o, N({
      as: m,
      ref: c,
      className: Be(h, i ? i(r) : r),
      theme: t && d[t] || d
    }, v));
  });
}
const fNe = {
  active: "active",
  checked: "checked",
  completed: "completed",
  disabled: "disabled",
  error: "error",
  expanded: "expanded",
  focused: "focused",
  focusVisible: "focusVisible",
  open: "open",
  readOnly: "readOnly",
  required: "required",
  selected: "selected"
};
function ot(e, t, n = "Mui") {
  const r = fNe[t];
  return r ? `${n}-${r}` : `${zI.generate(e)}-${t}`;
}
function st(e, t, n = "Mui") {
  const r = {};
  return t.forEach((i) => {
    r[i] = ot(e, i, n);
  }), r;
}
var UP = { exports: {} }, Cr = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var OB;
function hNe() {
  if (OB) return Cr;
  OB = 1;
  var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), s = Symbol.for("react.context"), a = Symbol.for("react.server_context"), u = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), m = Symbol.for("react.offscreen"), v;
  v = Symbol.for("react.module.reference");
  function x(C) {
    if (typeof C == "object" && C !== null) {
      var E = C.$$typeof;
      switch (E) {
        case e:
          switch (C = C.type, C) {
            case n:
            case i:
            case r:
            case c:
            case d:
              return C;
            default:
              switch (C = C && C.$$typeof, C) {
                case a:
                case s:
                case u:
                case h:
                case f:
                case o:
                  return C;
                default:
                  return E;
              }
          }
        case t:
          return E;
      }
    }
  }
  return Cr.ContextConsumer = s, Cr.ContextProvider = o, Cr.Element = e, Cr.ForwardRef = u, Cr.Fragment = n, Cr.Lazy = h, Cr.Memo = f, Cr.Portal = t, Cr.Profiler = i, Cr.StrictMode = r, Cr.Suspense = c, Cr.SuspenseList = d, Cr.isAsyncMode = function() {
    return !1;
  }, Cr.isConcurrentMode = function() {
    return !1;
  }, Cr.isContextConsumer = function(C) {
    return x(C) === s;
  }, Cr.isContextProvider = function(C) {
    return x(C) === o;
  }, Cr.isElement = function(C) {
    return typeof C == "object" && C !== null && C.$$typeof === e;
  }, Cr.isForwardRef = function(C) {
    return x(C) === u;
  }, Cr.isFragment = function(C) {
    return x(C) === n;
  }, Cr.isLazy = function(C) {
    return x(C) === h;
  }, Cr.isMemo = function(C) {
    return x(C) === f;
  }, Cr.isPortal = function(C) {
    return x(C) === t;
  }, Cr.isProfiler = function(C) {
    return x(C) === i;
  }, Cr.isStrictMode = function(C) {
    return x(C) === r;
  }, Cr.isSuspense = function(C) {
    return x(C) === c;
  }, Cr.isSuspenseList = function(C) {
    return x(C) === d;
  }, Cr.isValidElementType = function(C) {
    return typeof C == "string" || typeof C == "function" || C === n || C === i || C === r || C === c || C === d || C === m || typeof C == "object" && C !== null && (C.$$typeof === h || C.$$typeof === f || C.$$typeof === o || C.$$typeof === s || C.$$typeof === u || C.$$typeof === v || C.getModuleId !== void 0);
  }, Cr.typeOf = x, Cr;
}
var Er = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var IB;
function mNe() {
  return IB || (IB = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), s = Symbol.for("react.context"), a = Symbol.for("react.server_context"), u = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), m = Symbol.for("react.offscreen"), v = !1, x = !1, C = !1, E = !1, S = !1, w;
    w = Symbol.for("react.module.reference");
    function O(be) {
      return !!(typeof be == "string" || typeof be == "function" || be === n || be === i || S || be === r || be === c || be === d || E || be === m || v || x || C || typeof be == "object" && be !== null && (be.$$typeof === h || be.$$typeof === f || be.$$typeof === o || be.$$typeof === s || be.$$typeof === u || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      be.$$typeof === w || be.getModuleId !== void 0));
    }
    function A(be) {
      if (typeof be == "object" && be !== null) {
        var Re = be.$$typeof;
        switch (Re) {
          case e:
            var Te = be.type;
            switch (Te) {
              case n:
              case i:
              case r:
              case c:
              case d:
                return Te;
              default:
                var Xe = Te && Te.$$typeof;
                switch (Xe) {
                  case a:
                  case s:
                  case u:
                  case h:
                  case f:
                  case o:
                    return Xe;
                  default:
                    return Re;
                }
            }
          case t:
            return Re;
        }
      }
    }
    var I = s, $ = o, L = e, B = u, H = n, q = h, J = f, X = t, j = i, U = r, G = c, K = d, ee = !1, te = !1;
    function M(be) {
      return ee || (ee = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function Z(be) {
      return te || (te = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function ne(be) {
      return A(be) === s;
    }
    function R(be) {
      return A(be) === o;
    }
    function _(be) {
      return typeof be == "object" && be !== null && be.$$typeof === e;
    }
    function W(be) {
      return A(be) === u;
    }
    function Q(be) {
      return A(be) === n;
    }
    function oe(be) {
      return A(be) === h;
    }
    function ae(be) {
      return A(be) === f;
    }
    function pe(be) {
      return A(be) === t;
    }
    function me(be) {
      return A(be) === i;
    }
    function xe(be) {
      return A(be) === r;
    }
    function le(be) {
      return A(be) === c;
    }
    function ye(be) {
      return A(be) === d;
    }
    Er.ContextConsumer = I, Er.ContextProvider = $, Er.Element = L, Er.ForwardRef = B, Er.Fragment = H, Er.Lazy = q, Er.Memo = J, Er.Portal = X, Er.Profiler = j, Er.StrictMode = U, Er.Suspense = G, Er.SuspenseList = K, Er.isAsyncMode = M, Er.isConcurrentMode = Z, Er.isContextConsumer = ne, Er.isContextProvider = R, Er.isElement = _, Er.isForwardRef = W, Er.isFragment = Q, Er.isLazy = oe, Er.isMemo = ae, Er.isPortal = pe, Er.isProfiler = me, Er.isStrictMode = xe, Er.isSuspense = le, Er.isSuspenseList = ye, Er.isValidElementType = O, Er.typeOf = A;
  }()), Er;
}
process.env.NODE_ENV === "production" ? UP.exports = hNe() : UP.exports = mNe();
var Gp = UP.exports;
const gNe = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function Uz(e) {
  const t = `${e}`.match(gNe);
  return t && t[1] || "";
}
function Wz(e, t = "") {
  return e.displayName || e.name || Uz(e) || t;
}
function FB(e, t, n) {
  const r = Wz(t);
  return e.displayName || (r !== "" ? `${n}(${r})` : n);
}
function Hz(e) {
  if (e != null) {
    if (typeof e == "string")
      return e;
    if (typeof e == "function")
      return Wz(e, "Component");
    if (typeof e == "object")
      switch (e.$$typeof) {
        case Gp.ForwardRef:
          return FB(e, e.render, "ForwardRef");
        case Gp.Memo:
          return FB(e, e.type, "memo");
        default:
          return;
      }
  }
}
const yNe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Hz,
  getFunctionName: Uz
}, Symbol.toStringTag, { value: "Module" })), bNe = ["ownerState"], vNe = ["variants"], xNe = ["name", "slot", "skipVariantsResolver", "skipSx", "overridesResolver"];
function DNe(e) {
  return Object.keys(e).length === 0;
}
function CNe(e) {
  return typeof e == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  e.charCodeAt(0) > 96;
}
function zA(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
const ENe = ng(), $B = (e) => e && e.charAt(0).toLowerCase() + e.slice(1);
function R1({
  defaultTheme: e,
  theme: t,
  themeId: n
}) {
  return DNe(t) ? e : t[n] || t;
}
function TNe(e) {
  return e ? (t, n) => n[e] : null;
}
function Kx(e, t) {
  let {
    ownerState: n
  } = t, r = _e(t, bNe);
  const i = typeof e == "function" ? e(N({
    ownerState: n
  }, r)) : e;
  if (Array.isArray(i))
    return i.flatMap((o) => Kx(o, N({
      ownerState: n
    }, r)));
  if (i && typeof i == "object" && Array.isArray(i.variants)) {
    const {
      variants: o = []
    } = i;
    let a = _e(i, vNe);
    return o.forEach((u) => {
      let c = !0;
      typeof u.props == "function" ? c = u.props(N({
        ownerState: n
      }, r, n)) : Object.keys(u.props).forEach((d) => {
        (n == null ? void 0 : n[d]) !== u.props[d] && r[d] !== u.props[d] && (c = !1);
      }), c && (Array.isArray(a) || (a = [a]), a.push(typeof u.style == "function" ? u.style(N({
        ownerState: n
      }, r, n)) : u.style));
    }), a;
  }
  return i;
}
function SNe(e = {}) {
  const {
    themeId: t,
    defaultTheme: n = ENe,
    rootShouldForwardProp: r = zA,
    slotShouldForwardProp: i = zA
  } = e, o = (s) => tg(N({}, s, {
    theme: R1(N({}, s, {
      defaultTheme: n,
      themeId: t
    }))
  }));
  return o.__mui_systemSx = !0, (s, a = {}) => {
    Fz(s, (A) => A.filter((I) => !(I != null && I.__mui_systemSx)));
    const {
      name: u,
      slot: c,
      skipVariantsResolver: d,
      skipSx: f,
      // TODO v6: remove `lowercaseFirstLetter()` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      overridesResolver: h = TNe($B(c))
    } = a, m = _e(a, xNe), v = d !== void 0 ? d : (
      // TODO v6: remove `Root` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      c && c !== "Root" && c !== "root" || !1
    ), x = f || !1;
    let C;
    process.env.NODE_ENV !== "production" && u && (C = `${u}-${$B(c || "Root")}`);
    let E = zA;
    c === "Root" || c === "root" ? E = r : c ? E = i : CNe(s) && (E = void 0);
    const S = LI(s, N({
      shouldForwardProp: E,
      label: C
    }, m)), w = (A) => typeof A == "function" && A.__emotion_real !== A || Zu(A) ? (I) => Kx(A, N({}, I, {
      theme: R1({
        theme: I.theme,
        defaultTheme: n,
        themeId: t
      })
    })) : A, O = (A, ...I) => {
      let $ = w(A);
      const L = I ? I.map(w) : [];
      u && h && L.push((q) => {
        const J = R1(N({}, q, {
          defaultTheme: n,
          themeId: t
        }));
        if (!J.components || !J.components[u] || !J.components[u].styleOverrides)
          return null;
        const X = J.components[u].styleOverrides, j = {};
        return Object.entries(X).forEach(([U, G]) => {
          j[U] = Kx(G, N({}, q, {
            theme: J
          }));
        }), h(q, j);
      }), u && !v && L.push((q) => {
        var J;
        const X = R1(N({}, q, {
          defaultTheme: n,
          themeId: t
        })), j = X == null || (J = X.components) == null || (J = J[u]) == null ? void 0 : J.variants;
        return Kx({
          variants: j
        }, N({}, q, {
          theme: X
        }));
      }), x || L.push(o);
      const B = L.length - I.length;
      if (Array.isArray(A) && B > 0) {
        const q = new Array(B).fill("");
        $ = [...A, ...q], $.raw = [...A.raw, ...q];
      }
      const H = S($, ...L);
      if (process.env.NODE_ENV !== "production") {
        let q;
        u && (q = `${u}${Ue(c || "")}`), q === void 0 && (q = `Styled(${Hz(s)})`), H.displayName = q;
      }
      return s.muiName && (H.muiName = s.muiName), H;
    };
    return S.withConfig && (O.withConfig = S.withConfig), O;
  };
}
const qz = SNe();
function R0(e, t) {
  const n = N({}, t);
  return Object.keys(e).forEach((r) => {
    if (r.toString().match(/^(components|slots)$/))
      n[r] = N({}, e[r], n[r]);
    else if (r.toString().match(/^(componentsProps|slotProps)$/)) {
      const i = e[r] || {}, o = t[r];
      n[r] = {}, !o || !Object.keys(o) ? n[r] = i : !i || !Object.keys(i) ? n[r] = o : (n[r] = N({}, o), Object.keys(i).forEach((s) => {
        n[r][s] = R0(i[s], o[s]);
      }));
    } else n[r] === void 0 && (n[r] = e[r]);
  }), n;
}
function Gz(e) {
  const {
    theme: t,
    name: n,
    props: r
  } = e;
  return !t || !t.components || !t.components[n] || !t.components[n].defaultProps ? r : R0(t.components[n].defaultProps, r);
}
function UI({
  props: e,
  name: t,
  defaultTheme: n,
  themeId: r
}) {
  let i = rg(n);
  return r && (i = i[r] || i), Gz({
    theme: i,
    name: t,
    props: e
  });
}
const gi = typeof window < "u" ? V.useLayoutEffect : V.useEffect;
function ANe(e, t, n, r, i) {
  const [o, s] = V.useState(() => i && n ? n(e).matches : r ? r(e).matches : t);
  return gi(() => {
    let a = !0;
    if (!n)
      return;
    const u = n(e), c = () => {
      a && s(u.matches);
    };
    return c(), u.addListener(c), () => {
      a = !1, u.removeListener(c);
    };
  }, [e, n]), o;
}
const Yz = V.useSyncExternalStore;
function wNe(e, t, n, r, i) {
  const o = V.useCallback(() => t, [t]), s = V.useMemo(() => {
    if (i && n)
      return () => n(e).matches;
    if (r !== null) {
      const {
        matches: d
      } = r(e);
      return () => d;
    }
    return o;
  }, [o, e, r, i, n]), [a, u] = V.useMemo(() => {
    if (n === null)
      return [o, () => () => {
      }];
    const d = n(e);
    return [() => d.matches, (f) => (d.addListener(f), () => {
      d.removeListener(f);
    })];
  }, [o, n, e]);
  return Yz(u, a, s);
}
function PE(e, t = {}) {
  const n = jz(), r = typeof window < "u" && typeof window.matchMedia < "u", {
    defaultMatches: i = !1,
    matchMedia: o = r ? window.matchMedia : null,
    ssrMatchMedia: s = null,
    noSsr: a = !1
  } = Gz({
    name: "MuiUseMediaQuery",
    props: t,
    theme: n
  });
  process.env.NODE_ENV !== "production" && typeof e == "function" && n === null && console.error(["MUI: The `query` argument provided is invalid.", "You are providing a function without a theme in the context.", "One of the parent elements needs to use a ThemeProvider."].join(`
`));
  let u = typeof e == "function" ? e(n) : e;
  u = u.replace(/^@media( ?)/m, "");
  const d = (Yz !== void 0 ? wNe : ANe)(u, i, o, s, a);
  return process.env.NODE_ENV !== "production" && V.useDebugValue({
    query: u,
    match: d
  }), d;
}
function Ep(e, t = Number.MIN_SAFE_INTEGER, n = Number.MAX_SAFE_INTEGER) {
  return Math.max(t, Math.min(e, n));
}
const PNe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ep
}, Symbol.toStringTag, { value: "Module" }));
function kNe(e, t = 0, n = 1) {
  return process.env.NODE_ENV !== "production" && (e < t || e > n) && console.error(`MUI: The value provided ${e} is out of range [${t}, ${n}].`), Ep(e, t, n);
}
function ONe(e) {
  e = e.slice(1);
  const t = new RegExp(`.{1,${e.length >= 6 ? 2 : 1}}`, "g");
  let n = e.match(t);
  return n && n[0].length === 1 && (n = n.map((r) => r + r)), n ? `rgb${n.length === 4 ? "a" : ""}(${n.map((r, i) => i < 3 ? parseInt(r, 16) : Math.round(parseInt(r, 16) / 255 * 1e3) / 1e3).join(", ")})` : "";
}
function Kz(e) {
  if (e.type)
    return e;
  if (e.charAt(0) === "#")
    return Kz(ONe(e));
  const t = e.indexOf("("), n = e.substring(0, t);
  if (["rgb", "rgba", "hsl", "hsla", "color"].indexOf(n) === -1)
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI: Unsupported \`${e}\` color.
The following formats are supported: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` : gu(9, e));
  let r = e.substring(t + 1, e.length - 1), i;
  if (n === "color") {
    if (r = r.split(" "), i = r.shift(), r.length === 4 && r[3].charAt(0) === "/" && (r[3] = r[3].slice(1)), ["srgb", "display-p3", "a98-rgb", "prophoto-rgb", "rec-2020"].indexOf(i) === -1)
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: unsupported \`${i}\` color space.
The following color spaces are supported: srgb, display-p3, a98-rgb, prophoto-rgb, rec-2020.` : gu(10, i));
  } else
    r = r.split(",");
  return r = r.map((o) => parseFloat(o)), {
    type: n,
    values: r,
    colorSpace: i
  };
}
function INe(e) {
  const {
    type: t,
    colorSpace: n
  } = e;
  let {
    values: r
  } = e;
  return t.indexOf("rgb") !== -1 ? r = r.map((i, o) => o < 3 ? parseInt(i, 10) : i) : t.indexOf("hsl") !== -1 && (r[1] = `${r[1]}%`, r[2] = `${r[2]}%`), t.indexOf("color") !== -1 ? r = `${n} ${r.join(" ")}` : r = `${r.join(", ")}`, `${t}(${r})`;
}
function yu(e, t) {
  return e = Kz(e), t = kNe(t), (e.type === "rgb" || e.type === "hsl") && (e.type += "a"), e.type === "color" ? e.values[3] = `/${t}` : e.values[3] = t, INe(e);
}
function $s(e, t) {
  return process.env.NODE_ENV === "production" ? () => null : function(...r) {
    return e(...r) || t(...r);
  };
}
function FNe(e) {
  const {
    prototype: t = {}
  } = e;
  return !!t.isReactComponent;
}
function Jz(e, t, n, r, i) {
  const o = e[t], s = i || t;
  if (o == null || // When server-side rendering React doesn't warn either.
  // This is not an accurate check for SSR.
  // This is only in place for Emotion compat.
  // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
  typeof window > "u")
    return null;
  let a;
  const u = o.type;
  return typeof u == "function" && !FNe(u) && (a = "Did you accidentally use a plain function component for an element instead?"), a !== void 0 ? new Error(`Invalid ${r} \`${s}\` supplied to \`${n}\`. Expected an element that can hold a ref. ${a} For more information see https://mui.com/r/caveat-with-refs-guide`) : null;
}
const ig = $s(l.element, Jz);
ig.isRequired = $s(l.element.isRequired, Jz);
function $Ne(e) {
  const {
    prototype: t = {}
  } = e;
  return !!t.isReactComponent;
}
function NNe(e, t, n, r, i) {
  const o = e[t], s = i || t;
  if (o == null || // When server-side rendering React doesn't warn either.
  // This is not an accurate check for SSR.
  // This is only in place for emotion compat.
  // TODO: Revisit once https://github.com/facebook/react/issues/20047 is resolved.
  typeof window > "u")
    return null;
  let a;
  return typeof o == "function" && !$Ne(o) && (a = "Did you accidentally provide a plain function component instead?"), a !== void 0 ? new Error(`Invalid ${r} \`${s}\` supplied to \`${n}\`. Expected an element type that can hold a ref. ${a} For more information see https://mui.com/r/caveat-with-refs-guide`) : null;
}
const jb = $s(l.elementType, NNe), MNe = "exact-prop: ​";
function Xz(e) {
  return process.env.NODE_ENV === "production" ? e : N({}, e, {
    [MNe]: (t) => {
      const n = Object.keys(t).filter((r) => !e.hasOwnProperty(r));
      return n.length > 0 ? new Error(`The following props are not supported: ${n.map((r) => `\`${r}\``).join(", ")}. Please remove them.`) : null;
    }
  });
}
function sc(e, t, n, r, i) {
  if (process.env.NODE_ENV === "production")
    return null;
  const o = e[t], s = i || t;
  return o == null ? null : o && o.nodeType !== 1 ? new Error(`Invalid ${r} \`${s}\` supplied to \`${n}\`. Expected an HTMLElement.`) : null;
}
const wr = l.oneOfType([l.func, l.object]);
function zD(...e) {
  return e.reduce((t, n) => n == null ? t : function(...i) {
    t.apply(this, i), n.apply(this, i);
  }, () => {
  });
}
function Vb(e, t = 166) {
  let n;
  function r(...i) {
    const o = () => {
      e.apply(this, i);
    };
    clearTimeout(n), n = setTimeout(o, t);
  }
  return r.clear = () => {
    clearTimeout(n);
  }, r;
}
function RNe(e, t) {
  return process.env.NODE_ENV === "production" ? () => null : (n, r, i, o, s) => {
    const a = i || "<<anonymous>>", u = s || r;
    return typeof n[r] < "u" ? new Error(`The ${o} \`${u}\` of \`${a}\` is deprecated. ${t}`) : null;
  };
}
function _p(e, t) {
  var n, r;
  return /* @__PURE__ */ V.isValidElement(e) && t.indexOf(
    // For server components `muiName` is avaialble in element.type._payload.value.muiName
    // relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    (n = e.type.muiName) != null ? n : (r = e.type) == null || (r = r._payload) == null || (r = r.value) == null ? void 0 : r.muiName
  ) !== -1;
}
function ei(e) {
  return e && e.ownerDocument || document;
}
function bu(e) {
  return ei(e).defaultView || window;
}
function Qz(e, t) {
  if (process.env.NODE_ENV === "production")
    return () => null;
  const n = t ? N({}, t.propTypes) : null;
  return (i) => (o, s, a, u, c, ...d) => {
    const f = c || s, h = n == null ? void 0 : n[f];
    if (h) {
      const m = h(o, s, a, u, c, ...d);
      if (m)
        return m;
    }
    return typeof o[s] < "u" && !o[i] ? new Error(`The prop \`${f}\` of \`${e}\` can only be used together with the \`${i}\` prop.`) : null;
  };
}
function _0(e, t) {
  typeof e == "function" ? e(t) : e && (e.current = t);
}
let NB = 0;
function _Ne(e) {
  const [t, n] = V.useState(e), r = e || t;
  return V.useEffect(() => {
    t == null && (NB += 1, n(`mui-${NB}`));
  }, [t]), r;
}
const MB = V.useId;
function Pl(e) {
  if (MB !== void 0) {
    const t = MB();
    return e ?? t;
  }
  return _Ne(e);
}
function WI(e, t, n, r, i) {
  if (process.env.NODE_ENV === "production")
    return null;
  const o = i || t;
  return typeof e[t] < "u" ? new Error(`The prop \`${o}\` is not supported. Please remove it.`) : null;
}
function Hi({
  controlled: e,
  default: t,
  name: n,
  state: r = "value"
}) {
  const {
    current: i
  } = V.useRef(e !== void 0), [o, s] = V.useState(t), a = i ? e : o;
  if (process.env.NODE_ENV !== "production") {
    V.useEffect(() => {
      i !== (e !== void 0) && console.error([`MUI: A component is changing the ${i ? "" : "un"}controlled ${r} state of ${n} to be ${i ? "un" : ""}controlled.`, "Elements should not switch from uncontrolled to controlled (or vice versa).", `Decide between using a controlled or uncontrolled ${n} element for the lifetime of the component.`, "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.", "More info: https://fb.me/react-controlled-components"].join(`
`));
    }, [r, n, e]);
    const {
      current: c
    } = V.useRef(t);
    V.useEffect(() => {
      !i && !Object.is(c, t) && console.error([`MUI: A component is changing the default ${r} state of an uncontrolled ${n} after being initialized. To suppress this warning opt to use a controlled ${n}.`].join(`
`));
    }, [JSON.stringify(t)]);
  }
  const u = V.useCallback((c) => {
    i || s(c);
  }, []);
  return [a, u];
}
function Mt(e) {
  const t = V.useRef(e);
  return gi(() => {
    t.current = e;
  }), V.useRef((...n) => (
    // @ts-expect-error hide `this`
    (0, t.current)(...n)
  )).current;
}
function Hn(...e) {
  return V.useMemo(() => e.every((t) => t == null) ? null : (t) => {
    e.forEach((n) => {
      _0(n, t);
    });
  }, e);
}
const RB = {};
function LNe(e, t) {
  const n = V.useRef(RB);
  return n.current === RB && (n.current = e(t)), n;
}
const BNe = [];
function jNe(e) {
  V.useEffect(e, BNe);
}
class zb {
  constructor() {
    this.currentId = null, this.clear = () => {
      this.currentId !== null && (clearTimeout(this.currentId), this.currentId = null);
    }, this.disposeEffect = () => this.clear;
  }
  static create() {
    return new zb();
  }
  /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */
  start(t, n) {
    this.clear(), this.currentId = setTimeout(() => {
      this.currentId = null, n();
    }, t);
  }
}
function Pp() {
  const e = LNe(zb.create).current;
  return jNe(e.disposeEffect), e;
}
let kE = !0, WP = !1;
const VNe = new zb(), zNe = {
  text: !0,
  search: !0,
  url: !0,
  tel: !0,
  email: !0,
  password: !0,
  number: !0,
  date: !0,
  month: !0,
  week: !0,
  time: !0,
  datetime: !0,
  "datetime-local": !0
};
function UNe(e) {
  const {
    type: t,
    tagName: n
  } = e;
  return !!(n === "INPUT" && zNe[t] && !e.readOnly || n === "TEXTAREA" && !e.readOnly || e.isContentEditable);
}
function WNe(e) {
  e.metaKey || e.altKey || e.ctrlKey || (kE = !0);
}
function UA() {
  kE = !1;
}
function HNe() {
  this.visibilityState === "hidden" && WP && (kE = !0);
}
function qNe(e) {
  e.addEventListener("keydown", WNe, !0), e.addEventListener("mousedown", UA, !0), e.addEventListener("pointerdown", UA, !0), e.addEventListener("touchstart", UA, !0), e.addEventListener("visibilitychange", HNe, !0);
}
function GNe(e) {
  const {
    target: t
  } = e;
  try {
    return t.matches(":focus-visible");
  } catch {
  }
  return kE || UNe(t);
}
function OE() {
  const e = V.useCallback((i) => {
    i != null && qNe(i.ownerDocument);
  }, []), t = V.useRef(!1);
  function n() {
    return t.current ? (WP = !0, VNe.start(100, () => {
      WP = !1;
    }), t.current = !1, !0) : !1;
  }
  function r(i) {
    return GNe(i) ? (t.current = !0, !0) : !1;
  }
  return {
    isFocusVisibleRef: t,
    onFocus: r,
    onBlur: n,
    ref: e
  };
}
function Zz(e) {
  const t = e.documentElement.clientWidth;
  return Math.abs(window.innerWidth - t);
}
let bh;
function eU() {
  if (bh)
    return bh;
  const e = document.createElement("div"), t = document.createElement("div");
  return t.style.width = "10px", t.style.height = "1px", e.appendChild(t), e.dir = "rtl", e.style.fontSize = "14px", e.style.width = "4px", e.style.height = "1px", e.style.position = "absolute", e.style.top = "-1000px", e.style.overflow = "scroll", document.body.appendChild(e), bh = "reverse", e.scrollLeft > 0 ? bh = "default" : (e.scrollLeft = 1, e.scrollLeft === 0 && (bh = "negative")), document.body.removeChild(e), bh;
}
function YNe(e, t) {
  const n = e.scrollLeft;
  if (t !== "rtl")
    return n;
  switch (eU()) {
    case "negative":
      return e.scrollWidth - e.clientWidth + n;
    case "reverse":
      return e.scrollWidth - e.clientWidth - n;
    default:
      return n;
  }
}
const HI = (e) => {
  const t = V.useRef({});
  return V.useEffect(() => {
    t.current = e;
  }), t.current;
}, KNe = {
  border: 0,
  clip: "rect(0 0 0 0)",
  height: "1px",
  margin: "-1px",
  overflow: "hidden",
  padding: 0,
  position: "absolute",
  whiteSpace: "nowrap",
  width: "1px"
};
function JNe(e) {
  const t = typeof e;
  switch (t) {
    case "number":
      return Number.isNaN(e) ? "NaN" : Number.isFinite(e) ? e !== Math.floor(e) ? "float" : "number" : "Infinity";
    case "object":
      return e === null ? "null" : e.constructor.name;
    default:
      return t;
  }
}
function XNe(e) {
  return typeof e == "number" && isFinite(e) && Math.floor(e) === e;
}
const QNe = Number.isInteger || XNe;
function tU(e, t, n, r) {
  const i = e[t];
  if (i == null || !QNe(i)) {
    const o = JNe(i);
    return new RangeError(`Invalid ${r} \`${t}\` of type \`${o}\` supplied to \`${n}\`, expected \`integer\`.`);
  }
  return null;
}
function nU(e, t, ...n) {
  return e[t] === void 0 ? null : tU(e, t, ...n);
}
function HP() {
  return null;
}
nU.isRequired = tU;
HP.isRequired = HP;
const Ub = process.env.NODE_ENV === "production" ? HP : nU;
function at(e, t, n = void 0) {
  const r = {};
  return Object.keys(e).forEach(
    // `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (i) => {
      r[i] = e[i].reduce((o, s) => {
        if (s) {
          const a = t(s);
          a !== "" && o.push(a), n && n[s] && o.push(n[s]);
        }
        return o;
      }, []).join(" ");
    }
  ), r;
}
function lu(e) {
  return typeof e == "string";
}
function Nh(e, t, n) {
  return e === void 0 || lu(e) ? t : N({}, t, {
    ownerState: N({}, t.ownerState, n)
  });
}
function a0(e, t = []) {
  if (e === void 0)
    return {};
  const n = {};
  return Object.keys(e).filter((r) => r.match(/^on[A-Z]/) && typeof e[r] == "function" && !t.includes(r)).forEach((r) => {
    n[r] = e[r];
  }), n;
}
function _B(e) {
  if (e === void 0)
    return {};
  const t = {};
  return Object.keys(e).filter((n) => !(n.match(/^on[A-Z]/) && typeof e[n] == "function")).forEach((n) => {
    t[n] = e[n];
  }), t;
}
function rU(e) {
  const {
    getSlotProps: t,
    additionalProps: n,
    externalSlotProps: r,
    externalForwardedProps: i,
    className: o
  } = e;
  if (!t) {
    const m = Be(n == null ? void 0 : n.className, o, i == null ? void 0 : i.className, r == null ? void 0 : r.className), v = N({}, n == null ? void 0 : n.style, i == null ? void 0 : i.style, r == null ? void 0 : r.style), x = N({}, n, i, r);
    return m.length > 0 && (x.className = m), Object.keys(v).length > 0 && (x.style = v), {
      props: x,
      internalRef: void 0
    };
  }
  const s = a0(N({}, i, r)), a = _B(r), u = _B(i), c = t(s), d = Be(c == null ? void 0 : c.className, n == null ? void 0 : n.className, o, i == null ? void 0 : i.className, r == null ? void 0 : r.className), f = N({}, c == null ? void 0 : c.style, n == null ? void 0 : n.style, i == null ? void 0 : i.style, r == null ? void 0 : r.style), h = N({}, c, n, u, a);
  return d.length > 0 && (h.className = d), Object.keys(f).length > 0 && (h.style = f), {
    props: h,
    internalRef: c.ref
  };
}
function iU(e, t, n) {
  return typeof e == "function" ? e(t, n) : e;
}
const ZNe = ["elementType", "externalSlotProps", "ownerState", "skipResolvingSlotProps"];
function Ai(e) {
  var t;
  const {
    elementType: n,
    externalSlotProps: r,
    ownerState: i,
    skipResolvingSlotProps: o = !1
  } = e, s = _e(e, ZNe), a = o ? {} : iU(r, i), {
    props: u,
    internalRef: c
  } = rU(N({}, s, {
    externalSlotProps: a
  })), d = Hn(c, a == null ? void 0 : a.ref, (t = e.additionalProps) == null ? void 0 : t.ref);
  return Nh(n, N({}, u, {
    ref: d
  }), i);
}
const eMe = /* @__PURE__ */ V.createContext();
process.env.NODE_ENV !== "production" && (l.node, l.bool);
const Wb = () => {
  const e = V.useContext(eMe);
  return e ?? !1;
}, tMe = /* @__PURE__ */ V.createContext(void 0);
process.env.NODE_ENV !== "production" && (l.node, l.object);
function nMe(e) {
  const {
    theme: t,
    name: n,
    props: r
  } = e;
  if (!t || !t.components || !t.components[n])
    return r;
  const i = t.components[n];
  return i.defaultProps ? R0(i.defaultProps, r) : !i.styleOverrides && !i.variants ? R0(i, r) : r;
}
function rMe({
  props: e,
  name: t
}) {
  const n = V.useContext(tMe);
  return nMe({
    props: e,
    name: t,
    theme: {
      components: n
    }
  });
}
const iMe = ["className", "component", "disableGutters", "fixed", "maxWidth", "classes"], oMe = ng(), sMe = qz("div", {
  name: "MuiContainer",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[`maxWidth${Ue(String(n.maxWidth))}`], n.fixed && t.fixed, n.disableGutters && t.disableGutters];
  }
}), aMe = (e) => UI({
  props: e,
  name: "MuiContainer",
  defaultTheme: oMe
}), lMe = (e, t) => {
  const n = (u) => ot(t, u), {
    classes: r,
    fixed: i,
    disableGutters: o,
    maxWidth: s
  } = e, a = {
    root: ["root", s && `maxWidth${Ue(String(s))}`, i && "fixed", o && "disableGutters"]
  };
  return at(a, n, r);
};
function uMe(e = {}) {
  const {
    // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent: t = sMe,
    useThemeProps: n = aMe,
    componentName: r = "MuiContainer"
  } = e, i = t(({
    theme: s,
    ownerState: a
  }) => N({
    width: "100%",
    marginLeft: "auto",
    boxSizing: "border-box",
    marginRight: "auto",
    display: "block"
  }, !a.disableGutters && {
    paddingLeft: s.spacing(2),
    paddingRight: s.spacing(2),
    // @ts-ignore module augmentation fails if custom breakpoints are used
    [s.breakpoints.up("sm")]: {
      paddingLeft: s.spacing(3),
      paddingRight: s.spacing(3)
    }
  }), ({
    theme: s,
    ownerState: a
  }) => a.fixed && Object.keys(s.breakpoints.values).reduce((u, c) => {
    const d = c, f = s.breakpoints.values[d];
    return f !== 0 && (u[s.breakpoints.up(d)] = {
      maxWidth: `${f}${s.breakpoints.unit}`
    }), u;
  }, {}), ({
    theme: s,
    ownerState: a
  }) => N({}, a.maxWidth === "xs" && {
    // @ts-ignore module augmentation fails if custom breakpoints are used
    [s.breakpoints.up("xs")]: {
      // @ts-ignore module augmentation fails if custom breakpoints are used
      maxWidth: Math.max(s.breakpoints.values.xs, 444)
    }
  }, a.maxWidth && // @ts-ignore module augmentation fails if custom breakpoints are used
  a.maxWidth !== "xs" && {
    // @ts-ignore module augmentation fails if custom breakpoints are used
    [s.breakpoints.up(a.maxWidth)]: {
      // @ts-ignore module augmentation fails if custom breakpoints are used
      maxWidth: `${s.breakpoints.values[a.maxWidth]}${s.breakpoints.unit}`
    }
  })), o = /* @__PURE__ */ V.forwardRef(function(a, u) {
    const c = n(a), {
      className: d,
      component: f = "div",
      disableGutters: h = !1,
      fixed: m = !1,
      maxWidth: v = "lg"
    } = c, x = _e(c, iMe), C = N({}, c, {
      component: f,
      disableGutters: h,
      fixed: m,
      maxWidth: v
    }), E = lMe(C, r);
    return (
      // @ts-ignore theme is injected by the styled util
      /* @__PURE__ */ P.jsx(i, N({
        as: f,
        ownerState: C,
        className: Be(E.root, d),
        ref: u
      }, x))
    );
  });
  return process.env.NODE_ENV !== "production" && (o.propTypes = {
    children: l.node,
    classes: l.object,
    className: l.string,
    component: l.elementType,
    disableGutters: l.bool,
    fixed: l.bool,
    maxWidth: l.oneOfType([l.oneOf(["xs", "sm", "md", "lg", "xl", !1]), l.string]),
    sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
  }), o;
}
const cMe = ["component", "direction", "spacing", "divider", "children", "className", "useFlexGap"], dMe = ng(), pMe = qz("div", {
  name: "MuiStack",
  slot: "Root",
  overridesResolver: (e, t) => t.root
});
function fMe(e) {
  return UI({
    props: e,
    name: "MuiStack",
    defaultTheme: dMe
  });
}
function hMe(e, t) {
  const n = V.Children.toArray(e).filter(Boolean);
  return n.reduce((r, i, o) => (r.push(i), o < n.length - 1 && r.push(/* @__PURE__ */ V.cloneElement(t, {
    key: `separator-${o}`
  })), r), []);
}
const mMe = (e) => ({
  row: "Left",
  "row-reverse": "Right",
  column: "Top",
  "column-reverse": "Bottom"
})[e], gMe = ({
  ownerState: e,
  theme: t
}) => {
  let n = N({
    display: "flex",
    flexDirection: "column"
  }, Fs({
    theme: t
  }, Rp({
    values: e.direction,
    breakpoints: t.breakpoints.values
  }), (r) => ({
    flexDirection: r
  })));
  if (e.spacing) {
    const r = jI(t), i = Object.keys(t.breakpoints.values).reduce((u, c) => ((typeof e.spacing == "object" && e.spacing[c] != null || typeof e.direction == "object" && e.direction[c] != null) && (u[c] = !0), u), {}), o = Rp({
      values: e.direction,
      base: i
    }), s = Rp({
      values: e.spacing,
      base: i
    });
    typeof o == "object" && Object.keys(o).forEach((u, c, d) => {
      if (!o[u]) {
        const h = c > 0 ? o[d[c - 1]] : "column";
        o[u] = h;
      }
    }), n = is(n, Fs({
      theme: t
    }, s, (u, c) => e.useFlexGap ? {
      gap: qp(r, u)
    } : {
      // The useFlexGap={false} implement relies on each child to give up control of the margin.
      // We need to reset the margin to avoid double spacing.
      "& > :not(style):not(style)": {
        margin: 0
      },
      "& > :not(style) ~ :not(style)": {
        [`margin${mMe(c ? o[c] : e.direction)}`]: qp(r, u)
      }
    }));
  }
  return n = h$e(t.breakpoints, n), n;
};
function yMe(e = {}) {
  const {
    // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent: t = pMe,
    useThemeProps: n = fMe,
    componentName: r = "MuiStack"
  } = e, i = () => at({
    root: ["root"]
  }, (u) => ot(r, u), {}), o = t(gMe), s = /* @__PURE__ */ V.forwardRef(function(u, c) {
    const d = n(u), f = Bb(d), {
      component: h = "div",
      direction: m = "column",
      spacing: v = 0,
      divider: x,
      children: C,
      className: E,
      useFlexGap: S = !1
    } = f, w = _e(f, cMe), O = {
      direction: m,
      spacing: v,
      useFlexGap: S
    }, A = i();
    return /* @__PURE__ */ P.jsx(o, N({
      as: h,
      ownerState: O,
      ref: c,
      className: Be(A.root, E)
    }, w, {
      children: x ? hMe(C, x) : C
    }));
  });
  return process.env.NODE_ENV !== "production" && (s.propTypes = {
    children: l.node,
    direction: l.oneOfType([l.oneOf(["column-reverse", "column", "row-reverse", "row"]), l.arrayOf(l.oneOf(["column-reverse", "column", "row-reverse", "row"])), l.object]),
    divider: l.node,
    spacing: l.oneOfType([l.arrayOf(l.oneOfType([l.number, l.string])), l.number, l.object, l.string]),
    sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
  }), s;
}
function bMe(e, t) {
  return N({
    toolbar: {
      minHeight: 56,
      [e.up("xs")]: {
        "@media (orientation: landscape)": {
          minHeight: 48
        }
      },
      [e.up("sm")]: {
        minHeight: 64
      }
    }
  }, t);
}
var Oi = {}, oU = { exports: {} };
(function(e) {
  function t(n) {
    return n && n.__esModule ? n : {
      default: n
    };
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(oU);
var Eu = oU.exports;
const vMe = /* @__PURE__ */ Tl(WFe), xMe = /* @__PURE__ */ Tl(PNe);
var sU = Eu;
Object.defineProperty(Oi, "__esModule", {
  value: !0
});
var Yt = Oi.alpha = cU;
Oi.blend = OMe;
Oi.colorChannel = void 0;
var Yp = Oi.darken = GI;
Oi.decomposeColor = ja;
Oi.emphasize = dU;
var LB = Oi.getContrastRatio = SMe;
Oi.getLuminance = UD;
Oi.hexToRgb = aU;
Oi.hslToRgb = uU;
var Kp = Oi.lighten = YI;
Oi.private_safeAlpha = AMe;
Oi.private_safeColorChannel = void 0;
Oi.private_safeDarken = wMe;
Oi.private_safeEmphasize = kMe;
Oi.private_safeLighten = PMe;
Oi.recomposeColor = og;
Oi.rgbToHex = TMe;
var BB = sU(vMe), DMe = sU(xMe);
function qI(e, t = 0, n = 1) {
  return process.env.NODE_ENV !== "production" && (e < t || e > n) && console.error(`MUI: The value provided ${e} is out of range [${t}, ${n}].`), (0, DMe.default)(e, t, n);
}
function aU(e) {
  e = e.slice(1);
  const t = new RegExp(`.{1,${e.length >= 6 ? 2 : 1}}`, "g");
  let n = e.match(t);
  return n && n[0].length === 1 && (n = n.map((r) => r + r)), n ? `rgb${n.length === 4 ? "a" : ""}(${n.map((r, i) => i < 3 ? parseInt(r, 16) : Math.round(parseInt(r, 16) / 255 * 1e3) / 1e3).join(", ")})` : "";
}
function CMe(e) {
  const t = e.toString(16);
  return t.length === 1 ? `0${t}` : t;
}
function ja(e) {
  if (e.type)
    return e;
  if (e.charAt(0) === "#")
    return ja(aU(e));
  const t = e.indexOf("("), n = e.substring(0, t);
  if (["rgb", "rgba", "hsl", "hsla", "color"].indexOf(n) === -1)
    throw new Error(process.env.NODE_ENV !== "production" ? `MUI: Unsupported \`${e}\` color.
The following formats are supported: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` : (0, BB.default)(9, e));
  let r = e.substring(t + 1, e.length - 1), i;
  if (n === "color") {
    if (r = r.split(" "), i = r.shift(), r.length === 4 && r[3].charAt(0) === "/" && (r[3] = r[3].slice(1)), ["srgb", "display-p3", "a98-rgb", "prophoto-rgb", "rec-2020"].indexOf(i) === -1)
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: unsupported \`${i}\` color space.
The following color spaces are supported: srgb, display-p3, a98-rgb, prophoto-rgb, rec-2020.` : (0, BB.default)(10, i));
  } else
    r = r.split(",");
  return r = r.map((o) => parseFloat(o)), {
    type: n,
    values: r,
    colorSpace: i
  };
}
const lU = (e) => {
  const t = ja(e);
  return t.values.slice(0, 3).map((n, r) => t.type.indexOf("hsl") !== -1 && r !== 0 ? `${n}%` : n).join(" ");
};
Oi.colorChannel = lU;
const EMe = (e, t) => {
  try {
    return lU(e);
  } catch {
    return t && process.env.NODE_ENV !== "production" && console.warn(t), e;
  }
};
Oi.private_safeColorChannel = EMe;
function og(e) {
  const {
    type: t,
    colorSpace: n
  } = e;
  let {
    values: r
  } = e;
  return t.indexOf("rgb") !== -1 ? r = r.map((i, o) => o < 3 ? parseInt(i, 10) : i) : t.indexOf("hsl") !== -1 && (r[1] = `${r[1]}%`, r[2] = `${r[2]}%`), t.indexOf("color") !== -1 ? r = `${n} ${r.join(" ")}` : r = `${r.join(", ")}`, `${t}(${r})`;
}
function TMe(e) {
  if (e.indexOf("#") === 0)
    return e;
  const {
    values: t
  } = ja(e);
  return `#${t.map((n, r) => CMe(r === 3 ? Math.round(255 * n) : n)).join("")}`;
}
function uU(e) {
  e = ja(e);
  const {
    values: t
  } = e, n = t[0], r = t[1] / 100, i = t[2] / 100, o = r * Math.min(i, 1 - i), s = (c, d = (c + n / 30) % 12) => i - o * Math.max(Math.min(d - 3, 9 - d, 1), -1);
  let a = "rgb";
  const u = [Math.round(s(0) * 255), Math.round(s(8) * 255), Math.round(s(4) * 255)];
  return e.type === "hsla" && (a += "a", u.push(t[3])), og({
    type: a,
    values: u
  });
}
function UD(e) {
  e = ja(e);
  let t = e.type === "hsl" || e.type === "hsla" ? ja(uU(e)).values : e.values;
  return t = t.map((n) => (e.type !== "color" && (n /= 255), n <= 0.03928 ? n / 12.92 : ((n + 0.055) / 1.055) ** 2.4)), Number((0.2126 * t[0] + 0.7152 * t[1] + 0.0722 * t[2]).toFixed(3));
}
function SMe(e, t) {
  const n = UD(e), r = UD(t);
  return (Math.max(n, r) + 0.05) / (Math.min(n, r) + 0.05);
}
function cU(e, t) {
  return e = ja(e), t = qI(t), (e.type === "rgb" || e.type === "hsl") && (e.type += "a"), e.type === "color" ? e.values[3] = `/${t}` : e.values[3] = t, og(e);
}
function AMe(e, t, n) {
  try {
    return cU(e, t);
  } catch {
    return n && process.env.NODE_ENV !== "production" && console.warn(n), e;
  }
}
function GI(e, t) {
  if (e = ja(e), t = qI(t), e.type.indexOf("hsl") !== -1)
    e.values[2] *= 1 - t;
  else if (e.type.indexOf("rgb") !== -1 || e.type.indexOf("color") !== -1)
    for (let n = 0; n < 3; n += 1)
      e.values[n] *= 1 - t;
  return og(e);
}
function wMe(e, t, n) {
  try {
    return GI(e, t);
  } catch {
    return n && process.env.NODE_ENV !== "production" && console.warn(n), e;
  }
}
function YI(e, t) {
  if (e = ja(e), t = qI(t), e.type.indexOf("hsl") !== -1)
    e.values[2] += (100 - e.values[2]) * t;
  else if (e.type.indexOf("rgb") !== -1)
    for (let n = 0; n < 3; n += 1)
      e.values[n] += (255 - e.values[n]) * t;
  else if (e.type.indexOf("color") !== -1)
    for (let n = 0; n < 3; n += 1)
      e.values[n] += (1 - e.values[n]) * t;
  return og(e);
}
function PMe(e, t, n) {
  try {
    return YI(e, t);
  } catch {
    return n && process.env.NODE_ENV !== "production" && console.warn(n), e;
  }
}
function dU(e, t = 0.15) {
  return UD(e) > 0.5 ? GI(e, t) : YI(e, t);
}
function kMe(e, t, n) {
  try {
    return dU(e, t);
  } catch {
    return n && process.env.NODE_ENV !== "production" && console.warn(n), e;
  }
}
function OMe(e, t, n, r = 1) {
  const i = (u, c) => Math.round((u ** (1 / r) * (1 - n) + c ** (1 / r) * n) ** r), o = ja(e), s = ja(t), a = [i(o.values[0], s.values[0]), i(o.values[1], s.values[1]), i(o.values[2], s.values[2])];
  return og({
    type: "rgb",
    values: a
  });
}
const IMe = ["mode", "contrastThreshold", "tonalOffset"], jB = {
  // The colors used to style the text.
  text: {
    // The most important text.
    primary: "rgba(0, 0, 0, 0.87)",
    // Secondary text.
    secondary: "rgba(0, 0, 0, 0.6)",
    // Disabled text have even lower visual prominence.
    disabled: "rgba(0, 0, 0, 0.38)"
  },
  // The color used to divide different elements.
  divider: "rgba(0, 0, 0, 0.12)",
  // The background colors used to style the surfaces.
  // Consistency between these values is important.
  background: {
    paper: mu.white,
    default: mu.white
  },
  // The colors used to style the action elements.
  action: {
    // The color of an active action like an icon button.
    active: "rgba(0, 0, 0, 0.54)",
    // The color of an hovered action.
    hover: "rgba(0, 0, 0, 0.04)",
    hoverOpacity: 0.04,
    // The color of a selected action.
    selected: "rgba(0, 0, 0, 0.08)",
    selectedOpacity: 0.08,
    // The color of a disabled action.
    disabled: "rgba(0, 0, 0, 0.26)",
    // The background color of a disabled action.
    disabledBackground: "rgba(0, 0, 0, 0.12)",
    disabledOpacity: 0.38,
    focus: "rgba(0, 0, 0, 0.12)",
    focusOpacity: 0.12,
    activatedOpacity: 0.12
  }
}, WA = {
  text: {
    primary: mu.white,
    secondary: "rgba(255, 255, 255, 0.7)",
    disabled: "rgba(255, 255, 255, 0.5)",
    icon: "rgba(255, 255, 255, 0.5)"
  },
  divider: "rgba(255, 255, 255, 0.12)",
  background: {
    paper: "#121212",
    default: "#121212"
  },
  action: {
    active: mu.white,
    hover: "rgba(255, 255, 255, 0.08)",
    hoverOpacity: 0.08,
    selected: "rgba(255, 255, 255, 0.16)",
    selectedOpacity: 0.16,
    disabled: "rgba(255, 255, 255, 0.3)",
    disabledBackground: "rgba(255, 255, 255, 0.12)",
    disabledOpacity: 0.38,
    focus: "rgba(255, 255, 255, 0.12)",
    focusOpacity: 0.12,
    activatedOpacity: 0.24
  }
};
function VB(e, t, n, r) {
  const i = r.light || r, o = r.dark || r * 1.5;
  e[t] || (e.hasOwnProperty(n) ? e[t] = e[n] : t === "light" ? e.light = Kp(e.main, i) : t === "dark" && (e.dark = Yp(e.main, o)));
}
function FMe(e = "light") {
  return e === "dark" ? {
    main: mh[200],
    light: mh[50],
    dark: mh[400]
  } : {
    main: mh[700],
    light: mh[400],
    dark: mh[800]
  };
}
function $Me(e = "light") {
  return e === "dark" ? {
    main: hh[200],
    light: hh[50],
    dark: hh[400]
  } : {
    main: hh[500],
    light: hh[300],
    dark: hh[700]
  };
}
function NMe(e = "light") {
  return e === "dark" ? {
    main: fh[500],
    light: fh[300],
    dark: fh[700]
  } : {
    main: fh[700],
    light: fh[400],
    dark: fh[800]
  };
}
function MMe(e = "light") {
  return e === "dark" ? {
    main: gh[400],
    light: gh[300],
    dark: gh[700]
  } : {
    main: gh[700],
    light: gh[500],
    dark: gh[900]
  };
}
function RMe(e = "light") {
  return e === "dark" ? {
    main: yh[400],
    light: yh[300],
    dark: yh[700]
  } : {
    main: yh[800],
    light: yh[500],
    dark: yh[900]
  };
}
function _Me(e = "light") {
  return e === "dark" ? {
    main: Ey[400],
    light: Ey[300],
    dark: Ey[700]
  } : {
    main: "#ed6c02",
    // closest to orange[800] that pass 3:1.
    light: Ey[500],
    dark: Ey[900]
  };
}
function LMe(e) {
  const {
    mode: t = "light",
    contrastThreshold: n = 3,
    tonalOffset: r = 0.2
  } = e, i = _e(e, IMe), o = e.primary || FMe(t), s = e.secondary || $Me(t), a = e.error || NMe(t), u = e.info || MMe(t), c = e.success || RMe(t), d = e.warning || _Me(t);
  function f(x) {
    const C = LB(x, WA.text.primary) >= n ? WA.text.primary : jB.text.primary;
    if (process.env.NODE_ENV !== "production") {
      const E = LB(x, C);
      E < 3 && console.error([`MUI: The contrast ratio of ${E}:1 for ${C} on ${x}`, "falls below the WCAG recommended absolute minimum contrast ratio of 3:1.", "https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast"].join(`
`));
    }
    return C;
  }
  const h = ({
    color: x,
    name: C,
    mainShade: E = 500,
    lightShade: S = 300,
    darkShade: w = 700
  }) => {
    if (x = N({}, x), !x.main && x[E] && (x.main = x[E]), !x.hasOwnProperty("main"))
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${C ? ` (${C})` : ""} provided to augmentColor(color) is invalid.
The color object needs to have a \`main\` property or a \`${E}\` property.` : gu(11, C ? ` (${C})` : "", E));
    if (typeof x.main != "string")
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: The color${C ? ` (${C})` : ""} provided to augmentColor(color) is invalid.
\`color.main\` should be a string, but \`${JSON.stringify(x.main)}\` was provided instead.

Did you intend to use one of the following approaches?

import { green } from "@mui/material/colors";

const theme1 = createTheme({ palette: {
  primary: green,
} });

const theme2 = createTheme({ palette: {
  primary: { main: green[500] },
} });` : gu(12, C ? ` (${C})` : "", JSON.stringify(x.main)));
    return VB(x, "light", S, r), VB(x, "dark", w, r), x.contrastText || (x.contrastText = f(x.main)), x;
  }, m = {
    dark: WA,
    light: jB
  };
  return process.env.NODE_ENV !== "production" && (m[t] || console.error(`MUI: The palette mode \`${t}\` is not supported.`)), is(N({
    // A collection of common colors.
    common: N({}, mu),
    // prevent mutable object.
    // The palette mode, can be light or dark.
    mode: t,
    // The colors used to represent primary interface elements for a user.
    primary: h({
      color: o,
      name: "primary"
    }),
    // The colors used to represent secondary interface elements for a user.
    secondary: h({
      color: s,
      name: "secondary",
      mainShade: "A400",
      lightShade: "A200",
      darkShade: "A700"
    }),
    // The colors used to represent interface elements that the user should be made aware of.
    error: h({
      color: a,
      name: "error"
    }),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: h({
      color: d,
      name: "warning"
    }),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: h({
      color: u,
      name: "info"
    }),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: h({
      color: c,
      name: "success"
    }),
    // The grey colors.
    grey: UFe,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: n,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText: f,
    // Generate a rich color object.
    augmentColor: h,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: r
  }, m[t]), i);
}
const BMe = ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"];
function jMe(e) {
  return Math.round(e * 1e5) / 1e5;
}
const zB = {
  textTransform: "uppercase"
}, UB = '"Roboto", "Helvetica", "Arial", sans-serif';
function VMe(e, t) {
  const n = typeof t == "function" ? t(e) : t, {
    fontFamily: r = UB,
    // The default font size of the Material Specification.
    fontSize: i = 14,
    // px
    fontWeightLight: o = 300,
    fontWeightRegular: s = 400,
    fontWeightMedium: a = 500,
    fontWeightBold: u = 700,
    // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize: c = 16,
    // Apply the CSS properties to all the variants.
    allVariants: d,
    pxToRem: f
  } = n, h = _e(n, BMe);
  process.env.NODE_ENV !== "production" && (typeof i != "number" && console.error("MUI: `fontSize` is required to be a number."), typeof c != "number" && console.error("MUI: `htmlFontSize` is required to be a number."));
  const m = i / 14, v = f || ((E) => `${E / c * m}rem`), x = (E, S, w, O, A) => N({
    fontFamily: r,
    fontWeight: E,
    fontSize: v(S),
    // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
    lineHeight: w
  }, r === UB ? {
    letterSpacing: `${jMe(O / S)}em`
  } : {}, A, d), C = {
    h1: x(o, 96, 1.167, -1.5),
    h2: x(o, 60, 1.2, -0.5),
    h3: x(s, 48, 1.167, 0),
    h4: x(s, 34, 1.235, 0.25),
    h5: x(s, 24, 1.334, 0),
    h6: x(a, 20, 1.6, 0.15),
    subtitle1: x(s, 16, 1.75, 0.15),
    subtitle2: x(a, 14, 1.57, 0.1),
    body1: x(s, 16, 1.5, 0.15),
    body2: x(s, 14, 1.43, 0.15),
    button: x(a, 14, 1.75, 0.4, zB),
    caption: x(s, 12, 1.66, 0.4),
    overline: x(s, 12, 2.66, 1, zB),
    // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
    inherit: {
      fontFamily: "inherit",
      fontWeight: "inherit",
      fontSize: "inherit",
      lineHeight: "inherit",
      letterSpacing: "inherit"
    }
  };
  return is(N({
    htmlFontSize: c,
    pxToRem: v,
    fontFamily: r,
    fontSize: i,
    fontWeightLight: o,
    fontWeightRegular: s,
    fontWeightMedium: a,
    fontWeightBold: u
  }, C), h, {
    clone: !1
    // No need to clone deep
  });
}
const zMe = 0.2, UMe = 0.14, WMe = 0.12;
function Xr(...e) {
  return [`${e[0]}px ${e[1]}px ${e[2]}px ${e[3]}px rgba(0,0,0,${zMe})`, `${e[4]}px ${e[5]}px ${e[6]}px ${e[7]}px rgba(0,0,0,${UMe})`, `${e[8]}px ${e[9]}px ${e[10]}px ${e[11]}px rgba(0,0,0,${WMe})`].join(",");
}
const HMe = ["none", Xr(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), Xr(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), Xr(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), Xr(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), Xr(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), Xr(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), Xr(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), Xr(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), Xr(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), Xr(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), Xr(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), Xr(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), Xr(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), Xr(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), Xr(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), Xr(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), Xr(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), Xr(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), Xr(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), Xr(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), Xr(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), Xr(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), Xr(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), Xr(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)], qMe = ["duration", "easing", "delay"], GMe = {
  // This is the most common easing curve.
  easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: "cubic-bezier(0.4, 0, 1, 1)",
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
}, pU = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};
function WB(e) {
  return `${Math.round(e)}ms`;
}
function YMe(e) {
  if (!e)
    return 0;
  const t = e / 36;
  return Math.round((4 + 15 * t ** 0.25 + t / 5) * 10);
}
function KMe(e) {
  const t = N({}, GMe, e.easing), n = N({}, pU, e.duration);
  return N({
    getAutoHeightDuration: YMe,
    create: (i = ["all"], o = {}) => {
      const {
        duration: s = n.standard,
        easing: a = t.easeInOut,
        delay: u = 0
      } = o, c = _e(o, qMe);
      if (process.env.NODE_ENV !== "production") {
        const d = (h) => typeof h == "string", f = (h) => !isNaN(parseFloat(h));
        !d(i) && !Array.isArray(i) && console.error('MUI: Argument "props" must be a string or Array.'), !f(s) && !d(s) && console.error(`MUI: Argument "duration" must be a number or a string but found ${s}.`), d(a) || console.error('MUI: Argument "easing" must be a string.'), !f(u) && !d(u) && console.error('MUI: Argument "delay" must be a number or a string.'), typeof o != "object" && console.error(["MUI: Secong argument of transition.create must be an object.", "Arguments should be either `create('prop1', options)` or `create(['prop1', 'prop2'], options)`"].join(`
`)), Object.keys(c).length !== 0 && console.error(`MUI: Unrecognized argument(s) [${Object.keys(c).join(",")}].`);
      }
      return (Array.isArray(i) ? i : [i]).map((d) => `${d} ${typeof s == "string" ? s : WB(s)} ${a} ${typeof u == "string" ? u : WB(u)}`).join(",");
    }
  }, e, {
    easing: t,
    duration: n
  });
}
const JMe = {
  mobileStepper: 1e3,
  fab: 1050,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
}, XMe = ["breakpoints", "mixins", "spacing", "palette", "transitions", "typography", "shape"];
function Hb(e = {}, ...t) {
  const {
    mixins: n = {},
    palette: r = {},
    transitions: i = {},
    typography: o = {}
  } = e, s = _e(e, XMe);
  if (e.vars)
    throw new Error(process.env.NODE_ENV !== "production" ? "MUI: `vars` is a private field used for CSS variables support.\nPlease use another name." : gu(18));
  const a = LMe(r), u = ng(e);
  let c = is(u, {
    mixins: bMe(u.breakpoints, n),
    palette: a,
    // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
    shadows: HMe.slice(),
    typography: VMe(a, o),
    transitions: KMe(i),
    zIndex: N({}, JMe)
  });
  if (c = is(c, s), c = t.reduce((d, f) => is(d, f), c), process.env.NODE_ENV !== "production") {
    const d = ["active", "checked", "completed", "disabled", "error", "expanded", "focused", "focusVisible", "required", "selected"], f = (h, m) => {
      let v;
      for (v in h) {
        const x = h[v];
        if (d.indexOf(v) !== -1 && Object.keys(x).length > 0) {
          if (process.env.NODE_ENV !== "production") {
            const C = ot("", v);
            console.error([`MUI: The \`${m}\` component increases the CSS specificity of the \`${v}\` internal state.`, "You can not override it like this: ", JSON.stringify(h, null, 2), "", `Instead, you need to use the '&.${C}' syntax:`, JSON.stringify({
              root: {
                [`&.${C}`]: x
              }
            }, null, 2), "", "https://mui.com/r/state-classes-guide"].join(`
`));
          }
          h[v] = {};
        }
      }
    };
    Object.keys(c.components).forEach((h) => {
      const m = c.components[h].styleOverrides;
      m && h.indexOf("Mui") === 0 && f(m, h);
    });
  }
  return c.unstable_sxConfig = N({}, Lb, s == null ? void 0 : s.unstable_sxConfig), c.unstable_sx = function(f) {
    return tg({
      sx: f,
      theme: this
    });
  }, c;
}
function HB(e) {
  return String(parseFloat(e)).length === String(e).length;
}
function QMe(e) {
  return String(e).match(/[\d.\-+]*\s*(.*)/)[1] || "";
}
function up(e) {
  return parseFloat(e);
}
function ZMe(e) {
  return (t, n) => {
    const r = QMe(t);
    if (r === n)
      return t;
    let i = up(t);
    r !== "px" && (r === "em" || r === "rem") && (i = up(t) * up(e));
    let o = i;
    if (n !== "px")
      if (n === "em")
        o = i / up(e);
      else if (n === "rem")
        o = i / up(e);
      else
        return t;
    return parseFloat(o.toFixed(5)) + n;
  };
}
function eRe({
  size: e,
  grid: t
}) {
  const n = e - e % t, r = n + t;
  return e - n < r - e ? n : r;
}
function tRe({
  lineHeight: e,
  pixels: t,
  htmlFontSize: n
}) {
  return t / (e * n);
}
function nRe({
  cssProperty: e,
  min: t,
  max: n,
  unit: r = "rem",
  breakpoints: i = [600, 900, 1200],
  transform: o = null
}) {
  const s = {
    [e]: `${t}${r}`
  }, a = (n - t) / i[i.length - 1];
  return i.forEach((u) => {
    let c = t + a * u;
    o !== null && (c = o(c)), s[`@media (min-width:${u}px)`] = {
      [e]: `${Math.round(c * 1e4) / 1e4}${r}`
    };
  }), s;
}
function rRe(e, t = {}) {
  const {
    breakpoints: n = ["sm", "md", "lg"],
    disableAlign: r = !1,
    factor: i = 2,
    variants: o = ["h1", "h2", "h3", "h4", "h5", "h6", "subtitle1", "subtitle2", "body1", "body2", "caption", "button", "overline"]
  } = t, s = N({}, e);
  s.typography = N({}, s.typography);
  const a = s.typography, u = ZMe(a.htmlFontSize), c = n.map((d) => s.breakpoints.values[d]);
  return o.forEach((d) => {
    const f = a[d];
    if (!f)
      return;
    const h = parseFloat(u(f.fontSize, "rem"));
    if (h <= 1)
      return;
    const m = h, v = 1 + (m - 1) / i;
    let {
      lineHeight: x
    } = f;
    if (!HB(x) && !r)
      throw new Error(process.env.NODE_ENV !== "production" ? `MUI: Unsupported non-unitless line height with grid alignment.
Use unitless line heights instead.` : gu(6));
    HB(x) || (x = parseFloat(u(x, "rem")) / parseFloat(h));
    let C = null;
    r || (C = (E) => eRe({
      size: E,
      grid: tRe({
        pixels: 4,
        lineHeight: x,
        htmlFontSize: a.htmlFontSize
      })
    })), a[d] = N({}, f, nRe({
      cssProperty: "fontSize",
      min: v,
      max: m,
      unit: "rem",
      breakpoints: c,
      transform: C
    }));
  }), s;
}
const IE = Hb();
function Gi() {
  const e = rg(IE);
  return process.env.NODE_ENV !== "production" && V.useDebugValue(e), e[Rb] || e;
}
function Vn({
  props: e,
  name: t
}) {
  return UI({
    props: e,
    name: t,
    defaultTheme: IE,
    themeId: Rb
  });
}
var qb = {};
const iRe = /* @__PURE__ */ Tl(Loe);
var HA = { exports: {} }, qB;
function fU() {
  return qB || (qB = 1, function(e) {
    function t(n, r) {
      if (n == null) return {};
      var i = {};
      for (var o in n) if ({}.hasOwnProperty.call(n, o)) {
        if (r.indexOf(o) !== -1) continue;
        i[o] = n[o];
      }
      return i;
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(HA)), HA.exports;
}
const hU = /* @__PURE__ */ Tl(u$e), oRe = /* @__PURE__ */ Tl(c$e), sRe = /* @__PURE__ */ Tl(g$e), aRe = /* @__PURE__ */ Tl(yNe), lRe = /* @__PURE__ */ Tl(iNe), uRe = /* @__PURE__ */ Tl(uNe);
var sg = Eu;
Object.defineProperty(qb, "__esModule", {
  value: !0
});
var cRe = qb.default = TRe;
qb.shouldForwardProp = Jx;
qb.systemDefaultTheme = void 0;
var Sa = sg(iRe), qP = sg(fU()), GB = vRe(hU), dRe = oRe, pRe = sg(sRe), fRe = sg(aRe), hRe = sg(lRe), mRe = sg(uRe);
const gRe = ["ownerState"], yRe = ["variants"], bRe = ["name", "slot", "skipVariantsResolver", "skipSx", "overridesResolver"];
function mU(e) {
  if (typeof WeakMap != "function") return null;
  var t = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap();
  return (mU = function(r) {
    return r ? n : t;
  })(e);
}
function vRe(e, t) {
  if (e && e.__esModule) return e;
  if (e === null || typeof e != "object" && typeof e != "function") return { default: e };
  var n = mU(t);
  if (n && n.has(e)) return n.get(e);
  var r = { __proto__: null }, i = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var o in e) if (o !== "default" && Object.prototype.hasOwnProperty.call(e, o)) {
    var s = i ? Object.getOwnPropertyDescriptor(e, o) : null;
    s && (s.get || s.set) ? Object.defineProperty(r, o, s) : r[o] = e[o];
  }
  return r.default = e, n && n.set(e, r), r;
}
function xRe(e) {
  return Object.keys(e).length === 0;
}
function DRe(e) {
  return typeof e == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  e.charCodeAt(0) > 96;
}
function Jx(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
const CRe = qb.systemDefaultTheme = (0, hRe.default)(), YB = (e) => e && e.charAt(0).toLowerCase() + e.slice(1);
function _1({
  defaultTheme: e,
  theme: t,
  themeId: n
}) {
  return xRe(t) ? e : t[n] || t;
}
function ERe(e) {
  return e ? (t, n) => n[e] : null;
}
function Xx(e, t) {
  let {
    ownerState: n
  } = t, r = (0, qP.default)(t, gRe);
  const i = typeof e == "function" ? e((0, Sa.default)({
    ownerState: n
  }, r)) : e;
  if (Array.isArray(i))
    return i.flatMap((o) => Xx(o, (0, Sa.default)({
      ownerState: n
    }, r)));
  if (i && typeof i == "object" && Array.isArray(i.variants)) {
    const {
      variants: o = []
    } = i;
    let a = (0, qP.default)(i, yRe);
    return o.forEach((u) => {
      let c = !0;
      typeof u.props == "function" ? c = u.props((0, Sa.default)({
        ownerState: n
      }, r, n)) : Object.keys(u.props).forEach((d) => {
        (n == null ? void 0 : n[d]) !== u.props[d] && r[d] !== u.props[d] && (c = !1);
      }), c && (Array.isArray(a) || (a = [a]), a.push(typeof u.style == "function" ? u.style((0, Sa.default)({
        ownerState: n
      }, r, n)) : u.style));
    }), a;
  }
  return i;
}
function TRe(e = {}) {
  const {
    themeId: t,
    defaultTheme: n = CRe,
    rootShouldForwardProp: r = Jx,
    slotShouldForwardProp: i = Jx
  } = e, o = (s) => (0, mRe.default)((0, Sa.default)({}, s, {
    theme: _1((0, Sa.default)({}, s, {
      defaultTheme: n,
      themeId: t
    }))
  }));
  return o.__mui_systemSx = !0, (s, a = {}) => {
    (0, GB.internal_processStyles)(s, (A) => A.filter((I) => !(I != null && I.__mui_systemSx)));
    const {
      name: u,
      slot: c,
      skipVariantsResolver: d,
      skipSx: f,
      // TODO v6: remove `lowercaseFirstLetter()` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      overridesResolver: h = ERe(YB(c))
    } = a, m = (0, qP.default)(a, bRe), v = d !== void 0 ? d : (
      // TODO v6: remove `Root` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      c && c !== "Root" && c !== "root" || !1
    ), x = f || !1;
    let C;
    process.env.NODE_ENV !== "production" && u && (C = `${u}-${YB(c || "Root")}`);
    let E = Jx;
    c === "Root" || c === "root" ? E = r : c ? E = i : DRe(s) && (E = void 0);
    const S = (0, GB.default)(s, (0, Sa.default)({
      shouldForwardProp: E,
      label: C
    }, m)), w = (A) => typeof A == "function" && A.__emotion_real !== A || (0, dRe.isPlainObject)(A) ? (I) => Xx(A, (0, Sa.default)({}, I, {
      theme: _1({
        theme: I.theme,
        defaultTheme: n,
        themeId: t
      })
    })) : A, O = (A, ...I) => {
      let $ = w(A);
      const L = I ? I.map(w) : [];
      u && h && L.push((q) => {
        const J = _1((0, Sa.default)({}, q, {
          defaultTheme: n,
          themeId: t
        }));
        if (!J.components || !J.components[u] || !J.components[u].styleOverrides)
          return null;
        const X = J.components[u].styleOverrides, j = {};
        return Object.entries(X).forEach(([U, G]) => {
          j[U] = Xx(G, (0, Sa.default)({}, q, {
            theme: J
          }));
        }), h(q, j);
      }), u && !v && L.push((q) => {
        var J;
        const X = _1((0, Sa.default)({}, q, {
          defaultTheme: n,
          themeId: t
        })), j = X == null || (J = X.components) == null || (J = J[u]) == null ? void 0 : J.variants;
        return Xx({
          variants: j
        }, (0, Sa.default)({}, q, {
          theme: X
        }));
      }), x || L.push(o);
      const B = L.length - I.length;
      if (Array.isArray(A) && B > 0) {
        const q = new Array(B).fill("");
        $ = [...A, ...q], $.raw = [...A.raw, ...q];
      }
      const H = S($, ...L);
      if (process.env.NODE_ENV !== "production") {
        let q;
        u && (q = `${u}${(0, pRe.default)(c || "")}`), q === void 0 && (q = `Styled(${(0, fRe.default)(s)})`), H.displayName = q;
      }
      return s.muiName && (H.muiName = s.muiName), H;
    };
    return S.withConfig && (O.withConfig = S.withConfig), O;
  };
}
function FE(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
const Ao = (e) => FE(e) && e !== "classes", De = cRe({
  themeId: Rb,
  defaultTheme: IE,
  rootShouldForwardProp: Ao
}), KB = (e) => {
  let t;
  return e < 1 ? t = 5.11916 * e ** 2 : t = 4.5 * Math.log(e + 1) + 2, (t / 100).toFixed(2);
};
process.env.NODE_ENV !== "production" && (l.node, l.object.isRequired);
function Ot(e) {
  return rMe(e);
}
function SRe(e) {
  return ot("MuiSvgIcon", e);
}
st("MuiSvgIcon", ["root", "colorPrimary", "colorSecondary", "colorAction", "colorError", "colorDisabled", "fontSizeInherit", "fontSizeSmall", "fontSizeMedium", "fontSizeLarge"]);
const ARe = ["children", "className", "color", "component", "fontSize", "htmlColor", "inheritViewBox", "titleAccess", "viewBox"], wRe = (e) => {
  const {
    color: t,
    fontSize: n,
    classes: r
  } = e, i = {
    root: ["root", t !== "inherit" && `color${Ue(t)}`, `fontSize${Ue(n)}`]
  };
  return at(i, SRe, r);
}, PRe = De("svg", {
  name: "MuiSvgIcon",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.color !== "inherit" && t[`color${Ue(n.color)}`], t[`fontSize${Ue(n.fontSize)}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => {
  var n, r, i, o, s, a, u, c, d, f, h, m, v;
  return {
    userSelect: "none",
    width: "1em",
    height: "1em",
    display: "inline-block",
    // the <svg> will define the property that has `currentColor`
    // for example heroicons uses fill="none" and stroke="currentColor"
    fill: t.hasSvgAsChild ? void 0 : "currentColor",
    flexShrink: 0,
    transition: (n = e.transitions) == null || (r = n.create) == null ? void 0 : r.call(n, "fill", {
      duration: (i = e.transitions) == null || (i = i.duration) == null ? void 0 : i.shorter
    }),
    fontSize: {
      inherit: "inherit",
      small: ((o = e.typography) == null || (s = o.pxToRem) == null ? void 0 : s.call(o, 20)) || "1.25rem",
      medium: ((a = e.typography) == null || (u = a.pxToRem) == null ? void 0 : u.call(a, 24)) || "1.5rem",
      large: ((c = e.typography) == null || (d = c.pxToRem) == null ? void 0 : d.call(c, 35)) || "2.1875rem"
    }[t.fontSize],
    // TODO v5 deprecate, v6 remove for sx
    color: (f = (h = (e.vars || e).palette) == null || (h = h[t.color]) == null ? void 0 : h.main) != null ? f : {
      action: (m = (e.vars || e).palette) == null || (m = m.action) == null ? void 0 : m.active,
      disabled: (v = (e.vars || e).palette) == null || (v = v.action) == null ? void 0 : v.disabled,
      inherit: void 0
    }[t.color]
  };
}), L0 = /* @__PURE__ */ V.forwardRef(function(t, n) {
  const r = Ot({
    props: t,
    name: "MuiSvgIcon"
  }), {
    children: i,
    className: o,
    color: s = "inherit",
    component: a = "svg",
    fontSize: u = "medium",
    htmlColor: c,
    inheritViewBox: d = !1,
    titleAccess: f,
    viewBox: h = "0 0 24 24"
  } = r, m = _e(r, ARe), v = /* @__PURE__ */ V.isValidElement(i) && i.type === "svg", x = N({}, r, {
    color: s,
    component: a,
    fontSize: u,
    instanceFontSize: t.fontSize,
    inheritViewBox: d,
    viewBox: h,
    hasSvgAsChild: v
  }), C = {};
  d || (C.viewBox = h);
  const E = wRe(x);
  return /* @__PURE__ */ P.jsxs(PRe, N({
    as: a,
    className: Be(E.root, o),
    focusable: "false",
    color: c,
    "aria-hidden": f ? void 0 : !0,
    role: f ? "img" : void 0,
    ref: n
  }, C, m, v && i.props, {
    ownerState: x,
    children: [v ? i.props.children : i, f ? /* @__PURE__ */ P.jsx("title", {
      children: f
    }) : null]
  }));
});
process.env.NODE_ENV !== "production" && (L0.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Node passed into the SVG element.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * You can use the `htmlColor` prop to apply a color attribute to the SVG element.
   * @default 'inherit'
   */
  color: l.oneOfType([l.oneOf(["inherit", "action", "disabled", "primary", "secondary", "error", "info", "success", "warning"]), l.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   * @default 'medium'
   */
  fontSize: l.oneOfType([l.oneOf(["inherit", "large", "medium", "small"]), l.string]),
  /**
   * Applies a color attribute to the SVG element.
   */
  htmlColor: l.string,
  /**
   * If `true`, the root node will inherit the custom `component`'s viewBox and the `viewBox`
   * prop will be ignored.
   * Useful when you want to reference a custom `component` and have `SvgIcon` pass that
   * `component`'s viewBox to the root node.
   * @default false
   */
  inheritViewBox: l.bool,
  /**
   * The shape-rendering attribute. The behavior of the different options is described on the
   * [MDN Web Docs](https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/shape-rendering).
   * If you are having issues with blurry icons you should investigate this prop.
   */
  shapeRendering: l.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * Provides a human-readable title for the element that contains it.
   * https://www.w3.org/TR/SVG-access/#Equivalent
   */
  titleAccess: l.string,
  /**
   * Allows you to redefine what the coordinates without units mean inside an SVG element.
   * For example, if the SVG element is 500 (width) by 200 (height),
   * and you pass viewBox="0 0 50 20",
   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
   * to bottom right (50,20) and each unit will be worth 10px.
   * @default '0 0 24 24'
   */
  viewBox: l.string
});
L0.muiName = "SvgIcon";
function Rr(e, t) {
  function n(r, i) {
    return /* @__PURE__ */ P.jsx(L0, N({
      "data-testid": `${t}Icon`,
      ref: i
    }, r, {
      children: e
    }));
  }
  return process.env.NODE_ENV !== "production" && (n.displayName = `${t}Icon`), n.muiName = L0.muiName, /* @__PURE__ */ V.memo(/* @__PURE__ */ V.forwardRef(n));
}
const kRe = {
  configure: (e) => {
    process.env.NODE_ENV !== "production" && console.warn(["MUI: `ClassNameGenerator` import from `@mui/material/utils` is outdated and might cause unexpected issues.", "", "You should use `import { unstable_ClassNameGenerator } from '@mui/material/className'` instead", "", "The detail of the issue: https://github.com/mui/material-ui/issues/30011#issuecomment-1024993401", "", "The updated documentation: https://mui.com/guides/classname-generator/"].join(`
`)), zI.configure(e);
  }
}, ORe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  capitalize: Ue,
  createChainedFunction: zD,
  createSvgIcon: Rr,
  debounce: Vb,
  deprecatedPropType: RNe,
  isMuiElement: _p,
  ownerDocument: ei,
  ownerWindow: bu,
  requirePropFactory: Qz,
  setRef: _0,
  unstable_ClassNameGenerator: kRe,
  unstable_useEnhancedEffect: gi,
  unstable_useId: Pl,
  unsupportedProp: WI,
  useControlled: Hi,
  useEventCallback: Mt,
  useForkRef: Hn,
  useIsFocusVisible: OE
}, Symbol.toStringTag, { value: "Module" }));
function GP(e, t) {
  return GP = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, r) {
    return n.__proto__ = r, n;
  }, GP(e, t);
}
function KI(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, GP(e, t);
}
function IRe(e, t) {
  return e.classList ? !!t && e.classList.contains(t) : (" " + (e.className.baseVal || e.className) + " ").indexOf(" " + t + " ") !== -1;
}
function FRe(e, t) {
  e.classList ? e.classList.add(t) : IRe(e, t) || (typeof e.className == "string" ? e.className = e.className + " " + t : e.setAttribute("class", (e.className && e.className.baseVal || "") + " " + t));
}
function JB(e, t) {
  return e.replace(new RegExp("(^|\\s)" + t + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
}
function $Re(e, t) {
  e.classList ? e.classList.remove(t) : typeof e.className == "string" ? e.className = JB(e.className, t) : e.setAttribute("class", JB(e.className && e.className.baseVal || "", t));
}
const XB = {
  disabled: !1
};
var NRe = process.env.NODE_ENV !== "production" ? l.oneOfType([l.number, l.shape({
  enter: l.number,
  exit: l.number,
  appear: l.number
}).isRequired]) : null, MRe = process.env.NODE_ENV !== "production" ? l.oneOfType([l.string, l.shape({
  enter: l.string,
  exit: l.string,
  active: l.string
}), l.shape({
  enter: l.string,
  enterDone: l.string,
  enterActive: l.string,
  exit: l.string,
  exitDone: l.string,
  exitActive: l.string
})]) : null;
const WD = se.createContext(null);
var gU = function(t) {
  return t.scrollTop;
}, Hy = "unmounted", mp = "exited", gp = "entering", Ah = "entered", YP = "exiting", pa = /* @__PURE__ */ function(e) {
  KI(t, e);
  function t(r, i) {
    var o;
    o = e.call(this, r, i) || this;
    var s = i, a = s && !s.isMounting ? r.enter : r.appear, u;
    return o.appearStatus = null, r.in ? a ? (u = mp, o.appearStatus = gp) : u = Ah : r.unmountOnExit || r.mountOnEnter ? u = Hy : u = mp, o.state = {
      status: u
    }, o.nextCallback = null, o;
  }
  t.getDerivedStateFromProps = function(i, o) {
    var s = i.in;
    return s && o.status === Hy ? {
      status: mp
    } : null;
  };
  var n = t.prototype;
  return n.componentDidMount = function() {
    this.updateStatus(!0, this.appearStatus);
  }, n.componentDidUpdate = function(i) {
    var o = null;
    if (i !== this.props) {
      var s = this.state.status;
      this.props.in ? s !== gp && s !== Ah && (o = gp) : (s === gp || s === Ah) && (o = YP);
    }
    this.updateStatus(!1, o);
  }, n.componentWillUnmount = function() {
    this.cancelNextCallback();
  }, n.getTimeouts = function() {
    var i = this.props.timeout, o, s, a;
    return o = s = a = i, i != null && typeof i != "number" && (o = i.exit, s = i.enter, a = i.appear !== void 0 ? i.appear : s), {
      exit: o,
      enter: s,
      appear: a
    };
  }, n.updateStatus = function(i, o) {
    if (i === void 0 && (i = !1), o !== null)
      if (this.cancelNextCallback(), o === gp) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var s = this.props.nodeRef ? this.props.nodeRef.current : T1.findDOMNode(this);
          s && gU(s);
        }
        this.performEnter(i);
      } else
        this.performExit();
    else this.props.unmountOnExit && this.state.status === mp && this.setState({
      status: Hy
    });
  }, n.performEnter = function(i) {
    var o = this, s = this.props.enter, a = this.context ? this.context.isMounting : i, u = this.props.nodeRef ? [a] : [T1.findDOMNode(this), a], c = u[0], d = u[1], f = this.getTimeouts(), h = a ? f.appear : f.enter;
    if (!i && !s || XB.disabled) {
      this.safeSetState({
        status: Ah
      }, function() {
        o.props.onEntered(c);
      });
      return;
    }
    this.props.onEnter(c, d), this.safeSetState({
      status: gp
    }, function() {
      o.props.onEntering(c, d), o.onTransitionEnd(h, function() {
        o.safeSetState({
          status: Ah
        }, function() {
          o.props.onEntered(c, d);
        });
      });
    });
  }, n.performExit = function() {
    var i = this, o = this.props.exit, s = this.getTimeouts(), a = this.props.nodeRef ? void 0 : T1.findDOMNode(this);
    if (!o || XB.disabled) {
      this.safeSetState({
        status: mp
      }, function() {
        i.props.onExited(a);
      });
      return;
    }
    this.props.onExit(a), this.safeSetState({
      status: YP
    }, function() {
      i.props.onExiting(a), i.onTransitionEnd(s.exit, function() {
        i.safeSetState({
          status: mp
        }, function() {
          i.props.onExited(a);
        });
      });
    });
  }, n.cancelNextCallback = function() {
    this.nextCallback !== null && (this.nextCallback.cancel(), this.nextCallback = null);
  }, n.safeSetState = function(i, o) {
    o = this.setNextCallback(o), this.setState(i, o);
  }, n.setNextCallback = function(i) {
    var o = this, s = !0;
    return this.nextCallback = function(a) {
      s && (s = !1, o.nextCallback = null, i(a));
    }, this.nextCallback.cancel = function() {
      s = !1;
    }, this.nextCallback;
  }, n.onTransitionEnd = function(i, o) {
    this.setNextCallback(o);
    var s = this.props.nodeRef ? this.props.nodeRef.current : T1.findDOMNode(this), a = i == null && !this.props.addEndListener;
    if (!s || a) {
      setTimeout(this.nextCallback, 0);
      return;
    }
    if (this.props.addEndListener) {
      var u = this.props.nodeRef ? [this.nextCallback] : [s, this.nextCallback], c = u[0], d = u[1];
      this.props.addEndListener(c, d);
    }
    i != null && setTimeout(this.nextCallback, i);
  }, n.render = function() {
    var i = this.state.status;
    if (i === Hy)
      return null;
    var o = this.props, s = o.children;
    o.in, o.mountOnEnter, o.unmountOnExit, o.appear, o.enter, o.exit, o.timeout, o.addEndListener, o.onEnter, o.onEntering, o.onEntered, o.onExit, o.onExiting, o.onExited, o.nodeRef;
    var a = _e(o, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
    return (
      // allows for nested Transitions
      /* @__PURE__ */ se.createElement(WD.Provider, {
        value: null
      }, typeof s == "function" ? s(i, a) : se.cloneElement(se.Children.only(s), a))
    );
  }, t;
}(se.Component);
pa.contextType = WD;
pa.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: l.shape({
    current: typeof Element > "u" ? l.any : function(e, t, n, r, i, o) {
      var s = e[t];
      return l.instanceOf(s && "ownerDocument" in s ? s.ownerDocument.defaultView.Element : Element)(e, t, n, r, i, o);
    }
  }),
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: l.oneOfType([l.func.isRequired, l.element.isRequired]).isRequired,
  /**
   * Show the component; triggers the enter or exit states
   */
  in: l.bool,
  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: l.bool,
  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: l.bool,
  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: l.bool,
  /**
   * Enable or disable enter transitions.
   */
  enter: l.bool,
  /**
   * Enable or disable exit transitions.
   */
  exit: l.bool,
  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function(t) {
    var n = NRe;
    t.addEndListener || (n = n.isRequired);
    for (var r = arguments.length, i = new Array(r > 1 ? r - 1 : 0), o = 1; o < r; o++)
      i[o - 1] = arguments[o];
    return n.apply(void 0, [t].concat(i));
  },
  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: l.func,
  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: l.func,
  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: l.func,
  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: l.func,
  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: l.func,
  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: l.func,
  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: l.func
} : {};
function vh() {
}
pa.defaultProps = {
  in: !1,
  mountOnEnter: !1,
  unmountOnExit: !1,
  appear: !1,
  enter: !0,
  exit: !0,
  onEnter: vh,
  onEntering: vh,
  onEntered: vh,
  onExit: vh,
  onExiting: vh,
  onExited: vh
};
pa.UNMOUNTED = Hy;
pa.EXITED = mp;
pa.ENTERING = gp;
pa.ENTERED = Ah;
pa.EXITING = YP;
var RRe = function(t, n) {
  return t && n && n.split(" ").forEach(function(r) {
    return FRe(t, r);
  });
}, qA = function(t, n) {
  return t && n && n.split(" ").forEach(function(r) {
    return $Re(t, r);
  });
}, JI = /* @__PURE__ */ function(e) {
  KI(t, e);
  function t() {
    for (var r, i = arguments.length, o = new Array(i), s = 0; s < i; s++)
      o[s] = arguments[s];
    return r = e.call.apply(e, [this].concat(o)) || this, r.appliedClasses = {
      appear: {},
      enter: {},
      exit: {}
    }, r.onEnter = function(a, u) {
      var c = r.resolveArguments(a, u), d = c[0], f = c[1];
      r.removeClasses(d, "exit"), r.addClass(d, f ? "appear" : "enter", "base"), r.props.onEnter && r.props.onEnter(a, u);
    }, r.onEntering = function(a, u) {
      var c = r.resolveArguments(a, u), d = c[0], f = c[1], h = f ? "appear" : "enter";
      r.addClass(d, h, "active"), r.props.onEntering && r.props.onEntering(a, u);
    }, r.onEntered = function(a, u) {
      var c = r.resolveArguments(a, u), d = c[0], f = c[1], h = f ? "appear" : "enter";
      r.removeClasses(d, h), r.addClass(d, h, "done"), r.props.onEntered && r.props.onEntered(a, u);
    }, r.onExit = function(a) {
      var u = r.resolveArguments(a), c = u[0];
      r.removeClasses(c, "appear"), r.removeClasses(c, "enter"), r.addClass(c, "exit", "base"), r.props.onExit && r.props.onExit(a);
    }, r.onExiting = function(a) {
      var u = r.resolveArguments(a), c = u[0];
      r.addClass(c, "exit", "active"), r.props.onExiting && r.props.onExiting(a);
    }, r.onExited = function(a) {
      var u = r.resolveArguments(a), c = u[0];
      r.removeClasses(c, "exit"), r.addClass(c, "exit", "done"), r.props.onExited && r.props.onExited(a);
    }, r.resolveArguments = function(a, u) {
      return r.props.nodeRef ? [r.props.nodeRef.current, a] : [a, u];
    }, r.getClassNames = function(a) {
      var u = r.props.classNames, c = typeof u == "string", d = c && u ? u + "-" : "", f = c ? "" + d + a : u[a], h = c ? f + "-active" : u[a + "Active"], m = c ? f + "-done" : u[a + "Done"];
      return {
        baseClassName: f,
        activeClassName: h,
        doneClassName: m
      };
    }, r;
  }
  var n = t.prototype;
  return n.addClass = function(i, o, s) {
    var a = this.getClassNames(o)[s + "ClassName"], u = this.getClassNames("enter"), c = u.doneClassName;
    o === "appear" && s === "done" && c && (a += " " + c), s === "active" && i && gU(i), a && (this.appliedClasses[o][s] = a, RRe(i, a));
  }, n.removeClasses = function(i, o) {
    var s = this.appliedClasses[o], a = s.base, u = s.active, c = s.done;
    this.appliedClasses[o] = {}, a && qA(i, a), u && qA(i, u), c && qA(i, c);
  }, n.render = function() {
    var i = this.props;
    i.classNames;
    var o = _e(i, ["classNames"]);
    return /* @__PURE__ */ se.createElement(pa, N({}, o, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  }, t;
}(se.Component);
JI.defaultProps = {
  classNames: ""
};
JI.propTypes = process.env.NODE_ENV !== "production" ? N({}, pa.propTypes, {
  /**
   * The animation classNames applied to the component as it appears, enters,
   * exits or has finished the transition. A single name can be provided, which
   * will be suffixed for each stage, e.g. `classNames="fade"` applies:
   *
   * - `fade-appear`, `fade-appear-active`, `fade-appear-done`
   * - `fade-enter`, `fade-enter-active`, `fade-enter-done`
   * - `fade-exit`, `fade-exit-active`, `fade-exit-done`
   *
   * A few details to note about how these classes are applied:
   *
   * 1. They are _joined_ with the ones that are already defined on the child
   *    component, so if you want to add some base styles, you can use
   *    `className` without worrying that it will be overridden.
   *
   * 2. If the transition component mounts with `in={false}`, no classes are
   *    applied yet. You might be expecting `*-exit-done`, but if you think
   *    about it, a component cannot finish exiting if it hasn't entered yet.
   *
   * 2. `fade-appear-done` and `fade-enter-done` will _both_ be applied. This
   *    allows you to define different behavior for when appearing is done and
   *    when regular entering is done, using selectors like
   *    `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply
   *    an epic entrance animation when element first appears in the DOM using
   *    [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
   *    simply use `fade-enter-done` for defining both cases.
   *
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  appearDone: 'my-done-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply
   * spread them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  appearDone?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: MRe,
  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: l.func,
  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: l.func,
  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: l.func,
  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExit: l.func,
  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExiting: l.func,
  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement)
   */
  onExited: l.func
}) : {};
function _Re(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function XI(e, t) {
  var n = function(o) {
    return t && Fx(o) ? t(o) : o;
  }, r = /* @__PURE__ */ Object.create(null);
  return e && roe.map(e, function(i) {
    return i;
  }).forEach(function(i) {
    r[i.key] = n(i);
  }), r;
}
function LRe(e, t) {
  e = e || {}, t = t || {};
  function n(d) {
    return d in t ? t[d] : e[d];
  }
  var r = /* @__PURE__ */ Object.create(null), i = [];
  for (var o in e)
    o in t ? i.length && (r[o] = i, i = []) : i.push(o);
  var s, a = {};
  for (var u in t) {
    if (r[u])
      for (s = 0; s < r[u].length; s++) {
        var c = r[u][s];
        a[r[u][s]] = n(c);
      }
    a[u] = n(u);
  }
  for (s = 0; s < i.length; s++)
    a[i[s]] = n(i[s]);
  return a;
}
function kp(e, t, n) {
  return n[t] != null ? n[t] : e.props[t];
}
function BRe(e, t) {
  return XI(e.children, function(n) {
    return $x(n, {
      onExited: t.bind(null, n),
      in: !0,
      appear: kp(n, "appear", e),
      enter: kp(n, "enter", e),
      exit: kp(n, "exit", e)
    });
  });
}
function jRe(e, t, n) {
  var r = XI(e.children), i = LRe(t, r);
  return Object.keys(i).forEach(function(o) {
    var s = i[o];
    if (Fx(s)) {
      var a = o in t, u = o in r, c = t[o], d = Fx(c) && !c.props.in;
      u && (!a || d) ? i[o] = $x(s, {
        onExited: n.bind(null, s),
        in: !0,
        exit: kp(s, "exit", e),
        enter: kp(s, "enter", e)
      }) : !u && a && !d ? i[o] = $x(s, {
        in: !1
      }) : u && a && Fx(c) && (i[o] = $x(s, {
        onExited: n.bind(null, s),
        in: c.props.in,
        exit: kp(s, "exit", e),
        enter: kp(s, "enter", e)
      }));
    }
  }), i;
}
var VRe = Object.values || function(e) {
  return Object.keys(e).map(function(t) {
    return e[t];
  });
}, zRe = {
  component: "div",
  childFactory: function(t) {
    return t;
  }
}, Gb = /* @__PURE__ */ function(e) {
  KI(t, e);
  function t(r, i) {
    var o;
    o = e.call(this, r, i) || this;
    var s = o.handleExited.bind(_Re(o));
    return o.state = {
      contextValue: {
        isMounting: !0
      },
      handleExited: s,
      firstRender: !0
    }, o;
  }
  var n = t.prototype;
  return n.componentDidMount = function() {
    this.mounted = !0, this.setState({
      contextValue: {
        isMounting: !1
      }
    });
  }, n.componentWillUnmount = function() {
    this.mounted = !1;
  }, t.getDerivedStateFromProps = function(i, o) {
    var s = o.children, a = o.handleExited, u = o.firstRender;
    return {
      children: u ? BRe(i, a) : jRe(i, s, a),
      firstRender: !1
    };
  }, n.handleExited = function(i, o) {
    var s = XI(this.props.children);
    i.key in s || (i.props.onExited && i.props.onExited(o), this.mounted && this.setState(function(a) {
      var u = N({}, a.children);
      return delete u[i.key], {
        children: u
      };
    }));
  }, n.render = function() {
    var i = this.props, o = i.component, s = i.childFactory, a = _e(i, ["component", "childFactory"]), u = this.state.contextValue, c = VRe(this.state.children).map(s);
    return delete a.appear, delete a.enter, delete a.exit, o === null ? /* @__PURE__ */ se.createElement(WD.Provider, {
      value: u
    }, c) : /* @__PURE__ */ se.createElement(WD.Provider, {
      value: u
    }, /* @__PURE__ */ se.createElement(o, a, c));
  }, t;
}(se.Component);
Gb.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: l.any,
  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: l.node,
  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: l.bool,
  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: l.bool,
  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: l.bool,
  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: l.func
} : {};
Gb.defaultProps = zRe;
const yU = (e) => e.scrollTop;
function pm(e, t) {
  var n, r;
  const {
    timeout: i,
    easing: o,
    style: s = {}
  } = e;
  return {
    duration: (n = s.transitionDuration) != null ? n : typeof i == "number" ? i : i[t.mode] || 0,
    easing: (r = s.transitionTimingFunction) != null ? r : typeof o == "object" ? o[t.mode] : o,
    delay: s.transitionDelay
  };
}
function URe(e) {
  return ot("MuiCollapse", e);
}
st("MuiCollapse", ["root", "horizontal", "vertical", "entered", "hidden", "wrapper", "wrapperInner"]);
const WRe = ["addEndListener", "children", "className", "collapsedSize", "component", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "orientation", "style", "timeout", "TransitionComponent"], HRe = (e) => {
  const {
    orientation: t,
    classes: n
  } = e, r = {
    root: ["root", `${t}`],
    entered: ["entered"],
    hidden: ["hidden"],
    wrapper: ["wrapper", `${t}`],
    wrapperInner: ["wrapperInner", `${t}`]
  };
  return at(r, URe, n);
}, qRe = De("div", {
  name: "MuiCollapse",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.orientation], n.state === "entered" && t.entered, n.state === "exited" && !n.in && n.collapsedSize === "0px" && t.hidden];
  }
})(({
  theme: e,
  ownerState: t
}) => N({
  height: 0,
  overflow: "hidden",
  transition: e.transitions.create("height")
}, t.orientation === "horizontal" && {
  height: "auto",
  width: 0,
  transition: e.transitions.create("width")
}, t.state === "entered" && N({
  height: "auto",
  overflow: "visible"
}, t.orientation === "horizontal" && {
  width: "auto"
}), t.state === "exited" && !t.in && t.collapsedSize === "0px" && {
  visibility: "hidden"
})), GRe = De("div", {
  name: "MuiCollapse",
  slot: "Wrapper",
  overridesResolver: (e, t) => t.wrapper
})(({
  ownerState: e
}) => N({
  // Hack to get children with a negative margin to not falsify the height computation.
  display: "flex",
  width: "100%"
}, e.orientation === "horizontal" && {
  width: "auto",
  height: "100%"
})), YRe = De("div", {
  name: "MuiCollapse",
  slot: "WrapperInner",
  overridesResolver: (e, t) => t.wrapperInner
})(({
  ownerState: e
}) => N({
  width: "100%"
}, e.orientation === "horizontal" && {
  width: "auto",
  height: "100%"
})), QI = /* @__PURE__ */ V.forwardRef(function(t, n) {
  const r = Ot({
    props: t,
    name: "MuiCollapse"
  }), {
    addEndListener: i,
    children: o,
    className: s,
    collapsedSize: a = "0px",
    component: u,
    easing: c,
    in: d,
    onEnter: f,
    onEntered: h,
    onEntering: m,
    onExit: v,
    onExited: x,
    onExiting: C,
    orientation: E = "vertical",
    style: S,
    timeout: w = pU.standard,
    // eslint-disable-next-line react/prop-types
    TransitionComponent: O = pa
  } = r, A = _e(r, WRe), I = N({}, r, {
    orientation: E,
    collapsedSize: a
  }), $ = HRe(I), L = Gi(), B = Pp(), H = V.useRef(null), q = V.useRef(), J = typeof a == "number" ? `${a}px` : a, X = E === "horizontal", j = X ? "width" : "height", U = V.useRef(null), G = Hn(n, U), K = (Q) => (oe) => {
    if (Q) {
      const ae = U.current;
      oe === void 0 ? Q(ae) : Q(ae, oe);
    }
  }, ee = () => H.current ? H.current[X ? "clientWidth" : "clientHeight"] : 0, te = K((Q, oe) => {
    H.current && X && (H.current.style.position = "absolute"), Q.style[j] = J, f && f(Q, oe);
  }), M = K((Q, oe) => {
    const ae = ee();
    H.current && X && (H.current.style.position = "");
    const {
      duration: pe,
      easing: me
    } = pm({
      style: S,
      timeout: w,
      easing: c
    }, {
      mode: "enter"
    });
    if (w === "auto") {
      const xe = L.transitions.getAutoHeightDuration(ae);
      Q.style.transitionDuration = `${xe}ms`, q.current = xe;
    } else
      Q.style.transitionDuration = typeof pe == "string" ? pe : `${pe}ms`;
    Q.style[j] = `${ae}px`, Q.style.transitionTimingFunction = me, m && m(Q, oe);
  }), Z = K((Q, oe) => {
    Q.style[j] = "auto", h && h(Q, oe);
  }), ne = K((Q) => {
    Q.style[j] = `${ee()}px`, v && v(Q);
  }), R = K(x), _ = K((Q) => {
    const oe = ee(), {
      duration: ae,
      easing: pe
    } = pm({
      style: S,
      timeout: w,
      easing: c
    }, {
      mode: "exit"
    });
    if (w === "auto") {
      const me = L.transitions.getAutoHeightDuration(oe);
      Q.style.transitionDuration = `${me}ms`, q.current = me;
    } else
      Q.style.transitionDuration = typeof ae == "string" ? ae : `${ae}ms`;
    Q.style[j] = J, Q.style.transitionTimingFunction = pe, C && C(Q);
  }), W = (Q) => {
    w === "auto" && B.start(q.current || 0, Q), i && i(U.current, Q);
  };
  return /* @__PURE__ */ P.jsx(O, N({
    in: d,
    onEnter: te,
    onEntered: Z,
    onEntering: M,
    onExit: ne,
    onExited: R,
    onExiting: _,
    addEndListener: W,
    nodeRef: U,
    timeout: w === "auto" ? null : w
  }, A, {
    children: (Q, oe) => /* @__PURE__ */ P.jsx(qRe, N({
      as: u,
      className: Be($.root, s, {
        entered: $.entered,
        exited: !d && J === "0px" && $.hidden
      }[Q]),
      style: N({
        [X ? "minWidth" : "minHeight"]: J
      }, S),
      ref: G
    }, oe, {
      // `ownerState` is set after `childProps` to override any existing `ownerState` property in `childProps`
      // that might have been forwarded from the Transition component.
      ownerState: N({}, I, {
        state: Q
      }),
      children: /* @__PURE__ */ P.jsx(GRe, {
        ownerState: N({}, I, {
          state: Q
        }),
        className: $.wrapper,
        ref: H,
        children: /* @__PURE__ */ P.jsx(YRe, {
          ownerState: N({}, I, {
            state: Q
          }),
          className: $.wrapperInner,
          children: o
        })
      })
    }))
  }));
});
process.env.NODE_ENV !== "production" && (QI.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: l.func,
  /**
   * The content node to be collapsed.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The width (horizontal) or height (vertical) of the container when collapsed.
   * @default '0px'
   */
  collapsedSize: l.oneOfType([l.number, l.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: jb,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: l.oneOfType([l.shape({
    enter: l.string,
    exit: l.string
  }), l.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: l.bool,
  /**
   * @ignore
   */
  onEnter: l.func,
  /**
   * @ignore
   */
  onEntered: l.func,
  /**
   * @ignore
   */
  onEntering: l.func,
  /**
   * @ignore
   */
  onExit: l.func,
  /**
   * @ignore
   */
  onExited: l.func,
  /**
   * @ignore
   */
  onExiting: l.func,
  /**
   * The transition orientation.
   * @default 'vertical'
   */
  orientation: l.oneOf(["horizontal", "vertical"]),
  /**
   * @ignore
   */
  style: l.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default duration.standard
   */
  timeout: l.oneOfType([l.oneOf(["auto"]), l.number, l.shape({
    appear: l.number,
    enter: l.number,
    exit: l.number
  })])
});
QI.muiSupportAuto = !0;
function KRe(e) {
  return ot("MuiPaper", e);
}
const bU = st("MuiPaper", ["root", "rounded", "outlined", "elevation", "elevation0", "elevation1", "elevation2", "elevation3", "elevation4", "elevation5", "elevation6", "elevation7", "elevation8", "elevation9", "elevation10", "elevation11", "elevation12", "elevation13", "elevation14", "elevation15", "elevation16", "elevation17", "elevation18", "elevation19", "elevation20", "elevation21", "elevation22", "elevation23", "elevation24"]), JRe = ["className", "component", "elevation", "square", "variant"], XRe = (e) => {
  const {
    square: t,
    elevation: n,
    variant: r,
    classes: i
  } = e, o = {
    root: ["root", r, !t && "rounded", r === "elevation" && `elevation${n}`]
  };
  return at(o, KRe, i);
}, QRe = De("div", {
  name: "MuiPaper",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.variant], !n.square && t.rounded, n.variant === "elevation" && t[`elevation${n.elevation}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => {
  var n;
  return N({
    backgroundColor: (e.vars || e).palette.background.paper,
    color: (e.vars || e).palette.text.primary,
    transition: e.transitions.create("box-shadow")
  }, !t.square && {
    borderRadius: e.shape.borderRadius
  }, t.variant === "outlined" && {
    border: `1px solid ${(e.vars || e).palette.divider}`
  }, t.variant === "elevation" && N({
    boxShadow: (e.vars || e).shadows[t.elevation]
  }, !e.vars && e.palette.mode === "dark" && {
    backgroundImage: `linear-gradient(${Yt("#fff", KB(t.elevation))}, ${Yt("#fff", KB(t.elevation))})`
  }, e.vars && {
    backgroundImage: (n = e.vars.overlays) == null ? void 0 : n[t.elevation]
  }));
}), ti = /* @__PURE__ */ V.forwardRef(function(t, n) {
  const r = Ot({
    props: t,
    name: "MuiPaper"
  }), {
    className: i,
    component: o = "div",
    elevation: s = 1,
    square: a = !1,
    variant: u = "elevation"
  } = r, c = _e(r, JRe), d = N({}, r, {
    component: o,
    elevation: s,
    square: a,
    variant: u
  }), f = XRe(d);
  return process.env.NODE_ENV !== "production" && Gi().shadows[s] === void 0 && console.error([`MUI: The elevation provided <Paper elevation={${s}}> is not available in the theme.`, `Please make sure that \`theme.shadows[${s}]\` is defined.`].join(`
`)), /* @__PURE__ */ P.jsx(QRe, N({
    as: o,
    ownerState: d,
    className: Be(f.root, i),
    ref: n
  }, c));
});
process.env.NODE_ENV !== "production" && (ti.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * Shadow depth, corresponds to `dp` in the spec.
   * It accepts values between 0 and 24 inclusive.
   * @default 1
   */
  elevation: $s(Ub, (e) => {
    const {
      elevation: t,
      variant: n
    } = e;
    return t > 0 && n === "outlined" ? new Error(`MUI: Combining \`elevation={${t}}\` with \`variant="${n}"\` has no effect. Either use \`elevation={0}\` or use a different \`variant\`.`) : null;
  }),
  /**
   * If `true`, rounded corners are disabled.
   * @default false
   */
  square: l.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * The variant to use.
   * @default 'elevation'
   */
  variant: l.oneOfType([l.oneOf(["elevation", "outlined"]), l.string])
});
const ZI = /* @__PURE__ */ V.createContext({});
process.env.NODE_ENV !== "production" && (ZI.displayName = "AccordionContext");
const ZRe = ["className", "elementType", "ownerState", "externalForwardedProps", "getSlotOwnerState", "internalForwardedProps"], e_e = ["component", "slots", "slotProps"], t_e = ["component"];
function HD(e, t) {
  const {
    className: n,
    elementType: r,
    ownerState: i,
    externalForwardedProps: o,
    getSlotOwnerState: s,
    internalForwardedProps: a
  } = t, u = _e(t, ZRe), {
    component: c,
    slots: d = {
      [e]: void 0
    },
    slotProps: f = {
      [e]: void 0
    }
  } = o, h = _e(o, e_e), m = d[e] || r, v = iU(f[e], i), x = rU(N({
    className: n
  }, u, {
    externalForwardedProps: e === "root" ? h : void 0,
    externalSlotProps: v
  })), {
    props: {
      component: C
    },
    internalRef: E
  } = x, S = _e(x.props, t_e), w = Hn(E, v == null ? void 0 : v.ref, t.ref), O = s ? s(S) : {}, A = N({}, i, O), I = e === "root" ? C || c : C, $ = Nh(m, N({}, e === "root" && !c && !d[e] && a, e !== "root" && !d[e] && a, S, I && {
    as: I
  }, {
    ref: w
  }), A);
  return Object.keys(O).forEach((L) => {
    delete $[L];
  }), [m, $];
}
function n_e(e) {
  return ot("MuiAccordion", e);
}
const L1 = st("MuiAccordion", ["root", "rounded", "expanded", "disabled", "gutters", "region"]), r_e = ["children", "className", "defaultExpanded", "disabled", "disableGutters", "expanded", "onChange", "square", "slots", "slotProps", "TransitionComponent", "TransitionProps"], i_e = (e) => {
  const {
    classes: t,
    square: n,
    expanded: r,
    disabled: i,
    disableGutters: o
  } = e;
  return at({
    root: ["root", !n && "rounded", r && "expanded", i && "disabled", !o && "gutters"],
    region: ["region"]
  }, n_e, t);
}, o_e = De(ti, {
  name: "MuiAccordion",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [{
      [`& .${L1.region}`]: t.region
    }, t.root, !n.square && t.rounded, !n.disableGutters && t.gutters];
  }
})(({
  theme: e
}) => {
  const t = {
    duration: e.transitions.duration.shortest
  };
  return {
    position: "relative",
    transition: e.transitions.create(["margin"], t),
    overflowAnchor: "none",
    // Keep the same scrolling position
    "&::before": {
      position: "absolute",
      left: 0,
      top: -1,
      right: 0,
      height: 1,
      content: '""',
      opacity: 1,
      backgroundColor: (e.vars || e).palette.divider,
      transition: e.transitions.create(["opacity", "background-color"], t)
    },
    "&:first-of-type": {
      "&::before": {
        display: "none"
      }
    },
    [`&.${L1.expanded}`]: {
      "&::before": {
        opacity: 0
      },
      "&:first-of-type": {
        marginTop: 0
      },
      "&:last-of-type": {
        marginBottom: 0
      },
      "& + &": {
        "&::before": {
          display: "none"
        }
      }
    },
    [`&.${L1.disabled}`]: {
      backgroundColor: (e.vars || e).palette.action.disabledBackground
    }
  };
}, ({
  theme: e
}) => ({
  variants: [{
    props: (t) => !t.square,
    style: {
      borderRadius: 0,
      "&:first-of-type": {
        borderTopLeftRadius: (e.vars || e).shape.borderRadius,
        borderTopRightRadius: (e.vars || e).shape.borderRadius
      },
      "&:last-of-type": {
        borderBottomLeftRadius: (e.vars || e).shape.borderRadius,
        borderBottomRightRadius: (e.vars || e).shape.borderRadius,
        // Fix a rendering issue on Edge
        "@supports (-ms-ime-align: auto)": {
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0
        }
      }
    }
  }, {
    props: (t) => !t.disableGutters,
    style: {
      [`&.${L1.expanded}`]: {
        margin: "16px 0"
      }
    }
  }]
})), eF = /* @__PURE__ */ V.forwardRef(function(t, n) {
  const r = Ot({
    props: t,
    name: "MuiAccordion"
  }), {
    children: i,
    className: o,
    defaultExpanded: s = !1,
    disabled: a = !1,
    disableGutters: u = !1,
    expanded: c,
    onChange: d,
    square: f = !1,
    slots: h = {},
    slotProps: m = {},
    TransitionComponent: v,
    TransitionProps: x
  } = r, C = _e(r, r_e), [E, S] = Hi({
    controlled: c,
    default: s,
    name: "Accordion",
    state: "expanded"
  }), w = V.useCallback((X) => {
    S(!E), d && d(X, !E);
  }, [E, d, S]), [O, ...A] = V.Children.toArray(i), I = V.useMemo(() => ({
    expanded: E,
    disabled: a,
    disableGutters: u,
    toggle: w
  }), [E, a, u, w]), $ = N({}, r, {
    square: f,
    disabled: a,
    disableGutters: u,
    expanded: E
  }), L = i_e($), B = N({
    transition: v
  }, h), H = N({
    transition: x
  }, m), [q, J] = HD("transition", {
    elementType: QI,
    externalForwardedProps: {
      slots: B,
      slotProps: H
    },
    ownerState: $
  });
  return /* @__PURE__ */ P.jsxs(o_e, N({
    className: Be(L.root, o),
    ref: n,
    ownerState: $,
    square: f
  }, C, {
    children: [/* @__PURE__ */ P.jsx(ZI.Provider, {
      value: I,
      children: O
    }), /* @__PURE__ */ P.jsx(q, N({
      in: E,
      timeout: "auto"
    }, J, {
      children: /* @__PURE__ */ P.jsx("div", {
        "aria-labelledby": O.props.id,
        id: O.props["aria-controls"],
        role: "region",
        className: L.region,
        children: A
      })
    }))]
  }));
});
process.env.NODE_ENV !== "production" && (eF.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: $s(l.node.isRequired, (e) => {
    const t = V.Children.toArray(e.children)[0];
    return Gp.isFragment(t) ? new Error("MUI: The Accordion doesn't accept a Fragment as a child. Consider providing an array instead.") : /* @__PURE__ */ V.isValidElement(t) ? null : new Error("MUI: Expected the first child of Accordion to be a valid element.");
  }),
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * If `true`, expands the accordion by default.
   * @default false
   */
  defaultExpanded: l.bool,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: l.bool,
  /**
   * If `true`, it removes the margin between two expanded accordion items and the increase of height.
   * @default false
   */
  disableGutters: l.bool,
  /**
   * If `true`, expands the accordion, otherwise collapse it.
   * Setting this prop enables control over the accordion.
   */
  expanded: l.bool,
  /**
   * Callback fired when the expand/collapse state is changed.
   *
   * @param {React.SyntheticEvent} event The event source of the callback. **Warning**: This is a generic event not a change event.
   * @param {boolean} expanded The `expanded` state of the accordion.
   */
  onChange: l.func,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: l.shape({
    transition: l.oneOfType([l.func, l.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: l.shape({
    transition: l.elementType
  }),
  /**
   * If `true`, rounded corners are disabled.
   * @default false
   */
  square: l.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @deprecated Use `slots.transition` instead. This prop will be removed in v7. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/).
   */
  TransitionComponent: l.elementType,
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @deprecated Use `slotProps.transition` instead. This prop will be removed in v7. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/).
   */
  TransitionProps: l.object
});
function s_e(e) {
  return ot("MuiAccordionDetails", e);
}
st("MuiAccordionDetails", ["root"]);
const a_e = ["className"], l_e = (e) => {
  const {
    classes: t
  } = e;
  return at({
    root: ["root"]
  }, s_e, t);
}, u_e = De("div", {
  name: "MuiAccordionDetails",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e
}) => ({
  padding: e.spacing(1, 2, 2)
})), tF = /* @__PURE__ */ V.forwardRef(function(t, n) {
  const r = Ot({
    props: t,
    name: "MuiAccordionDetails"
  }), {
    className: i
  } = r, o = _e(r, a_e), s = r, a = l_e(s);
  return /* @__PURE__ */ P.jsx(u_e, N({
    className: Be(a.root, i),
    ref: n,
    ownerState: s
  }, o));
});
process.env.NODE_ENV !== "production" && (tF.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
function vU(e) {
  const {
    className: t,
    classes: n,
    pulsate: r = !1,
    rippleX: i,
    rippleY: o,
    rippleSize: s,
    in: a,
    onExited: u,
    timeout: c
  } = e, [d, f] = V.useState(!1), h = Be(t, n.ripple, n.rippleVisible, r && n.ripplePulsate), m = {
    width: s,
    height: s,
    top: -(s / 2) + o,
    left: -(s / 2) + i
  }, v = Be(n.child, d && n.childLeaving, r && n.childPulsate);
  return !a && !d && f(!0), V.useEffect(() => {
    if (!a && u != null) {
      const x = setTimeout(u, c);
      return () => {
        clearTimeout(x);
      };
    }
  }, [u, a, c]), /* @__PURE__ */ P.jsx("span", {
    className: h,
    style: m,
    children: /* @__PURE__ */ P.jsx("span", {
      className: v
    })
  });
}
process.env.NODE_ENV !== "production" && (vU.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object.isRequired,
  className: l.string,
  /**
   * @ignore - injected from TransitionGroup
   */
  in: l.bool,
  /**
   * @ignore - injected from TransitionGroup
   */
  onExited: l.func,
  /**
   * If `true`, the ripple pulsates, typically indicating the keyboard focus state of an element.
   */
  pulsate: l.bool,
  /**
   * Diameter of the ripple.
   */
  rippleSize: l.number,
  /**
   * Horizontal position of the ripple center.
   */
  rippleX: l.number,
  /**
   * Vertical position of the ripple center.
   */
  rippleY: l.number,
  /**
   * exit delay
   */
  timeout: l.number.isRequired
});
const Aa = st("MuiTouchRipple", ["root", "ripple", "rippleVisible", "ripplePulsate", "child", "childLeaving", "childPulsate"]), c_e = ["center", "classes", "className"];
let $E = (e) => e, QB, ZB, e3, t3;
const KP = 550, d_e = 80, p_e = UC(QB || (QB = $E`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`)), f_e = UC(ZB || (ZB = $E`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`)), h_e = UC(e3 || (e3 = $E`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`)), m_e = De("span", {
  name: "MuiTouchRipple",
  slot: "Root"
})({
  overflow: "hidden",
  pointerEvents: "none",
  position: "absolute",
  zIndex: 0,
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  borderRadius: "inherit"
}), g_e = De(vU, {
  name: "MuiTouchRipple",
  slot: "Ripple"
})(t3 || (t3 = $E`
  opacity: 0;
  position: absolute;

  &.${0} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  &.${0} {
    animation-duration: ${0}ms;
  }

  & .${0} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${0} {
    opacity: 0;
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  & .${0} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${0};
    animation-duration: 2500ms;
    animation-timing-function: ${0};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`), Aa.rippleVisible, p_e, KP, ({
  theme: e
}) => e.transitions.easing.easeInOut, Aa.ripplePulsate, ({
  theme: e
}) => e.transitions.duration.shorter, Aa.child, Aa.childLeaving, f_e, KP, ({
  theme: e
}) => e.transitions.easing.easeInOut, Aa.childPulsate, h_e, ({
  theme: e
}) => e.transitions.easing.easeInOut), xU = /* @__PURE__ */ V.forwardRef(function(t, n) {
  const r = Ot({
    props: t,
    name: "MuiTouchRipple"
  }), {
    center: i = !1,
    classes: o = {},
    className: s
  } = r, a = _e(r, c_e), [u, c] = V.useState([]), d = V.useRef(0), f = V.useRef(null);
  V.useEffect(() => {
    f.current && (f.current(), f.current = null);
  }, [u]);
  const h = V.useRef(!1), m = Pp(), v = V.useRef(null), x = V.useRef(null), C = V.useCallback((O) => {
    const {
      pulsate: A,
      rippleX: I,
      rippleY: $,
      rippleSize: L,
      cb: B
    } = O;
    c((H) => [...H, /* @__PURE__ */ P.jsx(g_e, {
      classes: {
        ripple: Be(o.ripple, Aa.ripple),
        rippleVisible: Be(o.rippleVisible, Aa.rippleVisible),
        ripplePulsate: Be(o.ripplePulsate, Aa.ripplePulsate),
        child: Be(o.child, Aa.child),
        childLeaving: Be(o.childLeaving, Aa.childLeaving),
        childPulsate: Be(o.childPulsate, Aa.childPulsate)
      },
      timeout: KP,
      pulsate: A,
      rippleX: I,
      rippleY: $,
      rippleSize: L
    }, d.current)]), d.current += 1, f.current = B;
  }, [o]), E = V.useCallback((O = {}, A = {}, I = () => {
  }) => {
    const {
      pulsate: $ = !1,
      center: L = i || A.pulsate,
      fakeElement: B = !1
      // For test purposes
    } = A;
    if ((O == null ? void 0 : O.type) === "mousedown" && h.current) {
      h.current = !1;
      return;
    }
    (O == null ? void 0 : O.type) === "touchstart" && (h.current = !0);
    const H = B ? null : x.current, q = H ? H.getBoundingClientRect() : {
      width: 0,
      height: 0,
      left: 0,
      top: 0
    };
    let J, X, j;
    if (L || O === void 0 || O.clientX === 0 && O.clientY === 0 || !O.clientX && !O.touches)
      J = Math.round(q.width / 2), X = Math.round(q.height / 2);
    else {
      const {
        clientX: U,
        clientY: G
      } = O.touches && O.touches.length > 0 ? O.touches[0] : O;
      J = Math.round(U - q.left), X = Math.round(G - q.top);
    }
    if (L)
      j = Math.sqrt((2 * q.width ** 2 + q.height ** 2) / 3), j % 2 === 0 && (j += 1);
    else {
      const U = Math.max(Math.abs((H ? H.clientWidth : 0) - J), J) * 2 + 2, G = Math.max(Math.abs((H ? H.clientHeight : 0) - X), X) * 2 + 2;
      j = Math.sqrt(U ** 2 + G ** 2);
    }
    O != null && O.touches ? v.current === null && (v.current = () => {
      C({
        pulsate: $,
        rippleX: J,
        rippleY: X,
        rippleSize: j,
        cb: I
      });
    }, m.start(d_e, () => {
      v.current && (v.current(), v.current = null);
    })) : C({
      pulsate: $,
      rippleX: J,
      rippleY: X,
      rippleSize: j,
      cb: I
    });
  }, [i, C, m]), S = V.useCallback(() => {
    E({}, {
      pulsate: !0
    });
  }, [E]), w = V.useCallback((O, A) => {
    if (m.clear(), (O == null ? void 0 : O.type) === "touchend" && v.current) {
      v.current(), v.current = null, m.start(0, () => {
        w(O, A);
      });
      return;
    }
    v.current = null, c((I) => I.length > 0 ? I.slice(1) : I), f.current = A;
  }, [m]);
  return V.useImperativeHandle(n, () => ({
    pulsate: S,
    start: E,
    stop: w
  }), [S, E, w]), /* @__PURE__ */ P.jsx(m_e, N({
    className: Be(Aa.root, o.root, s),
    ref: x
  }, a, {
    children: /* @__PURE__ */ P.jsx(Gb, {
      component: null,
      exit: !0,
      children: u
    })
  }));
});
process.env.NODE_ENV !== "production" && (xU.propTypes = {
  /**
   * If `true`, the ripple starts at the center of the component
   * rather than at the point of interaction.
   */
  center: l.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string
});
function y_e(e) {
  return ot("MuiButtonBase", e);
}
const b_e = st("MuiButtonBase", ["root", "disabled", "focusVisible"]), v_e = ["action", "centerRipple", "children", "className", "component", "disabled", "disableRipple", "disableTouchRipple", "focusRipple", "focusVisibleClassName", "LinkComponent", "onBlur", "onClick", "onContextMenu", "onDragLeave", "onFocus", "onFocusVisible", "onKeyDown", "onKeyUp", "onMouseDown", "onMouseLeave", "onMouseUp", "onTouchEnd", "onTouchMove", "onTouchStart", "tabIndex", "TouchRippleProps", "touchRippleRef", "type"], x_e = (e) => {
  const {
    disabled: t,
    focusVisible: n,
    focusVisibleClassName: r,
    classes: i
  } = e, s = at({
    root: ["root", t && "disabled", n && "focusVisible"]
  }, y_e, i);
  return n && r && (s.root += ` ${r}`), s;
}, D_e = De("button", {
  name: "MuiButtonBase",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  boxSizing: "border-box",
  WebkitTapHighlightColor: "transparent",
  backgroundColor: "transparent",
  // Reset default value
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  border: 0,
  margin: 0,
  // Remove the margin in Safari
  borderRadius: 0,
  padding: 0,
  // Remove the padding in Firefox
  cursor: "pointer",
  userSelect: "none",
  verticalAlign: "middle",
  MozAppearance: "none",
  // Reset
  WebkitAppearance: "none",
  // Reset
  textDecoration: "none",
  // So we take precedent over the style of a native <a /> element.
  color: "inherit",
  "&::-moz-focus-inner": {
    borderStyle: "none"
    // Remove Firefox dotted outline.
  },
  [`&.${b_e.disabled}`]: {
    pointerEvents: "none",
    // Disable link interactions
    cursor: "default"
  },
  "@media print": {
    colorAdjust: "exact"
  }
}), sa = /* @__PURE__ */ V.forwardRef(function(t, n) {
  const r = Ot({
    props: t,
    name: "MuiButtonBase"
  }), {
    action: i,
    centerRipple: o = !1,
    children: s,
    className: a,
    component: u = "button",
    disabled: c = !1,
    disableRipple: d = !1,
    disableTouchRipple: f = !1,
    focusRipple: h = !1,
    LinkComponent: m = "a",
    onBlur: v,
    onClick: x,
    onContextMenu: C,
    onDragLeave: E,
    onFocus: S,
    onFocusVisible: w,
    onKeyDown: O,
    onKeyUp: A,
    onMouseDown: I,
    onMouseLeave: $,
    onMouseUp: L,
    onTouchEnd: B,
    onTouchMove: H,
    onTouchStart: q,
    tabIndex: J = 0,
    TouchRippleProps: X,
    touchRippleRef: j,
    type: U
  } = r, G = _e(r, v_e), K = V.useRef(null), ee = V.useRef(null), te = Hn(ee, j), {
    isFocusVisibleRef: M,
    onFocus: Z,
    onBlur: ne,
    ref: R
  } = OE(), [_, W] = V.useState(!1);
  c && _ && W(!1), V.useImperativeHandle(i, () => ({
    focusVisible: () => {
      W(!0), K.current.focus();
    }
  }), []);
  const [Q, oe] = V.useState(!1);
  V.useEffect(() => {
    oe(!0);
  }, []);
  const ae = Q && !d && !c;
  V.useEffect(() => {
    _ && h && !d && Q && ee.current.pulsate();
  }, [d, h, _, Q]);
  function pe(Ae, We, At = f) {
    return Mt((Ft) => (We && We(Ft), !At && ee.current && ee.current[Ae](Ft), !0));
  }
  const me = pe("start", I), xe = pe("stop", C), le = pe("stop", E), ye = pe("stop", L), be = pe("stop", (Ae) => {
    _ && Ae.preventDefault(), $ && $(Ae);
  }), Re = pe("start", q), Te = pe("stop", B), Xe = pe("stop", H), Ne = pe("stop", (Ae) => {
    ne(Ae), M.current === !1 && W(!1), v && v(Ae);
  }, !1), Qe = Mt((Ae) => {
    K.current || (K.current = Ae.currentTarget), Z(Ae), M.current === !0 && (W(!0), w && w(Ae)), S && S(Ae);
  }), Ee = () => {
    const Ae = K.current;
    return u && u !== "button" && !(Ae.tagName === "A" && Ae.href);
  }, Ie = V.useRef(!1), Je = Mt((Ae) => {
    h && !Ie.current && _ && ee.current && Ae.key === " " && (Ie.current = !0, ee.current.stop(Ae, () => {
      ee.current.start(Ae);
    })), Ae.target === Ae.currentTarget && Ee() && Ae.key === " " && Ae.preventDefault(), O && O(Ae), Ae.target === Ae.currentTarget && Ee() && Ae.key === "Enter" && !c && (Ae.preventDefault(), x && x(Ae));
  }), vt = Mt((Ae) => {
    h && Ae.key === " " && ee.current && _ && !Ae.defaultPrevented && (Ie.current = !1, ee.current.stop(Ae, () => {
      ee.current.pulsate(Ae);
    })), A && A(Ae), x && Ae.target === Ae.currentTarget && Ee() && Ae.key === " " && !Ae.defaultPrevented && x(Ae);
  });
  let St = u;
  St === "button" && (G.href || G.to) && (St = m);
  const Lt = {};
  St === "button" ? (Lt.type = U === void 0 ? "button" : U, Lt.disabled = c) : (!G.href && !G.to && (Lt.role = "button"), c && (Lt["aria-disabled"] = c));
  const ke = Hn(n, R, K);
  process.env.NODE_ENV !== "production" && V.useEffect(() => {
    ae && !ee.current && console.error(["MUI: The `component` prop provided to ButtonBase is invalid.", "Please make sure the children prop is rendered in this custom component."].join(`
`));
  }, [ae]);
  const Le = N({}, r, {
    centerRipple: o,
    component: u,
    disabled: c,
    disableRipple: d,
    disableTouchRipple: f,
    focusRipple: h,
    tabIndex: J,
    focusVisible: _
  }), Pe = x_e(Le);
  return /* @__PURE__ */ P.jsxs(D_e, N({
    as: St,
    className: Be(Pe.root, a),
    ownerState: Le,
    onBlur: Ne,
    onClick: x,
    onContextMenu: xe,
    onFocus: Qe,
    onKeyDown: Je,
    onKeyUp: vt,
    onMouseDown: me,
    onMouseLeave: be,
    onMouseUp: ye,
    onDragLeave: le,
    onTouchEnd: Te,
    onTouchMove: Xe,
    onTouchStart: Re,
    ref: ke,
    tabIndex: c ? -1 : J,
    type: U
  }, Lt, G, {
    children: [s, ae ? (
      /* TouchRipple is only needed client-side, x2 boost on the server. */
      /* @__PURE__ */ P.jsx(xU, N({
        ref: te,
        center: o
      }, X))
    ) : null]
  }));
});
process.env.NODE_ENV !== "production" && (sa.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A ref for imperative actions.
   * It currently only supports `focusVisible()` action.
   */
  action: wr,
  /**
   * If `true`, the ripples are centered.
   * They won't start at the cursor interaction position.
   * @default false
   */
  centerRipple: l.bool,
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: jb,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: l.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: l.bool,
  /**
   * If `true`, the touch ripple effect is disabled.
   * @default false
   */
  disableTouchRipple: l.bool,
  /**
   * If `true`, the base button will have a keyboard focus ripple.
   * @default false
   */
  focusRipple: l.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: l.string,
  /**
   * @ignore
   */
  href: l.any,
  /**
   * The component used to render a link when the `href` prop is provided.
   * @default 'a'
   */
  LinkComponent: l.elementType,
  /**
   * @ignore
   */
  onBlur: l.func,
  /**
   * @ignore
   */
  onClick: l.func,
  /**
   * @ignore
   */
  onContextMenu: l.func,
  /**
   * @ignore
   */
  onDragLeave: l.func,
  /**
   * @ignore
   */
  onFocus: l.func,
  /**
   * Callback fired when the component is focused with a keyboard.
   * We trigger a `onFocus` callback too.
   */
  onFocusVisible: l.func,
  /**
   * @ignore
   */
  onKeyDown: l.func,
  /**
   * @ignore
   */
  onKeyUp: l.func,
  /**
   * @ignore
   */
  onMouseDown: l.func,
  /**
   * @ignore
   */
  onMouseLeave: l.func,
  /**
   * @ignore
   */
  onMouseUp: l.func,
  /**
   * @ignore
   */
  onTouchEnd: l.func,
  /**
   * @ignore
   */
  onTouchMove: l.func,
  /**
   * @ignore
   */
  onTouchStart: l.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * @default 0
   */
  tabIndex: l.number,
  /**
   * Props applied to the `TouchRipple` element.
   */
  TouchRippleProps: l.object,
  /**
   * A ref that points to the `TouchRipple` element.
   */
  touchRippleRef: l.oneOfType([l.func, l.shape({
    current: l.shape({
      pulsate: l.func.isRequired,
      start: l.func.isRequired,
      stop: l.func.isRequired
    })
  })]),
  /**
   * @ignore
   */
  type: l.oneOfType([l.oneOf(["button", "reset", "submit"]), l.string])
});
function C_e(e) {
  return ot("MuiAccordionSummary", e);
}
const Op = st("MuiAccordionSummary", ["root", "expanded", "focusVisible", "disabled", "gutters", "contentGutters", "content", "expandIconWrapper"]), E_e = ["children", "className", "expandIcon", "focusVisibleClassName", "onClick"], T_e = (e) => {
  const {
    classes: t,
    expanded: n,
    disabled: r,
    disableGutters: i
  } = e;
  return at({
    root: ["root", n && "expanded", r && "disabled", !i && "gutters"],
    focusVisible: ["focusVisible"],
    content: ["content", n && "expanded", !i && "contentGutters"],
    expandIconWrapper: ["expandIconWrapper", n && "expanded"]
  }, C_e, t);
}, S_e = De(sa, {
  name: "MuiAccordionSummary",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e
}) => {
  const t = {
    duration: e.transitions.duration.shortest
  };
  return {
    display: "flex",
    minHeight: 48,
    padding: e.spacing(0, 2),
    transition: e.transitions.create(["min-height", "background-color"], t),
    [`&.${Op.focusVisible}`]: {
      backgroundColor: (e.vars || e).palette.action.focus
    },
    [`&.${Op.disabled}`]: {
      opacity: (e.vars || e).palette.action.disabledOpacity
    },
    [`&:hover:not(.${Op.disabled})`]: {
      cursor: "pointer"
    },
    variants: [{
      props: (n) => !n.disableGutters,
      style: {
        [`&.${Op.expanded}`]: {
          minHeight: 64
        }
      }
    }]
  };
}), A_e = De("div", {
  name: "MuiAccordionSummary",
  slot: "Content",
  overridesResolver: (e, t) => t.content
})(({
  theme: e
}) => ({
  display: "flex",
  flexGrow: 1,
  margin: "12px 0",
  variants: [{
    props: (t) => !t.disableGutters,
    style: {
      transition: e.transitions.create(["margin"], {
        duration: e.transitions.duration.shortest
      }),
      [`&.${Op.expanded}`]: {
        margin: "20px 0"
      }
    }
  }]
})), w_e = De("div", {
  name: "MuiAccordionSummary",
  slot: "ExpandIconWrapper",
  overridesResolver: (e, t) => t.expandIconWrapper
})(({
  theme: e
}) => ({
  display: "flex",
  color: (e.vars || e).palette.action.active,
  transform: "rotate(0deg)",
  transition: e.transitions.create("transform", {
    duration: e.transitions.duration.shortest
  }),
  [`&.${Op.expanded}`]: {
    transform: "rotate(180deg)"
  }
})), nF = /* @__PURE__ */ V.forwardRef(function(t, n) {
  const r = Ot({
    props: t,
    name: "MuiAccordionSummary"
  }), {
    children: i,
    className: o,
    expandIcon: s,
    focusVisibleClassName: a,
    onClick: u
  } = r, c = _e(r, E_e), {
    disabled: d = !1,
    disableGutters: f,
    expanded: h,
    toggle: m
  } = V.useContext(ZI), v = (E) => {
    m && m(E), u && u(E);
  }, x = N({}, r, {
    expanded: h,
    disabled: d,
    disableGutters: f
  }), C = T_e(x);
  return /* @__PURE__ */ P.jsxs(S_e, N({
    focusRipple: !1,
    disableRipple: !0,
    disabled: d,
    component: "div",
    "aria-expanded": h,
    className: Be(C.root, o),
    focusVisibleClassName: Be(C.focusVisible, a),
    onClick: v,
    ref: n,
    ownerState: x
  }, c, {
    children: [/* @__PURE__ */ P.jsx(A_e, {
      className: C.content,
      ownerState: x,
      children: i
    }), s && /* @__PURE__ */ P.jsx(w_e, {
      className: C.expandIconWrapper,
      ownerState: x,
      children: s
    })]
  }));
});
process.env.NODE_ENV !== "production" && (nF.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The icon to display as the expand indicator.
   */
  expandIcon: l.node,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: l.string,
  /**
   * @ignore
   */
  onClick: l.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
function P_e(e) {
  return ot("MuiAlert", e);
}
const n3 = st("MuiAlert", ["root", "action", "icon", "message", "filled", "colorSuccess", "colorInfo", "colorWarning", "colorError", "filledSuccess", "filledInfo", "filledWarning", "filledError", "outlined", "outlinedSuccess", "outlinedInfo", "outlinedWarning", "outlinedError", "standard", "standardSuccess", "standardInfo", "standardWarning", "standardError"]);
function k_e(e) {
  return ot("MuiIconButton", e);
}
const O_e = st("MuiIconButton", ["root", "disabled", "colorInherit", "colorPrimary", "colorSecondary", "colorError", "colorInfo", "colorSuccess", "colorWarning", "edgeStart", "edgeEnd", "sizeSmall", "sizeMedium", "sizeLarge"]), I_e = ["edge", "children", "className", "color", "disabled", "disableFocusRipple", "size"], F_e = (e) => {
  const {
    classes: t,
    disabled: n,
    color: r,
    edge: i,
    size: o
  } = e, s = {
    root: ["root", n && "disabled", r !== "default" && `color${Ue(r)}`, i && `edge${Ue(i)}`, `size${Ue(o)}`]
  };
  return at(s, k_e, t);
}, $_e = De(sa, {
  name: "MuiIconButton",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.color !== "default" && t[`color${Ue(n.color)}`], n.edge && t[`edge${Ue(n.edge)}`], t[`size${Ue(n.size)}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => N({
  textAlign: "center",
  flex: "0 0 auto",
  fontSize: e.typography.pxToRem(24),
  padding: 8,
  borderRadius: "50%",
  overflow: "visible",
  // Explicitly set the default value to solve a bug on IE11.
  color: (e.vars || e).palette.action.active,
  transition: e.transitions.create("background-color", {
    duration: e.transitions.duration.shortest
  })
}, !t.disableRipple && {
  "&:hover": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.hoverOpacity})` : Yt(e.palette.action.active, e.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  }
}, t.edge === "start" && {
  marginLeft: t.size === "small" ? -3 : -12
}, t.edge === "end" && {
  marginRight: t.size === "small" ? -3 : -12
}), ({
  theme: e,
  ownerState: t
}) => {
  var n;
  const r = (n = (e.vars || e).palette) == null ? void 0 : n[t.color];
  return N({}, t.color === "inherit" && {
    color: "inherit"
  }, t.color !== "inherit" && t.color !== "default" && N({
    color: r == null ? void 0 : r.main
  }, !t.disableRipple && {
    "&:hover": N({}, r && {
      backgroundColor: e.vars ? `rgba(${r.mainChannel} / ${e.vars.palette.action.hoverOpacity})` : Yt(r.main, e.palette.action.hoverOpacity)
    }, {
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    })
  }), t.size === "small" && {
    padding: 5,
    fontSize: e.typography.pxToRem(18)
  }, t.size === "large" && {
    padding: 12,
    fontSize: e.typography.pxToRem(28)
  }, {
    [`&.${O_e.disabled}`]: {
      backgroundColor: "transparent",
      color: (e.vars || e).palette.action.disabled
    }
  });
}), Or = /* @__PURE__ */ V.forwardRef(function(t, n) {
  const r = Ot({
    props: t,
    name: "MuiIconButton"
  }), {
    edge: i = !1,
    children: o,
    className: s,
    color: a = "default",
    disabled: u = !1,
    disableFocusRipple: c = !1,
    size: d = "medium"
  } = r, f = _e(r, I_e), h = N({}, r, {
    edge: i,
    color: a,
    disabled: u,
    disableFocusRipple: c,
    size: d
  }), m = F_e(h);
  return /* @__PURE__ */ P.jsx($_e, N({
    className: Be(m.root, s),
    centerRipple: !0,
    focusRipple: !c,
    disabled: u,
    ref: n
  }, f, {
    ownerState: h,
    children: o
  }));
});
process.env.NODE_ENV !== "production" && (Or.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The icon to display.
   */
  children: $s(l.node, (e) => V.Children.toArray(e.children).some((n) => /* @__PURE__ */ V.isValidElement(n) && n.props.onClick) ? new Error(["MUI: You are providing an onClick event listener to a child of a button element.", "Prefer applying it to the IconButton directly.", "This guarantees that the whole <button> will be responsive to click events."].join(`
`)) : null),
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'default'
   */
  color: l.oneOfType([l.oneOf(["inherit", "default", "primary", "secondary", "error", "info", "success", "warning"]), l.string]),
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: l.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: l.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: l.bool,
  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */
  edge: l.oneOf(["end", "start", !1]),
  /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'medium'
   */
  size: l.oneOfType([l.oneOf(["small", "medium", "large"]), l.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
const N_e = Rr(/* @__PURE__ */ P.jsx("path", {
  d: "M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2, 4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0, 0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z"
}), "SuccessOutlined"), M_e = Rr(/* @__PURE__ */ P.jsx("path", {
  d: "M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"
}), "ReportProblemOutlined"), R_e = Rr(/* @__PURE__ */ P.jsx("path", {
  d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), "ErrorOutline"), __e = Rr(/* @__PURE__ */ P.jsx("path", {
  d: "M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20, 12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10, 10 0 0,0 12,2M11,17H13V11H11V17Z"
}), "InfoOutlined"), DU = Rr(/* @__PURE__ */ P.jsx("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close"), L_e = ["action", "children", "className", "closeText", "color", "components", "componentsProps", "icon", "iconMapping", "onClose", "role", "severity", "slotProps", "slots", "variant"], B_e = (e) => {
  const {
    variant: t,
    color: n,
    severity: r,
    classes: i
  } = e, o = {
    root: ["root", `color${Ue(n || r)}`, `${t}${Ue(n || r)}`, `${t}`],
    icon: ["icon"],
    message: ["message"],
    action: ["action"]
  };
  return at(o, P_e, i);
}, j_e = De(ti, {
  name: "MuiAlert",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.variant], t[`${n.variant}${Ue(n.color || n.severity)}`]];
  }
})(({
  theme: e
}) => {
  const t = e.palette.mode === "light" ? Yp : Kp, n = e.palette.mode === "light" ? Kp : Yp;
  return N({}, e.typography.body2, {
    backgroundColor: "transparent",
    display: "flex",
    padding: "6px 16px",
    variants: [...Object.entries(e.palette).filter(([, r]) => r.main && r.light).map(([r]) => ({
      props: {
        colorSeverity: r,
        variant: "standard"
      },
      style: {
        color: e.vars ? e.vars.palette.Alert[`${r}Color`] : t(e.palette[r].light, 0.6),
        backgroundColor: e.vars ? e.vars.palette.Alert[`${r}StandardBg`] : n(e.palette[r].light, 0.9),
        [`& .${n3.icon}`]: e.vars ? {
          color: e.vars.palette.Alert[`${r}IconColor`]
        } : {
          color: e.palette[r].main
        }
      }
    })), ...Object.entries(e.palette).filter(([, r]) => r.main && r.light).map(([r]) => ({
      props: {
        colorSeverity: r,
        variant: "outlined"
      },
      style: {
        color: e.vars ? e.vars.palette.Alert[`${r}Color`] : t(e.palette[r].light, 0.6),
        border: `1px solid ${(e.vars || e).palette[r].light}`,
        [`& .${n3.icon}`]: e.vars ? {
          color: e.vars.palette.Alert[`${r}IconColor`]
        } : {
          color: e.palette[r].main
        }
      }
    })), ...Object.entries(e.palette).filter(([, r]) => r.main && r.dark).map(([r]) => ({
      props: {
        colorSeverity: r,
        variant: "filled"
      },
      style: N({
        fontWeight: e.typography.fontWeightMedium
      }, e.vars ? {
        color: e.vars.palette.Alert[`${r}FilledColor`],
        backgroundColor: e.vars.palette.Alert[`${r}FilledBg`]
      } : {
        backgroundColor: e.palette.mode === "dark" ? e.palette[r].dark : e.palette[r].main,
        color: e.palette.getContrastText(e.palette[r].main)
      })
    }))]
  });
}), V_e = De("div", {
  name: "MuiAlert",
  slot: "Icon",
  overridesResolver: (e, t) => t.icon
})({
  marginRight: 12,
  padding: "7px 0",
  display: "flex",
  fontSize: 22,
  opacity: 0.9
}), z_e = De("div", {
  name: "MuiAlert",
  slot: "Message",
  overridesResolver: (e, t) => t.message
})({
  padding: "8px 0",
  minWidth: 0,
  overflow: "auto"
}), r3 = De("div", {
  name: "MuiAlert",
  slot: "Action",
  overridesResolver: (e, t) => t.action
})({
  display: "flex",
  alignItems: "flex-start",
  padding: "4px 0 0 16px",
  marginLeft: "auto",
  marginRight: -8
}), i3 = {
  success: /* @__PURE__ */ P.jsx(N_e, {
    fontSize: "inherit"
  }),
  warning: /* @__PURE__ */ P.jsx(M_e, {
    fontSize: "inherit"
  }),
  error: /* @__PURE__ */ P.jsx(R_e, {
    fontSize: "inherit"
  }),
  info: /* @__PURE__ */ P.jsx(__e, {
    fontSize: "inherit"
  })
}, CU = /* @__PURE__ */ V.forwardRef(function(t, n) {
  const r = Ot({
    props: t,
    name: "MuiAlert"
  }), {
    action: i,
    children: o,
    className: s,
    closeText: a = "Close",
    color: u,
    components: c = {},
    componentsProps: d = {},
    icon: f,
    iconMapping: h = i3,
    onClose: m,
    role: v = "alert",
    severity: x = "success",
    slotProps: C = {},
    slots: E = {},
    variant: S = "standard"
  } = r, w = _e(r, L_e), O = N({}, r, {
    color: u,
    severity: x,
    variant: S,
    colorSeverity: u || x
  }), A = B_e(O), I = {
    slots: N({
      closeButton: c.CloseButton,
      closeIcon: c.CloseIcon
    }, E),
    slotProps: N({}, d, C)
  }, [$, L] = HD("closeButton", {
    elementType: Or,
    externalForwardedProps: I,
    ownerState: O
  }), [B, H] = HD("closeIcon", {
    elementType: DU,
    externalForwardedProps: I,
    ownerState: O
  });
  return /* @__PURE__ */ P.jsxs(j_e, N({
    role: v,
    elevation: 0,
    ownerState: O,
    className: Be(A.root, s),
    ref: n
  }, w, {
    children: [f !== !1 ? /* @__PURE__ */ P.jsx(V_e, {
      ownerState: O,
      className: A.icon,
      children: f || h[x] || i3[x]
    }) : null, /* @__PURE__ */ P.jsx(z_e, {
      ownerState: O,
      className: A.message,
      children: o
    }), i != null ? /* @__PURE__ */ P.jsx(r3, {
      ownerState: O,
      className: A.action,
      children: i
    }) : null, i == null && m ? /* @__PURE__ */ P.jsx(r3, {
      ownerState: O,
      className: A.action,
      children: /* @__PURE__ */ P.jsx($, N({
        size: "small",
        "aria-label": a,
        title: a,
        color: "inherit",
        onClick: m
      }, L, {
        children: /* @__PURE__ */ P.jsx(B, N({
          fontSize: "small"
        }, H))
      }))
    }) : null]
  }));
});
process.env.NODE_ENV !== "production" && (CU.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The action to display. It renders after the message, at the end of the alert.
   */
  action: l.node,
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * Override the default label for the *close popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @default 'Close'
   */
  closeText: l.string,
  /**
   * The color of the component. Unless provided, the value is taken from the `severity` prop.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   */
  color: l.oneOfType([l.oneOf(["error", "info", "success", "warning"]), l.string]),
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/).
   *
   * @default {}
   */
  components: l.shape({
    CloseButton: l.elementType,
    CloseIcon: l.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/).
   *
   * @default {}
   */
  componentsProps: l.shape({
    closeButton: l.object,
    closeIcon: l.object
  }),
  /**
   * Override the icon displayed before the children.
   * Unless provided, the icon is mapped to the value of the `severity` prop.
   * Set to `false` to remove the `icon`.
   */
  icon: l.node,
  /**
   * The component maps the `severity` prop to a range of different icons,
   * for instance success to `<SuccessOutlined>`.
   * If you wish to change this mapping, you can provide your own.
   * Alternatively, you can use the `icon` prop to override the icon displayed.
   */
  iconMapping: l.shape({
    error: l.node,
    info: l.node,
    success: l.node,
    warning: l.node
  }),
  /**
   * Callback fired when the component requests to be closed.
   * When provided and no `action` prop is set, a close icon button is displayed that triggers the callback when clicked.
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onClose: l.func,
  /**
   * The ARIA role attribute of the element.
   * @default 'alert'
   */
  role: l.string,
  /**
   * The severity of the alert. This defines the color and icon used.
   * @default 'success'
   */
  severity: l.oneOfType([l.oneOf(["error", "info", "success", "warning"]), l.string]),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: l.shape({
    closeButton: l.oneOfType([l.func, l.object]),
    closeIcon: l.oneOfType([l.func, l.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: l.shape({
    closeButton: l.elementType,
    closeIcon: l.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * The variant to use.
   * @default 'standard'
   */
  variant: l.oneOfType([l.oneOf(["filled", "outlined", "standard"]), l.string])
});
function U_e(e) {
  return ot("MuiTypography", e);
}
st("MuiTypography", ["root", "h1", "h2", "h3", "h4", "h5", "h6", "subtitle1", "subtitle2", "body1", "body2", "inherit", "button", "caption", "overline", "alignLeft", "alignRight", "alignCenter", "alignJustify", "noWrap", "gutterBottom", "paragraph"]);
const W_e = ["align", "className", "component", "gutterBottom", "noWrap", "paragraph", "variant", "variantMapping"], H_e = (e) => {
  const {
    align: t,
    gutterBottom: n,
    noWrap: r,
    paragraph: i,
    variant: o,
    classes: s
  } = e, a = {
    root: ["root", o, e.align !== "inherit" && `align${Ue(t)}`, n && "gutterBottom", r && "noWrap", i && "paragraph"]
  };
  return at(a, U_e, s);
}, q_e = De("span", {
  name: "MuiTypography",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.variant && t[n.variant], n.align !== "inherit" && t[`align${Ue(n.align)}`], n.noWrap && t.noWrap, n.gutterBottom && t.gutterBottom, n.paragraph && t.paragraph];
  }
})(({
  theme: e,
  ownerState: t
}) => N({
  margin: 0
}, t.variant === "inherit" && {
  // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
  font: "inherit"
}, t.variant !== "inherit" && e.typography[t.variant], t.align !== "inherit" && {
  textAlign: t.align
}, t.noWrap && {
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap"
}, t.gutterBottom && {
  marginBottom: "0.35em"
}, t.paragraph && {
  marginBottom: 16
})), o3 = {
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4",
  h5: "h5",
  h6: "h6",
  subtitle1: "h6",
  subtitle2: "h6",
  body1: "p",
  body2: "p",
  inherit: "p"
}, G_e = {
  primary: "primary.main",
  textPrimary: "text.primary",
  secondary: "secondary.main",
  textSecondary: "text.secondary",
  error: "error.main"
}, Y_e = (e) => G_e[e] || e, cn = /* @__PURE__ */ V.forwardRef(function(t, n) {
  const r = Ot({
    props: t,
    name: "MuiTypography"
  }), i = Y_e(r.color), o = Bb(N({}, r, {
    color: i
  })), {
    align: s = "inherit",
    className: a,
    component: u,
    gutterBottom: c = !1,
    noWrap: d = !1,
    paragraph: f = !1,
    variant: h = "body1",
    variantMapping: m = o3
  } = o, v = _e(o, W_e), x = N({}, o, {
    align: s,
    color: i,
    className: a,
    component: u,
    gutterBottom: c,
    noWrap: d,
    paragraph: f,
    variant: h,
    variantMapping: m
  }), C = u || (f ? "p" : m[h] || o3[h]) || "span", E = H_e(x);
  return /* @__PURE__ */ P.jsx(q_e, N({
    as: C,
    ref: n,
    ownerState: x,
    className: Be(E.root, a)
  }, v));
});
process.env.NODE_ENV !== "production" && (cn.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Set the text-align on the component.
   * @default 'inherit'
   */
  align: l.oneOf(["center", "inherit", "justify", "left", "right"]),
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * If `true`, the text will have a bottom margin.
   * @default false
   */
  gutterBottom: l.bool,
  /**
   * If `true`, the text will not wrap, but instead will truncate with a text overflow ellipsis.
   *
   * Note that text overflow can only happen with block or inline-block level elements
   * (the element needs to have a width in order to overflow).
   * @default false
   */
  noWrap: l.bool,
  /**
   * If `true`, the element will be a paragraph element.
   * @default false
   */
  paragraph: l.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * Applies the theme typography styles.
   * @default 'body1'
   */
  variant: l.oneOfType([l.oneOf(["body1", "body2", "button", "caption", "h1", "h2", "h3", "h4", "h5", "h6", "inherit", "overline", "subtitle1", "subtitle2"]), l.string]),
  /**
   * The component maps the variant prop to a range of different HTML element types.
   * For instance, subtitle1 to `<h6>`.
   * If you wish to change that mapping, you can provide your own.
   * Alternatively, you can use the `component` prop.
   * @default {
   *   h1: 'h1',
   *   h2: 'h2',
   *   h3: 'h3',
   *   h4: 'h4',
   *   h5: 'h5',
   *   h6: 'h6',
   *   subtitle1: 'h6',
   *   subtitle2: 'h6',
   *   body1: 'p',
   *   body2: 'p',
   *   inherit: 'p',
   * }
   */
  variantMapping: l.object
});
function K_e(e) {
  return ot("MuiAlertTitle", e);
}
st("MuiAlertTitle", ["root"]);
const J_e = ["className"], X_e = (e) => {
  const {
    classes: t
  } = e;
  return at({
    root: ["root"]
  }, K_e, t);
}, Q_e = De(cn, {
  name: "MuiAlertTitle",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e
}) => ({
  fontWeight: e.typography.fontWeightMedium,
  marginTop: -2
})), EU = /* @__PURE__ */ V.forwardRef(function(t, n) {
  const r = Ot({
    props: t,
    name: "MuiAlertTitle"
  }), {
    className: i
  } = r, o = _e(r, J_e), s = r, a = X_e(s);
  return /* @__PURE__ */ P.jsx(Q_e, N({
    gutterBottom: !0,
    component: "div",
    ownerState: s,
    ref: n,
    className: Be(a.root, i)
  }, o));
});
process.env.NODE_ENV !== "production" && (EU.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
function Z_e(e) {
  return ot("MuiAppBar", e);
}
st("MuiAppBar", ["root", "positionFixed", "positionAbsolute", "positionSticky", "positionStatic", "positionRelative", "colorDefault", "colorPrimary", "colorSecondary", "colorInherit", "colorTransparent", "colorError", "colorInfo", "colorSuccess", "colorWarning"]);
const eLe = ["className", "color", "enableColorOnDark", "position"], tLe = (e) => {
  const {
    color: t,
    position: n,
    classes: r
  } = e, i = {
    root: ["root", `color${Ue(t)}`, `position${Ue(n)}`]
  };
  return at(i, Z_e, r);
}, B1 = (e, t) => e ? `${e == null ? void 0 : e.replace(")", "")}, ${t})` : t, nLe = De(ti, {
  name: "MuiAppBar",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[`position${Ue(n.position)}`], t[`color${Ue(n.color)}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => {
  const n = e.palette.mode === "light" ? e.palette.grey[100] : e.palette.grey[900];
  return N({
    display: "flex",
    flexDirection: "column",
    width: "100%",
    boxSizing: "border-box",
    // Prevent padding issue with the Modal and fixed positioned AppBar.
    flexShrink: 0
  }, t.position === "fixed" && {
    position: "fixed",
    zIndex: (e.vars || e).zIndex.appBar,
    top: 0,
    left: "auto",
    right: 0,
    "@media print": {
      // Prevent the app bar to be visible on each printed page.
      position: "absolute"
    }
  }, t.position === "absolute" && {
    position: "absolute",
    zIndex: (e.vars || e).zIndex.appBar,
    top: 0,
    left: "auto",
    right: 0
  }, t.position === "sticky" && {
    // ⚠️ sticky is not supported by IE11.
    position: "sticky",
    zIndex: (e.vars || e).zIndex.appBar,
    top: 0,
    left: "auto",
    right: 0
  }, t.position === "static" && {
    position: "static"
  }, t.position === "relative" && {
    position: "relative"
  }, !e.vars && N({}, t.color === "default" && {
    backgroundColor: n,
    color: e.palette.getContrastText(n)
  }, t.color && t.color !== "default" && t.color !== "inherit" && t.color !== "transparent" && {
    backgroundColor: e.palette[t.color].main,
    color: e.palette[t.color].contrastText
  }, t.color === "inherit" && {
    color: "inherit"
  }, e.palette.mode === "dark" && !t.enableColorOnDark && {
    backgroundColor: null,
    color: null
  }, t.color === "transparent" && N({
    backgroundColor: "transparent",
    color: "inherit"
  }, e.palette.mode === "dark" && {
    backgroundImage: "none"
  })), e.vars && N({}, t.color === "default" && {
    "--AppBar-background": t.enableColorOnDark ? e.vars.palette.AppBar.defaultBg : B1(e.vars.palette.AppBar.darkBg, e.vars.palette.AppBar.defaultBg),
    "--AppBar-color": t.enableColorOnDark ? e.vars.palette.text.primary : B1(e.vars.palette.AppBar.darkColor, e.vars.palette.text.primary)
  }, t.color && !t.color.match(/^(default|inherit|transparent)$/) && {
    "--AppBar-background": t.enableColorOnDark ? e.vars.palette[t.color].main : B1(e.vars.palette.AppBar.darkBg, e.vars.palette[t.color].main),
    "--AppBar-color": t.enableColorOnDark ? e.vars.palette[t.color].contrastText : B1(e.vars.palette.AppBar.darkColor, e.vars.palette[t.color].contrastText)
  }, !["inherit", "transparent"].includes(t.color) && {
    backgroundColor: "var(--AppBar-background)"
  }, {
    color: t.color === "inherit" ? "inherit" : "var(--AppBar-color)"
  }, t.color === "transparent" && {
    backgroundImage: "none",
    backgroundColor: "transparent",
    color: "inherit"
  }));
}), Yb = /* @__PURE__ */ V.forwardRef(function(t, n) {
  const r = Ot({
    props: t,
    name: "MuiAppBar"
  }), {
    className: i,
    color: o = "primary",
    enableColorOnDark: s = !1,
    position: a = "fixed"
  } = r, u = _e(r, eLe), c = N({}, r, {
    color: o,
    position: a,
    enableColorOnDark: s
  }), d = tLe(c);
  return /* @__PURE__ */ P.jsx(nLe, N({
    square: !0,
    component: "header",
    ownerState: c,
    elevation: 4,
    className: Be(d.root, i, a === "fixed" && "mui-fixed"),
    ref: n
  }, u));
});
process.env.NODE_ENV !== "production" && (Yb.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: l.oneOfType([l.oneOf(["default", "inherit", "primary", "secondary", "transparent", "error", "info", "success", "warning"]), l.string]),
  /**
   * If true, the `color` prop is applied in dark mode.
   * @default false
   */
  enableColorOnDark: l.bool,
  /**
   * The positioning type. The behavior of the different options is described
   * [in the MDN web docs](https://developer.mozilla.org/en-US/docs/Learn/CSS/CSS_layout/Positioning).
   * Note: `sticky` is not universally supported and will fall back to `static` when unavailable.
   * @default 'fixed'
   */
  position: l.oneOf(["absolute", "fixed", "relative", "static", "sticky"]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
function s3(e) {
  return typeof e.normalize < "u" ? e.normalize("NFD").replace(/[\u0300-\u036f]/g, "") : e;
}
function rLe(e = {}) {
  const {
    ignoreAccents: t = !0,
    ignoreCase: n = !0,
    limit: r,
    matchFrom: i = "any",
    stringify: o,
    trim: s = !1
  } = e;
  return (a, {
    inputValue: u,
    getOptionLabel: c
  }) => {
    let d = s ? u.trim() : u;
    n && (d = d.toLowerCase()), t && (d = s3(d));
    const f = d ? a.filter((h) => {
      let m = (o || c)(h);
      return n && (m = m.toLowerCase()), t && (m = s3(m)), i === "start" ? m.indexOf(d) === 0 : m.indexOf(d) > -1;
    }) : a;
    return typeof r == "number" ? f.slice(0, r) : f;
  };
}
function j1(e, t) {
  for (let n = 0; n < e.length; n += 1)
    if (t(e[n]))
      return n;
  return -1;
}
const iLe = rLe(), a3 = 5, oLe = (e) => {
  var t;
  return e.current !== null && ((t = e.current.parentElement) == null ? void 0 : t.contains(document.activeElement));
};
function sLe(e) {
  const {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_isActiveElementInListbox: t = oLe,
    // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_classNamePrefix: n = "Mui",
    autoComplete: r = !1,
    autoHighlight: i = !1,
    autoSelect: o = !1,
    blurOnSelect: s = !1,
    clearOnBlur: a = !e.freeSolo,
    clearOnEscape: u = !1,
    componentName: c = "useAutocomplete",
    defaultValue: d = e.multiple ? [] : null,
    disableClearable: f = !1,
    disableCloseOnSelect: h = !1,
    disabled: m,
    disabledItemsFocusable: v = !1,
    disableListWrap: x = !1,
    filterOptions: C = iLe,
    filterSelectedOptions: E = !1,
    freeSolo: S = !1,
    getOptionDisabled: w,
    getOptionKey: O,
    getOptionLabel: A = (Oe) => {
      var Fe;
      return (Fe = Oe.label) != null ? Fe : Oe;
    },
    groupBy: I,
    handleHomeEndKeys: $ = !e.freeSolo,
    id: L,
    includeInputInList: B = !1,
    inputValue: H,
    isOptionEqualToValue: q = (Oe, Fe) => Oe === Fe,
    multiple: J = !1,
    onChange: X,
    onClose: j,
    onHighlightChange: U,
    onInputChange: G,
    onOpen: K,
    open: ee,
    openOnFocus: te = !1,
    options: M,
    readOnly: Z = !1,
    selectOnFocus: ne = !e.freeSolo,
    value: R
  } = e, _ = Pl(L);
  let W = A;
  W = (Oe) => {
    const Fe = A(Oe);
    if (typeof Fe != "string") {
      if (process.env.NODE_ENV !== "production") {
        const et = Fe === void 0 ? "undefined" : `${typeof Fe} (${Fe})`;
        console.error(`MUI: The \`getOptionLabel\` method of ${c} returned ${et} instead of a string for ${JSON.stringify(Oe)}.`);
      }
      return String(Fe);
    }
    return Fe;
  };
  const Q = V.useRef(!1), oe = V.useRef(!0), ae = V.useRef(null), pe = V.useRef(null), [me, xe] = V.useState(null), [le, ye] = V.useState(-1), be = i ? 0 : -1, Re = V.useRef(be), [Te, Xe] = Hi({
    controlled: R,
    default: d,
    name: c
  }), [Ne, Qe] = Hi({
    controlled: H,
    default: "",
    name: c,
    state: "inputValue"
  }), [Ee, Ie] = V.useState(!1), Je = V.useCallback((Oe, Fe) => {
    if (!(J ? Te.length < Fe.length : Fe !== null) && !a)
      return;
    let Ke;
    if (J)
      Ke = "";
    else if (Fe == null)
      Ke = "";
    else {
      const ct = W(Fe);
      Ke = typeof ct == "string" ? ct : "";
    }
    Ne !== Ke && (Qe(Ke), G && G(Oe, Ke, "reset"));
  }, [W, Ne, J, G, Qe, a, Te]), [vt, St] = Hi({
    controlled: ee,
    default: !1,
    name: c,
    state: "open"
  }), [Lt, ke] = V.useState(!0), Le = !J && Te != null && Ne === W(Te), Pe = vt && !Z, Ae = Pe ? C(
    M.filter((Oe) => !(E && (J ? Te : [Te]).some((Fe) => Fe !== null && q(Oe, Fe)))),
    // we use the empty string to manipulate `filterOptions` to not filter any options
    // i.e. the filter predicate always returns true
    {
      inputValue: Le && Lt ? "" : Ne,
      getOptionLabel: W
    }
  ) : [], We = HI({
    filteredOptions: Ae,
    value: Te,
    inputValue: Ne
  });
  V.useEffect(() => {
    const Oe = Te !== We.value;
    Ee && !Oe || S && !Oe || Je(null, Te);
  }, [Te, Je, Ee, We.value, S]);
  const At = vt && Ae.length > 0 && !Z;
  if (process.env.NODE_ENV !== "production" && Te !== null && !S && M.length > 0) {
    const Oe = (J ? Te : [Te]).filter((Fe) => !M.some((et) => q(et, Fe)));
    Oe.length > 0 && console.warn([`MUI: The value provided to ${c} is invalid.`, `None of the options match with \`${Oe.length > 1 ? JSON.stringify(Oe) : JSON.stringify(Oe[0])}\`.`, "You can use the `isOptionEqualToValue` prop to customize the equality test."].join(`
`));
  }
  const Ft = Mt((Oe) => {
    Oe === -1 ? ae.current.focus() : me.querySelector(`[data-tag-index="${Oe}"]`).focus();
  });
  V.useEffect(() => {
    J && le > Te.length - 1 && (ye(-1), Ft(-1));
  }, [Te, J, le, Ft]);
  function Ct(Oe, Fe) {
    if (!pe.current || Oe < 0 || Oe >= Ae.length)
      return -1;
    let et = Oe;
    for (; ; ) {
      const Ke = pe.current.querySelector(`[data-option-index="${et}"]`), ct = v ? !1 : !Ke || Ke.disabled || Ke.getAttribute("aria-disabled") === "true";
      if (Ke && Ke.hasAttribute("tabindex") && !ct)
        return et;
      if (Fe === "next" ? et = (et + 1) % Ae.length : et = (et - 1 + Ae.length) % Ae.length, et === Oe)
        return -1;
    }
  }
  const ht = Mt(({
    event: Oe,
    index: Fe,
    reason: et = "auto"
  }) => {
    if (Re.current = Fe, Fe === -1 ? ae.current.removeAttribute("aria-activedescendant") : ae.current.setAttribute("aria-activedescendant", `${_}-option-${Fe}`), U && U(Oe, Fe === -1 ? null : Ae[Fe], et), !pe.current)
      return;
    const Ke = pe.current.querySelector(`[role="option"].${n}-focused`);
    Ke && (Ke.classList.remove(`${n}-focused`), Ke.classList.remove(`${n}-focusVisible`));
    let ct = pe.current;
    if (pe.current.getAttribute("role") !== "listbox" && (ct = pe.current.parentElement.querySelector('[role="listbox"]')), !ct)
      return;
    if (Fe === -1) {
      ct.scrollTop = 0;
      return;
    }
    const gt = pe.current.querySelector(`[data-option-index="${Fe}"]`);
    if (gt && (gt.classList.add(`${n}-focused`), et === "keyboard" && gt.classList.add(`${n}-focusVisible`), ct.scrollHeight > ct.clientHeight && et !== "mouse" && et !== "touch")) {
      const Ht = gt, Pn = ct.clientHeight + ct.scrollTop, tr = Ht.offsetTop + Ht.offsetHeight;
      tr > Pn ? ct.scrollTop = tr - ct.clientHeight : Ht.offsetTop - Ht.offsetHeight * (I ? 1.3 : 0) < ct.scrollTop && (ct.scrollTop = Ht.offsetTop - Ht.offsetHeight * (I ? 1.3 : 0));
    }
  }), He = Mt(({
    event: Oe,
    diff: Fe,
    direction: et = "next",
    reason: Ke = "auto"
  }) => {
    if (!Pe)
      return;
    const gt = Ct((() => {
      const Ht = Ae.length - 1;
      if (Fe === "reset")
        return be;
      if (Fe === "start")
        return 0;
      if (Fe === "end")
        return Ht;
      const Pn = Re.current + Fe;
      return Pn < 0 ? Pn === -1 && B ? -1 : x && Re.current !== -1 || Math.abs(Fe) > 1 ? 0 : Ht : Pn > Ht ? Pn === Ht + 1 && B ? -1 : x || Math.abs(Fe) > 1 ? Ht : 0 : Pn;
    })(), et);
    if (ht({
      index: gt,
      reason: Ke,
      event: Oe
    }), r && Fe !== "reset")
      if (gt === -1)
        ae.current.value = Ne;
      else {
        const Ht = W(Ae[gt]);
        ae.current.value = Ht, Ht.toLowerCase().indexOf(Ne.toLowerCase()) === 0 && Ne.length > 0 && ae.current.setSelectionRange(Ne.length, Ht.length);
      }
  }), qe = () => {
    const Oe = (Fe, et) => {
      const Ke = Fe ? W(Fe) : "", ct = et ? W(et) : "";
      return Ke === ct;
    };
    if (Re.current !== -1 && We.filteredOptions && We.filteredOptions.length !== Ae.length && We.inputValue === Ne && (J ? Te.length === We.value.length && We.value.every((Fe, et) => W(Te[et]) === W(Fe)) : Oe(We.value, Te))) {
      const Fe = We.filteredOptions[Re.current];
      if (Fe)
        return j1(Ae, (et) => W(et) === W(Fe));
    }
    return -1;
  }, wt = V.useCallback(() => {
    if (!Pe)
      return;
    const Oe = qe();
    if (Oe !== -1) {
      Re.current = Oe;
      return;
    }
    const Fe = J ? Te[0] : Te;
    if (Ae.length === 0 || Fe == null) {
      He({
        diff: "reset"
      });
      return;
    }
    if (pe.current) {
      if (Fe != null) {
        const et = Ae[Re.current];
        if (J && et && j1(Te, (ct) => q(et, ct)) !== -1)
          return;
        const Ke = j1(Ae, (ct) => q(ct, Fe));
        Ke === -1 ? He({
          diff: "reset"
        }) : ht({
          index: Ke
        });
        return;
      }
      if (Re.current >= Ae.length - 1) {
        ht({
          index: Ae.length - 1
        });
        return;
      }
      ht({
        index: Re.current
      });
    }
  }, [
    // Only sync the highlighted index when the option switch between empty and not
    Ae.length,
    // Don't sync the highlighted index with the value when multiple
    // eslint-disable-next-line react-hooks/exhaustive-deps
    J ? !1 : Te,
    E,
    He,
    ht,
    Pe,
    Ne,
    J
  ]), Ut = Mt((Oe) => {
    _0(pe, Oe), Oe && wt();
  });
  process.env.NODE_ENV !== "production" && V.useEffect(() => {
    (!ae.current || ae.current.nodeName !== "INPUT") && (ae.current && ae.current.nodeName === "TEXTAREA" ? console.warn([`A textarea element was provided to ${c} where input was expected.`, "This is not a supported scenario but it may work under certain conditions.", "A textarea keyboard navigation may conflict with Autocomplete controls (for example enter and arrow keys).", "Make sure to test keyboard navigation and add custom event handlers if necessary."].join(`
`)) : console.error([`MUI: Unable to find the input element. It was resolved to ${ae.current} while an HTMLInputElement was expected.`, `Instead, ${c} expects an input element.`, "", c === "useAutocomplete" ? "Make sure you have bound getInputProps correctly and that the normal ref/effect resolutions order is guaranteed." : "Make sure you have customized the input component correctly."].join(`
`)));
  }, [c]), V.useEffect(() => {
    wt();
  }, [wt]);
  const an = (Oe) => {
    vt || (St(!0), ke(!0), K && K(Oe));
  }, wn = (Oe, Fe) => {
    vt && (St(!1), j && j(Oe, Fe));
  }, En = (Oe, Fe, et, Ke) => {
    if (J) {
      if (Te.length === Fe.length && Te.every((ct, gt) => ct === Fe[gt]))
        return;
    } else if (Te === Fe)
      return;
    X && X(Oe, Fe, et, Ke), Xe(Fe);
  }, sr = V.useRef(!1), er = (Oe, Fe, et = "selectOption", Ke = "options") => {
    let ct = et, gt = Fe;
    if (J) {
      if (gt = Array.isArray(Te) ? Te.slice() : [], process.env.NODE_ENV !== "production") {
        const Pn = gt.filter((tr) => q(Fe, tr));
        Pn.length > 1 && console.error([`MUI: The \`isOptionEqualToValue\` method of ${c} does not handle the arguments correctly.`, `The component expects a single value to match a given option but found ${Pn.length} matches.`].join(`
`));
      }
      const Ht = j1(gt, (Pn) => q(Fe, Pn));
      Ht === -1 ? gt.push(Fe) : Ke !== "freeSolo" && (gt.splice(Ht, 1), ct = "removeOption");
    }
    Je(Oe, gt), En(Oe, gt, ct, {
      option: Fe
    }), !h && (!Oe || !Oe.ctrlKey && !Oe.metaKey) && wn(Oe, ct), (s === !0 || s === "touch" && sr.current || s === "mouse" && !sr.current) && ae.current.blur();
  };
  function pn(Oe, Fe) {
    if (Oe === -1)
      return -1;
    let et = Oe;
    for (; ; ) {
      if (Fe === "next" && et === Te.length || Fe === "previous" && et === -1)
        return -1;
      const Ke = me.querySelector(`[data-tag-index="${et}"]`);
      if (!Ke || !Ke.hasAttribute("tabindex") || Ke.disabled || Ke.getAttribute("aria-disabled") === "true")
        et += Fe === "next" ? 1 : -1;
      else
        return et;
    }
  }
  const Pr = (Oe, Fe) => {
    if (!J)
      return;
    Ne === "" && wn(Oe, "toggleInput");
    let et = le;
    le === -1 ? Ne === "" && Fe === "previous" && (et = Te.length - 1) : (et += Fe === "next" ? 1 : -1, et < 0 && (et = 0), et === Te.length && (et = -1)), et = pn(et, Fe), ye(et), Ft(et);
  }, bi = (Oe) => {
    Q.current = !0, Qe(""), G && G(Oe, "", "clear"), En(Oe, J ? [] : null, "clear");
  }, Wr = (Oe) => (Fe) => {
    if (Oe.onKeyDown && Oe.onKeyDown(Fe), !Fe.defaultMuiPrevented && (le !== -1 && ["ArrowLeft", "ArrowRight"].indexOf(Fe.key) === -1 && (ye(-1), Ft(-1)), Fe.which !== 229))
      switch (Fe.key) {
        case "Home":
          Pe && $ && (Fe.preventDefault(), He({
            diff: "start",
            direction: "next",
            reason: "keyboard",
            event: Fe
          }));
          break;
        case "End":
          Pe && $ && (Fe.preventDefault(), He({
            diff: "end",
            direction: "previous",
            reason: "keyboard",
            event: Fe
          }));
          break;
        case "PageUp":
          Fe.preventDefault(), He({
            diff: -a3,
            direction: "previous",
            reason: "keyboard",
            event: Fe
          }), an(Fe);
          break;
        case "PageDown":
          Fe.preventDefault(), He({
            diff: a3,
            direction: "next",
            reason: "keyboard",
            event: Fe
          }), an(Fe);
          break;
        case "ArrowDown":
          Fe.preventDefault(), He({
            diff: 1,
            direction: "next",
            reason: "keyboard",
            event: Fe
          }), an(Fe);
          break;
        case "ArrowUp":
          Fe.preventDefault(), He({
            diff: -1,
            direction: "previous",
            reason: "keyboard",
            event: Fe
          }), an(Fe);
          break;
        case "ArrowLeft":
          Pr(Fe, "previous");
          break;
        case "ArrowRight":
          Pr(Fe, "next");
          break;
        case "Enter":
          if (Re.current !== -1 && Pe) {
            const et = Ae[Re.current], Ke = w ? w(et) : !1;
            if (Fe.preventDefault(), Ke)
              return;
            er(Fe, et, "selectOption"), r && ae.current.setSelectionRange(ae.current.value.length, ae.current.value.length);
          } else S && Ne !== "" && Le === !1 && (J && Fe.preventDefault(), er(Fe, Ne, "createOption", "freeSolo"));
          break;
        case "Escape":
          Pe ? (Fe.preventDefault(), Fe.stopPropagation(), wn(Fe, "escape")) : u && (Ne !== "" || J && Te.length > 0) && (Fe.preventDefault(), Fe.stopPropagation(), bi(Fe));
          break;
        case "Backspace":
          if (J && !Z && Ne === "" && Te.length > 0) {
            const et = le === -1 ? Te.length - 1 : le, Ke = Te.slice();
            Ke.splice(et, 1), En(Fe, Ke, "removeOption", {
              option: Te[et]
            });
          }
          break;
        case "Delete":
          if (J && !Z && Ne === "" && Te.length > 0 && le !== -1) {
            const et = le, Ke = Te.slice();
            Ke.splice(et, 1), En(Fe, Ke, "removeOption", {
              option: Te[et]
            });
          }
          break;
      }
  }, Po = (Oe) => {
    Ie(!0), te && !Q.current && an(Oe);
  }, _r = (Oe) => {
    if (t(pe)) {
      ae.current.focus();
      return;
    }
    Ie(!1), oe.current = !0, Q.current = !1, o && Re.current !== -1 && Pe ? er(Oe, Ae[Re.current], "blur") : o && S && Ne !== "" ? er(Oe, Ne, "blur", "freeSolo") : a && Je(Oe, Te), wn(Oe, "blur");
  }, Lr = (Oe) => {
    const Fe = Oe.target.value;
    Ne !== Fe && (Qe(Fe), ke(!1), G && G(Oe, Fe, "input")), Fe === "" ? !f && !J && En(Oe, null, "clear") : an(Oe);
  }, Gn = (Oe) => {
    const Fe = Number(Oe.currentTarget.getAttribute("data-option-index"));
    Re.current !== Fe && ht({
      event: Oe,
      index: Fe,
      reason: "mouse"
    });
  }, Hr = (Oe) => {
    ht({
      event: Oe,
      index: Number(Oe.currentTarget.getAttribute("data-option-index")),
      reason: "touch"
    }), sr.current = !0;
  }, Qn = (Oe) => {
    const Fe = Number(Oe.currentTarget.getAttribute("data-option-index"));
    er(Oe, Ae[Fe], "selectOption"), sr.current = !1;
  }, ao = (Oe) => (Fe) => {
    const et = Te.slice();
    et.splice(Oe, 1), En(Fe, et, "removeOption", {
      option: Te[Oe]
    });
  }, Ls = (Oe) => {
    vt ? wn(Oe, "toggleInput") : an(Oe);
  }, Mi = (Oe) => {
    Oe.currentTarget.contains(Oe.target) && Oe.target.getAttribute("id") !== _ && Oe.preventDefault();
  }, ko = (Oe) => {
    Oe.currentTarget.contains(Oe.target) && (ae.current.focus(), ne && oe.current && ae.current.selectionEnd - ae.current.selectionStart === 0 && ae.current.select(), oe.current = !1);
  }, ve = (Oe) => {
    !m && (Ne === "" || !vt) && Ls(Oe);
  };
  let tt = S && Ne.length > 0;
  tt = tt || (J ? Te.length > 0 : Te !== null);
  let xt = Ae;
  if (I) {
    const Oe = /* @__PURE__ */ new Map();
    let Fe = !1;
    xt = Ae.reduce((et, Ke, ct) => {
      const gt = I(Ke);
      return et.length > 0 && et[et.length - 1].group === gt ? et[et.length - 1].options.push(Ke) : (process.env.NODE_ENV !== "production" && (Oe.get(gt) && !Fe && (console.warn(`MUI: The options provided combined with the \`groupBy\` method of ${c} returns duplicated headers.`, "You can solve the issue by sorting the options with the output of `groupBy`."), Fe = !0), Oe.set(gt, !0)), et.push({
        key: ct,
        index: ct,
        group: gt,
        options: [Ke]
      })), et;
    }, []);
  }
  return m && Ee && _r(), {
    getRootProps: (Oe = {}) => N({
      "aria-owns": At ? `${_}-listbox` : null
    }, Oe, {
      onKeyDown: Wr(Oe),
      onMouseDown: Mi,
      onClick: ko
    }),
    getInputLabelProps: () => ({
      id: `${_}-label`,
      htmlFor: _
    }),
    getInputProps: () => ({
      id: _,
      value: Ne,
      onBlur: _r,
      onFocus: Po,
      onChange: Lr,
      onMouseDown: ve,
      // if open then this is handled imperatively so don't let react override
      // only have an opinion about this when closed
      "aria-activedescendant": Pe ? "" : null,
      "aria-autocomplete": r ? "both" : "list",
      "aria-controls": At ? `${_}-listbox` : void 0,
      "aria-expanded": At,
      // Disable browser's suggestion that might overlap with the popup.
      // Handle autocomplete but not autofill.
      autoComplete: "off",
      ref: ae,
      autoCapitalize: "none",
      spellCheck: "false",
      role: "combobox",
      disabled: m
    }),
    getClearProps: () => ({
      tabIndex: -1,
      type: "button",
      onClick: bi
    }),
    getPopupIndicatorProps: () => ({
      tabIndex: -1,
      type: "button",
      onClick: Ls
    }),
    getTagProps: ({
      index: Oe
    }) => N({
      key: Oe,
      "data-tag-index": Oe,
      tabIndex: -1
    }, !Z && {
      onDelete: ao(Oe)
    }),
    getListboxProps: () => ({
      role: "listbox",
      id: `${_}-listbox`,
      "aria-labelledby": `${_}-label`,
      ref: Ut,
      onMouseDown: (Oe) => {
        Oe.preventDefault();
      }
    }),
    getOptionProps: ({
      index: Oe,
      option: Fe
    }) => {
      var et;
      const Ke = (J ? Te : [Te]).some((gt) => gt != null && q(Fe, gt)), ct = w ? w(Fe) : !1;
      return {
        key: (et = O == null ? void 0 : O(Fe)) != null ? et : W(Fe),
        tabIndex: -1,
        role: "option",
        id: `${_}-option-${Oe}`,
        onMouseMove: Gn,
        onClick: Qn,
        onTouchStart: Hr,
        "data-option-index": Oe,
        "aria-disabled": ct,
        "aria-selected": Ke
      };
    },
    id: _,
    inputValue: Ne,
    value: Te,
    dirty: tt,
    expanded: Pe && me,
    popupOpen: Pe,
    focused: Ee || le !== -1,
    anchorEl: me,
    setAnchorEl: xe,
    focusedTag: le,
    groupedOptions: xt
  };
}
var rF = {};
Object.defineProperty(rF, "__esModule", {
  value: !0
});
var TU = rF.default = void 0, aLe = uLe(se), lLe = hU;
function SU(e) {
  if (typeof WeakMap != "function") return null;
  var t = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap();
  return (SU = function(r) {
    return r ? n : t;
  })(e);
}
function uLe(e, t) {
  if (e && e.__esModule) return e;
  if (e === null || typeof e != "object" && typeof e != "function") return { default: e };
  var n = SU(t);
  if (n && n.has(e)) return n.get(e);
  var r = { __proto__: null }, i = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var o in e) if (o !== "default" && Object.prototype.hasOwnProperty.call(e, o)) {
    var s = i ? Object.getOwnPropertyDescriptor(e, o) : null;
    s && (s.get || s.set) ? Object.defineProperty(r, o, s) : r[o] = e[o];
  }
  return r.default = e, n && n.set(e, r), r;
}
function cLe(e) {
  return Object.keys(e).length === 0;
}
function dLe(e = null) {
  const t = aLe.useContext(lLe.ThemeContext);
  return !t || cLe(t) ? e : t;
}
TU = rF.default = dLe;
var As = "top", Va = "bottom", za = "right", ws = "left", iF = "auto", Kb = [As, Va, za, ws], fm = "start", B0 = "end", pLe = "clippingParents", AU = "viewport", Ty = "popper", fLe = "reference", l3 = /* @__PURE__ */ Kb.reduce(function(e, t) {
  return e.concat([t + "-" + fm, t + "-" + B0]);
}, []), wU = /* @__PURE__ */ [].concat(Kb, [iF]).reduce(function(e, t) {
  return e.concat([t, t + "-" + fm, t + "-" + B0]);
}, []), hLe = "beforeRead", mLe = "read", gLe = "afterRead", yLe = "beforeMain", bLe = "main", vLe = "afterMain", xLe = "beforeWrite", DLe = "write", CLe = "afterWrite", ELe = [hLe, mLe, gLe, yLe, bLe, vLe, xLe, DLe, CLe];
function vu(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function aa(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function Jp(e) {
  var t = aa(e).Element;
  return e instanceof t || e instanceof Element;
}
function Ma(e) {
  var t = aa(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function oF(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var t = aa(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function TLe(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(n) {
    var r = t.styles[n] || {}, i = t.attributes[n] || {}, o = t.elements[n];
    !Ma(o) || !vu(o) || (Object.assign(o.style, r), Object.keys(i).forEach(function(s) {
      var a = i[s];
      a === !1 ? o.removeAttribute(s) : o.setAttribute(s, a === !0 ? "" : a);
    }));
  });
}
function SLe(e) {
  var t = e.state, n = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, n.popper), t.styles = n, t.elements.arrow && Object.assign(t.elements.arrow.style, n.arrow), function() {
    Object.keys(t.elements).forEach(function(r) {
      var i = t.elements[r], o = t.attributes[r] || {}, s = Object.keys(t.styles.hasOwnProperty(r) ? t.styles[r] : n[r]), a = s.reduce(function(u, c) {
        return u[c] = "", u;
      }, {});
      !Ma(i) || !vu(i) || (Object.assign(i.style, a), Object.keys(o).forEach(function(u) {
        i.removeAttribute(u);
      }));
    });
  };
}
const ALe = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: TLe,
  effect: SLe,
  requires: ["computeStyles"]
};
function uu(e) {
  return e.split("-")[0];
}
var Lp = Math.max, qD = Math.min, hm = Math.round;
function JP() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(t) {
    return t.brand + "/" + t.version;
  }).join(" ") : navigator.userAgent;
}
function PU() {
  return !/^((?!chrome|android).)*safari/i.test(JP());
}
function mm(e, t, n) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  var r = e.getBoundingClientRect(), i = 1, o = 1;
  t && Ma(e) && (i = e.offsetWidth > 0 && hm(r.width) / e.offsetWidth || 1, o = e.offsetHeight > 0 && hm(r.height) / e.offsetHeight || 1);
  var s = Jp(e) ? aa(e) : window, a = s.visualViewport, u = !PU() && n, c = (r.left + (u && a ? a.offsetLeft : 0)) / i, d = (r.top + (u && a ? a.offsetTop : 0)) / o, f = r.width / i, h = r.height / o;
  return {
    width: f,
    height: h,
    top: d,
    right: c + f,
    bottom: d + h,
    left: c,
    x: c,
    y: d
  };
}
function sF(e) {
  var t = mm(e), n = e.offsetWidth, r = e.offsetHeight;
  return Math.abs(t.width - n) <= 1 && (n = t.width), Math.abs(t.height - r) <= 1 && (r = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: n,
    height: r
  };
}
function kU(e, t) {
  var n = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (n && oF(n)) {
    var r = t;
    do {
      if (r && e.isSameNode(r))
        return !0;
      r = r.parentNode || r.host;
    } while (r);
  }
  return !1;
}
function ac(e) {
  return aa(e).getComputedStyle(e);
}
function wLe(e) {
  return ["table", "td", "th"].indexOf(vu(e)) >= 0;
}
function Ad(e) {
  return ((Jp(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function NE(e) {
  return vu(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (oF(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    Ad(e)
  );
}
function u3(e) {
  return !Ma(e) || // https://github.com/popperjs/popper-core/issues/837
  ac(e).position === "fixed" ? null : e.offsetParent;
}
function PLe(e) {
  var t = /firefox/i.test(JP()), n = /Trident/i.test(JP());
  if (n && Ma(e)) {
    var r = ac(e);
    if (r.position === "fixed")
      return null;
  }
  var i = NE(e);
  for (oF(i) && (i = i.host); Ma(i) && ["html", "body"].indexOf(vu(i)) < 0; ) {
    var o = ac(i);
    if (o.transform !== "none" || o.perspective !== "none" || o.contain === "paint" || ["transform", "perspective"].indexOf(o.willChange) !== -1 || t && o.willChange === "filter" || t && o.filter && o.filter !== "none")
      return i;
    i = i.parentNode;
  }
  return null;
}
function Jb(e) {
  for (var t = aa(e), n = u3(e); n && wLe(n) && ac(n).position === "static"; )
    n = u3(n);
  return n && (vu(n) === "html" || vu(n) === "body" && ac(n).position === "static") ? t : n || PLe(e) || t;
}
function aF(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function l0(e, t, n) {
  return Lp(e, qD(t, n));
}
function kLe(e, t, n) {
  var r = l0(e, t, n);
  return r > n ? n : r;
}
function OU() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function IU(e) {
  return Object.assign({}, OU(), e);
}
function FU(e, t) {
  return t.reduce(function(n, r) {
    return n[r] = e, n;
  }, {});
}
var OLe = function(t, n) {
  return t = typeof t == "function" ? t(Object.assign({}, n.rects, {
    placement: n.placement
  })) : t, IU(typeof t != "number" ? t : FU(t, Kb));
};
function ILe(e) {
  var t, n = e.state, r = e.name, i = e.options, o = n.elements.arrow, s = n.modifiersData.popperOffsets, a = uu(n.placement), u = aF(a), c = [ws, za].indexOf(a) >= 0, d = c ? "height" : "width";
  if (!(!o || !s)) {
    var f = OLe(i.padding, n), h = sF(o), m = u === "y" ? As : ws, v = u === "y" ? Va : za, x = n.rects.reference[d] + n.rects.reference[u] - s[u] - n.rects.popper[d], C = s[u] - n.rects.reference[u], E = Jb(o), S = E ? u === "y" ? E.clientHeight || 0 : E.clientWidth || 0 : 0, w = x / 2 - C / 2, O = f[m], A = S - h[d] - f[v], I = S / 2 - h[d] / 2 + w, $ = l0(O, I, A), L = u;
    n.modifiersData[r] = (t = {}, t[L] = $, t.centerOffset = $ - I, t);
  }
}
function FLe(e) {
  var t = e.state, n = e.options, r = n.element, i = r === void 0 ? "[data-popper-arrow]" : r;
  i != null && (typeof i == "string" && (i = t.elements.popper.querySelector(i), !i) || kU(t.elements.popper, i) && (t.elements.arrow = i));
}
const $Le = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: ILe,
  effect: FLe,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function gm(e) {
  return e.split("-")[1];
}
var NLe = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function MLe(e, t) {
  var n = e.x, r = e.y, i = t.devicePixelRatio || 1;
  return {
    x: hm(n * i) / i || 0,
    y: hm(r * i) / i || 0
  };
}
function c3(e) {
  var t, n = e.popper, r = e.popperRect, i = e.placement, o = e.variation, s = e.offsets, a = e.position, u = e.gpuAcceleration, c = e.adaptive, d = e.roundOffsets, f = e.isFixed, h = s.x, m = h === void 0 ? 0 : h, v = s.y, x = v === void 0 ? 0 : v, C = typeof d == "function" ? d({
    x: m,
    y: x
  }) : {
    x: m,
    y: x
  };
  m = C.x, x = C.y;
  var E = s.hasOwnProperty("x"), S = s.hasOwnProperty("y"), w = ws, O = As, A = window;
  if (c) {
    var I = Jb(n), $ = "clientHeight", L = "clientWidth";
    if (I === aa(n) && (I = Ad(n), ac(I).position !== "static" && a === "absolute" && ($ = "scrollHeight", L = "scrollWidth")), I = I, i === As || (i === ws || i === za) && o === B0) {
      O = Va;
      var B = f && I === A && A.visualViewport ? A.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        I[$]
      );
      x -= B - r.height, x *= u ? 1 : -1;
    }
    if (i === ws || (i === As || i === Va) && o === B0) {
      w = za;
      var H = f && I === A && A.visualViewport ? A.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        I[L]
      );
      m -= H - r.width, m *= u ? 1 : -1;
    }
  }
  var q = Object.assign({
    position: a
  }, c && NLe), J = d === !0 ? MLe({
    x: m,
    y: x
  }, aa(n)) : {
    x: m,
    y: x
  };
  if (m = J.x, x = J.y, u) {
    var X;
    return Object.assign({}, q, (X = {}, X[O] = S ? "0" : "", X[w] = E ? "0" : "", X.transform = (A.devicePixelRatio || 1) <= 1 ? "translate(" + m + "px, " + x + "px)" : "translate3d(" + m + "px, " + x + "px, 0)", X));
  }
  return Object.assign({}, q, (t = {}, t[O] = S ? x + "px" : "", t[w] = E ? m + "px" : "", t.transform = "", t));
}
function RLe(e) {
  var t = e.state, n = e.options, r = n.gpuAcceleration, i = r === void 0 ? !0 : r, o = n.adaptive, s = o === void 0 ? !0 : o, a = n.roundOffsets, u = a === void 0 ? !0 : a, c = {
    placement: uu(t.placement),
    variation: gm(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: i,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, c3(Object.assign({}, c, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: s,
    roundOffsets: u
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, c3(Object.assign({}, c, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: u
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
const _Le = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: RLe,
  data: {}
};
var V1 = {
  passive: !0
};
function LLe(e) {
  var t = e.state, n = e.instance, r = e.options, i = r.scroll, o = i === void 0 ? !0 : i, s = r.resize, a = s === void 0 ? !0 : s, u = aa(t.elements.popper), c = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return o && c.forEach(function(d) {
    d.addEventListener("scroll", n.update, V1);
  }), a && u.addEventListener("resize", n.update, V1), function() {
    o && c.forEach(function(d) {
      d.removeEventListener("scroll", n.update, V1);
    }), a && u.removeEventListener("resize", n.update, V1);
  };
}
const BLe = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: LLe,
  data: {}
};
var jLe = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function Qx(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return jLe[t];
  });
}
var VLe = {
  start: "end",
  end: "start"
};
function d3(e) {
  return e.replace(/start|end/g, function(t) {
    return VLe[t];
  });
}
function lF(e) {
  var t = aa(e), n = t.pageXOffset, r = t.pageYOffset;
  return {
    scrollLeft: n,
    scrollTop: r
  };
}
function uF(e) {
  return mm(Ad(e)).left + lF(e).scrollLeft;
}
function zLe(e, t) {
  var n = aa(e), r = Ad(e), i = n.visualViewport, o = r.clientWidth, s = r.clientHeight, a = 0, u = 0;
  if (i) {
    o = i.width, s = i.height;
    var c = PU();
    (c || !c && t === "fixed") && (a = i.offsetLeft, u = i.offsetTop);
  }
  return {
    width: o,
    height: s,
    x: a + uF(e),
    y: u
  };
}
function ULe(e) {
  var t, n = Ad(e), r = lF(e), i = (t = e.ownerDocument) == null ? void 0 : t.body, o = Lp(n.scrollWidth, n.clientWidth, i ? i.scrollWidth : 0, i ? i.clientWidth : 0), s = Lp(n.scrollHeight, n.clientHeight, i ? i.scrollHeight : 0, i ? i.clientHeight : 0), a = -r.scrollLeft + uF(e), u = -r.scrollTop;
  return ac(i || n).direction === "rtl" && (a += Lp(n.clientWidth, i ? i.clientWidth : 0) - o), {
    width: o,
    height: s,
    x: a,
    y: u
  };
}
function cF(e) {
  var t = ac(e), n = t.overflow, r = t.overflowX, i = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(n + i + r);
}
function $U(e) {
  return ["html", "body", "#document"].indexOf(vu(e)) >= 0 ? e.ownerDocument.body : Ma(e) && cF(e) ? e : $U(NE(e));
}
function u0(e, t) {
  var n;
  t === void 0 && (t = []);
  var r = $U(e), i = r === ((n = e.ownerDocument) == null ? void 0 : n.body), o = aa(r), s = i ? [o].concat(o.visualViewport || [], cF(r) ? r : []) : r, a = t.concat(s);
  return i ? a : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    a.concat(u0(NE(s)))
  );
}
function XP(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function WLe(e, t) {
  var n = mm(e, !1, t === "fixed");
  return n.top = n.top + e.clientTop, n.left = n.left + e.clientLeft, n.bottom = n.top + e.clientHeight, n.right = n.left + e.clientWidth, n.width = e.clientWidth, n.height = e.clientHeight, n.x = n.left, n.y = n.top, n;
}
function p3(e, t, n) {
  return t === AU ? XP(zLe(e, n)) : Jp(t) ? WLe(t, n) : XP(ULe(Ad(e)));
}
function HLe(e) {
  var t = u0(NE(e)), n = ["absolute", "fixed"].indexOf(ac(e).position) >= 0, r = n && Ma(e) ? Jb(e) : e;
  return Jp(r) ? t.filter(function(i) {
    return Jp(i) && kU(i, r) && vu(i) !== "body";
  }) : [];
}
function qLe(e, t, n, r) {
  var i = t === "clippingParents" ? HLe(e) : [].concat(t), o = [].concat(i, [n]), s = o[0], a = o.reduce(function(u, c) {
    var d = p3(e, c, r);
    return u.top = Lp(d.top, u.top), u.right = qD(d.right, u.right), u.bottom = qD(d.bottom, u.bottom), u.left = Lp(d.left, u.left), u;
  }, p3(e, s, r));
  return a.width = a.right - a.left, a.height = a.bottom - a.top, a.x = a.left, a.y = a.top, a;
}
function NU(e) {
  var t = e.reference, n = e.element, r = e.placement, i = r ? uu(r) : null, o = r ? gm(r) : null, s = t.x + t.width / 2 - n.width / 2, a = t.y + t.height / 2 - n.height / 2, u;
  switch (i) {
    case As:
      u = {
        x: s,
        y: t.y - n.height
      };
      break;
    case Va:
      u = {
        x: s,
        y: t.y + t.height
      };
      break;
    case za:
      u = {
        x: t.x + t.width,
        y: a
      };
      break;
    case ws:
      u = {
        x: t.x - n.width,
        y: a
      };
      break;
    default:
      u = {
        x: t.x,
        y: t.y
      };
  }
  var c = i ? aF(i) : null;
  if (c != null) {
    var d = c === "y" ? "height" : "width";
    switch (o) {
      case fm:
        u[c] = u[c] - (t[d] / 2 - n[d] / 2);
        break;
      case B0:
        u[c] = u[c] + (t[d] / 2 - n[d] / 2);
        break;
    }
  }
  return u;
}
function j0(e, t) {
  t === void 0 && (t = {});
  var n = t, r = n.placement, i = r === void 0 ? e.placement : r, o = n.strategy, s = o === void 0 ? e.strategy : o, a = n.boundary, u = a === void 0 ? pLe : a, c = n.rootBoundary, d = c === void 0 ? AU : c, f = n.elementContext, h = f === void 0 ? Ty : f, m = n.altBoundary, v = m === void 0 ? !1 : m, x = n.padding, C = x === void 0 ? 0 : x, E = IU(typeof C != "number" ? C : FU(C, Kb)), S = h === Ty ? fLe : Ty, w = e.rects.popper, O = e.elements[v ? S : h], A = qLe(Jp(O) ? O : O.contextElement || Ad(e.elements.popper), u, d, s), I = mm(e.elements.reference), $ = NU({
    reference: I,
    element: w,
    strategy: "absolute",
    placement: i
  }), L = XP(Object.assign({}, w, $)), B = h === Ty ? L : I, H = {
    top: A.top - B.top + E.top,
    bottom: B.bottom - A.bottom + E.bottom,
    left: A.left - B.left + E.left,
    right: B.right - A.right + E.right
  }, q = e.modifiersData.offset;
  if (h === Ty && q) {
    var J = q[i];
    Object.keys(H).forEach(function(X) {
      var j = [za, Va].indexOf(X) >= 0 ? 1 : -1, U = [As, Va].indexOf(X) >= 0 ? "y" : "x";
      H[X] += J[U] * j;
    });
  }
  return H;
}
function GLe(e, t) {
  t === void 0 && (t = {});
  var n = t, r = n.placement, i = n.boundary, o = n.rootBoundary, s = n.padding, a = n.flipVariations, u = n.allowedAutoPlacements, c = u === void 0 ? wU : u, d = gm(r), f = d ? a ? l3 : l3.filter(function(v) {
    return gm(v) === d;
  }) : Kb, h = f.filter(function(v) {
    return c.indexOf(v) >= 0;
  });
  h.length === 0 && (h = f);
  var m = h.reduce(function(v, x) {
    return v[x] = j0(e, {
      placement: x,
      boundary: i,
      rootBoundary: o,
      padding: s
    })[uu(x)], v;
  }, {});
  return Object.keys(m).sort(function(v, x) {
    return m[v] - m[x];
  });
}
function YLe(e) {
  if (uu(e) === iF)
    return [];
  var t = Qx(e);
  return [d3(e), t, d3(t)];
}
function KLe(e) {
  var t = e.state, n = e.options, r = e.name;
  if (!t.modifiersData[r]._skip) {
    for (var i = n.mainAxis, o = i === void 0 ? !0 : i, s = n.altAxis, a = s === void 0 ? !0 : s, u = n.fallbackPlacements, c = n.padding, d = n.boundary, f = n.rootBoundary, h = n.altBoundary, m = n.flipVariations, v = m === void 0 ? !0 : m, x = n.allowedAutoPlacements, C = t.options.placement, E = uu(C), S = E === C, w = u || (S || !v ? [Qx(C)] : YLe(C)), O = [C].concat(w).reduce(function(_, W) {
      return _.concat(uu(W) === iF ? GLe(t, {
        placement: W,
        boundary: d,
        rootBoundary: f,
        padding: c,
        flipVariations: v,
        allowedAutoPlacements: x
      }) : W);
    }, []), A = t.rects.reference, I = t.rects.popper, $ = /* @__PURE__ */ new Map(), L = !0, B = O[0], H = 0; H < O.length; H++) {
      var q = O[H], J = uu(q), X = gm(q) === fm, j = [As, Va].indexOf(J) >= 0, U = j ? "width" : "height", G = j0(t, {
        placement: q,
        boundary: d,
        rootBoundary: f,
        altBoundary: h,
        padding: c
      }), K = j ? X ? za : ws : X ? Va : As;
      A[U] > I[U] && (K = Qx(K));
      var ee = Qx(K), te = [];
      if (o && te.push(G[J] <= 0), a && te.push(G[K] <= 0, G[ee] <= 0), te.every(function(_) {
        return _;
      })) {
        B = q, L = !1;
        break;
      }
      $.set(q, te);
    }
    if (L)
      for (var M = v ? 3 : 1, Z = function(W) {
        var Q = O.find(function(oe) {
          var ae = $.get(oe);
          if (ae)
            return ae.slice(0, W).every(function(pe) {
              return pe;
            });
        });
        if (Q)
          return B = Q, "break";
      }, ne = M; ne > 0; ne--) {
        var R = Z(ne);
        if (R === "break") break;
      }
    t.placement !== B && (t.modifiersData[r]._skip = !0, t.placement = B, t.reset = !0);
  }
}
const JLe = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: KLe,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function f3(e, t, n) {
  return n === void 0 && (n = {
    x: 0,
    y: 0
  }), {
    top: e.top - t.height - n.y,
    right: e.right - t.width + n.x,
    bottom: e.bottom - t.height + n.y,
    left: e.left - t.width - n.x
  };
}
function h3(e) {
  return [As, za, Va, ws].some(function(t) {
    return e[t] >= 0;
  });
}
function XLe(e) {
  var t = e.state, n = e.name, r = t.rects.reference, i = t.rects.popper, o = t.modifiersData.preventOverflow, s = j0(t, {
    elementContext: "reference"
  }), a = j0(t, {
    altBoundary: !0
  }), u = f3(s, r), c = f3(a, i, o), d = h3(u), f = h3(c);
  t.modifiersData[n] = {
    referenceClippingOffsets: u,
    popperEscapeOffsets: c,
    isReferenceHidden: d,
    hasPopperEscaped: f
  }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-reference-hidden": d,
    "data-popper-escaped": f
  });
}
const QLe = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: XLe
};
function ZLe(e, t, n) {
  var r = uu(e), i = [ws, As].indexOf(r) >= 0 ? -1 : 1, o = typeof n == "function" ? n(Object.assign({}, t, {
    placement: e
  })) : n, s = o[0], a = o[1];
  return s = s || 0, a = (a || 0) * i, [ws, za].indexOf(r) >= 0 ? {
    x: a,
    y: s
  } : {
    x: s,
    y: a
  };
}
function eBe(e) {
  var t = e.state, n = e.options, r = e.name, i = n.offset, o = i === void 0 ? [0, 0] : i, s = wU.reduce(function(d, f) {
    return d[f] = ZLe(f, t.rects, o), d;
  }, {}), a = s[t.placement], u = a.x, c = a.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += u, t.modifiersData.popperOffsets.y += c), t.modifiersData[r] = s;
}
const tBe = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: eBe
};
function nBe(e) {
  var t = e.state, n = e.name;
  t.modifiersData[n] = NU({
    reference: t.rects.reference,
    element: t.rects.popper,
    strategy: "absolute",
    placement: t.placement
  });
}
const rBe = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: nBe,
  data: {}
};
function iBe(e) {
  return e === "x" ? "y" : "x";
}
function oBe(e) {
  var t = e.state, n = e.options, r = e.name, i = n.mainAxis, o = i === void 0 ? !0 : i, s = n.altAxis, a = s === void 0 ? !1 : s, u = n.boundary, c = n.rootBoundary, d = n.altBoundary, f = n.padding, h = n.tether, m = h === void 0 ? !0 : h, v = n.tetherOffset, x = v === void 0 ? 0 : v, C = j0(t, {
    boundary: u,
    rootBoundary: c,
    padding: f,
    altBoundary: d
  }), E = uu(t.placement), S = gm(t.placement), w = !S, O = aF(E), A = iBe(O), I = t.modifiersData.popperOffsets, $ = t.rects.reference, L = t.rects.popper, B = typeof x == "function" ? x(Object.assign({}, t.rects, {
    placement: t.placement
  })) : x, H = typeof B == "number" ? {
    mainAxis: B,
    altAxis: B
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, B), q = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, J = {
    x: 0,
    y: 0
  };
  if (I) {
    if (o) {
      var X, j = O === "y" ? As : ws, U = O === "y" ? Va : za, G = O === "y" ? "height" : "width", K = I[O], ee = K + C[j], te = K - C[U], M = m ? -L[G] / 2 : 0, Z = S === fm ? $[G] : L[G], ne = S === fm ? -L[G] : -$[G], R = t.elements.arrow, _ = m && R ? sF(R) : {
        width: 0,
        height: 0
      }, W = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : OU(), Q = W[j], oe = W[U], ae = l0(0, $[G], _[G]), pe = w ? $[G] / 2 - M - ae - Q - H.mainAxis : Z - ae - Q - H.mainAxis, me = w ? -$[G] / 2 + M + ae + oe + H.mainAxis : ne + ae + oe + H.mainAxis, xe = t.elements.arrow && Jb(t.elements.arrow), le = xe ? O === "y" ? xe.clientTop || 0 : xe.clientLeft || 0 : 0, ye = (X = q == null ? void 0 : q[O]) != null ? X : 0, be = K + pe - ye - le, Re = K + me - ye, Te = l0(m ? qD(ee, be) : ee, K, m ? Lp(te, Re) : te);
      I[O] = Te, J[O] = Te - K;
    }
    if (a) {
      var Xe, Ne = O === "x" ? As : ws, Qe = O === "x" ? Va : za, Ee = I[A], Ie = A === "y" ? "height" : "width", Je = Ee + C[Ne], vt = Ee - C[Qe], St = [As, ws].indexOf(E) !== -1, Lt = (Xe = q == null ? void 0 : q[A]) != null ? Xe : 0, ke = St ? Je : Ee - $[Ie] - L[Ie] - Lt + H.altAxis, Le = St ? Ee + $[Ie] + L[Ie] - Lt - H.altAxis : vt, Pe = m && St ? kLe(ke, Ee, Le) : l0(m ? ke : Je, Ee, m ? Le : vt);
      I[A] = Pe, J[A] = Pe - Ee;
    }
    t.modifiersData[r] = J;
  }
}
const sBe = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: oBe,
  requiresIfExists: ["offset"]
};
function aBe(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function lBe(e) {
  return e === aa(e) || !Ma(e) ? lF(e) : aBe(e);
}
function uBe(e) {
  var t = e.getBoundingClientRect(), n = hm(t.width) / e.offsetWidth || 1, r = hm(t.height) / e.offsetHeight || 1;
  return n !== 1 || r !== 1;
}
function cBe(e, t, n) {
  n === void 0 && (n = !1);
  var r = Ma(t), i = Ma(t) && uBe(t), o = Ad(t), s = mm(e, i, n), a = {
    scrollLeft: 0,
    scrollTop: 0
  }, u = {
    x: 0,
    y: 0
  };
  return (r || !r && !n) && ((vu(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  cF(o)) && (a = lBe(t)), Ma(t) ? (u = mm(t, !0), u.x += t.clientLeft, u.y += t.clientTop) : o && (u.x = uF(o))), {
    x: s.left + a.scrollLeft - u.x,
    y: s.top + a.scrollTop - u.y,
    width: s.width,
    height: s.height
  };
}
function dBe(e) {
  var t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set(), r = [];
  e.forEach(function(o) {
    t.set(o.name, o);
  });
  function i(o) {
    n.add(o.name);
    var s = [].concat(o.requires || [], o.requiresIfExists || []);
    s.forEach(function(a) {
      if (!n.has(a)) {
        var u = t.get(a);
        u && i(u);
      }
    }), r.push(o);
  }
  return e.forEach(function(o) {
    n.has(o.name) || i(o);
  }), r;
}
function pBe(e) {
  var t = dBe(e);
  return ELe.reduce(function(n, r) {
    return n.concat(t.filter(function(i) {
      return i.phase === r;
    }));
  }, []);
}
function fBe(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(n) {
      Promise.resolve().then(function() {
        t = void 0, n(e());
      });
    })), t;
  };
}
function hBe(e) {
  var t = e.reduce(function(n, r) {
    var i = n[r.name];
    return n[r.name] = i ? Object.assign({}, i, r, {
      options: Object.assign({}, i.options, r.options),
      data: Object.assign({}, i.data, r.data)
    }) : r, n;
  }, {});
  return Object.keys(t).map(function(n) {
    return t[n];
  });
}
var m3 = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function g3() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return !t.some(function(r) {
    return !(r && typeof r.getBoundingClientRect == "function");
  });
}
function mBe(e) {
  e === void 0 && (e = {});
  var t = e, n = t.defaultModifiers, r = n === void 0 ? [] : n, i = t.defaultOptions, o = i === void 0 ? m3 : i;
  return function(a, u, c) {
    c === void 0 && (c = o);
    var d = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, m3, o),
      modifiersData: {},
      elements: {
        reference: a,
        popper: u
      },
      attributes: {},
      styles: {}
    }, f = [], h = !1, m = {
      state: d,
      setOptions: function(E) {
        var S = typeof E == "function" ? E(d.options) : E;
        x(), d.options = Object.assign({}, o, d.options, S), d.scrollParents = {
          reference: Jp(a) ? u0(a) : a.contextElement ? u0(a.contextElement) : [],
          popper: u0(u)
        };
        var w = pBe(hBe([].concat(r, d.options.modifiers)));
        return d.orderedModifiers = w.filter(function(O) {
          return O.enabled;
        }), v(), m.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!h) {
          var E = d.elements, S = E.reference, w = E.popper;
          if (g3(S, w)) {
            d.rects = {
              reference: cBe(S, Jb(w), d.options.strategy === "fixed"),
              popper: sF(w)
            }, d.reset = !1, d.placement = d.options.placement, d.orderedModifiers.forEach(function(H) {
              return d.modifiersData[H.name] = Object.assign({}, H.data);
            });
            for (var O = 0; O < d.orderedModifiers.length; O++) {
              if (d.reset === !0) {
                d.reset = !1, O = -1;
                continue;
              }
              var A = d.orderedModifiers[O], I = A.fn, $ = A.options, L = $ === void 0 ? {} : $, B = A.name;
              typeof I == "function" && (d = I({
                state: d,
                options: L,
                name: B,
                instance: m
              }) || d);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: fBe(function() {
        return new Promise(function(C) {
          m.forceUpdate(), C(d);
        });
      }),
      destroy: function() {
        x(), h = !0;
      }
    };
    if (!g3(a, u))
      return m;
    m.setOptions(c).then(function(C) {
      !h && c.onFirstUpdate && c.onFirstUpdate(C);
    });
    function v() {
      d.orderedModifiers.forEach(function(C) {
        var E = C.name, S = C.options, w = S === void 0 ? {} : S, O = C.effect;
        if (typeof O == "function") {
          var A = O({
            state: d,
            name: E,
            instance: m,
            options: w
          }), I = function() {
          };
          f.push(A || I);
        }
      });
    }
    function x() {
      f.forEach(function(C) {
        return C();
      }), f = [];
    }
    return m;
  };
}
var gBe = [BLe, rBe, _Le, ALe, tBe, JLe, sBe, $Le, QLe], yBe = /* @__PURE__ */ mBe({
  defaultModifiers: gBe
});
function bBe(e) {
  return typeof e == "function" ? e() : e;
}
const V0 = /* @__PURE__ */ V.forwardRef(function(t, n) {
  const {
    children: r,
    container: i,
    disablePortal: o = !1
  } = t, [s, a] = V.useState(null), u = Hn(/* @__PURE__ */ V.isValidElement(r) ? r.ref : null, n);
  if (gi(() => {
    o || a(bBe(i) || document.body);
  }, [i, o]), gi(() => {
    if (s && !o)
      return _0(n, s), () => {
        _0(n, null);
      };
  }, [n, s, o]), o) {
    if (/* @__PURE__ */ V.isValidElement(r)) {
      const c = {
        ref: u
      };
      return /* @__PURE__ */ V.cloneElement(r, c);
    }
    return /* @__PURE__ */ P.jsx(V.Fragment, {
      children: r
    });
  }
  return /* @__PURE__ */ P.jsx(V.Fragment, {
    children: s && /* @__PURE__ */ ooe.createPortal(r, s)
  });
});
process.env.NODE_ENV !== "production" && (V0.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The children to render into the `container`.
   */
  children: l.node,
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: l.oneOfType([sc, l.func]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: l.bool
});
process.env.NODE_ENV !== "production" && (V0.propTypes = Xz(V0.propTypes));
function vBe(e) {
  return ot("MuiPopper", e);
}
st("MuiPopper", ["root"]);
const xBe = ["anchorEl", "children", "direction", "disablePortal", "modifiers", "open", "placement", "popperOptions", "popperRef", "slotProps", "slots", "TransitionProps", "ownerState"], DBe = ["anchorEl", "children", "container", "direction", "disablePortal", "keepMounted", "modifiers", "open", "placement", "popperOptions", "popperRef", "style", "transition", "slotProps", "slots"];
function CBe(e, t) {
  if (t === "ltr")
    return e;
  switch (e) {
    case "bottom-end":
      return "bottom-start";
    case "bottom-start":
      return "bottom-end";
    case "top-end":
      return "top-start";
    case "top-start":
      return "top-end";
    default:
      return e;
  }
}
function GD(e) {
  return typeof e == "function" ? e() : e;
}
function ME(e) {
  return e.nodeType !== void 0;
}
function EBe(e) {
  return !ME(e);
}
const TBe = (e) => {
  const {
    classes: t
  } = e;
  return at({
    root: ["root"]
  }, vBe, t);
}, SBe = {}, ABe = /* @__PURE__ */ V.forwardRef(function(t, n) {
  var r;
  const {
    anchorEl: i,
    children: o,
    direction: s,
    disablePortal: a,
    modifiers: u,
    open: c,
    placement: d,
    popperOptions: f,
    popperRef: h,
    slotProps: m = {},
    slots: v = {},
    TransitionProps: x
    // @ts-ignore internal logic
    // prevent from spreading to DOM, it can come from the parent component e.g. Select.
  } = t, C = _e(t, xBe), E = V.useRef(null), S = Hn(E, n), w = V.useRef(null), O = Hn(w, h), A = V.useRef(O);
  gi(() => {
    A.current = O;
  }, [O]), V.useImperativeHandle(h, () => w.current, []);
  const I = CBe(d, s), [$, L] = V.useState(I), [B, H] = V.useState(GD(i));
  V.useEffect(() => {
    w.current && w.current.forceUpdate();
  }), V.useEffect(() => {
    i && H(GD(i));
  }, [i]), gi(() => {
    if (!B || !c)
      return;
    const U = (ee) => {
      L(ee.placement);
    };
    if (process.env.NODE_ENV !== "production" && B && ME(B) && B.nodeType === 1) {
      const ee = B.getBoundingClientRect();
      process.env.NODE_ENV !== "test" && ee.top === 0 && ee.left === 0 && ee.right === 0 && ee.bottom === 0 && console.warn(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
    }
    let G = [{
      name: "preventOverflow",
      options: {
        altBoundary: a
      }
    }, {
      name: "flip",
      options: {
        altBoundary: a
      }
    }, {
      name: "onUpdate",
      enabled: !0,
      phase: "afterWrite",
      fn: ({
        state: ee
      }) => {
        U(ee);
      }
    }];
    u != null && (G = G.concat(u)), f && f.modifiers != null && (G = G.concat(f.modifiers));
    const K = yBe(B, E.current, N({
      placement: I
    }, f, {
      modifiers: G
    }));
    return A.current(K), () => {
      K.destroy(), A.current(null);
    };
  }, [B, a, u, c, f, I]);
  const q = {
    placement: $
  };
  x !== null && (q.TransitionProps = x);
  const J = TBe(t), X = (r = v.root) != null ? r : "div", j = Ai({
    elementType: X,
    externalSlotProps: m.root,
    externalForwardedProps: C,
    additionalProps: {
      role: "tooltip",
      ref: S
    },
    ownerState: t,
    className: J.root
  });
  return /* @__PURE__ */ P.jsx(X, N({}, j, {
    children: typeof o == "function" ? o(q) : o
  }));
}), MU = /* @__PURE__ */ V.forwardRef(function(t, n) {
  const {
    anchorEl: r,
    children: i,
    container: o,
    direction: s = "ltr",
    disablePortal: a = !1,
    keepMounted: u = !1,
    modifiers: c,
    open: d,
    placement: f = "bottom",
    popperOptions: h = SBe,
    popperRef: m,
    style: v,
    transition: x = !1,
    slotProps: C = {},
    slots: E = {}
  } = t, S = _e(t, DBe), [w, O] = V.useState(!0), A = () => {
    O(!1);
  }, I = () => {
    O(!0);
  };
  if (!u && !d && (!x || w))
    return null;
  let $;
  if (o)
    $ = o;
  else if (r) {
    const H = GD(r);
    $ = H && ME(H) ? ei(H).body : ei(null).body;
  }
  const L = !d && u && (!x || w) ? "none" : void 0, B = x ? {
    in: d,
    onEnter: A,
    onExited: I
  } : void 0;
  return /* @__PURE__ */ P.jsx(V0, {
    disablePortal: a,
    container: $,
    children: /* @__PURE__ */ P.jsx(ABe, N({
      anchorEl: r,
      direction: s,
      disablePortal: a,
      modifiers: c,
      ref: n,
      open: x ? !w : d,
      placement: f,
      popperOptions: h,
      popperRef: m,
      slotProps: C,
      slots: E
    }, S, {
      style: N({
        // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
        position: "fixed",
        // Fix Popper.js display issue
        top: 0,
        left: 0,
        display: L
      }, v),
      TransitionProps: B,
      children: i
    }))
  });
});
process.env.NODE_ENV !== "production" && (MU.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, [virtualElement](https://popper.js.org/docs/v2/virtual-elements/),
   * or a function that returns either.
   * It's used to set the position of the popper.
   * The return value will passed as the reference object of the Popper instance.
   */
  anchorEl: $s(l.oneOfType([sc, l.object, l.func]), (e) => {
    if (e.open) {
      const t = GD(e.anchorEl);
      if (t && ME(t) && t.nodeType === 1) {
        const n = t.getBoundingClientRect();
        if (process.env.NODE_ENV !== "test" && n.top === 0 && n.left === 0 && n.right === 0 && n.bottom === 0)
          return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
      } else if (!t || typeof t.getBoundingClientRect != "function" || EBe(t) && t.contextElement != null && t.contextElement.nodeType !== 1)
        return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "It should be an HTML element instance or a virtualElement ", "(https://popper.js.org/docs/v2/virtual-elements/)."].join(`
`));
    }
    return null;
  }),
  /**
   * Popper render function or node.
   */
  children: l.oneOfType([l.node, l.func]),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: l.oneOfType([sc, l.func]),
  /**
   * Direction of the text.
   * @default 'ltr'
   */
  direction: l.oneOf(["ltr", "rtl"]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: l.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   * @default false
   */
  keepMounted: l.bool,
  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v2/modifiers/).
   */
  modifiers: l.arrayOf(l.shape({
    data: l.object,
    effect: l.func,
    enabled: l.bool,
    fn: l.func,
    name: l.any,
    options: l.object,
    phase: l.oneOf(["afterMain", "afterRead", "afterWrite", "beforeMain", "beforeRead", "beforeWrite", "main", "read", "write"]),
    requires: l.arrayOf(l.string),
    requiresIfExists: l.arrayOf(l.string)
  })),
  /**
   * If `true`, the component is shown.
   */
  open: l.bool.isRequired,
  /**
   * Popper placement.
   * @default 'bottom'
   */
  placement: l.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * Options provided to the [`Popper.js`](https://popper.js.org/docs/v2/constructors/#options) instance.
   * @default {}
   */
  popperOptions: l.shape({
    modifiers: l.array,
    onFirstUpdate: l.func,
    placement: l.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
    strategy: l.oneOf(["absolute", "fixed"])
  }),
  /**
   * A ref that points to the used popper instance.
   */
  popperRef: wr,
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  slotProps: l.shape({
    root: l.oneOfType([l.func, l.object])
  }),
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: l.shape({
    root: l.elementType
  }),
  /**
   * Help supporting a react-transition-group/Transition component.
   * @default false
   */
  transition: l.bool
});
const wBe = ["anchorEl", "component", "components", "componentsProps", "container", "disablePortal", "keepMounted", "modifiers", "open", "placement", "popperOptions", "popperRef", "transition", "slots", "slotProps"], PBe = De(MU, {
  name: "MuiPopper",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), ag = /* @__PURE__ */ V.forwardRef(function(t, n) {
  var r;
  const i = TU(), o = Ot({
    props: t,
    name: "MuiPopper"
  }), {
    anchorEl: s,
    component: a,
    components: u,
    componentsProps: c,
    container: d,
    disablePortal: f,
    keepMounted: h,
    modifiers: m,
    open: v,
    placement: x,
    popperOptions: C,
    popperRef: E,
    transition: S,
    slots: w,
    slotProps: O
  } = o, A = _e(o, wBe), I = (r = w == null ? void 0 : w.root) != null ? r : u == null ? void 0 : u.Root, $ = N({
    anchorEl: s,
    container: d,
    disablePortal: f,
    keepMounted: h,
    modifiers: m,
    open: v,
    placement: x,
    popperOptions: C,
    popperRef: E,
    transition: S
  }, A);
  return /* @__PURE__ */ P.jsx(PBe, N({
    as: a,
    direction: i == null ? void 0 : i.direction,
    slots: {
      root: I
    },
    slotProps: O ?? c
  }, $, {
    ref: n
  }));
});
process.env.NODE_ENV !== "production" && (ag.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, [virtualElement](https://popper.js.org/docs/v2/virtual-elements/),
   * or a function that returns either.
   * It's used to set the position of the popper.
   * The return value will passed as the reference object of the Popper instance.
   */
  anchorEl: l.oneOfType([sc, l.object, l.func]),
  /**
   * Popper render function or node.
   */
  children: l.oneOfType([l.node, l.func]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  components: l.shape({
    Root: l.elementType
  }),
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  componentsProps: l.shape({
    root: l.oneOfType([l.func, l.object])
  }),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: l.oneOfType([sc, l.func]),
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: l.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   * @default false
   */
  keepMounted: l.bool,
  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v2/modifiers/).
   */
  modifiers: l.arrayOf(l.shape({
    data: l.object,
    effect: l.func,
    enabled: l.bool,
    fn: l.func,
    name: l.any,
    options: l.object,
    phase: l.oneOf(["afterMain", "afterRead", "afterWrite", "beforeMain", "beforeRead", "beforeWrite", "main", "read", "write"]),
    requires: l.arrayOf(l.string),
    requiresIfExists: l.arrayOf(l.string)
  })),
  /**
   * If `true`, the component is shown.
   */
  open: l.bool.isRequired,
  /**
   * Popper placement.
   * @default 'bottom'
   */
  placement: l.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * Options provided to the [`Popper.js`](https://popper.js.org/docs/v2/constructors/#options) instance.
   * @default {}
   */
  popperOptions: l.shape({
    modifiers: l.array,
    onFirstUpdate: l.func,
    placement: l.oneOf(["auto-end", "auto-start", "auto", "bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
    strategy: l.oneOf(["absolute", "fixed"])
  }),
  /**
   * A ref that points to the used popper instance.
   */
  popperRef: wr,
  /**
   * The props used for each slot inside the Popper.
   * @default {}
   */
  slotProps: l.shape({
    root: l.oneOfType([l.func, l.object])
  }),
  /**
   * The components used for each slot inside the Popper.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: l.shape({
    root: l.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * Help supporting a react-transition-group/Transition component.
   * @default false
   */
  transition: l.bool
});
function kBe(e) {
  return ot("MuiListSubheader", e);
}
st("MuiListSubheader", ["root", "colorPrimary", "colorInherit", "gutters", "inset", "sticky"]);
const OBe = ["className", "color", "component", "disableGutters", "disableSticky", "inset"], IBe = (e) => {
  const {
    classes: t,
    color: n,
    disableGutters: r,
    inset: i,
    disableSticky: o
  } = e, s = {
    root: ["root", n !== "default" && `color${Ue(n)}`, !r && "gutters", i && "inset", !o && "sticky"]
  };
  return at(s, kBe, t);
}, FBe = De("li", {
  name: "MuiListSubheader",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.color !== "default" && t[`color${Ue(n.color)}`], !n.disableGutters && t.gutters, n.inset && t.inset, !n.disableSticky && t.sticky];
  }
})(({
  theme: e,
  ownerState: t
}) => N({
  boxSizing: "border-box",
  lineHeight: "48px",
  listStyle: "none",
  color: (e.vars || e).palette.text.secondary,
  fontFamily: e.typography.fontFamily,
  fontWeight: e.typography.fontWeightMedium,
  fontSize: e.typography.pxToRem(14)
}, t.color === "primary" && {
  color: (e.vars || e).palette.primary.main
}, t.color === "inherit" && {
  color: "inherit"
}, !t.disableGutters && {
  paddingLeft: 16,
  paddingRight: 16
}, t.inset && {
  paddingLeft: 72
}, !t.disableSticky && {
  position: "sticky",
  top: 0,
  zIndex: 1,
  backgroundColor: (e.vars || e).palette.background.paper
})), dF = /* @__PURE__ */ V.forwardRef(function(t, n) {
  const r = Ot({
    props: t,
    name: "MuiListSubheader"
  }), {
    className: i,
    color: o = "default",
    component: s = "li",
    disableGutters: a = !1,
    disableSticky: u = !1,
    inset: c = !1
  } = r, d = _e(r, OBe), f = N({}, r, {
    color: o,
    component: s,
    disableGutters: a,
    disableSticky: u,
    inset: c
  }), h = IBe(f);
  return /* @__PURE__ */ P.jsx(FBe, N({
    as: s,
    className: Be(h.root, i),
    ref: n,
    ownerState: f
  }, d));
});
dF.muiSkipListHighlight = !0;
process.env.NODE_ENV !== "production" && (dF.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   * @default 'default'
   */
  color: l.oneOf(["default", "inherit", "primary"]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * If `true`, the List Subheader will not have gutters.
   * @default false
   */
  disableGutters: l.bool,
  /**
   * If `true`, the List Subheader will not stick to the top during scroll.
   * @default false
   */
  disableSticky: l.bool,
  /**
   * If `true`, the List Subheader is indented.
   * @default false
   */
  inset: l.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
const $Be = Rr(/* @__PURE__ */ P.jsx("path", {
  d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), "Cancel");
function NBe(e) {
  return ot("MuiChip", e);
}
const lr = st("MuiChip", ["root", "sizeSmall", "sizeMedium", "colorError", "colorInfo", "colorPrimary", "colorSecondary", "colorSuccess", "colorWarning", "disabled", "clickable", "clickableColorPrimary", "clickableColorSecondary", "deletable", "deletableColorPrimary", "deletableColorSecondary", "outlined", "filled", "outlinedPrimary", "outlinedSecondary", "filledPrimary", "filledSecondary", "avatar", "avatarSmall", "avatarMedium", "avatarColorPrimary", "avatarColorSecondary", "icon", "iconSmall", "iconMedium", "iconColorPrimary", "iconColorSecondary", "label", "labelSmall", "labelMedium", "deleteIcon", "deleteIconSmall", "deleteIconMedium", "deleteIconColorPrimary", "deleteIconColorSecondary", "deleteIconOutlinedColorPrimary", "deleteIconOutlinedColorSecondary", "deleteIconFilledColorPrimary", "deleteIconFilledColorSecondary", "focusVisible"]), MBe = ["avatar", "className", "clickable", "color", "component", "deleteIcon", "disabled", "icon", "label", "onClick", "onDelete", "onKeyDown", "onKeyUp", "size", "variant", "tabIndex", "skipFocusWhenDisabled"], RBe = (e) => {
  const {
    classes: t,
    disabled: n,
    size: r,
    color: i,
    iconColor: o,
    onDelete: s,
    clickable: a,
    variant: u
  } = e, c = {
    root: ["root", u, n && "disabled", `size${Ue(r)}`, `color${Ue(i)}`, a && "clickable", a && `clickableColor${Ue(i)}`, s && "deletable", s && `deletableColor${Ue(i)}`, `${u}${Ue(i)}`],
    label: ["label", `label${Ue(r)}`],
    avatar: ["avatar", `avatar${Ue(r)}`, `avatarColor${Ue(i)}`],
    icon: ["icon", `icon${Ue(r)}`, `iconColor${Ue(o)}`],
    deleteIcon: ["deleteIcon", `deleteIcon${Ue(r)}`, `deleteIconColor${Ue(i)}`, `deleteIcon${Ue(u)}Color${Ue(i)}`]
  };
  return at(c, NBe, t);
}, _Be = De("div", {
  name: "MuiChip",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e, {
      color: r,
      iconColor: i,
      clickable: o,
      onDelete: s,
      size: a,
      variant: u
    } = n;
    return [{
      [`& .${lr.avatar}`]: t.avatar
    }, {
      [`& .${lr.avatar}`]: t[`avatar${Ue(a)}`]
    }, {
      [`& .${lr.avatar}`]: t[`avatarColor${Ue(r)}`]
    }, {
      [`& .${lr.icon}`]: t.icon
    }, {
      [`& .${lr.icon}`]: t[`icon${Ue(a)}`]
    }, {
      [`& .${lr.icon}`]: t[`iconColor${Ue(i)}`]
    }, {
      [`& .${lr.deleteIcon}`]: t.deleteIcon
    }, {
      [`& .${lr.deleteIcon}`]: t[`deleteIcon${Ue(a)}`]
    }, {
      [`& .${lr.deleteIcon}`]: t[`deleteIconColor${Ue(r)}`]
    }, {
      [`& .${lr.deleteIcon}`]: t[`deleteIcon${Ue(u)}Color${Ue(r)}`]
    }, t.root, t[`size${Ue(a)}`], t[`color${Ue(r)}`], o && t.clickable, o && r !== "default" && t[`clickableColor${Ue(r)})`], s && t.deletable, s && r !== "default" && t[`deletableColor${Ue(r)}`], t[u], t[`${u}${Ue(r)}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => {
  const n = e.palette.mode === "light" ? e.palette.grey[700] : e.palette.grey[300];
  return N({
    maxWidth: "100%",
    fontFamily: e.typography.fontFamily,
    fontSize: e.typography.pxToRem(13),
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    height: 32,
    color: (e.vars || e).palette.text.primary,
    backgroundColor: (e.vars || e).palette.action.selected,
    borderRadius: 32 / 2,
    whiteSpace: "nowrap",
    transition: e.transitions.create(["background-color", "box-shadow"]),
    // reset cursor explicitly in case ButtonBase is used
    cursor: "unset",
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    textDecoration: "none",
    border: 0,
    // Remove `button` border
    padding: 0,
    // Remove `button` padding
    verticalAlign: "middle",
    boxSizing: "border-box",
    [`&.${lr.disabled}`]: {
      opacity: (e.vars || e).palette.action.disabledOpacity,
      pointerEvents: "none"
    },
    [`& .${lr.avatar}`]: {
      marginLeft: 5,
      marginRight: -6,
      width: 24,
      height: 24,
      color: e.vars ? e.vars.palette.Chip.defaultAvatarColor : n,
      fontSize: e.typography.pxToRem(12)
    },
    [`& .${lr.avatarColorPrimary}`]: {
      color: (e.vars || e).palette.primary.contrastText,
      backgroundColor: (e.vars || e).palette.primary.dark
    },
    [`& .${lr.avatarColorSecondary}`]: {
      color: (e.vars || e).palette.secondary.contrastText,
      backgroundColor: (e.vars || e).palette.secondary.dark
    },
    [`& .${lr.avatarSmall}`]: {
      marginLeft: 4,
      marginRight: -4,
      width: 18,
      height: 18,
      fontSize: e.typography.pxToRem(10)
    },
    [`& .${lr.icon}`]: N({
      marginLeft: 5,
      marginRight: -6
    }, t.size === "small" && {
      fontSize: 18,
      marginLeft: 4,
      marginRight: -4
    }, t.iconColor === t.color && N({
      color: e.vars ? e.vars.palette.Chip.defaultIconColor : n
    }, t.color !== "default" && {
      color: "inherit"
    })),
    [`& .${lr.deleteIcon}`]: N({
      WebkitTapHighlightColor: "transparent",
      color: e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / 0.26)` : Yt(e.palette.text.primary, 0.26),
      fontSize: 22,
      cursor: "pointer",
      margin: "0 5px 0 -6px",
      "&:hover": {
        color: e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / 0.4)` : Yt(e.palette.text.primary, 0.4)
      }
    }, t.size === "small" && {
      fontSize: 16,
      marginRight: 4,
      marginLeft: -4
    }, t.color !== "default" && {
      color: e.vars ? `rgba(${e.vars.palette[t.color].contrastTextChannel} / 0.7)` : Yt(e.palette[t.color].contrastText, 0.7),
      "&:hover, &:active": {
        color: (e.vars || e).palette[t.color].contrastText
      }
    })
  }, t.size === "small" && {
    height: 24
  }, t.color !== "default" && {
    backgroundColor: (e.vars || e).palette[t.color].main,
    color: (e.vars || e).palette[t.color].contrastText
  }, t.onDelete && {
    [`&.${lr.focusVisible}`]: {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.action.selectedChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : Yt(e.palette.action.selected, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
    }
  }, t.onDelete && t.color !== "default" && {
    [`&.${lr.focusVisible}`]: {
      backgroundColor: (e.vars || e).palette[t.color].dark
    }
  });
}, ({
  theme: e,
  ownerState: t
}) => N({}, t.clickable && {
  userSelect: "none",
  WebkitTapHighlightColor: "transparent",
  cursor: "pointer",
  "&:hover": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.action.selectedChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : Yt(e.palette.action.selected, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity)
  },
  [`&.${lr.focusVisible}`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.action.selectedChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : Yt(e.palette.action.selected, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
  },
  "&:active": {
    boxShadow: (e.vars || e).shadows[1]
  }
}, t.clickable && t.color !== "default" && {
  [`&:hover, &.${lr.focusVisible}`]: {
    backgroundColor: (e.vars || e).palette[t.color].dark
  }
}), ({
  theme: e,
  ownerState: t
}) => N({}, t.variant === "outlined" && {
  backgroundColor: "transparent",
  border: e.vars ? `1px solid ${e.vars.palette.Chip.defaultBorder}` : `1px solid ${e.palette.mode === "light" ? e.palette.grey[400] : e.palette.grey[700]}`,
  [`&.${lr.clickable}:hover`]: {
    backgroundColor: (e.vars || e).palette.action.hover
  },
  [`&.${lr.focusVisible}`]: {
    backgroundColor: (e.vars || e).palette.action.focus
  },
  [`& .${lr.avatar}`]: {
    marginLeft: 4
  },
  [`& .${lr.avatarSmall}`]: {
    marginLeft: 2
  },
  [`& .${lr.icon}`]: {
    marginLeft: 4
  },
  [`& .${lr.iconSmall}`]: {
    marginLeft: 2
  },
  [`& .${lr.deleteIcon}`]: {
    marginRight: 5
  },
  [`& .${lr.deleteIconSmall}`]: {
    marginRight: 3
  }
}, t.variant === "outlined" && t.color !== "default" && {
  color: (e.vars || e).palette[t.color].main,
  border: `1px solid ${e.vars ? `rgba(${e.vars.palette[t.color].mainChannel} / 0.7)` : Yt(e.palette[t.color].main, 0.7)}`,
  [`&.${lr.clickable}:hover`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette[t.color].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : Yt(e.palette[t.color].main, e.palette.action.hoverOpacity)
  },
  [`&.${lr.focusVisible}`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette[t.color].mainChannel} / ${e.vars.palette.action.focusOpacity})` : Yt(e.palette[t.color].main, e.palette.action.focusOpacity)
  },
  [`& .${lr.deleteIcon}`]: {
    color: e.vars ? `rgba(${e.vars.palette[t.color].mainChannel} / 0.7)` : Yt(e.palette[t.color].main, 0.7),
    "&:hover, &:active": {
      color: (e.vars || e).palette[t.color].main
    }
  }
})), LBe = De("span", {
  name: "MuiChip",
  slot: "Label",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e, {
      size: r
    } = n;
    return [t.label, t[`label${Ue(r)}`]];
  }
})(({
  ownerState: e
}) => N({
  overflow: "hidden",
  textOverflow: "ellipsis",
  paddingLeft: 12,
  paddingRight: 12,
  whiteSpace: "nowrap"
}, e.variant === "outlined" && {
  paddingLeft: 11,
  paddingRight: 11
}, e.size === "small" && {
  paddingLeft: 8,
  paddingRight: 8
}, e.size === "small" && e.variant === "outlined" && {
  paddingLeft: 7,
  paddingRight: 7
}));
function y3(e) {
  return e.key === "Backspace" || e.key === "Delete";
}
const Xb = /* @__PURE__ */ V.forwardRef(function(t, n) {
  const r = Ot({
    props: t,
    name: "MuiChip"
  }), {
    avatar: i,
    className: o,
    clickable: s,
    color: a = "default",
    component: u,
    deleteIcon: c,
    disabled: d = !1,
    icon: f,
    label: h,
    onClick: m,
    onDelete: v,
    onKeyDown: x,
    onKeyUp: C,
    size: E = "medium",
    variant: S = "filled",
    tabIndex: w,
    skipFocusWhenDisabled: O = !1
    // TODO v6: Rename to `focusableWhenDisabled`.
  } = r, A = _e(r, MBe), I = V.useRef(null), $ = Hn(I, n), L = (te) => {
    te.stopPropagation(), v && v(te);
  }, B = (te) => {
    te.currentTarget === te.target && y3(te) && te.preventDefault(), x && x(te);
  }, H = (te) => {
    te.currentTarget === te.target && (v && y3(te) ? v(te) : te.key === "Escape" && I.current && I.current.blur()), C && C(te);
  }, q = s !== !1 && m ? !0 : s, J = q || v ? sa : u || "div", X = N({}, r, {
    component: J,
    disabled: d,
    size: E,
    color: a,
    iconColor: /* @__PURE__ */ V.isValidElement(f) && f.props.color || a,
    onDelete: !!v,
    clickable: q,
    variant: S
  }), j = RBe(X), U = J === sa ? N({
    component: u || "div",
    focusVisibleClassName: j.focusVisible
  }, v && {
    disableRipple: !0
  }) : {};
  let G = null;
  v && (G = c && /* @__PURE__ */ V.isValidElement(c) ? /* @__PURE__ */ V.cloneElement(c, {
    className: Be(c.props.className, j.deleteIcon),
    onClick: L
  }) : /* @__PURE__ */ P.jsx($Be, {
    className: Be(j.deleteIcon),
    onClick: L
  }));
  let K = null;
  i && /* @__PURE__ */ V.isValidElement(i) && (K = /* @__PURE__ */ V.cloneElement(i, {
    className: Be(j.avatar, i.props.className)
  }));
  let ee = null;
  return f && /* @__PURE__ */ V.isValidElement(f) && (ee = /* @__PURE__ */ V.cloneElement(f, {
    className: Be(j.icon, f.props.className)
  })), process.env.NODE_ENV !== "production" && K && ee && console.error("MUI: The Chip component can not handle the avatar and the icon prop at the same time. Pick one."), /* @__PURE__ */ P.jsxs(_Be, N({
    as: J,
    className: Be(j.root, o),
    disabled: q && d ? !0 : void 0,
    onClick: m,
    onKeyDown: B,
    onKeyUp: H,
    ref: $,
    tabIndex: O && d ? -1 : w,
    ownerState: X
  }, U, A, {
    children: [K || ee, /* @__PURE__ */ P.jsx(LBe, {
      className: Be(j.label),
      ownerState: X,
      children: h
    }), G]
  }));
});
process.env.NODE_ENV !== "production" && (Xb.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The Avatar element to display.
   */
  avatar: l.element,
  /**
   * This prop isn't supported.
   * Use the `component` prop if you need to change the children structure.
   */
  children: WI,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * If `true`, the chip will appear clickable, and will raise when pressed,
   * even if the onClick prop is not defined.
   * If `false`, the chip will not appear clickable, even if onClick prop is defined.
   * This can be used, for example,
   * along with the component prop to indicate an anchor Chip is clickable.
   * Note: this controls the UI and does not affect the onClick event.
   */
  clickable: l.bool,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'default'
   */
  color: l.oneOfType([l.oneOf(["default", "primary", "secondary", "error", "info", "success", "warning"]), l.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * Override the default delete icon element. Shown only if `onDelete` is set.
   */
  deleteIcon: l.element,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: l.bool,
  /**
   * Icon element.
   */
  icon: l.element,
  /**
   * The content of the component.
   */
  label: l.node,
  /**
   * @ignore
   */
  onClick: l.func,
  /**
   * Callback fired when the delete icon is clicked.
   * If set, the delete icon will be shown.
   */
  onDelete: l.func,
  /**
   * @ignore
   */
  onKeyDown: l.func,
  /**
   * @ignore
   */
  onKeyUp: l.func,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: l.oneOfType([l.oneOf(["medium", "small"]), l.string]),
  /**
   * If `true`, allows the disabled chip to escape focus.
   * If `false`, allows the disabled chip to receive focus.
   * @default false
   */
  skipFocusWhenDisabled: l.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * @ignore
   */
  tabIndex: l.number,
  /**
   * The variant to use.
   * @default 'filled'
   */
  variant: l.oneOfType([l.oneOf(["filled", "outlined"]), l.string])
});
const BBe = ["onChange", "maxRows", "minRows", "style", "value"];
function z1(e) {
  return parseInt(e, 10) || 0;
}
const jBe = {
  shadow: {
    // Visibility needed to hide the extra text area on iPads
    visibility: "hidden",
    // Remove from the content flow
    position: "absolute",
    // Ignore the scrollbar width
    overflow: "hidden",
    height: 0,
    top: 0,
    left: 0,
    // Create a new layer, increase the isolation of the computed values
    transform: "translateZ(0)"
  }
};
function VBe(e) {
  return e == null || Object.keys(e).length === 0 || e.outerHeightStyle === 0 && !e.overflowing;
}
const RU = /* @__PURE__ */ V.forwardRef(function(t, n) {
  const {
    onChange: r,
    maxRows: i,
    minRows: o = 1,
    style: s,
    value: a
  } = t, u = _e(t, BBe), {
    current: c
  } = V.useRef(a != null), d = V.useRef(null), f = Hn(n, d), h = V.useRef(null), m = V.useRef(null), v = V.useCallback(() => {
    const E = d.current, w = bu(E).getComputedStyle(E);
    if (w.width === "0px")
      return {
        outerHeightStyle: 0,
        overflowing: !1
      };
    const O = m.current;
    O.style.width = w.width, O.value = E.value || t.placeholder || "x", O.value.slice(-1) === `
` && (O.value += " ");
    const A = w.boxSizing, I = z1(w.paddingBottom) + z1(w.paddingTop), $ = z1(w.borderBottomWidth) + z1(w.borderTopWidth), L = O.scrollHeight;
    O.value = "x";
    const B = O.scrollHeight;
    let H = L;
    o && (H = Math.max(Number(o) * B, H)), i && (H = Math.min(Number(i) * B, H)), H = Math.max(H, B);
    const q = H + (A === "border-box" ? I + $ : 0), J = Math.abs(H - L) <= 1;
    return {
      outerHeightStyle: q,
      overflowing: J
    };
  }, [i, o, t.placeholder]), x = V.useCallback(() => {
    const E = v();
    if (VBe(E))
      return;
    const S = E.outerHeightStyle, w = d.current;
    h.current !== S && (h.current = S, w.style.height = `${S}px`), w.style.overflow = E.overflowing ? "hidden" : "";
  }, [v]);
  gi(() => {
    const E = () => {
      x();
    };
    let S;
    const w = () => {
      cancelAnimationFrame(S), S = requestAnimationFrame(() => {
        E();
      });
    }, O = Vb(E), A = d.current, I = bu(A);
    I.addEventListener("resize", O);
    let $;
    return typeof ResizeObserver < "u" && ($ = new ResizeObserver(process.env.NODE_ENV === "test" ? w : E), $.observe(A)), () => {
      O.clear(), cancelAnimationFrame(S), I.removeEventListener("resize", O), $ && $.disconnect();
    };
  }, [v, x]), gi(() => {
    x();
  });
  const C = (E) => {
    c || x(), r && r(E);
  };
  return /* @__PURE__ */ P.jsxs(V.Fragment, {
    children: [/* @__PURE__ */ P.jsx("textarea", N({
      value: a,
      onChange: C,
      ref: f,
      rows: o,
      style: s
    }, u)), /* @__PURE__ */ P.jsx("textarea", {
      "aria-hidden": !0,
      className: t.className,
      readOnly: !0,
      ref: m,
      tabIndex: -1,
      style: N({}, jBe.shadow, s, {
        paddingTop: 0,
        paddingBottom: 0
      })
    })]
  });
});
process.env.NODE_ENV !== "production" && (RU.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  className: l.string,
  /**
   * Maximum number of rows to display.
   */
  maxRows: l.oneOfType([l.number, l.string]),
  /**
   * Minimum number of rows to display.
   * @default 1
   */
  minRows: l.oneOfType([l.number, l.string]),
  /**
   * @ignore
   */
  onChange: l.func,
  /**
   * @ignore
   */
  placeholder: l.string,
  /**
   * @ignore
   */
  style: l.object,
  /**
   * @ignore
   */
  value: l.oneOfType([l.arrayOf(l.string), l.number, l.string])
});
function wd({
  props: e,
  states: t,
  muiFormControl: n
}) {
  return t.reduce((r, i) => (r[i] = e[i], n && typeof e[i] > "u" && (r[i] = n[i]), r), {});
}
const Qb = /* @__PURE__ */ V.createContext(void 0);
process.env.NODE_ENV !== "production" && (Qb.displayName = "FormControlContext");
function Tu() {
  return V.useContext(Qb);
}
function pF(e) {
  return /* @__PURE__ */ P.jsx(Vz, N({}, e, {
    defaultTheme: IE,
    themeId: Rb
  }));
}
process.env.NODE_ENV !== "production" && (pF.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The styles you want to apply globally.
   */
  styles: l.oneOfType([l.array, l.func, l.number, l.object, l.string, l.bool])
});
function b3(e) {
  return e != null && !(Array.isArray(e) && e.length === 0);
}
function YD(e, t = !1) {
  return e && (b3(e.value) && e.value !== "" || t && b3(e.defaultValue) && e.defaultValue !== "");
}
function zBe(e) {
  return e.startAdornment;
}
function UBe(e) {
  return ot("MuiInputBase", e);
}
const Qs = st("MuiInputBase", ["root", "formControl", "focused", "disabled", "adornedStart", "adornedEnd", "error", "sizeSmall", "multiline", "colorSecondary", "fullWidth", "hiddenLabel", "readOnly", "input", "inputSizeSmall", "inputMultiline", "inputTypeSearch", "inputAdornedStart", "inputAdornedEnd", "inputHiddenLabel"]), WBe = ["aria-describedby", "autoComplete", "autoFocus", "className", "color", "components", "componentsProps", "defaultValue", "disabled", "disableInjectingGlobalStyles", "endAdornment", "error", "fullWidth", "id", "inputComponent", "inputProps", "inputRef", "margin", "maxRows", "minRows", "multiline", "name", "onBlur", "onChange", "onClick", "onFocus", "onKeyDown", "onKeyUp", "placeholder", "readOnly", "renderSuffix", "rows", "size", "slotProps", "slots", "startAdornment", "type", "value"], RE = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.root, n.formControl && t.formControl, n.startAdornment && t.adornedStart, n.endAdornment && t.adornedEnd, n.error && t.error, n.size === "small" && t.sizeSmall, n.multiline && t.multiline, n.color && t[`color${Ue(n.color)}`], n.fullWidth && t.fullWidth, n.hiddenLabel && t.hiddenLabel];
}, _E = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.input, n.size === "small" && t.inputSizeSmall, n.multiline && t.inputMultiline, n.type === "search" && t.inputTypeSearch, n.startAdornment && t.inputAdornedStart, n.endAdornment && t.inputAdornedEnd, n.hiddenLabel && t.inputHiddenLabel];
}, HBe = (e) => {
  const {
    classes: t,
    color: n,
    disabled: r,
    error: i,
    endAdornment: o,
    focused: s,
    formControl: a,
    fullWidth: u,
    hiddenLabel: c,
    multiline: d,
    readOnly: f,
    size: h,
    startAdornment: m,
    type: v
  } = e, x = {
    root: ["root", `color${Ue(n)}`, r && "disabled", i && "error", u && "fullWidth", s && "focused", a && "formControl", h && h !== "medium" && `size${Ue(h)}`, d && "multiline", m && "adornedStart", o && "adornedEnd", c && "hiddenLabel", f && "readOnly"],
    input: ["input", r && "disabled", v === "search" && "inputTypeSearch", d && "inputMultiline", h === "small" && "inputSizeSmall", c && "inputHiddenLabel", m && "inputAdornedStart", o && "inputAdornedEnd", f && "readOnly"]
  };
  return at(x, UBe, t);
}, LE = De("div", {
  name: "MuiInputBase",
  slot: "Root",
  overridesResolver: RE
})(({
  theme: e,
  ownerState: t
}) => N({}, e.typography.body1, {
  color: (e.vars || e).palette.text.primary,
  lineHeight: "1.4375em",
  // 23px
  boxSizing: "border-box",
  // Prevent padding issue with fullWidth.
  position: "relative",
  cursor: "text",
  display: "inline-flex",
  alignItems: "center",
  [`&.${Qs.disabled}`]: {
    color: (e.vars || e).palette.text.disabled,
    cursor: "default"
  }
}, t.multiline && N({
  padding: "4px 0 5px"
}, t.size === "small" && {
  paddingTop: 1
}), t.fullWidth && {
  width: "100%"
})), BE = De("input", {
  name: "MuiInputBase",
  slot: "Input",
  overridesResolver: _E
})(({
  theme: e,
  ownerState: t
}) => {
  const n = e.palette.mode === "light", r = N({
    color: "currentColor"
  }, e.vars ? {
    opacity: e.vars.opacity.inputPlaceholder
  } : {
    opacity: n ? 0.42 : 0.5
  }, {
    transition: e.transitions.create("opacity", {
      duration: e.transitions.duration.shorter
    })
  }), i = {
    opacity: "0 !important"
  }, o = e.vars ? {
    opacity: e.vars.opacity.inputPlaceholder
  } : {
    opacity: n ? 0.42 : 0.5
  };
  return N({
    font: "inherit",
    letterSpacing: "inherit",
    color: "currentColor",
    padding: "4px 0 5px",
    border: 0,
    boxSizing: "content-box",
    background: "none",
    height: "1.4375em",
    // Reset 23pxthe native input line-height
    margin: 0,
    // Reset for Safari
    WebkitTapHighlightColor: "transparent",
    display: "block",
    // Make the flex item shrink with Firefox
    minWidth: 0,
    width: "100%",
    // Fix IE11 width issue
    animationName: "mui-auto-fill-cancel",
    animationDuration: "10ms",
    "&::-webkit-input-placeholder": r,
    "&::-moz-placeholder": r,
    // Firefox 19+
    "&:-ms-input-placeholder": r,
    // IE11
    "&::-ms-input-placeholder": r,
    // Edge
    "&:focus": {
      outline: 0
    },
    // Reset Firefox invalid required input style
    "&:invalid": {
      boxShadow: "none"
    },
    "&::-webkit-search-decoration": {
      // Remove the padding when type=search.
      WebkitAppearance: "none"
    },
    // Show and hide the placeholder logic
    [`label[data-shrink=false] + .${Qs.formControl} &`]: {
      "&::-webkit-input-placeholder": i,
      "&::-moz-placeholder": i,
      // Firefox 19+
      "&:-ms-input-placeholder": i,
      // IE11
      "&::-ms-input-placeholder": i,
      // Edge
      "&:focus::-webkit-input-placeholder": o,
      "&:focus::-moz-placeholder": o,
      // Firefox 19+
      "&:focus:-ms-input-placeholder": o,
      // IE11
      "&:focus::-ms-input-placeholder": o
      // Edge
    },
    [`&.${Qs.disabled}`]: {
      opacity: 1,
      // Reset iOS opacity
      WebkitTextFillColor: (e.vars || e).palette.text.disabled
      // Fix opacity Safari bug
    },
    "&:-webkit-autofill": {
      animationDuration: "5000s",
      animationName: "mui-auto-fill"
    }
  }, t.size === "small" && {
    paddingTop: 1
  }, t.multiline && {
    height: "auto",
    resize: "none",
    padding: 0,
    paddingTop: 0
  }, t.type === "search" && {
    // Improve type search style.
    MozAppearance: "textfield"
  });
}), qBe = /* @__PURE__ */ P.jsx(pF, {
  styles: {
    "@keyframes mui-auto-fill": {
      from: {
        display: "block"
      }
    },
    "@keyframes mui-auto-fill-cancel": {
      from: {
        display: "block"
      }
    }
  }
}), _U = /* @__PURE__ */ V.forwardRef(function(t, n) {
  var r;
  const i = Ot({
    props: t,
    name: "MuiInputBase"
  }), {
    "aria-describedby": o,
    autoComplete: s,
    autoFocus: a,
    className: u,
    components: c = {},
    componentsProps: d = {},
    defaultValue: f,
    disabled: h,
    disableInjectingGlobalStyles: m,
    endAdornment: v,
    fullWidth: x = !1,
    id: C,
    inputComponent: E = "input",
    inputProps: S = {},
    inputRef: w,
    maxRows: O,
    minRows: A,
    multiline: I = !1,
    name: $,
    onBlur: L,
    onChange: B,
    onClick: H,
    onFocus: q,
    onKeyDown: J,
    onKeyUp: X,
    placeholder: j,
    readOnly: U,
    renderSuffix: G,
    rows: K,
    slotProps: ee = {},
    slots: te = {},
    startAdornment: M,
    type: Z = "text",
    value: ne
  } = i, R = _e(i, WBe), _ = S.value != null ? S.value : ne, {
    current: W
  } = V.useRef(_ != null), Q = V.useRef(), oe = V.useCallback((Pe) => {
    process.env.NODE_ENV !== "production" && Pe && Pe.nodeName !== "INPUT" && !Pe.focus && console.error(["MUI: You have provided a `inputComponent` to the input component", "that does not correctly handle the `ref` prop.", "Make sure the `ref` prop is called with a HTMLInputElement."].join(`
`));
  }, []), ae = Hn(Q, w, S.ref, oe), [pe, me] = V.useState(!1), xe = Tu();
  process.env.NODE_ENV !== "production" && V.useEffect(() => {
    if (xe)
      return xe.registerEffect();
  }, [xe]);
  const le = wd({
    props: i,
    muiFormControl: xe,
    states: ["color", "disabled", "error", "hiddenLabel", "size", "required", "filled"]
  });
  le.focused = xe ? xe.focused : pe, V.useEffect(() => {
    !xe && h && pe && (me(!1), L && L());
  }, [xe, h, pe, L]);
  const ye = xe && xe.onFilled, be = xe && xe.onEmpty, Re = V.useCallback((Pe) => {
    YD(Pe) ? ye && ye() : be && be();
  }, [ye, be]);
  gi(() => {
    W && Re({
      value: _
    });
  }, [_, Re, W]);
  const Te = (Pe) => {
    if (le.disabled) {
      Pe.stopPropagation();
      return;
    }
    q && q(Pe), S.onFocus && S.onFocus(Pe), xe && xe.onFocus ? xe.onFocus(Pe) : me(!0);
  }, Xe = (Pe) => {
    L && L(Pe), S.onBlur && S.onBlur(Pe), xe && xe.onBlur ? xe.onBlur(Pe) : me(!1);
  }, Ne = (Pe, ...Ae) => {
    if (!W) {
      const We = Pe.target || Q.current;
      if (We == null)
        throw new Error(process.env.NODE_ENV !== "production" ? "MUI: Expected valid input target. Did you use a custom `inputComponent` and forget to forward refs? See https://mui.com/r/input-component-ref-interface for more info." : gu(1));
      Re({
        value: We.value
      });
    }
    S.onChange && S.onChange(Pe, ...Ae), B && B(Pe, ...Ae);
  };
  V.useEffect(() => {
    Re(Q.current);
  }, []);
  const Qe = (Pe) => {
    Q.current && Pe.currentTarget === Pe.target && Q.current.focus(), H && H(Pe);
  };
  let Ee = E, Ie = S;
  I && Ee === "input" && (K ? (process.env.NODE_ENV !== "production" && (A || O) && console.warn("MUI: You can not use the `minRows` or `maxRows` props when the input `rows` prop is set."), Ie = N({
    type: void 0,
    minRows: K,
    maxRows: K
  }, Ie)) : Ie = N({
    type: void 0,
    maxRows: O,
    minRows: A
  }, Ie), Ee = RU);
  const Je = (Pe) => {
    Re(Pe.animationName === "mui-auto-fill-cancel" ? Q.current : {
      value: "x"
    });
  };
  V.useEffect(() => {
    xe && xe.setAdornedStart(!!M);
  }, [xe, M]);
  const vt = N({}, i, {
    color: le.color || "primary",
    disabled: le.disabled,
    endAdornment: v,
    error: le.error,
    focused: le.focused,
    formControl: xe,
    fullWidth: x,
    hiddenLabel: le.hiddenLabel,
    multiline: I,
    size: le.size,
    startAdornment: M,
    type: Z
  }), St = HBe(vt), Lt = te.root || c.Root || LE, ke = ee.root || d.root || {}, Le = te.input || c.Input || BE;
  return Ie = N({}, Ie, (r = ee.input) != null ? r : d.input), /* @__PURE__ */ P.jsxs(V.Fragment, {
    children: [!m && qBe, /* @__PURE__ */ P.jsxs(Lt, N({}, ke, !lu(Lt) && {
      ownerState: N({}, vt, ke.ownerState)
    }, {
      ref: n,
      onClick: Qe
    }, R, {
      className: Be(St.root, ke.className, u, U && "MuiInputBase-readOnly"),
      children: [M, /* @__PURE__ */ P.jsx(Qb.Provider, {
        value: null,
        children: /* @__PURE__ */ P.jsx(Le, N({
          ownerState: vt,
          "aria-invalid": le.error,
          "aria-describedby": o,
          autoComplete: s,
          autoFocus: a,
          defaultValue: f,
          disabled: le.disabled,
          id: C,
          onAnimationStart: Je,
          name: $,
          placeholder: j,
          readOnly: U,
          required: le.required,
          rows: K,
          value: _,
          onKeyDown: J,
          onKeyUp: X,
          type: Z
        }, Ie, !lu(Le) && {
          as: Ee,
          ownerState: N({}, vt, Ie.ownerState)
        }, {
          ref: ae,
          className: Be(St.input, Ie.className, U && "MuiInputBase-readOnly"),
          onBlur: Xe,
          onChange: Ne,
          onFocus: Te
        }))
      }), v, G ? G(N({}, le, {
        startAdornment: M
      })) : null]
    }))]
  });
});
process.env.NODE_ENV !== "production" && (_U.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  "aria-describedby": l.string,
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: l.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: l.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: l.oneOfType([l.oneOf(["primary", "secondary", "error", "info", "success", "warning"]), l.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: l.shape({
    Input: l.elementType,
    Root: l.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: l.shape({
    input: l.object,
    root: l.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: l.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: l.bool,
  /**
   * If `true`, GlobalStyles for the auto-fill keyframes will not be injected/removed on mount/unmount. Make sure to inject them at the top of your application.
   * This option is intended to help with boosting the initial rendering performance if you are loading a big amount of Input components at once.
   * @default false
   */
  disableInjectingGlobalStyles: l.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: l.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: l.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: l.bool,
  /**
   * The id of the `input` element.
   */
  id: l.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: jb,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: l.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: wr,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: l.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: l.oneOfType([l.number, l.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: l.oneOfType([l.number, l.string]),
  /**
   * If `true`, a [TextareaAutosize](/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: l.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: l.string,
  /**
   * Callback fired when the `input` is blurred.
   *
   * Notice that the first argument (event) might be undefined.
   */
  onBlur: l.func,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: l.func,
  /**
   * @ignore
   */
  onClick: l.func,
  /**
   * @ignore
   */
  onFocus: l.func,
  /**
   * Callback fired when the `input` doesn't satisfy its constraints.
   */
  onInvalid: l.func,
  /**
   * @ignore
   */
  onKeyDown: l.func,
  /**
   * @ignore
   */
  onKeyUp: l.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: l.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: l.bool,
  /**
   * @ignore
   */
  renderSuffix: l.func,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: l.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: l.oneOfType([l.number, l.string]),
  /**
   * The size of the component.
   */
  size: l.oneOfType([l.oneOf(["medium", "small"]), l.string]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: l.shape({
    input: l.object,
    root: l.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: l.shape({
    input: l.elementType,
    root: l.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: l.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: l.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: l.any
});
const fF = _U;
function GBe(e) {
  return ot("MuiInput", e);
}
const Qc = N({}, Qs, st("MuiInput", ["root", "underline", "input"]));
function YBe(e) {
  return ot("MuiOutlinedInput", e);
}
const Vi = N({}, Qs, st("MuiOutlinedInput", ["root", "notchedOutline", "input"]));
function KBe(e) {
  return ot("MuiFilledInput", e);
}
const wi = N({}, Qs, st("MuiFilledInput", ["root", "underline", "input"])), LU = Rr(/* @__PURE__ */ P.jsx("path", {
  d: "M7 10l5 5 5-5z"
}), "ArrowDropDown");
function JBe(e) {
  return ot("MuiAutocomplete", e);
}
const Rn = st("MuiAutocomplete", ["root", "expanded", "fullWidth", "focused", "focusVisible", "tag", "tagSizeSmall", "tagSizeMedium", "hasPopupIcon", "hasClearIcon", "inputRoot", "input", "inputFocused", "endAdornment", "clearIndicator", "popupIndicator", "popupIndicatorOpen", "popper", "popperDisablePortal", "paper", "listbox", "loading", "noOptions", "option", "groupLabel", "groupUl"]);
var v3, x3;
const XBe = ["autoComplete", "autoHighlight", "autoSelect", "blurOnSelect", "ChipProps", "className", "clearIcon", "clearOnBlur", "clearOnEscape", "clearText", "closeText", "componentsProps", "defaultValue", "disableClearable", "disableCloseOnSelect", "disabled", "disabledItemsFocusable", "disableListWrap", "disablePortal", "filterOptions", "filterSelectedOptions", "forcePopupIcon", "freeSolo", "fullWidth", "getLimitTagsText", "getOptionDisabled", "getOptionKey", "getOptionLabel", "isOptionEqualToValue", "groupBy", "handleHomeEndKeys", "id", "includeInputInList", "inputValue", "limitTags", "ListboxComponent", "ListboxProps", "loading", "loadingText", "multiple", "noOptionsText", "onChange", "onClose", "onHighlightChange", "onInputChange", "onOpen", "open", "openOnFocus", "openText", "options", "PaperComponent", "PopperComponent", "popupIcon", "readOnly", "renderGroup", "renderInput", "renderOption", "renderTags", "selectOnFocus", "size", "slotProps", "value"], QBe = ["ref"], ZBe = ["key"], e3e = ["key"], t3e = (e) => {
  const {
    classes: t,
    disablePortal: n,
    expanded: r,
    focused: i,
    fullWidth: o,
    hasClearIcon: s,
    hasPopupIcon: a,
    inputFocused: u,
    popupOpen: c,
    size: d
  } = e, f = {
    root: ["root", r && "expanded", i && "focused", o && "fullWidth", s && "hasClearIcon", a && "hasPopupIcon"],
    inputRoot: ["inputRoot"],
    input: ["input", u && "inputFocused"],
    tag: ["tag", `tagSize${Ue(d)}`],
    endAdornment: ["endAdornment"],
    clearIndicator: ["clearIndicator"],
    popupIndicator: ["popupIndicator", c && "popupIndicatorOpen"],
    popper: ["popper", n && "popperDisablePortal"],
    paper: ["paper"],
    listbox: ["listbox"],
    loading: ["loading"],
    noOptions: ["noOptions"],
    option: ["option"],
    groupLabel: ["groupLabel"],
    groupUl: ["groupUl"]
  };
  return at(f, JBe, t);
}, n3e = De("div", {
  name: "MuiAutocomplete",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e, {
      fullWidth: r,
      hasClearIcon: i,
      hasPopupIcon: o,
      inputFocused: s,
      size: a
    } = n;
    return [{
      [`& .${Rn.tag}`]: t.tag
    }, {
      [`& .${Rn.tag}`]: t[`tagSize${Ue(a)}`]
    }, {
      [`& .${Rn.inputRoot}`]: t.inputRoot
    }, {
      [`& .${Rn.input}`]: t.input
    }, {
      [`& .${Rn.input}`]: s && t.inputFocused
    }, t.root, r && t.fullWidth, o && t.hasPopupIcon, i && t.hasClearIcon];
  }
})({
  [`&.${Rn.focused} .${Rn.clearIndicator}`]: {
    visibility: "visible"
  },
  /* Avoid double tap issue on iOS */
  "@media (pointer: fine)": {
    [`&:hover .${Rn.clearIndicator}`]: {
      visibility: "visible"
    }
  },
  [`& .${Rn.tag}`]: {
    margin: 3,
    maxWidth: "calc(100% - 6px)"
  },
  [`& .${Rn.inputRoot}`]: {
    [`.${Rn.hasPopupIcon}&, .${Rn.hasClearIcon}&`]: {
      paddingRight: 30
    },
    [`.${Rn.hasPopupIcon}.${Rn.hasClearIcon}&`]: {
      paddingRight: 56
    },
    [`& .${Rn.input}`]: {
      width: 0,
      minWidth: 30
    }
  },
  [`& .${Qc.root}`]: {
    paddingBottom: 1,
    "& .MuiInput-input": {
      padding: "4px 4px 4px 0px"
    }
  },
  [`& .${Qc.root}.${Qs.sizeSmall}`]: {
    [`& .${Qc.input}`]: {
      padding: "2px 4px 3px 0"
    }
  },
  [`& .${Vi.root}`]: {
    padding: 9,
    [`.${Rn.hasPopupIcon}&, .${Rn.hasClearIcon}&`]: {
      paddingRight: 39
    },
    [`.${Rn.hasPopupIcon}.${Rn.hasClearIcon}&`]: {
      paddingRight: 65
    },
    [`& .${Rn.input}`]: {
      padding: "7.5px 4px 7.5px 5px"
    },
    [`& .${Rn.endAdornment}`]: {
      right: 9
    }
  },
  [`& .${Vi.root}.${Qs.sizeSmall}`]: {
    // Don't specify paddingRight, as it overrides the default value set when there is only
    // one of the popup or clear icon as the specificity is equal so the latter one wins
    paddingTop: 6,
    paddingBottom: 6,
    paddingLeft: 6,
    [`& .${Rn.input}`]: {
      padding: "2.5px 4px 2.5px 8px"
    }
  },
  [`& .${wi.root}`]: {
    paddingTop: 19,
    paddingLeft: 8,
    [`.${Rn.hasPopupIcon}&, .${Rn.hasClearIcon}&`]: {
      paddingRight: 39
    },
    [`.${Rn.hasPopupIcon}.${Rn.hasClearIcon}&`]: {
      paddingRight: 65
    },
    [`& .${wi.input}`]: {
      padding: "7px 4px"
    },
    [`& .${Rn.endAdornment}`]: {
      right: 9
    }
  },
  [`& .${wi.root}.${Qs.sizeSmall}`]: {
    paddingBottom: 1,
    [`& .${wi.input}`]: {
      padding: "2.5px 4px"
    }
  },
  [`& .${Qs.hiddenLabel}`]: {
    paddingTop: 8
  },
  [`& .${wi.root}.${Qs.hiddenLabel}`]: {
    paddingTop: 0,
    paddingBottom: 0,
    [`& .${Rn.input}`]: {
      paddingTop: 16,
      paddingBottom: 17
    }
  },
  [`& .${wi.root}.${Qs.hiddenLabel}.${Qs.sizeSmall}`]: {
    [`& .${Rn.input}`]: {
      paddingTop: 8,
      paddingBottom: 9
    }
  },
  [`& .${Rn.input}`]: {
    flexGrow: 1,
    textOverflow: "ellipsis",
    opacity: 0
  },
  variants: [{
    props: {
      fullWidth: !0
    },
    style: {
      width: "100%"
    }
  }, {
    props: {
      size: "small"
    },
    style: {
      [`& .${Rn.tag}`]: {
        margin: 2,
        maxWidth: "calc(100% - 4px)"
      }
    }
  }, {
    props: {
      inputFocused: !0
    },
    style: {
      [`& .${Rn.input}`]: {
        opacity: 1
      }
    }
  }, {
    props: {
      multiple: !0
    },
    style: {
      [`& .${Rn.inputRoot}`]: {
        flexWrap: "wrap"
      }
    }
  }]
}), r3e = De("div", {
  name: "MuiAutocomplete",
  slot: "EndAdornment",
  overridesResolver: (e, t) => t.endAdornment
})({
  // We use a position absolute to support wrapping tags.
  position: "absolute",
  right: 0,
  top: "50%",
  transform: "translate(0, -50%)"
}), i3e = De(Or, {
  name: "MuiAutocomplete",
  slot: "ClearIndicator",
  overridesResolver: (e, t) => t.clearIndicator
})({
  marginRight: -2,
  padding: 4,
  visibility: "hidden"
}), o3e = De(Or, {
  name: "MuiAutocomplete",
  slot: "PopupIndicator",
  overridesResolver: ({
    ownerState: e
  }, t) => N({}, t.popupIndicator, e.popupOpen && t.popupIndicatorOpen)
})({
  padding: 2,
  marginRight: -2,
  variants: [{
    props: {
      popupOpen: !0
    },
    style: {
      transform: "rotate(180deg)"
    }
  }]
}), s3e = De(ag, {
  name: "MuiAutocomplete",
  slot: "Popper",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [{
      [`& .${Rn.option}`]: t.option
    }, t.popper, n.disablePortal && t.popperDisablePortal];
  }
})(({
  theme: e
}) => ({
  zIndex: (e.vars || e).zIndex.modal,
  variants: [{
    props: {
      disablePortal: !0
    },
    style: {
      position: "absolute"
    }
  }]
})), a3e = De(ti, {
  name: "MuiAutocomplete",
  slot: "Paper",
  overridesResolver: (e, t) => t.paper
})(({
  theme: e
}) => N({}, e.typography.body1, {
  overflow: "auto"
})), l3e = De("div", {
  name: "MuiAutocomplete",
  slot: "Loading",
  overridesResolver: (e, t) => t.loading
})(({
  theme: e
}) => ({
  color: (e.vars || e).palette.text.secondary,
  padding: "14px 16px"
})), u3e = De("div", {
  name: "MuiAutocomplete",
  slot: "NoOptions",
  overridesResolver: (e, t) => t.noOptions
})(({
  theme: e
}) => ({
  color: (e.vars || e).palette.text.secondary,
  padding: "14px 16px"
})), c3e = De("div", {
  name: "MuiAutocomplete",
  slot: "Listbox",
  overridesResolver: (e, t) => t.listbox
})(({
  theme: e
}) => ({
  listStyle: "none",
  margin: 0,
  padding: "8px 0",
  maxHeight: "40vh",
  overflow: "auto",
  position: "relative",
  [`& .${Rn.option}`]: {
    minHeight: 48,
    display: "flex",
    overflow: "hidden",
    justifyContent: "flex-start",
    alignItems: "center",
    cursor: "pointer",
    paddingTop: 6,
    boxSizing: "border-box",
    outline: "0",
    WebkitTapHighlightColor: "transparent",
    paddingBottom: 6,
    paddingLeft: 16,
    paddingRight: 16,
    [e.breakpoints.up("sm")]: {
      minHeight: "auto"
    },
    [`&.${Rn.focused}`]: {
      backgroundColor: (e.vars || e).palette.action.hover,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    },
    '&[aria-disabled="true"]': {
      opacity: (e.vars || e).palette.action.disabledOpacity,
      pointerEvents: "none"
    },
    [`&.${Rn.focusVisible}`]: {
      backgroundColor: (e.vars || e).palette.action.focus
    },
    '&[aria-selected="true"]': {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : Yt(e.palette.primary.main, e.palette.action.selectedOpacity),
      [`&.${Rn.focused}`]: {
        backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : Yt(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        "@media (hover: none)": {
          backgroundColor: (e.vars || e).palette.action.selected
        }
      },
      [`&.${Rn.focusVisible}`]: {
        backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : Yt(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
      }
    }
  }
})), d3e = De(dF, {
  name: "MuiAutocomplete",
  slot: "GroupLabel",
  overridesResolver: (e, t) => t.groupLabel
})(({
  theme: e
}) => ({
  backgroundColor: (e.vars || e).palette.background.paper,
  top: -8
})), p3e = De("ul", {
  name: "MuiAutocomplete",
  slot: "GroupUl",
  overridesResolver: (e, t) => t.groupUl
})({
  padding: 0,
  [`& .${Rn.option}`]: {
    paddingLeft: 24
  }
}), BU = /* @__PURE__ */ V.forwardRef(function(t, n) {
  var r, i, o, s;
  const a = Ot({
    props: t,
    name: "MuiAutocomplete"
  }), {
    autoComplete: u = !1,
    autoHighlight: c = !1,
    autoSelect: d = !1,
    blurOnSelect: f = !1,
    ChipProps: h,
    className: m,
    clearIcon: v = v3 || (v3 = /* @__PURE__ */ P.jsx(DU, {
      fontSize: "small"
    })),
    clearOnBlur: x = !a.freeSolo,
    clearOnEscape: C = !1,
    clearText: E = "Clear",
    closeText: S = "Close",
    componentsProps: w = {},
    defaultValue: O = a.multiple ? [] : null,
    disableClearable: A = !1,
    disableCloseOnSelect: I = !1,
    disabled: $ = !1,
    disabledItemsFocusable: L = !1,
    disableListWrap: B = !1,
    disablePortal: H = !1,
    filterSelectedOptions: q = !1,
    forcePopupIcon: J = "auto",
    freeSolo: X = !1,
    fullWidth: j = !1,
    getLimitTagsText: U = (Ke) => `+${Ke}`,
    getOptionLabel: G,
    groupBy: K,
    handleHomeEndKeys: ee = !a.freeSolo,
    includeInputInList: te = !1,
    limitTags: M = -1,
    ListboxComponent: Z = "ul",
    ListboxProps: ne,
    loading: R = !1,
    loadingText: _ = "Loading…",
    multiple: W = !1,
    noOptionsText: Q = "No options",
    openOnFocus: oe = !1,
    openText: ae = "Open",
    PaperComponent: pe = ti,
    PopperComponent: me = ag,
    popupIcon: xe = x3 || (x3 = /* @__PURE__ */ P.jsx(LU, {})),
    readOnly: le = !1,
    renderGroup: ye,
    renderInput: be,
    renderOption: Re,
    renderTags: Te,
    selectOnFocus: Xe = !a.freeSolo,
    size: Ne = "medium",
    slotProps: Qe = {}
  } = a, Ee = _e(a, XBe), {
    getRootProps: Ie,
    getInputProps: Je,
    getInputLabelProps: vt,
    getPopupIndicatorProps: St,
    getClearProps: Lt,
    getTagProps: ke,
    getListboxProps: Le,
    getOptionProps: Pe,
    value: Ae,
    dirty: We,
    expanded: At,
    id: Ft,
    popupOpen: Ct,
    focused: ht,
    focusedTag: He,
    anchorEl: qe,
    setAnchorEl: wt,
    inputValue: Ut,
    groupedOptions: an
  } = sLe(N({}, a, {
    componentName: "Autocomplete"
  })), wn = !A && !$ && We && !le, En = (!X || J === !0) && J !== !1, {
    onMouseDown: sr
  } = Je(), {
    ref: er
  } = ne ?? {}, pn = Le(), {
    ref: Pr
  } = pn, bi = _e(pn, QBe), Wr = Hn(Pr, er), _r = G || ((Ke) => {
    var ct;
    return (ct = Ke.label) != null ? ct : Ke;
  }), Lr = N({}, a, {
    disablePortal: H,
    expanded: At,
    focused: ht,
    fullWidth: j,
    getOptionLabel: _r,
    hasClearIcon: wn,
    hasPopupIcon: En,
    inputFocused: He === -1,
    popupOpen: Ct,
    size: Ne
  }), Gn = t3e(Lr);
  let Hr;
  if (W && Ae.length > 0) {
    const Ke = (ct) => N({
      className: Gn.tag,
      disabled: $
    }, ke(ct));
    Te ? Hr = Te(Ae, Ke, Lr) : Hr = Ae.map((ct, gt) => {
      const Ht = Ke({
        index: gt
      }), {
        key: Pn
      } = Ht, tr = _e(Ht, ZBe);
      return /* @__PURE__ */ P.jsx(Xb, N({
        label: _r(ct),
        size: Ne
      }, tr, h), Pn);
    });
  }
  if (M > -1 && Array.isArray(Hr)) {
    const Ke = Hr.length - M;
    !ht && Ke > 0 && (Hr = Hr.splice(0, M), Hr.push(/* @__PURE__ */ P.jsx("span", {
      className: Gn.tag,
      children: U(Ke)
    }, Hr.length)));
  }
  const ao = ye || ((Ke) => /* @__PURE__ */ P.jsxs("li", {
    children: [/* @__PURE__ */ P.jsx(d3e, {
      className: Gn.groupLabel,
      ownerState: Lr,
      component: "div",
      children: Ke.group
    }), /* @__PURE__ */ P.jsx(p3e, {
      className: Gn.groupUl,
      ownerState: Lr,
      children: Ke.children
    })]
  }, Ke.key)), Mi = Re || ((Ke, ct) => {
    const {
      key: gt
    } = Ke, Ht = _e(Ke, e3e);
    return /* @__PURE__ */ P.jsx("li", N({}, Ht, {
      children: _r(ct)
    }), gt);
  }), ko = (Ke, ct) => {
    const gt = Pe({
      option: Ke,
      index: ct
    });
    return Mi(N({}, gt, {
      className: Gn.option
    }), Ke, {
      selected: gt["aria-selected"],
      index: ct,
      inputValue: Ut
    }, Lr);
  }, ve = (r = Qe.clearIndicator) != null ? r : w.clearIndicator, tt = (i = Qe.paper) != null ? i : w.paper, xt = (o = Qe.popper) != null ? o : w.popper, Oe = (s = Qe.popupIndicator) != null ? s : w.popupIndicator, Fe = (Ke) => /* @__PURE__ */ P.jsx(s3e, N({
    as: me,
    disablePortal: H,
    style: {
      width: qe ? qe.clientWidth : null
    },
    ownerState: Lr,
    role: "presentation",
    anchorEl: qe,
    open: Ct
  }, xt, {
    className: Be(Gn.popper, xt == null ? void 0 : xt.className),
    children: /* @__PURE__ */ P.jsx(a3e, N({
      ownerState: Lr,
      as: pe
    }, tt, {
      className: Be(Gn.paper, tt == null ? void 0 : tt.className),
      children: Ke
    }))
  }));
  let et = null;
  return an.length > 0 ? et = Fe(/* @__PURE__ */ P.jsx(c3e, N({
    as: Z,
    className: Gn.listbox,
    ownerState: Lr
  }, bi, ne, {
    ref: Wr,
    children: an.map((Ke, ct) => K ? ao({
      key: Ke.key,
      group: Ke.group,
      children: Ke.options.map((gt, Ht) => ko(gt, Ke.index + Ht))
    }) : ko(Ke, ct))
  }))) : R && an.length === 0 ? et = Fe(/* @__PURE__ */ P.jsx(l3e, {
    className: Gn.loading,
    ownerState: Lr,
    children: _
  })) : an.length === 0 && !X && !R && (et = Fe(/* @__PURE__ */ P.jsx(u3e, {
    className: Gn.noOptions,
    ownerState: Lr,
    role: "presentation",
    onMouseDown: (Ke) => {
      Ke.preventDefault();
    },
    children: Q
  }))), /* @__PURE__ */ P.jsxs(V.Fragment, {
    children: [/* @__PURE__ */ P.jsx(n3e, N({
      ref: n,
      className: Be(Gn.root, m),
      ownerState: Lr
    }, Ie(Ee), {
      children: be({
        id: Ft,
        disabled: $,
        fullWidth: !0,
        size: Ne === "small" ? "small" : void 0,
        InputLabelProps: vt(),
        InputProps: N({
          ref: wt,
          className: Gn.inputRoot,
          startAdornment: Hr,
          onClick: (Ke) => {
            Ke.target === Ke.currentTarget && sr(Ke);
          }
        }, (wn || En) && {
          endAdornment: /* @__PURE__ */ P.jsxs(r3e, {
            className: Gn.endAdornment,
            ownerState: Lr,
            children: [wn ? /* @__PURE__ */ P.jsx(i3e, N({}, Lt(), {
              "aria-label": E,
              title: E,
              ownerState: Lr
            }, ve, {
              className: Be(Gn.clearIndicator, ve == null ? void 0 : ve.className),
              children: v
            })) : null, En ? /* @__PURE__ */ P.jsx(o3e, N({}, St(), {
              disabled: $,
              "aria-label": Ct ? S : ae,
              title: Ct ? S : ae,
              ownerState: Lr
            }, Oe, {
              className: Be(Gn.popupIndicator, Oe == null ? void 0 : Oe.className),
              children: xe
            })) : null]
          })
        }),
        inputProps: N({
          className: Gn.input,
          disabled: $,
          readOnly: le
        }, Je())
      })
    })), qe ? et : null]
  });
});
process.env.NODE_ENV !== "production" && (BU.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the portion of the selected suggestion that the user hasn't typed,
   * known as the completion string, appears inline after the input cursor in the textbox.
   * The inline completion string is visually highlighted and has a selected state.
   * @default false
   */
  autoComplete: l.bool,
  /**
   * If `true`, the first option is automatically highlighted.
   * @default false
   */
  autoHighlight: l.bool,
  /**
   * If `true`, the selected option becomes the value of the input
   * when the Autocomplete loses focus unless the user chooses
   * a different option or changes the character string in the input.
   *
   * When using the `freeSolo` mode, the typed value will be the input value
   * if the Autocomplete loses focus without highlighting an option.
   * @default false
   */
  autoSelect: l.bool,
  /**
   * Control if the input should be blurred when an option is selected:
   *
   * - `false` the input is not blurred.
   * - `true` the input is always blurred.
   * - `touch` the input is blurred after a touch event.
   * - `mouse` the input is blurred after a mouse event.
   * @default false
   */
  blurOnSelect: l.oneOfType([l.oneOf(["mouse", "touch"]), l.bool]),
  /**
   * Props applied to the [`Chip`](/material-ui/api/chip/) element.
   */
  ChipProps: l.object,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The icon to display in place of the default clear icon.
   * @default <ClearIcon fontSize="small" />
   */
  clearIcon: l.node,
  /**
   * If `true`, the input's text is cleared on blur if no value is selected.
   *
   * Set it to `true` if you want to help the user enter a new value.
   * Set it to `false` if you want to help the user resume their search.
   * @default !props.freeSolo
   */
  clearOnBlur: l.bool,
  /**
   * If `true`, clear all values when the user presses escape and the popup is closed.
   * @default false
   */
  clearOnEscape: l.bool,
  /**
   * Override the default text for the *clear* icon button.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @default 'Clear'
   */
  clearText: l.string,
  /**
   * Override the default text for the *close popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @default 'Close'
   */
  closeText: l.string,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  componentsProps: l.shape({
    clearIndicator: l.object,
    paper: l.object,
    popper: l.object,
    popupIndicator: l.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   * @default props.multiple ? [] : null
   */
  defaultValue: $s(l.any, (e) => e.multiple && e.defaultValue !== void 0 && !Array.isArray(e.defaultValue) ? new Error(["MUI: The Autocomplete expects the `defaultValue` prop to be an array when `multiple={true}` or undefined.", `However, ${e.defaultValue} was provided.`].join(`
`)) : null),
  /**
   * If `true`, the input can't be cleared.
   * @default false
   */
  disableClearable: l.bool,
  /**
   * If `true`, the popup won't close when a value is selected.
   * @default false
   */
  disableCloseOnSelect: l.bool,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: l.bool,
  /**
   * If `true`, will allow focus on disabled items.
   * @default false
   */
  disabledItemsFocusable: l.bool,
  /**
   * If `true`, the list box in the popup will not wrap focus.
   * @default false
   */
  disableListWrap: l.bool,
  /**
   * If `true`, the `Popper` content will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: l.bool,
  /**
   * A function that determines the filtered options to be rendered on search.
   *
   * @default createFilterOptions()
   * @param {Value[]} options The options to render.
   * @param {object} state The state of the component.
   * @returns {Value[]}
   */
  filterOptions: l.func,
  /**
   * If `true`, hide the selected options from the list box.
   * @default false
   */
  filterSelectedOptions: l.bool,
  /**
   * Force the visibility display of the popup icon.
   * @default 'auto'
   */
  forcePopupIcon: l.oneOfType([l.oneOf(["auto"]), l.bool]),
  /**
   * If `true`, the Autocomplete is free solo, meaning that the user input is not bound to provided options.
   * @default false
   */
  freeSolo: l.bool,
  /**
   * If `true`, the input will take up the full width of its container.
   * @default false
   */
  fullWidth: l.bool,
  /**
   * The label to display when the tags are truncated (`limitTags`).
   *
   * @param {number} more The number of truncated tags.
   * @returns {ReactNode}
   * @default (more) => `+${more}`
   */
  getLimitTagsText: l.func,
  /**
   * Used to determine the disabled state for a given option.
   *
   * @param {Value} option The option to test.
   * @returns {boolean}
   */
  getOptionDisabled: l.func,
  /**
   * Used to determine the key for a given option.
   * This can be useful when the labels of options are not unique (since labels are used as keys by default).
   *
   * @param {Value} option The option to get the key for.
   * @returns {string | number}
   */
  getOptionKey: l.func,
  /**
   * Used to determine the string value for a given option.
   * It's used to fill the input (and the list box options if `renderOption` is not provided).
   *
   * If used in free solo mode, it must accept both the type of the options and a string.
   *
   * @param {Value} option
   * @returns {string}
   * @default (option) => option.label ?? option
   */
  getOptionLabel: l.func,
  /**
   * If provided, the options will be grouped under the returned string.
   * The groupBy value is also used as the text for group headings when `renderGroup` is not provided.
   *
   * @param {Value} options The options to group.
   * @returns {string}
   */
  groupBy: l.func,
  /**
   * If `true`, the component handles the "Home" and "End" keys when the popup is open.
   * It should move focus to the first option and last option, respectively.
   * @default !props.freeSolo
   */
  handleHomeEndKeys: l.bool,
  /**
   * This prop is used to help implement the accessibility logic.
   * If you don't provide an id it will fall back to a randomly generated one.
   */
  id: l.string,
  /**
   * If `true`, the highlight can move to the input.
   * @default false
   */
  includeInputInList: l.bool,
  /**
   * The input value.
   */
  inputValue: l.string,
  /**
   * Used to determine if the option represents the given value.
   * Uses strict equality by default.
   * ⚠️ Both arguments need to be handled, an option can only match with one value.
   *
   * @param {Value} option The option to test.
   * @param {Value} value The value to test against.
   * @returns {boolean}
   */
  isOptionEqualToValue: l.func,
  /**
   * The maximum number of tags that will be visible when not focused.
   * Set `-1` to disable the limit.
   * @default -1
   */
  limitTags: Ub,
  /**
   * The component used to render the listbox.
   * @default 'ul'
   */
  ListboxComponent: l.elementType,
  /**
   * Props applied to the Listbox element.
   */
  ListboxProps: l.object,
  /**
   * If `true`, the component is in a loading state.
   * This shows the `loadingText` in place of suggestions (only if there are no suggestions to show, for example `options` are empty).
   * @default false
   */
  loading: l.bool,
  /**
   * Text to display when in a loading state.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @default 'Loading…'
   */
  loadingText: l.node,
  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   * @default false
   */
  multiple: l.bool,
  /**
   * Text to display when there are no options.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @default 'No options'
   */
  noOptionsText: l.node,
  /**
   * Callback fired when the value changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {Value|Value[]} value The new value of the component.
   * @param {string} reason One of "createOption", "selectOption", "removeOption", "blur" or "clear".
   * @param {string} [details]
   */
  onChange: l.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {string} reason Can be: `"toggleInput"`, `"escape"`, `"selectOption"`, `"removeOption"`, `"blur"`.
   */
  onClose: l.func,
  /**
   * Callback fired when the highlight option changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {Value} option The highlighted option.
   * @param {string} reason Can be: `"keyboard"`, `"auto"`, `"mouse"`, `"touch"`.
   */
  onHighlightChange: l.func,
  /**
   * Callback fired when the input value changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * @param {string} value The new value of the text input.
   * @param {string} reason Can be: `"input"` (user input), `"reset"` (programmatic change), `"clear"`.
   */
  onInputChange: l.func,
  /**
   * @ignore
   */
  onKeyDown: l.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onOpen: l.func,
  /**
   * If `true`, the component is shown.
   */
  open: l.bool,
  /**
   * If `true`, the popup will open on input focus.
   * @default false
   */
  openOnFocus: l.bool,
  /**
   * Override the default text for the *open popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](/material-ui/guides/localization/).
   * @default 'Open'
   */
  openText: l.string,
  /**
   * Array of options.
   */
  options: l.array.isRequired,
  /**
   * The component used to render the body of the popup.
   * @default Paper
   */
  PaperComponent: l.elementType,
  /**
   * The component used to position the popup.
   * @default Popper
   */
  PopperComponent: l.elementType,
  /**
   * The icon to display in place of the default popup icon.
   * @default <ArrowDropDownIcon />
   */
  popupIcon: l.node,
  /**
   * If `true`, the component becomes readonly. It is also supported for multiple tags where the tag cannot be deleted.
   * @default false
   */
  readOnly: l.bool,
  /**
   * Render the group.
   *
   * @param {AutocompleteRenderGroupParams} params The group to render.
   * @returns {ReactNode}
   */
  renderGroup: l.func,
  /**
   * Render the input.
   *
   * @param {object} params
   * @returns {ReactNode}
   */
  renderInput: l.func.isRequired,
  /**
   * Render the option, use `getOptionLabel` by default.
   *
   * @param {object} props The props to apply on the li element.
   * @param {Value} option The option to render.
   * @param {object} state The state of each option.
   * @param {object} ownerState The state of the Autocomplete component.
   * @returns {ReactNode}
   */
  renderOption: l.func,
  /**
   * Render the selected value.
   *
   * @param {Value[]} value The `value` provided to the component.
   * @param {function} getTagProps A tag props getter.
   * @param {object} ownerState The state of the Autocomplete component.
   * @returns {ReactNode}
   */
  renderTags: l.func,
  /**
   * If `true`, the input's text is selected on focus.
   * It helps the user clear the selected value.
   * @default !props.freeSolo
   */
  selectOnFocus: l.bool,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: l.oneOfType([l.oneOf(["small", "medium"]), l.string]),
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: l.shape({
    clearIndicator: l.object,
    paper: l.object,
    popper: l.object,
    popupIndicator: l.object
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * The value of the autocomplete.
   *
   * The value must have reference equality with the option in order to be selected.
   * You can customize the equality behavior with the `isOptionEqualToValue` prop.
   */
  value: $s(l.any, (e) => e.multiple && e.value !== void 0 && !Array.isArray(e.value) ? new Error(["MUI: The Autocomplete expects the `value` prop to be an array when `multiple={true}` or undefined.", `However, ${e.value} was provided.`].join(`
`)) : null)
});
const f3e = Rr(/* @__PURE__ */ P.jsx("path", {
  d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
}), "Person");
function h3e(e) {
  return ot("MuiAvatar", e);
}
st("MuiAvatar", ["root", "colorDefault", "circular", "rounded", "square", "img", "fallback"]);
const m3e = ["alt", "children", "className", "component", "slots", "slotProps", "imgProps", "sizes", "src", "srcSet", "variant"], g3e = (e) => {
  const {
    classes: t,
    variant: n,
    colorDefault: r
  } = e;
  return at({
    root: ["root", n, r && "colorDefault"],
    img: ["img"],
    fallback: ["fallback"]
  }, h3e, t);
}, y3e = De("div", {
  name: "MuiAvatar",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.variant], n.colorDefault && t.colorDefault];
  }
})(({
  theme: e
}) => ({
  position: "relative",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
  width: 40,
  height: 40,
  fontFamily: e.typography.fontFamily,
  fontSize: e.typography.pxToRem(20),
  lineHeight: 1,
  borderRadius: "50%",
  overflow: "hidden",
  userSelect: "none",
  variants: [{
    props: {
      variant: "rounded"
    },
    style: {
      borderRadius: (e.vars || e).shape.borderRadius
    }
  }, {
    props: {
      variant: "square"
    },
    style: {
      borderRadius: 0
    }
  }, {
    props: {
      colorDefault: !0
    },
    style: N({
      color: (e.vars || e).palette.background.default
    }, e.vars ? {
      backgroundColor: e.vars.palette.Avatar.defaultBg
    } : N({
      backgroundColor: e.palette.grey[400]
    }, e.applyStyles("dark", {
      backgroundColor: e.palette.grey[600]
    })))
  }]
})), b3e = De("img", {
  name: "MuiAvatar",
  slot: "Img",
  overridesResolver: (e, t) => t.img
})({
  width: "100%",
  height: "100%",
  textAlign: "center",
  // Handle non-square image. The property isn't supported by IE11.
  objectFit: "cover",
  // Hide alt text.
  color: "transparent",
  // Hide the image broken icon, only works on Chrome.
  textIndent: 1e4
}), v3e = De(f3e, {
  name: "MuiAvatar",
  slot: "Fallback",
  overridesResolver: (e, t) => t.fallback
})({
  width: "75%",
  height: "75%"
});
function x3e({
  crossOrigin: e,
  referrerPolicy: t,
  src: n,
  srcSet: r
}) {
  const [i, o] = V.useState(!1);
  return V.useEffect(() => {
    if (!n && !r)
      return;
    o(!1);
    let s = !0;
    const a = new Image();
    return a.onload = () => {
      s && o("loaded");
    }, a.onerror = () => {
      s && o("error");
    }, a.crossOrigin = e, a.referrerPolicy = t, a.src = n, r && (a.srcset = r), () => {
      s = !1;
    };
  }, [e, t, n, r]), i;
}
const jE = /* @__PURE__ */ V.forwardRef(function(t, n) {
  const r = Ot({
    props: t,
    name: "MuiAvatar"
  }), {
    alt: i,
    children: o,
    className: s,
    component: a = "div",
    slots: u = {},
    slotProps: c = {},
    imgProps: d,
    sizes: f,
    src: h,
    srcSet: m,
    variant: v = "circular"
  } = r, x = _e(r, m3e);
  let C = null;
  const E = x3e(N({}, d, {
    src: h,
    srcSet: m
  })), S = h || m, w = S && E !== "error", O = N({}, r, {
    colorDefault: !w,
    component: a,
    variant: v
  }), A = g3e(O), [I, $] = HD("img", {
    className: A.img,
    elementType: b3e,
    externalForwardedProps: {
      slots: u,
      slotProps: {
        img: N({}, d, c.img)
      }
    },
    additionalProps: {
      alt: i,
      src: h,
      srcSet: m,
      sizes: f
    },
    ownerState: O
  });
  return w ? C = /* @__PURE__ */ P.jsx(I, N({}, $)) : o || o === 0 ? C = o : S && i ? C = i[0] : C = /* @__PURE__ */ P.jsx(v3e, {
    ownerState: O,
    className: A.fallback
  }), /* @__PURE__ */ P.jsx(y3e, N({
    as: a,
    ownerState: O,
    className: Be(A.root, s),
    ref: n
  }, x, {
    children: C
  }));
});
process.env.NODE_ENV !== "production" && (jE.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Used in combination with `src` or `srcSet` to
   * provide an alt attribute for the rendered `img` element.
   */
  alt: l.string,
  /**
   * Used to render icon or text elements inside the Avatar if `src` is not set.
   * This can be an element, or just a string.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/img#attributes) applied to the `img` element if the component is used to display an image.
   * It can be used to listen for the loading error event.
   * @deprecated Use `slotProps.img` instead. This prop will be removed in v7. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/).
   */
  imgProps: l.object,
  /**
   * The `sizes` attribute for the `img` element.
   */
  sizes: l.string,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: l.shape({
    img: l.oneOfType([l.func, l.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: l.shape({
    img: l.elementType
  }),
  /**
   * The `src` attribute for the `img` element.
   */
  src: l.string,
  /**
   * The `srcSet` attribute for the `img` element.
   * Use this attribute for responsive image display.
   */
  srcSet: l.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * The shape of the avatar.
   * @default 'circular'
   */
  variant: l.oneOfType([l.oneOf(["circular", "rounded", "square"]), l.string])
});
const D3e = ["addEndListener", "appear", "children", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"], C3e = {
  entering: {
    opacity: 1
  },
  entered: {
    opacity: 1
  }
}, ff = /* @__PURE__ */ V.forwardRef(function(t, n) {
  const r = Gi(), i = {
    enter: r.transitions.duration.enteringScreen,
    exit: r.transitions.duration.leavingScreen
  }, {
    addEndListener: o,
    appear: s = !0,
    children: a,
    easing: u,
    in: c,
    onEnter: d,
    onEntered: f,
    onEntering: h,
    onExit: m,
    onExited: v,
    onExiting: x,
    style: C,
    timeout: E = i,
    // eslint-disable-next-line react/prop-types
    TransitionComponent: S = pa
  } = t, w = _e(t, D3e), O = V.useRef(null), A = Hn(O, a.ref, n), I = (j) => (U) => {
    if (j) {
      const G = O.current;
      U === void 0 ? j(G) : j(G, U);
    }
  }, $ = I(h), L = I((j, U) => {
    yU(j);
    const G = pm({
      style: C,
      timeout: E,
      easing: u
    }, {
      mode: "enter"
    });
    j.style.webkitTransition = r.transitions.create("opacity", G), j.style.transition = r.transitions.create("opacity", G), d && d(j, U);
  }), B = I(f), H = I(x), q = I((j) => {
    const U = pm({
      style: C,
      timeout: E,
      easing: u
    }, {
      mode: "exit"
    });
    j.style.webkitTransition = r.transitions.create("opacity", U), j.style.transition = r.transitions.create("opacity", U), m && m(j);
  }), J = I(v), X = (j) => {
    o && o(O.current, j);
  };
  return /* @__PURE__ */ P.jsx(S, N({
    appear: s,
    in: c,
    nodeRef: O,
    onEnter: L,
    onEntered: B,
    onEntering: $,
    onExit: q,
    onExited: J,
    onExiting: H,
    addEndListener: X,
    timeout: E
  }, w, {
    children: (j, U) => /* @__PURE__ */ V.cloneElement(a, N({
      style: N({
        opacity: 0,
        visibility: j === "exited" && !c ? "hidden" : void 0
      }, C3e[j], C, a.props.style),
      ref: A
    }, U))
  }));
});
process.env.NODE_ENV !== "production" && (ff.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: l.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: l.bool,
  /**
   * A single child content element.
   */
  children: ig.isRequired,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: l.oneOfType([l.shape({
    enter: l.string,
    exit: l.string
  }), l.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: l.bool,
  /**
   * @ignore
   */
  onEnter: l.func,
  /**
   * @ignore
   */
  onEntered: l.func,
  /**
   * @ignore
   */
  onEntering: l.func,
  /**
   * @ignore
   */
  onExit: l.func,
  /**
   * @ignore
   */
  onExited: l.func,
  /**
   * @ignore
   */
  onExiting: l.func,
  /**
   * @ignore
   */
  style: l.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  timeout: l.oneOfType([l.number, l.shape({
    appear: l.number,
    enter: l.number,
    exit: l.number
  })])
});
function E3e(e) {
  return ot("MuiBackdrop", e);
}
const jU = st("MuiBackdrop", ["root", "invisible"]), T3e = ["children", "className", "component", "components", "componentsProps", "invisible", "open", "slotProps", "slots", "TransitionComponent", "transitionDuration"], S3e = (e) => {
  const {
    classes: t,
    invisible: n
  } = e;
  return at({
    root: ["root", n && "invisible"]
  }, E3e, t);
}, A3e = De("div", {
  name: "MuiBackdrop",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.invisible && t.invisible];
  }
})(({
  ownerState: e
}) => N({
  position: "fixed",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  right: 0,
  bottom: 0,
  top: 0,
  left: 0,
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  WebkitTapHighlightColor: "transparent"
}, e.invisible && {
  backgroundColor: "transparent"
})), hF = /* @__PURE__ */ V.forwardRef(function(t, n) {
  var r, i, o;
  const s = Ot({
    props: t,
    name: "MuiBackdrop"
  }), {
    children: a,
    className: u,
    component: c = "div",
    components: d = {},
    componentsProps: f = {},
    invisible: h = !1,
    open: m,
    slotProps: v = {},
    slots: x = {},
    TransitionComponent: C = ff,
    transitionDuration: E
  } = s, S = _e(s, T3e), w = N({}, s, {
    component: c,
    invisible: h
  }), O = S3e(w), A = (r = v.root) != null ? r : f.root;
  return /* @__PURE__ */ P.jsx(C, N({
    in: m,
    timeout: E
  }, S, {
    children: /* @__PURE__ */ P.jsx(A3e, N({
      "aria-hidden": !0
    }, A, {
      as: (i = (o = x.root) != null ? o : d.Root) != null ? i : c,
      className: Be(O.root, u, A == null ? void 0 : A.className),
      ownerState: N({}, w, A == null ? void 0 : A.ownerState),
      classes: O,
      ref: n,
      children: a
    }))
  }));
});
process.env.NODE_ENV !== "production" && (hF.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: l.shape({
    Root: l.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: l.shape({
    root: l.object
  }),
  /**
   * If `true`, the backdrop is invisible.
   * It can be used when rendering a popover or a custom select component.
   * @default false
   */
  invisible: l.bool,
  /**
   * If `true`, the component is shown.
   */
  open: l.bool.isRequired,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: l.shape({
    root: l.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: l.shape({
    root: l.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Fade
   */
  TransitionComponent: l.elementType,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: l.oneOfType([l.number, l.shape({
    appear: l.number,
    enter: l.number,
    exit: l.number
  })])
});
function w3e(e) {
  const {
    badgeContent: t,
    invisible: n = !1,
    max: r = 99,
    showZero: i = !1
  } = e, o = HI({
    badgeContent: t,
    max: r
  });
  let s = n;
  n === !1 && t === 0 && !i && (s = !0);
  const {
    badgeContent: a,
    max: u = r
  } = s ? o : e, c = a && Number(a) > u ? `${u}+` : a;
  return {
    badgeContent: a,
    invisible: s,
    max: u,
    displayValue: c
  };
}
function P3e(e) {
  return ot("MuiBadge", e);
}
const Wc = st("MuiBadge", [
  "root",
  "badge",
  "dot",
  "standard",
  "anchorOriginTopRight",
  "anchorOriginBottomRight",
  "anchorOriginTopLeft",
  "anchorOriginBottomLeft",
  "invisible",
  "colorError",
  "colorInfo",
  "colorPrimary",
  "colorSecondary",
  "colorSuccess",
  "colorWarning",
  "overlapRectangular",
  "overlapCircular",
  // TODO: v6 remove the overlap value from these class keys
  "anchorOriginTopLeftCircular",
  "anchorOriginTopLeftRectangular",
  "anchorOriginTopRightCircular",
  "anchorOriginTopRightRectangular",
  "anchorOriginBottomLeftCircular",
  "anchorOriginBottomLeftRectangular",
  "anchorOriginBottomRightCircular",
  "anchorOriginBottomRightRectangular"
]), k3e = ["anchorOrigin", "className", "classes", "component", "components", "componentsProps", "children", "overlap", "color", "invisible", "max", "badgeContent", "slots", "slotProps", "showZero", "variant"], GA = 10, YA = 4, O3e = (e) => {
  const {
    color: t,
    anchorOrigin: n,
    invisible: r,
    overlap: i,
    variant: o,
    classes: s = {}
  } = e, a = {
    root: ["root"],
    badge: ["badge", o, r && "invisible", `anchorOrigin${Ue(n.vertical)}${Ue(n.horizontal)}`, `anchorOrigin${Ue(n.vertical)}${Ue(n.horizontal)}${Ue(i)}`, `overlap${Ue(i)}`, t !== "default" && `color${Ue(t)}`]
  };
  return at(a, P3e, s);
}, I3e = De("span", {
  name: "MuiBadge",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  position: "relative",
  display: "inline-flex",
  // For correct alignment with the text.
  verticalAlign: "middle",
  flexShrink: 0
}), F3e = De("span", {
  name: "MuiBadge",
  slot: "Badge",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.badge, t[n.variant], t[`anchorOrigin${Ue(n.anchorOrigin.vertical)}${Ue(n.anchorOrigin.horizontal)}${Ue(n.overlap)}`], n.color !== "default" && t[`color${Ue(n.color)}`], n.invisible && t.invisible];
  }
})(({
  theme: e
}) => {
  var t;
  return {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "center",
    alignContent: "center",
    alignItems: "center",
    position: "absolute",
    boxSizing: "border-box",
    fontFamily: e.typography.fontFamily,
    fontWeight: e.typography.fontWeightMedium,
    fontSize: e.typography.pxToRem(12),
    minWidth: GA * 2,
    lineHeight: 1,
    padding: "0 6px",
    height: GA * 2,
    borderRadius: GA,
    zIndex: 1,
    // Render the badge on top of potential ripples.
    transition: e.transitions.create("transform", {
      easing: e.transitions.easing.easeInOut,
      duration: e.transitions.duration.enteringScreen
    }),
    variants: [...Object.keys(((t = e.vars) != null ? t : e).palette).filter((n) => {
      var r, i;
      return ((r = e.vars) != null ? r : e).palette[n].main && ((i = e.vars) != null ? i : e).palette[n].contrastText;
    }).map((n) => ({
      props: {
        color: n
      },
      style: {
        backgroundColor: (e.vars || e).palette[n].main,
        color: (e.vars || e).palette[n].contrastText
      }
    })), {
      props: {
        variant: "dot"
      },
      style: {
        borderRadius: YA,
        height: YA * 2,
        minWidth: YA * 2,
        padding: 0
      }
    }, {
      props: ({
        ownerState: n
      }) => n.anchorOrigin.vertical === "top" && n.anchorOrigin.horizontal === "right" && n.overlap === "rectangular",
      style: {
        top: 0,
        right: 0,
        transform: "scale(1) translate(50%, -50%)",
        transformOrigin: "100% 0%",
        [`&.${Wc.invisible}`]: {
          transform: "scale(0) translate(50%, -50%)"
        }
      }
    }, {
      props: ({
        ownerState: n
      }) => n.anchorOrigin.vertical === "bottom" && n.anchorOrigin.horizontal === "right" && n.overlap === "rectangular",
      style: {
        bottom: 0,
        right: 0,
        transform: "scale(1) translate(50%, 50%)",
        transformOrigin: "100% 100%",
        [`&.${Wc.invisible}`]: {
          transform: "scale(0) translate(50%, 50%)"
        }
      }
    }, {
      props: ({
        ownerState: n
      }) => n.anchorOrigin.vertical === "top" && n.anchorOrigin.horizontal === "left" && n.overlap === "rectangular",
      style: {
        top: 0,
        left: 0,
        transform: "scale(1) translate(-50%, -50%)",
        transformOrigin: "0% 0%",
        [`&.${Wc.invisible}`]: {
          transform: "scale(0) translate(-50%, -50%)"
        }
      }
    }, {
      props: ({
        ownerState: n
      }) => n.anchorOrigin.vertical === "bottom" && n.anchorOrigin.horizontal === "left" && n.overlap === "rectangular",
      style: {
        bottom: 0,
        left: 0,
        transform: "scale(1) translate(-50%, 50%)",
        transformOrigin: "0% 100%",
        [`&.${Wc.invisible}`]: {
          transform: "scale(0) translate(-50%, 50%)"
        }
      }
    }, {
      props: ({
        ownerState: n
      }) => n.anchorOrigin.vertical === "top" && n.anchorOrigin.horizontal === "right" && n.overlap === "circular",
      style: {
        top: "14%",
        right: "14%",
        transform: "scale(1) translate(50%, -50%)",
        transformOrigin: "100% 0%",
        [`&.${Wc.invisible}`]: {
          transform: "scale(0) translate(50%, -50%)"
        }
      }
    }, {
      props: ({
        ownerState: n
      }) => n.anchorOrigin.vertical === "bottom" && n.anchorOrigin.horizontal === "right" && n.overlap === "circular",
      style: {
        bottom: "14%",
        right: "14%",
        transform: "scale(1) translate(50%, 50%)",
        transformOrigin: "100% 100%",
        [`&.${Wc.invisible}`]: {
          transform: "scale(0) translate(50%, 50%)"
        }
      }
    }, {
      props: ({
        ownerState: n
      }) => n.anchorOrigin.vertical === "top" && n.anchorOrigin.horizontal === "left" && n.overlap === "circular",
      style: {
        top: "14%",
        left: "14%",
        transform: "scale(1) translate(-50%, -50%)",
        transformOrigin: "0% 0%",
        [`&.${Wc.invisible}`]: {
          transform: "scale(0) translate(-50%, -50%)"
        }
      }
    }, {
      props: ({
        ownerState: n
      }) => n.anchorOrigin.vertical === "bottom" && n.anchorOrigin.horizontal === "left" && n.overlap === "circular",
      style: {
        bottom: "14%",
        left: "14%",
        transform: "scale(1) translate(-50%, 50%)",
        transformOrigin: "0% 100%",
        [`&.${Wc.invisible}`]: {
          transform: "scale(0) translate(-50%, 50%)"
        }
      }
    }, {
      props: {
        invisible: !0
      },
      style: {
        transition: e.transitions.create("transform", {
          easing: e.transitions.easing.easeInOut,
          duration: e.transitions.duration.leavingScreen
        })
      }
    }]
  };
}), mF = /* @__PURE__ */ V.forwardRef(function(t, n) {
  var r, i, o, s, a, u;
  const c = Ot({
    props: t,
    name: "MuiBadge"
  }), {
    anchorOrigin: d = {
      vertical: "top",
      horizontal: "right"
    },
    className: f,
    component: h,
    components: m = {},
    componentsProps: v = {},
    children: x,
    overlap: C = "rectangular",
    color: E = "default",
    invisible: S = !1,
    max: w = 99,
    badgeContent: O,
    slots: A,
    slotProps: I,
    showZero: $ = !1,
    variant: L = "standard"
  } = c, B = _e(c, k3e), {
    badgeContent: H,
    invisible: q,
    max: J,
    displayValue: X
  } = w3e({
    max: w,
    invisible: S,
    badgeContent: O,
    showZero: $
  }), j = HI({
    anchorOrigin: d,
    color: E,
    overlap: C,
    variant: L,
    badgeContent: O
  }), U = q || H == null && L !== "dot", {
    color: G = E,
    overlap: K = C,
    anchorOrigin: ee = d,
    variant: te = L
  } = U ? j : c, M = te !== "dot" ? X : void 0, Z = N({}, c, {
    badgeContent: H,
    invisible: U,
    max: J,
    displayValue: M,
    showZero: $,
    anchorOrigin: ee,
    color: G,
    overlap: K,
    variant: te
  }), ne = O3e(Z), R = (r = (i = A == null ? void 0 : A.root) != null ? i : m.Root) != null ? r : I3e, _ = (o = (s = A == null ? void 0 : A.badge) != null ? s : m.Badge) != null ? o : F3e, W = (a = I == null ? void 0 : I.root) != null ? a : v.root, Q = (u = I == null ? void 0 : I.badge) != null ? u : v.badge, oe = Ai({
    elementType: R,
    externalSlotProps: W,
    externalForwardedProps: B,
    additionalProps: {
      ref: n,
      as: h
    },
    ownerState: Z,
    className: Be(W == null ? void 0 : W.className, ne.root, f)
  }), ae = Ai({
    elementType: _,
    externalSlotProps: Q,
    ownerState: Z,
    className: Be(ne.badge, Q == null ? void 0 : Q.className)
  });
  return /* @__PURE__ */ P.jsxs(R, N({}, oe, {
    children: [x, /* @__PURE__ */ P.jsx(_, N({}, ae, {
      children: M
    }))]
  }));
});
process.env.NODE_ENV !== "production" && (mF.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The anchor of the badge.
   * @default {
   *   vertical: 'top',
   *   horizontal: 'right',
   * }
   */
  anchorOrigin: l.shape({
    horizontal: l.oneOf(["left", "right"]).isRequired,
    vertical: l.oneOf(["bottom", "top"]).isRequired
  }),
  /**
   * The content rendered within the badge.
   */
  badgeContent: l.node,
  /**
   * The badge will be added relative to this node.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'default'
   */
  color: l.oneOfType([l.oneOf(["default", "primary", "secondary", "error", "info", "success", "warning"]), l.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: l.shape({
    Badge: l.elementType,
    Root: l.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: l.shape({
    badge: l.oneOfType([l.func, l.object]),
    root: l.oneOfType([l.func, l.object])
  }),
  /**
   * If `true`, the badge is invisible.
   * @default false
   */
  invisible: l.bool,
  /**
   * Max count to show.
   * @default 99
   */
  max: l.number,
  /**
   * Wrapped shape the badge should overlap.
   * @default 'rectangular'
   */
  overlap: l.oneOf(["circular", "rectangular"]),
  /**
   * Controls whether the badge is hidden when `badgeContent` is zero.
   * @default false
   */
  showZero: l.bool,
  /**
   * The props used for each slot inside the Badge.
   * @default {}
   */
  slotProps: l.shape({
    badge: l.oneOfType([l.func, l.object]),
    root: l.oneOfType([l.func, l.object])
  }),
  /**
   * The components used for each slot inside the Badge.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: l.shape({
    badge: l.elementType,
    root: l.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * The variant to use.
   * @default 'standard'
   */
  variant: l.oneOfType([l.oneOf(["dot", "standard"]), l.string])
});
const $3e = st("MuiBox", ["root"]), N3e = Hb(), Ar = pNe({
  themeId: Rb,
  defaultTheme: N3e,
  defaultClassName: $3e.root,
  generateClassName: zI.generate
});
process.env.NODE_ENV !== "production" && (Ar.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: l.node,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
function M3e(e) {
  return ot("MuiButton", e);
}
const U1 = st("MuiButton", ["root", "text", "textInherit", "textPrimary", "textSecondary", "textSuccess", "textError", "textInfo", "textWarning", "outlined", "outlinedInherit", "outlinedPrimary", "outlinedSecondary", "outlinedSuccess", "outlinedError", "outlinedInfo", "outlinedWarning", "contained", "containedInherit", "containedPrimary", "containedSecondary", "containedSuccess", "containedError", "containedInfo", "containedWarning", "disableElevation", "focusVisible", "disabled", "colorInherit", "colorPrimary", "colorSecondary", "colorSuccess", "colorError", "colorInfo", "colorWarning", "textSizeSmall", "textSizeMedium", "textSizeLarge", "outlinedSizeSmall", "outlinedSizeMedium", "outlinedSizeLarge", "containedSizeSmall", "containedSizeMedium", "containedSizeLarge", "sizeMedium", "sizeSmall", "sizeLarge", "fullWidth", "startIcon", "endIcon", "icon", "iconSizeSmall", "iconSizeMedium", "iconSizeLarge"]), VU = /* @__PURE__ */ V.createContext({});
process.env.NODE_ENV !== "production" && (VU.displayName = "ButtonGroupContext");
const zU = /* @__PURE__ */ V.createContext(void 0);
process.env.NODE_ENV !== "production" && (zU.displayName = "ButtonGroupButtonContext");
const R3e = ["children", "color", "component", "className", "disabled", "disableElevation", "disableFocusRipple", "endIcon", "focusVisibleClassName", "fullWidth", "size", "startIcon", "type", "variant"], _3e = (e) => {
  const {
    color: t,
    disableElevation: n,
    fullWidth: r,
    size: i,
    variant: o,
    classes: s
  } = e, a = {
    root: ["root", o, `${o}${Ue(t)}`, `size${Ue(i)}`, `${o}Size${Ue(i)}`, `color${Ue(t)}`, n && "disableElevation", r && "fullWidth"],
    label: ["label"],
    startIcon: ["icon", "startIcon", `iconSize${Ue(i)}`],
    endIcon: ["icon", "endIcon", `iconSize${Ue(i)}`]
  }, u = at(a, M3e, s);
  return N({}, s, u);
}, UU = (e) => N({}, e.size === "small" && {
  "& > *:nth-of-type(1)": {
    fontSize: 18
  }
}, e.size === "medium" && {
  "& > *:nth-of-type(1)": {
    fontSize: 20
  }
}, e.size === "large" && {
  "& > *:nth-of-type(1)": {
    fontSize: 22
  }
}), L3e = De(sa, {
  shouldForwardProp: (e) => Ao(e) || e === "classes",
  name: "MuiButton",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.variant], t[`${n.variant}${Ue(n.color)}`], t[`size${Ue(n.size)}`], t[`${n.variant}Size${Ue(n.size)}`], n.color === "inherit" && t.colorInherit, n.disableElevation && t.disableElevation, n.fullWidth && t.fullWidth];
  }
})(({
  theme: e,
  ownerState: t
}) => {
  var n, r;
  const i = e.palette.mode === "light" ? e.palette.grey[300] : e.palette.grey[800], o = e.palette.mode === "light" ? e.palette.grey.A100 : e.palette.grey[700];
  return N({}, e.typography.button, {
    minWidth: 64,
    padding: "6px 16px",
    borderRadius: (e.vars || e).shape.borderRadius,
    transition: e.transitions.create(["background-color", "box-shadow", "border-color", "color"], {
      duration: e.transitions.duration.short
    }),
    "&:hover": N({
      textDecoration: "none",
      backgroundColor: e.vars ? `rgba(${e.vars.palette.text.primaryChannel} / ${e.vars.palette.action.hoverOpacity})` : Yt(e.palette.text.primary, e.palette.action.hoverOpacity),
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    }, t.variant === "text" && t.color !== "inherit" && {
      backgroundColor: e.vars ? `rgba(${e.vars.palette[t.color].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : Yt(e.palette[t.color].main, e.palette.action.hoverOpacity),
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    }, t.variant === "outlined" && t.color !== "inherit" && {
      border: `1px solid ${(e.vars || e).palette[t.color].main}`,
      backgroundColor: e.vars ? `rgba(${e.vars.palette[t.color].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : Yt(e.palette[t.color].main, e.palette.action.hoverOpacity),
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: "transparent"
      }
    }, t.variant === "contained" && {
      backgroundColor: e.vars ? e.vars.palette.Button.inheritContainedHoverBg : o,
      boxShadow: (e.vars || e).shadows[4],
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        boxShadow: (e.vars || e).shadows[2],
        backgroundColor: (e.vars || e).palette.grey[300]
      }
    }, t.variant === "contained" && t.color !== "inherit" && {
      backgroundColor: (e.vars || e).palette[t.color].dark,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: (e.vars || e).palette[t.color].main
      }
    }),
    "&:active": N({}, t.variant === "contained" && {
      boxShadow: (e.vars || e).shadows[8]
    }),
    [`&.${U1.focusVisible}`]: N({}, t.variant === "contained" && {
      boxShadow: (e.vars || e).shadows[6]
    }),
    [`&.${U1.disabled}`]: N({
      color: (e.vars || e).palette.action.disabled
    }, t.variant === "outlined" && {
      border: `1px solid ${(e.vars || e).palette.action.disabledBackground}`
    }, t.variant === "contained" && {
      color: (e.vars || e).palette.action.disabled,
      boxShadow: (e.vars || e).shadows[0],
      backgroundColor: (e.vars || e).palette.action.disabledBackground
    })
  }, t.variant === "text" && {
    padding: "6px 8px"
  }, t.variant === "text" && t.color !== "inherit" && {
    color: (e.vars || e).palette[t.color].main
  }, t.variant === "outlined" && {
    padding: "5px 15px",
    border: "1px solid currentColor"
  }, t.variant === "outlined" && t.color !== "inherit" && {
    color: (e.vars || e).palette[t.color].main,
    border: e.vars ? `1px solid rgba(${e.vars.palette[t.color].mainChannel} / 0.5)` : `1px solid ${Yt(e.palette[t.color].main, 0.5)}`
  }, t.variant === "contained" && {
    color: e.vars ? (
      // this is safe because grey does not change between default light/dark mode
      e.vars.palette.text.primary
    ) : (n = (r = e.palette).getContrastText) == null ? void 0 : n.call(r, e.palette.grey[300]),
    backgroundColor: e.vars ? e.vars.palette.Button.inheritContainedBg : i,
    boxShadow: (e.vars || e).shadows[2]
  }, t.variant === "contained" && t.color !== "inherit" && {
    color: (e.vars || e).palette[t.color].contrastText,
    backgroundColor: (e.vars || e).palette[t.color].main
  }, t.color === "inherit" && {
    color: "inherit",
    borderColor: "currentColor"
  }, t.size === "small" && t.variant === "text" && {
    padding: "4px 5px",
    fontSize: e.typography.pxToRem(13)
  }, t.size === "large" && t.variant === "text" && {
    padding: "8px 11px",
    fontSize: e.typography.pxToRem(15)
  }, t.size === "small" && t.variant === "outlined" && {
    padding: "3px 9px",
    fontSize: e.typography.pxToRem(13)
  }, t.size === "large" && t.variant === "outlined" && {
    padding: "7px 21px",
    fontSize: e.typography.pxToRem(15)
  }, t.size === "small" && t.variant === "contained" && {
    padding: "4px 10px",
    fontSize: e.typography.pxToRem(13)
  }, t.size === "large" && t.variant === "contained" && {
    padding: "8px 22px",
    fontSize: e.typography.pxToRem(15)
  }, t.fullWidth && {
    width: "100%"
  });
}, ({
  ownerState: e
}) => e.disableElevation && {
  boxShadow: "none",
  "&:hover": {
    boxShadow: "none"
  },
  [`&.${U1.focusVisible}`]: {
    boxShadow: "none"
  },
  "&:active": {
    boxShadow: "none"
  },
  [`&.${U1.disabled}`]: {
    boxShadow: "none"
  }
}), B3e = De("span", {
  name: "MuiButton",
  slot: "StartIcon",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.startIcon, t[`iconSize${Ue(n.size)}`]];
  }
})(({
  ownerState: e
}) => N({
  display: "inherit",
  marginRight: 8,
  marginLeft: -4
}, e.size === "small" && {
  marginLeft: -2
}, UU(e))), j3e = De("span", {
  name: "MuiButton",
  slot: "EndIcon",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.endIcon, t[`iconSize${Ue(n.size)}`]];
  }
})(({
  ownerState: e
}) => N({
  display: "inherit",
  marginRight: -4,
  marginLeft: 8
}, e.size === "small" && {
  marginRight: -2
}, UU(e))), Nr = /* @__PURE__ */ V.forwardRef(function(t, n) {
  const r = V.useContext(VU), i = V.useContext(zU), o = R0(r, t), s = Ot({
    props: o,
    name: "MuiButton"
  }), {
    children: a,
    color: u = "primary",
    component: c = "button",
    className: d,
    disabled: f = !1,
    disableElevation: h = !1,
    disableFocusRipple: m = !1,
    endIcon: v,
    focusVisibleClassName: x,
    fullWidth: C = !1,
    size: E = "medium",
    startIcon: S,
    type: w,
    variant: O = "text"
  } = s, A = _e(s, R3e), I = N({}, s, {
    color: u,
    component: c,
    disabled: f,
    disableElevation: h,
    disableFocusRipple: m,
    fullWidth: C,
    size: E,
    type: w,
    variant: O
  }), $ = _3e(I), L = S && /* @__PURE__ */ P.jsx(B3e, {
    className: $.startIcon,
    ownerState: I,
    children: S
  }), B = v && /* @__PURE__ */ P.jsx(j3e, {
    className: $.endIcon,
    ownerState: I,
    children: v
  }), H = i || "";
  return /* @__PURE__ */ P.jsxs(L3e, N({
    ownerState: I,
    className: Be(r.className, $.root, d, H),
    component: c,
    disabled: f,
    focusRipple: !m,
    focusVisibleClassName: Be($.focusVisible, x),
    ref: n,
    type: w
  }, A, {
    classes: $,
    children: [L, a, B]
  }));
});
process.env.NODE_ENV !== "production" && (Nr.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: l.oneOfType([l.oneOf(["inherit", "primary", "secondary", "success", "error", "info", "warning"]), l.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: l.bool,
  /**
   * If `true`, no elevation is used.
   * @default false
   */
  disableElevation: l.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: l.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: l.bool,
  /**
   * Element placed after the children.
   */
  endIcon: l.node,
  /**
   * @ignore
   */
  focusVisibleClassName: l.string,
  /**
   * If `true`, the button will take up the full width of its container.
   * @default false
   */
  fullWidth: l.bool,
  /**
   * The URL to link to when the button is clicked.
   * If defined, an `a` element will be used as the root node.
   */
  href: l.string,
  /**
   * The size of the component.
   * `small` is equivalent to the dense button styling.
   * @default 'medium'
   */
  size: l.oneOfType([l.oneOf(["small", "medium", "large"]), l.string]),
  /**
   * Element placed before the children.
   */
  startIcon: l.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * @ignore
   */
  type: l.oneOfType([l.oneOf(["button", "reset", "submit"]), l.string]),
  /**
   * The variant to use.
   * @default 'text'
   */
  variant: l.oneOfType([l.oneOf(["contained", "outlined", "text"]), l.string])
});
function V3e(e) {
  return ot("MuiCard", e);
}
st("MuiCard", ["root"]);
const z3e = ["className", "raised"], U3e = (e) => {
  const {
    classes: t
  } = e;
  return at({
    root: ["root"]
  }, V3e, t);
}, W3e = De(ti, {
  name: "MuiCard",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(() => ({
  overflow: "hidden"
})), gF = /* @__PURE__ */ V.forwardRef(function(t, n) {
  const r = Ot({
    props: t,
    name: "MuiCard"
  }), {
    className: i,
    raised: o = !1
  } = r, s = _e(r, z3e), a = N({}, r, {
    raised: o
  }), u = U3e(a);
  return /* @__PURE__ */ P.jsx(W3e, N({
    className: Be(u.root, i),
    elevation: o ? 8 : void 0,
    ref: n,
    ownerState: a
  }, s));
});
process.env.NODE_ENV !== "production" && (gF.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * If `true`, the card will use raised styling.
   * @default false
   */
  raised: $s(l.bool, (e) => e.raised && e.variant === "outlined" ? new Error('MUI: Combining `raised={true}` with `variant="outlined"` has no effect.') : null),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
function H3e(e) {
  return ot("MuiCardContent", e);
}
st("MuiCardContent", ["root"]);
const q3e = ["className", "component"], G3e = (e) => {
  const {
    classes: t
  } = e;
  return at({
    root: ["root"]
  }, H3e, t);
}, Y3e = De("div", {
  name: "MuiCardContent",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(() => ({
  padding: 16,
  "&:last-child": {
    paddingBottom: 24
  }
})), yF = /* @__PURE__ */ V.forwardRef(function(t, n) {
  const r = Ot({
    props: t,
    name: "MuiCardContent"
  }), {
    className: i,
    component: o = "div"
  } = r, s = _e(r, q3e), a = N({}, r, {
    component: o
  }), u = G3e(a);
  return /* @__PURE__ */ P.jsx(Y3e, N({
    as: o,
    className: Be(u.root, i),
    ownerState: a,
    ref: n
  }, s));
});
process.env.NODE_ENV !== "production" && (yF.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
function K3e(e) {
  return ot("MuiCardHeader", e);
}
const D3 = st("MuiCardHeader", ["root", "avatar", "action", "content", "title", "subheader"]), J3e = ["action", "avatar", "className", "component", "disableTypography", "subheader", "subheaderTypographyProps", "title", "titleTypographyProps"], X3e = (e) => {
  const {
    classes: t
  } = e;
  return at({
    root: ["root"],
    avatar: ["avatar"],
    action: ["action"],
    content: ["content"],
    title: ["title"],
    subheader: ["subheader"]
  }, K3e, t);
}, Q3e = De("div", {
  name: "MuiCardHeader",
  slot: "Root",
  overridesResolver: (e, t) => N({
    [`& .${D3.title}`]: t.title,
    [`& .${D3.subheader}`]: t.subheader
  }, t.root)
})({
  display: "flex",
  alignItems: "center",
  padding: 16
}), Z3e = De("div", {
  name: "MuiCardHeader",
  slot: "Avatar",
  overridesResolver: (e, t) => t.avatar
})({
  display: "flex",
  flex: "0 0 auto",
  marginRight: 16
}), eje = De("div", {
  name: "MuiCardHeader",
  slot: "Action",
  overridesResolver: (e, t) => t.action
})({
  flex: "0 0 auto",
  alignSelf: "flex-start",
  marginTop: -4,
  marginRight: -8,
  marginBottom: -4
}), tje = De("div", {
  name: "MuiCardHeader",
  slot: "Content",
  overridesResolver: (e, t) => t.content
})({
  flex: "1 1 auto"
}), bF = /* @__PURE__ */ V.forwardRef(function(t, n) {
  const r = Ot({
    props: t,
    name: "MuiCardHeader"
  }), {
    action: i,
    avatar: o,
    className: s,
    component: a = "div",
    disableTypography: u = !1,
    subheader: c,
    subheaderTypographyProps: d,
    title: f,
    titleTypographyProps: h
  } = r, m = _e(r, J3e), v = N({}, r, {
    component: a,
    disableTypography: u
  }), x = X3e(v);
  let C = f;
  C != null && C.type !== cn && !u && (C = /* @__PURE__ */ P.jsx(cn, N({
    variant: o ? "body2" : "h5",
    className: x.title,
    component: "span",
    display: "block"
  }, h, {
    children: C
  })));
  let E = c;
  return E != null && E.type !== cn && !u && (E = /* @__PURE__ */ P.jsx(cn, N({
    variant: o ? "body2" : "body1",
    className: x.subheader,
    color: "text.secondary",
    component: "span",
    display: "block"
  }, d, {
    children: E
  }))), /* @__PURE__ */ P.jsxs(Q3e, N({
    className: Be(x.root, s),
    as: a,
    ref: n,
    ownerState: v
  }, m, {
    children: [o && /* @__PURE__ */ P.jsx(Z3e, {
      className: x.avatar,
      ownerState: v,
      children: o
    }), /* @__PURE__ */ P.jsxs(tje, {
      className: x.content,
      ownerState: v,
      children: [C, E]
    }), i && /* @__PURE__ */ P.jsx(eje, {
      className: x.action,
      ownerState: v,
      children: i
    })]
  }));
});
process.env.NODE_ENV !== "production" && (bF.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The action to display in the card header.
   */
  action: l.node,
  /**
   * The Avatar element to display.
   */
  avatar: l.node,
  /**
   * @ignore
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * If `true`, `subheader` and `title` won't be wrapped by a Typography component.
   * This can be useful to render an alternative Typography variant by wrapping
   * the `title` text, and optional `subheader` text
   * with the Typography component.
   * @default false
   */
  disableTypography: l.bool,
  /**
   * The content of the component.
   */
  subheader: l.node,
  /**
   * These props will be forwarded to the subheader
   * (as long as disableTypography is not `true`).
   */
  subheaderTypographyProps: l.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * The content of the component.
   */
  title: l.node,
  /**
   * These props will be forwarded to the title
   * (as long as disableTypography is not `true`).
   */
  titleTypographyProps: l.object
});
function nje(e) {
  return ot("PrivateSwitchBase", e);
}
st("PrivateSwitchBase", ["root", "checked", "disabled", "input", "edgeStart", "edgeEnd"]);
const rje = ["autoFocus", "checked", "checkedIcon", "className", "defaultChecked", "disabled", "disableFocusRipple", "edge", "icon", "id", "inputProps", "inputRef", "name", "onBlur", "onChange", "onFocus", "readOnly", "required", "tabIndex", "type", "value"], ije = (e) => {
  const {
    classes: t,
    checked: n,
    disabled: r,
    edge: i
  } = e, o = {
    root: ["root", n && "checked", r && "disabled", i && `edge${Ue(i)}`],
    input: ["input"]
  };
  return at(o, nje, t);
}, oje = De(sa)(({
  ownerState: e
}) => N({
  padding: 9,
  borderRadius: "50%"
}, e.edge === "start" && {
  marginLeft: e.size === "small" ? -3 : -12
}, e.edge === "end" && {
  marginRight: e.size === "small" ? -3 : -12
})), sje = De("input", {
  shouldForwardProp: Ao
})({
  cursor: "inherit",
  position: "absolute",
  opacity: 0,
  width: "100%",
  height: "100%",
  top: 0,
  left: 0,
  margin: 0,
  padding: 0,
  zIndex: 1
}), VE = /* @__PURE__ */ V.forwardRef(function(t, n) {
  const {
    autoFocus: r,
    checked: i,
    checkedIcon: o,
    className: s,
    defaultChecked: a,
    disabled: u,
    disableFocusRipple: c = !1,
    edge: d = !1,
    icon: f,
    id: h,
    inputProps: m,
    inputRef: v,
    name: x,
    onBlur: C,
    onChange: E,
    onFocus: S,
    readOnly: w,
    required: O = !1,
    tabIndex: A,
    type: I,
    value: $
  } = t, L = _e(t, rje), [B, H] = Hi({
    controlled: i,
    default: !!a,
    name: "SwitchBase",
    state: "checked"
  }), q = Tu(), J = (te) => {
    S && S(te), q && q.onFocus && q.onFocus(te);
  }, X = (te) => {
    C && C(te), q && q.onBlur && q.onBlur(te);
  }, j = (te) => {
    if (te.nativeEvent.defaultPrevented)
      return;
    const M = te.target.checked;
    H(M), E && E(te, M);
  };
  let U = u;
  q && typeof U > "u" && (U = q.disabled);
  const G = I === "checkbox" || I === "radio", K = N({}, t, {
    checked: B,
    disabled: U,
    disableFocusRipple: c,
    edge: d
  }), ee = ije(K);
  return /* @__PURE__ */ P.jsxs(oje, N({
    component: "span",
    className: Be(ee.root, s),
    centerRipple: !0,
    focusRipple: !c,
    disabled: U,
    tabIndex: null,
    role: void 0,
    onFocus: J,
    onBlur: X,
    ownerState: K,
    ref: n
  }, L, {
    children: [/* @__PURE__ */ P.jsx(sje, N({
      autoFocus: r,
      checked: i,
      defaultChecked: a,
      className: ee.input,
      disabled: U,
      id: G ? h : void 0,
      name: x,
      onChange: j,
      readOnly: w,
      ref: v,
      required: O,
      ownerState: K,
      tabIndex: A,
      type: I
    }, I === "checkbox" && $ === void 0 ? {} : {
      value: $
    }, m)), B ? o : f]
  }));
});
process.env.NODE_ENV !== "production" && (VE.propTypes = {
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: l.bool,
  /**
   * If `true`, the component is checked.
   */
  checked: l.bool,
  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: l.node.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * @ignore
   */
  defaultChecked: l.bool,
  /**
   * If `true`, the component is disabled.
   */
  disabled: l.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: l.bool,
  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */
  edge: l.oneOf(["end", "start", !1]),
  /**
   * The icon to display when the component is unchecked.
   */
  icon: l.node.isRequired,
  /**
   * The id of the `input` element.
   */
  id: l.string,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: l.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: wr,
  /*
   * @ignore
   */
  name: l.string,
  /**
   * @ignore
   */
  onBlur: l.func,
  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: l.func,
  /**
   * @ignore
   */
  onFocus: l.func,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: l.bool,
  /**
   * If `true`, the `input` element is required.
   */
  required: l.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.object,
  /**
   * @ignore
   */
  tabIndex: l.oneOfType([l.number, l.string]),
  /**
   * The input component prop `type`.
   */
  type: l.string.isRequired,
  /**
   * The value of the component.
   */
  value: l.any
});
const aje = Rr(/* @__PURE__ */ P.jsx("path", {
  d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), "CheckBoxOutlineBlank"), lje = Rr(/* @__PURE__ */ P.jsx("path", {
  d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), "CheckBox"), uje = Rr(/* @__PURE__ */ P.jsx("path", {
  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), "IndeterminateCheckBox");
function cje(e) {
  return ot("MuiCheckbox", e);
}
const KA = st("MuiCheckbox", ["root", "checked", "disabled", "indeterminate", "colorPrimary", "colorSecondary", "sizeSmall", "sizeMedium"]), dje = ["checkedIcon", "color", "icon", "indeterminate", "indeterminateIcon", "inputProps", "size", "className"], pje = (e) => {
  const {
    classes: t,
    indeterminate: n,
    color: r,
    size: i
  } = e, o = {
    root: ["root", n && "indeterminate", `color${Ue(r)}`, `size${Ue(i)}`]
  }, s = at(o, cje, t);
  return N({}, t, s);
}, fje = De(VE, {
  shouldForwardProp: (e) => Ao(e) || e === "classes",
  name: "MuiCheckbox",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.indeterminate && t.indeterminate, t[`size${Ue(n.size)}`], n.color !== "default" && t[`color${Ue(n.color)}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => N({
  color: (e.vars || e).palette.text.secondary
}, !t.disableRipple && {
  "&:hover": {
    backgroundColor: e.vars ? `rgba(${t.color === "default" ? e.vars.palette.action.activeChannel : e.vars.palette[t.color].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : Yt(t.color === "default" ? e.palette.action.active : e.palette[t.color].main, e.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  }
}, t.color !== "default" && {
  [`&.${KA.checked}, &.${KA.indeterminate}`]: {
    color: (e.vars || e).palette[t.color].main
  },
  [`&.${KA.disabled}`]: {
    color: (e.vars || e).palette.action.disabled
  }
})), hje = /* @__PURE__ */ P.jsx(lje, {}), mje = /* @__PURE__ */ P.jsx(aje, {}), gje = /* @__PURE__ */ P.jsx(uje, {}), rc = /* @__PURE__ */ V.forwardRef(function(t, n) {
  var r, i;
  const o = Ot({
    props: t,
    name: "MuiCheckbox"
  }), {
    checkedIcon: s = hje,
    color: a = "primary",
    icon: u = mje,
    indeterminate: c = !1,
    indeterminateIcon: d = gje,
    inputProps: f,
    size: h = "medium",
    className: m
  } = o, v = _e(o, dje), x = c ? d : u, C = c ? d : s, E = N({}, o, {
    color: a,
    indeterminate: c,
    size: h
  }), S = pje(E);
  return /* @__PURE__ */ P.jsx(fje, N({
    type: "checkbox",
    inputProps: N({
      "data-indeterminate": c
    }, f),
    icon: /* @__PURE__ */ V.cloneElement(x, {
      fontSize: (r = x.props.fontSize) != null ? r : h
    }),
    checkedIcon: /* @__PURE__ */ V.cloneElement(C, {
      fontSize: (i = C.props.fontSize) != null ? i : h
    }),
    ownerState: E,
    ref: n,
    className: Be(S.root, m)
  }, v, {
    classes: S
  }));
});
process.env.NODE_ENV !== "production" && (rc.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the component is checked.
   */
  checked: l.bool,
  /**
   * The icon to display when the component is checked.
   * @default <CheckBoxIcon />
   */
  checkedIcon: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: l.oneOfType([l.oneOf(["default", "primary", "secondary", "error", "info", "success", "warning"]), l.string]),
  /**
   * The default checked state. Use when the component is not controlled.
   */
  defaultChecked: l.bool,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: l.bool,
  /**
   * If `true`, the ripple effect is disabled.
   * @default false
   */
  disableRipple: l.bool,
  /**
   * The icon to display when the component is unchecked.
   * @default <CheckBoxOutlineBlankIcon />
   */
  icon: l.node,
  /**
   * The id of the `input` element.
   */
  id: l.string,
  /**
   * If `true`, the component appears indeterminate.
   * This does not set the native input element to indeterminate due
   * to inconsistent behavior across browsers.
   * However, we set a `data-indeterminate` attribute on the `input`.
   * @default false
   */
  indeterminate: l.bool,
  /**
   * The icon to display when the component is indeterminate.
   * @default <IndeterminateCheckBoxIcon />
   */
  indeterminateIcon: l.node,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: l.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: wr,
  /**
   * Callback fired when the state is changed.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: l.func,
  /**
   * If `true`, the `input` element is required.
   * @default false
   */
  required: l.bool,
  /**
   * The size of the component.
   * `small` is equivalent to the dense checkbox styling.
   * @default 'medium'
   */
  size: l.oneOfType([l.oneOf(["medium", "small"]), l.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * The value of the component. The DOM API casts this to a string.
   * The browser uses "on" as the default value.
   */
  value: l.any
});
const WU = uMe({
  createStyledComponent: De("div", {
    name: "MuiContainer",
    slot: "Root",
    overridesResolver: (e, t) => {
      const {
        ownerState: n
      } = e;
      return [t.root, t[`maxWidth${Ue(String(n.maxWidth))}`], n.fixed && t.fixed, n.disableGutters && t.disableGutters];
    }
  }),
  useThemeProps: (e) => Ot({
    props: e,
    name: "MuiContainer"
  })
});
process.env.NODE_ENV !== "production" && (WU.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * @ignore
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * If `true`, the left and right padding is removed.
   * @default false
   */
  disableGutters: l.bool,
  /**
   * Set the max-width to match the min-width of the current breakpoint.
   * This is useful if you'd prefer to design for a fixed set of sizes
   * instead of trying to accommodate a fully fluid viewport.
   * It's fluid by default.
   * @default false
   */
  fixed: l.bool,
  /**
   * Determine the max-width of the container.
   * The container width grows with the size of the screen.
   * Set to `false` to disable `maxWidth`.
   * @default 'lg'
   */
  maxWidth: l.oneOfType([l.oneOf(["xs", "sm", "md", "lg", "xl", !1]), l.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
const yje = (e, t) => N({
  WebkitFontSmoothing: "antialiased",
  // Antialiasing.
  MozOsxFontSmoothing: "grayscale",
  // Antialiasing.
  // Change from `box-sizing: content-box` so that `width`
  // is not affected by `padding` or `border`.
  boxSizing: "border-box",
  // Fix font resize problem in iOS
  WebkitTextSizeAdjust: "100%"
}, t && !e.vars && {
  colorScheme: e.palette.mode
}), bje = (e) => N({
  color: (e.vars || e).palette.text.primary
}, e.typography.body1, {
  backgroundColor: (e.vars || e).palette.background.default,
  "@media print": {
    // Save printer ink.
    backgroundColor: (e.vars || e).palette.common.white
  }
}), vje = (e, t = !1) => {
  var n;
  const r = {};
  t && e.colorSchemes && Object.entries(e.colorSchemes).forEach(([s, a]) => {
    var u;
    r[e.getColorSchemeSelector(s).replace(/\s*&/, "")] = {
      colorScheme: (u = a.palette) == null ? void 0 : u.mode
    };
  });
  let i = N({
    html: yje(e, t),
    "*, *::before, *::after": {
      boxSizing: "inherit"
    },
    "strong, b": {
      fontWeight: e.typography.fontWeightBold
    },
    body: N({
      margin: 0
    }, bje(e), {
      // Add support for document.body.requestFullScreen().
      // Other elements, if background transparent, are not supported.
      "&::backdrop": {
        backgroundColor: (e.vars || e).palette.background.default
      }
    })
  }, r);
  const o = (n = e.components) == null || (n = n.MuiCssBaseline) == null ? void 0 : n.styleOverrides;
  return o && (i = [i, o]), i;
};
function HU(e) {
  const t = Ot({
    props: e,
    name: "MuiCssBaseline"
  }), {
    children: n,
    enableColorScheme: r = !1
  } = t;
  return /* @__PURE__ */ P.jsxs(V.Fragment, {
    children: [/* @__PURE__ */ P.jsx(pF, {
      styles: (i) => vje(i, r)
    }), n]
  });
}
process.env.NODE_ENV !== "production" && (HU.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * You can wrap a node.
   */
  children: l.node,
  /**
   * Enable `color-scheme` CSS property to use `theme.palette.mode`.
   * For more details, check out https://developer.mozilla.org/en-US/docs/Web/CSS/color-scheme
   * For browser support, check out https://caniuse.com/?search=color-scheme
   * @default false
   */
  enableColorScheme: l.bool
});
function xje(e) {
  const t = ei(e);
  return t.body === e ? bu(e).innerWidth > t.documentElement.clientWidth : e.scrollHeight > e.clientHeight;
}
function c0(e, t) {
  t ? e.setAttribute("aria-hidden", "true") : e.removeAttribute("aria-hidden");
}
function C3(e) {
  return parseInt(bu(e).getComputedStyle(e).paddingRight, 10) || 0;
}
function Dje(e) {
  const n = ["TEMPLATE", "SCRIPT", "STYLE", "LINK", "MAP", "META", "NOSCRIPT", "PICTURE", "COL", "COLGROUP", "PARAM", "SLOT", "SOURCE", "TRACK"].indexOf(e.tagName) !== -1, r = e.tagName === "INPUT" && e.getAttribute("type") === "hidden";
  return n || r;
}
function E3(e, t, n, r, i) {
  const o = [t, n, ...r];
  [].forEach.call(e.children, (s) => {
    const a = o.indexOf(s) === -1, u = !Dje(s);
    a && u && c0(s, i);
  });
}
function JA(e, t) {
  let n = -1;
  return e.some((r, i) => t(r) ? (n = i, !0) : !1), n;
}
function Cje(e, t) {
  const n = [], r = e.container;
  if (!t.disableScrollLock) {
    if (xje(r)) {
      const s = Zz(ei(r));
      n.push({
        value: r.style.paddingRight,
        property: "padding-right",
        el: r
      }), r.style.paddingRight = `${C3(r) + s}px`;
      const a = ei(r).querySelectorAll(".mui-fixed");
      [].forEach.call(a, (u) => {
        n.push({
          value: u.style.paddingRight,
          property: "padding-right",
          el: u
        }), u.style.paddingRight = `${C3(u) + s}px`;
      });
    }
    let o;
    if (r.parentNode instanceof DocumentFragment)
      o = ei(r).body;
    else {
      const s = r.parentElement, a = bu(r);
      o = (s == null ? void 0 : s.nodeName) === "HTML" && a.getComputedStyle(s).overflowY === "scroll" ? s : r;
    }
    n.push({
      value: o.style.overflow,
      property: "overflow",
      el: o
    }, {
      value: o.style.overflowX,
      property: "overflow-x",
      el: o
    }, {
      value: o.style.overflowY,
      property: "overflow-y",
      el: o
    }), o.style.overflow = "hidden";
  }
  return () => {
    n.forEach(({
      value: o,
      el: s,
      property: a
    }) => {
      o ? s.style.setProperty(a, o) : s.style.removeProperty(a);
    });
  };
}
function Eje(e) {
  const t = [];
  return [].forEach.call(e.children, (n) => {
    n.getAttribute("aria-hidden") === "true" && t.push(n);
  }), t;
}
class Tje {
  constructor() {
    this.containers = void 0, this.modals = void 0, this.modals = [], this.containers = [];
  }
  add(t, n) {
    let r = this.modals.indexOf(t);
    if (r !== -1)
      return r;
    r = this.modals.length, this.modals.push(t), t.modalRef && c0(t.modalRef, !1);
    const i = Eje(n);
    E3(n, t.mount, t.modalRef, i, !0);
    const o = JA(this.containers, (s) => s.container === n);
    return o !== -1 ? (this.containers[o].modals.push(t), r) : (this.containers.push({
      modals: [t],
      container: n,
      restore: null,
      hiddenSiblings: i
    }), r);
  }
  mount(t, n) {
    const r = JA(this.containers, (o) => o.modals.indexOf(t) !== -1), i = this.containers[r];
    i.restore || (i.restore = Cje(i, n));
  }
  remove(t, n = !0) {
    const r = this.modals.indexOf(t);
    if (r === -1)
      return r;
    const i = JA(this.containers, (s) => s.modals.indexOf(t) !== -1), o = this.containers[i];
    if (o.modals.splice(o.modals.indexOf(t), 1), this.modals.splice(r, 1), o.modals.length === 0)
      o.restore && o.restore(), t.modalRef && c0(t.modalRef, n), E3(o.container, t.mount, t.modalRef, o.hiddenSiblings, !1), this.containers.splice(i, 1);
    else {
      const s = o.modals[o.modals.length - 1];
      s.modalRef && c0(s.modalRef, !1);
    }
    return r;
  }
  isTopModal(t) {
    return this.modals.length > 0 && this.modals[this.modals.length - 1] === t;
  }
}
const Sje = ["input", "select", "textarea", "a[href]", "button", "[tabindex]", "audio[controls]", "video[controls]", '[contenteditable]:not([contenteditable="false"])'].join(",");
function Aje(e) {
  const t = parseInt(e.getAttribute("tabindex") || "", 10);
  return Number.isNaN(t) ? e.contentEditable === "true" || (e.nodeName === "AUDIO" || e.nodeName === "VIDEO" || e.nodeName === "DETAILS") && e.getAttribute("tabindex") === null ? 0 : e.tabIndex : t;
}
function wje(e) {
  if (e.tagName !== "INPUT" || e.type !== "radio" || !e.name)
    return !1;
  const t = (r) => e.ownerDocument.querySelector(`input[type="radio"]${r}`);
  let n = t(`[name="${e.name}"]:checked`);
  return n || (n = t(`[name="${e.name}"]`)), n !== e;
}
function Pje(e) {
  return !(e.disabled || e.tagName === "INPUT" && e.type === "hidden" || wje(e));
}
function kje(e) {
  const t = [], n = [];
  return Array.from(e.querySelectorAll(Sje)).forEach((r, i) => {
    const o = Aje(r);
    o === -1 || !Pje(r) || (o === 0 ? t.push(r) : n.push({
      documentOrder: i,
      tabIndex: o,
      node: r
    }));
  }), n.sort((r, i) => r.tabIndex === i.tabIndex ? r.documentOrder - i.documentOrder : r.tabIndex - i.tabIndex).map((r) => r.node).concat(t);
}
function Oje() {
  return !0;
}
function z0(e) {
  const {
    children: t,
    disableAutoFocus: n = !1,
    disableEnforceFocus: r = !1,
    disableRestoreFocus: i = !1,
    getTabbable: o = kje,
    isEnabled: s = Oje,
    open: a
  } = e, u = V.useRef(!1), c = V.useRef(null), d = V.useRef(null), f = V.useRef(null), h = V.useRef(null), m = V.useRef(!1), v = V.useRef(null), x = Hn(t.ref, v), C = V.useRef(null);
  V.useEffect(() => {
    !a || !v.current || (m.current = !n);
  }, [n, a]), V.useEffect(() => {
    if (!a || !v.current)
      return;
    const w = ei(v.current);
    return v.current.contains(w.activeElement) || (v.current.hasAttribute("tabIndex") || (process.env.NODE_ENV !== "production" && console.error(["MUI: The modal content node does not accept focus.", 'For the benefit of assistive technologies, the tabIndex of the node is being set to "-1".'].join(`
`)), v.current.setAttribute("tabIndex", "-1")), m.current && v.current.focus()), () => {
      i || (f.current && f.current.focus && (u.current = !0, f.current.focus()), f.current = null);
    };
  }, [a]), V.useEffect(() => {
    if (!a || !v.current)
      return;
    const w = ei(v.current), O = ($) => {
      C.current = $, !(r || !s() || $.key !== "Tab") && w.activeElement === v.current && $.shiftKey && (u.current = !0, d.current && d.current.focus());
    }, A = () => {
      const $ = v.current;
      if ($ === null)
        return;
      if (!w.hasFocus() || !s() || u.current) {
        u.current = !1;
        return;
      }
      if ($.contains(w.activeElement) || r && w.activeElement !== c.current && w.activeElement !== d.current)
        return;
      if (w.activeElement !== h.current)
        h.current = null;
      else if (h.current !== null)
        return;
      if (!m.current)
        return;
      let L = [];
      if ((w.activeElement === c.current || w.activeElement === d.current) && (L = o(v.current)), L.length > 0) {
        var B, H;
        const q = !!((B = C.current) != null && B.shiftKey && ((H = C.current) == null ? void 0 : H.key) === "Tab"), J = L[0], X = L[L.length - 1];
        typeof J != "string" && typeof X != "string" && (q ? X.focus() : J.focus());
      } else
        $.focus();
    };
    w.addEventListener("focusin", A), w.addEventListener("keydown", O, !0);
    const I = setInterval(() => {
      w.activeElement && w.activeElement.tagName === "BODY" && A();
    }, 50);
    return () => {
      clearInterval(I), w.removeEventListener("focusin", A), w.removeEventListener("keydown", O, !0);
    };
  }, [n, r, i, s, a, o]);
  const E = (w) => {
    f.current === null && (f.current = w.relatedTarget), m.current = !0, h.current = w.target;
    const O = t.props.onFocus;
    O && O(w);
  }, S = (w) => {
    f.current === null && (f.current = w.relatedTarget), m.current = !0;
  };
  return /* @__PURE__ */ P.jsxs(V.Fragment, {
    children: [/* @__PURE__ */ P.jsx("div", {
      tabIndex: a ? 0 : -1,
      onFocus: S,
      ref: c,
      "data-testid": "sentinelStart"
    }), /* @__PURE__ */ V.cloneElement(t, {
      ref: x,
      onFocus: E
    }), /* @__PURE__ */ P.jsx("div", {
      tabIndex: a ? 0 : -1,
      onFocus: S,
      ref: d,
      "data-testid": "sentinelEnd"
    })]
  });
}
process.env.NODE_ENV !== "production" && (z0.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │ To update them, edit the TypeScript types and run `pnpm proptypes`. │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A single child content element.
   */
  children: ig,
  /**
   * If `true`, the focus trap will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any focus trap children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the focus trap less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableAutoFocus: l.bool,
  /**
   * If `true`, the focus trap will not prevent focus from leaving the focus trap while open.
   *
   * Generally this should never be set to `true` as it makes the focus trap less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableEnforceFocus: l.bool,
  /**
   * If `true`, the focus trap will not restore focus to previously focused element once
   * focus trap is hidden or unmounted.
   * @default false
   */
  disableRestoreFocus: l.bool,
  /**
   * Returns an array of ordered tabbable nodes (i.e. in tab order) within the root.
   * For instance, you can provide the "tabbable" npm dependency.
   * @param {HTMLElement} root
   */
  getTabbable: l.func,
  /**
   * This prop extends the `open` prop.
   * It allows to toggle the open state without having to wait for a rerender when changing the `open` prop.
   * This prop should be memoized.
   * It can be used to support multiple focus trap mounted at the same time.
   * @default function defaultIsEnabled(): boolean {
   *   return true;
   * }
   */
  isEnabled: l.func,
  /**
   * If `true`, focus is locked.
   */
  open: l.bool.isRequired
});
process.env.NODE_ENV !== "production" && (z0.propTypes = Xz(z0.propTypes));
function Ije(e) {
  return typeof e == "function" ? e() : e;
}
function Fje(e) {
  return e ? e.props.hasOwnProperty("in") : !1;
}
const $je = new Tje();
function Nje(e) {
  const {
    container: t,
    disableEscapeKeyDown: n = !1,
    disableScrollLock: r = !1,
    // @ts-ignore internal logic - Base UI supports the manager as a prop too
    manager: i = $je,
    closeAfterTransition: o = !1,
    onTransitionEnter: s,
    onTransitionExited: a,
    children: u,
    onClose: c,
    open: d,
    rootRef: f
  } = e, h = V.useRef({}), m = V.useRef(null), v = V.useRef(null), x = Hn(v, f), [C, E] = V.useState(!d), S = Fje(u);
  let w = !0;
  (e["aria-hidden"] === "false" || e["aria-hidden"] === !1) && (w = !1);
  const O = () => ei(m.current), A = () => (h.current.modalRef = v.current, h.current.mount = m.current, h.current), I = () => {
    i.mount(A(), {
      disableScrollLock: r
    }), v.current && (v.current.scrollTop = 0);
  }, $ = Mt(() => {
    const G = Ije(t) || O().body;
    i.add(A(), G), v.current && I();
  }), L = V.useCallback(() => i.isTopModal(A()), [i]), B = Mt((G) => {
    m.current = G, G && (d && L() ? I() : v.current && c0(v.current, w));
  }), H = V.useCallback(() => {
    i.remove(A(), w);
  }, [w, i]);
  V.useEffect(() => () => {
    H();
  }, [H]), V.useEffect(() => {
    d ? $() : (!S || !o) && H();
  }, [d, H, S, o, $]);
  const q = (G) => (K) => {
    var ee;
    (ee = G.onKeyDown) == null || ee.call(G, K), !(K.key !== "Escape" || K.which === 229 || // Wait until IME is settled.
    !L()) && (n || (K.stopPropagation(), c && c(K, "escapeKeyDown")));
  }, J = (G) => (K) => {
    var ee;
    (ee = G.onClick) == null || ee.call(G, K), K.target === K.currentTarget && c && c(K, "backdropClick");
  };
  return {
    getRootProps: (G = {}) => {
      const K = a0(e);
      delete K.onTransitionEnter, delete K.onTransitionExited;
      const ee = N({}, K, G);
      return N({
        role: "presentation"
      }, ee, {
        onKeyDown: q(ee),
        ref: x
      });
    },
    getBackdropProps: (G = {}) => {
      const K = G;
      return N({
        "aria-hidden": !0
      }, K, {
        onClick: J(K),
        open: d
      });
    },
    getTransitionProps: () => {
      const G = () => {
        E(!1), s && s();
      }, K = () => {
        E(!0), a && a(), o && H();
      };
      return {
        onEnter: zD(G, u == null ? void 0 : u.props.onEnter),
        onExited: zD(K, u == null ? void 0 : u.props.onExited)
      };
    },
    rootRef: x,
    portalRef: B,
    isTopModal: L,
    exited: C,
    hasTransition: S
  };
}
function Mje(e) {
  return ot("MuiModal", e);
}
st("MuiModal", ["root", "hidden", "backdrop"]);
const Rje = ["BackdropComponent", "BackdropProps", "classes", "className", "closeAfterTransition", "children", "container", "component", "components", "componentsProps", "disableAutoFocus", "disableEnforceFocus", "disableEscapeKeyDown", "disablePortal", "disableRestoreFocus", "disableScrollLock", "hideBackdrop", "keepMounted", "onBackdropClick", "onClose", "onTransitionEnter", "onTransitionExited", "open", "slotProps", "slots", "theme"], _je = (e) => {
  const {
    open: t,
    exited: n,
    classes: r
  } = e;
  return at({
    root: ["root", !t && n && "hidden"],
    backdrop: ["backdrop"]
  }, Mje, r);
}, Lje = De("div", {
  name: "MuiModal",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, !n.open && n.exited && t.hidden];
  }
})(({
  theme: e,
  ownerState: t
}) => N({
  position: "fixed",
  zIndex: (e.vars || e).zIndex.modal,
  right: 0,
  bottom: 0,
  top: 0,
  left: 0
}, !t.open && t.exited && {
  visibility: "hidden"
})), Bje = De(hF, {
  name: "MuiModal",
  slot: "Backdrop",
  overridesResolver: (e, t) => t.backdrop
})({
  zIndex: -1
}), vF = /* @__PURE__ */ V.forwardRef(function(t, n) {
  var r, i, o, s, a, u;
  const c = Ot({
    name: "MuiModal",
    props: t
  }), {
    BackdropComponent: d = Bje,
    BackdropProps: f,
    className: h,
    closeAfterTransition: m = !1,
    children: v,
    container: x,
    component: C,
    components: E = {},
    componentsProps: S = {},
    disableAutoFocus: w = !1,
    disableEnforceFocus: O = !1,
    disableEscapeKeyDown: A = !1,
    disablePortal: I = !1,
    disableRestoreFocus: $ = !1,
    disableScrollLock: L = !1,
    hideBackdrop: B = !1,
    keepMounted: H = !1,
    onBackdropClick: q,
    open: J,
    slotProps: X,
    slots: j
    // eslint-disable-next-line react/prop-types
  } = c, U = _e(c, Rje), G = N({}, c, {
    closeAfterTransition: m,
    disableAutoFocus: w,
    disableEnforceFocus: O,
    disableEscapeKeyDown: A,
    disablePortal: I,
    disableRestoreFocus: $,
    disableScrollLock: L,
    hideBackdrop: B,
    keepMounted: H
  }), {
    getRootProps: K,
    getBackdropProps: ee,
    getTransitionProps: te,
    portalRef: M,
    isTopModal: Z,
    exited: ne,
    hasTransition: R
  } = Nje(N({}, G, {
    rootRef: n
  })), _ = N({}, G, {
    exited: ne
  }), W = _je(_), Q = {};
  if (v.props.tabIndex === void 0 && (Q.tabIndex = "-1"), R) {
    const {
      onEnter: ye,
      onExited: be
    } = te();
    Q.onEnter = ye, Q.onExited = be;
  }
  const oe = (r = (i = j == null ? void 0 : j.root) != null ? i : E.Root) != null ? r : Lje, ae = (o = (s = j == null ? void 0 : j.backdrop) != null ? s : E.Backdrop) != null ? o : d, pe = (a = X == null ? void 0 : X.root) != null ? a : S.root, me = (u = X == null ? void 0 : X.backdrop) != null ? u : S.backdrop, xe = Ai({
    elementType: oe,
    externalSlotProps: pe,
    externalForwardedProps: U,
    getSlotProps: K,
    additionalProps: {
      ref: n,
      as: C
    },
    ownerState: _,
    className: Be(h, pe == null ? void 0 : pe.className, W == null ? void 0 : W.root, !_.open && _.exited && (W == null ? void 0 : W.hidden))
  }), le = Ai({
    elementType: ae,
    externalSlotProps: me,
    additionalProps: f,
    getSlotProps: (ye) => ee(N({}, ye, {
      onClick: (be) => {
        q && q(be), ye != null && ye.onClick && ye.onClick(be);
      }
    })),
    className: Be(me == null ? void 0 : me.className, f == null ? void 0 : f.className, W == null ? void 0 : W.backdrop),
    ownerState: _
  });
  return !H && !J && (!R || ne) ? null : /* @__PURE__ */ P.jsx(V0, {
    ref: M,
    container: x,
    disablePortal: I,
    children: /* @__PURE__ */ P.jsxs(oe, N({}, xe, {
      children: [!B && d ? /* @__PURE__ */ P.jsx(ae, N({}, le)) : null, /* @__PURE__ */ P.jsx(z0, {
        disableEnforceFocus: O,
        disableAutoFocus: w,
        disableRestoreFocus: $,
        isEnabled: Z,
        open: J,
        children: /* @__PURE__ */ V.cloneElement(v, Q)
      })]
    }))
  });
});
process.env.NODE_ENV !== "production" && (vF.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A backdrop component. This prop enables custom backdrop rendering.
   * @deprecated Use `slots.backdrop` instead. While this prop currently works, it will be removed in the next major version.
   * Use the `slots.backdrop` prop to make your application ready for the next version of Material UI.
   * @default styled(Backdrop, {
   *   name: 'MuiModal',
   *   slot: 'Backdrop',
   *   overridesResolver: (props, styles) => {
   *     return styles.backdrop;
   *   },
   * })({
   *   zIndex: -1,
   * })
   */
  BackdropComponent: l.elementType,
  /**
   * Props applied to the [`Backdrop`](/material-ui/api/backdrop/) element.
   * @deprecated Use `slotProps.backdrop` instead.
   */
  BackdropProps: l.object,
  /**
   * A single child content element.
   */
  children: ig.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * When set to true the Modal waits until a nested Transition is completed before closing.
   * @default false
   */
  closeAfterTransition: l.bool,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: l.shape({
    Backdrop: l.elementType,
    Root: l.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: l.shape({
    backdrop: l.oneOfType([l.func, l.object]),
    root: l.oneOfType([l.func, l.object])
  }),
  /**
   * An HTML element or function that returns one.
   * The `container` will have the portal children appended to it.
   *
   * You can also provide a callback, which is called in a React layout effect.
   * This lets you set the container from a ref, and also makes server-side rendering possible.
   *
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: l.oneOfType([sc, l.func]),
  /**
   * If `true`, the modal will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any modal children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableAutoFocus: l.bool,
  /**
   * If `true`, the modal will not prevent focus from leaving the modal while open.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   * @default false
   */
  disableEnforceFocus: l.bool,
  /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   * @default false
   */
  disableEscapeKeyDown: l.bool,
  /**
   * The `children` will be under the DOM hierarchy of the parent component.
   * @default false
   */
  disablePortal: l.bool,
  /**
   * If `true`, the modal will not restore focus to previously focused element once
   * modal is hidden or unmounted.
   * @default false
   */
  disableRestoreFocus: l.bool,
  /**
   * Disable the scroll lock behavior.
   * @default false
   */
  disableScrollLock: l.bool,
  /**
   * If `true`, the backdrop is not rendered.
   * @default false
   */
  hideBackdrop: l.bool,
  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Modal.
   * @default false
   */
  keepMounted: l.bool,
  /**
   * Callback fired when the backdrop is clicked.
   * @deprecated Use the `onClose` prop with the `reason` argument to handle the `backdropClick` events.
   */
  onBackdropClick: l.func,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: l.func,
  /**
   * A function called when a transition enters.
   */
  onTransitionEnter: l.func,
  /**
   * A function called when a transition has exited.
   */
  onTransitionExited: l.func,
  /**
   * If `true`, the component is shown.
   */
  open: l.bool.isRequired,
  /**
   * The props used for each slot inside the Modal.
   * @default {}
   */
  slotProps: l.shape({
    backdrop: l.oneOfType([l.func, l.object]),
    root: l.oneOfType([l.func, l.object])
  }),
  /**
   * The components used for each slot inside the Modal.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: l.shape({
    backdrop: l.elementType,
    root: l.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
function jje(e) {
  return ot("MuiDialog", e);
}
const d0 = st("MuiDialog", ["root", "scrollPaper", "scrollBody", "container", "paper", "paperScrollPaper", "paperScrollBody", "paperWidthFalse", "paperWidthXs", "paperWidthSm", "paperWidthMd", "paperWidthLg", "paperWidthXl", "paperFullWidth", "paperFullScreen"]), xF = /* @__PURE__ */ V.createContext({});
process.env.NODE_ENV !== "production" && (xF.displayName = "DialogContext");
const Vje = ["aria-describedby", "aria-labelledby", "BackdropComponent", "BackdropProps", "children", "className", "disableEscapeKeyDown", "fullScreen", "fullWidth", "maxWidth", "onBackdropClick", "onClick", "onClose", "open", "PaperComponent", "PaperProps", "scroll", "TransitionComponent", "transitionDuration", "TransitionProps"], zje = De(hF, {
  name: "MuiDialog",
  slot: "Backdrop",
  overrides: (e, t) => t.backdrop
})({
  // Improve scrollable dialog support.
  zIndex: -1
}), Uje = (e) => {
  const {
    classes: t,
    scroll: n,
    maxWidth: r,
    fullWidth: i,
    fullScreen: o
  } = e, s = {
    root: ["root"],
    container: ["container", `scroll${Ue(n)}`],
    paper: ["paper", `paperScroll${Ue(n)}`, `paperWidth${Ue(String(r))}`, i && "paperFullWidth", o && "paperFullScreen"]
  };
  return at(s, jje, t);
}, Wje = De(vF, {
  name: "MuiDialog",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  "@media print": {
    // Use !important to override the Modal inline-style.
    position: "absolute !important"
  }
}), Hje = De("div", {
  name: "MuiDialog",
  slot: "Container",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.container, t[`scroll${Ue(n.scroll)}`]];
  }
})(({
  ownerState: e
}) => N({
  height: "100%",
  "@media print": {
    height: "auto"
  },
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}, e.scroll === "paper" && {
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
}, e.scroll === "body" && {
  overflowY: "auto",
  overflowX: "hidden",
  textAlign: "center",
  "&::after": {
    content: '""',
    display: "inline-block",
    verticalAlign: "middle",
    height: "100%",
    width: "0"
  }
})), qje = De(ti, {
  name: "MuiDialog",
  slot: "Paper",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.paper, t[`scrollPaper${Ue(n.scroll)}`], t[`paperWidth${Ue(String(n.maxWidth))}`], n.fullWidth && t.paperFullWidth, n.fullScreen && t.paperFullScreen];
  }
})(({
  theme: e,
  ownerState: t
}) => N({
  margin: 32,
  position: "relative",
  overflowY: "auto",
  // Fix IE11 issue, to remove at some point.
  "@media print": {
    overflowY: "visible",
    boxShadow: "none"
  }
}, t.scroll === "paper" && {
  display: "flex",
  flexDirection: "column",
  maxHeight: "calc(100% - 64px)"
}, t.scroll === "body" && {
  display: "inline-block",
  verticalAlign: "middle",
  textAlign: "left"
  // 'initial' doesn't work on IE11
}, !t.maxWidth && {
  maxWidth: "calc(100% - 64px)"
}, t.maxWidth === "xs" && {
  maxWidth: e.breakpoints.unit === "px" ? Math.max(e.breakpoints.values.xs, 444) : `max(${e.breakpoints.values.xs}${e.breakpoints.unit}, 444px)`,
  [`&.${d0.paperScrollBody}`]: {
    [e.breakpoints.down(Math.max(e.breakpoints.values.xs, 444) + 32 * 2)]: {
      maxWidth: "calc(100% - 64px)"
    }
  }
}, t.maxWidth && t.maxWidth !== "xs" && {
  maxWidth: `${e.breakpoints.values[t.maxWidth]}${e.breakpoints.unit}`,
  [`&.${d0.paperScrollBody}`]: {
    [e.breakpoints.down(e.breakpoints.values[t.maxWidth] + 32 * 2)]: {
      maxWidth: "calc(100% - 64px)"
    }
  }
}, t.fullWidth && {
  width: "calc(100% - 64px)"
}, t.fullScreen && {
  margin: 0,
  width: "100%",
  maxWidth: "100%",
  height: "100%",
  maxHeight: "none",
  borderRadius: 0,
  [`&.${d0.paperScrollBody}`]: {
    margin: 0,
    maxWidth: "100%"
  }
})), Zb = /* @__PURE__ */ V.forwardRef(function(t, n) {
  const r = Ot({
    props: t,
    name: "MuiDialog"
  }), i = Gi(), o = {
    enter: i.transitions.duration.enteringScreen,
    exit: i.transitions.duration.leavingScreen
  }, {
    "aria-describedby": s,
    "aria-labelledby": a,
    BackdropComponent: u,
    BackdropProps: c,
    children: d,
    className: f,
    disableEscapeKeyDown: h = !1,
    fullScreen: m = !1,
    fullWidth: v = !1,
    maxWidth: x = "sm",
    onBackdropClick: C,
    onClick: E,
    onClose: S,
    open: w,
    PaperComponent: O = ti,
    PaperProps: A = {},
    scroll: I = "paper",
    TransitionComponent: $ = ff,
    transitionDuration: L = o,
    TransitionProps: B
  } = r, H = _e(r, Vje), q = N({}, r, {
    disableEscapeKeyDown: h,
    fullScreen: m,
    fullWidth: v,
    maxWidth: x,
    scroll: I
  }), J = Uje(q), X = V.useRef(), j = (ee) => {
    X.current = ee.target === ee.currentTarget;
  }, U = (ee) => {
    E && E(ee), X.current && (X.current = null, C && C(ee), S && S(ee, "backdropClick"));
  }, G = Pl(a), K = V.useMemo(() => ({
    titleId: G
  }), [G]);
  return /* @__PURE__ */ P.jsx(Wje, N({
    className: Be(J.root, f),
    closeAfterTransition: !0,
    components: {
      Backdrop: zje
    },
    componentsProps: {
      backdrop: N({
        transitionDuration: L,
        as: u
      }, c)
    },
    disableEscapeKeyDown: h,
    onClose: S,
    open: w,
    ref: n,
    onClick: U,
    ownerState: q
  }, H, {
    children: /* @__PURE__ */ P.jsx($, N({
      appear: !0,
      in: w,
      timeout: L,
      role: "presentation"
    }, B, {
      children: /* @__PURE__ */ P.jsx(Hje, {
        className: Be(J.container),
        onMouseDown: j,
        ownerState: q,
        children: /* @__PURE__ */ P.jsx(qje, N({
          as: O,
          elevation: 24,
          role: "dialog",
          "aria-describedby": s,
          "aria-labelledby": G
        }, A, {
          className: Be(J.paper, A.className),
          ownerState: q,
          children: /* @__PURE__ */ P.jsx(xF.Provider, {
            value: K,
            children: d
          })
        }))
      })
    }))
  }));
});
process.env.NODE_ENV !== "production" && (Zb.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The id(s) of the element(s) that describe the dialog.
   */
  "aria-describedby": l.string,
  /**
   * The id(s) of the element(s) that label the dialog.
   */
  "aria-labelledby": l.string,
  /**
   * A backdrop component. This prop enables custom backdrop rendering.
   * @deprecated Use `slots.backdrop` instead. While this prop currently works, it will be removed in the next major version.
   * Use the `slots.backdrop` prop to make your application ready for the next version of Material UI.
   * @default styled(Backdrop, {
   *   name: 'MuiModal',
   *   slot: 'Backdrop',
   *   overridesResolver: (props, styles) => {
   *     return styles.backdrop;
   *   },
   * })({
   *   zIndex: -1,
   * })
   */
  BackdropComponent: l.elementType,
  /**
   * @ignore
   */
  BackdropProps: l.object,
  /**
   * Dialog children, usually the included sub-components.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   * @default false
   */
  disableEscapeKeyDown: l.bool,
  /**
   * If `true`, the dialog is full-screen.
   * @default false
   */
  fullScreen: l.bool,
  /**
   * If `true`, the dialog stretches to `maxWidth`.
   *
   * Notice that the dialog width grow is limited by the default margin.
   * @default false
   */
  fullWidth: l.bool,
  /**
   * Determine the max-width of the dialog.
   * The dialog width grows with the size of the screen.
   * Set to `false` to disable `maxWidth`.
   * @default 'sm'
   */
  maxWidth: l.oneOfType([l.oneOf(["xs", "sm", "md", "lg", "xl", !1]), l.string]),
  /**
   * Callback fired when the backdrop is clicked.
   * @deprecated Use the `onClose` prop with the `reason` argument to handle the `backdropClick` events.
   */
  onBackdropClick: l.func,
  /**
   * @ignore
   */
  onClick: l.func,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: l.func,
  /**
   * If `true`, the component is shown.
   */
  open: l.bool.isRequired,
  /**
   * The component used to render the body of the dialog.
   * @default Paper
   */
  PaperComponent: l.elementType,
  /**
   * Props applied to the [`Paper`](/material-ui/api/paper/) element.
   * @default {}
   */
  PaperProps: l.object,
  /**
   * Determine the container for scrolling the dialog.
   * @default 'paper'
   */
  scroll: l.oneOf(["body", "paper"]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Fade
   */
  TransitionComponent: l.elementType,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   * @default {
   *   enter: theme.transitions.duration.enteringScreen,
   *   exit: theme.transitions.duration.leavingScreen,
   * }
   */
  transitionDuration: l.oneOfType([l.number, l.shape({
    appear: l.number,
    enter: l.number,
    exit: l.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   */
  TransitionProps: l.object
});
function Gje(e) {
  return ot("MuiDialogActions", e);
}
st("MuiDialogActions", ["root", "spacing"]);
const Yje = ["className", "disableSpacing"], Kje = (e) => {
  const {
    classes: t,
    disableSpacing: n
  } = e;
  return at({
    root: ["root", !n && "spacing"]
  }, Gje, t);
}, Jje = De("div", {
  name: "MuiDialogActions",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, !n.disableSpacing && t.spacing];
  }
})(({
  ownerState: e
}) => N({
  display: "flex",
  alignItems: "center",
  padding: 8,
  justifyContent: "flex-end",
  flex: "0 0 auto"
}, !e.disableSpacing && {
  "& > :not(style) ~ :not(style)": {
    marginLeft: 8
  }
})), ev = /* @__PURE__ */ V.forwardRef(function(t, n) {
  const r = Ot({
    props: t,
    name: "MuiDialogActions"
  }), {
    className: i,
    disableSpacing: o = !1
  } = r, s = _e(r, Yje), a = N({}, r, {
    disableSpacing: o
  }), u = Kje(a);
  return /* @__PURE__ */ P.jsx(Jje, N({
    className: Be(u.root, i),
    ownerState: a,
    ref: n
  }, s));
});
process.env.NODE_ENV !== "production" && (ev.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * If `true`, the actions do not have additional margin.
   * @default false
   */
  disableSpacing: l.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
function Xje(e) {
  return ot("MuiDialogContent", e);
}
st("MuiDialogContent", ["root", "dividers"]);
function Qje(e) {
  return ot("MuiDialogTitle", e);
}
const Zje = st("MuiDialogTitle", ["root"]), e8e = ["className", "dividers"], t8e = (e) => {
  const {
    classes: t,
    dividers: n
  } = e;
  return at({
    root: ["root", n && "dividers"]
  }, Xje, t);
}, n8e = De("div", {
  name: "MuiDialogContent",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.dividers && t.dividers];
  }
})(({
  theme: e,
  ownerState: t
}) => N({
  flex: "1 1 auto",
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: "touch",
  overflowY: "auto",
  padding: "20px 24px"
}, t.dividers ? {
  padding: "16px 24px",
  borderTop: `1px solid ${(e.vars || e).palette.divider}`,
  borderBottom: `1px solid ${(e.vars || e).palette.divider}`
} : {
  [`.${Zje.root} + &`]: {
    paddingTop: 0
  }
})), tv = /* @__PURE__ */ V.forwardRef(function(t, n) {
  const r = Ot({
    props: t,
    name: "MuiDialogContent"
  }), {
    className: i,
    dividers: o = !1
  } = r, s = _e(r, e8e), a = N({}, r, {
    dividers: o
  }), u = t8e(a);
  return /* @__PURE__ */ P.jsx(n8e, N({
    className: Be(u.root, i),
    ownerState: a,
    ref: n
  }, s));
});
process.env.NODE_ENV !== "production" && (tv.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * Display the top and bottom dividers.
   * @default false
   */
  dividers: l.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
function r8e(e) {
  return ot("MuiDialogContentText", e);
}
st("MuiDialogContentText", ["root"]);
const i8e = ["children", "className"], o8e = (e) => {
  const {
    classes: t
  } = e, r = at({
    root: ["root"]
  }, r8e, t);
  return N({}, t, r);
}, s8e = De(cn, {
  shouldForwardProp: (e) => Ao(e) || e === "classes",
  name: "MuiDialogContentText",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), DF = /* @__PURE__ */ V.forwardRef(function(t, n) {
  const r = Ot({
    props: t,
    name: "MuiDialogContentText"
  }), {
    className: i
  } = r, o = _e(r, i8e), s = o8e(o);
  return /* @__PURE__ */ P.jsx(s8e, N({
    component: "p",
    variant: "body1",
    color: "text.secondary",
    ref: n,
    ownerState: o,
    className: Be(s.root, i)
  }, r, {
    classes: s
  }));
});
process.env.NODE_ENV !== "production" && (DF.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
const a8e = ["className", "id"], l8e = (e) => {
  const {
    classes: t
  } = e;
  return at({
    root: ["root"]
  }, Qje, t);
}, u8e = De(cn, {
  name: "MuiDialogTitle",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  padding: "16px 24px",
  flex: "0 0 auto"
}), zE = /* @__PURE__ */ V.forwardRef(function(t, n) {
  const r = Ot({
    props: t,
    name: "MuiDialogTitle"
  }), {
    className: i,
    id: o
  } = r, s = _e(r, a8e), a = r, u = l8e(a), {
    titleId: c = o
  } = V.useContext(xF);
  return /* @__PURE__ */ P.jsx(u8e, N({
    component: "h2",
    className: Be(u.root, i),
    ownerState: a,
    ref: n,
    variant: "h6",
    id: o ?? c
  }, s));
});
process.env.NODE_ENV !== "production" && (zE.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * @ignore
   */
  id: l.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
function c8e(e) {
  return ot("MuiDivider", e);
}
const T3 = st("MuiDivider", ["root", "absolute", "fullWidth", "inset", "middle", "flexItem", "light", "vertical", "withChildren", "withChildrenVertical", "textAlignRight", "textAlignLeft", "wrapper", "wrapperVertical"]), d8e = ["absolute", "children", "className", "component", "flexItem", "light", "orientation", "role", "textAlign", "variant"], p8e = (e) => {
  const {
    absolute: t,
    children: n,
    classes: r,
    flexItem: i,
    light: o,
    orientation: s,
    textAlign: a,
    variant: u
  } = e;
  return at({
    root: ["root", t && "absolute", u, o && "light", s === "vertical" && "vertical", i && "flexItem", n && "withChildren", n && s === "vertical" && "withChildrenVertical", a === "right" && s !== "vertical" && "textAlignRight", a === "left" && s !== "vertical" && "textAlignLeft"],
    wrapper: ["wrapper", s === "vertical" && "wrapperVertical"]
  }, c8e, r);
}, f8e = De("div", {
  name: "MuiDivider",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.absolute && t.absolute, t[n.variant], n.light && t.light, n.orientation === "vertical" && t.vertical, n.flexItem && t.flexItem, n.children && t.withChildren, n.children && n.orientation === "vertical" && t.withChildrenVertical, n.textAlign === "right" && n.orientation !== "vertical" && t.textAlignRight, n.textAlign === "left" && n.orientation !== "vertical" && t.textAlignLeft];
  }
})(({
  theme: e,
  ownerState: t
}) => N({
  margin: 0,
  // Reset browser default style.
  flexShrink: 0,
  borderWidth: 0,
  borderStyle: "solid",
  borderColor: (e.vars || e).palette.divider,
  borderBottomWidth: "thin"
}, t.absolute && {
  position: "absolute",
  bottom: 0,
  left: 0,
  width: "100%"
}, t.light && {
  borderColor: e.vars ? `rgba(${e.vars.palette.dividerChannel} / 0.08)` : Yt(e.palette.divider, 0.08)
}, t.variant === "inset" && {
  marginLeft: 72
}, t.variant === "middle" && t.orientation === "horizontal" && {
  marginLeft: e.spacing(2),
  marginRight: e.spacing(2)
}, t.variant === "middle" && t.orientation === "vertical" && {
  marginTop: e.spacing(1),
  marginBottom: e.spacing(1)
}, t.orientation === "vertical" && {
  height: "100%",
  borderBottomWidth: 0,
  borderRightWidth: "thin"
}, t.flexItem && {
  alignSelf: "stretch",
  height: "auto"
}), ({
  ownerState: e
}) => N({}, e.children && {
  display: "flex",
  whiteSpace: "nowrap",
  textAlign: "center",
  border: 0,
  borderTopStyle: "solid",
  borderLeftStyle: "solid",
  "&::before, &::after": {
    content: '""',
    alignSelf: "center"
  }
}), ({
  theme: e,
  ownerState: t
}) => N({}, t.children && t.orientation !== "vertical" && {
  "&::before, &::after": {
    width: "100%",
    borderTop: `thin solid ${(e.vars || e).palette.divider}`,
    borderTopStyle: "inherit"
  }
}), ({
  theme: e,
  ownerState: t
}) => N({}, t.children && t.orientation === "vertical" && {
  flexDirection: "column",
  "&::before, &::after": {
    height: "100%",
    borderLeft: `thin solid ${(e.vars || e).palette.divider}`,
    borderLeftStyle: "inherit"
  }
}), ({
  ownerState: e
}) => N({}, e.textAlign === "right" && e.orientation !== "vertical" && {
  "&::before": {
    width: "90%"
  },
  "&::after": {
    width: "10%"
  }
}, e.textAlign === "left" && e.orientation !== "vertical" && {
  "&::before": {
    width: "10%"
  },
  "&::after": {
    width: "90%"
  }
})), h8e = De("span", {
  name: "MuiDivider",
  slot: "Wrapper",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.wrapper, n.orientation === "vertical" && t.wrapperVertical];
  }
})(({
  theme: e,
  ownerState: t
}) => N({
  display: "inline-block",
  paddingLeft: `calc(${e.spacing(1)} * 1.2)`,
  paddingRight: `calc(${e.spacing(1)} * 1.2)`
}, t.orientation === "vertical" && {
  paddingTop: `calc(${e.spacing(1)} * 1.2)`,
  paddingBottom: `calc(${e.spacing(1)} * 1.2)`
})), U0 = /* @__PURE__ */ V.forwardRef(function(t, n) {
  const r = Ot({
    props: t,
    name: "MuiDivider"
  }), {
    absolute: i = !1,
    children: o,
    className: s,
    component: a = o ? "div" : "hr",
    flexItem: u = !1,
    light: c = !1,
    orientation: d = "horizontal",
    role: f = a !== "hr" ? "separator" : void 0,
    textAlign: h = "center",
    variant: m = "fullWidth"
  } = r, v = _e(r, d8e), x = N({}, r, {
    absolute: i,
    component: a,
    flexItem: u,
    light: c,
    orientation: d,
    role: f,
    textAlign: h,
    variant: m
  }), C = p8e(x);
  return /* @__PURE__ */ P.jsx(f8e, N({
    as: a,
    className: Be(C.root, s),
    role: f,
    ref: n,
    ownerState: x
  }, v, {
    children: o ? /* @__PURE__ */ P.jsx(h8e, {
      className: C.wrapper,
      ownerState: x,
      children: o
    }) : null
  }));
});
U0.muiSkipListHighlight = !0;
process.env.NODE_ENV !== "production" && (U0.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Absolutely position the element.
   * @default false
   */
  absolute: l.bool,
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * If `true`, a vertical divider will have the correct height when used in flex container.
   * (By default, a vertical divider will have a calculated height of `0px` if it is the child of a flex container.)
   * @default false
   */
  flexItem: l.bool,
  /**
   * If `true`, the divider will have a lighter color.
   * @default false
   * @deprecated Use <Divider sx={{ opacity: 0.6 }} /> (or any opacity or color) instead. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/)
   */
  light: l.bool,
  /**
   * The component orientation.
   * @default 'horizontal'
   */
  orientation: l.oneOf(["horizontal", "vertical"]),
  /**
   * @ignore
   */
  role: l.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * The text alignment.
   * @default 'center'
   */
  textAlign: l.oneOf(["center", "left", "right"]),
  /**
   * The variant to use.
   * @default 'fullWidth'
   */
  variant: l.oneOfType([l.oneOf(["fullWidth", "inset", "middle"]), l.string])
});
const m8e = ["disableUnderline", "components", "componentsProps", "fullWidth", "hiddenLabel", "inputComponent", "multiline", "slotProps", "slots", "type"], g8e = (e) => {
  const {
    classes: t,
    disableUnderline: n
  } = e, i = at({
    root: ["root", !n && "underline"],
    input: ["input"]
  }, KBe, t);
  return N({}, t, i);
}, y8e = De(LE, {
  shouldForwardProp: (e) => Ao(e) || e === "classes",
  name: "MuiFilledInput",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [...RE(e, t), !n.disableUnderline && t.underline];
  }
})(({
  theme: e,
  ownerState: t
}) => {
  var n;
  const r = e.palette.mode === "light", i = r ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)", o = r ? "rgba(0, 0, 0, 0.06)" : "rgba(255, 255, 255, 0.09)", s = r ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.13)", a = r ? "rgba(0, 0, 0, 0.12)" : "rgba(255, 255, 255, 0.12)";
  return N({
    position: "relative",
    backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : o,
    borderTopLeftRadius: (e.vars || e).shape.borderRadius,
    borderTopRightRadius: (e.vars || e).shape.borderRadius,
    transition: e.transitions.create("background-color", {
      duration: e.transitions.duration.shorter,
      easing: e.transitions.easing.easeOut
    }),
    "&:hover": {
      backgroundColor: e.vars ? e.vars.palette.FilledInput.hoverBg : s,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : o
      }
    },
    [`&.${wi.focused}`]: {
      backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : o
    },
    [`&.${wi.disabled}`]: {
      backgroundColor: e.vars ? e.vars.palette.FilledInput.disabledBg : a
    }
  }, !t.disableUnderline && {
    "&::after": {
      borderBottom: `2px solid ${(n = (e.vars || e).palette[t.color || "primary"]) == null ? void 0 : n.main}`,
      left: 0,
      bottom: 0,
      // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
      content: '""',
      position: "absolute",
      right: 0,
      transform: "scaleX(0)",
      transition: e.transitions.create("transform", {
        duration: e.transitions.duration.shorter,
        easing: e.transitions.easing.easeOut
      }),
      pointerEvents: "none"
      // Transparent to the hover style.
    },
    [`&.${wi.focused}:after`]: {
      // translateX(0) is a workaround for Safari transform scale bug
      // See https://github.com/mui/material-ui/issues/31766
      transform: "scaleX(1) translateX(0)"
    },
    [`&.${wi.error}`]: {
      "&::before, &::after": {
        borderBottomColor: (e.vars || e).palette.error.main
      }
    },
    "&::before": {
      borderBottom: `1px solid ${e.vars ? `rgba(${e.vars.palette.common.onBackgroundChannel} / ${e.vars.opacity.inputUnderline})` : i}`,
      left: 0,
      bottom: 0,
      // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
      content: '"\\00a0"',
      position: "absolute",
      right: 0,
      transition: e.transitions.create("border-bottom-color", {
        duration: e.transitions.duration.shorter
      }),
      pointerEvents: "none"
      // Transparent to the hover style.
    },
    [`&:hover:not(.${wi.disabled}, .${wi.error}):before`]: {
      borderBottom: `1px solid ${(e.vars || e).palette.text.primary}`
    },
    [`&.${wi.disabled}:before`]: {
      borderBottomStyle: "dotted"
    }
  }, t.startAdornment && {
    paddingLeft: 12
  }, t.endAdornment && {
    paddingRight: 12
  }, t.multiline && N({
    padding: "25px 12px 8px"
  }, t.size === "small" && {
    paddingTop: 21,
    paddingBottom: 4
  }, t.hiddenLabel && {
    paddingTop: 16,
    paddingBottom: 17
  }, t.hiddenLabel && t.size === "small" && {
    paddingTop: 8,
    paddingBottom: 9
  }));
}), b8e = De(BE, {
  name: "MuiFilledInput",
  slot: "Input",
  overridesResolver: _E
})(({
  theme: e,
  ownerState: t
}) => N({
  paddingTop: 25,
  paddingRight: 12,
  paddingBottom: 8,
  paddingLeft: 12
}, !e.vars && {
  "&:-webkit-autofill": {
    WebkitBoxShadow: e.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
    WebkitTextFillColor: e.palette.mode === "light" ? null : "#fff",
    caretColor: e.palette.mode === "light" ? null : "#fff",
    borderTopLeftRadius: "inherit",
    borderTopRightRadius: "inherit"
  }
}, e.vars && {
  "&:-webkit-autofill": {
    borderTopLeftRadius: "inherit",
    borderTopRightRadius: "inherit"
  },
  [e.getColorSchemeSelector("dark")]: {
    "&:-webkit-autofill": {
      WebkitBoxShadow: "0 0 0 100px #266798 inset",
      WebkitTextFillColor: "#fff",
      caretColor: "#fff"
    }
  }
}, t.size === "small" && {
  paddingTop: 21,
  paddingBottom: 4
}, t.hiddenLabel && {
  paddingTop: 16,
  paddingBottom: 17
}, t.startAdornment && {
  paddingLeft: 0
}, t.endAdornment && {
  paddingRight: 0
}, t.hiddenLabel && t.size === "small" && {
  paddingTop: 8,
  paddingBottom: 9
}, t.multiline && {
  paddingTop: 0,
  paddingBottom: 0,
  paddingLeft: 0,
  paddingRight: 0
})), Su = /* @__PURE__ */ V.forwardRef(function(t, n) {
  var r, i, o, s;
  const a = Ot({
    props: t,
    name: "MuiFilledInput"
  }), {
    components: u = {},
    componentsProps: c,
    fullWidth: d = !1,
    // declare here to prevent spreading to DOM
    inputComponent: f = "input",
    multiline: h = !1,
    slotProps: m,
    slots: v = {},
    type: x = "text"
  } = a, C = _e(a, m8e), E = N({}, a, {
    fullWidth: d,
    inputComponent: f,
    multiline: h,
    type: x
  }), S = g8e(a), w = {
    root: {
      ownerState: E
    },
    input: {
      ownerState: E
    }
  }, O = m ?? c ? is(w, m ?? c) : w, A = (r = (i = v.root) != null ? i : u.Root) != null ? r : y8e, I = (o = (s = v.input) != null ? s : u.Input) != null ? o : b8e;
  return /* @__PURE__ */ P.jsx(fF, N({
    slots: {
      root: A,
      input: I
    },
    componentsProps: O,
    fullWidth: d,
    inputComponent: f,
    multiline: h,
    ref: n,
    type: x
  }, C, {
    classes: S
  }));
});
process.env.NODE_ENV !== "production" && (Su.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: l.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: l.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: l.oneOfType([l.oneOf(["primary", "secondary"]), l.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: l.shape({
    Input: l.elementType,
    Root: l.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: l.shape({
    input: l.object,
    root: l.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: l.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: l.bool,
  /**
   * If `true`, the input will not have an underline.
   */
  disableUnderline: l.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: l.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: l.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: l.bool,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: l.bool,
  /**
   * The id of the `input` element.
   */
  id: l.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: l.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: l.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: wr,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: l.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: l.oneOfType([l.number, l.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: l.oneOfType([l.number, l.string]),
  /**
   * If `true`, a [TextareaAutosize](/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: l.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: l.string,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: l.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: l.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: l.bool,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: l.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: l.oneOfType([l.number, l.string]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: l.shape({
    input: l.object,
    root: l.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: l.shape({
    input: l.elementType,
    root: l.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: l.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: l.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: l.any
});
Su.muiName = "Input";
function v8e(e) {
  return ot("MuiFormControl", e);
}
st("MuiFormControl", ["root", "marginNone", "marginNormal", "marginDense", "fullWidth", "disabled"]);
const x8e = ["children", "className", "color", "component", "disabled", "error", "focused", "fullWidth", "hiddenLabel", "margin", "required", "size", "variant"], D8e = (e) => {
  const {
    classes: t,
    margin: n,
    fullWidth: r
  } = e, i = {
    root: ["root", n !== "none" && `margin${Ue(n)}`, r && "fullWidth"]
  };
  return at(i, v8e, t);
}, C8e = De("div", {
  name: "MuiFormControl",
  slot: "Root",
  overridesResolver: ({
    ownerState: e
  }, t) => N({}, t.root, t[`margin${Ue(e.margin)}`], e.fullWidth && t.fullWidth)
})(({
  ownerState: e
}) => N({
  display: "inline-flex",
  flexDirection: "column",
  position: "relative",
  // Reset fieldset default style.
  minWidth: 0,
  padding: 0,
  margin: 0,
  border: 0,
  verticalAlign: "top"
}, e.margin === "normal" && {
  marginTop: 16,
  marginBottom: 8
}, e.margin === "dense" && {
  marginTop: 8,
  marginBottom: 4
}, e.fullWidth && {
  width: "100%"
})), hi = /* @__PURE__ */ V.forwardRef(function(t, n) {
  const r = Ot({
    props: t,
    name: "MuiFormControl"
  }), {
    children: i,
    className: o,
    color: s = "primary",
    component: a = "div",
    disabled: u = !1,
    error: c = !1,
    focused: d,
    fullWidth: f = !1,
    hiddenLabel: h = !1,
    margin: m = "none",
    required: v = !1,
    size: x = "medium",
    variant: C = "outlined"
  } = r, E = _e(r, x8e), S = N({}, r, {
    color: s,
    component: a,
    disabled: u,
    error: c,
    fullWidth: f,
    hiddenLabel: h,
    margin: m,
    required: v,
    size: x,
    variant: C
  }), w = D8e(S), [O, A] = V.useState(() => {
    let X = !1;
    return i && V.Children.forEach(i, (j) => {
      if (!_p(j, ["Input", "Select"]))
        return;
      const U = _p(j, ["Select"]) ? j.props.input : j;
      U && zBe(U.props) && (X = !0);
    }), X;
  }), [I, $] = V.useState(() => {
    let X = !1;
    return i && V.Children.forEach(i, (j) => {
      _p(j, ["Input", "Select"]) && (YD(j.props, !0) || YD(j.props.inputProps, !0)) && (X = !0);
    }), X;
  }), [L, B] = V.useState(!1);
  u && L && B(!1);
  const H = d !== void 0 && !u ? d : L;
  let q;
  if (process.env.NODE_ENV !== "production") {
    const X = V.useRef(!1);
    q = () => (X.current && console.error(["MUI: There are multiple `InputBase` components inside a FormControl.", "This creates visual inconsistencies, only use one `InputBase`."].join(`
`)), X.current = !0, () => {
      X.current = !1;
    });
  }
  const J = V.useMemo(() => ({
    adornedStart: O,
    setAdornedStart: A,
    color: s,
    disabled: u,
    error: c,
    filled: I,
    focused: H,
    fullWidth: f,
    hiddenLabel: h,
    size: x,
    onBlur: () => {
      B(!1);
    },
    onEmpty: () => {
      $(!1);
    },
    onFilled: () => {
      $(!0);
    },
    onFocus: () => {
      B(!0);
    },
    registerEffect: q,
    required: v,
    variant: C
  }), [O, s, u, c, I, H, f, h, q, v, x, C]);
  return /* @__PURE__ */ P.jsx(Qb.Provider, {
    value: J,
    children: /* @__PURE__ */ P.jsx(C8e, N({
      as: a,
      ownerState: S,
      className: Be(w.root, o),
      ref: n
    }, E, {
      children: i
    }))
  });
});
process.env.NODE_ENV !== "production" && (hi.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: l.oneOfType([l.oneOf(["primary", "secondary", "error", "info", "success", "warning"]), l.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * If `true`, the label, input and helper text should be displayed in a disabled state.
   * @default false
   */
  disabled: l.bool,
  /**
   * If `true`, the label is displayed in an error state.
   * @default false
   */
  error: l.bool,
  /**
   * If `true`, the component is displayed in focused state.
   */
  focused: l.bool,
  /**
   * If `true`, the component will take up the full width of its container.
   * @default false
   */
  fullWidth: l.bool,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: l.bool,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */
  margin: l.oneOf(["dense", "none", "normal"]),
  /**
   * If `true`, the label will indicate that the `input` is required.
   * @default false
   */
  required: l.bool,
  /**
   * The size of the component.
   * @default 'medium'
   */
  size: l.oneOfType([l.oneOf(["medium", "small"]), l.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: l.oneOf(["filled", "outlined", "standard"])
});
const nv = yMe({
  createStyledComponent: De("div", {
    name: "MuiStack",
    slot: "Root",
    overridesResolver: (e, t) => t.root
  }),
  useThemeProps: (e) => Ot({
    props: e,
    name: "MuiStack"
  })
});
process.env.NODE_ENV !== "production" && (nv.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * Defines the `flex-direction` style property.
   * It is applied for all screen sizes.
   * @default 'column'
   */
  direction: l.oneOfType([l.oneOf(["column-reverse", "column", "row-reverse", "row"]), l.arrayOf(l.oneOf(["column-reverse", "column", "row-reverse", "row"])), l.object]),
  /**
   * Add an element between each child.
   */
  divider: l.node,
  /**
   * Defines the space between immediate children.
   * @default 0
   */
  spacing: l.oneOfType([l.arrayOf(l.oneOfType([l.number, l.string])), l.number, l.object, l.string]),
  /**
   * The system prop, which allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * If `true`, the CSS flexbox `gap` is used instead of applying `margin` to children.
   *
   * While CSS `gap` removes the [known limitations](https://mui.com/joy-ui/react-stack/#limitations),
   * it is not fully supported in some browsers. We recommend checking https://caniuse.com/?search=flex%20gap before using this flag.
   *
   * To enable this flag globally, follow the [theme's default props](https://mui.com/material-ui/customization/theme-components/#default-props) configuration.
   * @default false
   */
  useFlexGap: l.bool
});
function E8e(e) {
  return ot("MuiFormControlLabel", e);
}
const qy = st("MuiFormControlLabel", ["root", "labelPlacementStart", "labelPlacementTop", "labelPlacementBottom", "disabled", "label", "error", "required", "asterisk"]), T8e = ["checked", "className", "componentsProps", "control", "disabled", "disableTypography", "inputRef", "label", "labelPlacement", "name", "onChange", "required", "slotProps", "value"], S8e = (e) => {
  const {
    classes: t,
    disabled: n,
    labelPlacement: r,
    error: i,
    required: o
  } = e, s = {
    root: ["root", n && "disabled", `labelPlacement${Ue(r)}`, i && "error", o && "required"],
    label: ["label", n && "disabled"],
    asterisk: ["asterisk", i && "error"]
  };
  return at(s, E8e, t);
}, A8e = De("label", {
  name: "MuiFormControlLabel",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [{
      [`& .${qy.label}`]: t.label
    }, t.root, t[`labelPlacement${Ue(n.labelPlacement)}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => N({
  display: "inline-flex",
  alignItems: "center",
  cursor: "pointer",
  // For correct alignment with the text.
  verticalAlign: "middle",
  WebkitTapHighlightColor: "transparent",
  marginLeft: -11,
  marginRight: 16,
  // used for row presentation of radio/checkbox
  [`&.${qy.disabled}`]: {
    cursor: "default"
  }
}, t.labelPlacement === "start" && {
  flexDirection: "row-reverse",
  marginLeft: 16,
  // used for row presentation of radio/checkbox
  marginRight: -11
}, t.labelPlacement === "top" && {
  flexDirection: "column-reverse",
  marginLeft: 16
}, t.labelPlacement === "bottom" && {
  flexDirection: "column",
  marginLeft: 16
}, {
  [`& .${qy.label}`]: {
    [`&.${qy.disabled}`]: {
      color: (e.vars || e).palette.text.disabled
    }
  }
})), w8e = De("span", {
  name: "MuiFormControlLabel",
  slot: "Asterisk",
  overridesResolver: (e, t) => t.asterisk
})(({
  theme: e
}) => ({
  [`&.${qy.error}`]: {
    color: (e.vars || e).palette.error.main
  }
})), Ps = /* @__PURE__ */ V.forwardRef(function(t, n) {
  var r, i;
  const o = Ot({
    props: t,
    name: "MuiFormControlLabel"
  }), {
    className: s,
    componentsProps: a = {},
    control: u,
    disabled: c,
    disableTypography: d,
    label: f,
    labelPlacement: h = "end",
    required: m,
    slotProps: v = {}
  } = o, x = _e(o, T8e), C = Tu(), E = (r = c ?? u.props.disabled) != null ? r : C == null ? void 0 : C.disabled, S = m ?? u.props.required, w = {
    disabled: E,
    required: S
  };
  ["checked", "name", "onChange", "value", "inputRef"].forEach((B) => {
    typeof u.props[B] > "u" && typeof o[B] < "u" && (w[B] = o[B]);
  });
  const O = wd({
    props: o,
    muiFormControl: C,
    states: ["error"]
  }), A = N({}, o, {
    disabled: E,
    labelPlacement: h,
    required: S,
    error: O.error
  }), I = S8e(A), $ = (i = v.typography) != null ? i : a.typography;
  let L = f;
  return L != null && L.type !== cn && !d && (L = /* @__PURE__ */ P.jsx(cn, N({
    component: "span"
  }, $, {
    className: Be(I.label, $ == null ? void 0 : $.className),
    children: L
  }))), /* @__PURE__ */ P.jsxs(A8e, N({
    className: Be(I.root, s),
    ownerState: A,
    ref: n
  }, x, {
    children: [/* @__PURE__ */ V.cloneElement(u, w), S ? /* @__PURE__ */ P.jsxs(nv, {
      display: "block",
      children: [L, /* @__PURE__ */ P.jsxs(w8e, {
        ownerState: A,
        "aria-hidden": !0,
        className: I.asterisk,
        children: [" ", "*"]
      })]
    }) : L]
  }));
});
process.env.NODE_ENV !== "production" && (Ps.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the component appears selected.
   */
  checked: l.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  componentsProps: l.shape({
    typography: l.object
  }),
  /**
   * A control element. For instance, it can be a `Radio`, a `Switch` or a `Checkbox`.
   */
  control: l.element.isRequired,
  /**
   * If `true`, the control is disabled.
   */
  disabled: l.bool,
  /**
   * If `true`, the label is rendered as it is passed without an additional typography node.
   */
  disableTypography: l.bool,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: wr,
  /**
   * A text or an element to be used in an enclosing label element.
   */
  label: l.node,
  /**
   * The position of the label.
   * @default 'end'
   */
  labelPlacement: l.oneOf(["bottom", "end", "start", "top"]),
  /**
   * @ignore
   */
  name: l.string,
  /**
   * Callback fired when the state is changed.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: l.func,
  /**
   * If `true`, the label will indicate that the `input` is required.
   */
  required: l.bool,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: l.shape({
    typography: l.object
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * The value of the component.
   */
  value: l.any
});
function P8e(e) {
  return ot("MuiFormGroup", e);
}
st("MuiFormGroup", ["root", "row", "error"]);
const k8e = ["className", "row"], O8e = (e) => {
  const {
    classes: t,
    row: n,
    error: r
  } = e;
  return at({
    root: ["root", n && "row", r && "error"]
  }, P8e, t);
}, I8e = De("div", {
  name: "MuiFormGroup",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.row && t.row];
  }
})(({
  ownerState: e
}) => N({
  display: "flex",
  flexDirection: "column",
  flexWrap: "wrap"
}, e.row && {
  flexDirection: "row"
})), rv = /* @__PURE__ */ V.forwardRef(function(t, n) {
  const r = Ot({
    props: t,
    name: "MuiFormGroup"
  }), {
    className: i,
    row: o = !1
  } = r, s = _e(r, k8e), a = Tu(), u = wd({
    props: r,
    muiFormControl: a,
    states: ["error"]
  }), c = N({}, r, {
    row: o,
    error: u.error
  }), d = O8e(c);
  return /* @__PURE__ */ P.jsx(I8e, N({
    className: Be(d.root, i),
    ownerState: c,
    ref: n
  }, s));
});
process.env.NODE_ENV !== "production" && (rv.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * Display group of elements in a compact row.
   * @default false
   */
  row: l.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
function F8e(e) {
  return ot("MuiFormHelperText", e);
}
const S3 = st("MuiFormHelperText", ["root", "error", "disabled", "sizeSmall", "sizeMedium", "contained", "focused", "filled", "required"]);
var A3;
const $8e = ["children", "className", "component", "disabled", "error", "filled", "focused", "margin", "required", "variant"], N8e = (e) => {
  const {
    classes: t,
    contained: n,
    size: r,
    disabled: i,
    error: o,
    filled: s,
    focused: a,
    required: u
  } = e, c = {
    root: ["root", i && "disabled", o && "error", r && `size${Ue(r)}`, n && "contained", a && "focused", s && "filled", u && "required"]
  };
  return at(c, F8e, t);
}, M8e = De("p", {
  name: "MuiFormHelperText",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.size && t[`size${Ue(n.size)}`], n.contained && t.contained, n.filled && t.filled];
  }
})(({
  theme: e,
  ownerState: t
}) => N({
  color: (e.vars || e).palette.text.secondary
}, e.typography.caption, {
  textAlign: "left",
  marginTop: 3,
  marginRight: 0,
  marginBottom: 0,
  marginLeft: 0,
  [`&.${S3.disabled}`]: {
    color: (e.vars || e).palette.text.disabled
  },
  [`&.${S3.error}`]: {
    color: (e.vars || e).palette.error.main
  }
}, t.size === "small" && {
  marginTop: 4
}, t.contained && {
  marginLeft: 14,
  marginRight: 14
})), gn = /* @__PURE__ */ V.forwardRef(function(t, n) {
  const r = Ot({
    props: t,
    name: "MuiFormHelperText"
  }), {
    children: i,
    className: o,
    component: s = "p"
  } = r, a = _e(r, $8e), u = Tu(), c = wd({
    props: r,
    muiFormControl: u,
    states: ["variant", "size", "disabled", "error", "filled", "focused", "required"]
  }), d = N({}, r, {
    component: s,
    contained: c.variant === "filled" || c.variant === "outlined",
    variant: c.variant,
    size: c.size,
    disabled: c.disabled,
    error: c.error,
    filled: c.filled,
    focused: c.focused,
    required: c.required
  }), f = N8e(d);
  return /* @__PURE__ */ P.jsx(M8e, N({
    as: s,
    ownerState: d,
    className: Be(f.root, o),
    ref: n
  }, a, {
    children: i === " " ? (
      // notranslate needed while Google Translate will not fix zero-width space issue
      A3 || (A3 = /* @__PURE__ */ P.jsx("span", {
        className: "notranslate",
        children: "​"
      }))
    ) : i
  }));
});
process.env.NODE_ENV !== "production" && (gn.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   *
   * If `' '` is provided, the component reserves one line height for displaying a future message.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * If `true`, the helper text should be displayed in a disabled state.
   */
  disabled: l.bool,
  /**
   * If `true`, helper text should be displayed in an error state.
   */
  error: l.bool,
  /**
   * If `true`, the helper text should use filled classes key.
   */
  filled: l.bool,
  /**
   * If `true`, the helper text should use focused classes key.
   */
  focused: l.bool,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: l.oneOf(["dense"]),
  /**
   * If `true`, the helper text should use required classes key.
   */
  required: l.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * The variant to use.
   */
  variant: l.oneOfType([l.oneOf(["filled", "outlined", "standard"]), l.string])
});
function R8e(e) {
  return ot("MuiFormLabel", e);
}
const p0 = st("MuiFormLabel", ["root", "colorSecondary", "focused", "disabled", "error", "filled", "required", "asterisk"]), _8e = ["children", "className", "color", "component", "disabled", "error", "filled", "focused", "required"], L8e = (e) => {
  const {
    classes: t,
    color: n,
    focused: r,
    disabled: i,
    error: o,
    filled: s,
    required: a
  } = e, u = {
    root: ["root", `color${Ue(n)}`, i && "disabled", o && "error", s && "filled", r && "focused", a && "required"],
    asterisk: ["asterisk", o && "error"]
  };
  return at(u, R8e, t);
}, B8e = De("label", {
  name: "MuiFormLabel",
  slot: "Root",
  overridesResolver: ({
    ownerState: e
  }, t) => N({}, t.root, e.color === "secondary" && t.colorSecondary, e.filled && t.filled)
})(({
  theme: e,
  ownerState: t
}) => N({
  color: (e.vars || e).palette.text.secondary
}, e.typography.body1, {
  lineHeight: "1.4375em",
  padding: 0,
  position: "relative",
  [`&.${p0.focused}`]: {
    color: (e.vars || e).palette[t.color].main
  },
  [`&.${p0.disabled}`]: {
    color: (e.vars || e).palette.text.disabled
  },
  [`&.${p0.error}`]: {
    color: (e.vars || e).palette.error.main
  }
})), j8e = De("span", {
  name: "MuiFormLabel",
  slot: "Asterisk",
  overridesResolver: (e, t) => t.asterisk
})(({
  theme: e
}) => ({
  [`&.${p0.error}`]: {
    color: (e.vars || e).palette.error.main
  }
})), fa = /* @__PURE__ */ V.forwardRef(function(t, n) {
  const r = Ot({
    props: t,
    name: "MuiFormLabel"
  }), {
    children: i,
    className: o,
    component: s = "label"
  } = r, a = _e(r, _8e), u = Tu(), c = wd({
    props: r,
    muiFormControl: u,
    states: ["color", "required", "focused", "disabled", "error", "filled"]
  }), d = N({}, r, {
    color: c.color || "primary",
    component: s,
    disabled: c.disabled,
    error: c.error,
    filled: c.filled,
    focused: c.focused,
    required: c.required
  }), f = L8e(d);
  return /* @__PURE__ */ P.jsxs(B8e, N({
    as: s,
    ownerState: d,
    className: Be(f.root, o),
    ref: n
  }, a, {
    children: [i, c.required && /* @__PURE__ */ P.jsxs(j8e, {
      ownerState: d,
      "aria-hidden": !0,
      className: f.asterisk,
      children: [" ", "*"]
    })]
  }));
});
process.env.NODE_ENV !== "production" && (fa.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   */
  color: l.oneOfType([l.oneOf(["error", "info", "primary", "secondary", "success", "warning"]), l.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * If `true`, the label should be displayed in a disabled state.
   */
  disabled: l.bool,
  /**
   * If `true`, the label is displayed in an error state.
   */
  error: l.bool,
  /**
   * If `true`, the label should use filled classes key.
   */
  filled: l.bool,
  /**
   * If `true`, the input of this label is focused (used by `FormGroup` components).
   */
  focused: l.bool,
  /**
   * If `true`, the label will indicate that the `input` is required.
   */
  required: l.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
const QP = /* @__PURE__ */ V.createContext();
process.env.NODE_ENV !== "production" && (QP.displayName = "GridContext");
function V8e(e) {
  return ot("MuiGrid", e);
}
const z8e = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10], U8e = ["column-reverse", "column", "row-reverse", "row"], W8e = ["nowrap", "wrap-reverse", "wrap"], Sy = ["auto", !0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12], W0 = st("MuiGrid", [
  "root",
  "container",
  "item",
  "zeroMinWidth",
  // spacings
  ...z8e.map((e) => `spacing-xs-${e}`),
  // direction values
  ...U8e.map((e) => `direction-xs-${e}`),
  // wrap values
  ...W8e.map((e) => `wrap-xs-${e}`),
  // grid sizes for all breakpoints
  ...Sy.map((e) => `grid-xs-${e}`),
  ...Sy.map((e) => `grid-sm-${e}`),
  ...Sy.map((e) => `grid-md-${e}`),
  ...Sy.map((e) => `grid-lg-${e}`),
  ...Sy.map((e) => `grid-xl-${e}`)
]), H8e = ["className", "columns", "columnSpacing", "component", "container", "direction", "item", "rowSpacing", "spacing", "wrap", "zeroMinWidth"];
function Gh(e) {
  const t = parseFloat(e);
  return `${t}${String(e).replace(String(t), "") || "px"}`;
}
function q8e({
  theme: e,
  ownerState: t
}) {
  let n;
  return e.breakpoints.keys.reduce((r, i) => {
    let o = {};
    if (t[i] && (n = t[i]), !n)
      return r;
    if (n === !0)
      o = {
        flexBasis: 0,
        flexGrow: 1,
        maxWidth: "100%"
      };
    else if (n === "auto")
      o = {
        flexBasis: "auto",
        flexGrow: 0,
        flexShrink: 0,
        maxWidth: "none",
        width: "auto"
      };
    else {
      const s = Rp({
        values: t.columns,
        breakpoints: e.breakpoints.values
      }), a = typeof s == "object" ? s[i] : s;
      if (a == null)
        return r;
      const u = `${Math.round(n / a * 1e8) / 1e6}%`;
      let c = {};
      if (t.container && t.item && t.columnSpacing !== 0) {
        const d = e.spacing(t.columnSpacing);
        if (d !== "0px") {
          const f = `calc(${u} + ${Gh(d)})`;
          c = {
            flexBasis: f,
            maxWidth: f
          };
        }
      }
      o = N({
        flexBasis: u,
        flexGrow: 0,
        maxWidth: u
      }, c);
    }
    return e.breakpoints.values[i] === 0 ? Object.assign(r, o) : r[e.breakpoints.up(i)] = o, r;
  }, {});
}
function G8e({
  theme: e,
  ownerState: t
}) {
  const n = Rp({
    values: t.direction,
    breakpoints: e.breakpoints.values
  });
  return Fs({
    theme: e
  }, n, (r) => {
    const i = {
      flexDirection: r
    };
    return r.indexOf("column") === 0 && (i[`& > .${W0.item}`] = {
      maxWidth: "none"
    }), i;
  });
}
function qU({
  breakpoints: e,
  values: t
}) {
  let n = "";
  Object.keys(t).forEach((i) => {
    n === "" && t[i] !== 0 && (n = i);
  });
  const r = Object.keys(e).sort((i, o) => e[i] - e[o]);
  return r.slice(0, r.indexOf(n));
}
function Y8e({
  theme: e,
  ownerState: t
}) {
  const {
    container: n,
    rowSpacing: r
  } = t;
  let i = {};
  if (n && r !== 0) {
    const o = Rp({
      values: r,
      breakpoints: e.breakpoints.values
    });
    let s;
    typeof o == "object" && (s = qU({
      breakpoints: e.breakpoints.values,
      values: o
    })), i = Fs({
      theme: e
    }, o, (a, u) => {
      var c;
      const d = e.spacing(a);
      return d !== "0px" ? {
        marginTop: `-${Gh(d)}`,
        [`& > .${W0.item}`]: {
          paddingTop: Gh(d)
        }
      } : (c = s) != null && c.includes(u) ? {} : {
        marginTop: 0,
        [`& > .${W0.item}`]: {
          paddingTop: 0
        }
      };
    });
  }
  return i;
}
function K8e({
  theme: e,
  ownerState: t
}) {
  const {
    container: n,
    columnSpacing: r
  } = t;
  let i = {};
  if (n && r !== 0) {
    const o = Rp({
      values: r,
      breakpoints: e.breakpoints.values
    });
    let s;
    typeof o == "object" && (s = qU({
      breakpoints: e.breakpoints.values,
      values: o
    })), i = Fs({
      theme: e
    }, o, (a, u) => {
      var c;
      const d = e.spacing(a);
      return d !== "0px" ? {
        width: `calc(100% + ${Gh(d)})`,
        marginLeft: `-${Gh(d)}`,
        [`& > .${W0.item}`]: {
          paddingLeft: Gh(d)
        }
      } : (c = s) != null && c.includes(u) ? {} : {
        width: "100%",
        marginLeft: 0,
        [`& > .${W0.item}`]: {
          paddingLeft: 0
        }
      };
    });
  }
  return i;
}
function J8e(e, t, n = {}) {
  if (!e || e <= 0)
    return [];
  if (typeof e == "string" && !Number.isNaN(Number(e)) || typeof e == "number")
    return [n[`spacing-xs-${String(e)}`]];
  const r = [];
  return t.forEach((i) => {
    const o = e[i];
    Number(o) > 0 && r.push(n[`spacing-${i}-${String(o)}`]);
  }), r;
}
const X8e = De("div", {
  name: "MuiGrid",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e, {
      container: r,
      direction: i,
      item: o,
      spacing: s,
      wrap: a,
      zeroMinWidth: u,
      breakpoints: c
    } = n;
    let d = [];
    r && (d = J8e(s, c, t));
    const f = [];
    return c.forEach((h) => {
      const m = n[h];
      m && f.push(t[`grid-${h}-${String(m)}`]);
    }), [t.root, r && t.container, o && t.item, u && t.zeroMinWidth, ...d, i !== "row" && t[`direction-xs-${String(i)}`], a !== "wrap" && t[`wrap-xs-${String(a)}`], ...f];
  }
})(({
  ownerState: e
}) => N({
  boxSizing: "border-box"
}, e.container && {
  display: "flex",
  flexWrap: "wrap",
  width: "100%"
}, e.item && {
  margin: 0
  // For instance, it's useful when used with a `figure` element.
}, e.zeroMinWidth && {
  minWidth: 0
}, e.wrap !== "wrap" && {
  flexWrap: e.wrap
}), G8e, Y8e, K8e, q8e);
function Q8e(e, t) {
  if (!e || e <= 0)
    return [];
  if (typeof e == "string" && !Number.isNaN(Number(e)) || typeof e == "number")
    return [`spacing-xs-${String(e)}`];
  const n = [];
  return t.forEach((r) => {
    const i = e[r];
    if (Number(i) > 0) {
      const o = `spacing-${r}-${String(i)}`;
      n.push(o);
    }
  }), n;
}
const Z8e = (e) => {
  const {
    classes: t,
    container: n,
    direction: r,
    item: i,
    spacing: o,
    wrap: s,
    zeroMinWidth: a,
    breakpoints: u
  } = e;
  let c = [];
  n && (c = Q8e(o, u));
  const d = [];
  u.forEach((h) => {
    const m = e[h];
    m && d.push(`grid-${h}-${String(m)}`);
  });
  const f = {
    root: ["root", n && "container", i && "item", a && "zeroMinWidth", ...c, r !== "row" && `direction-xs-${String(r)}`, s !== "wrap" && `wrap-xs-${String(s)}`, ...d]
  };
  return at(f, V8e, t);
}, en = /* @__PURE__ */ V.forwardRef(function(t, n) {
  const r = Ot({
    props: t,
    name: "MuiGrid"
  }), {
    breakpoints: i
  } = Gi(), o = Bb(r), {
    className: s,
    columns: a,
    columnSpacing: u,
    component: c = "div",
    container: d = !1,
    direction: f = "row",
    item: h = !1,
    rowSpacing: m,
    spacing: v = 0,
    wrap: x = "wrap",
    zeroMinWidth: C = !1
  } = o, E = _e(o, H8e), S = m || v, w = u || v, O = V.useContext(QP), A = d ? a || 12 : O, I = {}, $ = N({}, E);
  i.keys.forEach((H) => {
    E[H] != null && (I[H] = E[H], delete $[H]);
  });
  const L = N({}, o, {
    columns: A,
    container: d,
    direction: f,
    item: h,
    rowSpacing: S,
    columnSpacing: w,
    wrap: x,
    zeroMinWidth: C,
    spacing: v
  }, I, {
    breakpoints: i.keys
  }), B = Z8e(L);
  return /* @__PURE__ */ P.jsx(QP.Provider, {
    value: A,
    children: /* @__PURE__ */ P.jsx(X8e, N({
      ownerState: L,
      className: Be(B.root, s),
      as: c,
      ref: n
    }, $))
  });
});
process.env.NODE_ENV !== "production" && (en.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The number of columns.
   * @default 12
   */
  columns: l.oneOfType([l.arrayOf(l.number), l.number, l.object]),
  /**
   * Defines the horizontal space between the type `item` components.
   * It overrides the value of the `spacing` prop.
   */
  columnSpacing: l.oneOfType([l.arrayOf(l.oneOfType([l.number, l.string])), l.number, l.object, l.string]),
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * If `true`, the component will have the flex *container* behavior.
   * You should be wrapping *items* with a *container*.
   * @default false
   */
  container: l.bool,
  /**
   * Defines the `flex-direction` style property.
   * It is applied for all screen sizes.
   * @default 'row'
   */
  direction: l.oneOfType([l.oneOf(["column-reverse", "column", "row-reverse", "row"]), l.arrayOf(l.oneOf(["column-reverse", "column", "row-reverse", "row"])), l.object]),
  /**
   * If `true`, the component will have the flex *item* behavior.
   * You should be wrapping *items* with a *container*.
   * @default false
   */
  item: l.bool,
  /**
   * If a number, it sets the number of columns the grid item uses.
   * It can't be greater than the total number of columns of the container (12 by default).
   * If 'auto', the grid item's width matches its content.
   * If false, the prop is ignored.
   * If true, the grid item's width grows to use the space available in the grid container.
   * The value is applied for the `lg` breakpoint and wider screens if not overridden.
   * @default false
   */
  lg: l.oneOfType([l.oneOf(["auto"]), l.number, l.bool]),
  /**
   * If a number, it sets the number of columns the grid item uses.
   * It can't be greater than the total number of columns of the container (12 by default).
   * If 'auto', the grid item's width matches its content.
   * If false, the prop is ignored.
   * If true, the grid item's width grows to use the space available in the grid container.
   * The value is applied for the `md` breakpoint and wider screens if not overridden.
   * @default false
   */
  md: l.oneOfType([l.oneOf(["auto"]), l.number, l.bool]),
  /**
   * Defines the vertical space between the type `item` components.
   * It overrides the value of the `spacing` prop.
   */
  rowSpacing: l.oneOfType([l.arrayOf(l.oneOfType([l.number, l.string])), l.number, l.object, l.string]),
  /**
   * If a number, it sets the number of columns the grid item uses.
   * It can't be greater than the total number of columns of the container (12 by default).
   * If 'auto', the grid item's width matches its content.
   * If false, the prop is ignored.
   * If true, the grid item's width grows to use the space available in the grid container.
   * The value is applied for the `sm` breakpoint and wider screens if not overridden.
   * @default false
   */
  sm: l.oneOfType([l.oneOf(["auto"]), l.number, l.bool]),
  /**
   * Defines the space between the type `item` components.
   * It can only be used on a type `container` component.
   * @default 0
   */
  spacing: l.oneOfType([l.arrayOf(l.oneOfType([l.number, l.string])), l.number, l.object, l.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * Defines the `flex-wrap` style property.
   * It's applied for all screen sizes.
   * @default 'wrap'
   */
  wrap: l.oneOf(["nowrap", "wrap-reverse", "wrap"]),
  /**
   * If a number, it sets the number of columns the grid item uses.
   * It can't be greater than the total number of columns of the container (12 by default).
   * If 'auto', the grid item's width matches its content.
   * If false, the prop is ignored.
   * If true, the grid item's width grows to use the space available in the grid container.
   * The value is applied for the `xl` breakpoint and wider screens if not overridden.
   * @default false
   */
  xl: l.oneOfType([l.oneOf(["auto"]), l.number, l.bool]),
  /**
   * If a number, it sets the number of columns the grid item uses.
   * It can't be greater than the total number of columns of the container (12 by default).
   * If 'auto', the grid item's width matches its content.
   * If false, the prop is ignored.
   * If true, the grid item's width grows to use the space available in the grid container.
   * The value is applied for all the screen sizes with the lowest priority.
   * @default false
   */
  xs: l.oneOfType([l.oneOf(["auto"]), l.number, l.bool]),
  /**
   * If `true`, it sets `min-width: 0` on the item.
   * Refer to the limitations section of the documentation to better understand the use case.
   * @default false
   */
  zeroMinWidth: l.bool
});
if (process.env.NODE_ENV !== "production") {
  const e = Qz("Grid", en);
  en.propTypes = N({}, en.propTypes, {
    direction: e("container"),
    lg: e("item"),
    md: e("item"),
    sm: e("item"),
    spacing: e("container"),
    wrap: e("container"),
    xs: e("item"),
    zeroMinWidth: e("item")
  });
}
const e5e = ["addEndListener", "appear", "children", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"];
function ZP(e) {
  return `scale(${e}, ${e ** 2})`;
}
const t5e = {
  entering: {
    opacity: 1,
    transform: ZP(1)
  },
  entered: {
    opacity: 1,
    transform: "none"
  }
}, XA = typeof navigator < "u" && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent), ym = /* @__PURE__ */ V.forwardRef(function(t, n) {
  const {
    addEndListener: r,
    appear: i = !0,
    children: o,
    easing: s,
    in: a,
    onEnter: u,
    onEntered: c,
    onEntering: d,
    onExit: f,
    onExited: h,
    onExiting: m,
    style: v,
    timeout: x = "auto",
    // eslint-disable-next-line react/prop-types
    TransitionComponent: C = pa
  } = t, E = _e(t, e5e), S = Pp(), w = V.useRef(), O = Gi(), A = V.useRef(null), I = Hn(A, o.ref, n), $ = (U) => (G) => {
    if (U) {
      const K = A.current;
      G === void 0 ? U(K) : U(K, G);
    }
  }, L = $(d), B = $((U, G) => {
    yU(U);
    const {
      duration: K,
      delay: ee,
      easing: te
    } = pm({
      style: v,
      timeout: x,
      easing: s
    }, {
      mode: "enter"
    });
    let M;
    x === "auto" ? (M = O.transitions.getAutoHeightDuration(U.clientHeight), w.current = M) : M = K, U.style.transition = [O.transitions.create("opacity", {
      duration: M,
      delay: ee
    }), O.transitions.create("transform", {
      duration: XA ? M : M * 0.666,
      delay: ee,
      easing: te
    })].join(","), u && u(U, G);
  }), H = $(c), q = $(m), J = $((U) => {
    const {
      duration: G,
      delay: K,
      easing: ee
    } = pm({
      style: v,
      timeout: x,
      easing: s
    }, {
      mode: "exit"
    });
    let te;
    x === "auto" ? (te = O.transitions.getAutoHeightDuration(U.clientHeight), w.current = te) : te = G, U.style.transition = [O.transitions.create("opacity", {
      duration: te,
      delay: K
    }), O.transitions.create("transform", {
      duration: XA ? te : te * 0.666,
      delay: XA ? K : K || te * 0.333,
      easing: ee
    })].join(","), U.style.opacity = 0, U.style.transform = ZP(0.75), f && f(U);
  }), X = $(h), j = (U) => {
    x === "auto" && S.start(w.current || 0, U), r && r(A.current, U);
  };
  return /* @__PURE__ */ P.jsx(C, N({
    appear: i,
    in: a,
    nodeRef: A,
    onEnter: B,
    onEntered: H,
    onEntering: L,
    onExit: J,
    onExited: X,
    onExiting: q,
    addEndListener: j,
    timeout: x === "auto" ? null : x
  }, E, {
    children: (U, G) => /* @__PURE__ */ V.cloneElement(o, N({
      style: N({
        opacity: 0,
        transform: ZP(0.75),
        visibility: U === "exited" && !a ? "hidden" : void 0
      }, t5e[U], v, o.props.style),
      ref: I
    }, G))
  }));
});
process.env.NODE_ENV !== "production" && (ym.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Add a custom transition end trigger. Called with the transitioning DOM
   * node and a done callback. Allows for more fine grained transition end
   * logic. Note: Timeouts are still used as a fallback if provided.
   */
  addEndListener: l.func,
  /**
   * Perform the enter transition when it first mounts if `in` is also `true`.
   * Set this to `false` to disable this behavior.
   * @default true
   */
  appear: l.bool,
  /**
   * A single child content element.
   */
  children: ig.isRequired,
  /**
   * The transition timing function.
   * You may specify a single easing or a object containing enter and exit values.
   */
  easing: l.oneOfType([l.shape({
    enter: l.string,
    exit: l.string
  }), l.string]),
  /**
   * If `true`, the component will transition in.
   */
  in: l.bool,
  /**
   * @ignore
   */
  onEnter: l.func,
  /**
   * @ignore
   */
  onEntered: l.func,
  /**
   * @ignore
   */
  onEntering: l.func,
  /**
   * @ignore
   */
  onExit: l.func,
  /**
   * @ignore
   */
  onExited: l.func,
  /**
   * @ignore
   */
  onExiting: l.func,
  /**
   * @ignore
   */
  style: l.object,
  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */
  timeout: l.oneOfType([l.oneOf(["auto"]), l.number, l.shape({
    appear: l.number,
    enter: l.number,
    exit: l.number
  })])
});
ym.muiSupportAuto = !0;
const n5e = ["disableUnderline", "components", "componentsProps", "fullWidth", "inputComponent", "multiline", "slotProps", "slots", "type"], r5e = (e) => {
  const {
    classes: t,
    disableUnderline: n
  } = e, i = at({
    root: ["root", !n && "underline"],
    input: ["input"]
  }, GBe, t);
  return N({}, t, i);
}, i5e = De(LE, {
  shouldForwardProp: (e) => Ao(e) || e === "classes",
  name: "MuiInput",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [...RE(e, t), !n.disableUnderline && t.underline];
  }
})(({
  theme: e,
  ownerState: t
}) => {
  let r = e.palette.mode === "light" ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)";
  return e.vars && (r = `rgba(${e.vars.palette.common.onBackgroundChannel} / ${e.vars.opacity.inputUnderline})`), N({
    position: "relative"
  }, t.formControl && {
    "label + &": {
      marginTop: 16
    }
  }, !t.disableUnderline && {
    "&::after": {
      borderBottom: `2px solid ${(e.vars || e).palette[t.color].main}`,
      left: 0,
      bottom: 0,
      // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
      content: '""',
      position: "absolute",
      right: 0,
      transform: "scaleX(0)",
      transition: e.transitions.create("transform", {
        duration: e.transitions.duration.shorter,
        easing: e.transitions.easing.easeOut
      }),
      pointerEvents: "none"
      // Transparent to the hover style.
    },
    [`&.${Qc.focused}:after`]: {
      // translateX(0) is a workaround for Safari transform scale bug
      // See https://github.com/mui/material-ui/issues/31766
      transform: "scaleX(1) translateX(0)"
    },
    [`&.${Qc.error}`]: {
      "&::before, &::after": {
        borderBottomColor: (e.vars || e).palette.error.main
      }
    },
    "&::before": {
      borderBottom: `1px solid ${r}`,
      left: 0,
      bottom: 0,
      // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
      content: '"\\00a0"',
      position: "absolute",
      right: 0,
      transition: e.transitions.create("border-bottom-color", {
        duration: e.transitions.duration.shorter
      }),
      pointerEvents: "none"
      // Transparent to the hover style.
    },
    [`&:hover:not(.${Qc.disabled}, .${Qc.error}):before`]: {
      borderBottom: `2px solid ${(e.vars || e).palette.text.primary}`,
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        borderBottom: `1px solid ${r}`
      }
    },
    [`&.${Qc.disabled}:before`]: {
      borderBottomStyle: "dotted"
    }
  });
}), o5e = De(BE, {
  name: "MuiInput",
  slot: "Input",
  overridesResolver: _E
})({}), iv = /* @__PURE__ */ V.forwardRef(function(t, n) {
  var r, i, o, s;
  const a = Ot({
    props: t,
    name: "MuiInput"
  }), {
    disableUnderline: u,
    components: c = {},
    componentsProps: d,
    fullWidth: f = !1,
    inputComponent: h = "input",
    multiline: m = !1,
    slotProps: v,
    slots: x = {},
    type: C = "text"
  } = a, E = _e(a, n5e), S = r5e(a), O = {
    root: {
      ownerState: {
        disableUnderline: u
      }
    }
  }, A = v ?? d ? is(v ?? d, O) : O, I = (r = (i = x.root) != null ? i : c.Root) != null ? r : i5e, $ = (o = (s = x.input) != null ? s : c.Input) != null ? o : o5e;
  return /* @__PURE__ */ P.jsx(fF, N({
    slots: {
      root: I,
      input: $
    },
    slotProps: A,
    fullWidth: f,
    inputComponent: h,
    multiline: m,
    ref: n,
    type: C
  }, E, {
    classes: S
  }));
});
process.env.NODE_ENV !== "production" && (iv.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: l.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: l.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: l.oneOfType([l.oneOf(["primary", "secondary"]), l.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: l.shape({
    Input: l.elementType,
    Root: l.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: l.shape({
    input: l.object,
    root: l.object
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: l.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: l.bool,
  /**
   * If `true`, the `input` will not have an underline.
   */
  disableUnderline: l.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: l.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: l.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: l.bool,
  /**
   * The id of the `input` element.
   */
  id: l.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: l.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: l.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: wr,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: l.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: l.oneOfType([l.number, l.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: l.oneOfType([l.number, l.string]),
  /**
   * If `true`, a [TextareaAutosize](/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: l.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: l.string,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: l.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: l.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: l.bool,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: l.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: l.oneOfType([l.number, l.string]),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: l.shape({
    input: l.object,
    root: l.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: l.shape({
    input: l.elementType,
    root: l.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: l.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: l.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: l.any
});
iv.muiName = "Input";
function s5e(e) {
  return ot("MuiInputAdornment", e);
}
const w3 = st("MuiInputAdornment", ["root", "filled", "standard", "outlined", "positionStart", "positionEnd", "disablePointerEvents", "hiddenLabel", "sizeSmall"]);
var P3;
const a5e = ["children", "className", "component", "disablePointerEvents", "disableTypography", "position", "variant"], l5e = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.root, t[`position${Ue(n.position)}`], n.disablePointerEvents === !0 && t.disablePointerEvents, t[n.variant]];
}, u5e = (e) => {
  const {
    classes: t,
    disablePointerEvents: n,
    hiddenLabel: r,
    position: i,
    size: o,
    variant: s
  } = e, a = {
    root: ["root", n && "disablePointerEvents", i && `position${Ue(i)}`, s, r && "hiddenLabel", o && `size${Ue(o)}`]
  };
  return at(a, s5e, t);
}, c5e = De("div", {
  name: "MuiInputAdornment",
  slot: "Root",
  overridesResolver: l5e
})(({
  theme: e,
  ownerState: t
}) => N({
  display: "flex",
  height: "0.01em",
  // Fix IE11 flexbox alignment. To remove at some point.
  maxHeight: "2em",
  alignItems: "center",
  whiteSpace: "nowrap",
  color: (e.vars || e).palette.action.active
}, t.variant === "filled" && {
  // Styles applied to the root element if `variant="filled"`.
  [`&.${w3.positionStart}&:not(.${w3.hiddenLabel})`]: {
    marginTop: 16
  }
}, t.position === "start" && {
  // Styles applied to the root element if `position="start"`.
  marginRight: 8
}, t.position === "end" && {
  // Styles applied to the root element if `position="end"`.
  marginLeft: 8
}, t.disablePointerEvents === !0 && {
  // Styles applied to the root element if `disablePointerEvents={true}`.
  pointerEvents: "none"
})), lg = /* @__PURE__ */ V.forwardRef(function(t, n) {
  const r = Ot({
    props: t,
    name: "MuiInputAdornment"
  }), {
    children: i,
    className: o,
    component: s = "div",
    disablePointerEvents: a = !1,
    disableTypography: u = !1,
    position: c,
    variant: d
  } = r, f = _e(r, a5e), h = Tu() || {};
  let m = d;
  d && h.variant && process.env.NODE_ENV !== "production" && d === h.variant && console.error("MUI: The `InputAdornment` variant infers the variant prop you do not have to provide one."), h && !m && (m = h.variant);
  const v = N({}, r, {
    hiddenLabel: h.hiddenLabel,
    size: h.size,
    disablePointerEvents: a,
    position: c,
    variant: m
  }), x = u5e(v);
  return /* @__PURE__ */ P.jsx(Qb.Provider, {
    value: null,
    children: /* @__PURE__ */ P.jsx(c5e, N({
      as: s,
      ownerState: v,
      className: Be(x.root, o),
      ref: n
    }, f, {
      children: typeof i == "string" && !u ? /* @__PURE__ */ P.jsx(cn, {
        color: "text.secondary",
        children: i
      }) : /* @__PURE__ */ P.jsxs(V.Fragment, {
        children: [c === "start" ? (
          /* notranslate needed while Google Translate will not fix zero-width space issue */
          P3 || (P3 = /* @__PURE__ */ P.jsx("span", {
            className: "notranslate",
            children: "​"
          }))
        ) : null, i]
      })
    }))
  });
});
process.env.NODE_ENV !== "production" && (lg.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally an `IconButton` or string.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * Disable pointer events on the root.
   * This allows for the content of the adornment to focus the `input` on click.
   * @default false
   */
  disablePointerEvents: l.bool,
  /**
   * If children is a string then disable wrapping in a Typography component.
   * @default false
   */
  disableTypography: l.bool,
  /**
   * The position this adornment should appear relative to the `Input`.
   */
  position: l.oneOf(["end", "start"]).isRequired,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * The variant to use.
   * Note: If you are using the `TextField` component or the `FormControl` component
   * you do not have to set this manually.
   */
  variant: l.oneOf(["filled", "outlined", "standard"])
});
function d5e(e) {
  return ot("MuiInputLabel", e);
}
const Yl = st("MuiInputLabel", ["root", "focused", "disabled", "error", "required", "asterisk", "formControl", "sizeSmall", "shrink", "animated", "standard", "filled", "outlined"]), p5e = ["disableAnimation", "margin", "shrink", "variant", "className"], f5e = (e) => {
  const {
    classes: t,
    formControl: n,
    size: r,
    shrink: i,
    disableAnimation: o,
    variant: s,
    required: a
  } = e, u = {
    root: ["root", n && "formControl", !o && "animated", i && "shrink", r && r !== "normal" && `size${Ue(r)}`, s],
    asterisk: [a && "asterisk"]
  }, c = at(u, d5e, t);
  return N({}, t, c);
}, h5e = De(fa, {
  shouldForwardProp: (e) => Ao(e) || e === "classes",
  name: "MuiInputLabel",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [{
      [`& .${p0.asterisk}`]: t.asterisk
    }, t.root, n.formControl && t.formControl, n.size === "small" && t.sizeSmall, n.shrink && t.shrink, !n.disableAnimation && t.animated, n.focused && t.focused, t[n.variant]];
  }
})(({
  theme: e,
  ownerState: t
}) => N({
  display: "block",
  transformOrigin: "top left",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  maxWidth: "100%"
}, t.formControl && {
  position: "absolute",
  left: 0,
  top: 0,
  // slight alteration to spec spacing to match visual spec result
  transform: "translate(0, 20px) scale(1)"
}, t.size === "small" && {
  // Compensation for the `Input.inputSizeSmall` style.
  transform: "translate(0, 17px) scale(1)"
}, t.shrink && {
  transform: "translate(0, -1.5px) scale(0.75)",
  transformOrigin: "top left",
  maxWidth: "133%"
}, !t.disableAnimation && {
  transition: e.transitions.create(["color", "transform", "max-width"], {
    duration: e.transitions.duration.shorter,
    easing: e.transitions.easing.easeOut
  })
}, t.variant === "filled" && N({
  // Chrome's autofill feature gives the input field a yellow background.
  // Since the input field is behind the label in the HTML tree,
  // the input field is drawn last and hides the label with an opaque background color.
  // zIndex: 1 will raise the label above opaque background-colors of input.
  zIndex: 1,
  pointerEvents: "none",
  transform: "translate(12px, 16px) scale(1)",
  maxWidth: "calc(100% - 24px)"
}, t.size === "small" && {
  transform: "translate(12px, 13px) scale(1)"
}, t.shrink && N({
  userSelect: "none",
  pointerEvents: "auto",
  transform: "translate(12px, 7px) scale(0.75)",
  maxWidth: "calc(133% - 24px)"
}, t.size === "small" && {
  transform: "translate(12px, 4px) scale(0.75)"
})), t.variant === "outlined" && N({
  // see comment above on filled.zIndex
  zIndex: 1,
  pointerEvents: "none",
  transform: "translate(14px, 16px) scale(1)",
  maxWidth: "calc(100% - 24px)"
}, t.size === "small" && {
  transform: "translate(14px, 9px) scale(1)"
}, t.shrink && {
  userSelect: "none",
  pointerEvents: "auto",
  // Theoretically, we should have (8+5)*2/0.75 = 34px
  // but it feels a better when it bleeds a bit on the left, so 32px.
  maxWidth: "calc(133% - 32px)",
  transform: "translate(14px, -9px) scale(0.75)"
}))), ra = /* @__PURE__ */ V.forwardRef(function(t, n) {
  const r = Ot({
    name: "MuiInputLabel",
    props: t
  }), {
    disableAnimation: i = !1,
    shrink: o,
    className: s
  } = r, a = _e(r, p5e), u = Tu();
  let c = o;
  typeof c > "u" && u && (c = u.filled || u.focused || u.adornedStart);
  const d = wd({
    props: r,
    muiFormControl: u,
    states: ["size", "variant", "required", "focused"]
  }), f = N({}, r, {
    disableAnimation: i,
    formControl: u,
    shrink: c,
    size: d.size,
    variant: d.variant,
    required: d.required,
    focused: d.focused
  }), h = f5e(f);
  return /* @__PURE__ */ P.jsx(h5e, N({
    "data-shrink": c,
    ownerState: f,
    ref: n,
    className: Be(h.root, s)
  }, a, {
    classes: h
  }));
});
process.env.NODE_ENV !== "production" && (ra.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   */
  color: l.oneOfType([l.oneOf(["error", "info", "primary", "secondary", "success", "warning"]), l.string]),
  /**
   * If `true`, the transition animation is disabled.
   * @default false
   */
  disableAnimation: l.bool,
  /**
   * If `true`, the component is disabled.
   */
  disabled: l.bool,
  /**
   * If `true`, the label is displayed in an error state.
   */
  error: l.bool,
  /**
   * If `true`, the `input` of this label is focused.
   */
  focused: l.bool,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: l.oneOf(["dense"]),
  /**
   * if `true`, the label will indicate that the `input` is required.
   */
  required: l.bool,
  /**
   * If `true`, the label is shrunk.
   */
  shrink: l.bool,
  /**
   * The size of the component.
   * @default 'normal'
   */
  size: l.oneOfType([l.oneOf(["normal", "small"]), l.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * The variant to use.
   */
  variant: l.oneOf(["filled", "outlined", "standard"])
});
const cu = /* @__PURE__ */ V.createContext({});
process.env.NODE_ENV !== "production" && (cu.displayName = "ListContext");
function m5e(e) {
  return ot("MuiList", e);
}
st("MuiList", ["root", "padding", "dense", "subheader"]);
const g5e = ["children", "className", "component", "dense", "disablePadding", "subheader"], y5e = (e) => {
  const {
    classes: t,
    disablePadding: n,
    dense: r,
    subheader: i
  } = e;
  return at({
    root: ["root", !n && "padding", r && "dense", i && "subheader"]
  }, m5e, t);
}, b5e = De("ul", {
  name: "MuiList",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, !n.disablePadding && t.padding, n.dense && t.dense, n.subheader && t.subheader];
  }
})(({
  ownerState: e
}) => N({
  listStyle: "none",
  margin: 0,
  padding: 0,
  position: "relative"
}, !e.disablePadding && {
  paddingTop: 8,
  paddingBottom: 8
}, e.subheader && {
  paddingTop: 0
})), ov = /* @__PURE__ */ V.forwardRef(function(t, n) {
  const r = Ot({
    props: t,
    name: "MuiList"
  }), {
    children: i,
    className: o,
    component: s = "ul",
    dense: a = !1,
    disablePadding: u = !1,
    subheader: c
  } = r, d = _e(r, g5e), f = V.useMemo(() => ({
    dense: a
  }), [a]), h = N({}, r, {
    component: s,
    dense: a,
    disablePadding: u
  }), m = y5e(h);
  return /* @__PURE__ */ P.jsx(cu.Provider, {
    value: f,
    children: /* @__PURE__ */ P.jsxs(b5e, N({
      as: s,
      className: Be(m.root, o),
      ref: n,
      ownerState: h
    }, d, {
      children: [c, i]
    }))
  });
});
process.env.NODE_ENV !== "production" && (ov.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used for
   * the list and list items.
   * The prop is available to descendant components as the `dense` context.
   * @default false
   */
  dense: l.bool,
  /**
   * If `true`, vertical padding is removed from the list.
   * @default false
   */
  disablePadding: l.bool,
  /**
   * The content of the subheader, normally `ListSubheader`.
   */
  subheader: l.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
function v5e(e) {
  return ot("MuiListItem", e);
}
const wh = st("MuiListItem", ["root", "container", "focusVisible", "dense", "alignItemsFlexStart", "disabled", "divider", "gutters", "padding", "button", "secondaryAction", "selected"]), x5e = st("MuiListItemButton", ["root", "focusVisible", "dense", "alignItemsFlexStart", "disabled", "divider", "gutters", "selected"]);
function D5e(e) {
  return ot("MuiListItemSecondaryAction", e);
}
st("MuiListItemSecondaryAction", ["root", "disableGutters"]);
const C5e = ["className"], E5e = (e) => {
  const {
    disableGutters: t,
    classes: n
  } = e;
  return at({
    root: ["root", t && "disableGutters"]
  }, D5e, n);
}, T5e = De("div", {
  name: "MuiListItemSecondaryAction",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.disableGutters && t.disableGutters];
  }
})(({
  ownerState: e
}) => N({
  position: "absolute",
  right: 16,
  top: "50%",
  transform: "translateY(-50%)"
}, e.disableGutters && {
  right: 0
})), sv = /* @__PURE__ */ V.forwardRef(function(t, n) {
  const r = Ot({
    props: t,
    name: "MuiListItemSecondaryAction"
  }), {
    className: i
  } = r, o = _e(r, C5e), s = V.useContext(cu), a = N({}, r, {
    disableGutters: s.disableGutters
  }), u = E5e(a);
  return /* @__PURE__ */ P.jsx(T5e, N({
    className: Be(u.root, i),
    ownerState: a,
    ref: n
  }, o));
});
process.env.NODE_ENV !== "production" && (sv.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally an `IconButton` or selection control.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
sv.muiName = "ListItemSecondaryAction";
const S5e = ["className"], A5e = ["alignItems", "autoFocus", "button", "children", "className", "component", "components", "componentsProps", "ContainerComponent", "ContainerProps", "dense", "disabled", "disableGutters", "disablePadding", "divider", "focusVisibleClassName", "secondaryAction", "selected", "slotProps", "slots"], w5e = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.root, n.dense && t.dense, n.alignItems === "flex-start" && t.alignItemsFlexStart, n.divider && t.divider, !n.disableGutters && t.gutters, !n.disablePadding && t.padding, n.button && t.button, n.hasSecondaryAction && t.secondaryAction];
}, P5e = (e) => {
  const {
    alignItems: t,
    button: n,
    classes: r,
    dense: i,
    disabled: o,
    disableGutters: s,
    disablePadding: a,
    divider: u,
    hasSecondaryAction: c,
    selected: d
  } = e;
  return at({
    root: ["root", i && "dense", !s && "gutters", !a && "padding", u && "divider", o && "disabled", n && "button", t === "flex-start" && "alignItemsFlexStart", c && "secondaryAction", d && "selected"],
    container: ["container"]
  }, v5e, r);
}, k5e = De("div", {
  name: "MuiListItem",
  slot: "Root",
  overridesResolver: w5e
})(({
  theme: e,
  ownerState: t
}) => N({
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  position: "relative",
  textDecoration: "none",
  width: "100%",
  boxSizing: "border-box",
  textAlign: "left"
}, !t.disablePadding && N({
  paddingTop: 8,
  paddingBottom: 8
}, t.dense && {
  paddingTop: 4,
  paddingBottom: 4
}, !t.disableGutters && {
  paddingLeft: 16,
  paddingRight: 16
}, !!t.secondaryAction && {
  // Add some space to avoid collision as `ListItemSecondaryAction`
  // is absolutely positioned.
  paddingRight: 48
}), !!t.secondaryAction && {
  [`& > .${x5e.root}`]: {
    paddingRight: 48
  }
}, {
  [`&.${wh.focusVisible}`]: {
    backgroundColor: (e.vars || e).palette.action.focus
  },
  [`&.${wh.selected}`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : Yt(e.palette.primary.main, e.palette.action.selectedOpacity),
    [`&.${wh.focusVisible}`]: {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : Yt(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
    }
  },
  [`&.${wh.disabled}`]: {
    opacity: (e.vars || e).palette.action.disabledOpacity
  }
}, t.alignItems === "flex-start" && {
  alignItems: "flex-start"
}, t.divider && {
  borderBottom: `1px solid ${(e.vars || e).palette.divider}`,
  backgroundClip: "padding-box"
}, t.button && {
  transition: e.transitions.create("background-color", {
    duration: e.transitions.duration.shortest
  }),
  "&:hover": {
    textDecoration: "none",
    backgroundColor: (e.vars || e).palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  [`&.${wh.selected}:hover`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : Yt(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : Yt(e.palette.primary.main, e.palette.action.selectedOpacity)
    }
  }
}, t.hasSecondaryAction && {
  // Add some space to avoid collision as `ListItemSecondaryAction`
  // is absolutely positioned.
  paddingRight: 48
})), O5e = De("li", {
  name: "MuiListItem",
  slot: "Container",
  overridesResolver: (e, t) => t.container
})({
  position: "relative"
}), UE = /* @__PURE__ */ V.forwardRef(function(t, n) {
  const r = Ot({
    props: t,
    name: "MuiListItem"
  }), {
    alignItems: i = "center",
    autoFocus: o = !1,
    button: s = !1,
    children: a,
    className: u,
    component: c,
    components: d = {},
    componentsProps: f = {},
    ContainerComponent: h = "li",
    ContainerProps: {
      className: m
    } = {},
    dense: v = !1,
    disabled: x = !1,
    disableGutters: C = !1,
    disablePadding: E = !1,
    divider: S = !1,
    focusVisibleClassName: w,
    secondaryAction: O,
    selected: A = !1,
    slotProps: I = {},
    slots: $ = {}
  } = r, L = _e(r.ContainerProps, S5e), B = _e(r, A5e), H = V.useContext(cu), q = V.useMemo(() => ({
    dense: v || H.dense || !1,
    alignItems: i,
    disableGutters: C
  }), [i, H.dense, v, C]), J = V.useRef(null);
  gi(() => {
    o && (J.current ? J.current.focus() : process.env.NODE_ENV !== "production" && console.error("MUI: Unable to set focus to a ListItem whose component has not been rendered."));
  }, [o]);
  const X = V.Children.toArray(a), j = X.length && _p(X[X.length - 1], ["ListItemSecondaryAction"]), U = N({}, r, {
    alignItems: i,
    autoFocus: o,
    button: s,
    dense: q.dense,
    disabled: x,
    disableGutters: C,
    disablePadding: E,
    divider: S,
    hasSecondaryAction: j,
    selected: A
  }), G = P5e(U), K = Hn(J, n), ee = $.root || d.Root || k5e, te = I.root || f.root || {}, M = N({
    className: Be(G.root, te.className, u),
    disabled: x
  }, B);
  let Z = c || "li";
  return s && (M.component = c || "div", M.focusVisibleClassName = Be(wh.focusVisible, w), Z = sa), j ? (Z = !M.component && !c ? "div" : Z, h === "li" && (Z === "li" ? Z = "div" : M.component === "li" && (M.component = "div")), /* @__PURE__ */ P.jsx(cu.Provider, {
    value: q,
    children: /* @__PURE__ */ P.jsxs(O5e, N({
      as: h,
      className: Be(G.container, m),
      ref: K,
      ownerState: U
    }, L, {
      children: [/* @__PURE__ */ P.jsx(ee, N({}, te, !lu(ee) && {
        as: Z,
        ownerState: N({}, U, te.ownerState)
      }, M, {
        children: X
      })), X.pop()]
    }))
  })) : /* @__PURE__ */ P.jsx(cu.Provider, {
    value: q,
    children: /* @__PURE__ */ P.jsxs(ee, N({}, te, {
      as: Z,
      ref: K
    }, !lu(ee) && {
      ownerState: N({}, U, te.ownerState)
    }, M, {
      children: [X, O && /* @__PURE__ */ P.jsx(sv, {
        children: O
      })]
    }))
  });
});
process.env.NODE_ENV !== "production" && (UE.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Defines the `align-items` style property.
   * @default 'center'
   */
  alignItems: l.oneOf(["center", "flex-start"]),
  /**
   * If `true`, the list item is focused during the first mount.
   * Focus will also be triggered if the value changes from false to true.
   * @default false
   * @deprecated checkout [ListItemButton](/material-ui/api/list-item-button/) instead
   */
  autoFocus: l.bool,
  /**
   * If `true`, the list item is a button (using `ButtonBase`). Props intended
   * for `ButtonBase` can then be applied to `ListItem`.
   * @default false
   * @deprecated checkout [ListItemButton](/material-ui/api/list-item-button/) instead
   */
  button: l.bool,
  /**
   * The content of the component if a `ListItemSecondaryAction` is used it must
   * be the last child.
   */
  children: $s(l.node, (e) => {
    const t = V.Children.toArray(e.children);
    let n = -1;
    for (let r = t.length - 1; r >= 0; r -= 1) {
      const i = t[r];
      if (_p(i, ["ListItemSecondaryAction"])) {
        n = r;
        break;
      }
    }
    return n !== -1 && n !== t.length - 1 ? new Error("MUI: You used an element after ListItemSecondaryAction. For ListItem to detect that it has a secondary action you must pass it as the last child to ListItem.") : null;
  }),
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: l.shape({
    Root: l.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: l.shape({
    root: l.object
  }),
  /**
   * The container component used when a `ListItemSecondaryAction` is the last child.
   * @default 'li'
   * @deprecated
   */
  ContainerComponent: jb,
  /**
   * Props applied to the container component if used.
   * @default {}
   * @deprecated
   */
  ContainerProps: l.object,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used.
   * The prop defaults to the value inherited from the parent List component.
   * @default false
   */
  dense: l.bool,
  /**
   * If `true`, the component is disabled.
   * @default false
   * @deprecated checkout [ListItemButton](/material-ui/api/list-item-button/) instead
   */
  disabled: l.bool,
  /**
   * If `true`, the left and right padding is removed.
   * @default false
   */
  disableGutters: l.bool,
  /**
   * If `true`, all padding is removed.
   * @default false
   */
  disablePadding: l.bool,
  /**
   * If `true`, a 1px light border is added to the bottom of the list item.
   * @default false
   */
  divider: l.bool,
  /**
   * @ignore
   */
  focusVisibleClassName: l.string,
  /**
   * The element to display at the end of ListItem.
   */
  secondaryAction: l.node,
  /**
   * Use to apply selected styling.
   * @default false
   * @deprecated checkout [ListItemButton](/material-ui/api/list-item-button/) instead
   */
  selected: l.bool,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: l.shape({
    root: l.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: l.shape({
    root: l.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
function I5e(e) {
  return ot("MuiListItemAvatar", e);
}
st("MuiListItemAvatar", ["root", "alignItemsFlexStart"]);
const F5e = ["className"], $5e = (e) => {
  const {
    alignItems: t,
    classes: n
  } = e;
  return at({
    root: ["root", t === "flex-start" && "alignItemsFlexStart"]
  }, I5e, n);
}, N5e = De("div", {
  name: "MuiListItemAvatar",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.alignItems === "flex-start" && t.alignItemsFlexStart];
  }
})(({
  ownerState: e
}) => N({
  minWidth: 56,
  flexShrink: 0
}, e.alignItems === "flex-start" && {
  marginTop: 8
})), CF = /* @__PURE__ */ V.forwardRef(function(t, n) {
  const r = Ot({
    props: t,
    name: "MuiListItemAvatar"
  }), {
    className: i
  } = r, o = _e(r, F5e), s = V.useContext(cu), a = N({}, r, {
    alignItems: s.alignItems
  }), u = $5e(a);
  return /* @__PURE__ */ P.jsx(N5e, N({
    className: Be(u.root, i),
    ownerState: a,
    ref: n
  }, o));
});
process.env.NODE_ENV !== "production" && (CF.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally an `Avatar`.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
const k3 = st("MuiListItemIcon", ["root", "alignItemsFlexStart"]);
function M5e(e) {
  return ot("MuiListItemText", e);
}
const KD = st("MuiListItemText", ["root", "multiline", "dense", "inset", "primary", "secondary"]), R5e = ["children", "className", "disableTypography", "inset", "primary", "primaryTypographyProps", "secondary", "secondaryTypographyProps"], _5e = (e) => {
  const {
    classes: t,
    inset: n,
    primary: r,
    secondary: i,
    dense: o
  } = e;
  return at({
    root: ["root", n && "inset", o && "dense", r && i && "multiline"],
    primary: ["primary"],
    secondary: ["secondary"]
  }, M5e, t);
}, L5e = De("div", {
  name: "MuiListItemText",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [{
      [`& .${KD.primary}`]: t.primary
    }, {
      [`& .${KD.secondary}`]: t.secondary
    }, t.root, n.inset && t.inset, n.primary && n.secondary && t.multiline, n.dense && t.dense];
  }
})(({
  ownerState: e
}) => N({
  flex: "1 1 auto",
  minWidth: 0,
  marginTop: 4,
  marginBottom: 4
}, e.primary && e.secondary && {
  marginTop: 6,
  marginBottom: 6
}, e.inset && {
  paddingLeft: 56
})), hf = /* @__PURE__ */ V.forwardRef(function(t, n) {
  const r = Ot({
    props: t,
    name: "MuiListItemText"
  }), {
    children: i,
    className: o,
    disableTypography: s = !1,
    inset: a = !1,
    primary: u,
    primaryTypographyProps: c,
    secondary: d,
    secondaryTypographyProps: f
  } = r, h = _e(r, R5e), {
    dense: m
  } = V.useContext(cu);
  let v = u ?? i, x = d;
  const C = N({}, r, {
    disableTypography: s,
    inset: a,
    primary: !!v,
    secondary: !!x,
    dense: m
  }), E = _5e(C);
  return v != null && v.type !== cn && !s && (v = /* @__PURE__ */ P.jsx(cn, N({
    variant: m ? "body2" : "body1",
    className: E.primary,
    component: c != null && c.variant ? void 0 : "span",
    display: "block"
  }, c, {
    children: v
  }))), x != null && x.type !== cn && !s && (x = /* @__PURE__ */ P.jsx(cn, N({
    variant: "body2",
    className: E.secondary,
    color: "text.secondary",
    display: "block"
  }, f, {
    children: x
  }))), /* @__PURE__ */ P.jsxs(L5e, N({
    className: Be(E.root, o),
    ownerState: C,
    ref: n
  }, h, {
    children: [v, x]
  }));
});
process.env.NODE_ENV !== "production" && (hf.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Alias for the `primary` prop.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * If `true`, the children won't be wrapped by a Typography component.
   * This can be useful to render an alternative Typography variant by wrapping
   * the `children` (or `primary`) text, and optional `secondary` text
   * with the Typography component.
   * @default false
   */
  disableTypography: l.bool,
  /**
   * If `true`, the children are indented.
   * This should be used if there is no left avatar or left icon.
   * @default false
   */
  inset: l.bool,
  /**
   * The main content element.
   */
  primary: l.node,
  /**
   * These props will be forwarded to the primary typography component
   * (as long as disableTypography is not `true`).
   */
  primaryTypographyProps: l.object,
  /**
   * The secondary content element.
   */
  secondary: l.node,
  /**
   * These props will be forwarded to the secondary typography component
   * (as long as disableTypography is not `true`).
   */
  secondaryTypographyProps: l.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
const B5e = ["actions", "autoFocus", "autoFocusItem", "children", "className", "disabledItemsFocusable", "disableListWrap", "onKeyDown", "variant"];
function QA(e, t, n) {
  return e === t ? e.firstChild : t && t.nextElementSibling ? t.nextElementSibling : n ? null : e.firstChild;
}
function O3(e, t, n) {
  return e === t ? n ? e.firstChild : e.lastChild : t && t.previousElementSibling ? t.previousElementSibling : n ? null : e.lastChild;
}
function GU(e, t) {
  if (t === void 0)
    return !0;
  let n = e.innerText;
  return n === void 0 && (n = e.textContent), n = n.trim().toLowerCase(), n.length === 0 ? !1 : t.repeating ? n[0] === t.keys[0] : n.indexOf(t.keys.join("")) === 0;
}
function Ay(e, t, n, r, i, o) {
  let s = !1, a = i(e, t, t ? n : !1);
  for (; a; ) {
    if (a === e.firstChild) {
      if (s)
        return !1;
      s = !0;
    }
    const u = r ? !1 : a.disabled || a.getAttribute("aria-disabled") === "true";
    if (!a.hasAttribute("tabindex") || !GU(a, o) || u)
      a = i(e, a, n);
    else
      return a.focus(), !0;
  }
  return !1;
}
const Pd = /* @__PURE__ */ V.forwardRef(function(t, n) {
  const {
    // private
    // eslint-disable-next-line react/prop-types
    actions: r,
    autoFocus: i = !1,
    autoFocusItem: o = !1,
    children: s,
    className: a,
    disabledItemsFocusable: u = !1,
    disableListWrap: c = !1,
    onKeyDown: d,
    variant: f = "selectedMenu"
  } = t, h = _e(t, B5e), m = V.useRef(null), v = V.useRef({
    keys: [],
    repeating: !0,
    previousKeyMatched: !0,
    lastTime: null
  });
  gi(() => {
    i && m.current.focus();
  }, [i]), V.useImperativeHandle(r, () => ({
    adjustStyleForScrollbar: (w, {
      direction: O
    }) => {
      const A = !m.current.style.width;
      if (w.clientHeight < m.current.clientHeight && A) {
        const I = `${Zz(ei(w))}px`;
        m.current.style[O === "rtl" ? "paddingLeft" : "paddingRight"] = I, m.current.style.width = `calc(100% + ${I})`;
      }
      return m.current;
    }
  }), []);
  const x = (w) => {
    const O = m.current, A = w.key, I = ei(O).activeElement;
    if (A === "ArrowDown")
      w.preventDefault(), Ay(O, I, c, u, QA);
    else if (A === "ArrowUp")
      w.preventDefault(), Ay(O, I, c, u, O3);
    else if (A === "Home")
      w.preventDefault(), Ay(O, null, c, u, QA);
    else if (A === "End")
      w.preventDefault(), Ay(O, null, c, u, O3);
    else if (A.length === 1) {
      const $ = v.current, L = A.toLowerCase(), B = performance.now();
      $.keys.length > 0 && (B - $.lastTime > 500 ? ($.keys = [], $.repeating = !0, $.previousKeyMatched = !0) : $.repeating && L !== $.keys[0] && ($.repeating = !1)), $.lastTime = B, $.keys.push(L);
      const H = I && !$.repeating && GU(I, $);
      $.previousKeyMatched && (H || Ay(O, I, !1, u, QA, $)) ? w.preventDefault() : $.previousKeyMatched = !1;
    }
    d && d(w);
  }, C = Hn(m, n);
  let E = -1;
  V.Children.forEach(s, (w, O) => {
    if (!/* @__PURE__ */ V.isValidElement(w)) {
      E === O && (E += 1, E >= s.length && (E = -1));
      return;
    }
    process.env.NODE_ENV !== "production" && Gp.isFragment(w) && console.error(["MUI: The Menu component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`)), w.props.disabled || (f === "selectedMenu" && w.props.selected || E === -1) && (E = O), E === O && (w.props.disabled || w.props.muiSkipListHighlight || w.type.muiSkipListHighlight) && (E += 1, E >= s.length && (E = -1));
  });
  const S = V.Children.map(s, (w, O) => {
    if (O === E) {
      const A = {};
      return o && (A.autoFocus = !0), w.props.tabIndex === void 0 && f === "selectedMenu" && (A.tabIndex = 0), /* @__PURE__ */ V.cloneElement(w, A);
    }
    return w;
  });
  return /* @__PURE__ */ P.jsx(ov, N({
    role: "menu",
    ref: C,
    className: a,
    onKeyDown: x,
    tabIndex: i ? 0 : -1
  }, h, {
    children: S
  }));
});
process.env.NODE_ENV !== "production" && (Pd.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, will focus the `[role="menu"]` container and move into tab order.
   * @default false
   */
  autoFocus: l.bool,
  /**
   * If `true`, will focus the first menuitem if `variant="menu"` or selected item
   * if `variant="selectedMenu"`.
   * @default false
   */
  autoFocusItem: l.bool,
  /**
   * MenuList contents, normally `MenuItem`s.
   */
  children: l.node,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * If `true`, will allow focus on disabled items.
   * @default false
   */
  disabledItemsFocusable: l.bool,
  /**
   * If `true`, the menu items will not wrap focus.
   * @default false
   */
  disableListWrap: l.bool,
  /**
   * @ignore
   */
  onKeyDown: l.func,
  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus
   * and the vertical alignment relative to the anchor element.
   * @default 'selectedMenu'
   */
  variant: l.oneOf(["menu", "selectedMenu"])
});
function j5e(e) {
  return ot("MuiPopover", e);
}
st("MuiPopover", ["root", "paper"]);
const V5e = ["onEntering"], z5e = ["action", "anchorEl", "anchorOrigin", "anchorPosition", "anchorReference", "children", "className", "container", "elevation", "marginThreshold", "open", "PaperProps", "slots", "slotProps", "transformOrigin", "TransitionComponent", "transitionDuration", "TransitionProps", "disableScrollLock"], U5e = ["slotProps"];
function I3(e, t) {
  let n = 0;
  return typeof t == "number" ? n = t : t === "center" ? n = e.height / 2 : t === "bottom" && (n = e.height), n;
}
function F3(e, t) {
  let n = 0;
  return typeof t == "number" ? n = t : t === "center" ? n = e.width / 2 : t === "right" && (n = e.width), n;
}
function $3(e) {
  return [e.horizontal, e.vertical].map((t) => typeof t == "number" ? `${t}px` : t).join(" ");
}
function Zx(e) {
  return typeof e == "function" ? e() : e;
}
const W5e = (e) => {
  const {
    classes: t
  } = e;
  return at({
    root: ["root"],
    paper: ["paper"]
  }, j5e, t);
}, H5e = De(vF, {
  name: "MuiPopover",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), YU = De(ti, {
  name: "MuiPopover",
  slot: "Paper",
  overridesResolver: (e, t) => t.paper
})({
  position: "absolute",
  overflowY: "auto",
  overflowX: "hidden",
  // So we see the popover when it's empty.
  // It's most likely on issue on userland.
  minWidth: 16,
  minHeight: 16,
  maxWidth: "calc(100% - 32px)",
  maxHeight: "calc(100% - 32px)",
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}), EF = /* @__PURE__ */ V.forwardRef(function(t, n) {
  var r, i, o;
  const s = Ot({
    props: t,
    name: "MuiPopover"
  }), {
    action: a,
    anchorEl: u,
    anchorOrigin: c = {
      vertical: "top",
      horizontal: "left"
    },
    anchorPosition: d,
    anchorReference: f = "anchorEl",
    children: h,
    className: m,
    container: v,
    elevation: x = 8,
    marginThreshold: C = 16,
    open: E,
    PaperProps: S = {},
    slots: w,
    slotProps: O,
    transformOrigin: A = {
      vertical: "top",
      horizontal: "left"
    },
    TransitionComponent: I = ym,
    transitionDuration: $ = "auto",
    TransitionProps: {
      onEntering: L
    } = {},
    disableScrollLock: B = !1
  } = s, H = _e(s.TransitionProps, V5e), q = _e(s, z5e), J = (r = O == null ? void 0 : O.paper) != null ? r : S, X = V.useRef(), j = Hn(X, J.ref), U = N({}, s, {
    anchorOrigin: c,
    anchorReference: f,
    elevation: x,
    marginThreshold: C,
    externalPaperSlotProps: J,
    transformOrigin: A,
    TransitionComponent: I,
    transitionDuration: $,
    TransitionProps: H
  }), G = W5e(U), K = V.useCallback(() => {
    if (f === "anchorPosition")
      return process.env.NODE_ENV !== "production" && (d || console.error('MUI: You need to provide a `anchorPosition` prop when using <Popover anchorReference="anchorPosition" />.')), d;
    const ye = Zx(u), be = ye && ye.nodeType === 1 ? ye : ei(X.current).body, Re = be.getBoundingClientRect();
    if (process.env.NODE_ENV !== "production") {
      const Te = be.getBoundingClientRect();
      process.env.NODE_ENV !== "test" && Te.top === 0 && Te.left === 0 && Te.right === 0 && Te.bottom === 0 && console.warn(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
    }
    return {
      top: Re.top + I3(Re, c.vertical),
      left: Re.left + F3(Re, c.horizontal)
    };
  }, [u, c.horizontal, c.vertical, d, f]), ee = V.useCallback((ye) => ({
    vertical: I3(ye, A.vertical),
    horizontal: F3(ye, A.horizontal)
  }), [A.horizontal, A.vertical]), te = V.useCallback((ye) => {
    const be = {
      width: ye.offsetWidth,
      height: ye.offsetHeight
    }, Re = ee(be);
    if (f === "none")
      return {
        top: null,
        left: null,
        transformOrigin: $3(Re)
      };
    const Te = K();
    let Xe = Te.top - Re.vertical, Ne = Te.left - Re.horizontal;
    const Qe = Xe + be.height, Ee = Ne + be.width, Ie = bu(Zx(u)), Je = Ie.innerHeight - C, vt = Ie.innerWidth - C;
    if (C !== null && Xe < C) {
      const St = Xe - C;
      Xe -= St, Re.vertical += St;
    } else if (C !== null && Qe > Je) {
      const St = Qe - Je;
      Xe -= St, Re.vertical += St;
    }
    if (process.env.NODE_ENV !== "production" && be.height > Je && be.height && Je && console.error(["MUI: The popover component is too tall.", `Some part of it can not be seen on the screen (${be.height - Je}px).`, "Please consider adding a `max-height` to improve the user-experience."].join(`
`)), C !== null && Ne < C) {
      const St = Ne - C;
      Ne -= St, Re.horizontal += St;
    } else if (Ee > vt) {
      const St = Ee - vt;
      Ne -= St, Re.horizontal += St;
    }
    return {
      top: `${Math.round(Xe)}px`,
      left: `${Math.round(Ne)}px`,
      transformOrigin: $3(Re)
    };
  }, [u, f, K, ee, C]), [M, Z] = V.useState(E), ne = V.useCallback(() => {
    const ye = X.current;
    if (!ye)
      return;
    const be = te(ye);
    be.top !== null && (ye.style.top = be.top), be.left !== null && (ye.style.left = be.left), ye.style.transformOrigin = be.transformOrigin, Z(!0);
  }, [te]);
  V.useEffect(() => (B && window.addEventListener("scroll", ne), () => window.removeEventListener("scroll", ne)), [u, B, ne]);
  const R = (ye, be) => {
    L && L(ye, be), ne();
  }, _ = () => {
    Z(!1);
  };
  V.useEffect(() => {
    E && ne();
  }), V.useImperativeHandle(a, () => E ? {
    updatePosition: () => {
      ne();
    }
  } : null, [E, ne]), V.useEffect(() => {
    if (!E)
      return;
    const ye = Vb(() => {
      ne();
    }), be = bu(u);
    return be.addEventListener("resize", ye), () => {
      ye.clear(), be.removeEventListener("resize", ye);
    };
  }, [u, E, ne]);
  let W = $;
  $ === "auto" && !I.muiSupportAuto && (W = void 0);
  const Q = v || (u ? ei(Zx(u)).body : void 0), oe = (i = w == null ? void 0 : w.root) != null ? i : H5e, ae = (o = w == null ? void 0 : w.paper) != null ? o : YU, pe = Ai({
    elementType: ae,
    externalSlotProps: N({}, J, {
      style: M ? J.style : N({}, J.style, {
        opacity: 0
      })
    }),
    additionalProps: {
      elevation: x,
      ref: j
    },
    ownerState: U,
    className: Be(G.paper, J == null ? void 0 : J.className)
  }), me = Ai({
    elementType: oe,
    externalSlotProps: (O == null ? void 0 : O.root) || {},
    externalForwardedProps: q,
    additionalProps: {
      ref: n,
      slotProps: {
        backdrop: {
          invisible: !0
        }
      },
      container: Q,
      open: E
    },
    ownerState: U,
    className: Be(G.root, m)
  }), {
    slotProps: xe
  } = me, le = _e(me, U5e);
  return /* @__PURE__ */ P.jsx(oe, N({}, le, !lu(oe) && {
    slotProps: xe,
    disableScrollLock: B
  }, {
    children: /* @__PURE__ */ P.jsx(I, N({
      appear: !0,
      in: E,
      onEntering: R,
      onExited: _,
      timeout: W
    }, H, {
      children: /* @__PURE__ */ P.jsx(ae, N({}, pe, {
        children: h
      }))
    }))
  }));
});
process.env.NODE_ENV !== "production" && (EF.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * A ref for imperative actions.
   * It currently only supports updatePosition() action.
   */
  action: wr,
  /**
   * An HTML element, [PopoverVirtualElement](/material-ui/react-popover/#virtual-element),
   * or a function that returns either.
   * It's used to set the position of the popover.
   */
  anchorEl: $s(l.oneOfType([sc, l.func]), (e) => {
    if (e.open && (!e.anchorReference || e.anchorReference === "anchorEl")) {
      const t = Zx(e.anchorEl);
      if (t && t.nodeType === 1) {
        const n = t.getBoundingClientRect();
        if (process.env.NODE_ENV !== "test" && n.top === 0 && n.left === 0 && n.right === 0 && n.bottom === 0)
          return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", "The anchor element should be part of the document layout.", "Make sure the element is present in the document or that it's not display none."].join(`
`));
      } else
        return new Error(["MUI: The `anchorEl` prop provided to the component is invalid.", `It should be an Element or PopoverVirtualElement instance but it's \`${t}\` instead.`].join(`
`));
    }
    return null;
  }),
  /**
   * This is the point on the anchor where the popover's
   * `anchorEl` will attach to. This is not used when the
   * anchorReference is 'anchorPosition'.
   *
   * Options:
   * vertical: [top, center, bottom];
   * horizontal: [left, center, right].
   * @default {
   *   vertical: 'top',
   *   horizontal: 'left',
   * }
   */
  anchorOrigin: l.shape({
    horizontal: l.oneOfType([l.oneOf(["center", "left", "right"]), l.number]).isRequired,
    vertical: l.oneOfType([l.oneOf(["bottom", "center", "top"]), l.number]).isRequired
  }),
  /**
   * This is the position that may be used to set the position of the popover.
   * The coordinates are relative to the application's client area.
   */
  anchorPosition: l.shape({
    left: l.number.isRequired,
    top: l.number.isRequired
  }),
  /**
   * This determines which anchor prop to refer to when setting
   * the position of the popover.
   * @default 'anchorEl'
   */
  anchorReference: l.oneOf(["anchorEl", "anchorPosition", "none"]),
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * An HTML element, component instance, or function that returns either.
   * The `container` will passed to the Modal component.
   *
   * By default, it uses the body of the anchorEl's top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: l.oneOfType([sc, l.func]),
  /**
   * Disable the scroll lock behavior.
   * @default false
   */
  disableScrollLock: l.bool,
  /**
   * The elevation of the popover.
   * @default 8
   */
  elevation: Ub,
  /**
   * Specifies how close to the edge of the window the popover can appear.
   * If null, the popover will not be constrained by the window.
   * @default 16
   */
  marginThreshold: l.number,
  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   */
  onClose: l.func,
  /**
   * If `true`, the component is shown.
   */
  open: l.bool.isRequired,
  /**
   * Props applied to the [`Paper`](/material-ui/api/paper/) element.
   *
   * This prop is an alias for `slotProps.paper` and will be overriden by it if both are used.
   * @deprecated Use `slotProps.paper` instead.
   *
   * @default {}
   */
  PaperProps: l.shape({
    component: jb
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @default {}
   */
  slotProps: l.shape({
    paper: l.oneOfType([l.func, l.object]),
    root: l.oneOfType([l.func, l.object])
  }),
  /**
   * The components used for each slot inside.
   *
   * @default {}
   */
  slots: l.shape({
    paper: l.elementType,
    root: l.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * This is the point on the popover which
   * will attach to the anchor's origin.
   *
   * Options:
   * vertical: [top, center, bottom, x(px)];
   * horizontal: [left, center, right, x(px)].
   * @default {
   *   vertical: 'top',
   *   horizontal: 'left',
   * }
   */
  transformOrigin: l.shape({
    horizontal: l.oneOfType([l.oneOf(["center", "left", "right"]), l.number]).isRequired,
    vertical: l.oneOfType([l.oneOf(["bottom", "center", "top"]), l.number]).isRequired
  }),
  /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Grow
   */
  TransitionComponent: l.elementType,
  /**
   * Set to 'auto' to automatically calculate transition time based on height.
   * @default 'auto'
   */
  transitionDuration: l.oneOfType([l.oneOf(["auto"]), l.number, l.shape({
    appear: l.number,
    enter: l.number,
    exit: l.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @default {}
   */
  TransitionProps: l.object
});
function q5e(e) {
  return ot("MuiMenu", e);
}
st("MuiMenu", ["root", "paper", "list"]);
const G5e = ["onEntering"], Y5e = ["autoFocus", "children", "className", "disableAutoFocusItem", "MenuListProps", "onClose", "open", "PaperProps", "PopoverClasses", "transitionDuration", "TransitionProps", "variant", "slots", "slotProps"], K5e = {
  vertical: "top",
  horizontal: "right"
}, J5e = {
  vertical: "top",
  horizontal: "left"
}, X5e = (e) => {
  const {
    classes: t
  } = e;
  return at({
    root: ["root"],
    paper: ["paper"],
    list: ["list"]
  }, q5e, t);
}, Q5e = De(EF, {
  shouldForwardProp: (e) => Ao(e) || e === "classes",
  name: "MuiMenu",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), Z5e = De(YU, {
  name: "MuiMenu",
  slot: "Paper",
  overridesResolver: (e, t) => t.paper
})({
  // specZ: The maximum height of a simple menu should be one or more rows less than the view
  // height. This ensures a tappable area outside of the simple menu with which to dismiss
  // the menu.
  maxHeight: "calc(100% - 96px)",
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: "touch"
}), e4e = De(Pd, {
  name: "MuiMenu",
  slot: "List",
  overridesResolver: (e, t) => t.list
})({
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}), KU = /* @__PURE__ */ V.forwardRef(function(t, n) {
  var r, i;
  const o = Ot({
    props: t,
    name: "MuiMenu"
  }), {
    autoFocus: s = !0,
    children: a,
    className: u,
    disableAutoFocusItem: c = !1,
    MenuListProps: d = {},
    onClose: f,
    open: h,
    PaperProps: m = {},
    PopoverClasses: v,
    transitionDuration: x = "auto",
    TransitionProps: {
      onEntering: C
    } = {},
    variant: E = "selectedMenu",
    slots: S = {},
    slotProps: w = {}
  } = o, O = _e(o.TransitionProps, G5e), A = _e(o, Y5e), I = Wb(), $ = N({}, o, {
    autoFocus: s,
    disableAutoFocusItem: c,
    MenuListProps: d,
    onEntering: C,
    PaperProps: m,
    transitionDuration: x,
    TransitionProps: O,
    variant: E
  }), L = X5e($), B = s && !c && h, H = V.useRef(null), q = (ee, te) => {
    H.current && H.current.adjustStyleForScrollbar(ee, {
      direction: I ? "rtl" : "ltr"
    }), C && C(ee, te);
  }, J = (ee) => {
    ee.key === "Tab" && (ee.preventDefault(), f && f(ee, "tabKeyDown"));
  };
  let X = -1;
  V.Children.map(a, (ee, te) => {
    /* @__PURE__ */ V.isValidElement(ee) && (process.env.NODE_ENV !== "production" && Gp.isFragment(ee) && console.error(["MUI: The Menu component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`)), ee.props.disabled || (E === "selectedMenu" && ee.props.selected || X === -1) && (X = te));
  });
  const j = (r = S.paper) != null ? r : Z5e, U = (i = w.paper) != null ? i : m, G = Ai({
    elementType: S.root,
    externalSlotProps: w.root,
    ownerState: $,
    className: [L.root, u]
  }), K = Ai({
    elementType: j,
    externalSlotProps: U,
    ownerState: $,
    className: L.paper
  });
  return /* @__PURE__ */ P.jsx(Q5e, N({
    onClose: f,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: I ? "right" : "left"
    },
    transformOrigin: I ? K5e : J5e,
    slots: {
      paper: j,
      root: S.root
    },
    slotProps: {
      root: G,
      paper: K
    },
    open: h,
    ref: n,
    transitionDuration: x,
    TransitionProps: N({
      onEntering: q
    }, O),
    ownerState: $
  }, A, {
    classes: v,
    children: /* @__PURE__ */ P.jsx(e4e, N({
      onKeyDown: J,
      actions: H,
      autoFocus: s && (X === -1 || c),
      autoFocusItem: B,
      variant: E
    }, d, {
      className: Be(L.list, d.className),
      children: a
    }))
  }));
});
process.env.NODE_ENV !== "production" && (KU.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * An HTML element, or a function that returns one.
   * It's used to set the position of the menu.
   */
  anchorEl: l.oneOfType([sc, l.func]),
  /**
   * If `true` (Default) will focus the `[role="menu"]` if no focusable child is found. Disabled
   * children are not focusable. If you set this prop to `false` focus will be placed
   * on the parent modal container. This has severe accessibility implications
   * and should only be considered if you manage focus otherwise.
   * @default true
   */
  autoFocus: l.bool,
  /**
   * Menu contents, normally `MenuItem`s.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * When opening the menu will not focus the active item but the `[role="menu"]`
   * unless `autoFocus` is also set to `false`. Not using the default means not
   * following WAI-ARIA authoring practices. Please be considerate about possible
   * accessibility implications.
   * @default false
   */
  disableAutoFocusItem: l.bool,
  /**
   * Props applied to the [`MenuList`](/material-ui/api/menu-list/) element.
   * @default {}
   */
  MenuListProps: l.object,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`, `"tabKeyDown"`.
   */
  onClose: l.func,
  /**
   * If `true`, the component is shown.
   */
  open: l.bool.isRequired,
  /**
   * @ignore
   */
  PaperProps: l.object,
  /**
   * `classes` prop applied to the [`Popover`](/material-ui/api/popover/) element.
   */
  PopoverClasses: l.object,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @default {}
   */
  slotProps: l.shape({
    paper: l.oneOfType([l.func, l.object]),
    root: l.oneOfType([l.func, l.object])
  }),
  /**
   * The components used for each slot inside.
   *
   * @default {}
   */
  slots: l.shape({
    paper: l.elementType,
    root: l.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * The length of the transition in `ms`, or 'auto'
   * @default 'auto'
   */
  transitionDuration: l.oneOfType([l.oneOf(["auto"]), l.number, l.shape({
    appear: l.number,
    enter: l.number,
    exit: l.number
  })]),
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   * @default {}
   */
  TransitionProps: l.object,
  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus.
   * @default 'selectedMenu'
   */
  variant: l.oneOf(["menu", "selectedMenu"])
});
function t4e(e) {
  return ot("MuiMenuItem", e);
}
const wy = st("MuiMenuItem", ["root", "focusVisible", "dense", "disabled", "divider", "gutters", "selected"]), n4e = ["autoFocus", "component", "dense", "divider", "disableGutters", "focusVisibleClassName", "role", "tabIndex", "className"], r4e = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.root, n.dense && t.dense, n.divider && t.divider, !n.disableGutters && t.gutters];
}, i4e = (e) => {
  const {
    disabled: t,
    dense: n,
    divider: r,
    disableGutters: i,
    selected: o,
    classes: s
  } = e, u = at({
    root: ["root", n && "dense", t && "disabled", !i && "gutters", r && "divider", o && "selected"]
  }, t4e, s);
  return N({}, s, u);
}, o4e = De(sa, {
  shouldForwardProp: (e) => Ao(e) || e === "classes",
  name: "MuiMenuItem",
  slot: "Root",
  overridesResolver: r4e
})(({
  theme: e,
  ownerState: t
}) => N({}, e.typography.body1, {
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  position: "relative",
  textDecoration: "none",
  minHeight: 48,
  paddingTop: 6,
  paddingBottom: 6,
  boxSizing: "border-box",
  whiteSpace: "nowrap"
}, !t.disableGutters && {
  paddingLeft: 16,
  paddingRight: 16
}, t.divider && {
  borderBottom: `1px solid ${(e.vars || e).palette.divider}`,
  backgroundClip: "padding-box"
}, {
  "&:hover": {
    textDecoration: "none",
    backgroundColor: (e.vars || e).palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  [`&.${wy.selected}`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : Yt(e.palette.primary.main, e.palette.action.selectedOpacity),
    [`&.${wy.focusVisible}`]: {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))` : Yt(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.focusOpacity)
    }
  },
  [`&.${wy.selected}:hover`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : Yt(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : Yt(e.palette.primary.main, e.palette.action.selectedOpacity)
    }
  },
  [`&.${wy.focusVisible}`]: {
    backgroundColor: (e.vars || e).palette.action.focus
  },
  [`&.${wy.disabled}`]: {
    opacity: (e.vars || e).palette.action.disabledOpacity
  },
  [`& + .${T3.root}`]: {
    marginTop: e.spacing(1),
    marginBottom: e.spacing(1)
  },
  [`& + .${T3.inset}`]: {
    marginLeft: 52
  },
  [`& .${KD.root}`]: {
    marginTop: 0,
    marginBottom: 0
  },
  [`& .${KD.inset}`]: {
    paddingLeft: 36
  },
  [`& .${k3.root}`]: {
    minWidth: 36
  }
}, !t.dense && {
  [e.breakpoints.up("sm")]: {
    minHeight: "auto"
  }
}, t.dense && N({
  minHeight: 32,
  // https://m2.material.io/components/menus#specs > Dense
  paddingTop: 4,
  paddingBottom: 4
}, e.typography.body2, {
  [`& .${k3.root} svg`]: {
    fontSize: "1.25rem"
  }
}))), ks = /* @__PURE__ */ V.forwardRef(function(t, n) {
  const r = Ot({
    props: t,
    name: "MuiMenuItem"
  }), {
    autoFocus: i = !1,
    component: o = "li",
    dense: s = !1,
    divider: a = !1,
    disableGutters: u = !1,
    focusVisibleClassName: c,
    role: d = "menuitem",
    tabIndex: f,
    className: h
  } = r, m = _e(r, n4e), v = V.useContext(cu), x = V.useMemo(() => ({
    dense: s || v.dense || !1,
    disableGutters: u
  }), [v.dense, s, u]), C = V.useRef(null);
  gi(() => {
    i && (C.current ? C.current.focus() : process.env.NODE_ENV !== "production" && console.error("MUI: Unable to set focus to a MenuItem whose component has not been rendered."));
  }, [i]);
  const E = N({}, r, {
    dense: x.dense,
    divider: a,
    disableGutters: u
  }), S = i4e(r), w = Hn(C, n);
  let O;
  return r.disabled || (O = f !== void 0 ? f : -1), /* @__PURE__ */ P.jsx(cu.Provider, {
    value: x,
    children: /* @__PURE__ */ P.jsx(o4e, N({
      ref: w,
      role: d,
      tabIndex: O,
      component: o,
      focusVisibleClassName: Be(S.focusVisible, c),
      className: Be(S.root, h)
    }, m, {
      ownerState: E,
      classes: S
    }))
  });
});
process.env.NODE_ENV !== "production" && (ks.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the list item is focused during the first mount.
   * Focus will also be triggered if the value changes from false to true.
   * @default false
   */
  autoFocus: l.bool,
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used.
   * The prop defaults to the value inherited from the parent Menu component.
   * @default false
   */
  dense: l.bool,
  /**
   * @ignore
   */
  disabled: l.bool,
  /**
   * If `true`, the left and right padding is removed.
   * @default false
   */
  disableGutters: l.bool,
  /**
   * If `true`, a 1px light border is added to the bottom of the menu item.
   * @default false
   */
  divider: l.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: l.string,
  /**
   * @ignore
   */
  role: l.string,
  /**
   * If `true`, the component is selected.
   * @default false
   */
  selected: l.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * @default 0
   */
  tabIndex: l.number
});
function s4e(e) {
  return ot("MuiNativeSelect", e);
}
const TF = st("MuiNativeSelect", ["root", "select", "multiple", "filled", "outlined", "standard", "disabled", "icon", "iconOpen", "iconFilled", "iconOutlined", "iconStandard", "nativeInput", "error"]), a4e = ["className", "disabled", "error", "IconComponent", "inputRef", "variant"], l4e = (e) => {
  const {
    classes: t,
    variant: n,
    disabled: r,
    multiple: i,
    open: o,
    error: s
  } = e, a = {
    select: ["select", n, r && "disabled", i && "multiple", s && "error"],
    icon: ["icon", `icon${Ue(n)}`, o && "iconOpen", r && "disabled"]
  };
  return at(a, s4e, t);
}, JU = ({
  ownerState: e,
  theme: t
}) => N({
  MozAppearance: "none",
  // Reset
  WebkitAppearance: "none",
  // Reset
  // When interacting quickly, the text can end up selected.
  // Native select can't be selected either.
  userSelect: "none",
  borderRadius: 0,
  // Reset
  cursor: "pointer",
  "&:focus": N({}, t.vars ? {
    backgroundColor: `rgba(${t.vars.palette.common.onBackgroundChannel} / 0.05)`
  } : {
    backgroundColor: t.palette.mode === "light" ? "rgba(0, 0, 0, 0.05)" : "rgba(255, 255, 255, 0.05)"
  }, {
    borderRadius: 0
    // Reset Chrome style
  }),
  // Remove IE11 arrow
  "&::-ms-expand": {
    display: "none"
  },
  [`&.${TF.disabled}`]: {
    cursor: "default"
  },
  "&[multiple]": {
    height: "auto"
  },
  "&:not([multiple]) option, &:not([multiple]) optgroup": {
    backgroundColor: (t.vars || t).palette.background.paper
  },
  // Bump specificity to allow extending custom inputs
  "&&&": {
    paddingRight: 24,
    minWidth: 16
    // So it doesn't collapse.
  }
}, e.variant === "filled" && {
  "&&&": {
    paddingRight: 32
  }
}, e.variant === "outlined" && {
  borderRadius: (t.vars || t).shape.borderRadius,
  "&:focus": {
    borderRadius: (t.vars || t).shape.borderRadius
    // Reset the reset for Chrome style
  },
  "&&&": {
    paddingRight: 32
  }
}), u4e = De("select", {
  name: "MuiNativeSelect",
  slot: "Select",
  shouldForwardProp: Ao,
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.select, t[n.variant], n.error && t.error, {
      [`&.${TF.multiple}`]: t.multiple
    }];
  }
})(JU), XU = ({
  ownerState: e,
  theme: t
}) => N({
  // We use a position absolute over a flexbox in order to forward the pointer events
  // to the input and to support wrapping tags..
  position: "absolute",
  right: 0,
  top: "calc(50% - .5em)",
  // Center vertically, height is 1em
  pointerEvents: "none",
  // Don't block pointer events on the select under the icon.
  color: (t.vars || t).palette.action.active,
  [`&.${TF.disabled}`]: {
    color: (t.vars || t).palette.action.disabled
  }
}, e.open && {
  transform: "rotate(180deg)"
}, e.variant === "filled" && {
  right: 7
}, e.variant === "outlined" && {
  right: 7
}), c4e = De("svg", {
  name: "MuiNativeSelect",
  slot: "Icon",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.icon, n.variant && t[`icon${Ue(n.variant)}`], n.open && t.iconOpen];
  }
})(XU), QU = /* @__PURE__ */ V.forwardRef(function(t, n) {
  const {
    className: r,
    disabled: i,
    error: o,
    IconComponent: s,
    inputRef: a,
    variant: u = "standard"
  } = t, c = _e(t, a4e), d = N({}, t, {
    disabled: i,
    variant: u,
    error: o
  }), f = l4e(d);
  return /* @__PURE__ */ P.jsxs(V.Fragment, {
    children: [/* @__PURE__ */ P.jsx(u4e, N({
      ownerState: d,
      className: Be(f.select, r),
      disabled: i,
      ref: a || n
    }, c)), t.multiple ? null : /* @__PURE__ */ P.jsx(c4e, {
      as: s,
      ownerState: d,
      className: f.icon
    })]
  });
});
process.env.NODE_ENV !== "production" && (QU.propTypes = {
  /**
   * The option elements to populate the select with.
   * Can be some `<option>` elements.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * The CSS class name of the select element.
   */
  className: l.string,
  /**
   * If `true`, the select is disabled.
   */
  disabled: l.bool,
  /**
   * If `true`, the `select input` will indicate an error.
   */
  error: l.bool,
  /**
   * The icon that displays the arrow.
   */
  IconComponent: l.elementType.isRequired,
  /**
   * Use that prop to pass a ref to the native select element.
   * @deprecated
   */
  inputRef: wr,
  /**
   * @ignore
   */
  multiple: l.bool,
  /**
   * Name attribute of the `select` or hidden `input` element.
   */
  name: l.string,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: l.func,
  /**
   * The input value.
   */
  value: l.any,
  /**
   * The variant to use.
   */
  variant: l.oneOf(["standard", "outlined", "filled"])
});
var N3;
const d4e = ["children", "classes", "className", "label", "notched"], p4e = De("fieldset", {
  shouldForwardProp: Ao
})({
  textAlign: "left",
  position: "absolute",
  bottom: 0,
  right: 0,
  top: -5,
  left: 0,
  margin: 0,
  padding: "0 8px",
  pointerEvents: "none",
  borderRadius: "inherit",
  borderStyle: "solid",
  borderWidth: 1,
  overflow: "hidden",
  minWidth: "0%"
}), f4e = De("legend", {
  shouldForwardProp: Ao
})(({
  ownerState: e,
  theme: t
}) => N({
  float: "unset",
  // Fix conflict with bootstrap
  width: "auto",
  // Fix conflict with bootstrap
  overflow: "hidden"
}, !e.withLabel && {
  padding: 0,
  lineHeight: "11px",
  // sync with `height` in `legend` styles
  transition: t.transitions.create("width", {
    duration: 150,
    easing: t.transitions.easing.easeOut
  })
}, e.withLabel && N({
  display: "block",
  // Fix conflict with normalize.css and sanitize.css
  padding: 0,
  height: 11,
  // sync with `lineHeight` in `legend` styles
  fontSize: "0.75em",
  visibility: "hidden",
  maxWidth: 0.01,
  transition: t.transitions.create("max-width", {
    duration: 50,
    easing: t.transitions.easing.easeOut
  }),
  whiteSpace: "nowrap",
  "& > span": {
    paddingLeft: 5,
    paddingRight: 5,
    display: "inline-block",
    opacity: 0,
    visibility: "visible"
  }
}, e.notched && {
  maxWidth: "100%",
  transition: t.transitions.create("max-width", {
    duration: 100,
    easing: t.transitions.easing.easeOut,
    delay: 50
  })
})));
function ZU(e) {
  const {
    className: t,
    label: n,
    notched: r
  } = e, i = _e(e, d4e), o = n != null && n !== "", s = N({}, e, {
    notched: r,
    withLabel: o
  });
  return /* @__PURE__ */ P.jsx(p4e, N({
    "aria-hidden": !0,
    className: t,
    ownerState: s
  }, i, {
    children: /* @__PURE__ */ P.jsx(f4e, {
      ownerState: s,
      children: o ? /* @__PURE__ */ P.jsx("span", {
        children: n
      }) : (
        // notranslate needed while Google Translate will not fix zero-width space issue
        N3 || (N3 = /* @__PURE__ */ P.jsx("span", {
          className: "notranslate",
          children: "​"
        }))
      )
    })
  }));
}
process.env.NODE_ENV !== "production" && (ZU.propTypes = {
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The label.
   */
  label: l.node,
  /**
   * If `true`, the outline is notched to accommodate the label.
   */
  notched: l.bool.isRequired,
  /**
   * @ignore
   */
  style: l.object
});
const h4e = ["components", "fullWidth", "inputComponent", "label", "multiline", "notched", "slots", "type"], m4e = (e) => {
  const {
    classes: t
  } = e, r = at({
    root: ["root"],
    notchedOutline: ["notchedOutline"],
    input: ["input"]
  }, YBe, t);
  return N({}, t, r);
}, g4e = De(LE, {
  shouldForwardProp: (e) => Ao(e) || e === "classes",
  name: "MuiOutlinedInput",
  slot: "Root",
  overridesResolver: RE
})(({
  theme: e,
  ownerState: t
}) => {
  const n = e.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
  return N({
    position: "relative",
    borderRadius: (e.vars || e).shape.borderRadius,
    [`&:hover .${Vi.notchedOutline}`]: {
      borderColor: (e.vars || e).palette.text.primary
    },
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      [`&:hover .${Vi.notchedOutline}`]: {
        borderColor: e.vars ? `rgba(${e.vars.palette.common.onBackgroundChannel} / 0.23)` : n
      }
    },
    [`&.${Vi.focused} .${Vi.notchedOutline}`]: {
      borderColor: (e.vars || e).palette[t.color].main,
      borderWidth: 2
    },
    [`&.${Vi.error} .${Vi.notchedOutline}`]: {
      borderColor: (e.vars || e).palette.error.main
    },
    [`&.${Vi.disabled} .${Vi.notchedOutline}`]: {
      borderColor: (e.vars || e).palette.action.disabled
    }
  }, t.startAdornment && {
    paddingLeft: 14
  }, t.endAdornment && {
    paddingRight: 14
  }, t.multiline && N({
    padding: "16.5px 14px"
  }, t.size === "small" && {
    padding: "8.5px 14px"
  }));
}), y4e = De(ZU, {
  name: "MuiOutlinedInput",
  slot: "NotchedOutline",
  overridesResolver: (e, t) => t.notchedOutline
})(({
  theme: e
}) => {
  const t = e.palette.mode === "light" ? "rgba(0, 0, 0, 0.23)" : "rgba(255, 255, 255, 0.23)";
  return {
    borderColor: e.vars ? `rgba(${e.vars.palette.common.onBackgroundChannel} / 0.23)` : t
  };
}), b4e = De(BE, {
  name: "MuiOutlinedInput",
  slot: "Input",
  overridesResolver: _E
})(({
  theme: e,
  ownerState: t
}) => N({
  padding: "16.5px 14px"
}, !e.vars && {
  "&:-webkit-autofill": {
    WebkitBoxShadow: e.palette.mode === "light" ? null : "0 0 0 100px #266798 inset",
    WebkitTextFillColor: e.palette.mode === "light" ? null : "#fff",
    caretColor: e.palette.mode === "light" ? null : "#fff",
    borderRadius: "inherit"
  }
}, e.vars && {
  "&:-webkit-autofill": {
    borderRadius: "inherit"
  },
  [e.getColorSchemeSelector("dark")]: {
    "&:-webkit-autofill": {
      WebkitBoxShadow: "0 0 0 100px #266798 inset",
      WebkitTextFillColor: "#fff",
      caretColor: "#fff"
    }
  }
}, t.size === "small" && {
  padding: "8.5px 14px"
}, t.multiline && {
  padding: 0
}, t.startAdornment && {
  paddingLeft: 0
}, t.endAdornment && {
  paddingRight: 0
})), Zo = /* @__PURE__ */ V.forwardRef(function(t, n) {
  var r, i, o, s, a;
  const u = Ot({
    props: t,
    name: "MuiOutlinedInput"
  }), {
    components: c = {},
    fullWidth: d = !1,
    inputComponent: f = "input",
    label: h,
    multiline: m = !1,
    notched: v,
    slots: x = {},
    type: C = "text"
  } = u, E = _e(u, h4e), S = m4e(u), w = Tu(), O = wd({
    props: u,
    muiFormControl: w,
    states: ["color", "disabled", "error", "focused", "hiddenLabel", "size", "required"]
  }), A = N({}, u, {
    color: O.color || "primary",
    disabled: O.disabled,
    error: O.error,
    focused: O.focused,
    formControl: w,
    fullWidth: d,
    hiddenLabel: O.hiddenLabel,
    multiline: m,
    size: O.size,
    type: C
  }), I = (r = (i = x.root) != null ? i : c.Root) != null ? r : g4e, $ = (o = (s = x.input) != null ? s : c.Input) != null ? o : b4e;
  return /* @__PURE__ */ P.jsx(fF, N({
    slots: {
      root: I,
      input: $
    },
    renderSuffix: (L) => /* @__PURE__ */ P.jsx(y4e, {
      ownerState: A,
      className: S.notchedOutline,
      label: h != null && h !== "" && O.required ? a || (a = /* @__PURE__ */ P.jsxs(V.Fragment, {
        children: [h, " ", "*"]
      })) : h,
      notched: typeof v < "u" ? v : !!(L.startAdornment || L.filled || L.focused)
    }),
    fullWidth: d,
    inputComponent: f,
    multiline: m,
    ref: n,
    type: C
  }, E, {
    classes: N({}, S, {
      notchedOutline: null
    })
  }));
});
process.env.NODE_ENV !== "production" && (Zo.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: l.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   */
  autoFocus: l.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * The prop defaults to the value (`'primary'`) inherited from the parent FormControl component.
   */
  color: l.oneOfType([l.oneOf(["primary", "secondary"]), l.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: l.shape({
    Input: l.elementType,
    Root: l.elementType
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: l.any,
  /**
   * If `true`, the component is disabled.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  disabled: l.bool,
  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: l.node,
  /**
   * If `true`, the `input` will indicate an error.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  error: l.bool,
  /**
   * If `true`, the `input` will take up the full width of its container.
   * @default false
   */
  fullWidth: l.bool,
  /**
   * The id of the `input` element.
   */
  id: l.string,
  /**
   * The component used for the `input` element.
   * Either a string to use a HTML element or a component.
   * @default 'input'
   */
  inputComponent: l.elementType,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @default {}
   */
  inputProps: l.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: wr,
  /**
   * The label of the `input`. It is only used for layout. The actual labelling
   * is handled by `InputLabel`.
   */
  label: l.node,
  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   * The prop defaults to the value (`'none'`) inherited from the parent FormControl component.
   */
  margin: l.oneOf(["dense", "none"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: l.oneOfType([l.number, l.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: l.oneOfType([l.number, l.string]),
  /**
   * If `true`, a [TextareaAutosize](/material-ui/react-textarea-autosize/) element is rendered.
   * @default false
   */
  multiline: l.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: l.string,
  /**
   * If `true`, the outline is notched to accommodate the label.
   */
  notched: l.bool,
  /**
   * Callback fired when the value is changed.
   *
   * @param {React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: l.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: l.string,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: l.bool,
  /**
   * If `true`, the `input` element is required.
   * The prop defaults to the value (`false`) inherited from the parent FormControl component.
   */
  required: l.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: l.oneOfType([l.number, l.string]),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: l.shape({
    input: l.elementType,
    root: l.elementType
  }),
  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: l.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   * @default 'text'
   */
  type: l.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: l.any
});
Zo.muiName = "Input";
const v4e = Rr(/* @__PURE__ */ P.jsx("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), "RadioButtonUnchecked"), x4e = Rr(/* @__PURE__ */ P.jsx("path", {
  d: "M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
}), "RadioButtonChecked"), D4e = De("span", {
  shouldForwardProp: Ao
})({
  position: "relative",
  display: "flex"
}), C4e = De(v4e)({
  // Scale applied to prevent dot misalignment in Safari
  transform: "scale(1)"
}), E4e = De(x4e)(({
  theme: e,
  ownerState: t
}) => N({
  left: 0,
  position: "absolute",
  transform: "scale(0)",
  transition: e.transitions.create("transform", {
    easing: e.transitions.easing.easeIn,
    duration: e.transitions.duration.shortest
  })
}, t.checked && {
  transform: "scale(1)",
  transition: e.transitions.create("transform", {
    easing: e.transitions.easing.easeOut,
    duration: e.transitions.duration.shortest
  })
}));
function SF(e) {
  const {
    checked: t = !1,
    classes: n = {},
    fontSize: r
  } = e, i = N({}, e, {
    checked: t
  });
  return /* @__PURE__ */ P.jsxs(D4e, {
    className: n.root,
    ownerState: i,
    children: [/* @__PURE__ */ P.jsx(C4e, {
      fontSize: r,
      className: n.background,
      ownerState: i
    }), /* @__PURE__ */ P.jsx(E4e, {
      fontSize: r,
      className: n.dot,
      ownerState: i
    })]
  });
}
process.env.NODE_ENV !== "production" && (SF.propTypes = {
  /**
   * If `true`, the component is checked.
   */
  checked: l.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * The size of the component.
   * `small` is equivalent to the dense radio styling.
   */
  fontSize: l.oneOf(["small", "medium"])
});
const AF = /* @__PURE__ */ V.createContext(void 0);
process.env.NODE_ENV !== "production" && (AF.displayName = "RadioGroupContext");
function T4e() {
  return V.useContext(AF);
}
function S4e(e) {
  return ot("MuiRadio", e);
}
const M3 = st("MuiRadio", ["root", "checked", "disabled", "colorPrimary", "colorSecondary", "sizeSmall"]), A4e = ["checked", "checkedIcon", "color", "icon", "name", "onChange", "size", "className"], w4e = (e) => {
  const {
    classes: t,
    color: n,
    size: r
  } = e, i = {
    root: ["root", `color${Ue(n)}`, r !== "medium" && `size${Ue(r)}`]
  };
  return N({}, t, at(i, S4e, t));
}, P4e = De(VE, {
  shouldForwardProp: (e) => Ao(e) || e === "classes",
  name: "MuiRadio",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.size !== "medium" && t[`size${Ue(n.size)}`], t[`color${Ue(n.color)}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => N({
  color: (e.vars || e).palette.text.secondary
}, !t.disableRipple && {
  "&:hover": {
    backgroundColor: e.vars ? `rgba(${t.color === "default" ? e.vars.palette.action.activeChannel : e.vars.palette[t.color].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : Yt(t.color === "default" ? e.palette.action.active : e.palette[t.color].main, e.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  }
}, t.color !== "default" && {
  [`&.${M3.checked}`]: {
    color: (e.vars || e).palette[t.color].main
  }
}, {
  [`&.${M3.disabled}`]: {
    color: (e.vars || e).palette.action.disabled
  }
}));
function k4e(e, t) {
  return typeof t == "object" && t !== null ? e === t : String(e) === String(t);
}
const R3 = /* @__PURE__ */ P.jsx(SF, {
  checked: !0
}), _3 = /* @__PURE__ */ P.jsx(SF, {}), wF = /* @__PURE__ */ V.forwardRef(function(t, n) {
  var r, i;
  const o = Ot({
    props: t,
    name: "MuiRadio"
  }), {
    checked: s,
    checkedIcon: a = R3,
    color: u = "primary",
    icon: c = _3,
    name: d,
    onChange: f,
    size: h = "medium",
    className: m
  } = o, v = _e(o, A4e), x = N({}, o, {
    color: u,
    size: h
  }), C = w4e(x), E = T4e();
  let S = s;
  const w = zD(f, E && E.onChange);
  let O = d;
  return E && (typeof S > "u" && (S = k4e(E.value, o.value)), typeof O > "u" && (O = E.name)), /* @__PURE__ */ P.jsx(P4e, N({
    type: "radio",
    icon: /* @__PURE__ */ V.cloneElement(c, {
      fontSize: (r = _3.props.fontSize) != null ? r : h
    }),
    checkedIcon: /* @__PURE__ */ V.cloneElement(a, {
      fontSize: (i = R3.props.fontSize) != null ? i : h
    }),
    ownerState: x,
    classes: C,
    name: O,
    checked: S,
    onChange: w,
    ref: n,
    className: Be(C.root, m)
  }, v));
});
process.env.NODE_ENV !== "production" && (wF.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the component is checked.
   */
  checked: l.bool,
  /**
   * The icon to display when the component is checked.
   * @default <RadioButtonIcon checked />
   */
  checkedIcon: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: l.oneOfType([l.oneOf(["default", "primary", "secondary", "error", "info", "success", "warning"]), l.string]),
  /**
   * If `true`, the component is disabled.
   */
  disabled: l.bool,
  /**
   * If `true`, the ripple effect is disabled.
   * @default false
   */
  disableRipple: l.bool,
  /**
   * The icon to display when the component is unchecked.
   * @default <RadioButtonIcon />
   */
  icon: l.node,
  /**
   * The id of the `input` element.
   */
  id: l.string,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: l.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: wr,
  /**
   * Name attribute of the `input` element.
   */
  name: l.string,
  /**
   * Callback fired when the state is changed.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: l.func,
  /**
   * If `true`, the `input` element is required.
   * @default false
   */
  required: l.bool,
  /**
   * The size of the component.
   * `small` is equivalent to the dense radio styling.
   * @default 'medium'
   */
  size: l.oneOfType([l.oneOf(["medium", "small"]), l.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * The value of the component. The DOM API casts this to a string.
   */
  value: l.any
});
function O4e(e) {
  return ot("MuiRadioGroup", e);
}
st("MuiRadioGroup", ["root", "row", "error"]);
const I4e = ["actions", "children", "className", "defaultValue", "name", "onChange", "value"], F4e = (e) => {
  const {
    classes: t,
    row: n,
    error: r
  } = e;
  return at({
    root: ["root", n && "row", r && "error"]
  }, O4e, t);
}, PF = /* @__PURE__ */ V.forwardRef(function(t, n) {
  const {
    // private
    // eslint-disable-next-line react/prop-types
    actions: r,
    children: i,
    className: o,
    defaultValue: s,
    name: a,
    onChange: u,
    value: c
  } = t, d = _e(t, I4e), f = V.useRef(null), h = F4e(t), [m, v] = Hi({
    controlled: c,
    default: s,
    name: "RadioGroup"
  });
  V.useImperativeHandle(r, () => ({
    focus: () => {
      let S = f.current.querySelector("input:not(:disabled):checked");
      S || (S = f.current.querySelector("input:not(:disabled)")), S && S.focus();
    }
  }), []);
  const x = Hn(n, f), C = Pl(a), E = V.useMemo(() => ({
    name: C,
    onChange(S) {
      v(S.target.value), u && u(S, S.target.value);
    },
    value: m
  }), [C, u, v, m]);
  return /* @__PURE__ */ P.jsx(AF.Provider, {
    value: E,
    children: /* @__PURE__ */ P.jsx(rv, N({
      role: "radiogroup",
      ref: x,
      className: Be(h.root, o)
    }, d, {
      children: i
    }))
  });
});
process.env.NODE_ENV !== "production" && (PF.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: l.any,
  /**
   * The name used to reference the value of the control.
   * If you don't provide this prop, it falls back to a randomly generated name.
   */
  name: l.string,
  /**
   * Callback fired when a radio button is selected.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * @param {string} value The value of the selected radio button.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: l.func,
  /**
   * Value of the selected radio button. The DOM API casts this to a string.
   */
  value: l.any
});
function $4e(e) {
  return ot("MuiSelect", e);
}
const Py = st("MuiSelect", ["root", "select", "multiple", "filled", "outlined", "standard", "disabled", "focused", "icon", "iconOpen", "iconFilled", "iconOutlined", "iconStandard", "nativeInput", "error"]);
var L3;
const N4e = ["aria-describedby", "aria-label", "autoFocus", "autoWidth", "children", "className", "defaultOpen", "defaultValue", "disabled", "displayEmpty", "error", "IconComponent", "inputRef", "labelId", "MenuProps", "multiple", "name", "onBlur", "onChange", "onClose", "onFocus", "onOpen", "open", "readOnly", "renderValue", "SelectDisplayProps", "tabIndex", "type", "value", "variant"], M4e = De("div", {
  name: "MuiSelect",
  slot: "Select",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [
      // Win specificity over the input base
      {
        [`&.${Py.select}`]: t.select
      },
      {
        [`&.${Py.select}`]: t[n.variant]
      },
      {
        [`&.${Py.error}`]: t.error
      },
      {
        [`&.${Py.multiple}`]: t.multiple
      }
    ];
  }
})(JU, {
  // Win specificity over the input base
  [`&.${Py.select}`]: {
    height: "auto",
    // Resets for multiple select with chips
    minHeight: "1.4375em",
    // Required for select\text-field height consistency
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden"
  }
}), R4e = De("svg", {
  name: "MuiSelect",
  slot: "Icon",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.icon, n.variant && t[`icon${Ue(n.variant)}`], n.open && t.iconOpen];
  }
})(XU), _4e = De("input", {
  shouldForwardProp: (e) => FE(e) && e !== "classes",
  name: "MuiSelect",
  slot: "NativeInput",
  overridesResolver: (e, t) => t.nativeInput
})({
  bottom: 0,
  left: 0,
  position: "absolute",
  opacity: 0,
  pointerEvents: "none",
  width: "100%",
  boxSizing: "border-box"
});
function B3(e, t) {
  return typeof t == "object" && t !== null ? e === t : String(e) === String(t);
}
function L4e(e) {
  return e == null || typeof e == "string" && !e.trim();
}
const B4e = (e) => {
  const {
    classes: t,
    variant: n,
    disabled: r,
    multiple: i,
    open: o,
    error: s
  } = e, a = {
    select: ["select", n, r && "disabled", i && "multiple", s && "error"],
    icon: ["icon", `icon${Ue(n)}`, o && "iconOpen", r && "disabled"],
    nativeInput: ["nativeInput"]
  };
  return at(a, $4e, t);
}, eW = /* @__PURE__ */ V.forwardRef(function(t, n) {
  var r;
  const {
    "aria-describedby": i,
    "aria-label": o,
    autoFocus: s,
    autoWidth: a,
    children: u,
    className: c,
    defaultOpen: d,
    defaultValue: f,
    disabled: h,
    displayEmpty: m,
    error: v = !1,
    IconComponent: x,
    inputRef: C,
    labelId: E,
    MenuProps: S = {},
    multiple: w,
    name: O,
    onBlur: A,
    onChange: I,
    onClose: $,
    onFocus: L,
    onOpen: B,
    open: H,
    readOnly: q,
    renderValue: J,
    SelectDisplayProps: X = {},
    tabIndex: j,
    value: U,
    variant: G = "standard"
  } = t, K = _e(t, N4e), [ee, te] = Hi({
    controlled: U,
    default: f,
    name: "Select"
  }), [M, Z] = Hi({
    controlled: H,
    default: d,
    name: "Select"
  }), ne = V.useRef(null), R = V.useRef(null), [_, W] = V.useState(null), {
    current: Q
  } = V.useRef(H != null), [oe, ae] = V.useState(), pe = Hn(n, C), me = V.useCallback((ht) => {
    R.current = ht, ht && W(ht);
  }, []), xe = _ == null ? void 0 : _.parentNode;
  V.useImperativeHandle(pe, () => ({
    focus: () => {
      R.current.focus();
    },
    node: ne.current,
    value: ee
  }), [ee]), V.useEffect(() => {
    d && M && _ && !Q && (ae(a ? null : xe.clientWidth), R.current.focus());
  }, [_, a]), V.useEffect(() => {
    s && R.current.focus();
  }, [s]), V.useEffect(() => {
    if (!E)
      return;
    const ht = ei(R.current).getElementById(E);
    if (ht) {
      const He = () => {
        getSelection().isCollapsed && R.current.focus();
      };
      return ht.addEventListener("click", He), () => {
        ht.removeEventListener("click", He);
      };
    }
  }, [E]);
  const le = (ht, He) => {
    ht ? B && B(He) : $ && $(He), Q || (ae(a ? null : xe.clientWidth), Z(ht));
  }, ye = (ht) => {
    ht.button === 0 && (ht.preventDefault(), R.current.focus(), le(!0, ht));
  }, be = (ht) => {
    le(!1, ht);
  }, Re = V.Children.toArray(u), Te = (ht) => {
    const He = Re.find((qe) => qe.props.value === ht.target.value);
    He !== void 0 && (te(He.props.value), I && I(ht, He));
  }, Xe = (ht) => (He) => {
    let qe;
    if (He.currentTarget.hasAttribute("tabindex")) {
      if (w) {
        qe = Array.isArray(ee) ? ee.slice() : [];
        const wt = ee.indexOf(ht.props.value);
        wt === -1 ? qe.push(ht.props.value) : qe.splice(wt, 1);
      } else
        qe = ht.props.value;
      if (ht.props.onClick && ht.props.onClick(He), ee !== qe && (te(qe), I)) {
        const wt = He.nativeEvent || He, Ut = new wt.constructor(wt.type, wt);
        Object.defineProperty(Ut, "target", {
          writable: !0,
          value: {
            value: qe,
            name: O
          }
        }), I(Ut, ht);
      }
      w || le(!1, He);
    }
  }, Ne = (ht) => {
    q || [
      " ",
      "ArrowUp",
      "ArrowDown",
      // The native select doesn't respond to enter on macOS, but it's recommended by
      // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
      "Enter"
    ].indexOf(ht.key) !== -1 && (ht.preventDefault(), le(!0, ht));
  }, Qe = _ !== null && M, Ee = (ht) => {
    !Qe && A && (Object.defineProperty(ht, "target", {
      writable: !0,
      value: {
        value: ee,
        name: O
      }
    }), A(ht));
  };
  delete K["aria-invalid"];
  let Ie, Je;
  const vt = [];
  let St = !1, Lt = !1;
  (YD({
    value: ee
  }) || m) && (J ? Ie = J(ee) : St = !0);
  const ke = Re.map((ht) => {
    if (!/* @__PURE__ */ V.isValidElement(ht))
      return null;
    process.env.NODE_ENV !== "production" && Gp.isFragment(ht) && console.error(["MUI: The Select component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`));
    let He;
    if (w) {
      if (!Array.isArray(ee))
        throw new Error(process.env.NODE_ENV !== "production" ? "MUI: The `value` prop must be an array when using the `Select` component with `multiple`." : gu(2));
      He = ee.some((qe) => B3(qe, ht.props.value)), He && St && vt.push(ht.props.children);
    } else
      He = B3(ee, ht.props.value), He && St && (Je = ht.props.children);
    return He && (Lt = !0), /* @__PURE__ */ V.cloneElement(ht, {
      "aria-selected": He ? "true" : "false",
      onClick: Xe(ht),
      onKeyUp: (qe) => {
        qe.key === " " && qe.preventDefault(), ht.props.onKeyUp && ht.props.onKeyUp(qe);
      },
      role: "option",
      selected: He,
      value: void 0,
      // The value is most likely not a valid HTML attribute.
      "data-value": ht.props.value
      // Instead, we provide it as a data attribute.
    });
  });
  process.env.NODE_ENV !== "production" && V.useEffect(() => {
    if (!Lt && !w && ee !== "") {
      const ht = Re.map((He) => He.props.value);
      console.warn([`MUI: You have provided an out-of-range value \`${ee}\` for the select ${O ? `(name="${O}") ` : ""}component.`, "Consider providing a value that matches one of the available options or ''.", `The available values are ${ht.filter((He) => He != null).map((He) => `\`${He}\``).join(", ") || '""'}.`].join(`
`));
    }
  }, [Lt, Re, w, O, ee]), St && (w ? vt.length === 0 ? Ie = null : Ie = vt.reduce((ht, He, qe) => (ht.push(He), qe < vt.length - 1 && ht.push(", "), ht), []) : Ie = Je);
  let Le = oe;
  !a && Q && _ && (Le = xe.clientWidth);
  let Pe;
  typeof j < "u" ? Pe = j : Pe = h ? null : 0;
  const Ae = X.id || (O ? `mui-component-select-${O}` : void 0), We = N({}, t, {
    variant: G,
    value: ee,
    open: Qe,
    error: v
  }), At = B4e(We), Ft = N({}, S.PaperProps, (r = S.slotProps) == null ? void 0 : r.paper), Ct = Pl();
  return /* @__PURE__ */ P.jsxs(V.Fragment, {
    children: [/* @__PURE__ */ P.jsx(M4e, N({
      ref: me,
      tabIndex: Pe,
      role: "combobox",
      "aria-controls": Ct,
      "aria-disabled": h ? "true" : void 0,
      "aria-expanded": Qe ? "true" : "false",
      "aria-haspopup": "listbox",
      "aria-label": o,
      "aria-labelledby": [E, Ae].filter(Boolean).join(" ") || void 0,
      "aria-describedby": i,
      onKeyDown: Ne,
      onMouseDown: h || q ? null : ye,
      onBlur: Ee,
      onFocus: L
    }, X, {
      ownerState: We,
      className: Be(X.className, At.select, c),
      id: Ae,
      children: L4e(Ie) ? (
        // notranslate needed while Google Translate will not fix zero-width space issue
        L3 || (L3 = /* @__PURE__ */ P.jsx("span", {
          className: "notranslate",
          children: "​"
        }))
      ) : Ie
    })), /* @__PURE__ */ P.jsx(_4e, N({
      "aria-invalid": v,
      value: Array.isArray(ee) ? ee.join(",") : ee,
      name: O,
      ref: ne,
      "aria-hidden": !0,
      onChange: Te,
      tabIndex: -1,
      disabled: h,
      className: At.nativeInput,
      autoFocus: s,
      ownerState: We
    }, K)), /* @__PURE__ */ P.jsx(R4e, {
      as: x,
      className: At.icon,
      ownerState: We
    }), /* @__PURE__ */ P.jsx(KU, N({
      id: `menu-${O || ""}`,
      anchorEl: xe,
      open: Qe,
      onClose: be,
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "center"
      },
      transformOrigin: {
        vertical: "top",
        horizontal: "center"
      }
    }, S, {
      MenuListProps: N({
        "aria-labelledby": E,
        role: "listbox",
        "aria-multiselectable": w ? "true" : void 0,
        disableListWrap: !0,
        id: Ct
      }, S.MenuListProps),
      slotProps: N({}, S.slotProps, {
        paper: N({}, Ft, {
          style: N({
            minWidth: Le
          }, Ft != null ? Ft.style : null)
        })
      }),
      children: ke
    }))]
  });
});
process.env.NODE_ENV !== "production" && (eW.propTypes = {
  /**
   * @ignore
   */
  "aria-describedby": l.string,
  /**
   * @ignore
   */
  "aria-label": l.string,
  /**
   * @ignore
   */
  autoFocus: l.bool,
  /**
   * If `true`, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   */
  autoWidth: l.bool,
  /**
   * The option elements to populate the select with.
   * Can be some `<MenuItem>` elements.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * The CSS class name of the select element.
   */
  className: l.string,
  /**
   * If `true`, the component is toggled on mount. Use when the component open state is not controlled.
   * You can only use it when the `native` prop is `false` (default).
   */
  defaultOpen: l.bool,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: l.any,
  /**
   * If `true`, the select is disabled.
   */
  disabled: l.bool,
  /**
   * If `true`, the selected item is displayed even if its value is empty.
   */
  displayEmpty: l.bool,
  /**
   * If `true`, the `select input` will indicate an error.
   */
  error: l.bool,
  /**
   * The icon that displays the arrow.
   */
  IconComponent: l.elementType.isRequired,
  /**
   * Imperative handle implementing `{ value: T, node: HTMLElement, focus(): void }`
   * Equivalent to `ref`
   */
  inputRef: wr,
  /**
   * The ID of an element that acts as an additional label. The Select will
   * be labelled by the additional label and the selected value.
   */
  labelId: l.string,
  /**
   * Props applied to the [`Menu`](/material-ui/api/menu/) element.
   */
  MenuProps: l.object,
  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   */
  multiple: l.bool,
  /**
   * Name attribute of the `select` or hidden `input` element.
   */
  name: l.string,
  /**
   * @ignore
   */
  onBlur: l.func,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * @param {object} [child] The react element that was selected.
   */
  onChange: l.func,
  /**
   * Callback fired when the component requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onClose: l.func,
  /**
   * @ignore
   */
  onFocus: l.func,
  /**
   * Callback fired when the component requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: l.func,
  /**
   * If `true`, the component is shown.
   */
  open: l.bool,
  /**
   * @ignore
   */
  readOnly: l.bool,
  /**
   * Render the selected value.
   *
   * @param {any} value The `value` provided to the component.
   * @returns {ReactNode}
   */
  renderValue: l.func,
  /**
   * Props applied to the clickable div element.
   */
  SelectDisplayProps: l.object,
  /**
   * @ignore
   */
  tabIndex: l.oneOfType([l.number, l.string]),
  /**
   * @ignore
   */
  type: l.any,
  /**
   * The input value.
   */
  value: l.any,
  /**
   * The variant to use.
   */
  variant: l.oneOf(["standard", "outlined", "filled"])
});
const j4e = ["autoWidth", "children", "classes", "className", "defaultOpen", "displayEmpty", "IconComponent", "id", "input", "inputProps", "label", "labelId", "MenuProps", "multiple", "native", "onClose", "onOpen", "open", "renderValue", "SelectDisplayProps", "variant"], V4e = ["root"], z4e = (e) => {
  const {
    classes: t
  } = e;
  return t;
}, kF = {
  name: "MuiSelect",
  overridesResolver: (e, t) => t.root,
  shouldForwardProp: (e) => Ao(e) && e !== "variant",
  slot: "Root"
}, U4e = De(iv, kF)(""), W4e = De(Zo, kF)(""), H4e = De(Su, kF)(""), mf = /* @__PURE__ */ V.forwardRef(function(t, n) {
  const r = Ot({
    name: "MuiSelect",
    props: t
  }), {
    autoWidth: i = !1,
    children: o,
    classes: s = {},
    className: a,
    defaultOpen: u = !1,
    displayEmpty: c = !1,
    IconComponent: d = LU,
    id: f,
    input: h,
    inputProps: m,
    label: v,
    labelId: x,
    MenuProps: C,
    multiple: E = !1,
    native: S = !1,
    onClose: w,
    onOpen: O,
    open: A,
    renderValue: I,
    SelectDisplayProps: $,
    variant: L = "outlined"
  } = r, B = _e(r, j4e), H = S ? QU : eW, q = Tu(), J = wd({
    props: r,
    muiFormControl: q,
    states: ["variant", "error"]
  }), X = J.variant || L, j = N({}, r, {
    variant: X,
    classes: s
  }), U = z4e(j), G = _e(U, V4e), K = h || {
    standard: /* @__PURE__ */ P.jsx(U4e, {
      ownerState: j
    }),
    outlined: /* @__PURE__ */ P.jsx(W4e, {
      label: v,
      ownerState: j
    }),
    filled: /* @__PURE__ */ P.jsx(H4e, {
      ownerState: j
    })
  }[X], ee = Hn(n, K.ref);
  return /* @__PURE__ */ P.jsx(V.Fragment, {
    children: /* @__PURE__ */ V.cloneElement(K, N({
      // Most of the logic is implemented in `SelectInput`.
      // The `Select` component is a simple API wrapper to expose something better to play with.
      inputComponent: H,
      inputProps: N({
        children: o,
        error: J.error,
        IconComponent: d,
        variant: X,
        type: void 0,
        // We render a select. We can ignore the type provided by the `Input`.
        multiple: E
      }, S ? {
        id: f
      } : {
        autoWidth: i,
        defaultOpen: u,
        displayEmpty: c,
        labelId: x,
        MenuProps: C,
        onClose: w,
        onOpen: O,
        open: A,
        renderValue: I,
        SelectDisplayProps: N({
          id: f
        }, $)
      }, m, {
        classes: m ? is(G, m.classes) : G
      }, h ? h.props.inputProps : {})
    }, (E && S || c) && X === "outlined" ? {
      notched: !0
    } : {}, {
      ref: ee,
      className: Be(K.props.className, a, U.root)
    }, !h && {
      variant: X
    }, B))
  });
});
process.env.NODE_ENV !== "production" && (mf.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   * @default false
   */
  autoWidth: l.bool,
  /**
   * The option elements to populate the select with.
   * Can be some `MenuItem` when `native` is false and `option` when `native` is true.
   *
   * ⚠️The `MenuItem` elements **must** be direct descendants when `native` is false.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   * @default {}
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * If `true`, the component is initially open. Use when the component open state is not controlled (i.e. the `open` prop is not defined).
   * You can only use it when the `native` prop is `false` (default).
   * @default false
   */
  defaultOpen: l.bool,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: l.any,
  /**
   * If `true`, a value is displayed even if no items are selected.
   *
   * In order to display a meaningful value, a function can be passed to the `renderValue` prop which
   * returns the value to be displayed when no items are selected.
   *
   * ⚠️ When using this prop, make sure the label doesn't overlap with the empty displayed value.
   * The label should either be hidden or forced to a shrunk state.
   * @default false
   */
  displayEmpty: l.bool,
  /**
   * The icon that displays the arrow.
   * @default ArrowDropDownIcon
   */
  IconComponent: l.elementType,
  /**
   * The `id` of the wrapper element or the `select` element when `native`.
   */
  id: l.string,
  /**
   * An `Input` element; does not have to be a material-ui specific `Input`.
   */
  input: l.element,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * When `native` is `true`, the attributes are applied on the `select` element.
   */
  inputProps: l.object,
  /**
   * See [OutlinedInput#label](/material-ui/api/outlined-input/#props)
   */
  label: l.node,
  /**
   * The ID of an element that acts as an additional label. The Select will
   * be labelled by the additional label and the selected value.
   */
  labelId: l.string,
  /**
   * Props applied to the [`Menu`](/material-ui/api/menu/) element.
   */
  MenuProps: l.object,
  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   * @default false
   */
  multiple: l.bool,
  /**
   * If `true`, the component uses a native `select` element.
   * @default false
   */
  native: l.bool,
  /**
   * Callback fired when a menu item is selected.
   *
   * @param {SelectChangeEvent<Value>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * **Warning**: This is a generic event, not a change event, unless the change event is caused by browser autofill.
   * @param {object} [child] The react element that was selected when `native` is `false` (default).
   */
  onChange: l.func,
  /**
   * Callback fired when the component requests to be closed.
   * Use it in either controlled (see the `open` prop), or uncontrolled mode (to detect when the Select collapses).
   *
   * @param {object} event The event source of the callback.
   */
  onClose: l.func,
  /**
   * Callback fired when the component requests to be opened.
   * Use it in either controlled (see the `open` prop), or uncontrolled mode (to detect when the Select expands).
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: l.func,
  /**
   * If `true`, the component is shown.
   * You can only use it when the `native` prop is `false` (default).
   */
  open: l.bool,
  /**
   * Render the selected value.
   * You can only use it when the `native` prop is `false` (default).
   *
   * @param {any} value The `value` provided to the component.
   * @returns {ReactNode}
   */
  renderValue: l.func,
  /**
   * Props applied to the clickable div element.
   */
  SelectDisplayProps: l.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * The `input` value. Providing an empty string will select no options.
   * Set to an empty string `''` if you don't want any of the available options to be selected.
   *
   * If the value is an object it must have reference equality with the option in order to be selected.
   * If the value is not an object, the string representation must match with the string representation of the option in order to be selected.
   */
  value: l.oneOfType([l.oneOf([""]), l.any]),
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: l.oneOf(["filled", "outlined", "standard"])
});
mf.muiName = "Select";
function q4e(e, t, n = (r, i) => r === i) {
  return e.length === t.length && e.every((r, i) => n(r, t[i]));
}
const G4e = 2;
function tW(e, t) {
  return e - t;
}
function j3(e, t) {
  var n;
  const {
    index: r
  } = (n = e.reduce((i, o, s) => {
    const a = Math.abs(t - o);
    return i === null || a < i.distance || a === i.distance ? {
      distance: a,
      index: s
    } : i;
  }, null)) != null ? n : {};
  return r;
}
function W1(e, t) {
  if (t.current !== void 0 && e.changedTouches) {
    const n = e;
    for (let r = 0; r < n.changedTouches.length; r += 1) {
      const i = n.changedTouches[r];
      if (i.identifier === t.current)
        return {
          x: i.clientX,
          y: i.clientY
        };
    }
    return !1;
  }
  return {
    x: e.clientX,
    y: e.clientY
  };
}
function JD(e, t, n) {
  return (e - t) * 100 / (n - t);
}
function Y4e(e, t, n) {
  return (n - t) * e + t;
}
function K4e(e) {
  if (Math.abs(e) < 1) {
    const n = e.toExponential().split("e-"), r = n[0].split(".")[1];
    return (r ? r.length : 0) + parseInt(n[1], 10);
  }
  const t = e.toString().split(".")[1];
  return t ? t.length : 0;
}
function J4e(e, t, n) {
  const r = Math.round((e - n) / t) * t + n;
  return Number(r.toFixed(K4e(t)));
}
function V3({
  values: e,
  newValue: t,
  index: n
}) {
  const r = e.slice();
  return r[n] = t, r.sort(tW);
}
function H1({
  sliderRef: e,
  activeIndex: t,
  setActive: n
}) {
  var r, i;
  const o = ei(e.current);
  if (!((r = e.current) != null && r.contains(o.activeElement)) || Number(o == null || (i = o.activeElement) == null ? void 0 : i.getAttribute("data-index")) !== t) {
    var s;
    (s = e.current) == null || s.querySelector(`[type="range"][data-index="${t}"]`).focus();
  }
  n && n(t);
}
function q1(e, t) {
  return typeof e == "number" && typeof t == "number" ? e === t : typeof e == "object" && typeof t == "object" ? q4e(e, t) : !1;
}
const X4e = {
  horizontal: {
    offset: (e) => ({
      left: `${e}%`
    }),
    leap: (e) => ({
      width: `${e}%`
    })
  },
  "horizontal-reverse": {
    offset: (e) => ({
      right: `${e}%`
    }),
    leap: (e) => ({
      width: `${e}%`
    })
  },
  vertical: {
    offset: (e) => ({
      bottom: `${e}%`
    }),
    leap: (e) => ({
      height: `${e}%`
    })
  }
}, Q4e = (e) => e;
let G1;
function z3() {
  return G1 === void 0 && (typeof CSS < "u" && typeof CSS.supports == "function" ? G1 = CSS.supports("touch-action", "none") : G1 = !0), G1;
}
function Z4e(e) {
  const {
    "aria-labelledby": t,
    defaultValue: n,
    disabled: r = !1,
    disableSwap: i = !1,
    isRtl: o = !1,
    marks: s = !1,
    max: a = 100,
    min: u = 0,
    name: c,
    onChange: d,
    onChangeCommitted: f,
    orientation: h = "horizontal",
    rootRef: m,
    scale: v = Q4e,
    step: x = 1,
    shiftStep: C = 10,
    tabIndex: E,
    value: S
  } = e, w = V.useRef(), [O, A] = V.useState(-1), [I, $] = V.useState(-1), [L, B] = V.useState(!1), H = V.useRef(0), [q, J] = Hi({
    controlled: S,
    default: n ?? u,
    name: "Slider"
  }), X = d && ((Pe, Ae, We) => {
    const At = Pe.nativeEvent || Pe, Ft = new At.constructor(At.type, At);
    Object.defineProperty(Ft, "target", {
      writable: !0,
      value: {
        value: Ae,
        name: c
      }
    }), d(Ft, Ae, We);
  }), j = Array.isArray(q);
  let U = j ? q.slice().sort(tW) : [q];
  U = U.map((Pe) => Pe == null ? u : Ep(Pe, u, a));
  const G = s === !0 && x !== null ? [...Array(Math.floor((a - u) / x) + 1)].map((Pe, Ae) => ({
    value: u + x * Ae
  })) : s || [], K = G.map((Pe) => Pe.value), {
    isFocusVisibleRef: ee,
    onBlur: te,
    onFocus: M,
    ref: Z
  } = OE(), [ne, R] = V.useState(-1), _ = V.useRef(), W = Hn(Z, _), Q = Hn(m, W), oe = (Pe) => (Ae) => {
    var We;
    const At = Number(Ae.currentTarget.getAttribute("data-index"));
    M(Ae), ee.current === !0 && R(At), $(At), Pe == null || (We = Pe.onFocus) == null || We.call(Pe, Ae);
  }, ae = (Pe) => (Ae) => {
    var We;
    te(Ae), ee.current === !1 && R(-1), $(-1), Pe == null || (We = Pe.onBlur) == null || We.call(Pe, Ae);
  }, pe = (Pe, Ae) => {
    const We = Number(Pe.currentTarget.getAttribute("data-index")), At = U[We], Ft = K.indexOf(At);
    let Ct = Ae;
    if (G && x == null) {
      const ht = K[K.length - 1];
      Ct > ht ? Ct = ht : Ct < K[0] ? Ct = K[0] : Ct = Ct < At ? K[Ft - 1] : K[Ft + 1];
    }
    if (Ct = Ep(Ct, u, a), j) {
      i && (Ct = Ep(Ct, U[We - 1] || -1 / 0, U[We + 1] || 1 / 0));
      const ht = Ct;
      Ct = V3({
        values: U,
        newValue: Ct,
        index: We
      });
      let He = We;
      i || (He = Ct.indexOf(ht)), H1({
        sliderRef: _,
        activeIndex: He
      });
    }
    J(Ct), R(We), X && !q1(Ct, q) && X(Pe, Ct, We), f && f(Pe, Ct);
  }, me = (Pe) => (Ae) => {
    var We;
    if (x !== null) {
      const At = Number(Ae.currentTarget.getAttribute("data-index")), Ft = U[At];
      let Ct = null;
      (Ae.key === "ArrowLeft" || Ae.key === "ArrowDown") && Ae.shiftKey || Ae.key === "PageDown" ? Ct = Math.max(Ft - C, u) : ((Ae.key === "ArrowRight" || Ae.key === "ArrowUp") && Ae.shiftKey || Ae.key === "PageUp") && (Ct = Math.min(Ft + C, a)), Ct !== null && (pe(Ae, Ct), Ae.preventDefault());
    }
    Pe == null || (We = Pe.onKeyDown) == null || We.call(Pe, Ae);
  };
  gi(() => {
    if (r && _.current.contains(document.activeElement)) {
      var Pe;
      (Pe = document.activeElement) == null || Pe.blur();
    }
  }, [r]), r && O !== -1 && A(-1), r && ne !== -1 && R(-1);
  const xe = (Pe) => (Ae) => {
    var We;
    (We = Pe.onChange) == null || We.call(Pe, Ae), pe(Ae, Ae.target.valueAsNumber);
  }, le = V.useRef();
  let ye = h;
  o && h === "horizontal" && (ye += "-reverse");
  const be = ({
    finger: Pe,
    move: Ae = !1
  }) => {
    const {
      current: We
    } = _, {
      width: At,
      height: Ft,
      bottom: Ct,
      left: ht
    } = We.getBoundingClientRect();
    let He;
    ye.indexOf("vertical") === 0 ? He = (Ct - Pe.y) / Ft : He = (Pe.x - ht) / At, ye.indexOf("-reverse") !== -1 && (He = 1 - He);
    let qe;
    if (qe = Y4e(He, u, a), x)
      qe = J4e(qe, x, u);
    else {
      const Ut = j3(K, qe);
      qe = K[Ut];
    }
    qe = Ep(qe, u, a);
    let wt = 0;
    if (j) {
      Ae ? wt = le.current : wt = j3(U, qe), i && (qe = Ep(qe, U[wt - 1] || -1 / 0, U[wt + 1] || 1 / 0));
      const Ut = qe;
      qe = V3({
        values: U,
        newValue: qe,
        index: wt
      }), i && Ae || (wt = qe.indexOf(Ut), le.current = wt);
    }
    return {
      newValue: qe,
      activeIndex: wt
    };
  }, Re = Mt((Pe) => {
    const Ae = W1(Pe, w);
    if (!Ae)
      return;
    if (H.current += 1, Pe.type === "mousemove" && Pe.buttons === 0) {
      Te(Pe);
      return;
    }
    const {
      newValue: We,
      activeIndex: At
    } = be({
      finger: Ae,
      move: !0
    });
    H1({
      sliderRef: _,
      activeIndex: At,
      setActive: A
    }), J(We), !L && H.current > G4e && B(!0), X && !q1(We, q) && X(Pe, We, At);
  }), Te = Mt((Pe) => {
    const Ae = W1(Pe, w);
    if (B(!1), !Ae)
      return;
    const {
      newValue: We
    } = be({
      finger: Ae,
      move: !0
    });
    A(-1), Pe.type === "touchend" && $(-1), f && f(Pe, We), w.current = void 0, Ne();
  }), Xe = Mt((Pe) => {
    if (r)
      return;
    z3() || Pe.preventDefault();
    const Ae = Pe.changedTouches[0];
    Ae != null && (w.current = Ae.identifier);
    const We = W1(Pe, w);
    if (We !== !1) {
      const {
        newValue: Ft,
        activeIndex: Ct
      } = be({
        finger: We
      });
      H1({
        sliderRef: _,
        activeIndex: Ct,
        setActive: A
      }), J(Ft), X && !q1(Ft, q) && X(Pe, Ft, Ct);
    }
    H.current = 0;
    const At = ei(_.current);
    At.addEventListener("touchmove", Re, {
      passive: !0
    }), At.addEventListener("touchend", Te, {
      passive: !0
    });
  }), Ne = V.useCallback(() => {
    const Pe = ei(_.current);
    Pe.removeEventListener("mousemove", Re), Pe.removeEventListener("mouseup", Te), Pe.removeEventListener("touchmove", Re), Pe.removeEventListener("touchend", Te);
  }, [Te, Re]);
  V.useEffect(() => {
    const {
      current: Pe
    } = _;
    return Pe.addEventListener("touchstart", Xe, {
      passive: z3()
    }), () => {
      Pe.removeEventListener("touchstart", Xe), Ne();
    };
  }, [Ne, Xe]), V.useEffect(() => {
    r && Ne();
  }, [r, Ne]);
  const Qe = (Pe) => (Ae) => {
    var We;
    if ((We = Pe.onMouseDown) == null || We.call(Pe, Ae), r || Ae.defaultPrevented || Ae.button !== 0)
      return;
    Ae.preventDefault();
    const At = W1(Ae, w);
    if (At !== !1) {
      const {
        newValue: Ct,
        activeIndex: ht
      } = be({
        finger: At
      });
      H1({
        sliderRef: _,
        activeIndex: ht,
        setActive: A
      }), J(Ct), X && !q1(Ct, q) && X(Ae, Ct, ht);
    }
    H.current = 0;
    const Ft = ei(_.current);
    Ft.addEventListener("mousemove", Re, {
      passive: !0
    }), Ft.addEventListener("mouseup", Te);
  }, Ee = JD(j ? U[0] : u, u, a), Ie = JD(U[U.length - 1], u, a) - Ee, Je = (Pe = {}) => {
    const Ae = a0(Pe), We = {
      onMouseDown: Qe(Ae || {})
    }, At = N({}, Ae, We);
    return N({}, Pe, {
      ref: Q
    }, At);
  }, vt = (Pe) => (Ae) => {
    var We;
    (We = Pe.onMouseOver) == null || We.call(Pe, Ae);
    const At = Number(Ae.currentTarget.getAttribute("data-index"));
    $(At);
  }, St = (Pe) => (Ae) => {
    var We;
    (We = Pe.onMouseLeave) == null || We.call(Pe, Ae), $(-1);
  };
  return {
    active: O,
    axis: ye,
    axisProps: X4e,
    dragging: L,
    focusedThumbIndex: ne,
    getHiddenInputProps: (Pe = {}) => {
      var Ae;
      const We = a0(Pe), At = {
        onChange: xe(We || {}),
        onFocus: oe(We || {}),
        onBlur: ae(We || {}),
        onKeyDown: me(We || {})
      }, Ft = N({}, We, At);
      return N({
        tabIndex: E,
        "aria-labelledby": t,
        "aria-orientation": h,
        "aria-valuemax": v(a),
        "aria-valuemin": v(u),
        name: c,
        type: "range",
        min: e.min,
        max: e.max,
        step: e.step === null && e.marks ? "any" : (Ae = e.step) != null ? Ae : void 0,
        disabled: r
      }, Pe, Ft, {
        style: N({}, KNe, {
          direction: o ? "rtl" : "ltr",
          // So that VoiceOver's focus indicator matches the thumb's dimensions
          width: "100%",
          height: "100%"
        })
      });
    },
    getRootProps: Je,
    getThumbProps: (Pe = {}) => {
      const Ae = a0(Pe), We = {
        onMouseOver: vt(Ae || {}),
        onMouseLeave: St(Ae || {})
      };
      return N({}, Pe, Ae, We);
    },
    marks: G,
    open: I,
    range: j,
    rootRef: Q,
    trackLeap: Ie,
    trackOffset: Ee,
    values: U,
    getThumbStyle: (Pe) => ({
      // So the non active thumb doesn't show its label on hover.
      pointerEvents: O !== -1 && O !== Pe ? "none" : void 0
    })
  };
}
const e6e = (e) => !e || !lu(e);
function t6e(e) {
  return ot("MuiSlider", e);
}
const Ia = st("MuiSlider", ["root", "active", "colorPrimary", "colorSecondary", "colorError", "colorInfo", "colorSuccess", "colorWarning", "disabled", "dragging", "focusVisible", "mark", "markActive", "marked", "markLabel", "markLabelActive", "rail", "sizeSmall", "thumb", "thumbColorPrimary", "thumbColorSecondary", "thumbColorError", "thumbColorSuccess", "thumbColorInfo", "thumbColorWarning", "track", "trackInverted", "trackFalse", "thumbSizeSmall", "valueLabel", "valueLabelOpen", "valueLabelCircle", "valueLabelLabel", "vertical"]), n6e = (e) => {
  const {
    open: t
  } = e;
  return {
    offset: Be(t && Ia.valueLabelOpen),
    circle: Ia.valueLabelCircle,
    label: Ia.valueLabelLabel
  };
};
function nW(e) {
  const {
    children: t,
    className: n,
    value: r
  } = e, i = n6e(e);
  return t ? /* @__PURE__ */ V.cloneElement(t, {
    className: Be(t.props.className)
  }, /* @__PURE__ */ P.jsxs(V.Fragment, {
    children: [t.props.children, /* @__PURE__ */ P.jsx("span", {
      className: Be(i.offset, n),
      "aria-hidden": !0,
      children: /* @__PURE__ */ P.jsx("span", {
        className: i.circle,
        children: /* @__PURE__ */ P.jsx("span", {
          className: i.label,
          children: r
        })
      })
    })]
  })) : null;
}
process.env.NODE_ENV !== "production" && (nW.propTypes = {
  children: l.element.isRequired,
  className: l.string,
  value: l.node
});
const r6e = ["aria-label", "aria-valuetext", "aria-labelledby", "component", "components", "componentsProps", "color", "classes", "className", "disableSwap", "disabled", "getAriaLabel", "getAriaValueText", "marks", "max", "min", "name", "onChange", "onChangeCommitted", "orientation", "shiftStep", "size", "step", "scale", "slotProps", "slots", "tabIndex", "track", "value", "valueLabelDisplay", "valueLabelFormat"];
function U3(e) {
  return e;
}
const i6e = De("span", {
  name: "MuiSlider",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[`color${Ue(n.color)}`], n.size !== "medium" && t[`size${Ue(n.size)}`], n.marked && t.marked, n.orientation === "vertical" && t.vertical, n.track === "inverted" && t.trackInverted, n.track === !1 && t.trackFalse];
  }
})(({
  theme: e
}) => {
  var t;
  return {
    borderRadius: 12,
    boxSizing: "content-box",
    display: "inline-block",
    position: "relative",
    cursor: "pointer",
    touchAction: "none",
    WebkitTapHighlightColor: "transparent",
    "@media print": {
      colorAdjust: "exact"
    },
    [`&.${Ia.disabled}`]: {
      pointerEvents: "none",
      cursor: "default",
      color: (e.vars || e).palette.grey[400]
    },
    [`&.${Ia.dragging}`]: {
      [`& .${Ia.thumb}, & .${Ia.track}`]: {
        transition: "none"
      }
    },
    variants: [...Object.keys(((t = e.vars) != null ? t : e).palette).filter((n) => {
      var r;
      return ((r = e.vars) != null ? r : e).palette[n].main;
    }).map((n) => ({
      props: {
        color: n
      },
      style: {
        color: (e.vars || e).palette[n].main
      }
    })), {
      props: {
        orientation: "horizontal"
      },
      style: {
        height: 4,
        width: "100%",
        padding: "13px 0",
        // The primary input mechanism of the device includes a pointing device of limited accuracy.
        "@media (pointer: coarse)": {
          // Reach 42px touch target, about ~8mm on screen.
          padding: "20px 0"
        }
      }
    }, {
      props: {
        orientation: "horizontal",
        size: "small"
      },
      style: {
        height: 2
      }
    }, {
      props: {
        orientation: "horizontal",
        marked: !0
      },
      style: {
        marginBottom: 20
      }
    }, {
      props: {
        orientation: "vertical"
      },
      style: {
        height: "100%",
        width: 4,
        padding: "0 13px",
        // The primary input mechanism of the device includes a pointing device of limited accuracy.
        "@media (pointer: coarse)": {
          // Reach 42px touch target, about ~8mm on screen.
          padding: "0 20px"
        }
      }
    }, {
      props: {
        orientation: "vertical",
        size: "small"
      },
      style: {
        width: 2
      }
    }, {
      props: {
        orientation: "vertical",
        marked: !0
      },
      style: {
        marginRight: 44
      }
    }]
  };
}), o6e = De("span", {
  name: "MuiSlider",
  slot: "Rail",
  overridesResolver: (e, t) => t.rail
})({
  display: "block",
  position: "absolute",
  borderRadius: "inherit",
  backgroundColor: "currentColor",
  opacity: 0.38,
  variants: [{
    props: {
      orientation: "horizontal"
    },
    style: {
      width: "100%",
      height: "inherit",
      top: "50%",
      transform: "translateY(-50%)"
    }
  }, {
    props: {
      orientation: "vertical"
    },
    style: {
      height: "100%",
      width: "inherit",
      left: "50%",
      transform: "translateX(-50%)"
    }
  }, {
    props: {
      track: "inverted"
    },
    style: {
      opacity: 1
    }
  }]
}), s6e = De("span", {
  name: "MuiSlider",
  slot: "Track",
  overridesResolver: (e, t) => t.track
})(({
  theme: e
}) => {
  var t;
  return {
    display: "block",
    position: "absolute",
    borderRadius: "inherit",
    border: "1px solid currentColor",
    backgroundColor: "currentColor",
    transition: e.transitions.create(["left", "width", "bottom", "height"], {
      duration: e.transitions.duration.shortest
    }),
    variants: [{
      props: {
        size: "small"
      },
      style: {
        border: "none"
      }
    }, {
      props: {
        orientation: "horizontal"
      },
      style: {
        height: "inherit",
        top: "50%",
        transform: "translateY(-50%)"
      }
    }, {
      props: {
        orientation: "vertical"
      },
      style: {
        width: "inherit",
        left: "50%",
        transform: "translateX(-50%)"
      }
    }, {
      props: {
        track: !1
      },
      style: {
        display: "none"
      }
    }, ...Object.keys(((t = e.vars) != null ? t : e).palette).filter((n) => {
      var r;
      return ((r = e.vars) != null ? r : e).palette[n].main;
    }).map((n) => ({
      props: {
        color: n,
        track: "inverted"
      },
      style: N({}, e.vars ? {
        backgroundColor: e.vars.palette.Slider[`${n}Track`],
        borderColor: e.vars.palette.Slider[`${n}Track`]
      } : N({
        backgroundColor: Kp(e.palette[n].main, 0.62),
        borderColor: Kp(e.palette[n].main, 0.62)
      }, e.applyStyles("dark", {
        backgroundColor: Yp(e.palette[n].main, 0.5)
      }), e.applyStyles("dark", {
        borderColor: Yp(e.palette[n].main, 0.5)
      })))
    }))]
  };
}), a6e = De("span", {
  name: "MuiSlider",
  slot: "Thumb",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.thumb, t[`thumbColor${Ue(n.color)}`], n.size !== "medium" && t[`thumbSize${Ue(n.size)}`]];
  }
})(({
  theme: e
}) => {
  var t;
  return {
    position: "absolute",
    width: 20,
    height: 20,
    boxSizing: "border-box",
    borderRadius: "50%",
    outline: 0,
    backgroundColor: "currentColor",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: e.transitions.create(["box-shadow", "left", "bottom"], {
      duration: e.transitions.duration.shortest
    }),
    "&::before": {
      position: "absolute",
      content: '""',
      borderRadius: "inherit",
      width: "100%",
      height: "100%",
      boxShadow: (e.vars || e).shadows[2]
    },
    "&::after": {
      position: "absolute",
      content: '""',
      borderRadius: "50%",
      // 42px is the hit target
      width: 42,
      height: 42,
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)"
    },
    [`&.${Ia.disabled}`]: {
      "&:hover": {
        boxShadow: "none"
      }
    },
    variants: [{
      props: {
        size: "small"
      },
      style: {
        width: 12,
        height: 12,
        "&::before": {
          boxShadow: "none"
        }
      }
    }, {
      props: {
        orientation: "horizontal"
      },
      style: {
        top: "50%",
        transform: "translate(-50%, -50%)"
      }
    }, {
      props: {
        orientation: "vertical"
      },
      style: {
        left: "50%",
        transform: "translate(-50%, 50%)"
      }
    }, ...Object.keys(((t = e.vars) != null ? t : e).palette).filter((n) => {
      var r;
      return ((r = e.vars) != null ? r : e).palette[n].main;
    }).map((n) => ({
      props: {
        color: n
      },
      style: {
        [`&:hover, &.${Ia.focusVisible}`]: N({}, e.vars ? {
          boxShadow: `0px 0px 0px 8px rgba(${e.vars.palette[n].mainChannel} / 0.16)`
        } : {
          boxShadow: `0px 0px 0px 8px ${Yt(e.palette[n].main, 0.16)}`
        }, {
          "@media (hover: none)": {
            boxShadow: "none"
          }
        }),
        [`&.${Ia.active}`]: N({}, e.vars ? {
          boxShadow: `0px 0px 0px 14px rgba(${e.vars.palette[n].mainChannel} / 0.16)`
        } : {
          boxShadow: `0px 0px 0px 14px ${Yt(e.palette[n].main, 0.16)}`
        })
      }
    }))]
  };
}), l6e = De(nW, {
  name: "MuiSlider",
  slot: "ValueLabel",
  overridesResolver: (e, t) => t.valueLabel
})(({
  theme: e
}) => N({
  zIndex: 1,
  whiteSpace: "nowrap"
}, e.typography.body2, {
  fontWeight: 500,
  transition: e.transitions.create(["transform"], {
    duration: e.transitions.duration.shortest
  }),
  position: "absolute",
  backgroundColor: (e.vars || e).palette.grey[600],
  borderRadius: 2,
  color: (e.vars || e).palette.common.white,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: "0.25rem 0.75rem",
  variants: [{
    props: {
      orientation: "horizontal"
    },
    style: {
      transform: "translateY(-100%) scale(0)",
      top: "-10px",
      transformOrigin: "bottom center",
      "&::before": {
        position: "absolute",
        content: '""',
        width: 8,
        height: 8,
        transform: "translate(-50%, 50%) rotate(45deg)",
        backgroundColor: "inherit",
        bottom: 0,
        left: "50%"
      },
      [`&.${Ia.valueLabelOpen}`]: {
        transform: "translateY(-100%) scale(1)"
      }
    }
  }, {
    props: {
      orientation: "vertical"
    },
    style: {
      transform: "translateY(-50%) scale(0)",
      right: "30px",
      top: "50%",
      transformOrigin: "right center",
      "&::before": {
        position: "absolute",
        content: '""',
        width: 8,
        height: 8,
        transform: "translate(-50%, -50%) rotate(45deg)",
        backgroundColor: "inherit",
        right: -8,
        top: "50%"
      },
      [`&.${Ia.valueLabelOpen}`]: {
        transform: "translateY(-50%) scale(1)"
      }
    }
  }, {
    props: {
      size: "small"
    },
    style: {
      fontSize: e.typography.pxToRem(12),
      padding: "0.25rem 0.5rem"
    }
  }, {
    props: {
      orientation: "vertical",
      size: "small"
    },
    style: {
      right: "20px"
    }
  }]
})), u6e = De("span", {
  name: "MuiSlider",
  slot: "Mark",
  shouldForwardProp: (e) => FE(e) && e !== "markActive",
  overridesResolver: (e, t) => {
    const {
      markActive: n
    } = e;
    return [t.mark, n && t.markActive];
  }
})(({
  theme: e
}) => ({
  position: "absolute",
  width: 2,
  height: 2,
  borderRadius: 1,
  backgroundColor: "currentColor",
  variants: [{
    props: {
      orientation: "horizontal"
    },
    style: {
      top: "50%",
      transform: "translate(-1px, -50%)"
    }
  }, {
    props: {
      orientation: "vertical"
    },
    style: {
      left: "50%",
      transform: "translate(-50%, 1px)"
    }
  }, {
    props: {
      markActive: !0
    },
    style: {
      backgroundColor: (e.vars || e).palette.background.paper,
      opacity: 0.8
    }
  }]
})), c6e = De("span", {
  name: "MuiSlider",
  slot: "MarkLabel",
  shouldForwardProp: (e) => FE(e) && e !== "markLabelActive",
  overridesResolver: (e, t) => t.markLabel
})(({
  theme: e
}) => N({}, e.typography.body2, {
  color: (e.vars || e).palette.text.secondary,
  position: "absolute",
  whiteSpace: "nowrap",
  variants: [{
    props: {
      orientation: "horizontal"
    },
    style: {
      top: 30,
      transform: "translateX(-50%)",
      "@media (pointer: coarse)": {
        top: 40
      }
    }
  }, {
    props: {
      orientation: "vertical"
    },
    style: {
      left: 36,
      transform: "translateY(50%)",
      "@media (pointer: coarse)": {
        left: 44
      }
    }
  }, {
    props: {
      markLabelActive: !0
    },
    style: {
      color: (e.vars || e).palette.text.primary
    }
  }]
})), d6e = (e) => {
  const {
    disabled: t,
    dragging: n,
    marked: r,
    orientation: i,
    track: o,
    classes: s,
    color: a,
    size: u
  } = e, c = {
    root: ["root", t && "disabled", n && "dragging", r && "marked", i === "vertical" && "vertical", o === "inverted" && "trackInverted", o === !1 && "trackFalse", a && `color${Ue(a)}`, u && `size${Ue(u)}`],
    rail: ["rail"],
    track: ["track"],
    mark: ["mark"],
    markActive: ["markActive"],
    markLabel: ["markLabel"],
    markLabelActive: ["markLabelActive"],
    valueLabel: ["valueLabel"],
    thumb: ["thumb", t && "disabled", u && `thumbSize${Ue(u)}`, a && `thumbColor${Ue(a)}`],
    active: ["active"],
    disabled: ["disabled"],
    focusVisible: ["focusVisible"]
  };
  return at(c, t6e, s);
}, p6e = ({
  children: e
}) => e, rW = /* @__PURE__ */ V.forwardRef(function(t, n) {
  var r, i, o, s, a, u, c, d, f, h, m, v, x, C, E, S, w, O, A, I, $, L, B, H;
  const q = Ot({
    props: t,
    name: "MuiSlider"
  }), J = Wb(), {
    "aria-label": X,
    "aria-valuetext": j,
    "aria-labelledby": U,
    // eslint-disable-next-line react/prop-types
    component: G = "span",
    components: K = {},
    componentsProps: ee = {},
    color: te = "primary",
    classes: M,
    className: Z,
    disableSwap: ne = !1,
    disabled: R = !1,
    getAriaLabel: _,
    getAriaValueText: W,
    marks: Q = !1,
    max: oe = 100,
    min: ae = 0,
    orientation: pe = "horizontal",
    shiftStep: me = 10,
    size: xe = "medium",
    step: le = 1,
    scale: ye = U3,
    slotProps: be,
    slots: Re,
    track: Te = "normal",
    valueLabelDisplay: Xe = "off",
    valueLabelFormat: Ne = U3
  } = q, Qe = _e(q, r6e), Ee = N({}, q, {
    isRtl: J,
    max: oe,
    min: ae,
    classes: M,
    disabled: R,
    disableSwap: ne,
    orientation: pe,
    marks: Q,
    color: te,
    size: xe,
    step: le,
    shiftStep: me,
    scale: ye,
    track: Te,
    valueLabelDisplay: Xe,
    valueLabelFormat: Ne
  }), {
    axisProps: Ie,
    getRootProps: Je,
    getHiddenInputProps: vt,
    getThumbProps: St,
    open: Lt,
    active: ke,
    axis: Le,
    focusedThumbIndex: Pe,
    range: Ae,
    dragging: We,
    marks: At,
    values: Ft,
    trackOffset: Ct,
    trackLeap: ht,
    getThumbStyle: He
  } = Z4e(N({}, Ee, {
    rootRef: n
  }));
  Ee.marked = At.length > 0 && At.some((Oe) => Oe.label), Ee.dragging = We, Ee.focusedThumbIndex = Pe;
  const qe = d6e(Ee), wt = (r = (i = Re == null ? void 0 : Re.root) != null ? i : K.Root) != null ? r : i6e, Ut = (o = (s = Re == null ? void 0 : Re.rail) != null ? s : K.Rail) != null ? o : o6e, an = (a = (u = Re == null ? void 0 : Re.track) != null ? u : K.Track) != null ? a : s6e, wn = (c = (d = Re == null ? void 0 : Re.thumb) != null ? d : K.Thumb) != null ? c : a6e, En = (f = (h = Re == null ? void 0 : Re.valueLabel) != null ? h : K.ValueLabel) != null ? f : l6e, sr = (m = (v = Re == null ? void 0 : Re.mark) != null ? v : K.Mark) != null ? m : u6e, er = (x = (C = Re == null ? void 0 : Re.markLabel) != null ? C : K.MarkLabel) != null ? x : c6e, pn = (E = (S = Re == null ? void 0 : Re.input) != null ? S : K.Input) != null ? E : "input", Pr = (w = be == null ? void 0 : be.root) != null ? w : ee.root, bi = (O = be == null ? void 0 : be.rail) != null ? O : ee.rail, Wr = (A = be == null ? void 0 : be.track) != null ? A : ee.track, Po = (I = be == null ? void 0 : be.thumb) != null ? I : ee.thumb, _r = ($ = be == null ? void 0 : be.valueLabel) != null ? $ : ee.valueLabel, Lr = (L = be == null ? void 0 : be.mark) != null ? L : ee.mark, Gn = (B = be == null ? void 0 : be.markLabel) != null ? B : ee.markLabel, Hr = (H = be == null ? void 0 : be.input) != null ? H : ee.input, Qn = Ai({
    elementType: wt,
    getSlotProps: Je,
    externalSlotProps: Pr,
    externalForwardedProps: Qe,
    additionalProps: N({}, e6e(wt) && {
      as: G
    }),
    ownerState: N({}, Ee, Pr == null ? void 0 : Pr.ownerState),
    className: [qe.root, Z]
  }), ao = Ai({
    elementType: Ut,
    externalSlotProps: bi,
    ownerState: Ee,
    className: qe.rail
  }), Ls = Ai({
    elementType: an,
    externalSlotProps: Wr,
    additionalProps: {
      style: N({}, Ie[Le].offset(Ct), Ie[Le].leap(ht))
    },
    ownerState: N({}, Ee, Wr == null ? void 0 : Wr.ownerState),
    className: qe.track
  }), Mi = Ai({
    elementType: wn,
    getSlotProps: St,
    externalSlotProps: Po,
    ownerState: N({}, Ee, Po == null ? void 0 : Po.ownerState),
    className: qe.thumb
  }), ko = Ai({
    elementType: En,
    externalSlotProps: _r,
    ownerState: N({}, Ee, _r == null ? void 0 : _r.ownerState),
    className: qe.valueLabel
  }), ve = Ai({
    elementType: sr,
    externalSlotProps: Lr,
    ownerState: Ee,
    className: qe.mark
  }), tt = Ai({
    elementType: er,
    externalSlotProps: Gn,
    ownerState: Ee,
    className: qe.markLabel
  }), xt = Ai({
    elementType: pn,
    getSlotProps: vt,
    externalSlotProps: Hr,
    ownerState: Ee
  });
  return /* @__PURE__ */ P.jsxs(wt, N({}, Qn, {
    children: [/* @__PURE__ */ P.jsx(Ut, N({}, ao)), /* @__PURE__ */ P.jsx(an, N({}, Ls)), At.filter((Oe) => Oe.value >= ae && Oe.value <= oe).map((Oe, Fe) => {
      const et = JD(Oe.value, ae, oe), Ke = Ie[Le].offset(et);
      let ct;
      return Te === !1 ? ct = Ft.indexOf(Oe.value) !== -1 : ct = Te === "normal" && (Ae ? Oe.value >= Ft[0] && Oe.value <= Ft[Ft.length - 1] : Oe.value <= Ft[0]) || Te === "inverted" && (Ae ? Oe.value <= Ft[0] || Oe.value >= Ft[Ft.length - 1] : Oe.value >= Ft[0]), /* @__PURE__ */ P.jsxs(V.Fragment, {
        children: [/* @__PURE__ */ P.jsx(sr, N({
          "data-index": Fe
        }, ve, !lu(sr) && {
          markActive: ct
        }, {
          style: N({}, Ke, ve.style),
          className: Be(ve.className, ct && qe.markActive)
        })), Oe.label != null ? /* @__PURE__ */ P.jsx(er, N({
          "aria-hidden": !0,
          "data-index": Fe
        }, tt, !lu(er) && {
          markLabelActive: ct
        }, {
          style: N({}, Ke, tt.style),
          className: Be(qe.markLabel, tt.className, ct && qe.markLabelActive),
          children: Oe.label
        })) : null]
      }, Fe);
    }), Ft.map((Oe, Fe) => {
      const et = JD(Oe, ae, oe), Ke = Ie[Le].offset(et), ct = Xe === "off" ? p6e : En;
      return (
        /* TODO v6: Change component structure. It will help in avoiding the complicated React.cloneElement API added in SliderValueLabel component. Should be: Thumb -> Input, ValueLabel. Follow Joy UI's Slider structure. */
        /* @__PURE__ */ P.jsx(ct, N({}, !lu(ct) && {
          valueLabelFormat: Ne,
          valueLabelDisplay: Xe,
          value: typeof Ne == "function" ? Ne(ye(Oe), Fe) : Ne,
          index: Fe,
          open: Lt === Fe || ke === Fe || Xe === "on",
          disabled: R
        }, ko, {
          children: /* @__PURE__ */ P.jsx(wn, N({
            "data-index": Fe
          }, Mi, {
            className: Be(qe.thumb, Mi.className, ke === Fe && qe.active, Pe === Fe && qe.focusVisible),
            style: N({}, Ke, He(Fe), Mi.style),
            children: /* @__PURE__ */ P.jsx(pn, N({
              "data-index": Fe,
              "aria-label": _ ? _(Fe) : X,
              "aria-valuenow": ye(Oe),
              "aria-labelledby": U,
              "aria-valuetext": W ? W(ye(Oe), Fe) : j,
              value: Ft[Fe]
            }, xt))
          }))
        }), Fe)
      );
    })]
  }));
});
process.env.NODE_ENV !== "production" && (rW.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The label of the slider.
   */
  "aria-label": $s(l.string, (e) => Array.isArray(e.value || e.defaultValue) && e["aria-label"] != null ? new Error("MUI: You need to use the `getAriaLabel` prop instead of `aria-label` when using a range slider.") : null),
  /**
   * The id of the element containing a label for the slider.
   */
  "aria-labelledby": l.string,
  /**
   * A string value that provides a user-friendly name for the current value of the slider.
   */
  "aria-valuetext": $s(l.string, (e) => Array.isArray(e.value || e.defaultValue) && e["aria-valuetext"] != null ? new Error("MUI: You need to use the `getAriaValueText` prop instead of `aria-valuetext` when using a range slider.") : null),
  /**
   * @ignore
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: l.oneOfType([l.oneOf(["primary", "secondary", "error", "info", "success", "warning"]), l.string]),
  /**
   * The components used for each slot inside.
   *
   * @deprecated use the `slots` prop instead. This prop will be removed in v7. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/).
   *
   * @default {}
   */
  components: l.shape({
    Input: l.elementType,
    Mark: l.elementType,
    MarkLabel: l.elementType,
    Rail: l.elementType,
    Root: l.elementType,
    Thumb: l.elementType,
    Track: l.elementType,
    ValueLabel: l.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * @deprecated use the `slotProps` prop instead. This prop will be removed in v7. [How to migrate](/material-ui/migration/migrating-from-deprecated-apis/).
   *
   * @default {}
   */
  componentsProps: l.shape({
    input: l.oneOfType([l.func, l.object]),
    mark: l.oneOfType([l.func, l.object]),
    markLabel: l.oneOfType([l.func, l.object]),
    rail: l.oneOfType([l.func, l.object]),
    root: l.oneOfType([l.func, l.object]),
    thumb: l.oneOfType([l.func, l.object]),
    track: l.oneOfType([l.func, l.object]),
    valueLabel: l.oneOfType([l.func, l.shape({
      children: l.element,
      className: l.string,
      open: l.bool,
      style: l.object,
      value: l.number,
      valueLabelDisplay: l.oneOf(["auto", "off", "on"])
    })])
  }),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: l.oneOfType([l.arrayOf(l.number), l.number]),
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: l.bool,
  /**
   * If `true`, the active thumb doesn't swap when moving pointer over a thumb while dragging another thumb.
   * @default false
   */
  disableSwap: l.bool,
  /**
   * Accepts a function which returns a string value that provides a user-friendly name for the thumb labels of the slider.
   * This is important for screen reader users.
   * @param {number} index The thumb label's index to format.
   * @returns {string}
   */
  getAriaLabel: l.func,
  /**
   * Accepts a function which returns a string value that provides a user-friendly name for the current value of the slider.
   * This is important for screen reader users.
   * @param {number} value The thumb label's value to format.
   * @param {number} index The thumb label's index to format.
   * @returns {string}
   */
  getAriaValueText: l.func,
  /**
   * Marks indicate predetermined values to which the user can move the slider.
   * If `true` the marks are spaced according the value of the `step` prop.
   * If an array, it should contain objects with `value` and an optional `label` keys.
   * @default false
   */
  marks: l.oneOfType([l.arrayOf(l.shape({
    label: l.node,
    value: l.number.isRequired
  })), l.bool]),
  /**
   * The maximum allowed value of the slider.
   * Should not be equal to min.
   * @default 100
   */
  max: l.number,
  /**
   * The minimum allowed value of the slider.
   * Should not be equal to max.
   * @default 0
   */
  min: l.number,
  /**
   * Name attribute of the hidden `input` element.
   */
  name: l.string,
  /**
   * Callback function that is fired when the slider's value changed.
   *
   * @param {Event} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * **Warning**: This is a generic event not a change event.
   * @param {number | number[]} value The new value.
   * @param {number} activeThumb Index of the currently moved thumb.
   */
  onChange: l.func,
  /**
   * Callback function that is fired when the `mouseup` is triggered.
   *
   * @param {React.SyntheticEvent | Event} event The event source of the callback. **Warning**: This is a generic event not a change event.
   * @param {number | number[]} value The new value.
   */
  onChangeCommitted: l.func,
  /**
   * The component orientation.
   * @default 'horizontal'
   */
  orientation: l.oneOf(["horizontal", "vertical"]),
  /**
   * A transformation function, to change the scale of the slider.
   * @param {any} x
   * @returns {any}
   * @default function Identity(x) {
   *   return x;
   * }
   */
  scale: l.func,
  /**
   * The granularity with which the slider can step through values when using Page Up/Page Down or Shift + Arrow Up/Arrow Down.
   * @default 10
   */
  shiftStep: l.number,
  /**
   * The size of the slider.
   * @default 'medium'
   */
  size: l.oneOfType([l.oneOf(["small", "medium"]), l.string]),
  /**
   * The props used for each slot inside the Slider.
   * @default {}
   */
  slotProps: l.shape({
    input: l.oneOfType([l.func, l.object]),
    mark: l.oneOfType([l.func, l.object]),
    markLabel: l.oneOfType([l.func, l.object]),
    rail: l.oneOfType([l.func, l.object]),
    root: l.oneOfType([l.func, l.object]),
    thumb: l.oneOfType([l.func, l.object]),
    track: l.oneOfType([l.func, l.object]),
    valueLabel: l.oneOfType([l.func, l.shape({
      children: l.element,
      className: l.string,
      open: l.bool,
      style: l.object,
      value: l.number,
      valueLabelDisplay: l.oneOf(["auto", "off", "on"])
    })])
  }),
  /**
   * The components used for each slot inside the Slider.
   * Either a string to use a HTML element or a component.
   * @default {}
   */
  slots: l.shape({
    input: l.elementType,
    mark: l.elementType,
    markLabel: l.elementType,
    rail: l.elementType,
    root: l.elementType,
    thumb: l.elementType,
    track: l.elementType,
    valueLabel: l.elementType
  }),
  /**
   * The granularity with which the slider can step through values. (A "discrete" slider.)
   * The `min` prop serves as the origin for the valid values.
   * We recommend (max - min) to be evenly divisible by the step.
   *
   * When step is `null`, the thumb can only be slid onto marks provided with the `marks` prop.
   * @default 1
   */
  step: l.number,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * Tab index attribute of the hidden `input` element.
   */
  tabIndex: l.number,
  /**
   * The track presentation:
   *
   * - `normal` the track will render a bar representing the slider value.
   * - `inverted` the track will render a bar representing the remaining slider value.
   * - `false` the track will render without a bar.
   * @default 'normal'
   */
  track: l.oneOf(["inverted", "normal", !1]),
  /**
   * The value of the slider.
   * For ranged sliders, provide an array with two values.
   */
  value: l.oneOfType([l.arrayOf(l.number), l.number]),
  /**
   * Controls when the value label is displayed:
   *
   * - `auto` the value label will display when the thumb is hovered or focused.
   * - `on` will display persistently.
   * - `off` will never display.
   * @default 'off'
   */
  valueLabelDisplay: l.oneOf(["auto", "off", "on"]),
  /**
   * The format function the value label's value.
   *
   * When a function is provided, it should have the following signature:
   *
   * - {number} value The value label's value to format
   * - {number} index The value label's index to format
   * @param {any} x
   * @returns {any}
   * @default function Identity(x) {
   *   return x;
   * }
   */
  valueLabelFormat: l.oneOfType([l.func, l.string])
});
function f6e(e) {
  return ot("MuiTooltip", e);
}
const td = st("MuiTooltip", ["popper", "popperInteractive", "popperArrow", "popperClose", "tooltip", "tooltipArrow", "touch", "tooltipPlacementLeft", "tooltipPlacementRight", "tooltipPlacementTop", "tooltipPlacementBottom", "arrow"]), h6e = ["arrow", "children", "classes", "components", "componentsProps", "describeChild", "disableFocusListener", "disableHoverListener", "disableInteractive", "disableTouchListener", "enterDelay", "enterNextDelay", "enterTouchDelay", "followCursor", "id", "leaveDelay", "leaveTouchDelay", "onClose", "onOpen", "open", "placement", "PopperComponent", "PopperProps", "slotProps", "slots", "title", "TransitionComponent", "TransitionProps"];
function m6e(e) {
  return Math.round(e * 1e5) / 1e5;
}
const g6e = (e) => {
  const {
    classes: t,
    disableInteractive: n,
    arrow: r,
    touch: i,
    placement: o
  } = e, s = {
    popper: ["popper", !n && "popperInteractive", r && "popperArrow"],
    tooltip: ["tooltip", r && "tooltipArrow", i && "touch", `tooltipPlacement${Ue(o.split("-")[0])}`],
    arrow: ["arrow"]
  };
  return at(s, f6e, t);
}, y6e = De(ag, {
  name: "MuiTooltip",
  slot: "Popper",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.popper, !n.disableInteractive && t.popperInteractive, n.arrow && t.popperArrow, !n.open && t.popperClose];
  }
})(({
  theme: e,
  ownerState: t,
  open: n
}) => N({
  zIndex: (e.vars || e).zIndex.tooltip,
  pointerEvents: "none"
}, !t.disableInteractive && {
  pointerEvents: "auto"
}, !n && {
  pointerEvents: "none"
}, t.arrow && {
  [`&[data-popper-placement*="bottom"] .${td.arrow}`]: {
    top: 0,
    marginTop: "-0.71em",
    "&::before": {
      transformOrigin: "0 100%"
    }
  },
  [`&[data-popper-placement*="top"] .${td.arrow}`]: {
    bottom: 0,
    marginBottom: "-0.71em",
    "&::before": {
      transformOrigin: "100% 0"
    }
  },
  [`&[data-popper-placement*="right"] .${td.arrow}`]: N({}, t.isRtl ? {
    right: 0,
    marginRight: "-0.71em"
  } : {
    left: 0,
    marginLeft: "-0.71em"
  }, {
    height: "1em",
    width: "0.71em",
    "&::before": {
      transformOrigin: "100% 100%"
    }
  }),
  [`&[data-popper-placement*="left"] .${td.arrow}`]: N({}, t.isRtl ? {
    left: 0,
    marginLeft: "-0.71em"
  } : {
    right: 0,
    marginRight: "-0.71em"
  }, {
    height: "1em",
    width: "0.71em",
    "&::before": {
      transformOrigin: "0 0"
    }
  })
})), b6e = De("div", {
  name: "MuiTooltip",
  slot: "Tooltip",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.tooltip, n.touch && t.touch, n.arrow && t.tooltipArrow, t[`tooltipPlacement${Ue(n.placement.split("-")[0])}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => N({
  backgroundColor: e.vars ? e.vars.palette.Tooltip.bg : Yt(e.palette.grey[700], 0.92),
  borderRadius: (e.vars || e).shape.borderRadius,
  color: (e.vars || e).palette.common.white,
  fontFamily: e.typography.fontFamily,
  padding: "4px 8px",
  fontSize: e.typography.pxToRem(11),
  maxWidth: 300,
  margin: 2,
  wordWrap: "break-word",
  fontWeight: e.typography.fontWeightMedium
}, t.arrow && {
  position: "relative",
  margin: 0
}, t.touch && {
  padding: "8px 16px",
  fontSize: e.typography.pxToRem(14),
  lineHeight: `${m6e(16 / 14)}em`,
  fontWeight: e.typography.fontWeightRegular
}, {
  [`.${td.popper}[data-popper-placement*="left"] &`]: N({
    transformOrigin: "right center"
  }, t.isRtl ? N({
    marginLeft: "14px"
  }, t.touch && {
    marginLeft: "24px"
  }) : N({
    marginRight: "14px"
  }, t.touch && {
    marginRight: "24px"
  })),
  [`.${td.popper}[data-popper-placement*="right"] &`]: N({
    transformOrigin: "left center"
  }, t.isRtl ? N({
    marginRight: "14px"
  }, t.touch && {
    marginRight: "24px"
  }) : N({
    marginLeft: "14px"
  }, t.touch && {
    marginLeft: "24px"
  })),
  [`.${td.popper}[data-popper-placement*="top"] &`]: N({
    transformOrigin: "center bottom",
    marginBottom: "14px"
  }, t.touch && {
    marginBottom: "24px"
  }),
  [`.${td.popper}[data-popper-placement*="bottom"] &`]: N({
    transformOrigin: "center top",
    marginTop: "14px"
  }, t.touch && {
    marginTop: "24px"
  })
})), v6e = De("span", {
  name: "MuiTooltip",
  slot: "Arrow",
  overridesResolver: (e, t) => t.arrow
})(({
  theme: e
}) => ({
  overflow: "hidden",
  position: "absolute",
  width: "1em",
  height: "0.71em",
  boxSizing: "border-box",
  color: e.vars ? e.vars.palette.Tooltip.bg : Yt(e.palette.grey[700], 0.9),
  "&::before": {
    content: '""',
    margin: "auto",
    display: "block",
    width: "100%",
    height: "100%",
    backgroundColor: "currentColor",
    transform: "rotate(45deg)"
  }
}));
let Y1 = !1;
const W3 = new zb();
let ky = {
  x: 0,
  y: 0
};
function K1(e, t) {
  return (n, ...r) => {
    t && t(n, ...r), e(n, ...r);
  };
}
const io = /* @__PURE__ */ V.forwardRef(function(t, n) {
  var r, i, o, s, a, u, c, d, f, h, m, v, x, C, E, S, w, O, A;
  const I = Ot({
    props: t,
    name: "MuiTooltip"
  }), {
    arrow: $ = !1,
    children: L,
    components: B = {},
    componentsProps: H = {},
    describeChild: q = !1,
    disableFocusListener: J = !1,
    disableHoverListener: X = !1,
    disableInteractive: j = !1,
    disableTouchListener: U = !1,
    enterDelay: G = 100,
    enterNextDelay: K = 0,
    enterTouchDelay: ee = 700,
    followCursor: te = !1,
    id: M,
    leaveDelay: Z = 0,
    leaveTouchDelay: ne = 1500,
    onClose: R,
    onOpen: _,
    open: W,
    placement: Q = "bottom",
    PopperComponent: oe,
    PopperProps: ae = {},
    slotProps: pe = {},
    slots: me = {},
    title: xe,
    TransitionComponent: le = ym,
    TransitionProps: ye
  } = I, be = _e(I, h6e), Re = /* @__PURE__ */ V.isValidElement(L) ? L : /* @__PURE__ */ P.jsx("span", {
    children: L
  }), Te = Gi(), Xe = Wb(), [Ne, Qe] = V.useState(), [Ee, Ie] = V.useState(null), Je = V.useRef(!1), vt = j || te, St = Pp(), Lt = Pp(), ke = Pp(), Le = Pp(), [Pe, Ae] = Hi({
    controlled: W,
    default: !1,
    name: "Tooltip",
    state: "open"
  });
  let We = Pe;
  if (process.env.NODE_ENV !== "production") {
    const {
      current: gt
    } = V.useRef(W !== void 0);
    V.useEffect(() => {
      Ne && Ne.disabled && !gt && xe !== "" && Ne.tagName.toLowerCase() === "button" && console.error(["MUI: You are providing a disabled `button` child to the Tooltip component.", "A disabled element does not fire events.", "Tooltip needs to listen to the child element's events to display the title.", "", "Add a simple wrapper element, such as a `span`."].join(`
`));
    }, [xe, Ne, gt]);
  }
  const At = Pl(M), Ft = V.useRef(), Ct = Mt(() => {
    Ft.current !== void 0 && (document.body.style.WebkitUserSelect = Ft.current, Ft.current = void 0), Le.clear();
  });
  V.useEffect(() => Ct, [Ct]);
  const ht = (gt) => {
    W3.clear(), Y1 = !0, Ae(!0), _ && !We && _(gt);
  }, He = Mt(
    /**
     * @param {React.SyntheticEvent | Event} event
     */
    (gt) => {
      W3.start(800 + Z, () => {
        Y1 = !1;
      }), Ae(!1), R && We && R(gt), St.start(Te.transitions.duration.shortest, () => {
        Je.current = !1;
      });
    }
  ), qe = (gt) => {
    Je.current && gt.type !== "touchstart" || (Ne && Ne.removeAttribute("title"), Lt.clear(), ke.clear(), G || Y1 && K ? Lt.start(Y1 ? K : G, () => {
      ht(gt);
    }) : ht(gt));
  }, wt = (gt) => {
    Lt.clear(), ke.start(Z, () => {
      He(gt);
    });
  }, {
    isFocusVisibleRef: Ut,
    onBlur: an,
    onFocus: wn,
    ref: En
  } = OE(), [, sr] = V.useState(!1), er = (gt) => {
    an(gt), Ut.current === !1 && (sr(!1), wt(gt));
  }, pn = (gt) => {
    Ne || Qe(gt.currentTarget), wn(gt), Ut.current === !0 && (sr(!0), qe(gt));
  }, Pr = (gt) => {
    Je.current = !0;
    const Ht = Re.props;
    Ht.onTouchStart && Ht.onTouchStart(gt);
  }, bi = (gt) => {
    Pr(gt), ke.clear(), St.clear(), Ct(), Ft.current = document.body.style.WebkitUserSelect, document.body.style.WebkitUserSelect = "none", Le.start(ee, () => {
      document.body.style.WebkitUserSelect = Ft.current, qe(gt);
    });
  }, Wr = (gt) => {
    Re.props.onTouchEnd && Re.props.onTouchEnd(gt), Ct(), ke.start(ne, () => {
      He(gt);
    });
  };
  V.useEffect(() => {
    if (!We)
      return;
    function gt(Ht) {
      (Ht.key === "Escape" || Ht.key === "Esc") && He(Ht);
    }
    return document.addEventListener("keydown", gt), () => {
      document.removeEventListener("keydown", gt);
    };
  }, [He, We]);
  const Po = Hn(Re.ref, En, Qe, n);
  !xe && xe !== 0 && (We = !1);
  const _r = V.useRef(), Lr = (gt) => {
    const Ht = Re.props;
    Ht.onMouseMove && Ht.onMouseMove(gt), ky = {
      x: gt.clientX,
      y: gt.clientY
    }, _r.current && _r.current.update();
  }, Gn = {}, Hr = typeof xe == "string";
  q ? (Gn.title = !We && Hr && !X ? xe : null, Gn["aria-describedby"] = We ? At : null) : (Gn["aria-label"] = Hr ? xe : null, Gn["aria-labelledby"] = We && !Hr ? At : null);
  const Qn = N({}, Gn, be, Re.props, {
    className: Be(be.className, Re.props.className),
    onTouchStart: Pr,
    ref: Po
  }, te ? {
    onMouseMove: Lr
  } : {});
  process.env.NODE_ENV !== "production" && (Qn["data-mui-internal-clone-element"] = !0, V.useEffect(() => {
    Ne && !Ne.getAttribute("data-mui-internal-clone-element") && console.error(["MUI: The `children` component of the Tooltip is not forwarding its props correctly.", "Please make sure that props are spread on the same element that the ref is applied to."].join(`
`));
  }, [Ne]));
  const ao = {};
  U || (Qn.onTouchStart = bi, Qn.onTouchEnd = Wr), X || (Qn.onMouseOver = K1(qe, Qn.onMouseOver), Qn.onMouseLeave = K1(wt, Qn.onMouseLeave), vt || (ao.onMouseOver = qe, ao.onMouseLeave = wt)), J || (Qn.onFocus = K1(pn, Qn.onFocus), Qn.onBlur = K1(er, Qn.onBlur), vt || (ao.onFocus = pn, ao.onBlur = er)), process.env.NODE_ENV !== "production" && Re.props.title && console.error(["MUI: You have provided a `title` prop to the child of <Tooltip />.", `Remove this title prop \`${Re.props.title}\` or the Tooltip component.`].join(`
`));
  const Ls = V.useMemo(() => {
    var gt;
    let Ht = [{
      name: "arrow",
      enabled: !!Ee,
      options: {
        element: Ee,
        padding: 4
      }
    }];
    return (gt = ae.popperOptions) != null && gt.modifiers && (Ht = Ht.concat(ae.popperOptions.modifiers)), N({}, ae.popperOptions, {
      modifiers: Ht
    });
  }, [Ee, ae]), Mi = N({}, I, {
    isRtl: Xe,
    arrow: $,
    disableInteractive: vt,
    placement: Q,
    PopperComponentProp: oe,
    touch: Je.current
  }), ko = g6e(Mi), ve = (r = (i = me.popper) != null ? i : B.Popper) != null ? r : y6e, tt = (o = (s = (a = me.transition) != null ? a : B.Transition) != null ? s : le) != null ? o : ym, xt = (u = (c = me.tooltip) != null ? c : B.Tooltip) != null ? u : b6e, Oe = (d = (f = me.arrow) != null ? f : B.Arrow) != null ? d : v6e, Fe = Nh(ve, N({}, ae, (h = pe.popper) != null ? h : H.popper, {
    className: Be(ko.popper, ae == null ? void 0 : ae.className, (m = (v = pe.popper) != null ? v : H.popper) == null ? void 0 : m.className)
  }), Mi), et = Nh(tt, N({}, ye, (x = pe.transition) != null ? x : H.transition), Mi), Ke = Nh(xt, N({}, (C = pe.tooltip) != null ? C : H.tooltip, {
    className: Be(ko.tooltip, (E = (S = pe.tooltip) != null ? S : H.tooltip) == null ? void 0 : E.className)
  }), Mi), ct = Nh(Oe, N({}, (w = pe.arrow) != null ? w : H.arrow, {
    className: Be(ko.arrow, (O = (A = pe.arrow) != null ? A : H.arrow) == null ? void 0 : O.className)
  }), Mi);
  return /* @__PURE__ */ P.jsxs(V.Fragment, {
    children: [/* @__PURE__ */ V.cloneElement(Re, Qn), /* @__PURE__ */ P.jsx(ve, N({
      as: oe ?? ag,
      placement: Q,
      anchorEl: te ? {
        getBoundingClientRect: () => ({
          top: ky.y,
          left: ky.x,
          right: ky.x,
          bottom: ky.y,
          width: 0,
          height: 0
        })
      } : Ne,
      popperRef: _r,
      open: Ne ? We : !1,
      id: At,
      transition: !0
    }, ao, Fe, {
      popperOptions: Ls,
      children: ({
        TransitionProps: gt
      }) => /* @__PURE__ */ P.jsx(tt, N({
        timeout: Te.transitions.duration.shorter
      }, gt, et, {
        children: /* @__PURE__ */ P.jsxs(xt, N({}, Ke, {
          children: [xe, $ ? /* @__PURE__ */ P.jsx(Oe, N({}, ct, {
            ref: Ie
          })) : null]
        }))
      }))
    }))]
  });
});
process.env.NODE_ENV !== "production" && (io.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, adds an arrow to the tooltip.
   * @default false
   */
  arrow: l.bool,
  /**
   * Tooltip reference element.
   */
  children: ig.isRequired,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `slots` prop.
   * It's recommended to use the `slots` prop instead.
   *
   * @default {}
   */
  components: l.shape({
    Arrow: l.elementType,
    Popper: l.elementType,
    Tooltip: l.elementType,
    Transition: l.elementType
  }),
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `slotProps` prop.
   * It's recommended to use the `slotProps` prop instead, as `componentsProps` will be deprecated in the future.
   *
   * @default {}
   */
  componentsProps: l.shape({
    arrow: l.object,
    popper: l.object,
    tooltip: l.object,
    transition: l.object
  }),
  /**
   * Set to `true` if the `title` acts as an accessible description.
   * By default the `title` acts as an accessible label for the child.
   * @default false
   */
  describeChild: l.bool,
  /**
   * Do not respond to focus-visible events.
   * @default false
   */
  disableFocusListener: l.bool,
  /**
   * Do not respond to hover events.
   * @default false
   */
  disableHoverListener: l.bool,
  /**
   * Makes a tooltip not interactive, i.e. it will close when the user
   * hovers over the tooltip before the `leaveDelay` is expired.
   * @default false
   */
  disableInteractive: l.bool,
  /**
   * Do not respond to long press touch events.
   * @default false
   */
  disableTouchListener: l.bool,
  /**
   * The number of milliseconds to wait before showing the tooltip.
   * This prop won't impact the enter touch delay (`enterTouchDelay`).
   * @default 100
   */
  enterDelay: l.number,
  /**
   * The number of milliseconds to wait before showing the tooltip when one was already recently opened.
   * @default 0
   */
  enterNextDelay: l.number,
  /**
   * The number of milliseconds a user must touch the element before showing the tooltip.
   * @default 700
   */
  enterTouchDelay: l.number,
  /**
   * If `true`, the tooltip follow the cursor over the wrapped element.
   * @default false
   */
  followCursor: l.bool,
  /**
   * This prop is used to help implement the accessibility logic.
   * If you don't provide this prop. It falls back to a randomly generated id.
   */
  id: l.string,
  /**
   * The number of milliseconds to wait before hiding the tooltip.
   * This prop won't impact the leave touch delay (`leaveTouchDelay`).
   * @default 0
   */
  leaveDelay: l.number,
  /**
   * The number of milliseconds after the user stops touching an element before hiding the tooltip.
   * @default 1500
   */
  leaveTouchDelay: l.number,
  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onClose: l.func,
  /**
   * Callback fired when the component requests to be open.
   *
   * @param {React.SyntheticEvent} event The event source of the callback.
   */
  onOpen: l.func,
  /**
   * If `true`, the component is shown.
   */
  open: l.bool,
  /**
   * Tooltip placement.
   * @default 'bottom'
   */
  placement: l.oneOf(["bottom-end", "bottom-start", "bottom", "left-end", "left-start", "left", "right-end", "right-start", "right", "top-end", "top-start", "top"]),
  /**
   * The component used for the popper.
   * @default Popper
   */
  PopperComponent: l.elementType,
  /**
   * Props applied to the [`Popper`](/material-ui/api/popper/) element.
   * @default {}
   */
  PopperProps: l.object,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   *
   * This prop is an alias for the `componentsProps` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slotProps: l.shape({
    arrow: l.object,
    popper: l.object,
    tooltip: l.object,
    transition: l.object
  }),
  /**
   * The components used for each slot inside.
   *
   * This prop is an alias for the `components` prop, which will be deprecated in the future.
   *
   * @default {}
   */
  slots: l.shape({
    arrow: l.elementType,
    popper: l.elementType,
    tooltip: l.elementType,
    transition: l.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * Tooltip title. Zero-length titles string, undefined, null and false are never displayed.
   */
  title: l.node,
  /**
   * The component used for the transition.
   * [Follow this guide](/material-ui/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
   * @default Grow
   */
  TransitionComponent: l.elementType,
  /**
   * Props applied to the transition element.
   * By default, the element is based on this [`Transition`](https://reactcommunity.org/react-transition-group/transition/) component.
   */
  TransitionProps: l.object
});
const ug = /* @__PURE__ */ V.createContext({});
process.env.NODE_ENV !== "production" && (ug.displayName = "StepperContext");
const av = /* @__PURE__ */ V.createContext({});
process.env.NODE_ENV !== "production" && (av.displayName = "StepContext");
function x6e(e) {
  return ot("MuiStep", e);
}
st("MuiStep", ["root", "horizontal", "vertical", "alternativeLabel", "completed"]);
const D6e = ["active", "children", "className", "component", "completed", "disabled", "expanded", "index", "last"], C6e = (e) => {
  const {
    classes: t,
    orientation: n,
    alternativeLabel: r,
    completed: i
  } = e;
  return at({
    root: ["root", n, r && "alternativeLabel", i && "completed"]
  }, x6e, t);
}, E6e = De("div", {
  name: "MuiStep",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.orientation], n.alternativeLabel && t.alternativeLabel, n.completed && t.completed];
  }
})(({
  ownerState: e
}) => N({}, e.orientation === "horizontal" && {
  paddingLeft: 8,
  paddingRight: 8
}, e.alternativeLabel && {
  flex: 1,
  position: "relative"
})), iW = /* @__PURE__ */ V.forwardRef(function(t, n) {
  const r = Ot({
    props: t,
    name: "MuiStep"
  }), {
    active: i,
    children: o,
    className: s,
    component: a = "div",
    completed: u,
    disabled: c,
    expanded: d = !1,
    index: f,
    last: h
  } = r, m = _e(r, D6e), {
    activeStep: v,
    connector: x,
    alternativeLabel: C,
    orientation: E,
    nonLinear: S
  } = V.useContext(ug);
  let [w = !1, O = !1, A = !1] = [i, u, c];
  v === f ? w = i !== void 0 ? i : !0 : !S && v > f ? O = u !== void 0 ? u : !0 : !S && v < f && (A = c !== void 0 ? c : !0);
  const I = V.useMemo(() => ({
    index: f,
    last: h,
    expanded: d,
    icon: f + 1,
    active: w,
    completed: O,
    disabled: A
  }), [f, h, d, w, O, A]), $ = N({}, r, {
    active: w,
    orientation: E,
    alternativeLabel: C,
    completed: O,
    disabled: A,
    expanded: d,
    component: a
  }), L = C6e($), B = /* @__PURE__ */ P.jsxs(E6e, N({
    as: a,
    className: Be(L.root, s),
    ref: n,
    ownerState: $
  }, m, {
    children: [x && C && f !== 0 ? x : null, o]
  }));
  return /* @__PURE__ */ P.jsx(av.Provider, {
    value: I,
    children: x && !C && f !== 0 ? /* @__PURE__ */ P.jsxs(V.Fragment, {
      children: [x, B]
    }) : B
  });
});
process.env.NODE_ENV !== "production" && (iW.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Sets the step as active. Is passed to child components.
   */
  active: l.bool,
  /**
   * Should be `Step` sub-components such as `StepLabel`, `StepContent`.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * Mark the step as completed. Is passed to child components.
   */
  completed: l.bool,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * If `true`, the step is disabled, will also disable the button if
   * `StepButton` is a child of `Step`. Is passed to child components.
   */
  disabled: l.bool,
  /**
   * Expand the step.
   * @default false
   */
  expanded: l.bool,
  /**
   * The position of the step.
   * The prop defaults to the value inherited from the parent Stepper component.
   */
  index: Ub,
  /**
   * If `true`, the Step is displayed as rendered last.
   * The prop defaults to the value inherited from the parent Stepper component.
   */
  last: l.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
const T6e = Rr(/* @__PURE__ */ P.jsx("path", {
  d: "M12 0a12 12 0 1 0 0 24 12 12 0 0 0 0-24zm-2 17l-5-5 1.4-1.4 3.6 3.6 7.6-7.6L19 8l-9 9z"
}), "CheckCircle"), S6e = Rr(/* @__PURE__ */ P.jsx("path", {
  d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
}), "Warning");
function A6e(e) {
  return ot("MuiStepIcon", e);
}
const ZA = st("MuiStepIcon", ["root", "active", "completed", "error", "text"]);
var H3;
const w6e = ["active", "className", "completed", "error", "icon"], P6e = (e) => {
  const {
    classes: t,
    active: n,
    completed: r,
    error: i
  } = e;
  return at({
    root: ["root", n && "active", r && "completed", i && "error"],
    text: ["text"]
  }, A6e, t);
}, ew = De(L0, {
  name: "MuiStepIcon",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e
}) => ({
  display: "block",
  transition: e.transitions.create("color", {
    duration: e.transitions.duration.shortest
  }),
  color: (e.vars || e).palette.text.disabled,
  [`&.${ZA.completed}`]: {
    color: (e.vars || e).palette.primary.main
  },
  [`&.${ZA.active}`]: {
    color: (e.vars || e).palette.primary.main
  },
  [`&.${ZA.error}`]: {
    color: (e.vars || e).palette.error.main
  }
})), k6e = De("text", {
  name: "MuiStepIcon",
  slot: "Text",
  overridesResolver: (e, t) => t.text
})(({
  theme: e
}) => ({
  fill: (e.vars || e).palette.primary.contrastText,
  fontSize: e.typography.caption.fontSize,
  fontFamily: e.typography.fontFamily
})), oW = /* @__PURE__ */ V.forwardRef(function(t, n) {
  const r = Ot({
    props: t,
    name: "MuiStepIcon"
  }), {
    active: i = !1,
    className: o,
    completed: s = !1,
    error: a = !1,
    icon: u
  } = r, c = _e(r, w6e), d = N({}, r, {
    active: i,
    completed: s,
    error: a
  }), f = P6e(d);
  if (typeof u == "number" || typeof u == "string") {
    const h = Be(o, f.root);
    return a ? /* @__PURE__ */ P.jsx(ew, N({
      as: S6e,
      className: h,
      ref: n,
      ownerState: d
    }, c)) : s ? /* @__PURE__ */ P.jsx(ew, N({
      as: T6e,
      className: h,
      ref: n,
      ownerState: d
    }, c)) : /* @__PURE__ */ P.jsxs(ew, N({
      className: h,
      ref: n,
      ownerState: d
    }, c, {
      children: [H3 || (H3 = /* @__PURE__ */ P.jsx("circle", {
        cx: "12",
        cy: "12",
        r: "12"
      })), /* @__PURE__ */ P.jsx(k6e, {
        className: f.text,
        x: "12",
        y: "12",
        textAnchor: "middle",
        dominantBaseline: "central",
        ownerState: d,
        children: u
      })]
    }));
  }
  return u;
});
process.env.NODE_ENV !== "production" && (oW.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Whether this step is active.
   * @default false
   */
  active: l.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * Mark the step as completed. Is passed to child components.
   * @default false
   */
  completed: l.bool,
  /**
   * If `true`, the step is marked as failed.
   * @default false
   */
  error: l.bool,
  /**
   * The label displayed in the step icon.
   */
  icon: l.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
function O6e(e) {
  return ot("MuiStepLabel", e);
}
const nd = st("MuiStepLabel", ["root", "horizontal", "vertical", "label", "active", "completed", "error", "disabled", "iconContainer", "alternativeLabel", "labelContainer"]), I6e = ["children", "className", "componentsProps", "error", "icon", "optional", "slotProps", "StepIconComponent", "StepIconProps"], F6e = (e) => {
  const {
    classes: t,
    orientation: n,
    active: r,
    completed: i,
    error: o,
    disabled: s,
    alternativeLabel: a
  } = e;
  return at({
    root: ["root", n, o && "error", s && "disabled", a && "alternativeLabel"],
    label: ["label", r && "active", i && "completed", o && "error", s && "disabled", a && "alternativeLabel"],
    iconContainer: ["iconContainer", r && "active", i && "completed", o && "error", s && "disabled", a && "alternativeLabel"],
    labelContainer: ["labelContainer", a && "alternativeLabel"]
  }, O6e, t);
}, $6e = De("span", {
  name: "MuiStepLabel",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.orientation]];
  }
})(({
  ownerState: e
}) => N({
  display: "flex",
  alignItems: "center",
  [`&.${nd.alternativeLabel}`]: {
    flexDirection: "column"
  },
  [`&.${nd.disabled}`]: {
    cursor: "default"
  }
}, e.orientation === "vertical" && {
  textAlign: "left",
  padding: "8px 0"
})), N6e = De("span", {
  name: "MuiStepLabel",
  slot: "Label",
  overridesResolver: (e, t) => t.label
})(({
  theme: e
}) => N({}, e.typography.body2, {
  display: "block",
  transition: e.transitions.create("color", {
    duration: e.transitions.duration.shortest
  }),
  [`&.${nd.active}`]: {
    color: (e.vars || e).palette.text.primary,
    fontWeight: 500
  },
  [`&.${nd.completed}`]: {
    color: (e.vars || e).palette.text.primary,
    fontWeight: 500
  },
  [`&.${nd.alternativeLabel}`]: {
    marginTop: 16
  },
  [`&.${nd.error}`]: {
    color: (e.vars || e).palette.error.main
  }
})), M6e = De("span", {
  name: "MuiStepLabel",
  slot: "IconContainer",
  overridesResolver: (e, t) => t.iconContainer
})(() => ({
  flexShrink: 0,
  // Fix IE11 issue
  display: "flex",
  paddingRight: 8,
  [`&.${nd.alternativeLabel}`]: {
    paddingRight: 0
  }
})), R6e = De("span", {
  name: "MuiStepLabel",
  slot: "LabelContainer",
  overridesResolver: (e, t) => t.labelContainer
})(({
  theme: e
}) => ({
  width: "100%",
  color: (e.vars || e).palette.text.secondary,
  [`&.${nd.alternativeLabel}`]: {
    textAlign: "center"
  }
})), OF = /* @__PURE__ */ V.forwardRef(function(t, n) {
  var r;
  const i = Ot({
    props: t,
    name: "MuiStepLabel"
  }), {
    children: o,
    className: s,
    componentsProps: a = {},
    error: u = !1,
    icon: c,
    optional: d,
    slotProps: f = {},
    StepIconComponent: h,
    StepIconProps: m
  } = i, v = _e(i, I6e), {
    alternativeLabel: x,
    orientation: C
  } = V.useContext(ug), {
    active: E,
    disabled: S,
    completed: w,
    icon: O
  } = V.useContext(av), A = c || O;
  let I = h;
  A && !I && (I = oW);
  const $ = N({}, i, {
    active: E,
    alternativeLabel: x,
    completed: w,
    disabled: S,
    error: u,
    orientation: C
  }), L = F6e($), B = (r = f.label) != null ? r : a.label;
  return /* @__PURE__ */ P.jsxs($6e, N({
    className: Be(L.root, s),
    ref: n,
    ownerState: $
  }, v, {
    children: [A || I ? /* @__PURE__ */ P.jsx(M6e, {
      className: L.iconContainer,
      ownerState: $,
      children: /* @__PURE__ */ P.jsx(I, N({
        completed: w,
        active: E,
        error: u,
        icon: A
      }, m))
    }) : null, /* @__PURE__ */ P.jsxs(R6e, {
      className: L.labelContainer,
      ownerState: $,
      children: [o ? /* @__PURE__ */ P.jsx(N6e, N({
        ownerState: $
      }, B, {
        className: Be(L.label, B == null ? void 0 : B.className),
        children: o
      })) : null, d]
    })]
  }));
});
process.env.NODE_ENV !== "production" && (OF.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * In most cases will simply be a string containing a title for the label.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  componentsProps: l.shape({
    label: l.object
  }),
  /**
   * If `true`, the step is marked as failed.
   * @default false
   */
  error: l.bool,
  /**
   * Override the default label of the step icon.
   */
  icon: l.node,
  /**
   * The optional node to display.
   */
  optional: l.node,
  /**
   * The props used for each slot inside.
   * @default {}
   */
  slotProps: l.shape({
    label: l.object
  }),
  /**
   * The component to render in place of the [`StepIcon`](/material-ui/api/step-icon/).
   */
  StepIconComponent: l.elementType,
  /**
   * Props applied to the [`StepIcon`](/material-ui/api/step-icon/) element.
   */
  StepIconProps: l.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
OF.muiName = "StepLabel";
function _6e(e) {
  return ot("MuiStepButton", e);
}
const q3 = st("MuiStepButton", ["root", "horizontal", "vertical", "touchRipple"]), L6e = ["children", "className", "icon", "optional"], B6e = (e) => {
  const {
    classes: t,
    orientation: n
  } = e;
  return at({
    root: ["root", n],
    touchRipple: ["touchRipple"]
  }, _6e, t);
}, j6e = De(sa, {
  name: "MuiStepButton",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [{
      [`& .${q3.touchRipple}`]: t.touchRipple
    }, t.root, t[n.orientation]];
  }
})(({
  ownerState: e
}) => N({
  width: "100%",
  padding: "24px 16px",
  margin: "-24px -16px",
  boxSizing: "content-box"
}, e.orientation === "vertical" && {
  justifyContent: "flex-start",
  padding: "8px",
  margin: "-8px"
}, {
  [`& .${q3.touchRipple}`]: {
    color: "rgba(0, 0, 0, 0.3)"
  }
})), sW = /* @__PURE__ */ V.forwardRef(function(t, n) {
  const r = Ot({
    props: t,
    name: "MuiStepButton"
  }), {
    children: i,
    className: o,
    icon: s,
    optional: a
  } = r, u = _e(r, L6e), {
    disabled: c,
    active: d
  } = V.useContext(av), {
    orientation: f
  } = V.useContext(ug), h = N({}, r, {
    orientation: f
  }), m = B6e(h), v = {
    icon: s,
    optional: a
  }, x = _p(i, ["StepLabel"]) ? /* @__PURE__ */ V.cloneElement(i, v) : /* @__PURE__ */ P.jsx(OF, N({}, v, {
    children: i
  }));
  return /* @__PURE__ */ P.jsx(j6e, N({
    focusRipple: !0,
    disabled: c,
    TouchRippleProps: {
      className: m.touchRipple
    },
    className: Be(m.root, o),
    ref: n,
    ownerState: h,
    "aria-current": d ? "step" : void 0
  }, u, {
    children: x
  }));
});
process.env.NODE_ENV !== "production" && (sW.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Can be a `StepLabel` or a node to place inside `StepLabel` as children.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The icon displayed by the step label.
   */
  icon: l.node,
  /**
   * The optional node to display.
   */
  optional: l.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
function V6e(e) {
  return ot("MuiStepConnector", e);
}
st("MuiStepConnector", ["root", "horizontal", "vertical", "alternativeLabel", "active", "completed", "disabled", "line", "lineHorizontal", "lineVertical"]);
const z6e = ["className"], U6e = (e) => {
  const {
    classes: t,
    orientation: n,
    alternativeLabel: r,
    active: i,
    completed: o,
    disabled: s
  } = e, a = {
    root: ["root", n, r && "alternativeLabel", i && "active", o && "completed", s && "disabled"],
    line: ["line", `line${Ue(n)}`]
  };
  return at(a, V6e, t);
}, W6e = De("div", {
  name: "MuiStepConnector",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.orientation], n.alternativeLabel && t.alternativeLabel, n.completed && t.completed];
  }
})(({
  ownerState: e
}) => N({
  flex: "1 1 auto"
}, e.orientation === "vertical" && {
  marginLeft: 12
  // half icon
}, e.alternativeLabel && {
  position: "absolute",
  top: 12,
  left: "calc(-50% + 20px)",
  right: "calc(50% + 20px)"
})), H6e = De("span", {
  name: "MuiStepConnector",
  slot: "Line",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.line, t[`line${Ue(n.orientation)}`]];
  }
})(({
  ownerState: e,
  theme: t
}) => {
  const n = t.palette.mode === "light" ? t.palette.grey[400] : t.palette.grey[600];
  return N({
    display: "block",
    borderColor: t.vars ? t.vars.palette.StepConnector.border : n
  }, e.orientation === "horizontal" && {
    borderTopStyle: "solid",
    borderTopWidth: 1
  }, e.orientation === "vertical" && {
    borderLeftStyle: "solid",
    borderLeftWidth: 1,
    minHeight: 24
  });
}), aW = /* @__PURE__ */ V.forwardRef(function(t, n) {
  const r = Ot({
    props: t,
    name: "MuiStepConnector"
  }), {
    className: i
  } = r, o = _e(r, z6e), {
    alternativeLabel: s,
    orientation: a = "horizontal"
  } = V.useContext(ug), {
    active: u,
    disabled: c,
    completed: d
  } = V.useContext(av), f = N({}, r, {
    alternativeLabel: s,
    orientation: a,
    active: u,
    completed: d,
    disabled: c
  }), h = U6e(f);
  return /* @__PURE__ */ P.jsx(W6e, N({
    className: Be(h.root, i),
    ref: n,
    ownerState: f
  }, o, {
    children: /* @__PURE__ */ P.jsx(H6e, {
      className: h.line,
      ownerState: f
    })
  }));
});
process.env.NODE_ENV !== "production" && (aW.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
function q6e(e) {
  return ot("MuiStepper", e);
}
st("MuiStepper", ["root", "horizontal", "vertical", "nonLinear", "alternativeLabel"]);
const G6e = ["activeStep", "alternativeLabel", "children", "className", "component", "connector", "nonLinear", "orientation"], Y6e = (e) => {
  const {
    orientation: t,
    nonLinear: n,
    alternativeLabel: r,
    classes: i
  } = e;
  return at({
    root: ["root", t, n && "nonLinear", r && "alternativeLabel"]
  }, q6e, i);
}, K6e = De("div", {
  name: "MuiStepper",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.orientation], n.alternativeLabel && t.alternativeLabel, n.nonLinear && t.nonLinear];
  }
})(({
  ownerState: e
}) => N({
  display: "flex"
}, e.orientation === "horizontal" && {
  flexDirection: "row",
  alignItems: "center"
}, e.orientation === "vertical" && {
  flexDirection: "column"
}, e.alternativeLabel && {
  alignItems: "flex-start"
})), J6e = /* @__PURE__ */ P.jsx(aW, {}), lW = /* @__PURE__ */ V.forwardRef(function(t, n) {
  const r = Ot({
    props: t,
    name: "MuiStepper"
  }), {
    activeStep: i = 0,
    alternativeLabel: o = !1,
    children: s,
    className: a,
    component: u = "div",
    connector: c = J6e,
    nonLinear: d = !1,
    orientation: f = "horizontal"
  } = r, h = _e(r, G6e), m = N({}, r, {
    nonLinear: d,
    alternativeLabel: o,
    orientation: f,
    component: u
  }), v = Y6e(m), x = V.Children.toArray(s).filter(Boolean), C = x.map((S, w) => /* @__PURE__ */ V.cloneElement(S, N({
    index: w,
    last: w + 1 === x.length
  }, S.props))), E = V.useMemo(() => ({
    activeStep: i,
    alternativeLabel: o,
    connector: c,
    nonLinear: d,
    orientation: f
  }), [i, o, c, d, f]);
  return /* @__PURE__ */ P.jsx(ug.Provider, {
    value: E,
    children: /* @__PURE__ */ P.jsx(K6e, N({
      as: u,
      ownerState: m,
      className: Be(v.root, a),
      ref: n
    }, h, {
      children: C
    }))
  });
});
process.env.NODE_ENV !== "production" && (lW.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Set the active step (zero based index).
   * Set to -1 to disable all the steps.
   * @default 0
   */
  activeStep: Ub,
  /**
   * If set to 'true' and orientation is horizontal,
   * then the step label will be positioned under the icon.
   * @default false
   */
  alternativeLabel: l.bool,
  /**
   * Two or more `<Step />` components.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * An element to be placed between each step.
   * @default <StepConnector />
   */
  connector: l.element,
  /**
   * If set the `Stepper` will not assist in controlling steps for linear flow.
   * @default false
   */
  nonLinear: l.bool,
  /**
   * The component orientation (layout flow direction).
   * @default 'horizontal'
   */
  orientation: l.oneOf(["horizontal", "vertical"]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
function X6e(e) {
  return ot("MuiSwitch", e);
}
const Jo = st("MuiSwitch", ["root", "edgeStart", "edgeEnd", "switchBase", "colorPrimary", "colorSecondary", "sizeSmall", "sizeMedium", "checked", "disabled", "input", "thumb", "track"]), Q6e = ["className", "color", "edge", "size", "sx"], Z6e = (e) => {
  const {
    classes: t,
    edge: n,
    size: r,
    color: i,
    checked: o,
    disabled: s
  } = e, a = {
    root: ["root", n && `edge${Ue(n)}`, `size${Ue(r)}`],
    switchBase: ["switchBase", `color${Ue(i)}`, o && "checked", s && "disabled"],
    thumb: ["thumb"],
    track: ["track"],
    input: ["input"]
  }, u = at(a, X6e, t);
  return N({}, t, u);
}, e9e = De("span", {
  name: "MuiSwitch",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.edge && t[`edge${Ue(n.edge)}`], t[`size${Ue(n.size)}`]];
  }
})({
  display: "inline-flex",
  width: 34 + 12 * 2,
  height: 14 + 12 * 2,
  overflow: "hidden",
  padding: 12,
  boxSizing: "border-box",
  position: "relative",
  flexShrink: 0,
  zIndex: 0,
  // Reset the stacking context.
  verticalAlign: "middle",
  // For correct alignment with the text.
  "@media print": {
    colorAdjust: "exact"
  },
  variants: [{
    props: {
      edge: "start"
    },
    style: {
      marginLeft: -8
    }
  }, {
    props: {
      edge: "end"
    },
    style: {
      marginRight: -8
    }
  }, {
    props: {
      size: "small"
    },
    style: {
      width: 40,
      height: 24,
      padding: 7,
      [`& .${Jo.thumb}`]: {
        width: 16,
        height: 16
      },
      [`& .${Jo.switchBase}`]: {
        padding: 4,
        [`&.${Jo.checked}`]: {
          transform: "translateX(16px)"
        }
      }
    }
  }]
}), t9e = De(VE, {
  name: "MuiSwitch",
  slot: "SwitchBase",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.switchBase, {
      [`& .${Jo.input}`]: t.input
    }, n.color !== "default" && t[`color${Ue(n.color)}`]];
  }
})(({
  theme: e
}) => ({
  position: "absolute",
  top: 0,
  left: 0,
  zIndex: 1,
  // Render above the focus ripple.
  color: e.vars ? e.vars.palette.Switch.defaultColor : `${e.palette.mode === "light" ? e.palette.common.white : e.palette.grey[300]}`,
  transition: e.transitions.create(["left", "transform"], {
    duration: e.transitions.duration.shortest
  }),
  [`&.${Jo.checked}`]: {
    transform: "translateX(20px)"
  },
  [`&.${Jo.disabled}`]: {
    color: e.vars ? e.vars.palette.Switch.defaultDisabledColor : `${e.palette.mode === "light" ? e.palette.grey[100] : e.palette.grey[600]}`
  },
  [`&.${Jo.checked} + .${Jo.track}`]: {
    opacity: 0.5
  },
  [`&.${Jo.disabled} + .${Jo.track}`]: {
    opacity: e.vars ? e.vars.opacity.switchTrackDisabled : `${e.palette.mode === "light" ? 0.12 : 0.2}`
  },
  [`& .${Jo.input}`]: {
    left: "-100%",
    width: "300%"
  }
}), ({
  theme: e
}) => ({
  "&:hover": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.hoverOpacity})` : Yt(e.palette.action.active, e.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    "@media (hover: none)": {
      backgroundColor: "transparent"
    }
  },
  variants: [...Object.entries(e.palette).filter(([, t]) => t.main && t.light).map(([t]) => ({
    props: {
      color: t
    },
    style: {
      [`&.${Jo.checked}`]: {
        color: (e.vars || e).palette[t].main,
        "&:hover": {
          backgroundColor: e.vars ? `rgba(${e.vars.palette[t].mainChannel} / ${e.vars.palette.action.hoverOpacity})` : Yt(e.palette[t].main, e.palette.action.hoverOpacity),
          "@media (hover: none)": {
            backgroundColor: "transparent"
          }
        },
        [`&.${Jo.disabled}`]: {
          color: e.vars ? e.vars.palette.Switch[`${t}DisabledColor`] : `${e.palette.mode === "light" ? Kp(e.palette[t].main, 0.62) : Yp(e.palette[t].main, 0.55)}`
        }
      },
      [`&.${Jo.checked} + .${Jo.track}`]: {
        backgroundColor: (e.vars || e).palette[t].main
      }
    }
  }))]
})), n9e = De("span", {
  name: "MuiSwitch",
  slot: "Track",
  overridesResolver: (e, t) => t.track
})(({
  theme: e
}) => ({
  height: "100%",
  width: "100%",
  borderRadius: 14 / 2,
  zIndex: -1,
  transition: e.transitions.create(["opacity", "background-color"], {
    duration: e.transitions.duration.shortest
  }),
  backgroundColor: e.vars ? e.vars.palette.common.onBackground : `${e.palette.mode === "light" ? e.palette.common.black : e.palette.common.white}`,
  opacity: e.vars ? e.vars.opacity.switchTrack : `${e.palette.mode === "light" ? 0.38 : 0.3}`
})), r9e = De("span", {
  name: "MuiSwitch",
  slot: "Thumb",
  overridesResolver: (e, t) => t.thumb
})(({
  theme: e
}) => ({
  boxShadow: (e.vars || e).shadows[1],
  backgroundColor: "currentColor",
  width: 20,
  height: 20,
  borderRadius: "50%"
})), uW = /* @__PURE__ */ V.forwardRef(function(t, n) {
  const r = Ot({
    props: t,
    name: "MuiSwitch"
  }), {
    className: i,
    color: o = "primary",
    edge: s = !1,
    size: a = "medium",
    sx: u
  } = r, c = _e(r, Q6e), d = N({}, r, {
    color: o,
    edge: s,
    size: a
  }), f = Z6e(d), h = /* @__PURE__ */ P.jsx(r9e, {
    className: f.thumb,
    ownerState: d
  });
  return /* @__PURE__ */ P.jsxs(e9e, {
    className: Be(f.root, i),
    sx: u,
    ownerState: d,
    children: [/* @__PURE__ */ P.jsx(t9e, N({
      type: "checkbox",
      icon: h,
      checkedIcon: h,
      ref: n,
      ownerState: d
    }, c, {
      classes: N({}, f, {
        root: f.switchBase
      })
    })), /* @__PURE__ */ P.jsx(n9e, {
      className: f.track,
      ownerState: d
    })]
  });
});
process.env.NODE_ENV !== "production" && (uW.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * If `true`, the component is checked.
   */
  checked: l.bool,
  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: l.oneOfType([l.oneOf(["default", "primary", "secondary", "error", "info", "success", "warning"]), l.string]),
  /**
   * The default checked state. Use when the component is not controlled.
   */
  defaultChecked: l.bool,
  /**
   * If `true`, the component is disabled.
   */
  disabled: l.bool,
  /**
   * If `true`, the ripple effect is disabled.
   * @default false
   */
  disableRipple: l.bool,
  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */
  edge: l.oneOf(["end", "start", !1]),
  /**
   * The icon to display when the component is unchecked.
   */
  icon: l.node,
  /**
   * The id of the `input` element.
   */
  id: l.string,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: l.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: wr,
  /**
   * Callback fired when the state is changed.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: l.func,
  /**
   * If `true`, the `input` element is required.
   * @default false
   */
  required: l.bool,
  /**
   * The size of the component.
   * `small` is equivalent to the dense switch styling.
   * @default 'medium'
   */
  size: l.oneOfType([l.oneOf(["medium", "small"]), l.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * The value of the component. The DOM API casts this to a string.
   * The browser uses "on" as the default value.
   */
  value: l.any
});
function i9e(e) {
  return ot("MuiTab", e);
}
const Hc = st("MuiTab", ["root", "labelIcon", "textColorInherit", "textColorPrimary", "textColorSecondary", "selected", "disabled", "fullWidth", "wrapped", "iconWrapper"]), o9e = ["className", "disabled", "disableFocusRipple", "fullWidth", "icon", "iconPosition", "indicator", "label", "onChange", "onClick", "onFocus", "selected", "selectionFollowsFocus", "textColor", "value", "wrapped"], s9e = (e) => {
  const {
    classes: t,
    textColor: n,
    fullWidth: r,
    wrapped: i,
    icon: o,
    label: s,
    selected: a,
    disabled: u
  } = e, c = {
    root: ["root", o && s && "labelIcon", `textColor${Ue(n)}`, r && "fullWidth", i && "wrapped", a && "selected", u && "disabled"],
    iconWrapper: ["iconWrapper"]
  };
  return at(c, i9e, t);
}, a9e = De(sa, {
  name: "MuiTab",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.label && n.icon && t.labelIcon, t[`textColor${Ue(n.textColor)}`], n.fullWidth && t.fullWidth, n.wrapped && t.wrapped, {
      [`& .${Hc.iconWrapper}`]: t.iconWrapper
    }];
  }
})(({
  theme: e,
  ownerState: t
}) => N({}, e.typography.button, {
  maxWidth: 360,
  minWidth: 90,
  position: "relative",
  minHeight: 48,
  flexShrink: 0,
  padding: "12px 16px",
  overflow: "hidden",
  whiteSpace: "normal",
  textAlign: "center"
}, t.label && {
  flexDirection: t.iconPosition === "top" || t.iconPosition === "bottom" ? "column" : "row"
}, {
  lineHeight: 1.25
}, t.icon && t.label && {
  minHeight: 72,
  paddingTop: 9,
  paddingBottom: 9,
  [`& > .${Hc.iconWrapper}`]: N({}, t.iconPosition === "top" && {
    marginBottom: 6
  }, t.iconPosition === "bottom" && {
    marginTop: 6
  }, t.iconPosition === "start" && {
    marginRight: e.spacing(1)
  }, t.iconPosition === "end" && {
    marginLeft: e.spacing(1)
  })
}, t.textColor === "inherit" && {
  color: "inherit",
  opacity: 0.6,
  // same opacity as theme.palette.text.secondary
  [`&.${Hc.selected}`]: {
    opacity: 1
  },
  [`&.${Hc.disabled}`]: {
    opacity: (e.vars || e).palette.action.disabledOpacity
  }
}, t.textColor === "primary" && {
  color: (e.vars || e).palette.text.secondary,
  [`&.${Hc.selected}`]: {
    color: (e.vars || e).palette.primary.main
  },
  [`&.${Hc.disabled}`]: {
    color: (e.vars || e).palette.text.disabled
  }
}, t.textColor === "secondary" && {
  color: (e.vars || e).palette.text.secondary,
  [`&.${Hc.selected}`]: {
    color: (e.vars || e).palette.secondary.main
  },
  [`&.${Hc.disabled}`]: {
    color: (e.vars || e).palette.text.disabled
  }
}, t.fullWidth && {
  flexShrink: 1,
  flexGrow: 1,
  flexBasis: 0,
  maxWidth: "none"
}, t.wrapped && {
  fontSize: e.typography.pxToRem(12)
})), pd = /* @__PURE__ */ V.forwardRef(function(t, n) {
  const r = Ot({
    props: t,
    name: "MuiTab"
  }), {
    className: i,
    disabled: o = !1,
    disableFocusRipple: s = !1,
    // eslint-disable-next-line react/prop-types
    fullWidth: a,
    icon: u,
    iconPosition: c = "top",
    // eslint-disable-next-line react/prop-types
    indicator: d,
    label: f,
    onChange: h,
    onClick: m,
    onFocus: v,
    // eslint-disable-next-line react/prop-types
    selected: x,
    // eslint-disable-next-line react/prop-types
    selectionFollowsFocus: C,
    // eslint-disable-next-line react/prop-types
    textColor: E = "inherit",
    value: S,
    wrapped: w = !1
  } = r, O = _e(r, o9e), A = N({}, r, {
    disabled: o,
    disableFocusRipple: s,
    selected: x,
    icon: !!u,
    iconPosition: c,
    label: !!f,
    fullWidth: a,
    textColor: E,
    wrapped: w
  }), I = s9e(A), $ = u && f && /* @__PURE__ */ V.isValidElement(u) ? /* @__PURE__ */ V.cloneElement(u, {
    className: Be(I.iconWrapper, u.props.className)
  }) : u, L = (H) => {
    !x && h && h(H, S), m && m(H);
  }, B = (H) => {
    C && !x && h && h(H, S), v && v(H);
  };
  return /* @__PURE__ */ P.jsxs(a9e, N({
    focusRipple: !s,
    className: Be(I.root, i),
    ref: n,
    role: "tab",
    "aria-selected": x,
    disabled: o,
    onClick: L,
    onFocus: B,
    ownerState: A,
    tabIndex: x ? 0 : -1
  }, O, {
    children: [c === "top" || c === "start" ? /* @__PURE__ */ P.jsxs(V.Fragment, {
      children: [$, f]
    }) : /* @__PURE__ */ P.jsxs(V.Fragment, {
      children: [f, $]
    }), d]
  }));
});
process.env.NODE_ENV !== "production" && (pd.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop isn't supported.
   * Use the `component` prop if you need to change the children structure.
   */
  children: WI,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: l.bool,
  /**
   * If `true`, the  keyboard focus ripple is disabled.
   * @default false
   */
  disableFocusRipple: l.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: l.bool,
  /**
   * The icon to display.
   */
  icon: l.oneOfType([l.element, l.string]),
  /**
   * The position of the icon relative to the label.
   * @default 'top'
   */
  iconPosition: l.oneOf(["bottom", "end", "start", "top"]),
  /**
   * The label element.
   */
  label: l.node,
  /**
   * @ignore
   */
  onChange: l.func,
  /**
   * @ignore
   */
  onClick: l.func,
  /**
   * @ignore
   */
  onFocus: l.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * You can provide your own value. Otherwise, we fallback to the child position index.
   */
  value: l.any,
  /**
   * Tab labels appear in a single row.
   * They can use a second line if needed.
   * @default false
   */
  wrapped: l.bool
});
const IF = /* @__PURE__ */ V.createContext();
process.env.NODE_ENV !== "production" && (IF.displayName = "TableContext");
function l9e(e) {
  return ot("MuiTable", e);
}
st("MuiTable", ["root", "stickyHeader"]);
const u9e = ["className", "component", "padding", "size", "stickyHeader"], c9e = (e) => {
  const {
    classes: t,
    stickyHeader: n
  } = e;
  return at({
    root: ["root", n && "stickyHeader"]
  }, l9e, t);
}, d9e = De("table", {
  name: "MuiTable",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.stickyHeader && t.stickyHeader];
  }
})(({
  theme: e,
  ownerState: t
}) => N({
  display: "table",
  width: "100%",
  borderCollapse: "collapse",
  borderSpacing: 0,
  "& caption": N({}, e.typography.body2, {
    padding: e.spacing(2),
    color: (e.vars || e).palette.text.secondary,
    textAlign: "left",
    captionSide: "bottom"
  })
}, t.stickyHeader && {
  borderCollapse: "separate"
})), G3 = "table", gf = /* @__PURE__ */ V.forwardRef(function(t, n) {
  const r = Ot({
    props: t,
    name: "MuiTable"
  }), {
    className: i,
    component: o = G3,
    padding: s = "normal",
    size: a = "medium",
    stickyHeader: u = !1
  } = r, c = _e(r, u9e), d = N({}, r, {
    component: o,
    padding: s,
    size: a,
    stickyHeader: u
  }), f = c9e(d), h = V.useMemo(() => ({
    padding: s,
    size: a,
    stickyHeader: u
  }), [s, a, u]);
  return /* @__PURE__ */ P.jsx(IF.Provider, {
    value: h,
    children: /* @__PURE__ */ P.jsx(d9e, N({
      as: o,
      role: o === G3 ? null : "table",
      ref: n,
      className: Be(f.root, i),
      ownerState: d
    }, c))
  });
});
process.env.NODE_ENV !== "production" && (gf.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the table, normally `TableHead` and `TableBody`.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * Allows TableCells to inherit padding of the Table.
   * @default 'normal'
   */
  padding: l.oneOf(["checkbox", "none", "normal"]),
  /**
   * Allows TableCells to inherit size of the Table.
   * @default 'medium'
   */
  size: l.oneOfType([l.oneOf(["medium", "small"]), l.string]),
  /**
   * Set the header sticky.
   *
   * ⚠️ It doesn't work with IE11.
   * @default false
   */
  stickyHeader: l.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
const cg = /* @__PURE__ */ V.createContext();
process.env.NODE_ENV !== "production" && (cg.displayName = "Tablelvl2Context");
function p9e(e) {
  return ot("MuiTableBody", e);
}
st("MuiTableBody", ["root"]);
const f9e = ["className", "component"], h9e = (e) => {
  const {
    classes: t
  } = e;
  return at({
    root: ["root"]
  }, p9e, t);
}, m9e = De("tbody", {
  name: "MuiTableBody",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "table-row-group"
}), g9e = {
  variant: "body"
}, Y3 = "tbody", yf = /* @__PURE__ */ V.forwardRef(function(t, n) {
  const r = Ot({
    props: t,
    name: "MuiTableBody"
  }), {
    className: i,
    component: o = Y3
  } = r, s = _e(r, f9e), a = N({}, r, {
    component: o
  }), u = h9e(a);
  return /* @__PURE__ */ P.jsx(cg.Provider, {
    value: g9e,
    children: /* @__PURE__ */ P.jsx(m9e, N({
      className: Be(u.root, i),
      as: o,
      ref: n,
      role: o === Y3 ? null : "rowgroup",
      ownerState: a
    }, s))
  });
});
process.env.NODE_ENV !== "production" && (yf.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally `TableRow`.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
function y9e(e) {
  return ot("MuiTableCell", e);
}
const Xp = st("MuiTableCell", ["root", "head", "body", "footer", "sizeSmall", "sizeMedium", "paddingCheckbox", "paddingNone", "alignLeft", "alignCenter", "alignRight", "alignJustify", "stickyHeader"]), b9e = ["align", "className", "component", "padding", "scope", "size", "sortDirection", "variant"], v9e = (e) => {
  const {
    classes: t,
    variant: n,
    align: r,
    padding: i,
    size: o,
    stickyHeader: s
  } = e, a = {
    root: ["root", n, s && "stickyHeader", r !== "inherit" && `align${Ue(r)}`, i !== "normal" && `padding${Ue(i)}`, `size${Ue(o)}`]
  };
  return at(a, y9e, t);
}, x9e = De("td", {
  name: "MuiTableCell",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, t[n.variant], t[`size${Ue(n.size)}`], n.padding !== "normal" && t[`padding${Ue(n.padding)}`], n.align !== "inherit" && t[`align${Ue(n.align)}`], n.stickyHeader && t.stickyHeader];
  }
})(({
  theme: e,
  ownerState: t
}) => N({}, e.typography.body2, {
  display: "table-cell",
  verticalAlign: "inherit",
  // Workaround for a rendering bug with spanned columns in Chrome 62.0.
  // Removes the alpha (sets it to 1), and lightens or darkens the theme color.
  borderBottom: e.vars ? `1px solid ${e.vars.palette.TableCell.border}` : `1px solid
    ${e.palette.mode === "light" ? Kp(Yt(e.palette.divider, 1), 0.88) : Yp(Yt(e.palette.divider, 1), 0.68)}`,
  textAlign: "left",
  padding: 16
}, t.variant === "head" && {
  color: (e.vars || e).palette.text.primary,
  lineHeight: e.typography.pxToRem(24),
  fontWeight: e.typography.fontWeightMedium
}, t.variant === "body" && {
  color: (e.vars || e).palette.text.primary
}, t.variant === "footer" && {
  color: (e.vars || e).palette.text.secondary,
  lineHeight: e.typography.pxToRem(21),
  fontSize: e.typography.pxToRem(12)
}, t.size === "small" && {
  padding: "6px 16px",
  [`&.${Xp.paddingCheckbox}`]: {
    width: 24,
    // prevent the checkbox column from growing
    padding: "0 12px 0 16px",
    "& > *": {
      padding: 0
    }
  }
}, t.padding === "checkbox" && {
  width: 48,
  // prevent the checkbox column from growing
  padding: "0 0 0 4px"
}, t.padding === "none" && {
  padding: 0
}, t.align === "left" && {
  textAlign: "left"
}, t.align === "center" && {
  textAlign: "center"
}, t.align === "right" && {
  textAlign: "right",
  flexDirection: "row-reverse"
}, t.align === "justify" && {
  textAlign: "justify"
}, t.stickyHeader && {
  position: "sticky",
  top: 0,
  zIndex: 2,
  backgroundColor: (e.vars || e).palette.background.default
})), hn = /* @__PURE__ */ V.forwardRef(function(t, n) {
  const r = Ot({
    props: t,
    name: "MuiTableCell"
  }), {
    align: i = "inherit",
    className: o,
    component: s,
    padding: a,
    scope: u,
    size: c,
    sortDirection: d,
    variant: f
  } = r, h = _e(r, b9e), m = V.useContext(IF), v = V.useContext(cg), x = v && v.variant === "head";
  let C;
  s ? C = s : C = x ? "th" : "td";
  let E = u;
  C === "td" ? E = void 0 : !E && x && (E = "col");
  const S = f || v && v.variant, w = N({}, r, {
    align: i,
    component: C,
    padding: a || (m && m.padding ? m.padding : "normal"),
    size: c || (m && m.size ? m.size : "medium"),
    sortDirection: d,
    stickyHeader: S === "head" && m && m.stickyHeader,
    variant: S
  }), O = v9e(w);
  let A = null;
  return d && (A = d === "asc" ? "ascending" : "descending"), /* @__PURE__ */ P.jsx(x9e, N({
    as: C,
    ref: n,
    className: Be(O.root, o),
    "aria-sort": A,
    scope: E,
    ownerState: w
  }, h));
});
process.env.NODE_ENV !== "production" && (hn.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Set the text-align on the table cell content.
   *
   * Monetary or generally number fields **should be right aligned** as that allows
   * you to add them up quickly in your head without having to worry about decimals.
   * @default 'inherit'
   */
  align: l.oneOf(["center", "inherit", "justify", "left", "right"]),
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * Sets the padding applied to the cell.
   * The prop defaults to the value (`'default'`) inherited from the parent Table component.
   */
  padding: l.oneOf(["checkbox", "none", "normal"]),
  /**
   * Set scope attribute.
   */
  scope: l.string,
  /**
   * Specify the size of the cell.
   * The prop defaults to the value (`'medium'`) inherited from the parent Table component.
   */
  size: l.oneOfType([l.oneOf(["medium", "small"]), l.string]),
  /**
   * Set aria-sort direction.
   */
  sortDirection: l.oneOf(["asc", "desc", !1]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * Specify the cell type.
   * The prop defaults to the value inherited from the parent TableHead, TableBody, or TableFooter components.
   */
  variant: l.oneOfType([l.oneOf(["body", "footer", "head"]), l.string])
});
function D9e(e) {
  return ot("MuiTableContainer", e);
}
st("MuiTableContainer", ["root"]);
const C9e = ["className", "component"], E9e = (e) => {
  const {
    classes: t
  } = e;
  return at({
    root: ["root"]
  }, D9e, t);
}, T9e = De("div", {
  name: "MuiTableContainer",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  width: "100%",
  overflowX: "auto"
}), dg = /* @__PURE__ */ V.forwardRef(function(t, n) {
  const r = Ot({
    props: t,
    name: "MuiTableContainer"
  }), {
    className: i,
    component: o = "div"
  } = r, s = _e(r, C9e), a = N({}, r, {
    component: o
  }), u = E9e(a);
  return /* @__PURE__ */ P.jsx(T9e, N({
    ref: n,
    as: o,
    className: Be(u.root, i),
    ownerState: a
  }, s));
});
process.env.NODE_ENV !== "production" && (dg.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally `Table`.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
function S9e(e) {
  return ot("MuiTableFooter", e);
}
st("MuiTableFooter", ["root"]);
const A9e = ["className", "component"], w9e = (e) => {
  const {
    classes: t
  } = e;
  return at({
    root: ["root"]
  }, S9e, t);
}, P9e = De("tfoot", {
  name: "MuiTableFooter",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "table-footer-group"
}), k9e = {
  variant: "footer"
}, K3 = "tfoot", cW = /* @__PURE__ */ V.forwardRef(function(t, n) {
  const r = Ot({
    props: t,
    name: "MuiTableFooter"
  }), {
    className: i,
    component: o = K3
  } = r, s = _e(r, A9e), a = N({}, r, {
    component: o
  }), u = w9e(a);
  return /* @__PURE__ */ P.jsx(cg.Provider, {
    value: k9e,
    children: /* @__PURE__ */ P.jsx(P9e, N({
      as: o,
      className: Be(u.root, i),
      ref: n,
      role: o === K3 ? null : "rowgroup",
      ownerState: a
    }, s))
  });
});
process.env.NODE_ENV !== "production" && (cW.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally `TableRow`.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
function O9e(e) {
  return ot("MuiTableHead", e);
}
st("MuiTableHead", ["root"]);
const I9e = ["className", "component"], F9e = (e) => {
  const {
    classes: t
  } = e;
  return at({
    root: ["root"]
  }, O9e, t);
}, $9e = De("thead", {
  name: "MuiTableHead",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "table-header-group"
}), N9e = {
  variant: "head"
}, J3 = "thead", bf = /* @__PURE__ */ V.forwardRef(function(t, n) {
  const r = Ot({
    props: t,
    name: "MuiTableHead"
  }), {
    className: i,
    component: o = J3
  } = r, s = _e(r, I9e), a = N({}, r, {
    component: o
  }), u = F9e(a);
  return /* @__PURE__ */ P.jsx(cg.Provider, {
    value: N9e,
    children: /* @__PURE__ */ P.jsx($9e, N({
      as: o,
      className: Be(u.root, i),
      ref: n,
      role: o === J3 ? null : "rowgroup",
      ownerState: a
    }, s))
  });
});
process.env.NODE_ENV !== "production" && (bf.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component, normally `TableRow`.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
function M9e(e) {
  return ot("MuiToolbar", e);
}
st("MuiToolbar", ["root", "gutters", "regular", "dense"]);
const R9e = ["className", "component", "disableGutters", "variant"], _9e = (e) => {
  const {
    classes: t,
    disableGutters: n,
    variant: r
  } = e;
  return at({
    root: ["root", !n && "gutters", r]
  }, M9e, t);
}, L9e = De("div", {
  name: "MuiToolbar",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, !n.disableGutters && t.gutters, t[n.variant]];
  }
})(({
  theme: e,
  ownerState: t
}) => N({
  position: "relative",
  display: "flex",
  alignItems: "center"
}, !t.disableGutters && {
  paddingLeft: e.spacing(2),
  paddingRight: e.spacing(2),
  [e.breakpoints.up("sm")]: {
    paddingLeft: e.spacing(3),
    paddingRight: e.spacing(3)
  }
}, t.variant === "dense" && {
  minHeight: 48
}), ({
  theme: e,
  ownerState: t
}) => t.variant === "regular" && e.mixins.toolbar), pg = /* @__PURE__ */ V.forwardRef(function(t, n) {
  const r = Ot({
    props: t,
    name: "MuiToolbar"
  }), {
    className: i,
    component: o = "div",
    disableGutters: s = !1,
    variant: a = "regular"
  } = r, u = _e(r, R9e), c = N({}, r, {
    component: o,
    disableGutters: s,
    variant: a
  }), d = _9e(c);
  return /* @__PURE__ */ P.jsx(L9e, N({
    as: o,
    className: Be(d.root, i),
    ref: n,
    ownerState: c
  }, u));
});
process.env.NODE_ENV !== "production" && (pg.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The Toolbar children, usually a mixture of `IconButton`, `Button` and `Typography`.
   * The Toolbar is a flex container, allowing flex item properties to be used to lay out the children.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * If `true`, disables gutter padding.
   * @default false
   */
  disableGutters: l.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * The variant to use.
   * @default 'regular'
   */
  variant: l.oneOfType([l.oneOf(["dense", "regular"]), l.string])
});
const B9e = Rr(/* @__PURE__ */ P.jsx("path", {
  d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
}), "KeyboardArrowLeft"), j9e = Rr(/* @__PURE__ */ P.jsx("path", {
  d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
}), "KeyboardArrowRight");
function V9e(e) {
  return ot("MuiTableRow", e);
}
const X3 = st("MuiTableRow", ["root", "selected", "hover", "head", "footer"]), z9e = ["className", "component", "hover", "selected"], U9e = (e) => {
  const {
    classes: t,
    selected: n,
    hover: r,
    head: i,
    footer: o
  } = e;
  return at({
    root: ["root", n && "selected", r && "hover", i && "head", o && "footer"]
  }, V9e, t);
}, W9e = De("tr", {
  name: "MuiTableRow",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.head && t.head, n.footer && t.footer];
  }
})(({
  theme: e
}) => ({
  color: "inherit",
  display: "table-row",
  verticalAlign: "middle",
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  [`&.${X3.hover}:hover`]: {
    backgroundColor: (e.vars || e).palette.action.hover
  },
  [`&.${X3.selected}`]: {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})` : Yt(e.palette.primary.main, e.palette.action.selectedOpacity),
    "&:hover": {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))` : Yt(e.palette.primary.main, e.palette.action.selectedOpacity + e.palette.action.hoverOpacity)
    }
  }
})), Q3 = "tr", _o = /* @__PURE__ */ V.forwardRef(function(t, n) {
  const r = Ot({
    props: t,
    name: "MuiTableRow"
  }), {
    className: i,
    component: o = Q3,
    hover: s = !1,
    selected: a = !1
  } = r, u = _e(r, z9e), c = V.useContext(cg), d = N({}, r, {
    component: o,
    hover: s,
    selected: a,
    head: c && c.variant === "head",
    footer: c && c.variant === "footer"
  }), f = U9e(d);
  return /* @__PURE__ */ P.jsx(W9e, N({
    as: o,
    ref: n,
    className: Be(f.root, i),
    role: o === Q3 ? null : "row",
    ownerState: d
  }, u));
});
process.env.NODE_ENV !== "production" && (_o.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Should be valid `<tr>` children such as `TableCell`.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * If `true`, the table row will shade on hover.
   * @default false
   */
  hover: l.bool,
  /**
   * If `true`, the table row will have the selected shading.
   * @default false
   */
  selected: l.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
function H9e(e) {
  return (1 + Math.sin(Math.PI * e - Math.PI / 2)) / 2;
}
function q9e(e, t, n, r = {}, i = () => {
}) {
  const {
    ease: o = H9e,
    duration: s = 300
    // standard
  } = r;
  let a = null;
  const u = t[e];
  let c = !1;
  const d = () => {
    c = !0;
  }, f = (h) => {
    if (c) {
      i(new Error("Animation cancelled"));
      return;
    }
    a === null && (a = h);
    const m = Math.min(1, (h - a) / s);
    if (t[e] = o(m) * (n - u) + u, m >= 1) {
      requestAnimationFrame(() => {
        i(null);
      });
      return;
    }
    requestAnimationFrame(f);
  };
  return u === n ? (i(new Error("Element already at target position")), d) : (requestAnimationFrame(f), d);
}
const G9e = ["onChange"], Y9e = {
  width: 99,
  height: 99,
  position: "absolute",
  top: -9999,
  overflow: "scroll"
};
function dW(e) {
  const {
    onChange: t
  } = e, n = _e(e, G9e), r = V.useRef(), i = V.useRef(null), o = () => {
    r.current = i.current.offsetHeight - i.current.clientHeight;
  };
  return gi(() => {
    const s = Vb(() => {
      const u = r.current;
      o(), u !== r.current && t(r.current);
    }), a = bu(i.current);
    return a.addEventListener("resize", s), () => {
      s.clear(), a.removeEventListener("resize", s);
    };
  }, [t]), V.useEffect(() => {
    o(), t(r.current);
  }, [t]), /* @__PURE__ */ P.jsx("div", N({
    style: Y9e,
    ref: i
  }, n));
}
process.env.NODE_ENV !== "production" && (dW.propTypes = {
  onChange: l.func.isRequired
});
function K9e(e) {
  return ot("MuiTabScrollButton", e);
}
const J9e = st("MuiTabScrollButton", ["root", "vertical", "horizontal", "disabled"]), X9e = ["className", "slots", "slotProps", "direction", "orientation", "disabled"], Q9e = (e) => {
  const {
    classes: t,
    orientation: n,
    disabled: r
  } = e;
  return at({
    root: ["root", n, r && "disabled"]
  }, K9e, t);
}, Z9e = De(sa, {
  name: "MuiTabScrollButton",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.root, n.orientation && t[n.orientation]];
  }
})(({
  ownerState: e
}) => N({
  width: 40,
  flexShrink: 0,
  opacity: 0.8,
  [`&.${J9e.disabled}`]: {
    opacity: 0
  }
}, e.orientation === "vertical" && {
  width: "100%",
  height: 40,
  "& svg": {
    transform: `rotate(${e.isRtl ? -90 : 90}deg)`
  }
})), pW = /* @__PURE__ */ V.forwardRef(function(t, n) {
  var r, i;
  const o = Ot({
    props: t,
    name: "MuiTabScrollButton"
  }), {
    className: s,
    slots: a = {},
    slotProps: u = {},
    direction: c
  } = o, d = _e(o, X9e), f = Wb(), h = N({
    isRtl: f
  }, o), m = Q9e(h), v = (r = a.StartScrollButtonIcon) != null ? r : B9e, x = (i = a.EndScrollButtonIcon) != null ? i : j9e, C = Ai({
    elementType: v,
    externalSlotProps: u.startScrollButtonIcon,
    additionalProps: {
      fontSize: "small"
    },
    ownerState: h
  }), E = Ai({
    elementType: x,
    externalSlotProps: u.endScrollButtonIcon,
    additionalProps: {
      fontSize: "small"
    },
    ownerState: h
  });
  return /* @__PURE__ */ P.jsx(Z9e, N({
    component: "div",
    className: Be(m.root, s),
    ref: n,
    role: null,
    ownerState: h,
    tabIndex: null
  }, d, {
    children: c === "left" ? /* @__PURE__ */ P.jsx(v, N({}, C)) : /* @__PURE__ */ P.jsx(x, N({}, E))
  }));
});
process.env.NODE_ENV !== "production" && (pW.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The direction the button should indicate.
   */
  direction: l.oneOf(["left", "right"]).isRequired,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: l.bool,
  /**
   * The component orientation (layout flow direction).
   */
  orientation: l.oneOf(["horizontal", "vertical"]).isRequired,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   * @default {}
   */
  slotProps: l.shape({
    endScrollButtonIcon: l.oneOfType([l.func, l.object]),
    startScrollButtonIcon: l.oneOfType([l.func, l.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: l.shape({
    EndScrollButtonIcon: l.elementType,
    StartScrollButtonIcon: l.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
function e7e(e) {
  return ot("MuiTabs", e);
}
const eD = st("MuiTabs", ["root", "vertical", "flexContainer", "flexContainerVertical", "centered", "scroller", "fixed", "scrollableX", "scrollableY", "hideScrollbar", "scrollButtons", "scrollButtonsHideMobile", "indicator"]), t7e = ["aria-label", "aria-labelledby", "action", "centered", "children", "className", "component", "allowScrollButtonsMobile", "indicatorColor", "onChange", "orientation", "ScrollButtonComponent", "scrollButtons", "selectionFollowsFocus", "slots", "slotProps", "TabIndicatorProps", "TabScrollButtonProps", "textColor", "value", "variant", "visibleScrollbar"], Z3 = (e, t) => e === t ? e.firstChild : t && t.nextElementSibling ? t.nextElementSibling : e.firstChild, ej = (e, t) => e === t ? e.lastChild : t && t.previousElementSibling ? t.previousElementSibling : e.lastChild, J1 = (e, t, n) => {
  let r = !1, i = n(e, t);
  for (; i; ) {
    if (i === e.firstChild) {
      if (r)
        return;
      r = !0;
    }
    const o = i.disabled || i.getAttribute("aria-disabled") === "true";
    if (!i.hasAttribute("tabindex") || o)
      i = n(e, i);
    else {
      i.focus();
      return;
    }
  }
}, n7e = (e) => {
  const {
    vertical: t,
    fixed: n,
    hideScrollbar: r,
    scrollableX: i,
    scrollableY: o,
    centered: s,
    scrollButtonsHideMobile: a,
    classes: u
  } = e;
  return at({
    root: ["root", t && "vertical"],
    scroller: ["scroller", n && "fixed", r && "hideScrollbar", i && "scrollableX", o && "scrollableY"],
    flexContainer: ["flexContainer", t && "flexContainerVertical", s && "centered"],
    indicator: ["indicator"],
    scrollButtons: ["scrollButtons", a && "scrollButtonsHideMobile"],
    scrollableX: [i && "scrollableX"],
    hideScrollbar: [r && "hideScrollbar"]
  }, e7e, u);
}, r7e = De("div", {
  name: "MuiTabs",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [{
      [`& .${eD.scrollButtons}`]: t.scrollButtons
    }, {
      [`& .${eD.scrollButtons}`]: n.scrollButtonsHideMobile && t.scrollButtonsHideMobile
    }, t.root, n.vertical && t.vertical];
  }
})(({
  ownerState: e,
  theme: t
}) => N({
  overflow: "hidden",
  minHeight: 48,
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: "touch",
  display: "flex"
}, e.vertical && {
  flexDirection: "column"
}, e.scrollButtonsHideMobile && {
  [`& .${eD.scrollButtons}`]: {
    [t.breakpoints.down("sm")]: {
      display: "none"
    }
  }
})), i7e = De("div", {
  name: "MuiTabs",
  slot: "Scroller",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.scroller, n.fixed && t.fixed, n.hideScrollbar && t.hideScrollbar, n.scrollableX && t.scrollableX, n.scrollableY && t.scrollableY];
  }
})(({
  ownerState: e
}) => N({
  position: "relative",
  display: "inline-block",
  flex: "1 1 auto",
  whiteSpace: "nowrap"
}, e.fixed && {
  overflowX: "hidden",
  width: "100%"
}, e.hideScrollbar && {
  // Hide dimensionless scrollbar on macOS
  scrollbarWidth: "none",
  // Firefox
  "&::-webkit-scrollbar": {
    display: "none"
    // Safari + Chrome
  }
}, e.scrollableX && {
  overflowX: "auto",
  overflowY: "hidden"
}, e.scrollableY && {
  overflowY: "auto",
  overflowX: "hidden"
})), o7e = De("div", {
  name: "MuiTabs",
  slot: "FlexContainer",
  overridesResolver: (e, t) => {
    const {
      ownerState: n
    } = e;
    return [t.flexContainer, n.vertical && t.flexContainerVertical, n.centered && t.centered];
  }
})(({
  ownerState: e
}) => N({
  display: "flex"
}, e.vertical && {
  flexDirection: "column"
}, e.centered && {
  justifyContent: "center"
})), s7e = De("span", {
  name: "MuiTabs",
  slot: "Indicator",
  overridesResolver: (e, t) => t.indicator
})(({
  ownerState: e,
  theme: t
}) => N({
  position: "absolute",
  height: 2,
  bottom: 0,
  width: "100%",
  transition: t.transitions.create()
}, e.indicatorColor === "primary" && {
  backgroundColor: (t.vars || t).palette.primary.main
}, e.indicatorColor === "secondary" && {
  backgroundColor: (t.vars || t).palette.secondary.main
}, e.vertical && {
  height: "100%",
  width: 2,
  right: 0
})), a7e = De(dW)({
  overflowX: "auto",
  overflowY: "hidden",
  // Hide dimensionless scrollbar on macOS
  scrollbarWidth: "none",
  // Firefox
  "&::-webkit-scrollbar": {
    display: "none"
    // Safari + Chrome
  }
}), tj = {};
let nj = !1;
const fg = /* @__PURE__ */ V.forwardRef(function(t, n) {
  const r = Ot({
    props: t,
    name: "MuiTabs"
  }), i = Gi(), o = Wb(), {
    "aria-label": s,
    "aria-labelledby": a,
    action: u,
    centered: c = !1,
    children: d,
    className: f,
    component: h = "div",
    allowScrollButtonsMobile: m = !1,
    indicatorColor: v = "primary",
    onChange: x,
    orientation: C = "horizontal",
    ScrollButtonComponent: E = pW,
    scrollButtons: S = "auto",
    selectionFollowsFocus: w,
    slots: O = {},
    slotProps: A = {},
    TabIndicatorProps: I = {},
    TabScrollButtonProps: $ = {},
    textColor: L = "primary",
    value: B,
    variant: H = "standard",
    visibleScrollbar: q = !1
  } = r, J = _e(r, t7e), X = H === "scrollable", j = C === "vertical", U = j ? "scrollTop" : "scrollLeft", G = j ? "top" : "left", K = j ? "bottom" : "right", ee = j ? "clientHeight" : "clientWidth", te = j ? "height" : "width", M = N({}, r, {
    component: h,
    allowScrollButtonsMobile: m,
    indicatorColor: v,
    orientation: C,
    vertical: j,
    scrollButtons: S,
    textColor: L,
    variant: H,
    visibleScrollbar: q,
    fixed: !X,
    hideScrollbar: X && !q,
    scrollableX: X && !j,
    scrollableY: X && j,
    centered: c && !X,
    scrollButtonsHideMobile: !m
  }), Z = n7e(M), ne = Ai({
    elementType: O.StartScrollButtonIcon,
    externalSlotProps: A.startScrollButtonIcon,
    ownerState: M
  }), R = Ai({
    elementType: O.EndScrollButtonIcon,
    externalSlotProps: A.endScrollButtonIcon,
    ownerState: M
  });
  process.env.NODE_ENV !== "production" && c && X && console.error('MUI: You can not use the `centered={true}` and `variant="scrollable"` properties at the same time on a `Tabs` component.');
  const [_, W] = V.useState(!1), [Q, oe] = V.useState(tj), [ae, pe] = V.useState(!1), [me, xe] = V.useState(!1), [le, ye] = V.useState(!1), [be, Re] = V.useState({
    overflow: "hidden",
    scrollbarWidth: 0
  }), Te = /* @__PURE__ */ new Map(), Xe = V.useRef(null), Ne = V.useRef(null), Qe = () => {
    const He = Xe.current;
    let qe;
    if (He) {
      const Ut = He.getBoundingClientRect();
      qe = {
        clientWidth: He.clientWidth,
        scrollLeft: He.scrollLeft,
        scrollTop: He.scrollTop,
        scrollLeftNormalized: YNe(He, o ? "rtl" : "ltr"),
        scrollWidth: He.scrollWidth,
        top: Ut.top,
        bottom: Ut.bottom,
        left: Ut.left,
        right: Ut.right
      };
    }
    let wt;
    if (He && B !== !1) {
      const Ut = Ne.current.children;
      if (Ut.length > 0) {
        const an = Ut[Te.get(B)];
        process.env.NODE_ENV !== "production" && (an || console.error(["MUI: The `value` provided to the Tabs component is invalid.", `None of the Tabs' children match with "${B}".`, Te.keys ? `You can provide one of the following values: ${Array.from(Te.keys()).join(", ")}.` : null].join(`
`))), wt = an ? an.getBoundingClientRect() : null, process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "test" && !nj && wt && wt.width === 0 && wt.height === 0 && // if the whole Tabs component is hidden, don't warn
        qe.clientWidth !== 0 && (qe = null, console.error(["MUI: The `value` provided to the Tabs component is invalid.", `The Tab with this \`value\` ("${B}") is not part of the document layout.`, "Make sure the tab item is present in the document or that it's not `display: none`."].join(`
`)), nj = !0);
      }
    }
    return {
      tabsMeta: qe,
      tabMeta: wt
    };
  }, Ee = Mt(() => {
    const {
      tabsMeta: He,
      tabMeta: qe
    } = Qe();
    let wt = 0, Ut;
    if (j)
      Ut = "top", qe && He && (wt = qe.top - He.top + He.scrollTop);
    else if (Ut = o ? "right" : "left", qe && He) {
      const wn = o ? He.scrollLeftNormalized + He.clientWidth - He.scrollWidth : He.scrollLeft;
      wt = (o ? -1 : 1) * (qe[Ut] - He[Ut] + wn);
    }
    const an = {
      [Ut]: wt,
      // May be wrong until the font is loaded.
      [te]: qe ? qe[te] : 0
    };
    if (isNaN(Q[Ut]) || isNaN(Q[te]))
      oe(an);
    else {
      const wn = Math.abs(Q[Ut] - an[Ut]), En = Math.abs(Q[te] - an[te]);
      (wn >= 1 || En >= 1) && oe(an);
    }
  }), Ie = (He, {
    animation: qe = !0
  } = {}) => {
    qe ? q9e(U, Xe.current, He, {
      duration: i.transitions.duration.standard
    }) : Xe.current[U] = He;
  }, Je = (He) => {
    let qe = Xe.current[U];
    j ? qe += He : (qe += He * (o ? -1 : 1), qe *= o && eU() === "reverse" ? -1 : 1), Ie(qe);
  }, vt = () => {
    const He = Xe.current[ee];
    let qe = 0;
    const wt = Array.from(Ne.current.children);
    for (let Ut = 0; Ut < wt.length; Ut += 1) {
      const an = wt[Ut];
      if (qe + an[ee] > He) {
        Ut === 0 && (qe = He);
        break;
      }
      qe += an[ee];
    }
    return qe;
  }, St = () => {
    Je(-1 * vt());
  }, Lt = () => {
    Je(vt());
  }, ke = V.useCallback((He) => {
    Re({
      overflow: null,
      scrollbarWidth: He
    });
  }, []), Le = () => {
    const He = {};
    He.scrollbarSizeListener = X ? /* @__PURE__ */ P.jsx(a7e, {
      onChange: ke,
      className: Be(Z.scrollableX, Z.hideScrollbar)
    }) : null;
    const wt = X && (S === "auto" && (ae || me) || S === !0);
    return He.scrollButtonStart = wt ? /* @__PURE__ */ P.jsx(E, N({
      slots: {
        StartScrollButtonIcon: O.StartScrollButtonIcon
      },
      slotProps: {
        startScrollButtonIcon: ne
      },
      orientation: C,
      direction: o ? "right" : "left",
      onClick: St,
      disabled: !ae
    }, $, {
      className: Be(Z.scrollButtons, $.className)
    })) : null, He.scrollButtonEnd = wt ? /* @__PURE__ */ P.jsx(E, N({
      slots: {
        EndScrollButtonIcon: O.EndScrollButtonIcon
      },
      slotProps: {
        endScrollButtonIcon: R
      },
      orientation: C,
      direction: o ? "left" : "right",
      onClick: Lt,
      disabled: !me
    }, $, {
      className: Be(Z.scrollButtons, $.className)
    })) : null, He;
  }, Pe = Mt((He) => {
    const {
      tabsMeta: qe,
      tabMeta: wt
    } = Qe();
    if (!(!wt || !qe)) {
      if (wt[G] < qe[G]) {
        const Ut = qe[U] + (wt[G] - qe[G]);
        Ie(Ut, {
          animation: He
        });
      } else if (wt[K] > qe[K]) {
        const Ut = qe[U] + (wt[K] - qe[K]);
        Ie(Ut, {
          animation: He
        });
      }
    }
  }), Ae = Mt(() => {
    X && S !== !1 && ye(!le);
  });
  V.useEffect(() => {
    const He = Vb(() => {
      Xe.current && Ee();
    });
    let qe;
    const wt = (wn) => {
      wn.forEach((En) => {
        En.removedNodes.forEach((sr) => {
          var er;
          (er = qe) == null || er.unobserve(sr);
        }), En.addedNodes.forEach((sr) => {
          var er;
          (er = qe) == null || er.observe(sr);
        });
      }), He(), Ae();
    }, Ut = bu(Xe.current);
    Ut.addEventListener("resize", He);
    let an;
    return typeof ResizeObserver < "u" && (qe = new ResizeObserver(He), Array.from(Ne.current.children).forEach((wn) => {
      qe.observe(wn);
    })), typeof MutationObserver < "u" && (an = new MutationObserver(wt), an.observe(Ne.current, {
      childList: !0
    })), () => {
      var wn, En;
      He.clear(), Ut.removeEventListener("resize", He), (wn = an) == null || wn.disconnect(), (En = qe) == null || En.disconnect();
    };
  }, [Ee, Ae]), V.useEffect(() => {
    const He = Array.from(Ne.current.children), qe = He.length;
    if (typeof IntersectionObserver < "u" && qe > 0 && X && S !== !1) {
      const wt = He[0], Ut = He[qe - 1], an = {
        root: Xe.current,
        threshold: 0.99
      }, wn = (pn) => {
        pe(!pn[0].isIntersecting);
      }, En = new IntersectionObserver(wn, an);
      En.observe(wt);
      const sr = (pn) => {
        xe(!pn[0].isIntersecting);
      }, er = new IntersectionObserver(sr, an);
      return er.observe(Ut), () => {
        En.disconnect(), er.disconnect();
      };
    }
  }, [X, S, le, d == null ? void 0 : d.length]), V.useEffect(() => {
    W(!0);
  }, []), V.useEffect(() => {
    Ee();
  }), V.useEffect(() => {
    Pe(tj !== Q);
  }, [Pe, Q]), V.useImperativeHandle(u, () => ({
    updateIndicator: Ee,
    updateScrollButtons: Ae
  }), [Ee, Ae]);
  const We = /* @__PURE__ */ P.jsx(s7e, N({}, I, {
    className: Be(Z.indicator, I.className),
    ownerState: M,
    style: N({}, Q, I.style)
  }));
  let At = 0;
  const Ft = V.Children.map(d, (He) => {
    if (!/* @__PURE__ */ V.isValidElement(He))
      return null;
    process.env.NODE_ENV !== "production" && Gp.isFragment(He) && console.error(["MUI: The Tabs component doesn't accept a Fragment as a child.", "Consider providing an array instead."].join(`
`));
    const qe = He.props.value === void 0 ? At : He.props.value;
    Te.set(qe, At);
    const wt = qe === B;
    return At += 1, /* @__PURE__ */ V.cloneElement(He, N({
      fullWidth: H === "fullWidth",
      indicator: wt && !_ && We,
      selected: wt,
      selectionFollowsFocus: w,
      onChange: x,
      textColor: L,
      value: qe
    }, At === 1 && B === !1 && !He.props.tabIndex ? {
      tabIndex: 0
    } : {}));
  }), Ct = (He) => {
    const qe = Ne.current, wt = ei(qe).activeElement;
    if (wt.getAttribute("role") !== "tab")
      return;
    let an = C === "horizontal" ? "ArrowLeft" : "ArrowUp", wn = C === "horizontal" ? "ArrowRight" : "ArrowDown";
    switch (C === "horizontal" && o && (an = "ArrowRight", wn = "ArrowLeft"), He.key) {
      case an:
        He.preventDefault(), J1(qe, wt, ej);
        break;
      case wn:
        He.preventDefault(), J1(qe, wt, Z3);
        break;
      case "Home":
        He.preventDefault(), J1(qe, null, Z3);
        break;
      case "End":
        He.preventDefault(), J1(qe, null, ej);
        break;
    }
  }, ht = Le();
  return /* @__PURE__ */ P.jsxs(r7e, N({
    className: Be(Z.root, f),
    ownerState: M,
    ref: n,
    as: h
  }, J, {
    children: [ht.scrollButtonStart, ht.scrollbarSizeListener, /* @__PURE__ */ P.jsxs(i7e, {
      className: Z.scroller,
      ownerState: M,
      style: {
        overflow: be.overflow,
        [j ? `margin${o ? "Left" : "Right"}` : "marginBottom"]: q ? void 0 : -be.scrollbarWidth
      },
      ref: Xe,
      children: [/* @__PURE__ */ P.jsx(o7e, {
        "aria-label": s,
        "aria-labelledby": a,
        "aria-orientation": C === "vertical" ? "vertical" : null,
        className: Z.flexContainer,
        ownerState: M,
        onKeyDown: Ct,
        ref: Ne,
        role: "tablist",
        children: Ft
      }), _ && We]
    }), ht.scrollButtonEnd]
  }));
});
process.env.NODE_ENV !== "production" && (fg.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * Callback fired when the component mounts.
   * This is useful when you want to trigger an action programmatically.
   * It supports two actions: `updateIndicator()` and `updateScrollButtons()`
   *
   * @param {object} actions This object contains all possible actions
   * that can be triggered programmatically.
   */
  action: wr,
  /**
   * If `true`, the scroll buttons aren't forced hidden on mobile.
   * By default the scroll buttons are hidden on mobile and takes precedence over `scrollButtons`.
   * @default false
   */
  allowScrollButtonsMobile: l.bool,
  /**
   * The label for the Tabs as a string.
   */
  "aria-label": l.string,
  /**
   * An id or list of ids separated by a space that label the Tabs.
   */
  "aria-labelledby": l.string,
  /**
   * If `true`, the tabs are centered.
   * This prop is intended for large views.
   * @default false
   */
  centered: l.bool,
  /**
   * The content of the component.
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: l.elementType,
  /**
   * Determines the color of the indicator.
   * @default 'primary'
   */
  indicatorColor: l.oneOfType([l.oneOf(["primary", "secondary"]), l.string]),
  /**
   * Callback fired when the value changes.
   *
   * @param {React.SyntheticEvent} event The event source of the callback. **Warning**: This is a generic event not a change event.
   * @param {any} value We default to the index of the child (number)
   */
  onChange: l.func,
  /**
   * The component orientation (layout flow direction).
   * @default 'horizontal'
   */
  orientation: l.oneOf(["horizontal", "vertical"]),
  /**
   * The component used to render the scroll buttons.
   * @default TabScrollButton
   */
  ScrollButtonComponent: l.elementType,
  /**
   * Determine behavior of scroll buttons when tabs are set to scroll:
   *
   * - `auto` will only present them when not all the items are visible.
   * - `true` will always present them.
   * - `false` will never present them.
   *
   * By default the scroll buttons are hidden on mobile.
   * This behavior can be disabled with `allowScrollButtonsMobile`.
   * @default 'auto'
   */
  scrollButtons: l.oneOf(["auto", !1, !0]),
  /**
   * If `true` the selected tab changes on focus. Otherwise it only
   * changes on activation.
   */
  selectionFollowsFocus: l.bool,
  /**
   * The extra props for the slot components.
   * You can override the existing props or add new ones.
   * @default {}
   */
  slotProps: l.shape({
    endScrollButtonIcon: l.oneOfType([l.func, l.object]),
    startScrollButtonIcon: l.oneOfType([l.func, l.object])
  }),
  /**
   * The components used for each slot inside.
   * @default {}
   */
  slots: l.shape({
    EndScrollButtonIcon: l.elementType,
    StartScrollButtonIcon: l.elementType
  }),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * Props applied to the tab indicator element.
   * @default  {}
   */
  TabIndicatorProps: l.object,
  /**
   * Props applied to the [`TabScrollButton`](/material-ui/api/tab-scroll-button/) element.
   * @default {}
   */
  TabScrollButtonProps: l.object,
  /**
   * Determines the color of the `Tab`.
   * @default 'primary'
   */
  textColor: l.oneOf(["inherit", "primary", "secondary"]),
  /**
   * The value of the currently selected `Tab`.
   * If you don't want any selected `Tab`, you can set this prop to `false`.
   */
  value: l.any,
  /**
   * Determines additional display behavior of the tabs:
   *
   *  - `scrollable` will invoke scrolling properties and allow for horizontally
   *  scrolling (or swiping) of the tab bar.
   *  - `fullWidth` will make the tabs grow to use all the available space,
   *  which should be used for small views, like on mobile.
   *  - `standard` will render the default state.
   * @default 'standard'
   */
  variant: l.oneOf(["fullWidth", "scrollable", "standard"]),
  /**
   * If `true`, the scrollbar is visible. It can be useful when displaying
   * a long vertical list of tabs.
   * @default false
   */
  visibleScrollbar: l.bool
});
function l7e(e) {
  return ot("MuiTextField", e);
}
st("MuiTextField", ["root"]);
const u7e = ["autoComplete", "autoFocus", "children", "className", "color", "defaultValue", "disabled", "error", "FormHelperTextProps", "fullWidth", "helperText", "id", "InputLabelProps", "inputProps", "InputProps", "inputRef", "label", "maxRows", "minRows", "multiline", "name", "onBlur", "onChange", "onFocus", "placeholder", "required", "rows", "select", "SelectProps", "type", "value", "variant"], c7e = {
  standard: iv,
  filled: Su,
  outlined: Zo
}, d7e = (e) => {
  const {
    classes: t
  } = e;
  return at({
    root: ["root"]
  }, l7e, t);
}, p7e = De(hi, {
  name: "MuiTextField",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), vf = /* @__PURE__ */ V.forwardRef(function(t, n) {
  const r = Ot({
    props: t,
    name: "MuiTextField"
  }), {
    autoComplete: i,
    autoFocus: o = !1,
    children: s,
    className: a,
    color: u = "primary",
    defaultValue: c,
    disabled: d = !1,
    error: f = !1,
    FormHelperTextProps: h,
    fullWidth: m = !1,
    helperText: v,
    id: x,
    InputLabelProps: C,
    inputProps: E,
    InputProps: S,
    inputRef: w,
    label: O,
    maxRows: A,
    minRows: I,
    multiline: $ = !1,
    name: L,
    onBlur: B,
    onChange: H,
    onFocus: q,
    placeholder: J,
    required: X = !1,
    rows: j,
    select: U = !1,
    SelectProps: G,
    type: K,
    value: ee,
    variant: te = "outlined"
  } = r, M = _e(r, u7e), Z = N({}, r, {
    autoFocus: o,
    color: u,
    disabled: d,
    error: f,
    fullWidth: m,
    multiline: $,
    required: X,
    select: U,
    variant: te
  }), ne = d7e(Z);
  process.env.NODE_ENV !== "production" && U && !s && console.error("MUI: `children` must be passed when using the `TextField` component with `select`.");
  const R = {};
  te === "outlined" && (C && typeof C.shrink < "u" && (R.notched = C.shrink), R.label = O), U && ((!G || !G.native) && (R.id = void 0), R["aria-describedby"] = void 0);
  const _ = Pl(x), W = v && _ ? `${_}-helper-text` : void 0, Q = O && _ ? `${_}-label` : void 0, oe = c7e[te], ae = /* @__PURE__ */ P.jsx(oe, N({
    "aria-describedby": W,
    autoComplete: i,
    autoFocus: o,
    defaultValue: c,
    fullWidth: m,
    multiline: $,
    name: L,
    rows: j,
    maxRows: A,
    minRows: I,
    type: K,
    value: ee,
    id: _,
    inputRef: w,
    onBlur: B,
    onChange: H,
    onFocus: q,
    placeholder: J,
    inputProps: E
  }, R, S));
  return /* @__PURE__ */ P.jsxs(p7e, N({
    className: Be(ne.root, a),
    disabled: d,
    error: f,
    fullWidth: m,
    ref: n,
    required: X,
    color: u,
    variant: te,
    ownerState: Z
  }, M, {
    children: [O != null && O !== "" && /* @__PURE__ */ P.jsx(ra, N({
      htmlFor: _,
      id: Q
    }, C, {
      children: O
    })), U ? /* @__PURE__ */ P.jsx(mf, N({
      "aria-describedby": W,
      id: _,
      labelId: Q,
      value: ee,
      input: ae
    }, G, {
      children: s
    })) : ae, v && /* @__PURE__ */ P.jsx(gn, N({
      id: W
    }, h, {
      children: v
    }))]
  }));
});
process.env.NODE_ENV !== "production" && (vf.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: l.string,
  /**
   * If `true`, the `input` element is focused during the first mount.
   * @default false
   */
  autoFocus: l.bool,
  /**
   * @ignore
   */
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * @ignore
   */
  className: l.string,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: l.oneOfType([l.oneOf(["primary", "secondary", "error", "info", "success", "warning"]), l.string]),
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: l.any,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: l.bool,
  /**
   * If `true`, the label is displayed in an error state.
   * @default false
   */
  error: l.bool,
  /**
   * Props applied to the [`FormHelperText`](/material-ui/api/form-helper-text/) element.
   */
  FormHelperTextProps: l.object,
  /**
   * If `true`, the input will take up the full width of its container.
   * @default false
   */
  fullWidth: l.bool,
  /**
   * The helper text content.
   */
  helperText: l.node,
  /**
   * The id of the `input` element.
   * Use this prop to make `label` and `helperText` accessible for screen readers.
   */
  id: l.string,
  /**
   * Props applied to the [`InputLabel`](/material-ui/api/input-label/) element.
   * Pointer events like `onClick` are enabled if and only if `shrink` is `true`.
   */
  InputLabelProps: l.object,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: l.object,
  /**
   * Props applied to the Input element.
   * It will be a [`FilledInput`](/material-ui/api/filled-input/),
   * [`OutlinedInput`](/material-ui/api/outlined-input/) or [`Input`](/material-ui/api/input/)
   * component depending on the `variant` prop value.
   */
  InputProps: l.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: wr,
  /**
   * The label content.
   */
  label: l.node,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */
  margin: l.oneOf(["dense", "none", "normal"]),
  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  maxRows: l.oneOfType([l.number, l.string]),
  /**
   * Minimum number of rows to display when multiline option is set to true.
   */
  minRows: l.oneOfType([l.number, l.string]),
  /**
   * If `true`, a `textarea` element is rendered instead of an input.
   * @default false
   */
  multiline: l.bool,
  /**
   * Name attribute of the `input` element.
   */
  name: l.string,
  /**
   * @ignore
   */
  onBlur: l.func,
  /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: l.func,
  /**
   * @ignore
   */
  onFocus: l.func,
  /**
   * The short hint displayed in the `input` before the user enters a value.
   */
  placeholder: l.string,
  /**
   * If `true`, the label is displayed as required and the `input` element is required.
   * @default false
   */
  required: l.bool,
  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: l.oneOfType([l.number, l.string]),
  /**
   * Render a [`Select`](/material-ui/api/select/) element while passing the Input element to `Select` as `input` parameter.
   * If this option is set you must pass the options of the select as children.
   * @default false
   */
  select: l.bool,
  /**
   * Props applied to the [`Select`](/material-ui/api/select/) element.
   */
  SelectProps: l.object,
  /**
   * The size of the component.
   */
  size: l.oneOfType([l.oneOf(["medium", "small"]), l.string]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   */
  type: l.string,
  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: l.any,
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: l.oneOf(["filled", "outlined", "standard"])
});
var f7e = Y2;
function h7e(e) {
  return f7e(e) ? void 0 : e;
}
var m7e = h7e, g7e = jm, y7e = lE, b7e = $V, v7e = Ab, x7e = Jm, D7e = m7e, C7e = IV, E7e = cV, T7e = 1, S7e = 2, A7e = 4, w7e = C7e(function(e, t) {
  var n = {};
  if (e == null)
    return n;
  var r = !1;
  t = g7e(t, function(o) {
    return o = v7e(o, e), r || (r = o.length > 1), o;
  }), x7e(e, E7e(e), n), r && (n = y7e(n, T7e | S7e | A7e, D7e));
  for (var i = t.length; i--; )
    b7e(n, t[i]);
  return n;
}), P7e = w7e;
const k7e = /* @__PURE__ */ Ln(P7e);
function O7e(e, t, n) {
  for (var r = -1, i = e == null ? 0 : e.length; ++r < i; )
    if (n(t, e[r]))
      return !0;
  return !1;
}
var I7e = O7e, tw = Q6, F7e = vV, $7e = YO, N7e = 1 / 0, M7e = tw && 1 / $7e(new tw([, -0]))[1] == N7e ? function(e) {
  return new tw(e);
} : F7e, R7e = M7e, _7e = $9, L7e = EV, B7e = I7e, j7e = M9, V7e = R7e, z7e = YO, U7e = 200;
function W7e(e, t, n) {
  var r = -1, i = L7e, o = e.length, s = !0, a = [], u = a;
  if (n)
    s = !1, i = B7e;
  else if (o >= U7e) {
    var c = t ? null : V7e(e);
    if (c)
      return z7e(c);
    s = !1, i = j7e, u = new _7e();
  } else
    u = t ? [] : a;
  e:
    for (; ++r < o; ) {
      var d = e[r], f = t ? t(d) : d;
      if (d = n || d !== 0 ? d : 0, s && f === f) {
        for (var h = u.length; h--; )
          if (u[h] === f)
            continue e;
        t && u.push(f), a.push(d);
      } else i(u, f, n) || (u !== a && u.push(f), a.push(d));
    }
  return a;
}
var H7e = W7e, q7e = OV, G7e = aV, Y7e = H7e, K7e = tV, J7e = G7e(function(e) {
  return Y7e(q7e(e, 1, K7e, !0));
}), X7e = J7e;
const Q7e = /* @__PURE__ */ Ln(X7e);
var FF = {}, nw = {};
const Z7e = /* @__PURE__ */ Tl(ORe);
var rj;
function kd() {
  return rj || (rj = 1, function(e) {
    "use client";
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "default", {
      enumerable: !0,
      get: function() {
        return t.createSvgIcon;
      }
    });
    var t = Z7e;
  }(nw)), nw;
}
var eVe = Eu;
Object.defineProperty(FF, "__esModule", {
  value: !0
});
var vc = FF.default = void 0, tVe = eVe(kd()), nVe = P;
vc = FF.default = (0, tVe.default)(/* @__PURE__ */ (0, nVe.jsx)("path", {
  d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6zM19 4h-3.5l-1-1h-5l-1 1H5v2h14z"
}), "Delete");
var $F = {}, rVe = Eu;
Object.defineProperty($F, "__esModule", {
  value: !0
});
var NF = $F.default = void 0, iVe = rVe(kd()), oVe = P;
NF = $F.default = (0, iVe.default)(/* @__PURE__ */ (0, oVe.jsx)("path", {
  d: "m20 12-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8z"
}), "ArrowDownward");
var MF = {}, sVe = Eu;
Object.defineProperty(MF, "__esModule", {
  value: !0
});
var RF = MF.default = void 0, aVe = sVe(kd()), lVe = P;
RF = MF.default = (0, aVe.default)(/* @__PURE__ */ (0, lVe.jsx)("path", {
  d: "m4 12 1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8z"
}), "ArrowUpward");
var _F = {}, uVe = Eu;
Object.defineProperty(_F, "__esModule", {
  value: !0
});
var WE = _F.default = void 0, cVe = uVe(kd()), dVe = P;
WE = _F.default = (0, cVe.default)(/* @__PURE__ */ (0, dVe.jsx)("path", {
  d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6z"
}), "Add");
var LF = {}, pVe = Eu;
Object.defineProperty(LF, "__esModule", {
  value: !0
});
var HE = LF.default = void 0, fVe = pVe(kd()), hVe = P;
HE = LF.default = (0, fVe.default)(/* @__PURE__ */ (0, hVe.jsx)("path", {
  d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2M12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8"
}), "ErrorOutline");
var fW = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(Kr, function() {
    var n = 1e3, r = 6e4, i = 36e5, o = "millisecond", s = "second", a = "minute", u = "hour", c = "day", d = "week", f = "month", h = "quarter", m = "year", v = "date", x = "Invalid Date", C = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, E = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, S = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_") }, w = function(X, j, U) {
      var G = String(X);
      return !G || G.length >= j ? X : "" + Array(j + 1 - G.length).join(U) + X;
    }, O = { s: w, z: function(X) {
      var j = -X.utcOffset(), U = Math.abs(j), G = Math.floor(U / 60), K = U % 60;
      return (j <= 0 ? "+" : "-") + w(G, 2, "0") + ":" + w(K, 2, "0");
    }, m: function X(j, U) {
      if (j.date() < U.date()) return -X(U, j);
      var G = 12 * (U.year() - j.year()) + (U.month() - j.month()), K = j.clone().add(G, f), ee = U - K < 0, te = j.clone().add(G + (ee ? -1 : 1), f);
      return +(-(G + (U - K) / (ee ? K - te : te - K)) || 0);
    }, a: function(X) {
      return X < 0 ? Math.ceil(X) || 0 : Math.floor(X);
    }, p: function(X) {
      return { M: f, y: m, w: d, d: c, D: v, h: u, m: a, s, ms: o, Q: h }[X] || String(X || "").toLowerCase().replace(/s$/, "");
    }, u: function(X) {
      return X === void 0;
    } }, A = "en", I = {};
    I[A] = S;
    var $ = function(X) {
      return X instanceof q;
    }, L = function(X, j, U) {
      var G;
      if (!X) return A;
      if (typeof X == "string") I[X] && (G = X), j && (I[X] = j, G = X);
      else {
        var K = X.name;
        I[K] = X, G = K;
      }
      return !U && G && (A = G), G || !U && A;
    }, B = function(X, j) {
      if ($(X)) return X.clone();
      var U = typeof j == "object" ? j : {};
      return U.date = X, U.args = arguments, new q(U);
    }, H = O;
    H.l = L, H.i = $, H.w = function(X, j) {
      return B(X, { locale: j.$L, utc: j.$u, x: j.$x, $offset: j.$offset });
    };
    var q = function() {
      function X(U) {
        this.$L = L(U.locale, null, !0), this.parse(U);
      }
      var j = X.prototype;
      return j.parse = function(U) {
        this.$d = function(G) {
          var K = G.date, ee = G.utc;
          if (K === null) return /* @__PURE__ */ new Date(NaN);
          if (H.u(K)) return /* @__PURE__ */ new Date();
          if (K instanceof Date) return new Date(K);
          if (typeof K == "string" && !/Z$/i.test(K)) {
            var te = K.match(C);
            if (te) {
              var M = te[2] - 1 || 0, Z = (te[7] || "0").substring(0, 3);
              return ee ? new Date(Date.UTC(te[1], M, te[3] || 1, te[4] || 0, te[5] || 0, te[6] || 0, Z)) : new Date(te[1], M, te[3] || 1, te[4] || 0, te[5] || 0, te[6] || 0, Z);
            }
          }
          return new Date(K);
        }(U), this.$x = U.x || {}, this.init();
      }, j.init = function() {
        var U = this.$d;
        this.$y = U.getFullYear(), this.$M = U.getMonth(), this.$D = U.getDate(), this.$W = U.getDay(), this.$H = U.getHours(), this.$m = U.getMinutes(), this.$s = U.getSeconds(), this.$ms = U.getMilliseconds();
      }, j.$utils = function() {
        return H;
      }, j.isValid = function() {
        return this.$d.toString() !== x;
      }, j.isSame = function(U, G) {
        var K = B(U);
        return this.startOf(G) <= K && K <= this.endOf(G);
      }, j.isAfter = function(U, G) {
        return B(U) < this.startOf(G);
      }, j.isBefore = function(U, G) {
        return this.endOf(G) < B(U);
      }, j.$g = function(U, G, K) {
        return H.u(U) ? this[G] : this.set(K, U);
      }, j.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, j.valueOf = function() {
        return this.$d.getTime();
      }, j.startOf = function(U, G) {
        var K = this, ee = !!H.u(G) || G, te = H.p(U), M = function(ae, pe) {
          var me = H.w(K.$u ? Date.UTC(K.$y, pe, ae) : new Date(K.$y, pe, ae), K);
          return ee ? me : me.endOf(c);
        }, Z = function(ae, pe) {
          return H.w(K.toDate()[ae].apply(K.toDate("s"), (ee ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(pe)), K);
        }, ne = this.$W, R = this.$M, _ = this.$D, W = "set" + (this.$u ? "UTC" : "");
        switch (te) {
          case m:
            return ee ? M(1, 0) : M(31, 11);
          case f:
            return ee ? M(1, R) : M(0, R + 1);
          case d:
            var Q = this.$locale().weekStart || 0, oe = (ne < Q ? ne + 7 : ne) - Q;
            return M(ee ? _ - oe : _ + (6 - oe), R);
          case c:
          case v:
            return Z(W + "Hours", 0);
          case u:
            return Z(W + "Minutes", 1);
          case a:
            return Z(W + "Seconds", 2);
          case s:
            return Z(W + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, j.endOf = function(U) {
        return this.startOf(U, !1);
      }, j.$set = function(U, G) {
        var K, ee = H.p(U), te = "set" + (this.$u ? "UTC" : ""), M = (K = {}, K[c] = te + "Date", K[v] = te + "Date", K[f] = te + "Month", K[m] = te + "FullYear", K[u] = te + "Hours", K[a] = te + "Minutes", K[s] = te + "Seconds", K[o] = te + "Milliseconds", K)[ee], Z = ee === c ? this.$D + (G - this.$W) : G;
        if (ee === f || ee === m) {
          var ne = this.clone().set(v, 1);
          ne.$d[M](Z), ne.init(), this.$d = ne.set(v, Math.min(this.$D, ne.daysInMonth())).$d;
        } else M && this.$d[M](Z);
        return this.init(), this;
      }, j.set = function(U, G) {
        return this.clone().$set(U, G);
      }, j.get = function(U) {
        return this[H.p(U)]();
      }, j.add = function(U, G) {
        var K, ee = this;
        U = Number(U);
        var te = H.p(G), M = function(R) {
          var _ = B(ee);
          return H.w(_.date(_.date() + Math.round(R * U)), ee);
        };
        if (te === f) return this.set(f, this.$M + U);
        if (te === m) return this.set(m, this.$y + U);
        if (te === c) return M(1);
        if (te === d) return M(7);
        var Z = (K = {}, K[a] = r, K[u] = i, K[s] = n, K)[te] || 1, ne = this.$d.getTime() + U * Z;
        return H.w(ne, this);
      }, j.subtract = function(U, G) {
        return this.add(-1 * U, G);
      }, j.format = function(U) {
        var G = this, K = this.$locale();
        if (!this.isValid()) return K.invalidDate || x;
        var ee = U || "YYYY-MM-DDTHH:mm:ssZ", te = H.z(this), M = this.$H, Z = this.$m, ne = this.$M, R = K.weekdays, _ = K.months, W = function(pe, me, xe, le) {
          return pe && (pe[me] || pe(G, ee)) || xe[me].substr(0, le);
        }, Q = function(pe) {
          return H.s(M % 12 || 12, pe, "0");
        }, oe = K.meridiem || function(pe, me, xe) {
          var le = pe < 12 ? "AM" : "PM";
          return xe ? le.toLowerCase() : le;
        }, ae = { YY: String(this.$y).slice(-2), YYYY: this.$y, M: ne + 1, MM: H.s(ne + 1, 2, "0"), MMM: W(K.monthsShort, ne, _, 3), MMMM: W(_, ne), D: this.$D, DD: H.s(this.$D, 2, "0"), d: String(this.$W), dd: W(K.weekdaysMin, this.$W, R, 2), ddd: W(K.weekdaysShort, this.$W, R, 3), dddd: R[this.$W], H: String(M), HH: H.s(M, 2, "0"), h: Q(1), hh: Q(2), a: oe(M, Z, !0), A: oe(M, Z, !1), m: String(Z), mm: H.s(Z, 2, "0"), s: String(this.$s), ss: H.s(this.$s, 2, "0"), SSS: H.s(this.$ms, 3, "0"), Z: te };
        return ee.replace(E, function(pe, me) {
          return me || ae[pe] || te.replace(":", "");
        });
      }, j.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, j.diff = function(U, G, K) {
        var ee, te = H.p(G), M = B(U), Z = (M.utcOffset() - this.utcOffset()) * r, ne = this - M, R = H.m(this, M);
        return R = (ee = {}, ee[m] = R / 12, ee[f] = R, ee[h] = R / 3, ee[d] = (ne - Z) / 6048e5, ee[c] = (ne - Z) / 864e5, ee[u] = ne / i, ee[a] = ne / r, ee[s] = ne / n, ee)[te] || ne, K ? R : H.a(R);
      }, j.daysInMonth = function() {
        return this.endOf(f).$D;
      }, j.$locale = function() {
        return I[this.$L];
      }, j.locale = function(U, G) {
        if (!U) return this.$L;
        var K = this.clone(), ee = L(U, G, !0);
        return ee && (K.$L = ee), K;
      }, j.clone = function() {
        return H.w(this.$d, this);
      }, j.toDate = function() {
        return new Date(this.valueOf());
      }, j.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, j.toISOString = function() {
        return this.$d.toISOString();
      }, j.toString = function() {
        return this.$d.toUTCString();
      }, X;
    }(), J = q.prototype;
    return B.prototype = J, [["$ms", o], ["$s", s], ["$m", a], ["$H", u], ["$W", c], ["$M", f], ["$y", m], ["$D", v]].forEach(function(X) {
      J[X[1]] = function(j) {
        return this.$g(j, X[0], X[1]);
      };
    }), B.extend = function(X, j) {
      return X.$i || (X(j, q, B), X.$i = !0), B;
    }, B.locale = L, B.isDayjs = $, B.unix = function(X) {
      return B(1e3 * X);
    }, B.en = I[A], B.Ls = I, B.p = {}, B;
  });
})(fW);
var mVe = fW.exports;
const BF = /* @__PURE__ */ Ln(mVe);
var hW = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(Kr, function() {
    var n = { LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" }, r = /(\[[^[]*\])|([-:/.()\s]+)|(A|a|YYYY|YY?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, i = /\d\d/, o = /\d\d?/, s = /\d*[^\s\d-_:/()]+/, a = {}, u = function(x) {
      return (x = +x) + (x > 68 ? 1900 : 2e3);
    }, c = function(x) {
      return function(C) {
        this[x] = +C;
      };
    }, d = [/[+-]\d\d:?(\d\d)?|Z/, function(x) {
      (this.zone || (this.zone = {})).offset = function(C) {
        if (!C || C === "Z") return 0;
        var E = C.match(/([+-]|\d\d)/g), S = 60 * E[1] + (+E[2] || 0);
        return S === 0 ? 0 : E[0] === "+" ? -S : S;
      }(x);
    }], f = function(x) {
      var C = a[x];
      return C && (C.indexOf ? C : C.s.concat(C.f));
    }, h = function(x, C) {
      var E, S = a.meridiem;
      if (S) {
        for (var w = 1; w <= 24; w += 1) if (x.indexOf(S(w, 0, C)) > -1) {
          E = w > 12;
          break;
        }
      } else E = x === (C ? "pm" : "PM");
      return E;
    }, m = { A: [s, function(x) {
      this.afternoon = h(x, !1);
    }], a: [s, function(x) {
      this.afternoon = h(x, !0);
    }], S: [/\d/, function(x) {
      this.milliseconds = 100 * +x;
    }], SS: [i, function(x) {
      this.milliseconds = 10 * +x;
    }], SSS: [/\d{3}/, function(x) {
      this.milliseconds = +x;
    }], s: [o, c("seconds")], ss: [o, c("seconds")], m: [o, c("minutes")], mm: [o, c("minutes")], H: [o, c("hours")], h: [o, c("hours")], HH: [o, c("hours")], hh: [o, c("hours")], D: [o, c("day")], DD: [i, c("day")], Do: [s, function(x) {
      var C = a.ordinal, E = x.match(/\d+/);
      if (this.day = E[0], C) for (var S = 1; S <= 31; S += 1) C(S).replace(/\[|\]/g, "") === x && (this.day = S);
    }], M: [o, c("month")], MM: [i, c("month")], MMM: [s, function(x) {
      var C = f("months"), E = (f("monthsShort") || C.map(function(S) {
        return S.substr(0, 3);
      })).indexOf(x) + 1;
      if (E < 1) throw new Error();
      this.month = E % 12 || E;
    }], MMMM: [s, function(x) {
      var C = f("months").indexOf(x) + 1;
      if (C < 1) throw new Error();
      this.month = C % 12 || C;
    }], Y: [/[+-]?\d+/, c("year")], YY: [i, function(x) {
      this.year = u(x);
    }], YYYY: [/\d{4}/, c("year")], Z: d, ZZ: d };
    function v(x) {
      var C, E;
      C = x, E = a && a.formats;
      for (var S = (x = C.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(B, H, q) {
        var J = q && q.toUpperCase();
        return H || E[q] || n[q] || E[J].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(X, j, U) {
          return j || U.slice(1);
        });
      })).match(r), w = S.length, O = 0; O < w; O += 1) {
        var A = S[O], I = m[A], $ = I && I[0], L = I && I[1];
        S[O] = L ? { regex: $, parser: L } : A.replace(/^\[|\]$/g, "");
      }
      return function(B) {
        for (var H = {}, q = 0, J = 0; q < w; q += 1) {
          var X = S[q];
          if (typeof X == "string") J += X.length;
          else {
            var j = X.regex, U = X.parser, G = B.substr(J), K = j.exec(G)[0];
            U.call(H, K), B = B.replace(K, "");
          }
        }
        return function(ee) {
          var te = ee.afternoon;
          if (te !== void 0) {
            var M = ee.hours;
            te ? M < 12 && (ee.hours += 12) : M === 12 && (ee.hours = 0), delete ee.afternoon;
          }
        }(H), H;
      };
    }
    return function(x, C, E) {
      E.p.customParseFormat = !0, x && x.parseTwoDigitYear && (u = x.parseTwoDigitYear);
      var S = C.prototype, w = S.parse;
      S.parse = function(O) {
        var A = O.date, I = O.utc, $ = O.args;
        this.$u = I;
        var L = $[1];
        if (typeof L == "string") {
          var B = $[2] === !0, H = $[3] === !0, q = B || H, J = $[2];
          H && (J = $[2]), a = this.$locale(), !B && J && (a = E.Ls[J]), this.$d = function(G, K, ee) {
            try {
              if (["x", "X"].indexOf(K) > -1) return new Date((K === "X" ? 1e3 : 1) * G);
              var te = v(K)(G), M = te.year, Z = te.month, ne = te.day, R = te.hours, _ = te.minutes, W = te.seconds, Q = te.milliseconds, oe = te.zone, ae = /* @__PURE__ */ new Date(), pe = ne || (M || Z ? 1 : ae.getDate()), me = M || ae.getFullYear(), xe = 0;
              M && !Z || (xe = Z > 0 ? Z - 1 : ae.getMonth());
              var le = R || 0, ye = _ || 0, be = W || 0, Re = Q || 0;
              return oe ? new Date(Date.UTC(me, xe, pe, le, ye, be, Re + 60 * oe.offset * 1e3)) : ee ? new Date(Date.UTC(me, xe, pe, le, ye, be, Re)) : new Date(me, xe, pe, le, ye, be, Re);
            } catch {
              return /* @__PURE__ */ new Date("");
            }
          }(A, L, I), this.init(), J && J !== !0 && (this.$L = this.locale(J).$L), q && A != this.format(L) && (this.$d = /* @__PURE__ */ new Date("")), a = {};
        } else if (L instanceof Array) for (var X = L.length, j = 1; j <= X; j += 1) {
          $[1] = L[j - 1];
          var U = E.apply(this, $);
          if (U.isValid()) {
            this.$d = U.$d, this.$L = U.$L, this.init();
            break;
          }
          j === X && (this.$d = /* @__PURE__ */ new Date(""));
        }
        else w.call(this, O);
      };
    };
  });
})(hW);
var gVe = hW.exports;
const yVe = /* @__PURE__ */ Ln(gVe);
var jF = {}, bVe = Eu;
Object.defineProperty(jF, "__esModule", {
  value: !0
});
var mW = jF.default = void 0, vVe = bVe(kd()), xVe = P;
mW = jF.default = (0, vVe.default)(/* @__PURE__ */ (0, xVe.jsx)("path", {
  d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close");
var DVe = Pb, CVe = gc;
function EVe(e, t) {
  var n = -1, r = CVe(e) ? Array(e.length) : [];
  return DVe(e, function(i, o, s) {
    r[++n] = t(i, o, s);
  }), r;
}
var TVe = EVe, SVe = jm, AVe = bc, wVe = TVe, PVe = yi;
function kVe(e, t) {
  var n = PVe(e) ? SVe : wVe;
  return n(e, AVe(t));
}
var OVe = kVe;
const VF = /* @__PURE__ */ Ln(OVe), IVe = ["localeText"], XD = /* @__PURE__ */ V.createContext(null);
process.env.NODE_ENV !== "production" && (XD.displayName = "MuiPickersAdapterContext");
const Od = function(t) {
  var n;
  const {
    localeText: r
  } = t, i = _e(t, IVe), {
    utils: o,
    localeText: s
  } = (n = V.useContext(XD)) != null ? n : {
    utils: void 0,
    localeText: void 0
  }, a = Vn({
    // We don't want to pass the `localeText` prop to the theme, that way it will always return the theme value,
    // We will then merge this theme value with our value manually
    props: i,
    name: "MuiLocalizationProvider"
  }), {
    children: u,
    dateAdapter: c,
    dateFormats: d,
    dateLibInstance: f,
    adapterLocale: h,
    localeText: m
  } = a, v = V.useMemo(() => N({}, m, s, r), [m, s, r]), x = V.useMemo(() => {
    if (!c)
      return o || null;
    const S = new c({
      locale: h,
      formats: d,
      instance: f
    });
    if (!S.isMUIAdapter)
      throw new Error(["MUI: The date adapter should be imported from `@mui/x-date-pickers` or `@mui/x-date-pickers-pro`, not from `@date-io`", "For example, `import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'` instead of `import AdapterDayjs from '@date-io/dayjs'`", "More information on the installation documentation: https://mui.com/x/react-date-pickers/getting-started/#installation"].join(`
`));
    return S;
  }, [c, h, d, f, o]), C = V.useMemo(() => x ? {
    minDate: x.date("1900-01-01T00:00:00.000"),
    maxDate: x.date("2099-12-31T00:00:00.000")
  } : null, [x]), E = V.useMemo(() => ({
    utils: x,
    defaultDates: C,
    localeText: v
  }), [C, x, v]);
  return /* @__PURE__ */ P.jsx(XD.Provider, {
    value: E,
    children: u
  });
};
process.env.NODE_ENV !== "production" && (Od.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Locale for the date library you are using
   */
  adapterLocale: l.any,
  children: l.node,
  /**
   * Date library adapter class function.
   * @see See the localization provider {@link https://mui.com/x/react-date-pickers/getting-started/#setup-your-date-library-adapter date adapter setup section} for more details.
   */
  dateAdapter: l.func,
  /**
   * Formats that are used for any child pickers
   */
  dateFormats: l.shape({
    dayOfMonth: l.string,
    fullDate: l.string,
    fullDateTime: l.string,
    fullDateTime12h: l.string,
    fullDateTime24h: l.string,
    fullDateWithWeekday: l.string,
    fullTime: l.string,
    fullTime12h: l.string,
    fullTime24h: l.string,
    hours12h: l.string,
    hours24h: l.string,
    keyboardDate: l.string,
    keyboardDateTime: l.string,
    keyboardDateTime12h: l.string,
    keyboardDateTime24h: l.string,
    meridiem: l.string,
    minutes: l.string,
    month: l.string,
    monthAndDate: l.string,
    monthAndYear: l.string,
    monthShort: l.string,
    normalDate: l.string,
    normalDateWithWeekday: l.string,
    seconds: l.string,
    shortDate: l.string,
    weekday: l.string,
    weekdayShort: l.string,
    year: l.string
  }),
  /**
   * Date library instance you are using, if it has some global overrides
   * ```jsx
   * dateLibInstance={momentTimeZone}
   * ```
   */
  dateLibInstance: l.any,
  /**
   * Locale for components texts
   */
  localeText: l.object
});
const FVe = (e) => ({
  components: {
    MuiLocalizationProvider: {
      defaultProps: {
        localeText: N({}, e)
      }
    }
  }
}), gW = {
  // Calendar navigation
  previousMonth: "Previous month",
  nextMonth: "Next month",
  // View navigation
  openPreviousView: "open previous view",
  openNextView: "open next view",
  calendarViewSwitchingButtonAriaLabel: (e) => e === "year" ? "year view is open, switch to calendar view" : "calendar view is open, switch to year view",
  // DateRange placeholders
  start: "Start",
  end: "End",
  // Action bar
  cancelButtonLabel: "Cancel",
  clearButtonLabel: "Clear",
  okButtonLabel: "OK",
  todayButtonLabel: "Today",
  // Toolbar titles
  datePickerToolbarTitle: "Select date",
  dateTimePickerToolbarTitle: "Select date & time",
  timePickerToolbarTitle: "Select time",
  dateRangePickerToolbarTitle: "Select date range",
  // Clock labels
  clockLabelText: (e, t, n) => `Select ${e}. ${t === null ? "No time selected" : `Selected time is ${n.format(t, "fullTime")}`}`,
  hoursClockNumberText: (e) => `${e} hours`,
  minutesClockNumberText: (e) => `${e} minutes`,
  secondsClockNumberText: (e) => `${e} seconds`,
  // Digital clock labels
  selectViewText: (e) => `Select ${e}`,
  // Calendar labels
  calendarWeekNumberHeaderLabel: "Week number",
  calendarWeekNumberHeaderText: "#",
  calendarWeekNumberAriaLabelText: (e) => `Week ${e}`,
  calendarWeekNumberText: (e) => `${e}`,
  // Open picker labels
  openDatePickerDialogue: (e, t) => e !== null && t.isValid(e) ? `Choose date, selected date is ${t.format(e, "fullDate")}` : "Choose date",
  openTimePickerDialogue: (e, t) => e !== null && t.isValid(e) ? `Choose time, selected time is ${t.format(e, "fullTime")}` : "Choose time",
  fieldClearLabel: "Clear value",
  // Table labels
  timeTableLabel: "pick time",
  dateTableLabel: "pick date",
  // Field section placeholders
  fieldYearPlaceholder: (e) => "Y".repeat(e.digitAmount),
  fieldMonthPlaceholder: (e) => e.contentType === "letter" ? "MMMM" : "MM",
  fieldDayPlaceholder: () => "DD",
  fieldWeekDayPlaceholder: (e) => e.contentType === "letter" ? "EEEE" : "EE",
  fieldHoursPlaceholder: () => "hh",
  fieldMinutesPlaceholder: () => "mm",
  fieldSecondsPlaceholder: () => "ss",
  fieldMeridiemPlaceholder: () => "aa"
}, $Ve = gW;
FVe(gW);
const xf = () => {
  const e = V.useContext(XD);
  if (e === null)
    throw new Error(["MUI: Can not find the date and time pickers localization context.", "It looks like you forgot to wrap your component in LocalizationProvider.", "This can also happen if you are bundling multiple versions of the `@mui/x-date-pickers` package"].join(`
`));
  if (e.utils === null)
    throw new Error(["MUI: Can not find the date and time pickers adapter from its localization context.", "It looks like you forgot to pass a `dateAdapter` to your LocalizationProvider."].join(`
`));
  const t = V.useMemo(() => N({}, $Ve, e.localeText), [e.localeText]);
  return V.useMemo(() => N({}, e, {
    localeText: t
  }), [e, t]);
}, Nn = () => xf().utils, Df = () => xf().defaultDates, Yi = () => xf().localeText, Cf = (e) => {
  const t = Nn(), n = V.useRef();
  return n.current === void 0 && (n.current = t.dateWithTimezone(void 0, e)), n.current;
};
function NVe(e) {
  return typeof e == "string";
}
function MVe(e, t, n) {
  return e === void 0 || NVe(e) ? t : N({}, t, {
    ownerState: N({}, t.ownerState, n)
  });
}
function RVe(e, t = []) {
  if (e === void 0)
    return {};
  const n = {};
  return Object.keys(e).filter((r) => r.match(/^on[A-Z]/) && typeof e[r] == "function" && !t.includes(r)).forEach((r) => {
    n[r] = e[r];
  }), n;
}
function Id(e, t, n) {
  return typeof e == "function" ? e(t, n) : e;
}
function ij(e) {
  if (e === void 0)
    return {};
  const t = {};
  return Object.keys(e).filter((n) => !(n.match(/^on[A-Z]/) && typeof e[n] == "function")).forEach((n) => {
    t[n] = e[n];
  }), t;
}
function _Ve(e) {
  const {
    getSlotProps: t,
    additionalProps: n,
    externalSlotProps: r,
    externalForwardedProps: i,
    className: o
  } = e;
  if (!t) {
    const m = Be(n == null ? void 0 : n.className, o, i == null ? void 0 : i.className, r == null ? void 0 : r.className), v = N({}, n == null ? void 0 : n.style, i == null ? void 0 : i.style, r == null ? void 0 : r.style), x = N({}, n, i, r);
    return m.length > 0 && (x.className = m), Object.keys(v).length > 0 && (x.style = v), {
      props: x,
      internalRef: void 0
    };
  }
  const s = RVe(N({}, i, r)), a = ij(r), u = ij(i), c = t(s), d = Be(c == null ? void 0 : c.className, n == null ? void 0 : n.className, o, i == null ? void 0 : i.className, r == null ? void 0 : r.className), f = N({}, c == null ? void 0 : c.style, n == null ? void 0 : n.style, i == null ? void 0 : i.style, r == null ? void 0 : r.style), h = N({}, c, n, u, a);
  return d.length > 0 && (h.className = d), Object.keys(f).length > 0 && (h.style = f), {
    props: h,
    internalRef: c.ref
  };
}
const LVe = ["elementType", "externalSlotProps", "ownerState", "skipResolvingSlotProps"];
function si(e) {
  var t;
  const {
    elementType: n,
    externalSlotProps: r,
    ownerState: i,
    skipResolvingSlotProps: o = !1
  } = e, s = _e(e, LVe), a = o ? {} : Id(r, i), {
    props: u,
    internalRef: c
  } = _Ve(N({}, s, {
    externalSlotProps: a
  })), d = Hn(c, a == null ? void 0 : a.ref, (t = e.additionalProps) == null ? void 0 : t.ref);
  return MVe(n, N({}, u, {
    ref: d
  }), i);
}
const BVe = Rr(/* @__PURE__ */ P.jsx("path", {
  d: "M7 10l5 5 5-5z"
}), "ArrowDropDown"), jVe = Rr(/* @__PURE__ */ P.jsx("path", {
  d: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
}), "ArrowLeft"), VVe = Rr(/* @__PURE__ */ P.jsx("path", {
  d: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
}), "ArrowRight"), yW = Rr(/* @__PURE__ */ P.jsx("path", {
  d: "M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"
}), "Calendar"), zVe = Rr(/* @__PURE__ */ P.jsxs(V.Fragment, {
  children: [/* @__PURE__ */ P.jsx("path", {
    d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
  }), /* @__PURE__ */ P.jsx("path", {
    d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
  })]
}), "Clock"), UVe = Rr(/* @__PURE__ */ P.jsx("path", {
  d: "M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z"
}), "DateRange"), WVe = Rr(/* @__PURE__ */ P.jsxs(V.Fragment, {
  children: [/* @__PURE__ */ P.jsx("path", {
    d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
  }), /* @__PURE__ */ P.jsx("path", {
    d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
  })]
}), "Time"), HVe = Rr(/* @__PURE__ */ P.jsx("path", {
  d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Clear");
function qVe(e) {
  return ot("MuiPickersArrowSwitcher", e);
}
st("MuiPickersArrowSwitcher", ["root", "spacer", "button"]);
const GVe = ["children", "className", "slots", "slotProps", "isNextDisabled", "isNextHidden", "onGoToNext", "nextLabel", "isPreviousDisabled", "isPreviousHidden", "onGoToPrevious", "previousLabel"], YVe = ["ownerState"], KVe = ["ownerState"], JVe = De("div", {
  name: "MuiPickersArrowSwitcher",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "flex"
}), XVe = De("div", {
  name: "MuiPickersArrowSwitcher",
  slot: "Spacer",
  overridesResolver: (e, t) => t.spacer
})(({
  theme: e
}) => ({
  width: e.spacing(3)
})), oj = De(Or, {
  name: "MuiPickersArrowSwitcher",
  slot: "Button",
  overridesResolver: (e, t) => t.button
})(({
  ownerState: e
}) => N({}, e.hidden && {
  visibility: "hidden"
})), QVe = (e) => {
  const {
    classes: t
  } = e;
  return at({
    root: ["root"],
    spacer: ["spacer"],
    button: ["button"]
  }, qVe, t);
}, bW = /* @__PURE__ */ V.forwardRef(function(t, n) {
  var r, i, o, s;
  const u = Gi().direction === "rtl", c = Vn({
    props: t,
    name: "MuiPickersArrowSwitcher"
  }), {
    children: d,
    className: f,
    slots: h,
    slotProps: m,
    isNextDisabled: v,
    isNextHidden: x,
    onGoToNext: C,
    nextLabel: E,
    isPreviousDisabled: S,
    isPreviousHidden: w,
    onGoToPrevious: O,
    previousLabel: A
  } = c, I = _e(c, GVe), $ = c, L = QVe($), B = {
    isDisabled: v,
    isHidden: x,
    goTo: C,
    label: E
  }, H = {
    isDisabled: S,
    isHidden: w,
    goTo: O,
    label: A
  }, q = (r = h == null ? void 0 : h.previousIconButton) != null ? r : oj, J = si({
    elementType: q,
    externalSlotProps: m == null ? void 0 : m.previousIconButton,
    additionalProps: {
      size: "medium",
      title: H.label,
      "aria-label": H.label,
      disabled: H.isDisabled,
      edge: "end",
      onClick: H.goTo
    },
    ownerState: N({}, $, {
      hidden: H.isHidden
    }),
    className: L.button
  }), X = (i = h == null ? void 0 : h.nextIconButton) != null ? i : oj, j = si({
    elementType: X,
    externalSlotProps: m == null ? void 0 : m.nextIconButton,
    additionalProps: {
      size: "medium",
      title: B.label,
      "aria-label": B.label,
      disabled: B.isDisabled,
      edge: "start",
      onClick: B.goTo
    },
    ownerState: N({}, $, {
      hidden: B.isHidden
    }),
    className: L.button
  }), U = (o = h == null ? void 0 : h.leftArrowIcon) != null ? o : jVe, G = si({
    elementType: U,
    externalSlotProps: m == null ? void 0 : m.leftArrowIcon,
    additionalProps: {
      fontSize: "inherit"
    },
    ownerState: void 0
  }), K = _e(G, YVe), ee = (s = h == null ? void 0 : h.rightArrowIcon) != null ? s : VVe, te = si({
    elementType: ee,
    externalSlotProps: m == null ? void 0 : m.rightArrowIcon,
    additionalProps: {
      fontSize: "inherit"
    },
    ownerState: void 0
  }), M = _e(te, KVe);
  return /* @__PURE__ */ P.jsxs(JVe, N({
    ref: n,
    className: Be(L.root, f),
    ownerState: $
  }, I, {
    children: [/* @__PURE__ */ P.jsx(q, N({}, J, {
      children: u ? /* @__PURE__ */ P.jsx(ee, N({}, M)) : /* @__PURE__ */ P.jsx(U, N({}, K))
    })), d ? /* @__PURE__ */ P.jsx(cn, {
      variant: "subtitle1",
      component: "span",
      children: d
    }) : /* @__PURE__ */ P.jsx(XVe, {
      className: L.spacer,
      ownerState: $
    }), /* @__PURE__ */ P.jsx(X, N({}, j, {
      children: u ? /* @__PURE__ */ P.jsx(U, N({}, K)) : /* @__PURE__ */ P.jsx(ee, N({}, M))
    }))]
  }));
}), Kl = (e, t) => e.length !== t.length ? !1 : t.every((n) => e.includes(n)), zF = ({
  openTo: e,
  defaultOpenTo: t,
  views: n,
  defaultViews: r
}) => {
  const i = n ?? r;
  let o;
  if (e != null)
    o = e;
  else if (i.includes(t))
    o = t;
  else if (i.length > 0)
    o = i[0];
  else
    throw new Error("MUI: The `views` prop must contain at least one view");
  return {
    views: i,
    openTo: o
  };
}, vW = ["hours", "minutes", "seconds"], bm = (e) => vW.includes(e), Kc = (e) => vW.includes(e) || e === "meridiem", ZVe = (e, t) => e ? t.getHours(e) >= 12 ? "pm" : "am" : null, H0 = (e, t, n) => n && (e >= 12 ? "pm" : "am") !== t ? t === "am" ? e - 12 : e + 12 : e, eze = (e, t, n, r) => {
  const i = H0(r.getHours(e), t, n);
  return r.setHours(e, i);
}, sj = (e, t) => t.getHours(e) * 3600 + t.getMinutes(e) * 60 + t.getSeconds(e), lv = (e, t) => (n, r) => e ? t.isAfter(n, r) : sj(n, t) > sj(r, t), QD = (e, {
  format: t,
  views: n,
  ampm: r
}) => {
  if (t != null)
    return t;
  const i = e.formats;
  return Kl(n, ["hours"]) ? r ? `${i.hours12h} ${i.meridiem}` : i.hours24h : Kl(n, ["minutes"]) ? i.minutes : Kl(n, ["seconds"]) ? i.seconds : Kl(n, ["minutes", "seconds"]) ? `${i.minutes}:${i.seconds}` : Kl(n, ["hours", "minutes", "seconds"]) ? r ? `${i.hours12h}:${i.minutes}:${i.seconds} ${i.meridiem}` : `${i.hours24h}:${i.minutes}:${i.seconds}` : r ? `${i.hours12h}:${i.minutes} ${i.meridiem}` : `${i.hours24h}:${i.minutes}`;
};
let rw = !1;
function uv({
  onChange: e,
  onViewChange: t,
  openTo: n,
  view: r,
  views: i,
  autoFocus: o,
  focusedView: s,
  onFocusedViewChange: a
}) {
  var u, c;
  process.env.NODE_ENV !== "production" && (rw || (r != null && !i.includes(r) && (console.warn(`MUI: \`view="${r}"\` is not a valid prop.`, `It must be an element of \`views=["${i.join('", "')}"]\`.`), rw = !0), r == null && n != null && !i.includes(n) && (console.warn(`MUI: \`openTo="${n}"\` is not a valid prop.`, `It must be an element of \`views=["${i.join('", "')}"]\`.`), rw = !0)));
  const d = V.useRef(n), f = V.useRef(i), h = V.useRef(i.includes(n) ? n : i[0]), [m, v] = Hi({
    name: "useViews",
    state: "view",
    controlled: r,
    default: h.current
  }), x = V.useRef(o ? m : null), [C, E] = Hi({
    name: "useViews",
    state: "focusedView",
    controlled: s,
    default: x.current
  });
  V.useEffect(() => {
    (d.current && d.current !== n || f.current && f.current.some((B) => !i.includes(B))) && (v(i.includes(n) ? n : i[0]), f.current = i, d.current = n);
  }, [n, v, m, i]);
  const S = i.indexOf(m), w = (u = i[S - 1]) != null ? u : null, O = (c = i[S + 1]) != null ? c : null, A = Mt((B, H) => {
    E(H ? B : (q) => B === q ? null : q), a == null || a(B, H);
  }), I = Mt((B) => {
    A(B, !0), B !== m && (v(B), t && t(B));
  }), $ = Mt(() => {
    O && I(O);
  }), L = Mt((B, H, q) => {
    const J = H === "finish", X = q ? (
      // handles case like `DateTimePicker`, where a view might return a `finish` selection state
      // but we it's not the final view given all `views` -> overall selection state should be `partial`.
      i.indexOf(q) < i.length - 1
    ) : !!O;
    if (e(B, J && X ? "partial" : H, q), q && q !== m) {
      const U = i[i.indexOf(q) + 1];
      U && I(U);
    } else J && $();
  });
  return {
    view: m,
    setView: I,
    focusedView: C,
    setFocusedView: A,
    nextView: O,
    previousView: w,
    // Always return up to date default view instead of the initial one (i.e. defaultView.current)
    defaultView: i.includes(n) ? n : i[0],
    goToNextView: $,
    setValueAndGoToNextView: L
  };
}
function tze(e, {
  disableFuture: t,
  maxDate: n,
  timezone: r
}) {
  const i = Nn();
  return V.useMemo(() => {
    const o = i.dateWithTimezone(void 0, r), s = i.startOfMonth(t && i.isBefore(o, n) ? o : n);
    return !i.isAfter(s, e);
  }, [t, n, e, i, r]);
}
function nze(e, {
  disablePast: t,
  minDate: n,
  timezone: r
}) {
  const i = Nn();
  return V.useMemo(() => {
    const o = i.dateWithTimezone(void 0, r), s = i.startOfMonth(t && i.isAfter(o, n) ? o : n);
    return !i.isBefore(s, e);
  }, [t, n, e, i, r]);
}
function qE(e, t, n, r) {
  const i = Nn(), o = ZVe(e, i), s = V.useCallback((a) => {
    const u = e == null ? null : eze(e, a, !!t, i);
    n(u, r ?? "partial");
  }, [t, e, n, r, i]);
  return {
    meridiemMode: o,
    handleMeridiemChange: s
  };
}
const q0 = 36, GE = 2, YE = 320, rze = 280, KE = 334, xW = 232, Gy = 48, JE = De("div")({
  overflow: "hidden",
  width: YE,
  maxHeight: KE,
  display: "flex",
  flexDirection: "column",
  margin: "0 auto"
});
function ize(e) {
  return ot("MuiTimeClock", e);
}
st("MuiTimeClock", ["root", "arrowSwitcher"]);
const vm = 220, du = 36, G0 = {
  x: vm / 2,
  y: vm / 2
}, DW = {
  x: G0.x,
  y: 0
}, oze = DW.x - G0.x, sze = DW.y - G0.y, aze = (e) => e * (180 / Math.PI), CW = (e, t, n) => {
  const r = t - G0.x, i = n - G0.y, o = Math.atan2(oze, sze) - Math.atan2(r, i);
  let s = aze(o);
  s = Math.round(s / e) * e, s %= 360;
  const a = Math.floor(s / e) || 0, u = r ** 2 + i ** 2, c = Math.sqrt(u);
  return {
    value: a,
    distance: c
  };
}, lze = (e, t, n = 1) => {
  const r = n * 6;
  let {
    value: i
  } = CW(r, e, t);
  return i = i * n % 60, i;
}, uze = (e, t, n) => {
  const {
    value: r,
    distance: i
  } = CW(30, e, t);
  let o = r || 12;
  return n ? o %= 12 : i < vm / 2 - du && (o += 12, o %= 24), o;
};
function cze(e) {
  return ot("MuiClockPointer", e);
}
st("MuiClockPointer", ["root", "thumb"]);
const dze = ["className", "hasSelected", "isInner", "type", "viewValue"], pze = (e) => {
  const {
    classes: t
  } = e;
  return at({
    root: ["root"],
    thumb: ["thumb"]
  }, cze, t);
}, fze = De("div", {
  name: "MuiClockPointer",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e,
  ownerState: t
}) => N({
  width: 2,
  backgroundColor: (e.vars || e).palette.primary.main,
  position: "absolute",
  left: "calc(50% - 1px)",
  bottom: "50%",
  transformOrigin: "center bottom 0px"
}, t.shouldAnimate && {
  transition: e.transitions.create(["transform", "height"])
})), hze = De("div", {
  name: "MuiClockPointer",
  slot: "Thumb",
  overridesResolver: (e, t) => t.thumb
})(({
  theme: e,
  ownerState: t
}) => N({
  width: 4,
  height: 4,
  backgroundColor: (e.vars || e).palette.primary.contrastText,
  borderRadius: "50%",
  position: "absolute",
  top: -21,
  left: `calc(50% - ${du / 2}px)`,
  border: `${(du - 4) / 2}px solid ${(e.vars || e).palette.primary.main}`,
  boxSizing: "content-box"
}, t.hasSelected && {
  backgroundColor: (e.vars || e).palette.primary.main
}));
function mze(e) {
  const t = Vn({
    props: e,
    name: "MuiClockPointer"
  }), {
    className: n,
    isInner: r,
    type: i,
    viewValue: o
  } = t, s = _e(t, dze), a = V.useRef(i);
  V.useEffect(() => {
    a.current = i;
  }, [i]);
  const u = N({}, t, {
    shouldAnimate: a.current !== i
  }), c = pze(u), d = () => {
    let h = 360 / (i === "hours" ? 12 : 60) * o;
    return i === "hours" && o > 12 && (h -= 360), {
      height: Math.round((r ? 0.26 : 0.4) * vm),
      transform: `rotateZ(${h}deg)`
    };
  };
  return /* @__PURE__ */ P.jsx(fze, N({
    style: d(),
    className: Be(n, c.root),
    ownerState: u
  }, s, {
    children: /* @__PURE__ */ P.jsx(hze, {
      ownerState: u,
      className: c.thumb
    })
  }));
}
function gze(e) {
  return ot("MuiClock", e);
}
st("MuiClock", ["root", "clock", "wrapper", "squareMask", "pin", "amButton", "pmButton", "meridiemText"]);
const ZD = (e, t, n) => {
  let r = t;
  return r = e.setHours(r, e.getHours(n)), r = e.setMinutes(r, e.getMinutes(n)), r = e.setSeconds(r, e.getSeconds(n)), r;
}, f0 = ({
  date: e,
  disableFuture: t,
  disablePast: n,
  maxDate: r,
  minDate: i,
  isDateDisabled: o,
  utils: s,
  timezone: a
}) => {
  const u = ZD(s, s.dateWithTimezone(void 0, a), e);
  n && s.isBefore(i, u) && (i = u), t && s.isAfter(r, u) && (r = u);
  let c = e, d = e;
  for (s.isBefore(e, i) && (c = i, d = null), s.isAfter(e, r) && (d && (d = r), c = null); c || d; ) {
    if (c && s.isAfter(c, r) && (c = null), d && s.isBefore(d, i) && (d = null), c) {
      if (!o(c))
        return c;
      c = s.addDays(c, 1);
    }
    if (d) {
      if (!o(d))
        return d;
      d = s.addDays(d, -1);
    }
  }
  return null;
}, yze = (e, t) => t == null || !e.isValid(t) ? null : t, Lo = (e, t, n) => t == null || !e.isValid(t) ? n : t, bze = (e, t, n) => !e.isValid(t) && t != null && !e.isValid(n) && n != null ? !0 : e.isEqual(t, n), UF = (e, t) => {
  const r = [e.startOfYear(t)];
  for (; r.length < 12; ) {
    const i = r[r.length - 1];
    r.push(e.addMonths(i, 1));
  }
  return r;
}, WF = (e, t, n) => n === "date" ? e.startOfDay(e.dateWithTimezone(void 0, t)) : e.dateWithTimezone(void 0, t), ml = (e, t) => {
  const n = e.setHours(e.date(), t === "am" ? 2 : 14);
  return e.format(n, "meridiem");
}, vze = ["year", "month", "day"], Yh = (e) => vze.includes(e), Y0 = (e, {
  format: t,
  views: n
}, r) => {
  if (t != null)
    return t;
  const i = e.formats;
  return Kl(n, ["year"]) ? i.year : Kl(n, ["month"]) ? i.month : Kl(n, ["day"]) ? i.dayOfMonth : Kl(n, ["month", "year"]) ? `${i.month} ${i.year}` : Kl(n, ["day", "month"]) ? `${i.month} ${i.dayOfMonth}` : r ? /en/.test(e.getCurrentLocaleCode()) ? i.normalDateWithWeekday : i.normalDate : i.keyboardDate;
}, xze = (e, t) => {
  const n = e.startOfWeek(t);
  return [0, 1, 2, 3, 4, 5, 6].map((r) => e.addDays(n, r));
}, Dze = (e) => {
  const {
    classes: t
  } = e;
  return at({
    root: ["root"],
    clock: ["clock"],
    wrapper: ["wrapper"],
    squareMask: ["squareMask"],
    pin: ["pin"],
    amButton: ["amButton"],
    pmButton: ["pmButton"],
    meridiemText: ["meridiemText"]
  }, gze, t);
}, Cze = De("div", {
  name: "MuiClock",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e
}) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  margin: e.spacing(2)
})), Eze = De("div", {
  name: "MuiClock",
  slot: "Clock",
  overridesResolver: (e, t) => t.clock
})({
  backgroundColor: "rgba(0,0,0,.07)",
  borderRadius: "50%",
  height: 220,
  width: 220,
  flexShrink: 0,
  position: "relative",
  pointerEvents: "none"
}), Tze = De("div", {
  name: "MuiClock",
  slot: "Wrapper",
  overridesResolver: (e, t) => t.wrapper
})({
  "&:focus": {
    outline: "none"
  }
}), Sze = De("div", {
  name: "MuiClock",
  slot: "SquareMask",
  overridesResolver: (e, t) => t.squareMask
})(({
  ownerState: e
}) => N({
  width: "100%",
  height: "100%",
  position: "absolute",
  pointerEvents: "auto",
  outline: 0,
  // Disable scroll capabilities.
  touchAction: "none",
  userSelect: "none"
}, e.disabled ? {} : {
  "@media (pointer: fine)": {
    cursor: "pointer",
    borderRadius: "50%"
  },
  "&:active": {
    cursor: "move"
  }
})), Aze = De("div", {
  name: "MuiClock",
  slot: "Pin",
  overridesResolver: (e, t) => t.pin
})(({
  theme: e
}) => ({
  width: 6,
  height: 6,
  borderRadius: "50%",
  backgroundColor: (e.vars || e).palette.primary.main,
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)"
})), wze = De(Or, {
  name: "MuiClock",
  slot: "AmButton",
  overridesResolver: (e, t) => t.amButton
})(({
  theme: e,
  ownerState: t
}) => N({
  zIndex: 1,
  position: "absolute",
  bottom: 8,
  left: 8,
  paddingLeft: 4,
  paddingRight: 4,
  width: du
}, t.meridiemMode === "am" && {
  backgroundColor: (e.vars || e).palette.primary.main,
  color: (e.vars || e).palette.primary.contrastText,
  "&:hover": {
    backgroundColor: (e.vars || e).palette.primary.light
  }
})), Pze = De(Or, {
  name: "MuiClock",
  slot: "PmButton",
  overridesResolver: (e, t) => t.pmButton
})(({
  theme: e,
  ownerState: t
}) => N({
  zIndex: 1,
  position: "absolute",
  bottom: 8,
  right: 8,
  paddingLeft: 4,
  paddingRight: 4,
  width: du
}, t.meridiemMode === "pm" && {
  backgroundColor: (e.vars || e).palette.primary.main,
  color: (e.vars || e).palette.primary.contrastText,
  "&:hover": {
    backgroundColor: (e.vars || e).palette.primary.light
  }
})), aj = De(cn, {
  name: "MuiClock",
  slot: "meridiemText",
  overridesResolver: (e, t) => t.meridiemText
})({
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis"
});
function kze(e) {
  const t = Vn({
    props: e,
    name: "MuiClock"
  }), {
    ampm: n,
    ampmInClock: r,
    autoFocus: i,
    children: o,
    value: s,
    handleMeridiemChange: a,
    isTimeDisabled: u,
    meridiemMode: c,
    minutesStep: d = 1,
    onChange: f,
    selectedId: h,
    type: m,
    viewValue: v,
    disabled: x,
    readOnly: C,
    className: E
  } = t, S = t, w = Nn(), O = Yi(), A = V.useRef(!1), I = Dze(S), $ = u(v, m), L = !n && m === "hours" && (v < 1 || v > 12), B = (te, M) => {
    x || C || u(te, m) || f(te, M);
  }, H = (te, M) => {
    let {
      offsetX: Z,
      offsetY: ne
    } = te;
    if (Z === void 0) {
      const _ = te.target.getBoundingClientRect();
      Z = te.changedTouches[0].clientX - _.left, ne = te.changedTouches[0].clientY - _.top;
    }
    const R = m === "seconds" || m === "minutes" ? lze(Z, ne, d) : uze(Z, ne, !!n);
    B(R, M);
  }, q = (te) => {
    A.current = !0, H(te, "shallow");
  }, J = (te) => {
    A.current && (H(te, "finish"), A.current = !1);
  }, X = (te) => {
    te.buttons > 0 && H(te.nativeEvent, "shallow");
  }, j = (te) => {
    A.current && (A.current = !1), H(te.nativeEvent, "finish");
  }, U = V.useMemo(() => m === "hours" ? !0 : v % 5 === 0, [m, v]), G = m === "minutes" ? d : 1, K = V.useRef(null);
  gi(() => {
    i && K.current.focus();
  }, [i]);
  const ee = (te) => {
    if (!A.current)
      switch (te.key) {
        case "Home":
          B(0, "partial"), te.preventDefault();
          break;
        case "End":
          B(m === "minutes" ? 59 : 23, "partial"), te.preventDefault();
          break;
        case "ArrowUp":
          B(v + G, "partial"), te.preventDefault();
          break;
        case "ArrowDown":
          B(v - G, "partial"), te.preventDefault();
          break;
      }
  };
  return /* @__PURE__ */ P.jsxs(Cze, {
    className: Be(E, I.root),
    children: [/* @__PURE__ */ P.jsxs(Eze, {
      className: I.clock,
      children: [/* @__PURE__ */ P.jsx(Sze, {
        onTouchMove: q,
        onTouchEnd: J,
        onMouseUp: j,
        onMouseMove: X,
        ownerState: {
          disabled: x
        },
        className: I.squareMask
      }), !$ && /* @__PURE__ */ P.jsxs(V.Fragment, {
        children: [/* @__PURE__ */ P.jsx(Aze, {
          className: I.pin
        }), s != null && /* @__PURE__ */ P.jsx(mze, {
          type: m,
          viewValue: v,
          isInner: L,
          hasSelected: U
        })]
      }), /* @__PURE__ */ P.jsx(Tze, {
        "aria-activedescendant": h,
        "aria-label": O.clockLabelText(m, s, w),
        ref: K,
        role: "listbox",
        onKeyDown: ee,
        tabIndex: 0,
        className: I.wrapper,
        children: o
      })]
    }), n && r && /* @__PURE__ */ P.jsxs(V.Fragment, {
      children: [/* @__PURE__ */ P.jsx(wze, {
        onClick: C ? void 0 : () => a("am"),
        disabled: x || c === null,
        ownerState: S,
        className: I.amButton,
        title: ml(w, "am"),
        children: /* @__PURE__ */ P.jsx(aj, {
          variant: "caption",
          className: I.meridiemText,
          children: ml(w, "am")
        })
      }), /* @__PURE__ */ P.jsx(Pze, {
        disabled: x || c === null,
        onClick: C ? void 0 : () => a("pm"),
        ownerState: S,
        className: I.pmButton,
        title: ml(w, "pm"),
        children: /* @__PURE__ */ P.jsx(aj, {
          variant: "caption",
          className: I.meridiemText,
          children: ml(w, "pm")
        })
      })]
    })]
  });
}
function Oze(e) {
  return ot("MuiClockNumber", e);
}
const X1 = st("MuiClockNumber", ["root", "selected", "disabled"]), Ize = ["className", "disabled", "index", "inner", "label", "selected"], Fze = (e) => {
  const {
    classes: t,
    selected: n,
    disabled: r
  } = e;
  return at({
    root: ["root", n && "selected", r && "disabled"]
  }, Oze, t);
}, $ze = De("span", {
  name: "MuiClockNumber",
  slot: "Root",
  overridesResolver: (e, t) => [t.root, {
    [`&.${X1.disabled}`]: t.disabled
  }, {
    [`&.${X1.selected}`]: t.selected
  }]
})(({
  theme: e,
  ownerState: t
}) => N({
  height: du,
  width: du,
  position: "absolute",
  left: `calc((100% - ${du}px) / 2)`,
  display: "inline-flex",
  justifyContent: "center",
  alignItems: "center",
  borderRadius: "50%",
  color: (e.vars || e).palette.text.primary,
  fontFamily: e.typography.fontFamily,
  "&:focused": {
    backgroundColor: (e.vars || e).palette.background.paper
  },
  [`&.${X1.selected}`]: {
    color: (e.vars || e).palette.primary.contrastText
  },
  [`&.${X1.disabled}`]: {
    pointerEvents: "none",
    color: (e.vars || e).palette.text.disabled
  }
}, t.inner && N({}, e.typography.body2, {
  color: (e.vars || e).palette.text.secondary
})));
function EW(e) {
  const t = Vn({
    props: e,
    name: "MuiClockNumber"
  }), {
    className: n,
    disabled: r,
    index: i,
    inner: o,
    label: s,
    selected: a
  } = t, u = _e(t, Ize), c = t, d = Fze(c), f = i % 12 / 12 * Math.PI * 2 - Math.PI / 2, h = (vm - du - 2) / 2 * (o ? 0.65 : 1), m = Math.round(Math.cos(f) * h), v = Math.round(Math.sin(f) * h);
  return /* @__PURE__ */ P.jsx($ze, N({
    className: Be(n, d.root),
    "aria-disabled": r ? !0 : void 0,
    "aria-selected": a ? !0 : void 0,
    role: "option",
    style: {
      transform: `translate(${m}px, ${v + (vm - du) / 2}px`
    },
    ownerState: c
  }, u, {
    children: s
  }));
}
const Nze = ({
  ampm: e,
  value: t,
  getClockNumberText: n,
  isDisabled: r,
  selectedId: i,
  utils: o
}) => {
  const s = t ? o.getHours(t) : null, a = [], u = e ? 1 : 0, c = e ? 12 : 23, d = (f) => s === null ? !1 : e ? f === 12 ? s === 12 || s === 0 : s === f || s - 12 === f : s === f;
  for (let f = u; f <= c; f += 1) {
    let h = f.toString();
    f === 0 && (h = "00");
    const m = !e && (f === 0 || f > 12);
    h = o.formatNumber(h);
    const v = d(f);
    a.push(/* @__PURE__ */ P.jsx(EW, {
      id: v ? i : void 0,
      index: f,
      inner: m,
      selected: v,
      disabled: r(f),
      label: h,
      "aria-label": n(h)
    }, f));
  }
  return a;
}, lj = ({
  utils: e,
  value: t,
  isDisabled: n,
  getClockNumberText: r,
  selectedId: i
}) => {
  const o = e.formatNumber;
  return [[5, o("05")], [10, o("10")], [15, o("15")], [20, o("20")], [25, o("25")], [30, o("30")], [35, o("35")], [40, o("40")], [45, o("45")], [50, o("50")], [55, o("55")], [0, o("00")]].map(([s, a], u) => {
    const c = s === t;
    return /* @__PURE__ */ P.jsx(EW, {
      label: a,
      id: c ? i : void 0,
      index: u + 1,
      inner: !1,
      disabled: n(s),
      selected: c,
      "aria-label": r(a)
    }, s);
  });
}, HF = ({
  timezone: e,
  value: t,
  defaultValue: n,
  onChange: r,
  valueManager: i
}) => {
  var o, s;
  const a = Nn(), u = V.useRef(n), c = (o = t ?? u.current) != null ? o : i.emptyValue, d = V.useMemo(() => i.getTimezone(a, c), [a, i, c]), f = Mt((x) => d == null ? x : i.setTimezone(a, d, x)), h = (s = e ?? d) != null ? s : "default", m = V.useMemo(() => i.setTimezone(a, h, c), [i, a, h, c]), v = Mt((x, ...C) => {
    const E = f(x);
    r == null || r(E, ...C);
  });
  return {
    value: m,
    handleValueChange: v,
    timezone: h
  };
}, hg = ({
  name: e,
  timezone: t,
  value: n,
  defaultValue: r,
  onChange: i,
  valueManager: o
}) => {
  const [s, a] = Hi({
    name: e,
    state: "value",
    controlled: n,
    default: r ?? o.emptyValue
  }), u = Mt((c, ...d) => {
    a(c), i == null || i(c, ...d);
  });
  return HF({
    timezone: t,
    value: s,
    defaultValue: void 0,
    onChange: u,
    valueManager: o
  });
}, pl = {
  year: 1,
  month: 2,
  day: 3,
  hours: 4,
  minutes: 5,
  seconds: 6,
  milliseconds: 7
}, Mze = (e) => Math.max(...e.map((t) => {
  var n;
  return (n = pl[t.type]) != null ? n : 1;
})), Oy = (e, t, n) => {
  if (t === pl.year)
    return e.startOfYear(n);
  if (t === pl.month)
    return e.startOfMonth(n);
  if (t === pl.day)
    return e.startOfDay(n);
  let r = n;
  return t < pl.minutes && (r = e.setMinutes(r, 0)), t < pl.seconds && (r = e.setSeconds(r, 0)), t < pl.milliseconds && (r = e.setMilliseconds(r, 0)), r;
}, Rze = ({
  props: e,
  utils: t,
  granularity: n,
  timezone: r,
  getTodayDate: i
}) => {
  var o;
  let s = i ? i() : Oy(t, n, WF(t, r));
  e.minDate != null && t.isAfterDay(e.minDate, s) && (s = Oy(t, n, e.minDate)), e.maxDate != null && t.isBeforeDay(e.maxDate, s) && (s = Oy(t, n, e.maxDate));
  const a = lv((o = e.disableIgnoringDatePartForTimeValidation) != null ? o : !1, t);
  return e.minTime != null && a(e.minTime, s) && (s = Oy(t, n, e.disableIgnoringDatePartForTimeValidation ? e.minTime : ZD(t, s, e.minTime))), e.maxTime != null && a(s, e.maxTime) && (s = Oy(t, n, e.disableIgnoringDatePartForTimeValidation ? e.maxTime : ZD(t, s, e.maxTime))), s;
}, qF = (e, t) => {
  const n = e.formatTokenMap[t];
  if (n == null)
    throw new Error([`MUI: The token "${t}" is not supported by the Date and Time Pickers.`, "Please try using another token or open an issue on https://github.com/mui/mui-x/issues/new/choose if you think it should be supported."].join(`
`));
  return typeof n == "string" ? {
    type: n,
    contentType: n === "meridiem" ? "letter" : "digit",
    maxLength: void 0
  } : {
    type: n.sectionType,
    contentType: n.contentType,
    maxLength: n.maxLength
  };
}, _ze = (e) => {
  switch (e) {
    case "ArrowUp":
      return 1;
    case "ArrowDown":
      return -1;
    case "PageUp":
      return 5;
    case "PageDown":
      return -5;
    default:
      return 0;
  }
}, XE = (e, t, n) => {
  const r = [], i = e.dateWithTimezone(void 0, t), o = e.startOfWeek(i), s = e.endOfWeek(i);
  let a = o;
  for (; e.isBefore(a, s); )
    r.push(a), a = e.addDays(a, 1);
  return r.map((u) => e.formatByString(u, n));
}, TW = (e, t, n, r) => {
  switch (n) {
    case "month":
      return UF(e, e.dateWithTimezone(void 0, t)).map((i) => e.formatByString(i, r));
    case "weekDay":
      return XE(e, t, r);
    case "meridiem": {
      const i = e.dateWithTimezone(void 0, t);
      return [e.startOfDay(i), e.endOfDay(i)].map((o) => e.formatByString(o, r));
    }
    default:
      return [];
  }
}, SW = (e, t, n) => {
  let r = t;
  for (r = Number(r).toString(); r.length < n; )
    r = `0${r}`;
  return r;
}, AW = (e, t, n, r, i) => {
  if (process.env.NODE_ENV !== "production" && i.type !== "day" && i.contentType === "digit-with-letter")
    throw new Error([`MUI: The token "${i.format}" is a digit format with letter in it.'
             This type of format is only supported for 'day' sections`].join(`
`));
  if (i.type === "day" && i.contentType === "digit-with-letter") {
    const s = e.setDate(r.longestMonth, n);
    return e.formatByString(s, i.format);
  }
  const o = n.toString();
  return i.hasLeadingZerosInInput ? SW(e, o, i.maxLength) : o;
}, Lze = (e, t, n, r, i, o, s) => {
  const a = _ze(r), u = r === "Home", c = r === "End", d = n.value === "" || u || c, f = () => {
    const m = i[n.type]({
      currentDate: o,
      format: n.format,
      contentType: n.contentType
    }), v = (S) => AW(e, t, S, m, n), x = n.type === "minutes" && s != null && s.minutesStep ? s.minutesStep : 1;
    let E = parseInt(n.value, 10) + a * x;
    if (d) {
      if (n.type === "year" && !c && !u)
        return e.formatByString(e.dateWithTimezone(void 0, t), n.format);
      a > 0 || u ? E = m.minimum : E = m.maximum;
    }
    return E % x !== 0 && ((a < 0 || u) && (E += x - (x + E) % x), (a > 0 || c) && (E -= E % x)), E > m.maximum ? v(m.minimum + (E - m.maximum - 1) % (m.maximum - m.minimum + 1)) : E < m.minimum ? v(m.maximum - (m.minimum - E - 1) % (m.maximum - m.minimum + 1)) : v(E);
  }, h = () => {
    const m = TW(e, t, n.type, n.format);
    if (m.length === 0)
      return n.value;
    if (d)
      return a > 0 || u ? m[0] : m[m.length - 1];
    const x = (m.indexOf(n.value) + m.length + a) % m.length;
    return m[x];
  };
  return n.contentType === "digit" || n.contentType === "digit-with-letter" ? f() : h();
}, GF = (e, t) => {
  let n = e.value || e.placeholder;
  const r = t === "non-input" ? e.hasLeadingZerosInFormat : e.hasLeadingZerosInInput;
  return t === "non-input" && e.hasLeadingZerosInInput && !e.hasLeadingZerosInFormat && (n = Number(n).toString()), ["input-rtl", "input-ltr"].includes(t) && e.contentType === "digit" && !r && n.length === 1 && (n = `${n}‎`), t === "input-rtl" && (n = `⁨${n}⁩`), n;
}, Mh = (e) => e.replace(/[\u2066\u2067\u2068\u2069]/g, ""), wW = (e, t) => {
  let n = 0, r = t ? 1 : 0;
  const i = [];
  for (let o = 0; o < e.length; o += 1) {
    const s = e[o], a = GF(s, t ? "input-rtl" : "input-ltr"), u = `${s.startSeparator}${a}${s.endSeparator}`, c = Mh(u).length, d = u.length, f = Mh(a), h = r + a.indexOf(f[0]) + s.startSeparator.length, m = h + f.length;
    i.push(N({}, s, {
      start: n,
      end: n + c,
      startInInput: h,
      endInInput: m
    })), n += c, r += d;
  }
  return i;
}, Bze = (e, t, n, r, i) => {
  switch (r.type) {
    case "year":
      return n.fieldYearPlaceholder({
        digitAmount: e.formatByString(e.dateWithTimezone(void 0, t), i).length,
        format: i
      });
    case "month":
      return n.fieldMonthPlaceholder({
        contentType: r.contentType,
        format: i
      });
    case "day":
      return n.fieldDayPlaceholder({
        format: i
      });
    case "weekDay":
      return n.fieldWeekDayPlaceholder({
        contentType: r.contentType,
        format: i
      });
    case "hours":
      return n.fieldHoursPlaceholder({
        format: i
      });
    case "minutes":
      return n.fieldMinutesPlaceholder({
        format: i
      });
    case "seconds":
      return n.fieldSecondsPlaceholder({
        format: i
      });
    case "meridiem":
      return n.fieldMeridiemPlaceholder({
        format: i
      });
    default:
      return i;
  }
}, uj = (e, t, n, r) => {
  if (process.env.NODE_ENV !== "production" && qF(e, n).type === "weekDay")
    throw new Error("changeSectionValueFormat doesn't support week day formats");
  return e.formatByString(e.parse(t, n), r);
}, PW = (e, t, n) => e.formatByString(e.dateWithTimezone(void 0, t), n).length === 4, kW = (e, t, n, r, i) => {
  if (n !== "digit")
    return !1;
  const o = e.dateWithTimezone(void 0, t);
  switch (r) {
    case "year":
      return PW(e, t, i) ? e.formatByString(e.setYear(o, 1), i) === "0001" : e.formatByString(e.setYear(o, 2001), i) === "01";
    case "month":
      return e.formatByString(e.startOfYear(o), i).length > 1;
    case "day":
      return e.formatByString(e.startOfMonth(o), i).length > 1;
    case "weekDay":
      return e.formatByString(e.startOfWeek(o), i).length > 1;
    case "hours":
      return e.formatByString(e.setHours(o, 1), i).length > 1;
    case "minutes":
      return e.formatByString(e.setMinutes(o, 1), i).length > 1;
    case "seconds":
      return e.formatByString(e.setSeconds(o, 1), i).length > 1;
    default:
      throw new Error("Invalid section type");
  }
}, jze = (e, t) => {
  const n = [], {
    start: r,
    end: i
  } = e.escapedCharacters, o = new RegExp(`(\\${r}[^\\${i}]*\\${i})+`, "g");
  let s = null;
  for (; s = o.exec(t); )
    n.push({
      start: s.index,
      end: o.lastIndex - 1
    });
  return n;
}, cj = (e, t, n, r, i, o, s, a) => {
  let u = "";
  const c = [], d = e.date(), f = (w) => {
    if (w === "")
      return null;
    const O = qF(e, w), A = kW(e, t, O.contentType, O.type, w), I = s ? A : O.contentType === "digit", $ = i != null && e.isValid(i);
    let L = $ ? e.formatByString(i, w) : "", B = null;
    if (I)
      if (A)
        B = L === "" ? e.formatByString(d, w).length : L.length;
      else {
        if (O.maxLength == null)
          throw new Error(`MUI: The token ${w} should have a 'maxDigitNumber' property on it's adapter`);
        B = O.maxLength, $ && (L = SW(e, L, B));
      }
    return c.push(N({}, O, {
      format: w,
      maxLength: B,
      value: L,
      placeholder: Bze(e, t, n, O, w),
      hasLeadingZeros: A,
      hasLeadingZerosInFormat: A,
      hasLeadingZerosInInput: I,
      startSeparator: c.length === 0 ? u : "",
      endSeparator: "",
      modified: !1
    })), null;
  };
  let h = 10, m = r, v = e.expandFormat(r);
  for (; v !== m; )
    if (m = v, v = e.expandFormat(m), h -= 1, h < 0)
      throw new Error("MUI: The format expansion seems to be  enter in an infinite loop. Please open an issue with the format passed to the picker component");
  const x = v, C = jze(e, x), E = new RegExp(`^(${Object.keys(e.formatTokenMap).sort((w, O) => O.length - w.length).join("|")})`, "g");
  let S = "";
  for (let w = 0; w < x.length; w += 1) {
    const O = C.find((B) => B.start <= w && B.end >= w), A = x[w], I = O != null, $ = `${S}${x.slice(w)}`, L = E.test($);
    !I && A.match(/([A-Za-z]+)/) && L ? (S = $.slice(0, E.lastIndex), w += E.lastIndex - 1) : I && (O == null ? void 0 : O.start) === w || (O == null ? void 0 : O.end) === w || (f(S), S = "", c.length === 0 ? u += A : c[c.length - 1].endSeparator += A);
  }
  return f(S), c.map((w) => {
    const O = (A) => {
      let I = A;
      return a && I !== null && I.includes(" ") && (I = `⁩${I}⁦`), o === "spacious" && ["/", ".", "-"].includes(I) && (I = ` ${I} `), I;
    };
    return w.startSeparator = O(w.startSeparator), w.endSeparator = O(w.endSeparator), w;
  });
}, Vze = (e, t) => {
  const n = t.some((a) => a.type === "day"), r = [], i = [];
  for (let a = 0; a < t.length; a += 1) {
    const u = t[a];
    n && u.type === "weekDay" || (r.push(u.format), i.push(GF(u, "non-input")));
  }
  const o = r.join(" "), s = i.join(" ");
  return e.parse(s, o);
}, zze = (e, t) => {
  const r = e.map((i) => {
    const o = GF(i, t ? "input-rtl" : "input-ltr");
    return `${i.startSeparator}${o}${i.endSeparator}`;
  }).join("");
  return t ? `⁦${r}⁩` : r;
}, Uze = (e, t) => {
  const n = e.dateWithTimezone(void 0, t), r = e.endOfYear(n), i = e.endOfDay(n), {
    maxDaysInMonth: o,
    longestMonth: s
  } = UF(e, n).reduce((a, u) => {
    const c = e.getDaysInMonth(u);
    return c > a.maxDaysInMonth ? {
      maxDaysInMonth: c,
      longestMonth: u
    } : a;
  }, {
    maxDaysInMonth: 0,
    longestMonth: null
  });
  return {
    year: ({
      format: a
    }) => ({
      minimum: 0,
      maximum: PW(e, t, a) ? 9999 : 99
    }),
    month: () => ({
      minimum: 1,
      // Assumption: All years have the same amount of months
      maximum: e.getMonth(r) + 1
    }),
    day: ({
      currentDate: a
    }) => ({
      minimum: 1,
      maximum: a != null && e.isValid(a) ? e.getDaysInMonth(a) : o,
      longestMonth: s
    }),
    weekDay: ({
      format: a,
      contentType: u
    }) => {
      if (u === "digit") {
        const c = XE(e, t, a).map(Number);
        return {
          minimum: Math.min(...c),
          maximum: Math.max(...c)
        };
      }
      return {
        minimum: 1,
        maximum: 7
      };
    },
    hours: ({
      format: a
    }) => {
      const u = e.getHours(i);
      return e.formatByString(e.endOfDay(n), a) !== u.toString() ? {
        minimum: 1,
        maximum: Number(e.formatByString(e.startOfDay(n), a))
      } : {
        minimum: 0,
        maximum: u
      };
    },
    minutes: () => ({
      minimum: 0,
      // Assumption: All years have the same amount of minutes
      maximum: e.getMinutes(i)
    }),
    seconds: () => ({
      minimum: 0,
      // Assumption: All years have the same amount of seconds
      maximum: e.getSeconds(i)
    }),
    meridiem: () => ({
      minimum: 0,
      maximum: 0
    })
  };
};
let dj = !1;
const pj = (e, t) => {
  if (process.env.NODE_ENV !== "production" && !dj) {
    const n = [];
    ["date", "date-time"].includes(t) && n.push("weekDay", "day", "month", "year"), ["time", "date-time"].includes(t) && n.push("hours", "minutes", "seconds", "meridiem");
    const r = e.find((i) => !n.includes(i.type));
    r && (console.warn(`MUI: The field component you are using is not compatible with the "${r.type} date section.`, `The supported date sections are ["${n.join('", "')}"]\`.`), dj = !0);
  }
}, Wze = (e, t, n, r, i) => {
  switch (n.type) {
    case "year":
      return e.setYear(i, e.getYear(r));
    case "month":
      return e.setMonth(i, e.getMonth(r));
    case "weekDay": {
      const o = XE(e, t, n.format), s = e.formatByString(r, n.format), a = o.indexOf(s), c = o.indexOf(n.value) - a;
      return e.addDays(r, c);
    }
    case "day":
      return e.setDate(i, e.getDate(r));
    case "meridiem": {
      const o = e.getHours(r) < 12, s = e.getHours(i);
      return o && s >= 12 ? e.addHours(i, -12) : !o && s < 12 ? e.addHours(i, 12) : i;
    }
    case "hours":
      return e.setHours(i, e.getHours(r));
    case "minutes":
      return e.setMinutes(i, e.getMinutes(r));
    case "seconds":
      return e.setSeconds(i, e.getSeconds(r));
    default:
      return i;
  }
}, fj = {
  year: 1,
  month: 2,
  day: 3,
  weekDay: 4,
  hours: 5,
  minutes: 6,
  seconds: 7,
  meridiem: 8
}, hj = (e, t, n, r, i, o) => (
  // cloning sections before sort to avoid mutating it
  [...r].sort((s, a) => fj[s.type] - fj[a.type]).reduce((s, a) => !o || a.modified ? Wze(e, t, a, n, s) : s, i)
), Hze = () => navigator.userAgent.toLowerCase().indexOf("android") > -1, qze = (e, t) => {
  const n = {};
  if (!t)
    return e.forEach((u, c) => {
      const d = c === 0 ? null : c - 1, f = c === e.length - 1 ? null : c + 1;
      n[c] = {
        leftIndex: d,
        rightIndex: f
      };
    }), {
      neighbors: n,
      startIndex: 0,
      endIndex: e.length - 1
    };
  const r = {}, i = {};
  let o = 0, s = 0, a = e.length - 1;
  for (; a >= 0; ) {
    s = e.findIndex(
      // eslint-disable-next-line @typescript-eslint/no-loop-func
      (u, c) => {
        var d;
        return c >= o && ((d = u.endSeparator) == null ? void 0 : d.includes(" ")) && // Special case where the spaces were not there in the initial input
        u.endSeparator !== " / ";
      }
    ), s === -1 && (s = e.length - 1);
    for (let u = s; u >= o; u -= 1)
      i[u] = a, r[a] = u, a -= 1;
    o = s + 1;
  }
  return e.forEach((u, c) => {
    const d = i[c], f = d === 0 ? null : r[d - 1], h = d === e.length - 1 ? null : r[d + 1];
    n[c] = {
      leftIndex: f,
      rightIndex: h
    };
  }), {
    neighbors: n,
    startIndex: r[0],
    endIndex: r[e.length - 1]
  };
}, Gze = ["value", "referenceDate"], qi = {
  emptyValue: null,
  getTodayValue: WF,
  getInitialReferenceValue: (e) => {
    let {
      value: t,
      referenceDate: n
    } = e, r = _e(e, Gze);
    return t != null && r.utils.isValid(t) ? t : n ?? Rze(r);
  },
  cleanValue: yze,
  areValuesEqual: bze,
  isSameError: (e, t) => e === t,
  hasError: (e) => e != null,
  defaultErrorState: null,
  getTimezone: (e, t) => t == null || !e.isValid(t) ? null : e.getTimezone(t),
  setTimezone: (e, t, n) => n == null ? null : e.setTimezone(n, t)
}, YF = {
  updateReferenceValue: (e, t, n) => t == null || !e.isValid(t) ? n : t,
  getSectionsFromValue: (e, t, n, r, i) => !e.isValid(t) && !!n ? n : wW(i(t), r),
  getValueStrFromSections: zze,
  getActiveDateManager: (e, t) => ({
    date: t.value,
    referenceDate: t.referenceValue,
    getSections: (n) => n,
    getNewValuesFromNewActiveDate: (n) => ({
      value: n,
      referenceValue: n == null || !e.isValid(n) ? t.referenceValue : n
    })
  }),
  parseValueStr: (e, t, n) => n(e.trim(), t)
}, cv = (e) => {
  if (e !== void 0)
    return Object.keys(e).reduce((t, n) => N({}, t, {
      [`${n.slice(0, 1).toLowerCase()}${n.slice(1)}`]: e[n]
    }), {});
}, KF = ({
  value: e,
  referenceDate: t,
  utils: n,
  props: r,
  timezone: i
}) => {
  const o = V.useMemo(
    () => qi.getInitialReferenceValue({
      value: e,
      utils: n,
      props: r,
      referenceDate: t,
      granularity: pl.day,
      timezone: i,
      getTodayDate: () => WF(n, i, "date")
    }),
    // We only want to compute the reference date on mount.
    []
    // eslint-disable-line react-hooks/exhaustive-deps
  );
  return e ?? o;
}, Yze = ["ampm", "ampmInClock", "autoFocus", "components", "componentsProps", "slots", "slotProps", "value", "defaultValue", "referenceDate", "disableIgnoringDatePartForTimeValidation", "maxTime", "minTime", "disableFuture", "disablePast", "minutesStep", "shouldDisableClock", "shouldDisableTime", "showViewSwitcher", "onChange", "view", "views", "openTo", "onViewChange", "focusedView", "onFocusedViewChange", "className", "disabled", "readOnly", "timezone"], Kze = (e) => {
  const {
    classes: t
  } = e;
  return at({
    root: ["root"],
    arrowSwitcher: ["arrowSwitcher"]
  }, ize, t);
}, Jze = De(JE, {
  name: "MuiTimeClock",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "flex",
  flexDirection: "column",
  position: "relative"
}), Xze = De(bW, {
  name: "MuiTimeClock",
  slot: "ArrowSwitcher",
  overridesResolver: (e, t) => t.arrowSwitcher
})({
  position: "absolute",
  right: 12,
  top: 15
}), Qze = ["hours", "minutes"], OW = /* @__PURE__ */ V.forwardRef(function(t, n) {
  const r = Nn(), i = Vn({
    props: t,
    name: "MuiTimeClock"
  }), {
    ampm: o = r.is12HourCycleInCurrentLocale(),
    ampmInClock: s = !1,
    autoFocus: a,
    components: u,
    componentsProps: c,
    slots: d,
    slotProps: f,
    value: h,
    defaultValue: m,
    referenceDate: v,
    disableIgnoringDatePartForTimeValidation: x = !1,
    maxTime: C,
    minTime: E,
    disableFuture: S,
    disablePast: w,
    minutesStep: O = 1,
    shouldDisableClock: A,
    shouldDisableTime: I,
    showViewSwitcher: $,
    onChange: L,
    view: B,
    views: H = Qze,
    openTo: q,
    onViewChange: J,
    focusedView: X,
    onFocusedViewChange: j,
    className: U,
    disabled: G,
    readOnly: K,
    timezone: ee
  } = i, te = _e(i, Yze), M = d ?? cv(u), Z = f ?? c, {
    value: ne,
    handleValueChange: R,
    timezone: _
  } = hg({
    name: "TimeClock",
    timezone: ee,
    value: h,
    defaultValue: m,
    onChange: L,
    valueManager: qi
  }), W = KF({
    value: ne,
    referenceDate: v,
    utils: r,
    props: i,
    timezone: _
  }), Q = Yi(), oe = Cf(_), {
    view: ae,
    setView: pe,
    previousView: me,
    nextView: xe,
    setValueAndGoToNextView: le
  } = uv({
    view: B,
    views: H,
    openTo: q,
    onViewChange: J,
    onChange: R,
    focusedView: X,
    onFocusedViewChange: j
  }), {
    meridiemMode: ye,
    handleMeridiemChange: be
  } = qE(W, o, le), Re = V.useCallback((Ee, Ie) => {
    const Je = lv(x, r), vt = Ie === "hours" || Ie === "minutes" && H.includes("seconds"), St = ({
      start: ke,
      end: Le
    }) => !(E && Je(E, Le) || C && Je(ke, C) || S && Je(ke, oe) || w && Je(oe, vt ? Le : ke)), Lt = (ke, Le = 1) => {
      if (ke % Le !== 0 || A != null && A(ke, Ie))
        return !1;
      if (I)
        switch (Ie) {
          case "hours":
            return !I(r.setHours(W, ke), "hours");
          case "minutes":
            return !I(r.setMinutes(W, ke), "minutes");
          case "seconds":
            return !I(r.setSeconds(W, ke), "seconds");
          default:
            return !1;
        }
      return !0;
    };
    switch (Ie) {
      case "hours": {
        const ke = H0(Ee, ye, o), Le = r.setHours(W, ke), Pe = r.setSeconds(r.setMinutes(Le, 0), 0), Ae = r.setSeconds(r.setMinutes(Le, 59), 59);
        return !St({
          start: Pe,
          end: Ae
        }) || !Lt(ke);
      }
      case "minutes": {
        const ke = r.setMinutes(W, Ee), Le = r.setSeconds(ke, 0), Pe = r.setSeconds(ke, 59);
        return !St({
          start: Le,
          end: Pe
        }) || !Lt(Ee, O);
      }
      case "seconds": {
        const ke = r.setSeconds(W, Ee);
        return !St({
          start: ke,
          end: ke
        }) || !Lt(Ee);
      }
      default:
        throw new Error("not supported");
    }
  }, [o, W, x, C, ye, E, O, A, I, r, S, w, oe, H]), Te = Pl(), Xe = V.useMemo(() => {
    switch (ae) {
      case "hours": {
        const Ee = (Ie, Je) => {
          const vt = H0(Ie, ye, o);
          le(r.setHours(W, vt), Je);
        };
        return {
          onChange: Ee,
          viewValue: r.getHours(W),
          children: Nze({
            value: ne,
            utils: r,
            ampm: o,
            onChange: Ee,
            getClockNumberText: Q.hoursClockNumberText,
            isDisabled: (Ie) => G || Re(Ie, "hours"),
            selectedId: Te
          })
        };
      }
      case "minutes": {
        const Ee = r.getMinutes(W), Ie = (Je, vt) => {
          le(r.setMinutes(W, Je), vt);
        };
        return {
          viewValue: Ee,
          onChange: Ie,
          children: lj({
            utils: r,
            value: Ee,
            onChange: Ie,
            getClockNumberText: Q.minutesClockNumberText,
            isDisabled: (Je) => G || Re(Je, "minutes"),
            selectedId: Te
          })
        };
      }
      case "seconds": {
        const Ee = r.getSeconds(W), Ie = (Je, vt) => {
          le(r.setSeconds(W, Je), vt);
        };
        return {
          viewValue: Ee,
          onChange: Ie,
          children: lj({
            utils: r,
            value: Ee,
            onChange: Ie,
            getClockNumberText: Q.secondsClockNumberText,
            isDisabled: (Je) => G || Re(Je, "seconds"),
            selectedId: Te
          })
        };
      }
      default:
        throw new Error("You must provide the type for ClockView");
    }
  }, [ae, r, ne, o, Q.hoursClockNumberText, Q.minutesClockNumberText, Q.secondsClockNumberText, ye, le, W, Re, Te, G]), Ne = i, Qe = Kze(Ne);
  return /* @__PURE__ */ P.jsxs(Jze, N({
    ref: n,
    className: Be(Qe.root, U),
    ownerState: Ne
  }, te, {
    children: [/* @__PURE__ */ P.jsx(kze, N({
      autoFocus: a ?? !!X,
      ampmInClock: s && H.includes("hours"),
      value: ne,
      type: ae,
      ampm: o,
      minutesStep: O,
      isTimeDisabled: Re,
      meridiemMode: ye,
      handleMeridiemChange: be,
      selectedId: Te,
      disabled: G,
      readOnly: K
    }, Xe)), $ && /* @__PURE__ */ P.jsx(Xze, {
      className: Qe.arrowSwitcher,
      slots: M,
      slotProps: Z,
      onGoToPrevious: () => pe(me),
      isPreviousDisabled: !me,
      previousLabel: Q.openPreviousView,
      onGoToNext: () => pe(xe),
      isNextDisabled: !xe,
      nextLabel: Q.openNextView,
      ownerState: Ne
    })]
  }));
});
process.env.NODE_ENV !== "production" && (OW.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * 12h/24h view for hour selection clock.
   * @default `utils.is12HourCycleInCurrentLocale()`
   */
  ampm: l.bool,
  /**
   * Display ampm controls under the clock (instead of in the toolbar).
   * @default false
   */
  ampmInClock: l.bool,
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: l.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  className: l.string,
  /**
   * Overridable components.
   * @default {}
   * @deprecated Please use `slots`.
   */
  components: l.object,
  /**
   * The props used for each component slot.
   * @default {}
   * @deprecated Please use `slotProps`.
   */
  componentsProps: l.object,
  /**
   * The default selected value.
   * Used when the component is not controlled.
   */
  defaultValue: l.any,
  /**
   * If `true`, the picker views and text field are disabled.
   * @default false
   */
  disabled: l.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: l.bool,
  /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */
  disableIgnoringDatePartForTimeValidation: l.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: l.bool,
  /**
   * Controlled focused view.
   */
  focusedView: l.oneOf(["hours", "minutes", "seconds"]),
  /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  maxTime: l.any,
  /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  minTime: l.any,
  /**
   * Step over minutes.
   * @default 1
   */
  minutesStep: l.number,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TView The view type. Will be one of date or time views.
   * @param {TValue} value The new value.
   * @param {PickerSelectionState | undefined} selectionState Indicates if the date selection is complete.
   * @param {TView | undefined} selectedView Indicates the view in which the selection has been made.
   */
  onChange: l.func,
  /**
   * Callback fired on focused view change.
   * @template TView
   * @param {TView} view The new view to focus or not.
   * @param {boolean} hasFocus `true` if the view should be focused.
   */
  onFocusedViewChange: l.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: l.func,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: l.oneOf(["hours", "minutes", "seconds"]),
  /**
   * If `true`, the picker views and text field are read-only.
   * @default false
   */
  readOnly: l.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid time using the validation props, except callbacks such as `shouldDisableTime`.
   */
  referenceDate: l.any,
  /**
   * Disable specific clock time.
   * @param {number} clockValue The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   * @deprecated Consider using `shouldDisableTime`.
   */
  shouldDisableClock: l.func,
  /**
   * Disable specific time.
   * @template TDate
   * @param {TDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */
  shouldDisableTime: l.func,
  showViewSwitcher: l.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: l.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: l.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documention} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: l.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: l.any,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: l.oneOf(["hours", "minutes", "seconds"]),
  /**
   * Available views.
   * @default ['hours', 'minutes']
   */
  views: l.arrayOf(l.oneOf(["hours", "minutes", "seconds"]).isRequired)
});
function Zze(e) {
  return ot("MuiDigitalClock", e);
}
const eUe = st("MuiDigitalClock", ["root", "list", "item"]), tUe = ["ampm", "timeStep", "autoFocus", "components", "componentsProps", "slots", "slotProps", "value", "defaultValue", "referenceDate", "disableIgnoringDatePartForTimeValidation", "maxTime", "minTime", "disableFuture", "disablePast", "minutesStep", "shouldDisableClock", "shouldDisableTime", "onChange", "view", "openTo", "onViewChange", "focusedView", "onFocusedViewChange", "className", "disabled", "readOnly", "views", "skipDisabled", "timezone"], nUe = (e) => {
  const {
    classes: t
  } = e;
  return at({
    root: ["root"],
    list: ["list"],
    item: ["item"]
  }, Zze, t);
}, rUe = De(JE, {
  name: "MuiDigitalClock",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  ownerState: e
}) => ({
  overflowY: "auto",
  width: "100%",
  "@media (prefers-reduced-motion: no-preference)": {
    scrollBehavior: e.alreadyRendered ? "smooth" : "auto"
  },
  maxHeight: xW
})), iUe = De(Pd, {
  name: "MuiDigitalClock",
  slot: "List",
  overridesResolver: (e, t) => t.list
})({
  padding: 0
}), oUe = De(ks, {
  name: "MuiDigitalClock",
  slot: "Item",
  overridesResolver: (e, t) => t.item
})(({
  theme: e
}) => ({
  padding: "8px 16px",
  margin: "2px 4px",
  "&:first-of-type": {
    marginTop: 4
  },
  "&:hover": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.hoverOpacity})` : yu(e.palette.primary.main, e.palette.action.hoverOpacity)
  },
  "&.Mui-selected": {
    backgroundColor: (e.vars || e).palette.primary.main,
    color: (e.vars || e).palette.primary.contrastText,
    "&:focus-visible, &:hover": {
      backgroundColor: (e.vars || e).palette.primary.dark
    }
  },
  "&.Mui-focusVisible": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.focusOpacity})` : yu(e.palette.primary.main, e.palette.action.focusOpacity)
  }
})), IW = /* @__PURE__ */ V.forwardRef(function(t, n) {
  var r, i, o;
  const s = Nn(), a = V.useRef(null), u = Hn(n, a), c = Vn({
    props: t,
    name: "MuiDigitalClock"
  }), {
    ampm: d = s.is12HourCycleInCurrentLocale(),
    timeStep: f = 30,
    autoFocus: h,
    components: m,
    componentsProps: v,
    slots: x,
    slotProps: C,
    value: E,
    defaultValue: S,
    referenceDate: w,
    disableIgnoringDatePartForTimeValidation: O = !1,
    maxTime: A,
    minTime: I,
    disableFuture: $,
    disablePast: L,
    minutesStep: B = 1,
    shouldDisableClock: H,
    shouldDisableTime: q,
    onChange: J,
    view: X,
    openTo: j,
    onViewChange: U,
    focusedView: G,
    onFocusedViewChange: K,
    className: ee,
    disabled: te,
    readOnly: M,
    views: Z = ["hours"],
    skipDisabled: ne = !1,
    timezone: R
  } = c, _ = _e(c, tUe), {
    value: W,
    handleValueChange: Q,
    timezone: oe
  } = hg({
    name: "DigitalClock",
    timezone: R,
    value: E,
    defaultValue: S,
    onChange: J,
    valueManager: qi
  }), ae = Yi(), pe = Cf(oe), me = V.useMemo(() => N({}, c, {
    alreadyRendered: !!a.current
  }), [c]), xe = nUe(me), le = (r = (i = x == null ? void 0 : x.digitalClockItem) != null ? i : m == null ? void 0 : m.DigitalClockItem) != null ? r : oUe, ye = si({
    elementType: le,
    externalSlotProps: (o = C == null ? void 0 : C.digitalClockItem) != null ? o : v == null ? void 0 : v.digitalClockItem,
    ownerState: {},
    className: xe.item
  }), be = KF({
    value: W,
    referenceDate: w,
    utils: s,
    props: c,
    timezone: oe
  }), Re = Mt((Ee) => Q(Ee, "finish", "hours")), {
    setValueAndGoToNextView: Te
  } = uv({
    view: X,
    views: Z,
    openTo: j,
    onViewChange: U,
    onChange: Re,
    focusedView: G,
    onFocusedViewChange: K
  }), Xe = Mt((Ee) => {
    Te(Ee, "finish");
  });
  V.useEffect(() => {
    if (a.current === null)
      return;
    const Ee = a.current.querySelector('[role="listbox"] [role="option"][aria-selected="true"]');
    if (!Ee)
      return;
    const Ie = Ee.offsetTop;
    a.current.scrollTop = Ie - 4;
  });
  const Ne = V.useCallback((Ee) => {
    const Ie = lv(O, s), Je = () => !(I && Ie(I, Ee) || A && Ie(Ee, A) || $ && Ie(Ee, pe) || L && Ie(pe, Ee)), vt = () => s.getMinutes(Ee) % B !== 0 || H != null && H(s.toJsDate(Ee).getTime(), "hours") ? !1 : q ? !q(Ee, "hours") : !0;
    return !Je() || !vt();
  }, [O, s, I, A, $, pe, L, B, H, q]), Qe = V.useMemo(() => {
    const Ee = s.startOfDay(be);
    return [Ee, ...Array.from({
      length: Math.ceil(24 * 60 / f) - 1
    }, (Ie, Je) => s.addMinutes(Ee, f * (Je + 1)))];
  }, [be, f, s]);
  return /* @__PURE__ */ P.jsx(rUe, N({
    ref: u,
    className: Be(xe.root, ee),
    ownerState: me
  }, _, {
    children: /* @__PURE__ */ P.jsx(iUe, {
      autoFocusItem: h || !!G,
      role: "listbox",
      "aria-label": ae.timePickerToolbarTitle,
      className: xe.list,
      children: Qe.map((Ee) => {
        if (ne && Ne(Ee))
          return null;
        const Ie = s.isEqual(Ee, W);
        return /* @__PURE__ */ P.jsx(le, N({
          onClick: () => !M && Xe(Ee),
          selected: Ie,
          disabled: te || Ne(Ee),
          disableRipple: M,
          role: "option",
          "aria-disabled": M,
          "aria-selected": Ie
        }, ye, {
          children: s.format(Ee, d ? "fullTime12h" : "fullTime24h")
        }), s.toISO(Ee));
      })
    })
  }));
});
process.env.NODE_ENV !== "production" && (IW.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * 12h/24h view for hour selection clock.
   * @default `utils.is12HourCycleInCurrentLocale()`
   */
  ampm: l.bool,
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: l.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  className: l.string,
  /**
   * Overrideable components.
   * @default {}
   * @deprecated Please use `slots`.
   */
  components: l.object,
  /**
   * The props used for each component slot.
   * @default {}
   * @deprecated Please use `slotProps`.
   */
  componentsProps: l.object,
  /**
   * The default selected value.
   * Used when the component is not controlled.
   */
  defaultValue: l.any,
  /**
   * If `true`, the picker views and text field are disabled.
   * @default false
   */
  disabled: l.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: l.bool,
  /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */
  disableIgnoringDatePartForTimeValidation: l.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: l.bool,
  /**
   * Controlled focused view.
   */
  focusedView: l.oneOf(["hours"]),
  /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  maxTime: l.any,
  /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  minTime: l.any,
  /**
   * Step over minutes.
   * @default 1
   */
  minutesStep: l.number,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TView The view type. Will be one of date or time views.
   * @param {TValue} value The new value.
   * @param {PickerSelectionState | undefined} selectionState Indicates if the date selection is complete.
   * @param {TView | undefined} selectedView Indicates the view in which the selection has been made.
   */
  onChange: l.func,
  /**
   * Callback fired on focused view change.
   * @template TView
   * @param {TView} view The new view to focus or not.
   * @param {boolean} hasFocus `true` if the view should be focused.
   */
  onFocusedViewChange: l.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: l.func,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: l.oneOf(["hours"]),
  /**
   * If `true`, the picker views and text field are read-only.
   * @default false
   */
  readOnly: l.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid time using the validation props, except callbacks such as `shouldDisableTime`.
   */
  referenceDate: l.any,
  /**
   * Disable specific clock time.
   * @param {number} clockValue The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   * @deprecated Consider using `shouldDisableTime`.
   */
  shouldDisableClock: l.func,
  /**
   * Disable specific time.
   * @template TDate
   * @param {TDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */
  shouldDisableTime: l.func,
  /**
   * If `true`, disabled digital clock items will not be rendered.
   * @default false
   */
  skipDisabled: l.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: l.object,
  /**
   * Overrideable component slots.
   * @default {}
   */
  slots: l.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * The time steps between two time options.
   * For example, if `timeStep = 45`, then the available time options will be `[00:00, 00:45, 01:30, 02:15, 03:00, etc.]`.
   * @default 30
   */
  timeStep: l.number,
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documention} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: l.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: l.any,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: l.oneOf(["hours"]),
  /**
   * Available views.
   * @default ['hours']
   */
  views: l.arrayOf(l.oneOf(["hours"]))
});
function sUe(e) {
  return ot("MuiMultiSectionDigitalClock", e);
}
st("MuiMultiSectionDigitalClock", ["root"]);
function aUe(e) {
  return ot("MuiMultiSectionDigitalClockSection", e);
}
const lUe = st("MuiMultiSectionDigitalClockSection", ["root", "item"]), uUe = ["autoFocus", "onChange", "className", "disabled", "readOnly", "items", "active", "slots", "slotProps", "skipDisabled"], cUe = (e) => {
  const {
    classes: t
  } = e;
  return at({
    root: ["root"],
    item: ["item"]
  }, aUe, t);
}, dUe = De(Pd, {
  name: "MuiMultiSectionDigitalClockSection",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e,
  ownerState: t
}) => ({
  maxHeight: xW,
  width: 56,
  padding: 0,
  overflow: "hidden",
  "@media (prefers-reduced-motion: no-preference)": {
    scrollBehavior: t.alreadyRendered ? "smooth" : "auto"
  },
  "@media (pointer: fine)": {
    "&:hover": {
      overflowY: "auto"
    }
  },
  "@media (pointer: none), (pointer: coarse)": {
    overflowY: "auto"
  },
  "&:not(:first-of-type)": {
    borderLeft: `1px solid ${(e.vars || e).palette.divider}`
  },
  "&:after": {
    display: "block",
    content: '""',
    // subtracting the height of one item, extra margin and borders to make sure the max height is correct
    height: "calc(100% - 40px - 6px)"
  }
})), pUe = De(ks, {
  name: "MuiMultiSectionDigitalClockSection",
  slot: "Item",
  overridesResolver: (e, t) => t.item
})(({
  theme: e
}) => ({
  padding: 8,
  margin: "2px 4px",
  width: Gy,
  justifyContent: "center",
  "&:first-of-type": {
    marginTop: 4
  },
  "&:hover": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.hoverOpacity})` : yu(e.palette.primary.main, e.palette.action.hoverOpacity)
  },
  "&.Mui-selected": {
    backgroundColor: (e.vars || e).palette.primary.main,
    color: (e.vars || e).palette.primary.contrastText,
    "&:focus-visible, &:hover": {
      backgroundColor: (e.vars || e).palette.primary.dark
    }
  },
  "&.Mui-focusVisible": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.focusOpacity})` : yu(e.palette.primary.main, e.palette.action.focusOpacity)
  }
})), fUe = /* @__PURE__ */ V.forwardRef(function(t, n) {
  var r;
  const i = V.useRef(null), o = Hn(n, i), s = V.useRef(null), a = Vn({
    props: t,
    name: "MuiMultiSectionDigitalClockSection"
  }), {
    autoFocus: u,
    onChange: c,
    className: d,
    disabled: f,
    readOnly: h,
    items: m,
    active: v,
    slots: x,
    slotProps: C,
    skipDisabled: E
  } = a, S = _e(a, uUe), w = V.useMemo(() => N({}, a, {
    alreadyRendered: !!i.current
  }), [a]), O = cUe(w), A = (r = x == null ? void 0 : x.digitalClockSectionItem) != null ? r : pUe;
  return V.useEffect(() => {
    if (i.current === null)
      return;
    const I = i.current.querySelector('[role="option"][aria-selected="true"]');
    if (v && u && I && I.focus(), !I || s.current === I)
      return;
    s.current = I;
    const $ = I.offsetTop;
    i.current.scrollTop = $ - 4;
  }), /* @__PURE__ */ P.jsx(dUe, N({
    ref: o,
    className: Be(O.root, d),
    ownerState: w,
    autoFocusItem: u && v,
    role: "listbox"
  }, S, {
    children: m.map((I) => {
      var $, L;
      if (E && ($ = I.isDisabled) != null && $.call(I, I.value))
        return null;
      const B = I.isSelected(I.value);
      return /* @__PURE__ */ P.jsx(A, N({
        onClick: () => !h && c(I.value),
        selected: B,
        disabled: f || ((L = I.isDisabled) == null ? void 0 : L.call(I, I.value)),
        disableRipple: h,
        role: "option",
        "aria-disabled": h,
        "aria-label": I.ariaLabel,
        "aria-selected": B,
        className: O.item
      }, C == null ? void 0 : C.digitalClockSectionItem, {
        children: I.label
      }), I.label);
    })
  }));
}), hUe = ({
  now: e,
  value: t,
  utils: n,
  ampm: r,
  isDisabled: i,
  resolveAriaLabel: o,
  timeStep: s
}) => {
  const a = t ? n.getHours(t) : null, u = [], c = (f) => a === null ? !1 : r ? f === 12 ? a === 12 || a === 0 : a === f || a - 12 === f : a === f, d = r ? 11 : 23;
  for (let f = 0; f <= d; f += s) {
    let h = n.format(n.setHours(e, f), r ? "hours12h" : "hours24h");
    const m = o(parseInt(h, 10).toString());
    h = n.formatNumber(h), u.push({
      value: f,
      label: h,
      isSelected: c,
      isDisabled: i,
      ariaLabel: m
    });
  }
  return u;
}, mj = ({
  value: e,
  utils: t,
  isDisabled: n,
  timeStep: r,
  resolveLabel: i,
  resolveAriaLabel: o,
  hasValue: s = !0
}) => {
  const a = (u) => e === null ? !1 : s && e === u;
  return [...Array.from({
    length: Math.ceil(60 / r)
  }, (u, c) => {
    const d = r * c;
    return {
      value: d,
      label: t.formatNumber(i(d)),
      isDisabled: n,
      isSelected: a,
      ariaLabel: o(d.toString())
    };
  })];
}, mUe = ["ampm", "timeSteps", "autoFocus", "components", "componentsProps", "slots", "slotProps", "value", "defaultValue", "referenceDate", "disableIgnoringDatePartForTimeValidation", "maxTime", "minTime", "disableFuture", "disablePast", "minutesStep", "shouldDisableClock", "shouldDisableTime", "onChange", "view", "views", "openTo", "onViewChange", "focusedView", "onFocusedViewChange", "className", "disabled", "readOnly", "skipDisabled", "timezone"], gUe = (e) => {
  const {
    classes: t
  } = e;
  return at({
    root: ["root"]
  }, sUe, t);
}, yUe = De(JE, {
  name: "MuiMultiSectionDigitalClock",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e
}) => ({
  display: "flex",
  flexDirection: "row",
  width: "100%",
  borderBottom: `1px solid ${(e.vars || e).palette.divider}`
})), FW = /* @__PURE__ */ V.forwardRef(function(t, n) {
  const r = Nn(), i = Vn({
    props: t,
    name: "MuiMultiSectionDigitalClock"
  }), {
    ampm: o = r.is12HourCycleInCurrentLocale(),
    timeSteps: s,
    autoFocus: a,
    components: u,
    componentsProps: c,
    slots: d,
    slotProps: f,
    value: h,
    defaultValue: m,
    referenceDate: v,
    disableIgnoringDatePartForTimeValidation: x = !1,
    maxTime: C,
    minTime: E,
    disableFuture: S,
    disablePast: w,
    minutesStep: O = 1,
    shouldDisableClock: A,
    shouldDisableTime: I,
    onChange: $,
    view: L,
    views: B = ["hours", "minutes"],
    openTo: H,
    onViewChange: q,
    focusedView: J,
    onFocusedViewChange: X,
    className: j,
    disabled: U,
    readOnly: G,
    skipDisabled: K = !1,
    timezone: ee
  } = i, te = _e(i, mUe), {
    value: M,
    handleValueChange: Z,
    timezone: ne
  } = hg({
    name: "MultiSectionDigitalClock",
    timezone: ee,
    value: h,
    defaultValue: m,
    onChange: $,
    valueManager: qi
  }), R = Yi(), _ = Cf(ne), W = V.useMemo(() => N({
    hours: 1,
    minutes: 5,
    seconds: 5
  }, s), [s]), Q = KF({
    value: M,
    referenceDate: v,
    utils: r,
    props: i,
    timezone: ne
  }), oe = Mt((Ee, Ie, Je) => Z(Ee, Ie, Je)), ae = V.useMemo(() => !o || !B.includes("hours") || B.includes("meridiem") ? B : [...B, "meridiem"], [o, B]), {
    view: pe,
    setValueAndGoToNextView: me,
    focusedView: xe
  } = uv({
    view: L,
    views: ae,
    openTo: H,
    onViewChange: q,
    onChange: oe,
    focusedView: J,
    onFocusedViewChange: X
  }), le = Mt((Ee) => {
    me(Ee, "finish", "meridiem");
  }), {
    meridiemMode: ye,
    handleMeridiemChange: be
  } = qE(Q, o, le, "finish"), Re = V.useCallback((Ee, Ie) => {
    const Je = lv(x, r), vt = Ie === "hours" || Ie === "minutes" && ae.includes("seconds"), St = ({
      start: ke,
      end: Le
    }) => !(E && Je(E, Le) || C && Je(ke, C) || S && Je(ke, _) || w && Je(_, vt ? Le : ke)), Lt = (ke, Le = 1) => {
      if (ke % Le !== 0 || A != null && A(ke, Ie))
        return !1;
      if (I)
        switch (Ie) {
          case "hours":
            return !I(r.setHours(Q, ke), "hours");
          case "minutes":
            return !I(r.setMinutes(Q, ke), "minutes");
          case "seconds":
            return !I(r.setSeconds(Q, ke), "seconds");
          default:
            return !1;
        }
      return !0;
    };
    switch (Ie) {
      case "hours": {
        const ke = H0(Ee, ye, o), Le = r.setHours(Q, ke), Pe = r.setSeconds(r.setMinutes(Le, 0), 0), Ae = r.setSeconds(r.setMinutes(Le, 59), 59);
        return !St({
          start: Pe,
          end: Ae
        }) || !Lt(ke);
      }
      case "minutes": {
        const ke = r.setMinutes(Q, Ee), Le = r.setSeconds(ke, 0), Pe = r.setSeconds(ke, 59);
        return !St({
          start: Le,
          end: Pe
        }) || !Lt(Ee, O);
      }
      case "seconds": {
        const ke = r.setSeconds(Q, Ee);
        return !St({
          start: ke,
          end: ke
        }) || !Lt(Ee);
      }
      default:
        throw new Error("not supported");
    }
  }, [o, Q, x, C, ye, E, O, A, I, r, S, w, _, ae]), Te = V.useCallback((Ee) => {
    switch (Ee) {
      case "hours":
        return {
          onChange: (Ie) => {
            const Je = H0(Ie, ye, o);
            me(r.setHours(Q, Je), "finish", "hours");
          },
          items: hUe({
            now: _,
            value: M,
            ampm: o,
            utils: r,
            isDisabled: (Ie) => U || Re(Ie, "hours"),
            timeStep: W.hours,
            resolveAriaLabel: R.hoursClockNumberText
          })
        };
      case "minutes":
        return {
          onChange: (Ie) => {
            me(r.setMinutes(Q, Ie), "finish", "minutes");
          },
          items: mj({
            value: r.getMinutes(Q),
            utils: r,
            isDisabled: (Ie) => U || Re(Ie, "minutes"),
            resolveLabel: (Ie) => r.format(r.setMinutes(_, Ie), "minutes"),
            timeStep: W.minutes,
            hasValue: !!M,
            resolveAriaLabel: R.minutesClockNumberText
          })
        };
      case "seconds":
        return {
          onChange: (Ie) => {
            me(r.setSeconds(Q, Ie), "finish", "seconds");
          },
          items: mj({
            value: r.getSeconds(Q),
            utils: r,
            isDisabled: (Ie) => U || Re(Ie, "seconds"),
            resolveLabel: (Ie) => r.format(r.setSeconds(_, Ie), "seconds"),
            timeStep: W.seconds,
            hasValue: !!M,
            resolveAriaLabel: R.secondsClockNumberText
          })
        };
      case "meridiem": {
        const Ie = ml(r, "am"), Je = ml(r, "pm");
        return {
          onChange: be,
          items: [{
            value: "am",
            label: Ie,
            isSelected: () => !!M && ye === "am",
            ariaLabel: Ie
          }, {
            value: "pm",
            label: Je,
            isSelected: () => !!M && ye === "pm",
            ariaLabel: Je
          }]
        };
      }
      default:
        throw new Error(`Unknown view: ${Ee} found.`);
    }
  }, [_, M, o, r, W.hours, W.minutes, W.seconds, R.hoursClockNumberText, R.minutesClockNumberText, R.secondsClockNumberText, ye, me, Q, U, Re, be]), Xe = V.useMemo(() => ae.reduce((Ee, Ie) => N({}, Ee, {
    [Ie]: Te(Ie)
  }), {}), [ae, Te]), Ne = i, Qe = gUe(Ne);
  return /* @__PURE__ */ P.jsx(yUe, N({
    ref: n,
    className: Be(Qe.root, j),
    ownerState: Ne,
    role: "group"
  }, te, {
    children: Object.entries(Xe).map(([Ee, Ie]) => /* @__PURE__ */ P.jsx(fUe, {
      items: Ie.items,
      onChange: Ie.onChange,
      active: pe === Ee,
      autoFocus: a ?? xe === Ee,
      disabled: U,
      readOnly: G,
      slots: d ?? u,
      slotProps: f ?? c,
      skipDisabled: K,
      "aria-label": R.selectViewText(Ee)
    }, Ee))
  }));
});
process.env.NODE_ENV !== "production" && (FW.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * 12h/24h view for hour selection clock.
   * @default `utils.is12HourCycleInCurrentLocale()`
   */
  ampm: l.bool,
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: l.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  className: l.string,
  /**
   * Overrideable components.
   * @default {}
   * @deprecated Please use `slots`.
   */
  components: l.object,
  /**
   * The props used for each component slot.
   * @default {}
   * @deprecated Please use `slotProps`.
   */
  componentsProps: l.object,
  /**
   * The default selected value.
   * Used when the component is not controlled.
   */
  defaultValue: l.any,
  /**
   * If `true`, the picker views and text field are disabled.
   * @default false
   */
  disabled: l.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: l.bool,
  /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */
  disableIgnoringDatePartForTimeValidation: l.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: l.bool,
  /**
   * Controlled focused view.
   */
  focusedView: l.oneOf(["hours", "meridiem", "minutes", "seconds"]),
  /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  maxTime: l.any,
  /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  minTime: l.any,
  /**
   * Step over minutes.
   * @default 1
   */
  minutesStep: l.number,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TView The view type. Will be one of date or time views.
   * @param {TValue} value The new value.
   * @param {PickerSelectionState | undefined} selectionState Indicates if the date selection is complete.
   * @param {TView | undefined} selectedView Indicates the view in which the selection has been made.
   */
  onChange: l.func,
  /**
   * Callback fired on focused view change.
   * @template TView
   * @param {TView} view The new view to focus or not.
   * @param {boolean} hasFocus `true` if the view should be focused.
   */
  onFocusedViewChange: l.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: l.func,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: l.oneOf(["hours", "meridiem", "minutes", "seconds"]),
  /**
   * If `true`, the picker views and text field are read-only.
   * @default false
   */
  readOnly: l.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid time using the validation props, except callbacks such as `shouldDisableTime`.
   */
  referenceDate: l.any,
  /**
   * Disable specific clock time.
   * @param {number} clockValue The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   * @deprecated Consider using `shouldDisableTime`.
   */
  shouldDisableClock: l.func,
  /**
   * Disable specific time.
   * @template TDate
   * @param {TDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */
  shouldDisableTime: l.func,
  /**
   * If `true`, disabled digital clock items will not be rendered.
   * @default false
   */
  skipDisabled: l.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: l.object,
  /**
   * Overrideable component slots.
   * @default {}
   */
  slots: l.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * The time steps between two time unit options.
   * For example, if `timeStep.minutes = 8`, then the available minute options will be `[0, 8, 16, 24, 32, 40, 48, 56]`.
   * @default{ hours: 1, minutes: 5, seconds: 5 }
   */
  timeSteps: l.shape({
    hours: l.number,
    minutes: l.number,
    seconds: l.number
  }),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documention} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: l.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: l.any,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: l.oneOf(["hours", "meridiem", "minutes", "seconds"]),
  /**
   * Available views.
   * @default ['hours', 'minutes']
   */
  views: l.arrayOf(l.oneOf(["hours", "meridiem", "minutes", "seconds"]).isRequired)
});
function bUe(e) {
  return ot("MuiPickersDay", e);
}
const cp = st("MuiPickersDay", ["root", "dayWithMargin", "dayOutsideMonth", "hiddenDaySpacingFiller", "today", "selected", "disabled"]), vUe = ["autoFocus", "className", "day", "disabled", "disableHighlightToday", "disableMargin", "hidden", "isAnimating", "onClick", "onDaySelect", "onFocus", "onBlur", "onKeyDown", "onMouseDown", "onMouseEnter", "outsideCurrentMonth", "selected", "showDaysOutsideCurrentMonth", "children", "today", "isFirstVisibleCell", "isLastVisibleCell"], xUe = (e) => {
  const {
    selected: t,
    disableMargin: n,
    disableHighlightToday: r,
    today: i,
    disabled: o,
    outsideCurrentMonth: s,
    showDaysOutsideCurrentMonth: a,
    classes: u
  } = e, c = s && !a;
  return at({
    root: ["root", t && !c && "selected", o && "disabled", !n && "dayWithMargin", !r && i && "today", s && a && "dayOutsideMonth", c && "hiddenDaySpacingFiller"],
    hiddenDaySpacingFiller: ["hiddenDaySpacingFiller"]
  }, bUe, u);
}, $W = ({
  theme: e,
  ownerState: t
}) => N({}, e.typography.caption, {
  width: q0,
  height: q0,
  borderRadius: "50%",
  padding: 0,
  // explicitly setting to `transparent` to avoid potentially getting impacted by change from the overridden component
  backgroundColor: "transparent",
  transition: e.transitions.create("background-color", {
    duration: e.transitions.duration.short
  }),
  color: (e.vars || e).palette.text.primary,
  "@media (pointer: fine)": {
    "&:hover": {
      backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.hoverOpacity})` : yu(e.palette.primary.main, e.palette.action.hoverOpacity)
    }
  },
  "&:focus": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.focusOpacity})` : yu(e.palette.primary.main, e.palette.action.focusOpacity),
    [`&.${cp.selected}`]: {
      willChange: "background-color",
      backgroundColor: (e.vars || e).palette.primary.dark
    }
  },
  [`&.${cp.selected}`]: {
    color: (e.vars || e).palette.primary.contrastText,
    backgroundColor: (e.vars || e).palette.primary.main,
    fontWeight: e.typography.fontWeightMedium,
    "&:hover": {
      willChange: "background-color",
      backgroundColor: (e.vars || e).palette.primary.dark
    }
  },
  [`&.${cp.disabled}:not(.${cp.selected})`]: {
    color: (e.vars || e).palette.text.disabled
  },
  [`&.${cp.disabled}&.${cp.selected}`]: {
    opacity: 0.6
  }
}, !t.disableMargin && {
  margin: `0 ${GE}px`
}, t.outsideCurrentMonth && t.showDaysOutsideCurrentMonth && {
  color: (e.vars || e).palette.text.secondary
}, !t.disableHighlightToday && t.today && {
  [`&:not(.${cp.selected})`]: {
    border: `1px solid ${(e.vars || e).palette.text.secondary}`
  }
}), NW = (e, t) => {
  const {
    ownerState: n
  } = e;
  return [t.root, !n.disableMargin && t.dayWithMargin, !n.disableHighlightToday && n.today && t.today, !n.outsideCurrentMonth && n.showDaysOutsideCurrentMonth && t.dayOutsideMonth, n.outsideCurrentMonth && !n.showDaysOutsideCurrentMonth && t.hiddenDaySpacingFiller];
}, DUe = De(sa, {
  name: "MuiPickersDay",
  slot: "Root",
  overridesResolver: NW
})($W), CUe = De("div", {
  name: "MuiPickersDay",
  slot: "Root",
  overridesResolver: NW
})(({
  theme: e,
  ownerState: t
}) => N({}, $W({
  theme: e,
  ownerState: t
}), {
  // visibility: 'hidden' does not work here as it hides the element from screen readers as well
  opacity: 0,
  pointerEvents: "none"
})), Iy = () => {
}, MW = /* @__PURE__ */ V.forwardRef(function(t, n) {
  const r = Vn({
    props: t,
    name: "MuiPickersDay"
  }), {
    autoFocus: i = !1,
    className: o,
    day: s,
    disabled: a = !1,
    disableHighlightToday: u = !1,
    disableMargin: c = !1,
    isAnimating: d,
    onClick: f,
    onDaySelect: h,
    onFocus: m = Iy,
    onBlur: v = Iy,
    onKeyDown: x = Iy,
    onMouseDown: C = Iy,
    onMouseEnter: E = Iy,
    outsideCurrentMonth: S,
    selected: w = !1,
    showDaysOutsideCurrentMonth: O = !1,
    children: A,
    today: I = !1
  } = r, $ = _e(r, vUe), L = N({}, r, {
    autoFocus: i,
    disabled: a,
    disableHighlightToday: u,
    disableMargin: c,
    selected: w,
    showDaysOutsideCurrentMonth: O,
    today: I
  }), B = xUe(L), H = Nn(), q = V.useRef(null), J = Hn(q, n);
  gi(() => {
    i && !a && !d && !S && q.current.focus();
  }, [i, a, d, S]);
  const X = (U) => {
    C(U), S && U.preventDefault();
  }, j = (U) => {
    a || h(s), S && U.currentTarget.focus(), f && f(U);
  };
  return S && !O ? /* @__PURE__ */ P.jsx(CUe, {
    className: Be(B.root, B.hiddenDaySpacingFiller, o),
    ownerState: L,
    role: $.role
  }) : /* @__PURE__ */ P.jsx(DUe, N({
    className: Be(B.root, o),
    ref: J,
    centerRipple: !0,
    disabled: a,
    tabIndex: w ? 0 : -1,
    onKeyDown: (U) => x(U, s),
    onFocus: (U) => m(U, s),
    onBlur: (U) => v(U, s),
    onMouseEnter: (U) => E(U, s),
    onClick: j,
    onMouseDown: X
  }, $, {
    ownerState: L,
    children: A || H.format(s, "dayOfMonth")
  }));
});
process.env.NODE_ENV !== "production" && (MW.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * A ref for imperative actions.
   * It currently only supports `focusVisible()` action.
   */
  action: l.oneOfType([l.func, l.shape({
    current: l.shape({
      focusVisible: l.func.isRequired
    })
  })]),
  /**
   * If `true`, the ripples are centered.
   * They won't start at the cursor interaction position.
   * @default false
   */
  centerRipple: l.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  className: l.string,
  component: l.elementType,
  /**
   * The date to show.
   */
  day: l.any.isRequired,
  /**
   * If `true`, renders as disabled.
   * @default false
   */
  disabled: l.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: l.bool,
  /**
   * If `true`, days are rendering without margin. Useful for displaying linked range of days.
   * @default false
   */
  disableMargin: l.bool,
  /**
   * If `true`, the ripple effect is disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `.Mui-focusVisible` class.
   * @default false
   */
  disableRipple: l.bool,
  /**
   * If `true`, the touch ripple effect is disabled.
   * @default false
   */
  disableTouchRipple: l.bool,
  /**
   * If `true`, the base button will have a keyboard focus ripple.
   * @default false
   */
  focusRipple: l.bool,
  /**
   * This prop can help identify which element has keyboard focus.
   * The class name will be applied when the element gains the focus through keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/HEAD/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: l.string,
  isAnimating: l.bool,
  /**
   * If `true`, day is the first visible cell of the month.
   * Either the first day of the month or the first day of the week depending on `showDaysOutsideCurrentMonth`.
   */
  isFirstVisibleCell: l.bool.isRequired,
  /**
   * If `true`, day is the last visible cell of the month.
   * Either the last day of the month or the last day of the week depending on `showDaysOutsideCurrentMonth`.
   */
  isLastVisibleCell: l.bool.isRequired,
  onBlur: l.func,
  onDaySelect: l.func.isRequired,
  onFocus: l.func,
  /**
   * Callback fired when the component is focused with a keyboard.
   * We trigger a `onFocus` callback too.
   */
  onFocusVisible: l.func,
  onKeyDown: l.func,
  onMouseEnter: l.func,
  /**
   * If `true`, day is outside of month and will be hidden.
   */
  outsideCurrentMonth: l.bool.isRequired,
  /**
   * If `true`, renders as selected.
   * @default false
   */
  selected: l.bool,
  /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */
  showDaysOutsideCurrentMonth: l.bool,
  style: l.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * @default 0
   */
  tabIndex: l.number,
  /**
   * If `true`, renders as today date.
   * @default false
   */
  today: l.bool,
  /**
   * Props applied to the `TouchRipple` element.
   */
  TouchRippleProps: l.object,
  /**
   * A ref that points to the `TouchRipple` element.
   */
  touchRippleRef: l.oneOfType([l.func, l.shape({
    current: l.shape({
      pulsate: l.func.isRequired,
      start: l.func.isRequired,
      stop: l.func.isRequired
    })
  })])
});
const EUe = /* @__PURE__ */ V.memo(MW);
function RW(e, t, n, r) {
  const {
    value: i,
    onError: o
  } = e, s = xf(), a = V.useRef(r), u = t({
    adapter: s,
    value: i,
    props: e
  });
  return V.useEffect(() => {
    o && !n(u, a.current) && o(u, i), a.current = u;
  }, [n, o, a, u, i]), u;
}
const TUe = (e) => {
  const t = Nn(), n = Yi(), r = xf(), o = Gi().direction === "rtl", {
    valueManager: s,
    fieldValueManager: a,
    valueType: u,
    validator: c,
    internalProps: d,
    internalProps: {
      value: f,
      defaultValue: h,
      referenceDate: m,
      onChange: v,
      format: x,
      formatDensity: C = "dense",
      selectedSections: E,
      onSelectedSectionsChange: S,
      shouldRespectLeadingZeros: w = !1,
      timezone: O
    }
  } = e, {
    timezone: A,
    value: I,
    handleValueChange: $
  } = HF({
    timezone: O,
    value: f,
    defaultValue: h,
    onChange: v,
    valueManager: s
  }), L = V.useMemo(() => Uze(t, A), [t, A]), B = V.useCallback((_, W = null) => a.getSectionsFromValue(t, _, W, o, (Q) => cj(t, A, n, x, Q, C, w, o)), [a, x, n, o, w, t, C, A]), H = V.useMemo(() => a.getValueStrFromSections(B(s.emptyValue), o), [a, B, s.emptyValue, o]), [q, J] = V.useState(() => {
    const _ = B(I);
    pj(_, u);
    const W = {
      sections: _,
      value: I,
      referenceValue: s.emptyValue,
      tempValueStrAndroid: null
    }, Q = Mze(_), oe = s.getInitialReferenceValue({
      referenceDate: m,
      value: I,
      utils: t,
      props: d,
      granularity: Q,
      timezone: A
    });
    return N({}, W, {
      referenceValue: oe
    });
  }), [X, j] = Hi({
    controlled: E,
    default: null,
    name: "useField",
    state: "selectedSectionIndexes"
  }), U = (_) => {
    j(_), S == null || S(_), J((W) => N({}, W, {
      selectedSectionQuery: null
    }));
  }, G = V.useMemo(() => {
    if (X == null)
      return null;
    if (X === "all")
      return {
        startIndex: 0,
        endIndex: q.sections.length - 1,
        shouldSelectBoundarySelectors: !0
      };
    if (typeof X == "number")
      return {
        startIndex: X,
        endIndex: X
      };
    if (typeof X == "string") {
      const _ = q.sections.findIndex((W) => W.type === X);
      return {
        startIndex: _,
        endIndex: _
      };
    }
    return X;
  }, [X, q.sections]), K = ({
    value: _,
    referenceValue: W,
    sections: Q
  }) => {
    if (J((ae) => N({}, ae, {
      sections: Q,
      value: _,
      referenceValue: W,
      tempValueStrAndroid: null
    })), s.areValuesEqual(t, q.value, _))
      return;
    const oe = {
      validationError: c({
        adapter: r,
        value: _,
        props: N({}, d, {
          value: _,
          timezone: A
        })
      })
    };
    $(_, oe);
  }, ee = (_, W) => {
    const Q = [...q.sections];
    return Q[_] = N({}, Q[_], {
      value: W,
      modified: !0
    }), wW(Q, o);
  }, te = () => {
    K({
      value: s.emptyValue,
      referenceValue: q.referenceValue,
      sections: B(s.emptyValue)
    });
  }, M = () => {
    if (G == null)
      return;
    const _ = q.sections[G.startIndex], W = a.getActiveDateManager(t, q, _), oe = W.getSections(q.sections).filter((xe) => xe.value !== "").length === (_.value === "" ? 0 : 1), ae = ee(G.startIndex, ""), pe = oe ? null : t.date(/* @__PURE__ */ new Date("")), me = W.getNewValuesFromNewActiveDate(pe);
    (pe != null && !t.isValid(pe)) != (W.date != null && !t.isValid(W.date)) ? K(N({}, me, {
      sections: ae
    })) : J((xe) => N({}, xe, me, {
      sections: ae,
      tempValueStrAndroid: null
    }));
  }, Z = (_) => {
    const W = (ae, pe) => {
      const me = t.parse(ae, x);
      if (me == null || !t.isValid(me))
        return null;
      const xe = cj(t, A, n, x, me, C, w, o);
      return hj(t, A, me, xe, pe, !1);
    }, Q = a.parseValueStr(_, q.referenceValue, W), oe = a.updateReferenceValue(t, Q, q.referenceValue);
    K({
      value: Q,
      referenceValue: oe,
      sections: B(Q, q.sections)
    });
  }, ne = ({
    activeSection: _,
    newSectionValue: W,
    shouldGoToNextSection: Q
  }) => {
    Q && G && G.startIndex < q.sections.length - 1 ? U(G.startIndex + 1) : G && G.startIndex !== G.endIndex && U(G.startIndex);
    const oe = a.getActiveDateManager(t, q, _), ae = ee(G.startIndex, W), pe = oe.getSections(ae), me = Vze(t, pe);
    let xe, le;
    if (me != null && t.isValid(me)) {
      const ye = hj(t, A, me, pe, oe.referenceDate, !0);
      xe = oe.getNewValuesFromNewActiveDate(ye), le = !0;
    } else
      xe = oe.getNewValuesFromNewActiveDate(me), le = (me != null && !t.isValid(me)) != (oe.date != null && !t.isValid(oe.date));
    return le ? K(N({}, xe, {
      sections: ae
    })) : J((ye) => N({}, ye, xe, {
      sections: ae,
      tempValueStrAndroid: null
    }));
  }, R = (_) => J((W) => N({}, W, {
    tempValueStrAndroid: _
  }));
  return V.useEffect(() => {
    const _ = B(q.value);
    pj(_, u), J((W) => N({}, W, {
      sections: _
    }));
  }, [x, t.locale]), V.useEffect(() => {
    let _ = !1;
    s.areValuesEqual(t, q.value, I) ? _ = s.getTimezone(t, q.value) !== s.getTimezone(t, I) : _ = !0, _ && J((W) => N({}, W, {
      value: I,
      referenceValue: a.updateReferenceValue(t, I, W.referenceValue),
      sections: B(I)
    }));
  }, [I]), {
    state: q,
    selectedSectionIndexes: G,
    setSelectedSections: U,
    clearValue: te,
    clearActiveSection: M,
    updateSectionValue: ne,
    updateValueFromValueStr: Z,
    setTempAndroidValueStr: R,
    sectionsValueBoundaries: L,
    placeholder: H,
    timezone: A
  };
}, SUe = 5e3, xh = (e) => e.saveQuery != null, AUe = ({
  sections: e,
  updateSectionValue: t,
  sectionsValueBoundaries: n,
  setTempAndroidValueStr: r,
  timezone: i
}) => {
  const o = Nn(), [s, a] = V.useState(null), u = Mt(() => a(null));
  V.useEffect(() => {
    var m;
    s != null && ((m = e[s.sectionIndex]) == null ? void 0 : m.type) !== s.sectionType && u();
  }, [e, s, u]), V.useEffect(() => {
    if (s != null) {
      const m = setTimeout(() => u(), SUe);
      return () => {
        window.clearTimeout(m);
      };
    }
    return () => {
    };
  }, [s, u]);
  const c = ({
    keyPressed: m,
    sectionIndex: v
  }, x, C) => {
    const E = m.toLowerCase(), S = e[v];
    if (s != null && (!C || C(s.value)) && s.sectionIndex === v) {
      const O = `${s.value}${E}`, A = x(O, S);
      if (!xh(A))
        return a({
          sectionIndex: v,
          value: O,
          sectionType: S.type
        }), A;
    }
    const w = x(E, S);
    return xh(w) && !w.saveQuery ? (u(), null) : (a({
      sectionIndex: v,
      value: E,
      sectionType: S.type
    }), xh(w) ? null : w);
  }, d = (m) => {
    const v = (E, S, w) => {
      const O = S.filter((A) => A.toLowerCase().startsWith(w));
      return O.length === 0 ? {
        saveQuery: !1
      } : {
        sectionValue: O[0],
        shouldGoToNextSection: O.length === 1
      };
    }, x = (E, S, w, O) => {
      const A = (I) => TW(o, i, S.type, I);
      if (S.contentType === "letter")
        return v(S.format, A(S.format), E);
      if (w && O != null && qF(o, w).contentType === "letter") {
        const I = A(w), $ = v(w, I, E);
        return xh($) ? {
          saveQuery: !1
        } : N({}, $, {
          sectionValue: O($.sectionValue, I)
        });
      }
      return {
        saveQuery: !1
      };
    };
    return c(m, (E, S) => {
      switch (S.type) {
        case "month": {
          const w = (O) => uj(o, O, o.formats.month, S.format);
          return x(E, S, o.formats.month, w);
        }
        case "weekDay": {
          const w = (O, A) => A.indexOf(O).toString();
          return x(E, S, o.formats.weekday, w);
        }
        case "meridiem":
          return x(E, S);
        default:
          return {
            saveQuery: !1
          };
      }
    });
  }, f = (m) => {
    const v = (C, E) => {
      const S = +`${C}`, w = n[E.type]({
        currentDate: null,
        format: E.format,
        contentType: E.contentType
      });
      if (S > w.maximum)
        return {
          saveQuery: !1
        };
      if (S < w.minimum)
        return {
          saveQuery: !0
        };
      const O = +`${C}0` > w.maximum || C.length === w.maximum.toString().length;
      return {
        sectionValue: AW(o, i, S, w, E),
        shouldGoToNextSection: O
      };
    };
    return c(m, (C, E) => {
      if (E.contentType === "digit" || E.contentType === "digit-with-letter")
        return v(C, E);
      if (E.type === "month") {
        const S = kW(o, i, "digit", "month", "MM"), w = v(C, {
          type: E.type,
          format: "MM",
          hasLeadingZerosInFormat: S,
          hasLeadingZerosInInput: !0,
          contentType: "digit",
          maxLength: 2
        });
        if (xh(w))
          return w;
        const O = uj(o, w.sectionValue, "MM", E.format);
        return N({}, w, {
          sectionValue: O
        });
      }
      if (E.type === "weekDay") {
        const S = v(C, E);
        if (xh(S))
          return S;
        const w = XE(o, i, E.format)[Number(S.sectionValue) - 1];
        return N({}, S, {
          sectionValue: w
        });
      }
      return {
        saveQuery: !1
      };
    }, (C) => !Number.isNaN(Number(C)));
  };
  return {
    applyCharacterEditing: Mt((m) => {
      const v = e[m.sectionIndex], C = m.keyPressed !== " " && !Number.isNaN(Number(m.keyPressed)) ? f(m) : d(m);
      C == null ? r(null) : t({
        activeSection: v,
        newSectionValue: C.sectionValue,
        shouldGoToNextSection: C.shouldGoToNextSection
      });
    }),
    resetCharacterQuery: u
  };
};
function Ph(e, t) {
  return Array.isArray(t) ? t.every((n) => e.indexOf(n) !== -1) : e.indexOf(t) !== -1;
}
const wUe = (e, t) => (n) => {
  (n.key === "Enter" || n.key === " ") && (e(n), n.preventDefault(), n.stopPropagation());
}, eC = (e = document) => {
  const t = e.activeElement;
  return t ? t.shadowRoot ? eC(t.shadowRoot) : t : null;
}, JF = "@media (pointer: fine)", PUe = ["onClick", "onKeyDown", "onFocus", "onBlur", "onMouseUp", "onPaste", "error", "clearable", "onClear", "disabled"], XF = (e) => {
  const t = Nn(), {
    state: n,
    selectedSectionIndexes: r,
    setSelectedSections: i,
    clearValue: o,
    clearActiveSection: s,
    updateSectionValue: a,
    updateValueFromValueStr: u,
    setTempAndroidValueStr: c,
    sectionsValueBoundaries: d,
    placeholder: f,
    timezone: h
  } = TUe(e), {
    inputRef: m,
    internalProps: v,
    internalProps: {
      readOnly: x = !1,
      unstableFieldRef: C,
      minutesStep: E
    },
    forwardedProps: {
      onClick: S,
      onKeyDown: w,
      onFocus: O,
      onBlur: A,
      onMouseUp: I,
      onPaste: $,
      error: L,
      clearable: B,
      onClear: H,
      disabled: q
    },
    fieldValueManager: J,
    valueManager: X,
    validator: j
  } = e, U = _e(e.forwardedProps, PUe), {
    applyCharacterEditing: G,
    resetCharacterQuery: K
  } = AUe({
    sections: n.sections,
    updateSectionValue: a,
    sectionsValueBoundaries: d,
    setTempAndroidValueStr: c,
    timezone: h
  }), ee = V.useRef(null), te = Hn(m, ee), M = V.useRef(void 0), ne = Gi().direction === "rtl", R = V.useMemo(() => qze(n.sections, ne), [n.sections, ne]), _ = () => {
    var Ee;
    if (x) {
      i(null);
      return;
    }
    const Ie = (Ee = ee.current.selectionStart) != null ? Ee : 0;
    let Je;
    Ie <= n.sections[0].startInInput || Ie >= n.sections[n.sections.length - 1].endInInput ? Je = 1 : Je = n.sections.findIndex((St) => St.startInInput - St.startSeparator.length > Ie);
    const vt = Je === -1 ? n.sections.length - 1 : Je - 1;
    i(vt);
  }, W = Mt((Ee, ...Ie) => {
    Ee.isDefaultPrevented() || (S == null || S(Ee, ...Ie), _());
  }), Q = Mt((Ee) => {
    I == null || I(Ee), Ee.preventDefault();
  }), oe = Mt((...Ee) => {
    O == null || O(...Ee);
    const Ie = ee.current;
    window.clearTimeout(M.current), M.current = setTimeout(() => {
      !Ie || Ie !== ee.current || r != null || x || (// avoid selecting all sections when focusing empty field without value
      Ie.value.length && Number(Ie.selectionEnd) - Number(Ie.selectionStart) === Ie.value.length ? i("all") : _());
    });
  }), ae = Mt((...Ee) => {
    A == null || A(...Ee), i(null);
  }), pe = Mt((Ee) => {
    if ($ == null || $(Ee), x) {
      Ee.preventDefault();
      return;
    }
    const Ie = Ee.clipboardData.getData("text");
    if (r && r.startIndex === r.endIndex) {
      const Je = n.sections[r.startIndex], vt = /^[a-zA-Z]+$/.test(Ie), St = /^[0-9]+$/.test(Ie), Lt = /^(([a-zA-Z]+)|)([0-9]+)(([a-zA-Z]+)|)$/.test(Ie);
      if (Je.contentType === "letter" && vt || Je.contentType === "digit" && St || Je.contentType === "digit-with-letter" && Lt) {
        K(), a({
          activeSection: Je,
          newSectionValue: Ie,
          shouldGoToNextSection: !0
        }), Ee.preventDefault();
        return;
      }
      if (vt || St) {
        Ee.preventDefault();
        return;
      }
    }
    Ee.preventDefault(), K(), u(Ie);
  }), me = Mt((Ee) => {
    if (x)
      return;
    const Ie = Ee.target.value;
    if (Ie === "") {
      K(), o();
      return;
    }
    const Je = Ee.nativeEvent.data, vt = Je && Je.length > 1, St = vt ? Je : Ie, Lt = Mh(St);
    if (r == null || vt) {
      u(vt ? Je : Lt);
      return;
    }
    let ke;
    if (r.startIndex === 0 && r.endIndex === n.sections.length - 1 && Lt.length === 1)
      ke = Lt;
    else {
      const Le = Mh(J.getValueStrFromSections(n.sections, ne));
      let Pe = -1, Ae = -1;
      for (let Ct = 0; Ct < Le.length; Ct += 1)
        Pe === -1 && Le[Ct] !== Lt[Ct] && (Pe = Ct), Ae === -1 && Le[Le.length - Ct - 1] !== Lt[Lt.length - Ct - 1] && (Ae = Ct);
      const We = n.sections[r.startIndex];
      if (Pe < We.start || Le.length - Ae - 1 > We.end)
        return;
      const Ft = Lt.length - Le.length + We.end - Mh(We.endSeparator || "").length;
      ke = Lt.slice(We.start + Mh(We.startSeparator || "").length, Ft);
    }
    if (ke.length === 0) {
      Hze() ? c(St) : (K(), s());
      return;
    }
    G({
      keyPressed: ke,
      sectionIndex: r.startIndex
    });
  }), xe = Mt((Ee) => {
    switch (w == null || w(Ee), !0) {
      case (Ee.key === "a" && (Ee.ctrlKey || Ee.metaKey)): {
        Ee.preventDefault(), i("all");
        break;
      }
      case Ee.key === "ArrowRight": {
        if (Ee.preventDefault(), r == null)
          i(R.startIndex);
        else if (r.startIndex !== r.endIndex)
          i(r.endIndex);
        else {
          const Ie = R.neighbors[r.startIndex].rightIndex;
          Ie !== null && i(Ie);
        }
        break;
      }
      case Ee.key === "ArrowLeft": {
        if (Ee.preventDefault(), r == null)
          i(R.endIndex);
        else if (r.startIndex !== r.endIndex)
          i(r.startIndex);
        else {
          const Ie = R.neighbors[r.startIndex].leftIndex;
          Ie !== null && i(Ie);
        }
        break;
      }
      case Ee.key === "Delete": {
        if (Ee.preventDefault(), x)
          break;
        r == null || r.startIndex === 0 && r.endIndex === n.sections.length - 1 ? o() : s(), K();
        break;
      }
      case ["ArrowUp", "ArrowDown", "Home", "End", "PageUp", "PageDown"].includes(Ee.key): {
        if (Ee.preventDefault(), x || r == null)
          break;
        const Ie = n.sections[r.startIndex], Je = J.getActiveDateManager(t, n, Ie), vt = Lze(t, h, Ie, Ee.key, d, Je.date, {
          minutesStep: E
        });
        a({
          activeSection: Ie,
          newSectionValue: vt,
          shouldGoToNextSection: !1
        });
        break;
      }
    }
  });
  gi(() => {
    if (!ee.current)
      return;
    if (r == null) {
      ee.current.scrollLeft && (ee.current.scrollLeft = 0);
      return;
    }
    const Ee = n.sections[r.startIndex], Ie = n.sections[r.endIndex];
    let Je = Ee.startInInput, vt = Ie.endInInput;
    if (r.shouldSelectBoundarySelectors && (Je -= Ee.startSeparator.length, vt += Ie.endSeparator.length), Je !== ee.current.selectionStart || vt !== ee.current.selectionEnd) {
      const St = ee.current.scrollTop;
      ee.current === eC(document) && ee.current.setSelectionRange(Je, vt), ee.current.scrollTop = St;
    }
  });
  const le = RW(N({}, v, {
    value: n.value,
    timezone: h
  }), j, X.isSameError, X.defaultErrorState), ye = V.useMemo(() => L !== void 0 ? L : X.hasError(le), [X, le, L]);
  V.useEffect(() => {
    !ye && !r && K();
  }, [n.referenceValue, r, ye]), V.useEffect(() => (ee.current && ee.current === document.activeElement && i("all"), () => window.clearTimeout(M.current)), []), V.useEffect(() => {
    n.tempValueStrAndroid != null && r != null && (K(), s());
  }, [n.tempValueStrAndroid]);
  const be = V.useMemo(() => {
    var Ee;
    return (Ee = n.tempValueStrAndroid) != null ? Ee : J.getValueStrFromSections(n.sections, ne);
  }, [n.sections, J, n.tempValueStrAndroid, ne]), Re = V.useMemo(() => r == null || n.sections[r.startIndex].contentType === "letter" ? "text" : "numeric", [r, n.sections]), Te = ee.current && ee.current === eC(document), Xe = X.areValuesEqual(t, n.value, X.emptyValue), Ne = !Te && Xe;
  V.useImperativeHandle(C, () => ({
    getSections: () => n.sections,
    getActiveSectionIndex: () => {
      var Ee, Ie, Je;
      const vt = (Ee = ee.current.selectionStart) != null ? Ee : 0, St = (Ie = ee.current.selectionEnd) != null ? Ie : 0, Lt = !!((Je = ee.current) != null && Je.readOnly);
      if (vt === 0 && St === 0 || Lt)
        return null;
      const ke = vt <= n.sections[0].startInInput ? 1 : n.sections.findIndex((Le) => Le.startInInput - Le.startSeparator.length > vt);
      return ke === -1 ? n.sections.length - 1 : ke - 1;
    },
    setSelectedSections: (Ee) => i(Ee)
  }));
  const Qe = Mt((Ee, ...Ie) => {
    var Je;
    Ee.preventDefault(), H == null || H(Ee, ...Ie), o(), ee == null || (Je = ee.current) == null || Je.focus(), i(0);
  });
  return N({
    placeholder: f,
    autoComplete: "off",
    disabled: !!q
  }, U, {
    value: Ne ? "" : be,
    inputMode: Re,
    readOnly: x,
    onClick: W,
    onFocus: oe,
    onBlur: ae,
    onPaste: pe,
    onChange: me,
    onKeyDown: xe,
    onMouseUp: Q,
    onClear: Qe,
    error: ye,
    ref: te,
    clearable: !!(B && !Xe && !x && !q)
  });
}, dv = ({
  props: e,
  value: t,
  adapter: n
}) => {
  if (t === null)
    return null;
  const {
    shouldDisableDate: r,
    shouldDisableMonth: i,
    shouldDisableYear: o,
    disablePast: s,
    disableFuture: a,
    timezone: u
  } = e, c = n.utils.dateWithTimezone(void 0, u), d = Lo(n.utils, e.minDate, n.defaultDates.minDate), f = Lo(n.utils, e.maxDate, n.defaultDates.maxDate);
  switch (!0) {
    case !n.utils.isValid(t):
      return "invalidDate";
    case !!(r && r(t)):
      return "shouldDisableDate";
    case !!(i && i(t)):
      return "shouldDisableMonth";
    case !!(o && o(t)):
      return "shouldDisableYear";
    case !!(a && n.utils.isAfterDay(t, c)):
      return "disableFuture";
    case !!(s && n.utils.isBeforeDay(t, c)):
      return "disablePast";
    case !!(d && n.utils.isBeforeDay(t, d)):
      return "minDate";
    case !!(f && n.utils.isAfterDay(t, f)):
      return "maxDate";
    default:
      return null;
  }
}, ek = ["disablePast", "disableFuture", "minDate", "maxDate", "shouldDisableDate", "shouldDisableMonth", "shouldDisableYear"], tk = ["disablePast", "disableFuture", "minTime", "maxTime", "shouldDisableClock", "shouldDisableTime", "minutesStep", "ampm", "disableIgnoringDatePartForTimeValidation"], _W = ["minDateTime", "maxDateTime"], kUe = [...ek, ...tk, ..._W], mg = (e) => kUe.reduce((t, n) => (e.hasOwnProperty(n) && (t[n] = e[n]), t), {}), OUe = ["value", "defaultValue", "referenceDate", "format", "formatDensity", "onChange", "timezone", "readOnly", "onError", "shouldRespectLeadingZeros", "selectedSections", "onSelectedSectionsChange", "unstableFieldRef"], QF = (e, t) => {
  const n = N({}, e), r = {}, i = (o) => {
    n.hasOwnProperty(o) && (r[o] = n[o], delete n[o]);
  };
  return OUe.forEach(i), t === "date" ? ek.forEach(i) : t === "time" ? tk.forEach(i) : t === "date-time" && (ek.forEach(i), tk.forEach(i), _W.forEach(i)), {
    forwardedProps: n,
    internalProps: r
  };
}, IUe = (e) => {
  var t, n, r;
  const i = Nn(), o = Df();
  return N({}, e, {
    disablePast: (t = e.disablePast) != null ? t : !1,
    disableFuture: (n = e.disableFuture) != null ? n : !1,
    format: (r = e.format) != null ? r : i.formats.keyboardDate,
    minDate: Lo(i, e.minDate, o.minDate),
    maxDate: Lo(i, e.maxDate, o.maxDate)
  });
}, FUe = ({
  props: e,
  inputRef: t
}) => {
  const n = IUe(e), {
    forwardedProps: r,
    internalProps: i
  } = QF(n, "date");
  return XF({
    inputRef: t,
    forwardedProps: r,
    internalProps: i,
    valueManager: qi,
    fieldValueManager: YF,
    validator: dv,
    valueType: "date"
  });
}, $Ue = De(Zb)({
  [`& .${d0.container}`]: {
    outline: 0
  },
  [`& .${d0.paper}`]: {
    outline: 0,
    minWidth: YE
  }
}), NUe = De(tv)({
  "&:first-of-type": {
    padding: 0
  }
});
function MUe(e) {
  var t, n;
  const {
    children: r,
    onDismiss: i,
    open: o,
    slots: s,
    slotProps: a
  } = e, u = (t = s == null ? void 0 : s.dialog) != null ? t : $Ue, c = (n = s == null ? void 0 : s.mobileTransition) != null ? n : ff;
  return /* @__PURE__ */ P.jsx(u, N({
    open: o,
    onClose: i
  }, a == null ? void 0 : a.dialog, {
    TransitionComponent: c,
    TransitionProps: a == null ? void 0 : a.mobileTransition,
    PaperComponent: s == null ? void 0 : s.mobilePaper,
    PaperProps: a == null ? void 0 : a.mobilePaper,
    children: /* @__PURE__ */ P.jsx(NUe, {
      children: r
    })
  }));
}
function RUe(e) {
  return ot("MuiPickersPopper", e);
}
st("MuiPickersPopper", ["root", "paper"]);
const _Ue = "@media (prefers-reduced-motion: reduce)", Kh = typeof navigator < "u" && navigator.userAgent.match(/android\s(\d+)|OS\s(\d+)/i), gj = Kh && Kh[1] ? parseInt(Kh[1], 10) : null, yj = Kh && Kh[2] ? parseInt(Kh[2], 10) : null, LUe = gj && gj < 10 || yj && yj < 13 || !1, LW = () => PE(_Ue, {
  defaultMatches: !1
}) || LUe, BUe = ["PaperComponent", "popperPlacement", "ownerState", "children", "paperSlotProps", "paperClasses", "onPaperClick", "onPaperTouchStart"], jUe = (e) => {
  const {
    classes: t
  } = e;
  return at({
    root: ["root"],
    paper: ["paper"]
  }, RUe, t);
}, VUe = De(ag, {
  name: "MuiPickersPopper",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e
}) => ({
  zIndex: e.zIndex.modal
})), zUe = De(ti, {
  name: "MuiPickersPopper",
  slot: "Paper",
  overridesResolver: (e, t) => t.paper
})(({
  ownerState: e
}) => N({
  outline: 0,
  transformOrigin: "top center"
}, e.placement.includes("top") && {
  transformOrigin: "bottom center"
}));
function UUe(e, t) {
  return t.documentElement.clientWidth < e.clientX || t.documentElement.clientHeight < e.clientY;
}
function WUe(e, t) {
  const n = V.useRef(!1), r = V.useRef(!1), i = V.useRef(null), o = V.useRef(!1);
  V.useEffect(() => {
    if (!e)
      return;
    function u() {
      o.current = !0;
    }
    return document.addEventListener("mousedown", u, !0), document.addEventListener("touchstart", u, !0), () => {
      document.removeEventListener("mousedown", u, !0), document.removeEventListener("touchstart", u, !0), o.current = !1;
    };
  }, [e]);
  const s = Mt((u) => {
    if (!o.current)
      return;
    const c = r.current;
    r.current = !1;
    const d = ei(i.current);
    if (!i.current || // is a TouchEvent?
    "clientX" in u && UUe(u, d))
      return;
    if (n.current) {
      n.current = !1;
      return;
    }
    let f;
    u.composedPath ? f = u.composedPath().indexOf(i.current) > -1 : f = !d.documentElement.contains(u.target) || i.current.contains(u.target), !f && !c && t(u);
  }), a = () => {
    r.current = !0;
  };
  return V.useEffect(() => {
    if (e) {
      const u = ei(i.current), c = () => {
        n.current = !0;
      };
      return u.addEventListener("touchstart", s), u.addEventListener("touchmove", c), () => {
        u.removeEventListener("touchstart", s), u.removeEventListener("touchmove", c);
      };
    }
  }, [e, s]), V.useEffect(() => {
    if (e) {
      const u = ei(i.current);
      return u.addEventListener("click", s), () => {
        u.removeEventListener("click", s), r.current = !1;
      };
    }
  }, [e, s]), [i, a, a];
}
const HUe = /* @__PURE__ */ V.forwardRef((e, t) => {
  const {
    PaperComponent: n,
    popperPlacement: r,
    ownerState: i,
    children: o,
    paperSlotProps: s,
    paperClasses: a,
    onPaperClick: u,
    onPaperTouchStart: c
    // picks up the style props provided by `Transition`
    // https://mui.com/material-ui/transitions/#child-requirement
  } = e, d = _e(e, BUe), f = N({}, i, {
    placement: r
  }), h = si({
    elementType: n,
    externalSlotProps: s,
    additionalProps: {
      tabIndex: -1,
      elevation: 8,
      ref: t
    },
    className: a,
    ownerState: f
  });
  return /* @__PURE__ */ P.jsx(n, N({}, d, h, {
    onClick: (m) => {
      var v;
      u(m), (v = h.onClick) == null || v.call(h, m);
    },
    onTouchStart: (m) => {
      var v;
      c(m), (v = h.onTouchStart) == null || v.call(h, m);
    },
    ownerState: f,
    children: o
  }));
});
function qUe(e) {
  var t, n, r, i;
  const o = Vn({
    props: e,
    name: "MuiPickersPopper"
  }), {
    anchorEl: s,
    children: a,
    containerRef: u = null,
    shouldRestoreFocus: c,
    onBlur: d,
    onDismiss: f,
    open: h,
    role: m,
    placement: v,
    slots: x,
    slotProps: C,
    reduceAnimations: E
  } = o;
  V.useEffect(() => {
    function te(M) {
      h && (M.key === "Escape" || M.key === "Esc") && f();
    }
    return document.addEventListener("keydown", te), () => {
      document.removeEventListener("keydown", te);
    };
  }, [f, h]);
  const S = V.useRef(null);
  V.useEffect(() => {
    m === "tooltip" || c && !c() || (h ? S.current = eC(document) : S.current && S.current instanceof HTMLElement && setTimeout(() => {
      S.current instanceof HTMLElement && S.current.focus();
    }));
  }, [h, m, c]);
  const [w, O, A] = WUe(h, d ?? f), I = V.useRef(null), $ = Hn(I, u), L = Hn($, w), B = o, H = jUe(B), q = LW(), J = E ?? q, X = (te) => {
    te.key === "Escape" && (te.stopPropagation(), f());
  }, j = ((t = x == null ? void 0 : x.desktopTransition) != null ? t : J) ? ff : ym, U = (n = x == null ? void 0 : x.desktopTrapFocus) != null ? n : z0, G = (r = x == null ? void 0 : x.desktopPaper) != null ? r : zUe, K = (i = x == null ? void 0 : x.popper) != null ? i : VUe, ee = si({
    elementType: K,
    externalSlotProps: C == null ? void 0 : C.popper,
    additionalProps: {
      transition: !0,
      role: m,
      open: h,
      anchorEl: s,
      placement: v,
      onKeyDown: X
    },
    className: H.root,
    ownerState: o
  });
  return /* @__PURE__ */ P.jsx(K, N({}, ee, {
    children: ({
      TransitionProps: te,
      placement: M
    }) => /* @__PURE__ */ P.jsx(U, N({
      open: h,
      disableAutoFocus: !0,
      disableRestoreFocus: !0,
      disableEnforceFocus: m === "tooltip",
      isEnabled: () => !0
    }, C == null ? void 0 : C.desktopTrapFocus, {
      children: /* @__PURE__ */ P.jsx(j, N({}, te, C == null ? void 0 : C.desktopTransition, {
        children: /* @__PURE__ */ P.jsx(HUe, {
          PaperComponent: G,
          ownerState: B,
          popperPlacement: M,
          ref: L,
          onPaperClick: O,
          onPaperTouchStart: A,
          paperClasses: H.paper,
          paperSlotProps: C == null ? void 0 : C.desktopPaper,
          children: a
        })
      }))
    }))
  }));
}
function BW(e) {
  return ot("MuiPickersToolbar", e);
}
st("MuiPickersToolbar", ["root", "content"]);
const GUe = (e) => {
  const {
    classes: t,
    isLandscape: n
  } = e;
  return at({
    root: ["root"],
    content: ["content"],
    penIconButton: ["penIconButton", n && "penIconButtonLandscape"]
  }, BW, t);
}, YUe = De("div", {
  name: "MuiPickersToolbar",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e,
  ownerState: t
}) => N({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  justifyContent: "space-between",
  padding: e.spacing(2, 3)
}, t.isLandscape && {
  height: "auto",
  maxWidth: 160,
  padding: 16,
  justifyContent: "flex-start",
  flexWrap: "wrap"
})), KUe = De("div", {
  name: "MuiPickersToolbar",
  slot: "Content",
  overridesResolver: (e, t) => t.content
})(({
  ownerState: e
}) => {
  var t;
  return {
    display: "flex",
    flexWrap: "wrap",
    width: "100%",
    justifyContent: e.isLandscape ? "flex-start" : "space-between",
    flexDirection: e.isLandscape ? (t = e.landscapeDirection) != null ? t : "column" : "row",
    flex: 1,
    alignItems: e.isLandscape ? "flex-start" : "center"
  };
}), ZF = /* @__PURE__ */ V.forwardRef(function(t, n) {
  const r = Vn({
    props: t,
    name: "MuiPickersToolbar"
  }), {
    children: i,
    className: o,
    toolbarTitle: s,
    hidden: a,
    titleId: u
  } = r, c = r, d = GUe(c);
  return a ? null : /* @__PURE__ */ P.jsxs(YUe, {
    ref: n,
    className: Be(d.root, o),
    ownerState: c,
    children: [/* @__PURE__ */ P.jsx(cn, {
      color: "text.secondary",
      variant: "overline",
      id: u,
      children: s
    }), /* @__PURE__ */ P.jsx(KUe, {
      className: d.content,
      ownerState: c,
      children: i
    })]
  });
});
function JUe(e) {
  return ot("MuiPickersToolbarText", e);
}
const bj = st("MuiPickersToolbarText", ["root", "selected"]), XUe = ["className", "selected", "value"], QUe = (e) => {
  const {
    classes: t,
    selected: n
  } = e;
  return at({
    root: ["root", n && "selected"]
  }, JUe, t);
}, ZUe = De(cn, {
  name: "MuiPickersToolbarText",
  slot: "Root",
  overridesResolver: (e, t) => [t.root, {
    [`&.${bj.selected}`]: t.selected
  }]
})(({
  theme: e
}) => ({
  transition: e.transitions.create("color"),
  color: (e.vars || e).palette.text.secondary,
  [`&.${bj.selected}`]: {
    color: (e.vars || e).palette.text.primary
  }
})), e$ = /* @__PURE__ */ V.forwardRef(function(t, n) {
  const r = Vn({
    props: t,
    name: "MuiPickersToolbarText"
  }), {
    className: i,
    value: o
  } = r, s = _e(r, XUe), a = QUe(r);
  return /* @__PURE__ */ P.jsx(ZUe, N({
    ref: n,
    className: Be(i, a.root),
    component: "span"
  }, s, {
    children: o
  }));
}), eWe = ["align", "className", "selected", "typographyClassName", "value", "variant", "width"], tWe = (e) => {
  const {
    classes: t
  } = e;
  return at({
    root: ["root"]
  }, BW, t);
}, nWe = De(Nr, {
  name: "MuiPickersToolbarButton",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  padding: 0,
  minWidth: 16,
  textTransform: "none"
}), Js = /* @__PURE__ */ V.forwardRef(function(t, n) {
  const r = Vn({
    props: t,
    name: "MuiPickersToolbarButton"
  }), {
    align: i,
    className: o,
    selected: s,
    typographyClassName: a,
    value: u,
    variant: c,
    width: d
  } = r, f = _e(r, eWe), h = tWe(r);
  return /* @__PURE__ */ P.jsx(nWe, N({
    variant: "text",
    ref: n,
    className: Be(o, h.root)
  }, d ? {
    sx: {
      width: d
    }
  } : {}, f, {
    children: /* @__PURE__ */ P.jsx(e$, {
      align: i,
      className: a,
      variant: c,
      value: u,
      selected: s
    })
  }));
}), rWe = ({
  open: e,
  onOpen: t,
  onClose: n
}) => {
  const r = V.useRef(typeof e == "boolean").current, [i, o] = V.useState(!1);
  V.useEffect(() => {
    if (r) {
      if (typeof e != "boolean")
        throw new Error("You must not mix controlling and uncontrolled mode for `open` prop");
      o(e);
    }
  }, [r, e]);
  const s = V.useCallback((a) => {
    r || o(a), a && t && t(), !a && n && n();
  }, [r, t, n]);
  return {
    isOpen: i,
    setIsOpen: s
  };
}, iWe = (e) => {
  const {
    action: t,
    hasChanged: n,
    dateState: r,
    isControlled: i
  } = e, o = !i && !r.hasBeenModifiedSinceMount;
  return t.name === "setValueFromField" ? !0 : t.name === "setValueFromAction" ? o && ["accept", "today", "clear"].includes(t.pickerAction) ? !0 : n(r.lastPublishedValue) : t.name === "setValueFromView" && t.selectionState !== "shallow" || t.name === "setValueFromShortcut" ? o ? !0 : n(r.lastPublishedValue) : !1;
}, oWe = (e) => {
  const {
    action: t,
    hasChanged: n,
    dateState: r,
    isControlled: i,
    closeOnSelect: o
  } = e, s = !i && !r.hasBeenModifiedSinceMount;
  return t.name === "setValueFromAction" ? s && ["accept", "today", "clear"].includes(t.pickerAction) ? !0 : n(r.lastCommittedValue) : t.name === "setValueFromView" && t.selectionState === "finish" && o ? s ? !0 : n(r.lastCommittedValue) : t.name === "setValueFromShortcut" ? t.changeImportance === "accept" && n(r.lastCommittedValue) : !1;
}, sWe = (e) => {
  const {
    action: t,
    closeOnSelect: n
  } = e;
  return t.name === "setValueFromAction" ? !0 : t.name === "setValueFromView" ? t.selectionState === "finish" && n : t.name === "setValueFromShortcut" ? t.changeImportance === "accept" : !1;
}, aWe = ({
  props: e,
  valueManager: t,
  valueType: n,
  wrapperVariant: r,
  validator: i
}) => {
  const {
    onAccept: o,
    onChange: s,
    value: a,
    defaultValue: u,
    closeOnSelect: c = r === "desktop",
    selectedSections: d,
    onSelectedSectionsChange: f,
    timezone: h
  } = e, {
    current: m
  } = V.useRef(u), {
    current: v
  } = V.useRef(a !== void 0);
  process.env.NODE_ENV !== "production" && (V.useEffect(() => {
    v !== (a !== void 0) && console.error([`MUI: A component is changing the ${v ? "" : "un"}controlled value of a picker to be ${v ? "un" : ""}controlled.`, "Elements should not switch from uncontrolled to controlled (or vice versa).", "Decide between using a controlled or uncontrolled valuefor the lifetime of the component.", "The nature of the state is determined during the first render. It's considered controlled if the value is not `undefined`.", "More info: https://fb.me/react-controlled-components"].join(`
`));
  }, [a]), V.useEffect(() => {
    !v && m !== u && console.error(["MUI: A component is changing the defaultValue of an uncontrolled picker after being initialized. To suppress this warning opt to use a controlled value."].join(`
`));
  }, [JSON.stringify(m)]));
  const x = Nn(), C = xf(), [E, S] = Hi({
    controlled: d,
    default: null,
    name: "usePickerValue",
    state: "selectedSections"
  }), {
    isOpen: w,
    setIsOpen: O
  } = rWe(e), [A, I] = V.useState(() => {
    let oe;
    return a !== void 0 ? oe = a : m !== void 0 ? oe = m : oe = t.emptyValue, {
      draft: oe,
      lastPublishedValue: oe,
      lastCommittedValue: oe,
      lastControlledValue: a,
      hasBeenModifiedSinceMount: !1
    };
  }), {
    timezone: $,
    handleValueChange: L
  } = HF({
    timezone: h,
    value: a,
    defaultValue: m,
    onChange: s,
    valueManager: t
  });
  RW(N({}, e, {
    value: A.draft,
    timezone: $
  }), i, t.isSameError, t.defaultErrorState);
  const B = Mt((oe) => {
    const ae = {
      action: oe,
      dateState: A,
      hasChanged: (le) => !t.areValuesEqual(x, oe.value, le),
      isControlled: v,
      closeOnSelect: c
    }, pe = iWe(ae), me = oWe(ae), xe = sWe(ae);
    if (I((le) => N({}, le, {
      draft: oe.value,
      lastPublishedValue: pe ? oe.value : le.lastPublishedValue,
      lastCommittedValue: me ? oe.value : le.lastCommittedValue,
      hasBeenModifiedSinceMount: !0
    })), pe) {
      const ye = {
        validationError: oe.name === "setValueFromField" ? oe.context.validationError : i({
          adapter: C,
          value: oe.value,
          props: N({}, e, {
            value: oe.value,
            timezone: $
          })
        })
      };
      oe.name === "setValueFromShortcut" && oe.shortcut != null && (ye.shortcut = oe.shortcut), L(oe.value, ye);
    }
    me && o && o(oe.value), xe && O(!1);
  });
  if (a !== void 0 && (A.lastControlledValue === void 0 || !t.areValuesEqual(x, A.lastControlledValue, a))) {
    const oe = t.areValuesEqual(x, A.draft, a);
    I((ae) => N({}, ae, {
      lastControlledValue: a
    }, oe ? {} : {
      lastCommittedValue: a,
      lastPublishedValue: a,
      draft: a,
      hasBeenModifiedSinceMount: !0
    }));
  }
  const H = Mt(() => {
    B({
      value: t.emptyValue,
      name: "setValueFromAction",
      pickerAction: "clear"
    });
  }), q = Mt(() => {
    B({
      value: A.lastPublishedValue,
      name: "setValueFromAction",
      pickerAction: "accept"
    });
  }), J = Mt(() => {
    B({
      value: A.lastPublishedValue,
      name: "setValueFromAction",
      pickerAction: "dismiss"
    });
  }), X = Mt(() => {
    B({
      value: A.lastCommittedValue,
      name: "setValueFromAction",
      pickerAction: "cancel"
    });
  }), j = Mt(() => {
    B({
      value: t.getTodayValue(x, $, n),
      name: "setValueFromAction",
      pickerAction: "today"
    });
  }), U = Mt(() => O(!0)), G = Mt(() => O(!1)), K = Mt((oe, ae = "partial") => B({
    name: "setValueFromView",
    value: oe,
    selectionState: ae
  })), ee = Mt((oe, ae, pe) => B({
    name: "setValueFromShortcut",
    value: oe,
    changeImportance: ae ?? "accept",
    shortcut: pe
  })), te = Mt((oe, ae) => B({
    name: "setValueFromField",
    value: oe,
    context: ae
  })), M = Mt((oe) => {
    S(oe), f == null || f(oe);
  }), Z = {
    onClear: H,
    onAccept: q,
    onDismiss: J,
    onCancel: X,
    onSetToday: j,
    onOpen: U,
    onClose: G
  }, ne = {
    value: A.draft,
    onChange: te,
    selectedSections: E,
    onSelectedSectionsChange: M
  }, R = V.useMemo(() => t.cleanValue(x, A.draft), [x, t, A.draft]), _ = {
    value: R,
    onChange: K,
    onClose: G,
    open: w,
    onSelectedSectionsChange: M
  }, Q = N({}, Z, {
    value: R,
    onChange: K,
    onSelectShortcut: ee,
    isValid: (oe) => {
      const ae = i({
        adapter: C,
        value: oe,
        props: N({}, e, {
          value: oe,
          timezone: $
        })
      });
      return !t.hasError(ae);
    }
  });
  return {
    open: w,
    fieldProps: ne,
    viewProps: _,
    layoutProps: Q,
    actions: Z
  };
}, lWe = ["className", "sx"], uWe = ({
  props: e,
  propsFromPickerValue: t,
  additionalViewProps: n,
  inputRef: r,
  autoFocusView: i
}) => {
  const {
    onChange: o,
    open: s,
    onSelectedSectionsChange: a,
    onClose: u
  } = t, {
    view: c,
    views: d,
    openTo: f,
    onViewChange: h,
    viewRenderers: m,
    timezone: v
  } = e, x = _e(e, lWe), {
    view: C,
    setView: E,
    defaultView: S,
    focusedView: w,
    setFocusedView: O,
    setValueAndGoToNextView: A
  } = uv({
    view: c,
    views: d,
    openTo: f,
    onChange: o,
    onViewChange: h,
    autoFocus: i
  }), {
    hasUIView: I,
    viewModeLookup: $
  } = V.useMemo(() => d.reduce((j, U) => {
    let G;
    return m[U] != null ? G = "UI" : G = "field", j.viewModeLookup[U] = G, G === "UI" && (j.hasUIView = !0), j;
  }, {
    hasUIView: !1,
    viewModeLookup: {}
  }), [m, d]), L = V.useMemo(() => d.reduce((j, U) => m[U] != null && bm(U) ? j + 1 : j, 0), [m, d]), B = $[C], H = Mt(() => B === "UI"), [q, J] = V.useState(B === "UI" ? C : null);
  return q !== C && $[C] === "UI" && J(C), gi(() => {
    B === "field" && s && (u(), setTimeout(() => {
      r == null || r.current.focus(), a(C);
    }));
  }, [C]), gi(() => {
    if (!s)
      return;
    let j = C;
    B === "field" && q != null && (j = q), j !== S && $[j] === "UI" && $[S] === "UI" && (j = S), j !== C && E(j), O(j, !0);
  }, [s]), {
    hasUIView: I,
    shouldRestoreFocus: H,
    layoutProps: {
      views: d,
      view: q,
      onViewChange: E
    },
    renderCurrentView: () => {
      if (q == null)
        return null;
      const j = m[q];
      return j == null ? null : j(N({}, x, n, t, {
        views: d,
        timezone: v,
        onChange: A,
        view: q,
        onViewChange: E,
        focusedView: w,
        onFocusedViewChange: O,
        showViewSwitcher: L > 1,
        timeViewsCount: L
      }));
    }
  };
};
function vj() {
  return typeof window > "u" ? "portrait" : window.screen && window.screen.orientation && window.screen.orientation.angle ? Math.abs(window.screen.orientation.angle) === 90 ? "landscape" : "portrait" : window.orientation && Math.abs(Number(window.orientation)) === 90 ? "landscape" : "portrait";
}
const cWe = (e, t) => {
  const [n, r] = V.useState(vj);
  return gi(() => {
    const o = () => {
      r(vj());
    };
    return window.addEventListener("orientationchange", o), () => {
      window.removeEventListener("orientationchange", o);
    };
  }, []), Ph(e, ["hours", "minutes", "seconds"]) ? !1 : (t || n) === "landscape";
}, dWe = ({
  props: e,
  propsFromPickerValue: t,
  propsFromPickerViews: n,
  wrapperVariant: r
}) => {
  const {
    orientation: i
  } = e, o = cWe(n.views, i);
  return {
    layoutProps: N({}, n, t, {
      isLandscape: o,
      wrapperVariant: r,
      disabled: e.disabled,
      readOnly: e.readOnly
    })
  };
}, jW = (e, t = "warning") => {
  let n = !1;
  const r = Array.isArray(e) ? e.join(`
`) : e;
  return () => {
    n || (n = !0, t === "error" ? console.error(r) : console.warn(r));
  };
}, pWe = jW(["The `renderInput` prop has been removed in version 6.0 of the Date and Time Pickers.", "You can replace it with the `textField` component slot in most cases.", "For more information, please have a look at the migration guide (https://mui.com/x/migration/migration-pickers-v5/#input-renderer-required-in-v5)."]), VW = ({
  props: e,
  valueManager: t,
  valueType: n,
  wrapperVariant: r,
  inputRef: i,
  additionalViewProps: o,
  validator: s,
  autoFocusView: a
}) => {
  process.env.NODE_ENV !== "production" && e.renderInput != null && pWe();
  const u = aWe({
    props: e,
    valueManager: t,
    valueType: n,
    wrapperVariant: r,
    validator: s
  }), c = uWe({
    props: e,
    inputRef: i,
    additionalViewProps: o,
    autoFocusView: a,
    propsFromPickerValue: u.viewProps
  }), d = dWe({
    props: e,
    wrapperVariant: r,
    propsFromPickerValue: u.layoutProps,
    propsFromPickerViews: c.layoutProps
  });
  return {
    // Picker value
    open: u.open,
    actions: u.actions,
    fieldProps: u.fieldProps,
    // Picker views
    renderCurrentView: c.renderCurrentView,
    hasUIView: c.hasUIView,
    shouldRestoreFocus: c.shouldRestoreFocus,
    // Picker layout
    layoutProps: d.layoutProps
  };
};
function zW(e) {
  return ot("MuiPickersLayout", e);
}
const iw = st("MuiPickersLayout", ["root", "landscape", "contentWrapper", "toolbar", "actionBar", "tabs", "shortcuts"]), fWe = ["onAccept", "onClear", "onCancel", "onSetToday", "actions"];
function UW(e) {
  const {
    onAccept: t,
    onClear: n,
    onCancel: r,
    onSetToday: i,
    actions: o
  } = e, s = _e(e, fWe), a = Yi();
  if (o == null || o.length === 0)
    return null;
  const u = o == null ? void 0 : o.map((c) => {
    switch (c) {
      case "clear":
        return /* @__PURE__ */ P.jsx(Nr, {
          onClick: n,
          children: a.clearButtonLabel
        }, c);
      case "cancel":
        return /* @__PURE__ */ P.jsx(Nr, {
          onClick: r,
          children: a.cancelButtonLabel
        }, c);
      case "accept":
        return /* @__PURE__ */ P.jsx(Nr, {
          onClick: t,
          children: a.okButtonLabel
        }, c);
      case "today":
        return /* @__PURE__ */ P.jsx(Nr, {
          onClick: i,
          children: a.todayButtonLabel
        }, c);
      default:
        return null;
    }
  });
  return /* @__PURE__ */ P.jsx(ev, N({}, s, {
    children: u
  }));
}
process.env.NODE_ENV !== "production" && (UW.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Ordered array of actions to display.
   * If empty, does not display that action bar.
   * @default `['cancel', 'accept']` for mobile and `[]` for desktop
   */
  actions: l.arrayOf(l.oneOf(["accept", "cancel", "clear", "today"]).isRequired),
  /**
   * If `true`, the actions do not have additional margin.
   * @default false
   */
  disableSpacing: l.bool,
  onAccept: l.func.isRequired,
  onCancel: l.func.isRequired,
  onClear: l.func.isRequired,
  onSetToday: l.func.isRequired,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
const hWe = ["items", "changeImportance", "isLandscape", "onChange", "isValid"], mWe = ["getValue"];
function WW(e) {
  const {
    items: t,
    changeImportance: n,
    onChange: r,
    isValid: i
  } = e, o = _e(e, hWe);
  if (t == null || t.length === 0)
    return null;
  const s = t.map((a) => {
    let {
      getValue: u
    } = a, c = _e(a, mWe);
    const d = u({
      isValid: i
    });
    return {
      label: c.label,
      onClick: () => {
        r(d, n, c);
      },
      disabled: !i(d)
    };
  });
  return /* @__PURE__ */ P.jsx(ov, N({
    dense: !0,
    sx: [{
      maxHeight: KE,
      maxWidth: 200,
      overflow: "auto"
    }, ...Array.isArray(o.sx) ? o.sx : [o.sx]]
  }, o, {
    children: s.map((a) => /* @__PURE__ */ P.jsx(UE, {
      children: /* @__PURE__ */ P.jsx(Xb, N({}, a))
    }, a.label))
  }));
}
process.env.NODE_ENV !== "production" && (WW.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Importance of the change when picking a shortcut:
   * - "accept": fires `onChange`, fires `onAccept` and closes the picker.
   * - "set": fires `onChange` but do not fire `onAccept` and does not close the picker.
   * @default "accept"
   */
  changeImportance: l.oneOf(["accept", "set"]),
  className: l.string,
  component: l.elementType,
  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input is used for
   * the list and list items.
   * The prop is available to descendant components as the `dense` context.
   * @default false
   */
  dense: l.bool,
  /**
   * If `true`, vertical padding is removed from the list.
   * @default false
   */
  disablePadding: l.bool,
  isLandscape: l.bool.isRequired,
  isValid: l.func.isRequired,
  /**
   * Ordered array of shortcuts to display.
   * If empty, does not display the shortcuts.
   * @default `[]`
   */
  items: l.arrayOf(l.shape({
    getValue: l.func.isRequired,
    label: l.string.isRequired
  })),
  onChange: l.func.isRequired,
  style: l.object,
  /**
   * The content of the subheader, normally `ListSubheader`.
   */
  subheader: l.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
});
function gWe(e) {
  return e.view !== null;
}
const yWe = (e) => {
  const {
    classes: t,
    isLandscape: n
  } = e;
  return at({
    root: ["root", n && "landscape"],
    contentWrapper: ["contentWrapper"],
    toolbar: ["toolbar"],
    actionBar: ["actionBar"],
    tabs: ["tabs"],
    landscape: ["landscape"],
    shortcuts: ["shortcuts"]
  }, zW, t);
}, bWe = (e) => {
  var t, n;
  const {
    wrapperVariant: r,
    onAccept: i,
    onClear: o,
    onCancel: s,
    onSetToday: a,
    view: u,
    views: c,
    onViewChange: d,
    value: f,
    onChange: h,
    onSelectShortcut: m,
    isValid: v,
    isLandscape: x,
    disabled: C,
    readOnly: E,
    children: S,
    components: w,
    componentsProps: O,
    slots: A,
    slotProps: I
    // TODO: Remove this "as" hack. It get introduced to mark `value` prop in PickersLayoutProps as not required.
    // The true type should be
    // - For pickers value: TDate | null
    // - For range pickers value: [TDate | null, TDate | null]
  } = e, $ = A ?? cv(w), L = I ?? O, B = yWe(e), H = (t = $ == null ? void 0 : $.actionBar) != null ? t : UW, q = si({
    elementType: H,
    externalSlotProps: L == null ? void 0 : L.actionBar,
    additionalProps: {
      onAccept: i,
      onClear: o,
      onCancel: s,
      onSetToday: a,
      actions: r === "desktop" ? [] : ["cancel", "accept"],
      className: B.actionBar
    },
    ownerState: N({}, e, {
      wrapperVariant: r
    })
  }), J = /* @__PURE__ */ P.jsx(H, N({}, q)), X = $ == null ? void 0 : $.toolbar, j = si({
    elementType: X,
    externalSlotProps: L == null ? void 0 : L.toolbar,
    additionalProps: {
      isLandscape: x,
      onChange: h,
      value: f,
      view: u,
      onViewChange: d,
      views: c,
      disabled: C,
      readOnly: E,
      className: B.toolbar
    },
    ownerState: N({}, e, {
      wrapperVariant: r
    })
  }), U = gWe(j) && X ? /* @__PURE__ */ P.jsx(X, N({}, j)) : null, G = S, K = $ == null ? void 0 : $.tabs, ee = u && K ? /* @__PURE__ */ P.jsx(K, N({
    view: u,
    onViewChange: d,
    className: B.tabs
  }, L == null ? void 0 : L.tabs)) : null, te = (n = $ == null ? void 0 : $.shortcuts) != null ? n : WW, M = si({
    elementType: te,
    externalSlotProps: L == null ? void 0 : L.shortcuts,
    additionalProps: {
      isValid: v,
      isLandscape: x,
      onChange: m,
      className: B.shortcuts
    },
    ownerState: {
      isValid: v,
      isLandscape: x,
      onChange: m,
      className: B.shortcuts,
      wrapperVariant: r
    }
  }), Z = u && te ? /* @__PURE__ */ P.jsx(te, N({}, M)) : null;
  return {
    toolbar: U,
    content: G,
    tabs: ee,
    actionBar: J,
    shortcuts: Z
  };
}, vWe = (e) => {
  const {
    isLandscape: t,
    classes: n
  } = e;
  return at({
    root: ["root", t && "landscape"],
    contentWrapper: ["contentWrapper"]
  }, zW, n);
}, HW = De("div", {
  name: "MuiPickersLayout",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e,
  ownerState: t
}) => ({
  display: "grid",
  gridAutoColumns: "max-content auto max-content",
  gridAutoRows: "max-content auto max-content",
  [`& .${iw.toolbar}`]: t.isLandscape ? {
    gridColumn: e.direction === "rtl" ? 3 : 1,
    gridRow: "2 / 3"
  } : {
    gridColumn: "2 / 4",
    gridRow: 1
  },
  [`.${iw.shortcuts}`]: t.isLandscape ? {
    gridColumn: "2 / 4",
    gridRow: 1
  } : {
    gridColumn: e.direction === "rtl" ? 3 : 1,
    gridRow: "2 / 3"
  },
  [`& .${iw.actionBar}`]: {
    gridColumn: "1 / 4",
    gridRow: 3
  }
}));
HW.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  as: l.elementType,
  ownerState: l.shape({
    isLandscape: l.bool.isRequired
  }).isRequired,
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
};
const xWe = De("div", {
  name: "MuiPickersLayout",
  slot: "ContentWrapper",
  overridesResolver: (e, t) => t.contentWrapper
})({
  gridColumn: 2,
  gridRow: 2,
  display: "flex",
  flexDirection: "column"
}), t$ = function(t) {
  const n = Vn({
    props: t,
    name: "MuiPickersLayout"
  }), {
    toolbar: r,
    content: i,
    tabs: o,
    actionBar: s,
    shortcuts: a
  } = bWe(n), {
    sx: u,
    className: c,
    isLandscape: d,
    ref: f,
    wrapperVariant: h
  } = n, m = n, v = vWe(m);
  return /* @__PURE__ */ P.jsxs(HW, {
    ref: f,
    sx: u,
    className: Be(c, v.root),
    ownerState: m,
    children: [d ? a : r, d ? r : a, /* @__PURE__ */ P.jsx(xWe, {
      className: v.contentWrapper,
      children: h === "desktop" ? /* @__PURE__ */ P.jsxs(V.Fragment, {
        children: [i, o]
      }) : /* @__PURE__ */ P.jsxs(V.Fragment, {
        children: [o, i]
      })
    }), s]
  });
};
process.env.NODE_ENV !== "production" && (t$.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  children: l.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  className: l.string,
  /**
   * Overridable components.
   * @default {}
   * @deprecated Please use `slots`.
   */
  components: l.object,
  /**
   * The props used for each component slot.
   * @default {}
   * @deprecated Please use `slotProps`.
   */
  componentsProps: l.object,
  disabled: l.bool,
  isLandscape: l.bool.isRequired,
  isValid: l.func.isRequired,
  onAccept: l.func.isRequired,
  onCancel: l.func.isRequired,
  onChange: l.func.isRequired,
  onClear: l.func.isRequired,
  onClose: l.func.isRequired,
  onDismiss: l.func.isRequired,
  onOpen: l.func.isRequired,
  onSelectShortcut: l.func.isRequired,
  onSetToday: l.func.isRequired,
  onViewChange: l.func.isRequired,
  /**
   * Force rendering in particular orientation.
   */
  orientation: l.oneOf(["landscape", "portrait"]),
  readOnly: l.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: l.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: l.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  value: l.any,
  view: l.oneOf(["day", "hours", "meridiem", "minutes", "month", "seconds", "year"]),
  views: l.arrayOf(l.oneOf(["day", "hours", "meridiem", "minutes", "month", "seconds", "year"]).isRequired).isRequired,
  wrapperVariant: l.oneOf(["desktop", "mobile"])
});
const QE = ({
  adapter: e,
  value: t,
  props: n
}) => {
  if (t === null)
    return null;
  const {
    minTime: r,
    maxTime: i,
    minutesStep: o,
    shouldDisableClock: s,
    shouldDisableTime: a,
    disableIgnoringDatePartForTimeValidation: u = !1,
    disablePast: c,
    disableFuture: d,
    timezone: f
  } = n, h = e.utils.dateWithTimezone(void 0, f), m = lv(u, e.utils);
  switch (!0) {
    case !e.utils.isValid(t):
      return "invalidDate";
    case !!(r && m(r, t)):
      return "minTime";
    case !!(i && m(t, i)):
      return "maxTime";
    case !!(d && e.utils.isAfter(t, h)):
      return "disableFuture";
    case !!(c && e.utils.isBefore(t, h)):
      return "disablePast";
    case !!(a && a(t, "hours")):
      return "shouldDisableTime-hours";
    case !!(a && a(t, "minutes")):
      return "shouldDisableTime-minutes";
    case !!(a && a(t, "seconds")):
      return "shouldDisableTime-seconds";
    case !!(s && s(e.utils.getHours(t), "hours")):
      return "shouldDisableClock-hours";
    case !!(s && s(e.utils.getMinutes(t), "minutes")):
      return "shouldDisableClock-minutes";
    case !!(s && s(e.utils.getSeconds(t), "seconds")):
      return "shouldDisableClock-seconds";
    case !!(o && e.utils.getMinutes(t) % o !== 0):
      return "minutesStep";
    default:
      return null;
  }
}, n$ = ({
  props: e,
  value: t,
  adapter: n
}) => {
  const r = dv({
    adapter: n,
    value: t,
    props: e
  });
  return r !== null ? r : QE({
    adapter: n,
    value: t,
    props: e
  });
}, DWe = (e) => ot("MuiPickersSlideTransition", e), Ea = st("MuiPickersSlideTransition", ["root", "slideEnter-left", "slideEnter-right", "slideEnterActive", "slideExit", "slideExitActiveLeft-left", "slideExitActiveLeft-right"]), CWe = ["children", "className", "reduceAnimations", "slideDirection", "transKey", "classes"], EWe = (e) => {
  const {
    classes: t,
    slideDirection: n
  } = e, r = {
    root: ["root"],
    exit: ["slideExit"],
    enterActive: ["slideEnterActive"],
    enter: [`slideEnter-${n}`],
    exitActive: [`slideExitActiveLeft-${n}`]
  };
  return at(r, DWe, t);
}, TWe = De(Gb, {
  name: "MuiPickersSlideTransition",
  slot: "Root",
  overridesResolver: (e, t) => [t.root, {
    [`.${Ea["slideEnter-left"]}`]: t["slideEnter-left"]
  }, {
    [`.${Ea["slideEnter-right"]}`]: t["slideEnter-right"]
  }, {
    [`.${Ea.slideEnterActive}`]: t.slideEnterActive
  }, {
    [`.${Ea.slideExit}`]: t.slideExit
  }, {
    [`.${Ea["slideExitActiveLeft-left"]}`]: t["slideExitActiveLeft-left"]
  }, {
    [`.${Ea["slideExitActiveLeft-right"]}`]: t["slideExitActiveLeft-right"]
  }]
})(({
  theme: e
}) => {
  const t = e.transitions.create("transform", {
    duration: e.transitions.duration.complex,
    easing: "cubic-bezier(0.35, 0.8, 0.4, 1)"
  });
  return {
    display: "block",
    position: "relative",
    overflowX: "hidden",
    "& > *": {
      position: "absolute",
      top: 0,
      right: 0,
      left: 0
    },
    [`& .${Ea["slideEnter-left"]}`]: {
      willChange: "transform",
      transform: "translate(100%)",
      zIndex: 1
    },
    [`& .${Ea["slideEnter-right"]}`]: {
      willChange: "transform",
      transform: "translate(-100%)",
      zIndex: 1
    },
    [`& .${Ea.slideEnterActive}`]: {
      transform: "translate(0%)",
      transition: t
    },
    [`& .${Ea.slideExit}`]: {
      transform: "translate(0%)"
    },
    [`& .${Ea["slideExitActiveLeft-left"]}`]: {
      willChange: "transform",
      transform: "translate(-100%)",
      transition: t,
      zIndex: 0
    },
    [`& .${Ea["slideExitActiveLeft-right"]}`]: {
      willChange: "transform",
      transform: "translate(100%)",
      transition: t,
      zIndex: 0
    }
  };
});
function SWe(e) {
  const t = Vn({
    props: e,
    name: "MuiPickersSlideTransition"
  }), {
    children: n,
    className: r,
    reduceAnimations: i,
    transKey: o
    // extracting `classes` from `other`
  } = t, s = _e(t, CWe), a = EWe(t), u = Gi();
  if (i)
    return /* @__PURE__ */ P.jsx("div", {
      className: Be(a.root, r),
      children: n
    });
  const c = {
    exit: a.exit,
    enterActive: a.enterActive,
    enter: a.enter,
    exitActive: a.exitActive
  };
  return /* @__PURE__ */ P.jsx(TWe, {
    className: Be(a.root, r),
    childFactory: (d) => /* @__PURE__ */ V.cloneElement(d, {
      classNames: c
    }),
    role: "presentation",
    children: /* @__PURE__ */ P.jsx(JI, N({
      mountOnEnter: !0,
      unmountOnExit: !0,
      timeout: u.transitions.duration.complex,
      classNames: c
    }, s, {
      children: n
    }), o)
  });
}
const qW = ({
  shouldDisableDate: e,
  shouldDisableMonth: t,
  shouldDisableYear: n,
  minDate: r,
  maxDate: i,
  disableFuture: o,
  disablePast: s,
  timezone: a
}) => {
  const u = xf();
  return V.useCallback((c) => dv({
    adapter: u,
    value: c,
    props: {
      shouldDisableDate: e,
      shouldDisableMonth: t,
      shouldDisableYear: n,
      minDate: r,
      maxDate: i,
      disableFuture: o,
      disablePast: s,
      timezone: a
    }
  }) !== null, [u, e, t, n, r, i, o, s, a]);
}, AWe = (e) => ot("MuiDayCalendar", e);
st("MuiDayCalendar", ["root", "header", "weekDayLabel", "loadingContainer", "slideTransition", "monthContainer", "weekContainer", "weekNumberLabel", "weekNumber"]);
const wWe = ["parentProps", "day", "focusableDay", "selectedDays", "isDateDisabled", "currentMonthNumber", "isViewFocused"], PWe = ["ownerState"], kWe = (e) => {
  const {
    classes: t
  } = e;
  return at({
    root: ["root"],
    header: ["header"],
    weekDayLabel: ["weekDayLabel"],
    loadingContainer: ["loadingContainer"],
    slideTransition: ["slideTransition"],
    monthContainer: ["monthContainer"],
    weekContainer: ["weekContainer"],
    weekNumberLabel: ["weekNumberLabel"],
    weekNumber: ["weekNumber"]
  }, AWe, t);
}, GW = (q0 + GE * 2) * 6, OWe = De("div", {
  name: "MuiDayCalendar",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), IWe = De("div", {
  name: "MuiDayCalendar",
  slot: "Header",
  overridesResolver: (e, t) => t.header
})({
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
}), FWe = De(cn, {
  name: "MuiDayCalendar",
  slot: "WeekDayLabel",
  overridesResolver: (e, t) => t.weekDayLabel
})(({
  theme: e
}) => ({
  width: 36,
  height: 40,
  margin: "0 2px",
  textAlign: "center",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  color: (e.vars || e).palette.text.secondary
})), $We = De(cn, {
  name: "MuiDayCalendar",
  slot: "WeekNumberLabel",
  overridesResolver: (e, t) => t.weekNumberLabel
})(({
  theme: e
}) => ({
  width: 36,
  height: 40,
  margin: "0 2px",
  textAlign: "center",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  color: e.palette.text.disabled
})), NWe = De(cn, {
  name: "MuiDayCalendar",
  slot: "WeekNumber",
  overridesResolver: (e, t) => t.weekNumber
})(({
  theme: e
}) => N({}, e.typography.caption, {
  width: q0,
  height: q0,
  padding: 0,
  margin: `0 ${GE}px`,
  color: e.palette.text.disabled,
  fontSize: "0.75rem",
  alignItems: "center",
  justifyContent: "center",
  display: "inline-flex"
})), MWe = De("div", {
  name: "MuiDayCalendar",
  slot: "LoadingContainer",
  overridesResolver: (e, t) => t.loadingContainer
})({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  minHeight: GW
}), RWe = De(SWe, {
  name: "MuiDayCalendar",
  slot: "SlideTransition",
  overridesResolver: (e, t) => t.slideTransition
})({
  minHeight: GW
}), _We = De("div", {
  name: "MuiDayCalendar",
  slot: "MonthContainer",
  overridesResolver: (e, t) => t.monthContainer
})({
  overflow: "hidden"
}), LWe = De("div", {
  name: "MuiDayCalendar",
  slot: "WeekContainer",
  overridesResolver: (e, t) => t.weekContainer
})({
  margin: `${GE}px 0`,
  display: "flex",
  justifyContent: "center"
});
function BWe(e) {
  var t, n, r;
  let {
    parentProps: i,
    day: o,
    focusableDay: s,
    selectedDays: a,
    isDateDisabled: u,
    currentMonthNumber: c,
    isViewFocused: d
  } = e, f = _e(e, wWe);
  const {
    disabled: h,
    disableHighlightToday: m,
    isMonthSwitchingAnimating: v,
    showDaysOutsideCurrentMonth: x,
    components: C,
    componentsProps: E,
    slots: S,
    slotProps: w,
    timezone: O
  } = i, A = Nn(), I = Cf(O), $ = s !== null && A.isSameDay(o, s), L = a.some((K) => A.isSameDay(K, o)), B = A.isSameDay(o, I), H = (t = (n = S == null ? void 0 : S.day) != null ? n : C == null ? void 0 : C.Day) != null ? t : EUe, q = si({
    elementType: H,
    externalSlotProps: (r = w == null ? void 0 : w.day) != null ? r : E == null ? void 0 : E.day,
    additionalProps: N({
      disableHighlightToday: m,
      showDaysOutsideCurrentMonth: x,
      role: "gridcell",
      isAnimating: v,
      // it is used in date range dragging logic by accessing `dataset.timestamp`
      "data-timestamp": A.toJsDate(o).valueOf()
    }, f),
    ownerState: N({}, i, {
      day: o,
      selected: L
    })
  }), J = _e(q, PWe), X = V.useMemo(() => h || u(o), [h, u, o]), j = V.useMemo(() => A.getMonth(o) !== c, [A, o, c]), U = V.useMemo(() => {
    const K = A.startOfMonth(A.setMonth(o, c));
    return x ? A.isSameDay(o, A.startOfWeek(K)) : A.isSameDay(o, K);
  }, [c, o, x, A]), G = V.useMemo(() => {
    const K = A.endOfMonth(A.setMonth(o, c));
    return x ? A.isSameDay(o, A.endOfWeek(K)) : A.isSameDay(o, K);
  }, [c, o, x, A]);
  return /* @__PURE__ */ P.jsx(H, N({}, J, {
    day: o,
    disabled: X,
    autoFocus: d && $,
    today: B,
    outsideCurrentMonth: j,
    isFirstVisibleCell: U,
    isLastVisibleCell: G,
    selected: L,
    tabIndex: $ ? 0 : -1,
    "aria-selected": L,
    "aria-current": B ? "date" : void 0
  }));
}
function jWe(e) {
  const t = Vn({
    props: e,
    name: "MuiDayCalendar"
  }), {
    onFocusedDayChange: n,
    className: r,
    currentMonth: i,
    selectedDays: o,
    focusedDay: s,
    loading: a,
    onSelectedDaysChange: u,
    onMonthSwitchingAnimationEnd: c,
    readOnly: d,
    reduceAnimations: f,
    renderLoading: h = () => /* @__PURE__ */ P.jsx("span", {
      children: "..."
    }),
    slideDirection: m,
    TransitionProps: v,
    disablePast: x,
    disableFuture: C,
    minDate: E,
    maxDate: S,
    shouldDisableDate: w,
    shouldDisableMonth: O,
    shouldDisableYear: A,
    dayOfWeekFormatter: I,
    hasFocus: $,
    onFocusedViewChange: L,
    gridLabelId: B,
    displayWeekNumber: H,
    fixedWeekNumber: q,
    autoFocus: J,
    timezone: X
  } = t, j = Cf(X), U = Nn(), G = kWe(t), ee = Gi().direction === "rtl", te = I || ((Ne, Qe) => U.format(Qe, "weekdayShort").charAt(0).toUpperCase()), M = qW({
    shouldDisableDate: w,
    shouldDisableMonth: O,
    shouldDisableYear: A,
    minDate: E,
    maxDate: S,
    disablePast: x,
    disableFuture: C,
    timezone: X
  }), Z = Yi(), [ne, R] = Hi({
    name: "DayCalendar",
    state: "hasFocus",
    controlled: $,
    default: J ?? !1
  }), [_, W] = V.useState(() => s || j), Q = Mt((Ne) => {
    d || u(Ne);
  }), oe = (Ne) => {
    M(Ne) || (n(Ne), W(Ne), L == null || L(!0), R(!0));
  }, ae = Mt((Ne, Qe) => {
    switch (Ne.key) {
      case "ArrowUp":
        oe(U.addDays(Qe, -7)), Ne.preventDefault();
        break;
      case "ArrowDown":
        oe(U.addDays(Qe, 7)), Ne.preventDefault();
        break;
      case "ArrowLeft": {
        const Ee = U.addDays(Qe, ee ? 1 : -1), Ie = U.addMonths(Qe, ee ? 1 : -1), Je = f0({
          utils: U,
          date: Ee,
          minDate: ee ? Ee : U.startOfMonth(Ie),
          maxDate: ee ? U.endOfMonth(Ie) : Ee,
          isDateDisabled: M,
          timezone: X
        });
        oe(Je || Ee), Ne.preventDefault();
        break;
      }
      case "ArrowRight": {
        const Ee = U.addDays(Qe, ee ? -1 : 1), Ie = U.addMonths(Qe, ee ? -1 : 1), Je = f0({
          utils: U,
          date: Ee,
          minDate: ee ? U.startOfMonth(Ie) : Ee,
          maxDate: ee ? Ee : U.endOfMonth(Ie),
          isDateDisabled: M,
          timezone: X
        });
        oe(Je || Ee), Ne.preventDefault();
        break;
      }
      case "Home":
        oe(U.startOfWeek(Qe)), Ne.preventDefault();
        break;
      case "End":
        oe(U.endOfWeek(Qe)), Ne.preventDefault();
        break;
      case "PageUp":
        oe(U.addMonths(Qe, 1)), Ne.preventDefault();
        break;
      case "PageDown":
        oe(U.addMonths(Qe, -1)), Ne.preventDefault();
        break;
    }
  }), pe = Mt((Ne, Qe) => oe(Qe)), me = Mt((Ne, Qe) => {
    ne && U.isSameDay(_, Qe) && (L == null || L(!1));
  }), xe = U.getMonth(i), le = V.useMemo(() => o.filter((Ne) => !!Ne).map((Ne) => U.startOfDay(Ne)), [U, o]), ye = xe, be = V.useMemo(() => /* @__PURE__ */ V.createRef(), [ye]), Re = U.startOfWeek(j), Te = V.useMemo(() => {
    const Ne = U.startOfMonth(i), Qe = U.endOfMonth(i);
    return M(_) || U.isAfterDay(_, Qe) || U.isBeforeDay(_, Ne) ? f0({
      utils: U,
      date: _,
      minDate: Ne,
      maxDate: Qe,
      disablePast: x,
      disableFuture: C,
      isDateDisabled: M,
      timezone: X
    }) : _;
  }, [i, C, x, _, M, U, X]), Xe = V.useMemo(() => {
    const Ne = U.setTimezone(i, X), Qe = U.getWeekArray(Ne);
    let Ee = U.addMonths(Ne, 1);
    for (; q && Qe.length < q; ) {
      const Ie = U.getWeekArray(Ee), Je = U.isSameDay(Qe[Qe.length - 1][0], Ie[0][0]);
      Ie.slice(Je ? 1 : 0).forEach((vt) => {
        Qe.length < q && Qe.push(vt);
      }), Ee = U.addMonths(Ee, 1);
    }
    return Qe;
  }, [i, q, U, X]);
  return /* @__PURE__ */ P.jsxs(OWe, {
    role: "grid",
    "aria-labelledby": B,
    className: G.root,
    children: [/* @__PURE__ */ P.jsxs(IWe, {
      role: "row",
      className: G.header,
      children: [H && /* @__PURE__ */ P.jsx($We, {
        variant: "caption",
        role: "columnheader",
        "aria-label": Z.calendarWeekNumberHeaderLabel,
        className: G.weekNumberLabel,
        children: Z.calendarWeekNumberHeaderText
      }), xze(U, j).map((Ne, Qe) => {
        var Ee;
        const Ie = U.format(Ne, "weekdayShort");
        return /* @__PURE__ */ P.jsx(FWe, {
          variant: "caption",
          role: "columnheader",
          "aria-label": U.format(U.addDays(Re, Qe), "weekday"),
          className: G.weekDayLabel,
          children: (Ee = te == null ? void 0 : te(Ie, Ne)) != null ? Ee : Ie
        }, Ie + Qe.toString());
      })]
    }), a ? /* @__PURE__ */ P.jsx(MWe, {
      className: G.loadingContainer,
      children: h()
    }) : /* @__PURE__ */ P.jsx(RWe, N({
      transKey: ye,
      onExited: c,
      reduceAnimations: f,
      slideDirection: m,
      className: Be(r, G.slideTransition)
    }, v, {
      nodeRef: be,
      children: /* @__PURE__ */ P.jsx(_We, {
        ref: be,
        role: "rowgroup",
        className: G.monthContainer,
        children: Xe.map((Ne, Qe) => /* @__PURE__ */ P.jsxs(LWe, {
          role: "row",
          className: G.weekContainer,
          "aria-rowindex": Qe + 1,
          children: [H && /* @__PURE__ */ P.jsx(NWe, {
            className: G.weekNumber,
            role: "rowheader",
            "aria-label": Z.calendarWeekNumberAriaLabelText(U.getWeekNumber(Ne[0])),
            children: Z.calendarWeekNumberText(U.getWeekNumber(Ne[0]))
          }), Ne.map((Ee, Ie) => /* @__PURE__ */ P.jsx(BWe, {
            parentProps: t,
            day: Ee,
            selectedDays: le,
            focusableDay: Te,
            onKeyDown: ae,
            onFocus: pe,
            onBlur: me,
            onDaySelect: Q,
            isDateDisabled: M,
            currentMonthNumber: xe,
            isViewFocused: ne,
            "aria-colindex": Ie + 1
          }, Ee.toString()))]
        }, `week-${Ne[0]}`))
      })
    }))]
  });
}
const VWe = (e, t, n) => (r, i) => {
  switch (i.type) {
    case "changeMonth":
      return N({}, r, {
        slideDirection: i.direction,
        currentMonth: i.newMonth,
        isMonthSwitchingAnimating: !e
      });
    case "finishMonthSwitchingAnimation":
      return N({}, r, {
        isMonthSwitchingAnimating: !1
      });
    case "changeFocusedDay": {
      if (r.focusedDay != null && i.focusedDay != null && n.isSameDay(i.focusedDay, r.focusedDay))
        return r;
      const o = i.focusedDay != null && !t && !n.isSameMonth(r.currentMonth, i.focusedDay);
      return N({}, r, {
        focusedDay: i.focusedDay,
        isMonthSwitchingAnimating: o && !e && !i.withoutMonthSwitchingAnimation,
        currentMonth: o ? n.startOfMonth(i.focusedDay) : r.currentMonth,
        slideDirection: i.focusedDay != null && n.isAfterDay(i.focusedDay, r.currentMonth) ? "left" : "right"
      });
    }
    default:
      throw new Error("missing support");
  }
}, zWe = (e) => {
  const {
    value: t,
    referenceDate: n,
    defaultCalendarMonth: r,
    disableFuture: i,
    disablePast: o,
    disableSwitchToMonthOnDayFocus: s = !1,
    maxDate: a,
    minDate: u,
    onMonthChange: c,
    reduceAnimations: d,
    shouldDisableDate: f,
    timezone: h
  } = e, m = Nn(), v = V.useRef(VWe(!!d, s, m)).current, x = V.useMemo(
    () => {
      let $ = null;
      return n ? $ = n : r && ($ = m.startOfMonth(r)), qi.getInitialReferenceValue({
        value: t,
        utils: m,
        timezone: h,
        props: e,
        referenceDate: $,
        granularity: pl.day
      });
    },
    []
    // eslint-disable-line react-hooks/exhaustive-deps
  ), [C, E] = V.useReducer(v, {
    isMonthSwitchingAnimating: !1,
    focusedDay: x,
    currentMonth: m.startOfMonth(x),
    slideDirection: "left"
  }), S = V.useCallback(($) => {
    E(N({
      type: "changeMonth"
    }, $)), c && c($.newMonth);
  }, [c]), w = V.useCallback(($) => {
    const L = $;
    m.isSameMonth(L, C.currentMonth) || S({
      newMonth: m.startOfMonth(L),
      direction: m.isAfterDay(L, C.currentMonth) ? "left" : "right"
    });
  }, [C.currentMonth, S, m]), O = qW({
    shouldDisableDate: f,
    minDate: u,
    maxDate: a,
    disableFuture: i,
    disablePast: o,
    timezone: h
  }), A = V.useCallback(() => {
    E({
      type: "finishMonthSwitchingAnimation"
    });
  }, []), I = Mt(($, L) => {
    O($) || E({
      type: "changeFocusedDay",
      focusedDay: $,
      withoutMonthSwitchingAnimation: L
    });
  });
  return {
    referenceDate: x,
    calendarState: C,
    changeMonth: w,
    changeFocusedDay: I,
    isDateDisabled: O,
    onMonthSwitchingAnimationEnd: A,
    handleChangeMonth: S
  };
}, UWe = ["ownerState"], r$ = ({
  clearable: e,
  fieldProps: t,
  InputProps: n,
  onClear: r,
  slots: i,
  slotProps: o,
  components: s,
  componentsProps: a
}) => {
  var u, c, d, f, h, m;
  const v = Yi(), x = (u = (c = i == null ? void 0 : i.clearButton) != null ? c : s == null ? void 0 : s.ClearButton) != null ? u : Or, C = si({
    elementType: x,
    externalSlotProps: (d = o == null ? void 0 : o.clearButton) != null ? d : a == null ? void 0 : a.clearButton,
    ownerState: {},
    className: "clearButton",
    additionalProps: {
      title: v.fieldClearLabel
    }
  }), E = _e(C, UWe), S = (f = (h = i == null ? void 0 : i.clearIcon) != null ? h : s == null ? void 0 : s.ClearIcon) != null ? f : HVe, w = si({
    elementType: S,
    externalSlotProps: (m = o == null ? void 0 : o.clearIcon) != null ? m : a == null ? void 0 : a.clearIcon,
    ownerState: {}
  }), O = N({}, n, {
    endAdornment: /* @__PURE__ */ P.jsxs(V.Fragment, {
      children: [e && /* @__PURE__ */ P.jsx(lg, {
        position: "end",
        sx: {
          marginRight: n != null && n.endAdornment ? -1 : -1.5
        },
        children: /* @__PURE__ */ P.jsx(x, N({}, E, {
          onClick: r,
          children: /* @__PURE__ */ P.jsx(S, N({
            fontSize: "small"
          }, w))
        }))
      }), n == null ? void 0 : n.endAdornment]
    })
  }), A = N({}, t, {
    sx: [{
      "& .clearButton": {
        opacity: 1
      },
      "@media (pointer: fine)": {
        "& .clearButton": {
          opacity: 0
        },
        "&:hover, &:focus-within": {
          ".clearButton": {
            opacity: 1
          }
        }
      }
    }, ...Array.isArray(t.sx) ? t.sx : [t.sx]]
  });
  return {
    InputProps: O,
    fieldProps: A
  };
}, WWe = ["components", "componentsProps", "slots", "slotProps", "InputProps", "inputProps"], HWe = ["inputRef"], qWe = ["ref", "onPaste", "onKeyDown", "inputMode", "readOnly", "clearable", "onClear"], i$ = /* @__PURE__ */ V.forwardRef(function(t, n) {
  var r, i, o;
  const s = Vn({
    props: t,
    name: "MuiDateField"
  }), {
    components: a,
    componentsProps: u,
    slots: c,
    slotProps: d,
    InputProps: f,
    inputProps: h
  } = s, m = _e(s, WWe), v = s, x = (r = (i = c == null ? void 0 : c.textField) != null ? i : a == null ? void 0 : a.TextField) != null ? r : vf, C = si({
    elementType: x,
    externalSlotProps: (o = d == null ? void 0 : d.textField) != null ? o : u == null ? void 0 : u.textField,
    externalForwardedProps: m,
    ownerState: v
  }), {
    inputRef: E
  } = C, S = _e(C, HWe);
  S.inputProps = N({}, h, S.inputProps), S.InputProps = N({}, f, S.InputProps);
  const w = FUe({
    props: S,
    inputRef: E
  }), {
    ref: O,
    onPaste: A,
    onKeyDown: I,
    inputMode: $,
    readOnly: L,
    clearable: B,
    onClear: H
  } = w, q = _e(w, qWe), {
    InputProps: J,
    fieldProps: X
  } = r$({
    onClear: H,
    clearable: B,
    fieldProps: q,
    InputProps: q.InputProps,
    slots: c,
    slotProps: d,
    components: a,
    componentsProps: u
  });
  return /* @__PURE__ */ P.jsx(x, N({
    ref: n
  }, X, {
    InputProps: N({}, J, {
      readOnly: L
    }),
    inputProps: N({}, q.inputProps, {
      inputMode: $,
      onPaste: A,
      onKeyDown: I,
      ref: O
    })
  }));
});
process.env.NODE_ENV !== "production" && (i$.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the `input` element is focused during the first mount.
   * @default false
   */
  autoFocus: l.bool,
  className: l.string,
  /**
   * If `true`, a clear button will be shown in the field allowing value clearing.
   * @default false
   */
  clearable: l.bool,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: l.oneOf(["error", "info", "primary", "secondary", "success", "warning"]),
  component: l.elementType,
  /**
   * Overridable components.
   * @default {}
   * @deprecated Please use `slots`.
   */
  components: l.object,
  /**
   * The props used for each component slot.
   * @default {}
   * @deprecated Please use `slotProps`.
   */
  componentsProps: l.object,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: l.any,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: l.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: l.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: l.bool,
  /**
   * If `true`, the component is displayed in focused state.
   */
  focused: l.bool,
  /**
   * Format of the date when rendered in the input(s).
   */
  format: l.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: l.oneOf(["dense", "spacious"]),
  /**
   * Props applied to the [`FormHelperText`](/material-ui/api/form-helper-text/) element.
   */
  FormHelperTextProps: l.object,
  /**
   * If `true`, the input will take up the full width of its container.
   * @default false
   */
  fullWidth: l.bool,
  /**
   * The helper text content.
   */
  helperText: l.node,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: l.bool,
  /**
   * The id of the `input` element.
   * Use this prop to make `label` and `helperText` accessible for screen readers.
   */
  id: l.string,
  /**
   * Props applied to the [`InputLabel`](/material-ui/api/input-label/) element.
   * Pointer events like `onClick` are enabled if and only if `shrink` is `true`.
   */
  InputLabelProps: l.object,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: l.object,
  /**
   * Props applied to the Input element.
   * It will be a [`FilledInput`](/material-ui/api/filled-input/),
   * [`OutlinedInput`](/material-ui/api/outlined-input/) or [`Input`](/material-ui/api/input/)
   * component depending on the `variant` prop value.
   */
  InputProps: l.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: wr,
  /**
   * The label content.
   */
  label: l.node,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */
  margin: l.oneOf(["dense", "none", "normal"]),
  /**
   * Maximal selectable date.
   */
  maxDate: l.any,
  /**
   * Minimal selectable date.
   */
  minDate: l.any,
  /**
   * Name attribute of the `input` element.
   */
  name: l.string,
  onBlur: l.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: l.func,
  /**
   * Callback fired when the clear button is clicked.
   */
  onClear: l.func,
  /**
   * Callback fired when the error associated to the current value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error.
   * @param {TValue} value The value associated to the error.
   */
  onError: l.func,
  onFocus: l.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: l.func,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   * @default false
   */
  readOnly: l.bool,
  /**
   * The date used to generate a part of the new value that is not present in the format when both `value` and `defaultValue` are empty.
   * For example, on time fields it will be used to determine the date to set.
   * @default The closest valid date using the validation props, except callbacks such as `shouldDisableDate`. Value is rounded to the most granular section used.
   */
  referenceDate: l.any,
  /**
   * If `true`, the label is displayed as required and the `input` element is required.
   * @default false
   */
  required: l.bool,
  /**
   * The currently selected sections.
   * This prop accept four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If an object with a `startIndex` and `endIndex` properties are provided, the sections between those two indexes will be selected.
   * 3. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 4. If `null` is provided, no section will be selected
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: l.oneOfType([l.oneOf(["all", "day", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), l.number, l.shape({
    endIndex: l.number.isRequired,
    startIndex: l.number.isRequired
  })]),
  /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (e.g. when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */
  shouldDisableDate: l.func,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: l.func,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: l.func,
  /**
   * If `true`, the format will respect the leading zeroes (e.g: on dayjs, the format `M/D/YYYY` will render `8/16/2018`)
   * If `false`, the format will always add leading zeroes (e.g: on dayjs, the format `M/D/YYYY` will render `08/16/2018`)
   *
   * Warning n°1: Luxon is not able to respect the leading zeroes when using macro tokens (e.g: "DD"), so `shouldRespectLeadingZeros={true}` might lead to inconsistencies when using `AdapterLuxon`.
   *
   * Warning n°2: When `shouldRespectLeadingZeros={true}`, the field will add an invisible character on the sections containing a single digit to make sure `onChange` is fired.
   * If you need to get the clean value from the input, you can remove this character using `input.value.replace(/\u200e/g, '')`.
   *
   * Warning n°3: When used in strict mode, dayjs and moment require to respect the leading zeros.
   * This mean that when using `shouldRespectLeadingZeros={false}`, if you retrieve the value directly from the input (not listening to `onChange`) and your format contains tokens without leading zeros, the value will not be parsed by your library.
   *
   * @default `false`
   */
  shouldRespectLeadingZeros: l.bool,
  /**
   * The size of the component.
   */
  size: l.oneOf(["medium", "small"]),
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: l.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: l.object,
  style: l.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documention} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: l.string,
  /**
   * The ref object used to imperatively interact with the field.
   */
  unstableFieldRef: l.oneOfType([l.func, l.object]),
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: l.any,
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: l.oneOf(["filled", "outlined", "standard"])
});
const GWe = (e) => {
  var t, n, r, i;
  const o = Nn(), a = ((t = e.ampm) != null ? t : o.is12HourCycleInCurrentLocale()) ? o.formats.fullTime12h : o.formats.fullTime24h;
  return N({}, e, {
    disablePast: (n = e.disablePast) != null ? n : !1,
    disableFuture: (r = e.disableFuture) != null ? r : !1,
    format: (i = e.format) != null ? i : a
  });
}, YWe = ({
  props: e,
  inputRef: t
}) => {
  const n = GWe(e), {
    forwardedProps: r,
    internalProps: i
  } = QF(n, "time");
  return XF({
    inputRef: t,
    forwardedProps: r,
    internalProps: i,
    valueManager: qi,
    fieldValueManager: YF,
    validator: QE,
    valueType: "time"
  });
}, KWe = ["slots", "slotProps", "components", "componentsProps", "InputProps", "inputProps"], JWe = ["inputRef"], XWe = ["ref", "onPaste", "onKeyDown", "inputMode", "readOnly", "clearable", "onClear"], o$ = /* @__PURE__ */ V.forwardRef(function(t, n) {
  var r, i, o;
  const s = Vn({
    props: t,
    name: "MuiTimeField"
  }), {
    slots: a,
    slotProps: u,
    components: c,
    componentsProps: d,
    InputProps: f,
    inputProps: h
  } = s, m = _e(s, KWe), v = s, x = (r = (i = a == null ? void 0 : a.textField) != null ? i : c == null ? void 0 : c.TextField) != null ? r : vf, C = si({
    elementType: x,
    externalSlotProps: (o = u == null ? void 0 : u.textField) != null ? o : d == null ? void 0 : d.textField,
    externalForwardedProps: m,
    ownerState: v
  }), {
    inputRef: E
  } = C, S = _e(C, JWe);
  S.inputProps = N({}, h, S.inputProps), S.InputProps = N({}, f, S.InputProps);
  const w = YWe({
    props: S,
    inputRef: E
  }), {
    ref: O,
    onPaste: A,
    onKeyDown: I,
    inputMode: $,
    readOnly: L,
    clearable: B,
    onClear: H
  } = w, q = _e(w, XWe), {
    InputProps: J,
    fieldProps: X
  } = r$({
    onClear: H,
    clearable: B,
    fieldProps: q,
    InputProps: q.InputProps,
    slots: a,
    slotProps: u,
    components: c,
    componentsProps: d
  });
  return /* @__PURE__ */ P.jsx(x, N({
    ref: n
  }, X, {
    InputProps: N({}, J, {
      readOnly: L
    }),
    inputProps: N({}, q.inputProps, {
      inputMode: $,
      onPaste: A,
      onKeyDown: I,
      ref: O
    })
  }));
});
process.env.NODE_ENV !== "production" && (o$.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * 12h/24h view for hour selection clock.
   * @default `utils.is12HourCycleInCurrentLocale()`
   */
  ampm: l.bool,
  /**
   * If `true`, the `input` element is focused during the first mount.
   * @default false
   */
  autoFocus: l.bool,
  className: l.string,
  /**
   * If `true`, a clear button will be shown in the field allowing value clearing.
   * @default false
   */
  clearable: l.bool,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: l.oneOf(["error", "info", "primary", "secondary", "success", "warning"]),
  component: l.elementType,
  /**
   * Overridable components.
   * @default {}
   * @deprecated Please use `slots`.
   */
  components: l.object,
  /**
   * The props used for each component slot.
   * @default {}
   * @deprecated Please use `slotProps`.
   */
  componentsProps: l.object,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: l.any,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: l.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: l.bool,
  /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */
  disableIgnoringDatePartForTimeValidation: l.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: l.bool,
  /**
   * If `true`, the component is displayed in focused state.
   */
  focused: l.bool,
  /**
   * Format of the date when rendered in the input(s).
   */
  format: l.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: l.oneOf(["dense", "spacious"]),
  /**
   * Props applied to the [`FormHelperText`](/material-ui/api/form-helper-text/) element.
   */
  FormHelperTextProps: l.object,
  /**
   * If `true`, the input will take up the full width of its container.
   * @default false
   */
  fullWidth: l.bool,
  /**
   * The helper text content.
   */
  helperText: l.node,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: l.bool,
  /**
   * The id of the `input` element.
   * Use this prop to make `label` and `helperText` accessible for screen readers.
   */
  id: l.string,
  /**
   * Props applied to the [`InputLabel`](/material-ui/api/input-label/) element.
   * Pointer events like `onClick` are enabled if and only if `shrink` is `true`.
   */
  InputLabelProps: l.object,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: l.object,
  /**
   * Props applied to the Input element.
   * It will be a [`FilledInput`](/material-ui/api/filled-input/),
   * [`OutlinedInput`](/material-ui/api/outlined-input/) or [`Input`](/material-ui/api/input/)
   * component depending on the `variant` prop value.
   */
  InputProps: l.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: wr,
  /**
   * The label content.
   */
  label: l.node,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */
  margin: l.oneOf(["dense", "none", "normal"]),
  /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  maxTime: l.any,
  /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  minTime: l.any,
  /**
   * Step over minutes.
   * @default 1
   */
  minutesStep: l.number,
  /**
   * Name attribute of the `input` element.
   */
  name: l.string,
  onBlur: l.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: l.func,
  /**
   * Callback fired when the clear button is clicked.
   */
  onClear: l.func,
  /**
   * Callback fired when the error associated to the current value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error.
   * @param {TValue} value The value associated to the error.
   */
  onError: l.func,
  onFocus: l.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: l.func,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   * @default false
   */
  readOnly: l.bool,
  /**
   * The date used to generate a part of the new value that is not present in the format when both `value` and `defaultValue` are empty.
   * For example, on time fields it will be used to determine the date to set.
   * @default The closest valid date using the validation props, except callbacks such as `shouldDisableDate`. Value is rounded to the most granular section used.
   */
  referenceDate: l.any,
  /**
   * If `true`, the label is displayed as required and the `input` element is required.
   * @default false
   */
  required: l.bool,
  /**
   * The currently selected sections.
   * This prop accept four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If an object with a `startIndex` and `endIndex` properties are provided, the sections between those two indexes will be selected.
   * 3. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 4. If `null` is provided, no section will be selected
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: l.oneOfType([l.oneOf(["all", "day", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), l.number, l.shape({
    endIndex: l.number.isRequired,
    startIndex: l.number.isRequired
  })]),
  /**
   * Disable specific clock time.
   * @param {number} clockValue The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   * @deprecated Consider using `shouldDisableTime`.
   */
  shouldDisableClock: l.func,
  /**
   * Disable specific time.
   * @template TDate
   * @param {TDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */
  shouldDisableTime: l.func,
  /**
   * If `true`, the format will respect the leading zeroes (e.g: on dayjs, the format `M/D/YYYY` will render `8/16/2018`)
   * If `false`, the format will always add leading zeroes (e.g: on dayjs, the format `M/D/YYYY` will render `08/16/2018`)
   *
   * Warning n°1: Luxon is not able to respect the leading zeroes when using macro tokens (e.g: "DD"), so `shouldRespectLeadingZeros={true}` might lead to inconsistencies when using `AdapterLuxon`.
   *
   * Warning n°2: When `shouldRespectLeadingZeros={true}`, the field will add an invisible character on the sections containing a single digit to make sure `onChange` is fired.
   * If you need to get the clean value from the input, you can remove this character using `input.value.replace(/\u200e/g, '')`.
   *
   * Warning n°3: When used in strict mode, dayjs and moment require to respect the leading zeros.
   * This mean that when using `shouldRespectLeadingZeros={false}`, if you retrieve the value directly from the input (not listening to `onChange`) and your format contains tokens without leading zeros, the value will not be parsed by your library.
   *
   * @default `false`
   */
  shouldRespectLeadingZeros: l.bool,
  /**
   * The size of the component.
   */
  size: l.oneOf(["medium", "small"]),
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: l.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: l.object,
  style: l.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documention} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: l.string,
  /**
   * The ref object used to imperatively interact with the field.
   */
  unstableFieldRef: l.oneOfType([l.func, l.object]),
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: l.any,
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: l.oneOf(["filled", "outlined", "standard"])
});
const QWe = (e) => {
  var t, n, r, i, o, s, a, u;
  const c = Nn(), d = Df(), h = ((t = e.ampm) != null ? t : c.is12HourCycleInCurrentLocale()) ? c.formats.keyboardDateTime12h : c.formats.keyboardDateTime24h;
  return N({}, e, {
    disablePast: (n = e.disablePast) != null ? n : !1,
    disableFuture: (r = e.disableFuture) != null ? r : !1,
    format: (i = e.format) != null ? i : h,
    disableIgnoringDatePartForTimeValidation: !!(e.minDateTime || e.maxDateTime),
    minDate: Lo(c, (o = e.minDateTime) != null ? o : e.minDate, d.minDate),
    maxDate: Lo(c, (s = e.maxDateTime) != null ? s : e.maxDate, d.maxDate),
    minTime: (a = e.minDateTime) != null ? a : e.minTime,
    maxTime: (u = e.maxDateTime) != null ? u : e.maxTime
  });
}, ZWe = ({
  props: e,
  inputRef: t
}) => {
  const n = QWe(e), {
    forwardedProps: r,
    internalProps: i
  } = QF(n, "date-time");
  return XF({
    inputRef: t,
    forwardedProps: r,
    internalProps: i,
    valueManager: qi,
    fieldValueManager: YF,
    validator: n$,
    valueType: "date-time"
  });
}, eHe = ["components", "componentsProps", "slots", "slotProps", "InputProps", "inputProps"], tHe = ["inputRef"], nHe = ["ref", "onPaste", "onKeyDown", "inputMode", "readOnly", "clearable", "onClear"], s$ = /* @__PURE__ */ V.forwardRef(function(t, n) {
  var r, i, o;
  const s = Vn({
    props: t,
    name: "MuiDateTimeField"
  }), {
    components: a,
    componentsProps: u,
    slots: c,
    slotProps: d,
    InputProps: f,
    inputProps: h
  } = s, m = _e(s, eHe), v = s, x = (r = (i = c == null ? void 0 : c.textField) != null ? i : a == null ? void 0 : a.TextField) != null ? r : vf, C = si({
    elementType: x,
    externalSlotProps: (o = d == null ? void 0 : d.textField) != null ? o : u == null ? void 0 : u.textField,
    externalForwardedProps: m,
    ownerState: v
  }), {
    inputRef: E
  } = C, S = _e(C, tHe);
  S.inputProps = N({}, h, S.inputProps), S.InputProps = N({}, f, S.InputProps);
  const w = ZWe({
    props: S,
    inputRef: E
  }), {
    ref: O,
    onPaste: A,
    onKeyDown: I,
    inputMode: $,
    readOnly: L,
    clearable: B,
    onClear: H
  } = w, q = _e(w, nHe), {
    InputProps: J,
    fieldProps: X
  } = r$({
    onClear: H,
    clearable: B,
    fieldProps: q,
    InputProps: q.InputProps,
    slots: c,
    slotProps: d,
    components: a,
    componentsProps: u
  });
  return /* @__PURE__ */ P.jsx(x, N({
    ref: n
  }, X, {
    InputProps: N({}, J, {
      readOnly: L
    }),
    inputProps: N({}, q.inputProps, {
      inputMode: $,
      onPaste: A,
      onKeyDown: I,
      ref: O
    })
  }));
});
process.env.NODE_ENV !== "production" && (s$.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * 12h/24h view for hour selection clock.
   * @default `utils.is12HourCycleInCurrentLocale()`
   */
  ampm: l.bool,
  /**
   * If `true`, the `input` element is focused during the first mount.
   * @default false
   */
  autoFocus: l.bool,
  className: l.string,
  /**
   * If `true`, a clear button will be shown in the field allowing value clearing.
   * @default false
   */
  clearable: l.bool,
  /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */
  color: l.oneOf(["error", "info", "primary", "secondary", "success", "warning"]),
  component: l.elementType,
  /**
   * Overridable components.
   * @default {}
   * @deprecated Please use `slots`.
   */
  components: l.object,
  /**
   * The props used for each component slot.
   * @default {}
   * @deprecated Please use `slotProps`.
   */
  componentsProps: l.object,
  /**
   * The default value. Use when the component is not controlled.
   */
  defaultValue: l.any,
  /**
   * If `true`, the component is disabled.
   * @default false
   */
  disabled: l.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: l.bool,
  /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */
  disableIgnoringDatePartForTimeValidation: l.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: l.bool,
  /**
   * If `true`, the component is displayed in focused state.
   */
  focused: l.bool,
  /**
   * Format of the date when rendered in the input(s).
   */
  format: l.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: l.oneOf(["dense", "spacious"]),
  /**
   * Props applied to the [`FormHelperText`](/material-ui/api/form-helper-text/) element.
   */
  FormHelperTextProps: l.object,
  /**
   * If `true`, the input will take up the full width of its container.
   * @default false
   */
  fullWidth: l.bool,
  /**
   * The helper text content.
   */
  helperText: l.node,
  /**
   * If `true`, the label is hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   * @default false
   */
  hiddenLabel: l.bool,
  /**
   * The id of the `input` element.
   * Use this prop to make `label` and `helperText` accessible for screen readers.
   */
  id: l.string,
  /**
   * Props applied to the [`InputLabel`](/material-ui/api/input-label/) element.
   * Pointer events like `onClick` are enabled if and only if `shrink` is `true`.
   */
  InputLabelProps: l.object,
  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: l.object,
  /**
   * Props applied to the Input element.
   * It will be a [`FilledInput`](/material-ui/api/filled-input/),
   * [`OutlinedInput`](/material-ui/api/outlined-input/) or [`Input`](/material-ui/api/input/)
   * component depending on the `variant` prop value.
   */
  InputProps: l.object,
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: wr,
  /**
   * The label content.
   */
  label: l.node,
  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   * @default 'none'
   */
  margin: l.oneOf(["dense", "none", "normal"]),
  /**
   * Maximal selectable date.
   */
  maxDate: l.any,
  /**
   * Maximal selectable moment of time with binding to date, to set max time in each day use `maxTime`.
   */
  maxDateTime: l.any,
  /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  maxTime: l.any,
  /**
   * Minimal selectable date.
   */
  minDate: l.any,
  /**
   * Minimal selectable moment of time with binding to date, to set min time in each day use `minTime`.
   */
  minDateTime: l.any,
  /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  minTime: l.any,
  /**
   * Step over minutes.
   * @default 1
   */
  minutesStep: l.number,
  /**
   * Name attribute of the `input` element.
   */
  name: l.string,
  onBlur: l.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: l.func,
  /**
   * Callback fired when the clear button is clicked.
   */
  onClear: l.func,
  /**
   * Callback fired when the error associated to the current value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error.
   * @param {TValue} value The value associated to the error.
   */
  onError: l.func,
  onFocus: l.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: l.func,
  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   * @default false
   */
  readOnly: l.bool,
  /**
   * The date used to generate a part of the new value that is not present in the format when both `value` and `defaultValue` are empty.
   * For example, on time fields it will be used to determine the date to set.
   * @default The closest valid date using the validation props, except callbacks such as `shouldDisableDate`. Value is rounded to the most granular section used.
   */
  referenceDate: l.any,
  /**
   * If `true`, the label is displayed as required and the `input` element is required.
   * @default false
   */
  required: l.bool,
  /**
   * The currently selected sections.
   * This prop accept four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If an object with a `startIndex` and `endIndex` properties are provided, the sections between those two indexes will be selected.
   * 3. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 4. If `null` is provided, no section will be selected
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: l.oneOfType([l.oneOf(["all", "day", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), l.number, l.shape({
    endIndex: l.number.isRequired,
    startIndex: l.number.isRequired
  })]),
  /**
   * Disable specific clock time.
   * @param {number} clockValue The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   * @deprecated Consider using `shouldDisableTime`.
   */
  shouldDisableClock: l.func,
  /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (e.g. when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */
  shouldDisableDate: l.func,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: l.func,
  /**
   * Disable specific time.
   * @template TDate
   * @param {TDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */
  shouldDisableTime: l.func,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: l.func,
  /**
   * If `true`, the format will respect the leading zeroes (e.g: on dayjs, the format `M/D/YYYY` will render `8/16/2018`)
   * If `false`, the format will always add leading zeroes (e.g: on dayjs, the format `M/D/YYYY` will render `08/16/2018`)
   *
   * Warning n°1: Luxon is not able to respect the leading zeroes when using macro tokens (e.g: "DD"), so `shouldRespectLeadingZeros={true}` might lead to inconsistencies when using `AdapterLuxon`.
   *
   * Warning n°2: When `shouldRespectLeadingZeros={true}`, the field will add an invisible character on the sections containing a single digit to make sure `onChange` is fired.
   * If you need to get the clean value from the input, you can remove this character using `input.value.replace(/\u200e/g, '')`.
   *
   * Warning n°3: When used in strict mode, dayjs and moment require to respect the leading zeros.
   * This mean that when using `shouldRespectLeadingZeros={false}`, if you retrieve the value directly from the input (not listening to `onChange`) and your format contains tokens without leading zeros, the value will not be parsed by your library.
   *
   * @default `false`
   */
  shouldRespectLeadingZeros: l.bool,
  /**
   * The size of the component.
   */
  size: l.oneOf(["medium", "small"]),
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: l.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: l.object,
  style: l.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documention} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: l.string,
  /**
   * The ref object used to imperatively interact with the field.
   */
  unstableFieldRef: l.oneOfType([l.func, l.object]),
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: l.any,
  /**
   * The variant to use.
   * @default 'outlined'
   */
  variant: l.oneOf(["filled", "outlined", "standard"])
});
const rHe = (e) => ot("MuiPickersFadeTransitionGroup", e);
st("MuiPickersFadeTransitionGroup", ["root"]);
const iHe = (e) => {
  const {
    classes: t
  } = e;
  return at({
    root: ["root"]
  }, rHe, t);
}, oHe = De(Gb, {
  name: "MuiPickersFadeTransitionGroup",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "block",
  position: "relative"
});
function YW(e) {
  const t = Vn({
    props: e,
    name: "MuiPickersFadeTransitionGroup"
  }), {
    children: n,
    className: r,
    reduceAnimations: i,
    transKey: o
  } = t, s = iHe(t), a = Gi();
  return i ? n : /* @__PURE__ */ P.jsx(oHe, {
    className: Be(s.root, r),
    children: /* @__PURE__ */ P.jsx(ff, {
      appear: !1,
      mountOnEnter: !0,
      unmountOnExit: !0,
      timeout: {
        appear: a.transitions.duration.enteringScreen,
        enter: a.transitions.duration.enteringScreen,
        exit: 0
      },
      children: n
    }, o)
  });
}
function sHe(e) {
  return ot("MuiPickersMonth", e);
}
const Q1 = st("MuiPickersMonth", ["root", "monthButton", "disabled", "selected"]), aHe = ["autoFocus", "children", "disabled", "selected", "value", "tabIndex", "onClick", "onKeyDown", "onFocus", "onBlur", "aria-current", "aria-label", "monthsPerRow"], lHe = (e) => {
  const {
    disabled: t,
    selected: n,
    classes: r
  } = e;
  return at({
    root: ["root"],
    monthButton: ["monthButton", t && "disabled", n && "selected"]
  }, sHe, r);
}, uHe = De("div", {
  name: "MuiPickersMonth",
  slot: "Root",
  overridesResolver: (e, t) => [t.root]
})(({
  ownerState: e
}) => ({
  flexBasis: e.monthsPerRow === 3 ? "33.3%" : "25%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center"
})), cHe = De("button", {
  name: "MuiPickersMonth",
  slot: "MonthButton",
  overridesResolver: (e, t) => [t.monthButton, {
    [`&.${Q1.disabled}`]: t.disabled
  }, {
    [`&.${Q1.selected}`]: t.selected
  }]
})(({
  theme: e
}) => N({
  color: "unset",
  backgroundColor: "transparent",
  border: 0,
  outline: 0
}, e.typography.subtitle1, {
  margin: "8px 0",
  height: 36,
  width: 72,
  borderRadius: 18,
  cursor: "pointer",
  "&:focus": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.hoverOpacity})` : yu(e.palette.action.active, e.palette.action.hoverOpacity)
  },
  "&:hover": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.hoverOpacity})` : yu(e.palette.action.active, e.palette.action.hoverOpacity)
  },
  "&:disabled": {
    cursor: "auto",
    pointerEvents: "none"
  },
  [`&.${Q1.disabled}`]: {
    color: (e.vars || e).palette.text.secondary
  },
  [`&.${Q1.selected}`]: {
    color: (e.vars || e).palette.primary.contrastText,
    backgroundColor: (e.vars || e).palette.primary.main,
    "&:focus, &:hover": {
      backgroundColor: (e.vars || e).palette.primary.dark
    }
  }
})), dHe = /* @__PURE__ */ V.memo(function(t) {
  const n = Vn({
    props: t,
    name: "MuiPickersMonth"
  }), {
    autoFocus: r,
    children: i,
    disabled: o,
    selected: s,
    value: a,
    tabIndex: u,
    onClick: c,
    onKeyDown: d,
    onFocus: f,
    onBlur: h,
    "aria-current": m,
    "aria-label": v
    // We don't want to forward this prop to the root element
  } = n, x = _e(n, aHe), C = V.useRef(null), E = lHe(n);
  return gi(() => {
    if (r) {
      var S;
      (S = C.current) == null || S.focus();
    }
  }, [r]), /* @__PURE__ */ P.jsx(uHe, N({
    className: E.root,
    ownerState: n
  }, x, {
    children: /* @__PURE__ */ P.jsx(cHe, {
      ref: C,
      disabled: o,
      type: "button",
      role: "radio",
      tabIndex: o ? -1 : u,
      "aria-current": m,
      "aria-checked": s,
      "aria-label": v,
      onClick: (S) => c(S, a),
      onKeyDown: (S) => d(S, a),
      onFocus: (S) => f(S, a),
      onBlur: (S) => h(S, a),
      className: E.monthButton,
      ownerState: n,
      children: i
    })
  }));
});
function pHe(e) {
  return ot("MuiMonthCalendar", e);
}
st("MuiMonthCalendar", ["root"]);
const fHe = ["className", "value", "defaultValue", "referenceDate", "disabled", "disableFuture", "disablePast", "maxDate", "minDate", "onChange", "shouldDisableMonth", "readOnly", "disableHighlightToday", "autoFocus", "onMonthFocus", "hasFocus", "onFocusedViewChange", "monthsPerRow", "timezone", "gridLabelId"], hHe = (e) => {
  const {
    classes: t
  } = e;
  return at({
    root: ["root"]
  }, pHe, t);
};
function mHe(e, t) {
  const n = Nn(), r = Df(), i = Vn({
    props: e,
    name: t
  });
  return N({
    disableFuture: !1,
    disablePast: !1
  }, i, {
    minDate: Lo(n, i.minDate, r.minDate),
    maxDate: Lo(n, i.maxDate, r.maxDate)
  });
}
const gHe = De("div", {
  name: "MuiMonthCalendar",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "flex",
  flexWrap: "wrap",
  alignContent: "stretch",
  padding: "0 4px",
  width: YE,
  // avoid padding increasing width over defined
  boxSizing: "border-box"
}), KW = /* @__PURE__ */ V.forwardRef(function(t, n) {
  const r = mHe(t, "MuiMonthCalendar"), {
    className: i,
    value: o,
    defaultValue: s,
    referenceDate: a,
    disabled: u,
    disableFuture: c,
    disablePast: d,
    maxDate: f,
    minDate: h,
    onChange: m,
    shouldDisableMonth: v,
    readOnly: x,
    disableHighlightToday: C,
    autoFocus: E = !1,
    onMonthFocus: S,
    hasFocus: w,
    onFocusedViewChange: O,
    monthsPerRow: A = 3,
    timezone: I,
    gridLabelId: $
  } = r, L = _e(r, fHe), {
    value: B,
    handleValueChange: H,
    timezone: q
  } = hg({
    name: "MonthCalendar",
    timezone: I,
    value: o,
    defaultValue: s,
    onChange: m,
    valueManager: qi
  }), J = Cf(q), X = rg(), j = Nn(), U = V.useMemo(
    () => qi.getInitialReferenceValue({
      value: B,
      utils: j,
      props: r,
      timezone: q,
      referenceDate: a,
      granularity: pl.month
    }),
    []
    // eslint-disable-line react-hooks/exhaustive-deps
  ), G = r, K = hHe(G), ee = V.useMemo(() => j.getMonth(J), [j, J]), te = V.useMemo(() => B != null ? j.getMonth(B) : C ? null : j.getMonth(U), [B, j, C, U]), [M, Z] = V.useState(() => te || ee), [ne, R] = Hi({
    name: "MonthCalendar",
    state: "hasFocus",
    controlled: w,
    default: E ?? !1
  }), _ = Mt((xe) => {
    R(xe), O && O(xe);
  }), W = V.useCallback((xe) => {
    const le = j.startOfMonth(d && j.isAfter(J, h) ? J : h), ye = j.startOfMonth(c && j.isBefore(J, f) ? J : f), be = j.startOfMonth(xe);
    return j.isBefore(be, le) || j.isAfter(be, ye) ? !0 : v ? v(be) : !1;
  }, [c, d, f, h, J, v, j]), Q = Mt((xe, le) => {
    if (x)
      return;
    const ye = j.setMonth(B ?? U, le);
    H(ye);
  }), oe = Mt((xe) => {
    W(j.setMonth(B ?? U, xe)) || (Z(xe), _(!0), S && S(xe));
  });
  V.useEffect(() => {
    Z((xe) => te !== null && xe !== te ? te : xe);
  }, [te]);
  const ae = Mt((xe, le) => {
    switch (xe.key) {
      case "ArrowUp":
        oe((12 + le - 3) % 12), xe.preventDefault();
        break;
      case "ArrowDown":
        oe((12 + le + 3) % 12), xe.preventDefault();
        break;
      case "ArrowLeft":
        oe((12 + le + (X.direction === "ltr" ? -1 : 1)) % 12), xe.preventDefault();
        break;
      case "ArrowRight":
        oe((12 + le + (X.direction === "ltr" ? 1 : -1)) % 12), xe.preventDefault();
        break;
    }
  }), pe = Mt((xe, le) => {
    oe(le);
  }), me = Mt((xe, le) => {
    M === le && _(!1);
  });
  return /* @__PURE__ */ P.jsx(gHe, N({
    ref: n,
    className: Be(K.root, i),
    ownerState: G,
    role: "radiogroup",
    "aria-labelledby": $
  }, L, {
    children: UF(j, B ?? U).map((xe) => {
      const le = j.getMonth(xe), ye = j.format(xe, "monthShort"), be = j.format(xe, "month"), Re = le === te, Te = u || W(xe);
      return /* @__PURE__ */ P.jsx(dHe, {
        selected: Re,
        value: le,
        onClick: Q,
        onKeyDown: ae,
        autoFocus: ne && le === M,
        disabled: Te,
        tabIndex: le === M ? 0 : -1,
        onFocus: pe,
        onBlur: me,
        "aria-current": ee === le ? "date" : void 0,
        "aria-label": be,
        monthsPerRow: A,
        children: ye
      }, ye);
    })
  }));
});
process.env.NODE_ENV !== "production" && (KW.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  autoFocus: l.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * className applied to the root element.
   */
  className: l.string,
  /**
   * The default selected value.
   * Used when the component is not controlled.
   */
  defaultValue: l.any,
  /**
   * If `true` picker is disabled
   */
  disabled: l.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: l.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: l.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: l.bool,
  gridLabelId: l.string,
  hasFocus: l.bool,
  /**
   * Maximal selectable date.
   */
  maxDate: l.any,
  /**
   * Minimal selectable date.
   */
  minDate: l.any,
  /**
   * Months rendered per row.
   * @default 3
   */
  monthsPerRow: l.oneOf([3, 4]),
  /**
   * Callback fired when the value changes.
   * @template TDate
   * @param {TDate} value The new value.
   */
  onChange: l.func,
  onFocusedViewChange: l.func,
  onMonthFocus: l.func,
  /**
   * If `true` picker is readonly
   */
  readOnly: l.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid month using the validation props, except callbacks such as `shouldDisableMonth`.
   */
  referenceDate: l.any,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: l.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documention} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: l.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: l.any
});
function yHe(e) {
  return ot("MuiPickersYear", e);
}
const Z1 = st("MuiPickersYear", ["root", "yearButton", "selected", "disabled"]), bHe = ["autoFocus", "className", "children", "disabled", "selected", "value", "tabIndex", "onClick", "onKeyDown", "onFocus", "onBlur", "aria-current", "yearsPerRow"], vHe = (e) => {
  const {
    disabled: t,
    selected: n,
    classes: r
  } = e;
  return at({
    root: ["root"],
    yearButton: ["yearButton", t && "disabled", n && "selected"]
  }, yHe, r);
}, xHe = De("div", {
  name: "MuiPickersYear",
  slot: "Root",
  overridesResolver: (e, t) => [t.root]
})(({
  ownerState: e
}) => ({
  flexBasis: e.yearsPerRow === 3 ? "33.3%" : "25%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center"
})), DHe = De("button", {
  name: "MuiPickersYear",
  slot: "YearButton",
  overridesResolver: (e, t) => [t.yearButton, {
    [`&.${Z1.disabled}`]: t.disabled
  }, {
    [`&.${Z1.selected}`]: t.selected
  }]
})(({
  theme: e
}) => N({
  color: "unset",
  backgroundColor: "transparent",
  border: 0,
  outline: 0
}, e.typography.subtitle1, {
  margin: "6px 0",
  height: 36,
  width: 72,
  borderRadius: 18,
  cursor: "pointer",
  "&:focus": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.focusOpacity})` : yu(e.palette.action.active, e.palette.action.focusOpacity)
  },
  "&:hover": {
    backgroundColor: e.vars ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.hoverOpacity})` : yu(e.palette.action.active, e.palette.action.hoverOpacity)
  },
  "&:disabled": {
    cursor: "auto",
    pointerEvents: "none"
  },
  [`&.${Z1.disabled}`]: {
    color: (e.vars || e).palette.text.secondary
  },
  [`&.${Z1.selected}`]: {
    color: (e.vars || e).palette.primary.contrastText,
    backgroundColor: (e.vars || e).palette.primary.main,
    "&:focus, &:hover": {
      backgroundColor: (e.vars || e).palette.primary.dark
    }
  }
})), CHe = /* @__PURE__ */ V.memo(function(t) {
  const n = Vn({
    props: t,
    name: "MuiPickersYear"
  }), {
    autoFocus: r,
    className: i,
    children: o,
    disabled: s,
    selected: a,
    value: u,
    tabIndex: c,
    onClick: d,
    onKeyDown: f,
    onFocus: h,
    onBlur: m,
    "aria-current": v
    // We don't want to forward this prop to the root element
  } = n, x = _e(n, bHe), C = V.useRef(null), E = vHe(n);
  return V.useEffect(() => {
    r && C.current.focus();
  }, [r]), /* @__PURE__ */ P.jsx(xHe, N({
    className: Be(E.root, i),
    ownerState: n
  }, x, {
    children: /* @__PURE__ */ P.jsx(DHe, {
      ref: C,
      disabled: s,
      type: "button",
      role: "radio",
      tabIndex: s ? -1 : c,
      "aria-current": v,
      "aria-checked": a,
      onClick: (S) => d(S, u),
      onKeyDown: (S) => f(S, u),
      onFocus: (S) => h(S, u),
      onBlur: (S) => m(S, u),
      className: E.yearButton,
      ownerState: n,
      children: o
    })
  }));
});
function EHe(e) {
  return ot("MuiYearCalendar", e);
}
st("MuiYearCalendar", ["root"]);
const THe = ["autoFocus", "className", "value", "defaultValue", "referenceDate", "disabled", "disableFuture", "disablePast", "maxDate", "minDate", "onChange", "readOnly", "shouldDisableYear", "disableHighlightToday", "onYearFocus", "hasFocus", "onFocusedViewChange", "yearsPerRow", "timezone", "gridLabelId"], SHe = (e) => {
  const {
    classes: t
  } = e;
  return at({
    root: ["root"]
  }, EHe, t);
};
function AHe(e, t) {
  var n;
  const r = Nn(), i = Df(), o = Vn({
    props: e,
    name: t
  });
  return N({
    disablePast: !1,
    disableFuture: !1
  }, o, {
    yearsPerRow: (n = o.yearsPerRow) != null ? n : 3,
    minDate: Lo(r, o.minDate, i.minDate),
    maxDate: Lo(r, o.maxDate, i.maxDate)
  });
}
const wHe = De("div", {
  name: "MuiYearCalendar",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  overflowY: "auto",
  height: "100%",
  padding: "0 4px",
  width: YE,
  maxHeight: rze,
  // avoid padding increasing width over defined
  boxSizing: "border-box",
  position: "relative"
}), JW = /* @__PURE__ */ V.forwardRef(function(t, n) {
  const r = AHe(t, "MuiYearCalendar"), {
    autoFocus: i,
    className: o,
    value: s,
    defaultValue: a,
    referenceDate: u,
    disabled: c,
    disableFuture: d,
    disablePast: f,
    maxDate: h,
    minDate: m,
    onChange: v,
    readOnly: x,
    shouldDisableYear: C,
    disableHighlightToday: E,
    onYearFocus: S,
    hasFocus: w,
    onFocusedViewChange: O,
    yearsPerRow: A,
    timezone: I,
    gridLabelId: $
  } = r, L = _e(r, THe), {
    value: B,
    handleValueChange: H,
    timezone: q
  } = hg({
    name: "YearCalendar",
    timezone: I,
    value: s,
    defaultValue: a,
    onChange: v,
    valueManager: qi
  }), J = Cf(q), X = rg(), j = Nn(), U = V.useMemo(
    () => qi.getInitialReferenceValue({
      value: B,
      utils: j,
      props: r,
      timezone: q,
      referenceDate: u,
      granularity: pl.year
    }),
    []
    // eslint-disable-line react-hooks/exhaustive-deps
  ), G = r, K = SHe(G), ee = V.useMemo(() => j.getYear(J), [j, J]), te = V.useMemo(() => B != null ? j.getYear(B) : E ? null : j.getYear(U), [B, j, E, U]), [M, Z] = V.useState(() => te || ee), [ne, R] = Hi({
    name: "YearCalendar",
    state: "hasFocus",
    controlled: w,
    default: i ?? !1
  }), _ = Mt((ye) => {
    R(ye), O && O(ye);
  }), W = V.useCallback((ye) => {
    if (f && j.isBeforeYear(ye, J) || d && j.isAfterYear(ye, J) || m && j.isBeforeYear(ye, m) || h && j.isAfterYear(ye, h))
      return !0;
    if (!C)
      return !1;
    const be = j.startOfYear(ye);
    return C(be);
  }, [d, f, h, m, J, C, j]), Q = Mt((ye, be) => {
    if (x)
      return;
    const Re = j.setYear(B ?? U, be);
    H(Re);
  }), oe = Mt((ye) => {
    W(j.setYear(B ?? U, ye)) || (Z(ye), _(!0), S == null || S(ye));
  });
  V.useEffect(() => {
    Z((ye) => te !== null && ye !== te ? te : ye);
  }, [te]);
  const ae = Mt((ye, be) => {
    switch (ye.key) {
      case "ArrowUp":
        oe(be - A), ye.preventDefault();
        break;
      case "ArrowDown":
        oe(be + A), ye.preventDefault();
        break;
      case "ArrowLeft":
        oe(be + (X.direction === "ltr" ? -1 : 1)), ye.preventDefault();
        break;
      case "ArrowRight":
        oe(be + (X.direction === "ltr" ? 1 : -1)), ye.preventDefault();
        break;
    }
  }), pe = Mt((ye, be) => {
    oe(be);
  }), me = Mt((ye, be) => {
    M === be && _(!1);
  }), xe = V.useRef(null), le = Hn(n, xe);
  return V.useEffect(() => {
    if (i || xe.current === null)
      return;
    const ye = xe.current.querySelector('[tabindex="0"]');
    if (!ye)
      return;
    const be = ye.offsetHeight, Re = ye.offsetTop, Te = xe.current.clientHeight, Xe = xe.current.scrollTop, Ne = Re + be;
    be > Te || Re < Xe || (xe.current.scrollTop = Ne - Te / 2 - be / 2);
  }, [i]), /* @__PURE__ */ P.jsx(wHe, N({
    ref: le,
    className: Be(K.root, o),
    ownerState: G,
    role: "radiogroup",
    "aria-labelledby": $
  }, L, {
    children: j.getYearRange(m, h).map((ye) => {
      const be = j.getYear(ye), Re = be === te, Te = c || W(ye);
      return /* @__PURE__ */ P.jsx(CHe, {
        selected: Re,
        value: be,
        onClick: Q,
        onKeyDown: ae,
        autoFocus: ne && be === M,
        disabled: Te,
        tabIndex: be === M ? 0 : -1,
        onFocus: pe,
        onBlur: me,
        "aria-current": ee === be ? "date" : void 0,
        yearsPerRow: A,
        children: j.format(ye, "year")
      }, j.format(ye, "year"));
    })
  }));
});
process.env.NODE_ENV !== "production" && (JW.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  autoFocus: l.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * className applied to the root element.
   */
  className: l.string,
  /**
   * The default selected value.
   * Used when the component is not controlled.
   */
  defaultValue: l.any,
  /**
   * If `true` picker is disabled
   */
  disabled: l.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: l.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: l.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: l.bool,
  gridLabelId: l.string,
  hasFocus: l.bool,
  /**
   * Maximal selectable date.
   */
  maxDate: l.any,
  /**
   * Minimal selectable date.
   */
  minDate: l.any,
  /**
   * Callback fired when the value changes.
   * @template TDate
   * @param {TDate} value The new value.
   */
  onChange: l.func,
  onFocusedViewChange: l.func,
  onYearFocus: l.func,
  /**
   * If `true` picker is readonly
   */
  readOnly: l.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid year using the validation props, except callbacks such as `shouldDisableYear`.
   */
  referenceDate: l.any,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: l.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documention} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: l.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: l.any,
  /**
   * Years rendered per row.
   * @default 3
   */
  yearsPerRow: l.oneOf([3, 4])
});
const PHe = (e) => ot("MuiPickersCalendarHeader", e), kHe = st("MuiPickersCalendarHeader", ["root", "labelContainer", "label", "switchViewButton", "switchViewIcon"]), OHe = ["slots", "slotProps", "components", "componentsProps", "currentMonth", "disabled", "disableFuture", "disablePast", "maxDate", "minDate", "onMonthChange", "onViewChange", "view", "reduceAnimations", "views", "labelId", "className", "timezone"], IHe = ["ownerState"], FHe = (e) => {
  const {
    classes: t
  } = e;
  return at({
    root: ["root"],
    labelContainer: ["labelContainer"],
    label: ["label"],
    switchViewButton: ["switchViewButton"],
    switchViewIcon: ["switchViewIcon"]
  }, PHe, t);
}, $He = De("div", {
  name: "MuiPickersCalendarHeader",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "flex",
  alignItems: "center",
  marginTop: 16,
  marginBottom: 8,
  paddingLeft: 24,
  paddingRight: 12,
  // prevent jumping in safari
  maxHeight: 30,
  minHeight: 30
}), NHe = De("div", {
  name: "MuiPickersCalendarHeader",
  slot: "LabelContainer",
  overridesResolver: (e, t) => t.labelContainer
})(({
  theme: e
}) => N({
  display: "flex",
  overflow: "hidden",
  alignItems: "center",
  cursor: "pointer",
  marginRight: "auto"
}, e.typography.body1, {
  fontWeight: e.typography.fontWeightMedium
})), MHe = De("div", {
  name: "MuiPickersCalendarHeader",
  slot: "Label",
  overridesResolver: (e, t) => t.label
})({
  marginRight: 6
}), RHe = De(Or, {
  name: "MuiPickersCalendarHeader",
  slot: "SwitchViewButton",
  overridesResolver: (e, t) => t.switchViewButton
})(({
  ownerState: e
}) => N({
  marginRight: "auto"
}, e.view === "year" && {
  [`.${kHe.switchViewIcon}`]: {
    transform: "rotate(180deg)"
  }
})), _He = De(BVe, {
  name: "MuiPickersCalendarHeader",
  slot: "SwitchViewIcon",
  overridesResolver: (e, t) => t.switchViewIcon
})(({
  theme: e
}) => ({
  willChange: "transform",
  transition: e.transitions.create("transform"),
  transform: "rotate(0deg)"
})), XW = /* @__PURE__ */ V.forwardRef(function(t, n) {
  var r, i, o, s;
  const a = Yi(), u = Nn(), c = Vn({
    props: t,
    name: "MuiPickersCalendarHeader"
  }), {
    slots: d,
    slotProps: f,
    components: h,
    currentMonth: m,
    disabled: v,
    disableFuture: x,
    disablePast: C,
    maxDate: E,
    minDate: S,
    onMonthChange: w,
    onViewChange: O,
    view: A,
    reduceAnimations: I,
    views: $,
    labelId: L,
    className: B,
    timezone: H
  } = c, q = _e(c, OHe), J = c, X = FHe(c), j = (r = (i = d == null ? void 0 : d.switchViewButton) != null ? i : h == null ? void 0 : h.SwitchViewButton) != null ? r : RHe, U = si({
    elementType: j,
    externalSlotProps: f == null ? void 0 : f.switchViewButton,
    additionalProps: {
      size: "small",
      "aria-label": a.calendarViewSwitchingButtonAriaLabel(A)
    },
    ownerState: J,
    className: X.switchViewButton
  }), G = (o = (s = d == null ? void 0 : d.switchViewIcon) != null ? s : h == null ? void 0 : h.SwitchViewIcon) != null ? o : _He, K = si({
    elementType: G,
    externalSlotProps: f == null ? void 0 : f.switchViewIcon,
    ownerState: void 0,
    className: X.switchViewIcon
  }), ee = _e(K, IHe), te = () => w(u.addMonths(m, 1), "left"), M = () => w(u.addMonths(m, -1), "right"), Z = tze(m, {
    disableFuture: x,
    maxDate: E,
    timezone: H
  }), ne = nze(m, {
    disablePast: C,
    minDate: S,
    timezone: H
  }), R = () => {
    if (!($.length === 1 || !O || v))
      if ($.length === 2)
        O($.find((_) => _ !== A) || $[0]);
      else {
        const _ = $.indexOf(A) !== 0 ? 0 : 1;
        O($[_]);
      }
  };
  return $.length === 1 && $[0] === "year" ? null : /* @__PURE__ */ P.jsxs($He, N({}, q, {
    ownerState: J,
    className: Be(B, X.root),
    ref: n,
    children: [/* @__PURE__ */ P.jsxs(NHe, {
      role: "presentation",
      onClick: R,
      ownerState: J,
      "aria-live": "polite",
      className: X.labelContainer,
      children: [/* @__PURE__ */ P.jsx(YW, {
        reduceAnimations: I,
        transKey: u.format(m, "monthAndYear"),
        children: /* @__PURE__ */ P.jsx(MHe, {
          id: L,
          ownerState: J,
          className: X.label,
          children: u.format(m, "monthAndYear")
        })
      }), $.length > 1 && !v && /* @__PURE__ */ P.jsx(j, N({}, U, {
        children: /* @__PURE__ */ P.jsx(G, N({}, ee))
      }))]
    }), /* @__PURE__ */ P.jsx(ff, {
      in: A === "day",
      children: /* @__PURE__ */ P.jsx(bW, {
        slots: d,
        slotProps: f,
        onGoToPrevious: M,
        isPreviousDisabled: ne,
        previousLabel: a.previousMonth,
        onGoToNext: te,
        isNextDisabled: Z,
        nextLabel: a.nextMonth
      })
    })]
  }));
});
process.env.NODE_ENV !== "production" && (XW.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * className applied to the root element.
   */
  className: l.string,
  /**
   * Overridable components.
   * @default {}
   * @deprecated Please use `slots`.
   */
  components: l.object,
  /**
   * The props used for each component slot.
   * @default {}
   * @deprecated Please use `slotProps`.
   */
  componentsProps: l.object,
  currentMonth: l.any.isRequired,
  disabled: l.bool,
  disableFuture: l.bool,
  disablePast: l.bool,
  labelId: l.string,
  maxDate: l.any.isRequired,
  minDate: l.any.isRequired,
  onMonthChange: l.func.isRequired,
  onViewChange: l.func,
  reduceAnimations: l.bool.isRequired,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: l.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: l.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  timezone: l.string.isRequired,
  view: l.oneOf(["day", "month", "year"]).isRequired,
  views: l.arrayOf(l.oneOf(["day", "month", "year"]).isRequired).isRequired
});
const LHe = (e) => ot("MuiDateCalendar", e);
st("MuiDateCalendar", ["root", "viewTransitionContainer"]);
const BHe = ["autoFocus", "onViewChange", "value", "defaultValue", "referenceDate", "disableFuture", "disablePast", "defaultCalendarMonth", "onChange", "onYearChange", "onMonthChange", "reduceAnimations", "shouldDisableDate", "shouldDisableMonth", "shouldDisableYear", "view", "views", "openTo", "className", "disabled", "readOnly", "minDate", "maxDate", "disableHighlightToday", "focusedView", "onFocusedViewChange", "showDaysOutsideCurrentMonth", "fixedWeekNumber", "dayOfWeekFormatter", "components", "componentsProps", "slots", "slotProps", "loading", "renderLoading", "displayWeekNumber", "yearsPerRow", "monthsPerRow", "timezone"], jHe = (e) => {
  const {
    classes: t
  } = e;
  return at({
    root: ["root"],
    viewTransitionContainer: ["viewTransitionContainer"]
  }, LHe, t);
};
function VHe(e, t) {
  var n, r, i, o, s, a, u;
  const c = Nn(), d = Df(), f = LW(), h = Vn({
    props: e,
    name: t
  });
  return N({}, h, {
    loading: (n = h.loading) != null ? n : !1,
    disablePast: (r = h.disablePast) != null ? r : !1,
    disableFuture: (i = h.disableFuture) != null ? i : !1,
    openTo: (o = h.openTo) != null ? o : "day",
    views: (s = h.views) != null ? s : ["year", "day"],
    reduceAnimations: (a = h.reduceAnimations) != null ? a : f,
    renderLoading: (u = h.renderLoading) != null ? u : () => /* @__PURE__ */ P.jsx("span", {
      children: "..."
    }),
    minDate: Lo(c, h.minDate, d.minDate),
    maxDate: Lo(c, h.maxDate, d.maxDate)
  });
}
const zHe = De(JE, {
  name: "MuiDateCalendar",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  display: "flex",
  flexDirection: "column",
  height: KE
}), UHe = De(YW, {
  name: "MuiDateCalendar",
  slot: "ViewTransitionContainer",
  overridesResolver: (e, t) => t.viewTransitionContainer
})({}), a$ = /* @__PURE__ */ V.forwardRef(function(t, n) {
  var r, i, o;
  const s = Nn(), a = Pl(), u = VHe(t, "MuiDateCalendar"), {
    autoFocus: c,
    onViewChange: d,
    value: f,
    defaultValue: h,
    referenceDate: m,
    disableFuture: v,
    disablePast: x,
    defaultCalendarMonth: C,
    onChange: E,
    onYearChange: S,
    onMonthChange: w,
    reduceAnimations: O,
    shouldDisableDate: A,
    shouldDisableMonth: I,
    shouldDisableYear: $,
    view: L,
    views: B,
    openTo: H,
    className: q,
    disabled: J,
    readOnly: X,
    minDate: j,
    maxDate: U,
    disableHighlightToday: G,
    focusedView: K,
    onFocusedViewChange: ee,
    showDaysOutsideCurrentMonth: te,
    fixedWeekNumber: M,
    dayOfWeekFormatter: Z,
    components: ne,
    componentsProps: R,
    slots: _,
    slotProps: W,
    loading: Q,
    renderLoading: oe,
    displayWeekNumber: ae,
    yearsPerRow: pe,
    monthsPerRow: me,
    timezone: xe
  } = u, le = _e(u, BHe), {
    value: ye,
    handleValueChange: be,
    timezone: Re
  } = hg({
    name: "DateCalendar",
    timezone: xe,
    value: f,
    defaultValue: h,
    onChange: E,
    valueManager: qi
  }), {
    view: Te,
    setView: Xe,
    focusedView: Ne,
    setFocusedView: Qe,
    goToNextView: Ee,
    setValueAndGoToNextView: Ie
  } = uv({
    view: L,
    views: B,
    openTo: H,
    onChange: be,
    onViewChange: d,
    autoFocus: c,
    focusedView: K,
    onFocusedViewChange: ee
  }), {
    referenceDate: Je,
    calendarState: vt,
    changeFocusedDay: St,
    changeMonth: Lt,
    handleChangeMonth: ke,
    isDateDisabled: Le,
    onMonthSwitchingAnimationEnd: Pe
  } = zWe({
    value: ye,
    defaultCalendarMonth: C,
    referenceDate: m,
    reduceAnimations: O,
    onMonthChange: w,
    minDate: j,
    maxDate: U,
    shouldDisableDate: A,
    disablePast: x,
    disableFuture: v,
    timezone: Re
  }), Ae = J && ye || j, We = J && ye || U, At = `${a}-grid-label`, Ft = Ne !== null, Ct = (r = (i = _ == null ? void 0 : _.calendarHeader) != null ? i : ne == null ? void 0 : ne.CalendarHeader) != null ? r : XW, ht = si({
    elementType: Ct,
    externalSlotProps: (o = W == null ? void 0 : W.calendarHeader) != null ? o : R == null ? void 0 : R.calendarHeader,
    additionalProps: {
      views: B,
      view: Te,
      currentMonth: vt.currentMonth,
      onViewChange: Xe,
      onMonthChange: (pn, Pr) => ke({
        newMonth: pn,
        direction: Pr
      }),
      minDate: Ae,
      maxDate: We,
      disabled: J,
      disablePast: x,
      disableFuture: v,
      reduceAnimations: O,
      timezone: Re,
      labelId: At,
      slots: _,
      slotProps: W
    },
    ownerState: u
  }), He = Mt((pn) => {
    const Pr = s.startOfMonth(pn), bi = s.endOfMonth(pn), Wr = Le(pn) ? f0({
      utils: s,
      date: pn,
      minDate: s.isBefore(j, Pr) ? Pr : j,
      maxDate: s.isAfter(U, bi) ? bi : U,
      disablePast: x,
      disableFuture: v,
      isDateDisabled: Le,
      timezone: Re
    }) : pn;
    Wr ? (Ie(Wr, "finish"), w == null || w(Pr)) : (Ee(), Lt(Pr)), St(Wr, !0);
  }), qe = Mt((pn) => {
    const Pr = s.startOfYear(pn), bi = s.endOfYear(pn), Wr = Le(pn) ? f0({
      utils: s,
      date: pn,
      minDate: s.isBefore(j, Pr) ? Pr : j,
      maxDate: s.isAfter(U, bi) ? bi : U,
      disablePast: x,
      disableFuture: v,
      isDateDisabled: Le,
      timezone: Re
    }) : pn;
    Wr ? (Ie(Wr, "finish"), S == null || S(Wr)) : (Ee(), Lt(Pr)), St(Wr, !0);
  }), wt = Mt((pn) => be(pn && ZD(s, pn, ye ?? Je), "finish", Te));
  V.useEffect(() => {
    ye != null && s.isValid(ye) && Lt(ye);
  }, [ye]);
  const Ut = u, an = jHe(Ut), wn = {
    disablePast: x,
    disableFuture: v,
    maxDate: U,
    minDate: j
  }, En = {
    disableHighlightToday: G,
    readOnly: X,
    disabled: J,
    timezone: Re,
    gridLabelId: At
  }, sr = V.useRef(Te);
  V.useEffect(() => {
    sr.current !== Te && (Ne === sr.current && Qe(Te, !0), sr.current = Te);
  }, [Ne, Qe, Te]);
  const er = V.useMemo(() => [ye], [ye]);
  return /* @__PURE__ */ P.jsxs(zHe, N({
    ref: n,
    className: Be(an.root, q),
    ownerState: Ut
  }, le, {
    children: [/* @__PURE__ */ P.jsx(Ct, N({}, ht)), /* @__PURE__ */ P.jsx(UHe, {
      reduceAnimations: O,
      className: an.viewTransitionContainer,
      transKey: Te,
      ownerState: Ut,
      children: /* @__PURE__ */ P.jsxs("div", {
        children: [Te === "year" && /* @__PURE__ */ P.jsx(JW, N({}, wn, En, {
          value: ye,
          onChange: qe,
          shouldDisableYear: $,
          hasFocus: Ft,
          onFocusedViewChange: (pn) => Qe("year", pn),
          yearsPerRow: pe,
          referenceDate: Je
        })), Te === "month" && /* @__PURE__ */ P.jsx(KW, N({}, wn, En, {
          hasFocus: Ft,
          className: q,
          value: ye,
          onChange: He,
          shouldDisableMonth: I,
          onFocusedViewChange: (pn) => Qe("month", pn),
          monthsPerRow: me,
          referenceDate: Je
        })), Te === "day" && /* @__PURE__ */ P.jsx(jWe, N({}, vt, wn, En, {
          onMonthSwitchingAnimationEnd: Pe,
          onFocusedDayChange: St,
          reduceAnimations: O,
          selectedDays: er,
          onSelectedDaysChange: wt,
          shouldDisableDate: A,
          shouldDisableMonth: I,
          shouldDisableYear: $,
          hasFocus: Ft,
          onFocusedViewChange: (pn) => Qe("day", pn),
          showDaysOutsideCurrentMonth: te,
          fixedWeekNumber: M,
          dayOfWeekFormatter: Z,
          displayWeekNumber: ae,
          components: ne,
          componentsProps: R,
          slots: _,
          slotProps: W,
          loading: Q,
          renderLoading: oe
        }))]
      })
    })]
  }));
});
process.env.NODE_ENV !== "production" && (a$.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: l.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  className: l.string,
  /**
   * Overridable components.
   * @default {}
   * @deprecated Please use `slots`.
   */
  components: l.object,
  /**
   * The props used for each component slot.
   * @default {}
   * @deprecated Please use `slotProps`.
   */
  componentsProps: l.object,
  /**
   * Formats the day of week displayed in the calendar header.
   * @param {string} day The day of week provided by the adapter.  Deprecated, will be removed in v7: Use `date` instead.
   * @param {TDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (_day: string, date: TDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */
  dayOfWeekFormatter: l.func,
  /**
   * Default calendar month displayed when `value` and `defaultValue` are empty.
   * @deprecated Consider using `referenceDate` instead.
   */
  defaultCalendarMonth: l.any,
  /**
   * The default selected value.
   * Used when the component is not controlled.
   */
  defaultValue: l.any,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: l.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: l.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: l.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: l.bool,
  /**
   * If `true`, the week number will be display in the calendar.
   */
  displayWeekNumber: l.bool,
  /**
   * Calendar will show more weeks in order to match this value.
   * Put it to 6 for having fix number of week in Gregorian calendars
   * @default undefined
   */
  fixedWeekNumber: l.number,
  /**
   * Controlled focused view.
   */
  focusedView: l.oneOf(["day", "month", "year"]),
  /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */
  loading: l.bool,
  /**
   * Maximal selectable date.
   */
  maxDate: l.any,
  /**
   * Minimal selectable date.
   */
  minDate: l.any,
  /**
   * Months rendered per row.
   * @default 3
   */
  monthsPerRow: l.oneOf([3, 4]),
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TView The view type. Will be one of date or time views.
   * @param {TValue} value The new value.
   * @param {PickerSelectionState | undefined} selectionState Indicates if the date selection is complete.
   * @param {TView | undefined} selectedView Indicates the view in which the selection has been made.
   */
  onChange: l.func,
  /**
   * Callback fired on focused view change.
   * @template TView
   * @param {TView} view The new view to focus or not.
   * @param {boolean} hasFocus `true` if the view should be focused.
   */
  onFocusedViewChange: l.func,
  /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */
  onMonthChange: l.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: l.func,
  /**
   * Callback fired on year change.
   * @template TDate
   * @param {TDate} year The new year.
   */
  onYearChange: l.func,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: l.oneOf(["day", "month", "year"]),
  /**
   * Make picker read only.
   * @default false
   */
  readOnly: l.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: l.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date using the validation props, except callbacks such as `shouldDisableDate`.
   */
  referenceDate: l.any,
  /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span data-mui-test="loading-progress">...</span>
   */
  renderLoading: l.func,
  /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (e.g. when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */
  shouldDisableDate: l.func,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: l.func,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: l.func,
  /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */
  showDaysOutsideCurrentMonth: l.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: l.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: l.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documention} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: l.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: l.any,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: l.oneOf(["day", "month", "year"]),
  /**
   * Available views.
   */
  views: l.arrayOf(l.oneOf(["day", "month", "year"]).isRequired),
  /**
   * Years rendered per row.
   * @default 3
   */
  yearsPerRow: l.oneOf([3, 4])
});
function WHe(e) {
  return ot("MuiDatePickerToolbar", e);
}
st("MuiDatePickerToolbar", ["root", "title"]);
const HHe = ["value", "isLandscape", "onChange", "toolbarFormat", "toolbarPlaceholder", "views", "className"], qHe = (e) => {
  const {
    classes: t
  } = e;
  return at({
    root: ["root"],
    title: ["title"]
  }, WHe, t);
}, GHe = De(ZF, {
  name: "MuiDatePickerToolbar",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), YHe = De(cn, {
  name: "MuiDatePickerToolbar",
  slot: "Title",
  overridesResolver: (e, t) => t.title
})(({
  ownerState: e
}) => N({}, e.isLandscape && {
  margin: "auto 16px auto auto"
})), QW = /* @__PURE__ */ V.forwardRef(function(t, n) {
  const r = Vn({
    props: t,
    name: "MuiDatePickerToolbar"
  }), {
    value: i,
    isLandscape: o,
    toolbarFormat: s,
    toolbarPlaceholder: a = "––",
    views: u,
    className: c
  } = r, d = _e(r, HHe), f = Nn(), h = Yi(), m = qHe(r), v = V.useMemo(() => {
    if (!i)
      return a;
    const C = Y0(f, {
      format: s,
      views: u
    }, !0);
    return f.formatByString(i, C);
  }, [i, s, a, f, u]), x = r;
  return /* @__PURE__ */ P.jsx(GHe, N({
    ref: n,
    toolbarTitle: h.datePickerToolbarTitle,
    isLandscape: o,
    className: Be(m.root, c)
  }, d, {
    children: /* @__PURE__ */ P.jsx(YHe, {
      variant: "h4",
      align: o ? "left" : "center",
      ownerState: x,
      className: m.title,
      children: v
    })
  }));
});
process.env.NODE_ENV !== "production" && (QW.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * className applied to the root component.
   */
  className: l.string,
  disabled: l.bool,
  /**
   * If `true`, show the toolbar even in desktop mode.
   * @default `true` for Desktop, `false` for Mobile.
   */
  hidden: l.bool,
  isLandscape: l.bool.isRequired,
  onChange: l.func.isRequired,
  /**
   * Callback called when a toolbar is clicked
   * @template TView
   * @param {TView} view The view to open
   */
  onViewChange: l.func.isRequired,
  readOnly: l.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  titleId: l.string,
  /**
   * Toolbar date format.
   */
  toolbarFormat: l.string,
  /**
   * Toolbar value placeholder—it is displayed when the value is empty.
   * @default "––"
   */
  toolbarPlaceholder: l.node,
  value: l.any,
  /**
   * Currently visible picker view.
   */
  view: l.oneOf(["day", "month", "year"]).isRequired,
  views: l.arrayOf(l.oneOf(["day", "month", "year"]).isRequired).isRequired
});
function ZW(e, t) {
  var n, r, i, o;
  const s = Nn(), a = Df(), u = Vn({
    props: e,
    name: t
  }), c = V.useMemo(() => {
    var f;
    return ((f = u.localeText) == null ? void 0 : f.toolbarTitle) == null ? u.localeText : N({}, u.localeText, {
      datePickerToolbarTitle: u.localeText.toolbarTitle
    });
  }, [u.localeText]), d = (n = u.slots) != null ? n : cv(u.components);
  return N({}, u, {
    localeText: c
  }, zF({
    views: u.views,
    openTo: u.openTo,
    defaultViews: ["year", "day"],
    defaultOpenTo: "day"
  }), {
    disableFuture: (r = u.disableFuture) != null ? r : !1,
    disablePast: (i = u.disablePast) != null ? i : !1,
    minDate: Lo(s, u.minDate, a.minDate),
    maxDate: Lo(s, u.maxDate, a.maxDate),
    slots: N({
      toolbar: QW
    }, d),
    slotProps: (o = u.slotProps) != null ? o : u.componentsProps
  });
}
const KHe = ["props", "getOpenDialogAriaText"], JHe = ["ownerState"], XHe = ["ownerState"], l$ = (e) => {
  var t, n, r, i, o;
  let {
    props: s,
    getOpenDialogAriaText: a
  } = e, u = _e(e, KHe);
  const {
    slots: c,
    slotProps: d,
    className: f,
    sx: h,
    format: m,
    formatDensity: v,
    timezone: x,
    name: C,
    label: E,
    inputRef: S,
    readOnly: w,
    disabled: O,
    autoFocus: A,
    localeText: I,
    reduceAnimations: $
  } = s, L = Nn(), B = V.useRef(null), H = V.useRef(null), q = Pl(), J = (t = d == null || (n = d.toolbar) == null ? void 0 : n.hidden) != null ? t : !1, {
    open: X,
    actions: j,
    hasUIView: U,
    layoutProps: G,
    renderCurrentView: K,
    shouldRestoreFocus: ee,
    fieldProps: te
  } = VW(N({}, u, {
    props: s,
    inputRef: B,
    autoFocusView: !0,
    additionalViewProps: {},
    wrapperVariant: "desktop"
  })), M = (r = c.inputAdornment) != null ? r : lg, Z = si({
    elementType: M,
    externalSlotProps: d == null ? void 0 : d.inputAdornment,
    additionalProps: {
      position: "end"
    },
    ownerState: s
  }), ne = _e(Z, JHe), R = (i = c.openPickerButton) != null ? i : Or, _ = si({
    elementType: R,
    externalSlotProps: d == null ? void 0 : d.openPickerButton,
    additionalProps: {
      disabled: O || w,
      onClick: X ? j.onClose : j.onOpen,
      "aria-label": a(te.value, L),
      edge: ne.position
    },
    ownerState: s
  }), W = _e(_, XHe), Q = c.openPickerIcon, oe = c.field, ae = si({
    elementType: oe,
    externalSlotProps: d == null ? void 0 : d.field,
    additionalProps: N({}, te, J && {
      id: q
    }, {
      readOnly: w,
      disabled: O,
      className: f,
      sx: h,
      format: m,
      formatDensity: v,
      timezone: x,
      label: E,
      name: C,
      autoFocus: A && !s.open,
      focused: X ? !0 : void 0
    }),
    ownerState: s
  });
  U && (ae.InputProps = N({}, ae.InputProps, {
    ref: H
  }, !s.disableOpenPicker && {
    [`${ne.position}Adornment`]: /* @__PURE__ */ P.jsx(M, N({}, ne, {
      children: /* @__PURE__ */ P.jsx(R, N({}, W, {
        children: /* @__PURE__ */ P.jsx(Q, N({}, d == null ? void 0 : d.openPickerIcon))
      }))
    }))
  }));
  const pe = N({
    textField: c.textField,
    clearIcon: c.clearIcon,
    clearButton: c.clearButton
  }, ae.slots), me = (o = c.layout) != null ? o : t$, xe = Hn(B, ae.inputRef, S);
  let le = q;
  J && (E ? le = `${q}-label` : le = void 0);
  const ye = N({}, d, {
    toolbar: N({}, d == null ? void 0 : d.toolbar, {
      titleId: q
    }),
    popper: N({
      "aria-labelledby": le
    }, d == null ? void 0 : d.popper)
  });
  return {
    renderPicker: () => /* @__PURE__ */ P.jsxs(Od, {
      localeText: I,
      children: [/* @__PURE__ */ P.jsx(oe, N({}, ae, {
        slots: pe,
        slotProps: ye,
        inputRef: xe
      })), /* @__PURE__ */ P.jsx(qUe, N({
        role: "dialog",
        placement: "bottom-start",
        anchorEl: H.current
      }, j, {
        open: X,
        slots: c,
        slotProps: ye,
        shouldRestoreFocus: ee,
        reduceAnimations: $,
        children: /* @__PURE__ */ P.jsx(me, N({}, G, ye == null ? void 0 : ye.layout, {
          slots: c,
          slotProps: ye,
          children: K()
        }))
      }))]
    })
  };
}, Ra = ({
  view: e,
  onViewChange: t,
  views: n,
  focusedView: r,
  onFocusedViewChange: i,
  value: o,
  defaultValue: s,
  referenceDate: a,
  onChange: u,
  className: c,
  classes: d,
  disableFuture: f,
  disablePast: h,
  minDate: m,
  maxDate: v,
  shouldDisableDate: x,
  shouldDisableMonth: C,
  shouldDisableYear: E,
  reduceAnimations: S,
  onMonthChange: w,
  monthsPerRow: O,
  onYearChange: A,
  yearsPerRow: I,
  defaultCalendarMonth: $,
  components: L,
  componentsProps: B,
  slots: H,
  slotProps: q,
  loading: J,
  renderLoading: X,
  disableHighlightToday: j,
  readOnly: U,
  disabled: G,
  showDaysOutsideCurrentMonth: K,
  dayOfWeekFormatter: ee,
  sx: te,
  autoFocus: M,
  fixedWeekNumber: Z,
  displayWeekNumber: ne,
  timezone: R
}) => /* @__PURE__ */ P.jsx(a$, {
  view: e,
  onViewChange: t,
  views: n.filter(Yh),
  focusedView: r && Yh(r) ? r : null,
  onFocusedViewChange: i,
  value: o,
  defaultValue: s,
  referenceDate: a,
  onChange: u,
  className: c,
  classes: d,
  disableFuture: f,
  disablePast: h,
  minDate: m,
  maxDate: v,
  shouldDisableDate: x,
  shouldDisableMonth: C,
  shouldDisableYear: E,
  reduceAnimations: S,
  onMonthChange: w,
  monthsPerRow: O,
  onYearChange: A,
  yearsPerRow: I,
  defaultCalendarMonth: $,
  components: L,
  componentsProps: B,
  slots: H,
  slotProps: q,
  loading: J,
  renderLoading: X,
  disableHighlightToday: j,
  readOnly: U,
  disabled: G,
  showDaysOutsideCurrentMonth: K,
  dayOfWeekFormatter: ee,
  sx: te,
  autoFocus: M,
  fixedWeekNumber: Z,
  displayWeekNumber: ne,
  timezone: R
}), eH = /* @__PURE__ */ V.forwardRef(function(t, n) {
  var r, i, o, s;
  const a = Yi(), u = Nn(), c = ZW(t, "MuiDesktopDatePicker"), d = N({
    day: Ra,
    month: Ra,
    year: Ra
  }, c.viewRenderers), f = N({}, c, {
    viewRenderers: d,
    format: Y0(u, c, !1),
    yearsPerRow: (r = c.yearsPerRow) != null ? r : 4,
    slots: N({
      openPickerIcon: yW,
      field: i$
    }, c.slots),
    slotProps: N({}, c.slotProps, {
      field: (m) => {
        var v;
        return N({}, Id((v = c.slotProps) == null ? void 0 : v.field, m), mg(c), {
          ref: n
        });
      },
      toolbar: N({
        hidden: !0
      }, (i = c.slotProps) == null ? void 0 : i.toolbar)
    })
  }), {
    renderPicker: h
  } = l$({
    props: f,
    valueManager: qi,
    valueType: "date",
    getOpenDialogAriaText: (o = (s = f.localeText) == null ? void 0 : s.openDatePickerDialogue) != null ? o : a.openDatePickerDialogue,
    validator: dv
  });
  return h();
});
eH.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: l.bool,
  /**
   * Class name applied to the root element.
   */
  className: l.string,
  /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */
  closeOnSelect: l.bool,
  /**
   * Overridable components.
   * @default {}
   * @deprecated Please use `slots`.
   */
  components: l.object,
  /**
   * The props used for each component slot.
   * @default {}
   * @deprecated Please use `slotProps`.
   */
  componentsProps: l.object,
  /**
   * Formats the day of week displayed in the calendar header.
   * @param {string} day The day of week provided by the adapter.  Deprecated, will be removed in v7: Use `date` instead.
   * @param {TDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (_day: string, date: TDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */
  dayOfWeekFormatter: l.func,
  /**
   * Default calendar month displayed when `value` and `defaultValue` are empty.
   * @deprecated Consider using `referenceDate` instead.
   */
  defaultCalendarMonth: l.any,
  /**
   * The default value.
   * Used when the component is not controlled.
   */
  defaultValue: l.any,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: l.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: l.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: l.bool,
  /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */
  disableOpenPicker: l.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: l.bool,
  /**
   * If `true`, the week number will be display in the calendar.
   */
  displayWeekNumber: l.bool,
  /**
   * Calendar will show more weeks in order to match this value.
   * Put it to 6 for having fix number of week in Gregorian calendars
   * @default undefined
   */
  fixedWeekNumber: l.number,
  /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */
  format: l.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: l.oneOf(["dense", "spacious"]),
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: wr,
  /**
   * The label content.
   */
  label: l.node,
  /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */
  loading: l.bool,
  /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */
  localeText: l.object,
  /**
   * Maximal selectable date.
   */
  maxDate: l.any,
  /**
   * Minimal selectable date.
   */
  minDate: l.any,
  /**
   * Months rendered per row.
   * @default 3
   */
  monthsPerRow: l.oneOf([3, 4]),
  /**
   * Name attribute used by the `input` element in the Field.
   */
  name: l.string,
  /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   */
  onAccept: l.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: l.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */
  onClose: l.func,
  /**
   * Callback fired when the error associated to the current value changes.
   * If the error has a non-null value, then the `TextField` will be rendered in `error` state.
   *
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error describing why the current value is not valid.
   * @param {TValue} value The value associated to the error.
   */
  onError: l.func,
  /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */
  onMonthChange: l.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */
  onOpen: l.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: l.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: l.func,
  /**
   * Callback fired on year change.
   * @template TDate
   * @param {TDate} year The new year.
   */
  onYearChange: l.func,
  /**
   * Control the popup or dialog open state.
   * @default false
   */
  open: l.bool,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: l.oneOf(["day", "month", "year"]),
  /**
   * Force rendering in particular orientation.
   */
  orientation: l.oneOf(["landscape", "portrait"]),
  readOnly: l.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: l.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */
  referenceDate: l.any,
  /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span data-mui-test="loading-progress">...</span>
   */
  renderLoading: l.func,
  /**
   * The currently selected sections.
   * This prop accept four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If an object with a `startIndex` and `endIndex` properties are provided, the sections between those two indexes will be selected.
   * 3. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 4. If `null` is provided, no section will be selected
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: l.oneOfType([l.oneOf(["all", "day", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), l.number, l.shape({
    endIndex: l.number.isRequired,
    startIndex: l.number.isRequired
  })]),
  /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (e.g. when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */
  shouldDisableDate: l.func,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: l.func,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: l.func,
  /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */
  showDaysOutsideCurrentMonth: l.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: l.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: l.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documention} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: l.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: l.any,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: l.oneOf(["day", "month", "year"]),
  /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be the used.
   */
  viewRenderers: l.shape({
    day: l.func,
    month: l.func,
    year: l.func
  }),
  /**
   * Available views.
   */
  views: l.arrayOf(l.oneOf(["day", "month", "year"]).isRequired),
  /**
   * Years rendered per row.
   * @default 4
   */
  yearsPerRow: l.oneOf([3, 4])
};
const QHe = ["props", "getOpenDialogAriaText"], u$ = (e) => {
  var t, n, r;
  let {
    props: i,
    getOpenDialogAriaText: o
  } = e, s = _e(e, QHe);
  const {
    slots: a,
    slotProps: u,
    className: c,
    sx: d,
    format: f,
    formatDensity: h,
    timezone: m,
    name: v,
    label: x,
    inputRef: C,
    readOnly: E,
    disabled: S,
    localeText: w
  } = i, O = Nn(), A = V.useRef(null), I = Pl(), $ = (t = u == null || (n = u.toolbar) == null ? void 0 : n.hidden) != null ? t : !1, {
    open: L,
    actions: B,
    layoutProps: H,
    renderCurrentView: q,
    fieldProps: J
  } = VW(N({}, s, {
    props: i,
    inputRef: A,
    autoFocusView: !0,
    additionalViewProps: {},
    wrapperVariant: "mobile"
  })), X = a.field, j = si({
    elementType: X,
    externalSlotProps: u == null ? void 0 : u.field,
    additionalProps: N({}, J, $ && {
      id: I
    }, !(S || E) && {
      onClick: B.onOpen,
      onKeyDown: wUe(B.onOpen)
    }, {
      readOnly: E ?? !0,
      disabled: S,
      className: c,
      sx: d,
      format: f,
      formatDensity: h,
      timezone: m,
      label: x,
      name: v
    }),
    ownerState: i
  });
  j.inputProps = N({}, j.inputProps, {
    "aria-label": o(J.value, O)
  });
  const U = N({
    textField: a.textField
  }, j.slots), G = (r = a.layout) != null ? r : t$, K = Hn(A, j.inputRef, C);
  let ee = I;
  $ && (x ? ee = `${I}-label` : ee = void 0);
  const te = N({}, u, {
    toolbar: N({}, u == null ? void 0 : u.toolbar, {
      titleId: I
    }),
    mobilePaper: N({
      "aria-labelledby": ee
    }, u == null ? void 0 : u.mobilePaper)
  });
  return {
    renderPicker: () => /* @__PURE__ */ P.jsxs(Od, {
      localeText: w,
      children: [/* @__PURE__ */ P.jsx(X, N({}, j, {
        slots: U,
        slotProps: te,
        inputRef: K
      })), /* @__PURE__ */ P.jsx(MUe, N({}, B, {
        open: L,
        slots: a,
        slotProps: te,
        children: /* @__PURE__ */ P.jsx(G, N({}, H, te == null ? void 0 : te.layout, {
          slots: a,
          slotProps: te,
          children: q()
        }))
      }))]
    })
  };
}, tH = /* @__PURE__ */ V.forwardRef(function(t, n) {
  var r, i, o;
  const s = Yi(), a = Nn(), u = ZW(t, "MuiMobileDatePicker"), c = N({
    day: Ra,
    month: Ra,
    year: Ra
  }, u.viewRenderers), d = N({}, u, {
    viewRenderers: c,
    format: Y0(a, u, !1),
    slots: N({
      field: i$
    }, u.slots),
    slotProps: N({}, u.slotProps, {
      field: (h) => {
        var m;
        return N({}, Id((m = u.slotProps) == null ? void 0 : m.field, h), mg(u), {
          ref: n
        });
      },
      toolbar: N({
        hidden: !1
      }, (r = u.slotProps) == null ? void 0 : r.toolbar)
    })
  }), {
    renderPicker: f
  } = u$({
    props: d,
    valueManager: qi,
    valueType: "date",
    getOpenDialogAriaText: (i = (o = d.localeText) == null ? void 0 : o.openDatePickerDialogue) != null ? i : s.openDatePickerDialogue,
    validator: dv
  });
  return f();
});
tH.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: l.bool,
  /**
   * Class name applied to the root element.
   */
  className: l.string,
  /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */
  closeOnSelect: l.bool,
  /**
   * Overridable components.
   * @default {}
   * @deprecated Please use `slots`.
   */
  components: l.object,
  /**
   * The props used for each component slot.
   * @default {}
   * @deprecated Please use `slotProps`.
   */
  componentsProps: l.object,
  /**
   * Formats the day of week displayed in the calendar header.
   * @param {string} day The day of week provided by the adapter.  Deprecated, will be removed in v7: Use `date` instead.
   * @param {TDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (_day: string, date: TDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */
  dayOfWeekFormatter: l.func,
  /**
   * Default calendar month displayed when `value` and `defaultValue` are empty.
   * @deprecated Consider using `referenceDate` instead.
   */
  defaultCalendarMonth: l.any,
  /**
   * The default value.
   * Used when the component is not controlled.
   */
  defaultValue: l.any,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: l.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: l.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: l.bool,
  /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */
  disableOpenPicker: l.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: l.bool,
  /**
   * If `true`, the week number will be display in the calendar.
   */
  displayWeekNumber: l.bool,
  /**
   * Calendar will show more weeks in order to match this value.
   * Put it to 6 for having fix number of week in Gregorian calendars
   * @default undefined
   */
  fixedWeekNumber: l.number,
  /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */
  format: l.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: l.oneOf(["dense", "spacious"]),
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: wr,
  /**
   * The label content.
   */
  label: l.node,
  /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */
  loading: l.bool,
  /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */
  localeText: l.object,
  /**
   * Maximal selectable date.
   */
  maxDate: l.any,
  /**
   * Minimal selectable date.
   */
  minDate: l.any,
  /**
   * Months rendered per row.
   * @default 3
   */
  monthsPerRow: l.oneOf([3, 4]),
  /**
   * Name attribute used by the `input` element in the Field.
   */
  name: l.string,
  /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   */
  onAccept: l.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: l.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */
  onClose: l.func,
  /**
   * Callback fired when the error associated to the current value changes.
   * If the error has a non-null value, then the `TextField` will be rendered in `error` state.
   *
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error describing why the current value is not valid.
   * @param {TValue} value The value associated to the error.
   */
  onError: l.func,
  /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */
  onMonthChange: l.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */
  onOpen: l.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: l.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: l.func,
  /**
   * Callback fired on year change.
   * @template TDate
   * @param {TDate} year The new year.
   */
  onYearChange: l.func,
  /**
   * Control the popup or dialog open state.
   * @default false
   */
  open: l.bool,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: l.oneOf(["day", "month", "year"]),
  /**
   * Force rendering in particular orientation.
   */
  orientation: l.oneOf(["landscape", "portrait"]),
  readOnly: l.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: l.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */
  referenceDate: l.any,
  /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span data-mui-test="loading-progress">...</span>
   */
  renderLoading: l.func,
  /**
   * The currently selected sections.
   * This prop accept four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If an object with a `startIndex` and `endIndex` properties are provided, the sections between those two indexes will be selected.
   * 3. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 4. If `null` is provided, no section will be selected
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: l.oneOfType([l.oneOf(["all", "day", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), l.number, l.shape({
    endIndex: l.number.isRequired,
    startIndex: l.number.isRequired
  })]),
  /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (e.g. when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */
  shouldDisableDate: l.func,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: l.func,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: l.func,
  /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */
  showDaysOutsideCurrentMonth: l.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: l.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: l.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documention} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: l.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: l.any,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: l.oneOf(["day", "month", "year"]),
  /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be the used.
   */
  viewRenderers: l.shape({
    day: l.func,
    month: l.func,
    year: l.func
  }),
  /**
   * Available views.
   */
  views: l.arrayOf(l.oneOf(["day", "month", "year"]).isRequired),
  /**
   * Years rendered per row.
   * @default 3
   */
  yearsPerRow: l.oneOf([3, 4])
};
const ZHe = ["desktopModeMediaQuery"], ZE = /* @__PURE__ */ V.forwardRef(function(t, n) {
  const r = Vn({
    props: t,
    name: "MuiDatePicker"
  }), {
    desktopModeMediaQuery: i = JF
  } = r, o = _e(r, ZHe);
  return PE(i, {
    defaultMatches: !0
  }) ? /* @__PURE__ */ P.jsx(eH, N({
    ref: n
  }, o)) : /* @__PURE__ */ P.jsx(tH, N({
    ref: n
  }, o));
});
process.env.NODE_ENV !== "production" && (ZE.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: l.bool,
  /**
   * Class name applied to the root element.
   */
  className: l.string,
  /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */
  closeOnSelect: l.bool,
  /**
   * Overridable components.
   * @default {}
   * @deprecated Please use `slots`.
   */
  components: l.object,
  /**
   * The props used for each component slot.
   * @default {}
   * @deprecated Please use `slotProps`.
   */
  componentsProps: l.object,
  /**
   * Formats the day of week displayed in the calendar header.
   * @param {string} day The day of week provided by the adapter.  Deprecated, will be removed in v7: Use `date` instead.
   * @param {TDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (_day: string, date: TDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */
  dayOfWeekFormatter: l.func,
  /**
   * Default calendar month displayed when `value` and `defaultValue` are empty.
   * @deprecated Consider using `referenceDate` instead.
   */
  defaultCalendarMonth: l.any,
  /**
   * The default value.
   * Used when the component is not controlled.
   */
  defaultValue: l.any,
  /**
   * CSS media query when `Mobile` mode will be changed to `Desktop`.
   * @default '@media (pointer: fine)'
   * @example '@media (min-width: 720px)' or theme.breakpoints.up("sm")
   */
  desktopModeMediaQuery: l.string,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: l.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: l.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: l.bool,
  /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */
  disableOpenPicker: l.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: l.bool,
  /**
   * If `true`, the week number will be display in the calendar.
   */
  displayWeekNumber: l.bool,
  /**
   * Calendar will show more weeks in order to match this value.
   * Put it to 6 for having fix number of week in Gregorian calendars
   * @default undefined
   */
  fixedWeekNumber: l.number,
  /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */
  format: l.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: l.oneOf(["dense", "spacious"]),
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: wr,
  /**
   * The label content.
   */
  label: l.node,
  /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */
  loading: l.bool,
  /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */
  localeText: l.object,
  /**
   * Maximal selectable date.
   */
  maxDate: l.any,
  /**
   * Minimal selectable date.
   */
  minDate: l.any,
  /**
   * Months rendered per row.
   * @default 3
   */
  monthsPerRow: l.oneOf([3, 4]),
  /**
   * Name attribute used by the `input` element in the Field.
   */
  name: l.string,
  /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   */
  onAccept: l.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: l.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */
  onClose: l.func,
  /**
   * Callback fired when the error associated to the current value changes.
   * If the error has a non-null value, then the `TextField` will be rendered in `error` state.
   *
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error describing why the current value is not valid.
   * @param {TValue} value The value associated to the error.
   */
  onError: l.func,
  /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */
  onMonthChange: l.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */
  onOpen: l.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: l.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: l.func,
  /**
   * Callback fired on year change.
   * @template TDate
   * @param {TDate} year The new year.
   */
  onYearChange: l.func,
  /**
   * Control the popup or dialog open state.
   * @default false
   */
  open: l.bool,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: l.oneOf(["day", "month", "year"]),
  /**
   * Force rendering in particular orientation.
   */
  orientation: l.oneOf(["landscape", "portrait"]),
  readOnly: l.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: l.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */
  referenceDate: l.any,
  /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span data-mui-test="loading-progress">...</span>
   */
  renderLoading: l.func,
  /**
   * The currently selected sections.
   * This prop accept four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If an object with a `startIndex` and `endIndex` properties are provided, the sections between those two indexes will be selected.
   * 3. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 4. If `null` is provided, no section will be selected
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: l.oneOfType([l.oneOf(["all", "day", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), l.number, l.shape({
    endIndex: l.number.isRequired,
    startIndex: l.number.isRequired
  })]),
  /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (e.g. when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */
  shouldDisableDate: l.func,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: l.func,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: l.func,
  /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */
  showDaysOutsideCurrentMonth: l.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: l.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: l.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documention} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: l.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: l.any,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: l.oneOf(["day", "month", "year"]),
  /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be the used.
   */
  viewRenderers: l.shape({
    day: l.func,
    month: l.func,
    year: l.func
  }),
  /**
   * Available views.
   */
  views: l.arrayOf(l.oneOf(["day", "month", "year"]).isRequired),
  /**
   * Years rendered per row.
   * @default 4 on desktop, 3 on mobile
   */
  yearsPerRow: l.oneOf([3, 4])
});
function eqe(e) {
  return ot("MuiTimePickerToolbar", e);
}
const h0 = st("MuiTimePickerToolbar", ["root", "separator", "hourMinuteLabel", "hourMinuteLabelLandscape", "hourMinuteLabelReverse", "ampmSelection", "ampmLandscape", "ampmLabel"]), tqe = ["ampm", "ampmInClock", "value", "isLandscape", "onChange", "view", "onViewChange", "views", "disabled", "readOnly", "className"], nqe = (e) => {
  const {
    theme: t,
    isLandscape: n,
    classes: r
  } = e, i = {
    root: ["root"],
    separator: ["separator"],
    hourMinuteLabel: ["hourMinuteLabel", n && "hourMinuteLabelLandscape", t.direction === "rtl" && "hourMinuteLabelReverse"],
    ampmSelection: ["ampmSelection", n && "ampmLandscape"],
    ampmLabel: ["ampmLabel"]
  };
  return at(i, eqe, r);
}, rqe = De(ZF, {
  name: "MuiTimePickerToolbar",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), iqe = De(e$, {
  name: "MuiTimePickerToolbar",
  slot: "Separator",
  overridesResolver: (e, t) => t.separator
})({
  outline: 0,
  margin: "0 4px 0 2px",
  cursor: "default"
}), nH = De("div", {
  name: "MuiTimePickerToolbar",
  slot: "HourMinuteLabel",
  overridesResolver: (e, t) => [{
    [`&.${h0.hourMinuteLabelLandscape}`]: t.hourMinuteLabelLandscape,
    [`&.${h0.hourMinuteLabelReverse}`]: t.hourMinuteLabelReverse
  }, t.hourMinuteLabel]
})(({
  theme: e,
  ownerState: t
}) => N({
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "flex-end"
}, t.isLandscape && {
  marginTop: "auto"
}, e.direction === "rtl" && {
  flexDirection: "row-reverse"
}));
nH.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  as: l.elementType,
  ownerState: l.object.isRequired,
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
};
const rH = De("div", {
  name: "MuiTimePickerToolbar",
  slot: "AmPmSelection",
  overridesResolver: (e, t) => [{
    [`.${h0.ampmLabel}`]: t.ampmLabel
  }, {
    [`&.${h0.ampmLandscape}`]: t.ampmLandscape
  }, t.ampmSelection]
})(({
  ownerState: e
}) => N({
  display: "flex",
  flexDirection: "column",
  marginRight: "auto",
  marginLeft: 12
}, e.isLandscape && {
  margin: "4px 0 auto",
  flexDirection: "row",
  justifyContent: "space-around",
  flexBasis: "100%"
}, {
  [`& .${h0.ampmLabel}`]: {
    fontSize: 17
  }
}));
rH.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  as: l.elementType,
  ownerState: l.object.isRequired,
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
};
function iH(e) {
  const t = Vn({
    props: e,
    name: "MuiTimePickerToolbar"
  }), {
    ampm: n,
    ampmInClock: r,
    value: i,
    isLandscape: o,
    onChange: s,
    view: a,
    onViewChange: u,
    views: c,
    disabled: d,
    readOnly: f,
    className: h
  } = t, m = _e(t, tqe), v = Nn(), x = Yi(), C = Gi(), E = !!(n && !r && c.includes("hours")), {
    meridiemMode: S,
    handleMeridiemChange: w
  } = qE(i, n, s), O = (L) => n ? v.format(L, "hours12h") : v.format(L, "hours24h"), A = t, I = nqe(N({}, A, {
    theme: C
  })), $ = /* @__PURE__ */ P.jsx(iqe, {
    tabIndex: -1,
    value: ":",
    variant: "h3",
    selected: !1,
    className: I.separator
  });
  return /* @__PURE__ */ P.jsxs(rqe, N({
    landscapeDirection: "row",
    toolbarTitle: x.timePickerToolbarTitle,
    isLandscape: o,
    ownerState: A,
    className: Be(I.root, h)
  }, m, {
    children: [/* @__PURE__ */ P.jsxs(nH, {
      className: I.hourMinuteLabel,
      ownerState: A,
      children: [Ph(c, "hours") && /* @__PURE__ */ P.jsx(Js, {
        tabIndex: -1,
        variant: "h3",
        onClick: () => u("hours"),
        selected: a === "hours",
        value: i ? O(i) : "--"
      }), Ph(c, ["hours", "minutes"]) && $, Ph(c, "minutes") && /* @__PURE__ */ P.jsx(Js, {
        tabIndex: -1,
        variant: "h3",
        onClick: () => u("minutes"),
        selected: a === "minutes",
        value: i ? v.format(i, "minutes") : "--"
      }), Ph(c, ["minutes", "seconds"]) && $, Ph(c, "seconds") && /* @__PURE__ */ P.jsx(Js, {
        variant: "h3",
        onClick: () => u("seconds"),
        selected: a === "seconds",
        value: i ? v.format(i, "seconds") : "--"
      })]
    }), E && /* @__PURE__ */ P.jsxs(rH, {
      className: I.ampmSelection,
      ownerState: A,
      children: [/* @__PURE__ */ P.jsx(Js, {
        disableRipple: !0,
        variant: "subtitle2",
        selected: S === "am",
        typographyClassName: I.ampmLabel,
        value: ml(v, "am"),
        onClick: f ? void 0 : () => w("am"),
        disabled: d
      }), /* @__PURE__ */ P.jsx(Js, {
        disableRipple: !0,
        variant: "subtitle2",
        selected: S === "pm",
        typographyClassName: I.ampmLabel,
        value: ml(v, "pm"),
        onClick: f ? void 0 : () => w("pm"),
        disabled: d
      })]
    })]
  }));
}
process.env.NODE_ENV !== "production" && (iH.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  ampm: l.bool,
  ampmInClock: l.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * className applied to the root component.
   */
  className: l.string,
  disabled: l.bool,
  /**
   * If `true`, show the toolbar even in desktop mode.
   * @default `true` for Desktop, `false` for Mobile.
   */
  hidden: l.bool,
  isLandscape: l.bool.isRequired,
  onChange: l.func.isRequired,
  /**
   * Callback called when a toolbar is clicked
   * @template TView
   * @param {TView} view The view to open
   */
  onViewChange: l.func.isRequired,
  readOnly: l.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  titleId: l.string,
  /**
   * Toolbar date format.
   */
  toolbarFormat: l.string,
  /**
   * Toolbar value placeholder—it is displayed when the value is empty.
   * @default "––"
   */
  toolbarPlaceholder: l.node,
  value: l.any,
  /**
   * Currently visible picker view.
   */
  view: l.oneOf(["hours", "meridiem", "minutes", "seconds"]).isRequired,
  views: l.arrayOf(l.oneOf(["hours", "meridiem", "minutes", "seconds"]).isRequired).isRequired
});
function oH(e, t) {
  var n, r, i, o, s;
  const a = Nn(), u = Vn({
    props: e,
    name: t
  }), c = (n = u.ampm) != null ? n : a.is12HourCycleInCurrentLocale(), d = V.useMemo(() => {
    var m;
    return ((m = u.localeText) == null ? void 0 : m.toolbarTitle) == null ? u.localeText : N({}, u.localeText, {
      timePickerToolbarTitle: u.localeText.toolbarTitle
    });
  }, [u.localeText]), f = (r = u.slots) != null ? r : cv(u.components), h = (i = u.slotProps) != null ? i : u.componentsProps;
  return N({}, u, {
    ampm: c,
    localeText: d
  }, zF({
    views: u.views,
    openTo: u.openTo,
    defaultViews: ["hours", "minutes"],
    defaultOpenTo: "hours"
  }), {
    disableFuture: (o = u.disableFuture) != null ? o : !1,
    disablePast: (s = u.disablePast) != null ? s : !1,
    slots: N({
      toolbar: iH
    }, f),
    slotProps: N({}, h, {
      toolbar: N({
        ampm: c,
        ampmInClock: u.ampmInClock
      }, h == null ? void 0 : h.toolbar)
    })
  });
}
const Jh = ({
  view: e,
  onViewChange: t,
  focusedView: n,
  onFocusedViewChange: r,
  views: i,
  value: o,
  defaultValue: s,
  referenceDate: a,
  onChange: u,
  className: c,
  classes: d,
  disableFuture: f,
  disablePast: h,
  minTime: m,
  maxTime: v,
  shouldDisableTime: x,
  shouldDisableClock: C,
  minutesStep: E,
  ampm: S,
  ampmInClock: w,
  components: O,
  componentsProps: A,
  slots: I,
  slotProps: $,
  readOnly: L,
  disabled: B,
  sx: H,
  autoFocus: q,
  showViewSwitcher: J,
  disableIgnoringDatePartForTimeValidation: X,
  timezone: j
}) => /* @__PURE__ */ P.jsx(OW, {
  view: e,
  onViewChange: t,
  focusedView: n && bm(n) ? n : null,
  onFocusedViewChange: r,
  views: i.filter(bm),
  value: o,
  defaultValue: s,
  referenceDate: a,
  onChange: u,
  className: c,
  classes: d,
  disableFuture: f,
  disablePast: h,
  minTime: m,
  maxTime: v,
  shouldDisableTime: x,
  shouldDisableClock: C,
  minutesStep: E,
  ampm: S,
  ampmInClock: w,
  components: O,
  componentsProps: A,
  slots: I,
  slotProps: $,
  readOnly: L,
  disabled: B,
  sx: H,
  autoFocus: q,
  showViewSwitcher: J,
  disableIgnoringDatePartForTimeValidation: X,
  timezone: j
}), sH = ({
  view: e,
  onViewChange: t,
  focusedView: n,
  onFocusedViewChange: r,
  views: i,
  value: o,
  defaultValue: s,
  referenceDate: a,
  onChange: u,
  className: c,
  classes: d,
  disableFuture: f,
  disablePast: h,
  minTime: m,
  maxTime: v,
  shouldDisableTime: x,
  shouldDisableClock: C,
  minutesStep: E,
  ampm: S,
  components: w,
  componentsProps: O,
  slots: A,
  slotProps: I,
  readOnly: $,
  disabled: L,
  sx: B,
  autoFocus: H,
  disableIgnoringDatePartForTimeValidation: q,
  timeSteps: J,
  skipDisabled: X,
  timezone: j
}) => /* @__PURE__ */ P.jsx(IW, {
  view: e,
  onViewChange: t,
  focusedView: n,
  onFocusedViewChange: r,
  views: i.filter(bm),
  value: o,
  defaultValue: s,
  referenceDate: a,
  onChange: u,
  className: c,
  classes: d,
  disableFuture: f,
  disablePast: h,
  minTime: m,
  maxTime: v,
  shouldDisableTime: x,
  shouldDisableClock: C,
  minutesStep: E,
  ampm: S,
  components: w,
  componentsProps: O,
  slots: A,
  slotProps: I,
  readOnly: $,
  disabled: L,
  sx: B,
  autoFocus: H,
  disableIgnoringDatePartForTimeValidation: q,
  timeStep: J == null ? void 0 : J.minutes,
  skipDisabled: X,
  timezone: j
}), nk = ({
  view: e,
  onViewChange: t,
  focusedView: n,
  onFocusedViewChange: r,
  views: i,
  value: o,
  defaultValue: s,
  referenceDate: a,
  onChange: u,
  className: c,
  classes: d,
  disableFuture: f,
  disablePast: h,
  minTime: m,
  maxTime: v,
  shouldDisableTime: x,
  shouldDisableClock: C,
  minutesStep: E,
  ampm: S,
  components: w,
  componentsProps: O,
  slots: A,
  slotProps: I,
  readOnly: $,
  disabled: L,
  sx: B,
  autoFocus: H,
  disableIgnoringDatePartForTimeValidation: q,
  timeSteps: J,
  skipDisabled: X,
  timezone: j
}) => /* @__PURE__ */ P.jsx(FW, {
  view: e,
  onViewChange: t,
  focusedView: n,
  onFocusedViewChange: r,
  views: i.filter(bm),
  value: o,
  defaultValue: s,
  referenceDate: a,
  onChange: u,
  className: c,
  classes: d,
  disableFuture: f,
  disablePast: h,
  minTime: m,
  maxTime: v,
  shouldDisableTime: x,
  shouldDisableClock: C,
  minutesStep: E,
  ampm: S,
  components: w,
  componentsProps: O,
  slots: A,
  slotProps: I,
  readOnly: $,
  disabled: L,
  sx: B,
  autoFocus: H,
  disableIgnoringDatePartForTimeValidation: q,
  timeSteps: J,
  skipDisabled: X,
  timezone: j
}), oqe = ["views", "format"], aH = (e, t) => {
  let {
    views: n,
    format: r
  } = t, i = _e(t, oqe);
  if (r)
    return r;
  const o = [], s = [];
  if (n.forEach((c) => {
    bm(c) ? s.push(c) : o.push(c);
  }), s.length === 0)
    return Y0(e, N({
      views: o
    }, i), !1);
  if (o.length === 0)
    return QD(e, N({
      views: s
    }, i));
  const a = QD(e, N({
    views: s
  }, i));
  return `${Y0(e, N({
    views: o
  }, i), !1)} ${a}`;
}, sqe = (e, t, n) => n ? t.filter((r) => !Kc(r) || r === "hours") : e ? [...t, "meridiem"] : t, aqe = (e, t) => {
  var n, r;
  return 24 * 60 / (((n = e.hours) != null ? n : 1) * ((r = e.minutes) != null ? r : 5)) <= t;
};
function lH({
  thresholdToRenderTimeInASingleColumn: e,
  ampm: t,
  timeSteps: n,
  views: r
}) {
  const i = e ?? 24, o = N({
    hours: 1,
    minutes: 5,
    seconds: 5
  }, n), s = aqe(o, i);
  return {
    thresholdToRenderTimeInASingleColumn: i,
    timeSteps: o,
    shouldRenderTimeInASingleColumn: s,
    views: sqe(t, r, s)
  };
}
const uH = /* @__PURE__ */ V.forwardRef(function(t, n) {
  var r, i, o, s, a, u;
  const c = Yi(), d = Nn(), f = oH(t, "MuiDesktopTimePicker"), {
    shouldRenderTimeInASingleColumn: h,
    views: m,
    timeSteps: v
  } = lH(f), x = h ? sH : nk, C = N({
    hours: x,
    minutes: x,
    seconds: x,
    meridiem: x
  }, f.viewRenderers), E = (r = f.ampmInClock) != null ? r : !0, S = h ? [] : ["accept"], O = ((i = C.hours) == null ? void 0 : i.name) === nk.name ? m : m.filter(($) => $ !== "meridiem"), A = N({}, f, {
    ampmInClock: E,
    timeSteps: v,
    viewRenderers: C,
    format: QD(d, f),
    // Setting only `hours` time view in case of single column time picker
    // Allows for easy view lifecycle management
    views: h ? ["hours"] : O,
    slots: N({
      field: o$,
      openPickerIcon: zVe
    }, f.slots),
    slotProps: N({}, f.slotProps, {
      field: ($) => {
        var L;
        return N({}, Id((L = f.slotProps) == null ? void 0 : L.field, $), mg(f), {
          ref: n
        });
      },
      toolbar: N({
        hidden: !0,
        ampmInClock: E
      }, (o = f.slotProps) == null ? void 0 : o.toolbar),
      actionBar: N({
        actions: S
      }, (s = f.slotProps) == null ? void 0 : s.actionBar)
    })
  }), {
    renderPicker: I
  } = l$({
    props: A,
    valueManager: qi,
    valueType: "time",
    getOpenDialogAriaText: (a = (u = A.localeText) == null ? void 0 : u.openTimePickerDialogue) != null ? a : c.openTimePickerDialogue,
    validator: QE
  });
  return I();
});
uH.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * 12h/24h view for hour selection clock.
   * @default `utils.is12HourCycleInCurrentLocale()`
   */
  ampm: l.bool,
  /**
   * Display ampm controls under the clock (instead of in the toolbar).
   * @default true on desktop, false on mobile
   */
  ampmInClock: l.bool,
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: l.bool,
  /**
   * Class name applied to the root element.
   */
  className: l.string,
  /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */
  closeOnSelect: l.bool,
  /**
   * Overridable components.
   * @default {}
   * @deprecated Please use `slots`.
   */
  components: l.object,
  /**
   * The props used for each component slot.
   * @default {}
   * @deprecated Please use `slotProps`.
   */
  componentsProps: l.object,
  /**
   * The default value.
   * Used when the component is not controlled.
   */
  defaultValue: l.any,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: l.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: l.bool,
  /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */
  disableIgnoringDatePartForTimeValidation: l.bool,
  /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */
  disableOpenPicker: l.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: l.bool,
  /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */
  format: l.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: l.oneOf(["dense", "spacious"]),
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: wr,
  /**
   * The label content.
   */
  label: l.node,
  /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */
  localeText: l.object,
  /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  maxTime: l.any,
  /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  minTime: l.any,
  /**
   * Step over minutes.
   * @default 1
   */
  minutesStep: l.number,
  /**
   * Name attribute used by the `input` element in the Field.
   */
  name: l.string,
  /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   */
  onAccept: l.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: l.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */
  onClose: l.func,
  /**
   * Callback fired when the error associated to the current value changes.
   * If the error has a non-null value, then the `TextField` will be rendered in `error` state.
   *
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error describing why the current value is not valid.
   * @param {TValue} value The value associated to the error.
   */
  onError: l.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */
  onOpen: l.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: l.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: l.func,
  /**
   * Control the popup or dialog open state.
   * @default false
   */
  open: l.bool,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: l.oneOf(["hours", "meridiem", "minutes", "seconds"]),
  /**
   * Force rendering in particular orientation.
   */
  orientation: l.oneOf(["landscape", "portrait"]),
  readOnly: l.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: l.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */
  referenceDate: l.any,
  /**
   * The currently selected sections.
   * This prop accept four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If an object with a `startIndex` and `endIndex` properties are provided, the sections between those two indexes will be selected.
   * 3. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 4. If `null` is provided, no section will be selected
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: l.oneOfType([l.oneOf(["all", "day", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), l.number, l.shape({
    endIndex: l.number.isRequired,
    startIndex: l.number.isRequired
  })]),
  /**
   * Disable specific clock time.
   * @param {number} clockValue The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   * @deprecated Consider using `shouldDisableTime`.
   */
  shouldDisableClock: l.func,
  /**
   * Disable specific time.
   * @template TDate
   * @param {TDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */
  shouldDisableTime: l.func,
  /**
   * If `true`, disabled digital clock items will not be rendered.
   * @default false
   */
  skipDisabled: l.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: l.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: l.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * Amount of time options below or at which the single column time renderer is used.
   * @default 24
   */
  thresholdToRenderTimeInASingleColumn: l.number,
  /**
   * The time steps between two time unit options.
   * For example, if `timeStep.minutes = 8`, then the available minute options will be `[0, 8, 16, 24, 32, 40, 48, 56]`.
   * When single column time renderer is used, only `timeStep.minutes` will be used.
   * @default{ hours: 1, minutes: 5, seconds: 5 }
   */
  timeSteps: l.shape({
    hours: l.number,
    minutes: l.number,
    seconds: l.number
  }),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documention} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: l.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: l.any,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: l.oneOf(["hours", "meridiem", "minutes", "seconds"]),
  /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be the used.
   */
  viewRenderers: l.shape({
    hours: l.func,
    meridiem: l.func,
    minutes: l.func,
    seconds: l.func
  }),
  /**
   * Available views.
   */
  views: l.arrayOf(l.oneOf(["hours", "minutes", "seconds"]).isRequired)
};
const cH = /* @__PURE__ */ V.forwardRef(function(t, n) {
  var r, i, o, s;
  const a = Yi(), u = Nn(), c = oH(t, "MuiMobileTimePicker"), d = N({
    hours: Jh,
    minutes: Jh,
    seconds: Jh
  }, c.viewRenderers), f = (r = c.ampmInClock) != null ? r : !1, h = N({}, c, {
    ampmInClock: f,
    viewRenderers: d,
    format: QD(u, c),
    slots: N({
      field: o$
    }, c.slots),
    slotProps: N({}, c.slotProps, {
      field: (v) => {
        var x;
        return N({}, Id((x = c.slotProps) == null ? void 0 : x.field, v), mg(c), {
          ref: n
        });
      },
      toolbar: N({
        hidden: !1,
        ampmInClock: f
      }, (i = c.slotProps) == null ? void 0 : i.toolbar)
    })
  }), {
    renderPicker: m
  } = u$({
    props: h,
    valueManager: qi,
    valueType: "time",
    getOpenDialogAriaText: (o = (s = h.localeText) == null ? void 0 : s.openTimePickerDialogue) != null ? o : a.openTimePickerDialogue,
    validator: QE
  });
  return m();
});
cH.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * 12h/24h view for hour selection clock.
   * @default `utils.is12HourCycleInCurrentLocale()`
   */
  ampm: l.bool,
  /**
   * Display ampm controls under the clock (instead of in the toolbar).
   * @default true on desktop, false on mobile
   */
  ampmInClock: l.bool,
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: l.bool,
  /**
   * Class name applied to the root element.
   */
  className: l.string,
  /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */
  closeOnSelect: l.bool,
  /**
   * Overridable components.
   * @default {}
   * @deprecated Please use `slots`.
   */
  components: l.object,
  /**
   * The props used for each component slot.
   * @default {}
   * @deprecated Please use `slotProps`.
   */
  componentsProps: l.object,
  /**
   * The default value.
   * Used when the component is not controlled.
   */
  defaultValue: l.any,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: l.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: l.bool,
  /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */
  disableIgnoringDatePartForTimeValidation: l.bool,
  /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */
  disableOpenPicker: l.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: l.bool,
  /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */
  format: l.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: l.oneOf(["dense", "spacious"]),
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: wr,
  /**
   * The label content.
   */
  label: l.node,
  /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */
  localeText: l.object,
  /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  maxTime: l.any,
  /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  minTime: l.any,
  /**
   * Step over minutes.
   * @default 1
   */
  minutesStep: l.number,
  /**
   * Name attribute used by the `input` element in the Field.
   */
  name: l.string,
  /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   */
  onAccept: l.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: l.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */
  onClose: l.func,
  /**
   * Callback fired when the error associated to the current value changes.
   * If the error has a non-null value, then the `TextField` will be rendered in `error` state.
   *
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error describing why the current value is not valid.
   * @param {TValue} value The value associated to the error.
   */
  onError: l.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */
  onOpen: l.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: l.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: l.func,
  /**
   * Control the popup or dialog open state.
   * @default false
   */
  open: l.bool,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: l.oneOf(["hours", "minutes", "seconds"]),
  /**
   * Force rendering in particular orientation.
   */
  orientation: l.oneOf(["landscape", "portrait"]),
  readOnly: l.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: l.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */
  referenceDate: l.any,
  /**
   * The currently selected sections.
   * This prop accept four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If an object with a `startIndex` and `endIndex` properties are provided, the sections between those two indexes will be selected.
   * 3. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 4. If `null` is provided, no section will be selected
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: l.oneOfType([l.oneOf(["all", "day", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), l.number, l.shape({
    endIndex: l.number.isRequired,
    startIndex: l.number.isRequired
  })]),
  /**
   * Disable specific clock time.
   * @param {number} clockValue The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   * @deprecated Consider using `shouldDisableTime`.
   */
  shouldDisableClock: l.func,
  /**
   * Disable specific time.
   * @template TDate
   * @param {TDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */
  shouldDisableTime: l.func,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: l.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: l.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documention} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: l.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: l.any,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: l.oneOf(["hours", "minutes", "seconds"]),
  /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be the used.
   */
  viewRenderers: l.shape({
    hours: l.func,
    minutes: l.func,
    seconds: l.func
  }),
  /**
   * Available views.
   */
  views: l.arrayOf(l.oneOf(["hours", "minutes", "seconds"]).isRequired)
};
const lqe = ["desktopModeMediaQuery"], dH = /* @__PURE__ */ V.forwardRef(function(t, n) {
  const r = Vn({
    props: t,
    name: "MuiTimePicker"
  }), {
    desktopModeMediaQuery: i = JF
  } = r, o = _e(r, lqe);
  return PE(i, {
    defaultMatches: !0
  }) ? /* @__PURE__ */ P.jsx(uH, N({
    ref: n
  }, o)) : /* @__PURE__ */ P.jsx(cH, N({
    ref: n
  }, o));
});
process.env.NODE_ENV !== "production" && (dH.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * 12h/24h view for hour selection clock.
   * @default `utils.is12HourCycleInCurrentLocale()`
   */
  ampm: l.bool,
  /**
   * Display ampm controls under the clock (instead of in the toolbar).
   * @default true on desktop, false on mobile
   */
  ampmInClock: l.bool,
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: l.bool,
  /**
   * Class name applied to the root element.
   */
  className: l.string,
  /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */
  closeOnSelect: l.bool,
  /**
   * Overridable components.
   * @default {}
   * @deprecated Please use `slots`.
   */
  components: l.object,
  /**
   * The props used for each component slot.
   * @default {}
   * @deprecated Please use `slotProps`.
   */
  componentsProps: l.object,
  /**
   * The default value.
   * Used when the component is not controlled.
   */
  defaultValue: l.any,
  /**
   * CSS media query when `Mobile` mode will be changed to `Desktop`.
   * @default '@media (pointer: fine)'
   * @example '@media (min-width: 720px)' or theme.breakpoints.up("sm")
   */
  desktopModeMediaQuery: l.string,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: l.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: l.bool,
  /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */
  disableIgnoringDatePartForTimeValidation: l.bool,
  /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */
  disableOpenPicker: l.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: l.bool,
  /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */
  format: l.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: l.oneOf(["dense", "spacious"]),
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: wr,
  /**
   * The label content.
   */
  label: l.node,
  /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */
  localeText: l.object,
  /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  maxTime: l.any,
  /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  minTime: l.any,
  /**
   * Step over minutes.
   * @default 1
   */
  minutesStep: l.number,
  /**
   * Name attribute used by the `input` element in the Field.
   */
  name: l.string,
  /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   */
  onAccept: l.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: l.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */
  onClose: l.func,
  /**
   * Callback fired when the error associated to the current value changes.
   * If the error has a non-null value, then the `TextField` will be rendered in `error` state.
   *
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error describing why the current value is not valid.
   * @param {TValue} value The value associated to the error.
   */
  onError: l.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */
  onOpen: l.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: l.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: l.func,
  /**
   * Control the popup or dialog open state.
   * @default false
   */
  open: l.bool,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: l.oneOf(["hours", "meridiem", "minutes", "seconds"]),
  /**
   * Force rendering in particular orientation.
   */
  orientation: l.oneOf(["landscape", "portrait"]),
  readOnly: l.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: l.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */
  referenceDate: l.any,
  /**
   * The currently selected sections.
   * This prop accept four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If an object with a `startIndex` and `endIndex` properties are provided, the sections between those two indexes will be selected.
   * 3. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 4. If `null` is provided, no section will be selected
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: l.oneOfType([l.oneOf(["all", "day", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), l.number, l.shape({
    endIndex: l.number.isRequired,
    startIndex: l.number.isRequired
  })]),
  /**
   * Disable specific clock time.
   * @param {number} clockValue The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   * @deprecated Consider using `shouldDisableTime`.
   */
  shouldDisableClock: l.func,
  /**
   * Disable specific time.
   * @template TDate
   * @param {TDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */
  shouldDisableTime: l.func,
  /**
   * If `true`, disabled digital clock items will not be rendered.
   * @default false
   */
  skipDisabled: l.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: l.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: l.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * Amount of time options below or at which the single column time renderer is used.
   * @default 24
   */
  thresholdToRenderTimeInASingleColumn: l.number,
  /**
   * The time steps between two time unit options.
   * For example, if `timeStep.minutes = 8`, then the available minute options will be `[0, 8, 16, 24, 32, 40, 48, 56]`.
   * When single column time renderer is used, only `timeStep.minutes` will be used.
   * @default{ hours: 1, minutes: 5, seconds: 5 }
   */
  timeSteps: l.shape({
    hours: l.number,
    minutes: l.number,
    seconds: l.number
  }),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documention} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: l.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: l.any,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: l.oneOf(["hours", "meridiem", "minutes", "seconds"]),
  /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be the used.
   */
  viewRenderers: l.shape({
    hours: l.func,
    meridiem: l.func,
    minutes: l.func,
    seconds: l.func
  }),
  /**
   * Available views.
   */
  views: l.arrayOf(l.oneOf(["hours", "minutes", "seconds"]).isRequired)
});
function uqe(e) {
  return ot("MuiDateTimePickerTabs", e);
}
st("MuiDateTimePickerTabs", ["root"]);
const cqe = (e) => Yh(e) ? "date" : "time", dqe = (e) => e === "date" ? "day" : "hours", pqe = (e) => {
  const {
    classes: t
  } = e;
  return at({
    root: ["root"]
  }, uqe, t);
}, fqe = De(fg, {
  name: "MuiDateTimePickerTabs",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e
}) => ({
  boxShadow: `0 -1px 0 0 inset ${(e.vars || e).palette.divider}`,
  "&:last-child": {
    boxShadow: `0 1px 0 0 inset ${(e.vars || e).palette.divider}`,
    [`& .${eD.indicator}`]: {
      bottom: "auto",
      top: 0
    }
  }
})), pH = function(t) {
  const n = Vn({
    props: t,
    name: "MuiDateTimePickerTabs"
  }), {
    dateIcon: r = /* @__PURE__ */ P.jsx(UVe, {}),
    onViewChange: i,
    timeIcon: o = /* @__PURE__ */ P.jsx(WVe, {}),
    view: s,
    hidden: a = typeof window > "u" || window.innerHeight < 667,
    className: u,
    sx: c
  } = n, d = Yi(), f = pqe(n), h = (m, v) => {
    i(dqe(v));
  };
  return a ? null : /* @__PURE__ */ P.jsxs(fqe, {
    ownerState: n,
    variant: "fullWidth",
    value: cqe(s),
    onChange: h,
    className: Be(u, f.root),
    sx: c,
    children: [/* @__PURE__ */ P.jsx(pd, {
      value: "date",
      "aria-label": d.dateTableLabel,
      icon: /* @__PURE__ */ P.jsx(V.Fragment, {
        children: r
      })
    }), /* @__PURE__ */ P.jsx(pd, {
      value: "time",
      "aria-label": d.timeTableLabel,
      icon: /* @__PURE__ */ P.jsx(V.Fragment, {
        children: o
      })
    })]
  });
};
process.env.NODE_ENV !== "production" && (pH.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  className: l.string,
  /**
   * Date tab icon.
   * @default DateRange
   */
  dateIcon: l.node,
  /**
   * Toggles visibility of the tabs allowing view switching.
   * @default `window.innerHeight < 667` for `DesktopDateTimePicker` and `MobileDateTimePicker`, `displayStaticWrapperAs === 'desktop'` for `StaticDateTimePicker`
   */
  hidden: l.bool,
  /**
   * Callback called when a tab is clicked
   * @template TView
   * @param {TView} view The view to open
   */
  onViewChange: l.func.isRequired,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * Time tab icon.
   * @default Time
   */
  timeIcon: l.node,
  /**
   * Currently visible picker view.
   */
  view: l.oneOf(["day", "hours", "meridiem", "minutes", "month", "seconds", "year"]).isRequired
});
function hqe(e) {
  return ot("MuiDateTimePickerToolbar", e);
}
const ow = st("MuiDateTimePickerToolbar", ["root", "dateContainer", "timeContainer", "timeDigitsContainer", "separator", "timeLabelReverse", "ampmSelection", "ampmLandscape", "ampmLabel"]), mqe = ["ampm", "ampmInClock", "value", "onChange", "view", "isLandscape", "onViewChange", "toolbarFormat", "toolbarPlaceholder", "views", "disabled", "readOnly", "toolbarVariant"], gqe = (e) => {
  const {
    classes: t,
    theme: n,
    isLandscape: r
  } = e, i = {
    root: ["root"],
    dateContainer: ["dateContainer"],
    timeContainer: ["timeContainer", n.direction === "rtl" && "timeLabelReverse"],
    timeDigitsContainer: ["timeDigitsContainer", n.direction === "rtl" && "timeLabelReverse"],
    separator: ["separator"],
    ampmSelection: ["ampmSelection", r && "ampmLandscape"],
    ampmLabel: ["ampmLabel"]
  };
  return at(i, hqe, t);
}, fH = De(ZF, {
  name: "MuiDateTimePickerToolbar",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e,
  ownerState: t
}) => ({
  paddingLeft: t.toolbarVariant === "desktop" && !t.isLandscape ? 24 : 16,
  paddingRight: t.toolbarVariant === "desktop" && !t.isLandscape ? 0 : 16,
  borderBottom: t.toolbarVariant === "desktop" ? `1px solid ${(e.vars || e).palette.divider}` : void 0,
  borderRight: t.toolbarVariant === "desktop" && t.isLandscape ? `1px solid ${(e.vars || e).palette.divider}` : void 0,
  justifyContent: "space-around",
  position: "relative"
}));
fH.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  as: l.elementType,
  classes: l.object,
  className: l.string,
  isLandscape: l.bool.isRequired,
  isMobileKeyboardViewOpen: l.bool,
  landscapeDirection: l.oneOf(["column", "row"]),
  ownerState: l.object.isRequired,
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  toggleMobileKeyboardView: l.func,
  toolbarTitle: l.node,
  viewType: l.oneOf(["date", "time"])
};
const yqe = De("div", {
  name: "MuiDateTimePickerToolbar",
  slot: "DateContainer",
  overridesResolver: (e, t) => t.dateContainer
})({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start"
}), hH = De("div", {
  name: "MuiDateTimePickerToolbar",
  slot: "TimeContainer",
  overridesResolver: (e, t) => t.timeContainer
})(({
  theme: e,
  ownerState: t
}) => {
  const n = t.isLandscape && t.toolbarVariant !== "desktop" ? "column" : "row";
  return N({
    display: "flex",
    flexDirection: n
  }, t.toolbarVariant === "desktop" && N({}, !t.isLandscape && {
    gap: 9,
    marginRight: 4,
    alignSelf: "flex-end"
  }), e.direction === "rtl" && {
    flexDirection: `${n}-reverse`
  });
}), bqe = De("div", {
  name: "MuiDateTimePickerToolbar",
  slot: "TimeDigitsContainer",
  overridesResolver: (e, t) => t.timeDigitsContainer
})(({
  theme: e,
  ownerState: t
}) => N({
  display: "flex"
}, t.toolbarVariant === "desktop" && {
  gap: 1.5
}, e.direction === "rtl" && {
  flexDirection: "row-reverse"
}));
hH.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  as: l.elementType,
  ownerState: l.object.isRequired,
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object])
};
const xj = De(e$, {
  name: "MuiDateTimePickerToolbar",
  slot: "Separator",
  overridesResolver: (e, t) => t.separator
})(({
  ownerState: e
}) => ({
  margin: e.toolbarVariant === "desktop" ? 0 : "0 4px 0 2px",
  cursor: "default"
})), vqe = De("div", {
  name: "MuiDateTimePickerToolbar",
  slot: "AmPmSelection",
  overridesResolver: (e, t) => [{
    [`.${ow.ampmLabel}`]: t.ampmLabel
  }, {
    [`&.${ow.ampmLandscape}`]: t.ampmLandscape
  }, t.ampmSelection]
})(({
  ownerState: e
}) => N({
  display: "flex",
  flexDirection: "column",
  marginRight: "auto",
  marginLeft: 12
}, e.isLandscape && {
  margin: "4px 0 auto",
  flexDirection: "row",
  justifyContent: "space-around",
  width: "100%"
}, {
  [`& .${ow.ampmLabel}`]: {
    fontSize: 17
  }
}));
function mH(e) {
  const t = Vn({
    props: e,
    name: "MuiDateTimePickerToolbar"
  }), {
    ampm: n,
    ampmInClock: r,
    value: i,
    onChange: o,
    view: s,
    isLandscape: a,
    onViewChange: u,
    toolbarFormat: c,
    toolbarPlaceholder: d = "––",
    views: f,
    disabled: h,
    readOnly: m,
    toolbarVariant: v = "mobile"
  } = t, x = _e(t, mqe), C = t, E = Nn(), {
    meridiemMode: S,
    handleMeridiemChange: w
  } = qE(i, n, o), O = !!(n && !r), A = v === "desktop", I = Yi(), $ = Gi(), L = gqe(N({}, C, {
    theme: $
  })), B = (q) => n ? E.format(q, "hours12h") : E.format(q, "hours24h"), H = V.useMemo(() => i ? c ? E.formatByString(i, c) : E.format(i, "shortDate") : d, [i, c, d, E]);
  return /* @__PURE__ */ P.jsxs(fH, N({
    toolbarTitle: I.dateTimePickerToolbarTitle,
    isLandscape: a,
    className: L.root
  }, x, {
    ownerState: C,
    children: [/* @__PURE__ */ P.jsxs(yqe, {
      className: L.dateContainer,
      ownerState: C,
      children: [f.includes("year") && /* @__PURE__ */ P.jsx(Js, {
        tabIndex: -1,
        variant: "subtitle1",
        onClick: () => u("year"),
        selected: s === "year",
        value: i ? E.format(i, "year") : "–"
      }), f.includes("day") && /* @__PURE__ */ P.jsx(Js, {
        tabIndex: -1,
        variant: A ? "h5" : "h4",
        onClick: () => u("day"),
        selected: s === "day",
        value: H
      })]
    }), /* @__PURE__ */ P.jsxs(hH, {
      className: L.timeContainer,
      ownerState: C,
      children: [/* @__PURE__ */ P.jsxs(bqe, {
        className: L.timeDigitsContainer,
        ownerState: C,
        children: [f.includes("hours") && /* @__PURE__ */ P.jsx(Js, {
          variant: A ? "h5" : "h3",
          width: A && !a ? Gy : void 0,
          onClick: () => u("hours"),
          selected: s === "hours",
          value: i ? B(i) : "--"
        }), f.includes("minutes") && /* @__PURE__ */ P.jsxs(V.Fragment, {
          children: [/* @__PURE__ */ P.jsx(xj, {
            variant: A ? "h5" : "h3",
            value: ":",
            className: L.separator,
            ownerState: C
          }), /* @__PURE__ */ P.jsx(Js, {
            variant: A ? "h5" : "h3",
            width: A && !a ? Gy : void 0,
            onClick: () => u("minutes"),
            selected: s === "minutes",
            value: i ? E.format(i, "minutes") : "--"
          })]
        }), f.includes("seconds") && /* @__PURE__ */ P.jsxs(V.Fragment, {
          children: [/* @__PURE__ */ P.jsx(xj, {
            variant: A ? "h5" : "h3",
            value: ":",
            className: L.separator,
            ownerState: C
          }), /* @__PURE__ */ P.jsx(Js, {
            variant: A ? "h5" : "h3",
            width: A && !a ? Gy : void 0,
            onClick: () => u("seconds"),
            selected: s === "seconds",
            value: i ? E.format(i, "seconds") : "--"
          })]
        })]
      }), O && !A && /* @__PURE__ */ P.jsxs(vqe, {
        className: L.ampmSelection,
        ownerState: C,
        children: [/* @__PURE__ */ P.jsx(Js, {
          variant: "subtitle2",
          selected: S === "am",
          typographyClassName: L.ampmLabel,
          value: ml(E, "am"),
          onClick: m ? void 0 : () => w("am"),
          disabled: h
        }), /* @__PURE__ */ P.jsx(Js, {
          variant: "subtitle2",
          selected: S === "pm",
          typographyClassName: L.ampmLabel,
          value: ml(E, "pm"),
          onClick: m ? void 0 : () => w("pm"),
          disabled: h
        })]
      }), n && A && /* @__PURE__ */ P.jsx(Js, {
        variant: "h5",
        onClick: () => u("meridiem"),
        selected: s === "meridiem",
        value: i && S ? ml(E, S) : "--",
        width: Gy
      })]
    })]
  }));
}
process.env.NODE_ENV !== "production" && (mH.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  ampm: l.bool,
  ampmInClock: l.bool,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: l.object,
  /**
   * className applied to the root component.
   */
  className: l.string,
  disabled: l.bool,
  /**
   * If `true`, show the toolbar even in desktop mode.
   * @default `true` for Desktop, `false` for Mobile.
   */
  hidden: l.bool,
  isLandscape: l.bool.isRequired,
  onChange: l.func.isRequired,
  /**
   * Callback called when a toolbar is clicked
   * @template TView
   * @param {TView} view The view to open
   */
  onViewChange: l.func.isRequired,
  readOnly: l.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  titleId: l.string,
  /**
   * Toolbar date format.
   */
  toolbarFormat: l.string,
  /**
   * Toolbar value placeholder—it is displayed when the value is empty.
   * @default "––"
   */
  toolbarPlaceholder: l.node,
  toolbarVariant: l.oneOf(["desktop", "mobile"]),
  value: l.any,
  /**
   * Currently visible picker view.
   */
  view: l.oneOf(["day", "hours", "meridiem", "minutes", "month", "seconds", "year"]).isRequired,
  views: l.arrayOf(l.oneOf(["day", "hours", "meridiem", "minutes", "month", "seconds", "year"]).isRequired).isRequired
});
function gH(e, t) {
  var n, r, i, o, s, a, u, c, d, f, h;
  const m = Nn(), v = Df(), x = Vn({
    props: e,
    name: t
  }), C = (n = x.ampm) != null ? n : m.is12HourCycleInCurrentLocale(), E = V.useMemo(() => {
    var O;
    return ((O = x.localeText) == null ? void 0 : O.toolbarTitle) == null ? x.localeText : N({}, x.localeText, {
      dateTimePickerToolbarTitle: x.localeText.toolbarTitle
    });
  }, [x.localeText]), S = (r = x.slots) != null ? r : cv(x.components), w = (i = x.slotProps) != null ? i : x.componentsProps;
  return N({}, x, zF({
    views: x.views,
    openTo: x.openTo,
    defaultViews: ["year", "day", "hours", "minutes"],
    defaultOpenTo: "day"
  }), {
    ampm: C,
    localeText: E,
    orientation: (o = x.orientation) != null ? o : "portrait",
    // TODO: Remove from public API
    disableIgnoringDatePartForTimeValidation: (s = x.disableIgnoringDatePartForTimeValidation) != null ? s : !!(x.minDateTime || x.maxDateTime || // allow time clock to correctly check time validity: https://github.com/mui/mui-x/issues/8520
    x.disablePast || x.disableFuture),
    disableFuture: (a = x.disableFuture) != null ? a : !1,
    disablePast: (u = x.disablePast) != null ? u : !1,
    minDate: Lo(m, (c = x.minDateTime) != null ? c : x.minDate, v.minDate),
    maxDate: Lo(m, (d = x.maxDateTime) != null ? d : x.maxDate, v.maxDate),
    minTime: (f = x.minDateTime) != null ? f : x.minTime,
    maxTime: (h = x.maxDateTime) != null ? h : x.maxTime,
    slots: N({
      toolbar: mH,
      tabs: pH
    }, S),
    slotProps: N({}, w, {
      toolbar: N({
        ampm: C
      }, w == null ? void 0 : w.toolbar)
    })
  });
}
const xqe = De("div")({
  display: "flex",
  margin: "0 auto"
}), dp = ({
  view: e,
  onViewChange: t,
  views: n,
  focusedView: r,
  onFocusedViewChange: i,
  value: o,
  defaultValue: s,
  referenceDate: a,
  onChange: u,
  className: c,
  classes: d,
  disableFuture: f,
  disablePast: h,
  minDate: m,
  minTime: v,
  maxDate: x,
  maxTime: C,
  shouldDisableDate: E,
  shouldDisableMonth: S,
  shouldDisableYear: w,
  shouldDisableTime: O,
  shouldDisableClock: A,
  reduceAnimations: I,
  minutesStep: $,
  ampm: L,
  onMonthChange: B,
  monthsPerRow: H,
  onYearChange: q,
  yearsPerRow: J,
  defaultCalendarMonth: X,
  components: j,
  componentsProps: U,
  slots: G,
  slotProps: K,
  loading: ee,
  renderLoading: te,
  disableHighlightToday: M,
  readOnly: Z,
  disabled: ne,
  showDaysOutsideCurrentMonth: R,
  dayOfWeekFormatter: _,
  sx: W,
  autoFocus: Q,
  fixedWeekNumber: oe,
  displayWeekNumber: ae,
  timezone: pe,
  disableIgnoringDatePartForTimeValidation: me,
  timeSteps: xe,
  skipDisabled: le,
  timeViewsCount: ye,
  shouldRenderTimeInASingleColumn: be
}) => {
  var Re, Te;
  const Xe = !!((Re = Id((Te = K == null ? void 0 : K.actionBar) != null ? Te : U == null ? void 0 : U.actionBar, {})) != null && (Re = Re.actions) != null && Re.length), Ne = {
    view: Kc(e) ? e : "hours",
    onViewChange: t,
    focusedView: r && Kc(r) ? r : null,
    onFocusedViewChange: i,
    views: n.filter(Kc),
    value: o,
    defaultValue: s,
    referenceDate: a,
    onChange: u,
    className: c,
    classes: d,
    disableFuture: f,
    disablePast: h,
    minTime: v,
    maxTime: C,
    shouldDisableTime: O,
    shouldDisableClock: A,
    minutesStep: $,
    ampm: L,
    components: j,
    componentsProps: U,
    slots: G,
    slotProps: K,
    readOnly: Z,
    disabled: ne,
    autoFocus: Q,
    disableIgnoringDatePartForTimeValidation: me,
    timeSteps: xe,
    skipDisabled: le,
    timezone: pe
  };
  return /* @__PURE__ */ P.jsxs(V.Fragment, {
    children: [/* @__PURE__ */ P.jsxs(xqe, {
      children: [/* @__PURE__ */ P.jsx(a$, {
        view: Yh(e) ? e : "day",
        onViewChange: t,
        views: n.filter(Yh),
        focusedView: r && Yh(r) ? r : null,
        onFocusedViewChange: i,
        value: o,
        defaultValue: s,
        referenceDate: a,
        onChange: u,
        className: c,
        classes: d,
        disableFuture: f,
        disablePast: h,
        minDate: m,
        maxDate: x,
        shouldDisableDate: E,
        shouldDisableMonth: S,
        shouldDisableYear: w,
        reduceAnimations: I,
        onMonthChange: B,
        monthsPerRow: H,
        onYearChange: q,
        yearsPerRow: J,
        defaultCalendarMonth: X,
        components: j,
        componentsProps: U,
        slots: G,
        slotProps: K,
        loading: ee,
        renderLoading: te,
        disableHighlightToday: M,
        readOnly: Z,
        disabled: ne,
        showDaysOutsideCurrentMonth: R,
        dayOfWeekFormatter: _,
        sx: W,
        autoFocus: Q,
        fixedWeekNumber: oe,
        displayWeekNumber: ae,
        timezone: pe
      }), ye > 0 && /* @__PURE__ */ P.jsxs(V.Fragment, {
        children: [/* @__PURE__ */ P.jsx(U0, {
          orientation: "vertical"
        }), be ? sH(N({}, Ne, {
          view: "hours",
          views: ["hours"],
          focusedView: r && Kc(r) ? "hours" : null,
          sx: N({
            width: "auto",
            [`&.${eUe.root}`]: {
              maxHeight: KE
            }
          }, Array.isArray(W) ? W : [W])
        })) : nk(N({}, Ne, {
          view: Kc(e) ? e : "hours",
          views: n.filter(Kc),
          focusedView: r && Kc(r) ? r : null,
          sx: N({
            borderBottom: 0,
            width: "auto",
            [`.${lUe.root}`]: {
              maxHeight: "100%"
            }
          }, Array.isArray(W) ? W : [W])
        }))]
      })]
    }), Xe && /* @__PURE__ */ P.jsx(U0, {})]
  });
}, yH = /* @__PURE__ */ V.forwardRef(function(t, n) {
  var r, i, o, s, a, u, c;
  const d = Yi(), f = Nn(), h = gH(t, "MuiDesktopDateTimePicker"), {
    shouldRenderTimeInASingleColumn: m,
    thresholdToRenderTimeInASingleColumn: v,
    views: x,
    timeSteps: C
  } = lH(h), E = !h.viewRenderers || Object.keys(h.viewRenderers).length === 0, S = (
    // we can only ensure the expected two-column layout if none of the renderers are overridden
    E ? {
      day: dp,
      month: dp,
      year: dp,
      hours: dp,
      minutes: dp,
      seconds: dp,
      meridiem: dp
    } : N({
      day: Ra,
      month: Ra,
      year: Ra,
      hours: null,
      minutes: null,
      seconds: null,
      meridiem: null
    }, h.viewRenderers)
  ), w = (r = h.ampmInClock) != null ? r : !0, O = E ? ["accept"] : [], A = N({}, h, {
    viewRenderers: S,
    format: aH(f, h),
    views: x,
    yearsPerRow: (i = h.yearsPerRow) != null ? i : 4,
    ampmInClock: w,
    timeSteps: C,
    thresholdToRenderTimeInASingleColumn: v,
    shouldRenderTimeInASingleColumn: m,
    slots: N({
      field: s$,
      openPickerIcon: yW
    }, h.slots),
    slotProps: N({}, h.slotProps, {
      field: ($) => {
        var L;
        return N({}, Id((L = h.slotProps) == null ? void 0 : L.field, $), mg(h), {
          ref: n
        });
      },
      toolbar: N({
        hidden: !0,
        ampmInClock: w,
        toolbarVariant: E ? "desktop" : "mobile"
      }, (o = h.slotProps) == null ? void 0 : o.toolbar),
      tabs: N({
        hidden: !0
      }, (s = h.slotProps) == null ? void 0 : s.tabs),
      actionBar: N({
        actions: O
      }, (a = h.slotProps) == null ? void 0 : a.actionBar)
    })
  }), {
    renderPicker: I
  } = l$({
    props: A,
    valueManager: qi,
    valueType: "date-time",
    getOpenDialogAriaText: (u = (c = A.localeText) == null ? void 0 : c.openDatePickerDialogue) != null ? u : d.openDatePickerDialogue,
    validator: n$
  });
  return I();
});
yH.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * 12h/24h view for hour selection clock.
   * @default `utils.is12HourCycleInCurrentLocale()`
   */
  ampm: l.bool,
  /**
   * Display ampm controls under the clock (instead of in the toolbar).
   * @default true on desktop, false on mobile
   */
  ampmInClock: l.bool,
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: l.bool,
  /**
   * Class name applied to the root element.
   */
  className: l.string,
  /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */
  closeOnSelect: l.bool,
  /**
   * Overridable components.
   * @default {}
   * @deprecated Please use `slots`.
   */
  components: l.object,
  /**
   * The props used for each component slot.
   * @default {}
   * @deprecated Please use `slotProps`.
   */
  componentsProps: l.object,
  /**
   * Formats the day of week displayed in the calendar header.
   * @param {string} day The day of week provided by the adapter.  Deprecated, will be removed in v7: Use `date` instead.
   * @param {TDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (_day: string, date: TDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */
  dayOfWeekFormatter: l.func,
  /**
   * Default calendar month displayed when `value` and `defaultValue` are empty.
   * @deprecated Consider using `referenceDate` instead.
   */
  defaultCalendarMonth: l.any,
  /**
   * The default value.
   * Used when the component is not controlled.
   */
  defaultValue: l.any,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: l.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: l.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: l.bool,
  /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */
  disableIgnoringDatePartForTimeValidation: l.bool,
  /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */
  disableOpenPicker: l.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: l.bool,
  /**
   * If `true`, the week number will be display in the calendar.
   */
  displayWeekNumber: l.bool,
  /**
   * Calendar will show more weeks in order to match this value.
   * Put it to 6 for having fix number of week in Gregorian calendars
   * @default undefined
   */
  fixedWeekNumber: l.number,
  /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */
  format: l.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: l.oneOf(["dense", "spacious"]),
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: wr,
  /**
   * The label content.
   */
  label: l.node,
  /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */
  loading: l.bool,
  /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */
  localeText: l.object,
  /**
   * Maximal selectable date.
   */
  maxDate: l.any,
  /**
   * Maximal selectable moment of time with binding to date, to set max time in each day use `maxTime`.
   */
  maxDateTime: l.any,
  /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  maxTime: l.any,
  /**
   * Minimal selectable date.
   */
  minDate: l.any,
  /**
   * Minimal selectable moment of time with binding to date, to set min time in each day use `minTime`.
   */
  minDateTime: l.any,
  /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  minTime: l.any,
  /**
   * Step over minutes.
   * @default 1
   */
  minutesStep: l.number,
  /**
   * Months rendered per row.
   * @default 3
   */
  monthsPerRow: l.oneOf([3, 4]),
  /**
   * Name attribute used by the `input` element in the Field.
   */
  name: l.string,
  /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   */
  onAccept: l.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: l.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */
  onClose: l.func,
  /**
   * Callback fired when the error associated to the current value changes.
   * If the error has a non-null value, then the `TextField` will be rendered in `error` state.
   *
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error describing why the current value is not valid.
   * @param {TValue} value The value associated to the error.
   */
  onError: l.func,
  /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */
  onMonthChange: l.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */
  onOpen: l.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: l.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: l.func,
  /**
   * Callback fired on year change.
   * @template TDate
   * @param {TDate} year The new year.
   */
  onYearChange: l.func,
  /**
   * Control the popup or dialog open state.
   * @default false
   */
  open: l.bool,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: l.oneOf(["day", "hours", "meridiem", "minutes", "month", "seconds", "year"]),
  /**
   * Force rendering in particular orientation.
   */
  orientation: l.oneOf(["landscape", "portrait"]),
  readOnly: l.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: l.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */
  referenceDate: l.any,
  /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span data-mui-test="loading-progress">...</span>
   */
  renderLoading: l.func,
  /**
   * The currently selected sections.
   * This prop accept four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If an object with a `startIndex` and `endIndex` properties are provided, the sections between those two indexes will be selected.
   * 3. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 4. If `null` is provided, no section will be selected
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: l.oneOfType([l.oneOf(["all", "day", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), l.number, l.shape({
    endIndex: l.number.isRequired,
    startIndex: l.number.isRequired
  })]),
  /**
   * Disable specific clock time.
   * @param {number} clockValue The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   * @deprecated Consider using `shouldDisableTime`.
   */
  shouldDisableClock: l.func,
  /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (e.g. when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */
  shouldDisableDate: l.func,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: l.func,
  /**
   * Disable specific time.
   * @template TDate
   * @param {TDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */
  shouldDisableTime: l.func,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: l.func,
  /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */
  showDaysOutsideCurrentMonth: l.bool,
  /**
   * If `true`, disabled digital clock items will not be rendered.
   * @default false
   */
  skipDisabled: l.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: l.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: l.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * Amount of time options below or at which the single column time renderer is used.
   * @default 24
   */
  thresholdToRenderTimeInASingleColumn: l.number,
  /**
   * The time steps between two time unit options.
   * For example, if `timeStep.minutes = 8`, then the available minute options will be `[0, 8, 16, 24, 32, 40, 48, 56]`.
   * When single column time renderer is used, only `timeStep.minutes` will be used.
   * @default{ hours: 1, minutes: 5, seconds: 5 }
   */
  timeSteps: l.shape({
    hours: l.number,
    minutes: l.number,
    seconds: l.number
  }),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documention} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: l.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: l.any,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: l.oneOf(["day", "hours", "meridiem", "minutes", "month", "seconds", "year"]),
  /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be the used.
   */
  viewRenderers: l.shape({
    day: l.func,
    hours: l.func,
    meridiem: l.func,
    minutes: l.func,
    month: l.func,
    seconds: l.func,
    year: l.func
  }),
  /**
   * Available views.
   */
  views: l.arrayOf(l.oneOf(["day", "hours", "minutes", "month", "seconds", "year"]).isRequired),
  /**
   * Years rendered per row.
   * @default 4
   */
  yearsPerRow: l.oneOf([3, 4])
};
const bH = /* @__PURE__ */ V.forwardRef(function(t, n) {
  var r, i, o, s, a;
  const u = Yi(), c = Nn(), d = gH(t, "MuiMobileDateTimePicker"), f = N({
    day: Ra,
    month: Ra,
    year: Ra,
    hours: Jh,
    minutes: Jh,
    seconds: Jh
  }, d.viewRenderers), h = (r = d.ampmInClock) != null ? r : !1, m = N({}, d, {
    viewRenderers: f,
    format: aH(c, d),
    ampmInClock: h,
    slots: N({
      field: s$
    }, d.slots),
    slotProps: N({}, d.slotProps, {
      field: (x) => {
        var C;
        return N({}, Id((C = d.slotProps) == null ? void 0 : C.field, x), mg(d), {
          ref: n
        });
      },
      toolbar: N({
        hidden: !1,
        ampmInClock: h
      }, (i = d.slotProps) == null ? void 0 : i.toolbar),
      tabs: N({
        hidden: !1
      }, (o = d.slotProps) == null ? void 0 : o.tabs)
    })
  }), {
    renderPicker: v
  } = u$({
    props: m,
    valueManager: qi,
    valueType: "date-time",
    getOpenDialogAriaText: (s = (a = m.localeText) == null ? void 0 : a.openDatePickerDialogue) != null ? s : u.openDatePickerDialogue,
    validator: n$
  });
  return v();
});
bH.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * 12h/24h view for hour selection clock.
   * @default `utils.is12HourCycleInCurrentLocale()`
   */
  ampm: l.bool,
  /**
   * Display ampm controls under the clock (instead of in the toolbar).
   * @default true on desktop, false on mobile
   */
  ampmInClock: l.bool,
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: l.bool,
  /**
   * Class name applied to the root element.
   */
  className: l.string,
  /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */
  closeOnSelect: l.bool,
  /**
   * Overridable components.
   * @default {}
   * @deprecated Please use `slots`.
   */
  components: l.object,
  /**
   * The props used for each component slot.
   * @default {}
   * @deprecated Please use `slotProps`.
   */
  componentsProps: l.object,
  /**
   * Formats the day of week displayed in the calendar header.
   * @param {string} day The day of week provided by the adapter.  Deprecated, will be removed in v7: Use `date` instead.
   * @param {TDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (_day: string, date: TDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */
  dayOfWeekFormatter: l.func,
  /**
   * Default calendar month displayed when `value` and `defaultValue` are empty.
   * @deprecated Consider using `referenceDate` instead.
   */
  defaultCalendarMonth: l.any,
  /**
   * The default value.
   * Used when the component is not controlled.
   */
  defaultValue: l.any,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: l.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: l.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: l.bool,
  /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */
  disableIgnoringDatePartForTimeValidation: l.bool,
  /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */
  disableOpenPicker: l.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: l.bool,
  /**
   * If `true`, the week number will be display in the calendar.
   */
  displayWeekNumber: l.bool,
  /**
   * Calendar will show more weeks in order to match this value.
   * Put it to 6 for having fix number of week in Gregorian calendars
   * @default undefined
   */
  fixedWeekNumber: l.number,
  /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */
  format: l.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: l.oneOf(["dense", "spacious"]),
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: wr,
  /**
   * The label content.
   */
  label: l.node,
  /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */
  loading: l.bool,
  /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */
  localeText: l.object,
  /**
   * Maximal selectable date.
   */
  maxDate: l.any,
  /**
   * Maximal selectable moment of time with binding to date, to set max time in each day use `maxTime`.
   */
  maxDateTime: l.any,
  /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  maxTime: l.any,
  /**
   * Minimal selectable date.
   */
  minDate: l.any,
  /**
   * Minimal selectable moment of time with binding to date, to set min time in each day use `minTime`.
   */
  minDateTime: l.any,
  /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  minTime: l.any,
  /**
   * Step over minutes.
   * @default 1
   */
  minutesStep: l.number,
  /**
   * Months rendered per row.
   * @default 3
   */
  monthsPerRow: l.oneOf([3, 4]),
  /**
   * Name attribute used by the `input` element in the Field.
   */
  name: l.string,
  /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   */
  onAccept: l.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: l.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */
  onClose: l.func,
  /**
   * Callback fired when the error associated to the current value changes.
   * If the error has a non-null value, then the `TextField` will be rendered in `error` state.
   *
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error describing why the current value is not valid.
   * @param {TValue} value The value associated to the error.
   */
  onError: l.func,
  /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */
  onMonthChange: l.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */
  onOpen: l.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: l.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: l.func,
  /**
   * Callback fired on year change.
   * @template TDate
   * @param {TDate} year The new year.
   */
  onYearChange: l.func,
  /**
   * Control the popup or dialog open state.
   * @default false
   */
  open: l.bool,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: l.oneOf(["day", "hours", "minutes", "month", "seconds", "year"]),
  /**
   * Force rendering in particular orientation.
   */
  orientation: l.oneOf(["landscape", "portrait"]),
  readOnly: l.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: l.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */
  referenceDate: l.any,
  /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span data-mui-test="loading-progress">...</span>
   */
  renderLoading: l.func,
  /**
   * The currently selected sections.
   * This prop accept four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If an object with a `startIndex` and `endIndex` properties are provided, the sections between those two indexes will be selected.
   * 3. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 4. If `null` is provided, no section will be selected
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: l.oneOfType([l.oneOf(["all", "day", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), l.number, l.shape({
    endIndex: l.number.isRequired,
    startIndex: l.number.isRequired
  })]),
  /**
   * Disable specific clock time.
   * @param {number} clockValue The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   * @deprecated Consider using `shouldDisableTime`.
   */
  shouldDisableClock: l.func,
  /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (e.g. when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */
  shouldDisableDate: l.func,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: l.func,
  /**
   * Disable specific time.
   * @template TDate
   * @param {TDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */
  shouldDisableTime: l.func,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: l.func,
  /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */
  showDaysOutsideCurrentMonth: l.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: l.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: l.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documention} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: l.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: l.any,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: l.oneOf(["day", "hours", "minutes", "month", "seconds", "year"]),
  /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be the used.
   */
  viewRenderers: l.shape({
    day: l.func,
    hours: l.func,
    minutes: l.func,
    month: l.func,
    seconds: l.func,
    year: l.func
  }),
  /**
   * Available views.
   */
  views: l.arrayOf(l.oneOf(["day", "hours", "minutes", "month", "seconds", "year"]).isRequired),
  /**
   * Years rendered per row.
   * @default 3
   */
  yearsPerRow: l.oneOf([3, 4])
};
const Dqe = ["desktopModeMediaQuery"], vH = /* @__PURE__ */ V.forwardRef(function(t, n) {
  const r = Vn({
    props: t,
    name: "MuiDateTimePicker"
  }), {
    desktopModeMediaQuery: i = JF
  } = r, o = _e(r, Dqe);
  return PE(i, {
    defaultMatches: !0
  }) ? /* @__PURE__ */ P.jsx(yH, N({
    ref: n
  }, o)) : /* @__PURE__ */ P.jsx(bH, N({
    ref: n
  }, o));
});
process.env.NODE_ENV !== "production" && (vH.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  /**
   * 12h/24h view for hour selection clock.
   * @default `utils.is12HourCycleInCurrentLocale()`
   */
  ampm: l.bool,
  /**
   * Display ampm controls under the clock (instead of in the toolbar).
   * @default true on desktop, false on mobile
   */
  ampmInClock: l.bool,
  /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */
  autoFocus: l.bool,
  /**
   * Class name applied to the root element.
   */
  className: l.string,
  /**
   * If `true`, the popover or modal will close after submitting the full date.
   * @default `true` for desktop, `false` for mobile (based on the chosen wrapper and `desktopModeMediaQuery` prop).
   */
  closeOnSelect: l.bool,
  /**
   * Overridable components.
   * @default {}
   * @deprecated Please use `slots`.
   */
  components: l.object,
  /**
   * The props used for each component slot.
   * @default {}
   * @deprecated Please use `slotProps`.
   */
  componentsProps: l.object,
  /**
   * Formats the day of week displayed in the calendar header.
   * @param {string} day The day of week provided by the adapter.  Deprecated, will be removed in v7: Use `date` instead.
   * @param {TDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (_day: string, date: TDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */
  dayOfWeekFormatter: l.func,
  /**
   * Default calendar month displayed when `value` and `defaultValue` are empty.
   * @deprecated Consider using `referenceDate` instead.
   */
  defaultCalendarMonth: l.any,
  /**
   * The default value.
   * Used when the component is not controlled.
   */
  defaultValue: l.any,
  /**
   * CSS media query when `Mobile` mode will be changed to `Desktop`.
   * @default '@media (pointer: fine)'
   * @example '@media (min-width: 720px)' or theme.breakpoints.up("sm")
   */
  desktopModeMediaQuery: l.string,
  /**
   * If `true`, the picker and text field are disabled.
   * @default false
   */
  disabled: l.bool,
  /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disableFuture: l.bool,
  /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */
  disableHighlightToday: l.bool,
  /**
   * Do not ignore date part when validating min/max time.
   * @default false
   */
  disableIgnoringDatePartForTimeValidation: l.bool,
  /**
   * If `true`, the open picker button will not be rendered (renders only the field).
   * @default false
   */
  disableOpenPicker: l.bool,
  /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */
  disablePast: l.bool,
  /**
   * If `true`, the week number will be display in the calendar.
   */
  displayWeekNumber: l.bool,
  /**
   * Calendar will show more weeks in order to match this value.
   * Put it to 6 for having fix number of week in Gregorian calendars
   * @default undefined
   */
  fixedWeekNumber: l.number,
  /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */
  format: l.string,
  /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */
  formatDensity: l.oneOf(["dense", "spacious"]),
  /**
   * Pass a ref to the `input` element.
   */
  inputRef: wr,
  /**
   * The label content.
   */
  label: l.node,
  /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */
  loading: l.bool,
  /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */
  localeText: l.object,
  /**
   * Maximal selectable date.
   */
  maxDate: l.any,
  /**
   * Maximal selectable moment of time with binding to date, to set max time in each day use `maxTime`.
   */
  maxDateTime: l.any,
  /**
   * Maximal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  maxTime: l.any,
  /**
   * Minimal selectable date.
   */
  minDate: l.any,
  /**
   * Minimal selectable moment of time with binding to date, to set min time in each day use `minTime`.
   */
  minDateTime: l.any,
  /**
   * Minimal selectable time.
   * The date part of the object will be ignored unless `props.disableIgnoringDatePartForTimeValidation === true`.
   */
  minTime: l.any,
  /**
   * Step over minutes.
   * @default 1
   */
  minutesStep: l.number,
  /**
   * Months rendered per row.
   * @default 3
   */
  monthsPerRow: l.oneOf([3, 4]),
  /**
   * Name attribute used by the `input` element in the Field.
   */
  name: l.string,
  /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   */
  onAccept: l.func,
  /**
   * Callback fired when the value changes.
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */
  onChange: l.func,
  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */
  onClose: l.func,
  /**
   * Callback fired when the error associated to the current value changes.
   * If the error has a non-null value, then the `TextField` will be rendered in `error` state.
   *
   * @template TValue The value type. Will be either the same type as `value` or `null`. Can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. Will be either `string` or a `null`. Can be in `[start, end]` format in case of range value.
   * @param {TError} error The new error describing why the current value is not valid.
   * @param {TValue} value The value associated to the error.
   */
  onError: l.func,
  /**
   * Callback fired on month change.
   * @template TDate
   * @param {TDate} month The new month.
   */
  onMonthChange: l.func,
  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */
  onOpen: l.func,
  /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */
  onSelectedSectionsChange: l.func,
  /**
   * Callback fired on view change.
   * @template TView
   * @param {TView} view The new view.
   */
  onViewChange: l.func,
  /**
   * Callback fired on year change.
   * @template TDate
   * @param {TDate} year The new year.
   */
  onYearChange: l.func,
  /**
   * Control the popup or dialog open state.
   * @default false
   */
  open: l.bool,
  /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */
  openTo: l.oneOf(["day", "hours", "meridiem", "minutes", "month", "seconds", "year"]),
  /**
   * Force rendering in particular orientation.
   */
  orientation: l.oneOf(["landscape", "portrait"]),
  readOnly: l.bool,
  /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */
  reduceAnimations: l.bool,
  /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */
  referenceDate: l.any,
  /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span data-mui-test="loading-progress">...</span>
   */
  renderLoading: l.func,
  /**
   * The currently selected sections.
   * This prop accept four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If an object with a `startIndex` and `endIndex` properties are provided, the sections between those two indexes will be selected.
   * 3. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 4. If `null` is provided, no section will be selected
   * If not provided, the selected sections will be handled internally.
   */
  selectedSections: l.oneOfType([l.oneOf(["all", "day", "hours", "meridiem", "minutes", "month", "seconds", "weekDay", "year"]), l.number, l.shape({
    endIndex: l.number.isRequired,
    startIndex: l.number.isRequired
  })]),
  /**
   * Disable specific clock time.
   * @param {number} clockValue The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   * @deprecated Consider using `shouldDisableTime`.
   */
  shouldDisableClock: l.func,
  /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (e.g. when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @template TDate
   * @param {TDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */
  shouldDisableDate: l.func,
  /**
   * Disable specific month.
   * @template TDate
   * @param {TDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */
  shouldDisableMonth: l.func,
  /**
   * Disable specific time.
   * @template TDate
   * @param {TDate} value The value to check.
   * @param {TimeView} view The clock type of the timeValue.
   * @returns {boolean} If `true` the time will be disabled.
   */
  shouldDisableTime: l.func,
  /**
   * Disable specific year.
   * @template TDate
   * @param {TDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */
  shouldDisableYear: l.func,
  /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */
  showDaysOutsideCurrentMonth: l.bool,
  /**
   * If `true`, disabled digital clock items will not be rendered.
   * @default false
   */
  skipDisabled: l.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: l.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: l.object,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: l.oneOfType([l.arrayOf(l.oneOfType([l.func, l.object, l.bool])), l.func, l.object]),
  /**
   * Amount of time options below or at which the single column time renderer is used.
   * @default 24
   */
  thresholdToRenderTimeInASingleColumn: l.number,
  /**
   * The time steps between two time unit options.
   * For example, if `timeStep.minutes = 8`, then the available minute options will be `[0, 8, 16, 24, 32, 40, 48, 56]`.
   * When single column time renderer is used, only `timeStep.minutes` will be used.
   * @default{ hours: 1, minutes: 5, seconds: 5 }
   */
  timeSteps: l.shape({
    hours: l.number,
    minutes: l.number,
    seconds: l.number
  }),
  /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documention} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */
  timezone: l.string,
  /**
   * The selected value.
   * Used when the component is controlled.
   */
  value: l.any,
  /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */
  view: l.oneOf(["day", "hours", "meridiem", "minutes", "month", "seconds", "year"]),
  /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be the used.
   */
  viewRenderers: l.shape({
    day: l.func,
    hours: l.func,
    meridiem: l.func,
    minutes: l.func,
    month: l.func,
    seconds: l.func,
    year: l.func
  }),
  /**
   * Available views.
   */
  views: l.arrayOf(l.oneOf(["day", "hours", "minutes", "month", "seconds", "year"]).isRequired),
  /**
   * Years rendered per row.
   * @default 4 on desktop, 3 on mobile
   */
  yearsPerRow: l.oneOf([3, 4])
});
var xH = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(Kr, function() {
    var n = 1e3, r = 6e4, i = 36e5, o = "millisecond", s = "second", a = "minute", u = "hour", c = "day", d = "week", f = "month", h = "quarter", m = "year", v = "date", x = "Invalid Date", C = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, E = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, S = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(j) {
      var U = ["th", "st", "nd", "rd"], G = j % 100;
      return "[" + j + (U[(G - 20) % 10] || U[G] || U[0]) + "]";
    } }, w = function(j, U, G) {
      var K = String(j);
      return !K || K.length >= U ? j : "" + Array(U + 1 - K.length).join(G) + j;
    }, O = { s: w, z: function(j) {
      var U = -j.utcOffset(), G = Math.abs(U), K = Math.floor(G / 60), ee = G % 60;
      return (U <= 0 ? "+" : "-") + w(K, 2, "0") + ":" + w(ee, 2, "0");
    }, m: function j(U, G) {
      if (U.date() < G.date()) return -j(G, U);
      var K = 12 * (G.year() - U.year()) + (G.month() - U.month()), ee = U.clone().add(K, f), te = G - ee < 0, M = U.clone().add(K + (te ? -1 : 1), f);
      return +(-(K + (G - ee) / (te ? ee - M : M - ee)) || 0);
    }, a: function(j) {
      return j < 0 ? Math.ceil(j) || 0 : Math.floor(j);
    }, p: function(j) {
      return { M: f, y: m, w: d, d: c, D: v, h: u, m: a, s, ms: o, Q: h }[j] || String(j || "").toLowerCase().replace(/s$/, "");
    }, u: function(j) {
      return j === void 0;
    } }, A = "en", I = {};
    I[A] = S;
    var $ = "$isDayjsObject", L = function(j) {
      return j instanceof J || !(!j || !j[$]);
    }, B = function j(U, G, K) {
      var ee;
      if (!U) return A;
      if (typeof U == "string") {
        var te = U.toLowerCase();
        I[te] && (ee = te), G && (I[te] = G, ee = te);
        var M = U.split("-");
        if (!ee && M.length > 1) return j(M[0]);
      } else {
        var Z = U.name;
        I[Z] = U, ee = Z;
      }
      return !K && ee && (A = ee), ee || !K && A;
    }, H = function(j, U) {
      if (L(j)) return j.clone();
      var G = typeof U == "object" ? U : {};
      return G.date = j, G.args = arguments, new J(G);
    }, q = O;
    q.l = B, q.i = L, q.w = function(j, U) {
      return H(j, { locale: U.$L, utc: U.$u, x: U.$x, $offset: U.$offset });
    };
    var J = function() {
      function j(G) {
        this.$L = B(G.locale, null, !0), this.parse(G), this.$x = this.$x || G.x || {}, this[$] = !0;
      }
      var U = j.prototype;
      return U.parse = function(G) {
        this.$d = function(K) {
          var ee = K.date, te = K.utc;
          if (ee === null) return /* @__PURE__ */ new Date(NaN);
          if (q.u(ee)) return /* @__PURE__ */ new Date();
          if (ee instanceof Date) return new Date(ee);
          if (typeof ee == "string" && !/Z$/i.test(ee)) {
            var M = ee.match(C);
            if (M) {
              var Z = M[2] - 1 || 0, ne = (M[7] || "0").substring(0, 3);
              return te ? new Date(Date.UTC(M[1], Z, M[3] || 1, M[4] || 0, M[5] || 0, M[6] || 0, ne)) : new Date(M[1], Z, M[3] || 1, M[4] || 0, M[5] || 0, M[6] || 0, ne);
            }
          }
          return new Date(ee);
        }(G), this.init();
      }, U.init = function() {
        var G = this.$d;
        this.$y = G.getFullYear(), this.$M = G.getMonth(), this.$D = G.getDate(), this.$W = G.getDay(), this.$H = G.getHours(), this.$m = G.getMinutes(), this.$s = G.getSeconds(), this.$ms = G.getMilliseconds();
      }, U.$utils = function() {
        return q;
      }, U.isValid = function() {
        return this.$d.toString() !== x;
      }, U.isSame = function(G, K) {
        var ee = H(G);
        return this.startOf(K) <= ee && ee <= this.endOf(K);
      }, U.isAfter = function(G, K) {
        return H(G) < this.startOf(K);
      }, U.isBefore = function(G, K) {
        return this.endOf(K) < H(G);
      }, U.$g = function(G, K, ee) {
        return q.u(G) ? this[K] : this.set(ee, G);
      }, U.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, U.valueOf = function() {
        return this.$d.getTime();
      }, U.startOf = function(G, K) {
        var ee = this, te = !!q.u(K) || K, M = q.p(G), Z = function(pe, me) {
          var xe = q.w(ee.$u ? Date.UTC(ee.$y, me, pe) : new Date(ee.$y, me, pe), ee);
          return te ? xe : xe.endOf(c);
        }, ne = function(pe, me) {
          return q.w(ee.toDate()[pe].apply(ee.toDate("s"), (te ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(me)), ee);
        }, R = this.$W, _ = this.$M, W = this.$D, Q = "set" + (this.$u ? "UTC" : "");
        switch (M) {
          case m:
            return te ? Z(1, 0) : Z(31, 11);
          case f:
            return te ? Z(1, _) : Z(0, _ + 1);
          case d:
            var oe = this.$locale().weekStart || 0, ae = (R < oe ? R + 7 : R) - oe;
            return Z(te ? W - ae : W + (6 - ae), _);
          case c:
          case v:
            return ne(Q + "Hours", 0);
          case u:
            return ne(Q + "Minutes", 1);
          case a:
            return ne(Q + "Seconds", 2);
          case s:
            return ne(Q + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, U.endOf = function(G) {
        return this.startOf(G, !1);
      }, U.$set = function(G, K) {
        var ee, te = q.p(G), M = "set" + (this.$u ? "UTC" : ""), Z = (ee = {}, ee[c] = M + "Date", ee[v] = M + "Date", ee[f] = M + "Month", ee[m] = M + "FullYear", ee[u] = M + "Hours", ee[a] = M + "Minutes", ee[s] = M + "Seconds", ee[o] = M + "Milliseconds", ee)[te], ne = te === c ? this.$D + (K - this.$W) : K;
        if (te === f || te === m) {
          var R = this.clone().set(v, 1);
          R.$d[Z](ne), R.init(), this.$d = R.set(v, Math.min(this.$D, R.daysInMonth())).$d;
        } else Z && this.$d[Z](ne);
        return this.init(), this;
      }, U.set = function(G, K) {
        return this.clone().$set(G, K);
      }, U.get = function(G) {
        return this[q.p(G)]();
      }, U.add = function(G, K) {
        var ee, te = this;
        G = Number(G);
        var M = q.p(K), Z = function(_) {
          var W = H(te);
          return q.w(W.date(W.date() + Math.round(_ * G)), te);
        };
        if (M === f) return this.set(f, this.$M + G);
        if (M === m) return this.set(m, this.$y + G);
        if (M === c) return Z(1);
        if (M === d) return Z(7);
        var ne = (ee = {}, ee[a] = r, ee[u] = i, ee[s] = n, ee)[M] || 1, R = this.$d.getTime() + G * ne;
        return q.w(R, this);
      }, U.subtract = function(G, K) {
        return this.add(-1 * G, K);
      }, U.format = function(G) {
        var K = this, ee = this.$locale();
        if (!this.isValid()) return ee.invalidDate || x;
        var te = G || "YYYY-MM-DDTHH:mm:ssZ", M = q.z(this), Z = this.$H, ne = this.$m, R = this.$M, _ = ee.weekdays, W = ee.months, Q = ee.meridiem, oe = function(me, xe, le, ye) {
          return me && (me[xe] || me(K, te)) || le[xe].slice(0, ye);
        }, ae = function(me) {
          return q.s(Z % 12 || 12, me, "0");
        }, pe = Q || function(me, xe, le) {
          var ye = me < 12 ? "AM" : "PM";
          return le ? ye.toLowerCase() : ye;
        };
        return te.replace(E, function(me, xe) {
          return xe || function(le) {
            switch (le) {
              case "YY":
                return String(K.$y).slice(-2);
              case "YYYY":
                return q.s(K.$y, 4, "0");
              case "M":
                return R + 1;
              case "MM":
                return q.s(R + 1, 2, "0");
              case "MMM":
                return oe(ee.monthsShort, R, W, 3);
              case "MMMM":
                return oe(W, R);
              case "D":
                return K.$D;
              case "DD":
                return q.s(K.$D, 2, "0");
              case "d":
                return String(K.$W);
              case "dd":
                return oe(ee.weekdaysMin, K.$W, _, 2);
              case "ddd":
                return oe(ee.weekdaysShort, K.$W, _, 3);
              case "dddd":
                return _[K.$W];
              case "H":
                return String(Z);
              case "HH":
                return q.s(Z, 2, "0");
              case "h":
                return ae(1);
              case "hh":
                return ae(2);
              case "a":
                return pe(Z, ne, !0);
              case "A":
                return pe(Z, ne, !1);
              case "m":
                return String(ne);
              case "mm":
                return q.s(ne, 2, "0");
              case "s":
                return String(K.$s);
              case "ss":
                return q.s(K.$s, 2, "0");
              case "SSS":
                return q.s(K.$ms, 3, "0");
              case "Z":
                return M;
            }
            return null;
          }(me) || M.replace(":", "");
        });
      }, U.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, U.diff = function(G, K, ee) {
        var te, M = this, Z = q.p(K), ne = H(G), R = (ne.utcOffset() - this.utcOffset()) * r, _ = this - ne, W = function() {
          return q.m(M, ne);
        };
        switch (Z) {
          case m:
            te = W() / 12;
            break;
          case f:
            te = W();
            break;
          case h:
            te = W() / 3;
            break;
          case d:
            te = (_ - R) / 6048e5;
            break;
          case c:
            te = (_ - R) / 864e5;
            break;
          case u:
            te = _ / i;
            break;
          case a:
            te = _ / r;
            break;
          case s:
            te = _ / n;
            break;
          default:
            te = _;
        }
        return ee ? te : q.a(te);
      }, U.daysInMonth = function() {
        return this.endOf(f).$D;
      }, U.$locale = function() {
        return I[this.$L];
      }, U.locale = function(G, K) {
        if (!G) return this.$L;
        var ee = this.clone(), te = B(G, K, !0);
        return te && (ee.$L = te), ee;
      }, U.clone = function() {
        return q.w(this.$d, this);
      }, U.toDate = function() {
        return new Date(this.valueOf());
      }, U.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, U.toISOString = function() {
        return this.$d.toISOString();
      }, U.toString = function() {
        return this.$d.toUTCString();
      }, j;
    }(), X = J.prototype;
    return H.prototype = X, [["$ms", o], ["$s", s], ["$m", a], ["$H", u], ["$W", c], ["$M", f], ["$y", m], ["$D", v]].forEach(function(j) {
      X[j[1]] = function(U) {
        return this.$g(U, j[0], j[1]);
      };
    }), H.extend = function(j, U) {
      return j.$i || (j(U, J, H), j.$i = !0), H;
    }, H.locale = B, H.isDayjs = L, H.unix = function(j) {
      return H(1e3 * j);
    }, H.en = I[A], H.Ls = I, H.p = {}, H;
  });
})(xH);
var Cqe = xH.exports;
const Bi = /* @__PURE__ */ Ln(Cqe);
var DH = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(Kr, function() {
    var n = "week", r = "year";
    return function(i, o, s) {
      var a = o.prototype;
      a.week = function(u) {
        if (u === void 0 && (u = null), u !== null) return this.add(7 * (u - this.week()), "day");
        var c = this.$locale().yearStart || 1;
        if (this.month() === 11 && this.date() > 25) {
          var d = s(this).startOf(r).add(1, r).date(c), f = s(this).endOf(n);
          if (d.isBefore(f)) return 1;
        }
        var h = s(this).startOf(r).date(c).startOf(n).subtract(1, "millisecond"), m = this.diff(h, n, !0);
        return m < 0 ? s(this).startOf("week").week() : Math.ceil(m);
      }, a.weeks = function(u) {
        return u === void 0 && (u = null), this.week(u);
      };
    };
  });
})(DH);
var Eqe = DH.exports;
const Tqe = /* @__PURE__ */ Ln(Eqe);
var CH = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(Kr, function() {
    var n = { LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" }, r = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|YYYY|YY?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, i = /\d\d/, o = /\d\d?/, s = /\d*[^-_:/,()\s\d]+/, a = {}, u = function(x) {
      return (x = +x) + (x > 68 ? 1900 : 2e3);
    }, c = function(x) {
      return function(C) {
        this[x] = +C;
      };
    }, d = [/[+-]\d\d:?(\d\d)?|Z/, function(x) {
      (this.zone || (this.zone = {})).offset = function(C) {
        if (!C || C === "Z") return 0;
        var E = C.match(/([+-]|\d\d)/g), S = 60 * E[1] + (+E[2] || 0);
        return S === 0 ? 0 : E[0] === "+" ? -S : S;
      }(x);
    }], f = function(x) {
      var C = a[x];
      return C && (C.indexOf ? C : C.s.concat(C.f));
    }, h = function(x, C) {
      var E, S = a.meridiem;
      if (S) {
        for (var w = 1; w <= 24; w += 1) if (x.indexOf(S(w, 0, C)) > -1) {
          E = w > 12;
          break;
        }
      } else E = x === (C ? "pm" : "PM");
      return E;
    }, m = { A: [s, function(x) {
      this.afternoon = h(x, !1);
    }], a: [s, function(x) {
      this.afternoon = h(x, !0);
    }], S: [/\d/, function(x) {
      this.milliseconds = 100 * +x;
    }], SS: [i, function(x) {
      this.milliseconds = 10 * +x;
    }], SSS: [/\d{3}/, function(x) {
      this.milliseconds = +x;
    }], s: [o, c("seconds")], ss: [o, c("seconds")], m: [o, c("minutes")], mm: [o, c("minutes")], H: [o, c("hours")], h: [o, c("hours")], HH: [o, c("hours")], hh: [o, c("hours")], D: [o, c("day")], DD: [i, c("day")], Do: [s, function(x) {
      var C = a.ordinal, E = x.match(/\d+/);
      if (this.day = E[0], C) for (var S = 1; S <= 31; S += 1) C(S).replace(/\[|\]/g, "") === x && (this.day = S);
    }], M: [o, c("month")], MM: [i, c("month")], MMM: [s, function(x) {
      var C = f("months"), E = (f("monthsShort") || C.map(function(S) {
        return S.slice(0, 3);
      })).indexOf(x) + 1;
      if (E < 1) throw new Error();
      this.month = E % 12 || E;
    }], MMMM: [s, function(x) {
      var C = f("months").indexOf(x) + 1;
      if (C < 1) throw new Error();
      this.month = C % 12 || C;
    }], Y: [/[+-]?\d+/, c("year")], YY: [i, function(x) {
      this.year = u(x);
    }], YYYY: [/\d{4}/, c("year")], Z: d, ZZ: d };
    function v(x) {
      var C, E;
      C = x, E = a && a.formats;
      for (var S = (x = C.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(B, H, q) {
        var J = q && q.toUpperCase();
        return H || E[q] || n[q] || E[J].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(X, j, U) {
          return j || U.slice(1);
        });
      })).match(r), w = S.length, O = 0; O < w; O += 1) {
        var A = S[O], I = m[A], $ = I && I[0], L = I && I[1];
        S[O] = L ? { regex: $, parser: L } : A.replace(/^\[|\]$/g, "");
      }
      return function(B) {
        for (var H = {}, q = 0, J = 0; q < w; q += 1) {
          var X = S[q];
          if (typeof X == "string") J += X.length;
          else {
            var j = X.regex, U = X.parser, G = B.slice(J), K = j.exec(G)[0];
            U.call(H, K), B = B.replace(K, "");
          }
        }
        return function(ee) {
          var te = ee.afternoon;
          if (te !== void 0) {
            var M = ee.hours;
            te ? M < 12 && (ee.hours += 12) : M === 12 && (ee.hours = 0), delete ee.afternoon;
          }
        }(H), H;
      };
    }
    return function(x, C, E) {
      E.p.customParseFormat = !0, x && x.parseTwoDigitYear && (u = x.parseTwoDigitYear);
      var S = C.prototype, w = S.parse;
      S.parse = function(O) {
        var A = O.date, I = O.utc, $ = O.args;
        this.$u = I;
        var L = $[1];
        if (typeof L == "string") {
          var B = $[2] === !0, H = $[3] === !0, q = B || H, J = $[2];
          H && (J = $[2]), a = this.$locale(), !B && J && (a = E.Ls[J]), this.$d = function(G, K, ee) {
            try {
              if (["x", "X"].indexOf(K) > -1) return new Date((K === "X" ? 1e3 : 1) * G);
              var te = v(K)(G), M = te.year, Z = te.month, ne = te.day, R = te.hours, _ = te.minutes, W = te.seconds, Q = te.milliseconds, oe = te.zone, ae = /* @__PURE__ */ new Date(), pe = ne || (M || Z ? 1 : ae.getDate()), me = M || ae.getFullYear(), xe = 0;
              M && !Z || (xe = Z > 0 ? Z - 1 : ae.getMonth());
              var le = R || 0, ye = _ || 0, be = W || 0, Re = Q || 0;
              return oe ? new Date(Date.UTC(me, xe, pe, le, ye, be, Re + 60 * oe.offset * 1e3)) : ee ? new Date(Date.UTC(me, xe, pe, le, ye, be, Re)) : new Date(me, xe, pe, le, ye, be, Re);
            } catch {
              return /* @__PURE__ */ new Date("");
            }
          }(A, L, I), this.init(), J && J !== !0 && (this.$L = this.locale(J).$L), q && A != this.format(L) && (this.$d = /* @__PURE__ */ new Date("")), a = {};
        } else if (L instanceof Array) for (var X = L.length, j = 1; j <= X; j += 1) {
          $[1] = L[j - 1];
          var U = E.apply(this, $);
          if (U.isValid()) {
            this.$d = U.$d, this.$L = U.$L, this.init();
            break;
          }
          j === X && (this.$d = /* @__PURE__ */ new Date(""));
        }
        else w.call(this, O);
      };
    };
  });
})(CH);
var Sqe = CH.exports;
const Aqe = /* @__PURE__ */ Ln(Sqe);
var EH = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(Kr, function() {
    var n = { LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" };
    return function(r, i, o) {
      var s = i.prototype, a = s.format;
      o.en.formats = n, s.format = function(u) {
        u === void 0 && (u = "YYYY-MM-DDTHH:mm:ssZ");
        var c = this.$locale().formats, d = function(f, h) {
          return f.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(m, v, x) {
            var C = x && x.toUpperCase();
            return v || h[x] || n[x] || h[C].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(E, S, w) {
              return S || w.slice(1);
            });
          });
        }(u, c === void 0 ? {} : c);
        return a.call(this, d);
      };
    };
  });
})(EH);
var wqe = EH.exports;
const Pqe = /* @__PURE__ */ Ln(wqe);
var TH = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r();
  })(Kr, function() {
    return function(n, r, i) {
      r.prototype.isBetween = function(o, s, a, u) {
        var c = i(o), d = i(s), f = (u = u || "()")[0] === "(", h = u[1] === ")";
        return (f ? this.isAfter(c, a) : !this.isBefore(c, a)) && (h ? this.isBefore(d, a) : !this.isAfter(d, a)) || (f ? this.isBefore(c, a) : !this.isAfter(c, a)) && (h ? this.isAfter(d, a) : !this.isBefore(d, a));
      };
    };
  });
})(TH);
var kqe = TH.exports;
const Oqe = /* @__PURE__ */ Ln(kqe);
Bi.extend(Aqe);
Bi.extend(Pqe);
Bi.extend(Oqe);
const Iqe = jW(["Your locale has not been found.", "Either the locale key is not a supported one. Locales supported by dayjs are available here: https://github.com/iamkun/dayjs/tree/dev/src/locale", "Or you forget to import the locale from 'dayjs/locale/{localeUsed}'", "fallback on English locale"]), Fqe = {
  // Year
  YY: "year",
  YYYY: {
    sectionType: "year",
    contentType: "digit",
    maxLength: 4
  },
  // Month
  M: {
    sectionType: "month",
    contentType: "digit",
    maxLength: 2
  },
  MM: "month",
  MMM: {
    sectionType: "month",
    contentType: "letter"
  },
  MMMM: {
    sectionType: "month",
    contentType: "letter"
  },
  // Day of the month
  D: {
    sectionType: "day",
    contentType: "digit",
    maxLength: 2
  },
  DD: "day",
  Do: {
    sectionType: "day",
    contentType: "digit-with-letter"
  },
  // Day of the week
  d: {
    sectionType: "weekDay",
    contentType: "digit",
    maxLength: 2
  },
  dd: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  ddd: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  dddd: {
    sectionType: "weekDay",
    contentType: "letter"
  },
  // Meridiem
  A: "meridiem",
  a: "meridiem",
  // Hours
  H: {
    sectionType: "hours",
    contentType: "digit",
    maxLength: 2
  },
  HH: "hours",
  h: {
    sectionType: "hours",
    contentType: "digit",
    maxLength: 2
  },
  hh: "hours",
  // Minutes
  m: {
    sectionType: "minutes",
    contentType: "digit",
    maxLength: 2
  },
  mm: "minutes",
  // Seconds
  s: {
    sectionType: "seconds",
    contentType: "digit",
    maxLength: 2
  },
  ss: "seconds"
}, $qe = {
  year: "YYYY",
  month: "MMMM",
  monthShort: "MMM",
  dayOfMonth: "D",
  weekday: "dddd",
  weekdayShort: "dd",
  hours24h: "HH",
  hours12h: "hh",
  meridiem: "A",
  minutes: "mm",
  seconds: "ss",
  fullDate: "ll",
  fullDateWithWeekday: "dddd, LL",
  keyboardDate: "L",
  shortDate: "MMM D",
  normalDate: "D MMMM",
  normalDateWithWeekday: "ddd, MMM D",
  monthAndYear: "MMMM YYYY",
  monthAndDate: "MMMM D",
  fullTime: "LT",
  fullTime12h: "hh:mm A",
  fullTime24h: "HH:mm",
  fullDateTime: "lll",
  fullDateTime12h: "ll hh:mm A",
  fullDateTime24h: "ll HH:mm",
  keyboardDateTime: "L LT",
  keyboardDateTime12h: "L hh:mm A",
  keyboardDateTime24h: "L HH:mm"
}, sw = ["Missing UTC plugin", "To be able to use UTC or timezones, you have to enable the `utc` plugin", "Find more information on https://mui.com/x/react-date-pickers/timezone/#day-js-and-utc"].join(`
`), Dj = ["Missing timezone plugin", "To be able to use timezones, you have to enable both the `utc` and the `timezone` plugin", "Find more information on https://mui.com/x/react-date-pickers/timezone/#day-js-and-timezone"].join(`
`), Nqe = (e, t) => t ? (...n) => e(...n).locale(t) : e;
class pv {
  constructor({
    locale: t,
    formats: n,
    instance: r
  } = {}) {
    var i;
    this.isMUIAdapter = !0, this.isTimezoneCompatible = !0, this.lib = "dayjs", this.rawDayJsInstance = void 0, this.dayjs = void 0, this.locale = void 0, this.formats = void 0, this.escapedCharacters = {
      start: "[",
      end: "]"
    }, this.formatTokenMap = Fqe, this.setLocaleToValue = (o) => {
      const s = this.getCurrentLocaleCode();
      return s === o.locale() ? o : o.locale(s);
    }, this.hasUTCPlugin = () => typeof Bi.utc < "u", this.hasTimezonePlugin = () => typeof Bi.tz < "u", this.isSame = (o, s, a) => {
      const u = this.setTimezone(s, this.getTimezone(o));
      return o.format(a) === u.format(a);
    }, this.cleanTimezone = (o) => {
      switch (o) {
        case "default":
          return;
        case "system":
          return Bi.tz.guess();
        default:
          return o;
      }
    }, this.createSystemDate = (o) => {
      if (this.rawDayJsInstance)
        return this.rawDayJsInstance(o);
      if (this.hasUTCPlugin() && this.hasTimezonePlugin()) {
        const s = Bi.tz.guess();
        return s !== "UTC" ? Bi.tz(o, s) : Bi(o);
      }
      return Bi(o);
    }, this.createUTCDate = (o) => {
      if (!this.hasUTCPlugin())
        throw new Error(sw);
      return Bi.utc(o);
    }, this.createTZDate = (o, s) => {
      if (!this.hasUTCPlugin())
        throw new Error(sw);
      if (!this.hasTimezonePlugin())
        throw new Error(Dj);
      const a = o !== void 0 && !o.endsWith("Z");
      return Bi(o).tz(this.cleanTimezone(s), a);
    }, this.getLocaleFormats = () => {
      const o = Bi.Ls, s = this.locale || "en";
      let a = o[s];
      return a === void 0 && (Iqe(), a = o.en), a.formats;
    }, this.adjustOffset = (o) => {
      if (!this.hasTimezonePlugin())
        return o;
      const s = this.getTimezone(o);
      if (s !== "UTC") {
        var a, u;
        const c = o.tz(this.cleanTimezone(s), !0);
        if (((a = c.$offset) != null ? a : 0) === ((u = o.$offset) != null ? u : 0))
          return o;
        o.$offset = c.$offset;
      }
      return o;
    }, this.date = (o) => o === null ? null : this.dayjs(o), this.dateWithTimezone = (o, s) => {
      if (o === null)
        return null;
      let a;
      return s === "UTC" ? a = this.createUTCDate(o) : s === "system" || s === "default" && !this.hasTimezonePlugin() ? a = this.createSystemDate(o) : a = this.createTZDate(o, s), this.locale === void 0 ? a : a.locale(this.locale);
    }, this.getTimezone = (o) => {
      if (this.hasTimezonePlugin()) {
        var s;
        const a = (s = o.$x) == null ? void 0 : s.$timezone;
        if (a)
          return a;
      }
      return this.hasUTCPlugin() && o.isUTC() ? "UTC" : "system";
    }, this.setTimezone = (o, s) => {
      if (this.getTimezone(o) === s)
        return o;
      if (s === "UTC") {
        if (!this.hasUTCPlugin())
          throw new Error(sw);
        return o.utc();
      }
      if (s === "system")
        return o.local();
      if (!this.hasTimezonePlugin()) {
        if (s === "default")
          return o;
        throw new Error(Dj);
      }
      return Bi.tz(o, this.cleanTimezone(s));
    }, this.toJsDate = (o) => o.toDate(), this.parseISO = (o) => this.dayjs(o), this.toISO = (o) => o.toISOString(), this.parse = (o, s) => o === "" ? null : this.dayjs(o, s, this.locale, !0), this.getCurrentLocaleCode = () => this.locale || "en", this.is12HourCycleInCurrentLocale = () => /A|a/.test(this.getLocaleFormats().LT || ""), this.expandFormat = (o) => {
      const s = this.getLocaleFormats(), a = (u) => u.replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, (c, d, f) => d || f.slice(1));
      return o.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, (u, c, d) => {
        const f = d && d.toUpperCase();
        return c || s[d] || a(s[f]);
      });
    }, this.getFormatHelperText = (o) => this.expandFormat(o).replace(/a/gi, "(a|p)m").toLocaleLowerCase(), this.isNull = (o) => o === null, this.isValid = (o) => this.dayjs(o).isValid(), this.format = (o, s) => this.formatByString(o, this.formats[s]), this.formatByString = (o, s) => this.dayjs(o).format(s), this.formatNumber = (o) => o, this.getDiff = (o, s, a) => o.diff(s, a), this.isEqual = (o, s) => o === null && s === null ? !0 : this.dayjs(o).toDate().getTime() === this.dayjs(s).toDate().getTime(), this.isSameYear = (o, s) => this.isSame(o, s, "YYYY"), this.isSameMonth = (o, s) => this.isSame(o, s, "YYYY-MM"), this.isSameDay = (o, s) => this.isSame(o, s, "YYYY-MM-DD"), this.isSameHour = (o, s) => o.isSame(s, "hour"), this.isAfter = (o, s) => o > s, this.isAfterYear = (o, s) => this.hasUTCPlugin() ? !this.isSameYear(o, s) && o.utc() > s.utc() : o.isAfter(s, "year"), this.isAfterDay = (o, s) => this.hasUTCPlugin() ? !this.isSameDay(o, s) && o.utc() > s.utc() : o.isAfter(s, "day"), this.isBefore = (o, s) => o < s, this.isBeforeYear = (o, s) => this.hasUTCPlugin() ? !this.isSameYear(o, s) && o.utc() < s.utc() : o.isBefore(s, "year"), this.isBeforeDay = (o, s) => this.hasUTCPlugin() ? !this.isSameDay(o, s) && o.utc() < s.utc() : o.isBefore(s, "day"), this.isWithinRange = (o, [s, a]) => o >= s && o <= a, this.startOfYear = (o) => this.adjustOffset(o.startOf("year")), this.startOfMonth = (o) => this.adjustOffset(o.startOf("month")), this.startOfWeek = (o) => this.adjustOffset(o.startOf("week")), this.startOfDay = (o) => this.adjustOffset(o.startOf("day")), this.endOfYear = (o) => this.adjustOffset(o.endOf("year")), this.endOfMonth = (o) => this.adjustOffset(o.endOf("month")), this.endOfWeek = (o) => this.adjustOffset(o.endOf("week")), this.endOfDay = (o) => this.adjustOffset(o.endOf("day")), this.addYears = (o, s) => this.adjustOffset(s < 0 ? o.subtract(Math.abs(s), "year") : o.add(s, "year")), this.addMonths = (o, s) => this.adjustOffset(s < 0 ? o.subtract(Math.abs(s), "month") : o.add(s, "month")), this.addWeeks = (o, s) => this.adjustOffset(s < 0 ? o.subtract(Math.abs(s), "week") : o.add(s, "week")), this.addDays = (o, s) => this.adjustOffset(s < 0 ? o.subtract(Math.abs(s), "day") : o.add(s, "day")), this.addHours = (o, s) => this.adjustOffset(s < 0 ? o.subtract(Math.abs(s), "hour") : o.add(s, "hour")), this.addMinutes = (o, s) => this.adjustOffset(s < 0 ? o.subtract(Math.abs(s), "minute") : o.add(s, "minute")), this.addSeconds = (o, s) => this.adjustOffset(s < 0 ? o.subtract(Math.abs(s), "second") : o.add(s, "second")), this.getYear = (o) => o.year(), this.getMonth = (o) => o.month(), this.getDate = (o) => o.date(), this.getHours = (o) => o.hour(), this.getMinutes = (o) => o.minute(), this.getSeconds = (o) => o.second(), this.getMilliseconds = (o) => o.millisecond(), this.setYear = (o, s) => this.adjustOffset(o.set("year", s)), this.setMonth = (o, s) => this.adjustOffset(o.set("month", s)), this.setDate = (o, s) => this.adjustOffset(o.set("date", s)), this.setHours = (o, s) => this.adjustOffset(o.set("hour", s)), this.setMinutes = (o, s) => this.adjustOffset(o.set("minute", s)), this.setSeconds = (o, s) => this.adjustOffset(o.set("second", s)), this.setMilliseconds = (o, s) => this.adjustOffset(o.set("millisecond", s)), this.getDaysInMonth = (o) => o.daysInMonth(), this.getNextMonth = (o) => this.addMonths(o, 1), this.getPreviousMonth = (o) => this.addMonths(o, -1), this.getMonthArray = (o) => {
      const a = [o.startOf("year")];
      for (; a.length < 12; ) {
        const u = a[a.length - 1];
        a.push(this.addMonths(u, 1));
      }
      return a;
    }, this.mergeDateAndTime = (o, s) => o.hour(s.hour()).minute(s.minute()).second(s.second()), this.getWeekdays = () => {
      const o = this.dayjs().startOf("week");
      return [0, 1, 2, 3, 4, 5, 6].map((s) => this.formatByString(this.addDays(o, s), "dd"));
    }, this.getWeekArray = (o) => {
      const s = this.setLocaleToValue(o), a = s.startOf("month").startOf("week"), u = s.endOf("month").endOf("week");
      let c = 0, d = a;
      const f = [];
      for (; d < u; ) {
        const h = Math.floor(c / 7);
        f[h] = f[h] || [], f[h].push(d), d = this.addDays(d, 1), c += 1;
      }
      return f;
    }, this.getWeekNumber = (o) => o.week(), this.getYearRange = (o, s) => {
      const a = o.startOf("year"), u = s.endOf("year"), c = [];
      let d = a;
      for (; d < u; )
        c.push(d), d = this.addYears(d, 1);
      return c;
    }, this.getMeridiemText = (o) => o === "am" ? "AM" : "PM", this.rawDayJsInstance = r, this.dayjs = Nqe((i = this.rawDayJsInstance) != null ? i : Bi, t), this.locale = t, this.formats = N({}, $qe, n), Bi.extend(Tqe);
  }
}
var c$ = {}, Mqe = Eu;
Object.defineProperty(c$, "__esModule", {
  value: !0
});
var d$ = c$.default = void 0, Rqe = Mqe(kd()), _qe = P;
d$ = c$.default = (0, Rqe.default)(/* @__PURE__ */ (0, _qe.jsx)("path", {
  d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), "ExpandMore");
const SH = ({ schema: e, rootSchema: t, visible: n, renderers: r, cells: i, path: o, uischemas: s, uischema: a }) => {
  const u = az(s)(e, a.scope, o);
  if (!n)
    return null;
  if (u)
    return se.createElement(vl, { schema: e, uischema: u, path: o, renderers: r, cells: i });
  const c = MI(e.allOf, t, "allOf", a, o, s);
  return se.createElement(se.Fragment, null, c.map((d, f) => se.createElement(vl, { key: f, schema: d.schema, uischema: d.uischema, path: o, renderers: r, cells: i })));
}, Lqe = Gt(3, q2e);
var Bqe = $Fe(SH);
class AH extends se.Component {
  render() {
    const { schema: t, combinatorKeyword: n, path: r, rootSchema: i } = this.props, o = k7e(t, n), s = Wp.uiSchema(o, "VerticalLayout", void 0, i);
    let a = !1;
    return s !== null && sI(s) && (a = s.elements.length > 0), a ? se.createElement(vl, { schema: o, path: r, uischema: s }) : null;
  }
}
const wH = ({ open: e, handleClose: t, confirm: n, cancel: r, id: i }) => se.createElement(
  Zb,
  { open: e, onClose: t, "aria-labelledby": "alert-dialog-title", "aria-describedby": "alert-dialog-description" },
  se.createElement(zE, { id: "alert-dialog-title" }, "Clear form?"),
  se.createElement(
    tv,
    null,
    se.createElement(DF, { id: "alert-dialog-description" }, "Your data will be cleared if you navigate away from this tab. Do you want to proceed?")
  ),
  se.createElement(
    ev,
    null,
    se.createElement(Nr, { onClick: r, color: "primary" }, "No"),
    se.createElement(Nr, { onClick: n, color: "primary", autoFocus: !0, id: `${i}-confirm-yes` }, "Yes")
  )
), PH = ({ handleChange: e, schema: t, rootSchema: n, indexOfFittingSchema: r, visible: i, path: o, renderers: s, cells: a, uischema: u, uischemas: c, id: d, data: f }) => {
  const [h, m] = Et(r || 0), [v, x] = Et(!1), [C, E] = Et(0), S = Cn(() => x(!1), [x]), w = Cn((L, B) => {
    xn(f) || typeof f == typeof au($[B].schema, n) ? m(B) : (E(B), x(!0));
  }, [x, m, f]), O = (L) => {
    e(o, au($[L].schema, n)), m(L);
  }, A = Cn(() => {
    O(C), x(!1);
  }, [e, au, C]), I = "anyOf", $ = MI(t.anyOf, n, I, u, o, c);
  return i ? se.createElement(
    se.Fragment,
    null,
    se.createElement(AH, { schema: t, combinatorKeyword: I, path: o, rootSchema: n }),
    se.createElement(fg, { value: h, onChange: w }, $.map((L) => se.createElement(pd, { key: L.label, label: L.label }))),
    $.map((L, B) => h === B && se.createElement(vl, { key: B, schema: L.schema, uischema: L.uischema, path: o, renderers: s, cells: a })),
    se.createElement(wH, { cancel: S, confirm: A, id: "anyOf-" + d, open: v, handleClose: S })
  ) : null;
}, jqe = Gt(3, G2e);
var Vqe = FFe(PH);
const zqe = De(hn)({
  borderBottom: "none"
}), K0 = ({ children: e, ...t }) => se.createElement(zqe, { ...t }, e), Uqe = De(mF)(({ theme: e }) => ({
  color: e.palette.error.main
})), kH = ({ errorMessages: e, id: t }) => se.createElement(
  io,
  { id: t, title: e },
  se.createElement(
    Uqe,
    { badgeContent: e.split(`
`).length },
    se.createElement(HE, { color: "inherit" })
  )
), Wqe = {
  paddingLeft: 0,
  paddingRight: 0
}, Hqe = se.memo(function({ numColumns: t, errors: n, label: r, description: i, path: o, addItem: s, schema: a, enabled: u, translations: c, rootSchema: d, disableAdd: f }) {
  return se.createElement(
    _o,
    null,
    se.createElement(
      K0,
      { colSpan: t },
      se.createElement(
        nv,
        null,
        se.createElement(
          en,
          { container: !0, justifyContent: "flex-start", alignItems: "center", spacing: 2 },
          se.createElement(
            en,
            { item: !0 },
            se.createElement(cn, { variant: "h6" }, r)
          ),
          se.createElement(en, { item: !0 }, n.length !== 0 && se.createElement(
            en,
            { item: !0 },
            se.createElement(kH, { id: "tooltip-validation", errorMessages: n })
          ))
        ),
        i && se.createElement(gn, null, i)
      )
    ),
    u && !f ? se.createElement(
      K0,
      { align: "right", style: Wqe },
      se.createElement(
        io,
        { id: "tooltip-add", title: c.addTooltip, placement: "bottom" },
        se.createElement(
          Or,
          { "aria-label": c.addAriaLabel, onClick: s(o, au(a, d)), size: "large" },
          se.createElement(WE, null)
        )
      )
    ) : null
  );
}), Cj = {
  fixedCell: {
    width: "150px",
    height: "50px",
    paddingLeft: 0,
    paddingRight: 0,
    textAlign: "center"
  },
  fixedCellSmall: {
    width: "50px",
    height: "50px",
    paddingLeft: 0,
    paddingRight: 0,
    textAlign: "center"
  }
}, OH = (e, t, n, r, i) => {
  if (t.type === "object")
    return IH(t).map((o) => {
      var u, c;
      const s = Xm.compose(n, o), a = {
        propName: o,
        schema: t,
        title: ((c = (u = t.properties) == null ? void 0 : u[o]) == null ? void 0 : c.title) ?? UO(o),
        rowPath: n,
        cellPath: s,
        enabled: r,
        cells: i
      };
      return se.createElement(e, { key: s, ...a });
    });
  {
    const o = {
      schema: t,
      rowPath: n,
      cellPath: n,
      enabled: r
    };
    return se.createElement(e, { key: n, ...o });
  }
}, IH = (e) => e.type === "object" && typeof e.properties == "object" ? Object.keys(e.properties).filter((t) => e.properties[t].type !== "array") : [""], qqe = ({ numColumns: e, translations: t }) => se.createElement(
  _o,
  null,
  se.createElement(
    K0,
    { colSpan: e },
    se.createElement(cn, { align: "center" }, t.noDataMessage)
  )
), Gqe = se.memo(function({ title: t }) {
  return se.createElement(hn, null, t);
}), Yqe = (e, t) => {
  const n = t.rowPath + (t.schema.type === "object" ? "." + t.propName : ""), r = qV(Q7e(HV(n, t.schema, (i) => i === n)(e.core.errors).map((i) => i.message)));
  return {
    rowPath: t.rowPath,
    propName: t.propName,
    schema: t.schema,
    rootSchema: e.core.schema,
    errors: r,
    path: n,
    enabled: t.enabled,
    cells: t.cells || e.cells,
    renderers: t.renderers || e.renderers
  };
}, Ej = (e) => ({
  type: "Control",
  scope: e,
  label: !1
}), Kqe = se.memo(function({ path: t, propName: n, schema: r, rootSchema: i, errors: o, enabled: s, renderers: a, cells: u, isValid: c }) {
  return se.createElement(
    K0,
    null,
    r.properties ? se.createElement(mB, { schema: xo.schema(r, `#/properties/${_D(n)}`, i), uischema: Ej(`#/properties/${_D(n)}`), path: t, enabled: s, renderers: a, cells: u }) : se.createElement(mB, { schema: r, uischema: Ej("#"), path: t, enabled: s, renderers: a, cells: u }),
    se.createElement(gn, { error: !c }, !c && o)
  );
}), Jqe = (e) => {
  const t = So(), n = Yqe(t, e), r = xn(n.errors);
  return se.createElement(Kqe, { ...n, isValid: r });
}, Xqe = ({ childPath: e, schema: t, rowIndex: n, openDeleteDialog: r, moveUpCreator: i, moveDownCreator: o, enableUp: s, enableDown: a, showSortButtons: u, enabled: c, cells: d, path: f, translations: h, disableRemove: m }) => {
  const v = vn(() => i(f, n), [i, f, n]), x = vn(() => o(f, n), [o, f, n]);
  return se.createElement(
    _o,
    { key: e, hover: !0 },
    OH(Jqe, t, e, c, d),
    c ? se.createElement(
      K0,
      { style: u ? Cj.fixedCell : Cj.fixedCellSmall },
      se.createElement(
        en,
        { container: !0, direction: "row", justifyContent: "flex-end", alignItems: "center" },
        u ? se.createElement(
          P6,
          null,
          se.createElement(
            en,
            { item: !0 },
            se.createElement(
              io,
              { id: "tooltip-up", title: h.up, placement: "bottom", open: s ? void 0 : !1 },
              se.createElement(
                Or,
                { "aria-label": h.upAriaLabel, onClick: v, disabled: !s, size: "large" },
                se.createElement(RF, null)
              )
            )
          ),
          se.createElement(
            en,
            { item: !0 },
            se.createElement(
              io,
              { id: "tooltip-down", title: h.down, placement: "bottom", open: a ? void 0 : !1 },
              se.createElement(
                Or,
                { "aria-label": h.downAriaLabel, onClick: x, disabled: !a, size: "large" },
                se.createElement(NF, null)
              )
            )
          )
        ) : null,
        m ? null : se.createElement(
          en,
          { item: !0 },
          se.createElement(
            io,
            { id: "tooltip-remove", title: h.removeTooltip, placement: "bottom" },
            se.createElement(
              Or,
              { "aria-label": h.removeAriaLabel, onClick: () => r(e, n), size: "large" },
              se.createElement(vc, null)
            )
          )
        )
      )
    ) : null
  );
}, Qqe = se.memo(Xqe), Zqe = ({ data: e, path: t, schema: n, openDeleteDialog: r, moveUp: i, moveDown: o, uischema: s, config: a, enabled: u, cells: c, translations: d, disableRemove: f }) => {
  if (e === 0)
    return se.createElement(qqe, { numColumns: IH(n).length + 1, translations: d });
  const m = qn({}, a, s.options);
  return se.createElement(se.Fragment, null, Sb(e).map((v) => {
    const x = Xm.compose(t, `${v}`);
    return se.createElement(Qqe, { key: x, childPath: x, rowIndex: v, schema: n, openDeleteDialog: r, moveUpCreator: i, moveDownCreator: o, enableUp: v !== 0, enableDown: v !== e - 1, showSortButtons: m.showSortButtons || m.showArrayTableSortButtons, enabled: u, cells: c, path: t, translations: d, disableRemove: f });
  }));
};
class eGe extends se.Component {
  constructor() {
    super(...arguments), this.addItem = (t, n) => this.props.addItem(t, n);
  }
  render() {
    const { label: t, description: n, path: r, schema: i, rootSchema: o, uischema: s, errors: a, openDeleteDialog: u, visible: c, enabled: d, cells: f, translations: h, disableAdd: m, disableRemove: v, config: x } = this.props, C = qn({}, x, s.options), E = m || C.disableAdd, S = v || C.disableRemove, w = s, O = i.type === "object", A = O ? OH(Gqe, i, r, d, f) : void 0;
    return c ? se.createElement(
      gf,
      null,
      se.createElement(
        bf,
        null,
        se.createElement(Hqe, { errors: a, label: t, description: n, addItem: this.addItem, numColumns: O ? A.length : 1, path: r, uischema: w, schema: i, rootSchema: o, enabled: d, translations: h, disableAdd: E }),
        O && se.createElement(
          _o,
          null,
          A,
          d ? se.createElement(hn, null) : null
        )
      ),
      se.createElement(
        yf,
        null,
        se.createElement(Zqe, { openDeleteDialog: u, translations: h, ...this.props, disableRemove: S })
      )
    ) : null;
  }
}
const tGe = se.memo(function({ open: t, onClose: n, onConfirm: r, onCancel: i, title: o, message: s, acceptText: a, declineText: u }) {
  return se.createElement(
    Zb,
    { open: t, keepMounted: !0, onClose: n, "aria-labelledby": "alert-dialog-confirmdelete-title", "aria-describedby": "alert-dialog-confirmdelete-description" },
    se.createElement(zE, { id: "alert-dialog-confirmdelete-title" }, o),
    se.createElement(
      tv,
      null,
      se.createElement(DF, { id: "alert-dialog-confirmdelete-description" }, s)
    ),
    se.createElement(
      ev,
      null,
      se.createElement(Nr, { onClick: i, color: "primary" }, u),
      se.createElement(Nr, { onClick: r, color: "primary" }, a)
    )
  );
}), FH = (e) => {
  const [t, n] = Et(!1), [r, i] = Et(void 0), [o, s] = Et(void 0), { removeItems: a, visible: u, translations: c } = e, d = Cn((v, x) => {
    n(!0), i(v), s(x);
  }, [n, i, s]), f = Cn(() => n(!1), [n]), h = Cn(() => {
    const v = r.substring(0, r.lastIndexOf("."));
    a(v, [o])(), n(!1);
  }, [n, r, o]), m = Cn(() => n(!1), [n]);
  return u ? se.createElement(
    se.Fragment,
    null,
    se.createElement(eGe, { ...e, openDeleteDialog: d, translations: c }),
    se.createElement(tGe, { open: t, onCancel: f, onConfirm: h, onClose: m, acceptText: c.deleteDialogAccept, declineText: c.deleteDialogDecline, title: c.deleteDialogTitle, message: c.deleteDialogMessage })
  ) : null;
}, nGe = Gt(3, Qm(J2e, Q2e));
var rGe = yE(Ka(vE(FH)));
const ha = () => {
  const [e, t] = Et(!1), n = Cn(() => t(!0), []), r = Cn(() => t(!1), []);
  return [e, n, r];
}, $H = (e) => {
  const { description: t, errors: n, visible: r, required: i, label: o, data: s, className: a, id: u, enabled: c, uischema: d, path: f, handleChange: h, options: m, config: v, getOptionLabel: x, renderOption: C, filterOptions: E, isValid: S } = e, w = qn({}, v, d.options), [O, A] = se.useState(s ?? ""), [I, $, L] = ha(), B = m.find((X) => X.value === s) ?? null, H = !Do(r, t, I, w.showUnfocusedDescription), q = H ? t : S ? null : n, J = H && !S ? n : null;
  return r ? se.createElement(
    se.Fragment,
    null,
    se.createElement(BU, { className: a, id: u, disabled: !c, value: B, onChange: (X, j) => {
      h(f, j == null ? void 0 : j.value);
    }, inputValue: O, onInputChange: (X, j) => {
      A(j);
    }, autoHighlight: !0, autoComplete: !0, fullWidth: !0, options: m, getOptionLabel: x || ((X) => X == null ? void 0 : X.label), freeSolo: !1, renderInput: (X) => se.createElement(vf, { label: o, type: "text", inputProps: X.inputProps, inputRef: X.InputProps.ref, autoFocus: w.focus, disabled: !c, ...X, id: u, required: i && !w.hideRequiredAsterisk, error: !S, fullWidth: !w.trim, InputLabelProps: s ? { shrink: !0 } : void 0, onFocus: $, onBlur: L, focused: I }), renderOption: C, filterOptions: E }),
    se.createElement(gn, { error: !S && !H }, q),
    se.createElement(gn, { error: !S }, J)
  ) : null;
}, gg = se.memo(function(t) {
  const { data: n, className: r, id: i, enabled: o, uischema: s, path: a, handleChange: u, config: c, inputProps: d } = t, f = qn({}, c, s.options), h = qn({}, d, {
    autoFocus: !!f.focus
  }), m = !!n;
  return se.createElement(rc, { checked: m, onChange: (v, x) => u(a, x), className: r, id: i, disabled: !o, inputProps: h });
});
BF.extend(yVe);
const p$ = (e, t, n) => (r) => {
  if (!r)
    t(e, void 0);
  else if (r.toString() !== "Invalid Date") {
    const i = J0(r, n);
    t(e, i);
  }
}, f$ = (e, t, n, r, i, o) => (s) => {
  const a = BF(s.target.value, n), u = J0(a, r);
  u.toString() === "Invalid Date" ? (t(e, void 0), i()) : t(e, u), o();
}, J0 = (e, t) => {
  let n = e.format(t);
  const r = t.indexOf("YYYY");
  if (e.year() < 1e3 && r !== -1) {
    const i = n.slice(0, r), o = n.slice(r);
    e.year() >= 100 ? n = [i, 0, o].join("") : e.year() >= 10 ? n = [i, 0, 0, o].join("") : e.year() >= 1 && (n = [i, 0, 0, 0, o].join(""));
  }
  return n;
}, h$ = (e, t) => {
  if (!e)
    return null;
  const n = BF(e, t);
  return n.toString() === "Invalid Date" ? null : n;
}, iGe = (e, t, n, r, i, o) => e.map((s, a) => se.createElement(
  en,
  { item: !0, key: `${n}-${a}`, xs: !0 },
  se.createElement(vl, { uischema: s, schema: t, path: n, enabled: r, renderers: i, cells: o })
)), oGe = ({ visible: e, elements: t, schema: n, path: r, enabled: i, direction: o, renderers: s, cells: a }) => xn(t) || !e ? null : se.createElement(en, { container: !0, direction: o, spacing: o === "row" ? 2 : 0 }, iGe(t, n, r, i, s, a)), Ef = se.memo(oGe), NH = (e) => function(n) {
  const r = So(), i = Zm({ jsonforms: { ...r } });
  return se.createElement(e, { ...n, ajv: i });
}, Tj = {
  standard: iv,
  filled: Su,
  outlined: Zo
}, MH = "outlined";
function Tf() {
  const { variant: e = MH } = Vn({
    props: {},
    name: "MuiTextField"
  });
  return e;
}
function Sf() {
  const e = Tf();
  return Tj[e] ?? Tj[MH];
}
const sGe = (e) => e.target.value, Af = (e, t, n, r, i = sGe, o = 300) => {
  const [s, a] = Et(n ?? t);
  rn(() => {
    a(n ?? t);
  }, [n]);
  const u = Cn(Cz((f) => e(r, f), o), [e, r, o]), c = Cn((f) => {
    const h = i(f);
    a(h ?? t), u(h);
  }, [u, i]), d = Cn(() => {
    a(t), e(r, void 0);
  }, [t, e, r]);
  return [s, c, d];
}, aGe = {
  "enum.none": "None"
}, lGe = (e) => e === "" ? void 0 : parseInt(e, 10), uGe = (e) => lGe(e.target.value), RH = se.memo(function(t) {
  const { data: n, className: r, id: i, enabled: o, uischema: s, path: a, handleChange: u, config: c, label: d } = t, f = Sf(), h = { step: "1" }, m = qn({}, c, s.options), [v, x] = Af(u, "", n, a, uGe);
  return se.createElement(f, { label: d, type: "number", value: v, onChange: x, className: r, id: i, disabled: !o, autoFocus: m.focus, inputProps: h, fullWidth: !0 });
}), cGe = (e) => e === "" ? void 0 : parseFloat(e), dGe = (e) => cGe(e.target.value), _H = se.memo(function(t) {
  const { data: n, className: r, id: i, enabled: o, uischema: s, path: a, handleChange: u, config: c, label: d } = t, f = Sf(), h = { step: "0.1" }, m = qn({}, c, s.options), [v, x] = Af(u, "", n, a, dGe);
  return se.createElement(f, { type: "number", label: d, value: v, onChange: x, className: r, id: i, disabled: !o, autoFocus: m.focus, inputProps: h, fullWidth: !0 });
}), pGe = se.memo(function(t) {
  const { className: n, id: r, enabled: i, uischema: o, isValid: s, path: a, handleChange: u, schema: c, config: d, label: f } = t, h = Sf(), m = c.maxLength, v = qn({}, d, o.options);
  let x;
  v.restrict ? x = { maxLength: m } : x = {};
  const C = t.toFormatted(t.data), E = Cn((O) => t.fromFormatted(O.currentTarget.value), [t.fromFormatted]), [S, w] = Af(u, "", C, a, E);
  return se.createElement(h, { type: "text", value: S, onChange: w, className: n, id: r, label: f, disabled: !i, autoFocus: v.focus, multiline: v.multi, fullWidth: !v.trim || m === void 0, inputProps: x, error: !s });
}), fGe = (e) => e.target.value === "" ? void 0 : e.target.value, LH = se.memo(function(t) {
  var J, X, j;
  const [n, r] = Et(!1), { data: i, config: o, className: s, id: a, enabled: u, uischema: c, isValid: d, path: f, handleChange: h, schema: m, muiInputProps: v, label: x, inputComponent: C } = t, E = Sf(), S = m.maxLength, w = qn({}, o, c.options);
  let O;
  w.restrict ? O = { maxLength: S } : O = {}, O = qn(O, v), w.trim && S !== void 0 && (O.size = S);
  const [A, I, $] = Af(h, "", i, f, fGe), L = () => r(!0), B = () => r(!1), H = Gi(), q = {
    background: ((j = (X = (J = H.jsonforms) == null ? void 0 : J.input) == null ? void 0 : X.delete) == null ? void 0 : j.background) || H.palette.background.default,
    borderRadius: "50%"
  };
  return se.createElement(E, { label: x, type: w.format === "password" ? "password" : "text", value: A, onChange: I, className: s, id: a, disabled: !u, autoFocus: w.focus, multiline: w.multi, fullWidth: !w.trim || S === void 0, inputProps: O, error: !d, onPointerEnter: L, onPointerLeave: B, endAdornment: se.createElement(
    lg,
    { position: "end", style: {
      display: !n || !u || i === void 0 ? "none" : "flex",
      position: "absolute",
      right: 0
    } },
    se.createElement(
      Or,
      { "aria-label": "Clear input field", onClick: $, size: "large" },
      se.createElement(mW, { style: q })
    )
  ), inputComponent: C });
}), hGe = se.memo(function(t) {
  const { data: n, className: r, id: i, enabled: o, uischema: s, path: a, handleChange: u, config: c, label: d } = t, f = Sf(), h = qn({}, c, s.options), [m, v] = Af(u, "", n, a);
  return se.createElement(f, { type: "time", value: m, onChange: v, className: r, id: i, label: d, disabled: !o, autoFocus: h.focus, fullWidth: !0 });
}), eT = se.memo(function(t) {
  const { data: n, className: r, id: i, enabled: o, schema: s, uischema: a, path: u, handleChange: c, options: d, config: f, label: h, t: m, multiple: v } = t, x = qn({}, f, a.options), C = vn(() => m("enum.none", aGe["enum.none"], { schema: s, uischema: a, path: u }), [m, s, a, u]);
  return se.createElement(mf, { className: r, id: i, label: h, disabled: !o, autoFocus: x.focus, value: n !== void 0 ? n : "", onChange: (E) => c(u, E.target.value || void 0), fullWidth: !0, multiple: v || !1 }, [
    se.createElement(
      ks,
      { value: "", key: "jsonforms.enum.none" },
      se.createElement("em", null, C)
    )
  ].concat(d.map((E) => se.createElement(ks, { value: E.value, key: E.value }, E.label))));
}), BH = se.memo(function(t) {
  const { data: n, className: r, id: i, enabled: o, uischema: s, path: a, handleChange: u, config: c, inputProps: d } = t, f = qn({}, c, s.options), h = qn({}, d, {
    autoFocus: !!f.focus
  }), m = !!n;
  return se.createElement(uW, { checked: m, onChange: (v, x) => u(a, x), className: r, id: i, disabled: !o, inputProps: h });
}), jH = ({ config: e, id: t, schema: n, visible: r, errors: i, description: o, label: s, required: a, path: u, options: c, data: d, addItem: f, removeItem: h, handleChange: m, ...v }) => {
  const [x, C, E] = ha(), S = i.length === 0, w = qn({}, e, v.uischema.options), O = !Do(r, o, x, w.showUnfocusedDescription);
  return r ? se.createElement(
    hi,
    { component: "fieldset", fullWidth: !w.trim, onFocus: C, onBlur: E },
    se.createElement(fa, { error: !S, component: "legend", required: da(a, w.hideRequiredAsterisk) }, s),
    se.createElement(rv, { row: !0 }, c.map((A, I) => {
      const $ = Xm.compose(u, `${I}`), L = d != null && d.includes(A.value) ? A.value : void 0;
      return se.createElement(Ps, { id: t + "-label-" + A.value, key: A.value, control: se.createElement(gg, { id: t + "-" + A.value, key: "checkbox-" + A.value, isValid: xn(i), path: $, handleChange: (B, H) => H ? f(u, A.value) : h(u, A.value), data: L, errors: i, schema: n, visible: r, ...v }), label: A.label });
    })),
    se.createElement(gn, { error: !S }, S ? O ? o : null : i)
  ) : null;
}, mGe = (e) => e.oneOf !== void 0 && e.oneOf.length > 0 && e.oneOf.every((t) => t.const !== void 0), gGe = (e) => e.type === "string" && e.enum !== void 0, yGe = Gt(5, pr(dn("Control"), pr(ca((e) => to(e, "array") && !Array.isArray(e.items) && e.uniqueItems === !0), pE("items", (e, t) => {
  const n = e.$ref ? ls(t, e.$ref, t) : e;
  return mGe(n) || gGe(n);
}))));
var bGe = bE(jH);
const VH = ({ renderers: e, cells: t, uischemas: n, schema: r, label: i, path: o, visible: s, enabled: a, uischema: u, rootSchema: c }) => {
  const d = vn(() => $b(n, r, u.scope, o, () => xn(o) ? Wp.uiSchema(r, "VerticalLayout", void 0, c) : {
    ...Wp.uiSchema(r, "Group", void 0, c),
    label: i
  }, u, c), [n, r, u.scope, o, i, u, c]);
  return s ? se.createElement(vl, { visible: s, enabled: a, schema: r, uischema: d, path: o, renderers: e, cells: t }) : null;
}, vGe = Gt(2, H2e);
var xGe = NFe(VH);
const zH = ({ handleChange: e, schema: t, path: n, renderers: r, cells: i, rootSchema: o, id: s, visible: a, indexOfFittingSchema: u, uischema: c, uischemas: d, data: f }) => {
  const [h, m] = Et(!1), [v, x] = Et(u || 0), [C, E] = Et(0), S = Cn(() => m(!1), [m]), w = Cn(() => {
    m(!1);
  }, [m]), O = vn(() => MI(t.oneOf, o, "oneOf", c, n, d), [t, o, c, n, d]), A = (L) => {
    e(n, au(O[L].schema, o)), x(L);
  }, I = Cn(() => {
    A(C), m(!1);
  }, [e, au, C]), $ = Cn((L, B) => {
    E(B), xn(f) ? A(B) : m(!0);
  }, [m, x, f]);
  return a ? se.createElement(
    se.Fragment,
    null,
    se.createElement(AH, { schema: t, combinatorKeyword: "oneOf", path: n, rootSchema: o }),
    se.createElement(fg, { value: v, onChange: $ }, O.map((L) => se.createElement(pd, { key: L.label, label: L.label }))),
    O.map((L, B) => v === B && se.createElement(vl, { key: B, schema: L.schema, uischema: L.uischema, path: n, renderers: r, cells: i })),
    se.createElement(wH, { cancel: w, confirm: I, id: "oneOf-" + s, open: h, handleClose: S })
  ) : null;
}, DGe = Gt(3, Y2e);
var CGe = IFe(zH);
const EGe = Gt(1, dn("Label")), UH = ({ text: e, visible: t }) => t ? se.createElement(cn, { variant: "h6" }, e) : null;
var TGe = LFe(UH);
const WH = se.memo(function({ label: t, description: n, errors: r, addItem: i, path: o, enabled: s, createDefault: a, translations: u, disableAdd: c }) {
  return se.createElement(
    pg,
    { disableGutters: !0 },
    se.createElement(
      nv,
      null,
      se.createElement(
        en,
        { container: !0, alignItems: "center", justifyContent: "space-between" },
        se.createElement(
          en,
          { item: !0 },
          se.createElement(
            en,
            { container: !0, justifyContent: "flex-start", alignItems: "center", spacing: 2 },
            se.createElement(
              en,
              { item: !0 },
              se.createElement(cn, { variant: "h6" }, t)
            ),
            se.createElement(en, { item: !0 }, r.length !== 0 && se.createElement(
              en,
              { item: !0 },
              se.createElement(kH, { id: "tooltip-validation", errorMessages: r })
            ))
          )
        ),
        s && !c && se.createElement(
          en,
          { item: !0 },
          se.createElement(
            en,
            { container: !0 },
            se.createElement(
              en,
              { item: !0 },
              se.createElement(
                io,
                { id: "tooltip-add", title: u.addTooltip, placement: "bottom" },
                se.createElement(
                  Or,
                  { "aria-label": u.addTooltip, onClick: i(o, a()), size: "large" },
                  se.createElement(WE, null)
                )
              )
            )
          )
        )
      ),
      n && se.createElement(gn, null, n)
    )
  );
}), SGe = ({ index: e, childLabel: t, selected: n, enabled: r, handleSelect: i, removeItem: o, path: s, translations: a, disableRemove: u }) => se.createElement(
  UE,
  { button: !0, selected: n, onClick: i(e) },
  se.createElement(
    CF,
    null,
    se.createElement(jE, { "aria-label": "Index" }, e + 1)
  ),
  se.createElement(hf, { primary: t }),
  r && !u && se.createElement(
    sv,
    null,
    se.createElement(
      io,
      { id: "tooltip-remove", title: a.removeTooltip, placement: "bottom" },
      se.createElement(
        Or,
        { "aria-label": a.removeAriaLabel, onClick: o(s, e), size: "large" },
        se.createElement(vc, null)
      )
    )
  )
);
var AGe = Az(SGe);
const HH = ({ uischemas: e, schema: t, uischema: n, path: r, enabled: i, errors: o, visible: s, label: a, required: u, removeItems: c, addItem: d, data: f, renderers: h, cells: m, config: v, rootSchema: x, description: C, disableAdd: E, disableRemove: S, translations: w }) => {
  const [O, A] = Et(void 0), I = Cn((X, j) => () => {
    c(X, [j])(), O === j ? A(void 0) : O > j && A(O - 1);
  }, [c, A]), $ = Cn((X) => () => A(X), [A]), L = Cn(() => au(t, x), [au]), B = vn(() => $b(e, t, n.scope, r, void 0, n, x), [e, t, n.scope, r, n, x]), H = qn({}, v, n.options), q = E || H.disableAdd, J = S || H.disableRemove;
  return se.useEffect(() => {
    A(void 0);
  }, [t]), s ? se.createElement(
    se.Fragment,
    null,
    se.createElement(WH, { translations: w, label: $I(a, u, H.hideRequiredAsterisk), description: C, errors: o, path: r, enabled: i, addItem: d, createDefault: L, disableAdd: q }),
    se.createElement(
      en,
      { container: !0, direction: "row", spacing: 2 },
      se.createElement(
        en,
        { item: !0, xs: 3 },
        se.createElement(ov, null, f > 0 ? VF(Sb(f), (X) => se.createElement(AGe, { index: X, path: r, schema: t, enabled: i, handleSelect: $, removeItem: I, selected: O === X, key: X, uischema: B, childLabelProp: H.elementLabelProp, translations: w, disableRemove: J })) : se.createElement("p", null, w.noDataMessage))
      ),
      se.createElement(en, { item: !0, xs: !0 }, O !== void 0 ? se.createElement(vl, { renderers: h, cells: m, visible: s, schema: t, uischema: B, path: pf(r, `${O}`) }) : se.createElement(cn, { variant: "h6" }, w.noSelection))
    )
  ) : null;
}, wGe = Gt(4, pr(dn("ListWithDetail"), II));
var PGe = yE(Ka(vE(HH)));
const yg = (e) => {
  const [t, n, r] = ha(), { id: i, description: o, errors: s, label: a, uischema: u, visible: c, required: d, config: f, input: h } = e, m = Tf(), v = s.length === 0, x = qn({}, f, u.options), C = !Do(c, o, t, x.showUnfocusedDescription), E = C ? o : v ? null : s, S = C && !v ? s : null, w = h;
  return c ? se.createElement(
    hi,
    { fullWidth: !x.trim, onFocus: n, onBlur: r, variant: m, id: i },
    se.createElement(ra, { htmlFor: i + "-input", error: !v, required: da(d, x.hideRequiredAsterisk) }, a),
    se.createElement(w, { ...e, id: i + "-input", isValid: v, visible: c }),
    se.createElement(gn, { error: !v && !C }, E),
    se.createElement(gn, { error: !v }, S)
  ) : null;
}, qH = (e) => e.find((t) => t.enum !== void 0 && (t.type === "string" || t.type === void 0)), GH = (e) => e.find((t) => t.type === "string" && t.enum === void 0), kGe = (e) => {
  const { data: t, config: n, className: r, id: i, enabled: o, uischema: s, isValid: a, path: u, handleChange: c, schema: d, label: f } = e, h = Sf(), m = qH(d.anyOf), x = GH(d.anyOf).maxLength, C = vn(() => qn({}, n, s.options), [n, s.options]), E = vn(() => {
    let A = {};
    return C.restrict && (A = { maxLength: x }), C.trim && x !== void 0 && (A.size = x), A.list = e.id + "datalist", A;
  }, [C, e.id]), [S, w] = Af(c, "", t, u), O = se.createElement("datalist", { id: e.id + "datalist" }, m.enum.map((A) => se.createElement("option", { value: A, key: A })));
  return se.createElement(h, { type: "text", value: S, onChange: w, className: r, id: i, label: f, disabled: !o, autoFocus: C.focus, fullWidth: !C.trim || x === void 0, inputProps: E, error: !a, endAdornment: O });
};
class YH extends HIe {
  render() {
    return se.createElement(yg, { ...this.props, input: kGe });
  }
}
const OGe = (e) => {
  const t = qH(e), n = GH(e), i = e.filter((o) => o !== t || o !== n).find((o) => o.type && o.type !== "string");
  return t && n && !i;
}, IGe = pr(dn("Control"), ca((e) => Object.prototype.hasOwnProperty.call(e, "anyOf") && OGe(e.anyOf))), FGe = Gt(5, IGe);
var $Ge = li(YH);
const KH = ({ data: e, visible: t, label: n, id: r, enabled: i, uischema: o, schema: s, rootSchema: a, handleChange: u, errors: c, path: d, config: f, description: h }) => {
  const m = c.length === 0, v = qn({}, f, o.options), x = !Do(
    t,
    h,
    !1,
    v.showUnfocusedDescription
  ), C = !x && !Do(
    t,
    h,
    !0,
    !0
  ), E = x ? h : m ? null : c, S = x && !m ? c : null, w = [], O = `${r}-tip`, A = `${r}-help1`, I = `${r}-help2`;
  C && w.push(O), E && w.push(A), S && w.push(I);
  const $ = w.join(" ");
  return t ? se.createElement(
    se.Fragment,
    null,
    se.createElement(
      io,
      { id: O, title: C ? h : "" },
      se.createElement(Ps, { label: n, id: r, control: se.createElement(gg, { id: `${r}-input`, isValid: xn(c), data: e, enabled: i, visible: t, path: d, uischema: o, schema: s, rootSchema: a, handleChange: u, errors: c, config: f, inputProps: {
        "aria-describedby": $
      } }) })
    ),
    se.createElement(gn, { id: A, error: !m && !x }, E),
    se.createElement(gn, { id: I, error: !m }, S)
  ) : null;
}, NGe = Gt(2, fE);
var MGe = li(KH);
const JH = ({ data: e, visible: t, label: n, id: r, enabled: i, uischema: o, schema: s, rootSchema: a, handleChange: u, errors: c, path: d, config: f, description: h }) => {
  const m = c.length === 0, v = qn({}, f, o.options), x = !Do(
    t,
    h,
    !1,
    v.showUnfocusedDescription
  ), C = !x && !Do(
    t,
    h,
    !0,
    !0
  ), E = x ? h : m ? null : c, S = x && !m ? c : null, w = [], O = `${r}-tip`, A = `${r}-help1`, I = `${r}-help2`;
  C && w.push(O), E && w.push(A), S && w.push(I);
  const $ = w.join(" ");
  return t ? se.createElement(
    se.Fragment,
    null,
    se.createElement(
      io,
      { id: O, title: C ? h : "" },
      se.createElement(Ps, { label: n, id: r, control: se.createElement(BH, { id: `${r}-input`, isValid: xn(c), data: e, enabled: i, visible: t, path: d, uischema: o, schema: s, rootSchema: a, handleChange: u, errors: c, config: f, inputProps: {
        "aria-describedby": $
      } }) })
    ),
    se.createElement(gn, { id: A, error: !m && !x }, E),
    se.createElement(gn, { id: I, error: !m }, S)
  ) : null;
}, RGe = Gt(3, pr(fE, Al("toggle", !0)));
var _Ge = li(JH);
const XH = (e) => {
  const [t, n, r] = ha(), { description: i, id: o, errors: s, label: a, uischema: u, visible: c, enabled: d, required: f, path: h, handleChange: m, data: v, config: x } = e, C = s.length === 0, E = qn({}, x, u.options), S = !Do(c, i, t, E.showUnfocusedDescription), [w, O] = Et(0), [A, I] = Et(!1), $ = E.dateFormat ?? "YYYY-MM-DD", L = E.dateSaveFormat ?? lI, B = E.views ?? ["year", "day"], H = S ? i : C ? null : s, q = S && !C ? s : null, J = Cn(() => O((G) => G + 1), []), X = vn(() => p$(h, m, L), [h, m, L]), j = vn(() => f$(h, m, $, L, J, r), [h, m, $, L, J]), U = h$(v, L);
  return c ? se.createElement(
    Od,
    { dateAdapter: pv },
    se.createElement(ZE, { open: A, onOpen: () => I(!0), onClose: () => I(!1), key: w, label: a, value: U, onAccept: X, format: $, views: B, disabled: !d, slotProps: {
      actionBar: ({ wrapperVariant: G }) => ({
        actions: G === "desktop" ? [] : ["clear", "cancel", "accept"]
      }),
      textField: {
        id: o + "-input",
        required: f && !E.hideRequiredAsterisk,
        autoFocus: E.focus,
        error: !C,
        fullWidth: !E.trim,
        inputProps: {
          type: "text"
        },
        InputLabelProps: v ? { shrink: !0 } : void 0,
        onFocus: n,
        onBlur: j
      }
    } }),
    se.createElement(gn, { error: !C && !S }, H),
    se.createElement(gn, { error: !C }, q)
  ) : null;
}, LGe = Gt(4, kI);
var BGe = li(XH);
const QH = (e) => {
  const [t, n, r] = ha(), { id: i, description: o, errors: s, label: a, uischema: u, visible: c, enabled: d, required: f, path: h, handleChange: m, data: v, config: x } = e, C = qn({}, x, u.options), E = s.length === 0, S = !Do(c, o, t, C.showUnfocusedDescription), w = C.dateTimeFormat ?? "YYYY-MM-DD HH:mm", O = C.dateTimeSaveFormat ?? o2e, [A, I] = Et(0), [$, L] = Et(!1), B = C.views ?? [
    "year",
    "day",
    "hours",
    "minutes"
  ], H = S ? o : E ? null : s, q = S && !E ? s : null, J = Cn(() => I((G) => G + 1), []), X = vn(() => p$(h, m, O), [h, m, O]), j = vn(() => f$(h, m, w, O, J, r), [h, m, w, O, J]), U = h$(v, O);
  return c ? se.createElement(
    Od,
    { dateAdapter: pv },
    se.createElement(vH, { open: $, onOpen: () => L(!0), onClose: () => L(!1), key: A, label: a, value: U, onAccept: X, format: w, ampm: !!C.ampm, views: B, disabled: !d, slotProps: {
      actionBar: ({ wrapperVariant: G }) => ({
        actions: G === "desktop" ? [] : ["clear", "cancel", "accept"]
      }),
      textField: {
        id: i + "-input",
        required: f && !C.hideRequiredAsterisk,
        autoFocus: C.focus,
        error: !E,
        fullWidth: !C.trim,
        inputProps: {
          type: "text"
        },
        InputLabelProps: v ? { shrink: !0 } : void 0,
        onFocus: n,
        onBlur: j
      }
    } }),
    se.createElement(gn, { error: !E && !S }, H),
    se.createElement(gn, { error: !E }, q)
  ) : null;
}, jGe = Gt(2, K2e);
var VGe = li(QH);
const ZH = (e) => {
  const { config: t, uischema: n, errors: r } = e, i = qn({}, t, n.options), o = r.length === 0;
  return i.autocomplete === !1 ? se.createElement(yg, { ...e, input: eT }) : se.createElement($H, { ...e, isValid: o });
}, zGe = Gt(2, hE);
var UGe = Mb(Ka(se.memo(ZH)), !1);
const eq = (e) => se.createElement(yg, { ...e, input: RH }), WGe = Gt(2, rz);
var HGe = li(eq);
const tq = (e) => {
  const [t, n, r] = ha(), { id: i, errors: o, label: s, schema: a, description: u, enabled: c, visible: d, required: f, path: h, handleChange: m, data: v, config: x } = e, C = o.length === 0, E = qn({}, x, e.uischema.options), [S, w] = Af(m, "", v, h), O = E.format ?? a.format, A = !Do(d, u, t, E.showUnfocusedDescription);
  return d ? se.createElement(vf, { required: da(f, E.hideRequiredAsterisk), id: i + "-input", label: s, type: O, error: !C, disabled: !c, fullWidth: !E.trim, onFocus: n, onBlur: r, helperText: C ? A ? u : null : o, InputLabelProps: { shrink: !0 }, value: S, onChange: w }) : null;
}, qGe = Gt(2, Qm(kI, OI));
var GGe = li(tq);
const nq = (e) => se.createElement(yg, { ...e, input: _H }), YGe = Gt(2, iz);
var KGe = li(nq);
const rq = (e) => {
  const { config: t, uischema: n, errors: r } = e, i = qn({}, t, n.options), o = r.length === 0;
  return i.autocomplete === !1 ? se.createElement(yg, { ...e, input: eT }) : se.createElement($H, { ...e, isValid: o });
}, JGe = Gt(5, PI);
var XGe = wz(Ka(se.memo(rq)), !1);
const iq = (e) => {
  const [t, n, r] = ha(), { config: i, label: o, required: s, description: a, errors: u, data: c, visible: d, options: f, handleChange: h, path: m, enabled: v } = e, x = u.length === 0, C = qn({}, i, e.uischema.options), E = !Do(d, a, t, C.showUnfocusedDescription);
  return d ? se.createElement(
    hi,
    { component: "fieldset", fullWidth: !C.trim, onFocus: n, onBlur: r },
    se.createElement(fa, { error: !x, component: "legend", required: da(s, C.hideRequiredAsterisk) }, o),
    se.createElement(PF, { value: e.data ?? "", row: !0 }, f.map((S) => se.createElement(Ps, { value: S.value, key: S.label, control: se.createElement(wF, { checked: c === S.value, onChange: () => h(m, S.value) }), label: S.label, disabled: !v }))),
    se.createElement(gn, { error: !x }, x ? E ? a : null : u)
  ) : null;
}, oq = (e) => se.createElement(iq, { ...e }), QGe = Gt(20, pr(PI, Al("format", "radio")));
var ZGe = wz(oq);
const sq = (e) => se.createElement(iq, { ...e }), eYe = Gt(20, pr(hE, Al("format", "radio")));
var tYe = Mb(sq);
const aq = (e) => {
  const [t, n, r] = ha(), { id: i, data: o, description: s, enabled: a, errors: u, label: c, schema: d, handleChange: f, visible: h, path: m, required: v, config: x } = e, C = u.length === 0, E = qn({}, x, e.uischema.options), S = {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    width: "100%"
  }, w = {
    display: "flex"
  }, O = {
    flexGrow: "1"
  }, A = {
    marginTop: "7px"
  }, I = !Do(h, s, t, E.showUnfocusedDescription), $ = Cn((L, B) => f(m, Number(B)), [m, f]);
  return h ? se.createElement(
    hi,
    { fullWidth: !E.trim, onFocus: n, onBlur: r, id: i },
    se.createElement(
      fa,
      { htmlFor: i, error: !C, component: "legend", required: da(v, E.hideRequiredAsterisk) },
      se.createElement(cn, { id: i + "-typo", style: S, variant: "caption" }, c)
    ),
    se.createElement(
      "div",
      { style: w },
      se.createElement(cn, { style: O, variant: "caption", align: "left" }, d.minimum),
      se.createElement(cn, { style: O, variant: "caption", align: "right" }, d.maximum)
    ),
    se.createElement(rW, { style: A, min: d.minimum, max: d.maximum, value: Number(o || d.default), onChange: $, id: i + "-input", disabled: !a, step: d.multipleOf || 1 }),
    se.createElement(gn, { error: !C }, C ? I ? s : null : u)
  ) : null;
}, nYe = Gt(4, Z2e);
var rYe = li(aq);
const lq = (e) => se.createElement(yg, { ...e, input: LH }), iYe = Gt(1, oz);
var oYe = li(lq);
const uq = (e) => {
  const [t, n, r] = ha(), { id: i, description: o, errors: s, label: a, uischema: u, visible: c, enabled: d, required: f, path: h, handleChange: m, data: v, config: x } = e, C = qn({}, x, u.options), E = s.length === 0, [S, w] = Et(0), [O, A] = Et(!1), I = !Do(c, o, t, C.showUnfocusedDescription), $ = C.timeFormat ?? "HH:mm", L = C.timeSaveFormat ?? i2e, B = C.views ?? ["hours", "minutes"], H = I ? o : E ? null : s, q = I && !E ? s : null, J = Cn(() => w((G) => G + 1), []), X = vn(() => p$(h, m, L), [h, m, L]), j = vn(() => f$(h, m, $, L, J, r), [h, m, $, L, J]), U = h$(v, L);
  return c ? se.createElement(
    Od,
    { dateAdapter: pv },
    se.createElement(dH, { open: O, onOpen: () => A(!0), onClose: () => A(!1), key: S, label: a, value: U, onAccept: X, format: $, ampm: !!C.ampm, views: B, disabled: !d, slotProps: {
      actionBar: ({ wrapperVariant: G }) => ({
        actions: G === "desktop" ? [] : ["clear", "cancel", "accept"]
      }),
      textField: {
        id: i + "-input",
        required: f && !C.hideRequiredAsterisk,
        autoFocus: C.focus,
        error: !E,
        fullWidth: !C.trim,
        inputProps: {
          type: "text"
        },
        InputLabelProps: v ? { shrink: !0 } : void 0,
        onFocus: n,
        onBlur: j
      }
    } }),
    se.createElement(gn, { error: !E && !I }, H),
    se.createElement(gn, { error: !E }, q)
  ) : null;
}, sYe = Gt(4, OI);
var aYe = li(uq);
const aw = { float: "right" }, lYe = (e) => {
  const [t] = Et($P("expand-panel"));
  rn(() => () => {
    NP(t);
  }, [t]);
  const { enabled: n, childLabel: r, childPath: i, index: o, expanded: s, moveDown: a, moveUp: u, enableMoveDown: c, enableMoveUp: d, handleExpansion: f, removeItems: h, path: m, rootSchema: v, schema: x, uischema: C, uischemas: E, renderers: S, cells: w, config: O, translations: A, disableRemove: I } = e, $ = vn(() => $b(E, x, C.scope, m, void 0, C, v), [E, x, C.scope, m, C, v]), L = qn({}, O, C.options), B = L.showSortButtons || L.showArrayLayoutSortButtons;
  return se.createElement(
    eF,
    { "aria-labelledby": t, expanded: s, onChange: f(i) },
    se.createElement(
      nF,
      { expandIcon: se.createElement(d$, null) },
      se.createElement(
        en,
        { container: !0, alignItems: "center" },
        se.createElement(
          en,
          { item: !0, xs: 7, md: 9 },
          se.createElement(
            en,
            { container: !0, alignItems: "center" },
            se.createElement(
              en,
              { item: !0, xs: 2, md: 1 },
              se.createElement(jE, { "aria-label": "Index" }, o + 1)
            ),
            se.createElement(
              en,
              { item: !0, xs: 10, md: 11 },
              se.createElement("span", { id: t }, r)
            )
          )
        ),
        se.createElement(
          en,
          { item: !0, xs: 5, md: 3 },
          se.createElement(
            en,
            { container: !0, justifyContent: "flex-end" },
            se.createElement(
              en,
              { item: !0 },
              se.createElement(
                en,
                { container: !0, direction: "row", justifyContent: "center", alignItems: "center" },
                B && n ? se.createElement(
                  P6,
                  null,
                  se.createElement(
                    en,
                    { item: !0 },
                    se.createElement(
                      io,
                      { id: "tooltip-up", title: A.up, placement: "bottom", open: d ? void 0 : !1 },
                      se.createElement(
                        Or,
                        { onClick: u(m, o), style: aw, disabled: !d, "aria-label": A.upAriaLabel, size: "large" },
                        se.createElement(RF, null)
                      )
                    )
                  ),
                  se.createElement(
                    en,
                    { item: !0 },
                    se.createElement(
                      io,
                      { id: "tooltip-down", title: A.down, placement: "bottom", open: c ? void 0 : !1 },
                      se.createElement(
                        Or,
                        { onClick: a(m, o), style: aw, disabled: !c, "aria-label": A.downAriaLabel, size: "large" },
                        se.createElement(NF, null)
                      )
                    )
                  )
                ) : "",
                n && !I && se.createElement(
                  en,
                  { item: !0 },
                  se.createElement(
                    io,
                    { id: "tooltip-remove", title: A.removeTooltip, placement: "bottom" },
                    se.createElement(
                      Or,
                      { onClick: h(m, [o]), style: aw, "aria-label": A.removeAriaLabel, size: "large" },
                      se.createElement(vc, null)
                    )
                  )
                )
              )
            )
          )
        )
      )
    ),
    se.createElement(
      tF,
      null,
      se.createElement(vl, { enabled: n, schema: x, uischema: $, path: i, key: i, renderers: S, cells: w })
    )
  );
}, cq = se.memo(lYe), uYe = (e) => ({
  removeItems: Cn((t, n) => (r) => {
    r.stopPropagation(), e(Oa(t, (i) => (n.sort().reverse().forEach((o) => i.splice(o, 1)), i), { type: "REMOVE", indices: n }));
  }, [e]),
  moveUp: Cn((t, n) => (r) => {
    r.stopPropagation(), e(Oa(t, (i) => (yz(i, n), i), {
      type: "MOVE",
      moves: [{ from: n, to: n - 1 }]
    }));
  }, [e]),
  moveDown: Cn((t, n) => (r) => {
    r.stopPropagation(), e(Oa(t, (i) => (bz(i, n), i), {
      type: "MOVE",
      moves: [{ from: n, to: n + 1 }]
    }));
  }, [e])
}), cYe = (e) => function({ ctx: n, props: r }) {
  const i = uYe(n.dispatch), {
    childLabelProp: o,
    schema: s,
    uischema: a,
    rootSchema: u,
    path: c,
    index: d,
    uischemas: f
  } = r, h = pf(c, `${d}`), m = vn(() => Dz(n.core.data, h, o, s, u, n.i18n.translate, a), [
    n.core.data,
    h,
    o,
    s,
    u,
    n.i18n.translate,
    a
  ]);
  return se.createElement(e, { ...r, ...i, childLabel: m, childPath: h, uischemas: f });
}, dYe = (e) => so(cYe(e));
var pYe = dYe(cq);
const fYe = Gt(1, dn("Group")), hYe = { marginBottom: "10px" }, mYe = se.memo(function({ visible: t, enabled: n, uischema: r, label: i, ...o }) {
  const s = r;
  return t ? se.createElement(
    gF,
    { style: hYe },
    !xn(i) && se.createElement(bF, { title: i }),
    se.createElement(
      yF,
      null,
      se.createElement(Ef, { ...o, visible: t, enabled: n, elements: s.elements })
    )
  ) : null;
}), dq = ({ uischema: e, schema: t, path: n, visible: r, enabled: i, renderers: o, cells: s, direction: a, label: u }) => {
  const c = e;
  return se.createElement(mYe, { elements: c.elements, schema: t, path: n, direction: a, visible: r, enabled: i, uischema: e, renderers: o, cells: s, label: u });
};
var gYe = wl(dq);
const yYe = W2e(1, fYe), bYe = Gt(2, dn("HorizontalLayout")), pq = ({ uischema: e, renderers: t, cells: n, schema: r, path: i, enabled: o, visible: s }) => {
  const u = {
    elements: e.elements,
    schema: r,
    path: i,
    enabled: o,
    direction: "row",
    visible: s
  };
  return se.createElement(Ef, { ...u, renderers: t, cells: n });
};
var vYe = wl(pq);
const xYe = Gt(1, dn("VerticalLayout")), fq = ({ uischema: e, schema: t, path: n, enabled: r, visible: i, renderers: o, cells: s }) => {
  const u = {
    elements: e.elements,
    schema: t,
    path: n,
    enabled: r,
    direction: "column",
    visible: i
  };
  return se.createElement(Ef, { ...u, renderers: o, cells: s });
};
var DYe = wl(fq);
const CYe = pr(dn("Categorization"), (e) => {
  const t = e;
  return t.elements && t.elements.reduce((n, r) => n && r.type === "Category", !0);
}), EYe = Gt(1, CYe), hq = (e) => {
  const { data: t, path: n, renderers: r, cells: i, schema: o, uischema: s, visible: a, enabled: u, selected: c, onChange: d, ajv: f, t: h } = e, m = s, [v, x] = Et(s), [C, E] = Et(c ?? 0), S = vn(() => m.elements.filter(($) => Ed($, t, void 0, f)), [m, t, f]);
  m !== v && (E(0), x(m));
  const w = C >= m.elements.length ? 0 : C, O = {
    elements: S[w] ? S[w].elements : [],
    schema: o,
    path: n,
    direction: "column",
    enabled: u,
    visible: a,
    renderers: r,
    cells: i
  }, A = ($, L) => {
    d && d(L, w), E(L);
  }, I = vn(() => S.map(($) => SI($, h)), [S, h]);
  return a ? se.createElement(
    se.Fragment,
    null,
    se.createElement(
      Yb,
      { position: "static" },
      se.createElement(fg, { value: w, onChange: A, textColor: "inherit", indicatorColor: "secondary", variant: "scrollable" }, S.map(($, L) => se.createElement(pd, { key: L, label: I[L] })))
    ),
    se.createElement(
      "div",
      { style: { marginTop: "0.5em" } },
      se.createElement(Ef, { ...O, key: w })
    )
  ) : null;
};
var TYe = NH(Ka(wl(hq)));
const SYe = (e) => {
  const [t, n] = Et(!1), r = Cn(() => au(e.schema, e.rootSchema), [e.schema]), i = Cn((q) => (J, X) => {
    n(X ? q : !1);
  }, []), o = (q) => t === pf(e.path, `${q}`), { enabled: s, data: a, path: u, schema: c, uischema: d, errors: f, addItem: h, renderers: m, cells: v, label: x, required: C, rootSchema: E, config: S, uischemas: w, description: O, disableAdd: A, disableRemove: I, translations: $ } = e, L = qn({}, S, e.uischema.options), B = A || L.disableAdd, H = I || L.disableRemove;
  return se.createElement(
    "div",
    null,
    se.createElement(WH, { translations: $, label: $I(x, C, L.hideRequiredAsterisk), description: O, errors: f, path: u, enabled: s, addItem: h, createDefault: r, disableAdd: B }),
    se.createElement("div", null, a > 0 ? VF(Sb(a), (q) => se.createElement(pYe, { enabled: s, index: q, expanded: o(q), schema: c, path: u, handleExpansion: i, uischema: d, renderers: m, cells: v, key: q, rootSchema: E, enableMoveUp: q != 0, enableMoveDown: q < a - 1, config: S, childLabelProp: L.elementLabelProp, uischemas: w, translations: $, disableRemove: H })) : se.createElement("p", null, $.noDataMessage))
  );
}, AYe = se.memo(SYe), mq = ({ visible: e, addItem: t, translations: n, ...r }) => {
  const i = Cn((o, s) => t(o, s), [t]);
  return e ? se.createElement(AYe, { translations: n, visible: e, addItem: i, ...r }) : null;
}, wYe = Gt(4, X2e);
var PYe = yE(Ka(vE(mq)));
const kYe = (e) => se.createElement(gg, { ...e }), OYe = Gt(2, fE);
var IYe = Td(kYe);
const FYe = (e) => se.createElement(BH, { ...e }), $Ye = Gt(3, pr(fE, Al("toggle", !0)));
var NYe = Td(FYe);
const MYe = (e) => {
  const { data: t, className: n, id: r, enabled: i, uischema: o, path: s, handleChange: a, config: u, label: c } = e, d = Sf(), f = qn({}, u, o.options);
  return se.createElement(d, { type: "date", value: t || "", onChange: (h) => a(s, h.target.value), className: n, id: r, label: c, disabled: !i, autoFocus: f.focus, fullWidth: !0 });
}, RYe = Gt(2, kI);
var _Ye = Td(MYe);
const LYe = (e) => se.createElement(eT, { ...e }), BYe = Gt(2, hE);
var jYe = RFe(Ka(se.memo(LYe)), !1);
const VYe = (e) => se.createElement(RH, { ...e }), zYe = Gt(2, rz);
var UYe = Td(VYe);
const WYe = (e) => se.createElement(_H, { ...e }), HYe = Gt(2, iz);
var qYe = Td(WYe);
const GYe = (e) => se.createElement(pGe, { ...e }), YYe = Gt(4, eIe);
var KYe = Td(GYe);
const JYe = (e) => se.createElement(eT, { ...e }), XYe = Gt(2, PI);
var QYe = _Fe(Ka(se.memo(JYe)), !1);
const ZYe = (e) => se.createElement(LH, { ...e }), eKe = Gt(1, oz);
var tKe = Td(ZYe);
const nKe = (e) => se.createElement(hGe, { ...e }), rKe = Gt(2, OI);
var iKe = Td(nKe);
const oKe = Gt(2, pr(dn("Categorization"), rIe, Al("variant", "stepper"))), sKe = (e) => {
  const [t, n] = Et(0), r = (I) => {
    n(I);
  }, { data: i, path: o, renderers: s, schema: a, uischema: u, visible: c, cells: d, config: f, ajv: h, t: m } = e, v = u, x = qn({}, f, u.options), C = {
    textAlign: "right",
    width: "100%",
    margin: "1em auto"
  }, E = {
    float: "right"
  }, S = {
    marginRight: "1em"
  }, w = vn(() => v.elements.filter((I) => Ed(I, i, void 0, h)), [v, i, h]), O = {
    elements: w[t].elements,
    schema: a,
    path: o,
    direction: "column",
    visible: c,
    renderers: s,
    cells: d
  }, A = vn(() => w.map((I) => SI(I, m)), [w, m]);
  return c ? se.createElement(
    se.Fragment,
    null,
    se.createElement(lW, { activeStep: t, nonLinear: !0 }, w.map((I, $) => se.createElement(
      iW,
      { key: A[$] },
      se.createElement(sW, { onClick: () => r($) }, A[$])
    ))),
    se.createElement(
      "div",
      null,
      se.createElement(Ef, { ...O })
    ),
    x.showNavButtons ? se.createElement(
      "div",
      { style: C },
      se.createElement(Nr, { style: E, variant: "contained", color: "primary", disabled: t >= w.length - 1, onClick: () => r(t + 1) }, "Next"),
      se.createElement(Nr, { style: S, color: "secondary", variant: "contained", disabled: t <= 0, onClick: () => r(t - 1) }, "Previous")
    ) : se.createElement(se.Fragment, null)
  ) : null;
};
var aKe = NH(Ka(wl(sKe)));
const lKe = {
  MaterialLabelRenderer: UH,
  MaterialListWithDetailRenderer: HH
}, uKe = {
  MaterialAllOfRenderer: SH,
  MaterialAnyOfRenderer: PH,
  MaterialArrayControlRenderer: FH,
  MaterialEnumArrayRenderer: jH,
  MaterialObjectRenderer: VH,
  MaterialOneOfRenderer: zH
}, cKe = {
  MaterialAnyOfStringOrEnumControl: YH,
  MaterialBooleanControl: KH,
  MaterialBooleanToggleControl: JH,
  MaterialDateControl: XH,
  MaterialDateTimeControl: QH,
  MaterialEnumControl: ZH,
  MaterialIntegerControl: eq,
  MaterialNativeControl: tq,
  MaterialNumberControl: nq,
  MaterialOneOfEnumControl: rq,
  MaterialOneOfRadioGroupControl: oq,
  MaterialSliderControl: aq,
  MaterialRadioGroupControl: sq,
  MaterialTextControl: lq,
  MaterialTimeControl: uq
}, dKe = {
  ExpandPanelRenderer: cq,
  MaterialArrayLayout: mq,
  MaterialCategorizationLayout: hq,
  MaterialGroupLayout: dq,
  MaterialHorizontalLayout: pq,
  MaterialVerticalLayout: fq
}, pKe = [
  {
    tester: nGe,
    renderer: rGe
  },
  { tester: NGe, renderer: MGe },
  {
    tester: RGe,
    renderer: _Ge
  },
  { tester: qGe, renderer: GGe },
  { tester: zGe, renderer: UGe },
  { tester: WGe, renderer: HGe },
  { tester: YGe, renderer: KGe },
  { tester: iYe, renderer: oYe },
  { tester: jGe, renderer: VGe },
  { tester: LGe, renderer: BGe },
  { tester: sYe, renderer: aYe },
  { tester: nYe, renderer: rYe },
  { tester: vGe, renderer: xGe },
  { tester: Lqe, renderer: Bqe },
  { tester: jqe, renderer: Vqe },
  { tester: DGe, renderer: CGe },
  {
    tester: eYe,
    renderer: tYe
  },
  {
    tester: QGe,
    renderer: ZGe
  },
  {
    tester: JGe,
    renderer: XGe
  },
  { tester: yYe, renderer: gYe },
  {
    tester: bYe,
    renderer: vYe
  },
  { tester: xYe, renderer: DYe },
  {
    tester: EYe,
    renderer: TYe
  },
  {
    tester: oKe,
    renderer: aKe
  },
  { tester: wYe, renderer: PYe },
  { tester: EGe, renderer: TGe },
  {
    tester: wGe,
    renderer: PGe
  },
  {
    tester: FGe,
    renderer: $Ge
  },
  {
    tester: yGe,
    renderer: bGe
  }
], fKe = [
  { tester: OYe, cell: IYe },
  { tester: $Ye, cell: NYe },
  { tester: RYe, cell: _Ye },
  { tester: BYe, cell: jYe },
  { tester: zYe, cell: UYe },
  { tester: HYe, cell: qYe },
  { tester: YYe, cell: KYe },
  { tester: XYe, cell: QYe },
  { tester: eKe, cell: tKe },
  { tester: rKe, cell: iKe }
], m$ = {
  ...lKe,
  ...uKe,
  ...cKe,
  ...dKe
};
var rk = { exports: {} };
(function(e, t) {
  Object.defineProperty(t, "__esModule", { value: !0 });
  const n = W2, r = $n, i = um, o = Na, s = qm, a = Sl, u = "errorMessage", c = new n.Name("emUsed"), d = {
    required: "missingProperty",
    dependencies: "property",
    dependentRequired: "property"
  }, f = /\$\{[^}]+\}/, h = /\$\{([^}]+)\}/g, m = /^""\s*\+\s*|\s*\+\s*""$/g;
  function v(C) {
    return {
      keyword: u,
      schemaType: ["string", "object"],
      post: !0,
      code(E) {
        const { gen: S, data: w, schema: O, schemaValue: A, it: I } = E;
        if (I.createErrors === !1)
          return;
        const $ = O, L = r.strConcat(a.default.instancePath, I.errorPath);
        S.if(n._`${a.default.errors} > 0`, () => {
          if (typeof $ == "object") {
            const [R, _] = H($);
            _ && q(_), R && J(R), X(B($));
          }
          const ne = typeof $ == "string" ? $ : $._;
          ne && j(ne), C.keepErrors || U();
        });
        function B({ properties: ne, items: R }) {
          const _ = {};
          if (ne) {
            _.props = {};
            for (const W in ne)
              _.props[W] = [];
          }
          if (R) {
            _.items = {};
            for (let W = 0; W < R.length; W++)
              _.items[W] = [];
          }
          return _;
        }
        function H(ne) {
          let R, _;
          for (const W in ne) {
            if (W === "properties" || W === "items")
              continue;
            const Q = ne[W];
            if (typeof Q == "object") {
              R || (R = {});
              const oe = R[W] = {};
              for (const ae in Q)
                oe[ae] = [];
            } else
              _ || (_ = {}), _[W] = [];
          }
          return [R, _];
        }
        function q(ne) {
          const R = S.const("emErrors", n.stringify(ne)), _ = S.const("templates", te(ne, O));
          S.forOf("err", a.default.vErrors, (ae) => S.if(G(ae, R), () => S.code(n._`${R}[${ae}.keyword].push(${ae})`).assign(n._`${ae}.${c}`, !0)));
          const { singleError: W } = C;
          if (W) {
            const ae = S.let("message", n._`""`), pe = S.let("paramsErrors", n._`[]`);
            Q((me) => {
              S.if(ae, () => S.code(n._`${ae} += ${typeof W == "string" ? W : ";"}`)), S.code(n._`${ae} += ${oe(me)}`), S.assign(pe, n._`${pe}.concat(${R}[${me}])`);
            }), s.reportError(E, { message: ae, params: n._`{errors: ${pe}}` });
          } else
            Q((ae) => s.reportError(E, {
              message: oe(ae),
              params: n._`{errors: ${R}[${ae}]}`
            }));
          function Q(ae) {
            S.forIn("key", R, (pe) => S.if(n._`${R}[${pe}].length`, () => ae(pe)));
          }
          function oe(ae) {
            return n._`${ae} in ${_} ? ${_}[${ae}]() : ${A}[${ae}]`;
          }
        }
        function J(ne) {
          const R = S.const("emErrors", n.stringify(ne)), _ = [];
          for (const pe in ne)
            _.push([
              pe,
              te(ne[pe], O[pe])
            ]);
          const W = S.const("templates", S.object(..._)), Q = S.scopeValue("obj", {
            ref: d,
            code: n.stringify(d)
          }), oe = S.let("emPropParams"), ae = S.let("emParamsErrors");
          S.forOf("err", a.default.vErrors, (pe) => S.if(G(pe, R), () => {
            S.assign(oe, n._`${Q}[${pe}.keyword]`), S.assign(ae, n._`${R}[${pe}.keyword][${pe}.params[${oe}]]`), S.if(ae, () => S.code(n._`${ae}.push(${pe})`).assign(n._`${pe}.${c}`, !0));
          })), S.forIn("key", R, (pe) => S.forIn("keyProp", n._`${R}[${pe}]`, (me) => {
            S.assign(ae, n._`${R}[${pe}][${me}]`), S.if(n._`${ae}.length`, () => {
              const xe = S.const("tmpl", n._`${W}[${pe}] && ${W}[${pe}][${me}]`);
              s.reportError(E, {
                message: n._`${xe} ? ${xe}() : ${A}[${pe}][${me}]`,
                params: n._`{errors: ${ae}}`
              });
            });
          }));
        }
        function X(ne) {
          const { props: R, items: _ } = ne;
          if (!R && !_)
            return;
          const W = n._`typeof ${w} == "object"`, Q = n._`Array.isArray(${w})`, oe = S.let("emErrors");
          let ae, pe;
          const me = S.let("templates");
          R && _ ? (ae = S.let("emChildKwd"), S.if(W), S.if(Q, () => {
            xe(_, O.items), S.assign(ae, n.str`items`);
          }, () => {
            xe(R, O.properties), S.assign(ae, n.str`properties`);
          }), pe = n._`[${ae}]`) : _ ? (S.if(Q), xe(_, O.items), pe = n._`.items`) : R && (S.if(r.and(W, r.not(Q))), xe(R, O.properties), pe = n._`.properties`), S.forOf("err", a.default.vErrors, (le) => K(le, oe, (ye) => S.code(n._`${oe}[${ye}].push(${le})`).assign(n._`${le}.${c}`, !0))), S.forIn("key", oe, (le) => S.if(n._`${oe}[${le}].length`, () => {
            s.reportError(E, {
              message: n._`${le} in ${me} ? ${me}[${le}]() : ${A}${pe}[${le}]`,
              params: n._`{errors: ${oe}[${le}]}`
            }), S.assign(n._`${a.default.vErrors}[${a.default.errors}-1].instancePath`, n._`${L} + "/" + ${le}.replace(/~/g, "~0").replace(/\\//g, "~1")`);
          })), S.endIf();
          function xe(le, ye) {
            S.assign(oe, n.stringify(le)), S.assign(me, te(le, ye));
          }
        }
        function j(ne) {
          const R = S.const("emErrs", n._`[]`);
          S.forOf("err", a.default.vErrors, (_) => S.if(ee(_), () => S.code(n._`${R}.push(${_})`).assign(n._`${_}.${c}`, !0))), S.if(n._`${R}.length`, () => s.reportError(E, {
            message: M(ne),
            params: n._`{errors: ${R}}`
          }));
        }
        function U() {
          const ne = S.const("emErrs", n._`[]`);
          S.forOf("err", a.default.vErrors, (R) => S.if(n._`!${R}.${c}`, () => S.code(n._`${ne}.push(${R})`))), S.assign(a.default.vErrors, ne).assign(a.default.errors, n._`${ne}.length`);
        }
        function G(ne, R) {
          return r.and(
            n._`${ne}.keyword !== ${u}`,
            n._`!${ne}.${c}`,
            n._`${ne}.instancePath === ${L}`,
            n._`${ne}.keyword in ${R}`,
            // TODO match the end of the string?
            n._`${ne}.schemaPath.indexOf(${I.errSchemaPath}) === 0`,
            n._`/^\\/[^\\/]*$/.test(${ne}.schemaPath.slice(${I.errSchemaPath.length}))`
          );
        }
        function K(ne, R, _) {
          S.if(r.and(n._`${ne}.keyword !== ${u}`, n._`!${ne}.${c}`, n._`${ne}.instancePath.indexOf(${L}) === 0`), () => {
            const W = S.scopeValue("pattern", {
              ref: /^\/([^/]*)(?:\/|$)/,
              code: n._`new RegExp("^\\\/([^/]*)(?:\\\/|$)")`
            }), Q = S.const("emMatches", n._`${W}.exec(${ne}.instancePath.slice(${L}.length))`), oe = S.const("emChild", n._`${Q} && ${Q}[1].replace(/~1/g, "/").replace(/~0/g, "~")`);
            S.if(n._`${oe} !== undefined && ${oe} in ${R}`, () => _(oe));
          });
        }
        function ee(ne) {
          return r.and(n._`${ne}.keyword !== ${u}`, n._`!${ne}.${c}`, r.or(n._`${ne}.instancePath === ${L}`, r.and(n._`${ne}.instancePath.indexOf(${L}) === 0`, n._`${ne}.instancePath[${L}.length] === "/"`)), n._`${ne}.schemaPath.indexOf(${I.errSchemaPath}) === 0`, n._`${ne}.schemaPath[${I.errSchemaPath}.length] === "/"`);
        }
        function te(ne, R) {
          const _ = [];
          for (const W in ne) {
            const Q = R[W];
            f.test(Q) && _.push([W, Z(Q)]);
          }
          return S.object(..._);
        }
        function M(ne) {
          return f.test(ne) ? new i._Code(i.safeStringify(ne).replace(h, (R, _) => `" + JSON.stringify(${o.getData(_, I)}) + "`).replace(m, "")) : n.stringify(ne);
        }
        function Z(ne) {
          return n._`function(){return ${M(ne)}}`;
        }
      },
      metaSchema: {
        anyOf: [
          { type: "string" },
          {
            type: "object",
            properties: {
              properties: { $ref: "#/$defs/stringMap" },
              items: { $ref: "#/$defs/stringList" },
              required: { $ref: "#/$defs/stringOrMap" },
              dependencies: { $ref: "#/$defs/stringOrMap" }
            },
            additionalProperties: { type: "string" }
          }
        ],
        $defs: {
          stringMap: {
            type: "object",
            additionalProperties: { type: "string" }
          },
          stringOrMap: {
            anyOf: [{ type: "string" }, { $ref: "#/$defs/stringMap" }]
          },
          stringList: { type: "array", items: { type: "string" } }
        }
      }
    };
  }
  const x = (C, E = {}) => {
    if (!C.opts.allErrors)
      throw new Error("ajv-errors: Ajv option allErrors must be true");
    if (C.opts.jsPropertySyntax)
      throw new Error("ajv-errors: ajv option jsPropertySyntax is not supported");
    return C.addKeyword(v(E));
  };
  t.default = x, e.exports = x, e.exports.default = x;
})(rk, rk.exports);
var hKe = rk.exports;
const mKe = /* @__PURE__ */ Ln(hKe), gKe = (e) => Object.hasOwn(e, "elements"), gq = (e, t, n, r = !0) => {
  if (!n)
    return t;
  const i = Ed(e, t, "", n) && r;
  if (gKe(e) && e.elements.forEach((o) => {
    gq(o, t, n, i);
  }), Mp(e)) {
    const o = e.scope.replaceAll("properties", ".").split("/").filter((a) => a.length > 1).join(".");
    vo.get(t, o) && !i && vo.set(t, o, void 0);
  }
  return t;
}, yKe = Gt(1e3, dn("CollapsibleSection")), bKe = Gt(1e3, dn("CalculatedField")), vKe = Gt(1e3, dn("Page")), xKe = Gt(1e3, dn("PageNavigation")), DKe = Gt(1e3, dn("Divider")), CKe = Gt(1e3, dn("Text")), EKe = (e) => e.oneOf !== void 0 && e.oneOf.length > 0 && e.oneOf.every((t) => t.const !== void 0), TKe = (e) => e.type === "string" && e.enum !== void 0, SKe = Gt(
  1e3,
  pr(
    dn("Control"),
    pr(
      ca(
        (e) => to(e, "array") && !Array.isArray(e.items) && e.uniqueItems === !0
      ),
      pE("items", (e, t) => {
        const n = e.$ref ? ls(t, e.$ref, t) : e;
        return EKe(n) || TKe(n);
      })
    )
  )
), AKe = Gt(1e3, pr(hE, Al("format", "radio"))), wKe = Gt(1e3, dn("Icd10")), PKe = Gt(1e3, dn("Icd10Long")), kKe = Gt(1e3, dn("Cpt")), OKe = Gt(1e3, dn("CptV2")), IKe = Gt(1e3, dn("DynamicDropdown")), FKe = (e) => {
  if ((e.match(/#/g) || []).length !== 2)
    return !1;
  let n = e.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
  return n = n.replace("#", ""), n = n.replace("#", "(\\d+)"), new RegExp(`^#${n}$`);
}, yq = (e, t, n = []) => {
  if ((!t || t.length === 0) && n.length == 0)
    return 0;
  let r = 0;
  return t == null || t.forEach((i) => {
    const o = F0(i), s = LD(o);
    e.includes(`#${s}`) && r++, e.forEach((a) => {
      const u = FKe(a);
      u && u.test(`#${s}`) && r++;
    });
  }), n == null || n.forEach((i) => {
    const o = F0(i), s = LD(o);
    e.includes(`#${s}`) && r++;
  }), r;
}, Fd = (e) => ({
  ...e,
  alpha4: Yt(e.main, 0.04),
  alpha8: Yt(e.main, 0.08),
  alpha12: Yt(e.main, 0.12),
  alpha30: Yt(e.main, 0.3),
  alpha50: Yt(e.main, 0.5)
}), ji = {
  50: "#F8F9FA",
  100: "#F3F4F6",
  200: "#E5E7EB",
  300: "#D2D6DB",
  400: "#9DA4AE",
  500: "#6C737F",
  600: "#4D5761",
  700: "#2F3746",
  800: "#1C2536",
  900: "#111927"
}, Sj = Fd({
  lightest: "#F5F8FF",
  light: "#EBEFFF",
  main: "#2970FF",
  dark: "#004EEB",
  darkest: "#00359E",
  contrastText: "#FFFFFF"
}), $Ke = Fd({
  lightest: "#F6FEF9",
  light: "#EDFCF2",
  main: "#16B364",
  dark: "#087443",
  darkest: "#084C2E",
  contrastText: "#FFFFFF"
}), NKe = Fd({
  lightest: "#F5F7FF",
  light: "#EBEEFE",
  main: "#6366F1",
  dark: "#4338CA",
  darkest: "#312E81",
  contrastText: "#FFFFFF"
}), MKe = Fd({
  lightest: "#F9F5FF",
  light: "#F4EBFF",
  main: "#9E77ED",
  dark: "#6941C6",
  darkest: "#42307D",
  contrastText: "#FFFFFF"
}), bq = Fd({
  lightest: "#F0FDF9",
  light: "#3FC79A",
  main: "#10B981",
  dark: "#0B815A",
  darkest: "#134E48",
  contrastText: "#FFFFFF"
}), vq = Fd({
  lightest: "#ECFDFF",
  light: "#CFF9FE",
  main: "#06AED4",
  dark: "#0E7090",
  darkest: "#164C63",
  contrastText: "#FFFFFF"
}), xq = Fd({
  lightest: "#FFFAEB",
  light: "#FEF0C7",
  main: "#F79009",
  dark: "#B54708",
  darkest: "#7A2E0E",
  contrastText: "#FFFFFF"
}), Ua = Fd({
  lightest: "#FEF3F2",
  light: "#FEE4E2",
  main: "#F04438",
  dark: "#B42318",
  darkest: "#7A271A",
  contrastText: "#FFFFFF"
}), Dq = BC(void 0), RKe = ({ children: e, initialCollapse: t }) => {
  const [n, r] = Et(t), i = (o, s) => {
    r((a) => ({
      ...a,
      [o]: s
    }));
  };
  return /* @__PURE__ */ P.jsx(Dq.Provider, { value: { collapse: n, setCollapse: i }, children: e });
}, _Ke = () => {
  const e = Rm(Dq);
  if (e === void 0)
    throw new Error("useCollapse must be used within a CollapseProvider");
  return e;
}, g$ = (e, t = [], n) => {
  for (const r in e)
    if (r === "scope")
      n ? t.push(`${n}/properties/${e[r]}`) : t.push(e[r]);
    else if (typeof e[r] == "object" && e[r] !== null) {
      let i = n;
      e.type === "ListWithDetail" && (i = e.scope), g$(e[r], t, i);
    }
  return t;
}, LKe = (e) => {
  var v, x;
  const { collapse: t, setCollapse: n } = _Ke(), r = So(), i = e.uischema.elements, o = e.uischema.collapseGroup, s = e.uischema.groupId, a = e.uischema.defaultExpanded, u = yq(g$(i), (v = r.core) == null ? void 0 : v.errors, (x = r.core) == null ? void 0 : x.additionalErrors), c = t[o] === s, [d, f] = Et(a);
  rn(() => {
    o && typeof t[o] > "u" && a && n(o, s);
  }, [o, t, a, s, n]);
  const h = () => {
    if (!o) {
      f(!d);
      return;
    }
    c ? n(o, "") : n(o, s);
  }, m = o ? c : d;
  return e.visible ? /* @__PURE__ */ P.jsxs(
    eF,
    {
      onChange: h,
      expanded: m,
      variant: "outlined",
      slotProps: {
        transition: {
          timeout: 100,
          onEnter: (C) => {
            setTimeout(() => {
              var E;
              (E = C.parentElement) == null || E.scrollIntoView({ behavior: "smooth" });
            }, 101);
          }
        }
      },
      sx: {
        "& .MuiAccordion-region": { height: c ? "auto" : 0 },
        "& .MuiAccordionDetails-root": { display: c ? "block" : "none" },
        my: 2
      },
      children: [
        /* @__PURE__ */ P.jsxs(nF, { expandIcon: /* @__PURE__ */ P.jsx(d$, {}), children: [
          /* @__PURE__ */ P.jsx("div", { className: "topTarget" }),
          /* @__PURE__ */ P.jsx(cn, { sx: { fontWeight: "bold" }, children: e.label }),
          /* @__PURE__ */ P.jsxs(cn, { sx: { fontStyle: "italic", color: Ua.main, paddingLeft: "1rem" }, children: [
            u > 0 ? `${u} error` : "",
            u > 1 && "s"
          ] })
        ] }),
        /* @__PURE__ */ P.jsx(tF, { children: e.visible && m && /* @__PURE__ */ P.jsx(Ef, { ...e, elements: i }) })
      ]
    }
  ) : /* @__PURE__ */ P.jsx(P.Fragment, {});
}, BKe = wl(LKe), bg = (e, t, n = "") => {
  const r = n ? n.split(".") : [], i = dE(t);
  if (i.length === 1 && r.length > 1) {
    const s = [...r];
    s.pop(), s[s.length] = i[0], i.length = 0, i.push(...s);
  }
  let o = e;
  for (const s of i)
    if (o && typeof o == "object" && s in o)
      o = o[s];
    else
      return;
  return o;
}, jKe = (e, t) => {
  const n = t.split(".");
  let r = e;
  for (const i of n)
    if (r && typeof r == "object" && i in r)
      r = r[i];
    else
      return;
  return r;
}, { MaterialNumberControl: VKe } = m$, zKe = (e) => {
  const { type: t, scopes: n } = e.uischema.calculation, r = So(), i = [];
  n.forEach((s) => {
    if (r.core) {
      const a = bg(r.core.data, s);
      a && i.push(a);
    }
  });
  let o;
  switch (t) {
    case "ADD":
      o = i.reduce((s, a) => s + a, 0);
      break;
    case "SUBTRACT":
      o = i.reduce((s, a) => s - a);
      break;
    case "MULTIPLY":
      o = i.reduce((s, a) => s * a, 1);
      break;
    case "DIVIDE":
      o = i.reduce((s, a) => {
        if (a === 0)
          throw new Error("Division by zero is not allowed.");
        return s / a;
      });
      break;
    default:
      throw new Error("Invalid operator.");
  }
  return rn(() => {
    o !== e.data && e.handleChange(e.path, o);
  }, [o, e]), e.visible ? /* @__PURE__ */ P.jsx(VKe, { ...e, data: o, label: e.label }) : /* @__PURE__ */ P.jsx(P.Fragment, {});
}, UKe = li(zKe), Cq = BC(void 0), WKe = ({ children: e }) => {
  const [t, n] = Et(1), [r, i] = Et(null), [o, s] = Et([]), a = (c) => o.includes(c), u = (c, d) => {
    if (a(c) && d || !a(c) && !d)
      return;
    let f = o;
    a(c) && !d ? f = o.filter((h) => h !== c) : f.push(c), s(f);
  };
  return /* @__PURE__ */ P.jsx(Cq.Provider, { value: { currentPage: t, setCurrentPage: n, pages: r, setPages: i, isHidden: a, setHidden: u }, children: e });
}, tT = () => {
  const e = Rm(Cq);
  if (e === void 0)
    throw new Error("usePage must be used within a PageProvider");
  return e;
}, HKe = ({ pages: e, totalPages: t, currentPage: n, setPage: r }) => {
  const { isHidden: i } = tT(), o = (d) => {
    r(d);
    const f = document.getElementById("top");
    f == null || f.scrollIntoView();
  }, s = (d, f) => {
    let h = null;
    if (f === "next") {
      for (let m = d + 1; m <= t; m++)
        if (!i(m)) {
          h = m;
          break;
        }
    } else
      for (let m = d - 1; m >= 1; m--)
        if (!i(m)) {
          h = m;
          break;
        }
    return h;
  }, a = s(n, "next"), u = s(n, "prev"), c = {};
  return e.map((d) => {
    c[d.number] = d.label;
  }), /* @__PURE__ */ P.jsx(Yb, { position: "relative", sx: { borderRadius: "0 0 20px 20px" }, children: /* @__PURE__ */ P.jsxs(pg, { children: [
    u !== null && /* @__PURE__ */ P.jsxs(Nr, { variant: "outlined", color: "inherit", onClick: () => o(u), children: [
      "Previous",
      c[u] ? ` - ${c[u]}` : ""
    ] }),
    /* @__PURE__ */ P.jsx(Ar, { sx: { flexGrow: 1 } }),
    a && /* @__PURE__ */ P.jsxs(Nr, { variant: "outlined", color: "inherit", onClick: () => o(a), children: [
      "Next",
      c[a] ? ` - ${c[a]}` : ""
    ] })
  ] }) });
}, qKe = (e) => {
  const t = [];
  function n(r) {
    for (const i in r)
      typeof r[i] == "object" && r[i] !== null && (r[i].type === "Page" && t.push({
        number: r[i].pageNumber,
        label: r[i].label,
        elements: r[i].elements
      }), n(r[i]));
  }
  return n(e), t;
}, GKe = (e) => {
  var x;
  const { currentPage: t, setCurrentPage: n, pages: r, setPages: i, isHidden: o, setHidden: s } = tT(), { label: a, visible: u } = e, c = So(), d = e.uischema.elements, f = e.uischema.pageNumber, h = e.uischema.keepMounted || !1;
  if (rn(() => {
    var C, E;
    if (r === null && ((C = c.core) != null && C.uischema)) {
      const S = qKe((E = c.core) == null ? void 0 : E.uischema);
      S.length > 0 && i(S);
    }
  }, [r, i, (x = c.core) == null ? void 0 : x.uischema]), rn(() => {
    o(f) !== !u && s(f, !u);
  }, [o, s, f, u]), !u)
    return /* @__PURE__ */ P.jsx(P.Fragment, {});
  if (f !== t && !h)
    return /* @__PURE__ */ P.jsx(P.Fragment, {});
  const m = f !== t && h, v = {
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: "1px",
    width: "1px",
    left: "-99999",
    top: "0",
    position: "absolute",
    overflow: "hidden",
    whiteSpace: "nowrap"
  };
  return /* @__PURE__ */ P.jsxs(gF, { id: `page-tabpanel-${f}`, sx: m ? v : { overflow: "unset" }, children: [
    !vo.isEmpty(a) && /* @__PURE__ */ P.jsx(bF, { title: a }),
    /* @__PURE__ */ P.jsx(yF, { children: /* @__PURE__ */ P.jsx(Ef, { ...e, elements: d }) }),
    r !== null && /* @__PURE__ */ P.jsx(HKe, { pages: r, currentPage: t, totalPages: r.length, setPage: n })
  ] });
}, YKe = wl(GKe);
function Aj(e) {
  return {
    id: `page-tab-${e}`,
    "aria-controls": `page-tabpanel-${e}`
  };
}
const KKe = () => {
  const { currentPage: e, setCurrentPage: t, pages: n, isHidden: r } = tT(), i = So(), o = n == null ? void 0 : n.map((a) => {
    var c, d;
    return r(a.number) ? void 0 : yq(g$(a.elements), (c = i.core) == null ? void 0 : c.errors, (d = i.core) == null ? void 0 : d.additionalErrors) > 0 ? /* @__PURE__ */ DD(
      pd,
      {
        icon: /* @__PURE__ */ P.jsx(HE, { sx: { color: Ua.main }, fontSize: "small", titleAccess: "Validation errors" }),
        label: /* @__PURE__ */ P.jsx(Ar, { sx: { color: Ua.main }, children: a.label }),
        ...Aj(a.number),
        wrapped: !0,
        key: `pagenav-${a.number}`,
        iconPosition: "start",
        sx: { padding: "0 0.5rem" },
        value: a.number
      }
    ) : /* @__PURE__ */ DD(
      pd,
      {
        sx: { padding: "0 0.5rem" },
        label: a.label,
        ...Aj(a.number),
        key: `pagenav-${a.number}`,
        value: a.number
      }
    );
  }), s = (a, u) => {
    t(u);
  };
  return !n || n.length <= 0 ? /* @__PURE__ */ P.jsx(P.Fragment, {}) : /* @__PURE__ */ P.jsx(Ar, { sx: { width: "100%", typography: "body1" }, children: /* @__PURE__ */ P.jsx(Ar, { sx: { borderBottom: 1, borderColor: "divider" }, children: /* @__PURE__ */ P.jsx(
    fg,
    {
      value: e,
      onChange: s,
      "aria-label": "basic tabs example",
      variant: "scrollable",
      scrollButtons: "auto",
      children: o
    }
  ) }) });
}, JKe = wl(KKe), XKe = (e) => {
  const { visible: t } = e;
  return t ? /* @__PURE__ */ P.jsx(U0, { variant: "middle", component: "hr" }) : /* @__PURE__ */ P.jsx(P.Fragment, {});
}, QKe = wl(XKe);
function ZKe(e, t) {
  const n = {};
  return (e[e.length - 1] === "" ? [...e, ""] : e).join(
    (n.padRight ? " " : "") + "," + (n.padLeft === !1 ? "" : " ")
  ).trim();
}
const eJe = /^[$_\p{ID_Start}][$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, tJe = /^[$_\p{ID_Start}][-$_\u{200C}\u{200D}\p{ID_Continue}]*$/u, nJe = {};
function wj(e, t) {
  return (nJe.jsx ? tJe : eJe).test(e);
}
const rJe = /[ \t\n\f\r]/g;
function iJe(e) {
  return typeof e == "object" ? e.type === "text" ? Pj(e.value) : !1 : Pj(e);
}
function Pj(e) {
  return e.replace(rJe, "") === "";
}
class fv {
  /**
   * @constructor
   * @param {Properties} property
   * @param {Normal} normal
   * @param {string} [space]
   */
  constructor(t, n, r) {
    this.property = t, this.normal = n, r && (this.space = r);
  }
}
fv.prototype.property = {};
fv.prototype.normal = {};
fv.prototype.space = null;
function Eq(e, t) {
  const n = {}, r = {};
  let i = -1;
  for (; ++i < e.length; )
    Object.assign(n, e[i].property), Object.assign(r, e[i].normal);
  return new fv(n, r, t);
}
function ik(e) {
  return e.toLowerCase();
}
class Xa {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   */
  constructor(t, n) {
    this.property = t, this.attribute = n;
  }
}
Xa.prototype.space = null;
Xa.prototype.boolean = !1;
Xa.prototype.booleanish = !1;
Xa.prototype.overloadedBoolean = !1;
Xa.prototype.number = !1;
Xa.prototype.commaSeparated = !1;
Xa.prototype.spaceSeparated = !1;
Xa.prototype.commaOrSpaceSeparated = !1;
Xa.prototype.mustUseProperty = !1;
Xa.prototype.defined = !1;
let oJe = 0;
const Sn = wf(), Ii = wf(), Tq = wf(), yt = wf(), Vr = wf(), Xh = wf(), Ks = wf();
function wf() {
  return 2 ** ++oJe;
}
const ok = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  boolean: Sn,
  booleanish: Ii,
  commaOrSpaceSeparated: Ks,
  commaSeparated: Xh,
  number: yt,
  overloadedBoolean: Tq,
  spaceSeparated: Vr
}, Symbol.toStringTag, { value: "Module" })), lw = Object.keys(ok);
class y$ extends Xa {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   * @param {number|null} [mask]
   * @param {string} [space]
   */
  constructor(t, n, r, i) {
    let o = -1;
    if (super(t, n), kj(this, "space", i), typeof r == "number")
      for (; ++o < lw.length; ) {
        const s = lw[o];
        kj(this, lw[o], (r & ok[s]) === ok[s]);
      }
  }
}
y$.prototype.defined = !0;
function kj(e, t, n) {
  n && (e[t] = n);
}
const sJe = {}.hasOwnProperty;
function vg(e) {
  const t = {}, n = {};
  let r;
  for (r in e.properties)
    if (sJe.call(e.properties, r)) {
      const i = e.properties[r], o = new y$(
        r,
        e.transform(e.attributes || {}, r),
        i,
        e.space
      );
      e.mustUseProperty && e.mustUseProperty.includes(r) && (o.mustUseProperty = !0), t[r] = o, n[ik(r)] = r, n[ik(o.attribute)] = r;
    }
  return new fv(t, n, e.space);
}
const Sq = vg({
  space: "xlink",
  transform(e, t) {
    return "xlink:" + t.slice(5).toLowerCase();
  },
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  }
}), Aq = vg({
  space: "xml",
  transform(e, t) {
    return "xml:" + t.slice(3).toLowerCase();
  },
  properties: { xmlLang: null, xmlBase: null, xmlSpace: null }
});
function wq(e, t) {
  return t in e ? e[t] : t;
}
function Pq(e, t) {
  return wq(e, t.toLowerCase());
}
const kq = vg({
  space: "xmlns",
  attributes: { xmlnsxlink: "xmlns:xlink" },
  transform: Pq,
  properties: { xmlns: null, xmlnsXLink: null }
}), Oq = vg({
  transform(e, t) {
    return t === "role" ? t : "aria-" + t.slice(4).toLowerCase();
  },
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: Ii,
    ariaAutoComplete: null,
    ariaBusy: Ii,
    ariaChecked: Ii,
    ariaColCount: yt,
    ariaColIndex: yt,
    ariaColSpan: yt,
    ariaControls: Vr,
    ariaCurrent: null,
    ariaDescribedBy: Vr,
    ariaDetails: null,
    ariaDisabled: Ii,
    ariaDropEffect: Vr,
    ariaErrorMessage: null,
    ariaExpanded: Ii,
    ariaFlowTo: Vr,
    ariaGrabbed: Ii,
    ariaHasPopup: null,
    ariaHidden: Ii,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: Vr,
    ariaLevel: yt,
    ariaLive: null,
    ariaModal: Ii,
    ariaMultiLine: Ii,
    ariaMultiSelectable: Ii,
    ariaOrientation: null,
    ariaOwns: Vr,
    ariaPlaceholder: null,
    ariaPosInSet: yt,
    ariaPressed: Ii,
    ariaReadOnly: Ii,
    ariaRelevant: null,
    ariaRequired: Ii,
    ariaRoleDescription: Vr,
    ariaRowCount: yt,
    ariaRowIndex: yt,
    ariaRowSpan: yt,
    ariaSelected: Ii,
    ariaSetSize: yt,
    ariaSort: null,
    ariaValueMax: yt,
    ariaValueMin: yt,
    ariaValueNow: yt,
    ariaValueText: null,
    role: null
  }
}), aJe = vg({
  space: "html",
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  transform: Pq,
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: Xh,
    acceptCharset: Vr,
    accessKey: Vr,
    action: null,
    allow: null,
    allowFullScreen: Sn,
    allowPaymentRequest: Sn,
    allowUserMedia: Sn,
    alt: null,
    as: null,
    async: Sn,
    autoCapitalize: null,
    autoComplete: Vr,
    autoFocus: Sn,
    autoPlay: Sn,
    blocking: Vr,
    capture: null,
    charSet: null,
    checked: Sn,
    cite: null,
    className: Vr,
    cols: yt,
    colSpan: null,
    content: null,
    contentEditable: Ii,
    controls: Sn,
    controlsList: Vr,
    coords: yt | Xh,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: Sn,
    defer: Sn,
    dir: null,
    dirName: null,
    disabled: Sn,
    download: Tq,
    draggable: Ii,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: Sn,
    formTarget: null,
    headers: Vr,
    height: yt,
    hidden: Sn,
    high: yt,
    href: null,
    hrefLang: null,
    htmlFor: Vr,
    httpEquiv: Vr,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: Sn,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: Sn,
    itemId: null,
    itemProp: Vr,
    itemRef: Vr,
    itemScope: Sn,
    itemType: Vr,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: Sn,
    low: yt,
    manifest: null,
    max: null,
    maxLength: yt,
    media: null,
    method: null,
    min: null,
    minLength: yt,
    multiple: Sn,
    muted: Sn,
    name: null,
    nonce: null,
    noModule: Sn,
    noValidate: Sn,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeToggle: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: Sn,
    optimum: yt,
    pattern: null,
    ping: Vr,
    placeholder: null,
    playsInline: Sn,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: Sn,
    referrerPolicy: null,
    rel: Vr,
    required: Sn,
    reversed: Sn,
    rows: yt,
    rowSpan: yt,
    sandbox: Vr,
    scope: null,
    scoped: Sn,
    seamless: Sn,
    selected: Sn,
    shadowRootClonable: Sn,
    shadowRootDelegatesFocus: Sn,
    shadowRootMode: null,
    shape: null,
    size: yt,
    sizes: null,
    slot: null,
    span: yt,
    spellCheck: Ii,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: yt,
    step: null,
    style: null,
    tabIndex: yt,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: Sn,
    useMap: null,
    value: Ii,
    width: yt,
    wrap: null,
    writingSuggestions: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: Vr,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: yt,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: yt,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: Sn,
    // Lists. Use CSS to reduce space between items instead
    declare: Sn,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: yt,
    // `<img>` and `<object>`
    leftMargin: yt,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: yt,
    // `<body>`
    marginWidth: yt,
    // `<body>`
    noResize: Sn,
    // `<frame>`
    noHref: Sn,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: Sn,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: Sn,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: yt,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: Ii,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: yt,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: yt,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: Sn,
    disableRemotePlayback: Sn,
    prefix: null,
    property: null,
    results: yt,
    security: null,
    unselectable: null
  }
}), lJe = vg({
  space: "svg",
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    transformOrigin: "transform-origin",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  transform: wq,
  properties: {
    about: Ks,
    accentHeight: yt,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: yt,
    amplitude: yt,
    arabicForm: null,
    ascent: yt,
    attributeName: null,
    attributeType: null,
    azimuth: yt,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: yt,
    by: null,
    calcMode: null,
    capHeight: yt,
    className: Vr,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: yt,
    diffuseConstant: yt,
    direction: null,
    display: null,
    dur: null,
    divisor: yt,
    dominantBaseline: null,
    download: Sn,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: yt,
    enableBackground: null,
    end: null,
    event: null,
    exponent: yt,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: yt,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: Xh,
    g2: Xh,
    glyphName: Xh,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: yt,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: yt,
    horizOriginX: yt,
    horizOriginY: yt,
    id: null,
    ideographic: yt,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: yt,
    k: yt,
    k1: yt,
    k2: yt,
    k3: yt,
    k4: yt,
    kernelMatrix: Ks,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: yt,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: yt,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: yt,
    overlineThickness: yt,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: yt,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: Vr,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: yt,
    pointsAtY: yt,
    pointsAtZ: yt,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: Ks,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: Ks,
    rev: Ks,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: Ks,
    requiredFeatures: Ks,
    requiredFonts: Ks,
    requiredFormats: Ks,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: yt,
    specularExponent: yt,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: yt,
    strikethroughThickness: yt,
    string: null,
    stroke: null,
    strokeDashArray: Ks,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: yt,
    strokeOpacity: yt,
    strokeWidth: null,
    style: null,
    surfaceScale: yt,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: Ks,
    tabIndex: yt,
    tableValues: null,
    target: null,
    targetX: yt,
    targetY: yt,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: Ks,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: yt,
    underlineThickness: yt,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: yt,
    values: null,
    vAlphabetic: yt,
    vMathematical: yt,
    vectorEffect: null,
    vHanging: yt,
    vIdeographic: yt,
    version: null,
    vertAdvY: yt,
    vertOriginX: yt,
    vertOriginY: yt,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: yt,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  }
}), uJe = /^data[-\w.:]+$/i, Oj = /-[a-z]/g, cJe = /[A-Z]/g;
function dJe(e, t) {
  const n = ik(t);
  let r = t, i = Xa;
  if (n in e.normal)
    return e.property[e.normal[n]];
  if (n.length > 4 && n.slice(0, 4) === "data" && uJe.test(t)) {
    if (t.charAt(4) === "-") {
      const o = t.slice(5).replace(Oj, fJe);
      r = "data" + o.charAt(0).toUpperCase() + o.slice(1);
    } else {
      const o = t.slice(4);
      if (!Oj.test(o)) {
        let s = o.replace(cJe, pJe);
        s.charAt(0) !== "-" && (s = "-" + s), t = "data" + s;
      }
    }
    i = y$;
  }
  return new i(r, t);
}
function pJe(e) {
  return "-" + e.toLowerCase();
}
function fJe(e) {
  return e.charAt(1).toUpperCase();
}
const hJe = {
  classId: "classID",
  dataType: "datatype",
  itemId: "itemID",
  strokeDashArray: "strokeDasharray",
  strokeDashOffset: "strokeDashoffset",
  strokeLineCap: "strokeLinecap",
  strokeLineJoin: "strokeLinejoin",
  strokeMiterLimit: "strokeMiterlimit",
  typeOf: "typeof",
  xLinkActuate: "xlinkActuate",
  xLinkArcRole: "xlinkArcrole",
  xLinkHref: "xlinkHref",
  xLinkRole: "xlinkRole",
  xLinkShow: "xlinkShow",
  xLinkTitle: "xlinkTitle",
  xLinkType: "xlinkType",
  xmlnsXLink: "xmlnsXlink"
}, mJe = Eq([Aq, Sq, kq, Oq, aJe], "html"), b$ = Eq([Aq, Sq, kq, Oq, lJe], "svg");
function gJe(e) {
  return e.join(" ").trim();
}
var Iq = {}, Ij = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, yJe = /\n/g, bJe = /^\s*/, vJe = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/, xJe = /^:\s*/, DJe = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/, CJe = /^[;\s]*/, EJe = /^\s+|\s+$/g, TJe = `
`, Fj = "/", $j = "*", Tp = "", SJe = "comment", AJe = "declaration", wJe = function(e, t) {
  if (typeof e != "string")
    throw new TypeError("First argument must be a string");
  if (!e) return [];
  t = t || {};
  var n = 1, r = 1;
  function i(v) {
    var x = v.match(yJe);
    x && (n += x.length);
    var C = v.lastIndexOf(TJe);
    r = ~C ? v.length - C : r + v.length;
  }
  function o() {
    var v = { line: n, column: r };
    return function(x) {
      return x.position = new s(v), c(), x;
    };
  }
  function s(v) {
    this.start = v, this.end = { line: n, column: r }, this.source = t.source;
  }
  s.prototype.content = e;
  function a(v) {
    var x = new Error(
      t.source + ":" + n + ":" + r + ": " + v
    );
    if (x.reason = v, x.filename = t.source, x.line = n, x.column = r, x.source = e, !t.silent) throw x;
  }
  function u(v) {
    var x = v.exec(e);
    if (x) {
      var C = x[0];
      return i(C), e = e.slice(C.length), x;
    }
  }
  function c() {
    u(bJe);
  }
  function d(v) {
    var x;
    for (v = v || []; x = f(); )
      x !== !1 && v.push(x);
    return v;
  }
  function f() {
    var v = o();
    if (!(Fj != e.charAt(0) || $j != e.charAt(1))) {
      for (var x = 2; Tp != e.charAt(x) && ($j != e.charAt(x) || Fj != e.charAt(x + 1)); )
        ++x;
      if (x += 2, Tp === e.charAt(x - 1))
        return a("End of comment missing");
      var C = e.slice(2, x - 2);
      return r += 2, i(C), e = e.slice(x), r += 2, v({
        type: SJe,
        comment: C
      });
    }
  }
  function h() {
    var v = o(), x = u(vJe);
    if (x) {
      if (f(), !u(xJe)) return a("property missing ':'");
      var C = u(DJe), E = v({
        type: AJe,
        property: Nj(x[0].replace(Ij, Tp)),
        value: C ? Nj(C[0].replace(Ij, Tp)) : Tp
      });
      return u(CJe), E;
    }
  }
  function m() {
    var v = [];
    d(v);
    for (var x; x = h(); )
      x !== !1 && (v.push(x), d(v));
    return v;
  }
  return c(), m();
};
function Nj(e) {
  return e ? e.replace(EJe, Tp) : Tp;
}
var PJe = Kr && Kr.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Iq, "__esModule", { value: !0 });
var kJe = PJe(wJe);
function OJe(e, t) {
  var n = null;
  if (!e || typeof e != "string")
    return n;
  var r = (0, kJe.default)(e), i = typeof t == "function";
  return r.forEach(function(o) {
    if (o.type === "declaration") {
      var s = o.property, a = o.value;
      i ? t(s, a, o) : a && (n = n || {}, n[s] = a);
    }
  }), n;
}
var Mj = Iq.default = OJe;
const IJe = Mj.default || Mj, Fq = $q("end"), v$ = $q("start");
function $q(e) {
  return t;
  function t(n) {
    const r = n && n.position && n.position[e] || {};
    if (typeof r.line == "number" && r.line > 0 && typeof r.column == "number" && r.column > 0)
      return {
        line: r.line,
        column: r.column,
        offset: typeof r.offset == "number" && r.offset > -1 ? r.offset : void 0
      };
  }
}
function FJe(e) {
  const t = v$(e), n = Fq(e);
  if (t && n)
    return { start: t, end: n };
}
function m0(e) {
  return !e || typeof e != "object" ? "" : "position" in e || "type" in e ? Rj(e.position) : "start" in e || "end" in e ? Rj(e) : "line" in e || "column" in e ? sk(e) : "";
}
function sk(e) {
  return _j(e && e.line) + ":" + _j(e && e.column);
}
function Rj(e) {
  return sk(e && e.start) + "-" + sk(e && e.end);
}
function _j(e) {
  return e && typeof e == "number" ? e : 1;
}
class Vo extends Error {
  /**
   * Create a message for `reason`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {Options | null | undefined} [options]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | Options | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // eslint-disable-next-line complexity
  constructor(t, n, r) {
    super(), typeof n == "string" && (r = n, n = void 0);
    let i = "", o = {}, s = !1;
    if (n && ("line" in n && "column" in n ? o = { place: n } : "start" in n && "end" in n ? o = { place: n } : "type" in n ? o = {
      ancestors: [n],
      place: n.position
    } : o = { ...n }), typeof t == "string" ? i = t : !o.cause && t && (s = !0, i = t.message, o.cause = t), !o.ruleId && !o.source && typeof r == "string") {
      const u = r.indexOf(":");
      u === -1 ? o.ruleId = r : (o.source = r.slice(0, u), o.ruleId = r.slice(u + 1));
    }
    if (!o.place && o.ancestors && o.ancestors) {
      const u = o.ancestors[o.ancestors.length - 1];
      u && (o.place = u.position);
    }
    const a = o.place && "start" in o.place ? o.place.start : o.place;
    this.ancestors = o.ancestors || void 0, this.cause = o.cause || void 0, this.column = a ? a.column : void 0, this.fatal = void 0, this.file, this.message = i, this.line = a ? a.line : void 0, this.name = m0(o.place) || "1:1", this.place = o.place || void 0, this.reason = this.message, this.ruleId = o.ruleId || void 0, this.source = o.source || void 0, this.stack = s && o.cause && typeof o.cause.stack == "string" ? o.cause.stack : "", this.actual, this.expected, this.note, this.url;
  }
}
Vo.prototype.file = "";
Vo.prototype.name = "";
Vo.prototype.reason = "";
Vo.prototype.message = "";
Vo.prototype.stack = "";
Vo.prototype.column = void 0;
Vo.prototype.line = void 0;
Vo.prototype.ancestors = void 0;
Vo.prototype.cause = void 0;
Vo.prototype.fatal = void 0;
Vo.prototype.place = void 0;
Vo.prototype.ruleId = void 0;
Vo.prototype.source = void 0;
const x$ = {}.hasOwnProperty, $Je = /* @__PURE__ */ new Map(), NJe = /[A-Z]/g, MJe = /-([a-z])/g, RJe = /* @__PURE__ */ new Set(["table", "tbody", "thead", "tfoot", "tr"]), _Je = /* @__PURE__ */ new Set(["td", "th"]), Nq = "https://github.com/syntax-tree/hast-util-to-jsx-runtime";
function LJe(e, t) {
  if (!t || t.Fragment === void 0)
    throw new TypeError("Expected `Fragment` in options");
  const n = t.filePath || void 0;
  let r;
  if (t.development) {
    if (typeof t.jsxDEV != "function")
      throw new TypeError(
        "Expected `jsxDEV` in options when `development: true`"
      );
    r = qJe(n, t.jsxDEV);
  } else {
    if (typeof t.jsx != "function")
      throw new TypeError("Expected `jsx` in production options");
    if (typeof t.jsxs != "function")
      throw new TypeError("Expected `jsxs` in production options");
    r = HJe(n, t.jsx, t.jsxs);
  }
  const i = {
    Fragment: t.Fragment,
    ancestors: [],
    components: t.components || {},
    create: r,
    elementAttributeNameCase: t.elementAttributeNameCase || "react",
    evaluater: t.createEvaluater ? t.createEvaluater() : void 0,
    filePath: n,
    ignoreInvalidStyle: t.ignoreInvalidStyle || !1,
    passKeys: t.passKeys !== !1,
    passNode: t.passNode || !1,
    schema: t.space === "svg" ? b$ : mJe,
    stylePropertyNameCase: t.stylePropertyNameCase || "dom",
    tableCellAlignToStyle: t.tableCellAlignToStyle !== !1
  }, o = Mq(i, e, void 0);
  return o && typeof o != "string" ? o : i.create(
    e,
    i.Fragment,
    { children: o || void 0 },
    void 0
  );
}
function Mq(e, t, n) {
  if (t.type === "element")
    return BJe(e, t, n);
  if (t.type === "mdxFlowExpression" || t.type === "mdxTextExpression")
    return jJe(e, t);
  if (t.type === "mdxJsxFlowElement" || t.type === "mdxJsxTextElement")
    return zJe(e, t, n);
  if (t.type === "mdxjsEsm")
    return VJe(e, t);
  if (t.type === "root")
    return UJe(e, t, n);
  if (t.type === "text")
    return WJe(e, t);
}
function BJe(e, t, n) {
  const r = e.schema;
  let i = r;
  t.tagName.toLowerCase() === "svg" && r.space === "html" && (i = b$, e.schema = i), e.ancestors.push(t);
  const o = _q(e, t.tagName, !1), s = GJe(e, t);
  let a = C$(e, t);
  return RJe.has(t.tagName) && (a = a.filter(function(u) {
    return typeof u == "string" ? !iJe(u) : !0;
  })), Rq(e, s, o, t), D$(s, a), e.ancestors.pop(), e.schema = r, e.create(t, o, s, n);
}
function jJe(e, t) {
  if (t.data && t.data.estree && e.evaluater) {
    const r = t.data.estree.body[0];
    return r.type, /** @type {Child | undefined} */
    e.evaluater.evaluateExpression(r.expression);
  }
  X0(e, t.position);
}
function VJe(e, t) {
  if (t.data && t.data.estree && e.evaluater)
    return (
      /** @type {Child | undefined} */
      e.evaluater.evaluateProgram(t.data.estree)
    );
  X0(e, t.position);
}
function zJe(e, t, n) {
  const r = e.schema;
  let i = r;
  t.name === "svg" && r.space === "html" && (i = b$, e.schema = i), e.ancestors.push(t);
  const o = t.name === null ? e.Fragment : _q(e, t.name, !0), s = YJe(e, t), a = C$(e, t);
  return Rq(e, s, o, t), D$(s, a), e.ancestors.pop(), e.schema = r, e.create(t, o, s, n);
}
function UJe(e, t, n) {
  const r = {};
  return D$(r, C$(e, t)), e.create(t, e.Fragment, r, n);
}
function WJe(e, t) {
  return t.value;
}
function Rq(e, t, n, r) {
  typeof n != "string" && n !== e.Fragment && e.passNode && (t.node = r);
}
function D$(e, t) {
  if (t.length > 0) {
    const n = t.length > 1 ? t : t[0];
    n && (e.children = n);
  }
}
function HJe(e, t, n) {
  return r;
  function r(i, o, s, a) {
    const c = Array.isArray(s.children) ? n : t;
    return a ? c(o, s, a) : c(o, s);
  }
}
function qJe(e, t) {
  return n;
  function n(r, i, o, s) {
    const a = Array.isArray(o.children), u = v$(r);
    return t(
      i,
      o,
      s,
      a,
      {
        columnNumber: u ? u.column - 1 : void 0,
        fileName: e,
        lineNumber: u ? u.line : void 0
      },
      void 0
    );
  }
}
function GJe(e, t) {
  const n = {};
  let r, i;
  for (i in t.properties)
    if (i !== "children" && x$.call(t.properties, i)) {
      const o = KJe(e, i, t.properties[i]);
      if (o) {
        const [s, a] = o;
        e.tableCellAlignToStyle && s === "align" && typeof a == "string" && _Je.has(t.tagName) ? r = a : n[s] = a;
      }
    }
  if (r) {
    const o = (
      /** @type {Style} */
      n.style || (n.style = {})
    );
    o[e.stylePropertyNameCase === "css" ? "text-align" : "textAlign"] = r;
  }
  return n;
}
function YJe(e, t) {
  const n = {};
  for (const r of t.attributes)
    if (r.type === "mdxJsxExpressionAttribute")
      if (r.data && r.data.estree && e.evaluater) {
        const o = r.data.estree.body[0];
        o.type;
        const s = o.expression;
        s.type;
        const a = s.properties[0];
        a.type, Object.assign(
          n,
          e.evaluater.evaluateExpression(a.argument)
        );
      } else
        X0(e, t.position);
    else {
      const i = r.name;
      let o;
      if (r.value && typeof r.value == "object")
        if (r.value.data && r.value.data.estree && e.evaluater) {
          const a = r.value.data.estree.body[0];
          a.type, o = e.evaluater.evaluateExpression(a.expression);
        } else
          X0(e, t.position);
      else
        o = r.value === null ? !0 : r.value;
      n[i] = /** @type {Props[keyof Props]} */
      o;
    }
  return n;
}
function C$(e, t) {
  const n = [];
  let r = -1;
  const i = e.passKeys ? /* @__PURE__ */ new Map() : $Je;
  for (; ++r < t.children.length; ) {
    const o = t.children[r];
    let s;
    if (e.passKeys) {
      const u = o.type === "element" ? o.tagName : o.type === "mdxJsxFlowElement" || o.type === "mdxJsxTextElement" ? o.name : void 0;
      if (u) {
        const c = i.get(u) || 0;
        s = u + "-" + c, i.set(u, c + 1);
      }
    }
    const a = Mq(e, o, s);
    a !== void 0 && n.push(a);
  }
  return n;
}
function KJe(e, t, n) {
  const r = dJe(e.schema, t);
  if (!(n == null || typeof n == "number" && Number.isNaN(n))) {
    if (Array.isArray(n) && (n = r.commaSeparated ? ZKe(n) : gJe(n)), r.property === "style") {
      let i = typeof n == "object" ? n : JJe(e, String(n));
      return e.stylePropertyNameCase === "css" && (i = XJe(i)), ["style", i];
    }
    return [
      e.elementAttributeNameCase === "react" && r.space ? hJe[r.property] || r.property : r.attribute,
      n
    ];
  }
}
function JJe(e, t) {
  const n = {};
  try {
    IJe(t, r);
  } catch (i) {
    if (!e.ignoreInvalidStyle) {
      const o = (
        /** @type {Error} */
        i
      ), s = new Vo("Cannot parse `style` attribute", {
        ancestors: e.ancestors,
        cause: o,
        ruleId: "style",
        source: "hast-util-to-jsx-runtime"
      });
      throw s.file = e.filePath || void 0, s.url = Nq + "#cannot-parse-style-attribute", s;
    }
  }
  return n;
  function r(i, o) {
    let s = i;
    s.slice(0, 2) !== "--" && (s.slice(0, 4) === "-ms-" && (s = "ms-" + s.slice(4)), s = s.replace(MJe, ZJe)), n[s] = o;
  }
}
function _q(e, t, n) {
  let r;
  if (!n)
    r = { type: "Literal", value: t };
  else if (t.includes(".")) {
    const i = t.split(".");
    let o = -1, s;
    for (; ++o < i.length; ) {
      const a = wj(i[o]) ? { type: "Identifier", name: i[o] } : { type: "Literal", value: i[o] };
      s = s ? {
        type: "MemberExpression",
        object: s,
        property: a,
        computed: !!(o && a.type === "Literal"),
        optional: !1
      } : a;
    }
    r = s;
  } else
    r = wj(t) && !/^[a-z]/.test(t) ? { type: "Identifier", name: t } : { type: "Literal", value: t };
  if (r.type === "Literal") {
    const i = (
      /** @type {keyof JSX.IntrinsicElements} */
      r.value
    );
    return x$.call(e.components, i) ? e.components[i] : i;
  }
  if (e.evaluater)
    return e.evaluater.evaluateExpression(r);
  X0(e);
}
function X0(e, t) {
  const n = new Vo(
    "Cannot handle MDX estrees without `createEvaluater`",
    {
      ancestors: e.ancestors,
      place: t,
      ruleId: "mdx-estree",
      source: "hast-util-to-jsx-runtime"
    }
  );
  throw n.file = e.filePath || void 0, n.url = Nq + "#cannot-handle-mdx-estrees-without-createevaluater", n;
}
function XJe(e) {
  const t = {};
  let n;
  for (n in e)
    x$.call(e, n) && (t[QJe(n)] = e[n]);
  return t;
}
function QJe(e) {
  let t = e.replace(NJe, eXe);
  return t.slice(0, 3) === "ms-" && (t = "-" + t), t;
}
function ZJe(e, t) {
  return t.toUpperCase();
}
function eXe(e) {
  return "-" + e.toLowerCase();
}
const uw = {
  action: ["form"],
  cite: ["blockquote", "del", "ins", "q"],
  data: ["object"],
  formAction: ["button", "input"],
  href: ["a", "area", "base", "link"],
  icon: ["menuitem"],
  itemId: null,
  manifest: ["html"],
  ping: ["a", "area"],
  poster: ["video"],
  src: [
    "audio",
    "embed",
    "iframe",
    "img",
    "input",
    "script",
    "source",
    "track",
    "video"
  ]
}, tXe = {};
function nXe(e, t) {
  const n = tXe, r = typeof n.includeImageAlt == "boolean" ? n.includeImageAlt : !0, i = typeof n.includeHtml == "boolean" ? n.includeHtml : !0;
  return Lq(e, r, i);
}
function Lq(e, t, n) {
  if (rXe(e)) {
    if ("value" in e)
      return e.type === "html" && !n ? "" : e.value;
    if (t && "alt" in e && e.alt)
      return e.alt;
    if ("children" in e)
      return Lj(e.children, t, n);
  }
  return Array.isArray(e) ? Lj(e, t, n) : "";
}
function Lj(e, t, n) {
  const r = [];
  let i = -1;
  for (; ++i < e.length; )
    r[i] = Lq(e[i], t, n);
  return r.join("");
}
function rXe(e) {
  return !!(e && typeof e == "object");
}
const Bj = document.createElement("i");
function E$(e) {
  const t = "&" + e + ";";
  Bj.innerHTML = t;
  const n = Bj.textContent;
  return n.charCodeAt(n.length - 1) === 59 && e !== "semi" || n === t ? !1 : n;
}
function lc(e, t, n, r) {
  const i = e.length;
  let o = 0, s;
  if (t < 0 ? t = -t > i ? 0 : i + t : t = t > i ? i : t, n = n > 0 ? n : 0, r.length < 1e4)
    s = Array.from(r), s.unshift(t, n), e.splice(...s);
  else
    for (n && e.splice(t, n); o < r.length; )
      s = r.slice(o, o + 1e4), s.unshift(t, 0), e.splice(...s), o += 1e4, t += 1e4;
}
function Pa(e, t) {
  return e.length > 0 ? (lc(e, e.length, 0, t), e) : t;
}
const jj = {}.hasOwnProperty;
function iXe(e) {
  const t = {};
  let n = -1;
  for (; ++n < e.length; )
    oXe(t, e[n]);
  return t;
}
function oXe(e, t) {
  let n;
  for (n in t) {
    const i = (jj.call(e, n) ? e[n] : void 0) || (e[n] = {}), o = t[n];
    let s;
    if (o)
      for (s in o) {
        jj.call(i, s) || (i[s] = []);
        const a = o[s];
        sXe(
          // @ts-expect-error Looks like a list.
          i[s],
          Array.isArray(a) ? a : a ? [a] : []
        );
      }
  }
}
function sXe(e, t) {
  let n = -1;
  const r = [];
  for (; ++n < t.length; )
    (t[n].add === "after" ? e : r).push(t[n]);
  lc(e, 0, 0, r);
}
function Bq(e, t) {
  const n = Number.parseInt(e, t);
  return (
    // C0 except for HT, LF, FF, CR, space.
    n < 9 || n === 11 || n > 13 && n < 32 || // Control character (DEL) of C0, and C1 controls.
    n > 126 && n < 160 || // Lone high surrogates and low surrogates.
    n > 55295 && n < 57344 || // Noncharacters.
    n > 64975 && n < 65008 || /* eslint-disable no-bitwise */
    (n & 65535) === 65535 || (n & 65535) === 65534 || /* eslint-enable no-bitwise */
    // Out of range
    n > 1114111 ? "�" : String.fromCodePoint(n)
  );
}
function Qh(e) {
  return e.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
const Jl = $d(/[A-Za-z]/), ea = $d(/[\dA-Za-z]/), aXe = $d(/[#-'*+\--9=?A-Z^-~]/);
function ak(e) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    e !== null && (e < 32 || e === 127)
  );
}
const lk = $d(/\d/), lXe = $d(/[\dA-Fa-f]/), uXe = $d(/[!-/:-@[-`{-~]/);
function yn(e) {
  return e !== null && e < -2;
}
function Os(e) {
  return e !== null && (e < 0 || e === 32);
}
function gr(e) {
  return e === -2 || e === -1 || e === 32;
}
const cXe = $d(new RegExp("\\p{P}|\\p{S}", "u")), dXe = $d(/\s/);
function $d(e) {
  return t;
  function t(n) {
    return n !== null && n > -1 && e.test(String.fromCharCode(n));
  }
}
function xg(e) {
  const t = [];
  let n = -1, r = 0, i = 0;
  for (; ++n < e.length; ) {
    const o = e.charCodeAt(n);
    let s = "";
    if (o === 37 && ea(e.charCodeAt(n + 1)) && ea(e.charCodeAt(n + 2)))
      i = 2;
    else if (o < 128)
      /[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(o)) || (s = String.fromCharCode(o));
    else if (o > 55295 && o < 57344) {
      const a = e.charCodeAt(n + 1);
      o < 56320 && a > 56319 && a < 57344 ? (s = String.fromCharCode(o, a), i = 1) : s = "�";
    } else
      s = String.fromCharCode(o);
    s && (t.push(e.slice(r, n), encodeURIComponent(s)), r = n + i + 1, s = ""), i && (n += i, i = 0);
  }
  return t.join("") + e.slice(r);
}
function Ur(e, t, n, r) {
  const i = r ? r - 1 : Number.POSITIVE_INFINITY;
  let o = 0;
  return s;
  function s(u) {
    return gr(u) ? (e.enter(n), a(u)) : t(u);
  }
  function a(u) {
    return gr(u) && o++ < i ? (e.consume(u), a) : (e.exit(n), t(u));
  }
}
const pXe = {
  tokenize: fXe
};
function fXe(e) {
  const t = e.attempt(
    this.parser.constructs.contentInitial,
    r,
    i
  );
  let n;
  return t;
  function r(a) {
    if (a === null) {
      e.consume(a);
      return;
    }
    return e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), Ur(e, t, "linePrefix");
  }
  function i(a) {
    return e.enter("paragraph"), o(a);
  }
  function o(a) {
    const u = e.enter("chunkText", {
      contentType: "text",
      previous: n
    });
    return n && (n.next = u), n = u, s(a);
  }
  function s(a) {
    if (a === null) {
      e.exit("chunkText"), e.exit("paragraph"), e.consume(a);
      return;
    }
    return yn(a) ? (e.consume(a), e.exit("chunkText"), o) : (e.consume(a), s);
  }
}
const hXe = {
  tokenize: mXe
}, Vj = {
  tokenize: gXe
};
function mXe(e) {
  const t = this, n = [];
  let r = 0, i, o, s;
  return a;
  function a(w) {
    if (r < n.length) {
      const O = n[r];
      return t.containerState = O[1], e.attempt(
        O[0].continuation,
        u,
        c
      )(w);
    }
    return c(w);
  }
  function u(w) {
    if (r++, t.containerState._closeFlow) {
      t.containerState._closeFlow = void 0, i && S();
      const O = t.events.length;
      let A = O, I;
      for (; A--; )
        if (t.events[A][0] === "exit" && t.events[A][1].type === "chunkFlow") {
          I = t.events[A][1].end;
          break;
        }
      E(r);
      let $ = O;
      for (; $ < t.events.length; )
        t.events[$][1].end = Object.assign({}, I), $++;
      return lc(
        t.events,
        A + 1,
        0,
        t.events.slice(O)
      ), t.events.length = $, c(w);
    }
    return a(w);
  }
  function c(w) {
    if (r === n.length) {
      if (!i)
        return h(w);
      if (i.currentConstruct && i.currentConstruct.concrete)
        return v(w);
      t.interrupt = !!(i.currentConstruct && !i._gfmTableDynamicInterruptHack);
    }
    return t.containerState = {}, e.check(
      Vj,
      d,
      f
    )(w);
  }
  function d(w) {
    return i && S(), E(r), h(w);
  }
  function f(w) {
    return t.parser.lazy[t.now().line] = r !== n.length, s = t.now().offset, v(w);
  }
  function h(w) {
    return t.containerState = {}, e.attempt(
      Vj,
      m,
      v
    )(w);
  }
  function m(w) {
    return r++, n.push([t.currentConstruct, t.containerState]), h(w);
  }
  function v(w) {
    if (w === null) {
      i && S(), E(0), e.consume(w);
      return;
    }
    return i = i || t.parser.flow(t.now()), e.enter("chunkFlow", {
      contentType: "flow",
      previous: o,
      _tokenizer: i
    }), x(w);
  }
  function x(w) {
    if (w === null) {
      C(e.exit("chunkFlow"), !0), E(0), e.consume(w);
      return;
    }
    return yn(w) ? (e.consume(w), C(e.exit("chunkFlow")), r = 0, t.interrupt = void 0, a) : (e.consume(w), x);
  }
  function C(w, O) {
    const A = t.sliceStream(w);
    if (O && A.push(null), w.previous = o, o && (o.next = w), o = w, i.defineSkip(w.start), i.write(A), t.parser.lazy[w.start.line]) {
      let I = i.events.length;
      for (; I--; )
        if (
          // The token starts before the line ending…
          i.events[I][1].start.offset < s && // …and either is not ended yet…
          (!i.events[I][1].end || // …or ends after it.
          i.events[I][1].end.offset > s)
        )
          return;
      const $ = t.events.length;
      let L = $, B, H;
      for (; L--; )
        if (t.events[L][0] === "exit" && t.events[L][1].type === "chunkFlow") {
          if (B) {
            H = t.events[L][1].end;
            break;
          }
          B = !0;
        }
      for (E(r), I = $; I < t.events.length; )
        t.events[I][1].end = Object.assign({}, H), I++;
      lc(
        t.events,
        L + 1,
        0,
        t.events.slice($)
      ), t.events.length = I;
    }
  }
  function E(w) {
    let O = n.length;
    for (; O-- > w; ) {
      const A = n[O];
      t.containerState = A[1], A[0].exit.call(t, e);
    }
    n.length = w;
  }
  function S() {
    i.write([null]), o = void 0, i = void 0, t.containerState._closeFlow = void 0;
  }
}
function gXe(e, t, n) {
  return Ur(
    e,
    e.attempt(this.parser.constructs.document, t, n),
    "linePrefix",
    this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
  );
}
function zj(e) {
  if (e === null || Os(e) || dXe(e))
    return 1;
  if (cXe(e))
    return 2;
}
function T$(e, t, n) {
  const r = [];
  let i = -1;
  for (; ++i < e.length; ) {
    const o = e[i].resolveAll;
    o && !r.includes(o) && (t = o(t, n), r.push(o));
  }
  return t;
}
const uk = {
  name: "attention",
  tokenize: bXe,
  resolveAll: yXe
};
function yXe(e, t) {
  let n = -1, r, i, o, s, a, u, c, d;
  for (; ++n < e.length; )
    if (e[n][0] === "enter" && e[n][1].type === "attentionSequence" && e[n][1]._close) {
      for (r = n; r--; )
        if (e[r][0] === "exit" && e[r][1].type === "attentionSequence" && e[r][1]._open && // If the markers are the same:
        t.sliceSerialize(e[r][1]).charCodeAt(0) === t.sliceSerialize(e[n][1]).charCodeAt(0)) {
          if ((e[r][1]._close || e[n][1]._open) && (e[n][1].end.offset - e[n][1].start.offset) % 3 && !((e[r][1].end.offset - e[r][1].start.offset + e[n][1].end.offset - e[n][1].start.offset) % 3))
            continue;
          u = e[r][1].end.offset - e[r][1].start.offset > 1 && e[n][1].end.offset - e[n][1].start.offset > 1 ? 2 : 1;
          const f = Object.assign({}, e[r][1].end), h = Object.assign({}, e[n][1].start);
          Uj(f, -u), Uj(h, u), s = {
            type: u > 1 ? "strongSequence" : "emphasisSequence",
            start: f,
            end: Object.assign({}, e[r][1].end)
          }, a = {
            type: u > 1 ? "strongSequence" : "emphasisSequence",
            start: Object.assign({}, e[n][1].start),
            end: h
          }, o = {
            type: u > 1 ? "strongText" : "emphasisText",
            start: Object.assign({}, e[r][1].end),
            end: Object.assign({}, e[n][1].start)
          }, i = {
            type: u > 1 ? "strong" : "emphasis",
            start: Object.assign({}, s.start),
            end: Object.assign({}, a.end)
          }, e[r][1].end = Object.assign({}, s.start), e[n][1].start = Object.assign({}, a.end), c = [], e[r][1].end.offset - e[r][1].start.offset && (c = Pa(c, [["enter", e[r][1], t], ["exit", e[r][1], t]])), c = Pa(c, [["enter", i, t], ["enter", s, t], ["exit", s, t], ["enter", o, t]]), c = Pa(c, T$(t.parser.constructs.insideSpan.null, e.slice(r + 1, n), t)), c = Pa(c, [["exit", o, t], ["enter", a, t], ["exit", a, t], ["exit", i, t]]), e[n][1].end.offset - e[n][1].start.offset ? (d = 2, c = Pa(c, [["enter", e[n][1], t], ["exit", e[n][1], t]])) : d = 0, lc(e, r - 1, n - r + 3, c), n = r + c.length - d - 2;
          break;
        }
    }
  for (n = -1; ++n < e.length; )
    e[n][1].type === "attentionSequence" && (e[n][1].type = "data");
  return e;
}
function bXe(e, t) {
  const n = this.parser.constructs.attentionMarkers.null, r = this.previous, i = zj(r);
  let o;
  return s;
  function s(u) {
    return o = u, e.enter("attentionSequence"), a(u);
  }
  function a(u) {
    if (u === o)
      return e.consume(u), a;
    const c = e.exit("attentionSequence"), d = zj(u), f = !d || d === 2 && i || n.includes(u), h = !i || i === 2 && d || n.includes(r);
    return c._open = !!(o === 42 ? f : f && (i || !h)), c._close = !!(o === 42 ? h : h && (d || !f)), t(u);
  }
}
function Uj(e, t) {
  e.column += t, e.offset += t, e._bufferIndex += t;
}
const vXe = {
  name: "autolink",
  tokenize: xXe
};
function xXe(e, t, n) {
  let r = 0;
  return i;
  function i(m) {
    return e.enter("autolink"), e.enter("autolinkMarker"), e.consume(m), e.exit("autolinkMarker"), e.enter("autolinkProtocol"), o;
  }
  function o(m) {
    return Jl(m) ? (e.consume(m), s) : m === 64 ? n(m) : c(m);
  }
  function s(m) {
    return m === 43 || m === 45 || m === 46 || ea(m) ? (r = 1, a(m)) : c(m);
  }
  function a(m) {
    return m === 58 ? (e.consume(m), r = 0, u) : (m === 43 || m === 45 || m === 46 || ea(m)) && r++ < 32 ? (e.consume(m), a) : (r = 0, c(m));
  }
  function u(m) {
    return m === 62 ? (e.exit("autolinkProtocol"), e.enter("autolinkMarker"), e.consume(m), e.exit("autolinkMarker"), e.exit("autolink"), t) : m === null || m === 32 || m === 60 || ak(m) ? n(m) : (e.consume(m), u);
  }
  function c(m) {
    return m === 64 ? (e.consume(m), d) : aXe(m) ? (e.consume(m), c) : n(m);
  }
  function d(m) {
    return ea(m) ? f(m) : n(m);
  }
  function f(m) {
    return m === 46 ? (e.consume(m), r = 0, d) : m === 62 ? (e.exit("autolinkProtocol").type = "autolinkEmail", e.enter("autolinkMarker"), e.consume(m), e.exit("autolinkMarker"), e.exit("autolink"), t) : h(m);
  }
  function h(m) {
    if ((m === 45 || ea(m)) && r++ < 63) {
      const v = m === 45 ? h : f;
      return e.consume(m), v;
    }
    return n(m);
  }
}
const nT = {
  tokenize: DXe,
  partial: !0
};
function DXe(e, t, n) {
  return r;
  function r(o) {
    return gr(o) ? Ur(e, i, "linePrefix")(o) : i(o);
  }
  function i(o) {
    return o === null || yn(o) ? t(o) : n(o);
  }
}
const jq = {
  name: "blockQuote",
  tokenize: CXe,
  continuation: {
    tokenize: EXe
  },
  exit: TXe
};
function CXe(e, t, n) {
  const r = this;
  return i;
  function i(s) {
    if (s === 62) {
      const a = r.containerState;
      return a.open || (e.enter("blockQuote", {
        _container: !0
      }), a.open = !0), e.enter("blockQuotePrefix"), e.enter("blockQuoteMarker"), e.consume(s), e.exit("blockQuoteMarker"), o;
    }
    return n(s);
  }
  function o(s) {
    return gr(s) ? (e.enter("blockQuotePrefixWhitespace"), e.consume(s), e.exit("blockQuotePrefixWhitespace"), e.exit("blockQuotePrefix"), t) : (e.exit("blockQuotePrefix"), t(s));
  }
}
function EXe(e, t, n) {
  const r = this;
  return i;
  function i(s) {
    return gr(s) ? Ur(e, o, "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(s) : o(s);
  }
  function o(s) {
    return e.attempt(jq, t, n)(s);
  }
}
function TXe(e) {
  e.exit("blockQuote");
}
const Vq = {
  name: "characterEscape",
  tokenize: SXe
};
function SXe(e, t, n) {
  return r;
  function r(o) {
    return e.enter("characterEscape"), e.enter("escapeMarker"), e.consume(o), e.exit("escapeMarker"), i;
  }
  function i(o) {
    return uXe(o) ? (e.enter("characterEscapeValue"), e.consume(o), e.exit("characterEscapeValue"), e.exit("characterEscape"), t) : n(o);
  }
}
const zq = {
  name: "characterReference",
  tokenize: AXe
};
function AXe(e, t, n) {
  const r = this;
  let i = 0, o, s;
  return a;
  function a(f) {
    return e.enter("characterReference"), e.enter("characterReferenceMarker"), e.consume(f), e.exit("characterReferenceMarker"), u;
  }
  function u(f) {
    return f === 35 ? (e.enter("characterReferenceMarkerNumeric"), e.consume(f), e.exit("characterReferenceMarkerNumeric"), c) : (e.enter("characterReferenceValue"), o = 31, s = ea, d(f));
  }
  function c(f) {
    return f === 88 || f === 120 ? (e.enter("characterReferenceMarkerHexadecimal"), e.consume(f), e.exit("characterReferenceMarkerHexadecimal"), e.enter("characterReferenceValue"), o = 6, s = lXe, d) : (e.enter("characterReferenceValue"), o = 7, s = lk, d(f));
  }
  function d(f) {
    if (f === 59 && i) {
      const h = e.exit("characterReferenceValue");
      return s === ea && !E$(r.sliceSerialize(h)) ? n(f) : (e.enter("characterReferenceMarker"), e.consume(f), e.exit("characterReferenceMarker"), e.exit("characterReference"), t);
    }
    return s(f) && i++ < o ? (e.consume(f), d) : n(f);
  }
}
const Wj = {
  tokenize: PXe,
  partial: !0
}, Hj = {
  name: "codeFenced",
  tokenize: wXe,
  concrete: !0
};
function wXe(e, t, n) {
  const r = this, i = {
    tokenize: A,
    partial: !0
  };
  let o = 0, s = 0, a;
  return u;
  function u(I) {
    return c(I);
  }
  function c(I) {
    const $ = r.events[r.events.length - 1];
    return o = $ && $[1].type === "linePrefix" ? $[2].sliceSerialize($[1], !0).length : 0, a = I, e.enter("codeFenced"), e.enter("codeFencedFence"), e.enter("codeFencedFenceSequence"), d(I);
  }
  function d(I) {
    return I === a ? (s++, e.consume(I), d) : s < 3 ? n(I) : (e.exit("codeFencedFenceSequence"), gr(I) ? Ur(e, f, "whitespace")(I) : f(I));
  }
  function f(I) {
    return I === null || yn(I) ? (e.exit("codeFencedFence"), r.interrupt ? t(I) : e.check(Wj, x, O)(I)) : (e.enter("codeFencedFenceInfo"), e.enter("chunkString", {
      contentType: "string"
    }), h(I));
  }
  function h(I) {
    return I === null || yn(I) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), f(I)) : gr(I) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), Ur(e, m, "whitespace")(I)) : I === 96 && I === a ? n(I) : (e.consume(I), h);
  }
  function m(I) {
    return I === null || yn(I) ? f(I) : (e.enter("codeFencedFenceMeta"), e.enter("chunkString", {
      contentType: "string"
    }), v(I));
  }
  function v(I) {
    return I === null || yn(I) ? (e.exit("chunkString"), e.exit("codeFencedFenceMeta"), f(I)) : I === 96 && I === a ? n(I) : (e.consume(I), v);
  }
  function x(I) {
    return e.attempt(i, O, C)(I);
  }
  function C(I) {
    return e.enter("lineEnding"), e.consume(I), e.exit("lineEnding"), E;
  }
  function E(I) {
    return o > 0 && gr(I) ? Ur(e, S, "linePrefix", o + 1)(I) : S(I);
  }
  function S(I) {
    return I === null || yn(I) ? e.check(Wj, x, O)(I) : (e.enter("codeFlowValue"), w(I));
  }
  function w(I) {
    return I === null || yn(I) ? (e.exit("codeFlowValue"), S(I)) : (e.consume(I), w);
  }
  function O(I) {
    return e.exit("codeFenced"), t(I);
  }
  function A(I, $, L) {
    let B = 0;
    return H;
    function H(U) {
      return I.enter("lineEnding"), I.consume(U), I.exit("lineEnding"), q;
    }
    function q(U) {
      return I.enter("codeFencedFence"), gr(U) ? Ur(I, J, "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(U) : J(U);
    }
    function J(U) {
      return U === a ? (I.enter("codeFencedFenceSequence"), X(U)) : L(U);
    }
    function X(U) {
      return U === a ? (B++, I.consume(U), X) : B >= s ? (I.exit("codeFencedFenceSequence"), gr(U) ? Ur(I, j, "whitespace")(U) : j(U)) : L(U);
    }
    function j(U) {
      return U === null || yn(U) ? (I.exit("codeFencedFence"), $(U)) : L(U);
    }
  }
}
function PXe(e, t, n) {
  const r = this;
  return i;
  function i(s) {
    return s === null ? n(s) : (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), o);
  }
  function o(s) {
    return r.parser.lazy[r.now().line] ? n(s) : t(s);
  }
}
const cw = {
  name: "codeIndented",
  tokenize: OXe
}, kXe = {
  tokenize: IXe,
  partial: !0
};
function OXe(e, t, n) {
  const r = this;
  return i;
  function i(c) {
    return e.enter("codeIndented"), Ur(e, o, "linePrefix", 5)(c);
  }
  function o(c) {
    const d = r.events[r.events.length - 1];
    return d && d[1].type === "linePrefix" && d[2].sliceSerialize(d[1], !0).length >= 4 ? s(c) : n(c);
  }
  function s(c) {
    return c === null ? u(c) : yn(c) ? e.attempt(kXe, s, u)(c) : (e.enter("codeFlowValue"), a(c));
  }
  function a(c) {
    return c === null || yn(c) ? (e.exit("codeFlowValue"), s(c)) : (e.consume(c), a);
  }
  function u(c) {
    return e.exit("codeIndented"), t(c);
  }
}
function IXe(e, t, n) {
  const r = this;
  return i;
  function i(s) {
    return r.parser.lazy[r.now().line] ? n(s) : yn(s) ? (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), i) : Ur(e, o, "linePrefix", 5)(s);
  }
  function o(s) {
    const a = r.events[r.events.length - 1];
    return a && a[1].type === "linePrefix" && a[2].sliceSerialize(a[1], !0).length >= 4 ? t(s) : yn(s) ? i(s) : n(s);
  }
}
const FXe = {
  name: "codeText",
  tokenize: MXe,
  resolve: $Xe,
  previous: NXe
};
function $Xe(e) {
  let t = e.length - 4, n = 3, r, i;
  if ((e[n][1].type === "lineEnding" || e[n][1].type === "space") && (e[t][1].type === "lineEnding" || e[t][1].type === "space")) {
    for (r = n; ++r < t; )
      if (e[r][1].type === "codeTextData") {
        e[n][1].type = "codeTextPadding", e[t][1].type = "codeTextPadding", n += 2, t -= 2;
        break;
      }
  }
  for (r = n - 1, t++; ++r <= t; )
    i === void 0 ? r !== t && e[r][1].type !== "lineEnding" && (i = r) : (r === t || e[r][1].type === "lineEnding") && (e[i][1].type = "codeTextData", r !== i + 2 && (e[i][1].end = e[r - 1][1].end, e.splice(i + 2, r - i - 2), t -= r - i - 2, r = i + 2), i = void 0);
  return e;
}
function NXe(e) {
  return e !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function MXe(e, t, n) {
  let r = 0, i, o;
  return s;
  function s(f) {
    return e.enter("codeText"), e.enter("codeTextSequence"), a(f);
  }
  function a(f) {
    return f === 96 ? (e.consume(f), r++, a) : (e.exit("codeTextSequence"), u(f));
  }
  function u(f) {
    return f === null ? n(f) : f === 32 ? (e.enter("space"), e.consume(f), e.exit("space"), u) : f === 96 ? (o = e.enter("codeTextSequence"), i = 0, d(f)) : yn(f) ? (e.enter("lineEnding"), e.consume(f), e.exit("lineEnding"), u) : (e.enter("codeTextData"), c(f));
  }
  function c(f) {
    return f === null || f === 32 || f === 96 || yn(f) ? (e.exit("codeTextData"), u(f)) : (e.consume(f), c);
  }
  function d(f) {
    return f === 96 ? (e.consume(f), i++, d) : i === r ? (e.exit("codeTextSequence"), e.exit("codeText"), t(f)) : (o.type = "codeTextData", c(f));
  }
}
class RXe {
  /**
   * @param {ReadonlyArray<T> | null | undefined} [initial]
   *   Initial items (optional).
   * @returns
   *   Splice buffer.
   */
  constructor(t) {
    this.left = t ? [...t] : [], this.right = [];
  }
  /**
   * Array access;
   * does not move the cursor.
   *
   * @param {number} index
   *   Index.
   * @return {T}
   *   Item.
   */
  get(t) {
    if (t < 0 || t >= this.left.length + this.right.length)
      throw new RangeError("Cannot access index `" + t + "` in a splice buffer of size `" + (this.left.length + this.right.length) + "`");
    return t < this.left.length ? this.left[t] : this.right[this.right.length - t + this.left.length - 1];
  }
  /**
   * The length of the splice buffer, one greater than the largest index in the
   * array.
   */
  get length() {
    return this.left.length + this.right.length;
  }
  /**
   * Remove and return `list[0]`;
   * moves the cursor to `0`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  shift() {
    return this.setCursor(0), this.right.pop();
  }
  /**
   * Slice the buffer to get an array;
   * does not move the cursor.
   *
   * @param {number} start
   *   Start.
   * @param {number | null | undefined} [end]
   *   End (optional).
   * @returns {Array<T>}
   *   Array of items.
   */
  slice(t, n) {
    const r = n ?? Number.POSITIVE_INFINITY;
    return r < this.left.length ? this.left.slice(t, r) : t > this.left.length ? this.right.slice(this.right.length - r + this.left.length, this.right.length - t + this.left.length).reverse() : this.left.slice(t).concat(this.right.slice(this.right.length - r + this.left.length).reverse());
  }
  /**
   * Mimics the behavior of Array.prototype.splice() except for the change of
   * interface necessary to avoid segfaults when patching in very large arrays.
   *
   * This operation moves cursor is moved to `start` and results in the cursor
   * placed after any inserted items.
   *
   * @param {number} start
   *   Start;
   *   zero-based index at which to start changing the array;
   *   negative numbers count backwards from the end of the array and values
   *   that are out-of bounds are clamped to the appropriate end of the array.
   * @param {number | null | undefined} [deleteCount=0]
   *   Delete count (default: `0`);
   *   maximum number of elements to delete, starting from start.
   * @param {Array<T> | null | undefined} [items=[]]
   *   Items to include in place of the deleted items (default: `[]`).
   * @return {Array<T>}
   *   Any removed items.
   */
  splice(t, n, r) {
    const i = n || 0;
    this.setCursor(Math.trunc(t));
    const o = this.right.splice(this.right.length - i, Number.POSITIVE_INFINITY);
    return r && Fy(this.left, r), o.reverse();
  }
  /**
   * Remove and return the highest-numbered item in the array, so
   * `list[list.length - 1]`;
   * Moves the cursor to `length`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  pop() {
    return this.setCursor(Number.POSITIVE_INFINITY), this.left.pop();
  }
  /**
   * Inserts a single item to the high-numbered side of the array;
   * moves the cursor to `length`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  push(t) {
    this.setCursor(Number.POSITIVE_INFINITY), this.left.push(t);
  }
  /**
   * Inserts many items to the high-numbered side of the array.
   * Moves the cursor to `length`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  pushMany(t) {
    this.setCursor(Number.POSITIVE_INFINITY), Fy(this.left, t);
  }
  /**
   * Inserts a single item to the low-numbered side of the array;
   * Moves the cursor to `0`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  unshift(t) {
    this.setCursor(0), this.right.push(t);
  }
  /**
   * Inserts many items to the low-numbered side of the array;
   * moves the cursor to `0`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  unshiftMany(t) {
    this.setCursor(0), Fy(this.right, t.reverse());
  }
  /**
   * Move the cursor to a specific position in the array. Requires
   * time proportional to the distance moved.
   *
   * If `n < 0`, the cursor will end up at the beginning.
   * If `n > length`, the cursor will end up at the end.
   *
   * @param {number} n
   *   Position.
   * @return {undefined}
   *   Nothing.
   */
  setCursor(t) {
    if (!(t === this.left.length || t > this.left.length && this.right.length === 0 || t < 0 && this.left.length === 0))
      if (t < this.left.length) {
        const n = this.left.splice(t, Number.POSITIVE_INFINITY);
        Fy(this.right, n.reverse());
      } else {
        const n = this.right.splice(this.left.length + this.right.length - t, Number.POSITIVE_INFINITY);
        Fy(this.left, n.reverse());
      }
  }
}
function Fy(e, t) {
  let n = 0;
  if (t.length < 1e4)
    e.push(...t);
  else
    for (; n < t.length; )
      e.push(...t.slice(n, n + 1e4)), n += 1e4;
}
function Uq(e) {
  const t = {};
  let n = -1, r, i, o, s, a, u, c;
  const d = new RXe(e);
  for (; ++n < d.length; ) {
    for (; n in t; )
      n = t[n];
    if (r = d.get(n), n && r[1].type === "chunkFlow" && d.get(n - 1)[1].type === "listItemPrefix" && (u = r[1]._tokenizer.events, o = 0, o < u.length && u[o][1].type === "lineEndingBlank" && (o += 2), o < u.length && u[o][1].type === "content"))
      for (; ++o < u.length && u[o][1].type !== "content"; )
        u[o][1].type === "chunkText" && (u[o][1]._isInFirstContentOfListItem = !0, o++);
    if (r[0] === "enter")
      r[1].contentType && (Object.assign(t, _Xe(d, n)), n = t[n], c = !0);
    else if (r[1]._container) {
      for (o = n, i = void 0; o-- && (s = d.get(o), s[1].type === "lineEnding" || s[1].type === "lineEndingBlank"); )
        s[0] === "enter" && (i && (d.get(i)[1].type = "lineEndingBlank"), s[1].type = "lineEnding", i = o);
      i && (r[1].end = Object.assign({}, d.get(i)[1].start), a = d.slice(i, n), a.unshift(r), d.splice(i, n - i + 1, a));
    }
  }
  return lc(e, 0, Number.POSITIVE_INFINITY, d.slice(0)), !c;
}
function _Xe(e, t) {
  const n = e.get(t)[1], r = e.get(t)[2];
  let i = t - 1;
  const o = [], s = n._tokenizer || r.parser[n.contentType](n.start), a = s.events, u = [], c = {};
  let d, f, h = -1, m = n, v = 0, x = 0;
  const C = [x];
  for (; m; ) {
    for (; e.get(++i)[1] !== m; )
      ;
    o.push(i), m._tokenizer || (d = r.sliceStream(m), m.next || d.push(null), f && s.defineSkip(m.start), m._isInFirstContentOfListItem && (s._gfmTasklistFirstContentOfListItem = !0), s.write(d), m._isInFirstContentOfListItem && (s._gfmTasklistFirstContentOfListItem = void 0)), f = m, m = m.next;
  }
  for (m = n; ++h < a.length; )
    // Find a void token that includes a break.
    a[h][0] === "exit" && a[h - 1][0] === "enter" && a[h][1].type === a[h - 1][1].type && a[h][1].start.line !== a[h][1].end.line && (x = h + 1, C.push(x), m._tokenizer = void 0, m.previous = void 0, m = m.next);
  for (s.events = [], m ? (m._tokenizer = void 0, m.previous = void 0) : C.pop(), h = C.length; h--; ) {
    const E = a.slice(C[h], C[h + 1]), S = o.pop();
    u.push([S, S + E.length - 1]), e.splice(S, 2, E);
  }
  for (u.reverse(), h = -1; ++h < u.length; )
    c[v + u[h][0]] = v + u[h][1], v += u[h][1] - u[h][0] - 1;
  return c;
}
const LXe = {
  tokenize: VXe,
  resolve: jXe
}, BXe = {
  tokenize: zXe,
  partial: !0
};
function jXe(e) {
  return Uq(e), e;
}
function VXe(e, t) {
  let n;
  return r;
  function r(a) {
    return e.enter("content"), n = e.enter("chunkContent", {
      contentType: "content"
    }), i(a);
  }
  function i(a) {
    return a === null ? o(a) : yn(a) ? e.check(BXe, s, o)(a) : (e.consume(a), i);
  }
  function o(a) {
    return e.exit("chunkContent"), e.exit("content"), t(a);
  }
  function s(a) {
    return e.consume(a), e.exit("chunkContent"), n.next = e.enter("chunkContent", {
      contentType: "content",
      previous: n
    }), n = n.next, i;
  }
}
function zXe(e, t, n) {
  const r = this;
  return i;
  function i(s) {
    return e.exit("chunkContent"), e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), Ur(e, o, "linePrefix");
  }
  function o(s) {
    if (s === null || yn(s))
      return n(s);
    const a = r.events[r.events.length - 1];
    return !r.parser.constructs.disable.null.includes("codeIndented") && a && a[1].type === "linePrefix" && a[2].sliceSerialize(a[1], !0).length >= 4 ? t(s) : e.interrupt(r.parser.constructs.flow, n, t)(s);
  }
}
function Wq(e, t, n, r, i, o, s, a, u) {
  const c = u || Number.POSITIVE_INFINITY;
  let d = 0;
  return f;
  function f(E) {
    return E === 60 ? (e.enter(r), e.enter(i), e.enter(o), e.consume(E), e.exit(o), h) : E === null || E === 32 || E === 41 || ak(E) ? n(E) : (e.enter(r), e.enter(s), e.enter(a), e.enter("chunkString", {
      contentType: "string"
    }), x(E));
  }
  function h(E) {
    return E === 62 ? (e.enter(o), e.consume(E), e.exit(o), e.exit(i), e.exit(r), t) : (e.enter(a), e.enter("chunkString", {
      contentType: "string"
    }), m(E));
  }
  function m(E) {
    return E === 62 ? (e.exit("chunkString"), e.exit(a), h(E)) : E === null || E === 60 || yn(E) ? n(E) : (e.consume(E), E === 92 ? v : m);
  }
  function v(E) {
    return E === 60 || E === 62 || E === 92 ? (e.consume(E), m) : m(E);
  }
  function x(E) {
    return !d && (E === null || E === 41 || Os(E)) ? (e.exit("chunkString"), e.exit(a), e.exit(s), e.exit(r), t(E)) : d < c && E === 40 ? (e.consume(E), d++, x) : E === 41 ? (e.consume(E), d--, x) : E === null || E === 32 || E === 40 || ak(E) ? n(E) : (e.consume(E), E === 92 ? C : x);
  }
  function C(E) {
    return E === 40 || E === 41 || E === 92 ? (e.consume(E), x) : x(E);
  }
}
function Hq(e, t, n, r, i, o) {
  const s = this;
  let a = 0, u;
  return c;
  function c(m) {
    return e.enter(r), e.enter(i), e.consume(m), e.exit(i), e.enter(o), d;
  }
  function d(m) {
    return a > 999 || m === null || m === 91 || m === 93 && !u || // To do: remove in the future once we’ve switched from
    // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
    // which doesn’t need this.
    // Hidden footnotes hook.
    /* c8 ignore next 3 */
    m === 94 && !a && "_hiddenFootnoteSupport" in s.parser.constructs ? n(m) : m === 93 ? (e.exit(o), e.enter(i), e.consume(m), e.exit(i), e.exit(r), t) : yn(m) ? (e.enter("lineEnding"), e.consume(m), e.exit("lineEnding"), d) : (e.enter("chunkString", {
      contentType: "string"
    }), f(m));
  }
  function f(m) {
    return m === null || m === 91 || m === 93 || yn(m) || a++ > 999 ? (e.exit("chunkString"), d(m)) : (e.consume(m), u || (u = !gr(m)), m === 92 ? h : f);
  }
  function h(m) {
    return m === 91 || m === 92 || m === 93 ? (e.consume(m), a++, f) : f(m);
  }
}
function qq(e, t, n, r, i, o) {
  let s;
  return a;
  function a(h) {
    return h === 34 || h === 39 || h === 40 ? (e.enter(r), e.enter(i), e.consume(h), e.exit(i), s = h === 40 ? 41 : h, u) : n(h);
  }
  function u(h) {
    return h === s ? (e.enter(i), e.consume(h), e.exit(i), e.exit(r), t) : (e.enter(o), c(h));
  }
  function c(h) {
    return h === s ? (e.exit(o), u(s)) : h === null ? n(h) : yn(h) ? (e.enter("lineEnding"), e.consume(h), e.exit("lineEnding"), Ur(e, c, "linePrefix")) : (e.enter("chunkString", {
      contentType: "string"
    }), d(h));
  }
  function d(h) {
    return h === s || h === null || yn(h) ? (e.exit("chunkString"), c(h)) : (e.consume(h), h === 92 ? f : d);
  }
  function f(h) {
    return h === s || h === 92 ? (e.consume(h), d) : d(h);
  }
}
function g0(e, t) {
  let n;
  return r;
  function r(i) {
    return yn(i) ? (e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), n = !0, r) : gr(i) ? Ur(
      e,
      r,
      n ? "linePrefix" : "lineSuffix"
    )(i) : t(i);
  }
}
const UXe = {
  name: "definition",
  tokenize: HXe
}, WXe = {
  tokenize: qXe,
  partial: !0
};
function HXe(e, t, n) {
  const r = this;
  let i;
  return o;
  function o(m) {
    return e.enter("definition"), s(m);
  }
  function s(m) {
    return Hq.call(
      r,
      e,
      a,
      // Note: we don’t need to reset the way `markdown-rs` does.
      n,
      "definitionLabel",
      "definitionLabelMarker",
      "definitionLabelString"
    )(m);
  }
  function a(m) {
    return i = Qh(r.sliceSerialize(r.events[r.events.length - 1][1]).slice(1, -1)), m === 58 ? (e.enter("definitionMarker"), e.consume(m), e.exit("definitionMarker"), u) : n(m);
  }
  function u(m) {
    return Os(m) ? g0(e, c)(m) : c(m);
  }
  function c(m) {
    return Wq(
      e,
      d,
      // Note: we don’t need to reset the way `markdown-rs` does.
      n,
      "definitionDestination",
      "definitionDestinationLiteral",
      "definitionDestinationLiteralMarker",
      "definitionDestinationRaw",
      "definitionDestinationString"
    )(m);
  }
  function d(m) {
    return e.attempt(WXe, f, f)(m);
  }
  function f(m) {
    return gr(m) ? Ur(e, h, "whitespace")(m) : h(m);
  }
  function h(m) {
    return m === null || yn(m) ? (e.exit("definition"), r.parser.defined.push(i), t(m)) : n(m);
  }
}
function qXe(e, t, n) {
  return r;
  function r(a) {
    return Os(a) ? g0(e, i)(a) : n(a);
  }
  function i(a) {
    return qq(e, o, n, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(a);
  }
  function o(a) {
    return gr(a) ? Ur(e, s, "whitespace")(a) : s(a);
  }
  function s(a) {
    return a === null || yn(a) ? t(a) : n(a);
  }
}
const GXe = {
  name: "hardBreakEscape",
  tokenize: YXe
};
function YXe(e, t, n) {
  return r;
  function r(o) {
    return e.enter("hardBreakEscape"), e.consume(o), i;
  }
  function i(o) {
    return yn(o) ? (e.exit("hardBreakEscape"), t(o)) : n(o);
  }
}
const KXe = {
  name: "headingAtx",
  tokenize: XXe,
  resolve: JXe
};
function JXe(e, t) {
  let n = e.length - 2, r = 3, i, o;
  return e[r][1].type === "whitespace" && (r += 2), n - 2 > r && e[n][1].type === "whitespace" && (n -= 2), e[n][1].type === "atxHeadingSequence" && (r === n - 1 || n - 4 > r && e[n - 2][1].type === "whitespace") && (n -= r + 1 === n ? 2 : 4), n > r && (i = {
    type: "atxHeadingText",
    start: e[r][1].start,
    end: e[n][1].end
  }, o = {
    type: "chunkText",
    start: e[r][1].start,
    end: e[n][1].end,
    contentType: "text"
  }, lc(e, r, n - r + 1, [["enter", i, t], ["enter", o, t], ["exit", o, t], ["exit", i, t]])), e;
}
function XXe(e, t, n) {
  let r = 0;
  return i;
  function i(d) {
    return e.enter("atxHeading"), o(d);
  }
  function o(d) {
    return e.enter("atxHeadingSequence"), s(d);
  }
  function s(d) {
    return d === 35 && r++ < 6 ? (e.consume(d), s) : d === null || Os(d) ? (e.exit("atxHeadingSequence"), a(d)) : n(d);
  }
  function a(d) {
    return d === 35 ? (e.enter("atxHeadingSequence"), u(d)) : d === null || yn(d) ? (e.exit("atxHeading"), t(d)) : gr(d) ? Ur(e, a, "whitespace")(d) : (e.enter("atxHeadingText"), c(d));
  }
  function u(d) {
    return d === 35 ? (e.consume(d), u) : (e.exit("atxHeadingSequence"), a(d));
  }
  function c(d) {
    return d === null || d === 35 || Os(d) ? (e.exit("atxHeadingText"), a(d)) : (e.consume(d), c);
  }
}
const QXe = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], qj = ["pre", "script", "style", "textarea"], ZXe = {
  name: "htmlFlow",
  tokenize: rQe,
  resolveTo: nQe,
  concrete: !0
}, eQe = {
  tokenize: oQe,
  partial: !0
}, tQe = {
  tokenize: iQe,
  partial: !0
};
function nQe(e) {
  let t = e.length;
  for (; t-- && !(e[t][0] === "enter" && e[t][1].type === "htmlFlow"); )
    ;
  return t > 1 && e[t - 2][1].type === "linePrefix" && (e[t][1].start = e[t - 2][1].start, e[t + 1][1].start = e[t - 2][1].start, e.splice(t - 2, 2)), e;
}
function rQe(e, t, n) {
  const r = this;
  let i, o, s, a, u;
  return c;
  function c(R) {
    return d(R);
  }
  function d(R) {
    return e.enter("htmlFlow"), e.enter("htmlFlowData"), e.consume(R), f;
  }
  function f(R) {
    return R === 33 ? (e.consume(R), h) : R === 47 ? (e.consume(R), o = !0, x) : R === 63 ? (e.consume(R), i = 3, r.interrupt ? t : M) : Jl(R) ? (e.consume(R), s = String.fromCharCode(R), C) : n(R);
  }
  function h(R) {
    return R === 45 ? (e.consume(R), i = 2, m) : R === 91 ? (e.consume(R), i = 5, a = 0, v) : Jl(R) ? (e.consume(R), i = 4, r.interrupt ? t : M) : n(R);
  }
  function m(R) {
    return R === 45 ? (e.consume(R), r.interrupt ? t : M) : n(R);
  }
  function v(R) {
    const _ = "CDATA[";
    return R === _.charCodeAt(a++) ? (e.consume(R), a === _.length ? r.interrupt ? t : J : v) : n(R);
  }
  function x(R) {
    return Jl(R) ? (e.consume(R), s = String.fromCharCode(R), C) : n(R);
  }
  function C(R) {
    if (R === null || R === 47 || R === 62 || Os(R)) {
      const _ = R === 47, W = s.toLowerCase();
      return !_ && !o && qj.includes(W) ? (i = 1, r.interrupt ? t(R) : J(R)) : QXe.includes(s.toLowerCase()) ? (i = 6, _ ? (e.consume(R), E) : r.interrupt ? t(R) : J(R)) : (i = 7, r.interrupt && !r.parser.lazy[r.now().line] ? n(R) : o ? S(R) : w(R));
    }
    return R === 45 || ea(R) ? (e.consume(R), s += String.fromCharCode(R), C) : n(R);
  }
  function E(R) {
    return R === 62 ? (e.consume(R), r.interrupt ? t : J) : n(R);
  }
  function S(R) {
    return gr(R) ? (e.consume(R), S) : H(R);
  }
  function w(R) {
    return R === 47 ? (e.consume(R), H) : R === 58 || R === 95 || Jl(R) ? (e.consume(R), O) : gr(R) ? (e.consume(R), w) : H(R);
  }
  function O(R) {
    return R === 45 || R === 46 || R === 58 || R === 95 || ea(R) ? (e.consume(R), O) : A(R);
  }
  function A(R) {
    return R === 61 ? (e.consume(R), I) : gr(R) ? (e.consume(R), A) : w(R);
  }
  function I(R) {
    return R === null || R === 60 || R === 61 || R === 62 || R === 96 ? n(R) : R === 34 || R === 39 ? (e.consume(R), u = R, $) : gr(R) ? (e.consume(R), I) : L(R);
  }
  function $(R) {
    return R === u ? (e.consume(R), u = null, B) : R === null || yn(R) ? n(R) : (e.consume(R), $);
  }
  function L(R) {
    return R === null || R === 34 || R === 39 || R === 47 || R === 60 || R === 61 || R === 62 || R === 96 || Os(R) ? A(R) : (e.consume(R), L);
  }
  function B(R) {
    return R === 47 || R === 62 || gr(R) ? w(R) : n(R);
  }
  function H(R) {
    return R === 62 ? (e.consume(R), q) : n(R);
  }
  function q(R) {
    return R === null || yn(R) ? J(R) : gr(R) ? (e.consume(R), q) : n(R);
  }
  function J(R) {
    return R === 45 && i === 2 ? (e.consume(R), G) : R === 60 && i === 1 ? (e.consume(R), K) : R === 62 && i === 4 ? (e.consume(R), Z) : R === 63 && i === 3 ? (e.consume(R), M) : R === 93 && i === 5 ? (e.consume(R), te) : yn(R) && (i === 6 || i === 7) ? (e.exit("htmlFlowData"), e.check(eQe, ne, X)(R)) : R === null || yn(R) ? (e.exit("htmlFlowData"), X(R)) : (e.consume(R), J);
  }
  function X(R) {
    return e.check(tQe, j, ne)(R);
  }
  function j(R) {
    return e.enter("lineEnding"), e.consume(R), e.exit("lineEnding"), U;
  }
  function U(R) {
    return R === null || yn(R) ? X(R) : (e.enter("htmlFlowData"), J(R));
  }
  function G(R) {
    return R === 45 ? (e.consume(R), M) : J(R);
  }
  function K(R) {
    return R === 47 ? (e.consume(R), s = "", ee) : J(R);
  }
  function ee(R) {
    if (R === 62) {
      const _ = s.toLowerCase();
      return qj.includes(_) ? (e.consume(R), Z) : J(R);
    }
    return Jl(R) && s.length < 8 ? (e.consume(R), s += String.fromCharCode(R), ee) : J(R);
  }
  function te(R) {
    return R === 93 ? (e.consume(R), M) : J(R);
  }
  function M(R) {
    return R === 62 ? (e.consume(R), Z) : R === 45 && i === 2 ? (e.consume(R), M) : J(R);
  }
  function Z(R) {
    return R === null || yn(R) ? (e.exit("htmlFlowData"), ne(R)) : (e.consume(R), Z);
  }
  function ne(R) {
    return e.exit("htmlFlow"), t(R);
  }
}
function iQe(e, t, n) {
  const r = this;
  return i;
  function i(s) {
    return yn(s) ? (e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), o) : n(s);
  }
  function o(s) {
    return r.parser.lazy[r.now().line] ? n(s) : t(s);
  }
}
function oQe(e, t, n) {
  return r;
  function r(i) {
    return e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), e.attempt(nT, t, n);
  }
}
const sQe = {
  name: "htmlText",
  tokenize: aQe
};
function aQe(e, t, n) {
  const r = this;
  let i, o, s;
  return a;
  function a(M) {
    return e.enter("htmlText"), e.enter("htmlTextData"), e.consume(M), u;
  }
  function u(M) {
    return M === 33 ? (e.consume(M), c) : M === 47 ? (e.consume(M), A) : M === 63 ? (e.consume(M), w) : Jl(M) ? (e.consume(M), L) : n(M);
  }
  function c(M) {
    return M === 45 ? (e.consume(M), d) : M === 91 ? (e.consume(M), o = 0, v) : Jl(M) ? (e.consume(M), S) : n(M);
  }
  function d(M) {
    return M === 45 ? (e.consume(M), m) : n(M);
  }
  function f(M) {
    return M === null ? n(M) : M === 45 ? (e.consume(M), h) : yn(M) ? (s = f, K(M)) : (e.consume(M), f);
  }
  function h(M) {
    return M === 45 ? (e.consume(M), m) : f(M);
  }
  function m(M) {
    return M === 62 ? G(M) : M === 45 ? h(M) : f(M);
  }
  function v(M) {
    const Z = "CDATA[";
    return M === Z.charCodeAt(o++) ? (e.consume(M), o === Z.length ? x : v) : n(M);
  }
  function x(M) {
    return M === null ? n(M) : M === 93 ? (e.consume(M), C) : yn(M) ? (s = x, K(M)) : (e.consume(M), x);
  }
  function C(M) {
    return M === 93 ? (e.consume(M), E) : x(M);
  }
  function E(M) {
    return M === 62 ? G(M) : M === 93 ? (e.consume(M), E) : x(M);
  }
  function S(M) {
    return M === null || M === 62 ? G(M) : yn(M) ? (s = S, K(M)) : (e.consume(M), S);
  }
  function w(M) {
    return M === null ? n(M) : M === 63 ? (e.consume(M), O) : yn(M) ? (s = w, K(M)) : (e.consume(M), w);
  }
  function O(M) {
    return M === 62 ? G(M) : w(M);
  }
  function A(M) {
    return Jl(M) ? (e.consume(M), I) : n(M);
  }
  function I(M) {
    return M === 45 || ea(M) ? (e.consume(M), I) : $(M);
  }
  function $(M) {
    return yn(M) ? (s = $, K(M)) : gr(M) ? (e.consume(M), $) : G(M);
  }
  function L(M) {
    return M === 45 || ea(M) ? (e.consume(M), L) : M === 47 || M === 62 || Os(M) ? B(M) : n(M);
  }
  function B(M) {
    return M === 47 ? (e.consume(M), G) : M === 58 || M === 95 || Jl(M) ? (e.consume(M), H) : yn(M) ? (s = B, K(M)) : gr(M) ? (e.consume(M), B) : G(M);
  }
  function H(M) {
    return M === 45 || M === 46 || M === 58 || M === 95 || ea(M) ? (e.consume(M), H) : q(M);
  }
  function q(M) {
    return M === 61 ? (e.consume(M), J) : yn(M) ? (s = q, K(M)) : gr(M) ? (e.consume(M), q) : B(M);
  }
  function J(M) {
    return M === null || M === 60 || M === 61 || M === 62 || M === 96 ? n(M) : M === 34 || M === 39 ? (e.consume(M), i = M, X) : yn(M) ? (s = J, K(M)) : gr(M) ? (e.consume(M), J) : (e.consume(M), j);
  }
  function X(M) {
    return M === i ? (e.consume(M), i = void 0, U) : M === null ? n(M) : yn(M) ? (s = X, K(M)) : (e.consume(M), X);
  }
  function j(M) {
    return M === null || M === 34 || M === 39 || M === 60 || M === 61 || M === 96 ? n(M) : M === 47 || M === 62 || Os(M) ? B(M) : (e.consume(M), j);
  }
  function U(M) {
    return M === 47 || M === 62 || Os(M) ? B(M) : n(M);
  }
  function G(M) {
    return M === 62 ? (e.consume(M), e.exit("htmlTextData"), e.exit("htmlText"), t) : n(M);
  }
  function K(M) {
    return e.exit("htmlTextData"), e.enter("lineEnding"), e.consume(M), e.exit("lineEnding"), ee;
  }
  function ee(M) {
    return gr(M) ? Ur(e, te, "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(M) : te(M);
  }
  function te(M) {
    return e.enter("htmlTextData"), s(M);
  }
}
const S$ = {
  name: "labelEnd",
  tokenize: fQe,
  resolveTo: pQe,
  resolveAll: dQe
}, lQe = {
  tokenize: hQe
}, uQe = {
  tokenize: mQe
}, cQe = {
  tokenize: gQe
};
function dQe(e) {
  let t = -1;
  for (; ++t < e.length; ) {
    const n = e[t][1];
    (n.type === "labelImage" || n.type === "labelLink" || n.type === "labelEnd") && (e.splice(t + 1, n.type === "labelImage" ? 4 : 2), n.type = "data", t++);
  }
  return e;
}
function pQe(e, t) {
  let n = e.length, r = 0, i, o, s, a;
  for (; n--; )
    if (i = e[n][1], o) {
      if (i.type === "link" || i.type === "labelLink" && i._inactive)
        break;
      e[n][0] === "enter" && i.type === "labelLink" && (i._inactive = !0);
    } else if (s) {
      if (e[n][0] === "enter" && (i.type === "labelImage" || i.type === "labelLink") && !i._balanced && (o = n, i.type !== "labelLink")) {
        r = 2;
        break;
      }
    } else i.type === "labelEnd" && (s = n);
  const u = {
    type: e[o][1].type === "labelLink" ? "link" : "image",
    start: Object.assign({}, e[o][1].start),
    end: Object.assign({}, e[e.length - 1][1].end)
  }, c = {
    type: "label",
    start: Object.assign({}, e[o][1].start),
    end: Object.assign({}, e[s][1].end)
  }, d = {
    type: "labelText",
    start: Object.assign({}, e[o + r + 2][1].end),
    end: Object.assign({}, e[s - 2][1].start)
  };
  return a = [["enter", u, t], ["enter", c, t]], a = Pa(a, e.slice(o + 1, o + r + 3)), a = Pa(a, [["enter", d, t]]), a = Pa(a, T$(t.parser.constructs.insideSpan.null, e.slice(o + r + 4, s - 3), t)), a = Pa(a, [["exit", d, t], e[s - 2], e[s - 1], ["exit", c, t]]), a = Pa(a, e.slice(s + 1)), a = Pa(a, [["exit", u, t]]), lc(e, o, e.length, a), e;
}
function fQe(e, t, n) {
  const r = this;
  let i = r.events.length, o, s;
  for (; i--; )
    if ((r.events[i][1].type === "labelImage" || r.events[i][1].type === "labelLink") && !r.events[i][1]._balanced) {
      o = r.events[i][1];
      break;
    }
  return a;
  function a(h) {
    return o ? o._inactive ? f(h) : (s = r.parser.defined.includes(Qh(r.sliceSerialize({
      start: o.end,
      end: r.now()
    }))), e.enter("labelEnd"), e.enter("labelMarker"), e.consume(h), e.exit("labelMarker"), e.exit("labelEnd"), u) : n(h);
  }
  function u(h) {
    return h === 40 ? e.attempt(lQe, d, s ? d : f)(h) : h === 91 ? e.attempt(uQe, d, s ? c : f)(h) : s ? d(h) : f(h);
  }
  function c(h) {
    return e.attempt(cQe, d, f)(h);
  }
  function d(h) {
    return t(h);
  }
  function f(h) {
    return o._balanced = !0, n(h);
  }
}
function hQe(e, t, n) {
  return r;
  function r(f) {
    return e.enter("resource"), e.enter("resourceMarker"), e.consume(f), e.exit("resourceMarker"), i;
  }
  function i(f) {
    return Os(f) ? g0(e, o)(f) : o(f);
  }
  function o(f) {
    return f === 41 ? d(f) : Wq(e, s, a, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(f);
  }
  function s(f) {
    return Os(f) ? g0(e, u)(f) : d(f);
  }
  function a(f) {
    return n(f);
  }
  function u(f) {
    return f === 34 || f === 39 || f === 40 ? qq(e, c, n, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(f) : d(f);
  }
  function c(f) {
    return Os(f) ? g0(e, d)(f) : d(f);
  }
  function d(f) {
    return f === 41 ? (e.enter("resourceMarker"), e.consume(f), e.exit("resourceMarker"), e.exit("resource"), t) : n(f);
  }
}
function mQe(e, t, n) {
  const r = this;
  return i;
  function i(a) {
    return Hq.call(r, e, o, s, "reference", "referenceMarker", "referenceString")(a);
  }
  function o(a) {
    return r.parser.defined.includes(Qh(r.sliceSerialize(r.events[r.events.length - 1][1]).slice(1, -1))) ? t(a) : n(a);
  }
  function s(a) {
    return n(a);
  }
}
function gQe(e, t, n) {
  return r;
  function r(o) {
    return e.enter("reference"), e.enter("referenceMarker"), e.consume(o), e.exit("referenceMarker"), i;
  }
  function i(o) {
    return o === 93 ? (e.enter("referenceMarker"), e.consume(o), e.exit("referenceMarker"), e.exit("reference"), t) : n(o);
  }
}
const yQe = {
  name: "labelStartImage",
  tokenize: bQe,
  resolveAll: S$.resolveAll
};
function bQe(e, t, n) {
  const r = this;
  return i;
  function i(a) {
    return e.enter("labelImage"), e.enter("labelImageMarker"), e.consume(a), e.exit("labelImageMarker"), o;
  }
  function o(a) {
    return a === 91 ? (e.enter("labelMarker"), e.consume(a), e.exit("labelMarker"), e.exit("labelImage"), s) : n(a);
  }
  function s(a) {
    return a === 94 && "_hiddenFootnoteSupport" in r.parser.constructs ? n(a) : t(a);
  }
}
const vQe = {
  name: "labelStartLink",
  tokenize: xQe,
  resolveAll: S$.resolveAll
};
function xQe(e, t, n) {
  const r = this;
  return i;
  function i(s) {
    return e.enter("labelLink"), e.enter("labelMarker"), e.consume(s), e.exit("labelMarker"), e.exit("labelLink"), o;
  }
  function o(s) {
    return s === 94 && "_hiddenFootnoteSupport" in r.parser.constructs ? n(s) : t(s);
  }
}
const dw = {
  name: "lineEnding",
  tokenize: DQe
};
function DQe(e, t) {
  return n;
  function n(r) {
    return e.enter("lineEnding"), e.consume(r), e.exit("lineEnding"), Ur(e, t, "linePrefix");
  }
}
const tD = {
  name: "thematicBreak",
  tokenize: CQe
};
function CQe(e, t, n) {
  let r = 0, i;
  return o;
  function o(c) {
    return e.enter("thematicBreak"), s(c);
  }
  function s(c) {
    return i = c, a(c);
  }
  function a(c) {
    return c === i ? (e.enter("thematicBreakSequence"), u(c)) : r >= 3 && (c === null || yn(c)) ? (e.exit("thematicBreak"), t(c)) : n(c);
  }
  function u(c) {
    return c === i ? (e.consume(c), r++, u) : (e.exit("thematicBreakSequence"), gr(c) ? Ur(e, a, "whitespace")(c) : a(c));
  }
}
const gs = {
  name: "list",
  tokenize: SQe,
  continuation: {
    tokenize: AQe
  },
  exit: PQe
}, EQe = {
  tokenize: kQe,
  partial: !0
}, TQe = {
  tokenize: wQe,
  partial: !0
};
function SQe(e, t, n) {
  const r = this, i = r.events[r.events.length - 1];
  let o = i && i[1].type === "linePrefix" ? i[2].sliceSerialize(i[1], !0).length : 0, s = 0;
  return a;
  function a(m) {
    const v = r.containerState.type || (m === 42 || m === 43 || m === 45 ? "listUnordered" : "listOrdered");
    if (v === "listUnordered" ? !r.containerState.marker || m === r.containerState.marker : lk(m)) {
      if (r.containerState.type || (r.containerState.type = v, e.enter(v, {
        _container: !0
      })), v === "listUnordered")
        return e.enter("listItemPrefix"), m === 42 || m === 45 ? e.check(tD, n, c)(m) : c(m);
      if (!r.interrupt || m === 49)
        return e.enter("listItemPrefix"), e.enter("listItemValue"), u(m);
    }
    return n(m);
  }
  function u(m) {
    return lk(m) && ++s < 10 ? (e.consume(m), u) : (!r.interrupt || s < 2) && (r.containerState.marker ? m === r.containerState.marker : m === 41 || m === 46) ? (e.exit("listItemValue"), c(m)) : n(m);
  }
  function c(m) {
    return e.enter("listItemMarker"), e.consume(m), e.exit("listItemMarker"), r.containerState.marker = r.containerState.marker || m, e.check(
      nT,
      // Can’t be empty when interrupting.
      r.interrupt ? n : d,
      e.attempt(EQe, h, f)
    );
  }
  function d(m) {
    return r.containerState.initialBlankLine = !0, o++, h(m);
  }
  function f(m) {
    return gr(m) ? (e.enter("listItemPrefixWhitespace"), e.consume(m), e.exit("listItemPrefixWhitespace"), h) : n(m);
  }
  function h(m) {
    return r.containerState.size = o + r.sliceSerialize(e.exit("listItemPrefix"), !0).length, t(m);
  }
}
function AQe(e, t, n) {
  const r = this;
  return r.containerState._closeFlow = void 0, e.check(nT, i, o);
  function i(a) {
    return r.containerState.furtherBlankLines = r.containerState.furtherBlankLines || r.containerState.initialBlankLine, Ur(e, t, "listItemIndent", r.containerState.size + 1)(a);
  }
  function o(a) {
    return r.containerState.furtherBlankLines || !gr(a) ? (r.containerState.furtherBlankLines = void 0, r.containerState.initialBlankLine = void 0, s(a)) : (r.containerState.furtherBlankLines = void 0, r.containerState.initialBlankLine = void 0, e.attempt(TQe, t, s)(a));
  }
  function s(a) {
    return r.containerState._closeFlow = !0, r.interrupt = void 0, Ur(e, e.attempt(gs, t, n), "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(a);
  }
}
function wQe(e, t, n) {
  const r = this;
  return Ur(e, i, "listItemIndent", r.containerState.size + 1);
  function i(o) {
    const s = r.events[r.events.length - 1];
    return s && s[1].type === "listItemIndent" && s[2].sliceSerialize(s[1], !0).length === r.containerState.size ? t(o) : n(o);
  }
}
function PQe(e) {
  e.exit(this.containerState.type);
}
function kQe(e, t, n) {
  const r = this;
  return Ur(e, i, "listItemPrefixWhitespace", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 5);
  function i(o) {
    const s = r.events[r.events.length - 1];
    return !gr(o) && s && s[1].type === "listItemPrefixWhitespace" ? t(o) : n(o);
  }
}
const Gj = {
  name: "setextUnderline",
  tokenize: IQe,
  resolveTo: OQe
};
function OQe(e, t) {
  let n = e.length, r, i, o;
  for (; n--; )
    if (e[n][0] === "enter") {
      if (e[n][1].type === "content") {
        r = n;
        break;
      }
      e[n][1].type === "paragraph" && (i = n);
    } else
      e[n][1].type === "content" && e.splice(n, 1), !o && e[n][1].type === "definition" && (o = n);
  const s = {
    type: "setextHeading",
    start: Object.assign({}, e[i][1].start),
    end: Object.assign({}, e[e.length - 1][1].end)
  };
  return e[i][1].type = "setextHeadingText", o ? (e.splice(i, 0, ["enter", s, t]), e.splice(o + 1, 0, ["exit", e[r][1], t]), e[r][1].end = Object.assign({}, e[o][1].end)) : e[r][1] = s, e.push(["exit", s, t]), e;
}
function IQe(e, t, n) {
  const r = this;
  let i;
  return o;
  function o(c) {
    let d = r.events.length, f;
    for (; d--; )
      if (r.events[d][1].type !== "lineEnding" && r.events[d][1].type !== "linePrefix" && r.events[d][1].type !== "content") {
        f = r.events[d][1].type === "paragraph";
        break;
      }
    return !r.parser.lazy[r.now().line] && (r.interrupt || f) ? (e.enter("setextHeadingLine"), i = c, s(c)) : n(c);
  }
  function s(c) {
    return e.enter("setextHeadingLineSequence"), a(c);
  }
  function a(c) {
    return c === i ? (e.consume(c), a) : (e.exit("setextHeadingLineSequence"), gr(c) ? Ur(e, u, "lineSuffix")(c) : u(c));
  }
  function u(c) {
    return c === null || yn(c) ? (e.exit("setextHeadingLine"), t(c)) : n(c);
  }
}
const FQe = {
  tokenize: $Qe
};
function $Qe(e) {
  const t = this, n = e.attempt(
    // Try to parse a blank line.
    nT,
    r,
    // Try to parse initial flow (essentially, only code).
    e.attempt(
      this.parser.constructs.flowInitial,
      i,
      Ur(
        e,
        e.attempt(
          this.parser.constructs.flow,
          i,
          e.attempt(LXe, i)
        ),
        "linePrefix"
      )
    )
  );
  return n;
  function r(o) {
    if (o === null) {
      e.consume(o);
      return;
    }
    return e.enter("lineEndingBlank"), e.consume(o), e.exit("lineEndingBlank"), t.currentConstruct = void 0, n;
  }
  function i(o) {
    if (o === null) {
      e.consume(o);
      return;
    }
    return e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), t.currentConstruct = void 0, n;
  }
}
const NQe = {
  resolveAll: Yq()
}, MQe = Gq("string"), RQe = Gq("text");
function Gq(e) {
  return {
    tokenize: t,
    resolveAll: Yq(
      e === "text" ? _Qe : void 0
    )
  };
  function t(n) {
    const r = this, i = this.parser.constructs[e], o = n.attempt(i, s, a);
    return s;
    function s(d) {
      return c(d) ? o(d) : a(d);
    }
    function a(d) {
      if (d === null) {
        n.consume(d);
        return;
      }
      return n.enter("data"), n.consume(d), u;
    }
    function u(d) {
      return c(d) ? (n.exit("data"), o(d)) : (n.consume(d), u);
    }
    function c(d) {
      if (d === null)
        return !0;
      const f = i[d];
      let h = -1;
      if (f)
        for (; ++h < f.length; ) {
          const m = f[h];
          if (!m.previous || m.previous.call(r, r.previous))
            return !0;
        }
      return !1;
    }
  }
}
function Yq(e) {
  return t;
  function t(n, r) {
    let i = -1, o;
    for (; ++i <= n.length; )
      o === void 0 ? n[i] && n[i][1].type === "data" && (o = i, i++) : (!n[i] || n[i][1].type !== "data") && (i !== o + 2 && (n[o][1].end = n[i - 1][1].end, n.splice(o + 2, i - o - 2), i = o + 2), o = void 0);
    return e ? e(n, r) : n;
  }
}
function _Qe(e, t) {
  let n = 0;
  for (; ++n <= e.length; )
    if ((n === e.length || e[n][1].type === "lineEnding") && e[n - 1][1].type === "data") {
      const r = e[n - 1][1], i = t.sliceStream(r);
      let o = i.length, s = -1, a = 0, u;
      for (; o--; ) {
        const c = i[o];
        if (typeof c == "string") {
          for (s = c.length; c.charCodeAt(s - 1) === 32; )
            a++, s--;
          if (s) break;
          s = -1;
        } else if (c === -2)
          u = !0, a++;
        else if (c !== -1) {
          o++;
          break;
        }
      }
      if (a) {
        const c = {
          type: n === e.length || u || a < 2 ? "lineSuffix" : "hardBreakTrailing",
          start: {
            line: r.end.line,
            column: r.end.column - a,
            offset: r.end.offset - a,
            _index: r.start._index + o,
            _bufferIndex: o ? s : r.start._bufferIndex + s
          },
          end: Object.assign({}, r.end)
        };
        r.end = Object.assign({}, c.start), r.start.offset === r.end.offset ? Object.assign(r, c) : (e.splice(
          n,
          0,
          ["enter", c, t],
          ["exit", c, t]
        ), n += 2);
      }
      n++;
    }
  return e;
}
function LQe(e, t, n) {
  let r = Object.assign(
    n ? Object.assign({}, n) : {
      line: 1,
      column: 1,
      offset: 0
    },
    {
      _index: 0,
      _bufferIndex: -1
    }
  );
  const i = {}, o = [];
  let s = [], a = [];
  const u = {
    consume: S,
    enter: w,
    exit: O,
    attempt: $(A),
    check: $(I),
    interrupt: $(I, {
      interrupt: !0
    })
  }, c = {
    previous: null,
    code: null,
    containerState: {},
    events: [],
    parser: e,
    sliceStream: m,
    sliceSerialize: h,
    now: v,
    defineSkip: x,
    write: f
  };
  let d = t.tokenize.call(c, u);
  return t.resolveAll && o.push(t), c;
  function f(q) {
    return s = Pa(s, q), C(), s[s.length - 1] !== null ? [] : (L(t, 0), c.events = T$(o, c.events, c), c.events);
  }
  function h(q, J) {
    return jQe(m(q), J);
  }
  function m(q) {
    return BQe(s, q);
  }
  function v() {
    const { line: q, column: J, offset: X, _index: j, _bufferIndex: U } = r;
    return {
      line: q,
      column: J,
      offset: X,
      _index: j,
      _bufferIndex: U
    };
  }
  function x(q) {
    i[q.line] = q.column, H();
  }
  function C() {
    let q;
    for (; r._index < s.length; ) {
      const J = s[r._index];
      if (typeof J == "string")
        for (q = r._index, r._bufferIndex < 0 && (r._bufferIndex = 0); r._index === q && r._bufferIndex < J.length; )
          E(J.charCodeAt(r._bufferIndex));
      else
        E(J);
    }
  }
  function E(q) {
    d = d(q);
  }
  function S(q) {
    yn(q) ? (r.line++, r.column = 1, r.offset += q === -3 ? 2 : 1, H()) : q !== -1 && (r.column++, r.offset++), r._bufferIndex < 0 ? r._index++ : (r._bufferIndex++, r._bufferIndex === s[r._index].length && (r._bufferIndex = -1, r._index++)), c.previous = q;
  }
  function w(q, J) {
    const X = J || {};
    return X.type = q, X.start = v(), c.events.push(["enter", X, c]), a.push(X), X;
  }
  function O(q) {
    const J = a.pop();
    return J.end = v(), c.events.push(["exit", J, c]), J;
  }
  function A(q, J) {
    L(q, J.from);
  }
  function I(q, J) {
    J.restore();
  }
  function $(q, J) {
    return X;
    function X(j, U, G) {
      let K, ee, te, M;
      return Array.isArray(j) ? ne(j) : "tokenize" in j ? (
        // @ts-expect-error Looks like a construct.
        ne([j])
      ) : Z(j);
      function Z(Q) {
        return oe;
        function oe(ae) {
          const pe = ae !== null && Q[ae], me = ae !== null && Q.null, xe = [
            // To do: add more extension tests.
            /* c8 ignore next 2 */
            ...Array.isArray(pe) ? pe : pe ? [pe] : [],
            ...Array.isArray(me) ? me : me ? [me] : []
          ];
          return ne(xe)(ae);
        }
      }
      function ne(Q) {
        return K = Q, ee = 0, Q.length === 0 ? G : R(Q[ee]);
      }
      function R(Q) {
        return oe;
        function oe(ae) {
          return M = B(), te = Q, Q.partial || (c.currentConstruct = Q), Q.name && c.parser.constructs.disable.null.includes(Q.name) ? W() : Q.tokenize.call(
            // If we do have fields, create an object w/ `context` as its
            // prototype.
            // This allows a “live binding”, which is needed for `interrupt`.
            J ? Object.assign(Object.create(c), J) : c,
            u,
            _,
            W
          )(ae);
        }
      }
      function _(Q) {
        return q(te, M), U;
      }
      function W(Q) {
        return M.restore(), ++ee < K.length ? R(K[ee]) : G;
      }
    }
  }
  function L(q, J) {
    q.resolveAll && !o.includes(q) && o.push(q), q.resolve && lc(
      c.events,
      J,
      c.events.length - J,
      q.resolve(c.events.slice(J), c)
    ), q.resolveTo && (c.events = q.resolveTo(c.events, c));
  }
  function B() {
    const q = v(), J = c.previous, X = c.currentConstruct, j = c.events.length, U = Array.from(a);
    return {
      restore: G,
      from: j
    };
    function G() {
      r = q, c.previous = J, c.currentConstruct = X, c.events.length = j, a = U, H();
    }
  }
  function H() {
    r.line in i && r.column < 2 && (r.column = i[r.line], r.offset += i[r.line] - 1);
  }
}
function BQe(e, t) {
  const n = t.start._index, r = t.start._bufferIndex, i = t.end._index, o = t.end._bufferIndex;
  let s;
  if (n === i)
    s = [e[n].slice(r, o)];
  else {
    if (s = e.slice(n, i), r > -1) {
      const a = s[0];
      typeof a == "string" ? s[0] = a.slice(r) : s.shift();
    }
    o > 0 && s.push(e[i].slice(0, o));
  }
  return s;
}
function jQe(e, t) {
  let n = -1;
  const r = [];
  let i;
  for (; ++n < e.length; ) {
    const o = e[n];
    let s;
    if (typeof o == "string")
      s = o;
    else
      switch (o) {
        case -5: {
          s = "\r";
          break;
        }
        case -4: {
          s = `
`;
          break;
        }
        case -3: {
          s = `\r
`;
          break;
        }
        case -2: {
          s = t ? " " : "	";
          break;
        }
        case -1: {
          if (!t && i) continue;
          s = " ";
          break;
        }
        default:
          s = String.fromCharCode(o);
      }
    i = o === -2, r.push(s);
  }
  return r.join("");
}
const VQe = {
  42: gs,
  43: gs,
  45: gs,
  48: gs,
  49: gs,
  50: gs,
  51: gs,
  52: gs,
  53: gs,
  54: gs,
  55: gs,
  56: gs,
  57: gs,
  62: jq
}, zQe = {
  91: UXe
}, UQe = {
  [-2]: cw,
  [-1]: cw,
  32: cw
}, WQe = {
  35: KXe,
  42: tD,
  45: [Gj, tD],
  60: ZXe,
  61: Gj,
  95: tD,
  96: Hj,
  126: Hj
}, HQe = {
  38: zq,
  92: Vq
}, qQe = {
  [-5]: dw,
  [-4]: dw,
  [-3]: dw,
  33: yQe,
  38: zq,
  42: uk,
  60: [vXe, sQe],
  91: vQe,
  92: [GXe, Vq],
  93: S$,
  95: uk,
  96: FXe
}, GQe = {
  null: [uk, NQe]
}, YQe = {
  null: [42, 95]
}, KQe = {
  null: []
}, JQe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  attentionMarkers: YQe,
  contentInitial: zQe,
  disable: KQe,
  document: VQe,
  flow: WQe,
  flowInitial: UQe,
  insideSpan: GQe,
  string: HQe,
  text: qQe
}, Symbol.toStringTag, { value: "Module" }));
function XQe(e) {
  const n = (
    /** @type {FullNormalizedExtension} */
    iXe([JQe, ...(e || {}).extensions || []])
  ), r = {
    defined: [],
    lazy: {},
    constructs: n,
    content: i(pXe),
    document: i(hXe),
    flow: i(FQe),
    string: i(MQe),
    text: i(RQe)
  };
  return r;
  function i(o) {
    return s;
    function s(a) {
      return LQe(r, o, a);
    }
  }
}
function QQe(e) {
  for (; !Uq(e); )
    ;
  return e;
}
const Yj = /[\0\t\n\r]/g;
function ZQe() {
  let e = 1, t = "", n = !0, r;
  return i;
  function i(o, s, a) {
    const u = [];
    let c, d, f, h, m;
    for (o = t + (typeof o == "string" ? o.toString() : new TextDecoder(s || void 0).decode(o)), f = 0, t = "", n && (o.charCodeAt(0) === 65279 && f++, n = void 0); f < o.length; ) {
      if (Yj.lastIndex = f, c = Yj.exec(o), h = c && c.index !== void 0 ? c.index : o.length, m = o.charCodeAt(h), !c) {
        t = o.slice(f);
        break;
      }
      if (m === 10 && f === h && r)
        u.push(-3), r = void 0;
      else
        switch (r && (u.push(-5), r = void 0), f < h && (u.push(o.slice(f, h)), e += h - f), m) {
          case 0: {
            u.push(65533), e++;
            break;
          }
          case 9: {
            for (d = Math.ceil(e / 4) * 4, u.push(-2); e++ < d; ) u.push(-1);
            break;
          }
          case 10: {
            u.push(-4), e = 1;
            break;
          }
          default:
            r = !0, e = 1;
        }
      f = h + 1;
    }
    return a && (r && u.push(-5), t && u.push(t), u.push(null)), u;
  }
}
const eZe = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function tZe(e) {
  return e.replace(eZe, nZe);
}
function nZe(e, t, n) {
  if (t)
    return t;
  if (n.charCodeAt(0) === 35) {
    const i = n.charCodeAt(1), o = i === 120 || i === 88;
    return Bq(n.slice(o ? 2 : 1), o ? 16 : 10);
  }
  return E$(n) || e;
}
const Kq = {}.hasOwnProperty;
function rZe(e, t, n) {
  return typeof t != "string" && (n = t, t = void 0), iZe(n)(QQe(XQe(n).document().write(ZQe()(e, t, !0))));
}
function iZe(e) {
  const t = {
    transforms: [],
    canContainEols: ["emphasis", "fragment", "heading", "paragraph", "strong"],
    enter: {
      autolink: o(Qe),
      autolinkProtocol: B,
      autolinkEmail: B,
      atxHeading: o(Re),
      blockQuote: o(me),
      characterEscape: B,
      characterReference: B,
      codeFenced: o(xe),
      codeFencedFenceInfo: s,
      codeFencedFenceMeta: s,
      codeIndented: o(xe, s),
      codeText: o(le, s),
      codeTextData: B,
      data: B,
      codeFlowValue: B,
      definition: o(ye),
      definitionDestinationString: s,
      definitionLabelString: s,
      definitionTitleString: s,
      emphasis: o(be),
      hardBreakEscape: o(Te),
      hardBreakTrailing: o(Te),
      htmlFlow: o(Xe, s),
      htmlFlowData: B,
      htmlText: o(Xe, s),
      htmlTextData: B,
      image: o(Ne),
      label: s,
      link: o(Qe),
      listItem: o(Ie),
      listItemValue: h,
      listOrdered: o(Ee, f),
      listUnordered: o(Ee),
      paragraph: o(Je),
      reference: R,
      referenceString: s,
      resourceDestinationString: s,
      resourceTitleString: s,
      setextHeading: o(Re),
      strong: o(vt),
      thematicBreak: o(Lt)
    },
    exit: {
      atxHeading: u(),
      atxHeadingSequence: A,
      autolink: u(),
      autolinkEmail: pe,
      autolinkProtocol: ae,
      blockQuote: u(),
      characterEscapeValue: H,
      characterReferenceMarkerHexadecimal: W,
      characterReferenceMarkerNumeric: W,
      characterReferenceValue: Q,
      characterReference: oe,
      codeFenced: u(C),
      codeFencedFence: x,
      codeFencedFenceInfo: m,
      codeFencedFenceMeta: v,
      codeFlowValue: H,
      codeIndented: u(E),
      codeText: u(U),
      codeTextData: H,
      data: H,
      definition: u(),
      definitionDestinationString: O,
      definitionLabelString: S,
      definitionTitleString: w,
      emphasis: u(),
      hardBreakEscape: u(J),
      hardBreakTrailing: u(J),
      htmlFlow: u(X),
      htmlFlowData: H,
      htmlText: u(j),
      htmlTextData: H,
      image: u(K),
      label: te,
      labelText: ee,
      lineEnding: q,
      link: u(G),
      listItem: u(),
      listOrdered: u(),
      listUnordered: u(),
      paragraph: u(),
      referenceString: _,
      resourceDestinationString: M,
      resourceTitleString: Z,
      resource: ne,
      setextHeading: u(L),
      setextHeadingLineSequence: $,
      setextHeadingText: I,
      strong: u(),
      thematicBreak: u()
    }
  };
  Jq(t, (e || {}).mdastExtensions || []);
  const n = {};
  return r;
  function r(ke) {
    let Le = {
      type: "root",
      children: []
    };
    const Pe = {
      stack: [Le],
      tokenStack: [],
      config: t,
      enter: a,
      exit: c,
      buffer: s,
      resume: d,
      data: n
    }, Ae = [];
    let We = -1;
    for (; ++We < ke.length; )
      if (ke[We][1].type === "listOrdered" || ke[We][1].type === "listUnordered")
        if (ke[We][0] === "enter")
          Ae.push(We);
        else {
          const At = Ae.pop();
          We = i(ke, At, We);
        }
    for (We = -1; ++We < ke.length; ) {
      const At = t[ke[We][0]];
      Kq.call(At, ke[We][1].type) && At[ke[We][1].type].call(Object.assign({
        sliceSerialize: ke[We][2].sliceSerialize
      }, Pe), ke[We][1]);
    }
    if (Pe.tokenStack.length > 0) {
      const At = Pe.tokenStack[Pe.tokenStack.length - 1];
      (At[1] || Kj).call(Pe, void 0, At[0]);
    }
    for (Le.position = {
      start: qc(ke.length > 0 ? ke[0][1].start : {
        line: 1,
        column: 1,
        offset: 0
      }),
      end: qc(ke.length > 0 ? ke[ke.length - 2][1].end : {
        line: 1,
        column: 1,
        offset: 0
      })
    }, We = -1; ++We < t.transforms.length; )
      Le = t.transforms[We](Le) || Le;
    return Le;
  }
  function i(ke, Le, Pe) {
    let Ae = Le - 1, We = -1, At = !1, Ft, Ct, ht, He;
    for (; ++Ae <= Pe; ) {
      const qe = ke[Ae];
      switch (qe[1].type) {
        case "listUnordered":
        case "listOrdered":
        case "blockQuote": {
          qe[0] === "enter" ? We++ : We--, He = void 0;
          break;
        }
        case "lineEndingBlank": {
          qe[0] === "enter" && (Ft && !He && !We && !ht && (ht = Ae), He = void 0);
          break;
        }
        case "linePrefix":
        case "listItemValue":
        case "listItemMarker":
        case "listItemPrefix":
        case "listItemPrefixWhitespace":
          break;
        default:
          He = void 0;
      }
      if (!We && qe[0] === "enter" && qe[1].type === "listItemPrefix" || We === -1 && qe[0] === "exit" && (qe[1].type === "listUnordered" || qe[1].type === "listOrdered")) {
        if (Ft) {
          let wt = Ae;
          for (Ct = void 0; wt--; ) {
            const Ut = ke[wt];
            if (Ut[1].type === "lineEnding" || Ut[1].type === "lineEndingBlank") {
              if (Ut[0] === "exit") continue;
              Ct && (ke[Ct][1].type = "lineEndingBlank", At = !0), Ut[1].type = "lineEnding", Ct = wt;
            } else if (!(Ut[1].type === "linePrefix" || Ut[1].type === "blockQuotePrefix" || Ut[1].type === "blockQuotePrefixWhitespace" || Ut[1].type === "blockQuoteMarker" || Ut[1].type === "listItemIndent")) break;
          }
          ht && (!Ct || ht < Ct) && (Ft._spread = !0), Ft.end = Object.assign({}, Ct ? ke[Ct][1].start : qe[1].end), ke.splice(Ct || Ae, 0, ["exit", Ft, qe[2]]), Ae++, Pe++;
        }
        if (qe[1].type === "listItemPrefix") {
          const wt = {
            type: "listItem",
            _spread: !1,
            start: Object.assign({}, qe[1].start),
            // @ts-expect-error: we’ll add `end` in a second.
            end: void 0
          };
          Ft = wt, ke.splice(Ae, 0, ["enter", wt, qe[2]]), Ae++, Pe++, ht = void 0, He = !0;
        }
      }
    }
    return ke[Le][1]._spread = At, Pe;
  }
  function o(ke, Le) {
    return Pe;
    function Pe(Ae) {
      a.call(this, ke(Ae), Ae), Le && Le.call(this, Ae);
    }
  }
  function s() {
    this.stack.push({
      type: "fragment",
      children: []
    });
  }
  function a(ke, Le, Pe) {
    this.stack[this.stack.length - 1].children.push(ke), this.stack.push(ke), this.tokenStack.push([Le, Pe]), ke.position = {
      start: qc(Le.start),
      // @ts-expect-error: `end` will be patched later.
      end: void 0
    };
  }
  function u(ke) {
    return Le;
    function Le(Pe) {
      ke && ke.call(this, Pe), c.call(this, Pe);
    }
  }
  function c(ke, Le) {
    const Pe = this.stack.pop(), Ae = this.tokenStack.pop();
    if (Ae)
      Ae[0].type !== ke.type && (Le ? Le.call(this, ke, Ae[0]) : (Ae[1] || Kj).call(this, ke, Ae[0]));
    else throw new Error("Cannot close `" + ke.type + "` (" + m0({
      start: ke.start,
      end: ke.end
    }) + "): it’s not open");
    Pe.position.end = qc(ke.end);
  }
  function d() {
    return nXe(this.stack.pop());
  }
  function f() {
    this.data.expectingFirstListItemValue = !0;
  }
  function h(ke) {
    if (this.data.expectingFirstListItemValue) {
      const Le = this.stack[this.stack.length - 2];
      Le.start = Number.parseInt(this.sliceSerialize(ke), 10), this.data.expectingFirstListItemValue = void 0;
    }
  }
  function m() {
    const ke = this.resume(), Le = this.stack[this.stack.length - 1];
    Le.lang = ke;
  }
  function v() {
    const ke = this.resume(), Le = this.stack[this.stack.length - 1];
    Le.meta = ke;
  }
  function x() {
    this.data.flowCodeInside || (this.buffer(), this.data.flowCodeInside = !0);
  }
  function C() {
    const ke = this.resume(), Le = this.stack[this.stack.length - 1];
    Le.value = ke.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), this.data.flowCodeInside = void 0;
  }
  function E() {
    const ke = this.resume(), Le = this.stack[this.stack.length - 1];
    Le.value = ke.replace(/(\r?\n|\r)$/g, "");
  }
  function S(ke) {
    const Le = this.resume(), Pe = this.stack[this.stack.length - 1];
    Pe.label = Le, Pe.identifier = Qh(this.sliceSerialize(ke)).toLowerCase();
  }
  function w() {
    const ke = this.resume(), Le = this.stack[this.stack.length - 1];
    Le.title = ke;
  }
  function O() {
    const ke = this.resume(), Le = this.stack[this.stack.length - 1];
    Le.url = ke;
  }
  function A(ke) {
    const Le = this.stack[this.stack.length - 1];
    if (!Le.depth) {
      const Pe = this.sliceSerialize(ke).length;
      Le.depth = Pe;
    }
  }
  function I() {
    this.data.setextHeadingSlurpLineEnding = !0;
  }
  function $(ke) {
    const Le = this.stack[this.stack.length - 1];
    Le.depth = this.sliceSerialize(ke).codePointAt(0) === 61 ? 1 : 2;
  }
  function L() {
    this.data.setextHeadingSlurpLineEnding = void 0;
  }
  function B(ke) {
    const Pe = this.stack[this.stack.length - 1].children;
    let Ae = Pe[Pe.length - 1];
    (!Ae || Ae.type !== "text") && (Ae = St(), Ae.position = {
      start: qc(ke.start),
      // @ts-expect-error: we’ll add `end` later.
      end: void 0
    }, Pe.push(Ae)), this.stack.push(Ae);
  }
  function H(ke) {
    const Le = this.stack.pop();
    Le.value += this.sliceSerialize(ke), Le.position.end = qc(ke.end);
  }
  function q(ke) {
    const Le = this.stack[this.stack.length - 1];
    if (this.data.atHardBreak) {
      const Pe = Le.children[Le.children.length - 1];
      Pe.position.end = qc(ke.end), this.data.atHardBreak = void 0;
      return;
    }
    !this.data.setextHeadingSlurpLineEnding && t.canContainEols.includes(Le.type) && (B.call(this, ke), H.call(this, ke));
  }
  function J() {
    this.data.atHardBreak = !0;
  }
  function X() {
    const ke = this.resume(), Le = this.stack[this.stack.length - 1];
    Le.value = ke;
  }
  function j() {
    const ke = this.resume(), Le = this.stack[this.stack.length - 1];
    Le.value = ke;
  }
  function U() {
    const ke = this.resume(), Le = this.stack[this.stack.length - 1];
    Le.value = ke;
  }
  function G() {
    const ke = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const Le = this.data.referenceType || "shortcut";
      ke.type += "Reference", ke.referenceType = Le, delete ke.url, delete ke.title;
    } else
      delete ke.identifier, delete ke.label;
    this.data.referenceType = void 0;
  }
  function K() {
    const ke = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const Le = this.data.referenceType || "shortcut";
      ke.type += "Reference", ke.referenceType = Le, delete ke.url, delete ke.title;
    } else
      delete ke.identifier, delete ke.label;
    this.data.referenceType = void 0;
  }
  function ee(ke) {
    const Le = this.sliceSerialize(ke), Pe = this.stack[this.stack.length - 2];
    Pe.label = tZe(Le), Pe.identifier = Qh(Le).toLowerCase();
  }
  function te() {
    const ke = this.stack[this.stack.length - 1], Le = this.resume(), Pe = this.stack[this.stack.length - 1];
    if (this.data.inReference = !0, Pe.type === "link") {
      const Ae = ke.children;
      Pe.children = Ae;
    } else
      Pe.alt = Le;
  }
  function M() {
    const ke = this.resume(), Le = this.stack[this.stack.length - 1];
    Le.url = ke;
  }
  function Z() {
    const ke = this.resume(), Le = this.stack[this.stack.length - 1];
    Le.title = ke;
  }
  function ne() {
    this.data.inReference = void 0;
  }
  function R() {
    this.data.referenceType = "collapsed";
  }
  function _(ke) {
    const Le = this.resume(), Pe = this.stack[this.stack.length - 1];
    Pe.label = Le, Pe.identifier = Qh(this.sliceSerialize(ke)).toLowerCase(), this.data.referenceType = "full";
  }
  function W(ke) {
    this.data.characterReferenceType = ke.type;
  }
  function Q(ke) {
    const Le = this.sliceSerialize(ke), Pe = this.data.characterReferenceType;
    let Ae;
    Pe ? (Ae = Bq(Le, Pe === "characterReferenceMarkerNumeric" ? 10 : 16), this.data.characterReferenceType = void 0) : Ae = E$(Le);
    const We = this.stack[this.stack.length - 1];
    We.value += Ae;
  }
  function oe(ke) {
    const Le = this.stack.pop();
    Le.position.end = qc(ke.end);
  }
  function ae(ke) {
    H.call(this, ke);
    const Le = this.stack[this.stack.length - 1];
    Le.url = this.sliceSerialize(ke);
  }
  function pe(ke) {
    H.call(this, ke);
    const Le = this.stack[this.stack.length - 1];
    Le.url = "mailto:" + this.sliceSerialize(ke);
  }
  function me() {
    return {
      type: "blockquote",
      children: []
    };
  }
  function xe() {
    return {
      type: "code",
      lang: null,
      meta: null,
      value: ""
    };
  }
  function le() {
    return {
      type: "inlineCode",
      value: ""
    };
  }
  function ye() {
    return {
      type: "definition",
      identifier: "",
      label: null,
      title: null,
      url: ""
    };
  }
  function be() {
    return {
      type: "emphasis",
      children: []
    };
  }
  function Re() {
    return {
      type: "heading",
      // @ts-expect-error `depth` will be set later.
      depth: 0,
      children: []
    };
  }
  function Te() {
    return {
      type: "break"
    };
  }
  function Xe() {
    return {
      type: "html",
      value: ""
    };
  }
  function Ne() {
    return {
      type: "image",
      title: null,
      url: "",
      alt: null
    };
  }
  function Qe() {
    return {
      type: "link",
      title: null,
      url: "",
      children: []
    };
  }
  function Ee(ke) {
    return {
      type: "list",
      ordered: ke.type === "listOrdered",
      start: null,
      spread: ke._spread,
      children: []
    };
  }
  function Ie(ke) {
    return {
      type: "listItem",
      spread: ke._spread,
      checked: null,
      children: []
    };
  }
  function Je() {
    return {
      type: "paragraph",
      children: []
    };
  }
  function vt() {
    return {
      type: "strong",
      children: []
    };
  }
  function St() {
    return {
      type: "text",
      value: ""
    };
  }
  function Lt() {
    return {
      type: "thematicBreak"
    };
  }
}
function qc(e) {
  return {
    line: e.line,
    column: e.column,
    offset: e.offset
  };
}
function Jq(e, t) {
  let n = -1;
  for (; ++n < t.length; ) {
    const r = t[n];
    Array.isArray(r) ? Jq(e, r) : oZe(e, r);
  }
}
function oZe(e, t) {
  let n;
  for (n in t)
    if (Kq.call(t, n))
      switch (n) {
        case "canContainEols": {
          const r = t[n];
          r && e[n].push(...r);
          break;
        }
        case "transforms": {
          const r = t[n];
          r && e[n].push(...r);
          break;
        }
        case "enter":
        case "exit": {
          const r = t[n];
          r && Object.assign(e[n], r);
          break;
        }
      }
}
function Kj(e, t) {
  throw e ? new Error("Cannot close `" + e.type + "` (" + m0({
    start: e.start,
    end: e.end
  }) + "): a different token (`" + t.type + "`, " + m0({
    start: t.start,
    end: t.end
  }) + ") is open") : new Error("Cannot close document, a token (`" + t.type + "`, " + m0({
    start: t.start,
    end: t.end
  }) + ") is still open");
}
function sZe(e) {
  const t = this;
  t.parser = n;
  function n(r) {
    return rZe(r, {
      ...t.data("settings"),
      ...e,
      // Note: these options are not in the readme.
      // The goal is for them to be set by plugins on `data` instead of being
      // passed by users.
      extensions: t.data("micromarkExtensions") || [],
      mdastExtensions: t.data("fromMarkdownExtensions") || []
    });
  }
}
function aZe(e, t) {
  const n = {
    type: "element",
    tagName: "blockquote",
    properties: {},
    children: e.wrap(e.all(t), !0)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function lZe(e, t) {
  const n = { type: "element", tagName: "br", properties: {}, children: [] };
  return e.patch(t, n), [e.applyData(t, n), { type: "text", value: `
` }];
}
function uZe(e, t) {
  const n = t.value ? t.value + `
` : "", r = {};
  t.lang && (r.className = ["language-" + t.lang]);
  let i = {
    type: "element",
    tagName: "code",
    properties: r,
    children: [{ type: "text", value: n }]
  };
  return t.meta && (i.data = { meta: t.meta }), e.patch(t, i), i = e.applyData(t, i), i = { type: "element", tagName: "pre", properties: {}, children: [i] }, e.patch(t, i), i;
}
function cZe(e, t) {
  const n = {
    type: "element",
    tagName: "del",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function dZe(e, t) {
  const n = {
    type: "element",
    tagName: "em",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function pZe(e, t) {
  const n = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", r = String(t.identifier).toUpperCase(), i = xg(r.toLowerCase()), o = e.footnoteOrder.indexOf(r);
  let s, a = e.footnoteCounts.get(r);
  a === void 0 ? (a = 0, e.footnoteOrder.push(r), s = e.footnoteOrder.length) : s = o + 1, a += 1, e.footnoteCounts.set(r, a);
  const u = {
    type: "element",
    tagName: "a",
    properties: {
      href: "#" + n + "fn-" + i,
      id: n + "fnref-" + i + (a > 1 ? "-" + a : ""),
      dataFootnoteRef: !0,
      ariaDescribedBy: ["footnote-label"]
    },
    children: [{ type: "text", value: String(s) }]
  };
  e.patch(t, u);
  const c = {
    type: "element",
    tagName: "sup",
    properties: {},
    children: [u]
  };
  return e.patch(t, c), e.applyData(t, c);
}
function fZe(e, t) {
  const n = {
    type: "element",
    tagName: "h" + t.depth,
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function hZe(e, t) {
  if (e.options.allowDangerousHtml) {
    const n = { type: "raw", value: t.value };
    return e.patch(t, n), e.applyData(t, n);
  }
}
function Xq(e, t) {
  const n = t.referenceType;
  let r = "]";
  if (n === "collapsed" ? r += "[]" : n === "full" && (r += "[" + (t.label || t.identifier) + "]"), t.type === "imageReference")
    return [{ type: "text", value: "![" + t.alt + r }];
  const i = e.all(t), o = i[0];
  o && o.type === "text" ? o.value = "[" + o.value : i.unshift({ type: "text", value: "[" });
  const s = i[i.length - 1];
  return s && s.type === "text" ? s.value += r : i.push({ type: "text", value: r }), i;
}
function mZe(e, t) {
  const n = String(t.identifier).toUpperCase(), r = e.definitionById.get(n);
  if (!r)
    return Xq(e, t);
  const i = { src: xg(r.url || ""), alt: t.alt };
  r.title !== null && r.title !== void 0 && (i.title = r.title);
  const o = { type: "element", tagName: "img", properties: i, children: [] };
  return e.patch(t, o), e.applyData(t, o);
}
function gZe(e, t) {
  const n = { src: xg(t.url) };
  t.alt !== null && t.alt !== void 0 && (n.alt = t.alt), t.title !== null && t.title !== void 0 && (n.title = t.title);
  const r = { type: "element", tagName: "img", properties: n, children: [] };
  return e.patch(t, r), e.applyData(t, r);
}
function yZe(e, t) {
  const n = { type: "text", value: t.value.replace(/\r?\n|\r/g, " ") };
  e.patch(t, n);
  const r = {
    type: "element",
    tagName: "code",
    properties: {},
    children: [n]
  };
  return e.patch(t, r), e.applyData(t, r);
}
function bZe(e, t) {
  const n = String(t.identifier).toUpperCase(), r = e.definitionById.get(n);
  if (!r)
    return Xq(e, t);
  const i = { href: xg(r.url || "") };
  r.title !== null && r.title !== void 0 && (i.title = r.title);
  const o = {
    type: "element",
    tagName: "a",
    properties: i,
    children: e.all(t)
  };
  return e.patch(t, o), e.applyData(t, o);
}
function vZe(e, t) {
  const n = { href: xg(t.url) };
  t.title !== null && t.title !== void 0 && (n.title = t.title);
  const r = {
    type: "element",
    tagName: "a",
    properties: n,
    children: e.all(t)
  };
  return e.patch(t, r), e.applyData(t, r);
}
function xZe(e, t, n) {
  const r = e.all(t), i = n ? DZe(n) : Qq(t), o = {}, s = [];
  if (typeof t.checked == "boolean") {
    const d = r[0];
    let f;
    d && d.type === "element" && d.tagName === "p" ? f = d : (f = { type: "element", tagName: "p", properties: {}, children: [] }, r.unshift(f)), f.children.length > 0 && f.children.unshift({ type: "text", value: " " }), f.children.unshift({
      type: "element",
      tagName: "input",
      properties: { type: "checkbox", checked: t.checked, disabled: !0 },
      children: []
    }), o.className = ["task-list-item"];
  }
  let a = -1;
  for (; ++a < r.length; ) {
    const d = r[a];
    (i || a !== 0 || d.type !== "element" || d.tagName !== "p") && s.push({ type: "text", value: `
` }), d.type === "element" && d.tagName === "p" && !i ? s.push(...d.children) : s.push(d);
  }
  const u = r[r.length - 1];
  u && (i || u.type !== "element" || u.tagName !== "p") && s.push({ type: "text", value: `
` });
  const c = { type: "element", tagName: "li", properties: o, children: s };
  return e.patch(t, c), e.applyData(t, c);
}
function DZe(e) {
  let t = !1;
  if (e.type === "list") {
    t = e.spread || !1;
    const n = e.children;
    let r = -1;
    for (; !t && ++r < n.length; )
      t = Qq(n[r]);
  }
  return t;
}
function Qq(e) {
  const t = e.spread;
  return t ?? e.children.length > 1;
}
function CZe(e, t) {
  const n = {}, r = e.all(t);
  let i = -1;
  for (typeof t.start == "number" && t.start !== 1 && (n.start = t.start); ++i < r.length; ) {
    const s = r[i];
    if (s.type === "element" && s.tagName === "li" && s.properties && Array.isArray(s.properties.className) && s.properties.className.includes("task-list-item")) {
      n.className = ["contains-task-list"];
      break;
    }
  }
  const o = {
    type: "element",
    tagName: t.ordered ? "ol" : "ul",
    properties: n,
    children: e.wrap(r, !0)
  };
  return e.patch(t, o), e.applyData(t, o);
}
function EZe(e, t) {
  const n = {
    type: "element",
    tagName: "p",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function TZe(e, t) {
  const n = { type: "root", children: e.wrap(e.all(t)) };
  return e.patch(t, n), e.applyData(t, n);
}
function SZe(e, t) {
  const n = {
    type: "element",
    tagName: "strong",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function AZe(e, t) {
  const n = e.all(t), r = n.shift(), i = [];
  if (r) {
    const s = {
      type: "element",
      tagName: "thead",
      properties: {},
      children: e.wrap([r], !0)
    };
    e.patch(t.children[0], s), i.push(s);
  }
  if (n.length > 0) {
    const s = {
      type: "element",
      tagName: "tbody",
      properties: {},
      children: e.wrap(n, !0)
    }, a = v$(t.children[1]), u = Fq(t.children[t.children.length - 1]);
    a && u && (s.position = { start: a, end: u }), i.push(s);
  }
  const o = {
    type: "element",
    tagName: "table",
    properties: {},
    children: e.wrap(i, !0)
  };
  return e.patch(t, o), e.applyData(t, o);
}
function wZe(e, t, n) {
  const r = n ? n.children : void 0, o = (r ? r.indexOf(t) : 1) === 0 ? "th" : "td", s = n && n.type === "table" ? n.align : void 0, a = s ? s.length : t.children.length;
  let u = -1;
  const c = [];
  for (; ++u < a; ) {
    const f = t.children[u], h = {}, m = s ? s[u] : void 0;
    m && (h.align = m);
    let v = { type: "element", tagName: o, properties: h, children: [] };
    f && (v.children = e.all(f), e.patch(f, v), v = e.applyData(f, v)), c.push(v);
  }
  const d = {
    type: "element",
    tagName: "tr",
    properties: {},
    children: e.wrap(c, !0)
  };
  return e.patch(t, d), e.applyData(t, d);
}
function PZe(e, t) {
  const n = {
    type: "element",
    tagName: "td",
    // Assume body cell.
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
const Jj = 9, Xj = 32;
function kZe(e) {
  const t = String(e), n = /\r?\n|\r/g;
  let r = n.exec(t), i = 0;
  const o = [];
  for (; r; )
    o.push(
      Qj(t.slice(i, r.index), i > 0, !0),
      r[0]
    ), i = r.index + r[0].length, r = n.exec(t);
  return o.push(Qj(t.slice(i), i > 0, !1)), o.join("");
}
function Qj(e, t, n) {
  let r = 0, i = e.length;
  if (t) {
    let o = e.codePointAt(r);
    for (; o === Jj || o === Xj; )
      r++, o = e.codePointAt(r);
  }
  if (n) {
    let o = e.codePointAt(i - 1);
    for (; o === Jj || o === Xj; )
      i--, o = e.codePointAt(i - 1);
  }
  return i > r ? e.slice(r, i) : "";
}
function OZe(e, t) {
  const n = { type: "text", value: kZe(String(t.value)) };
  return e.patch(t, n), e.applyData(t, n);
}
function IZe(e, t) {
  const n = {
    type: "element",
    tagName: "hr",
    properties: {},
    children: []
  };
  return e.patch(t, n), e.applyData(t, n);
}
const FZe = {
  blockquote: aZe,
  break: lZe,
  code: uZe,
  delete: cZe,
  emphasis: dZe,
  footnoteReference: pZe,
  heading: fZe,
  html: hZe,
  imageReference: mZe,
  image: gZe,
  inlineCode: yZe,
  linkReference: bZe,
  link: vZe,
  listItem: xZe,
  list: CZe,
  paragraph: EZe,
  // @ts-expect-error: root is different, but hard to type.
  root: TZe,
  strong: SZe,
  table: AZe,
  tableCell: PZe,
  tableRow: wZe,
  text: OZe,
  thematicBreak: IZe,
  toml: ex,
  yaml: ex,
  definition: ex,
  footnoteDefinition: ex
};
function ex() {
}
const Zq = -1, rT = 0, tC = 1, nC = 2, A$ = 3, w$ = 4, P$ = 5, k$ = 6, eG = 7, tG = 8, Zj = typeof self == "object" ? self : globalThis, $Ze = (e, t) => {
  const n = (i, o) => (e.set(o, i), i), r = (i) => {
    if (e.has(i))
      return e.get(i);
    const [o, s] = t[i];
    switch (o) {
      case rT:
      case Zq:
        return n(s, i);
      case tC: {
        const a = n([], i);
        for (const u of s)
          a.push(r(u));
        return a;
      }
      case nC: {
        const a = n({}, i);
        for (const [u, c] of s)
          a[r(u)] = r(c);
        return a;
      }
      case A$:
        return n(new Date(s), i);
      case w$: {
        const { source: a, flags: u } = s;
        return n(new RegExp(a, u), i);
      }
      case P$: {
        const a = n(/* @__PURE__ */ new Map(), i);
        for (const [u, c] of s)
          a.set(r(u), r(c));
        return a;
      }
      case k$: {
        const a = n(/* @__PURE__ */ new Set(), i);
        for (const u of s)
          a.add(r(u));
        return a;
      }
      case eG: {
        const { name: a, message: u } = s;
        return n(new Zj[a](u), i);
      }
      case tG:
        return n(BigInt(s), i);
      case "BigInt":
        return n(Object(BigInt(s)), i);
    }
    return n(new Zj[o](s), i);
  };
  return r;
}, e8 = (e) => $Ze(/* @__PURE__ */ new Map(), e)(0), Dh = "", { toString: NZe } = {}, { keys: MZe } = Object, $y = (e) => {
  const t = typeof e;
  if (t !== "object" || !e)
    return [rT, t];
  const n = NZe.call(e).slice(8, -1);
  switch (n) {
    case "Array":
      return [tC, Dh];
    case "Object":
      return [nC, Dh];
    case "Date":
      return [A$, Dh];
    case "RegExp":
      return [w$, Dh];
    case "Map":
      return [P$, Dh];
    case "Set":
      return [k$, Dh];
  }
  return n.includes("Array") ? [tC, n] : n.includes("Error") ? [eG, n] : [nC, n];
}, tx = ([e, t]) => e === rT && (t === "function" || t === "symbol"), RZe = (e, t, n, r) => {
  const i = (s, a) => {
    const u = r.push(s) - 1;
    return n.set(a, u), u;
  }, o = (s) => {
    if (n.has(s))
      return n.get(s);
    let [a, u] = $y(s);
    switch (a) {
      case rT: {
        let d = s;
        switch (u) {
          case "bigint":
            a = tG, d = s.toString();
            break;
          case "function":
          case "symbol":
            if (e)
              throw new TypeError("unable to serialize " + u);
            d = null;
            break;
          case "undefined":
            return i([Zq], s);
        }
        return i([a, d], s);
      }
      case tC: {
        if (u)
          return i([u, [...s]], s);
        const d = [], f = i([a, d], s);
        for (const h of s)
          d.push(o(h));
        return f;
      }
      case nC: {
        if (u)
          switch (u) {
            case "BigInt":
              return i([u, s.toString()], s);
            case "Boolean":
            case "Number":
            case "String":
              return i([u, s.valueOf()], s);
          }
        if (t && "toJSON" in s)
          return o(s.toJSON());
        const d = [], f = i([a, d], s);
        for (const h of MZe(s))
          (e || !tx($y(s[h]))) && d.push([o(h), o(s[h])]);
        return f;
      }
      case A$:
        return i([a, s.toISOString()], s);
      case w$: {
        const { source: d, flags: f } = s;
        return i([a, { source: d, flags: f }], s);
      }
      case P$: {
        const d = [], f = i([a, d], s);
        for (const [h, m] of s)
          (e || !(tx($y(h)) || tx($y(m)))) && d.push([o(h), o(m)]);
        return f;
      }
      case k$: {
        const d = [], f = i([a, d], s);
        for (const h of s)
          (e || !tx($y(h))) && d.push(o(h));
        return f;
      }
    }
    const { message: c } = s;
    return i([a, { name: u, message: c }], s);
  };
  return o;
}, t8 = (e, { json: t, lossy: n } = {}) => {
  const r = [];
  return RZe(!(t || n), !!t, /* @__PURE__ */ new Map(), r)(e), r;
}, rC = typeof structuredClone == "function" ? (
  /* c8 ignore start */
  (e, t) => t && ("json" in t || "lossy" in t) ? e8(t8(e, t)) : structuredClone(e)
) : (e, t) => e8(t8(e, t));
function _Ze(e, t) {
  const n = [{ type: "text", value: "↩" }];
  return t > 1 && n.push({
    type: "element",
    tagName: "sup",
    properties: {},
    children: [{ type: "text", value: String(t) }]
  }), n;
}
function LZe(e, t) {
  return "Back to reference " + (e + 1) + (t > 1 ? "-" + t : "");
}
function BZe(e) {
  const t = typeof e.options.clobberPrefix == "string" ? e.options.clobberPrefix : "user-content-", n = e.options.footnoteBackContent || _Ze, r = e.options.footnoteBackLabel || LZe, i = e.options.footnoteLabel || "Footnotes", o = e.options.footnoteLabelTagName || "h2", s = e.options.footnoteLabelProperties || {
    className: ["sr-only"]
  }, a = [];
  let u = -1;
  for (; ++u < e.footnoteOrder.length; ) {
    const c = e.footnoteById.get(
      e.footnoteOrder[u]
    );
    if (!c)
      continue;
    const d = e.all(c), f = String(c.identifier).toUpperCase(), h = xg(f.toLowerCase());
    let m = 0;
    const v = [], x = e.footnoteCounts.get(f);
    for (; x !== void 0 && ++m <= x; ) {
      v.length > 0 && v.push({ type: "text", value: " " });
      let S = typeof n == "string" ? n : n(u, m);
      typeof S == "string" && (S = { type: "text", value: S }), v.push({
        type: "element",
        tagName: "a",
        properties: {
          href: "#" + t + "fnref-" + h + (m > 1 ? "-" + m : ""),
          dataFootnoteBackref: "",
          ariaLabel: typeof r == "string" ? r : r(u, m),
          className: ["data-footnote-backref"]
        },
        children: Array.isArray(S) ? S : [S]
      });
    }
    const C = d[d.length - 1];
    if (C && C.type === "element" && C.tagName === "p") {
      const S = C.children[C.children.length - 1];
      S && S.type === "text" ? S.value += " " : C.children.push({ type: "text", value: " " }), C.children.push(...v);
    } else
      d.push(...v);
    const E = {
      type: "element",
      tagName: "li",
      properties: { id: t + "fn-" + h },
      children: e.wrap(d, !0)
    };
    e.patch(c, E), a.push(E);
  }
  if (a.length !== 0)
    return {
      type: "element",
      tagName: "section",
      properties: { dataFootnotes: !0, className: ["footnotes"] },
      children: [
        {
          type: "element",
          tagName: o,
          properties: {
            ...rC(s),
            id: "footnote-label"
          },
          children: [{ type: "text", value: i }]
        },
        { type: "text", value: `
` },
        {
          type: "element",
          tagName: "ol",
          properties: {},
          children: e.wrap(a, !0)
        },
        { type: "text", value: `
` }
      ]
    };
}
const nG = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {Check}
   */
  function(e) {
    if (e == null)
      return UZe;
    if (typeof e == "function")
      return iT(e);
    if (typeof e == "object")
      return Array.isArray(e) ? jZe(e) : VZe(e);
    if (typeof e == "string")
      return zZe(e);
    throw new Error("Expected function, string, or object as test");
  }
);
function jZe(e) {
  const t = [];
  let n = -1;
  for (; ++n < e.length; )
    t[n] = nG(e[n]);
  return iT(r);
  function r(...i) {
    let o = -1;
    for (; ++o < t.length; )
      if (t[o].apply(this, i)) return !0;
    return !1;
  }
}
function VZe(e) {
  const t = (
    /** @type {Record<string, unknown>} */
    e
  );
  return iT(n);
  function n(r) {
    const i = (
      /** @type {Record<string, unknown>} */
      /** @type {unknown} */
      r
    );
    let o;
    for (o in e)
      if (i[o] !== t[o]) return !1;
    return !0;
  }
}
function zZe(e) {
  return iT(t);
  function t(n) {
    return n && n.type === e;
  }
}
function iT(e) {
  return t;
  function t(n, r, i) {
    return !!(WZe(n) && e.call(
      this,
      n,
      typeof r == "number" ? r : void 0,
      i || void 0
    ));
  }
}
function UZe() {
  return !0;
}
function WZe(e) {
  return e !== null && typeof e == "object" && "type" in e;
}
const rG = [], HZe = !0, n8 = !1, qZe = "skip";
function GZe(e, t, n, r) {
  let i;
  typeof t == "function" && typeof n != "function" ? (r = n, n = t) : i = t;
  const o = nG(i), s = r ? -1 : 1;
  a(e, void 0, [])();
  function a(u, c, d) {
    const f = (
      /** @type {Record<string, unknown>} */
      u && typeof u == "object" ? u : {}
    );
    if (typeof f.type == "string") {
      const m = (
        // `hast`
        typeof f.tagName == "string" ? f.tagName : (
          // `xast`
          typeof f.name == "string" ? f.name : void 0
        )
      );
      Object.defineProperty(h, "name", {
        value: "node (" + (u.type + (m ? "<" + m + ">" : "")) + ")"
      });
    }
    return h;
    function h() {
      let m = rG, v, x, C;
      if ((!t || o(u, c, d[d.length - 1] || void 0)) && (m = YZe(n(u, d)), m[0] === n8))
        return m;
      if ("children" in u && u.children) {
        const E = (
          /** @type {UnistParent} */
          u
        );
        if (E.children && m[0] !== qZe)
          for (x = (r ? E.children.length : -1) + s, C = d.concat(E); x > -1 && x < E.children.length; ) {
            const S = E.children[x];
            if (v = a(S, x, C)(), v[0] === n8)
              return v;
            x = typeof v[1] == "number" ? v[1] : x + s;
          }
      }
      return m;
    }
  }
}
function YZe(e) {
  return Array.isArray(e) ? e : typeof e == "number" ? [HZe, e] : e == null ? rG : [e];
}
function iG(e, t, n, r) {
  let i, o, s;
  typeof t == "function" && typeof n != "function" ? (o = void 0, s = t, i = n) : (o = t, s = n, i = r), GZe(e, o, a, i);
  function a(u, c) {
    const d = c[c.length - 1], f = d ? d.children.indexOf(u) : void 0;
    return s(u, f, d);
  }
}
const ck = {}.hasOwnProperty, KZe = {};
function JZe(e, t) {
  const n = t || KZe, r = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map(), s = { ...FZe, ...n.handlers }, a = {
    all: c,
    applyData: QZe,
    definitionById: r,
    footnoteById: i,
    footnoteCounts: o,
    footnoteOrder: [],
    handlers: s,
    one: u,
    options: n,
    patch: XZe,
    wrap: eet
  };
  return iG(e, function(d) {
    if (d.type === "definition" || d.type === "footnoteDefinition") {
      const f = d.type === "definition" ? r : i, h = String(d.identifier).toUpperCase();
      f.has(h) || f.set(h, d);
    }
  }), a;
  function u(d, f) {
    const h = d.type, m = a.handlers[h];
    if (ck.call(a.handlers, h) && m)
      return m(a, d, f);
    if (a.options.passThrough && a.options.passThrough.includes(h)) {
      if ("children" in d) {
        const { children: x, ...C } = d, E = rC(C);
        return E.children = a.all(d), E;
      }
      return rC(d);
    }
    return (a.options.unknownHandler || ZZe)(a, d, f);
  }
  function c(d) {
    const f = [];
    if ("children" in d) {
      const h = d.children;
      let m = -1;
      for (; ++m < h.length; ) {
        const v = a.one(h[m], d);
        if (v) {
          if (m && h[m - 1].type === "break" && (!Array.isArray(v) && v.type === "text" && (v.value = r8(v.value)), !Array.isArray(v) && v.type === "element")) {
            const x = v.children[0];
            x && x.type === "text" && (x.value = r8(x.value));
          }
          Array.isArray(v) ? f.push(...v) : f.push(v);
        }
      }
    }
    return f;
  }
}
function XZe(e, t) {
  e.position && (t.position = FJe(e));
}
function QZe(e, t) {
  let n = t;
  if (e && e.data) {
    const r = e.data.hName, i = e.data.hChildren, o = e.data.hProperties;
    if (typeof r == "string")
      if (n.type === "element")
        n.tagName = r;
      else {
        const s = "children" in n ? n.children : [n];
        n = { type: "element", tagName: r, properties: {}, children: s };
      }
    n.type === "element" && o && Object.assign(n.properties, rC(o)), "children" in n && n.children && i !== null && i !== void 0 && (n.children = i);
  }
  return n;
}
function ZZe(e, t) {
  const n = t.data || {}, r = "value" in t && !(ck.call(n, "hProperties") || ck.call(n, "hChildren")) ? { type: "text", value: t.value } : {
    type: "element",
    tagName: "div",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, r), e.applyData(t, r);
}
function eet(e, t) {
  const n = [];
  let r = -1;
  for (t && n.push({ type: "text", value: `
` }); ++r < e.length; )
    r && n.push({ type: "text", value: `
` }), n.push(e[r]);
  return t && e.length > 0 && n.push({ type: "text", value: `
` }), n;
}
function r8(e) {
  let t = 0, n = e.charCodeAt(t);
  for (; n === 9 || n === 32; )
    t++, n = e.charCodeAt(t);
  return e.slice(t);
}
function i8(e, t) {
  const n = JZe(e, t), r = n.one(e, void 0), i = BZe(n), o = Array.isArray(r) ? { type: "root", children: r } : r || { type: "root", children: [] };
  return i && o.children.push({ type: "text", value: `
` }, i), o;
}
function tet(e, t) {
  return e && "run" in e ? async function(n, r) {
    const i = (
      /** @type {HastRoot} */
      i8(n, { file: r, ...t })
    );
    await e.run(i, r);
  } : function(n, r) {
    return (
      /** @type {HastRoot} */
      i8(n, { file: r, ...t || e })
    );
  };
}
function o8(e) {
  if (e)
    throw e;
}
var nD = Object.prototype.hasOwnProperty, oG = Object.prototype.toString, s8 = Object.defineProperty, a8 = Object.getOwnPropertyDescriptor, l8 = function(t) {
  return typeof Array.isArray == "function" ? Array.isArray(t) : oG.call(t) === "[object Array]";
}, u8 = function(t) {
  if (!t || oG.call(t) !== "[object Object]")
    return !1;
  var n = nD.call(t, "constructor"), r = t.constructor && t.constructor.prototype && nD.call(t.constructor.prototype, "isPrototypeOf");
  if (t.constructor && !n && !r)
    return !1;
  var i;
  for (i in t)
    ;
  return typeof i > "u" || nD.call(t, i);
}, c8 = function(t, n) {
  s8 && n.name === "__proto__" ? s8(t, n.name, {
    enumerable: !0,
    configurable: !0,
    value: n.newValue,
    writable: !0
  }) : t[n.name] = n.newValue;
}, d8 = function(t, n) {
  if (n === "__proto__")
    if (nD.call(t, n)) {
      if (a8)
        return a8(t, n).value;
    } else return;
  return t[n];
}, net = function e() {
  var t, n, r, i, o, s, a = arguments[0], u = 1, c = arguments.length, d = !1;
  for (typeof a == "boolean" && (d = a, a = arguments[1] || {}, u = 2), (a == null || typeof a != "object" && typeof a != "function") && (a = {}); u < c; ++u)
    if (t = arguments[u], t != null)
      for (n in t)
        r = d8(a, n), i = d8(t, n), a !== i && (d && i && (u8(i) || (o = l8(i))) ? (o ? (o = !1, s = r && l8(r) ? r : []) : s = r && u8(r) ? r : {}, c8(a, { name: n, newValue: e(d, s, i) })) : typeof i < "u" && c8(a, { name: n, newValue: i }));
  return a;
};
const pw = /* @__PURE__ */ Ln(net);
function dk(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const t = Object.getPrototypeOf(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function ret() {
  const e = [], t = { run: n, use: r };
  return t;
  function n(...i) {
    let o = -1;
    const s = i.pop();
    if (typeof s != "function")
      throw new TypeError("Expected function as last argument, not " + s);
    a(null, ...i);
    function a(u, ...c) {
      const d = e[++o];
      let f = -1;
      if (u) {
        s(u);
        return;
      }
      for (; ++f < i.length; )
        (c[f] === null || c[f] === void 0) && (c[f] = i[f]);
      i = c, d ? iet(d, a)(...c) : s(null, ...c);
    }
  }
  function r(i) {
    if (typeof i != "function")
      throw new TypeError(
        "Expected `middelware` to be a function, not " + i
      );
    return e.push(i), t;
  }
}
function iet(e, t) {
  let n;
  return r;
  function r(...s) {
    const a = e.length > s.length;
    let u;
    a && s.push(i);
    try {
      u = e.apply(this, s);
    } catch (c) {
      const d = (
        /** @type {Error} */
        c
      );
      if (a && n)
        throw d;
      return i(d);
    }
    a || (u && u.then && typeof u.then == "function" ? u.then(o, i) : u instanceof Error ? i(u) : o(u));
  }
  function i(s, ...a) {
    n || (n = !0, t(s, ...a));
  }
  function o(s) {
    i(null, s);
  }
}
const Wl = { basename: oet, dirname: set, extname: aet, join: uet, sep: "/" };
function oet(e, t) {
  if (t !== void 0 && typeof t != "string")
    throw new TypeError('"ext" argument must be a string');
  hv(e);
  let n = 0, r = -1, i = e.length, o;
  if (t === void 0 || t.length === 0 || t.length > e.length) {
    for (; i--; )
      if (e.codePointAt(i) === 47) {
        if (o) {
          n = i + 1;
          break;
        }
      } else r < 0 && (o = !0, r = i + 1);
    return r < 0 ? "" : e.slice(n, r);
  }
  if (t === e)
    return "";
  let s = -1, a = t.length - 1;
  for (; i--; )
    if (e.codePointAt(i) === 47) {
      if (o) {
        n = i + 1;
        break;
      }
    } else
      s < 0 && (o = !0, s = i + 1), a > -1 && (e.codePointAt(i) === t.codePointAt(a--) ? a < 0 && (r = i) : (a = -1, r = s));
  return n === r ? r = s : r < 0 && (r = e.length), e.slice(n, r);
}
function set(e) {
  if (hv(e), e.length === 0)
    return ".";
  let t = -1, n = e.length, r;
  for (; --n; )
    if (e.codePointAt(n) === 47) {
      if (r) {
        t = n;
        break;
      }
    } else r || (r = !0);
  return t < 0 ? e.codePointAt(0) === 47 ? "/" : "." : t === 1 && e.codePointAt(0) === 47 ? "//" : e.slice(0, t);
}
function aet(e) {
  hv(e);
  let t = e.length, n = -1, r = 0, i = -1, o = 0, s;
  for (; t--; ) {
    const a = e.codePointAt(t);
    if (a === 47) {
      if (s) {
        r = t + 1;
        break;
      }
      continue;
    }
    n < 0 && (s = !0, n = t + 1), a === 46 ? i < 0 ? i = t : o !== 1 && (o = 1) : i > -1 && (o = -1);
  }
  return i < 0 || n < 0 || // We saw a non-dot character immediately before the dot.
  o === 0 || // The (right-most) trimmed path component is exactly `..`.
  o === 1 && i === n - 1 && i === r + 1 ? "" : e.slice(i, n);
}
function uet(...e) {
  let t = -1, n;
  for (; ++t < e.length; )
    hv(e[t]), e[t] && (n = n === void 0 ? e[t] : n + "/" + e[t]);
  return n === void 0 ? "." : cet(n);
}
function cet(e) {
  hv(e);
  const t = e.codePointAt(0) === 47;
  let n = det(e, !t);
  return n.length === 0 && !t && (n = "."), n.length > 0 && e.codePointAt(e.length - 1) === 47 && (n += "/"), t ? "/" + n : n;
}
function det(e, t) {
  let n = "", r = 0, i = -1, o = 0, s = -1, a, u;
  for (; ++s <= e.length; ) {
    if (s < e.length)
      a = e.codePointAt(s);
    else {
      if (a === 47)
        break;
      a = 47;
    }
    if (a === 47) {
      if (!(i === s - 1 || o === 1)) if (i !== s - 1 && o === 2) {
        if (n.length < 2 || r !== 2 || n.codePointAt(n.length - 1) !== 46 || n.codePointAt(n.length - 2) !== 46) {
          if (n.length > 2) {
            if (u = n.lastIndexOf("/"), u !== n.length - 1) {
              u < 0 ? (n = "", r = 0) : (n = n.slice(0, u), r = n.length - 1 - n.lastIndexOf("/")), i = s, o = 0;
              continue;
            }
          } else if (n.length > 0) {
            n = "", r = 0, i = s, o = 0;
            continue;
          }
        }
        t && (n = n.length > 0 ? n + "/.." : "..", r = 2);
      } else
        n.length > 0 ? n += "/" + e.slice(i + 1, s) : n = e.slice(i + 1, s), r = s - i - 1;
      i = s, o = 0;
    } else a === 46 && o > -1 ? o++ : o = -1;
  }
  return n;
}
function hv(e) {
  if (typeof e != "string")
    throw new TypeError(
      "Path must be a string. Received " + JSON.stringify(e)
    );
}
const pet = { cwd: fet };
function fet() {
  return "/";
}
function pk(e) {
  return !!(e !== null && typeof e == "object" && "href" in e && e.href && "protocol" in e && e.protocol && // @ts-expect-error: indexing is fine.
  e.auth === void 0);
}
function het(e) {
  if (typeof e == "string")
    e = new URL(e);
  else if (!pk(e)) {
    const t = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' + e + "`"
    );
    throw t.code = "ERR_INVALID_ARG_TYPE", t;
  }
  if (e.protocol !== "file:") {
    const t = new TypeError("The URL must be of scheme file");
    throw t.code = "ERR_INVALID_URL_SCHEME", t;
  }
  return met(e);
}
function met(e) {
  if (e.hostname !== "") {
    const r = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    );
    throw r.code = "ERR_INVALID_FILE_URL_HOST", r;
  }
  const t = e.pathname;
  let n = -1;
  for (; ++n < t.length; )
    if (t.codePointAt(n) === 37 && t.codePointAt(n + 1) === 50) {
      const r = t.codePointAt(n + 2);
      if (r === 70 || r === 102) {
        const i = new TypeError(
          "File URL path must not include encoded / characters"
        );
        throw i.code = "ERR_INVALID_FILE_URL_PATH", i;
      }
    }
  return decodeURIComponent(t);
}
const fw = (
  /** @type {const} */
  [
    "history",
    "path",
    "basename",
    "stem",
    "extname",
    "dirname"
  ]
);
class sG {
  /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Uint8Array` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */
  constructor(t) {
    let n;
    t ? pk(t) ? n = { path: t } : typeof t == "string" || get(t) ? n = { value: t } : n = t : n = {}, this.cwd = "cwd" in n ? "" : pet.cwd(), this.data = {}, this.history = [], this.messages = [], this.value, this.map, this.result, this.stored;
    let r = -1;
    for (; ++r < fw.length; ) {
      const o = fw[r];
      o in n && n[o] !== void 0 && n[o] !== null && (this[o] = o === "history" ? [...n[o]] : n[o]);
    }
    let i;
    for (i in n)
      fw.includes(i) || (this[i] = n[i]);
  }
  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   *
   * @returns {string | undefined}
   *   Basename.
   */
  get basename() {
    return typeof this.path == "string" ? Wl.basename(this.path) : void 0;
  }
  /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} basename
   *   Basename.
   * @returns {undefined}
   *   Nothing.
   */
  set basename(t) {
    mw(t, "basename"), hw(t, "basename"), this.path = Wl.join(this.dirname || "", t);
  }
  /**
   * Get the parent path (example: `'~'`).
   *
   * @returns {string | undefined}
   *   Dirname.
   */
  get dirname() {
    return typeof this.path == "string" ? Wl.dirname(this.path) : void 0;
  }
  /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} dirname
   *   Dirname.
   * @returns {undefined}
   *   Nothing.
   */
  set dirname(t) {
    p8(this.basename, "dirname"), this.path = Wl.join(t || "", this.basename);
  }
  /**
   * Get the extname (including dot) (example: `'.js'`).
   *
   * @returns {string | undefined}
   *   Extname.
   */
  get extname() {
    return typeof this.path == "string" ? Wl.extname(this.path) : void 0;
  }
  /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} extname
   *   Extname.
   * @returns {undefined}
   *   Nothing.
   */
  set extname(t) {
    if (hw(t, "extname"), p8(this.dirname, "extname"), t) {
      if (t.codePointAt(0) !== 46)
        throw new Error("`extname` must start with `.`");
      if (t.includes(".", 1))
        throw new Error("`extname` cannot contain multiple dots");
    }
    this.path = Wl.join(this.dirname, this.stem + (t || ""));
  }
  /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   *   Path.
   */
  get path() {
    return this.history[this.history.length - 1];
  }
  /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {URL | string} path
   *   Path.
   * @returns {undefined}
   *   Nothing.
   */
  set path(t) {
    pk(t) && (t = het(t)), mw(t, "path"), this.path !== t && this.history.push(t);
  }
  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   *
   * @returns {string | undefined}
   *   Stem.
   */
  get stem() {
    return typeof this.path == "string" ? Wl.basename(this.path, this.extname) : void 0;
  }
  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} stem
   *   Stem.
   * @returns {undefined}
   *   Nothing.
   */
  set stem(t) {
    mw(t, "stem"), hw(t, "stem"), this.path = Wl.join(this.dirname || "", t + (this.extname || ""));
  }
  // Normal prototypal methods.
  /**
   * Create a fatal message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `true` (error; file not usable)
   * and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Never.
   * @throws {VFileMessage}
   *   Message.
   */
  fail(t, n, r) {
    const i = this.message(t, n, r);
    throw i.fatal = !0, i;
  }
  /**
   * Create an info message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `undefined` (info; change
   * likely not needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  info(t, n, r) {
    const i = this.message(t, n, r);
    return i.fatal = void 0, i;
  }
  /**
   * Create a message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `false` (warning; change may be
   * needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  message(t, n, r) {
    const i = new Vo(
      // @ts-expect-error: the overloads are fine.
      t,
      n,
      r
    );
    return this.path && (i.name = this.path + ":" + i.name, i.file = this.path), i.fatal = !1, this.messages.push(i), i;
  }
  /**
   * Serialize the file.
   *
   * > **Note**: which encodings are supported depends on the engine.
   * > For info on Node.js, see:
   * > <https://nodejs.org/api/util.html#whatwg-supported-encodings>.
   *
   * @param {string | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Uint8Array`
   *   (default: `'utf-8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(t) {
    return this.value === void 0 ? "" : typeof this.value == "string" ? this.value : new TextDecoder(t || void 0).decode(this.value);
  }
}
function hw(e, t) {
  if (e && e.includes(Wl.sep))
    throw new Error(
      "`" + t + "` cannot be a path: did not expect `" + Wl.sep + "`"
    );
}
function mw(e, t) {
  if (!e)
    throw new Error("`" + t + "` cannot be empty");
}
function p8(e, t) {
  if (!e)
    throw new Error("Setting `" + t + "` requires `path` to be set too");
}
function get(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const yet = (
  /**
   * @type {new <Parameters extends Array<unknown>, Result>(property: string | symbol) => (...parameters: Parameters) => Result}
   */
  /** @type {unknown} */
  /**
   * @this {Function}
   * @param {string | symbol} property
   * @returns {(...parameters: Array<unknown>) => unknown}
   */
  function(e) {
    const r = (
      /** @type {Record<string | symbol, Function>} */
      // Prototypes do exist.
      // type-coverage:ignore-next-line
      this.constructor.prototype
    ), i = r[e], o = function() {
      return i.apply(o, arguments);
    };
    return Object.setPrototypeOf(o, r), o;
  }
), bet = {}.hasOwnProperty;
class O$ extends yet {
  /**
   * Create a processor.
   */
  constructor() {
    super("copy"), this.Compiler = void 0, this.Parser = void 0, this.attachers = [], this.compiler = void 0, this.freezeIndex = -1, this.frozen = void 0, this.namespace = {}, this.parser = void 0, this.transformers = ret();
  }
  /**
   * Copy a processor.
   *
   * @deprecated
   *   This is a private internal method and should not be used.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   New *unfrozen* processor ({@linkcode Processor}) that is
   *   configured to work the same as its ancestor.
   *   When the descendant processor is configured in the future it does not
   *   affect the ancestral processor.
   */
  copy() {
    const t = (
      /** @type {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>} */
      new O$()
    );
    let n = -1;
    for (; ++n < this.attachers.length; ) {
      const r = this.attachers[n];
      t.use(...r);
    }
    return t.data(pw(!0, {}, this.namespace)), t;
  }
  /**
   * Configure the processor with info available to all plugins.
   * Information is stored in an object.
   *
   * Typically, options can be given to a specific plugin, but sometimes it
   * makes sense to have information shared with several plugins.
   * For example, a list of HTML elements that are self-closing, which is
   * needed during all phases.
   *
   * > **Note**: setting information cannot occur on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * > **Note**: to register custom data in TypeScript, augment the
   * > {@linkcode Data} interface.
   *
   * @example
   *   This example show how to get and set info:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   const processor = unified().data('alpha', 'bravo')
   *
   *   processor.data('alpha') // => 'bravo'
   *
   *   processor.data() // => {alpha: 'bravo'}
   *
   *   processor.data({charlie: 'delta'})
   *
   *   processor.data() // => {charlie: 'delta'}
   *   ```
   *
   * @template {keyof Data} Key
   *
   * @overload
   * @returns {Data}
   *
   * @overload
   * @param {Data} dataset
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Key} key
   * @returns {Data[Key]}
   *
   * @overload
   * @param {Key} key
   * @param {Data[Key]} value
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @param {Data | Key} [key]
   *   Key to get or set, or entire dataset to set, or nothing to get the
   *   entire dataset (optional).
   * @param {Data[Key]} [value]
   *   Value to set (optional).
   * @returns {unknown}
   *   The current processor when setting, the value at `key` when getting, or
   *   the entire dataset when getting without key.
   */
  data(t, n) {
    return typeof t == "string" ? arguments.length === 2 ? (bw("data", this.frozen), this.namespace[t] = n, this) : bet.call(this.namespace, t) && this.namespace[t] || void 0 : t ? (bw("data", this.frozen), this.namespace = t, this) : this.namespace;
  }
  /**
   * Freeze a processor.
   *
   * Frozen processors are meant to be extended and not to be configured
   * directly.
   *
   * When a processor is frozen it cannot be unfrozen.
   * New processors working the same way can be created by calling the
   * processor.
   *
   * It’s possible to freeze processors explicitly by calling `.freeze()`.
   * Processors freeze automatically when `.parse()`, `.run()`, `.runSync()`,
   * `.stringify()`, `.process()`, or `.processSync()` are called.
   *
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   The current processor.
   */
  freeze() {
    if (this.frozen)
      return this;
    const t = (
      /** @type {Processor} */
      /** @type {unknown} */
      this
    );
    for (; ++this.freezeIndex < this.attachers.length; ) {
      const [n, ...r] = this.attachers[this.freezeIndex];
      if (r[0] === !1)
        continue;
      r[0] === !0 && (r[0] = void 0);
      const i = n.call(t, ...r);
      typeof i == "function" && this.transformers.use(i);
    }
    return this.frozen = !0, this.freezeIndex = Number.POSITIVE_INFINITY, this;
  }
  /**
   * Parse text to a syntax tree.
   *
   * > **Note**: `parse` freezes the processor if not already *frozen*.
   *
   * > **Note**: `parse` performs the parse phase, not the run phase or other
   * > phases.
   *
   * @param {Compatible | undefined} [file]
   *   file to parse (optional); typically `string` or `VFile`; any value
   *   accepted as `x` in `new VFile(x)`.
   * @returns {ParseTree extends undefined ? Node : ParseTree}
   *   Syntax tree representing `file`.
   */
  parse(t) {
    this.freeze();
    const n = nx(t), r = this.parser || this.Parser;
    return gw("parse", r), r(String(n), n);
  }
  /**
   * Process the given file as configured on the processor.
   *
   * > **Note**: `process` freezes the processor if not already *frozen*.
   *
   * > **Note**: `process` performs the parse, run, and stringify phases.
   *
   * @overload
   * @param {Compatible | undefined} file
   * @param {ProcessCallback<VFileWithOutput<CompileResult>>} done
   * @returns {undefined}
   *
   * @overload
   * @param {Compatible | undefined} [file]
   * @returns {Promise<VFileWithOutput<CompileResult>>}
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`]; any value accepted as
   *   `x` in `new VFile(x)`.
   * @param {ProcessCallback<VFileWithOutput<CompileResult>> | undefined} [done]
   *   Callback (optional).
   * @returns {Promise<VFile> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise a promise, rejected with a fatal error or resolved with the
   *   processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  process(t, n) {
    const r = this;
    return this.freeze(), gw("process", this.parser || this.Parser), yw("process", this.compiler || this.Compiler), n ? i(void 0, n) : new Promise(i);
    function i(o, s) {
      const a = nx(t), u = (
        /** @type {HeadTree extends undefined ? Node : HeadTree} */
        /** @type {unknown} */
        r.parse(a)
      );
      r.run(u, a, function(d, f, h) {
        if (d || !f || !h)
          return c(d);
        const m = (
          /** @type {CompileTree extends undefined ? Node : CompileTree} */
          /** @type {unknown} */
          f
        ), v = r.stringify(m, h);
        Det(v) ? h.value = v : h.result = v, c(
          d,
          /** @type {VFileWithOutput<CompileResult>} */
          h
        );
      });
      function c(d, f) {
        d || !f ? s(d) : o ? o(f) : n(void 0, f);
      }
    }
  }
  /**
   * Process the given file as configured on the processor.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `processSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `processSync` performs the parse, run, and stringify phases.
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`; any value accepted as
   *   `x` in `new VFile(x)`.
   * @returns {VFileWithOutput<CompileResult>}
   *   The processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  processSync(t) {
    let n = !1, r;
    return this.freeze(), gw("processSync", this.parser || this.Parser), yw("processSync", this.compiler || this.Compiler), this.process(t, i), h8("processSync", "process", n), r;
    function i(o, s) {
      n = !0, o8(o), r = s;
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * > **Note**: `run` freezes the processor if not already *frozen*.
   *
   * > **Note**: `run` performs the run phase, not other phases.
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} file
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} [file]
   * @returns {Promise<TailTree extends undefined ? Node : TailTree>}
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {(
   *   RunCallback<TailTree extends undefined ? Node : TailTree> |
   *   Compatible
   * )} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} [done]
   *   Callback (optional).
   * @returns {Promise<TailTree extends undefined ? Node : TailTree> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise, a promise rejected with a fatal error or resolved with the
   *   transformed tree.
   */
  run(t, n, r) {
    f8(t), this.freeze();
    const i = this.transformers;
    return !r && typeof n == "function" && (r = n, n = void 0), r ? o(void 0, r) : new Promise(o);
    function o(s, a) {
      const u = nx(n);
      i.run(t, u, c);
      function c(d, f, h) {
        const m = (
          /** @type {TailTree extends undefined ? Node : TailTree} */
          f || t
        );
        d ? a(d) : s ? s(m) : r(void 0, m, h);
      }
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `runSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `runSync` performs the run phase, not other phases.
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {TailTree extends undefined ? Node : TailTree}
   *   Transformed tree.
   */
  runSync(t, n) {
    let r = !1, i;
    return this.run(t, n, o), h8("runSync", "run", r), i;
    function o(s, a) {
      o8(s), i = a, r = !0;
    }
  }
  /**
   * Compile a syntax tree.
   *
   * > **Note**: `stringify` freezes the processor if not already *frozen*.
   *
   * > **Note**: `stringify` performs the stringify phase, not the run phase
   * > or other phases.
   *
   * @param {CompileTree extends undefined ? Node : CompileTree} tree
   *   Tree to compile.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {CompileResult extends undefined ? Value : CompileResult}
   *   Textual representation of the tree (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most compilers
   *   > return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  stringify(t, n) {
    this.freeze();
    const r = nx(n), i = this.compiler || this.Compiler;
    return yw("stringify", i), f8(t), i(t, r);
  }
  /**
   * Configure the processor to use a plugin, a list of usable values, or a
   * preset.
   *
   * If the processor is already using a plugin, the previous plugin
   * configuration is changed based on the options that are passed in.
   * In other words, the plugin is not added a second time.
   *
   * > **Note**: `use` cannot be called on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * @example
   *   There are many ways to pass plugins to `.use()`.
   *   This example gives an overview:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   unified()
   *     // Plugin with options:
   *     .use(pluginA, {x: true, y: true})
   *     // Passing the same plugin again merges configuration (to `{x: true, y: false, z: true}`):
   *     .use(pluginA, {y: false, z: true})
   *     // Plugins:
   *     .use([pluginB, pluginC])
   *     // Two plugins, the second with options:
   *     .use([pluginD, [pluginE, {}]])
   *     // Preset with plugins and settings:
   *     .use({plugins: [pluginF, [pluginG, {}]], settings: {position: false}})
   *     // Settings only:
   *     .use({settings: {position: false}})
   *   ```
   *
   * @template {Array<unknown>} [Parameters=[]]
   * @template {Node | string | undefined} [Input=undefined]
   * @template [Output=Input]
   *
   * @overload
   * @param {Preset | null | undefined} [preset]
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {PluggableList} list
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Plugin<Parameters, Input, Output>} plugin
   * @param {...(Parameters | [boolean])} parameters
   * @returns {UsePlugin<ParseTree, HeadTree, TailTree, CompileTree, CompileResult, Input, Output>}
   *
   * @param {PluggableList | Plugin | Preset | null | undefined} value
   *   Usable value.
   * @param {...unknown} parameters
   *   Parameters, when a plugin is given as a usable value.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   Current processor.
   */
  use(t, ...n) {
    const r = this.attachers, i = this.namespace;
    if (bw("use", this.frozen), t != null) if (typeof t == "function")
      u(t, n);
    else if (typeof t == "object")
      Array.isArray(t) ? a(t) : s(t);
    else
      throw new TypeError("Expected usable value, not `" + t + "`");
    return this;
    function o(c) {
      if (typeof c == "function")
        u(c, []);
      else if (typeof c == "object")
        if (Array.isArray(c)) {
          const [d, ...f] = (
            /** @type {PluginTuple<Array<unknown>>} */
            c
          );
          u(d, f);
        } else
          s(c);
      else
        throw new TypeError("Expected usable value, not `" + c + "`");
    }
    function s(c) {
      if (!("plugins" in c) && !("settings" in c))
        throw new Error(
          "Expected usable value but received an empty preset, which is probably a mistake: presets typically come with `plugins` and sometimes with `settings`, but this has neither"
        );
      a(c.plugins), c.settings && (i.settings = pw(!0, i.settings, c.settings));
    }
    function a(c) {
      let d = -1;
      if (c != null) if (Array.isArray(c))
        for (; ++d < c.length; ) {
          const f = c[d];
          o(f);
        }
      else
        throw new TypeError("Expected a list of plugins, not `" + c + "`");
    }
    function u(c, d) {
      let f = -1, h = -1;
      for (; ++f < r.length; )
        if (r[f][0] === c) {
          h = f;
          break;
        }
      if (h === -1)
        r.push([c, ...d]);
      else if (d.length > 0) {
        let [m, ...v] = d;
        const x = r[h][1];
        dk(x) && dk(m) && (m = pw(!0, x, m)), r[h] = [c, m, ...v];
      }
    }
  }
}
const vet = new O$().freeze();
function gw(e, t) {
  if (typeof t != "function")
    throw new TypeError("Cannot `" + e + "` without `parser`");
}
function yw(e, t) {
  if (typeof t != "function")
    throw new TypeError("Cannot `" + e + "` without `compiler`");
}
function bw(e, t) {
  if (t)
    throw new Error(
      "Cannot call `" + e + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`."
    );
}
function f8(e) {
  if (!dk(e) || typeof e.type != "string")
    throw new TypeError("Expected node, got `" + e + "`");
}
function h8(e, t, n) {
  if (!n)
    throw new Error(
      "`" + e + "` finished async. Use `" + t + "` instead"
    );
}
function nx(e) {
  return xet(e) ? e : new sG(e);
}
function xet(e) {
  return !!(e && typeof e == "object" && "message" in e && "messages" in e);
}
function Det(e) {
  return typeof e == "string" || Cet(e);
}
function Cet(e) {
  return !!(e && typeof e == "object" && "byteLength" in e && "byteOffset" in e);
}
const Eet = "https://github.com/remarkjs/react-markdown/blob/main/changelog.md", m8 = [], g8 = { allowDangerousHtml: !0 }, Tet = /^(https?|ircs?|mailto|xmpp)$/i, Aet = [
  { from: "astPlugins", id: "remove-buggy-html-in-markdown-parser" },
  { from: "allowDangerousHtml", id: "remove-buggy-html-in-markdown-parser" },
  {
    from: "allowNode",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowElement"
  },
  {
    from: "allowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "allowedElements"
  },
  {
    from: "disallowedTypes",
    id: "replace-allownode-allowedtypes-and-disallowedtypes",
    to: "disallowedElements"
  },
  { from: "escapeHtml", id: "remove-buggy-html-in-markdown-parser" },
  { from: "includeElementIndex", id: "#remove-includeelementindex" },
  {
    from: "includeNodeIndex",
    id: "change-includenodeindex-to-includeelementindex"
  },
  { from: "linkTarget", id: "remove-linktarget" },
  { from: "plugins", id: "change-plugins-to-remarkplugins", to: "remarkPlugins" },
  { from: "rawSourcePos", id: "#remove-rawsourcepos" },
  { from: "renderers", id: "change-renderers-to-components", to: "components" },
  { from: "source", id: "change-source-to-children", to: "children" },
  { from: "sourcePos", id: "#remove-sourcepos" },
  { from: "transformImageUri", id: "#add-urltransform", to: "urlTransform" },
  { from: "transformLinkUri", id: "#add-urltransform", to: "urlTransform" }
];
function wet(e) {
  const t = e.allowedElements, n = e.allowElement, r = e.children || "", i = e.className, o = e.components, s = e.disallowedElements, a = e.rehypePlugins || m8, u = e.remarkPlugins || m8, c = e.remarkRehypeOptions ? { ...e.remarkRehypeOptions, ...g8 } : g8, d = e.skipHtml, f = e.unwrapDisallowed, h = e.urlTransform || Pet, m = vet().use(sZe).use(u).use(tet, c).use(a), v = new sG();
  typeof r == "string" && (v.value = r);
  for (const S of Aet)
    Object.hasOwn(e, S.from) && ("" + S.from + (S.to ? "use `" + S.to + "` instead" : "remove it") + Eet + S.id, void 0);
  const x = m.parse(v);
  let C = m.runSync(x, v);
  return i && (C = {
    type: "element",
    tagName: "div",
    properties: { className: i },
    // Assume no doctypes.
    children: (
      /** @type {Array<ElementContent>} */
      C.type === "root" ? C.children : [C]
    )
  }), iG(C, E), LJe(C, {
    Fragment: P.Fragment,
    components: o,
    ignoreInvalidStyle: !0,
    jsx: P.jsx,
    jsxs: P.jsxs,
    passKeys: !0,
    passNode: !0
  });
  function E(S, w, O) {
    if (S.type === "raw" && O && typeof w == "number")
      return d ? O.children.splice(w, 1) : O.children[w] = { type: "text", value: S.value }, w;
    if (S.type === "element") {
      let A;
      for (A in uw)
        if (Object.hasOwn(uw, A) && Object.hasOwn(S.properties, A)) {
          const I = S.properties[A], $ = uw[A];
          ($ === null || $.includes(S.tagName)) && (S.properties[A] = h(String(I || ""), A, S));
        }
    }
    if (S.type === "element") {
      let A = t ? !t.includes(S.tagName) : s ? s.includes(S.tagName) : !1;
      if (!A && n && typeof w == "number" && (A = !n(S, w, O)), A && O && typeof w == "number")
        return f && S.children ? O.children.splice(w, 1, ...S.children) : O.children.splice(w, 1), w;
    }
  }
}
function Pet(e) {
  const t = e.indexOf(":"), n = e.indexOf("?"), r = e.indexOf("#"), i = e.indexOf("/");
  return (
    // If there is no protocol, it’s relative.
    t < 0 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    i > -1 && t > i || n > -1 && t > n || r > -1 && t > r || // It is a protocol, it should be allowed.
    Tet.test(e.slice(0, t)) ? e : ""
  );
}
const ket = (e) => {
  const { uischema: t, visible: n } = e;
  return n ? /* @__PURE__ */ P.jsx(Ar, { sx: { padding: "0 0 1rem 0" }, children: /* @__PURE__ */ P.jsx(wet, { children: t.content }) }) : /* @__PURE__ */ P.jsx(P.Fragment, {});
}, Oet = wl(ket), Iet = (e) => {
  var X, j, U;
  const {
    config: t,
    id: n,
    schema: r,
    visible: i,
    errors: o,
    description: s,
    label: a,
    required: u,
    path: c,
    options: d,
    data: f,
    addItem: h,
    handleChange: m,
    removeItem: v,
    ...x
  } = e, [C, E] = Et(!1), [S, w, O] = ha(), A = o.length === 0, I = vo.merge({}, t, x.uischema.options), $ = !Do(
    i,
    s,
    S,
    I.showUnfocusedDescription
  ), { compactEnabled: L } = Gi();
  let B = !1;
  const H = (X = x.uischema.options) == null ? void 0 : X.singleColumn;
  d && d.length > 2 && !H && (B = !0);
  const q = ((j = x.uischema.options) == null ? void 0 : j.singleRow) && ((U = x.uischema.options) == null ? void 0 : U.singleColumn) !== !0, J = () => {
    if (q)
      return {
        display: "grid",
        gridTemplateColumns: { xs: "repeat(1, 1fr)", md: "repeat(3, 1fr)", lg: "repeat(6, 1fr)" }
      };
    if (B)
      return L ? { display: "block", columns: { xs: 1, md: 2, lg: 4 } } : { display: "block", columns: { xs: 1, md: 2, lg: 3 } };
  };
  return rn(() => {
    const G = setTimeout(() => {
      if (f && d && !C) {
        const K = [];
        Array.isArray(f) && f.forEach((ee) => {
          d == null || d.forEach((te) => {
            const M = `${te.value}`.toLowerCase(), Z = `${ee}`.toLowerCase();
            (te.value === ee || M === Z) && K.push(te.value);
          });
        }), m(c, K), E(!0);
      }
    }, 100);
    return () => {
      clearTimeout(G);
    };
  }, [C, f, d, m, c]), e.visible ? /* @__PURE__ */ P.jsxs(hi, { component: "fieldset", fullWidth: !I.trim, onFocus: w, onBlur: O, children: [
    /* @__PURE__ */ P.jsx(
      fa,
      {
        error: !A,
        component: "legend",
        required: da(u || !1, I.hideRequiredAsterisk),
        sx: { marginBottom: L ? "0.375em" : void 0 },
        children: a
      }
    ),
    /* @__PURE__ */ P.jsx(Ar, { sx: J(), children: d == null ? void 0 : d.map((G, K) => {
      const ee = Xm.compose(c, `${K}`), te = f != null && f.includes(G.value) ? G.value : void 0;
      return /* @__PURE__ */ P.jsx(Ar, { sx: { marginBottom: L ? "0.375em" : void 0 }, children: /* @__PURE__ */ P.jsx(
        Ps,
        {
          id: n + "-label-" + G.value,
          control: /* @__PURE__ */ DD(
            gg,
            {
              ...x,
              id: n + "-" + G.value,
              key: "checkbox-" + G.value,
              isValid: vo.isEmpty(o),
              path: ee,
              handleChange: (M, Z) => {
                if (Z)
                  return h(c, G.value);
                if (v)
                  return v(c, G.value);
              },
              data: te,
              errors: o,
              schema: r,
              visible: i
            }
          ),
          label: G.label
        }
      ) }, G.value);
    }) }),
    /* @__PURE__ */ P.jsx(gn, { sx: { marginBottom: L ? "0" : void 0 }, error: !A, children: A ? $ ? s : null : o }),
    /* @__PURE__ */ P.jsx(gn, {})
  ] }) : /* @__PURE__ */ P.jsx(P.Fragment, {});
}, Fet = bE(Iet), $et = (e) => {
  var U, G, K, ee, te;
  const [t, n] = Et(!1), [r, i, o] = ha(), {
    config: s,
    label: a,
    required: u,
    description: c,
    errors: d,
    data: f,
    visible: h,
    options: m,
    handleChange: v,
    path: x,
    enabled: C,
    uischema: E
  } = e, S = d.length === 0, w = qn({}, s, E.options), O = !Do(
    h,
    c,
    r,
    w.showUnfocusedDescription
  ), { condition: A } = E, { core: I } = So(), $ = (U = E == null ? void 0 : E.options) == null ? void 0 : U.boldWord, { compactEnabled: L } = Gi(), B = () => {
    if (!$) return a;
    const M = a.split(new RegExp(`(${$})`, "gi"));
    return /* @__PURE__ */ P.jsx(P.Fragment, { children: M.map(
      (Z, ne) => Z.toLowerCase() === $.toLowerCase() ? /* @__PURE__ */ P.jsx("strong", { style: { fontWeight: "bold" }, children: Z }, ne) : Z
    ) });
  };
  if (rn(() => {
    if (A && I) {
      const M = bg(I.data, A.scope);
      let Z = !1;
      A.operator === "EQUALS" && M === A.checkValue && (Z = !0), A.operator === "NOT EQUALS" && M !== A.checkValue && (Z = !0), Z && A.setValue !== f && v(x, A.setValue);
    }
  }), rn(() => {
    const M = setTimeout(() => {
      if (f && m && !t) {
        let Z = !1;
        m == null || m.forEach((ne) => {
          if (!Z) {
            const R = `${ne.value}`.toLowerCase(), _ = `${f}`.toLowerCase();
            ne.value === f ? Z = !0 : R === _ && (Z = !0, v(x, ne.value));
          }
        }), Z || v(x, void 0), n(!0);
      }
    }, 100);
    return () => {
      clearTimeout(M);
    };
  }, [t, f, m, x, v]), !h)
    return null;
  let H = !1;
  const q = (G = E.options) == null ? void 0 : G.singleColumn;
  m && m.length > 2 && !q && (H = !0);
  const J = ((K = E.options) == null ? void 0 : K.singleRow) && ((ee = E.options) == null ? void 0 : ee.singleColumn) !== !0, X = ((te = E.options) == null ? void 0 : te.optionsColumn) || 0, j = () => {
    if (J)
      return {
        display: "grid",
        gridGap: L ? "0.25em" : void 0,
        gridTemplateColumns: { xs: "repeat(1, 1fr)", md: "repeat(3, 1fr)", lg: "repeat(6, 1fr)" }
      };
    if (H)
      return X ? { display: "block", columns: X } : L ? { display: "block", columns: { xs: 1, md: 2, lg: 4 } } : { display: "block", columns: { xs: 1, md: 2, lg: 3 } };
  };
  return e.visible ? /* @__PURE__ */ P.jsxs(hi, { component: "fieldset", fullWidth: !w.trim, onFocus: i, onBlur: o, children: [
    /* @__PURE__ */ P.jsx(
      fa,
      {
        error: !S,
        component: "legend",
        required: da(u || !1, w.hideRequiredAsterisk),
        sx: { marginBottom: L ? "0.375em" : void 0 },
        children: B()
      }
    ),
    /* @__PURE__ */ P.jsx(PF, { value: e.data ?? "", sx: j(), children: m == null ? void 0 : m.map((M) => /* @__PURE__ */ P.jsx(Ar, { sx: { marginBottom: L ? "0.375em" : void 0 }, children: /* @__PURE__ */ P.jsx(
      Ps,
      {
        value: M.value,
        control: /* @__PURE__ */ P.jsx(wF, { checked: f === M.value, onChange: () => v(x, M.value) }),
        label: M.label,
        disabled: !C
      }
    ) }, M.label)) }),
    /* @__PURE__ */ P.jsx(gn, { sx: { marginTop: L ? "0" : void 0 }, error: !S, children: S ? O ? c : null : d }),
    /* @__PURE__ */ P.jsx(gn, {})
  ] }) : /* @__PURE__ */ P.jsx(P.Fragment, {});
}, Net = Mb($et);
var Met = { BASE_URL: "/", DEV: !1, MODE: "production", PROD: !0, SSR: !1, VITE_CODES_API: "https://mc.production-insights.restoreskills.com", VITE_CODES_API_SECURITY_CODE: "b14104be5ab736a008d7833e3139ba177a062ba36bb0bf06d9bb7a412abb920e" };
const Ret = "https://mc.production-insights.restoreskills.com", _et = "b14104be5ab736a008d7833e3139ba177a062ba36bb0bf06d9bb7a412abb920e", Let = localStorage.getItem("realm") || Met.REALM_OVERRIDE, Bet = async (e, t) => {
  if (!e.length)
    return [];
  const n = `${Ret}/cpt/?search=${e}`, r = t ? 2 : 1;
  return fetch(n, {
    method: "GET",
    headers: {
      "X-Realm-Name": Let,
      "X-Restore-Id": _et
    }
  }).then((i) => {
    if (i.status === 200)
      return i.json().then((o) => o.items.map((s) => ({ code: Object.values(s)[0], description: Object.values(s)[r] })));
    throw Error(`Error getting CPT codes: ${i.status}`);
  }).catch((i) => {
    throw Error(`Error getting CPT codes: ${i}`);
  });
};
var jet = { BASE_URL: "/", DEV: !1, MODE: "production", PROD: !0, SSR: !1, VITE_CODES_API: "https://mc.production-insights.restoreskills.com", VITE_CODES_API_SECURITY_CODE: "b14104be5ab736a008d7833e3139ba177a062ba36bb0bf06d9bb7a412abb920e" };
const Vet = "https://mc.production-insights.restoreskills.com", zet = "b14104be5ab736a008d7833e3139ba177a062ba36bb0bf06d9bb7a412abb920e", Uet = localStorage.getItem("realm") || jet.REALM_OVERRIDE, Wet = async (e, t) => {
  if (!e.length)
    return [];
  const n = `${Vet}/icd10/?search=${e}`, r = t ? 2 : 1;
  return fetch(n, {
    method: "GET",
    headers: {
      "X-Realm-Name": Uet,
      "X-Restore-Id": zet
    }
  }).then((i) => {
    if (i.status === 200)
      return i.json().then((o) => o.items.map((s) => ({ code: Object.values(s)[0], description: Object.values(s)[r] })));
    throw Error(`Error getting ICD10 codes: ${i.status}`);
  }).catch((i) => {
    throw Error(`Error getting ICD10 codes: ${i}`);
  });
}, xm = {
  searchIcd10: Wet,
  searchCpt: Bet
}, mv = async (e, t, n) => {
  let r;
  t === "ICD10" ? r = xm.searchIcd10 : r = xm.searchCpt;
  const i = e.map((u) => {
    const c = u.replace(" (Group)", "");
    return { original: u, cleaned: c };
  }), o = i.map(({ cleaned: u }) => u).join(","), s = await r(o, n), a = [];
  return i.forEach(({ original: u, cleaned: c }) => {
    if (u !== "undefined") {
      let d = !1;
      const f = {};
      f.code = u, s.forEach((h) => {
        Object.values(h)[0] === c && (d = !0, f.value = Object.values(h)[1]);
      }), d || (f.value = ""), f.code && f.code.trim() !== "" && f.code !== "undefined" && a.push(f);
    }
  }), a;
}, aG = BC(void 0), Dg = () => {
  const e = Rm(aG);
  if (!e)
    throw new Error("useAdditionalErrorContext must be used within an AdditionalErrorProvider");
  return e;
}, Het = ({ children: e }) => {
  const [t, n] = Et([]), r = (o) => {
    n((s) => {
      const a = s.some((c) => c.instancePath === o.instancePath && c.message === o.message), u = s.filter((c) => c.instancePath !== o.instancePath);
      return a ? s : [...u, o];
    });
  }, i = (o) => {
    n((s) => s.filter((a) => a.instancePath !== o));
  };
  return /* @__PURE__ */ P.jsx(aG.Provider, { value: { additionalErrors: t, addAdditionalError: r, removeAdditionalError: i }, children: e });
}, qet = (e) => {
  var ye, be, Re;
  const t = Tf(), { config: n, data: r, errors: i, handleChange: o, id: s, label: a, path: u, required: c, uischema: d } = e, f = vo.merge({}, n, d.options), [h, m] = Et(""), [v, x] = Et([]), [C, E] = Et(!1), [S, w] = Et(!!(r != null && r.length)), O = d.enablePrimarySelector || !1, A = ou(), I = ou(), $ = So(), { addAdditionalError: L, removeAdditionalError: B } = Dg(), H = (ye = e.uischema.options) == null ? void 0 : ye.readonly, q = `/${u.replaceAll(".", "/")}`, J = (Re = (be = $.core) == null ? void 0 : be.errors) == null ? void 0 : Re.filter((Te) => Te.instancePath.includes(q));
  let X = !1, j = !1;
  const U = rs(null), G = rs(null), K = rs(null);
  J == null || J.forEach((Te) => {
    Te.params.missingProperty === "primary" && (X = !0), Te.params.missingProperty === "onsetDate" && (j = !0);
  }), rn(() => {
    let Te = null, Xe = null;
    X ? Te = {
      instancePath: q,
      message: "requires a primary code to be selected",
      schemaPath: "",
      keyword: "",
      params: {}
    } : Te = null, j ? Xe = {
      instancePath: q,
      message: "requires all codes to have onset dates",
      schemaPath: "",
      keyword: "",
      params: {}
    } : Xe = null;
    const Ne = setTimeout(() => {
      var Ee;
      Te ? (L(Te), U.current = Te) : (U.current && B((Ee = U.current) == null ? void 0 : Ee.instancePath), U.current = null);
    }, 100), Qe = setTimeout(() => {
      var Ee;
      Xe ? (L(Xe), G.current = Xe) : (G.current && B((Ee = G.current) == null ? void 0 : Ee.instancePath), G.current = null);
    }, 100);
    return () => {
      clearTimeout(Ne), clearTimeout(Qe);
    };
  }, [X, j, L, q, B]);
  const ee = i.length === 0 && (J == null ? void 0 : J.length) === 0, te = () => {
    x([]), m("");
  }, M = f.dateFormat ?? "YYYY-MM-DD", Z = f.dateSaveFormat ?? lI, ne = r || [], R = () => ne.map((Te) => ({
    ...Te,
    primary: void 0
  })), _ = (Te, Xe) => {
    if (H) return;
    let Ne = R();
    Te.target.checked && (Ne = ne.map((Qe) => ({
      ...Qe,
      primary: Qe.code === Xe && Te.target.checked
    }))), o(u, Ne);
  }, [W, Q] = Et([]), oe = (Te, Xe) => {
    if (!H) {
      if ((Te == null ? void 0 : Te.toString()) === "Invalid Date" && Q((Ne) => [...Ne, Xe]), !Te)
        o(u, void 0);
      else if (Te.toString() !== "Invalid Date") {
        Q((Qe) => Qe.filter((Ee) => Ee !== Xe));
        const Ne = ne.map((Qe) => ({
          ...Qe,
          onsetDate: Qe.code === Xe ? J0(Te, Z) : Qe.onsetDate
        }));
        o(u, Ne);
      }
    }
  };
  rn(() => {
    let Te = null;
    W.length !== 0 ? Te = {
      instancePath: q,
      message: "requires all codes to have valid onset date",
      schemaPath: "",
      keyword: "",
      params: {}
    } : Te = null;
    const Xe = setTimeout(() => {
      var Ne;
      Te ? (L(Te), K.current = Te) : (K.current && B((Ne = K.current) == null ? void 0 : Ne.instancePath), K.current = null);
    }, 100);
    return () => {
      clearTimeout(Xe);
    };
  }, [W, L, q, B]);
  const ae = (Te) => {
    if (H) return;
    const Xe = Te.currentTarget.value;
    m(Te.currentTarget.value), xm.searchIcd10(Xe).then((Ne) => {
      const Qe = Ne.filter((Ee) => !ne.some((Ie) => Ie.code === Ee.code));
      x(Qe);
    });
  }, pe = (Te) => {
    H || (S || w(!0), ne.some((Xe) => Xe.code === Te.code) || (o(u, [
      ...ne,
      {
        code: Te.code,
        description: Te.description
      }
    ]), te()));
  }, me = (Te) => {
    if (H) return;
    const Xe = ne.filter((Ne) => Ne.code !== Te);
    o(u, Xe);
  }, xe = ne.map((Te) => /* @__PURE__ */ P.jsxs(_o, { children: [
    /* @__PURE__ */ P.jsx(hn, { size: "small", children: /* @__PURE__ */ P.jsx(Or, { size: "small", "aria-label": "delete", onClick: () => me(Te.code), children: !H && /* @__PURE__ */ P.jsx(vc, {}) }) }),
    /* @__PURE__ */ P.jsx(hn, { size: "small", children: Te.code }),
    /* @__PURE__ */ P.jsx(hn, { size: "small", children: Te.description || "" }),
    O && /* @__PURE__ */ P.jsx(hn, { size: "small", children: /* @__PURE__ */ P.jsx(
      rc,
      {
        size: "small",
        checked: Te.primary || !1,
        disabled: H,
        onChange: H ? void 0 : (Xe) => _(Xe, Te.code)
      }
    ) }),
    /* @__PURE__ */ P.jsx(hn, { size: "small", children: /* @__PURE__ */ P.jsx(Od, { dateAdapter: pv, children: /* @__PURE__ */ P.jsx(
      ZE,
      {
        slotProps: {
          textField: {
            size: "small",
            variant: "outlined"
          }
        },
        format: M,
        disabled: H,
        defaultValue: Te.onsetDate ? Bi(`${Te.onsetDate}`) : null,
        onChange: H ? void 0 : (Xe) => oe(Xe, Te.code)
      }
    ) }) })
  ] }, `${s}-s-${Te.code}`)), le = v.map((Te) => /* @__PURE__ */ P.jsx(
    ks,
    {
      onClick: () => pe(Te),
      role: "button",
      sx: { overflowX: "hidden" },
      children: /* @__PURE__ */ P.jsxs(hf, { title: `${Te.code}: ${Te.description}`, children: [
        Te.code,
        ": ",
        Te.description
      ] })
    },
    `${s}-ac-${Te.code}}`
  ));
  return rn(() => {
    if (ne.length && !C) {
      const Te = [];
      if (ne.forEach((Xe) => {
        Xe.description || Te.push(Xe.code);
      }), Te.length <= 0)
        return;
      mv(Te, "ICD10").then((Xe) => {
        let Ne = 0;
        const Qe = ne.map((Ee) => {
          if (Te.includes(Ee.code)) {
            Ne++;
            const Ie = Xe.filter((Je) => Object.values(Je)[0] === Ee.code);
            return {
              ...Ee,
              description: Object.values(Ie[0])[1]
            };
          }
          return {
            ...Ee
          };
        });
        Ne > 0 && o(u, Qe), E(!0);
      });
    }
  }), rn(() => {
    if (O) {
      const Te = r || [];
      let Xe = 0, Ne = 0;
      if (Te.forEach((Qe) => {
        typeof Qe.primary > "u" && Ne++, Qe.primary === !0 && Xe++;
      }), Xe > 0 && Ne > 0) {
        const Qe = Te.map((Ee) => ({
          ...Ee,
          primary: Ee.primary || !1
        }));
        o(u, Qe);
      }
    }
  }, [r, O, o, u]), rn(() => {
    const Te = (Ne) => {
      Ne.key === "Escape" && te();
    }, Xe = (Ne) => {
      A.current && !A.current.contains(Ne.target) && I.current && !I.current.contains(Ne.target) && le && le.length > 0 && te();
    };
    return document.addEventListener("keyup", Te), document.addEventListener("mouseup", Xe), () => {
      document.removeEventListener("keyup", Te), document.removeEventListener("mouseup", Xe);
    };
  }), e.visible ? /* @__PURE__ */ P.jsxs(
    ti,
    {
      sx: {
        margin: "1rem 0",
        border: 0
      },
      component: "fieldset",
      children: [
        /* @__PURE__ */ P.jsx(
          fa,
          {
            component: "legend",
            required: da(c || !1, f.hideRequiredAsterisk),
            error: !ee,
            children: a
          }
        ),
        /* @__PURE__ */ P.jsxs(hi, { fullWidth: !f.trim, id: s, sx: { position: "relative" }, children: [
          !H && /* @__PURE__ */ P.jsxs(P.Fragment, { children: [
            /* @__PURE__ */ P.jsx(ra, { htmlFor: `${s}-search`, variant: t, children: "Type code or description to search by" }),
            /* @__PURE__ */ P.jsx(Su, { id: `${s}-search`, value: h, onChange: ae, ref: A })
          ] }),
          v && /* @__PURE__ */ P.jsx(ti, { sx: { position: "absolute", top: "100%", zIndex: "2" }, ref: I, children: /* @__PURE__ */ P.jsx(Pd, { dense: !0, children: le }) })
        ] }),
        /* @__PURE__ */ P.jsx(
          dg,
          {
            component: ti,
            sx: {
              marginTop: H ? "0" : "1rem",
              maxHeight: 500,
              overflowY: "scroll",
              zIndex: 1,
              border: ee ? "1px solid transparent" : `1px solid ${Ua.main}`,
              boxShadow: ee ? "" : `${Ua.main} 0 0 0 2px`
            },
            children: /* @__PURE__ */ P.jsxs(gf, { size: "small", children: [
              /* @__PURE__ */ P.jsx(bf, { children: /* @__PURE__ */ P.jsxs(_o, { children: [
                /* @__PURE__ */ P.jsx(hn, {}),
                /* @__PURE__ */ P.jsx(hn, { children: "Code" }),
                /* @__PURE__ */ P.jsx(hn, { children: "Description" }),
                O && /* @__PURE__ */ P.jsx(hn, { children: "Primary" }),
                /* @__PURE__ */ P.jsx(hn, { children: "Onset Date" })
              ] }) }),
              /* @__PURE__ */ P.jsx(yf, { children: xe })
            ] })
          }
        ),
        /* @__PURE__ */ P.jsx(gn, { error: !ee, children: ee ? null : i })
      ]
    }
  ) : /* @__PURE__ */ P.jsx(P.Fragment, {});
}, Get = li(qet), Yet = (e) => {
  var ee;
  const t = Tf(), { config: n, data: r, errors: i, handleChange: o, id: s, label: a, path: u, required: c, uischema: d } = e, f = vo.merge({}, n, d.options), [h, m] = Et(""), [v, x] = Et([]), [C, E] = Et(!!(r != null && r.length)), [S, w] = Et(!1), O = vn(() => r || [], [r]), A = d.enablePrimarySelector || !1, I = ou(), $ = ou(), L = (ee = e.uischema.options) == null ? void 0 : ee.readonly, B = f.dateFormat ?? "YYYY-MM-DD", H = f.dateSaveFormat ?? lI, q = (te) => {
    if (L) return;
    const M = te.currentTarget.value;
    m(M), xm.searchIcd10(M).then((Z) => {
      const ne = Z.filter((R) => !O.some((_) => _.icdCode === R.code));
      x(ne);
    });
  }, J = (te, M) => {
    if (!L) {
      if (!te)
        o(u, void 0);
      else if (te.toString() !== "Invalid Date") {
        const Z = O.map((ne) => ({
          ...ne,
          icdCodeDate: ne.icdCode === M ? J0(te, H) : ne.icdCodeDate
        }));
        o(u, Z);
      }
    }
  }, X = (te) => {
    if (!L && (C || E(!0), !O.some((M) => M.icdCode === te.code))) {
      const M = {
        icdCode: te.code,
        icdCodeType: A ? "MEDICAL" : "TREATMENT",
        icdCodeDate: J0(Bi(), H),
        description: te.description
      };
      o(u, [...O, M]), x([]), m("");
    }
  }, j = (te) => {
    if (L) return;
    const M = O.filter((Z) => Z.icdCode !== te);
    o(u, M);
  }, U = (te, M) => {
    if (L) return;
    const Z = O.map((ne) => ({
      ...ne,
      icdCode: ne.icdCode === M ? te.target.checked ? `${ne.icdCode.split(" ")[0]} (Primary)` : ne.icdCode.split(" ")[0] : ne.icdCode
    }));
    o(u, Z);
  }, G = O.map((te) => {
    const M = te.icdCode.includes("(Primary)"), Z = te.icdCode.split(" ")[0];
    return /* @__PURE__ */ P.jsxs(_o, { children: [
      /* @__PURE__ */ P.jsx(hn, { size: "small", children: /* @__PURE__ */ P.jsx(Or, { size: "small", "aria-label": "delete", onClick: () => j(te.icdCode), children: !L && /* @__PURE__ */ P.jsx(vc, {}) }) }),
      /* @__PURE__ */ P.jsx(hn, { size: "small", children: Z }),
      /* @__PURE__ */ P.jsx(hn, { size: "small", children: te.description || "" }),
      A && /* @__PURE__ */ P.jsx(hn, { size: "small", children: /* @__PURE__ */ P.jsx(
        rc,
        {
          size: "small",
          checked: M,
          disabled: L,
          onChange: (ne) => U(ne, te.icdCode)
        }
      ) }),
      /* @__PURE__ */ P.jsx(hn, { size: "small", children: /* @__PURE__ */ P.jsx(Od, { dateAdapter: pv, children: /* @__PURE__ */ P.jsx(
        ZE,
        {
          slotProps: {
            textField: {
              size: "small",
              variant: "outlined"
            }
          },
          format: B,
          disabled: L,
          defaultValue: te.icdCodeDate ? Bi(te.icdCodeDate) : null,
          onChange: (ne) => J(ne, te.icdCode)
        }
      ) }) })
    ] }, `${s}-s-${te.icdCode}`);
  }), K = v.map((te) => /* @__PURE__ */ P.jsx(
    ks,
    {
      onClick: () => X(te),
      role: "button",
      sx: { overflow: "hidden" },
      children: /* @__PURE__ */ P.jsxs(hf, { title: `${te.code}: ${te.description}`, children: [
        te.code,
        ": ",
        te.description
      ] })
    },
    `${s}-ac-${te.code}`
  ));
  return rn(() => {
    if (O.length && !S) {
      const te = O.filter((M) => !M.description).map((M) => M.icdCode.split(" ")[0]);
      if (te.length === 0)
        return;
      mv(te, "ICD10").then((M) => {
        let Z = 0;
        const ne = O.map((R) => {
          const _ = R.icdCode.split(" ")[0];
          if (te.includes(_)) {
            Z++;
            const W = M.find((Q) => Object.values(Q)[0] === _);
            return {
              ...R,
              description: W ? Object.values(W)[1] : void 0
            };
          }
          return R;
        });
        Z > 0 && o(u, ne), w(!0);
      });
    }
  }, [O, S, o, u]), e.visible ? /* @__PURE__ */ P.jsxs(ti, { sx: { margin: "1rem 0", border: 0 }, component: "fieldset", children: [
    /* @__PURE__ */ P.jsx(
      fa,
      {
        component: "legend",
        required: da(c || !1, f.hideRequiredAsterisk),
        error: i.length > 0,
        children: a
      }
    ),
    /* @__PURE__ */ P.jsxs(hi, { fullWidth: !f.trim, id: s, sx: { position: "relative" }, children: [
      !L && /* @__PURE__ */ P.jsxs(P.Fragment, { children: [
        /* @__PURE__ */ P.jsx(ra, { htmlFor: `${s}-search`, variant: t, children: "Type code to search" }),
        /* @__PURE__ */ P.jsx(Su, { id: `${s}-search`, value: h, onChange: q, ref: I })
      ] }),
      v.length > 0 && /* @__PURE__ */ P.jsx(ti, { sx: { position: "absolute", top: "100%", zIndex: "2" }, ref: $, children: /* @__PURE__ */ P.jsx(Pd, { dense: !0, children: K }) })
    ] }),
    /* @__PURE__ */ P.jsx(
      dg,
      {
        component: ti,
        sx: {
          marginTop: L ? "0" : "1rem",
          maxHeight: 500,
          overflowY: "scroll",
          border: i.length > 0 ? `1px solid ${Ua.main}` : "1px solid transparent"
        },
        children: /* @__PURE__ */ P.jsxs(gf, { size: "small", children: [
          /* @__PURE__ */ P.jsx(bf, { children: /* @__PURE__ */ P.jsxs(_o, { children: [
            /* @__PURE__ */ P.jsx(hn, {}),
            /* @__PURE__ */ P.jsx(hn, { children: "Code" }),
            /* @__PURE__ */ P.jsx(hn, { children: "Description" }),
            A && /* @__PURE__ */ P.jsx(hn, { children: "Primary" }),
            /* @__PURE__ */ P.jsx(hn, { children: "Onset Date" })
          ] }) }),
          /* @__PURE__ */ P.jsx(yf, { children: G })
        ] })
      }
    ),
    /* @__PURE__ */ P.jsx(gn, { error: i.length > 0, children: i })
  ] }) : null;
}, Ket = li(Yet), fk = {
  PT: ["97161", "97162", "97163", "HH-PT-EVAL"],
  OT: ["97165", "97166", "97167", "HH-OT-EVAL"],
  SLP: ["92521", "92522", "92523", "92524", "92610", "HH-ST-EVAL"]
}, y8 = [
  {
    code: "97110",
    description: "Therapeutic Exercise"
  },
  {
    code: "97112",
    description: "Neuromuscular Re-education"
  },
  {
    code: "97116",
    description: "Gait Training"
  },
  {
    code: "97150",
    description: "Group Treatment"
  },
  {
    code: "97530",
    description: "Therapeutic Activity"
  },
  {
    code: "97763",
    description: "Orthotic Management/Training"
  },
  {
    code: "97140",
    description: "Manual Therapy"
  },
  {
    code: "97161",
    description: "PT Eval Low Complexity"
  },
  {
    code: "97162",
    description: "PT Eval Moderate Complexity"
  },
  {
    code: "97163",
    description: "PT Eval High Complexity"
  }
], Jet = [
  {
    code: "97110",
    description: "Therapeutic Exercise"
  },
  {
    code: "97112",
    description: "Neuromuscular Re-education"
  },
  {
    code: "97150",
    description: "Group Treatment"
  },
  {
    code: "97530",
    description: "Therapeutic Activity"
  },
  {
    code: "97535",
    description: "Self-Care/Home Management"
  },
  {
    code: "97542",
    description: "Wheelchair Management"
  },
  {
    code: "97763",
    description: "Orthotic Management/Training"
  },
  {
    code: "97165",
    description: "OT Eval Low Complexity"
  },
  {
    code: "97166",
    description: "OT Eval Moderate Complexity"
  },
  {
    code: "97167",
    description: "OT Eval High Complexity"
  }
], Xet = [
  {
    code: "92521",
    description: "Fluency Evaluation"
  },
  {
    code: "92522",
    description: "Speech Sound Production Evaluation"
  },
  {
    code: "92523",
    description: "Speech and Language Comprehensive Evaluation"
  },
  {
    code: "92524",
    description: "Voice and Resonance Evaluation"
  },
  {
    code: "92610",
    description: "Swallowing Evaluation"
  },
  {
    code: "92611",
    description: "Motion Fluoroscopy Swallowing Evaluation"
  },
  {
    code: "92612",
    description: "Flexible Endoscopic Swallowing Evaluation"
  },
  {
    code: "96105",
    description: "Aphasia Assessment"
  },
  {
    code: "96125",
    description: "Cognitive Testing"
  },
  {
    code: "92597",
    description: "Voice Prosthetic Fitting Evaluation"
  },
  {
    code: "92607",
    description: "AAC Device Evaluation"
  },
  {
    code: "92608",
    description: "AAC Add-on (30 mins)"
  },
  {
    code: "92609",
    description: "AAC Therapy"
  },
  {
    code: "92507",
    description: "Individual SLP Therapy"
  },
  {
    code: "92508",
    description: "Group SLP Therapy (2+)"
  },
  {
    code: "92526",
    description: "Swallowing Therapy"
  },
  {
    code: "97129",
    description: "Cognitive Evaluation (15 min)"
  },
  {
    code: "97130",
    description: "Cognitive Add-on (15 min)"
  },
  {
    code: "97150",
    description: "General Group Therapy (2+)"
  },
  {
    code: "97533",
    description: "Sensory Integration Therapy"
  }
], Qet = [
  {
    code: "92521",
    description: "EVALUATION OF SPEECH FLUENCY (EG, STUTTERING, CLUTTERING)"
  },
  {
    code: "92522",
    description: "EVALUATE SPEECH PRODUCTION"
  },
  {
    code: "92523",
    description: "EVALUATION OF SPEECH SOUND PRODUCTION (EG, ARTICULATION, PHONOLOGICAL PROCESS, APRAXIA, DYSARTHRIA); WITH EVALUATION OF LANGUAGE COMPREHENSION AND EXPRESSION (EG, RECEPTIVE AND EXPRESSIVE LANGUAGE)"
  },
  {
    code: "92524",
    description: "BEHAVIORAL AND QUALITATIVE ANALYSIS OF VOICE AND RESONANCE"
  },
  {
    code: "92610",
    description: "EVALUATION OF ORAL AND PHARYNGEAL SWALLOWING FUNCTION"
  },
  {
    code: "92611",
    description: "MOTION FLUOROSCOPIC EVALUATION OF SWALLOWING FUNCTION BY CINE OR VIDEO RECORDING"
  },
  {
    code: "92612",
    description: "FLEXIBLE ENDOSCOPIC EVALUATION OF SWALLOWING BY CINE OR VIDEO RECORDING"
  },
  {
    code: "96105",
    description: "ASSESSMENT OF APHASIA (INCLUDES ASSESSMENT OF EXPRESSIVE AND RECEPTIVE SPEECH AND LANGUAGE FUNCTION, LANGUAGE COMPREHENSION, SPEECH PRODUCTION ABILITY, READING, SPELLING, WRITING, EG, BY BOSTON DIAGNOSTIC APHASIA EXAMINATION) WITH INTERPRETATION AND REPORT, PER HOUR"
  },
  {
    code: "96125",
    description: "STANDARDIZED COGNITIVE PERFORMANCE TESTING (EG, ROSS INFORMATION PROCESSING ASSESSMENT) PER HOUR OF A QUALIFIED HEALTH CARE PROFESSIONAL'S TIME, BOTH FACE-TO-FACE TIME ADMINISTERING TESTS TO THE PATIENT AND TIME INTERPRETING THESE TEST RESULTS AND PREPARING THE REPORT"
  },
  {
    code: "92597",
    description: "EVALUATION FOR USE AND/OR FITTING OF VOICE PROSTHETIC DEVICE TO SUPPLEMENT ORAL SPEECH"
  },
  {
    code: "92607",
    description: "EVALUATION FOR PRESCRIPTION FOR SPEECH-GENERATING AUGMENTATIVE AND ALTERNATIVE COMMUNICATION DEVICE, FACE-TO-FACE WITH THE PATIENT; FIRST HOUR"
  },
  {
    code: "92608",
    description: "EVALUATION FOR PRESCRIPTION FOR SPEECH-GENERATING AUGMENTATIVE AND ALTERNATIVE COMMUNICATION DEVICE, FACE-TO-FACE WITH THE PATIENT; EACH ADDITIONAL 30 MINUTES (LIST SEPARATELY IN ADDITION TO CODE FOR PRIMARY PROCEDURE)"
  },
  {
    code: "92609",
    description: "THERAPEUTIC SERVICES FOR THE USE OF SPEECH-GENERATING DEVICE, INCLUDING PROGRAMMING AND MODIFICATION"
  },
  {
    code: "92507",
    description: "TREATMENT OF SPEECH, LANGUAGE, VOICE, COMMUNICATION, AND/OR AUDITORY PROCESSING DISORDER; INDIVIDUAL"
  },
  {
    code: "92508",
    description: "TREATMENT OF SPEECH, LANGUAGE, VOICE, COMMUNICATION, AND/OR AUDITORY PROCESSING DISORDER; GROUP, 2 OR MORE INDIVIDUALS"
  },
  {
    code: "92526",
    description: "TREATMENT OF SWALLOWING DYSFUNCTION AND/OR ORAL FUNCTION FOR FEEDING"
  },
  {
    code: "97129",
    description: "THERAPEUTIC INTERVENTIONS THAT FOCUS ON COGNITIVE FUNCTION (EG, ATTENTION, MEMORY, REASONING, EXECUTIVE FUNCTION, PROBLEM SOLVING, AND/OR PRAGMATIC FUNCTIONING) AND COMPENSATORY STRATEGIES TO MANAGE THE PERFORMANCE OF AN ACTIVITY (EG, MANAGING TIME OR SCHEDULES, INITIATING, ORGANIZING, AND SEQUENCING TASKS), DIRECT (ONE-ON-ONE) PATIENT CONTACT; INITIAL 15 MINUTES"
  },
  {
    code: "97130",
    description: "THERAPEUTIC INTERVENTIONS THAT FOCUS ON COGNITIVE FUNCTION (EG, ATTENTION, MEMORY, REASONING, EXECUTIVE FUNCTION, PROBLEM SOLVING, AND/OR PRAGMATIC FUNCTIONING) AND COMPENSATORY STRATEGIES TO MANAGE THE PERFORMANCE OF AN ACTIVITY (EG, MANAGING TIME OR SCHEDULES, INITIATING, ORGANIZING, AND SEQUENCING TASKS), DIRECT (ONE-ON-ONE) PATIENT CONTACT; EACH ADDITIONAL 15 MINUTES (LIST SEPARATELY IN ADDITION TO CODE FOR PRIMARY PROCEDURE)"
  },
  {
    code: "97150",
    description: "THERAPEUTIC PROCEDURE(S), GROUP (2 OR MORE INDIVIDUALS)"
  },
  {
    code: "97533",
    description: "SENSORY INTEGRATIVE TECHNIQUES TO ENHANCE SENSORY PROCESSING AND PROMOTE ADAPTIVE RESPONSES TO ENVIRONMENTAL DEMANDS, DIRECT (ONE-ON-ONE) PATIENT CONTACT, EACH 15 MINUTES"
  }
], Zet = [
  {
    code: "97110",
    description: "THERAPEUTIC PROCEDURE, 1 OR MORE AREAS, EACH 15 MINUTES; THERAPEUTIC EXERCISES TO DEVELOP STRENGTH AND ENDURANCE, RANGE OF MOTION AND FLEXIBILITY"
  },
  {
    code: "97112",
    description: "THERAPEUTIC PROCEDURE, 1 OR MORE AREAS, EACH 15 MINUTES; NEUROMUSCULAR REEDUCATION OF MOVEMENT, BALANCE, COORDINATION, KINESTHETIC SENSE, POSTURE, AND/OR PROPRIOCEPTION FOR SITTING AND/OR STANDING ACTIVITIES"
  },
  {
    code: "97150",
    description: "THERAPEUTIC PROCEDURE(S), GROUP (2 OR MORE INDIVIDUALS"
  },
  {
    code: "97530",
    description: "THERAPEUTIC ACTIVITIES, DIRECT (ONE-ON-ONE) PATIENT CONTACT (USE OF DYNAMIC ACTIVITIES TO IMPROVE FUNCTIONAL PERFORMANCE), EACH 15 MINUTES"
  },
  {
    code: "97535",
    description: "SELF-CARE/HOME MANAGEMENT TRAINING (EG, ACTIVITIES OF DAILY LIVING (ADL) AND COMPENSATORY TRAINING, MEAL PREPARATION, SAFETY PROCEDURES, AND INSTRUCTIONS IN USE OF ASSISTIVE TECHNOLOGY DEVICES/ADAPTIVE EQUIPMENT) DIRECT ONE-ON-ONE CONTACT, EACH 15 MINUTES"
  },
  {
    code: "97542",
    description: "WHEELCHAIR MANAGEMENT (EG, ASSESSMENT, FITTING, TRAINING), EACH 15 MINUTES"
  },
  {
    code: "97763",
    description: "ORTHOTIC(S)/PROSTHETIC(S) MANAGEMENT AND/OR TRAINING, UPPER EXTREMITY(IES), LOWER EXTREMITY(IES), AND/OR TRUNK, SUBSEQUENT ORTHOTIC(S)/PROSTHETIC(S) ENCOUNTER, EACH 15 MINUTES"
  },
  {
    code: "97165",
    description: "OCCUPATIONAL THERAPY EVALUATION, LOW COMPLEXITY, REQUIRING THESE COMPONENTS: AN OCCUPATIONAL PROFILE AND MEDICAL AND THERAPY HISTORY, WHICH INCLUDES A BRIEF HISTORY INCLUDING REVIEW OF MEDICAL AND/OR THERAPY RECORDS RELATING TO THE PRESENTING PROBLEM; AN ASSESSMENT(S) THAT IDENTIFIES 1-3 PERFORMANCE DEFICITS (IE, RELATING TO PHYSICAL, COGNITIVE, OR PSYCHOSOCIAL SKILLS) THAT RESULT IN ACTIVITY LIMITATIONS AND/OR PARTICIPATION RESTRICTIONS; AND CLINICAL DECISION MAKING OF LOW COMPLEXITY, WHICH INCLUDES AN ANALYSIS OF THE OCCUPATIONAL PROFILE, ANALYSIS OF DATA FROM PROBLEM-FOCUSED ASSESSMENT(S), AND CONSIDERATION OF A LIMITED NUMBER OF TREATMENT OPTIONS. PATIENT PRESENTS WITH NO COMORBIDITIES THAT AFFECT OCCUPATIONAL PERFORMANCE. MODIFICATION OF TASKS OR ASSISTANCE (EG, PHYSICAL OR VERBAL) WITH ASSESSMENT(S) IS NOT NECESSARY TO ENABLE COMPLETION OF EVALUATION COMPONENT. TYPICALLY, 30 MINUTES ARE SPENT FACE-TO-FACE WITH THE PATIENT AND/OR FAMILY."
  },
  {
    code: "97166",
    description: "OCCUPATIONAL THERAPY EVALUATION, MODERATE COMPLEXITY, REQUIRING THESE COMPONENTS: AN OCCUPATIONAL PROFILE AND MEDICAL AND THERAPY HISTORY, WHICH INCLUDES AN EXPANDED REVIEW OF MEDICAL AND/OR THERAPY RECORDS AND ADDITIONAL REVIEW OF PHYSICAL, COGNITIVE, OR PSYCHOSOCIAL HISTORY RELATED TO CURRENT FUNCTIONAL PERFORMANCE; AN ASSESSMENT(S) THAT IDENTIFIES 3-5 PERFORMANCE DEFICITS (IE, RELATING TO PHYSICAL, COGNITIVE, OR PSYCHOSOCIAL SKILLS) THAT RESULT IN ACTIVITY LIMITATIONS AND/OR PARTICIPATION RESTRICTIONS; AND CLINICAL DECISION MAKING OF MODERATE ANALYTIC COMPLEXITY, WHICH INCLUDES AN ANALYSIS OF THE OCCUPATIONAL PROFILE, ANALYSIS OF DATA FROM DETAILED ASSESSMENT(S), AND CONSIDERATION OF SEVERAL TREATMENT OPTIONS. PATIENT MAY PRESENT WITH COMORBIDITIES THAT AFFECT OCCUPATIONAL PERFORMANCE. MINIMAL TO MODERATE MODIFICATION OF TASKS OR ASSISTANCE (EG, PHYSICAL OR VERBAL) WITH ASSESSMENT(S) IS NECESSARY TO ENABLE PATIENT TO COMPLETE EVALUATION COMPONENT. TYPICALLY, 45 MINUTES ARE SPENT FACE-TO-FACE WITH THE PATIENT AND/OR FAMILY."
  },
  {
    code: "97167",
    description: "OCCUPATIONAL THERAPY EVALUATION, HIGH COMPLEXITY, REQUIRING THESE COMPONENTS: AN OCCUPATIONAL PROFILE AND MEDICAL AND THERAPY HISTORY, WHICH INCLUDES REVIEW OF MEDICAL AND/OR THERAPY RECORDS AND EXTENSIVE ADDITIONAL REVIEW OF PHYSICAL, COGNITIVE, OR PSYCHOSOCIAL HISTORY RELATED TO CURRENT FUNCTIONAL PERFORMANCE; AN ASSESSMENT(S) THAT IDENTIFIES 5 OR MORE PERFORMANCE DEFICITS (IE, RELATING TO PHYSICAL, COGNITIVE, OR PSYCHOSOCIAL SKILLS) THAT RESULT IN ACTIVITY LIMITATIONS AND/OR PARTICIPATION RESTRICTIONS; AND CLINICAL DECISION MAKING OF HIGH ANALYTIC COMPLEXITY, WHICH INCLUDES AN ANALYSIS OF THE PATIENT PROFILE, ANALYSIS OF DATA FROM COMPREHENSIVE ASSESSMENT(S), AND CONSIDERATION OF MULTIPLE TREATMENT OPTIONS. PATIENT PRESENTS WITH COMORBIDITIES THAT AFFECT OCCUPATIONAL PERFORMANCE. SIGNIFICANT MODIFICATION OF TASKS OR ASSISTANCE (EG, PHYSICAL OR VERBAL) WITH ASSESSMENT(S) IS NECESSARY TO ENABLE PATIENT TO COMPLETE EVALUATION COMPONENT. TYPICALLY, 60 MINUTES ARE SPENT FACE-TO-FACE WITH THE PATIENT AND/OR FAMILY."
  }
], ett = [
  {
    code: "97110",
    description: "THERAPEUTIC PROCEDURE, 1 OR MORE AREAS, EACH 15 MINUTES; THERAPEUTIC EXERCISES TO DEVELOP STRENGTH AND ENDURANCE, RANGE OF MOTION AND FLEXIBILITY"
  },
  {
    code: "97112",
    description: "THERAPEUTIC PROCEDURE, 1 OR MORE AREAS, EACH 15 MINUTES; NEUROMUSCULAR REEDUCATION OF MOVEMENT, BALANCE, COORDINATION, KINESTHETIC SENSE, POSTURE, AND/OR PROPRIOCEPTION FOR SITTING AND/OR STANDING ACTIVITIES"
  },
  {
    code: "97116",
    description: "THERAPEUTIC PROCEDURE, 1 OR MORE AREAS, EACH 15 MINUTES; GAIT TRAINING (INCLUDES STAIR CLIMBING)"
  },
  {
    code: "97150",
    description: "THERAPEUTIC PROCEDURE(S), GROUP (2 OR MORE INDIVIDUALS"
  },
  {
    code: "97530",
    description: "THERAPEUTIC ACTIVITIES, DIRECT (ONE-ON-ONE) PATIENT CONTACT (USE OF DYNAMIC ACTIVITIES TO IMPROVE FUNCTIONAL PERFORMANCE), EACH 15 MINUTE"
  },
  {
    code: "97763",
    description: "ORTHOTIC(S)/PROSTHETIC(S) MANAGEMENT AND/OR TRAINING, UPPER EXTREMITY(IES), LOWER EXTREMITY(IES), AND/OR TRUNK, SUBSEQUENT ORTHOTIC(S)/PROSTHETIC(S) ENCOUNTER, EACH 15 MINUTES"
  },
  {
    code: "97140",
    description: "MANUAL THERAPY TECHNIQUES (EG, MOBILIZATION/ MANIPULATION, MANUAL LYMPHATIC DRAINAGE, MANUAL TRACTION), 1 OR MORE REGIONS, EACH 15 MINUTES"
  },
  {
    code: "97161",
    description: "PHYSICAL THERAPY EVALUATION: LOW COMPLEXITY, REQUIRING THESE COMPONENTS: A HISTORY WITH NO PERSONAL FACTORS AND/OR COMORBIDITIES THAT IMPACT THE PLAN OF CARE; AN EXAMINATION OF BODY SYSTEM(S) USING STANDARDIZED TESTS AND MEASURES ADDRESSING 1-2 ELEMENTS FROM ANY OF THE FOLLOWING: BODY STRUCTURES AND FUNCTIONS, ACTIVITY LIMITATIONS, AND/OR PARTICIPATION RESTRICTIONS; A CLINICAL PRESENTATION WITH STABLE AND/OR UNCOMPLICATED CHARACTERISTICS; AND CLINICAL DECISION MAKING OF LOW COMPLEXITY USING STANDARDIZED PATIENT ASSESSMENT INSTRUMENT AND/OR MEASURABLE ASSESSMENT OF FUNCTIONAL OUTCOME. TYPICALLY, 20 MINUTES ARE SPENT FACE-TO-FACE WITH THE PATIENT AND/OR FAMILY."
  },
  {
    code: "97162",
    description: "PHYSICAL THERAPY EVALUATION: MODERATE COMPLEXITY, REQUIRING THESE COMPONENTS: A HISTORY OF PRESENT PROBLEM WITH 1-2 PERSONAL FACTORS AND/OR COMORBIDITIES THAT IMPACT THE PLAN OF CARE; AN EXAMINATION OF BODY SYSTEMS USING STANDARDIZED TESTS AND MEASURES IN ADDRESSING A TOTAL OF 3 OR MORE ELEMENTS FROM ANY OF THE FOLLOWING: BODY STRUCTURES AND FUNCTIONS, ACTIVITY LIMITATIONS, AND/OR PARTICIPATION RESTRICTIONS; AN EVOLVING CLINICAL PRESENTATION WITH CHANGING CHARACTERISTICS; AND CLINICAL DECISION MAKING OF MODERATE COMPLEXITY USING STANDARDIZED PATIENT ASSESSMENT INSTRUMENT AND/OR MEASURABLE ASSESSMENT OF FUNCTIONAL OUTCOME. TYPICALLY, 30 MINUTES ARE SPENT FACE-TO-FACE WITH THE PATIENT AND/OR FAMILY."
  },
  {
    code: "97163",
    description: "PHYSICAL THERAPY EVALUATION: HIGH COMPLEXITY, REQUIRING THESE COMPONENTS: A HISTORY OF PRESENT PROBLEM WITH 3 OR MORE PERSONAL FACTORS AND/OR COMORBIDITIES THAT IMPACT THE PLAN OF CARE; AN EXAMINATION OF BODY SYSTEMS USING STANDARDIZED TESTS AND MEASURES ADDRESSING A TOTAL OF 4 OR MORE ELEMENTS FROM ANY OF THE FOLLOWING: BODY STRUCTURES AND FUNCTIONS, ACTIVITY LIMITATIONS, AND/OR PARTICIPATION RESTRICTIONS; A CLINICAL PRESENTATION WITH UNSTABLE AND UNPREDICTABLE CHARACTERISTICS; AND CLINICAL DECISION MAKING OF HIGH COMPLEXITY USING STANDARDIZED PATIENT ASSESSMENT INSTRUMENT AND/OR MEASURABLE ASSESSMENT OF FUNCTIONAL OUTCOME. TYPICALLY, 45 MINUTES ARE SPENT FACE-TO-FACE WITH THE PATIENT AND/OR FAMILY."
  }
], lG = (e) => {
  switch (e) {
    case "OT":
      return Jet;
    case "PT":
      return y8;
    case "SLP":
      return Xet;
    default:
      return y8;
  }
}, uG = (e, t) => {
  switch (e) {
    case "OT":
      return Zet.find((n) => n.code == t.code);
    case "PT":
      return ett.find((n) => n.code == t.code);
    case "SLP":
      return Qet.find((n) => n.code == t.code);
    default:
      return t;
  }
}, ttt = (e) => {
  var pe, me, xe;
  const t = Tf(), { config: n, data: r, errors: i, handleChange: o, id: s, label: a, path: u, required: c, uischema: d } = e, f = vo.merge({}, n, d.options), h = i.length === 0, [m, v] = Et(""), [x, C] = Et([]), [E, S] = Et(!!(r != null && r.length)), w = ou(), O = ou(), A = ou(), [I, $] = Et(!1), [L, B] = Et(!1), H = vn(() => r || [], [r]), q = d.discipline || "PT", J = ((pe = d == null ? void 0 : d.options) == null ? void 0 : pe.validationPath) || "", { addAdditionalError: X, removeAdditionalError: j } = Dg(), U = So(), G = bg((me = U.core) == null ? void 0 : me.data, J) || "", K = (xe = e.uischema.options) == null ? void 0 : xe.readonly, ee = Cn(() => {
    var le;
    return u ? `/${(le = u == null ? void 0 : u.split(".")) == null ? void 0 : le.join("/")}` : "";
  }, [u]), te = () => {
    C([]), v("");
  }, M = (le) => {
    if (K) return;
    const ye = le.currentTarget.value;
    v(ye);
  };
  rn(() => {
    if (!m) return;
    let le = null;
    return le = setTimeout(() => {
      xm.searchCpt(m).then((ye) => {
        const be = ye.filter((Re) => !H.some((Te) => Te.code === Re.code));
        C(be), $(!0);
      });
    }, 2500), () => {
      le && clearTimeout(le);
    };
  }, [m, H]);
  const Z = rs(null), ne = Cn(() => {
    const le = H == null ? void 0 : H.filter(
      (be) => {
        var Re;
        return (Re = fk[q]) == null ? void 0 : Re.includes(be.code);
      }
    ), ye = H == null ? void 0 : H.filter(
      (be) => {
        var Re;
        return !((Re = fk[q]) != null && Re.includes(be.code));
      }
    );
    return {
      atLeastOneEval: le.length !== 0,
      atLeastOneNonEvalCode: ye.length !== 0
    };
  }, [H, q]);
  rn(() => {
    var be, Re;
    if (H.length === 0 || (be = d == null ? void 0 : d.options) != null && be.noRestriction) return;
    let le = null;
    ne().atLeastOneEval ? G === ((Re = d == null ? void 0 : d.options) == null ? void 0 : Re.value) && (!ne().atLeastOneEval || !ne().atLeastOneNonEvalCode) ? le = {
      instancePath: ee(),
      message: `Please select at least one ${q} eval code and one non eval code`,
      schemaPath: "",
      keyword: "",
      params: {}
    } : le = null : le = {
      instancePath: ee(),
      message: `Please select at least one ${q} eval code`,
      schemaPath: "",
      keyword: "",
      params: {}
    };
    const ye = setTimeout(() => {
      le ? (X(le), Z.current = le) : (Z.current && j(Z.current.instancePath), Z.current = null);
    }, 100);
    return () => {
      clearTimeout(ye);
    };
  }, [
    H,
    q,
    X,
    j,
    d,
    G,
    ne,
    ee
  ]);
  const R = (le) => {
    if (!K && (E || S(!0), !H.some((ye) => ye.code === le.code))) {
      I || (le = uG(q, le));
      const ye = [
        ...H,
        {
          code: le.code,
          description: le.description
        }
      ];
      o(u, ye), te();
    }
  }, _ = (le) => {
    if (K) return;
    const ye = H.filter((be) => be.code !== le);
    o(u, ye);
  }, W = () => {
    K || (C(lG(q)), $(!1));
  }, Q = H.map((le) => /* @__PURE__ */ P.jsxs(_o, { children: [
    /* @__PURE__ */ P.jsx(hn, { size: "small", children: /* @__PURE__ */ P.jsx(Or, { size: "small", "aria-label": "delete", onClick: () => _(le.code), children: !K && /* @__PURE__ */ P.jsx(vc, {}) }) }),
    /* @__PURE__ */ P.jsx(hn, { size: "small", children: le.code }),
    /* @__PURE__ */ P.jsx(hn, { size: "small", children: le.description || "" })
  ] }, `${s}-s-${le.code}`)), oe = (le) => {
    try {
      return !!(r && r.length > 0 && r.find((be) => be.code === le));
    } catch {
      return !1;
    }
  }, ae = x.map((le) => /* @__PURE__ */ P.jsx(
    ks,
    {
      disabled: !!oe(le.code),
      onClick: K ? void 0 : () => R(le),
      role: "button",
      sx: { overflowX: "hidden" },
      children: /* @__PURE__ */ P.jsxs(hf, { title: `${le.code}: ${le.description}`, children: [
        le.code,
        ": ",
        le.description
      ] })
    },
    `${s}-ac-${le.code}}`
  ));
  return rn(() => {
    if (H.length && !L) {
      const le = [];
      if (H.forEach((ye) => {
        ye.description || le.push(ye.code);
      }), le.length <= 0)
        return;
      mv(le, "CPT").then((ye) => {
        let be = 0;
        const Re = H.map((Te) => {
          if (le.includes(Te.code)) {
            be++;
            const Xe = ye.filter((Ne) => Object.values(Ne)[0] === Te.code);
            return {
              ...Te,
              description: Object.values(Xe[0])[1]
            };
          }
          return {
            ...Te
          };
        });
        be > 0 && o(u, Re), B(!0);
      });
    }
  }, [H, o, u, L]), rn(() => {
    const le = (be) => {
      be.key === "Escape" && te();
    }, ye = (be) => {
      w.current && !w.current.contains(be.target) && O.current && !O.current.contains(be.target) && A.current && !A.current.contains(be.target) && ae && ae.length > 0 && te();
    };
    return document.addEventListener("keyup", le), document.addEventListener("mouseup", ye), () => {
      document.removeEventListener("keyup", le), document.removeEventListener("mouseup", ye);
    };
  }), e.visible ? /* @__PURE__ */ P.jsxs(
    ti,
    {
      sx: {
        margin: "1rem 0",
        border: 0
      },
      component: "fieldset",
      children: [
        /* @__PURE__ */ P.jsx(
          fa,
          {
            component: "legend",
            required: K ? !1 : da(c || !1, f.hideRequiredAsterisk),
            error: !h,
            children: a
          }
        ),
        /* @__PURE__ */ P.jsxs(hi, { fullWidth: !f.trim, id: s, sx: { position: "relative" }, children: [
          !K && /* @__PURE__ */ P.jsxs(P.Fragment, { children: [
            /* @__PURE__ */ P.jsx(ra, { htmlFor: `${s}-search`, variant: t, ref: O, children: "Type code or description to search by" }),
            /* @__PURE__ */ P.jsx(
              Su,
              {
                id: `${s}-search`,
                value: m,
                onFocusCapture: K ? void 0 : W,
                onChange: K ? void 0 : M,
                ref: w
              }
            )
          ] }),
          x && /* @__PURE__ */ P.jsx(
            ti,
            {
              sx: {
                position: "absolute",
                top: "100%",
                zIndex: "2",
                overflowY: "auto",
                height: "auto",
                maxHeight: "15rem",
                width: "auto",
                maxWidth: "100%"
              },
              ref: A,
              children: /* @__PURE__ */ P.jsx(Pd, { dense: !0, children: ae })
            }
          )
        ] }),
        /* @__PURE__ */ P.jsx(
          dg,
          {
            component: ti,
            sx: {
              marginTop: K ? "0" : "1rem",
              maxHeight: 500,
              overflowY: "scroll",
              zIndex: 1,
              border: h ? "1px solid transparent" : `1px solid ${Ua.main}`,
              boxShadow: h ? "" : `${Ua.main} 0 0 0 2px`
            },
            children: /* @__PURE__ */ P.jsxs(gf, { size: "small", children: [
              /* @__PURE__ */ P.jsx(bf, { children: /* @__PURE__ */ P.jsxs(_o, { children: [
                /* @__PURE__ */ P.jsx(hn, {}),
                /* @__PURE__ */ P.jsx(hn, { children: "Code" }),
                /* @__PURE__ */ P.jsx(hn, { children: "Description" })
              ] }) }),
              /* @__PURE__ */ P.jsx(yf, { children: Q })
            ] })
          }
        ),
        /* @__PURE__ */ P.jsx(gn, { error: !h, children: h ? null : i })
      ]
    }
  ) : /* @__PURE__ */ P.jsx(P.Fragment, {});
}, ntt = li(ttt), rtt = (e) => {
  var _;
  const t = Tf(), { config: n, data: r, errors: i, handleChange: o, id: s, label: a, path: u, required: c, uischema: d } = e, f = vo.merge({}, n, d.options), h = i.length === 0, [m, v] = Et(""), [x, C] = Et([]), [E, S] = Et(!!(r != null && r.length)), w = ou(), O = ou(), A = ou(), [I, $] = Et(!1), [L, B] = Et(!1), H = vn(() => r ? Array.isArray(r) ? r.length === 0 ? [] : typeof r[0] == "string" ? r.map((W) => ({ code: W, description: void 0 })) : r : [] : [], [r]), q = d.discipline || "PT", { addAdditionalError: J, removeAdditionalError: X } = Dg(), j = (_ = e.uischema.options) == null ? void 0 : _.readonly, U = () => {
    C([]), v("");
  }, G = (W) => {
    if (j) return;
    const Q = W.currentTarget.value;
    v(Q);
  };
  rn(() => {
    if (!m) return;
    let W = null;
    return W = setTimeout(() => {
      xm.searchCpt(m).then((Q) => {
        const oe = Q.filter((ae) => !H.some((pe) => pe.code === ae.code));
        C(oe), $(!0);
      });
    }, 2500), () => {
      W && clearTimeout(W);
    };
  }, [m, H]);
  const K = rs(null);
  rn(() => {
    var ae;
    if (H.length === 0 || (ae = d == null ? void 0 : d.options) != null && ae.noRestriction) return;
    let W = null;
    H.filter(
      (pe) => fk[q].includes(pe.code)
    ).length === 0 ? W = {
      instancePath: "/otherData/cptCodes",
      message: `Please select at least one ${q} eval code`,
      schemaPath: "",
      keyword: "",
      params: {}
    } : W = null;
    const oe = setTimeout(() => {
      W ? (J(W), K.current = W) : (K.current && X(K.current.instancePath), K.current = null);
    }, 100);
    return () => {
      clearTimeout(oe);
    };
  }, [H, q, J, X, d]);
  const ee = (W) => {
    if (!j && (E || S(!0), !H.some((Q) => Q.code === W.code))) {
      I || (W = uG(q, W));
      const Q = [
        ...H,
        {
          code: W.code,
          description: W.description
        }
      ];
      o(u, Q), U();
    }
  }, te = (W) => {
    if (j) return;
    const Q = H.filter((oe) => oe.code !== W);
    o(u, Q);
  }, M = () => {
    j || (C(lG(q)), $(!1));
  }, Z = H.map((W) => /* @__PURE__ */ P.jsxs(_o, { children: [
    /* @__PURE__ */ P.jsx(hn, { size: "small", children: /* @__PURE__ */ P.jsx(Or, { size: "small", "aria-label": "delete", onClick: () => te(W.code), children: !j && /* @__PURE__ */ P.jsx(vc, {}) }) }),
    /* @__PURE__ */ P.jsx(hn, { size: "small", children: W.code }),
    /* @__PURE__ */ P.jsx(hn, { size: "small", children: W.description || "" })
  ] }, `${s}-s-${W.code}`)), ne = (W) => {
    try {
      return !!(r && r.length > 0 && r.find((oe) => oe.code === W));
    } catch {
      return !1;
    }
  }, R = x.map((W) => /* @__PURE__ */ P.jsx(
    ks,
    {
      disabled: !!ne(W.code),
      onClick: j ? void 0 : () => ee(W),
      role: "button",
      sx: { overflowX: "hidden" },
      children: /* @__PURE__ */ P.jsxs(hf, { title: `${W.code}: ${W.description}`, children: [
        W.code,
        ": ",
        W.description
      ] })
    },
    `${s}-ac-${W.code}}`
  ));
  return rn(() => {
    if (H.length && !L) {
      const W = [];
      if (H.forEach((Q) => {
        Q.description || W.push(Q.code);
      }), W.length <= 0)
        return;
      mv(W, "CPT").then((Q) => {
        let oe = 0;
        const ae = H.map((pe) => {
          if (W.includes(pe.code)) {
            oe++;
            const me = Q.filter((xe) => Object.values(xe)[0] === pe.code);
            return {
              ...pe,
              description: Object.values(me[0])[1]
            };
          }
          return {
            ...pe
          };
        });
        oe > 0 && o(u, ae), B(!0);
      });
    }
  }, [H, o, u, L]), rn(() => {
    const W = (oe) => {
      oe.key === "Escape" && U();
    }, Q = (oe) => {
      w.current && !w.current.contains(oe.target) && O.current && !O.current.contains(oe.target) && A.current && !A.current.contains(oe.target) && R && R.length > 0 && U();
    };
    return document.addEventListener("keyup", W), document.addEventListener("mouseup", Q), () => {
      document.removeEventListener("keyup", W), document.removeEventListener("mouseup", Q);
    };
  }), e.visible ? /* @__PURE__ */ P.jsxs(
    ti,
    {
      sx: {
        margin: "1rem 0",
        border: 0
      },
      component: "fieldset",
      children: [
        /* @__PURE__ */ P.jsx(
          fa,
          {
            component: "legend",
            required: j ? !1 : da(c || !1, f.hideRequiredAsterisk),
            error: !h,
            children: a
          }
        ),
        /* @__PURE__ */ P.jsxs(hi, { fullWidth: !f.trim, id: s, sx: { position: "relative" }, children: [
          !j && /* @__PURE__ */ P.jsxs(P.Fragment, { children: [
            /* @__PURE__ */ P.jsx(ra, { htmlFor: `${s}-search`, variant: t, ref: O, children: "Type code or description to search by" }),
            /* @__PURE__ */ P.jsx(
              Su,
              {
                id: `${s}-search`,
                value: m,
                onFocusCapture: j ? void 0 : M,
                onChange: j ? void 0 : G,
                ref: w
              }
            )
          ] }),
          x && /* @__PURE__ */ P.jsx(
            ti,
            {
              sx: {
                position: "absolute",
                top: "100%",
                zIndex: "2",
                overflowY: "auto",
                height: "auto",
                maxHeight: "15rem",
                width: "auto",
                maxWidth: "100%"
              },
              ref: A,
              children: /* @__PURE__ */ P.jsx(Pd, { dense: !0, children: R })
            }
          )
        ] }),
        /* @__PURE__ */ P.jsx(
          dg,
          {
            component: ti,
            sx: {
              marginTop: j ? "0" : "1rem",
              maxHeight: 500,
              overflowY: "scroll",
              zIndex: 1,
              border: h ? "1px solid transparent" : `1px solid ${Ua.main}`,
              boxShadow: h ? "" : `${Ua.main} 0 0 0 2px`
            },
            children: /* @__PURE__ */ P.jsxs(gf, { size: "small", children: [
              /* @__PURE__ */ P.jsx(bf, { children: /* @__PURE__ */ P.jsxs(_o, { children: [
                /* @__PURE__ */ P.jsx(hn, {}),
                /* @__PURE__ */ P.jsx(hn, { children: "Code" }),
                /* @__PURE__ */ P.jsx(hn, { children: "Description" })
              ] }) }),
              /* @__PURE__ */ P.jsx(yf, { children: Z })
            ] })
          }
        ),
        /* @__PURE__ */ P.jsx(gn, { error: !h, children: h ? null : i })
      ]
    }
  ) : /* @__PURE__ */ P.jsx(P.Fragment, {});
}, itt = li(rtt), { MaterialEnumControl: ott } = m$, stt = (e) => {
  const { targetScope: t, values: n } = e.uischema, r = So();
  let i = [];
  if (!e.visible)
    return /* @__PURE__ */ P.jsx(P.Fragment, {});
  if (r.core) {
    const o = bg(r.core.data, t, e.path);
    o && n[o] ? i = n[o].map((a) => ({ label: a, value: a })) : (o === "" || o === null) && n[""] ? i = n[""].map((a) => ({ label: a, value: a })) : o && n["*"] && (i = n["*"].map((a) => ({ label: a, value: a })));
  }
  return /* @__PURE__ */ P.jsx(ott, { ...e, label: e.label, options: i });
}, att = Mb(Ka(k6(stt)), !1), ltt = Gt(1e3, dn("AutofilledDate")), { MaterialDateControl: utt } = m$, ctt = (e) => {
  const { copyFrom: t, offset: n } = e.uischema, r = So();
  rn(() => {
    if (!e.data && r.core) {
      let o = bg(r.core.data, t);
      if (o) {
        if (n) {
          const { days: s, months: a, years: u } = n, c = new Date(o);
          s && c.setDate(c.getDate() + s), a && c.setMonth(c.getMonth() + a), u && c.setFullYear(c.getFullYear() + u);
          const d = String(c.getDate() + 1).padStart(2, "0"), f = String(c.getMonth() + 1).padStart(2, "0");
          o = `${c.getFullYear() + (u || 0)}-${f}-${d}`;
        }
        e.handleChange(e.path, o);
      }
    }
  }, [t, r.core, e, n]);
  const i = (o, s) => {
    e.handleChange(o, s);
  };
  return e.visible ? /* @__PURE__ */ P.jsx(utt, { ...e, data: e.data, handleChange: i, label: e.label }) : /* @__PURE__ */ P.jsx(P.Fragment, {});
}, dtt = li(ctt), ptt = Gt(1e3, dn("Spacer")), ftt = (e) => {
  const { visible: t } = e;
  return t ? /* @__PURE__ */ P.jsx(Ar, {}) : /* @__PURE__ */ P.jsx(P.Fragment, {});
}, htt = wl(ftt), mtt = Gt(1e3, dn("CheckboxNone")), gtt = ({
  config: e,
  id: t,
  schema: n,
  visible: r,
  errors: i,
  description: o,
  label: s,
  required: a,
  path: u,
  options: c,
  data: d,
  addItem: f,
  enabled: h,
  removeItem: m,
  handleChange: v,
  ...x
}) => {
  const [C, E, S] = ha(), [w, O] = Et(d === "none"), [A, I] = Et([]), $ = i.length === 0, L = qn({}, e, x.uischema.options), B = !Do(
    r,
    o,
    C,
    L.showUnfocusedDescription
  ), H = (J) => {
    J ? (I(d), v(u, ["None"])) : v(u, A), O(J);
  };
  if (!r)
    return null;
  let q = h;
  return w && (q = !1), /* @__PURE__ */ P.jsxs(hi, { component: "fieldset", fullWidth: !L.trim, onFocus: E, onBlur: S, children: [
    /* @__PURE__ */ P.jsx(
      fa,
      {
        error: !$,
        component: "legend",
        required: da(a || !1, L.hideRequiredAsterisk),
        children: s
      }
    ),
    /* @__PURE__ */ P.jsx(rv, { row: !0, children: c == null ? void 0 : c.map((J, X) => {
      const j = Xm.compose(u, `${X}`), U = d != null && d.includes(J.value) ? J.value : void 0;
      return /* @__PURE__ */ P.jsx(
        Ps,
        {
          id: t + "-label-" + J.value,
          control: /* @__PURE__ */ P.jsx(
            gg,
            {
              enabled: q,
              id: t + "-" + J.value,
              isValid: xn(i),
              path: j,
              handleChange: (G, K) => K ? f(u, J.value) : m ? m(u, J.value) : () => {
              },
              data: U,
              errors: i,
              schema: n,
              visible: r,
              ...x
            },
            "checkbox-" + J.value
          ),
          label: J.label
        },
        J.value
      );
    }) }),
    /* @__PURE__ */ P.jsx(Ar, { children: /* @__PURE__ */ P.jsx(
      Ps,
      {
        id: t + "-label-none",
        control: /* @__PURE__ */ P.jsx(
          rc,
          {
            id: t + "-none",
            checked: w,
            onChange: (J, X) => H(X),
            disabled: !h
          }
        ),
        label: "None of the above"
      }
    ) }),
    /* @__PURE__ */ P.jsx(gn, { error: !$, children: $ ? B ? o : null : i })
  ] });
}, ytt = bE(gtt), btt = Gt(1e3, dn("CheckboxOther")), vtt = (e) => {
  var G;
  const {
    config: t,
    id: n,
    schema: r,
    visible: i,
    handleChange: o,
    errors: s,
    description: a,
    label: u,
    required: c,
    path: d,
    options: f,
    data: h,
    ...m
  } = e, v = (f == null ? void 0 : f.map((K) => K.value)) || [], x = h.filter((K) => v.includes(K)), C = h.filter((K) => !v.includes(K)) || "", [E, S] = Et(`${C}`), [w, O] = Et(x), [A, I, $] = ha(), L = s.length === 0, B = vo.merge({}, t, m.uischema.options), H = Tf(), q = !Do(
    i,
    a,
    A,
    B.showUnfocusedDescription
  );
  let J = !1;
  const X = (G = m.uischema.options) == null ? void 0 : G.singleColumn;
  f && f.length > 2 && !X && (J = !0);
  const j = (K) => {
    S(K.currentTarget.value);
  }, U = (K, ee) => {
    const te = parseInt(K.split(".").pop() || ""), M = f == null ? void 0 : f[te].value;
    if (M)
      if (ee) {
        const Z = [...w, M];
        O(Z);
      } else {
        const Z = w.filter((ne) => ne !== M);
        O(Z);
      }
  };
  return rn(() => {
    if (w.length > 0 || E.length > 0) {
      const K = [...w, E];
      o(d, K);
    } else
      o(d, void 0);
  }, [w, E, o, d]), e.visible ? /* @__PURE__ */ P.jsxs(
    Ar,
    {
      sx: {
        margin: "1rem 0",
        border: 0
      },
      children: [
        /* @__PURE__ */ P.jsxs(hi, { component: "fieldset", fullWidth: !B.trim, onFocus: I, onBlur: $, children: [
          /* @__PURE__ */ P.jsx(
            fa,
            {
              error: !L,
              component: "legend",
              required: da(c || !1, B.hideRequiredAsterisk),
              children: u
            }
          ),
          /* @__PURE__ */ P.jsx(Ar, { sx: J ? { columns: { xs: 1, md: 2, lg: 3 } } : {}, children: f == null ? void 0 : f.map((K, ee) => {
            const te = Xm.compose(d, `${ee}`), M = w != null && w.includes(K.value) ? K.value : void 0;
            return /* @__PURE__ */ P.jsx("div", { children: /* @__PURE__ */ P.jsx(
              Ps,
              {
                id: n + "-label-" + K.value,
                control: /* @__PURE__ */ DD(
                  gg,
                  {
                    ...m,
                    id: n + "-" + K.value,
                    key: "checkbox-" + K.value,
                    isValid: vo.isEmpty(s),
                    path: te,
                    handleChange: (Z, ne) => {
                      U(Z, ne);
                    },
                    data: M,
                    errors: s,
                    schema: r,
                    visible: i
                  }
                ),
                label: K.label
              }
            ) }, K.value);
          }) })
        ] }),
        /* @__PURE__ */ P.jsxs(hi, { fullWidth: !B.trim, onFocus: I, onBlur: $, children: [
          /* @__PURE__ */ P.jsx(ra, { htmlFor: `${n}-other`, variant: H, children: "Other" }),
          /* @__PURE__ */ P.jsx(Su, { id: `${n}-other`, value: E, onChange: j })
        ] }),
        /* @__PURE__ */ P.jsx(gn, { error: !L, children: L ? q ? a : null : s })
      ]
    }
  ) : /* @__PURE__ */ P.jsx(P.Fragment, {});
}, xtt = bE(vtt), Dtt = Gt(1e3, pr(dn("ListWithDetail"), II)), Ctt = De(mF)(({ theme: e }) => ({
  color: e.palette.error.main
})), Ett = se.memo(function({
  label: t,
  description: n,
  errors: r,
  addItem: i,
  path: o,
  enabled: s,
  createDefault: a,
  translations: u,
  disableAdd: c
}) {
  return /* @__PURE__ */ P.jsx(pg, { disableGutters: !0, children: /* @__PURE__ */ P.jsxs(nv, { children: [
    /* @__PURE__ */ P.jsxs(en, { container: !0, alignItems: "center", justifyContent: "space-between", children: [
      /* @__PURE__ */ P.jsx(en, { item: !0, children: /* @__PURE__ */ P.jsxs(en, { container: !0, justifyContent: "flex-start", alignItems: "center", spacing: 2, children: [
        /* @__PURE__ */ P.jsx(en, { item: !0, children: /* @__PURE__ */ P.jsx(cn, { variant: "h6", children: t }) }),
        /* @__PURE__ */ P.jsx(en, { item: !0, children: r.length !== 0 && /* @__PURE__ */ P.jsx(en, { item: !0, children: /* @__PURE__ */ P.jsx(Ctt, { children: /* @__PURE__ */ P.jsx(HE, { id: "tooltip-validation" }) }) }) })
      ] }) }),
      s && !c && /* @__PURE__ */ P.jsx(en, { item: !0, children: /* @__PURE__ */ P.jsx(en, { container: !0, children: /* @__PURE__ */ P.jsx(en, { item: !0, children: /* @__PURE__ */ P.jsx(io, { id: "tooltip-add", title: u.addTooltip, placement: "bottom", children: /* @__PURE__ */ P.jsx(
        Or,
        {
          "aria-label": u.addTooltip,
          onClick: i(o, a()),
          size: "large",
          children: /* @__PURE__ */ P.jsx(WE, {})
        }
      ) }) }) }) })
    ] }),
    n && /* @__PURE__ */ P.jsx(gn, { children: n })
  ] }) });
}), Ttt = De(cn)(({ theme: e }) => ({
  fontSize: "0.75rem",
  color: e.palette.primary.main,
  fontWeight: 500,
  marginBottom: -4
})), Stt = ({
  index: e,
  childLabel: t,
  selected: n,
  enabled: r,
  handleSelect: i,
  removeItem: o,
  path: s,
  translations: a,
  disableRemove: u,
  data: c,
  headerField: d
}) => {
  const f = d && c && c[d] ? String(c[d]) : "";
  return /* @__PURE__ */ P.jsxs(UE, { button: !0, selected: n, onClick: i(e), children: [
    /* @__PURE__ */ P.jsx(CF, { children: /* @__PURE__ */ P.jsx(jE, { "aria-label": "Index", children: e + 1 }) }),
    /* @__PURE__ */ P.jsx(
      hf,
      {
        primary: /* @__PURE__ */ P.jsxs(P.Fragment, { children: [
          f && /* @__PURE__ */ P.jsx(Ttt, { children: f }),
          t
        ] })
      }
    ),
    r && !u && /* @__PURE__ */ P.jsx(sv, { children: /* @__PURE__ */ P.jsx(io, { id: "tooltip-remove", title: a.removeTooltip, placement: "bottom", children: /* @__PURE__ */ P.jsx(Or, { "aria-label": a.removeAriaLabel, onClick: o(s, e), size: "large", children: /* @__PURE__ */ P.jsx(vc, {}) }) }) })
  ] });
}, Att = Az(Stt), wtt = (e, t) => [...e].sort((n, r) => {
  const i = n[t], o = r[t];
  return typeof i != "string" ? 1 : typeof o != "string" ? -1 : i.localeCompare(o);
}).map((n) => n.originalIndex ?? 0), Ptt = ({
  uischemas: e,
  schema: t,
  uischema: n,
  path: r,
  enabled: i,
  errors: o,
  visible: s,
  label: a,
  required: u,
  removeItems: c,
  addItem: d,
  data: f,
  renderers: h,
  cells: m,
  config: v,
  rootSchema: x,
  description: C,
  disableAdd: E,
  disableRemove: S,
  translations: w
}) => {
  var Z, ne;
  const O = (R, _) => _.split(".").reduce((Q, oe) => {
    if (Q && typeof Q == "object")
      return Q[oe];
  }, R), A = So(), I = (Z = A.core) != null && Z.data ? O(A.core.data, r) : void 0, [$, L] = Et(void 0), B = Cn((R) => () => L(R), [L]), H = Cn(() => au(t, x), [x, t]), q = vn(
    () => $b(e || [], t, n.scope, r, void 0, n, x),
    [e, t, r, n, x]
  ), J = vn(() => {
    var R, _;
    return typeof ((R = n.options) == null ? void 0 : R.maxItems) == "number" && f >= ((_ = n.options) == null ? void 0 : _.maxItems);
  }, [(ne = n.options) == null ? void 0 : ne.maxItems, f]), X = Cn(
    (R, _) => () => {
      J || (d(R, _)(), L(f));
    },
    [d, f, J]
  ), j = qn({}, v, n.options), U = E || j.disableAdd || J, G = Cn(
    (R) => {
      if (S || j.disableRemove) {
        const W = (Array.isArray(I) ? I : [])[R];
        return !(W && typeof W == "object" && "id" in W && W.id);
      }
      return !0;
    },
    [S, j, I]
  ), K = Cn(
    (R, _) => () => {
      c && G(_) && (c(R, [_])(), $ && $ === _ ? L(void 0) : $ && $ > _ && L($ - 1));
    },
    [c, L, $, G]
  ), ee = j.listHeaderField, te = vn(() => Array.isArray(I) ? I : [], [I]), M = vn(() => !ee || !te.length ? Sb(f) : wtt(
    te.map((R, _) => ({ ...R, originalIndex: _ })),
    ee
  ), [ee, te, f]);
  return se.useEffect(() => {
    f > 0 && $ === void 0 ? L(0) : f === 0 && L(void 0);
  }, [f, $]), s ? /* @__PURE__ */ P.jsxs(P.Fragment, { children: [
    /* @__PURE__ */ P.jsx(
      Ett,
      {
        translations: w,
        label: $I(a, u || !1, j.hideRequiredAsterisk),
        description: C || "",
        errors: o,
        path: r,
        enabled: i,
        addItem: X,
        createDefault: H,
        disableAdd: U
      }
    ),
    /* @__PURE__ */ P.jsxs(en, { container: !0, direction: "row", spacing: 2, children: [
      /* @__PURE__ */ P.jsx(en, { item: !0, xs: 3, children: /* @__PURE__ */ P.jsx(ov, { children: f > 0 ? VF(M, (R) => {
        const _ = te[R], W = _ && j.elementLabelProp ? String(_[j.elementLabelProp]) : `Item ${R + 1}`;
        return /* @__PURE__ */ P.jsx(
          Att,
          {
            index: R,
            path: r,
            schema: t,
            enabled: i,
            handleSelect: B,
            removeItem: K,
            selected: $ === R,
            uischema: q,
            childLabelProp: j.elementLabelProp,
            translations: w,
            disableRemove: !G(R),
            data: _,
            headerField: ee,
            childLabel: W
          },
          R
        );
      }) : /* @__PURE__ */ P.jsx("p", { children: w.noDataMessage }) }) }),
      /* @__PURE__ */ P.jsx(en, { item: !0, xs: !0, children: $ !== void 0 ? /* @__PURE__ */ P.jsx(
        vl,
        {
          renderers: h,
          cells: m,
          visible: s,
          schema: t,
          uischema: q,
          path: pf(r, `${$}`)
        }
      ) : /* @__PURE__ */ P.jsx(cn, { variant: "h6", children: w.noSelection }) })
    ] })
  ] }) : null;
}, ktt = yE(
  Ka(vE(Ptt))
), Ott = ({ uischema: e }) => {
  const { content: t } = e;
  return /* @__PURE__ */ P.jsxs(P.Fragment, { children: [
    t && Object.keys(t).map((n) => /* @__PURE__ */ P.jsx(io, { title: t[n] || "", arrow: !0, placement: "top-start", children: /* @__PURE__ */ P.jsx(Xb, { label: n, variant: "outlined", sx: { marginRight: "8px" } }) })),
    /* @__PURE__ */ P.jsx("br", {}),
    /* @__PURE__ */ P.jsx("br", {})
  ] });
}, Itt = li(Ott), Ftt = Gt(1e3, dn("Tooltip"));
var I$ = {}, $tt = Eu;
Object.defineProperty(I$, "__esModule", {
  value: !0
});
var F$ = I$.default = void 0, Ntt = $tt(kd()), Mtt = P;
F$ = I$.default = (0, Ntt.default)(/* @__PURE__ */ (0, Mtt.jsx)("path", {
  d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Clear");
const Rtt = ({ schema: e, data: t, handleChange: n, path: r }) => {
  var d, f, h;
  const i = e, o = So(), s = i.enum || [], a = ((d = i.options) == null ? void 0 : d.enumDescriptions) || {}, u = (h = (f = o == null ? void 0 : o.core) == null ? void 0 : f.errors) == null ? void 0 : h.find((m) => m.params.missingProperty === r.split(".")[1]), c = () => {
    n(r, void 0);
  };
  return /* @__PURE__ */ P.jsxs(hi, { fullWidth: !0, error: !!u, children: [
    /* @__PURE__ */ P.jsx(ra, { id: `${r}-label`, shrink: !!t || void 0, children: `*${e.title}` }),
    /* @__PURE__ */ P.jsx(
      mf,
      {
        labelId: `${r}-label`,
        value: t || "",
        onChange: (m) => {
          const v = m.target.value;
          n(r, v);
        },
        displayEmpty: !0,
        label: `*${e.title}`,
        input: /* @__PURE__ */ P.jsx(
          Zo,
          {
            notched: !0,
            endAdornment: t ? /* @__PURE__ */ P.jsx(lg, { position: "end", children: /* @__PURE__ */ P.jsx(
              Or,
              {
                onClick: c,
                edge: "end",
                "aria-label": "clear selection",
                size: "small",
                sx: { marginLeft: "-48px" },
                children: /* @__PURE__ */ P.jsx(F$, { sx: { fontSize: "20px" } })
              }
            ) }) : null
          }
        ),
        children: s.map((m) => /* @__PURE__ */ P.jsx(ks, { value: m, children: /* @__PURE__ */ P.jsx(io, { title: a[m] || "", arrow: !0, placement: "right", children: /* @__PURE__ */ P.jsx("span", { style: { display: "block", width: "100%" }, children: m }) }) }, m))
      }
    ),
    u && /* @__PURE__ */ P.jsx(cn, { fontSize: "12px", color: "error", fontWeight: "medium", children: "is a required property" }),
    /* @__PURE__ */ P.jsx("br", {})
  ] });
}, _tt = li(Rtt), b8 = [], Ltt = Gt(1e3, (e) => Mp(e) && e.scope && b8.length !== 0 ? b8.some((t) => e.scope.endsWith(t)) : !1), Btt = Gt(1e3, dn("ScoringLegend")), jtt = ["Objective Assessment", "Prior Living"], v8 = (e, t) => {
  let n = {
    isEnable: !1,
    page: ""
  };
  if (!e)
    return n;
  const r = e.find((i) => i.number === t);
  return r ? n = {
    isEnable: jtt.includes(r.label),
    page: r.label
  } : n = {
    isEnable: !1,
    page: ""
  }, n;
}, Vtt = {
  "06. Independent": "Patient/resident safely completes the activity by him/herself with no assistance from a helper.",
  "05. Setup or clean-up assistance": "Helper sets up or cleans up; patient/resident completes activity. Helper assists only prior to or following the activity.",
  "04. Supervision or touching assistance": "Helper provides verbal cues and/or touching/steadying and/or contact guard assistance as patient/resident completes activity. Assistance may be provided throughout the activity or intermittently.",
  "03. Partial/moderate assistance": "Helper does LESS THAN HALF the effort. Helper lifts, holds or supports trunk or limbs, but provides less than half the effort.",
  "02. Substantial/maximal assistance": "Helper does MORE THAN HALF the effort. Helper lifts or holds trunk or limbs and provides more than half the effort.",
  "01. Dependent": "Helper does ALL of the effort. Patient/resident does none of the effort to complete the activity. Or, the assistance of 2 or more helpers is required for the patient/resident to complete the activity."
}, vw = {
  "07. Patient/resident refused": "",
  "09. Not applicable": "Not attempted and the patient/resident did not perform this activity prior to the current illness, exacerbation, or injury.",
  "10. Not attempted due to environmental limitations": "(e.g., lack of equipment, weather constraints)",
  "88. Not attempted due to medical condition or safety concerns": ""
}, x8 = {
  5: "Holds test position against strong pressure",
  "4+": "Holds test position against moderate to strong pressure",
  4: "Holds test position against moderate pressure",
  "4-": "Holds test position against slight to moderate pressure",
  "3+": "Hold test position against slight pressure",
  3: "Holds test position (no added pressure)",
  "3-": "Gradual release from test position",
  "2+": "Moves through partial range of motion (antigravity position)",
  2: "Moves through complete range of motion (movement in horizontal plane)",
  "2-": "Move through partial range of motion (movement in horizontal plane)",
  1: "Tendon becomes prominent or feeble contraction felt in the muscle, but no visible movement of the part"
}, ztt = {
  "3. Independent": "if the patient or resident completed the activities by themselves, with or without an assistive device, with no assistance from a helper.",
  "2. Needed Some Help": "if the patient or resident needed partial assistance from another person to complete activities.",
  "1. Dependent": "if the helper completed the activities for the patient or resident.",
  "8. Unknown": "if the patient's or resident's usual ability prior to the current illness, exacerbation or injury is unknown.",
  "9. Not Applicable": "if the activity was not applicable to the patient or resident prior the current illness, exacerbation or injury."
};
function Utt({ source: e }) {
  const [t, n] = Et({}), [r, i] = Et("");
  return rn(() => {
    switch (e) {
      case "Objective Assessment":
        n(Vtt), i("Objective Assessment GG Scoring");
        break;
      case "Prior Living":
        n(ztt), i("Prior Functioning & Prior Equipment Scoring");
        break;
    }
  }, [e]), /* @__PURE__ */ P.jsxs(Ar, { p: 2, borderRadius: 1, sx: { border: "1px solid black" }, children: [
    /* @__PURE__ */ P.jsx(cn, { fontWeight: 600, children: r }),
    /* @__PURE__ */ P.jsxs(Ar, { children: [
      Object.keys(t).map((o) => /* @__PURE__ */ P.jsxs(Ar, { children: [
        /* @__PURE__ */ P.jsx(cn, { display: "inline", fontWeight: 600, fontSize: "12px", children: o }),
        t[o] ? /* @__PURE__ */ P.jsxs(cn, { fontSize: "12px", display: "inline", children: [
          " ",
          "- ",
          t[o]
        ] }) : null
      ] })),
      e === "Objective Assessment" && /* @__PURE__ */ P.jsxs(P.Fragment, { children: [
        /* @__PURE__ */ P.jsx(cn, { fontSize: "12px", fontWeight: 600, children: "If not tested:" }),
        Object.keys(vw).map((o) => /* @__PURE__ */ P.jsxs(Ar, { children: [
          /* @__PURE__ */ P.jsx(cn, { fontSize: "12px", fontWeight: 600, display: "inline", children: o }),
          vw[o] ? /* @__PURE__ */ P.jsxs(cn, { fontSize: "12px", display: "inline", children: [
            " ",
            "- ",
            vw[o]
          ] }) : null
        ] })),
        /* @__PURE__ */ P.jsx("br", {}),
        /* @__PURE__ */ P.jsxs(Ar, { children: [
          /* @__PURE__ */ P.jsx(cn, { fontWeight: 600, children: "Strength Assessment / Manual Muscle Testing Grades" }),
          Object.keys(x8).map((o) => /* @__PURE__ */ P.jsxs(Ar, { children: [
            /* @__PURE__ */ P.jsx(cn, { fontSize: "12px", fontWeight: 600, display: "inline", children: o }),
            /* @__PURE__ */ P.jsxs(cn, { fontSize: "12px", display: "inline", children: [
              " ",
              x8[o]
            ] })
          ] }))
        ] })
      ] })
    ] })
  ] });
}
function Wtt() {
  const { currentPage: e, pages: t } = tT(), [n, r] = Et(null);
  if (!v8(t, e).isEnable)
    return null;
  const i = (u) => {
    r(u.currentTarget);
  }, o = () => {
    r(null);
  }, s = !!n, a = s ? "simple-popover" : void 0;
  return /* @__PURE__ */ P.jsxs(Ar, { sx: { position: "relative" }, children: [
    /* @__PURE__ */ P.jsx(
      Xb,
      {
        sx: { position: "absolute", right: 20, top: 20 },
        label: "Scoring Legend",
        variant: "outlined",
        onClick: (u) => i(u),
        color: "primary"
      }
    ),
    /* @__PURE__ */ P.jsx(
      EF,
      {
        id: a,
        open: s,
        anchorEl: n,
        onClose: o,
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "left"
        },
        transformOrigin: {
          vertical: "top",
          horizontal: "right"
        },
        slotProps: {
          paper: {
            sx: {
              width: "50%",
              height: "auto",
              maxHeight: "55%"
            }
          }
        },
        disableScrollLock: !0,
        children: /* @__PURE__ */ P.jsx(Utt, { source: v8(t, e).page })
      }
    )
  ] });
}
const Htt = Gt(1e3, dn("CustomDropdown")), qtt = ({
  schema: e,
  uischema: t,
  path: n,
  data: r,
  handleChange: i,
  visible: o,
  required: s,
  errors: a,
  label: u,
  id: c
}) => {
  var w;
  const d = e.enum || [], f = So(), h = t == null ? void 0 : t.options, { targetScope: m, value: v, prefill: x } = h || {}, C = (O) => {
    i(n, O.target.value);
  }, E = () => {
    i(n, "");
  }, S = m ? bg((w = f.core) == null ? void 0 : w.data, m) : void 0;
  return rn(() => {
    S && !r && S === v && f != null && f.dispatch && (f == null || f.dispatch(Oa(n, () => x || "")));
  }, [t.options, r, S, f, n, x, v]), o ? /* @__PURE__ */ P.jsxs(hi, { fullWidth: !0, variant: "outlined", sx: { marginTop: a ? 0 : 2 }, error: !!a, children: [
    /* @__PURE__ */ P.jsx(ra, { htmlFor: c, required: s, children: u }),
    /* @__PURE__ */ P.jsx(
      mf,
      {
        id: c,
        value: r || "",
        onChange: C,
        label: u,
        endAdornment: r && /* @__PURE__ */ P.jsx(lg, { position: "end", children: /* @__PURE__ */ P.jsx(
          Or,
          {
            size: "small",
            onClick: E,
            edge: "end",
            sx: { fontSize: "12px", marginRight: "15px" },
            children: /* @__PURE__ */ P.jsx(F$, {})
          }
        ) }),
        children: d.map((O) => /* @__PURE__ */ P.jsx(ks, { value: O, children: /* @__PURE__ */ P.jsx(cn, { variant: "body1", children: O }) }, O))
      }
    ),
    a && /* @__PURE__ */ P.jsx(cn, { variant: "caption", color: "error", children: a })
  ] }) : null;
}, Gtt = li(qtt), Ytt = Gt(1e3, dn("SoapCptBilling")), xw = (e) => {
  const t = e.toUpperCase();
  return {
    isGroupCode: t.includes("(GROUP)"),
    cleanedCode: t.replace(" (GROUP)", "")
  };
}, cG = BC(void 0), Ktt = (e) => /* @__PURE__ */ P.jsx(cG.Provider, { value: { ...e }, children: e.children }), dG = () => {
  const e = Rm(cG);
  if (e === void 0)
    throw new Error("useApi must be used within a ApiProvider");
  return e;
}, Jtt = (e) => {
  const { data: t, handleChange: n, id: r, path: i } = e, o = {
    totalIndividual: (t == null ? void 0 : t.individual) || 0,
    totalGroup: (t == null ? void 0 : t.group) || 0,
    totalTreatmentTime: t.totalTreatmentTime || 0,
    maxConcurrent: 0,
    maxCotreatment: 0
  }, { discipline: s } = dG(), [a, u] = Et([]), [c, d] = Et(null), [f, h] = Et({
    discipline: (t == null ? void 0 : t.disipline) || s,
    codes: (t == null ? void 0 : t.codes) || [],
    concurrent: (t == null ? void 0 : t.concurrent) || 0,
    cotreatment: (t == null ? void 0 : t.cotreatment) || 0,
    totalTreatmentTime: (t == null ? void 0 : t.totalTreatmentTime) || 0,
    cotreatmentDiscipline: (t == null ? void 0 : t.cotreatmentDiscipline) || [],
    group: (t == null ? void 0 : t.group) || 0,
    individual: (t == null ? void 0 : t.individual) || 0
  }), [m, v] = Et(o), { addAdditionalError: x, removeAdditionalError: C } = Dg(), E = rs(!1), S = rs(!1);
  rn(() => {
    const G = setTimeout(() => {
      n(i, f);
    }, 500);
    return () => clearTimeout(G);
  }, [f, n, i]), rn(() => {
    E.current = !1;
    const G = f.codes.map((K) => {
      const { cleanedCode: ee } = xw(K.code);
      return K.minutes > 0 && !K.notes && (E.current = !0), ee;
    });
    u(G);
  }, [f]);
  const w = Cn(() => {
    a.length && mv(a, "CPT", !0).then((G) => {
      const K = {};
      G.forEach((ee) => {
        const [te, M] = Object.values(ee);
        K[te] = M;
      }), d(K);
    });
  }, [a]);
  rn(() => {
    c === null && f.codes.length && w();
  }, [f.codes, c, w]);
  const O = Cn(() => {
    const { codes: G, concurrent: K } = f;
    let ee = 0, te = 0, M = 0;
    Object.values(G).forEach((Q) => {
      const { code: oe, isEval: ae, minutes: pe, serviceBasedCode: me } = Q, { isGroupCode: xe } = xw(oe);
      xe ? te += pe : ee += pe, (ae || me) && (M += pe);
    });
    const Z = ee - K - M, ne = te, R = ee + ne, _ = ee - M, W = ee - M;
    return {
      totalIndividual: Z >= 0 ? Z : 0,
      totalGroup: ne >= 0 ? ne : 0,
      totalTreatmentTime: R >= 0 ? R : 0,
      maxConcurrent: _ >= 0 ? _ : 0,
      maxCotreatment: W >= 0 ? W : 0
    };
  }, [f]);
  rn(() => {
    const G = O();
    let K = !1;
    const ee = f;
    G.totalTreatmentTime !== f.totalTreatmentTime && (ee.totalTreatmentTime = G.totalTreatmentTime, K = !0), G.totalIndividual !== f.individual && (ee.individual = G.totalIndividual, K = !0), G.totalGroup !== f.group && (ee.group = G.totalGroup, K = !0), K && h(ee), v(G);
  }, [O, i, f]);
  const A = (G) => {
    const K = {};
    return G.forEach((ee, te) => {
      const { minutes: M, notes: Z, isEval: ne, serviceBasedCode: R } = ee;
      K[ee.code] = {
        minutes: M,
        notes: Z,
        isEval: ne,
        serviceBasedCode: R,
        index: te
      };
    }), K;
  }, I = (G) => {
    const K = [];
    for (const [ee, te] of Object.entries(G))
      K[te.index] = {
        code: ee,
        minutes: te.minutes,
        notes: te.notes,
        isEval: te.isEval,
        serviceBasedCode: te.serviceBasedCode
      };
    return K;
  }, $ = (G, K, ee) => {
    let te;
    if (ee === "minutes") {
      const _ = G.currentTarget.value.replace(/\D/g, "") || "0";
      G.currentTarget.value = _, te = parseInt(_);
    } else
      te = G.currentTarget.value;
    const M = A(f.codes), Z = {
      ...M,
      [K]: {
        ...M[K],
        [ee]: te
      }
    }, ne = I(Z), R = {
      ...f,
      codes: ne
    };
    h(R);
  }, L = (G, K) => {
    const ee = G.currentTarget.value.replace(/\D/g, "") || "0";
    G.currentTarget.value = ee;
    const te = {
      ...f,
      [K]: parseInt(ee)
    };
    h(te);
  }, B = (G) => {
    const { checked: K, value: ee } = G.currentTarget;
    let te = f.cotreatmentDiscipline;
    K && !te.includes(ee) && te.push(ee), K || (te = te.filter((Z) => Z !== ee));
    const M = {
      ...f,
      cotreatmentDiscipline: te
    };
    h(M);
  }, H = (G) => {
    G.target.select();
  }, q = Object.values(f.codes).map((G) => {
    const { code: K, minutes: ee, notes: te } = G, { cleanedCode: M } = xw(K), Z = ee > 0 && !te;
    return /* @__PURE__ */ P.jsxs(_o, { children: [
      /* @__PURE__ */ P.jsxs(hn, { valign: "top", sx: { verticalAlign: "top", padding: "0.5rem" }, children: [
        /* @__PURE__ */ P.jsx(Ar, { sx: { lineHeight: 1.25, fontWeight: "bold" }, children: G.code }),
        c !== null && /* @__PURE__ */ P.jsx(Ar, { sx: { lineHeight: 1.25 }, children: c[M] })
      ] }),
      /* @__PURE__ */ P.jsx(hn, { valign: "top", sx: { verticalAlign: "top", padding: "0.5rem" }, children: /* @__PURE__ */ P.jsx(
        Zo,
        {
          id: `${r}-${K}-minutes`,
          type: "tel",
          onChange: (ne) => $(ne, K, "minutes"),
          size: "small",
          fullWidth: !0,
          "aria-label": `Minutes for ${K}`,
          placeholder: "0",
          value: ee,
          inputProps: {
            min: 0,
            pattern: "\\d*",
            sx: { textAlign: "right" }
          },
          onFocus: H
        }
      ) }),
      /* @__PURE__ */ P.jsxs(hn, { valign: "top", sx: { verticalAlign: "top", padding: "0.5rem" }, colSpan: 5, children: [
        /* @__PURE__ */ P.jsx(
          Zo,
          {
            id: `${r}-notes`,
            onChange: (ne) => $(ne, K, "notes"),
            multiline: !0,
            size: "small",
            fullWidth: !0,
            error: Z,
            value: te,
            "aria-label": `Notes for ${K}`
          }
        ),
        Z && /* @__PURE__ */ P.jsx(gn, { error: !0, children: "Notes are required for all codes with minutes" })
      ] })
    ] }, `entry-${r}-${K}`);
  }), J = f.discipline, X = f.cotreatmentDiscipline, j = f.cotreatment > 0 && !f.cotreatmentDiscipline.length, U = vn(() => !!(!f.totalTreatmentTime || f.totalTreatmentTime <= 0 || E.current || f.concurrent > m.maxConcurrent || f.cotreatment > m.maxCotreatment || j), [f, m, j]);
  return rn(() => {
    let G = null;
    const K = setTimeout(() => {
      U ? (G = {
        instancePath: `/${i}`,
        message: "Invalid billing code information",
        schemaPath: "",
        keyword: "",
        params: {
          uischema: e.uischema
        }
      }, x(G), S.current = !0) : (S.current && C(`/${i}`), S.current = !1);
    }, 100);
    return () => {
      clearTimeout(K);
    };
  }, [x, i, C, U, e.uischema]), f.codes.length < 1 ? /* @__PURE__ */ P.jsx(P.Fragment, { children: "No billable codes found" }) : /* @__PURE__ */ P.jsx(WU, { children: /* @__PURE__ */ P.jsx(dg, { children: /* @__PURE__ */ P.jsxs(gf, { size: "small", children: [
    /* @__PURE__ */ P.jsx(bf, { children: /* @__PURE__ */ P.jsxs(_o, { children: [
      /* @__PURE__ */ P.jsx(hn, { sx: { width: "20%", padding: "0.5rem" }, children: "Code" }),
      /* @__PURE__ */ P.jsx(hn, { sx: { width: "12%", padding: "0.5rem", textAlign: "right" }, children: "Minutes" }),
      /* @__PURE__ */ P.jsx(hn, { colSpan: 5, children: "Notes" })
    ] }) }),
    /* @__PURE__ */ P.jsx(yf, { children: q }),
    /* @__PURE__ */ P.jsx(cW, { children: /* @__PURE__ */ P.jsxs(_o, { children: [
      /* @__PURE__ */ P.jsx(hn, {}),
      /* @__PURE__ */ P.jsxs(
        hn,
        {
          valign: "top",
          sx: { verticalAlign: "top", textAlign: "right", padding: "0.5rem", width: "12%" },
          children: [
            /* @__PURE__ */ P.jsx(gn, { sx: { textAlign: "right", whiteSpace: "nowrap" }, children: "Total Treatment Time" }),
            /* @__PURE__ */ P.jsx(
              Zo,
              {
                id: "total-treatment-time",
                disabled: !0,
                size: "small",
                value: m == null ? void 0 : m.totalTreatmentTime,
                inputProps: { sx: { textAlign: "right" } }
              }
            ),
            /* @__PURE__ */ P.jsx(gn, { sx: { textAlign: "right" }, error: f.totalTreatmentTime <= 0, children: f.totalTreatmentTime <= 0 && "Minutes required" })
          ]
        }
      ),
      /* @__PURE__ */ P.jsxs(hn, { valign: "top", sx: { verticalAlign: "top", padding: "0.5rem", width: "12%" }, children: [
        /* @__PURE__ */ P.jsx(gn, { sx: { textAlign: "right" }, children: "Individual" }),
        /* @__PURE__ */ P.jsx(
          Zo,
          {
            id: `${r}-individualMinutes-total`,
            disabled: !0,
            size: "small",
            fullWidth: !0,
            value: (m == null ? void 0 : m.totalIndividual) || 0,
            inputProps: { sx: { textAlign: "right" } }
          }
        )
      ] }),
      /* @__PURE__ */ P.jsxs(hn, { valign: "top", sx: { verticalAlign: "top", width: "12%", padding: "0.5rem" }, children: [
        /* @__PURE__ */ P.jsx(gn, { sx: { textAlign: "right" }, children: "Group" }),
        /* @__PURE__ */ P.jsx(
          Zo,
          {
            id: `${r}-group-total`,
            disabled: !0,
            size: "small",
            fullWidth: !0,
            value: (m == null ? void 0 : m.totalGroup) || 0,
            inputProps: { sx: { textAlign: "right" } }
          }
        )
      ] }),
      /* @__PURE__ */ P.jsxs(hn, { valign: "top", sx: { verticalAlign: "top", width: "12%", padding: "0.5rem" }, children: [
        /* @__PURE__ */ P.jsx(gn, { sx: { textAlign: "right" }, children: "Concurrent" }),
        /* @__PURE__ */ P.jsx(
          Zo,
          {
            id: `${r}-concurrent`,
            onChange: (G) => L(G, "concurrent"),
            size: "small",
            fullWidth: !0,
            error: f.concurrent > m.maxConcurrent,
            value: f.concurrent || 0,
            inputProps: { sx: { textAlign: "right" } },
            onFocus: H
          }
        ),
        /* @__PURE__ */ P.jsxs(gn, { error: f.concurrent > m.maxConcurrent, sx: { textAlign: "right" }, children: [
          "Max: ",
          m.maxConcurrent
        ] })
      ] }),
      /* @__PURE__ */ P.jsxs(hn, { valign: "top", sx: { verticalAlign: "top", width: "12%", padding: "0.5rem" }, children: [
        /* @__PURE__ */ P.jsx(gn, { sx: { textAlign: "right" }, children: "Co-treatment" }),
        /* @__PURE__ */ P.jsx(
          Zo,
          {
            id: `${r}-cotreatment`,
            onChange: (G) => L(G, "cotreatment"),
            size: "small",
            fullWidth: !0,
            error: f.cotreatment > m.maxCotreatment,
            value: f.cotreatment || 0,
            inputProps: { sx: { textAlign: "right" } },
            onFocus: H
          }
        ),
        /* @__PURE__ */ P.jsxs(gn, { error: f.cotreatment > m.maxCotreatment, sx: { textAlign: "right" }, children: [
          "Max: ",
          m.maxCotreatment
        ] })
      ] }),
      /* @__PURE__ */ P.jsx(hn, { sx: { padding: "0.5rem" }, children: /* @__PURE__ */ P.jsxs(rv, { children: [
        J !== "PT" && /* @__PURE__ */ P.jsx(
          Ps,
          {
            sx: j ? { color: "red" } : void 0,
            control: /* @__PURE__ */ P.jsx(
              rc,
              {
                checked: X.includes("PT"),
                onChange: B,
                value: "PT",
                disabled: f.cotreatment <= 0,
                sx: j ? { color: "red" } : void 0
              }
            ),
            label: "PT"
          }
        ),
        J !== "OT" && /* @__PURE__ */ P.jsx(
          Ps,
          {
            sx: j ? { color: "red" } : void 0,
            control: /* @__PURE__ */ P.jsx(
              rc,
              {
                checked: X.includes("OT"),
                onChange: B,
                value: "OT",
                disabled: f.cotreatment <= 0,
                sx: j ? { color: "red" } : void 0
              }
            ),
            label: "OT"
          }
        ),
        J !== "SLP" && /* @__PURE__ */ P.jsx(
          Ps,
          {
            sx: j ? { color: "red" } : void 0,
            control: /* @__PURE__ */ P.jsx(
              rc,
              {
                checked: X.includes("SLP"),
                onChange: B,
                value: "SLP",
                disabled: f.cotreatment <= 0,
                sx: j ? { color: "red" } : void 0
              }
            ),
            label: "SLP"
          }
        )
      ] }) })
    ] }) })
  ] }) }) });
}, Xtt = li(Jtt), Qtt = Gt(1e3, dn("SupervisorSelector")), Ztt = async (e, t, n, r) => fetch(`${t}/provider/get-dsn-supervisors`, {
  method: "GET",
  headers: {
    Authorization: `Bearer ${e}`,
    "x-tenant-id": n,
    facility_id: r
  }
}).then((i) => i.json()).then((i) => i.data).catch((i) => {
  throw Error(`Error fetching supervisors: ${i}`);
}), ent = (e) => {
  var O, A;
  const { handleChange: t, path: n } = e, { getAccessToken: r, realm: i, apiUrl: o, facilityId: s } = dG(), [a, u] = Et(null), [c, d] = Et(""), [f, h] = Et((O = e == null ? void 0 : e.data) == null ? void 0 : O.name), [m, v] = Et((A = e == null ? void 0 : e.data) == null ? void 0 : A.credentials), [x, C] = Et(!0);
  if (rn(() => {
    a === null && r().then((I) => {
      Ztt(I, o, i, s).then(($) => {
        if ($.length > 0) {
          const L = $.filter(({ credentials: B, name: H, uuid: q }) => B && B !== "" && H && H !== "" && q && q !== "");
          L.length === 1 && !f && !m && (h(L[0].name), v(L[0].credentials)), u(L);
        } else
          u([]);
      });
    });
  }, [o, s, r, i, a, m, f]), rn(() => {
    if (x && a && e.data) {
      const { name: I, credentials: $ } = e.data;
      if (I && I !== "" && $ && $ !== "") {
        let L = !1;
        for (let B = 0; B < a.length; B++)
          a[B].credentials === $ && a[B].name === I && (L = !0, d(`${B}`));
        L || d("other");
      }
      C(!1);
    }
  }, [x, e.data, c, a]), rn(() => {
    const I = setTimeout(() => {
      t(n, {
        name: f,
        credentials: m
      });
    }, 500);
    return () => clearTimeout(I);
  }, [t, n, f, m]), !e.visible)
    return /* @__PURE__ */ P.jsx(P.Fragment, {});
  const E = (I) => {
    h(I.currentTarget.value);
  }, S = (I) => {
    v(I.currentTarget.value);
  }, w = () => /* @__PURE__ */ P.jsxs(P.Fragment, { children: [
    /* @__PURE__ */ P.jsx(en, { item: !0, xs: 4, children: /* @__PURE__ */ P.jsxs(hi, { fullWidth: !0, children: [
      /* @__PURE__ */ P.jsx(ra, { id: `${e.path}-supervisorName-label`, children: "Supervisor Name" }),
      /* @__PURE__ */ P.jsx(
        Zo,
        {
          id: `${e.path}-supervisorName`,
          value: f || "",
          label: "Supervisor Name",
          onChange: E
        }
      ),
      /* @__PURE__ */ P.jsx(gn, {})
    ] }) }),
    /* @__PURE__ */ P.jsx(en, { item: !0, xs: 4, children: /* @__PURE__ */ P.jsxs(hi, { fullWidth: !0, children: [
      /* @__PURE__ */ P.jsx(ra, { id: `${e.path}-supervisorCredentials-label`, children: "Supervisor Credentials" }),
      /* @__PURE__ */ P.jsx(
        Zo,
        {
          id: `${e.path}-supervisorCredentials`,
          value: m || "",
          label: "Supervisor Credentials",
          onChange: S
        }
      ),
      /* @__PURE__ */ P.jsx(gn, {})
    ] }) })
  ] });
  if (a && a.length > 0) {
    const I = a.map((L, B) => /* @__PURE__ */ P.jsxs(ks, { value: B, children: [
      L.name,
      " - ",
      `(${L.credentials})`
    ] }, `${e.path}-option-${B}`)), $ = (L) => {
      if (L.target.value !== "other" && L.target.value !== "") {
        const B = a[parseInt(L.target.value)];
        h(B.name), v(B.credentials), d(L.target.value);
      } else
        h(""), v(""), d(L.target.value);
    };
    return /* @__PURE__ */ P.jsxs(en, { container: !0, direction: "row", spacing: 2, children: [
      /* @__PURE__ */ P.jsx(en, { item: !0, xs: 4, children: /* @__PURE__ */ P.jsxs(hi, { fullWidth: !0, children: [
        /* @__PURE__ */ P.jsx(ra, { id: `${e.id}-label`, children: e.label }),
        /* @__PURE__ */ P.jsxs(mf, { onChange: $, label: e.label, value: c, children: [
          /* @__PURE__ */ P.jsx(ks, { value: "", children: /* @__PURE__ */ P.jsx("em", { children: "- Select -" }) }),
          I,
          /* @__PURE__ */ P.jsx(ks, { value: "other", children: "Other" })
        ] }),
        /* @__PURE__ */ P.jsx(gn, {})
      ] }) }),
      c === "other" && w()
    ] });
  }
  return /* @__PURE__ */ P.jsx(en, { container: !0, direction: "row", spacing: 2, children: w() });
}, tnt = Mb(Ka(k6(ent)), !1), nnt = (e, t = "") => {
  const n = t ? t.split(".") : [], r = dE(e);
  if (r.length === 1 && n.length > 1) {
    const i = [...n];
    i.pop(), i[i.length] = r[0], r.length = 0, r.push(...i);
  }
  return r.join(".");
}, rnt = (e) => {
  const { data: t, handleChange: n, path: r, uischema: i, visible: o, label: s } = e, { targetScope: a, allowedTargetValues: u, hideIf: c } = i, d = So();
  return rn(() => {
    if (!d.core || t !== void 0) return;
    const h = nnt(a, r), m = `RF_INITIAL_DATA.${h}`, v = jKe(d.core.data, m);
    if (v !== void 0) {
      const x = v === null ? "" : String(v);
      n(r, x), u != null && u.length && !u.includes(x) && n(h, "");
    }
  }, [a, d.core, t, n, r, u]), !!(!o || !t || c && c.includes(t)) ? /* @__PURE__ */ P.jsx(P.Fragment, {}) : /* @__PURE__ */ P.jsxs(Ar, { sx: { padding: "1rem 0 1.5rem", fontSize: "0.75em" }, children: [
    /* @__PURE__ */ P.jsxs("strong", { children: [
      s,
      ":"
    ] }),
    " ",
    t
  ] });
}, int = li(rnt), ont = Gt(1e3, dn("ExistingFieldDisplay")), snt = ({
  handleChange: e,
  path: t,
  schema: n,
  visible: r,
  required: i,
  errors: o,
  data: s
}) => {
  const a = (n == null ? void 0 : n.value) || "", u = (n == null ? void 0 : n.title) || "", c = n, d = (c == null ? void 0 : c.errorMessage) || "This field is required.", [f, h] = Et({}), { addAdditionalError: m, removeAdditionalError: v } = Dg(), x = vn(() => a.split(`
`).map(($) => {
    const L = /\(([^)]+)\)/g, B = [];
    let H = 0, q;
    for (; (q = L.exec($)) !== null; )
      q.index > H && B.push({ type: "text", value: $.slice(H, q.index) }), B.push({ type: "input", key: `${q.index}-${q[1]}` }), H = L.lastIndex;
    return H < $.length && B.push({ type: "text", value: $.slice(H) }), B;
  }), [a]), C = x.map((I) => I.map(($) => $.type === "text" ? $.value : `<<<${$.key}>>>`).join("")).join(`
`);
  rn(() => {
    var H;
    if (!s || Object.keys(f).length > 0) return;
    const I = C.split(/(<<<.*?>>>)/g), $ = I.map(
      (q) => q.startsWith("<<<") && q.endsWith(">>>") ? "(.*?)" : q.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
      // escape static text
    ), L = new RegExp(`^${$.join("")}$`, "s"), B = s.match(L);
    if (B) {
      const q = {};
      let J = 1;
      for (const X of I)
        if (X.startsWith("<<<") && X.endsWith(">>>")) {
          const j = X.slice(3, -3);
          q[j] = ((H = B[J++]) == null ? void 0 : H.trim()) || "";
        }
      h(q);
    }
  }, [s, f, C]);
  const E = Cn(() => {
    var I;
    return t ? `/${(I = t == null ? void 0 : t.split(".")) == null ? void 0 : I.join("/")}` : "";
  }, [t]), S = i && x.some((I) => I.some(($) => $.type === "input" && vo.isEmpty(f[$.key]))), w = S || !!o;
  rn(() => {
    const I = Object.values(f).every((L) => L.trim() === ""), $ = x.map(
      (L) => L.map((B) => B.type === "text" ? B.value : f[B.key] || `(${B.key.split("-")[1]})`).join("")
    ).join(`
`);
    e(t, I ? "" : $);
  }, [f, x, e, t]);
  const O = (I, $) => {
    h((L) => ({ ...L, [I]: $ }));
  }, A = rs(null);
  return rn(() => {
    let I = null;
    S ? I = {
      instancePath: E(),
      message: d,
      schemaPath: "",
      keyword: "",
      params: {}
    } : I = null;
    const $ = setTimeout(() => {
      I ? (m(I), A.current = I) : (A.current && v(A.current.instancePath), A.current = null);
    }, 100);
    return () => {
      clearTimeout($);
    };
  }, [S, m, d, E, v]), r ? /* @__PURE__ */ P.jsxs(Ar, { sx: { display: "flex", flexDirection: "column", marginBottom: "16px" }, children: [
    u && /* @__PURE__ */ P.jsx(cn, { variant: "subtitle1", children: u }),
    /* @__PURE__ */ P.jsx(
      ti,
      {
        variant: "outlined",
        sx: {
          border: w ? "3px solid" : "1px solid",
          borderColor: w ? "#F04438" : "grey.400",
          borderRadius: 2,
          padding: 2,
          backgroundColor: "#FFFFFF"
        },
        children: /* @__PURE__ */ P.jsx(Ar, { display: "flex", flexDirection: "column", gap: 2, children: x.map((I, $) => /* @__PURE__ */ P.jsx(Ar, { display: "flex", flexWrap: "wrap", alignItems: "center", gap: 1, children: I.map(
          (L, B) => {
            var H;
            return L.type === "text" ? /* @__PURE__ */ P.jsx("span", { children: L.value }, B) : /* @__PURE__ */ P.jsx(
              vf,
              {
                value: f[L.key] || "",
                placeholder: L.key.split("-")[1],
                onChange: (q) => O(L.key, q.target.value),
                size: "small",
                variant: "standard",
                inputProps: {
                  size: L.key.split("-")[1].length + 5
                },
                error: !!((!f[L.key] || ((H = f[L.key]) == null ? void 0 : H.length) === 0) && w)
              },
              B
            );
          }
        ) }, $)) })
      }
    ),
    w && /* @__PURE__ */ P.jsx(gn, { error: w, children: d })
  ] }) : null;
}, ant = li(snt), lnt = Gt(1e3, (e) => (e == null ? void 0 : e.type) === "FillInTheBlanks"), unt = [
  ...pKe,
  { tester: yKe, renderer: BKe },
  { tester: bKe, renderer: UKe },
  { tester: vKe, renderer: YKe },
  { tester: xKe, renderer: JKe },
  { tester: DKe, renderer: QKe },
  { tester: CKe, renderer: Oet },
  { tester: SKe, renderer: Fet },
  { tester: AKe, renderer: Net },
  { tester: wKe, renderer: Get },
  { tester: PKe, renderer: Ket },
  { tester: kKe, renderer: ntt },
  { tester: OKe, renderer: itt },
  { tester: IKe, renderer: att },
  { tester: ltt, renderer: dtt },
  { tester: ptt, renderer: htt },
  { tester: mtt, renderer: ytt },
  { tester: btt, renderer: xtt },
  { tester: Dtt, renderer: ktt },
  { tester: Ftt, renderer: Itt },
  { tester: Ltt, renderer: _tt },
  { tester: Btt, renderer: Wtt },
  { tester: Htt, renderer: Gtt },
  { tester: Ytt, renderer: Xtt },
  { tester: Qtt, renderer: tnt },
  { tester: ont, renderer: int },
  { tester: lnt, renderer: ant }
];
var cnt = fU();
const dnt = /* @__PURE__ */ Ln(cnt);
let hk = [], pG = [];
(() => {
  let e = "lc,34,7n,7,7b,19,,,,2,,2,,,20,b,1c,l,g,,2t,7,2,6,2,2,,4,z,,u,r,2j,b,1m,9,9,,o,4,,9,,3,,5,17,3,3b,f,,w,1j,,,,4,8,4,,3,7,a,2,t,,1m,,,,2,4,8,,9,,a,2,q,,2,2,1l,,4,2,4,2,2,3,3,,u,2,3,,b,2,1l,,4,5,,2,4,,k,2,m,6,,,1m,,,2,,4,8,,7,3,a,2,u,,1n,,,,c,,9,,14,,3,,1l,3,5,3,,4,7,2,b,2,t,,1m,,2,,2,,3,,5,2,7,2,b,2,s,2,1l,2,,,2,4,8,,9,,a,2,t,,20,,4,,2,3,,,8,,29,,2,7,c,8,2q,,2,9,b,6,22,2,r,,,,,,1j,e,,5,,2,5,b,,10,9,,2u,4,,6,,2,2,2,p,2,4,3,g,4,d,,2,2,6,,f,,jj,3,qa,3,t,3,t,2,u,2,1s,2,,7,8,,2,b,9,,19,3,3b,2,y,,3a,3,4,2,9,,6,3,63,2,2,,1m,,,7,,,,,2,8,6,a,2,,1c,h,1r,4,1c,7,,,5,,14,9,c,2,w,4,2,2,,3,1k,,,2,3,,,3,1m,8,2,2,48,3,,d,,7,4,,6,,3,2,5i,1m,,5,ek,,5f,x,2da,3,3x,,2o,w,fe,6,2x,2,n9w,4,,a,w,2,28,2,7k,,3,,4,,p,2,5,,47,2,q,i,d,,12,8,p,b,1a,3,1c,,2,4,2,2,13,,1v,6,2,2,2,2,c,,8,,1b,,1f,,,3,2,2,5,2,,,16,2,8,,6m,,2,,4,,fn4,,kh,g,g,g,a6,2,gt,,6a,,45,5,1ae,3,,2,5,4,14,3,4,,4l,2,fx,4,ar,2,49,b,4w,,1i,f,1k,3,1d,4,2,2,1x,3,10,5,,8,1q,,c,2,1g,9,a,4,2,,2n,3,2,,,2,6,,4g,,3,8,l,2,1l,2,,,,,m,,e,7,3,5,5f,8,2,3,,,n,,29,,2,6,,,2,,,2,,2,6j,,2,4,6,2,,2,r,2,2d,8,2,,,2,2y,,,,2,6,,,2t,3,2,4,,5,77,9,,2,6t,,a,2,,,4,,40,4,2,2,4,,w,a,14,6,2,4,8,,9,6,2,3,1a,d,,2,ba,7,,6,,,2a,m,2,7,,2,,2,3e,6,3,,,2,,7,,,20,2,3,,,,9n,2,f0b,5,1n,7,t4,,1r,4,29,,f5k,2,43q,,,3,4,5,8,8,2,7,u,4,44,3,1iz,1j,4,1e,8,,e,,m,5,,f,11s,7,,h,2,7,,2,,5,79,7,c5,4,15s,7,31,7,240,5,gx7k,2o,3k,6o".split(",").map((t) => t ? parseInt(t, 36) : 1);
  for (let t = 0, n = 0; t < e.length; t++)
    (t % 2 ? pG : hk).push(n = n + e[t]);
})();
function pnt(e) {
  if (e < 768) return !1;
  for (let t = 0, n = hk.length; ; ) {
    let r = t + n >> 1;
    if (e < hk[r]) n = r;
    else if (e >= pG[r]) t = r + 1;
    else return !0;
    if (t == n) return !1;
  }
}
function D8(e) {
  return e >= 127462 && e <= 127487;
}
const C8 = 8205;
function fnt(e, t, n = !0, r = !0) {
  return (n ? fG : hnt)(e, t, r);
}
function fG(e, t, n) {
  if (t == e.length) return t;
  t && hG(e.charCodeAt(t)) && mG(e.charCodeAt(t - 1)) && t--;
  let r = Dw(e, t);
  for (t += E8(r); t < e.length; ) {
    let i = Dw(e, t);
    if (r == C8 || i == C8 || n && pnt(i))
      t += E8(i), r = i;
    else if (D8(i)) {
      let o = 0, s = t - 2;
      for (; s >= 0 && D8(Dw(e, s)); )
        o++, s -= 2;
      if (o % 2 == 0) break;
      t += 2;
    } else
      break;
  }
  return t;
}
function hnt(e, t, n) {
  for (; t > 0; ) {
    let r = fG(e, t - 2, n);
    if (r < t) return r;
    t--;
  }
  return 0;
}
function Dw(e, t) {
  let n = e.charCodeAt(t);
  if (!mG(n) || t + 1 == e.length) return n;
  let r = e.charCodeAt(t + 1);
  return hG(r) ? (n - 55296 << 10) + (r - 56320) + 65536 : n;
}
function hG(e) {
  return e >= 56320 && e < 57344;
}
function mG(e) {
  return e >= 55296 && e < 56320;
}
function E8(e) {
  return e < 65536 ? 1 : 2;
}
class cr {
  /**
  Get the line description around the given position.
  */
  lineAt(t) {
    if (t < 0 || t > this.length)
      throw new RangeError(`Invalid position ${t} in document of length ${this.length}`);
    return this.lineInner(t, !1, 1, 0);
  }
  /**
  Get the description for the given (1-based) line number.
  */
  line(t) {
    if (t < 1 || t > this.lines)
      throw new RangeError(`Invalid line number ${t} in ${this.lines}-line document`);
    return this.lineInner(t, !0, 1, 0);
  }
  /**
  Replace a range of the text with the given content.
  */
  replace(t, n, r) {
    [t, n] = Dm(this, t, n);
    let i = [];
    return this.decompose(
      0,
      t,
      i,
      2
      /* Open.To */
    ), r.length && r.decompose(
      0,
      r.length,
      i,
      3
      /* Open.To */
    ), this.decompose(
      n,
      this.length,
      i,
      1
      /* Open.From */
    ), Xl.from(i, this.length - (n - t) + r.length);
  }
  /**
  Append another document to this one.
  */
  append(t) {
    return this.replace(this.length, this.length, t);
  }
  /**
  Retrieve the text between the given points.
  */
  slice(t, n = this.length) {
    [t, n] = Dm(this, t, n);
    let r = [];
    return this.decompose(t, n, r, 0), Xl.from(r, n - t);
  }
  /**
  Test whether this text is equal to another instance.
  */
  eq(t) {
    if (t == this)
      return !0;
    if (t.length != this.length || t.lines != this.lines)
      return !1;
    let n = this.scanIdentical(t, 1), r = this.length - this.scanIdentical(t, -1), i = new y0(this), o = new y0(t);
    for (let s = n, a = n; ; ) {
      if (i.next(s), o.next(s), s = 0, i.lineBreak != o.lineBreak || i.done != o.done || i.value != o.value)
        return !1;
      if (a += i.value.length, i.done || a >= r)
        return !0;
    }
  }
  /**
  Iterate over the text. When `dir` is `-1`, iteration happens
  from end to start. This will return lines and the breaks between
  them as separate strings.
  */
  iter(t = 1) {
    return new y0(this, t);
  }
  /**
  Iterate over a range of the text. When `from` > `to`, the
  iterator will run in reverse.
  */
  iterRange(t, n = this.length) {
    return new gG(this, t, n);
  }
  /**
  Return a cursor that iterates over the given range of lines,
  _without_ returning the line breaks between, and yielding empty
  strings for empty lines.
  
  When `from` and `to` are given, they should be 1-based line numbers.
  */
  iterLines(t, n) {
    let r;
    if (t == null)
      r = this.iter();
    else {
      n == null && (n = this.lines + 1);
      let i = this.line(t).from;
      r = this.iterRange(i, Math.max(i, n == this.lines + 1 ? this.length : n <= 1 ? 0 : this.line(n - 1).to));
    }
    return new yG(r);
  }
  /**
  Return the document as a string, using newline characters to
  separate lines.
  */
  toString() {
    return this.sliceString(0);
  }
  /**
  Convert the document to an array of lines (which can be
  deserialized again via [`Text.of`](https://codemirror.net/6/docs/ref/#state.Text^of)).
  */
  toJSON() {
    let t = [];
    return this.flatten(t), t;
  }
  /**
  @internal
  */
  constructor() {
  }
  /**
  Create a `Text` instance for the given array of lines.
  */
  static of(t) {
    if (t.length == 0)
      throw new RangeError("A document must have at least one line");
    return t.length == 1 && !t[0] ? cr.empty : t.length <= 32 ? new Si(t) : Xl.from(Si.split(t, []));
  }
}
class Si extends cr {
  constructor(t, n = mnt(t)) {
    super(), this.text = t, this.length = n;
  }
  get lines() {
    return this.text.length;
  }
  get children() {
    return null;
  }
  lineInner(t, n, r, i) {
    for (let o = 0; ; o++) {
      let s = this.text[o], a = i + s.length;
      if ((n ? r : a) >= t)
        return new gnt(i, a, r, s);
      i = a + 1, r++;
    }
  }
  decompose(t, n, r, i) {
    let o = t <= 0 && n >= this.length ? this : new Si(T8(this.text, t, n), Math.min(n, this.length) - Math.max(0, t));
    if (i & 1) {
      let s = r.pop(), a = rD(o.text, s.text.slice(), 0, o.length);
      if (a.length <= 32)
        r.push(new Si(a, s.length + o.length));
      else {
        let u = a.length >> 1;
        r.push(new Si(a.slice(0, u)), new Si(a.slice(u)));
      }
    } else
      r.push(o);
  }
  replace(t, n, r) {
    if (!(r instanceof Si))
      return super.replace(t, n, r);
    [t, n] = Dm(this, t, n);
    let i = rD(this.text, rD(r.text, T8(this.text, 0, t)), n), o = this.length + r.length - (n - t);
    return i.length <= 32 ? new Si(i, o) : Xl.from(Si.split(i, []), o);
  }
  sliceString(t, n = this.length, r = `
`) {
    [t, n] = Dm(this, t, n);
    let i = "";
    for (let o = 0, s = 0; o <= n && s < this.text.length; s++) {
      let a = this.text[s], u = o + a.length;
      o > t && s && (i += r), t < u && n > o && (i += a.slice(Math.max(0, t - o), n - o)), o = u + 1;
    }
    return i;
  }
  flatten(t) {
    for (let n of this.text)
      t.push(n);
  }
  scanIdentical() {
    return 0;
  }
  static split(t, n) {
    let r = [], i = -1;
    for (let o of t)
      r.push(o), i += o.length + 1, r.length == 32 && (n.push(new Si(r, i)), r = [], i = -1);
    return i > -1 && n.push(new Si(r, i)), n;
  }
}
class Xl extends cr {
  constructor(t, n) {
    super(), this.children = t, this.length = n, this.lines = 0;
    for (let r of t)
      this.lines += r.lines;
  }
  lineInner(t, n, r, i) {
    for (let o = 0; ; o++) {
      let s = this.children[o], a = i + s.length, u = r + s.lines - 1;
      if ((n ? u : a) >= t)
        return s.lineInner(t, n, r, i);
      i = a + 1, r = u + 1;
    }
  }
  decompose(t, n, r, i) {
    for (let o = 0, s = 0; s <= n && o < this.children.length; o++) {
      let a = this.children[o], u = s + a.length;
      if (t <= u && n >= s) {
        let c = i & ((s <= t ? 1 : 0) | (u >= n ? 2 : 0));
        s >= t && u <= n && !c ? r.push(a) : a.decompose(t - s, n - s, r, c);
      }
      s = u + 1;
    }
  }
  replace(t, n, r) {
    if ([t, n] = Dm(this, t, n), r.lines < this.lines)
      for (let i = 0, o = 0; i < this.children.length; i++) {
        let s = this.children[i], a = o + s.length;
        if (t >= o && n <= a) {
          let u = s.replace(t - o, n - o, r), c = this.lines - s.lines + u.lines;
          if (u.lines < c >> 4 && u.lines > c >> 6) {
            let d = this.children.slice();
            return d[i] = u, new Xl(d, this.length - (n - t) + r.length);
          }
          return super.replace(o, a, u);
        }
        o = a + 1;
      }
    return super.replace(t, n, r);
  }
  sliceString(t, n = this.length, r = `
`) {
    [t, n] = Dm(this, t, n);
    let i = "";
    for (let o = 0, s = 0; o < this.children.length && s <= n; o++) {
      let a = this.children[o], u = s + a.length;
      s > t && o && (i += r), t < u && n > s && (i += a.sliceString(t - s, n - s, r)), s = u + 1;
    }
    return i;
  }
  flatten(t) {
    for (let n of this.children)
      n.flatten(t);
  }
  scanIdentical(t, n) {
    if (!(t instanceof Xl))
      return 0;
    let r = 0, [i, o, s, a] = n > 0 ? [0, 0, this.children.length, t.children.length] : [this.children.length - 1, t.children.length - 1, -1, -1];
    for (; ; i += n, o += n) {
      if (i == s || o == a)
        return r;
      let u = this.children[i], c = t.children[o];
      if (u != c)
        return r + u.scanIdentical(c, n);
      r += u.length + 1;
    }
  }
  static from(t, n = t.reduce((r, i) => r + i.length + 1, -1)) {
    let r = 0;
    for (let m of t)
      r += m.lines;
    if (r < 32) {
      let m = [];
      for (let v of t)
        v.flatten(m);
      return new Si(m, n);
    }
    let i = Math.max(
      32,
      r >> 5
      /* Tree.BranchShift */
    ), o = i << 1, s = i >> 1, a = [], u = 0, c = -1, d = [];
    function f(m) {
      let v;
      if (m.lines > o && m instanceof Xl)
        for (let x of m.children)
          f(x);
      else m.lines > s && (u > s || !u) ? (h(), a.push(m)) : m instanceof Si && u && (v = d[d.length - 1]) instanceof Si && m.lines + v.lines <= 32 ? (u += m.lines, c += m.length + 1, d[d.length - 1] = new Si(v.text.concat(m.text), v.length + 1 + m.length)) : (u + m.lines > i && h(), u += m.lines, c += m.length + 1, d.push(m));
    }
    function h() {
      u != 0 && (a.push(d.length == 1 ? d[0] : Xl.from(d, c)), c = -1, u = d.length = 0);
    }
    for (let m of t)
      f(m);
    return h(), a.length == 1 ? a[0] : new Xl(a, n);
  }
}
cr.empty = /* @__PURE__ */ new Si([""], 0);
function mnt(e) {
  let t = -1;
  for (let n of e)
    t += n.length + 1;
  return t;
}
function rD(e, t, n = 0, r = 1e9) {
  for (let i = 0, o = 0, s = !0; o < e.length && i <= r; o++) {
    let a = e[o], u = i + a.length;
    u >= n && (u > r && (a = a.slice(0, r - i)), i < n && (a = a.slice(n - i)), s ? (t[t.length - 1] += a, s = !1) : t.push(a)), i = u + 1;
  }
  return t;
}
function T8(e, t, n) {
  return rD(e, [""], t, n);
}
class y0 {
  constructor(t, n = 1) {
    this.dir = n, this.done = !1, this.lineBreak = !1, this.value = "", this.nodes = [t], this.offsets = [n > 0 ? 1 : (t instanceof Si ? t.text.length : t.children.length) << 1];
  }
  nextInner(t, n) {
    for (this.done = this.lineBreak = !1; ; ) {
      let r = this.nodes.length - 1, i = this.nodes[r], o = this.offsets[r], s = o >> 1, a = i instanceof Si ? i.text.length : i.children.length;
      if (s == (n > 0 ? a : 0)) {
        if (r == 0)
          return this.done = !0, this.value = "", this;
        n > 0 && this.offsets[r - 1]++, this.nodes.pop(), this.offsets.pop();
      } else if ((o & 1) == (n > 0 ? 0 : 1)) {
        if (this.offsets[r] += n, t == 0)
          return this.lineBreak = !0, this.value = `
`, this;
        t--;
      } else if (i instanceof Si) {
        let u = i.text[s + (n < 0 ? -1 : 0)];
        if (this.offsets[r] += n, u.length > Math.max(0, t))
          return this.value = t == 0 ? u : n > 0 ? u.slice(t) : u.slice(0, u.length - t), this;
        t -= u.length;
      } else {
        let u = i.children[s + (n < 0 ? -1 : 0)];
        t > u.length ? (t -= u.length, this.offsets[r] += n) : (n < 0 && this.offsets[r]--, this.nodes.push(u), this.offsets.push(n > 0 ? 1 : (u instanceof Si ? u.text.length : u.children.length) << 1));
      }
    }
  }
  next(t = 0) {
    return t < 0 && (this.nextInner(-t, -this.dir), t = this.value.length), this.nextInner(t, this.dir);
  }
}
class gG {
  constructor(t, n, r) {
    this.value = "", this.done = !1, this.cursor = new y0(t, n > r ? -1 : 1), this.pos = n > r ? t.length : 0, this.from = Math.min(n, r), this.to = Math.max(n, r);
  }
  nextInner(t, n) {
    if (n < 0 ? this.pos <= this.from : this.pos >= this.to)
      return this.value = "", this.done = !0, this;
    t += Math.max(0, n < 0 ? this.pos - this.to : this.from - this.pos);
    let r = n < 0 ? this.pos - this.from : this.to - this.pos;
    t > r && (t = r), r -= t;
    let { value: i } = this.cursor.next(t);
    return this.pos += (i.length + t) * n, this.value = i.length <= r ? i : n < 0 ? i.slice(i.length - r) : i.slice(0, r), this.done = !this.value, this;
  }
  next(t = 0) {
    return t < 0 ? t = Math.max(t, this.from - this.pos) : t > 0 && (t = Math.min(t, this.to - this.pos)), this.nextInner(t, this.cursor.dir);
  }
  get lineBreak() {
    return this.cursor.lineBreak && this.value != "";
  }
}
class yG {
  constructor(t) {
    this.inner = t, this.afterBreak = !0, this.value = "", this.done = !1;
  }
  next(t = 0) {
    let { done: n, lineBreak: r, value: i } = this.inner.next(t);
    return n && this.afterBreak ? (this.value = "", this.afterBreak = !1) : n ? (this.done = !0, this.value = "") : r ? this.afterBreak ? this.value = "" : (this.afterBreak = !0, this.next()) : (this.value = i, this.afterBreak = !1), this;
  }
  get lineBreak() {
    return !1;
  }
}
typeof Symbol < "u" && (cr.prototype[Symbol.iterator] = function() {
  return this.iter();
}, y0.prototype[Symbol.iterator] = gG.prototype[Symbol.iterator] = yG.prototype[Symbol.iterator] = function() {
  return this;
});
class gnt {
  /**
  @internal
  */
  constructor(t, n, r, i) {
    this.from = t, this.to = n, this.number = r, this.text = i;
  }
  /**
  The length of the line (not including any line break after it).
  */
  get length() {
    return this.to - this.from;
  }
}
function Dm(e, t, n) {
  return t = Math.max(0, Math.min(e.length, t)), [t, Math.max(t, Math.min(e.length, n))];
}
function go(e, t, n = !0, r = !0) {
  return fnt(e, t, n, r);
}
function ynt(e) {
  return e >= 56320 && e < 57344;
}
function bnt(e) {
  return e >= 55296 && e < 56320;
}
function xs(e, t) {
  let n = e.charCodeAt(t);
  if (!bnt(n) || t + 1 == e.length)
    return n;
  let r = e.charCodeAt(t + 1);
  return ynt(r) ? (n - 55296 << 10) + (r - 56320) + 65536 : n;
}
function $$(e) {
  return e <= 65535 ? String.fromCharCode(e) : (e -= 65536, String.fromCharCode((e >> 10) + 55296, (e & 1023) + 56320));
}
function Ql(e) {
  return e < 65536 ? 1 : 2;
}
const mk = /\r\n?|\n/;
var es = /* @__PURE__ */ function(e) {
  return e[e.Simple = 0] = "Simple", e[e.TrackDel = 1] = "TrackDel", e[e.TrackBefore = 2] = "TrackBefore", e[e.TrackAfter = 3] = "TrackAfter", e;
}(es || (es = {}));
class pu {
  // Sections are encoded as pairs of integers. The first is the
  // length in the current document, and the second is -1 for
  // unaffected sections, and the length of the replacement content
  // otherwise. So an insertion would be (0, n>0), a deletion (n>0,
  // 0), and a replacement two positive numbers.
  /**
  @internal
  */
  constructor(t) {
    this.sections = t;
  }
  /**
  The length of the document before the change.
  */
  get length() {
    let t = 0;
    for (let n = 0; n < this.sections.length; n += 2)
      t += this.sections[n];
    return t;
  }
  /**
  The length of the document after the change.
  */
  get newLength() {
    let t = 0;
    for (let n = 0; n < this.sections.length; n += 2) {
      let r = this.sections[n + 1];
      t += r < 0 ? this.sections[n] : r;
    }
    return t;
  }
  /**
  False when there are actual changes in this set.
  */
  get empty() {
    return this.sections.length == 0 || this.sections.length == 2 && this.sections[1] < 0;
  }
  /**
  Iterate over the unchanged parts left by these changes. `posA`
  provides the position of the range in the old document, `posB`
  the new position in the changed document.
  */
  iterGaps(t) {
    for (let n = 0, r = 0, i = 0; n < this.sections.length; ) {
      let o = this.sections[n++], s = this.sections[n++];
      s < 0 ? (t(r, i, o), i += o) : i += s, r += o;
    }
  }
  /**
  Iterate over the ranges changed by these changes. (See
  [`ChangeSet.iterChanges`](https://codemirror.net/6/docs/ref/#state.ChangeSet.iterChanges) for a
  variant that also provides you with the inserted text.)
  `fromA`/`toA` provides the extent of the change in the starting
  document, `fromB`/`toB` the extent of the replacement in the
  changed document.
  
  When `individual` is true, adjacent changes (which are kept
  separate for [position mapping](https://codemirror.net/6/docs/ref/#state.ChangeDesc.mapPos)) are
  reported separately.
  */
  iterChangedRanges(t, n = !1) {
    gk(this, t, n);
  }
  /**
  Get a description of the inverted form of these changes.
  */
  get invertedDesc() {
    let t = [];
    for (let n = 0; n < this.sections.length; ) {
      let r = this.sections[n++], i = this.sections[n++];
      i < 0 ? t.push(r, i) : t.push(i, r);
    }
    return new pu(t);
  }
  /**
  Compute the combined effect of applying another set of changes
  after this one. The length of the document after this set should
  match the length before `other`.
  */
  composeDesc(t) {
    return this.empty ? t : t.empty ? this : bG(this, t);
  }
  /**
  Map this description, which should start with the same document
  as `other`, over another set of changes, so that it can be
  applied after it. When `before` is true, map as if the changes
  in `this` happened before the ones in `other`.
  */
  mapDesc(t, n = !1) {
    return t.empty ? this : yk(this, t, n);
  }
  mapPos(t, n = -1, r = es.Simple) {
    let i = 0, o = 0;
    for (let s = 0; s < this.sections.length; ) {
      let a = this.sections[s++], u = this.sections[s++], c = i + a;
      if (u < 0) {
        if (c > t)
          return o + (t - i);
        o += a;
      } else {
        if (r != es.Simple && c >= t && (r == es.TrackDel && i < t && c > t || r == es.TrackBefore && i < t || r == es.TrackAfter && c > t))
          return null;
        if (c > t || c == t && n < 0 && !a)
          return t == i || n < 0 ? o : o + u;
        o += u;
      }
      i = c;
    }
    if (t > i)
      throw new RangeError(`Position ${t} is out of range for changeset of length ${i}`);
    return o;
  }
  /**
  Check whether these changes touch a given range. When one of the
  changes entirely covers the range, the string `"cover"` is
  returned.
  */
  touchesRange(t, n = t) {
    for (let r = 0, i = 0; r < this.sections.length && i <= n; ) {
      let o = this.sections[r++], s = this.sections[r++], a = i + o;
      if (s >= 0 && i <= n && a >= t)
        return i < t && a > n ? "cover" : !0;
      i = a;
    }
    return !1;
  }
  /**
  @internal
  */
  toString() {
    let t = "";
    for (let n = 0; n < this.sections.length; ) {
      let r = this.sections[n++], i = this.sections[n++];
      t += (t ? " " : "") + r + (i >= 0 ? ":" + i : "");
    }
    return t;
  }
  /**
  Serialize this change desc to a JSON-representable value.
  */
  toJSON() {
    return this.sections;
  }
  /**
  Create a change desc from its JSON representation (as produced
  by [`toJSON`](https://codemirror.net/6/docs/ref/#state.ChangeDesc.toJSON).
  */
  static fromJSON(t) {
    if (!Array.isArray(t) || t.length % 2 || t.some((n) => typeof n != "number"))
      throw new RangeError("Invalid JSON representation of ChangeDesc");
    return new pu(t);
  }
  /**
  @internal
  */
  static create(t) {
    return new pu(t);
  }
}
class Ui extends pu {
  constructor(t, n) {
    super(t), this.inserted = n;
  }
  /**
  Apply the changes to a document, returning the modified
  document.
  */
  apply(t) {
    if (this.length != t.length)
      throw new RangeError("Applying change set to a document with the wrong length");
    return gk(this, (n, r, i, o, s) => t = t.replace(i, i + (r - n), s), !1), t;
  }
  mapDesc(t, n = !1) {
    return yk(this, t, n, !0);
  }
  /**
  Given the document as it existed _before_ the changes, return a
  change set that represents the inverse of this set, which could
  be used to go from the document created by the changes back to
  the document as it existed before the changes.
  */
  invert(t) {
    let n = this.sections.slice(), r = [];
    for (let i = 0, o = 0; i < n.length; i += 2) {
      let s = n[i], a = n[i + 1];
      if (a >= 0) {
        n[i] = a, n[i + 1] = s;
        let u = i >> 1;
        for (; r.length < u; )
          r.push(cr.empty);
        r.push(s ? t.slice(o, o + s) : cr.empty);
      }
      o += s;
    }
    return new Ui(n, r);
  }
  /**
  Combine two subsequent change sets into a single set. `other`
  must start in the document produced by `this`. If `this` goes
  `docA` → `docB` and `other` represents `docB` → `docC`, the
  returned value will represent the change `docA` → `docC`.
  */
  compose(t) {
    return this.empty ? t : t.empty ? this : bG(this, t, !0);
  }
  /**
  Given another change set starting in the same document, maps this
  change set over the other, producing a new change set that can be
  applied to the document produced by applying `other`. When
  `before` is `true`, order changes as if `this` comes before
  `other`, otherwise (the default) treat `other` as coming first.
  
  Given two changes `A` and `B`, `A.compose(B.map(A))` and
  `B.compose(A.map(B, true))` will produce the same document. This
  provides a basic form of [operational
  transformation](https://en.wikipedia.org/wiki/Operational_transformation),
  and can be used for collaborative editing.
  */
  map(t, n = !1) {
    return t.empty ? this : yk(this, t, n, !0);
  }
  /**
  Iterate over the changed ranges in the document, calling `f` for
  each, with the range in the original document (`fromA`-`toA`)
  and the range that replaces it in the new document
  (`fromB`-`toB`).
  
  When `individual` is true, adjacent changes are reported
  separately.
  */
  iterChanges(t, n = !1) {
    gk(this, t, n);
  }
  /**
  Get a [change description](https://codemirror.net/6/docs/ref/#state.ChangeDesc) for this change
  set.
  */
  get desc() {
    return pu.create(this.sections);
  }
  /**
  @internal
  */
  filter(t) {
    let n = [], r = [], i = [], o = new Q0(this);
    e: for (let s = 0, a = 0; ; ) {
      let u = s == t.length ? 1e9 : t[s++];
      for (; a < u || a == u && o.len == 0; ) {
        if (o.done)
          break e;
        let d = Math.min(o.len, u - a);
        Mo(i, d, -1);
        let f = o.ins == -1 ? -1 : o.off == 0 ? o.ins : 0;
        Mo(n, d, f), f > 0 && rd(r, n, o.text), o.forward(d), a += d;
      }
      let c = t[s++];
      for (; a < c; ) {
        if (o.done)
          break e;
        let d = Math.min(o.len, c - a);
        Mo(n, d, -1), Mo(i, d, o.ins == -1 ? -1 : o.off == 0 ? o.ins : 0), o.forward(d), a += d;
      }
    }
    return {
      changes: new Ui(n, r),
      filtered: pu.create(i)
    };
  }
  /**
  Serialize this change set to a JSON-representable value.
  */
  toJSON() {
    let t = [];
    for (let n = 0; n < this.sections.length; n += 2) {
      let r = this.sections[n], i = this.sections[n + 1];
      i < 0 ? t.push(r) : i == 0 ? t.push([r]) : t.push([r].concat(this.inserted[n >> 1].toJSON()));
    }
    return t;
  }
  /**
  Create a change set for the given changes, for a document of the
  given length, using `lineSep` as line separator.
  */
  static of(t, n, r) {
    let i = [], o = [], s = 0, a = null;
    function u(d = !1) {
      if (!d && !i.length)
        return;
      s < n && Mo(i, n - s, -1);
      let f = new Ui(i, o);
      a = a ? a.compose(f.map(a)) : f, i = [], o = [], s = 0;
    }
    function c(d) {
      if (Array.isArray(d))
        for (let f of d)
          c(f);
      else if (d instanceof Ui) {
        if (d.length != n)
          throw new RangeError(`Mismatched change set length (got ${d.length}, expected ${n})`);
        u(), a = a ? a.compose(d.map(a)) : d;
      } else {
        let { from: f, to: h = f, insert: m } = d;
        if (f > h || f < 0 || h > n)
          throw new RangeError(`Invalid change range ${f} to ${h} (in doc of length ${n})`);
        let v = m ? typeof m == "string" ? cr.of(m.split(r || mk)) : m : cr.empty, x = v.length;
        if (f == h && x == 0)
          return;
        f < s && u(), f > s && Mo(i, f - s, -1), Mo(i, h - f, x), rd(o, i, v), s = h;
      }
    }
    return c(t), u(!a), a;
  }
  /**
  Create an empty changeset of the given length.
  */
  static empty(t) {
    return new Ui(t ? [t, -1] : [], []);
  }
  /**
  Create a changeset from its JSON representation (as produced by
  [`toJSON`](https://codemirror.net/6/docs/ref/#state.ChangeSet.toJSON).
  */
  static fromJSON(t) {
    if (!Array.isArray(t))
      throw new RangeError("Invalid JSON representation of ChangeSet");
    let n = [], r = [];
    for (let i = 0; i < t.length; i++) {
      let o = t[i];
      if (typeof o == "number")
        n.push(o, -1);
      else {
        if (!Array.isArray(o) || typeof o[0] != "number" || o.some((s, a) => a && typeof s != "string"))
          throw new RangeError("Invalid JSON representation of ChangeSet");
        if (o.length == 1)
          n.push(o[0], 0);
        else {
          for (; r.length < i; )
            r.push(cr.empty);
          r[i] = cr.of(o.slice(1)), n.push(o[0], r[i].length);
        }
      }
    }
    return new Ui(n, r);
  }
  /**
  @internal
  */
  static createSet(t, n) {
    return new Ui(t, n);
  }
}
function Mo(e, t, n, r = !1) {
  if (t == 0 && n <= 0)
    return;
  let i = e.length - 2;
  i >= 0 && n <= 0 && n == e[i + 1] ? e[i] += t : i >= 0 && t == 0 && e[i] == 0 ? e[i + 1] += n : r ? (e[i] += t, e[i + 1] += n) : e.push(t, n);
}
function rd(e, t, n) {
  if (n.length == 0)
    return;
  let r = t.length - 2 >> 1;
  if (r < e.length)
    e[e.length - 1] = e[e.length - 1].append(n);
  else {
    for (; e.length < r; )
      e.push(cr.empty);
    e.push(n);
  }
}
function gk(e, t, n) {
  let r = e.inserted;
  for (let i = 0, o = 0, s = 0; s < e.sections.length; ) {
    let a = e.sections[s++], u = e.sections[s++];
    if (u < 0)
      i += a, o += a;
    else {
      let c = i, d = o, f = cr.empty;
      for (; c += a, d += u, u && r && (f = f.append(r[s - 2 >> 1])), !(n || s == e.sections.length || e.sections[s + 1] < 0); )
        a = e.sections[s++], u = e.sections[s++];
      t(i, c, o, d, f), i = c, o = d;
    }
  }
}
function yk(e, t, n, r = !1) {
  let i = [], o = r ? [] : null, s = new Q0(e), a = new Q0(t);
  for (let u = -1; ; ) {
    if (s.done && a.len || a.done && s.len)
      throw new Error("Mismatched change set lengths");
    if (s.ins == -1 && a.ins == -1) {
      let c = Math.min(s.len, a.len);
      Mo(i, c, -1), s.forward(c), a.forward(c);
    } else if (a.ins >= 0 && (s.ins < 0 || u == s.i || s.off == 0 && (a.len < s.len || a.len == s.len && !n))) {
      let c = a.len;
      for (Mo(i, a.ins, -1); c; ) {
        let d = Math.min(s.len, c);
        s.ins >= 0 && u < s.i && s.len <= d && (Mo(i, 0, s.ins), o && rd(o, i, s.text), u = s.i), s.forward(d), c -= d;
      }
      a.next();
    } else if (s.ins >= 0) {
      let c = 0, d = s.len;
      for (; d; )
        if (a.ins == -1) {
          let f = Math.min(d, a.len);
          c += f, d -= f, a.forward(f);
        } else if (a.ins == 0 && a.len < d)
          d -= a.len, a.next();
        else
          break;
      Mo(i, c, u < s.i ? s.ins : 0), o && u < s.i && rd(o, i, s.text), u = s.i, s.forward(s.len - d);
    } else {
      if (s.done && a.done)
        return o ? Ui.createSet(i, o) : pu.create(i);
      throw new Error("Mismatched change set lengths");
    }
  }
}
function bG(e, t, n = !1) {
  let r = [], i = n ? [] : null, o = new Q0(e), s = new Q0(t);
  for (let a = !1; ; ) {
    if (o.done && s.done)
      return i ? Ui.createSet(r, i) : pu.create(r);
    if (o.ins == 0)
      Mo(r, o.len, 0, a), o.next();
    else if (s.len == 0 && !s.done)
      Mo(r, 0, s.ins, a), i && rd(i, r, s.text), s.next();
    else {
      if (o.done || s.done)
        throw new Error("Mismatched change set lengths");
      {
        let u = Math.min(o.len2, s.len), c = r.length;
        if (o.ins == -1) {
          let d = s.ins == -1 ? -1 : s.off ? 0 : s.ins;
          Mo(r, u, d, a), i && d && rd(i, r, s.text);
        } else s.ins == -1 ? (Mo(r, o.off ? 0 : o.len, u, a), i && rd(i, r, o.textBit(u))) : (Mo(r, o.off ? 0 : o.len, s.off ? 0 : s.ins, a), i && !s.off && rd(i, r, s.text));
        a = (o.ins > u || s.ins >= 0 && s.len > u) && (a || r.length > c), o.forward2(u), s.forward(u);
      }
    }
  }
}
class Q0 {
  constructor(t) {
    this.set = t, this.i = 0, this.next();
  }
  next() {
    let { sections: t } = this.set;
    this.i < t.length ? (this.len = t[this.i++], this.ins = t[this.i++]) : (this.len = 0, this.ins = -2), this.off = 0;
  }
  get done() {
    return this.ins == -2;
  }
  get len2() {
    return this.ins < 0 ? this.len : this.ins;
  }
  get text() {
    let { inserted: t } = this.set, n = this.i - 2 >> 1;
    return n >= t.length ? cr.empty : t[n];
  }
  textBit(t) {
    let { inserted: n } = this.set, r = this.i - 2 >> 1;
    return r >= n.length && !t ? cr.empty : n[r].slice(this.off, t == null ? void 0 : this.off + t);
  }
  forward(t) {
    t == this.len ? this.next() : (this.len -= t, this.off += t);
  }
  forward2(t) {
    this.ins == -1 ? this.forward(t) : t == this.ins ? this.next() : (this.ins -= t, this.off += t);
  }
}
class Ip {
  constructor(t, n, r) {
    this.from = t, this.to = n, this.flags = r;
  }
  /**
  The anchor of the range—the side that doesn't move when you
  extend it.
  */
  get anchor() {
    return this.flags & 32 ? this.to : this.from;
  }
  /**
  The head of the range, which is moved when the range is
  [extended](https://codemirror.net/6/docs/ref/#state.SelectionRange.extend).
  */
  get head() {
    return this.flags & 32 ? this.from : this.to;
  }
  /**
  True when `anchor` and `head` are at the same position.
  */
  get empty() {
    return this.from == this.to;
  }
  /**
  If this is a cursor that is explicitly associated with the
  character on one of its sides, this returns the side. -1 means
  the character before its position, 1 the character after, and 0
  means no association.
  */
  get assoc() {
    return this.flags & 8 ? -1 : this.flags & 16 ? 1 : 0;
  }
  /**
  The bidirectional text level associated with this cursor, if
  any.
  */
  get bidiLevel() {
    let t = this.flags & 7;
    return t == 7 ? null : t;
  }
  /**
  The goal column (stored vertical offset) associated with a
  cursor. This is used to preserve the vertical position when
  [moving](https://codemirror.net/6/docs/ref/#view.EditorView.moveVertically) across
  lines of different length.
  */
  get goalColumn() {
    let t = this.flags >> 6;
    return t == 16777215 ? void 0 : t;
  }
  /**
  Map this range through a change, producing a valid range in the
  updated document.
  */
  map(t, n = -1) {
    let r, i;
    return this.empty ? r = i = t.mapPos(this.from, n) : (r = t.mapPos(this.from, 1), i = t.mapPos(this.to, -1)), r == this.from && i == this.to ? this : new Ip(r, i, this.flags);
  }
  /**
  Extend this range to cover at least `from` to `to`.
  */
  extend(t, n = t) {
    if (t <= this.anchor && n >= this.anchor)
      return it.range(t, n);
    let r = Math.abs(t - this.anchor) > Math.abs(n - this.anchor) ? t : n;
    return it.range(this.anchor, r);
  }
  /**
  Compare this range to another range.
  */
  eq(t, n = !1) {
    return this.anchor == t.anchor && this.head == t.head && (!n || !this.empty || this.assoc == t.assoc);
  }
  /**
  Return a JSON-serializable object representing the range.
  */
  toJSON() {
    return { anchor: this.anchor, head: this.head };
  }
  /**
  Convert a JSON representation of a range to a `SelectionRange`
  instance.
  */
  static fromJSON(t) {
    if (!t || typeof t.anchor != "number" || typeof t.head != "number")
      throw new RangeError("Invalid JSON representation for SelectionRange");
    return it.range(t.anchor, t.head);
  }
  /**
  @internal
  */
  static create(t, n, r) {
    return new Ip(t, n, r);
  }
}
class it {
  constructor(t, n) {
    this.ranges = t, this.mainIndex = n;
  }
  /**
  Map a selection through a change. Used to adjust the selection
  position for changes.
  */
  map(t, n = -1) {
    return t.empty ? this : it.create(this.ranges.map((r) => r.map(t, n)), this.mainIndex);
  }
  /**
  Compare this selection to another selection. By default, ranges
  are compared only by position. When `includeAssoc` is true,
  cursor ranges must also have the same
  [`assoc`](https://codemirror.net/6/docs/ref/#state.SelectionRange.assoc) value.
  */
  eq(t, n = !1) {
    if (this.ranges.length != t.ranges.length || this.mainIndex != t.mainIndex)
      return !1;
    for (let r = 0; r < this.ranges.length; r++)
      if (!this.ranges[r].eq(t.ranges[r], n))
        return !1;
    return !0;
  }
  /**
  Get the primary selection range. Usually, you should make sure
  your code applies to _all_ ranges, by using methods like
  [`changeByRange`](https://codemirror.net/6/docs/ref/#state.EditorState.changeByRange).
  */
  get main() {
    return this.ranges[this.mainIndex];
  }
  /**
  Make sure the selection only has one range. Returns a selection
  holding only the main range from this selection.
  */
  asSingle() {
    return this.ranges.length == 1 ? this : new it([this.main], 0);
  }
  /**
  Extend this selection with an extra range.
  */
  addRange(t, n = !0) {
    return it.create([t].concat(this.ranges), n ? 0 : this.mainIndex + 1);
  }
  /**
  Replace a given range with another range, and then normalize the
  selection to merge and sort ranges if necessary.
  */
  replaceRange(t, n = this.mainIndex) {
    let r = this.ranges.slice();
    return r[n] = t, it.create(r, this.mainIndex);
  }
  /**
  Convert this selection to an object that can be serialized to
  JSON.
  */
  toJSON() {
    return { ranges: this.ranges.map((t) => t.toJSON()), main: this.mainIndex };
  }
  /**
  Create a selection from a JSON representation.
  */
  static fromJSON(t) {
    if (!t || !Array.isArray(t.ranges) || typeof t.main != "number" || t.main >= t.ranges.length)
      throw new RangeError("Invalid JSON representation for EditorSelection");
    return new it(t.ranges.map((n) => Ip.fromJSON(n)), t.main);
  }
  /**
  Create a selection holding a single range.
  */
  static single(t, n = t) {
    return new it([it.range(t, n)], 0);
  }
  /**
  Sort and merge the given set of ranges, creating a valid
  selection.
  */
  static create(t, n = 0) {
    if (t.length == 0)
      throw new RangeError("A selection needs at least one range");
    for (let r = 0, i = 0; i < t.length; i++) {
      let o = t[i];
      if (o.empty ? o.from <= r : o.from < r)
        return it.normalized(t.slice(), n);
      r = o.to;
    }
    return new it(t, n);
  }
  /**
  Create a cursor selection range at the given position. You can
  safely ignore the optional arguments in most situations.
  */
  static cursor(t, n = 0, r, i) {
    return Ip.create(t, t, (n == 0 ? 0 : n < 0 ? 8 : 16) | (r == null ? 7 : Math.min(6, r)) | (i ?? 16777215) << 6);
  }
  /**
  Create a selection range.
  */
  static range(t, n, r, i) {
    let o = (r ?? 16777215) << 6 | (i == null ? 7 : Math.min(6, i));
    return n < t ? Ip.create(n, t, 48 | o) : Ip.create(t, n, (n > t ? 8 : 0) | o);
  }
  /**
  @internal
  */
  static normalized(t, n = 0) {
    let r = t[n];
    t.sort((i, o) => i.from - o.from), n = t.indexOf(r);
    for (let i = 1; i < t.length; i++) {
      let o = t[i], s = t[i - 1];
      if (o.empty ? o.from <= s.to : o.from < s.to) {
        let a = s.from, u = Math.max(o.to, s.to);
        i <= n && n--, t.splice(--i, 2, o.anchor > o.head ? it.range(u, a) : it.range(a, u));
      }
    }
    return new it(t, n);
  }
}
function vG(e, t) {
  for (let n of e.ranges)
    if (n.to > t)
      throw new RangeError("Selection points outside of document");
}
let N$ = 0;
class zt {
  constructor(t, n, r, i, o) {
    this.combine = t, this.compareInput = n, this.compare = r, this.isStatic = i, this.id = N$++, this.default = t([]), this.extensions = typeof o == "function" ? o(this) : o;
  }
  /**
  Returns a facet reader for this facet, which can be used to
  [read](https://codemirror.net/6/docs/ref/#state.EditorState.facet) it but not to define values for it.
  */
  get reader() {
    return this;
  }
  /**
  Define a new facet.
  */
  static define(t = {}) {
    return new zt(t.combine || ((n) => n), t.compareInput || ((n, r) => n === r), t.compare || (t.combine ? (n, r) => n === r : M$), !!t.static, t.enables);
  }
  /**
  Returns an extension that adds the given value to this facet.
  */
  of(t) {
    return new iD([], this, 0, t);
  }
  /**
  Create an extension that computes a value for the facet from a
  state. You must take care to declare the parts of the state that
  this value depends on, since your function is only called again
  for a new state when one of those parts changed.
  
  In cases where your value depends only on a single field, you'll
  want to use the [`from`](https://codemirror.net/6/docs/ref/#state.Facet.from) method instead.
  */
  compute(t, n) {
    if (this.isStatic)
      throw new Error("Can't compute a static facet");
    return new iD(t, this, 1, n);
  }
  /**
  Create an extension that computes zero or more values for this
  facet from a state.
  */
  computeN(t, n) {
    if (this.isStatic)
      throw new Error("Can't compute a static facet");
    return new iD(t, this, 2, n);
  }
  from(t, n) {
    return n || (n = (r) => r), this.compute([t], (r) => n(r.field(t)));
  }
}
function M$(e, t) {
  return e == t || e.length == t.length && e.every((n, r) => n === t[r]);
}
class iD {
  constructor(t, n, r, i) {
    this.dependencies = t, this.facet = n, this.type = r, this.value = i, this.id = N$++;
  }
  dynamicSlot(t) {
    var n;
    let r = this.value, i = this.facet.compareInput, o = this.id, s = t[o] >> 1, a = this.type == 2, u = !1, c = !1, d = [];
    for (let f of this.dependencies)
      f == "doc" ? u = !0 : f == "selection" ? c = !0 : ((n = t[f.id]) !== null && n !== void 0 ? n : 1) & 1 || d.push(t[f.id]);
    return {
      create(f) {
        return f.values[s] = r(f), 1;
      },
      update(f, h) {
        if (u && h.docChanged || c && (h.docChanged || h.selection) || bk(f, d)) {
          let m = r(f);
          if (a ? !S8(m, f.values[s], i) : !i(m, f.values[s]))
            return f.values[s] = m, 1;
        }
        return 0;
      },
      reconfigure: (f, h) => {
        let m, v = h.config.address[o];
        if (v != null) {
          let x = oC(h, v);
          if (this.dependencies.every((C) => C instanceof zt ? h.facet(C) === f.facet(C) : C instanceof wo ? h.field(C, !1) == f.field(C, !1) : !0) || (a ? S8(m = r(f), x, i) : i(m = r(f), x)))
            return f.values[s] = x, 0;
        } else
          m = r(f);
        return f.values[s] = m, 1;
      }
    };
  }
}
function S8(e, t, n) {
  if (e.length != t.length)
    return !1;
  for (let r = 0; r < e.length; r++)
    if (!n(e[r], t[r]))
      return !1;
  return !0;
}
function bk(e, t) {
  let n = !1;
  for (let r of t)
    b0(e, r) & 1 && (n = !0);
  return n;
}
function vnt(e, t, n) {
  let r = n.map((u) => e[u.id]), i = n.map((u) => u.type), o = r.filter((u) => !(u & 1)), s = e[t.id] >> 1;
  function a(u) {
    let c = [];
    for (let d = 0; d < r.length; d++) {
      let f = oC(u, r[d]);
      if (i[d] == 2)
        for (let h of f)
          c.push(h);
      else
        c.push(f);
    }
    return t.combine(c);
  }
  return {
    create(u) {
      for (let c of r)
        b0(u, c);
      return u.values[s] = a(u), 1;
    },
    update(u, c) {
      if (!bk(u, o))
        return 0;
      let d = a(u);
      return t.compare(d, u.values[s]) ? 0 : (u.values[s] = d, 1);
    },
    reconfigure(u, c) {
      let d = bk(u, r), f = c.config.facets[t.id], h = c.facet(t);
      if (f && !d && M$(n, f))
        return u.values[s] = h, 0;
      let m = a(u);
      return t.compare(m, h) ? (u.values[s] = h, 0) : (u.values[s] = m, 1);
    }
  };
}
const A8 = /* @__PURE__ */ zt.define({ static: !0 });
class wo {
  constructor(t, n, r, i, o) {
    this.id = t, this.createF = n, this.updateF = r, this.compareF = i, this.spec = o, this.provides = void 0;
  }
  /**
  Define a state field.
  */
  static define(t) {
    let n = new wo(N$++, t.create, t.update, t.compare || ((r, i) => r === i), t);
    return t.provide && (n.provides = t.provide(n)), n;
  }
  create(t) {
    let n = t.facet(A8).find((r) => r.field == this);
    return ((n == null ? void 0 : n.create) || this.createF)(t);
  }
  /**
  @internal
  */
  slot(t) {
    let n = t[this.id] >> 1;
    return {
      create: (r) => (r.values[n] = this.create(r), 1),
      update: (r, i) => {
        let o = r.values[n], s = this.updateF(o, i);
        return this.compareF(o, s) ? 0 : (r.values[n] = s, 1);
      },
      reconfigure: (r, i) => i.config.address[this.id] != null ? (r.values[n] = i.field(this), 0) : (r.values[n] = this.create(r), 1)
    };
  }
  /**
  Returns an extension that enables this field and overrides the
  way it is initialized. Can be useful when you need to provide a
  non-default starting value for the field.
  */
  init(t) {
    return [this, A8.of({ field: this, create: t })];
  }
  /**
  State field instances can be used as
  [`Extension`](https://codemirror.net/6/docs/ref/#state.Extension) values to enable the field in a
  given state.
  */
  get extension() {
    return this;
  }
}
const Sp = { lowest: 4, low: 3, default: 2, high: 1, highest: 0 };
function Ny(e) {
  return (t) => new xG(t, e);
}
const Pf = {
  /**
  The highest precedence level, for extensions that should end up
  near the start of the precedence ordering.
  */
  highest: /* @__PURE__ */ Ny(Sp.highest),
  /**
  A higher-than-default precedence, for extensions that should
  come before those with default precedence.
  */
  high: /* @__PURE__ */ Ny(Sp.high),
  /**
  The default precedence, which is also used for extensions
  without an explicit precedence.
  */
  default: /* @__PURE__ */ Ny(Sp.default),
  /**
  A lower-than-default precedence.
  */
  low: /* @__PURE__ */ Ny(Sp.low),
  /**
  The lowest precedence level. Meant for things that should end up
  near the end of the extension order.
  */
  lowest: /* @__PURE__ */ Ny(Sp.lowest)
};
class xG {
  constructor(t, n) {
    this.inner = t, this.prec = n;
  }
}
class oT {
  /**
  Create an instance of this compartment to add to your [state
  configuration](https://codemirror.net/6/docs/ref/#state.EditorStateConfig.extensions).
  */
  of(t) {
    return new vk(this, t);
  }
  /**
  Create an [effect](https://codemirror.net/6/docs/ref/#state.TransactionSpec.effects) that
  reconfigures this compartment.
  */
  reconfigure(t) {
    return oT.reconfigure.of({ compartment: this, extension: t });
  }
  /**
  Get the current content of the compartment in the state, or
  `undefined` if it isn't present.
  */
  get(t) {
    return t.config.compartments.get(this);
  }
}
class vk {
  constructor(t, n) {
    this.compartment = t, this.inner = n;
  }
}
class iC {
  constructor(t, n, r, i, o, s) {
    for (this.base = t, this.compartments = n, this.dynamicSlots = r, this.address = i, this.staticValues = o, this.facets = s, this.statusTemplate = []; this.statusTemplate.length < r.length; )
      this.statusTemplate.push(
        0
        /* SlotStatus.Unresolved */
      );
  }
  staticFacet(t) {
    let n = this.address[t.id];
    return n == null ? t.default : this.staticValues[n >> 1];
  }
  static resolve(t, n, r) {
    let i = [], o = /* @__PURE__ */ Object.create(null), s = /* @__PURE__ */ new Map();
    for (let h of xnt(t, n, s))
      h instanceof wo ? i.push(h) : (o[h.facet.id] || (o[h.facet.id] = [])).push(h);
    let a = /* @__PURE__ */ Object.create(null), u = [], c = [];
    for (let h of i)
      a[h.id] = c.length << 1, c.push((m) => h.slot(m));
    let d = r == null ? void 0 : r.config.facets;
    for (let h in o) {
      let m = o[h], v = m[0].facet, x = d && d[h] || [];
      if (m.every(
        (C) => C.type == 0
        /* Provider.Static */
      ))
        if (a[v.id] = u.length << 1 | 1, M$(x, m))
          u.push(r.facet(v));
        else {
          let C = v.combine(m.map((E) => E.value));
          u.push(r && v.compare(C, r.facet(v)) ? r.facet(v) : C);
        }
      else {
        for (let C of m)
          C.type == 0 ? (a[C.id] = u.length << 1 | 1, u.push(C.value)) : (a[C.id] = c.length << 1, c.push((E) => C.dynamicSlot(E)));
        a[v.id] = c.length << 1, c.push((C) => vnt(C, v, m));
      }
    }
    let f = c.map((h) => h(a));
    return new iC(t, s, f, a, u, o);
  }
}
function xnt(e, t, n) {
  let r = [[], [], [], [], []], i = /* @__PURE__ */ new Map();
  function o(s, a) {
    let u = i.get(s);
    if (u != null) {
      if (u <= a)
        return;
      let c = r[u].indexOf(s);
      c > -1 && r[u].splice(c, 1), s instanceof vk && n.delete(s.compartment);
    }
    if (i.set(s, a), Array.isArray(s))
      for (let c of s)
        o(c, a);
    else if (s instanceof vk) {
      if (n.has(s.compartment))
        throw new RangeError("Duplicate use of compartment in extensions");
      let c = t.get(s.compartment) || s.inner;
      n.set(s.compartment, c), o(c, a);
    } else if (s instanceof xG)
      o(s.inner, s.prec);
    else if (s instanceof wo)
      r[a].push(s), s.provides && o(s.provides, a);
    else if (s instanceof iD)
      r[a].push(s), s.facet.extensions && o(s.facet.extensions, Sp.default);
    else {
      let c = s.extension;
      if (!c)
        throw new Error(`Unrecognized extension value in extension set (${s}). This sometimes happens because multiple instances of @codemirror/state are loaded, breaking instanceof checks.`);
      o(c, a);
    }
  }
  return o(e, Sp.default), r.reduce((s, a) => s.concat(a));
}
function b0(e, t) {
  if (t & 1)
    return 2;
  let n = t >> 1, r = e.status[n];
  if (r == 4)
    throw new Error("Cyclic dependency between fields and/or facets");
  if (r & 2)
    return r;
  e.status[n] = 4;
  let i = e.computeSlot(e, e.config.dynamicSlots[n]);
  return e.status[n] = 2 | i;
}
function oC(e, t) {
  return t & 1 ? e.config.staticValues[t >> 1] : e.values[t >> 1];
}
const DG = /* @__PURE__ */ zt.define(), xk = /* @__PURE__ */ zt.define({
  combine: (e) => e.some((t) => t),
  static: !0
}), CG = /* @__PURE__ */ zt.define({
  combine: (e) => e.length ? e[0] : void 0,
  static: !0
}), EG = /* @__PURE__ */ zt.define(), TG = /* @__PURE__ */ zt.define(), SG = /* @__PURE__ */ zt.define(), AG = /* @__PURE__ */ zt.define({
  combine: (e) => e.length ? e[0] : !1
});
class Au {
  /**
  @internal
  */
  constructor(t, n) {
    this.type = t, this.value = n;
  }
  /**
  Define a new type of annotation.
  */
  static define() {
    return new Dnt();
  }
}
class Dnt {
  /**
  Create an instance of this annotation.
  */
  of(t) {
    return new Au(this, t);
  }
}
class Cnt {
  /**
  @internal
  */
  constructor(t) {
    this.map = t;
  }
  /**
  Create a [state effect](https://codemirror.net/6/docs/ref/#state.StateEffect) instance of this
  type.
  */
  of(t) {
    return new An(this, t);
  }
}
class An {
  /**
  @internal
  */
  constructor(t, n) {
    this.type = t, this.value = n;
  }
  /**
  Map this effect through a position mapping. Will return
  `undefined` when that ends up deleting the effect.
  */
  map(t) {
    let n = this.type.map(this.value, t);
    return n === void 0 ? void 0 : n == this.value ? this : new An(this.type, n);
  }
  /**
  Tells you whether this effect object is of a given
  [type](https://codemirror.net/6/docs/ref/#state.StateEffectType).
  */
  is(t) {
    return this.type == t;
  }
  /**
  Define a new effect type. The type parameter indicates the type
  of values that his effect holds. It should be a type that
  doesn't include `undefined`, since that is used in
  [mapping](https://codemirror.net/6/docs/ref/#state.StateEffect.map) to indicate that an effect is
  removed.
  */
  static define(t = {}) {
    return new Cnt(t.map || ((n) => n));
  }
  /**
  Map an array of effects through a change set.
  */
  static mapEffects(t, n) {
    if (!t.length)
      return t;
    let r = [];
    for (let i of t) {
      let o = i.map(n);
      o && r.push(o);
    }
    return r;
  }
}
An.reconfigure = /* @__PURE__ */ An.define();
An.appendConfig = /* @__PURE__ */ An.define();
class Wi {
  constructor(t, n, r, i, o, s) {
    this.startState = t, this.changes = n, this.selection = r, this.effects = i, this.annotations = o, this.scrollIntoView = s, this._doc = null, this._state = null, r && vG(r, n.newLength), o.some((a) => a.type == Wi.time) || (this.annotations = o.concat(Wi.time.of(Date.now())));
  }
  /**
  @internal
  */
  static create(t, n, r, i, o, s) {
    return new Wi(t, n, r, i, o, s);
  }
  /**
  The new document produced by the transaction. Contrary to
  [`.state`](https://codemirror.net/6/docs/ref/#state.Transaction.state)`.doc`, accessing this won't
  force the entire new state to be computed right away, so it is
  recommended that [transaction
  filters](https://codemirror.net/6/docs/ref/#state.EditorState^transactionFilter) use this getter
  when they need to look at the new document.
  */
  get newDoc() {
    return this._doc || (this._doc = this.changes.apply(this.startState.doc));
  }
  /**
  The new selection produced by the transaction. If
  [`this.selection`](https://codemirror.net/6/docs/ref/#state.Transaction.selection) is undefined,
  this will [map](https://codemirror.net/6/docs/ref/#state.EditorSelection.map) the start state's
  current selection through the changes made by the transaction.
  */
  get newSelection() {
    return this.selection || this.startState.selection.map(this.changes);
  }
  /**
  The new state created by the transaction. Computed on demand
  (but retained for subsequent access), so it is recommended not to
  access it in [transaction
  filters](https://codemirror.net/6/docs/ref/#state.EditorState^transactionFilter) when possible.
  */
  get state() {
    return this._state || this.startState.applyTransaction(this), this._state;
  }
  /**
  Get the value of the given annotation type, if any.
  */
  annotation(t) {
    for (let n of this.annotations)
      if (n.type == t)
        return n.value;
  }
  /**
  Indicates whether the transaction changed the document.
  */
  get docChanged() {
    return !this.changes.empty;
  }
  /**
  Indicates whether this transaction reconfigures the state
  (through a [configuration compartment](https://codemirror.net/6/docs/ref/#state.Compartment) or
  with a top-level configuration
  [effect](https://codemirror.net/6/docs/ref/#state.StateEffect^reconfigure).
  */
  get reconfigured() {
    return this.startState.config != this.state.config;
  }
  /**
  Returns true if the transaction has a [user
  event](https://codemirror.net/6/docs/ref/#state.Transaction^userEvent) annotation that is equal to
  or more specific than `event`. For example, if the transaction
  has `"select.pointer"` as user event, `"select"` and
  `"select.pointer"` will match it.
  */
  isUserEvent(t) {
    let n = this.annotation(Wi.userEvent);
    return !!(n && (n == t || n.length > t.length && n.slice(0, t.length) == t && n[t.length] == "."));
  }
}
Wi.time = /* @__PURE__ */ Au.define();
Wi.userEvent = /* @__PURE__ */ Au.define();
Wi.addToHistory = /* @__PURE__ */ Au.define();
Wi.remote = /* @__PURE__ */ Au.define();
function Ent(e, t) {
  let n = [];
  for (let r = 0, i = 0; ; ) {
    let o, s;
    if (r < e.length && (i == t.length || t[i] >= e[r]))
      o = e[r++], s = e[r++];
    else if (i < t.length)
      o = t[i++], s = t[i++];
    else
      return n;
    !n.length || n[n.length - 1] < o ? n.push(o, s) : n[n.length - 1] < s && (n[n.length - 1] = s);
  }
}
function wG(e, t, n) {
  var r;
  let i, o, s;
  return n ? (i = t.changes, o = Ui.empty(t.changes.length), s = e.changes.compose(t.changes)) : (i = t.changes.map(e.changes), o = e.changes.mapDesc(t.changes, !0), s = e.changes.compose(i)), {
    changes: s,
    selection: t.selection ? t.selection.map(o) : (r = e.selection) === null || r === void 0 ? void 0 : r.map(i),
    effects: An.mapEffects(e.effects, i).concat(An.mapEffects(t.effects, o)),
    annotations: e.annotations.length ? e.annotations.concat(t.annotations) : t.annotations,
    scrollIntoView: e.scrollIntoView || t.scrollIntoView
  };
}
function Dk(e, t, n) {
  let r = t.selection, i = Zh(t.annotations);
  return t.userEvent && (i = i.concat(Wi.userEvent.of(t.userEvent))), {
    changes: t.changes instanceof Ui ? t.changes : Ui.of(t.changes || [], n, e.facet(CG)),
    selection: r && (r instanceof it ? r : it.single(r.anchor, r.head)),
    effects: Zh(t.effects),
    annotations: i,
    scrollIntoView: !!t.scrollIntoView
  };
}
function PG(e, t, n) {
  let r = Dk(e, t.length ? t[0] : {}, e.doc.length);
  t.length && t[0].filter === !1 && (n = !1);
  for (let o = 1; o < t.length; o++) {
    t[o].filter === !1 && (n = !1);
    let s = !!t[o].sequential;
    r = wG(r, Dk(e, t[o], s ? r.changes.newLength : e.doc.length), s);
  }
  let i = Wi.create(e, r.changes, r.selection, r.effects, r.annotations, r.scrollIntoView);
  return Snt(n ? Tnt(i) : i);
}
function Tnt(e) {
  let t = e.startState, n = !0;
  for (let i of t.facet(EG)) {
    let o = i(e);
    if (o === !1) {
      n = !1;
      break;
    }
    Array.isArray(o) && (n = n === !0 ? o : Ent(n, o));
  }
  if (n !== !0) {
    let i, o;
    if (n === !1)
      o = e.changes.invertedDesc, i = Ui.empty(t.doc.length);
    else {
      let s = e.changes.filter(n);
      i = s.changes, o = s.filtered.mapDesc(s.changes).invertedDesc;
    }
    e = Wi.create(t, i, e.selection && e.selection.map(o), An.mapEffects(e.effects, o), e.annotations, e.scrollIntoView);
  }
  let r = t.facet(TG);
  for (let i = r.length - 1; i >= 0; i--) {
    let o = r[i](e);
    o instanceof Wi ? e = o : Array.isArray(o) && o.length == 1 && o[0] instanceof Wi ? e = o[0] : e = PG(t, Zh(o), !1);
  }
  return e;
}
function Snt(e) {
  let t = e.startState, n = t.facet(SG), r = e;
  for (let i = n.length - 1; i >= 0; i--) {
    let o = n[i](e);
    o && Object.keys(o).length && (r = wG(r, Dk(t, o, e.changes.newLength), !0));
  }
  return r == e ? e : Wi.create(t, e.changes, e.selection, r.effects, r.annotations, r.scrollIntoView);
}
const Ant = [];
function Zh(e) {
  return e == null ? Ant : Array.isArray(e) ? e : [e];
}
var Qr = /* @__PURE__ */ function(e) {
  return e[e.Word = 0] = "Word", e[e.Space = 1] = "Space", e[e.Other = 2] = "Other", e;
}(Qr || (Qr = {}));
const wnt = /[\u00df\u0587\u0590-\u05f4\u0600-\u06ff\u3040-\u309f\u30a0-\u30ff\u3400-\u4db5\u4e00-\u9fcc\uac00-\ud7af]/;
let Ck;
try {
  Ck = /* @__PURE__ */ new RegExp("[\\p{Alphabetic}\\p{Number}_]", "u");
} catch {
}
function Pnt(e) {
  if (Ck)
    return Ck.test(e);
  for (let t = 0; t < e.length; t++) {
    let n = e[t];
    if (/\w/.test(n) || n > "" && (n.toUpperCase() != n.toLowerCase() || wnt.test(n)))
      return !0;
  }
  return !1;
}
function knt(e) {
  return (t) => {
    if (!/\S/.test(t))
      return Qr.Space;
    if (Pnt(t))
      return Qr.Word;
    for (let n = 0; n < e.length; n++)
      if (t.indexOf(e[n]) > -1)
        return Qr.Word;
    return Qr.Other;
  };
}
class Jn {
  constructor(t, n, r, i, o, s) {
    this.config = t, this.doc = n, this.selection = r, this.values = i, this.status = t.statusTemplate.slice(), this.computeSlot = o, s && (s._state = this);
    for (let a = 0; a < this.config.dynamicSlots.length; a++)
      b0(this, a << 1);
    this.computeSlot = null;
  }
  field(t, n = !0) {
    let r = this.config.address[t.id];
    if (r == null) {
      if (n)
        throw new RangeError("Field is not present in this state");
      return;
    }
    return b0(this, r), oC(this, r);
  }
  /**
  Create a [transaction](https://codemirror.net/6/docs/ref/#state.Transaction) that updates this
  state. Any number of [transaction specs](https://codemirror.net/6/docs/ref/#state.TransactionSpec)
  can be passed. Unless
  [`sequential`](https://codemirror.net/6/docs/ref/#state.TransactionSpec.sequential) is set, the
  [changes](https://codemirror.net/6/docs/ref/#state.TransactionSpec.changes) (if any) of each spec
  are assumed to start in the _current_ document (not the document
  produced by previous specs), and its
  [selection](https://codemirror.net/6/docs/ref/#state.TransactionSpec.selection) and
  [effects](https://codemirror.net/6/docs/ref/#state.TransactionSpec.effects) are assumed to refer
  to the document created by its _own_ changes. The resulting
  transaction contains the combined effect of all the different
  specs. For [selection](https://codemirror.net/6/docs/ref/#state.TransactionSpec.selection), later
  specs take precedence over earlier ones.
  */
  update(...t) {
    return PG(this, t, !0);
  }
  /**
  @internal
  */
  applyTransaction(t) {
    let n = this.config, { base: r, compartments: i } = n;
    for (let a of t.effects)
      a.is(oT.reconfigure) ? (n && (i = /* @__PURE__ */ new Map(), n.compartments.forEach((u, c) => i.set(c, u)), n = null), i.set(a.value.compartment, a.value.extension)) : a.is(An.reconfigure) ? (n = null, r = a.value) : a.is(An.appendConfig) && (n = null, r = Zh(r).concat(a.value));
    let o;
    n ? o = t.startState.values.slice() : (n = iC.resolve(r, i, this), o = new Jn(n, this.doc, this.selection, n.dynamicSlots.map(() => null), (u, c) => c.reconfigure(u, this), null).values);
    let s = t.startState.facet(xk) ? t.newSelection : t.newSelection.asSingle();
    new Jn(n, t.newDoc, s, o, (a, u) => u.update(a, t), t);
  }
  /**
  Create a [transaction spec](https://codemirror.net/6/docs/ref/#state.TransactionSpec) that
  replaces every selection range with the given content.
  */
  replaceSelection(t) {
    return typeof t == "string" && (t = this.toText(t)), this.changeByRange((n) => ({
      changes: { from: n.from, to: n.to, insert: t },
      range: it.cursor(n.from + t.length)
    }));
  }
  /**
  Create a set of changes and a new selection by running the given
  function for each range in the active selection. The function
  can return an optional set of changes (in the coordinate space
  of the start document), plus an updated range (in the coordinate
  space of the document produced by the call's own changes). This
  method will merge all the changes and ranges into a single
  changeset and selection, and return it as a [transaction
  spec](https://codemirror.net/6/docs/ref/#state.TransactionSpec), which can be passed to
  [`update`](https://codemirror.net/6/docs/ref/#state.EditorState.update).
  */
  changeByRange(t) {
    let n = this.selection, r = t(n.ranges[0]), i = this.changes(r.changes), o = [r.range], s = Zh(r.effects);
    for (let a = 1; a < n.ranges.length; a++) {
      let u = t(n.ranges[a]), c = this.changes(u.changes), d = c.map(i);
      for (let h = 0; h < a; h++)
        o[h] = o[h].map(d);
      let f = i.mapDesc(c, !0);
      o.push(u.range.map(f)), i = i.compose(d), s = An.mapEffects(s, d).concat(An.mapEffects(Zh(u.effects), f));
    }
    return {
      changes: i,
      selection: it.create(o, n.mainIndex),
      effects: s
    };
  }
  /**
  Create a [change set](https://codemirror.net/6/docs/ref/#state.ChangeSet) from the given change
  description, taking the state's document length and line
  separator into account.
  */
  changes(t = []) {
    return t instanceof Ui ? t : Ui.of(t, this.doc.length, this.facet(Jn.lineSeparator));
  }
  /**
  Using the state's [line
  separator](https://codemirror.net/6/docs/ref/#state.EditorState^lineSeparator), create a
  [`Text`](https://codemirror.net/6/docs/ref/#state.Text) instance from the given string.
  */
  toText(t) {
    return cr.of(t.split(this.facet(Jn.lineSeparator) || mk));
  }
  /**
  Return the given range of the document as a string.
  */
  sliceDoc(t = 0, n = this.doc.length) {
    return this.doc.sliceString(t, n, this.lineBreak);
  }
  /**
  Get the value of a state [facet](https://codemirror.net/6/docs/ref/#state.Facet).
  */
  facet(t) {
    let n = this.config.address[t.id];
    return n == null ? t.default : (b0(this, n), oC(this, n));
  }
  /**
  Convert this state to a JSON-serializable object. When custom
  fields should be serialized, you can pass them in as an object
  mapping property names (in the resulting object, which should
  not use `doc` or `selection`) to fields.
  */
  toJSON(t) {
    let n = {
      doc: this.sliceDoc(),
      selection: this.selection.toJSON()
    };
    if (t)
      for (let r in t) {
        let i = t[r];
        i instanceof wo && this.config.address[i.id] != null && (n[r] = i.spec.toJSON(this.field(t[r]), this));
      }
    return n;
  }
  /**
  Deserialize a state from its JSON representation. When custom
  fields should be deserialized, pass the same object you passed
  to [`toJSON`](https://codemirror.net/6/docs/ref/#state.EditorState.toJSON) when serializing as
  third argument.
  */
  static fromJSON(t, n = {}, r) {
    if (!t || typeof t.doc != "string")
      throw new RangeError("Invalid JSON representation for EditorState");
    let i = [];
    if (r) {
      for (let o in r)
        if (Object.prototype.hasOwnProperty.call(t, o)) {
          let s = r[o], a = t[o];
          i.push(s.init((u) => s.spec.fromJSON(a, u)));
        }
    }
    return Jn.create({
      doc: t.doc,
      selection: it.fromJSON(t.selection),
      extensions: n.extensions ? i.concat([n.extensions]) : i
    });
  }
  /**
  Create a new state. You'll usually only need this when
  initializing an editor—updated states are created by applying
  transactions.
  */
  static create(t = {}) {
    let n = iC.resolve(t.extensions || [], /* @__PURE__ */ new Map()), r = t.doc instanceof cr ? t.doc : cr.of((t.doc || "").split(n.staticFacet(Jn.lineSeparator) || mk)), i = t.selection ? t.selection instanceof it ? t.selection : it.single(t.selection.anchor, t.selection.head) : it.single(0);
    return vG(i, r.length), n.staticFacet(xk) || (i = i.asSingle()), new Jn(n, r, i, n.dynamicSlots.map(() => null), (o, s) => s.create(o), null);
  }
  /**
  The size (in columns) of a tab in the document, determined by
  the [`tabSize`](https://codemirror.net/6/docs/ref/#state.EditorState^tabSize) facet.
  */
  get tabSize() {
    return this.facet(Jn.tabSize);
  }
  /**
  Get the proper [line-break](https://codemirror.net/6/docs/ref/#state.EditorState^lineSeparator)
  string for this state.
  */
  get lineBreak() {
    return this.facet(Jn.lineSeparator) || `
`;
  }
  /**
  Returns true when the editor is
  [configured](https://codemirror.net/6/docs/ref/#state.EditorState^readOnly) to be read-only.
  */
  get readOnly() {
    return this.facet(AG);
  }
  /**
  Look up a translation for the given phrase (via the
  [`phrases`](https://codemirror.net/6/docs/ref/#state.EditorState^phrases) facet), or return the
  original string if no translation is found.
  
  If additional arguments are passed, they will be inserted in
  place of markers like `$1` (for the first value) and `$2`, etc.
  A single `$` is equivalent to `$1`, and `$$` will produce a
  literal dollar sign.
  */
  phrase(t, ...n) {
    for (let r of this.facet(Jn.phrases))
      if (Object.prototype.hasOwnProperty.call(r, t)) {
        t = r[t];
        break;
      }
    return n.length && (t = t.replace(/\$(\$|\d*)/g, (r, i) => {
      if (i == "$")
        return "$";
      let o = +(i || 1);
      return !o || o > n.length ? r : n[o - 1];
    })), t;
  }
  /**
  Find the values for a given language data field, provided by the
  the [`languageData`](https://codemirror.net/6/docs/ref/#state.EditorState^languageData) facet.
  
  Examples of language data fields are...
  
  - [`"commentTokens"`](https://codemirror.net/6/docs/ref/#commands.CommentTokens) for specifying
    comment syntax.
  - [`"autocomplete"`](https://codemirror.net/6/docs/ref/#autocomplete.autocompletion^config.override)
    for providing language-specific completion sources.
  - [`"wordChars"`](https://codemirror.net/6/docs/ref/#state.EditorState.charCategorizer) for adding
    characters that should be considered part of words in this
    language.
  - [`"closeBrackets"`](https://codemirror.net/6/docs/ref/#autocomplete.CloseBracketConfig) controls
    bracket closing behavior.
  */
  languageDataAt(t, n, r = -1) {
    let i = [];
    for (let o of this.facet(DG))
      for (let s of o(this, n, r))
        Object.prototype.hasOwnProperty.call(s, t) && i.push(s[t]);
    return i;
  }
  /**
  Return a function that can categorize strings (expected to
  represent a single [grapheme cluster](https://codemirror.net/6/docs/ref/#state.findClusterBreak))
  into one of:
  
   - Word (contains an alphanumeric character or a character
     explicitly listed in the local language's `"wordChars"`
     language data, which should be a string)
   - Space (contains only whitespace)
   - Other (anything else)
  */
  charCategorizer(t) {
    return knt(this.languageDataAt("wordChars", t).join(""));
  }
  /**
  Find the word at the given position, meaning the range
  containing all [word](https://codemirror.net/6/docs/ref/#state.CharCategory.Word) characters
  around it. If no word characters are adjacent to the position,
  this returns null.
  */
  wordAt(t) {
    let { text: n, from: r, length: i } = this.doc.lineAt(t), o = this.charCategorizer(t), s = t - r, a = t - r;
    for (; s > 0; ) {
      let u = go(n, s, !1);
      if (o(n.slice(u, s)) != Qr.Word)
        break;
      s = u;
    }
    for (; a < i; ) {
      let u = go(n, a);
      if (o(n.slice(a, u)) != Qr.Word)
        break;
      a = u;
    }
    return s == a ? null : it.range(s + r, a + r);
  }
}
Jn.allowMultipleSelections = xk;
Jn.tabSize = /* @__PURE__ */ zt.define({
  combine: (e) => e.length ? e[0] : 4
});
Jn.lineSeparator = CG;
Jn.readOnly = AG;
Jn.phrases = /* @__PURE__ */ zt.define({
  compare(e, t) {
    let n = Object.keys(e), r = Object.keys(t);
    return n.length == r.length && n.every((i) => e[i] == t[i]);
  }
});
Jn.languageData = DG;
Jn.changeFilter = EG;
Jn.transactionFilter = TG;
Jn.transactionExtender = SG;
oT.reconfigure = /* @__PURE__ */ An.define();
function wu(e, t, n = {}) {
  let r = {};
  for (let i of e)
    for (let o of Object.keys(i)) {
      let s = i[o], a = r[o];
      if (a === void 0)
        r[o] = s;
      else if (!(a === s || s === void 0)) if (Object.hasOwnProperty.call(n, o))
        r[o] = n[o](a, s);
      else
        throw new Error("Config merge conflict for field " + o);
    }
  for (let i in t)
    r[i] === void 0 && (r[i] = t[i]);
  return r;
}
class Qp {
  /**
  Compare this value with another value. Used when comparing
  rangesets. The default implementation compares by identity.
  Unless you are only creating a fixed number of unique instances
  of your value type, it is a good idea to implement this
  properly.
  */
  eq(t) {
    return this == t;
  }
  /**
  Create a [range](https://codemirror.net/6/docs/ref/#state.Range) with this value.
  */
  range(t, n = t) {
    return Ek.create(t, n, this);
  }
}
Qp.prototype.startSide = Qp.prototype.endSide = 0;
Qp.prototype.point = !1;
Qp.prototype.mapMode = es.TrackDel;
let Ek = class kG {
  constructor(t, n, r) {
    this.from = t, this.to = n, this.value = r;
  }
  /**
  @internal
  */
  static create(t, n, r) {
    return new kG(t, n, r);
  }
};
function Tk(e, t) {
  return e.from - t.from || e.value.startSide - t.value.startSide;
}
class R$ {
  constructor(t, n, r, i) {
    this.from = t, this.to = n, this.value = r, this.maxPoint = i;
  }
  get length() {
    return this.to[this.to.length - 1];
  }
  // Find the index of the given position and side. Use the ranges'
  // `from` pos when `end == false`, `to` when `end == true`.
  findIndex(t, n, r, i = 0) {
    let o = r ? this.to : this.from;
    for (let s = i, a = o.length; ; ) {
      if (s == a)
        return s;
      let u = s + a >> 1, c = o[u] - t || (r ? this.value[u].endSide : this.value[u].startSide) - n;
      if (u == s)
        return c >= 0 ? s : a;
      c >= 0 ? a = u : s = u + 1;
    }
  }
  between(t, n, r, i) {
    for (let o = this.findIndex(n, -1e9, !0), s = this.findIndex(r, 1e9, !1, o); o < s; o++)
      if (i(this.from[o] + t, this.to[o] + t, this.value[o]) === !1)
        return !1;
  }
  map(t, n) {
    let r = [], i = [], o = [], s = -1, a = -1;
    for (let u = 0; u < this.value.length; u++) {
      let c = this.value[u], d = this.from[u] + t, f = this.to[u] + t, h, m;
      if (d == f) {
        let v = n.mapPos(d, c.startSide, c.mapMode);
        if (v == null || (h = m = v, c.startSide != c.endSide && (m = n.mapPos(d, c.endSide), m < h)))
          continue;
      } else if (h = n.mapPos(d, c.startSide), m = n.mapPos(f, c.endSide), h > m || h == m && c.startSide > 0 && c.endSide <= 0)
        continue;
      (m - h || c.endSide - c.startSide) < 0 || (s < 0 && (s = h), c.point && (a = Math.max(a, m - h)), r.push(c), i.push(h - s), o.push(m - s));
    }
    return { mapped: r.length ? new R$(i, o, r, a) : null, pos: s };
  }
}
class ir {
  constructor(t, n, r, i) {
    this.chunkPos = t, this.chunk = n, this.nextLayer = r, this.maxPoint = i;
  }
  /**
  @internal
  */
  static create(t, n, r, i) {
    return new ir(t, n, r, i);
  }
  /**
  @internal
  */
  get length() {
    let t = this.chunk.length - 1;
    return t < 0 ? 0 : Math.max(this.chunkEnd(t), this.nextLayer.length);
  }
  /**
  The number of ranges in the set.
  */
  get size() {
    if (this.isEmpty)
      return 0;
    let t = this.nextLayer.size;
    for (let n of this.chunk)
      t += n.value.length;
    return t;
  }
  /**
  @internal
  */
  chunkEnd(t) {
    return this.chunkPos[t] + this.chunk[t].length;
  }
  /**
  Update the range set, optionally adding new ranges or filtering
  out existing ones.
  
  (Note: The type parameter is just there as a kludge to work
  around TypeScript variance issues that prevented `RangeSet<X>`
  from being a subtype of `RangeSet<Y>` when `X` is a subtype of
  `Y`.)
  */
  update(t) {
    let { add: n = [], sort: r = !1, filterFrom: i = 0, filterTo: o = this.length } = t, s = t.filter;
    if (n.length == 0 && !s)
      return this;
    if (r && (n = n.slice().sort(Tk)), this.isEmpty)
      return n.length ? ir.of(n) : this;
    let a = new OG(this, null, -1).goto(0), u = 0, c = [], d = new uc();
    for (; a.value || u < n.length; )
      if (u < n.length && (a.from - n[u].from || a.startSide - n[u].value.startSide) >= 0) {
        let f = n[u++];
        d.addInner(f.from, f.to, f.value) || c.push(f);
      } else a.rangeIndex == 1 && a.chunkIndex < this.chunk.length && (u == n.length || this.chunkEnd(a.chunkIndex) < n[u].from) && (!s || i > this.chunkEnd(a.chunkIndex) || o < this.chunkPos[a.chunkIndex]) && d.addChunk(this.chunkPos[a.chunkIndex], this.chunk[a.chunkIndex]) ? a.nextChunk() : ((!s || i > a.to || o < a.from || s(a.from, a.to, a.value)) && (d.addInner(a.from, a.to, a.value) || c.push(Ek.create(a.from, a.to, a.value))), a.next());
    return d.finishInner(this.nextLayer.isEmpty && !c.length ? ir.empty : this.nextLayer.update({ add: c, filter: s, filterFrom: i, filterTo: o }));
  }
  /**
  Map this range set through a set of changes, return the new set.
  */
  map(t) {
    if (t.empty || this.isEmpty)
      return this;
    let n = [], r = [], i = -1;
    for (let s = 0; s < this.chunk.length; s++) {
      let a = this.chunkPos[s], u = this.chunk[s], c = t.touchesRange(a, a + u.length);
      if (c === !1)
        i = Math.max(i, u.maxPoint), n.push(u), r.push(t.mapPos(a));
      else if (c === !0) {
        let { mapped: d, pos: f } = u.map(a, t);
        d && (i = Math.max(i, d.maxPoint), n.push(d), r.push(f));
      }
    }
    let o = this.nextLayer.map(t);
    return n.length == 0 ? o : new ir(r, n, o || ir.empty, i);
  }
  /**
  Iterate over the ranges that touch the region `from` to `to`,
  calling `f` for each. There is no guarantee that the ranges will
  be reported in any specific order. When the callback returns
  `false`, iteration stops.
  */
  between(t, n, r) {
    if (!this.isEmpty) {
      for (let i = 0; i < this.chunk.length; i++) {
        let o = this.chunkPos[i], s = this.chunk[i];
        if (n >= o && t <= o + s.length && s.between(o, t - o, n - o, r) === !1)
          return;
      }
      this.nextLayer.between(t, n, r);
    }
  }
  /**
  Iterate over the ranges in this set, in order, including all
  ranges that end at or after `from`.
  */
  iter(t = 0) {
    return Z0.from([this]).goto(t);
  }
  /**
  @internal
  */
  get isEmpty() {
    return this.nextLayer == this;
  }
  /**
  Iterate over the ranges in a collection of sets, in order,
  starting from `from`.
  */
  static iter(t, n = 0) {
    return Z0.from(t).goto(n);
  }
  /**
  Iterate over two groups of sets, calling methods on `comparator`
  to notify it of possible differences.
  */
  static compare(t, n, r, i, o = -1) {
    let s = t.filter((f) => f.maxPoint > 0 || !f.isEmpty && f.maxPoint >= o), a = n.filter((f) => f.maxPoint > 0 || !f.isEmpty && f.maxPoint >= o), u = w8(s, a, r), c = new My(s, u, o), d = new My(a, u, o);
    r.iterGaps((f, h, m) => P8(c, f, d, h, m, i)), r.empty && r.length == 0 && P8(c, 0, d, 0, 0, i);
  }
  /**
  Compare the contents of two groups of range sets, returning true
  if they are equivalent in the given range.
  */
  static eq(t, n, r = 0, i) {
    i == null && (i = 999999999);
    let o = t.filter((d) => !d.isEmpty && n.indexOf(d) < 0), s = n.filter((d) => !d.isEmpty && t.indexOf(d) < 0);
    if (o.length != s.length)
      return !1;
    if (!o.length)
      return !0;
    let a = w8(o, s), u = new My(o, a, 0).goto(r), c = new My(s, a, 0).goto(r);
    for (; ; ) {
      if (u.to != c.to || !Sk(u.active, c.active) || u.point && (!c.point || !u.point.eq(c.point)))
        return !1;
      if (u.to > i)
        return !0;
      u.next(), c.next();
    }
  }
  /**
  Iterate over a group of range sets at the same time, notifying
  the iterator about the ranges covering every given piece of
  content. Returns the open count (see
  [`SpanIterator.span`](https://codemirror.net/6/docs/ref/#state.SpanIterator.span)) at the end
  of the iteration.
  */
  static spans(t, n, r, i, o = -1) {
    let s = new My(t, null, o).goto(n), a = n, u = s.openStart;
    for (; ; ) {
      let c = Math.min(s.to, r);
      if (s.point) {
        let d = s.activeForPoint(s.to), f = s.pointFrom < n ? d.length + 1 : s.point.startSide < 0 ? d.length : Math.min(d.length, u);
        i.point(a, c, s.point, d, f, s.pointRank), u = Math.min(s.openEnd(c), d.length);
      } else c > a && (i.span(a, c, s.active, u), u = s.openEnd(c));
      if (s.to > r)
        return u + (s.point && s.to > r ? 1 : 0);
      a = s.to, s.next();
    }
  }
  /**
  Create a range set for the given range or array of ranges. By
  default, this expects the ranges to be _sorted_ (by start
  position and, if two start at the same position,
  `value.startSide`). You can pass `true` as second argument to
  cause the method to sort them.
  */
  static of(t, n = !1) {
    let r = new uc();
    for (let i of t instanceof Ek ? [t] : n ? Ont(t) : t)
      r.add(i.from, i.to, i.value);
    return r.finish();
  }
  /**
  Join an array of range sets into a single set.
  */
  static join(t) {
    if (!t.length)
      return ir.empty;
    let n = t[t.length - 1];
    for (let r = t.length - 2; r >= 0; r--)
      for (let i = t[r]; i != ir.empty; i = i.nextLayer)
        n = new ir(i.chunkPos, i.chunk, n, Math.max(i.maxPoint, n.maxPoint));
    return n;
  }
}
ir.empty = /* @__PURE__ */ new ir([], [], null, -1);
function Ont(e) {
  if (e.length > 1)
    for (let t = e[0], n = 1; n < e.length; n++) {
      let r = e[n];
      if (Tk(t, r) > 0)
        return e.slice().sort(Tk);
      t = r;
    }
  return e;
}
ir.empty.nextLayer = ir.empty;
class uc {
  finishChunk(t) {
    this.chunks.push(new R$(this.from, this.to, this.value, this.maxPoint)), this.chunkPos.push(this.chunkStart), this.chunkStart = -1, this.setMaxPoint = Math.max(this.setMaxPoint, this.maxPoint), this.maxPoint = -1, t && (this.from = [], this.to = [], this.value = []);
  }
  /**
  Create an empty builder.
  */
  constructor() {
    this.chunks = [], this.chunkPos = [], this.chunkStart = -1, this.last = null, this.lastFrom = -1e9, this.lastTo = -1e9, this.from = [], this.to = [], this.value = [], this.maxPoint = -1, this.setMaxPoint = -1, this.nextLayer = null;
  }
  /**
  Add a range. Ranges should be added in sorted (by `from` and
  `value.startSide`) order.
  */
  add(t, n, r) {
    this.addInner(t, n, r) || (this.nextLayer || (this.nextLayer = new uc())).add(t, n, r);
  }
  /**
  @internal
  */
  addInner(t, n, r) {
    let i = t - this.lastTo || r.startSide - this.last.endSide;
    if (i <= 0 && (t - this.lastFrom || r.startSide - this.last.startSide) < 0)
      throw new Error("Ranges must be added sorted by `from` position and `startSide`");
    return i < 0 ? !1 : (this.from.length == 250 && this.finishChunk(!0), this.chunkStart < 0 && (this.chunkStart = t), this.from.push(t - this.chunkStart), this.to.push(n - this.chunkStart), this.last = r, this.lastFrom = t, this.lastTo = n, this.value.push(r), r.point && (this.maxPoint = Math.max(this.maxPoint, n - t)), !0);
  }
  /**
  @internal
  */
  addChunk(t, n) {
    if ((t - this.lastTo || n.value[0].startSide - this.last.endSide) < 0)
      return !1;
    this.from.length && this.finishChunk(!0), this.setMaxPoint = Math.max(this.setMaxPoint, n.maxPoint), this.chunks.push(n), this.chunkPos.push(t);
    let r = n.value.length - 1;
    return this.last = n.value[r], this.lastFrom = n.from[r] + t, this.lastTo = n.to[r] + t, !0;
  }
  /**
  Finish the range set. Returns the new set. The builder can't be
  used anymore after this has been called.
  */
  finish() {
    return this.finishInner(ir.empty);
  }
  /**
  @internal
  */
  finishInner(t) {
    if (this.from.length && this.finishChunk(!1), this.chunks.length == 0)
      return t;
    let n = ir.create(this.chunkPos, this.chunks, this.nextLayer ? this.nextLayer.finishInner(t) : t, this.setMaxPoint);
    return this.from = null, n;
  }
}
function w8(e, t, n) {
  let r = /* @__PURE__ */ new Map();
  for (let o of e)
    for (let s = 0; s < o.chunk.length; s++)
      o.chunk[s].maxPoint <= 0 && r.set(o.chunk[s], o.chunkPos[s]);
  let i = /* @__PURE__ */ new Set();
  for (let o of t)
    for (let s = 0; s < o.chunk.length; s++) {
      let a = r.get(o.chunk[s]);
      a != null && (n ? n.mapPos(a) : a) == o.chunkPos[s] && !(n != null && n.touchesRange(a, a + o.chunk[s].length)) && i.add(o.chunk[s]);
    }
  return i;
}
class OG {
  constructor(t, n, r, i = 0) {
    this.layer = t, this.skip = n, this.minPoint = r, this.rank = i;
  }
  get startSide() {
    return this.value ? this.value.startSide : 0;
  }
  get endSide() {
    return this.value ? this.value.endSide : 0;
  }
  goto(t, n = -1e9) {
    return this.chunkIndex = this.rangeIndex = 0, this.gotoInner(t, n, !1), this;
  }
  gotoInner(t, n, r) {
    for (; this.chunkIndex < this.layer.chunk.length; ) {
      let i = this.layer.chunk[this.chunkIndex];
      if (!(this.skip && this.skip.has(i) || this.layer.chunkEnd(this.chunkIndex) < t || i.maxPoint < this.minPoint))
        break;
      this.chunkIndex++, r = !1;
    }
    if (this.chunkIndex < this.layer.chunk.length) {
      let i = this.layer.chunk[this.chunkIndex].findIndex(t - this.layer.chunkPos[this.chunkIndex], n, !0);
      (!r || this.rangeIndex < i) && this.setRangeIndex(i);
    }
    this.next();
  }
  forward(t, n) {
    (this.to - t || this.endSide - n) < 0 && this.gotoInner(t, n, !0);
  }
  next() {
    for (; ; )
      if (this.chunkIndex == this.layer.chunk.length) {
        this.from = this.to = 1e9, this.value = null;
        break;
      } else {
        let t = this.layer.chunkPos[this.chunkIndex], n = this.layer.chunk[this.chunkIndex], r = t + n.from[this.rangeIndex];
        if (this.from = r, this.to = t + n.to[this.rangeIndex], this.value = n.value[this.rangeIndex], this.setRangeIndex(this.rangeIndex + 1), this.minPoint < 0 || this.value.point && this.to - this.from >= this.minPoint)
          break;
      }
  }
  setRangeIndex(t) {
    if (t == this.layer.chunk[this.chunkIndex].value.length) {
      if (this.chunkIndex++, this.skip)
        for (; this.chunkIndex < this.layer.chunk.length && this.skip.has(this.layer.chunk[this.chunkIndex]); )
          this.chunkIndex++;
      this.rangeIndex = 0;
    } else
      this.rangeIndex = t;
  }
  nextChunk() {
    this.chunkIndex++, this.rangeIndex = 0, this.next();
  }
  compare(t) {
    return this.from - t.from || this.startSide - t.startSide || this.rank - t.rank || this.to - t.to || this.endSide - t.endSide;
  }
}
class Z0 {
  constructor(t) {
    this.heap = t;
  }
  static from(t, n = null, r = -1) {
    let i = [];
    for (let o = 0; o < t.length; o++)
      for (let s = t[o]; !s.isEmpty; s = s.nextLayer)
        s.maxPoint >= r && i.push(new OG(s, n, r, o));
    return i.length == 1 ? i[0] : new Z0(i);
  }
  get startSide() {
    return this.value ? this.value.startSide : 0;
  }
  goto(t, n = -1e9) {
    for (let r of this.heap)
      r.goto(t, n);
    for (let r = this.heap.length >> 1; r >= 0; r--)
      Cw(this.heap, r);
    return this.next(), this;
  }
  forward(t, n) {
    for (let r of this.heap)
      r.forward(t, n);
    for (let r = this.heap.length >> 1; r >= 0; r--)
      Cw(this.heap, r);
    (this.to - t || this.value.endSide - n) < 0 && this.next();
  }
  next() {
    if (this.heap.length == 0)
      this.from = this.to = 1e9, this.value = null, this.rank = -1;
    else {
      let t = this.heap[0];
      this.from = t.from, this.to = t.to, this.value = t.value, this.rank = t.rank, t.value && t.next(), Cw(this.heap, 0);
    }
  }
}
function Cw(e, t) {
  for (let n = e[t]; ; ) {
    let r = (t << 1) + 1;
    if (r >= e.length)
      break;
    let i = e[r];
    if (r + 1 < e.length && i.compare(e[r + 1]) >= 0 && (i = e[r + 1], r++), n.compare(i) < 0)
      break;
    e[r] = n, e[t] = i, t = r;
  }
}
class My {
  constructor(t, n, r) {
    this.minPoint = r, this.active = [], this.activeTo = [], this.activeRank = [], this.minActive = -1, this.point = null, this.pointFrom = 0, this.pointRank = 0, this.to = -1e9, this.endSide = 0, this.openStart = -1, this.cursor = Z0.from(t, n, r);
  }
  goto(t, n = -1e9) {
    return this.cursor.goto(t, n), this.active.length = this.activeTo.length = this.activeRank.length = 0, this.minActive = -1, this.to = t, this.endSide = n, this.openStart = -1, this.next(), this;
  }
  forward(t, n) {
    for (; this.minActive > -1 && (this.activeTo[this.minActive] - t || this.active[this.minActive].endSide - n) < 0; )
      this.removeActive(this.minActive);
    this.cursor.forward(t, n);
  }
  removeActive(t) {
    rx(this.active, t), rx(this.activeTo, t), rx(this.activeRank, t), this.minActive = k8(this.active, this.activeTo);
  }
  addActive(t) {
    let n = 0, { value: r, to: i, rank: o } = this.cursor;
    for (; n < this.activeRank.length && (o - this.activeRank[n] || i - this.activeTo[n]) > 0; )
      n++;
    ix(this.active, n, r), ix(this.activeTo, n, i), ix(this.activeRank, n, o), t && ix(t, n, this.cursor.from), this.minActive = k8(this.active, this.activeTo);
  }
  // After calling this, if `this.point` != null, the next range is a
  // point. Otherwise, it's a regular range, covered by `this.active`.
  next() {
    let t = this.to, n = this.point;
    this.point = null;
    let r = this.openStart < 0 ? [] : null;
    for (; ; ) {
      let i = this.minActive;
      if (i > -1 && (this.activeTo[i] - this.cursor.from || this.active[i].endSide - this.cursor.startSide) < 0) {
        if (this.activeTo[i] > t) {
          this.to = this.activeTo[i], this.endSide = this.active[i].endSide;
          break;
        }
        this.removeActive(i), r && rx(r, i);
      } else if (this.cursor.value)
        if (this.cursor.from > t) {
          this.to = this.cursor.from, this.endSide = this.cursor.startSide;
          break;
        } else {
          let o = this.cursor.value;
          if (!o.point)
            this.addActive(r), this.cursor.next();
          else if (n && this.cursor.to == this.to && this.cursor.from < this.cursor.to)
            this.cursor.next();
          else {
            this.point = o, this.pointFrom = this.cursor.from, this.pointRank = this.cursor.rank, this.to = this.cursor.to, this.endSide = o.endSide, this.cursor.next(), this.forward(this.to, this.endSide);
            break;
          }
        }
      else {
        this.to = this.endSide = 1e9;
        break;
      }
    }
    if (r) {
      this.openStart = 0;
      for (let i = r.length - 1; i >= 0 && r[i] < t; i--)
        this.openStart++;
    }
  }
  activeForPoint(t) {
    if (!this.active.length)
      return this.active;
    let n = [];
    for (let r = this.active.length - 1; r >= 0 && !(this.activeRank[r] < this.pointRank); r--)
      (this.activeTo[r] > t || this.activeTo[r] == t && this.active[r].endSide >= this.point.endSide) && n.push(this.active[r]);
    return n.reverse();
  }
  openEnd(t) {
    let n = 0;
    for (let r = this.activeTo.length - 1; r >= 0 && this.activeTo[r] > t; r--)
      n++;
    return n;
  }
}
function P8(e, t, n, r, i, o) {
  e.goto(t), n.goto(r);
  let s = r + i, a = r, u = r - t;
  for (; ; ) {
    let c = e.to + u - n.to, d = c || e.endSide - n.endSide, f = d < 0 ? e.to + u : n.to, h = Math.min(f, s);
    if (e.point || n.point ? e.point && n.point && (e.point == n.point || e.point.eq(n.point)) && Sk(e.activeForPoint(e.to), n.activeForPoint(n.to)) || o.comparePoint(a, h, e.point, n.point) : h > a && !Sk(e.active, n.active) && o.compareRange(a, h, e.active, n.active), f > s)
      break;
    (c || e.openEnd != n.openEnd) && o.boundChange && o.boundChange(f), a = f, d <= 0 && e.next(), d >= 0 && n.next();
  }
}
function Sk(e, t) {
  if (e.length != t.length)
    return !1;
  for (let n = 0; n < e.length; n++)
    if (e[n] != t[n] && !e[n].eq(t[n]))
      return !1;
  return !0;
}
function rx(e, t) {
  for (let n = t, r = e.length - 1; n < r; n++)
    e[n] = e[n + 1];
  e.pop();
}
function ix(e, t, n) {
  for (let r = e.length - 1; r >= t; r--)
    e[r + 1] = e[r];
  e[t] = n;
}
function k8(e, t) {
  let n = -1, r = 1e9;
  for (let i = 0; i < t.length; i++)
    (t[i] - r || e[i].endSide - e[n].endSide) < 0 && (n = i, r = t[i]);
  return n;
}
function Cg(e, t, n = e.length) {
  let r = 0;
  for (let i = 0; i < n; )
    e.charCodeAt(i) == 9 ? (r += t - r % t, i++) : (r++, i = go(e, i));
  return r;
}
function Ak(e, t, n, r) {
  for (let i = 0, o = 0; ; ) {
    if (o >= t)
      return i;
    if (i == e.length)
      break;
    o += e.charCodeAt(i) == 9 ? n - o % n : 1, i = go(e, i);
  }
  return r === !0 ? -1 : e.length;
}
const wk = "ͼ", O8 = typeof Symbol > "u" ? "__" + wk : Symbol.for(wk), Pk = typeof Symbol > "u" ? "__styleSet" + Math.floor(Math.random() * 1e8) : Symbol("styleSet"), I8 = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : {};
class fd {
  // :: (Object<Style>, ?{finish: ?(string) → string})
  // Create a style module from the given spec.
  //
  // When `finish` is given, it is called on regular (non-`@`)
  // selectors (after `&` expansion) to compute the final selector.
  constructor(t, n) {
    this.rules = [];
    let { finish: r } = n || {};
    function i(s) {
      return /^@/.test(s) ? [s] : s.split(/,\s*/);
    }
    function o(s, a, u, c) {
      let d = [], f = /^@(\w+)\b/.exec(s[0]), h = f && f[1] == "keyframes";
      if (f && a == null) return u.push(s[0] + ";");
      for (let m in a) {
        let v = a[m];
        if (/&/.test(m))
          o(
            m.split(/,\s*/).map((x) => s.map((C) => x.replace(/&/, C))).reduce((x, C) => x.concat(C)),
            v,
            u
          );
        else if (v && typeof v == "object") {
          if (!f) throw new RangeError("The value of a property (" + m + ") should be a primitive value.");
          o(i(m), v, d, h);
        } else v != null && d.push(m.replace(/_.*/, "").replace(/[A-Z]/g, (x) => "-" + x.toLowerCase()) + ": " + v + ";");
      }
      (d.length || h) && u.push((r && !f && !c ? s.map(r) : s).join(", ") + " {" + d.join(" ") + "}");
    }
    for (let s in t) o(i(s), t[s], this.rules);
  }
  // :: () → string
  // Returns a string containing the module's CSS rules.
  getRules() {
    return this.rules.join(`
`);
  }
  // :: () → string
  // Generate a new unique CSS class name.
  static newName() {
    let t = I8[O8] || 1;
    return I8[O8] = t + 1, wk + t.toString(36);
  }
  // :: (union<Document, ShadowRoot>, union<[StyleModule], StyleModule>, ?{nonce: ?string})
  //
  // Mount the given set of modules in the given DOM root, which ensures
  // that the CSS rules defined by the module are available in that
  // context.
  //
  // Rules are only added to the document once per root.
  //
  // Rule order will follow the order of the modules, so that rules from
  // modules later in the array take precedence of those from earlier
  // modules. If you call this function multiple times for the same root
  // in a way that changes the order of already mounted modules, the old
  // order will be changed.
  //
  // If a Content Security Policy nonce is provided, it is added to
  // the `<style>` tag generated by the library.
  static mount(t, n, r) {
    let i = t[Pk], o = r && r.nonce;
    i ? o && i.setNonce(o) : i = new Int(t, o), i.mount(Array.isArray(n) ? n : [n], t);
  }
}
let F8 = /* @__PURE__ */ new Map();
class Int {
  constructor(t, n) {
    let r = t.ownerDocument || t, i = r.defaultView;
    if (!t.head && t.adoptedStyleSheets && i.CSSStyleSheet) {
      let o = F8.get(r);
      if (o) return t[Pk] = o;
      this.sheet = new i.CSSStyleSheet(), F8.set(r, this);
    } else
      this.styleTag = r.createElement("style"), n && this.styleTag.setAttribute("nonce", n);
    this.modules = [], t[Pk] = this;
  }
  mount(t, n) {
    let r = this.sheet, i = 0, o = 0;
    for (let s = 0; s < t.length; s++) {
      let a = t[s], u = this.modules.indexOf(a);
      if (u < o && u > -1 && (this.modules.splice(u, 1), o--, u = -1), u == -1) {
        if (this.modules.splice(o++, 0, a), r) for (let c = 0; c < a.rules.length; c++)
          r.insertRule(a.rules[c], i++);
      } else {
        for (; o < u; ) i += this.modules[o++].rules.length;
        i += a.rules.length, o++;
      }
    }
    if (r)
      n.adoptedStyleSheets.indexOf(this.sheet) < 0 && (n.adoptedStyleSheets = [this.sheet, ...n.adoptedStyleSheets]);
    else {
      let s = "";
      for (let u = 0; u < this.modules.length; u++)
        s += this.modules[u].getRules() + `
`;
      this.styleTag.textContent = s;
      let a = n.head || n;
      this.styleTag.parentNode != a && a.insertBefore(this.styleTag, a.firstChild);
    }
  }
  setNonce(t) {
    this.styleTag && this.styleTag.getAttribute("nonce") != t && this.styleTag.setAttribute("nonce", t);
  }
}
var hd = {
  8: "Backspace",
  9: "Tab",
  10: "Enter",
  12: "NumLock",
  13: "Enter",
  16: "Shift",
  17: "Control",
  18: "Alt",
  20: "CapsLock",
  27: "Escape",
  32: " ",
  33: "PageUp",
  34: "PageDown",
  35: "End",
  36: "Home",
  37: "ArrowLeft",
  38: "ArrowUp",
  39: "ArrowRight",
  40: "ArrowDown",
  44: "PrintScreen",
  45: "Insert",
  46: "Delete",
  59: ";",
  61: "=",
  91: "Meta",
  92: "Meta",
  106: "*",
  107: "+",
  108: ",",
  109: "-",
  110: ".",
  111: "/",
  144: "NumLock",
  145: "ScrollLock",
  160: "Shift",
  161: "Shift",
  162: "Control",
  163: "Control",
  164: "Alt",
  165: "Alt",
  173: "-",
  186: ";",
  187: "=",
  188: ",",
  189: "-",
  190: ".",
  191: "/",
  192: "`",
  219: "[",
  220: "\\",
  221: "]",
  222: "'"
}, eb = {
  48: ")",
  49: "!",
  50: "@",
  51: "#",
  52: "$",
  53: "%",
  54: "^",
  55: "&",
  56: "*",
  57: "(",
  59: ":",
  61: "+",
  173: "_",
  186: ":",
  187: "+",
  188: "<",
  189: "_",
  190: ">",
  191: "?",
  192: "~",
  219: "{",
  220: "|",
  221: "}",
  222: '"'
}, Fnt = typeof navigator < "u" && /Mac/.test(navigator.platform), $nt = typeof navigator < "u" && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
for (var mo = 0; mo < 10; mo++) hd[48 + mo] = hd[96 + mo] = String(mo);
for (var mo = 1; mo <= 24; mo++) hd[mo + 111] = "F" + mo;
for (var mo = 65; mo <= 90; mo++)
  hd[mo] = String.fromCharCode(mo + 32), eb[mo] = String.fromCharCode(mo);
for (var Ew in hd) eb.hasOwnProperty(Ew) || (eb[Ew] = hd[Ew]);
function Nnt(e) {
  var t = Fnt && e.metaKey && e.shiftKey && !e.ctrlKey && !e.altKey || $nt && e.shiftKey && e.key && e.key.length == 1 || e.key == "Unidentified", n = !t && e.key || (e.shiftKey ? eb : hd)[e.keyCode] || e.key || "Unidentified";
  return n == "Esc" && (n = "Escape"), n == "Del" && (n = "Delete"), n == "Left" && (n = "ArrowLeft"), n == "Up" && (n = "ArrowUp"), n == "Right" && (n = "ArrowRight"), n == "Down" && (n = "ArrowDown"), n;
}
function tb(e) {
  let t;
  return e.nodeType == 11 ? t = e.getSelection ? e : e.ownerDocument : t = e, t.getSelection();
}
function kk(e, t) {
  return t ? e == t || e.contains(t.nodeType != 1 ? t.parentNode : t) : !1;
}
function oD(e, t) {
  if (!t.anchorNode)
    return !1;
  try {
    return kk(e, t.anchorNode);
  } catch {
    return !1;
  }
}
function Cm(e) {
  return e.nodeType == 3 ? ef(e, 0, e.nodeValue.length).getClientRects() : e.nodeType == 1 ? e.getClientRects() : [];
}
function v0(e, t, n, r) {
  return n ? $8(e, t, n, r, -1) || $8(e, t, n, r, 1) : !1;
}
function Zp(e) {
  for (var t = 0; ; t++)
    if (e = e.previousSibling, !e)
      return t;
}
function sC(e) {
  return e.nodeType == 1 && /^(DIV|P|LI|UL|OL|BLOCKQUOTE|DD|DT|H\d|SECTION|PRE)$/.test(e.nodeName);
}
function $8(e, t, n, r, i) {
  for (; ; ) {
    if (e == n && t == r)
      return !0;
    if (t == (i < 0 ? 0 : xu(e))) {
      if (e.nodeName == "DIV")
        return !1;
      let o = e.parentNode;
      if (!o || o.nodeType != 1)
        return !1;
      t = Zp(e) + (i < 0 ? 0 : 1), e = o;
    } else if (e.nodeType == 1) {
      if (e = e.childNodes[t + (i < 0 ? -1 : 0)], e.nodeType == 1 && e.contentEditable == "false")
        return !1;
      t = i < 0 ? xu(e) : 0;
    } else
      return !1;
  }
}
function xu(e) {
  return e.nodeType == 3 ? e.nodeValue.length : e.childNodes.length;
}
function gv(e, t) {
  let n = t ? e.left : e.right;
  return { left: n, right: n, top: e.top, bottom: e.bottom };
}
function Mnt(e) {
  let t = e.visualViewport;
  return t ? {
    left: 0,
    right: t.width,
    top: 0,
    bottom: t.height
  } : {
    left: 0,
    right: e.innerWidth,
    top: 0,
    bottom: e.innerHeight
  };
}
function IG(e, t) {
  let n = t.width / e.offsetWidth, r = t.height / e.offsetHeight;
  return (n > 0.995 && n < 1.005 || !isFinite(n) || Math.abs(t.width - e.offsetWidth) < 1) && (n = 1), (r > 0.995 && r < 1.005 || !isFinite(r) || Math.abs(t.height - e.offsetHeight) < 1) && (r = 1), { scaleX: n, scaleY: r };
}
function Rnt(e, t, n, r, i, o, s, a) {
  let u = e.ownerDocument, c = u.defaultView || window;
  for (let d = e, f = !1; d && !f; )
    if (d.nodeType == 1) {
      let h, m = d == u.body, v = 1, x = 1;
      if (m)
        h = Mnt(c);
      else {
        if (/^(fixed|sticky)$/.test(getComputedStyle(d).position) && (f = !0), d.scrollHeight <= d.clientHeight && d.scrollWidth <= d.clientWidth) {
          d = d.assignedSlot || d.parentNode;
          continue;
        }
        let S = d.getBoundingClientRect();
        ({ scaleX: v, scaleY: x } = IG(d, S)), h = {
          left: S.left,
          right: S.left + d.clientWidth * v,
          top: S.top,
          bottom: S.top + d.clientHeight * x
        };
      }
      let C = 0, E = 0;
      if (i == "nearest")
        t.top < h.top ? (E = -(h.top - t.top + s), n > 0 && t.bottom > h.bottom + E && (E = t.bottom - h.bottom + E + s)) : t.bottom > h.bottom && (E = t.bottom - h.bottom + s, n < 0 && t.top - E < h.top && (E = -(h.top + E - t.top + s)));
      else {
        let S = t.bottom - t.top, w = h.bottom - h.top;
        E = (i == "center" && S <= w ? t.top + S / 2 - w / 2 : i == "start" || i == "center" && n < 0 ? t.top - s : t.bottom - w + s) - h.top;
      }
      if (r == "nearest" ? t.left < h.left ? (C = -(h.left - t.left + o), n > 0 && t.right > h.right + C && (C = t.right - h.right + C + o)) : t.right > h.right && (C = t.right - h.right + o, n < 0 && t.left < h.left + C && (C = -(h.left + C - t.left + o))) : C = (r == "center" ? t.left + (t.right - t.left) / 2 - (h.right - h.left) / 2 : r == "start" == a ? t.left - o : t.right - (h.right - h.left) + o) - h.left, C || E)
        if (m)
          c.scrollBy(C, E);
        else {
          let S = 0, w = 0;
          if (E) {
            let O = d.scrollTop;
            d.scrollTop += E / x, w = (d.scrollTop - O) * x;
          }
          if (C) {
            let O = d.scrollLeft;
            d.scrollLeft += C / v, S = (d.scrollLeft - O) * v;
          }
          t = {
            left: t.left - S,
            top: t.top - w,
            right: t.right - S,
            bottom: t.bottom - w
          }, S && Math.abs(S - C) < 1 && (r = "nearest"), w && Math.abs(w - E) < 1 && (i = "nearest");
        }
      if (m)
        break;
      d = d.assignedSlot || d.parentNode;
    } else if (d.nodeType == 11)
      d = d.host;
    else
      break;
}
function _nt(e) {
  let t = e.ownerDocument, n, r;
  for (let i = e.parentNode; i && !(i == t.body || n && r); )
    if (i.nodeType == 1)
      !r && i.scrollHeight > i.clientHeight && (r = i), !n && i.scrollWidth > i.clientWidth && (n = i), i = i.assignedSlot || i.parentNode;
    else if (i.nodeType == 11)
      i = i.host;
    else
      break;
  return { x: n, y: r };
}
class Lnt {
  constructor() {
    this.anchorNode = null, this.anchorOffset = 0, this.focusNode = null, this.focusOffset = 0;
  }
  eq(t) {
    return this.anchorNode == t.anchorNode && this.anchorOffset == t.anchorOffset && this.focusNode == t.focusNode && this.focusOffset == t.focusOffset;
  }
  setRange(t) {
    let { anchorNode: n, focusNode: r } = t;
    this.set(n, Math.min(t.anchorOffset, n ? xu(n) : 0), r, Math.min(t.focusOffset, r ? xu(r) : 0));
  }
  set(t, n, r, i) {
    this.anchorNode = t, this.anchorOffset = n, this.focusNode = r, this.focusOffset = i;
  }
}
let Ch = null;
function FG(e) {
  if (e.setActive)
    return e.setActive();
  if (Ch)
    return e.focus(Ch);
  let t = [];
  for (let n = e; n && (t.push(n, n.scrollTop, n.scrollLeft), n != n.ownerDocument); n = n.parentNode)
    ;
  if (e.focus(Ch == null ? {
    get preventScroll() {
      return Ch = { preventScroll: !0 }, !0;
    }
  } : void 0), !Ch) {
    Ch = !1;
    for (let n = 0; n < t.length; ) {
      let r = t[n++], i = t[n++], o = t[n++];
      r.scrollTop != i && (r.scrollTop = i), r.scrollLeft != o && (r.scrollLeft = o);
    }
  }
}
let N8;
function ef(e, t, n = t) {
  let r = N8 || (N8 = document.createRange());
  return r.setEnd(e, n), r.setStart(e, t), r;
}
function em(e, t, n, r) {
  let i = { key: t, code: t, keyCode: n, which: n, cancelable: !0 };
  r && ({ altKey: i.altKey, ctrlKey: i.ctrlKey, shiftKey: i.shiftKey, metaKey: i.metaKey } = r);
  let o = new KeyboardEvent("keydown", i);
  o.synthetic = !0, e.dispatchEvent(o);
  let s = new KeyboardEvent("keyup", i);
  return s.synthetic = !0, e.dispatchEvent(s), o.defaultPrevented || s.defaultPrevented;
}
function Bnt(e) {
  for (; e; ) {
    if (e && (e.nodeType == 9 || e.nodeType == 11 && e.host))
      return e;
    e = e.assignedSlot || e.parentNode;
  }
  return null;
}
function $G(e) {
  for (; e.attributes.length; )
    e.removeAttributeNode(e.attributes[0]);
}
function jnt(e, t) {
  let n = t.focusNode, r = t.focusOffset;
  if (!n || t.anchorNode != n || t.anchorOffset != r)
    return !1;
  for (r = Math.min(r, xu(n)); ; )
    if (r) {
      if (n.nodeType != 1)
        return !1;
      let i = n.childNodes[r - 1];
      i.contentEditable == "false" ? r-- : (n = i, r = xu(n));
    } else {
      if (n == e)
        return !0;
      r = Zp(n), n = n.parentNode;
    }
}
function NG(e) {
  return e.scrollTop > Math.max(1, e.scrollHeight - e.clientHeight - 4);
}
function MG(e, t) {
  for (let n = e, r = t; ; ) {
    if (n.nodeType == 3 && r > 0)
      return { node: n, offset: r };
    if (n.nodeType == 1 && r > 0) {
      if (n.contentEditable == "false")
        return null;
      n = n.childNodes[r - 1], r = xu(n);
    } else if (n.parentNode && !sC(n))
      r = Zp(n), n = n.parentNode;
    else
      return null;
  }
}
function RG(e, t) {
  for (let n = e, r = t; ; ) {
    if (n.nodeType == 3 && r < n.nodeValue.length)
      return { node: n, offset: r };
    if (n.nodeType == 1 && r < n.childNodes.length) {
      if (n.contentEditable == "false")
        return null;
      n = n.childNodes[r], r = 0;
    } else if (n.parentNode && !sC(n))
      r = Zp(n) + 1, n = n.parentNode;
    else
      return null;
  }
}
class Ro {
  constructor(t, n, r = !0) {
    this.node = t, this.offset = n, this.precise = r;
  }
  static before(t, n) {
    return new Ro(t.parentNode, Zp(t), n);
  }
  static after(t, n) {
    return new Ro(t.parentNode, Zp(t) + 1, n);
  }
}
const _$ = [];
class Mr {
  constructor() {
    this.parent = null, this.dom = null, this.flags = 2;
  }
  get overrideDOMText() {
    return null;
  }
  get posAtStart() {
    return this.parent ? this.parent.posBefore(this) : 0;
  }
  get posAtEnd() {
    return this.posAtStart + this.length;
  }
  posBefore(t) {
    let n = this.posAtStart;
    for (let r of this.children) {
      if (r == t)
        return n;
      n += r.length + r.breakAfter;
    }
    throw new RangeError("Invalid child in posBefore");
  }
  posAfter(t) {
    return this.posBefore(t) + t.length;
  }
  sync(t, n) {
    if (this.flags & 2) {
      let r = this.dom, i = null, o;
      for (let s of this.children) {
        if (s.flags & 7) {
          if (!s.dom && (o = i ? i.nextSibling : r.firstChild)) {
            let a = Mr.get(o);
            (!a || !a.parent && a.canReuseDOM(s)) && s.reuseDOM(o);
          }
          s.sync(t, n), s.flags &= -8;
        }
        if (o = i ? i.nextSibling : r.firstChild, n && !n.written && n.node == r && o != s.dom && (n.written = !0), s.dom.parentNode == r)
          for (; o && o != s.dom; )
            o = M8(o);
        else
          r.insertBefore(s.dom, o);
        i = s.dom;
      }
      for (o = i ? i.nextSibling : r.firstChild, o && n && n.node == r && (n.written = !0); o; )
        o = M8(o);
    } else if (this.flags & 1)
      for (let r of this.children)
        r.flags & 7 && (r.sync(t, n), r.flags &= -8);
  }
  reuseDOM(t) {
  }
  localPosFromDOM(t, n) {
    let r;
    if (t == this.dom)
      r = this.dom.childNodes[n];
    else {
      let i = xu(t) == 0 ? 0 : n == 0 ? -1 : 1;
      for (; ; ) {
        let o = t.parentNode;
        if (o == this.dom)
          break;
        i == 0 && o.firstChild != o.lastChild && (t == o.firstChild ? i = -1 : i = 1), t = o;
      }
      i < 0 ? r = t : r = t.nextSibling;
    }
    if (r == this.dom.firstChild)
      return 0;
    for (; r && !Mr.get(r); )
      r = r.nextSibling;
    if (!r)
      return this.length;
    for (let i = 0, o = 0; ; i++) {
      let s = this.children[i];
      if (s.dom == r)
        return o;
      o += s.length + s.breakAfter;
    }
  }
  domBoundsAround(t, n, r = 0) {
    let i = -1, o = -1, s = -1, a = -1;
    for (let u = 0, c = r, d = r; u < this.children.length; u++) {
      let f = this.children[u], h = c + f.length;
      if (c < t && h > n)
        return f.domBoundsAround(t, n, c);
      if (h >= t && i == -1 && (i = u, o = c), c > n && f.dom.parentNode == this.dom) {
        s = u, a = d;
        break;
      }
      d = h, c = h + f.breakAfter;
    }
    return {
      from: o,
      to: a < 0 ? r + this.length : a,
      startDOM: (i ? this.children[i - 1].dom.nextSibling : null) || this.dom.firstChild,
      endDOM: s < this.children.length && s >= 0 ? this.children[s].dom : null
    };
  }
  markDirty(t = !1) {
    this.flags |= 2, this.markParentsDirty(t);
  }
  markParentsDirty(t) {
    for (let n = this.parent; n; n = n.parent) {
      if (t && (n.flags |= 2), n.flags & 1)
        return;
      n.flags |= 1, t = !1;
    }
  }
  setParent(t) {
    this.parent != t && (this.parent = t, this.flags & 7 && this.markParentsDirty(!0));
  }
  setDOM(t) {
    this.dom != t && (this.dom && (this.dom.cmView = null), this.dom = t, t.cmView = this);
  }
  get rootView() {
    for (let t = this; ; ) {
      let n = t.parent;
      if (!n)
        return t;
      t = n;
    }
  }
  replaceChildren(t, n, r = _$) {
    this.markDirty();
    for (let i = t; i < n; i++) {
      let o = this.children[i];
      o.parent == this && r.indexOf(o) < 0 && o.destroy();
    }
    r.length < 250 ? this.children.splice(t, n - t, ...r) : this.children = [].concat(this.children.slice(0, t), r, this.children.slice(n));
    for (let i = 0; i < r.length; i++)
      r[i].setParent(this);
  }
  ignoreMutation(t) {
    return !1;
  }
  ignoreEvent(t) {
    return !1;
  }
  childCursor(t = this.length) {
    return new _G(this.children, t, this.children.length);
  }
  childPos(t, n = 1) {
    return this.childCursor().findPos(t, n);
  }
  toString() {
    let t = this.constructor.name.replace("View", "");
    return t + (this.children.length ? "(" + this.children.join() + ")" : this.length ? "[" + (t == "Text" ? this.text : this.length) + "]" : "") + (this.breakAfter ? "#" : "");
  }
  static get(t) {
    return t.cmView;
  }
  get isEditable() {
    return !0;
  }
  get isWidget() {
    return !1;
  }
  get isHidden() {
    return !1;
  }
  merge(t, n, r, i, o, s) {
    return !1;
  }
  become(t) {
    return !1;
  }
  canReuseDOM(t) {
    return t.constructor == this.constructor && !((this.flags | t.flags) & 8);
  }
  // When this is a zero-length view with a side, this should return a
  // number <= 0 to indicate it is before its position, or a
  // number > 0 when after its position.
  getSide() {
    return 0;
  }
  destroy() {
    for (let t of this.children)
      t.parent == this && t.destroy();
    this.parent = null;
  }
}
Mr.prototype.breakAfter = 0;
function M8(e) {
  let t = e.nextSibling;
  return e.parentNode.removeChild(e), t;
}
class _G {
  constructor(t, n, r) {
    this.children = t, this.pos = n, this.i = r, this.off = 0;
  }
  findPos(t, n = 1) {
    for (; ; ) {
      if (t > this.pos || t == this.pos && (n > 0 || this.i == 0 || this.children[this.i - 1].breakAfter))
        return this.off = t - this.pos, this;
      let r = this.children[--this.i];
      this.pos -= r.length + r.breakAfter;
    }
  }
}
function LG(e, t, n, r, i, o, s, a, u) {
  let { children: c } = e, d = c.length ? c[t] : null, f = o.length ? o[o.length - 1] : null, h = f ? f.breakAfter : s;
  if (!(t == r && d && !s && !h && o.length < 2 && d.merge(n, i, o.length ? f : null, n == 0, a, u))) {
    if (r < c.length) {
      let m = c[r];
      m && (i < m.length || m.breakAfter && (f != null && f.breakAfter)) ? (t == r && (m = m.split(i), i = 0), !h && f && m.merge(0, i, f, !0, 0, u) ? o[o.length - 1] = m : ((i || m.children.length && !m.children[0].length) && m.merge(0, i, null, !1, 0, u), o.push(m))) : m != null && m.breakAfter && (f ? f.breakAfter = 1 : s = 1), r++;
    }
    for (d && (d.breakAfter = s, n > 0 && (!s && o.length && d.merge(n, d.length, o[0], !1, a, 0) ? d.breakAfter = o.shift().breakAfter : (n < d.length || d.children.length && d.children[d.children.length - 1].length == 0) && d.merge(n, d.length, null, !1, a, 0), t++)); t < r && o.length; )
      if (c[r - 1].become(o[o.length - 1]))
        r--, o.pop(), u = o.length ? 0 : a;
      else if (c[t].become(o[0]))
        t++, o.shift(), a = o.length ? 0 : u;
      else
        break;
    !o.length && t && r < c.length && !c[t - 1].breakAfter && c[r].merge(0, 0, c[t - 1], !1, a, u) && t--, (t < r || o.length) && e.replaceChildren(t, r, o);
  }
}
function BG(e, t, n, r, i, o) {
  let s = e.childCursor(), { i: a, off: u } = s.findPos(n, 1), { i: c, off: d } = s.findPos(t, -1), f = t - n;
  for (let h of r)
    f += h.length;
  e.length += f, LG(e, c, d, a, u, r, 0, i, o);
}
let Ds = typeof navigator < "u" ? navigator : { userAgent: "", vendor: "", platform: "" }, Ok = typeof document < "u" ? document : { documentElement: { style: {} } };
const Ik = /* @__PURE__ */ /Edge\/(\d+)/.exec(Ds.userAgent), jG = /* @__PURE__ */ /MSIE \d/.test(Ds.userAgent), Fk = /* @__PURE__ */ /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(Ds.userAgent), sT = !!(jG || Fk || Ik), R8 = !sT && /* @__PURE__ */ /gecko\/(\d+)/i.test(Ds.userAgent), Tw = !sT && /* @__PURE__ */ /Chrome\/(\d+)/.exec(Ds.userAgent), _8 = "webkitFontSmoothing" in Ok.documentElement.style, VG = !sT && /* @__PURE__ */ /Apple Computer/.test(Ds.vendor), L8 = VG && (/* @__PURE__ */ /Mobile\/\w+/.test(Ds.userAgent) || Ds.maxTouchPoints > 2);
var Vt = {
  mac: L8 || /* @__PURE__ */ /Mac/.test(Ds.platform),
  windows: /* @__PURE__ */ /Win/.test(Ds.platform),
  linux: /* @__PURE__ */ /Linux|X11/.test(Ds.platform),
  ie: sT,
  ie_version: jG ? Ok.documentMode || 6 : Fk ? +Fk[1] : Ik ? +Ik[1] : 0,
  gecko: R8,
  gecko_version: R8 ? +(/* @__PURE__ */ /Firefox\/(\d+)/.exec(Ds.userAgent) || [0, 0])[1] : 0,
  chrome: !!Tw,
  chrome_version: Tw ? +Tw[1] : 0,
  ios: L8,
  android: /* @__PURE__ */ /Android\b/.test(Ds.userAgent),
  webkit: _8,
  safari: VG,
  webkit_version: _8 ? +(/* @__PURE__ */ /\bAppleWebKit\/(\d+)/.exec(Ds.userAgent) || [0, 0])[1] : 0,
  tabSize: Ok.documentElement.style.tabSize != null ? "tab-size" : "-moz-tab-size"
};
const Vnt = 256;
class xl extends Mr {
  constructor(t) {
    super(), this.text = t;
  }
  get length() {
    return this.text.length;
  }
  createDOM(t) {
    this.setDOM(t || document.createTextNode(this.text));
  }
  sync(t, n) {
    this.dom || this.createDOM(), this.dom.nodeValue != this.text && (n && n.node == this.dom && (n.written = !0), this.dom.nodeValue = this.text);
  }
  reuseDOM(t) {
    t.nodeType == 3 && this.createDOM(t);
  }
  merge(t, n, r) {
    return this.flags & 8 || r && (!(r instanceof xl) || this.length - (n - t) + r.length > Vnt || r.flags & 8) ? !1 : (this.text = this.text.slice(0, t) + (r ? r.text : "") + this.text.slice(n), this.markDirty(), !0);
  }
  split(t) {
    let n = new xl(this.text.slice(t));
    return this.text = this.text.slice(0, t), this.markDirty(), n.flags |= this.flags & 8, n;
  }
  localPosFromDOM(t, n) {
    return t == this.dom ? n : n ? this.text.length : 0;
  }
  domAtPos(t) {
    return new Ro(this.dom, t);
  }
  domBoundsAround(t, n, r) {
    return { from: r, to: r + this.length, startDOM: this.dom, endDOM: this.dom.nextSibling };
  }
  coordsAt(t, n) {
    return znt(this.dom, t, n);
  }
}
class cc extends Mr {
  constructor(t, n = [], r = 0) {
    super(), this.mark = t, this.children = n, this.length = r;
    for (let i of n)
      i.setParent(this);
  }
  setAttrs(t) {
    if ($G(t), this.mark.class && (t.className = this.mark.class), this.mark.attrs)
      for (let n in this.mark.attrs)
        t.setAttribute(n, this.mark.attrs[n]);
    return t;
  }
  canReuseDOM(t) {
    return super.canReuseDOM(t) && !((this.flags | t.flags) & 8);
  }
  reuseDOM(t) {
    t.nodeName == this.mark.tagName.toUpperCase() && (this.setDOM(t), this.flags |= 6);
  }
  sync(t, n) {
    this.dom ? this.flags & 4 && this.setAttrs(this.dom) : this.setDOM(this.setAttrs(document.createElement(this.mark.tagName))), super.sync(t, n);
  }
  merge(t, n, r, i, o, s) {
    return r && (!(r instanceof cc && r.mark.eq(this.mark)) || t && o <= 0 || n < this.length && s <= 0) ? !1 : (BG(this, t, n, r ? r.children.slice() : [], o - 1, s - 1), this.markDirty(), !0);
  }
  split(t) {
    let n = [], r = 0, i = -1, o = 0;
    for (let a of this.children) {
      let u = r + a.length;
      u > t && n.push(r < t ? a.split(t - r) : a), i < 0 && r >= t && (i = o), r = u, o++;
    }
    let s = this.length - t;
    return this.length = t, i > -1 && (this.children.length = i, this.markDirty()), new cc(this.mark, n, s);
  }
  domAtPos(t) {
    return zG(this, t);
  }
  coordsAt(t, n) {
    return WG(this, t, n);
  }
}
function znt(e, t, n) {
  let r = e.nodeValue.length;
  t > r && (t = r);
  let i = t, o = t, s = 0;
  t == 0 && n < 0 || t == r && n >= 0 ? Vt.chrome || Vt.gecko || (t ? (i--, s = 1) : o < r && (o++, s = -1)) : n < 0 ? i-- : o < r && o++;
  let a = ef(e, i, o).getClientRects();
  if (!a.length)
    return null;
  let u = a[(s ? s < 0 : n >= 0) ? 0 : a.length - 1];
  return Vt.safari && !s && u.width == 0 && (u = Array.prototype.find.call(a, (c) => c.width) || u), s ? gv(u, s < 0) : u || null;
}
class id extends Mr {
  static create(t, n, r) {
    return new id(t, n, r);
  }
  constructor(t, n, r) {
    super(), this.widget = t, this.length = n, this.side = r, this.prevWidget = null;
  }
  split(t) {
    let n = id.create(this.widget, this.length - t, this.side);
    return this.length -= t, n;
  }
  sync(t) {
    (!this.dom || !this.widget.updateDOM(this.dom, t)) && (this.dom && this.prevWidget && this.prevWidget.destroy(this.dom), this.prevWidget = null, this.setDOM(this.widget.toDOM(t)), this.widget.editable || (this.dom.contentEditable = "false"));
  }
  getSide() {
    return this.side;
  }
  merge(t, n, r, i, o, s) {
    return r && (!(r instanceof id) || !this.widget.compare(r.widget) || t > 0 && o <= 0 || n < this.length && s <= 0) ? !1 : (this.length = t + (r ? r.length : 0) + (this.length - n), !0);
  }
  become(t) {
    return t instanceof id && t.side == this.side && this.widget.constructor == t.widget.constructor ? (this.widget.compare(t.widget) || this.markDirty(!0), this.dom && !this.prevWidget && (this.prevWidget = this.widget), this.widget = t.widget, this.length = t.length, !0) : !1;
  }
  ignoreMutation() {
    return !0;
  }
  ignoreEvent(t) {
    return this.widget.ignoreEvent(t);
  }
  get overrideDOMText() {
    if (this.length == 0)
      return cr.empty;
    let t = this;
    for (; t.parent; )
      t = t.parent;
    let { view: n } = t, r = n && n.state.doc, i = this.posAtStart;
    return r ? r.slice(i, i + this.length) : cr.empty;
  }
  domAtPos(t) {
    return (this.length ? t == 0 : this.side > 0) ? Ro.before(this.dom) : Ro.after(this.dom, t == this.length);
  }
  domBoundsAround() {
    return null;
  }
  coordsAt(t, n) {
    let r = this.widget.coordsAt(this.dom, t, n);
    if (r)
      return r;
    let i = this.dom.getClientRects(), o = null;
    if (!i.length)
      return null;
    let s = this.side ? this.side < 0 : t > 0;
    for (let a = s ? i.length - 1 : 0; o = i[a], !(t > 0 ? a == 0 : a == i.length - 1 || o.top < o.bottom); a += s ? -1 : 1)
      ;
    return gv(o, !s);
  }
  get isEditable() {
    return !1;
  }
  get isWidget() {
    return !0;
  }
  get isHidden() {
    return this.widget.isHidden;
  }
  destroy() {
    super.destroy(), this.dom && this.widget.destroy(this.dom);
  }
}
class Em extends Mr {
  constructor(t) {
    super(), this.side = t;
  }
  get length() {
    return 0;
  }
  merge() {
    return !1;
  }
  become(t) {
    return t instanceof Em && t.side == this.side;
  }
  split() {
    return new Em(this.side);
  }
  sync() {
    if (!this.dom) {
      let t = document.createElement("img");
      t.className = "cm-widgetBuffer", t.setAttribute("aria-hidden", "true"), this.setDOM(t);
    }
  }
  getSide() {
    return this.side;
  }
  domAtPos(t) {
    return this.side > 0 ? Ro.before(this.dom) : Ro.after(this.dom);
  }
  localPosFromDOM() {
    return 0;
  }
  domBoundsAround() {
    return null;
  }
  coordsAt(t) {
    return this.dom.getBoundingClientRect();
  }
  get overrideDOMText() {
    return cr.empty;
  }
  get isHidden() {
    return !0;
  }
}
xl.prototype.children = id.prototype.children = Em.prototype.children = _$;
function zG(e, t) {
  let n = e.dom, { children: r } = e, i = 0;
  for (let o = 0; i < r.length; i++) {
    let s = r[i], a = o + s.length;
    if (!(a == o && s.getSide() <= 0)) {
      if (t > o && t < a && s.dom.parentNode == n)
        return s.domAtPos(t - o);
      if (t <= o)
        break;
      o = a;
    }
  }
  for (let o = i; o > 0; o--) {
    let s = r[o - 1];
    if (s.dom.parentNode == n)
      return s.domAtPos(s.length);
  }
  for (let o = i; o < r.length; o++) {
    let s = r[o];
    if (s.dom.parentNode == n)
      return s.domAtPos(0);
  }
  return new Ro(n, 0);
}
function UG(e, t, n) {
  let r, { children: i } = e;
  n > 0 && t instanceof cc && i.length && (r = i[i.length - 1]) instanceof cc && r.mark.eq(t.mark) ? UG(r, t.children[0], n - 1) : (i.push(t), t.setParent(e)), e.length += t.length;
}
function WG(e, t, n) {
  let r = null, i = -1, o = null, s = -1;
  function a(c, d) {
    for (let f = 0, h = 0; f < c.children.length && h <= d; f++) {
      let m = c.children[f], v = h + m.length;
      v >= d && (m.children.length ? a(m, d - h) : (!o || o.isHidden && n > 0) && (v > d || h == v && m.getSide() > 0) ? (o = m, s = d - h) : (h < d || h == v && m.getSide() < 0 && !m.isHidden) && (r = m, i = d - h)), h = v;
    }
  }
  a(e, t);
  let u = (n < 0 ? r : o) || r || o;
  return u ? u.coordsAt(Math.max(0, u == r ? i : s), n) : Unt(e);
}
function Unt(e) {
  let t = e.dom.lastChild;
  if (!t)
    return e.dom.getBoundingClientRect();
  let n = Cm(t);
  return n[n.length - 1] || null;
}
function $k(e, t) {
  for (let n in e)
    n == "class" && t.class ? t.class += " " + e.class : n == "style" && t.style ? t.style += ";" + e.style : t[n] = e[n];
  return t;
}
const B8 = /* @__PURE__ */ Object.create(null);
function aC(e, t, n) {
  if (e == t)
    return !0;
  e || (e = B8), t || (t = B8);
  let r = Object.keys(e), i = Object.keys(t);
  if (r.length - (n && r.indexOf(n) > -1 ? 1 : 0) != i.length - (n && i.indexOf(n) > -1 ? 1 : 0))
    return !1;
  for (let o of r)
    if (o != n && (i.indexOf(o) == -1 || e[o] !== t[o]))
      return !1;
  return !0;
}
function Nk(e, t, n) {
  let r = !1;
  if (t)
    for (let i in t)
      n && i in n || (r = !0, i == "style" ? e.style.cssText = "" : e.removeAttribute(i));
  if (n)
    for (let i in n)
      t && t[i] == n[i] || (r = !0, i == "style" ? e.style.cssText = n[i] : e.setAttribute(i, n[i]));
  return r;
}
function Wnt(e) {
  let t = /* @__PURE__ */ Object.create(null);
  for (let n = 0; n < e.attributes.length; n++) {
    let r = e.attributes[n];
    t[r.name] = r.value;
  }
  return t;
}
class xc {
  /**
  Compare this instance to another instance of the same type.
  (TypeScript can't express this, but only instances of the same
  specific class will be passed to this method.) This is used to
  avoid redrawing widgets when they are replaced by a new
  decoration of the same type. The default implementation just
  returns `false`, which will cause new instances of the widget to
  always be redrawn.
  */
  eq(t) {
    return !1;
  }
  /**
  Update a DOM element created by a widget of the same type (but
  different, non-`eq` content) to reflect this widget. May return
  true to indicate that it could update, false to indicate it
  couldn't (in which case the widget will be redrawn). The default
  implementation just returns false.
  */
  updateDOM(t, n) {
    return !1;
  }
  /**
  @internal
  */
  compare(t) {
    return this == t || this.constructor == t.constructor && this.eq(t);
  }
  /**
  The estimated height this widget will have, to be used when
  estimating the height of content that hasn't been drawn. May
  return -1 to indicate you don't know. The default implementation
  returns -1.
  */
  get estimatedHeight() {
    return -1;
  }
  /**
  For inline widgets that are displayed inline (as opposed to
  `inline-block`) and introduce line breaks (through `<br>` tags
  or textual newlines), this must indicate the amount of line
  breaks they introduce. Defaults to 0.
  */
  get lineBreaks() {
    return 0;
  }
  /**
  Can be used to configure which kinds of events inside the widget
  should be ignored by the editor. The default is to ignore all
  events.
  */
  ignoreEvent(t) {
    return !0;
  }
  /**
  Override the way screen coordinates for positions at/in the
  widget are found. `pos` will be the offset into the widget, and
  `side` the side of the position that is being queried—less than
  zero for before, greater than zero for after, and zero for
  directly at that position.
  */
  coordsAt(t, n, r) {
    return null;
  }
  /**
  @internal
  */
  get isHidden() {
    return !1;
  }
  /**
  @internal
  */
  get editable() {
    return !1;
  }
  /**
  This is called when the an instance of the widget is removed
  from the editor view.
  */
  destroy(t) {
  }
}
var os = /* @__PURE__ */ function(e) {
  return e[e.Text = 0] = "Text", e[e.WidgetBefore = 1] = "WidgetBefore", e[e.WidgetAfter = 2] = "WidgetAfter", e[e.WidgetRange = 3] = "WidgetRange", e;
}(os || (os = {}));
class tn extends Qp {
  constructor(t, n, r, i) {
    super(), this.startSide = t, this.endSide = n, this.widget = r, this.spec = i;
  }
  /**
  @internal
  */
  get heightRelevant() {
    return !1;
  }
  /**
  Create a mark decoration, which influences the styling of the
  content in its range. Nested mark decorations will cause nested
  DOM elements to be created. Nesting order is determined by
  precedence of the [facet](https://codemirror.net/6/docs/ref/#view.EditorView^decorations), with
  the higher-precedence decorations creating the inner DOM nodes.
  Such elements are split on line boundaries and on the boundaries
  of lower-precedence decorations.
  */
  static mark(t) {
    return new yv(t);
  }
  /**
  Create a widget decoration, which displays a DOM element at the
  given position.
  */
  static widget(t) {
    let n = Math.max(-1e4, Math.min(1e4, t.side || 0)), r = !!t.block;
    return n += r && !t.inlineOrder ? n > 0 ? 3e8 : -4e8 : n > 0 ? 1e8 : -1e8, new md(t, n, n, r, t.widget || null, !1);
  }
  /**
  Create a replace decoration which replaces the given range with
  a widget, or simply hides it.
  */
  static replace(t) {
    let n = !!t.block, r, i;
    if (t.isBlockGap)
      r = -5e8, i = 4e8;
    else {
      let { start: o, end: s } = HG(t, n);
      r = (o ? n ? -3e8 : -1 : 5e8) - 1, i = (s ? n ? 2e8 : 1 : -6e8) + 1;
    }
    return new md(t, r, i, n, t.widget || null, !0);
  }
  /**
  Create a line decoration, which can add DOM attributes to the
  line starting at the given position.
  */
  static line(t) {
    return new bv(t);
  }
  /**
  Build a [`DecorationSet`](https://codemirror.net/6/docs/ref/#view.DecorationSet) from the given
  decorated range or ranges. If the ranges aren't already sorted,
  pass `true` for `sort` to make the library sort them for you.
  */
  static set(t, n = !1) {
    return ir.of(t, n);
  }
  /**
  @internal
  */
  hasHeight() {
    return this.widget ? this.widget.estimatedHeight > -1 : !1;
  }
}
tn.none = ir.empty;
class yv extends tn {
  constructor(t) {
    let { start: n, end: r } = HG(t);
    super(n ? -1 : 5e8, r ? 1 : -6e8, null, t), this.tagName = t.tagName || "span", this.class = t.class || "", this.attrs = t.attributes || null;
  }
  eq(t) {
    var n, r;
    return this == t || t instanceof yv && this.tagName == t.tagName && (this.class || ((n = this.attrs) === null || n === void 0 ? void 0 : n.class)) == (t.class || ((r = t.attrs) === null || r === void 0 ? void 0 : r.class)) && aC(this.attrs, t.attrs, "class");
  }
  range(t, n = t) {
    if (t >= n)
      throw new RangeError("Mark decorations may not be empty");
    return super.range(t, n);
  }
}
yv.prototype.point = !1;
class bv extends tn {
  constructor(t) {
    super(-2e8, -2e8, null, t);
  }
  eq(t) {
    return t instanceof bv && this.spec.class == t.spec.class && aC(this.spec.attributes, t.spec.attributes);
  }
  range(t, n = t) {
    if (n != t)
      throw new RangeError("Line decoration ranges must be zero-length");
    return super.range(t, n);
  }
}
bv.prototype.mapMode = es.TrackBefore;
bv.prototype.point = !0;
class md extends tn {
  constructor(t, n, r, i, o, s) {
    super(n, r, o, t), this.block = i, this.isReplace = s, this.mapMode = i ? n <= 0 ? es.TrackBefore : es.TrackAfter : es.TrackDel;
  }
  // Only relevant when this.block == true
  get type() {
    return this.startSide != this.endSide ? os.WidgetRange : this.startSide <= 0 ? os.WidgetBefore : os.WidgetAfter;
  }
  get heightRelevant() {
    return this.block || !!this.widget && (this.widget.estimatedHeight >= 5 || this.widget.lineBreaks > 0);
  }
  eq(t) {
    return t instanceof md && Hnt(this.widget, t.widget) && this.block == t.block && this.startSide == t.startSide && this.endSide == t.endSide;
  }
  range(t, n = t) {
    if (this.isReplace && (t > n || t == n && this.startSide > 0 && this.endSide <= 0))
      throw new RangeError("Invalid range for replacement decoration");
    if (!this.isReplace && n != t)
      throw new RangeError("Widget decorations can only have zero-length ranges");
    return super.range(t, n);
  }
}
md.prototype.point = !0;
function HG(e, t = !1) {
  let { inclusiveStart: n, inclusiveEnd: r } = e;
  return n == null && (n = e.inclusive), r == null && (r = e.inclusive), { start: n ?? t, end: r ?? t };
}
function Hnt(e, t) {
  return e == t || !!(e && t && e.compare(t));
}
function sD(e, t, n, r = 0) {
  let i = n.length - 1;
  i >= 0 && n[i] + r >= e ? n[i] = Math.max(n[i], t) : n.push(e, t);
}
class Fi extends Mr {
  constructor() {
    super(...arguments), this.children = [], this.length = 0, this.prevAttrs = void 0, this.attrs = null, this.breakAfter = 0;
  }
  // Consumes source
  merge(t, n, r, i, o, s) {
    if (r) {
      if (!(r instanceof Fi))
        return !1;
      this.dom || r.transferDOM(this);
    }
    return i && this.setDeco(r ? r.attrs : null), BG(this, t, n, r ? r.children.slice() : [], o, s), !0;
  }
  split(t) {
    let n = new Fi();
    if (n.breakAfter = this.breakAfter, this.length == 0)
      return n;
    let { i: r, off: i } = this.childPos(t);
    i && (n.append(this.children[r].split(i), 0), this.children[r].merge(i, this.children[r].length, null, !1, 0, 0), r++);
    for (let o = r; o < this.children.length; o++)
      n.append(this.children[o], 0);
    for (; r > 0 && this.children[r - 1].length == 0; )
      this.children[--r].destroy();
    return this.children.length = r, this.markDirty(), this.length = t, n;
  }
  transferDOM(t) {
    this.dom && (this.markDirty(), t.setDOM(this.dom), t.prevAttrs = this.prevAttrs === void 0 ? this.attrs : this.prevAttrs, this.prevAttrs = void 0, this.dom = null);
  }
  setDeco(t) {
    aC(this.attrs, t) || (this.dom && (this.prevAttrs = this.attrs, this.markDirty()), this.attrs = t);
  }
  append(t, n) {
    UG(this, t, n);
  }
  // Only called when building a line view in ContentBuilder
  addLineDeco(t) {
    let n = t.spec.attributes, r = t.spec.class;
    n && (this.attrs = $k(n, this.attrs || {})), r && (this.attrs = $k({ class: r }, this.attrs || {}));
  }
  domAtPos(t) {
    return zG(this, t);
  }
  reuseDOM(t) {
    t.nodeName == "DIV" && (this.setDOM(t), this.flags |= 6);
  }
  sync(t, n) {
    var r;
    this.dom ? this.flags & 4 && ($G(this.dom), this.dom.className = "cm-line", this.prevAttrs = this.attrs ? null : void 0) : (this.setDOM(document.createElement("div")), this.dom.className = "cm-line", this.prevAttrs = this.attrs ? null : void 0), this.prevAttrs !== void 0 && (Nk(this.dom, this.prevAttrs, this.attrs), this.dom.classList.add("cm-line"), this.prevAttrs = void 0), super.sync(t, n);
    let i = this.dom.lastChild;
    for (; i && Mr.get(i) instanceof cc; )
      i = i.lastChild;
    if (!i || !this.length || i.nodeName != "BR" && ((r = Mr.get(i)) === null || r === void 0 ? void 0 : r.isEditable) == !1 && (!Vt.ios || !this.children.some((o) => o instanceof xl))) {
      let o = document.createElement("BR");
      o.cmIgnore = !0, this.dom.appendChild(o);
    }
  }
  measureTextSize() {
    if (this.children.length == 0 || this.length > 20)
      return null;
    let t = 0, n;
    for (let r of this.children) {
      if (!(r instanceof xl) || /[^ -~]/.test(r.text))
        return null;
      let i = Cm(r.dom);
      if (i.length != 1)
        return null;
      t += i[0].width, n = i[0].height;
    }
    return t ? {
      lineHeight: this.dom.getBoundingClientRect().height,
      charWidth: t / this.length,
      textHeight: n
    } : null;
  }
  coordsAt(t, n) {
    let r = WG(this, t, n);
    if (!this.children.length && r && this.parent) {
      let { heightOracle: i } = this.parent.view.viewState, o = r.bottom - r.top;
      if (Math.abs(o - i.lineHeight) < 2 && i.textHeight < o) {
        let s = (o - i.textHeight) / 2;
        return { top: r.top + s, bottom: r.bottom - s, left: r.left, right: r.left };
      }
    }
    return r;
  }
  become(t) {
    return t instanceof Fi && this.children.length == 0 && t.children.length == 0 && aC(this.attrs, t.attrs) && this.breakAfter == t.breakAfter;
  }
  covers() {
    return !0;
  }
  static find(t, n) {
    for (let r = 0, i = 0; r < t.children.length; r++) {
      let o = t.children[r], s = i + o.length;
      if (s >= n) {
        if (o instanceof Fi)
          return o;
        if (s > n)
          break;
      }
      i = s + o.breakAfter;
    }
    return null;
  }
}
class ic extends Mr {
  constructor(t, n, r) {
    super(), this.widget = t, this.length = n, this.deco = r, this.breakAfter = 0, this.prevWidget = null;
  }
  merge(t, n, r, i, o, s) {
    return r && (!(r instanceof ic) || !this.widget.compare(r.widget) || t > 0 && o <= 0 || n < this.length && s <= 0) ? !1 : (this.length = t + (r ? r.length : 0) + (this.length - n), !0);
  }
  domAtPos(t) {
    return t == 0 ? Ro.before(this.dom) : Ro.after(this.dom, t == this.length);
  }
  split(t) {
    let n = this.length - t;
    this.length = t;
    let r = new ic(this.widget, n, this.deco);
    return r.breakAfter = this.breakAfter, r;
  }
  get children() {
    return _$;
  }
  sync(t) {
    (!this.dom || !this.widget.updateDOM(this.dom, t)) && (this.dom && this.prevWidget && this.prevWidget.destroy(this.dom), this.prevWidget = null, this.setDOM(this.widget.toDOM(t)), this.widget.editable || (this.dom.contentEditable = "false"));
  }
  get overrideDOMText() {
    return this.parent ? this.parent.view.state.doc.slice(this.posAtStart, this.posAtEnd) : cr.empty;
  }
  domBoundsAround() {
    return null;
  }
  become(t) {
    return t instanceof ic && t.widget.constructor == this.widget.constructor ? (t.widget.compare(this.widget) || this.markDirty(!0), this.dom && !this.prevWidget && (this.prevWidget = this.widget), this.widget = t.widget, this.length = t.length, this.deco = t.deco, this.breakAfter = t.breakAfter, !0) : !1;
  }
  ignoreMutation() {
    return !0;
  }
  ignoreEvent(t) {
    return this.widget.ignoreEvent(t);
  }
  get isEditable() {
    return !1;
  }
  get isWidget() {
    return !0;
  }
  coordsAt(t, n) {
    let r = this.widget.coordsAt(this.dom, t, n);
    return r || (this.widget instanceof Mk ? null : gv(this.dom.getBoundingClientRect(), this.length ? t == 0 : n <= 0));
  }
  destroy() {
    super.destroy(), this.dom && this.widget.destroy(this.dom);
  }
  covers(t) {
    let { startSide: n, endSide: r } = this.deco;
    return n == r ? !1 : t < 0 ? n < 0 : r > 0;
  }
}
class Mk extends xc {
  constructor(t) {
    super(), this.height = t;
  }
  toDOM() {
    let t = document.createElement("div");
    return t.className = "cm-gap", this.updateDOM(t), t;
  }
  eq(t) {
    return t.height == this.height;
  }
  updateDOM(t) {
    return t.style.height = this.height + "px", !0;
  }
  get editable() {
    return !0;
  }
  get estimatedHeight() {
    return this.height;
  }
  ignoreEvent() {
    return !1;
  }
}
class x0 {
  constructor(t, n, r, i) {
    this.doc = t, this.pos = n, this.end = r, this.disallowBlockEffectsFor = i, this.content = [], this.curLine = null, this.breakAtStart = 0, this.pendingBuffer = 0, this.bufferMarks = [], this.atCursorPos = !0, this.openStart = -1, this.openEnd = -1, this.text = "", this.textOff = 0, this.cursor = t.iter(), this.skip = n;
  }
  posCovered() {
    if (this.content.length == 0)
      return !this.breakAtStart && this.doc.lineAt(this.pos).from != this.pos;
    let t = this.content[this.content.length - 1];
    return !(t.breakAfter || t instanceof ic && t.deco.endSide < 0);
  }
  getLine() {
    return this.curLine || (this.content.push(this.curLine = new Fi()), this.atCursorPos = !0), this.curLine;
  }
  flushBuffer(t = this.bufferMarks) {
    this.pendingBuffer && (this.curLine.append(ox(new Em(-1), t), t.length), this.pendingBuffer = 0);
  }
  addBlockWidget(t) {
    this.flushBuffer(), this.curLine = null, this.content.push(t);
  }
  finish(t) {
    this.pendingBuffer && t <= this.bufferMarks.length ? this.flushBuffer() : this.pendingBuffer = 0, !this.posCovered() && !(t && this.content.length && this.content[this.content.length - 1] instanceof ic) && this.getLine();
  }
  buildText(t, n, r) {
    for (; t > 0; ) {
      if (this.textOff == this.text.length) {
        let { value: o, lineBreak: s, done: a } = this.cursor.next(this.skip);
        if (this.skip = 0, a)
          throw new Error("Ran out of text content when drawing inline views");
        if (s) {
          this.posCovered() || this.getLine(), this.content.length ? this.content[this.content.length - 1].breakAfter = 1 : this.breakAtStart = 1, this.flushBuffer(), this.curLine = null, this.atCursorPos = !0, t--;
          continue;
        } else
          this.text = o, this.textOff = 0;
      }
      let i = Math.min(
        this.text.length - this.textOff,
        t,
        512
        /* T.Chunk */
      );
      this.flushBuffer(n.slice(n.length - r)), this.getLine().append(ox(new xl(this.text.slice(this.textOff, this.textOff + i)), n), r), this.atCursorPos = !0, this.textOff += i, t -= i, r = 0;
    }
  }
  span(t, n, r, i) {
    this.buildText(n - t, r, i), this.pos = n, this.openStart < 0 && (this.openStart = i);
  }
  point(t, n, r, i, o, s) {
    if (this.disallowBlockEffectsFor[s] && r instanceof md) {
      if (r.block)
        throw new RangeError("Block decorations may not be specified via plugins");
      if (n > this.doc.lineAt(this.pos).to)
        throw new RangeError("Decorations that replace line breaks may not be specified via plugins");
    }
    let a = n - t;
    if (r instanceof md)
      if (r.block)
        r.startSide > 0 && !this.posCovered() && this.getLine(), this.addBlockWidget(new ic(r.widget || Tm.block, a, r));
      else {
        let u = id.create(r.widget || Tm.inline, a, a ? 0 : r.startSide), c = this.atCursorPos && !u.isEditable && o <= i.length && (t < n || r.startSide > 0), d = !u.isEditable && (t < n || o > i.length || r.startSide <= 0), f = this.getLine();
        this.pendingBuffer == 2 && !c && !u.isEditable && (this.pendingBuffer = 0), this.flushBuffer(i), c && (f.append(ox(new Em(1), i), o), o = i.length + Math.max(0, o - i.length)), f.append(ox(u, i), o), this.atCursorPos = d, this.pendingBuffer = d ? t < n || o > i.length ? 1 : 2 : 0, this.pendingBuffer && (this.bufferMarks = i.slice());
      }
    else this.doc.lineAt(this.pos).from == this.pos && this.getLine().addLineDeco(r);
    a && (this.textOff + a <= this.text.length ? this.textOff += a : (this.skip += a - (this.text.length - this.textOff), this.text = "", this.textOff = 0), this.pos = n), this.openStart < 0 && (this.openStart = o);
  }
  static build(t, n, r, i, o) {
    let s = new x0(t, n, r, o);
    return s.openEnd = ir.spans(i, n, r, s), s.openStart < 0 && (s.openStart = s.openEnd), s.finish(s.openEnd), s;
  }
}
function ox(e, t) {
  for (let n of t)
    e = new cc(n, [e], e.length);
  return e;
}
class Tm extends xc {
  constructor(t) {
    super(), this.tag = t;
  }
  eq(t) {
    return t.tag == this.tag;
  }
  toDOM() {
    return document.createElement(this.tag);
  }
  updateDOM(t) {
    return t.nodeName.toLowerCase() == this.tag;
  }
  get isHidden() {
    return !0;
  }
}
Tm.inline = /* @__PURE__ */ new Tm("span");
Tm.block = /* @__PURE__ */ new Tm("div");
var Jr = /* @__PURE__ */ function(e) {
  return e[e.LTR = 0] = "LTR", e[e.RTL = 1] = "RTL", e;
}(Jr || (Jr = {}));
const tf = Jr.LTR, L$ = Jr.RTL;
function qG(e) {
  let t = [];
  for (let n = 0; n < e.length; n++)
    t.push(1 << +e[n]);
  return t;
}
const qnt = /* @__PURE__ */ qG("88888888888888888888888888888888888666888888787833333333337888888000000000000000000000000008888880000000000000000000000000088888888888888888888888888888888888887866668888088888663380888308888800000000000000000000000800000000000000000000000000000008"), Gnt = /* @__PURE__ */ qG("4444448826627288999999999992222222222222222222222222222222222222222222222229999999999999999999994444444444644222822222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222999999949999999229989999223333333333"), Rk = /* @__PURE__ */ Object.create(null), Ll = [];
for (let e of ["()", "[]", "{}"]) {
  let t = /* @__PURE__ */ e.charCodeAt(0), n = /* @__PURE__ */ e.charCodeAt(1);
  Rk[t] = n, Rk[n] = -t;
}
function GG(e) {
  return e <= 247 ? qnt[e] : 1424 <= e && e <= 1524 ? 2 : 1536 <= e && e <= 1785 ? Gnt[e - 1536] : 1774 <= e && e <= 2220 ? 4 : 8192 <= e && e <= 8204 ? 256 : 64336 <= e && e <= 65023 ? 4 : 1;
}
const Ynt = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac\ufb50-\ufdff]/;
class od {
  /**
  The direction of this span.
  */
  get dir() {
    return this.level % 2 ? L$ : tf;
  }
  /**
  @internal
  */
  constructor(t, n, r) {
    this.from = t, this.to = n, this.level = r;
  }
  /**
  @internal
  */
  side(t, n) {
    return this.dir == n == t ? this.to : this.from;
  }
  /**
  @internal
  */
  forward(t, n) {
    return t == (this.dir == n);
  }
  /**
  @internal
  */
  static find(t, n, r, i) {
    let o = -1;
    for (let s = 0; s < t.length; s++) {
      let a = t[s];
      if (a.from <= n && a.to >= n) {
        if (a.level == r)
          return s;
        (o < 0 || (i != 0 ? i < 0 ? a.from < n : a.to > n : t[o].level > a.level)) && (o = s);
      }
    }
    if (o < 0)
      throw new RangeError("Index out of range");
    return o;
  }
}
function YG(e, t) {
  if (e.length != t.length)
    return !1;
  for (let n = 0; n < e.length; n++) {
    let r = e[n], i = t[n];
    if (r.from != i.from || r.to != i.to || r.direction != i.direction || !YG(r.inner, i.inner))
      return !1;
  }
  return !0;
}
const $r = [];
function Knt(e, t, n, r, i) {
  for (let o = 0; o <= r.length; o++) {
    let s = o ? r[o - 1].to : t, a = o < r.length ? r[o].from : n, u = o ? 256 : i;
    for (let c = s, d = u, f = u; c < a; c++) {
      let h = GG(e.charCodeAt(c));
      h == 512 ? h = d : h == 8 && f == 4 && (h = 16), $r[c] = h == 4 ? 2 : h, h & 7 && (f = h), d = h;
    }
    for (let c = s, d = u, f = u; c < a; c++) {
      let h = $r[c];
      if (h == 128)
        c < a - 1 && d == $r[c + 1] && d & 24 ? h = $r[c] = d : $r[c] = 256;
      else if (h == 64) {
        let m = c + 1;
        for (; m < a && $r[m] == 64; )
          m++;
        let v = c && d == 8 || m < n && $r[m] == 8 ? f == 1 ? 1 : 8 : 256;
        for (let x = c; x < m; x++)
          $r[x] = v;
        c = m - 1;
      } else h == 8 && f == 1 && ($r[c] = 1);
      d = h, h & 7 && (f = h);
    }
  }
}
function Jnt(e, t, n, r, i) {
  let o = i == 1 ? 2 : 1;
  for (let s = 0, a = 0, u = 0; s <= r.length; s++) {
    let c = s ? r[s - 1].to : t, d = s < r.length ? r[s].from : n;
    for (let f = c, h, m, v; f < d; f++)
      if (m = Rk[h = e.charCodeAt(f)])
        if (m < 0) {
          for (let x = a - 3; x >= 0; x -= 3)
            if (Ll[x + 1] == -m) {
              let C = Ll[x + 2], E = C & 2 ? i : C & 4 ? C & 1 ? o : i : 0;
              E && ($r[f] = $r[Ll[x]] = E), a = x;
              break;
            }
        } else {
          if (Ll.length == 189)
            break;
          Ll[a++] = f, Ll[a++] = h, Ll[a++] = u;
        }
      else if ((v = $r[f]) == 2 || v == 1) {
        let x = v == i;
        u = x ? 0 : 1;
        for (let C = a - 3; C >= 0; C -= 3) {
          let E = Ll[C + 2];
          if (E & 2)
            break;
          if (x)
            Ll[C + 2] |= 2;
          else {
            if (E & 4)
              break;
            Ll[C + 2] |= 4;
          }
        }
      }
  }
}
function Xnt(e, t, n, r) {
  for (let i = 0, o = r; i <= n.length; i++) {
    let s = i ? n[i - 1].to : e, a = i < n.length ? n[i].from : t;
    for (let u = s; u < a; ) {
      let c = $r[u];
      if (c == 256) {
        let d = u + 1;
        for (; ; )
          if (d == a) {
            if (i == n.length)
              break;
            d = n[i++].to, a = i < n.length ? n[i].from : t;
          } else if ($r[d] == 256)
            d++;
          else
            break;
        let f = o == 1, h = (d < t ? $r[d] : r) == 1, m = f == h ? f ? 1 : 2 : r;
        for (let v = d, x = i, C = x ? n[x - 1].to : e; v > u; )
          v == C && (v = n[--x].from, C = x ? n[x - 1].to : e), $r[--v] = m;
        u = d;
      } else
        o = c, u++;
    }
  }
}
function _k(e, t, n, r, i, o, s) {
  let a = r % 2 ? 2 : 1;
  if (r % 2 == i % 2)
    for (let u = t, c = 0; u < n; ) {
      let d = !0, f = !1;
      if (c == o.length || u < o[c].from) {
        let x = $r[u];
        x != a && (d = !1, f = x == 16);
      }
      let h = !d && a == 1 ? [] : null, m = d ? r : r + 1, v = u;
      e: for (; ; )
        if (c < o.length && v == o[c].from) {
          if (f)
            break e;
          let x = o[c];
          if (!d)
            for (let C = x.to, E = c + 1; ; ) {
              if (C == n)
                break e;
              if (E < o.length && o[E].from == C)
                C = o[E++].to;
              else {
                if ($r[C] == a)
                  break e;
                break;
              }
            }
          if (c++, h)
            h.push(x);
          else {
            x.from > u && s.push(new od(u, x.from, m));
            let C = x.direction == tf != !(m % 2);
            Lk(e, C ? r + 1 : r, i, x.inner, x.from, x.to, s), u = x.to;
          }
          v = x.to;
        } else {
          if (v == n || (d ? $r[v] != a : $r[v] == a))
            break;
          v++;
        }
      h ? _k(e, u, v, r + 1, i, h, s) : u < v && s.push(new od(u, v, m)), u = v;
    }
  else
    for (let u = n, c = o.length; u > t; ) {
      let d = !0, f = !1;
      if (!c || u > o[c - 1].to) {
        let x = $r[u - 1];
        x != a && (d = !1, f = x == 16);
      }
      let h = !d && a == 1 ? [] : null, m = d ? r : r + 1, v = u;
      e: for (; ; )
        if (c && v == o[c - 1].to) {
          if (f)
            break e;
          let x = o[--c];
          if (!d)
            for (let C = x.from, E = c; ; ) {
              if (C == t)
                break e;
              if (E && o[E - 1].to == C)
                C = o[--E].from;
              else {
                if ($r[C - 1] == a)
                  break e;
                break;
              }
            }
          if (h)
            h.push(x);
          else {
            x.to < u && s.push(new od(x.to, u, m));
            let C = x.direction == tf != !(m % 2);
            Lk(e, C ? r + 1 : r, i, x.inner, x.from, x.to, s), u = x.from;
          }
          v = x.from;
        } else {
          if (v == t || (d ? $r[v - 1] != a : $r[v - 1] == a))
            break;
          v--;
        }
      h ? _k(e, v, u, r + 1, i, h, s) : v < u && s.push(new od(v, u, m)), u = v;
    }
}
function Lk(e, t, n, r, i, o, s) {
  let a = t % 2 ? 2 : 1;
  Knt(e, i, o, r, a), Jnt(e, i, o, r, a), Xnt(i, o, r, a), _k(e, i, o, t, n, r, s);
}
function Qnt(e, t, n) {
  if (!e)
    return [new od(0, 0, t == L$ ? 1 : 0)];
  if (t == tf && !n.length && !Ynt.test(e))
    return KG(e.length);
  if (n.length)
    for (; e.length > $r.length; )
      $r[$r.length] = 256;
  let r = [], i = t == tf ? 0 : 1;
  return Lk(e, i, i, n, 0, e.length, r), r;
}
function KG(e) {
  return [new od(0, e, 0)];
}
let JG = "";
function Znt(e, t, n, r, i) {
  var o;
  let s = r.head - e.from, a = od.find(t, s, (o = r.bidiLevel) !== null && o !== void 0 ? o : -1, r.assoc), u = t[a], c = u.side(i, n);
  if (s == c) {
    let h = a += i ? 1 : -1;
    if (h < 0 || h >= t.length)
      return null;
    u = t[a = h], s = u.side(!i, n), c = u.side(i, n);
  }
  let d = go(e.text, s, u.forward(i, n));
  (d < u.from || d > u.to) && (d = c), JG = e.text.slice(Math.min(s, d), Math.max(s, d));
  let f = a == (i ? t.length - 1 : 0) ? null : t[a + (i ? 1 : -1)];
  return f && d == c && f.level + (i ? 0 : 1) < u.level ? it.cursor(f.side(!i, n) + e.from, f.forward(i, n) ? 1 : -1, f.level) : it.cursor(d + e.from, u.forward(i, n) ? -1 : 1, u.level);
}
function ert(e, t, n) {
  for (let r = t; r < n; r++) {
    let i = GG(e.charCodeAt(r));
    if (i == 1)
      return tf;
    if (i == 2 || i == 4)
      return L$;
  }
  return tf;
}
const XG = /* @__PURE__ */ zt.define(), QG = /* @__PURE__ */ zt.define(), ZG = /* @__PURE__ */ zt.define(), eY = /* @__PURE__ */ zt.define(), Bk = /* @__PURE__ */ zt.define(), tY = /* @__PURE__ */ zt.define(), nY = /* @__PURE__ */ zt.define(), B$ = /* @__PURE__ */ zt.define(), j$ = /* @__PURE__ */ zt.define(), rY = /* @__PURE__ */ zt.define({
  combine: (e) => e.some((t) => t)
}), iY = /* @__PURE__ */ zt.define({
  combine: (e) => e.some((t) => t)
}), oY = /* @__PURE__ */ zt.define();
class tm {
  constructor(t, n = "nearest", r = "nearest", i = 5, o = 5, s = !1) {
    this.range = t, this.y = n, this.x = r, this.yMargin = i, this.xMargin = o, this.isSnapshot = s;
  }
  map(t) {
    return t.empty ? this : new tm(this.range.map(t), this.y, this.x, this.yMargin, this.xMargin, this.isSnapshot);
  }
  clip(t) {
    return this.range.to <= t.doc.length ? this : new tm(it.cursor(t.doc.length), this.y, this.x, this.yMargin, this.xMargin, this.isSnapshot);
  }
}
const sx = /* @__PURE__ */ An.define({ map: (e, t) => e.map(t) }), sY = /* @__PURE__ */ An.define();
function Ts(e, t, n) {
  let r = e.facet(eY);
  r.length ? r[0](t) : window.onerror ? window.onerror(String(t), n, void 0, void 0, t) : n ? console.error(n + ":", t) : console.error(t);
}
const ec = /* @__PURE__ */ zt.define({ combine: (e) => e.length ? e[0] : !0 });
let trt = 0;
const Yy = /* @__PURE__ */ zt.define();
class Pi {
  constructor(t, n, r, i, o) {
    this.id = t, this.create = n, this.domEventHandlers = r, this.domEventObservers = i, this.extension = o(this);
  }
  /**
  Define a plugin from a constructor function that creates the
  plugin's value, given an editor view.
  */
  static define(t, n) {
    const { eventHandlers: r, eventObservers: i, provide: o, decorations: s } = n || {};
    return new Pi(trt++, t, r, i, (a) => {
      let u = [Yy.of(a)];
      return s && u.push(nb.of((c) => {
        let d = c.plugin(a);
        return d ? s(d) : tn.none;
      })), o && u.push(o(a)), u;
    });
  }
  /**
  Create a plugin for a class whose constructor takes a single
  editor view as argument.
  */
  static fromClass(t, n) {
    return Pi.define((r) => new t(r), n);
  }
}
class Sw {
  constructor(t) {
    this.spec = t, this.mustUpdate = null, this.value = null;
  }
  update(t) {
    if (this.value) {
      if (this.mustUpdate) {
        let n = this.mustUpdate;
        if (this.mustUpdate = null, this.value.update)
          try {
            this.value.update(n);
          } catch (r) {
            if (Ts(n.state, r, "CodeMirror plugin crashed"), this.value.destroy)
              try {
                this.value.destroy();
              } catch {
              }
            this.deactivate();
          }
      }
    } else if (this.spec)
      try {
        this.value = this.spec.create(t);
      } catch (n) {
        Ts(t.state, n, "CodeMirror plugin crashed"), this.deactivate();
      }
    return this;
  }
  destroy(t) {
    var n;
    if (!((n = this.value) === null || n === void 0) && n.destroy)
      try {
        this.value.destroy();
      } catch (r) {
        Ts(t.state, r, "CodeMirror plugin crashed");
      }
  }
  deactivate() {
    this.spec = this.value = null;
  }
}
const aY = /* @__PURE__ */ zt.define(), V$ = /* @__PURE__ */ zt.define(), nb = /* @__PURE__ */ zt.define(), lY = /* @__PURE__ */ zt.define(), z$ = /* @__PURE__ */ zt.define(), uY = /* @__PURE__ */ zt.define();
function j8(e, t) {
  let n = e.state.facet(uY);
  if (!n.length)
    return n;
  let r = n.map((o) => o instanceof Function ? o(e) : o), i = [];
  return ir.spans(r, t.from, t.to, {
    point() {
    },
    span(o, s, a, u) {
      let c = o - t.from, d = s - t.from, f = i;
      for (let h = a.length - 1; h >= 0; h--, u--) {
        let m = a[h].spec.bidiIsolate, v;
        if (m == null && (m = ert(t.text, c, d)), u > 0 && f.length && (v = f[f.length - 1]).to == c && v.direction == m)
          v.to = d, f = v.inner;
        else {
          let x = { from: c, to: d, direction: m, inner: [] };
          f.push(x), f = x.inner;
        }
      }
    }
  }), i;
}
const cY = /* @__PURE__ */ zt.define();
function U$(e) {
  let t = 0, n = 0, r = 0, i = 0;
  for (let o of e.state.facet(cY)) {
    let s = o(e);
    s && (s.left != null && (t = Math.max(t, s.left)), s.right != null && (n = Math.max(n, s.right)), s.top != null && (r = Math.max(r, s.top)), s.bottom != null && (i = Math.max(i, s.bottom)));
  }
  return { left: t, right: n, top: r, bottom: i };
}
const Ky = /* @__PURE__ */ zt.define();
class _a {
  constructor(t, n, r, i) {
    this.fromA = t, this.toA = n, this.fromB = r, this.toB = i;
  }
  join(t) {
    return new _a(Math.min(this.fromA, t.fromA), Math.max(this.toA, t.toA), Math.min(this.fromB, t.fromB), Math.max(this.toB, t.toB));
  }
  addToSet(t) {
    let n = t.length, r = this;
    for (; n > 0; n--) {
      let i = t[n - 1];
      if (!(i.fromA > r.toA)) {
        if (i.toA < r.fromA)
          break;
        r = r.join(i), t.splice(n - 1, 1);
      }
    }
    return t.splice(n, 0, r), t;
  }
  static extendWithRanges(t, n) {
    if (n.length == 0)
      return t;
    let r = [];
    for (let i = 0, o = 0, s = 0, a = 0; ; i++) {
      let u = i == t.length ? null : t[i], c = s - a, d = u ? u.fromB : 1e9;
      for (; o < n.length && n[o] < d; ) {
        let f = n[o], h = n[o + 1], m = Math.max(a, f), v = Math.min(d, h);
        if (m <= v && new _a(m + c, v + c, m, v).addToSet(r), h > d)
          break;
        o += 2;
      }
      if (!u)
        return r;
      new _a(u.fromA, u.toA, u.fromB, u.toB).addToSet(r), s = u.toA, a = u.toB;
    }
  }
}
class lC {
  constructor(t, n, r) {
    this.view = t, this.state = n, this.transactions = r, this.flags = 0, this.startState = t.state, this.changes = Ui.empty(this.startState.doc.length);
    for (let o of r)
      this.changes = this.changes.compose(o.changes);
    let i = [];
    this.changes.iterChangedRanges((o, s, a, u) => i.push(new _a(o, s, a, u))), this.changedRanges = i;
  }
  /**
  @internal
  */
  static create(t, n, r) {
    return new lC(t, n, r);
  }
  /**
  Tells you whether the [viewport](https://codemirror.net/6/docs/ref/#view.EditorView.viewport) or
  [visible ranges](https://codemirror.net/6/docs/ref/#view.EditorView.visibleRanges) changed in this
  update.
  */
  get viewportChanged() {
    return (this.flags & 4) > 0;
  }
  /**
  Returns true when
  [`viewportChanged`](https://codemirror.net/6/docs/ref/#view.ViewUpdate.viewportChanged) is true
  and the viewport change is not just the result of mapping it in
  response to document changes.
  */
  get viewportMoved() {
    return (this.flags & 8) > 0;
  }
  /**
  Indicates whether the height of a block element in the editor
  changed in this update.
  */
  get heightChanged() {
    return (this.flags & 2) > 0;
  }
  /**
  Returns true when the document was modified or the size of the
  editor, or elements within the editor, changed.
  */
  get geometryChanged() {
    return this.docChanged || (this.flags & 18) > 0;
  }
  /**
  True when this update indicates a focus change.
  */
  get focusChanged() {
    return (this.flags & 1) > 0;
  }
  /**
  Whether the document changed in this update.
  */
  get docChanged() {
    return !this.changes.empty;
  }
  /**
  Whether the selection was explicitly set in this update.
  */
  get selectionSet() {
    return this.transactions.some((t) => t.selection);
  }
  /**
  @internal
  */
  get empty() {
    return this.flags == 0 && this.transactions.length == 0;
  }
}
class V8 extends Mr {
  get length() {
    return this.view.state.doc.length;
  }
  constructor(t) {
    super(), this.view = t, this.decorations = [], this.dynamicDecorationMap = [!1], this.domChanged = null, this.hasComposition = null, this.markedForComposition = /* @__PURE__ */ new Set(), this.editContextFormatting = tn.none, this.lastCompositionAfterCursor = !1, this.minWidth = 0, this.minWidthFrom = 0, this.minWidthTo = 0, this.impreciseAnchor = null, this.impreciseHead = null, this.forceSelection = !1, this.lastUpdate = Date.now(), this.setDOM(t.contentDOM), this.children = [new Fi()], this.children[0].setParent(this), this.updateDeco(), this.updateInner([new _a(0, 0, 0, t.state.doc.length)], 0, null);
  }
  // Update the document view to a given state.
  update(t) {
    var n;
    let r = t.changedRanges;
    this.minWidth > 0 && r.length && (r.every(({ fromA: c, toA: d }) => d < this.minWidthFrom || c > this.minWidthTo) ? (this.minWidthFrom = t.changes.mapPos(this.minWidthFrom, 1), this.minWidthTo = t.changes.mapPos(this.minWidthTo, 1)) : this.minWidth = this.minWidthFrom = this.minWidthTo = 0), this.updateEditContextFormatting(t);
    let i = -1;
    this.view.inputState.composing >= 0 && !this.view.observer.editContext && (!((n = this.domChanged) === null || n === void 0) && n.newSel ? i = this.domChanged.newSel.head : !lrt(t.changes, this.hasComposition) && !t.selectionSet && (i = t.state.selection.main.head));
    let o = i > -1 ? rrt(this.view, t.changes, i) : null;
    if (this.domChanged = null, this.hasComposition) {
      this.markedForComposition.clear();
      let { from: c, to: d } = this.hasComposition;
      r = new _a(c, d, t.changes.mapPos(c, -1), t.changes.mapPos(d, 1)).addToSet(r.slice());
    }
    this.hasComposition = o ? { from: o.range.fromB, to: o.range.toB } : null, (Vt.ie || Vt.chrome) && !o && t && t.state.doc.lines != t.startState.doc.lines && (this.forceSelection = !0);
    let s = this.decorations, a = this.updateDeco(), u = srt(s, a, t.changes);
    return r = _a.extendWithRanges(r, u), !(this.flags & 7) && r.length == 0 ? !1 : (this.updateInner(r, t.startState.doc.length, o), t.transactions.length && (this.lastUpdate = Date.now()), !0);
  }
  // Used by update and the constructor do perform the actual DOM
  // update
  updateInner(t, n, r) {
    this.view.viewState.mustMeasureContent = !0, this.updateChildren(t, n, r);
    let { observer: i } = this.view;
    i.ignore(() => {
      this.dom.style.height = this.view.viewState.contentHeight / this.view.scaleY + "px", this.dom.style.flexBasis = this.minWidth ? this.minWidth + "px" : "";
      let s = Vt.chrome || Vt.ios ? { node: i.selectionRange.focusNode, written: !1 } : void 0;
      this.sync(this.view, s), this.flags &= -8, s && (s.written || i.selectionRange.focusNode != s.node) && (this.forceSelection = !0), this.dom.style.height = "";
    }), this.markedForComposition.forEach(
      (s) => s.flags &= -9
      /* ViewFlag.Composition */
    );
    let o = [];
    if (this.view.viewport.from || this.view.viewport.to < this.view.state.doc.length)
      for (let s of this.children)
        s instanceof ic && s.widget instanceof Mk && o.push(s.dom);
    i.updateGaps(o);
  }
  updateChildren(t, n, r) {
    let i = r ? r.range.addToSet(t.slice()) : t, o = this.childCursor(n);
    for (let s = i.length - 1; ; s--) {
      let a = s >= 0 ? i[s] : null;
      if (!a)
        break;
      let { fromA: u, toA: c, fromB: d, toB: f } = a, h, m, v, x;
      if (r && r.range.fromB < f && r.range.toB > d) {
        let O = x0.build(this.view.state.doc, d, r.range.fromB, this.decorations, this.dynamicDecorationMap), A = x0.build(this.view.state.doc, r.range.toB, f, this.decorations, this.dynamicDecorationMap);
        m = O.breakAtStart, v = O.openStart, x = A.openEnd;
        let I = this.compositionView(r);
        A.breakAtStart ? I.breakAfter = 1 : A.content.length && I.merge(I.length, I.length, A.content[0], !1, A.openStart, 0) && (I.breakAfter = A.content[0].breakAfter, A.content.shift()), O.content.length && I.merge(0, 0, O.content[O.content.length - 1], !0, 0, O.openEnd) && O.content.pop(), h = O.content.concat(I).concat(A.content);
      } else
        ({ content: h, breakAtStart: m, openStart: v, openEnd: x } = x0.build(this.view.state.doc, d, f, this.decorations, this.dynamicDecorationMap));
      let { i: C, off: E } = o.findPos(c, 1), { i: S, off: w } = o.findPos(u, -1);
      LG(this, S, w, C, E, h, m, v, x);
    }
    r && this.fixCompositionDOM(r);
  }
  updateEditContextFormatting(t) {
    this.editContextFormatting = this.editContextFormatting.map(t.changes);
    for (let n of t.transactions)
      for (let r of n.effects)
        r.is(sY) && (this.editContextFormatting = r.value);
  }
  compositionView(t) {
    let n = new xl(t.text.nodeValue);
    n.flags |= 8;
    for (let { deco: i } of t.marks)
      n = new cc(i, [n], n.length);
    let r = new Fi();
    return r.append(n, 0), r;
  }
  fixCompositionDOM(t) {
    let n = (o, s) => {
      s.flags |= 8 | (s.children.some(
        (u) => u.flags & 7
        /* ViewFlag.Dirty */
      ) ? 1 : 0), this.markedForComposition.add(s);
      let a = Mr.get(o);
      a && a != s && (a.dom = null), s.setDOM(o);
    }, r = this.childPos(t.range.fromB, 1), i = this.children[r.i];
    n(t.line, i);
    for (let o = t.marks.length - 1; o >= -1; o--)
      r = i.childPos(r.off, 1), i = i.children[r.i], n(o >= 0 ? t.marks[o].node : t.text, i);
  }
  // Sync the DOM selection to this.state.selection
  updateSelection(t = !1, n = !1) {
    (t || !this.view.observer.selectionRange.focusNode) && this.view.observer.readSelectionRange();
    let r = this.view.root.activeElement, i = r == this.dom, o = !i && !(this.view.state.facet(ec) || this.dom.tabIndex > -1) && oD(this.dom, this.view.observer.selectionRange) && !(r && this.dom.contains(r));
    if (!(i || n || o))
      return;
    let s = this.forceSelection;
    this.forceSelection = !1;
    let a = this.view.state.selection.main, u = this.moveToLine(this.domAtPos(a.anchor)), c = a.empty ? u : this.moveToLine(this.domAtPos(a.head));
    if (Vt.gecko && a.empty && !this.hasComposition && nrt(u)) {
      let f = document.createTextNode("");
      this.view.observer.ignore(() => u.node.insertBefore(f, u.node.childNodes[u.offset] || null)), u = c = new Ro(f, 0), s = !0;
    }
    let d = this.view.observer.selectionRange;
    (s || !d.focusNode || (!v0(u.node, u.offset, d.anchorNode, d.anchorOffset) || !v0(c.node, c.offset, d.focusNode, d.focusOffset)) && !this.suppressWidgetCursorChange(d, a)) && (this.view.observer.ignore(() => {
      Vt.android && Vt.chrome && this.dom.contains(d.focusNode) && art(d.focusNode, this.dom) && (this.dom.blur(), this.dom.focus({ preventScroll: !0 }));
      let f = tb(this.view.root);
      if (f) if (a.empty) {
        if (Vt.gecko) {
          let h = irt(u.node, u.offset);
          if (h && h != 3) {
            let m = (h == 1 ? MG : RG)(u.node, u.offset);
            m && (u = new Ro(m.node, m.offset));
          }
        }
        f.collapse(u.node, u.offset), a.bidiLevel != null && f.caretBidiLevel !== void 0 && (f.caretBidiLevel = a.bidiLevel);
      } else if (f.extend) {
        f.collapse(u.node, u.offset);
        try {
          f.extend(c.node, c.offset);
        } catch {
        }
      } else {
        let h = document.createRange();
        a.anchor > a.head && ([u, c] = [c, u]), h.setEnd(c.node, c.offset), h.setStart(u.node, u.offset), f.removeAllRanges(), f.addRange(h);
      }
      o && this.view.root.activeElement == this.dom && (this.dom.blur(), r && r.focus());
    }), this.view.observer.setSelectionRange(u, c)), this.impreciseAnchor = u.precise ? null : new Ro(d.anchorNode, d.anchorOffset), this.impreciseHead = c.precise ? null : new Ro(d.focusNode, d.focusOffset);
  }
  // If a zero-length widget is inserted next to the cursor during
  // composition, avoid moving it across it and disrupting the
  // composition.
  suppressWidgetCursorChange(t, n) {
    return this.hasComposition && n.empty && v0(t.focusNode, t.focusOffset, t.anchorNode, t.anchorOffset) && this.posFromDOM(t.focusNode, t.focusOffset) == n.head;
  }
  enforceCursorAssoc() {
    if (this.hasComposition)
      return;
    let { view: t } = this, n = t.state.selection.main, r = tb(t.root), { anchorNode: i, anchorOffset: o } = t.observer.selectionRange;
    if (!r || !n.empty || !n.assoc || !r.modify)
      return;
    let s = Fi.find(this, n.head);
    if (!s)
      return;
    let a = s.posAtStart;
    if (n.head == a || n.head == a + s.length)
      return;
    let u = this.coordsAt(n.head, -1), c = this.coordsAt(n.head, 1);
    if (!u || !c || u.bottom > c.top)
      return;
    let d = this.domAtPos(n.head + n.assoc);
    r.collapse(d.node, d.offset), r.modify("move", n.assoc < 0 ? "forward" : "backward", "lineboundary"), t.observer.readSelectionRange();
    let f = t.observer.selectionRange;
    t.docView.posFromDOM(f.anchorNode, f.anchorOffset) != n.from && r.collapse(i, o);
  }
  // If a position is in/near a block widget, move it to a nearby text
  // line, since we don't want the cursor inside a block widget.
  moveToLine(t) {
    let n = this.dom, r;
    if (t.node != n)
      return t;
    for (let i = t.offset; !r && i < n.childNodes.length; i++) {
      let o = Mr.get(n.childNodes[i]);
      o instanceof Fi && (r = o.domAtPos(0));
    }
    for (let i = t.offset - 1; !r && i >= 0; i--) {
      let o = Mr.get(n.childNodes[i]);
      o instanceof Fi && (r = o.domAtPos(o.length));
    }
    return r ? new Ro(r.node, r.offset, !0) : t;
  }
  nearest(t) {
    for (let n = t; n; ) {
      let r = Mr.get(n);
      if (r && r.rootView == this)
        return r;
      n = n.parentNode;
    }
    return null;
  }
  posFromDOM(t, n) {
    let r = this.nearest(t);
    if (!r)
      throw new RangeError("Trying to find position for a DOM position outside of the document");
    return r.localPosFromDOM(t, n) + r.posAtStart;
  }
  domAtPos(t) {
    let { i: n, off: r } = this.childCursor().findPos(t, -1);
    for (; n < this.children.length - 1; ) {
      let i = this.children[n];
      if (r < i.length || i instanceof Fi)
        break;
      n++, r = 0;
    }
    return this.children[n].domAtPos(r);
  }
  coordsAt(t, n) {
    let r = null, i = 0;
    for (let o = this.length, s = this.children.length - 1; s >= 0; s--) {
      let a = this.children[s], u = o - a.breakAfter, c = u - a.length;
      if (u < t)
        break;
      if (c <= t && (c < t || a.covers(-1)) && (u > t || a.covers(1)) && (!r || a instanceof Fi && !(r instanceof Fi && n >= 0)))
        r = a, i = c;
      else if (r && c == t && u == t && a instanceof ic && Math.abs(n) < 2) {
        if (a.deco.startSide < 0)
          break;
        s && (r = null);
      }
      o = c;
    }
    return r ? r.coordsAt(t - i, n) : null;
  }
  coordsForChar(t) {
    let { i: n, off: r } = this.childPos(t, 1), i = this.children[n];
    if (!(i instanceof Fi))
      return null;
    for (; i.children.length; ) {
      let { i: a, off: u } = i.childPos(r, 1);
      for (; ; a++) {
        if (a == i.children.length)
          return null;
        if ((i = i.children[a]).length)
          break;
      }
      r = u;
    }
    if (!(i instanceof xl))
      return null;
    let o = go(i.text, r);
    if (o == r)
      return null;
    let s = ef(i.dom, r, o).getClientRects();
    for (let a = 0; a < s.length; a++) {
      let u = s[a];
      if (a == s.length - 1 || u.top < u.bottom && u.left < u.right)
        return u;
    }
    return null;
  }
  measureVisibleLineHeights(t) {
    let n = [], { from: r, to: i } = t, o = this.view.contentDOM.clientWidth, s = o > Math.max(this.view.scrollDOM.clientWidth, this.minWidth) + 1, a = -1, u = this.view.textDirection == Jr.LTR;
    for (let c = 0, d = 0; d < this.children.length; d++) {
      let f = this.children[d], h = c + f.length;
      if (h > i)
        break;
      if (c >= r) {
        let m = f.dom.getBoundingClientRect();
        if (n.push(m.height), s) {
          let v = f.dom.lastChild, x = v ? Cm(v) : [];
          if (x.length) {
            let C = x[x.length - 1], E = u ? C.right - m.left : m.right - C.left;
            E > a && (a = E, this.minWidth = o, this.minWidthFrom = c, this.minWidthTo = h);
          }
        }
      }
      c = h + f.breakAfter;
    }
    return n;
  }
  textDirectionAt(t) {
    let { i: n } = this.childPos(t, 1);
    return getComputedStyle(this.children[n].dom).direction == "rtl" ? Jr.RTL : Jr.LTR;
  }
  measureTextSize() {
    for (let o of this.children)
      if (o instanceof Fi) {
        let s = o.measureTextSize();
        if (s)
          return s;
      }
    let t = document.createElement("div"), n, r, i;
    return t.className = "cm-line", t.style.width = "99999px", t.style.position = "absolute", t.textContent = "abc def ghi jkl mno pqr stu", this.view.observer.ignore(() => {
      this.dom.appendChild(t);
      let o = Cm(t.firstChild)[0];
      n = t.getBoundingClientRect().height, r = o ? o.width / 27 : 7, i = o ? o.height : n, t.remove();
    }), { lineHeight: n, charWidth: r, textHeight: i };
  }
  childCursor(t = this.length) {
    let n = this.children.length;
    return n && (t -= this.children[--n].length), new _G(this.children, t, n);
  }
  computeBlockGapDeco() {
    let t = [], n = this.view.viewState;
    for (let r = 0, i = 0; ; i++) {
      let o = i == n.viewports.length ? null : n.viewports[i], s = o ? o.from - 1 : this.length;
      if (s > r) {
        let a = (n.lineBlockAt(s).bottom - n.lineBlockAt(r).top) / this.view.scaleY;
        t.push(tn.replace({
          widget: new Mk(a),
          block: !0,
          inclusive: !0,
          isBlockGap: !0
        }).range(r, s));
      }
      if (!o)
        break;
      r = o.to + 1;
    }
    return tn.set(t);
  }
  updateDeco() {
    let t = 1, n = this.view.state.facet(nb).map((o) => (this.dynamicDecorationMap[t++] = typeof o == "function") ? o(this.view) : o), r = !1, i = this.view.state.facet(lY).map((o, s) => {
      let a = typeof o == "function";
      return a && (r = !0), a ? o(this.view) : o;
    });
    for (i.length && (this.dynamicDecorationMap[t++] = r, n.push(ir.join(i))), this.decorations = [
      this.editContextFormatting,
      ...n,
      this.computeBlockGapDeco(),
      this.view.viewState.lineGapDeco
    ]; t < this.decorations.length; )
      this.dynamicDecorationMap[t++] = !1;
    return this.decorations;
  }
  scrollIntoView(t) {
    if (t.isSnapshot) {
      let c = this.view.viewState.lineBlockAt(t.range.head);
      this.view.scrollDOM.scrollTop = c.top - t.yMargin, this.view.scrollDOM.scrollLeft = t.xMargin;
      return;
    }
    for (let c of this.view.state.facet(oY))
      try {
        if (c(this.view, t.range, t))
          return !0;
      } catch (d) {
        Ts(this.view.state, d, "scroll handler");
      }
    let { range: n } = t, r = this.coordsAt(n.head, n.empty ? n.assoc : n.head > n.anchor ? -1 : 1), i;
    if (!r)
      return;
    !n.empty && (i = this.coordsAt(n.anchor, n.anchor > n.head ? -1 : 1)) && (r = {
      left: Math.min(r.left, i.left),
      top: Math.min(r.top, i.top),
      right: Math.max(r.right, i.right),
      bottom: Math.max(r.bottom, i.bottom)
    });
    let o = U$(this.view), s = {
      left: r.left - o.left,
      top: r.top - o.top,
      right: r.right + o.right,
      bottom: r.bottom + o.bottom
    }, { offsetWidth: a, offsetHeight: u } = this.view.scrollDOM;
    Rnt(this.view.scrollDOM, s, n.head < n.anchor ? -1 : 1, t.x, t.y, Math.max(Math.min(t.xMargin, a), -a), Math.max(Math.min(t.yMargin, u), -u), this.view.textDirection == Jr.LTR);
  }
}
function nrt(e) {
  return e.node.nodeType == 1 && e.node.firstChild && (e.offset == 0 || e.node.childNodes[e.offset - 1].contentEditable == "false") && (e.offset == e.node.childNodes.length || e.node.childNodes[e.offset].contentEditable == "false");
}
function dY(e, t) {
  let n = e.observer.selectionRange;
  if (!n.focusNode)
    return null;
  let r = MG(n.focusNode, n.focusOffset), i = RG(n.focusNode, n.focusOffset), o = r || i;
  if (i && r && i.node != r.node) {
    let a = Mr.get(i.node);
    if (!a || a instanceof xl && a.text != i.node.nodeValue)
      o = i;
    else if (e.docView.lastCompositionAfterCursor) {
      let u = Mr.get(r.node);
      !u || u instanceof xl && u.text != r.node.nodeValue || (o = i);
    }
  }
  if (e.docView.lastCompositionAfterCursor = o != r, !o)
    return null;
  let s = t - o.offset;
  return { from: s, to: s + o.node.nodeValue.length, node: o.node };
}
function rrt(e, t, n) {
  let r = dY(e, n);
  if (!r)
    return null;
  let { node: i, from: o, to: s } = r, a = i.nodeValue;
  if (/[\n\r]/.test(a) || e.state.doc.sliceString(r.from, r.to) != a)
    return null;
  let u = t.invertedDesc, c = new _a(u.mapPos(o), u.mapPos(s), o, s), d = [];
  for (let f = i.parentNode; ; f = f.parentNode) {
    let h = Mr.get(f);
    if (h instanceof cc)
      d.push({ node: f, deco: h.mark });
    else {
      if (h instanceof Fi || f.nodeName == "DIV" && f.parentNode == e.contentDOM)
        return { range: c, text: i, marks: d, line: f };
      if (f != e.contentDOM)
        d.push({ node: f, deco: new yv({
          inclusive: !0,
          attributes: Wnt(f),
          tagName: f.tagName.toLowerCase()
        }) });
      else
        return null;
    }
  }
}
function irt(e, t) {
  return e.nodeType != 1 ? 0 : (t && e.childNodes[t - 1].contentEditable == "false" ? 1 : 0) | (t < e.childNodes.length && e.childNodes[t].contentEditable == "false" ? 2 : 0);
}
let ort = class {
  constructor() {
    this.changes = [];
  }
  compareRange(t, n) {
    sD(t, n, this.changes);
  }
  comparePoint(t, n) {
    sD(t, n, this.changes);
  }
  boundChange(t) {
    sD(t, t, this.changes);
  }
};
function srt(e, t, n) {
  let r = new ort();
  return ir.compare(e, t, n, r), r.changes;
}
function art(e, t) {
  for (let n = e; n && n != t; n = n.assignedSlot || n.parentNode)
    if (n.nodeType == 1 && n.contentEditable == "false")
      return !0;
  return !1;
}
function lrt(e, t) {
  let n = !1;
  return t && e.iterChangedRanges((r, i) => {
    r < t.to && i > t.from && (n = !0);
  }), n;
}
function urt(e, t, n = 1) {
  let r = e.charCategorizer(t), i = e.doc.lineAt(t), o = t - i.from;
  if (i.length == 0)
    return it.cursor(t);
  o == 0 ? n = 1 : o == i.length && (n = -1);
  let s = o, a = o;
  n < 0 ? s = go(i.text, o, !1) : a = go(i.text, o);
  let u = r(i.text.slice(s, a));
  for (; s > 0; ) {
    let c = go(i.text, s, !1);
    if (r(i.text.slice(c, s)) != u)
      break;
    s = c;
  }
  for (; a < i.length; ) {
    let c = go(i.text, a);
    if (r(i.text.slice(a, c)) != u)
      break;
    a = c;
  }
  return it.range(s + i.from, a + i.from);
}
function crt(e, t) {
  return t.left > e ? t.left - e : Math.max(0, e - t.right);
}
function drt(e, t) {
  return t.top > e ? t.top - e : Math.max(0, e - t.bottom);
}
function Aw(e, t) {
  return e.top < t.bottom - 1 && e.bottom > t.top + 1;
}
function z8(e, t) {
  return t < e.top ? { top: t, left: e.left, right: e.right, bottom: e.bottom } : e;
}
function U8(e, t) {
  return t > e.bottom ? { top: e.top, left: e.left, right: e.right, bottom: t } : e;
}
function jk(e, t, n) {
  let r, i, o, s, a = !1, u, c, d, f;
  for (let v = e.firstChild; v; v = v.nextSibling) {
    let x = Cm(v);
    for (let C = 0; C < x.length; C++) {
      let E = x[C];
      i && Aw(i, E) && (E = z8(U8(E, i.bottom), i.top));
      let S = crt(t, E), w = drt(n, E);
      if (S == 0 && w == 0)
        return v.nodeType == 3 ? W8(v, t, n) : jk(v, t, n);
      if (!r || s > w || s == w && o > S) {
        r = v, i = E, o = S, s = w;
        let O = w ? n < E.top ? -1 : 1 : S ? t < E.left ? -1 : 1 : 0;
        a = !O || (O > 0 ? C < x.length - 1 : C > 0);
      }
      S == 0 ? n > E.bottom && (!d || d.bottom < E.bottom) ? (u = v, d = E) : n < E.top && (!f || f.top > E.top) && (c = v, f = E) : d && Aw(d, E) ? d = U8(d, E.bottom) : f && Aw(f, E) && (f = z8(f, E.top));
    }
  }
  if (d && d.bottom >= n ? (r = u, i = d) : f && f.top <= n && (r = c, i = f), !r)
    return { node: e, offset: 0 };
  let h = Math.max(i.left, Math.min(i.right, t));
  if (r.nodeType == 3)
    return W8(r, h, n);
  if (a && r.contentEditable != "false")
    return jk(r, h, n);
  let m = Array.prototype.indexOf.call(e.childNodes, r) + (t >= (i.left + i.right) / 2 ? 1 : 0);
  return { node: e, offset: m };
}
function W8(e, t, n) {
  let r = e.nodeValue.length, i = -1, o = 1e9, s = 0;
  for (let a = 0; a < r; a++) {
    let u = ef(e, a, a + 1).getClientRects();
    for (let c = 0; c < u.length; c++) {
      let d = u[c];
      if (d.top == d.bottom)
        continue;
      s || (s = t - d.left);
      let f = (d.top > n ? d.top - n : n - d.bottom) - 1;
      if (d.left - 1 <= t && d.right + 1 >= t && f < o) {
        let h = t >= (d.left + d.right) / 2, m = h;
        if ((Vt.chrome || Vt.gecko) && ef(e, a).getBoundingClientRect().left == d.right && (m = !h), f <= 0)
          return { node: e, offset: a + (m ? 1 : 0) };
        i = a + (m ? 1 : 0), o = f;
      }
    }
  }
  return { node: e, offset: i > -1 ? i : s > 0 ? e.nodeValue.length : 0 };
}
function pY(e, t, n, r = -1) {
  var i, o;
  let s = e.contentDOM.getBoundingClientRect(), a = s.top + e.viewState.paddingTop, u, { docHeight: c } = e.viewState, { x: d, y: f } = t, h = f - a;
  if (h < 0)
    return 0;
  if (h > c)
    return e.state.doc.length;
  for (let O = e.viewState.heightOracle.textHeight / 2, A = !1; u = e.elementAtHeight(h), u.type != os.Text; )
    for (; h = r > 0 ? u.bottom + O : u.top - O, !(h >= 0 && h <= c); ) {
      if (A)
        return n ? null : 0;
      A = !0, r = -r;
    }
  f = a + h;
  let m = u.from;
  if (m < e.viewport.from)
    return e.viewport.from == 0 ? 0 : n ? null : H8(e, s, u, d, f);
  if (m > e.viewport.to)
    return e.viewport.to == e.state.doc.length ? e.state.doc.length : n ? null : H8(e, s, u, d, f);
  let v = e.dom.ownerDocument, x = e.root.elementFromPoint ? e.root : v, C = x.elementFromPoint(d, f);
  C && !e.contentDOM.contains(C) && (C = null), C || (d = Math.max(s.left + 1, Math.min(s.right - 1, d)), C = x.elementFromPoint(d, f), C && !e.contentDOM.contains(C) && (C = null));
  let E, S = -1;
  if (C && ((i = e.docView.nearest(C)) === null || i === void 0 ? void 0 : i.isEditable) != !1) {
    if (v.caretPositionFromPoint) {
      let O = v.caretPositionFromPoint(d, f);
      O && ({ offsetNode: E, offset: S } = O);
    } else if (v.caretRangeFromPoint) {
      let O = v.caretRangeFromPoint(d, f);
      O && ({ startContainer: E, startOffset: S } = O, (!e.contentDOM.contains(E) || Vt.safari && prt(E, S, d) || Vt.chrome && frt(E, S, d)) && (E = void 0));
    }
    E && (S = Math.min(xu(E), S));
  }
  if (!E || !e.docView.dom.contains(E)) {
    let O = Fi.find(e.docView, m);
    if (!O)
      return h > u.top + u.height / 2 ? u.to : u.from;
    ({ node: E, offset: S } = jk(O.dom, d, f));
  }
  let w = e.docView.nearest(E);
  if (!w)
    return null;
  if (w.isWidget && ((o = w.dom) === null || o === void 0 ? void 0 : o.nodeType) == 1) {
    let O = w.dom.getBoundingClientRect();
    return t.y < O.top || t.y <= O.bottom && t.x <= (O.left + O.right) / 2 ? w.posAtStart : w.posAtEnd;
  } else
    return w.localPosFromDOM(E, S) + w.posAtStart;
}
function H8(e, t, n, r, i) {
  let o = Math.round((r - t.left) * e.defaultCharacterWidth);
  if (e.lineWrapping && n.height > e.defaultLineHeight * 1.5) {
    let a = e.viewState.heightOracle.textHeight, u = Math.floor((i - n.top - (e.defaultLineHeight - a) * 0.5) / a);
    o += u * e.viewState.heightOracle.lineLength;
  }
  let s = e.state.sliceDoc(n.from, n.to);
  return n.from + Ak(s, o, e.state.tabSize);
}
function prt(e, t, n) {
  let r;
  if (e.nodeType != 3 || t != (r = e.nodeValue.length))
    return !1;
  for (let i = e.nextSibling; i; i = i.nextSibling)
    if (i.nodeType != 1 || i.nodeName != "BR")
      return !1;
  return ef(e, r - 1, r).getBoundingClientRect().left > n;
}
function frt(e, t, n) {
  if (t != 0)
    return !1;
  for (let i = e; ; ) {
    let o = i.parentNode;
    if (!o || o.nodeType != 1 || o.firstChild != i)
      return !1;
    if (o.classList.contains("cm-line"))
      break;
    i = o;
  }
  let r = e.nodeType == 1 ? e.getBoundingClientRect() : ef(e, 0, Math.max(e.nodeValue.length, 1)).getBoundingClientRect();
  return n - r.left > 5;
}
function Vk(e, t) {
  let n = e.lineBlockAt(t);
  if (Array.isArray(n.type)) {
    for (let r of n.type)
      if (r.to > t || r.to == t && (r.to == n.to || r.type == os.Text))
        return r;
  }
  return n;
}
function hrt(e, t, n, r) {
  let i = Vk(e, t.head), o = !r || i.type != os.Text || !(e.lineWrapping || i.widgetLineBreaks) ? null : e.coordsAtPos(t.assoc < 0 && t.head > i.from ? t.head - 1 : t.head);
  if (o) {
    let s = e.dom.getBoundingClientRect(), a = e.textDirectionAt(i.from), u = e.posAtCoords({
      x: n == (a == Jr.LTR) ? s.right - 1 : s.left + 1,
      y: (o.top + o.bottom) / 2
    });
    if (u != null)
      return it.cursor(u, n ? -1 : 1);
  }
  return it.cursor(n ? i.to : i.from, n ? -1 : 1);
}
function q8(e, t, n, r) {
  let i = e.state.doc.lineAt(t.head), o = e.bidiSpans(i), s = e.textDirectionAt(i.from);
  for (let a = t, u = null; ; ) {
    let c = Znt(i, o, s, a, n), d = JG;
    if (!c) {
      if (i.number == (n ? e.state.doc.lines : 1))
        return a;
      d = `
`, i = e.state.doc.line(i.number + (n ? 1 : -1)), o = e.bidiSpans(i), c = e.visualLineSide(i, !n);
    }
    if (u) {
      if (!u(d))
        return a;
    } else {
      if (!r)
        return c;
      u = r(d);
    }
    a = c;
  }
}
function mrt(e, t, n) {
  let r = e.state.charCategorizer(t), i = r(n);
  return (o) => {
    let s = r(o);
    return i == Qr.Space && (i = s), i == s;
  };
}
function grt(e, t, n, r) {
  let i = t.head, o = n ? 1 : -1;
  if (i == (n ? e.state.doc.length : 0))
    return it.cursor(i, t.assoc);
  let s = t.goalColumn, a, u = e.contentDOM.getBoundingClientRect(), c = e.coordsAtPos(i, t.assoc || -1), d = e.documentTop;
  if (c)
    s == null && (s = c.left - u.left), a = o < 0 ? c.top : c.bottom;
  else {
    let m = e.viewState.lineBlockAt(i);
    s == null && (s = Math.min(u.right - u.left, e.defaultCharacterWidth * (i - m.from))), a = (o < 0 ? m.top : m.bottom) + d;
  }
  let f = u.left + s, h = r ?? e.viewState.heightOracle.textHeight >> 1;
  for (let m = 0; ; m += 10) {
    let v = a + (h + m) * o, x = pY(e, { x: f, y: v }, !1, o);
    if (v < u.top || v > u.bottom || (o < 0 ? x < i : x > i)) {
      let C = e.docView.coordsForChar(x), E = !C || v < C.top ? -1 : 1;
      return it.cursor(x, E, void 0, s);
    }
  }
}
function aD(e, t, n) {
  for (; ; ) {
    let r = 0;
    for (let i of e)
      i.between(t - 1, t + 1, (o, s, a) => {
        if (t > o && t < s) {
          let u = r || n || (t - o < s - t ? -1 : 1);
          t = u < 0 ? o : s, r = u;
        }
      });
    if (!r)
      return t;
  }
}
function ww(e, t, n) {
  let r = aD(e.state.facet(z$).map((i) => i(e)), n.from, t.head > n.from ? -1 : 1);
  return r == n.from ? n : it.cursor(r, r < n.from ? 1 : -1);
}
const Jy = "￿";
class yrt {
  constructor(t, n) {
    this.points = t, this.text = "", this.lineSeparator = n.facet(Jn.lineSeparator);
  }
  append(t) {
    this.text += t;
  }
  lineBreak() {
    this.text += Jy;
  }
  readRange(t, n) {
    if (!t)
      return this;
    let r = t.parentNode;
    for (let i = t; ; ) {
      this.findPointBefore(r, i);
      let o = this.text.length;
      this.readNode(i);
      let s = i.nextSibling;
      if (s == n)
        break;
      let a = Mr.get(i), u = Mr.get(s);
      (a && u ? a.breakAfter : (a ? a.breakAfter : sC(i)) || sC(s) && (i.nodeName != "BR" || i.cmIgnore) && this.text.length > o) && this.lineBreak(), i = s;
    }
    return this.findPointBefore(r, n), this;
  }
  readTextNode(t) {
    let n = t.nodeValue;
    for (let r of this.points)
      r.node == t && (r.pos = this.text.length + Math.min(r.offset, n.length));
    for (let r = 0, i = this.lineSeparator ? null : /\r\n?|\n/g; ; ) {
      let o = -1, s = 1, a;
      if (this.lineSeparator ? (o = n.indexOf(this.lineSeparator, r), s = this.lineSeparator.length) : (a = i.exec(n)) && (o = a.index, s = a[0].length), this.append(n.slice(r, o < 0 ? n.length : o)), o < 0)
        break;
      if (this.lineBreak(), s > 1)
        for (let u of this.points)
          u.node == t && u.pos > this.text.length && (u.pos -= s - 1);
      r = o + s;
    }
  }
  readNode(t) {
    if (t.cmIgnore)
      return;
    let n = Mr.get(t), r = n && n.overrideDOMText;
    if (r != null) {
      this.findPointInside(t, r.length);
      for (let i = r.iter(); !i.next().done; )
        i.lineBreak ? this.lineBreak() : this.append(i.value);
    } else t.nodeType == 3 ? this.readTextNode(t) : t.nodeName == "BR" ? t.nextSibling && this.lineBreak() : t.nodeType == 1 && this.readRange(t.firstChild, null);
  }
  findPointBefore(t, n) {
    for (let r of this.points)
      r.node == t && t.childNodes[r.offset] == n && (r.pos = this.text.length);
  }
  findPointInside(t, n) {
    for (let r of this.points)
      (t.nodeType == 3 ? r.node == t : t.contains(r.node)) && (r.pos = this.text.length + (brt(t, r.node, r.offset) ? n : 0));
  }
}
function brt(e, t, n) {
  for (; ; ) {
    if (!t || n < xu(t))
      return !1;
    if (t == e)
      return !0;
    n = Zp(t) + 1, t = t.parentNode;
  }
}
class G8 {
  constructor(t, n) {
    this.node = t, this.offset = n, this.pos = -1;
  }
}
class vrt {
  constructor(t, n, r, i) {
    this.typeOver = i, this.bounds = null, this.text = "", this.domChanged = n > -1;
    let { impreciseHead: o, impreciseAnchor: s } = t.docView;
    if (t.state.readOnly && n > -1)
      this.newSel = null;
    else if (n > -1 && (this.bounds = t.docView.domBoundsAround(n, r, 0))) {
      let a = o || s ? [] : Crt(t), u = new yrt(a, t.state);
      u.readRange(this.bounds.startDOM, this.bounds.endDOM), this.text = u.text, this.newSel = Ert(a, this.bounds.from);
    } else {
      let a = t.observer.selectionRange, u = o && o.node == a.focusNode && o.offset == a.focusOffset || !kk(t.contentDOM, a.focusNode) ? t.state.selection.main.head : t.docView.posFromDOM(a.focusNode, a.focusOffset), c = s && s.node == a.anchorNode && s.offset == a.anchorOffset || !kk(t.contentDOM, a.anchorNode) ? t.state.selection.main.anchor : t.docView.posFromDOM(a.anchorNode, a.anchorOffset), d = t.viewport;
      if ((Vt.ios || Vt.chrome) && t.state.selection.main.empty && u != c && (d.from > 0 || d.to < t.state.doc.length)) {
        let f = Math.min(u, c), h = Math.max(u, c), m = d.from - f, v = d.to - h;
        (m == 0 || m == 1 || f == 0) && (v == 0 || v == -1 || h == t.state.doc.length) && (u = 0, c = t.state.doc.length);
      }
      this.newSel = it.single(c, u);
    }
  }
}
function fY(e, t) {
  let n, { newSel: r } = t, i = e.state.selection.main, o = e.inputState.lastKeyTime > Date.now() - 100 ? e.inputState.lastKeyCode : -1;
  if (t.bounds) {
    let { from: s, to: a } = t.bounds, u = i.from, c = null;
    (o === 8 || Vt.android && t.text.length < a - s) && (u = i.to, c = "end");
    let d = Drt(e.state.doc.sliceString(s, a, Jy), t.text, u - s, c);
    d && (Vt.chrome && o == 13 && d.toB == d.from + 2 && t.text.slice(d.from, d.toB) == Jy + Jy && d.toB--, n = {
      from: s + d.from,
      to: s + d.toA,
      insert: cr.of(t.text.slice(d.from, d.toB).split(Jy))
    });
  } else r && (!e.hasFocus && e.state.facet(ec) || r.main.eq(i)) && (r = null);
  if (!n && !r)
    return !1;
  if (!n && t.typeOver && !i.empty && r && r.main.empty ? n = { from: i.from, to: i.to, insert: e.state.doc.slice(i.from, i.to) } : n && n.from >= i.from && n.to <= i.to && (n.from != i.from || n.to != i.to) && i.to - i.from - (n.to - n.from) <= 4 ? n = {
    from: i.from,
    to: i.to,
    insert: e.state.doc.slice(i.from, n.from).append(n.insert).append(e.state.doc.slice(n.to, i.to))
  } : (Vt.mac || Vt.android) && n && n.from == n.to && n.from == i.head - 1 && /^\. ?$/.test(n.insert.toString()) && e.contentDOM.getAttribute("autocorrect") == "off" ? (r && n.insert.length == 2 && (r = it.single(r.main.anchor - 1, r.main.head - 1)), n = { from: i.from, to: i.to, insert: cr.of([" "]) }) : Vt.chrome && n && n.from == n.to && n.from == i.head && n.insert.toString() == `
 ` && e.lineWrapping && (r && (r = it.single(r.main.anchor - 1, r.main.head - 1)), n = { from: i.from, to: i.to, insert: cr.of([" "]) }), n)
    return W$(e, n, r, o);
  if (r && !r.main.eq(i)) {
    let s = !1, a = "select";
    return e.inputState.lastSelectionTime > Date.now() - 50 && (e.inputState.lastSelectionOrigin == "select" && (s = !0), a = e.inputState.lastSelectionOrigin), e.dispatch({ selection: r, scrollIntoView: s, userEvent: a }), !0;
  } else
    return !1;
}
function W$(e, t, n, r = -1) {
  if (Vt.ios && e.inputState.flushIOSKey(t))
    return !0;
  let i = e.state.selection.main;
  if (Vt.android && (t.to == i.to && // GBoard will sometimes remove a space it just inserted
  // after a completion when you press enter
  (t.from == i.from || t.from == i.from - 1 && e.state.sliceDoc(t.from, i.from) == " ") && t.insert.length == 1 && t.insert.lines == 2 && em(e.contentDOM, "Enter", 13) || (t.from == i.from - 1 && t.to == i.to && t.insert.length == 0 || r == 8 && t.insert.length < t.to - t.from && t.to > i.head) && em(e.contentDOM, "Backspace", 8) || t.from == i.from && t.to == i.to + 1 && t.insert.length == 0 && em(e.contentDOM, "Delete", 46)))
    return !0;
  let o = t.insert.toString();
  e.inputState.composing >= 0 && e.inputState.composing++;
  let s, a = () => s || (s = xrt(e, t, n));
  return e.state.facet(tY).some((u) => u(e, t.from, t.to, o, a)) || e.dispatch(a()), !0;
}
function xrt(e, t, n) {
  let r, i = e.state, o = i.selection.main;
  if (t.from >= o.from && t.to <= o.to && t.to - t.from >= (o.to - o.from) / 3 && (!n || n.main.empty && n.main.from == t.from + t.insert.length) && e.inputState.composing < 0) {
    let a = o.from < t.from ? i.sliceDoc(o.from, t.from) : "", u = o.to > t.to ? i.sliceDoc(t.to, o.to) : "";
    r = i.replaceSelection(e.state.toText(a + t.insert.sliceString(0, void 0, e.state.lineBreak) + u));
  } else {
    let a = i.changes(t), u = n && n.main.to <= a.newLength ? n.main : void 0;
    if (i.selection.ranges.length > 1 && e.inputState.composing >= 0 && t.to <= o.to && t.to >= o.to - 10) {
      let c = e.state.sliceDoc(t.from, t.to), d, f = n && dY(e, n.main.head);
      if (f) {
        let v = t.insert.length - (t.to - t.from);
        d = { from: f.from, to: f.to - v };
      } else
        d = e.state.doc.lineAt(o.head);
      let h = o.to - t.to, m = o.to - o.from;
      r = i.changeByRange((v) => {
        if (v.from == o.from && v.to == o.to)
          return { changes: a, range: u || v.map(a) };
        let x = v.to - h, C = x - c.length;
        if (v.to - v.from != m || e.state.sliceDoc(C, x) != c || // Unfortunately, there's no way to make multiple
        // changes in the same node work without aborting
        // composition, so cursors in the composition range are
        // ignored.
        v.to >= d.from && v.from <= d.to)
          return { range: v };
        let E = i.changes({ from: C, to: x, insert: t.insert }), S = v.to - o.to;
        return {
          changes: E,
          range: u ? it.range(Math.max(0, u.anchor + S), Math.max(0, u.head + S)) : v.map(E)
        };
      });
    } else
      r = {
        changes: a,
        selection: u && i.selection.replaceRange(u)
      };
  }
  let s = "input.type";
  return (e.composing || e.inputState.compositionPendingChange && e.inputState.compositionEndedAt > Date.now() - 50) && (e.inputState.compositionPendingChange = !1, s += ".compose", e.inputState.compositionFirstChange && (s += ".start", e.inputState.compositionFirstChange = !1)), i.update(r, { userEvent: s, scrollIntoView: !0 });
}
function Drt(e, t, n, r) {
  let i = Math.min(e.length, t.length), o = 0;
  for (; o < i && e.charCodeAt(o) == t.charCodeAt(o); )
    o++;
  if (o == i && e.length == t.length)
    return null;
  let s = e.length, a = t.length;
  for (; s > 0 && a > 0 && e.charCodeAt(s - 1) == t.charCodeAt(a - 1); )
    s--, a--;
  if (r == "end") {
    let u = Math.max(0, o - Math.min(s, a));
    n -= s + u - o;
  }
  if (s < o && e.length < t.length) {
    let u = n <= o && n >= s ? o - n : 0;
    o -= u, a = o + (a - s), s = o;
  } else if (a < o) {
    let u = n <= o && n >= a ? o - n : 0;
    o -= u, s = o + (s - a), a = o;
  }
  return { from: o, toA: s, toB: a };
}
function Crt(e) {
  let t = [];
  if (e.root.activeElement != e.contentDOM)
    return t;
  let { anchorNode: n, anchorOffset: r, focusNode: i, focusOffset: o } = e.observer.selectionRange;
  return n && (t.push(new G8(n, r)), (i != n || o != r) && t.push(new G8(i, o))), t;
}
function Ert(e, t) {
  if (e.length == 0)
    return null;
  let n = e[0].pos, r = e.length == 2 ? e[1].pos : n;
  return n > -1 && r > -1 ? it.single(n + t, r + t) : null;
}
class Trt {
  setSelectionOrigin(t) {
    this.lastSelectionOrigin = t, this.lastSelectionTime = Date.now();
  }
  constructor(t) {
    this.view = t, this.lastKeyCode = 0, this.lastKeyTime = 0, this.lastTouchTime = 0, this.lastFocusTime = 0, this.lastScrollTop = 0, this.lastScrollLeft = 0, this.pendingIOSKey = void 0, this.tabFocusMode = -1, this.lastSelectionOrigin = null, this.lastSelectionTime = 0, this.lastContextMenu = 0, this.scrollHandlers = [], this.handlers = /* @__PURE__ */ Object.create(null), this.composing = -1, this.compositionFirstChange = null, this.compositionEndedAt = 0, this.compositionPendingKey = !1, this.compositionPendingChange = !1, this.mouseSelection = null, this.draggedContent = null, this.handleEvent = this.handleEvent.bind(this), this.notifiedFocused = t.hasFocus, Vt.safari && t.contentDOM.addEventListener("input", () => null), Vt.gecko && jrt(t.contentDOM.ownerDocument);
  }
  handleEvent(t) {
    !Frt(this.view, t) || this.ignoreDuringComposition(t) || t.type == "keydown" && this.keydown(t) || this.runHandlers(t.type, t);
  }
  runHandlers(t, n) {
    let r = this.handlers[t];
    if (r) {
      for (let i of r.observers)
        i(this.view, n);
      for (let i of r.handlers) {
        if (n.defaultPrevented)
          break;
        if (i(this.view, n)) {
          n.preventDefault();
          break;
        }
      }
    }
  }
  ensureHandlers(t) {
    let n = Srt(t), r = this.handlers, i = this.view.contentDOM;
    for (let o in n)
      if (o != "scroll") {
        let s = !n[o].handlers.length, a = r[o];
        a && s != !a.handlers.length && (i.removeEventListener(o, this.handleEvent), a = null), a || i.addEventListener(o, this.handleEvent, { passive: s });
      }
    for (let o in r)
      o != "scroll" && !n[o] && i.removeEventListener(o, this.handleEvent);
    this.handlers = n;
  }
  keydown(t) {
    if (this.lastKeyCode = t.keyCode, this.lastKeyTime = Date.now(), t.keyCode == 9 && this.tabFocusMode > -1 && (!this.tabFocusMode || Date.now() <= this.tabFocusMode))
      return !0;
    if (this.tabFocusMode > 0 && t.keyCode != 27 && mY.indexOf(t.keyCode) < 0 && (this.tabFocusMode = -1), Vt.android && Vt.chrome && !t.synthetic && (t.keyCode == 13 || t.keyCode == 8))
      return this.view.observer.delayAndroidKey(t.key, t.keyCode), !0;
    let n;
    return Vt.ios && !t.synthetic && !t.altKey && !t.metaKey && ((n = hY.find((r) => r.keyCode == t.keyCode)) && !t.ctrlKey || Art.indexOf(t.key) > -1 && t.ctrlKey && !t.shiftKey) ? (this.pendingIOSKey = n || t, setTimeout(() => this.flushIOSKey(), 250), !0) : (t.keyCode != 229 && this.view.observer.forceFlush(), !1);
  }
  flushIOSKey(t) {
    let n = this.pendingIOSKey;
    return !n || n.key == "Enter" && t && t.from < t.to && /^\S+$/.test(t.insert.toString()) ? !1 : (this.pendingIOSKey = void 0, em(this.view.contentDOM, n.key, n.keyCode, n instanceof KeyboardEvent ? n : void 0));
  }
  ignoreDuringComposition(t) {
    return /^key/.test(t.type) ? this.composing > 0 ? !0 : Vt.safari && !Vt.ios && this.compositionPendingKey && Date.now() - this.compositionEndedAt < 100 ? (this.compositionPendingKey = !1, !0) : !1 : !1;
  }
  startMouseSelection(t) {
    this.mouseSelection && this.mouseSelection.destroy(), this.mouseSelection = t;
  }
  update(t) {
    this.view.observer.update(t), this.mouseSelection && this.mouseSelection.update(t), this.draggedContent && t.docChanged && (this.draggedContent = this.draggedContent.map(t.changes)), t.transactions.length && (this.lastKeyCode = this.lastSelectionTime = 0);
  }
  destroy() {
    this.mouseSelection && this.mouseSelection.destroy();
  }
}
function Y8(e, t) {
  return (n, r) => {
    try {
      return t.call(e, r, n);
    } catch (i) {
      Ts(n.state, i);
    }
  };
}
function Srt(e) {
  let t = /* @__PURE__ */ Object.create(null);
  function n(r) {
    return t[r] || (t[r] = { observers: [], handlers: [] });
  }
  for (let r of e) {
    let i = r.spec;
    if (i && i.domEventHandlers)
      for (let o in i.domEventHandlers) {
        let s = i.domEventHandlers[o];
        s && n(o).handlers.push(Y8(r.value, s));
      }
    if (i && i.domEventObservers)
      for (let o in i.domEventObservers) {
        let s = i.domEventObservers[o];
        s && n(o).observers.push(Y8(r.value, s));
      }
  }
  for (let r in Dl)
    n(r).handlers.push(Dl[r]);
  for (let r in Wa)
    n(r).observers.push(Wa[r]);
  return t;
}
const hY = [
  { key: "Backspace", keyCode: 8, inputType: "deleteContentBackward" },
  { key: "Enter", keyCode: 13, inputType: "insertParagraph" },
  { key: "Enter", keyCode: 13, inputType: "insertLineBreak" },
  { key: "Delete", keyCode: 46, inputType: "deleteContentForward" }
], Art = "dthko", mY = [16, 17, 18, 20, 91, 92, 224, 225], ax = 6;
function lx(e) {
  return Math.max(0, e) * 0.7 + 8;
}
function wrt(e, t) {
  return Math.max(Math.abs(e.clientX - t.clientX), Math.abs(e.clientY - t.clientY));
}
class Prt {
  constructor(t, n, r, i) {
    this.view = t, this.startEvent = n, this.style = r, this.mustSelect = i, this.scrollSpeed = { x: 0, y: 0 }, this.scrolling = -1, this.lastEvent = n, this.scrollParents = _nt(t.contentDOM), this.atoms = t.state.facet(z$).map((s) => s(t));
    let o = t.contentDOM.ownerDocument;
    o.addEventListener("mousemove", this.move = this.move.bind(this)), o.addEventListener("mouseup", this.up = this.up.bind(this)), this.extend = n.shiftKey, this.multiple = t.state.facet(Jn.allowMultipleSelections) && krt(t, n), this.dragging = Irt(t, n) && bY(n) == 1 ? null : !1;
  }
  start(t) {
    this.dragging === !1 && this.select(t);
  }
  move(t) {
    if (t.buttons == 0)
      return this.destroy();
    if (this.dragging || this.dragging == null && wrt(this.startEvent, t) < 10)
      return;
    this.select(this.lastEvent = t);
    let n = 0, r = 0, i = 0, o = 0, s = this.view.win.innerWidth, a = this.view.win.innerHeight;
    this.scrollParents.x && ({ left: i, right: s } = this.scrollParents.x.getBoundingClientRect()), this.scrollParents.y && ({ top: o, bottom: a } = this.scrollParents.y.getBoundingClientRect());
    let u = U$(this.view);
    t.clientX - u.left <= i + ax ? n = -lx(i - t.clientX) : t.clientX + u.right >= s - ax && (n = lx(t.clientX - s)), t.clientY - u.top <= o + ax ? r = -lx(o - t.clientY) : t.clientY + u.bottom >= a - ax && (r = lx(t.clientY - a)), this.setScrollSpeed(n, r);
  }
  up(t) {
    this.dragging == null && this.select(this.lastEvent), this.dragging || t.preventDefault(), this.destroy();
  }
  destroy() {
    this.setScrollSpeed(0, 0);
    let t = this.view.contentDOM.ownerDocument;
    t.removeEventListener("mousemove", this.move), t.removeEventListener("mouseup", this.up), this.view.inputState.mouseSelection = this.view.inputState.draggedContent = null;
  }
  setScrollSpeed(t, n) {
    this.scrollSpeed = { x: t, y: n }, t || n ? this.scrolling < 0 && (this.scrolling = setInterval(() => this.scroll(), 50)) : this.scrolling > -1 && (clearInterval(this.scrolling), this.scrolling = -1);
  }
  scroll() {
    let { x: t, y: n } = this.scrollSpeed;
    t && this.scrollParents.x && (this.scrollParents.x.scrollLeft += t, t = 0), n && this.scrollParents.y && (this.scrollParents.y.scrollTop += n, n = 0), (t || n) && this.view.win.scrollBy(t, n), this.dragging === !1 && this.select(this.lastEvent);
  }
  skipAtoms(t) {
    let n = null;
    for (let r = 0; r < t.ranges.length; r++) {
      let i = t.ranges[r], o = null;
      if (i.empty) {
        let s = aD(this.atoms, i.from, 0);
        s != i.from && (o = it.cursor(s, -1));
      } else {
        let s = aD(this.atoms, i.from, -1), a = aD(this.atoms, i.to, 1);
        (s != i.from || a != i.to) && (o = it.range(i.from == i.anchor ? s : a, i.from == i.head ? s : a));
      }
      o && (n || (n = t.ranges.slice()), n[r] = o);
    }
    return n ? it.create(n, t.mainIndex) : t;
  }
  select(t) {
    let { view: n } = this, r = this.skipAtoms(this.style.get(t, this.extend, this.multiple));
    (this.mustSelect || !r.eq(n.state.selection, this.dragging === !1)) && this.view.dispatch({
      selection: r,
      userEvent: "select.pointer"
    }), this.mustSelect = !1;
  }
  update(t) {
    t.transactions.some((n) => n.isUserEvent("input.type")) ? this.destroy() : this.style.update(t) && setTimeout(() => this.select(this.lastEvent), 20);
  }
}
function krt(e, t) {
  let n = e.state.facet(XG);
  return n.length ? n[0](t) : Vt.mac ? t.metaKey : t.ctrlKey;
}
function Ort(e, t) {
  let n = e.state.facet(QG);
  return n.length ? n[0](t) : Vt.mac ? !t.altKey : !t.ctrlKey;
}
function Irt(e, t) {
  let { main: n } = e.state.selection;
  if (n.empty)
    return !1;
  let r = tb(e.root);
  if (!r || r.rangeCount == 0)
    return !0;
  let i = r.getRangeAt(0).getClientRects();
  for (let o = 0; o < i.length; o++) {
    let s = i[o];
    if (s.left <= t.clientX && s.right >= t.clientX && s.top <= t.clientY && s.bottom >= t.clientY)
      return !0;
  }
  return !1;
}
function Frt(e, t) {
  if (!t.bubbles)
    return !0;
  if (t.defaultPrevented)
    return !1;
  for (let n = t.target, r; n != e.contentDOM; n = n.parentNode)
    if (!n || n.nodeType == 11 || (r = Mr.get(n)) && r.ignoreEvent(t))
      return !1;
  return !0;
}
const Dl = /* @__PURE__ */ Object.create(null), Wa = /* @__PURE__ */ Object.create(null), gY = Vt.ie && Vt.ie_version < 15 || Vt.ios && Vt.webkit_version < 604;
function $rt(e) {
  let t = e.dom.parentNode;
  if (!t)
    return;
  let n = t.appendChild(document.createElement("textarea"));
  n.style.cssText = "position: fixed; left: -10000px; top: 10px", n.focus(), setTimeout(() => {
    e.focus(), n.remove(), yY(e, n.value);
  }, 50);
}
function aT(e, t, n) {
  for (let r of e.facet(t))
    n = r(n, e);
  return n;
}
function yY(e, t) {
  t = aT(e.state, B$, t);
  let { state: n } = e, r, i = 1, o = n.toText(t), s = o.lines == n.selection.ranges.length;
  if (zk != null && n.selection.ranges.every((u) => u.empty) && zk == o.toString()) {
    let u = -1;
    r = n.changeByRange((c) => {
      let d = n.doc.lineAt(c.from);
      if (d.from == u)
        return { range: c };
      u = d.from;
      let f = n.toText((s ? o.line(i++).text : t) + n.lineBreak);
      return {
        changes: { from: d.from, insert: f },
        range: it.cursor(c.from + f.length)
      };
    });
  } else s ? r = n.changeByRange((u) => {
    let c = o.line(i++);
    return {
      changes: { from: u.from, to: u.to, insert: c.text },
      range: it.cursor(u.from + c.length)
    };
  }) : r = n.replaceSelection(o);
  e.dispatch(r, {
    userEvent: "input.paste",
    scrollIntoView: !0
  });
}
Wa.scroll = (e) => {
  e.inputState.lastScrollTop = e.scrollDOM.scrollTop, e.inputState.lastScrollLeft = e.scrollDOM.scrollLeft;
};
Dl.keydown = (e, t) => (e.inputState.setSelectionOrigin("select"), t.keyCode == 27 && e.inputState.tabFocusMode != 0 && (e.inputState.tabFocusMode = Date.now() + 2e3), !1);
Wa.touchstart = (e, t) => {
  e.inputState.lastTouchTime = Date.now(), e.inputState.setSelectionOrigin("select.pointer");
};
Wa.touchmove = (e) => {
  e.inputState.setSelectionOrigin("select.pointer");
};
Dl.mousedown = (e, t) => {
  if (e.observer.flush(), e.inputState.lastTouchTime > Date.now() - 2e3)
    return !1;
  let n = null;
  for (let r of e.state.facet(ZG))
    if (n = r(e, t), n)
      break;
  if (!n && t.button == 0 && (n = Rrt(e, t)), n) {
    let r = !e.hasFocus;
    e.inputState.startMouseSelection(new Prt(e, t, n, r)), r && e.observer.ignore(() => {
      FG(e.contentDOM);
      let o = e.root.activeElement;
      o && !o.contains(e.contentDOM) && o.blur();
    });
    let i = e.inputState.mouseSelection;
    if (i)
      return i.start(t), i.dragging === !1;
  }
  return !1;
};
function K8(e, t, n, r) {
  if (r == 1)
    return it.cursor(t, n);
  if (r == 2)
    return urt(e.state, t, n);
  {
    let i = Fi.find(e.docView, t), o = e.state.doc.lineAt(i ? i.posAtEnd : t), s = i ? i.posAtStart : o.from, a = i ? i.posAtEnd : o.to;
    return a < e.state.doc.length && a == o.to && a++, it.range(s, a);
  }
}
let J8 = (e, t, n) => t >= n.top && t <= n.bottom && e >= n.left && e <= n.right;
function Nrt(e, t, n, r) {
  let i = Fi.find(e.docView, t);
  if (!i)
    return 1;
  let o = t - i.posAtStart;
  if (o == 0)
    return 1;
  if (o == i.length)
    return -1;
  let s = i.coordsAt(o, -1);
  if (s && J8(n, r, s))
    return -1;
  let a = i.coordsAt(o, 1);
  return a && J8(n, r, a) ? 1 : s && s.bottom >= r ? -1 : 1;
}
function X8(e, t) {
  let n = e.posAtCoords({ x: t.clientX, y: t.clientY }, !1);
  return { pos: n, bias: Nrt(e, n, t.clientX, t.clientY) };
}
const Mrt = Vt.ie && Vt.ie_version <= 11;
let Q8 = null, Z8 = 0, e5 = 0;
function bY(e) {
  if (!Mrt)
    return e.detail;
  let t = Q8, n = e5;
  return Q8 = e, e5 = Date.now(), Z8 = !t || n > Date.now() - 400 && Math.abs(t.clientX - e.clientX) < 2 && Math.abs(t.clientY - e.clientY) < 2 ? (Z8 + 1) % 3 : 1;
}
function Rrt(e, t) {
  let n = X8(e, t), r = bY(t), i = e.state.selection;
  return {
    update(o) {
      o.docChanged && (n.pos = o.changes.mapPos(n.pos), i = i.map(o.changes));
    },
    get(o, s, a) {
      let u = X8(e, o), c, d = K8(e, u.pos, u.bias, r);
      if (n.pos != u.pos && !s) {
        let f = K8(e, n.pos, n.bias, r), h = Math.min(f.from, d.from), m = Math.max(f.to, d.to);
        d = h < d.from ? it.range(h, m) : it.range(m, h);
      }
      return s ? i.replaceRange(i.main.extend(d.from, d.to)) : a && r == 1 && i.ranges.length > 1 && (c = _rt(i, u.pos)) ? c : a ? i.addRange(d) : it.create([d]);
    }
  };
}
function _rt(e, t) {
  for (let n = 0; n < e.ranges.length; n++) {
    let { from: r, to: i } = e.ranges[n];
    if (r <= t && i >= t)
      return it.create(e.ranges.slice(0, n).concat(e.ranges.slice(n + 1)), e.mainIndex == n ? 0 : e.mainIndex - (e.mainIndex > n ? 1 : 0));
  }
  return null;
}
Dl.dragstart = (e, t) => {
  let { selection: { main: n } } = e.state;
  if (t.target.draggable) {
    let i = e.docView.nearest(t.target);
    if (i && i.isWidget) {
      let o = i.posAtStart, s = o + i.length;
      (o >= n.to || s <= n.from) && (n = it.range(o, s));
    }
  }
  let { inputState: r } = e;
  return r.mouseSelection && (r.mouseSelection.dragging = !0), r.draggedContent = n, t.dataTransfer && (t.dataTransfer.setData("Text", aT(e.state, j$, e.state.sliceDoc(n.from, n.to))), t.dataTransfer.effectAllowed = "copyMove"), !1;
};
Dl.dragend = (e) => (e.inputState.draggedContent = null, !1);
function t5(e, t, n, r) {
  if (n = aT(e.state, B$, n), !n)
    return;
  let i = e.posAtCoords({ x: t.clientX, y: t.clientY }, !1), { draggedContent: o } = e.inputState, s = r && o && Ort(e, t) ? { from: o.from, to: o.to } : null, a = { from: i, insert: n }, u = e.state.changes(s ? [s, a] : a);
  e.focus(), e.dispatch({
    changes: u,
    selection: { anchor: u.mapPos(i, -1), head: u.mapPos(i, 1) },
    userEvent: s ? "move.drop" : "input.drop"
  }), e.inputState.draggedContent = null;
}
Dl.drop = (e, t) => {
  if (!t.dataTransfer)
    return !1;
  if (e.state.readOnly)
    return !0;
  let n = t.dataTransfer.files;
  if (n && n.length) {
    let r = Array(n.length), i = 0, o = () => {
      ++i == n.length && t5(e, t, r.filter((s) => s != null).join(e.state.lineBreak), !1);
    };
    for (let s = 0; s < n.length; s++) {
      let a = new FileReader();
      a.onerror = o, a.onload = () => {
        /[\x00-\x08\x0e-\x1f]{2}/.test(a.result) || (r[s] = a.result), o();
      }, a.readAsText(n[s]);
    }
    return !0;
  } else {
    let r = t.dataTransfer.getData("Text");
    if (r)
      return t5(e, t, r, !0), !0;
  }
  return !1;
};
Dl.paste = (e, t) => {
  if (e.state.readOnly)
    return !0;
  e.observer.flush();
  let n = gY ? null : t.clipboardData;
  return n ? (yY(e, n.getData("text/plain") || n.getData("text/uri-list")), !0) : ($rt(e), !1);
};
function Lrt(e, t) {
  let n = e.dom.parentNode;
  if (!n)
    return;
  let r = n.appendChild(document.createElement("textarea"));
  r.style.cssText = "position: fixed; left: -10000px; top: 10px", r.value = t, r.focus(), r.selectionEnd = t.length, r.selectionStart = 0, setTimeout(() => {
    r.remove(), e.focus();
  }, 50);
}
function Brt(e) {
  let t = [], n = [], r = !1;
  for (let i of e.selection.ranges)
    i.empty || (t.push(e.sliceDoc(i.from, i.to)), n.push(i));
  if (!t.length) {
    let i = -1;
    for (let { from: o } of e.selection.ranges) {
      let s = e.doc.lineAt(o);
      s.number > i && (t.push(s.text), n.push({ from: s.from, to: Math.min(e.doc.length, s.to + 1) })), i = s.number;
    }
    r = !0;
  }
  return { text: aT(e, j$, t.join(e.lineBreak)), ranges: n, linewise: r };
}
let zk = null;
Dl.copy = Dl.cut = (e, t) => {
  let { text: n, ranges: r, linewise: i } = Brt(e.state);
  if (!n && !i)
    return !1;
  zk = i ? n : null, t.type == "cut" && !e.state.readOnly && e.dispatch({
    changes: r,
    scrollIntoView: !0,
    userEvent: "delete.cut"
  });
  let o = gY ? null : t.clipboardData;
  return o ? (o.clearData(), o.setData("text/plain", n), !0) : (Lrt(e, n), !1);
};
const vY = /* @__PURE__ */ Au.define();
function xY(e, t) {
  let n = [];
  for (let r of e.facet(nY)) {
    let i = r(e, t);
    i && n.push(i);
  }
  return n ? e.update({ effects: n, annotations: vY.of(!0) }) : null;
}
function DY(e) {
  setTimeout(() => {
    let t = e.hasFocus;
    if (t != e.inputState.notifiedFocused) {
      let n = xY(e.state, t);
      n ? e.dispatch(n) : e.update([]);
    }
  }, 10);
}
Wa.focus = (e) => {
  e.inputState.lastFocusTime = Date.now(), !e.scrollDOM.scrollTop && (e.inputState.lastScrollTop || e.inputState.lastScrollLeft) && (e.scrollDOM.scrollTop = e.inputState.lastScrollTop, e.scrollDOM.scrollLeft = e.inputState.lastScrollLeft), DY(e);
};
Wa.blur = (e) => {
  e.observer.clearSelectionRange(), DY(e);
};
Wa.compositionstart = Wa.compositionupdate = (e) => {
  e.observer.editContext || (e.inputState.compositionFirstChange == null && (e.inputState.compositionFirstChange = !0), e.inputState.composing < 0 && (e.inputState.composing = 0));
};
Wa.compositionend = (e) => {
  e.observer.editContext || (e.inputState.composing = -1, e.inputState.compositionEndedAt = Date.now(), e.inputState.compositionPendingKey = !0, e.inputState.compositionPendingChange = e.observer.pendingRecords().length > 0, e.inputState.compositionFirstChange = null, Vt.chrome && Vt.android ? e.observer.flushSoon() : e.inputState.compositionPendingChange ? Promise.resolve().then(() => e.observer.flush()) : setTimeout(() => {
    e.inputState.composing < 0 && e.docView.hasComposition && e.update([]);
  }, 50));
};
Wa.contextmenu = (e) => {
  e.inputState.lastContextMenu = Date.now();
};
Dl.beforeinput = (e, t) => {
  var n, r;
  if (t.inputType == "insertReplacementText" && e.observer.editContext) {
    let o = (n = t.dataTransfer) === null || n === void 0 ? void 0 : n.getData("text/plain"), s = t.getTargetRanges();
    if (o && s.length) {
      let a = s[0], u = e.posAtDOM(a.startContainer, a.startOffset), c = e.posAtDOM(a.endContainer, a.endOffset);
      return W$(e, { from: u, to: c, insert: e.state.toText(o) }, null), !0;
    }
  }
  let i;
  if (Vt.chrome && Vt.android && (i = hY.find((o) => o.inputType == t.inputType)) && (e.observer.delayAndroidKey(i.key, i.keyCode), i.key == "Backspace" || i.key == "Delete")) {
    let o = ((r = window.visualViewport) === null || r === void 0 ? void 0 : r.height) || 0;
    setTimeout(() => {
      var s;
      (((s = window.visualViewport) === null || s === void 0 ? void 0 : s.height) || 0) > o + 10 && e.hasFocus && (e.contentDOM.blur(), e.focus());
    }, 100);
  }
  return Vt.ios && t.inputType == "deleteContentForward" && e.observer.flushSoon(), Vt.safari && t.inputType == "insertText" && e.inputState.composing >= 0 && setTimeout(() => Wa.compositionend(e, t), 20), !1;
};
const n5 = /* @__PURE__ */ new Set();
function jrt(e) {
  n5.has(e) || (n5.add(e), e.addEventListener("copy", () => {
  }), e.addEventListener("cut", () => {
  }));
}
const r5 = ["pre-wrap", "normal", "pre-line", "break-spaces"];
let Sm = !1;
function i5() {
  Sm = !1;
}
class Vrt {
  constructor(t) {
    this.lineWrapping = t, this.doc = cr.empty, this.heightSamples = {}, this.lineHeight = 14, this.charWidth = 7, this.textHeight = 14, this.lineLength = 30;
  }
  heightForGap(t, n) {
    let r = this.doc.lineAt(n).number - this.doc.lineAt(t).number + 1;
    return this.lineWrapping && (r += Math.max(0, Math.ceil((n - t - r * this.lineLength * 0.5) / this.lineLength))), this.lineHeight * r;
  }
  heightForLine(t) {
    return this.lineWrapping ? (1 + Math.max(0, Math.ceil((t - this.lineLength) / (this.lineLength - 5)))) * this.lineHeight : this.lineHeight;
  }
  setDoc(t) {
    return this.doc = t, this;
  }
  mustRefreshForWrapping(t) {
    return r5.indexOf(t) > -1 != this.lineWrapping;
  }
  mustRefreshForHeights(t) {
    let n = !1;
    for (let r = 0; r < t.length; r++) {
      let i = t[r];
      i < 0 ? r++ : this.heightSamples[Math.floor(i * 10)] || (n = !0, this.heightSamples[Math.floor(i * 10)] = !0);
    }
    return n;
  }
  refresh(t, n, r, i, o, s) {
    let a = r5.indexOf(t) > -1, u = Math.round(n) != Math.round(this.lineHeight) || this.lineWrapping != a;
    if (this.lineWrapping = a, this.lineHeight = n, this.charWidth = r, this.textHeight = i, this.lineLength = o, u) {
      this.heightSamples = {};
      for (let c = 0; c < s.length; c++) {
        let d = s[c];
        d < 0 ? c++ : this.heightSamples[Math.floor(d * 10)] = !0;
      }
    }
    return u;
  }
}
class zrt {
  constructor(t, n) {
    this.from = t, this.heights = n, this.index = 0;
  }
  get more() {
    return this.index < this.heights.length;
  }
}
class Zl {
  /**
  @internal
  */
  constructor(t, n, r, i, o) {
    this.from = t, this.length = n, this.top = r, this.height = i, this._content = o;
  }
  /**
  The type of element this is. When querying lines, this may be
  an array of all the blocks that make up the line.
  */
  get type() {
    return typeof this._content == "number" ? os.Text : Array.isArray(this._content) ? this._content : this._content.type;
  }
  /**
  The end of the element as a document position.
  */
  get to() {
    return this.from + this.length;
  }
  /**
  The bottom position of the element.
  */
  get bottom() {
    return this.top + this.height;
  }
  /**
  If this is a widget block, this will return the widget
  associated with it.
  */
  get widget() {
    return this._content instanceof md ? this._content.widget : null;
  }
  /**
  If this is a textblock, this holds the number of line breaks
  that appear in widgets inside the block.
  */
  get widgetLineBreaks() {
    return typeof this._content == "number" ? this._content : 0;
  }
  /**
  @internal
  */
  join(t) {
    let n = (Array.isArray(this._content) ? this._content : [this]).concat(Array.isArray(t._content) ? t._content : [t]);
    return new Zl(this.from, this.length + t.length, this.top, this.height + t.height, n);
  }
}
var Gr = /* @__PURE__ */ function(e) {
  return e[e.ByPos = 0] = "ByPos", e[e.ByHeight = 1] = "ByHeight", e[e.ByPosNoHeight = 2] = "ByPosNoHeight", e;
}(Gr || (Gr = {}));
const lD = 1e-3;
class ss {
  constructor(t, n, r = 2) {
    this.length = t, this.height = n, this.flags = r;
  }
  get outdated() {
    return (this.flags & 2) > 0;
  }
  set outdated(t) {
    this.flags = (t ? 2 : 0) | this.flags & -3;
  }
  setHeight(t) {
    this.height != t && (Math.abs(this.height - t) > lD && (Sm = !0), this.height = t);
  }
  // Base case is to replace a leaf node, which simply builds a tree
  // from the new nodes and returns that (HeightMapBranch and
  // HeightMapGap override this to actually use from/to)
  replace(t, n, r) {
    return ss.of(r);
  }
  // Again, these are base cases, and are overridden for branch and gap nodes.
  decomposeLeft(t, n) {
    n.push(this);
  }
  decomposeRight(t, n) {
    n.push(this);
  }
  applyChanges(t, n, r, i) {
    let o = this, s = r.doc;
    for (let a = i.length - 1; a >= 0; a--) {
      let { fromA: u, toA: c, fromB: d, toB: f } = i[a], h = o.lineAt(u, Gr.ByPosNoHeight, r.setDoc(n), 0, 0), m = h.to >= c ? h : o.lineAt(c, Gr.ByPosNoHeight, r, 0, 0);
      for (f += m.to - c, c = m.to; a > 0 && h.from <= i[a - 1].toA; )
        u = i[a - 1].fromA, d = i[a - 1].fromB, a--, u < h.from && (h = o.lineAt(u, Gr.ByPosNoHeight, r, 0, 0));
      d += h.from - u, u = h.from;
      let v = H$.build(r.setDoc(s), t, d, f);
      o = uC(o, o.replace(u, c, v));
    }
    return o.updateHeight(r, 0);
  }
  static empty() {
    return new Xs(0, 0);
  }
  // nodes uses null values to indicate the position of line breaks.
  // There are never line breaks at the start or end of the array, or
  // two line breaks next to each other, and the array isn't allowed
  // to be empty (same restrictions as return value from the builder).
  static of(t) {
    if (t.length == 1)
      return t[0];
    let n = 0, r = t.length, i = 0, o = 0;
    for (; ; )
      if (n == r)
        if (i > o * 2) {
          let a = t[n - 1];
          a.break ? t.splice(--n, 1, a.left, null, a.right) : t.splice(--n, 1, a.left, a.right), r += 1 + a.break, i -= a.size;
        } else if (o > i * 2) {
          let a = t[r];
          a.break ? t.splice(r, 1, a.left, null, a.right) : t.splice(r, 1, a.left, a.right), r += 2 + a.break, o -= a.size;
        } else
          break;
      else if (i < o) {
        let a = t[n++];
        a && (i += a.size);
      } else {
        let a = t[--r];
        a && (o += a.size);
      }
    let s = 0;
    return t[n - 1] == null ? (s = 1, n--) : t[n] == null && (s = 1, r++), new Urt(ss.of(t.slice(0, n)), s, ss.of(t.slice(r)));
  }
}
function uC(e, t) {
  return e == t ? e : (e.constructor != t.constructor && (Sm = !0), t);
}
ss.prototype.size = 1;
class CY extends ss {
  constructor(t, n, r) {
    super(t, n), this.deco = r;
  }
  blockAt(t, n, r, i) {
    return new Zl(i, this.length, r, this.height, this.deco || 0);
  }
  lineAt(t, n, r, i, o) {
    return this.blockAt(0, r, i, o);
  }
  forEachLine(t, n, r, i, o, s) {
    t <= o + this.length && n >= o && s(this.blockAt(0, r, i, o));
  }
  updateHeight(t, n = 0, r = !1, i) {
    return i && i.from <= n && i.more && this.setHeight(i.heights[i.index++]), this.outdated = !1, this;
  }
  toString() {
    return `block(${this.length})`;
  }
}
class Xs extends CY {
  constructor(t, n) {
    super(t, n, null), this.collapsed = 0, this.widgetHeight = 0, this.breaks = 0;
  }
  blockAt(t, n, r, i) {
    return new Zl(i, this.length, r, this.height, this.breaks);
  }
  replace(t, n, r) {
    let i = r[0];
    return r.length == 1 && (i instanceof Xs || i instanceof po && i.flags & 4) && Math.abs(this.length - i.length) < 10 ? (i instanceof po ? i = new Xs(i.length, this.height) : i.height = this.height, this.outdated || (i.outdated = !1), i) : ss.of(r);
  }
  updateHeight(t, n = 0, r = !1, i) {
    return i && i.from <= n && i.more ? this.setHeight(i.heights[i.index++]) : (r || this.outdated) && this.setHeight(Math.max(this.widgetHeight, t.heightForLine(this.length - this.collapsed)) + this.breaks * t.lineHeight), this.outdated = !1, this;
  }
  toString() {
    return `line(${this.length}${this.collapsed ? -this.collapsed : ""}${this.widgetHeight ? ":" + this.widgetHeight : ""})`;
  }
}
class po extends ss {
  constructor(t) {
    super(t, 0);
  }
  heightMetrics(t, n) {
    let r = t.doc.lineAt(n).number, i = t.doc.lineAt(n + this.length).number, o = i - r + 1, s, a = 0;
    if (t.lineWrapping) {
      let u = Math.min(this.height, t.lineHeight * o);
      s = u / o, this.length > o + 1 && (a = (this.height - u) / (this.length - o - 1));
    } else
      s = this.height / o;
    return { firstLine: r, lastLine: i, perLine: s, perChar: a };
  }
  blockAt(t, n, r, i) {
    let { firstLine: o, lastLine: s, perLine: a, perChar: u } = this.heightMetrics(n, i);
    if (n.lineWrapping) {
      let c = i + (t < n.lineHeight ? 0 : Math.round(Math.max(0, Math.min(1, (t - r) / this.height)) * this.length)), d = n.doc.lineAt(c), f = a + d.length * u, h = Math.max(r, t - f / 2);
      return new Zl(d.from, d.length, h, f, 0);
    } else {
      let c = Math.max(0, Math.min(s - o, Math.floor((t - r) / a))), { from: d, length: f } = n.doc.line(o + c);
      return new Zl(d, f, r + a * c, a, 0);
    }
  }
  lineAt(t, n, r, i, o) {
    if (n == Gr.ByHeight)
      return this.blockAt(t, r, i, o);
    if (n == Gr.ByPosNoHeight) {
      let { from: m, to: v } = r.doc.lineAt(t);
      return new Zl(m, v - m, 0, 0, 0);
    }
    let { firstLine: s, perLine: a, perChar: u } = this.heightMetrics(r, o), c = r.doc.lineAt(t), d = a + c.length * u, f = c.number - s, h = i + a * f + u * (c.from - o - f);
    return new Zl(c.from, c.length, Math.max(i, Math.min(h, i + this.height - d)), d, 0);
  }
  forEachLine(t, n, r, i, o, s) {
    t = Math.max(t, o), n = Math.min(n, o + this.length);
    let { firstLine: a, perLine: u, perChar: c } = this.heightMetrics(r, o);
    for (let d = t, f = i; d <= n; ) {
      let h = r.doc.lineAt(d);
      if (d == t) {
        let v = h.number - a;
        f += u * v + c * (t - o - v);
      }
      let m = u + c * h.length;
      s(new Zl(h.from, h.length, f, m, 0)), f += m, d = h.to + 1;
    }
  }
  replace(t, n, r) {
    let i = this.length - n;
    if (i > 0) {
      let o = r[r.length - 1];
      o instanceof po ? r[r.length - 1] = new po(o.length + i) : r.push(null, new po(i - 1));
    }
    if (t > 0) {
      let o = r[0];
      o instanceof po ? r[0] = new po(t + o.length) : r.unshift(new po(t - 1), null);
    }
    return ss.of(r);
  }
  decomposeLeft(t, n) {
    n.push(new po(t - 1), null);
  }
  decomposeRight(t, n) {
    n.push(null, new po(this.length - t - 1));
  }
  updateHeight(t, n = 0, r = !1, i) {
    let o = n + this.length;
    if (i && i.from <= n + this.length && i.more) {
      let s = [], a = Math.max(n, i.from), u = -1;
      for (i.from > n && s.push(new po(i.from - n - 1).updateHeight(t, n)); a <= o && i.more; ) {
        let d = t.doc.lineAt(a).length;
        s.length && s.push(null);
        let f = i.heights[i.index++];
        u == -1 ? u = f : Math.abs(f - u) >= lD && (u = -2);
        let h = new Xs(d, f);
        h.outdated = !1, s.push(h), a += d + 1;
      }
      a <= o && s.push(null, new po(o - a).updateHeight(t, a));
      let c = ss.of(s);
      return (u < 0 || Math.abs(c.height - this.height) >= lD || Math.abs(u - this.heightMetrics(t, n).perLine) >= lD) && (Sm = !0), uC(this, c);
    } else (r || this.outdated) && (this.setHeight(t.heightForGap(n, n + this.length)), this.outdated = !1);
    return this;
  }
  toString() {
    return `gap(${this.length})`;
  }
}
class Urt extends ss {
  constructor(t, n, r) {
    super(t.length + n + r.length, t.height + r.height, n | (t.outdated || r.outdated ? 2 : 0)), this.left = t, this.right = r, this.size = t.size + r.size;
  }
  get break() {
    return this.flags & 1;
  }
  blockAt(t, n, r, i) {
    let o = r + this.left.height;
    return t < o ? this.left.blockAt(t, n, r, i) : this.right.blockAt(t, n, o, i + this.left.length + this.break);
  }
  lineAt(t, n, r, i, o) {
    let s = i + this.left.height, a = o + this.left.length + this.break, u = n == Gr.ByHeight ? t < s : t < a, c = u ? this.left.lineAt(t, n, r, i, o) : this.right.lineAt(t, n, r, s, a);
    if (this.break || (u ? c.to < a : c.from > a))
      return c;
    let d = n == Gr.ByPosNoHeight ? Gr.ByPosNoHeight : Gr.ByPos;
    return u ? c.join(this.right.lineAt(a, d, r, s, a)) : this.left.lineAt(a, d, r, i, o).join(c);
  }
  forEachLine(t, n, r, i, o, s) {
    let a = i + this.left.height, u = o + this.left.length + this.break;
    if (this.break)
      t < u && this.left.forEachLine(t, n, r, i, o, s), n >= u && this.right.forEachLine(t, n, r, a, u, s);
    else {
      let c = this.lineAt(u, Gr.ByPos, r, i, o);
      t < c.from && this.left.forEachLine(t, c.from - 1, r, i, o, s), c.to >= t && c.from <= n && s(c), n > c.to && this.right.forEachLine(c.to + 1, n, r, a, u, s);
    }
  }
  replace(t, n, r) {
    let i = this.left.length + this.break;
    if (n < i)
      return this.balanced(this.left.replace(t, n, r), this.right);
    if (t > this.left.length)
      return this.balanced(this.left, this.right.replace(t - i, n - i, r));
    let o = [];
    t > 0 && this.decomposeLeft(t, o);
    let s = o.length;
    for (let a of r)
      o.push(a);
    if (t > 0 && o5(o, s - 1), n < this.length) {
      let a = o.length;
      this.decomposeRight(n, o), o5(o, a);
    }
    return ss.of(o);
  }
  decomposeLeft(t, n) {
    let r = this.left.length;
    if (t <= r)
      return this.left.decomposeLeft(t, n);
    n.push(this.left), this.break && (r++, t >= r && n.push(null)), t > r && this.right.decomposeLeft(t - r, n);
  }
  decomposeRight(t, n) {
    let r = this.left.length, i = r + this.break;
    if (t >= i)
      return this.right.decomposeRight(t - i, n);
    t < r && this.left.decomposeRight(t, n), this.break && t < i && n.push(null), n.push(this.right);
  }
  balanced(t, n) {
    return t.size > 2 * n.size || n.size > 2 * t.size ? ss.of(this.break ? [t, null, n] : [t, n]) : (this.left = uC(this.left, t), this.right = uC(this.right, n), this.setHeight(t.height + n.height), this.outdated = t.outdated || n.outdated, this.size = t.size + n.size, this.length = t.length + this.break + n.length, this);
  }
  updateHeight(t, n = 0, r = !1, i) {
    let { left: o, right: s } = this, a = n + o.length + this.break, u = null;
    return i && i.from <= n + o.length && i.more ? u = o = o.updateHeight(t, n, r, i) : o.updateHeight(t, n, r), i && i.from <= a + s.length && i.more ? u = s = s.updateHeight(t, a, r, i) : s.updateHeight(t, a, r), u ? this.balanced(o, s) : (this.height = this.left.height + this.right.height, this.outdated = !1, this);
  }
  toString() {
    return this.left + (this.break ? " " : "-") + this.right;
  }
}
function o5(e, t) {
  let n, r;
  e[t] == null && (n = e[t - 1]) instanceof po && (r = e[t + 1]) instanceof po && e.splice(t - 1, 3, new po(n.length + 1 + r.length));
}
const Wrt = 5;
class H$ {
  constructor(t, n) {
    this.pos = t, this.oracle = n, this.nodes = [], this.lineStart = -1, this.lineEnd = -1, this.covering = null, this.writtenTo = t;
  }
  get isCovered() {
    return this.covering && this.nodes[this.nodes.length - 1] == this.covering;
  }
  span(t, n) {
    if (this.lineStart > -1) {
      let r = Math.min(n, this.lineEnd), i = this.nodes[this.nodes.length - 1];
      i instanceof Xs ? i.length += r - this.pos : (r > this.pos || !this.isCovered) && this.nodes.push(new Xs(r - this.pos, -1)), this.writtenTo = r, n > r && (this.nodes.push(null), this.writtenTo++, this.lineStart = -1);
    }
    this.pos = n;
  }
  point(t, n, r) {
    if (t < n || r.heightRelevant) {
      let i = r.widget ? r.widget.estimatedHeight : 0, o = r.widget ? r.widget.lineBreaks : 0;
      i < 0 && (i = this.oracle.lineHeight);
      let s = n - t;
      r.block ? this.addBlock(new CY(s, i, r)) : (s || o || i >= Wrt) && this.addLineDeco(i, o, s);
    } else n > t && this.span(t, n);
    this.lineEnd > -1 && this.lineEnd < this.pos && (this.lineEnd = this.oracle.doc.lineAt(this.pos).to);
  }
  enterLine() {
    if (this.lineStart > -1)
      return;
    let { from: t, to: n } = this.oracle.doc.lineAt(this.pos);
    this.lineStart = t, this.lineEnd = n, this.writtenTo < t && ((this.writtenTo < t - 1 || this.nodes[this.nodes.length - 1] == null) && this.nodes.push(this.blankContent(this.writtenTo, t - 1)), this.nodes.push(null)), this.pos > t && this.nodes.push(new Xs(this.pos - t, -1)), this.writtenTo = this.pos;
  }
  blankContent(t, n) {
    let r = new po(n - t);
    return this.oracle.doc.lineAt(t).to == n && (r.flags |= 4), r;
  }
  ensureLine() {
    this.enterLine();
    let t = this.nodes.length ? this.nodes[this.nodes.length - 1] : null;
    if (t instanceof Xs)
      return t;
    let n = new Xs(0, -1);
    return this.nodes.push(n), n;
  }
  addBlock(t) {
    this.enterLine();
    let n = t.deco;
    n && n.startSide > 0 && !this.isCovered && this.ensureLine(), this.nodes.push(t), this.writtenTo = this.pos = this.pos + t.length, n && n.endSide > 0 && (this.covering = t);
  }
  addLineDeco(t, n, r) {
    let i = this.ensureLine();
    i.length += r, i.collapsed += r, i.widgetHeight = Math.max(i.widgetHeight, t), i.breaks += n, this.writtenTo = this.pos = this.pos + r;
  }
  finish(t) {
    let n = this.nodes.length == 0 ? null : this.nodes[this.nodes.length - 1];
    this.lineStart > -1 && !(n instanceof Xs) && !this.isCovered ? this.nodes.push(new Xs(0, -1)) : (this.writtenTo < this.pos || n == null) && this.nodes.push(this.blankContent(this.writtenTo, this.pos));
    let r = t;
    for (let i of this.nodes)
      i instanceof Xs && i.updateHeight(this.oracle, r), r += i ? i.length : 1;
    return this.nodes;
  }
  // Always called with a region that on both sides either stretches
  // to a line break or the end of the document.
  // The returned array uses null to indicate line breaks, but never
  // starts or ends in a line break, or has multiple line breaks next
  // to each other.
  static build(t, n, r, i) {
    let o = new H$(r, t);
    return ir.spans(n, r, i, o, 0), o.finish(r);
  }
}
function Hrt(e, t, n) {
  let r = new qrt();
  return ir.compare(e, t, n, r, 0), r.changes;
}
class qrt {
  constructor() {
    this.changes = [];
  }
  compareRange() {
  }
  comparePoint(t, n, r, i) {
    (t < n || r && r.heightRelevant || i && i.heightRelevant) && sD(t, n, this.changes, 5);
  }
}
function Grt(e, t) {
  let n = e.getBoundingClientRect(), r = e.ownerDocument, i = r.defaultView || window, o = Math.max(0, n.left), s = Math.min(i.innerWidth, n.right), a = Math.max(0, n.top), u = Math.min(i.innerHeight, n.bottom);
  for (let c = e.parentNode; c && c != r.body; )
    if (c.nodeType == 1) {
      let d = c, f = window.getComputedStyle(d);
      if ((d.scrollHeight > d.clientHeight || d.scrollWidth > d.clientWidth) && f.overflow != "visible") {
        let h = d.getBoundingClientRect();
        o = Math.max(o, h.left), s = Math.min(s, h.right), a = Math.max(a, h.top), u = Math.min(c == e.parentNode ? i.innerHeight : u, h.bottom);
      }
      c = f.position == "absolute" || f.position == "fixed" ? d.offsetParent : d.parentNode;
    } else if (c.nodeType == 11)
      c = c.host;
    else
      break;
  return {
    left: o - n.left,
    right: Math.max(o, s) - n.left,
    top: a - (n.top + t),
    bottom: Math.max(a, u) - (n.top + t)
  };
}
function Yrt(e, t) {
  let n = e.getBoundingClientRect();
  return {
    left: 0,
    right: n.right - n.left,
    top: t,
    bottom: n.bottom - (n.top + t)
  };
}
class Pw {
  constructor(t, n, r, i) {
    this.from = t, this.to = n, this.size = r, this.displaySize = i;
  }
  static same(t, n) {
    if (t.length != n.length)
      return !1;
    for (let r = 0; r < t.length; r++) {
      let i = t[r], o = n[r];
      if (i.from != o.from || i.to != o.to || i.size != o.size)
        return !1;
    }
    return !0;
  }
  draw(t, n) {
    return tn.replace({
      widget: new Krt(this.displaySize * (n ? t.scaleY : t.scaleX), n)
    }).range(this.from, this.to);
  }
}
class Krt extends xc {
  constructor(t, n) {
    super(), this.size = t, this.vertical = n;
  }
  eq(t) {
    return t.size == this.size && t.vertical == this.vertical;
  }
  toDOM() {
    let t = document.createElement("div");
    return this.vertical ? t.style.height = this.size + "px" : (t.style.width = this.size + "px", t.style.height = "2px", t.style.display = "inline-block"), t;
  }
  get estimatedHeight() {
    return this.vertical ? this.size : -1;
  }
}
class s5 {
  constructor(t) {
    this.state = t, this.pixelViewport = { left: 0, right: window.innerWidth, top: 0, bottom: 0 }, this.inView = !0, this.paddingTop = 0, this.paddingBottom = 0, this.contentDOMWidth = 0, this.contentDOMHeight = 0, this.editorHeight = 0, this.editorWidth = 0, this.scrollTop = 0, this.scrolledToBottom = !1, this.scaleX = 1, this.scaleY = 1, this.scrollAnchorPos = 0, this.scrollAnchorHeight = -1, this.scaler = a5, this.scrollTarget = null, this.printing = !1, this.mustMeasureContent = !0, this.defaultTextDirection = Jr.LTR, this.visibleRanges = [], this.mustEnforceCursorAssoc = !1;
    let n = t.facet(V$).some((r) => typeof r != "function" && r.class == "cm-lineWrapping");
    this.heightOracle = new Vrt(n), this.stateDeco = t.facet(nb).filter((r) => typeof r != "function"), this.heightMap = ss.empty().applyChanges(this.stateDeco, cr.empty, this.heightOracle.setDoc(t.doc), [new _a(0, 0, 0, t.doc.length)]);
    for (let r = 0; r < 2 && (this.viewport = this.getViewport(0, null), !!this.updateForViewport()); r++)
      ;
    this.updateViewportLines(), this.lineGaps = this.ensureLineGaps([]), this.lineGapDeco = tn.set(this.lineGaps.map((r) => r.draw(this, !1))), this.computeVisibleRanges();
  }
  updateForViewport() {
    let t = [this.viewport], { main: n } = this.state.selection;
    for (let r = 0; r <= 1; r++) {
      let i = r ? n.head : n.anchor;
      if (!t.some(({ from: o, to: s }) => i >= o && i <= s)) {
        let { from: o, to: s } = this.lineBlockAt(i);
        t.push(new ux(o, s));
      }
    }
    return this.viewports = t.sort((r, i) => r.from - i.from), this.updateScaler();
  }
  updateScaler() {
    let t = this.scaler;
    return this.scaler = this.heightMap.height <= 7e6 ? a5 : new q$(this.heightOracle, this.heightMap, this.viewports), t.eq(this.scaler) ? 0 : 2;
  }
  updateViewportLines() {
    this.viewportLines = [], this.heightMap.forEachLine(this.viewport.from, this.viewport.to, this.heightOracle.setDoc(this.state.doc), 0, 0, (t) => {
      this.viewportLines.push(Xy(t, this.scaler));
    });
  }
  update(t, n = null) {
    this.state = t.state;
    let r = this.stateDeco;
    this.stateDeco = this.state.facet(nb).filter((d) => typeof d != "function");
    let i = t.changedRanges, o = _a.extendWithRanges(i, Hrt(r, this.stateDeco, t ? t.changes : Ui.empty(this.state.doc.length))), s = this.heightMap.height, a = this.scrolledToBottom ? null : this.scrollAnchorAt(this.scrollTop);
    i5(), this.heightMap = this.heightMap.applyChanges(this.stateDeco, t.startState.doc, this.heightOracle.setDoc(this.state.doc), o), (this.heightMap.height != s || Sm) && (t.flags |= 2), a ? (this.scrollAnchorPos = t.changes.mapPos(a.from, -1), this.scrollAnchorHeight = a.top) : (this.scrollAnchorPos = -1, this.scrollAnchorHeight = this.heightMap.height);
    let u = o.length ? this.mapViewport(this.viewport, t.changes) : this.viewport;
    (n && (n.range.head < u.from || n.range.head > u.to) || !this.viewportIsAppropriate(u)) && (u = this.getViewport(0, n));
    let c = u.from != this.viewport.from || u.to != this.viewport.to;
    this.viewport = u, t.flags |= this.updateForViewport(), (c || !t.changes.empty || t.flags & 2) && this.updateViewportLines(), (this.lineGaps.length || this.viewport.to - this.viewport.from > 4e3) && this.updateLineGaps(this.ensureLineGaps(this.mapLineGaps(this.lineGaps, t.changes))), t.flags |= this.computeVisibleRanges(t.changes), n && (this.scrollTarget = n), !this.mustEnforceCursorAssoc && t.selectionSet && t.view.lineWrapping && t.state.selection.main.empty && t.state.selection.main.assoc && !t.state.facet(iY) && (this.mustEnforceCursorAssoc = !0);
  }
  measure(t) {
    let n = t.contentDOM, r = window.getComputedStyle(n), i = this.heightOracle, o = r.whiteSpace;
    this.defaultTextDirection = r.direction == "rtl" ? Jr.RTL : Jr.LTR;
    let s = this.heightOracle.mustRefreshForWrapping(o), a = n.getBoundingClientRect(), u = s || this.mustMeasureContent || this.contentDOMHeight != a.height;
    this.contentDOMHeight = a.height, this.mustMeasureContent = !1;
    let c = 0, d = 0;
    if (a.width && a.height) {
      let { scaleX: O, scaleY: A } = IG(n, a);
      (O > 5e-3 && Math.abs(this.scaleX - O) > 5e-3 || A > 5e-3 && Math.abs(this.scaleY - A) > 5e-3) && (this.scaleX = O, this.scaleY = A, c |= 16, s = u = !0);
    }
    let f = (parseInt(r.paddingTop) || 0) * this.scaleY, h = (parseInt(r.paddingBottom) || 0) * this.scaleY;
    (this.paddingTop != f || this.paddingBottom != h) && (this.paddingTop = f, this.paddingBottom = h, c |= 18), this.editorWidth != t.scrollDOM.clientWidth && (i.lineWrapping && (u = !0), this.editorWidth = t.scrollDOM.clientWidth, c |= 16);
    let m = t.scrollDOM.scrollTop * this.scaleY;
    this.scrollTop != m && (this.scrollAnchorHeight = -1, this.scrollTop = m), this.scrolledToBottom = NG(t.scrollDOM);
    let v = (this.printing ? Yrt : Grt)(n, this.paddingTop), x = v.top - this.pixelViewport.top, C = v.bottom - this.pixelViewport.bottom;
    this.pixelViewport = v;
    let E = this.pixelViewport.bottom > this.pixelViewport.top && this.pixelViewport.right > this.pixelViewport.left;
    if (E != this.inView && (this.inView = E, E && (u = !0)), !this.inView && !this.scrollTarget)
      return 0;
    let S = a.width;
    if ((this.contentDOMWidth != S || this.editorHeight != t.scrollDOM.clientHeight) && (this.contentDOMWidth = a.width, this.editorHeight = t.scrollDOM.clientHeight, c |= 16), u) {
      let O = t.docView.measureVisibleLineHeights(this.viewport);
      if (i.mustRefreshForHeights(O) && (s = !0), s || i.lineWrapping && Math.abs(S - this.contentDOMWidth) > i.charWidth) {
        let { lineHeight: A, charWidth: I, textHeight: $ } = t.docView.measureTextSize();
        s = A > 0 && i.refresh(o, A, I, $, S / I, O), s && (t.docView.minWidth = 0, c |= 16);
      }
      x > 0 && C > 0 ? d = Math.max(x, C) : x < 0 && C < 0 && (d = Math.min(x, C)), i5();
      for (let A of this.viewports) {
        let I = A.from == this.viewport.from ? O : t.docView.measureVisibleLineHeights(A);
        this.heightMap = (s ? ss.empty().applyChanges(this.stateDeco, cr.empty, this.heightOracle, [new _a(0, 0, 0, t.state.doc.length)]) : this.heightMap).updateHeight(i, 0, s, new zrt(A.from, I));
      }
      Sm && (c |= 2);
    }
    let w = !this.viewportIsAppropriate(this.viewport, d) || this.scrollTarget && (this.scrollTarget.range.head < this.viewport.from || this.scrollTarget.range.head > this.viewport.to);
    return w && (c & 2 && (c |= this.updateScaler()), this.viewport = this.getViewport(d, this.scrollTarget), c |= this.updateForViewport()), (c & 2 || w) && this.updateViewportLines(), (this.lineGaps.length || this.viewport.to - this.viewport.from > 4e3) && this.updateLineGaps(this.ensureLineGaps(s ? [] : this.lineGaps, t)), c |= this.computeVisibleRanges(), this.mustEnforceCursorAssoc && (this.mustEnforceCursorAssoc = !1, t.docView.enforceCursorAssoc()), c;
  }
  get visibleTop() {
    return this.scaler.fromDOM(this.pixelViewport.top);
  }
  get visibleBottom() {
    return this.scaler.fromDOM(this.pixelViewport.bottom);
  }
  getViewport(t, n) {
    let r = 0.5 - Math.max(-0.5, Math.min(0.5, t / 1e3 / 2)), i = this.heightMap, o = this.heightOracle, { visibleTop: s, visibleBottom: a } = this, u = new ux(i.lineAt(s - r * 1e3, Gr.ByHeight, o, 0, 0).from, i.lineAt(a + (1 - r) * 1e3, Gr.ByHeight, o, 0, 0).to);
    if (n) {
      let { head: c } = n.range;
      if (c < u.from || c > u.to) {
        let d = Math.min(this.editorHeight, this.pixelViewport.bottom - this.pixelViewport.top), f = i.lineAt(c, Gr.ByPos, o, 0, 0), h;
        n.y == "center" ? h = (f.top + f.bottom) / 2 - d / 2 : n.y == "start" || n.y == "nearest" && c < u.from ? h = f.top : h = f.bottom - d, u = new ux(i.lineAt(h - 1e3 / 2, Gr.ByHeight, o, 0, 0).from, i.lineAt(h + d + 1e3 / 2, Gr.ByHeight, o, 0, 0).to);
      }
    }
    return u;
  }
  mapViewport(t, n) {
    let r = n.mapPos(t.from, -1), i = n.mapPos(t.to, 1);
    return new ux(this.heightMap.lineAt(r, Gr.ByPos, this.heightOracle, 0, 0).from, this.heightMap.lineAt(i, Gr.ByPos, this.heightOracle, 0, 0).to);
  }
  // Checks if a given viewport covers the visible part of the
  // document and not too much beyond that.
  viewportIsAppropriate({ from: t, to: n }, r = 0) {
    if (!this.inView)
      return !0;
    let { top: i } = this.heightMap.lineAt(t, Gr.ByPos, this.heightOracle, 0, 0), { bottom: o } = this.heightMap.lineAt(n, Gr.ByPos, this.heightOracle, 0, 0), { visibleTop: s, visibleBottom: a } = this;
    return (t == 0 || i <= s - Math.max(10, Math.min(
      -r,
      250
      /* VP.MaxCoverMargin */
    ))) && (n == this.state.doc.length || o >= a + Math.max(10, Math.min(
      r,
      250
      /* VP.MaxCoverMargin */
    ))) && i > s - 2 * 1e3 && o < a + 2 * 1e3;
  }
  mapLineGaps(t, n) {
    if (!t.length || n.empty)
      return t;
    let r = [];
    for (let i of t)
      n.touchesRange(i.from, i.to) || r.push(new Pw(n.mapPos(i.from), n.mapPos(i.to), i.size, i.displaySize));
    return r;
  }
  // Computes positions in the viewport where the start or end of a
  // line should be hidden, trying to reuse existing line gaps when
  // appropriate to avoid unneccesary redraws.
  // Uses crude character-counting for the positioning and sizing,
  // since actual DOM coordinates aren't always available and
  // predictable. Relies on generous margins (see LG.Margin) to hide
  // the artifacts this might produce from the user.
  ensureLineGaps(t, n) {
    let r = this.heightOracle.lineWrapping, i = r ? 1e4 : 2e3, o = i >> 1, s = i << 1;
    if (this.defaultTextDirection != Jr.LTR && !r)
      return [];
    let a = [], u = (d, f, h, m) => {
      if (f - d < o)
        return;
      let v = this.state.selection.main, x = [v.from];
      v.empty || x.push(v.to);
      for (let E of x)
        if (E > d && E < f) {
          u(d, E - 10, h, m), u(E + 10, f, h, m);
          return;
        }
      let C = Xrt(t, (E) => E.from >= h.from && E.to <= h.to && Math.abs(E.from - d) < o && Math.abs(E.to - f) < o && !x.some((S) => E.from < S && E.to > S));
      if (!C) {
        if (f < h.to && n && r && n.visibleRanges.some((w) => w.from <= f && w.to >= f)) {
          let w = n.moveToLineBoundary(it.cursor(f), !1, !0).head;
          w > d && (f = w);
        }
        let E = this.gapSize(h, d, f, m), S = r || E < 2e6 ? E : 2e6;
        C = new Pw(d, f, E, S);
      }
      a.push(C);
    }, c = (d) => {
      if (d.length < s || d.type != os.Text)
        return;
      let f = Jrt(d.from, d.to, this.stateDeco);
      if (f.total < s)
        return;
      let h = this.scrollTarget ? this.scrollTarget.range.head : null, m, v;
      if (r) {
        let x = i / this.heightOracle.lineLength * this.heightOracle.lineHeight, C, E;
        if (h != null) {
          let S = dx(f, h), w = ((this.visibleBottom - this.visibleTop) / 2 + x) / d.height;
          C = S - w, E = S + w;
        } else
          C = (this.visibleTop - d.top - x) / d.height, E = (this.visibleBottom - d.top + x) / d.height;
        m = cx(f, C), v = cx(f, E);
      } else {
        let x = f.total * this.heightOracle.charWidth, C = i * this.heightOracle.charWidth, E = 0;
        if (x > 2e6)
          for (let I of t)
            I.from >= d.from && I.from < d.to && I.size != I.displaySize && I.from * this.heightOracle.charWidth + E < this.pixelViewport.left && (E = I.size - I.displaySize);
        let S = this.pixelViewport.left + E, w = this.pixelViewport.right + E, O, A;
        if (h != null) {
          let I = dx(f, h), $ = ((w - S) / 2 + C) / x;
          O = I - $, A = I + $;
        } else
          O = (S - C) / x, A = (w + C) / x;
        m = cx(f, O), v = cx(f, A);
      }
      m > d.from && u(d.from, m, d, f), v < d.to && u(v, d.to, d, f);
    };
    for (let d of this.viewportLines)
      Array.isArray(d.type) ? d.type.forEach(c) : c(d);
    return a;
  }
  gapSize(t, n, r, i) {
    let o = dx(i, r) - dx(i, n);
    return this.heightOracle.lineWrapping ? t.height * o : i.total * this.heightOracle.charWidth * o;
  }
  updateLineGaps(t) {
    Pw.same(t, this.lineGaps) || (this.lineGaps = t, this.lineGapDeco = tn.set(t.map((n) => n.draw(this, this.heightOracle.lineWrapping))));
  }
  computeVisibleRanges(t) {
    let n = this.stateDeco;
    this.lineGaps.length && (n = n.concat(this.lineGapDeco));
    let r = [];
    ir.spans(n, this.viewport.from, this.viewport.to, {
      span(o, s) {
        r.push({ from: o, to: s });
      },
      point() {
      }
    }, 20);
    let i = 0;
    if (r.length != this.visibleRanges.length)
      i = 12;
    else
      for (let o = 0; o < r.length && !(i & 8); o++) {
        let s = this.visibleRanges[o], a = r[o];
        (s.from != a.from || s.to != a.to) && (i |= 4, t && t.mapPos(s.from, -1) == a.from && t.mapPos(s.to, 1) == a.to || (i |= 8));
      }
    return this.visibleRanges = r, i;
  }
  lineBlockAt(t) {
    return t >= this.viewport.from && t <= this.viewport.to && this.viewportLines.find((n) => n.from <= t && n.to >= t) || Xy(this.heightMap.lineAt(t, Gr.ByPos, this.heightOracle, 0, 0), this.scaler);
  }
  lineBlockAtHeight(t) {
    return t >= this.viewportLines[0].top && t <= this.viewportLines[this.viewportLines.length - 1].bottom && this.viewportLines.find((n) => n.top <= t && n.bottom >= t) || Xy(this.heightMap.lineAt(this.scaler.fromDOM(t), Gr.ByHeight, this.heightOracle, 0, 0), this.scaler);
  }
  scrollAnchorAt(t) {
    let n = this.lineBlockAtHeight(t + 8);
    return n.from >= this.viewport.from || this.viewportLines[0].top - t > 200 ? n : this.viewportLines[0];
  }
  elementAtHeight(t) {
    return Xy(this.heightMap.blockAt(this.scaler.fromDOM(t), this.heightOracle, 0, 0), this.scaler);
  }
  get docHeight() {
    return this.scaler.toDOM(this.heightMap.height);
  }
  get contentHeight() {
    return this.docHeight + this.paddingTop + this.paddingBottom;
  }
}
class ux {
  constructor(t, n) {
    this.from = t, this.to = n;
  }
}
function Jrt(e, t, n) {
  let r = [], i = e, o = 0;
  return ir.spans(n, e, t, {
    span() {
    },
    point(s, a) {
      s > i && (r.push({ from: i, to: s }), o += s - i), i = a;
    }
  }, 20), i < t && (r.push({ from: i, to: t }), o += t - i), { total: o, ranges: r };
}
function cx({ total: e, ranges: t }, n) {
  if (n <= 0)
    return t[0].from;
  if (n >= 1)
    return t[t.length - 1].to;
  let r = Math.floor(e * n);
  for (let i = 0; ; i++) {
    let { from: o, to: s } = t[i], a = s - o;
    if (r <= a)
      return o + r;
    r -= a;
  }
}
function dx(e, t) {
  let n = 0;
  for (let { from: r, to: i } of e.ranges) {
    if (t <= i) {
      n += t - r;
      break;
    }
    n += i - r;
  }
  return n / e.total;
}
function Xrt(e, t) {
  for (let n of e)
    if (t(n))
      return n;
}
const a5 = {
  toDOM(e) {
    return e;
  },
  fromDOM(e) {
    return e;
  },
  scale: 1,
  eq(e) {
    return e == this;
  }
};
class q$ {
  constructor(t, n, r) {
    let i = 0, o = 0, s = 0;
    this.viewports = r.map(({ from: a, to: u }) => {
      let c = n.lineAt(a, Gr.ByPos, t, 0, 0).top, d = n.lineAt(u, Gr.ByPos, t, 0, 0).bottom;
      return i += d - c, { from: a, to: u, top: c, bottom: d, domTop: 0, domBottom: 0 };
    }), this.scale = (7e6 - i) / (n.height - i);
    for (let a of this.viewports)
      a.domTop = s + (a.top - o) * this.scale, s = a.domBottom = a.domTop + (a.bottom - a.top), o = a.bottom;
  }
  toDOM(t) {
    for (let n = 0, r = 0, i = 0; ; n++) {
      let o = n < this.viewports.length ? this.viewports[n] : null;
      if (!o || t < o.top)
        return i + (t - r) * this.scale;
      if (t <= o.bottom)
        return o.domTop + (t - o.top);
      r = o.bottom, i = o.domBottom;
    }
  }
  fromDOM(t) {
    for (let n = 0, r = 0, i = 0; ; n++) {
      let o = n < this.viewports.length ? this.viewports[n] : null;
      if (!o || t < o.domTop)
        return r + (t - i) / this.scale;
      if (t <= o.domBottom)
        return o.top + (t - o.domTop);
      r = o.bottom, i = o.domBottom;
    }
  }
  eq(t) {
    return t instanceof q$ ? this.scale == t.scale && this.viewports.length == t.viewports.length && this.viewports.every((n, r) => n.from == t.viewports[r].from && n.to == t.viewports[r].to) : !1;
  }
}
function Xy(e, t) {
  if (t.scale == 1)
    return e;
  let n = t.toDOM(e.top), r = t.toDOM(e.bottom);
  return new Zl(e.from, e.length, n, r - n, Array.isArray(e._content) ? e._content.map((i) => Xy(i, t)) : e._content);
}
const px = /* @__PURE__ */ zt.define({ combine: (e) => e.join(" ") }), Uk = /* @__PURE__ */ zt.define({ combine: (e) => e.indexOf(!0) > -1 }), Wk = /* @__PURE__ */ fd.newName(), EY = /* @__PURE__ */ fd.newName(), TY = /* @__PURE__ */ fd.newName(), SY = { "&light": "." + EY, "&dark": "." + TY };
function Hk(e, t, n) {
  return new fd(t, {
    finish(r) {
      return /&/.test(r) ? r.replace(/&\w*/, (i) => {
        if (i == "&")
          return e;
        if (!n || !n[i])
          throw new RangeError(`Unsupported selector: ${i}`);
        return n[i];
      }) : e + " " + r;
    }
  });
}
const Qrt = /* @__PURE__ */ Hk("." + Wk, {
  "&": {
    position: "relative !important",
    boxSizing: "border-box",
    "&.cm-focused": {
      // Provide a simple default outline to make sure a focused
      // editor is visually distinct. Can't leave the default behavior
      // because that will apply to the content element, which is
      // inside the scrollable container and doesn't include the
      // gutters. We also can't use an 'auto' outline, since those
      // are, for some reason, drawn behind the element content, which
      // will cause things like the active line background to cover
      // the outline (#297).
      outline: "1px dotted #212121"
    },
    display: "flex !important",
    flexDirection: "column"
  },
  ".cm-scroller": {
    display: "flex !important",
    alignItems: "flex-start !important",
    fontFamily: "monospace",
    lineHeight: 1.4,
    height: "100%",
    overflowX: "auto",
    position: "relative",
    zIndex: 0,
    overflowAnchor: "none"
  },
  ".cm-content": {
    margin: 0,
    flexGrow: 2,
    flexShrink: 0,
    display: "block",
    whiteSpace: "pre",
    wordWrap: "normal",
    // https://github.com/codemirror/dev/issues/456
    boxSizing: "border-box",
    minHeight: "100%",
    padding: "4px 0",
    outline: "none",
    "&[contenteditable=true]": {
      WebkitUserModify: "read-write-plaintext-only"
    }
  },
  ".cm-lineWrapping": {
    whiteSpace_fallback: "pre-wrap",
    // For IE
    whiteSpace: "break-spaces",
    wordBreak: "break-word",
    // For Safari, which doesn't support overflow-wrap: anywhere
    overflowWrap: "anywhere",
    flexShrink: 1
  },
  "&light .cm-content": { caretColor: "black" },
  "&dark .cm-content": { caretColor: "white" },
  ".cm-line": {
    display: "block",
    padding: "0 2px 0 6px"
  },
  ".cm-layer": {
    position: "absolute",
    left: 0,
    top: 0,
    contain: "size style",
    "& > *": {
      position: "absolute"
    }
  },
  "&light .cm-selectionBackground": {
    background: "#d9d9d9"
  },
  "&dark .cm-selectionBackground": {
    background: "#222"
  },
  "&light.cm-focused > .cm-scroller > .cm-selectionLayer .cm-selectionBackground": {
    background: "#d7d4f0"
  },
  "&dark.cm-focused > .cm-scroller > .cm-selectionLayer .cm-selectionBackground": {
    background: "#233"
  },
  ".cm-cursorLayer": {
    pointerEvents: "none"
  },
  "&.cm-focused > .cm-scroller > .cm-cursorLayer": {
    animation: "steps(1) cm-blink 1.2s infinite"
  },
  // Two animations defined so that we can switch between them to
  // restart the animation without forcing another style
  // recomputation.
  "@keyframes cm-blink": { "0%": {}, "50%": { opacity: 0 }, "100%": {} },
  "@keyframes cm-blink2": { "0%": {}, "50%": { opacity: 0 }, "100%": {} },
  ".cm-cursor, .cm-dropCursor": {
    borderLeft: "1.2px solid black",
    marginLeft: "-0.6px",
    pointerEvents: "none"
  },
  ".cm-cursor": {
    display: "none"
  },
  "&dark .cm-cursor": {
    borderLeftColor: "#ddd"
  },
  ".cm-dropCursor": {
    position: "absolute"
  },
  "&.cm-focused > .cm-scroller > .cm-cursorLayer .cm-cursor": {
    display: "block"
  },
  ".cm-iso": {
    unicodeBidi: "isolate"
  },
  ".cm-announced": {
    position: "fixed",
    top: "-10000px"
  },
  "@media print": {
    ".cm-announced": { display: "none" }
  },
  "&light .cm-activeLine": { backgroundColor: "#cceeff44" },
  "&dark .cm-activeLine": { backgroundColor: "#99eeff33" },
  "&light .cm-specialChar": { color: "red" },
  "&dark .cm-specialChar": { color: "#f78" },
  ".cm-gutters": {
    flexShrink: 0,
    display: "flex",
    height: "100%",
    boxSizing: "border-box",
    insetInlineStart: 0,
    zIndex: 200
  },
  "&light .cm-gutters": {
    backgroundColor: "#f5f5f5",
    color: "#6c6c6c",
    borderRight: "1px solid #ddd"
  },
  "&dark .cm-gutters": {
    backgroundColor: "#333338",
    color: "#ccc"
  },
  ".cm-gutter": {
    display: "flex !important",
    // Necessary -- prevents margin collapsing
    flexDirection: "column",
    flexShrink: 0,
    boxSizing: "border-box",
    minHeight: "100%",
    overflow: "hidden"
  },
  ".cm-gutterElement": {
    boxSizing: "border-box"
  },
  ".cm-lineNumbers .cm-gutterElement": {
    padding: "0 3px 0 5px",
    minWidth: "20px",
    textAlign: "right",
    whiteSpace: "nowrap"
  },
  "&light .cm-activeLineGutter": {
    backgroundColor: "#e2f2ff"
  },
  "&dark .cm-activeLineGutter": {
    backgroundColor: "#222227"
  },
  ".cm-panels": {
    boxSizing: "border-box",
    position: "sticky",
    left: 0,
    right: 0,
    zIndex: 300
  },
  "&light .cm-panels": {
    backgroundColor: "#f5f5f5",
    color: "black"
  },
  "&light .cm-panels-top": {
    borderBottom: "1px solid #ddd"
  },
  "&light .cm-panels-bottom": {
    borderTop: "1px solid #ddd"
  },
  "&dark .cm-panels": {
    backgroundColor: "#333338",
    color: "white"
  },
  ".cm-tab": {
    display: "inline-block",
    overflow: "hidden",
    verticalAlign: "bottom"
  },
  ".cm-widgetBuffer": {
    verticalAlign: "text-top",
    height: "1em",
    width: 0,
    display: "inline"
  },
  ".cm-placeholder": {
    color: "#888",
    display: "inline-block",
    verticalAlign: "top"
  },
  ".cm-highlightSpace": {
    backgroundImage: "radial-gradient(circle at 50% 55%, #aaa 20%, transparent 5%)",
    backgroundPosition: "center"
  },
  ".cm-highlightTab": {
    backgroundImage: `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="200" height="20"><path stroke="%23888" stroke-width="1" fill="none" d="M1 10H196L190 5M190 15L196 10M197 4L197 16"/></svg>')`,
    backgroundSize: "auto 100%",
    backgroundPosition: "right 90%",
    backgroundRepeat: "no-repeat"
  },
  ".cm-trailingSpace": {
    backgroundColor: "#ff332255"
  },
  ".cm-button": {
    verticalAlign: "middle",
    color: "inherit",
    fontSize: "70%",
    padding: ".2em 1em",
    borderRadius: "1px"
  },
  "&light .cm-button": {
    backgroundImage: "linear-gradient(#eff1f5, #d9d9df)",
    border: "1px solid #888",
    "&:active": {
      backgroundImage: "linear-gradient(#b4b4b4, #d0d3d6)"
    }
  },
  "&dark .cm-button": {
    backgroundImage: "linear-gradient(#393939, #111)",
    border: "1px solid #888",
    "&:active": {
      backgroundImage: "linear-gradient(#111, #333)"
    }
  },
  ".cm-textfield": {
    verticalAlign: "middle",
    color: "inherit",
    fontSize: "70%",
    border: "1px solid silver",
    padding: ".2em .5em"
  },
  "&light .cm-textfield": {
    backgroundColor: "white"
  },
  "&dark .cm-textfield": {
    border: "1px solid #555",
    backgroundColor: "inherit"
  }
}, SY), Zrt = {
  childList: !0,
  characterData: !0,
  subtree: !0,
  attributes: !0,
  characterDataOldValue: !0
}, kw = Vt.ie && Vt.ie_version <= 11;
class eit {
  constructor(t) {
    this.view = t, this.active = !1, this.editContext = null, this.selectionRange = new Lnt(), this.selectionChanged = !1, this.delayedFlush = -1, this.resizeTimeout = -1, this.queue = [], this.delayedAndroidKey = null, this.flushingAndroidKey = -1, this.lastChange = 0, this.scrollTargets = [], this.intersection = null, this.resizeScroll = null, this.intersecting = !1, this.gapIntersection = null, this.gaps = [], this.printQuery = null, this.parentCheck = -1, this.dom = t.contentDOM, this.observer = new MutationObserver((n) => {
      for (let r of n)
        this.queue.push(r);
      (Vt.ie && Vt.ie_version <= 11 || Vt.ios && t.composing) && n.some((r) => r.type == "childList" && r.removedNodes.length || r.type == "characterData" && r.oldValue.length > r.target.nodeValue.length) ? this.flushSoon() : this.flush();
    }), window.EditContext && t.constructor.EDIT_CONTEXT !== !1 && // Chrome <126 doesn't support inverted selections in edit context (#1392)
    !(Vt.chrome && Vt.chrome_version < 126) && (this.editContext = new nit(t), t.state.facet(ec) && (t.contentDOM.editContext = this.editContext.editContext)), kw && (this.onCharData = (n) => {
      this.queue.push({
        target: n.target,
        type: "characterData",
        oldValue: n.prevValue
      }), this.flushSoon();
    }), this.onSelectionChange = this.onSelectionChange.bind(this), this.onResize = this.onResize.bind(this), this.onPrint = this.onPrint.bind(this), this.onScroll = this.onScroll.bind(this), window.matchMedia && (this.printQuery = window.matchMedia("print")), typeof ResizeObserver == "function" && (this.resizeScroll = new ResizeObserver(() => {
      var n;
      ((n = this.view.docView) === null || n === void 0 ? void 0 : n.lastUpdate) < Date.now() - 75 && this.onResize();
    }), this.resizeScroll.observe(t.scrollDOM)), this.addWindowListeners(this.win = t.win), this.start(), typeof IntersectionObserver == "function" && (this.intersection = new IntersectionObserver((n) => {
      this.parentCheck < 0 && (this.parentCheck = setTimeout(this.listenForScroll.bind(this), 1e3)), n.length > 0 && n[n.length - 1].intersectionRatio > 0 != this.intersecting && (this.intersecting = !this.intersecting, this.intersecting != this.view.inView && this.onScrollChanged(document.createEvent("Event")));
    }, { threshold: [0, 1e-3] }), this.intersection.observe(this.dom), this.gapIntersection = new IntersectionObserver((n) => {
      n.length > 0 && n[n.length - 1].intersectionRatio > 0 && this.onScrollChanged(document.createEvent("Event"));
    }, {})), this.listenForScroll(), this.readSelectionRange();
  }
  onScrollChanged(t) {
    this.view.inputState.runHandlers("scroll", t), this.intersecting && this.view.measure();
  }
  onScroll(t) {
    this.intersecting && this.flush(!1), this.editContext && this.view.requestMeasure(this.editContext.measureReq), this.onScrollChanged(t);
  }
  onResize() {
    this.resizeTimeout < 0 && (this.resizeTimeout = setTimeout(() => {
      this.resizeTimeout = -1, this.view.requestMeasure();
    }, 50));
  }
  onPrint(t) {
    (t.type == "change" || !t.type) && !t.matches || (this.view.viewState.printing = !0, this.view.measure(), setTimeout(() => {
      this.view.viewState.printing = !1, this.view.requestMeasure();
    }, 500));
  }
  updateGaps(t) {
    if (this.gapIntersection && (t.length != this.gaps.length || this.gaps.some((n, r) => n != t[r]))) {
      this.gapIntersection.disconnect();
      for (let n of t)
        this.gapIntersection.observe(n);
      this.gaps = t;
    }
  }
  onSelectionChange(t) {
    let n = this.selectionChanged;
    if (!this.readSelectionRange() || this.delayedAndroidKey)
      return;
    let { view: r } = this, i = this.selectionRange;
    if (r.state.facet(ec) ? r.root.activeElement != this.dom : !oD(this.dom, i))
      return;
    let o = i.anchorNode && r.docView.nearest(i.anchorNode);
    if (o && o.ignoreEvent(t)) {
      n || (this.selectionChanged = !1);
      return;
    }
    (Vt.ie && Vt.ie_version <= 11 || Vt.android && Vt.chrome) && !r.state.selection.main.empty && // (Selection.isCollapsed isn't reliable on IE)
    i.focusNode && v0(i.focusNode, i.focusOffset, i.anchorNode, i.anchorOffset) ? this.flushSoon() : this.flush(!1);
  }
  readSelectionRange() {
    let { view: t } = this, n = tb(t.root);
    if (!n)
      return !1;
    let r = Vt.safari && t.root.nodeType == 11 && t.root.activeElement == this.dom && tit(this.view, n) || n;
    if (!r || this.selectionRange.eq(r))
      return !1;
    let i = oD(this.dom, r);
    return i && !this.selectionChanged && t.inputState.lastFocusTime > Date.now() - 200 && t.inputState.lastTouchTime < Date.now() - 300 && jnt(this.dom, r) ? (this.view.inputState.lastFocusTime = 0, t.docView.updateSelection(), !1) : (this.selectionRange.setRange(r), i && (this.selectionChanged = !0), !0);
  }
  setSelectionRange(t, n) {
    this.selectionRange.set(t.node, t.offset, n.node, n.offset), this.selectionChanged = !1;
  }
  clearSelectionRange() {
    this.selectionRange.set(null, 0, null, 0);
  }
  listenForScroll() {
    this.parentCheck = -1;
    let t = 0, n = null;
    for (let r = this.dom; r; )
      if (r.nodeType == 1)
        !n && t < this.scrollTargets.length && this.scrollTargets[t] == r ? t++ : n || (n = this.scrollTargets.slice(0, t)), n && n.push(r), r = r.assignedSlot || r.parentNode;
      else if (r.nodeType == 11)
        r = r.host;
      else
        break;
    if (t < this.scrollTargets.length && !n && (n = this.scrollTargets.slice(0, t)), n) {
      for (let r of this.scrollTargets)
        r.removeEventListener("scroll", this.onScroll);
      for (let r of this.scrollTargets = n)
        r.addEventListener("scroll", this.onScroll);
    }
  }
  ignore(t) {
    if (!this.active)
      return t();
    try {
      return this.stop(), t();
    } finally {
      this.start(), this.clear();
    }
  }
  start() {
    this.active || (this.observer.observe(this.dom, Zrt), kw && this.dom.addEventListener("DOMCharacterDataModified", this.onCharData), this.active = !0);
  }
  stop() {
    this.active && (this.active = !1, this.observer.disconnect(), kw && this.dom.removeEventListener("DOMCharacterDataModified", this.onCharData));
  }
  // Throw away any pending changes
  clear() {
    this.processRecords(), this.queue.length = 0, this.selectionChanged = !1;
  }
  // Chrome Android, especially in combination with GBoard, not only
  // doesn't reliably fire regular key events, but also often
  // surrounds the effect of enter or backspace with a bunch of
  // composition events that, when interrupted, cause text duplication
  // or other kinds of corruption. This hack makes the editor back off
  // from handling DOM changes for a moment when such a key is
  // detected (via beforeinput or keydown), and then tries to flush
  // them or, if that has no effect, dispatches the given key.
  delayAndroidKey(t, n) {
    var r;
    if (!this.delayedAndroidKey) {
      let i = () => {
        let o = this.delayedAndroidKey;
        o && (this.clearDelayedAndroidKey(), this.view.inputState.lastKeyCode = o.keyCode, this.view.inputState.lastKeyTime = Date.now(), !this.flush() && o.force && em(this.dom, o.key, o.keyCode));
      };
      this.flushingAndroidKey = this.view.win.requestAnimationFrame(i);
    }
    (!this.delayedAndroidKey || t == "Enter") && (this.delayedAndroidKey = {
      key: t,
      keyCode: n,
      // Only run the key handler when no changes are detected if
      // this isn't coming right after another change, in which case
      // it is probably part of a weird chain of updates, and should
      // be ignored if it returns the DOM to its previous state.
      force: this.lastChange < Date.now() - 50 || !!(!((r = this.delayedAndroidKey) === null || r === void 0) && r.force)
    });
  }
  clearDelayedAndroidKey() {
    this.win.cancelAnimationFrame(this.flushingAndroidKey), this.delayedAndroidKey = null, this.flushingAndroidKey = -1;
  }
  flushSoon() {
    this.delayedFlush < 0 && (this.delayedFlush = this.view.win.requestAnimationFrame(() => {
      this.delayedFlush = -1, this.flush();
    }));
  }
  forceFlush() {
    this.delayedFlush >= 0 && (this.view.win.cancelAnimationFrame(this.delayedFlush), this.delayedFlush = -1), this.flush();
  }
  pendingRecords() {
    for (let t of this.observer.takeRecords())
      this.queue.push(t);
    return this.queue;
  }
  processRecords() {
    let t = this.pendingRecords();
    t.length && (this.queue = []);
    let n = -1, r = -1, i = !1;
    for (let o of t) {
      let s = this.readMutation(o);
      s && (s.typeOver && (i = !0), n == -1 ? { from: n, to: r } = s : (n = Math.min(s.from, n), r = Math.max(s.to, r)));
    }
    return { from: n, to: r, typeOver: i };
  }
  readChange() {
    let { from: t, to: n, typeOver: r } = this.processRecords(), i = this.selectionChanged && oD(this.dom, this.selectionRange);
    if (t < 0 && !i)
      return null;
    t > -1 && (this.lastChange = Date.now()), this.view.inputState.lastFocusTime = 0, this.selectionChanged = !1;
    let o = new vrt(this.view, t, n, r);
    return this.view.docView.domChanged = { newSel: o.newSel ? o.newSel.main : null }, o;
  }
  // Apply pending changes, if any
  flush(t = !0) {
    if (this.delayedFlush >= 0 || this.delayedAndroidKey)
      return !1;
    t && this.readSelectionRange();
    let n = this.readChange();
    if (!n)
      return this.view.requestMeasure(), !1;
    let r = this.view.state, i = fY(this.view, n);
    return this.view.state == r && (n.domChanged || n.newSel && !n.newSel.main.eq(this.view.state.selection.main)) && this.view.update([]), i;
  }
  readMutation(t) {
    let n = this.view.docView.nearest(t.target);
    if (!n || n.ignoreMutation(t))
      return null;
    if (n.markDirty(t.type == "attributes"), t.type == "attributes" && (n.flags |= 4), t.type == "childList") {
      let r = l5(n, t.previousSibling || t.target.previousSibling, -1), i = l5(n, t.nextSibling || t.target.nextSibling, 1);
      return {
        from: r ? n.posAfter(r) : n.posAtStart,
        to: i ? n.posBefore(i) : n.posAtEnd,
        typeOver: !1
      };
    } else return t.type == "characterData" ? { from: n.posAtStart, to: n.posAtEnd, typeOver: t.target.nodeValue == t.oldValue } : null;
  }
  setWindow(t) {
    t != this.win && (this.removeWindowListeners(this.win), this.win = t, this.addWindowListeners(this.win));
  }
  addWindowListeners(t) {
    t.addEventListener("resize", this.onResize), this.printQuery ? this.printQuery.addEventListener ? this.printQuery.addEventListener("change", this.onPrint) : this.printQuery.addListener(this.onPrint) : t.addEventListener("beforeprint", this.onPrint), t.addEventListener("scroll", this.onScroll), t.document.addEventListener("selectionchange", this.onSelectionChange);
  }
  removeWindowListeners(t) {
    t.removeEventListener("scroll", this.onScroll), t.removeEventListener("resize", this.onResize), this.printQuery ? this.printQuery.removeEventListener ? this.printQuery.removeEventListener("change", this.onPrint) : this.printQuery.removeListener(this.onPrint) : t.removeEventListener("beforeprint", this.onPrint), t.document.removeEventListener("selectionchange", this.onSelectionChange);
  }
  update(t) {
    this.editContext && (this.editContext.update(t), t.startState.facet(ec) != t.state.facet(ec) && (t.view.contentDOM.editContext = t.state.facet(ec) ? this.editContext.editContext : null));
  }
  destroy() {
    var t, n, r;
    this.stop(), (t = this.intersection) === null || t === void 0 || t.disconnect(), (n = this.gapIntersection) === null || n === void 0 || n.disconnect(), (r = this.resizeScroll) === null || r === void 0 || r.disconnect();
    for (let i of this.scrollTargets)
      i.removeEventListener("scroll", this.onScroll);
    this.removeWindowListeners(this.win), clearTimeout(this.parentCheck), clearTimeout(this.resizeTimeout), this.win.cancelAnimationFrame(this.delayedFlush), this.win.cancelAnimationFrame(this.flushingAndroidKey), this.editContext && (this.view.contentDOM.editContext = null, this.editContext.destroy());
  }
}
function l5(e, t, n) {
  for (; t; ) {
    let r = Mr.get(t);
    if (r && r.parent == e)
      return r;
    let i = t.parentNode;
    t = i != e.dom ? i : n > 0 ? t.nextSibling : t.previousSibling;
  }
  return null;
}
function u5(e, t) {
  let n = t.startContainer, r = t.startOffset, i = t.endContainer, o = t.endOffset, s = e.docView.domAtPos(e.state.selection.main.anchor);
  return v0(s.node, s.offset, i, o) && ([n, r, i, o] = [i, o, n, r]), { anchorNode: n, anchorOffset: r, focusNode: i, focusOffset: o };
}
function tit(e, t) {
  if (t.getComposedRanges) {
    let i = t.getComposedRanges(e.root)[0];
    if (i)
      return u5(e, i);
  }
  let n = null;
  function r(i) {
    i.preventDefault(), i.stopImmediatePropagation(), n = i.getTargetRanges()[0];
  }
  return e.contentDOM.addEventListener("beforeinput", r, !0), e.dom.ownerDocument.execCommand("indent"), e.contentDOM.removeEventListener("beforeinput", r, !0), n ? u5(e, n) : null;
}
class nit {
  constructor(t) {
    this.from = 0, this.to = 0, this.pendingContextChange = null, this.handlers = /* @__PURE__ */ Object.create(null), this.composing = null, this.resetRange(t.state);
    let n = this.editContext = new window.EditContext({
      text: t.state.doc.sliceString(this.from, this.to),
      selectionStart: this.toContextPos(Math.max(this.from, Math.min(this.to, t.state.selection.main.anchor))),
      selectionEnd: this.toContextPos(t.state.selection.main.head)
    });
    this.handlers.textupdate = (r) => {
      let { anchor: i } = t.state.selection.main, o = this.toEditorPos(r.updateRangeStart), s = this.toEditorPos(r.updateRangeEnd);
      t.inputState.composing >= 0 && !this.composing && (this.composing = { contextBase: r.updateRangeStart, editorBase: o, drifted: !1 });
      let a = { from: o, to: s, insert: cr.of(r.text.split(`
`)) };
      if (a.from == this.from && i < this.from ? a.from = i : a.to == this.to && i > this.to && (a.to = i), !(a.from == a.to && !a.insert.length)) {
        if (this.pendingContextChange = a, !t.state.readOnly) {
          let u = this.to - this.from + (a.to - a.from + a.insert.length);
          W$(t, a, it.single(this.toEditorPos(r.selectionStart, u), this.toEditorPos(r.selectionEnd, u)));
        }
        this.pendingContextChange && (this.revertPending(t.state), this.setSelection(t.state));
      }
    }, this.handlers.characterboundsupdate = (r) => {
      let i = [], o = null;
      for (let s = this.toEditorPos(r.rangeStart), a = this.toEditorPos(r.rangeEnd); s < a; s++) {
        let u = t.coordsForChar(s);
        o = u && new DOMRect(u.left, u.top, u.right - u.left, u.bottom - u.top) || o || new DOMRect(), i.push(o);
      }
      n.updateCharacterBounds(r.rangeStart, i);
    }, this.handlers.textformatupdate = (r) => {
      let i = [];
      for (let o of r.getTextFormats()) {
        let s = o.underlineStyle, a = o.underlineThickness;
        if (s != "None" && a != "None") {
          let u = this.toEditorPos(o.rangeStart), c = this.toEditorPos(o.rangeEnd);
          if (u < c) {
            let d = `text-decoration: underline ${s == "Dashed" ? "dashed " : s == "Squiggle" ? "wavy " : ""}${a == "Thin" ? 1 : 2}px`;
            i.push(tn.mark({ attributes: { style: d } }).range(u, c));
          }
        }
      }
      t.dispatch({ effects: sY.of(tn.set(i)) });
    }, this.handlers.compositionstart = () => {
      t.inputState.composing < 0 && (t.inputState.composing = 0, t.inputState.compositionFirstChange = !0);
    }, this.handlers.compositionend = () => {
      if (t.inputState.composing = -1, t.inputState.compositionFirstChange = null, this.composing) {
        let { drifted: r } = this.composing;
        this.composing = null, r && this.reset(t.state);
      }
    };
    for (let r in this.handlers)
      n.addEventListener(r, this.handlers[r]);
    this.measureReq = { read: (r) => {
      this.editContext.updateControlBounds(r.contentDOM.getBoundingClientRect());
      let i = tb(r.root);
      i && i.rangeCount && this.editContext.updateSelectionBounds(i.getRangeAt(0).getBoundingClientRect());
    } };
  }
  applyEdits(t) {
    let n = 0, r = !1, i = this.pendingContextChange;
    return t.changes.iterChanges((o, s, a, u, c) => {
      if (r)
        return;
      let d = c.length - (s - o);
      if (i && s >= i.to)
        if (i.from == o && i.to == s && i.insert.eq(c)) {
          i = this.pendingContextChange = null, n += d, this.to += d;
          return;
        } else
          i = null, this.revertPending(t.state);
      if (o += n, s += n, s <= this.from)
        this.from += d, this.to += d;
      else if (o < this.to) {
        if (o < this.from || s > this.to || this.to - this.from + c.length > 3e4) {
          r = !0;
          return;
        }
        this.editContext.updateText(this.toContextPos(o), this.toContextPos(s), c.toString()), this.to += d;
      }
      n += d;
    }), i && !r && this.revertPending(t.state), !r;
  }
  update(t) {
    let n = this.pendingContextChange;
    this.composing && (this.composing.drifted || t.transactions.some((r) => !r.isUserEvent("input.type") && r.changes.touchesRange(this.from, this.to))) ? (this.composing.drifted = !0, this.composing.editorBase = t.changes.mapPos(this.composing.editorBase)) : !this.applyEdits(t) || !this.rangeIsValid(t.state) ? (this.pendingContextChange = null, this.reset(t.state)) : (t.docChanged || t.selectionSet || n) && this.setSelection(t.state), (t.geometryChanged || t.docChanged || t.selectionSet) && t.view.requestMeasure(this.measureReq);
  }
  resetRange(t) {
    let { head: n } = t.selection.main;
    this.from = Math.max(
      0,
      n - 1e4
      /* CxVp.Margin */
    ), this.to = Math.min(
      t.doc.length,
      n + 1e4
      /* CxVp.Margin */
    );
  }
  reset(t) {
    this.resetRange(t), this.editContext.updateText(0, this.editContext.text.length, t.doc.sliceString(this.from, this.to)), this.setSelection(t);
  }
  revertPending(t) {
    let n = this.pendingContextChange;
    this.pendingContextChange = null, this.editContext.updateText(this.toContextPos(n.from), this.toContextPos(n.from + n.insert.length), t.doc.sliceString(n.from, n.to));
  }
  setSelection(t) {
    let { main: n } = t.selection, r = this.toContextPos(Math.max(this.from, Math.min(this.to, n.anchor))), i = this.toContextPos(n.head);
    (this.editContext.selectionStart != r || this.editContext.selectionEnd != i) && this.editContext.updateSelection(r, i);
  }
  rangeIsValid(t) {
    let { head: n } = t.selection.main;
    return !(this.from > 0 && n - this.from < 500 || this.to < t.doc.length && this.to - n < 500 || this.to - this.from > 1e4 * 3);
  }
  toEditorPos(t, n = this.to - this.from) {
    t = Math.min(t, n);
    let r = this.composing;
    return r && r.drifted ? r.editorBase + (t - r.contextBase) : t + this.from;
  }
  toContextPos(t) {
    let n = this.composing;
    return n && n.drifted ? n.contextBase + (t - n.editorBase) : t - this.from;
  }
  destroy() {
    for (let t in this.handlers)
      this.editContext.removeEventListener(t, this.handlers[t]);
  }
}
class Rt {
  /**
  The current editor state.
  */
  get state() {
    return this.viewState.state;
  }
  /**
  To be able to display large documents without consuming too much
  memory or overloading the browser, CodeMirror only draws the
  code that is visible (plus a margin around it) to the DOM. This
  property tells you the extent of the current drawn viewport, in
  document positions.
  */
  get viewport() {
    return this.viewState.viewport;
  }
  /**
  When there are, for example, large collapsed ranges in the
  viewport, its size can be a lot bigger than the actual visible
  content. Thus, if you are doing something like styling the
  content in the viewport, it is preferable to only do so for
  these ranges, which are the subset of the viewport that is
  actually drawn.
  */
  get visibleRanges() {
    return this.viewState.visibleRanges;
  }
  /**
  Returns false when the editor is entirely scrolled out of view
  or otherwise hidden.
  */
  get inView() {
    return this.viewState.inView;
  }
  /**
  Indicates whether the user is currently composing text via
  [IME](https://en.wikipedia.org/wiki/Input_method), and at least
  one change has been made in the current composition.
  */
  get composing() {
    return this.inputState.composing > 0;
  }
  /**
  Indicates whether the user is currently in composing state. Note
  that on some platforms, like Android, this will be the case a
  lot, since just putting the cursor on a word starts a
  composition there.
  */
  get compositionStarted() {
    return this.inputState.composing >= 0;
  }
  /**
  The document or shadow root that the view lives in.
  */
  get root() {
    return this._root;
  }
  /**
  @internal
  */
  get win() {
    return this.dom.ownerDocument.defaultView || window;
  }
  /**
  Construct a new view. You'll want to either provide a `parent`
  option, or put `view.dom` into your document after creating a
  view, so that the user can see the editor.
  */
  constructor(t = {}) {
    var n;
    this.plugins = [], this.pluginMap = /* @__PURE__ */ new Map(), this.editorAttrs = {}, this.contentAttrs = {}, this.bidiCache = [], this.destroyed = !1, this.updateState = 2, this.measureScheduled = -1, this.measureRequests = [], this.contentDOM = document.createElement("div"), this.scrollDOM = document.createElement("div"), this.scrollDOM.tabIndex = -1, this.scrollDOM.className = "cm-scroller", this.scrollDOM.appendChild(this.contentDOM), this.announceDOM = document.createElement("div"), this.announceDOM.className = "cm-announced", this.announceDOM.setAttribute("aria-live", "polite"), this.dom = document.createElement("div"), this.dom.appendChild(this.announceDOM), this.dom.appendChild(this.scrollDOM), t.parent && t.parent.appendChild(this.dom);
    let { dispatch: r } = t;
    this.dispatchTransactions = t.dispatchTransactions || r && ((i) => i.forEach((o) => r(o, this))) || ((i) => this.update(i)), this.dispatch = this.dispatch.bind(this), this._root = t.root || Bnt(t.parent) || document, this.viewState = new s5(t.state || Jn.create(t)), t.scrollTo && t.scrollTo.is(sx) && (this.viewState.scrollTarget = t.scrollTo.value.clip(this.viewState.state)), this.plugins = this.state.facet(Yy).map((i) => new Sw(i));
    for (let i of this.plugins)
      i.update(this);
    this.observer = new eit(this), this.inputState = new Trt(this), this.inputState.ensureHandlers(this.plugins), this.docView = new V8(this), this.mountStyles(), this.updateAttrs(), this.updateState = 0, this.requestMeasure(), !((n = document.fonts) === null || n === void 0) && n.ready && document.fonts.ready.then(() => this.requestMeasure());
  }
  dispatch(...t) {
    let n = t.length == 1 && t[0] instanceof Wi ? t : t.length == 1 && Array.isArray(t[0]) ? t[0] : [this.state.update(...t)];
    this.dispatchTransactions(n, this);
  }
  /**
  Update the view for the given array of transactions. This will
  update the visible document and selection to match the state
  produced by the transactions, and notify view plugins of the
  change. You should usually call
  [`dispatch`](https://codemirror.net/6/docs/ref/#view.EditorView.dispatch) instead, which uses this
  as a primitive.
  */
  update(t) {
    if (this.updateState != 0)
      throw new Error("Calls to EditorView.update are not allowed while an update is in progress");
    let n = !1, r = !1, i, o = this.state;
    for (let h of t) {
      if (h.startState != o)
        throw new RangeError("Trying to update state with a transaction that doesn't start from the previous state.");
      o = h.state;
    }
    if (this.destroyed) {
      this.viewState.state = o;
      return;
    }
    let s = this.hasFocus, a = 0, u = null;
    t.some((h) => h.annotation(vY)) ? (this.inputState.notifiedFocused = s, a = 1) : s != this.inputState.notifiedFocused && (this.inputState.notifiedFocused = s, u = xY(o, s), u || (a = 1));
    let c = this.observer.delayedAndroidKey, d = null;
    if (c ? (this.observer.clearDelayedAndroidKey(), d = this.observer.readChange(), (d && !this.state.doc.eq(o.doc) || !this.state.selection.eq(o.selection)) && (d = null)) : this.observer.clear(), o.facet(Jn.phrases) != this.state.facet(Jn.phrases))
      return this.setState(o);
    i = lC.create(this, o, t), i.flags |= a;
    let f = this.viewState.scrollTarget;
    try {
      this.updateState = 2;
      for (let h of t) {
        if (f && (f = f.map(h.changes)), h.scrollIntoView) {
          let { main: m } = h.state.selection;
          f = new tm(m.empty ? m : it.cursor(m.head, m.head > m.anchor ? -1 : 1));
        }
        for (let m of h.effects)
          m.is(sx) && (f = m.value.clip(this.state));
      }
      this.viewState.update(i, f), this.bidiCache = cC.update(this.bidiCache, i.changes), i.empty || (this.updatePlugins(i), this.inputState.update(i)), n = this.docView.update(i), this.state.facet(Ky) != this.styleModules && this.mountStyles(), r = this.updateAttrs(), this.showAnnouncements(t), this.docView.updateSelection(n, t.some((h) => h.isUserEvent("select.pointer")));
    } finally {
      this.updateState = 0;
    }
    if (i.startState.facet(px) != i.state.facet(px) && (this.viewState.mustMeasureContent = !0), (n || r || f || this.viewState.mustEnforceCursorAssoc || this.viewState.mustMeasureContent) && this.requestMeasure(), n && this.docViewUpdate(), !i.empty)
      for (let h of this.state.facet(Bk))
        try {
          h(i);
        } catch (m) {
          Ts(this.state, m, "update listener");
        }
    (u || d) && Promise.resolve().then(() => {
      u && this.state == u.startState && this.dispatch(u), d && !fY(this, d) && c.force && em(this.contentDOM, c.key, c.keyCode);
    });
  }
  /**
  Reset the view to the given state. (This will cause the entire
  document to be redrawn and all view plugins to be reinitialized,
  so you should probably only use it when the new state isn't
  derived from the old state. Otherwise, use
  [`dispatch`](https://codemirror.net/6/docs/ref/#view.EditorView.dispatch) instead.)
  */
  setState(t) {
    if (this.updateState != 0)
      throw new Error("Calls to EditorView.setState are not allowed while an update is in progress");
    if (this.destroyed) {
      this.viewState.state = t;
      return;
    }
    this.updateState = 2;
    let n = this.hasFocus;
    try {
      for (let r of this.plugins)
        r.destroy(this);
      this.viewState = new s5(t), this.plugins = t.facet(Yy).map((r) => new Sw(r)), this.pluginMap.clear();
      for (let r of this.plugins)
        r.update(this);
      this.docView.destroy(), this.docView = new V8(this), this.inputState.ensureHandlers(this.plugins), this.mountStyles(), this.updateAttrs(), this.bidiCache = [];
    } finally {
      this.updateState = 0;
    }
    n && this.focus(), this.requestMeasure();
  }
  updatePlugins(t) {
    let n = t.startState.facet(Yy), r = t.state.facet(Yy);
    if (n != r) {
      let i = [];
      for (let o of r) {
        let s = n.indexOf(o);
        if (s < 0)
          i.push(new Sw(o));
        else {
          let a = this.plugins[s];
          a.mustUpdate = t, i.push(a);
        }
      }
      for (let o of this.plugins)
        o.mustUpdate != t && o.destroy(this);
      this.plugins = i, this.pluginMap.clear();
    } else
      for (let i of this.plugins)
        i.mustUpdate = t;
    for (let i = 0; i < this.plugins.length; i++)
      this.plugins[i].update(this);
    n != r && this.inputState.ensureHandlers(this.plugins);
  }
  docViewUpdate() {
    for (let t of this.plugins) {
      let n = t.value;
      if (n && n.docViewUpdate)
        try {
          n.docViewUpdate(this);
        } catch (r) {
          Ts(this.state, r, "doc view update listener");
        }
    }
  }
  /**
  @internal
  */
  measure(t = !0) {
    if (this.destroyed)
      return;
    if (this.measureScheduled > -1 && this.win.cancelAnimationFrame(this.measureScheduled), this.observer.delayedAndroidKey) {
      this.measureScheduled = -1, this.requestMeasure();
      return;
    }
    this.measureScheduled = 0, t && this.observer.forceFlush();
    let n = null, r = this.scrollDOM, i = r.scrollTop * this.scaleY, { scrollAnchorPos: o, scrollAnchorHeight: s } = this.viewState;
    Math.abs(i - this.viewState.scrollTop) > 1 && (s = -1), this.viewState.scrollAnchorHeight = -1;
    try {
      for (let a = 0; ; a++) {
        if (s < 0)
          if (NG(r))
            o = -1, s = this.viewState.heightMap.height;
          else {
            let m = this.viewState.scrollAnchorAt(i);
            o = m.from, s = m.top;
          }
        this.updateState = 1;
        let u = this.viewState.measure(this);
        if (!u && !this.measureRequests.length && this.viewState.scrollTarget == null)
          break;
        if (a > 5) {
          console.warn(this.measureRequests.length ? "Measure loop restarted more than 5 times" : "Viewport failed to stabilize");
          break;
        }
        let c = [];
        u & 4 || ([this.measureRequests, c] = [c, this.measureRequests]);
        let d = c.map((m) => {
          try {
            return m.read(this);
          } catch (v) {
            return Ts(this.state, v), c5;
          }
        }), f = lC.create(this, this.state, []), h = !1;
        f.flags |= u, n ? n.flags |= u : n = f, this.updateState = 2, f.empty || (this.updatePlugins(f), this.inputState.update(f), this.updateAttrs(), h = this.docView.update(f), h && this.docViewUpdate());
        for (let m = 0; m < c.length; m++)
          if (d[m] != c5)
            try {
              let v = c[m];
              v.write && v.write(d[m], this);
            } catch (v) {
              Ts(this.state, v);
            }
        if (h && this.docView.updateSelection(!0), !f.viewportChanged && this.measureRequests.length == 0) {
          if (this.viewState.editorHeight)
            if (this.viewState.scrollTarget) {
              this.docView.scrollIntoView(this.viewState.scrollTarget), this.viewState.scrollTarget = null, s = -1;
              continue;
            } else {
              let v = (o < 0 ? this.viewState.heightMap.height : this.viewState.lineBlockAt(o).top) - s;
              if (v > 1 || v < -1) {
                i = i + v, r.scrollTop = i / this.scaleY, s = -1;
                continue;
              }
            }
          break;
        }
      }
    } finally {
      this.updateState = 0, this.measureScheduled = -1;
    }
    if (n && !n.empty)
      for (let a of this.state.facet(Bk))
        a(n);
  }
  /**
  Get the CSS classes for the currently active editor themes.
  */
  get themeClasses() {
    return Wk + " " + (this.state.facet(Uk) ? TY : EY) + " " + this.state.facet(px);
  }
  updateAttrs() {
    let t = d5(this, aY, {
      class: "cm-editor" + (this.hasFocus ? " cm-focused " : " ") + this.themeClasses
    }), n = {
      spellcheck: "false",
      autocorrect: "off",
      autocapitalize: "off",
      writingsuggestions: "false",
      translate: "no",
      contenteditable: this.state.facet(ec) ? "true" : "false",
      class: "cm-content",
      style: `${Vt.tabSize}: ${this.state.tabSize}`,
      role: "textbox",
      "aria-multiline": "true"
    };
    this.state.readOnly && (n["aria-readonly"] = "true"), d5(this, V$, n);
    let r = this.observer.ignore(() => {
      let i = Nk(this.contentDOM, this.contentAttrs, n), o = Nk(this.dom, this.editorAttrs, t);
      return i || o;
    });
    return this.editorAttrs = t, this.contentAttrs = n, r;
  }
  showAnnouncements(t) {
    let n = !0;
    for (let r of t)
      for (let i of r.effects)
        if (i.is(Rt.announce)) {
          n && (this.announceDOM.textContent = ""), n = !1;
          let o = this.announceDOM.appendChild(document.createElement("div"));
          o.textContent = i.value;
        }
  }
  mountStyles() {
    this.styleModules = this.state.facet(Ky);
    let t = this.state.facet(Rt.cspNonce);
    fd.mount(this.root, this.styleModules.concat(Qrt).reverse(), t ? { nonce: t } : void 0);
  }
  readMeasured() {
    if (this.updateState == 2)
      throw new Error("Reading the editor layout isn't allowed during an update");
    this.updateState == 0 && this.measureScheduled > -1 && this.measure(!1);
  }
  /**
  Schedule a layout measurement, optionally providing callbacks to
  do custom DOM measuring followed by a DOM write phase. Using
  this is preferable reading DOM layout directly from, for
  example, an event handler, because it'll make sure measuring and
  drawing done by other components is synchronized, avoiding
  unnecessary DOM layout computations.
  */
  requestMeasure(t) {
    if (this.measureScheduled < 0 && (this.measureScheduled = this.win.requestAnimationFrame(() => this.measure())), t) {
      if (this.measureRequests.indexOf(t) > -1)
        return;
      if (t.key != null) {
        for (let n = 0; n < this.measureRequests.length; n++)
          if (this.measureRequests[n].key === t.key) {
            this.measureRequests[n] = t;
            return;
          }
      }
      this.measureRequests.push(t);
    }
  }
  /**
  Get the value of a specific plugin, if present. Note that
  plugins that crash can be dropped from a view, so even when you
  know you registered a given plugin, it is recommended to check
  the return value of this method.
  */
  plugin(t) {
    let n = this.pluginMap.get(t);
    return (n === void 0 || n && n.spec != t) && this.pluginMap.set(t, n = this.plugins.find((r) => r.spec == t) || null), n && n.update(this).value;
  }
  /**
  The top position of the document, in screen coordinates. This
  may be negative when the editor is scrolled down. Points
  directly to the top of the first line, not above the padding.
  */
  get documentTop() {
    return this.contentDOM.getBoundingClientRect().top + this.viewState.paddingTop;
  }
  /**
  Reports the padding above and below the document.
  */
  get documentPadding() {
    return { top: this.viewState.paddingTop, bottom: this.viewState.paddingBottom };
  }
  /**
  If the editor is transformed with CSS, this provides the scale
  along the X axis. Otherwise, it will just be 1. Note that
  transforms other than translation and scaling are not supported.
  */
  get scaleX() {
    return this.viewState.scaleX;
  }
  /**
  Provide the CSS transformed scale along the Y axis.
  */
  get scaleY() {
    return this.viewState.scaleY;
  }
  /**
  Find the text line or block widget at the given vertical
  position (which is interpreted as relative to the [top of the
  document](https://codemirror.net/6/docs/ref/#view.EditorView.documentTop)).
  */
  elementAtHeight(t) {
    return this.readMeasured(), this.viewState.elementAtHeight(t);
  }
  /**
  Find the line block (see
  [`lineBlockAt`](https://codemirror.net/6/docs/ref/#view.EditorView.lineBlockAt) at the given
  height, again interpreted relative to the [top of the
  document](https://codemirror.net/6/docs/ref/#view.EditorView.documentTop).
  */
  lineBlockAtHeight(t) {
    return this.readMeasured(), this.viewState.lineBlockAtHeight(t);
  }
  /**
  Get the extent and vertical position of all [line
  blocks](https://codemirror.net/6/docs/ref/#view.EditorView.lineBlockAt) in the viewport. Positions
  are relative to the [top of the
  document](https://codemirror.net/6/docs/ref/#view.EditorView.documentTop);
  */
  get viewportLineBlocks() {
    return this.viewState.viewportLines;
  }
  /**
  Find the line block around the given document position. A line
  block is a range delimited on both sides by either a
  non-[hidden](https://codemirror.net/6/docs/ref/#view.Decoration^replace) line break, or the
  start/end of the document. It will usually just hold a line of
  text, but may be broken into multiple textblocks by block
  widgets.
  */
  lineBlockAt(t) {
    return this.viewState.lineBlockAt(t);
  }
  /**
  The editor's total content height.
  */
  get contentHeight() {
    return this.viewState.contentHeight;
  }
  /**
  Move a cursor position by [grapheme
  cluster](https://codemirror.net/6/docs/ref/#state.findClusterBreak). `forward` determines whether
  the motion is away from the line start, or towards it. In
  bidirectional text, the line is traversed in visual order, using
  the editor's [text direction](https://codemirror.net/6/docs/ref/#view.EditorView.textDirection).
  When the start position was the last one on the line, the
  returned position will be across the line break. If there is no
  further line, the original position is returned.
  
  By default, this method moves over a single cluster. The
  optional `by` argument can be used to move across more. It will
  be called with the first cluster as argument, and should return
  a predicate that determines, for each subsequent cluster,
  whether it should also be moved over.
  */
  moveByChar(t, n, r) {
    return ww(this, t, q8(this, t, n, r));
  }
  /**
  Move a cursor position across the next group of either
  [letters](https://codemirror.net/6/docs/ref/#state.EditorState.charCategorizer) or non-letter
  non-whitespace characters.
  */
  moveByGroup(t, n) {
    return ww(this, t, q8(this, t, n, (r) => mrt(this, t.head, r)));
  }
  /**
  Get the cursor position visually at the start or end of a line.
  Note that this may differ from the _logical_ position at its
  start or end (which is simply at `line.from`/`line.to`) if text
  at the start or end goes against the line's base text direction.
  */
  visualLineSide(t, n) {
    let r = this.bidiSpans(t), i = this.textDirectionAt(t.from), o = r[n ? r.length - 1 : 0];
    return it.cursor(o.side(n, i) + t.from, o.forward(!n, i) ? 1 : -1);
  }
  /**
  Move to the next line boundary in the given direction. If
  `includeWrap` is true, line wrapping is on, and there is a
  further wrap point on the current line, the wrap point will be
  returned. Otherwise this function will return the start or end
  of the line.
  */
  moveToLineBoundary(t, n, r = !0) {
    return hrt(this, t, n, r);
  }
  /**
  Move a cursor position vertically. When `distance` isn't given,
  it defaults to moving to the next line (including wrapped
  lines). Otherwise, `distance` should provide a positive distance
  in pixels.
  
  When `start` has a
  [`goalColumn`](https://codemirror.net/6/docs/ref/#state.SelectionRange.goalColumn), the vertical
  motion will use that as a target horizontal position. Otherwise,
  the cursor's own horizontal position is used. The returned
  cursor will have its goal column set to whichever column was
  used.
  */
  moveVertically(t, n, r) {
    return ww(this, t, grt(this, t, n, r));
  }
  /**
  Find the DOM parent node and offset (child offset if `node` is
  an element, character offset when it is a text node) at the
  given document position.
  
  Note that for positions that aren't currently in
  `visibleRanges`, the resulting DOM position isn't necessarily
  meaningful (it may just point before or after a placeholder
  element).
  */
  domAtPos(t) {
    return this.docView.domAtPos(t);
  }
  /**
  Find the document position at the given DOM node. Can be useful
  for associating positions with DOM events. Will raise an error
  when `node` isn't part of the editor content.
  */
  posAtDOM(t, n = 0) {
    return this.docView.posFromDOM(t, n);
  }
  posAtCoords(t, n = !0) {
    return this.readMeasured(), pY(this, t, n);
  }
  /**
  Get the screen coordinates at the given document position.
  `side` determines whether the coordinates are based on the
  element before (-1) or after (1) the position (if no element is
  available on the given side, the method will transparently use
  another strategy to get reasonable coordinates).
  */
  coordsAtPos(t, n = 1) {
    this.readMeasured();
    let r = this.docView.coordsAt(t, n);
    if (!r || r.left == r.right)
      return r;
    let i = this.state.doc.lineAt(t), o = this.bidiSpans(i), s = o[od.find(o, t - i.from, -1, n)];
    return gv(r, s.dir == Jr.LTR == n > 0);
  }
  /**
  Return the rectangle around a given character. If `pos` does not
  point in front of a character that is in the viewport and
  rendered (i.e. not replaced, not a line break), this will return
  null. For space characters that are a line wrap point, this will
  return the position before the line break.
  */
  coordsForChar(t) {
    return this.readMeasured(), this.docView.coordsForChar(t);
  }
  /**
  The default width of a character in the editor. May not
  accurately reflect the width of all characters (given variable
  width fonts or styling of invididual ranges).
  */
  get defaultCharacterWidth() {
    return this.viewState.heightOracle.charWidth;
  }
  /**
  The default height of a line in the editor. May not be accurate
  for all lines.
  */
  get defaultLineHeight() {
    return this.viewState.heightOracle.lineHeight;
  }
  /**
  The text direction
  ([`direction`](https://developer.mozilla.org/en-US/docs/Web/CSS/direction)
  CSS property) of the editor's content element.
  */
  get textDirection() {
    return this.viewState.defaultTextDirection;
  }
  /**
  Find the text direction of the block at the given position, as
  assigned by CSS. If
  [`perLineTextDirection`](https://codemirror.net/6/docs/ref/#view.EditorView^perLineTextDirection)
  isn't enabled, or the given position is outside of the viewport,
  this will always return the same as
  [`textDirection`](https://codemirror.net/6/docs/ref/#view.EditorView.textDirection). Note that
  this may trigger a DOM layout.
  */
  textDirectionAt(t) {
    return !this.state.facet(rY) || t < this.viewport.from || t > this.viewport.to ? this.textDirection : (this.readMeasured(), this.docView.textDirectionAt(t));
  }
  /**
  Whether this editor [wraps lines](https://codemirror.net/6/docs/ref/#view.EditorView.lineWrapping)
  (as determined by the
  [`white-space`](https://developer.mozilla.org/en-US/docs/Web/CSS/white-space)
  CSS property of its content element).
  */
  get lineWrapping() {
    return this.viewState.heightOracle.lineWrapping;
  }
  /**
  Returns the bidirectional text structure of the given line
  (which should be in the current document) as an array of span
  objects. The order of these spans matches the [text
  direction](https://codemirror.net/6/docs/ref/#view.EditorView.textDirection)—if that is
  left-to-right, the leftmost spans come first, otherwise the
  rightmost spans come first.
  */
  bidiSpans(t) {
    if (t.length > rit)
      return KG(t.length);
    let n = this.textDirectionAt(t.from), r;
    for (let o of this.bidiCache)
      if (o.from == t.from && o.dir == n && (o.fresh || YG(o.isolates, r = j8(this, t))))
        return o.order;
    r || (r = j8(this, t));
    let i = Qnt(t.text, n, r);
    return this.bidiCache.push(new cC(t.from, t.to, n, r, !0, i)), i;
  }
  /**
  Check whether the editor has focus.
  */
  get hasFocus() {
    var t;
    return (this.dom.ownerDocument.hasFocus() || Vt.safari && ((t = this.inputState) === null || t === void 0 ? void 0 : t.lastContextMenu) > Date.now() - 3e4) && this.root.activeElement == this.contentDOM;
  }
  /**
  Put focus on the editor.
  */
  focus() {
    this.observer.ignore(() => {
      FG(this.contentDOM), this.docView.updateSelection();
    });
  }
  /**
  Update the [root](https://codemirror.net/6/docs/ref/##view.EditorViewConfig.root) in which the editor lives. This is only
  necessary when moving the editor's existing DOM to a new window or shadow root.
  */
  setRoot(t) {
    this._root != t && (this._root = t, this.observer.setWindow((t.nodeType == 9 ? t : t.ownerDocument).defaultView || window), this.mountStyles());
  }
  /**
  Clean up this editor view, removing its element from the
  document, unregistering event handlers, and notifying
  plugins. The view instance can no longer be used after
  calling this.
  */
  destroy() {
    this.root.activeElement == this.contentDOM && this.contentDOM.blur();
    for (let t of this.plugins)
      t.destroy(this);
    this.plugins = [], this.inputState.destroy(), this.docView.destroy(), this.dom.remove(), this.observer.destroy(), this.measureScheduled > -1 && this.win.cancelAnimationFrame(this.measureScheduled), this.destroyed = !0;
  }
  /**
  Returns an effect that can be
  [added](https://codemirror.net/6/docs/ref/#state.TransactionSpec.effects) to a transaction to
  cause it to scroll the given position or range into view.
  */
  static scrollIntoView(t, n = {}) {
    return sx.of(new tm(typeof t == "number" ? it.cursor(t) : t, n.y, n.x, n.yMargin, n.xMargin));
  }
  /**
  Return an effect that resets the editor to its current (at the
  time this method was called) scroll position. Note that this
  only affects the editor's own scrollable element, not parents.
  See also
  [`EditorViewConfig.scrollTo`](https://codemirror.net/6/docs/ref/#view.EditorViewConfig.scrollTo).
  
  The effect should be used with a document identical to the one
  it was created for. Failing to do so is not an error, but may
  not scroll to the expected position. You can
  [map](https://codemirror.net/6/docs/ref/#state.StateEffect.map) the effect to account for changes.
  */
  scrollSnapshot() {
    let { scrollTop: t, scrollLeft: n } = this.scrollDOM, r = this.viewState.scrollAnchorAt(t);
    return sx.of(new tm(it.cursor(r.from), "start", "start", r.top - t, n, !0));
  }
  /**
  Enable or disable tab-focus mode, which disables key bindings
  for Tab and Shift-Tab, letting the browser's default
  focus-changing behavior go through instead. This is useful to
  prevent trapping keyboard users in your editor.
  
  Without argument, this toggles the mode. With a boolean, it
  enables (true) or disables it (false). Given a number, it
  temporarily enables the mode until that number of milliseconds
  have passed or another non-Tab key is pressed.
  */
  setTabFocusMode(t) {
    t == null ? this.inputState.tabFocusMode = this.inputState.tabFocusMode < 0 ? 0 : -1 : typeof t == "boolean" ? this.inputState.tabFocusMode = t ? 0 : -1 : this.inputState.tabFocusMode != 0 && (this.inputState.tabFocusMode = Date.now() + t);
  }
  /**
  Returns an extension that can be used to add DOM event handlers.
  The value should be an object mapping event names to handler
  functions. For any given event, such functions are ordered by
  extension precedence, and the first handler to return true will
  be assumed to have handled that event, and no other handlers or
  built-in behavior will be activated for it. These are registered
  on the [content element](https://codemirror.net/6/docs/ref/#view.EditorView.contentDOM), except
  for `scroll` handlers, which will be called any time the
  editor's [scroll element](https://codemirror.net/6/docs/ref/#view.EditorView.scrollDOM) or one of
  its parent nodes is scrolled.
  */
  static domEventHandlers(t) {
    return Pi.define(() => ({}), { eventHandlers: t });
  }
  /**
  Create an extension that registers DOM event observers. Contrary
  to event [handlers](https://codemirror.net/6/docs/ref/#view.EditorView^domEventHandlers),
  observers can't be prevented from running by a higher-precedence
  handler returning true. They also don't prevent other handlers
  and observers from running when they return true, and should not
  call `preventDefault`.
  */
  static domEventObservers(t) {
    return Pi.define(() => ({}), { eventObservers: t });
  }
  /**
  Create a theme extension. The first argument can be a
  [`style-mod`](https://github.com/marijnh/style-mod#documentation)
  style spec providing the styles for the theme. These will be
  prefixed with a generated class for the style.
  
  Because the selectors will be prefixed with a scope class, rule
  that directly match the editor's [wrapper
  element](https://codemirror.net/6/docs/ref/#view.EditorView.dom)—to which the scope class will be
  added—need to be explicitly differentiated by adding an `&` to
  the selector for that element—for example
  `&.cm-focused`.
  
  When `dark` is set to true, the theme will be marked as dark,
  which will cause the `&dark` rules from [base
  themes](https://codemirror.net/6/docs/ref/#view.EditorView^baseTheme) to be used (as opposed to
  `&light` when a light theme is active).
  */
  static theme(t, n) {
    let r = fd.newName(), i = [px.of(r), Ky.of(Hk(`.${r}`, t))];
    return n && n.dark && i.push(Uk.of(!0)), i;
  }
  /**
  Create an extension that adds styles to the base theme. Like
  with [`theme`](https://codemirror.net/6/docs/ref/#view.EditorView^theme), use `&` to indicate the
  place of the editor wrapper element when directly targeting
  that. You can also use `&dark` or `&light` instead to only
  target editors with a dark or light theme.
  */
  static baseTheme(t) {
    return Pf.lowest(Ky.of(Hk("." + Wk, t, SY)));
  }
  /**
  Retrieve an editor view instance from the view's DOM
  representation.
  */
  static findFromDOM(t) {
    var n;
    let r = t.querySelector(".cm-content"), i = r && Mr.get(r) || Mr.get(t);
    return ((n = i == null ? void 0 : i.rootView) === null || n === void 0 ? void 0 : n.view) || null;
  }
}
Rt.styleModule = Ky;
Rt.inputHandler = tY;
Rt.clipboardInputFilter = B$;
Rt.clipboardOutputFilter = j$;
Rt.scrollHandler = oY;
Rt.focusChangeEffect = nY;
Rt.perLineTextDirection = rY;
Rt.exceptionSink = eY;
Rt.updateListener = Bk;
Rt.editable = ec;
Rt.mouseSelectionStyle = ZG;
Rt.dragMovesSelection = QG;
Rt.clickAddsSelectionRange = XG;
Rt.decorations = nb;
Rt.outerDecorations = lY;
Rt.atomicRanges = z$;
Rt.bidiIsolatedRanges = uY;
Rt.scrollMargins = cY;
Rt.darkTheme = Uk;
Rt.cspNonce = /* @__PURE__ */ zt.define({ combine: (e) => e.length ? e[0] : "" });
Rt.contentAttributes = V$;
Rt.editorAttributes = aY;
Rt.lineWrapping = /* @__PURE__ */ Rt.contentAttributes.of({ class: "cm-lineWrapping" });
Rt.announce = /* @__PURE__ */ An.define();
const rit = 4096, c5 = {};
class cC {
  constructor(t, n, r, i, o, s) {
    this.from = t, this.to = n, this.dir = r, this.isolates = i, this.fresh = o, this.order = s;
  }
  static update(t, n) {
    if (n.empty && !t.some((o) => o.fresh))
      return t;
    let r = [], i = t.length ? t[t.length - 1].dir : Jr.LTR;
    for (let o = Math.max(0, t.length - 10); o < t.length; o++) {
      let s = t[o];
      s.dir == i && !n.touchesRange(s.from, s.to) && r.push(new cC(n.mapPos(s.from, 1), n.mapPos(s.to, -1), s.dir, s.isolates, !1, s.order));
    }
    return r;
  }
}
function d5(e, t, n) {
  for (let r = e.state.facet(t), i = r.length - 1; i >= 0; i--) {
    let o = r[i], s = typeof o == "function" ? o(e) : o;
    s && $k(s, n);
  }
  return n;
}
const iit = Vt.mac ? "mac" : Vt.windows ? "win" : Vt.linux ? "linux" : "key";
function oit(e, t) {
  const n = e.split(/-(?!$)/);
  let r = n[n.length - 1];
  r == "Space" && (r = " ");
  let i, o, s, a;
  for (let u = 0; u < n.length - 1; ++u) {
    const c = n[u];
    if (/^(cmd|meta|m)$/i.test(c))
      a = !0;
    else if (/^a(lt)?$/i.test(c))
      i = !0;
    else if (/^(c|ctrl|control)$/i.test(c))
      o = !0;
    else if (/^s(hift)?$/i.test(c))
      s = !0;
    else if (/^mod$/i.test(c))
      t == "mac" ? a = !0 : o = !0;
    else
      throw new Error("Unrecognized modifier name: " + c);
  }
  return i && (r = "Alt-" + r), o && (r = "Ctrl-" + r), a && (r = "Meta-" + r), s && (r = "Shift-" + r), r;
}
function fx(e, t, n) {
  return t.altKey && (e = "Alt-" + e), t.ctrlKey && (e = "Ctrl-" + e), t.metaKey && (e = "Meta-" + e), n !== !1 && t.shiftKey && (e = "Shift-" + e), e;
}
const sit = /* @__PURE__ */ Pf.default(/* @__PURE__ */ Rt.domEventHandlers({
  keydown(e, t) {
    return wY(AY(t.state), e, t, "editor");
  }
})), lT = /* @__PURE__ */ zt.define({ enables: sit }), p5 = /* @__PURE__ */ new WeakMap();
function AY(e) {
  let t = e.facet(lT), n = p5.get(t);
  return n || p5.set(t, n = uit(t.reduce((r, i) => r.concat(i), []))), n;
}
function ait(e, t, n) {
  return wY(AY(e.state), t, e, n);
}
let Zc = null;
const lit = 4e3;
function uit(e, t = iit) {
  let n = /* @__PURE__ */ Object.create(null), r = /* @__PURE__ */ Object.create(null), i = (s, a) => {
    let u = r[s];
    if (u == null)
      r[s] = a;
    else if (u != a)
      throw new Error("Key binding " + s + " is used both as a regular binding and as a multi-stroke prefix");
  }, o = (s, a, u, c, d) => {
    var f, h;
    let m = n[s] || (n[s] = /* @__PURE__ */ Object.create(null)), v = a.split(/ (?!$)/).map((E) => oit(E, t));
    for (let E = 1; E < v.length; E++) {
      let S = v.slice(0, E).join(" ");
      i(S, !0), m[S] || (m[S] = {
        preventDefault: !0,
        stopPropagation: !1,
        run: [(w) => {
          let O = Zc = { view: w, prefix: S, scope: s };
          return setTimeout(() => {
            Zc == O && (Zc = null);
          }, lit), !0;
        }]
      });
    }
    let x = v.join(" ");
    i(x, !1);
    let C = m[x] || (m[x] = {
      preventDefault: !1,
      stopPropagation: !1,
      run: ((h = (f = m._any) === null || f === void 0 ? void 0 : f.run) === null || h === void 0 ? void 0 : h.slice()) || []
    });
    u && C.run.push(u), c && (C.preventDefault = !0), d && (C.stopPropagation = !0);
  };
  for (let s of e) {
    let a = s.scope ? s.scope.split(" ") : ["editor"];
    if (s.any)
      for (let c of a) {
        let d = n[c] || (n[c] = /* @__PURE__ */ Object.create(null));
        d._any || (d._any = { preventDefault: !1, stopPropagation: !1, run: [] });
        let { any: f } = s;
        for (let h in d)
          d[h].run.push((m) => f(m, qk));
      }
    let u = s[t] || s.key;
    if (u)
      for (let c of a)
        o(c, u, s.run, s.preventDefault, s.stopPropagation), s.shift && o(c, "Shift-" + u, s.shift, s.preventDefault, s.stopPropagation);
  }
  return n;
}
let qk = null;
function wY(e, t, n, r) {
  qk = t;
  let i = Nnt(t), o = xs(i, 0), s = Ql(o) == i.length && i != " ", a = "", u = !1, c = !1, d = !1;
  Zc && Zc.view == n && Zc.scope == r && (a = Zc.prefix + " ", mY.indexOf(t.keyCode) < 0 && (c = !0, Zc = null));
  let f = /* @__PURE__ */ new Set(), h = (C) => {
    if (C) {
      for (let E of C.run)
        if (!f.has(E) && (f.add(E), E(n)))
          return C.stopPropagation && (d = !0), !0;
      C.preventDefault && (C.stopPropagation && (d = !0), c = !0);
    }
    return !1;
  }, m = e[r], v, x;
  return m && (h(m[a + fx(i, t, !s)]) ? u = !0 : s && (t.altKey || t.metaKey || t.ctrlKey) && // Ctrl-Alt may be used for AltGr on Windows
  !(Vt.windows && t.ctrlKey && t.altKey) && (v = hd[t.keyCode]) && v != i ? (h(m[a + fx(v, t, !0)]) || t.shiftKey && (x = eb[t.keyCode]) != i && x != v && h(m[a + fx(x, t, !1)])) && (u = !0) : s && t.shiftKey && h(m[a + fx(i, t, !0)]) && (u = !0), !u && h(m._any) && (u = !0)), c && (u = !0), u && d && t.stopPropagation(), qk = null, u;
}
class vv {
  /**
  Create a marker with the given class and dimensions. If `width`
  is null, the DOM element will get no width style.
  */
  constructor(t, n, r, i, o) {
    this.className = t, this.left = n, this.top = r, this.width = i, this.height = o;
  }
  draw() {
    let t = document.createElement("div");
    return t.className = this.className, this.adjust(t), t;
  }
  update(t, n) {
    return n.className != this.className ? !1 : (this.adjust(t), !0);
  }
  adjust(t) {
    t.style.left = this.left + "px", t.style.top = this.top + "px", this.width != null && (t.style.width = this.width + "px"), t.style.height = this.height + "px";
  }
  eq(t) {
    return this.left == t.left && this.top == t.top && this.width == t.width && this.height == t.height && this.className == t.className;
  }
  /**
  Create a set of rectangles for the given selection range,
  assigning them theclass`className`. Will create a single
  rectangle for empty ranges, and a set of selection-style
  rectangles covering the range's content (in a bidi-aware
  way) for non-empty ones.
  */
  static forRange(t, n, r) {
    if (r.empty) {
      let i = t.coordsAtPos(r.head, r.assoc || 1);
      if (!i)
        return [];
      let o = PY(t);
      return [new vv(n, i.left - o.left, i.top - o.top, null, i.bottom - i.top)];
    } else
      return cit(t, n, r);
  }
}
function PY(e) {
  let t = e.scrollDOM.getBoundingClientRect();
  return { left: (e.textDirection == Jr.LTR ? t.left : t.right - e.scrollDOM.clientWidth * e.scaleX) - e.scrollDOM.scrollLeft * e.scaleX, top: t.top - e.scrollDOM.scrollTop * e.scaleY };
}
function f5(e, t, n, r) {
  let i = e.coordsAtPos(t, n * 2);
  if (!i)
    return r;
  let o = e.dom.getBoundingClientRect(), s = (i.top + i.bottom) / 2, a = e.posAtCoords({ x: o.left + 1, y: s }), u = e.posAtCoords({ x: o.right - 1, y: s });
  return a == null || u == null ? r : { from: Math.max(r.from, Math.min(a, u)), to: Math.min(r.to, Math.max(a, u)) };
}
function cit(e, t, n) {
  if (n.to <= e.viewport.from || n.from >= e.viewport.to)
    return [];
  let r = Math.max(n.from, e.viewport.from), i = Math.min(n.to, e.viewport.to), o = e.textDirection == Jr.LTR, s = e.contentDOM, a = s.getBoundingClientRect(), u = PY(e), c = s.querySelector(".cm-line"), d = c && window.getComputedStyle(c), f = a.left + (d ? parseInt(d.paddingLeft) + Math.min(0, parseInt(d.textIndent)) : 0), h = a.right - (d ? parseInt(d.paddingRight) : 0), m = Vk(e, r), v = Vk(e, i), x = m.type == os.Text ? m : null, C = v.type == os.Text ? v : null;
  if (x && (e.lineWrapping || m.widgetLineBreaks) && (x = f5(e, r, 1, x)), C && (e.lineWrapping || v.widgetLineBreaks) && (C = f5(e, i, -1, C)), x && C && x.from == C.from && x.to == C.to)
    return S(w(n.from, n.to, x));
  {
    let A = x ? w(n.from, null, x) : O(m, !1), I = C ? w(null, n.to, C) : O(v, !0), $ = [];
    return (x || m).to < (C || v).from - (x && C ? 1 : 0) || m.widgetLineBreaks > 1 && A.bottom + e.defaultLineHeight / 2 < I.top ? $.push(E(f, A.bottom, h, I.top)) : A.bottom < I.top && e.elementAtHeight((A.bottom + I.top) / 2).type == os.Text && (A.bottom = I.top = (A.bottom + I.top) / 2), S(A).concat($).concat(S(I));
  }
  function E(A, I, $, L) {
    return new vv(t, A - u.left, I - u.top, $ - A, L - I);
  }
  function S({ top: A, bottom: I, horizontal: $ }) {
    let L = [];
    for (let B = 0; B < $.length; B += 2)
      L.push(E($[B], A, $[B + 1], I));
    return L;
  }
  function w(A, I, $) {
    let L = 1e9, B = -1e9, H = [];
    function q(j, U, G, K, ee) {
      let te = e.coordsAtPos(j, j == $.to ? -2 : 2), M = e.coordsAtPos(G, G == $.from ? 2 : -2);
      !te || !M || (L = Math.min(te.top, M.top, L), B = Math.max(te.bottom, M.bottom, B), ee == Jr.LTR ? H.push(o && U ? f : te.left, o && K ? h : M.right) : H.push(!o && K ? f : M.left, !o && U ? h : te.right));
    }
    let J = A ?? $.from, X = I ?? $.to;
    for (let j of e.visibleRanges)
      if (j.to > J && j.from < X)
        for (let U = Math.max(j.from, J), G = Math.min(j.to, X); ; ) {
          let K = e.state.doc.lineAt(U);
          for (let ee of e.bidiSpans(K)) {
            let te = ee.from + K.from, M = ee.to + K.from;
            if (te >= G)
              break;
            M > U && q(Math.max(te, U), A == null && te <= J, Math.min(M, G), I == null && M >= X, ee.dir);
          }
          if (U = K.to + 1, U >= G)
            break;
        }
    return H.length == 0 && q(J, A == null, X, I == null, e.textDirection), { top: L, bottom: B, horizontal: H };
  }
  function O(A, I) {
    let $ = a.top + (I ? A.top : A.bottom);
    return { top: $, bottom: $, horizontal: [] };
  }
}
function dit(e, t) {
  return e.constructor == t.constructor && e.eq(t);
}
class pit {
  constructor(t, n) {
    this.view = t, this.layer = n, this.drawn = [], this.scaleX = 1, this.scaleY = 1, this.measureReq = { read: this.measure.bind(this), write: this.draw.bind(this) }, this.dom = t.scrollDOM.appendChild(document.createElement("div")), this.dom.classList.add("cm-layer"), n.above && this.dom.classList.add("cm-layer-above"), n.class && this.dom.classList.add(n.class), this.scale(), this.dom.setAttribute("aria-hidden", "true"), this.setOrder(t.state), t.requestMeasure(this.measureReq), n.mount && n.mount(this.dom, t);
  }
  update(t) {
    t.startState.facet(uD) != t.state.facet(uD) && this.setOrder(t.state), (this.layer.update(t, this.dom) || t.geometryChanged) && (this.scale(), t.view.requestMeasure(this.measureReq));
  }
  docViewUpdate(t) {
    this.layer.updateOnDocViewUpdate !== !1 && t.requestMeasure(this.measureReq);
  }
  setOrder(t) {
    let n = 0, r = t.facet(uD);
    for (; n < r.length && r[n] != this.layer; )
      n++;
    this.dom.style.zIndex = String((this.layer.above ? 150 : -1) - n);
  }
  measure() {
    return this.layer.markers(this.view);
  }
  scale() {
    let { scaleX: t, scaleY: n } = this.view;
    (t != this.scaleX || n != this.scaleY) && (this.scaleX = t, this.scaleY = n, this.dom.style.transform = `scale(${1 / t}, ${1 / n})`);
  }
  draw(t) {
    if (t.length != this.drawn.length || t.some((n, r) => !dit(n, this.drawn[r]))) {
      let n = this.dom.firstChild, r = 0;
      for (let i of t)
        i.update && n && i.constructor && this.drawn[r].constructor && i.update(n, this.drawn[r]) ? (n = n.nextSibling, r++) : this.dom.insertBefore(i.draw(), n);
      for (; n; ) {
        let i = n.nextSibling;
        n.remove(), n = i;
      }
      this.drawn = t;
    }
  }
  destroy() {
    this.layer.destroy && this.layer.destroy(this.dom, this.view), this.dom.remove();
  }
}
const uD = /* @__PURE__ */ zt.define();
function kY(e) {
  return [
    Pi.define((t) => new pit(t, e)),
    uD.of(e)
  ];
}
const OY = !(Vt.ios && Vt.webkit && Vt.webkit_version < 534), rb = /* @__PURE__ */ zt.define({
  combine(e) {
    return wu(e, {
      cursorBlinkRate: 1200,
      drawRangeCursor: !0
    }, {
      cursorBlinkRate: (t, n) => Math.min(t, n),
      drawRangeCursor: (t, n) => t || n
    });
  }
});
function fit(e = {}) {
  return [
    rb.of(e),
    hit,
    mit,
    git,
    iY.of(!0)
  ];
}
function IY(e) {
  return e.startState.facet(rb) != e.state.facet(rb);
}
const hit = /* @__PURE__ */ kY({
  above: !0,
  markers(e) {
    let { state: t } = e, n = t.facet(rb), r = [];
    for (let i of t.selection.ranges) {
      let o = i == t.selection.main;
      if (i.empty ? !o || OY : n.drawRangeCursor) {
        let s = o ? "cm-cursor cm-cursor-primary" : "cm-cursor cm-cursor-secondary", a = i.empty ? i : it.cursor(i.head, i.head > i.anchor ? -1 : 1);
        for (let u of vv.forRange(e, s, a))
          r.push(u);
      }
    }
    return r;
  },
  update(e, t) {
    e.transactions.some((r) => r.selection) && (t.style.animationName = t.style.animationName == "cm-blink" ? "cm-blink2" : "cm-blink");
    let n = IY(e);
    return n && h5(e.state, t), e.docChanged || e.selectionSet || n;
  },
  mount(e, t) {
    h5(t.state, e);
  },
  class: "cm-cursorLayer"
});
function h5(e, t) {
  t.style.animationDuration = e.facet(rb).cursorBlinkRate + "ms";
}
const mit = /* @__PURE__ */ kY({
  above: !1,
  markers(e) {
    return e.state.selection.ranges.map((t) => t.empty ? [] : vv.forRange(e, "cm-selectionBackground", t)).reduce((t, n) => t.concat(n));
  },
  update(e, t) {
    return e.docChanged || e.selectionSet || e.viewportChanged || IY(e);
  },
  class: "cm-selectionLayer"
}), Gk = {
  ".cm-line": {
    "& ::selection, &::selection": { backgroundColor: "transparent !important" }
  },
  ".cm-content": {
    "& :focus": {
      caretColor: "initial !important",
      "&::selection, & ::selection": {
        backgroundColor: "Highlight !important"
      }
    }
  }
};
OY && (Gk[".cm-line"].caretColor = Gk[".cm-content"].caretColor = "transparent !important");
const git = /* @__PURE__ */ Pf.highest(/* @__PURE__ */ Rt.theme(Gk)), FY = /* @__PURE__ */ An.define({
  map(e, t) {
    return e == null ? null : t.mapPos(e);
  }
}), Qy = /* @__PURE__ */ wo.define({
  create() {
    return null;
  },
  update(e, t) {
    return e != null && (e = t.changes.mapPos(e)), t.effects.reduce((n, r) => r.is(FY) ? r.value : n, e);
  }
}), yit = /* @__PURE__ */ Pi.fromClass(class {
  constructor(e) {
    this.view = e, this.cursor = null, this.measureReq = { read: this.readPos.bind(this), write: this.drawCursor.bind(this) };
  }
  update(e) {
    var t;
    let n = e.state.field(Qy);
    n == null ? this.cursor != null && ((t = this.cursor) === null || t === void 0 || t.remove(), this.cursor = null) : (this.cursor || (this.cursor = this.view.scrollDOM.appendChild(document.createElement("div")), this.cursor.className = "cm-dropCursor"), (e.startState.field(Qy) != n || e.docChanged || e.geometryChanged) && this.view.requestMeasure(this.measureReq));
  }
  readPos() {
    let { view: e } = this, t = e.state.field(Qy), n = t != null && e.coordsAtPos(t);
    if (!n)
      return null;
    let r = e.scrollDOM.getBoundingClientRect();
    return {
      left: n.left - r.left + e.scrollDOM.scrollLeft * e.scaleX,
      top: n.top - r.top + e.scrollDOM.scrollTop * e.scaleY,
      height: n.bottom - n.top
    };
  }
  drawCursor(e) {
    if (this.cursor) {
      let { scaleX: t, scaleY: n } = this.view;
      e ? (this.cursor.style.left = e.left / t + "px", this.cursor.style.top = e.top / n + "px", this.cursor.style.height = e.height / n + "px") : this.cursor.style.left = "-100000px";
    }
  }
  destroy() {
    this.cursor && this.cursor.remove();
  }
  setDropPos(e) {
    this.view.state.field(Qy) != e && this.view.dispatch({ effects: FY.of(e) });
  }
}, {
  eventObservers: {
    dragover(e) {
      this.setDropPos(this.view.posAtCoords({ x: e.clientX, y: e.clientY }));
    },
    dragleave(e) {
      (e.target == this.view.contentDOM || !this.view.contentDOM.contains(e.relatedTarget)) && this.setDropPos(null);
    },
    dragend() {
      this.setDropPos(null);
    },
    drop() {
      this.setDropPos(null);
    }
  }
});
function bit() {
  return [Qy, yit];
}
function m5(e, t, n, r, i) {
  t.lastIndex = 0;
  for (let o = e.iterRange(n, r), s = n, a; !o.next().done; s += o.value.length)
    if (!o.lineBreak)
      for (; a = t.exec(o.value); )
        i(s + a.index, a);
}
function vit(e, t) {
  let n = e.visibleRanges;
  if (n.length == 1 && n[0].from == e.viewport.from && n[0].to == e.viewport.to)
    return n;
  let r = [];
  for (let { from: i, to: o } of n)
    i = Math.max(e.state.doc.lineAt(i).from, i - t), o = Math.min(e.state.doc.lineAt(o).to, o + t), r.length && r[r.length - 1].to >= i ? r[r.length - 1].to = o : r.push({ from: i, to: o });
  return r;
}
class xit {
  /**
  Create a decorator.
  */
  constructor(t) {
    const { regexp: n, decoration: r, decorate: i, boundary: o, maxLength: s = 1e3 } = t;
    if (!n.global)
      throw new RangeError("The regular expression given to MatchDecorator should have its 'g' flag set");
    if (this.regexp = n, i)
      this.addMatch = (a, u, c, d) => i(d, c, c + a[0].length, a, u);
    else if (typeof r == "function")
      this.addMatch = (a, u, c, d) => {
        let f = r(a, u, c);
        f && d(c, c + a[0].length, f);
      };
    else if (r)
      this.addMatch = (a, u, c, d) => d(c, c + a[0].length, r);
    else
      throw new RangeError("Either 'decorate' or 'decoration' should be provided to MatchDecorator");
    this.boundary = o, this.maxLength = s;
  }
  /**
  Compute the full set of decorations for matches in the given
  view's viewport. You'll want to call this when initializing your
  plugin.
  */
  createDeco(t) {
    let n = new uc(), r = n.add.bind(n);
    for (let { from: i, to: o } of vit(t, this.maxLength))
      m5(t.state.doc, this.regexp, i, o, (s, a) => this.addMatch(a, t, s, r));
    return n.finish();
  }
  /**
  Update a set of decorations for a view update. `deco` _must_ be
  the set of decorations produced by _this_ `MatchDecorator` for
  the view state before the update.
  */
  updateDeco(t, n) {
    let r = 1e9, i = -1;
    return t.docChanged && t.changes.iterChanges((o, s, a, u) => {
      u >= t.view.viewport.from && a <= t.view.viewport.to && (r = Math.min(a, r), i = Math.max(u, i));
    }), t.viewportMoved || i - r > 1e3 ? this.createDeco(t.view) : i > -1 ? this.updateRange(t.view, n.map(t.changes), r, i) : n;
  }
  updateRange(t, n, r, i) {
    for (let o of t.visibleRanges) {
      let s = Math.max(o.from, r), a = Math.min(o.to, i);
      if (a > s) {
        let u = t.state.doc.lineAt(s), c = u.to < a ? t.state.doc.lineAt(a) : u, d = Math.max(o.from, u.from), f = Math.min(o.to, c.to);
        if (this.boundary) {
          for (; s > u.from; s--)
            if (this.boundary.test(u.text[s - 1 - u.from])) {
              d = s;
              break;
            }
          for (; a < c.to; a++)
            if (this.boundary.test(c.text[a - c.from])) {
              f = a;
              break;
            }
        }
        let h = [], m, v = (x, C, E) => h.push(E.range(x, C));
        if (u == c)
          for (this.regexp.lastIndex = d - u.from; (m = this.regexp.exec(u.text)) && m.index < f - u.from; )
            this.addMatch(m, t, m.index + u.from, v);
        else
          m5(t.state.doc, this.regexp, d, f, (x, C) => this.addMatch(C, t, x, v));
        n = n.update({ filterFrom: d, filterTo: f, filter: (x, C) => x < d || C > f, add: h });
      }
    }
    return n;
  }
}
const Yk = /x/.unicode != null ? "gu" : "g", Dit = /* @__PURE__ */ new RegExp(`[\0-\b
--­؜​‎‏\u2028\u2029‭‮⁦⁧⁩\uFEFF￹-￼]`, Yk), Cit = {
  0: "null",
  7: "bell",
  8: "backspace",
  10: "newline",
  11: "vertical tab",
  13: "carriage return",
  27: "escape",
  8203: "zero width space",
  8204: "zero width non-joiner",
  8205: "zero width joiner",
  8206: "left-to-right mark",
  8207: "right-to-left mark",
  8232: "line separator",
  8237: "left-to-right override",
  8238: "right-to-left override",
  8294: "left-to-right isolate",
  8295: "right-to-left isolate",
  8297: "pop directional isolate",
  8233: "paragraph separator",
  65279: "zero width no-break space",
  65532: "object replacement"
};
let Ow = null;
function Eit() {
  var e;
  if (Ow == null && typeof document < "u" && document.body) {
    let t = document.body.style;
    Ow = ((e = t.tabSize) !== null && e !== void 0 ? e : t.MozTabSize) != null;
  }
  return Ow || !1;
}
const cD = /* @__PURE__ */ zt.define({
  combine(e) {
    let t = wu(e, {
      render: null,
      specialChars: Dit,
      addSpecialChars: null
    });
    return (t.replaceTabs = !Eit()) && (t.specialChars = new RegExp("	|" + t.specialChars.source, Yk)), t.addSpecialChars && (t.specialChars = new RegExp(t.specialChars.source + "|" + t.addSpecialChars.source, Yk)), t;
  }
});
function Tit(e = {}) {
  return [cD.of(e), Sit()];
}
let g5 = null;
function Sit() {
  return g5 || (g5 = Pi.fromClass(class {
    constructor(e) {
      this.view = e, this.decorations = tn.none, this.decorationCache = /* @__PURE__ */ Object.create(null), this.decorator = this.makeDecorator(e.state.facet(cD)), this.decorations = this.decorator.createDeco(e);
    }
    makeDecorator(e) {
      return new xit({
        regexp: e.specialChars,
        decoration: (t, n, r) => {
          let { doc: i } = n.state, o = xs(t[0], 0);
          if (o == 9) {
            let s = i.lineAt(r), a = n.state.tabSize, u = Cg(s.text, a, r - s.from);
            return tn.replace({
              widget: new kit((a - u % a) * this.view.defaultCharacterWidth / this.view.scaleX)
            });
          }
          return this.decorationCache[o] || (this.decorationCache[o] = tn.replace({ widget: new Pit(e, o) }));
        },
        boundary: e.replaceTabs ? void 0 : /[^]/
      });
    }
    update(e) {
      let t = e.state.facet(cD);
      e.startState.facet(cD) != t ? (this.decorator = this.makeDecorator(t), this.decorations = this.decorator.createDeco(e.view)) : this.decorations = this.decorator.updateDeco(e, this.decorations);
    }
  }, {
    decorations: (e) => e.decorations
  }));
}
const Ait = "•";
function wit(e) {
  return e >= 32 ? Ait : e == 10 ? "␤" : String.fromCharCode(9216 + e);
}
class Pit extends xc {
  constructor(t, n) {
    super(), this.options = t, this.code = n;
  }
  eq(t) {
    return t.code == this.code;
  }
  toDOM(t) {
    let n = wit(this.code), r = t.state.phrase("Control character") + " " + (Cit[this.code] || "0x" + this.code.toString(16)), i = this.options.render && this.options.render(this.code, r, n);
    if (i)
      return i;
    let o = document.createElement("span");
    return o.textContent = n, o.title = r, o.setAttribute("aria-label", r), o.className = "cm-specialChar", o;
  }
  ignoreEvent() {
    return !1;
  }
}
class kit extends xc {
  constructor(t) {
    super(), this.width = t;
  }
  eq(t) {
    return t.width == this.width;
  }
  toDOM() {
    let t = document.createElement("span");
    return t.textContent = "	", t.className = "cm-tab", t.style.width = this.width + "px", t;
  }
  ignoreEvent() {
    return !1;
  }
}
function Oit() {
  return Fit;
}
const Iit = /* @__PURE__ */ tn.line({ class: "cm-activeLine" }), Fit = /* @__PURE__ */ Pi.fromClass(class {
  constructor(e) {
    this.decorations = this.getDeco(e);
  }
  update(e) {
    (e.docChanged || e.selectionSet) && (this.decorations = this.getDeco(e.view));
  }
  getDeco(e) {
    let t = -1, n = [];
    for (let r of e.state.selection.ranges) {
      let i = e.lineBlockAt(r.head);
      i.from > t && (n.push(Iit.range(i.from)), t = i.from);
    }
    return tn.set(n);
  }
}, {
  decorations: (e) => e.decorations
});
class $it extends xc {
  constructor(t) {
    super(), this.content = t;
  }
  toDOM(t) {
    let n = document.createElement("span");
    return n.className = "cm-placeholder", n.style.pointerEvents = "none", n.appendChild(typeof this.content == "string" ? document.createTextNode(this.content) : typeof this.content == "function" ? this.content(t) : this.content.cloneNode(!0)), typeof this.content == "string" ? n.setAttribute("aria-label", "placeholder " + this.content) : n.setAttribute("aria-hidden", "true"), n;
  }
  coordsAt(t) {
    let n = t.firstChild ? Cm(t.firstChild) : [];
    if (!n.length)
      return null;
    let r = window.getComputedStyle(t.parentNode), i = gv(n[0], r.direction != "rtl"), o = parseInt(r.lineHeight);
    return i.bottom - i.top > o * 1.5 ? { left: i.left, right: i.right, top: i.top, bottom: i.top + o } : i;
  }
  ignoreEvent() {
    return !1;
  }
}
function Nit(e) {
  return Pi.fromClass(class {
    constructor(t) {
      this.view = t, this.placeholder = e ? tn.set([tn.widget({ widget: new $it(e), side: 1 }).range(0)]) : tn.none;
    }
    get decorations() {
      return this.view.state.doc.length ? tn.none : this.placeholder;
    }
  }, { decorations: (t) => t.decorations });
}
const Kk = 2e3;
function Mit(e, t, n) {
  let r = Math.min(t.line, n.line), i = Math.max(t.line, n.line), o = [];
  if (t.off > Kk || n.off > Kk || t.col < 0 || n.col < 0) {
    let s = Math.min(t.off, n.off), a = Math.max(t.off, n.off);
    for (let u = r; u <= i; u++) {
      let c = e.doc.line(u);
      c.length <= a && o.push(it.range(c.from + s, c.to + a));
    }
  } else {
    let s = Math.min(t.col, n.col), a = Math.max(t.col, n.col);
    for (let u = r; u <= i; u++) {
      let c = e.doc.line(u), d = Ak(c.text, s, e.tabSize, !0);
      if (d < 0)
        o.push(it.cursor(c.to));
      else {
        let f = Ak(c.text, a, e.tabSize);
        o.push(it.range(c.from + d, c.from + f));
      }
    }
  }
  return o;
}
function Rit(e, t) {
  let n = e.coordsAtPos(e.viewport.from);
  return n ? Math.round(Math.abs((n.left - t) / e.defaultCharacterWidth)) : -1;
}
function y5(e, t) {
  let n = e.posAtCoords({ x: t.clientX, y: t.clientY }, !1), r = e.state.doc.lineAt(n), i = n - r.from, o = i > Kk ? -1 : i == r.length ? Rit(e, t.clientX) : Cg(r.text, e.state.tabSize, n - r.from);
  return { line: r.number, col: o, off: i };
}
function _it(e, t) {
  let n = y5(e, t), r = e.state.selection;
  return n ? {
    update(i) {
      if (i.docChanged) {
        let o = i.changes.mapPos(i.startState.doc.line(n.line).from), s = i.state.doc.lineAt(o);
        n = { line: s.number, col: n.col, off: Math.min(n.off, s.length) }, r = r.map(i.changes);
      }
    },
    get(i, o, s) {
      let a = y5(e, i);
      if (!a)
        return r;
      let u = Mit(e.state, n, a);
      return u.length ? s ? it.create(u.concat(r.ranges)) : it.create(u) : r;
    }
  } : null;
}
function Lit(e) {
  let t = (n) => n.altKey && n.button == 0;
  return Rt.mouseSelectionStyle.of((n, r) => t(r) ? _it(n, r) : null);
}
const Bit = {
  Alt: [18, (e) => !!e.altKey],
  Control: [17, (e) => !!e.ctrlKey],
  Shift: [16, (e) => !!e.shiftKey],
  Meta: [91, (e) => !!e.metaKey]
}, jit = { style: "cursor: crosshair" };
function Vit(e = {}) {
  let [t, n] = Bit[e.key || "Alt"], r = Pi.fromClass(class {
    constructor(i) {
      this.view = i, this.isDown = !1;
    }
    set(i) {
      this.isDown != i && (this.isDown = i, this.view.update([]));
    }
  }, {
    eventObservers: {
      keydown(i) {
        this.set(i.keyCode == t || n(i));
      },
      keyup(i) {
        (i.keyCode == t || !n(i)) && this.set(!1);
      },
      mousemove(i) {
        this.set(n(i));
      }
    }
  });
  return [
    r,
    Rt.contentAttributes.of((i) => {
      var o;
      return !((o = i.plugin(r)) === null || o === void 0) && o.isDown ? jit : null;
    })
  ];
}
const Ry = "-10000px";
class $Y {
  constructor(t, n, r, i) {
    this.facet = n, this.createTooltipView = r, this.removeTooltipView = i, this.input = t.state.facet(n), this.tooltips = this.input.filter((s) => s);
    let o = null;
    this.tooltipViews = this.tooltips.map((s) => o = r(s, o));
  }
  update(t, n) {
    var r;
    let i = t.state.facet(this.facet), o = i.filter((u) => u);
    if (i === this.input) {
      for (let u of this.tooltipViews)
        u.update && u.update(t);
      return !1;
    }
    let s = [], a = n ? [] : null;
    for (let u = 0; u < o.length; u++) {
      let c = o[u], d = -1;
      if (c) {
        for (let f = 0; f < this.tooltips.length; f++) {
          let h = this.tooltips[f];
          h && h.create == c.create && (d = f);
        }
        if (d < 0)
          s[u] = this.createTooltipView(c, u ? s[u - 1] : null), a && (a[u] = !!c.above);
        else {
          let f = s[u] = this.tooltipViews[d];
          a && (a[u] = n[d]), f.update && f.update(t);
        }
      }
    }
    for (let u of this.tooltipViews)
      s.indexOf(u) < 0 && (this.removeTooltipView(u), (r = u.destroy) === null || r === void 0 || r.call(u));
    return n && (a.forEach((u, c) => n[c] = u), n.length = a.length), this.input = i, this.tooltips = o, this.tooltipViews = s, !0;
  }
}
function zit(e) {
  let { win: t } = e;
  return { top: 0, left: 0, bottom: t.innerHeight, right: t.innerWidth };
}
const Iw = /* @__PURE__ */ zt.define({
  combine: (e) => {
    var t, n, r;
    return {
      position: Vt.ios ? "absolute" : ((t = e.find((i) => i.position)) === null || t === void 0 ? void 0 : t.position) || "fixed",
      parent: ((n = e.find((i) => i.parent)) === null || n === void 0 ? void 0 : n.parent) || null,
      tooltipSpace: ((r = e.find((i) => i.tooltipSpace)) === null || r === void 0 ? void 0 : r.tooltipSpace) || zit
    };
  }
}), b5 = /* @__PURE__ */ new WeakMap(), G$ = /* @__PURE__ */ Pi.fromClass(class {
  constructor(e) {
    this.view = e, this.above = [], this.inView = !0, this.madeAbsolute = !1, this.lastTransaction = 0, this.measureTimeout = -1;
    let t = e.state.facet(Iw);
    this.position = t.position, this.parent = t.parent, this.classes = e.themeClasses, this.createContainer(), this.measureReq = { read: this.readMeasure.bind(this), write: this.writeMeasure.bind(this), key: this }, this.resizeObserver = typeof ResizeObserver == "function" ? new ResizeObserver(() => this.measureSoon()) : null, this.manager = new $Y(e, Y$, (n, r) => this.createTooltip(n, r), (n) => {
      this.resizeObserver && this.resizeObserver.unobserve(n.dom), n.dom.remove();
    }), this.above = this.manager.tooltips.map((n) => !!n.above), this.intersectionObserver = typeof IntersectionObserver == "function" ? new IntersectionObserver((n) => {
      Date.now() > this.lastTransaction - 50 && n.length > 0 && n[n.length - 1].intersectionRatio < 1 && this.measureSoon();
    }, { threshold: [1] }) : null, this.observeIntersection(), e.win.addEventListener("resize", this.measureSoon = this.measureSoon.bind(this)), this.maybeMeasure();
  }
  createContainer() {
    this.parent ? (this.container = document.createElement("div"), this.container.style.position = "relative", this.container.className = this.view.themeClasses, this.parent.appendChild(this.container)) : this.container = this.view.dom;
  }
  observeIntersection() {
    if (this.intersectionObserver) {
      this.intersectionObserver.disconnect();
      for (let e of this.manager.tooltipViews)
        this.intersectionObserver.observe(e.dom);
    }
  }
  measureSoon() {
    this.measureTimeout < 0 && (this.measureTimeout = setTimeout(() => {
      this.measureTimeout = -1, this.maybeMeasure();
    }, 50));
  }
  update(e) {
    e.transactions.length && (this.lastTransaction = Date.now());
    let t = this.manager.update(e, this.above);
    t && this.observeIntersection();
    let n = t || e.geometryChanged, r = e.state.facet(Iw);
    if (r.position != this.position && !this.madeAbsolute) {
      this.position = r.position;
      for (let i of this.manager.tooltipViews)
        i.dom.style.position = this.position;
      n = !0;
    }
    if (r.parent != this.parent) {
      this.parent && this.container.remove(), this.parent = r.parent, this.createContainer();
      for (let i of this.manager.tooltipViews)
        this.container.appendChild(i.dom);
      n = !0;
    } else this.parent && this.view.themeClasses != this.classes && (this.classes = this.container.className = this.view.themeClasses);
    n && this.maybeMeasure();
  }
  createTooltip(e, t) {
    let n = e.create(this.view), r = t ? t.dom : null;
    if (n.dom.classList.add("cm-tooltip"), e.arrow && !n.dom.querySelector(".cm-tooltip > .cm-tooltip-arrow")) {
      let i = document.createElement("div");
      i.className = "cm-tooltip-arrow", n.dom.appendChild(i);
    }
    return n.dom.style.position = this.position, n.dom.style.top = Ry, n.dom.style.left = "0px", this.container.insertBefore(n.dom, r), n.mount && n.mount(this.view), this.resizeObserver && this.resizeObserver.observe(n.dom), n;
  }
  destroy() {
    var e, t, n;
    this.view.win.removeEventListener("resize", this.measureSoon);
    for (let r of this.manager.tooltipViews)
      r.dom.remove(), (e = r.destroy) === null || e === void 0 || e.call(r);
    this.parent && this.container.remove(), (t = this.resizeObserver) === null || t === void 0 || t.disconnect(), (n = this.intersectionObserver) === null || n === void 0 || n.disconnect(), clearTimeout(this.measureTimeout);
  }
  readMeasure() {
    let e = 1, t = 1, n = !1;
    if (this.position == "fixed" && this.manager.tooltipViews.length) {
      let { dom: o } = this.manager.tooltipViews[0];
      if (Vt.gecko)
        n = o.offsetParent != this.container.ownerDocument.body;
      else if (o.style.top == Ry && o.style.left == "0px") {
        let s = o.getBoundingClientRect();
        n = Math.abs(s.top + 1e4) > 1 || Math.abs(s.left) > 1;
      }
    }
    if (n || this.position == "absolute")
      if (this.parent) {
        let o = this.parent.getBoundingClientRect();
        o.width && o.height && (e = o.width / this.parent.offsetWidth, t = o.height / this.parent.offsetHeight);
      } else
        ({ scaleX: e, scaleY: t } = this.view.viewState);
    let r = this.view.scrollDOM.getBoundingClientRect(), i = U$(this.view);
    return {
      visible: {
        left: r.left + i.left,
        top: r.top + i.top,
        right: r.right - i.right,
        bottom: r.bottom - i.bottom
      },
      parent: this.parent ? this.container.getBoundingClientRect() : this.view.dom.getBoundingClientRect(),
      pos: this.manager.tooltips.map((o, s) => {
        let a = this.manager.tooltipViews[s];
        return a.getCoords ? a.getCoords(o.pos) : this.view.coordsAtPos(o.pos);
      }),
      size: this.manager.tooltipViews.map(({ dom: o }) => o.getBoundingClientRect()),
      space: this.view.state.facet(Iw).tooltipSpace(this.view),
      scaleX: e,
      scaleY: t,
      makeAbsolute: n
    };
  }
  writeMeasure(e) {
    var t;
    if (e.makeAbsolute) {
      this.madeAbsolute = !0, this.position = "absolute";
      for (let a of this.manager.tooltipViews)
        a.dom.style.position = "absolute";
    }
    let { visible: n, space: r, scaleX: i, scaleY: o } = e, s = [];
    for (let a = 0; a < this.manager.tooltips.length; a++) {
      let u = this.manager.tooltips[a], c = this.manager.tooltipViews[a], { dom: d } = c, f = e.pos[a], h = e.size[a];
      if (!f || u.clip !== !1 && (f.bottom <= Math.max(n.top, r.top) || f.top >= Math.min(n.bottom, r.bottom) || f.right < Math.max(n.left, r.left) - 0.1 || f.left > Math.min(n.right, r.right) + 0.1)) {
        d.style.top = Ry;
        continue;
      }
      let m = u.arrow ? c.dom.querySelector(".cm-tooltip-arrow") : null, v = m ? 7 : 0, x = h.right - h.left, C = (t = b5.get(c)) !== null && t !== void 0 ? t : h.bottom - h.top, E = c.offset || Wit, S = this.view.textDirection == Jr.LTR, w = h.width > r.right - r.left ? S ? r.left : r.right - h.width : S ? Math.max(r.left, Math.min(f.left - (m ? 14 : 0) + E.x, r.right - x)) : Math.min(Math.max(r.left, f.left - x + (m ? 14 : 0) - E.x), r.right - x), O = this.above[a];
      !u.strictSide && (O ? f.top - C - v - E.y < r.top : f.bottom + C + v + E.y > r.bottom) && O == r.bottom - f.bottom > f.top - r.top && (O = this.above[a] = !O);
      let A = (O ? f.top - r.top : r.bottom - f.bottom) - v;
      if (A < C && c.resize !== !1) {
        if (A < this.view.defaultLineHeight) {
          d.style.top = Ry;
          continue;
        }
        b5.set(c, C), d.style.height = (C = A) / o + "px";
      } else d.style.height && (d.style.height = "");
      let I = O ? f.top - C - v - E.y : f.bottom + v + E.y, $ = w + x;
      if (c.overlap !== !0)
        for (let L of s)
          L.left < $ && L.right > w && L.top < I + C && L.bottom > I && (I = O ? L.top - C - 2 - v : L.bottom + v + 2);
      if (this.position == "absolute" ? (d.style.top = (I - e.parent.top) / o + "px", v5(d, (w - e.parent.left) / i)) : (d.style.top = I / o + "px", v5(d, w / i)), m) {
        let L = f.left + (S ? E.x : -E.x) - (w + 14 - 7);
        m.style.left = L / i + "px";
      }
      c.overlap !== !0 && s.push({ left: w, top: I, right: $, bottom: I + C }), d.classList.toggle("cm-tooltip-above", O), d.classList.toggle("cm-tooltip-below", !O), c.positioned && c.positioned(e.space);
    }
  }
  maybeMeasure() {
    if (this.manager.tooltips.length && (this.view.inView && this.view.requestMeasure(this.measureReq), this.inView != this.view.inView && (this.inView = this.view.inView, !this.inView)))
      for (let e of this.manager.tooltipViews)
        e.dom.style.top = Ry;
  }
}, {
  eventObservers: {
    scroll() {
      this.maybeMeasure();
    }
  }
});
function v5(e, t) {
  let n = parseInt(e.style.left, 10);
  (isNaN(n) || Math.abs(t - n) > 1) && (e.style.left = t + "px");
}
const Uit = /* @__PURE__ */ Rt.baseTheme({
  ".cm-tooltip": {
    zIndex: 500,
    boxSizing: "border-box"
  },
  "&light .cm-tooltip": {
    border: "1px solid #bbb",
    backgroundColor: "#f5f5f5"
  },
  "&light .cm-tooltip-section:not(:first-child)": {
    borderTop: "1px solid #bbb"
  },
  "&dark .cm-tooltip": {
    backgroundColor: "#333338",
    color: "white"
  },
  ".cm-tooltip-arrow": {
    height: "7px",
    width: `${7 * 2}px`,
    position: "absolute",
    zIndex: -1,
    overflow: "hidden",
    "&:before, &:after": {
      content: "''",
      position: "absolute",
      width: 0,
      height: 0,
      borderLeft: "7px solid transparent",
      borderRight: "7px solid transparent"
    },
    ".cm-tooltip-above &": {
      bottom: "-7px",
      "&:before": {
        borderTop: "7px solid #bbb"
      },
      "&:after": {
        borderTop: "7px solid #f5f5f5",
        bottom: "1px"
      }
    },
    ".cm-tooltip-below &": {
      top: "-7px",
      "&:before": {
        borderBottom: "7px solid #bbb"
      },
      "&:after": {
        borderBottom: "7px solid #f5f5f5",
        top: "1px"
      }
    }
  },
  "&dark .cm-tooltip .cm-tooltip-arrow": {
    "&:before": {
      borderTopColor: "#333338",
      borderBottomColor: "#333338"
    },
    "&:after": {
      borderTopColor: "transparent",
      borderBottomColor: "transparent"
    }
  }
}), Wit = { x: 0, y: 0 }, Y$ = /* @__PURE__ */ zt.define({
  enables: [G$, Uit]
}), dC = /* @__PURE__ */ zt.define({
  combine: (e) => e.reduce((t, n) => t.concat(n), [])
});
class uT {
  // Needs to be static so that host tooltip instances always match
  static create(t) {
    return new uT(t);
  }
  constructor(t) {
    this.view = t, this.mounted = !1, this.dom = document.createElement("div"), this.dom.classList.add("cm-tooltip-hover"), this.manager = new $Y(t, dC, (n, r) => this.createHostedView(n, r), (n) => n.dom.remove());
  }
  createHostedView(t, n) {
    let r = t.create(this.view);
    return r.dom.classList.add("cm-tooltip-section"), this.dom.insertBefore(r.dom, n ? n.dom.nextSibling : this.dom.firstChild), this.mounted && r.mount && r.mount(this.view), r;
  }
  mount(t) {
    for (let n of this.manager.tooltipViews)
      n.mount && n.mount(t);
    this.mounted = !0;
  }
  positioned(t) {
    for (let n of this.manager.tooltipViews)
      n.positioned && n.positioned(t);
  }
  update(t) {
    this.manager.update(t);
  }
  destroy() {
    var t;
    for (let n of this.manager.tooltipViews)
      (t = n.destroy) === null || t === void 0 || t.call(n);
  }
  passProp(t) {
    let n;
    for (let r of this.manager.tooltipViews) {
      let i = r[t];
      if (i !== void 0) {
        if (n === void 0)
          n = i;
        else if (n !== i)
          return;
      }
    }
    return n;
  }
  get offset() {
    return this.passProp("offset");
  }
  get getCoords() {
    return this.passProp("getCoords");
  }
  get overlap() {
    return this.passProp("overlap");
  }
  get resize() {
    return this.passProp("resize");
  }
}
const Hit = /* @__PURE__ */ Y$.compute([dC], (e) => {
  let t = e.facet(dC);
  return t.length === 0 ? null : {
    pos: Math.min(...t.map((n) => n.pos)),
    end: Math.max(...t.map((n) => {
      var r;
      return (r = n.end) !== null && r !== void 0 ? r : n.pos;
    })),
    create: uT.create,
    above: t[0].above,
    arrow: t.some((n) => n.arrow)
  };
});
class qit {
  constructor(t, n, r, i, o) {
    this.view = t, this.source = n, this.field = r, this.setHover = i, this.hoverTime = o, this.hoverTimeout = -1, this.restartTimeout = -1, this.pending = null, this.lastMove = { x: 0, y: 0, target: t.dom, time: 0 }, this.checkHover = this.checkHover.bind(this), t.dom.addEventListener("mouseleave", this.mouseleave = this.mouseleave.bind(this)), t.dom.addEventListener("mousemove", this.mousemove = this.mousemove.bind(this));
  }
  update() {
    this.pending && (this.pending = null, clearTimeout(this.restartTimeout), this.restartTimeout = setTimeout(() => this.startHover(), 20));
  }
  get active() {
    return this.view.state.field(this.field);
  }
  checkHover() {
    if (this.hoverTimeout = -1, this.active.length)
      return;
    let t = Date.now() - this.lastMove.time;
    t < this.hoverTime ? this.hoverTimeout = setTimeout(this.checkHover, this.hoverTime - t) : this.startHover();
  }
  startHover() {
    clearTimeout(this.restartTimeout);
    let { view: t, lastMove: n } = this, r = t.docView.nearest(n.target);
    if (!r)
      return;
    let i, o = 1;
    if (r instanceof id)
      i = r.posAtStart;
    else {
      if (i = t.posAtCoords(n), i == null)
        return;
      let a = t.coordsAtPos(i);
      if (!a || n.y < a.top || n.y > a.bottom || n.x < a.left - t.defaultCharacterWidth || n.x > a.right + t.defaultCharacterWidth)
        return;
      let u = t.bidiSpans(t.state.doc.lineAt(i)).find((d) => d.from <= i && d.to >= i), c = u && u.dir == Jr.RTL ? -1 : 1;
      o = n.x < a.left ? -c : c;
    }
    let s = this.source(t, i, o);
    if (s != null && s.then) {
      let a = this.pending = { pos: i };
      s.then((u) => {
        this.pending == a && (this.pending = null, u && !(Array.isArray(u) && !u.length) && t.dispatch({ effects: this.setHover.of(Array.isArray(u) ? u : [u]) }));
      }, (u) => Ts(t.state, u, "hover tooltip"));
    } else s && !(Array.isArray(s) && !s.length) && t.dispatch({ effects: this.setHover.of(Array.isArray(s) ? s : [s]) });
  }
  get tooltip() {
    let t = this.view.plugin(G$), n = t ? t.manager.tooltips.findIndex((r) => r.create == uT.create) : -1;
    return n > -1 ? t.manager.tooltipViews[n] : null;
  }
  mousemove(t) {
    var n, r;
    this.lastMove = { x: t.clientX, y: t.clientY, target: t.target, time: Date.now() }, this.hoverTimeout < 0 && (this.hoverTimeout = setTimeout(this.checkHover, this.hoverTime));
    let { active: i, tooltip: o } = this;
    if (i.length && o && !Git(o.dom, t) || this.pending) {
      let { pos: s } = i[0] || this.pending, a = (r = (n = i[0]) === null || n === void 0 ? void 0 : n.end) !== null && r !== void 0 ? r : s;
      (s == a ? this.view.posAtCoords(this.lastMove) != s : !Yit(this.view, s, a, t.clientX, t.clientY)) && (this.view.dispatch({ effects: this.setHover.of([]) }), this.pending = null);
    }
  }
  mouseleave(t) {
    clearTimeout(this.hoverTimeout), this.hoverTimeout = -1;
    let { active: n } = this;
    if (n.length) {
      let { tooltip: r } = this;
      r && r.dom.contains(t.relatedTarget) ? this.watchTooltipLeave(r.dom) : this.view.dispatch({ effects: this.setHover.of([]) });
    }
  }
  watchTooltipLeave(t) {
    let n = (r) => {
      t.removeEventListener("mouseleave", n), this.active.length && !this.view.dom.contains(r.relatedTarget) && this.view.dispatch({ effects: this.setHover.of([]) });
    };
    t.addEventListener("mouseleave", n);
  }
  destroy() {
    clearTimeout(this.hoverTimeout), this.view.dom.removeEventListener("mouseleave", this.mouseleave), this.view.dom.removeEventListener("mousemove", this.mousemove);
  }
}
const hx = 4;
function Git(e, t) {
  let { left: n, right: r, top: i, bottom: o } = e.getBoundingClientRect(), s;
  if (s = e.querySelector(".cm-tooltip-arrow")) {
    let a = s.getBoundingClientRect();
    i = Math.min(a.top, i), o = Math.max(a.bottom, o);
  }
  return t.clientX >= n - hx && t.clientX <= r + hx && t.clientY >= i - hx && t.clientY <= o + hx;
}
function Yit(e, t, n, r, i, o) {
  let s = e.scrollDOM.getBoundingClientRect(), a = e.documentTop + e.documentPadding.top + e.contentHeight;
  if (s.left > r || s.right < r || s.top > i || Math.min(s.bottom, a) < i)
    return !1;
  let u = e.posAtCoords({ x: r, y: i }, !1);
  return u >= t && u <= n;
}
function Kit(e, t = {}) {
  let n = An.define(), r = wo.define({
    create() {
      return [];
    },
    update(i, o) {
      if (i.length && (t.hideOnChange && (o.docChanged || o.selection) ? i = [] : t.hideOn && (i = i.filter((s) => !t.hideOn(o, s))), o.docChanged)) {
        let s = [];
        for (let a of i) {
          let u = o.changes.mapPos(a.pos, -1, es.TrackDel);
          if (u != null) {
            let c = Object.assign(/* @__PURE__ */ Object.create(null), a);
            c.pos = u, c.end != null && (c.end = o.changes.mapPos(c.end)), s.push(c);
          }
        }
        i = s;
      }
      for (let s of o.effects)
        s.is(n) && (i = s.value), s.is(Jit) && (i = []);
      return i;
    },
    provide: (i) => dC.from(i)
  });
  return {
    active: r,
    extension: [
      r,
      Pi.define((i) => new qit(
        i,
        e,
        r,
        n,
        t.hoverTime || 300
        /* Hover.Time */
      )),
      Hit
    ]
  };
}
function NY(e, t) {
  let n = e.plugin(G$);
  if (!n)
    return null;
  let r = n.manager.tooltips.indexOf(t);
  return r < 0 ? null : n.manager.tooltipViews[r];
}
const Jit = /* @__PURE__ */ An.define(), x5 = /* @__PURE__ */ zt.define({
  combine(e) {
    let t, n;
    for (let r of e)
      t = t || r.topContainer, n = n || r.bottomContainer;
    return { topContainer: t, bottomContainer: n };
  }
});
function ib(e, t) {
  let n = e.plugin(MY), r = n ? n.specs.indexOf(t) : -1;
  return r > -1 ? n.panels[r] : null;
}
const MY = /* @__PURE__ */ Pi.fromClass(class {
  constructor(e) {
    this.input = e.state.facet(ob), this.specs = this.input.filter((n) => n), this.panels = this.specs.map((n) => n(e));
    let t = e.state.facet(x5);
    this.top = new mx(e, !0, t.topContainer), this.bottom = new mx(e, !1, t.bottomContainer), this.top.sync(this.panels.filter((n) => n.top)), this.bottom.sync(this.panels.filter((n) => !n.top));
    for (let n of this.panels)
      n.dom.classList.add("cm-panel"), n.mount && n.mount();
  }
  update(e) {
    let t = e.state.facet(x5);
    this.top.container != t.topContainer && (this.top.sync([]), this.top = new mx(e.view, !0, t.topContainer)), this.bottom.container != t.bottomContainer && (this.bottom.sync([]), this.bottom = new mx(e.view, !1, t.bottomContainer)), this.top.syncClasses(), this.bottom.syncClasses();
    let n = e.state.facet(ob);
    if (n != this.input) {
      let r = n.filter((u) => u), i = [], o = [], s = [], a = [];
      for (let u of r) {
        let c = this.specs.indexOf(u), d;
        c < 0 ? (d = u(e.view), a.push(d)) : (d = this.panels[c], d.update && d.update(e)), i.push(d), (d.top ? o : s).push(d);
      }
      this.specs = r, this.panels = i, this.top.sync(o), this.bottom.sync(s);
      for (let u of a)
        u.dom.classList.add("cm-panel"), u.mount && u.mount();
    } else
      for (let r of this.panels)
        r.update && r.update(e);
  }
  destroy() {
    this.top.sync([]), this.bottom.sync([]);
  }
}, {
  provide: (e) => Rt.scrollMargins.of((t) => {
    let n = t.plugin(e);
    return n && { top: n.top.scrollMargin(), bottom: n.bottom.scrollMargin() };
  })
});
class mx {
  constructor(t, n, r) {
    this.view = t, this.top = n, this.container = r, this.dom = void 0, this.classes = "", this.panels = [], this.syncClasses();
  }
  sync(t) {
    for (let n of this.panels)
      n.destroy && t.indexOf(n) < 0 && n.destroy();
    this.panels = t, this.syncDOM();
  }
  syncDOM() {
    if (this.panels.length == 0) {
      this.dom && (this.dom.remove(), this.dom = void 0);
      return;
    }
    if (!this.dom) {
      this.dom = document.createElement("div"), this.dom.className = this.top ? "cm-panels cm-panels-top" : "cm-panels cm-panels-bottom", this.dom.style[this.top ? "top" : "bottom"] = "0";
      let n = this.container || this.view.dom;
      n.insertBefore(this.dom, this.top ? n.firstChild : null);
    }
    let t = this.dom.firstChild;
    for (let n of this.panels)
      if (n.dom.parentNode == this.dom) {
        for (; t != n.dom; )
          t = D5(t);
        t = t.nextSibling;
      } else
        this.dom.insertBefore(n.dom, t);
    for (; t; )
      t = D5(t);
  }
  scrollMargin() {
    return !this.dom || this.container ? 0 : Math.max(0, this.top ? this.dom.getBoundingClientRect().bottom - Math.max(0, this.view.scrollDOM.getBoundingClientRect().top) : Math.min(innerHeight, this.view.scrollDOM.getBoundingClientRect().bottom) - this.dom.getBoundingClientRect().top);
  }
  syncClasses() {
    if (!(!this.container || this.classes == this.view.themeClasses)) {
      for (let t of this.classes.split(" "))
        t && this.container.classList.remove(t);
      for (let t of (this.classes = this.view.themeClasses).split(" "))
        t && this.container.classList.add(t);
    }
  }
}
function D5(e) {
  let t = e.nextSibling;
  return e.remove(), t;
}
const ob = /* @__PURE__ */ zt.define({
  enables: MY
});
class dc extends Qp {
  /**
  @internal
  */
  compare(t) {
    return this == t || this.constructor == t.constructor && this.eq(t);
  }
  /**
  Compare this marker to another marker of the same type.
  */
  eq(t) {
    return !1;
  }
  /**
  Called if the marker has a `toDOM` method and its representation
  was removed from a gutter.
  */
  destroy(t) {
  }
}
dc.prototype.elementClass = "";
dc.prototype.toDOM = void 0;
dc.prototype.mapMode = es.TrackBefore;
dc.prototype.startSide = dc.prototype.endSide = -1;
dc.prototype.point = !0;
const dD = /* @__PURE__ */ zt.define(), Xit = /* @__PURE__ */ zt.define(), Qit = {
  class: "",
  renderEmptyElements: !1,
  elementStyle: "",
  markers: () => ir.empty,
  lineMarker: () => null,
  widgetMarker: () => null,
  lineMarkerChange: null,
  initialSpacer: null,
  updateSpacer: null,
  domEventHandlers: {}
}, D0 = /* @__PURE__ */ zt.define();
function Zit(e) {
  return [RY(), D0.of(Object.assign(Object.assign({}, Qit), e))];
}
const C5 = /* @__PURE__ */ zt.define({
  combine: (e) => e.some((t) => t)
});
function RY(e) {
  return [
    eot
  ];
}
const eot = /* @__PURE__ */ Pi.fromClass(class {
  constructor(e) {
    this.view = e, this.prevViewport = e.viewport, this.dom = document.createElement("div"), this.dom.className = "cm-gutters", this.dom.setAttribute("aria-hidden", "true"), this.dom.style.minHeight = this.view.contentHeight / this.view.scaleY + "px", this.gutters = e.state.facet(D0).map((t) => new T5(e, t));
    for (let t of this.gutters)
      this.dom.appendChild(t.dom);
    this.fixed = !e.state.facet(C5), this.fixed && (this.dom.style.position = "sticky"), this.syncGutters(!1), e.scrollDOM.insertBefore(this.dom, e.contentDOM);
  }
  update(e) {
    if (this.updateGutters(e)) {
      let t = this.prevViewport, n = e.view.viewport, r = Math.min(t.to, n.to) - Math.max(t.from, n.from);
      this.syncGutters(r < (n.to - n.from) * 0.8);
    }
    e.geometryChanged && (this.dom.style.minHeight = this.view.contentHeight / this.view.scaleY + "px"), this.view.state.facet(C5) != !this.fixed && (this.fixed = !this.fixed, this.dom.style.position = this.fixed ? "sticky" : ""), this.prevViewport = e.view.viewport;
  }
  syncGutters(e) {
    let t = this.dom.nextSibling;
    e && this.dom.remove();
    let n = ir.iter(this.view.state.facet(dD), this.view.viewport.from), r = [], i = this.gutters.map((o) => new tot(o, this.view.viewport, -this.view.documentPadding.top));
    for (let o of this.view.viewportLineBlocks)
      if (r.length && (r = []), Array.isArray(o.type)) {
        let s = !0;
        for (let a of o.type)
          if (a.type == os.Text && s) {
            Jk(n, r, a.from);
            for (let u of i)
              u.line(this.view, a, r);
            s = !1;
          } else if (a.widget)
            for (let u of i)
              u.widget(this.view, a);
      } else if (o.type == os.Text) {
        Jk(n, r, o.from);
        for (let s of i)
          s.line(this.view, o, r);
      } else if (o.widget)
        for (let s of i)
          s.widget(this.view, o);
    for (let o of i)
      o.finish();
    e && this.view.scrollDOM.insertBefore(this.dom, t);
  }
  updateGutters(e) {
    let t = e.startState.facet(D0), n = e.state.facet(D0), r = e.docChanged || e.heightChanged || e.viewportChanged || !ir.eq(e.startState.facet(dD), e.state.facet(dD), e.view.viewport.from, e.view.viewport.to);
    if (t == n)
      for (let i of this.gutters)
        i.update(e) && (r = !0);
    else {
      r = !0;
      let i = [];
      for (let o of n) {
        let s = t.indexOf(o);
        s < 0 ? i.push(new T5(this.view, o)) : (this.gutters[s].update(e), i.push(this.gutters[s]));
      }
      for (let o of this.gutters)
        o.dom.remove(), i.indexOf(o) < 0 && o.destroy();
      for (let o of i)
        this.dom.appendChild(o.dom);
      this.gutters = i;
    }
    return r;
  }
  destroy() {
    for (let e of this.gutters)
      e.destroy();
    this.dom.remove();
  }
}, {
  provide: (e) => Rt.scrollMargins.of((t) => {
    let n = t.plugin(e);
    return !n || n.gutters.length == 0 || !n.fixed ? null : t.textDirection == Jr.LTR ? { left: n.dom.offsetWidth * t.scaleX } : { right: n.dom.offsetWidth * t.scaleX };
  })
});
function E5(e) {
  return Array.isArray(e) ? e : [e];
}
function Jk(e, t, n) {
  for (; e.value && e.from <= n; )
    e.from == n && t.push(e.value), e.next();
}
class tot {
  constructor(t, n, r) {
    this.gutter = t, this.height = r, this.i = 0, this.cursor = ir.iter(t.markers, n.from);
  }
  addElement(t, n, r) {
    let { gutter: i } = this, o = (n.top - this.height) / t.scaleY, s = n.height / t.scaleY;
    if (this.i == i.elements.length) {
      let a = new _Y(t, s, o, r);
      i.elements.push(a), i.dom.appendChild(a.dom);
    } else
      i.elements[this.i].update(t, s, o, r);
    this.height = n.bottom, this.i++;
  }
  line(t, n, r) {
    let i = [];
    Jk(this.cursor, i, n.from), r.length && (i = i.concat(r));
    let o = this.gutter.config.lineMarker(t, n, i);
    o && i.unshift(o);
    let s = this.gutter;
    i.length == 0 && !s.config.renderEmptyElements || this.addElement(t, n, i);
  }
  widget(t, n) {
    let r = this.gutter.config.widgetMarker(t, n.widget, n), i = r ? [r] : null;
    for (let o of t.state.facet(Xit)) {
      let s = o(t, n.widget, n);
      s && (i || (i = [])).push(s);
    }
    i && this.addElement(t, n, i);
  }
  finish() {
    let t = this.gutter;
    for (; t.elements.length > this.i; ) {
      let n = t.elements.pop();
      t.dom.removeChild(n.dom), n.destroy();
    }
  }
}
class T5 {
  constructor(t, n) {
    this.view = t, this.config = n, this.elements = [], this.spacer = null, this.dom = document.createElement("div"), this.dom.className = "cm-gutter" + (this.config.class ? " " + this.config.class : "");
    for (let r in n.domEventHandlers)
      this.dom.addEventListener(r, (i) => {
        let o = i.target, s;
        if (o != this.dom && this.dom.contains(o)) {
          for (; o.parentNode != this.dom; )
            o = o.parentNode;
          let u = o.getBoundingClientRect();
          s = (u.top + u.bottom) / 2;
        } else
          s = i.clientY;
        let a = t.lineBlockAtHeight(s - t.documentTop);
        n.domEventHandlers[r](t, a, i) && i.preventDefault();
      });
    this.markers = E5(n.markers(t)), n.initialSpacer && (this.spacer = new _Y(t, 0, 0, [n.initialSpacer(t)]), this.dom.appendChild(this.spacer.dom), this.spacer.dom.style.cssText += "visibility: hidden; pointer-events: none");
  }
  update(t) {
    let n = this.markers;
    if (this.markers = E5(this.config.markers(t.view)), this.spacer && this.config.updateSpacer) {
      let i = this.config.updateSpacer(this.spacer.markers[0], t);
      i != this.spacer.markers[0] && this.spacer.update(t.view, 0, 0, [i]);
    }
    let r = t.view.viewport;
    return !ir.eq(this.markers, n, r.from, r.to) || (this.config.lineMarkerChange ? this.config.lineMarkerChange(t) : !1);
  }
  destroy() {
    for (let t of this.elements)
      t.destroy();
  }
}
class _Y {
  constructor(t, n, r, i) {
    this.height = -1, this.above = 0, this.markers = [], this.dom = document.createElement("div"), this.dom.className = "cm-gutterElement", this.update(t, n, r, i);
  }
  update(t, n, r, i) {
    this.height != n && (this.height = n, this.dom.style.height = n + "px"), this.above != r && (this.dom.style.marginTop = (this.above = r) ? r + "px" : ""), not(this.markers, i) || this.setMarkers(t, i);
  }
  setMarkers(t, n) {
    let r = "cm-gutterElement", i = this.dom.firstChild;
    for (let o = 0, s = 0; ; ) {
      let a = s, u = o < n.length ? n[o++] : null, c = !1;
      if (u) {
        let d = u.elementClass;
        d && (r += " " + d);
        for (let f = s; f < this.markers.length; f++)
          if (this.markers[f].compare(u)) {
            a = f, c = !0;
            break;
          }
      } else
        a = this.markers.length;
      for (; s < a; ) {
        let d = this.markers[s++];
        if (d.toDOM) {
          d.destroy(i);
          let f = i.nextSibling;
          i.remove(), i = f;
        }
      }
      if (!u)
        break;
      u.toDOM && (c ? i = i.nextSibling : this.dom.insertBefore(u.toDOM(t), i)), c && s++;
    }
    this.dom.className = r, this.markers = n;
  }
  destroy() {
    this.setMarkers(null, []);
  }
}
function not(e, t) {
  if (e.length != t.length)
    return !1;
  for (let n = 0; n < e.length; n++)
    if (!e[n].compare(t[n]))
      return !1;
  return !0;
}
const rot = /* @__PURE__ */ zt.define(), iot = /* @__PURE__ */ zt.define(), Rh = /* @__PURE__ */ zt.define({
  combine(e) {
    return wu(e, { formatNumber: String, domEventHandlers: {} }, {
      domEventHandlers(t, n) {
        let r = Object.assign({}, t);
        for (let i in n) {
          let o = r[i], s = n[i];
          r[i] = o ? (a, u, c) => o(a, u, c) || s(a, u, c) : s;
        }
        return r;
      }
    });
  }
});
class Fw extends dc {
  constructor(t) {
    super(), this.number = t;
  }
  eq(t) {
    return this.number == t.number;
  }
  toDOM() {
    return document.createTextNode(this.number);
  }
}
function $w(e, t) {
  return e.state.facet(Rh).formatNumber(t, e.state);
}
const oot = /* @__PURE__ */ D0.compute([Rh], (e) => ({
  class: "cm-lineNumbers",
  renderEmptyElements: !1,
  markers(t) {
    return t.state.facet(rot);
  },
  lineMarker(t, n, r) {
    return r.some((i) => i.toDOM) ? null : new Fw($w(t, t.state.doc.lineAt(n.from).number));
  },
  widgetMarker: (t, n, r) => {
    for (let i of t.state.facet(iot)) {
      let o = i(t, n, r);
      if (o)
        return o;
    }
    return null;
  },
  lineMarkerChange: (t) => t.startState.facet(Rh) != t.state.facet(Rh),
  initialSpacer(t) {
    return new Fw($w(t, S5(t.state.doc.lines)));
  },
  updateSpacer(t, n) {
    let r = $w(n.view, S5(n.view.state.doc.lines));
    return r == t.number ? t : new Fw(r);
  },
  domEventHandlers: e.facet(Rh).domEventHandlers
}));
function sot(e = {}) {
  return [
    Rh.of(e),
    RY(),
    oot
  ];
}
function S5(e) {
  let t = 9;
  for (; t < e; )
    t = t * 10 + 9;
  return t;
}
const aot = /* @__PURE__ */ new class extends dc {
  constructor() {
    super(...arguments), this.elementClass = "cm-activeLineGutter";
  }
}(), lot = /* @__PURE__ */ dD.compute(["selection"], (e) => {
  let t = [], n = -1;
  for (let r of e.selection.ranges) {
    let i = e.doc.lineAt(r.head).from;
    i > n && (n = i, t.push(aot.range(i)));
  }
  return ir.of(t);
});
function uot() {
  return lot;
}
const LY = 1024;
let cot = 0;
class Nw {
  constructor(t, n) {
    this.from = t, this.to = n;
  }
}
class jn {
  /**
  Create a new node prop type.
  */
  constructor(t = {}) {
    this.id = cot++, this.perNode = !!t.perNode, this.deserialize = t.deserialize || (() => {
      throw new Error("This node type doesn't define a deserialize function");
    });
  }
  /**
  This is meant to be used with
  [`NodeSet.extend`](#common.NodeSet.extend) or
  [`LRParser.configure`](#lr.ParserConfig.props) to compute
  prop values for each node type in the set. Takes a [match
  object](#common.NodeType^match) or function that returns undefined
  if the node type doesn't get this prop, and the prop's value if
  it does.
  */
  add(t) {
    if (this.perNode)
      throw new RangeError("Can't add per-node props to node types");
    return typeof t != "function" && (t = Ns.match(t)), (n) => {
      let r = t(n);
      return r === void 0 ? null : [this, r];
    };
  }
}
jn.closedBy = new jn({ deserialize: (e) => e.split(" ") });
jn.openedBy = new jn({ deserialize: (e) => e.split(" ") });
jn.group = new jn({ deserialize: (e) => e.split(" ") });
jn.isolate = new jn({ deserialize: (e) => {
  if (e && e != "rtl" && e != "ltr" && e != "auto")
    throw new RangeError("Invalid value for isolate: " + e);
  return e || "auto";
} });
jn.contextHash = new jn({ perNode: !0 });
jn.lookAhead = new jn({ perNode: !0 });
jn.mounted = new jn({ perNode: !0 });
class pC {
  constructor(t, n, r) {
    this.tree = t, this.overlay = n, this.parser = r;
  }
  /**
  @internal
  */
  static get(t) {
    return t && t.props && t.props[jn.mounted.id];
  }
}
const dot = /* @__PURE__ */ Object.create(null);
class Ns {
  /**
  @internal
  */
  constructor(t, n, r, i = 0) {
    this.name = t, this.props = n, this.id = r, this.flags = i;
  }
  /**
  Define a node type.
  */
  static define(t) {
    let n = t.props && t.props.length ? /* @__PURE__ */ Object.create(null) : dot, r = (t.top ? 1 : 0) | (t.skipped ? 2 : 0) | (t.error ? 4 : 0) | (t.name == null ? 8 : 0), i = new Ns(t.name || "", n, t.id, r);
    if (t.props) {
      for (let o of t.props)
        if (Array.isArray(o) || (o = o(i)), o) {
          if (o[0].perNode)
            throw new RangeError("Can't store a per-node prop on a node type");
          n[o[0].id] = o[1];
        }
    }
    return i;
  }
  /**
  Retrieves a node prop for this type. Will return `undefined` if
  the prop isn't present on this node.
  */
  prop(t) {
    return this.props[t.id];
  }
  /**
  True when this is the top node of a grammar.
  */
  get isTop() {
    return (this.flags & 1) > 0;
  }
  /**
  True when this node is produced by a skip rule.
  */
  get isSkipped() {
    return (this.flags & 2) > 0;
  }
  /**
  Indicates whether this is an error node.
  */
  get isError() {
    return (this.flags & 4) > 0;
  }
  /**
  When true, this node type doesn't correspond to a user-declared
  named node, for example because it is used to cache repetition.
  */
  get isAnonymous() {
    return (this.flags & 8) > 0;
  }
  /**
  Returns true when this node's name or one of its
  [groups](#common.NodeProp^group) matches the given string.
  */
  is(t) {
    if (typeof t == "string") {
      if (this.name == t)
        return !0;
      let n = this.prop(jn.group);
      return n ? n.indexOf(t) > -1 : !1;
    }
    return this.id == t;
  }
  /**
  Create a function from node types to arbitrary values by
  specifying an object whose property names are node or
  [group](#common.NodeProp^group) names. Often useful with
  [`NodeProp.add`](#common.NodeProp.add). You can put multiple
  names, separated by spaces, in a single property name to map
  multiple node names to a single value.
  */
  static match(t) {
    let n = /* @__PURE__ */ Object.create(null);
    for (let r in t)
      for (let i of r.split(" "))
        n[i] = t[r];
    return (r) => {
      for (let i = r.prop(jn.group), o = -1; o < (i ? i.length : 0); o++) {
        let s = n[o < 0 ? r.name : i[o]];
        if (s)
          return s;
      }
    };
  }
}
Ns.none = new Ns(
  "",
  /* @__PURE__ */ Object.create(null),
  0,
  8
  /* NodeFlag.Anonymous */
);
class K$ {
  /**
  Create a set with the given types. The `id` property of each
  type should correspond to its position within the array.
  */
  constructor(t) {
    this.types = t;
    for (let n = 0; n < t.length; n++)
      if (t[n].id != n)
        throw new RangeError("Node type ids should correspond to array positions when creating a node set");
  }
  /**
  Create a copy of this set with some node properties added. The
  arguments to this method can be created with
  [`NodeProp.add`](#common.NodeProp.add).
  */
  extend(...t) {
    let n = [];
    for (let r of this.types) {
      let i = null;
      for (let o of t) {
        let s = o(r);
        s && (i || (i = Object.assign({}, r.props)), i[s[0].id] = s[1]);
      }
      n.push(i ? new Ns(r.name, i, r.id, r.flags) : r);
    }
    return new K$(n);
  }
}
const gx = /* @__PURE__ */ new WeakMap(), A5 = /* @__PURE__ */ new WeakMap();
var no;
(function(e) {
  e[e.ExcludeBuffers = 1] = "ExcludeBuffers", e[e.IncludeAnonymous = 2] = "IncludeAnonymous", e[e.IgnoreMounts = 4] = "IgnoreMounts", e[e.IgnoreOverlays = 8] = "IgnoreOverlays";
})(no || (no = {}));
class Ni {
  /**
  Construct a new tree. See also [`Tree.build`](#common.Tree^build).
  */
  constructor(t, n, r, i, o) {
    if (this.type = t, this.children = n, this.positions = r, this.length = i, this.props = null, o && o.length) {
      this.props = /* @__PURE__ */ Object.create(null);
      for (let [s, a] of o)
        this.props[typeof s == "number" ? s : s.id] = a;
    }
  }
  /**
  @internal
  */
  toString() {
    let t = pC.get(this);
    if (t && !t.overlay)
      return t.tree.toString();
    let n = "";
    for (let r of this.children) {
      let i = r.toString();
      i && (n && (n += ","), n += i);
    }
    return this.type.name ? (/\W/.test(this.type.name) && !this.type.isError ? JSON.stringify(this.type.name) : this.type.name) + (n.length ? "(" + n + ")" : "") : n;
  }
  /**
  Get a [tree cursor](#common.TreeCursor) positioned at the top of
  the tree. Mode can be used to [control](#common.IterMode) which
  nodes the cursor visits.
  */
  cursor(t = 0) {
    return new Qk(this.topNode, t);
  }
  /**
  Get a [tree cursor](#common.TreeCursor) pointing into this tree
  at the given position and side (see
  [`moveTo`](#common.TreeCursor.moveTo).
  */
  cursorAt(t, n = 0, r = 0) {
    let i = gx.get(this) || this.topNode, o = new Qk(i);
    return o.moveTo(t, n), gx.set(this, o._tree), o;
  }
  /**
  Get a [syntax node](#common.SyntaxNode) object for the top of the
  tree.
  */
  get topNode() {
    return new La(this, 0, 0, null);
  }
  /**
  Get the [syntax node](#common.SyntaxNode) at the given position.
  If `side` is -1, this will move into nodes that end at the
  position. If 1, it'll move into nodes that start at the
  position. With 0, it'll only enter nodes that cover the position
  from both sides.
  
  Note that this will not enter
  [overlays](#common.MountedTree.overlay), and you often want
  [`resolveInner`](#common.Tree.resolveInner) instead.
  */
  resolve(t, n = 0) {
    let r = sb(gx.get(this) || this.topNode, t, n, !1);
    return gx.set(this, r), r;
  }
  /**
  Like [`resolve`](#common.Tree.resolve), but will enter
  [overlaid](#common.MountedTree.overlay) nodes, producing a syntax node
  pointing into the innermost overlaid tree at the given position
  (with parent links going through all parent structure, including
  the host trees).
  */
  resolveInner(t, n = 0) {
    let r = sb(A5.get(this) || this.topNode, t, n, !0);
    return A5.set(this, r), r;
  }
  /**
  In some situations, it can be useful to iterate through all
  nodes around a position, including those in overlays that don't
  directly cover the position. This method gives you an iterator
  that will produce all nodes, from small to big, around the given
  position.
  */
  resolveStack(t, n = 0) {
    return hot(this, t, n);
  }
  /**
  Iterate over the tree and its children, calling `enter` for any
  node that touches the `from`/`to` region (if given) before
  running over such a node's children, and `leave` (if given) when
  leaving the node. When `enter` returns `false`, that node will
  not have its children iterated over (or `leave` called).
  */
  iterate(t) {
    let { enter: n, leave: r, from: i = 0, to: o = this.length } = t, s = t.mode || 0, a = (s & no.IncludeAnonymous) > 0;
    for (let u = this.cursor(s | no.IncludeAnonymous); ; ) {
      let c = !1;
      if (u.from <= o && u.to >= i && (!a && u.type.isAnonymous || n(u) !== !1)) {
        if (u.firstChild())
          continue;
        c = !0;
      }
      for (; c && r && (a || !u.type.isAnonymous) && r(u), !u.nextSibling(); ) {
        if (!u.parent())
          return;
        c = !0;
      }
    }
  }
  /**
  Get the value of the given [node prop](#common.NodeProp) for this
  node. Works with both per-node and per-type props.
  */
  prop(t) {
    return t.perNode ? this.props ? this.props[t.id] : void 0 : this.type.prop(t);
  }
  /**
  Returns the node's [per-node props](#common.NodeProp.perNode) in a
  format that can be passed to the [`Tree`](#common.Tree)
  constructor.
  */
  get propValues() {
    let t = [];
    if (this.props)
      for (let n in this.props)
        t.push([+n, this.props[n]]);
    return t;
  }
  /**
  Balance the direct children of this tree, producing a copy of
  which may have children grouped into subtrees with type
  [`NodeType.none`](#common.NodeType^none).
  */
  balance(t = {}) {
    return this.children.length <= 8 ? this : Q$(Ns.none, this.children, this.positions, 0, this.children.length, 0, this.length, (n, r, i) => new Ni(this.type, n, r, i, this.propValues), t.makeTree || ((n, r, i) => new Ni(Ns.none, n, r, i)));
  }
  /**
  Build a tree from a postfix-ordered buffer of node information,
  or a cursor over such a buffer.
  */
  static build(t) {
    return mot(t);
  }
}
Ni.empty = new Ni(Ns.none, [], [], 0);
class J$ {
  constructor(t, n) {
    this.buffer = t, this.index = n;
  }
  get id() {
    return this.buffer[this.index - 4];
  }
  get start() {
    return this.buffer[this.index - 3];
  }
  get end() {
    return this.buffer[this.index - 2];
  }
  get size() {
    return this.buffer[this.index - 1];
  }
  get pos() {
    return this.index;
  }
  next() {
    this.index -= 4;
  }
  fork() {
    return new J$(this.buffer, this.index);
  }
}
class gd {
  /**
  Create a tree buffer.
  */
  constructor(t, n, r) {
    this.buffer = t, this.length = n, this.set = r;
  }
  /**
  @internal
  */
  get type() {
    return Ns.none;
  }
  /**
  @internal
  */
  toString() {
    let t = [];
    for (let n = 0; n < this.buffer.length; )
      t.push(this.childString(n)), n = this.buffer[n + 3];
    return t.join(",");
  }
  /**
  @internal
  */
  childString(t) {
    let n = this.buffer[t], r = this.buffer[t + 3], i = this.set.types[n], o = i.name;
    if (/\W/.test(o) && !i.isError && (o = JSON.stringify(o)), t += 4, r == t)
      return o;
    let s = [];
    for (; t < r; )
      s.push(this.childString(t)), t = this.buffer[t + 3];
    return o + "(" + s.join(",") + ")";
  }
  /**
  @internal
  */
  findChild(t, n, r, i, o) {
    let { buffer: s } = this, a = -1;
    for (let u = t; u != n && !(BY(o, i, s[u + 1], s[u + 2]) && (a = u, r > 0)); u = s[u + 3])
      ;
    return a;
  }
  /**
  @internal
  */
  slice(t, n, r) {
    let i = this.buffer, o = new Uint16Array(n - t), s = 0;
    for (let a = t, u = 0; a < n; ) {
      o[u++] = i[a++], o[u++] = i[a++] - r;
      let c = o[u++] = i[a++] - r;
      o[u++] = i[a++] - t, s = Math.max(s, c);
    }
    return new gd(o, s, this.set);
  }
}
function BY(e, t, n, r) {
  switch (e) {
    case -2:
      return n < t;
    case -1:
      return r >= t && n < t;
    case 0:
      return n < t && r > t;
    case 1:
      return n <= t && r > t;
    case 2:
      return r > t;
    case 4:
      return !0;
  }
}
function sb(e, t, n, r) {
  for (var i; e.from == e.to || (n < 1 ? e.from >= t : e.from > t) || (n > -1 ? e.to <= t : e.to < t); ) {
    let s = !r && e instanceof La && e.index < 0 ? null : e.parent;
    if (!s)
      return e;
    e = s;
  }
  let o = r ? 0 : no.IgnoreOverlays;
  if (r)
    for (let s = e, a = s.parent; a; s = a, a = s.parent)
      s instanceof La && s.index < 0 && ((i = a.enter(t, n, o)) === null || i === void 0 ? void 0 : i.from) != s.from && (e = a);
  for (; ; ) {
    let s = e.enter(t, n, o);
    if (!s)
      return e;
    e = s;
  }
}
class jY {
  cursor(t = 0) {
    return new Qk(this, t);
  }
  getChild(t, n = null, r = null) {
    let i = w5(this, t, n, r);
    return i.length ? i[0] : null;
  }
  getChildren(t, n = null, r = null) {
    return w5(this, t, n, r);
  }
  resolve(t, n = 0) {
    return sb(this, t, n, !1);
  }
  resolveInner(t, n = 0) {
    return sb(this, t, n, !0);
  }
  matchContext(t) {
    return Xk(this.parent, t);
  }
  enterUnfinishedNodesBefore(t) {
    let n = this.childBefore(t), r = this;
    for (; n; ) {
      let i = n.lastChild;
      if (!i || i.to != n.to)
        break;
      i.type.isError && i.from == i.to ? (r = n, n = i.prevSibling) : n = i;
    }
    return r;
  }
  get node() {
    return this;
  }
  get next() {
    return this.parent;
  }
}
class La extends jY {
  constructor(t, n, r, i) {
    super(), this._tree = t, this.from = n, this.index = r, this._parent = i;
  }
  get type() {
    return this._tree.type;
  }
  get name() {
    return this._tree.type.name;
  }
  get to() {
    return this.from + this._tree.length;
  }
  nextChild(t, n, r, i, o = 0) {
    for (let s = this; ; ) {
      for (let { children: a, positions: u } = s._tree, c = n > 0 ? a.length : -1; t != c; t += n) {
        let d = a[t], f = u[t] + s.from;
        if (BY(i, r, f, f + d.length)) {
          if (d instanceof gd) {
            if (o & no.ExcludeBuffers)
              continue;
            let h = d.findChild(0, d.buffer.length, n, r - f, i);
            if (h > -1)
              return new sd(new pot(s, d, t, f), null, h);
          } else if (o & no.IncludeAnonymous || !d.type.isAnonymous || X$(d)) {
            let h;
            if (!(o & no.IgnoreMounts) && (h = pC.get(d)) && !h.overlay)
              return new La(h.tree, f, t, s);
            let m = new La(d, f, t, s);
            return o & no.IncludeAnonymous || !m.type.isAnonymous ? m : m.nextChild(n < 0 ? d.children.length - 1 : 0, n, r, i);
          }
        }
      }
      if (o & no.IncludeAnonymous || !s.type.isAnonymous || (s.index >= 0 ? t = s.index + n : t = n < 0 ? -1 : s._parent._tree.children.length, s = s._parent, !s))
        return null;
    }
  }
  get firstChild() {
    return this.nextChild(
      0,
      1,
      0,
      4
      /* Side.DontCare */
    );
  }
  get lastChild() {
    return this.nextChild(
      this._tree.children.length - 1,
      -1,
      0,
      4
      /* Side.DontCare */
    );
  }
  childAfter(t) {
    return this.nextChild(
      0,
      1,
      t,
      2
      /* Side.After */
    );
  }
  childBefore(t) {
    return this.nextChild(
      this._tree.children.length - 1,
      -1,
      t,
      -2
      /* Side.Before */
    );
  }
  enter(t, n, r = 0) {
    let i;
    if (!(r & no.IgnoreOverlays) && (i = pC.get(this._tree)) && i.overlay) {
      let o = t - this.from;
      for (let { from: s, to: a } of i.overlay)
        if ((n > 0 ? s <= o : s < o) && (n < 0 ? a >= o : a > o))
          return new La(i.tree, i.overlay[0].from + this.from, -1, this);
    }
    return this.nextChild(0, 1, t, n, r);
  }
  nextSignificantParent() {
    let t = this;
    for (; t.type.isAnonymous && t._parent; )
      t = t._parent;
    return t;
  }
  get parent() {
    return this._parent ? this._parent.nextSignificantParent() : null;
  }
  get nextSibling() {
    return this._parent && this.index >= 0 ? this._parent.nextChild(
      this.index + 1,
      1,
      0,
      4
      /* Side.DontCare */
    ) : null;
  }
  get prevSibling() {
    return this._parent && this.index >= 0 ? this._parent.nextChild(
      this.index - 1,
      -1,
      0,
      4
      /* Side.DontCare */
    ) : null;
  }
  get tree() {
    return this._tree;
  }
  toTree() {
    return this._tree;
  }
  /**
  @internal
  */
  toString() {
    return this._tree.toString();
  }
}
function w5(e, t, n, r) {
  let i = e.cursor(), o = [];
  if (!i.firstChild())
    return o;
  if (n != null) {
    for (let s = !1; !s; )
      if (s = i.type.is(n), !i.nextSibling())
        return o;
  }
  for (; ; ) {
    if (r != null && i.type.is(r))
      return o;
    if (i.type.is(t) && o.push(i.node), !i.nextSibling())
      return r == null ? o : [];
  }
}
function Xk(e, t, n = t.length - 1) {
  for (let r = e; n >= 0; r = r.parent) {
    if (!r)
      return !1;
    if (!r.type.isAnonymous) {
      if (t[n] && t[n] != r.name)
        return !1;
      n--;
    }
  }
  return !0;
}
class pot {
  constructor(t, n, r, i) {
    this.parent = t, this.buffer = n, this.index = r, this.start = i;
  }
}
class sd extends jY {
  get name() {
    return this.type.name;
  }
  get from() {
    return this.context.start + this.context.buffer.buffer[this.index + 1];
  }
  get to() {
    return this.context.start + this.context.buffer.buffer[this.index + 2];
  }
  constructor(t, n, r) {
    super(), this.context = t, this._parent = n, this.index = r, this.type = t.buffer.set.types[t.buffer.buffer[r]];
  }
  child(t, n, r) {
    let { buffer: i } = this.context, o = i.findChild(this.index + 4, i.buffer[this.index + 3], t, n - this.context.start, r);
    return o < 0 ? null : new sd(this.context, this, o);
  }
  get firstChild() {
    return this.child(
      1,
      0,
      4
      /* Side.DontCare */
    );
  }
  get lastChild() {
    return this.child(
      -1,
      0,
      4
      /* Side.DontCare */
    );
  }
  childAfter(t) {
    return this.child(
      1,
      t,
      2
      /* Side.After */
    );
  }
  childBefore(t) {
    return this.child(
      -1,
      t,
      -2
      /* Side.Before */
    );
  }
  enter(t, n, r = 0) {
    if (r & no.ExcludeBuffers)
      return null;
    let { buffer: i } = this.context, o = i.findChild(this.index + 4, i.buffer[this.index + 3], n > 0 ? 1 : -1, t - this.context.start, n);
    return o < 0 ? null : new sd(this.context, this, o);
  }
  get parent() {
    return this._parent || this.context.parent.nextSignificantParent();
  }
  externalSibling(t) {
    return this._parent ? null : this.context.parent.nextChild(
      this.context.index + t,
      t,
      0,
      4
      /* Side.DontCare */
    );
  }
  get nextSibling() {
    let { buffer: t } = this.context, n = t.buffer[this.index + 3];
    return n < (this._parent ? t.buffer[this._parent.index + 3] : t.buffer.length) ? new sd(this.context, this._parent, n) : this.externalSibling(1);
  }
  get prevSibling() {
    let { buffer: t } = this.context, n = this._parent ? this._parent.index + 4 : 0;
    return this.index == n ? this.externalSibling(-1) : new sd(this.context, this._parent, t.findChild(
      n,
      this.index,
      -1,
      0,
      4
      /* Side.DontCare */
    ));
  }
  get tree() {
    return null;
  }
  toTree() {
    let t = [], n = [], { buffer: r } = this.context, i = this.index + 4, o = r.buffer[this.index + 3];
    if (o > i) {
      let s = r.buffer[this.index + 1];
      t.push(r.slice(i, o, s)), n.push(0);
    }
    return new Ni(this.type, t, n, this.to - this.from);
  }
  /**
  @internal
  */
  toString() {
    return this.context.buffer.childString(this.index);
  }
}
function VY(e) {
  if (!e.length)
    return null;
  let t = 0, n = e[0];
  for (let o = 1; o < e.length; o++) {
    let s = e[o];
    (s.from > n.from || s.to < n.to) && (n = s, t = o);
  }
  let r = n instanceof La && n.index < 0 ? null : n.parent, i = e.slice();
  return r ? i[t] = r : i.splice(t, 1), new fot(i, n);
}
class fot {
  constructor(t, n) {
    this.heads = t, this.node = n;
  }
  get next() {
    return VY(this.heads);
  }
}
function hot(e, t, n) {
  let r = e.resolveInner(t, n), i = null;
  for (let o = r instanceof La ? r : r.context.parent; o; o = o.parent)
    if (o.index < 0) {
      let s = o.parent;
      (i || (i = [r])).push(s.resolve(t, n)), o = s;
    } else {
      let s = pC.get(o.tree);
      if (s && s.overlay && s.overlay[0].from <= t && s.overlay[s.overlay.length - 1].to >= t) {
        let a = new La(s.tree, s.overlay[0].from + o.from, -1, o);
        (i || (i = [r])).push(sb(a, t, n, !1));
      }
    }
  return i ? VY(i) : r;
}
class Qk {
  /**
  Shorthand for `.type.name`.
  */
  get name() {
    return this.type.name;
  }
  /**
  @internal
  */
  constructor(t, n = 0) {
    if (this.mode = n, this.buffer = null, this.stack = [], this.index = 0, this.bufferNode = null, t instanceof La)
      this.yieldNode(t);
    else {
      this._tree = t.context.parent, this.buffer = t.context;
      for (let r = t._parent; r; r = r._parent)
        this.stack.unshift(r.index);
      this.bufferNode = t, this.yieldBuf(t.index);
    }
  }
  yieldNode(t) {
    return t ? (this._tree = t, this.type = t.type, this.from = t.from, this.to = t.to, !0) : !1;
  }
  yieldBuf(t, n) {
    this.index = t;
    let { start: r, buffer: i } = this.buffer;
    return this.type = n || i.set.types[i.buffer[t]], this.from = r + i.buffer[t + 1], this.to = r + i.buffer[t + 2], !0;
  }
  /**
  @internal
  */
  yield(t) {
    return t ? t instanceof La ? (this.buffer = null, this.yieldNode(t)) : (this.buffer = t.context, this.yieldBuf(t.index, t.type)) : !1;
  }
  /**
  @internal
  */
  toString() {
    return this.buffer ? this.buffer.buffer.childString(this.index) : this._tree.toString();
  }
  /**
  @internal
  */
  enterChild(t, n, r) {
    if (!this.buffer)
      return this.yield(this._tree.nextChild(t < 0 ? this._tree._tree.children.length - 1 : 0, t, n, r, this.mode));
    let { buffer: i } = this.buffer, o = i.findChild(this.index + 4, i.buffer[this.index + 3], t, n - this.buffer.start, r);
    return o < 0 ? !1 : (this.stack.push(this.index), this.yieldBuf(o));
  }
  /**
  Move the cursor to this node's first child. When this returns
  false, the node has no child, and the cursor has not been moved.
  */
  firstChild() {
    return this.enterChild(
      1,
      0,
      4
      /* Side.DontCare */
    );
  }
  /**
  Move the cursor to this node's last child.
  */
  lastChild() {
    return this.enterChild(
      -1,
      0,
      4
      /* Side.DontCare */
    );
  }
  /**
  Move the cursor to the first child that ends after `pos`.
  */
  childAfter(t) {
    return this.enterChild(
      1,
      t,
      2
      /* Side.After */
    );
  }
  /**
  Move to the last child that starts before `pos`.
  */
  childBefore(t) {
    return this.enterChild(
      -1,
      t,
      -2
      /* Side.Before */
    );
  }
  /**
  Move the cursor to the child around `pos`. If side is -1 the
  child may end at that position, when 1 it may start there. This
  will also enter [overlaid](#common.MountedTree.overlay)
  [mounted](#common.NodeProp^mounted) trees unless `overlays` is
  set to false.
  */
  enter(t, n, r = this.mode) {
    return this.buffer ? r & no.ExcludeBuffers ? !1 : this.enterChild(1, t, n) : this.yield(this._tree.enter(t, n, r));
  }
  /**
  Move to the node's parent node, if this isn't the top node.
  */
  parent() {
    if (!this.buffer)
      return this.yieldNode(this.mode & no.IncludeAnonymous ? this._tree._parent : this._tree.parent);
    if (this.stack.length)
      return this.yieldBuf(this.stack.pop());
    let t = this.mode & no.IncludeAnonymous ? this.buffer.parent : this.buffer.parent.nextSignificantParent();
    return this.buffer = null, this.yieldNode(t);
  }
  /**
  @internal
  */
  sibling(t) {
    if (!this.buffer)
      return this._tree._parent ? this.yield(this._tree.index < 0 ? null : this._tree._parent.nextChild(this._tree.index + t, t, 0, 4, this.mode)) : !1;
    let { buffer: n } = this.buffer, r = this.stack.length - 1;
    if (t < 0) {
      let i = r < 0 ? 0 : this.stack[r] + 4;
      if (this.index != i)
        return this.yieldBuf(n.findChild(
          i,
          this.index,
          -1,
          0,
          4
          /* Side.DontCare */
        ));
    } else {
      let i = n.buffer[this.index + 3];
      if (i < (r < 0 ? n.buffer.length : n.buffer[this.stack[r] + 3]))
        return this.yieldBuf(i);
    }
    return r < 0 ? this.yield(this.buffer.parent.nextChild(this.buffer.index + t, t, 0, 4, this.mode)) : !1;
  }
  /**
  Move to this node's next sibling, if any.
  */
  nextSibling() {
    return this.sibling(1);
  }
  /**
  Move to this node's previous sibling, if any.
  */
  prevSibling() {
    return this.sibling(-1);
  }
  atLastNode(t) {
    let n, r, { buffer: i } = this;
    if (i) {
      if (t > 0) {
        if (this.index < i.buffer.buffer.length)
          return !1;
      } else
        for (let o = 0; o < this.index; o++)
          if (i.buffer.buffer[o + 3] < this.index)
            return !1;
      ({ index: n, parent: r } = i);
    } else
      ({ index: n, _parent: r } = this._tree);
    for (; r; { index: n, _parent: r } = r)
      if (n > -1)
        for (let o = n + t, s = t < 0 ? -1 : r._tree.children.length; o != s; o += t) {
          let a = r._tree.children[o];
          if (this.mode & no.IncludeAnonymous || a instanceof gd || !a.type.isAnonymous || X$(a))
            return !1;
        }
    return !0;
  }
  move(t, n) {
    if (n && this.enterChild(
      t,
      0,
      4
      /* Side.DontCare */
    ))
      return !0;
    for (; ; ) {
      if (this.sibling(t))
        return !0;
      if (this.atLastNode(t) || !this.parent())
        return !1;
    }
  }
  /**
  Move to the next node in a
  [pre-order](https://en.wikipedia.org/wiki/Tree_traversal#Pre-order,_NLR)
  traversal, going from a node to its first child or, if the
  current node is empty or `enter` is false, its next sibling or
  the next sibling of the first parent node that has one.
  */
  next(t = !0) {
    return this.move(1, t);
  }
  /**
  Move to the next node in a last-to-first pre-order traversal. A
  node is followed by its last child or, if it has none, its
  previous sibling or the previous sibling of the first parent
  node that has one.
  */
  prev(t = !0) {
    return this.move(-1, t);
  }
  /**
  Move the cursor to the innermost node that covers `pos`. If
  `side` is -1, it will enter nodes that end at `pos`. If it is 1,
  it will enter nodes that start at `pos`.
  */
  moveTo(t, n = 0) {
    for (; (this.from == this.to || (n < 1 ? this.from >= t : this.from > t) || (n > -1 ? this.to <= t : this.to < t)) && this.parent(); )
      ;
    for (; this.enterChild(1, t, n); )
      ;
    return this;
  }
  /**
  Get a [syntax node](#common.SyntaxNode) at the cursor's current
  position.
  */
  get node() {
    if (!this.buffer)
      return this._tree;
    let t = this.bufferNode, n = null, r = 0;
    if (t && t.context == this.buffer)
      e: for (let i = this.index, o = this.stack.length; o >= 0; ) {
        for (let s = t; s; s = s._parent)
          if (s.index == i) {
            if (i == this.index)
              return s;
            n = s, r = o + 1;
            break e;
          }
        i = this.stack[--o];
      }
    for (let i = r; i < this.stack.length; i++)
      n = new sd(this.buffer, n, this.stack[i]);
    return this.bufferNode = new sd(this.buffer, n, this.index);
  }
  /**
  Get the [tree](#common.Tree) that represents the current node, if
  any. Will return null when the node is in a [tree
  buffer](#common.TreeBuffer).
  */
  get tree() {
    return this.buffer ? null : this._tree._tree;
  }
  /**
  Iterate over the current node and all its descendants, calling
  `enter` when entering a node and `leave`, if given, when leaving
  one. When `enter` returns `false`, any children of that node are
  skipped, and `leave` isn't called for it.
  */
  iterate(t, n) {
    for (let r = 0; ; ) {
      let i = !1;
      if (this.type.isAnonymous || t(this) !== !1) {
        if (this.firstChild()) {
          r++;
          continue;
        }
        this.type.isAnonymous || (i = !0);
      }
      for (; ; ) {
        if (i && n && n(this), i = this.type.isAnonymous, !r)
          return;
        if (this.nextSibling())
          break;
        this.parent(), r--, i = !0;
      }
    }
  }
  /**
  Test whether the current node matches a given context—a sequence
  of direct parent node names. Empty strings in the context array
  are treated as wildcards.
  */
  matchContext(t) {
    if (!this.buffer)
      return Xk(this.node.parent, t);
    let { buffer: n } = this.buffer, { types: r } = n.set;
    for (let i = t.length - 1, o = this.stack.length - 1; i >= 0; o--) {
      if (o < 0)
        return Xk(this._tree, t, i);
      let s = r[n.buffer[this.stack[o]]];
      if (!s.isAnonymous) {
        if (t[i] && t[i] != s.name)
          return !1;
        i--;
      }
    }
    return !0;
  }
}
function X$(e) {
  return e.children.some((t) => t instanceof gd || !t.type.isAnonymous || X$(t));
}
function mot(e) {
  var t;
  let { buffer: n, nodeSet: r, maxBufferLength: i = LY, reused: o = [], minRepeatType: s = r.types.length } = e, a = Array.isArray(n) ? new J$(n, n.length) : n, u = r.types, c = 0, d = 0;
  function f(A, I, $, L, B, H) {
    let { id: q, start: J, end: X, size: j } = a, U = d, G = c;
    for (; j < 0; )
      if (a.next(), j == -1) {
        let Z = o[q];
        $.push(Z), L.push(J - A);
        return;
      } else if (j == -3) {
        c = q;
        return;
      } else if (j == -4) {
        d = q;
        return;
      } else
        throw new RangeError(`Unrecognized record size: ${j}`);
    let K = u[q], ee, te, M = J - A;
    if (X - J <= i && (te = C(a.pos - I, B))) {
      let Z = new Uint16Array(te.size - te.skip), ne = a.pos - te.size, R = Z.length;
      for (; a.pos > ne; )
        R = E(te.start, Z, R);
      ee = new gd(Z, X - te.start, r), M = te.start - A;
    } else {
      let Z = a.pos - j;
      a.next();
      let ne = [], R = [], _ = q >= s ? q : -1, W = 0, Q = X;
      for (; a.pos > Z; )
        _ >= 0 && a.id == _ && a.size >= 0 ? (a.end <= Q - i && (v(ne, R, J, W, a.end, Q, _, U, G), W = ne.length, Q = a.end), a.next()) : H > 2500 ? h(J, Z, ne, R) : f(J, Z, ne, R, _, H + 1);
      if (_ >= 0 && W > 0 && W < ne.length && v(ne, R, J, W, J, Q, _, U, G), ne.reverse(), R.reverse(), _ > -1 && W > 0) {
        let oe = m(K, G);
        ee = Q$(K, ne, R, 0, ne.length, 0, X - J, oe, oe);
      } else
        ee = x(K, ne, R, X - J, U - X, G);
    }
    $.push(ee), L.push(M);
  }
  function h(A, I, $, L) {
    let B = [], H = 0, q = -1;
    for (; a.pos > I; ) {
      let { id: J, start: X, end: j, size: U } = a;
      if (U > 4)
        a.next();
      else {
        if (q > -1 && X < q)
          break;
        q < 0 && (q = j - i), B.push(J, X, j), H++, a.next();
      }
    }
    if (H) {
      let J = new Uint16Array(H * 4), X = B[B.length - 2];
      for (let j = B.length - 3, U = 0; j >= 0; j -= 3)
        J[U++] = B[j], J[U++] = B[j + 1] - X, J[U++] = B[j + 2] - X, J[U++] = U;
      $.push(new gd(J, B[2] - X, r)), L.push(X - A);
    }
  }
  function m(A, I) {
    return ($, L, B) => {
      let H = 0, q = $.length - 1, J, X;
      if (q >= 0 && (J = $[q]) instanceof Ni) {
        if (!q && J.type == A && J.length == B)
          return J;
        (X = J.prop(jn.lookAhead)) && (H = L[q] + J.length + X);
      }
      return x(A, $, L, B, H, I);
    };
  }
  function v(A, I, $, L, B, H, q, J, X) {
    let j = [], U = [];
    for (; A.length > L; )
      j.push(A.pop()), U.push(I.pop() + $ - B);
    A.push(x(r.types[q], j, U, H - B, J - H, X)), I.push(B - $);
  }
  function x(A, I, $, L, B, H, q) {
    if (H) {
      let J = [jn.contextHash, H];
      q = q ? [J].concat(q) : [J];
    }
    if (B > 25) {
      let J = [jn.lookAhead, B];
      q = q ? [J].concat(q) : [J];
    }
    return new Ni(A, I, $, L, q);
  }
  function C(A, I) {
    let $ = a.fork(), L = 0, B = 0, H = 0, q = $.end - i, J = { size: 0, start: 0, skip: 0 };
    e: for (let X = $.pos - A; $.pos > X; ) {
      let j = $.size;
      if ($.id == I && j >= 0) {
        J.size = L, J.start = B, J.skip = H, H += 4, L += 4, $.next();
        continue;
      }
      let U = $.pos - j;
      if (j < 0 || U < X || $.start < q)
        break;
      let G = $.id >= s ? 4 : 0, K = $.start;
      for ($.next(); $.pos > U; ) {
        if ($.size < 0)
          if ($.size == -3)
            G += 4;
          else
            break e;
        else $.id >= s && (G += 4);
        $.next();
      }
      B = K, L += j, H += G;
    }
    return (I < 0 || L == A) && (J.size = L, J.start = B, J.skip = H), J.size > 4 ? J : void 0;
  }
  function E(A, I, $) {
    let { id: L, start: B, end: H, size: q } = a;
    if (a.next(), q >= 0 && L < s) {
      let J = $;
      if (q > 4) {
        let X = a.pos - (q - 4);
        for (; a.pos > X; )
          $ = E(A, I, $);
      }
      I[--$] = J, I[--$] = H - A, I[--$] = B - A, I[--$] = L;
    } else q == -3 ? c = L : q == -4 && (d = L);
    return $;
  }
  let S = [], w = [];
  for (; a.pos > 0; )
    f(e.start || 0, e.bufferStart || 0, S, w, -1, 0);
  let O = (t = e.length) !== null && t !== void 0 ? t : S.length ? w[0] + S[0].length : 0;
  return new Ni(u[e.topID], S.reverse(), w.reverse(), O);
}
const P5 = /* @__PURE__ */ new WeakMap();
function pD(e, t) {
  if (!e.isAnonymous || t instanceof gd || t.type != e)
    return 1;
  let n = P5.get(t);
  if (n == null) {
    n = 1;
    for (let r of t.children) {
      if (r.type != e || !(r instanceof Ni)) {
        n = 1;
        break;
      }
      n += pD(e, r);
    }
    P5.set(t, n);
  }
  return n;
}
function Q$(e, t, n, r, i, o, s, a, u) {
  let c = 0;
  for (let v = r; v < i; v++)
    c += pD(e, t[v]);
  let d = Math.ceil(
    c * 1.5 / 8
    /* Balance.BranchFactor */
  ), f = [], h = [];
  function m(v, x, C, E, S) {
    for (let w = C; w < E; ) {
      let O = w, A = x[w], I = pD(e, v[w]);
      for (w++; w < E; w++) {
        let $ = pD(e, v[w]);
        if (I + $ >= d)
          break;
        I += $;
      }
      if (w == O + 1) {
        if (I > d) {
          let $ = v[O];
          m($.children, $.positions, 0, $.children.length, x[O] + S);
          continue;
        }
        f.push(v[O]);
      } else {
        let $ = x[w - 1] + v[w - 1].length - A;
        f.push(Q$(e, v, x, O, w, A, $, null, u));
      }
      h.push(A + S - o);
    }
  }
  return m(t, n, r, i, 0), (a || u)(f, h, s);
}
class Bp {
  /**
  Construct a tree fragment. You'll usually want to use
  [`addTree`](#common.TreeFragment^addTree) and
  [`applyChanges`](#common.TreeFragment^applyChanges) instead of
  calling this directly.
  */
  constructor(t, n, r, i, o = !1, s = !1) {
    this.from = t, this.to = n, this.tree = r, this.offset = i, this.open = (o ? 1 : 0) | (s ? 2 : 0);
  }
  /**
  Whether the start of the fragment represents the start of a
  parse, or the end of a change. (In the second case, it may not
  be safe to reuse some nodes at the start, depending on the
  parsing algorithm.)
  */
  get openStart() {
    return (this.open & 1) > 0;
  }
  /**
  Whether the end of the fragment represents the end of a
  full-document parse, or the start of a change.
  */
  get openEnd() {
    return (this.open & 2) > 0;
  }
  /**
  Create a set of fragments from a freshly parsed tree, or update
  an existing set of fragments by replacing the ones that overlap
  with a tree with content from the new tree. When `partial` is
  true, the parse is treated as incomplete, and the resulting
  fragment has [`openEnd`](#common.TreeFragment.openEnd) set to
  true.
  */
  static addTree(t, n = [], r = !1) {
    let i = [new Bp(0, t.length, t, 0, !1, r)];
    for (let o of n)
      o.to > t.length && i.push(o);
    return i;
  }
  /**
  Apply a set of edits to an array of fragments, removing or
  splitting fragments as necessary to remove edited ranges, and
  adjusting offsets for fragments that moved.
  */
  static applyChanges(t, n, r = 128) {
    if (!n.length)
      return t;
    let i = [], o = 1, s = t.length ? t[0] : null;
    for (let a = 0, u = 0, c = 0; ; a++) {
      let d = a < n.length ? n[a] : null, f = d ? d.fromA : 1e9;
      if (f - u >= r)
        for (; s && s.from < f; ) {
          let h = s;
          if (u >= h.from || f <= h.to || c) {
            let m = Math.max(h.from, u) - c, v = Math.min(h.to, f) - c;
            h = m >= v ? null : new Bp(m, v, h.tree, h.offset + c, a > 0, !!d);
          }
          if (h && i.push(h), s.to > f)
            break;
          s = o < t.length ? t[o++] : null;
        }
      if (!d)
        break;
      u = d.toA, c = d.toA - d.toB;
    }
    return i;
  }
}
class zY {
  /**
  Start a parse, returning a [partial parse](#common.PartialParse)
  object. [`fragments`](#common.TreeFragment) can be passed in to
  make the parse incremental.
  
  By default, the entire input is parsed. You can pass `ranges`,
  which should be a sorted array of non-empty, non-overlapping
  ranges, to parse only those ranges. The tree returned in that
  case will start at `ranges[0].from`.
  */
  startParse(t, n, r) {
    return typeof t == "string" && (t = new got(t)), r = r ? r.length ? r.map((i) => new Nw(i.from, i.to)) : [new Nw(0, 0)] : [new Nw(0, t.length)], this.createParse(t, n || [], r);
  }
  /**
  Run a full parse, returning the resulting tree.
  */
  parse(t, n, r) {
    let i = this.startParse(t, n, r);
    for (; ; ) {
      let o = i.advance();
      if (o)
        return o;
    }
  }
}
class got {
  constructor(t) {
    this.string = t;
  }
  get length() {
    return this.string.length;
  }
  chunk(t) {
    return this.string.slice(t);
  }
  get lineChunks() {
    return !1;
  }
  read(t, n) {
    return this.string.slice(t, n);
  }
}
new jn({ perNode: !0 });
let yot = 0;
class ka {
  /**
  @internal
  */
  constructor(t, n, r, i) {
    this.name = t, this.set = n, this.base = r, this.modified = i, this.id = yot++;
  }
  toString() {
    let { name: t } = this;
    for (let n of this.modified)
      n.name && (t = `${n.name}(${t})`);
    return t;
  }
  static define(t, n) {
    let r = typeof t == "string" ? t : "?";
    if (t instanceof ka && (n = t), n != null && n.base)
      throw new Error("Can not derive from a modified tag");
    let i = new ka(r, [], null, []);
    if (i.set.push(i), n)
      for (let o of n.set)
        i.set.push(o);
    return i;
  }
  /**
  Define a tag _modifier_, which is a function that, given a tag,
  will return a tag that is a subtag of the original. Applying the
  same modifier to a twice tag will return the same value (`m1(t1)
  == m1(t1)`) and applying multiple modifiers will, regardless or
  order, produce the same tag (`m1(m2(t1)) == m2(m1(t1))`).
  
  When multiple modifiers are applied to a given base tag, each
  smaller set of modifiers is registered as a parent, so that for
  example `m1(m2(m3(t1)))` is a subtype of `m1(m2(t1))`,
  `m1(m3(t1)`, and so on.
  */
  static defineModifier(t) {
    let n = new fC(t);
    return (r) => r.modified.indexOf(n) > -1 ? r : fC.get(r.base || r, r.modified.concat(n).sort((i, o) => i.id - o.id));
  }
}
let bot = 0;
class fC {
  constructor(t) {
    this.name = t, this.instances = [], this.id = bot++;
  }
  static get(t, n) {
    if (!n.length)
      return t;
    let r = n[0].instances.find((a) => a.base == t && vot(n, a.modified));
    if (r)
      return r;
    let i = [], o = new ka(t.name, i, t, n);
    for (let a of n)
      a.instances.push(o);
    let s = xot(n);
    for (let a of t.set)
      if (!a.modified.length)
        for (let u of s)
          i.push(fC.get(a, u));
    return o;
  }
}
function vot(e, t) {
  return e.length == t.length && e.every((n, r) => n == t[r]);
}
function xot(e) {
  let t = [[]];
  for (let n = 0; n < e.length; n++)
    for (let r = 0, i = t.length; r < i; r++)
      t.push(t[r].concat(e[n]));
  return t.sort((n, r) => r.length - n.length);
}
function UY(e) {
  let t = /* @__PURE__ */ Object.create(null);
  for (let n in e) {
    let r = e[n];
    Array.isArray(r) || (r = [r]);
    for (let i of n.split(" "))
      if (i) {
        let o = [], s = 2, a = i;
        for (let f = 0; ; ) {
          if (a == "..." && f > 0 && f + 3 == i.length) {
            s = 1;
            break;
          }
          let h = /^"(?:[^"\\]|\\.)*?"|[^\/!]+/.exec(a);
          if (!h)
            throw new RangeError("Invalid path: " + i);
          if (o.push(h[0] == "*" ? "" : h[0][0] == '"' ? JSON.parse(h[0]) : h[0]), f += h[0].length, f == i.length)
            break;
          let m = i[f++];
          if (f == i.length && m == "!") {
            s = 0;
            break;
          }
          if (m != "/")
            throw new RangeError("Invalid path: " + i);
          a = i.slice(f);
        }
        let u = o.length - 1, c = o[u];
        if (!c)
          throw new RangeError("Invalid path: " + i);
        let d = new hC(r, s, u > 0 ? o.slice(0, u) : null);
        t[c] = d.sort(t[c]);
      }
  }
  return WY.add(t);
}
const WY = new jn();
class hC {
  constructor(t, n, r, i) {
    this.tags = t, this.mode = n, this.context = r, this.next = i;
  }
  get opaque() {
    return this.mode == 0;
  }
  get inherit() {
    return this.mode == 1;
  }
  sort(t) {
    return !t || t.depth < this.depth ? (this.next = t, this) : (t.next = this.sort(t.next), t);
  }
  get depth() {
    return this.context ? this.context.length : 0;
  }
}
hC.empty = new hC([], 2, null);
function HY(e, t) {
  let n = /* @__PURE__ */ Object.create(null);
  for (let o of e)
    if (!Array.isArray(o.tag))
      n[o.tag.id] = o.class;
    else
      for (let s of o.tag)
        n[s.id] = o.class;
  let { scope: r, all: i = null } = t || {};
  return {
    style: (o) => {
      let s = i;
      for (let a of o)
        for (let u of a.set) {
          let c = n[u.id];
          if (c) {
            s = s ? s + " " + c : c;
            break;
          }
        }
      return s;
    },
    scope: r
  };
}
function Dot(e, t) {
  let n = null;
  for (let r of e) {
    let i = r.style(t);
    i && (n = n ? n + " " + i : i);
  }
  return n;
}
function Cot(e, t, n, r = 0, i = e.length) {
  let o = new Eot(r, Array.isArray(t) ? t : [t], n);
  o.highlightRange(e.cursor(), r, i, "", o.highlighters), o.flush(i);
}
class Eot {
  constructor(t, n, r) {
    this.at = t, this.highlighters = n, this.span = r, this.class = "";
  }
  startSpan(t, n) {
    n != this.class && (this.flush(t), t > this.at && (this.at = t), this.class = n);
  }
  flush(t) {
    t > this.at && this.class && this.span(this.at, t, this.class);
  }
  highlightRange(t, n, r, i, o) {
    let { type: s, from: a, to: u } = t;
    if (a >= r || u <= n)
      return;
    s.isTop && (o = this.highlighters.filter((m) => !m.scope || m.scope(s)));
    let c = i, d = Tot(t) || hC.empty, f = Dot(o, d.tags);
    if (f && (c && (c += " "), c += f, d.mode == 1 && (i += (i ? " " : "") + f)), this.startSpan(Math.max(n, a), c), d.opaque)
      return;
    let h = t.tree && t.tree.prop(jn.mounted);
    if (h && h.overlay) {
      let m = t.node.enter(h.overlay[0].from + a, 1), v = this.highlighters.filter((C) => !C.scope || C.scope(h.tree.type)), x = t.firstChild();
      for (let C = 0, E = a; ; C++) {
        let S = C < h.overlay.length ? h.overlay[C] : null, w = S ? S.from + a : u, O = Math.max(n, E), A = Math.min(r, w);
        if (O < A && x)
          for (; t.from < A && (this.highlightRange(t, O, A, i, o), this.startSpan(Math.min(A, t.to), c), !(t.to >= w || !t.nextSibling())); )
            ;
        if (!S || w > r)
          break;
        E = S.to + a, E > n && (this.highlightRange(m.cursor(), Math.max(n, S.from + a), Math.min(r, E), "", v), this.startSpan(Math.min(r, E), c));
      }
      x && t.parent();
    } else if (t.firstChild()) {
      h && (i = "");
      do
        if (!(t.to <= n)) {
          if (t.from >= r)
            break;
          this.highlightRange(t, n, r, i, o), this.startSpan(Math.min(r, t.to), c);
        }
      while (t.nextSibling());
      t.parent();
    }
  }
}
function Tot(e) {
  let t = e.type.prop(WY);
  for (; t && t.context && !e.matchContext(t.context); )
    t = t.next;
  return t || null;
}
const Pt = ka.define, yx = Pt(), Jc = Pt(), k5 = Pt(Jc), O5 = Pt(Jc), Xc = Pt(), bx = Pt(Xc), Mw = Pt(Xc), Vl = Pt(), pp = Pt(Vl), Bl = Pt(), jl = Pt(), Zk = Pt(), _y = Pt(Zk), vx = Pt(), Ge = {
  /**
  A comment.
  */
  comment: yx,
  /**
  A line [comment](#highlight.tags.comment).
  */
  lineComment: Pt(yx),
  /**
  A block [comment](#highlight.tags.comment).
  */
  blockComment: Pt(yx),
  /**
  A documentation [comment](#highlight.tags.comment).
  */
  docComment: Pt(yx),
  /**
  Any kind of identifier.
  */
  name: Jc,
  /**
  The [name](#highlight.tags.name) of a variable.
  */
  variableName: Pt(Jc),
  /**
  A type [name](#highlight.tags.name).
  */
  typeName: k5,
  /**
  A tag name (subtag of [`typeName`](#highlight.tags.typeName)).
  */
  tagName: Pt(k5),
  /**
  A property or field [name](#highlight.tags.name).
  */
  propertyName: O5,
  /**
  An attribute name (subtag of [`propertyName`](#highlight.tags.propertyName)).
  */
  attributeName: Pt(O5),
  /**
  The [name](#highlight.tags.name) of a class.
  */
  className: Pt(Jc),
  /**
  A label [name](#highlight.tags.name).
  */
  labelName: Pt(Jc),
  /**
  A namespace [name](#highlight.tags.name).
  */
  namespace: Pt(Jc),
  /**
  The [name](#highlight.tags.name) of a macro.
  */
  macroName: Pt(Jc),
  /**
  A literal value.
  */
  literal: Xc,
  /**
  A string [literal](#highlight.tags.literal).
  */
  string: bx,
  /**
  A documentation [string](#highlight.tags.string).
  */
  docString: Pt(bx),
  /**
  A character literal (subtag of [string](#highlight.tags.string)).
  */
  character: Pt(bx),
  /**
  An attribute value (subtag of [string](#highlight.tags.string)).
  */
  attributeValue: Pt(bx),
  /**
  A number [literal](#highlight.tags.literal).
  */
  number: Mw,
  /**
  An integer [number](#highlight.tags.number) literal.
  */
  integer: Pt(Mw),
  /**
  A floating-point [number](#highlight.tags.number) literal.
  */
  float: Pt(Mw),
  /**
  A boolean [literal](#highlight.tags.literal).
  */
  bool: Pt(Xc),
  /**
  Regular expression [literal](#highlight.tags.literal).
  */
  regexp: Pt(Xc),
  /**
  An escape [literal](#highlight.tags.literal), for example a
  backslash escape in a string.
  */
  escape: Pt(Xc),
  /**
  A color [literal](#highlight.tags.literal).
  */
  color: Pt(Xc),
  /**
  A URL [literal](#highlight.tags.literal).
  */
  url: Pt(Xc),
  /**
  A language keyword.
  */
  keyword: Bl,
  /**
  The [keyword](#highlight.tags.keyword) for the self or this
  object.
  */
  self: Pt(Bl),
  /**
  The [keyword](#highlight.tags.keyword) for null.
  */
  null: Pt(Bl),
  /**
  A [keyword](#highlight.tags.keyword) denoting some atomic value.
  */
  atom: Pt(Bl),
  /**
  A [keyword](#highlight.tags.keyword) that represents a unit.
  */
  unit: Pt(Bl),
  /**
  A modifier [keyword](#highlight.tags.keyword).
  */
  modifier: Pt(Bl),
  /**
  A [keyword](#highlight.tags.keyword) that acts as an operator.
  */
  operatorKeyword: Pt(Bl),
  /**
  A control-flow related [keyword](#highlight.tags.keyword).
  */
  controlKeyword: Pt(Bl),
  /**
  A [keyword](#highlight.tags.keyword) that defines something.
  */
  definitionKeyword: Pt(Bl),
  /**
  A [keyword](#highlight.tags.keyword) related to defining or
  interfacing with modules.
  */
  moduleKeyword: Pt(Bl),
  /**
  An operator.
  */
  operator: jl,
  /**
  An [operator](#highlight.tags.operator) that dereferences something.
  */
  derefOperator: Pt(jl),
  /**
  Arithmetic-related [operator](#highlight.tags.operator).
  */
  arithmeticOperator: Pt(jl),
  /**
  Logical [operator](#highlight.tags.operator).
  */
  logicOperator: Pt(jl),
  /**
  Bit [operator](#highlight.tags.operator).
  */
  bitwiseOperator: Pt(jl),
  /**
  Comparison [operator](#highlight.tags.operator).
  */
  compareOperator: Pt(jl),
  /**
  [Operator](#highlight.tags.operator) that updates its operand.
  */
  updateOperator: Pt(jl),
  /**
  [Operator](#highlight.tags.operator) that defines something.
  */
  definitionOperator: Pt(jl),
  /**
  Type-related [operator](#highlight.tags.operator).
  */
  typeOperator: Pt(jl),
  /**
  Control-flow [operator](#highlight.tags.operator).
  */
  controlOperator: Pt(jl),
  /**
  Program or markup punctuation.
  */
  punctuation: Zk,
  /**
  [Punctuation](#highlight.tags.punctuation) that separates
  things.
  */
  separator: Pt(Zk),
  /**
  Bracket-style [punctuation](#highlight.tags.punctuation).
  */
  bracket: _y,
  /**
  Angle [brackets](#highlight.tags.bracket) (usually `<` and `>`
  tokens).
  */
  angleBracket: Pt(_y),
  /**
  Square [brackets](#highlight.tags.bracket) (usually `[` and `]`
  tokens).
  */
  squareBracket: Pt(_y),
  /**
  Parentheses (usually `(` and `)` tokens). Subtag of
  [bracket](#highlight.tags.bracket).
  */
  paren: Pt(_y),
  /**
  Braces (usually `{` and `}` tokens). Subtag of
  [bracket](#highlight.tags.bracket).
  */
  brace: Pt(_y),
  /**
  Content, for example plain text in XML or markup documents.
  */
  content: Vl,
  /**
  [Content](#highlight.tags.content) that represents a heading.
  */
  heading: pp,
  /**
  A level 1 [heading](#highlight.tags.heading).
  */
  heading1: Pt(pp),
  /**
  A level 2 [heading](#highlight.tags.heading).
  */
  heading2: Pt(pp),
  /**
  A level 3 [heading](#highlight.tags.heading).
  */
  heading3: Pt(pp),
  /**
  A level 4 [heading](#highlight.tags.heading).
  */
  heading4: Pt(pp),
  /**
  A level 5 [heading](#highlight.tags.heading).
  */
  heading5: Pt(pp),
  /**
  A level 6 [heading](#highlight.tags.heading).
  */
  heading6: Pt(pp),
  /**
  A prose [content](#highlight.tags.content) separator (such as a horizontal rule).
  */
  contentSeparator: Pt(Vl),
  /**
  [Content](#highlight.tags.content) that represents a list.
  */
  list: Pt(Vl),
  /**
  [Content](#highlight.tags.content) that represents a quote.
  */
  quote: Pt(Vl),
  /**
  [Content](#highlight.tags.content) that is emphasized.
  */
  emphasis: Pt(Vl),
  /**
  [Content](#highlight.tags.content) that is styled strong.
  */
  strong: Pt(Vl),
  /**
  [Content](#highlight.tags.content) that is part of a link.
  */
  link: Pt(Vl),
  /**
  [Content](#highlight.tags.content) that is styled as code or
  monospace.
  */
  monospace: Pt(Vl),
  /**
  [Content](#highlight.tags.content) that has a strike-through
  style.
  */
  strikethrough: Pt(Vl),
  /**
  Inserted text in a change-tracking format.
  */
  inserted: Pt(),
  /**
  Deleted text.
  */
  deleted: Pt(),
  /**
  Changed text.
  */
  changed: Pt(),
  /**
  An invalid or unsyntactic element.
  */
  invalid: Pt(),
  /**
  Metadata or meta-instruction.
  */
  meta: vx,
  /**
  [Metadata](#highlight.tags.meta) that applies to the entire
  document.
  */
  documentMeta: Pt(vx),
  /**
  [Metadata](#highlight.tags.meta) that annotates or adds
  attributes to a given syntactic element.
  */
  annotation: Pt(vx),
  /**
  Processing instruction or preprocessor directive. Subtag of
  [meta](#highlight.tags.meta).
  */
  processingInstruction: Pt(vx),
  /**
  [Modifier](#highlight.Tag^defineModifier) that indicates that a
  given element is being defined. Expected to be used with the
  various [name](#highlight.tags.name) tags.
  */
  definition: ka.defineModifier("definition"),
  /**
  [Modifier](#highlight.Tag^defineModifier) that indicates that
  something is constant. Mostly expected to be used with
  [variable names](#highlight.tags.variableName).
  */
  constant: ka.defineModifier("constant"),
  /**
  [Modifier](#highlight.Tag^defineModifier) used to indicate that
  a [variable](#highlight.tags.variableName) or [property
  name](#highlight.tags.propertyName) is being called or defined
  as a function.
  */
  function: ka.defineModifier("function"),
  /**
  [Modifier](#highlight.Tag^defineModifier) that can be applied to
  [names](#highlight.tags.name) to indicate that they belong to
  the language's standard environment.
  */
  standard: ka.defineModifier("standard"),
  /**
  [Modifier](#highlight.Tag^defineModifier) that indicates a given
  [names](#highlight.tags.name) is local to some scope.
  */
  local: ka.defineModifier("local"),
  /**
  A generic variant [modifier](#highlight.Tag^defineModifier) that
  can be used to tag language-specific alternative variants of
  some common tag. It is recommended for themes to define special
  forms of at least the [string](#highlight.tags.string) and
  [variable name](#highlight.tags.variableName) tags, since those
  come up a lot.
  */
  special: ka.defineModifier("special")
};
for (let e in Ge) {
  let t = Ge[e];
  t instanceof ka && (t.name = e);
}
HY([
  { tag: Ge.link, class: "tok-link" },
  { tag: Ge.heading, class: "tok-heading" },
  { tag: Ge.emphasis, class: "tok-emphasis" },
  { tag: Ge.strong, class: "tok-strong" },
  { tag: Ge.keyword, class: "tok-keyword" },
  { tag: Ge.atom, class: "tok-atom" },
  { tag: Ge.bool, class: "tok-bool" },
  { tag: Ge.url, class: "tok-url" },
  { tag: Ge.labelName, class: "tok-labelName" },
  { tag: Ge.inserted, class: "tok-inserted" },
  { tag: Ge.deleted, class: "tok-deleted" },
  { tag: Ge.literal, class: "tok-literal" },
  { tag: Ge.string, class: "tok-string" },
  { tag: Ge.number, class: "tok-number" },
  { tag: [Ge.regexp, Ge.escape, Ge.special(Ge.string)], class: "tok-string2" },
  { tag: Ge.variableName, class: "tok-variableName" },
  { tag: Ge.local(Ge.variableName), class: "tok-variableName tok-local" },
  { tag: Ge.definition(Ge.variableName), class: "tok-variableName tok-definition" },
  { tag: Ge.special(Ge.variableName), class: "tok-variableName2" },
  { tag: Ge.definition(Ge.propertyName), class: "tok-propertyName tok-definition" },
  { tag: Ge.typeName, class: "tok-typeName" },
  { tag: Ge.namespace, class: "tok-namespace" },
  { tag: Ge.className, class: "tok-className" },
  { tag: Ge.macroName, class: "tok-macroName" },
  { tag: Ge.propertyName, class: "tok-propertyName" },
  { tag: Ge.operator, class: "tok-operator" },
  { tag: Ge.comment, class: "tok-comment" },
  { tag: Ge.meta, class: "tok-meta" },
  { tag: Ge.invalid, class: "tok-invalid" },
  { tag: Ge.punctuation, class: "tok-punctuation" }
]);
var Rw;
const _h = /* @__PURE__ */ new jn();
function Sot(e) {
  return zt.define({
    combine: e ? (t) => t.concat(e) : void 0
  });
}
const Aot = /* @__PURE__ */ new jn();
class gl {
  /**
  Construct a language object. If you need to invoke this
  directly, first define a data facet with
  [`defineLanguageFacet`](https://codemirror.net/6/docs/ref/#language.defineLanguageFacet), and then
  configure your parser to [attach](https://codemirror.net/6/docs/ref/#language.languageDataProp) it
  to the language's outer syntax node.
  */
  constructor(t, n, r = [], i = "") {
    this.data = t, this.name = i, Jn.prototype.hasOwnProperty("tree") || Object.defineProperty(Jn.prototype, "tree", { get() {
      return Bo(this);
    } }), this.parser = n, this.extension = [
      yd.of(this),
      Jn.languageData.of((o, s, a) => {
        let u = I5(o, s, a), c = u.type.prop(_h);
        if (!c)
          return [];
        let d = o.facet(c), f = u.type.prop(Aot);
        if (f) {
          let h = u.resolve(s - u.from, a);
          for (let m of f)
            if (m.test(h, o)) {
              let v = o.facet(m.facet);
              return m.type == "replace" ? v : v.concat(d);
            }
        }
        return d;
      })
    ].concat(r);
  }
  /**
  Query whether this language is active at the given position.
  */
  isActiveAt(t, n, r = -1) {
    return I5(t, n, r).type.prop(_h) == this.data;
  }
  /**
  Find the document regions that were parsed using this language.
  The returned regions will _include_ any nested languages rooted
  in this language, when those exist.
  */
  findRegions(t) {
    let n = t.facet(yd);
    if ((n == null ? void 0 : n.data) == this.data)
      return [{ from: 0, to: t.doc.length }];
    if (!n || !n.allowsNesting)
      return [];
    let r = [], i = (o, s) => {
      if (o.prop(_h) == this.data) {
        r.push({ from: s, to: s + o.length });
        return;
      }
      let a = o.prop(jn.mounted);
      if (a) {
        if (a.tree.prop(_h) == this.data) {
          if (a.overlay)
            for (let u of a.overlay)
              r.push({ from: u.from + s, to: u.to + s });
          else
            r.push({ from: s, to: s + o.length });
          return;
        } else if (a.overlay) {
          let u = r.length;
          if (i(a.tree, a.overlay[0].from + s), r.length > u)
            return;
        }
      }
      for (let u = 0; u < o.children.length; u++) {
        let c = o.children[u];
        c instanceof Ni && i(c, o.positions[u] + s);
      }
    };
    return i(Bo(t), 0), r;
  }
  /**
  Indicates whether this language allows nested languages. The
  default implementation returns true.
  */
  get allowsNesting() {
    return !0;
  }
}
gl.setState = /* @__PURE__ */ An.define();
function I5(e, t, n) {
  let r = e.facet(yd), i = Bo(e).topNode;
  if (!r || r.allowsNesting)
    for (let o = i; o; o = o.enter(t, n, no.ExcludeBuffers))
      o.type.isTop && (i = o);
  return i;
}
class mC extends gl {
  constructor(t, n, r) {
    super(t, n, [], r), this.parser = n;
  }
  /**
  Define a language from a parser.
  */
  static define(t) {
    let n = Sot(t.languageData);
    return new mC(n, t.parser.configure({
      props: [_h.add((r) => r.isTop ? n : void 0)]
    }), t.name);
  }
  /**
  Create a new instance of this language with a reconfigured
  version of its parser and optionally a new name.
  */
  configure(t, n) {
    return new mC(this.data, this.parser.configure(t), n || this.name);
  }
  get allowsNesting() {
    return this.parser.hasWrappers();
  }
}
function Bo(e) {
  let t = e.field(gl.state, !1);
  return t ? t.tree : Ni.empty;
}
class wot {
  /**
  Create an input object for the given document.
  */
  constructor(t) {
    this.doc = t, this.cursorPos = 0, this.string = "", this.cursor = t.iter();
  }
  get length() {
    return this.doc.length;
  }
  syncTo(t) {
    return this.string = this.cursor.next(t - this.cursorPos).value, this.cursorPos = t + this.string.length, this.cursorPos - this.string.length;
  }
  chunk(t) {
    return this.syncTo(t), this.string;
  }
  get lineChunks() {
    return !0;
  }
  read(t, n) {
    let r = this.cursorPos - this.string.length;
    return t < r || n >= this.cursorPos ? this.doc.sliceString(t, n) : this.string.slice(t - r, n - r);
  }
}
let Ly = null;
class gC {
  constructor(t, n, r = [], i, o, s, a, u) {
    this.parser = t, this.state = n, this.fragments = r, this.tree = i, this.treeLen = o, this.viewport = s, this.skipped = a, this.scheduleOn = u, this.parse = null, this.tempSkipped = [];
  }
  /**
  @internal
  */
  static create(t, n, r) {
    return new gC(t, n, [], Ni.empty, 0, r, [], null);
  }
  startParse() {
    return this.parser.startParse(new wot(this.state.doc), this.fragments);
  }
  /**
  @internal
  */
  work(t, n) {
    return n != null && n >= this.state.doc.length && (n = void 0), this.tree != Ni.empty && this.isDone(n ?? this.state.doc.length) ? (this.takeTree(), !0) : this.withContext(() => {
      var r;
      if (typeof t == "number") {
        let i = Date.now() + t;
        t = () => Date.now() > i;
      }
      for (this.parse || (this.parse = this.startParse()), n != null && (this.parse.stoppedAt == null || this.parse.stoppedAt > n) && n < this.state.doc.length && this.parse.stopAt(n); ; ) {
        let i = this.parse.advance();
        if (i)
          if (this.fragments = this.withoutTempSkipped(Bp.addTree(i, this.fragments, this.parse.stoppedAt != null)), this.treeLen = (r = this.parse.stoppedAt) !== null && r !== void 0 ? r : this.state.doc.length, this.tree = i, this.parse = null, this.treeLen < (n ?? this.state.doc.length))
            this.parse = this.startParse();
          else
            return !0;
        if (t())
          return !1;
      }
    });
  }
  /**
  @internal
  */
  takeTree() {
    let t, n;
    this.parse && (t = this.parse.parsedPos) >= this.treeLen && ((this.parse.stoppedAt == null || this.parse.stoppedAt > t) && this.parse.stopAt(t), this.withContext(() => {
      for (; !(n = this.parse.advance()); )
        ;
    }), this.treeLen = t, this.tree = n, this.fragments = this.withoutTempSkipped(Bp.addTree(this.tree, this.fragments, !0)), this.parse = null);
  }
  withContext(t) {
    let n = Ly;
    Ly = this;
    try {
      return t();
    } finally {
      Ly = n;
    }
  }
  withoutTempSkipped(t) {
    for (let n; n = this.tempSkipped.pop(); )
      t = F5(t, n.from, n.to);
    return t;
  }
  /**
  @internal
  */
  changes(t, n) {
    let { fragments: r, tree: i, treeLen: o, viewport: s, skipped: a } = this;
    if (this.takeTree(), !t.empty) {
      let u = [];
      if (t.iterChangedRanges((c, d, f, h) => u.push({ fromA: c, toA: d, fromB: f, toB: h })), r = Bp.applyChanges(r, u), i = Ni.empty, o = 0, s = { from: t.mapPos(s.from, -1), to: t.mapPos(s.to, 1) }, this.skipped.length) {
        a = [];
        for (let c of this.skipped) {
          let d = t.mapPos(c.from, 1), f = t.mapPos(c.to, -1);
          d < f && a.push({ from: d, to: f });
        }
      }
    }
    return new gC(this.parser, n, r, i, o, s, a, this.scheduleOn);
  }
  /**
  @internal
  */
  updateViewport(t) {
    if (this.viewport.from == t.from && this.viewport.to == t.to)
      return !1;
    this.viewport = t;
    let n = this.skipped.length;
    for (let r = 0; r < this.skipped.length; r++) {
      let { from: i, to: o } = this.skipped[r];
      i < t.to && o > t.from && (this.fragments = F5(this.fragments, i, o), this.skipped.splice(r--, 1));
    }
    return this.skipped.length >= n ? !1 : (this.reset(), !0);
  }
  /**
  @internal
  */
  reset() {
    this.parse && (this.takeTree(), this.parse = null);
  }
  /**
  Notify the parse scheduler that the given region was skipped
  because it wasn't in view, and the parse should be restarted
  when it comes into view.
  */
  skipUntilInView(t, n) {
    this.skipped.push({ from: t, to: n });
  }
  /**
  Returns a parser intended to be used as placeholder when
  asynchronously loading a nested parser. It'll skip its input and
  mark it as not-really-parsed, so that the next update will parse
  it again.
  
  When `until` is given, a reparse will be scheduled when that
  promise resolves.
  */
  static getSkippingParser(t) {
    return new class extends zY {
      createParse(n, r, i) {
        let o = i[0].from, s = i[i.length - 1].to;
        return {
          parsedPos: o,
          advance() {
            let u = Ly;
            if (u) {
              for (let c of i)
                u.tempSkipped.push(c);
              t && (u.scheduleOn = u.scheduleOn ? Promise.all([u.scheduleOn, t]) : t);
            }
            return this.parsedPos = s, new Ni(Ns.none, [], [], s - o);
          },
          stoppedAt: null,
          stopAt() {
          }
        };
      }
    }();
  }
  /**
  @internal
  */
  isDone(t) {
    t = Math.min(t, this.state.doc.length);
    let n = this.fragments;
    return this.treeLen >= t && n.length && n[0].from == 0 && n[0].to >= t;
  }
  /**
  Get the context for the current parse, or `null` if no editor
  parse is in progress.
  */
  static get() {
    return Ly;
  }
}
function F5(e, t, n) {
  return Bp.applyChanges(e, [{ fromA: t, toA: n, fromB: t, toB: n }]);
}
class Am {
  constructor(t) {
    this.context = t, this.tree = t.tree;
  }
  apply(t) {
    if (!t.docChanged && this.tree == this.context.tree)
      return this;
    let n = this.context.changes(t.changes, t.state), r = this.context.treeLen == t.startState.doc.length ? void 0 : Math.max(t.changes.mapPos(this.context.treeLen), n.viewport.to);
    return n.work(20, r) || n.takeTree(), new Am(n);
  }
  static init(t) {
    let n = Math.min(3e3, t.doc.length), r = gC.create(t.facet(yd).parser, t, { from: 0, to: n });
    return r.work(20, n) || r.takeTree(), new Am(r);
  }
}
gl.state = /* @__PURE__ */ wo.define({
  create: Am.init,
  update(e, t) {
    for (let n of t.effects)
      if (n.is(gl.setState))
        return n.value;
    return t.startState.facet(yd) != t.state.facet(yd) ? Am.init(t.state) : e.apply(t);
  }
});
let qY = (e) => {
  let t = setTimeout(
    () => e(),
    500
    /* Work.MaxPause */
  );
  return () => clearTimeout(t);
};
typeof requestIdleCallback < "u" && (qY = (e) => {
  let t = -1, n = setTimeout(
    () => {
      t = requestIdleCallback(e, {
        timeout: 400
        /* Work.MinPause */
      });
    },
    100
    /* Work.MinPause */
  );
  return () => t < 0 ? clearTimeout(n) : cancelIdleCallback(t);
});
const _w = typeof navigator < "u" && (!((Rw = navigator.scheduling) === null || Rw === void 0) && Rw.isInputPending) ? () => navigator.scheduling.isInputPending() : null, Pot = /* @__PURE__ */ Pi.fromClass(class {
  constructor(t) {
    this.view = t, this.working = null, this.workScheduled = 0, this.chunkEnd = -1, this.chunkBudget = -1, this.work = this.work.bind(this), this.scheduleWork();
  }
  update(t) {
    let n = this.view.state.field(gl.state).context;
    (n.updateViewport(t.view.viewport) || this.view.viewport.to > n.treeLen) && this.scheduleWork(), (t.docChanged || t.selectionSet) && (this.view.hasFocus && (this.chunkBudget += 50), this.scheduleWork()), this.checkAsyncSchedule(n);
  }
  scheduleWork() {
    if (this.working)
      return;
    let { state: t } = this.view, n = t.field(gl.state);
    (n.tree != n.context.tree || !n.context.isDone(t.doc.length)) && (this.working = qY(this.work));
  }
  work(t) {
    this.working = null;
    let n = Date.now();
    if (this.chunkEnd < n && (this.chunkEnd < 0 || this.view.hasFocus) && (this.chunkEnd = n + 3e4, this.chunkBudget = 3e3), this.chunkBudget <= 0)
      return;
    let { state: r, viewport: { to: i } } = this.view, o = r.field(gl.state);
    if (o.tree == o.context.tree && o.context.isDone(
      i + 1e5
      /* Work.MaxParseAhead */
    ))
      return;
    let s = Date.now() + Math.min(this.chunkBudget, 100, t && !_w ? Math.max(25, t.timeRemaining() - 5) : 1e9), a = o.context.treeLen < i && r.doc.length > i + 1e3, u = o.context.work(() => _w && _w() || Date.now() > s, i + (a ? 0 : 1e5));
    this.chunkBudget -= Date.now() - n, (u || this.chunkBudget <= 0) && (o.context.takeTree(), this.view.dispatch({ effects: gl.setState.of(new Am(o.context)) })), this.chunkBudget > 0 && !(u && !a) && this.scheduleWork(), this.checkAsyncSchedule(o.context);
  }
  checkAsyncSchedule(t) {
    t.scheduleOn && (this.workScheduled++, t.scheduleOn.then(() => this.scheduleWork()).catch((n) => Ts(this.view.state, n)).then(() => this.workScheduled--), t.scheduleOn = null);
  }
  destroy() {
    this.working && this.working();
  }
  isWorking() {
    return !!(this.working || this.workScheduled > 0);
  }
}, {
  eventHandlers: { focus() {
    this.scheduleWork();
  } }
}), yd = /* @__PURE__ */ zt.define({
  combine(e) {
    return e.length ? e[0] : null;
  },
  enables: (e) => [
    gl.state,
    Pot,
    Rt.contentAttributes.compute([e], (t) => {
      let n = t.facet(e);
      return n && n.name ? { "data-language": n.name } : {};
    })
  ]
});
class kot {
  /**
  Create a language support object.
  */
  constructor(t, n = []) {
    this.language = t, this.support = n, this.extension = [t, n];
  }
}
const Oot = /* @__PURE__ */ zt.define(), cT = /* @__PURE__ */ zt.define({
  combine: (e) => {
    if (!e.length)
      return "  ";
    let t = e[0];
    if (!t || /\S/.test(t) || Array.from(t).some((n) => n != t[0]))
      throw new Error("Invalid indent unit: " + JSON.stringify(e[0]));
    return t;
  }
});
function yC(e) {
  let t = e.facet(cT);
  return t.charCodeAt(0) == 9 ? e.tabSize * t.length : t.length;
}
function ab(e, t) {
  let n = "", r = e.tabSize, i = e.facet(cT)[0];
  if (i == "	") {
    for (; t >= r; )
      n += "	", t -= r;
    i = " ";
  }
  for (let o = 0; o < t; o++)
    n += i;
  return n;
}
function Z$(e, t) {
  e instanceof Jn && (e = new dT(e));
  for (let r of e.state.facet(Oot)) {
    let i = r(e, t);
    if (i !== void 0)
      return i;
  }
  let n = Bo(e.state);
  return n.length >= t ? Iot(e, n, t) : null;
}
class dT {
  /**
  Create an indent context.
  */
  constructor(t, n = {}) {
    this.state = t, this.options = n, this.unit = yC(t);
  }
  /**
  Get a description of the line at the given position, taking
  [simulated line
  breaks](https://codemirror.net/6/docs/ref/#language.IndentContext.constructor^options.simulateBreak)
  into account. If there is such a break at `pos`, the `bias`
  argument determines whether the part of the line line before or
  after the break is used.
  */
  lineAt(t, n = 1) {
    let r = this.state.doc.lineAt(t), { simulateBreak: i, simulateDoubleBreak: o } = this.options;
    return i != null && i >= r.from && i <= r.to ? o && i == t ? { text: "", from: t } : (n < 0 ? i < t : i <= t) ? { text: r.text.slice(i - r.from), from: i } : { text: r.text.slice(0, i - r.from), from: r.from } : r;
  }
  /**
  Get the text directly after `pos`, either the entire line
  or the next 100 characters, whichever is shorter.
  */
  textAfterPos(t, n = 1) {
    if (this.options.simulateDoubleBreak && t == this.options.simulateBreak)
      return "";
    let { text: r, from: i } = this.lineAt(t, n);
    return r.slice(t - i, Math.min(r.length, t + 100 - i));
  }
  /**
  Find the column for the given position.
  */
  column(t, n = 1) {
    let { text: r, from: i } = this.lineAt(t, n), o = this.countColumn(r, t - i), s = this.options.overrideIndentation ? this.options.overrideIndentation(i) : -1;
    return s > -1 && (o += s - this.countColumn(r, r.search(/\S|$/))), o;
  }
  /**
  Find the column position (taking tabs into account) of the given
  position in the given string.
  */
  countColumn(t, n = t.length) {
    return Cg(t, this.state.tabSize, n);
  }
  /**
  Find the indentation column of the line at the given point.
  */
  lineIndent(t, n = 1) {
    let { text: r, from: i } = this.lineAt(t, n), o = this.options.overrideIndentation;
    if (o) {
      let s = o(i);
      if (s > -1)
        return s;
    }
    return this.countColumn(r, r.search(/\S|$/));
  }
  /**
  Returns the [simulated line
  break](https://codemirror.net/6/docs/ref/#language.IndentContext.constructor^options.simulateBreak)
  for this context, if any.
  */
  get simulatedBreak() {
    return this.options.simulateBreak || null;
  }
}
const GY = /* @__PURE__ */ new jn();
function Iot(e, t, n) {
  let r = t.resolveStack(n), i = t.resolveInner(n, -1).resolve(n, 0).enterUnfinishedNodesBefore(n);
  if (i != r.node) {
    let o = [];
    for (let s = i; s && !(s.from == r.node.from && s.type == r.node.type); s = s.parent)
      o.push(s);
    for (let s = o.length - 1; s >= 0; s--)
      r = { node: o[s], next: r };
  }
  return YY(r, e, n);
}
function YY(e, t, n) {
  for (let r = e; r; r = r.next) {
    let i = $ot(r.node);
    if (i)
      return i(eN.create(t, n, r));
  }
  return 0;
}
function Fot(e) {
  return e.pos == e.options.simulateBreak && e.options.simulateDoubleBreak;
}
function $ot(e) {
  let t = e.type.prop(GY);
  if (t)
    return t;
  let n = e.firstChild, r;
  if (n && (r = n.type.prop(jn.closedBy))) {
    let i = e.lastChild, o = i && r.indexOf(i.name) > -1;
    return (s) => _ot(s, !0, 1, void 0, o && !Fot(s) ? i.from : void 0);
  }
  return e.parent == null ? Not : null;
}
function Not() {
  return 0;
}
class eN extends dT {
  constructor(t, n, r) {
    super(t.state, t.options), this.base = t, this.pos = n, this.context = r;
  }
  /**
  The syntax tree node to which the indentation strategy
  applies.
  */
  get node() {
    return this.context.node;
  }
  /**
  @internal
  */
  static create(t, n, r) {
    return new eN(t, n, r);
  }
  /**
  Get the text directly after `this.pos`, either the entire line
  or the next 100 characters, whichever is shorter.
  */
  get textAfter() {
    return this.textAfterPos(this.pos);
  }
  /**
  Get the indentation at the reference line for `this.node`, which
  is the line on which it starts, unless there is a node that is
  _not_ a parent of this node covering the start of that line. If
  so, the line at the start of that node is tried, again skipping
  on if it is covered by another such node.
  */
  get baseIndent() {
    return this.baseIndentFor(this.node);
  }
  /**
  Get the indentation for the reference line of the given node
  (see [`baseIndent`](https://codemirror.net/6/docs/ref/#language.TreeIndentContext.baseIndent)).
  */
  baseIndentFor(t) {
    let n = this.state.doc.lineAt(t.from);
    for (; ; ) {
      let r = t.resolve(n.from);
      for (; r.parent && r.parent.from == r.from; )
        r = r.parent;
      if (Mot(r, t))
        break;
      n = this.state.doc.lineAt(r.from);
    }
    return this.lineIndent(n.from);
  }
  /**
  Continue looking for indentations in the node's parent nodes,
  and return the result of that.
  */
  continue() {
    return YY(this.context.next, this.base, this.pos);
  }
}
function Mot(e, t) {
  for (let n = t; n; n = n.parent)
    if (e == n)
      return !0;
  return !1;
}
function Rot(e) {
  let t = e.node, n = t.childAfter(t.from), r = t.lastChild;
  if (!n)
    return null;
  let i = e.options.simulateBreak, o = e.state.doc.lineAt(n.from), s = i == null || i <= o.from ? o.to : Math.min(o.to, i);
  for (let a = n.to; ; ) {
    let u = t.childAfter(a);
    if (!u || u == r)
      return null;
    if (!u.type.isSkipped) {
      if (u.from >= s)
        return null;
      let c = /^ */.exec(o.text.slice(n.to - o.from))[0].length;
      return { from: n.from, to: n.to + c };
    }
    a = u.to;
  }
}
function _ot(e, t, n, r, i) {
  let o = e.textAfter, s = o.match(/^\s*/)[0].length, a = i == e.pos + s, u = Rot(e);
  return u ? a ? e.column(u.from) : e.column(u.to) : e.baseIndent + (a ? 0 : e.unit * n);
}
function $5({ except: e, units: t = 1 } = {}) {
  return (n) => {
    let r = e && e.test(n.textAfter);
    return n.baseIndent + (r ? 0 : t * n.unit);
  };
}
const Lot = 200;
function Bot() {
  return Jn.transactionFilter.of((e) => {
    if (!e.docChanged || !e.isUserEvent("input.type") && !e.isUserEvent("input.complete"))
      return e;
    let t = e.startState.languageDataAt("indentOnInput", e.startState.selection.main.head);
    if (!t.length)
      return e;
    let n = e.newDoc, { head: r } = e.newSelection.main, i = n.lineAt(r);
    if (r > i.from + Lot)
      return e;
    let o = n.sliceString(i.from, r);
    if (!t.some((c) => c.test(o)))
      return e;
    let { state: s } = e, a = -1, u = [];
    for (let { head: c } of s.selection.ranges) {
      let d = s.doc.lineAt(c);
      if (d.from == a)
        continue;
      a = d.from;
      let f = Z$(s, d.from);
      if (f == null)
        continue;
      let h = /^\s*/.exec(d.text)[0], m = ab(s, f);
      h != m && u.push({ from: d.from, to: d.from + h.length, insert: m });
    }
    return u.length ? [e, { changes: u, sequential: !0 }] : e;
  });
}
const jot = /* @__PURE__ */ zt.define(), KY = /* @__PURE__ */ new jn();
function Vot(e) {
  let t = e.firstChild, n = e.lastChild;
  return t && t.to < n.from ? { from: t.to, to: n.type.isError ? e.to : n.from } : null;
}
function zot(e, t, n) {
  let r = Bo(e);
  if (r.length < n)
    return null;
  let i = r.resolveStack(n, 1), o = null;
  for (let s = i; s; s = s.next) {
    let a = s.node;
    if (a.to <= n || a.from > n)
      continue;
    if (o && a.from < t)
      break;
    let u = a.type.prop(KY);
    if (u && (a.to < r.length - 50 || r.length == e.doc.length || !Uot(a))) {
      let c = u(a, e);
      c && c.from <= n && c.from >= t && c.to > n && (o = c);
    }
  }
  return o;
}
function Uot(e) {
  let t = e.lastChild;
  return t && t.to == e.to && t.type.isError;
}
function bC(e, t, n) {
  for (let r of e.facet(jot)) {
    let i = r(e, t, n);
    if (i)
      return i;
  }
  return zot(e, t, n);
}
function JY(e, t) {
  let n = t.mapPos(e.from, 1), r = t.mapPos(e.to, -1);
  return n >= r ? void 0 : { from: n, to: r };
}
const pT = /* @__PURE__ */ An.define({ map: JY }), xv = /* @__PURE__ */ An.define({ map: JY });
function XY(e) {
  let t = [];
  for (let { head: n } of e.state.selection.ranges)
    t.some((r) => r.from <= n && r.to >= n) || t.push(e.lineBlockAt(n));
  return t;
}
const nf = /* @__PURE__ */ wo.define({
  create() {
    return tn.none;
  },
  update(e, t) {
    e = e.map(t.changes);
    for (let n of t.effects)
      if (n.is(pT) && !Wot(e, n.value.from, n.value.to)) {
        let { preparePlaceholder: r } = t.state.facet(eK), i = r ? tn.replace({ widget: new Xot(r(t.state, n.value)) }) : N5;
        e = e.update({ add: [i.range(n.value.from, n.value.to)] });
      } else n.is(xv) && (e = e.update({
        filter: (r, i) => n.value.from != r || n.value.to != i,
        filterFrom: n.value.from,
        filterTo: n.value.to
      }));
    if (t.selection) {
      let n = !1, { head: r } = t.selection.main;
      e.between(r, r, (i, o) => {
        i < r && o > r && (n = !0);
      }), n && (e = e.update({
        filterFrom: r,
        filterTo: r,
        filter: (i, o) => o <= r || i >= r
      }));
    }
    return e;
  },
  provide: (e) => Rt.decorations.from(e),
  toJSON(e, t) {
    let n = [];
    return e.between(0, t.doc.length, (r, i) => {
      n.push(r, i);
    }), n;
  },
  fromJSON(e) {
    if (!Array.isArray(e) || e.length % 2)
      throw new RangeError("Invalid JSON for fold state");
    let t = [];
    for (let n = 0; n < e.length; ) {
      let r = e[n++], i = e[n++];
      if (typeof r != "number" || typeof i != "number")
        throw new RangeError("Invalid JSON for fold state");
      t.push(N5.range(r, i));
    }
    return tn.set(t, !0);
  }
});
function vC(e, t, n) {
  var r;
  let i = null;
  return (r = e.field(nf, !1)) === null || r === void 0 || r.between(t, n, (o, s) => {
    (!i || i.from > o) && (i = { from: o, to: s });
  }), i;
}
function Wot(e, t, n) {
  let r = !1;
  return e.between(t, t, (i, o) => {
    i == t && o == n && (r = !0);
  }), r;
}
function QY(e, t) {
  return e.field(nf, !1) ? t : t.concat(An.appendConfig.of(tK()));
}
const Hot = (e) => {
  for (let t of XY(e)) {
    let n = bC(e.state, t.from, t.to);
    if (n)
      return e.dispatch({ effects: QY(e.state, [pT.of(n), ZY(e, n)]) }), !0;
  }
  return !1;
}, qot = (e) => {
  if (!e.state.field(nf, !1))
    return !1;
  let t = [];
  for (let n of XY(e)) {
    let r = vC(e.state, n.from, n.to);
    r && t.push(xv.of(r), ZY(e, r, !1));
  }
  return t.length && e.dispatch({ effects: t }), t.length > 0;
};
function ZY(e, t, n = !0) {
  let r = e.state.doc.lineAt(t.from).number, i = e.state.doc.lineAt(t.to).number;
  return Rt.announce.of(`${e.state.phrase(n ? "Folded lines" : "Unfolded lines")} ${r} ${e.state.phrase("to")} ${i}.`);
}
const Got = (e) => {
  let { state: t } = e, n = [];
  for (let r = 0; r < t.doc.length; ) {
    let i = e.lineBlockAt(r), o = bC(t, i.from, i.to);
    o && n.push(pT.of(o)), r = (o ? e.lineBlockAt(o.to) : i).to + 1;
  }
  return n.length && e.dispatch({ effects: QY(e.state, n) }), !!n.length;
}, Yot = (e) => {
  let t = e.state.field(nf, !1);
  if (!t || !t.size)
    return !1;
  let n = [];
  return t.between(0, e.state.doc.length, (r, i) => {
    n.push(xv.of({ from: r, to: i }));
  }), e.dispatch({ effects: n }), !0;
}, Kot = [
  { key: "Ctrl-Shift-[", mac: "Cmd-Alt-[", run: Hot },
  { key: "Ctrl-Shift-]", mac: "Cmd-Alt-]", run: qot },
  { key: "Ctrl-Alt-[", run: Got },
  { key: "Ctrl-Alt-]", run: Yot }
], Jot = {
  placeholderDOM: null,
  preparePlaceholder: null,
  placeholderText: "…"
}, eK = /* @__PURE__ */ zt.define({
  combine(e) {
    return wu(e, Jot);
  }
});
function tK(e) {
  return [nf, est];
}
function nK(e, t) {
  let { state: n } = e, r = n.facet(eK), i = (s) => {
    let a = e.lineBlockAt(e.posAtDOM(s.target)), u = vC(e.state, a.from, a.to);
    u && e.dispatch({ effects: xv.of(u) }), s.preventDefault();
  };
  if (r.placeholderDOM)
    return r.placeholderDOM(e, i, t);
  let o = document.createElement("span");
  return o.textContent = r.placeholderText, o.setAttribute("aria-label", n.phrase("folded code")), o.title = n.phrase("unfold"), o.className = "cm-foldPlaceholder", o.onclick = i, o;
}
const N5 = /* @__PURE__ */ tn.replace({ widget: /* @__PURE__ */ new class extends xc {
  toDOM(e) {
    return nK(e, null);
  }
}() });
class Xot extends xc {
  constructor(t) {
    super(), this.value = t;
  }
  eq(t) {
    return this.value == t.value;
  }
  toDOM(t) {
    return nK(t, this.value);
  }
}
const Qot = {
  openText: "⌄",
  closedText: "›",
  markerDOM: null,
  domEventHandlers: {},
  foldingChanged: () => !1
};
class Lw extends dc {
  constructor(t, n) {
    super(), this.config = t, this.open = n;
  }
  eq(t) {
    return this.config == t.config && this.open == t.open;
  }
  toDOM(t) {
    if (this.config.markerDOM)
      return this.config.markerDOM(this.open);
    let n = document.createElement("span");
    return n.textContent = this.open ? this.config.openText : this.config.closedText, n.title = t.state.phrase(this.open ? "Fold line" : "Unfold line"), n;
  }
}
function Zot(e = {}) {
  let t = Object.assign(Object.assign({}, Qot), e), n = new Lw(t, !0), r = new Lw(t, !1), i = Pi.fromClass(class {
    constructor(s) {
      this.from = s.viewport.from, this.markers = this.buildMarkers(s);
    }
    update(s) {
      (s.docChanged || s.viewportChanged || s.startState.facet(yd) != s.state.facet(yd) || s.startState.field(nf, !1) != s.state.field(nf, !1) || Bo(s.startState) != Bo(s.state) || t.foldingChanged(s)) && (this.markers = this.buildMarkers(s.view));
    }
    buildMarkers(s) {
      let a = new uc();
      for (let u of s.viewportLineBlocks) {
        let c = vC(s.state, u.from, u.to) ? r : bC(s.state, u.from, u.to) ? n : null;
        c && a.add(u.from, u.from, c);
      }
      return a.finish();
    }
  }), { domEventHandlers: o } = t;
  return [
    i,
    Zit({
      class: "cm-foldGutter",
      markers(s) {
        var a;
        return ((a = s.plugin(i)) === null || a === void 0 ? void 0 : a.markers) || ir.empty;
      },
      initialSpacer() {
        return new Lw(t, !1);
      },
      domEventHandlers: Object.assign(Object.assign({}, o), { click: (s, a, u) => {
        if (o.click && o.click(s, a, u))
          return !0;
        let c = vC(s.state, a.from, a.to);
        if (c)
          return s.dispatch({ effects: xv.of(c) }), !0;
        let d = bC(s.state, a.from, a.to);
        return d ? (s.dispatch({ effects: pT.of(d) }), !0) : !1;
      } })
    }),
    tK()
  ];
}
const est = /* @__PURE__ */ Rt.baseTheme({
  ".cm-foldPlaceholder": {
    backgroundColor: "#eee",
    border: "1px solid #ddd",
    color: "#888",
    borderRadius: ".2em",
    margin: "0 1px",
    padding: "0 1px",
    cursor: "pointer"
  },
  ".cm-foldGutter span": {
    padding: "0 1px",
    cursor: "pointer"
  }
});
class Dv {
  constructor(t, n) {
    this.specs = t;
    let r;
    function i(a) {
      let u = fd.newName();
      return (r || (r = /* @__PURE__ */ Object.create(null)))["." + u] = a, u;
    }
    const o = typeof n.all == "string" ? n.all : n.all ? i(n.all) : void 0, s = n.scope;
    this.scope = s instanceof gl ? (a) => a.prop(_h) == s.data : s ? (a) => a == s : void 0, this.style = HY(t.map((a) => ({
      tag: a.tag,
      class: a.class || i(Object.assign({}, a, { tag: null }))
    })), {
      all: o
    }).style, this.module = r ? new fd(r) : null, this.themeType = n.themeType;
  }
  /**
  Create a highlighter style that associates the given styles to
  the given tags. The specs must be objects that hold a style tag
  or array of tags in their `tag` property, and either a single
  `class` property providing a static CSS class (for highlighter
  that rely on external styling), or a
  [`style-mod`](https://github.com/marijnh/style-mod#documentation)-style
  set of CSS properties (which define the styling for those tags).
  
  The CSS rules created for a highlighter will be emitted in the
  order of the spec's properties. That means that for elements that
  have multiple tags associated with them, styles defined further
  down in the list will have a higher CSS precedence than styles
  defined earlier.
  */
  static define(t, n) {
    return new Dv(t, n || {});
  }
}
const eO = /* @__PURE__ */ zt.define(), rK = /* @__PURE__ */ zt.define({
  combine(e) {
    return e.length ? [e[0]] : null;
  }
});
function Bw(e) {
  let t = e.facet(eO);
  return t.length ? t : e.facet(rK);
}
function iK(e, t) {
  let n = [nst], r;
  return e instanceof Dv && (e.module && n.push(Rt.styleModule.of(e.module)), r = e.themeType), t != null && t.fallback ? n.push(rK.of(e)) : r ? n.push(eO.computeN([Rt.darkTheme], (i) => i.facet(Rt.darkTheme) == (r == "dark") ? [e] : [])) : n.push(eO.of(e)), n;
}
class tst {
  constructor(t) {
    this.markCache = /* @__PURE__ */ Object.create(null), this.tree = Bo(t.state), this.decorations = this.buildDeco(t, Bw(t.state)), this.decoratedTo = t.viewport.to;
  }
  update(t) {
    let n = Bo(t.state), r = Bw(t.state), i = r != Bw(t.startState), { viewport: o } = t.view, s = t.changes.mapPos(this.decoratedTo, 1);
    n.length < o.to && !i && n.type == this.tree.type && s >= o.to ? (this.decorations = this.decorations.map(t.changes), this.decoratedTo = s) : (n != this.tree || t.viewportChanged || i) && (this.tree = n, this.decorations = this.buildDeco(t.view, r), this.decoratedTo = o.to);
  }
  buildDeco(t, n) {
    if (!n || !this.tree.length)
      return tn.none;
    let r = new uc();
    for (let { from: i, to: o } of t.visibleRanges)
      Cot(this.tree, n, (s, a, u) => {
        r.add(s, a, this.markCache[u] || (this.markCache[u] = tn.mark({ class: u })));
      }, i, o);
    return r.finish();
  }
}
const nst = /* @__PURE__ */ Pf.high(/* @__PURE__ */ Pi.fromClass(tst, {
  decorations: (e) => e.decorations
})), rst = /* @__PURE__ */ Dv.define([
  {
    tag: Ge.meta,
    color: "#404740"
  },
  {
    tag: Ge.link,
    textDecoration: "underline"
  },
  {
    tag: Ge.heading,
    textDecoration: "underline",
    fontWeight: "bold"
  },
  {
    tag: Ge.emphasis,
    fontStyle: "italic"
  },
  {
    tag: Ge.strong,
    fontWeight: "bold"
  },
  {
    tag: Ge.strikethrough,
    textDecoration: "line-through"
  },
  {
    tag: Ge.keyword,
    color: "#708"
  },
  {
    tag: [Ge.atom, Ge.bool, Ge.url, Ge.contentSeparator, Ge.labelName],
    color: "#219"
  },
  {
    tag: [Ge.literal, Ge.inserted],
    color: "#164"
  },
  {
    tag: [Ge.string, Ge.deleted],
    color: "#a11"
  },
  {
    tag: [Ge.regexp, Ge.escape, /* @__PURE__ */ Ge.special(Ge.string)],
    color: "#e40"
  },
  {
    tag: /* @__PURE__ */ Ge.definition(Ge.variableName),
    color: "#00f"
  },
  {
    tag: /* @__PURE__ */ Ge.local(Ge.variableName),
    color: "#30a"
  },
  {
    tag: [Ge.typeName, Ge.namespace],
    color: "#085"
  },
  {
    tag: Ge.className,
    color: "#167"
  },
  {
    tag: [/* @__PURE__ */ Ge.special(Ge.variableName), Ge.macroName],
    color: "#256"
  },
  {
    tag: /* @__PURE__ */ Ge.definition(Ge.propertyName),
    color: "#00c"
  },
  {
    tag: Ge.comment,
    color: "#940"
  },
  {
    tag: Ge.invalid,
    color: "#f00"
  }
]), ist = /* @__PURE__ */ Rt.baseTheme({
  "&.cm-focused .cm-matchingBracket": { backgroundColor: "#328c8252" },
  "&.cm-focused .cm-nonmatchingBracket": { backgroundColor: "#bb555544" }
}), oK = 1e4, sK = "()[]{}", aK = /* @__PURE__ */ zt.define({
  combine(e) {
    return wu(e, {
      afterCursor: !0,
      brackets: sK,
      maxScanDistance: oK,
      renderMatch: ast
    });
  }
}), ost = /* @__PURE__ */ tn.mark({ class: "cm-matchingBracket" }), sst = /* @__PURE__ */ tn.mark({ class: "cm-nonmatchingBracket" });
function ast(e) {
  let t = [], n = e.matched ? ost : sst;
  return t.push(n.range(e.start.from, e.start.to)), e.end && t.push(n.range(e.end.from, e.end.to)), t;
}
const lst = /* @__PURE__ */ wo.define({
  create() {
    return tn.none;
  },
  update(e, t) {
    if (!t.docChanged && !t.selection)
      return e;
    let n = [], r = t.state.facet(aK);
    for (let i of t.state.selection.ranges) {
      if (!i.empty)
        continue;
      let o = nu(t.state, i.head, -1, r) || i.head > 0 && nu(t.state, i.head - 1, 1, r) || r.afterCursor && (nu(t.state, i.head, 1, r) || i.head < t.state.doc.length && nu(t.state, i.head + 1, -1, r));
      o && (n = n.concat(r.renderMatch(o, t.state)));
    }
    return tn.set(n, !0);
  },
  provide: (e) => Rt.decorations.from(e)
}), ust = [
  lst,
  ist
];
function cst(e = {}) {
  return [aK.of(e), ust];
}
const dst = /* @__PURE__ */ new jn();
function tO(e, t, n) {
  let r = e.prop(t < 0 ? jn.openedBy : jn.closedBy);
  if (r)
    return r;
  if (e.name.length == 1) {
    let i = n.indexOf(e.name);
    if (i > -1 && i % 2 == (t < 0 ? 1 : 0))
      return [n[i + t]];
  }
  return null;
}
function nO(e) {
  let t = e.type.prop(dst);
  return t ? t(e.node) : e;
}
function nu(e, t, n, r = {}) {
  let i = r.maxScanDistance || oK, o = r.brackets || sK, s = Bo(e), a = s.resolveInner(t, n);
  for (let u = a; u; u = u.parent) {
    let c = tO(u.type, n, o);
    if (c && u.from < u.to) {
      let d = nO(u);
      if (d && (n > 0 ? t >= d.from && t < d.to : t > d.from && t <= d.to))
        return pst(e, t, n, u, d, c, o);
    }
  }
  return fst(e, t, n, s, a.type, i, o);
}
function pst(e, t, n, r, i, o, s) {
  let a = r.parent, u = { from: i.from, to: i.to }, c = 0, d = a == null ? void 0 : a.cursor();
  if (d && (n < 0 ? d.childBefore(r.from) : d.childAfter(r.to)))
    do
      if (n < 0 ? d.to <= r.from : d.from >= r.to) {
        if (c == 0 && o.indexOf(d.type.name) > -1 && d.from < d.to) {
          let f = nO(d);
          return { start: u, end: f ? { from: f.from, to: f.to } : void 0, matched: !0 };
        } else if (tO(d.type, n, s))
          c++;
        else if (tO(d.type, -n, s)) {
          if (c == 0) {
            let f = nO(d);
            return {
              start: u,
              end: f && f.from < f.to ? { from: f.from, to: f.to } : void 0,
              matched: !1
            };
          }
          c--;
        }
      }
    while (n < 0 ? d.prevSibling() : d.nextSibling());
  return { start: u, matched: !1 };
}
function fst(e, t, n, r, i, o, s) {
  let a = n < 0 ? e.sliceDoc(t - 1, t) : e.sliceDoc(t, t + 1), u = s.indexOf(a);
  if (u < 0 || u % 2 == 0 != n > 0)
    return null;
  let c = { from: n < 0 ? t - 1 : t, to: n > 0 ? t + 1 : t }, d = e.doc.iterRange(t, n > 0 ? e.doc.length : 0), f = 0;
  for (let h = 0; !d.next().done && h <= o; ) {
    let m = d.value;
    n < 0 && (h += m.length);
    let v = t + h * n;
    for (let x = n > 0 ? 0 : m.length - 1, C = n > 0 ? m.length : -1; x != C; x += n) {
      let E = s.indexOf(m[x]);
      if (!(E < 0 || r.resolveInner(v + x, 1).type != i))
        if (E % 2 == 0 == n > 0)
          f++;
        else {
          if (f == 1)
            return { start: c, end: { from: v + x, to: v + x + 1 }, matched: E >> 1 == u >> 1 };
          f--;
        }
    }
    n > 0 && (h += m.length);
  }
  return d.done ? { start: c, matched: !1 } : null;
}
const hst = /* @__PURE__ */ Object.create(null), M5 = [Ns.none], R5 = [], _5 = /* @__PURE__ */ Object.create(null), mst = /* @__PURE__ */ Object.create(null);
for (let [e, t] of [
  ["variable", "variableName"],
  ["variable-2", "variableName.special"],
  ["string-2", "string.special"],
  ["def", "variableName.definition"],
  ["tag", "tagName"],
  ["attribute", "attributeName"],
  ["type", "typeName"],
  ["builtin", "variableName.standard"],
  ["qualifier", "modifier"],
  ["error", "invalid"],
  ["header", "heading"],
  ["property", "propertyName"]
])
  mst[e] = /* @__PURE__ */ gst(hst, t);
function jw(e, t) {
  R5.indexOf(e) > -1 || (R5.push(e), console.warn(t));
}
function gst(e, t) {
  let n = [];
  for (let a of t.split(" ")) {
    let u = [];
    for (let c of a.split(".")) {
      let d = e[c] || Ge[c];
      d ? typeof d == "function" ? u.length ? u = u.map(d) : jw(c, `Modifier ${c} used at start of tag`) : u.length ? jw(c, `Tag ${c} used as modifier`) : u = Array.isArray(d) ? d : [d] : jw(c, `Unknown highlighting tag ${c}`);
    }
    for (let c of u)
      n.push(c);
  }
  if (!n.length)
    return 0;
  let r = t.replace(/ /g, "_"), i = r + " " + n.map((a) => a.id), o = _5[i];
  if (o)
    return o.id;
  let s = _5[i] = Ns.define({
    id: M5.length,
    name: r,
    props: [UY({ [r]: n })]
  });
  return M5.push(s), s.id;
}
Jr.RTL, Jr.LTR;
const yst = (e) => {
  let { state: t } = e, n = t.doc.lineAt(t.selection.main.from), r = nN(e.state, n.from);
  return r.line ? bst(e) : r.block ? xst(e) : !1;
};
function tN(e, t) {
  return ({ state: n, dispatch: r }) => {
    if (n.readOnly)
      return !1;
    let i = e(t, n);
    return i ? (r(n.update(i)), !0) : !1;
  };
}
const bst = /* @__PURE__ */ tN(
  Est,
  0
  /* CommentOption.Toggle */
), vst = /* @__PURE__ */ tN(
  lK,
  0
  /* CommentOption.Toggle */
), xst = /* @__PURE__ */ tN(
  (e, t) => lK(e, t, Cst(t)),
  0
  /* CommentOption.Toggle */
);
function nN(e, t) {
  let n = e.languageDataAt("commentTokens", t);
  return n.length ? n[0] : {};
}
const By = 50;
function Dst(e, { open: t, close: n }, r, i) {
  let o = e.sliceDoc(r - By, r), s = e.sliceDoc(i, i + By), a = /\s*$/.exec(o)[0].length, u = /^\s*/.exec(s)[0].length, c = o.length - a;
  if (o.slice(c - t.length, c) == t && s.slice(u, u + n.length) == n)
    return {
      open: { pos: r - a, margin: a && 1 },
      close: { pos: i + u, margin: u && 1 }
    };
  let d, f;
  i - r <= 2 * By ? d = f = e.sliceDoc(r, i) : (d = e.sliceDoc(r, r + By), f = e.sliceDoc(i - By, i));
  let h = /^\s*/.exec(d)[0].length, m = /\s*$/.exec(f)[0].length, v = f.length - m - n.length;
  return d.slice(h, h + t.length) == t && f.slice(v, v + n.length) == n ? {
    open: {
      pos: r + h + t.length,
      margin: /\s/.test(d.charAt(h + t.length)) ? 1 : 0
    },
    close: {
      pos: i - m - n.length,
      margin: /\s/.test(f.charAt(v - 1)) ? 1 : 0
    }
  } : null;
}
function Cst(e) {
  let t = [];
  for (let n of e.selection.ranges) {
    let r = e.doc.lineAt(n.from), i = n.to <= r.to ? r : e.doc.lineAt(n.to);
    i.from > r.from && i.from == n.to && (i = n.to == r.to + 1 ? r : e.doc.lineAt(n.to - 1));
    let o = t.length - 1;
    o >= 0 && t[o].to > r.from ? t[o].to = i.to : t.push({ from: r.from + /^\s*/.exec(r.text)[0].length, to: i.to });
  }
  return t;
}
function lK(e, t, n = t.selection.ranges) {
  let r = n.map((o) => nN(t, o.from).block);
  if (!r.every((o) => o))
    return null;
  let i = n.map((o, s) => Dst(t, r[s], o.from, o.to));
  if (e != 2 && !i.every((o) => o))
    return { changes: t.changes(n.map((o, s) => i[s] ? [] : [{ from: o.from, insert: r[s].open + " " }, { from: o.to, insert: " " + r[s].close }])) };
  if (e != 1 && i.some((o) => o)) {
    let o = [];
    for (let s = 0, a; s < i.length; s++)
      if (a = i[s]) {
        let u = r[s], { open: c, close: d } = a;
        o.push({ from: c.pos - u.open.length, to: c.pos + c.margin }, { from: d.pos - d.margin, to: d.pos + u.close.length });
      }
    return { changes: o };
  }
  return null;
}
function Est(e, t, n = t.selection.ranges) {
  let r = [], i = -1;
  for (let { from: o, to: s } of n) {
    let a = r.length, u = 1e9, c = nN(t, o).line;
    if (c) {
      for (let d = o; d <= s; ) {
        let f = t.doc.lineAt(d);
        if (f.from > i && (o == s || s > f.from)) {
          i = f.from;
          let h = /^\s*/.exec(f.text)[0].length, m = h == f.length, v = f.text.slice(h, h + c.length) == c ? h : -1;
          h < f.text.length && h < u && (u = h), r.push({ line: f, comment: v, token: c, indent: h, empty: m, single: !1 });
        }
        d = f.to + 1;
      }
      if (u < 1e9)
        for (let d = a; d < r.length; d++)
          r[d].indent < r[d].line.text.length && (r[d].indent = u);
      r.length == a + 1 && (r[a].single = !0);
    }
  }
  if (e != 2 && r.some((o) => o.comment < 0 && (!o.empty || o.single))) {
    let o = [];
    for (let { line: a, token: u, indent: c, empty: d, single: f } of r)
      (f || !d) && o.push({ from: a.from + c, insert: u + " " });
    let s = t.changes(o);
    return { changes: s, selection: t.selection.map(s, 1) };
  } else if (e != 1 && r.some((o) => o.comment >= 0)) {
    let o = [];
    for (let { line: s, comment: a, token: u } of r)
      if (a >= 0) {
        let c = s.from + a, d = c + u.length;
        s.text[d - s.from] == " " && d++, o.push({ from: c, to: d });
      }
    return { changes: o };
  }
  return null;
}
const rO = /* @__PURE__ */ Au.define(), Tst = /* @__PURE__ */ Au.define(), Sst = /* @__PURE__ */ zt.define(), uK = /* @__PURE__ */ zt.define({
  combine(e) {
    return wu(e, {
      minDepth: 100,
      newGroupDelay: 500,
      joinToEvent: (t, n) => n
    }, {
      minDepth: Math.max,
      newGroupDelay: Math.min,
      joinToEvent: (t, n) => (r, i) => t(r, i) || n(r, i)
    });
  }
}), cK = /* @__PURE__ */ wo.define({
  create() {
    return ru.empty;
  },
  update(e, t) {
    let n = t.state.facet(uK), r = t.annotation(rO);
    if (r) {
      let u = Ss.fromTransaction(t, r.selection), c = r.side, d = c == 0 ? e.undone : e.done;
      return u ? d = xC(d, d.length, n.minDepth, u) : d = fK(d, t.startState.selection), new ru(c == 0 ? r.rest : d, c == 0 ? d : r.rest);
    }
    let i = t.annotation(Tst);
    if ((i == "full" || i == "before") && (e = e.isolate()), t.annotation(Wi.addToHistory) === !1)
      return t.changes.empty ? e : e.addMapping(t.changes.desc);
    let o = Ss.fromTransaction(t), s = t.annotation(Wi.time), a = t.annotation(Wi.userEvent);
    return o ? e = e.addChanges(o, s, a, n, t) : t.selection && (e = e.addSelection(t.startState.selection, s, a, n.newGroupDelay)), (i == "full" || i == "after") && (e = e.isolate()), e;
  },
  toJSON(e) {
    return { done: e.done.map((t) => t.toJSON()), undone: e.undone.map((t) => t.toJSON()) };
  },
  fromJSON(e) {
    return new ru(e.done.map(Ss.fromJSON), e.undone.map(Ss.fromJSON));
  }
});
function Ast(e = {}) {
  return [
    cK,
    uK.of(e),
    Rt.domEventHandlers({
      beforeinput(t, n) {
        let r = t.inputType == "historyUndo" ? dK : t.inputType == "historyRedo" ? iO : null;
        return r ? (t.preventDefault(), r(n)) : !1;
      }
    })
  ];
}
function fT(e, t) {
  return function({ state: n, dispatch: r }) {
    if (!t && n.readOnly)
      return !1;
    let i = n.field(cK, !1);
    if (!i)
      return !1;
    let o = i.pop(e, n, t);
    return o ? (r(o), !0) : !1;
  };
}
const dK = /* @__PURE__ */ fT(0, !1), iO = /* @__PURE__ */ fT(1, !1), wst = /* @__PURE__ */ fT(0, !0), Pst = /* @__PURE__ */ fT(1, !0);
class Ss {
  constructor(t, n, r, i, o) {
    this.changes = t, this.effects = n, this.mapped = r, this.startSelection = i, this.selectionsAfter = o;
  }
  setSelAfter(t) {
    return new Ss(this.changes, this.effects, this.mapped, this.startSelection, t);
  }
  toJSON() {
    var t, n, r;
    return {
      changes: (t = this.changes) === null || t === void 0 ? void 0 : t.toJSON(),
      mapped: (n = this.mapped) === null || n === void 0 ? void 0 : n.toJSON(),
      startSelection: (r = this.startSelection) === null || r === void 0 ? void 0 : r.toJSON(),
      selectionsAfter: this.selectionsAfter.map((i) => i.toJSON())
    };
  }
  static fromJSON(t) {
    return new Ss(t.changes && Ui.fromJSON(t.changes), [], t.mapped && pu.fromJSON(t.mapped), t.startSelection && it.fromJSON(t.startSelection), t.selectionsAfter.map(it.fromJSON));
  }
  // This does not check `addToHistory` and such, it assumes the
  // transaction needs to be converted to an item. Returns null when
  // there are no changes or effects in the transaction.
  static fromTransaction(t, n) {
    let r = Fa;
    for (let i of t.startState.facet(Sst)) {
      let o = i(t);
      o.length && (r = r.concat(o));
    }
    return !r.length && t.changes.empty ? null : new Ss(t.changes.invert(t.startState.doc), r, void 0, n || t.startState.selection, Fa);
  }
  static selection(t) {
    return new Ss(void 0, Fa, void 0, void 0, t);
  }
}
function xC(e, t, n, r) {
  let i = t + 1 > n + 20 ? t - n - 1 : 0, o = e.slice(i, t);
  return o.push(r), o;
}
function kst(e, t) {
  let n = [], r = !1;
  return e.iterChangedRanges((i, o) => n.push(i, o)), t.iterChangedRanges((i, o, s, a) => {
    for (let u = 0; u < n.length; ) {
      let c = n[u++], d = n[u++];
      a >= c && s <= d && (r = !0);
    }
  }), r;
}
function Ost(e, t) {
  return e.ranges.length == t.ranges.length && e.ranges.filter((n, r) => n.empty != t.ranges[r].empty).length === 0;
}
function pK(e, t) {
  return e.length ? t.length ? e.concat(t) : e : t;
}
const Fa = [], Ist = 200;
function fK(e, t) {
  if (e.length) {
    let n = e[e.length - 1], r = n.selectionsAfter.slice(Math.max(0, n.selectionsAfter.length - Ist));
    return r.length && r[r.length - 1].eq(t) ? e : (r.push(t), xC(e, e.length - 1, 1e9, n.setSelAfter(r)));
  } else
    return [Ss.selection([t])];
}
function Fst(e) {
  let t = e[e.length - 1], n = e.slice();
  return n[e.length - 1] = t.setSelAfter(t.selectionsAfter.slice(0, t.selectionsAfter.length - 1)), n;
}
function Vw(e, t) {
  if (!e.length)
    return e;
  let n = e.length, r = Fa;
  for (; n; ) {
    let i = $st(e[n - 1], t, r);
    if (i.changes && !i.changes.empty || i.effects.length) {
      let o = e.slice(0, n);
      return o[n - 1] = i, o;
    } else
      t = i.mapped, n--, r = i.selectionsAfter;
  }
  return r.length ? [Ss.selection(r)] : Fa;
}
function $st(e, t, n) {
  let r = pK(e.selectionsAfter.length ? e.selectionsAfter.map((a) => a.map(t)) : Fa, n);
  if (!e.changes)
    return Ss.selection(r);
  let i = e.changes.map(t), o = t.mapDesc(e.changes, !0), s = e.mapped ? e.mapped.composeDesc(o) : o;
  return new Ss(i, An.mapEffects(e.effects, t), s, e.startSelection.map(o), r);
}
const Nst = /^(input\.type|delete)($|\.)/;
class ru {
  constructor(t, n, r = 0, i = void 0) {
    this.done = t, this.undone = n, this.prevTime = r, this.prevUserEvent = i;
  }
  isolate() {
    return this.prevTime ? new ru(this.done, this.undone) : this;
  }
  addChanges(t, n, r, i, o) {
    let s = this.done, a = s[s.length - 1];
    return a && a.changes && !a.changes.empty && t.changes && (!r || Nst.test(r)) && (!a.selectionsAfter.length && n - this.prevTime < i.newGroupDelay && i.joinToEvent(o, kst(a.changes, t.changes)) || // For compose (but not compose.start) events, always join with previous event
    r == "input.type.compose") ? s = xC(s, s.length - 1, i.minDepth, new Ss(t.changes.compose(a.changes), pK(An.mapEffects(t.effects, a.changes), a.effects), a.mapped, a.startSelection, Fa)) : s = xC(s, s.length, i.minDepth, t), new ru(s, Fa, n, r);
  }
  addSelection(t, n, r, i) {
    let o = this.done.length ? this.done[this.done.length - 1].selectionsAfter : Fa;
    return o.length > 0 && n - this.prevTime < i && r == this.prevUserEvent && r && /^select($|\.)/.test(r) && Ost(o[o.length - 1], t) ? this : new ru(fK(this.done, t), this.undone, n, r);
  }
  addMapping(t) {
    return new ru(Vw(this.done, t), Vw(this.undone, t), this.prevTime, this.prevUserEvent);
  }
  pop(t, n, r) {
    let i = t == 0 ? this.done : this.undone;
    if (i.length == 0)
      return null;
    let o = i[i.length - 1], s = o.selectionsAfter[0] || n.selection;
    if (r && o.selectionsAfter.length)
      return n.update({
        selection: o.selectionsAfter[o.selectionsAfter.length - 1],
        annotations: rO.of({ side: t, rest: Fst(i), selection: s }),
        userEvent: t == 0 ? "select.undo" : "select.redo",
        scrollIntoView: !0
      });
    if (o.changes) {
      let a = i.length == 1 ? Fa : i.slice(0, i.length - 1);
      return o.mapped && (a = Vw(a, o.mapped)), n.update({
        changes: o.changes,
        selection: o.startSelection,
        effects: o.effects,
        annotations: rO.of({ side: t, rest: a, selection: s }),
        filter: !1,
        userEvent: t == 0 ? "undo" : "redo",
        scrollIntoView: !0
      });
    } else
      return null;
  }
}
ru.empty = /* @__PURE__ */ new ru(Fa, Fa);
const Mst = [
  { key: "Mod-z", run: dK, preventDefault: !0 },
  { key: "Mod-y", mac: "Mod-Shift-z", run: iO, preventDefault: !0 },
  { linux: "Ctrl-Shift-z", run: iO, preventDefault: !0 },
  { key: "Mod-u", run: wst, preventDefault: !0 },
  { key: "Alt-u", mac: "Mod-Shift-u", run: Pst, preventDefault: !0 }
];
function Eg(e, t) {
  return it.create(e.ranges.map(t), e.mainIndex);
}
function Pu(e, t) {
  return e.update({ selection: t, scrollIntoView: !0, userEvent: "select" });
}
function kl({ state: e, dispatch: t }, n) {
  let r = Eg(e.selection, n);
  return r.eq(e.selection, !0) ? !1 : (t(Pu(e, r)), !0);
}
function hT(e, t) {
  return it.cursor(t ? e.to : e.from);
}
function hK(e, t) {
  return kl(e, (n) => n.empty ? e.moveByChar(n, t) : hT(n, t));
}
function zo(e) {
  return e.textDirectionAt(e.state.selection.main.head) == Jr.LTR;
}
const mK = (e) => hK(e, !zo(e)), gK = (e) => hK(e, zo(e));
function yK(e, t) {
  return kl(e, (n) => n.empty ? e.moveByGroup(n, t) : hT(n, t));
}
const Rst = (e) => yK(e, !zo(e)), _st = (e) => yK(e, zo(e));
function Lst(e, t, n) {
  if (t.type.prop(n))
    return !0;
  let r = t.to - t.from;
  return r && (r > 2 || /[^\s,.;:]/.test(e.sliceDoc(t.from, t.to))) || t.firstChild;
}
function mT(e, t, n) {
  let r = Bo(e).resolveInner(t.head), i = n ? jn.closedBy : jn.openedBy;
  for (let u = t.head; ; ) {
    let c = n ? r.childAfter(u) : r.childBefore(u);
    if (!c)
      break;
    Lst(e, c, i) ? r = c : u = n ? c.to : c.from;
  }
  let o = r.type.prop(i), s, a;
  return o && (s = n ? nu(e, r.from, 1) : nu(e, r.to, -1)) && s.matched ? a = n ? s.end.to : s.end.from : a = n ? r.to : r.from, it.cursor(a, n ? -1 : 1);
}
const Bst = (e) => kl(e, (t) => mT(e.state, t, !zo(e))), jst = (e) => kl(e, (t) => mT(e.state, t, zo(e)));
function bK(e, t) {
  return kl(e, (n) => {
    if (!n.empty)
      return hT(n, t);
    let r = e.moveVertically(n, t);
    return r.head != n.head ? r : e.moveToLineBoundary(n, t);
  });
}
const vK = (e) => bK(e, !1), xK = (e) => bK(e, !0);
function DK(e) {
  let t = e.scrollDOM.clientHeight < e.scrollDOM.scrollHeight - 2, n = 0, r = 0, i;
  if (t) {
    for (let o of e.state.facet(Rt.scrollMargins)) {
      let s = o(e);
      s != null && s.top && (n = Math.max(s == null ? void 0 : s.top, n)), s != null && s.bottom && (r = Math.max(s == null ? void 0 : s.bottom, r));
    }
    i = e.scrollDOM.clientHeight - n - r;
  } else
    i = (e.dom.ownerDocument.defaultView || window).innerHeight;
  return {
    marginTop: n,
    marginBottom: r,
    selfScroll: t,
    height: Math.max(e.defaultLineHeight, i - 5)
  };
}
function CK(e, t) {
  let n = DK(e), { state: r } = e, i = Eg(r.selection, (s) => s.empty ? e.moveVertically(s, t, n.height) : hT(s, t));
  if (i.eq(r.selection))
    return !1;
  let o;
  if (n.selfScroll) {
    let s = e.coordsAtPos(r.selection.main.head), a = e.scrollDOM.getBoundingClientRect(), u = a.top + n.marginTop, c = a.bottom - n.marginBottom;
    s && s.top > u && s.bottom < c && (o = Rt.scrollIntoView(i.main.head, { y: "start", yMargin: s.top - u }));
  }
  return e.dispatch(Pu(r, i), { effects: o }), !0;
}
const L5 = (e) => CK(e, !1), oO = (e) => CK(e, !0);
function Nd(e, t, n) {
  let r = e.lineBlockAt(t.head), i = e.moveToLineBoundary(t, n);
  if (i.head == t.head && i.head != (n ? r.to : r.from) && (i = e.moveToLineBoundary(t, n, !1)), !n && i.head == r.from && r.length) {
    let o = /^\s*/.exec(e.state.sliceDoc(r.from, Math.min(r.from + 100, r.to)))[0].length;
    o && t.head != r.from + o && (i = it.cursor(r.from + o));
  }
  return i;
}
const Vst = (e) => kl(e, (t) => Nd(e, t, !0)), zst = (e) => kl(e, (t) => Nd(e, t, !1)), Ust = (e) => kl(e, (t) => Nd(e, t, !zo(e))), Wst = (e) => kl(e, (t) => Nd(e, t, zo(e))), Hst = (e) => kl(e, (t) => it.cursor(e.lineBlockAt(t.head).from, 1)), qst = (e) => kl(e, (t) => it.cursor(e.lineBlockAt(t.head).to, -1));
function Gst(e, t, n) {
  let r = !1, i = Eg(e.selection, (o) => {
    let s = nu(e, o.head, -1) || nu(e, o.head, 1) || o.head > 0 && nu(e, o.head - 1, 1) || o.head < e.doc.length && nu(e, o.head + 1, -1);
    if (!s || !s.end)
      return o;
    r = !0;
    let a = s.start.from == o.head ? s.end.to : s.end.from;
    return it.cursor(a);
  });
  return r ? (t(Pu(e, i)), !0) : !1;
}
const Yst = ({ state: e, dispatch: t }) => Gst(e, t);
function Qa(e, t) {
  let n = Eg(e.state.selection, (r) => {
    let i = t(r);
    return it.range(r.anchor, i.head, i.goalColumn, i.bidiLevel || void 0);
  });
  return n.eq(e.state.selection) ? !1 : (e.dispatch(Pu(e.state, n)), !0);
}
function EK(e, t) {
  return Qa(e, (n) => e.moveByChar(n, t));
}
const TK = (e) => EK(e, !zo(e)), SK = (e) => EK(e, zo(e));
function AK(e, t) {
  return Qa(e, (n) => e.moveByGroup(n, t));
}
const Kst = (e) => AK(e, !zo(e)), Jst = (e) => AK(e, zo(e)), Xst = (e) => Qa(e, (t) => mT(e.state, t, !zo(e))), Qst = (e) => Qa(e, (t) => mT(e.state, t, zo(e)));
function wK(e, t) {
  return Qa(e, (n) => e.moveVertically(n, t));
}
const PK = (e) => wK(e, !1), kK = (e) => wK(e, !0);
function OK(e, t) {
  return Qa(e, (n) => e.moveVertically(n, t, DK(e).height));
}
const B5 = (e) => OK(e, !1), j5 = (e) => OK(e, !0), Zst = (e) => Qa(e, (t) => Nd(e, t, !0)), eat = (e) => Qa(e, (t) => Nd(e, t, !1)), tat = (e) => Qa(e, (t) => Nd(e, t, !zo(e))), nat = (e) => Qa(e, (t) => Nd(e, t, zo(e))), rat = (e) => Qa(e, (t) => it.cursor(e.lineBlockAt(t.head).from)), iat = (e) => Qa(e, (t) => it.cursor(e.lineBlockAt(t.head).to)), V5 = ({ state: e, dispatch: t }) => (t(Pu(e, { anchor: 0 })), !0), z5 = ({ state: e, dispatch: t }) => (t(Pu(e, { anchor: e.doc.length })), !0), U5 = ({ state: e, dispatch: t }) => (t(Pu(e, { anchor: e.selection.main.anchor, head: 0 })), !0), W5 = ({ state: e, dispatch: t }) => (t(Pu(e, { anchor: e.selection.main.anchor, head: e.doc.length })), !0), oat = ({ state: e, dispatch: t }) => (t(e.update({ selection: { anchor: 0, head: e.doc.length }, userEvent: "select" })), !0), sat = ({ state: e, dispatch: t }) => {
  let n = gT(e).map(({ from: r, to: i }) => it.range(r, Math.min(i + 1, e.doc.length)));
  return t(e.update({ selection: it.create(n), userEvent: "select" })), !0;
}, aat = ({ state: e, dispatch: t }) => {
  let n = Eg(e.selection, (r) => {
    let i = Bo(e), o = i.resolveStack(r.from, 1);
    if (r.empty) {
      let s = i.resolveStack(r.from, -1);
      s.node.from >= o.node.from && s.node.to <= o.node.to && (o = s);
    }
    for (let s = o; s; s = s.next) {
      let { node: a } = s;
      if ((a.from < r.from && a.to >= r.to || a.to > r.to && a.from <= r.from) && s.next)
        return it.range(a.to, a.from);
    }
    return r;
  });
  return n.eq(e.selection) ? !1 : (t(Pu(e, n)), !0);
}, lat = ({ state: e, dispatch: t }) => {
  let n = e.selection, r = null;
  return n.ranges.length > 1 ? r = it.create([n.main]) : n.main.empty || (r = it.create([it.cursor(n.main.head)])), r ? (t(Pu(e, r)), !0) : !1;
};
function Cv(e, t) {
  if (e.state.readOnly)
    return !1;
  let n = "delete.selection", { state: r } = e, i = r.changeByRange((o) => {
    let { from: s, to: a } = o;
    if (s == a) {
      let u = t(o);
      u < s ? (n = "delete.backward", u = xx(e, u, !1)) : u > s && (n = "delete.forward", u = xx(e, u, !0)), s = Math.min(s, u), a = Math.max(a, u);
    } else
      s = xx(e, s, !1), a = xx(e, a, !0);
    return s == a ? { range: o } : { changes: { from: s, to: a }, range: it.cursor(s, s < o.head ? -1 : 1) };
  });
  return i.changes.empty ? !1 : (e.dispatch(r.update(i, {
    scrollIntoView: !0,
    userEvent: n,
    effects: n == "delete.selection" ? Rt.announce.of(r.phrase("Selection deleted")) : void 0
  })), !0);
}
function xx(e, t, n) {
  if (e instanceof Rt)
    for (let r of e.state.facet(Rt.atomicRanges).map((i) => i(e)))
      r.between(t, t, (i, o) => {
        i < t && o > t && (t = n ? o : i);
      });
  return t;
}
const IK = (e, t, n) => Cv(e, (r) => {
  let i = r.from, { state: o } = e, s = o.doc.lineAt(i), a, u;
  if (n && !t && i > s.from && i < s.from + 200 && !/[^ \t]/.test(a = s.text.slice(0, i - s.from))) {
    if (a[a.length - 1] == "	")
      return i - 1;
    let c = Cg(a, o.tabSize), d = c % yC(o) || yC(o);
    for (let f = 0; f < d && a[a.length - 1 - f] == " "; f++)
      i--;
    u = i;
  } else
    u = go(s.text, i - s.from, t, t) + s.from, u == i && s.number != (t ? o.doc.lines : 1) ? u += t ? 1 : -1 : !t && /[\ufe00-\ufe0f]/.test(s.text.slice(u - s.from, i - s.from)) && (u = go(s.text, u - s.from, !1, !1) + s.from);
  return u;
}), sO = (e) => IK(e, !1, !0), FK = (e) => IK(e, !0, !1), $K = (e, t) => Cv(e, (n) => {
  let r = n.head, { state: i } = e, o = i.doc.lineAt(r), s = i.charCategorizer(r);
  for (let a = null; ; ) {
    if (r == (t ? o.to : o.from)) {
      r == n.head && o.number != (t ? i.doc.lines : 1) && (r += t ? 1 : -1);
      break;
    }
    let u = go(o.text, r - o.from, t) + o.from, c = o.text.slice(Math.min(r, u) - o.from, Math.max(r, u) - o.from), d = s(c);
    if (a != null && d != a)
      break;
    (c != " " || r != n.head) && (a = d), r = u;
  }
  return r;
}), NK = (e) => $K(e, !1), uat = (e) => $K(e, !0), cat = (e) => Cv(e, (t) => {
  let n = e.lineBlockAt(t.head).to;
  return t.head < n ? n : Math.min(e.state.doc.length, t.head + 1);
}), dat = (e) => Cv(e, (t) => {
  let n = e.moveToLineBoundary(t, !1).head;
  return t.head > n ? n : Math.max(0, t.head - 1);
}), pat = (e) => Cv(e, (t) => {
  let n = e.moveToLineBoundary(t, !0).head;
  return t.head < n ? n : Math.min(e.state.doc.length, t.head + 1);
}), fat = ({ state: e, dispatch: t }) => {
  if (e.readOnly)
    return !1;
  let n = e.changeByRange((r) => ({
    changes: { from: r.from, to: r.to, insert: cr.of(["", ""]) },
    range: it.cursor(r.from)
  }));
  return t(e.update(n, { scrollIntoView: !0, userEvent: "input" })), !0;
}, hat = ({ state: e, dispatch: t }) => {
  if (e.readOnly)
    return !1;
  let n = e.changeByRange((r) => {
    if (!r.empty || r.from == 0 || r.from == e.doc.length)
      return { range: r };
    let i = r.from, o = e.doc.lineAt(i), s = i == o.from ? i - 1 : go(o.text, i - o.from, !1) + o.from, a = i == o.to ? i + 1 : go(o.text, i - o.from, !0) + o.from;
    return {
      changes: { from: s, to: a, insert: e.doc.slice(i, a).append(e.doc.slice(s, i)) },
      range: it.cursor(a)
    };
  });
  return n.changes.empty ? !1 : (t(e.update(n, { scrollIntoView: !0, userEvent: "move.character" })), !0);
};
function gT(e) {
  let t = [], n = -1;
  for (let r of e.selection.ranges) {
    let i = e.doc.lineAt(r.from), o = e.doc.lineAt(r.to);
    if (!r.empty && r.to == o.from && (o = e.doc.lineAt(r.to - 1)), n >= i.number) {
      let s = t[t.length - 1];
      s.to = o.to, s.ranges.push(r);
    } else
      t.push({ from: i.from, to: o.to, ranges: [r] });
    n = o.number + 1;
  }
  return t;
}
function MK(e, t, n) {
  if (e.readOnly)
    return !1;
  let r = [], i = [];
  for (let o of gT(e)) {
    if (n ? o.to == e.doc.length : o.from == 0)
      continue;
    let s = e.doc.lineAt(n ? o.to + 1 : o.from - 1), a = s.length + 1;
    if (n) {
      r.push({ from: o.to, to: s.to }, { from: o.from, insert: s.text + e.lineBreak });
      for (let u of o.ranges)
        i.push(it.range(Math.min(e.doc.length, u.anchor + a), Math.min(e.doc.length, u.head + a)));
    } else {
      r.push({ from: s.from, to: o.from }, { from: o.to, insert: e.lineBreak + s.text });
      for (let u of o.ranges)
        i.push(it.range(u.anchor - a, u.head - a));
    }
  }
  return r.length ? (t(e.update({
    changes: r,
    scrollIntoView: !0,
    selection: it.create(i, e.selection.mainIndex),
    userEvent: "move.line"
  })), !0) : !1;
}
const mat = ({ state: e, dispatch: t }) => MK(e, t, !1), gat = ({ state: e, dispatch: t }) => MK(e, t, !0);
function RK(e, t, n) {
  if (e.readOnly)
    return !1;
  let r = [];
  for (let i of gT(e))
    n ? r.push({ from: i.from, insert: e.doc.slice(i.from, i.to) + e.lineBreak }) : r.push({ from: i.to, insert: e.lineBreak + e.doc.slice(i.from, i.to) });
  return t(e.update({ changes: r, scrollIntoView: !0, userEvent: "input.copyline" })), !0;
}
const yat = ({ state: e, dispatch: t }) => RK(e, t, !1), bat = ({ state: e, dispatch: t }) => RK(e, t, !0), vat = (e) => {
  if (e.state.readOnly)
    return !1;
  let { state: t } = e, n = t.changes(gT(t).map(({ from: i, to: o }) => (i > 0 ? i-- : o < t.doc.length && o++, { from: i, to: o }))), r = Eg(t.selection, (i) => {
    let o;
    if (e.lineWrapping) {
      let s = e.lineBlockAt(i.head), a = e.coordsAtPos(i.head, i.assoc || 1);
      a && (o = s.bottom + e.documentTop - a.bottom + e.defaultLineHeight / 2);
    }
    return e.moveVertically(i, !0, o);
  }).map(n);
  return e.dispatch({ changes: n, selection: r, scrollIntoView: !0, userEvent: "delete.line" }), !0;
};
function xat(e, t) {
  if (/\(\)|\[\]|\{\}/.test(e.sliceDoc(t - 1, t + 1)))
    return { from: t, to: t };
  let n = Bo(e).resolveInner(t), r = n.childBefore(t), i = n.childAfter(t), o;
  return r && i && r.to <= t && i.from >= t && (o = r.type.prop(jn.closedBy)) && o.indexOf(i.name) > -1 && e.doc.lineAt(r.to).from == e.doc.lineAt(i.from).from && !/\S/.test(e.sliceDoc(r.to, i.from)) ? { from: r.to, to: i.from } : null;
}
const H5 = /* @__PURE__ */ _K(!1), Dat = /* @__PURE__ */ _K(!0);
function _K(e) {
  return ({ state: t, dispatch: n }) => {
    if (t.readOnly)
      return !1;
    let r = t.changeByRange((i) => {
      let { from: o, to: s } = i, a = t.doc.lineAt(o), u = !e && o == s && xat(t, o);
      e && (o = s = (s <= a.to ? a : t.doc.lineAt(s)).to);
      let c = new dT(t, { simulateBreak: o, simulateDoubleBreak: !!u }), d = Z$(c, o);
      for (d == null && (d = Cg(/^\s*/.exec(t.doc.lineAt(o).text)[0], t.tabSize)); s < a.to && /\s/.test(a.text[s - a.from]); )
        s++;
      u ? { from: o, to: s } = u : o > a.from && o < a.from + 100 && !/\S/.test(a.text.slice(0, o)) && (o = a.from);
      let f = ["", ab(t, d)];
      return u && f.push(ab(t, c.lineIndent(a.from, -1))), {
        changes: { from: o, to: s, insert: cr.of(f) },
        range: it.cursor(o + 1 + f[1].length)
      };
    });
    return n(t.update(r, { scrollIntoView: !0, userEvent: "input" })), !0;
  };
}
function rN(e, t) {
  let n = -1;
  return e.changeByRange((r) => {
    let i = [];
    for (let s = r.from; s <= r.to; ) {
      let a = e.doc.lineAt(s);
      a.number > n && (r.empty || r.to > a.from) && (t(a, i, r), n = a.number), s = a.to + 1;
    }
    let o = e.changes(i);
    return {
      changes: i,
      range: it.range(o.mapPos(r.anchor, 1), o.mapPos(r.head, 1))
    };
  });
}
const Cat = ({ state: e, dispatch: t }) => {
  if (e.readOnly)
    return !1;
  let n = /* @__PURE__ */ Object.create(null), r = new dT(e, { overrideIndentation: (o) => {
    let s = n[o];
    return s ?? -1;
  } }), i = rN(e, (o, s, a) => {
    let u = Z$(r, o.from);
    if (u == null)
      return;
    /\S/.test(o.text) || (u = 0);
    let c = /^\s*/.exec(o.text)[0], d = ab(e, u);
    (c != d || a.from < o.from + c.length) && (n[o.from] = u, s.push({ from: o.from, to: o.from + c.length, insert: d }));
  });
  return i.changes.empty || t(e.update(i, { userEvent: "indent" })), !0;
}, LK = ({ state: e, dispatch: t }) => e.readOnly ? !1 : (t(e.update(rN(e, (n, r) => {
  r.push({ from: n.from, insert: e.facet(cT) });
}), { userEvent: "input.indent" })), !0), BK = ({ state: e, dispatch: t }) => e.readOnly ? !1 : (t(e.update(rN(e, (n, r) => {
  let i = /^\s*/.exec(n.text)[0];
  if (!i)
    return;
  let o = Cg(i, e.tabSize), s = 0, a = ab(e, Math.max(0, o - yC(e)));
  for (; s < i.length && s < a.length && i.charCodeAt(s) == a.charCodeAt(s); )
    s++;
  r.push({ from: n.from + s, to: n.from + i.length, insert: a.slice(s) });
}), { userEvent: "delete.dedent" })), !0), Eat = (e) => (e.setTabFocusMode(), !0), Tat = [
  { key: "Ctrl-b", run: mK, shift: TK, preventDefault: !0 },
  { key: "Ctrl-f", run: gK, shift: SK },
  { key: "Ctrl-p", run: vK, shift: PK },
  { key: "Ctrl-n", run: xK, shift: kK },
  { key: "Ctrl-a", run: Hst, shift: rat },
  { key: "Ctrl-e", run: qst, shift: iat },
  { key: "Ctrl-d", run: FK },
  { key: "Ctrl-h", run: sO },
  { key: "Ctrl-k", run: cat },
  { key: "Ctrl-Alt-h", run: NK },
  { key: "Ctrl-o", run: fat },
  { key: "Ctrl-t", run: hat },
  { key: "Ctrl-v", run: oO }
], Sat = /* @__PURE__ */ [
  { key: "ArrowLeft", run: mK, shift: TK, preventDefault: !0 },
  { key: "Mod-ArrowLeft", mac: "Alt-ArrowLeft", run: Rst, shift: Kst, preventDefault: !0 },
  { mac: "Cmd-ArrowLeft", run: Ust, shift: tat, preventDefault: !0 },
  { key: "ArrowRight", run: gK, shift: SK, preventDefault: !0 },
  { key: "Mod-ArrowRight", mac: "Alt-ArrowRight", run: _st, shift: Jst, preventDefault: !0 },
  { mac: "Cmd-ArrowRight", run: Wst, shift: nat, preventDefault: !0 },
  { key: "ArrowUp", run: vK, shift: PK, preventDefault: !0 },
  { mac: "Cmd-ArrowUp", run: V5, shift: U5 },
  { mac: "Ctrl-ArrowUp", run: L5, shift: B5 },
  { key: "ArrowDown", run: xK, shift: kK, preventDefault: !0 },
  { mac: "Cmd-ArrowDown", run: z5, shift: W5 },
  { mac: "Ctrl-ArrowDown", run: oO, shift: j5 },
  { key: "PageUp", run: L5, shift: B5 },
  { key: "PageDown", run: oO, shift: j5 },
  { key: "Home", run: zst, shift: eat, preventDefault: !0 },
  { key: "Mod-Home", run: V5, shift: U5 },
  { key: "End", run: Vst, shift: Zst, preventDefault: !0 },
  { key: "Mod-End", run: z5, shift: W5 },
  { key: "Enter", run: H5, shift: H5 },
  { key: "Mod-a", run: oat },
  { key: "Backspace", run: sO, shift: sO },
  { key: "Delete", run: FK },
  { key: "Mod-Backspace", mac: "Alt-Backspace", run: NK },
  { key: "Mod-Delete", mac: "Alt-Delete", run: uat },
  { mac: "Mod-Backspace", run: dat },
  { mac: "Mod-Delete", run: pat }
].concat(/* @__PURE__ */ Tat.map((e) => ({ mac: e.key, run: e.run, shift: e.shift }))), Aat = /* @__PURE__ */ [
  { key: "Alt-ArrowLeft", mac: "Ctrl-ArrowLeft", run: Bst, shift: Xst },
  { key: "Alt-ArrowRight", mac: "Ctrl-ArrowRight", run: jst, shift: Qst },
  { key: "Alt-ArrowUp", run: mat },
  { key: "Shift-Alt-ArrowUp", run: yat },
  { key: "Alt-ArrowDown", run: gat },
  { key: "Shift-Alt-ArrowDown", run: bat },
  { key: "Escape", run: lat },
  { key: "Mod-Enter", run: Dat },
  { key: "Alt-l", mac: "Ctrl-l", run: sat },
  { key: "Mod-i", run: aat, preventDefault: !0 },
  { key: "Mod-[", run: BK },
  { key: "Mod-]", run: LK },
  { key: "Mod-Alt-\\", run: Cat },
  { key: "Shift-Mod-k", run: vat },
  { key: "Shift-Mod-\\", run: Yst },
  { key: "Mod-/", run: yst },
  { key: "Alt-A", run: vst },
  { key: "Ctrl-m", mac: "Shift-Alt-m", run: Eat }
].concat(Sat), wat = { key: "Tab", run: LK, shift: BK };
function zr() {
  var e = arguments[0];
  typeof e == "string" && (e = document.createElement(e));
  var t = 1, n = arguments[1];
  if (n && typeof n == "object" && n.nodeType == null && !Array.isArray(n)) {
    for (var r in n) if (Object.prototype.hasOwnProperty.call(n, r)) {
      var i = n[r];
      typeof i == "string" ? e.setAttribute(r, i) : i != null && (e[r] = i);
    }
    t++;
  }
  for (; t < arguments.length; t++) jK(e, arguments[t]);
  return e;
}
function jK(e, t) {
  if (typeof t == "string")
    e.appendChild(document.createTextNode(t));
  else if (t != null) if (t.nodeType != null)
    e.appendChild(t);
  else if (Array.isArray(t))
    for (var n = 0; n < t.length; n++) jK(e, t[n]);
  else
    throw new RangeError("Unsupported child node: " + t);
}
const q5 = typeof String.prototype.normalize == "function" ? (e) => e.normalize("NFKD") : (e) => e;
class wm {
  /**
  Create a text cursor. The query is the search string, `from` to
  `to` provides the region to search.
  
  When `normalize` is given, it will be called, on both the query
  string and the content it is matched against, before comparing.
  You can, for example, create a case-insensitive search by
  passing `s => s.toLowerCase()`.
  
  Text is always normalized with
  [`.normalize("NFKD")`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/normalize)
  (when supported).
  */
  constructor(t, n, r = 0, i = t.length, o, s) {
    this.test = s, this.value = { from: 0, to: 0 }, this.done = !1, this.matches = [], this.buffer = "", this.bufferPos = 0, this.iter = t.iterRange(r, i), this.bufferStart = r, this.normalize = o ? (a) => o(q5(a)) : q5, this.query = this.normalize(n);
  }
  peek() {
    if (this.bufferPos == this.buffer.length) {
      if (this.bufferStart += this.buffer.length, this.iter.next(), this.iter.done)
        return -1;
      this.bufferPos = 0, this.buffer = this.iter.value;
    }
    return xs(this.buffer, this.bufferPos);
  }
  /**
  Look for the next match. Updates the iterator's
  [`value`](https://codemirror.net/6/docs/ref/#search.SearchCursor.value) and
  [`done`](https://codemirror.net/6/docs/ref/#search.SearchCursor.done) properties. Should be called
  at least once before using the cursor.
  */
  next() {
    for (; this.matches.length; )
      this.matches.pop();
    return this.nextOverlapping();
  }
  /**
  The `next` method will ignore matches that partially overlap a
  previous match. This method behaves like `next`, but includes
  such matches.
  */
  nextOverlapping() {
    for (; ; ) {
      let t = this.peek();
      if (t < 0)
        return this.done = !0, this;
      let n = $$(t), r = this.bufferStart + this.bufferPos;
      this.bufferPos += Ql(t);
      let i = this.normalize(n);
      if (i.length)
        for (let o = 0, s = r; ; o++) {
          let a = i.charCodeAt(o), u = this.match(a, s, this.bufferPos + this.bufferStart);
          if (o == i.length - 1) {
            if (u)
              return this.value = u, this;
            break;
          }
          s == r && o < n.length && n.charCodeAt(o) == a && s++;
        }
    }
  }
  match(t, n, r) {
    let i = null;
    for (let o = 0; o < this.matches.length; o += 2) {
      let s = this.matches[o], a = !1;
      this.query.charCodeAt(s) == t && (s == this.query.length - 1 ? i = { from: this.matches[o + 1], to: r } : (this.matches[o]++, a = !0)), a || (this.matches.splice(o, 2), o -= 2);
    }
    return this.query.charCodeAt(0) == t && (this.query.length == 1 ? i = { from: n, to: r } : this.matches.push(1, n)), i && this.test && !this.test(i.from, i.to, this.buffer, this.bufferStart) && (i = null), i;
  }
}
typeof Symbol < "u" && (wm.prototype[Symbol.iterator] = function() {
  return this;
});
const VK = { from: -1, to: -1, match: /* @__PURE__ */ /.*/.exec("") }, iN = "gm" + (/x/.unicode == null ? "" : "u");
class zK {
  /**
  Create a cursor that will search the given range in the given
  document. `query` should be the raw pattern (as you'd pass it to
  `new RegExp`).
  */
  constructor(t, n, r, i = 0, o = t.length) {
    if (this.text = t, this.to = o, this.curLine = "", this.done = !1, this.value = VK, /\\[sWDnr]|\n|\r|\[\^/.test(n))
      return new UK(t, n, r, i, o);
    this.re = new RegExp(n, iN + (r != null && r.ignoreCase ? "i" : "")), this.test = r == null ? void 0 : r.test, this.iter = t.iter();
    let s = t.lineAt(i);
    this.curLineStart = s.from, this.matchPos = DC(t, i), this.getLine(this.curLineStart);
  }
  getLine(t) {
    this.iter.next(t), this.iter.lineBreak ? this.curLine = "" : (this.curLine = this.iter.value, this.curLineStart + this.curLine.length > this.to && (this.curLine = this.curLine.slice(0, this.to - this.curLineStart)), this.iter.next());
  }
  nextLine() {
    this.curLineStart = this.curLineStart + this.curLine.length + 1, this.curLineStart > this.to ? this.curLine = "" : this.getLine(0);
  }
  /**
  Move to the next match, if there is one.
  */
  next() {
    for (let t = this.matchPos - this.curLineStart; ; ) {
      this.re.lastIndex = t;
      let n = this.matchPos <= this.to && this.re.exec(this.curLine);
      if (n) {
        let r = this.curLineStart + n.index, i = r + n[0].length;
        if (this.matchPos = DC(this.text, i + (r == i ? 1 : 0)), r == this.curLineStart + this.curLine.length && this.nextLine(), (r < i || r > this.value.to) && (!this.test || this.test(r, i, n)))
          return this.value = { from: r, to: i, match: n }, this;
        t = this.matchPos - this.curLineStart;
      } else if (this.curLineStart + this.curLine.length < this.to)
        this.nextLine(), t = 0;
      else
        return this.done = !0, this;
    }
  }
}
const zw = /* @__PURE__ */ new WeakMap();
class nm {
  constructor(t, n) {
    this.from = t, this.text = n;
  }
  get to() {
    return this.from + this.text.length;
  }
  static get(t, n, r) {
    let i = zw.get(t);
    if (!i || i.from >= r || i.to <= n) {
      let a = new nm(n, t.sliceString(n, r));
      return zw.set(t, a), a;
    }
    if (i.from == n && i.to == r)
      return i;
    let { text: o, from: s } = i;
    return s > n && (o = t.sliceString(n, s) + o, s = n), i.to < r && (o += t.sliceString(i.to, r)), zw.set(t, new nm(s, o)), new nm(n, o.slice(n - s, r - s));
  }
}
class UK {
  constructor(t, n, r, i, o) {
    this.text = t, this.to = o, this.done = !1, this.value = VK, this.matchPos = DC(t, i), this.re = new RegExp(n, iN + (r != null && r.ignoreCase ? "i" : "")), this.test = r == null ? void 0 : r.test, this.flat = nm.get(t, i, this.chunkEnd(
      i + 5e3
      /* Chunk.Base */
    ));
  }
  chunkEnd(t) {
    return t >= this.to ? this.to : this.text.lineAt(t).to;
  }
  next() {
    for (; ; ) {
      let t = this.re.lastIndex = this.matchPos - this.flat.from, n = this.re.exec(this.flat.text);
      if (n && !n[0] && n.index == t && (this.re.lastIndex = t + 1, n = this.re.exec(this.flat.text)), n) {
        let r = this.flat.from + n.index, i = r + n[0].length;
        if ((this.flat.to >= this.to || n.index + n[0].length <= this.flat.text.length - 10) && (!this.test || this.test(r, i, n)))
          return this.value = { from: r, to: i, match: n }, this.matchPos = DC(this.text, i + (r == i ? 1 : 0)), this;
      }
      if (this.flat.to == this.to)
        return this.done = !0, this;
      this.flat = nm.get(this.text, this.flat.from, this.chunkEnd(this.flat.from + this.flat.text.length * 2));
    }
  }
}
typeof Symbol < "u" && (zK.prototype[Symbol.iterator] = UK.prototype[Symbol.iterator] = function() {
  return this;
});
function Pat(e) {
  try {
    return new RegExp(e, iN), !0;
  } catch {
    return !1;
  }
}
function DC(e, t) {
  if (t >= e.length)
    return t;
  let n = e.lineAt(t), r;
  for (; t < n.to && (r = n.text.charCodeAt(t - n.from)) >= 56320 && r < 57344; )
    t++;
  return t;
}
function aO(e) {
  let t = String(e.state.doc.lineAt(e.state.selection.main.head).number), n = zr("input", { class: "cm-textfield", name: "line", value: t }), r = zr("form", {
    class: "cm-gotoLine",
    onkeydown: (o) => {
      o.keyCode == 27 ? (o.preventDefault(), e.dispatch({ effects: CC.of(!1) }), e.focus()) : o.keyCode == 13 && (o.preventDefault(), i());
    },
    onsubmit: (o) => {
      o.preventDefault(), i();
    }
  }, zr("label", e.state.phrase("Go to line"), ": ", n), " ", zr("button", { class: "cm-button", type: "submit" }, e.state.phrase("go")));
  function i() {
    let o = /^([+-])?(\d+)?(:\d+)?(%)?$/.exec(n.value);
    if (!o)
      return;
    let { state: s } = e, a = s.doc.lineAt(s.selection.main.head), [, u, c, d, f] = o, h = d ? +d.slice(1) : 0, m = c ? +c : a.number;
    if (c && f) {
      let C = m / 100;
      u && (C = C * (u == "-" ? -1 : 1) + a.number / s.doc.lines), m = Math.round(s.doc.lines * C);
    } else c && u && (m = m * (u == "-" ? -1 : 1) + a.number);
    let v = s.doc.line(Math.max(1, Math.min(s.doc.lines, m))), x = it.cursor(v.from + Math.max(0, Math.min(h, v.length)));
    e.dispatch({
      effects: [CC.of(!1), Rt.scrollIntoView(x.from, { y: "center" })],
      selection: x
    }), e.focus();
  }
  return { dom: r };
}
const CC = /* @__PURE__ */ An.define(), G5 = /* @__PURE__ */ wo.define({
  create() {
    return !0;
  },
  update(e, t) {
    for (let n of t.effects)
      n.is(CC) && (e = n.value);
    return e;
  },
  provide: (e) => ob.from(e, (t) => t ? aO : null)
}), kat = (e) => {
  let t = ib(e, aO);
  if (!t) {
    let n = [CC.of(!0)];
    e.state.field(G5, !1) == null && n.push(An.appendConfig.of([G5, Oat])), e.dispatch({ effects: n }), t = ib(e, aO);
  }
  return t && t.dom.querySelector("input").select(), !0;
}, Oat = /* @__PURE__ */ Rt.baseTheme({
  ".cm-panel.cm-gotoLine": {
    padding: "2px 6px 4px",
    "& label": { fontSize: "80%" }
  }
}), Iat = {
  highlightWordAroundCursor: !1,
  minSelectionLength: 1,
  maxMatches: 100,
  wholeWords: !1
}, Fat = /* @__PURE__ */ zt.define({
  combine(e) {
    return wu(e, Iat, {
      highlightWordAroundCursor: (t, n) => t || n,
      minSelectionLength: Math.min,
      maxMatches: Math.min
    });
  }
});
function $at(e) {
  return [Lat, _at];
}
const Nat = /* @__PURE__ */ tn.mark({ class: "cm-selectionMatch" }), Mat = /* @__PURE__ */ tn.mark({ class: "cm-selectionMatch cm-selectionMatch-main" });
function Y5(e, t, n, r) {
  return (n == 0 || e(t.sliceDoc(n - 1, n)) != Qr.Word) && (r == t.doc.length || e(t.sliceDoc(r, r + 1)) != Qr.Word);
}
function Rat(e, t, n, r) {
  return e(t.sliceDoc(n, n + 1)) == Qr.Word && e(t.sliceDoc(r - 1, r)) == Qr.Word;
}
const _at = /* @__PURE__ */ Pi.fromClass(class {
  constructor(e) {
    this.decorations = this.getDeco(e);
  }
  update(e) {
    (e.selectionSet || e.docChanged || e.viewportChanged) && (this.decorations = this.getDeco(e.view));
  }
  getDeco(e) {
    let t = e.state.facet(Fat), { state: n } = e, r = n.selection;
    if (r.ranges.length > 1)
      return tn.none;
    let i = r.main, o, s = null;
    if (i.empty) {
      if (!t.highlightWordAroundCursor)
        return tn.none;
      let u = n.wordAt(i.head);
      if (!u)
        return tn.none;
      s = n.charCategorizer(i.head), o = n.sliceDoc(u.from, u.to);
    } else {
      let u = i.to - i.from;
      if (u < t.minSelectionLength || u > 200)
        return tn.none;
      if (t.wholeWords) {
        if (o = n.sliceDoc(i.from, i.to), s = n.charCategorizer(i.head), !(Y5(s, n, i.from, i.to) && Rat(s, n, i.from, i.to)))
          return tn.none;
      } else if (o = n.sliceDoc(i.from, i.to), !o)
        return tn.none;
    }
    let a = [];
    for (let u of e.visibleRanges) {
      let c = new wm(n.doc, o, u.from, u.to);
      for (; !c.next().done; ) {
        let { from: d, to: f } = c.value;
        if ((!s || Y5(s, n, d, f)) && (i.empty && d <= i.from && f >= i.to ? a.push(Mat.range(d, f)) : (d >= i.to || f <= i.from) && a.push(Nat.range(d, f)), a.length > t.maxMatches))
          return tn.none;
      }
    }
    return tn.set(a);
  }
}, {
  decorations: (e) => e.decorations
}), Lat = /* @__PURE__ */ Rt.baseTheme({
  ".cm-selectionMatch": { backgroundColor: "#99ff7780" },
  ".cm-searchMatch .cm-selectionMatch": { backgroundColor: "transparent" }
}), Bat = ({ state: e, dispatch: t }) => {
  let { selection: n } = e, r = it.create(n.ranges.map((i) => e.wordAt(i.head) || it.cursor(i.head)), n.mainIndex);
  return r.eq(n) ? !1 : (t(e.update({ selection: r })), !0);
};
function jat(e, t) {
  let { main: n, ranges: r } = e.selection, i = e.wordAt(n.head), o = i && i.from == n.from && i.to == n.to;
  for (let s = !1, a = new wm(e.doc, t, r[r.length - 1].to); ; )
    if (a.next(), a.done) {
      if (s)
        return null;
      a = new wm(e.doc, t, 0, Math.max(0, r[r.length - 1].from - 1)), s = !0;
    } else {
      if (s && r.some((u) => u.from == a.value.from))
        continue;
      if (o) {
        let u = e.wordAt(a.value.from);
        if (!u || u.from != a.value.from || u.to != a.value.to)
          continue;
      }
      return a.value;
    }
}
const Vat = ({ state: e, dispatch: t }) => {
  let { ranges: n } = e.selection;
  if (n.some((o) => o.from === o.to))
    return Bat({ state: e, dispatch: t });
  let r = e.sliceDoc(n[0].from, n[0].to);
  if (e.selection.ranges.some((o) => e.sliceDoc(o.from, o.to) != r))
    return !1;
  let i = jat(e, r);
  return i ? (t(e.update({
    selection: e.selection.addRange(it.range(i.from, i.to), !1),
    effects: Rt.scrollIntoView(i.to)
  })), !0) : !1;
}, Tg = /* @__PURE__ */ zt.define({
  combine(e) {
    return wu(e, {
      top: !1,
      caseSensitive: !1,
      literal: !1,
      regexp: !1,
      wholeWord: !1,
      createPanel: (t) => new Zat(t),
      scrollToMatch: (t) => Rt.scrollIntoView(t)
    });
  }
});
class WK {
  /**
  Create a query object.
  */
  constructor(t) {
    this.search = t.search, this.caseSensitive = !!t.caseSensitive, this.literal = !!t.literal, this.regexp = !!t.regexp, this.replace = t.replace || "", this.valid = !!this.search && (!this.regexp || Pat(this.search)), this.unquoted = this.unquote(this.search), this.wholeWord = !!t.wholeWord;
  }
  /**
  @internal
  */
  unquote(t) {
    return this.literal ? t : t.replace(/\\([nrt\\])/g, (n, r) => r == "n" ? `
` : r == "r" ? "\r" : r == "t" ? "	" : "\\");
  }
  /**
  Compare this query to another query.
  */
  eq(t) {
    return this.search == t.search && this.replace == t.replace && this.caseSensitive == t.caseSensitive && this.regexp == t.regexp && this.wholeWord == t.wholeWord;
  }
  /**
  @internal
  */
  create() {
    return this.regexp ? new Hat(this) : new Uat(this);
  }
  /**
  Get a search cursor for this query, searching through the given
  range in the given state.
  */
  getCursor(t, n = 0, r) {
    let i = t.doc ? t : Jn.create({ doc: t });
    return r == null && (r = i.doc.length), this.regexp ? Oh(this, i, n, r) : kh(this, i, n, r);
  }
}
class HK {
  constructor(t) {
    this.spec = t;
  }
}
function kh(e, t, n, r) {
  return new wm(t.doc, e.unquoted, n, r, e.caseSensitive ? void 0 : (i) => i.toLowerCase(), e.wholeWord ? zat(t.doc, t.charCategorizer(t.selection.main.head)) : void 0);
}
function zat(e, t) {
  return (n, r, i, o) => ((o > n || o + i.length < r) && (o = Math.max(0, n - 2), i = e.sliceString(o, Math.min(e.length, r + 2))), (t(EC(i, n - o)) != Qr.Word || t(TC(i, n - o)) != Qr.Word) && (t(TC(i, r - o)) != Qr.Word || t(EC(i, r - o)) != Qr.Word));
}
class Uat extends HK {
  constructor(t) {
    super(t);
  }
  nextMatch(t, n, r) {
    let i = kh(this.spec, t, r, t.doc.length).nextOverlapping();
    if (i.done) {
      let o = Math.min(t.doc.length, n + this.spec.unquoted.length);
      i = kh(this.spec, t, 0, o).nextOverlapping();
    }
    return i.done || i.value.from == n && i.value.to == r ? null : i.value;
  }
  // Searching in reverse is, rather than implementing an inverted search
  // cursor, done by scanning chunk after chunk forward.
  prevMatchInRange(t, n, r) {
    for (let i = r; ; ) {
      let o = Math.max(n, i - 1e4 - this.spec.unquoted.length), s = kh(this.spec, t, o, i), a = null;
      for (; !s.nextOverlapping().done; )
        a = s.value;
      if (a)
        return a;
      if (o == n)
        return null;
      i -= 1e4;
    }
  }
  prevMatch(t, n, r) {
    let i = this.prevMatchInRange(t, 0, n);
    return i || (i = this.prevMatchInRange(t, Math.max(0, r - this.spec.unquoted.length), t.doc.length)), i && (i.from != n || i.to != r) ? i : null;
  }
  getReplacement(t) {
    return this.spec.unquote(this.spec.replace);
  }
  matchAll(t, n) {
    let r = kh(this.spec, t, 0, t.doc.length), i = [];
    for (; !r.next().done; ) {
      if (i.length >= n)
        return null;
      i.push(r.value);
    }
    return i;
  }
  highlight(t, n, r, i) {
    let o = kh(this.spec, t, Math.max(0, n - this.spec.unquoted.length), Math.min(r + this.spec.unquoted.length, t.doc.length));
    for (; !o.next().done; )
      i(o.value.from, o.value.to);
  }
}
function Oh(e, t, n, r) {
  return new zK(t.doc, e.search, {
    ignoreCase: !e.caseSensitive,
    test: e.wholeWord ? Wat(t.charCategorizer(t.selection.main.head)) : void 0
  }, n, r);
}
function EC(e, t) {
  return e.slice(go(e, t, !1), t);
}
function TC(e, t) {
  return e.slice(t, go(e, t));
}
function Wat(e) {
  return (t, n, r) => !r[0].length || (e(EC(r.input, r.index)) != Qr.Word || e(TC(r.input, r.index)) != Qr.Word) && (e(TC(r.input, r.index + r[0].length)) != Qr.Word || e(EC(r.input, r.index + r[0].length)) != Qr.Word);
}
class Hat extends HK {
  nextMatch(t, n, r) {
    let i = Oh(this.spec, t, r, t.doc.length).next();
    return i.done && (i = Oh(this.spec, t, 0, n).next()), i.done ? null : i.value;
  }
  prevMatchInRange(t, n, r) {
    for (let i = 1; ; i++) {
      let o = Math.max(
        n,
        r - i * 1e4
        /* FindPrev.ChunkSize */
      ), s = Oh(this.spec, t, o, r), a = null;
      for (; !s.next().done; )
        a = s.value;
      if (a && (o == n || a.from > o + 10))
        return a;
      if (o == n)
        return null;
    }
  }
  prevMatch(t, n, r) {
    return this.prevMatchInRange(t, 0, n) || this.prevMatchInRange(t, r, t.doc.length);
  }
  getReplacement(t) {
    return this.spec.unquote(this.spec.replace).replace(/\$([$&\d+])/g, (n, r) => r == "$" ? "$" : r == "&" ? t.match[0] : r != "0" && +r < t.match.length ? t.match[r] : n);
  }
  matchAll(t, n) {
    let r = Oh(this.spec, t, 0, t.doc.length), i = [];
    for (; !r.next().done; ) {
      if (i.length >= n)
        return null;
      i.push(r.value);
    }
    return i;
  }
  highlight(t, n, r, i) {
    let o = Oh(this.spec, t, Math.max(
      0,
      n - 250
      /* RegExp.HighlightMargin */
    ), Math.min(r + 250, t.doc.length));
    for (; !o.next().done; )
      i(o.value.from, o.value.to);
  }
}
const lb = /* @__PURE__ */ An.define(), oN = /* @__PURE__ */ An.define(), ud = /* @__PURE__ */ wo.define({
  create(e) {
    return new Uw(lO(e).create(), null);
  },
  update(e, t) {
    for (let n of t.effects)
      n.is(lb) ? e = new Uw(n.value.create(), e.panel) : n.is(oN) && (e = new Uw(e.query, n.value ? sN : null));
    return e;
  },
  provide: (e) => ob.from(e, (t) => t.panel)
});
class Uw {
  constructor(t, n) {
    this.query = t, this.panel = n;
  }
}
const qat = /* @__PURE__ */ tn.mark({ class: "cm-searchMatch" }), Gat = /* @__PURE__ */ tn.mark({ class: "cm-searchMatch cm-searchMatch-selected" }), Yat = /* @__PURE__ */ Pi.fromClass(class {
  constructor(e) {
    this.view = e, this.decorations = this.highlight(e.state.field(ud));
  }
  update(e) {
    let t = e.state.field(ud);
    (t != e.startState.field(ud) || e.docChanged || e.selectionSet || e.viewportChanged) && (this.decorations = this.highlight(t));
  }
  highlight({ query: e, panel: t }) {
    if (!t || !e.spec.valid)
      return tn.none;
    let { view: n } = this, r = new uc();
    for (let i = 0, o = n.visibleRanges, s = o.length; i < s; i++) {
      let { from: a, to: u } = o[i];
      for (; i < s - 1 && u > o[i + 1].from - 2 * 250; )
        u = o[++i].to;
      e.highlight(n.state, a, u, (c, d) => {
        let f = n.state.selection.ranges.some((h) => h.from == c && h.to == d);
        r.add(c, d, f ? Gat : qat);
      });
    }
    return r.finish();
  }
}, {
  decorations: (e) => e.decorations
});
function Ev(e) {
  return (t) => {
    let n = t.state.field(ud, !1);
    return n && n.query.spec.valid ? e(t, n) : YK(t);
  };
}
const SC = /* @__PURE__ */ Ev((e, { query: t }) => {
  let { to: n } = e.state.selection.main, r = t.nextMatch(e.state, n, n);
  if (!r)
    return !1;
  let i = it.single(r.from, r.to), o = e.state.facet(Tg);
  return e.dispatch({
    selection: i,
    effects: [aN(e, r), o.scrollToMatch(i.main, e)],
    userEvent: "select.search"
  }), GK(e), !0;
}), AC = /* @__PURE__ */ Ev((e, { query: t }) => {
  let { state: n } = e, { from: r } = n.selection.main, i = t.prevMatch(n, r, r);
  if (!i)
    return !1;
  let o = it.single(i.from, i.to), s = e.state.facet(Tg);
  return e.dispatch({
    selection: o,
    effects: [aN(e, i), s.scrollToMatch(o.main, e)],
    userEvent: "select.search"
  }), GK(e), !0;
}), Kat = /* @__PURE__ */ Ev((e, { query: t }) => {
  let n = t.matchAll(e.state, 1e3);
  return !n || !n.length ? !1 : (e.dispatch({
    selection: it.create(n.map((r) => it.range(r.from, r.to))),
    userEvent: "select.search.matches"
  }), !0);
}), Jat = ({ state: e, dispatch: t }) => {
  let n = e.selection;
  if (n.ranges.length > 1 || n.main.empty)
    return !1;
  let { from: r, to: i } = n.main, o = [], s = 0;
  for (let a = new wm(e.doc, e.sliceDoc(r, i)); !a.next().done; ) {
    if (o.length > 1e3)
      return !1;
    a.value.from == r && (s = o.length), o.push(it.range(a.value.from, a.value.to));
  }
  return t(e.update({
    selection: it.create(o, s),
    userEvent: "select.search.matches"
  })), !0;
}, K5 = /* @__PURE__ */ Ev((e, { query: t }) => {
  let { state: n } = e, { from: r, to: i } = n.selection.main;
  if (n.readOnly)
    return !1;
  let o = t.nextMatch(n, r, r);
  if (!o)
    return !1;
  let s = o, a = [], u, c, d = [];
  if (s.from == r && s.to == i && (c = n.toText(t.getReplacement(s)), a.push({ from: s.from, to: s.to, insert: c }), s = t.nextMatch(n, s.from, s.to), d.push(Rt.announce.of(n.phrase("replaced match on line $", n.doc.lineAt(r).number) + "."))), s) {
    let f = a.length == 0 || a[0].from >= o.to ? 0 : o.to - o.from - c.length;
    u = it.single(s.from - f, s.to - f), d.push(aN(e, s)), d.push(n.facet(Tg).scrollToMatch(u.main, e));
  }
  return e.dispatch({
    changes: a,
    selection: u,
    effects: d,
    userEvent: "input.replace"
  }), !0;
}), Xat = /* @__PURE__ */ Ev((e, { query: t }) => {
  if (e.state.readOnly)
    return !1;
  let n = t.matchAll(e.state, 1e9).map((i) => {
    let { from: o, to: s } = i;
    return { from: o, to: s, insert: t.getReplacement(i) };
  });
  if (!n.length)
    return !1;
  let r = e.state.phrase("replaced $ matches", n.length) + ".";
  return e.dispatch({
    changes: n,
    effects: Rt.announce.of(r),
    userEvent: "input.replace.all"
  }), !0;
});
function sN(e) {
  return e.state.facet(Tg).createPanel(e);
}
function lO(e, t) {
  var n, r, i, o, s;
  let a = e.selection.main, u = a.empty || a.to > a.from + 100 ? "" : e.sliceDoc(a.from, a.to);
  if (t && !u)
    return t;
  let c = e.facet(Tg);
  return new WK({
    search: ((n = t == null ? void 0 : t.literal) !== null && n !== void 0 ? n : c.literal) ? u : u.replace(/\n/g, "\\n"),
    caseSensitive: (r = t == null ? void 0 : t.caseSensitive) !== null && r !== void 0 ? r : c.caseSensitive,
    literal: (i = t == null ? void 0 : t.literal) !== null && i !== void 0 ? i : c.literal,
    regexp: (o = t == null ? void 0 : t.regexp) !== null && o !== void 0 ? o : c.regexp,
    wholeWord: (s = t == null ? void 0 : t.wholeWord) !== null && s !== void 0 ? s : c.wholeWord
  });
}
function qK(e) {
  let t = ib(e, sN);
  return t && t.dom.querySelector("[main-field]");
}
function GK(e) {
  let t = qK(e);
  t && t == e.root.activeElement && t.select();
}
const YK = (e) => {
  let t = e.state.field(ud, !1);
  if (t && t.panel) {
    let n = qK(e);
    if (n && n != e.root.activeElement) {
      let r = lO(e.state, t.query.spec);
      r.valid && e.dispatch({ effects: lb.of(r) }), n.focus(), n.select();
    }
  } else
    e.dispatch({ effects: [
      oN.of(!0),
      t ? lb.of(lO(e.state, t.query.spec)) : An.appendConfig.of(tlt)
    ] });
  return !0;
}, KK = (e) => {
  let t = e.state.field(ud, !1);
  if (!t || !t.panel)
    return !1;
  let n = ib(e, sN);
  return n && n.dom.contains(e.root.activeElement) && e.focus(), e.dispatch({ effects: oN.of(!1) }), !0;
}, Qat = [
  { key: "Mod-f", run: YK, scope: "editor search-panel" },
  { key: "F3", run: SC, shift: AC, scope: "editor search-panel", preventDefault: !0 },
  { key: "Mod-g", run: SC, shift: AC, scope: "editor search-panel", preventDefault: !0 },
  { key: "Escape", run: KK, scope: "editor search-panel" },
  { key: "Mod-Shift-l", run: Jat },
  { key: "Mod-Alt-g", run: kat },
  { key: "Mod-d", run: Vat, preventDefault: !0 }
];
class Zat {
  constructor(t) {
    this.view = t;
    let n = this.query = t.state.field(ud).query.spec;
    this.commit = this.commit.bind(this), this.searchField = zr("input", {
      value: n.search,
      placeholder: Gs(t, "Find"),
      "aria-label": Gs(t, "Find"),
      class: "cm-textfield",
      name: "search",
      form: "",
      "main-field": "true",
      onchange: this.commit,
      onkeyup: this.commit
    }), this.replaceField = zr("input", {
      value: n.replace,
      placeholder: Gs(t, "Replace"),
      "aria-label": Gs(t, "Replace"),
      class: "cm-textfield",
      name: "replace",
      form: "",
      onchange: this.commit,
      onkeyup: this.commit
    }), this.caseField = zr("input", {
      type: "checkbox",
      name: "case",
      form: "",
      checked: n.caseSensitive,
      onchange: this.commit
    }), this.reField = zr("input", {
      type: "checkbox",
      name: "re",
      form: "",
      checked: n.regexp,
      onchange: this.commit
    }), this.wordField = zr("input", {
      type: "checkbox",
      name: "word",
      form: "",
      checked: n.wholeWord,
      onchange: this.commit
    });
    function r(i, o, s) {
      return zr("button", { class: "cm-button", name: i, onclick: o, type: "button" }, s);
    }
    this.dom = zr("div", { onkeydown: (i) => this.keydown(i), class: "cm-search" }, [
      this.searchField,
      r("next", () => SC(t), [Gs(t, "next")]),
      r("prev", () => AC(t), [Gs(t, "previous")]),
      r("select", () => Kat(t), [Gs(t, "all")]),
      zr("label", null, [this.caseField, Gs(t, "match case")]),
      zr("label", null, [this.reField, Gs(t, "regexp")]),
      zr("label", null, [this.wordField, Gs(t, "by word")]),
      ...t.state.readOnly ? [] : [
        zr("br"),
        this.replaceField,
        r("replace", () => K5(t), [Gs(t, "replace")]),
        r("replaceAll", () => Xat(t), [Gs(t, "replace all")])
      ],
      zr("button", {
        name: "close",
        onclick: () => KK(t),
        "aria-label": Gs(t, "close"),
        type: "button"
      }, ["×"])
    ]);
  }
  commit() {
    let t = new WK({
      search: this.searchField.value,
      caseSensitive: this.caseField.checked,
      regexp: this.reField.checked,
      wholeWord: this.wordField.checked,
      replace: this.replaceField.value
    });
    t.eq(this.query) || (this.query = t, this.view.dispatch({ effects: lb.of(t) }));
  }
  keydown(t) {
    ait(this.view, t, "search-panel") ? t.preventDefault() : t.keyCode == 13 && t.target == this.searchField ? (t.preventDefault(), (t.shiftKey ? AC : SC)(this.view)) : t.keyCode == 13 && t.target == this.replaceField && (t.preventDefault(), K5(this.view));
  }
  update(t) {
    for (let n of t.transactions)
      for (let r of n.effects)
        r.is(lb) && !r.value.eq(this.query) && this.setQuery(r.value);
  }
  setQuery(t) {
    this.query = t, this.searchField.value = t.search, this.replaceField.value = t.replace, this.caseField.checked = t.caseSensitive, this.reField.checked = t.regexp, this.wordField.checked = t.wholeWord;
  }
  mount() {
    this.searchField.select();
  }
  get pos() {
    return 80;
  }
  get top() {
    return this.view.state.facet(Tg).top;
  }
}
function Gs(e, t) {
  return e.state.phrase(t);
}
const Dx = 30, Cx = /[\s\.,:;?!]/;
function aN(e, { from: t, to: n }) {
  let r = e.state.doc.lineAt(t), i = e.state.doc.lineAt(n).to, o = Math.max(r.from, t - Dx), s = Math.min(i, n + Dx), a = e.state.sliceDoc(o, s);
  if (o != r.from) {
    for (let u = 0; u < Dx; u++)
      if (!Cx.test(a[u + 1]) && Cx.test(a[u])) {
        a = a.slice(u);
        break;
      }
  }
  if (s != i) {
    for (let u = a.length - 1; u > a.length - Dx; u--)
      if (!Cx.test(a[u - 1]) && Cx.test(a[u])) {
        a = a.slice(0, u);
        break;
      }
  }
  return Rt.announce.of(`${e.state.phrase("current match")}. ${a} ${e.state.phrase("on line")} ${r.number}.`);
}
const elt = /* @__PURE__ */ Rt.baseTheme({
  ".cm-panel.cm-search": {
    padding: "2px 6px 4px",
    position: "relative",
    "& [name=close]": {
      position: "absolute",
      top: "0",
      right: "4px",
      backgroundColor: "inherit",
      border: "none",
      font: "inherit",
      padding: 0,
      margin: 0
    },
    "& input, & button, & label": {
      margin: ".2em .6em .2em 0"
    },
    "& input[type=checkbox]": {
      marginRight: ".2em"
    },
    "& label": {
      fontSize: "80%",
      whiteSpace: "pre"
    }
  },
  "&light .cm-searchMatch": { backgroundColor: "#ffff0054" },
  "&dark .cm-searchMatch": { backgroundColor: "#00ffff8a" },
  "&light .cm-searchMatch-selected": { backgroundColor: "#ff6a0054" },
  "&dark .cm-searchMatch-selected": { backgroundColor: "#ff00ff8a" }
}), tlt = [
  ud,
  /* @__PURE__ */ Pf.low(Yat),
  elt
];
class JK {
  /**
  Create a new completion context. (Mostly useful for testing
  completion sources—in the editor, the extension will create
  these for you.)
  */
  constructor(t, n, r, i) {
    this.state = t, this.pos = n, this.explicit = r, this.view = i, this.abortListeners = [], this.abortOnDocChange = !1;
  }
  /**
  Get the extent, content, and (if there is a token) type of the
  token before `this.pos`.
  */
  tokenBefore(t) {
    let n = Bo(this.state).resolveInner(this.pos, -1);
    for (; n && t.indexOf(n.name) < 0; )
      n = n.parent;
    return n ? {
      from: n.from,
      to: this.pos,
      text: this.state.sliceDoc(n.from, this.pos),
      type: n.type
    } : null;
  }
  /**
  Get the match of the given expression directly before the
  cursor.
  */
  matchBefore(t) {
    let n = this.state.doc.lineAt(this.pos), r = Math.max(n.from, this.pos - 250), i = n.text.slice(r - n.from, this.pos - n.from), o = i.search(XK(t, !1));
    return o < 0 ? null : { from: r + o, to: this.pos, text: i.slice(o) };
  }
  /**
  Yields true when the query has been aborted. Can be useful in
  asynchronous queries to avoid doing work that will be ignored.
  */
  get aborted() {
    return this.abortListeners == null;
  }
  /**
  Allows you to register abort handlers, which will be called when
  the query is
  [aborted](https://codemirror.net/6/docs/ref/#autocomplete.CompletionContext.aborted).
  
  By default, running queries will not be aborted for regular
  typing or backspacing, on the assumption that they are likely to
  return a result with a
  [`validFor`](https://codemirror.net/6/docs/ref/#autocomplete.CompletionResult.validFor) field that
  allows the result to be used after all. Passing `onDocChange:
  true` will cause this query to be aborted for any document
  change.
  */
  addEventListener(t, n, r) {
    t == "abort" && this.abortListeners && (this.abortListeners.push(n), r && r.onDocChange && (this.abortOnDocChange = !0));
  }
}
function J5(e) {
  let t = Object.keys(e).join(""), n = /\w/.test(t);
  return n && (t = t.replace(/\w/g, "")), `[${n ? "\\w" : ""}${t.replace(/[^\w\s]/g, "\\$&")}]`;
}
function nlt(e) {
  let t = /* @__PURE__ */ Object.create(null), n = /* @__PURE__ */ Object.create(null);
  for (let { label: i } of e) {
    t[i[0]] = !0;
    for (let o = 1; o < i.length; o++)
      n[i[o]] = !0;
  }
  let r = J5(t) + J5(n) + "*$";
  return [new RegExp("^" + r), new RegExp(r)];
}
function rlt(e) {
  let t = e.map((i) => typeof i == "string" ? { label: i } : i), [n, r] = t.every((i) => /^\w+$/.test(i.label)) ? [/\w*$/, /\w+$/] : nlt(t);
  return (i) => {
    let o = i.matchBefore(r);
    return o || i.explicit ? { from: o ? o.from : i.pos, options: t, validFor: n } : null;
  };
}
class X5 {
  constructor(t, n, r, i) {
    this.completion = t, this.source = n, this.match = r, this.score = i;
  }
}
function jp(e) {
  return e.selection.main.from;
}
function XK(e, t) {
  var n;
  let { source: r } = e, i = t && r[0] != "^", o = r[r.length - 1] != "$";
  return !i && !o ? e : new RegExp(`${i ? "^" : ""}(?:${r})${o ? "$" : ""}`, (n = e.flags) !== null && n !== void 0 ? n : e.ignoreCase ? "i" : "");
}
const QK = /* @__PURE__ */ Au.define();
function ilt(e, t, n, r) {
  let { main: i } = e.selection, o = n - i.from, s = r - i.from;
  return Object.assign(Object.assign({}, e.changeByRange((a) => {
    if (a != i && n != r && e.sliceDoc(a.from + o, a.from + s) != e.sliceDoc(n, r))
      return { range: a };
    let u = e.toText(t);
    return {
      changes: { from: a.from + o, to: r == i.from ? a.to : a.from + s, insert: u },
      range: it.cursor(a.from + o + u.length)
    };
  })), { scrollIntoView: !0, userEvent: "input.complete" });
}
const Q5 = /* @__PURE__ */ new WeakMap();
function olt(e) {
  if (!Array.isArray(e))
    return e;
  let t = Q5.get(e);
  return t || Q5.set(e, t = rlt(e)), t;
}
const wC = /* @__PURE__ */ An.define(), ub = /* @__PURE__ */ An.define();
class slt {
  constructor(t) {
    this.pattern = t, this.chars = [], this.folded = [], this.any = [], this.precise = [], this.byWord = [], this.score = 0, this.matched = [];
    for (let n = 0; n < t.length; ) {
      let r = xs(t, n), i = Ql(r);
      this.chars.push(r);
      let o = t.slice(n, n + i), s = o.toUpperCase();
      this.folded.push(xs(s == o ? o.toLowerCase() : s, 0)), n += i;
    }
    this.astral = t.length != this.chars.length;
  }
  ret(t, n) {
    return this.score = t, this.matched = n, this;
  }
  // Matches a given word (completion) against the pattern (input).
  // Will return a boolean indicating whether there was a match and,
  // on success, set `this.score` to the score, `this.matched` to an
  // array of `from, to` pairs indicating the matched parts of `word`.
  //
  // The score is a number that is more negative the worse the match
  // is. See `Penalty` above.
  match(t) {
    if (this.pattern.length == 0)
      return this.ret(-100, []);
    if (t.length < this.pattern.length)
      return null;
    let { chars: n, folded: r, any: i, precise: o, byWord: s } = this;
    if (n.length == 1) {
      let S = xs(t, 0), w = Ql(S), O = w == t.length ? 0 : -100;
      if (S != n[0]) if (S == r[0])
        O += -200;
      else
        return null;
      return this.ret(O, [0, w]);
    }
    let a = t.indexOf(this.pattern);
    if (a == 0)
      return this.ret(t.length == this.pattern.length ? 0 : -100, [0, this.pattern.length]);
    let u = n.length, c = 0;
    if (a < 0) {
      for (let S = 0, w = Math.min(t.length, 200); S < w && c < u; ) {
        let O = xs(t, S);
        (O == n[c] || O == r[c]) && (i[c++] = S), S += Ql(O);
      }
      if (c < u)
        return null;
    }
    let d = 0, f = 0, h = !1, m = 0, v = -1, x = -1, C = /[a-z]/.test(t), E = !0;
    for (let S = 0, w = Math.min(t.length, 200), O = 0; S < w && f < u; ) {
      let A = xs(t, S);
      a < 0 && (d < u && A == n[d] && (o[d++] = S), m < u && (A == n[m] || A == r[m] ? (m == 0 && (v = S), x = S + 1, m++) : m = 0));
      let I, $ = A < 255 ? A >= 48 && A <= 57 || A >= 97 && A <= 122 ? 2 : A >= 65 && A <= 90 ? 1 : 0 : (I = $$(A)) != I.toLowerCase() ? 1 : I != I.toUpperCase() ? 2 : 0;
      (!S || $ == 1 && C || O == 0 && $ != 0) && (n[f] == A || r[f] == A && (h = !0) ? s[f++] = S : s.length && (E = !1)), O = $, S += Ql(A);
    }
    return f == u && s[0] == 0 && E ? this.result(-100 + (h ? -200 : 0), s, t) : m == u && v == 0 ? this.ret(-200 - t.length + (x == t.length ? 0 : -100), [0, x]) : a > -1 ? this.ret(-700 - t.length, [a, a + this.pattern.length]) : m == u ? this.ret(-900 - t.length, [v, x]) : f == u ? this.result(-100 + (h ? -200 : 0) + -700 + (E ? 0 : -1100), s, t) : n.length == 2 ? null : this.result((i[0] ? -700 : 0) + -200 + -1100, i, t);
  }
  result(t, n, r) {
    let i = [], o = 0;
    for (let s of n) {
      let a = s + (this.astral ? Ql(xs(r, s)) : 1);
      o && i[o - 1] == s ? i[o - 1] = a : (i[o++] = s, i[o++] = a);
    }
    return this.ret(t - r.length, i);
  }
}
class alt {
  constructor(t) {
    this.pattern = t, this.matched = [], this.score = 0, this.folded = t.toLowerCase();
  }
  match(t) {
    if (t.length < this.pattern.length)
      return null;
    let n = t.slice(0, this.pattern.length), r = n == this.pattern ? 0 : n.toLowerCase() == this.folded ? -200 : null;
    return r == null ? null : (this.matched = [0, n.length], this.score = r + (t.length == this.pattern.length ? 0 : -100), this);
  }
}
const ro = /* @__PURE__ */ zt.define({
  combine(e) {
    return wu(e, {
      activateOnTyping: !0,
      activateOnCompletion: () => !1,
      activateOnTypingDelay: 100,
      selectOnOpen: !0,
      override: null,
      closeOnBlur: !0,
      maxRenderedOptions: 100,
      defaultKeymap: !0,
      tooltipClass: () => "",
      optionClass: () => "",
      aboveCursor: !1,
      icons: !0,
      addToOptions: [],
      positionInfo: llt,
      filterStrict: !1,
      compareCompletions: (t, n) => t.label.localeCompare(n.label),
      interactionDelay: 75,
      updateSyncTime: 100
    }, {
      defaultKeymap: (t, n) => t && n,
      closeOnBlur: (t, n) => t && n,
      icons: (t, n) => t && n,
      tooltipClass: (t, n) => (r) => Z5(t(r), n(r)),
      optionClass: (t, n) => (r) => Z5(t(r), n(r)),
      addToOptions: (t, n) => t.concat(n),
      filterStrict: (t, n) => t || n
    });
  }
});
function Z5(e, t) {
  return e ? t ? e + " " + t : e : t;
}
function llt(e, t, n, r, i, o) {
  let s = e.textDirection == Jr.RTL, a = s, u = !1, c = "top", d, f, h = t.left - i.left, m = i.right - t.right, v = r.right - r.left, x = r.bottom - r.top;
  if (a && h < Math.min(v, m) ? a = !1 : !a && m < Math.min(v, h) && (a = !0), v <= (a ? h : m))
    d = Math.max(i.top, Math.min(n.top, i.bottom - x)) - t.top, f = Math.min(400, a ? h : m);
  else {
    u = !0, f = Math.min(
      400,
      (s ? t.right : i.right - t.left) - 30
      /* Info.Margin */
    );
    let S = i.bottom - t.bottom;
    S >= x || S > t.top ? d = n.bottom - t.top : (c = "bottom", d = t.bottom - n.top);
  }
  let C = (t.bottom - t.top) / o.offsetHeight, E = (t.right - t.left) / o.offsetWidth;
  return {
    style: `${c}: ${d / C}px; max-width: ${f / E}px`,
    class: "cm-completionInfo-" + (u ? s ? "left-narrow" : "right-narrow" : a ? "left" : "right")
  };
}
function ult(e) {
  let t = e.addToOptions.slice();
  return e.icons && t.push({
    render(n) {
      let r = document.createElement("div");
      return r.classList.add("cm-completionIcon"), n.type && r.classList.add(...n.type.split(/\s+/g).map((i) => "cm-completionIcon-" + i)), r.setAttribute("aria-hidden", "true"), r;
    },
    position: 20
  }), t.push({
    render(n, r, i, o) {
      let s = document.createElement("span");
      s.className = "cm-completionLabel";
      let a = n.displayLabel || n.label, u = 0;
      for (let c = 0; c < o.length; ) {
        let d = o[c++], f = o[c++];
        d > u && s.appendChild(document.createTextNode(a.slice(u, d)));
        let h = s.appendChild(document.createElement("span"));
        h.appendChild(document.createTextNode(a.slice(d, f))), h.className = "cm-completionMatchedText", u = f;
      }
      return u < a.length && s.appendChild(document.createTextNode(a.slice(u))), s;
    },
    position: 50
  }, {
    render(n) {
      if (!n.detail)
        return null;
      let r = document.createElement("span");
      return r.className = "cm-completionDetail", r.textContent = n.detail, r;
    },
    position: 80
  }), t.sort((n, r) => n.position - r.position).map((n) => n.render);
}
function Ww(e, t, n) {
  if (e <= n)
    return { from: 0, to: e };
  if (t < 0 && (t = 0), t <= e >> 1) {
    let i = Math.floor(t / n);
    return { from: i * n, to: (i + 1) * n };
  }
  let r = Math.floor((e - t) / n);
  return { from: e - (r + 1) * n, to: e - r * n };
}
class clt {
  constructor(t, n, r) {
    this.view = t, this.stateField = n, this.applyCompletion = r, this.info = null, this.infoDestroy = null, this.placeInfoReq = {
      read: () => this.measureInfo(),
      write: (u) => this.placeInfo(u),
      key: this
    }, this.space = null, this.currentClass = "";
    let i = t.state.field(n), { options: o, selected: s } = i.open, a = t.state.facet(ro);
    this.optionContent = ult(a), this.optionClass = a.optionClass, this.tooltipClass = a.tooltipClass, this.range = Ww(o.length, s, a.maxRenderedOptions), this.dom = document.createElement("div"), this.dom.className = "cm-tooltip-autocomplete", this.updateTooltipClass(t.state), this.dom.addEventListener("mousedown", (u) => {
      let { options: c } = t.state.field(n).open;
      for (let d = u.target, f; d && d != this.dom; d = d.parentNode)
        if (d.nodeName == "LI" && (f = /-(\d+)$/.exec(d.id)) && +f[1] < c.length) {
          this.applyCompletion(t, c[+f[1]]), u.preventDefault();
          return;
        }
    }), this.dom.addEventListener("focusout", (u) => {
      let c = t.state.field(this.stateField, !1);
      c && c.tooltip && t.state.facet(ro).closeOnBlur && u.relatedTarget != t.contentDOM && t.dispatch({ effects: ub.of(null) });
    }), this.showOptions(o, i.id);
  }
  mount() {
    this.updateSel();
  }
  showOptions(t, n) {
    this.list && this.list.remove(), this.list = this.dom.appendChild(this.createListBox(t, n, this.range)), this.list.addEventListener("scroll", () => {
      this.info && this.view.requestMeasure(this.placeInfoReq);
    });
  }
  update(t) {
    var n;
    let r = t.state.field(this.stateField), i = t.startState.field(this.stateField);
    if (this.updateTooltipClass(t.state), r != i) {
      let { options: o, selected: s, disabled: a } = r.open;
      (!i.open || i.open.options != o) && (this.range = Ww(o.length, s, t.state.facet(ro).maxRenderedOptions), this.showOptions(o, r.id)), this.updateSel(), a != ((n = i.open) === null || n === void 0 ? void 0 : n.disabled) && this.dom.classList.toggle("cm-tooltip-autocomplete-disabled", !!a);
    }
  }
  updateTooltipClass(t) {
    let n = this.tooltipClass(t);
    if (n != this.currentClass) {
      for (let r of this.currentClass.split(" "))
        r && this.dom.classList.remove(r);
      for (let r of n.split(" "))
        r && this.dom.classList.add(r);
      this.currentClass = n;
    }
  }
  positioned(t) {
    this.space = t, this.info && this.view.requestMeasure(this.placeInfoReq);
  }
  updateSel() {
    let t = this.view.state.field(this.stateField), n = t.open;
    if ((n.selected > -1 && n.selected < this.range.from || n.selected >= this.range.to) && (this.range = Ww(n.options.length, n.selected, this.view.state.facet(ro).maxRenderedOptions), this.showOptions(n.options, t.id)), this.updateSelectedOption(n.selected)) {
      this.destroyInfo();
      let { completion: r } = n.options[n.selected], { info: i } = r;
      if (!i)
        return;
      let o = typeof i == "string" ? document.createTextNode(i) : i(r);
      if (!o)
        return;
      "then" in o ? o.then((s) => {
        s && this.view.state.field(this.stateField, !1) == t && this.addInfoPane(s, r);
      }).catch((s) => Ts(this.view.state, s, "completion info")) : this.addInfoPane(o, r);
    }
  }
  addInfoPane(t, n) {
    this.destroyInfo();
    let r = this.info = document.createElement("div");
    if (r.className = "cm-tooltip cm-completionInfo", t.nodeType != null)
      r.appendChild(t), this.infoDestroy = null;
    else {
      let { dom: i, destroy: o } = t;
      r.appendChild(i), this.infoDestroy = o || null;
    }
    this.dom.appendChild(r), this.view.requestMeasure(this.placeInfoReq);
  }
  updateSelectedOption(t) {
    let n = null;
    for (let r = this.list.firstChild, i = this.range.from; r; r = r.nextSibling, i++)
      r.nodeName != "LI" || !r.id ? i-- : i == t ? r.hasAttribute("aria-selected") || (r.setAttribute("aria-selected", "true"), n = r) : r.hasAttribute("aria-selected") && r.removeAttribute("aria-selected");
    return n && plt(this.list, n), n;
  }
  measureInfo() {
    let t = this.dom.querySelector("[aria-selected]");
    if (!t || !this.info)
      return null;
    let n = this.dom.getBoundingClientRect(), r = this.info.getBoundingClientRect(), i = t.getBoundingClientRect(), o = this.space;
    if (!o) {
      let s = this.dom.ownerDocument.defaultView || window;
      o = { left: 0, top: 0, right: s.innerWidth, bottom: s.innerHeight };
    }
    return i.top > Math.min(o.bottom, n.bottom) - 10 || i.bottom < Math.max(o.top, n.top) + 10 ? null : this.view.state.facet(ro).positionInfo(this.view, n, i, r, o, this.dom);
  }
  placeInfo(t) {
    this.info && (t ? (t.style && (this.info.style.cssText = t.style), this.info.className = "cm-tooltip cm-completionInfo " + (t.class || "")) : this.info.style.cssText = "top: -1e6px");
  }
  createListBox(t, n, r) {
    const i = document.createElement("ul");
    i.id = n, i.setAttribute("role", "listbox"), i.setAttribute("aria-expanded", "true"), i.setAttribute("aria-label", this.view.state.phrase("Completions"));
    let o = null;
    for (let s = r.from; s < r.to; s++) {
      let { completion: a, match: u } = t[s], { section: c } = a;
      if (c) {
        let h = typeof c == "string" ? c : c.name;
        if (h != o && (s > r.from || r.from == 0))
          if (o = h, typeof c != "string" && c.header)
            i.appendChild(c.header(c));
          else {
            let m = i.appendChild(document.createElement("completion-section"));
            m.textContent = h;
          }
      }
      const d = i.appendChild(document.createElement("li"));
      d.id = n + "-" + s, d.setAttribute("role", "option");
      let f = this.optionClass(a);
      f && (d.className = f);
      for (let h of this.optionContent) {
        let m = h(a, this.view.state, this.view, u);
        m && d.appendChild(m);
      }
    }
    return r.from && i.classList.add("cm-completionListIncompleteTop"), r.to < t.length && i.classList.add("cm-completionListIncompleteBottom"), i;
  }
  destroyInfo() {
    this.info && (this.infoDestroy && this.infoDestroy(), this.info.remove(), this.info = null);
  }
  destroy() {
    this.destroyInfo();
  }
}
function dlt(e, t) {
  return (n) => new clt(n, e, t);
}
function plt(e, t) {
  let n = e.getBoundingClientRect(), r = t.getBoundingClientRect(), i = n.height / e.offsetHeight;
  r.top < n.top ? e.scrollTop -= (n.top - r.top) / i : r.bottom > n.bottom && (e.scrollTop += (r.bottom - n.bottom) / i);
}
function e4(e) {
  return (e.boost || 0) * 100 + (e.apply ? 10 : 0) + (e.info ? 5 : 0) + (e.type ? 1 : 0);
}
function flt(e, t) {
  let n = [], r = null, i = (c) => {
    n.push(c);
    let { section: d } = c.completion;
    if (d) {
      r || (r = []);
      let f = typeof d == "string" ? d : d.name;
      r.some((h) => h.name == f) || r.push(typeof d == "string" ? { name: f } : d);
    }
  }, o = t.facet(ro);
  for (let c of e)
    if (c.hasResult()) {
      let d = c.result.getMatch;
      if (c.result.filter === !1)
        for (let f of c.result.options)
          i(new X5(f, c.source, d ? d(f) : [], 1e9 - n.length));
      else {
        let f = t.sliceDoc(c.from, c.to), h, m = o.filterStrict ? new alt(f) : new slt(f);
        for (let v of c.result.options)
          if (h = m.match(v.label)) {
            let x = v.displayLabel ? d ? d(v, h.matched) : [] : h.matched;
            i(new X5(v, c.source, x, h.score + (v.boost || 0)));
          }
      }
    }
  if (r) {
    let c = /* @__PURE__ */ Object.create(null), d = 0, f = (h, m) => {
      var v, x;
      return ((v = h.rank) !== null && v !== void 0 ? v : 1e9) - ((x = m.rank) !== null && x !== void 0 ? x : 1e9) || (h.name < m.name ? -1 : 1);
    };
    for (let h of r.sort(f))
      d -= 1e5, c[h.name] = d;
    for (let h of n) {
      let { section: m } = h.completion;
      m && (h.score += c[typeof m == "string" ? m : m.name]);
    }
  }
  let s = [], a = null, u = o.compareCompletions;
  for (let c of n.sort((d, f) => f.score - d.score || u(d.completion, f.completion))) {
    let d = c.completion;
    !a || a.label != d.label || a.detail != d.detail || a.type != null && d.type != null && a.type != d.type || a.apply != d.apply || a.boost != d.boost ? s.push(c) : e4(c.completion) > e4(a) && (s[s.length - 1] = c), a = c.completion;
  }
  return s;
}
class Lh {
  constructor(t, n, r, i, o, s) {
    this.options = t, this.attrs = n, this.tooltip = r, this.timestamp = i, this.selected = o, this.disabled = s;
  }
  setSelected(t, n) {
    return t == this.selected || t >= this.options.length ? this : new Lh(this.options, t4(n, t), this.tooltip, this.timestamp, t, this.disabled);
  }
  static build(t, n, r, i, o, s) {
    if (i && !s && t.some((c) => c.isPending))
      return i.setDisabled();
    let a = flt(t, n);
    if (!a.length)
      return i && t.some((c) => c.isPending) ? i.setDisabled() : null;
    let u = n.facet(ro).selectOnOpen ? 0 : -1;
    if (i && i.selected != u && i.selected != -1) {
      let c = i.options[i.selected].completion;
      for (let d = 0; d < a.length; d++)
        if (a[d].completion == c) {
          u = d;
          break;
        }
    }
    return new Lh(a, t4(r, u), {
      pos: t.reduce((c, d) => d.hasResult() ? Math.min(c, d.from) : c, 1e8),
      create: vlt,
      above: o.aboveCursor
    }, i ? i.timestamp : Date.now(), u, !1);
  }
  map(t) {
    return new Lh(this.options, this.attrs, Object.assign(Object.assign({}, this.tooltip), { pos: t.mapPos(this.tooltip.pos) }), this.timestamp, this.selected, this.disabled);
  }
  setDisabled() {
    return new Lh(this.options, this.attrs, this.tooltip, this.timestamp, this.selected, !0);
  }
}
class PC {
  constructor(t, n, r) {
    this.active = t, this.id = n, this.open = r;
  }
  static start() {
    return new PC(ylt, "cm-ac-" + Math.floor(Math.random() * 2e6).toString(36), null);
  }
  update(t) {
    let { state: n } = t, r = n.facet(ro), o = (r.override || n.languageDataAt("autocomplete", jp(n)).map(olt)).map((u) => (this.active.find((d) => d.source == u) || new $a(
      u,
      this.active.some(
        (d) => d.state != 0
        /* State.Inactive */
      ) ? 1 : 0
      /* State.Inactive */
    )).update(t, r));
    o.length == this.active.length && o.every((u, c) => u == this.active[c]) && (o = this.active);
    let s = this.open, a = t.effects.some((u) => u.is(lN));
    s && t.docChanged && (s = s.map(t.changes)), t.selection || o.some((u) => u.hasResult() && t.changes.touchesRange(u.from, u.to)) || !hlt(o, this.active) || a ? s = Lh.build(o, n, this.id, s, r, a) : s && s.disabled && !o.some((u) => u.isPending) && (s = null), !s && o.every((u) => !u.isPending) && o.some((u) => u.hasResult()) && (o = o.map((u) => u.hasResult() ? new $a(
      u.source,
      0
      /* State.Inactive */
    ) : u));
    for (let u of t.effects)
      u.is(eJ) && (s = s && s.setSelected(u.value, this.id));
    return o == this.active && s == this.open ? this : new PC(o, this.id, s);
  }
  get tooltip() {
    return this.open ? this.open.tooltip : null;
  }
  get attrs() {
    return this.open ? this.open.attrs : this.active.length ? mlt : glt;
  }
}
function hlt(e, t) {
  if (e == t)
    return !0;
  for (let n = 0, r = 0; ; ) {
    for (; n < e.length && !e[n].hasResult(); )
      n++;
    for (; r < t.length && !t[r].hasResult(); )
      r++;
    let i = n == e.length, o = r == t.length;
    if (i || o)
      return i == o;
    if (e[n++].result != t[r++].result)
      return !1;
  }
}
const mlt = {
  "aria-autocomplete": "list"
}, glt = {};
function t4(e, t) {
  let n = {
    "aria-autocomplete": "list",
    "aria-haspopup": "listbox",
    "aria-controls": e
  };
  return t > -1 && (n["aria-activedescendant"] = e + "-" + t), n;
}
const ylt = [];
function ZK(e, t) {
  if (e.isUserEvent("input.complete")) {
    let r = e.annotation(QK);
    if (r && t.activateOnCompletion(r))
      return 12;
  }
  let n = e.isUserEvent("input.type");
  return n && t.activateOnTyping ? 5 : n ? 1 : e.isUserEvent("delete.backward") ? 2 : e.selection ? 8 : e.docChanged ? 16 : 0;
}
class $a {
  constructor(t, n, r = !1) {
    this.source = t, this.state = n, this.explicit = r;
  }
  hasResult() {
    return !1;
  }
  get isPending() {
    return this.state == 1;
  }
  update(t, n) {
    let r = ZK(t, n), i = this;
    (r & 8 || r & 16 && this.touches(t)) && (i = new $a(
      i.source,
      0
      /* State.Inactive */
    )), r & 4 && i.state == 0 && (i = new $a(
      this.source,
      1
      /* State.Pending */
    )), i = i.updateFor(t, r);
    for (let o of t.effects)
      if (o.is(wC))
        i = new $a(i.source, 1, o.value);
      else if (o.is(ub))
        i = new $a(
          i.source,
          0
          /* State.Inactive */
        );
      else if (o.is(lN))
        for (let s of o.value)
          s.source == i.source && (i = s);
    return i;
  }
  updateFor(t, n) {
    return this.map(t.changes);
  }
  map(t) {
    return this;
  }
  touches(t) {
    return t.changes.touchesRange(jp(t.state));
  }
}
class rm extends $a {
  constructor(t, n, r, i, o, s) {
    super(t, 3, n), this.limit = r, this.result = i, this.from = o, this.to = s;
  }
  hasResult() {
    return !0;
  }
  updateFor(t, n) {
    var r;
    if (!(n & 3))
      return this.map(t.changes);
    let i = this.result;
    i.map && !t.changes.empty && (i = i.map(i, t.changes));
    let o = t.changes.mapPos(this.from), s = t.changes.mapPos(this.to, 1), a = jp(t.state);
    if (a > s || !i || n & 2 && (jp(t.startState) == this.from || a < this.limit))
      return new $a(
        this.source,
        n & 4 ? 1 : 0
        /* State.Inactive */
      );
    let u = t.changes.mapPos(this.limit);
    return blt(i.validFor, t.state, o, s) ? new rm(this.source, this.explicit, u, i, o, s) : i.update && (i = i.update(i, o, s, new JK(t.state, a, !1))) ? new rm(this.source, this.explicit, u, i, i.from, (r = i.to) !== null && r !== void 0 ? r : jp(t.state)) : new $a(this.source, 1, this.explicit);
  }
  map(t) {
    return t.empty ? this : (this.result.map ? this.result.map(this.result, t) : this.result) ? new rm(this.source, this.explicit, t.mapPos(this.limit), this.result, t.mapPos(this.from), t.mapPos(this.to, 1)) : new $a(
      this.source,
      0
      /* State.Inactive */
    );
  }
  touches(t) {
    return t.changes.touchesRange(this.from, this.to);
  }
}
function blt(e, t, n, r) {
  if (!e)
    return !1;
  let i = t.sliceDoc(n, r);
  return typeof e == "function" ? e(i, n, r, t) : XK(e, !0).test(i);
}
const lN = /* @__PURE__ */ An.define({
  map(e, t) {
    return e.map((n) => n.map(t));
  }
}), eJ = /* @__PURE__ */ An.define(), Cs = /* @__PURE__ */ wo.define({
  create() {
    return PC.start();
  },
  update(e, t) {
    return e.update(t);
  },
  provide: (e) => [
    Y$.from(e, (t) => t.tooltip),
    Rt.contentAttributes.from(e, (t) => t.attrs)
  ]
});
function uN(e, t) {
  const n = t.completion.apply || t.completion.label;
  let r = e.state.field(Cs).active.find((i) => i.source == t.source);
  return r instanceof rm ? (typeof n == "string" ? e.dispatch(Object.assign(Object.assign({}, ilt(e.state, n, r.from, r.to)), { annotations: QK.of(t.completion) })) : n(e, t.completion, r.from, r.to), !0) : !1;
}
const vlt = /* @__PURE__ */ dlt(Cs, uN);
function Ex(e, t = "option") {
  return (n) => {
    let r = n.state.field(Cs, !1);
    if (!r || !r.open || r.open.disabled || Date.now() - r.open.timestamp < n.state.facet(ro).interactionDelay)
      return !1;
    let i = 1, o;
    t == "page" && (o = NY(n, r.open.tooltip)) && (i = Math.max(2, Math.floor(o.dom.offsetHeight / o.dom.querySelector("li").offsetHeight) - 1));
    let { length: s } = r.open.options, a = r.open.selected > -1 ? r.open.selected + i * (e ? 1 : -1) : e ? 0 : s - 1;
    return a < 0 ? a = t == "page" ? 0 : s - 1 : a >= s && (a = t == "page" ? s - 1 : 0), n.dispatch({ effects: eJ.of(a) }), !0;
  };
}
const xlt = (e) => {
  let t = e.state.field(Cs, !1);
  return e.state.readOnly || !t || !t.open || t.open.selected < 0 || t.open.disabled || Date.now() - t.open.timestamp < e.state.facet(ro).interactionDelay ? !1 : uN(e, t.open.options[t.open.selected]);
}, n4 = (e) => e.state.field(Cs, !1) ? (e.dispatch({ effects: wC.of(!0) }), !0) : !1, Dlt = (e) => {
  let t = e.state.field(Cs, !1);
  return !t || !t.active.some(
    (n) => n.state != 0
    /* State.Inactive */
  ) ? !1 : (e.dispatch({ effects: ub.of(null) }), !0);
};
class Clt {
  constructor(t, n) {
    this.active = t, this.context = n, this.time = Date.now(), this.updates = [], this.done = void 0;
  }
}
const Elt = 50, Tlt = 1e3, Slt = /* @__PURE__ */ Pi.fromClass(class {
  constructor(e) {
    this.view = e, this.debounceUpdate = -1, this.running = [], this.debounceAccept = -1, this.pendingStart = !1, this.composing = 0;
    for (let t of e.state.field(Cs).active)
      t.isPending && this.startQuery(t);
  }
  update(e) {
    let t = e.state.field(Cs), n = e.state.facet(ro);
    if (!e.selectionSet && !e.docChanged && e.startState.field(Cs) == t)
      return;
    let r = e.transactions.some((o) => {
      let s = ZK(o, n);
      return s & 8 || (o.selection || o.docChanged) && !(s & 3);
    });
    for (let o = 0; o < this.running.length; o++) {
      let s = this.running[o];
      if (r || s.context.abortOnDocChange && e.docChanged || s.updates.length + e.transactions.length > Elt && Date.now() - s.time > Tlt) {
        for (let a of s.context.abortListeners)
          try {
            a();
          } catch (u) {
            Ts(this.view.state, u);
          }
        s.context.abortListeners = null, this.running.splice(o--, 1);
      } else
        s.updates.push(...e.transactions);
    }
    this.debounceUpdate > -1 && clearTimeout(this.debounceUpdate), e.transactions.some((o) => o.effects.some((s) => s.is(wC))) && (this.pendingStart = !0);
    let i = this.pendingStart ? 50 : n.activateOnTypingDelay;
    if (this.debounceUpdate = t.active.some((o) => o.isPending && !this.running.some((s) => s.active.source == o.source)) ? setTimeout(() => this.startUpdate(), i) : -1, this.composing != 0)
      for (let o of e.transactions)
        o.isUserEvent("input.type") ? this.composing = 2 : this.composing == 2 && o.selection && (this.composing = 3);
  }
  startUpdate() {
    this.debounceUpdate = -1, this.pendingStart = !1;
    let { state: e } = this.view, t = e.field(Cs);
    for (let n of t.active)
      n.isPending && !this.running.some((r) => r.active.source == n.source) && this.startQuery(n);
    this.running.length && t.open && t.open.disabled && (this.debounceAccept = setTimeout(() => this.accept(), this.view.state.facet(ro).updateSyncTime));
  }
  startQuery(e) {
    let { state: t } = this.view, n = jp(t), r = new JK(t, n, e.explicit, this.view), i = new Clt(e, r);
    this.running.push(i), Promise.resolve(e.source(r)).then((o) => {
      i.context.aborted || (i.done = o || null, this.scheduleAccept());
    }, (o) => {
      this.view.dispatch({ effects: ub.of(null) }), Ts(this.view.state, o);
    });
  }
  scheduleAccept() {
    this.running.every((e) => e.done !== void 0) ? this.accept() : this.debounceAccept < 0 && (this.debounceAccept = setTimeout(() => this.accept(), this.view.state.facet(ro).updateSyncTime));
  }
  // For each finished query in this.running, try to create a result
  // or, if appropriate, restart the query.
  accept() {
    var e;
    this.debounceAccept > -1 && clearTimeout(this.debounceAccept), this.debounceAccept = -1;
    let t = [], n = this.view.state.facet(ro), r = this.view.state.field(Cs);
    for (let i = 0; i < this.running.length; i++) {
      let o = this.running[i];
      if (o.done === void 0)
        continue;
      if (this.running.splice(i--, 1), o.done) {
        let a = jp(o.updates.length ? o.updates[0].startState : this.view.state), u = Math.min(a, o.done.from + (o.active.explicit ? 0 : 1)), c = new rm(o.active.source, o.active.explicit, u, o.done, o.done.from, (e = o.done.to) !== null && e !== void 0 ? e : a);
        for (let d of o.updates)
          c = c.update(d, n);
        if (c.hasResult()) {
          t.push(c);
          continue;
        }
      }
      let s = r.active.find((a) => a.source == o.active.source);
      if (s && s.isPending)
        if (o.done == null) {
          let a = new $a(
            o.active.source,
            0
            /* State.Inactive */
          );
          for (let u of o.updates)
            a = a.update(u, n);
          a.isPending || t.push(a);
        } else
          this.startQuery(s);
    }
    (t.length || r.open && r.open.disabled) && this.view.dispatch({ effects: lN.of(t) });
  }
}, {
  eventHandlers: {
    blur(e) {
      let t = this.view.state.field(Cs, !1);
      if (t && t.tooltip && this.view.state.facet(ro).closeOnBlur) {
        let n = t.open && NY(this.view, t.open.tooltip);
        (!n || !n.dom.contains(e.relatedTarget)) && setTimeout(() => this.view.dispatch({ effects: ub.of(null) }), 10);
      }
    },
    compositionstart() {
      this.composing = 1;
    },
    compositionend() {
      this.composing == 3 && setTimeout(() => this.view.dispatch({ effects: wC.of(!1) }), 20), this.composing = 0;
    }
  }
}), Alt = typeof navigator == "object" && /* @__PURE__ */ /Win/.test(navigator.platform), wlt = /* @__PURE__ */ Pf.highest(/* @__PURE__ */ Rt.domEventHandlers({
  keydown(e, t) {
    let n = t.state.field(Cs, !1);
    if (!n || !n.open || n.open.disabled || n.open.selected < 0 || e.key.length > 1 || e.ctrlKey && !(Alt && e.altKey) || e.metaKey)
      return !1;
    let r = n.open.options[n.open.selected], i = n.active.find((s) => s.source == r.source), o = r.completion.commitCharacters || i.result.commitCharacters;
    return o && o.indexOf(e.key) > -1 && uN(t, r), !1;
  }
})), Plt = /* @__PURE__ */ Rt.baseTheme({
  ".cm-tooltip.cm-tooltip-autocomplete": {
    "& > ul": {
      fontFamily: "monospace",
      whiteSpace: "nowrap",
      overflow: "hidden auto",
      maxWidth_fallback: "700px",
      maxWidth: "min(700px, 95vw)",
      minWidth: "250px",
      maxHeight: "10em",
      height: "100%",
      listStyle: "none",
      margin: 0,
      padding: 0,
      "& > li, & > completion-section": {
        padding: "1px 3px",
        lineHeight: 1.2
      },
      "& > li": {
        overflowX: "hidden",
        textOverflow: "ellipsis",
        cursor: "pointer"
      },
      "& > completion-section": {
        display: "list-item",
        borderBottom: "1px solid silver",
        paddingLeft: "0.5em",
        opacity: 0.7
      }
    }
  },
  "&light .cm-tooltip-autocomplete ul li[aria-selected]": {
    background: "#17c",
    color: "white"
  },
  "&light .cm-tooltip-autocomplete-disabled ul li[aria-selected]": {
    background: "#777"
  },
  "&dark .cm-tooltip-autocomplete ul li[aria-selected]": {
    background: "#347",
    color: "white"
  },
  "&dark .cm-tooltip-autocomplete-disabled ul li[aria-selected]": {
    background: "#444"
  },
  ".cm-completionListIncompleteTop:before, .cm-completionListIncompleteBottom:after": {
    content: '"···"',
    opacity: 0.5,
    display: "block",
    textAlign: "center"
  },
  ".cm-tooltip.cm-completionInfo": {
    position: "absolute",
    padding: "3px 9px",
    width: "max-content",
    maxWidth: "400px",
    boxSizing: "border-box",
    whiteSpace: "pre-line"
  },
  ".cm-completionInfo.cm-completionInfo-left": { right: "100%" },
  ".cm-completionInfo.cm-completionInfo-right": { left: "100%" },
  ".cm-completionInfo.cm-completionInfo-left-narrow": { right: "30px" },
  ".cm-completionInfo.cm-completionInfo-right-narrow": { left: "30px" },
  "&light .cm-snippetField": { backgroundColor: "#00000022" },
  "&dark .cm-snippetField": { backgroundColor: "#ffffff22" },
  ".cm-snippetFieldPosition": {
    verticalAlign: "text-top",
    width: 0,
    height: "1.15em",
    display: "inline-block",
    margin: "0 -0.7px -.7em",
    borderLeft: "1.4px dotted #888"
  },
  ".cm-completionMatchedText": {
    textDecoration: "underline"
  },
  ".cm-completionDetail": {
    marginLeft: "0.5em",
    fontStyle: "italic"
  },
  ".cm-completionIcon": {
    fontSize: "90%",
    width: ".8em",
    display: "inline-block",
    textAlign: "center",
    paddingRight: ".6em",
    opacity: "0.6",
    boxSizing: "content-box"
  },
  ".cm-completionIcon-function, .cm-completionIcon-method": {
    "&:after": { content: "'ƒ'" }
  },
  ".cm-completionIcon-class": {
    "&:after": { content: "'○'" }
  },
  ".cm-completionIcon-interface": {
    "&:after": { content: "'◌'" }
  },
  ".cm-completionIcon-variable": {
    "&:after": { content: "'𝑥'" }
  },
  ".cm-completionIcon-constant": {
    "&:after": { content: "'𝐶'" }
  },
  ".cm-completionIcon-type": {
    "&:after": { content: "'𝑡'" }
  },
  ".cm-completionIcon-enum": {
    "&:after": { content: "'∪'" }
  },
  ".cm-completionIcon-property": {
    "&:after": { content: "'□'" }
  },
  ".cm-completionIcon-keyword": {
    "&:after": { content: "'🔑︎'" }
    // Disable emoji rendering
  },
  ".cm-completionIcon-namespace": {
    "&:after": { content: "'▢'" }
  },
  ".cm-completionIcon-text": {
    "&:after": { content: "'abc'", fontSize: "50%", verticalAlign: "middle" }
  }
}), cb = {
  brackets: ["(", "[", "{", "'", '"'],
  before: ")]}:;>",
  stringPrefixes: []
}, Fp = /* @__PURE__ */ An.define({
  map(e, t) {
    let n = t.mapPos(e, -1, es.TrackAfter);
    return n ?? void 0;
  }
}), cN = /* @__PURE__ */ new class extends Qp {
}();
cN.startSide = 1;
cN.endSide = -1;
const tJ = /* @__PURE__ */ wo.define({
  create() {
    return ir.empty;
  },
  update(e, t) {
    if (e = e.map(t.changes), t.selection) {
      let n = t.state.doc.lineAt(t.selection.main.head);
      e = e.update({ filter: (r) => r >= n.from && r <= n.to });
    }
    for (let n of t.effects)
      n.is(Fp) && (e = e.update({ add: [cN.range(n.value, n.value + 1)] }));
    return e;
  }
});
function klt() {
  return [Ilt, tJ];
}
const Hw = "()[]{}<>";
function nJ(e) {
  for (let t = 0; t < Hw.length; t += 2)
    if (Hw.charCodeAt(t) == e)
      return Hw.charAt(t + 1);
  return $$(e < 128 ? e : e + 1);
}
function rJ(e, t) {
  return e.languageDataAt("closeBrackets", t)[0] || cb;
}
const Olt = typeof navigator == "object" && /* @__PURE__ */ /Android\b/.test(navigator.userAgent), Ilt = /* @__PURE__ */ Rt.inputHandler.of((e, t, n, r) => {
  if ((Olt ? e.composing : e.compositionStarted) || e.state.readOnly)
    return !1;
  let i = e.state.selection.main;
  if (r.length > 2 || r.length == 2 && Ql(xs(r, 0)) == 1 || t != i.from || n != i.to)
    return !1;
  let o = Nlt(e.state, r);
  return o ? (e.dispatch(o), !0) : !1;
}), Flt = ({ state: e, dispatch: t }) => {
  if (e.readOnly)
    return !1;
  let r = rJ(e, e.selection.main.head).brackets || cb.brackets, i = null, o = e.changeByRange((s) => {
    if (s.empty) {
      let a = Mlt(e.doc, s.head);
      for (let u of r)
        if (u == a && yT(e.doc, s.head) == nJ(xs(u, 0)))
          return {
            changes: { from: s.head - u.length, to: s.head + u.length },
            range: it.cursor(s.head - u.length)
          };
    }
    return { range: i = s };
  });
  return i || t(e.update(o, { scrollIntoView: !0, userEvent: "delete.backward" })), !i;
}, $lt = [
  { key: "Backspace", run: Flt }
];
function Nlt(e, t) {
  let n = rJ(e, e.selection.main.head), r = n.brackets || cb.brackets;
  for (let i of r) {
    let o = nJ(xs(i, 0));
    if (t == i)
      return o == i ? Llt(e, i, r.indexOf(i + i + i) > -1, n) : Rlt(e, i, o, n.before || cb.before);
    if (t == o && iJ(e, e.selection.main.from))
      return _lt(e, i, o);
  }
  return null;
}
function iJ(e, t) {
  let n = !1;
  return e.field(tJ).between(0, e.doc.length, (r) => {
    r == t && (n = !0);
  }), n;
}
function yT(e, t) {
  let n = e.sliceString(t, t + 2);
  return n.slice(0, Ql(xs(n, 0)));
}
function Mlt(e, t) {
  let n = e.sliceString(t - 2, t);
  return Ql(xs(n, 0)) == n.length ? n : n.slice(1);
}
function Rlt(e, t, n, r) {
  let i = null, o = e.changeByRange((s) => {
    if (!s.empty)
      return {
        changes: [{ insert: t, from: s.from }, { insert: n, from: s.to }],
        effects: Fp.of(s.to + t.length),
        range: it.range(s.anchor + t.length, s.head + t.length)
      };
    let a = yT(e.doc, s.head);
    return !a || /\s/.test(a) || r.indexOf(a) > -1 ? {
      changes: { insert: t + n, from: s.head },
      effects: Fp.of(s.head + t.length),
      range: it.cursor(s.head + t.length)
    } : { range: i = s };
  });
  return i ? null : e.update(o, {
    scrollIntoView: !0,
    userEvent: "input.type"
  });
}
function _lt(e, t, n) {
  let r = null, i = e.changeByRange((o) => o.empty && yT(e.doc, o.head) == n ? {
    changes: { from: o.head, to: o.head + n.length, insert: n },
    range: it.cursor(o.head + n.length)
  } : r = { range: o });
  return r ? null : e.update(i, {
    scrollIntoView: !0,
    userEvent: "input.type"
  });
}
function Llt(e, t, n, r) {
  let i = r.stringPrefixes || cb.stringPrefixes, o = null, s = e.changeByRange((a) => {
    if (!a.empty)
      return {
        changes: [{ insert: t, from: a.from }, { insert: t, from: a.to }],
        effects: Fp.of(a.to + t.length),
        range: it.range(a.anchor + t.length, a.head + t.length)
      };
    let u = a.head, c = yT(e.doc, u), d;
    if (c == t) {
      if (r4(e, u))
        return {
          changes: { insert: t + t, from: u },
          effects: Fp.of(u + t.length),
          range: it.cursor(u + t.length)
        };
      if (iJ(e, u)) {
        let h = n && e.sliceDoc(u, u + t.length * 3) == t + t + t ? t + t + t : t;
        return {
          changes: { from: u, to: u + h.length, insert: h },
          range: it.cursor(u + h.length)
        };
      }
    } else {
      if (n && e.sliceDoc(u - 2 * t.length, u) == t + t && (d = i4(e, u - 2 * t.length, i)) > -1 && r4(e, d))
        return {
          changes: { insert: t + t + t + t, from: u },
          effects: Fp.of(u + t.length),
          range: it.cursor(u + t.length)
        };
      if (e.charCategorizer(u)(c) != Qr.Word && i4(e, u, i) > -1 && !Blt(e, u, t, i))
        return {
          changes: { insert: t + t, from: u },
          effects: Fp.of(u + t.length),
          range: it.cursor(u + t.length)
        };
    }
    return { range: o = a };
  });
  return o ? null : e.update(s, {
    scrollIntoView: !0,
    userEvent: "input.type"
  });
}
function r4(e, t) {
  let n = Bo(e).resolveInner(t + 1);
  return n.parent && n.from == t;
}
function Blt(e, t, n, r) {
  let i = Bo(e).resolveInner(t, -1), o = r.reduce((s, a) => Math.max(s, a.length), 0);
  for (let s = 0; s < 5; s++) {
    let a = e.sliceDoc(i.from, Math.min(i.to, i.from + n.length + o)), u = a.indexOf(n);
    if (!u || u > -1 && r.indexOf(a.slice(0, u)) > -1) {
      let d = i.firstChild;
      for (; d && d.from == i.from && d.to - d.from > n.length + u; ) {
        if (e.sliceDoc(d.to - n.length, d.to) == n)
          return !1;
        d = d.firstChild;
      }
      return !0;
    }
    let c = i.to == t && i.parent;
    if (!c)
      break;
    i = c;
  }
  return !1;
}
function i4(e, t, n) {
  let r = e.charCategorizer(t);
  if (r(e.sliceDoc(t - 1, t)) != Qr.Word)
    return t;
  for (let i of n) {
    let o = t - i.length;
    if (e.sliceDoc(o, t) == i && r(e.sliceDoc(o - 1, o)) != Qr.Word)
      return o;
  }
  return -1;
}
function jlt(e = {}) {
  return [
    wlt,
    Cs,
    ro.of(e),
    Slt,
    Vlt,
    Plt
  ];
}
const oJ = [
  { key: "Ctrl-Space", run: n4 },
  { mac: "Alt-`", run: n4 },
  { key: "Escape", run: Dlt },
  { key: "ArrowDown", run: /* @__PURE__ */ Ex(!0) },
  { key: "ArrowUp", run: /* @__PURE__ */ Ex(!1) },
  { key: "PageDown", run: /* @__PURE__ */ Ex(!0, "page") },
  { key: "PageUp", run: /* @__PURE__ */ Ex(!1, "page") },
  { key: "Enter", run: xlt }
], Vlt = /* @__PURE__ */ Pf.highest(/* @__PURE__ */ lT.computeN([ro], (e) => e.facet(ro).defaultKeymap ? [oJ] : []));
class o4 {
  constructor(t, n, r) {
    this.from = t, this.to = n, this.diagnostic = r;
  }
}
class Ap {
  constructor(t, n, r) {
    this.diagnostics = t, this.panel = n, this.selected = r;
  }
  static init(t, n, r) {
    let i = t, o = r.facet(db).markerFilter;
    o && (i = o(i, r));
    let s = t.slice().sort((f, h) => f.from - h.from || f.to - h.to), a = new uc(), u = [], c = 0;
    for (let f = 0; ; ) {
      let h = f == s.length ? null : s[f];
      if (!h && !u.length)
        break;
      let m, v;
      for (u.length ? (m = c, v = u.reduce((C, E) => Math.min(C, E.to), h && h.from > m ? h.from : 1e8)) : (m = h.from, v = h.to, u.push(h), f++); f < s.length; ) {
        let C = s[f];
        if (C.from == m && (C.to > C.from || C.to == m))
          u.push(C), f++, v = Math.min(C.to, v);
        else {
          v = Math.min(C.from, v);
          break;
        }
      }
      let x = eut(u);
      if (u.some((C) => C.from == C.to || C.from == C.to - 1 && r.doc.lineAt(C.from).to == C.from))
        a.add(m, m, tn.widget({
          widget: new Jlt(x),
          diagnostics: u.slice()
        }));
      else {
        let C = u.reduce((E, S) => S.markClass ? E + " " + S.markClass : E, "");
        a.add(m, v, tn.mark({
          class: "cm-lintRange cm-lintRange-" + x + C,
          diagnostics: u.slice(),
          inclusiveEnd: u.some((E) => E.to > v)
        }));
      }
      c = v;
      for (let C = 0; C < u.length; C++)
        u[C].to <= c && u.splice(C--, 1);
    }
    let d = a.finish();
    return new Ap(d, n, Pm(d));
  }
}
function Pm(e, t = null, n = 0) {
  let r = null;
  return e.between(n, 1e9, (i, o, { spec: s }) => {
    if (!(t && s.diagnostics.indexOf(t) < 0))
      if (!r)
        r = new o4(i, o, t || s.diagnostics[0]);
      else {
        if (s.diagnostics.indexOf(r.diagnostic) < 0)
          return !1;
        r = new o4(r.from, o, r.diagnostic);
      }
  }), r;
}
function zlt(e, t) {
  let n = t.pos, r = t.end || n, i = e.state.facet(db).hideOn(e, n, r);
  if (i != null)
    return i;
  let o = e.startState.doc.lineAt(t.pos);
  return !!(e.effects.some((s) => s.is(sJ)) || e.changes.touchesRange(o.from, Math.max(o.to, r)));
}
function Ult(e, t) {
  return e.field(ta, !1) ? t : t.concat(An.appendConfig.of(tut));
}
const sJ = /* @__PURE__ */ An.define(), dN = /* @__PURE__ */ An.define(), aJ = /* @__PURE__ */ An.define(), ta = /* @__PURE__ */ wo.define({
  create() {
    return new Ap(tn.none, null, null);
  },
  update(e, t) {
    if (t.docChanged && e.diagnostics.size) {
      let n = e.diagnostics.map(t.changes), r = null, i = e.panel;
      if (e.selected) {
        let o = t.changes.mapPos(e.selected.from, 1);
        r = Pm(n, e.selected.diagnostic, o) || Pm(n, null, o);
      }
      !n.size && i && t.state.facet(db).autoPanel && (i = null), e = new Ap(n, i, r);
    }
    for (let n of t.effects)
      if (n.is(sJ)) {
        let r = t.state.facet(db).autoPanel ? n.value.length ? pb.open : null : e.panel;
        e = Ap.init(n.value, r, t.state);
      } else n.is(dN) ? e = new Ap(e.diagnostics, n.value ? pb.open : null, e.selected) : n.is(aJ) && (e = new Ap(e.diagnostics, e.panel, n.value));
    return e;
  },
  provide: (e) => [
    ob.from(e, (t) => t.panel),
    Rt.decorations.from(e, (t) => t.diagnostics)
  ]
}), Wlt = /* @__PURE__ */ tn.mark({ class: "cm-lintRange cm-lintRange-active" });
function Hlt(e, t, n) {
  let { diagnostics: r } = e.state.field(ta), i, o = -1, s = -1;
  r.between(t - (n < 0 ? 1 : 0), t + (n > 0 ? 1 : 0), (u, c, { spec: d }) => {
    if (t >= u && t <= c && (u == c || (t > u || n > 0) && (t < c || n < 0)))
      return i = d.diagnostics, o = u, s = c, !1;
  });
  let a = e.state.facet(db).tooltipFilter;
  return i && a && (i = a(i, e.state)), i ? {
    pos: o,
    end: s,
    above: e.state.doc.lineAt(o).to < s,
    create() {
      return { dom: qlt(e, i) };
    }
  } : null;
}
function qlt(e, t) {
  return zr("ul", { class: "cm-tooltip-lint" }, t.map((n) => uJ(e, n, !1)));
}
const Glt = (e) => {
  let t = e.state.field(ta, !1);
  (!t || !t.panel) && e.dispatch({ effects: Ult(e.state, [dN.of(!0)]) });
  let n = ib(e, pb.open);
  return n && n.dom.querySelector(".cm-panel-lint ul").focus(), !0;
}, s4 = (e) => {
  let t = e.state.field(ta, !1);
  return !t || !t.panel ? !1 : (e.dispatch({ effects: dN.of(!1) }), !0);
}, Ylt = (e) => {
  let t = e.state.field(ta, !1);
  if (!t)
    return !1;
  let n = e.state.selection.main, r = t.diagnostics.iter(n.to + 1);
  return !r.value && (r = t.diagnostics.iter(0), !r.value || r.from == n.from && r.to == n.to) ? !1 : (e.dispatch({ selection: { anchor: r.from, head: r.to }, scrollIntoView: !0 }), !0);
}, Klt = [
  { key: "Mod-Shift-m", run: Glt, preventDefault: !0 },
  { key: "F8", run: Ylt }
], db = /* @__PURE__ */ zt.define({
  combine(e) {
    return Object.assign({ sources: e.map((t) => t.source).filter((t) => t != null) }, wu(e.map((t) => t.config), {
      delay: 750,
      markerFilter: null,
      tooltipFilter: null,
      needsRefresh: null,
      hideOn: () => null
    }, {
      needsRefresh: (t, n) => t ? n ? (r) => t(r) || n(r) : t : n
    }));
  }
});
function lJ(e) {
  let t = [];
  if (e)
    e: for (let { name: n } of e) {
      for (let r = 0; r < n.length; r++) {
        let i = n[r];
        if (/[a-zA-Z]/.test(i) && !t.some((o) => o.toLowerCase() == i.toLowerCase())) {
          t.push(i);
          continue e;
        }
      }
      t.push("");
    }
  return t;
}
function uJ(e, t, n) {
  var r;
  let i = n ? lJ(t.actions) : [];
  return zr("li", { class: "cm-diagnostic cm-diagnostic-" + t.severity }, zr("span", { class: "cm-diagnosticText" }, t.renderMessage ? t.renderMessage(e) : t.message), (r = t.actions) === null || r === void 0 ? void 0 : r.map((o, s) => {
    let a = !1, u = (h) => {
      if (h.preventDefault(), a)
        return;
      a = !0;
      let m = Pm(e.state.field(ta).diagnostics, t);
      m && o.apply(e, m.from, m.to);
    }, { name: c } = o, d = i[s] ? c.indexOf(i[s]) : -1, f = d < 0 ? c : [
      c.slice(0, d),
      zr("u", c.slice(d, d + 1)),
      c.slice(d + 1)
    ];
    return zr("button", {
      type: "button",
      class: "cm-diagnosticAction",
      onclick: u,
      onmousedown: u,
      "aria-label": ` Action: ${c}${d < 0 ? "" : ` (access key "${i[s]})"`}.`
    }, f);
  }), t.source && zr("div", { class: "cm-diagnosticSource" }, t.source));
}
class Jlt extends xc {
  constructor(t) {
    super(), this.sev = t;
  }
  eq(t) {
    return t.sev == this.sev;
  }
  toDOM() {
    return zr("span", { class: "cm-lintPoint cm-lintPoint-" + this.sev });
  }
}
class a4 {
  constructor(t, n) {
    this.diagnostic = n, this.id = "item_" + Math.floor(Math.random() * 4294967295).toString(16), this.dom = uJ(t, n, !0), this.dom.id = this.id, this.dom.setAttribute("role", "option");
  }
}
class pb {
  constructor(t) {
    this.view = t, this.items = [];
    let n = (i) => {
      if (i.keyCode == 27)
        s4(this.view), this.view.focus();
      else if (i.keyCode == 38 || i.keyCode == 33)
        this.moveSelection((this.selectedIndex - 1 + this.items.length) % this.items.length);
      else if (i.keyCode == 40 || i.keyCode == 34)
        this.moveSelection((this.selectedIndex + 1) % this.items.length);
      else if (i.keyCode == 36)
        this.moveSelection(0);
      else if (i.keyCode == 35)
        this.moveSelection(this.items.length - 1);
      else if (i.keyCode == 13)
        this.view.focus();
      else if (i.keyCode >= 65 && i.keyCode <= 90 && this.selectedIndex >= 0) {
        let { diagnostic: o } = this.items[this.selectedIndex], s = lJ(o.actions);
        for (let a = 0; a < s.length; a++)
          if (s[a].toUpperCase().charCodeAt(0) == i.keyCode) {
            let u = Pm(this.view.state.field(ta).diagnostics, o);
            u && o.actions[a].apply(t, u.from, u.to);
          }
      } else
        return;
      i.preventDefault();
    }, r = (i) => {
      for (let o = 0; o < this.items.length; o++)
        this.items[o].dom.contains(i.target) && this.moveSelection(o);
    };
    this.list = zr("ul", {
      tabIndex: 0,
      role: "listbox",
      "aria-label": this.view.state.phrase("Diagnostics"),
      onkeydown: n,
      onclick: r
    }), this.dom = zr("div", { class: "cm-panel-lint" }, this.list, zr("button", {
      type: "button",
      name: "close",
      "aria-label": this.view.state.phrase("close"),
      onclick: () => s4(this.view)
    }, "×")), this.update();
  }
  get selectedIndex() {
    let t = this.view.state.field(ta).selected;
    if (!t)
      return -1;
    for (let n = 0; n < this.items.length; n++)
      if (this.items[n].diagnostic == t.diagnostic)
        return n;
    return -1;
  }
  update() {
    let { diagnostics: t, selected: n } = this.view.state.field(ta), r = 0, i = !1, o = null, s = /* @__PURE__ */ new Set();
    for (t.between(0, this.view.state.doc.length, (a, u, { spec: c }) => {
      for (let d of c.diagnostics) {
        if (s.has(d))
          continue;
        s.add(d);
        let f = -1, h;
        for (let m = r; m < this.items.length; m++)
          if (this.items[m].diagnostic == d) {
            f = m;
            break;
          }
        f < 0 ? (h = new a4(this.view, d), this.items.splice(r, 0, h), i = !0) : (h = this.items[f], f > r && (this.items.splice(r, f - r), i = !0)), n && h.diagnostic == n.diagnostic ? h.dom.hasAttribute("aria-selected") || (h.dom.setAttribute("aria-selected", "true"), o = h) : h.dom.hasAttribute("aria-selected") && h.dom.removeAttribute("aria-selected"), r++;
      }
    }); r < this.items.length && !(this.items.length == 1 && this.items[0].diagnostic.from < 0); )
      i = !0, this.items.pop();
    this.items.length == 0 && (this.items.push(new a4(this.view, {
      from: -1,
      to: -1,
      severity: "info",
      message: this.view.state.phrase("No diagnostics")
    })), i = !0), o ? (this.list.setAttribute("aria-activedescendant", o.id), this.view.requestMeasure({
      key: this,
      read: () => ({ sel: o.dom.getBoundingClientRect(), panel: this.list.getBoundingClientRect() }),
      write: ({ sel: a, panel: u }) => {
        let c = u.height / this.list.offsetHeight;
        a.top < u.top ? this.list.scrollTop -= (u.top - a.top) / c : a.bottom > u.bottom && (this.list.scrollTop += (a.bottom - u.bottom) / c);
      }
    })) : this.selectedIndex < 0 && this.list.removeAttribute("aria-activedescendant"), i && this.sync();
  }
  sync() {
    let t = this.list.firstChild;
    function n() {
      let r = t;
      t = r.nextSibling, r.remove();
    }
    for (let r of this.items)
      if (r.dom.parentNode == this.list) {
        for (; t != r.dom; )
          n();
        t = r.dom.nextSibling;
      } else
        this.list.insertBefore(r.dom, t);
    for (; t; )
      n();
  }
  moveSelection(t) {
    if (this.selectedIndex < 0)
      return;
    let n = this.view.state.field(ta), r = Pm(n.diagnostics, this.items[t].diagnostic);
    r && this.view.dispatch({
      selection: { anchor: r.from, head: r.to },
      scrollIntoView: !0,
      effects: aJ.of(r)
    });
  }
  static open(t) {
    return new pb(t);
  }
}
function Xlt(e, t = 'viewBox="0 0 40 40"') {
  return `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" ${t}>${encodeURIComponent(e)}</svg>')`;
}
function Tx(e) {
  return Xlt(`<path d="m0 2.5 l2 -1.5 l1 0 l2 1.5 l1 0" stroke="${e}" fill="none" stroke-width=".7"/>`, 'width="6" height="3"');
}
const Qlt = /* @__PURE__ */ Rt.baseTheme({
  ".cm-diagnostic": {
    padding: "3px 6px 3px 8px",
    marginLeft: "-1px",
    display: "block",
    whiteSpace: "pre-wrap"
  },
  ".cm-diagnostic-error": { borderLeft: "5px solid #d11" },
  ".cm-diagnostic-warning": { borderLeft: "5px solid orange" },
  ".cm-diagnostic-info": { borderLeft: "5px solid #999" },
  ".cm-diagnostic-hint": { borderLeft: "5px solid #66d" },
  ".cm-diagnosticAction": {
    font: "inherit",
    border: "none",
    padding: "2px 4px",
    backgroundColor: "#444",
    color: "white",
    borderRadius: "3px",
    marginLeft: "8px",
    cursor: "pointer"
  },
  ".cm-diagnosticSource": {
    fontSize: "70%",
    opacity: 0.7
  },
  ".cm-lintRange": {
    backgroundPosition: "left bottom",
    backgroundRepeat: "repeat-x",
    paddingBottom: "0.7px"
  },
  ".cm-lintRange-error": { backgroundImage: /* @__PURE__ */ Tx("#d11") },
  ".cm-lintRange-warning": { backgroundImage: /* @__PURE__ */ Tx("orange") },
  ".cm-lintRange-info": { backgroundImage: /* @__PURE__ */ Tx("#999") },
  ".cm-lintRange-hint": { backgroundImage: /* @__PURE__ */ Tx("#66d") },
  ".cm-lintRange-active": { backgroundColor: "#ffdd9980" },
  ".cm-tooltip-lint": {
    padding: 0,
    margin: 0
  },
  ".cm-lintPoint": {
    position: "relative",
    "&:after": {
      content: '""',
      position: "absolute",
      bottom: 0,
      left: "-2px",
      borderLeft: "3px solid transparent",
      borderRight: "3px solid transparent",
      borderBottom: "4px solid #d11"
    }
  },
  ".cm-lintPoint-warning": {
    "&:after": { borderBottomColor: "orange" }
  },
  ".cm-lintPoint-info": {
    "&:after": { borderBottomColor: "#999" }
  },
  ".cm-lintPoint-hint": {
    "&:after": { borderBottomColor: "#66d" }
  },
  ".cm-panel.cm-panel-lint": {
    position: "relative",
    "& ul": {
      maxHeight: "100px",
      overflowY: "auto",
      "& [aria-selected]": {
        backgroundColor: "#ddd",
        "& u": { textDecoration: "underline" }
      },
      "&:focus [aria-selected]": {
        background_fallback: "#bdf",
        backgroundColor: "Highlight",
        color_fallback: "white",
        color: "HighlightText"
      },
      "& u": { textDecoration: "none" },
      padding: 0,
      margin: 0
    },
    "& [name=close]": {
      position: "absolute",
      top: "0",
      right: "2px",
      background: "inherit",
      border: "none",
      font: "inherit",
      padding: 0,
      margin: 0
    }
  }
});
function Zlt(e) {
  return e == "error" ? 4 : e == "warning" ? 3 : e == "info" ? 2 : 1;
}
function eut(e) {
  let t = "hint", n = 1;
  for (let r of e) {
    let i = Zlt(r.severity);
    i > n && (n = i, t = r.severity);
  }
  return t;
}
const tut = [
  ta,
  /* @__PURE__ */ Rt.decorations.compute([ta], (e) => {
    let { selected: t, panel: n } = e.field(ta);
    return !t || !n || t.from == t.to ? tn.none : tn.set([
      Wlt.range(t.from, t.to)
    ]);
  }),
  /* @__PURE__ */ Kit(Hlt, { hideOn: zlt }),
  Qlt
];
var l4 = function(t) {
  t === void 0 && (t = {});
  var {
    crosshairCursor: n = !1
  } = t, r = [];
  t.closeBracketsKeymap !== !1 && (r = r.concat($lt)), t.defaultKeymap !== !1 && (r = r.concat(Aat)), t.searchKeymap !== !1 && (r = r.concat(Qat)), t.historyKeymap !== !1 && (r = r.concat(Mst)), t.foldKeymap !== !1 && (r = r.concat(Kot)), t.completionKeymap !== !1 && (r = r.concat(oJ)), t.lintKeymap !== !1 && (r = r.concat(Klt));
  var i = [];
  return t.lineNumbers !== !1 && i.push(sot()), t.highlightActiveLineGutter !== !1 && i.push(uot()), t.highlightSpecialChars !== !1 && i.push(Tit()), t.history !== !1 && i.push(Ast()), t.foldGutter !== !1 && i.push(Zot()), t.drawSelection !== !1 && i.push(fit()), t.dropCursor !== !1 && i.push(bit()), t.allowMultipleSelections !== !1 && i.push(Jn.allowMultipleSelections.of(!0)), t.indentOnInput !== !1 && i.push(Bot()), t.syntaxHighlighting !== !1 && i.push(iK(rst, {
    fallback: !0
  })), t.bracketMatching !== !1 && i.push(cst()), t.closeBrackets !== !1 && i.push(klt()), t.autocompletion !== !1 && i.push(jlt()), t.rectangularSelection !== !1 && i.push(Lit()), n !== !1 && i.push(Vit()), t.highlightActiveLine !== !1 && i.push(Oit()), t.highlightSelectionMatches !== !1 && i.push($at()), t.tabSize && typeof t.tabSize == "number" && i.push(cT.of(" ".repeat(t.tabSize))), i.concat([lT.of(r.flat())]).filter(Boolean);
};
const nut = "#e5c07b", u4 = "#e06c75", rut = "#56b6c2", iut = "#ffffff", fD = "#abb2bf", uO = "#7d8799", out = "#61afef", sut = "#98c379", c4 = "#d19a66", aut = "#c678dd", lut = "#21252b", d4 = "#2c313a", p4 = "#282c34", qw = "#353a42", uut = "#3E4451", f4 = "#528bff", cut = /* @__PURE__ */ Rt.theme({
  "&": {
    color: fD,
    backgroundColor: p4
  },
  ".cm-content": {
    caretColor: f4
  },
  ".cm-cursor, .cm-dropCursor": { borderLeftColor: f4 },
  "&.cm-focused > .cm-scroller > .cm-selectionLayer .cm-selectionBackground, .cm-selectionBackground, .cm-content ::selection": { backgroundColor: uut },
  ".cm-panels": { backgroundColor: lut, color: fD },
  ".cm-panels.cm-panels-top": { borderBottom: "2px solid black" },
  ".cm-panels.cm-panels-bottom": { borderTop: "2px solid black" },
  ".cm-searchMatch": {
    backgroundColor: "#72a1ff59",
    outline: "1px solid #457dff"
  },
  ".cm-searchMatch.cm-searchMatch-selected": {
    backgroundColor: "#6199ff2f"
  },
  ".cm-activeLine": { backgroundColor: "#6699ff0b" },
  ".cm-selectionMatch": { backgroundColor: "#aafe661a" },
  "&.cm-focused .cm-matchingBracket, &.cm-focused .cm-nonmatchingBracket": {
    backgroundColor: "#bad0f847"
  },
  ".cm-gutters": {
    backgroundColor: p4,
    color: uO,
    border: "none"
  },
  ".cm-activeLineGutter": {
    backgroundColor: d4
  },
  ".cm-foldPlaceholder": {
    backgroundColor: "transparent",
    border: "none",
    color: "#ddd"
  },
  ".cm-tooltip": {
    border: "none",
    backgroundColor: qw
  },
  ".cm-tooltip .cm-tooltip-arrow:before": {
    borderTopColor: "transparent",
    borderBottomColor: "transparent"
  },
  ".cm-tooltip .cm-tooltip-arrow:after": {
    borderTopColor: qw,
    borderBottomColor: qw
  },
  ".cm-tooltip-autocomplete": {
    "& > ul > li[aria-selected]": {
      backgroundColor: d4,
      color: fD
    }
  }
}, { dark: !0 }), dut = /* @__PURE__ */ Dv.define([
  {
    tag: Ge.keyword,
    color: aut
  },
  {
    tag: [Ge.name, Ge.deleted, Ge.character, Ge.propertyName, Ge.macroName],
    color: u4
  },
  {
    tag: [/* @__PURE__ */ Ge.function(Ge.variableName), Ge.labelName],
    color: out
  },
  {
    tag: [Ge.color, /* @__PURE__ */ Ge.constant(Ge.name), /* @__PURE__ */ Ge.standard(Ge.name)],
    color: c4
  },
  {
    tag: [/* @__PURE__ */ Ge.definition(Ge.name), Ge.separator],
    color: fD
  },
  {
    tag: [Ge.typeName, Ge.className, Ge.number, Ge.changed, Ge.annotation, Ge.modifier, Ge.self, Ge.namespace],
    color: nut
  },
  {
    tag: [Ge.operator, Ge.operatorKeyword, Ge.url, Ge.escape, Ge.regexp, Ge.link, /* @__PURE__ */ Ge.special(Ge.string)],
    color: rut
  },
  {
    tag: [Ge.meta, Ge.comment],
    color: uO
  },
  {
    tag: Ge.strong,
    fontWeight: "bold"
  },
  {
    tag: Ge.emphasis,
    fontStyle: "italic"
  },
  {
    tag: Ge.strikethrough,
    textDecoration: "line-through"
  },
  {
    tag: Ge.link,
    color: uO,
    textDecoration: "underline"
  },
  {
    tag: Ge.heading,
    fontWeight: "bold",
    color: u4
  },
  {
    tag: [Ge.atom, Ge.bool, /* @__PURE__ */ Ge.special(Ge.variableName)],
    color: c4
  },
  {
    tag: [Ge.processingInstruction, Ge.string, Ge.inserted],
    color: sut
  },
  {
    tag: Ge.invalid,
    color: iut
  }
]), put = [cut, /* @__PURE__ */ iK(dut)];
var fut = Rt.theme({
  "&": {
    backgroundColor: "#fff"
  }
}, {
  dark: !1
}), hut = function(t) {
  t === void 0 && (t = {});
  var {
    indentWithTab: n = !0,
    editable: r = !0,
    readOnly: i = !1,
    theme: o = "light",
    placeholder: s = "",
    basicSetup: a = !0
  } = t, u = [];
  switch (n && u.unshift(lT.of([wat])), a && (typeof a == "boolean" ? u.unshift(l4()) : u.unshift(l4(a))), s && u.unshift(Nit(s)), o) {
    case "light":
      u.push(fut);
      break;
    case "dark":
      u.push(put);
      break;
    case "none":
      break;
    default:
      u.push(o);
      break;
  }
  return r === !1 && u.push(Rt.editable.of(!1)), i && u.push(Jn.readOnly.of(!0)), [...u];
}, mut = (e) => ({
  line: e.state.doc.lineAt(e.state.selection.main.from),
  lineCount: e.state.doc.lines,
  lineBreak: e.state.lineBreak,
  length: e.state.doc.length,
  readOnly: e.state.readOnly,
  tabSize: e.state.tabSize,
  selection: e.state.selection,
  selectionAsSingle: e.state.selection.asSingle().main,
  ranges: e.state.selection.ranges,
  selectionCode: e.state.sliceDoc(e.state.selection.main.from, e.state.selection.main.to),
  selections: e.state.selection.ranges.map((t) => e.state.sliceDoc(t.from, t.to)),
  selectedText: e.state.selection.ranges.some((t) => !t.empty)
}), h4 = Au.define(), gut = [];
function yut(e) {
  var {
    value: t,
    selection: n,
    onChange: r,
    onStatistics: i,
    onCreateEditor: o,
    onUpdate: s,
    extensions: a = gut,
    autoFocus: u,
    theme: c = "light",
    height: d = null,
    minHeight: f = null,
    maxHeight: h = null,
    width: m = null,
    minWidth: v = null,
    maxWidth: x = null,
    placeholder: C = "",
    editable: E = !0,
    readOnly: S = !1,
    indentWithTab: w = !0,
    basicSetup: O = !0,
    root: A,
    initialState: I
  } = e, [$, L] = Et(), [B, H] = Et(), [q, J] = Et(), X = Rt.theme({
    "&": {
      height: d,
      minHeight: f,
      maxHeight: h,
      width: m,
      minWidth: v,
      maxWidth: x
    },
    "& .cm-scroller": {
      height: "100% !important"
    }
  }), j = Rt.updateListener.of((K) => {
    if (K.docChanged && typeof r == "function" && // Fix echoing of the remote changes:
    // If transaction is market as remote we don't have to call `onChange` handler again
    !K.transactions.some((M) => M.annotation(h4))) {
      var ee = K.state.doc, te = ee.toString();
      r(te, K);
    }
    i && i(mut(K));
  }), U = hut({
    theme: c,
    editable: E,
    readOnly: S,
    placeholder: C,
    indentWithTab: w,
    basicSetup: O
  }), G = [j, X, ...U];
  return s && typeof s == "function" && G.push(Rt.updateListener.of(s)), G = G.concat(a), rn(() => {
    if ($ && !q) {
      var K = {
        doc: t,
        selection: n,
        extensions: G
      }, ee = I ? Jn.fromJSON(I.json, K, I.fields) : Jn.create(K);
      if (J(ee), !B) {
        var te = new Rt({
          state: ee,
          parent: $,
          root: A
        });
        H(te), o && o(te, ee);
      }
    }
    return () => {
      B && (J(void 0), H(void 0));
    };
  }, [$, q]), rn(() => L(e.container), [e.container]), rn(() => () => {
    B && (B.destroy(), H(void 0));
  }, [B]), rn(() => {
    u && B && B.focus();
  }, [u, B]), rn(() => {
    B && B.dispatch({
      effects: An.reconfigure.of(G)
    });
  }, [c, a, d, f, h, m, v, x, C, E, S, w, O, r, s]), rn(() => {
    if (t !== void 0) {
      var K = B ? B.state.doc.toString() : "";
      B && t !== K && B.dispatch({
        changes: {
          from: 0,
          to: K.length,
          insert: t || ""
        },
        annotations: [h4.of(!0)]
      });
    }
  }, [t, B]), {
    state: q,
    setState: J,
    view: B,
    setView: H,
    container: $,
    setContainer: L
  };
}
var but = ["className", "value", "selection", "extensions", "onChange", "onStatistics", "onCreateEditor", "onUpdate", "autoFocus", "theme", "height", "minHeight", "maxHeight", "width", "minWidth", "maxWidth", "basicSetup", "placeholder", "indentWithTab", "editable", "readOnly", "root", "initialState"], cJ = /* @__PURE__ */ w6((e, t) => {
  var {
    className: n,
    value: r = "",
    selection: i,
    extensions: o = [],
    onChange: s,
    onStatistics: a,
    onCreateEditor: u,
    onUpdate: c,
    autoFocus: d,
    theme: f = "light",
    height: h,
    minHeight: m,
    maxHeight: v,
    width: x,
    minWidth: C,
    maxWidth: E,
    basicSetup: S,
    placeholder: w,
    indentWithTab: O,
    editable: A,
    readOnly: I,
    root: $,
    initialState: L
  } = e, B = dnt(e, but), H = rs(null), {
    state: q,
    view: J,
    container: X
  } = yut({
    container: H.current,
    root: $,
    value: r,
    autoFocus: d,
    theme: f,
    height: h,
    minHeight: m,
    maxHeight: v,
    width: x,
    minWidth: C,
    maxWidth: E,
    basicSetup: S,
    placeholder: w,
    indentWithTab: O,
    editable: A,
    readOnly: I,
    selection: i,
    onChange: s,
    onStatistics: a,
    onCreateEditor: u,
    onUpdate: c,
    extensions: o,
    initialState: L
  });
  if (ioe(t, () => ({
    editor: H.current,
    state: q,
    view: J
  }), [H, X, q, J]), typeof r != "string")
    throw new Error("value must be typeof string but got " + typeof r);
  var j = typeof f == "string" ? "cm-theme-" + f : "cm-theme";
  return /* @__PURE__ */ P.jsx("div", N({
    ref: H,
    className: "" + j + (n ? " " + n : "")
  }, B));
});
cJ.displayName = "CodeMirror";
class kC {
  /**
  @internal
  */
  constructor(t, n, r, i, o, s, a, u, c, d = 0, f) {
    this.p = t, this.stack = n, this.state = r, this.reducePos = i, this.pos = o, this.score = s, this.buffer = a, this.bufferBase = u, this.curContext = c, this.lookAhead = d, this.parent = f;
  }
  /**
  @internal
  */
  toString() {
    return `[${this.stack.filter((t, n) => n % 3 == 0).concat(this.state)}]@${this.pos}${this.score ? "!" + this.score : ""}`;
  }
  // Start an empty stack
  /**
  @internal
  */
  static start(t, n, r = 0) {
    let i = t.parser.context;
    return new kC(t, [], n, r, r, 0, [], 0, i ? new m4(i, i.start) : null, 0, null);
  }
  /**
  The stack's current [context](#lr.ContextTracker) value, if
  any. Its type will depend on the context tracker's type
  parameter, or it will be `null` if there is no context
  tracker.
  */
  get context() {
    return this.curContext ? this.curContext.context : null;
  }
  // Push a state onto the stack, tracking its start position as well
  // as the buffer base at that point.
  /**
  @internal
  */
  pushState(t, n) {
    this.stack.push(this.state, n, this.bufferBase + this.buffer.length), this.state = t;
  }
  // Apply a reduce action
  /**
  @internal
  */
  reduce(t) {
    var n;
    let r = t >> 19, i = t & 65535, { parser: o } = this.p, s = this.reducePos < this.pos - 25;
    s && this.setLookAhead(this.pos);
    let a = o.dynamicPrecedence(i);
    if (a && (this.score += a), r == 0) {
      this.pushState(o.getGoto(this.state, i, !0), this.reducePos), i < o.minRepeatTerm && this.storeNode(i, this.reducePos, this.reducePos, s ? 8 : 4, !0), this.reduceContext(i, this.reducePos);
      return;
    }
    let u = this.stack.length - (r - 1) * 3 - (t & 262144 ? 6 : 0), c = u ? this.stack[u - 2] : this.p.ranges[0].from, d = this.reducePos - c;
    d >= 2e3 && !(!((n = this.p.parser.nodeSet.types[i]) === null || n === void 0) && n.isAnonymous) && (c == this.p.lastBigReductionStart ? (this.p.bigReductionCount++, this.p.lastBigReductionSize = d) : this.p.lastBigReductionSize < d && (this.p.bigReductionCount = 1, this.p.lastBigReductionStart = c, this.p.lastBigReductionSize = d));
    let f = u ? this.stack[u - 1] : 0, h = this.bufferBase + this.buffer.length - f;
    if (i < o.minRepeatTerm || t & 131072) {
      let m = o.stateFlag(
        this.state,
        1
        /* StateFlag.Skipped */
      ) ? this.pos : this.reducePos;
      this.storeNode(i, c, m, h + 4, !0);
    }
    if (t & 262144)
      this.state = this.stack[u];
    else {
      let m = this.stack[u - 3];
      this.state = o.getGoto(m, i, !0);
    }
    for (; this.stack.length > u; )
      this.stack.pop();
    this.reduceContext(i, c);
  }
  // Shift a value into the buffer
  /**
  @internal
  */
  storeNode(t, n, r, i = 4, o = !1) {
    if (t == 0 && (!this.stack.length || this.stack[this.stack.length - 1] < this.buffer.length + this.bufferBase)) {
      let s = this, a = this.buffer.length;
      if (a == 0 && s.parent && (a = s.bufferBase - s.parent.bufferBase, s = s.parent), a > 0 && s.buffer[a - 4] == 0 && s.buffer[a - 1] > -1) {
        if (n == r)
          return;
        if (s.buffer[a - 2] >= n) {
          s.buffer[a - 2] = r;
          return;
        }
      }
    }
    if (!o || this.pos == r)
      this.buffer.push(t, n, r, i);
    else {
      let s = this.buffer.length;
      if (s > 0 && this.buffer[s - 4] != 0) {
        let a = !1;
        for (let u = s; u > 0 && this.buffer[u - 2] > r; u -= 4)
          if (this.buffer[u - 1] >= 0) {
            a = !0;
            break;
          }
        if (a)
          for (; s > 0 && this.buffer[s - 2] > r; )
            this.buffer[s] = this.buffer[s - 4], this.buffer[s + 1] = this.buffer[s - 3], this.buffer[s + 2] = this.buffer[s - 2], this.buffer[s + 3] = this.buffer[s - 1], s -= 4, i > 4 && (i -= 4);
      }
      this.buffer[s] = t, this.buffer[s + 1] = n, this.buffer[s + 2] = r, this.buffer[s + 3] = i;
    }
  }
  // Apply a shift action
  /**
  @internal
  */
  shift(t, n, r, i) {
    if (t & 131072)
      this.pushState(t & 65535, this.pos);
    else if (t & 262144)
      this.pos = i, this.shiftContext(n, r), n <= this.p.parser.maxNode && this.buffer.push(n, r, i, 4);
    else {
      let o = t, { parser: s } = this.p;
      (i > this.pos || n <= s.maxNode) && (this.pos = i, s.stateFlag(
        o,
        1
        /* StateFlag.Skipped */
      ) || (this.reducePos = i)), this.pushState(o, r), this.shiftContext(n, r), n <= s.maxNode && this.buffer.push(n, r, i, 4);
    }
  }
  // Apply an action
  /**
  @internal
  */
  apply(t, n, r, i) {
    t & 65536 ? this.reduce(t) : this.shift(t, n, r, i);
  }
  // Add a prebuilt (reused) node into the buffer.
  /**
  @internal
  */
  useNode(t, n) {
    let r = this.p.reused.length - 1;
    (r < 0 || this.p.reused[r] != t) && (this.p.reused.push(t), r++);
    let i = this.pos;
    this.reducePos = this.pos = i + t.length, this.pushState(n, i), this.buffer.push(
      r,
      i,
      this.reducePos,
      -1
      /* size == -1 means this is a reused value */
    ), this.curContext && this.updateContext(this.curContext.tracker.reuse(this.curContext.context, t, this, this.p.stream.reset(this.pos - t.length)));
  }
  // Split the stack. Due to the buffer sharing and the fact
  // that `this.stack` tends to stay quite shallow, this isn't very
  // expensive.
  /**
  @internal
  */
  split() {
    let t = this, n = t.buffer.length;
    for (; n > 0 && t.buffer[n - 2] > t.reducePos; )
      n -= 4;
    let r = t.buffer.slice(n), i = t.bufferBase + n;
    for (; t && i == t.bufferBase; )
      t = t.parent;
    return new kC(this.p, this.stack.slice(), this.state, this.reducePos, this.pos, this.score, r, i, this.curContext, this.lookAhead, t);
  }
  // Try to recover from an error by 'deleting' (ignoring) one token.
  /**
  @internal
  */
  recoverByDelete(t, n) {
    let r = t <= this.p.parser.maxNode;
    r && this.storeNode(t, this.pos, n, 4), this.storeNode(0, this.pos, n, r ? 8 : 4), this.pos = this.reducePos = n, this.score -= 190;
  }
  /**
  Check if the given term would be able to be shifted (optionally
  after some reductions) on this stack. This can be useful for
  external tokenizers that want to make sure they only provide a
  given token when it applies.
  */
  canShift(t) {
    for (let n = new vut(this); ; ) {
      let r = this.p.parser.stateSlot(
        n.state,
        4
        /* ParseState.DefaultReduce */
      ) || this.p.parser.hasAction(n.state, t);
      if (r == 0)
        return !1;
      if (!(r & 65536))
        return !0;
      n.reduce(r);
    }
  }
  // Apply up to Recover.MaxNext recovery actions that conceptually
  // inserts some missing token or rule.
  /**
  @internal
  */
  recoverByInsert(t) {
    if (this.stack.length >= 300)
      return [];
    let n = this.p.parser.nextStates(this.state);
    if (n.length > 8 || this.stack.length >= 120) {
      let i = [];
      for (let o = 0, s; o < n.length; o += 2)
        (s = n[o + 1]) != this.state && this.p.parser.hasAction(s, t) && i.push(n[o], s);
      if (this.stack.length < 120)
        for (let o = 0; i.length < 8 && o < n.length; o += 2) {
          let s = n[o + 1];
          i.some((a, u) => u & 1 && a == s) || i.push(n[o], s);
        }
      n = i;
    }
    let r = [];
    for (let i = 0; i < n.length && r.length < 4; i += 2) {
      let o = n[i + 1];
      if (o == this.state)
        continue;
      let s = this.split();
      s.pushState(o, this.pos), s.storeNode(0, s.pos, s.pos, 4, !0), s.shiftContext(n[i], this.pos), s.reducePos = this.pos, s.score -= 200, r.push(s);
    }
    return r;
  }
  // Force a reduce, if possible. Return false if that can't
  // be done.
  /**
  @internal
  */
  forceReduce() {
    let { parser: t } = this.p, n = t.stateSlot(
      this.state,
      5
      /* ParseState.ForcedReduce */
    );
    if (!(n & 65536))
      return !1;
    if (!t.validAction(this.state, n)) {
      let r = n >> 19, i = n & 65535, o = this.stack.length - r * 3;
      if (o < 0 || t.getGoto(this.stack[o], i, !1) < 0) {
        let s = this.findForcedReduction();
        if (s == null)
          return !1;
        n = s;
      }
      this.storeNode(0, this.pos, this.pos, 4, !0), this.score -= 100;
    }
    return this.reducePos = this.pos, this.reduce(n), !0;
  }
  /**
  Try to scan through the automaton to find some kind of reduction
  that can be applied. Used when the regular ForcedReduce field
  isn't a valid action. @internal
  */
  findForcedReduction() {
    let { parser: t } = this.p, n = [], r = (i, o) => {
      if (!n.includes(i))
        return n.push(i), t.allActions(i, (s) => {
          if (!(s & 393216)) if (s & 65536) {
            let a = (s >> 19) - o;
            if (a > 1) {
              let u = s & 65535, c = this.stack.length - a * 3;
              if (c >= 0 && t.getGoto(this.stack[c], u, !1) >= 0)
                return a << 19 | 65536 | u;
            }
          } else {
            let a = r(s, o + 1);
            if (a != null)
              return a;
          }
        });
    };
    return r(this.state, 0);
  }
  /**
  @internal
  */
  forceAll() {
    for (; !this.p.parser.stateFlag(
      this.state,
      2
      /* StateFlag.Accepting */
    ); )
      if (!this.forceReduce()) {
        this.storeNode(0, this.pos, this.pos, 4, !0);
        break;
      }
    return this;
  }
  /**
  Check whether this state has no further actions (assumed to be a direct descendant of the
  top state, since any other states must be able to continue
  somehow). @internal
  */
  get deadEnd() {
    if (this.stack.length != 3)
      return !1;
    let { parser: t } = this.p;
    return t.data[t.stateSlot(
      this.state,
      1
      /* ParseState.Actions */
    )] == 65535 && !t.stateSlot(
      this.state,
      4
      /* ParseState.DefaultReduce */
    );
  }
  /**
  Restart the stack (put it back in its start state). Only safe
  when this.stack.length == 3 (state is directly below the top
  state). @internal
  */
  restart() {
    this.storeNode(0, this.pos, this.pos, 4, !0), this.state = this.stack[0], this.stack.length = 0;
  }
  /**
  @internal
  */
  sameState(t) {
    if (this.state != t.state || this.stack.length != t.stack.length)
      return !1;
    for (let n = 0; n < this.stack.length; n += 3)
      if (this.stack[n] != t.stack[n])
        return !1;
    return !0;
  }
  /**
  Get the parser used by this stack.
  */
  get parser() {
    return this.p.parser;
  }
  /**
  Test whether a given dialect (by numeric ID, as exported from
  the terms file) is enabled.
  */
  dialectEnabled(t) {
    return this.p.parser.dialect.flags[t];
  }
  shiftContext(t, n) {
    this.curContext && this.updateContext(this.curContext.tracker.shift(this.curContext.context, t, this, this.p.stream.reset(n)));
  }
  reduceContext(t, n) {
    this.curContext && this.updateContext(this.curContext.tracker.reduce(this.curContext.context, t, this, this.p.stream.reset(n)));
  }
  /**
  @internal
  */
  emitContext() {
    let t = this.buffer.length - 1;
    (t < 0 || this.buffer[t] != -3) && this.buffer.push(this.curContext.hash, this.pos, this.pos, -3);
  }
  /**
  @internal
  */
  emitLookAhead() {
    let t = this.buffer.length - 1;
    (t < 0 || this.buffer[t] != -4) && this.buffer.push(this.lookAhead, this.pos, this.pos, -4);
  }
  updateContext(t) {
    if (t != this.curContext.context) {
      let n = new m4(this.curContext.tracker, t);
      n.hash != this.curContext.hash && this.emitContext(), this.curContext = n;
    }
  }
  /**
  @internal
  */
  setLookAhead(t) {
    t > this.lookAhead && (this.emitLookAhead(), this.lookAhead = t);
  }
  /**
  @internal
  */
  close() {
    this.curContext && this.curContext.tracker.strict && this.emitContext(), this.lookAhead > 0 && this.emitLookAhead();
  }
}
class m4 {
  constructor(t, n) {
    this.tracker = t, this.context = n, this.hash = t.strict ? t.hash(n) : 0;
  }
}
class vut {
  constructor(t) {
    this.start = t, this.state = t.state, this.stack = t.stack, this.base = this.stack.length;
  }
  reduce(t) {
    let n = t & 65535, r = t >> 19;
    r == 0 ? (this.stack == this.start.stack && (this.stack = this.stack.slice()), this.stack.push(this.state, 0, 0), this.base += 3) : this.base -= (r - 1) * 3;
    let i = this.start.p.parser.getGoto(this.stack[this.base - 3], n, !0);
    this.state = i;
  }
}
class OC {
  constructor(t, n, r) {
    this.stack = t, this.pos = n, this.index = r, this.buffer = t.buffer, this.index == 0 && this.maybeNext();
  }
  static create(t, n = t.bufferBase + t.buffer.length) {
    return new OC(t, n, n - t.bufferBase);
  }
  maybeNext() {
    let t = this.stack.parent;
    t != null && (this.index = this.stack.bufferBase - t.bufferBase, this.stack = t, this.buffer = t.buffer);
  }
  get id() {
    return this.buffer[this.index - 4];
  }
  get start() {
    return this.buffer[this.index - 3];
  }
  get end() {
    return this.buffer[this.index - 2];
  }
  get size() {
    return this.buffer[this.index - 1];
  }
  next() {
    this.index -= 4, this.pos -= 4, this.index == 0 && this.maybeNext();
  }
  fork() {
    return new OC(this.stack, this.pos, this.index);
  }
}
function Sx(e, t = Uint16Array) {
  if (typeof e != "string")
    return e;
  let n = null;
  for (let r = 0, i = 0; r < e.length; ) {
    let o = 0;
    for (; ; ) {
      let s = e.charCodeAt(r++), a = !1;
      if (s == 126) {
        o = 65535;
        break;
      }
      s >= 92 && s--, s >= 34 && s--;
      let u = s - 32;
      if (u >= 46 && (u -= 46, a = !0), o += u, a)
        break;
      o *= 46;
    }
    n ? n[i++] = o : n = new t(o);
  }
  return n;
}
class hD {
  constructor() {
    this.start = -1, this.value = -1, this.end = -1, this.extended = -1, this.lookAhead = 0, this.mask = 0, this.context = 0;
  }
}
const g4 = new hD();
class xut {
  /**
  @internal
  */
  constructor(t, n) {
    this.input = t, this.ranges = n, this.chunk = "", this.chunkOff = 0, this.chunk2 = "", this.chunk2Pos = 0, this.next = -1, this.token = g4, this.rangeIndex = 0, this.pos = this.chunkPos = n[0].from, this.range = n[0], this.end = n[n.length - 1].to, this.readNext();
  }
  /**
  @internal
  */
  resolveOffset(t, n) {
    let r = this.range, i = this.rangeIndex, o = this.pos + t;
    for (; o < r.from; ) {
      if (!i)
        return null;
      let s = this.ranges[--i];
      o -= r.from - s.to, r = s;
    }
    for (; n < 0 ? o > r.to : o >= r.to; ) {
      if (i == this.ranges.length - 1)
        return null;
      let s = this.ranges[++i];
      o += s.from - r.to, r = s;
    }
    return o;
  }
  /**
  @internal
  */
  clipPos(t) {
    if (t >= this.range.from && t < this.range.to)
      return t;
    for (let n of this.ranges)
      if (n.to > t)
        return Math.max(t, n.from);
    return this.end;
  }
  /**
  Look at a code unit near the stream position. `.peek(0)` equals
  `.next`, `.peek(-1)` gives you the previous character, and so
  on.
  
  Note that looking around during tokenizing creates dependencies
  on potentially far-away content, which may reduce the
  effectiveness incremental parsing—when looking forward—or even
  cause invalid reparses when looking backward more than 25 code
  units, since the library does not track lookbehind.
  */
  peek(t) {
    let n = this.chunkOff + t, r, i;
    if (n >= 0 && n < this.chunk.length)
      r = this.pos + t, i = this.chunk.charCodeAt(n);
    else {
      let o = this.resolveOffset(t, 1);
      if (o == null)
        return -1;
      if (r = o, r >= this.chunk2Pos && r < this.chunk2Pos + this.chunk2.length)
        i = this.chunk2.charCodeAt(r - this.chunk2Pos);
      else {
        let s = this.rangeIndex, a = this.range;
        for (; a.to <= r; )
          a = this.ranges[++s];
        this.chunk2 = this.input.chunk(this.chunk2Pos = r), r + this.chunk2.length > a.to && (this.chunk2 = this.chunk2.slice(0, a.to - r)), i = this.chunk2.charCodeAt(0);
      }
    }
    return r >= this.token.lookAhead && (this.token.lookAhead = r + 1), i;
  }
  /**
  Accept a token. By default, the end of the token is set to the
  current stream position, but you can pass an offset (relative to
  the stream position) to change that.
  */
  acceptToken(t, n = 0) {
    let r = n ? this.resolveOffset(n, -1) : this.pos;
    if (r == null || r < this.token.start)
      throw new RangeError("Token end out of bounds");
    this.token.value = t, this.token.end = r;
  }
  /**
  Accept a token ending at a specific given position.
  */
  acceptTokenTo(t, n) {
    this.token.value = t, this.token.end = n;
  }
  getChunk() {
    if (this.pos >= this.chunk2Pos && this.pos < this.chunk2Pos + this.chunk2.length) {
      let { chunk: t, chunkPos: n } = this;
      this.chunk = this.chunk2, this.chunkPos = this.chunk2Pos, this.chunk2 = t, this.chunk2Pos = n, this.chunkOff = this.pos - this.chunkPos;
    } else {
      this.chunk2 = this.chunk, this.chunk2Pos = this.chunkPos;
      let t = this.input.chunk(this.pos), n = this.pos + t.length;
      this.chunk = n > this.range.to ? t.slice(0, this.range.to - this.pos) : t, this.chunkPos = this.pos, this.chunkOff = 0;
    }
  }
  readNext() {
    return this.chunkOff >= this.chunk.length && (this.getChunk(), this.chunkOff == this.chunk.length) ? this.next = -1 : this.next = this.chunk.charCodeAt(this.chunkOff);
  }
  /**
  Move the stream forward N (defaults to 1) code units. Returns
  the new value of [`next`](#lr.InputStream.next).
  */
  advance(t = 1) {
    for (this.chunkOff += t; this.pos + t >= this.range.to; ) {
      if (this.rangeIndex == this.ranges.length - 1)
        return this.setDone();
      t -= this.range.to - this.pos, this.range = this.ranges[++this.rangeIndex], this.pos = this.range.from;
    }
    return this.pos += t, this.pos >= this.token.lookAhead && (this.token.lookAhead = this.pos + 1), this.readNext();
  }
  setDone() {
    return this.pos = this.chunkPos = this.end, this.range = this.ranges[this.rangeIndex = this.ranges.length - 1], this.chunk = "", this.next = -1;
  }
  /**
  @internal
  */
  reset(t, n) {
    if (n ? (this.token = n, n.start = t, n.lookAhead = t + 1, n.value = n.extended = -1) : this.token = g4, this.pos != t) {
      if (this.pos = t, t == this.end)
        return this.setDone(), this;
      for (; t < this.range.from; )
        this.range = this.ranges[--this.rangeIndex];
      for (; t >= this.range.to; )
        this.range = this.ranges[++this.rangeIndex];
      t >= this.chunkPos && t < this.chunkPos + this.chunk.length ? this.chunkOff = t - this.chunkPos : (this.chunk = "", this.chunkOff = 0), this.readNext();
    }
    return this;
  }
  /**
  @internal
  */
  read(t, n) {
    if (t >= this.chunkPos && n <= this.chunkPos + this.chunk.length)
      return this.chunk.slice(t - this.chunkPos, n - this.chunkPos);
    if (t >= this.chunk2Pos && n <= this.chunk2Pos + this.chunk2.length)
      return this.chunk2.slice(t - this.chunk2Pos, n - this.chunk2Pos);
    if (t >= this.range.from && n <= this.range.to)
      return this.input.read(t, n);
    let r = "";
    for (let i of this.ranges) {
      if (i.from >= n)
        break;
      i.to > t && (r += this.input.read(Math.max(i.from, t), Math.min(i.to, n)));
    }
    return r;
  }
}
class im {
  constructor(t, n) {
    this.data = t, this.id = n;
  }
  token(t, n) {
    let { parser: r } = n.p;
    Dut(this.data, t, n, this.id, r.data, r.tokenPrecTable);
  }
}
im.prototype.contextual = im.prototype.fallback = im.prototype.extend = !1;
im.prototype.fallback = im.prototype.extend = !1;
function Dut(e, t, n, r, i, o) {
  let s = 0, a = 1 << r, { dialect: u } = n.p.parser;
  e: for (; a & e[s]; ) {
    let c = e[s + 1];
    for (let m = s + 3; m < c; m += 2)
      if ((e[m + 1] & a) > 0) {
        let v = e[m];
        if (u.allows(v) && (t.token.value == -1 || t.token.value == v || Cut(v, t.token.value, i, o))) {
          t.acceptToken(v);
          break;
        }
      }
    let d = t.next, f = 0, h = e[s + 2];
    if (t.next < 0 && h > f && e[c + h * 3 - 3] == 65535) {
      s = e[c + h * 3 - 1];
      continue e;
    }
    for (; f < h; ) {
      let m = f + h >> 1, v = c + m + (m << 1), x = e[v], C = e[v + 1] || 65536;
      if (d < x)
        h = m;
      else if (d >= C)
        f = m + 1;
      else {
        s = e[v + 2], t.advance();
        continue e;
      }
    }
    break;
  }
}
function y4(e, t, n) {
  for (let r = t, i; (i = e[r]) != 65535; r++)
    if (i == n)
      return r - t;
  return -1;
}
function Cut(e, t, n, r) {
  let i = y4(n, r, t);
  return i < 0 || y4(n, r, e) < i;
}
const Ys = typeof process < "u" && process.env && /\bparse\b/.test(process.env.LOG);
let Gw = null;
function b4(e, t, n) {
  let r = e.cursor(no.IncludeAnonymous);
  for (r.moveTo(t); ; )
    if (!(n < 0 ? r.childBefore(t) : r.childAfter(t)))
      for (; ; ) {
        if ((n < 0 ? r.to < t : r.from > t) && !r.type.isError)
          return n < 0 ? Math.max(0, Math.min(
            r.to - 1,
            t - 25
            /* Lookahead.Margin */
          )) : Math.min(e.length, Math.max(
            r.from + 1,
            t + 25
            /* Lookahead.Margin */
          ));
        if (n < 0 ? r.prevSibling() : r.nextSibling())
          break;
        if (!r.parent())
          return n < 0 ? 0 : e.length;
      }
}
class Eut {
  constructor(t, n) {
    this.fragments = t, this.nodeSet = n, this.i = 0, this.fragment = null, this.safeFrom = -1, this.safeTo = -1, this.trees = [], this.start = [], this.index = [], this.nextFragment();
  }
  nextFragment() {
    let t = this.fragment = this.i == this.fragments.length ? null : this.fragments[this.i++];
    if (t) {
      for (this.safeFrom = t.openStart ? b4(t.tree, t.from + t.offset, 1) - t.offset : t.from, this.safeTo = t.openEnd ? b4(t.tree, t.to + t.offset, -1) - t.offset : t.to; this.trees.length; )
        this.trees.pop(), this.start.pop(), this.index.pop();
      this.trees.push(t.tree), this.start.push(-t.offset), this.index.push(0), this.nextStart = this.safeFrom;
    } else
      this.nextStart = 1e9;
  }
  // `pos` must be >= any previously given `pos` for this cursor
  nodeAt(t) {
    if (t < this.nextStart)
      return null;
    for (; this.fragment && this.safeTo <= t; )
      this.nextFragment();
    if (!this.fragment)
      return null;
    for (; ; ) {
      let n = this.trees.length - 1;
      if (n < 0)
        return this.nextFragment(), null;
      let r = this.trees[n], i = this.index[n];
      if (i == r.children.length) {
        this.trees.pop(), this.start.pop(), this.index.pop();
        continue;
      }
      let o = r.children[i], s = this.start[n] + r.positions[i];
      if (s > t)
        return this.nextStart = s, null;
      if (o instanceof Ni) {
        if (s == t) {
          if (s < this.safeFrom)
            return null;
          let a = s + o.length;
          if (a <= this.safeTo) {
            let u = o.prop(jn.lookAhead);
            if (!u || a + u < this.fragment.to)
              return o;
          }
        }
        this.index[n]++, s + o.length >= Math.max(this.safeFrom, t) && (this.trees.push(o), this.start.push(s), this.index.push(0));
      } else
        this.index[n]++, this.nextStart = s + o.length;
    }
  }
}
class Tut {
  constructor(t, n) {
    this.stream = n, this.tokens = [], this.mainToken = null, this.actions = [], this.tokens = t.tokenizers.map((r) => new hD());
  }
  getActions(t) {
    let n = 0, r = null, { parser: i } = t.p, { tokenizers: o } = i, s = i.stateSlot(
      t.state,
      3
      /* ParseState.TokenizerMask */
    ), a = t.curContext ? t.curContext.hash : 0, u = 0;
    for (let c = 0; c < o.length; c++) {
      if (!(1 << c & s))
        continue;
      let d = o[c], f = this.tokens[c];
      if (!(r && !d.fallback) && ((d.contextual || f.start != t.pos || f.mask != s || f.context != a) && (this.updateCachedToken(f, d, t), f.mask = s, f.context = a), f.lookAhead > f.end + 25 && (u = Math.max(f.lookAhead, u)), f.value != 0)) {
        let h = n;
        if (f.extended > -1 && (n = this.addActions(t, f.extended, f.end, n)), n = this.addActions(t, f.value, f.end, n), !d.extend && (r = f, n > h))
          break;
      }
    }
    for (; this.actions.length > n; )
      this.actions.pop();
    return u && t.setLookAhead(u), !r && t.pos == this.stream.end && (r = new hD(), r.value = t.p.parser.eofTerm, r.start = r.end = t.pos, n = this.addActions(t, r.value, r.end, n)), this.mainToken = r, this.actions;
  }
  getMainToken(t) {
    if (this.mainToken)
      return this.mainToken;
    let n = new hD(), { pos: r, p: i } = t;
    return n.start = r, n.end = Math.min(r + 1, i.stream.end), n.value = r == i.stream.end ? i.parser.eofTerm : 0, n;
  }
  updateCachedToken(t, n, r) {
    let i = this.stream.clipPos(r.pos);
    if (n.token(this.stream.reset(i, t), r), t.value > -1) {
      let { parser: o } = r.p;
      for (let s = 0; s < o.specialized.length; s++)
        if (o.specialized[s] == t.value) {
          let a = o.specializers[s](this.stream.read(t.start, t.end), r);
          if (a >= 0 && r.p.parser.dialect.allows(a >> 1)) {
            a & 1 ? t.extended = a >> 1 : t.value = a >> 1;
            break;
          }
        }
    } else
      t.value = 0, t.end = this.stream.clipPos(i + 1);
  }
  putAction(t, n, r, i) {
    for (let o = 0; o < i; o += 3)
      if (this.actions[o] == t)
        return i;
    return this.actions[i++] = t, this.actions[i++] = n, this.actions[i++] = r, i;
  }
  addActions(t, n, r, i) {
    let { state: o } = t, { parser: s } = t.p, { data: a } = s;
    for (let u = 0; u < 2; u++)
      for (let c = s.stateSlot(
        o,
        u ? 2 : 1
        /* ParseState.Actions */
      ); ; c += 3) {
        if (a[c] == 65535)
          if (a[c + 1] == 1)
            c = Qu(a, c + 2);
          else {
            i == 0 && a[c + 1] == 2 && (i = this.putAction(Qu(a, c + 2), n, r, i));
            break;
          }
        a[c] == n && (i = this.putAction(Qu(a, c + 1), n, r, i));
      }
    return i;
  }
}
class Sut {
  constructor(t, n, r, i) {
    this.parser = t, this.input = n, this.ranges = i, this.recovering = 0, this.nextStackID = 9812, this.minStackPos = 0, this.reused = [], this.stoppedAt = null, this.lastBigReductionStart = -1, this.lastBigReductionSize = 0, this.bigReductionCount = 0, this.stream = new xut(n, i), this.tokens = new Tut(t, this.stream), this.topTerm = t.top[1];
    let { from: o } = i[0];
    this.stacks = [kC.start(this, t.top[0], o)], this.fragments = r.length && this.stream.end - o > t.bufferLength * 4 ? new Eut(r, t.nodeSet) : null;
  }
  get parsedPos() {
    return this.minStackPos;
  }
  // Move the parser forward. This will process all parse stacks at
  // `this.pos` and try to advance them to a further position. If no
  // stack for such a position is found, it'll start error-recovery.
  //
  // When the parse is finished, this will return a syntax tree. When
  // not, it returns `null`.
  advance() {
    let t = this.stacks, n = this.minStackPos, r = this.stacks = [], i, o;
    if (this.bigReductionCount > 300 && t.length == 1) {
      let [s] = t;
      for (; s.forceReduce() && s.stack.length && s.stack[s.stack.length - 2] >= this.lastBigReductionStart; )
        ;
      this.bigReductionCount = this.lastBigReductionSize = 0;
    }
    for (let s = 0; s < t.length; s++) {
      let a = t[s];
      for (; ; ) {
        if (this.tokens.mainToken = null, a.pos > n)
          r.push(a);
        else {
          if (this.advanceStack(a, r, t))
            continue;
          {
            i || (i = [], o = []), i.push(a);
            let u = this.tokens.getMainToken(a);
            o.push(u.value, u.end);
          }
        }
        break;
      }
    }
    if (!r.length) {
      let s = i && wut(i);
      if (s)
        return Ys && console.log("Finish with " + this.stackID(s)), this.stackToTree(s);
      if (this.parser.strict)
        throw Ys && i && console.log("Stuck with token " + (this.tokens.mainToken ? this.parser.getName(this.tokens.mainToken.value) : "none")), new SyntaxError("No parse at " + n);
      this.recovering || (this.recovering = 5);
    }
    if (this.recovering && i) {
      let s = this.stoppedAt != null && i[0].pos > this.stoppedAt ? i[0] : this.runRecovery(i, o, r);
      if (s)
        return Ys && console.log("Force-finish " + this.stackID(s)), this.stackToTree(s.forceAll());
    }
    if (this.recovering) {
      let s = this.recovering == 1 ? 1 : this.recovering * 3;
      if (r.length > s)
        for (r.sort((a, u) => u.score - a.score); r.length > s; )
          r.pop();
      r.some((a) => a.reducePos > n) && this.recovering--;
    } else if (r.length > 1) {
      e: for (let s = 0; s < r.length - 1; s++) {
        let a = r[s];
        for (let u = s + 1; u < r.length; u++) {
          let c = r[u];
          if (a.sameState(c) || a.buffer.length > 500 && c.buffer.length > 500)
            if ((a.score - c.score || a.buffer.length - c.buffer.length) > 0)
              r.splice(u--, 1);
            else {
              r.splice(s--, 1);
              continue e;
            }
        }
      }
      r.length > 12 && r.splice(
        12,
        r.length - 12
        /* Rec.MaxStackCount */
      );
    }
    this.minStackPos = r[0].pos;
    for (let s = 1; s < r.length; s++)
      r[s].pos < this.minStackPos && (this.minStackPos = r[s].pos);
    return null;
  }
  stopAt(t) {
    if (this.stoppedAt != null && this.stoppedAt < t)
      throw new RangeError("Can't move stoppedAt forward");
    this.stoppedAt = t;
  }
  // Returns an updated version of the given stack, or null if the
  // stack can't advance normally. When `split` and `stacks` are
  // given, stacks split off by ambiguous operations will be pushed to
  // `split`, or added to `stacks` if they move `pos` forward.
  advanceStack(t, n, r) {
    let i = t.pos, { parser: o } = this, s = Ys ? this.stackID(t) + " -> " : "";
    if (this.stoppedAt != null && i > this.stoppedAt)
      return t.forceReduce() ? t : null;
    if (this.fragments) {
      let c = t.curContext && t.curContext.tracker.strict, d = c ? t.curContext.hash : 0;
      for (let f = this.fragments.nodeAt(i); f; ) {
        let h = this.parser.nodeSet.types[f.type.id] == f.type ? o.getGoto(t.state, f.type.id) : -1;
        if (h > -1 && f.length && (!c || (f.prop(jn.contextHash) || 0) == d))
          return t.useNode(f, h), Ys && console.log(s + this.stackID(t) + ` (via reuse of ${o.getName(f.type.id)})`), !0;
        if (!(f instanceof Ni) || f.children.length == 0 || f.positions[0] > 0)
          break;
        let m = f.children[0];
        if (m instanceof Ni && f.positions[0] == 0)
          f = m;
        else
          break;
      }
    }
    let a = o.stateSlot(
      t.state,
      4
      /* ParseState.DefaultReduce */
    );
    if (a > 0)
      return t.reduce(a), Ys && console.log(s + this.stackID(t) + ` (via always-reduce ${o.getName(
        a & 65535
        /* Action.ValueMask */
      )})`), !0;
    if (t.stack.length >= 8400)
      for (; t.stack.length > 6e3 && t.forceReduce(); )
        ;
    let u = this.tokens.getActions(t);
    for (let c = 0; c < u.length; ) {
      let d = u[c++], f = u[c++], h = u[c++], m = c == u.length || !r, v = m ? t : t.split(), x = this.tokens.mainToken;
      if (v.apply(d, f, x ? x.start : v.pos, h), Ys && console.log(s + this.stackID(v) + ` (via ${d & 65536 ? `reduce of ${o.getName(
        d & 65535
        /* Action.ValueMask */
      )}` : "shift"} for ${o.getName(f)} @ ${i}${v == t ? "" : ", split"})`), m)
        return !0;
      v.pos > i ? n.push(v) : r.push(v);
    }
    return !1;
  }
  // Advance a given stack forward as far as it will go. Returns the
  // (possibly updated) stack if it got stuck, or null if it moved
  // forward and was given to `pushStackDedup`.
  advanceFully(t, n) {
    let r = t.pos;
    for (; ; ) {
      if (!this.advanceStack(t, null, null))
        return !1;
      if (t.pos > r)
        return v4(t, n), !0;
    }
  }
  runRecovery(t, n, r) {
    let i = null, o = !1;
    for (let s = 0; s < t.length; s++) {
      let a = t[s], u = n[s << 1], c = n[(s << 1) + 1], d = Ys ? this.stackID(a) + " -> " : "";
      if (a.deadEnd && (o || (o = !0, a.restart(), Ys && console.log(d + this.stackID(a) + " (restarted)"), this.advanceFully(a, r))))
        continue;
      let f = a.split(), h = d;
      for (let m = 0; f.forceReduce() && m < 10 && (Ys && console.log(h + this.stackID(f) + " (via force-reduce)"), !this.advanceFully(f, r)); m++)
        Ys && (h = this.stackID(f) + " -> ");
      for (let m of a.recoverByInsert(u))
        Ys && console.log(d + this.stackID(m) + " (via recover-insert)"), this.advanceFully(m, r);
      this.stream.end > a.pos ? (c == a.pos && (c++, u = 0), a.recoverByDelete(u, c), Ys && console.log(d + this.stackID(a) + ` (via recover-delete ${this.parser.getName(u)})`), v4(a, r)) : (!i || i.score < a.score) && (i = a);
    }
    return i;
  }
  // Convert the stack's buffer to a syntax tree.
  stackToTree(t) {
    return t.close(), Ni.build({
      buffer: OC.create(t),
      nodeSet: this.parser.nodeSet,
      topID: this.topTerm,
      maxBufferLength: this.parser.bufferLength,
      reused: this.reused,
      start: this.ranges[0].from,
      length: t.pos - this.ranges[0].from,
      minRepeatType: this.parser.minRepeatTerm
    });
  }
  stackID(t) {
    let n = (Gw || (Gw = /* @__PURE__ */ new WeakMap())).get(t);
    return n || Gw.set(t, n = String.fromCodePoint(this.nextStackID++)), n + t;
  }
}
function v4(e, t) {
  for (let n = 0; n < t.length; n++) {
    let r = t[n];
    if (r.pos == e.pos && r.sameState(e)) {
      t[n].score < e.score && (t[n] = e);
      return;
    }
  }
  t.push(e);
}
class Aut {
  constructor(t, n, r) {
    this.source = t, this.flags = n, this.disabled = r;
  }
  allows(t) {
    return !this.disabled || this.disabled[t] == 0;
  }
}
class IC extends zY {
  /**
  @internal
  */
  constructor(t) {
    if (super(), this.wrappers = [], t.version != 14)
      throw new RangeError(`Parser version (${t.version}) doesn't match runtime version (14)`);
    let n = t.nodeNames.split(" ");
    this.minRepeatTerm = n.length;
    for (let a = 0; a < t.repeatNodeCount; a++)
      n.push("");
    let r = Object.keys(t.topRules).map((a) => t.topRules[a][1]), i = [];
    for (let a = 0; a < n.length; a++)
      i.push([]);
    function o(a, u, c) {
      i[a].push([u, u.deserialize(String(c))]);
    }
    if (t.nodeProps)
      for (let a of t.nodeProps) {
        let u = a[0];
        typeof u == "string" && (u = jn[u]);
        for (let c = 1; c < a.length; ) {
          let d = a[c++];
          if (d >= 0)
            o(d, u, a[c++]);
          else {
            let f = a[c + -d];
            for (let h = -d; h > 0; h--)
              o(a[c++], u, f);
            c++;
          }
        }
      }
    this.nodeSet = new K$(n.map((a, u) => Ns.define({
      name: u >= this.minRepeatTerm ? void 0 : a,
      id: u,
      props: i[u],
      top: r.indexOf(u) > -1,
      error: u == 0,
      skipped: t.skippedNodes && t.skippedNodes.indexOf(u) > -1
    }))), t.propSources && (this.nodeSet = this.nodeSet.extend(...t.propSources)), this.strict = !1, this.bufferLength = LY;
    let s = Sx(t.tokenData);
    this.context = t.context, this.specializerSpecs = t.specialized || [], this.specialized = new Uint16Array(this.specializerSpecs.length);
    for (let a = 0; a < this.specializerSpecs.length; a++)
      this.specialized[a] = this.specializerSpecs[a].term;
    this.specializers = this.specializerSpecs.map(x4), this.states = Sx(t.states, Uint32Array), this.data = Sx(t.stateData), this.goto = Sx(t.goto), this.maxTerm = t.maxTerm, this.tokenizers = t.tokenizers.map((a) => typeof a == "number" ? new im(s, a) : a), this.topRules = t.topRules, this.dialects = t.dialects || {}, this.dynamicPrecedences = t.dynamicPrecedences || null, this.tokenPrecTable = t.tokenPrec, this.termNames = t.termNames || null, this.maxNode = this.nodeSet.types.length - 1, this.dialect = this.parseDialect(), this.top = this.topRules[Object.keys(this.topRules)[0]];
  }
  createParse(t, n, r) {
    let i = new Sut(this, t, n, r);
    for (let o of this.wrappers)
      i = o(i, t, n, r);
    return i;
  }
  /**
  Get a goto table entry @internal
  */
  getGoto(t, n, r = !1) {
    let i = this.goto;
    if (n >= i[0])
      return -1;
    for (let o = i[n + 1]; ; ) {
      let s = i[o++], a = s & 1, u = i[o++];
      if (a && r)
        return u;
      for (let c = o + (s >> 1); o < c; o++)
        if (i[o] == t)
          return u;
      if (a)
        return -1;
    }
  }
  /**
  Check if this state has an action for a given terminal @internal
  */
  hasAction(t, n) {
    let r = this.data;
    for (let i = 0; i < 2; i++)
      for (let o = this.stateSlot(
        t,
        i ? 2 : 1
        /* ParseState.Actions */
      ), s; ; o += 3) {
        if ((s = r[o]) == 65535)
          if (r[o + 1] == 1)
            s = r[o = Qu(r, o + 2)];
          else {
            if (r[o + 1] == 2)
              return Qu(r, o + 2);
            break;
          }
        if (s == n || s == 0)
          return Qu(r, o + 1);
      }
    return 0;
  }
  /**
  @internal
  */
  stateSlot(t, n) {
    return this.states[t * 6 + n];
  }
  /**
  @internal
  */
  stateFlag(t, n) {
    return (this.stateSlot(
      t,
      0
      /* ParseState.Flags */
    ) & n) > 0;
  }
  /**
  @internal
  */
  validAction(t, n) {
    return !!this.allActions(t, (r) => r == n ? !0 : null);
  }
  /**
  @internal
  */
  allActions(t, n) {
    let r = this.stateSlot(
      t,
      4
      /* ParseState.DefaultReduce */
    ), i = r ? n(r) : void 0;
    for (let o = this.stateSlot(
      t,
      1
      /* ParseState.Actions */
    ); i == null; o += 3) {
      if (this.data[o] == 65535)
        if (this.data[o + 1] == 1)
          o = Qu(this.data, o + 2);
        else
          break;
      i = n(Qu(this.data, o + 1));
    }
    return i;
  }
  /**
  Get the states that can follow this one through shift actions or
  goto jumps. @internal
  */
  nextStates(t) {
    let n = [];
    for (let r = this.stateSlot(
      t,
      1
      /* ParseState.Actions */
    ); ; r += 3) {
      if (this.data[r] == 65535)
        if (this.data[r + 1] == 1)
          r = Qu(this.data, r + 2);
        else
          break;
      if (!(this.data[r + 2] & 1)) {
        let i = this.data[r + 1];
        n.some((o, s) => s & 1 && o == i) || n.push(this.data[r], i);
      }
    }
    return n;
  }
  /**
  Configure the parser. Returns a new parser instance that has the
  given settings modified. Settings not provided in `config` are
  kept from the original parser.
  */
  configure(t) {
    let n = Object.assign(Object.create(IC.prototype), this);
    if (t.props && (n.nodeSet = this.nodeSet.extend(...t.props)), t.top) {
      let r = this.topRules[t.top];
      if (!r)
        throw new RangeError(`Invalid top rule name ${t.top}`);
      n.top = r;
    }
    return t.tokenizers && (n.tokenizers = this.tokenizers.map((r) => {
      let i = t.tokenizers.find((o) => o.from == r);
      return i ? i.to : r;
    })), t.specializers && (n.specializers = this.specializers.slice(), n.specializerSpecs = this.specializerSpecs.map((r, i) => {
      let o = t.specializers.find((a) => a.from == r.external);
      if (!o)
        return r;
      let s = Object.assign(Object.assign({}, r), { external: o.to });
      return n.specializers[i] = x4(s), s;
    })), t.contextTracker && (n.context = t.contextTracker), t.dialect && (n.dialect = this.parseDialect(t.dialect)), t.strict != null && (n.strict = t.strict), t.wrap && (n.wrappers = n.wrappers.concat(t.wrap)), t.bufferLength != null && (n.bufferLength = t.bufferLength), n;
  }
  /**
  Tells you whether any [parse wrappers](#lr.ParserConfig.wrap)
  are registered for this parser.
  */
  hasWrappers() {
    return this.wrappers.length > 0;
  }
  /**
  Returns the name associated with a given term. This will only
  work for all terms when the parser was generated with the
  `--names` option. By default, only the names of tagged terms are
  stored.
  */
  getName(t) {
    return this.termNames ? this.termNames[t] : String(t <= this.maxNode && this.nodeSet.types[t].name || t);
  }
  /**
  The eof term id is always allocated directly after the node
  types. @internal
  */
  get eofTerm() {
    return this.maxNode + 1;
  }
  /**
  The type of top node produced by the parser.
  */
  get topNode() {
    return this.nodeSet.types[this.top[1]];
  }
  /**
  @internal
  */
  dynamicPrecedence(t) {
    let n = this.dynamicPrecedences;
    return n == null ? 0 : n[t] || 0;
  }
  /**
  @internal
  */
  parseDialect(t) {
    let n = Object.keys(this.dialects), r = n.map(() => !1);
    if (t)
      for (let o of t.split(" ")) {
        let s = n.indexOf(o);
        s >= 0 && (r[s] = !0);
      }
    let i = null;
    for (let o = 0; o < n.length; o++)
      if (!r[o])
        for (let s = this.dialects[n[o]], a; (a = this.data[s++]) != 65535; )
          (i || (i = new Uint8Array(this.maxTerm + 1)))[a] = 1;
    return new Aut(t, r, i);
  }
  /**
  Used by the output of the parser generator. Not available to
  user code. @hide
  */
  static deserialize(t) {
    return new IC(t);
  }
}
function Qu(e, t) {
  return e[t] | e[t + 1] << 16;
}
function wut(e) {
  let t = null;
  for (let n of e) {
    let r = n.p.stoppedAt;
    (n.pos == n.p.stream.end || r != null && n.pos > r) && n.p.parser.stateFlag(
      n.state,
      2
      /* StateFlag.Accepting */
    ) && (!t || t.score < n.score) && (t = n);
  }
  return t;
}
function x4(e) {
  if (e.external) {
    let t = e.extend ? 1 : 0;
    return (n, r) => e.external(n, r) << 1 | t;
  }
  return e.get;
}
const Put = UY({
  String: Ge.string,
  Number: Ge.number,
  "True False": Ge.bool,
  PropertyName: Ge.propertyName,
  Null: Ge.null,
  ", :": Ge.separator,
  "[ ]": Ge.squareBracket,
  "{ }": Ge.brace
}), kut = IC.deserialize({
  version: 14,
  states: "$bOVQPOOOOQO'#Cb'#CbOnQPO'#CeOvQPO'#ClOOQO'#Cr'#CrQOQPOOOOQO'#Cg'#CgO}QPO'#CfO!SQPO'#CtOOQO,59P,59PO![QPO,59PO!aQPO'#CuOOQO,59W,59WO!iQPO,59WOVQPO,59QOqQPO'#CmO!nQPO,59`OOQO1G.k1G.kOVQPO'#CnO!vQPO,59aOOQO1G.r1G.rOOQO1G.l1G.lOOQO,59X,59XOOQO-E6k-E6kOOQO,59Y,59YOOQO-E6l-E6l",
  stateData: "#O~OeOS~OQSORSOSSOTSOWQO_ROgPO~OVXOgUO~O^[O~PVO[^O~O]_OVhX~OVaO~O]bO^iX~O^dO~O]_OVha~O]bO^ia~O",
  goto: "!kjPPPPPPkPPkqwPPPPk{!RPPP!XP!e!hXSOR^bQWQRf_TVQ_Q`WRg`QcZRicQTOQZRQe^RhbRYQR]R",
  nodeNames: "⚠ JsonText True False Null Number String } { Object Property PropertyName : , ] [ Array",
  maxTerm: 25,
  nodeProps: [
    ["isolate", -2, 6, 11, ""],
    ["openedBy", 7, "{", 14, "["],
    ["closedBy", 8, "}", 15, "]"]
  ],
  propSources: [Put],
  skippedNodes: [0],
  repeatNodeCount: 2,
  tokenData: "(|~RaXY!WYZ!W]^!Wpq!Wrs!]|}$u}!O$z!Q!R%T!R![&c![!]&t!}#O&y#P#Q'O#Y#Z'T#b#c'r#h#i(Z#o#p(r#q#r(w~!]Oe~~!`Wpq!]qr!]rs!xs#O!]#O#P!}#P;'S!];'S;=`$o<%lO!]~!}Og~~#QXrs!]!P!Q!]#O#P!]#U#V!]#Y#Z!]#b#c!]#f#g!]#h#i!]#i#j#m~#pR!Q![#y!c!i#y#T#Z#y~#|R!Q![$V!c!i$V#T#Z$V~$YR!Q![$c!c!i$c#T#Z$c~$fR!Q![!]!c!i!]#T#Z!]~$rP;=`<%l!]~$zO]~~$}Q!Q!R%T!R![&c~%YRT~!O!P%c!g!h%w#X#Y%w~%fP!Q![%i~%nRT~!Q![%i!g!h%w#X#Y%w~%zR{|&T}!O&T!Q![&Z~&WP!Q![&Z~&`PT~!Q![&Z~&hST~!O!P%c!Q![&c!g!h%w#X#Y%w~&yO[~~'OO_~~'TO^~~'WP#T#U'Z~'^P#`#a'a~'dP#g#h'g~'jP#X#Y'm~'rOR~~'uP#i#j'x~'{P#`#a(O~(RP#`#a(U~(ZOS~~(^P#f#g(a~(dP#i#j(g~(jP#X#Y(m~(rOQ~~(wOW~~(|OV~",
  tokenizers: [0],
  topRules: { JsonText: [0, 1] },
  tokenPrec: 0
}), Out = /* @__PURE__ */ mC.define({
  name: "json",
  parser: /* @__PURE__ */ kut.configure({
    props: [
      /* @__PURE__ */ GY.add({
        Object: /* @__PURE__ */ $5({ except: /^\s*\}/ }),
        Array: /* @__PURE__ */ $5({ except: /^\s*\]/ })
      }),
      /* @__PURE__ */ KY.add({
        "Object Array": Vot
      })
    ]
  }),
  languageData: {
    closeBrackets: { brackets: ["[", "{", '"'] },
    indentOnInput: /^\s*[\}\]]$/
  }
});
function Iut() {
  return new kot(Out);
}
var Fut = Object.create, bT = Object.defineProperty, $ut = Object.getOwnPropertyDescriptor, Nut = Object.getOwnPropertyNames, Mut = Object.getPrototypeOf, Rut = Object.prototype.hasOwnProperty, dJ = (e) => {
  throw TypeError(e);
}, _ut = (e, t) => () => (e && (t = e(e = 0)), t), pN = (e, t) => () => (t || e((t = { exports: {} }).exports, t), t.exports), vT = (e, t) => {
  for (var n in t) bT(e, n, { get: t[n], enumerable: !0 });
}, pJ = (e, t, n, r) => {
  if (t && typeof t == "object" || typeof t == "function") for (let i of Nut(t)) !Rut.call(e, i) && i !== n && bT(e, i, { get: () => t[i], enumerable: !(r = $ut(t, i)) || r.enumerable });
  return e;
}, xT = (e, t, n) => (n = e != null ? Fut(Mut(e)) : {}, pJ(bT(n, "default", { value: e, enumerable: !0 }), e)), Lut = (e) => pJ(bT({}, "__esModule", { value: !0 }), e), But = (e, t, n) => t.has(e) || dJ("Cannot " + n), jut = (e, t, n) => t.has(e) ? dJ("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, n), jy = (e, t, n) => (But(e, t, "access private method"), n), fN = pN((e, t) => {
  var n = new Proxy(String, { get: () => n });
  t.exports = n;
}), fJ = {};
vT(fJ, { default: () => mJ, shouldHighlight: () => hJ });
var hJ, mJ, Vut = _ut(() => {
  hJ = () => !1, mJ = String;
}), zut = pN((e, t) => {
  var n = String, r = function() {
    return { isColorSupported: !1, reset: n, bold: n, dim: n, italic: n, underline: n, inverse: n, hidden: n, strikethrough: n, black: n, red: n, green: n, yellow: n, blue: n, magenta: n, cyan: n, white: n, gray: n, bgBlack: n, bgRed: n, bgGreen: n, bgYellow: n, bgBlue: n, bgMagenta: n, bgCyan: n, bgWhite: n };
  };
  t.exports = r(), t.exports.createColors = r;
}), Uut = pN((e) => {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.codeFrameColumns = m, e.default = v;
  var t = (Vut(), Lut(fJ)), n = i(zut(), !0);
  function r(x) {
    if (typeof WeakMap != "function") return null;
    var C = /* @__PURE__ */ new WeakMap(), E = /* @__PURE__ */ new WeakMap();
    return (r = function(S) {
      return S ? E : C;
    })(x);
  }
  function i(x, C) {
    if (x === null || typeof x != "object" && typeof x != "function") return { default: x };
    var E = r(C);
    if (E && E.has(x)) return E.get(x);
    var S = { __proto__: null }, w = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var O in x) if (O !== "default" && {}.hasOwnProperty.call(x, O)) {
      var A = w ? Object.getOwnPropertyDescriptor(x, O) : null;
      A && (A.get || A.set) ? Object.defineProperty(S, O, A) : S[O] = x[O];
    }
    return S.default = x, E && E.set(x, S), S;
  }
  var o = n.default, s = (x, C) => (E) => x(C(E)), a;
  function u(x) {
    return x ? (a != null || (a = (0, n.createColors)(!0)), a) : o;
  }
  var c = !1;
  function d(x) {
    return { gutter: x.gray, marker: s(x.red, x.bold), message: s(x.red, x.bold) };
  }
  var f = /\r\n|[\n\r\u2028\u2029]/;
  function h(x, C, E) {
    let S = Object.assign({ column: 0, line: -1 }, x.start), w = Object.assign({}, S, x.end), { linesAbove: O = 2, linesBelow: A = 3 } = E || {}, I = S.line, $ = S.column, L = w.line, B = w.column, H = Math.max(I - (O + 1), 0), q = Math.min(C.length, L + A);
    I === -1 && (H = 0), L === -1 && (q = C.length);
    let J = L - I, X = {};
    if (J) for (let j = 0; j <= J; j++) {
      let U = j + I;
      if (!$) X[U] = !0;
      else if (j === 0) {
        let G = C[U - 1].length;
        X[U] = [$, G - $ + 1];
      } else if (j === J) X[U] = [0, B];
      else {
        let G = C[U - j].length;
        X[U] = [0, G];
      }
    }
    else $ === B ? $ ? X[I] = [$, 0] : X[I] = !0 : X[I] = [$, B - $];
    return { start: H, end: q, markerLines: X };
  }
  function m(x, C, E = {}) {
    let S = (E.highlightCode || E.forceColor) && (0, t.shouldHighlight)(E), w = u(E.forceColor), O = d(w), A = (X, j) => S ? X(j) : j, I = x.split(f), { start: $, end: L, markerLines: B } = h(C, I, E), H = C.start && typeof C.start.column == "number", q = String(L).length, J = (S ? (0, t.default)(x, E) : x).split(f, L).slice($, L).map((X, j) => {
      let U = $ + 1 + j, G = ` ${` ${U}`.slice(-q)} |`, K = B[U], ee = !B[U + 1];
      if (K) {
        let te = "";
        if (Array.isArray(K)) {
          let M = X.slice(0, Math.max(K[0] - 1, 0)).replace(/[^\t]/g, " "), Z = K[1] || 1;
          te = [`
 `, A(O.gutter, G.replace(/\d/g, " ")), " ", M, A(O.marker, "^").repeat(Z)].join(""), ee && E.message && (te += " " + A(O.message, E.message));
        }
        return [A(O.marker, ">"), A(O.gutter, G), X.length > 0 ? ` ${X}` : "", te].join("");
      } else return ` ${A(O.gutter, G)}${X.length > 0 ? ` ${X}` : ""}`;
    }).join(`
`);
    return E.message && !H && (J = `${" ".repeat(q + 1)}${E.message}
${J}`), S ? w.reset(J) : J;
  }
  function v(x, C, E, S = {}) {
    if (!c) {
      c = !0;
      let w = "Passing lineNumber and colNumber is deprecated to @babel/code-frame. Please use `codeFrameColumns`.";
      {
        let O = new Error(w);
        O.name = "DeprecationWarning", console.warn(new Error(w));
      }
    }
    return E = Math.max(E, 0), m(x, { start: { column: E, line: C } }, S);
  }
}), Wut = {};
vT(Wut, { __debug: () => qpt, check: () => Wpt, doc: () => tX, format: () => wN, formatWithCursor: () => rX, getSupportInfo: () => Hpt, util: () => nX, version: () => xpt });
var Hut = (e, t, n, r) => {
  if (!(e && t == null)) return t.replaceAll ? t.replaceAll(n, r) : n.global ? t.replace(n, r) : t.split(n).join(r);
}, DT = Hut;
function Md() {
}
Md.prototype = { diff: function(e, t) {
  var n, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, i = r.callback;
  typeof r == "function" && (i = r, r = {}), this.options = r;
  var o = this;
  function s(w) {
    return i ? (setTimeout(function() {
      i(void 0, w);
    }, 0), !0) : w;
  }
  e = this.castInput(e), t = this.castInput(t), e = this.removeEmpty(this.tokenize(e)), t = this.removeEmpty(this.tokenize(t));
  var a = t.length, u = e.length, c = 1, d = a + u;
  r.maxEditLength && (d = Math.min(d, r.maxEditLength));
  var f = (n = r.timeout) !== null && n !== void 0 ? n : 1 / 0, h = Date.now() + f, m = [{ oldPos: -1, lastComponent: void 0 }], v = this.extractCommon(m[0], t, e, 0);
  if (m[0].oldPos + 1 >= u && v + 1 >= a) return s([{ value: this.join(t), count: t.length }]);
  var x = -1 / 0, C = 1 / 0;
  function E() {
    for (var w = Math.max(x, -c); w <= Math.min(C, c); w += 2) {
      var O = void 0, A = m[w - 1], I = m[w + 1];
      A && (m[w - 1] = void 0);
      var $ = !1;
      if (I) {
        var L = I.oldPos - w;
        $ = I && 0 <= L && L < a;
      }
      var B = A && A.oldPos + 1 < u;
      if (!$ && !B) {
        m[w] = void 0;
        continue;
      }
      if (!B || $ && A.oldPos + 1 < I.oldPos ? O = o.addToPath(I, !0, void 0, 0) : O = o.addToPath(A, void 0, !0, 1), v = o.extractCommon(O, t, e, w), O.oldPos + 1 >= u && v + 1 >= a) return s(qut(o, O.lastComponent, t, e, o.useLongestToken));
      m[w] = O, O.oldPos + 1 >= u && (C = Math.min(C, w - 1)), v + 1 >= a && (x = Math.max(x, w + 1));
    }
    c++;
  }
  if (i) (function w() {
    setTimeout(function() {
      if (c > d || Date.now() > h) return i();
      E() || w();
    }, 0);
  })();
  else for (; c <= d && Date.now() <= h; ) {
    var S = E();
    if (S) return S;
  }
}, addToPath: function(e, t, n, r) {
  var i = e.lastComponent;
  return i && i.added === t && i.removed === n ? { oldPos: e.oldPos + r, lastComponent: { count: i.count + 1, added: t, removed: n, previousComponent: i.previousComponent } } : { oldPos: e.oldPos + r, lastComponent: { count: 1, added: t, removed: n, previousComponent: i } };
}, extractCommon: function(e, t, n, r) {
  for (var i = t.length, o = n.length, s = e.oldPos, a = s - r, u = 0; a + 1 < i && s + 1 < o && this.equals(t[a + 1], n[s + 1]); ) a++, s++, u++;
  return u && (e.lastComponent = { count: u, previousComponent: e.lastComponent }), e.oldPos = s, a;
}, equals: function(e, t) {
  return this.options.comparator ? this.options.comparator(e, t) : e === t || this.options.ignoreCase && e.toLowerCase() === t.toLowerCase();
}, removeEmpty: function(e) {
  for (var t = [], n = 0; n < e.length; n++) e[n] && t.push(e[n]);
  return t;
}, castInput: function(e) {
  return e;
}, tokenize: function(e) {
  return e.split("");
}, join: function(e) {
  return e.join("");
} };
function qut(e, t, n, r, i) {
  for (var o = [], s; t; ) o.push(t), s = t.previousComponent, delete t.previousComponent, t = s;
  o.reverse();
  for (var a = 0, u = o.length, c = 0, d = 0; a < u; a++) {
    var f = o[a];
    if (f.removed) {
      if (f.value = e.join(r.slice(d, d + f.count)), d += f.count, a && o[a - 1].added) {
        var h = o[a - 1];
        o[a - 1] = o[a], o[a] = h;
      }
    } else {
      if (!f.added && i) {
        var m = n.slice(c, c + f.count);
        m = m.map(function(x, C) {
          var E = r[d + C];
          return E.length > x.length ? E : x;
        }), f.value = e.join(m);
      } else f.value = e.join(n.slice(c, c + f.count));
      c += f.count, f.added || (d += f.count);
    }
  }
  var v = o[u - 1];
  return u > 1 && typeof v.value == "string" && (v.added || v.removed) && e.equals("", v.value) && (o[u - 2].value += v.value, o.pop()), o;
}
var D4 = /^[A-Za-z\xC0-\u02C6\u02C8-\u02D7\u02DE-\u02FF\u1E00-\u1EFF]+$/, C4 = /\S/, gJ = new Md();
gJ.equals = function(e, t) {
  return this.options.ignoreCase && (e = e.toLowerCase(), t = t.toLowerCase()), e === t || this.options.ignoreWhitespace && !C4.test(e) && !C4.test(t);
};
gJ.tokenize = function(e) {
  for (var t = e.split(/([^\S\r\n]+|[()[\]{}'"\r\n]|\b)/), n = 0; n < t.length - 1; n++) !t[n + 1] && t[n + 2] && D4.test(t[n]) && D4.test(t[n + 2]) && (t[n] += t[n + 2], t.splice(n + 1, 2), n--);
  return t;
};
var yJ = new Md();
yJ.tokenize = function(e) {
  this.options.stripTrailingCr && (e = e.replace(/\r\n/g, `
`));
  var t = [], n = e.split(/(\n|\r\n)/);
  n[n.length - 1] || n.pop();
  for (var r = 0; r < n.length; r++) {
    var i = n[r];
    r % 2 && !this.options.newlineIsToken ? t[t.length - 1] += i : (this.options.ignoreWhitespace && (i = i.trim()), t.push(i));
  }
  return t;
};
var Gut = new Md();
Gut.tokenize = function(e) {
  return e.split(/(\S.+?[.!?])(?=\s+|$)/);
};
var Yut = new Md();
Yut.tokenize = function(e) {
  return e.split(/([{}:;,]|\s+)/);
};
function mD(e) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? mD = function(t) {
    return typeof t;
  } : mD = function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, mD(e);
}
var Kut = Object.prototype.toString, fb = new Md();
fb.useLongestToken = !0;
fb.tokenize = yJ.tokenize;
fb.castInput = function(e) {
  var t = this.options, n = t.undefinedReplacement, r = t.stringifyReplacer, i = r === void 0 ? function(o, s) {
    return typeof s > "u" ? n : s;
  } : r;
  return typeof e == "string" ? e : JSON.stringify(cO(e, null, null, i), i, "  ");
};
fb.equals = function(e, t) {
  return Md.prototype.equals.call(fb, e.replace(/,([\r\n])/g, "$1"), t.replace(/,([\r\n])/g, "$1"));
};
function cO(e, t, n, r, i) {
  t = t || [], n = n || [], r && (e = r(i, e));
  var o;
  for (o = 0; o < t.length; o += 1) if (t[o] === e) return n[o];
  var s;
  if (Kut.call(e) === "[object Array]") {
    for (t.push(e), s = new Array(e.length), n.push(s), o = 0; o < e.length; o += 1) s[o] = cO(e[o], t, n, r, i);
    return t.pop(), n.pop(), s;
  }
  if (e && e.toJSON && (e = e.toJSON()), mD(e) === "object" && e !== null) {
    t.push(e), s = {}, n.push(s);
    var a = [], u;
    for (u in e) e.hasOwnProperty(u) && a.push(u);
    for (a.sort(), o = 0; o < a.length; o += 1) u = a[o], s[u] = cO(e[u], t, n, r, u);
    t.pop(), n.pop();
  } else s = e;
  return s;
}
var FC = new Md();
FC.tokenize = function(e) {
  return e.slice();
};
FC.join = FC.removeEmpty = function(e) {
  return e;
};
function Jut(e, t, n) {
  return FC.diff(e, t, n);
}
function Xut(e) {
  let t = e.indexOf("\r");
  return t >= 0 ? e.charAt(t + 1) === `
` ? "crlf" : "cr" : "lf";
}
function hN(e) {
  switch (e) {
    case "cr":
      return "\r";
    case "crlf":
      return `\r
`;
    default:
      return `
`;
  }
}
function bJ(e, t) {
  let n;
  switch (t) {
    case `
`:
      n = /\n/gu;
      break;
    case "\r":
      n = /\r/gu;
      break;
    case `\r
`:
      n = /\r\n/gu;
      break;
    default:
      throw new Error(`Unexpected "eol" ${JSON.stringify(t)}.`);
  }
  let r = e.match(n);
  return r ? r.length : 0;
}
function Qut(e) {
  return DT(!1, e, /\r\n?/gu, `
`);
}
var kf = "string", pc = "array", Of = "cursor", Dc = "indent", Cc = "align", Ec = "trim", Ms = "group", ku = "fill", ia = "if-break", Tc = "indent-if-break", Sc = "line-suffix", Ac = "line-suffix-boundary", Co = "line", Ou = "label", Ha = "break-parent", vJ = /* @__PURE__ */ new Set([Of, Dc, Cc, Ec, Ms, ku, ia, Tc, Sc, Ac, Co, Ou, Ha]);
function Zut(e) {
  if (typeof e == "string") return kf;
  if (Array.isArray(e)) return pc;
  if (!e) return;
  let { type: t } = e;
  if (vJ.has(t)) return t;
}
var If = Zut, ect = (e) => new Intl.ListFormat("en-US", { type: "disjunction" }).format(e);
function tct(e) {
  let t = e === null ? "null" : typeof e;
  if (t !== "string" && t !== "object") return `Unexpected doc '${t}', 
Expected it to be 'string' or 'object'.`;
  if (If(e)) throw new Error("doc is valid.");
  let n = Object.prototype.toString.call(e);
  if (n !== "[object Object]") return `Unexpected doc '${n}'.`;
  let r = ect([...vJ].map((i) => `'${i}'`));
  return `Unexpected doc.type '${e.type}'.
Expected it to be ${r}.`;
}
var nct = class extends Error {
  constructor(t) {
    super(tct(t));
    ap(this, "name", "InvalidDocError");
    this.doc = t;
  }
}, km = nct, E4 = {};
function rct(e, t, n, r) {
  let i = [e];
  for (; i.length > 0; ) {
    let o = i.pop();
    if (o === E4) {
      n(i.pop());
      continue;
    }
    n && i.push(o, E4);
    let s = If(o);
    if (!s) throw new km(o);
    if ((t == null ? void 0 : t(o)) !== !1) switch (s) {
      case pc:
      case ku: {
        let a = s === pc ? o : o.parts;
        for (let u = a.length, c = u - 1; c >= 0; --c) i.push(a[c]);
        break;
      }
      case ia:
        i.push(o.flatContents, o.breakContents);
        break;
      case Ms:
        if (r && o.expandedStates) for (let a = o.expandedStates.length, u = a - 1; u >= 0; --u) i.push(o.expandedStates[u]);
        else i.push(o.contents);
        break;
      case Cc:
      case Dc:
      case Tc:
      case Ou:
      case Sc:
        i.push(o.contents);
        break;
      case kf:
      case Of:
      case Ec:
      case Ac:
      case Co:
      case Ha:
        break;
      default:
        throw new km(o);
    }
  }
}
var mN = rct, ict = () => {
}, oct = ict;
function $C(e) {
  return { type: Dc, contents: e };
}
function Om(e, t) {
  return { type: Cc, contents: t, n: e };
}
function xJ(e, t = {}) {
  return oct(t.expandedStates), { type: Ms, id: t.id, contents: e, break: !!t.shouldBreak, expandedStates: t.expandedStates };
}
function sct(e) {
  return Om(Number.NEGATIVE_INFINITY, e);
}
function act(e) {
  return Om({ type: "root" }, e);
}
function lct(e) {
  return Om(-1, e);
}
function uct(e, t) {
  return xJ(e[0], { ...t, expandedStates: e });
}
function DJ(e) {
  return { type: ku, parts: e };
}
function cct(e, t = "", n = {}) {
  return { type: ia, breakContents: e, flatContents: t, groupId: n.groupId };
}
function dct(e, t) {
  return { type: Tc, contents: e, groupId: t.groupId, negate: t.negate };
}
function dO(e) {
  return { type: Sc, contents: e };
}
var pct = { type: Ac }, CT = { type: Ha }, fct = { type: Ec }, gN = { type: Co, hard: !0 }, CJ = { type: Co, hard: !0, literal: !0 }, EJ = { type: Co }, hct = { type: Co, soft: !0 }, Vp = [gN, CT], TJ = [CJ, CT], pO = { type: Of };
function SJ(e, t) {
  let n = [];
  for (let r = 0; r < t.length; r++) r !== 0 && n.push(e), n.push(t[r]);
  return n;
}
function AJ(e, t, n) {
  let r = e;
  if (t > 0) {
    for (let i = 0; i < Math.floor(t / n); ++i) r = $C(r);
    r = Om(t % n, r), r = Om(Number.NEGATIVE_INFINITY, r);
  }
  return r;
}
function mct(e, t) {
  return e ? { type: Ou, label: e, contents: t } : t;
}
function Xu(e) {
  var t;
  if (!e) return "";
  if (Array.isArray(e)) {
    let n = [];
    for (let r of e) if (Array.isArray(r)) n.push(...Xu(r));
    else {
      let i = Xu(r);
      i !== "" && n.push(i);
    }
    return n;
  }
  return e.type === ia ? { ...e, breakContents: Xu(e.breakContents), flatContents: Xu(e.flatContents) } : e.type === Ms ? { ...e, contents: Xu(e.contents), expandedStates: (t = e.expandedStates) == null ? void 0 : t.map(Xu) } : e.type === ku ? { type: "fill", parts: e.parts.map(Xu) } : e.contents ? { ...e, contents: Xu(e.contents) } : e;
}
function gct(e) {
  let t = /* @__PURE__ */ Object.create(null), n = /* @__PURE__ */ new Set();
  return r(Xu(e));
  function r(o, s, a) {
    var u, c;
    if (typeof o == "string") return JSON.stringify(o);
    if (Array.isArray(o)) {
      let d = o.map(r).filter(Boolean);
      return d.length === 1 ? d[0] : `[${d.join(", ")}]`;
    }
    if (o.type === Co) {
      let d = ((u = a == null ? void 0 : a[s + 1]) == null ? void 0 : u.type) === Ha;
      return o.literal ? d ? "literalline" : "literallineWithoutBreakParent" : o.hard ? d ? "hardline" : "hardlineWithoutBreakParent" : o.soft ? "softline" : "line";
    }
    if (o.type === Ha) return ((c = a == null ? void 0 : a[s - 1]) == null ? void 0 : c.type) === Co && a[s - 1].hard ? void 0 : "breakParent";
    if (o.type === Ec) return "trim";
    if (o.type === Dc) return "indent(" + r(o.contents) + ")";
    if (o.type === Cc) return o.n === Number.NEGATIVE_INFINITY ? "dedentToRoot(" + r(o.contents) + ")" : o.n < 0 ? "dedent(" + r(o.contents) + ")" : o.n.type === "root" ? "markAsRoot(" + r(o.contents) + ")" : "align(" + JSON.stringify(o.n) + ", " + r(o.contents) + ")";
    if (o.type === ia) return "ifBreak(" + r(o.breakContents) + (o.flatContents ? ", " + r(o.flatContents) : "") + (o.groupId ? (o.flatContents ? "" : ', ""') + `, { groupId: ${i(o.groupId)} }` : "") + ")";
    if (o.type === Tc) {
      let d = [];
      o.negate && d.push("negate: true"), o.groupId && d.push(`groupId: ${i(o.groupId)}`);
      let f = d.length > 0 ? `, { ${d.join(", ")} }` : "";
      return `indentIfBreak(${r(o.contents)}${f})`;
    }
    if (o.type === Ms) {
      let d = [];
      o.break && o.break !== "propagated" && d.push("shouldBreak: true"), o.id && d.push(`id: ${i(o.id)}`);
      let f = d.length > 0 ? `, { ${d.join(", ")} }` : "";
      return o.expandedStates ? `conditionalGroup([${o.expandedStates.map((h) => r(h)).join(",")}]${f})` : `group(${r(o.contents)}${f})`;
    }
    if (o.type === ku) return `fill([${o.parts.map((d) => r(d)).join(", ")}])`;
    if (o.type === Sc) return "lineSuffix(" + r(o.contents) + ")";
    if (o.type === Ac) return "lineSuffixBoundary";
    if (o.type === Ou) return `label(${JSON.stringify(o.label)}, ${r(o.contents)})`;
    throw new Error("Unknown doc type " + o.type);
  }
  function i(o) {
    if (typeof o != "symbol") return JSON.stringify(String(o));
    if (o in t) return t[o];
    let s = o.description || "symbol";
    for (let a = 0; ; a++) {
      let u = s + (a > 0 ? ` #${a}` : "");
      if (!n.has(u)) return n.add(u), t[o] = `Symbol.for(${JSON.stringify(u)})`;
    }
  }
}
var yct = (e, t, n) => {
  if (!(e && t == null)) return Array.isArray(t) || typeof t == "string" ? t[n < 0 ? t.length + n : n] : t.at(n);
}, eo = yct, bct = () => /[#*0-9]\uFE0F?\u20E3|[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23ED-\u23EF\u23F1\u23F2\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB\u25FC\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u267F\u2692\u2694-\u2697\u2699\u269B\u269C\u26A0\u26A7\u26AA\u26B0\u26B1\u26BD\u26BE\u26C4\u26C8\u26CF\u26D1\u26E9\u26F0-\u26F5\u26F7\u26F8\u26FA\u2702\u2708\u2709\u270F\u2712\u2714\u2716\u271D\u2721\u2733\u2734\u2744\u2747\u2757\u2763\u27A1\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B55\u3030\u303D\u3297\u3299]\uFE0F?|[\u261D\u270C\u270D](?:\uFE0F|\uD83C[\uDFFB-\uDFFF])?|[\u270A\u270B](?:\uD83C[\uDFFB-\uDFFF])?|[\u23E9-\u23EC\u23F0\u23F3\u25FD\u2693\u26A1\u26AB\u26C5\u26CE\u26D4\u26EA\u26FD\u2705\u2728\u274C\u274E\u2753-\u2755\u2795-\u2797\u27B0\u27BF\u2B50]|\u26D3\uFE0F?(?:\u200D\uD83D\uDCA5)?|\u26F9(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|\u2764\uFE0F?(?:\u200D(?:\uD83D\uDD25|\uD83E\uDE79))?|\uD83C(?:[\uDC04\uDD70\uDD71\uDD7E\uDD7F\uDE02\uDE37\uDF21\uDF24-\uDF2C\uDF36\uDF7D\uDF96\uDF97\uDF99-\uDF9B\uDF9E\uDF9F\uDFCD\uDFCE\uDFD4-\uDFDF\uDFF5\uDFF7]\uFE0F?|[\uDF85\uDFC2\uDFC7](?:\uD83C[\uDFFB-\uDFFF])?|[\uDFC4\uDFCA](?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDFCB\uDFCC](?:\uFE0F|\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDCCF\uDD8E\uDD91-\uDD9A\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF43\uDF45-\uDF4A\uDF4C-\uDF7C\uDF7E-\uDF84\uDF86-\uDF93\uDFA0-\uDFC1\uDFC5\uDFC6\uDFC8\uDFC9\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF8-\uDFFF]|\uDDE6\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF]|\uDDE7\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF]|\uDDE8\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF5\uDDF7\uDDFA-\uDDFF]|\uDDE9\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF]|\uDDEA\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA]|\uDDEB\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7]|\uDDEC\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE]|\uDDED\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA]|\uDDEE\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9]|\uDDEF\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5]|\uDDF0\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF]|\uDDF1\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE]|\uDDF2\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF]|\uDDF3\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF]|\uDDF4\uD83C\uDDF2|\uDDF5\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE]|\uDDF6\uD83C\uDDE6|\uDDF7\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC]|\uDDF8\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF]|\uDDF9\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF]|\uDDFA\uD83C[\uDDE6\uDDEC\uDDF2\uDDF3\uDDF8\uDDFE\uDDFF]|\uDDFB\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA]|\uDDFC\uD83C[\uDDEB\uDDF8]|\uDDFD\uD83C\uDDF0|\uDDFE\uD83C[\uDDEA\uDDF9]|\uDDFF\uD83C[\uDDE6\uDDF2\uDDFC]|\uDF44(?:\u200D\uD83D\uDFEB)?|\uDF4B(?:\u200D\uD83D\uDFE9)?|\uDFC3(?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D(?:[\u2640\u2642]\uFE0F?(?:\u200D\u27A1\uFE0F?)?|\u27A1\uFE0F?))?|\uDFF3\uFE0F?(?:\u200D(?:\u26A7\uFE0F?|\uD83C\uDF08))?|\uDFF4(?:\u200D\u2620\uFE0F?|\uDB40\uDC67\uDB40\uDC62\uDB40(?:\uDC65\uDB40\uDC6E\uDB40\uDC67|\uDC73\uDB40\uDC63\uDB40\uDC74|\uDC77\uDB40\uDC6C\uDB40\uDC73)\uDB40\uDC7F)?)|\uD83D(?:[\uDC3F\uDCFD\uDD49\uDD4A\uDD6F\uDD70\uDD73\uDD76-\uDD79\uDD87\uDD8A-\uDD8D\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA\uDECB\uDECD-\uDECF\uDEE0-\uDEE5\uDEE9\uDEF0\uDEF3]\uFE0F?|[\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC6B-\uDC6D\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDC8F\uDC91\uDCAA\uDD7A\uDD95\uDD96\uDE4C\uDE4F\uDEC0\uDECC](?:\uD83C[\uDFFB-\uDFFF])?|[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4\uDEB5](?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDD74\uDD90](?:\uFE0F|\uD83C[\uDFFB-\uDFFF])?|[\uDC00-\uDC07\uDC09-\uDC14\uDC16-\uDC25\uDC27-\uDC3A\uDC3C-\uDC3E\uDC40\uDC44\uDC45\uDC51-\uDC65\uDC6A\uDC79-\uDC7B\uDC7D-\uDC80\uDC84\uDC88-\uDC8E\uDC90\uDC92-\uDCA9\uDCAB-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDDA4\uDDFB-\uDE2D\uDE2F-\uDE34\uDE37-\uDE41\uDE43\uDE44\uDE48-\uDE4A\uDE80-\uDEA2\uDEA4-\uDEB3\uDEB7-\uDEBF\uDEC1-\uDEC5\uDED0-\uDED2\uDED5-\uDED7\uDEDC-\uDEDF\uDEEB\uDEEC\uDEF4-\uDEFC\uDFE0-\uDFEB\uDFF0]|\uDC08(?:\u200D\u2B1B)?|\uDC15(?:\u200D\uD83E\uDDBA)?|\uDC26(?:\u200D(?:\u2B1B|\uD83D\uDD25))?|\uDC3B(?:\u200D\u2744\uFE0F?)?|\uDC41\uFE0F?(?:\u200D\uD83D\uDDE8\uFE0F?)?|\uDC68(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDC68\uDC69]\u200D\uD83D(?:\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?)|[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?)|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]))|\uD83C(?:\uDFFB(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFC-\uDFFF])))?|\uDFFC(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFB\uDFFD-\uDFFF])))?|\uDFFD(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])))?|\uDFFE(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFB-\uDFFD\uDFFF])))?|\uDFFF(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFB-\uDFFE])))?))?|\uDC69(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?[\uDC68\uDC69]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?|\uDC69\u200D\uD83D(?:\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?))|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]))|\uD83C(?:\uDFFB(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFC-\uDFFF])))?|\uDFFC(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB\uDFFD-\uDFFF])))?|\uDFFD(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])))?|\uDFFE(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB-\uDFFD\uDFFF])))?|\uDFFF(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB-\uDFFE])))?))?|\uDC6F(?:\u200D[\u2640\u2642]\uFE0F?)?|\uDD75(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|\uDE2E(?:\u200D\uD83D\uDCA8)?|\uDE35(?:\u200D\uD83D\uDCAB)?|\uDE36(?:\u200D\uD83C\uDF2B\uFE0F?)?|\uDE42(?:\u200D[\u2194\u2195]\uFE0F?)?|\uDEB6(?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D(?:[\u2640\u2642]\uFE0F?(?:\u200D\u27A1\uFE0F?)?|\u27A1\uFE0F?))?)|\uD83E(?:[\uDD0C\uDD0F\uDD18-\uDD1F\uDD30-\uDD34\uDD36\uDD77\uDDB5\uDDB6\uDDBB\uDDD2\uDDD3\uDDD5\uDEC3-\uDEC5\uDEF0\uDEF2-\uDEF8](?:\uD83C[\uDFFB-\uDFFF])?|[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD\uDDCF\uDDD4\uDDD6-\uDDDD](?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDDDE\uDDDF](?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDD0D\uDD0E\uDD10-\uDD17\uDD20-\uDD25\uDD27-\uDD2F\uDD3A\uDD3F-\uDD45\uDD47-\uDD76\uDD78-\uDDB4\uDDB7\uDDBA\uDDBC-\uDDCC\uDDD0\uDDE0-\uDDFF\uDE70-\uDE7C\uDE80-\uDE88\uDE90-\uDEBD\uDEBF-\uDEC2\uDECE-\uDEDB\uDEE0-\uDEE8]|\uDD3C(?:\u200D[\u2640\u2642]\uFE0F?|\uD83C[\uDFFB-\uDFFF])?|\uDDCE(?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D(?:[\u2640\u2642]\uFE0F?(?:\u200D\u27A1\uFE0F?)?|\u27A1\uFE0F?))?|\uDDD1(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83E\uDDD1|\uDDD1\u200D\uD83E\uDDD2(?:\u200D\uD83E\uDDD2)?|\uDDD2(?:\u200D\uD83E\uDDD2)?))|\uD83C(?:\uDFFB(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFC-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?|\uDFFC(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB\uDFFD-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?|\uDFFD(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?|\uDFFE(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB-\uDFFD\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?|\uDFFF(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB-\uDFFE]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?))?|\uDEF1(?:\uD83C(?:\uDFFB(?:\u200D\uD83E\uDEF2\uD83C[\uDFFC-\uDFFF])?|\uDFFC(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB\uDFFD-\uDFFF])?|\uDFFD(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])?|\uDFFE(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB-\uDFFD\uDFFF])?|\uDFFF(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB-\uDFFE])?))?)/g;
function vct(e) {
  return e === 12288 || e >= 65281 && e <= 65376 || e >= 65504 && e <= 65510;
}
function xct(e) {
  return e >= 4352 && e <= 4447 || e === 8986 || e === 8987 || e === 9001 || e === 9002 || e >= 9193 && e <= 9196 || e === 9200 || e === 9203 || e === 9725 || e === 9726 || e === 9748 || e === 9749 || e >= 9800 && e <= 9811 || e === 9855 || e === 9875 || e === 9889 || e === 9898 || e === 9899 || e === 9917 || e === 9918 || e === 9924 || e === 9925 || e === 9934 || e === 9940 || e === 9962 || e === 9970 || e === 9971 || e === 9973 || e === 9978 || e === 9981 || e === 9989 || e === 9994 || e === 9995 || e === 10024 || e === 10060 || e === 10062 || e >= 10067 && e <= 10069 || e === 10071 || e >= 10133 && e <= 10135 || e === 10160 || e === 10175 || e === 11035 || e === 11036 || e === 11088 || e === 11093 || e >= 11904 && e <= 11929 || e >= 11931 && e <= 12019 || e >= 12032 && e <= 12245 || e >= 12272 && e <= 12287 || e >= 12289 && e <= 12350 || e >= 12353 && e <= 12438 || e >= 12441 && e <= 12543 || e >= 12549 && e <= 12591 || e >= 12593 && e <= 12686 || e >= 12688 && e <= 12771 || e >= 12783 && e <= 12830 || e >= 12832 && e <= 12871 || e >= 12880 && e <= 19903 || e >= 19968 && e <= 42124 || e >= 42128 && e <= 42182 || e >= 43360 && e <= 43388 || e >= 44032 && e <= 55203 || e >= 63744 && e <= 64255 || e >= 65040 && e <= 65049 || e >= 65072 && e <= 65106 || e >= 65108 && e <= 65126 || e >= 65128 && e <= 65131 || e >= 94176 && e <= 94180 || e === 94192 || e === 94193 || e >= 94208 && e <= 100343 || e >= 100352 && e <= 101589 || e >= 101632 && e <= 101640 || e >= 110576 && e <= 110579 || e >= 110581 && e <= 110587 || e === 110589 || e === 110590 || e >= 110592 && e <= 110882 || e === 110898 || e >= 110928 && e <= 110930 || e === 110933 || e >= 110948 && e <= 110951 || e >= 110960 && e <= 111355 || e === 126980 || e === 127183 || e === 127374 || e >= 127377 && e <= 127386 || e >= 127488 && e <= 127490 || e >= 127504 && e <= 127547 || e >= 127552 && e <= 127560 || e === 127568 || e === 127569 || e >= 127584 && e <= 127589 || e >= 127744 && e <= 127776 || e >= 127789 && e <= 127797 || e >= 127799 && e <= 127868 || e >= 127870 && e <= 127891 || e >= 127904 && e <= 127946 || e >= 127951 && e <= 127955 || e >= 127968 && e <= 127984 || e === 127988 || e >= 127992 && e <= 128062 || e === 128064 || e >= 128066 && e <= 128252 || e >= 128255 && e <= 128317 || e >= 128331 && e <= 128334 || e >= 128336 && e <= 128359 || e === 128378 || e === 128405 || e === 128406 || e === 128420 || e >= 128507 && e <= 128591 || e >= 128640 && e <= 128709 || e === 128716 || e >= 128720 && e <= 128722 || e >= 128725 && e <= 128727 || e >= 128732 && e <= 128735 || e === 128747 || e === 128748 || e >= 128756 && e <= 128764 || e >= 128992 && e <= 129003 || e === 129008 || e >= 129292 && e <= 129338 || e >= 129340 && e <= 129349 || e >= 129351 && e <= 129535 || e >= 129648 && e <= 129660 || e >= 129664 && e <= 129672 || e >= 129680 && e <= 129725 || e >= 129727 && e <= 129733 || e >= 129742 && e <= 129755 || e >= 129760 && e <= 129768 || e >= 129776 && e <= 129784 || e >= 131072 && e <= 196605 || e >= 196608 && e <= 262141;
}
var Dct = (e) => !(vct(e) || xct(e)), Cct = /[^\x20-\x7F]/u;
function Ect(e) {
  if (!e) return 0;
  if (!Cct.test(e)) return e.length;
  e = e.replace(bct(), "  ");
  let t = 0;
  for (let n of e) {
    let r = n.codePointAt(0);
    r <= 31 || r >= 127 && r <= 159 || r >= 768 && r <= 879 || (t += Dct(r) ? 1 : 2);
  }
  return t;
}
var yN = Ect;
function ET(e, t) {
  if (typeof e == "string") return t(e);
  let n = /* @__PURE__ */ new Map();
  return r(e);
  function r(o) {
    if (n.has(o)) return n.get(o);
    let s = i(o);
    return n.set(o, s), s;
  }
  function i(o) {
    switch (If(o)) {
      case pc:
        return t(o.map(r));
      case ku:
        return t({ ...o, parts: o.parts.map(r) });
      case ia:
        return t({ ...o, breakContents: r(o.breakContents), flatContents: r(o.flatContents) });
      case Ms: {
        let { expandedStates: s, contents: a } = o;
        return s ? (s = s.map(r), a = s[0]) : a = r(a), t({ ...o, contents: a, expandedStates: s });
      }
      case Cc:
      case Dc:
      case Tc:
      case Ou:
      case Sc:
        return t({ ...o, contents: r(o.contents) });
      case kf:
      case Of:
      case Ec:
      case Ac:
      case Co:
      case Ha:
        return t(o);
      default:
        throw new km(o);
    }
  }
}
function bN(e, t, n) {
  let r = n, i = !1;
  function o(s) {
    if (i) return !1;
    let a = t(s);
    a !== void 0 && (i = !0, r = a);
  }
  return mN(e, o), r;
}
function Tct(e) {
  if (e.type === Ms && e.break || e.type === Co && e.hard || e.type === Ha) return !0;
}
function Sct(e) {
  return bN(e, Tct, !1);
}
function T4(e) {
  if (e.length > 0) {
    let t = eo(!1, e, -1);
    !t.expandedStates && !t.break && (t.break = "propagated");
  }
  return null;
}
function Act(e) {
  let t = /* @__PURE__ */ new Set(), n = [];
  function r(o) {
    if (o.type === Ha && T4(n), o.type === Ms) {
      if (n.push(o), t.has(o)) return !1;
      t.add(o);
    }
  }
  function i(o) {
    o.type === Ms && n.pop().break && T4(n);
  }
  mN(e, r, i, !0);
}
function wct(e) {
  return e.type === Co && !e.hard ? e.soft ? "" : " " : e.type === ia ? e.flatContents : e;
}
function Pct(e) {
  return ET(e, wct);
}
function S4(e) {
  for (e = [...e]; e.length >= 2 && eo(!1, e, -2).type === Co && eo(!1, e, -1).type === Ha; ) e.length -= 2;
  if (e.length > 0) {
    let t = C0(eo(!1, e, -1));
    e[e.length - 1] = t;
  }
  return e;
}
function C0(e) {
  switch (If(e)) {
    case Dc:
    case Tc:
    case Ms:
    case Sc:
    case Ou: {
      let t = C0(e.contents);
      return { ...e, contents: t };
    }
    case ia:
      return { ...e, breakContents: C0(e.breakContents), flatContents: C0(e.flatContents) };
    case ku:
      return { ...e, parts: S4(e.parts) };
    case pc:
      return S4(e);
    case kf:
      return e.replace(/[\n\r]*$/u, "");
    case Cc:
    case Of:
    case Ec:
    case Ac:
    case Co:
    case Ha:
      break;
    default:
      throw new km(e);
  }
  return e;
}
function wJ(e) {
  return C0(Oct(e));
}
function kct(e) {
  switch (If(e)) {
    case ku:
      if (e.parts.every((t) => t === "")) return "";
      break;
    case Ms:
      if (!e.contents && !e.id && !e.break && !e.expandedStates) return "";
      if (e.contents.type === Ms && e.contents.id === e.id && e.contents.break === e.break && e.contents.expandedStates === e.expandedStates) return e.contents;
      break;
    case Cc:
    case Dc:
    case Tc:
    case Sc:
      if (!e.contents) return "";
      break;
    case ia:
      if (!e.flatContents && !e.breakContents) return "";
      break;
    case pc: {
      let t = [];
      for (let n of e) {
        if (!n) continue;
        let [r, ...i] = Array.isArray(n) ? n : [n];
        typeof r == "string" && typeof eo(!1, t, -1) == "string" ? t[t.length - 1] += r : t.push(r), t.push(...i);
      }
      return t.length === 0 ? "" : t.length === 1 ? t[0] : t;
    }
    case kf:
    case Of:
    case Ec:
    case Ac:
    case Co:
    case Ou:
    case Ha:
      break;
    default:
      throw new km(e);
  }
  return e;
}
function Oct(e) {
  return ET(e, (t) => kct(t));
}
function Ict(e, t = TJ) {
  return ET(e, (n) => typeof n == "string" ? SJ(t, n.split(`
`)) : n);
}
function Fct(e) {
  if (e.type === Co) return !0;
}
function $ct(e) {
  return bN(e, Fct, !1);
}
function PJ(e, t) {
  return e.type === Ou ? { ...e, contents: t(e.contents) } : t(e);
}
var bs = Symbol("MODE_BREAK"), zl = Symbol("MODE_FLAT"), E0 = Symbol("cursor");
function kJ() {
  return { value: "", length: 0, queue: [] };
}
function Nct(e, t) {
  return fO(e, { type: "indent" }, t);
}
function Mct(e, t, n) {
  return t === Number.NEGATIVE_INFINITY ? e.root || kJ() : t < 0 ? fO(e, { type: "dedent" }, n) : t ? t.type === "root" ? { ...e, root: e } : fO(e, { type: typeof t == "string" ? "stringAlign" : "numberAlign", n: t }, n) : e;
}
function fO(e, t, n) {
  let r = t.type === "dedent" ? e.queue.slice(0, -1) : [...e.queue, t], i = "", o = 0, s = 0, a = 0;
  for (let v of r) switch (v.type) {
    case "indent":
      d(), n.useTabs ? u(1) : c(n.tabWidth);
      break;
    case "stringAlign":
      d(), i += v.n, o += v.n.length;
      break;
    case "numberAlign":
      s += 1, a += v.n;
      break;
    default:
      throw new Error(`Unexpected type '${v.type}'`);
  }
  return h(), { ...e, value: i, length: o, queue: r };
  function u(v) {
    i += "	".repeat(v), o += n.tabWidth * v;
  }
  function c(v) {
    i += " ".repeat(v), o += v;
  }
  function d() {
    n.useTabs ? f() : h();
  }
  function f() {
    s > 0 && u(s), m();
  }
  function h() {
    a > 0 && c(a), m();
  }
  function m() {
    s = 0, a = 0;
  }
}
function hO(e) {
  let t = 0, n = 0, r = e.length;
  e: for (; r--; ) {
    let i = e[r];
    if (i === E0) {
      n++;
      continue;
    }
    for (let o = i.length - 1; o >= 0; o--) {
      let s = i[o];
      if (s === " " || s === "	") t++;
      else {
        e[r] = i.slice(0, o + 1);
        break e;
      }
    }
  }
  if (t > 0 || n > 0) for (e.length = r + 1; n-- > 0; ) e.push(E0);
  return t;
}
function Ax(e, t, n, r, i, o) {
  if (n === Number.POSITIVE_INFINITY) return !0;
  let s = t.length, a = [e], u = [];
  for (; n >= 0; ) {
    if (a.length === 0) {
      if (s === 0) return !0;
      a.push(t[--s]);
      continue;
    }
    let { mode: c, doc: d } = a.pop(), f = If(d);
    switch (f) {
      case kf:
        u.push(d), n -= yN(d);
        break;
      case pc:
      case ku: {
        let h = f === pc ? d : d.parts;
        for (let m = h.length - 1; m >= 0; m--) a.push({ mode: c, doc: h[m] });
        break;
      }
      case Dc:
      case Cc:
      case Tc:
      case Ou:
        a.push({ mode: c, doc: d.contents });
        break;
      case Ec:
        n += hO(u);
        break;
      case Ms: {
        if (o && d.break) return !1;
        let h = d.break ? bs : c, m = d.expandedStates && h === bs ? eo(!1, d.expandedStates, -1) : d.contents;
        a.push({ mode: h, doc: m });
        break;
      }
      case ia: {
        let h = (d.groupId ? i[d.groupId] || zl : c) === bs ? d.breakContents : d.flatContents;
        h && a.push({ mode: c, doc: h });
        break;
      }
      case Co:
        if (c === bs || d.hard) return !0;
        d.soft || (u.push(" "), n--);
        break;
      case Sc:
        r = !0;
        break;
      case Ac:
        if (r) return !1;
        break;
    }
  }
  return !1;
}
function TT(e, t) {
  let n = {}, r = t.printWidth, i = hN(t.endOfLine), o = 0, s = [{ ind: kJ(), mode: bs, doc: e }], a = [], u = !1, c = [], d = 0;
  for (Act(e); s.length > 0; ) {
    let { ind: h, mode: m, doc: v } = s.pop();
    switch (If(v)) {
      case kf: {
        let x = i !== `
` ? DT(!1, v, `
`, i) : v;
        a.push(x), s.length > 0 && (o += yN(x));
        break;
      }
      case pc:
        for (let x = v.length - 1; x >= 0; x--) s.push({ ind: h, mode: m, doc: v[x] });
        break;
      case Of:
        if (d >= 2) throw new Error("There are too many 'cursor' in doc.");
        a.push(E0), d++;
        break;
      case Dc:
        s.push({ ind: Nct(h, t), mode: m, doc: v.contents });
        break;
      case Cc:
        s.push({ ind: Mct(h, v.n, t), mode: m, doc: v.contents });
        break;
      case Ec:
        o -= hO(a);
        break;
      case Ms:
        switch (m) {
          case zl:
            if (!u) {
              s.push({ ind: h, mode: v.break ? bs : zl, doc: v.contents });
              break;
            }
          case bs: {
            u = !1;
            let x = { ind: h, mode: zl, doc: v.contents }, C = r - o, E = c.length > 0;
            if (!v.break && Ax(x, s, C, E, n)) s.push(x);
            else if (v.expandedStates) {
              let S = eo(!1, v.expandedStates, -1);
              if (v.break) {
                s.push({ ind: h, mode: bs, doc: S });
                break;
              } else for (let w = 1; w < v.expandedStates.length + 1; w++) if (w >= v.expandedStates.length) {
                s.push({ ind: h, mode: bs, doc: S });
                break;
              } else {
                let O = v.expandedStates[w], A = { ind: h, mode: zl, doc: O };
                if (Ax(A, s, C, E, n)) {
                  s.push(A);
                  break;
                }
              }
            } else s.push({ ind: h, mode: bs, doc: v.contents });
            break;
          }
        }
        v.id && (n[v.id] = eo(!1, s, -1).mode);
        break;
      case ku: {
        let x = r - o, { parts: C } = v;
        if (C.length === 0) break;
        let [E, S] = C, w = { ind: h, mode: zl, doc: E }, O = { ind: h, mode: bs, doc: E }, A = Ax(w, [], x, c.length > 0, n, !0);
        if (C.length === 1) {
          A ? s.push(w) : s.push(O);
          break;
        }
        let I = { ind: h, mode: zl, doc: S }, $ = { ind: h, mode: bs, doc: S };
        if (C.length === 2) {
          A ? s.push(I, w) : s.push($, O);
          break;
        }
        C.splice(0, 2);
        let L = { ind: h, mode: m, doc: DJ(C) }, B = C[0];
        Ax({ ind: h, mode: zl, doc: [E, S, B] }, [], x, c.length > 0, n, !0) ? s.push(L, I, w) : A ? s.push(L, $, w) : s.push(L, $, O);
        break;
      }
      case ia:
      case Tc: {
        let x = v.groupId ? n[v.groupId] : m;
        if (x === bs) {
          let C = v.type === ia ? v.breakContents : v.negate ? v.contents : $C(v.contents);
          C && s.push({ ind: h, mode: m, doc: C });
        }
        if (x === zl) {
          let C = v.type === ia ? v.flatContents : v.negate ? $C(v.contents) : v.contents;
          C && s.push({ ind: h, mode: m, doc: C });
        }
        break;
      }
      case Sc:
        c.push({ ind: h, mode: m, doc: v.contents });
        break;
      case Ac:
        c.length > 0 && s.push({ ind: h, mode: m, doc: gN });
        break;
      case Co:
        switch (m) {
          case zl:
            if (v.hard) u = !0;
            else {
              v.soft || (a.push(" "), o += 1);
              break;
            }
          case bs:
            if (c.length > 0) {
              s.push({ ind: h, mode: m, doc: v }, ...c.reverse()), c.length = 0;
              break;
            }
            v.literal ? h.root ? (a.push(i, h.root.value), o = h.root.length) : (a.push(i), o = 0) : (o -= hO(a), a.push(i + h.value), o = h.length);
            break;
        }
        break;
      case Ou:
        s.push({ ind: h, mode: m, doc: v.contents });
        break;
      case Ha:
        break;
      default:
        throw new km(v);
    }
    s.length === 0 && c.length > 0 && (s.push(...c.reverse()), c.length = 0);
  }
  let f = a.indexOf(E0);
  if (f !== -1) {
    let h = a.indexOf(E0, f + 1), m = a.slice(0, f).join(""), v = a.slice(f + 1, h).join(""), x = a.slice(h + 1).join("");
    return { formatted: m + v + x, cursorNodeStart: m.length, cursorNodeText: v };
  }
  return { formatted: a.join("") };
}
function Rct(e, t, n = 0) {
  let r = 0;
  for (let i = n; i < e.length; ++i) e[i] === "	" ? r = r + t - r % t : r++;
  return r;
}
var vN = Rct, yp, mO, gD, _ct = class {
  constructor(t) {
    jut(this, yp), this.stack = [t];
  }
  get key() {
    let { stack: t, siblings: n } = this;
    return eo(!1, t, n === null ? -2 : -4) ?? null;
  }
  get index() {
    return this.siblings === null ? null : eo(!1, this.stack, -2);
  }
  get node() {
    return eo(!1, this.stack, -1);
  }
  get parent() {
    return this.getNode(1);
  }
  get grandparent() {
    return this.getNode(2);
  }
  get isInArray() {
    return this.siblings !== null;
  }
  get siblings() {
    let { stack: t } = this, n = eo(!1, t, -3);
    return Array.isArray(n) ? n : null;
  }
  get next() {
    let { siblings: t } = this;
    return t === null ? null : t[this.index + 1];
  }
  get previous() {
    let { siblings: t } = this;
    return t === null ? null : t[this.index - 1];
  }
  get isFirst() {
    return this.index === 0;
  }
  get isLast() {
    let { siblings: t, index: n } = this;
    return t !== null && n === t.length - 1;
  }
  get isRoot() {
    return this.stack.length === 1;
  }
  get root() {
    return this.stack[0];
  }
  get ancestors() {
    return [...jy(this, yp, gD).call(this)];
  }
  getName() {
    let { stack: t } = this, { length: n } = t;
    return n > 1 ? eo(!1, t, -2) : null;
  }
  getValue() {
    return eo(!1, this.stack, -1);
  }
  getNode(t = 0) {
    let n = jy(this, yp, mO).call(this, t);
    return n === -1 ? null : this.stack[n];
  }
  getParentNode(t = 0) {
    return this.getNode(t + 1);
  }
  call(t, ...n) {
    let { stack: r } = this, { length: i } = r, o = eo(!1, r, -1);
    for (let s of n) o = o[s], r.push(s, o);
    try {
      return t(this);
    } finally {
      r.length = i;
    }
  }
  callParent(t, n = 0) {
    let r = jy(this, yp, mO).call(this, n + 1), i = this.stack.splice(r + 1);
    try {
      return t(this);
    } finally {
      this.stack.push(...i);
    }
  }
  each(t, ...n) {
    let { stack: r } = this, { length: i } = r, o = eo(!1, r, -1);
    for (let s of n) o = o[s], r.push(s, o);
    try {
      for (let s = 0; s < o.length; ++s) r.push(s, o[s]), t(this, s, o), r.length -= 2;
    } finally {
      r.length = i;
    }
  }
  map(t, ...n) {
    let r = [];
    return this.each((i, o, s) => {
      r[o] = t(i, o, s);
    }, ...n), r;
  }
  match(...t) {
    let n = this.stack.length - 1, r = null, i = this.stack[n--];
    for (let o of t) {
      if (i === void 0) return !1;
      let s = null;
      if (typeof r == "number" && (s = r, r = this.stack[n--], i = this.stack[n--]), o && !o(i, r, s)) return !1;
      r = this.stack[n--], i = this.stack[n--];
    }
    return !0;
  }
  findAncestor(t) {
    for (let n of jy(this, yp, gD).call(this)) if (t(n)) return n;
  }
  hasAncestor(t) {
    for (let n of jy(this, yp, gD).call(this)) if (t(n)) return !0;
    return !1;
  }
};
yp = /* @__PURE__ */ new WeakSet(), mO = function(e) {
  let { stack: t } = this;
  for (let n = t.length - 1; n >= 0; n -= 2) if (!Array.isArray(t[n]) && --e < 0) return n;
  return -1;
}, gD = function* () {
  let { stack: e } = this;
  for (let t = e.length - 3; t >= 0; t -= 2) {
    let n = e[t];
    Array.isArray(n) || (yield n);
  }
};
var Lct = _ct, OJ = new Proxy(() => {
}, { get: () => OJ }), gO = OJ;
function Bct(e) {
  return e !== null && typeof e == "object";
}
var jct = Bct;
function* IJ(e, t) {
  let { getVisitorKeys: n, filter: r = () => !0 } = t, i = (o) => jct(o) && r(o);
  for (let o of n(e)) {
    let s = e[o];
    if (Array.isArray(s)) for (let a of s) i(a) && (yield a);
    else i(s) && (yield s);
  }
}
function* Vct(e, t) {
  let n = [e];
  for (let r = 0; r < n.length; r++) {
    let i = n[r];
    for (let o of IJ(i, t)) yield o, n.push(o);
  }
}
function Tv(e) {
  return (t, n, r) => {
    let i = !!(r != null && r.backwards);
    if (n === !1) return !1;
    let { length: o } = t, s = n;
    for (; s >= 0 && s < o; ) {
      let a = t.charAt(s);
      if (e instanceof RegExp) {
        if (!e.test(a)) return s;
      } else if (!e.includes(a)) return s;
      i ? s-- : s++;
    }
    return s === -1 || s === o ? s : !1;
  };
}
var zct = Tv(/\s/u), bd = Tv(" 	"), FJ = Tv(",; 	"), $J = Tv(/[^\n\r]/u);
function Uct(e, t, n) {
  let r = !!(n != null && n.backwards);
  if (t === !1) return !1;
  let i = e.charAt(t);
  if (r) {
    if (e.charAt(t - 1) === "\r" && i === `
`) return t - 2;
    if (i === `
` || i === "\r" || i === "\u2028" || i === "\u2029") return t - 1;
  } else {
    if (i === "\r" && e.charAt(t + 1) === `
`) return t + 2;
    if (i === `
` || i === "\r" || i === "\u2028" || i === "\u2029") return t + 1;
  }
  return t;
}
var rf = Uct;
function Wct(e, t, n = {}) {
  let r = bd(e, n.backwards ? t - 1 : t, n), i = rf(e, r, n);
  return r !== i;
}
var cd = Wct;
function Hct(e) {
  return Array.isArray(e) && e.length > 0;
}
var qct = Hct, NJ = /* @__PURE__ */ new Set(["tokens", "comments", "parent", "enclosingNode", "precedingNode", "followingNode"]), Gct = (e) => Object.keys(e).filter((t) => !NJ.has(t));
function Yct(e) {
  return e ? (t) => e(t, NJ) : Gct;
}
var ST = Yct;
function Kct(e) {
  let t = e.type || e.kind || "(unknown type)", n = String(e.name || e.id && (typeof e.id == "object" ? e.id.name : e.id) || e.key && (typeof e.key == "object" ? e.key.name : e.key) || e.value && (typeof e.value == "object" ? "" : String(e.value)) || e.operator || "");
  return n.length > 20 && (n = n.slice(0, 19) + "…"), t + (n ? " " + n : "");
}
function xN(e, t) {
  (e.comments ?? (e.comments = [])).push(t), t.printed = !1, t.nodeDescription = Kct(e);
}
function Bh(e, t) {
  t.leading = !0, t.trailing = !1, xN(e, t);
}
function bp(e, t, n) {
  t.leading = !1, t.trailing = !1, n && (t.marker = n), xN(e, t);
}
function jh(e, t) {
  t.leading = !1, t.trailing = !0, xN(e, t);
}
var Yw = /* @__PURE__ */ new WeakMap();
function DN(e, t) {
  if (Yw.has(e)) return Yw.get(e);
  let { printer: { getCommentChildNodes: n, canAttachComment: r, getVisitorKeys: i }, locStart: o, locEnd: s } = t;
  if (!r) return [];
  let a = ((n == null ? void 0 : n(e, t)) ?? [...IJ(e, { getVisitorKeys: ST(i) })]).flatMap((u) => r(u) ? [u] : DN(u, t));
  return a.sort((u, c) => o(u) - o(c) || s(u) - s(c)), Yw.set(e, a), a;
}
function MJ(e, t, n, r) {
  let { locStart: i, locEnd: o } = n, s = i(t), a = o(t), u = DN(e, n), c, d, f = 0, h = u.length;
  for (; f < h; ) {
    let m = f + h >> 1, v = u[m], x = i(v), C = o(v);
    if (x <= s && a <= C) return MJ(v, t, n, v);
    if (C <= s) {
      c = v, f = m + 1;
      continue;
    }
    if (a <= x) {
      d = v, h = m;
      continue;
    }
    throw new Error("Comment location overlaps with node location");
  }
  if ((r == null ? void 0 : r.type) === "TemplateLiteral") {
    let { quasis: m } = r, v = Jw(m, t, n);
    c && Jw(m, c, n) !== v && (c = null), d && Jw(m, d, n) !== v && (d = null);
  }
  return { enclosingNode: r, precedingNode: c, followingNode: d };
}
var Kw = () => !1;
function Jct(e, t) {
  let { comments: n } = e;
  if (delete e.comments, !qct(n) || !t.printer.canAttachComment) return;
  let r = [], { locStart: i, locEnd: o, printer: { experimentalFeatures: { avoidAstMutation: s = !1 } = {}, handleComments: a = {} }, originalText: u } = t, { ownLine: c = Kw, endOfLine: d = Kw, remaining: f = Kw } = a, h = n.map((m, v) => ({ ...MJ(e, m, t), comment: m, text: u, options: t, ast: e, isLastComment: n.length - 1 === v }));
  for (let [m, v] of h.entries()) {
    let { comment: x, precedingNode: C, enclosingNode: E, followingNode: S, text: w, options: O, ast: A, isLastComment: I } = v;
    if (O.parser === "json" || O.parser === "json5" || O.parser === "jsonc" || O.parser === "__js_expression" || O.parser === "__ts_expression" || O.parser === "__vue_expression" || O.parser === "__vue_ts_expression") {
      if (i(x) - i(A) <= 0) {
        Bh(A, x);
        continue;
      }
      if (o(x) - o(A) >= 0) {
        jh(A, x);
        continue;
      }
    }
    let $;
    if (s ? $ = [v] : (x.enclosingNode = E, x.precedingNode = C, x.followingNode = S, $ = [x, w, O, A, I]), Xct(w, O, h, m)) x.placement = "ownLine", c(...$) || (S ? Bh(S, x) : C ? jh(C, x) : bp(E || A, x));
    else if (Qct(w, O, h, m)) x.placement = "endOfLine", d(...$) || (C ? jh(C, x) : S ? Bh(S, x) : bp(E || A, x));
    else if (x.placement = "remaining", !f(...$)) if (C && S) {
      let L = r.length;
      L > 0 && r[L - 1].followingNode !== S && A4(r, O), r.push(v);
    } else C ? jh(C, x) : S ? Bh(S, x) : bp(E || A, x);
  }
  if (A4(r, t), !s) for (let m of n) delete m.precedingNode, delete m.enclosingNode, delete m.followingNode;
}
var RJ = (e) => !/[\S\n\u2028\u2029]/u.test(e);
function Xct(e, t, n, r) {
  let { comment: i, precedingNode: o } = n[r], { locStart: s, locEnd: a } = t, u = s(i);
  if (o) for (let c = r - 1; c >= 0; c--) {
    let { comment: d, precedingNode: f } = n[c];
    if (f !== o || !RJ(e.slice(a(d), u))) break;
    u = s(d);
  }
  return cd(e, u, { backwards: !0 });
}
function Qct(e, t, n, r) {
  let { comment: i, followingNode: o } = n[r], { locStart: s, locEnd: a } = t, u = a(i);
  if (o) for (let c = r + 1; c < n.length; c++) {
    let { comment: d, followingNode: f } = n[c];
    if (f !== o || !RJ(e.slice(u, s(d)))) break;
    u = a(d);
  }
  return cd(e, u);
}
function A4(e, t) {
  var n, r;
  let i = e.length;
  if (i === 0) return;
  let { precedingNode: o, followingNode: s } = e[0], a = t.locStart(s), u;
  for (u = i; u > 0; --u) {
    let { comment: c, precedingNode: d, followingNode: f } = e[u - 1];
    gO.strictEqual(d, o), gO.strictEqual(f, s);
    let h = t.originalText.slice(t.locEnd(c), a);
    if (((r = (n = t.printer).isGap) == null ? void 0 : r.call(n, h, t)) ?? /^[\s(]*$/u.test(h)) a = t.locStart(c);
    else break;
  }
  for (let [c, { comment: d }] of e.entries()) c < u ? jh(o, d) : Bh(s, d);
  for (let c of [o, s]) c.comments && c.comments.length > 1 && c.comments.sort((d, f) => t.locStart(d) - t.locStart(f));
  e.length = 0;
}
function Jw(e, t, n) {
  let r = n.locStart(t) - 1;
  for (let i = 1; i < e.length; ++i) if (r < n.locStart(e[i])) return i - 1;
  return 0;
}
function Zct(e, t) {
  let n = t - 1;
  n = bd(e, n, { backwards: !0 }), n = rf(e, n, { backwards: !0 }), n = bd(e, n, { backwards: !0 });
  let r = rf(e, n, { backwards: !0 });
  return n !== r;
}
var CN = Zct;
function _J(e, t) {
  let n = e.node;
  return n.printed = !0, t.printer.printComment(e, t);
}
function edt(e, t) {
  var n;
  let r = e.node, i = [_J(e, t)], { printer: o, originalText: s, locStart: a, locEnd: u } = t;
  if ((n = o.isBlockComment) != null && n.call(o, r)) {
    let d = cd(s, u(r)) ? cd(s, a(r), { backwards: !0 }) ? Vp : EJ : " ";
    i.push(d);
  } else i.push(Vp);
  let c = rf(s, bd(s, u(r)));
  return c !== !1 && cd(s, c) && i.push(Vp), i;
}
function tdt(e, t, n) {
  var r;
  let i = e.node, o = _J(e, t), { printer: s, originalText: a, locStart: u } = t, c = (r = s.isBlockComment) == null ? void 0 : r.call(s, i);
  if (n != null && n.hasLineSuffix && !(n != null && n.isBlock) || cd(a, u(i), { backwards: !0 })) {
    let d = CN(a, u(i));
    return { doc: dO([Vp, d ? Vp : "", o]), isBlock: c, hasLineSuffix: !0 };
  }
  return !c || n != null && n.hasLineSuffix ? { doc: [dO([" ", o]), CT], isBlock: c, hasLineSuffix: !0 } : { doc: [" ", o], isBlock: c, hasLineSuffix: !1 };
}
function ndt(e, t) {
  let n = e.node;
  if (!n) return {};
  let r = t[Symbol.for("printedComments")];
  if ((n.comments || []).filter((a) => !r.has(a)).length === 0) return { leading: "", trailing: "" };
  let i = [], o = [], s;
  return e.each(() => {
    let a = e.node;
    if (r != null && r.has(a)) return;
    let { leading: u, trailing: c } = a;
    u ? i.push(edt(e, t)) : c && (s = tdt(e, t, s), o.push(s.doc));
  }, "comments"), { leading: i, trailing: o };
}
function rdt(e, t, n) {
  let { leading: r, trailing: i } = ndt(e, n);
  return !r && !i ? t : PJ(t, (o) => [r, o, i]);
}
function idt(e) {
  let { [Symbol.for("comments")]: t, [Symbol.for("printedComments")]: n } = e;
  for (let r of t) {
    if (!r.printed && !n.has(r)) throw new Error('Comment "' + r.value.trim() + '" was not printed. Please report this error!');
    delete r.printed;
  }
}
var LJ = class extends Error {
  constructor() {
    super(...arguments);
    ap(this, "name", "ConfigError");
  }
}, w4 = class extends Error {
  constructor() {
    super(...arguments);
    ap(this, "name", "UndefinedParserError");
  }
}, odt = { cursorOffset: { category: "Special", type: "int", default: -1, range: { start: -1, end: 1 / 0, step: 1 }, description: "Print (to stderr) where a cursor at the given position would move to after formatting.", cliCategory: "Editor" }, endOfLine: { category: "Global", type: "choice", default: "lf", description: "Which end of line characters to apply.", choices: [{ value: "lf", description: "Line Feed only (\\n), common on Linux and macOS as well as inside git repos" }, { value: "crlf", description: "Carriage Return + Line Feed characters (\\r\\n), common on Windows" }, { value: "cr", description: "Carriage Return character only (\\r), used very rarely" }, { value: "auto", description: `Maintain existing
(mixed values within one file are normalised by looking at what's used after the first line)` }] }, filepath: { category: "Special", type: "path", description: "Specify the input filepath. This will be used to do parser inference.", cliName: "stdin-filepath", cliCategory: "Other", cliDescription: "Path to the file to pretend that stdin comes from." }, insertPragma: { category: "Special", type: "boolean", default: !1, description: "Insert @format pragma into file's first docblock comment.", cliCategory: "Other" }, parser: { category: "Global", type: "choice", default: void 0, description: "Which parser to use.", exception: (e) => typeof e == "string" || typeof e == "function", choices: [{ value: "flow", description: "Flow" }, { value: "babel", description: "JavaScript" }, { value: "babel-flow", description: "Flow" }, { value: "babel-ts", description: "TypeScript" }, { value: "typescript", description: "TypeScript" }, { value: "acorn", description: "JavaScript" }, { value: "espree", description: "JavaScript" }, { value: "meriyah", description: "JavaScript" }, { value: "css", description: "CSS" }, { value: "less", description: "Less" }, { value: "scss", description: "SCSS" }, { value: "json", description: "JSON" }, { value: "json5", description: "JSON5" }, { value: "jsonc", description: "JSON with Comments" }, { value: "json-stringify", description: "JSON.stringify" }, { value: "graphql", description: "GraphQL" }, { value: "markdown", description: "Markdown" }, { value: "mdx", description: "MDX" }, { value: "vue", description: "Vue" }, { value: "yaml", description: "YAML" }, { value: "glimmer", description: "Ember / Handlebars" }, { value: "html", description: "HTML" }, { value: "angular", description: "Angular" }, { value: "lwc", description: "Lightning Web Components" }] }, plugins: { type: "path", array: !0, default: [{ value: [] }], category: "Global", description: "Add a plugin. Multiple plugins can be passed as separate `--plugin`s.", exception: (e) => typeof e == "string" || typeof e == "object", cliName: "plugin", cliCategory: "Config" }, printWidth: { category: "Global", type: "int", default: 80, description: "The line length where Prettier will try wrap.", range: { start: 0, end: 1 / 0, step: 1 } }, rangeEnd: { category: "Special", type: "int", default: 1 / 0, range: { start: 0, end: 1 / 0, step: 1 }, description: `Format code ending at a given character offset (exclusive).
The range will extend forwards to the end of the selected statement.`, cliCategory: "Editor" }, rangeStart: { category: "Special", type: "int", default: 0, range: { start: 0, end: 1 / 0, step: 1 }, description: `Format code starting at a given character offset.
The range will extend backwards to the start of the first line containing the selected statement.`, cliCategory: "Editor" }, requirePragma: { category: "Special", type: "boolean", default: !1, description: `Require either '@prettier' or '@format' to be present in the file's first docblock comment
in order for it to be formatted.`, cliCategory: "Other" }, tabWidth: { type: "int", category: "Global", default: 2, description: "Number of spaces per indentation level.", range: { start: 0, end: 1 / 0, step: 1 } }, useTabs: { category: "Global", type: "boolean", default: !1, description: "Indent with tabs instead of spaces." }, embeddedLanguageFormatting: { category: "Global", type: "choice", default: "auto", description: "Control how Prettier formats quoted code embedded in the file.", choices: [{ value: "auto", description: "Format embedded code if Prettier can automatically identify it." }, { value: "off", description: "Never automatically format embedded code." }] } };
function BJ({ plugins: e = [], showDeprecated: t = !1 } = {}) {
  let n = e.flatMap((i) => i.languages ?? []), r = [];
  for (let i of adt(Object.assign({}, ...e.map(({ options: o }) => o), odt))) !t && i.deprecated || (Array.isArray(i.choices) && (t || (i.choices = i.choices.filter((o) => !o.deprecated)), i.name === "parser" && (i.choices = [...i.choices, ...sdt(i.choices, n, e)])), i.pluginDefaults = Object.fromEntries(e.filter((o) => {
    var s;
    return ((s = o.defaultOptions) == null ? void 0 : s[i.name]) !== void 0;
  }).map((o) => [o.name, o.defaultOptions[i.name]])), r.push(i));
  return { languages: n, options: r };
}
function* sdt(e, t, n) {
  let r = new Set(e.map((i) => i.value));
  for (let i of t) if (i.parsers) {
    for (let o of i.parsers) if (!r.has(o)) {
      r.add(o);
      let s = n.find((u) => u.parsers && Object.prototype.hasOwnProperty.call(u.parsers, o)), a = i.name;
      s != null && s.name && (a += ` (plugin: ${s.name})`), yield { value: o, description: a };
    }
  }
}
function adt(e) {
  let t = [];
  for (let [n, r] of Object.entries(e)) {
    let i = { name: n, ...r };
    Array.isArray(i.default) && (i.default = eo(!1, i.default, -1).value), t.push(i);
  }
  return t;
}
var ldt = (e) => String(e).split(/[/\\]/u).pop();
function P4(e, t) {
  if (!t) return;
  let n = ldt(t).toLowerCase();
  return e.find(({ filenames: r }) => r == null ? void 0 : r.some((i) => i.toLowerCase() === n)) ?? e.find(({ extensions: r }) => r == null ? void 0 : r.some((i) => n.endsWith(i)));
}
function udt(e, t) {
  if (t) return e.find(({ name: n }) => n.toLowerCase() === t) ?? e.find(({ aliases: n }) => n == null ? void 0 : n.includes(t)) ?? e.find(({ extensions: n }) => n == null ? void 0 : n.includes(`.${t}`));
}
function cdt(e, t) {
  let n = e.plugins.flatMap((i) => i.languages ?? []), r = udt(n, t.language) ?? P4(n, t.physicalFile) ?? P4(n, t.file) ?? (t.physicalFile, void 0);
  return r == null ? void 0 : r.parsers[0];
}
var ddt = cdt, Vh = { key: (e) => /^[$_a-zA-Z][$_a-zA-Z0-9]*$/.test(e) ? e : JSON.stringify(e), value(e) {
  if (e === null || typeof e != "object") return JSON.stringify(e);
  if (Array.isArray(e)) return `[${e.map((n) => Vh.value(n)).join(", ")}]`;
  let t = Object.keys(e);
  return t.length === 0 ? "{}" : `{ ${t.map((n) => `${Vh.key(n)}: ${Vh.value(e[n])}`).join(", ")} }`;
}, pair: ({ key: e, value: t }) => Vh.value({ [e]: t }) }, k4 = xT(fN()), pdt = (e, t, { descriptor: n }) => {
  let r = [`${k4.default.yellow(typeof e == "string" ? n.key(e) : n.pair(e))} is deprecated`];
  return t && r.push(`we now treat it as ${k4.default.blue(typeof t == "string" ? n.key(t) : n.pair(t))}`), r.join("; ") + ".";
}, zh = xT(fN()), jJ = Symbol.for("vnopts.VALUE_NOT_EXIST"), yD = Symbol.for("vnopts.VALUE_UNCHANGED"), O4 = " ".repeat(2), fdt = (e, t, n) => {
  let { text: r, list: i } = n.normalizeExpectedResult(n.schemas[e].expected(n)), o = [];
  return r && o.push(I4(e, t, r, n.descriptor)), i && o.push([I4(e, t, i.title, n.descriptor)].concat(i.values.map((s) => VJ(s, n.loggerPrintWidth))).join(`
`)), zJ(o, n.loggerPrintWidth);
};
function I4(e, t, n, r) {
  return [`Invalid ${zh.default.red(r.key(e))} value.`, `Expected ${zh.default.blue(n)},`, `but received ${t === jJ ? zh.default.gray("nothing") : zh.default.red(r.value(t))}.`].join(" ");
}
function VJ({ text: e, list: t }, n) {
  let r = [];
  return e && r.push(`- ${zh.default.blue(e)}`), t && r.push([`- ${zh.default.blue(t.title)}:`].concat(t.values.map((i) => VJ(i, n - O4.length).replace(/^|\n/g, `$&${O4}`))).join(`
`)), zJ(r, n);
}
function zJ(e, t) {
  if (e.length === 1) return e[0];
  let [n, r] = e, [i, o] = e.map((s) => s.split(`
`, 1)[0].length);
  return i > t && i > o ? r : n;
}
var F4 = xT(fN()), Xw = [], $4 = [];
function hdt(e, t) {
  if (e === t) return 0;
  let n = e;
  e.length > t.length && (e = t, t = n);
  let r = e.length, i = t.length;
  for (; r > 0 && e.charCodeAt(~-r) === t.charCodeAt(~-i); ) r--, i--;
  let o = 0;
  for (; o < r && e.charCodeAt(o) === t.charCodeAt(o); ) o++;
  if (r -= o, i -= o, r === 0) return i;
  let s, a, u, c, d = 0, f = 0;
  for (; d < r; ) $4[d] = e.charCodeAt(o + d), Xw[d] = ++d;
  for (; f < i; ) for (s = t.charCodeAt(o + f), u = f++, a = f, d = 0; d < r; d++) c = s === $4[d] ? u : u + 1, u = Xw[d], a = Xw[d] = u > a ? c > a ? a + 1 : c : c > u ? u + 1 : c;
  return a;
}
var UJ = (e, t, { descriptor: n, logger: r, schemas: i }) => {
  let o = [`Ignored unknown option ${F4.default.yellow(n.pair({ key: e, value: t }))}.`], s = Object.keys(i).sort().find((a) => hdt(e, a) < 3);
  s && o.push(`Did you mean ${F4.default.blue(n.key(s))}?`), r.warn(o.join(" "));
}, mdt = ["default", "expected", "validate", "deprecated", "forward", "redirect", "overlap", "preprocess", "postprocess"];
function gdt(e, t) {
  let n = new e(t), r = Object.create(n);
  for (let i of mdt) i in t && (r[i] = ydt(t[i], n, Rd.prototype[i].length));
  return r;
}
var Rd = class {
  static create(t) {
    return gdt(this, t);
  }
  constructor(t) {
    this.name = t.name;
  }
  default(t) {
  }
  expected(t) {
    return "nothing";
  }
  validate(t, n) {
    return !1;
  }
  deprecated(t, n) {
    return !1;
  }
  forward(t, n) {
  }
  redirect(t, n) {
  }
  overlap(t, n, r) {
    return t;
  }
  preprocess(t, n) {
    return t;
  }
  postprocess(t, n) {
    return yD;
  }
};
function ydt(e, t, n) {
  return typeof e == "function" ? (...r) => e(...r.slice(0, n - 1), t, ...r.slice(n - 1)) : () => e;
}
var bdt = class extends Rd {
  constructor(t) {
    super(t), this._sourceName = t.sourceName;
  }
  expected(t) {
    return t.schemas[this._sourceName].expected(t);
  }
  validate(t, n) {
    return n.schemas[this._sourceName].validate(t, n);
  }
  redirect(t, n) {
    return this._sourceName;
  }
}, vdt = class extends Rd {
  expected() {
    return "anything";
  }
  validate() {
    return !0;
  }
}, xdt = class extends Rd {
  constructor({ valueSchema: t, name: n = t.name, ...r }) {
    super({ ...r, name: n }), this._valueSchema = t;
  }
  expected(t) {
    let { text: n, list: r } = t.normalizeExpectedResult(this._valueSchema.expected(t));
    return { text: n && `an array of ${n}`, list: r && { title: "an array of the following values", values: [{ list: r }] } };
  }
  validate(t, n) {
    if (!Array.isArray(t)) return !1;
    let r = [];
    for (let i of t) {
      let o = n.normalizeValidateResult(this._valueSchema.validate(i, n), i);
      o !== !0 && r.push(o.value);
    }
    return r.length === 0 ? !0 : { value: r };
  }
  deprecated(t, n) {
    let r = [];
    for (let i of t) {
      let o = n.normalizeDeprecatedResult(this._valueSchema.deprecated(i, n), i);
      o !== !1 && r.push(...o.map(({ value: s }) => ({ value: [s] })));
    }
    return r;
  }
  forward(t, n) {
    let r = [];
    for (let i of t) {
      let o = n.normalizeForwardResult(this._valueSchema.forward(i, n), i);
      r.push(...o.map(N4));
    }
    return r;
  }
  redirect(t, n) {
    let r = [], i = [];
    for (let o of t) {
      let s = n.normalizeRedirectResult(this._valueSchema.redirect(o, n), o);
      "remain" in s && r.push(s.remain), i.push(...s.redirect.map(N4));
    }
    return r.length === 0 ? { redirect: i } : { redirect: i, remain: r };
  }
  overlap(t, n) {
    return t.concat(n);
  }
};
function N4({ from: e, to: t }) {
  return { from: [e], to: t };
}
var Ddt = class extends Rd {
  expected() {
    return "true or false";
  }
  validate(t) {
    return typeof t == "boolean";
  }
};
function Cdt(e, t) {
  let n = /* @__PURE__ */ Object.create(null);
  for (let r of e) {
    let i = r[t];
    if (n[i]) throw new Error(`Duplicate ${t} ${JSON.stringify(i)}`);
    n[i] = r;
  }
  return n;
}
function Edt(e, t) {
  let n = /* @__PURE__ */ new Map();
  for (let r of e) {
    let i = r[t];
    if (n.has(i)) throw new Error(`Duplicate ${t} ${JSON.stringify(i)}`);
    n.set(i, r);
  }
  return n;
}
function Tdt() {
  let e = /* @__PURE__ */ Object.create(null);
  return (t) => {
    let n = JSON.stringify(t);
    return e[n] ? !0 : (e[n] = !0, !1);
  };
}
function Sdt(e, t) {
  let n = [], r = [];
  for (let i of e) t(i) ? n.push(i) : r.push(i);
  return [n, r];
}
function Adt(e) {
  return e === Math.floor(e);
}
function wdt(e, t) {
  if (e === t) return 0;
  let n = typeof e, r = typeof t, i = ["undefined", "object", "boolean", "number", "string"];
  return n !== r ? i.indexOf(n) - i.indexOf(r) : n !== "string" ? Number(e) - Number(t) : e.localeCompare(t);
}
function Pdt(e) {
  return (...t) => {
    let n = e(...t);
    return typeof n == "string" ? new Error(n) : n;
  };
}
function M4(e) {
  return e === void 0 ? {} : e;
}
function WJ(e) {
  if (typeof e == "string") return { text: e };
  let { text: t, list: n } = e;
  return kdt((t || n) !== void 0, "Unexpected `expected` result, there should be at least one field."), n ? { text: t, list: { title: n.title, values: n.values.map(WJ) } } : { text: t };
}
function R4(e, t) {
  return e === !0 ? !0 : e === !1 ? { value: t } : e;
}
function _4(e, t, n = !1) {
  return e === !1 ? !1 : e === !0 ? n ? !0 : [{ value: t }] : "value" in e ? [e] : e.length === 0 ? !1 : e;
}
function L4(e, t) {
  return typeof e == "string" || "key" in e ? { from: t, to: e } : "from" in e ? { from: e.from, to: e.to } : { from: t, to: e.to };
}
function yO(e, t) {
  return e === void 0 ? [] : Array.isArray(e) ? e.map((n) => L4(n, t)) : [L4(e, t)];
}
function B4(e, t) {
  let n = yO(typeof e == "object" && "redirect" in e ? e.redirect : e, t);
  return n.length === 0 ? { remain: t, redirect: n } : typeof e == "object" && "remain" in e ? { remain: e.remain, redirect: n } : { redirect: n };
}
function kdt(e, t) {
  if (!e) throw new Error(t);
}
var Odt = class extends Rd {
  constructor(t) {
    super(t), this._choices = Edt(t.choices.map((n) => n && typeof n == "object" ? n : { value: n }), "value");
  }
  expected({ descriptor: t }) {
    let n = Array.from(this._choices.keys()).map((o) => this._choices.get(o)).filter(({ hidden: o }) => !o).map((o) => o.value).sort(wdt).map(t.value), r = n.slice(0, -2), i = n.slice(-2);
    return { text: r.concat(i.join(" or ")).join(", "), list: { title: "one of the following values", values: n } };
  }
  validate(t) {
    return this._choices.has(t);
  }
  deprecated(t) {
    let n = this._choices.get(t);
    return n && n.deprecated ? { value: t } : !1;
  }
  forward(t) {
    let n = this._choices.get(t);
    return n ? n.forward : void 0;
  }
  redirect(t) {
    let n = this._choices.get(t);
    return n ? n.redirect : void 0;
  }
}, Idt = class extends Rd {
  expected() {
    return "a number";
  }
  validate(t, n) {
    return typeof t == "number";
  }
}, Fdt = class extends Idt {
  expected() {
    return "an integer";
  }
  validate(t, n) {
    return n.normalizeValidateResult(super.validate(t, n), t) === !0 && Adt(t);
  }
}, j4 = class extends Rd {
  expected() {
    return "a string";
  }
  validate(t) {
    return typeof t == "string";
  }
}, $dt = Vh, Ndt = UJ, Mdt = fdt, Rdt = pdt, _dt = class {
  constructor(t, n) {
    let { logger: r = console, loggerPrintWidth: i = 80, descriptor: o = $dt, unknown: s = Ndt, invalid: a = Mdt, deprecated: u = Rdt, missing: c = () => !1, required: d = () => !1, preprocess: f = (m) => m, postprocess: h = () => yD } = n || {};
    this._utils = { descriptor: o, logger: r || { warn: () => {
    } }, loggerPrintWidth: i, schemas: Cdt(t, "name"), normalizeDefaultResult: M4, normalizeExpectedResult: WJ, normalizeDeprecatedResult: _4, normalizeForwardResult: yO, normalizeRedirectResult: B4, normalizeValidateResult: R4 }, this._unknownHandler = s, this._invalidHandler = Pdt(a), this._deprecatedHandler = u, this._identifyMissing = (m, v) => !(m in v) || c(m, v), this._identifyRequired = d, this._preprocess = f, this._postprocess = h, this.cleanHistory();
  }
  cleanHistory() {
    this._hasDeprecationWarned = Tdt();
  }
  normalize(t) {
    let n = {}, r = [this._preprocess(t, this._utils)], i = () => {
      for (; r.length !== 0; ) {
        let o = r.shift(), s = this._applyNormalization(o, n);
        r.push(...s);
      }
    };
    i();
    for (let o of Object.keys(this._utils.schemas)) {
      let s = this._utils.schemas[o];
      if (!(o in n)) {
        let a = M4(s.default(this._utils));
        "value" in a && r.push({ [o]: a.value });
      }
    }
    i();
    for (let o of Object.keys(this._utils.schemas)) {
      if (!(o in n)) continue;
      let s = this._utils.schemas[o], a = n[o], u = s.postprocess(a, this._utils);
      u !== yD && (this._applyValidation(u, o, s), n[o] = u);
    }
    return this._applyPostprocess(n), this._applyRequiredCheck(n), n;
  }
  _applyNormalization(t, n) {
    let r = [], { knownKeys: i, unknownKeys: o } = this._partitionOptionKeys(t);
    for (let s of i) {
      let a = this._utils.schemas[s], u = a.preprocess(t[s], this._utils);
      this._applyValidation(u, s, a);
      let c = ({ from: h, to: m }) => {
        r.push(typeof m == "string" ? { [m]: h } : { [m.key]: m.value });
      }, d = ({ value: h, redirectTo: m }) => {
        let v = _4(a.deprecated(h, this._utils), u, !0);
        if (v !== !1) if (v === !0) this._hasDeprecationWarned(s) || this._utils.logger.warn(this._deprecatedHandler(s, m, this._utils));
        else for (let { value: x } of v) {
          let C = { key: s, value: x };
          if (!this._hasDeprecationWarned(C)) {
            let E = typeof m == "string" ? { key: m, value: x } : m;
            this._utils.logger.warn(this._deprecatedHandler(C, E, this._utils));
          }
        }
      };
      yO(a.forward(u, this._utils), u).forEach(c);
      let f = B4(a.redirect(u, this._utils), u);
      if (f.redirect.forEach(c), "remain" in f) {
        let h = f.remain;
        n[s] = s in n ? a.overlap(n[s], h, this._utils) : h, d({ value: h });
      }
      for (let { from: h, to: m } of f.redirect) d({ value: h, redirectTo: m });
    }
    for (let s of o) {
      let a = t[s];
      this._applyUnknownHandler(s, a, n, (u, c) => {
        r.push({ [u]: c });
      });
    }
    return r;
  }
  _applyRequiredCheck(t) {
    for (let n of Object.keys(this._utils.schemas)) if (this._identifyMissing(n, t) && this._identifyRequired(n)) throw this._invalidHandler(n, jJ, this._utils);
  }
  _partitionOptionKeys(t) {
    let [n, r] = Sdt(Object.keys(t).filter((i) => !this._identifyMissing(i, t)), (i) => i in this._utils.schemas);
    return { knownKeys: n, unknownKeys: r };
  }
  _applyValidation(t, n, r) {
    let i = R4(r.validate(t, this._utils), t);
    if (i !== !0) throw this._invalidHandler(n, i.value, this._utils);
  }
  _applyUnknownHandler(t, n, r, i) {
    let o = this._unknownHandler(t, n, this._utils);
    if (o) for (let s of Object.keys(o)) {
      if (this._identifyMissing(s, o)) continue;
      let a = o[s];
      s in this._utils.schemas ? i(s, a) : r[s] = a;
    }
  }
  _applyPostprocess(t) {
    let n = this._postprocess(t, this._utils);
    if (n !== yD) {
      if (n.delete) for (let r of n.delete) delete t[r];
      if (n.override) {
        let { knownKeys: r, unknownKeys: i } = this._partitionOptionKeys(n.override);
        for (let o of r) {
          let s = n.override[o];
          this._applyValidation(s, o, this._utils.schemas[o]), t[o] = s;
        }
        for (let o of i) {
          let s = n.override[o];
          this._applyUnknownHandler(o, s, t, (a, u) => {
            let c = this._utils.schemas[a];
            this._applyValidation(u, a, c), t[a] = u;
          });
        }
      }
    }
  }
}, Qw;
function Ldt(e, t, { logger: n = !1, isCLI: r = !1, passThrough: i = !1, FlagSchema: o, descriptor: s } = {}) {
  if (r) {
    if (!o) throw new Error("'FlagSchema' option is required.");
    if (!s) throw new Error("'descriptor' option is required.");
  } else s = Vh;
  let a = i ? Array.isArray(i) ? (h, m) => i.includes(h) ? { [h]: m } : void 0 : (h, m) => ({ [h]: m }) : (h, m, v) => {
    let { _: x, ...C } = v.schemas;
    return UJ(h, m, { ...v, schemas: C });
  }, u = Bdt(t, { isCLI: r, FlagSchema: o }), c = new _dt(u, { logger: n, unknown: a, descriptor: s }), d = n !== !1;
  d && Qw && (c._hasDeprecationWarned = Qw);
  let f = c.normalize(e);
  return d && (Qw = c._hasDeprecationWarned), f;
}
function Bdt(e, { isCLI: t, FlagSchema: n }) {
  let r = [];
  t && r.push(vdt.create({ name: "_" }));
  for (let i of e) r.push(jdt(i, { isCLI: t, optionInfos: e, FlagSchema: n })), i.alias && t && r.push(bdt.create({ name: i.alias, sourceName: i.name }));
  return r;
}
function jdt(e, { isCLI: t, optionInfos: n, FlagSchema: r }) {
  let { name: i } = e, o = { name: i }, s, a = {};
  switch (e.type) {
    case "int":
      s = Fdt, t && (o.preprocess = Number);
      break;
    case "string":
      s = j4;
      break;
    case "choice":
      s = Odt, o.choices = e.choices.map((u) => u != null && u.redirect ? { ...u, redirect: { to: { key: e.name, value: u.redirect } } } : u);
      break;
    case "boolean":
      s = Ddt;
      break;
    case "flag":
      s = r, o.flags = n.flatMap((u) => [u.alias, u.description && u.name, u.oppositeDescription && `no-${u.name}`].filter(Boolean));
      break;
    case "path":
      s = j4;
      break;
    default:
      throw new Error(`Unexpected type ${e.type}`);
  }
  if (e.exception ? o.validate = (u, c, d) => e.exception(u) || c.validate(u, d) : o.validate = (u, c, d) => u === void 0 || c.validate(u, d), e.redirect && (a.redirect = (u) => u ? { to: typeof e.redirect == "string" ? e.redirect : { key: e.redirect.option, value: e.redirect.value } } : void 0), e.deprecated && (a.deprecated = !0), t && !e.array) {
    let u = o.preprocess || ((c) => c);
    o.preprocess = (c, d, f) => d.preprocess(u(Array.isArray(c) ? eo(!1, c, -1) : c), f);
  }
  return e.array ? xdt.create({ ...t ? { preprocess: (u) => Array.isArray(u) ? u : [u] } : {}, ...a, valueSchema: s.create(o) }) : s.create({ ...o, ...a });
}
var Vdt = Ldt, zdt = (e, t, n) => {
  if (!(e && t == null)) {
    if (t.findLast) return t.findLast(n);
    for (let r = t.length - 1; r >= 0; r--) {
      let i = t[r];
      if (n(i, r, t)) return i;
    }
  }
}, HJ = zdt;
function qJ(e, t) {
  if (!t) throw new Error("parserName is required.");
  let n = HJ(!1, e, (i) => i.parsers && Object.prototype.hasOwnProperty.call(i.parsers, t));
  if (n) return n;
  let r = `Couldn't resolve parser "${t}".`;
  throw r += " Plugins must be explicitly added to the standalone bundle.", new LJ(r);
}
function Udt(e, t) {
  if (!t) throw new Error("astFormat is required.");
  let n = HJ(!1, e, (i) => i.printers && Object.prototype.hasOwnProperty.call(i.printers, t));
  if (n) return n;
  let r = `Couldn't find plugin for AST format "${t}".`;
  throw r += " Plugins must be explicitly added to the standalone bundle.", new LJ(r);
}
function GJ({ plugins: e, parser: t }) {
  let n = qJ(e, t);
  return YJ(n, t);
}
function YJ(e, t) {
  let n = e.parsers[t];
  return typeof n == "function" ? n() : n;
}
function Wdt(e, t) {
  let n = e.printers[t];
  return typeof n == "function" ? n() : n;
}
var V4 = { astFormat: "estree", printer: {}, originalText: void 0, locStart: null, locEnd: null };
async function Hdt(e, t = {}) {
  var n;
  let r = { ...e };
  if (!r.parser) if (r.filepath) {
    if (r.parser = ddt(r, { physicalFile: r.filepath }), !r.parser) throw new w4(`No parser could be inferred for file "${r.filepath}".`);
  } else throw new w4("No parser and no file path given, couldn't infer a parser.");
  let i = BJ({ plugins: e.plugins, showDeprecated: !0 }).options, o = { ...V4, ...Object.fromEntries(i.filter((h) => h.default !== void 0).map((h) => [h.name, h.default])) }, s = qJ(r.plugins, r.parser), a = await YJ(s, r.parser);
  r.astFormat = a.astFormat, r.locEnd = a.locEnd, r.locStart = a.locStart;
  let u = (n = s.printers) != null && n[a.astFormat] ? s : Udt(r.plugins, a.astFormat), c = await Wdt(u, a.astFormat);
  r.printer = c;
  let d = u.defaultOptions ? Object.fromEntries(Object.entries(u.defaultOptions).filter(([, h]) => h !== void 0)) : {}, f = { ...o, ...d };
  for (let [h, m] of Object.entries(f)) (r[h] === null || r[h] === void 0) && (r[h] = m);
  return r.parser === "json" && (r.trailingComma = "none"), Vdt(r, i, { passThrough: Object.keys(V4), ...t });
}
var Sg = Hdt, qdt = xT(Uut());
async function Gdt(e, t) {
  let n = await GJ(t), r = n.preprocess ? n.preprocess(e, t) : e;
  t.originalText = r;
  let i;
  try {
    i = await n.parse(r, t, t);
  } catch (o) {
    Ydt(o, e);
  }
  return { text: r, ast: i };
}
function Ydt(e, t) {
  let { loc: n } = e;
  if (n) {
    let r = (0, qdt.codeFrameColumns)(t, n, { highlightCode: !0 });
    throw e.message += `
` + r, e.codeFrame = r, e;
  }
  throw e;
}
var Sv = Gdt;
async function Kdt(e, t, n, r, i) {
  let { embeddedLanguageFormatting: o, printer: { embed: s, hasPrettierIgnore: a = () => !1, getVisitorKeys: u } } = n;
  if (!s || o !== "auto") return;
  if (s.length > 2) throw new Error("printer.embed has too many parameters. The API changed in Prettier v3. Please update your plugin. See https://prettier.io/docs/en/plugins.html#optional-embed");
  let c = ST(s.getVisitorKeys ?? u), d = [];
  m();
  let f = e.stack;
  for (let { print: v, node: x, pathStack: C } of d) try {
    e.stack = C;
    let E = await v(h, t, e, n);
    E && i.set(x, E);
  } catch (E) {
    if (globalThis.PRETTIER_DEBUG) throw E;
  }
  e.stack = f;
  function h(v, x) {
    return Jdt(v, x, n, r);
  }
  function m() {
    let { node: v } = e;
    if (v === null || typeof v != "object" || a(e)) return;
    for (let C of c(v)) Array.isArray(v[C]) ? e.each(m, C) : e.call(m, C);
    let x = s(e, n);
    if (x) {
      if (typeof x == "function") {
        d.push({ print: x, node: v, pathStack: [...e.stack] });
        return;
      }
      i.set(v, x);
    }
  }
}
async function Jdt(e, t, n, r) {
  let i = await Sg({ ...n, ...t, parentParser: n.parser, originalText: e }, { passThrough: !0 }), { ast: o } = await Sv(e, i), s = await r(o, i);
  return wJ(s);
}
function Xdt(e, t) {
  let { originalText: n, [Symbol.for("comments")]: r, locStart: i, locEnd: o, [Symbol.for("printedComments")]: s } = t, { node: a } = e, u = i(a), c = o(a);
  for (let d of r) i(d) >= u && o(d) <= c && s.add(d);
  return n.slice(u, c);
}
var Qdt = Xdt;
async function AT(e, t) {
  ({ ast: e } = await KJ(e, t));
  let n = /* @__PURE__ */ new Map(), r = new Lct(e), i = /* @__PURE__ */ new Map();
  await Kdt(r, s, t, AT, i);
  let o = await z4(r, t, s, void 0, i);
  return idt(t), o;
  function s(u, c) {
    return u === void 0 || u === r ? a(c) : Array.isArray(u) ? r.call(() => a(c), ...u) : r.call(() => a(c), u);
  }
  function a(u) {
    let c = r.node;
    if (c == null) return "";
    let d = c && typeof c == "object" && u === void 0;
    if (d && n.has(c)) return n.get(c);
    let f = z4(r, t, s, u, i);
    return d && n.set(c, f), f;
  }
}
function z4(e, t, n, r, i) {
  var o;
  let { node: s } = e, { printer: a } = t, u;
  return (o = a.hasPrettierIgnore) != null && o.call(a, e) ? u = Qdt(e, t) : i.has(s) ? u = i.get(s) : u = a.print(e, t, n, r), s === t.cursorNode && (u = PJ(u, (c) => [pO, c, pO])), a.printComment && (!a.willPrintOwnComments || !a.willPrintOwnComments(e, t)) && (u = rdt(e, u, t)), u;
}
async function KJ(e, t) {
  let n = e.comments ?? [];
  t[Symbol.for("comments")] = n, t[Symbol.for("tokens")] = e.tokens ?? [], t[Symbol.for("printedComments")] = /* @__PURE__ */ new Set(), Jct(e, t);
  let { printer: { preprocess: r } } = t;
  return e = r ? await r(e, t) : e, { ast: e, comments: n };
}
function Zdt(e, t) {
  let { cursorOffset: n, locStart: r, locEnd: i } = t, o = ST(t.printer.getVisitorKeys), s = (u) => r(u) <= n && i(u) >= n, a = e;
  for (let u of Vct(e, { getVisitorKeys: o, filter: s })) a = u;
  return a;
}
var ept = Zdt;
function tpt(e, t) {
  let { printer: { massageAstNode: n, getVisitorKeys: r } } = t;
  if (!n) return e;
  let i = ST(r), o = n.ignoredProperties ?? /* @__PURE__ */ new Set();
  return s(e);
  function s(a, u) {
    if (!(a !== null && typeof a == "object")) return a;
    if (Array.isArray(a)) return a.map((h) => s(h, u)).filter(Boolean);
    let c = {}, d = new Set(i(a));
    for (let h in a) !Object.prototype.hasOwnProperty.call(a, h) || o.has(h) || (d.has(h) ? c[h] = s(a[h], a) : c[h] = a[h]);
    let f = n(a, c, u);
    if (f !== null) return f ?? c;
  }
}
var npt = tpt, rpt = (e, t, n) => {
  if (!(e && t == null)) {
    if (t.findLastIndex) return t.findLastIndex(n);
    for (let r = t.length - 1; r >= 0; r--) {
      let i = t[r];
      if (n(i, r, t)) return r;
    }
    return -1;
  }
}, ipt = rpt, opt = ({ parser: e }) => e === "json" || e === "json5" || e === "jsonc" || e === "json-stringify";
function spt(e, t) {
  let n = [e.node, ...e.parentNodes], r = /* @__PURE__ */ new Set([t.node, ...t.parentNodes]);
  return n.find((i) => JJ.has(i.type) && r.has(i));
}
function U4(e) {
  let t = ipt(!1, e, (n) => n.type !== "Program" && n.type !== "File");
  return t === -1 ? e : e.slice(0, t + 1);
}
function apt(e, t, { locStart: n, locEnd: r }) {
  let i = e.node, o = t.node;
  if (i === o) return { startNode: i, endNode: o };
  let s = n(e.node);
  for (let u of U4(t.parentNodes)) if (n(u) >= s) o = u;
  else break;
  let a = r(t.node);
  for (let u of U4(e.parentNodes)) {
    if (r(u) <= a) i = u;
    else break;
    if (i === o) break;
  }
  return { startNode: i, endNode: o };
}
function bO(e, t, n, r, i = [], o) {
  let { locStart: s, locEnd: a } = n, u = s(e), c = a(e);
  if (!(t > c || t < u || o === "rangeEnd" && t === u || o === "rangeStart" && t === c)) {
    for (let d of DN(e, n)) {
      let f = bO(d, t, n, r, [e, ...i], o);
      if (f) return f;
    }
    if (!r || r(e, i[0])) return { node: e, parentNodes: i };
  }
}
function lpt(e, t) {
  return t !== "DeclareExportDeclaration" && e !== "TypeParameterDeclaration" && (e === "Directive" || e === "TypeAlias" || e === "TSExportAssignment" || e.startsWith("Declare") || e.startsWith("TSDeclare") || e.endsWith("Statement") || e.endsWith("Declaration"));
}
var JJ = /* @__PURE__ */ new Set(["JsonRoot", "ObjectExpression", "ArrayExpression", "StringLiteral", "NumericLiteral", "BooleanLiteral", "NullLiteral", "UnaryExpression", "TemplateLiteral"]), upt = /* @__PURE__ */ new Set(["OperationDefinition", "FragmentDefinition", "VariableDefinition", "TypeExtensionDefinition", "ObjectTypeDefinition", "FieldDefinition", "DirectiveDefinition", "EnumTypeDefinition", "EnumValueDefinition", "InputValueDefinition", "InputObjectTypeDefinition", "SchemaDefinition", "OperationTypeDefinition", "InterfaceTypeDefinition", "UnionTypeDefinition", "ScalarTypeDefinition"]);
function W4(e, t, n) {
  if (!t) return !1;
  switch (e.parser) {
    case "flow":
    case "babel":
    case "babel-flow":
    case "babel-ts":
    case "typescript":
    case "acorn":
    case "espree":
    case "meriyah":
    case "__babel_estree":
      return lpt(t.type, n == null ? void 0 : n.type);
    case "json":
    case "json5":
    case "jsonc":
    case "json-stringify":
      return JJ.has(t.type);
    case "graphql":
      return upt.has(t.kind);
    case "vue":
      return t.tag !== "root";
  }
  return !1;
}
function cpt(e, t, n) {
  let { rangeStart: r, rangeEnd: i, locStart: o, locEnd: s } = t;
  gO.ok(i > r);
  let a = e.slice(r, i).search(/\S/u), u = a === -1;
  if (!u) for (r += a; i > r && !/\S/u.test(e[i - 1]); --i) ;
  let c = bO(n, r, t, (m, v) => W4(t, m, v), [], "rangeStart"), d = u ? c : bO(n, i, t, (m) => W4(t, m), [], "rangeEnd");
  if (!c || !d) return { rangeStart: 0, rangeEnd: 0 };
  let f, h;
  if (opt(t)) {
    let m = spt(c, d);
    f = m, h = m;
  } else ({ startNode: f, endNode: h } = apt(c, d, t));
  return { rangeStart: Math.min(o(f), o(h)), rangeEnd: Math.max(s(f), s(h)) };
}
var XJ = "\uFEFF", H4 = Symbol("cursor");
async function QJ(e, t, n = 0) {
  if (!e || e.trim().length === 0) return { formatted: "", cursorOffset: -1, comments: [] };
  let { ast: r, text: i } = await Sv(e, t);
  t.cursorOffset >= 0 && (t.cursorNode = ept(r, t));
  let o = await AT(r, t);
  n > 0 && (o = AJ([Vp, o], n, t.tabWidth));
  let s = TT(o, t);
  if (n > 0) {
    let u = s.formatted.trim();
    s.cursorNodeStart !== void 0 && (s.cursorNodeStart -= s.formatted.indexOf(u)), s.formatted = u + hN(t.endOfLine);
  }
  let a = t[Symbol.for("comments")];
  if (t.cursorOffset >= 0) {
    let u, c, d, f, h;
    if (t.cursorNode && s.cursorNodeText ? (u = t.locStart(t.cursorNode), c = i.slice(u, t.locEnd(t.cursorNode)), d = t.cursorOffset - u, f = s.cursorNodeStart, h = s.cursorNodeText) : (u = 0, c = i, d = t.cursorOffset, f = 0, h = s.formatted), c === h) return { formatted: s.formatted, cursorOffset: f + d, comments: a };
    let m = c.split("");
    m.splice(d, 0, H4);
    let v = h.split(""), x = Jut(m, v), C = f;
    for (let E of x) if (E.removed) {
      if (E.value.includes(H4)) break;
    } else C += E.count;
    return { formatted: s.formatted, cursorOffset: C, comments: a };
  }
  return { formatted: s.formatted, cursorOffset: -1, comments: a };
}
async function dpt(e, t) {
  let { ast: n, text: r } = await Sv(e, t), { rangeStart: i, rangeEnd: o } = cpt(r, t, n), s = r.slice(i, o), a = Math.min(i, r.lastIndexOf(`
`, i) + 1), u = r.slice(a, i).match(/^\s*/u)[0], c = vN(u, t.tabWidth), d = await QJ(s, { ...t, rangeStart: 0, rangeEnd: Number.POSITIVE_INFINITY, cursorOffset: t.cursorOffset > i && t.cursorOffset <= o ? t.cursorOffset - i : -1, endOfLine: "lf" }, c), f = d.formatted.trimEnd(), { cursorOffset: h } = t;
  h > o ? h += f.length - s.length : d.cursorOffset >= 0 && (h = d.cursorOffset + i);
  let m = r.slice(0, i) + f + r.slice(o);
  if (t.endOfLine !== "lf") {
    let v = hN(t.endOfLine);
    h >= 0 && v === `\r
` && (h += bJ(m.slice(0, h), `
`)), m = DT(!1, m, `
`, v);
  }
  return { formatted: m, cursorOffset: h, comments: d.comments };
}
function Zw(e, t, n) {
  return typeof t != "number" || Number.isNaN(t) || t < 0 || t > e.length ? n : t;
}
function q4(e, t) {
  let { cursorOffset: n, rangeStart: r, rangeEnd: i } = t;
  return n = Zw(e, n, -1), r = Zw(e, r, 0), i = Zw(e, i, e.length), { ...t, cursorOffset: n, rangeStart: r, rangeEnd: i };
}
function ZJ(e, t) {
  let { cursorOffset: n, rangeStart: r, rangeEnd: i, endOfLine: o } = q4(e, t), s = e.charAt(0) === XJ;
  if (s && (e = e.slice(1), n--, r--, i--), o === "auto" && (o = Xut(e)), e.includes("\r")) {
    let a = (u) => bJ(e.slice(0, Math.max(u, 0)), `\r
`);
    n -= a(n), r -= a(r), i -= a(i), e = Qut(e);
  }
  return { hasBOM: s, text: e, options: q4(e, { ...t, cursorOffset: n, rangeStart: r, rangeEnd: i, endOfLine: o }) };
}
async function G4(e, t) {
  let n = await GJ(t);
  return !n.hasPragma || n.hasPragma(e);
}
async function eX(e, t) {
  let { hasBOM: n, text: r, options: i } = ZJ(e, await Sg(t));
  if (i.rangeStart >= i.rangeEnd && r !== "" || i.requirePragma && !await G4(r, i)) return { formatted: e, cursorOffset: t.cursorOffset, comments: [] };
  let o;
  return i.rangeStart > 0 || i.rangeEnd < r.length ? o = await dpt(r, i) : (!i.requirePragma && i.insertPragma && i.printer.insertPragma && !await G4(r, i) && (r = i.printer.insertPragma(r)), o = await QJ(r, i)), n && (o.formatted = XJ + o.formatted, o.cursorOffset >= 0 && o.cursorOffset++), o;
}
async function ppt(e, t, n) {
  let { text: r, options: i } = ZJ(e, await Sg(t)), o = await Sv(r, i);
  return n && (n.preprocessForPrint && (o.ast = await KJ(o.ast, i)), n.massage && (o.ast = npt(o.ast, i))), o;
}
async function fpt(e, t) {
  t = await Sg(t);
  let n = await AT(e, t);
  return TT(n, t);
}
async function hpt(e, t) {
  let n = gct(e), { formatted: r } = await eX(n, { ...t, parser: "__js_expression" });
  return r;
}
async function mpt(e, t) {
  t = await Sg(t);
  let { ast: n } = await Sv(e, t);
  return AT(n, t);
}
async function gpt(e, t) {
  return TT(e, await Sg(t));
}
var tX = {};
vT(tX, { builders: () => ypt, printer: () => bpt, utils: () => vpt });
var ypt = { join: SJ, line: EJ, softline: hct, hardline: Vp, literalline: TJ, group: xJ, conditionalGroup: uct, fill: DJ, lineSuffix: dO, lineSuffixBoundary: pct, cursor: pO, breakParent: CT, ifBreak: cct, trim: fct, indent: $C, indentIfBreak: dct, align: Om, addAlignmentToDoc: AJ, markAsRoot: act, dedentToRoot: sct, dedent: lct, hardlineWithoutBreakParent: gN, literallineWithoutBreakParent: CJ, label: mct, concat: (e) => e }, bpt = { printDocToString: TT }, vpt = { willBreak: Sct, traverseDoc: mN, findInDoc: bN, mapDoc: ET, removeLines: Pct, stripTrailingHardline: wJ, replaceEndOfLine: Ict, canBreak: $ct }, xpt = "3.3.3", nX = {};
vT(nX, { addDanglingComment: () => bp, addLeadingComment: () => Bh, addTrailingComment: () => jh, getAlignmentSize: () => vN, getIndentSize: () => Apt, getMaxContinuousCount: () => kpt, getNextNonSpaceNonCommentCharacter: () => Ipt, getNextNonSpaceNonCommentCharacterIndex: () => Bpt, getStringWidth: () => yN, hasNewline: () => cd, hasNewlineInRange: () => $pt, hasSpaces: () => Mpt, isNextLineEmpty: () => Upt, isNextLineEmptyAfterIndex: () => AN, isPreviousLineEmpty: () => Vpt, makeString: () => _pt, skip: () => Tv, skipEverythingButNewLine: () => $J, skipInlineComment: () => EN, skipNewline: () => rf, skipSpaces: () => bd, skipToLineEnd: () => FJ, skipTrailingComment: () => TN, skipWhitespace: () => zct });
function Dpt(e, t) {
  if (t === !1) return !1;
  if (e.charAt(t) === "/" && e.charAt(t + 1) === "*") {
    for (let n = t + 2; n < e.length; ++n) if (e.charAt(n) === "*" && e.charAt(n + 1) === "/") return n + 2;
  }
  return t;
}
var EN = Dpt;
function Cpt(e, t) {
  return t === !1 ? !1 : e.charAt(t) === "/" && e.charAt(t + 1) === "/" ? $J(e, t) : t;
}
var TN = Cpt;
function Ept(e, t) {
  let n = null, r = t;
  for (; r !== n; ) n = r, r = bd(e, r), r = EN(e, r), r = TN(e, r), r = rf(e, r);
  return r;
}
var SN = Ept;
function Tpt(e, t) {
  let n = null, r = t;
  for (; r !== n; ) n = r, r = FJ(e, r), r = EN(e, r), r = bd(e, r);
  return r = TN(e, r), r = rf(e, r), r !== !1 && cd(e, r);
}
var AN = Tpt;
function Spt(e, t) {
  let n = e.lastIndexOf(`
`);
  return n === -1 ? 0 : vN(e.slice(n + 1).match(/^[\t ]*/u)[0], t);
}
var Apt = Spt;
function wpt(e) {
  if (typeof e != "string") throw new TypeError("Expected a string");
  return e.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
}
function Ppt(e, t) {
  let n = e.match(new RegExp(`(${wpt(t)})+`, "gu"));
  return n === null ? 0 : n.reduce((r, i) => Math.max(r, i.length / t.length), 0);
}
var kpt = Ppt;
function Opt(e, t) {
  let n = SN(e, t);
  return n === !1 ? "" : e.charAt(n);
}
var Ipt = Opt;
function Fpt(e, t, n) {
  for (let r = t; r < n; ++r) if (e.charAt(r) === `
`) return !0;
  return !1;
}
var $pt = Fpt;
function Npt(e, t, n = {}) {
  return bd(e, n.backwards ? t - 1 : t, n) !== t;
}
var Mpt = Npt;
function Rpt(e, t, n) {
  let r = t === '"' ? "'" : '"', i = DT(!1, e, /\\(.)|(["'])/gsu, (o, s, a) => s === r ? s : a === t ? "\\" + a : a || (n && /^[^\n\r"'0-7\\bfnrt-vx\u2028\u2029]$/u.test(s) ? s : "\\" + s));
  return t + i + t;
}
var _pt = Rpt;
function Lpt(e, t, n) {
  return SN(e, n(t));
}
function Bpt(e, t) {
  return arguments.length === 2 || typeof t == "number" ? SN(e, t) : Lpt(...arguments);
}
function jpt(e, t, n) {
  return CN(e, n(t));
}
function Vpt(e, t) {
  return arguments.length === 2 || typeof t == "number" ? CN(e, t) : jpt(...arguments);
}
function zpt(e, t, n) {
  return AN(e, n(t));
}
function Upt(e, t) {
  return arguments.length === 2 || typeof t == "number" ? AN(e, t) : zpt(...arguments);
}
function wp(e, t = 1) {
  return async (...n) => {
    let r = n[t] ?? {}, i = r.plugins ?? [];
    return n[t] = { ...r, plugins: Array.isArray(i) ? i : Object.values(i) }, e(...n);
  };
}
var rX = wp(eX);
async function wN(e, t) {
  let { formatted: n } = await rX(e, { ...t, cursorOffset: -1 });
  return n;
}
async function Wpt(e, t) {
  return await wN(e, t) === e;
}
var Hpt = wp(BJ, 0), qpt = { parse: wp(ppt), formatAST: wp(fpt), formatDoc: wp(hpt), printToDoc: wp(mpt), printDocToString: wp(gpt) }, iX = { exports: {} };
(function(e, t) {
  (function(n) {
    function r() {
      var i = n();
      return i.default || i;
    }
    e.exports = r();
  })(function() {
    var n = Object.create, r = Object.defineProperty, i = Object.getOwnPropertyDescriptor, o = Object.getOwnPropertyNames, s = Object.getPrototypeOf, a = Object.prototype.hasOwnProperty, u = (Ce, Ve) => () => (Ve || Ce((Ve = { exports: {} }).exports, Ve), Ve.exports), c = (Ce, Ve) => {
      for (var pt in Ve) r(Ce, pt, { get: Ve[pt], enumerable: !0 });
    }, d = (Ce, Ve, pt, bt) => {
      if (Ve && typeof Ve == "object" || typeof Ve == "function") for (let dt of o(Ve)) !a.call(Ce, dt) && dt !== pt && r(Ce, dt, { get: () => Ve[dt], enumerable: !(bt = i(Ve, dt)) || bt.enumerable });
      return Ce;
    }, f = (Ce, Ve, pt) => (pt = Ce != null ? n(s(Ce)) : {}, d(r(pt, "default", { value: Ce, enumerable: !0 }), Ce)), h = (Ce) => d(r({}, "__esModule", { value: !0 }), Ce), m = u((Ce) => {
      Object.defineProperty(Ce, "__esModule", { value: !0 });
      function Ve(y, p) {
        if (y == null) return {};
        var b = {}, T = Object.keys(y), F, Y;
        for (Y = 0; Y < T.length; Y++) F = T[Y], !(p.indexOf(F) >= 0) && (b[F] = y[F]);
        return b;
      }
      var pt = class {
        constructor(y, p, b) {
          this.line = void 0, this.column = void 0, this.index = void 0, this.line = y, this.column = p, this.index = b;
        }
      }, bt = class {
        constructor(y, p) {
          this.start = void 0, this.end = void 0, this.filename = void 0, this.identifierName = void 0, this.start = y, this.end = p;
        }
      };
      function dt(y, p) {
        let { line: b, column: T, index: F } = y;
        return new pt(b, T + p, F + p);
      }
      var on = "BABEL_PARSER_SOURCETYPE_MODULE_REQUIRED", nn = { ImportMetaOutsideModule: { message: `import.meta may appear only with 'sourceType: "module"'`, code: on }, ImportOutsideModule: { message: `'import' and 'export' may appear only with 'sourceType: "module"'`, code: on } }, ri = { ArrayPattern: "array destructuring pattern", AssignmentExpression: "assignment expression", AssignmentPattern: "assignment expression", ArrowFunctionExpression: "arrow function expression", ConditionalExpression: "conditional expression", CatchClause: "catch clause", ForOfStatement: "for-of statement", ForInStatement: "for-in statement", ForStatement: "for-loop", FormalParameters: "function parameter list", Identifier: "identifier", ImportSpecifier: "import specifier", ImportDefaultSpecifier: "import default specifier", ImportNamespaceSpecifier: "import namespace specifier", ObjectPattern: "object destructuring pattern", ParenthesizedExpression: "parenthesized expression", RestElement: "rest element", UpdateExpression: { true: "prefix operation", false: "postfix operation" }, VariableDeclarator: "variable declaration", YieldExpression: "yield expression" }, lo = (y) => y.type === "UpdateExpression" ? ri.UpdateExpression[`${y.prefix}`] : ri[y.type], Vf = { AccessorIsGenerator: ({ kind: y }) => `A ${y}ter cannot be a generator.`, ArgumentsInClass: "'arguments' is only allowed in functions and class methods.", AsyncFunctionInSingleStatementContext: "Async functions can only be declared at the top level or inside a block.", AwaitBindingIdentifier: "Can not use 'await' as identifier inside an async function.", AwaitBindingIdentifierInStaticBlock: "Can not use 'await' as identifier inside a static block.", AwaitExpressionFormalParameter: "'await' is not allowed in async function parameters.", AwaitUsingNotInAsyncContext: "'await using' is only allowed within async functions and at the top levels of modules.", AwaitNotInAsyncContext: "'await' is only allowed within async functions and at the top levels of modules.", AwaitNotInAsyncFunction: "'await' is only allowed within async functions.", BadGetterArity: "A 'get' accessor must not have any formal parameters.", BadSetterArity: "A 'set' accessor must have exactly one formal parameter.", BadSetterRestParameter: "A 'set' accessor function argument must not be a rest parameter.", ConstructorClassField: "Classes may not have a field named 'constructor'.", ConstructorClassPrivateField: "Classes may not have a private field named '#constructor'.", ConstructorIsAccessor: "Class constructor may not be an accessor.", ConstructorIsAsync: "Constructor can't be an async function.", ConstructorIsGenerator: "Constructor can't be a generator.", DeclarationMissingInitializer: ({ kind: y }) => `Missing initializer in ${y} declaration.`, DecoratorArgumentsOutsideParentheses: "Decorator arguments must be moved inside parentheses: use '@(decorator(args))' instead of '@(decorator)(args)'.", DecoratorBeforeExport: "Decorators must be placed *before* the 'export' keyword. Remove the 'decoratorsBeforeExport: true' option to use the 'export @decorator class {}' syntax.", DecoratorsBeforeAfterExport: "Decorators can be placed *either* before or after the 'export' keyword, but not in both locations at the same time.", DecoratorConstructor: "Decorators can't be used with a constructor. Did you mean '@dec class { ... }'?", DecoratorExportClass: "Decorators must be placed *after* the 'export' keyword. Remove the 'decoratorsBeforeExport: false' option to use the '@decorator export class {}' syntax.", DecoratorSemicolon: "Decorators must not be followed by a semicolon.", DecoratorStaticBlock: "Decorators can't be used with a static block.", DeferImportRequiresNamespace: 'Only `import defer * as x from "./module"` is valid.', DeletePrivateField: "Deleting a private field is not allowed.", DestructureNamedImport: "ES2015 named imports do not destructure. Use another statement for destructuring after the import.", DuplicateConstructor: "Duplicate constructor in the same class.", DuplicateDefaultExport: "Only one default export allowed per module.", DuplicateExport: ({ exportName: y }) => `\`${y}\` has already been exported. Exported identifiers must be unique.`, DuplicateProto: "Redefinition of __proto__ property.", DuplicateRegExpFlags: "Duplicate regular expression flag.", DynamicImportPhaseRequiresImportExpressions: ({ phase: y }) => `'import.${y}(...)' can only be parsed when using the 'createImportExpressions' option.`, ElementAfterRest: "Rest element must be last element.", EscapedCharNotAnIdentifier: "Invalid Unicode escape.", ExportBindingIsString: ({ localName: y, exportName: p }) => `A string literal cannot be used as an exported binding without \`from\`.
- Did you mean \`export { '${y}' as '${p}' } from 'some-module'\`?`, ExportDefaultFromAsIdentifier: "'from' is not allowed as an identifier after 'export default'.", ForInOfLoopInitializer: ({ type: y }) => `'${y === "ForInStatement" ? "for-in" : "for-of"}' loop variable declaration may not have an initializer.`, ForInUsing: "For-in loop may not start with 'using' declaration.", ForOfAsync: "The left-hand side of a for-of loop may not be 'async'.", ForOfLet: "The left-hand side of a for-of loop may not start with 'let'.", GeneratorInSingleStatementContext: "Generators can only be declared at the top level or inside a block.", IllegalBreakContinue: ({ type: y }) => `Unsyntactic ${y === "BreakStatement" ? "break" : "continue"}.`, IllegalLanguageModeDirective: "Illegal 'use strict' directive in function with non-simple parameter list.", IllegalReturn: "'return' outside of function.", ImportAttributesUseAssert: "The `assert` keyword in import attributes is deprecated and it has been replaced by the `with` keyword. You can enable the `deprecatedAssertSyntax: true` option in the import attributes plugin to suppress this error.", ImportBindingIsString: ({ importName: y }) => `A string literal cannot be used as an imported binding.
- Did you mean \`import { "${y}" as foo }\`?`, ImportCallArgumentTrailingComma: "Trailing comma is disallowed inside import(...) arguments.", ImportCallArity: ({ maxArgumentCount: y }) => `\`import()\` requires exactly ${y === 1 ? "one argument" : "one or two arguments"}.`, ImportCallNotNewExpression: "Cannot use new with import(...).", ImportCallSpreadArgument: "`...` is not allowed in `import()`.", ImportJSONBindingNotDefault: "A JSON module can only be imported with `default`.", ImportReflectionHasAssertion: "`import module x` cannot have assertions.", ImportReflectionNotBinding: 'Only `import module x from "./module"` is valid.', IncompatibleRegExpUVFlags: "The 'u' and 'v' regular expression flags cannot be enabled at the same time.", InvalidBigIntLiteral: "Invalid BigIntLiteral.", InvalidCodePoint: "Code point out of bounds.", InvalidCoverInitializedName: "Invalid shorthand property initializer.", InvalidDecimal: "Invalid decimal.", InvalidDigit: ({ radix: y }) => `Expected number in radix ${y}.`, InvalidEscapeSequence: "Bad character escape sequence.", InvalidEscapeSequenceTemplate: "Invalid escape sequence in template.", InvalidEscapedReservedWord: ({ reservedWord: y }) => `Escape sequence in keyword ${y}.`, InvalidIdentifier: ({ identifierName: y }) => `Invalid identifier ${y}.`, InvalidLhs: ({ ancestor: y }) => `Invalid left-hand side in ${lo(y)}.`, InvalidLhsBinding: ({ ancestor: y }) => `Binding invalid left-hand side in ${lo(y)}.`, InvalidLhsOptionalChaining: ({ ancestor: y }) => `Invalid optional chaining in the left-hand side of ${lo(y)}.`, InvalidNumber: "Invalid number.", InvalidOrMissingExponent: "Floating-point numbers require a valid exponent after the 'e'.", InvalidOrUnexpectedToken: ({ unexpected: y }) => `Unexpected character '${y}'.`, InvalidParenthesizedAssignment: "Invalid parenthesized assignment pattern.", InvalidPrivateFieldResolution: ({ identifierName: y }) => `Private name #${y} is not defined.`, InvalidPropertyBindingPattern: "Binding member expression.", InvalidRecordProperty: "Only properties and spread elements are allowed in record definitions.", InvalidRestAssignmentPattern: "Invalid rest operator's argument.", LabelRedeclaration: ({ labelName: y }) => `Label '${y}' is already declared.`, LetInLexicalBinding: "'let' is disallowed as a lexically bound name.", LineTerminatorBeforeArrow: "No line break is allowed before '=>'.", MalformedRegExpFlags: "Invalid regular expression flag.", MissingClassName: "A class name is required.", MissingEqInAssignment: "Only '=' operator can be used for specifying default value.", MissingSemicolon: "Missing semicolon.", MissingPlugin: ({ missingPlugin: y }) => `This experimental syntax requires enabling the parser plugin: ${y.map((p) => JSON.stringify(p)).join(", ")}.`, MissingOneOfPlugins: ({ missingPlugin: y }) => `This experimental syntax requires enabling one of the following parser plugin(s): ${y.map((p) => JSON.stringify(p)).join(", ")}.`, MissingUnicodeEscape: "Expecting Unicode escape sequence \\uXXXX.", MixingCoalesceWithLogical: "Nullish coalescing operator(??) requires parens when mixing with logical operators.", ModuleAttributeDifferentFromType: "The only accepted module attribute is `type`.", ModuleAttributeInvalidValue: "Only string literals are allowed as module attribute values.", ModuleAttributesWithDuplicateKeys: ({ key: y }) => `Duplicate key "${y}" is not allowed in module attributes.`, ModuleExportNameHasLoneSurrogate: ({ surrogateCharCode: y }) => `An export name cannot include a lone surrogate, found '\\u${y.toString(16)}'.`, ModuleExportUndefined: ({ localName: y }) => `Export '${y}' is not defined.`, MultipleDefaultsInSwitch: "Multiple default clauses.", NewlineAfterThrow: "Illegal newline after throw.", NoCatchOrFinally: "Missing catch or finally clause.", NumberIdentifier: "Identifier directly after number.", NumericSeparatorInEscapeSequence: "Numeric separators are not allowed inside unicode escape sequences or hex escape sequences.", ObsoleteAwaitStar: "'await*' has been removed from the async functions proposal. Use Promise.all() instead.", OptionalChainingNoNew: "Constructors in/after an Optional Chain are not allowed.", OptionalChainingNoTemplate: "Tagged Template Literals are not allowed in optionalChain.", OverrideOnConstructor: "'override' modifier cannot appear on a constructor declaration.", ParamDupe: "Argument name clash.", PatternHasAccessor: "Object pattern can't contain getter or setter.", PatternHasMethod: "Object pattern can't contain methods.", PrivateInExpectedIn: ({ identifierName: y }) => `Private names are only allowed in property accesses (\`obj.#${y}\`) or in \`in\` expressions (\`#${y} in obj\`).`, PrivateNameRedeclaration: ({ identifierName: y }) => `Duplicate private name #${y}.`, RecordExpressionBarIncorrectEndSyntaxType: "Record expressions ending with '|}' are only allowed when the 'syntaxType' option of the 'recordAndTuple' plugin is set to 'bar'.", RecordExpressionBarIncorrectStartSyntaxType: "Record expressions starting with '{|' are only allowed when the 'syntaxType' option of the 'recordAndTuple' plugin is set to 'bar'.", RecordExpressionHashIncorrectStartSyntaxType: "Record expressions starting with '#{' are only allowed when the 'syntaxType' option of the 'recordAndTuple' plugin is set to 'hash'.", RecordNoProto: "'__proto__' is not allowed in Record expressions.", RestTrailingComma: "Unexpected trailing comma after rest element.", SloppyFunction: "In non-strict mode code, functions can only be declared at top level or inside a block.", SloppyFunctionAnnexB: "In non-strict mode code, functions can only be declared at top level, inside a block, or as the body of an if statement.", SourcePhaseImportRequiresDefault: 'Only `import source x from "./module"` is valid.', StaticPrototype: "Classes may not have static property named prototype.", SuperNotAllowed: "`super()` is only valid inside a class constructor of a subclass. Maybe a typo in the method name ('constructor') or not extending another class?", SuperPrivateField: "Private fields can't be accessed on super.", TrailingDecorator: "Decorators must be attached to a class element.", TupleExpressionBarIncorrectEndSyntaxType: "Tuple expressions ending with '|]' are only allowed when the 'syntaxType' option of the 'recordAndTuple' plugin is set to 'bar'.", TupleExpressionBarIncorrectStartSyntaxType: "Tuple expressions starting with '[|' are only allowed when the 'syntaxType' option of the 'recordAndTuple' plugin is set to 'bar'.", TupleExpressionHashIncorrectStartSyntaxType: "Tuple expressions starting with '#[' are only allowed when the 'syntaxType' option of the 'recordAndTuple' plugin is set to 'hash'.", UnexpectedArgumentPlaceholder: "Unexpected argument placeholder.", UnexpectedAwaitAfterPipelineBody: 'Unexpected "await" after pipeline body; await must have parentheses in minimal proposal.', UnexpectedDigitAfterHash: "Unexpected digit after hash token.", UnexpectedImportExport: "'import' and 'export' may only appear at the top level.", UnexpectedKeyword: ({ keyword: y }) => `Unexpected keyword '${y}'.`, UnexpectedLeadingDecorator: "Leading decorators must be attached to a class declaration.", UnexpectedLexicalDeclaration: "Lexical declaration cannot appear in a single-statement context.", UnexpectedNewTarget: "`new.target` can only be used in functions or class properties.", UnexpectedNumericSeparator: "A numeric separator is only allowed between two digits.", UnexpectedPrivateField: "Unexpected private name.", UnexpectedReservedWord: ({ reservedWord: y }) => `Unexpected reserved word '${y}'.`, UnexpectedSuper: "'super' is only allowed in object methods and classes.", UnexpectedToken: ({ expected: y, unexpected: p }) => `Unexpected token${p ? ` '${p}'.` : ""}${y ? `, expected "${y}"` : ""}`, UnexpectedTokenUnaryExponentiation: "Illegal expression. Wrap left hand side or entire exponentiation in parentheses.", UnexpectedUsingDeclaration: "Using declaration cannot appear in the top level when source type is `script`.", UnsupportedBind: "Binding should be performed on object property.", UnsupportedDecoratorExport: "A decorated export must export a class declaration.", UnsupportedDefaultExport: "Only expressions, functions or classes are allowed as the `default` export.", UnsupportedImport: "`import` can only be used in `import()` or `import.meta`.", UnsupportedMetaProperty: ({ target: y, onlyValidPropertyName: p }) => `The only valid meta property for ${y} is ${y}.${p}.`, UnsupportedParameterDecorator: "Decorators cannot be used to decorate parameters.", UnsupportedPropertyDecorator: "Decorators cannot be used to decorate object literal properties.", UnsupportedSuper: "'super' can only be used with function calls (i.e. super()) or in property accesses (i.e. super.prop or super[prop]).", UnterminatedComment: "Unterminated comment.", UnterminatedRegExp: "Unterminated regular expression.", UnterminatedString: "Unterminated string constant.", UnterminatedTemplate: "Unterminated template.", UsingDeclarationExport: "Using declaration cannot be exported.", UsingDeclarationHasBindingPattern: "Using declaration cannot have destructuring patterns.", VarRedeclaration: ({ identifierName: y }) => `Identifier '${y}' has already been declared.`, YieldBindingIdentifier: "Can not use 'yield' as identifier inside a generator.", YieldInParameter: "Yield expression is not allowed in formal parameters.", ZeroDigitNumericSeparator: "Numeric separator can not be used after leading 0." }, Ng = { StrictDelete: "Deleting local variable in strict mode.", StrictEvalArguments: ({ referenceName: y }) => `Assigning to '${y}' in strict mode.`, StrictEvalArgumentsBinding: ({ bindingName: y }) => `Binding '${y}' in strict mode.`, StrictFunction: "In strict mode code, functions can only be declared at top level or inside a block.", StrictNumericEscape: "The only valid numeric escape in strict mode is '\\0'.", StrictOctalLiteral: "Legacy octal literals are not allowed in strict mode.", StrictWith: "'with' in strict mode." }, LT = /* @__PURE__ */ new Set(["ArrowFunctionExpression", "AssignmentExpression", "ConditionalExpression", "YieldExpression"]), Ov = { PipeBodyIsTighter: "Unexpected yield after pipeline body; any yield expression acting as Hack-style pipe body must be parenthesized due to its loose operator precedence.", PipeTopicRequiresHackPipes: 'Topic reference is used, but the pipelineOperator plugin was not passed a "proposal": "hack" or "smart" option.', PipeTopicUnbound: "Topic reference is unbound; it must be inside a pipe body.", PipeTopicUnconfiguredToken: ({ token: y }) => `Invalid topic token ${y}. In order to use ${y} as a topic reference, the pipelineOperator plugin must be configured with { "proposal": "hack", "topicToken": "${y}" }.`, PipeTopicUnused: "Hack-style pipe body does not contain a topic reference; Hack-style pipes must use topic at least once.", PipeUnparenthesizedBody: ({ type: y }) => `Hack-style pipe body cannot be an unparenthesized ${lo({ type: y })}; please wrap it in parentheses.`, PipelineBodyNoArrow: 'Unexpected arrow "=>" after pipeline body; arrow function in pipeline body must be parenthesized.', PipelineBodySequenceExpression: "Pipeline body may not be a comma-separated sequence expression.", PipelineHeadSequenceExpression: "Pipeline head should not be a comma-separated sequence expression.", PipelineTopicUnused: "Pipeline is in topic style but does not use topic reference.", PrimaryTopicNotAllowed: "Topic reference was used in a lexical context without topic binding.", PrimaryTopicRequiresSmartPipeline: 'Topic reference is used, but the pipelineOperator plugin was not passed a "proposal": "hack" or "smart" option.' }, zf = ["toMessage"], Iv = ["message"];
      function Fv(y, p, b) {
        Object.defineProperty(y, p, { enumerable: !1, configurable: !0, value: b });
      }
      function $v(y) {
        let { toMessage: p } = y, b = Ve(y, zf);
        return function T(F, Y) {
          let ie = new SyntaxError();
          return Object.assign(ie, b, { loc: F, pos: F.index }), "missingPlugin" in Y && Object.assign(ie, { missingPlugin: Y.missingPlugin }), Fv(ie, "clone", function(de = {}) {
            var he;
            let { line: fe, column: Ze, index: Dt } = (he = de.loc) != null ? he : F;
            return T(new pt(fe, Ze, Dt), Object.assign({}, Y, de.details));
          }), Fv(ie, "details", Y), Object.defineProperty(ie, "message", { configurable: !0, get() {
            let de = `${p(Y)} (${F.line}:${F.column})`;
            return this.message = de, de;
          }, set(de) {
            Object.defineProperty(this, "message", { value: de, writable: !0 });
          } }), ie;
        };
      }
      function ga(y, p) {
        if (Array.isArray(y)) return (T) => ga(T, y[0]);
        let b = {};
        for (let T of Object.keys(y)) {
          let F = y[T], Y = typeof F == "string" ? { message: () => F } : typeof F == "function" ? { message: F } : F, { message: ie } = Y, de = Ve(Y, Iv), he = typeof ie == "string" ? () => ie : ie;
          b[T] = $v(Object.assign({ code: "BABEL_PARSER_SYNTAX_ERROR", reasonCode: T, toMessage: he }, p ? { syntaxPlugin: p } : {}, de));
        }
        return b;
      }
      var Se = Object.assign({}, ga(nn), ga(Vf), ga(Ng), ga`pipelineOperator`(Ov)), { defineProperty: BT } = Object, Mg = (y, p) => {
        y && BT(y, p, { enumerable: !1, value: y[p] });
      };
      function Iu(y) {
        return Mg(y.loc.start, "index"), Mg(y.loc.end, "index"), y;
      }
      var Rg = (y) => class extends y {
        parse() {
          let p = Iu(super.parse());
          return this.options.tokens && (p.tokens = p.tokens.map(Iu)), p;
        }
        parseRegExpLiteral({ pattern: p, flags: b }) {
          let T = null;
          try {
            T = new RegExp(p, b);
          } catch {
          }
          let F = this.estreeParseLiteral(T);
          return F.regex = { pattern: p, flags: b }, F;
        }
        parseBigIntLiteral(p) {
          let b;
          try {
            b = BigInt(p);
          } catch {
            b = null;
          }
          let T = this.estreeParseLiteral(b);
          return T.bigint = String(T.value || p), T;
        }
        parseDecimalLiteral(p) {
          let b = this.estreeParseLiteral(null);
          return b.decimal = String(b.value || p), b;
        }
        estreeParseLiteral(p) {
          return this.parseLiteral(p, "Literal");
        }
        parseStringLiteral(p) {
          return this.estreeParseLiteral(p);
        }
        parseNumericLiteral(p) {
          return this.estreeParseLiteral(p);
        }
        parseNullLiteral() {
          return this.estreeParseLiteral(null);
        }
        parseBooleanLiteral(p) {
          return this.estreeParseLiteral(p);
        }
        directiveToStmt(p) {
          let b = p.value;
          delete p.value, b.type = "Literal", b.raw = b.extra.raw, b.value = b.extra.expressionValue;
          let T = p;
          return T.type = "ExpressionStatement", T.expression = b, T.directive = b.extra.rawValue, delete b.extra, T;
        }
        initFunction(p, b) {
          super.initFunction(p, b), p.expression = !1;
        }
        checkDeclaration(p) {
          p != null && this.isObjectProperty(p) ? this.checkDeclaration(p.value) : super.checkDeclaration(p);
        }
        getObjectOrClassMethodParams(p) {
          return p.value.params;
        }
        isValidDirective(p) {
          var b;
          return p.type === "ExpressionStatement" && p.expression.type === "Literal" && typeof p.expression.value == "string" && !((b = p.expression.extra) != null && b.parenthesized);
        }
        parseBlockBody(p, b, T, F, Y) {
          super.parseBlockBody(p, b, T, F, Y);
          let ie = p.directives.map((de) => this.directiveToStmt(de));
          p.body = ie.concat(p.body), delete p.directives;
        }
        pushClassMethod(p, b, T, F, Y, ie) {
          this.parseMethod(b, T, F, Y, ie, "ClassMethod", !0), b.typeParameters && (b.value.typeParameters = b.typeParameters, delete b.typeParameters), p.body.push(b);
        }
        parsePrivateName() {
          let p = super.parsePrivateName();
          return this.getPluginOption("estree", "classFeatures") ? this.convertPrivateNameToPrivateIdentifier(p) : p;
        }
        convertPrivateNameToPrivateIdentifier(p) {
          let b = super.getPrivateNameSV(p);
          return p = p, delete p.id, p.name = b, p.type = "PrivateIdentifier", p;
        }
        isPrivateName(p) {
          return this.getPluginOption("estree", "classFeatures") ? p.type === "PrivateIdentifier" : super.isPrivateName(p);
        }
        getPrivateNameSV(p) {
          return this.getPluginOption("estree", "classFeatures") ? p.name : super.getPrivateNameSV(p);
        }
        parseLiteral(p, b) {
          let T = super.parseLiteral(p, b);
          return T.raw = T.extra.raw, delete T.extra, T;
        }
        parseFunctionBody(p, b, T = !1) {
          super.parseFunctionBody(p, b, T), p.expression = p.body.type !== "BlockStatement";
        }
        parseMethod(p, b, T, F, Y, ie, de = !1) {
          let he = this.startNode();
          return he.kind = p.kind, he = super.parseMethod(he, b, T, F, Y, ie, de), he.type = "FunctionExpression", delete he.kind, p.value = he, ie === "ClassPrivateMethod" && (p.computed = !1), this.finishNode(p, "MethodDefinition");
        }
        nameIsConstructor(p) {
          return p.type === "Literal" ? p.value === "constructor" : super.nameIsConstructor(p);
        }
        parseClassProperty(...p) {
          let b = super.parseClassProperty(...p);
          return this.getPluginOption("estree", "classFeatures") && (b.type = "PropertyDefinition"), b;
        }
        parseClassPrivateProperty(...p) {
          let b = super.parseClassPrivateProperty(...p);
          return this.getPluginOption("estree", "classFeatures") && (b.type = "PropertyDefinition", b.computed = !1), b;
        }
        parseObjectMethod(p, b, T, F, Y) {
          let ie = super.parseObjectMethod(p, b, T, F, Y);
          return ie && (ie.type = "Property", ie.kind === "method" && (ie.kind = "init"), ie.shorthand = !1), ie;
        }
        parseObjectProperty(p, b, T, F) {
          let Y = super.parseObjectProperty(p, b, T, F);
          return Y && (Y.kind = "init", Y.type = "Property"), Y;
        }
        isValidLVal(p, b, T) {
          return p === "Property" ? "value" : super.isValidLVal(p, b, T);
        }
        isAssignable(p, b) {
          return p != null && this.isObjectProperty(p) ? this.isAssignable(p.value, b) : super.isAssignable(p, b);
        }
        toAssignable(p, b = !1) {
          if (p != null && this.isObjectProperty(p)) {
            let { key: T, value: F } = p;
            this.isPrivateName(T) && this.classScope.usePrivateName(this.getPrivateNameSV(T), T.loc.start), this.toAssignable(F, b);
          } else super.toAssignable(p, b);
        }
        toAssignableObjectExpressionProp(p, b, T) {
          p.type === "Property" && (p.kind === "get" || p.kind === "set") ? this.raise(Se.PatternHasAccessor, p.key) : p.type === "Property" && p.method ? this.raise(Se.PatternHasMethod, p.key) : super.toAssignableObjectExpressionProp(p, b, T);
        }
        finishCallExpression(p, b) {
          let T = super.finishCallExpression(p, b);
          if (T.callee.type === "Import") {
            if (T.type = "ImportExpression", T.source = T.arguments[0], this.hasPlugin("importAttributes") || this.hasPlugin("importAssertions")) {
              var F, Y;
              T.options = (F = T.arguments[1]) != null ? F : null, T.attributes = (Y = T.arguments[1]) != null ? Y : null;
            }
            delete T.arguments, delete T.callee;
          }
          return T;
        }
        toReferencedArguments(p) {
          p.type !== "ImportExpression" && super.toReferencedArguments(p);
        }
        parseExport(p, b) {
          let T = this.state.lastTokStartLoc, F = super.parseExport(p, b);
          switch (F.type) {
            case "ExportAllDeclaration":
              F.exported = null;
              break;
            case "ExportNamedDeclaration":
              F.specifiers.length === 1 && F.specifiers[0].type === "ExportNamespaceSpecifier" && (F.type = "ExportAllDeclaration", F.exported = F.specifiers[0].exported, delete F.specifiers);
            case "ExportDefaultDeclaration":
              {
                var Y;
                let { declaration: ie } = F;
                (ie == null ? void 0 : ie.type) === "ClassDeclaration" && ((Y = ie.decorators) == null ? void 0 : Y.length) > 0 && ie.start === F.start && this.resetStartLocation(F, T);
              }
              break;
          }
          return F;
        }
        parseSubscript(p, b, T, F) {
          let Y = super.parseSubscript(p, b, T, F);
          if (F.optionalChainMember) {
            if ((Y.type === "OptionalMemberExpression" || Y.type === "OptionalCallExpression") && (Y.type = Y.type.substring(8)), F.stop) {
              let ie = this.startNodeAtNode(Y);
              return ie.expression = Y, this.finishNode(ie, "ChainExpression");
            }
          } else (Y.type === "MemberExpression" || Y.type === "CallExpression") && (Y.optional = !1);
          return Y;
        }
        isOptionalMemberExpression(p) {
          return p.type === "ChainExpression" ? p.expression.type === "MemberExpression" : super.isOptionalMemberExpression(p);
        }
        hasPropertyAsPrivateName(p) {
          return p.type === "ChainExpression" && (p = p.expression), super.hasPropertyAsPrivateName(p);
        }
        isObjectProperty(p) {
          return p.type === "Property" && p.kind === "init" && !p.method;
        }
        isObjectMethod(p) {
          return p.type === "Property" && (p.method || p.kind === "get" || p.kind === "set");
        }
        finishNodeAt(p, b, T) {
          return Iu(super.finishNodeAt(p, b, T));
        }
        resetStartLocation(p, b) {
          super.resetStartLocation(p, b), Iu(p);
        }
        resetEndLocation(p, b = this.state.lastTokEndLoc) {
          super.resetEndLocation(p, b), Iu(p);
        }
      }, ya = class {
        constructor(y, p) {
          this.token = void 0, this.preserveSpace = void 0, this.token = y, this.preserveSpace = !!p;
        }
      }, ar = { brace: new ya("{"), j_oTag: new ya("<tag"), j_cTag: new ya("</tag"), j_expr: new ya("<tag>...</tag>", !0) };
      ar.template = new ya("`", !0);
      var Tn = !0, Tt = !0, Uf = !0, Oc = !0, tl = !0, Nv = !0, Mv = class {
        constructor(y, p = {}) {
          this.label = void 0, this.keyword = void 0, this.beforeExpr = void 0, this.startsExpr = void 0, this.rightAssociative = void 0, this.isLoop = void 0, this.isAssign = void 0, this.prefix = void 0, this.postfix = void 0, this.binop = void 0, this.label = y, this.keyword = p.keyword, this.beforeExpr = !!p.beforeExpr, this.startsExpr = !!p.startsExpr, this.rightAssociative = !!p.rightAssociative, this.isLoop = !!p.isLoop, this.isAssign = !!p.isAssign, this.prefix = !!p.prefix, this.postfix = !!p.postfix, this.binop = p.binop != null ? p.binop : null, this.updateContext = null;
        }
      }, _g = /* @__PURE__ */ new Map();
      function zn(y, p = {}) {
        p.keyword = y;
        let b = Kt(y, p);
        return _g.set(y, b), b;
      }
      function Ji(y, p) {
        return Kt(y, { beforeExpr: Tn, binop: p });
      }
      var zd = -1, nl = [], Lg = [], Bg = [], Ud = [], jg = [], Vg = [];
      function Kt(y, p = {}) {
        var b, T, F, Y;
        return ++zd, Lg.push(y), Bg.push((b = p.binop) != null ? b : -1), Ud.push((T = p.beforeExpr) != null ? T : !1), jg.push((F = p.startsExpr) != null ? F : !1), Vg.push((Y = p.prefix) != null ? Y : !1), nl.push(new Mv(y, p)), zd;
      }
      function kn(y, p = {}) {
        var b, T, F, Y;
        return ++zd, _g.set(y, zd), Lg.push(y), Bg.push((b = p.binop) != null ? b : -1), Ud.push((T = p.beforeExpr) != null ? T : !1), jg.push((F = p.startsExpr) != null ? F : !1), Vg.push((Y = p.prefix) != null ? Y : !1), nl.push(new Mv("name", p)), zd;
      }
      var jT = { bracketL: Kt("[", { beforeExpr: Tn, startsExpr: Tt }), bracketHashL: Kt("#[", { beforeExpr: Tn, startsExpr: Tt }), bracketBarL: Kt("[|", { beforeExpr: Tn, startsExpr: Tt }), bracketR: Kt("]"), bracketBarR: Kt("|]"), braceL: Kt("{", { beforeExpr: Tn, startsExpr: Tt }), braceBarL: Kt("{|", { beforeExpr: Tn, startsExpr: Tt }), braceHashL: Kt("#{", { beforeExpr: Tn, startsExpr: Tt }), braceR: Kt("}"), braceBarR: Kt("|}"), parenL: Kt("(", { beforeExpr: Tn, startsExpr: Tt }), parenR: Kt(")"), comma: Kt(",", { beforeExpr: Tn }), semi: Kt(";", { beforeExpr: Tn }), colon: Kt(":", { beforeExpr: Tn }), doubleColon: Kt("::", { beforeExpr: Tn }), dot: Kt("."), question: Kt("?", { beforeExpr: Tn }), questionDot: Kt("?."), arrow: Kt("=>", { beforeExpr: Tn }), template: Kt("template"), ellipsis: Kt("...", { beforeExpr: Tn }), backQuote: Kt("`", { startsExpr: Tt }), dollarBraceL: Kt("${", { beforeExpr: Tn, startsExpr: Tt }), templateTail: Kt("...`", { startsExpr: Tt }), templateNonTail: Kt("...${", { beforeExpr: Tn, startsExpr: Tt }), at: Kt("@"), hash: Kt("#", { startsExpr: Tt }), interpreterDirective: Kt("#!..."), eq: Kt("=", { beforeExpr: Tn, isAssign: Oc }), assign: Kt("_=", { beforeExpr: Tn, isAssign: Oc }), slashAssign: Kt("_=", { beforeExpr: Tn, isAssign: Oc }), xorAssign: Kt("_=", { beforeExpr: Tn, isAssign: Oc }), moduloAssign: Kt("_=", { beforeExpr: Tn, isAssign: Oc }), incDec: Kt("++/--", { prefix: tl, postfix: Nv, startsExpr: Tt }), bang: Kt("!", { beforeExpr: Tn, prefix: tl, startsExpr: Tt }), tilde: Kt("~", { beforeExpr: Tn, prefix: tl, startsExpr: Tt }), doubleCaret: Kt("^^", { startsExpr: Tt }), doubleAt: Kt("@@", { startsExpr: Tt }), pipeline: Ji("|>", 0), nullishCoalescing: Ji("??", 1), logicalOR: Ji("||", 1), logicalAND: Ji("&&", 2), bitwiseOR: Ji("|", 3), bitwiseXOR: Ji("^", 4), bitwiseAND: Ji("&", 5), equality: Ji("==/!=/===/!==", 6), lt: Ji("</>/<=/>=", 7), gt: Ji("</>/<=/>=", 7), relational: Ji("</>/<=/>=", 7), bitShift: Ji("<</>>/>>>", 8), bitShiftL: Ji("<</>>/>>>", 8), bitShiftR: Ji("<</>>/>>>", 8), plusMin: Kt("+/-", { beforeExpr: Tn, binop: 9, prefix: tl, startsExpr: Tt }), modulo: Kt("%", { binop: 10, startsExpr: Tt }), star: Kt("*", { binop: 10 }), slash: Ji("/", 10), exponent: Kt("**", { beforeExpr: Tn, binop: 11, rightAssociative: !0 }), _in: zn("in", { beforeExpr: Tn, binop: 7 }), _instanceof: zn("instanceof", { beforeExpr: Tn, binop: 7 }), _break: zn("break"), _case: zn("case", { beforeExpr: Tn }), _catch: zn("catch"), _continue: zn("continue"), _debugger: zn("debugger"), _default: zn("default", { beforeExpr: Tn }), _else: zn("else", { beforeExpr: Tn }), _finally: zn("finally"), _function: zn("function", { startsExpr: Tt }), _if: zn("if"), _return: zn("return", { beforeExpr: Tn }), _switch: zn("switch"), _throw: zn("throw", { beforeExpr: Tn, prefix: tl, startsExpr: Tt }), _try: zn("try"), _var: zn("var"), _const: zn("const"), _with: zn("with"), _new: zn("new", { beforeExpr: Tn, startsExpr: Tt }), _this: zn("this", { startsExpr: Tt }), _super: zn("super", { startsExpr: Tt }), _class: zn("class", { startsExpr: Tt }), _extends: zn("extends", { beforeExpr: Tn }), _export: zn("export"), _import: zn("import", { startsExpr: Tt }), _null: zn("null", { startsExpr: Tt }), _true: zn("true", { startsExpr: Tt }), _false: zn("false", { startsExpr: Tt }), _typeof: zn("typeof", { beforeExpr: Tn, prefix: tl, startsExpr: Tt }), _void: zn("void", { beforeExpr: Tn, prefix: tl, startsExpr: Tt }), _delete: zn("delete", { beforeExpr: Tn, prefix: tl, startsExpr: Tt }), _do: zn("do", { isLoop: Uf, beforeExpr: Tn }), _for: zn("for", { isLoop: Uf }), _while: zn("while", { isLoop: Uf }), _as: kn("as", { startsExpr: Tt }), _assert: kn("assert", { startsExpr: Tt }), _async: kn("async", { startsExpr: Tt }), _await: kn("await", { startsExpr: Tt }), _defer: kn("defer", { startsExpr: Tt }), _from: kn("from", { startsExpr: Tt }), _get: kn("get", { startsExpr: Tt }), _let: kn("let", { startsExpr: Tt }), _meta: kn("meta", { startsExpr: Tt }), _of: kn("of", { startsExpr: Tt }), _sent: kn("sent", { startsExpr: Tt }), _set: kn("set", { startsExpr: Tt }), _source: kn("source", { startsExpr: Tt }), _static: kn("static", { startsExpr: Tt }), _using: kn("using", { startsExpr: Tt }), _yield: kn("yield", { startsExpr: Tt }), _asserts: kn("asserts", { startsExpr: Tt }), _checks: kn("checks", { startsExpr: Tt }), _exports: kn("exports", { startsExpr: Tt }), _global: kn("global", { startsExpr: Tt }), _implements: kn("implements", { startsExpr: Tt }), _intrinsic: kn("intrinsic", { startsExpr: Tt }), _infer: kn("infer", { startsExpr: Tt }), _is: kn("is", { startsExpr: Tt }), _mixins: kn("mixins", { startsExpr: Tt }), _proto: kn("proto", { startsExpr: Tt }), _require: kn("require", { startsExpr: Tt }), _satisfies: kn("satisfies", { startsExpr: Tt }), _keyof: kn("keyof", { startsExpr: Tt }), _readonly: kn("readonly", { startsExpr: Tt }), _unique: kn("unique", { startsExpr: Tt }), _abstract: kn("abstract", { startsExpr: Tt }), _declare: kn("declare", { startsExpr: Tt }), _enum: kn("enum", { startsExpr: Tt }), _module: kn("module", { startsExpr: Tt }), _namespace: kn("namespace", { startsExpr: Tt }), _interface: kn("interface", { startsExpr: Tt }), _type: kn("type", { startsExpr: Tt }), _opaque: kn("opaque", { startsExpr: Tt }), name: Kt("name", { startsExpr: Tt }), string: Kt("string", { startsExpr: Tt }), num: Kt("num", { startsExpr: Tt }), bigint: Kt("bigint", { startsExpr: Tt }), decimal: Kt("decimal", { startsExpr: Tt }), regexp: Kt("regexp", { startsExpr: Tt }), privateName: Kt("#name", { startsExpr: Tt }), eof: Kt("eof"), jsxName: Kt("jsxName"), jsxText: Kt("jsxText", { beforeExpr: !0 }), jsxTagStart: Kt("jsxTagStart", { startsExpr: !0 }), jsxTagEnd: Kt("jsxTagEnd"), placeholder: Kt("%%", { startsExpr: !0 }) };
      function Qt(y) {
        return y >= 93 && y <= 132;
      }
      function kr(y) {
        return y <= 92;
      }
      function Bs(y) {
        return y >= 58 && y <= 132;
      }
      function Rv(y) {
        return y >= 58 && y <= 136;
      }
      function VT(y) {
        return Ud[y];
      }
      function zg(y) {
        return jg[y];
      }
      function zT(y) {
        return y >= 29 && y <= 33;
      }
      function _v(y) {
        return y >= 129 && y <= 131;
      }
      function Lv(y) {
        return y >= 90 && y <= 92;
      }
      function Ug(y) {
        return y >= 58 && y <= 92;
      }
      function Ri(y) {
        return y >= 39 && y <= 59;
      }
      function Wg(y) {
        return y === 34;
      }
      function Fu(y) {
        return Vg[y];
      }
      function Bv(y) {
        return y >= 121 && y <= 123;
      }
      function Hg(y) {
        return y >= 124 && y <= 130;
      }
      function vi(y) {
        return Lg[y];
      }
      function Wd(y) {
        return Bg[y];
      }
      function jv(y) {
        return y === 57;
      }
      function Hd(y) {
        return y >= 24 && y <= 25;
      }
      function ba(y) {
        return nl[y];
      }
      nl[8].updateContext = (y) => {
        y.pop();
      }, nl[5].updateContext = nl[7].updateContext = nl[23].updateContext = (y) => {
        y.push(ar.brace);
      }, nl[22].updateContext = (y) => {
        y[y.length - 1] === ar.template ? y.pop() : y.push(ar.template);
      }, nl[142].updateContext = (y) => {
        y.push(ar.j_expr, ar.j_oTag);
      };
      var Wf = "ªµºÀ-ÖØ-öø-ˁˆ-ˑˠ-ˤˬˮͰ-ʹͶͷͺ-ͽͿΆΈ-ΊΌΎ-ΡΣ-ϵϷ-ҁҊ-ԯԱ-Ֆՙՠ-ֈא-תׯ-ײؠ-يٮٯٱ-ۓەۥۦۮۯۺ-ۼۿܐܒ-ܯݍ-ޥޱߊ-ߪߴߵߺࠀ-ࠕࠚࠤࠨࡀ-ࡘࡠ-ࡪࡰ-ࢇࢉ-ࢎࢠ-ࣉऄ-हऽॐक़-ॡॱ-ঀঅ-ঌএঐও-নপ-রলশ-হঽৎড়ঢ়য়-ৡৰৱৼਅ-ਊਏਐਓ-ਨਪ-ਰਲਲ਼ਵਸ਼ਸਹਖ਼-ੜਫ਼ੲ-ੴઅ-ઍએ-ઑઓ-નપ-રલળવ-હઽૐૠૡૹଅ-ଌଏଐଓ-ନପ-ରଲଳଵ-ହଽଡ଼ଢ଼ୟ-ୡୱஃஅ-ஊஎ-ஐஒ-கஙசஜஞடணதந-பம-ஹௐఅ-ఌఎ-ఐఒ-నప-హఽౘ-ౚౝౠౡಀಅ-ಌಎ-ಐಒ-ನಪ-ಳವ-ಹಽೝೞೠೡೱೲഄ-ഌഎ-ഐഒ-ഺഽൎൔ-ൖൟ-ൡൺ-ൿඅ-ඖක-නඳ-රලව-ෆก-ะาำเ-ๆກຂຄຆ-ຊຌ-ຣລວ-ະາຳຽເ-ໄໆໜ-ໟༀཀ-ཇཉ-ཬྈ-ྌက-ဪဿၐ-ၕၚ-ၝၡၥၦၮ-ၰၵ-ႁႎႠ-ჅჇჍა-ჺჼ-ቈቊ-ቍቐ-ቖቘቚ-ቝበ-ኈኊ-ኍነ-ኰኲ-ኵኸ-ኾዀዂ-ዅወ-ዖዘ-ጐጒ-ጕጘ-ፚᎀ-ᎏᎠ-Ᏽᏸ-ᏽᐁ-ᙬᙯ-ᙿᚁ-ᚚᚠ-ᛪᛮ-ᛸᜀ-ᜑᜟ-ᜱᝀ-ᝑᝠ-ᝬᝮ-ᝰក-ឳៗៜᠠ-ᡸᢀ-ᢨᢪᢰ-ᣵᤀ-ᤞᥐ-ᥭᥰ-ᥴᦀ-ᦫᦰ-ᧉᨀ-ᨖᨠ-ᩔᪧᬅ-ᬳᭅ-ᭌᮃ-ᮠᮮᮯᮺ-ᯥᰀ-ᰣᱍ-ᱏᱚ-ᱽᲀ-ᲈᲐ-ᲺᲽ-Ჿᳩ-ᳬᳮ-ᳳᳵᳶᳺᴀ-ᶿḀ-ἕἘ-Ἕἠ-ὅὈ-Ὅὐ-ὗὙὛὝὟ-ώᾀ-ᾴᾶ-ᾼιῂ-ῄῆ-ῌῐ-ΐῖ-Ίῠ-Ῥῲ-ῴῶ-ῼⁱⁿₐ-ₜℂℇℊ-ℓℕ℘-ℝℤΩℨK-ℹℼ-ℿⅅ-ⅉⅎⅠ-ↈⰀ-ⳤⳫ-ⳮⳲⳳⴀ-ⴥⴧⴭⴰ-ⵧⵯⶀ-ⶖⶠ-ⶦⶨ-ⶮⶰ-ⶶⶸ-ⶾⷀ-ⷆⷈ-ⷎⷐ-ⷖⷘ-ⷞ々-〇〡-〩〱-〵〸-〼ぁ-ゖ゛-ゟァ-ヺー-ヿㄅ-ㄯㄱ-ㆎㆠ-ㆿㇰ-ㇿ㐀-䶿一-ꒌꓐ-ꓽꔀ-ꘌꘐ-ꘟꘪꘫꙀ-ꙮꙿ-ꚝꚠ-ꛯꜗ-ꜟꜢ-ꞈꞋ-ꟊꟐꟑꟓꟕ-ꟙꟲ-ꠁꠃ-ꠅꠇ-ꠊꠌ-ꠢꡀ-ꡳꢂ-ꢳꣲ-ꣷꣻꣽꣾꤊ-ꤥꤰ-ꥆꥠ-ꥼꦄ-ꦲꧏꧠ-ꧤꧦ-ꧯꧺ-ꧾꨀ-ꨨꩀ-ꩂꩄ-ꩋꩠ-ꩶꩺꩾ-ꪯꪱꪵꪶꪹ-ꪽꫀꫂꫛ-ꫝꫠ-ꫪꫲ-ꫴꬁ-ꬆꬉ-ꬎꬑ-ꬖꬠ-ꬦꬨ-ꬮꬰ-ꭚꭜ-ꭩꭰ-ꯢ가-힣ힰ-ퟆퟋ-ퟻ豈-舘並-龎ﬀ-ﬆﬓ-ﬗיִײַ-ﬨשׁ-זּטּ-לּמּנּסּףּפּצּ-ﮱﯓ-ﴽﵐ-ﶏﶒ-ﷇﷰ-ﷻﹰ-ﹴﹶ-ﻼＡ-Ｚａ-ｚｦ-ﾾￂ-ￇￊ-ￏￒ-ￗￚ-ￜ", qg = "‌‍·̀-ͯ·҃-֑҇-ׇֽֿׁׂׅׄؐ-ًؚ-٩ٰۖ-ۜ۟-۪ۤۧۨ-ۭ۰-۹ܑܰ-݊ަ-ް߀-߉߫-߽߳ࠖ-࠙ࠛ-ࠣࠥ-ࠧࠩ-࡙࠭-࡛࢘-࢟࣊-ࣣ࣡-ःऺ-़ा-ॏ॑-ॗॢॣ०-९ঁ-ঃ়া-ৄেৈো-্ৗৢৣ০-৯৾ਁ-ਃ਼ਾ-ੂੇੈੋ-੍ੑ੦-ੱੵઁ-ઃ઼ા-ૅે-ૉો-્ૢૣ૦-૯ૺ-૿ଁ-ଃ଼ା-ୄେୈୋ-୍୕-ୗୢୣ୦-୯ஂா-ூெ-ைொ-்ௗ௦-௯ఀ-ఄ఼ా-ౄె-ైొ-్ౕౖౢౣ౦-౯ಁ-ಃ಼ಾ-ೄೆ-ೈೊ-್ೕೖೢೣ೦-೯ೳഀ-ഃ഻഼ാ-ൄെ-ൈൊ-്ൗൢൣ൦-൯ඁ-ඃ්ා-ුූෘ-ෟ෦-෯ෲෳัิ-ฺ็-๎๐-๙ັິ-ຼ່-໎໐-໙༘༙༠-༩༹༵༷༾༿ཱ-྄྆྇ྍ-ྗྙ-ྼ࿆ါ-ှ၀-၉ၖ-ၙၞ-ၠၢ-ၤၧ-ၭၱ-ၴႂ-ႍႏ-ႝ፝-፟፩-፱ᜒ-᜕ᜲ-᜴ᝒᝓᝲᝳ឴-៓៝០-៩᠋-᠍᠏-᠙ᢩᤠ-ᤫᤰ-᤻᥆-᥏᧐-᧚ᨗ-ᨛᩕ-ᩞ᩠-᩿᩼-᪉᪐-᪙᪰-᪽ᪿ-ᫎᬀ-ᬄ᬴-᭄᭐-᭙᭫-᭳ᮀ-ᮂᮡ-ᮭ᮰-᮹᯦-᯳ᰤ-᰷᱀-᱉᱐-᱙᳐-᳔᳒-᳨᳭᳴᳷-᳹᷀-᷿‌‍‿⁀⁔⃐-⃥⃜⃡-⃰⳯-⵿⳱ⷠ-〪ⷿ-゙゚〯・꘠-꘩꙯ꙴ-꙽ꚞꚟ꛰꛱ꠂ꠆ꠋꠣ-ꠧ꠬ꢀꢁꢴ-ꣅ꣐-꣙꣠-꣱ꣿ-꤉ꤦ-꤭ꥇ-꥓ꦀ-ꦃ꦳-꧀꧐-꧙ꧥ꧰-꧹ꨩ-ꨶꩃꩌꩍ꩐-꩙ꩻ-ꩽꪰꪲ-ꪴꪷꪸꪾ꪿꫁ꫫ-ꫯꫵ꫶ꯣ-ꯪ꯬꯭꯰-꯹ﬞ︀-️︠-︯︳︴﹍-﹏０-９＿･", Wo = new RegExp("[" + Wf + "]"), UT = new RegExp("[" + Wf + qg + "]");
      Wf = qg = null;
      var Ho = [0, 11, 2, 25, 2, 18, 2, 1, 2, 14, 3, 13, 35, 122, 70, 52, 268, 28, 4, 48, 48, 31, 14, 29, 6, 37, 11, 29, 3, 35, 5, 7, 2, 4, 43, 157, 19, 35, 5, 35, 5, 39, 9, 51, 13, 10, 2, 14, 2, 6, 2, 1, 2, 10, 2, 14, 2, 6, 2, 1, 68, 310, 10, 21, 11, 7, 25, 5, 2, 41, 2, 8, 70, 5, 3, 0, 2, 43, 2, 1, 4, 0, 3, 22, 11, 22, 10, 30, 66, 18, 2, 1, 11, 21, 11, 25, 71, 55, 7, 1, 65, 0, 16, 3, 2, 2, 2, 28, 43, 28, 4, 28, 36, 7, 2, 27, 28, 53, 11, 21, 11, 18, 14, 17, 111, 72, 56, 50, 14, 50, 14, 35, 349, 41, 7, 1, 79, 28, 11, 0, 9, 21, 43, 17, 47, 20, 28, 22, 13, 52, 58, 1, 3, 0, 14, 44, 33, 24, 27, 35, 30, 0, 3, 0, 9, 34, 4, 0, 13, 47, 15, 3, 22, 0, 2, 0, 36, 17, 2, 24, 20, 1, 64, 6, 2, 0, 2, 3, 2, 14, 2, 9, 8, 46, 39, 7, 3, 1, 3, 21, 2, 6, 2, 1, 2, 4, 4, 0, 19, 0, 13, 4, 159, 52, 19, 3, 21, 2, 31, 47, 21, 1, 2, 0, 185, 46, 42, 3, 37, 47, 21, 0, 60, 42, 14, 0, 72, 26, 38, 6, 186, 43, 117, 63, 32, 7, 3, 0, 3, 7, 2, 1, 2, 23, 16, 0, 2, 0, 95, 7, 3, 38, 17, 0, 2, 0, 29, 0, 11, 39, 8, 0, 22, 0, 12, 45, 20, 0, 19, 72, 264, 8, 2, 36, 18, 0, 50, 29, 113, 6, 2, 1, 2, 37, 22, 0, 26, 5, 2, 1, 2, 31, 15, 0, 328, 18, 16, 0, 2, 12, 2, 33, 125, 0, 80, 921, 103, 110, 18, 195, 2637, 96, 16, 1071, 18, 5, 4026, 582, 8634, 568, 8, 30, 18, 78, 18, 29, 19, 47, 17, 3, 32, 20, 6, 18, 689, 63, 129, 74, 6, 0, 67, 12, 65, 1, 2, 0, 29, 6135, 9, 1237, 43, 8, 8936, 3, 2, 6, 2, 1, 2, 290, 16, 0, 30, 2, 3, 0, 15, 3, 9, 395, 2309, 106, 6, 12, 4, 8, 8, 9, 5991, 84, 2, 70, 2, 1, 3, 0, 3, 1, 3, 3, 2, 11, 2, 0, 2, 6, 2, 64, 2, 3, 3, 7, 2, 6, 2, 27, 2, 3, 2, 4, 2, 0, 4, 6, 2, 339, 3, 24, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 30, 2, 24, 2, 7, 1845, 30, 7, 5, 262, 61, 147, 44, 11, 6, 17, 0, 322, 29, 19, 43, 485, 27, 757, 6, 2, 3, 2, 1, 2, 14, 2, 196, 60, 67, 8, 0, 1205, 3, 2, 26, 2, 1, 2, 0, 3, 0, 2, 9, 2, 3, 2, 0, 2, 0, 7, 0, 5, 0, 2, 0, 2, 0, 2, 2, 2, 1, 2, 0, 3, 0, 2, 0, 2, 0, 2, 0, 2, 0, 2, 1, 2, 0, 3, 3, 2, 6, 2, 3, 2, 3, 2, 0, 2, 9, 2, 16, 6, 2, 2, 4, 2, 16, 4421, 42719, 33, 4153, 7, 221, 3, 5761, 15, 7472, 16, 621, 2467, 541, 1507, 4938, 6, 4191], WT = [509, 0, 227, 0, 150, 4, 294, 9, 1368, 2, 2, 1, 6, 3, 41, 2, 5, 0, 166, 1, 574, 3, 9, 9, 370, 1, 81, 2, 71, 10, 50, 3, 123, 2, 54, 14, 32, 10, 3, 1, 11, 3, 46, 10, 8, 0, 46, 9, 7, 2, 37, 13, 2, 9, 6, 1, 45, 0, 13, 2, 49, 13, 9, 3, 2, 11, 83, 11, 7, 0, 3, 0, 158, 11, 6, 9, 7, 3, 56, 1, 2, 6, 3, 1, 3, 2, 10, 0, 11, 1, 3, 6, 4, 4, 193, 17, 10, 9, 5, 0, 82, 19, 13, 9, 214, 6, 3, 8, 28, 1, 83, 16, 16, 9, 82, 12, 9, 9, 84, 14, 5, 9, 243, 14, 166, 9, 71, 5, 2, 1, 3, 3, 2, 0, 2, 1, 13, 9, 120, 6, 3, 6, 4, 0, 29, 9, 41, 6, 2, 3, 9, 0, 10, 10, 47, 15, 406, 7, 2, 7, 17, 9, 57, 21, 2, 13, 123, 5, 4, 0, 2, 1, 2, 6, 2, 0, 9, 9, 49, 4, 2, 1, 2, 4, 9, 9, 330, 3, 10, 1, 2, 0, 49, 6, 4, 4, 14, 9, 5351, 0, 7, 14, 13835, 9, 87, 9, 39, 4, 60, 6, 26, 9, 1014, 0, 2, 54, 8, 3, 82, 0, 12, 1, 19628, 1, 4706, 45, 3, 22, 543, 4, 4, 5, 9, 7, 3, 6, 31, 3, 149, 2, 1418, 49, 513, 54, 5, 49, 9, 0, 15, 0, 23, 4, 2, 14, 1361, 6, 2, 16, 3, 6, 2, 1, 2, 4, 101, 0, 161, 6, 10, 9, 357, 0, 62, 13, 499, 13, 983, 6, 110, 6, 6, 9, 4759, 9, 787719, 239];
      function Hf(y, p) {
        let b = 65536;
        for (let T = 0, F = p.length; T < F; T += 2) {
          if (b += p[T], b > y) return !1;
          if (b += p[T + 1], b >= y) return !0;
        }
        return !1;
      }
      function Xi(y) {
        return y < 65 ? y === 36 : y <= 90 ? !0 : y < 97 ? y === 95 : y <= 122 ? !0 : y <= 65535 ? y >= 170 && Wo.test(String.fromCharCode(y)) : Hf(y, Ho);
      }
      function rl(y) {
        return y < 48 ? y === 36 : y < 58 ? !0 : y < 65 ? !1 : y <= 90 ? !0 : y < 97 ? y === 95 : y <= 122 ? !0 : y <= 65535 ? y >= 170 && UT.test(String.fromCharCode(y)) : Hf(y, Ho) || Hf(y, WT);
      }
      var qd = { keyword: ["break", "case", "catch", "continue", "debugger", "default", "do", "else", "finally", "for", "function", "if", "return", "switch", "throw", "try", "var", "const", "while", "with", "new", "this", "super", "class", "extends", "export", "import", "null", "true", "false", "in", "instanceof", "typeof", "void", "delete"], strict: ["implements", "interface", "let", "package", "private", "protected", "public", "static", "yield"], strictBind: ["eval", "arguments"] }, Br = new Set(qd.keyword), Ol = new Set(qd.strict), Gg = new Set(qd.strictBind);
      function Vv(y, p) {
        return p && y === "await" || y === "enum";
      }
      function qf(y, p) {
        return Vv(y, p) || Ol.has(y);
      }
      function zv(y) {
        return Gg.has(y);
      }
      function Uv(y, p) {
        return qf(y, p) || zv(y);
      }
      function HT(y) {
        return Br.has(y);
      }
      function Wv(y, p, b) {
        return y === 64 && p === 64 && Xi(b);
      }
      var Gf = /* @__PURE__ */ new Set(["break", "case", "catch", "continue", "debugger", "default", "do", "else", "finally", "for", "function", "if", "return", "switch", "throw", "try", "var", "const", "while", "with", "new", "this", "super", "class", "extends", "export", "import", "null", "true", "false", "in", "instanceof", "typeof", "void", "delete", "implements", "interface", "let", "package", "private", "protected", "public", "static", "yield", "eval", "arguments", "enum", "await"]);
      function Ic(y) {
        return Gf.has(y);
      }
      var Yg = class {
        constructor(y) {
          this.flags = 0, this.names = /* @__PURE__ */ new Map(), this.firstLexicalName = "", this.flags = y;
        }
      }, Yf = class {
        constructor(y, p) {
          this.parser = void 0, this.scopeStack = [], this.inModule = void 0, this.undefinedExports = /* @__PURE__ */ new Map(), this.parser = y, this.inModule = p;
        }
        get inTopLevel() {
          return (this.currentScope().flags & 1) > 0;
        }
        get inFunction() {
          return (this.currentVarScopeFlags() & 2) > 0;
        }
        get allowSuper() {
          return (this.currentThisScopeFlags() & 16) > 0;
        }
        get allowDirectSuper() {
          return (this.currentThisScopeFlags() & 32) > 0;
        }
        get inClass() {
          return (this.currentThisScopeFlags() & 64) > 0;
        }
        get inClassAndNotInNonArrowFunction() {
          let y = this.currentThisScopeFlags();
          return (y & 64) > 0 && (y & 2) === 0;
        }
        get inStaticBlock() {
          for (let y = this.scopeStack.length - 1; ; y--) {
            let { flags: p } = this.scopeStack[y];
            if (p & 128) return !0;
            if (p & 451) return !1;
          }
        }
        get inNonArrowFunction() {
          return (this.currentThisScopeFlags() & 2) > 0;
        }
        get treatFunctionsAsVar() {
          return this.treatFunctionsAsVarInScope(this.currentScope());
        }
        createScope(y) {
          return new Yg(y);
        }
        enter(y) {
          this.scopeStack.push(this.createScope(y));
        }
        exit() {
          return this.scopeStack.pop().flags;
        }
        treatFunctionsAsVarInScope(y) {
          return !!(y.flags & 130 || !this.parser.inModule && y.flags & 1);
        }
        declareName(y, p, b) {
          let T = this.currentScope();
          if (p & 8 || p & 16) {
            this.checkRedeclarationInScope(T, y, p, b);
            let F = T.names.get(y) || 0;
            p & 16 ? F = F | 4 : (T.firstLexicalName || (T.firstLexicalName = y), F = F | 2), T.names.set(y, F), p & 8 && this.maybeExportDefined(T, y);
          } else if (p & 4) for (let F = this.scopeStack.length - 1; F >= 0 && (T = this.scopeStack[F], this.checkRedeclarationInScope(T, y, p, b), T.names.set(y, (T.names.get(y) || 0) | 1), this.maybeExportDefined(T, y), !(T.flags & 387)); --F) ;
          this.parser.inModule && T.flags & 1 && this.undefinedExports.delete(y);
        }
        maybeExportDefined(y, p) {
          this.parser.inModule && y.flags & 1 && this.undefinedExports.delete(p);
        }
        checkRedeclarationInScope(y, p, b, T) {
          this.isRedeclaredInScope(y, p, b) && this.parser.raise(Se.VarRedeclaration, T, { identifierName: p });
        }
        isRedeclaredInScope(y, p, b) {
          if (!(b & 1)) return !1;
          if (b & 8) return y.names.has(p);
          let T = y.names.get(p);
          return b & 16 ? (T & 2) > 0 || !this.treatFunctionsAsVarInScope(y) && (T & 1) > 0 : (T & 2) > 0 && !(y.flags & 8 && y.firstLexicalName === p) || !this.treatFunctionsAsVarInScope(y) && (T & 4) > 0;
        }
        checkLocalExport(y) {
          let { name: p } = y;
          this.scopeStack[0].names.has(p) || this.undefinedExports.set(p, y.loc.start);
        }
        currentScope() {
          return this.scopeStack[this.scopeStack.length - 1];
        }
        currentVarScopeFlags() {
          for (let y = this.scopeStack.length - 1; ; y--) {
            let { flags: p } = this.scopeStack[y];
            if (p & 387) return p;
          }
        }
        currentThisScopeFlags() {
          for (let y = this.scopeStack.length - 1; ; y--) {
            let { flags: p } = this.scopeStack[y];
            if (p & 451 && !(p & 4)) return p;
          }
        }
      }, Hv = class extends Yg {
        constructor(...y) {
          super(...y), this.declareFunctions = /* @__PURE__ */ new Set();
        }
      }, Kg = class extends Yf {
        createScope(y) {
          return new Hv(y);
        }
        declareName(y, p, b) {
          let T = this.currentScope();
          if (p & 2048) {
            this.checkRedeclarationInScope(T, y, p, b), this.maybeExportDefined(T, y), T.declareFunctions.add(y);
            return;
          }
          super.declareName(y, p, b);
        }
        isRedeclaredInScope(y, p, b) {
          if (super.isRedeclaredInScope(y, p, b)) return !0;
          if (b & 2048 && !y.declareFunctions.has(p)) {
            let T = y.names.get(p);
            return (T & 4) > 0 || (T & 2) > 0;
          }
          return !1;
        }
        checkLocalExport(y) {
          this.scopeStack[0].declareFunctions.has(y.name) || super.checkLocalExport(y);
        }
      }, Jg = class {
        constructor() {
          this.sawUnambiguousESM = !1, this.ambiguousScriptDifferentAst = !1;
        }
        hasPlugin(y) {
          if (typeof y == "string") return this.plugins.has(y);
          {
            let [p, b] = y;
            if (!this.hasPlugin(p)) return !1;
            let T = this.plugins.get(p);
            for (let F of Object.keys(b)) if ((T == null ? void 0 : T[F]) !== b[F]) return !1;
            return !0;
          }
        }
        getPluginOption(y, p) {
          var b;
          return (b = this.plugins.get(y)) == null ? void 0 : b[p];
        }
      };
      function Xg(y, p) {
        y.trailingComments === void 0 ? y.trailingComments = p : y.trailingComments.unshift(...p);
      }
      function qT(y, p) {
        y.leadingComments === void 0 ? y.leadingComments = p : y.leadingComments.unshift(...p);
      }
      function $u(y, p) {
        y.innerComments === void 0 ? y.innerComments = p : y.innerComments.unshift(...p);
      }
      function Nu(y, p, b) {
        let T = null, F = p.length;
        for (; T === null && F > 0; ) T = p[--F];
        T === null || T.start > b.start ? $u(y, b.comments) : Xg(T, b.comments);
      }
      var GT = class extends Jg {
        addComment(y) {
          this.filename && (y.loc.filename = this.filename);
          let { commentsLen: p } = this.state;
          this.comments.length !== p && (this.comments.length = p), this.comments.push(y), this.state.commentsLen++;
        }
        processComment(y) {
          let { commentStack: p } = this.state, b = p.length;
          if (b === 0) return;
          let T = b - 1, F = p[T];
          F.start === y.end && (F.leadingNode = y, T--);
          let { start: Y } = y;
          for (; T >= 0; T--) {
            let ie = p[T], de = ie.end;
            if (de > Y) ie.containingNode = y, this.finalizeComment(ie), p.splice(T, 1);
            else {
              de === Y && (ie.trailingNode = y);
              break;
            }
          }
        }
        finalizeComment(y) {
          let { comments: p } = y;
          if (y.leadingNode !== null || y.trailingNode !== null) y.leadingNode !== null && Xg(y.leadingNode, p), y.trailingNode !== null && qT(y.trailingNode, p);
          else {
            let { containingNode: b, start: T } = y;
            if (this.input.charCodeAt(T - 1) === 44) switch (b.type) {
              case "ObjectExpression":
              case "ObjectPattern":
              case "RecordExpression":
                Nu(b, b.properties, y);
                break;
              case "CallExpression":
              case "OptionalCallExpression":
                Nu(b, b.arguments, y);
                break;
              case "FunctionDeclaration":
              case "FunctionExpression":
              case "ArrowFunctionExpression":
              case "ObjectMethod":
              case "ClassMethod":
              case "ClassPrivateMethod":
                Nu(b, b.params, y);
                break;
              case "ArrayExpression":
              case "ArrayPattern":
              case "TupleExpression":
                Nu(b, b.elements, y);
                break;
              case "ExportNamedDeclaration":
              case "ImportDeclaration":
                Nu(b, b.specifiers, y);
                break;
              default:
                $u(b, p);
            }
            else $u(b, p);
          }
        }
        finalizeRemainingComments() {
          let { commentStack: y } = this.state;
          for (let p = y.length - 1; p >= 0; p--) this.finalizeComment(y[p]);
          this.state.commentStack = [];
        }
        resetPreviousNodeTrailingComments(y) {
          let { commentStack: p } = this.state, { length: b } = p;
          if (b === 0) return;
          let T = p[b - 1];
          T.leadingNode === y && (T.leadingNode = null);
        }
        resetPreviousIdentifierLeadingComments(y) {
          let { commentStack: p } = this.state, { length: b } = p;
          b !== 0 && (p[b - 1].trailingNode === y ? p[b - 1].trailingNode = null : b >= 2 && p[b - 2].trailingNode === y && (p[b - 2].trailingNode = null));
        }
        takeSurroundingComments(y, p, b) {
          let { commentStack: T } = this.state, F = T.length;
          if (F === 0) return;
          let Y = F - 1;
          for (; Y >= 0; Y--) {
            let ie = T[Y], de = ie.end;
            if (ie.start === b) ie.leadingNode = y;
            else if (de === p) ie.trailingNode = y;
            else if (de < p) break;
          }
        }
      }, Qg = /\r\n?|[\n\u2028\u2029]/, Qi = new RegExp(Qg.source, "g");
      function Mu(y) {
        switch (y) {
          case 10:
          case 13:
          case 8232:
          case 8233:
            return !0;
          default:
            return !1;
        }
      }
      var Ru = /(?:\s|\/\/.*|\/\*[^]*?\*\/)*/g, Gd = /(?:[^\S\n\r\u2028\u2029]|\/\/.*|\/\*.*?\*\/)*/g, Zg = new RegExp("(?=(" + Gd.source + "))\\1" + /(?=[\n\r\u2028\u2029]|\/\*(?!.*?\*\/)|$)/.source, "y");
      function YT(y) {
        switch (y) {
          case 9:
          case 11:
          case 12:
          case 32:
          case 160:
          case 5760:
          case 8192:
          case 8193:
          case 8194:
          case 8195:
          case 8196:
          case 8197:
          case 8198:
          case 8199:
          case 8200:
          case 8201:
          case 8202:
          case 8239:
          case 8287:
          case 12288:
          case 65279:
            return !0;
          default:
            return !1;
        }
      }
      var KT = class oX {
        constructor() {
          this.flags = 1024, this.curLine = void 0, this.lineStart = void 0, this.startLoc = void 0, this.endLoc = void 0, this.errors = [], this.potentialArrowAt = -1, this.noArrowAt = [], this.noArrowParamsConversionAt = [], this.topicContext = { maxNumOfResolvableTopics: 0, maxTopicIndex: null }, this.labels = [], this.commentsLen = 0, this.commentStack = [], this.pos = 0, this.type = 139, this.value = null, this.start = 0, this.end = 0, this.lastTokEndLoc = null, this.lastTokStartLoc = null, this.context = [ar.brace], this.firstInvalidTemplateEscapePos = null, this.strictErrors = /* @__PURE__ */ new Map(), this.tokensLength = 0;
        }
        get strict() {
          return (this.flags & 1) > 0;
        }
        set strict(p) {
          p ? this.flags |= 1 : this.flags &= -2;
        }
        init({ strictMode: p, sourceType: b, startLine: T, startColumn: F }) {
          this.strict = p === !1 ? !1 : p === !0 ? !0 : b === "module", this.curLine = T, this.lineStart = -F, this.startLoc = this.endLoc = new pt(T, F, 0);
        }
        get maybeInArrowParameters() {
          return (this.flags & 2) > 0;
        }
        set maybeInArrowParameters(p) {
          p ? this.flags |= 2 : this.flags &= -3;
        }
        get inType() {
          return (this.flags & 4) > 0;
        }
        set inType(p) {
          p ? this.flags |= 4 : this.flags &= -5;
        }
        get noAnonFunctionType() {
          return (this.flags & 8) > 0;
        }
        set noAnonFunctionType(p) {
          p ? this.flags |= 8 : this.flags &= -9;
        }
        get hasFlowComment() {
          return (this.flags & 16) > 0;
        }
        set hasFlowComment(p) {
          p ? this.flags |= 16 : this.flags &= -17;
        }
        get isAmbientContext() {
          return (this.flags & 32) > 0;
        }
        set isAmbientContext(p) {
          p ? this.flags |= 32 : this.flags &= -33;
        }
        get inAbstractClass() {
          return (this.flags & 64) > 0;
        }
        set inAbstractClass(p) {
          p ? this.flags |= 64 : this.flags &= -65;
        }
        get inDisallowConditionalTypesContext() {
          return (this.flags & 128) > 0;
        }
        set inDisallowConditionalTypesContext(p) {
          p ? this.flags |= 128 : this.flags &= -129;
        }
        get soloAwait() {
          return (this.flags & 256) > 0;
        }
        set soloAwait(p) {
          p ? this.flags |= 256 : this.flags &= -257;
        }
        get inFSharpPipelineDirectBody() {
          return (this.flags & 512) > 0;
        }
        set inFSharpPipelineDirectBody(p) {
          p ? this.flags |= 512 : this.flags &= -513;
        }
        get canStartJSXElement() {
          return (this.flags & 1024) > 0;
        }
        set canStartJSXElement(p) {
          p ? this.flags |= 1024 : this.flags &= -1025;
        }
        get containsEsc() {
          return (this.flags & 2048) > 0;
        }
        set containsEsc(p) {
          p ? this.flags |= 2048 : this.flags &= -2049;
        }
        curPosition() {
          return new pt(this.curLine, this.pos - this.lineStart, this.pos);
        }
        clone() {
          let p = new oX();
          return p.flags = this.flags, p.curLine = this.curLine, p.lineStart = this.lineStart, p.startLoc = this.startLoc, p.endLoc = this.endLoc, p.errors = this.errors.slice(), p.potentialArrowAt = this.potentialArrowAt, p.noArrowAt = this.noArrowAt.slice(), p.noArrowParamsConversionAt = this.noArrowParamsConversionAt.slice(), p.topicContext = this.topicContext, p.labels = this.labels.slice(), p.commentsLen = this.commentsLen, p.commentStack = this.commentStack.slice(), p.pos = this.pos, p.type = this.type, p.value = this.value, p.start = this.start, p.end = this.end, p.lastTokEndLoc = this.lastTokEndLoc, p.lastTokStartLoc = this.lastTokStartLoc, p.context = this.context.slice(), p.firstInvalidTemplateEscapePos = this.firstInvalidTemplateEscapePos, p.strictErrors = this.strictErrors, p.tokensLength = this.tokensLength, p;
        }
      }, JT = function(y) {
        return y >= 48 && y <= 57;
      }, qv = { decBinOct: /* @__PURE__ */ new Set([46, 66, 69, 79, 95, 98, 101, 111]), hex: /* @__PURE__ */ new Set([46, 88, 95, 120]) }, Kf = { bin: (y) => y === 48 || y === 49, oct: (y) => y >= 48 && y <= 55, dec: (y) => y >= 48 && y <= 57, hex: (y) => y >= 48 && y <= 57 || y >= 65 && y <= 70 || y >= 97 && y <= 102 };
      function _u(y, p, b, T, F, Y) {
        let ie = b, de = T, he = F, fe = "", Ze = null, Dt = b, { length: $t } = p;
        for (; ; ) {
          if (b >= $t) {
            Y.unterminated(ie, de, he), fe += p.slice(Dt, b);
            break;
          }
          let It = p.charCodeAt(b);
          if (XT(y, It, p, b)) {
            fe += p.slice(Dt, b);
            break;
          }
          if (It === 92) {
            fe += p.slice(Dt, b);
            let nr = QT(p, b, T, F, y === "template", Y);
            nr.ch === null && !Ze ? Ze = { pos: b, lineStart: T, curLine: F } : fe += nr.ch, { pos: b, lineStart: T, curLine: F } = nr, Dt = b;
          } else It === 8232 || It === 8233 ? (++b, ++F, T = b) : It === 10 || It === 13 ? y === "template" ? (fe += p.slice(Dt, b) + `
`, ++b, It === 13 && p.charCodeAt(b) === 10 && ++b, ++F, Dt = T = b) : Y.unterminated(ie, de, he) : ++b;
        }
        return { pos: b, str: fe, firstInvalidLoc: Ze, lineStart: T, curLine: F, containsInvalid: !!Ze };
      }
      function XT(y, p, b, T) {
        return y === "template" ? p === 96 || p === 36 && b.charCodeAt(T + 1) === 123 : p === (y === "double" ? 34 : 39);
      }
      function QT(y, p, b, T, F, Y) {
        let ie = !F;
        p++;
        let de = (fe) => ({ pos: p, ch: fe, lineStart: b, curLine: T }), he = y.charCodeAt(p++);
        switch (he) {
          case 110:
            return de(`
`);
          case 114:
            return de("\r");
          case 120: {
            let fe;
            return { code: fe, pos: p } = Yd(y, p, b, T, 2, !1, ie, Y), de(fe === null ? null : String.fromCharCode(fe));
          }
          case 117: {
            let fe;
            return { code: fe, pos: p } = il(y, p, b, T, ie, Y), de(fe === null ? null : String.fromCodePoint(fe));
          }
          case 116:
            return de("	");
          case 98:
            return de("\b");
          case 118:
            return de("\v");
          case 102:
            return de("\f");
          case 13:
            y.charCodeAt(p) === 10 && ++p;
          case 10:
            b = p, ++T;
          case 8232:
          case 8233:
            return de("");
          case 56:
          case 57:
            if (F) return de(null);
            Y.strictNumericEscape(p - 1, b, T);
          default:
            if (he >= 48 && he <= 55) {
              let fe = p - 1, Ze = /^[0-7]+/.exec(y.slice(fe, p + 2))[0], Dt = parseInt(Ze, 8);
              Dt > 255 && (Ze = Ze.slice(0, -1), Dt = parseInt(Ze, 8)), p += Ze.length - 1;
              let $t = y.charCodeAt(p);
              if (Ze !== "0" || $t === 56 || $t === 57) {
                if (F) return de(null);
                Y.strictNumericEscape(fe, b, T);
              }
              return de(String.fromCharCode(Dt));
            }
            return de(String.fromCharCode(he));
        }
      }
      function Yd(y, p, b, T, F, Y, ie, de) {
        let he = p, fe;
        return { n: fe, pos: p } = ey(y, p, b, T, 16, F, Y, !1, de, !ie), fe === null && (ie ? de.invalidEscapeSequence(he, b, T) : p = he - 1), { code: fe, pos: p };
      }
      function ey(y, p, b, T, F, Y, ie, de, he, fe) {
        let Ze = p, Dt = F === 16 ? qv.hex : qv.decBinOct, $t = F === 16 ? Kf.hex : F === 10 ? Kf.dec : F === 8 ? Kf.oct : Kf.bin, It = !1, nr = 0;
        for (let Di = 0, Sr = Y ?? 1 / 0; Di < Sr; ++Di) {
          let ii = y.charCodeAt(p), qo;
          if (ii === 95 && de !== "bail") {
            let zs = y.charCodeAt(p - 1), sy = y.charCodeAt(p + 1);
            if (de) {
              if (Number.isNaN(sy) || !$t(sy) || Dt.has(zs) || Dt.has(sy)) {
                if (fe) return { n: null, pos: p };
                he.unexpectedNumericSeparator(p, b, T);
              }
            } else {
              if (fe) return { n: null, pos: p };
              he.numericSeparatorInEscapeSequence(p, b, T);
            }
            ++p;
            continue;
          }
          if (ii >= 97 ? qo = ii - 97 + 10 : ii >= 65 ? qo = ii - 65 + 10 : JT(ii) ? qo = ii - 48 : qo = 1 / 0, qo >= F) {
            if (qo <= 9 && fe) return { n: null, pos: p };
            if (qo <= 9 && he.invalidDigit(p, b, T, F)) qo = 0;
            else if (ie) qo = 0, It = !0;
            else break;
          }
          ++p, nr = nr * F + qo;
        }
        return p === Ze || Y != null && p - Ze !== Y || It ? { n: null, pos: p } : { n: nr, pos: p };
      }
      function il(y, p, b, T, F, Y) {
        let ie = y.charCodeAt(p), de;
        if (ie === 123) {
          if (++p, { code: de, pos: p } = Yd(y, p, b, T, y.indexOf("}", p) - p, !0, F, Y), ++p, de !== null && de > 1114111) if (F) Y.invalidCodePoint(p, b, T);
          else return { code: null, pos: p };
        } else ({ code: de, pos: p } = Yd(y, p, b, T, 4, !1, F, Y));
        return { code: de, pos: p };
      }
      function Il(y, p, b) {
        return new pt(b, y - p, y);
      }
      var ZT = /* @__PURE__ */ new Set([103, 109, 115, 105, 121, 117, 100, 118]), Fl = class {
        constructor(y) {
          this.type = y.type, this.value = y.value, this.start = y.start, this.end = y.end, this.loc = new bt(y.startLoc, y.endLoc);
        }
      }, eS = class extends GT {
        constructor(y, p) {
          super(), this.isLookahead = void 0, this.tokens = [], this.errorHandlers_readInt = { invalidDigit: (b, T, F, Y) => this.options.errorRecovery ? (this.raise(Se.InvalidDigit, Il(b, T, F), { radix: Y }), !0) : !1, numericSeparatorInEscapeSequence: this.errorBuilder(Se.NumericSeparatorInEscapeSequence), unexpectedNumericSeparator: this.errorBuilder(Se.UnexpectedNumericSeparator) }, this.errorHandlers_readCodePoint = Object.assign({}, this.errorHandlers_readInt, { invalidEscapeSequence: this.errorBuilder(Se.InvalidEscapeSequence), invalidCodePoint: this.errorBuilder(Se.InvalidCodePoint) }), this.errorHandlers_readStringContents_string = Object.assign({}, this.errorHandlers_readCodePoint, { strictNumericEscape: (b, T, F) => {
            this.recordStrictModeErrors(Se.StrictNumericEscape, Il(b, T, F));
          }, unterminated: (b, T, F) => {
            throw this.raise(Se.UnterminatedString, Il(b - 1, T, F));
          } }), this.errorHandlers_readStringContents_template = Object.assign({}, this.errorHandlers_readCodePoint, { strictNumericEscape: this.errorBuilder(Se.StrictNumericEscape), unterminated: (b, T, F) => {
            throw this.raise(Se.UnterminatedTemplate, Il(b, T, F));
          } }), this.state = new KT(), this.state.init(y), this.input = p, this.length = p.length, this.comments = [], this.isLookahead = !1;
        }
        pushToken(y) {
          this.tokens.length = this.state.tokensLength, this.tokens.push(y), ++this.state.tokensLength;
        }
        next() {
          this.checkKeywordEscapes(), this.options.tokens && this.pushToken(new Fl(this.state)), this.state.lastTokEndLoc = this.state.endLoc, this.state.lastTokStartLoc = this.state.startLoc, this.nextToken();
        }
        eat(y) {
          return this.match(y) ? (this.next(), !0) : !1;
        }
        match(y) {
          return this.state.type === y;
        }
        createLookaheadState(y) {
          return { pos: y.pos, value: null, type: y.type, start: y.start, end: y.end, context: [this.curContext()], inType: y.inType, startLoc: y.startLoc, lastTokEndLoc: y.lastTokEndLoc, curLine: y.curLine, lineStart: y.lineStart, curPosition: y.curPosition };
        }
        lookahead() {
          let y = this.state;
          this.state = this.createLookaheadState(y), this.isLookahead = !0, this.nextToken(), this.isLookahead = !1;
          let p = this.state;
          return this.state = y, p;
        }
        nextTokenStart() {
          return this.nextTokenStartSince(this.state.pos);
        }
        nextTokenStartSince(y) {
          return Ru.lastIndex = y, Ru.test(this.input) ? Ru.lastIndex : y;
        }
        lookaheadCharCode() {
          return this.input.charCodeAt(this.nextTokenStart());
        }
        nextTokenInLineStart() {
          return this.nextTokenInLineStartSince(this.state.pos);
        }
        nextTokenInLineStartSince(y) {
          return Gd.lastIndex = y, Gd.test(this.input) ? Gd.lastIndex : y;
        }
        lookaheadInLineCharCode() {
          return this.input.charCodeAt(this.nextTokenInLineStart());
        }
        codePointAtPos(y) {
          let p = this.input.charCodeAt(y);
          if ((p & 64512) === 55296 && ++y < this.input.length) {
            let b = this.input.charCodeAt(y);
            (b & 64512) === 56320 && (p = 65536 + ((p & 1023) << 10) + (b & 1023));
          }
          return p;
        }
        setStrict(y) {
          this.state.strict = y, y && (this.state.strictErrors.forEach(([p, b]) => this.raise(p, b)), this.state.strictErrors.clear());
        }
        curContext() {
          return this.state.context[this.state.context.length - 1];
        }
        nextToken() {
          if (this.skipSpace(), this.state.start = this.state.pos, this.isLookahead || (this.state.startLoc = this.state.curPosition()), this.state.pos >= this.length) {
            this.finishToken(139);
            return;
          }
          this.getTokenFromCode(this.codePointAtPos(this.state.pos));
        }
        skipBlockComment(y) {
          let p;
          this.isLookahead || (p = this.state.curPosition());
          let b = this.state.pos, T = this.input.indexOf(y, b + 2);
          if (T === -1) throw this.raise(Se.UnterminatedComment, this.state.curPosition());
          for (this.state.pos = T + y.length, Qi.lastIndex = b + 2; Qi.test(this.input) && Qi.lastIndex <= T; ) ++this.state.curLine, this.state.lineStart = Qi.lastIndex;
          if (this.isLookahead) return;
          let F = { type: "CommentBlock", value: this.input.slice(b + 2, T), start: b, end: T + y.length, loc: new bt(p, this.state.curPosition()) };
          return this.options.tokens && this.pushToken(F), F;
        }
        skipLineComment(y) {
          let p = this.state.pos, b;
          this.isLookahead || (b = this.state.curPosition());
          let T = this.input.charCodeAt(this.state.pos += y);
          if (this.state.pos < this.length) for (; !Mu(T) && ++this.state.pos < this.length; ) T = this.input.charCodeAt(this.state.pos);
          if (this.isLookahead) return;
          let F = this.state.pos, Y = { type: "CommentLine", value: this.input.slice(p + y, F), start: p, end: F, loc: new bt(b, this.state.curPosition()) };
          return this.options.tokens && this.pushToken(Y), Y;
        }
        skipSpace() {
          let y = this.state.pos, p = [];
          e: for (; this.state.pos < this.length; ) {
            let b = this.input.charCodeAt(this.state.pos);
            switch (b) {
              case 32:
              case 160:
              case 9:
                ++this.state.pos;
                break;
              case 13:
                this.input.charCodeAt(this.state.pos + 1) === 10 && ++this.state.pos;
              case 10:
              case 8232:
              case 8233:
                ++this.state.pos, ++this.state.curLine, this.state.lineStart = this.state.pos;
                break;
              case 47:
                switch (this.input.charCodeAt(this.state.pos + 1)) {
                  case 42: {
                    let T = this.skipBlockComment("*/");
                    T !== void 0 && (this.addComment(T), this.options.attachComment && p.push(T));
                    break;
                  }
                  case 47: {
                    let T = this.skipLineComment(2);
                    T !== void 0 && (this.addComment(T), this.options.attachComment && p.push(T));
                    break;
                  }
                  default:
                    break e;
                }
                break;
              default:
                if (YT(b)) ++this.state.pos;
                else if (b === 45 && !this.inModule && this.options.annexB) {
                  let T = this.state.pos;
                  if (this.input.charCodeAt(T + 1) === 45 && this.input.charCodeAt(T + 2) === 62 && (y === 0 || this.state.lineStart > y)) {
                    let F = this.skipLineComment(3);
                    F !== void 0 && (this.addComment(F), this.options.attachComment && p.push(F));
                  } else break e;
                } else if (b === 60 && !this.inModule && this.options.annexB) {
                  let T = this.state.pos;
                  if (this.input.charCodeAt(T + 1) === 33 && this.input.charCodeAt(T + 2) === 45 && this.input.charCodeAt(T + 3) === 45) {
                    let F = this.skipLineComment(4);
                    F !== void 0 && (this.addComment(F), this.options.attachComment && p.push(F));
                  } else break e;
                } else break e;
            }
          }
          if (p.length > 0) {
            let b = this.state.pos, T = { start: y, end: b, comments: p, leadingNode: null, trailingNode: null, containingNode: null };
            this.state.commentStack.push(T);
          }
        }
        finishToken(y, p) {
          this.state.end = this.state.pos, this.state.endLoc = this.state.curPosition();
          let b = this.state.type;
          this.state.type = y, this.state.value = p, this.isLookahead || this.updateContext(b);
        }
        replaceToken(y) {
          this.state.type = y, this.updateContext();
        }
        readToken_numberSign() {
          if (this.state.pos === 0 && this.readToken_interpreter()) return;
          let y = this.state.pos + 1, p = this.codePointAtPos(y);
          if (p >= 48 && p <= 57) throw this.raise(Se.UnexpectedDigitAfterHash, this.state.curPosition());
          if (p === 123 || p === 91 && this.hasPlugin("recordAndTuple")) {
            if (this.expectPlugin("recordAndTuple"), this.getPluginOption("recordAndTuple", "syntaxType") === "bar") throw this.raise(p === 123 ? Se.RecordExpressionHashIncorrectStartSyntaxType : Se.TupleExpressionHashIncorrectStartSyntaxType, this.state.curPosition());
            this.state.pos += 2, p === 123 ? this.finishToken(7) : this.finishToken(1);
          } else Xi(p) ? (++this.state.pos, this.finishToken(138, this.readWord1(p))) : p === 92 ? (++this.state.pos, this.finishToken(138, this.readWord1())) : this.finishOp(27, 1);
        }
        readToken_dot() {
          let y = this.input.charCodeAt(this.state.pos + 1);
          if (y >= 48 && y <= 57) {
            this.readNumber(!0);
            return;
          }
          y === 46 && this.input.charCodeAt(this.state.pos + 2) === 46 ? (this.state.pos += 3, this.finishToken(21)) : (++this.state.pos, this.finishToken(16));
        }
        readToken_slash() {
          this.input.charCodeAt(this.state.pos + 1) === 61 ? this.finishOp(31, 2) : this.finishOp(56, 1);
        }
        readToken_interpreter() {
          if (this.state.pos !== 0 || this.length < 2) return !1;
          let y = this.input.charCodeAt(this.state.pos + 1);
          if (y !== 33) return !1;
          let p = this.state.pos;
          for (this.state.pos += 1; !Mu(y) && ++this.state.pos < this.length; ) y = this.input.charCodeAt(this.state.pos);
          let b = this.input.slice(p + 2, this.state.pos);
          return this.finishToken(28, b), !0;
        }
        readToken_mult_modulo(y) {
          let p = y === 42 ? 55 : 54, b = 1, T = this.input.charCodeAt(this.state.pos + 1);
          y === 42 && T === 42 && (b++, T = this.input.charCodeAt(this.state.pos + 2), p = 57), T === 61 && !this.state.inType && (b++, p = y === 37 ? 33 : 30), this.finishOp(p, b);
        }
        readToken_pipe_amp(y) {
          let p = this.input.charCodeAt(this.state.pos + 1);
          if (p === y) {
            this.input.charCodeAt(this.state.pos + 2) === 61 ? this.finishOp(30, 3) : this.finishOp(y === 124 ? 41 : 42, 2);
            return;
          }
          if (y === 124) {
            if (p === 62) {
              this.finishOp(39, 2);
              return;
            }
            if (this.hasPlugin("recordAndTuple") && p === 125) {
              if (this.getPluginOption("recordAndTuple", "syntaxType") !== "bar") throw this.raise(Se.RecordExpressionBarIncorrectEndSyntaxType, this.state.curPosition());
              this.state.pos += 2, this.finishToken(9);
              return;
            }
            if (this.hasPlugin("recordAndTuple") && p === 93) {
              if (this.getPluginOption("recordAndTuple", "syntaxType") !== "bar") throw this.raise(Se.TupleExpressionBarIncorrectEndSyntaxType, this.state.curPosition());
              this.state.pos += 2, this.finishToken(4);
              return;
            }
          }
          if (p === 61) {
            this.finishOp(30, 2);
            return;
          }
          this.finishOp(y === 124 ? 43 : 45, 1);
        }
        readToken_caret() {
          let y = this.input.charCodeAt(this.state.pos + 1);
          y === 61 && !this.state.inType ? this.finishOp(32, 2) : y === 94 && this.hasPlugin(["pipelineOperator", { proposal: "hack", topicToken: "^^" }]) ? (this.finishOp(37, 2), this.input.codePointAt(this.state.pos) === 94 && this.unexpected()) : this.finishOp(44, 1);
        }
        readToken_atSign() {
          this.input.charCodeAt(this.state.pos + 1) === 64 && this.hasPlugin(["pipelineOperator", { proposal: "hack", topicToken: "@@" }]) ? this.finishOp(38, 2) : this.finishOp(26, 1);
        }
        readToken_plus_min(y) {
          let p = this.input.charCodeAt(this.state.pos + 1);
          if (p === y) {
            this.finishOp(34, 2);
            return;
          }
          p === 61 ? this.finishOp(30, 2) : this.finishOp(53, 1);
        }
        readToken_lt() {
          let { pos: y } = this.state, p = this.input.charCodeAt(y + 1);
          if (p === 60) {
            if (this.input.charCodeAt(y + 2) === 61) {
              this.finishOp(30, 3);
              return;
            }
            this.finishOp(51, 2);
            return;
          }
          if (p === 61) {
            this.finishOp(49, 2);
            return;
          }
          this.finishOp(47, 1);
        }
        readToken_gt() {
          let { pos: y } = this.state, p = this.input.charCodeAt(y + 1);
          if (p === 62) {
            let b = this.input.charCodeAt(y + 2) === 62 ? 3 : 2;
            if (this.input.charCodeAt(y + b) === 61) {
              this.finishOp(30, b + 1);
              return;
            }
            this.finishOp(52, b);
            return;
          }
          if (p === 61) {
            this.finishOp(49, 2);
            return;
          }
          this.finishOp(48, 1);
        }
        readToken_eq_excl(y) {
          let p = this.input.charCodeAt(this.state.pos + 1);
          if (p === 61) {
            this.finishOp(46, this.input.charCodeAt(this.state.pos + 2) === 61 ? 3 : 2);
            return;
          }
          if (y === 61 && p === 62) {
            this.state.pos += 2, this.finishToken(19);
            return;
          }
          this.finishOp(y === 61 ? 29 : 35, 1);
        }
        readToken_question() {
          let y = this.input.charCodeAt(this.state.pos + 1), p = this.input.charCodeAt(this.state.pos + 2);
          y === 63 ? p === 61 ? this.finishOp(30, 3) : this.finishOp(40, 2) : y === 46 && !(p >= 48 && p <= 57) ? (this.state.pos += 2, this.finishToken(18)) : (++this.state.pos, this.finishToken(17));
        }
        getTokenFromCode(y) {
          switch (y) {
            case 46:
              this.readToken_dot();
              return;
            case 40:
              ++this.state.pos, this.finishToken(10);
              return;
            case 41:
              ++this.state.pos, this.finishToken(11);
              return;
            case 59:
              ++this.state.pos, this.finishToken(13);
              return;
            case 44:
              ++this.state.pos, this.finishToken(12);
              return;
            case 91:
              if (this.hasPlugin("recordAndTuple") && this.input.charCodeAt(this.state.pos + 1) === 124) {
                if (this.getPluginOption("recordAndTuple", "syntaxType") !== "bar") throw this.raise(Se.TupleExpressionBarIncorrectStartSyntaxType, this.state.curPosition());
                this.state.pos += 2, this.finishToken(2);
              } else ++this.state.pos, this.finishToken(0);
              return;
            case 93:
              ++this.state.pos, this.finishToken(3);
              return;
            case 123:
              if (this.hasPlugin("recordAndTuple") && this.input.charCodeAt(this.state.pos + 1) === 124) {
                if (this.getPluginOption("recordAndTuple", "syntaxType") !== "bar") throw this.raise(Se.RecordExpressionBarIncorrectStartSyntaxType, this.state.curPosition());
                this.state.pos += 2, this.finishToken(6);
              } else ++this.state.pos, this.finishToken(5);
              return;
            case 125:
              ++this.state.pos, this.finishToken(8);
              return;
            case 58:
              this.hasPlugin("functionBind") && this.input.charCodeAt(this.state.pos + 1) === 58 ? this.finishOp(15, 2) : (++this.state.pos, this.finishToken(14));
              return;
            case 63:
              this.readToken_question();
              return;
            case 96:
              this.readTemplateToken();
              return;
            case 48: {
              let p = this.input.charCodeAt(this.state.pos + 1);
              if (p === 120 || p === 88) {
                this.readRadixNumber(16);
                return;
              }
              if (p === 111 || p === 79) {
                this.readRadixNumber(8);
                return;
              }
              if (p === 98 || p === 66) {
                this.readRadixNumber(2);
                return;
              }
            }
            case 49:
            case 50:
            case 51:
            case 52:
            case 53:
            case 54:
            case 55:
            case 56:
            case 57:
              this.readNumber(!1);
              return;
            case 34:
            case 39:
              this.readString(y);
              return;
            case 47:
              this.readToken_slash();
              return;
            case 37:
            case 42:
              this.readToken_mult_modulo(y);
              return;
            case 124:
            case 38:
              this.readToken_pipe_amp(y);
              return;
            case 94:
              this.readToken_caret();
              return;
            case 43:
            case 45:
              this.readToken_plus_min(y);
              return;
            case 60:
              this.readToken_lt();
              return;
            case 62:
              this.readToken_gt();
              return;
            case 61:
            case 33:
              this.readToken_eq_excl(y);
              return;
            case 126:
              this.finishOp(36, 1);
              return;
            case 64:
              this.readToken_atSign();
              return;
            case 35:
              this.readToken_numberSign();
              return;
            case 92:
              this.readWord();
              return;
            default:
              if (Xi(y)) {
                this.readWord(y);
                return;
              }
          }
          throw this.raise(Se.InvalidOrUnexpectedToken, this.state.curPosition(), { unexpected: String.fromCodePoint(y) });
        }
        finishOp(y, p) {
          let b = this.input.slice(this.state.pos, this.state.pos + p);
          this.state.pos += p, this.finishToken(y, b);
        }
        readRegexp() {
          let y = this.state.startLoc, p = this.state.start + 1, b, T, { pos: F } = this.state;
          for (; ; ++F) {
            if (F >= this.length) throw this.raise(Se.UnterminatedRegExp, dt(y, 1));
            let he = this.input.charCodeAt(F);
            if (Mu(he)) throw this.raise(Se.UnterminatedRegExp, dt(y, 1));
            if (b) b = !1;
            else {
              if (he === 91) T = !0;
              else if (he === 93 && T) T = !1;
              else if (he === 47 && !T) break;
              b = he === 92;
            }
          }
          let Y = this.input.slice(p, F);
          ++F;
          let ie = "", de = () => dt(y, F + 2 - p);
          for (; F < this.length; ) {
            let he = this.codePointAtPos(F), fe = String.fromCharCode(he);
            if (ZT.has(he)) he === 118 ? ie.includes("u") && this.raise(Se.IncompatibleRegExpUVFlags, de()) : he === 117 && ie.includes("v") && this.raise(Se.IncompatibleRegExpUVFlags, de()), ie.includes(fe) && this.raise(Se.DuplicateRegExpFlags, de());
            else if (rl(he) || he === 92) this.raise(Se.MalformedRegExpFlags, de());
            else break;
            ++F, ie += fe;
          }
          this.state.pos = F, this.finishToken(137, { pattern: Y, flags: ie });
        }
        readInt(y, p, b = !1, T = !0) {
          let { n: F, pos: Y } = ey(this.input, this.state.pos, this.state.lineStart, this.state.curLine, y, p, b, T, this.errorHandlers_readInt, !1);
          return this.state.pos = Y, F;
        }
        readRadixNumber(y) {
          let p = this.state.curPosition(), b = !1;
          this.state.pos += 2;
          let T = this.readInt(y);
          T == null && this.raise(Se.InvalidDigit, dt(p, 2), { radix: y });
          let F = this.input.charCodeAt(this.state.pos);
          if (F === 110) ++this.state.pos, b = !0;
          else if (F === 109) throw this.raise(Se.InvalidDecimal, p);
          if (Xi(this.codePointAtPos(this.state.pos))) throw this.raise(Se.NumberIdentifier, this.state.curPosition());
          if (b) {
            let Y = this.input.slice(p.index, this.state.pos).replace(/[_n]/g, "");
            this.finishToken(135, Y);
            return;
          }
          this.finishToken(134, T);
        }
        readNumber(y) {
          let p = this.state.pos, b = this.state.curPosition(), T = !1, F = !1, Y = !1, ie = !1, de = !1;
          !y && this.readInt(10) === null && this.raise(Se.InvalidNumber, this.state.curPosition());
          let he = this.state.pos - p >= 2 && this.input.charCodeAt(p) === 48;
          if (he) {
            let $t = this.input.slice(p, this.state.pos);
            if (this.recordStrictModeErrors(Se.StrictOctalLiteral, b), !this.state.strict) {
              let It = $t.indexOf("_");
              It > 0 && this.raise(Se.ZeroDigitNumericSeparator, dt(b, It));
            }
            de = he && !/[89]/.test($t);
          }
          let fe = this.input.charCodeAt(this.state.pos);
          if (fe === 46 && !de && (++this.state.pos, this.readInt(10), T = !0, fe = this.input.charCodeAt(this.state.pos)), (fe === 69 || fe === 101) && !de && (fe = this.input.charCodeAt(++this.state.pos), (fe === 43 || fe === 45) && ++this.state.pos, this.readInt(10) === null && this.raise(Se.InvalidOrMissingExponent, b), T = !0, ie = !0, fe = this.input.charCodeAt(this.state.pos)), fe === 110 && ((T || he) && this.raise(Se.InvalidBigIntLiteral, b), ++this.state.pos, F = !0), fe === 109 && (this.expectPlugin("decimal", this.state.curPosition()), (ie || he) && this.raise(Se.InvalidDecimal, b), ++this.state.pos, Y = !0), Xi(this.codePointAtPos(this.state.pos))) throw this.raise(Se.NumberIdentifier, this.state.curPosition());
          let Ze = this.input.slice(p, this.state.pos).replace(/[_mn]/g, "");
          if (F) {
            this.finishToken(135, Ze);
            return;
          }
          if (Y) {
            this.finishToken(136, Ze);
            return;
          }
          let Dt = de ? parseInt(Ze, 8) : parseFloat(Ze);
          this.finishToken(134, Dt);
        }
        readCodePoint(y) {
          let { code: p, pos: b } = il(this.input, this.state.pos, this.state.lineStart, this.state.curLine, y, this.errorHandlers_readCodePoint);
          return this.state.pos = b, p;
        }
        readString(y) {
          let { str: p, pos: b, curLine: T, lineStart: F } = _u(y === 34 ? "double" : "single", this.input, this.state.pos + 1, this.state.lineStart, this.state.curLine, this.errorHandlers_readStringContents_string);
          this.state.pos = b + 1, this.state.lineStart = F, this.state.curLine = T, this.finishToken(133, p);
        }
        readTemplateContinuation() {
          this.match(8) || this.unexpected(null, 8), this.state.pos--, this.readTemplateToken();
        }
        readTemplateToken() {
          let y = this.input[this.state.pos], { str: p, firstInvalidLoc: b, pos: T, curLine: F, lineStart: Y } = _u("template", this.input, this.state.pos + 1, this.state.lineStart, this.state.curLine, this.errorHandlers_readStringContents_template);
          this.state.pos = T + 1, this.state.lineStart = Y, this.state.curLine = F, b && (this.state.firstInvalidTemplateEscapePos = new pt(b.curLine, b.pos - b.lineStart, b.pos)), this.input.codePointAt(T) === 96 ? this.finishToken(24, b ? null : y + p + "`") : (this.state.pos++, this.finishToken(25, b ? null : y + p + "${"));
        }
        recordStrictModeErrors(y, p) {
          let b = p.index;
          this.state.strict && !this.state.strictErrors.has(b) ? this.raise(y, p) : this.state.strictErrors.set(b, [y, p]);
        }
        readWord1(y) {
          this.state.containsEsc = !1;
          let p = "", b = this.state.pos, T = this.state.pos;
          for (y !== void 0 && (this.state.pos += y <= 65535 ? 1 : 2); this.state.pos < this.length; ) {
            let F = this.codePointAtPos(this.state.pos);
            if (rl(F)) this.state.pos += F <= 65535 ? 1 : 2;
            else if (F === 92) {
              this.state.containsEsc = !0, p += this.input.slice(T, this.state.pos);
              let Y = this.state.curPosition(), ie = this.state.pos === b ? Xi : rl;
              if (this.input.charCodeAt(++this.state.pos) !== 117) {
                this.raise(Se.MissingUnicodeEscape, this.state.curPosition()), T = this.state.pos - 1;
                continue;
              }
              ++this.state.pos;
              let de = this.readCodePoint(!0);
              de !== null && (ie(de) || this.raise(Se.EscapedCharNotAnIdentifier, Y), p += String.fromCodePoint(de)), T = this.state.pos;
            } else break;
          }
          return p + this.input.slice(T, this.state.pos);
        }
        readWord(y) {
          let p = this.readWord1(y), b = _g.get(p);
          b !== void 0 ? this.finishToken(b, vi(b)) : this.finishToken(132, p);
        }
        checkKeywordEscapes() {
          let { type: y } = this.state;
          Ug(y) && this.state.containsEsc && this.raise(Se.InvalidEscapedReservedWord, this.state.startLoc, { reservedWord: vi(y) });
        }
        raise(y, p, b = {}) {
          let T = p instanceof pt ? p : p.loc.start, F = y(T, b);
          if (!this.options.errorRecovery) throw F;
          return this.isLookahead || this.state.errors.push(F), F;
        }
        raiseOverwrite(y, p, b = {}) {
          let T = p instanceof pt ? p : p.loc.start, F = T.index, Y = this.state.errors;
          for (let ie = Y.length - 1; ie >= 0; ie--) {
            let de = Y[ie];
            if (de.loc.index === F) return Y[ie] = y(T, b);
            if (de.loc.index < F) break;
          }
          return this.raise(y, p, b);
        }
        updateContext(y) {
        }
        unexpected(y, p) {
          throw this.raise(Se.UnexpectedToken, y ?? this.state.startLoc, { expected: p ? vi(p) : null });
        }
        expectPlugin(y, p) {
          if (this.hasPlugin(y)) return !0;
          throw this.raise(Se.MissingPlugin, p ?? this.state.startLoc, { missingPlugin: [y] });
        }
        expectOnePlugin(y) {
          if (!y.some((p) => this.hasPlugin(p))) throw this.raise(Se.MissingOneOfPlugins, this.state.startLoc, { missingPlugin: y });
        }
        errorBuilder(y) {
          return (p, b, T) => {
            this.raise(y, Il(p, b, T));
          };
        }
      }, Fc = class {
        constructor() {
          this.privateNames = /* @__PURE__ */ new Set(), this.loneAccessors = /* @__PURE__ */ new Map(), this.undefinedPrivateNames = /* @__PURE__ */ new Map();
        }
      }, js = class {
        constructor(y) {
          this.parser = void 0, this.stack = [], this.undefinedPrivateNames = /* @__PURE__ */ new Map(), this.parser = y;
        }
        current() {
          return this.stack[this.stack.length - 1];
        }
        enter() {
          this.stack.push(new Fc());
        }
        exit() {
          let y = this.stack.pop(), p = this.current();
          for (let [b, T] of Array.from(y.undefinedPrivateNames)) p ? p.undefinedPrivateNames.has(b) || p.undefinedPrivateNames.set(b, T) : this.parser.raise(Se.InvalidPrivateFieldResolution, T, { identifierName: b });
        }
        declarePrivateName(y, p, b) {
          let { privateNames: T, loneAccessors: F, undefinedPrivateNames: Y } = this.current(), ie = T.has(y);
          if (p & 3) {
            let de = ie && F.get(y);
            if (de) {
              let he = de & 4, fe = p & 4, Ze = de & 3, Dt = p & 3;
              ie = Ze === Dt || he !== fe, ie || F.delete(y);
            } else ie || F.set(y, p);
          }
          ie && this.parser.raise(Se.PrivateNameRedeclaration, b, { identifierName: y }), T.add(y), Y.delete(y);
        }
        usePrivateName(y, p) {
          let b;
          for (b of this.stack) if (b.privateNames.has(y)) return;
          b ? b.undefinedPrivateNames.set(y, p) : this.parser.raise(Se.InvalidPrivateFieldResolution, p, { identifierName: y });
        }
      }, Kd = class {
        constructor(y = 0) {
          this.type = y;
        }
        canBeArrowParameterDeclaration() {
          return this.type === 2 || this.type === 1;
        }
        isCertainlyParameterDeclaration() {
          return this.type === 3;
        }
      }, Gv = class extends Kd {
        constructor(y) {
          super(y), this.declarationErrors = /* @__PURE__ */ new Map();
        }
        recordDeclarationError(y, p) {
          let b = p.index;
          this.declarationErrors.set(b, [y, p]);
        }
        clearDeclarationError(y) {
          this.declarationErrors.delete(y);
        }
        iterateErrors(y) {
          this.declarationErrors.forEach(y);
        }
      }, tS = class {
        constructor(y) {
          this.parser = void 0, this.stack = [new Kd()], this.parser = y;
        }
        enter(y) {
          this.stack.push(y);
        }
        exit() {
          this.stack.pop();
        }
        recordParameterInitializerError(y, p) {
          let b = p.loc.start, { stack: T } = this, F = T.length - 1, Y = T[F];
          for (; !Y.isCertainlyParameterDeclaration(); ) {
            if (Y.canBeArrowParameterDeclaration()) Y.recordDeclarationError(y, b);
            else return;
            Y = T[--F];
          }
          this.parser.raise(y, b);
        }
        recordArrowParameterBindingError(y, p) {
          let { stack: b } = this, T = b[b.length - 1], F = p.loc.start;
          if (T.isCertainlyParameterDeclaration()) this.parser.raise(y, F);
          else if (T.canBeArrowParameterDeclaration()) T.recordDeclarationError(y, F);
          else return;
        }
        recordAsyncArrowParametersError(y) {
          let { stack: p } = this, b = p.length - 1, T = p[b];
          for (; T.canBeArrowParameterDeclaration(); ) T.type === 2 && T.recordDeclarationError(Se.AwaitBindingIdentifier, y), T = p[--b];
        }
        validateAsPattern() {
          let { stack: y } = this, p = y[y.length - 1];
          p.canBeArrowParameterDeclaration() && p.iterateErrors(([b, T]) => {
            this.parser.raise(b, T);
            let F = y.length - 2, Y = y[F];
            for (; Y.canBeArrowParameterDeclaration(); ) Y.clearDeclarationError(T.index), Y = y[--F];
          });
        }
      };
      function nS() {
        return new Kd(3);
      }
      function rS() {
        return new Gv(1);
      }
      function iS() {
        return new Gv(2);
      }
      function Lu() {
        return new Kd();
      }
      var $e = class {
        constructor() {
          this.stacks = [];
        }
        enter(y) {
          this.stacks.push(y);
        }
        exit() {
          this.stacks.pop();
        }
        currentFlags() {
          return this.stacks[this.stacks.length - 1];
        }
        get hasAwait() {
          return (this.currentFlags() & 2) > 0;
        }
        get hasYield() {
          return (this.currentFlags() & 1) > 0;
        }
        get hasReturn() {
          return (this.currentFlags() & 4) > 0;
        }
        get hasIn() {
          return (this.currentFlags() & 8) > 0;
        }
      };
      function Ye(y, p) {
        return (y ? 2 : 0) | (p ? 1 : 0);
      }
      var ze = class extends eS {
        addExtra(y, p, b, T = !0) {
          if (!y) return;
          let F = y.extra = y.extra || {};
          T ? F[p] = b : Object.defineProperty(F, p, { enumerable: T, value: b });
        }
        isContextual(y) {
          return this.state.type === y && !this.state.containsEsc;
        }
        isUnparsedContextual(y, p) {
          let b = y + p.length;
          if (this.input.slice(y, b) === p) {
            let T = this.input.charCodeAt(b);
            return !(rl(T) || (T & 64512) === 55296);
          }
          return !1;
        }
        isLookaheadContextual(y) {
          let p = this.nextTokenStart();
          return this.isUnparsedContextual(p, y);
        }
        eatContextual(y) {
          return this.isContextual(y) ? (this.next(), !0) : !1;
        }
        expectContextual(y, p) {
          if (!this.eatContextual(y)) {
            if (p != null) throw this.raise(p, this.state.startLoc);
            this.unexpected(null, y);
          }
        }
        canInsertSemicolon() {
          return this.match(139) || this.match(8) || this.hasPrecedingLineBreak();
        }
        hasPrecedingLineBreak() {
          return Qg.test(this.input.slice(this.state.lastTokEndLoc.index, this.state.start));
        }
        hasFollowingLineBreak() {
          return Zg.lastIndex = this.state.end, Zg.test(this.input);
        }
        isLineTerminator() {
          return this.eat(13) || this.canInsertSemicolon();
        }
        semicolon(y = !0) {
          (y ? this.isLineTerminator() : this.eat(13)) || this.raise(Se.MissingSemicolon, this.state.lastTokEndLoc);
        }
        expect(y, p) {
          this.eat(y) || this.unexpected(p, y);
        }
        tryParse(y, p = this.state.clone()) {
          let b = { node: null };
          try {
            let T = y((F = null) => {
              throw b.node = F, b;
            });
            if (this.state.errors.length > p.errors.length) {
              let F = this.state;
              return this.state = p, this.state.tokensLength = F.tokensLength, { node: T, error: F.errors[p.errors.length], thrown: !1, aborted: !1, failState: F };
            }
            return { node: T, error: null, thrown: !1, aborted: !1, failState: null };
          } catch (T) {
            let F = this.state;
            if (this.state = p, T instanceof SyntaxError) return { node: null, error: T, thrown: !0, aborted: !1, failState: F };
            if (T === b) return { node: b.node, error: null, thrown: !1, aborted: !0, failState: F };
            throw T;
          }
        }
        checkExpressionErrors(y, p) {
          if (!y) return !1;
          let { shorthandAssignLoc: b, doubleProtoLoc: T, privateKeyLoc: F, optionalParametersLoc: Y } = y, ie = !!b || !!T || !!Y || !!F;
          if (!p) return ie;
          b != null && this.raise(Se.InvalidCoverInitializedName, b), T != null && this.raise(Se.DuplicateProto, T), F != null && this.raise(Se.UnexpectedPrivateField, F), Y != null && this.unexpected(Y);
        }
        isLiteralPropertyName() {
          return Rv(this.state.type);
        }
        isPrivateName(y) {
          return y.type === "PrivateName";
        }
        getPrivateNameSV(y) {
          return y.id.name;
        }
        hasPropertyAsPrivateName(y) {
          return (y.type === "MemberExpression" || y.type === "OptionalMemberExpression") && this.isPrivateName(y.property);
        }
        isObjectProperty(y) {
          return y.type === "ObjectProperty";
        }
        isObjectMethod(y) {
          return y.type === "ObjectMethod";
        }
        initializeScopes(y = this.options.sourceType === "module") {
          let p = this.state.labels;
          this.state.labels = [];
          let b = this.exportedIdentifiers;
          this.exportedIdentifiers = /* @__PURE__ */ new Set();
          let T = this.inModule;
          this.inModule = y;
          let F = this.scope, Y = this.getScopeHandler();
          this.scope = new Y(this, y);
          let ie = this.prodParam;
          this.prodParam = new $e();
          let de = this.classScope;
          this.classScope = new js(this);
          let he = this.expressionScope;
          return this.expressionScope = new tS(this), () => {
            this.state.labels = p, this.exportedIdentifiers = b, this.inModule = T, this.scope = F, this.prodParam = ie, this.classScope = de, this.expressionScope = he;
          };
        }
        enterInitialScopes() {
          let y = 0;
          this.inModule && (y |= 2), this.scope.enter(1), this.prodParam.enter(y);
        }
        checkDestructuringPrivate(y) {
          let { privateKeyLoc: p } = y;
          p !== null && this.expectPlugin("destructuringPrivate", p);
        }
      }, _t = class {
        constructor() {
          this.shorthandAssignLoc = null, this.doubleProtoLoc = null, this.privateKeyLoc = null, this.optionalParametersLoc = null;
        }
      }, fn = class {
        constructor(y, p, b) {
          this.type = "", this.start = p, this.end = 0, this.loc = new bt(b), y != null && y.options.ranges && (this.range = [p, 0]), y != null && y.filename && (this.loc.filename = y.filename);
        }
      }, Yn = fn.prototype;
      Yn.__clone = function() {
        let y = new fn(void 0, this.start, this.loc.start), p = Object.keys(this);
        for (let b = 0, T = p.length; b < T; b++) {
          let F = p[b];
          F !== "leadingComments" && F !== "trailingComments" && F !== "innerComments" && (y[F] = this[F]);
        }
        return y;
      };
      function xi(y) {
        return Un(y);
      }
      function Un(y) {
        let { type: p, start: b, end: T, loc: F, range: Y, extra: ie, name: de } = y, he = Object.create(Yn);
        return he.type = p, he.start = b, he.end = T, he.loc = F, he.range = Y, he.extra = ie, he.name = de, p === "Placeholder" && (he.expectedNode = y.expectedNode), he;
      }
      function ty(y) {
        let { type: p, start: b, end: T, loc: F, range: Y, extra: ie } = y;
        if (p === "Placeholder") return xi(y);
        let de = Object.create(Yn);
        return de.type = p, de.start = b, de.end = T, de.loc = F, de.range = Y, y.raw !== void 0 ? de.raw = y.raw : de.extra = ie, de.value = y.value, de;
      }
      var oS = class extends ze {
        startNode() {
          let y = this.state.startLoc;
          return new fn(this, y.index, y);
        }
        startNodeAt(y) {
          return new fn(this, y.index, y);
        }
        startNodeAtNode(y) {
          return this.startNodeAt(y.loc.start);
        }
        finishNode(y, p) {
          return this.finishNodeAt(y, p, this.state.lastTokEndLoc);
        }
        finishNodeAt(y, p, b) {
          return y.type = p, y.end = b.index, y.loc.end = b, this.options.ranges && (y.range[1] = b.index), this.options.attachComment && this.processComment(y), y;
        }
        resetStartLocation(y, p) {
          y.start = p.index, y.loc.start = p, this.options.ranges && (y.range[0] = p.index);
        }
        resetEndLocation(y, p = this.state.lastTokEndLoc) {
          y.end = p.index, y.loc.end = p, this.options.ranges && (y.range[1] = p.index);
        }
        resetStartLocationFromNode(y, p) {
          this.resetStartLocation(y, p.loc.start);
        }
      }, ds = /* @__PURE__ */ new Set(["_", "any", "bool", "boolean", "empty", "extends", "false", "interface", "mixed", "null", "number", "static", "string", "true", "typeof", "void"]), Jt = ga`flow`({ AmbiguousConditionalArrow: "Ambiguous expression: wrap the arrow functions in parentheses to disambiguate.", AmbiguousDeclareModuleKind: "Found both `declare module.exports` and `declare export` in the same module. Modules can only have 1 since they are either an ES module or they are a CommonJS module.", AssignReservedType: ({ reservedType: y }) => `Cannot overwrite reserved type ${y}.`, DeclareClassElement: "The `declare` modifier can only appear on class fields.", DeclareClassFieldInitializer: "Initializers are not allowed in fields with the `declare` modifier.", DuplicateDeclareModuleExports: "Duplicate `declare module.exports` statement.", EnumBooleanMemberNotInitialized: ({ memberName: y, enumName: p }) => `Boolean enum members need to be initialized. Use either \`${y} = true,\` or \`${y} = false,\` in enum \`${p}\`.`, EnumDuplicateMemberName: ({ memberName: y, enumName: p }) => `Enum member names need to be unique, but the name \`${y}\` has already been used before in enum \`${p}\`.`, EnumInconsistentMemberValues: ({ enumName: y }) => `Enum \`${y}\` has inconsistent member initializers. Either use no initializers, or consistently use literals (either booleans, numbers, or strings) for all member initializers.`, EnumInvalidExplicitType: ({ invalidEnumType: y, enumName: p }) => `Enum type \`${y}\` is not valid. Use one of \`boolean\`, \`number\`, \`string\`, or \`symbol\` in enum \`${p}\`.`, EnumInvalidExplicitTypeUnknownSupplied: ({ enumName: y }) => `Supplied enum type is not valid. Use one of \`boolean\`, \`number\`, \`string\`, or \`symbol\` in enum \`${y}\`.`, EnumInvalidMemberInitializerPrimaryType: ({ enumName: y, memberName: p, explicitType: b }) => `Enum \`${y}\` has type \`${b}\`, so the initializer of \`${p}\` needs to be a ${b} literal.`, EnumInvalidMemberInitializerSymbolType: ({ enumName: y, memberName: p }) => `Symbol enum members cannot be initialized. Use \`${p},\` in enum \`${y}\`.`, EnumInvalidMemberInitializerUnknownType: ({ enumName: y, memberName: p }) => `The enum member initializer for \`${p}\` needs to be a literal (either a boolean, number, or string) in enum \`${y}\`.`, EnumInvalidMemberName: ({ enumName: y, memberName: p, suggestion: b }) => `Enum member names cannot start with lowercase 'a' through 'z'. Instead of using \`${p}\`, consider using \`${b}\`, in enum \`${y}\`.`, EnumNumberMemberNotInitialized: ({ enumName: y, memberName: p }) => `Number enum members need to be initialized, e.g. \`${p} = 1\` in enum \`${y}\`.`, EnumStringMemberInconsistentlyInitialized: ({ enumName: y }) => `String enum members need to consistently either all use initializers, or use no initializers, in enum \`${y}\`.`, GetterMayNotHaveThisParam: "A getter cannot have a `this` parameter.", ImportReflectionHasImportType: "An `import module` declaration can not use `type` or `typeof` keyword.", ImportTypeShorthandOnlyInPureImport: "The `type` and `typeof` keywords on named imports can only be used on regular `import` statements. It cannot be used with `import type` or `import typeof` statements.", InexactInsideExact: "Explicit inexact syntax cannot appear inside an explicit exact object type.", InexactInsideNonObject: "Explicit inexact syntax cannot appear in class or interface definitions.", InexactVariance: "Explicit inexact syntax cannot have variance.", InvalidNonTypeImportInDeclareModule: "Imports within a `declare module` body must always be `import type` or `import typeof`.", MissingTypeParamDefault: "Type parameter declaration needs a default, since a preceding type parameter declaration has a default.", NestedDeclareModule: "`declare module` cannot be used inside another `declare module`.", NestedFlowComment: "Cannot have a flow comment inside another flow comment.", PatternIsOptional: Object.assign({ message: "A binding pattern parameter cannot be optional in an implementation signature." }, { reasonCode: "OptionalBindingPattern" }), SetterMayNotHaveThisParam: "A setter cannot have a `this` parameter.", SpreadVariance: "Spread properties cannot have variance.", ThisParamAnnotationRequired: "A type annotation is required for the `this` parameter.", ThisParamBannedInConstructor: "Constructors cannot have a `this` parameter; constructors don't bind `this` like other functions.", ThisParamMayNotBeOptional: "The `this` parameter cannot be optional.", ThisParamMustBeFirst: "The `this` parameter must be the first function parameter.", ThisParamNoDefault: "The `this` parameter may not have a default value.", TypeBeforeInitializer: "Type annotations must come before default assignments, e.g. instead of `age = 25: number` use `age: number = 25`.", TypeCastInPattern: "The type cast expression is expected to be wrapped with parenthesis.", UnexpectedExplicitInexactInObject: "Explicit inexact syntax must appear at the end of an inexact object.", UnexpectedReservedType: ({ reservedType: y }) => `Unexpected reserved type ${y}.`, UnexpectedReservedUnderscore: "`_` is only allowed as a type argument to call or new.", UnexpectedSpaceBetweenModuloChecks: "Spaces between `%` and `checks` are not allowed here.", UnexpectedSpreadType: "Spread operator cannot appear in class or interface definitions.", UnexpectedSubtractionOperand: 'Unexpected token, expected "number" or "bigint".', UnexpectedTokenAfterTypeParameter: "Expected an arrow function after this type parameter declaration.", UnexpectedTypeParameterBeforeAsyncArrowFunction: "Type parameters must come after the async keyword, e.g. instead of `<T> async () => {}`, use `async <T>() => {}`.", UnsupportedDeclareExportKind: ({ unsupportedExportKind: y, suggestion: p }) => `\`declare export ${y}\` is not supported. Use \`${p}\` instead.`, UnsupportedStatementInDeclareModule: "Only declares and type imports are allowed inside declare module.", UnterminatedFlowComment: "Unterminated flow-comment." });
      function sS(y) {
        return y.type === "DeclareExportAllDeclaration" || y.type === "DeclareExportDeclaration" && (!y.declaration || y.declaration.type !== "TypeAlias" && y.declaration.type !== "InterfaceDeclaration");
      }
      function Bu(y) {
        return y.importKind === "type" || y.importKind === "typeof";
      }
      var Jf = { const: "declare export var", let: "declare export var", type: "export type", interface: "export interface" };
      function Xf(y, p) {
        let b = [], T = [];
        for (let F = 0; F < y.length; F++) (p(y[F], F, y) ? b : T).push(y[F]);
        return [b, T];
      }
      var fr = /\*?\s*@((?:no)?flow)\b/, aS = (y) => class extends y {
        constructor(...p) {
          super(...p), this.flowPragma = void 0;
        }
        getScopeHandler() {
          return Kg;
        }
        shouldParseTypes() {
          return this.getPluginOption("flow", "all") || this.flowPragma === "flow";
        }
        shouldParseEnums() {
          return !!this.getPluginOption("flow", "enums");
        }
        finishToken(p, b) {
          p !== 133 && p !== 13 && p !== 28 && this.flowPragma === void 0 && (this.flowPragma = null), super.finishToken(p, b);
        }
        addComment(p) {
          if (this.flowPragma === void 0) {
            let b = fr.exec(p.value);
            if (b) if (b[1] === "flow") this.flowPragma = "flow";
            else if (b[1] === "noflow") this.flowPragma = "noflow";
            else throw new Error("Unexpected flow pragma");
          }
          super.addComment(p);
        }
        flowParseTypeInitialiser(p) {
          let b = this.state.inType;
          this.state.inType = !0, this.expect(p || 14);
          let T = this.flowParseType();
          return this.state.inType = b, T;
        }
        flowParsePredicate() {
          let p = this.startNode(), b = this.state.startLoc;
          return this.next(), this.expectContextual(110), this.state.lastTokStartLoc.index > b.index + 1 && this.raise(Jt.UnexpectedSpaceBetweenModuloChecks, b), this.eat(10) ? (p.value = super.parseExpression(), this.expect(11), this.finishNode(p, "DeclaredPredicate")) : this.finishNode(p, "InferredPredicate");
        }
        flowParseTypeAndPredicateInitialiser() {
          let p = this.state.inType;
          this.state.inType = !0, this.expect(14);
          let b = null, T = null;
          return this.match(54) ? (this.state.inType = p, T = this.flowParsePredicate()) : (b = this.flowParseType(), this.state.inType = p, this.match(54) && (T = this.flowParsePredicate())), [b, T];
        }
        flowParseDeclareClass(p) {
          return this.next(), this.flowParseInterfaceish(p, !0), this.finishNode(p, "DeclareClass");
        }
        flowParseDeclareFunction(p) {
          this.next();
          let b = p.id = this.parseIdentifier(), T = this.startNode(), F = this.startNode();
          this.match(47) ? T.typeParameters = this.flowParseTypeParameterDeclaration() : T.typeParameters = null, this.expect(10);
          let Y = this.flowParseFunctionTypeParams();
          return T.params = Y.params, T.rest = Y.rest, T.this = Y._this, this.expect(11), [T.returnType, p.predicate] = this.flowParseTypeAndPredicateInitialiser(), F.typeAnnotation = this.finishNode(T, "FunctionTypeAnnotation"), b.typeAnnotation = this.finishNode(F, "TypeAnnotation"), this.resetEndLocation(b), this.semicolon(), this.scope.declareName(p.id.name, 2048, p.id.loc.start), this.finishNode(p, "DeclareFunction");
        }
        flowParseDeclare(p, b) {
          if (this.match(80)) return this.flowParseDeclareClass(p);
          if (this.match(68)) return this.flowParseDeclareFunction(p);
          if (this.match(74)) return this.flowParseDeclareVariable(p);
          if (this.eatContextual(127)) return this.match(16) ? this.flowParseDeclareModuleExports(p) : (b && this.raise(Jt.NestedDeclareModule, this.state.lastTokStartLoc), this.flowParseDeclareModule(p));
          if (this.isContextual(130)) return this.flowParseDeclareTypeAlias(p);
          if (this.isContextual(131)) return this.flowParseDeclareOpaqueType(p);
          if (this.isContextual(129)) return this.flowParseDeclareInterface(p);
          if (this.match(82)) return this.flowParseDeclareExportDeclaration(p, b);
          this.unexpected();
        }
        flowParseDeclareVariable(p) {
          return this.next(), p.id = this.flowParseTypeAnnotatableIdentifier(!0), this.scope.declareName(p.id.name, 5, p.id.loc.start), this.semicolon(), this.finishNode(p, "DeclareVariable");
        }
        flowParseDeclareModule(p) {
          this.scope.enter(0), this.match(133) ? p.id = super.parseExprAtom() : p.id = this.parseIdentifier();
          let b = p.body = this.startNode(), T = b.body = [];
          for (this.expect(5); !this.match(8); ) {
            let ie = this.startNode();
            this.match(83) ? (this.next(), !this.isContextual(130) && !this.match(87) && this.raise(Jt.InvalidNonTypeImportInDeclareModule, this.state.lastTokStartLoc), super.parseImport(ie)) : (this.expectContextual(125, Jt.UnsupportedStatementInDeclareModule), ie = this.flowParseDeclare(ie, !0)), T.push(ie);
          }
          this.scope.exit(), this.expect(8), this.finishNode(b, "BlockStatement");
          let F = null, Y = !1;
          return T.forEach((ie) => {
            sS(ie) ? (F === "CommonJS" && this.raise(Jt.AmbiguousDeclareModuleKind, ie), F = "ES") : ie.type === "DeclareModuleExports" && (Y && this.raise(Jt.DuplicateDeclareModuleExports, ie), F === "ES" && this.raise(Jt.AmbiguousDeclareModuleKind, ie), F = "CommonJS", Y = !0);
          }), p.kind = F || "CommonJS", this.finishNode(p, "DeclareModule");
        }
        flowParseDeclareExportDeclaration(p, b) {
          if (this.expect(82), this.eat(65)) return this.match(68) || this.match(80) ? p.declaration = this.flowParseDeclare(this.startNode()) : (p.declaration = this.flowParseType(), this.semicolon()), p.default = !0, this.finishNode(p, "DeclareExportDeclaration");
          if (this.match(75) || this.isLet() || (this.isContextual(130) || this.isContextual(129)) && !b) {
            let T = this.state.value;
            throw this.raise(Jt.UnsupportedDeclareExportKind, this.state.startLoc, { unsupportedExportKind: T, suggestion: Jf[T] });
          }
          if (this.match(74) || this.match(68) || this.match(80) || this.isContextual(131)) return p.declaration = this.flowParseDeclare(this.startNode()), p.default = !1, this.finishNode(p, "DeclareExportDeclaration");
          if (this.match(55) || this.match(5) || this.isContextual(129) || this.isContextual(130) || this.isContextual(131)) return p = this.parseExport(p, null), p.type === "ExportNamedDeclaration" && (p.type = "ExportDeclaration", p.default = !1, delete p.exportKind), p.type = "Declare" + p.type, p;
          this.unexpected();
        }
        flowParseDeclareModuleExports(p) {
          return this.next(), this.expectContextual(111), p.typeAnnotation = this.flowParseTypeAnnotation(), this.semicolon(), this.finishNode(p, "DeclareModuleExports");
        }
        flowParseDeclareTypeAlias(p) {
          this.next();
          let b = this.flowParseTypeAlias(p);
          return b.type = "DeclareTypeAlias", b;
        }
        flowParseDeclareOpaqueType(p) {
          this.next();
          let b = this.flowParseOpaqueType(p, !0);
          return b.type = "DeclareOpaqueType", b;
        }
        flowParseDeclareInterface(p) {
          return this.next(), this.flowParseInterfaceish(p, !1), this.finishNode(p, "DeclareInterface");
        }
        flowParseInterfaceish(p, b) {
          if (p.id = this.flowParseRestrictedIdentifier(!b, !0), this.scope.declareName(p.id.name, b ? 17 : 8201, p.id.loc.start), this.match(47) ? p.typeParameters = this.flowParseTypeParameterDeclaration() : p.typeParameters = null, p.extends = [], this.eat(81)) do
            p.extends.push(this.flowParseInterfaceExtends());
          while (!b && this.eat(12));
          if (b) {
            if (p.implements = [], p.mixins = [], this.eatContextual(117)) do
              p.mixins.push(this.flowParseInterfaceExtends());
            while (this.eat(12));
            if (this.eatContextual(113)) do
              p.implements.push(this.flowParseInterfaceExtends());
            while (this.eat(12));
          }
          p.body = this.flowParseObjectType({ allowStatic: b, allowExact: !1, allowSpread: !1, allowProto: b, allowInexact: !1 });
        }
        flowParseInterfaceExtends() {
          let p = this.startNode();
          return p.id = this.flowParseQualifiedTypeIdentifier(), this.match(47) ? p.typeParameters = this.flowParseTypeParameterInstantiation() : p.typeParameters = null, this.finishNode(p, "InterfaceExtends");
        }
        flowParseInterface(p) {
          return this.flowParseInterfaceish(p, !1), this.finishNode(p, "InterfaceDeclaration");
        }
        checkNotUnderscore(p) {
          p === "_" && this.raise(Jt.UnexpectedReservedUnderscore, this.state.startLoc);
        }
        checkReservedType(p, b, T) {
          ds.has(p) && this.raise(T ? Jt.AssignReservedType : Jt.UnexpectedReservedType, b, { reservedType: p });
        }
        flowParseRestrictedIdentifier(p, b) {
          return this.checkReservedType(this.state.value, this.state.startLoc, b), this.parseIdentifier(p);
        }
        flowParseTypeAlias(p) {
          return p.id = this.flowParseRestrictedIdentifier(!1, !0), this.scope.declareName(p.id.name, 8201, p.id.loc.start), this.match(47) ? p.typeParameters = this.flowParseTypeParameterDeclaration() : p.typeParameters = null, p.right = this.flowParseTypeInitialiser(29), this.semicolon(), this.finishNode(p, "TypeAlias");
        }
        flowParseOpaqueType(p, b) {
          return this.expectContextual(130), p.id = this.flowParseRestrictedIdentifier(!0, !0), this.scope.declareName(p.id.name, 8201, p.id.loc.start), this.match(47) ? p.typeParameters = this.flowParseTypeParameterDeclaration() : p.typeParameters = null, p.supertype = null, this.match(14) && (p.supertype = this.flowParseTypeInitialiser(14)), p.impltype = null, b || (p.impltype = this.flowParseTypeInitialiser(29)), this.semicolon(), this.finishNode(p, "OpaqueType");
        }
        flowParseTypeParameter(p = !1) {
          let b = this.state.startLoc, T = this.startNode(), F = this.flowParseVariance(), Y = this.flowParseTypeAnnotatableIdentifier();
          return T.name = Y.name, T.variance = F, T.bound = Y.typeAnnotation, this.match(29) ? (this.eat(29), T.default = this.flowParseType()) : p && this.raise(Jt.MissingTypeParamDefault, b), this.finishNode(T, "TypeParameter");
        }
        flowParseTypeParameterDeclaration() {
          let p = this.state.inType, b = this.startNode();
          b.params = [], this.state.inType = !0, this.match(47) || this.match(142) ? this.next() : this.unexpected();
          let T = !1;
          do {
            let F = this.flowParseTypeParameter(T);
            b.params.push(F), F.default && (T = !0), this.match(48) || this.expect(12);
          } while (!this.match(48));
          return this.expect(48), this.state.inType = p, this.finishNode(b, "TypeParameterDeclaration");
        }
        flowParseTypeParameterInstantiation() {
          let p = this.startNode(), b = this.state.inType;
          p.params = [], this.state.inType = !0, this.expect(47);
          let T = this.state.noAnonFunctionType;
          for (this.state.noAnonFunctionType = !1; !this.match(48); ) p.params.push(this.flowParseType()), this.match(48) || this.expect(12);
          return this.state.noAnonFunctionType = T, this.expect(48), this.state.inType = b, this.finishNode(p, "TypeParameterInstantiation");
        }
        flowParseTypeParameterInstantiationCallOrNew() {
          let p = this.startNode(), b = this.state.inType;
          for (p.params = [], this.state.inType = !0, this.expect(47); !this.match(48); ) p.params.push(this.flowParseTypeOrImplicitInstantiation()), this.match(48) || this.expect(12);
          return this.expect(48), this.state.inType = b, this.finishNode(p, "TypeParameterInstantiation");
        }
        flowParseInterfaceType() {
          let p = this.startNode();
          if (this.expectContextual(129), p.extends = [], this.eat(81)) do
            p.extends.push(this.flowParseInterfaceExtends());
          while (this.eat(12));
          return p.body = this.flowParseObjectType({ allowStatic: !1, allowExact: !1, allowSpread: !1, allowProto: !1, allowInexact: !1 }), this.finishNode(p, "InterfaceTypeAnnotation");
        }
        flowParseObjectPropertyKey() {
          return this.match(134) || this.match(133) ? super.parseExprAtom() : this.parseIdentifier(!0);
        }
        flowParseObjectTypeIndexer(p, b, T) {
          return p.static = b, this.lookahead().type === 14 ? (p.id = this.flowParseObjectPropertyKey(), p.key = this.flowParseTypeInitialiser()) : (p.id = null, p.key = this.flowParseType()), this.expect(3), p.value = this.flowParseTypeInitialiser(), p.variance = T, this.finishNode(p, "ObjectTypeIndexer");
        }
        flowParseObjectTypeInternalSlot(p, b) {
          return p.static = b, p.id = this.flowParseObjectPropertyKey(), this.expect(3), this.expect(3), this.match(47) || this.match(10) ? (p.method = !0, p.optional = !1, p.value = this.flowParseObjectTypeMethodish(this.startNodeAt(p.loc.start))) : (p.method = !1, this.eat(17) && (p.optional = !0), p.value = this.flowParseTypeInitialiser()), this.finishNode(p, "ObjectTypeInternalSlot");
        }
        flowParseObjectTypeMethodish(p) {
          for (p.params = [], p.rest = null, p.typeParameters = null, p.this = null, this.match(47) && (p.typeParameters = this.flowParseTypeParameterDeclaration()), this.expect(10), this.match(78) && (p.this = this.flowParseFunctionTypeParam(!0), p.this.name = null, this.match(11) || this.expect(12)); !this.match(11) && !this.match(21); ) p.params.push(this.flowParseFunctionTypeParam(!1)), this.match(11) || this.expect(12);
          return this.eat(21) && (p.rest = this.flowParseFunctionTypeParam(!1)), this.expect(11), p.returnType = this.flowParseTypeInitialiser(), this.finishNode(p, "FunctionTypeAnnotation");
        }
        flowParseObjectTypeCallProperty(p, b) {
          let T = this.startNode();
          return p.static = b, p.value = this.flowParseObjectTypeMethodish(T), this.finishNode(p, "ObjectTypeCallProperty");
        }
        flowParseObjectType({ allowStatic: p, allowExact: b, allowSpread: T, allowProto: F, allowInexact: Y }) {
          let ie = this.state.inType;
          this.state.inType = !0;
          let de = this.startNode();
          de.callProperties = [], de.properties = [], de.indexers = [], de.internalSlots = [];
          let he, fe, Ze = !1;
          for (b && this.match(6) ? (this.expect(6), he = 9, fe = !0) : (this.expect(5), he = 8, fe = !1), de.exact = fe; !this.match(he); ) {
            let $t = !1, It = null, nr = null, Di = this.startNode();
            if (F && this.isContextual(118)) {
              let ii = this.lookahead();
              ii.type !== 14 && ii.type !== 17 && (this.next(), It = this.state.startLoc, p = !1);
            }
            if (p && this.isContextual(106)) {
              let ii = this.lookahead();
              ii.type !== 14 && ii.type !== 17 && (this.next(), $t = !0);
            }
            let Sr = this.flowParseVariance();
            if (this.eat(0)) It != null && this.unexpected(It), this.eat(0) ? (Sr && this.unexpected(Sr.loc.start), de.internalSlots.push(this.flowParseObjectTypeInternalSlot(Di, $t))) : de.indexers.push(this.flowParseObjectTypeIndexer(Di, $t, Sr));
            else if (this.match(10) || this.match(47)) It != null && this.unexpected(It), Sr && this.unexpected(Sr.loc.start), de.callProperties.push(this.flowParseObjectTypeCallProperty(Di, $t));
            else {
              let ii = "init";
              if (this.isContextual(99) || this.isContextual(104)) {
                let zs = this.lookahead();
                Rv(zs.type) && (ii = this.state.value, this.next());
              }
              let qo = this.flowParseObjectTypeProperty(Di, $t, It, Sr, ii, T, Y ?? !fe);
              qo === null ? (Ze = !0, nr = this.state.lastTokStartLoc) : de.properties.push(qo);
            }
            this.flowObjectTypeSemicolon(), nr && !this.match(8) && !this.match(9) && this.raise(Jt.UnexpectedExplicitInexactInObject, nr);
          }
          this.expect(he), T && (de.inexact = Ze);
          let Dt = this.finishNode(de, "ObjectTypeAnnotation");
          return this.state.inType = ie, Dt;
        }
        flowParseObjectTypeProperty(p, b, T, F, Y, ie, de) {
          if (this.eat(21)) return this.match(12) || this.match(13) || this.match(8) || this.match(9) ? (ie ? de || this.raise(Jt.InexactInsideExact, this.state.lastTokStartLoc) : this.raise(Jt.InexactInsideNonObject, this.state.lastTokStartLoc), F && this.raise(Jt.InexactVariance, F), null) : (ie || this.raise(Jt.UnexpectedSpreadType, this.state.lastTokStartLoc), T != null && this.unexpected(T), F && this.raise(Jt.SpreadVariance, F), p.argument = this.flowParseType(), this.finishNode(p, "ObjectTypeSpreadProperty"));
          {
            p.key = this.flowParseObjectPropertyKey(), p.static = b, p.proto = T != null, p.kind = Y;
            let he = !1;
            return this.match(47) || this.match(10) ? (p.method = !0, T != null && this.unexpected(T), F && this.unexpected(F.loc.start), p.value = this.flowParseObjectTypeMethodish(this.startNodeAt(p.loc.start)), (Y === "get" || Y === "set") && this.flowCheckGetterSetterParams(p), !ie && p.key.name === "constructor" && p.value.this && this.raise(Jt.ThisParamBannedInConstructor, p.value.this)) : (Y !== "init" && this.unexpected(), p.method = !1, this.eat(17) && (he = !0), p.value = this.flowParseTypeInitialiser(), p.variance = F), p.optional = he, this.finishNode(p, "ObjectTypeProperty");
          }
        }
        flowCheckGetterSetterParams(p) {
          let b = p.kind === "get" ? 0 : 1, T = p.value.params.length + (p.value.rest ? 1 : 0);
          p.value.this && this.raise(p.kind === "get" ? Jt.GetterMayNotHaveThisParam : Jt.SetterMayNotHaveThisParam, p.value.this), T !== b && this.raise(p.kind === "get" ? Se.BadGetterArity : Se.BadSetterArity, p), p.kind === "set" && p.value.rest && this.raise(Se.BadSetterRestParameter, p);
        }
        flowObjectTypeSemicolon() {
          !this.eat(13) && !this.eat(12) && !this.match(8) && !this.match(9) && this.unexpected();
        }
        flowParseQualifiedTypeIdentifier(p, b) {
          p != null || (p = this.state.startLoc);
          let T = b || this.flowParseRestrictedIdentifier(!0);
          for (; this.eat(16); ) {
            let F = this.startNodeAt(p);
            F.qualification = T, F.id = this.flowParseRestrictedIdentifier(!0), T = this.finishNode(F, "QualifiedTypeIdentifier");
          }
          return T;
        }
        flowParseGenericType(p, b) {
          let T = this.startNodeAt(p);
          return T.typeParameters = null, T.id = this.flowParseQualifiedTypeIdentifier(p, b), this.match(47) && (T.typeParameters = this.flowParseTypeParameterInstantiation()), this.finishNode(T, "GenericTypeAnnotation");
        }
        flowParseTypeofType() {
          let p = this.startNode();
          return this.expect(87), p.argument = this.flowParsePrimaryType(), this.finishNode(p, "TypeofTypeAnnotation");
        }
        flowParseTupleType() {
          let p = this.startNode();
          for (p.types = [], this.expect(0); this.state.pos < this.length && !this.match(3) && (p.types.push(this.flowParseType()), !this.match(3)); ) this.expect(12);
          return this.expect(3), this.finishNode(p, "TupleTypeAnnotation");
        }
        flowParseFunctionTypeParam(p) {
          let b = null, T = !1, F = null, Y = this.startNode(), ie = this.lookahead(), de = this.state.type === 78;
          return ie.type === 14 || ie.type === 17 ? (de && !p && this.raise(Jt.ThisParamMustBeFirst, Y), b = this.parseIdentifier(de), this.eat(17) && (T = !0, de && this.raise(Jt.ThisParamMayNotBeOptional, Y)), F = this.flowParseTypeInitialiser()) : F = this.flowParseType(), Y.name = b, Y.optional = T, Y.typeAnnotation = F, this.finishNode(Y, "FunctionTypeParam");
        }
        reinterpretTypeAsFunctionTypeParam(p) {
          let b = this.startNodeAt(p.loc.start);
          return b.name = null, b.optional = !1, b.typeAnnotation = p, this.finishNode(b, "FunctionTypeParam");
        }
        flowParseFunctionTypeParams(p = []) {
          let b = null, T = null;
          for (this.match(78) && (T = this.flowParseFunctionTypeParam(!0), T.name = null, this.match(11) || this.expect(12)); !this.match(11) && !this.match(21); ) p.push(this.flowParseFunctionTypeParam(!1)), this.match(11) || this.expect(12);
          return this.eat(21) && (b = this.flowParseFunctionTypeParam(!1)), { params: p, rest: b, _this: T };
        }
        flowIdentToTypeAnnotation(p, b, T) {
          switch (T.name) {
            case "any":
              return this.finishNode(b, "AnyTypeAnnotation");
            case "bool":
            case "boolean":
              return this.finishNode(b, "BooleanTypeAnnotation");
            case "mixed":
              return this.finishNode(b, "MixedTypeAnnotation");
            case "empty":
              return this.finishNode(b, "EmptyTypeAnnotation");
            case "number":
              return this.finishNode(b, "NumberTypeAnnotation");
            case "string":
              return this.finishNode(b, "StringTypeAnnotation");
            case "symbol":
              return this.finishNode(b, "SymbolTypeAnnotation");
            default:
              return this.checkNotUnderscore(T.name), this.flowParseGenericType(p, T);
          }
        }
        flowParsePrimaryType() {
          let p = this.state.startLoc, b = this.startNode(), T, F, Y = !1, ie = this.state.noAnonFunctionType;
          switch (this.state.type) {
            case 5:
              return this.flowParseObjectType({ allowStatic: !1, allowExact: !1, allowSpread: !0, allowProto: !1, allowInexact: !0 });
            case 6:
              return this.flowParseObjectType({ allowStatic: !1, allowExact: !0, allowSpread: !0, allowProto: !1, allowInexact: !1 });
            case 0:
              return this.state.noAnonFunctionType = !1, F = this.flowParseTupleType(), this.state.noAnonFunctionType = ie, F;
            case 47: {
              let de = this.startNode();
              return de.typeParameters = this.flowParseTypeParameterDeclaration(), this.expect(10), T = this.flowParseFunctionTypeParams(), de.params = T.params, de.rest = T.rest, de.this = T._this, this.expect(11), this.expect(19), de.returnType = this.flowParseType(), this.finishNode(de, "FunctionTypeAnnotation");
            }
            case 10: {
              let de = this.startNode();
              if (this.next(), !this.match(11) && !this.match(21)) if (Qt(this.state.type) || this.match(78)) {
                let he = this.lookahead().type;
                Y = he !== 17 && he !== 14;
              } else Y = !0;
              if (Y) {
                if (this.state.noAnonFunctionType = !1, F = this.flowParseType(), this.state.noAnonFunctionType = ie, this.state.noAnonFunctionType || !(this.match(12) || this.match(11) && this.lookahead().type === 19)) return this.expect(11), F;
                this.eat(12);
              }
              return F ? T = this.flowParseFunctionTypeParams([this.reinterpretTypeAsFunctionTypeParam(F)]) : T = this.flowParseFunctionTypeParams(), de.params = T.params, de.rest = T.rest, de.this = T._this, this.expect(11), this.expect(19), de.returnType = this.flowParseType(), de.typeParameters = null, this.finishNode(de, "FunctionTypeAnnotation");
            }
            case 133:
              return this.parseLiteral(this.state.value, "StringLiteralTypeAnnotation");
            case 85:
            case 86:
              return b.value = this.match(85), this.next(), this.finishNode(b, "BooleanLiteralTypeAnnotation");
            case 53:
              if (this.state.value === "-") {
                if (this.next(), this.match(134)) return this.parseLiteralAtNode(-this.state.value, "NumberLiteralTypeAnnotation", b);
                if (this.match(135)) return this.parseLiteralAtNode(-this.state.value, "BigIntLiteralTypeAnnotation", b);
                throw this.raise(Jt.UnexpectedSubtractionOperand, this.state.startLoc);
              }
              this.unexpected();
              return;
            case 134:
              return this.parseLiteral(this.state.value, "NumberLiteralTypeAnnotation");
            case 135:
              return this.parseLiteral(this.state.value, "BigIntLiteralTypeAnnotation");
            case 88:
              return this.next(), this.finishNode(b, "VoidTypeAnnotation");
            case 84:
              return this.next(), this.finishNode(b, "NullLiteralTypeAnnotation");
            case 78:
              return this.next(), this.finishNode(b, "ThisTypeAnnotation");
            case 55:
              return this.next(), this.finishNode(b, "ExistsTypeAnnotation");
            case 87:
              return this.flowParseTypeofType();
            default:
              if (Ug(this.state.type)) {
                let de = vi(this.state.type);
                return this.next(), super.createIdentifier(b, de);
              } else if (Qt(this.state.type)) return this.isContextual(129) ? this.flowParseInterfaceType() : this.flowIdentToTypeAnnotation(p, b, this.parseIdentifier());
          }
          this.unexpected();
        }
        flowParsePostfixType() {
          let p = this.state.startLoc, b = this.flowParsePrimaryType(), T = !1;
          for (; (this.match(0) || this.match(18)) && !this.canInsertSemicolon(); ) {
            let F = this.startNodeAt(p), Y = this.eat(18);
            T = T || Y, this.expect(0), !Y && this.match(3) ? (F.elementType = b, this.next(), b = this.finishNode(F, "ArrayTypeAnnotation")) : (F.objectType = b, F.indexType = this.flowParseType(), this.expect(3), T ? (F.optional = Y, b = this.finishNode(F, "OptionalIndexedAccessType")) : b = this.finishNode(F, "IndexedAccessType"));
          }
          return b;
        }
        flowParsePrefixType() {
          let p = this.startNode();
          return this.eat(17) ? (p.typeAnnotation = this.flowParsePrefixType(), this.finishNode(p, "NullableTypeAnnotation")) : this.flowParsePostfixType();
        }
        flowParseAnonFunctionWithoutParens() {
          let p = this.flowParsePrefixType();
          if (!this.state.noAnonFunctionType && this.eat(19)) {
            let b = this.startNodeAt(p.loc.start);
            return b.params = [this.reinterpretTypeAsFunctionTypeParam(p)], b.rest = null, b.this = null, b.returnType = this.flowParseType(), b.typeParameters = null, this.finishNode(b, "FunctionTypeAnnotation");
          }
          return p;
        }
        flowParseIntersectionType() {
          let p = this.startNode();
          this.eat(45);
          let b = this.flowParseAnonFunctionWithoutParens();
          for (p.types = [b]; this.eat(45); ) p.types.push(this.flowParseAnonFunctionWithoutParens());
          return p.types.length === 1 ? b : this.finishNode(p, "IntersectionTypeAnnotation");
        }
        flowParseUnionType() {
          let p = this.startNode();
          this.eat(43);
          let b = this.flowParseIntersectionType();
          for (p.types = [b]; this.eat(43); ) p.types.push(this.flowParseIntersectionType());
          return p.types.length === 1 ? b : this.finishNode(p, "UnionTypeAnnotation");
        }
        flowParseType() {
          let p = this.state.inType;
          this.state.inType = !0;
          let b = this.flowParseUnionType();
          return this.state.inType = p, b;
        }
        flowParseTypeOrImplicitInstantiation() {
          if (this.state.type === 132 && this.state.value === "_") {
            let p = this.state.startLoc, b = this.parseIdentifier();
            return this.flowParseGenericType(p, b);
          } else return this.flowParseType();
        }
        flowParseTypeAnnotation() {
          let p = this.startNode();
          return p.typeAnnotation = this.flowParseTypeInitialiser(), this.finishNode(p, "TypeAnnotation");
        }
        flowParseTypeAnnotatableIdentifier(p) {
          let b = p ? this.parseIdentifier() : this.flowParseRestrictedIdentifier();
          return this.match(14) && (b.typeAnnotation = this.flowParseTypeAnnotation(), this.resetEndLocation(b)), b;
        }
        typeCastToParameter(p) {
          return p.expression.typeAnnotation = p.typeAnnotation, this.resetEndLocation(p.expression, p.typeAnnotation.loc.end), p.expression;
        }
        flowParseVariance() {
          let p = null;
          return this.match(53) ? (p = this.startNode(), this.state.value === "+" ? p.kind = "plus" : p.kind = "minus", this.next(), this.finishNode(p, "Variance")) : p;
        }
        parseFunctionBody(p, b, T = !1) {
          if (b) {
            this.forwardNoArrowParamsConversionAt(p, () => super.parseFunctionBody(p, !0, T));
            return;
          }
          super.parseFunctionBody(p, !1, T);
        }
        parseFunctionBodyAndFinish(p, b, T = !1) {
          if (this.match(14)) {
            let F = this.startNode();
            [F.typeAnnotation, p.predicate] = this.flowParseTypeAndPredicateInitialiser(), p.returnType = F.typeAnnotation ? this.finishNode(F, "TypeAnnotation") : null;
          }
          return super.parseFunctionBodyAndFinish(p, b, T);
        }
        parseStatementLike(p) {
          if (this.state.strict && this.isContextual(129)) {
            let T = this.lookahead();
            if (Bs(T.type)) {
              let F = this.startNode();
              return this.next(), this.flowParseInterface(F);
            }
          } else if (this.shouldParseEnums() && this.isContextual(126)) {
            let T = this.startNode();
            return this.next(), this.flowParseEnumDeclaration(T);
          }
          let b = super.parseStatementLike(p);
          return this.flowPragma === void 0 && !this.isValidDirective(b) && (this.flowPragma = null), b;
        }
        parseExpressionStatement(p, b, T) {
          if (b.type === "Identifier") {
            if (b.name === "declare") {
              if (this.match(80) || Qt(this.state.type) || this.match(68) || this.match(74) || this.match(82)) return this.flowParseDeclare(p);
            } else if (Qt(this.state.type)) {
              if (b.name === "interface") return this.flowParseInterface(p);
              if (b.name === "type") return this.flowParseTypeAlias(p);
              if (b.name === "opaque") return this.flowParseOpaqueType(p, !1);
            }
          }
          return super.parseExpressionStatement(p, b, T);
        }
        shouldParseExportDeclaration() {
          let { type: p } = this.state;
          return _v(p) || this.shouldParseEnums() && p === 126 ? !this.state.containsEsc : super.shouldParseExportDeclaration();
        }
        isExportDefaultSpecifier() {
          let { type: p } = this.state;
          return _v(p) || this.shouldParseEnums() && p === 126 ? this.state.containsEsc : super.isExportDefaultSpecifier();
        }
        parseExportDefaultExpression() {
          if (this.shouldParseEnums() && this.isContextual(126)) {
            let p = this.startNode();
            return this.next(), this.flowParseEnumDeclaration(p);
          }
          return super.parseExportDefaultExpression();
        }
        parseConditional(p, b, T) {
          if (!this.match(17)) return p;
          if (this.state.maybeInArrowParameters) {
            let Dt = this.lookaheadCharCode();
            if (Dt === 44 || Dt === 61 || Dt === 58 || Dt === 41) return this.setOptionalParametersError(T), p;
          }
          this.expect(17);
          let F = this.state.clone(), Y = this.state.noArrowAt, ie = this.startNodeAt(b), { consequent: de, failed: he } = this.tryParseConditionalConsequent(), [fe, Ze] = this.getArrowLikeExpressions(de);
          if (he || Ze.length > 0) {
            let Dt = [...Y];
            if (Ze.length > 0) {
              this.state = F, this.state.noArrowAt = Dt;
              for (let $t = 0; $t < Ze.length; $t++) Dt.push(Ze[$t].start);
              ({ consequent: de, failed: he } = this.tryParseConditionalConsequent()), [fe, Ze] = this.getArrowLikeExpressions(de);
            }
            he && fe.length > 1 && this.raise(Jt.AmbiguousConditionalArrow, F.startLoc), he && fe.length === 1 && (this.state = F, Dt.push(fe[0].start), this.state.noArrowAt = Dt, { consequent: de, failed: he } = this.tryParseConditionalConsequent());
          }
          return this.getArrowLikeExpressions(de, !0), this.state.noArrowAt = Y, this.expect(14), ie.test = p, ie.consequent = de, ie.alternate = this.forwardNoArrowParamsConversionAt(ie, () => this.parseMaybeAssign(void 0, void 0)), this.finishNode(ie, "ConditionalExpression");
        }
        tryParseConditionalConsequent() {
          this.state.noArrowParamsConversionAt.push(this.state.start);
          let p = this.parseMaybeAssignAllowIn(), b = !this.match(14);
          return this.state.noArrowParamsConversionAt.pop(), { consequent: p, failed: b };
        }
        getArrowLikeExpressions(p, b) {
          let T = [p], F = [];
          for (; T.length !== 0; ) {
            let Y = T.pop();
            Y.type === "ArrowFunctionExpression" && Y.body.type !== "BlockStatement" ? (Y.typeParameters || !Y.returnType ? this.finishArrowValidation(Y) : F.push(Y), T.push(Y.body)) : Y.type === "ConditionalExpression" && (T.push(Y.consequent), T.push(Y.alternate));
          }
          return b ? (F.forEach((Y) => this.finishArrowValidation(Y)), [F, []]) : Xf(F, (Y) => Y.params.every((ie) => this.isAssignable(ie, !0)));
        }
        finishArrowValidation(p) {
          var b;
          this.toAssignableList(p.params, (b = p.extra) == null ? void 0 : b.trailingCommaLoc, !1), this.scope.enter(6), super.checkParams(p, !1, !0), this.scope.exit();
        }
        forwardNoArrowParamsConversionAt(p, b) {
          let T;
          return this.state.noArrowParamsConversionAt.includes(p.start) ? (this.state.noArrowParamsConversionAt.push(this.state.start), T = b(), this.state.noArrowParamsConversionAt.pop()) : T = b(), T;
        }
        parseParenItem(p, b) {
          let T = super.parseParenItem(p, b);
          if (this.eat(17) && (T.optional = !0, this.resetEndLocation(p)), this.match(14)) {
            let F = this.startNodeAt(b);
            return F.expression = T, F.typeAnnotation = this.flowParseTypeAnnotation(), this.finishNode(F, "TypeCastExpression");
          }
          return T;
        }
        assertModuleNodeAllowed(p) {
          p.type === "ImportDeclaration" && (p.importKind === "type" || p.importKind === "typeof") || p.type === "ExportNamedDeclaration" && p.exportKind === "type" || p.type === "ExportAllDeclaration" && p.exportKind === "type" || super.assertModuleNodeAllowed(p);
        }
        parseExportDeclaration(p) {
          if (this.isContextual(130)) {
            p.exportKind = "type";
            let b = this.startNode();
            return this.next(), this.match(5) ? (p.specifiers = this.parseExportSpecifiers(!0), super.parseExportFrom(p), null) : this.flowParseTypeAlias(b);
          } else if (this.isContextual(131)) {
            p.exportKind = "type";
            let b = this.startNode();
            return this.next(), this.flowParseOpaqueType(b, !1);
          } else if (this.isContextual(129)) {
            p.exportKind = "type";
            let b = this.startNode();
            return this.next(), this.flowParseInterface(b);
          } else if (this.shouldParseEnums() && this.isContextual(126)) {
            p.exportKind = "value";
            let b = this.startNode();
            return this.next(), this.flowParseEnumDeclaration(b);
          } else return super.parseExportDeclaration(p);
        }
        eatExportStar(p) {
          return super.eatExportStar(p) ? !0 : this.isContextual(130) && this.lookahead().type === 55 ? (p.exportKind = "type", this.next(), this.next(), !0) : !1;
        }
        maybeParseExportNamespaceSpecifier(p) {
          let { startLoc: b } = this.state, T = super.maybeParseExportNamespaceSpecifier(p);
          return T && p.exportKind === "type" && this.unexpected(b), T;
        }
        parseClassId(p, b, T) {
          super.parseClassId(p, b, T), this.match(47) && (p.typeParameters = this.flowParseTypeParameterDeclaration());
        }
        parseClassMember(p, b, T) {
          let { startLoc: F } = this.state;
          if (this.isContextual(125)) {
            if (super.parseClassMemberFromModifier(p, b)) return;
            b.declare = !0;
          }
          super.parseClassMember(p, b, T), b.declare && (b.type !== "ClassProperty" && b.type !== "ClassPrivateProperty" && b.type !== "PropertyDefinition" ? this.raise(Jt.DeclareClassElement, F) : b.value && this.raise(Jt.DeclareClassFieldInitializer, b.value));
        }
        isIterator(p) {
          return p === "iterator" || p === "asyncIterator";
        }
        readIterator() {
          let p = super.readWord1(), b = "@@" + p;
          (!this.isIterator(p) || !this.state.inType) && this.raise(Se.InvalidIdentifier, this.state.curPosition(), { identifierName: b }), this.finishToken(132, b);
        }
        getTokenFromCode(p) {
          let b = this.input.charCodeAt(this.state.pos + 1);
          p === 123 && b === 124 ? this.finishOp(6, 2) : this.state.inType && (p === 62 || p === 60) ? this.finishOp(p === 62 ? 48 : 47, 1) : this.state.inType && p === 63 ? b === 46 ? this.finishOp(18, 2) : this.finishOp(17, 1) : Wv(p, b, this.input.charCodeAt(this.state.pos + 2)) ? (this.state.pos += 2, this.readIterator()) : super.getTokenFromCode(p);
        }
        isAssignable(p, b) {
          return p.type === "TypeCastExpression" ? this.isAssignable(p.expression, b) : super.isAssignable(p, b);
        }
        toAssignable(p, b = !1) {
          !b && p.type === "AssignmentExpression" && p.left.type === "TypeCastExpression" && (p.left = this.typeCastToParameter(p.left)), super.toAssignable(p, b);
        }
        toAssignableList(p, b, T) {
          for (let F = 0; F < p.length; F++) {
            let Y = p[F];
            (Y == null ? void 0 : Y.type) === "TypeCastExpression" && (p[F] = this.typeCastToParameter(Y));
          }
          super.toAssignableList(p, b, T);
        }
        toReferencedList(p, b) {
          for (let F = 0; F < p.length; F++) {
            var T;
            let Y = p[F];
            Y && Y.type === "TypeCastExpression" && !((T = Y.extra) != null && T.parenthesized) && (p.length > 1 || !b) && this.raise(Jt.TypeCastInPattern, Y.typeAnnotation);
          }
          return p;
        }
        parseArrayLike(p, b, T, F) {
          let Y = super.parseArrayLike(p, b, T, F);
          return b && !this.state.maybeInArrowParameters && this.toReferencedList(Y.elements), Y;
        }
        isValidLVal(p, b, T) {
          return p === "TypeCastExpression" || super.isValidLVal(p, b, T);
        }
        parseClassProperty(p) {
          return this.match(14) && (p.typeAnnotation = this.flowParseTypeAnnotation()), super.parseClassProperty(p);
        }
        parseClassPrivateProperty(p) {
          return this.match(14) && (p.typeAnnotation = this.flowParseTypeAnnotation()), super.parseClassPrivateProperty(p);
        }
        isClassMethod() {
          return this.match(47) || super.isClassMethod();
        }
        isClassProperty() {
          return this.match(14) || super.isClassProperty();
        }
        isNonstaticConstructor(p) {
          return !this.match(14) && super.isNonstaticConstructor(p);
        }
        pushClassMethod(p, b, T, F, Y, ie) {
          if (b.variance && this.unexpected(b.variance.loc.start), delete b.variance, this.match(47) && (b.typeParameters = this.flowParseTypeParameterDeclaration()), super.pushClassMethod(p, b, T, F, Y, ie), b.params && Y) {
            let de = b.params;
            de.length > 0 && this.isThisParam(de[0]) && this.raise(Jt.ThisParamBannedInConstructor, b);
          } else if (b.type === "MethodDefinition" && Y && b.value.params) {
            let de = b.value.params;
            de.length > 0 && this.isThisParam(de[0]) && this.raise(Jt.ThisParamBannedInConstructor, b);
          }
        }
        pushClassPrivateMethod(p, b, T, F) {
          b.variance && this.unexpected(b.variance.loc.start), delete b.variance, this.match(47) && (b.typeParameters = this.flowParseTypeParameterDeclaration()), super.pushClassPrivateMethod(p, b, T, F);
        }
        parseClassSuper(p) {
          if (super.parseClassSuper(p), p.superClass && this.match(47) && (p.superTypeParameters = this.flowParseTypeParameterInstantiation()), this.isContextual(113)) {
            this.next();
            let b = p.implements = [];
            do {
              let T = this.startNode();
              T.id = this.flowParseRestrictedIdentifier(!0), this.match(47) ? T.typeParameters = this.flowParseTypeParameterInstantiation() : T.typeParameters = null, b.push(this.finishNode(T, "ClassImplements"));
            } while (this.eat(12));
          }
        }
        checkGetterSetterParams(p) {
          super.checkGetterSetterParams(p);
          let b = this.getObjectOrClassMethodParams(p);
          if (b.length > 0) {
            let T = b[0];
            this.isThisParam(T) && p.kind === "get" ? this.raise(Jt.GetterMayNotHaveThisParam, T) : this.isThisParam(T) && this.raise(Jt.SetterMayNotHaveThisParam, T);
          }
        }
        parsePropertyNamePrefixOperator(p) {
          p.variance = this.flowParseVariance();
        }
        parseObjPropValue(p, b, T, F, Y, ie, de) {
          p.variance && this.unexpected(p.variance.loc.start), delete p.variance;
          let he;
          this.match(47) && !ie && (he = this.flowParseTypeParameterDeclaration(), this.match(10) || this.unexpected());
          let fe = super.parseObjPropValue(p, b, T, F, Y, ie, de);
          return he && ((fe.value || fe).typeParameters = he), fe;
        }
        parseAssignableListItemTypes(p) {
          return this.eat(17) && (p.type !== "Identifier" && this.raise(Jt.PatternIsOptional, p), this.isThisParam(p) && this.raise(Jt.ThisParamMayNotBeOptional, p), p.optional = !0), this.match(14) ? p.typeAnnotation = this.flowParseTypeAnnotation() : this.isThisParam(p) && this.raise(Jt.ThisParamAnnotationRequired, p), this.match(29) && this.isThisParam(p) && this.raise(Jt.ThisParamNoDefault, p), this.resetEndLocation(p), p;
        }
        parseMaybeDefault(p, b) {
          let T = super.parseMaybeDefault(p, b);
          return T.type === "AssignmentPattern" && T.typeAnnotation && T.right.start < T.typeAnnotation.start && this.raise(Jt.TypeBeforeInitializer, T.typeAnnotation), T;
        }
        checkImportReflection(p) {
          super.checkImportReflection(p), p.module && p.importKind !== "value" && this.raise(Jt.ImportReflectionHasImportType, p.specifiers[0].loc.start);
        }
        parseImportSpecifierLocal(p, b, T) {
          b.local = Bu(p) ? this.flowParseRestrictedIdentifier(!0, !0) : this.parseIdentifier(), p.specifiers.push(this.finishImportSpecifier(b, T));
        }
        isPotentialImportPhase(p) {
          if (super.isPotentialImportPhase(p)) return !0;
          if (this.isContextual(130)) {
            if (!p) return !0;
            let b = this.lookaheadCharCode();
            return b === 123 || b === 42;
          }
          return !p && this.isContextual(87);
        }
        applyImportPhase(p, b, T, F) {
          if (super.applyImportPhase(p, b, T, F), b) {
            if (!T && this.match(65)) return;
            p.exportKind = T === "type" ? T : "value";
          } else T === "type" && this.match(55) && this.unexpected(), p.importKind = T === "type" || T === "typeof" ? T : "value";
        }
        parseImportSpecifier(p, b, T, F, Y) {
          let ie = p.imported, de = null;
          ie.type === "Identifier" && (ie.name === "type" ? de = "type" : ie.name === "typeof" && (de = "typeof"));
          let he = !1;
          if (this.isContextual(93) && !this.isLookaheadContextual("as")) {
            let Ze = this.parseIdentifier(!0);
            de !== null && !Bs(this.state.type) ? (p.imported = Ze, p.importKind = de, p.local = Un(Ze)) : (p.imported = ie, p.importKind = null, p.local = this.parseIdentifier());
          } else {
            if (de !== null && Bs(this.state.type)) p.imported = this.parseIdentifier(!0), p.importKind = de;
            else {
              if (b) throw this.raise(Se.ImportBindingIsString, p, { importName: ie.value });
              p.imported = ie, p.importKind = null;
            }
            this.eatContextual(93) ? p.local = this.parseIdentifier() : (he = !0, p.local = Un(p.imported));
          }
          let fe = Bu(p);
          return T && fe && this.raise(Jt.ImportTypeShorthandOnlyInPureImport, p), (T || fe) && this.checkReservedType(p.local.name, p.local.loc.start, !0), he && !T && !fe && this.checkReservedWord(p.local.name, p.loc.start, !0, !0), this.finishImportSpecifier(p, "ImportSpecifier");
        }
        parseBindingAtom() {
          switch (this.state.type) {
            case 78:
              return this.parseIdentifier(!0);
            default:
              return super.parseBindingAtom();
          }
        }
        parseFunctionParams(p, b) {
          let T = p.kind;
          T !== "get" && T !== "set" && this.match(47) && (p.typeParameters = this.flowParseTypeParameterDeclaration()), super.parseFunctionParams(p, b);
        }
        parseVarId(p, b) {
          super.parseVarId(p, b), this.match(14) && (p.id.typeAnnotation = this.flowParseTypeAnnotation(), this.resetEndLocation(p.id));
        }
        parseAsyncArrowFromCallExpression(p, b) {
          if (this.match(14)) {
            let T = this.state.noAnonFunctionType;
            this.state.noAnonFunctionType = !0, p.returnType = this.flowParseTypeAnnotation(), this.state.noAnonFunctionType = T;
          }
          return super.parseAsyncArrowFromCallExpression(p, b);
        }
        shouldParseAsyncArrow() {
          return this.match(14) || super.shouldParseAsyncArrow();
        }
        parseMaybeAssign(p, b) {
          var T;
          let F = null, Y;
          if (this.hasPlugin("jsx") && (this.match(142) || this.match(47))) {
            if (F = this.state.clone(), Y = this.tryParse(() => super.parseMaybeAssign(p, b), F), !Y.error) return Y.node;
            let { context: he } = this.state, fe = he[he.length - 1];
            (fe === ar.j_oTag || fe === ar.j_expr) && he.pop();
          }
          if ((T = Y) != null && T.error || this.match(47)) {
            var ie, de;
            F = F || this.state.clone();
            let he, fe = this.tryParse((Dt) => {
              var $t;
              he = this.flowParseTypeParameterDeclaration();
              let It = this.forwardNoArrowParamsConversionAt(he, () => {
                let Di = super.parseMaybeAssign(p, b);
                return this.resetStartLocationFromNode(Di, he), Di;
              });
              ($t = It.extra) != null && $t.parenthesized && Dt();
              let nr = this.maybeUnwrapTypeCastExpression(It);
              return nr.type !== "ArrowFunctionExpression" && Dt(), nr.typeParameters = he, this.resetStartLocationFromNode(nr, he), It;
            }, F), Ze = null;
            if (fe.node && this.maybeUnwrapTypeCastExpression(fe.node).type === "ArrowFunctionExpression") {
              if (!fe.error && !fe.aborted) return fe.node.async && this.raise(Jt.UnexpectedTypeParameterBeforeAsyncArrowFunction, he), fe.node;
              Ze = fe.node;
            }
            if ((ie = Y) != null && ie.node) return this.state = Y.failState, Y.node;
            if (Ze) return this.state = fe.failState, Ze;
            throw (de = Y) != null && de.thrown ? Y.error : fe.thrown ? fe.error : this.raise(Jt.UnexpectedTokenAfterTypeParameter, he);
          }
          return super.parseMaybeAssign(p, b);
        }
        parseArrow(p) {
          if (this.match(14)) {
            let b = this.tryParse(() => {
              let T = this.state.noAnonFunctionType;
              this.state.noAnonFunctionType = !0;
              let F = this.startNode();
              return [F.typeAnnotation, p.predicate] = this.flowParseTypeAndPredicateInitialiser(), this.state.noAnonFunctionType = T, this.canInsertSemicolon() && this.unexpected(), this.match(19) || this.unexpected(), F;
            });
            if (b.thrown) return null;
            b.error && (this.state = b.failState), p.returnType = b.node.typeAnnotation ? this.finishNode(b.node, "TypeAnnotation") : null;
          }
          return super.parseArrow(p);
        }
        shouldParseArrow(p) {
          return this.match(14) || super.shouldParseArrow(p);
        }
        setArrowFunctionParameters(p, b) {
          this.state.noArrowParamsConversionAt.includes(p.start) ? p.params = b : super.setArrowFunctionParameters(p, b);
        }
        checkParams(p, b, T, F = !0) {
          if (!(T && this.state.noArrowParamsConversionAt.includes(p.start))) {
            for (let Y = 0; Y < p.params.length; Y++) this.isThisParam(p.params[Y]) && Y > 0 && this.raise(Jt.ThisParamMustBeFirst, p.params[Y]);
            super.checkParams(p, b, T, F);
          }
        }
        parseParenAndDistinguishExpression(p) {
          return super.parseParenAndDistinguishExpression(p && !this.state.noArrowAt.includes(this.state.start));
        }
        parseSubscripts(p, b, T) {
          if (p.type === "Identifier" && p.name === "async" && this.state.noArrowAt.includes(b.index)) {
            this.next();
            let F = this.startNodeAt(b);
            F.callee = p, F.arguments = super.parseCallExpressionArguments(11, !1), p = this.finishNode(F, "CallExpression");
          } else if (p.type === "Identifier" && p.name === "async" && this.match(47)) {
            let F = this.state.clone(), Y = this.tryParse((de) => this.parseAsyncArrowWithTypeParameters(b) || de(), F);
            if (!Y.error && !Y.aborted) return Y.node;
            let ie = this.tryParse(() => super.parseSubscripts(p, b, T), F);
            if (ie.node && !ie.error) return ie.node;
            if (Y.node) return this.state = Y.failState, Y.node;
            if (ie.node) return this.state = ie.failState, ie.node;
            throw Y.error || ie.error;
          }
          return super.parseSubscripts(p, b, T);
        }
        parseSubscript(p, b, T, F) {
          if (this.match(18) && this.isLookaheadToken_lt()) {
            if (F.optionalChainMember = !0, T) return F.stop = !0, p;
            this.next();
            let Y = this.startNodeAt(b);
            return Y.callee = p, Y.typeArguments = this.flowParseTypeParameterInstantiation(), this.expect(10), Y.arguments = this.parseCallExpressionArguments(11, !1), Y.optional = !0, this.finishCallExpression(Y, !0);
          } else if (!T && this.shouldParseTypes() && this.match(47)) {
            let Y = this.startNodeAt(b);
            Y.callee = p;
            let ie = this.tryParse(() => (Y.typeArguments = this.flowParseTypeParameterInstantiationCallOrNew(), this.expect(10), Y.arguments = super.parseCallExpressionArguments(11, !1), F.optionalChainMember && (Y.optional = !1), this.finishCallExpression(Y, F.optionalChainMember)));
            if (ie.node) return ie.error && (this.state = ie.failState), ie.node;
          }
          return super.parseSubscript(p, b, T, F);
        }
        parseNewCallee(p) {
          super.parseNewCallee(p);
          let b = null;
          this.shouldParseTypes() && this.match(47) && (b = this.tryParse(() => this.flowParseTypeParameterInstantiationCallOrNew()).node), p.typeArguments = b;
        }
        parseAsyncArrowWithTypeParameters(p) {
          let b = this.startNodeAt(p);
          if (this.parseFunctionParams(b, !1), !!this.parseArrow(b)) return super.parseArrowExpression(b, void 0, !0);
        }
        readToken_mult_modulo(p) {
          let b = this.input.charCodeAt(this.state.pos + 1);
          if (p === 42 && b === 47 && this.state.hasFlowComment) {
            this.state.hasFlowComment = !1, this.state.pos += 2, this.nextToken();
            return;
          }
          super.readToken_mult_modulo(p);
        }
        readToken_pipe_amp(p) {
          let b = this.input.charCodeAt(this.state.pos + 1);
          if (p === 124 && b === 125) {
            this.finishOp(9, 2);
            return;
          }
          super.readToken_pipe_amp(p);
        }
        parseTopLevel(p, b) {
          let T = super.parseTopLevel(p, b);
          return this.state.hasFlowComment && this.raise(Jt.UnterminatedFlowComment, this.state.curPosition()), T;
        }
        skipBlockComment() {
          if (this.hasPlugin("flowComments") && this.skipFlowComment()) {
            if (this.state.hasFlowComment) throw this.raise(Jt.NestedFlowComment, this.state.startLoc);
            this.hasFlowCommentCompletion();
            let p = this.skipFlowComment();
            p && (this.state.pos += p, this.state.hasFlowComment = !0);
            return;
          }
          return super.skipBlockComment(this.state.hasFlowComment ? "*-/" : "*/");
        }
        skipFlowComment() {
          let { pos: p } = this.state, b = 2;
          for (; [32, 9].includes(this.input.charCodeAt(p + b)); ) b++;
          let T = this.input.charCodeAt(b + p), F = this.input.charCodeAt(b + p + 1);
          return T === 58 && F === 58 ? b + 2 : this.input.slice(b + p, b + p + 12) === "flow-include" ? b + 12 : T === 58 && F !== 58 ? b : !1;
        }
        hasFlowCommentCompletion() {
          if (this.input.indexOf("*/", this.state.pos) === -1) throw this.raise(Se.UnterminatedComment, this.state.curPosition());
        }
        flowEnumErrorBooleanMemberNotInitialized(p, { enumName: b, memberName: T }) {
          this.raise(Jt.EnumBooleanMemberNotInitialized, p, { memberName: T, enumName: b });
        }
        flowEnumErrorInvalidMemberInitializer(p, b) {
          return this.raise(b.explicitType ? b.explicitType === "symbol" ? Jt.EnumInvalidMemberInitializerSymbolType : Jt.EnumInvalidMemberInitializerPrimaryType : Jt.EnumInvalidMemberInitializerUnknownType, p, b);
        }
        flowEnumErrorNumberMemberNotInitialized(p, b) {
          this.raise(Jt.EnumNumberMemberNotInitialized, p, b);
        }
        flowEnumErrorStringMemberInconsistentlyInitialized(p, b) {
          this.raise(Jt.EnumStringMemberInconsistentlyInitialized, p, b);
        }
        flowEnumMemberInit() {
          let p = this.state.startLoc, b = () => this.match(12) || this.match(8);
          switch (this.state.type) {
            case 134: {
              let T = this.parseNumericLiteral(this.state.value);
              return b() ? { type: "number", loc: T.loc.start, value: T } : { type: "invalid", loc: p };
            }
            case 133: {
              let T = this.parseStringLiteral(this.state.value);
              return b() ? { type: "string", loc: T.loc.start, value: T } : { type: "invalid", loc: p };
            }
            case 85:
            case 86: {
              let T = this.parseBooleanLiteral(this.match(85));
              return b() ? { type: "boolean", loc: T.loc.start, value: T } : { type: "invalid", loc: p };
            }
            default:
              return { type: "invalid", loc: p };
          }
        }
        flowEnumMemberRaw() {
          let p = this.state.startLoc, b = this.parseIdentifier(!0), T = this.eat(29) ? this.flowEnumMemberInit() : { type: "none", loc: p };
          return { id: b, init: T };
        }
        flowEnumCheckExplicitTypeMismatch(p, b, T) {
          let { explicitType: F } = b;
          F !== null && F !== T && this.flowEnumErrorInvalidMemberInitializer(p, b);
        }
        flowEnumMembers({ enumName: p, explicitType: b }) {
          let T = /* @__PURE__ */ new Set(), F = { booleanMembers: [], numberMembers: [], stringMembers: [], defaultedMembers: [] }, Y = !1;
          for (; !this.match(8); ) {
            if (this.eat(21)) {
              Y = !0;
              break;
            }
            let ie = this.startNode(), { id: de, init: he } = this.flowEnumMemberRaw(), fe = de.name;
            if (fe === "") continue;
            /^[a-z]/.test(fe) && this.raise(Jt.EnumInvalidMemberName, de, { memberName: fe, suggestion: fe[0].toUpperCase() + fe.slice(1), enumName: p }), T.has(fe) && this.raise(Jt.EnumDuplicateMemberName, de, { memberName: fe, enumName: p }), T.add(fe);
            let Ze = { enumName: p, explicitType: b, memberName: fe };
            switch (ie.id = de, he.type) {
              case "boolean": {
                this.flowEnumCheckExplicitTypeMismatch(he.loc, Ze, "boolean"), ie.init = he.value, F.booleanMembers.push(this.finishNode(ie, "EnumBooleanMember"));
                break;
              }
              case "number": {
                this.flowEnumCheckExplicitTypeMismatch(he.loc, Ze, "number"), ie.init = he.value, F.numberMembers.push(this.finishNode(ie, "EnumNumberMember"));
                break;
              }
              case "string": {
                this.flowEnumCheckExplicitTypeMismatch(he.loc, Ze, "string"), ie.init = he.value, F.stringMembers.push(this.finishNode(ie, "EnumStringMember"));
                break;
              }
              case "invalid":
                throw this.flowEnumErrorInvalidMemberInitializer(he.loc, Ze);
              case "none":
                switch (b) {
                  case "boolean":
                    this.flowEnumErrorBooleanMemberNotInitialized(he.loc, Ze);
                    break;
                  case "number":
                    this.flowEnumErrorNumberMemberNotInitialized(he.loc, Ze);
                    break;
                  default:
                    F.defaultedMembers.push(this.finishNode(ie, "EnumDefaultedMember"));
                }
            }
            this.match(8) || this.expect(12);
          }
          return { members: F, hasUnknownMembers: Y };
        }
        flowEnumStringMembers(p, b, { enumName: T }) {
          if (p.length === 0) return b;
          if (b.length === 0) return p;
          if (b.length > p.length) {
            for (let F of p) this.flowEnumErrorStringMemberInconsistentlyInitialized(F, { enumName: T });
            return b;
          } else {
            for (let F of b) this.flowEnumErrorStringMemberInconsistentlyInitialized(F, { enumName: T });
            return p;
          }
        }
        flowEnumParseExplicitType({ enumName: p }) {
          if (!this.eatContextual(102)) return null;
          if (!Qt(this.state.type)) throw this.raise(Jt.EnumInvalidExplicitTypeUnknownSupplied, this.state.startLoc, { enumName: p });
          let { value: b } = this.state;
          return this.next(), b !== "boolean" && b !== "number" && b !== "string" && b !== "symbol" && this.raise(Jt.EnumInvalidExplicitType, this.state.startLoc, { enumName: p, invalidEnumType: b }), b;
        }
        flowEnumBody(p, b) {
          let T = b.name, F = b.loc.start, Y = this.flowEnumParseExplicitType({ enumName: T });
          this.expect(5);
          let { members: ie, hasUnknownMembers: de } = this.flowEnumMembers({ enumName: T, explicitType: Y });
          switch (p.hasUnknownMembers = de, Y) {
            case "boolean":
              return p.explicitType = !0, p.members = ie.booleanMembers, this.expect(8), this.finishNode(p, "EnumBooleanBody");
            case "number":
              return p.explicitType = !0, p.members = ie.numberMembers, this.expect(8), this.finishNode(p, "EnumNumberBody");
            case "string":
              return p.explicitType = !0, p.members = this.flowEnumStringMembers(ie.stringMembers, ie.defaultedMembers, { enumName: T }), this.expect(8), this.finishNode(p, "EnumStringBody");
            case "symbol":
              return p.members = ie.defaultedMembers, this.expect(8), this.finishNode(p, "EnumSymbolBody");
            default: {
              let he = () => (p.members = [], this.expect(8), this.finishNode(p, "EnumStringBody"));
              p.explicitType = !1;
              let fe = ie.booleanMembers.length, Ze = ie.numberMembers.length, Dt = ie.stringMembers.length, $t = ie.defaultedMembers.length;
              if (!fe && !Ze && !Dt && !$t) return he();
              if (!fe && !Ze) return p.members = this.flowEnumStringMembers(ie.stringMembers, ie.defaultedMembers, { enumName: T }), this.expect(8), this.finishNode(p, "EnumStringBody");
              if (!Ze && !Dt && fe >= $t) {
                for (let It of ie.defaultedMembers) this.flowEnumErrorBooleanMemberNotInitialized(It.loc.start, { enumName: T, memberName: It.id.name });
                return p.members = ie.booleanMembers, this.expect(8), this.finishNode(p, "EnumBooleanBody");
              } else if (!fe && !Dt && Ze >= $t) {
                for (let It of ie.defaultedMembers) this.flowEnumErrorNumberMemberNotInitialized(It.loc.start, { enumName: T, memberName: It.id.name });
                return p.members = ie.numberMembers, this.expect(8), this.finishNode(p, "EnumNumberBody");
              } else return this.raise(Jt.EnumInconsistentMemberValues, F, { enumName: T }), he();
            }
          }
        }
        flowParseEnumDeclaration(p) {
          let b = this.parseIdentifier();
          return p.id = b, p.body = this.flowEnumBody(this.startNode(), b), this.finishNode(p, "EnumDeclaration");
        }
        isLookaheadToken_lt() {
          let p = this.nextTokenStart();
          if (this.input.charCodeAt(p) === 60) {
            let b = this.input.charCodeAt(p + 1);
            return b !== 60 && b !== 61;
          }
          return !1;
        }
        maybeUnwrapTypeCastExpression(p) {
          return p.type === "TypeCastExpression" ? p.expression : p;
        }
      }, $l = ga`jsx`({ AttributeIsEmpty: "JSX attributes must only be assigned a non-empty expression.", MissingClosingTagElement: ({ openingTagName: y }) => `Expected corresponding JSX closing tag for <${y}>.`, MissingClosingTagFragment: "Expected corresponding JSX closing tag for <>.", UnexpectedSequenceExpression: "Sequence expressions cannot be directly nested inside JSX. Did you mean to wrap it in parentheses (...)?", UnexpectedToken: ({ unexpected: y, HTMLEntity: p }) => `Unexpected token \`${y}\`. Did you mean \`${p}\` or \`{'${y}'}\`?`, UnsupportedJsxValue: "JSX value should be either an expression or a quoted JSX text.", UnterminatedJsxContent: "Unterminated JSX contents.", UnwrappedAdjacentJSXElements: "Adjacent JSX elements must be wrapped in an enclosing tag. Did you want a JSX fragment <>...</>?" });
      function Vs(y) {
        return y ? y.type === "JSXOpeningFragment" || y.type === "JSXClosingFragment" : !1;
      }
      function $c(y) {
        if (y.type === "JSXIdentifier") return y.name;
        if (y.type === "JSXNamespacedName") return y.namespace.name + ":" + y.name.name;
        if (y.type === "JSXMemberExpression") return $c(y.object) + "." + $c(y.property);
        throw new Error("Node had unexpected type: " + y.type);
      }
      var lS = (y) => class extends y {
        jsxReadToken() {
          let p = "", b = this.state.pos;
          for (; ; ) {
            if (this.state.pos >= this.length) throw this.raise($l.UnterminatedJsxContent, this.state.startLoc);
            let T = this.input.charCodeAt(this.state.pos);
            switch (T) {
              case 60:
              case 123:
                if (this.state.pos === this.state.start) {
                  T === 60 && this.state.canStartJSXElement ? (++this.state.pos, this.finishToken(142)) : super.getTokenFromCode(T);
                  return;
                }
                p += this.input.slice(b, this.state.pos), this.finishToken(141, p);
                return;
              case 38:
                p += this.input.slice(b, this.state.pos), p += this.jsxReadEntity(), b = this.state.pos;
                break;
              case 62:
              case 125:
              default:
                Mu(T) ? (p += this.input.slice(b, this.state.pos), p += this.jsxReadNewLine(!0), b = this.state.pos) : ++this.state.pos;
            }
          }
        }
        jsxReadNewLine(p) {
          let b = this.input.charCodeAt(this.state.pos), T;
          return ++this.state.pos, b === 13 && this.input.charCodeAt(this.state.pos) === 10 ? (++this.state.pos, T = p ? `
` : `\r
`) : T = String.fromCharCode(b), ++this.state.curLine, this.state.lineStart = this.state.pos, T;
        }
        jsxReadString(p) {
          let b = "", T = ++this.state.pos;
          for (; ; ) {
            if (this.state.pos >= this.length) throw this.raise(Se.UnterminatedString, this.state.startLoc);
            let F = this.input.charCodeAt(this.state.pos);
            if (F === p) break;
            F === 38 ? (b += this.input.slice(T, this.state.pos), b += this.jsxReadEntity(), T = this.state.pos) : Mu(F) ? (b += this.input.slice(T, this.state.pos), b += this.jsxReadNewLine(!1), T = this.state.pos) : ++this.state.pos;
          }
          b += this.input.slice(T, this.state.pos++), this.finishToken(133, b);
        }
        jsxReadEntity() {
          let p = ++this.state.pos;
          if (this.codePointAtPos(this.state.pos) === 35) {
            ++this.state.pos;
            let b = 10;
            this.codePointAtPos(this.state.pos) === 120 && (b = 16, ++this.state.pos);
            let T = this.readInt(b, void 0, !1, "bail");
            if (T !== null && this.codePointAtPos(this.state.pos) === 59) return ++this.state.pos, String.fromCodePoint(T);
          } else {
            let b = 0, T = !1;
            for (; b++ < 10 && this.state.pos < this.length && !(T = this.codePointAtPos(this.state.pos) === 59); ) ++this.state.pos;
            if (T) {
              this.input.slice(p, this.state.pos);
              let F;
              ++this.state.pos;
            }
          }
          return this.state.pos = p, "&";
        }
        jsxReadWord() {
          let p, b = this.state.pos;
          do
            p = this.input.charCodeAt(++this.state.pos);
          while (rl(p) || p === 45);
          this.finishToken(140, this.input.slice(b, this.state.pos));
        }
        jsxParseIdentifier() {
          let p = this.startNode();
          return this.match(140) ? p.name = this.state.value : Ug(this.state.type) ? p.name = vi(this.state.type) : this.unexpected(), this.next(), this.finishNode(p, "JSXIdentifier");
        }
        jsxParseNamespacedName() {
          let p = this.state.startLoc, b = this.jsxParseIdentifier();
          if (!this.eat(14)) return b;
          let T = this.startNodeAt(p);
          return T.namespace = b, T.name = this.jsxParseIdentifier(), this.finishNode(T, "JSXNamespacedName");
        }
        jsxParseElementName() {
          let p = this.state.startLoc, b = this.jsxParseNamespacedName();
          if (b.type === "JSXNamespacedName") return b;
          for (; this.eat(16); ) {
            let T = this.startNodeAt(p);
            T.object = b, T.property = this.jsxParseIdentifier(), b = this.finishNode(T, "JSXMemberExpression");
          }
          return b;
        }
        jsxParseAttributeValue() {
          let p;
          switch (this.state.type) {
            case 5:
              return p = this.startNode(), this.setContext(ar.brace), this.next(), p = this.jsxParseExpressionContainer(p, ar.j_oTag), p.expression.type === "JSXEmptyExpression" && this.raise($l.AttributeIsEmpty, p), p;
            case 142:
            case 133:
              return this.parseExprAtom();
            default:
              throw this.raise($l.UnsupportedJsxValue, this.state.startLoc);
          }
        }
        jsxParseEmptyExpression() {
          let p = this.startNodeAt(this.state.lastTokEndLoc);
          return this.finishNodeAt(p, "JSXEmptyExpression", this.state.startLoc);
        }
        jsxParseSpreadChild(p) {
          return this.next(), p.expression = this.parseExpression(), this.setContext(ar.j_expr), this.state.canStartJSXElement = !0, this.expect(8), this.finishNode(p, "JSXSpreadChild");
        }
        jsxParseExpressionContainer(p, b) {
          if (this.match(8)) p.expression = this.jsxParseEmptyExpression();
          else {
            let T = this.parseExpression();
            p.expression = T;
          }
          return this.setContext(b), this.state.canStartJSXElement = !0, this.expect(8), this.finishNode(p, "JSXExpressionContainer");
        }
        jsxParseAttribute() {
          let p = this.startNode();
          return this.match(5) ? (this.setContext(ar.brace), this.next(), this.expect(21), p.argument = this.parseMaybeAssignAllowIn(), this.setContext(ar.j_oTag), this.state.canStartJSXElement = !0, this.expect(8), this.finishNode(p, "JSXSpreadAttribute")) : (p.name = this.jsxParseNamespacedName(), p.value = this.eat(29) ? this.jsxParseAttributeValue() : null, this.finishNode(p, "JSXAttribute"));
        }
        jsxParseOpeningElementAt(p) {
          let b = this.startNodeAt(p);
          return this.eat(143) ? this.finishNode(b, "JSXOpeningFragment") : (b.name = this.jsxParseElementName(), this.jsxParseOpeningElementAfterName(b));
        }
        jsxParseOpeningElementAfterName(p) {
          let b = [];
          for (; !this.match(56) && !this.match(143); ) b.push(this.jsxParseAttribute());
          return p.attributes = b, p.selfClosing = this.eat(56), this.expect(143), this.finishNode(p, "JSXOpeningElement");
        }
        jsxParseClosingElementAt(p) {
          let b = this.startNodeAt(p);
          return this.eat(143) ? this.finishNode(b, "JSXClosingFragment") : (b.name = this.jsxParseElementName(), this.expect(143), this.finishNode(b, "JSXClosingElement"));
        }
        jsxParseElementAt(p) {
          let b = this.startNodeAt(p), T = [], F = this.jsxParseOpeningElementAt(p), Y = null;
          if (!F.selfClosing) {
            e: for (; ; ) switch (this.state.type) {
              case 142:
                if (p = this.state.startLoc, this.next(), this.eat(56)) {
                  Y = this.jsxParseClosingElementAt(p);
                  break e;
                }
                T.push(this.jsxParseElementAt(p));
                break;
              case 141:
                T.push(this.parseLiteral(this.state.value, "JSXText"));
                break;
              case 5: {
                let ie = this.startNode();
                this.setContext(ar.brace), this.next(), this.match(21) ? T.push(this.jsxParseSpreadChild(ie)) : T.push(this.jsxParseExpressionContainer(ie, ar.j_expr));
                break;
              }
              default:
                this.unexpected();
            }
            Vs(F) && !Vs(Y) && Y !== null ? this.raise($l.MissingClosingTagFragment, Y) : !Vs(F) && Vs(Y) ? this.raise($l.MissingClosingTagElement, Y, { openingTagName: $c(F.name) }) : !Vs(F) && !Vs(Y) && $c(Y.name) !== $c(F.name) && this.raise($l.MissingClosingTagElement, Y, { openingTagName: $c(F.name) });
          }
          if (Vs(F) ? (b.openingFragment = F, b.closingFragment = Y) : (b.openingElement = F, b.closingElement = Y), b.children = T, this.match(47)) throw this.raise($l.UnwrappedAdjacentJSXElements, this.state.startLoc);
          return Vs(F) ? this.finishNode(b, "JSXFragment") : this.finishNode(b, "JSXElement");
        }
        jsxParseElement() {
          let p = this.state.startLoc;
          return this.next(), this.jsxParseElementAt(p);
        }
        setContext(p) {
          let { context: b } = this.state;
          b[b.length - 1] = p;
        }
        parseExprAtom(p) {
          return this.match(142) ? this.jsxParseElement() : this.match(47) && this.input.charCodeAt(this.state.pos) !== 33 ? (this.replaceToken(142), this.jsxParseElement()) : super.parseExprAtom(p);
        }
        skipSpace() {
          this.curContext().preserveSpace || super.skipSpace();
        }
        getTokenFromCode(p) {
          let b = this.curContext();
          if (b === ar.j_expr) {
            this.jsxReadToken();
            return;
          }
          if (b === ar.j_oTag || b === ar.j_cTag) {
            if (Xi(p)) {
              this.jsxReadWord();
              return;
            }
            if (p === 62) {
              ++this.state.pos, this.finishToken(143);
              return;
            }
            if ((p === 34 || p === 39) && b === ar.j_oTag) {
              this.jsxReadString(p);
              return;
            }
          }
          if (p === 60 && this.state.canStartJSXElement && this.input.charCodeAt(this.state.pos + 1) !== 33) {
            ++this.state.pos, this.finishToken(142);
            return;
          }
          super.getTokenFromCode(p);
        }
        updateContext(p) {
          let { context: b, type: T } = this.state;
          if (T === 56 && p === 142) b.splice(-2, 2, ar.j_cTag), this.state.canStartJSXElement = !1;
          else if (T === 142) b.push(ar.j_oTag);
          else if (T === 143) {
            let F = b[b.length - 1];
            F === ar.j_oTag && p === 56 || F === ar.j_cTag ? (b.pop(), this.state.canStartJSXElement = b[b.length - 1] === ar.j_expr) : (this.setContext(ar.j_expr), this.state.canStartJSXElement = !0);
          } else this.state.canStartJSXElement = VT(T);
        }
      }, uS = class extends Yg {
        constructor(...y) {
          super(...y), this.tsNames = /* @__PURE__ */ new Map();
        }
      }, Qf = class extends Yf {
        constructor(...y) {
          super(...y), this.importsStack = [];
        }
        createScope(y) {
          return this.importsStack.push(/* @__PURE__ */ new Set()), new uS(y);
        }
        enter(y) {
          y === 256 && this.importsStack.push(/* @__PURE__ */ new Set()), super.enter(y);
        }
        exit() {
          let y = super.exit();
          return y === 256 && this.importsStack.pop(), y;
        }
        hasImport(y, p) {
          let b = this.importsStack.length;
          if (this.importsStack[b - 1].has(y)) return !0;
          if (!p && b > 1) {
            for (let T = 0; T < b - 1; T++) if (this.importsStack[T].has(y)) return !0;
          }
          return !1;
        }
        declareName(y, p, b) {
          if (p & 4096) {
            this.hasImport(y, !0) && this.parser.raise(Se.VarRedeclaration, b, { identifierName: y }), this.importsStack[this.importsStack.length - 1].add(y);
            return;
          }
          let T = this.currentScope(), F = T.tsNames.get(y) || 0;
          if (p & 1024) {
            this.maybeExportDefined(T, y), T.tsNames.set(y, F | 16);
            return;
          }
          super.declareName(y, p, b), p & 2 && (p & 1 || (this.checkRedeclarationInScope(T, y, p, b), this.maybeExportDefined(T, y)), F = F | 1), p & 256 && (F = F | 2), p & 512 && (F = F | 4), p & 128 && (F = F | 8), F && T.tsNames.set(y, F);
        }
        isRedeclaredInScope(y, p, b) {
          let T = y.tsNames.get(p);
          if ((T & 2) > 0) {
            if (b & 256) {
              let F = !!(b & 512), Y = (T & 4) > 0;
              return F !== Y;
            }
            return !0;
          }
          return b & 128 && (T & 8) > 0 ? y.names.get(p) & 2 ? !!(b & 1) : !1 : b & 2 && (T & 1) > 0 ? !0 : super.isRedeclaredInScope(y, p, b);
        }
        checkLocalExport(y) {
          let { name: p } = y;
          if (this.hasImport(p)) return;
          let b = this.scopeStack.length;
          for (let T = b - 1; T >= 0; T--) {
            let F = this.scopeStack[T].tsNames.get(p);
            if ((F & 1) > 0 || (F & 16) > 0) return;
          }
          super.checkLocalExport(y);
        }
      }, Nl = (y, p) => hasOwnProperty.call(y, p) && y[p], Jd = (y) => y.type === "ParenthesizedExpression" ? Jd(y.expression) : y, Yv = class extends oS {
        toAssignable(y, p = !1) {
          var b, T;
          let F;
          switch ((y.type === "ParenthesizedExpression" || (b = y.extra) != null && b.parenthesized) && (F = Jd(y), p ? F.type === "Identifier" ? this.expressionScope.recordArrowParameterBindingError(Se.InvalidParenthesizedAssignment, y) : F.type !== "MemberExpression" && !this.isOptionalMemberExpression(F) && this.raise(Se.InvalidParenthesizedAssignment, y) : this.raise(Se.InvalidParenthesizedAssignment, y)), y.type) {
            case "Identifier":
            case "ObjectPattern":
            case "ArrayPattern":
            case "AssignmentPattern":
            case "RestElement":
              break;
            case "ObjectExpression":
              y.type = "ObjectPattern";
              for (let ie = 0, de = y.properties.length, he = de - 1; ie < de; ie++) {
                var Y;
                let fe = y.properties[ie], Ze = ie === he;
                this.toAssignableObjectExpressionProp(fe, Ze, p), Ze && fe.type === "RestElement" && (Y = y.extra) != null && Y.trailingCommaLoc && this.raise(Se.RestTrailingComma, y.extra.trailingCommaLoc);
              }
              break;
            case "ObjectProperty": {
              let { key: ie, value: de } = y;
              this.isPrivateName(ie) && this.classScope.usePrivateName(this.getPrivateNameSV(ie), ie.loc.start), this.toAssignable(de, p);
              break;
            }
            case "SpreadElement":
              throw new Error("Internal @babel/parser error (this is a bug, please report it). SpreadElement should be converted by .toAssignable's caller.");
            case "ArrayExpression":
              y.type = "ArrayPattern", this.toAssignableList(y.elements, (T = y.extra) == null ? void 0 : T.trailingCommaLoc, p);
              break;
            case "AssignmentExpression":
              y.operator !== "=" && this.raise(Se.MissingEqInAssignment, y.left.loc.end), y.type = "AssignmentPattern", delete y.operator, this.toAssignable(y.left, p);
              break;
            case "ParenthesizedExpression":
              this.toAssignable(F, p);
              break;
          }
        }
        toAssignableObjectExpressionProp(y, p, b) {
          if (y.type === "ObjectMethod") this.raise(y.kind === "get" || y.kind === "set" ? Se.PatternHasAccessor : Se.PatternHasMethod, y.key);
          else if (y.type === "SpreadElement") {
            y.type = "RestElement";
            let T = y.argument;
            this.checkToRestConversion(T, !1), this.toAssignable(T, b), p || this.raise(Se.RestTrailingComma, y);
          } else this.toAssignable(y, b);
        }
        toAssignableList(y, p, b) {
          let T = y.length - 1;
          for (let F = 0; F <= T; F++) {
            let Y = y[F];
            if (Y) {
              if (Y.type === "SpreadElement") {
                Y.type = "RestElement";
                let ie = Y.argument;
                this.checkToRestConversion(ie, !0), this.toAssignable(ie, b);
              } else this.toAssignable(Y, b);
              Y.type === "RestElement" && (F < T ? this.raise(Se.RestTrailingComma, Y) : p && this.raise(Se.RestTrailingComma, p));
            }
          }
        }
        isAssignable(y, p) {
          switch (y.type) {
            case "Identifier":
            case "ObjectPattern":
            case "ArrayPattern":
            case "AssignmentPattern":
            case "RestElement":
              return !0;
            case "ObjectExpression": {
              let b = y.properties.length - 1;
              return y.properties.every((T, F) => T.type !== "ObjectMethod" && (F === b || T.type !== "SpreadElement") && this.isAssignable(T));
            }
            case "ObjectProperty":
              return this.isAssignable(y.value);
            case "SpreadElement":
              return this.isAssignable(y.argument);
            case "ArrayExpression":
              return y.elements.every((b) => b === null || this.isAssignable(b));
            case "AssignmentExpression":
              return y.operator === "=";
            case "ParenthesizedExpression":
              return this.isAssignable(y.expression);
            case "MemberExpression":
            case "OptionalMemberExpression":
              return !p;
            default:
              return !1;
          }
        }
        toReferencedList(y, p) {
          return y;
        }
        toReferencedListDeep(y, p) {
          this.toReferencedList(y, p);
          for (let b of y) (b == null ? void 0 : b.type) === "ArrayExpression" && this.toReferencedListDeep(b.elements);
        }
        parseSpread(y) {
          let p = this.startNode();
          return this.next(), p.argument = this.parseMaybeAssignAllowIn(y, void 0), this.finishNode(p, "SpreadElement");
        }
        parseRestBinding() {
          let y = this.startNode();
          return this.next(), y.argument = this.parseBindingAtom(), this.finishNode(y, "RestElement");
        }
        parseBindingAtom() {
          switch (this.state.type) {
            case 0: {
              let y = this.startNode();
              return this.next(), y.elements = this.parseBindingList(3, 93, 1), this.finishNode(y, "ArrayPattern");
            }
            case 5:
              return this.parseObjectLike(8, !0);
          }
          return this.parseIdentifier();
        }
        parseBindingList(y, p, b) {
          let T = b & 1, F = [], Y = !0;
          for (; !this.eat(y); ) if (Y ? Y = !1 : this.expect(12), T && this.match(12)) F.push(null);
          else {
            if (this.eat(y)) break;
            if (this.match(21)) {
              if (F.push(this.parseAssignableListItemTypes(this.parseRestBinding(), b)), !this.checkCommaAfterRest(p)) {
                this.expect(y);
                break;
              }
            } else {
              let ie = [];
              for (this.match(26) && this.hasPlugin("decorators") && this.raise(Se.UnsupportedParameterDecorator, this.state.startLoc); this.match(26); ) ie.push(this.parseDecorator());
              F.push(this.parseAssignableListItem(b, ie));
            }
          }
          return F;
        }
        parseBindingRestProperty(y) {
          return this.next(), y.argument = this.parseIdentifier(), this.checkCommaAfterRest(125), this.finishNode(y, "RestElement");
        }
        parseBindingProperty() {
          let { type: y, startLoc: p } = this.state;
          if (y === 21) return this.parseBindingRestProperty(this.startNode());
          let b = this.startNode();
          return y === 138 ? (this.expectPlugin("destructuringPrivate", p), this.classScope.usePrivateName(this.state.value, p), b.key = this.parsePrivateName()) : this.parsePropertyName(b), b.method = !1, this.parseObjPropValue(b, p, !1, !1, !0, !1);
        }
        parseAssignableListItem(y, p) {
          let b = this.parseMaybeDefault();
          this.parseAssignableListItemTypes(b, y);
          let T = this.parseMaybeDefault(b.loc.start, b);
          return p.length && (b.decorators = p), T;
        }
        parseAssignableListItemTypes(y, p) {
          return y;
        }
        parseMaybeDefault(y, p) {
          var b;
          if (y != null || (y = this.state.startLoc), p = (b = p) != null ? b : this.parseBindingAtom(), !this.eat(29)) return p;
          let T = this.startNodeAt(y);
          return T.left = p, T.right = this.parseMaybeAssignAllowIn(), this.finishNode(T, "AssignmentPattern");
        }
        isValidLVal(y, p, b) {
          return Nl({ AssignmentPattern: "left", RestElement: "argument", ObjectProperty: "value", ParenthesizedExpression: "expression", ArrayPattern: "elements", ObjectPattern: "properties" }, y);
        }
        isOptionalMemberExpression(y) {
          return y.type === "OptionalMemberExpression";
        }
        checkLVal(y, { in: p, binding: b = 64, checkClashes: T = !1, strictModeChanged: F = !1, hasParenthesizedAncestor: Y = !1 }) {
          var ie;
          let de = y.type;
          if (this.isObjectMethod(y)) return;
          let he = this.isOptionalMemberExpression(y);
          if (he || de === "MemberExpression") {
            he && (this.expectPlugin("optionalChainingAssign", y.loc.start), p.type !== "AssignmentExpression" && this.raise(Se.InvalidLhsOptionalChaining, y, { ancestor: p })), b !== 64 && this.raise(Se.InvalidPropertyBindingPattern, y);
            return;
          }
          if (de === "Identifier") {
            this.checkIdentifier(y, b, F);
            let { name: It } = y;
            T && (T.has(It) ? this.raise(Se.ParamDupe, y) : T.add(It));
            return;
          }
          let fe = this.isValidLVal(de, !(Y || (ie = y.extra) != null && ie.parenthesized) && p.type === "AssignmentExpression", b);
          if (fe === !0) return;
          if (fe === !1) {
            let It = b === 64 ? Se.InvalidLhs : Se.InvalidLhsBinding;
            this.raise(It, y, { ancestor: p });
            return;
          }
          let [Ze, Dt] = Array.isArray(fe) ? fe : [fe, de === "ParenthesizedExpression"], $t = de === "ArrayPattern" || de === "ObjectPattern" ? { type: de } : p;
          for (let It of [].concat(y[Ze])) It && this.checkLVal(It, { in: $t, binding: b, checkClashes: T, strictModeChanged: F, hasParenthesizedAncestor: Dt });
        }
        checkIdentifier(y, p, b = !1) {
          this.state.strict && (b ? Uv(y.name, this.inModule) : zv(y.name)) && (p === 64 ? this.raise(Se.StrictEvalArguments, y, { referenceName: y.name }) : this.raise(Se.StrictEvalArgumentsBinding, y, { bindingName: y.name })), p & 8192 && y.name === "let" && this.raise(Se.LetInLexicalBinding, y), p & 64 || this.declareNameFromIdentifier(y, p);
        }
        declareNameFromIdentifier(y, p) {
          this.scope.declareName(y.name, p, y.loc.start);
        }
        checkToRestConversion(y, p) {
          switch (y.type) {
            case "ParenthesizedExpression":
              this.checkToRestConversion(y.expression, p);
              break;
            case "Identifier":
            case "MemberExpression":
              break;
            case "ArrayExpression":
            case "ObjectExpression":
              if (p) break;
            default:
              this.raise(Se.InvalidRestAssignmentPattern, y);
          }
        }
        checkCommaAfterRest(y) {
          return this.match(12) ? (this.raise(this.lookaheadCharCode() === y ? Se.RestTrailingComma : Se.ElementAfterRest, this.state.startLoc), !0) : !1;
        }
      }, Zf = (y, p) => hasOwnProperty.call(y, p) && y[p];
      function Kv(y) {
        if (y == null) throw new Error(`Unexpected ${y} value.`);
        return y;
      }
      function ny(y) {
        if (!y) throw new Error("Assert fail");
      }
      var Bt = ga`typescript`({ AbstractMethodHasImplementation: ({ methodName: y }) => `Method '${y}' cannot have an implementation because it is marked abstract.`, AbstractPropertyHasInitializer: ({ propertyName: y }) => `Property '${y}' cannot have an initializer because it is marked abstract.`, AccesorCannotDeclareThisParameter: "'get' and 'set' accessors cannot declare 'this' parameters.", AccesorCannotHaveTypeParameters: "An accessor cannot have type parameters.", AccessorCannotBeOptional: "An 'accessor' property cannot be declared optional.", ClassMethodHasDeclare: "Class methods cannot have the 'declare' modifier.", ClassMethodHasReadonly: "Class methods cannot have the 'readonly' modifier.", ConstInitiailizerMustBeStringOrNumericLiteralOrLiteralEnumReference: "A 'const' initializer in an ambient context must be a string or numeric literal or literal enum reference.", ConstructorHasTypeParameters: "Type parameters cannot appear on a constructor declaration.", DeclareAccessor: ({ kind: y }) => `'declare' is not allowed in ${y}ters.`, DeclareClassFieldHasInitializer: "Initializers are not allowed in ambient contexts.", DeclareFunctionHasImplementation: "An implementation cannot be declared in ambient contexts.", DuplicateAccessibilityModifier: ({ modifier: y }) => "Accessibility modifier already seen.", DuplicateModifier: ({ modifier: y }) => `Duplicate modifier: '${y}'.`, EmptyHeritageClauseType: ({ token: y }) => `'${y}' list cannot be empty.`, EmptyTypeArguments: "Type argument list cannot be empty.", EmptyTypeParameters: "Type parameter list cannot be empty.", ExpectedAmbientAfterExportDeclare: "'export declare' must be followed by an ambient declaration.", ImportAliasHasImportType: "An import alias can not use 'import type'.", ImportReflectionHasImportType: "An `import module` declaration can not use `type` modifier", IncompatibleModifiers: ({ modifiers: y }) => `'${y[0]}' modifier cannot be used with '${y[1]}' modifier.`, IndexSignatureHasAbstract: "Index signatures cannot have the 'abstract' modifier.", IndexSignatureHasAccessibility: ({ modifier: y }) => `Index signatures cannot have an accessibility modifier ('${y}').`, IndexSignatureHasDeclare: "Index signatures cannot have the 'declare' modifier.", IndexSignatureHasOverride: "'override' modifier cannot appear on an index signature.", IndexSignatureHasStatic: "Index signatures cannot have the 'static' modifier.", InitializerNotAllowedInAmbientContext: "Initializers are not allowed in ambient contexts.", InvalidModifierOnTypeMember: ({ modifier: y }) => `'${y}' modifier cannot appear on a type member.`, InvalidModifierOnTypeParameter: ({ modifier: y }) => `'${y}' modifier cannot appear on a type parameter.`, InvalidModifierOnTypeParameterPositions: ({ modifier: y }) => `'${y}' modifier can only appear on a type parameter of a class, interface or type alias.`, InvalidModifiersOrder: ({ orderedModifiers: y }) => `'${y[0]}' modifier must precede '${y[1]}' modifier.`, InvalidPropertyAccessAfterInstantiationExpression: "Invalid property access after an instantiation expression. You can either wrap the instantiation expression in parentheses, or delete the type arguments.", InvalidTupleMemberLabel: "Tuple members must be labeled with a simple identifier.", MissingInterfaceName: "'interface' declarations must be followed by an identifier.", NonAbstractClassHasAbstractMethod: "Abstract methods can only appear within an abstract class.", NonClassMethodPropertyHasAbstractModifer: "'abstract' modifier can only appear on a class, method, or property declaration.", OptionalTypeBeforeRequired: "A required element cannot follow an optional element.", OverrideNotInSubClass: "This member cannot have an 'override' modifier because its containing class does not extend another class.", PatternIsOptional: "A binding pattern parameter cannot be optional in an implementation signature.", PrivateElementHasAbstract: "Private elements cannot have the 'abstract' modifier.", PrivateElementHasAccessibility: ({ modifier: y }) => `Private elements cannot have an accessibility modifier ('${y}').`, ReadonlyForMethodSignature: "'readonly' modifier can only appear on a property declaration or index signature.", ReservedArrowTypeParam: "This syntax is reserved in files with the .mts or .cts extension. Add a trailing comma, as in `<T,>() => ...`.", ReservedTypeAssertion: "This syntax is reserved in files with the .mts or .cts extension. Use an `as` expression instead.", SetAccesorCannotHaveOptionalParameter: "A 'set' accessor cannot have an optional parameter.", SetAccesorCannotHaveRestParameter: "A 'set' accessor cannot have rest parameter.", SetAccesorCannotHaveReturnType: "A 'set' accessor cannot have a return type annotation.", SingleTypeParameterWithoutTrailingComma: ({ typeParameterName: y }) => `Single type parameter ${y} should have a trailing comma. Example usage: <${y},>.`, StaticBlockCannotHaveModifier: "Static class blocks cannot have any modifier.", TupleOptionalAfterType: "A labeled tuple optional element must be declared using a question mark after the name and before the colon (`name?: type`), rather than after the type (`name: type?`).", TypeAnnotationAfterAssign: "Type annotations must come before default assignments, e.g. instead of `age = 25: number` use `age: number = 25`.", TypeImportCannotSpecifyDefaultAndNamed: "A type-only import can specify a default import or named bindings, but not both.", TypeModifierIsUsedInTypeExports: "The 'type' modifier cannot be used on a named export when 'export type' is used on its export statement.", TypeModifierIsUsedInTypeImports: "The 'type' modifier cannot be used on a named import when 'import type' is used on its import statement.", UnexpectedParameterModifier: "A parameter property is only allowed in a constructor implementation.", UnexpectedReadonly: "'readonly' type modifier is only permitted on array and tuple literal types.", UnexpectedTypeAnnotation: "Did not expect a type annotation here.", UnexpectedTypeCastInParameter: "Unexpected type cast in parameter position.", UnsupportedImportTypeArgument: "Argument in a type import must be a string literal.", UnsupportedParameterPropertyKind: "A parameter property may not be declared using a binding pattern.", UnsupportedSignatureParameterKind: ({ type: y }) => `Name in a signature must be an Identifier, ObjectPattern or ArrayPattern, instead got ${y}.` });
      function Jv(y) {
        switch (y) {
          case "any":
            return "TSAnyKeyword";
          case "boolean":
            return "TSBooleanKeyword";
          case "bigint":
            return "TSBigIntKeyword";
          case "never":
            return "TSNeverKeyword";
          case "number":
            return "TSNumberKeyword";
          case "object":
            return "TSObjectKeyword";
          case "string":
            return "TSStringKeyword";
          case "symbol":
            return "TSSymbolKeyword";
          case "undefined":
            return "TSUndefinedKeyword";
          case "unknown":
            return "TSUnknownKeyword";
          default:
            return;
        }
      }
      function Nc(y) {
        return y === "private" || y === "public" || y === "protected";
      }
      function ju(y) {
        return y === "in" || y === "out";
      }
      var eh = (y) => class extends y {
        constructor(...p) {
          super(...p), this.tsParseInOutModifiers = this.tsParseModifiers.bind(this, { allowedModifiers: ["in", "out"], disallowedModifiers: ["const", "public", "private", "protected", "readonly", "declare", "abstract", "override"], errorTemplate: Bt.InvalidModifierOnTypeParameter }), this.tsParseConstModifier = this.tsParseModifiers.bind(this, { allowedModifiers: ["const"], disallowedModifiers: ["in", "out"], errorTemplate: Bt.InvalidModifierOnTypeParameterPositions }), this.tsParseInOutConstModifiers = this.tsParseModifiers.bind(this, { allowedModifiers: ["in", "out", "const"], disallowedModifiers: ["public", "private", "protected", "readonly", "declare", "abstract", "override"], errorTemplate: Bt.InvalidModifierOnTypeParameter });
        }
        getScopeHandler() {
          return Qf;
        }
        tsIsIdentifier() {
          return Qt(this.state.type);
        }
        tsTokenCanFollowModifier() {
          return (this.match(0) || this.match(5) || this.match(55) || this.match(21) || this.match(138) || this.isLiteralPropertyName()) && !this.hasPrecedingLineBreak();
        }
        tsNextTokenCanFollowModifier() {
          return this.next(), this.tsTokenCanFollowModifier();
        }
        tsParseModifier(p, b) {
          if (!Qt(this.state.type) && this.state.type !== 58 && this.state.type !== 75) return;
          let T = this.state.value;
          if (p.includes(T)) {
            if (b && this.tsIsStartOfStaticBlocks()) return;
            if (this.tsTryParse(this.tsNextTokenCanFollowModifier.bind(this))) return T;
          }
        }
        tsParseModifiers({ allowedModifiers: p, disallowedModifiers: b, stopOnStartOfClassStaticBlock: T, errorTemplate: F = Bt.InvalidModifierOnTypeMember }, Y) {
          let ie = (he, fe, Ze, Dt) => {
            fe === Ze && Y[Dt] && this.raise(Bt.InvalidModifiersOrder, he, { orderedModifiers: [Ze, Dt] });
          }, de = (he, fe, Ze, Dt) => {
            (Y[Ze] && fe === Dt || Y[Dt] && fe === Ze) && this.raise(Bt.IncompatibleModifiers, he, { modifiers: [Ze, Dt] });
          };
          for (; ; ) {
            let { startLoc: he } = this.state, fe = this.tsParseModifier(p.concat(b ?? []), T);
            if (!fe) break;
            Nc(fe) ? Y.accessibility ? this.raise(Bt.DuplicateAccessibilityModifier, he, { modifier: fe }) : (ie(he, fe, fe, "override"), ie(he, fe, fe, "static"), ie(he, fe, fe, "readonly"), Y.accessibility = fe) : ju(fe) ? (Y[fe] && this.raise(Bt.DuplicateModifier, he, { modifier: fe }), Y[fe] = !0, ie(he, fe, "in", "out")) : (hasOwnProperty.call(Y, fe) ? this.raise(Bt.DuplicateModifier, he, { modifier: fe }) : (ie(he, fe, "static", "readonly"), ie(he, fe, "static", "override"), ie(he, fe, "override", "readonly"), ie(he, fe, "abstract", "override"), de(he, fe, "declare", "override"), de(he, fe, "static", "abstract")), Y[fe] = !0), b != null && b.includes(fe) && this.raise(F, he, { modifier: fe });
          }
        }
        tsIsListTerminator(p) {
          switch (p) {
            case "EnumMembers":
            case "TypeMembers":
              return this.match(8);
            case "HeritageClauseElement":
              return this.match(5);
            case "TupleElementTypes":
              return this.match(3);
            case "TypeParametersOrArguments":
              return this.match(48);
          }
        }
        tsParseList(p, b) {
          let T = [];
          for (; !this.tsIsListTerminator(p); ) T.push(b());
          return T;
        }
        tsParseDelimitedList(p, b, T) {
          return Kv(this.tsParseDelimitedListWorker(p, b, !0, T));
        }
        tsParseDelimitedListWorker(p, b, T, F) {
          let Y = [], ie = -1;
          for (; !this.tsIsListTerminator(p); ) {
            ie = -1;
            let de = b();
            if (de == null) return;
            if (Y.push(de), this.eat(12)) {
              ie = this.state.lastTokStartLoc.index;
              continue;
            }
            if (this.tsIsListTerminator(p)) break;
            T && this.expect(12);
            return;
          }
          return F && (F.value = ie), Y;
        }
        tsParseBracketedList(p, b, T, F, Y) {
          F || (T ? this.expect(0) : this.expect(47));
          let ie = this.tsParseDelimitedList(p, b, Y);
          return T ? this.expect(3) : this.expect(48), ie;
        }
        tsParseImportType() {
          let p = this.startNode();
          return this.expect(83), this.expect(10), this.match(133) || this.raise(Bt.UnsupportedImportTypeArgument, this.state.startLoc), p.argument = super.parseExprAtom(), (this.hasPlugin("importAttributes") || this.hasPlugin("importAssertions")) && (p.options = null), this.eat(12) && (this.expectImportAttributesPlugin(), this.match(11) || (p.options = super.parseMaybeAssignAllowIn(), this.eat(12))), this.expect(11), this.eat(16) && (p.qualifier = this.tsParseEntityName()), this.match(47) && (p.typeParameters = this.tsParseTypeArguments()), this.finishNode(p, "TSImportType");
        }
        tsParseEntityName(p = !0) {
          let b = this.parseIdentifier(p);
          for (; this.eat(16); ) {
            let T = this.startNodeAtNode(b);
            T.left = b, T.right = this.parseIdentifier(p), b = this.finishNode(T, "TSQualifiedName");
          }
          return b;
        }
        tsParseTypeReference() {
          let p = this.startNode();
          return p.typeName = this.tsParseEntityName(), !this.hasPrecedingLineBreak() && this.match(47) && (p.typeParameters = this.tsParseTypeArguments()), this.finishNode(p, "TSTypeReference");
        }
        tsParseThisTypePredicate(p) {
          this.next();
          let b = this.startNodeAtNode(p);
          return b.parameterName = p, b.typeAnnotation = this.tsParseTypeAnnotation(!1), b.asserts = !1, this.finishNode(b, "TSTypePredicate");
        }
        tsParseThisTypeNode() {
          let p = this.startNode();
          return this.next(), this.finishNode(p, "TSThisType");
        }
        tsParseTypeQuery() {
          let p = this.startNode();
          return this.expect(87), this.match(83) ? p.exprName = this.tsParseImportType() : p.exprName = this.tsParseEntityName(), !this.hasPrecedingLineBreak() && this.match(47) && (p.typeParameters = this.tsParseTypeArguments()), this.finishNode(p, "TSTypeQuery");
        }
        tsParseTypeParameter(p) {
          let b = this.startNode();
          return p(b), b.name = this.tsParseTypeParameterName(), b.constraint = this.tsEatThenParseType(81), b.default = this.tsEatThenParseType(29), this.finishNode(b, "TSTypeParameter");
        }
        tsTryParseTypeParameters(p) {
          if (this.match(47)) return this.tsParseTypeParameters(p);
        }
        tsParseTypeParameters(p) {
          let b = this.startNode();
          this.match(47) || this.match(142) ? this.next() : this.unexpected();
          let T = { value: -1 };
          return b.params = this.tsParseBracketedList("TypeParametersOrArguments", this.tsParseTypeParameter.bind(this, p), !1, !0, T), b.params.length === 0 && this.raise(Bt.EmptyTypeParameters, b), T.value !== -1 && this.addExtra(b, "trailingComma", T.value), this.finishNode(b, "TSTypeParameterDeclaration");
        }
        tsFillSignature(p, b) {
          let T = p === 19, F = "parameters", Y = "typeAnnotation";
          b.typeParameters = this.tsTryParseTypeParameters(this.tsParseConstModifier), this.expect(10), b[F] = this.tsParseBindingListForSignature(), T ? b[Y] = this.tsParseTypeOrTypePredicateAnnotation(p) : this.match(p) && (b[Y] = this.tsParseTypeOrTypePredicateAnnotation(p));
        }
        tsParseBindingListForSignature() {
          let p = super.parseBindingList(11, 41, 2);
          for (let b of p) {
            let { type: T } = b;
            (T === "AssignmentPattern" || T === "TSParameterProperty") && this.raise(Bt.UnsupportedSignatureParameterKind, b, { type: T });
          }
          return p;
        }
        tsParseTypeMemberSemicolon() {
          !this.eat(12) && !this.isLineTerminator() && this.expect(13);
        }
        tsParseSignatureMember(p, b) {
          return this.tsFillSignature(14, b), this.tsParseTypeMemberSemicolon(), this.finishNode(b, p);
        }
        tsIsUnambiguouslyIndexSignature() {
          return this.next(), Qt(this.state.type) ? (this.next(), this.match(14)) : !1;
        }
        tsTryParseIndexSignature(p) {
          if (!(this.match(0) && this.tsLookAhead(this.tsIsUnambiguouslyIndexSignature.bind(this)))) return;
          this.expect(0);
          let b = this.parseIdentifier();
          b.typeAnnotation = this.tsParseTypeAnnotation(), this.resetEndLocation(b), this.expect(3), p.parameters = [b];
          let T = this.tsTryParseTypeAnnotation();
          return T && (p.typeAnnotation = T), this.tsParseTypeMemberSemicolon(), this.finishNode(p, "TSIndexSignature");
        }
        tsParsePropertyOrMethodSignature(p, b) {
          this.eat(17) && (p.optional = !0);
          let T = p;
          if (this.match(10) || this.match(47)) {
            b && this.raise(Bt.ReadonlyForMethodSignature, p);
            let F = T;
            F.kind && this.match(47) && this.raise(Bt.AccesorCannotHaveTypeParameters, this.state.curPosition()), this.tsFillSignature(14, F), this.tsParseTypeMemberSemicolon();
            let Y = "parameters", ie = "typeAnnotation";
            if (F.kind === "get") F[Y].length > 0 && (this.raise(Se.BadGetterArity, this.state.curPosition()), this.isThisParam(F[Y][0]) && this.raise(Bt.AccesorCannotDeclareThisParameter, this.state.curPosition()));
            else if (F.kind === "set") {
              if (F[Y].length !== 1) this.raise(Se.BadSetterArity, this.state.curPosition());
              else {
                let de = F[Y][0];
                this.isThisParam(de) && this.raise(Bt.AccesorCannotDeclareThisParameter, this.state.curPosition()), de.type === "Identifier" && de.optional && this.raise(Bt.SetAccesorCannotHaveOptionalParameter, this.state.curPosition()), de.type === "RestElement" && this.raise(Bt.SetAccesorCannotHaveRestParameter, this.state.curPosition());
              }
              F[ie] && this.raise(Bt.SetAccesorCannotHaveReturnType, F[ie]);
            } else F.kind = "method";
            return this.finishNode(F, "TSMethodSignature");
          } else {
            let F = T;
            b && (F.readonly = !0);
            let Y = this.tsTryParseTypeAnnotation();
            return Y && (F.typeAnnotation = Y), this.tsParseTypeMemberSemicolon(), this.finishNode(F, "TSPropertySignature");
          }
        }
        tsParseTypeMember() {
          let p = this.startNode();
          if (this.match(10) || this.match(47)) return this.tsParseSignatureMember("TSCallSignatureDeclaration", p);
          if (this.match(77)) {
            let T = this.startNode();
            return this.next(), this.match(10) || this.match(47) ? this.tsParseSignatureMember("TSConstructSignatureDeclaration", p) : (p.key = this.createIdentifier(T, "new"), this.tsParsePropertyOrMethodSignature(p, !1));
          }
          return this.tsParseModifiers({ allowedModifiers: ["readonly"], disallowedModifiers: ["declare", "abstract", "private", "protected", "public", "static", "override"] }, p), this.tsTryParseIndexSignature(p) || (super.parsePropertyName(p), !p.computed && p.key.type === "Identifier" && (p.key.name === "get" || p.key.name === "set") && this.tsTokenCanFollowModifier() && (p.kind = p.key.name, super.parsePropertyName(p)), this.tsParsePropertyOrMethodSignature(p, !!p.readonly));
        }
        tsParseTypeLiteral() {
          let p = this.startNode();
          return p.members = this.tsParseObjectTypeMembers(), this.finishNode(p, "TSTypeLiteral");
        }
        tsParseObjectTypeMembers() {
          this.expect(5);
          let p = this.tsParseList("TypeMembers", this.tsParseTypeMember.bind(this));
          return this.expect(8), p;
        }
        tsIsStartOfMappedType() {
          return this.next(), this.eat(53) ? this.isContextual(122) : (this.isContextual(122) && this.next(), !this.match(0) || (this.next(), !this.tsIsIdentifier()) ? !1 : (this.next(), this.match(58)));
        }
        tsParseMappedTypeParameter() {
          let p = this.startNode();
          return p.name = this.tsParseTypeParameterName(), p.constraint = this.tsExpectThenParseType(58), this.finishNode(p, "TSTypeParameter");
        }
        tsParseMappedType() {
          let p = this.startNode();
          return this.expect(5), this.match(53) ? (p.readonly = this.state.value, this.next(), this.expectContextual(122)) : this.eatContextual(122) && (p.readonly = !0), this.expect(0), p.typeParameter = this.tsParseMappedTypeParameter(), p.nameType = this.eatContextual(93) ? this.tsParseType() : null, this.expect(3), this.match(53) ? (p.optional = this.state.value, this.next(), this.expect(17)) : this.eat(17) && (p.optional = !0), p.typeAnnotation = this.tsTryParseType(), this.semicolon(), this.expect(8), this.finishNode(p, "TSMappedType");
        }
        tsParseTupleType() {
          let p = this.startNode();
          p.elementTypes = this.tsParseBracketedList("TupleElementTypes", this.tsParseTupleElementType.bind(this), !0, !1);
          let b = !1;
          return p.elementTypes.forEach((T) => {
            let { type: F } = T;
            b && F !== "TSRestType" && F !== "TSOptionalType" && !(F === "TSNamedTupleMember" && T.optional) && this.raise(Bt.OptionalTypeBeforeRequired, T), b || (b = F === "TSNamedTupleMember" && T.optional || F === "TSOptionalType");
          }), this.finishNode(p, "TSTupleType");
        }
        tsParseTupleElementType() {
          let { startLoc: p } = this.state, b = this.eat(21), T, F, Y, ie, de = Bs(this.state.type) ? this.lookaheadCharCode() : null;
          if (de === 58) T = !0, Y = !1, F = this.parseIdentifier(!0), this.expect(14), ie = this.tsParseType();
          else if (de === 63) {
            Y = !0;
            let he = this.state.startLoc, fe = this.state.value, Ze = this.tsParseNonArrayType();
            this.lookaheadCharCode() === 58 ? (T = !0, F = this.createIdentifier(this.startNodeAt(he), fe), this.expect(17), this.expect(14), ie = this.tsParseType()) : (T = !1, ie = Ze, this.expect(17));
          } else ie = this.tsParseType(), Y = this.eat(17), T = this.eat(14);
          if (T) {
            let he;
            F ? (he = this.startNodeAtNode(F), he.optional = Y, he.label = F, he.elementType = ie, this.eat(17) && (he.optional = !0, this.raise(Bt.TupleOptionalAfterType, this.state.lastTokStartLoc))) : (he = this.startNodeAtNode(ie), he.optional = Y, this.raise(Bt.InvalidTupleMemberLabel, ie), he.label = ie, he.elementType = this.tsParseType()), ie = this.finishNode(he, "TSNamedTupleMember");
          } else if (Y) {
            let he = this.startNodeAtNode(ie);
            he.typeAnnotation = ie, ie = this.finishNode(he, "TSOptionalType");
          }
          if (b) {
            let he = this.startNodeAt(p);
            he.typeAnnotation = ie, ie = this.finishNode(he, "TSRestType");
          }
          return ie;
        }
        tsParseParenthesizedType() {
          let p = this.startNode();
          return this.expect(10), p.typeAnnotation = this.tsParseType(), this.expect(11), this.finishNode(p, "TSParenthesizedType");
        }
        tsParseFunctionOrConstructorType(p, b) {
          let T = this.startNode();
          return p === "TSConstructorType" && (T.abstract = !!b, b && this.next(), this.next()), this.tsInAllowConditionalTypesContext(() => this.tsFillSignature(19, T)), this.finishNode(T, p);
        }
        tsParseLiteralTypeNode() {
          let p = this.startNode();
          switch (this.state.type) {
            case 134:
            case 135:
            case 133:
            case 85:
            case 86:
              p.literal = super.parseExprAtom();
              break;
            default:
              this.unexpected();
          }
          return this.finishNode(p, "TSLiteralType");
        }
        tsParseTemplateLiteralType() {
          let p = this.startNode();
          return p.literal = super.parseTemplate(!1), this.finishNode(p, "TSLiteralType");
        }
        parseTemplateSubstitution() {
          return this.state.inType ? this.tsParseType() : super.parseTemplateSubstitution();
        }
        tsParseThisTypeOrThisTypePredicate() {
          let p = this.tsParseThisTypeNode();
          return this.isContextual(116) && !this.hasPrecedingLineBreak() ? this.tsParseThisTypePredicate(p) : p;
        }
        tsParseNonArrayType() {
          switch (this.state.type) {
            case 133:
            case 134:
            case 135:
            case 85:
            case 86:
              return this.tsParseLiteralTypeNode();
            case 53:
              if (this.state.value === "-") {
                let p = this.startNode(), b = this.lookahead();
                return b.type !== 134 && b.type !== 135 && this.unexpected(), p.literal = this.parseMaybeUnary(), this.finishNode(p, "TSLiteralType");
              }
              break;
            case 78:
              return this.tsParseThisTypeOrThisTypePredicate();
            case 87:
              return this.tsParseTypeQuery();
            case 83:
              return this.tsParseImportType();
            case 5:
              return this.tsLookAhead(this.tsIsStartOfMappedType.bind(this)) ? this.tsParseMappedType() : this.tsParseTypeLiteral();
            case 0:
              return this.tsParseTupleType();
            case 10:
              return this.tsParseParenthesizedType();
            case 25:
            case 24:
              return this.tsParseTemplateLiteralType();
            default: {
              let { type: p } = this.state;
              if (Qt(p) || p === 88 || p === 84) {
                let b = p === 88 ? "TSVoidKeyword" : p === 84 ? "TSNullKeyword" : Jv(this.state.value);
                if (b !== void 0 && this.lookaheadCharCode() !== 46) {
                  let T = this.startNode();
                  return this.next(), this.finishNode(T, b);
                }
                return this.tsParseTypeReference();
              }
            }
          }
          this.unexpected();
        }
        tsParseArrayTypeOrHigher() {
          let p = this.tsParseNonArrayType();
          for (; !this.hasPrecedingLineBreak() && this.eat(0); ) if (this.match(3)) {
            let b = this.startNodeAtNode(p);
            b.elementType = p, this.expect(3), p = this.finishNode(b, "TSArrayType");
          } else {
            let b = this.startNodeAtNode(p);
            b.objectType = p, b.indexType = this.tsParseType(), this.expect(3), p = this.finishNode(b, "TSIndexedAccessType");
          }
          return p;
        }
        tsParseTypeOperator() {
          let p = this.startNode(), b = this.state.value;
          return this.next(), p.operator = b, p.typeAnnotation = this.tsParseTypeOperatorOrHigher(), b === "readonly" && this.tsCheckTypeAnnotationForReadOnly(p), this.finishNode(p, "TSTypeOperator");
        }
        tsCheckTypeAnnotationForReadOnly(p) {
          switch (p.typeAnnotation.type) {
            case "TSTupleType":
            case "TSArrayType":
              return;
            default:
              this.raise(Bt.UnexpectedReadonly, p);
          }
        }
        tsParseInferType() {
          let p = this.startNode();
          this.expectContextual(115);
          let b = this.startNode();
          return b.name = this.tsParseTypeParameterName(), b.constraint = this.tsTryParse(() => this.tsParseConstraintForInferType()), p.typeParameter = this.finishNode(b, "TSTypeParameter"), this.finishNode(p, "TSInferType");
        }
        tsParseConstraintForInferType() {
          if (this.eat(81)) {
            let p = this.tsInDisallowConditionalTypesContext(() => this.tsParseType());
            if (this.state.inDisallowConditionalTypesContext || !this.match(17)) return p;
          }
        }
        tsParseTypeOperatorOrHigher() {
          return Bv(this.state.type) && !this.state.containsEsc ? this.tsParseTypeOperator() : this.isContextual(115) ? this.tsParseInferType() : this.tsInAllowConditionalTypesContext(() => this.tsParseArrayTypeOrHigher());
        }
        tsParseUnionOrIntersectionType(p, b, T) {
          let F = this.startNode(), Y = this.eat(T), ie = [];
          do
            ie.push(b());
          while (this.eat(T));
          return ie.length === 1 && !Y ? ie[0] : (F.types = ie, this.finishNode(F, p));
        }
        tsParseIntersectionTypeOrHigher() {
          return this.tsParseUnionOrIntersectionType("TSIntersectionType", this.tsParseTypeOperatorOrHigher.bind(this), 45);
        }
        tsParseUnionTypeOrHigher() {
          return this.tsParseUnionOrIntersectionType("TSUnionType", this.tsParseIntersectionTypeOrHigher.bind(this), 43);
        }
        tsIsStartOfFunctionType() {
          return this.match(47) ? !0 : this.match(10) && this.tsLookAhead(this.tsIsUnambiguouslyStartOfFunctionType.bind(this));
        }
        tsSkipParameterStart() {
          if (Qt(this.state.type) || this.match(78)) return this.next(), !0;
          if (this.match(5)) {
            let { errors: p } = this.state, b = p.length;
            try {
              return this.parseObjectLike(8, !0), p.length === b;
            } catch {
              return !1;
            }
          }
          if (this.match(0)) {
            this.next();
            let { errors: p } = this.state, b = p.length;
            try {
              return super.parseBindingList(3, 93, 1), p.length === b;
            } catch {
              return !1;
            }
          }
          return !1;
        }
        tsIsUnambiguouslyStartOfFunctionType() {
          return this.next(), !!(this.match(11) || this.match(21) || this.tsSkipParameterStart() && (this.match(14) || this.match(12) || this.match(17) || this.match(29) || this.match(11) && (this.next(), this.match(19))));
        }
        tsParseTypeOrTypePredicateAnnotation(p) {
          return this.tsInType(() => {
            let b = this.startNode();
            this.expect(p);
            let T = this.startNode(), F = !!this.tsTryParse(this.tsParseTypePredicateAsserts.bind(this));
            if (F && this.match(78)) {
              let de = this.tsParseThisTypeOrThisTypePredicate();
              return de.type === "TSThisType" ? (T.parameterName = de, T.asserts = !0, T.typeAnnotation = null, de = this.finishNode(T, "TSTypePredicate")) : (this.resetStartLocationFromNode(de, T), de.asserts = !0), b.typeAnnotation = de, this.finishNode(b, "TSTypeAnnotation");
            }
            let Y = this.tsIsIdentifier() && this.tsTryParse(this.tsParseTypePredicatePrefix.bind(this));
            if (!Y) return F ? (T.parameterName = this.parseIdentifier(), T.asserts = F, T.typeAnnotation = null, b.typeAnnotation = this.finishNode(T, "TSTypePredicate"), this.finishNode(b, "TSTypeAnnotation")) : this.tsParseTypeAnnotation(!1, b);
            let ie = this.tsParseTypeAnnotation(!1);
            return T.parameterName = Y, T.typeAnnotation = ie, T.asserts = F, b.typeAnnotation = this.finishNode(T, "TSTypePredicate"), this.finishNode(b, "TSTypeAnnotation");
          });
        }
        tsTryParseTypeOrTypePredicateAnnotation() {
          if (this.match(14)) return this.tsParseTypeOrTypePredicateAnnotation(14);
        }
        tsTryParseTypeAnnotation() {
          if (this.match(14)) return this.tsParseTypeAnnotation();
        }
        tsTryParseType() {
          return this.tsEatThenParseType(14);
        }
        tsParseTypePredicatePrefix() {
          let p = this.parseIdentifier();
          if (this.isContextual(116) && !this.hasPrecedingLineBreak()) return this.next(), p;
        }
        tsParseTypePredicateAsserts() {
          if (this.state.type !== 109) return !1;
          let p = this.state.containsEsc;
          return this.next(), !Qt(this.state.type) && !this.match(78) ? !1 : (p && this.raise(Se.InvalidEscapedReservedWord, this.state.lastTokStartLoc, { reservedWord: "asserts" }), !0);
        }
        tsParseTypeAnnotation(p = !0, b = this.startNode()) {
          return this.tsInType(() => {
            p && this.expect(14), b.typeAnnotation = this.tsParseType();
          }), this.finishNode(b, "TSTypeAnnotation");
        }
        tsParseType() {
          ny(this.state.inType);
          let p = this.tsParseNonConditionalType();
          if (this.state.inDisallowConditionalTypesContext || this.hasPrecedingLineBreak() || !this.eat(81)) return p;
          let b = this.startNodeAtNode(p);
          return b.checkType = p, b.extendsType = this.tsInDisallowConditionalTypesContext(() => this.tsParseNonConditionalType()), this.expect(17), b.trueType = this.tsInAllowConditionalTypesContext(() => this.tsParseType()), this.expect(14), b.falseType = this.tsInAllowConditionalTypesContext(() => this.tsParseType()), this.finishNode(b, "TSConditionalType");
        }
        isAbstractConstructorSignature() {
          return this.isContextual(124) && this.lookahead().type === 77;
        }
        tsParseNonConditionalType() {
          return this.tsIsStartOfFunctionType() ? this.tsParseFunctionOrConstructorType("TSFunctionType") : this.match(77) ? this.tsParseFunctionOrConstructorType("TSConstructorType") : this.isAbstractConstructorSignature() ? this.tsParseFunctionOrConstructorType("TSConstructorType", !0) : this.tsParseUnionTypeOrHigher();
        }
        tsParseTypeAssertion() {
          this.getPluginOption("typescript", "disallowAmbiguousJSXLike") && this.raise(Bt.ReservedTypeAssertion, this.state.startLoc);
          let p = this.startNode();
          return p.typeAnnotation = this.tsInType(() => (this.next(), this.match(75) ? this.tsParseTypeReference() : this.tsParseType())), this.expect(48), p.expression = this.parseMaybeUnary(), this.finishNode(p, "TSTypeAssertion");
        }
        tsParseHeritageClause(p) {
          let b = this.state.startLoc, T = this.tsParseDelimitedList("HeritageClauseElement", () => {
            let F = this.startNode();
            return F.expression = this.tsParseEntityName(), this.match(47) && (F.typeParameters = this.tsParseTypeArguments()), this.finishNode(F, "TSExpressionWithTypeArguments");
          });
          return T.length || this.raise(Bt.EmptyHeritageClauseType, b, { token: p }), T;
        }
        tsParseInterfaceDeclaration(p, b = {}) {
          if (this.hasFollowingLineBreak()) return null;
          this.expectContextual(129), b.declare && (p.declare = !0), Qt(this.state.type) ? (p.id = this.parseIdentifier(), this.checkIdentifier(p.id, 130)) : (p.id = null, this.raise(Bt.MissingInterfaceName, this.state.startLoc)), p.typeParameters = this.tsTryParseTypeParameters(this.tsParseInOutConstModifiers), this.eat(81) && (p.extends = this.tsParseHeritageClause("extends"));
          let T = this.startNode();
          return T.body = this.tsInType(this.tsParseObjectTypeMembers.bind(this)), p.body = this.finishNode(T, "TSInterfaceBody"), this.finishNode(p, "TSInterfaceDeclaration");
        }
        tsParseTypeAliasDeclaration(p) {
          return p.id = this.parseIdentifier(), this.checkIdentifier(p.id, 2), p.typeAnnotation = this.tsInType(() => {
            if (p.typeParameters = this.tsTryParseTypeParameters(this.tsParseInOutModifiers), this.expect(29), this.isContextual(114) && this.lookahead().type !== 16) {
              let b = this.startNode();
              return this.next(), this.finishNode(b, "TSIntrinsicKeyword");
            }
            return this.tsParseType();
          }), this.semicolon(), this.finishNode(p, "TSTypeAliasDeclaration");
        }
        tsInNoContext(p) {
          let b = this.state.context;
          this.state.context = [b[0]];
          try {
            return p();
          } finally {
            this.state.context = b;
          }
        }
        tsInType(p) {
          let b = this.state.inType;
          this.state.inType = !0;
          try {
            return p();
          } finally {
            this.state.inType = b;
          }
        }
        tsInDisallowConditionalTypesContext(p) {
          let b = this.state.inDisallowConditionalTypesContext;
          this.state.inDisallowConditionalTypesContext = !0;
          try {
            return p();
          } finally {
            this.state.inDisallowConditionalTypesContext = b;
          }
        }
        tsInAllowConditionalTypesContext(p) {
          let b = this.state.inDisallowConditionalTypesContext;
          this.state.inDisallowConditionalTypesContext = !1;
          try {
            return p();
          } finally {
            this.state.inDisallowConditionalTypesContext = b;
          }
        }
        tsEatThenParseType(p) {
          if (this.match(p)) return this.tsNextThenParseType();
        }
        tsExpectThenParseType(p) {
          return this.tsInType(() => (this.expect(p), this.tsParseType()));
        }
        tsNextThenParseType() {
          return this.tsInType(() => (this.next(), this.tsParseType()));
        }
        tsParseEnumMember() {
          let p = this.startNode();
          return p.id = this.match(133) ? super.parseStringLiteral(this.state.value) : this.parseIdentifier(!0), this.eat(29) && (p.initializer = super.parseMaybeAssignAllowIn()), this.finishNode(p, "TSEnumMember");
        }
        tsParseEnumDeclaration(p, b = {}) {
          return b.const && (p.const = !0), b.declare && (p.declare = !0), this.expectContextual(126), p.id = this.parseIdentifier(), this.checkIdentifier(p.id, p.const ? 8971 : 8459), this.expect(5), p.members = this.tsParseDelimitedList("EnumMembers", this.tsParseEnumMember.bind(this)), this.expect(8), this.finishNode(p, "TSEnumDeclaration");
        }
        tsParseModuleBlock() {
          let p = this.startNode();
          return this.scope.enter(0), this.expect(5), super.parseBlockOrModuleBlockBody(p.body = [], void 0, !0, 8), this.scope.exit(), this.finishNode(p, "TSModuleBlock");
        }
        tsParseModuleOrNamespaceDeclaration(p, b = !1) {
          if (p.id = this.parseIdentifier(), b || this.checkIdentifier(p.id, 1024), this.eat(16)) {
            let T = this.startNode();
            this.tsParseModuleOrNamespaceDeclaration(T, !0), p.body = T;
          } else this.scope.enter(256), this.prodParam.enter(0), p.body = this.tsParseModuleBlock(), this.prodParam.exit(), this.scope.exit();
          return this.finishNode(p, "TSModuleDeclaration");
        }
        tsParseAmbientExternalModuleDeclaration(p) {
          return this.isContextual(112) ? (p.global = !0, p.id = this.parseIdentifier()) : this.match(133) ? p.id = super.parseStringLiteral(this.state.value) : this.unexpected(), this.match(5) ? (this.scope.enter(256), this.prodParam.enter(0), p.body = this.tsParseModuleBlock(), this.prodParam.exit(), this.scope.exit()) : this.semicolon(), this.finishNode(p, "TSModuleDeclaration");
        }
        tsParseImportEqualsDeclaration(p, b, T) {
          p.isExport = T || !1, p.id = b || this.parseIdentifier(), this.checkIdentifier(p.id, 4096), this.expect(29);
          let F = this.tsParseModuleReference();
          return p.importKind === "type" && F.type !== "TSExternalModuleReference" && this.raise(Bt.ImportAliasHasImportType, F), p.moduleReference = F, this.semicolon(), this.finishNode(p, "TSImportEqualsDeclaration");
        }
        tsIsExternalModuleReference() {
          return this.isContextual(119) && this.lookaheadCharCode() === 40;
        }
        tsParseModuleReference() {
          return this.tsIsExternalModuleReference() ? this.tsParseExternalModuleReference() : this.tsParseEntityName(!1);
        }
        tsParseExternalModuleReference() {
          let p = this.startNode();
          return this.expectContextual(119), this.expect(10), this.match(133) || this.unexpected(), p.expression = super.parseExprAtom(), this.expect(11), this.sawUnambiguousESM = !0, this.finishNode(p, "TSExternalModuleReference");
        }
        tsLookAhead(p) {
          let b = this.state.clone(), T = p();
          return this.state = b, T;
        }
        tsTryParseAndCatch(p) {
          let b = this.tryParse((T) => p() || T());
          if (!(b.aborted || !b.node)) return b.error && (this.state = b.failState), b.node;
        }
        tsTryParse(p) {
          let b = this.state.clone(), T = p();
          if (T !== void 0 && T !== !1) return T;
          this.state = b;
        }
        tsTryParseDeclare(p) {
          if (this.isLineTerminator()) return;
          let b = this.state.type, T;
          return this.isContextual(100) && (b = 74, T = "let"), this.tsInAmbientContext(() => {
            switch (b) {
              case 68:
                return p.declare = !0, super.parseFunctionStatement(p, !1, !1);
              case 80:
                return p.declare = !0, this.parseClass(p, !0, !1);
              case 126:
                return this.tsParseEnumDeclaration(p, { declare: !0 });
              case 112:
                return this.tsParseAmbientExternalModuleDeclaration(p);
              case 75:
              case 74:
                return !this.match(75) || !this.isLookaheadContextual("enum") ? (p.declare = !0, this.parseVarStatement(p, T || this.state.value, !0)) : (this.expect(75), this.tsParseEnumDeclaration(p, { const: !0, declare: !0 }));
              case 129: {
                let F = this.tsParseInterfaceDeclaration(p, { declare: !0 });
                if (F) return F;
              }
              default:
                if (Qt(b)) return this.tsParseDeclaration(p, this.state.value, !0, null);
            }
          });
        }
        tsTryParseExportDeclaration() {
          return this.tsParseDeclaration(this.startNode(), this.state.value, !0, null);
        }
        tsParseExpressionStatement(p, b, T) {
          switch (b.name) {
            case "declare": {
              let F = this.tsTryParseDeclare(p);
              return F && (F.declare = !0), F;
            }
            case "global":
              if (this.match(5)) {
                this.scope.enter(256), this.prodParam.enter(0);
                let F = p;
                return F.global = !0, F.id = b, F.body = this.tsParseModuleBlock(), this.scope.exit(), this.prodParam.exit(), this.finishNode(F, "TSModuleDeclaration");
              }
              break;
            default:
              return this.tsParseDeclaration(p, b.name, !1, T);
          }
        }
        tsParseDeclaration(p, b, T, F) {
          switch (b) {
            case "abstract":
              if (this.tsCheckLineTerminator(T) && (this.match(80) || Qt(this.state.type))) return this.tsParseAbstractDeclaration(p, F);
              break;
            case "module":
              if (this.tsCheckLineTerminator(T)) {
                if (this.match(133)) return this.tsParseAmbientExternalModuleDeclaration(p);
                if (Qt(this.state.type)) return this.tsParseModuleOrNamespaceDeclaration(p);
              }
              break;
            case "namespace":
              if (this.tsCheckLineTerminator(T) && Qt(this.state.type)) return this.tsParseModuleOrNamespaceDeclaration(p);
              break;
            case "type":
              if (this.tsCheckLineTerminator(T) && Qt(this.state.type)) return this.tsParseTypeAliasDeclaration(p);
              break;
          }
        }
        tsCheckLineTerminator(p) {
          return p ? this.hasFollowingLineBreak() ? !1 : (this.next(), !0) : !this.isLineTerminator();
        }
        tsTryParseGenericAsyncArrowFunction(p) {
          if (!this.match(47)) return;
          let b = this.state.maybeInArrowParameters;
          this.state.maybeInArrowParameters = !0;
          let T = this.tsTryParseAndCatch(() => {
            let F = this.startNodeAt(p);
            return F.typeParameters = this.tsParseTypeParameters(this.tsParseConstModifier), super.parseFunctionParams(F), F.returnType = this.tsTryParseTypeOrTypePredicateAnnotation(), this.expect(19), F;
          });
          if (this.state.maybeInArrowParameters = b, !!T) return super.parseArrowExpression(T, null, !0);
        }
        tsParseTypeArgumentsInExpression() {
          if (this.reScan_lt() === 47) return this.tsParseTypeArguments();
        }
        tsParseTypeArguments() {
          let p = this.startNode();
          return p.params = this.tsInType(() => this.tsInNoContext(() => (this.expect(47), this.tsParseDelimitedList("TypeParametersOrArguments", this.tsParseType.bind(this))))), p.params.length === 0 ? this.raise(Bt.EmptyTypeArguments, p) : !this.state.inType && this.curContext() === ar.brace && this.reScan_lt_gt(), this.expect(48), this.finishNode(p, "TSTypeParameterInstantiation");
        }
        tsIsDeclarationStart() {
          return Hg(this.state.type);
        }
        isExportDefaultSpecifier() {
          return this.tsIsDeclarationStart() ? !1 : super.isExportDefaultSpecifier();
        }
        parseAssignableListItem(p, b) {
          let T = this.state.startLoc, F = {};
          this.tsParseModifiers({ allowedModifiers: ["public", "private", "protected", "override", "readonly"] }, F);
          let Y = F.accessibility, ie = F.override, de = F.readonly;
          !(p & 4) && (Y || de || ie) && this.raise(Bt.UnexpectedParameterModifier, T);
          let he = this.parseMaybeDefault();
          this.parseAssignableListItemTypes(he, p);
          let fe = this.parseMaybeDefault(he.loc.start, he);
          if (Y || de || ie) {
            let Ze = this.startNodeAt(T);
            return b.length && (Ze.decorators = b), Y && (Ze.accessibility = Y), de && (Ze.readonly = de), ie && (Ze.override = ie), fe.type !== "Identifier" && fe.type !== "AssignmentPattern" && this.raise(Bt.UnsupportedParameterPropertyKind, Ze), Ze.parameter = fe, this.finishNode(Ze, "TSParameterProperty");
          }
          return b.length && (he.decorators = b), fe;
        }
        isSimpleParameter(p) {
          return p.type === "TSParameterProperty" && super.isSimpleParameter(p.parameter) || super.isSimpleParameter(p);
        }
        tsDisallowOptionalPattern(p) {
          for (let b of p.params) b.type !== "Identifier" && b.optional && !this.state.isAmbientContext && this.raise(Bt.PatternIsOptional, b);
        }
        setArrowFunctionParameters(p, b, T) {
          super.setArrowFunctionParameters(p, b, T), this.tsDisallowOptionalPattern(p);
        }
        parseFunctionBodyAndFinish(p, b, T = !1) {
          this.match(14) && (p.returnType = this.tsParseTypeOrTypePredicateAnnotation(14));
          let F = b === "FunctionDeclaration" ? "TSDeclareFunction" : b === "ClassMethod" || b === "ClassPrivateMethod" ? "TSDeclareMethod" : void 0;
          return F && !this.match(5) && this.isLineTerminator() ? this.finishNode(p, F) : F === "TSDeclareFunction" && this.state.isAmbientContext && (this.raise(Bt.DeclareFunctionHasImplementation, p), p.declare) ? super.parseFunctionBodyAndFinish(p, F, T) : (this.tsDisallowOptionalPattern(p), super.parseFunctionBodyAndFinish(p, b, T));
        }
        registerFunctionStatementId(p) {
          !p.body && p.id ? this.checkIdentifier(p.id, 1024) : super.registerFunctionStatementId(p);
        }
        tsCheckForInvalidTypeCasts(p) {
          p.forEach((b) => {
            (b == null ? void 0 : b.type) === "TSTypeCastExpression" && this.raise(Bt.UnexpectedTypeAnnotation, b.typeAnnotation);
          });
        }
        toReferencedList(p, b) {
          return this.tsCheckForInvalidTypeCasts(p), p;
        }
        parseArrayLike(p, b, T, F) {
          let Y = super.parseArrayLike(p, b, T, F);
          return Y.type === "ArrayExpression" && this.tsCheckForInvalidTypeCasts(Y.elements), Y;
        }
        parseSubscript(p, b, T, F) {
          if (!this.hasPrecedingLineBreak() && this.match(35)) {
            this.state.canStartJSXElement = !1, this.next();
            let ie = this.startNodeAt(b);
            return ie.expression = p, this.finishNode(ie, "TSNonNullExpression");
          }
          let Y = !1;
          if (this.match(18) && this.lookaheadCharCode() === 60) {
            if (T) return F.stop = !0, p;
            F.optionalChainMember = Y = !0, this.next();
          }
          if (this.match(47) || this.match(51)) {
            let ie, de = this.tsTryParseAndCatch(() => {
              if (!T && this.atPossibleAsyncArrow(p)) {
                let Dt = this.tsTryParseGenericAsyncArrowFunction(b);
                if (Dt) return Dt;
              }
              let he = this.tsParseTypeArgumentsInExpression();
              if (!he) return;
              if (Y && !this.match(10)) {
                ie = this.state.curPosition();
                return;
              }
              if (Hd(this.state.type)) {
                let Dt = super.parseTaggedTemplateExpression(p, b, F);
                return Dt.typeParameters = he, Dt;
              }
              if (!T && this.eat(10)) {
                let Dt = this.startNodeAt(b);
                return Dt.callee = p, Dt.arguments = this.parseCallExpressionArguments(11, !1), this.tsCheckForInvalidTypeCasts(Dt.arguments), Dt.typeParameters = he, F.optionalChainMember && (Dt.optional = Y), this.finishCallExpression(Dt, F.optionalChainMember);
              }
              let fe = this.state.type;
              if (fe === 48 || fe === 52 || fe !== 10 && zg(fe) && !this.hasPrecedingLineBreak()) return;
              let Ze = this.startNodeAt(b);
              return Ze.expression = p, Ze.typeParameters = he, this.finishNode(Ze, "TSInstantiationExpression");
            });
            if (ie && this.unexpected(ie, 10), de) return de.type === "TSInstantiationExpression" && (this.match(16) || this.match(18) && this.lookaheadCharCode() !== 40) && this.raise(Bt.InvalidPropertyAccessAfterInstantiationExpression, this.state.startLoc), de;
          }
          return super.parseSubscript(p, b, T, F);
        }
        parseNewCallee(p) {
          var b;
          super.parseNewCallee(p);
          let { callee: T } = p;
          T.type === "TSInstantiationExpression" && !((b = T.extra) != null && b.parenthesized) && (p.typeParameters = T.typeParameters, p.callee = T.expression);
        }
        parseExprOp(p, b, T) {
          let F;
          if (Wd(58) > T && !this.hasPrecedingLineBreak() && (this.isContextual(93) || (F = this.isContextual(120)))) {
            let Y = this.startNodeAt(b);
            return Y.expression = p, Y.typeAnnotation = this.tsInType(() => (this.next(), this.match(75) ? (F && this.raise(Se.UnexpectedKeyword, this.state.startLoc, { keyword: "const" }), this.tsParseTypeReference()) : this.tsParseType())), this.finishNode(Y, F ? "TSSatisfiesExpression" : "TSAsExpression"), this.reScan_lt_gt(), this.parseExprOp(Y, b, T);
          }
          return super.parseExprOp(p, b, T);
        }
        checkReservedWord(p, b, T, F) {
          this.state.isAmbientContext || super.checkReservedWord(p, b, T, F);
        }
        checkImportReflection(p) {
          super.checkImportReflection(p), p.module && p.importKind !== "value" && this.raise(Bt.ImportReflectionHasImportType, p.specifiers[0].loc.start);
        }
        checkDuplicateExports() {
        }
        isPotentialImportPhase(p) {
          if (super.isPotentialImportPhase(p)) return !0;
          if (this.isContextual(130)) {
            let b = this.lookaheadCharCode();
            return p ? b === 123 || b === 42 : b !== 61;
          }
          return !p && this.isContextual(87);
        }
        applyImportPhase(p, b, T, F) {
          super.applyImportPhase(p, b, T, F), b ? p.exportKind = T === "type" ? "type" : "value" : p.importKind = T === "type" || T === "typeof" ? T : "value";
        }
        parseImport(p) {
          if (this.match(133)) return p.importKind = "value", super.parseImport(p);
          let b;
          if (Qt(this.state.type) && this.lookaheadCharCode() === 61) return p.importKind = "value", this.tsParseImportEqualsDeclaration(p);
          if (this.isContextual(130)) {
            let T = this.parseMaybeImportPhase(p, !1);
            if (this.lookaheadCharCode() === 61) return this.tsParseImportEqualsDeclaration(p, T);
            b = super.parseImportSpecifiersAndAfter(p, T);
          } else b = super.parseImport(p);
          return b.importKind === "type" && b.specifiers.length > 1 && b.specifiers[0].type === "ImportDefaultSpecifier" && this.raise(Bt.TypeImportCannotSpecifyDefaultAndNamed, b), b;
        }
        parseExport(p, b) {
          if (this.match(83)) {
            this.next();
            let T = p, F = null;
            return this.isContextual(130) && this.isPotentialImportPhase(!1) ? F = this.parseMaybeImportPhase(T, !1) : T.importKind = "value", this.tsParseImportEqualsDeclaration(T, F, !0);
          } else if (this.eat(29)) {
            let T = p;
            return T.expression = super.parseExpression(), this.semicolon(), this.sawUnambiguousESM = !0, this.finishNode(T, "TSExportAssignment");
          } else if (this.eatContextual(93)) {
            let T = p;
            return this.expectContextual(128), T.id = this.parseIdentifier(), this.semicolon(), this.finishNode(T, "TSNamespaceExportDeclaration");
          } else return super.parseExport(p, b);
        }
        isAbstractClass() {
          return this.isContextual(124) && this.lookahead().type === 80;
        }
        parseExportDefaultExpression() {
          if (this.isAbstractClass()) {
            let p = this.startNode();
            return this.next(), p.abstract = !0, this.parseClass(p, !0, !0);
          }
          if (this.match(129)) {
            let p = this.tsParseInterfaceDeclaration(this.startNode());
            if (p) return p;
          }
          return super.parseExportDefaultExpression();
        }
        parseVarStatement(p, b, T = !1) {
          let { isAmbientContext: F } = this.state, Y = super.parseVarStatement(p, b, T || F);
          if (!F) return Y;
          for (let { id: ie, init: de } of Y.declarations) de && (b !== "const" || ie.typeAnnotation ? this.raise(Bt.InitializerNotAllowedInAmbientContext, de) : dS(de, this.hasPlugin("estree")) || this.raise(Bt.ConstInitiailizerMustBeStringOrNumericLiteralOrLiteralEnumReference, de));
          return Y;
        }
        parseStatementContent(p, b) {
          if (this.match(75) && this.isLookaheadContextual("enum")) {
            let T = this.startNode();
            return this.expect(75), this.tsParseEnumDeclaration(T, { const: !0 });
          }
          if (this.isContextual(126)) return this.tsParseEnumDeclaration(this.startNode());
          if (this.isContextual(129)) {
            let T = this.tsParseInterfaceDeclaration(this.startNode());
            if (T) return T;
          }
          return super.parseStatementContent(p, b);
        }
        parseAccessModifier() {
          return this.tsParseModifier(["public", "protected", "private"]);
        }
        tsHasSomeModifiers(p, b) {
          return b.some((T) => Nc(T) ? p.accessibility === T : !!p[T]);
        }
        tsIsStartOfStaticBlocks() {
          return this.isContextual(106) && this.lookaheadCharCode() === 123;
        }
        parseClassMember(p, b, T) {
          let F = ["declare", "private", "public", "protected", "override", "abstract", "readonly", "static"];
          this.tsParseModifiers({ allowedModifiers: F, disallowedModifiers: ["in", "out"], stopOnStartOfClassStaticBlock: !0, errorTemplate: Bt.InvalidModifierOnTypeParameterPositions }, b);
          let Y = () => {
            this.tsIsStartOfStaticBlocks() ? (this.next(), this.next(), this.tsHasSomeModifiers(b, F) && this.raise(Bt.StaticBlockCannotHaveModifier, this.state.curPosition()), super.parseClassStaticBlock(p, b)) : this.parseClassMemberWithIsStatic(p, b, T, !!b.static);
          };
          b.declare ? this.tsInAmbientContext(Y) : Y();
        }
        parseClassMemberWithIsStatic(p, b, T, F) {
          let Y = this.tsTryParseIndexSignature(b);
          if (Y) {
            p.body.push(Y), b.abstract && this.raise(Bt.IndexSignatureHasAbstract, b), b.accessibility && this.raise(Bt.IndexSignatureHasAccessibility, b, { modifier: b.accessibility }), b.declare && this.raise(Bt.IndexSignatureHasDeclare, b), b.override && this.raise(Bt.IndexSignatureHasOverride, b);
            return;
          }
          !this.state.inAbstractClass && b.abstract && this.raise(Bt.NonAbstractClassHasAbstractMethod, b), b.override && (T.hadSuperClass || this.raise(Bt.OverrideNotInSubClass, b)), super.parseClassMemberWithIsStatic(p, b, T, F);
        }
        parsePostMemberNameModifiers(p) {
          this.eat(17) && (p.optional = !0), p.readonly && this.match(10) && this.raise(Bt.ClassMethodHasReadonly, p), p.declare && this.match(10) && this.raise(Bt.ClassMethodHasDeclare, p);
        }
        parseExpressionStatement(p, b, T) {
          return (b.type === "Identifier" ? this.tsParseExpressionStatement(p, b, T) : void 0) || super.parseExpressionStatement(p, b, T);
        }
        shouldParseExportDeclaration() {
          return this.tsIsDeclarationStart() ? !0 : super.shouldParseExportDeclaration();
        }
        parseConditional(p, b, T) {
          if (!this.state.maybeInArrowParameters || !this.match(17)) return super.parseConditional(p, b, T);
          let F = this.tryParse(() => super.parseConditional(p, b));
          return F.node ? (F.error && (this.state = F.failState), F.node) : (F.error && super.setOptionalParametersError(T, F.error), p);
        }
        parseParenItem(p, b) {
          let T = super.parseParenItem(p, b);
          if (this.eat(17) && (T.optional = !0, this.resetEndLocation(p)), this.match(14)) {
            let F = this.startNodeAt(b);
            return F.expression = p, F.typeAnnotation = this.tsParseTypeAnnotation(), this.finishNode(F, "TSTypeCastExpression");
          }
          return p;
        }
        parseExportDeclaration(p) {
          if (!this.state.isAmbientContext && this.isContextual(125)) return this.tsInAmbientContext(() => this.parseExportDeclaration(p));
          let b = this.state.startLoc, T = this.eatContextual(125);
          if (T && (this.isContextual(125) || !this.shouldParseExportDeclaration())) throw this.raise(Bt.ExpectedAmbientAfterExportDeclare, this.state.startLoc);
          let F = Qt(this.state.type) && this.tsTryParseExportDeclaration() || super.parseExportDeclaration(p);
          return F ? ((F.type === "TSInterfaceDeclaration" || F.type === "TSTypeAliasDeclaration" || T) && (p.exportKind = "type"), T && (this.resetStartLocation(F, b), F.declare = !0), F) : null;
        }
        parseClassId(p, b, T, F) {
          if ((!b || T) && this.isContextual(113)) return;
          super.parseClassId(p, b, T, p.declare ? 1024 : 8331);
          let Y = this.tsTryParseTypeParameters(this.tsParseInOutConstModifiers);
          Y && (p.typeParameters = Y);
        }
        parseClassPropertyAnnotation(p) {
          p.optional || (this.eat(35) ? p.definite = !0 : this.eat(17) && (p.optional = !0));
          let b = this.tsTryParseTypeAnnotation();
          b && (p.typeAnnotation = b);
        }
        parseClassProperty(p) {
          if (this.parseClassPropertyAnnotation(p), this.state.isAmbientContext && !(p.readonly && !p.typeAnnotation) && this.match(29) && this.raise(Bt.DeclareClassFieldHasInitializer, this.state.startLoc), p.abstract && this.match(29)) {
            let { key: b } = p;
            this.raise(Bt.AbstractPropertyHasInitializer, this.state.startLoc, { propertyName: b.type === "Identifier" && !p.computed ? b.name : `[${this.input.slice(b.start, b.end)}]` });
          }
          return super.parseClassProperty(p);
        }
        parseClassPrivateProperty(p) {
          return p.abstract && this.raise(Bt.PrivateElementHasAbstract, p), p.accessibility && this.raise(Bt.PrivateElementHasAccessibility, p, { modifier: p.accessibility }), this.parseClassPropertyAnnotation(p), super.parseClassPrivateProperty(p);
        }
        parseClassAccessorProperty(p) {
          return this.parseClassPropertyAnnotation(p), p.optional && this.raise(Bt.AccessorCannotBeOptional, p), super.parseClassAccessorProperty(p);
        }
        pushClassMethod(p, b, T, F, Y, ie) {
          let de = this.tsTryParseTypeParameters(this.tsParseConstModifier);
          de && Y && this.raise(Bt.ConstructorHasTypeParameters, de);
          let { declare: he = !1, kind: fe } = b;
          he && (fe === "get" || fe === "set") && this.raise(Bt.DeclareAccessor, b, { kind: fe }), de && (b.typeParameters = de), super.pushClassMethod(p, b, T, F, Y, ie);
        }
        pushClassPrivateMethod(p, b, T, F) {
          let Y = this.tsTryParseTypeParameters(this.tsParseConstModifier);
          Y && (b.typeParameters = Y), super.pushClassPrivateMethod(p, b, T, F);
        }
        declareClassPrivateMethodInScope(p, b) {
          p.type !== "TSDeclareMethod" && (p.type === "MethodDefinition" && !hasOwnProperty.call(p.value, "body") || super.declareClassPrivateMethodInScope(p, b));
        }
        parseClassSuper(p) {
          super.parseClassSuper(p), p.superClass && (this.match(47) || this.match(51)) && (p.superTypeParameters = this.tsParseTypeArgumentsInExpression()), this.eatContextual(113) && (p.implements = this.tsParseHeritageClause("implements"));
        }
        parseObjPropValue(p, b, T, F, Y, ie, de) {
          let he = this.tsTryParseTypeParameters(this.tsParseConstModifier);
          return he && (p.typeParameters = he), super.parseObjPropValue(p, b, T, F, Y, ie, de);
        }
        parseFunctionParams(p, b) {
          let T = this.tsTryParseTypeParameters(this.tsParseConstModifier);
          T && (p.typeParameters = T), super.parseFunctionParams(p, b);
        }
        parseVarId(p, b) {
          super.parseVarId(p, b), p.id.type === "Identifier" && !this.hasPrecedingLineBreak() && this.eat(35) && (p.definite = !0);
          let T = this.tsTryParseTypeAnnotation();
          T && (p.id.typeAnnotation = T, this.resetEndLocation(p.id));
        }
        parseAsyncArrowFromCallExpression(p, b) {
          return this.match(14) && (p.returnType = this.tsParseTypeAnnotation()), super.parseAsyncArrowFromCallExpression(p, b);
        }
        parseMaybeAssign(p, b) {
          var T, F, Y, ie, de;
          let he, fe, Ze;
          if (this.hasPlugin("jsx") && (this.match(142) || this.match(47))) {
            if (he = this.state.clone(), fe = this.tryParse(() => super.parseMaybeAssign(p, b), he), !fe.error) return fe.node;
            let { context: It } = this.state, nr = It[It.length - 1];
            (nr === ar.j_oTag || nr === ar.j_expr) && It.pop();
          }
          if (!((T = fe) != null && T.error) && !this.match(47)) return super.parseMaybeAssign(p, b);
          (!he || he === this.state) && (he = this.state.clone());
          let Dt, $t = this.tryParse((It) => {
            var nr, Di;
            Dt = this.tsParseTypeParameters(this.tsParseConstModifier);
            let Sr = super.parseMaybeAssign(p, b);
            return (Sr.type !== "ArrowFunctionExpression" || (nr = Sr.extra) != null && nr.parenthesized) && It(), ((Di = Dt) == null ? void 0 : Di.params.length) !== 0 && this.resetStartLocationFromNode(Sr, Dt), Sr.typeParameters = Dt, Sr;
          }, he);
          if (!$t.error && !$t.aborted) return Dt && this.reportReservedArrowTypeParam(Dt), $t.node;
          if (!fe && (ny(!this.hasPlugin("jsx")), Ze = this.tryParse(() => super.parseMaybeAssign(p, b), he), !Ze.error)) return Ze.node;
          if ((F = fe) != null && F.node) return this.state = fe.failState, fe.node;
          if ($t.node) return this.state = $t.failState, Dt && this.reportReservedArrowTypeParam(Dt), $t.node;
          if ((Y = Ze) != null && Y.node) return this.state = Ze.failState, Ze.node;
          throw ((ie = fe) == null ? void 0 : ie.error) || $t.error || ((de = Ze) == null ? void 0 : de.error);
        }
        reportReservedArrowTypeParam(p) {
          var b;
          p.params.length === 1 && !p.params[0].constraint && !((b = p.extra) != null && b.trailingComma) && this.getPluginOption("typescript", "disallowAmbiguousJSXLike") && this.raise(Bt.ReservedArrowTypeParam, p);
        }
        parseMaybeUnary(p, b) {
          return !this.hasPlugin("jsx") && this.match(47) ? this.tsParseTypeAssertion() : super.parseMaybeUnary(p, b);
        }
        parseArrow(p) {
          if (this.match(14)) {
            let b = this.tryParse((T) => {
              let F = this.tsParseTypeOrTypePredicateAnnotation(14);
              return (this.canInsertSemicolon() || !this.match(19)) && T(), F;
            });
            if (b.aborted) return;
            b.thrown || (b.error && (this.state = b.failState), p.returnType = b.node);
          }
          return super.parseArrow(p);
        }
        parseAssignableListItemTypes(p, b) {
          if (!(b & 2)) return p;
          this.eat(17) && (p.optional = !0);
          let T = this.tsTryParseTypeAnnotation();
          return T && (p.typeAnnotation = T), this.resetEndLocation(p), p;
        }
        isAssignable(p, b) {
          switch (p.type) {
            case "TSTypeCastExpression":
              return this.isAssignable(p.expression, b);
            case "TSParameterProperty":
              return !0;
            default:
              return super.isAssignable(p, b);
          }
        }
        toAssignable(p, b = !1) {
          switch (p.type) {
            case "ParenthesizedExpression":
              this.toAssignableParenthesizedExpression(p, b);
              break;
            case "TSAsExpression":
            case "TSSatisfiesExpression":
            case "TSNonNullExpression":
            case "TSTypeAssertion":
              b ? this.expressionScope.recordArrowParameterBindingError(Bt.UnexpectedTypeCastInParameter, p) : this.raise(Bt.UnexpectedTypeCastInParameter, p), this.toAssignable(p.expression, b);
              break;
            case "AssignmentExpression":
              !b && p.left.type === "TSTypeCastExpression" && (p.left = this.typeCastToParameter(p.left));
            default:
              super.toAssignable(p, b);
          }
        }
        toAssignableParenthesizedExpression(p, b) {
          switch (p.expression.type) {
            case "TSAsExpression":
            case "TSSatisfiesExpression":
            case "TSNonNullExpression":
            case "TSTypeAssertion":
            case "ParenthesizedExpression":
              this.toAssignable(p.expression, b);
              break;
            default:
              super.toAssignable(p, b);
          }
        }
        checkToRestConversion(p, b) {
          switch (p.type) {
            case "TSAsExpression":
            case "TSSatisfiesExpression":
            case "TSTypeAssertion":
            case "TSNonNullExpression":
              this.checkToRestConversion(p.expression, !1);
              break;
            default:
              super.checkToRestConversion(p, b);
          }
        }
        isValidLVal(p, b, T) {
          return Zf({ TSTypeCastExpression: !0, TSParameterProperty: "parameter", TSNonNullExpression: "expression", TSInstantiationExpression: "expression", TSAsExpression: (T !== 64 || !b) && ["expression", !0], TSSatisfiesExpression: (T !== 64 || !b) && ["expression", !0], TSTypeAssertion: (T !== 64 || !b) && ["expression", !0] }, p) || super.isValidLVal(p, b, T);
        }
        parseBindingAtom() {
          return this.state.type === 78 ? this.parseIdentifier(!0) : super.parseBindingAtom();
        }
        parseMaybeDecoratorArguments(p) {
          if (this.match(47) || this.match(51)) {
            let b = this.tsParseTypeArgumentsInExpression();
            if (this.match(10)) {
              let T = super.parseMaybeDecoratorArguments(p);
              return T.typeParameters = b, T;
            }
            this.unexpected(null, 10);
          }
          return super.parseMaybeDecoratorArguments(p);
        }
        checkCommaAfterRest(p) {
          return this.state.isAmbientContext && this.match(12) && this.lookaheadCharCode() === p ? (this.next(), !1) : super.checkCommaAfterRest(p);
        }
        isClassMethod() {
          return this.match(47) || super.isClassMethod();
        }
        isClassProperty() {
          return this.match(35) || this.match(14) || super.isClassProperty();
        }
        parseMaybeDefault(p, b) {
          let T = super.parseMaybeDefault(p, b);
          return T.type === "AssignmentPattern" && T.typeAnnotation && T.right.start < T.typeAnnotation.start && this.raise(Bt.TypeAnnotationAfterAssign, T.typeAnnotation), T;
        }
        getTokenFromCode(p) {
          if (this.state.inType) {
            if (p === 62) {
              this.finishOp(48, 1);
              return;
            }
            if (p === 60) {
              this.finishOp(47, 1);
              return;
            }
          }
          super.getTokenFromCode(p);
        }
        reScan_lt_gt() {
          let { type: p } = this.state;
          p === 47 ? (this.state.pos -= 1, this.readToken_lt()) : p === 48 && (this.state.pos -= 1, this.readToken_gt());
        }
        reScan_lt() {
          let { type: p } = this.state;
          return p === 51 ? (this.state.pos -= 2, this.finishOp(47, 1), 47) : p;
        }
        toAssignableList(p, b, T) {
          for (let F = 0; F < p.length; F++) {
            let Y = p[F];
            (Y == null ? void 0 : Y.type) === "TSTypeCastExpression" && (p[F] = this.typeCastToParameter(Y));
          }
          super.toAssignableList(p, b, T);
        }
        typeCastToParameter(p) {
          return p.expression.typeAnnotation = p.typeAnnotation, this.resetEndLocation(p.expression, p.typeAnnotation.loc.end), p.expression;
        }
        shouldParseArrow(p) {
          return this.match(14) ? p.every((b) => this.isAssignable(b, !0)) : super.shouldParseArrow(p);
        }
        shouldParseAsyncArrow() {
          return this.match(14) || super.shouldParseAsyncArrow();
        }
        canHaveLeadingDecorator() {
          return super.canHaveLeadingDecorator() || this.isAbstractClass();
        }
        jsxParseOpeningElementAfterName(p) {
          if (this.match(47) || this.match(51)) {
            let b = this.tsTryParseAndCatch(() => this.tsParseTypeArgumentsInExpression());
            b && (p.typeParameters = b);
          }
          return super.jsxParseOpeningElementAfterName(p);
        }
        getGetterSetterExpectedParamCount(p) {
          let b = super.getGetterSetterExpectedParamCount(p), T = this.getObjectOrClassMethodParams(p)[0];
          return T && this.isThisParam(T) ? b + 1 : b;
        }
        parseCatchClauseParam() {
          let p = super.parseCatchClauseParam(), b = this.tsTryParseTypeAnnotation();
          return b && (p.typeAnnotation = b, this.resetEndLocation(p)), p;
        }
        tsInAmbientContext(p) {
          let { isAmbientContext: b, strict: T } = this.state;
          this.state.isAmbientContext = !0, this.state.strict = !1;
          try {
            return p();
          } finally {
            this.state.isAmbientContext = b, this.state.strict = T;
          }
        }
        parseClass(p, b, T) {
          let F = this.state.inAbstractClass;
          this.state.inAbstractClass = !!p.abstract;
          try {
            return super.parseClass(p, b, T);
          } finally {
            this.state.inAbstractClass = F;
          }
        }
        tsParseAbstractDeclaration(p, b) {
          if (this.match(80)) return p.abstract = !0, this.maybeTakeDecorators(b, this.parseClass(p, !0, !1));
          if (this.isContextual(129)) {
            if (!this.hasFollowingLineBreak()) return p.abstract = !0, this.raise(Bt.NonClassMethodPropertyHasAbstractModifer, p), this.tsParseInterfaceDeclaration(p);
          } else this.unexpected(null, 80);
        }
        parseMethod(p, b, T, F, Y, ie, de) {
          let he = super.parseMethod(p, b, T, F, Y, ie, de);
          if (he.abstract && (this.hasPlugin("estree") ? he.value.body : he.body)) {
            let { key: fe } = he;
            this.raise(Bt.AbstractMethodHasImplementation, he, { methodName: fe.type === "Identifier" && !he.computed ? fe.name : `[${this.input.slice(fe.start, fe.end)}]` });
          }
          return he;
        }
        tsParseTypeParameterName() {
          return this.parseIdentifier().name;
        }
        shouldParseAsAmbientContext() {
          return !!this.getPluginOption("typescript", "dts");
        }
        parse() {
          return this.shouldParseAsAmbientContext() && (this.state.isAmbientContext = !0), super.parse();
        }
        getExpression() {
          return this.shouldParseAsAmbientContext() && (this.state.isAmbientContext = !0), super.getExpression();
        }
        parseExportSpecifier(p, b, T, F) {
          return !b && F ? (this.parseTypeOnlyImportExportSpecifier(p, !1, T), this.finishNode(p, "ExportSpecifier")) : (p.exportKind = "value", super.parseExportSpecifier(p, b, T, F));
        }
        parseImportSpecifier(p, b, T, F, Y) {
          return !b && F ? (this.parseTypeOnlyImportExportSpecifier(p, !0, T), this.finishNode(p, "ImportSpecifier")) : (p.importKind = "value", super.parseImportSpecifier(p, b, T, F, T ? 4098 : 4096));
        }
        parseTypeOnlyImportExportSpecifier(p, b, T) {
          let F = b ? "imported" : "local", Y = b ? "local" : "exported", ie = p[F], de, he = !1, fe = !0, Ze = ie.loc.start;
          if (this.isContextual(93)) {
            let $t = this.parseIdentifier();
            if (this.isContextual(93)) {
              let It = this.parseIdentifier();
              Bs(this.state.type) ? (he = !0, ie = $t, de = b ? this.parseIdentifier() : this.parseModuleExportName(), fe = !1) : (de = It, fe = !1);
            } else Bs(this.state.type) ? (fe = !1, de = b ? this.parseIdentifier() : this.parseModuleExportName()) : (he = !0, ie = $t);
          } else Bs(this.state.type) && (he = !0, b ? (ie = this.parseIdentifier(!0), this.isContextual(93) || this.checkReservedWord(ie.name, ie.loc.start, !0, !0)) : ie = this.parseModuleExportName());
          he && T && this.raise(b ? Bt.TypeModifierIsUsedInTypeImports : Bt.TypeModifierIsUsedInTypeExports, Ze), p[F] = ie, p[Y] = de;
          let Dt = b ? "importKind" : "exportKind";
          p[Dt] = he ? "type" : "value", fe && this.eatContextual(93) && (p[Y] = b ? this.parseIdentifier() : this.parseModuleExportName()), p[Y] || (p[Y] = Un(p[F])), b && this.checkIdentifier(p[Y], he ? 4098 : 4096);
        }
      };
      function cS(y) {
        if (y.type !== "MemberExpression") return !1;
        let { computed: p, property: b } = y;
        return p && b.type !== "StringLiteral" && (b.type !== "TemplateLiteral" || b.expressions.length > 0) ? !1 : Xd(y.object);
      }
      function dS(y, p) {
        var b;
        let { type: T } = y;
        if ((b = y.extra) != null && b.parenthesized) return !1;
        if (p) {
          if (T === "Literal") {
            let { value: F } = y;
            if (typeof F == "string" || typeof F == "boolean") return !0;
          }
        } else if (T === "StringLiteral" || T === "BooleanLiteral") return !0;
        return !!(Xv(y, p) || th(y, p) || T === "TemplateLiteral" && y.expressions.length === 0 || cS(y));
      }
      function Xv(y, p) {
        return p ? y.type === "Literal" && (typeof y.value == "number" || "bigint" in y) : y.type === "NumericLiteral" || y.type === "BigIntLiteral";
      }
      function th(y, p) {
        if (y.type === "UnaryExpression") {
          let { operator: b, argument: T } = y;
          if (b === "-" && Xv(T, p)) return !0;
        }
        return !1;
      }
      function Xd(y) {
        return y.type === "Identifier" ? !0 : y.type !== "MemberExpression" || y.computed ? !1 : Xd(y.object);
      }
      var nh = ga`placeholders`({ ClassNameIsRequired: "A class name is required.", UnexpectedSpace: "Unexpected space in placeholder." }), pS = (y) => class extends y {
        parsePlaceholder(p) {
          if (this.match(144)) {
            let b = this.startNode();
            return this.next(), this.assertNoSpace(), b.name = super.parseIdentifier(!0), this.assertNoSpace(), this.expect(144), this.finishPlaceholder(b, p);
          }
        }
        finishPlaceholder(p, b) {
          let T = p;
          return (!T.expectedNode || !T.type) && (T = this.finishNode(T, "Placeholder")), T.expectedNode = b, T;
        }
        getTokenFromCode(p) {
          p === 37 && this.input.charCodeAt(this.state.pos + 1) === 37 ? this.finishOp(144, 2) : super.getTokenFromCode(p);
        }
        parseExprAtom(p) {
          return this.parsePlaceholder("Expression") || super.parseExprAtom(p);
        }
        parseIdentifier(p) {
          return this.parsePlaceholder("Identifier") || super.parseIdentifier(p);
        }
        checkReservedWord(p, b, T, F) {
          p !== void 0 && super.checkReservedWord(p, b, T, F);
        }
        parseBindingAtom() {
          return this.parsePlaceholder("Pattern") || super.parseBindingAtom();
        }
        isValidLVal(p, b, T) {
          return p === "Placeholder" || super.isValidLVal(p, b, T);
        }
        toAssignable(p, b) {
          p && p.type === "Placeholder" && p.expectedNode === "Expression" ? p.expectedNode = "Pattern" : super.toAssignable(p, b);
        }
        chStartsBindingIdentifier(p, b) {
          return !!(super.chStartsBindingIdentifier(p, b) || this.lookahead().type === 144);
        }
        verifyBreakContinue(p, b) {
          p.label && p.label.type === "Placeholder" || super.verifyBreakContinue(p, b);
        }
        parseExpressionStatement(p, b) {
          var T;
          if (b.type !== "Placeholder" || (T = b.extra) != null && T.parenthesized) return super.parseExpressionStatement(p, b);
          if (this.match(14)) {
            let Y = p;
            return Y.label = this.finishPlaceholder(b, "Identifier"), this.next(), Y.body = super.parseStatementOrSloppyAnnexBFunctionDeclaration(), this.finishNode(Y, "LabeledStatement");
          }
          this.semicolon();
          let F = p;
          return F.name = b.name, this.finishPlaceholder(F, "Statement");
        }
        parseBlock(p, b, T) {
          return this.parsePlaceholder("BlockStatement") || super.parseBlock(p, b, T);
        }
        parseFunctionId(p) {
          return this.parsePlaceholder("Identifier") || super.parseFunctionId(p);
        }
        parseClass(p, b, T) {
          let F = b ? "ClassDeclaration" : "ClassExpression";
          this.next();
          let Y = this.state.strict, ie = this.parsePlaceholder("Identifier");
          if (ie) if (this.match(81) || this.match(144) || this.match(5)) p.id = ie;
          else {
            if (T || !b) return p.id = null, p.body = this.finishPlaceholder(ie, "ClassBody"), this.finishNode(p, F);
            throw this.raise(nh.ClassNameIsRequired, this.state.startLoc);
          }
          else this.parseClassId(p, b, T);
          return super.parseClassSuper(p), p.body = this.parsePlaceholder("ClassBody") || super.parseClassBody(!!p.superClass, Y), this.finishNode(p, F);
        }
        parseExport(p, b) {
          let T = this.parsePlaceholder("Identifier");
          if (!T) return super.parseExport(p, b);
          let F = p;
          if (!this.isContextual(98) && !this.match(12)) return F.specifiers = [], F.source = null, F.declaration = this.finishPlaceholder(T, "Declaration"), this.finishNode(F, "ExportNamedDeclaration");
          this.expectPlugin("exportDefaultFrom");
          let Y = this.startNode();
          return Y.exported = T, F.specifiers = [this.finishNode(Y, "ExportDefaultSpecifier")], super.parseExport(F, b);
        }
        isExportDefaultSpecifier() {
          if (this.match(65)) {
            let p = this.nextTokenStart();
            if (this.isUnparsedContextual(p, "from") && this.input.startsWith(vi(144), this.nextTokenStartSince(p + 4))) return !0;
          }
          return super.isExportDefaultSpecifier();
        }
        maybeParseExportDefaultSpecifier(p, b) {
          var T;
          return (T = p.specifiers) != null && T.length ? !0 : super.maybeParseExportDefaultSpecifier(p, b);
        }
        checkExport(p) {
          let { specifiers: b } = p;
          b != null && b.length && (p.specifiers = b.filter((T) => T.exported.type === "Placeholder")), super.checkExport(p), p.specifiers = b;
        }
        parseImport(p) {
          let b = this.parsePlaceholder("Identifier");
          if (!b) return super.parseImport(p);
          if (p.specifiers = [], !this.isContextual(98) && !this.match(12)) return p.source = this.finishPlaceholder(b, "StringLiteral"), this.semicolon(), this.finishNode(p, "ImportDeclaration");
          let T = this.startNodeAtNode(b);
          return T.local = b, p.specifiers.push(this.finishNode(T, "ImportDefaultSpecifier")), this.eat(12) && (this.maybeParseStarImportSpecifier(p) || this.parseNamedImportSpecifiers(p)), this.expectContextual(98), p.source = this.parseImportSource(), this.semicolon(), this.finishNode(p, "ImportDeclaration");
        }
        parseImportSource() {
          return this.parsePlaceholder("StringLiteral") || super.parseImportSource();
        }
        assertNoSpace() {
          this.state.start > this.state.lastTokEndLoc.index && this.raise(nh.UnexpectedSpace, this.state.lastTokEndLoc);
        }
      }, Qv = (y) => class extends y {
        parseV8Intrinsic() {
          if (this.match(54)) {
            let p = this.state.startLoc, b = this.startNode();
            if (this.next(), Qt(this.state.type)) {
              let T = this.parseIdentifierName(), F = this.createIdentifier(b, T);
              if (F.type = "V8IntrinsicIdentifier", this.match(10)) return F;
            }
            this.unexpected(p);
          }
        }
        parseExprAtom(p) {
          return this.parseV8Intrinsic() || super.parseExprAtom(p);
        }
      };
      function ui(y, p) {
        let [b, T] = typeof p == "string" ? [p, {}] : p, F = Object.keys(T), Y = F.length === 0;
        return y.some((ie) => {
          if (typeof ie == "string") return Y && ie === b;
          {
            let [de, he] = ie;
            if (de !== b) return !1;
            for (let fe of F) if (he[fe] !== T[fe]) return !1;
            return !0;
          }
        });
      }
      function Vu(y, p, b) {
        let T = y.find((F) => Array.isArray(F) ? F[0] === p : F === p);
        return T && Array.isArray(T) && T.length > 1 ? T[1][b] : null;
      }
      var ci = ["minimal", "fsharp", "hack", "smart"], _i = ["^^", "@@", "^", "%", "#"];
      function fS(y) {
        if (ui(y, "decorators")) {
          if (ui(y, "decorators-legacy")) throw new Error("Cannot use the decorators and decorators-legacy plugin together");
          let p = Vu(y, "decorators", "decoratorsBeforeExport");
          if (p != null && typeof p != "boolean") throw new Error("'decoratorsBeforeExport' must be a boolean, if specified.");
          let b = Vu(y, "decorators", "allowCallParenthesized");
          if (b != null && typeof b != "boolean") throw new Error("'allowCallParenthesized' must be a boolean.");
        }
        if (ui(y, "flow") && ui(y, "typescript")) throw new Error("Cannot combine flow and typescript plugins.");
        if (ui(y, "placeholders") && ui(y, "v8intrinsic")) throw new Error("Cannot combine placeholders and v8intrinsic plugins.");
        if (ui(y, "pipelineOperator")) {
          let p = Vu(y, "pipelineOperator", "proposal");
          if (!ci.includes(p)) {
            let F = ci.map((Y) => `"${Y}"`).join(", ");
            throw new Error(`"pipelineOperator" requires "proposal" option whose value must be one of: ${F}.`);
          }
          let b = ["recordAndTuple", { syntaxType: "hash" }], T = ui(y, b);
          if (p === "hack") {
            if (ui(y, "placeholders")) throw new Error("Cannot combine placeholders plugin and Hack-style pipes.");
            if (ui(y, "v8intrinsic")) throw new Error("Cannot combine v8intrinsic plugin and Hack-style pipes.");
            let F = Vu(y, "pipelineOperator", "topicToken");
            if (!_i.includes(F)) {
              let Y = _i.map((ie) => `"${ie}"`).join(", ");
              throw new Error(`"pipelineOperator" in "proposal": "hack" mode also requires a "topicToken" option whose value must be one of: ${Y}.`);
            }
            if (F === "#" && T) throw new Error(`Plugin conflict between \`["pipelineOperator", { proposal: "hack", topicToken: "#" }]\` and \`${JSON.stringify(b)}\`.`);
          } else if (p === "smart" && T) throw new Error(`Plugin conflict between \`["pipelineOperator", { proposal: "smart" }]\` and \`${JSON.stringify(b)}\`.`);
        }
        if (ui(y, "moduleAttributes")) {
          if (ui(y, "importAssertions") || ui(y, "importAttributes")) throw new Error("Cannot combine importAssertions, importAttributes and moduleAttributes plugins.");
          if (Vu(y, "moduleAttributes", "version") !== "may-2020") throw new Error("The 'moduleAttributes' plugin requires a 'version' option, representing the last proposal update. Currently, the only supported value is 'may-2020'.");
        }
        if (ui(y, "importAssertions") && ui(y, "importAttributes")) throw new Error("Cannot combine importAssertions and importAttributes plugins.");
        if (ui(y, "recordAndTuple")) {
          let p = Vu(y, "recordAndTuple", "syntaxType");
          if (p != null) {
            let b = ["hash", "bar"];
            if (!b.includes(p)) throw new Error("The 'syntaxType' option of the 'recordAndTuple' plugin must be one of: " + b.map((T) => `'${T}'`).join(", "));
          }
        }
        if (ui(y, "asyncDoExpressions") && !ui(y, "doExpressions")) {
          let p = new Error("'asyncDoExpressions' requires 'doExpressions', please add 'doExpressions' to parser plugins.");
          throw p.missingPlugins = "doExpressions", p;
        }
        if (ui(y, "optionalChainingAssign") && Vu(y, "optionalChainingAssign", "version") !== "2023-07") throw new Error("The 'optionalChainingAssign' plugin requires a 'version' option, representing the last proposal update. Currently, the only supported value is '2023-07'.");
      }
      var Zv = { estree: Rg, jsx: lS, flow: aS, typescript: eh, v8intrinsic: Qv, placeholders: pS }, e1 = Object.keys(Zv), ry = { sourceType: "script", sourceFilename: void 0, startColumn: 0, startLine: 1, allowAwaitOutsideFunction: !1, allowReturnOutsideFunction: !1, allowNewTargetOutsideFunction: !1, allowImportExportEverywhere: !1, allowSuperOutsideMethod: !1, allowUndeclaredExports: !1, plugins: [], strictMode: null, ranges: !1, tokens: !1, createImportExpressions: !1, createParenthesizedExpressions: !1, errorRecovery: !1, attachComment: !0, annexB: !0 };
      function iy(y) {
        if (y == null) return Object.assign({}, ry);
        if (y.annexB != null && y.annexB !== !1) throw new Error("The `annexB` option can only be set to `false`.");
        let p = {};
        for (let T of Object.keys(ry)) {
          var b;
          p[T] = (b = y[T]) != null ? b : ry[T];
        }
        return p;
      }
      var Qd = class extends Yv {
        checkProto(y, p, b, T) {
          if (y.type === "SpreadElement" || this.isObjectMethod(y) || y.computed || y.shorthand) return;
          let F = y.key;
          if ((F.type === "Identifier" ? F.name : F.value) === "__proto__") {
            if (p) {
              this.raise(Se.RecordNoProto, F);
              return;
            }
            b.used && (T ? T.doubleProtoLoc === null && (T.doubleProtoLoc = F.loc.start) : this.raise(Se.DuplicateProto, F)), b.used = !0;
          }
        }
        shouldExitDescending(y, p) {
          return y.type === "ArrowFunctionExpression" && y.start === p;
        }
        getExpression() {
          this.enterInitialScopes(), this.nextToken();
          let y = this.parseExpression();
          return this.match(139) || this.unexpected(), this.finalizeRemainingComments(), y.comments = this.comments, y.errors = this.state.errors, this.options.tokens && (y.tokens = this.tokens), y;
        }
        parseExpression(y, p) {
          return y ? this.disallowInAnd(() => this.parseExpressionBase(p)) : this.allowInAnd(() => this.parseExpressionBase(p));
        }
        parseExpressionBase(y) {
          let p = this.state.startLoc, b = this.parseMaybeAssign(y);
          if (this.match(12)) {
            let T = this.startNodeAt(p);
            for (T.expressions = [b]; this.eat(12); ) T.expressions.push(this.parseMaybeAssign(y));
            return this.toReferencedList(T.expressions), this.finishNode(T, "SequenceExpression");
          }
          return b;
        }
        parseMaybeAssignDisallowIn(y, p) {
          return this.disallowInAnd(() => this.parseMaybeAssign(y, p));
        }
        parseMaybeAssignAllowIn(y, p) {
          return this.allowInAnd(() => this.parseMaybeAssign(y, p));
        }
        setOptionalParametersError(y, p) {
          var b;
          y.optionalParametersLoc = (b = p == null ? void 0 : p.loc) != null ? b : this.state.startLoc;
        }
        parseMaybeAssign(y, p) {
          let b = this.state.startLoc;
          if (this.isContextual(108) && this.prodParam.hasYield) {
            let ie = this.parseYield();
            return p && (ie = p.call(this, ie, b)), ie;
          }
          let T;
          y ? T = !1 : (y = new _t(), T = !0);
          let { type: F } = this.state;
          (F === 10 || Qt(F)) && (this.state.potentialArrowAt = this.state.start);
          let Y = this.parseMaybeConditional(y);
          if (p && (Y = p.call(this, Y, b)), zT(this.state.type)) {
            let ie = this.startNodeAt(b), de = this.state.value;
            if (ie.operator = de, this.match(29)) {
              this.toAssignable(Y, !0), ie.left = Y;
              let he = b.index;
              y.doubleProtoLoc != null && y.doubleProtoLoc.index >= he && (y.doubleProtoLoc = null), y.shorthandAssignLoc != null && y.shorthandAssignLoc.index >= he && (y.shorthandAssignLoc = null), y.privateKeyLoc != null && y.privateKeyLoc.index >= he && (this.checkDestructuringPrivate(y), y.privateKeyLoc = null);
            } else ie.left = Y;
            return this.next(), ie.right = this.parseMaybeAssign(), this.checkLVal(Y, { in: this.finishNode(ie, "AssignmentExpression") }), ie;
          } else T && this.checkExpressionErrors(y, !0);
          return Y;
        }
        parseMaybeConditional(y) {
          let p = this.state.startLoc, b = this.state.potentialArrowAt, T = this.parseExprOps(y);
          return this.shouldExitDescending(T, b) ? T : this.parseConditional(T, p, y);
        }
        parseConditional(y, p, b) {
          if (this.eat(17)) {
            let T = this.startNodeAt(p);
            return T.test = y, T.consequent = this.parseMaybeAssignAllowIn(), this.expect(14), T.alternate = this.parseMaybeAssign(), this.finishNode(T, "ConditionalExpression");
          }
          return y;
        }
        parseMaybeUnaryOrPrivate(y) {
          return this.match(138) ? this.parsePrivateName() : this.parseMaybeUnary(y);
        }
        parseExprOps(y) {
          let p = this.state.startLoc, b = this.state.potentialArrowAt, T = this.parseMaybeUnaryOrPrivate(y);
          return this.shouldExitDescending(T, b) ? T : this.parseExprOp(T, p, -1);
        }
        parseExprOp(y, p, b) {
          if (this.isPrivateName(y)) {
            let F = this.getPrivateNameSV(y);
            (b >= Wd(58) || !this.prodParam.hasIn || !this.match(58)) && this.raise(Se.PrivateInExpectedIn, y, { identifierName: F }), this.classScope.usePrivateName(F, y.loc.start);
          }
          let T = this.state.type;
          if (Ri(T) && (this.prodParam.hasIn || !this.match(58))) {
            let F = Wd(T);
            if (F > b) {
              if (T === 39) {
                if (this.expectPlugin("pipelineOperator"), this.state.inFSharpPipelineDirectBody) return y;
                this.checkPipelineAtInfixOperator(y, p);
              }
              let Y = this.startNodeAt(p);
              Y.left = y, Y.operator = this.state.value;
              let ie = T === 41 || T === 42, de = T === 40;
              if (de && (F = Wd(42)), this.next(), T === 39 && this.hasPlugin(["pipelineOperator", { proposal: "minimal" }]) && this.state.type === 96 && this.prodParam.hasAwait) throw this.raise(Se.UnexpectedAwaitAfterPipelineBody, this.state.startLoc);
              Y.right = this.parseExprOpRightExpr(T, F);
              let he = this.finishNode(Y, ie || de ? "LogicalExpression" : "BinaryExpression"), fe = this.state.type;
              if (de && (fe === 41 || fe === 42) || ie && fe === 40) throw this.raise(Se.MixingCoalesceWithLogical, this.state.startLoc);
              return this.parseExprOp(he, p, b);
            }
          }
          return y;
        }
        parseExprOpRightExpr(y, p) {
          let b = this.state.startLoc;
          switch (y) {
            case 39:
              switch (this.getPluginOption("pipelineOperator", "proposal")) {
                case "hack":
                  return this.withTopicBindingContext(() => this.parseHackPipeBody());
                case "smart":
                  return this.withTopicBindingContext(() => {
                    if (this.prodParam.hasYield && this.isContextual(108)) throw this.raise(Se.PipeBodyIsTighter, this.state.startLoc);
                    return this.parseSmartPipelineBodyInStyle(this.parseExprOpBaseRightExpr(y, p), b);
                  });
                case "fsharp":
                  return this.withSoloAwaitPermittingContext(() => this.parseFSharpPipelineBody(p));
              }
            default:
              return this.parseExprOpBaseRightExpr(y, p);
          }
        }
        parseExprOpBaseRightExpr(y, p) {
          let b = this.state.startLoc;
          return this.parseExprOp(this.parseMaybeUnaryOrPrivate(), b, jv(y) ? p - 1 : p);
        }
        parseHackPipeBody() {
          var y;
          let { startLoc: p } = this.state, b = this.parseMaybeAssign();
          return LT.has(b.type) && !((y = b.extra) != null && y.parenthesized) && this.raise(Se.PipeUnparenthesizedBody, p, { type: b.type }), this.topicReferenceWasUsedInCurrentContext() || this.raise(Se.PipeTopicUnused, p), b;
        }
        checkExponentialAfterUnary(y) {
          this.match(57) && this.raise(Se.UnexpectedTokenUnaryExponentiation, y.argument);
        }
        parseMaybeUnary(y, p) {
          let b = this.state.startLoc, T = this.isContextual(96);
          if (T && this.isAwaitAllowed()) {
            this.next();
            let de = this.parseAwait(b);
            return p || this.checkExponentialAfterUnary(de), de;
          }
          let F = this.match(34), Y = this.startNode();
          if (Fu(this.state.type)) {
            Y.operator = this.state.value, Y.prefix = !0, this.match(72) && this.expectPlugin("throwExpressions");
            let de = this.match(89);
            if (this.next(), Y.argument = this.parseMaybeUnary(null, !0), this.checkExpressionErrors(y, !0), this.state.strict && de) {
              let he = Y.argument;
              he.type === "Identifier" ? this.raise(Se.StrictDelete, Y) : this.hasPropertyAsPrivateName(he) && this.raise(Se.DeletePrivateField, Y);
            }
            if (!F) return p || this.checkExponentialAfterUnary(Y), this.finishNode(Y, "UnaryExpression");
          }
          let ie = this.parseUpdate(Y, F, y);
          if (T) {
            let { type: de } = this.state;
            if ((this.hasPlugin("v8intrinsic") ? zg(de) : zg(de) && !this.match(54)) && !this.isAmbiguousAwait()) return this.raiseOverwrite(Se.AwaitNotInAsyncContext, b), this.parseAwait(b);
          }
          return ie;
        }
        parseUpdate(y, p, b) {
          if (p) {
            let Y = y;
            return this.checkLVal(Y.argument, { in: this.finishNode(Y, "UpdateExpression") }), y;
          }
          let T = this.state.startLoc, F = this.parseExprSubscripts(b);
          if (this.checkExpressionErrors(b, !1)) return F;
          for (; Wg(this.state.type) && !this.canInsertSemicolon(); ) {
            let Y = this.startNodeAt(T);
            Y.operator = this.state.value, Y.prefix = !1, Y.argument = F, this.next(), this.checkLVal(F, { in: F = this.finishNode(Y, "UpdateExpression") });
          }
          return F;
        }
        parseExprSubscripts(y) {
          let p = this.state.startLoc, b = this.state.potentialArrowAt, T = this.parseExprAtom(y);
          return this.shouldExitDescending(T, b) ? T : this.parseSubscripts(T, p);
        }
        parseSubscripts(y, p, b) {
          let T = { optionalChainMember: !1, maybeAsyncArrow: this.atPossibleAsyncArrow(y), stop: !1 };
          do
            y = this.parseSubscript(y, p, b, T), T.maybeAsyncArrow = !1;
          while (!T.stop);
          return y;
        }
        parseSubscript(y, p, b, T) {
          let { type: F } = this.state;
          if (!b && F === 15) return this.parseBind(y, p, b, T);
          if (Hd(F)) return this.parseTaggedTemplateExpression(y, p, T);
          let Y = !1;
          if (F === 18) {
            if (b && (this.raise(Se.OptionalChainingNoNew, this.state.startLoc), this.lookaheadCharCode() === 40)) return T.stop = !0, y;
            T.optionalChainMember = Y = !0, this.next();
          }
          if (!b && this.match(10)) return this.parseCoverCallAndAsyncArrowHead(y, p, T, Y);
          {
            let ie = this.eat(0);
            return ie || Y || this.eat(16) ? this.parseMember(y, p, T, ie, Y) : (T.stop = !0, y);
          }
        }
        parseMember(y, p, b, T, F) {
          let Y = this.startNodeAt(p);
          return Y.object = y, Y.computed = T, T ? (Y.property = this.parseExpression(), this.expect(3)) : this.match(138) ? (y.type === "Super" && this.raise(Se.SuperPrivateField, p), this.classScope.usePrivateName(this.state.value, this.state.startLoc), Y.property = this.parsePrivateName()) : Y.property = this.parseIdentifier(!0), b.optionalChainMember ? (Y.optional = F, this.finishNode(Y, "OptionalMemberExpression")) : this.finishNode(Y, "MemberExpression");
        }
        parseBind(y, p, b, T) {
          let F = this.startNodeAt(p);
          return F.object = y, this.next(), F.callee = this.parseNoCallExpr(), T.stop = !0, this.parseSubscripts(this.finishNode(F, "BindExpression"), p, b);
        }
        parseCoverCallAndAsyncArrowHead(y, p, b, T) {
          let F = this.state.maybeInArrowParameters, Y = null;
          this.state.maybeInArrowParameters = !0, this.next();
          let ie = this.startNodeAt(p);
          ie.callee = y;
          let { maybeAsyncArrow: de, optionalChainMember: he } = b;
          de && (this.expressionScope.enter(iS()), Y = new _t()), he && (ie.optional = T), T ? ie.arguments = this.parseCallExpressionArguments(11) : ie.arguments = this.parseCallExpressionArguments(11, y.type === "Import", y.type !== "Super", ie, Y);
          let fe = this.finishCallExpression(ie, he);
          return de && this.shouldParseAsyncArrow() && !T ? (b.stop = !0, this.checkDestructuringPrivate(Y), this.expressionScope.validateAsPattern(), this.expressionScope.exit(), fe = this.parseAsyncArrowFromCallExpression(this.startNodeAt(p), fe)) : (de && (this.checkExpressionErrors(Y, !0), this.expressionScope.exit()), this.toReferencedArguments(fe)), this.state.maybeInArrowParameters = F, fe;
        }
        toReferencedArguments(y, p) {
          this.toReferencedListDeep(y.arguments, p);
        }
        parseTaggedTemplateExpression(y, p, b) {
          let T = this.startNodeAt(p);
          return T.tag = y, T.quasi = this.parseTemplate(!0), b.optionalChainMember && this.raise(Se.OptionalChainingNoTemplate, p), this.finishNode(T, "TaggedTemplateExpression");
        }
        atPossibleAsyncArrow(y) {
          return y.type === "Identifier" && y.name === "async" && this.state.lastTokEndLoc.index === y.end && !this.canInsertSemicolon() && y.end - y.start === 5 && y.start === this.state.potentialArrowAt;
        }
        expectImportAttributesPlugin() {
          this.hasPlugin("importAssertions") || this.expectPlugin("importAttributes");
        }
        finishCallExpression(y, p) {
          if (y.callee.type === "Import") if (y.arguments.length === 2 && (this.hasPlugin("moduleAttributes") || this.expectImportAttributesPlugin()), y.arguments.length === 0 || y.arguments.length > 2) this.raise(Se.ImportCallArity, y, { maxArgumentCount: this.hasPlugin("importAttributes") || this.hasPlugin("importAssertions") || this.hasPlugin("moduleAttributes") ? 2 : 1 });
          else for (let b of y.arguments) b.type === "SpreadElement" && this.raise(Se.ImportCallSpreadArgument, b);
          return this.finishNode(y, p ? "OptionalCallExpression" : "CallExpression");
        }
        parseCallExpressionArguments(y, p, b, T, F) {
          let Y = [], ie = !0, de = this.state.inFSharpPipelineDirectBody;
          for (this.state.inFSharpPipelineDirectBody = !1; !this.eat(y); ) {
            if (ie) ie = !1;
            else if (this.expect(12), this.match(y)) {
              p && !this.hasPlugin("importAttributes") && !this.hasPlugin("importAssertions") && !this.hasPlugin("moduleAttributes") && this.raise(Se.ImportCallArgumentTrailingComma, this.state.lastTokStartLoc), T && this.addTrailingCommaExtraToNode(T), this.next();
              break;
            }
            Y.push(this.parseExprListItem(!1, F, b));
          }
          return this.state.inFSharpPipelineDirectBody = de, Y;
        }
        shouldParseAsyncArrow() {
          return this.match(19) && !this.canInsertSemicolon();
        }
        parseAsyncArrowFromCallExpression(y, p) {
          var b;
          return this.resetPreviousNodeTrailingComments(p), this.expect(19), this.parseArrowExpression(y, p.arguments, !0, (b = p.extra) == null ? void 0 : b.trailingCommaLoc), p.innerComments && $u(y, p.innerComments), p.callee.trailingComments && $u(y, p.callee.trailingComments), y;
        }
        parseNoCallExpr() {
          let y = this.state.startLoc;
          return this.parseSubscripts(this.parseExprAtom(), y, !0);
        }
        parseExprAtom(y) {
          let p, b = null, { type: T } = this.state;
          switch (T) {
            case 79:
              return this.parseSuper();
            case 83:
              return p = this.startNode(), this.next(), this.match(16) ? this.parseImportMetaProperty(p) : this.match(10) ? this.options.createImportExpressions ? this.parseImportCall(p) : this.finishNode(p, "Import") : (this.raise(Se.UnsupportedImport, this.state.lastTokStartLoc), this.finishNode(p, "Import"));
            case 78:
              return p = this.startNode(), this.next(), this.finishNode(p, "ThisExpression");
            case 90:
              return this.parseDo(this.startNode(), !1);
            case 56:
            case 31:
              return this.readRegexp(), this.parseRegExpLiteral(this.state.value);
            case 134:
              return this.parseNumericLiteral(this.state.value);
            case 135:
              return this.parseBigIntLiteral(this.state.value);
            case 136:
              return this.parseDecimalLiteral(this.state.value);
            case 133:
              return this.parseStringLiteral(this.state.value);
            case 84:
              return this.parseNullLiteral();
            case 85:
              return this.parseBooleanLiteral(!0);
            case 86:
              return this.parseBooleanLiteral(!1);
            case 10: {
              let F = this.state.potentialArrowAt === this.state.start;
              return this.parseParenAndDistinguishExpression(F);
            }
            case 2:
            case 1:
              return this.parseArrayLike(this.state.type === 2 ? 4 : 3, !1, !0);
            case 0:
              return this.parseArrayLike(3, !0, !1, y);
            case 6:
            case 7:
              return this.parseObjectLike(this.state.type === 6 ? 9 : 8, !1, !0);
            case 5:
              return this.parseObjectLike(8, !1, !1, y);
            case 68:
              return this.parseFunctionOrFunctionSent();
            case 26:
              b = this.parseDecorators();
            case 80:
              return this.parseClass(this.maybeTakeDecorators(b, this.startNode()), !1);
            case 77:
              return this.parseNewOrNewTarget();
            case 25:
            case 24:
              return this.parseTemplate(!1);
            case 15: {
              p = this.startNode(), this.next(), p.object = null;
              let F = p.callee = this.parseNoCallExpr();
              if (F.type === "MemberExpression") return this.finishNode(p, "BindExpression");
              throw this.raise(Se.UnsupportedBind, F);
            }
            case 138:
              return this.raise(Se.PrivateInExpectedIn, this.state.startLoc, { identifierName: this.state.value }), this.parsePrivateName();
            case 33:
              return this.parseTopicReferenceThenEqualsSign(54, "%");
            case 32:
              return this.parseTopicReferenceThenEqualsSign(44, "^");
            case 37:
            case 38:
              return this.parseTopicReference("hack");
            case 44:
            case 54:
            case 27: {
              let F = this.getPluginOption("pipelineOperator", "proposal");
              if (F) return this.parseTopicReference(F);
              this.unexpected();
              break;
            }
            case 47: {
              let F = this.input.codePointAt(this.nextTokenStart());
              Xi(F) || F === 62 ? this.expectOnePlugin(["jsx", "flow", "typescript"]) : this.unexpected();
              break;
            }
            default:
              if (Qt(T)) {
                if (this.isContextual(127) && this.lookaheadInLineCharCode() === 123) return this.parseModuleExpression();
                let F = this.state.potentialArrowAt === this.state.start, Y = this.state.containsEsc, ie = this.parseIdentifier();
                if (!Y && ie.name === "async" && !this.canInsertSemicolon()) {
                  let { type: de } = this.state;
                  if (de === 68) return this.resetPreviousNodeTrailingComments(ie), this.next(), this.parseAsyncFunctionExpression(this.startNodeAtNode(ie));
                  if (Qt(de)) return this.lookaheadCharCode() === 61 ? this.parseAsyncArrowUnaryFunction(this.startNodeAtNode(ie)) : ie;
                  if (de === 90) return this.resetPreviousNodeTrailingComments(ie), this.parseDo(this.startNodeAtNode(ie), !0);
                }
                return F && this.match(19) && !this.canInsertSemicolon() ? (this.next(), this.parseArrowExpression(this.startNodeAtNode(ie), [ie], !1)) : ie;
              } else this.unexpected();
          }
        }
        parseTopicReferenceThenEqualsSign(y, p) {
          let b = this.getPluginOption("pipelineOperator", "proposal");
          if (b) return this.state.type = y, this.state.value = p, this.state.pos--, this.state.end--, this.state.endLoc = dt(this.state.endLoc, -1), this.parseTopicReference(b);
          this.unexpected();
        }
        parseTopicReference(y) {
          let p = this.startNode(), b = this.state.startLoc, T = this.state.type;
          return this.next(), this.finishTopicReference(p, b, y, T);
        }
        finishTopicReference(y, p, b, T) {
          if (this.testTopicReferenceConfiguration(b, p, T)) {
            let F = b === "smart" ? "PipelinePrimaryTopicReference" : "TopicReference";
            return this.topicReferenceIsAllowedInCurrentContext() || this.raise(b === "smart" ? Se.PrimaryTopicNotAllowed : Se.PipeTopicUnbound, p), this.registerTopicReference(), this.finishNode(y, F);
          } else throw this.raise(Se.PipeTopicUnconfiguredToken, p, { token: vi(T) });
        }
        testTopicReferenceConfiguration(y, p, b) {
          switch (y) {
            case "hack":
              return this.hasPlugin(["pipelineOperator", { topicToken: vi(b) }]);
            case "smart":
              return b === 27;
            default:
              throw this.raise(Se.PipeTopicRequiresHackPipes, p);
          }
        }
        parseAsyncArrowUnaryFunction(y) {
          this.prodParam.enter(Ye(!0, this.prodParam.hasYield));
          let p = [this.parseIdentifier()];
          return this.prodParam.exit(), this.hasPrecedingLineBreak() && this.raise(Se.LineTerminatorBeforeArrow, this.state.curPosition()), this.expect(19), this.parseArrowExpression(y, p, !0);
        }
        parseDo(y, p) {
          this.expectPlugin("doExpressions"), p && this.expectPlugin("asyncDoExpressions"), y.async = p, this.next();
          let b = this.state.labels;
          return this.state.labels = [], p ? (this.prodParam.enter(2), y.body = this.parseBlock(), this.prodParam.exit()) : y.body = this.parseBlock(), this.state.labels = b, this.finishNode(y, "DoExpression");
        }
        parseSuper() {
          let y = this.startNode();
          return this.next(), this.match(10) && !this.scope.allowDirectSuper && !this.options.allowSuperOutsideMethod ? this.raise(Se.SuperNotAllowed, y) : !this.scope.allowSuper && !this.options.allowSuperOutsideMethod && this.raise(Se.UnexpectedSuper, y), !this.match(10) && !this.match(0) && !this.match(16) && this.raise(Se.UnsupportedSuper, y), this.finishNode(y, "Super");
        }
        parsePrivateName() {
          let y = this.startNode(), p = this.startNodeAt(dt(this.state.startLoc, 1)), b = this.state.value;
          return this.next(), y.id = this.createIdentifier(p, b), this.finishNode(y, "PrivateName");
        }
        parseFunctionOrFunctionSent() {
          let y = this.startNode();
          if (this.next(), this.prodParam.hasYield && this.match(16)) {
            let p = this.createIdentifier(this.startNodeAtNode(y), "function");
            return this.next(), this.match(103) ? this.expectPlugin("functionSent") : this.hasPlugin("functionSent") || this.unexpected(), this.parseMetaProperty(y, p, "sent");
          }
          return this.parseFunction(y);
        }
        parseMetaProperty(y, p, b) {
          y.meta = p;
          let T = this.state.containsEsc;
          return y.property = this.parseIdentifier(!0), (y.property.name !== b || T) && this.raise(Se.UnsupportedMetaProperty, y.property, { target: p.name, onlyValidPropertyName: b }), this.finishNode(y, "MetaProperty");
        }
        parseImportMetaProperty(y) {
          let p = this.createIdentifier(this.startNodeAtNode(y), "import");
          if (this.next(), this.isContextual(101)) this.inModule || this.raise(Se.ImportMetaOutsideModule, p), this.sawUnambiguousESM = !0;
          else if (this.isContextual(105) || this.isContextual(97)) {
            let b = this.isContextual(105);
            if (b || this.unexpected(), this.expectPlugin(b ? "sourcePhaseImports" : "deferredImportEvaluation"), !this.options.createImportExpressions) throw this.raise(Se.DynamicImportPhaseRequiresImportExpressions, this.state.startLoc, { phase: this.state.value });
            return this.next(), y.phase = b ? "source" : "defer", this.parseImportCall(y);
          }
          return this.parseMetaProperty(y, p, "meta");
        }
        parseLiteralAtNode(y, p, b) {
          return this.addExtra(b, "rawValue", y), this.addExtra(b, "raw", this.input.slice(b.start, this.state.end)), b.value = y, this.next(), this.finishNode(b, p);
        }
        parseLiteral(y, p) {
          let b = this.startNode();
          return this.parseLiteralAtNode(y, p, b);
        }
        parseStringLiteral(y) {
          return this.parseLiteral(y, "StringLiteral");
        }
        parseNumericLiteral(y) {
          return this.parseLiteral(y, "NumericLiteral");
        }
        parseBigIntLiteral(y) {
          return this.parseLiteral(y, "BigIntLiteral");
        }
        parseDecimalLiteral(y) {
          return this.parseLiteral(y, "DecimalLiteral");
        }
        parseRegExpLiteral(y) {
          let p = this.startNode();
          return this.addExtra(p, "raw", this.input.slice(p.start, this.state.end)), p.pattern = y.pattern, p.flags = y.flags, this.next(), this.finishNode(p, "RegExpLiteral");
        }
        parseBooleanLiteral(y) {
          let p = this.startNode();
          return p.value = y, this.next(), this.finishNode(p, "BooleanLiteral");
        }
        parseNullLiteral() {
          let y = this.startNode();
          return this.next(), this.finishNode(y, "NullLiteral");
        }
        parseParenAndDistinguishExpression(y) {
          let p = this.state.startLoc, b;
          this.next(), this.expressionScope.enter(rS());
          let T = this.state.maybeInArrowParameters, F = this.state.inFSharpPipelineDirectBody;
          this.state.maybeInArrowParameters = !0, this.state.inFSharpPipelineDirectBody = !1;
          let Y = this.state.startLoc, ie = [], de = new _t(), he = !0, fe, Ze;
          for (; !this.match(11); ) {
            if (he) he = !1;
            else if (this.expect(12, de.optionalParametersLoc === null ? null : de.optionalParametersLoc), this.match(11)) {
              Ze = this.state.startLoc;
              break;
            }
            if (this.match(21)) {
              let It = this.state.startLoc;
              if (fe = this.state.startLoc, ie.push(this.parseParenItem(this.parseRestBinding(), It)), !this.checkCommaAfterRest(41)) break;
            } else ie.push(this.parseMaybeAssignAllowIn(de, this.parseParenItem));
          }
          let Dt = this.state.lastTokEndLoc;
          this.expect(11), this.state.maybeInArrowParameters = T, this.state.inFSharpPipelineDirectBody = F;
          let $t = this.startNodeAt(p);
          return y && this.shouldParseArrow(ie) && ($t = this.parseArrow($t)) ? (this.checkDestructuringPrivate(de), this.expressionScope.validateAsPattern(), this.expressionScope.exit(), this.parseArrowExpression($t, ie, !1), $t) : (this.expressionScope.exit(), ie.length || this.unexpected(this.state.lastTokStartLoc), Ze && this.unexpected(Ze), fe && this.unexpected(fe), this.checkExpressionErrors(de, !0), this.toReferencedListDeep(ie, !0), ie.length > 1 ? (b = this.startNodeAt(Y), b.expressions = ie, this.finishNode(b, "SequenceExpression"), this.resetEndLocation(b, Dt)) : b = ie[0], this.wrapParenthesis(p, b));
        }
        wrapParenthesis(y, p) {
          if (!this.options.createParenthesizedExpressions) return this.addExtra(p, "parenthesized", !0), this.addExtra(p, "parenStart", y.index), this.takeSurroundingComments(p, y.index, this.state.lastTokEndLoc.index), p;
          let b = this.startNodeAt(y);
          return b.expression = p, this.finishNode(b, "ParenthesizedExpression");
        }
        shouldParseArrow(y) {
          return !this.canInsertSemicolon();
        }
        parseArrow(y) {
          if (this.eat(19)) return y;
        }
        parseParenItem(y, p) {
          return y;
        }
        parseNewOrNewTarget() {
          let y = this.startNode();
          if (this.next(), this.match(16)) {
            let p = this.createIdentifier(this.startNodeAtNode(y), "new");
            this.next();
            let b = this.parseMetaProperty(y, p, "target");
            return !this.scope.inNonArrowFunction && !this.scope.inClass && !this.options.allowNewTargetOutsideFunction && this.raise(Se.UnexpectedNewTarget, b), b;
          }
          return this.parseNew(y);
        }
        parseNew(y) {
          if (this.parseNewCallee(y), this.eat(10)) {
            let p = this.parseExprList(11);
            this.toReferencedList(p), y.arguments = p;
          } else y.arguments = [];
          return this.finishNode(y, "NewExpression");
        }
        parseNewCallee(y) {
          let p = this.match(83), b = this.parseNoCallExpr();
          y.callee = b, p && (b.type === "Import" || b.type === "ImportExpression") && this.raise(Se.ImportCallNotNewExpression, b);
        }
        parseTemplateElement(y) {
          let { start: p, startLoc: b, end: T, value: F } = this.state, Y = p + 1, ie = this.startNodeAt(dt(b, 1));
          F === null && (y || this.raise(Se.InvalidEscapeSequenceTemplate, dt(this.state.firstInvalidTemplateEscapePos, 1)));
          let de = this.match(24), he = de ? -1 : -2, fe = T + he;
          ie.value = { raw: this.input.slice(Y, fe).replace(/\r\n?/g, `
`), cooked: F === null ? null : F.slice(1, he) }, ie.tail = de, this.next();
          let Ze = this.finishNode(ie, "TemplateElement");
          return this.resetEndLocation(Ze, dt(this.state.lastTokEndLoc, he)), Ze;
        }
        parseTemplate(y) {
          let p = this.startNode(), b = this.parseTemplateElement(y), T = [b], F = [];
          for (; !b.tail; ) F.push(this.parseTemplateSubstitution()), this.readTemplateContinuation(), T.push(b = this.parseTemplateElement(y));
          return p.expressions = F, p.quasis = T, this.finishNode(p, "TemplateLiteral");
        }
        parseTemplateSubstitution() {
          return this.parseExpression();
        }
        parseObjectLike(y, p, b, T) {
          b && this.expectPlugin("recordAndTuple");
          let F = this.state.inFSharpPipelineDirectBody;
          this.state.inFSharpPipelineDirectBody = !1;
          let Y = /* @__PURE__ */ Object.create(null), ie = !0, de = this.startNode();
          for (de.properties = [], this.next(); !this.match(y); ) {
            if (ie) ie = !1;
            else if (this.expect(12), this.match(y)) {
              this.addTrailingCommaExtraToNode(de);
              break;
            }
            let fe;
            p ? fe = this.parseBindingProperty() : (fe = this.parsePropertyDefinition(T), this.checkProto(fe, b, Y, T)), b && !this.isObjectProperty(fe) && fe.type !== "SpreadElement" && this.raise(Se.InvalidRecordProperty, fe), fe.shorthand && this.addExtra(fe, "shorthand", !0), de.properties.push(fe);
          }
          this.next(), this.state.inFSharpPipelineDirectBody = F;
          let he = "ObjectExpression";
          return p ? he = "ObjectPattern" : b && (he = "RecordExpression"), this.finishNode(de, he);
        }
        addTrailingCommaExtraToNode(y) {
          this.addExtra(y, "trailingComma", this.state.lastTokStartLoc.index), this.addExtra(y, "trailingCommaLoc", this.state.lastTokStartLoc, !1);
        }
        maybeAsyncOrAccessorProp(y) {
          return !y.computed && y.key.type === "Identifier" && (this.isLiteralPropertyName() || this.match(0) || this.match(55));
        }
        parsePropertyDefinition(y) {
          let p = [];
          if (this.match(26)) for (this.hasPlugin("decorators") && this.raise(Se.UnsupportedPropertyDecorator, this.state.startLoc); this.match(26); ) p.push(this.parseDecorator());
          let b = this.startNode(), T = !1, F = !1, Y;
          if (this.match(21)) return p.length && this.unexpected(), this.parseSpread();
          p.length && (b.decorators = p, p = []), b.method = !1, y && (Y = this.state.startLoc);
          let ie = this.eat(55);
          this.parsePropertyNamePrefixOperator(b);
          let de = this.state.containsEsc;
          if (this.parsePropertyName(b, y), !ie && !de && this.maybeAsyncOrAccessorProp(b)) {
            let { key: he } = b, fe = he.name;
            fe === "async" && !this.hasPrecedingLineBreak() && (T = !0, this.resetPreviousNodeTrailingComments(he), ie = this.eat(55), this.parsePropertyName(b)), (fe === "get" || fe === "set") && (F = !0, this.resetPreviousNodeTrailingComments(he), b.kind = fe, this.match(55) && (ie = !0, this.raise(Se.AccessorIsGenerator, this.state.curPosition(), { kind: fe }), this.next()), this.parsePropertyName(b));
          }
          return this.parseObjPropValue(b, Y, ie, T, !1, F, y);
        }
        getGetterSetterExpectedParamCount(y) {
          return y.kind === "get" ? 0 : 1;
        }
        getObjectOrClassMethodParams(y) {
          return y.params;
        }
        checkGetterSetterParams(y) {
          var p;
          let b = this.getGetterSetterExpectedParamCount(y), T = this.getObjectOrClassMethodParams(y);
          T.length !== b && this.raise(y.kind === "get" ? Se.BadGetterArity : Se.BadSetterArity, y), y.kind === "set" && ((p = T[T.length - 1]) == null ? void 0 : p.type) === "RestElement" && this.raise(Se.BadSetterRestParameter, y);
        }
        parseObjectMethod(y, p, b, T, F) {
          if (F) {
            let Y = this.parseMethod(y, p, !1, !1, !1, "ObjectMethod");
            return this.checkGetterSetterParams(Y), Y;
          }
          if (b || p || this.match(10)) return T && this.unexpected(), y.kind = "method", y.method = !0, this.parseMethod(y, p, b, !1, !1, "ObjectMethod");
        }
        parseObjectProperty(y, p, b, T) {
          if (y.shorthand = !1, this.eat(14)) return y.value = b ? this.parseMaybeDefault(this.state.startLoc) : this.parseMaybeAssignAllowIn(T), this.finishNode(y, "ObjectProperty");
          if (!y.computed && y.key.type === "Identifier") {
            if (this.checkReservedWord(y.key.name, y.key.loc.start, !0, !1), b) y.value = this.parseMaybeDefault(p, Un(y.key));
            else if (this.match(29)) {
              let F = this.state.startLoc;
              T != null ? T.shorthandAssignLoc === null && (T.shorthandAssignLoc = F) : this.raise(Se.InvalidCoverInitializedName, F), y.value = this.parseMaybeDefault(p, Un(y.key));
            } else y.value = Un(y.key);
            return y.shorthand = !0, this.finishNode(y, "ObjectProperty");
          }
        }
        parseObjPropValue(y, p, b, T, F, Y, ie) {
          let de = this.parseObjectMethod(y, b, T, F, Y) || this.parseObjectProperty(y, p, F, ie);
          return de || this.unexpected(), de;
        }
        parsePropertyName(y, p) {
          if (this.eat(0)) y.computed = !0, y.key = this.parseMaybeAssignAllowIn(), this.expect(3);
          else {
            let { type: b, value: T } = this.state, F;
            if (Bs(b)) F = this.parseIdentifier(!0);
            else switch (b) {
              case 134:
                F = this.parseNumericLiteral(T);
                break;
              case 133:
                F = this.parseStringLiteral(T);
                break;
              case 135:
                F = this.parseBigIntLiteral(T);
                break;
              case 136:
                F = this.parseDecimalLiteral(T);
                break;
              case 138: {
                let Y = this.state.startLoc;
                p != null ? p.privateKeyLoc === null && (p.privateKeyLoc = Y) : this.raise(Se.UnexpectedPrivateField, Y), F = this.parsePrivateName();
                break;
              }
              default:
                this.unexpected();
            }
            y.key = F, b !== 138 && (y.computed = !1);
          }
        }
        initFunction(y, p) {
          y.id = null, y.generator = !1, y.async = p;
        }
        parseMethod(y, p, b, T, F, Y, ie = !1) {
          this.initFunction(y, b), y.generator = p, this.scope.enter(18 | (ie ? 64 : 0) | (F ? 32 : 0)), this.prodParam.enter(Ye(b, y.generator)), this.parseFunctionParams(y, T);
          let de = this.parseFunctionBodyAndFinish(y, Y, !0);
          return this.prodParam.exit(), this.scope.exit(), de;
        }
        parseArrayLike(y, p, b, T) {
          b && this.expectPlugin("recordAndTuple");
          let F = this.state.inFSharpPipelineDirectBody;
          this.state.inFSharpPipelineDirectBody = !1;
          let Y = this.startNode();
          return this.next(), Y.elements = this.parseExprList(y, !b, T, Y), this.state.inFSharpPipelineDirectBody = F, this.finishNode(Y, b ? "TupleExpression" : "ArrayExpression");
        }
        parseArrowExpression(y, p, b, T) {
          this.scope.enter(6);
          let F = Ye(b, !1);
          !this.match(5) && this.prodParam.hasIn && (F |= 8), this.prodParam.enter(F), this.initFunction(y, b);
          let Y = this.state.maybeInArrowParameters;
          return p && (this.state.maybeInArrowParameters = !0, this.setArrowFunctionParameters(y, p, T)), this.state.maybeInArrowParameters = !1, this.parseFunctionBody(y, !0), this.prodParam.exit(), this.scope.exit(), this.state.maybeInArrowParameters = Y, this.finishNode(y, "ArrowFunctionExpression");
        }
        setArrowFunctionParameters(y, p, b) {
          this.toAssignableList(p, b, !1), y.params = p;
        }
        parseFunctionBodyAndFinish(y, p, b = !1) {
          return this.parseFunctionBody(y, !1, b), this.finishNode(y, p);
        }
        parseFunctionBody(y, p, b = !1) {
          let T = p && !this.match(5);
          if (this.expressionScope.enter(Lu()), T) y.body = this.parseMaybeAssign(), this.checkParams(y, !1, p, !1);
          else {
            let F = this.state.strict, Y = this.state.labels;
            this.state.labels = [], this.prodParam.enter(this.prodParam.currentFlags() | 4), y.body = this.parseBlock(!0, !1, (ie) => {
              let de = !this.isSimpleParamList(y.params);
              ie && de && this.raise(Se.IllegalLanguageModeDirective, (y.kind === "method" || y.kind === "constructor") && y.key ? y.key.loc.end : y);
              let he = !F && this.state.strict;
              this.checkParams(y, !this.state.strict && !p && !b && !de, p, he), this.state.strict && y.id && this.checkIdentifier(y.id, 65, he);
            }), this.prodParam.exit(), this.state.labels = Y;
          }
          this.expressionScope.exit();
        }
        isSimpleParameter(y) {
          return y.type === "Identifier";
        }
        isSimpleParamList(y) {
          for (let p = 0, b = y.length; p < b; p++) if (!this.isSimpleParameter(y[p])) return !1;
          return !0;
        }
        checkParams(y, p, b, T = !0) {
          let F = !p && /* @__PURE__ */ new Set(), Y = { type: "FormalParameters" };
          for (let ie of y.params) this.checkLVal(ie, { in: Y, binding: 5, checkClashes: F, strictModeChanged: T });
        }
        parseExprList(y, p, b, T) {
          let F = [], Y = !0;
          for (; !this.eat(y); ) {
            if (Y) Y = !1;
            else if (this.expect(12), this.match(y)) {
              T && this.addTrailingCommaExtraToNode(T), this.next();
              break;
            }
            F.push(this.parseExprListItem(p, b));
          }
          return F;
        }
        parseExprListItem(y, p, b) {
          let T;
          if (this.match(12)) y || this.raise(Se.UnexpectedToken, this.state.curPosition(), { unexpected: "," }), T = null;
          else if (this.match(21)) {
            let F = this.state.startLoc;
            T = this.parseParenItem(this.parseSpread(p), F);
          } else if (this.match(17)) {
            this.expectPlugin("partialApplication"), b || this.raise(Se.UnexpectedArgumentPlaceholder, this.state.startLoc);
            let F = this.startNode();
            this.next(), T = this.finishNode(F, "ArgumentPlaceholder");
          } else T = this.parseMaybeAssignAllowIn(p, this.parseParenItem);
          return T;
        }
        parseIdentifier(y) {
          let p = this.startNode(), b = this.parseIdentifierName(y);
          return this.createIdentifier(p, b);
        }
        createIdentifier(y, p) {
          return y.name = p, y.loc.identifierName = p, this.finishNode(y, "Identifier");
        }
        parseIdentifierName(y) {
          let p, { startLoc: b, type: T } = this.state;
          Bs(T) ? p = this.state.value : this.unexpected();
          let F = kr(T);
          return y ? F && this.replaceToken(132) : this.checkReservedWord(p, b, F, !1), this.next(), p;
        }
        checkReservedWord(y, p, b, T) {
          if (!(y.length > 10 || !Ic(y))) {
            if (b && HT(y)) {
              this.raise(Se.UnexpectedKeyword, p, { keyword: y });
              return;
            }
            if ((this.state.strict ? T ? Uv : qf : Vv)(y, this.inModule)) {
              this.raise(Se.UnexpectedReservedWord, p, { reservedWord: y });
              return;
            } else if (y === "yield") {
              if (this.prodParam.hasYield) {
                this.raise(Se.YieldBindingIdentifier, p);
                return;
              }
            } else if (y === "await") {
              if (this.prodParam.hasAwait) {
                this.raise(Se.AwaitBindingIdentifier, p);
                return;
              }
              if (this.scope.inStaticBlock) {
                this.raise(Se.AwaitBindingIdentifierInStaticBlock, p);
                return;
              }
              this.expressionScope.recordAsyncArrowParametersError(p);
            } else if (y === "arguments" && this.scope.inClassAndNotInNonArrowFunction) {
              this.raise(Se.ArgumentsInClass, p);
              return;
            }
          }
        }
        isAwaitAllowed() {
          return !!(this.prodParam.hasAwait || this.options.allowAwaitOutsideFunction && !this.scope.inFunction);
        }
        parseAwait(y) {
          let p = this.startNodeAt(y);
          return this.expressionScope.recordParameterInitializerError(Se.AwaitExpressionFormalParameter, p), this.eat(55) && this.raise(Se.ObsoleteAwaitStar, p), !this.scope.inFunction && !this.options.allowAwaitOutsideFunction && (this.isAmbiguousAwait() ? this.ambiguousScriptDifferentAst = !0 : this.sawUnambiguousESM = !0), this.state.soloAwait || (p.argument = this.parseMaybeUnary(null, !0)), this.finishNode(p, "AwaitExpression");
        }
        isAmbiguousAwait() {
          if (this.hasPrecedingLineBreak()) return !0;
          let { type: y } = this.state;
          return y === 53 || y === 10 || y === 0 || Hd(y) || y === 102 && !this.state.containsEsc || y === 137 || y === 56 || this.hasPlugin("v8intrinsic") && y === 54;
        }
        parseYield() {
          let y = this.startNode();
          this.expressionScope.recordParameterInitializerError(Se.YieldInParameter, y), this.next();
          let p = !1, b = null;
          if (!this.hasPrecedingLineBreak()) switch (p = this.eat(55), this.state.type) {
            case 13:
            case 139:
            case 8:
            case 11:
            case 3:
            case 9:
            case 14:
            case 12:
              if (!p) break;
            default:
              b = this.parseMaybeAssign();
          }
          return y.delegate = p, y.argument = b, this.finishNode(y, "YieldExpression");
        }
        parseImportCall(y) {
          return this.next(), y.source = this.parseMaybeAssignAllowIn(), (this.hasPlugin("importAttributes") || this.hasPlugin("importAssertions")) && (y.options = null), this.eat(12) && (this.expectImportAttributesPlugin(), this.match(11) || (y.options = this.parseMaybeAssignAllowIn(), this.eat(12))), this.expect(11), this.finishNode(y, "ImportExpression");
        }
        checkPipelineAtInfixOperator(y, p) {
          this.hasPlugin(["pipelineOperator", { proposal: "smart" }]) && y.type === "SequenceExpression" && this.raise(Se.PipelineHeadSequenceExpression, p);
        }
        parseSmartPipelineBodyInStyle(y, p) {
          if (this.isSimpleReference(y)) {
            let b = this.startNodeAt(p);
            return b.callee = y, this.finishNode(b, "PipelineBareFunction");
          } else {
            let b = this.startNodeAt(p);
            return this.checkSmartPipeTopicBodyEarlyErrors(p), b.expression = y, this.finishNode(b, "PipelineTopicExpression");
          }
        }
        isSimpleReference(y) {
          switch (y.type) {
            case "MemberExpression":
              return !y.computed && this.isSimpleReference(y.object);
            case "Identifier":
              return !0;
            default:
              return !1;
          }
        }
        checkSmartPipeTopicBodyEarlyErrors(y) {
          if (this.match(19)) throw this.raise(Se.PipelineBodyNoArrow, this.state.startLoc);
          this.topicReferenceWasUsedInCurrentContext() || this.raise(Se.PipelineTopicUnused, y);
        }
        withTopicBindingContext(y) {
          let p = this.state.topicContext;
          this.state.topicContext = { maxNumOfResolvableTopics: 1, maxTopicIndex: null };
          try {
            return y();
          } finally {
            this.state.topicContext = p;
          }
        }
        withSmartMixTopicForbiddingContext(y) {
          if (this.hasPlugin(["pipelineOperator", { proposal: "smart" }])) {
            let p = this.state.topicContext;
            this.state.topicContext = { maxNumOfResolvableTopics: 0, maxTopicIndex: null };
            try {
              return y();
            } finally {
              this.state.topicContext = p;
            }
          } else return y();
        }
        withSoloAwaitPermittingContext(y) {
          let p = this.state.soloAwait;
          this.state.soloAwait = !0;
          try {
            return y();
          } finally {
            this.state.soloAwait = p;
          }
        }
        allowInAnd(y) {
          let p = this.prodParam.currentFlags();
          if (8 & ~p) {
            this.prodParam.enter(p | 8);
            try {
              return y();
            } finally {
              this.prodParam.exit();
            }
          }
          return y();
        }
        disallowInAnd(y) {
          let p = this.prodParam.currentFlags();
          if (8 & p) {
            this.prodParam.enter(p & -9);
            try {
              return y();
            } finally {
              this.prodParam.exit();
            }
          }
          return y();
        }
        registerTopicReference() {
          this.state.topicContext.maxTopicIndex = 0;
        }
        topicReferenceIsAllowedInCurrentContext() {
          return this.state.topicContext.maxNumOfResolvableTopics >= 1;
        }
        topicReferenceWasUsedInCurrentContext() {
          return this.state.topicContext.maxTopicIndex != null && this.state.topicContext.maxTopicIndex >= 0;
        }
        parseFSharpPipelineBody(y) {
          let p = this.state.startLoc;
          this.state.potentialArrowAt = this.state.start;
          let b = this.state.inFSharpPipelineDirectBody;
          this.state.inFSharpPipelineDirectBody = !0;
          let T = this.parseExprOp(this.parseMaybeUnaryOrPrivate(), p, y);
          return this.state.inFSharpPipelineDirectBody = b, T;
        }
        parseModuleExpression() {
          this.expectPlugin("moduleBlocks");
          let y = this.startNode();
          this.next(), this.match(5) || this.unexpected(null, 5);
          let p = this.startNodeAt(this.state.endLoc);
          this.next();
          let b = this.initializeScopes(!0);
          this.enterInitialScopes();
          try {
            y.body = this.parseProgram(p, 8, "module");
          } finally {
            b();
          }
          return this.finishNode(y, "ModuleExpression");
        }
        parsePropertyNamePrefixOperator(y) {
        }
      }, Zd = { kind: 1 }, Mc = { kind: 2 }, ep = /[\uD800-\uDFFF]/u, zu = /in(?:stanceof)?/y;
      function rh(y, p) {
        for (let b = 0; b < y.length; b++) {
          let T = y[b], { type: F } = T;
          if (typeof F == "number") {
            {
              if (F === 138) {
                let { loc: Y, start: ie, value: de, end: he } = T, fe = ie + 1, Ze = dt(Y.start, 1);
                y.splice(b, 1, new Fl({ type: ba(27), value: "#", start: ie, end: fe, startLoc: Y.start, endLoc: Ze }), new Fl({ type: ba(132), value: de, start: fe, end: he, startLoc: Ze, endLoc: Y.end })), b++;
                continue;
              }
              if (Hd(F)) {
                let { loc: Y, start: ie, value: de, end: he } = T, fe = ie + 1, Ze = dt(Y.start, 1), Dt;
                p.charCodeAt(ie) === 96 ? Dt = new Fl({ type: ba(22), value: "`", start: ie, end: fe, startLoc: Y.start, endLoc: Ze }) : Dt = new Fl({ type: ba(8), value: "}", start: ie, end: fe, startLoc: Y.start, endLoc: Ze });
                let $t, It, nr, Di;
                F === 24 ? (It = he - 1, nr = dt(Y.end, -1), $t = de === null ? null : de.slice(1, -1), Di = new Fl({ type: ba(22), value: "`", start: It, end: he, startLoc: nr, endLoc: Y.end })) : (It = he - 2, nr = dt(Y.end, -2), $t = de === null ? null : de.slice(1, -2), Di = new Fl({ type: ba(23), value: "${", start: It, end: he, startLoc: nr, endLoc: Y.end })), y.splice(b, 1, Dt, new Fl({ type: ba(20), value: $t, start: fe, end: It, startLoc: Ze, endLoc: nr }), Di), b += 2;
                continue;
              }
            }
            T.type = ba(F);
          }
        }
        return y;
      }
      var Rc = class extends Qd {
        parseTopLevel(y, p) {
          return y.program = this.parseProgram(p), y.comments = this.comments, this.options.tokens && (y.tokens = rh(this.tokens, this.input)), this.finishNode(y, "File");
        }
        parseProgram(y, p = 139, b = this.options.sourceType) {
          if (y.sourceType = b, y.interpreter = this.parseInterpreterDirective(), this.parseBlockBody(y, !0, !0, p), this.inModule && !this.options.allowUndeclaredExports && this.scope.undefinedExports.size > 0) for (let [F, Y] of Array.from(this.scope.undefinedExports)) this.raise(Se.ModuleExportUndefined, Y, { localName: F });
          let T;
          return p === 139 ? T = this.finishNode(y, "Program") : T = this.finishNodeAt(y, "Program", dt(this.state.startLoc, -1)), T;
        }
        stmtToDirective(y) {
          let p = y;
          p.type = "Directive", p.value = p.expression, delete p.expression;
          let b = p.value, T = b.value, F = this.input.slice(b.start, b.end), Y = b.value = F.slice(1, -1);
          return this.addExtra(b, "raw", F), this.addExtra(b, "rawValue", Y), this.addExtra(b, "expressionValue", T), b.type = "DirectiveLiteral", p;
        }
        parseInterpreterDirective() {
          if (!this.match(28)) return null;
          let y = this.startNode();
          return y.value = this.state.value, this.next(), this.finishNode(y, "InterpreterDirective");
        }
        isLet() {
          return this.isContextual(100) ? this.hasFollowingBindingAtom() : !1;
        }
        chStartsBindingIdentifier(y, p) {
          if (Xi(y)) {
            if (zu.lastIndex = p, zu.test(this.input)) {
              let b = this.codePointAtPos(zu.lastIndex);
              if (!rl(b) && b !== 92) return !1;
            }
            return !0;
          } else return y === 92;
        }
        chStartsBindingPattern(y) {
          return y === 91 || y === 123;
        }
        hasFollowingBindingAtom() {
          let y = this.nextTokenStart(), p = this.codePointAtPos(y);
          return this.chStartsBindingPattern(p) || this.chStartsBindingIdentifier(p, y);
        }
        hasInLineFollowingBindingIdentifierOrBrace() {
          let y = this.nextTokenInLineStart(), p = this.codePointAtPos(y);
          return p === 123 || this.chStartsBindingIdentifier(p, y);
        }
        startsUsingForOf() {
          let { type: y, containsEsc: p } = this.lookahead();
          if (y === 102 && !p) return !1;
          if (Qt(y) && !this.hasFollowingLineBreak()) return this.expectPlugin("explicitResourceManagement"), !0;
        }
        startsAwaitUsing() {
          let y = this.nextTokenInLineStart();
          if (this.isUnparsedContextual(y, "using")) {
            y = this.nextTokenInLineStartSince(y + 5);
            let p = this.codePointAtPos(y);
            if (this.chStartsBindingIdentifier(p, y)) return this.expectPlugin("explicitResourceManagement"), !0;
          }
          return !1;
        }
        parseModuleItem() {
          return this.parseStatementLike(15);
        }
        parseStatementListItem() {
          return this.parseStatementLike(6 | (!this.options.annexB || this.state.strict ? 0 : 8));
        }
        parseStatementOrSloppyAnnexBFunctionDeclaration(y = !1) {
          let p = 0;
          return this.options.annexB && !this.state.strict && (p |= 4, y && (p |= 8)), this.parseStatementLike(p);
        }
        parseStatement() {
          return this.parseStatementLike(0);
        }
        parseStatementLike(y) {
          let p = null;
          return this.match(26) && (p = this.parseDecorators(!0)), this.parseStatementContent(y, p);
        }
        parseStatementContent(y, p) {
          let b = this.state.type, T = this.startNode(), F = !!(y & 2), Y = !!(y & 4), ie = y & 1;
          switch (b) {
            case 60:
              return this.parseBreakContinueStatement(T, !0);
            case 63:
              return this.parseBreakContinueStatement(T, !1);
            case 64:
              return this.parseDebuggerStatement(T);
            case 90:
              return this.parseDoWhileStatement(T);
            case 91:
              return this.parseForStatement(T);
            case 68:
              if (this.lookaheadCharCode() === 46) break;
              return Y || this.raise(this.state.strict ? Se.StrictFunction : this.options.annexB ? Se.SloppyFunctionAnnexB : Se.SloppyFunction, this.state.startLoc), this.parseFunctionStatement(T, !1, !F && Y);
            case 80:
              return F || this.unexpected(), this.parseClass(this.maybeTakeDecorators(p, T), !0);
            case 69:
              return this.parseIfStatement(T);
            case 70:
              return this.parseReturnStatement(T);
            case 71:
              return this.parseSwitchStatement(T);
            case 72:
              return this.parseThrowStatement(T);
            case 73:
              return this.parseTryStatement(T);
            case 96:
              if (!this.state.containsEsc && this.startsAwaitUsing()) return this.isAwaitAllowed() ? F || this.raise(Se.UnexpectedLexicalDeclaration, T) : this.raise(Se.AwaitUsingNotInAsyncContext, T), this.next(), this.parseVarStatement(T, "await using");
              break;
            case 107:
              if (this.state.containsEsc || !this.hasInLineFollowingBindingIdentifierOrBrace()) break;
              return this.expectPlugin("explicitResourceManagement"), !this.scope.inModule && this.scope.inTopLevel ? this.raise(Se.UnexpectedUsingDeclaration, this.state.startLoc) : F || this.raise(Se.UnexpectedLexicalDeclaration, this.state.startLoc), this.parseVarStatement(T, "using");
            case 100: {
              if (this.state.containsEsc) break;
              let fe = this.nextTokenStart(), Ze = this.codePointAtPos(fe);
              if (Ze !== 91 && (!F && this.hasFollowingLineBreak() || !this.chStartsBindingIdentifier(Ze, fe) && Ze !== 123)) break;
            }
            case 75:
              F || this.raise(Se.UnexpectedLexicalDeclaration, this.state.startLoc);
            case 74: {
              let fe = this.state.value;
              return this.parseVarStatement(T, fe);
            }
            case 92:
              return this.parseWhileStatement(T);
            case 76:
              return this.parseWithStatement(T);
            case 5:
              return this.parseBlock();
            case 13:
              return this.parseEmptyStatement(T);
            case 83: {
              let fe = this.lookaheadCharCode();
              if (fe === 40 || fe === 46) break;
            }
            case 82: {
              !this.options.allowImportExportEverywhere && !ie && this.raise(Se.UnexpectedImportExport, this.state.startLoc), this.next();
              let fe;
              return b === 83 ? (fe = this.parseImport(T), fe.type === "ImportDeclaration" && (!fe.importKind || fe.importKind === "value") && (this.sawUnambiguousESM = !0)) : (fe = this.parseExport(T, p), (fe.type === "ExportNamedDeclaration" && (!fe.exportKind || fe.exportKind === "value") || fe.type === "ExportAllDeclaration" && (!fe.exportKind || fe.exportKind === "value") || fe.type === "ExportDefaultDeclaration") && (this.sawUnambiguousESM = !0)), this.assertModuleNodeAllowed(fe), fe;
            }
            default:
              if (this.isAsyncFunction()) return F || this.raise(Se.AsyncFunctionInSingleStatementContext, this.state.startLoc), this.next(), this.parseFunctionStatement(T, !0, !F && Y);
          }
          let de = this.state.value, he = this.parseExpression();
          return Qt(b) && he.type === "Identifier" && this.eat(14) ? this.parseLabeledStatement(T, de, he, y) : this.parseExpressionStatement(T, he, p);
        }
        assertModuleNodeAllowed(y) {
          !this.options.allowImportExportEverywhere && !this.inModule && this.raise(Se.ImportOutsideModule, y);
        }
        decoratorsEnabledBeforeExport() {
          return this.hasPlugin("decorators-legacy") ? !0 : this.hasPlugin("decorators") && this.getPluginOption("decorators", "decoratorsBeforeExport") !== !1;
        }
        maybeTakeDecorators(y, p, b) {
          return y && (p.decorators && p.decorators.length > 0 ? (typeof this.getPluginOption("decorators", "decoratorsBeforeExport") != "boolean" && this.raise(Se.DecoratorsBeforeAfterExport, p.decorators[0]), p.decorators.unshift(...y)) : p.decorators = y, this.resetStartLocationFromNode(p, y[0]), b && this.resetStartLocationFromNode(b, p)), p;
        }
        canHaveLeadingDecorator() {
          return this.match(80);
        }
        parseDecorators(y) {
          let p = [];
          do
            p.push(this.parseDecorator());
          while (this.match(26));
          if (this.match(82)) y || this.unexpected(), this.decoratorsEnabledBeforeExport() || this.raise(Se.DecoratorExportClass, this.state.startLoc);
          else if (!this.canHaveLeadingDecorator()) throw this.raise(Se.UnexpectedLeadingDecorator, this.state.startLoc);
          return p;
        }
        parseDecorator() {
          this.expectOnePlugin(["decorators", "decorators-legacy"]);
          let y = this.startNode();
          if (this.next(), this.hasPlugin("decorators")) {
            let p = this.state.startLoc, b;
            if (this.match(10)) {
              let T = this.state.startLoc;
              this.next(), b = this.parseExpression(), this.expect(11), b = this.wrapParenthesis(T, b);
              let F = this.state.startLoc;
              y.expression = this.parseMaybeDecoratorArguments(b), this.getPluginOption("decorators", "allowCallParenthesized") === !1 && y.expression !== b && this.raise(Se.DecoratorArgumentsOutsideParentheses, F);
            } else {
              for (b = this.parseIdentifier(!1); this.eat(16); ) {
                let T = this.startNodeAt(p);
                T.object = b, this.match(138) ? (this.classScope.usePrivateName(this.state.value, this.state.startLoc), T.property = this.parsePrivateName()) : T.property = this.parseIdentifier(!0), T.computed = !1, b = this.finishNode(T, "MemberExpression");
              }
              y.expression = this.parseMaybeDecoratorArguments(b);
            }
          } else y.expression = this.parseExprSubscripts();
          return this.finishNode(y, "Decorator");
        }
        parseMaybeDecoratorArguments(y) {
          if (this.eat(10)) {
            let p = this.startNodeAtNode(y);
            return p.callee = y, p.arguments = this.parseCallExpressionArguments(11, !1), this.toReferencedList(p.arguments), this.finishNode(p, "CallExpression");
          }
          return y;
        }
        parseBreakContinueStatement(y, p) {
          return this.next(), this.isLineTerminator() ? y.label = null : (y.label = this.parseIdentifier(), this.semicolon()), this.verifyBreakContinue(y, p), this.finishNode(y, p ? "BreakStatement" : "ContinueStatement");
        }
        verifyBreakContinue(y, p) {
          let b;
          for (b = 0; b < this.state.labels.length; ++b) {
            let T = this.state.labels[b];
            if ((y.label == null || T.name === y.label.name) && (T.kind != null && (p || T.kind === 1) || y.label && p)) break;
          }
          if (b === this.state.labels.length) {
            let T = p ? "BreakStatement" : "ContinueStatement";
            this.raise(Se.IllegalBreakContinue, y, { type: T });
          }
        }
        parseDebuggerStatement(y) {
          return this.next(), this.semicolon(), this.finishNode(y, "DebuggerStatement");
        }
        parseHeaderExpression() {
          this.expect(10);
          let y = this.parseExpression();
          return this.expect(11), y;
        }
        parseDoWhileStatement(y) {
          return this.next(), this.state.labels.push(Zd), y.body = this.withSmartMixTopicForbiddingContext(() => this.parseStatement()), this.state.labels.pop(), this.expect(92), y.test = this.parseHeaderExpression(), this.eat(13), this.finishNode(y, "DoWhileStatement");
        }
        parseForStatement(y) {
          this.next(), this.state.labels.push(Zd);
          let p = null;
          if (this.isAwaitAllowed() && this.eatContextual(96) && (p = this.state.lastTokStartLoc), this.scope.enter(0), this.expect(10), this.match(13)) return p !== null && this.unexpected(p), this.parseFor(y, null);
          let b = this.isContextual(100);
          {
            let de = this.isContextual(96) && this.startsAwaitUsing(), he = de || this.isContextual(107) && this.startsUsingForOf(), fe = b && this.hasFollowingBindingAtom() || he;
            if (this.match(74) || this.match(75) || fe) {
              let Ze = this.startNode(), Dt;
              de ? (Dt = "await using", this.isAwaitAllowed() || this.raise(Se.AwaitUsingNotInAsyncContext, this.state.startLoc), this.next()) : Dt = this.state.value, this.next(), this.parseVar(Ze, !0, Dt);
              let $t = this.finishNode(Ze, "VariableDeclaration"), It = this.match(58);
              return It && he && this.raise(Se.ForInUsing, $t), (It || this.isContextual(102)) && $t.declarations.length === 1 ? this.parseForIn(y, $t, p) : (p !== null && this.unexpected(p), this.parseFor(y, $t));
            }
          }
          let T = this.isContextual(95), F = new _t(), Y = this.parseExpression(!0, F), ie = this.isContextual(102);
          if (ie && (b && this.raise(Se.ForOfLet, Y), p === null && T && Y.type === "Identifier" && this.raise(Se.ForOfAsync, Y)), ie || this.match(58)) {
            this.checkDestructuringPrivate(F), this.toAssignable(Y, !0);
            let de = ie ? "ForOfStatement" : "ForInStatement";
            return this.checkLVal(Y, { in: { type: de } }), this.parseForIn(y, Y, p);
          } else this.checkExpressionErrors(F, !0);
          return p !== null && this.unexpected(p), this.parseFor(y, Y);
        }
        parseFunctionStatement(y, p, b) {
          return this.next(), this.parseFunction(y, 1 | (b ? 2 : 0) | (p ? 8 : 0));
        }
        parseIfStatement(y) {
          return this.next(), y.test = this.parseHeaderExpression(), y.consequent = this.parseStatementOrSloppyAnnexBFunctionDeclaration(), y.alternate = this.eat(66) ? this.parseStatementOrSloppyAnnexBFunctionDeclaration() : null, this.finishNode(y, "IfStatement");
        }
        parseReturnStatement(y) {
          return !this.prodParam.hasReturn && !this.options.allowReturnOutsideFunction && this.raise(Se.IllegalReturn, this.state.startLoc), this.next(), this.isLineTerminator() ? y.argument = null : (y.argument = this.parseExpression(), this.semicolon()), this.finishNode(y, "ReturnStatement");
        }
        parseSwitchStatement(y) {
          this.next(), y.discriminant = this.parseHeaderExpression();
          let p = y.cases = [];
          this.expect(5), this.state.labels.push(Mc), this.scope.enter(0);
          let b;
          for (let T; !this.match(8); ) if (this.match(61) || this.match(65)) {
            let F = this.match(61);
            b && this.finishNode(b, "SwitchCase"), p.push(b = this.startNode()), b.consequent = [], this.next(), F ? b.test = this.parseExpression() : (T && this.raise(Se.MultipleDefaultsInSwitch, this.state.lastTokStartLoc), T = !0, b.test = null), this.expect(14);
          } else b ? b.consequent.push(this.parseStatementListItem()) : this.unexpected();
          return this.scope.exit(), b && this.finishNode(b, "SwitchCase"), this.next(), this.state.labels.pop(), this.finishNode(y, "SwitchStatement");
        }
        parseThrowStatement(y) {
          return this.next(), this.hasPrecedingLineBreak() && this.raise(Se.NewlineAfterThrow, this.state.lastTokEndLoc), y.argument = this.parseExpression(), this.semicolon(), this.finishNode(y, "ThrowStatement");
        }
        parseCatchClauseParam() {
          let y = this.parseBindingAtom();
          return this.scope.enter(this.options.annexB && y.type === "Identifier" ? 8 : 0), this.checkLVal(y, { in: { type: "CatchClause" }, binding: 9 }), y;
        }
        parseTryStatement(y) {
          if (this.next(), y.block = this.parseBlock(), y.handler = null, this.match(62)) {
            let p = this.startNode();
            this.next(), this.match(10) ? (this.expect(10), p.param = this.parseCatchClauseParam(), this.expect(11)) : (p.param = null, this.scope.enter(0)), p.body = this.withSmartMixTopicForbiddingContext(() => this.parseBlock(!1, !1)), this.scope.exit(), y.handler = this.finishNode(p, "CatchClause");
          }
          return y.finalizer = this.eat(67) ? this.parseBlock() : null, !y.handler && !y.finalizer && this.raise(Se.NoCatchOrFinally, y), this.finishNode(y, "TryStatement");
        }
        parseVarStatement(y, p, b = !1) {
          return this.next(), this.parseVar(y, !1, p, b), this.semicolon(), this.finishNode(y, "VariableDeclaration");
        }
        parseWhileStatement(y) {
          return this.next(), y.test = this.parseHeaderExpression(), this.state.labels.push(Zd), y.body = this.withSmartMixTopicForbiddingContext(() => this.parseStatement()), this.state.labels.pop(), this.finishNode(y, "WhileStatement");
        }
        parseWithStatement(y) {
          return this.state.strict && this.raise(Se.StrictWith, this.state.startLoc), this.next(), y.object = this.parseHeaderExpression(), y.body = this.withSmartMixTopicForbiddingContext(() => this.parseStatement()), this.finishNode(y, "WithStatement");
        }
        parseEmptyStatement(y) {
          return this.next(), this.finishNode(y, "EmptyStatement");
        }
        parseLabeledStatement(y, p, b, T) {
          for (let Y of this.state.labels) Y.name === p && this.raise(Se.LabelRedeclaration, b, { labelName: p });
          let F = Lv(this.state.type) ? 1 : this.match(71) ? 2 : null;
          for (let Y = this.state.labels.length - 1; Y >= 0; Y--) {
            let ie = this.state.labels[Y];
            if (ie.statementStart === y.start) ie.statementStart = this.state.start, ie.kind = F;
            else break;
          }
          return this.state.labels.push({ name: p, kind: F, statementStart: this.state.start }), y.body = T & 8 ? this.parseStatementOrSloppyAnnexBFunctionDeclaration(!0) : this.parseStatement(), this.state.labels.pop(), y.label = b, this.finishNode(y, "LabeledStatement");
        }
        parseExpressionStatement(y, p, b) {
          return y.expression = p, this.semicolon(), this.finishNode(y, "ExpressionStatement");
        }
        parseBlock(y = !1, p = !0, b) {
          let T = this.startNode();
          return y && this.state.strictErrors.clear(), this.expect(5), p && this.scope.enter(0), this.parseBlockBody(T, y, !1, 8, b), p && this.scope.exit(), this.finishNode(T, "BlockStatement");
        }
        isValidDirective(y) {
          return y.type === "ExpressionStatement" && y.expression.type === "StringLiteral" && !y.expression.extra.parenthesized;
        }
        parseBlockBody(y, p, b, T, F) {
          let Y = y.body = [], ie = y.directives = [];
          this.parseBlockOrModuleBlockBody(Y, p ? ie : void 0, b, T, F);
        }
        parseBlockOrModuleBlockBody(y, p, b, T, F) {
          let Y = this.state.strict, ie = !1, de = !1;
          for (; !this.match(T); ) {
            let he = b ? this.parseModuleItem() : this.parseStatementListItem();
            if (p && !de) {
              if (this.isValidDirective(he)) {
                let fe = this.stmtToDirective(he);
                p.push(fe), !ie && fe.value.value === "use strict" && (ie = !0, this.setStrict(!0));
                continue;
              }
              de = !0, this.state.strictErrors.clear();
            }
            y.push(he);
          }
          F == null || F.call(this, ie), Y || this.setStrict(!1), this.next();
        }
        parseFor(y, p) {
          return y.init = p, this.semicolon(!1), y.test = this.match(13) ? null : this.parseExpression(), this.semicolon(!1), y.update = this.match(11) ? null : this.parseExpression(), this.expect(11), y.body = this.withSmartMixTopicForbiddingContext(() => this.parseStatement()), this.scope.exit(), this.state.labels.pop(), this.finishNode(y, "ForStatement");
        }
        parseForIn(y, p, b) {
          let T = this.match(58);
          return this.next(), T ? b !== null && this.unexpected(b) : y.await = b !== null, p.type === "VariableDeclaration" && p.declarations[0].init != null && (!T || !this.options.annexB || this.state.strict || p.kind !== "var" || p.declarations[0].id.type !== "Identifier") && this.raise(Se.ForInOfLoopInitializer, p, { type: T ? "ForInStatement" : "ForOfStatement" }), p.type === "AssignmentPattern" && this.raise(Se.InvalidLhs, p, { ancestor: { type: "ForStatement" } }), y.left = p, y.right = T ? this.parseExpression() : this.parseMaybeAssignAllowIn(), this.expect(11), y.body = this.withSmartMixTopicForbiddingContext(() => this.parseStatement()), this.scope.exit(), this.state.labels.pop(), this.finishNode(y, T ? "ForInStatement" : "ForOfStatement");
        }
        parseVar(y, p, b, T = !1) {
          let F = y.declarations = [];
          for (y.kind = b; ; ) {
            let Y = this.startNode();
            if (this.parseVarId(Y, b), Y.init = this.eat(29) ? p ? this.parseMaybeAssignDisallowIn() : this.parseMaybeAssignAllowIn() : null, Y.init === null && !T && (Y.id.type !== "Identifier" && !(p && (this.match(58) || this.isContextual(102))) ? this.raise(Se.DeclarationMissingInitializer, this.state.lastTokEndLoc, { kind: "destructuring" }) : (b === "const" || b === "using" || b === "await using") && !(this.match(58) || this.isContextual(102)) && this.raise(Se.DeclarationMissingInitializer, this.state.lastTokEndLoc, { kind: b })), F.push(this.finishNode(Y, "VariableDeclarator")), !this.eat(12)) break;
          }
          return y;
        }
        parseVarId(y, p) {
          let b = this.parseBindingAtom();
          (p === "using" || p === "await using") && (b.type === "ArrayPattern" || b.type === "ObjectPattern") && this.raise(Se.UsingDeclarationHasBindingPattern, b.loc.start), this.checkLVal(b, { in: { type: "VariableDeclarator" }, binding: p === "var" ? 5 : 8201 }), y.id = b;
        }
        parseAsyncFunctionExpression(y) {
          return this.parseFunction(y, 8);
        }
        parseFunction(y, p = 0) {
          let b = p & 2, T = !!(p & 1), F = T && !(p & 4), Y = !!(p & 8);
          this.initFunction(y, Y), this.match(55) && (b && this.raise(Se.GeneratorInSingleStatementContext, this.state.startLoc), this.next(), y.generator = !0), T && (y.id = this.parseFunctionId(F));
          let ie = this.state.maybeInArrowParameters;
          return this.state.maybeInArrowParameters = !1, this.scope.enter(2), this.prodParam.enter(Ye(Y, y.generator)), T || (y.id = this.parseFunctionId()), this.parseFunctionParams(y, !1), this.withSmartMixTopicForbiddingContext(() => {
            this.parseFunctionBodyAndFinish(y, T ? "FunctionDeclaration" : "FunctionExpression");
          }), this.prodParam.exit(), this.scope.exit(), T && !b && this.registerFunctionStatementId(y), this.state.maybeInArrowParameters = ie, y;
        }
        parseFunctionId(y) {
          return y || Qt(this.state.type) ? this.parseIdentifier() : null;
        }
        parseFunctionParams(y, p) {
          this.expect(10), this.expressionScope.enter(nS()), y.params = this.parseBindingList(11, 41, 2 | (p ? 4 : 0)), this.expressionScope.exit();
        }
        registerFunctionStatementId(y) {
          y.id && this.scope.declareName(y.id.name, !this.options.annexB || this.state.strict || y.generator || y.async ? this.scope.treatFunctionsAsVar ? 5 : 8201 : 17, y.id.loc.start);
        }
        parseClass(y, p, b) {
          this.next();
          let T = this.state.strict;
          return this.state.strict = !0, this.parseClassId(y, p, b), this.parseClassSuper(y), y.body = this.parseClassBody(!!y.superClass, T), this.finishNode(y, p ? "ClassDeclaration" : "ClassExpression");
        }
        isClassProperty() {
          return this.match(29) || this.match(13) || this.match(8);
        }
        isClassMethod() {
          return this.match(10);
        }
        nameIsConstructor(y) {
          return y.type === "Identifier" && y.name === "constructor" || y.type === "StringLiteral" && y.value === "constructor";
        }
        isNonstaticConstructor(y) {
          return !y.computed && !y.static && this.nameIsConstructor(y.key);
        }
        parseClassBody(y, p) {
          this.classScope.enter();
          let b = { hadConstructor: !1, hadSuperClass: y }, T = [], F = this.startNode();
          if (F.body = [], this.expect(5), this.withSmartMixTopicForbiddingContext(() => {
            for (; !this.match(8); ) {
              if (this.eat(13)) {
                if (T.length > 0) throw this.raise(Se.DecoratorSemicolon, this.state.lastTokEndLoc);
                continue;
              }
              if (this.match(26)) {
                T.push(this.parseDecorator());
                continue;
              }
              let Y = this.startNode();
              T.length && (Y.decorators = T, this.resetStartLocationFromNode(Y, T[0]), T = []), this.parseClassMember(F, Y, b), Y.kind === "constructor" && Y.decorators && Y.decorators.length > 0 && this.raise(Se.DecoratorConstructor, Y);
            }
          }), this.state.strict = p, this.next(), T.length) throw this.raise(Se.TrailingDecorator, this.state.startLoc);
          return this.classScope.exit(), this.finishNode(F, "ClassBody");
        }
        parseClassMemberFromModifier(y, p) {
          let b = this.parseIdentifier(!0);
          if (this.isClassMethod()) {
            let T = p;
            return T.kind = "method", T.computed = !1, T.key = b, T.static = !1, this.pushClassMethod(y, T, !1, !1, !1, !1), !0;
          } else if (this.isClassProperty()) {
            let T = p;
            return T.computed = !1, T.key = b, T.static = !1, y.body.push(this.parseClassProperty(T)), !0;
          }
          return this.resetPreviousNodeTrailingComments(b), !1;
        }
        parseClassMember(y, p, b) {
          let T = this.isContextual(106);
          if (T) {
            if (this.parseClassMemberFromModifier(y, p)) return;
            if (this.eat(5)) {
              this.parseClassStaticBlock(y, p);
              return;
            }
          }
          this.parseClassMemberWithIsStatic(y, p, b, T);
        }
        parseClassMemberWithIsStatic(y, p, b, T) {
          let F = p, Y = p, ie = p, de = p, he = p, fe = F, Ze = F;
          if (p.static = T, this.parsePropertyNamePrefixOperator(p), this.eat(55)) {
            fe.kind = "method";
            let Sr = this.match(138);
            if (this.parseClassElementName(fe), Sr) {
              this.pushClassPrivateMethod(y, Y, !0, !1);
              return;
            }
            this.isNonstaticConstructor(F) && this.raise(Se.ConstructorIsGenerator, F.key), this.pushClassMethod(y, F, !0, !1, !1, !1);
            return;
          }
          let Dt = !this.state.containsEsc && Qt(this.state.type), $t = this.parseClassElementName(p), It = Dt ? $t.name : null, nr = this.isPrivateName($t), Di = this.state.startLoc;
          if (this.parsePostMemberNameModifiers(Ze), this.isClassMethod()) {
            if (fe.kind = "method", nr) {
              this.pushClassPrivateMethod(y, Y, !1, !1);
              return;
            }
            let Sr = this.isNonstaticConstructor(F), ii = !1;
            Sr && (F.kind = "constructor", b.hadConstructor && !this.hasPlugin("typescript") && this.raise(Se.DuplicateConstructor, $t), Sr && this.hasPlugin("typescript") && p.override && this.raise(Se.OverrideOnConstructor, $t), b.hadConstructor = !0, ii = b.hadSuperClass), this.pushClassMethod(y, F, !1, !1, Sr, ii);
          } else if (this.isClassProperty()) nr ? this.pushClassPrivateProperty(y, de) : this.pushClassProperty(y, ie);
          else if (It === "async" && !this.isLineTerminator()) {
            this.resetPreviousNodeTrailingComments($t);
            let Sr = this.eat(55);
            Ze.optional && this.unexpected(Di), fe.kind = "method";
            let ii = this.match(138);
            this.parseClassElementName(fe), this.parsePostMemberNameModifiers(Ze), ii ? this.pushClassPrivateMethod(y, Y, Sr, !0) : (this.isNonstaticConstructor(F) && this.raise(Se.ConstructorIsAsync, F.key), this.pushClassMethod(y, F, Sr, !0, !1, !1));
          } else if ((It === "get" || It === "set") && !(this.match(55) && this.isLineTerminator())) {
            this.resetPreviousNodeTrailingComments($t), fe.kind = It;
            let Sr = this.match(138);
            this.parseClassElementName(F), Sr ? this.pushClassPrivateMethod(y, Y, !1, !1) : (this.isNonstaticConstructor(F) && this.raise(Se.ConstructorIsAccessor, F.key), this.pushClassMethod(y, F, !1, !1, !1, !1)), this.checkGetterSetterParams(F);
          } else if (It === "accessor" && !this.isLineTerminator()) {
            this.expectPlugin("decoratorAutoAccessors"), this.resetPreviousNodeTrailingComments($t);
            let Sr = this.match(138);
            this.parseClassElementName(ie), this.pushClassAccessorProperty(y, he, Sr);
          } else this.isLineTerminator() ? nr ? this.pushClassPrivateProperty(y, de) : this.pushClassProperty(y, ie) : this.unexpected();
        }
        parseClassElementName(y) {
          let { type: p, value: b } = this.state;
          if ((p === 132 || p === 133) && y.static && b === "prototype" && this.raise(Se.StaticPrototype, this.state.startLoc), p === 138) {
            b === "constructor" && this.raise(Se.ConstructorClassPrivateField, this.state.startLoc);
            let T = this.parsePrivateName();
            return y.key = T, T;
          }
          return this.parsePropertyName(y), y.key;
        }
        parseClassStaticBlock(y, p) {
          var b;
          this.scope.enter(208);
          let T = this.state.labels;
          this.state.labels = [], this.prodParam.enter(0);
          let F = p.body = [];
          this.parseBlockOrModuleBlockBody(F, void 0, !1, 8), this.prodParam.exit(), this.scope.exit(), this.state.labels = T, y.body.push(this.finishNode(p, "StaticBlock")), (b = p.decorators) != null && b.length && this.raise(Se.DecoratorStaticBlock, p);
        }
        pushClassProperty(y, p) {
          !p.computed && this.nameIsConstructor(p.key) && this.raise(Se.ConstructorClassField, p.key), y.body.push(this.parseClassProperty(p));
        }
        pushClassPrivateProperty(y, p) {
          let b = this.parseClassPrivateProperty(p);
          y.body.push(b), this.classScope.declarePrivateName(this.getPrivateNameSV(b.key), 0, b.key.loc.start);
        }
        pushClassAccessorProperty(y, p, b) {
          !b && !p.computed && this.nameIsConstructor(p.key) && this.raise(Se.ConstructorClassField, p.key);
          let T = this.parseClassAccessorProperty(p);
          y.body.push(T), b && this.classScope.declarePrivateName(this.getPrivateNameSV(T.key), 0, T.key.loc.start);
        }
        pushClassMethod(y, p, b, T, F, Y) {
          y.body.push(this.parseMethod(p, b, T, F, Y, "ClassMethod", !0));
        }
        pushClassPrivateMethod(y, p, b, T) {
          let F = this.parseMethod(p, b, T, !1, !1, "ClassPrivateMethod", !0);
          y.body.push(F);
          let Y = F.kind === "get" ? F.static ? 6 : 2 : F.kind === "set" ? F.static ? 5 : 1 : 0;
          this.declareClassPrivateMethodInScope(F, Y);
        }
        declareClassPrivateMethodInScope(y, p) {
          this.classScope.declarePrivateName(this.getPrivateNameSV(y.key), p, y.key.loc.start);
        }
        parsePostMemberNameModifiers(y) {
        }
        parseClassPrivateProperty(y) {
          return this.parseInitializer(y), this.semicolon(), this.finishNode(y, "ClassPrivateProperty");
        }
        parseClassProperty(y) {
          return this.parseInitializer(y), this.semicolon(), this.finishNode(y, "ClassProperty");
        }
        parseClassAccessorProperty(y) {
          return this.parseInitializer(y), this.semicolon(), this.finishNode(y, "ClassAccessorProperty");
        }
        parseInitializer(y) {
          this.scope.enter(80), this.expressionScope.enter(Lu()), this.prodParam.enter(0), y.value = this.eat(29) ? this.parseMaybeAssignAllowIn() : null, this.expressionScope.exit(), this.prodParam.exit(), this.scope.exit();
        }
        parseClassId(y, p, b, T = 8331) {
          if (Qt(this.state.type)) y.id = this.parseIdentifier(), p && this.declareNameFromIdentifier(y.id, T);
          else if (b || !p) y.id = null;
          else throw this.raise(Se.MissingClassName, this.state.startLoc);
        }
        parseClassSuper(y) {
          y.superClass = this.eat(81) ? this.parseExprSubscripts() : null;
        }
        parseExport(y, p) {
          let b = this.parseMaybeImportPhase(y, !0), T = this.maybeParseExportDefaultSpecifier(y, b), F = !T || this.eat(12), Y = F && this.eatExportStar(y), ie = Y && this.maybeParseExportNamespaceSpecifier(y), de = F && (!ie || this.eat(12)), he = T || Y;
          if (Y && !ie) {
            if (T && this.unexpected(), p) throw this.raise(Se.UnsupportedDecoratorExport, y);
            return this.parseExportFrom(y, !0), this.finishNode(y, "ExportAllDeclaration");
          }
          let fe = this.maybeParseExportNamedSpecifiers(y);
          T && F && !Y && !fe && this.unexpected(null, 5), ie && de && this.unexpected(null, 98);
          let Ze;
          if (he || fe) {
            if (Ze = !1, p) throw this.raise(Se.UnsupportedDecoratorExport, y);
            this.parseExportFrom(y, he);
          } else Ze = this.maybeParseExportDeclaration(y);
          if (he || fe || Ze) {
            var Dt;
            let $t = y;
            if (this.checkExport($t, !0, !1, !!$t.source), ((Dt = $t.declaration) == null ? void 0 : Dt.type) === "ClassDeclaration") this.maybeTakeDecorators(p, $t.declaration, $t);
            else if (p) throw this.raise(Se.UnsupportedDecoratorExport, y);
            return this.finishNode($t, "ExportNamedDeclaration");
          }
          if (this.eat(65)) {
            let $t = y, It = this.parseExportDefaultExpression();
            if ($t.declaration = It, It.type === "ClassDeclaration") this.maybeTakeDecorators(p, It, $t);
            else if (p) throw this.raise(Se.UnsupportedDecoratorExport, y);
            return this.checkExport($t, !0, !0), this.finishNode($t, "ExportDefaultDeclaration");
          }
          this.unexpected(null, 5);
        }
        eatExportStar(y) {
          return this.eat(55);
        }
        maybeParseExportDefaultSpecifier(y, p) {
          if (p || this.isExportDefaultSpecifier()) {
            this.expectPlugin("exportDefaultFrom", p == null ? void 0 : p.loc.start);
            let b = p || this.parseIdentifier(!0), T = this.startNodeAtNode(b);
            return T.exported = b, y.specifiers = [this.finishNode(T, "ExportDefaultSpecifier")], !0;
          }
          return !1;
        }
        maybeParseExportNamespaceSpecifier(y) {
          if (this.isContextual(93)) {
            var p;
            (p = y).specifiers != null || (p.specifiers = []);
            let b = this.startNodeAt(this.state.lastTokStartLoc);
            return this.next(), b.exported = this.parseModuleExportName(), y.specifiers.push(this.finishNode(b, "ExportNamespaceSpecifier")), !0;
          }
          return !1;
        }
        maybeParseExportNamedSpecifiers(y) {
          if (this.match(5)) {
            let p = y;
            p.specifiers || (p.specifiers = []);
            let b = p.exportKind === "type";
            return p.specifiers.push(...this.parseExportSpecifiers(b)), p.source = null, p.declaration = null, this.hasPlugin("importAssertions") && (p.assertions = []), !0;
          }
          return !1;
        }
        maybeParseExportDeclaration(y) {
          return this.shouldParseExportDeclaration() ? (y.specifiers = [], y.source = null, this.hasPlugin("importAssertions") && (y.assertions = []), y.declaration = this.parseExportDeclaration(y), !0) : !1;
        }
        isAsyncFunction() {
          if (!this.isContextual(95)) return !1;
          let y = this.nextTokenInLineStart();
          return this.isUnparsedContextual(y, "function");
        }
        parseExportDefaultExpression() {
          let y = this.startNode();
          if (this.match(68)) return this.next(), this.parseFunction(y, 5);
          if (this.isAsyncFunction()) return this.next(), this.next(), this.parseFunction(y, 13);
          if (this.match(80)) return this.parseClass(y, !0, !0);
          if (this.match(26)) return this.hasPlugin("decorators") && this.getPluginOption("decorators", "decoratorsBeforeExport") === !0 && this.raise(Se.DecoratorBeforeExport, this.state.startLoc), this.parseClass(this.maybeTakeDecorators(this.parseDecorators(!1), this.startNode()), !0, !0);
          if (this.match(75) || this.match(74) || this.isLet()) throw this.raise(Se.UnsupportedDefaultExport, this.state.startLoc);
          let p = this.parseMaybeAssignAllowIn();
          return this.semicolon(), p;
        }
        parseExportDeclaration(y) {
          return this.match(80) ? this.parseClass(this.startNode(), !0, !1) : this.parseStatementListItem();
        }
        isExportDefaultSpecifier() {
          let { type: y } = this.state;
          if (Qt(y)) {
            if (y === 95 && !this.state.containsEsc || y === 100) return !1;
            if ((y === 130 || y === 129) && !this.state.containsEsc) {
              let { type: T } = this.lookahead();
              if (Qt(T) && T !== 98 || T === 5) return this.expectOnePlugin(["flow", "typescript"]), !1;
            }
          } else if (!this.match(65)) return !1;
          let p = this.nextTokenStart(), b = this.isUnparsedContextual(p, "from");
          if (this.input.charCodeAt(p) === 44 || Qt(this.state.type) && b) return !0;
          if (this.match(65) && b) {
            let T = this.input.charCodeAt(this.nextTokenStartSince(p + 4));
            return T === 34 || T === 39;
          }
          return !1;
        }
        parseExportFrom(y, p) {
          this.eatContextual(98) ? (y.source = this.parseImportSource(), this.checkExport(y), this.maybeParseImportAttributes(y), this.checkJSONModuleImport(y)) : p && this.unexpected(), this.semicolon();
        }
        shouldParseExportDeclaration() {
          let { type: y } = this.state;
          return y === 26 && (this.expectOnePlugin(["decorators", "decorators-legacy"]), this.hasPlugin("decorators")) ? (this.getPluginOption("decorators", "decoratorsBeforeExport") === !0 && this.raise(Se.DecoratorBeforeExport, this.state.startLoc), !0) : this.isContextual(107) ? (this.raise(Se.UsingDeclarationExport, this.state.startLoc), !0) : this.isContextual(96) && this.startsAwaitUsing() ? (this.raise(Se.UsingDeclarationExport, this.state.startLoc), !0) : y === 74 || y === 75 || y === 68 || y === 80 || this.isLet() || this.isAsyncFunction();
        }
        checkExport(y, p, b, T) {
          if (p) {
            var F;
            if (b) {
              if (this.checkDuplicateExports(y, "default"), this.hasPlugin("exportDefaultFrom")) {
                var Y;
                let ie = y.declaration;
                ie.type === "Identifier" && ie.name === "from" && ie.end - ie.start === 4 && !((Y = ie.extra) != null && Y.parenthesized) && this.raise(Se.ExportDefaultFromAsIdentifier, ie);
              }
            } else if ((F = y.specifiers) != null && F.length) for (let ie of y.specifiers) {
              let { exported: de } = ie, he = de.type === "Identifier" ? de.name : de.value;
              if (this.checkDuplicateExports(ie, he), !T && ie.local) {
                let { local: fe } = ie;
                fe.type !== "Identifier" ? this.raise(Se.ExportBindingIsString, ie, { localName: fe.value, exportName: he }) : (this.checkReservedWord(fe.name, fe.loc.start, !0, !1), this.scope.checkLocalExport(fe));
              }
            }
            else if (y.declaration) {
              let ie = y.declaration;
              if (ie.type === "FunctionDeclaration" || ie.type === "ClassDeclaration") {
                let { id: de } = ie;
                if (!de) throw new Error("Assertion failure");
                this.checkDuplicateExports(y, de.name);
              } else if (ie.type === "VariableDeclaration") for (let de of ie.declarations) this.checkDeclaration(de.id);
            }
          }
        }
        checkDeclaration(y) {
          if (y.type === "Identifier") this.checkDuplicateExports(y, y.name);
          else if (y.type === "ObjectPattern") for (let p of y.properties) this.checkDeclaration(p);
          else if (y.type === "ArrayPattern") for (let p of y.elements) p && this.checkDeclaration(p);
          else y.type === "ObjectProperty" ? this.checkDeclaration(y.value) : y.type === "RestElement" ? this.checkDeclaration(y.argument) : y.type === "AssignmentPattern" && this.checkDeclaration(y.left);
        }
        checkDuplicateExports(y, p) {
          this.exportedIdentifiers.has(p) && (p === "default" ? this.raise(Se.DuplicateDefaultExport, y) : this.raise(Se.DuplicateExport, y, { exportName: p })), this.exportedIdentifiers.add(p);
        }
        parseExportSpecifiers(y) {
          let p = [], b = !0;
          for (this.expect(5); !this.eat(8); ) {
            if (b) b = !1;
            else if (this.expect(12), this.eat(8)) break;
            let T = this.isContextual(130), F = this.match(133), Y = this.startNode();
            Y.local = this.parseModuleExportName(), p.push(this.parseExportSpecifier(Y, F, y, T));
          }
          return p;
        }
        parseExportSpecifier(y, p, b, T) {
          return this.eatContextual(93) ? y.exported = this.parseModuleExportName() : p ? y.exported = ty(y.local) : y.exported || (y.exported = Un(y.local)), this.finishNode(y, "ExportSpecifier");
        }
        parseModuleExportName() {
          if (this.match(133)) {
            let y = this.parseStringLiteral(this.state.value), p = ep.exec(y.value);
            return p && this.raise(Se.ModuleExportNameHasLoneSurrogate, y, { surrogateCharCode: p[0].charCodeAt(0) }), y;
          }
          return this.parseIdentifier(!0);
        }
        isJSONModuleImport(y) {
          return y.assertions != null ? y.assertions.some(({ key: p, value: b }) => b.value === "json" && (p.type === "Identifier" ? p.name === "type" : p.value === "type")) : !1;
        }
        checkImportReflection(y) {
          let { specifiers: p } = y, b = p.length === 1 ? p[0].type : null;
          if (y.phase === "source") b !== "ImportDefaultSpecifier" && this.raise(Se.SourcePhaseImportRequiresDefault, p[0].loc.start);
          else if (y.phase === "defer") b !== "ImportNamespaceSpecifier" && this.raise(Se.DeferImportRequiresNamespace, p[0].loc.start);
          else if (y.module) {
            var T;
            b !== "ImportDefaultSpecifier" && this.raise(Se.ImportReflectionNotBinding, p[0].loc.start), ((T = y.assertions) == null ? void 0 : T.length) > 0 && this.raise(Se.ImportReflectionHasAssertion, p[0].loc.start);
          }
        }
        checkJSONModuleImport(y) {
          if (this.isJSONModuleImport(y) && y.type !== "ExportAllDeclaration") {
            let { specifiers: p } = y;
            if (p != null) {
              let b = p.find((T) => {
                let F;
                if (T.type === "ExportSpecifier" ? F = T.local : T.type === "ImportSpecifier" && (F = T.imported), F !== void 0) return F.type === "Identifier" ? F.name !== "default" : F.value !== "default";
              });
              b !== void 0 && this.raise(Se.ImportJSONBindingNotDefault, b.loc.start);
            }
          }
        }
        isPotentialImportPhase(y) {
          return y ? !1 : this.isContextual(105) || this.isContextual(97) || this.isContextual(127);
        }
        applyImportPhase(y, p, b, T) {
          p || (b === "module" ? (this.expectPlugin("importReflection", T), y.module = !0) : this.hasPlugin("importReflection") && (y.module = !1), b === "source" ? (this.expectPlugin("sourcePhaseImports", T), y.phase = "source") : b === "defer" ? (this.expectPlugin("deferredImportEvaluation", T), y.phase = "defer") : this.hasPlugin("sourcePhaseImports") && (y.phase = null));
        }
        parseMaybeImportPhase(y, p) {
          if (!this.isPotentialImportPhase(p)) return this.applyImportPhase(y, p, null), null;
          let b = this.parseIdentifier(!0), { type: T } = this.state;
          return (Bs(T) ? T !== 98 || this.lookaheadCharCode() === 102 : T !== 12) ? (this.resetPreviousIdentifierLeadingComments(b), this.applyImportPhase(y, p, b.name, b.loc.start), null) : (this.applyImportPhase(y, p, null), b);
        }
        isPrecedingIdImportPhase(y) {
          let { type: p } = this.state;
          return Qt(p) ? p !== 98 || this.lookaheadCharCode() === 102 : p !== 12;
        }
        parseImport(y) {
          return this.match(133) ? this.parseImportSourceAndAttributes(y) : this.parseImportSpecifiersAndAfter(y, this.parseMaybeImportPhase(y, !1));
        }
        parseImportSpecifiersAndAfter(y, p) {
          y.specifiers = [];
          let b = !this.maybeParseDefaultImportSpecifier(y, p) || this.eat(12), T = b && this.maybeParseStarImportSpecifier(y);
          return b && !T && this.parseNamedImportSpecifiers(y), this.expectContextual(98), this.parseImportSourceAndAttributes(y);
        }
        parseImportSourceAndAttributes(y) {
          return y.specifiers != null || (y.specifiers = []), y.source = this.parseImportSource(), this.maybeParseImportAttributes(y), this.checkImportReflection(y), this.checkJSONModuleImport(y), this.semicolon(), this.finishNode(y, "ImportDeclaration");
        }
        parseImportSource() {
          return this.match(133) || this.unexpected(), this.parseExprAtom();
        }
        parseImportSpecifierLocal(y, p, b) {
          p.local = this.parseIdentifier(), y.specifiers.push(this.finishImportSpecifier(p, b));
        }
        finishImportSpecifier(y, p, b = 8201) {
          return this.checkLVal(y.local, { in: { type: p }, binding: b }), this.finishNode(y, p);
        }
        parseImportAttributes() {
          this.expect(5);
          let y = [], p = /* @__PURE__ */ new Set();
          do {
            if (this.match(8)) break;
            let b = this.startNode(), T = this.state.value;
            if (p.has(T) && this.raise(Se.ModuleAttributesWithDuplicateKeys, this.state.startLoc, { key: T }), p.add(T), this.match(133) ? b.key = this.parseStringLiteral(T) : b.key = this.parseIdentifier(!0), this.expect(14), !this.match(133)) throw this.raise(Se.ModuleAttributeInvalidValue, this.state.startLoc);
            b.value = this.parseStringLiteral(this.state.value), y.push(this.finishNode(b, "ImportAttribute"));
          } while (this.eat(12));
          return this.expect(8), y;
        }
        parseModuleAttributes() {
          let y = [], p = /* @__PURE__ */ new Set();
          do {
            let b = this.startNode();
            if (b.key = this.parseIdentifier(!0), b.key.name !== "type" && this.raise(Se.ModuleAttributeDifferentFromType, b.key), p.has(b.key.name) && this.raise(Se.ModuleAttributesWithDuplicateKeys, b.key, { key: b.key.name }), p.add(b.key.name), this.expect(14), !this.match(133)) throw this.raise(Se.ModuleAttributeInvalidValue, this.state.startLoc);
            b.value = this.parseStringLiteral(this.state.value), y.push(this.finishNode(b, "ImportAttribute"));
          } while (this.eat(12));
          return y;
        }
        maybeParseImportAttributes(y) {
          let p, b = !1;
          if (this.match(76)) {
            if (this.hasPrecedingLineBreak() && this.lookaheadCharCode() === 40) return;
            this.next(), this.hasPlugin("moduleAttributes") ? p = this.parseModuleAttributes() : (this.expectImportAttributesPlugin(), p = this.parseImportAttributes()), b = !0;
          } else if (this.isContextual(94) && !this.hasPrecedingLineBreak()) this.hasPlugin("importAttributes") ? (this.getPluginOption("importAttributes", "deprecatedAssertSyntax") !== !0 && this.raise(Se.ImportAttributesUseAssert, this.state.startLoc), this.addExtra(y, "deprecatedAssertSyntax", !0)) : this.expectOnePlugin(["importAttributes", "importAssertions"]), this.next(), p = this.parseImportAttributes();
          else if (this.hasPlugin("importAttributes") || this.hasPlugin("importAssertions")) p = [];
          else if (this.hasPlugin("moduleAttributes")) p = [];
          else return;
          !b && this.hasPlugin("importAssertions") ? y.assertions = p : y.attributes = p;
        }
        maybeParseDefaultImportSpecifier(y, p) {
          if (p) {
            let b = this.startNodeAtNode(p);
            return b.local = p, y.specifiers.push(this.finishImportSpecifier(b, "ImportDefaultSpecifier")), !0;
          } else if (Bs(this.state.type)) return this.parseImportSpecifierLocal(y, this.startNode(), "ImportDefaultSpecifier"), !0;
          return !1;
        }
        maybeParseStarImportSpecifier(y) {
          if (this.match(55)) {
            let p = this.startNode();
            return this.next(), this.expectContextual(93), this.parseImportSpecifierLocal(y, p, "ImportNamespaceSpecifier"), !0;
          }
          return !1;
        }
        parseNamedImportSpecifiers(y) {
          let p = !0;
          for (this.expect(5); !this.eat(8); ) {
            if (p) p = !1;
            else {
              if (this.eat(14)) throw this.raise(Se.DestructureNamedImport, this.state.startLoc);
              if (this.expect(12), this.eat(8)) break;
            }
            let b = this.startNode(), T = this.match(133), F = this.isContextual(130);
            b.imported = this.parseModuleExportName();
            let Y = this.parseImportSpecifier(b, T, y.importKind === "type" || y.importKind === "typeof", F, void 0);
            y.specifiers.push(Y);
          }
        }
        parseImportSpecifier(y, p, b, T, F) {
          if (this.eatContextual(93)) y.local = this.parseIdentifier();
          else {
            let { imported: Y } = y;
            if (p) throw this.raise(Se.ImportBindingIsString, y, { importName: Y.value });
            this.checkReservedWord(Y.name, y.loc.start, !0, !0), y.local || (y.local = Un(Y));
          }
          return this.finishImportSpecifier(y, "ImportSpecifier", F);
        }
        isThisParam(y) {
          return y.type === "Identifier" && y.name === "this";
        }
      }, t1 = class extends Rc {
        constructor(y, p) {
          y = iy(y), super(y, p), this.options = y, this.initializeScopes(), this.plugins = hS(this.options.plugins), this.filename = y.sourceFilename;
        }
        getScopeHandler() {
          return Yf;
        }
        parse() {
          this.enterInitialScopes();
          let y = this.startNode(), p = this.startNode();
          return this.nextToken(), y.errors = null, this.parseTopLevel(y, p), y.errors = this.state.errors, y.comments.length = this.state.commentsLen, y;
        }
      };
      function hS(y) {
        let p = /* @__PURE__ */ new Map();
        for (let b of y) {
          let [T, F] = Array.isArray(b) ? b : [b, {}];
          p.has(T) || p.set(T, F || {});
        }
        return p;
      }
      function mS(y, p) {
        var b;
        if (((b = p) == null ? void 0 : b.sourceType) === "unambiguous") {
          p = Object.assign({}, p);
          try {
            p.sourceType = "module";
            let T = ol(p, y), F = T.parse();
            if (T.sawUnambiguousESM) return F;
            if (T.ambiguousScriptDifferentAst) try {
              return p.sourceType = "script", ol(p, y).parse();
            } catch {
            }
            else F.program.sourceType = "script";
            return F;
          } catch (T) {
            try {
              return p.sourceType = "script", ol(p, y).parse();
            } catch {
            }
            throw T;
          }
        } else return ol(p, y).parse();
      }
      function gS(y, p) {
        let b = ol(p, y);
        return b.options.strictMode && (b.state.strict = !0), b.getExpression();
      }
      function yS(y) {
        let p = {};
        for (let b of Object.keys(y)) p[b] = ba(y[b]);
        return p;
      }
      var ih = yS(jT);
      function ol(y, p) {
        let b = t1;
        return y != null && y.plugins && (fS(y.plugins), b = ue(y.plugins)), new b(y, p);
      }
      var oy = {};
      function ue(y) {
        let p = e1.filter((F) => ui(y, F)), b = p.join("/"), T = oy[b];
        if (!T) {
          T = t1;
          for (let F of p) T = Zv[F](T);
          oy[b] = T;
        }
        return T;
      }
      Ce.parse = mS, Ce.parseExpression = gS, Ce.tokTypes = ih;
    }), v = {};
    c(v, { parsers: () => $g });
    var x = f(m());
    function C(Ce) {
      return (Ve, pt, bt) => {
        let dt = !!(bt != null && bt.backwards);
        if (pt === !1) return !1;
        let { length: on } = Ve, nn = pt;
        for (; nn >= 0 && nn < on; ) {
          let ri = Ve.charAt(nn);
          if (Ce instanceof RegExp) {
            if (!Ce.test(ri)) return nn;
          } else if (!Ce.includes(ri)) return nn;
          dt ? nn-- : nn++;
        }
        return nn === -1 || nn === on ? nn : !1;
      };
    }
    var E = C(" 	"), S = C(/[^\n\r]/u);
    function w(Ce, Ve) {
      if (Ve === !1) return !1;
      if (Ce.charAt(Ve) === "/" && Ce.charAt(Ve + 1) === "*") {
        for (let pt = Ve + 2; pt < Ce.length; ++pt) if (Ce.charAt(pt) === "*" && Ce.charAt(pt + 1) === "/") return pt + 2;
      }
      return Ve;
    }
    var O = w;
    function A(Ce, Ve, pt) {
      let bt = !!(pt != null && pt.backwards);
      if (Ve === !1) return !1;
      let dt = Ce.charAt(Ve);
      if (bt) {
        if (Ce.charAt(Ve - 1) === "\r" && dt === `
`) return Ve - 2;
        if (dt === `
` || dt === "\r" || dt === "\u2028" || dt === "\u2029") return Ve - 1;
      } else {
        if (dt === "\r" && Ce.charAt(Ve + 1) === `
`) return Ve + 2;
        if (dt === `
` || dt === "\r" || dt === "\u2028" || dt === "\u2029") return Ve + 1;
      }
      return Ve;
    }
    var I = A;
    function $(Ce, Ve) {
      return Ve === !1 ? !1 : Ce.charAt(Ve) === "/" && Ce.charAt(Ve + 1) === "/" ? S(Ce, Ve) : Ve;
    }
    var L = $;
    function B(Ce, Ve) {
      let pt = null, bt = Ve;
      for (; bt !== pt; ) pt = bt, bt = E(Ce, bt), bt = O(Ce, bt), bt = L(Ce, bt), bt = I(Ce, bt);
      return bt;
    }
    var H = B;
    function q(Ce) {
      let Ve = [];
      for (let pt of Ce) try {
        return pt();
      } catch (bt) {
        Ve.push(bt);
      }
      throw Object.assign(new Error("All combinations failed"), { errors: Ve });
    }
    var J = q;
    function X(Ce) {
      if (!Ce.startsWith("#!")) return "";
      let Ve = Ce.indexOf(`
`);
      return Ve === -1 ? Ce : Ce.slice(0, Ve);
    }
    var j = X, U = (Ce, Ve, pt) => {
      if (!(Ce && Ve == null)) return Array.isArray(Ve) || typeof Ve == "string" ? Ve[pt < 0 ? Ve.length + pt : pt] : Ve.at(pt);
    }, G = U;
    function K(Ce) {
      return Array.isArray(Ce) && Ce.length > 0;
    }
    var ee = K;
    function te(Ce) {
      var Ve, pt, bt;
      let dt = ((Ve = Ce.range) == null ? void 0 : Ve[0]) ?? Ce.start, on = (bt = ((pt = Ce.declaration) == null ? void 0 : pt.decorators) ?? Ce.decorators) == null ? void 0 : bt[0];
      return on ? Math.min(te(on), dt) : dt;
    }
    function M(Ce) {
      var Ve;
      return ((Ve = Ce.range) == null ? void 0 : Ve[1]) ?? Ce.end;
    }
    function Z(Ce) {
      let Ve = new Set(Ce);
      return (pt) => Ve.has(pt == null ? void 0 : pt.type);
    }
    var ne = Z, R = ne(["Block", "CommentBlock", "MultiLine"]), _ = R;
    function W(Ce) {
      let Ve = `*${Ce.value}*`.split(`
`);
      return Ve.length > 1 && Ve.every((pt) => pt.trimStart()[0] === "*");
    }
    var Q = W;
    function oe(Ce) {
      return _(Ce) && Ce.value[0] === "*" && /@(?:type|satisfies)\b/u.test(Ce.value);
    }
    var ae = oe, pe = null;
    function me(Ce) {
      if (pe !== null && typeof pe.property) {
        let Ve = pe;
        return pe = me.prototype = null, Ve;
      }
      return pe = me.prototype = Ce ?? /* @__PURE__ */ Object.create(null), new me();
    }
    var xe = 10;
    for (let Ce = 0; Ce <= xe; Ce++) me();
    function le(Ce) {
      return me(Ce);
    }
    function ye(Ce, Ve = "type") {
      le(Ce);
      function pt(bt) {
        let dt = bt[Ve], on = Ce[dt];
        if (!Array.isArray(on)) throw Object.assign(new Error(`Missing visitor keys for '${dt}'.`), { node: bt });
        return on;
      }
      return pt;
    }
    var be = ye, Re = { ArrayExpression: ["elements"], AssignmentExpression: ["left", "right"], BinaryExpression: ["left", "right"], InterpreterDirective: [], Directive: ["value"], DirectiveLiteral: [], BlockStatement: ["directives", "body"], BreakStatement: ["label"], CallExpression: ["callee", "arguments", "typeParameters", "typeArguments"], CatchClause: ["param", "body"], ConditionalExpression: ["test", "consequent", "alternate"], ContinueStatement: ["label"], DebuggerStatement: [], DoWhileStatement: ["test", "body"], EmptyStatement: [], ExpressionStatement: ["expression"], File: ["program"], ForInStatement: ["left", "right", "body"], ForStatement: ["init", "test", "update", "body"], FunctionDeclaration: ["id", "params", "body", "returnType", "typeParameters", "predicate"], FunctionExpression: ["id", "params", "body", "returnType", "typeParameters"], Identifier: ["typeAnnotation", "decorators"], IfStatement: ["test", "consequent", "alternate"], LabeledStatement: ["label", "body"], StringLiteral: [], NumericLiteral: [], NullLiteral: [], BooleanLiteral: [], RegExpLiteral: [], LogicalExpression: ["left", "right"], MemberExpression: ["object", "property"], NewExpression: ["callee", "arguments", "typeParameters", "typeArguments"], Program: ["directives", "body"], ObjectExpression: ["properties"], ObjectMethod: ["key", "params", "body", "decorators", "returnType", "typeParameters"], ObjectProperty: ["key", "value", "decorators"], RestElement: ["argument", "typeAnnotation", "decorators"], ReturnStatement: ["argument"], SequenceExpression: ["expressions"], ParenthesizedExpression: ["expression"], SwitchCase: ["test", "consequent"], SwitchStatement: ["discriminant", "cases"], ThisExpression: [], ThrowStatement: ["argument"], TryStatement: ["block", "handler", "finalizer"], UnaryExpression: ["argument"], UpdateExpression: ["argument"], VariableDeclaration: ["declarations"], VariableDeclarator: ["id", "init"], WhileStatement: ["test", "body"], WithStatement: ["object", "body"], AssignmentPattern: ["left", "right", "decorators", "typeAnnotation"], ArrayPattern: ["elements", "typeAnnotation", "decorators"], ArrowFunctionExpression: ["params", "body", "returnType", "typeParameters", "predicate"], ClassBody: ["body"], ClassExpression: ["id", "body", "superClass", "mixins", "typeParameters", "superTypeParameters", "implements", "decorators", "superTypeArguments"], ClassDeclaration: ["id", "body", "superClass", "mixins", "typeParameters", "superTypeParameters", "implements", "decorators", "superTypeArguments"], ExportAllDeclaration: ["source", "attributes", "exported"], ExportDefaultDeclaration: ["declaration"], ExportNamedDeclaration: ["declaration", "specifiers", "source", "attributes"], ExportSpecifier: ["local", "exported"], ForOfStatement: ["left", "right", "body"], ImportDeclaration: ["specifiers", "source", "attributes"], ImportDefaultSpecifier: ["local"], ImportNamespaceSpecifier: ["local"], ImportSpecifier: ["local", "imported"], ImportExpression: ["source", "options", "attributes"], MetaProperty: ["meta", "property"], ClassMethod: ["key", "params", "body", "decorators", "returnType", "typeParameters"], ObjectPattern: ["properties", "typeAnnotation", "decorators"], SpreadElement: ["argument"], Super: [], TaggedTemplateExpression: ["tag", "quasi", "typeParameters", "typeArguments"], TemplateElement: [], TemplateLiteral: ["quasis", "expressions"], YieldExpression: ["argument"], AwaitExpression: ["argument"], Import: [], BigIntLiteral: [], ExportNamespaceSpecifier: ["exported"], OptionalMemberExpression: ["object", "property"], OptionalCallExpression: ["callee", "arguments", "typeParameters", "typeArguments"], ClassProperty: ["key", "value", "typeAnnotation", "decorators", "variance"], ClassAccessorProperty: ["key", "value", "typeAnnotation", "decorators"], ClassPrivateProperty: ["key", "value", "decorators", "typeAnnotation", "variance"], ClassPrivateMethod: ["key", "params", "body", "decorators", "returnType", "typeParameters"], PrivateName: ["id"], StaticBlock: ["body"], AnyTypeAnnotation: [], ArrayTypeAnnotation: ["elementType"], BooleanTypeAnnotation: [], BooleanLiteralTypeAnnotation: [], NullLiteralTypeAnnotation: [], ClassImplements: ["id", "typeParameters"], DeclareClass: ["id", "typeParameters", "extends", "mixins", "implements", "body"], DeclareFunction: ["id", "predicate"], DeclareInterface: ["id", "typeParameters", "extends", "body"], DeclareModule: ["id", "body"], DeclareModuleExports: ["typeAnnotation"], DeclareTypeAlias: ["id", "typeParameters", "right"], DeclareOpaqueType: ["id", "typeParameters", "supertype"], DeclareVariable: ["id"], DeclareExportDeclaration: ["declaration", "specifiers", "source"], DeclareExportAllDeclaration: ["source"], DeclaredPredicate: ["value"], ExistsTypeAnnotation: [], FunctionTypeAnnotation: ["typeParameters", "params", "rest", "returnType", "this"], FunctionTypeParam: ["name", "typeAnnotation"], GenericTypeAnnotation: ["id", "typeParameters"], InferredPredicate: [], InterfaceExtends: ["id", "typeParameters"], InterfaceDeclaration: ["id", "typeParameters", "extends", "body"], InterfaceTypeAnnotation: ["extends", "body"], IntersectionTypeAnnotation: ["types"], MixedTypeAnnotation: [], EmptyTypeAnnotation: [], NullableTypeAnnotation: ["typeAnnotation"], NumberLiteralTypeAnnotation: [], NumberTypeAnnotation: [], ObjectTypeAnnotation: ["properties", "indexers", "callProperties", "internalSlots"], ObjectTypeInternalSlot: ["id", "value"], ObjectTypeCallProperty: ["value"], ObjectTypeIndexer: ["id", "key", "value", "variance"], ObjectTypeProperty: ["key", "value", "variance"], ObjectTypeSpreadProperty: ["argument"], OpaqueType: ["id", "typeParameters", "supertype", "impltype"], QualifiedTypeIdentifier: ["id", "qualification"], StringLiteralTypeAnnotation: [], StringTypeAnnotation: [], SymbolTypeAnnotation: [], ThisTypeAnnotation: [], TupleTypeAnnotation: ["types", "elementTypes"], TypeofTypeAnnotation: ["argument", "typeArguments"], TypeAlias: ["id", "typeParameters", "right"], TypeAnnotation: ["typeAnnotation"], TypeCastExpression: ["expression", "typeAnnotation"], TypeParameter: ["bound", "default", "variance"], TypeParameterDeclaration: ["params"], TypeParameterInstantiation: ["params"], UnionTypeAnnotation: ["types"], Variance: [], VoidTypeAnnotation: [], EnumDeclaration: ["id", "body"], EnumBooleanBody: ["members"], EnumNumberBody: ["members"], EnumStringBody: ["members"], EnumSymbolBody: ["members"], EnumBooleanMember: ["id", "init"], EnumNumberMember: ["id", "init"], EnumStringMember: ["id", "init"], EnumDefaultedMember: ["id"], IndexedAccessType: ["objectType", "indexType"], OptionalIndexedAccessType: ["objectType", "indexType"], JSXAttribute: ["name", "value"], JSXClosingElement: ["name"], JSXElement: ["openingElement", "children", "closingElement"], JSXEmptyExpression: [], JSXExpressionContainer: ["expression"], JSXSpreadChild: ["expression"], JSXIdentifier: [], JSXMemberExpression: ["object", "property"], JSXNamespacedName: ["namespace", "name"], JSXOpeningElement: ["name", "attributes", "typeArguments", "typeParameters"], JSXSpreadAttribute: ["argument"], JSXText: [], JSXFragment: ["openingFragment", "children", "closingFragment"], JSXOpeningFragment: [], JSXClosingFragment: [], Noop: [], Placeholder: [], V8IntrinsicIdentifier: [], ArgumentPlaceholder: [], BindExpression: ["object", "callee"], ImportAttribute: ["key", "value"], Decorator: ["expression"], DoExpression: ["body"], ExportDefaultSpecifier: ["exported"], RecordExpression: ["properties"], TupleExpression: ["elements"], DecimalLiteral: [], ModuleExpression: ["body"], TopicReference: [], PipelineTopicExpression: ["expression"], PipelineBareFunction: ["callee"], PipelinePrimaryTopicReference: [], TSParameterProperty: ["parameter", "decorators"], TSDeclareFunction: ["id", "typeParameters", "params", "returnType", "body"], TSDeclareMethod: ["decorators", "key", "typeParameters", "params", "returnType"], TSQualifiedName: ["left", "right"], TSCallSignatureDeclaration: ["typeParameters", "parameters", "typeAnnotation", "params", "returnType"], TSConstructSignatureDeclaration: ["typeParameters", "parameters", "typeAnnotation", "params", "returnType"], TSPropertySignature: ["key", "typeAnnotation"], TSMethodSignature: ["key", "typeParameters", "parameters", "typeAnnotation", "params", "returnType"], TSIndexSignature: ["parameters", "typeAnnotation"], TSAnyKeyword: [], TSBooleanKeyword: [], TSBigIntKeyword: [], TSIntrinsicKeyword: [], TSNeverKeyword: [], TSNullKeyword: [], TSNumberKeyword: [], TSObjectKeyword: [], TSStringKeyword: [], TSSymbolKeyword: [], TSUndefinedKeyword: [], TSUnknownKeyword: [], TSVoidKeyword: [], TSThisType: [], TSFunctionType: ["typeParameters", "parameters", "typeAnnotation", "params", "returnType"], TSConstructorType: ["typeParameters", "parameters", "typeAnnotation", "params", "returnType"], TSTypeReference: ["typeName", "typeParameters", "typeArguments"], TSTypePredicate: ["parameterName", "typeAnnotation"], TSTypeQuery: ["exprName", "typeParameters", "typeArguments"], TSTypeLiteral: ["members"], TSArrayType: ["elementType"], TSTupleType: ["elementTypes"], TSOptionalType: ["typeAnnotation"], TSRestType: ["typeAnnotation"], TSNamedTupleMember: ["label", "elementType"], TSUnionType: ["types"], TSIntersectionType: ["types"], TSConditionalType: ["checkType", "extendsType", "trueType", "falseType"], TSInferType: ["typeParameter"], TSParenthesizedType: ["typeAnnotation"], TSTypeOperator: ["typeAnnotation"], TSIndexedAccessType: ["objectType", "indexType"], TSMappedType: ["typeParameter", "typeAnnotation", "nameType"], TSLiteralType: ["literal"], TSExpressionWithTypeArguments: ["expression", "typeParameters"], TSInterfaceDeclaration: ["id", "typeParameters", "extends", "body"], TSInterfaceBody: ["body"], TSTypeAliasDeclaration: ["id", "typeParameters", "typeAnnotation"], TSInstantiationExpression: ["expression", "typeParameters", "typeArguments"], TSAsExpression: ["expression", "typeAnnotation"], TSSatisfiesExpression: ["expression", "typeAnnotation"], TSTypeAssertion: ["typeAnnotation", "expression"], TSEnumDeclaration: ["id", "members"], TSEnumMember: ["id", "initializer"], TSModuleDeclaration: ["id", "body"], TSModuleBlock: ["body"], TSImportType: ["argument", "qualifier", "typeParameters", "typeArguments"], TSImportEqualsDeclaration: ["id", "moduleReference"], TSExternalModuleReference: ["expression"], TSNonNullExpression: ["expression"], TSExportAssignment: ["expression"], TSNamespaceExportDeclaration: ["id"], TSTypeAnnotation: ["typeAnnotation"], TSTypeParameterInstantiation: ["params"], TSTypeParameterDeclaration: ["params"], TSTypeParameter: ["constraint", "default", "name"], ChainExpression: ["expression"], ExperimentalRestProperty: ["argument"], ExperimentalSpreadProperty: ["argument"], Literal: [], MethodDefinition: ["decorators", "key", "value"], PrivateIdentifier: [], Property: ["key", "value"], PropertyDefinition: ["decorators", "key", "typeAnnotation", "value", "variance"], AccessorProperty: ["decorators", "key", "typeAnnotation", "value"], TSAbstractAccessorProperty: ["decorators", "key", "typeAnnotation"], TSAbstractKeyword: [], TSAbstractMethodDefinition: ["key", "value"], TSAbstractPropertyDefinition: ["decorators", "key", "typeAnnotation"], TSAsyncKeyword: [], TSClassImplements: ["expression", "typeArguments", "typeParameters"], TSDeclareKeyword: [], TSEmptyBodyFunctionExpression: ["id", "typeParameters", "params", "returnType"], TSEnumBody: ["members"], TSExportKeyword: [], TSInterfaceHeritage: ["expression", "typeArguments", "typeParameters"], TSPrivateKeyword: [], TSProtectedKeyword: [], TSPublicKeyword: [], TSReadonlyKeyword: [], TSStaticKeyword: [], TSTemplateLiteralType: ["quasis", "types"], AsConstExpression: ["expression"], AsExpression: ["expression", "typeAnnotation"], BigIntLiteralTypeAnnotation: [], BigIntTypeAnnotation: [], ComponentDeclaration: ["id", "params", "body", "typeParameters", "rendersType"], ComponentParameter: ["name", "local"], ComponentTypeAnnotation: ["params", "rest", "typeParameters", "rendersType"], ComponentTypeParameter: ["name", "typeAnnotation"], ConditionalTypeAnnotation: ["checkType", "extendsType", "trueType", "falseType"], DeclareComponent: ["id", "params", "rest", "typeParameters", "rendersType"], DeclareEnum: ["id", "body"], DeclareHook: ["id"], DeclareNamespace: ["id", "body"], EnumBigIntBody: ["members"], EnumBigIntMember: ["id", "init"], HookDeclaration: ["id", "params", "body", "typeParameters", "returnType"], HookTypeAnnotation: ["params", "returnType", "rest", "typeParameters"], InferTypeAnnotation: ["typeParameter"], KeyofTypeAnnotation: ["argument"], ObjectTypeMappedTypeProperty: ["keyTparam", "propType", "sourceType", "variance"], QualifiedTypeofIdentifier: ["qualification", "id"], TupleTypeLabeledElement: ["label", "elementType", "variance"], TupleTypeSpreadElement: ["label", "typeAnnotation"], TypeOperator: ["typeAnnotation"], TypePredicate: ["parameterName", "typeAnnotation", "asserts"], NGRoot: ["node"], NGPipeExpression: ["left", "right", "arguments"], NGChainedExpression: ["expressions"], NGEmptyExpression: [], NGMicrosyntax: ["body"], NGMicrosyntaxKey: [], NGMicrosyntaxExpression: ["expression", "alias"], NGMicrosyntaxKeyedExpression: ["key", "expression"], NGMicrosyntaxLet: ["key", "value"], NGMicrosyntaxAs: ["key", "alias"], JsExpressionRoot: ["node"], JsonRoot: ["node"], TSJSDocAllType: [], TSJSDocUnknownType: [], TSJSDocNullableType: ["typeAnnotation"], TSJSDocNonNullableType: ["typeAnnotation"], NeverTypeAnnotation: [], UndefinedTypeAnnotation: [], UnknownTypeAnnotation: [], SatisfiesExpression: ["expression", "typeAnnotation"] }, Te = be(Re), Xe = Te;
    function Ne(Ce, Ve) {
      if (!(Ce !== null && typeof Ce == "object")) return Ce;
      if (Array.isArray(Ce)) {
        for (let bt = 0; bt < Ce.length; bt++) Ce[bt] = Ne(Ce[bt], Ve);
        return Ce;
      }
      let pt = Xe(Ce);
      for (let bt = 0; bt < pt.length; bt++) Ce[pt[bt]] = Ne(Ce[pt[bt]], Ve);
      return Ve(Ce) || Ce;
    }
    var Qe = Ne;
    function Ee(Ce, Ve) {
      let { parser: pt, text: bt } = Ve;
      if (Ce.type === "File" && Ce.program.interpreter) {
        let { program: { interpreter: dt }, comments: on } = Ce;
        delete Ce.program.interpreter, on.unshift(dt);
      }
      if (pt === "babel") {
        let dt = /* @__PURE__ */ new Set();
        Ce = Qe(Ce, (on) => {
          var nn;
          (nn = on.leadingComments) != null && nn.some(ae) && dt.add(te(on));
        }), Ce = Qe(Ce, (on) => {
          if (on.type === "ParenthesizedExpression") {
            let { expression: nn } = on;
            if (nn.type === "TypeCastExpression") return nn.range = [...on.range], nn;
            let ri = te(on);
            if (!dt.has(ri)) return nn.extra = { ...nn.extra, parenthesized: !0 }, nn;
          }
        });
      }
      if (Ce = Qe(Ce, (dt) => {
        var on;
        switch (dt.type) {
          case "LogicalExpression":
            if (Ie(dt)) return Je(dt);
            break;
          case "VariableDeclaration": {
            let nn = G(!1, dt.declarations, -1);
            nn != null && nn.init && bt[M(nn)] !== ";" && (dt.range = [te(dt), M(nn)]);
            break;
          }
          case "TSParenthesizedType":
            return dt.typeAnnotation;
          case "TSTypeParameter":
            if (typeof dt.name == "string") {
              let nn = te(dt);
              dt.name = { type: "Identifier", name: dt.name, range: [nn, nn + dt.name.length] };
            }
            break;
          case "TopicReference":
            Ce.extra = { ...Ce.extra, __isUsingHackPipeline: !0 };
            break;
          case "ExportAllDeclaration":
            if (pt === "meriyah" && ((on = dt.exported) == null ? void 0 : on.type) === "Identifier") {
              let { exported: nn } = dt, ri = bt.slice(te(nn), M(nn));
              (ri.startsWith('"') || ri.startsWith("'")) && (dt.exported = { ...dt.exported, type: "Literal", value: dt.exported.name, raw: ri });
            }
            break;
          case "TSUnionType":
          case "TSIntersectionType":
            if (dt.types.length === 1) return dt.types[0];
            break;
        }
      }), ee(Ce.comments)) {
        let dt = G(!1, Ce.comments, -1);
        for (let on = Ce.comments.length - 2; on >= 0; on--) {
          let nn = Ce.comments[on];
          M(nn) === te(dt) && _(nn) && _(dt) && Q(nn) && Q(dt) && (Ce.comments.splice(on + 1, 1), nn.value += "*//*" + dt.value, nn.range = [te(nn), M(dt)]), dt = nn;
        }
      }
      return Ce.type === "Program" && (Ce.range = [0, bt.length]), Ce;
    }
    function Ie(Ce) {
      return Ce.type === "LogicalExpression" && Ce.right.type === "LogicalExpression" && Ce.operator === Ce.right.operator;
    }
    function Je(Ce) {
      return Ie(Ce) ? Je({ type: "LogicalExpression", operator: Ce.operator, left: Je({ type: "LogicalExpression", operator: Ce.operator, left: Ce.left, right: Ce.right.left, range: [te(Ce.left), M(Ce.right.left)] }), right: Ce.right.right, range: [te(Ce), M(Ce)] }) : Ce;
    }
    var vt = Ee;
    function St(Ce, Ve) {
      let pt = new SyntaxError(Ce + " (" + Ve.loc.start.line + ":" + Ve.loc.start.column + ")");
      return Object.assign(pt, Ve);
    }
    var Lt = St;
    function ke(Ce) {
      let { message: Ve, loc: { line: pt, column: bt }, reasonCode: dt } = Ce, on = Ce;
      (dt === "MissingPlugin" || dt === "MissingOneOfPlugins") && (Ve = "Unexpected token.", on = void 0);
      let nn = ` (${pt}:${bt})`;
      return Ve.endsWith(nn) && (Ve = Ve.slice(0, -nn.length)), Lt(Ve, { loc: { start: { line: pt, column: bt + 1 } }, cause: on });
    }
    var Le = ke, Pe = (Ce, Ve, pt, bt) => {
      if (!(Ce && Ve == null)) return Ve.replaceAll ? Ve.replaceAll(pt, bt) : pt.global ? Ve.replace(pt, bt) : Ve.split(pt).join(bt);
    }, Ae = Pe, We = /\*\/$/, At = /^\/\*\*?/, Ft = /^\s*(\/\*\*?(.|\r?\n)*?\*\/)/, Ct = /(^|\s+)\/\/([^\n\r]*)/g, ht = /^(\r?\n)+/, He = /(?:^|\r?\n) *(@[^\n\r]*?) *\r?\n *(?![^\n\r@]*\/\/[^]*)([^\s@][^\n\r@]+?) *\r?\n/g, qe = /(?:^|\r?\n) *@(\S+) *([^\n\r]*)/g, wt = /(\r?\n|^) *\* ?/g, Ut = [];
    function an(Ce) {
      let Ve = Ce.match(Ft);
      return Ve ? Ve[0].trimStart() : "";
    }
    function wn(Ce) {
      let Ve = `
`;
      Ce = Ae(!1, Ce.replace(At, "").replace(We, ""), wt, "$1");
      let pt = "";
      for (; pt !== Ce; ) pt = Ce, Ce = Ae(!1, Ce, He, `${Ve}$1 $2${Ve}`);
      Ce = Ce.replace(ht, "").trimEnd();
      let bt = /* @__PURE__ */ Object.create(null), dt = Ae(!1, Ce, qe, "").replace(ht, "").trimEnd(), on;
      for (; on = qe.exec(Ce); ) {
        let nn = Ae(!1, on[2], Ct, "");
        if (typeof bt[on[1]] == "string" || Array.isArray(bt[on[1]])) {
          let ri = bt[on[1]];
          bt[on[1]] = [...Ut, ...Array.isArray(ri) ? ri : [ri], nn];
        } else bt[on[1]] = nn;
      }
      return { comments: dt, pragmas: bt };
    }
    function En(Ce) {
      let Ve = j(Ce);
      Ve && (Ce = Ce.slice(Ve.length + 1));
      let pt = an(Ce), { pragmas: bt, comments: dt } = wn(pt);
      return { shebang: Ve, text: Ce, pragmas: bt, comments: dt };
    }
    function sr(Ce) {
      let { pragmas: Ve } = En(Ce);
      return Object.prototype.hasOwnProperty.call(Ve, "prettier") || Object.prototype.hasOwnProperty.call(Ve, "format");
    }
    function er(Ce) {
      return Ce = typeof Ce == "function" ? { parse: Ce } : Ce, { astFormat: "estree", hasPragma: sr, locStart: te, locEnd: M, ...Ce };
    }
    var pn = er;
    function Pr(Ce) {
      let { filepath: Ve } = Ce;
      if (Ve) {
        if (Ve = Ve.toLowerCase(), Ve.endsWith(".cjs")) return "script";
        if (Ve.endsWith(".mjs")) return "module";
      }
    }
    var bi = Pr;
    function Wr(Ce, Ve) {
      let { type: pt = "JsExpressionRoot", rootMarker: bt, text: dt } = Ve, { tokens: on, comments: nn } = Ce;
      return delete Ce.tokens, delete Ce.comments, { tokens: on, comments: nn, type: pt, node: Ce, range: [0, dt.length], rootMarker: bt };
    }
    var Po = Wr, _r = (Ce) => pn(ko(Ce)), Lr = { sourceType: "module", allowImportExportEverywhere: !0, allowReturnOutsideFunction: !0, allowNewTargetOutsideFunction: !0, allowSuperOutsideMethod: !0, allowUndeclaredExports: !0, errorRecovery: !0, createParenthesizedExpressions: !0, createImportExpressions: !0, plugins: ["doExpressions", "exportDefaultFrom", "functionBind", "functionSent", "throwExpressions", "partialApplication", "decorators", "decimal", "moduleBlocks", "asyncDoExpressions", "destructuringPrivate", "decoratorAutoAccessors", "importReflection", "explicitResourceManagement", ["importAttributes", { deprecatedAssertSyntax: !0 }], "sourcePhaseImports", "deferredImportEvaluation", ["optionalChainingAssign", { version: "2023-07" }], "recordAndTuple"], tokens: !0, ranges: !0 }, Gn = "v8intrinsic", Hr = [["pipelineOperator", { proposal: "hack", topicToken: "%" }], ["pipelineOperator", { proposal: "minimal" }], ["pipelineOperator", { proposal: "fsharp" }]], Qn = (Ce, Ve = Lr) => ({ ...Ve, plugins: [...Ve.plugins, ...Ce] }), ao = /@(?:no)?flow\b/u;
    function Ls(Ce, Ve) {
      var pt;
      if ((pt = Ve.filepath) != null && pt.endsWith(".js.flow")) return !0;
      let bt = j(Ce);
      bt && (Ce = Ce.slice(bt.length));
      let dt = H(Ce, 0);
      return dt !== !1 && (Ce = Ce.slice(0, dt)), ao.test(Ce);
    }
    function Mi(Ce, Ve, pt) {
      let bt = Ce(Ve, pt), dt = bt.errors.find((on) => !ve.has(on.reasonCode));
      if (dt) throw dt;
      return bt;
    }
    function ko({ isExpression: Ce = !1, optionsCombinations: Ve }) {
      return (pt, bt = {}) => {
        if ((bt.parser === "babel" || bt.parser === "__babel_estree") && Ls(pt, bt)) return bt.parser = "babel-flow", Ke.parse(pt, bt);
        let dt = Ve;
        (bt.__babelSourceType ?? bi(bt)) === "script" && (dt = dt.map((lo) => ({ ...lo, sourceType: "script" })));
        let on = /%[A-Z]/u.test(pt);
        pt.includes("|>") ? dt = (on ? [...Hr, Gn] : Hr).flatMap((lo) => dt.map((Vf) => Qn([lo], Vf))) : on && (dt = dt.map((lo) => Qn([Gn], lo)));
        let nn = Ce ? x.parseExpression : x.parse, ri;
        try {
          ri = J(dt.map((lo) => () => Mi(nn, pt, lo)));
        } catch ({ errors: [lo] }) {
          throw Le(lo);
        }
        return Ce && (ri = Po(ri, { text: pt, rootMarker: bt.rootMarker })), vt(ri, { parser: "babel", text: pt });
      };
    }
    var ve = /* @__PURE__ */ new Set(["StrictNumericEscape", "StrictWith", "StrictOctalLiteral", "StrictDelete", "StrictEvalArguments", "StrictEvalArgumentsBinding", "StrictFunction", "ForInOfLoopInitializer", "EmptyTypeArguments", "EmptyTypeParameters", "ConstructorHasTypeParameters", "UnsupportedParameterPropertyKind", "DecoratorExportClass", "ParamDupe", "InvalidDecimal", "RestTrailingComma", "UnsupportedParameterDecorator", "UnterminatedJsxContent", "UnexpectedReservedWord", "ModuleAttributesWithDuplicateKeys", "LineTerminatorBeforeArrow", "InvalidEscapeSequenceTemplate", "NonAbstractClassHasAbstractMethod", "OptionalTypeBeforeRequired", "PatternIsOptional", "OptionalBindingPattern", "DeclareClassFieldHasInitializer", "TypeImportCannotSpecifyDefaultAndNamed", "ConstructorClassField", "VarRedeclaration", "InvalidPrivateFieldResolution", "DuplicateExport"]), tt = [Qn(["jsx"])], xt = _r({ optionsCombinations: tt }), Oe = _r({ optionsCombinations: [Qn(["jsx", "typescript"]), Qn(["typescript"])] }), Fe = _r({ isExpression: !0, optionsCombinations: [Qn(["jsx"])] }), et = _r({ isExpression: !0, optionsCombinations: [Qn(["typescript"])] }), Ke = _r({ optionsCombinations: [Qn(["jsx", ["flow", { all: !0, enums: !0 }], "flowComments"])] }), ct = _r({ optionsCombinations: tt.map((Ce) => Qn(["estree"], Ce)) }), gt = { babel: xt, "babel-flow": Ke, "babel-ts": Oe, __js_expression: Fe, __ts_expression: et, __vue_expression: Fe, __vue_ts_expression: et, __vue_event_binding: xt, __vue_ts_event_binding: Oe, __babel_estree: ct }, Ht = f(m());
    function Pn(Ce = {}) {
      let { allowComments: Ve = !0 } = Ce;
      return function(pt) {
        let bt;
        try {
          bt = (0, Ht.parseExpression)(pt, { tokens: !0, ranges: !0, attachComment: !1 });
        } catch (dt) {
          throw Le(dt);
        }
        if (!Ve && ee(bt.comments)) throw tr(bt.comments[0], "Comment");
        return Uo(bt), Po(bt, { type: "JsonRoot", text: pt });
      };
    }
    function tr(Ce, Ve) {
      let [pt, bt] = [Ce.loc.start, Ce.loc.end].map(({ line: dt, column: on }) => ({ line: dt, column: on + 1 }));
      return Lt(`${Ve} is not allowed in JSON.`, { loc: { start: pt, end: bt } });
    }
    function Uo(Ce) {
      switch (Ce.type) {
        case "ArrayExpression":
          for (let Ve of Ce.elements) Ve !== null && Uo(Ve);
          return;
        case "ObjectExpression":
          for (let Ve of Ce.properties) Uo(Ve);
          return;
        case "ObjectProperty":
          if (Ce.computed) throw tr(Ce.key, "Computed key");
          if (Ce.shorthand) throw tr(Ce.key, "Shorthand property");
          Ce.key.type !== "Identifier" && Uo(Ce.key), Uo(Ce.value);
          return;
        case "UnaryExpression": {
          let { operator: Ve, argument: pt } = Ce;
          if (Ve !== "+" && Ve !== "-") throw tr(Ce, `Operator '${Ce.operator}'`);
          if (pt.type === "NumericLiteral" || pt.type === "Identifier" && (pt.name === "Infinity" || pt.name === "NaN")) return;
          throw tr(pt, `Operator '${Ve}' before '${pt.type}'`);
        }
        case "Identifier":
          if (Ce.name !== "Infinity" && Ce.name !== "NaN" && Ce.name !== "undefined") throw tr(Ce, `Identifier '${Ce.name}'`);
          return;
        case "TemplateLiteral":
          if (ee(Ce.expressions)) throw tr(Ce.expressions[0], "'TemplateLiteral' with expression");
          for (let Ve of Ce.quasis) Uo(Ve);
          return;
        case "NullLiteral":
        case "BooleanLiteral":
        case "NumericLiteral":
        case "StringLiteral":
        case "TemplateElement":
          return;
        default:
          throw tr(Ce, `'${Ce.type}'`);
      }
    }
    var Oo = Pn(), Ki = { json: pn({ parse: Oo, hasPragma() {
      return !0;
    } }), json5: pn(Oo), jsonc: pn(Oo), "json-stringify": pn({ parse: Pn({ allowComments: !1 }), astFormat: "estree-json" }) }, Vd = Ki, $g = { ...gt, ...Vd };
    return h(v);
  });
})(iX);
var sX = iX.exports;
const Gpt = /* @__PURE__ */ Ln(sX), Ypt = /* @__PURE__ */ soe({
  __proto__: null,
  default: Gpt
}, [sX]);
var Kpt = Object.defineProperty, aX = (e) => {
  throw TypeError(e);
}, wT = (e, t) => {
  for (var n in t) Kpt(e, n, { get: t[n], enumerable: !0 });
}, lX = (e, t, n) => t.has(e) || aX("Cannot " + n), Gc = (e, t, n) => (lX(e, t, "read from private field"), t.get(e)), Jpt = (e, t, n) => t.has(e) ? aX("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, n), Xpt = (e, t, n, r) => (lX(e, t, "write to private field"), t.set(e, n), n), uX = {};
wT(uX, { languages: () => vZ, options: () => yZ, printers: () => bZ });
var Qpt = [{ linguistLanguageId: 183, name: "JavaScript", type: "programming", tmScope: "source.js", aceMode: "javascript", codemirrorMode: "javascript", codemirrorMimeType: "text/javascript", color: "#f1e05a", aliases: ["js", "node"], extensions: [".js", "._js", ".bones", ".cjs", ".es", ".es6", ".frag", ".gs", ".jake", ".javascript", ".jsb", ".jscad", ".jsfl", ".jslib", ".jsm", ".jspre", ".jss", ".mjs", ".njs", ".pac", ".sjs", ".ssjs", ".xsjs", ".xsjslib", ".wxs"], filenames: ["Jakefile"], interpreters: ["chakra", "d8", "gjs", "js", "node", "nodejs", "qjs", "rhino", "v8", "v8-shell", "zx"], parsers: ["babel", "acorn", "espree", "meriyah", "babel-flow", "babel-ts", "flow", "typescript"], vscodeLanguageIds: ["javascript", "mongo"] }, { linguistLanguageId: 183, name: "Flow", type: "programming", tmScope: "source.js", aceMode: "javascript", codemirrorMode: "javascript", codemirrorMimeType: "text/javascript", color: "#f1e05a", aliases: [], extensions: [".js.flow"], filenames: [], interpreters: ["chakra", "d8", "gjs", "js", "node", "nodejs", "qjs", "rhino", "v8", "v8-shell"], parsers: ["flow", "babel-flow"], vscodeLanguageIds: ["javascript"] }, { linguistLanguageId: 183, name: "JSX", type: "programming", tmScope: "source.js.jsx", aceMode: "javascript", codemirrorMode: "jsx", codemirrorMimeType: "text/jsx", color: void 0, aliases: void 0, extensions: [".jsx"], filenames: void 0, interpreters: void 0, parsers: ["babel", "babel-flow", "babel-ts", "flow", "typescript", "espree", "meriyah"], vscodeLanguageIds: ["javascriptreact"], group: "JavaScript" }, { linguistLanguageId: 378, name: "TypeScript", type: "programming", color: "#3178c6", aliases: ["ts"], interpreters: ["deno", "ts-node"], extensions: [".ts", ".cts", ".mts"], tmScope: "source.ts", aceMode: "typescript", codemirrorMode: "javascript", codemirrorMimeType: "application/typescript", parsers: ["typescript", "babel-ts"], vscodeLanguageIds: ["typescript"] }, { linguistLanguageId: 94901924, name: "TSX", type: "programming", color: "#3178c6", group: "TypeScript", extensions: [".tsx"], tmScope: "source.tsx", aceMode: "javascript", codemirrorMode: "jsx", codemirrorMimeType: "text/jsx", parsers: ["typescript", "babel-ts"], vscodeLanguageIds: ["typescriptreact"] }], cX = {};
wT(cX, { canAttachComment: () => imt, embed: () => Hmt, experimentalFeatures: () => H0t, getCommentChildNodes: () => omt, getVisitorKeys: () => fX, handleComments: () => NX, insertPragma: () => igt, isBlockComment: () => Za, isGap: () => smt, massageAstNode: () => rht, print: () => W0t, printComment: () => Cht, willPrintOwnComments: () => WX });
var Zpt = (e, t, n, r) => {
  if (!(e && t == null)) return t.replaceAll ? t.replaceAll(n, r) : n.global ? t.replace(n, r) : t.split(n).join(r);
}, yo = Zpt, eft = (e, t, n) => {
  if (!(e && t == null)) return Array.isArray(t) || typeof t == "string" ? t[n < 0 ? t.length + n : n] : t.at(n);
}, ur = eft;
function tft(e) {
  return e !== null && typeof e == "object";
}
var nft = tft;
function* rft(e, t) {
  let { getVisitorKeys: n, filter: r = () => !0 } = t, i = (o) => nft(o) && r(o);
  for (let o of n(e)) {
    let s = e[o];
    if (Array.isArray(s)) for (let a of s) i(a) && (yield a);
    else i(s) && (yield s);
  }
}
function* ift(e, t) {
  let n = [e];
  for (let r = 0; r < n.length; r++) {
    let i = n[r];
    for (let o of rft(i, t)) yield o, n.push(o);
  }
}
function oft(e, { getVisitorKeys: t, predicate: n }) {
  for (let r of ift(e, { getVisitorKeys: t })) if (n(r)) return !0;
  return !1;
}
var sft = () => /[#*0-9]\uFE0F?\u20E3|[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23ED-\u23EF\u23F1\u23F2\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB\u25FC\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u267F\u2692\u2694-\u2697\u2699\u269B\u269C\u26A0\u26A7\u26AA\u26B0\u26B1\u26BD\u26BE\u26C4\u26C8\u26CF\u26D1\u26E9\u26F0-\u26F5\u26F7\u26F8\u26FA\u2702\u2708\u2709\u270F\u2712\u2714\u2716\u271D\u2721\u2733\u2734\u2744\u2747\u2757\u2763\u27A1\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B55\u3030\u303D\u3297\u3299]\uFE0F?|[\u261D\u270C\u270D](?:\uFE0F|\uD83C[\uDFFB-\uDFFF])?|[\u270A\u270B](?:\uD83C[\uDFFB-\uDFFF])?|[\u23E9-\u23EC\u23F0\u23F3\u25FD\u2693\u26A1\u26AB\u26C5\u26CE\u26D4\u26EA\u26FD\u2705\u2728\u274C\u274E\u2753-\u2755\u2795-\u2797\u27B0\u27BF\u2B50]|\u26D3\uFE0F?(?:\u200D\uD83D\uDCA5)?|\u26F9(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|\u2764\uFE0F?(?:\u200D(?:\uD83D\uDD25|\uD83E\uDE79))?|\uD83C(?:[\uDC04\uDD70\uDD71\uDD7E\uDD7F\uDE02\uDE37\uDF21\uDF24-\uDF2C\uDF36\uDF7D\uDF96\uDF97\uDF99-\uDF9B\uDF9E\uDF9F\uDFCD\uDFCE\uDFD4-\uDFDF\uDFF5\uDFF7]\uFE0F?|[\uDF85\uDFC2\uDFC7](?:\uD83C[\uDFFB-\uDFFF])?|[\uDFC4\uDFCA](?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDFCB\uDFCC](?:\uFE0F|\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDCCF\uDD8E\uDD91-\uDD9A\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF43\uDF45-\uDF4A\uDF4C-\uDF7C\uDF7E-\uDF84\uDF86-\uDF93\uDFA0-\uDFC1\uDFC5\uDFC6\uDFC8\uDFC9\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF8-\uDFFF]|\uDDE6\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF]|\uDDE7\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF]|\uDDE8\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF5\uDDF7\uDDFA-\uDDFF]|\uDDE9\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF]|\uDDEA\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA]|\uDDEB\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7]|\uDDEC\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE]|\uDDED\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA]|\uDDEE\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9]|\uDDEF\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5]|\uDDF0\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF]|\uDDF1\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE]|\uDDF2\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF]|\uDDF3\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF]|\uDDF4\uD83C\uDDF2|\uDDF5\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE]|\uDDF6\uD83C\uDDE6|\uDDF7\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC]|\uDDF8\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF]|\uDDF9\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF]|\uDDFA\uD83C[\uDDE6\uDDEC\uDDF2\uDDF3\uDDF8\uDDFE\uDDFF]|\uDDFB\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA]|\uDDFC\uD83C[\uDDEB\uDDF8]|\uDDFD\uD83C\uDDF0|\uDDFE\uD83C[\uDDEA\uDDF9]|\uDDFF\uD83C[\uDDE6\uDDF2\uDDFC]|\uDF44(?:\u200D\uD83D\uDFEB)?|\uDF4B(?:\u200D\uD83D\uDFE9)?|\uDFC3(?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D(?:[\u2640\u2642]\uFE0F?(?:\u200D\u27A1\uFE0F?)?|\u27A1\uFE0F?))?|\uDFF3\uFE0F?(?:\u200D(?:\u26A7\uFE0F?|\uD83C\uDF08))?|\uDFF4(?:\u200D\u2620\uFE0F?|\uDB40\uDC67\uDB40\uDC62\uDB40(?:\uDC65\uDB40\uDC6E\uDB40\uDC67|\uDC73\uDB40\uDC63\uDB40\uDC74|\uDC77\uDB40\uDC6C\uDB40\uDC73)\uDB40\uDC7F)?)|\uD83D(?:[\uDC3F\uDCFD\uDD49\uDD4A\uDD6F\uDD70\uDD73\uDD76-\uDD79\uDD87\uDD8A-\uDD8D\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA\uDECB\uDECD-\uDECF\uDEE0-\uDEE5\uDEE9\uDEF0\uDEF3]\uFE0F?|[\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC6B-\uDC6D\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDC8F\uDC91\uDCAA\uDD7A\uDD95\uDD96\uDE4C\uDE4F\uDEC0\uDECC](?:\uD83C[\uDFFB-\uDFFF])?|[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4\uDEB5](?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDD74\uDD90](?:\uFE0F|\uD83C[\uDFFB-\uDFFF])?|[\uDC00-\uDC07\uDC09-\uDC14\uDC16-\uDC25\uDC27-\uDC3A\uDC3C-\uDC3E\uDC40\uDC44\uDC45\uDC51-\uDC65\uDC6A\uDC79-\uDC7B\uDC7D-\uDC80\uDC84\uDC88-\uDC8E\uDC90\uDC92-\uDCA9\uDCAB-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDDA4\uDDFB-\uDE2D\uDE2F-\uDE34\uDE37-\uDE41\uDE43\uDE44\uDE48-\uDE4A\uDE80-\uDEA2\uDEA4-\uDEB3\uDEB7-\uDEBF\uDEC1-\uDEC5\uDED0-\uDED2\uDED5-\uDED7\uDEDC-\uDEDF\uDEEB\uDEEC\uDEF4-\uDEFC\uDFE0-\uDFEB\uDFF0]|\uDC08(?:\u200D\u2B1B)?|\uDC15(?:\u200D\uD83E\uDDBA)?|\uDC26(?:\u200D(?:\u2B1B|\uD83D\uDD25))?|\uDC3B(?:\u200D\u2744\uFE0F?)?|\uDC41\uFE0F?(?:\u200D\uD83D\uDDE8\uFE0F?)?|\uDC68(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDC68\uDC69]\u200D\uD83D(?:\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?)|[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?)|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]))|\uD83C(?:\uDFFB(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFC-\uDFFF])))?|\uDFFC(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFB\uDFFD-\uDFFF])))?|\uDFFD(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])))?|\uDFFE(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFB-\uDFFD\uDFFF])))?|\uDFFF(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFB-\uDFFE])))?))?|\uDC69(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?[\uDC68\uDC69]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?|\uDC69\u200D\uD83D(?:\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?))|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]))|\uD83C(?:\uDFFB(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFC-\uDFFF])))?|\uDFFC(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB\uDFFD-\uDFFF])))?|\uDFFD(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])))?|\uDFFE(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB-\uDFFD\uDFFF])))?|\uDFFF(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB-\uDFFE])))?))?|\uDC6F(?:\u200D[\u2640\u2642]\uFE0F?)?|\uDD75(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|\uDE2E(?:\u200D\uD83D\uDCA8)?|\uDE35(?:\u200D\uD83D\uDCAB)?|\uDE36(?:\u200D\uD83C\uDF2B\uFE0F?)?|\uDE42(?:\u200D[\u2194\u2195]\uFE0F?)?|\uDEB6(?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D(?:[\u2640\u2642]\uFE0F?(?:\u200D\u27A1\uFE0F?)?|\u27A1\uFE0F?))?)|\uD83E(?:[\uDD0C\uDD0F\uDD18-\uDD1F\uDD30-\uDD34\uDD36\uDD77\uDDB5\uDDB6\uDDBB\uDDD2\uDDD3\uDDD5\uDEC3-\uDEC5\uDEF0\uDEF2-\uDEF8](?:\uD83C[\uDFFB-\uDFFF])?|[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD\uDDCF\uDDD4\uDDD6-\uDDDD](?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDDDE\uDDDF](?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDD0D\uDD0E\uDD10-\uDD17\uDD20-\uDD25\uDD27-\uDD2F\uDD3A\uDD3F-\uDD45\uDD47-\uDD76\uDD78-\uDDB4\uDDB7\uDDBA\uDDBC-\uDDCC\uDDD0\uDDE0-\uDDFF\uDE70-\uDE7C\uDE80-\uDE88\uDE90-\uDEBD\uDEBF-\uDEC2\uDECE-\uDEDB\uDEE0-\uDEE8]|\uDD3C(?:\u200D[\u2640\u2642]\uFE0F?|\uD83C[\uDFFB-\uDFFF])?|\uDDCE(?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D(?:[\u2640\u2642]\uFE0F?(?:\u200D\u27A1\uFE0F?)?|\u27A1\uFE0F?))?|\uDDD1(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83E\uDDD1|\uDDD1\u200D\uD83E\uDDD2(?:\u200D\uD83E\uDDD2)?|\uDDD2(?:\u200D\uD83E\uDDD2)?))|\uD83C(?:\uDFFB(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFC-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?|\uDFFC(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB\uDFFD-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?|\uDFFD(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?|\uDFFE(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB-\uDFFD\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?|\uDFFF(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB-\uDFFE]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?))?|\uDEF1(?:\uD83C(?:\uDFFB(?:\u200D\uD83E\uDEF2\uD83C[\uDFFC-\uDFFF])?|\uDFFC(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB\uDFFD-\uDFFF])?|\uDFFD(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])?|\uDFFE(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB-\uDFFD\uDFFF])?|\uDFFF(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB-\uDFFE])?))?)/g;
function aft(e) {
  return e === 12288 || e >= 65281 && e <= 65376 || e >= 65504 && e <= 65510;
}
function lft(e) {
  return e >= 4352 && e <= 4447 || e === 8986 || e === 8987 || e === 9001 || e === 9002 || e >= 9193 && e <= 9196 || e === 9200 || e === 9203 || e === 9725 || e === 9726 || e === 9748 || e === 9749 || e >= 9800 && e <= 9811 || e === 9855 || e === 9875 || e === 9889 || e === 9898 || e === 9899 || e === 9917 || e === 9918 || e === 9924 || e === 9925 || e === 9934 || e === 9940 || e === 9962 || e === 9970 || e === 9971 || e === 9973 || e === 9978 || e === 9981 || e === 9989 || e === 9994 || e === 9995 || e === 10024 || e === 10060 || e === 10062 || e >= 10067 && e <= 10069 || e === 10071 || e >= 10133 && e <= 10135 || e === 10160 || e === 10175 || e === 11035 || e === 11036 || e === 11088 || e === 11093 || e >= 11904 && e <= 11929 || e >= 11931 && e <= 12019 || e >= 12032 && e <= 12245 || e >= 12272 && e <= 12287 || e >= 12289 && e <= 12350 || e >= 12353 && e <= 12438 || e >= 12441 && e <= 12543 || e >= 12549 && e <= 12591 || e >= 12593 && e <= 12686 || e >= 12688 && e <= 12771 || e >= 12783 && e <= 12830 || e >= 12832 && e <= 12871 || e >= 12880 && e <= 19903 || e >= 19968 && e <= 42124 || e >= 42128 && e <= 42182 || e >= 43360 && e <= 43388 || e >= 44032 && e <= 55203 || e >= 63744 && e <= 64255 || e >= 65040 && e <= 65049 || e >= 65072 && e <= 65106 || e >= 65108 && e <= 65126 || e >= 65128 && e <= 65131 || e >= 94176 && e <= 94180 || e === 94192 || e === 94193 || e >= 94208 && e <= 100343 || e >= 100352 && e <= 101589 || e >= 101632 && e <= 101640 || e >= 110576 && e <= 110579 || e >= 110581 && e <= 110587 || e === 110589 || e === 110590 || e >= 110592 && e <= 110882 || e === 110898 || e >= 110928 && e <= 110930 || e === 110933 || e >= 110948 && e <= 110951 || e >= 110960 && e <= 111355 || e === 126980 || e === 127183 || e === 127374 || e >= 127377 && e <= 127386 || e >= 127488 && e <= 127490 || e >= 127504 && e <= 127547 || e >= 127552 && e <= 127560 || e === 127568 || e === 127569 || e >= 127584 && e <= 127589 || e >= 127744 && e <= 127776 || e >= 127789 && e <= 127797 || e >= 127799 && e <= 127868 || e >= 127870 && e <= 127891 || e >= 127904 && e <= 127946 || e >= 127951 && e <= 127955 || e >= 127968 && e <= 127984 || e === 127988 || e >= 127992 && e <= 128062 || e === 128064 || e >= 128066 && e <= 128252 || e >= 128255 && e <= 128317 || e >= 128331 && e <= 128334 || e >= 128336 && e <= 128359 || e === 128378 || e === 128405 || e === 128406 || e === 128420 || e >= 128507 && e <= 128591 || e >= 128640 && e <= 128709 || e === 128716 || e >= 128720 && e <= 128722 || e >= 128725 && e <= 128727 || e >= 128732 && e <= 128735 || e === 128747 || e === 128748 || e >= 128756 && e <= 128764 || e >= 128992 && e <= 129003 || e === 129008 || e >= 129292 && e <= 129338 || e >= 129340 && e <= 129349 || e >= 129351 && e <= 129535 || e >= 129648 && e <= 129660 || e >= 129664 && e <= 129672 || e >= 129680 && e <= 129725 || e >= 129727 && e <= 129733 || e >= 129742 && e <= 129755 || e >= 129760 && e <= 129768 || e >= 129776 && e <= 129784 || e >= 131072 && e <= 196605 || e >= 196608 && e <= 262141;
}
var uft = (e) => !(aft(e) || lft(e)), cft = /[^\x20-\x7F]/u;
function dft(e) {
  if (!e) return 0;
  if (!cft.test(e)) return e.length;
  e = e.replace(sft(), "  ");
  let t = 0;
  for (let n of e) {
    let r = n.codePointAt(0);
    r <= 31 || r >= 127 && r <= 159 || r >= 768 && r <= 879 || (t += uft(r) ? 1 : 2);
  }
  return t;
}
var Im = dft;
function PN(e) {
  return (t, n, r) => {
    let i = !!(r != null && r.backwards);
    if (n === !1) return !1;
    let { length: o } = t, s = n;
    for (; s >= 0 && s < o; ) {
      let a = t.charAt(s);
      if (e instanceof RegExp) {
        if (!e.test(a)) return s;
      } else if (!e.includes(a)) return s;
      i ? s-- : s++;
    }
    return s === -1 || s === o ? s : !1;
  };
}
var Fm = PN(" 	"), pft = PN(",; 	"), fft = PN(/[^\n\r]/u);
function hft(e, t, n) {
  let r = !!(n != null && n.backwards);
  if (t === !1) return !1;
  let i = e.charAt(t);
  if (r) {
    if (e.charAt(t - 1) === "\r" && i === `
`) return t - 2;
    if (i === `
` || i === "\r" || i === "\u2028" || i === "\u2029") return t - 1;
  } else {
    if (i === "\r" && e.charAt(t + 1) === `
`) return t + 2;
    if (i === `
` || i === "\r" || i === "\u2028" || i === "\u2029") return t + 1;
  }
  return t;
}
var $m = hft;
function mft(e, t, n = {}) {
  let r = Fm(e, n.backwards ? t - 1 : t, n), i = $m(e, r, n);
  return r !== i;
}
var oa = mft;
function gft(e, t) {
  if (t === !1) return !1;
  if (e.charAt(t) === "/" && e.charAt(t + 1) === "*") {
    for (let n = t + 2; n < e.length; ++n) if (e.charAt(n) === "*" && e.charAt(n + 1) === "/") return n + 2;
  }
  return t;
}
var kN = gft;
function yft(e, t) {
  return t === !1 ? !1 : e.charAt(t) === "/" && e.charAt(t + 1) === "/" ? fft(e, t) : t;
}
var ON = yft;
function bft(e, t) {
  let n = null, r = t;
  for (; r !== n; ) n = r, r = pft(e, r), r = kN(e, r), r = Fm(e, r);
  return r = ON(e, r), r = $m(e, r), r !== !1 && oa(e, r);
}
var IN = bft;
function vft(e) {
  return Array.isArray(e) && e.length > 0;
}
var dr = vft, wx = "'", Y4 = '"';
function xft(e, t) {
  let n = t === !0 || t === wx ? wx : Y4, r = n === wx ? Y4 : wx, i = 0, o = 0;
  for (let s of e) s === n ? i++ : s === r && o++;
  return i > o ? r : n;
}
var dX = xft;
function Dft(e, t, n) {
  let r = t === '"' ? "'" : '"', i = yo(!1, e, /\\(.)|(["'])/gsu, (o, s, a) => s === r ? s : a === t ? "\\" + a : a || (n && /^[^\n\r"'0-7\\bfnrt-vx\u2028\u2029]$/u.test(s) ? s : "\\" + s));
  return t + i + t;
}
var Cft = Dft;
function Eft(e, t) {
  let n = e.slice(1, -1), r = t.parser === "json" || t.parser === "jsonc" || t.parser === "json5" && t.quoteProps === "preserve" && !t.singleQuote ? '"' : t.__isInHtmlAttribute ? "'" : dX(n, t.singleQuote);
  return Cft(n, r, !(t.parser === "css" || t.parser === "less" || t.parser === "scss" || t.__embeddedInHtml));
}
var Nm = Eft;
function ni(e) {
  var t, n, r;
  let i = ((t = e.range) == null ? void 0 : t[0]) ?? e.start, o = (r = ((n = e.declaration) == null ? void 0 : n.decorators) ?? e.decorators) == null ? void 0 : r[0];
  return o ? Math.min(ni(o), i) : i;
}
function Zn(e) {
  var t;
  return ((t = e.range) == null ? void 0 : t[1]) ?? e.end;
}
function PT(e, t) {
  let n = ni(e);
  return Number.isInteger(n) && n === ni(t);
}
function Tft(e, t) {
  let n = Zn(e);
  return Number.isInteger(n) && n === Zn(t);
}
function Sft(e, t) {
  return PT(e, t) && Tft(e, t);
}
var Vy = null;
function T0(e) {
  if (Vy !== null && typeof Vy.property) {
    let t = Vy;
    return Vy = T0.prototype = null, t;
  }
  return Vy = T0.prototype = e ?? /* @__PURE__ */ Object.create(null), new T0();
}
var Aft = 10;
for (let e = 0; e <= Aft; e++) T0();
function wft(e) {
  return T0(e);
}
function Pft(e, t = "type") {
  wft(e);
  function n(r) {
    let i = r[t], o = e[i];
    if (!Array.isArray(o)) throw Object.assign(new Error(`Missing visitor keys for '${i}'.`), { node: r });
    return o;
  }
  return n;
}
var pX = Pft, kft = { ArrayExpression: ["elements"], AssignmentExpression: ["left", "right"], BinaryExpression: ["left", "right"], InterpreterDirective: [], Directive: ["value"], DirectiveLiteral: [], BlockStatement: ["directives", "body"], BreakStatement: ["label"], CallExpression: ["callee", "arguments", "typeParameters", "typeArguments"], CatchClause: ["param", "body"], ConditionalExpression: ["test", "consequent", "alternate"], ContinueStatement: ["label"], DebuggerStatement: [], DoWhileStatement: ["test", "body"], EmptyStatement: [], ExpressionStatement: ["expression"], File: ["program"], ForInStatement: ["left", "right", "body"], ForStatement: ["init", "test", "update", "body"], FunctionDeclaration: ["id", "params", "body", "returnType", "typeParameters", "predicate"], FunctionExpression: ["id", "params", "body", "returnType", "typeParameters"], Identifier: ["typeAnnotation", "decorators"], IfStatement: ["test", "consequent", "alternate"], LabeledStatement: ["label", "body"], StringLiteral: [], NumericLiteral: [], NullLiteral: [], BooleanLiteral: [], RegExpLiteral: [], LogicalExpression: ["left", "right"], MemberExpression: ["object", "property"], NewExpression: ["callee", "arguments", "typeParameters", "typeArguments"], Program: ["directives", "body"], ObjectExpression: ["properties"], ObjectMethod: ["key", "params", "body", "decorators", "returnType", "typeParameters"], ObjectProperty: ["key", "value", "decorators"], RestElement: ["argument", "typeAnnotation", "decorators"], ReturnStatement: ["argument"], SequenceExpression: ["expressions"], ParenthesizedExpression: ["expression"], SwitchCase: ["test", "consequent"], SwitchStatement: ["discriminant", "cases"], ThisExpression: [], ThrowStatement: ["argument"], TryStatement: ["block", "handler", "finalizer"], UnaryExpression: ["argument"], UpdateExpression: ["argument"], VariableDeclaration: ["declarations"], VariableDeclarator: ["id", "init"], WhileStatement: ["test", "body"], WithStatement: ["object", "body"], AssignmentPattern: ["left", "right", "decorators", "typeAnnotation"], ArrayPattern: ["elements", "typeAnnotation", "decorators"], ArrowFunctionExpression: ["params", "body", "returnType", "typeParameters", "predicate"], ClassBody: ["body"], ClassExpression: ["id", "body", "superClass", "mixins", "typeParameters", "superTypeParameters", "implements", "decorators", "superTypeArguments"], ClassDeclaration: ["id", "body", "superClass", "mixins", "typeParameters", "superTypeParameters", "implements", "decorators", "superTypeArguments"], ExportAllDeclaration: ["source", "attributes", "exported"], ExportDefaultDeclaration: ["declaration"], ExportNamedDeclaration: ["declaration", "specifiers", "source", "attributes"], ExportSpecifier: ["local", "exported"], ForOfStatement: ["left", "right", "body"], ImportDeclaration: ["specifiers", "source", "attributes"], ImportDefaultSpecifier: ["local"], ImportNamespaceSpecifier: ["local"], ImportSpecifier: ["local", "imported"], ImportExpression: ["source", "options", "attributes"], MetaProperty: ["meta", "property"], ClassMethod: ["key", "params", "body", "decorators", "returnType", "typeParameters"], ObjectPattern: ["properties", "typeAnnotation", "decorators"], SpreadElement: ["argument"], Super: [], TaggedTemplateExpression: ["tag", "quasi", "typeParameters", "typeArguments"], TemplateElement: [], TemplateLiteral: ["quasis", "expressions"], YieldExpression: ["argument"], AwaitExpression: ["argument"], Import: [], BigIntLiteral: [], ExportNamespaceSpecifier: ["exported"], OptionalMemberExpression: ["object", "property"], OptionalCallExpression: ["callee", "arguments", "typeParameters", "typeArguments"], ClassProperty: ["key", "value", "typeAnnotation", "decorators", "variance"], ClassAccessorProperty: ["key", "value", "typeAnnotation", "decorators"], ClassPrivateProperty: ["key", "value", "decorators", "typeAnnotation", "variance"], ClassPrivateMethod: ["key", "params", "body", "decorators", "returnType", "typeParameters"], PrivateName: ["id"], StaticBlock: ["body"], AnyTypeAnnotation: [], ArrayTypeAnnotation: ["elementType"], BooleanTypeAnnotation: [], BooleanLiteralTypeAnnotation: [], NullLiteralTypeAnnotation: [], ClassImplements: ["id", "typeParameters"], DeclareClass: ["id", "typeParameters", "extends", "mixins", "implements", "body"], DeclareFunction: ["id", "predicate"], DeclareInterface: ["id", "typeParameters", "extends", "body"], DeclareModule: ["id", "body"], DeclareModuleExports: ["typeAnnotation"], DeclareTypeAlias: ["id", "typeParameters", "right"], DeclareOpaqueType: ["id", "typeParameters", "supertype"], DeclareVariable: ["id"], DeclareExportDeclaration: ["declaration", "specifiers", "source"], DeclareExportAllDeclaration: ["source"], DeclaredPredicate: ["value"], ExistsTypeAnnotation: [], FunctionTypeAnnotation: ["typeParameters", "params", "rest", "returnType", "this"], FunctionTypeParam: ["name", "typeAnnotation"], GenericTypeAnnotation: ["id", "typeParameters"], InferredPredicate: [], InterfaceExtends: ["id", "typeParameters"], InterfaceDeclaration: ["id", "typeParameters", "extends", "body"], InterfaceTypeAnnotation: ["extends", "body"], IntersectionTypeAnnotation: ["types"], MixedTypeAnnotation: [], EmptyTypeAnnotation: [], NullableTypeAnnotation: ["typeAnnotation"], NumberLiteralTypeAnnotation: [], NumberTypeAnnotation: [], ObjectTypeAnnotation: ["properties", "indexers", "callProperties", "internalSlots"], ObjectTypeInternalSlot: ["id", "value"], ObjectTypeCallProperty: ["value"], ObjectTypeIndexer: ["id", "key", "value", "variance"], ObjectTypeProperty: ["key", "value", "variance"], ObjectTypeSpreadProperty: ["argument"], OpaqueType: ["id", "typeParameters", "supertype", "impltype"], QualifiedTypeIdentifier: ["id", "qualification"], StringLiteralTypeAnnotation: [], StringTypeAnnotation: [], SymbolTypeAnnotation: [], ThisTypeAnnotation: [], TupleTypeAnnotation: ["types", "elementTypes"], TypeofTypeAnnotation: ["argument", "typeArguments"], TypeAlias: ["id", "typeParameters", "right"], TypeAnnotation: ["typeAnnotation"], TypeCastExpression: ["expression", "typeAnnotation"], TypeParameter: ["bound", "default", "variance"], TypeParameterDeclaration: ["params"], TypeParameterInstantiation: ["params"], UnionTypeAnnotation: ["types"], Variance: [], VoidTypeAnnotation: [], EnumDeclaration: ["id", "body"], EnumBooleanBody: ["members"], EnumNumberBody: ["members"], EnumStringBody: ["members"], EnumSymbolBody: ["members"], EnumBooleanMember: ["id", "init"], EnumNumberMember: ["id", "init"], EnumStringMember: ["id", "init"], EnumDefaultedMember: ["id"], IndexedAccessType: ["objectType", "indexType"], OptionalIndexedAccessType: ["objectType", "indexType"], JSXAttribute: ["name", "value"], JSXClosingElement: ["name"], JSXElement: ["openingElement", "children", "closingElement"], JSXEmptyExpression: [], JSXExpressionContainer: ["expression"], JSXSpreadChild: ["expression"], JSXIdentifier: [], JSXMemberExpression: ["object", "property"], JSXNamespacedName: ["namespace", "name"], JSXOpeningElement: ["name", "attributes", "typeArguments", "typeParameters"], JSXSpreadAttribute: ["argument"], JSXText: [], JSXFragment: ["openingFragment", "children", "closingFragment"], JSXOpeningFragment: [], JSXClosingFragment: [], Noop: [], Placeholder: [], V8IntrinsicIdentifier: [], ArgumentPlaceholder: [], BindExpression: ["object", "callee"], ImportAttribute: ["key", "value"], Decorator: ["expression"], DoExpression: ["body"], ExportDefaultSpecifier: ["exported"], RecordExpression: ["properties"], TupleExpression: ["elements"], DecimalLiteral: [], ModuleExpression: ["body"], TopicReference: [], PipelineTopicExpression: ["expression"], PipelineBareFunction: ["callee"], PipelinePrimaryTopicReference: [], TSParameterProperty: ["parameter", "decorators"], TSDeclareFunction: ["id", "typeParameters", "params", "returnType", "body"], TSDeclareMethod: ["decorators", "key", "typeParameters", "params", "returnType"], TSQualifiedName: ["left", "right"], TSCallSignatureDeclaration: ["typeParameters", "parameters", "typeAnnotation", "params", "returnType"], TSConstructSignatureDeclaration: ["typeParameters", "parameters", "typeAnnotation", "params", "returnType"], TSPropertySignature: ["key", "typeAnnotation"], TSMethodSignature: ["key", "typeParameters", "parameters", "typeAnnotation", "params", "returnType"], TSIndexSignature: ["parameters", "typeAnnotation"], TSAnyKeyword: [], TSBooleanKeyword: [], TSBigIntKeyword: [], TSIntrinsicKeyword: [], TSNeverKeyword: [], TSNullKeyword: [], TSNumberKeyword: [], TSObjectKeyword: [], TSStringKeyword: [], TSSymbolKeyword: [], TSUndefinedKeyword: [], TSUnknownKeyword: [], TSVoidKeyword: [], TSThisType: [], TSFunctionType: ["typeParameters", "parameters", "typeAnnotation", "params", "returnType"], TSConstructorType: ["typeParameters", "parameters", "typeAnnotation", "params", "returnType"], TSTypeReference: ["typeName", "typeParameters", "typeArguments"], TSTypePredicate: ["parameterName", "typeAnnotation"], TSTypeQuery: ["exprName", "typeParameters", "typeArguments"], TSTypeLiteral: ["members"], TSArrayType: ["elementType"], TSTupleType: ["elementTypes"], TSOptionalType: ["typeAnnotation"], TSRestType: ["typeAnnotation"], TSNamedTupleMember: ["label", "elementType"], TSUnionType: ["types"], TSIntersectionType: ["types"], TSConditionalType: ["checkType", "extendsType", "trueType", "falseType"], TSInferType: ["typeParameter"], TSParenthesizedType: ["typeAnnotation"], TSTypeOperator: ["typeAnnotation"], TSIndexedAccessType: ["objectType", "indexType"], TSMappedType: ["typeParameter", "typeAnnotation", "nameType"], TSLiteralType: ["literal"], TSExpressionWithTypeArguments: ["expression", "typeParameters"], TSInterfaceDeclaration: ["id", "typeParameters", "extends", "body"], TSInterfaceBody: ["body"], TSTypeAliasDeclaration: ["id", "typeParameters", "typeAnnotation"], TSInstantiationExpression: ["expression", "typeParameters", "typeArguments"], TSAsExpression: ["expression", "typeAnnotation"], TSSatisfiesExpression: ["expression", "typeAnnotation"], TSTypeAssertion: ["typeAnnotation", "expression"], TSEnumDeclaration: ["id", "members"], TSEnumMember: ["id", "initializer"], TSModuleDeclaration: ["id", "body"], TSModuleBlock: ["body"], TSImportType: ["argument", "qualifier", "typeParameters", "typeArguments"], TSImportEqualsDeclaration: ["id", "moduleReference"], TSExternalModuleReference: ["expression"], TSNonNullExpression: ["expression"], TSExportAssignment: ["expression"], TSNamespaceExportDeclaration: ["id"], TSTypeAnnotation: ["typeAnnotation"], TSTypeParameterInstantiation: ["params"], TSTypeParameterDeclaration: ["params"], TSTypeParameter: ["constraint", "default", "name"], ChainExpression: ["expression"], ExperimentalRestProperty: ["argument"], ExperimentalSpreadProperty: ["argument"], Literal: [], MethodDefinition: ["decorators", "key", "value"], PrivateIdentifier: [], Property: ["key", "value"], PropertyDefinition: ["decorators", "key", "typeAnnotation", "value", "variance"], AccessorProperty: ["decorators", "key", "typeAnnotation", "value"], TSAbstractAccessorProperty: ["decorators", "key", "typeAnnotation"], TSAbstractKeyword: [], TSAbstractMethodDefinition: ["key", "value"], TSAbstractPropertyDefinition: ["decorators", "key", "typeAnnotation"], TSAsyncKeyword: [], TSClassImplements: ["expression", "typeArguments", "typeParameters"], TSDeclareKeyword: [], TSEmptyBodyFunctionExpression: ["id", "typeParameters", "params", "returnType"], TSEnumBody: ["members"], TSExportKeyword: [], TSInterfaceHeritage: ["expression", "typeArguments", "typeParameters"], TSPrivateKeyword: [], TSProtectedKeyword: [], TSPublicKeyword: [], TSReadonlyKeyword: [], TSStaticKeyword: [], TSTemplateLiteralType: ["quasis", "types"], AsConstExpression: ["expression"], AsExpression: ["expression", "typeAnnotation"], BigIntLiteralTypeAnnotation: [], BigIntTypeAnnotation: [], ComponentDeclaration: ["id", "params", "body", "typeParameters", "rendersType"], ComponentParameter: ["name", "local"], ComponentTypeAnnotation: ["params", "rest", "typeParameters", "rendersType"], ComponentTypeParameter: ["name", "typeAnnotation"], ConditionalTypeAnnotation: ["checkType", "extendsType", "trueType", "falseType"], DeclareComponent: ["id", "params", "rest", "typeParameters", "rendersType"], DeclareEnum: ["id", "body"], DeclareHook: ["id"], DeclareNamespace: ["id", "body"], EnumBigIntBody: ["members"], EnumBigIntMember: ["id", "init"], HookDeclaration: ["id", "params", "body", "typeParameters", "returnType"], HookTypeAnnotation: ["params", "returnType", "rest", "typeParameters"], InferTypeAnnotation: ["typeParameter"], KeyofTypeAnnotation: ["argument"], ObjectTypeMappedTypeProperty: ["keyTparam", "propType", "sourceType", "variance"], QualifiedTypeofIdentifier: ["qualification", "id"], TupleTypeLabeledElement: ["label", "elementType", "variance"], TupleTypeSpreadElement: ["label", "typeAnnotation"], TypeOperator: ["typeAnnotation"], TypePredicate: ["parameterName", "typeAnnotation", "asserts"], NGRoot: ["node"], NGPipeExpression: ["left", "right", "arguments"], NGChainedExpression: ["expressions"], NGEmptyExpression: [], NGMicrosyntax: ["body"], NGMicrosyntaxKey: [], NGMicrosyntaxExpression: ["expression", "alias"], NGMicrosyntaxKeyedExpression: ["key", "expression"], NGMicrosyntaxLet: ["key", "value"], NGMicrosyntaxAs: ["key", "alias"], JsExpressionRoot: ["node"], JsonRoot: ["node"], TSJSDocAllType: [], TSJSDocUnknownType: [], TSJSDocNullableType: ["typeAnnotation"], TSJSDocNonNullableType: ["typeAnnotation"], NeverTypeAnnotation: [], UndefinedTypeAnnotation: [], UnknownTypeAnnotation: [], SatisfiesExpression: ["expression", "typeAnnotation"] }, Oft = pX(kft), fX = Oft;
function Ift(e) {
  let t = new Set(e);
  return (n) => t.has(n == null ? void 0 : n.type);
}
var Ir = Ift, Fft = Ir(["Block", "CommentBlock", "MultiLine"]), Za = Fft, $ft = Ir(["AnyTypeAnnotation", "ThisTypeAnnotation", "NumberTypeAnnotation", "VoidTypeAnnotation", "BooleanTypeAnnotation", "BigIntTypeAnnotation", "SymbolTypeAnnotation", "StringTypeAnnotation", "NeverTypeAnnotation", "UndefinedTypeAnnotation", "UnknownTypeAnnotation", "EmptyTypeAnnotation", "MixedTypeAnnotation"]), hX = $ft;
function Nft(e, t) {
  let n = t.split(".");
  for (let r = n.length - 1; r >= 0; r--) {
    let i = n[r];
    if (r === 0) return e.type === "Identifier" && e.name === i;
    if (e.type !== "MemberExpression" || e.optional || e.computed || e.property.type !== "Identifier" || e.property.name !== i) return !1;
    e = e.object;
  }
}
function Mft(e, t) {
  return t.some((n) => Nft(e, n));
}
var Rft = Mft;
function _ft({ type: e }) {
  return e.startsWith("TS") && e.endsWith("Keyword");
}
var mX = _ft;
function vO(e, t) {
  return t(e) || oft(e, { getVisitorKeys: fX, predicate: t });
}
function FN(e) {
  return e.type === "AssignmentExpression" || e.type === "BinaryExpression" || e.type === "LogicalExpression" || e.type === "NGPipeExpression" || e.type === "ConditionalExpression" || or(e) || mi(e) || e.type === "SequenceExpression" || e.type === "TaggedTemplateExpression" || e.type === "BindExpression" || e.type === "UpdateExpression" && !e.prefix || iu(e) || e.type === "TSNonNullExpression" || e.type === "ChainExpression";
}
function Lft(e) {
  return e.expressions ? e.expressions[0] : e.left ?? e.test ?? e.callee ?? e.object ?? e.tag ?? e.argument ?? e.expression;
}
function gX(e) {
  if (e.expressions) return ["expressions", 0];
  if (e.left) return ["left"];
  if (e.test) return ["test"];
  if (e.object) return ["object"];
  if (e.callee) return ["callee"];
  if (e.tag) return ["tag"];
  if (e.argument) return ["argument"];
  if (e.expression) return ["expression"];
  throw new Error("Unexpected node has no left side.");
}
var kT = Ir(["Line", "CommentLine", "SingleLine", "HashbangComment", "HTMLOpen", "HTMLClose", "Hashbang", "InterpreterDirective"]), Bft = Ir(["ExportDefaultDeclaration", "DeclareExportDeclaration", "ExportNamedDeclaration", "ExportAllDeclaration", "DeclareExportAllDeclaration"]), Eo = Ir(["ArrayExpression", "TupleExpression"]), Cl = Ir(["ObjectExpression", "RecordExpression"]);
function jft(e) {
  return e.type === "LogicalExpression" && e.operator === "??";
}
function fc(e) {
  return e.type === "NumericLiteral" || e.type === "Literal" && typeof e.value == "number";
}
function yX(e) {
  return e.type === "UnaryExpression" && (e.operator === "+" || e.operator === "-") && fc(e.argument);
}
function us(e) {
  return !!(e && (e.type === "StringLiteral" || e.type === "Literal" && typeof e.value == "string"));
}
function bX(e) {
  return e.type === "RegExpLiteral" || e.type === "Literal" && !!e.regex;
}
var $N = Ir(["Literal", "BooleanLiteral", "BigIntLiteral", "DecimalLiteral", "DirectiveLiteral", "NullLiteral", "NumericLiteral", "RegExpLiteral", "StringLiteral"]), Vft = Ir(["Identifier", "ThisExpression", "Super", "PrivateName", "PrivateIdentifier", "Import"]), vd = Ir(["ObjectTypeAnnotation", "TSTypeLiteral", "TSMappedType"]), hb = Ir(["FunctionExpression", "ArrowFunctionExpression"]);
function zft(e) {
  return e.type === "FunctionExpression" || e.type === "ArrowFunctionExpression" && e.body.type === "BlockStatement";
}
function eP(e) {
  return or(e) && e.callee.type === "Identifier" && ["async", "inject", "fakeAsync", "waitForAsync"].includes(e.callee.name);
}
var oo = Ir(["JSXElement", "JSXFragment"]);
function OT(e) {
  return e.method && e.kind === "init" || e.kind === "get" || e.kind === "set";
}
function vX(e) {
  return (e.type === "ObjectTypeProperty" || e.type === "ObjectTypeInternalSlot") && !e.static && !e.method && e.kind !== "get" && e.kind !== "set" && e.value.type === "FunctionTypeAnnotation";
}
function Uft(e) {
  return (e.type === "TypeAnnotation" || e.type === "TSTypeAnnotation") && e.typeAnnotation.type === "FunctionTypeAnnotation" && !e.static && !PT(e, e.typeAnnotation);
}
var hc = Ir(["BinaryExpression", "LogicalExpression", "NGPipeExpression"]);
function Ih(e) {
  return mi(e) || e.type === "BindExpression" && !!e.object;
}
var Wft = Ir(["TSThisType", "NullLiteralTypeAnnotation", "BooleanLiteralTypeAnnotation", "StringLiteralTypeAnnotation", "BigIntLiteralTypeAnnotation", "NumberLiteralTypeAnnotation", "TSLiteralType", "TSTemplateLiteralType"]);
function NN(e) {
  return mX(e) || hX(e) || Wft(e) || (e.type === "GenericTypeAnnotation" || e.type === "TSTypeReference") && !e.typeParameters && !e.typeArguments;
}
function Hft(e) {
  return e.type === "Identifier" && (e.name === "beforeEach" || e.name === "beforeAll" || e.name === "afterEach" || e.name === "afterAll");
}
var qft = ["it", "it.only", "it.skip", "describe", "describe.only", "describe.skip", "test", "test.only", "test.skip", "test.step", "test.describe", "test.describe.only", "test.describe.parallel", "test.describe.parallel.only", "test.describe.serial", "test.describe.serial.only", "skip", "xit", "xdescribe", "xtest", "fit", "fdescribe", "ftest"];
function Gft(e) {
  return Rft(e, qft);
}
function IT(e, t) {
  if ((e == null ? void 0 : e.type) !== "CallExpression" || e.optional) return !1;
  let n = el(e);
  if (n.length === 1) {
    if (eP(e) && IT(t)) return hb(n[0]);
    if (Hft(e.callee)) return eP(n[0]);
  } else if ((n.length === 2 || n.length === 3) && (n[0].type === "TemplateLiteral" || us(n[0])) && Gft(e.callee)) return n[2] && !fc(n[2]) ? !1 : (n.length === 2 ? hb(n[1]) : zft(n[1]) && jo(n[1]).length <= 1) || eP(n[1]);
  return !1;
}
var xX = (e) => (t) => ((t == null ? void 0 : t.type) === "ChainExpression" && (t = t.expression), e(t)), or = xX(Ir(["CallExpression", "OptionalCallExpression"])), mi = xX(Ir(["MemberExpression", "OptionalMemberExpression"]));
function K4(e, t = 5) {
  return DX(e, t) <= t;
}
function DX(e, t) {
  let n = 0;
  for (let r in e) {
    let i = e[r];
    if (i && typeof i == "object" && typeof i.type == "string" && (n++, n += DX(i, t - n)), n > t) return n;
  }
  return n;
}
var Yft = 0.25;
function MN(e, t) {
  let { printWidth: n } = t;
  if (kt(e)) return !1;
  let r = n * Yft;
  if (e.type === "ThisExpression" || e.type === "Identifier" && e.name.length <= r || yX(e) && !kt(e.argument)) return !0;
  let i = e.type === "Literal" && "regex" in e && e.regex.pattern || e.type === "RegExpLiteral" && e.pattern;
  return i ? i.length <= r : us(e) ? Nm(qa(e), t).length <= r : e.type === "TemplateLiteral" ? e.expressions.length === 0 && e.quasis[0].value.raw.length <= r && !e.quasis[0].value.raw.includes(`
`) : e.type === "UnaryExpression" ? MN(e.argument, { printWidth: n }) : e.type === "CallExpression" && e.arguments.length === 0 && e.callee.type === "Identifier" ? e.callee.name.length <= r - 2 : $N(e);
}
function of(e, t) {
  return oo(t) ? FT(t) : kt(t, qt.Leading, (n) => oa(e, Zn(n)));
}
function J4(e) {
  return e.quasis.some((t) => t.value.raw.includes(`
`));
}
function CX(e, t) {
  return (e.type === "TemplateLiteral" && J4(e) || e.type === "TaggedTemplateExpression" && J4(e.quasi)) && !oa(t, ni(e), { backwards: !0 });
}
function EX(e) {
  if (!kt(e)) return !1;
  let t = ur(!1, om(e, qt.Dangling), -1);
  return t && !Za(t);
}
function Kft(e) {
  if (e.length <= 1) return !1;
  let t = 0;
  for (let n of e) if (hb(n)) {
    if (t += 1, t > 1) return !0;
  } else if (or(n)) {
    for (let r of el(n)) if (hb(r)) return !0;
  }
  return !1;
}
function TX(e) {
  let { node: t, parent: n, key: r } = e;
  return r === "callee" && or(t) && or(n) && n.arguments.length > 0 && t.arguments.length > n.arguments.length;
}
var Jft = /* @__PURE__ */ new Set(["!", "-", "+", "~"]);
function fl(e, t = 2) {
  if (t <= 0) return !1;
  if (e.type === "ChainExpression" || e.type === "TSNonNullExpression") return fl(e.expression, t);
  let n = (r) => fl(r, t - 1);
  if (bX(e)) return Im(e.pattern ?? e.regex.pattern) <= 5;
  if ($N(e) || Vft(e) || e.type === "ArgumentPlaceholder") return !0;
  if (e.type === "TemplateLiteral") return e.quasis.every((r) => !r.value.raw.includes(`
`)) && e.expressions.every(n);
  if (Cl(e)) return e.properties.every((r) => !r.computed && (r.shorthand || r.value && n(r.value)));
  if (Eo(e)) return e.elements.every((r) => r === null || n(r));
  if (Mm(e)) {
    if (e.type === "ImportExpression" || fl(e.callee, t)) {
      let r = el(e);
      return r.length <= t && r.every(n);
    }
    return !1;
  }
  return mi(e) ? fl(e.object, t) && fl(e.property, t) : e.type === "UnaryExpression" && Jft.has(e.operator) || e.type === "UpdateExpression" ? fl(e.argument, t) : !1;
}
function qa(e) {
  var t;
  return ((t = e.extra) == null ? void 0 : t.raw) ?? e.raw;
}
function Xft(e) {
  return e;
}
function wc(e, t = "es5") {
  return e.trailingComma === "es5" && t === "es5" || e.trailingComma === "all" && (t === "all" || t === "es5");
}
function Qo(e, t) {
  switch (e.type) {
    case "BinaryExpression":
    case "LogicalExpression":
    case "AssignmentExpression":
    case "NGPipeExpression":
      return Qo(e.left, t);
    case "MemberExpression":
    case "OptionalMemberExpression":
      return Qo(e.object, t);
    case "TaggedTemplateExpression":
      return e.tag.type === "FunctionExpression" ? !1 : Qo(e.tag, t);
    case "CallExpression":
    case "OptionalCallExpression":
      return e.callee.type === "FunctionExpression" ? !1 : Qo(e.callee, t);
    case "ConditionalExpression":
      return Qo(e.test, t);
    case "UpdateExpression":
      return !e.prefix && Qo(e.argument, t);
    case "BindExpression":
      return e.object && Qo(e.object, t);
    case "SequenceExpression":
      return Qo(e.expressions[0], t);
    case "ChainExpression":
    case "TSSatisfiesExpression":
    case "TSAsExpression":
    case "TSNonNullExpression":
    case "AsExpression":
    case "AsConstExpression":
    case "SatisfiesExpression":
      return Qo(e.expression, t);
    default:
      return t(e);
  }
}
var X4 = { "==": !0, "!=": !0, "===": !0, "!==": !0 }, Px = { "*": !0, "/": !0, "%": !0 }, xO = { ">>": !0, ">>>": !0, "<<": !0 };
function RN(e, t) {
  return !(NC(t) !== NC(e) || e === "**" || X4[e] && X4[t] || t === "%" && Px[e] || e === "%" && Px[t] || t !== e && Px[t] && Px[e] || xO[e] && xO[t]);
}
var Qft = new Map([["|>"], ["??"], ["||"], ["&&"], ["|"], ["^"], ["&"], ["==", "===", "!=", "!=="], ["<", ">", "<=", ">=", "in", "instanceof"], [">>", "<<", ">>>"], ["+", "-"], ["*", "/", "%"], ["**"]].flatMap((e, t) => e.map((n) => [n, t])));
function NC(e) {
  return Qft.get(e);
}
function Zft(e) {
  return !!xO[e] || e === "|" || e === "^" || e === "&";
}
function eht(e) {
  var t;
  if (e.rest) return !0;
  let n = jo(e);
  return ((t = ur(!1, n, -1)) == null ? void 0 : t.type) === "RestElement";
}
var tP = /* @__PURE__ */ new WeakMap();
function jo(e) {
  if (tP.has(e)) return tP.get(e);
  let t = [];
  return e.this && t.push(e.this), Array.isArray(e.parameters) ? t.push(...e.parameters) : Array.isArray(e.params) && t.push(...e.params), e.rest && t.push(e.rest), tP.set(e, t), t;
}
function tht(e, t) {
  let { node: n } = e, r = 0, i = (o) => t(o, r++);
  n.this && e.call(i, "this"), Array.isArray(n.parameters) ? e.each(i, "parameters") : Array.isArray(n.params) && e.each(i, "params"), n.rest && e.call(i, "rest");
}
var nP = /* @__PURE__ */ new WeakMap();
function el(e) {
  if (nP.has(e)) return nP.get(e);
  if (e.type === "ChainExpression") return el(e.expression);
  let t = e.arguments;
  return e.type === "ImportExpression" && (t = [e.source], e.attributes && t.push(e.attributes), e.options && t.push(e.options)), nP.set(e, t), t;
}
function MC(e, t) {
  let { node: n } = e;
  if (n.type === "ChainExpression") return e.call(() => MC(e, t), "expression");
  n.type === "ImportExpression" ? (e.call((r) => t(r, 0), "source"), n.attributes && e.call((r) => t(r, 1), "attributes"), n.options && e.call((r) => t(r, 1), "options")) : e.each(t, "arguments");
}
function Q4(e, t) {
  let n = [];
  if (e.type === "ChainExpression" && (e = e.expression, n.push("expression")), e.type === "ImportExpression") {
    if (t === 0 || t === (e.attributes || e.options ? -2 : -1)) return [...n, "source"];
    if (e.attributes && (t === 1 || t === -1)) return [...n, "attributes"];
    if (e.options && (t === 1 || t === -1)) return [...n, "options"];
    throw new RangeError("Invalid argument index");
  }
  if (t < 0 && (t = e.arguments.length + t), t < 0 || t >= e.arguments.length) throw new RangeError("Invalid argument index");
  return [...n, "arguments", t];
}
function RC(e) {
  return e.value.trim() === "prettier-ignore" && !e.unignore;
}
function FT(e) {
  return (e == null ? void 0 : e.prettierIgnore) || kt(e, qt.PrettierIgnore);
}
var qt = { Leading: 2, Trailing: 4, Dangling: 8, Block: 16, Line: 32, PrettierIgnore: 64, First: 128, Last: 256 }, SX = (e, t) => {
  if (typeof e == "function" && (t = e, e = 0), e || t) return (n, r, i) => !(e & qt.Leading && !n.leading || e & qt.Trailing && !n.trailing || e & qt.Dangling && (n.leading || n.trailing) || e & qt.Block && !Za(n) || e & qt.Line && !kT(n) || e & qt.First && r !== 0 || e & qt.Last && r !== i.length - 1 || e & qt.PrettierIgnore && !RC(n) || t && !t(n));
};
function kt(e, t, n) {
  if (!dr(e == null ? void 0 : e.comments)) return !1;
  let r = SX(t, n);
  return r ? e.comments.some(r) : !0;
}
function om(e, t, n) {
  if (!Array.isArray(e == null ? void 0 : e.comments)) return [];
  let r = SX(t, n);
  return r ? e.comments.filter(r) : e.comments;
}
var Pc = (e, { originalText: t }) => IN(t, Zn(e));
function Mm(e) {
  return or(e) || e.type === "NewExpression" || e.type === "ImportExpression";
}
function kc(e) {
  return e && (e.type === "ObjectProperty" || e.type === "Property" && !OT(e));
}
var iu = Ir(["TSAsExpression", "TSSatisfiesExpression", "AsExpression", "AsConstExpression", "SatisfiesExpression"]), sf = Ir(["UnionTypeAnnotation", "TSUnionType"]), AX = Ir(["IntersectionTypeAnnotation", "TSIntersectionType"]), nht = /* @__PURE__ */ new Set(["range", "raw", "comments", "leadingComments", "trailingComments", "innerComments", "extra", "start", "end", "loc", "flags", "errors", "tokens"]), Eh = (e) => {
  for (let t of e.quasis) delete t.value;
};
function wX(e, t, n) {
  var r, i;
  if (e.type === "Program" && delete t.sourceType, (e.type === "BigIntLiteral" || e.type === "BigIntLiteralTypeAnnotation") && e.value && (t.value = e.value.toLowerCase()), (e.type === "BigIntLiteral" || e.type === "Literal") && e.bigint && (t.bigint = e.bigint.toLowerCase()), e.type === "DecimalLiteral" && (t.value = Number(e.value)), e.type === "Literal" && t.decimal && (t.decimal = Number(e.decimal)), e.type === "EmptyStatement" || e.type === "JSXText" || e.type === "JSXExpressionContainer" && (e.expression.type === "Literal" || e.expression.type === "StringLiteral") && e.expression.value === " ") return null;
  if ((e.type === "Property" || e.type === "ObjectProperty" || e.type === "MethodDefinition" || e.type === "ClassProperty" || e.type === "ClassMethod" || e.type === "PropertyDefinition" || e.type === "TSDeclareMethod" || e.type === "TSPropertySignature" || e.type === "ObjectTypeProperty" || e.type === "ImportAttribute") && e.key && !e.computed) {
    let { key: s } = e;
    us(s) || fc(s) ? t.key = String(s.value) : s.type === "Identifier" && (t.key = s.name);
  }
  if (e.type === "JSXElement" && e.openingElement.name.name === "style" && e.openingElement.attributes.some((s) => s.type === "JSXAttribute" && s.name.name === "jsx")) for (let { type: s, expression: a } of t.children) s === "JSXExpressionContainer" && a.type === "TemplateLiteral" && Eh(a);
  e.type === "JSXAttribute" && e.name.name === "css" && e.value.type === "JSXExpressionContainer" && e.value.expression.type === "TemplateLiteral" && Eh(t.value.expression), e.type === "JSXAttribute" && ((r = e.value) == null ? void 0 : r.type) === "Literal" && /["']|&quot;|&apos;/u.test(e.value.value) && (t.value.value = yo(!1, e.value.value, /["']|&quot;|&apos;/gu, '"'));
  let o = e.expression || e.callee;
  if (e.type === "Decorator" && o.type === "CallExpression" && o.callee.name === "Component" && o.arguments.length === 1) {
    let s = e.expression.arguments[0].properties;
    for (let [a, u] of t.expression.arguments[0].properties.entries()) switch (s[a].key.name) {
      case "styles":
        Eo(u.value) && Eh(u.value.elements[0]);
        break;
      case "template":
        u.value.type === "TemplateLiteral" && Eh(u.value);
        break;
    }
  }
  e.type === "TaggedTemplateExpression" && (e.tag.type === "MemberExpression" || e.tag.type === "Identifier" && (e.tag.name === "gql" || e.tag.name === "graphql" || e.tag.name === "css" || e.tag.name === "md" || e.tag.name === "markdown" || e.tag.name === "html") || e.tag.type === "CallExpression") && Eh(t.quasi), e.type === "TemplateLiteral" && ((i = e.leadingComments) != null && i.some((s) => Za(s) && ["GraphQL", "HTML"].some((a) => s.value === ` ${a} `)) || n.type === "CallExpression" && n.callee.name === "graphql" || !e.leadingComments) && Eh(t), e.type === "ChainExpression" && e.expression.type === "TSNonNullExpression" && (t.type = "TSNonNullExpression", t.expression.type = "ChainExpression"), e.type === "TSMappedType" && (delete t.key, delete t.constraint), e.type === "TSEnumDeclaration" && delete t.body;
}
wX.ignoredProperties = nht;
var rht = wX, Ag = "string", xd = "array", wg = "cursor", Ff = "indent", $f = "align", Pg = "trim", Ga = "group", _d = "fill", fu = "if-break", Nf = "indent-if-break", Mf = "line-suffix", Rf = "line-suffix-boundary", ma = "line", Ld = "label", Bd = "break-parent", PX = /* @__PURE__ */ new Set([wg, Ff, $f, Pg, Ga, _d, fu, Nf, Mf, Rf, ma, Ld, Bd]);
function iht(e) {
  if (typeof e == "string") return Ag;
  if (Array.isArray(e)) return xd;
  if (!e) return;
  let { type: t } = e;
  if (PX.has(t)) return t;
}
var kg = iht, oht = (e) => new Intl.ListFormat("en-US", { type: "disjunction" }).format(e);
function sht(e) {
  let t = e === null ? "null" : typeof e;
  if (t !== "string" && t !== "object") return `Unexpected doc '${t}', 
Expected it to be 'string' or 'object'.`;
  if (kg(e)) throw new Error("doc is valid.");
  let n = Object.prototype.toString.call(e);
  if (n !== "[object Object]") return `Unexpected doc '${n}'.`;
  let r = oht([...PX].map((i) => `'${i}'`));
  return `Unexpected doc.type '${e.type}'.
Expected it to be ${r}.`;
}
var aht = class extends Error {
  constructor(t) {
    super(sht(t));
    ap(this, "name", "InvalidDocError");
    this.doc = t;
  }
}, mb = aht, Z4 = {};
function lht(e, t, n, r) {
  let i = [e];
  for (; i.length > 0; ) {
    let o = i.pop();
    if (o === Z4) {
      n(i.pop());
      continue;
    }
    n && i.push(o, Z4);
    let s = kg(o);
    if (!s) throw new mb(o);
    if ((t == null ? void 0 : t(o)) !== !1) switch (s) {
      case xd:
      case _d: {
        let a = s === xd ? o : o.parts;
        for (let u = a.length, c = u - 1; c >= 0; --c) i.push(a[c]);
        break;
      }
      case fu:
        i.push(o.flatContents, o.breakContents);
        break;
      case Ga:
        if (r && o.expandedStates) for (let a = o.expandedStates.length, u = a - 1; u >= 0; --u) i.push(o.expandedStates[u]);
        else i.push(o.contents);
        break;
      case $f:
      case Ff:
      case Nf:
      case Ld:
      case Mf:
        i.push(o.contents);
        break;
      case Ag:
      case wg:
      case Pg:
      case Rf:
      case ma:
      case Bd:
        break;
      default:
        throw new mb(o);
    }
  }
}
var kX = lht, uht = () => {
}, cht = uht;
function mt(e) {
  return { type: Ff, contents: e };
}
function Du(e, t) {
  return { type: $f, contents: t, n: e };
}
function je(e, t = {}) {
  return cht(t.expandedStates), { type: Ga, id: t.id, contents: e, break: !!t.shouldBreak, expandedStates: t.expandedStates };
}
function dht(e) {
  return Du(Number.NEGATIVE_INFINITY, e);
}
function OX(e) {
  return Du(-1, e);
}
function $p(e, t) {
  return je(e[0], { ...t, expandedStates: e });
}
function _N(e) {
  return { type: _d, parts: e };
}
function Fn(e, t = "", n = {}) {
  return { type: fu, breakContents: e, flatContents: t, groupId: n.groupId };
}
function $T(e, t) {
  return { type: Nf, contents: e, groupId: t.groupId, negate: t.negate };
}
function e6(e) {
  return { type: Mf, contents: e };
}
var mc = { type: Rf }, Cu = { type: Bd }, IX = { type: ma, hard: !0 }, pht = { type: ma, hard: !0, literal: !0 }, Wt = { type: ma }, lt = { type: ma, soft: !0 }, ft = [IX, Cu], FX = [pht, Cu], t6 = { type: wg };
function Xn(e, t) {
  let n = [];
  for (let r = 0; r < t.length; r++) r !== 0 && n.push(e), n.push(t[r]);
  return n;
}
function fht(e, t, n) {
  let r = e;
  if (t > 0) {
    for (let i = 0; i < Math.floor(t / n); ++i) r = mt(r);
    r = Du(t % n, r), r = Du(Number.NEGATIVE_INFINITY, r);
  }
  return r;
}
function Av(e, t) {
  return e ? { type: Ld, label: e, contents: t } : t;
}
function Og(e, t) {
  if (typeof e == "string") return t(e);
  let n = /* @__PURE__ */ new Map();
  return r(e);
  function r(o) {
    if (n.has(o)) return n.get(o);
    let s = i(o);
    return n.set(o, s), s;
  }
  function i(o) {
    switch (kg(o)) {
      case xd:
        return t(o.map(r));
      case _d:
        return t({ ...o, parts: o.parts.map(r) });
      case fu:
        return t({ ...o, breakContents: r(o.breakContents), flatContents: r(o.flatContents) });
      case Ga: {
        let { expandedStates: s, contents: a } = o;
        return s ? (s = s.map(r), a = s[0]) : a = r(a), t({ ...o, contents: a, expandedStates: s });
      }
      case $f:
      case Ff:
      case Nf:
      case Ld:
      case Mf:
        return t({ ...o, contents: r(o.contents) });
      case Ag:
      case wg:
      case Pg:
      case Rf:
      case ma:
      case Bd:
        return t(o);
      default:
        throw new mb(o);
    }
  }
}
function $X(e, t, n) {
  let r = n, i = !1;
  function o(s) {
    if (i) return !1;
    let a = t(s);
    a !== void 0 && (i = !0, r = a);
  }
  return kX(e, o), r;
}
function hht(e) {
  if (e.type === Ga && e.break || e.type === ma && e.hard || e.type === Bd) return !0;
}
function ts(e) {
  return $X(e, hht, !1);
}
function n6(e) {
  if (e.length > 0) {
    let t = ur(!1, e, -1);
    !t.expandedStates && !t.break && (t.break = "propagated");
  }
  return null;
}
function mht(e) {
  let t = /* @__PURE__ */ new Set(), n = [];
  function r(o) {
    if (o.type === Bd && n6(n), o.type === Ga) {
      if (n.push(o), t.has(o)) return !1;
      t.add(o);
    }
  }
  function i(o) {
    o.type === Ga && n.pop().break && n6(n);
  }
  kX(e, r, i, !0);
}
function ght(e) {
  return e.type === ma && !e.hard ? e.soft ? "" : " " : e.type === fu ? e.flatContents : e;
}
function DO(e) {
  return Og(e, ght);
}
function yht(e) {
  switch (kg(e)) {
    case _d:
      if (e.parts.every((t) => t === "")) return "";
      break;
    case Ga:
      if (!e.contents && !e.id && !e.break && !e.expandedStates) return "";
      if (e.contents.type === Ga && e.contents.id === e.id && e.contents.break === e.break && e.contents.expandedStates === e.expandedStates) return e.contents;
      break;
    case $f:
    case Ff:
    case Nf:
    case Mf:
      if (!e.contents) return "";
      break;
    case fu:
      if (!e.flatContents && !e.breakContents) return "";
      break;
    case xd: {
      let t = [];
      for (let n of e) {
        if (!n) continue;
        let [r, ...i] = Array.isArray(n) ? n : [n];
        typeof r == "string" && typeof ur(!1, t, -1) == "string" ? t[t.length - 1] += r : t.push(r), t.push(...i);
      }
      return t.length === 0 ? "" : t.length === 1 ? t[0] : t;
    }
    case Ag:
    case wg:
    case Pg:
    case Rf:
    case ma:
    case Ld:
    case Bd:
      break;
    default:
      throw new mb(e);
  }
  return e;
}
function LN(e) {
  return Og(e, (t) => yht(t));
}
function af(e, t = FX) {
  return Og(e, (n) => typeof n == "string" ? Xn(t, n.split(`
`)) : n);
}
function bht(e) {
  if (e.type === ma) return !0;
}
function vht(e) {
  return $X(e, bht, !1);
}
function CO(e, t) {
  return e.type === Ld ? { ...e, contents: t(e.contents) } : t(e);
}
function xht(e) {
  let t = `*${e.value}*`.split(`
`);
  return t.length > 1 && t.every((n) => n.trimStart()[0] === "*");
}
var Dht = xht;
function Cht(e, t) {
  let n = e.node;
  if (kT(n)) return t.originalText.slice(ni(n), Zn(n)).trimEnd();
  if (Za(n)) return Dht(n) ? Eht(n) : ["/*", af(n.value), "*/"];
  throw new Error("Not a comment: " + JSON.stringify(n));
}
function Eht(e) {
  let t = e.value.split(`
`);
  return ["/*", Xn(ft, t.map((n, r) => r === 0 ? n.trimEnd() : " " + (r < t.length - 1 ? n.trim() : n.trimStart()))), "*/"];
}
var NX = {};
wT(NX, { endOfLine: () => Iht, ownLine: () => Oht, remaining: () => Fht });
function Tht(e) {
  let t = e.type || e.kind || "(unknown type)", n = String(e.name || e.id && (typeof e.id == "object" ? e.id.name : e.id) || e.key && (typeof e.key == "object" ? e.key.name : e.key) || e.value && (typeof e.value == "object" ? "" : String(e.value)) || e.operator || "");
  return n.length > 20 && (n = n.slice(0, 19) + "…"), t + (n ? " " + n : "");
}
function BN(e, t) {
  (e.comments ?? (e.comments = [])).push(t), t.printed = !1, t.nodeDescription = Tht(e);
}
function To(e, t) {
  t.leading = !0, t.trailing = !1, BN(e, t);
}
function Ya(e, t, n) {
  t.leading = !1, t.trailing = !1, n && (t.marker = n), BN(e, t);
}
function ai(e, t) {
  t.leading = !1, t.trailing = !0, BN(e, t);
}
function Sht(e, t) {
  let n = null, r = t;
  for (; r !== n; ) n = r, r = Fm(e, r), r = kN(e, r), r = ON(e, r), r = $m(e, r);
  return r;
}
var wv = Sht;
function Aht(e, t) {
  let n = wv(e, t);
  return n === !1 ? "" : e.charAt(n);
}
var El = Aht;
function wht(e, t, n) {
  for (let r = t; r < n; ++r) if (e.charAt(r) === `
`) return !0;
  return !1;
}
var Dd = wht;
function Pht(e) {
  return Za(e) && e.value[0] === "*" && /@(?:type|satisfies)\b/u.test(e.value);
}
var kht = Pht;
function Oht(e) {
  return [zX, RX, BX, Uht, Nht, jN, VN, MX, _X, Ght, Hht, UN, VX, Yht, LX, jX, zN, Mht, nmt].some((t) => t(e));
}
function Iht(e) {
  return [$ht, BX, RX, VX, jN, VN, MX, _X, jX, Wht, qht, UN, Xht, zN, emt, tmt].some((t) => t(e));
}
function Fht(e) {
  return [zX, jN, VN, Rht, zht, LX, UN, Vht, jht, Zht, zN, Qht].some((t) => t(e));
}
function _f(e, t) {
  let n = (e.body || e.properties).find(({ type: r }) => r !== "EmptyStatement");
  n ? To(n, t) : Ya(e, t);
}
function EO(e, t) {
  e.type === "BlockStatement" ? _f(e, t) : To(e, t);
}
function $ht({ comment: e, followingNode: t }) {
  return t && kht(e) ? (To(t, e), !0) : !1;
}
function jN({ comment: e, precedingNode: t, enclosingNode: n, followingNode: r, text: i }) {
  if ((n == null ? void 0 : n.type) !== "IfStatement" || !r) return !1;
  if (El(i, Zn(e)) === ")") return ai(t, e), !0;
  if (t === n.consequent && r === n.alternate) {
    if (t.type === "BlockStatement") ai(t, e);
    else {
      let o = kT(e) || e.loc.start.line === e.loc.end.line, s = e.loc.start.line === t.loc.start.line;
      o && s ? ai(t, e) : Ya(n, e);
    }
    return !0;
  }
  return r.type === "BlockStatement" ? (_f(r, e), !0) : r.type === "IfStatement" ? (EO(r.consequent, e), !0) : n.consequent === r ? (To(r, e), !0) : !1;
}
function VN({ comment: e, precedingNode: t, enclosingNode: n, followingNode: r, text: i }) {
  return (n == null ? void 0 : n.type) !== "WhileStatement" || !r ? !1 : El(i, Zn(e)) === ")" ? (ai(t, e), !0) : r.type === "BlockStatement" ? (_f(r, e), !0) : n.body === r ? (To(r, e), !0) : !1;
}
function MX({ comment: e, precedingNode: t, enclosingNode: n, followingNode: r }) {
  return (n == null ? void 0 : n.type) !== "TryStatement" && (n == null ? void 0 : n.type) !== "CatchClause" || !r ? !1 : n.type === "CatchClause" && t ? (ai(t, e), !0) : r.type === "BlockStatement" ? (_f(r, e), !0) : r.type === "TryStatement" ? (EO(r.finalizer, e), !0) : r.type === "CatchClause" ? (EO(r.body, e), !0) : !1;
}
function Nht({ comment: e, enclosingNode: t, followingNode: n }) {
  return mi(t) && (n == null ? void 0 : n.type) === "Identifier" ? (To(t, e), !0) : !1;
}
function Mht({ comment: e, enclosingNode: t, followingNode: n, options: r }) {
  return !r.experimentalTernaries || !((t == null ? void 0 : t.type) === "ConditionalExpression" || (t == null ? void 0 : t.type) === "ConditionalTypeAnnotation" || (t == null ? void 0 : t.type) === "TSConditionalType") ? !1 : (n == null ? void 0 : n.type) === "ConditionalExpression" || (n == null ? void 0 : n.type) === "ConditionalTypeAnnotation" || (n == null ? void 0 : n.type) === "TSConditionalType" ? (Ya(t, e), !0) : !1;
}
function RX({ comment: e, precedingNode: t, enclosingNode: n, followingNode: r, text: i, options: o }) {
  let s = t && !Dd(i, Zn(t), ni(e));
  return (!t || !s) && ((n == null ? void 0 : n.type) === "ConditionalExpression" || (n == null ? void 0 : n.type) === "ConditionalTypeAnnotation" || (n == null ? void 0 : n.type) === "TSConditionalType") && r ? o.experimentalTernaries && n.alternate === r && !(Za(e) && !Dd(o.originalText, ni(e), Zn(e))) ? (Ya(n, e), !0) : (To(r, e), !0) : !1;
}
function Rht({ comment: e, precedingNode: t, enclosingNode: n }) {
  return kc(n) && n.shorthand && n.key === t && n.value.type === "AssignmentPattern" ? (ai(n.value.left, e), !0) : !1;
}
var _ht = /* @__PURE__ */ new Set(["ClassDeclaration", "ClassExpression", "DeclareClass", "DeclareInterface", "InterfaceDeclaration", "TSInterfaceDeclaration"]);
function _X({ comment: e, precedingNode: t, enclosingNode: n, followingNode: r }) {
  if (_ht.has(n == null ? void 0 : n.type)) {
    if (dr(n.decorators) && (r == null ? void 0 : r.type) !== "Decorator") return ai(ur(!1, n.decorators, -1), e), !0;
    if (n.body && r === n.body) return _f(n.body, e), !0;
    if (r) {
      if (n.superClass && r === n.superClass && t && (t === n.id || t === n.typeParameters)) return ai(t, e), !0;
      for (let i of ["implements", "extends", "mixins"]) if (n[i] && r === n[i][0]) return t && (t === n.id || t === n.typeParameters || t === n.superClass) ? ai(t, e) : Ya(n, e, i), !0;
    }
  }
  return !1;
}
var Lht = /* @__PURE__ */ new Set(["ClassMethod", "ClassProperty", "PropertyDefinition", "TSAbstractPropertyDefinition", "TSAbstractMethodDefinition", "TSDeclareMethod", "MethodDefinition", "ClassAccessorProperty", "AccessorProperty", "TSAbstractAccessorProperty"]);
function LX({ comment: e, precedingNode: t, enclosingNode: n, text: r }) {
  return n && t && El(r, Zn(e)) === "(" && (n.type === "Property" || n.type === "TSDeclareMethod" || n.type === "TSAbstractMethodDefinition") && t.type === "Identifier" && n.key === t && El(r, Zn(t)) !== ":" || (t == null ? void 0 : t.type) === "Decorator" && Lht.has(n == null ? void 0 : n.type) ? (ai(t, e), !0) : !1;
}
var Bht = /* @__PURE__ */ new Set(["FunctionDeclaration", "FunctionExpression", "ClassMethod", "MethodDefinition", "ObjectMethod"]);
function jht({ comment: e, precedingNode: t, enclosingNode: n, text: r }) {
  return El(r, Zn(e)) !== "(" ? !1 : t && Bht.has(n == null ? void 0 : n.type) ? (ai(t, e), !0) : !1;
}
function Vht({ comment: e, enclosingNode: t, text: n }) {
  if ((t == null ? void 0 : t.type) !== "ArrowFunctionExpression") return !1;
  let r = wv(n, Zn(e));
  return r !== !1 && n.slice(r, r + 2) === "=>" ? (Ya(t, e), !0) : !1;
}
function zht({ comment: e, enclosingNode: t, text: n }) {
  return El(n, Zn(e)) !== ")" ? !1 : t && (UX(t) && jo(t).length === 0 || Mm(t) && el(t).length === 0) ? (Ya(t, e), !0) : ((t == null ? void 0 : t.type) === "MethodDefinition" || (t == null ? void 0 : t.type) === "TSAbstractMethodDefinition") && jo(t.value).length === 0 ? (Ya(t.value, e), !0) : !1;
}
function Uht({ comment: e, precedingNode: t, enclosingNode: n, followingNode: r, text: i }) {
  return (t == null ? void 0 : t.type) === "ComponentTypeParameter" && ((n == null ? void 0 : n.type) === "DeclareComponent" || (n == null ? void 0 : n.type) === "ComponentTypeAnnotation") && (r == null ? void 0 : r.type) !== "ComponentTypeParameter" || ((t == null ? void 0 : t.type) === "ComponentParameter" || (t == null ? void 0 : t.type) === "RestElement") && (n == null ? void 0 : n.type) === "ComponentDeclaration" && El(i, Zn(e)) === ")" ? (ai(t, e), !0) : !1;
}
function BX({ comment: e, precedingNode: t, enclosingNode: n, followingNode: r, text: i }) {
  return (t == null ? void 0 : t.type) === "FunctionTypeParam" && (n == null ? void 0 : n.type) === "FunctionTypeAnnotation" && (r == null ? void 0 : r.type) !== "FunctionTypeParam" || ((t == null ? void 0 : t.type) === "Identifier" || (t == null ? void 0 : t.type) === "AssignmentPattern" || (t == null ? void 0 : t.type) === "ObjectPattern" || (t == null ? void 0 : t.type) === "ArrayPattern" || (t == null ? void 0 : t.type) === "RestElement" || (t == null ? void 0 : t.type) === "TSParameterProperty") && UX(n) && El(i, Zn(e)) === ")" ? (ai(t, e), !0) : !Za(e) && ((n == null ? void 0 : n.type) === "FunctionDeclaration" || (n == null ? void 0 : n.type) === "FunctionExpression" || (n == null ? void 0 : n.type) === "ObjectMethod") && (r == null ? void 0 : r.type) === "BlockStatement" && n.body === r && wv(i, Zn(e)) === ni(r) ? (_f(r, e), !0) : !1;
}
function jX({ comment: e, enclosingNode: t }) {
  return (t == null ? void 0 : t.type) === "LabeledStatement" ? (To(t, e), !0) : !1;
}
function zN({ comment: e, enclosingNode: t }) {
  return ((t == null ? void 0 : t.type) === "ContinueStatement" || (t == null ? void 0 : t.type) === "BreakStatement") && !t.label ? (ai(t, e), !0) : !1;
}
function Wht({ comment: e, precedingNode: t, enclosingNode: n }) {
  return or(n) && t && n.callee === t && n.arguments.length > 0 ? (To(n.arguments[0], e), !0) : !1;
}
function Hht({ comment: e, precedingNode: t, enclosingNode: n, followingNode: r }) {
  return sf(n) ? (RC(e) && (r.prettierIgnore = !0, e.unignore = !0), t ? (ai(t, e), !0) : !1) : (sf(r) && RC(e) && (r.types[0].prettierIgnore = !0, e.unignore = !0), !1);
}
function qht({ comment: e, enclosingNode: t }) {
  return kc(t) ? (To(t, e), !0) : !1;
}
function UN({ comment: e, enclosingNode: t, ast: n, isLastComment: r }) {
  var i;
  return ((i = n == null ? void 0 : n.body) == null ? void 0 : i.length) === 0 ? (r ? Ya(n, e) : To(n, e), !0) : (t == null ? void 0 : t.type) === "Program" && t.body.length === 0 && !dr(t.directives) ? (r ? Ya(t, e) : To(t, e), !0) : !1;
}
function Ght({ comment: e, enclosingNode: t }) {
  return (t == null ? void 0 : t.type) === "ForInStatement" || (t == null ? void 0 : t.type) === "ForOfStatement" ? (To(t, e), !0) : !1;
}
function VX({ comment: e, precedingNode: t, enclosingNode: n, text: r }) {
  if ((n == null ? void 0 : n.type) === "ImportSpecifier" || (n == null ? void 0 : n.type) === "ExportSpecifier") return To(n, e), !0;
  let i = (t == null ? void 0 : t.type) === "ImportSpecifier" && (n == null ? void 0 : n.type) === "ImportDeclaration", o = (t == null ? void 0 : t.type) === "ExportSpecifier" && (n == null ? void 0 : n.type) === "ExportNamedDeclaration";
  return (i || o) && oa(r, Zn(e)) ? (ai(t, e), !0) : !1;
}
function Yht({ comment: e, enclosingNode: t }) {
  return (t == null ? void 0 : t.type) === "AssignmentPattern" ? (To(t, e), !0) : !1;
}
var Kht = /* @__PURE__ */ new Set(["VariableDeclarator", "AssignmentExpression", "TypeAlias", "TSTypeAliasDeclaration"]), Jht = /* @__PURE__ */ new Set(["ObjectExpression", "RecordExpression", "ArrayExpression", "TupleExpression", "TemplateLiteral", "TaggedTemplateExpression", "ObjectTypeAnnotation", "TSTypeLiteral"]);
function Xht({ comment: e, enclosingNode: t, followingNode: n }) {
  return Kht.has(t == null ? void 0 : t.type) && n && (Jht.has(n.type) || Za(e)) ? (To(n, e), !0) : !1;
}
function Qht({ comment: e, enclosingNode: t, followingNode: n, text: r }) {
  return !n && ((t == null ? void 0 : t.type) === "TSMethodSignature" || (t == null ? void 0 : t.type) === "TSDeclareFunction" || (t == null ? void 0 : t.type) === "TSAbstractMethodDefinition") && El(r, Zn(e)) === ";" ? (ai(t, e), !0) : !1;
}
function zX({ comment: e, enclosingNode: t, followingNode: n }) {
  if (RC(e) && (t == null ? void 0 : t.type) === "TSMappedType" && (n == null ? void 0 : n.type) === "TSTypeParameter" && n.constraint) return t.prettierIgnore = !0, e.unignore = !0, !0;
}
function Zht({ comment: e, precedingNode: t, enclosingNode: n, followingNode: r }) {
  return (n == null ? void 0 : n.type) !== "TSMappedType" ? !1 : (r == null ? void 0 : r.type) === "TSTypeParameter" && r.name ? (To(r.name, e), !0) : (t == null ? void 0 : t.type) === "TSTypeParameter" && t.constraint ? (ai(t.constraint, e), !0) : !1;
}
function emt({ comment: e, enclosingNode: t, followingNode: n }) {
  return !t || t.type !== "SwitchCase" || t.test || !n || n !== t.consequent[0] ? !1 : (n.type === "BlockStatement" && kT(e) ? _f(n, e) : Ya(t, e), !0);
}
function tmt({ comment: e, precedingNode: t, enclosingNode: n, followingNode: r }) {
  return sf(t) && ((n.type === "TSArrayType" || n.type === "ArrayTypeAnnotation") && !r || AX(n)) ? (ai(ur(!1, t.types, -1), e), !0) : !1;
}
function nmt({ comment: e, enclosingNode: t, precedingNode: n, followingNode: r }) {
  if (((t == null ? void 0 : t.type) === "ObjectPattern" || (t == null ? void 0 : t.type) === "ArrayPattern") && (r == null ? void 0 : r.type) === "TSTypeAnnotation") return n ? ai(n, e) : Ya(t, e), !0;
}
var UX = Ir(["ArrowFunctionExpression", "FunctionExpression", "FunctionDeclaration", "ObjectMethod", "ClassMethod", "TSDeclareFunction", "TSCallSignatureDeclaration", "TSConstructSignatureDeclaration", "TSMethodSignature", "TSConstructorType", "TSFunctionType", "TSDeclareMethod"]), rmt = /* @__PURE__ */ new Set(["EmptyStatement", "TemplateElement", "Import", "TSEmptyBodyFunctionExpression", "ChainExpression"]);
function imt(e) {
  return !rmt.has(e.type);
}
function omt(e, t) {
  var n;
  if ((t.parser === "typescript" || t.parser === "flow" || t.parser === "acorn" || t.parser === "espree" || t.parser === "meriyah" || t.parser === "__babel_estree") && e.type === "MethodDefinition" && ((n = e.value) == null ? void 0 : n.type) === "FunctionExpression" && jo(e.value).length === 0 && !e.value.returnType && !dr(e.value.typeParameters) && e.value.body) return [...e.decorators || [], e.key, e.value.body];
}
function WX(e) {
  let { node: t, parent: n } = e;
  return (oo(t) || n && (n.type === "JSXSpreadAttribute" || n.type === "JSXSpreadChild" || sf(n) || (n.type === "ClassDeclaration" || n.type === "ClassExpression") && n.superClass === t)) && (!FT(t) || sf(n));
}
function smt(e, { parser: t }) {
  if (t === "flow" || t === "babel-flow") return e = yo(!1, e, /[\s(]/gu, ""), e === "" || e === "/*" || e === "/*::";
}
function amt(e) {
  switch (e) {
    case "cr":
      return "\r";
    case "crlf":
      return `\r
`;
    default:
      return `
`;
  }
}
var vs = Symbol("MODE_BREAK"), Ul = Symbol("MODE_FLAT"), S0 = Symbol("cursor");
function HX() {
  return { value: "", length: 0, queue: [] };
}
function lmt(e, t) {
  return TO(e, { type: "indent" }, t);
}
function umt(e, t, n) {
  return t === Number.NEGATIVE_INFINITY ? e.root || HX() : t < 0 ? TO(e, { type: "dedent" }, n) : t ? t.type === "root" ? { ...e, root: e } : TO(e, { type: typeof t == "string" ? "stringAlign" : "numberAlign", n: t }, n) : e;
}
function TO(e, t, n) {
  let r = t.type === "dedent" ? e.queue.slice(0, -1) : [...e.queue, t], i = "", o = 0, s = 0, a = 0;
  for (let v of r) switch (v.type) {
    case "indent":
      d(), n.useTabs ? u(1) : c(n.tabWidth);
      break;
    case "stringAlign":
      d(), i += v.n, o += v.n.length;
      break;
    case "numberAlign":
      s += 1, a += v.n;
      break;
    default:
      throw new Error(`Unexpected type '${v.type}'`);
  }
  return h(), { ...e, value: i, length: o, queue: r };
  function u(v) {
    i += "	".repeat(v), o += n.tabWidth * v;
  }
  function c(v) {
    i += " ".repeat(v), o += v;
  }
  function d() {
    n.useTabs ? f() : h();
  }
  function f() {
    s > 0 && u(s), m();
  }
  function h() {
    a > 0 && c(a), m();
  }
  function m() {
    s = 0, a = 0;
  }
}
function SO(e) {
  let t = 0, n = 0, r = e.length;
  e: for (; r--; ) {
    let i = e[r];
    if (i === S0) {
      n++;
      continue;
    }
    for (let o = i.length - 1; o >= 0; o--) {
      let s = i[o];
      if (s === " " || s === "	") t++;
      else {
        e[r] = i.slice(0, o + 1);
        break e;
      }
    }
  }
  if (t > 0 || n > 0) for (e.length = r + 1; n-- > 0; ) e.push(S0);
  return t;
}
function kx(e, t, n, r, i, o) {
  if (n === Number.POSITIVE_INFINITY) return !0;
  let s = t.length, a = [e], u = [];
  for (; n >= 0; ) {
    if (a.length === 0) {
      if (s === 0) return !0;
      a.push(t[--s]);
      continue;
    }
    let { mode: c, doc: d } = a.pop(), f = kg(d);
    switch (f) {
      case Ag:
        u.push(d), n -= Im(d);
        break;
      case xd:
      case _d: {
        let h = f === xd ? d : d.parts;
        for (let m = h.length - 1; m >= 0; m--) a.push({ mode: c, doc: h[m] });
        break;
      }
      case Ff:
      case $f:
      case Nf:
      case Ld:
        a.push({ mode: c, doc: d.contents });
        break;
      case Pg:
        n += SO(u);
        break;
      case Ga: {
        if (o && d.break) return !1;
        let h = d.break ? vs : c, m = d.expandedStates && h === vs ? ur(!1, d.expandedStates, -1) : d.contents;
        a.push({ mode: h, doc: m });
        break;
      }
      case fu: {
        let h = (d.groupId ? i[d.groupId] || Ul : c) === vs ? d.breakContents : d.flatContents;
        h && a.push({ mode: c, doc: h });
        break;
      }
      case ma:
        if (c === vs || d.hard) return !0;
        d.soft || (u.push(" "), n--);
        break;
      case Mf:
        r = !0;
        break;
      case Rf:
        if (r) return !1;
        break;
    }
  }
  return !1;
}
function qX(e, t) {
  let n = {}, r = t.printWidth, i = amt(t.endOfLine), o = 0, s = [{ ind: HX(), mode: vs, doc: e }], a = [], u = !1, c = [], d = 0;
  for (mht(e); s.length > 0; ) {
    let { ind: h, mode: m, doc: v } = s.pop();
    switch (kg(v)) {
      case Ag: {
        let x = i !== `
` ? yo(!1, v, `
`, i) : v;
        a.push(x), s.length > 0 && (o += Im(x));
        break;
      }
      case xd:
        for (let x = v.length - 1; x >= 0; x--) s.push({ ind: h, mode: m, doc: v[x] });
        break;
      case wg:
        if (d >= 2) throw new Error("There are too many 'cursor' in doc.");
        a.push(S0), d++;
        break;
      case Ff:
        s.push({ ind: lmt(h, t), mode: m, doc: v.contents });
        break;
      case $f:
        s.push({ ind: umt(h, v.n, t), mode: m, doc: v.contents });
        break;
      case Pg:
        o -= SO(a);
        break;
      case Ga:
        switch (m) {
          case Ul:
            if (!u) {
              s.push({ ind: h, mode: v.break ? vs : Ul, doc: v.contents });
              break;
            }
          case vs: {
            u = !1;
            let x = { ind: h, mode: Ul, doc: v.contents }, C = r - o, E = c.length > 0;
            if (!v.break && kx(x, s, C, E, n)) s.push(x);
            else if (v.expandedStates) {
              let S = ur(!1, v.expandedStates, -1);
              if (v.break) {
                s.push({ ind: h, mode: vs, doc: S });
                break;
              } else for (let w = 1; w < v.expandedStates.length + 1; w++) if (w >= v.expandedStates.length) {
                s.push({ ind: h, mode: vs, doc: S });
                break;
              } else {
                let O = v.expandedStates[w], A = { ind: h, mode: Ul, doc: O };
                if (kx(A, s, C, E, n)) {
                  s.push(A);
                  break;
                }
              }
            } else s.push({ ind: h, mode: vs, doc: v.contents });
            break;
          }
        }
        v.id && (n[v.id] = ur(!1, s, -1).mode);
        break;
      case _d: {
        let x = r - o, { parts: C } = v;
        if (C.length === 0) break;
        let [E, S] = C, w = { ind: h, mode: Ul, doc: E }, O = { ind: h, mode: vs, doc: E }, A = kx(w, [], x, c.length > 0, n, !0);
        if (C.length === 1) {
          A ? s.push(w) : s.push(O);
          break;
        }
        let I = { ind: h, mode: Ul, doc: S }, $ = { ind: h, mode: vs, doc: S };
        if (C.length === 2) {
          A ? s.push(I, w) : s.push($, O);
          break;
        }
        C.splice(0, 2);
        let L = { ind: h, mode: m, doc: _N(C) }, B = C[0];
        kx({ ind: h, mode: Ul, doc: [E, S, B] }, [], x, c.length > 0, n, !0) ? s.push(L, I, w) : A ? s.push(L, $, w) : s.push(L, $, O);
        break;
      }
      case fu:
      case Nf: {
        let x = v.groupId ? n[v.groupId] : m;
        if (x === vs) {
          let C = v.type === fu ? v.breakContents : v.negate ? v.contents : mt(v.contents);
          C && s.push({ ind: h, mode: m, doc: C });
        }
        if (x === Ul) {
          let C = v.type === fu ? v.flatContents : v.negate ? mt(v.contents) : v.contents;
          C && s.push({ ind: h, mode: m, doc: C });
        }
        break;
      }
      case Mf:
        c.push({ ind: h, mode: m, doc: v.contents });
        break;
      case Rf:
        c.length > 0 && s.push({ ind: h, mode: m, doc: IX });
        break;
      case ma:
        switch (m) {
          case Ul:
            if (v.hard) u = !0;
            else {
              v.soft || (a.push(" "), o += 1);
              break;
            }
          case vs:
            if (c.length > 0) {
              s.push({ ind: h, mode: m, doc: v }, ...c.reverse()), c.length = 0;
              break;
            }
            v.literal ? h.root ? (a.push(i, h.root.value), o = h.root.length) : (a.push(i), o = 0) : (o -= SO(a), a.push(i + h.value), o = h.length);
            break;
        }
        break;
      case Ld:
        s.push({ ind: h, mode: m, doc: v.contents });
        break;
      case Bd:
        break;
      default:
        throw new mb(v);
    }
    s.length === 0 && c.length > 0 && (s.push(...c.reverse()), c.length = 0);
  }
  let f = a.indexOf(S0);
  if (f !== -1) {
    let h = a.indexOf(S0, f + 1), m = a.slice(0, f).join(""), v = a.slice(f + 1, h).join(""), x = a.slice(h + 1).join("");
    return { formatted: m + v + x, cursorNodeStart: m.length, cursorNodeText: v };
  }
  return { formatted: a.join("") };
}
function cmt(e, t, n = 0) {
  let r = 0;
  for (let i = n; i < e.length; ++i) e[i] === "	" ? r = r + t - r % t : r++;
  return r;
}
var dmt = cmt;
function pmt(e, t) {
  let n = e.lastIndexOf(`
`);
  return n === -1 ? 0 : dmt(e.slice(n + 1).match(/^[\t ]*/u)[0], t);
}
var fmt = pmt;
function GX(e, t, n) {
  let { node: r } = e;
  if (r.type === "TemplateLiteral" && ymt(e)) {
    let u = mmt(e, n, t);
    if (u) return u;
  }
  let i = "expressions";
  r.type === "TSTemplateLiteralType" && (i = "types");
  let o = [], s = e.map(t, i);
  o.push(mc, "`");
  let a = 0;
  return e.each(({ index: u, node: c }) => {
    if (o.push(t()), c.tail) return;
    let { tabWidth: d } = n, f = c.value.raw, h = f.includes(`
`) ? fmt(f, d) : a;
    a = h;
    let m = s[u], v = r[i][u], x = Dd(n.originalText, Zn(c), ni(r.quasis[u + 1]));
    if (!x) {
      let E = qX(m, { ...n, printWidth: Number.POSITIVE_INFINITY }).formatted;
      E.includes(`
`) ? x = !0 : m = E;
    }
    x && (kt(v) || v.type === "Identifier" || mi(v) || v.type === "ConditionalExpression" || v.type === "SequenceExpression" || iu(v) || hc(v)) && (m = [mt([lt, m]), lt]);
    let C = h === 0 && f.endsWith(`
`) ? Du(Number.NEGATIVE_INFINITY, m) : fht(m, h, d);
    o.push(je(["${", C, mc, "}"]));
  }, "quasis"), o.push("`"), o;
}
function hmt(e, t) {
  let n = t("quasi");
  return Av(n.label && { tagged: !0, ...n.label }, [t("tag"), t(e.node.typeArguments ? "typeArguments" : "typeParameters"), mc, n]);
}
function mmt(e, t, n) {
  let { node: r } = e, i = r.quasis[0].value.raw.trim().split(/\s*\|\s*/u);
  if (i.length > 1 || i.some((o) => o.length > 0)) {
    t.__inJestEach = !0;
    let o = e.map(n, "expressions");
    t.__inJestEach = !1;
    let s = [], a = o.map((h) => "${" + qX(h, { ...t, printWidth: Number.POSITIVE_INFINITY, endOfLine: "lf" }).formatted + "}"), u = [{ hasLineBreak: !1, cells: [] }];
    for (let h = 1; h < r.quasis.length; h++) {
      let m = ur(!1, u, -1), v = a[h - 1];
      m.cells.push(v), v.includes(`
`) && (m.hasLineBreak = !0), r.quasis[h].value.raw.includes(`
`) && u.push({ hasLineBreak: !1, cells: [] });
    }
    let c = Math.max(i.length, ...u.map((h) => h.cells.length)), d = Array.from({ length: c }).fill(0), f = [{ cells: i }, ...u.filter((h) => h.cells.length > 0)];
    for (let { cells: h } of f.filter((m) => !m.hasLineBreak)) for (let [m, v] of h.entries()) d[m] = Math.max(d[m], Im(v));
    return s.push(mc, "`", mt([ft, Xn(ft, f.map((h) => Xn(" | ", h.cells.map((m, v) => h.hasLineBreak ? m : m + " ".repeat(d[v] - Im(m))))))]), ft, "`"), s;
  }
}
function gmt(e, t) {
  let { node: n } = e, r = t();
  return kt(n) && (r = je([mt([lt, r]), lt])), ["${", r, mc, "}"];
}
function WN(e, t) {
  return e.map((n) => gmt(n, t), "expressions");
}
function YX(e, t) {
  return Og(e, (n) => typeof n == "string" ? t ? yo(!1, n, /(\\*)`/gu, "$1$1\\`") : KX(n) : n);
}
function KX(e) {
  return yo(!1, e, /([\\`]|\$\{)/gu, String.raw`\$1`);
}
function ymt({ node: e, parent: t }) {
  let n = /^[fx]?(?:describe|it|test)$/u;
  return t.type === "TaggedTemplateExpression" && t.quasi === e && t.tag.type === "MemberExpression" && t.tag.property.type === "Identifier" && t.tag.property.name === "each" && (t.tag.object.type === "Identifier" && n.test(t.tag.object.name) || t.tag.object.type === "MemberExpression" && t.tag.object.property.type === "Identifier" && (t.tag.object.property.name === "only" || t.tag.object.property.name === "skip") && t.tag.object.object.type === "Identifier" && n.test(t.tag.object.object.name));
}
var AO = [(e, t) => e.type === "ObjectExpression" && t === "properties", (e, t) => e.type === "CallExpression" && e.callee.type === "Identifier" && e.callee.name === "Component" && t === "arguments", (e, t) => e.type === "Decorator" && t === "expression"];
function bmt(e) {
  let t = (r) => r.type === "TemplateLiteral", n = (r, i) => kc(r) && !r.computed && r.key.type === "Identifier" && r.key.name === "styles" && i === "value";
  return e.match(t, (r, i) => Eo(r) && i === "elements", n, ...AO) || e.match(t, n, ...AO);
}
function vmt(e) {
  return e.match((t) => t.type === "TemplateLiteral", (t, n) => kc(t) && !t.computed && t.key.type === "Identifier" && t.key.name === "template" && n === "value", ...AO);
}
function rP(e, t) {
  return kt(e, qt.Block | qt.Leading, ({ value: n }) => n === ` ${t} `);
}
function JX({ node: e, parent: t }, n) {
  return rP(e, n) || xmt(t) && rP(t, n) || t.type === "ExpressionStatement" && rP(t, n);
}
function xmt(e) {
  return e.type === "AsConstExpression" || e.type === "TSAsExpression" && e.typeAnnotation.type === "TSTypeReference" && e.typeAnnotation.typeName.type === "Identifier" && e.typeAnnotation.typeName.name === "const";
}
async function Dmt(e, t, n) {
  let { node: r } = n, i = r.quasis.map((d) => d.value.raw), o = 0, s = i.reduce((d, f, h) => h === 0 ? f : d + "@prettier-placeholder-" + o++ + "-id" + f, ""), a = await e(s, { parser: "scss" }), u = WN(n, t), c = Cmt(a, u);
  if (!c) throw new Error("Couldn't insert all the expressions");
  return ["`", mt([ft, c]), lt, "`"];
}
function Cmt(e, t) {
  if (!dr(t)) return e;
  let n = 0, r = Og(LN(e), (i) => typeof i != "string" || !i.includes("@prettier-placeholder") ? i : i.split(/@prettier-placeholder-(\d+)-id/u).map((o, s) => s % 2 === 0 ? af(o) : (n++, t[o])));
  return t.length === n ? r : null;
}
function Emt({ node: e, parent: t, grandparent: n }) {
  return n && e.quasis && t.type === "JSXExpressionContainer" && n.type === "JSXElement" && n.openingElement.name.name === "style" && n.openingElement.attributes.some((r) => r.type === "JSXAttribute" && r.name.name === "jsx") || (t == null ? void 0 : t.type) === "TaggedTemplateExpression" && t.tag.type === "Identifier" && t.tag.name === "css" || (t == null ? void 0 : t.type) === "TaggedTemplateExpression" && t.tag.type === "MemberExpression" && t.tag.object.name === "css" && (t.tag.property.name === "global" || t.tag.property.name === "resolve");
}
function Ox(e) {
  return e.type === "Identifier" && e.name === "styled";
}
function r6(e) {
  return /^[A-Z]/u.test(e.object.name) && e.property.name === "extend";
}
function Tmt({ parent: e }) {
  if (!e || e.type !== "TaggedTemplateExpression") return !1;
  let t = e.tag.type === "ParenthesizedExpression" ? e.tag.expression : e.tag;
  switch (t.type) {
    case "MemberExpression":
      return Ox(t.object) || r6(t);
    case "CallExpression":
      return Ox(t.callee) || t.callee.type === "MemberExpression" && (t.callee.object.type === "MemberExpression" && (Ox(t.callee.object.object) || r6(t.callee.object)) || t.callee.object.type === "CallExpression" && Ox(t.callee.object.callee));
    case "Identifier":
      return t.name === "css";
    default:
      return !1;
  }
}
function Smt({ parent: e, grandparent: t }) {
  return (t == null ? void 0 : t.type) === "JSXAttribute" && e.type === "JSXExpressionContainer" && t.name.type === "JSXIdentifier" && t.name.name === "css";
}
function Amt(e) {
  if (Emt(e) || Tmt(e) || Smt(e) || bmt(e)) return Dmt;
}
var wmt = Amt;
async function Pmt(e, t, n) {
  let { node: r } = n, i = r.quasis.length, o = WN(n, t), s = [];
  for (let a = 0; a < i; a++) {
    let u = r.quasis[a], c = a === 0, d = a === i - 1, f = u.value.cooked, h = f.split(`
`), m = h.length, v = o[a], x = m > 2 && h[0].trim() === "" && h[1].trim() === "", C = m > 2 && h[m - 1].trim() === "" && h[m - 2].trim() === "", E = h.every((w) => /^\s*(?:#[^\n\r]*)?$/u.test(w));
    if (!d && /#[^\n\r]*$/u.test(h[m - 1])) return null;
    let S = null;
    E ? S = kmt(h) : S = await e(f, { parser: "graphql" }), S ? (S = YX(S, !1), !c && x && s.push(""), s.push(S), !d && C && s.push("")) : !c && !d && x && s.push(""), v && s.push(v);
  }
  return ["`", mt([ft, Xn(ft, s)]), ft, "`"];
}
function kmt(e) {
  let t = [], n = !1, r = e.map((i) => i.trim());
  for (let [i, o] of r.entries()) o !== "" && (r[i - 1] === "" && n ? t.push([ft, o]) : t.push(o), n = !0);
  return t.length === 0 ? null : Xn(ft, t);
}
function Omt({ node: e, parent: t }) {
  return JX({ node: e, parent: t }, "GraphQL") || t && (t.type === "TaggedTemplateExpression" && (t.tag.type === "MemberExpression" && t.tag.object.name === "graphql" && t.tag.property.name === "experimental" || t.tag.type === "Identifier" && (t.tag.name === "gql" || t.tag.name === "graphql")) || t.type === "CallExpression" && t.callee.type === "Identifier" && t.callee.name === "graphql");
}
function Imt(e) {
  if (Omt(e)) return Pmt;
}
var Fmt = Imt, iP = 0;
async function XX(e, t, n, r, i) {
  let { node: o } = r, s = iP;
  iP = iP + 1 >>> 0;
  let a = (E) => `PRETTIER_HTML_PLACEHOLDER_${E}_${s}_IN_JS`, u = o.quasis.map((E, S, w) => S === w.length - 1 ? E.value.cooked : E.value.cooked + a(S)).join(""), c = WN(r, n), d = new RegExp(a(String.raw`(\d+)`), "gu"), f = 0, h = await t(u, { parser: e, __onHtmlRoot(E) {
    f = E.children.length;
  } }), m = Og(h, (E) => {
    if (typeof E != "string") return E;
    let S = [], w = E.split(d);
    for (let O = 0; O < w.length; O++) {
      let A = w[O];
      if (O % 2 === 0) {
        A && (A = KX(A), i.__embeddedInHtml && (A = yo(!1, A, /<\/(?=script\b)/giu, String.raw`<\/`)), S.push(A));
        continue;
      }
      let I = Number(A);
      S.push(c[I]);
    }
    return S;
  }), v = /^\s/u.test(u) ? " " : "", x = /\s$/u.test(u) ? " " : "", C = i.htmlWhitespaceSensitivity === "ignore" ? ft : v && x ? Wt : null;
  return C ? je(["`", mt([C, je(m)]), C, "`"]) : Av({ hug: !1 }, je(["`", v, f > 1 ? mt(je(m)) : je(m), x, "`"]));
}
function $mt(e) {
  return JX(e, "HTML") || e.match((t) => t.type === "TemplateLiteral", (t, n) => t.type === "TaggedTemplateExpression" && t.tag.type === "Identifier" && t.tag.name === "html" && n === "quasi");
}
var Nmt = XX.bind(void 0, "html"), Mmt = XX.bind(void 0, "angular");
function Rmt(e) {
  if ($mt(e)) return Nmt;
  if (vmt(e)) return Mmt;
}
var _mt = Rmt;
async function Lmt(e, t, n) {
  let { node: r } = n, i = yo(!1, r.quasis[0].value.raw, /((?:\\\\)*)\\`/gu, (u, c) => "\\".repeat(c.length / 2) + "`"), o = Bmt(i), s = o !== "";
  s && (i = yo(!1, i, new RegExp(`^${o}`, "gmu"), ""));
  let a = YX(await e(i, { parser: "markdown", __inJsTemplate: !0 }), !0);
  return ["`", s ? mt([lt, a]) : [FX, dht(a)], lt, "`"];
}
function Bmt(e) {
  let t = e.match(/^([^\S\n]*)\S/mu);
  return t === null ? "" : t[1];
}
function jmt(e) {
  if (Vmt(e)) return Lmt;
}
function Vmt({ node: e, parent: t }) {
  return (t == null ? void 0 : t.type) === "TaggedTemplateExpression" && e.quasis.length === 1 && t.tag.type === "Identifier" && (t.tag.name === "md" || t.tag.name === "markdown");
}
var zmt = jmt;
function Umt(e) {
  let { node: t } = e;
  if (t.type !== "TemplateLiteral" || Wmt(t)) return;
  let n;
  for (let r of [wmt, Fmt, _mt, zmt]) if (n = r(e), !!n) return t.quasis.length === 1 && t.quasis[0].value.raw.trim() === "" ? "``" : async (...i) => {
    let o = await n(...i);
    return o && Av({ embed: !0, ...o.label }, o);
  };
}
function Wmt({ quasis: e }) {
  return e.some(({ value: { cooked: t } }) => t === null);
}
var Hmt = Umt, qmt = /\*\/$/, Gmt = /^\/\*\*?/, QX = /^\s*(\/\*\*?(.|\r?\n)*?\*\/)/, Ymt = /(^|\s+)\/\/([^\n\r]*)/g, i6 = /^(\r?\n)+/, Kmt = /(?:^|\r?\n) *(@[^\n\r]*?) *\r?\n *(?![^\n\r@]*\/\/[^]*)([^\s@][^\n\r@]+?) *\r?\n/g, o6 = /(?:^|\r?\n) *@(\S+) *([^\n\r]*)/g, Jmt = /(\r?\n|^) *\* ?/g, ZX = [];
function Xmt(e) {
  let t = e.match(QX);
  return t ? t[0].trimStart() : "";
}
function Qmt(e) {
  let t = e.match(QX), n = t == null ? void 0 : t[0];
  return n == null ? e : e.slice(n.length);
}
function Zmt(e) {
  let t = `
`;
  e = yo(!1, e.replace(Gmt, "").replace(qmt, ""), Jmt, "$1");
  let n = "";
  for (; n !== e; ) n = e, e = yo(!1, e, Kmt, `${t}$1 $2${t}`);
  e = e.replace(i6, "").trimEnd();
  let r = /* @__PURE__ */ Object.create(null), i = yo(!1, e, o6, "").replace(i6, "").trimEnd(), o;
  for (; o = o6.exec(e); ) {
    let s = yo(!1, o[2], Ymt, "");
    if (typeof r[o[1]] == "string" || Array.isArray(r[o[1]])) {
      let a = r[o[1]];
      r[o[1]] = [...ZX, ...Array.isArray(a) ? a : [a], s];
    } else r[o[1]] = s;
  }
  return { comments: i, pragmas: r };
}
function egt({ comments: e = "", pragmas: t = {} }) {
  let n = `
`, r = "/**", i = " *", o = " */", s = Object.keys(t), a = s.flatMap((c) => s6(c, t[c])).map((c) => `${i} ${c}${n}`).join("");
  if (!e) {
    if (s.length === 0) return "";
    if (s.length === 1 && !Array.isArray(t[s[0]])) {
      let c = t[s[0]];
      return `${r} ${s6(s[0], c)[0]}${o}`;
    }
  }
  let u = e.split(n).map((c) => `${i} ${c}`).join(n) + n;
  return r + n + (e ? u : "") + (e && s.length > 0 ? i + n : "") + a + o;
}
function s6(e, t) {
  return [...ZX, ...Array.isArray(t) ? t : [t]].map((n) => `@${e} ${n}`.trim());
}
function tgt(e) {
  if (!e.startsWith("#!")) return "";
  let t = e.indexOf(`
`);
  return t === -1 ? e : e.slice(0, t);
}
var ngt = tgt;
function rgt(e) {
  let t = ngt(e);
  t && (e = e.slice(t.length + 1));
  let n = Xmt(e), { pragmas: r, comments: i } = Zmt(n);
  return { shebang: t, text: e, pragmas: r, comments: i };
}
function igt(e) {
  let { shebang: t, text: n, pragmas: r, comments: i } = rgt(e), o = Qmt(n), s = egt({ pragmas: { format: "", ...r }, comments: i.trimStart() });
  return (t ? `${t}
` : "") + s + (o.startsWith(`
`) ? `
` : `

`) + o;
}
function ogt(e, t) {
  let { originalText: n, [Symbol.for("comments")]: r, locStart: i, locEnd: o, [Symbol.for("printedComments")]: s } = t, { node: a } = e, u = i(a), c = o(a);
  for (let d of r) i(d) >= u && o(d) <= c && s.add(d);
  return n.slice(u, c);
}
var sgt = ogt;
function wO(e, t) {
  var n, r, i, o, s, a, u, c, d;
  if (e.isRoot) return !1;
  let { node: f, key: h, parent: m } = e;
  if (t.__isInHtmlInterpolation && !t.bracketSpacing && cgt(f) && Zy(e)) return !0;
  if (agt(f)) return !1;
  if (f.type === "Identifier") {
    if ((n = f.extra) != null && n.parenthesized && /^PRETTIER_HTML_PLACEHOLDER_\d+_\d+_IN_JS$/u.test(f.name) || h === "left" && (f.name === "async" && !m.await || f.name === "let") && m.type === "ForOfStatement") return !0;
    if (f.name === "let") {
      let v = (r = e.findAncestor((x) => x.type === "ForOfStatement")) == null ? void 0 : r.left;
      if (v && Qo(v, (x) => x === f)) return !0;
    }
    if (h === "object" && f.name === "let" && m.type === "MemberExpression" && m.computed && !m.optional) {
      let v = e.findAncestor((C) => C.type === "ExpressionStatement" || C.type === "ForStatement" || C.type === "ForInStatement"), x = v ? v.type === "ExpressionStatement" ? v.expression : v.type === "ForStatement" ? v.init : v.left : void 0;
      if (x && Qo(x, (C) => C === f)) return !0;
    }
    if (h === "expression") switch (f.name) {
      case "await":
      case "interface":
      case "module":
      case "using":
      case "yield":
      case "let":
      case "component":
      case "hook":
      case "type": {
        let v = e.findAncestor((x) => !iu(x));
        if (v !== m && v.type === "ExpressionStatement") return !0;
      }
    }
    return !1;
  }
  if (f.type === "ObjectExpression" || f.type === "FunctionExpression" || f.type === "ClassExpression" || f.type === "DoExpression") {
    let v = (i = e.findAncestor((x) => x.type === "ExpressionStatement")) == null ? void 0 : i.expression;
    if (v && Qo(v, (x) => x === f)) return !0;
  }
  if (f.type === "ObjectExpression") {
    let v = (o = e.findAncestor((x) => x.type === "ArrowFunctionExpression")) == null ? void 0 : o.body;
    if (v && v.type !== "SequenceExpression" && v.type !== "AssignmentExpression" && Qo(v, (x) => x === f)) return !0;
  }
  switch (m.type) {
    case "ParenthesizedExpression":
      return !1;
    case "ClassDeclaration":
    case "ClassExpression":
      if (h === "superClass" && (f.type === "ArrowFunctionExpression" || f.type === "AssignmentExpression" || f.type === "AwaitExpression" || f.type === "BinaryExpression" || f.type === "ConditionalExpression" || f.type === "LogicalExpression" || f.type === "NewExpression" || f.type === "ObjectExpression" || f.type === "SequenceExpression" || f.type === "TaggedTemplateExpression" || f.type === "UnaryExpression" || f.type === "UpdateExpression" || f.type === "YieldExpression" || f.type === "TSNonNullExpression" || f.type === "ClassExpression" && dr(f.decorators))) return !0;
      break;
    case "ExportDefaultDeclaration":
      return eQ(e, t) || f.type === "SequenceExpression";
    case "Decorator":
      if (h === "expression" && !pgt(f)) return !0;
      break;
    case "TypeAnnotation":
      if (e.match(void 0, void 0, (v, x) => x === "returnType" && v.type === "ArrowFunctionExpression") && ugt(f)) return !0;
      break;
    case "BinaryExpression":
      if (h === "left" && (m.operator === "in" || m.operator === "instanceof") && f.type === "UnaryExpression") return !0;
      break;
    case "VariableDeclarator":
      if (h === "init" && e.match(void 0, void 0, (v, x) => x === "declarations" && v.type === "VariableDeclaration", (v, x) => x === "left" && v.type === "ForInStatement")) return !0;
      break;
  }
  switch (f.type) {
    case "UpdateExpression":
      if (m.type === "UnaryExpression") return f.prefix && (f.operator === "++" && m.operator === "+" || f.operator === "--" && m.operator === "-");
    case "UnaryExpression":
      switch (m.type) {
        case "UnaryExpression":
          return f.operator === m.operator && (f.operator === "+" || f.operator === "-");
        case "BindExpression":
          return !0;
        case "MemberExpression":
        case "OptionalMemberExpression":
          return h === "object";
        case "TaggedTemplateExpression":
          return !0;
        case "NewExpression":
        case "CallExpression":
        case "OptionalCallExpression":
          return h === "callee";
        case "BinaryExpression":
          return h === "left" && m.operator === "**";
        case "TSNonNullExpression":
          return !0;
        default:
          return !1;
      }
    case "BinaryExpression":
      if (m.type === "UpdateExpression" || f.operator === "in" && lgt(e)) return !0;
      if (f.operator === "|>" && (s = f.extra) != null && s.parenthesized) {
        let v = e.grandparent;
        if (v.type === "BinaryExpression" && v.operator === "|>") return !0;
      }
    case "TSTypeAssertion":
    case "TSAsExpression":
    case "TSSatisfiesExpression":
    case "AsExpression":
    case "AsConstExpression":
    case "SatisfiesExpression":
    case "LogicalExpression":
      switch (m.type) {
        case "TSAsExpression":
        case "TSSatisfiesExpression":
        case "AsExpression":
        case "AsConstExpression":
        case "SatisfiesExpression":
          return !iu(f);
        case "ConditionalExpression":
          return iu(f) || jft(f);
        case "CallExpression":
        case "NewExpression":
        case "OptionalCallExpression":
          return h === "callee";
        case "ClassExpression":
        case "ClassDeclaration":
          return h === "superClass";
        case "TSTypeAssertion":
        case "TaggedTemplateExpression":
        case "UnaryExpression":
        case "JSXSpreadAttribute":
        case "SpreadElement":
        case "BindExpression":
        case "AwaitExpression":
        case "TSNonNullExpression":
        case "UpdateExpression":
          return !0;
        case "MemberExpression":
        case "OptionalMemberExpression":
          return h === "object";
        case "AssignmentExpression":
        case "AssignmentPattern":
          return h === "left" && (f.type === "TSTypeAssertion" || iu(f));
        case "LogicalExpression":
          if (f.type === "LogicalExpression") return m.operator !== f.operator;
        case "BinaryExpression": {
          let { operator: v, type: x } = f;
          if (!v && x !== "TSTypeAssertion") return !0;
          let C = NC(v), E = m.operator, S = NC(E);
          return S > C || h === "right" && S === C || S === C && !RN(E, v) ? !0 : S < C && v === "%" ? E === "+" || E === "-" : !!Zft(E);
        }
        default:
          return !1;
      }
    case "SequenceExpression":
      switch (m.type) {
        case "ReturnStatement":
          return !1;
        case "ForStatement":
          return !1;
        case "ExpressionStatement":
          return h !== "expression";
        case "ArrowFunctionExpression":
          return h !== "body";
        default:
          return !0;
      }
    case "YieldExpression":
      if (m.type === "AwaitExpression" || m.type === "TSTypeAssertion") return !0;
    case "AwaitExpression":
      switch (m.type) {
        case "TaggedTemplateExpression":
        case "UnaryExpression":
        case "LogicalExpression":
        case "SpreadElement":
        case "TSAsExpression":
        case "TSSatisfiesExpression":
        case "TSNonNullExpression":
        case "AsExpression":
        case "AsConstExpression":
        case "SatisfiesExpression":
        case "BindExpression":
          return !0;
        case "MemberExpression":
        case "OptionalMemberExpression":
          return h === "object";
        case "NewExpression":
        case "CallExpression":
        case "OptionalCallExpression":
          return h === "callee";
        case "ConditionalExpression":
          return h === "test";
        case "BinaryExpression":
          return !(!f.argument && m.operator === "|>");
        default:
          return !1;
      }
    case "TSFunctionType":
      if (e.match((v) => v.type === "TSFunctionType", (v, x) => x === "typeAnnotation" && v.type === "TSTypeAnnotation", (v, x) => x === "returnType" && v.type === "ArrowFunctionExpression")) return !0;
    case "TSConditionalType":
    case "TSConstructorType":
      if (h === "extendsType" && m.type === "TSConditionalType") {
        if (f.type === "TSConditionalType") return !0;
        let { typeAnnotation: v } = f.returnType || f.typeAnnotation;
        if (v.type === "TSTypePredicate" && v.typeAnnotation && (v = v.typeAnnotation.typeAnnotation), v.type === "TSInferType" && v.typeParameter.constraint) return !0;
      }
      if (h === "checkType" && m.type === "TSConditionalType") return !0;
    case "TSUnionType":
    case "TSIntersectionType":
      if ((m.type === "TSUnionType" || m.type === "TSIntersectionType") && m.types.length > 1 && (!f.types || f.types.length > 1)) return !0;
    case "TSInferType":
      if (f.type === "TSInferType") {
        if (m.type === "TSRestType") return !1;
        if (h === "types" && (m.type === "TSUnionType" || m.type === "TSIntersectionType") && f.typeParameter.type === "TSTypeParameter" && f.typeParameter.constraint) return !0;
      }
    case "TSTypeOperator":
      return m.type === "TSArrayType" || m.type === "TSOptionalType" || m.type === "TSRestType" || h === "objectType" && m.type === "TSIndexedAccessType" || m.type === "TSTypeOperator" || m.type === "TSTypeAnnotation" && e.grandparent.type.startsWith("TSJSDoc");
    case "TSTypeQuery":
      return h === "objectType" && m.type === "TSIndexedAccessType" || h === "elementType" && m.type === "TSArrayType";
    case "TypeOperator":
      return m.type === "ArrayTypeAnnotation" || m.type === "NullableTypeAnnotation" || h === "objectType" && (m.type === "IndexedAccessType" || m.type === "OptionalIndexedAccessType") || m.type === "TypeOperator";
    case "TypeofTypeAnnotation":
      return h === "objectType" && (m.type === "IndexedAccessType" || m.type === "OptionalIndexedAccessType") || h === "elementType" && m.type === "ArrayTypeAnnotation";
    case "ArrayTypeAnnotation":
      return m.type === "NullableTypeAnnotation";
    case "IntersectionTypeAnnotation":
    case "UnionTypeAnnotation":
      return m.type === "TypeOperator" || m.type === "ArrayTypeAnnotation" || m.type === "NullableTypeAnnotation" || m.type === "IntersectionTypeAnnotation" || m.type === "UnionTypeAnnotation" || h === "objectType" && (m.type === "IndexedAccessType" || m.type === "OptionalIndexedAccessType");
    case "InferTypeAnnotation":
    case "NullableTypeAnnotation":
      return m.type === "ArrayTypeAnnotation" || h === "objectType" && (m.type === "IndexedAccessType" || m.type === "OptionalIndexedAccessType");
    case "ComponentTypeAnnotation":
    case "FunctionTypeAnnotation": {
      if (f.type === "ComponentTypeAnnotation" && (f.rendersType === null || f.rendersType === void 0)) return !1;
      if (e.match(void 0, (x, C) => C === "typeAnnotation" && x.type === "TypeAnnotation", (x, C) => C === "returnType" && x.type === "ArrowFunctionExpression") || e.match(void 0, (x, C) => C === "typeAnnotation" && x.type === "TypePredicate", (x, C) => C === "typeAnnotation" && x.type === "TypeAnnotation", (x, C) => C === "returnType" && x.type === "ArrowFunctionExpression")) return !0;
      let v = m.type === "NullableTypeAnnotation" ? e.grandparent : m;
      return v.type === "UnionTypeAnnotation" || v.type === "IntersectionTypeAnnotation" || v.type === "ArrayTypeAnnotation" || h === "objectType" && (v.type === "IndexedAccessType" || v.type === "OptionalIndexedAccessType") || h === "checkType" && m.type === "ConditionalTypeAnnotation" || h === "extendsType" && m.type === "ConditionalTypeAnnotation" && ((a = f.returnType) == null ? void 0 : a.type) === "InferTypeAnnotation" && ((u = f.returnType) == null ? void 0 : u.typeParameter.bound) || v.type === "NullableTypeAnnotation" || m.type === "FunctionTypeParam" && m.name === null && jo(f).some((x) => {
        var C;
        return ((C = x.typeAnnotation) == null ? void 0 : C.type) === "NullableTypeAnnotation";
      });
    }
    case "ConditionalTypeAnnotation":
      if (h === "extendsType" && m.type === "ConditionalTypeAnnotation" && f.type === "ConditionalTypeAnnotation" || h === "checkType" && m.type === "ConditionalTypeAnnotation") return !0;
    case "OptionalIndexedAccessType":
      return h === "objectType" && m.type === "IndexedAccessType";
    case "StringLiteral":
    case "NumericLiteral":
    case "Literal":
      if (typeof f.value == "string" && m.type === "ExpressionStatement" && !m.directive) {
        let v = e.grandparent;
        return v.type === "Program" || v.type === "BlockStatement";
      }
      return h === "object" && m.type === "MemberExpression" && typeof f.value == "number";
    case "AssignmentExpression": {
      let v = e.grandparent;
      return h === "body" && m.type === "ArrowFunctionExpression" ? !0 : h === "key" && (m.type === "ClassProperty" || m.type === "PropertyDefinition") && m.computed || (h === "init" || h === "update") && m.type === "ForStatement" ? !1 : m.type === "ExpressionStatement" ? f.left.type === "ObjectPattern" : !(h === "key" && m.type === "TSPropertySignature" || m.type === "AssignmentExpression" || m.type === "SequenceExpression" && v.type === "ForStatement" && (v.init === m || v.update === m) || h === "value" && m.type === "Property" && v.type === "ObjectPattern" && v.properties.includes(m) || m.type === "NGChainedExpression");
    }
    case "ConditionalExpression":
      switch (m.type) {
        case "TaggedTemplateExpression":
        case "UnaryExpression":
        case "SpreadElement":
        case "BinaryExpression":
        case "LogicalExpression":
        case "NGPipeExpression":
        case "ExportDefaultDeclaration":
        case "AwaitExpression":
        case "JSXSpreadAttribute":
        case "TSTypeAssertion":
        case "TypeCastExpression":
        case "TSAsExpression":
        case "TSSatisfiesExpression":
        case "AsExpression":
        case "AsConstExpression":
        case "SatisfiesExpression":
        case "TSNonNullExpression":
          return !0;
        case "NewExpression":
        case "CallExpression":
        case "OptionalCallExpression":
          return h === "callee";
        case "ConditionalExpression":
          return t.experimentalTernaries ? !1 : h === "test";
        case "MemberExpression":
        case "OptionalMemberExpression":
          return h === "object";
        default:
          return !1;
      }
    case "FunctionExpression":
      switch (m.type) {
        case "NewExpression":
        case "CallExpression":
        case "OptionalCallExpression":
          return h === "callee";
        case "TaggedTemplateExpression":
          return !0;
        default:
          return !1;
      }
    case "ArrowFunctionExpression":
      switch (m.type) {
        case "BinaryExpression":
          return m.operator !== "|>" || ((c = f.extra) == null ? void 0 : c.parenthesized);
        case "NewExpression":
        case "CallExpression":
        case "OptionalCallExpression":
          return h === "callee";
        case "MemberExpression":
        case "OptionalMemberExpression":
          return h === "object";
        case "TSAsExpression":
        case "TSSatisfiesExpression":
        case "AsExpression":
        case "AsConstExpression":
        case "SatisfiesExpression":
        case "TSNonNullExpression":
        case "BindExpression":
        case "TaggedTemplateExpression":
        case "UnaryExpression":
        case "LogicalExpression":
        case "AwaitExpression":
        case "TSTypeAssertion":
          return !0;
        case "ConditionalExpression":
          return h === "test";
        default:
          return !1;
      }
    case "ClassExpression":
      switch (m.type) {
        case "NewExpression":
          return h === "callee";
        default:
          return !1;
      }
    case "OptionalMemberExpression":
    case "OptionalCallExpression":
    case "CallExpression":
    case "MemberExpression":
      if (dgt(e)) return !0;
    case "TaggedTemplateExpression":
    case "TSNonNullExpression":
      if (h === "callee" && (m.type === "BindExpression" || m.type === "NewExpression")) {
        let v = f;
        for (; v; ) switch (v.type) {
          case "CallExpression":
          case "OptionalCallExpression":
            return !0;
          case "MemberExpression":
          case "OptionalMemberExpression":
          case "BindExpression":
            v = v.object;
            break;
          case "TaggedTemplateExpression":
            v = v.tag;
            break;
          case "TSNonNullExpression":
            v = v.expression;
            break;
          default:
            return !1;
        }
      }
      return !1;
    case "BindExpression":
      return h === "callee" && (m.type === "BindExpression" || m.type === "NewExpression") || h === "object" && mi(m);
    case "NGPipeExpression":
      return !(m.type === "NGRoot" || m.type === "NGMicrosyntaxExpression" || m.type === "ObjectProperty" && !((d = f.extra) != null && d.parenthesized) || Eo(m) || h === "arguments" && or(m) || h === "right" && m.type === "NGPipeExpression" || h === "property" && m.type === "MemberExpression" || m.type === "AssignmentExpression");
    case "JSXFragment":
    case "JSXElement":
      return h === "callee" || h === "left" && m.type === "BinaryExpression" && m.operator === "<" || !Eo(m) && m.type !== "ArrowFunctionExpression" && m.type !== "AssignmentExpression" && m.type !== "AssignmentPattern" && m.type !== "BinaryExpression" && m.type !== "NewExpression" && m.type !== "ConditionalExpression" && m.type !== "ExpressionStatement" && m.type !== "JsExpressionRoot" && m.type !== "JSXAttribute" && m.type !== "JSXElement" && m.type !== "JSXExpressionContainer" && m.type !== "JSXFragment" && m.type !== "LogicalExpression" && !or(m) && !kc(m) && m.type !== "ReturnStatement" && m.type !== "ThrowStatement" && m.type !== "TypeCastExpression" && m.type !== "VariableDeclarator" && m.type !== "YieldExpression";
    case "TSInstantiationExpression":
      return h === "object" && mi(m);
  }
  return !1;
}
var agt = Ir(["BlockStatement", "BreakStatement", "ComponentDeclaration", "ClassBody", "ClassDeclaration", "ClassMethod", "ClassProperty", "PropertyDefinition", "ClassPrivateProperty", "ContinueStatement", "DebuggerStatement", "DeclareComponent", "DeclareClass", "DeclareExportAllDeclaration", "DeclareExportDeclaration", "DeclareFunction", "DeclareHook", "DeclareInterface", "DeclareModule", "DeclareModuleExports", "DeclareNamespace", "DeclareVariable", "DeclareEnum", "DoWhileStatement", "EnumDeclaration", "ExportAllDeclaration", "ExportDefaultDeclaration", "ExportNamedDeclaration", "ExpressionStatement", "ForInStatement", "ForOfStatement", "ForStatement", "FunctionDeclaration", "HookDeclaration", "IfStatement", "ImportDeclaration", "InterfaceDeclaration", "LabeledStatement", "MethodDefinition", "ReturnStatement", "SwitchStatement", "ThrowStatement", "TryStatement", "TSDeclareFunction", "TSEnumDeclaration", "TSImportEqualsDeclaration", "TSInterfaceDeclaration", "TSModuleDeclaration", "TSNamespaceExportDeclaration", "TypeAlias", "VariableDeclaration", "WhileStatement", "WithStatement"]);
function lgt(e) {
  let t = 0, { node: n } = e;
  for (; n; ) {
    let r = e.getParentNode(t++);
    if ((r == null ? void 0 : r.type) === "ForStatement" && r.init === n) return !0;
    n = r;
  }
  return !1;
}
function ugt(e) {
  return vO(e, (t) => t.type === "ObjectTypeAnnotation" && vO(t, (n) => n.type === "FunctionTypeAnnotation"));
}
function cgt(e) {
  return Cl(e);
}
function Zy(e) {
  let { parent: t, key: n } = e;
  switch (t.type) {
    case "NGPipeExpression":
      if (n === "arguments" && e.isLast) return e.callParent(Zy);
      break;
    case "ObjectProperty":
      if (n === "value") return e.callParent(() => e.key === "properties" && e.isLast);
      break;
    case "BinaryExpression":
    case "LogicalExpression":
      if (n === "right") return e.callParent(Zy);
      break;
    case "ConditionalExpression":
      if (n === "alternate") return e.callParent(Zy);
      break;
    case "UnaryExpression":
      if (t.prefix) return e.callParent(Zy);
      break;
  }
  return !1;
}
function eQ(e, t) {
  let { node: n, parent: r } = e;
  return n.type === "FunctionExpression" || n.type === "ClassExpression" ? r.type === "ExportDefaultDeclaration" || !wO(e, t) : !FN(n) || r.type !== "ExportDefaultDeclaration" && wO(e, t) ? !1 : e.call(() => eQ(e, t), ...gX(n));
}
function dgt(e) {
  let { node: t, parent: n, grandparent: r, key: i } = e;
  return !!((t.type === "OptionalMemberExpression" || t.type === "OptionalCallExpression") && (i === "object" && n.type === "MemberExpression" || i === "callee" && (n.type === "CallExpression" || n.type === "NewExpression") || n.type === "TSNonNullExpression" && r.type === "MemberExpression" && r.object === n) || e.match(() => t.type === "CallExpression" || t.type === "MemberExpression", (o, s) => s === "expression" && o.type === "ChainExpression") && (e.match(void 0, void 0, (o, s) => s === "callee" && (o.type === "CallExpression" && !o.optional || o.type === "NewExpression") || s === "object" && o.type === "MemberExpression" && !o.optional) || e.match(void 0, void 0, (o, s) => s === "expression" && o.type === "TSNonNullExpression", (o, s) => s === "object" && o.type === "MemberExpression")) || e.match(() => t.type === "CallExpression" || t.type === "MemberExpression", (o, s) => s === "expression" && o.type === "TSNonNullExpression", (o, s) => s === "expression" && o.type === "ChainExpression", (o, s) => s === "object" && o.type === "MemberExpression"));
}
function PO(e) {
  return e.type === "Identifier" ? !0 : mi(e) ? !e.computed && !e.optional && e.property.type === "Identifier" && PO(e.object) : !1;
}
function pgt(e) {
  return e.type === "ChainExpression" && (e = e.expression), PO(e) || or(e) && !e.optional && PO(e.callee);
}
var Lf = wO;
function fgt(e, t) {
  let n = t - 1;
  n = Fm(e, n, { backwards: !0 }), n = $m(e, n, { backwards: !0 }), n = Fm(e, n, { backwards: !0 });
  let r = $m(e, n, { backwards: !0 });
  return n !== r;
}
var hgt = fgt, mgt = () => !0;
function HN(e, t) {
  let n = e.node;
  return n.printed = !0, t.printer.printComment(e, t);
}
function ggt(e, t) {
  var n;
  let r = e.node, i = [HN(e, t)], { printer: o, originalText: s, locStart: a, locEnd: u } = t;
  if ((n = o.isBlockComment) != null && n.call(o, r)) {
    let d = oa(s, u(r)) ? oa(s, a(r), { backwards: !0 }) ? ft : Wt : " ";
    i.push(d);
  } else i.push(ft);
  let c = $m(s, Fm(s, u(r)));
  return c !== !1 && oa(s, c) && i.push(ft), i;
}
function ygt(e, t, n) {
  var r;
  let i = e.node, o = HN(e, t), { printer: s, originalText: a, locStart: u } = t, c = (r = s.isBlockComment) == null ? void 0 : r.call(s, i);
  if (n != null && n.hasLineSuffix && !(n != null && n.isBlock) || oa(a, u(i), { backwards: !0 })) {
    let d = hgt(a, u(i));
    return { doc: e6([ft, d ? ft : "", o]), isBlock: c, hasLineSuffix: !0 };
  }
  return !c || n != null && n.hasLineSuffix ? { doc: [e6([" ", o]), Cu], isBlock: c, hasLineSuffix: !0 } : { doc: [" ", o], isBlock: c, hasLineSuffix: !1 };
}
function Zr(e, t, n = {}) {
  let { node: r } = e;
  if (!dr(r == null ? void 0 : r.comments)) return "";
  let { indent: i = !1, marker: o, filter: s = mgt } = n, a = [];
  if (e.each(({ node: c }) => {
    c.leading || c.trailing || c.marker !== o || !s(c) || a.push(HN(e, t));
  }, "comments"), a.length === 0) return "";
  let u = Xn(ft, a);
  return i ? mt([ft, u]) : u;
}
function tQ(e, t) {
  let n = e.node;
  if (!n) return {};
  let r = t[Symbol.for("printedComments")];
  if ((n.comments || []).filter((a) => !r.has(a)).length === 0) return { leading: "", trailing: "" };
  let i = [], o = [], s;
  return e.each(() => {
    let a = e.node;
    if (r != null && r.has(a)) return;
    let { leading: u, trailing: c } = a;
    u ? i.push(ggt(e, t)) : c && (s = ygt(e, t, s), o.push(s.doc));
  }, "comments"), { leading: i, trailing: o };
}
function yl(e, t, n) {
  let { leading: r, trailing: i } = tQ(e, n);
  return !r && !i ? t : CO(t, (o) => [r, o, i]);
}
var bgt = class extends Error {
  constructor(t, n, r = "type") {
    super(`Unexpected ${n} node ${r}: ${JSON.stringify(t[r])}.`);
    ap(this, "name", "UnexpectedNodeError");
    this.node = t;
  }
}, Ig = bgt;
function vgt(e) {
  if (typeof e != "string") throw new TypeError("Expected a string");
  return e.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
}
var dl, xgt = class {
  constructor(e) {
    Jpt(this, dl), Xpt(this, dl, new Set(e));
  }
  getLeadingWhitespaceCount(e) {
    let t = Gc(this, dl), n = 0;
    for (let r = 0; r < e.length && t.has(e.charAt(r)); r++) n++;
    return n;
  }
  getTrailingWhitespaceCount(e) {
    let t = Gc(this, dl), n = 0;
    for (let r = e.length - 1; r >= 0 && t.has(e.charAt(r)); r--) n++;
    return n;
  }
  getLeadingWhitespace(e) {
    let t = this.getLeadingWhitespaceCount(e);
    return e.slice(0, t);
  }
  getTrailingWhitespace(e) {
    let t = this.getTrailingWhitespaceCount(e);
    return e.slice(e.length - t);
  }
  hasLeadingWhitespace(e) {
    return Gc(this, dl).has(e.charAt(0));
  }
  hasTrailingWhitespace(e) {
    return Gc(this, dl).has(ur(!1, e, -1));
  }
  trimStart(e) {
    let t = this.getLeadingWhitespaceCount(e);
    return e.slice(t);
  }
  trimEnd(e) {
    let t = this.getTrailingWhitespaceCount(e);
    return e.slice(0, e.length - t);
  }
  trim(e) {
    return this.trimEnd(this.trimStart(e));
  }
  split(e, t = !1) {
    let n = `[${vgt([...Gc(this, dl)].join(""))}]+`, r = new RegExp(t ? `(${n})` : n, "u");
    return e.split(r);
  }
  hasWhitespaceCharacter(e) {
    let t = Gc(this, dl);
    return Array.prototype.some.call(e, (n) => t.has(n));
  }
  hasNonWhitespaceCharacter(e) {
    let t = Gc(this, dl);
    return Array.prototype.some.call(e, (n) => !t.has(n));
  }
  isWhitespaceOnly(e) {
    let t = Gc(this, dl);
    return Array.prototype.every.call(e, (n) => t.has(n));
  }
};
dl = /* @__PURE__ */ new WeakMap();
var Dgt = xgt, bD = new Dgt(` 
\r	`), oP = (e) => e === "" || e === Wt || e === ft || e === lt;
function Cgt(e, t, n) {
  var r, i, o;
  let { node: s } = e;
  if (s.type === "JSXElement" && _gt(s)) return [n("openingElement"), n("closingElement")];
  let a = s.type === "JSXElement" ? n("openingElement") : n("openingFragment"), u = s.type === "JSXElement" ? n("closingElement") : n("closingFragment");
  if (s.children.length === 1 && s.children[0].type === "JSXExpressionContainer" && (s.children[0].expression.type === "TemplateLiteral" || s.children[0].expression.type === "TaggedTemplateExpression")) return [a, ...e.map(n, "children"), u];
  s.children = s.children.map((I) => Lgt(I) ? { type: "JSXText", value: " ", raw: " " } : I);
  let c = s.children.some(oo), d = s.children.filter((I) => I.type === "JSXExpressionContainer").length > 1, f = s.type === "JSXElement" && s.openingElement.attributes.length > 1, h = ts(a) || c || f || d, m = e.parent.rootMarker === "mdx", v = t.singleQuote ? "{' '}" : '{" "}', x = m ? " " : Fn([v, lt], " "), C = ((i = (r = s.openingElement) == null ? void 0 : r.name) == null ? void 0 : i.name) === "fbt", E = Egt(e, t, n, x, C), S = s.children.some((I) => gb(I));
  for (let I = E.length - 2; I >= 0; I--) {
    let $ = E[I] === "" && E[I + 1] === "", L = E[I] === ft && E[I + 1] === "" && E[I + 2] === ft, B = (E[I] === lt || E[I] === ft) && E[I + 1] === "" && E[I + 2] === x, H = E[I] === x && E[I + 1] === "" && (E[I + 2] === lt || E[I + 2] === ft), q = E[I] === x && E[I + 1] === "" && E[I + 2] === x, J = E[I] === lt && E[I + 1] === "" && E[I + 2] === ft || E[I] === ft && E[I + 1] === "" && E[I + 2] === lt;
    L && S || $ || B || q || J ? E.splice(I, 2) : H && E.splice(I + 1, 2);
  }
  for (; E.length > 0 && oP(ur(!1, E, -1)); ) E.pop();
  for (; E.length > 1 && oP(E[0]) && oP(E[1]); ) E.shift(), E.shift();
  let w = [];
  for (let [I, $] of E.entries()) {
    if ($ === x) {
      if (I === 1 && E[I - 1] === "") {
        if (E.length === 2) {
          w.push(v);
          continue;
        }
        w.push([v, ft]);
        continue;
      } else if (I === E.length - 1) {
        w.push(v);
        continue;
      } else if (E[I - 1] === "" && E[I - 2] === ft) {
        w.push(v);
        continue;
      }
    }
    w.push($), ts($) && (h = !0);
  }
  let O = S ? _N(w) : je(w, { shouldBreak: !0 });
  if (((o = t.cursorNode) == null ? void 0 : o.type) === "JSXText" && s.children.includes(t.cursorNode) && (O = [t6, O, t6]), m) return O;
  let A = je([a, mt([ft, O]), ft, u]);
  return h ? A : $p([je([a, ...E, u]), A]);
}
function Egt(e, t, n, r, i) {
  let o = [];
  return e.each(({ node: s, next: a }) => {
    if (s.type === "JSXText") {
      let u = qa(s);
      if (gb(s)) {
        let c = bD.split(u, !0);
        c[0] === "" && (o.push(""), c.shift(), /\n/u.test(c[0]) ? o.push(l6(i, c[1], s, a)) : o.push(r), c.shift());
        let d;
        if (ur(!1, c, -1) === "" && (c.pop(), d = c.pop()), c.length === 0) return;
        for (let [f, h] of c.entries()) f % 2 === 1 ? o.push(Wt) : o.push(h);
        d !== void 0 ? /\n/u.test(d) ? o.push(l6(i, ur(!1, o, -1), s, a)) : o.push(r) : o.push(a6(i, ur(!1, o, -1), s, a));
      } else /\n/u.test(u) ? u.match(/\n/gu).length > 1 && o.push("", ft) : o.push("", r);
    } else {
      let u = n();
      if (o.push(u), a && gb(a)) {
        let c = bD.trim(qa(a)), [d] = bD.split(c);
        o.push(a6(i, d, s, a));
      } else o.push(ft);
    }
  }, "children"), o;
}
function a6(e, t, n, r) {
  return e ? "" : n.type === "JSXElement" && !n.closingElement || (r == null ? void 0 : r.type) === "JSXElement" && !r.closingElement ? t.length === 1 ? lt : ft : lt;
}
function l6(e, t, n, r) {
  return e ? ft : t.length === 1 ? n.type === "JSXElement" && !n.closingElement || (r == null ? void 0 : r.type) === "JSXElement" && !r.closingElement ? ft : lt : ft;
}
var Tgt = /* @__PURE__ */ new Set(["ArrayExpression", "TupleExpression", "JSXAttribute", "JSXElement", "JSXExpressionContainer", "JSXFragment", "ExpressionStatement", "CallExpression", "OptionalCallExpression", "ConditionalExpression", "JsExpressionRoot"]);
function Sgt(e, t, n) {
  let { parent: r } = e;
  if (Tgt.has(r.type)) return t;
  let i = e.match(void 0, (s) => s.type === "ArrowFunctionExpression", or, (s) => s.type === "JSXExpressionContainer"), o = Lf(e, n);
  return je([o ? "" : Fn("("), mt([lt, t]), lt, o ? "" : Fn(")")], { shouldBreak: i });
}
function Agt(e, t, n) {
  let { node: r } = e, i = [];
  if (i.push(n("name")), r.value) {
    let o;
    if (us(r.value)) {
      let s = qa(r.value), a = yo(!1, yo(!1, s.slice(1, -1), "&apos;", "'"), "&quot;", '"'), u = dX(a, t.jsxSingleQuote);
      a = u === '"' ? yo(!1, a, '"', "&quot;") : yo(!1, a, "'", "&apos;"), o = e.call(() => yl(e, af(u + a + u), t), "value");
    } else o = n("value");
    i.push("=", o);
  }
  return i;
}
function wgt(e, t, n) {
  let { node: r } = e, i = (o, s) => o.type === "JSXEmptyExpression" || !kt(o) && (Eo(o) || Cl(o) || o.type === "ArrowFunctionExpression" || o.type === "AwaitExpression" && (i(o.argument, o) || o.argument.type === "JSXElement") || or(o) || o.type === "ChainExpression" && or(o.expression) || o.type === "FunctionExpression" || o.type === "TemplateLiteral" || o.type === "TaggedTemplateExpression" || o.type === "DoExpression" || oo(s) && (o.type === "ConditionalExpression" || hc(o)));
  return i(r.expression, e.parent) ? je(["{", n("expression"), mc, "}"]) : je(["{", mt([lt, n("expression")]), lt, mc, "}"]);
}
function Pgt(e, t, n) {
  var r, i;
  let { node: o } = e, s = kt(o.name) || kt(o.typeParameters) || kt(o.typeArguments);
  if (o.selfClosing && o.attributes.length === 0 && !s) return ["<", n("name"), o.typeArguments ? n("typeArguments") : n("typeParameters"), " />"];
  if (((r = o.attributes) == null ? void 0 : r.length) === 1 && us(o.attributes[0].value) && !o.attributes[0].value.value.includes(`
`) && !s && !kt(o.attributes[0])) return je(["<", n("name"), o.typeArguments ? n("typeArguments") : n("typeParameters"), " ", ...e.map(n, "attributes"), o.selfClosing ? " />" : ">"]);
  let a = (i = o.attributes) == null ? void 0 : i.some((c) => us(c.value) && c.value.value.includes(`
`)), u = t.singleAttributePerLine && o.attributes.length > 1 ? ft : Wt;
  return je(["<", n("name"), o.typeArguments ? n("typeArguments") : n("typeParameters"), mt(e.map(() => [u, n()], "attributes")), ...kgt(o, t, s)], { shouldBreak: a });
}
function kgt(e, t, n) {
  return e.selfClosing ? [Wt, "/>"] : Ogt(e, t, n) ? [">"] : [lt, ">"];
}
function Ogt(e, t, n) {
  let r = e.attributes.length > 0 && kt(ur(!1, e.attributes, -1), qt.Trailing);
  return e.attributes.length === 0 && !n || (t.bracketSameLine || t.jsxBracketSameLine) && (!n || e.attributes.length > 0) && !r;
}
function Igt(e, t, n) {
  let { node: r } = e, i = [];
  i.push("</");
  let o = n("name");
  return kt(r.name, qt.Leading | qt.Line) ? i.push(mt([ft, o]), ft) : kt(r.name, qt.Leading | qt.Block) ? i.push(" ", o) : i.push(o), i.push(">"), i;
}
function Fgt(e, t) {
  let { node: n } = e, r = kt(n), i = kt(n, qt.Line), o = n.type === "JSXOpeningFragment";
  return [o ? "<" : "</", mt([i ? ft : r && !o ? " " : "", Zr(e, t)]), i ? ft : "", ">"];
}
function $gt(e, t, n) {
  let r = yl(e, Cgt(e, t, n), t);
  return Sgt(e, r, t);
}
function Ngt(e, t) {
  let { node: n } = e, r = kt(n, qt.Line);
  return [Zr(e, t, { indent: r }), r ? ft : ""];
}
function Mgt(e, t, n) {
  let { node: r } = e;
  return ["{", e.call(({ node: i }) => {
    let o = ["...", n()];
    return !kt(i) || !WX(e) ? o : [mt([lt, yl(e, o, t)]), lt];
  }, r.type === "JSXSpreadAttribute" ? "argument" : "expression"), "}"];
}
function Rgt(e, t, n) {
  let { node: r } = e;
  if (r.type.startsWith("JSX")) switch (r.type) {
    case "JSXAttribute":
      return Agt(e, t, n);
    case "JSXIdentifier":
      return r.name;
    case "JSXNamespacedName":
      return Xn(":", [n("namespace"), n("name")]);
    case "JSXMemberExpression":
      return Xn(".", [n("object"), n("property")]);
    case "JSXSpreadAttribute":
    case "JSXSpreadChild":
      return Mgt(e, t, n);
    case "JSXExpressionContainer":
      return wgt(e, t, n);
    case "JSXFragment":
    case "JSXElement":
      return $gt(e, t, n);
    case "JSXOpeningElement":
      return Pgt(e, t, n);
    case "JSXClosingElement":
      return Igt(e, t, n);
    case "JSXOpeningFragment":
    case "JSXClosingFragment":
      return Fgt(e, t);
    case "JSXEmptyExpression":
      return Ngt(e, t);
    case "JSXText":
      throw new Error("JSXText should be handled by JSXElement");
    default:
      throw new Ig(r, "JSX");
  }
}
function _gt(e) {
  if (e.children.length === 0) return !0;
  if (e.children.length > 1) return !1;
  let t = e.children[0];
  return t.type === "JSXText" && !gb(t);
}
function gb(e) {
  return e.type === "JSXText" && (bD.hasNonWhitespaceCharacter(qa(e)) || !/\n/u.test(qa(e)));
}
function Lgt(e) {
  return e.type === "JSXExpressionContainer" && us(e.expression) && e.expression.value === " " && !kt(e.expression);
}
function Bgt(e) {
  let { node: t, parent: n } = e;
  if (!oo(t) || !oo(n)) return !1;
  let { index: r, siblings: i } = e, o;
  for (let s = r; s > 0; s--) {
    let a = i[s - 1];
    if (!(a.type === "JSXText" && !gb(a))) {
      o = a;
      break;
    }
  }
  return (o == null ? void 0 : o.type) === "JSXExpressionContainer" && o.expression.type === "JSXEmptyExpression" && FT(o.expression);
}
function jgt(e) {
  return FT(e.node) || Bgt(e);
}
var nQ = jgt, Vgt = 0;
function rQ(e, t, n) {
  var r;
  let { node: i, parent: o, grandparent: s, key: a } = e, u = a !== "body" && (o.type === "IfStatement" || o.type === "WhileStatement" || o.type === "SwitchStatement" || o.type === "DoWhileStatement"), c = i.operator === "|>" && ((r = e.root.extra) == null ? void 0 : r.__isUsingHackPipeline), d = kO(e, n, t, !1, u);
  if (u) return d;
  if (c) return je(d);
  if (or(o) && o.callee === i || o.type === "UnaryExpression" || mi(o) && !o.computed) return je([mt([lt, ...d]), lt]);
  let f = o.type === "ReturnStatement" || o.type === "ThrowStatement" || o.type === "JSXExpressionContainer" && s.type === "JSXAttribute" || i.operator !== "|" && o.type === "JsExpressionRoot" || i.type !== "NGPipeExpression" && (o.type === "NGRoot" && t.parser === "__ng_binding" || o.type === "NGMicrosyntaxExpression" && s.type === "NGMicrosyntax" && s.body.length === 1) || i === o.body && o.type === "ArrowFunctionExpression" || i !== o.body && o.type === "ForStatement" || o.type === "ConditionalExpression" && s.type !== "ReturnStatement" && s.type !== "ThrowStatement" && !or(s) || o.type === "TemplateLiteral", h = o.type === "AssignmentExpression" || o.type === "VariableDeclarator" || o.type === "ClassProperty" || o.type === "PropertyDefinition" || o.type === "TSAbstractPropertyDefinition" || o.type === "ClassPrivateProperty" || kc(o), m = hc(i.left) && RN(i.operator, i.left.operator);
  if (f || yb(i) && !m || !yb(i) && h) return je(d);
  if (d.length === 0) return "";
  let v = oo(i.right), x = d.findIndex((A) => typeof A != "string" && !Array.isArray(A) && A.type === Ga), C = d.slice(0, x === -1 ? 1 : x + 1), E = d.slice(C.length, v ? -1 : void 0), S = Symbol("logicalChain-" + ++Vgt), w = je([...C, mt(E)], { id: S });
  if (!v) return w;
  let O = ur(!1, d, -1);
  return je([w, $T(O, { groupId: S })]);
}
function kO(e, t, n, r, i) {
  var o;
  let { node: s } = e;
  if (!hc(s)) return [je(t())];
  let a = [];
  RN(s.operator, s.left.operator) ? a = e.call((C) => kO(C, t, n, !0, i), "left") : a.push(je(t("left")));
  let u = yb(s), c = (s.operator === "|>" || s.type === "NGPipeExpression" || zgt(e, n)) && !of(n.originalText, s.right), d = s.type === "NGPipeExpression" ? "|" : s.operator, f = s.type === "NGPipeExpression" && s.arguments.length > 0 ? je(mt([lt, ": ", Xn([Wt, ": "], e.map(() => Du(2, je(t())), "arguments"))])) : "", h;
  if (u) h = [d, " ", t("right"), f];
  else {
    let C = d === "|>" && ((o = e.root.extra) != null && o.__isUsingHackPipeline) ? e.call((E) => kO(E, t, n, !0, i), "right") : t("right");
    h = [c ? Wt : "", d, c ? " " : Wt, C, f];
  }
  let { parent: m } = e, v = kt(s.left, qt.Trailing | qt.Line), x = v || !(i && s.type === "LogicalExpression") && m.type !== s.type && s.left.type !== s.type && s.right.type !== s.type;
  if (a.push(c ? "" : " ", x ? je(h, { shouldBreak: v }) : h), r && kt(s)) {
    let C = LN(yl(e, a, n));
    return C.type === _d ? C.parts : Array.isArray(C) ? C : [C];
  }
  return a;
}
function yb(e) {
  return e.type !== "LogicalExpression" ? !1 : !!(Cl(e.right) && e.right.properties.length > 0 || Eo(e.right) && e.right.elements.length > 0 || oo(e.right));
}
var u6 = (e) => e.type === "BinaryExpression" && e.operator === "|";
function zgt(e, t) {
  return (t.parser === "__vue_expression" || t.parser === "__vue_ts_expression") && u6(e.node) && !e.hasAncestor((n) => !u6(n) && n.type !== "JsExpressionRoot");
}
function Ugt(e, t, n) {
  let { node: r } = e;
  if (r.type.startsWith("NG")) switch (r.type) {
    case "NGRoot":
      return [n("node"), kt(r.node) ? " //" + om(r.node)[0].value.trimEnd() : ""];
    case "NGPipeExpression":
      return rQ(e, t, n);
    case "NGChainedExpression":
      return je(Xn([";", Wt], e.map(() => Hgt(e) ? n() : ["(", n(), ")"], "expressions")));
    case "NGEmptyExpression":
      return "";
    case "NGMicrosyntax":
      return e.map(() => [e.isFirst ? "" : c6(e) ? " " : [";", Wt], n()], "body");
    case "NGMicrosyntaxKey":
      return /^[$_a-z][\w$]*(?:-[$_a-z][\w$])*$/iu.test(r.name) ? r.name : JSON.stringify(r.name);
    case "NGMicrosyntaxExpression":
      return [n("expression"), r.alias === null ? "" : [" as ", n("alias")]];
    case "NGMicrosyntaxKeyedExpression": {
      let { index: i, parent: o } = e, s = c6(e) || (i === 1 && (r.key.name === "then" || r.key.name === "else" || r.key.name === "as") || (i === 2 || i === 3) && (r.key.name === "else" && o.body[i - 1].type === "NGMicrosyntaxKeyedExpression" && o.body[i - 1].key.name === "then" || r.key.name === "track")) && o.body[0].type === "NGMicrosyntaxExpression";
      return [n("key"), s ? " " : ": ", n("expression")];
    }
    case "NGMicrosyntaxLet":
      return ["let ", n("key"), r.value === null ? "" : [" = ", n("value")]];
    case "NGMicrosyntaxAs":
      return [n("key"), " as ", n("alias")];
    default:
      throw new Ig(r, "Angular");
  }
}
function c6({ node: e, index: t }) {
  return e.type === "NGMicrosyntaxKeyedExpression" && e.key.name === "of" && t === 1;
}
var Wgt = Ir(["CallExpression", "OptionalCallExpression", "AssignmentExpression"]);
function Hgt({ node: e }) {
  return vO(e, Wgt);
}
function iQ(e, t, n) {
  let { node: r } = e;
  return je([Xn(Wt, e.map(n, "decorators")), oQ(r, t) ? ft : Wt]);
}
function qgt(e, t, n) {
  return sQ(e.node) ? [Xn(ft, e.map(n, "declaration", "decorators")), ft] : "";
}
function Ggt(e, t, n) {
  let { node: r, parent: i } = e, { decorators: o } = r;
  if (!dr(o) || sQ(i) || nQ(e)) return "";
  let s = r.type === "ClassExpression" || r.type === "ClassDeclaration" || oQ(r, t);
  return [e.key === "declaration" && Bft(i) ? ft : s ? Cu : "", Xn(Wt, e.map(n, "decorators")), Wt];
}
function oQ(e, t) {
  return e.decorators.some((n) => oa(t.originalText, Zn(n)));
}
function sQ(e) {
  var t;
  if (e.type !== "ExportDefaultDeclaration" && e.type !== "ExportNamedDeclaration" && e.type !== "DeclareExportDeclaration") return !1;
  let n = (t = e.declaration) == null ? void 0 : t.decorators;
  return dr(n) && PT(e, n[0]);
}
var _C = class extends Error {
  constructor() {
    super(...arguments);
    ap(this, "name", "ArgExpansionBailout");
  }
};
function Ygt(e, t, n) {
  let { node: r } = e, i = el(r);
  if (i.length === 0) return ["(", Zr(e, t), ")"];
  let o = i.length - 1;
  if (Xgt(i)) {
    let h = ["("];
    return MC(e, (m, v) => {
      h.push(n()), v !== o && h.push(", ");
    }), h.push(")"), h;
  }
  let s = !1, a = [];
  MC(e, ({ node: h }, m) => {
    let v = n();
    m === o || (Pc(h, t) ? (s = !0, v = [v, ",", ft, ft]) : v = [v, ",", Wt]), a.push(v);
  });
  let u = r.type === "ImportExpression" || r.callee.type === "Import", c = !t.parser.startsWith("__ng_") && !u && wc(t, "all") ? "," : "";
  function d() {
    return je(["(", mt([Wt, ...a]), c, Wt, ")"], { shouldBreak: !0 });
  }
  if (s || e.parent.type !== "Decorator" && Kft(i)) return d();
  if (Jgt(i)) {
    let h = a.slice(1);
    if (h.some(ts)) return d();
    let m;
    try {
      m = n(Q4(r, 0), { expandFirstArg: !0 });
    } catch (v) {
      if (v instanceof _C) return d();
      throw v;
    }
    return ts(m) ? [Cu, $p([["(", je(m, { shouldBreak: !0 }), ", ", ...h, ")"], d()])] : $p([["(", m, ", ", ...h, ")"], ["(", je(m, { shouldBreak: !0 }), ", ", ...h, ")"], d()]);
  }
  if (Kgt(i, a, t)) {
    let h = a.slice(0, -1);
    if (h.some(ts)) return d();
    let m;
    try {
      m = n(Q4(r, -1), { expandLastArg: !0 });
    } catch (v) {
      if (v instanceof _C) return d();
      throw v;
    }
    return ts(m) ? [Cu, $p([["(", ...h, je(m, { shouldBreak: !0 }), ")"], d()])] : $p([["(", ...h, m, ")"], ["(", ...h, je(m, { shouldBreak: !0 }), ")"], d()]);
  }
  let f = ["(", mt([lt, ...a]), Fn(c), lt, ")"];
  return TX(e) ? f : je(f, { shouldBreak: a.some(ts) || s });
}
function A0(e, t = !1) {
  return Cl(e) && (e.properties.length > 0 || kt(e)) || Eo(e) && (e.elements.length > 0 || kt(e)) || e.type === "TSTypeAssertion" && A0(e.expression) || iu(e) && A0(e.expression) || e.type === "FunctionExpression" || e.type === "ArrowFunctionExpression" && (!e.returnType || !e.returnType.typeAnnotation || e.returnType.typeAnnotation.type !== "TSTypeReference" || Qgt(e.body)) && (e.body.type === "BlockStatement" || e.body.type === "ArrowFunctionExpression" && A0(e.body, !0) || Cl(e.body) || Eo(e.body) || !t && (or(e.body) || e.body.type === "ConditionalExpression") || oo(e.body)) || e.type === "DoExpression" || e.type === "ModuleExpression";
}
function Kgt(e, t, n) {
  var r, i;
  let o = ur(!1, e, -1);
  if (e.length === 1) {
    let a = ur(!1, t, -1);
    if ((r = a.label) != null && r.embed && ((i = a.label) == null ? void 0 : i.hug) !== !1) return !0;
  }
  let s = ur(!1, e, -2);
  return !kt(o, qt.Leading) && !kt(o, qt.Trailing) && A0(o) && (!s || s.type !== o.type) && (e.length !== 2 || s.type !== "ArrowFunctionExpression" || !Eo(o)) && !(e.length > 1 && FQ(o, n));
}
function Jgt(e) {
  if (e.length !== 2) return !1;
  let [t, n] = e;
  return t.type === "ModuleExpression" && Zgt(n) ? !0 : !kt(t) && (t.type === "FunctionExpression" || t.type === "ArrowFunctionExpression" && t.body.type === "BlockStatement") && n.type !== "FunctionExpression" && n.type !== "ArrowFunctionExpression" && n.type !== "ConditionalExpression" && aQ(n) && !A0(n);
}
function aQ(e) {
  if (e.type === "ParenthesizedExpression") return aQ(e.expression);
  if (iu(e) || e.type === "TypeCastExpression") {
    let { typeAnnotation: t } = e;
    if (t.type === "TypeAnnotation" && (t = t.typeAnnotation), t.type === "TSArrayType" && (t = t.elementType, t.type === "TSArrayType" && (t = t.elementType)), t.type === "GenericTypeAnnotation" || t.type === "TSTypeReference") {
      let n = t.typeArguments ?? t.typeParameters;
      (n == null ? void 0 : n.params.length) === 1 && (t = n.params[0]);
    }
    return NN(t) && fl(e.expression, 1);
  }
  return Mm(e) && el(e).length > 1 ? !1 : hc(e) ? fl(e.left, 1) && fl(e.right, 1) : bX(e) || fl(e);
}
function Xgt(e) {
  return e.length === 2 ? d6(e, 0) : e.length === 3 ? e[0].type === "Identifier" && d6(e, 1) : !1;
}
function d6(e, t) {
  let n = e[t], r = e[t + 1];
  return n.type === "ArrowFunctionExpression" && jo(n).length === 0 && n.body.type === "BlockStatement" && r.type === "ArrayExpression" && !e.some((i) => kt(i));
}
function Qgt(e) {
  return e.type === "BlockStatement" && (e.body.some((t) => t.type !== "EmptyStatement") || kt(e, qt.Dangling));
}
function Zgt(e) {
  return e.type === "ObjectExpression" && e.properties.length === 1 && kc(e.properties[0]) && e.properties[0].key.type === "Identifier" && e.properties[0].key.name === "type" && us(e.properties[0].value) && e.properties[0].value.value === "module";
}
var OO = Ygt, eyt = (e) => ((e.type === "ChainExpression" || e.type === "TSNonNullExpression") && (e = e.expression), or(e) && el(e).length > 0);
function tyt(e, t, n) {
  var r;
  let i = n("object"), o = lQ(e, t, n), { node: s } = e, a = e.findAncestor((d) => !(mi(d) || d.type === "TSNonNullExpression")), u = e.findAncestor((d) => !(d.type === "ChainExpression" || d.type === "TSNonNullExpression")), c = a && (a.type === "NewExpression" || a.type === "BindExpression" || a.type === "AssignmentExpression" && a.left.type !== "Identifier") || s.computed || s.object.type === "Identifier" && s.property.type === "Identifier" && !mi(u) || (u.type === "AssignmentExpression" || u.type === "VariableDeclarator") && (eyt(s.object) || ((r = i.label) == null ? void 0 : r.memberChain));
  return Av(i.label, [i, c ? o : je(mt([lt, o]))]);
}
function lQ(e, t, n) {
  let r = n("property"), { node: i } = e, o = as(e);
  return i.computed ? !i.property || fc(i.property) ? [o, "[", r, "]"] : je([o, "[", mt([lt, r]), lt, "]"]) : [o, ".", r];
}
function uQ(e, t, n) {
  if (e.node.type === "ChainExpression") return e.call(() => uQ(e, t, n), "expression");
  let { parent: r } = e, i = !r || r.type === "ExpressionStatement", o = [];
  function s(j) {
    let { originalText: U } = t, G = wv(U, Zn(j));
    return U.charAt(G) === ")" ? G !== !1 && IN(U, G + 1) : Pc(j, t);
  }
  function a(j) {
    let { node: U } = j;
    if (U.type === "ChainExpression") return j.call(() => a(j), "expression");
    if (or(U) && (Ih(U.callee) || or(U.callee))) {
      let G = s(U);
      o.unshift({ node: U, hasTrailingEmptyLine: G, printed: [yl(j, [as(j), lf(j, t, n), OO(j, t, n)], t), G ? ft : ""] }), j.call((K) => a(K), "callee");
    } else Ih(U) ? (o.unshift({ node: U, needsParens: Lf(j, t), printed: yl(j, mi(U) ? lQ(j, t, n) : OQ(j, t, n), t) }), j.call((G) => a(G), "object")) : U.type === "TSNonNullExpression" ? (o.unshift({ node: U, printed: yl(j, "!", t) }), j.call((G) => a(G), "expression")) : o.unshift({ node: U, printed: n() });
  }
  let { node: u } = e;
  o.unshift({ node: u, printed: [as(e), lf(e, t, n), OO(e, t, n)] }), u.callee && e.call((j) => a(j), "callee");
  let c = [], d = [o[0]], f = 1;
  for (; f < o.length && (o[f].node.type === "TSNonNullExpression" || or(o[f].node) || mi(o[f].node) && o[f].node.computed && fc(o[f].node.property)); ++f) d.push(o[f]);
  if (!or(o[0].node)) for (; f + 1 < o.length && Ih(o[f].node) && Ih(o[f + 1].node); ++f) d.push(o[f]);
  c.push(d), d = [];
  let h = !1;
  for (; f < o.length; ++f) {
    if (h && Ih(o[f].node)) {
      if (o[f].node.computed && fc(o[f].node.property)) {
        d.push(o[f]);
        continue;
      }
      c.push(d), d = [], h = !1;
    }
    (or(o[f].node) || o[f].node.type === "ImportExpression") && (h = !0), d.push(o[f]), kt(o[f].node, qt.Trailing) && (c.push(d), d = [], h = !1);
  }
  d.length > 0 && c.push(d);
  function m(j) {
    return /^[A-Z]|^[$_]+$/u.test(j);
  }
  function v(j) {
    return j.length <= t.tabWidth;
  }
  function x(j) {
    var U;
    let G = (U = j[1][0]) == null ? void 0 : U.node.computed;
    if (j[0].length === 1) {
      let ee = j[0][0].node;
      return ee.type === "ThisExpression" || ee.type === "Identifier" && (m(ee.name) || i && v(ee.name) || G);
    }
    let K = ur(!1, j[0], -1).node;
    return mi(K) && K.property.type === "Identifier" && (m(K.property.name) || G);
  }
  let C = c.length >= 2 && !kt(c[1][0].node) && x(c);
  function E(j) {
    let U = j.map((G) => G.printed);
    return j.length > 0 && ur(!1, j, -1).needsParens ? ["(", ...U, ")"] : U;
  }
  function S(j) {
    return j.length === 0 ? "" : mt([ft, Xn(ft, j.map(E))]);
  }
  let w = c.map(E), O = w, A = C ? 3 : 2, I = c.flat(), $ = I.slice(1, -1).some((j) => kt(j.node, qt.Leading)) || I.slice(0, -1).some((j) => kt(j.node, qt.Trailing)) || c[A] && kt(c[A][0].node, qt.Leading);
  if (c.length <= A && !$ && !c.some((j) => ur(!1, j, -1).hasTrailingEmptyLine)) return TX(e) ? O : je(O);
  let L = ur(!1, c[C ? 1 : 0], -1).node, B = !or(L) && s(L), H = [E(c[0]), C ? c.slice(1, 2).map(E) : "", B ? ft : "", S(c.slice(C ? 2 : 1))], q = o.map(({ node: j }) => j).filter(or);
  function J() {
    let j = ur(!1, ur(!1, c, -1), -1).node, U = ur(!1, w, -1);
    return or(j) && ts(U) && q.slice(0, -1).some((G) => G.arguments.some(hb));
  }
  let X;
  return $ || q.length > 2 && q.some((j) => !j.arguments.every((U) => fl(U))) || w.slice(0, -1).some(ts) || J() ? X = je(H) : X = [ts(O) || B ? Cu : "", $p([O, H])], Av({ memberChain: !0 }, X);
}
var nyt = uQ;
function cQ(e, t, n) {
  var r;
  let { node: i } = e, o = i.type === "NewExpression", s = i.type === "ImportExpression", a = as(e), u = el(i), c = u.length === 1 && CX(u[0], t.originalText);
  if (c || ryt(e) || IT(i, e.parent)) {
    let f = [];
    if (MC(e, () => {
      f.push(n());
    }), !(c && (r = f[0].label) != null && r.embed)) return [o ? "new " : "", p6(e, n), a, lf(e, t, n), "(", Xn(", ", f), ")"];
  }
  if (!s && !o && Ih(i.callee) && !e.call((f) => Lf(f, t), "callee", ...i.callee.type === "ChainExpression" ? ["expression"] : [])) return nyt(e, t, n);
  let d = [o ? "new " : "", p6(e, n), a, lf(e, t, n), OO(e, t, n)];
  return s || or(i.callee) ? je(d) : d;
}
function p6(e, t) {
  let { node: n } = e;
  return n.type === "ImportExpression" ? `import${n.phase ? `.${n.phase}` : ""}` : t("callee");
}
function ryt(e) {
  let { node: t } = e;
  if (t.type !== "CallExpression" || t.optional || t.callee.type !== "Identifier") return !1;
  let n = el(t);
  return t.callee.name === "require" ? n.length === 1 && us(n[0]) || n.length > 1 : t.callee.name === "define" && e.parent.type === "ExpressionStatement" ? n.length === 1 || n.length === 2 && n[0].type === "ArrayExpression" || n.length === 3 && us(n[0]) && n[1].type === "ArrayExpression" : !1;
}
function Pv(e, t, n, r, i, o) {
  let s = syt(e, t, n, r, o), a = o ? n(o, { assignmentLayout: s }) : "";
  switch (s) {
    case "break-after-operator":
      return je([je(r), i, je(mt([Wt, a]))]);
    case "never-break-after-operator":
      return je([je(r), i, " ", a]);
    case "fluid": {
      let u = Symbol("assignment");
      return je([je(r), i, je(mt(Wt), { id: u }), mc, $T(a, { groupId: u })]);
    }
    case "break-lhs":
      return je([r, i, " ", je(a)]);
    case "chain":
      return [je(r), i, Wt, a];
    case "chain-tail":
      return [je(r), i, mt([Wt, a])];
    case "chain-tail-arrow-chain":
      return [je(r), i, a];
    case "only-left":
      return r;
  }
}
function iyt(e, t, n) {
  let { node: r } = e;
  return Pv(e, t, n, n("left"), [" ", r.operator], "right");
}
function oyt(e, t, n) {
  return Pv(e, t, n, n("id"), " =", "init");
}
function syt(e, t, n, r, i) {
  let { node: o } = e, s = o[i];
  if (!s) return "only-left";
  let a = !vD(s);
  if (e.match(vD, dQ, (d) => !a || d.type !== "ExpressionStatement" && d.type !== "VariableDeclaration")) return a ? s.type === "ArrowFunctionExpression" && s.body.type === "ArrowFunctionExpression" ? "chain-tail-arrow-chain" : "chain-tail" : "chain";
  if (!a && vD(s.right) || of(t.originalText, s)) return "break-after-operator";
  if (o.type === "ImportAttribute" || s.type === "CallExpression" && s.callee.name === "require" || t.parser === "json5" || t.parser === "jsonc" || t.parser === "json") return "never-break-after-operator";
  let u = vht(r);
  if (lyt(o) || pyt(o) || pQ(o) && u) return "break-lhs";
  let c = hyt(o, r, t);
  return e.call(() => ayt(e, t, n, c), i) ? "break-after-operator" : uyt(o) ? "break-lhs" : !u && (c || s.type === "TemplateLiteral" || s.type === "TaggedTemplateExpression" || s.type === "BooleanLiteral" || fc(s) || s.type === "ClassExpression") ? "never-break-after-operator" : "fluid";
}
function ayt(e, t, n, r) {
  let i = e.node;
  if (hc(i) && !yb(i)) return !0;
  switch (i.type) {
    case "StringLiteralTypeAnnotation":
    case "SequenceExpression":
      return !0;
    case "TSConditionalType":
    case "ConditionalTypeAnnotation":
      if (!t.experimentalTernaries && !yyt(i)) break;
      return !0;
    case "ConditionalExpression": {
      if (!t.experimentalTernaries) {
        let { test: c } = i;
        return hc(c) && !yb(c);
      }
      let { consequent: a, alternate: u } = i;
      return a.type === "ConditionalExpression" || u.type === "ConditionalExpression";
    }
    case "ClassExpression":
      return dr(i.decorators);
  }
  if (r) return !1;
  let o = i, s = [];
  for (; ; ) if (o.type === "UnaryExpression" || o.type === "AwaitExpression" || o.type === "YieldExpression" && o.argument !== null) o = o.argument, s.push("argument");
  else if (o.type === "TSNonNullExpression") o = o.expression, s.push("expression");
  else break;
  return !!(us(o) || e.call(() => fQ(e, t, n), ...s));
}
function lyt(e) {
  if (dQ(e)) {
    let t = e.left || e.id;
    return t.type === "ObjectPattern" && t.properties.length > 2 && t.properties.some((n) => {
      var r;
      return kc(n) && (!n.shorthand || ((r = n.value) == null ? void 0 : r.type) === "AssignmentPattern");
    });
  }
  return !1;
}
function vD(e) {
  return e.type === "AssignmentExpression";
}
function dQ(e) {
  return vD(e) || e.type === "VariableDeclarator";
}
function uyt(e) {
  let t = dyt(e);
  if (dr(t)) {
    let n = e.type === "TSTypeAliasDeclaration" ? "constraint" : "bound";
    if (t.length > 1 && t.some((r) => r[n] || r.default)) return !0;
  }
  return !1;
}
var cyt = Ir(["TSTypeAliasDeclaration", "TypeAlias"]);
function dyt(e) {
  var t;
  if (cyt(e)) return (t = e.typeParameters) == null ? void 0 : t.params;
}
function pyt(e) {
  if (e.type !== "VariableDeclarator") return !1;
  let { typeAnnotation: t } = e.id;
  if (!t || !t.typeAnnotation) return !1;
  let n = f6(t.typeAnnotation);
  return dr(n) && n.length > 1 && n.some((r) => dr(f6(r)) || r.type === "TSConditionalType");
}
function pQ(e) {
  var t;
  return e.type === "VariableDeclarator" && ((t = e.init) == null ? void 0 : t.type) === "ArrowFunctionExpression";
}
var fyt = Ir(["TSTypeReference", "GenericTypeAnnotation"]);
function f6(e) {
  var t;
  if (fyt(e)) return (t = e.typeArguments ?? e.typeParameters) == null ? void 0 : t.params;
}
function fQ(e, t, n, r = !1) {
  var i;
  let { node: o } = e, s = () => fQ(e, t, n, !0);
  if (o.type === "ChainExpression" || o.type === "TSNonNullExpression") return e.call(s, "expression");
  if (or(o)) {
    if ((i = cQ(e, t, n).label) != null && i.memberChain) return !1;
    let a = el(o);
    return !(a.length === 0 || a.length === 1 && MN(a[0], t)) || myt(o, n) ? !1 : e.call(s, "callee");
  }
  return mi(o) ? e.call(s, "object") : r && (o.type === "Identifier" || o.type === "ThisExpression");
}
function hyt(e, t, n) {
  return kc(e) ? (t = LN(t), typeof t == "string" && Im(t) < n.tabWidth + 3) : !1;
}
function myt(e, t) {
  let n = gyt(e);
  if (dr(n)) {
    if (n.length > 1) return !0;
    if (n.length === 1) {
      let i = n[0];
      if (sf(i) || AX(i) || i.type === "TSTypeLiteral" || i.type === "ObjectTypeAnnotation") return !0;
    }
    let r = e.typeParameters ? "typeParameters" : "typeArguments";
    if (ts(t(r))) return !0;
  }
  return !1;
}
function gyt(e) {
  var t;
  return (t = e.typeParameters ?? e.typeArguments) == null ? void 0 : t.params;
}
function yyt(e) {
  function t(n) {
    switch (n.type) {
      case "FunctionTypeAnnotation":
      case "GenericTypeAnnotation":
      case "TSFunctionType":
        return !!n.typeParameters;
      case "TSTypeReference":
        return !!(n.typeArguments ?? n.typeParameters);
      default:
        return !1;
    }
  }
  return t(e.checkType) || t(e.extendsType);
}
function Bf(e, t, n, r, i) {
  let o = e.node, s = jo(o), a = i ? lf(e, n, t) : "";
  if (s.length === 0) return [a, "(", Zr(e, n, { filter: (m) => El(n.originalText, Zn(m)) === ")" }), ")"];
  let { parent: u } = e, c = IT(u), d = hQ(o), f = [];
  if (tht(e, (m, v) => {
    let x = v === s.length - 1;
    x && o.rest && f.push("..."), f.push(t()), !x && (f.push(","), c || d ? f.push(" ") : Pc(s[v], n) ? f.push(ft, ft) : f.push(Wt));
  }), r && !vyt(e)) {
    if (ts(a) || ts(f)) throw new _C();
    return je([DO(a), "(", DO(f), ")"]);
  }
  let h = s.every((m) => !dr(m.decorators));
  return d && h ? [a, "(", ...f, ")"] : c ? [a, "(", ...f, ")"] : (vX(u) || Uft(u) || u.type === "TypeAlias" || u.type === "UnionTypeAnnotation" || u.type === "IntersectionTypeAnnotation" || u.type === "FunctionTypeAnnotation" && u.returnType === o) && s.length === 1 && s[0].name === null && o.this !== s[0] && s[0].typeAnnotation && o.typeParameters === null && NN(s[0].typeAnnotation) && !o.rest ? n.arrowParens === "always" || o.type === "HookTypeAnnotation" ? ["(", ...f, ")"] : f : [a, "(", mt([lt, ...f]), Fn(!eht(o) && wc(n, "all") ? "," : ""), lt, ")"];
}
function hQ(e) {
  if (!e) return !1;
  let t = jo(e);
  if (t.length !== 1) return !1;
  let [n] = t;
  return !kt(n) && (n.type === "ObjectPattern" || n.type === "ArrayPattern" || n.type === "Identifier" && n.typeAnnotation && (n.typeAnnotation.type === "TypeAnnotation" || n.typeAnnotation.type === "TSTypeAnnotation") && vd(n.typeAnnotation.typeAnnotation) || n.type === "FunctionTypeParam" && vd(n.typeAnnotation) && n !== e.rest || n.type === "AssignmentPattern" && (n.left.type === "ObjectPattern" || n.left.type === "ArrayPattern") && (n.right.type === "Identifier" || Cl(n.right) && n.right.properties.length === 0 || Eo(n.right) && n.right.elements.length === 0));
}
function byt(e) {
  let t;
  return e.returnType ? (t = e.returnType, t.typeAnnotation && (t = t.typeAnnotation)) : e.typeAnnotation && (t = e.typeAnnotation), t;
}
function Fg(e, t) {
  var n;
  let r = byt(e);
  if (!r) return !1;
  let i = (n = e.typeParameters) == null ? void 0 : n.params;
  if (i) {
    if (i.length > 1) return !1;
    if (i.length === 1) {
      let o = i[0];
      if (o.constraint || o.default) return !1;
    }
  }
  return jo(e).length === 1 && (vd(r) || ts(t));
}
function vyt(e) {
  return e.match((t) => t.type === "ArrowFunctionExpression" && t.body.type === "BlockStatement", (t, n) => {
    if (t.type === "CallExpression" && n === "arguments" && t.arguments.length === 1 && t.callee.type === "CallExpression") {
      let r = t.callee.callee;
      return r.type === "Identifier" || r.type === "MemberExpression" && !r.computed && r.object.type === "Identifier" && r.property.type === "Identifier";
    }
    return !1;
  }, (t, n) => t.type === "VariableDeclarator" && n === "init" || t.type === "ExportDefaultDeclaration" && n === "declaration" || t.type === "TSExportAssignment" && n === "expression" || t.type === "AssignmentExpression" && n === "right" && t.left.type === "MemberExpression" && t.left.object.type === "Identifier" && t.left.object.name === "module" && t.left.property.type === "Identifier" && t.left.property.name === "exports", (t) => t.type !== "VariableDeclaration" || t.kind === "const" && t.declarations.length === 1);
}
function xyt(e) {
  let t = jo(e);
  return t.length > 1 && t.some((n) => n.type === "TSParameterProperty");
}
var Dyt = Ir(["VoidTypeAnnotation", "TSVoidKeyword", "NullLiteralTypeAnnotation", "TSNullKeyword"]), Cyt = Ir(["ObjectTypeAnnotation", "TSTypeLiteral", "GenericTypeAnnotation", "TSTypeReference"]);
function Eyt(e) {
  let { types: t } = e;
  if (t.some((r) => kt(r))) return !1;
  let n = t.find((r) => Cyt(r));
  return n ? t.every((r) => r === n || Dyt(r)) : !1;
}
function mQ(e) {
  return NN(e) || vd(e) ? !0 : sf(e) ? Eyt(e) : !1;
}
function Tyt(e, t, n) {
  let r = t.semi ? ";" : "", { node: i } = e, o = [Rs(e), "opaque type ", n("id"), n("typeParameters")];
  return i.supertype && o.push(": ", n("supertype")), i.impltype && o.push(" = ", n("impltype")), o.push(r), o;
}
function gQ(e, t, n) {
  let r = t.semi ? ";" : "", { node: i } = e, o = [Rs(e)];
  o.push("type ", n("id"), n("typeParameters"));
  let s = i.type === "TSTypeAliasDeclaration" ? "typeAnnotation" : "right";
  return [Pv(e, t, n, o, " =", s), r];
}
function yQ(e, t, n) {
  let r = !1;
  return je(e.map(({ isFirst: i, previous: o, node: s, index: a }) => {
    let u = n();
    if (i) return u;
    let c = vd(s), d = vd(o);
    return d && c ? [" & ", r ? mt(u) : u] : !d && !c ? mt([" &", Wt, u]) : (a > 1 && (r = !0), [" & ", a > 1 ? mt(u) : u]);
  }, "types"));
}
function bQ(e, t, n) {
  let { node: r } = e, { parent: i } = e, o = i.type !== "TypeParameterInstantiation" && (i.type !== "TSConditionalType" || !t.experimentalTernaries) && (i.type !== "ConditionalTypeAnnotation" || !t.experimentalTernaries) && i.type !== "TSTypeParameterInstantiation" && i.type !== "GenericTypeAnnotation" && i.type !== "TSTypeReference" && i.type !== "TSTypeAssertion" && i.type !== "TupleTypeAnnotation" && i.type !== "TSTupleType" && !(i.type === "FunctionTypeParam" && !i.name && e.grandparent.this !== i) && !((i.type === "TypeAlias" || i.type === "VariableDeclarator" || i.type === "TSTypeAliasDeclaration") && of(t.originalText, r)), s = mQ(r), a = e.map((d) => {
    let f = n();
    return s || (f = Du(2, f)), yl(d, f, t);
  }, "types");
  if (s) return Xn(" | ", a);
  let u = o && !of(t.originalText, r), c = [Fn([u ? Wt : "", "| "]), Xn([Wt, "| "], a)];
  return Lf(e, t) ? je([mt(c), lt]) : (i.type === "TupleTypeAnnotation" || i.type === "TSTupleType") && i[i.type === "TupleTypeAnnotation" && i.types ? "types" : "elementTypes"].length > 1 ? je([mt([Fn(["(", lt]), c]), lt, Fn(")")]) : je(o ? mt(c) : c);
}
function Syt(e) {
  var t;
  let { node: n, parent: r } = e;
  return n.type === "FunctionTypeAnnotation" && (vX(r) || !((r.type === "ObjectTypeProperty" || r.type === "ObjectTypeInternalSlot") && !r.variance && !r.optional && PT(r, n) || r.type === "ObjectTypeCallProperty" || ((t = e.getParentNode(2)) == null ? void 0 : t.type) === "DeclareFunction"));
}
function vQ(e, t, n) {
  let { node: r } = e, i = [NT(e)];
  (r.type === "TSConstructorType" || r.type === "TSConstructSignatureDeclaration") && i.push("new ");
  let o = Bf(e, n, t, !1, !0), s = [];
  return r.type === "FunctionTypeAnnotation" ? s.push(Syt(e) ? " => " : ": ", n("returnType")) : s.push(bo(e, n, r.returnType ? "returnType" : "typeAnnotation")), Fg(r, s) && (o = je(o)), i.push(o, s), je(i);
}
function xQ(e, t, n) {
  return [n("objectType"), as(e), "[", n("indexType"), "]"];
}
function DQ(e, t, n) {
  return ["infer ", n("typeParameter")];
}
function h6(e, t, n) {
  let { node: r } = e;
  return [r.postfix ? "" : n, bo(e, t), r.postfix ? n : ""];
}
function CQ(e, t, n) {
  let { node: r } = e;
  return ["...", ...r.type === "TupleTypeSpreadElement" && r.label ? [n("label"), ": "] : [], n("typeAnnotation")];
}
function EQ(e, t, n) {
  let { node: r } = e;
  return [r.variance ? n("variance") : "", n("label"), r.optional ? "?" : "", ": ", n("elementType")];
}
var Ayt = /* @__PURE__ */ new WeakSet();
function bo(e, t, n = "typeAnnotation") {
  let { node: { [n]: r } } = e;
  if (!r) return "";
  let i = !1;
  if (r.type === "TSTypeAnnotation" || r.type === "TypeAnnotation") {
    let o = e.call(TQ, n);
    (o === "=>" || o === ":" && kt(r, qt.Leading)) && (i = !0), Ayt.add(r);
  }
  return i ? [" ", t(n)] : t(n);
}
var TQ = (e) => e.match((t) => t.type === "TSTypeAnnotation", (t, n) => (n === "returnType" || n === "typeAnnotation") && (t.type === "TSFunctionType" || t.type === "TSConstructorType")) ? "=>" : e.match((t) => t.type === "TSTypeAnnotation", (t, n) => n === "typeAnnotation" && (t.type === "TSJSDocNullableType" || t.type === "TSJSDocNonNullableType" || t.type === "TSTypePredicate")) || e.match((t) => t.type === "TypeAnnotation", (t, n) => n === "typeAnnotation" && t.type === "Identifier", (t, n) => n === "id" && t.type === "DeclareFunction") || e.match((t) => t.type === "TypeAnnotation", (t, n) => n === "typeAnnotation" && t.type === "Identifier", (t, n) => n === "id" && t.type === "DeclareHook") || e.match((t) => t.type === "TypeAnnotation", (t, n) => n === "bound" && t.type === "TypeParameter" && t.usesExtendsBound) ? "" : ":";
function SQ(e, t, n) {
  let r = TQ(e);
  return r ? [r, " ", n("typeAnnotation")] : n("typeAnnotation");
}
function AQ(e) {
  return [e("elementType"), "[]"];
}
function wQ({ node: e }, t) {
  let n = e.type === "TSTypeQuery" ? "exprName" : "argument", r = e.type === "TypeofTypeAnnotation" || e.typeArguments ? "typeArguments" : "typeParameters";
  return ["typeof ", t(n), t(r)];
}
function PQ(e, t) {
  let { node: n } = e;
  return [n.type === "TSTypePredicate" && n.asserts ? "asserts " : n.type === "TypePredicate" && n.kind ? `${n.kind} ` : "", t("parameterName"), n.typeAnnotation ? [" is ", bo(e, t)] : ""];
}
function as(e) {
  let { node: t } = e;
  return !t.optional || t.type === "Identifier" && t === e.parent.key ? "" : or(t) || mi(t) && t.computed || t.type === "OptionalIndexedAccessType" ? "?." : "?";
}
function kQ(e) {
  return e.node.definite || e.match(void 0, (t, n) => n === "id" && t.type === "VariableDeclarator" && t.definite) ? "!" : "";
}
var wyt = /* @__PURE__ */ new Set(["DeclareClass", "DeclareComponent", "DeclareFunction", "DeclareHook", "DeclareVariable", "DeclareExportDeclaration", "DeclareExportAllDeclaration", "DeclareOpaqueType", "DeclareTypeAlias", "DeclareEnum", "DeclareInterface"]);
function Rs(e) {
  let { node: t } = e;
  return t.declare || wyt.has(t.type) && e.parent.type !== "DeclareExportDeclaration" ? "declare " : "";
}
var Pyt = /* @__PURE__ */ new Set(["TSAbstractMethodDefinition", "TSAbstractPropertyDefinition", "TSAbstractAccessorProperty"]);
function NT({ node: e }) {
  return e.abstract || Pyt.has(e.type) ? "abstract " : "";
}
function lf(e, t, n) {
  let r = e.node;
  return r.typeArguments ? n("typeArguments") : r.typeParameters ? n("typeParameters") : "";
}
function OQ(e, t, n) {
  return ["::", n("callee")];
}
function Yc(e, t, n) {
  return e.type === "EmptyStatement" ? ";" : e.type === "BlockStatement" || n ? [" ", t] : mt([Wt, t]);
}
function IQ(e, t) {
  return ["...", t("argument"), bo(e, t)];
}
function LC(e) {
  return e.accessibility ? e.accessibility + " " : "";
}
function kyt(e, t, n, r) {
  let { node: i } = e, o = i.inexact ? "..." : "";
  return kt(i, qt.Dangling) ? je([n, o, Zr(e, t, { indent: !0 }), lt, r]) : [n, o, r];
}
function qN(e, t, n) {
  let { node: r } = e, i = [], o = r.type === "TupleExpression" ? "#[" : "[", s = "]", a = r.type === "TupleTypeAnnotation" && r.types ? "types" : r.type === "TSTupleType" || r.type === "TupleTypeAnnotation" ? "elementTypes" : "elements", u = r[a];
  if (u.length === 0) i.push(kyt(e, t, o, s));
  else {
    let c = ur(!1, u, -1), d = (c == null ? void 0 : c.type) !== "RestElement" && !r.inexact, f = c === null, h = Symbol("array"), m = !t.__inJestEach && u.length > 1 && u.every((C, E, S) => {
      let w = C == null ? void 0 : C.type;
      if (!Eo(C) && !Cl(C)) return !1;
      let O = S[E + 1];
      if (O && w !== O.type) return !1;
      let A = Eo(C) ? "elements" : "properties";
      return C[A] && C[A].length > 1;
    }), v = FQ(r, t), x = d ? f ? "," : wc(t) ? v ? Fn(",", "", { groupId: h }) : Fn(",") : "" : "";
    i.push(je([o, mt([lt, v ? Iyt(e, t, n, x) : [Oyt(e, t, a, r.inexact, n), x], Zr(e, t)]), lt, s], { shouldBreak: m, id: h }));
  }
  return i.push(as(e), bo(e, n)), i;
}
function FQ(e, t) {
  return Eo(e) && e.elements.length > 1 && e.elements.every((n) => n && (fc(n) || yX(n) && !kt(n.argument)) && !kt(n, qt.Trailing | qt.Line, (r) => !oa(t.originalText, ni(r), { backwards: !0 })));
}
function $Q({ node: e }, { originalText: t }) {
  let n = (i) => kN(t, ON(t, i)), r = (i) => t[i] === "," ? i : r(n(i + 1));
  return IN(t, r(Zn(e)));
}
function Oyt(e, t, n, r, i) {
  let o = [];
  return e.each(({ node: s, isLast: a }) => {
    o.push(s ? je(i()) : ""), (!a || r) && o.push([",", Wt, s && $Q(e, t) ? lt : ""]);
  }, n), r && o.push("..."), o;
}
function Iyt(e, t, n, r) {
  let i = [];
  return e.each(({ isLast: o, next: s }) => {
    i.push([n(), o ? r : ","]), o || i.push($Q(e, t) ? [ft, ft] : kt(s, qt.Leading | qt.Line) ? ft : Wt);
  }, "elements"), _N(i);
}
var NQ = new Proxy(() => {
}, { get: () => NQ }), MQ = NQ, Fyt = /^[\$A-Z_a-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC][\$0-9A-Z_a-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0300-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u0483-\u0487\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u05D0-\u05EA\u05F0-\u05F2\u0610-\u061A\u0620-\u0669\u066E-\u06D3\u06D5-\u06DC\u06DF-\u06E8\u06EA-\u06FC\u06FF\u0710-\u074A\u074D-\u07B1\u07C0-\u07F5\u07FA\u0800-\u082D\u0840-\u085B\u08A0-\u08B4\u08B6-\u08BD\u08D4-\u08E1\u08E3-\u0963\u0966-\u096F\u0971-\u0983\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BC-\u09C4\u09C7\u09C8\u09CB-\u09CE\u09D7\u09DC\u09DD\u09DF-\u09E3\u09E6-\u09F1\u0A01-\u0A03\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A59-\u0A5C\u0A5E\u0A66-\u0A75\u0A81-\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABC-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AD0\u0AE0-\u0AE3\u0AE6-\u0AEF\u0AF9\u0B01-\u0B03\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3C-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B5C\u0B5D\u0B5F-\u0B63\u0B66-\u0B6F\u0B71\u0B82\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD0\u0BD7\u0BE6-\u0BEF\u0C00-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C58-\u0C5A\u0C60-\u0C63\u0C66-\u0C6F\u0C80-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBC-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CDE\u0CE0-\u0CE3\u0CE6-\u0CEF\u0CF1\u0CF2\u0D01-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D-\u0D44\u0D46-\u0D48\u0D4A-\u0D4E\u0D54-\u0D57\u0D5F-\u0D63\u0D66-\u0D6F\u0D7A-\u0D7F\u0D82\u0D83\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2\u0DF3\u0E01-\u0E3A\u0E40-\u0E4E\u0E50-\u0E59\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB9\u0EBB-\u0EBD\u0EC0-\u0EC4\u0EC6\u0EC8-\u0ECD\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E-\u0F47\u0F49-\u0F6C\u0F71-\u0F84\u0F86-\u0F97\u0F99-\u0FBC\u0FC6\u1000-\u1049\u1050-\u109D\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u135D-\u135F\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1714\u1720-\u1734\u1740-\u1753\u1760-\u176C\u176E-\u1770\u1772\u1773\u1780-\u17D3\u17D7\u17DC\u17DD\u17E0-\u17E9\u180B-\u180D\u1810-\u1819\u1820-\u1877\u1880-\u18AA\u18B0-\u18F5\u1900-\u191E\u1920-\u192B\u1930-\u193B\u1946-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19D9\u1A00-\u1A1B\u1A20-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AA7\u1AB0-\u1ABD\u1B00-\u1B4B\u1B50-\u1B59\u1B6B-\u1B73\u1B80-\u1BF3\u1C00-\u1C37\u1C40-\u1C49\u1C4D-\u1C7D\u1C80-\u1C88\u1CD0-\u1CD2\u1CD4-\u1CF6\u1CF8\u1CF9\u1D00-\u1DF5\u1DFB-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u200C\u200D\u203F\u2040\u2054\u2071\u207F\u2090-\u209C\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D7F-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2DE0-\u2DFF\u2E2F\u3005-\u3007\u3021-\u302F\u3031-\u3035\u3038-\u303C\u3041-\u3096\u3099\u309A\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA62B\uA640-\uA66F\uA674-\uA67D\uA67F-\uA6F1\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA827\uA840-\uA873\uA880-\uA8C5\uA8D0-\uA8D9\uA8E0-\uA8F7\uA8FB\uA8FD\uA900-\uA92D\uA930-\uA953\uA960-\uA97C\uA980-\uA9C0\uA9CF-\uA9D9\uA9E0-\uA9FE\uAA00-\uAA36\uAA40-\uAA4D\uAA50-\uAA59\uAA60-\uAA76\uAA7A-\uAAC2\uAADB-\uAADD\uAAE0-\uAAEF\uAAF2-\uAAF6\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABEA\uABEC\uABED\uABF0-\uABF9\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE00-\uFE0F\uFE20-\uFE2F\uFE33\uFE34\uFE4D-\uFE4F\uFE70-\uFE74\uFE76-\uFEFC\uFF10-\uFF19\uFF21-\uFF3A\uFF3F\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]*$/, $yt = (e) => Fyt.test(e), Nyt = $yt;
function Myt(e) {
  return e.length === 1 ? e : e.toLowerCase().replace(/^([+-]?[\d.]+e)(?:\+|(-))?0*(?=\d)/u, "$1$2").replace(/^([+-]?[\d.]+)e[+-]?0+$/u, "$1").replace(/^([+-])?\./u, "$10.").replace(/(\.\d+?)0+(?=e|$)/u, "$1").replace(/\.(?=e|$)/u, "");
}
var ad = Myt, xD = /* @__PURE__ */ new WeakMap();
function RQ(e) {
  return /^(?:\d+|\d+\.\d+)$/u.test(e);
}
function m6(e, t) {
  return t.parser === "json" || t.parser === "jsonc" || !us(e.key) || Nm(qa(e.key), t).slice(1, -1) !== e.key.value ? !1 : !!(Nyt(e.key.value) && !(t.parser === "babel-ts" && e.type === "ClassProperty" || t.parser === "typescript" && e.type === "PropertyDefinition") || RQ(e.key.value) && String(Number(e.key.value)) === e.key.value && e.type !== "ImportAttribute" && (t.parser === "babel" || t.parser === "acorn" || t.parser === "espree" || t.parser === "meriyah" || t.parser === "__babel_estree"));
}
function Ryt(e, t) {
  let { key: n } = e.node;
  return (n.type === "Identifier" || fc(n) && RQ(ad(qa(n))) && String(n.value) === ad(qa(n)) && !(t.parser === "typescript" || t.parser === "babel-ts")) && (t.parser === "json" || t.parser === "jsonc" || t.quoteProps === "consistent" && xD.get(e.parent));
}
function kv(e, t, n) {
  let { node: r } = e;
  if (r.computed) return ["[", n("key"), "]"];
  let { parent: i } = e, { key: o } = r;
  if (t.quoteProps === "consistent" && !xD.has(i)) {
    let s = e.siblings.some((a) => !a.computed && us(a.key) && !m6(a, t));
    xD.set(i, s);
  }
  if (Ryt(e, t)) {
    let s = Nm(JSON.stringify(o.type === "Identifier" ? o.name : o.value.toString()), t);
    return e.call((a) => yl(a, s, t), "key");
  }
  return m6(r, t) && (t.quoteProps === "as-needed" || t.quoteProps === "consistent" && !xD.get(i)) ? e.call((s) => yl(s, /^\d/u.test(o.value) ? ad(o.value) : o.value, t), "key") : n("key");
}
function sP(e, t, n) {
  let { node: r } = e;
  return r.shorthand ? n("value") : Pv(e, t, n, kv(e, t, n), ":", "value");
}
var _yt = ({ node: e, key: t, parent: n }) => t === "value" && e.type === "FunctionExpression" && (n.type === "ObjectMethod" || n.type === "ClassMethod" || n.type === "ClassPrivateMethod" || n.type === "MethodDefinition" || n.type === "TSAbstractMethodDefinition" || n.type === "TSDeclareMethod" || n.type === "Property" && OT(n));
function _Q(e, t, n, r) {
  if (_yt(e)) return GN(e, n, t);
  let { node: i } = e, o = !1;
  if ((i.type === "FunctionDeclaration" || i.type === "FunctionExpression") && r != null && r.expandLastArg) {
    let { parent: d } = e;
    or(d) && (el(d).length > 1 || jo(i).every((f) => f.type === "Identifier" && !f.typeAnnotation)) && (o = !0);
  }
  let s = [Rs(e), i.async ? "async " : "", `function${i.generator ? "*" : ""} `, i.id ? t("id") : ""], a = Bf(e, t, n, o), u = MT(e, t), c = Fg(i, u);
  return s.push(lf(e, n, t), je([c ? je(a) : a, u]), i.body ? " " : "", t("body")), n.semi && (i.declare || !i.body) && s.push(";"), s;
}
function IO(e, t, n) {
  let { node: r } = e, { kind: i } = r, o = r.value || r, s = [];
  return !i || i === "init" || i === "method" || i === "constructor" ? o.async && s.push("async ") : (MQ.ok(i === "get" || i === "set"), s.push(i, " ")), o.generator && s.push("*"), s.push(kv(e, t, n), r.optional || r.key.optional ? "?" : "", r === o ? GN(e, t, n) : n("value")), s;
}
function GN(e, t, n) {
  let { node: r } = e, i = Bf(e, n, t), o = MT(e, n), s = xyt(r), a = Fg(r, o), u = [lf(e, t, n), je([s ? je(i, { shouldBreak: !0 }) : a ? je(i) : i, o])];
  return r.body ? u.push(" ", n("body")) : u.push(t.semi ? ";" : ""), u;
}
function Lyt(e) {
  let t = jo(e);
  return t.length === 1 && !e.typeParameters && !kt(e, qt.Dangling) && t[0].type === "Identifier" && !t[0].typeAnnotation && !kt(t[0]) && !t[0].optional && !e.predicate && !e.returnType;
}
function LQ(e, t) {
  if (t.arrowParens === "always") return !1;
  if (t.arrowParens === "avoid") {
    let { node: n } = e;
    return Lyt(n);
  }
  return !1;
}
function MT(e, t) {
  let { node: n } = e, r = [bo(e, t, "returnType")];
  return n.predicate && r.push(t("predicate")), r;
}
function BQ(e, t, n) {
  let { node: r } = e, i = t.semi ? ";" : "", o = [];
  if (r.argument) {
    let u = n("argument");
    Vyt(t, r.argument) ? u = ["(", mt([ft, u]), ft, ")"] : (hc(r.argument) || r.argument.type === "SequenceExpression" || t.experimentalTernaries && r.argument.type === "ConditionalExpression" && (r.argument.consequent.type === "ConditionalExpression" || r.argument.alternate.type === "ConditionalExpression")) && (u = je([Fn("("), mt([lt, u]), lt, Fn(")")])), o.push(" ", u);
  }
  let s = kt(r, qt.Dangling), a = i && s && kt(r, qt.Last | qt.Line);
  return a && o.push(i), s && o.push(" ", Zr(e, t)), a || o.push(i), o;
}
function Byt(e, t, n) {
  return ["return", BQ(e, t, n)];
}
function jyt(e, t, n) {
  return ["throw", BQ(e, t, n)];
}
function Vyt(e, t) {
  if (of(e.originalText, t) || kt(t, qt.Leading, (n) => Dd(e.originalText, ni(n), Zn(n))) && !oo(t)) return !0;
  if (FN(t)) {
    let n = t, r;
    for (; r = Lft(n); ) if (n = r, of(e.originalText, n)) return !0;
  }
  return !1;
}
var aP = /* @__PURE__ */ new WeakMap();
function jQ(e) {
  return aP.has(e) || aP.set(e, e.type === "ConditionalExpression" && !Qo(e, (t) => t.type === "ObjectExpression")), aP.get(e);
}
var VQ = (e) => e.type === "SequenceExpression";
function zyt(e, t, n, r = {}) {
  let i = [], o, s = [], a = !1, u = !r.expandLastArg && e.node.body.type === "ArrowFunctionExpression", c;
  (function C() {
    let { node: E } = e, S = Uyt(e, t, n, r);
    if (i.length === 0) i.push(S);
    else {
      let { leading: w, trailing: O } = tQ(e, t);
      i.push([w, S]), s.unshift(O);
    }
    u && (a || (a = E.returnType && jo(E).length > 0 || E.typeParameters || jo(E).some((w) => w.type !== "Identifier"))), !u || E.body.type !== "ArrowFunctionExpression" ? (o = n("body", r), c = E.body) : e.call(C, "body");
  })();
  let d = !of(t.originalText, c) && (VQ(c) || Wyt(c, o, t) || !a && jQ(c)), f = e.key === "callee" && Mm(e.parent), h = Symbol("arrow-chain"), m = Hyt(e, r, { signatureDocs: i, shouldBreak: a }), v, x = !1;
  return u && (f || r.assignmentLayout) && (x = !0, v = r.assignmentLayout === "chain-tail-arrow-chain" || f && !d), o = qyt(e, t, r, { bodyDoc: o, bodyComments: s, functionBody: c, shouldPutBodyOnSameLine: d }), je([je(x ? mt([lt, m]) : m, { shouldBreak: v, id: h }), " =>", u ? $T(o, { groupId: h }) : je(o), u && f ? Fn(lt, "", { groupId: h }) : ""]);
}
function Uyt(e, t, n, r) {
  let { node: i } = e, o = [];
  if (i.async && o.push("async "), LQ(e, t)) o.push(n(["params", 0]));
  else {
    let a = r.expandLastArg || r.expandFirstArg, u = MT(e, n);
    if (a) {
      if (ts(u)) throw new _C();
      u = je(DO(u));
    }
    o.push(je([Bf(e, n, t, a, !0), u]));
  }
  let s = Zr(e, t, { filter(a) {
    let u = wv(t.originalText, Zn(a));
    return u !== !1 && t.originalText.slice(u, u + 2) === "=>";
  } });
  return s && o.push(" ", s), o;
}
function Wyt(e, t, n) {
  var r, i;
  return Eo(e) || Cl(e) || e.type === "ArrowFunctionExpression" || e.type === "DoExpression" || e.type === "BlockStatement" || oo(e) || ((r = t.label) == null ? void 0 : r.hug) !== !1 && (((i = t.label) == null ? void 0 : i.embed) || CX(e, n.originalText));
}
function Hyt(e, t, { signatureDocs: n, shouldBreak: r }) {
  if (n.length === 1) return n[0];
  let { parent: i, key: o } = e;
  return o !== "callee" && Mm(i) || hc(i) ? je([n[0], " =>", mt([Wt, Xn([" =>", Wt], n.slice(1))])], { shouldBreak: r }) : o === "callee" && Mm(i) || t.assignmentLayout ? je(Xn([" =>", Wt], n), { shouldBreak: r }) : je(mt(Xn([" =>", Wt], n)), { shouldBreak: r });
}
function qyt(e, t, n, { bodyDoc: r, bodyComments: i, functionBody: o, shouldPutBodyOnSameLine: s }) {
  let { node: a, parent: u } = e, c = n.expandLastArg && wc(t, "all") ? Fn(",") : "", d = (n.expandLastArg || u.type === "JSXExpressionContainer") && !kt(a) ? lt : "";
  return s && jQ(o) ? [" ", je([Fn("", "("), mt([lt, r]), Fn("", ")"), c, d]), i] : (VQ(o) && (r = je(["(", mt([lt, r]), lt, ")"])), s ? [" ", r, i] : [mt([Wt, r, i]), c, d]);
}
var Gyt = (e, t, n) => {
  if (!(e && t == null)) {
    if (t.findLast) return t.findLast(n);
    for (let r = t.length - 1; r >= 0; r--) {
      let i = t[r];
      if (n(i, r, t)) return i;
    }
  }
}, Yyt = Gyt;
function FO(e, t, n, r) {
  let { node: i } = e, o = [], s = Yyt(!1, i[r], (a) => a.type !== "EmptyStatement");
  return e.each(({ node: a }) => {
    a.type !== "EmptyStatement" && (o.push(n()), a !== s && (o.push(ft), Pc(a, t) && o.push(ft)));
  }, r), o;
}
function zQ(e, t, n) {
  let r = Kyt(e, t, n), { node: i, parent: o } = e;
  if (i.type === "Program" && (o == null ? void 0 : o.type) !== "ModuleExpression") return r ? [r, ft] : "";
  let s = [];
  if (i.type === "StaticBlock" && s.push("static "), s.push("{"), r) s.push(mt([ft, r]), ft);
  else {
    let a = e.grandparent;
    o.type === "ArrowFunctionExpression" || o.type === "FunctionExpression" || o.type === "FunctionDeclaration" || o.type === "ComponentDeclaration" || o.type === "HookDeclaration" || o.type === "ObjectMethod" || o.type === "ClassMethod" || o.type === "ClassPrivateMethod" || o.type === "ForStatement" || o.type === "WhileStatement" || o.type === "DoWhileStatement" || o.type === "DoExpression" || o.type === "ModuleExpression" || o.type === "CatchClause" && !a.finalizer || o.type === "TSModuleDeclaration" || i.type === "StaticBlock" || s.push(ft);
  }
  return s.push("}"), s;
}
function Kyt(e, t, n) {
  let { node: r } = e, i = dr(r.directives), o = r.body.some((u) => u.type !== "EmptyStatement"), s = kt(r, qt.Dangling);
  if (!i && !o && !s) return "";
  let a = [];
  return i && (a.push(FO(e, t, n, "directives")), (o || s) && (a.push(ft), Pc(ur(!1, r.directives, -1), t) && a.push(ft))), o && a.push(FO(e, t, n, "body")), s && a.push(Zr(e, t)), a;
}
function Jyt(e) {
  let t = /* @__PURE__ */ new WeakMap();
  return function(n) {
    return t.has(n) || t.set(n, Symbol(e)), t.get(n);
  };
}
var UQ = Jyt;
function Xyt(e) {
  switch (e) {
    case null:
      return "";
    case "PlusOptional":
      return "+?";
    case "MinusOptional":
      return "-?";
    case "Optional":
      return "?";
  }
}
function Qyt(e, t, n) {
  let { node: r } = e;
  return je([r.variance ? n("variance") : "", "[", mt([n("keyTparam"), " in ", n("sourceType")]), "]", Xyt(r.optional), ": ", n("propType")]);
}
function WQ(e, t) {
  return e === "+" || e === "-" ? e + t : t;
}
function Zyt(e, t, n) {
  let { node: r } = e, i = Dd(t.originalText, ni(r), ni(r.typeParameter));
  return je(["{", mt([t.bracketSpacing ? Wt : lt, je([n("typeParameter"), r.optional ? WQ(r.optional, "?") : "", r.typeAnnotation ? ": " : "", n("typeAnnotation")]), t.semi ? Fn(";") : ""]), Zr(e, t), t.bracketSpacing ? Wt : lt, "}"], { shouldBreak: i });
}
var YN = UQ("typeParameters");
function e0t(e, t, n) {
  let { node: r } = e;
  return jo(r).length === 1 && r.type.startsWith("TS") && !r[n][0].constraint && e.parent.type === "ArrowFunctionExpression" && !(t.filepath && /\.ts$/u.test(t.filepath));
}
function w0(e, t, n, r) {
  let { node: i } = e;
  if (!i[r]) return "";
  if (!Array.isArray(i[r])) return n(r);
  let o = IT(e.grandparent), s = e.match((u) => !(u[r].length === 1 && vd(u[r][0])), void 0, (u, c) => c === "typeAnnotation", (u) => u.type === "Identifier", pQ);
  if (i[r].length === 0 || !s && (o || i[r].length === 1 && (i[r][0].type === "NullableTypeAnnotation" || mQ(i[r][0])))) return ["<", Xn(", ", e.map(n, r)), t0t(e, t), ">"];
  let a = i.type === "TSTypeParameterInstantiation" ? "" : e0t(e, t, r) ? "," : wc(t) ? Fn(",") : "";
  return je(["<", mt([lt, Xn([",", Wt], e.map(n, r))]), a, lt, ">"], { id: YN(i) });
}
function t0t(e, t) {
  let { node: n } = e;
  if (!kt(n, qt.Dangling)) return "";
  let r = !kt(n, qt.Line), i = Zr(e, t, { indent: !r });
  return r ? i : [i, ft];
}
function HQ(e, t, n) {
  let { node: r, parent: i } = e, o = [r.type === "TSTypeParameter" && r.const ? "const " : ""], s = r.type === "TSTypeParameter" ? n("name") : r.name;
  if (i.type === "TSMappedType") return i.readonly && o.push(WQ(i.readonly, "readonly"), " "), o.push("[", s), r.constraint && o.push(" in ", n("constraint")), i.nameType && o.push(" as ", e.callParent(() => n("nameType"))), o.push("]"), o;
  if (r.variance && o.push(n("variance")), r.in && o.push("in "), r.out && o.push("out "), o.push(s), r.bound && (r.usesExtendsBound && o.push(" extends "), o.push(bo(e, n, "bound"))), r.constraint) {
    let a = Symbol("constraint");
    o.push(" extends", je(mt(Wt), { id: a }), mc, $T(n("constraint"), { groupId: a }));
  }
  return r.default && o.push(" = ", n("default")), je(o);
}
var qQ = Ir(["ClassProperty", "PropertyDefinition", "ClassPrivateProperty", "ClassAccessorProperty", "AccessorProperty", "TSAbstractPropertyDefinition", "TSAbstractAccessorProperty"]);
function GQ(e, t, n) {
  let { node: r } = e, i = [Rs(e), NT(e), "class"], o = kt(r.id, qt.Trailing) || kt(r.typeParameters, qt.Trailing) || kt(r.superClass) || dr(r.extends) || dr(r.mixins) || dr(r.implements), s = [], a = [];
  if (r.id && s.push(" ", n("id")), s.push(n("typeParameters")), r.superClass) {
    let u = [r0t(e, t, n), n(r.superTypeArguments ? "superTypeArguments" : "superTypeParameters")], c = e.call((d) => ["extends ", yl(d, u, t)], "superClass");
    o ? a.push(Wt, je(c)) : a.push(" ", c);
  } else a.push(lP(e, t, n, "extends"));
  if (a.push(lP(e, t, n, "mixins"), lP(e, t, n, "implements")), o) {
    let u;
    JQ(r) ? u = [...s, mt(a)] : u = mt([...s, a]), i.push(je(u, { id: YQ(r) }));
  } else i.push(...s, ...a);
  return i.push(" ", n("body")), i;
}
var YQ = UQ("heritageGroup");
function KQ(e) {
  return Fn(ft, "", { groupId: YQ(e) });
}
function n0t(e) {
  return ["extends", "mixins", "implements"].reduce((t, n) => t + (Array.isArray(e[n]) ? e[n].length : 0), e.superClass ? 1 : 0) > 1;
}
function JQ(e) {
  return e.typeParameters && !kt(e.typeParameters, qt.Trailing | qt.Line) && !n0t(e);
}
function lP(e, t, n, r) {
  let { node: i } = e;
  if (!dr(i[r])) return "";
  let o = Zr(e, t, { marker: r });
  return [JQ(i) ? Fn(" ", Wt, { groupId: YN(i.typeParameters) }) : Wt, o, o && ft, r, je(mt([Wt, Xn([",", Wt], e.map(n, r))]))];
}
function r0t(e, t, n) {
  let r = n("superClass"), { parent: i } = e;
  return i.type === "AssignmentExpression" ? je(Fn(["(", mt([lt, r]), lt, ")"], r)) : r;
}
function XQ(e, t, n) {
  let { node: r } = e, i = [];
  return dr(r.decorators) && i.push(iQ(e, t, n)), i.push(LC(r)), r.static && i.push("static "), i.push(NT(e)), r.override && i.push("override "), i.push(IO(e, t, n)), i;
}
function QQ(e, t, n) {
  let { node: r } = e, i = [], o = t.semi ? ";" : "";
  dr(r.decorators) && i.push(iQ(e, t, n)), i.push(LC(r), Rs(e)), r.static && i.push("static "), i.push(NT(e)), r.override && i.push("override "), r.readonly && i.push("readonly "), r.variance && i.push(n("variance")), (r.type === "ClassAccessorProperty" || r.type === "AccessorProperty" || r.type === "TSAbstractAccessorProperty") && i.push("accessor "), i.push(kv(e, t, n), as(e), kQ(e), bo(e, n));
  let s = r.type === "TSAbstractPropertyDefinition" || r.type === "TSAbstractAccessorProperty";
  return [Pv(e, t, n, i, " =", s ? void 0 : "value"), o];
}
function i0t(e, t, n) {
  let { node: r } = e, i = [];
  return e.each(({ node: o, next: s, isLast: a }) => {
    i.push(n()), !t.semi && qQ(o) && o0t(o, s) && i.push(";"), a || (i.push(ft), Pc(o, t) && i.push(ft));
  }, "body"), kt(r, qt.Dangling) && i.push(Zr(e, t)), [dr(r.body) ? KQ(e.parent) : "", "{", i.length > 0 ? [mt([ft, i]), ft] : "", "}"];
}
function o0t(e, t) {
  var n;
  let { type: r, name: i } = e.key;
  if (!e.computed && r === "Identifier" && (i === "static" || i === "get" || i === "set") && !e.value && !e.typeAnnotation) return !0;
  if (!t || t.static || t.accessibility || t.readonly) return !1;
  if (!t.computed) {
    let o = (n = t.key) == null ? void 0 : n.name;
    if (o === "in" || o === "instanceof") return !0;
  }
  if (qQ(t) && t.variance && !t.static && !t.declare) return !0;
  switch (t.type) {
    case "ClassProperty":
    case "PropertyDefinition":
    case "TSAbstractPropertyDefinition":
      return t.computed;
    case "MethodDefinition":
    case "TSAbstractMethodDefinition":
    case "ClassMethod":
    case "ClassPrivateMethod": {
      if ((t.value ? t.value.async : t.async) || t.kind === "get" || t.kind === "set") return !1;
      let o = t.value ? t.value.generator : t.generator;
      return !!(t.computed || o);
    }
    case "TSIndexSignature":
      return !0;
  }
  return !1;
}
function s0t(e, t) {
  if (t.semi || eZ(e, t) || nZ(e, t)) return !1;
  let { node: n, key: r, parent: i } = e;
  return !!(n.type === "ExpressionStatement" && (r === "body" && (i.type === "Program" || i.type === "BlockStatement" || i.type === "StaticBlock" || i.type === "TSModuleBlock") || r === "consequent" && i.type === "SwitchCase") && e.call(() => ZQ(e, t), "expression"));
}
function ZQ(e, t) {
  let { node: n } = e;
  switch (n.type) {
    case "ParenthesizedExpression":
    case "TypeCastExpression":
    case "ArrayExpression":
    case "ArrayPattern":
    case "TemplateLiteral":
    case "TemplateElement":
    case "RegExpLiteral":
      return !0;
    case "ArrowFunctionExpression":
      if (!LQ(e, t)) return !0;
      break;
    case "UnaryExpression": {
      let { prefix: r, operator: i } = n;
      if (r && (i === "+" || i === "-")) return !0;
      break;
    }
    case "BindExpression":
      if (!n.object) return !0;
      break;
    case "Literal":
      if (n.regex) return !0;
      break;
    default:
      if (oo(n)) return !0;
  }
  return Lf(e, t) ? !0 : FN(n) ? e.call(() => ZQ(e, t), ...gX(n)) : !1;
}
function eZ({ node: e, parent: t }, n) {
  return (n.parentParser === "markdown" || n.parentParser === "mdx") && e.type === "ExpressionStatement" && oo(e.expression) && t.type === "Program" && t.body.length === 1;
}
function tZ(e) {
  switch (e.type) {
    case "MemberExpression":
      switch (e.property.type) {
        case "Identifier":
        case "NumericLiteral":
        case "StringLiteral":
          return tZ(e.object);
      }
      return !1;
    case "Identifier":
      return !0;
    default:
      return !1;
  }
}
function nZ({ node: e, parent: t }, n) {
  return (n.parser === "__vue_event_binding" || n.parser === "__vue_ts_event_binding") && e.type === "ExpressionStatement" && t.type === "Program" && t.body.length === 1;
}
function a0t(e, t, n) {
  let r = [n("expression")];
  return nZ(e, t) ? tZ(e.node.expression) && r.push(";") : eZ(e, t) || t.semi && r.push(";"), r;
}
function l0t(e, t, n) {
  if (t.__isVueBindings || t.__isVueForBindingLeft) {
    let r = e.map(n, "program", "body", 0, "params");
    if (r.length === 1) return r[0];
    let i = Xn([",", Wt], r);
    return t.__isVueForBindingLeft ? ["(", mt([lt, je(i)]), lt, ")"] : i;
  }
  if (t.__isEmbeddedTypescriptGenericParameters) {
    let r = e.map(n, "program", "body", 0, "typeParameters", "params");
    return Xn([",", Wt], r);
  }
}
function u0t(e, t) {
  let { node: n } = e;
  switch (n.type) {
    case "RegExpLiteral":
      return g6(n);
    case "BigIntLiteral":
      return $O(n.extra.raw);
    case "NumericLiteral":
      return ad(n.extra.raw);
    case "StringLiteral":
      return af(Nm(n.extra.raw, t));
    case "NullLiteral":
      return "null";
    case "BooleanLiteral":
      return String(n.value);
    case "DecimalLiteral":
      return ad(n.value) + "m";
    case "DirectiveLiteral":
      return y6(n.extra.raw, t);
    case "Literal": {
      if (n.regex) return g6(n.regex);
      if (n.bigint) return $O(n.raw);
      if (n.decimal) return ad(n.decimal) + "m";
      let { value: r } = n;
      return typeof r == "number" ? ad(n.raw) : typeof r == "string" ? c0t(e) ? y6(n.raw, t) : af(Nm(n.raw, t)) : String(r);
    }
  }
}
function c0t(e) {
  if (e.key !== "expression") return;
  let { parent: t } = e;
  return t.type === "ExpressionStatement" && t.directive;
}
function $O(e) {
  return e.toLowerCase();
}
function g6({ pattern: e, flags: t }) {
  return t = [...t].sort().join(""), `/${e}/${t}`;
}
function y6(e, t) {
  let n = e.slice(1, -1);
  if (n.includes('"') || n.includes("'")) return e;
  let r = t.singleQuote ? "'" : '"';
  return r + n + r;
}
function d0t(e, t, n) {
  let r = e.originalText.slice(t, n);
  for (let i of e[Symbol.for("comments")]) {
    let o = ni(i);
    if (o > n) break;
    let s = Zn(i);
    if (s < t) continue;
    let a = s - o;
    r = r.slice(0, o - t) + " ".repeat(a) + r.slice(s - t);
  }
  return r;
}
var KN = d0t;
function p0t(e, t, n) {
  let { node: r } = e;
  return ["import", r.module ? " module" : "", r.phase ? ` ${r.phase}` : "", oZ(r), aZ(e, t, n), sZ(e, t, n), uZ(e, t, n), t.semi ? ";" : ""];
}
var rZ = (e) => e.type === "ExportDefaultDeclaration" || e.type === "DeclareExportDeclaration" && e.default;
function iZ(e, t, n) {
  let { node: r } = e, i = [qgt(e, t, n), Rs(e), "export", rZ(r) ? " default" : ""], { declaration: o, exported: s } = r;
  return kt(r, qt.Dangling) && (i.push(" ", Zr(e, t)), EX(r) && i.push(ft)), o ? i.push(" ", n("declaration")) : (i.push(m0t(r)), r.type === "ExportAllDeclaration" || r.type === "DeclareExportAllDeclaration" ? (i.push(" *"), s && i.push(" as ", n("exported"))) : i.push(aZ(e, t, n)), i.push(sZ(e, t, n), uZ(e, t, n))), i.push(h0t(r, t)), i;
}
var f0t = Ir(["ClassDeclaration", "ComponentDeclaration", "FunctionDeclaration", "TSInterfaceDeclaration", "DeclareClass", "DeclareComponent", "DeclareFunction", "DeclareHook", "HookDeclaration", "TSDeclareFunction", "EnumDeclaration"]);
function h0t(e, t) {
  return t.semi && (!e.declaration || rZ(e) && !f0t(e.declaration)) ? ";" : "";
}
function JN(e, t = !0) {
  return e && e !== "value" ? `${t ? " " : ""}${e}${t ? "" : " "}` : "";
}
function oZ(e, t) {
  return JN(e.importKind, t);
}
function m0t(e) {
  return JN(e.exportKind);
}
function sZ(e, t, n) {
  let { node: r } = e;
  if (!r.source) return "";
  let i = [];
  return lZ(r, t) && i.push(" from"), i.push(" ", n("source")), i;
}
function aZ(e, t, n) {
  let { node: r } = e;
  if (!lZ(r, t)) return "";
  let i = [" "];
  if (dr(r.specifiers)) {
    let o = [], s = [];
    e.each(() => {
      let a = e.node.type;
      if (a === "ExportNamespaceSpecifier" || a === "ExportDefaultSpecifier" || a === "ImportNamespaceSpecifier" || a === "ImportDefaultSpecifier") o.push(n());
      else if (a === "ExportSpecifier" || a === "ImportSpecifier") s.push(n());
      else throw new Ig(r, "specifier");
    }, "specifiers"), i.push(Xn(", ", o)), s.length > 0 && (o.length > 0 && i.push(", "), s.length > 1 || o.length > 0 || r.specifiers.some((a) => kt(a)) ? i.push(je(["{", mt([t.bracketSpacing ? Wt : lt, Xn([",", Wt], s)]), Fn(wc(t) ? "," : ""), t.bracketSpacing ? Wt : lt, "}"])) : i.push(["{", t.bracketSpacing ? " " : "", ...s, t.bracketSpacing ? " " : "", "}"]));
  } else i.push("{}");
  return i;
}
function lZ(e, t) {
  return e.type !== "ImportDeclaration" || dr(e.specifiers) || e.importKind === "type" ? !0 : KN(t, ni(e), ni(e.source)).trimEnd().endsWith("from");
}
function g0t(e, t) {
  var n, r;
  if ((n = e.extra) != null && n.deprecatedAssertSyntax) return "assert";
  let i = KN(t, Zn(e.source), (r = e.attributes) != null && r[0] ? ni(e.attributes[0]) : Zn(e)).trimStart();
  return i.startsWith("assert") ? "assert" : i.startsWith("with") || dr(e.attributes) ? "with" : void 0;
}
function uZ(e, t, n) {
  let { node: r } = e;
  if (!r.source) return "";
  let i = g0t(r, t);
  if (!i) return "";
  let o = [` ${i} {`];
  return dr(r.attributes) && (t.bracketSpacing && o.push(" "), o.push(Xn(", ", e.map(n, "attributes"))), t.bracketSpacing && o.push(" ")), o.push("}"), o;
}
function y0t(e, t, n) {
  let { node: r } = e, { type: i } = r, o = i.startsWith("Import"), s = o ? "imported" : "local", a = o ? "local" : "exported", u = r[s], c = r[a], d = "", f = "";
  return i === "ExportNamespaceSpecifier" || i === "ImportNamespaceSpecifier" ? d = "*" : u && (d = n(s)), c && !b0t(r) && (f = n(a)), [JN(i === "ImportSpecifier" ? r.importKind : r.exportKind, !1), d, d && f ? " as " : "", f];
}
function b0t(e) {
  if (e.type !== "ImportSpecifier" && e.type !== "ExportSpecifier") return !1;
  let { local: t, [e.type === "ImportSpecifier" ? "imported" : "exported"]: n } = e;
  if (t.type !== n.type || !Sft(t, n)) return !1;
  if (us(t)) return t.value === n.value && qa(t) === qa(n);
  switch (t.type) {
    case "Identifier":
      return t.name === n.name;
    default:
      return !1;
  }
}
function RT(e, t, n) {
  var r;
  let i = t.semi ? ";" : "", { node: o } = e, s = o.type === "ObjectTypeAnnotation", a = o.type === "TSEnumDeclaration" || o.type === "EnumBooleanBody" || o.type === "EnumNumberBody" || o.type === "EnumBigIntBody" || o.type === "EnumStringBody" || o.type === "EnumSymbolBody", u = [o.type === "TSTypeLiteral" || a ? "members" : o.type === "TSInterfaceBody" ? "body" : "properties"];
  s && u.push("indexers", "callProperties", "internalSlots");
  let c = u.flatMap((I) => e.map(({ node: $ }) => ({ node: $, printed: n(), loc: ni($) }), I));
  u.length > 1 && c.sort((I, $) => I.loc - $.loc);
  let { parent: d, key: f } = e, h = s && f === "body" && (d.type === "InterfaceDeclaration" || d.type === "DeclareInterface" || d.type === "DeclareClass"), m = o.type === "TSInterfaceBody" || a || h || o.type === "ObjectPattern" && d.type !== "FunctionDeclaration" && d.type !== "FunctionExpression" && d.type !== "ArrowFunctionExpression" && d.type !== "ObjectMethod" && d.type !== "ClassMethod" && d.type !== "ClassPrivateMethod" && d.type !== "AssignmentPattern" && d.type !== "CatchClause" && o.properties.some((I) => I.value && (I.value.type === "ObjectPattern" || I.value.type === "ArrayPattern")) || o.type !== "ObjectPattern" && c.length > 0 && Dd(t.originalText, ni(o), c[0].loc), v = h ? ";" : o.type === "TSInterfaceBody" || o.type === "TSTypeLiteral" ? Fn(i, ";") : ",", x = o.type === "RecordExpression" ? "#{" : o.exact ? "{|" : "{", C = o.exact ? "|}" : "}", E = [], S = c.map((I) => {
    let $ = [...E, je(I.printed)];
    return E = [v, Wt], (I.node.type === "TSPropertySignature" || I.node.type === "TSMethodSignature" || I.node.type === "TSConstructSignatureDeclaration" || I.node.type === "TSCallSignatureDeclaration") && kt(I.node, qt.PrettierIgnore) && E.shift(), Pc(I.node, t) && E.push(ft), $;
  });
  if (o.inexact || o.hasUnknownMembers) {
    let I;
    if (kt(o, qt.Dangling)) {
      let $ = kt(o, qt.Line);
      I = [Zr(e, t), $ || oa(t.originalText, Zn(ur(!1, om(o), -1))) ? ft : Wt, "..."];
    } else I = ["..."];
    S.push([...E, ...I]);
  }
  let w = (r = ur(!1, c, -1)) == null ? void 0 : r.node, O = !(o.inexact || o.hasUnknownMembers || w && (w.type === "RestElement" || (w.type === "TSPropertySignature" || w.type === "TSCallSignatureDeclaration" || w.type === "TSMethodSignature" || w.type === "TSConstructSignatureDeclaration") && kt(w, qt.PrettierIgnore))), A;
  if (S.length === 0) {
    if (!kt(o, qt.Dangling)) return [x, C, bo(e, n)];
    A = je([x, Zr(e, t, { indent: !0 }), lt, C, as(e), bo(e, n)]);
  } else A = [h && dr(o.properties) ? KQ(d) : "", x, mt([t.bracketSpacing ? Wt : lt, ...S]), Fn(O && (v !== "," || wc(t)) ? v : ""), t.bracketSpacing ? Wt : lt, C, as(e), bo(e, n)];
  return e.match((I) => I.type === "ObjectPattern" && !dr(I.decorators), uP) || vd(o) && (e.match(void 0, (I, $) => $ === "typeAnnotation", (I, $) => $ === "typeAnnotation", uP) || e.match(void 0, (I, $) => I.type === "FunctionTypeParam" && $ === "typeAnnotation", uP)) || !m && e.match((I) => I.type === "ObjectPattern", (I) => I.type === "AssignmentExpression" || I.type === "VariableDeclarator") ? A : je(A, { shouldBreak: m });
}
function uP(e, t) {
  return (t === "params" || t === "parameters" || t === "this" || t === "rest") && hQ(e);
}
function v0t(e) {
  let t = [e];
  for (let n = 0; n < t.length; n++) {
    let r = t[n];
    for (let i of ["test", "consequent", "alternate"]) {
      let o = r[i];
      if (oo(o)) return !0;
      o.type === "ConditionalExpression" && t.push(o);
    }
  }
  return !1;
}
function x0t(e, t, n) {
  let { node: r } = e, i = r.type === "ConditionalExpression", o = i ? "alternate" : "falseType", { parent: s } = e, a = i ? n("test") : [n("checkType"), " ", "extends", " ", n("extendsType")];
  return s.type === r.type && s[o] === r ? Du(2, a) : a;
}
var D0t = /* @__PURE__ */ new Map([["AssignmentExpression", "right"], ["VariableDeclarator", "init"], ["ReturnStatement", "argument"], ["ThrowStatement", "argument"], ["UnaryExpression", "argument"], ["YieldExpression", "argument"], ["AwaitExpression", "argument"]]);
function C0t(e) {
  let { node: t } = e;
  if (t.type !== "ConditionalExpression") return !1;
  let n, r = t;
  for (let i = 0; !n; i++) {
    let o = e.getParentNode(i);
    if (o.type === "ChainExpression" && o.expression === r || or(o) && o.callee === r || mi(o) && o.object === r || o.type === "TSNonNullExpression" && o.expression === r) {
      r = o;
      continue;
    }
    o.type === "NewExpression" && o.callee === r || iu(o) && o.expression === r ? (n = e.getParentNode(i + 1), r = o) : n = o;
  }
  return r === t ? !1 : n[D0t.get(n.type)] === r;
}
function E0t(e, t, n) {
  let { node: r } = e, i = r.type === "ConditionalExpression", o = i ? "consequent" : "trueType", s = i ? "alternate" : "falseType", a = i ? ["test"] : ["checkType", "extendsType"], u = r[o], c = r[s], d = [], f = !1, { parent: h } = e, m = h.type === r.type && a.some((B) => h[B] === r), v = h.type === r.type && !m, x, C, E = 0;
  do
    C = x || r, x = e.getParentNode(E), E++;
  while (x && x.type === r.type && a.every((B) => x[B] !== C));
  let S = x || h, w = C;
  if (i && (oo(r[a[0]]) || oo(u) || oo(c) || v0t(w))) {
    f = !0, v = !0;
    let B = (q) => [Fn("("), mt([lt, q]), lt, Fn(")")], H = (q) => q.type === "NullLiteral" || q.type === "Literal" && q.value === null || q.type === "Identifier" && q.name === "undefined";
    d.push(" ? ", H(u) ? n(o) : B(n(o)), " : ", c.type === r.type || H(c) ? n(s) : B(n(s)));
  } else {
    let B = (q) => t.useTabs ? mt(n(q)) : Du(2, n(q)), H = [Wt, "? ", u.type === r.type ? Fn("", "(") : "", B(o), u.type === r.type ? Fn("", ")") : "", Wt, ": ", B(s)];
    d.push(h.type !== r.type || h[s] === r || m ? H : t.useTabs ? OX(mt(H)) : Du(Math.max(0, t.tabWidth - 2), H));
  }
  let O = [o, s, ...a].some((B) => kt(r[B], (H) => Za(H) && Dd(t.originalText, ni(H), Zn(H)))), A = (B) => h === S ? je(B, { shouldBreak: O }) : O ? [B, Cu] : B, I = !f && (mi(h) || h.type === "NGPipeExpression" && h.left === r) && !h.computed, $ = C0t(e), L = A([x0t(e, t, n), v ? d : mt(d), i && I && !$ ? lt : ""]);
  return m || $ ? je([mt([lt, L]), lt]) : L;
}
function T0t(e, t) {
  return (mi(t) || t.type === "NGPipeExpression" && t.left === e) && !t.computed;
}
function S0t(e, t, n, r) {
  return [...e.map((i) => om(i)), om(t), om(n)].flat().some((i) => Za(i) && Dd(r.originalText, ni(i), Zn(i)));
}
var A0t = /* @__PURE__ */ new Map([["AssignmentExpression", "right"], ["VariableDeclarator", "init"], ["ReturnStatement", "argument"], ["ThrowStatement", "argument"], ["UnaryExpression", "argument"], ["YieldExpression", "argument"], ["AwaitExpression", "argument"]]);
function w0t(e) {
  let { node: t } = e;
  if (t.type !== "ConditionalExpression") return !1;
  let n, r = t;
  for (let i = 0; !n; i++) {
    let o = e.getParentNode(i);
    if (o.type === "ChainExpression" && o.expression === r || or(o) && o.callee === r || mi(o) && o.object === r || o.type === "TSNonNullExpression" && o.expression === r) {
      r = o;
      continue;
    }
    o.type === "NewExpression" && o.callee === r || iu(o) && o.expression === r ? (n = e.getParentNode(i + 1), r = o) : n = o;
  }
  return r === t ? !1 : n[A0t.get(n.type)] === r;
}
var cP = (e) => [Fn("("), mt([lt, e]), lt, Fn(")")];
function XN(e, t, n, r) {
  if (!t.experimentalTernaries) return E0t(e, t, n);
  let { node: i } = e, o = i.type === "ConditionalExpression", s = i.type === "TSConditionalType" || i.type === "ConditionalTypeAnnotation", a = o ? "consequent" : "trueType", u = o ? "alternate" : "falseType", c = o ? ["test"] : ["checkType", "extendsType"], d = i[a], f = i[u], h = c.map((le) => i[le]), { parent: m } = e, v = m.type === i.type, x = v && c.some((le) => m[le] === i), C = v && m[u] === i, E = d.type === i.type, S = f.type === i.type, w = S || C, O = t.tabWidth > 2 || t.useTabs, A, I, $ = 0;
  do
    I = A || i, A = e.getParentNode($), $++;
  while (A && A.type === i.type && c.every((le) => A[le] !== I));
  let L = A || m, B = r && r.assignmentLayout && r.assignmentLayout !== "break-after-operator" && (m.type === "AssignmentExpression" || m.type === "VariableDeclarator" || m.type === "ClassProperty" || m.type === "PropertyDefinition" || m.type === "ClassPrivateProperty" || m.type === "ObjectProperty" || m.type === "Property"), H = (m.type === "ReturnStatement" || m.type === "ThrowStatement") && !(E || S), q = o && L.type === "JSXExpressionContainer" && e.grandparent.type !== "JSXAttribute", J = w0t(e), X = T0t(i, m), j = s && Lf(e, t), U = O ? t.useTabs ? "	" : " ".repeat(t.tabWidth - 1) : "", G = S0t(h, d, f, t) || E || S, K = !w && !v && !s && (q ? d.type === "NullLiteral" || d.type === "Literal" && d.value === null : MN(d, t) && K4(i.test, 3)), ee = w || C || s && !v || v && o && K4(i.test, 1) || K, te = [];
  !E && kt(d, qt.Dangling) && e.call((le) => {
    te.push(Zr(le, t), ft);
  }, "consequent");
  let M = [];
  kt(i.test, qt.Dangling) && e.call((le) => {
    M.push(Zr(le, t));
  }, "test"), !S && kt(f, qt.Dangling) && e.call((le) => {
    M.push(Zr(le, t));
  }, "alternate"), kt(i, qt.Dangling) && M.push(Zr(e, t));
  let Z = Symbol("test"), ne = Symbol("consequent"), R = Symbol("test-and-consequent"), _ = o ? [cP(n("test")), i.test.type === "ConditionalExpression" ? Cu : ""] : [n("checkType"), " ", "extends", " ", i.extendsType.type === "TSConditionalType" || i.extendsType.type === "ConditionalTypeAnnotation" || i.extendsType.type === "TSMappedType" ? n("extendsType") : je(cP(n("extendsType")))], W = je([_, " ?"], { id: Z }), Q = n(a), oe = mt([E || q && (oo(d) || v || w) ? ft : Wt, te, Q]), ae = ee ? je([W, w ? oe : Fn(oe, je(oe, { id: ne }), { groupId: Z })], { id: R }) : [W, oe], pe = n(u), me = K ? Fn(pe, OX(cP(pe)), { groupId: R }) : pe, xe = [ae, M.length > 0 ? [mt([ft, M]), ft] : S ? ft : K ? Fn(Wt, " ", { groupId: R }) : Wt, ":", S ? " " : O ? ee ? Fn(U, Fn(w || K ? " " : U, " "), { groupId: R }) : Fn(U, " ") : " ", S ? me : je([mt(me), q && !K ? lt : ""]), X && !J ? lt : "", G ? Cu : ""];
  return B && !G ? je(mt([lt, je(xe)])) : B || H ? je(mt(xe)) : J || s && x ? je([mt([lt, xe]), j ? lt : ""]) : m === L ? je(xe) : xe;
}
function P0t(e, t, n, r) {
  let { node: i } = e;
  if ($N(i)) return u0t(e, t);
  let o = t.semi ? ";" : "", s = [];
  switch (i.type) {
    case "JsExpressionRoot":
      return n("node");
    case "JsonRoot":
      return [n("node"), ft];
    case "File":
      return l0t(e, t, n) ?? n("program");
    case "EmptyStatement":
      return "";
    case "ExpressionStatement":
      return a0t(e, t, n);
    case "ChainExpression":
      return n("expression");
    case "ParenthesizedExpression":
      return !kt(i.expression) && (Cl(i.expression) || Eo(i.expression)) ? ["(", n("expression"), ")"] : je(["(", mt([lt, n("expression")]), lt, ")"]);
    case "AssignmentExpression":
      return iyt(e, t, n);
    case "VariableDeclarator":
      return oyt(e, t, n);
    case "BinaryExpression":
    case "LogicalExpression":
      return rQ(e, t, n);
    case "AssignmentPattern":
      return [n("left"), " = ", n("right")];
    case "OptionalMemberExpression":
    case "MemberExpression":
      return tyt(e, t, n);
    case "MetaProperty":
      return [n("meta"), ".", n("property")];
    case "BindExpression":
      return i.object && s.push(n("object")), s.push(je(mt([lt, OQ(e, t, n)]))), s;
    case "Identifier":
      return [i.name, as(e), kQ(e), bo(e, n)];
    case "V8IntrinsicIdentifier":
      return ["%", i.name];
    case "SpreadElement":
    case "SpreadElementPattern":
    case "SpreadPropertyPattern":
    case "RestElement":
      return IQ(e, n);
    case "FunctionDeclaration":
    case "FunctionExpression":
      return _Q(e, n, t, r);
    case "ArrowFunctionExpression":
      return zyt(e, t, n, r);
    case "YieldExpression":
      return s.push("yield"), i.delegate && s.push("*"), i.argument && s.push(" ", n("argument")), s;
    case "AwaitExpression":
      if (s.push("await"), i.argument) {
        s.push(" ", n("argument"));
        let { parent: a } = e;
        if (or(a) && a.callee === i || mi(a) && a.object === i) {
          s = [mt([lt, ...s]), lt];
          let u = e.findAncestor((c) => c.type === "AwaitExpression" || c.type === "BlockStatement");
          if ((u == null ? void 0 : u.type) !== "AwaitExpression" || !Qo(u.argument, (c) => c === i)) return je(s);
        }
      }
      return s;
    case "ExportDefaultDeclaration":
    case "ExportNamedDeclaration":
    case "ExportAllDeclaration":
      return iZ(e, t, n);
    case "ImportDeclaration":
      return p0t(e, t, n);
    case "ImportSpecifier":
    case "ExportSpecifier":
    case "ImportNamespaceSpecifier":
    case "ExportNamespaceSpecifier":
    case "ImportDefaultSpecifier":
    case "ExportDefaultSpecifier":
      return y0t(e, t, n);
    case "ImportAttribute":
      return sP(e, t, n);
    case "Import":
      return "import";
    case "Program":
    case "BlockStatement":
    case "StaticBlock":
      return zQ(e, t, n);
    case "ClassBody":
      return i0t(e, t, n);
    case "ThrowStatement":
      return jyt(e, t, n);
    case "ReturnStatement":
      return Byt(e, t, n);
    case "NewExpression":
    case "ImportExpression":
    case "OptionalCallExpression":
    case "CallExpression":
      return cQ(e, t, n);
    case "ObjectExpression":
    case "ObjectPattern":
    case "RecordExpression":
      return RT(e, t, n);
    case "Property":
      return OT(i) ? IO(e, t, n) : sP(e, t, n);
    case "ObjectProperty":
      return sP(e, t, n);
    case "ObjectMethod":
      return IO(e, t, n);
    case "Decorator":
      return ["@", n("expression")];
    case "ArrayExpression":
    case "ArrayPattern":
    case "TupleExpression":
      return qN(e, t, n);
    case "SequenceExpression": {
      let { parent: a } = e;
      if (a.type === "ExpressionStatement" || a.type === "ForStatement") {
        let u = [];
        return e.each(({ isFirst: c }) => {
          c ? u.push(n()) : u.push(",", mt([Wt, n()]));
        }, "expressions"), je(u);
      }
      return je(Xn([",", Wt], e.map(n, "expressions")));
    }
    case "ThisExpression":
      return "this";
    case "Super":
      return "super";
    case "Directive":
      return [n("value"), o];
    case "UnaryExpression":
      return s.push(i.operator), /[a-z]$/u.test(i.operator) && s.push(" "), kt(i.argument) ? s.push(je(["(", mt([lt, n("argument")]), lt, ")"])) : s.push(n("argument")), s;
    case "UpdateExpression":
      return [i.prefix ? i.operator : "", n("argument"), i.prefix ? "" : i.operator];
    case "ConditionalExpression":
      return XN(e, t, n, r);
    case "VariableDeclaration": {
      let a = e.map(n, "declarations"), u = e.parent, c = u.type === "ForStatement" || u.type === "ForInStatement" || u.type === "ForOfStatement", d = i.declarations.some((h) => h.init), f;
      return a.length === 1 && !kt(i.declarations[0]) ? f = a[0] : a.length > 0 && (f = mt(a[0])), s = [Rs(e), i.kind, f ? [" ", f] : "", mt(a.slice(1).map((h) => [",", d && !c ? ft : Wt, h]))], c && u.body !== i || s.push(o), je(s);
    }
    case "WithStatement":
      return je(["with (", n("object"), ")", Yc(i.body, n("body"))]);
    case "IfStatement": {
      let a = Yc(i.consequent, n("consequent")), u = je(["if (", je([mt([lt, n("test")]), lt]), ")", a]);
      if (s.push(u), i.alternate) {
        let c = kt(i.consequent, qt.Trailing | qt.Line) || EX(i), d = i.consequent.type === "BlockStatement" && !c;
        s.push(d ? " " : ft), kt(i, qt.Dangling) && s.push(Zr(e, t), c ? ft : " "), s.push("else", je(Yc(i.alternate, n("alternate"), i.alternate.type === "IfStatement")));
      }
      return s;
    }
    case "ForStatement": {
      let a = Yc(i.body, n("body")), u = Zr(e, t), c = u ? [u, lt] : "";
      return !i.init && !i.test && !i.update ? [c, je(["for (;;)", a])] : [c, je(["for (", je([mt([lt, n("init"), ";", Wt, n("test"), ";", Wt, n("update")]), lt]), ")", a])];
    }
    case "WhileStatement":
      return je(["while (", je([mt([lt, n("test")]), lt]), ")", Yc(i.body, n("body"))]);
    case "ForInStatement":
      return je(["for (", n("left"), " in ", n("right"), ")", Yc(i.body, n("body"))]);
    case "ForOfStatement":
      return je(["for", i.await ? " await" : "", " (", n("left"), " of ", n("right"), ")", Yc(i.body, n("body"))]);
    case "DoWhileStatement": {
      let a = Yc(i.body, n("body"));
      return s = [je(["do", a])], i.body.type === "BlockStatement" ? s.push(" ") : s.push(ft), s.push("while (", je([mt([lt, n("test")]), lt]), ")", o), s;
    }
    case "DoExpression":
      return [i.async ? "async " : "", "do ", n("body")];
    case "BreakStatement":
    case "ContinueStatement":
      return s.push(i.type === "BreakStatement" ? "break" : "continue"), i.label && s.push(" ", n("label")), s.push(o), s;
    case "LabeledStatement":
      return i.body.type === "EmptyStatement" ? [n("label"), ":;"] : [n("label"), ": ", n("body")];
    case "TryStatement":
      return ["try ", n("block"), i.handler ? [" ", n("handler")] : "", i.finalizer ? [" finally ", n("finalizer")] : ""];
    case "CatchClause":
      if (i.param) {
        let a = kt(i.param, (c) => !Za(c) || c.leading && oa(t.originalText, Zn(c)) || c.trailing && oa(t.originalText, ni(c), { backwards: !0 })), u = n("param");
        return ["catch ", a ? ["(", mt([lt, u]), lt, ") "] : ["(", u, ") "], n("body")];
      }
      return ["catch ", n("body")];
    case "SwitchStatement":
      return [je(["switch (", mt([lt, n("discriminant")]), lt, ")"]), " {", i.cases.length > 0 ? mt([ft, Xn(ft, e.map(({ node: a, isLast: u }) => [n(), !u && Pc(a, t) ? ft : ""], "cases"))]) : "", ft, "}"];
    case "SwitchCase": {
      i.test ? s.push("case ", n("test"), ":") : s.push("default:"), kt(i, qt.Dangling) && s.push(" ", Zr(e, t));
      let a = i.consequent.filter((u) => u.type !== "EmptyStatement");
      if (a.length > 0) {
        let u = FO(e, t, n, "consequent");
        s.push(a.length === 1 && a[0].type === "BlockStatement" ? [" ", u] : mt([ft, u]));
      }
      return s;
    }
    case "DebuggerStatement":
      return ["debugger", o];
    case "ClassDeclaration":
    case "ClassExpression":
      return GQ(e, t, n);
    case "ClassMethod":
    case "ClassPrivateMethod":
    case "MethodDefinition":
      return XQ(e, t, n);
    case "ClassProperty":
    case "PropertyDefinition":
    case "ClassPrivateProperty":
    case "ClassAccessorProperty":
    case "AccessorProperty":
      return QQ(e, t, n);
    case "TemplateElement":
      return af(i.value.raw);
    case "TemplateLiteral":
      return GX(e, n, t);
    case "TaggedTemplateExpression":
      return hmt(e, n);
    case "PrivateIdentifier":
      return ["#", i.name];
    case "PrivateName":
      return ["#", n("id")];
    case "TopicReference":
      return "%";
    case "ArgumentPlaceholder":
      return "?";
    case "ModuleExpression":
      return ["module ", n("body")];
    case "InterpreterDirective":
    default:
      throw new Ig(i, "ESTree");
  }
}
function cZ(e, t, n) {
  let { parent: r, node: i, key: o } = e, s = [n("expression")];
  switch (i.type) {
    case "AsConstExpression":
      s.push(" as const");
      break;
    case "AsExpression":
    case "TSAsExpression":
      s.push(" as ", n("typeAnnotation"));
      break;
    case "SatisfiesExpression":
    case "TSSatisfiesExpression":
      s.push(" satisfies ", n("typeAnnotation"));
      break;
  }
  return o === "callee" && or(r) || o === "object" && mi(r) ? je([mt([lt, ...s]), lt]) : s;
}
function k0t(e, t, n) {
  let { node: r } = e, i = [Rs(e), "component"];
  r.id && i.push(" ", n("id")), i.push(n("typeParameters"));
  let o = O0t(e, n, t);
  return r.rendersType ? i.push(je([o, " ", n("rendersType")])) : i.push(je([o])), r.body && i.push(" ", n("body")), t.semi && r.type === "DeclareComponent" && i.push(";"), i;
}
function O0t(e, t, n) {
  let { node: r } = e, i = r.params;
  if (r.rest && (i = [...i, r.rest]), i.length === 0) return ["(", Zr(e, n, { filter: (s) => El(n.originalText, Zn(s)) === ")" }), ")"];
  let o = [];
  return F0t(e, (s, a) => {
    let u = a === i.length - 1;
    u && r.rest && o.push("..."), o.push(t()), !u && (o.push(","), Pc(i[a], n) ? o.push(ft, ft) : o.push(Wt));
  }), ["(", mt([lt, ...o]), Fn(wc(n, "all") && !I0t(r, i) ? "," : ""), lt, ")"];
}
function I0t(e, t) {
  var n;
  return e.rest || ((n = ur(!1, t, -1)) == null ? void 0 : n.type) === "RestElement";
}
function F0t(e, t) {
  let { node: n } = e, r = 0, i = (o) => t(o, r++);
  e.each(i, "params"), n.rest && e.call(i, "rest");
}
function $0t(e, t, n) {
  let { node: r } = e;
  return r.shorthand ? n("local") : [n("name"), " as ", n("local")];
}
function N0t(e, t, n) {
  let { node: r } = e, i = [];
  return r.name && i.push(n("name"), r.optional ? "?: " : ": "), i.push(n("typeAnnotation")), i;
}
function dZ(e, t, n) {
  return RT(e, n, t);
}
function pZ(e, t) {
  let { node: n } = e, r = t("id");
  n.computed && (r = ["[", r, "]"]);
  let i = "";
  return n.initializer && (i = t("initializer")), n.init && (i = t("init")), i ? [r, " = ", i] : r;
}
function M0t(e, t, n) {
  let { node: r } = e, i;
  if (r.type === "EnumSymbolBody" || r.explicitType) switch (r.type) {
    case "EnumBooleanBody":
      i = "boolean";
      break;
    case "EnumNumberBody":
      i = "number";
      break;
    case "EnumBigIntBody":
      i = "bigint";
      break;
    case "EnumStringBody":
      i = "string";
      break;
    case "EnumSymbolBody":
      i = "symbol";
      break;
  }
  return [i ? `of ${i} ` : "", dZ(e, t, n)];
}
function fZ(e, t, n) {
  let { node: r } = e;
  return [Rs(e), r.const ? "const " : "", "enum ", t("id"), " ", r.type === "TSEnumDeclaration" ? dZ(e, t, n) : t("body")];
}
function R0t(e, t, n) {
  let { node: r } = e, i = ["hook"];
  r.id && i.push(" ", n("id"));
  let o = Bf(e, n, t, !1, !0), s = MT(e, n), a = Fg(r, s);
  return i.push(je([a ? je(o) : o, s]), r.body ? " " : "", n("body")), i;
}
function _0t(e, t, n) {
  let { node: r } = e, i = [Rs(e), "hook"];
  return r.id && i.push(" ", n("id")), t.semi && i.push(";"), i;
}
function b6(e) {
  var t;
  let { node: n } = e;
  return n.type === "HookTypeAnnotation" && ((t = e.getParentNode(2)) == null ? void 0 : t.type) === "DeclareHook";
}
function L0t(e, t, n) {
  let { node: r } = e, i = [];
  i.push(b6(e) ? "" : "hook ");
  let o = Bf(e, n, t, !1, !0), s = [];
  return s.push(b6(e) ? ": " : " => ", n("returnType")), Fg(r, s) && (o = je(o)), i.push(o, s), je(i);
}
function hZ(e, t, n) {
  let { node: r } = e, i = [Rs(e), "interface"], o = [], s = [];
  r.type !== "InterfaceTypeAnnotation" && o.push(" ", n("id"), n("typeParameters"));
  let a = r.typeParameters && !kt(r.typeParameters, qt.Trailing | qt.Line);
  return dr(r.extends) && s.push(a ? Fn(" ", Wt, { groupId: YN(r.typeParameters) }) : Wt, "extends ", (r.extends.length === 1 ? Xft : mt)(Xn([",", Wt], e.map(n, "extends")))), kt(r.id, qt.Trailing) || dr(r.extends) ? a ? i.push(je([...o, mt(s)])) : i.push(je(mt([...o, ...s]))) : i.push(...o, ...s), i.push(" ", n("body")), je(i);
}
function B0t(e, t, n) {
  let { node: r } = e;
  if (hX(r)) return r.type.slice(0, -14).toLowerCase();
  let i = t.semi ? ";" : "";
  switch (r.type) {
    case "ComponentDeclaration":
    case "DeclareComponent":
    case "ComponentTypeAnnotation":
      return k0t(e, t, n);
    case "ComponentParameter":
      return $0t(e, t, n);
    case "ComponentTypeParameter":
      return N0t(e, t, n);
    case "HookDeclaration":
      return R0t(e, t, n);
    case "DeclareHook":
      return _0t(e, t, n);
    case "HookTypeAnnotation":
      return L0t(e, t, n);
    case "DeclareClass":
      return GQ(e, t, n);
    case "DeclareFunction":
      return [Rs(e), "function ", n("id"), n("predicate"), i];
    case "DeclareModule":
      return ["declare module ", n("id"), " ", n("body")];
    case "DeclareModuleExports":
      return ["declare module.exports", bo(e, n), i];
    case "DeclareNamespace":
      return ["declare namespace ", n("id"), " ", n("body")];
    case "DeclareVariable":
      return [Rs(e), r.kind ?? "var", " ", n("id"), i];
    case "DeclareExportDeclaration":
    case "DeclareExportAllDeclaration":
      return iZ(e, t, n);
    case "DeclareOpaqueType":
    case "OpaqueType":
      return Tyt(e, t, n);
    case "DeclareTypeAlias":
    case "TypeAlias":
      return gQ(e, t, n);
    case "IntersectionTypeAnnotation":
      return yQ(e, t, n);
    case "UnionTypeAnnotation":
      return bQ(e, t, n);
    case "ConditionalTypeAnnotation":
      return XN(e, t, n);
    case "InferTypeAnnotation":
      return DQ(e, t, n);
    case "FunctionTypeAnnotation":
      return vQ(e, t, n);
    case "TupleTypeAnnotation":
      return qN(e, t, n);
    case "TupleTypeLabeledElement":
      return EQ(e, t, n);
    case "TupleTypeSpreadElement":
      return CQ(e, t, n);
    case "GenericTypeAnnotation":
      return [n("id"), w0(e, t, n, "typeParameters")];
    case "IndexedAccessType":
    case "OptionalIndexedAccessType":
      return xQ(e, t, n);
    case "TypeAnnotation":
      return SQ(e, t, n);
    case "TypeParameter":
      return HQ(e, t, n);
    case "TypeofTypeAnnotation":
      return wQ(e, n);
    case "ExistsTypeAnnotation":
      return "*";
    case "ArrayTypeAnnotation":
      return AQ(n);
    case "DeclareEnum":
    case "EnumDeclaration":
      return fZ(e, n, t);
    case "EnumBooleanBody":
    case "EnumNumberBody":
    case "EnumBigIntBody":
    case "EnumStringBody":
    case "EnumSymbolBody":
      return M0t(e, n, t);
    case "EnumBooleanMember":
    case "EnumNumberMember":
    case "EnumBigIntMember":
    case "EnumStringMember":
    case "EnumDefaultedMember":
      return pZ(e, n);
    case "FunctionTypeParam": {
      let o = r.name ? n("name") : e.parent.this === r ? "this" : "";
      return [o, as(e), o ? ": " : "", n("typeAnnotation")];
    }
    case "DeclareInterface":
    case "InterfaceDeclaration":
    case "InterfaceTypeAnnotation":
      return hZ(e, t, n);
    case "ClassImplements":
    case "InterfaceExtends":
      return [n("id"), n("typeParameters")];
    case "NullableTypeAnnotation":
      return ["?", n("typeAnnotation")];
    case "Variance": {
      let { kind: o } = r;
      return MQ.ok(o === "plus" || o === "minus"), o === "plus" ? "+" : "-";
    }
    case "KeyofTypeAnnotation":
      return ["keyof ", n("argument")];
    case "ObjectTypeCallProperty":
      return [r.static ? "static " : "", n("value")];
    case "ObjectTypeMappedTypeProperty":
      return Qyt(e, t, n);
    case "ObjectTypeIndexer":
      return [r.static ? "static " : "", r.variance ? n("variance") : "", "[", n("id"), r.id ? ": " : "", n("key"), "]: ", n("value")];
    case "ObjectTypeProperty": {
      let o = "";
      return r.proto ? o = "proto " : r.static && (o = "static "), [o, r.kind !== "init" ? r.kind + " " : "", r.variance ? n("variance") : "", kv(e, t, n), as(e), OT(r) ? "" : ": ", n("value")];
    }
    case "ObjectTypeAnnotation":
      return RT(e, t, n);
    case "ObjectTypeInternalSlot":
      return [r.static ? "static " : "", "[[", n("id"), "]]", as(e), r.method ? "" : ": ", n("value")];
    case "ObjectTypeSpreadProperty":
      return IQ(e, n);
    case "QualifiedTypeofIdentifier":
    case "QualifiedTypeIdentifier":
      return [n("qualification"), ".", n("id")];
    case "NullLiteralTypeAnnotation":
      return "null";
    case "BooleanLiteralTypeAnnotation":
      return String(r.value);
    case "StringLiteralTypeAnnotation":
      return af(Nm(qa(r), t));
    case "NumberLiteralTypeAnnotation":
      return ad(r.raw ?? r.extra.raw);
    case "BigIntLiteralTypeAnnotation":
      return $O(r.raw ?? r.extra.raw);
    case "TypeCastExpression":
      return ["(", n("expression"), bo(e, n), ")"];
    case "TypePredicate":
      return PQ(e, n);
    case "TypeOperator":
      return [r.operator, " ", n("typeAnnotation")];
    case "TypeParameterDeclaration":
    case "TypeParameterInstantiation":
      return w0(e, t, n, "params");
    case "InferredPredicate":
    case "DeclaredPredicate":
      return [e.key === "predicate" && e.parent.type !== "DeclareFunction" && !e.parent.returnType ? ": " : " ", "%checks", ...r.type === "DeclaredPredicate" ? ["(", n("value"), ")"] : []];
    case "AsExpression":
    case "AsConstExpression":
    case "SatisfiesExpression":
      return cZ(e, t, n);
  }
}
function j0t(e, t, n) {
  var r;
  let { node: i } = e;
  if (!i.type.startsWith("TS")) return;
  if (mX(i)) return i.type.slice(2, -7).toLowerCase();
  let o = t.semi ? ";" : "", s = [];
  switch (i.type) {
    case "TSThisType":
      return "this";
    case "TSTypeAssertion": {
      let a = !(Eo(i.expression) || Cl(i.expression)), u = je(["<", mt([lt, n("typeAnnotation")]), lt, ">"]), c = [Fn("("), mt([lt, n("expression")]), lt, Fn(")")];
      return a ? $p([[u, n("expression")], [u, je(c, { shouldBreak: !0 })], [u, n("expression")]]) : je([u, n("expression")]);
    }
    case "TSDeclareFunction":
      return _Q(e, n, t);
    case "TSExportAssignment":
      return ["export = ", n("expression"), o];
    case "TSModuleBlock":
      return zQ(e, t, n);
    case "TSInterfaceBody":
    case "TSTypeLiteral":
      return RT(e, t, n);
    case "TSTypeAliasDeclaration":
      return gQ(e, t, n);
    case "TSQualifiedName":
      return [n("left"), ".", n("right")];
    case "TSAbstractMethodDefinition":
    case "TSDeclareMethod":
      return XQ(e, t, n);
    case "TSAbstractAccessorProperty":
    case "TSAbstractPropertyDefinition":
      return QQ(e, t, n);
    case "TSInterfaceHeritage":
    case "TSClassImplements":
    case "TSExpressionWithTypeArguments":
    case "TSInstantiationExpression":
      return [n("expression"), n(i.typeArguments ? "typeArguments" : "typeParameters")];
    case "TSTemplateLiteralType":
      return GX(e, n, t);
    case "TSNamedTupleMember":
      return EQ(e, t, n);
    case "TSRestType":
      return CQ(e, t, n);
    case "TSOptionalType":
      return [n("typeAnnotation"), "?"];
    case "TSInterfaceDeclaration":
      return hZ(e, t, n);
    case "TSTypeParameterDeclaration":
    case "TSTypeParameterInstantiation":
      return w0(e, t, n, "params");
    case "TSTypeParameter":
      return HQ(e, t, n);
    case "TSAsExpression":
    case "TSSatisfiesExpression":
      return cZ(e, t, n);
    case "TSArrayType":
      return AQ(n);
    case "TSPropertySignature":
      return [i.readonly ? "readonly " : "", kv(e, t, n), as(e), bo(e, n)];
    case "TSParameterProperty":
      return [LC(i), i.static ? "static " : "", i.override ? "override " : "", i.readonly ? "readonly " : "", n("parameter")];
    case "TSTypeQuery":
      return wQ(e, n);
    case "TSIndexSignature": {
      let a = i.parameters.length > 1 ? Fn(wc(t) ? "," : "") : "", u = je([mt([lt, Xn([", ", lt], e.map(n, "parameters"))]), a, lt]), c = e.parent.type === "ClassBody" && e.key === "body";
      return [c && i.static ? "static " : "", i.readonly ? "readonly " : "", "[", i.parameters ? u : "", "]", bo(e, n), c ? o : ""];
    }
    case "TSTypePredicate":
      return PQ(e, n);
    case "TSNonNullExpression":
      return [n("expression"), "!"];
    case "TSImportType":
      return [i.isTypeOf ? "typeof " : "", "import(", n("argument"), ")", i.qualifier ? [".", n("qualifier")] : "", w0(e, t, n, i.typeArguments ? "typeArguments" : "typeParameters")];
    case "TSLiteralType":
      return n("literal");
    case "TSIndexedAccessType":
      return xQ(e, t, n);
    case "TSTypeOperator":
      return [i.operator, " ", n("typeAnnotation")];
    case "TSMappedType":
      return Zyt(e, t, n);
    case "TSMethodSignature": {
      let a = i.kind && i.kind !== "method" ? `${i.kind} ` : "";
      s.push(LC(i), a, i.computed ? "[" : "", n("key"), i.computed ? "]" : "", as(e));
      let u = Bf(e, n, t, !1, !0), c = i.returnType ? "returnType" : "typeAnnotation", d = i[c], f = d ? bo(e, n, c) : "", h = Fg(i, f);
      return s.push(h ? je(u) : u), d && s.push(je(f)), je(s);
    }
    case "TSNamespaceExportDeclaration":
      return ["export as namespace ", n("id"), t.semi ? ";" : ""];
    case "TSEnumDeclaration":
      return fZ(e, n, t);
    case "TSEnumMember":
      return pZ(e, n);
    case "TSImportEqualsDeclaration":
      return [i.isExport ? "export " : "", "import ", oZ(i, !1), n("id"), " = ", n("moduleReference"), t.semi ? ";" : ""];
    case "TSExternalModuleReference":
      return ["require(", n("expression"), ")"];
    case "TSModuleDeclaration": {
      let { parent: a } = e, u = a.type === "TSModuleDeclaration", c = ((r = i.body) == null ? void 0 : r.type) === "TSModuleDeclaration";
      if (u) s.push(".");
      else if (s.push(Rs(e)), !(i.kind === "global" || i.global)) {
        let d = i.kind ?? (us(i.id) || KN(t, ni(i), ni(i.id)).trim().endsWith("module") ? "module" : "namespace");
        s.push(d, " ");
      }
      return s.push(n("id")), c ? s.push(n("body")) : i.body ? s.push(" ", je(n("body"))) : s.push(o), s;
    }
    case "TSConditionalType":
      return XN(e, t, n);
    case "TSInferType":
      return DQ(e, t, n);
    case "TSIntersectionType":
      return yQ(e, t, n);
    case "TSUnionType":
      return bQ(e, t, n);
    case "TSFunctionType":
    case "TSCallSignatureDeclaration":
    case "TSConstructorType":
    case "TSConstructSignatureDeclaration":
      return vQ(e, t, n);
    case "TSTupleType":
      return qN(e, t, n);
    case "TSTypeReference":
      return [n("typeName"), w0(e, t, n, i.typeArguments ? "typeArguments" : "typeParameters")];
    case "TSTypeAnnotation":
      return SQ(e, t, n);
    case "TSEmptyBodyFunctionExpression":
      return GN(e, t, n);
    case "TSJSDocAllType":
      return "*";
    case "TSJSDocUnknownType":
      return "?";
    case "TSJSDocNullableType":
      return h6(e, n, "?");
    case "TSJSDocNonNullableType":
      return h6(e, n, "!");
    case "TSParenthesizedType":
    default:
      throw new Ig(i, "TypeScript");
  }
}
function V0t(e, t, n, r) {
  if (nQ(e)) return sgt(e, t);
  for (let i of [Ugt, Rgt, B0t, j0t, P0t]) {
    let o = i(e, t, n, r);
    if (o !== void 0) return o;
  }
}
var z0t = Ir(["ClassMethod", "ClassPrivateMethod", "ClassProperty", "ClassAccessorProperty", "AccessorProperty", "TSAbstractAccessorProperty", "PropertyDefinition", "TSAbstractPropertyDefinition", "ClassPrivateProperty", "MethodDefinition", "TSAbstractMethodDefinition", "TSDeclareMethod"]);
function U0t(e, t, n, r) {
  var i;
  e.isRoot && ((i = t.__onHtmlBindingRoot) == null || i.call(t, e.node, t));
  let o = V0t(e, t, n, r);
  if (!o) return "";
  let { node: s } = e;
  if (z0t(s)) return o;
  let a = dr(s.decorators), u = Ggt(e, t, n), c = s.type === "ClassExpression";
  if (a && !c) return CO(o, (h) => je([u, h]));
  let d = Lf(e, t), f = s0t(e, t);
  return !u && !d && !f ? o : CO(o, (h) => [f ? ";" : "", d ? "(" : "", d && c && a ? [mt([Wt, u, h]), Wt] : [u, h], d ? ")" : ""]);
}
var W0t = U0t, H0t = { avoidAstMutation: !0 }, q0t = [{ linguistLanguageId: 174, name: "JSON.stringify", type: "data", color: "#292929", tmScope: "source.json", aceMode: "json", codemirrorMode: "javascript", codemirrorMimeType: "application/json", aliases: ["geojson", "jsonl", "topojson"], extensions: [".importmap"], filenames: ["package.json", "package-lock.json", "composer.json"], parsers: ["json-stringify"], vscodeLanguageIds: ["json"] }, { linguistLanguageId: 174, name: "JSON", type: "data", color: "#292929", tmScope: "source.json", aceMode: "json", codemirrorMode: "javascript", codemirrorMimeType: "application/json", aliases: ["geojson", "jsonl", "topojson"], extensions: [".json", ".4DForm", ".4DProject", ".avsc", ".geojson", ".gltf", ".har", ".ice", ".JSON-tmLanguage", ".mcmeta", ".tfstate", ".tfstate.backup", ".topojson", ".webapp", ".webmanifest", ".yy", ".yyp"], filenames: [".all-contributorsrc", ".arcconfig", ".auto-changelog", ".c8rc", ".htmlhintrc", ".imgbotconfig", ".nycrc", ".tern-config", ".tern-project", ".watchmanconfig", "Pipfile.lock", "composer.lock", "flake.lock", "mcmod.info", ".babelrc", ".jscsrc", ".jshintrc", ".jslintrc", ".swcrc"], parsers: ["json"], vscodeLanguageIds: ["json"] }, { linguistLanguageId: 423, name: "JSON with Comments", type: "data", color: "#292929", group: "JSON", tmScope: "source.js", aceMode: "javascript", codemirrorMode: "javascript", codemirrorMimeType: "text/javascript", aliases: ["jsonc"], extensions: [".jsonc", ".code-snippets", ".code-workspace", ".sublime-build", ".sublime-commands", ".sublime-completions", ".sublime-keymap", ".sublime-macro", ".sublime-menu", ".sublime-mousemap", ".sublime-project", ".sublime-settings", ".sublime-theme", ".sublime-workspace", ".sublime_metrics", ".sublime_session"], filenames: [], parsers: ["jsonc"], vscodeLanguageIds: ["jsonc"] }, { linguistLanguageId: 175, name: "JSON5", type: "data", color: "#267CB9", extensions: [".json5"], tmScope: "source.js", aceMode: "javascript", codemirrorMode: "javascript", codemirrorMimeType: "application/json", parsers: ["json5"], vscodeLanguageIds: ["json5"] }], mZ = {};
wT(mZ, { getVisitorKeys: () => J0t, massageAstNode: () => gZ, print: () => X0t });
var G0t = { JsonRoot: ["node"], ArrayExpression: ["elements"], ObjectExpression: ["properties"], ObjectProperty: ["key", "value"], UnaryExpression: ["argument"], NullLiteral: [], BooleanLiteral: [], StringLiteral: [], NumericLiteral: [], Identifier: [], TemplateLiteral: ["quasis"], TemplateElement: [] }, Y0t = G0t, K0t = pX(Y0t), J0t = K0t;
function X0t(e, t, n) {
  let { node: r } = e;
  switch (r.type) {
    case "JsonRoot":
      return [n("node"), ft];
    case "ArrayExpression": {
      if (r.elements.length === 0) return "[]";
      let i = e.map(() => e.node === null ? "null" : n(), "elements");
      return ["[", mt([ft, Xn([",", ft], i)]), ft, "]"];
    }
    case "ObjectExpression":
      return r.properties.length === 0 ? "{}" : ["{", mt([ft, Xn([",", ft], e.map(n, "properties"))]), ft, "}"];
    case "ObjectProperty":
      return [n("key"), ": ", n("value")];
    case "UnaryExpression":
      return [r.operator === "+" ? "" : r.operator, n("argument")];
    case "NullLiteral":
      return "null";
    case "BooleanLiteral":
      return r.value ? "true" : "false";
    case "StringLiteral":
      return JSON.stringify(r.value);
    case "NumericLiteral":
      return v6(e) ? JSON.stringify(String(r.value)) : JSON.stringify(r.value);
    case "Identifier":
      return v6(e) ? JSON.stringify(r.name) : r.name;
    case "TemplateLiteral":
      return n(["quasis", 0]);
    case "TemplateElement":
      return JSON.stringify(r.value.cooked);
    default:
      throw new Ig(r, "JSON");
  }
}
function v6(e) {
  return e.key === "key" && e.parent.type === "ObjectProperty";
}
var Q0t = /* @__PURE__ */ new Set(["start", "end", "extra", "loc", "comments", "leadingComments", "trailingComments", "innerComments", "errors", "range", "tokens"]);
function gZ(e, t) {
  let { type: n } = e;
  if (n === "ObjectProperty") {
    let { key: r } = e;
    r.type === "Identifier" ? t.key = { type: "StringLiteral", value: r.name } : r.type === "NumericLiteral" && (t.key = { type: "StringLiteral", value: String(r.value) });
    return;
  }
  if (n === "UnaryExpression" && e.operator === "+") return t.argument;
  if (n === "ArrayExpression") {
    for (let [r, i] of e.elements.entries()) i === null && t.elements.splice(r, 0, { type: "NullLiteral" });
    return;
  }
  if (n === "TemplateLiteral") return { type: "StringLiteral", value: e.quasis[0].value.cooked };
}
gZ.ignoredProperties = Q0t;
var Ix = { bracketSpacing: { category: "Common", type: "boolean", default: !0, description: "Print spaces between brackets.", oppositeDescription: "Do not print spaces between brackets." }, singleQuote: { category: "Common", type: "boolean", default: !1, description: "Use single quotes instead of double quotes." }, proseWrap: { category: "Common", type: "choice", default: "preserve", description: "How to wrap prose.", choices: [{ value: "always", description: "Wrap prose if it exceeds the print width." }, { value: "never", description: "Do not wrap prose." }, { value: "preserve", description: "Wrap prose as-is." }] }, bracketSameLine: { category: "Common", type: "boolean", default: !1, description: "Put > of opening tags on the last line instead of on a new line." }, singleAttributePerLine: { category: "Common", type: "boolean", default: !1, description: "Enforce single attribute per line in HTML, Vue and JSX." } }, fp = "JavaScript", Z0t = { arrowParens: { category: fp, type: "choice", default: "always", description: "Include parentheses around a sole arrow function parameter.", choices: [{ value: "always", description: "Always include parens. Example: `(x) => x`" }, { value: "avoid", description: "Omit parens when possible. Example: `x => x`" }] }, bracketSameLine: Ix.bracketSameLine, bracketSpacing: Ix.bracketSpacing, jsxBracketSameLine: { category: fp, type: "boolean", description: "Put > on the last line instead of at a new line.", deprecated: "2.4.0" }, semi: { category: fp, type: "boolean", default: !0, description: "Print semicolons.", oppositeDescription: "Do not print semicolons, except at the beginning of lines which may need them." }, experimentalTernaries: { category: fp, type: "boolean", default: !1, description: "Use curious ternaries, with the question mark after the condition.", oppositeDescription: "Default behavior of ternaries; keep question marks on the same line as the consequent." }, singleQuote: Ix.singleQuote, jsxSingleQuote: { category: fp, type: "boolean", default: !1, description: "Use single quotes in JSX." }, quoteProps: { category: fp, type: "choice", default: "as-needed", description: "Change when properties in objects are quoted.", choices: [{ value: "as-needed", description: "Only add quotes around object properties where required." }, { value: "consistent", description: "If at least one property in an object requires quotes, quote all properties." }, { value: "preserve", description: "Respect the input use of quotes in object properties." }] }, trailingComma: { category: fp, type: "choice", default: "all", description: "Print trailing commas wherever possible when multi-line.", choices: [{ value: "all", description: "Trailing commas wherever possible (including function arguments)." }, { value: "es5", description: "Trailing commas where valid in ES5 (objects, arrays, etc.)" }, { value: "none", description: "No trailing commas." }] }, singleAttributePerLine: Ix.singleAttributePerLine }, yZ = Z0t, bZ = { estree: cX, "estree-json": mZ }, vZ = [...Qpt, ...q0t], ebt = uX;
const tbt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ebt,
  languages: vZ,
  options: yZ,
  printers: bZ
}, Symbol.toStringTag, { value: "Module" })), nbt = Rr(/* @__PURE__ */ P.jsx("path", {
  d: "M11 18h2v-2h-2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8m0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4"
}), "HelpOutline");
var QN = { exports: {} };
QN.exports;
(function(e) {
  (function(t, n, r) {
    function i(u) {
      var c = this, d = a();
      c.next = function() {
        var f = 2091639 * c.s0 + c.c * 23283064365386963e-26;
        return c.s0 = c.s1, c.s1 = c.s2, c.s2 = f - (c.c = f | 0);
      }, c.c = 1, c.s0 = d(" "), c.s1 = d(" "), c.s2 = d(" "), c.s0 -= d(u), c.s0 < 0 && (c.s0 += 1), c.s1 -= d(u), c.s1 < 0 && (c.s1 += 1), c.s2 -= d(u), c.s2 < 0 && (c.s2 += 1), d = null;
    }
    function o(u, c) {
      return c.c = u.c, c.s0 = u.s0, c.s1 = u.s1, c.s2 = u.s2, c;
    }
    function s(u, c) {
      var d = new i(u), f = c && c.state, h = d.next;
      return h.int32 = function() {
        return d.next() * 4294967296 | 0;
      }, h.double = function() {
        return h() + (h() * 2097152 | 0) * 11102230246251565e-32;
      }, h.quick = h, f && (typeof f == "object" && o(f, d), h.state = function() {
        return o(d, {});
      }), h;
    }
    function a() {
      var u = 4022871197, c = function(d) {
        d = String(d);
        for (var f = 0; f < d.length; f++) {
          u += d.charCodeAt(f);
          var h = 0.02519603282416938 * u;
          u = h >>> 0, h -= u, h *= u, u = h >>> 0, h -= u, u += h * 4294967296;
        }
        return (u >>> 0) * 23283064365386963e-26;
      };
      return c;
    }
    n && n.exports ? n.exports = s : this.alea = s;
  })(
    Kr,
    e
  );
})(QN);
var rbt = QN.exports, ZN = { exports: {} };
ZN.exports;
(function(e) {
  (function(t, n, r) {
    function i(a) {
      var u = this, c = "";
      u.x = 0, u.y = 0, u.z = 0, u.w = 0, u.next = function() {
        var f = u.x ^ u.x << 11;
        return u.x = u.y, u.y = u.z, u.z = u.w, u.w ^= u.w >>> 19 ^ f ^ f >>> 8;
      }, a === (a | 0) ? u.x = a : c += a;
      for (var d = 0; d < c.length + 64; d++)
        u.x ^= c.charCodeAt(d) | 0, u.next();
    }
    function o(a, u) {
      return u.x = a.x, u.y = a.y, u.z = a.z, u.w = a.w, u;
    }
    function s(a, u) {
      var c = new i(a), d = u && u.state, f = function() {
        return (c.next() >>> 0) / 4294967296;
      };
      return f.double = function() {
        do
          var h = c.next() >>> 11, m = (c.next() >>> 0) / 4294967296, v = (h + m) / (1 << 21);
        while (v === 0);
        return v;
      }, f.int32 = c.next, f.quick = f, d && (typeof d == "object" && o(d, c), f.state = function() {
        return o(c, {});
      }), f;
    }
    n && n.exports ? n.exports = s : this.xor128 = s;
  })(
    Kr,
    e
  );
})(ZN);
var ibt = ZN.exports, eM = { exports: {} };
eM.exports;
(function(e) {
  (function(t, n, r) {
    function i(a) {
      var u = this, c = "";
      u.next = function() {
        var f = u.x ^ u.x >>> 2;
        return u.x = u.y, u.y = u.z, u.z = u.w, u.w = u.v, (u.d = u.d + 362437 | 0) + (u.v = u.v ^ u.v << 4 ^ (f ^ f << 1)) | 0;
      }, u.x = 0, u.y = 0, u.z = 0, u.w = 0, u.v = 0, a === (a | 0) ? u.x = a : c += a;
      for (var d = 0; d < c.length + 64; d++)
        u.x ^= c.charCodeAt(d) | 0, d == c.length && (u.d = u.x << 10 ^ u.x >>> 4), u.next();
    }
    function o(a, u) {
      return u.x = a.x, u.y = a.y, u.z = a.z, u.w = a.w, u.v = a.v, u.d = a.d, u;
    }
    function s(a, u) {
      var c = new i(a), d = u && u.state, f = function() {
        return (c.next() >>> 0) / 4294967296;
      };
      return f.double = function() {
        do
          var h = c.next() >>> 11, m = (c.next() >>> 0) / 4294967296, v = (h + m) / (1 << 21);
        while (v === 0);
        return v;
      }, f.int32 = c.next, f.quick = f, d && (typeof d == "object" && o(d, c), f.state = function() {
        return o(c, {});
      }), f;
    }
    n && n.exports ? n.exports = s : this.xorwow = s;
  })(
    Kr,
    e
  );
})(eM);
var obt = eM.exports, tM = { exports: {} };
tM.exports;
(function(e) {
  (function(t, n, r) {
    function i(a) {
      var u = this;
      u.next = function() {
        var d = u.x, f = u.i, h, m;
        return h = d[f], h ^= h >>> 7, m = h ^ h << 24, h = d[f + 1 & 7], m ^= h ^ h >>> 10, h = d[f + 3 & 7], m ^= h ^ h >>> 3, h = d[f + 4 & 7], m ^= h ^ h << 7, h = d[f + 7 & 7], h = h ^ h << 13, m ^= h ^ h << 9, d[f] = m, u.i = f + 1 & 7, m;
      };
      function c(d, f) {
        var h, m = [];
        if (f === (f | 0))
          m[0] = f;
        else
          for (f = "" + f, h = 0; h < f.length; ++h)
            m[h & 7] = m[h & 7] << 15 ^ f.charCodeAt(h) + m[h + 1 & 7] << 13;
        for (; m.length < 8; ) m.push(0);
        for (h = 0; h < 8 && m[h] === 0; ++h) ;
        for (h == 8 ? m[7] = -1 : m[h], d.x = m, d.i = 0, h = 256; h > 0; --h)
          d.next();
      }
      c(u, a);
    }
    function o(a, u) {
      return u.x = a.x.slice(), u.i = a.i, u;
    }
    function s(a, u) {
      a == null && (a = +/* @__PURE__ */ new Date());
      var c = new i(a), d = u && u.state, f = function() {
        return (c.next() >>> 0) / 4294967296;
      };
      return f.double = function() {
        do
          var h = c.next() >>> 11, m = (c.next() >>> 0) / 4294967296, v = (h + m) / (1 << 21);
        while (v === 0);
        return v;
      }, f.int32 = c.next, f.quick = f, d && (d.x && o(d, c), f.state = function() {
        return o(c, {});
      }), f;
    }
    n && n.exports ? n.exports = s : this.xorshift7 = s;
  })(
    Kr,
    e
  );
})(tM);
var sbt = tM.exports, nM = { exports: {} };
nM.exports;
(function(e) {
  (function(t, n, r) {
    function i(a) {
      var u = this;
      u.next = function() {
        var d = u.w, f = u.X, h = u.i, m, v;
        return u.w = d = d + 1640531527 | 0, v = f[h + 34 & 127], m = f[h = h + 1 & 127], v ^= v << 13, m ^= m << 17, v ^= v >>> 15, m ^= m >>> 12, v = f[h] = v ^ m, u.i = h, v + (d ^ d >>> 16) | 0;
      };
      function c(d, f) {
        var h, m, v, x, C, E = [], S = 128;
        for (f === (f | 0) ? (m = f, f = null) : (f = f + "\0", m = 0, S = Math.max(S, f.length)), v = 0, x = -32; x < S; ++x)
          f && (m ^= f.charCodeAt((x + 32) % f.length)), x === 0 && (C = m), m ^= m << 10, m ^= m >>> 15, m ^= m << 4, m ^= m >>> 13, x >= 0 && (C = C + 1640531527 | 0, h = E[x & 127] ^= m + C, v = h == 0 ? v + 1 : 0);
        for (v >= 128 && (E[(f && f.length || 0) & 127] = -1), v = 127, x = 4 * 128; x > 0; --x)
          m = E[v + 34 & 127], h = E[v = v + 1 & 127], m ^= m << 13, h ^= h << 17, m ^= m >>> 15, h ^= h >>> 12, E[v] = m ^ h;
        d.w = C, d.X = E, d.i = v;
      }
      c(u, a);
    }
    function o(a, u) {
      return u.i = a.i, u.w = a.w, u.X = a.X.slice(), u;
    }
    function s(a, u) {
      a == null && (a = +/* @__PURE__ */ new Date());
      var c = new i(a), d = u && u.state, f = function() {
        return (c.next() >>> 0) / 4294967296;
      };
      return f.double = function() {
        do
          var h = c.next() >>> 11, m = (c.next() >>> 0) / 4294967296, v = (h + m) / (1 << 21);
        while (v === 0);
        return v;
      }, f.int32 = c.next, f.quick = f, d && (d.X && o(d, c), f.state = function() {
        return o(c, {});
      }), f;
    }
    n && n.exports ? n.exports = s : this.xor4096 = s;
  })(
    Kr,
    // window object or global
    e
  );
})(nM);
var abt = nM.exports, rM = { exports: {} };
rM.exports;
(function(e) {
  (function(t, n, r) {
    function i(a) {
      var u = this, c = "";
      u.next = function() {
        var f = u.b, h = u.c, m = u.d, v = u.a;
        return f = f << 25 ^ f >>> 7 ^ h, h = h - m | 0, m = m << 24 ^ m >>> 8 ^ v, v = v - f | 0, u.b = f = f << 20 ^ f >>> 12 ^ h, u.c = h = h - m | 0, u.d = m << 16 ^ h >>> 16 ^ v, u.a = v - f | 0;
      }, u.a = 0, u.b = 0, u.c = -1640531527, u.d = 1367130551, a === Math.floor(a) ? (u.a = a / 4294967296 | 0, u.b = a | 0) : c += a;
      for (var d = 0; d < c.length + 20; d++)
        u.b ^= c.charCodeAt(d) | 0, u.next();
    }
    function o(a, u) {
      return u.a = a.a, u.b = a.b, u.c = a.c, u.d = a.d, u;
    }
    function s(a, u) {
      var c = new i(a), d = u && u.state, f = function() {
        return (c.next() >>> 0) / 4294967296;
      };
      return f.double = function() {
        do
          var h = c.next() >>> 11, m = (c.next() >>> 0) / 4294967296, v = (h + m) / (1 << 21);
        while (v === 0);
        return v;
      }, f.int32 = c.next, f.quick = f, d && (typeof d == "object" && o(d, c), f.state = function() {
        return o(c, {});
      }), f;
    }
    n && n.exports ? n.exports = s : this.tychei = s;
  })(
    Kr,
    e
  );
})(rM);
var lbt = rM.exports, xZ = { exports: {} };
const ubt = {}, cbt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ubt
}, Symbol.toStringTag, { value: "Module" })), dbt = /* @__PURE__ */ Tl(cbt);
(function(e) {
  (function(t, n, r) {
    var i = 256, o = 6, s = 52, a = "random", u = r.pow(i, o), c = r.pow(2, s), d = c * 2, f = i - 1, h;
    function m(O, A, I) {
      var $ = [];
      A = A == !0 ? { entropy: !0 } : A || {};
      var L = E(C(
        A.entropy ? [O, w(n)] : O ?? S(),
        3
      ), $), B = new v($), H = function() {
        for (var q = B.g(o), J = u, X = 0; q < c; )
          q = (q + X) * i, J *= i, X = B.g(1);
        for (; q >= d; )
          q /= 2, J /= 2, X >>>= 1;
        return (q + X) / J;
      };
      return H.int32 = function() {
        return B.g(4) | 0;
      }, H.quick = function() {
        return B.g(4) / 4294967296;
      }, H.double = H, E(w(B.S), n), (A.pass || I || function(q, J, X, j) {
        return j && (j.S && x(j, B), q.state = function() {
          return x(B, {});
        }), X ? (r[a] = q, J) : q;
      })(
        H,
        L,
        "global" in A ? A.global : this == r,
        A.state
      );
    }
    function v(O) {
      var A, I = O.length, $ = this, L = 0, B = $.i = $.j = 0, H = $.S = [];
      for (I || (O = [I++]); L < i; )
        H[L] = L++;
      for (L = 0; L < i; L++)
        H[L] = H[B = f & B + O[L % I] + (A = H[L])], H[B] = A;
      ($.g = function(q) {
        for (var J, X = 0, j = $.i, U = $.j, G = $.S; q--; )
          J = G[j = f & j + 1], X = X * i + G[f & (G[j] = G[U = f & U + J]) + (G[U] = J)];
        return $.i = j, $.j = U, X;
      })(i);
    }
    function x(O, A) {
      return A.i = O.i, A.j = O.j, A.S = O.S.slice(), A;
    }
    function C(O, A) {
      var I = [], $ = typeof O, L;
      if (A && $ == "object")
        for (L in O)
          try {
            I.push(C(O[L], A - 1));
          } catch {
          }
      return I.length ? I : $ == "string" ? O : O + "\0";
    }
    function E(O, A) {
      for (var I = O + "", $, L = 0; L < I.length; )
        A[f & L] = f & ($ ^= A[f & L] * 19) + I.charCodeAt(L++);
      return w(A);
    }
    function S() {
      try {
        var O;
        return h && (O = h.randomBytes) ? O = O(i) : (O = new Uint8Array(i), (t.crypto || t.msCrypto).getRandomValues(O)), w(O);
      } catch {
        var A = t.navigator, I = A && A.plugins;
        return [+/* @__PURE__ */ new Date(), t, I, t.screen, w(n)];
      }
    }
    function w(O) {
      return String.fromCharCode.apply(0, O);
    }
    if (E(r.random(), n), e.exports) {
      e.exports = m;
      try {
        h = dbt;
      } catch {
      }
    } else
      r["seed" + a] = m;
  })(
    // global: `self` in browsers (including strict mode and web workers),
    // otherwise `this` in Node and other environments
    typeof self < "u" ? self : Kr,
    [],
    // pool: entropy pool starts empty
    Math
    // math: package containing random, pow, and seedrandom
  );
})(xZ);
var pbt = xZ.exports, fbt = rbt, hbt = ibt, mbt = obt, gbt = sbt, ybt = abt, bbt = lbt, jf = pbt;
jf.alea = fbt;
jf.xor128 = hbt;
jf.xorwow = mbt;
jf.xorshift7 = gbt;
jf.xor4096 = ybt;
jf.tychei = bbt;
var vbt = jf;
const xbt = /* @__PURE__ */ Ln(vbt);
let Dbt = xbt();
function DZ() {
  return Dbt();
}
function jd(e, t) {
  let n = e;
  if (Array.isArray(e)) {
    let r = e;
    t != null && t.maxCharCount && typeof e[0] == "string" && (r = e.filter((i) => i.length <= t.maxCharCount)), n = () => iM(r);
  }
  return (t == null ? void 0 : t.length) === void 0 ? n(0) : Array.from({ length: t.length }, (r, i) => n(i));
}
function iM(e) {
  return e[Math.floor(DZ() * e.length)];
}
function CZ({ min: e = 1, max: t = 9999.99, fraction: n = 0 } = {}) {
  if (t < e) throw new Error("Max must be bigger than min");
  return Number((DZ() * (t - e) + e).toFixed(n));
}
const Cbt = "abcdefghijklmnopqrstuvwxyz";
function Ebt(e) {
  return jd(Cbt.split(""), e);
}
function Tbt(e) {
  return jd(() => iM([!0, !1]), e);
}
function vp(e) {
  const t = { min: (e == null ? void 0 : e.min) ?? 0, max: (e == null ? void 0 : e.max) ?? 999999, precision: e == null ? void 0 : e.precision, fraction: e == null ? void 0 : e.fraction };
  return jd(() => {
    if (t.min === t.max) return t.min;
    const n = CZ(t);
    return t.precision !== void 0 ? Math.floor(n / t.precision) * t.precision : n;
  }, e);
}
function Sbt(e) {
  const t = new Date(e.from).getTime(), n = new Date(e.to).getTime();
  if (t >= n) throw new Error("From must be before to");
  return jd(() => new Date(vp({ min: t, max: n })), e);
}
var Abt = ["est", "voluptatem", "non", "aut", "aliquid", "quaerat", "quos", "vel", "tenetur", "consectetur", "ipsum", "voluptate", "numquam", "nulla", "asperiores", "in", "laborum", "quas", "et", "ullam", "consequuntur", "enim", "dicta", "quia", "facilis", "voluptatibus", "at", "hic", "sunt", "excepturi", "maiores", "vitae", "fugit", "possimus", "unde", "repellat", "sit", "necessitatibus", "nemo", "qui", "exercitationem", "dolores", "esse", "reiciendis", "nihil", "commodi", "id", "sequi", "consequatur", "occaecati", "deserunt", "quae", "eos", "sapiente", "fugiat", "neque", "quasi", "nostrum", "magnam", "sed", "omnis", "doloribus", "error", "ducimus", "rerum", "beatae", "cupiditate", "blanditiis", "labore"];
function x6(e) {
  return jd(() => {
    let t = iM(Abt);
    var n;
    return e != null && e.capitalize && (t = (n = t).charAt(0).toUpperCase() + n.slice(1)), t;
  }, e);
}
var wbt = { china: ["Peking roasted duck", "Kung pao chicken", "Sweet and sour pork", "Hot pot", "Dim sum", "Dumplings", "Ma po tofu", "Char siu", "Chicken chow mein", "Beef chow mein", "vegetable chow mein", "Chicken fried rice", "Beef fried rice", "Vegetable fried Rice", "Special fried Rice", "Sichuan pork", "Xiaolongbao", "Zhajiangmian", "Wonton soup", "Sweet and sour pork", "Duck spring Rolls", "Vegetable spring Rolls", "Wonton", "Peking duck", "Lamb hot pot", "Spicy crayfish", "Guilin rice noodles", "Lanzhou hand-pulled noodles", "Steamed crab", "Shredded pork with garlic sauce", "Red braised pork", "Sweet and sour Ribs", "Xinjiang", "Braised pork with vermicelli"], italy: ["Butternut squash risotto", "Mushroom risotto", "Beetroot risotto", "Courgette risotto", "Pizza", "Gnocchi", "Spaghetti bolognese", "Spaghetti carbonara", "Pesto alla Genovese", "Beef lasagne", "Vegetable lasagne", "Gelato", "Prosciutto di Parma", "Ribollita", "Bagna cauda", "Polenta", "Tortelli and ravioli", "Focaccia", "Garlic bread", "Arancini", "Il tartufo", "Panzerotto fritto", "Fiorentina", "Minestrone", "Frico", "Arrosticini", "Olive ascolante", "Fritto misto piemontes", "Tiramisù"], india: ["Biryani", "Dosa", "Tandoori chicken", "Samosas", "Chaat", "Plain naan", "Garlic naan", "Pilau rice", "Steamed rice", "Chicken madras", "Vegetable madras", "Chicken vindaloo", "Chicken jalfrezi", "Chicken roghan josh", "Lamb roghan josh", "Beef roghan josh", "Butter chicken", "Dosa", "Gulab jamun", "Chicken korma", "Mutter paneer", "Papadum", "Paratha", "Raita", "Saag paneer", "Tandoori chicken", "Chicken tikka masala", "Pakora", "Dal", "Chapati", "Pasanda", "Aloo gobi", "Kofta", "Chicken makhani", "Paneer naan", "Chana Aloo Curry"], mexico: ["Chilaquiles", "Pozole", "Tacos al pastor", "Tostadas", "Chiles en nogada", "Elote", "Enchiladas", "Mole", "Guacamole", "Tamales", "Huevos rancheros", "Machaca", "Discada", "Beef Burrito", "Chicken Burrito", "Pozole de pollo o duajolote", "Menudo", "Cochinita pibil", "Tamale", "Quesadilla", "Frijoles puercos", "Chile en nogada", "Esquites", "Alegria de amaranto", "Pipián", "Aguachile", "Ceviche", "Pescado zarandeado", "Camarones a la diabla", "Birria de chivo", "Tlayuda", "Guacamole con chapulines", "Flautas", "Torta Ahogada", "Carnitas", "Caldo Azteca", "Gorditas de Nata"], japan: ["Sushi", "Udon", "Tofu", "Tempura", "Yakitori", "Sashimi", "Ramen", "Donburi", "Natto", "Oden", "Tamagoyaki", "Soba", "Tonkatsu", "Kashipan", "Sukiyaki", "Miso soup", "Okonomiyaki", "Mentaiko", "Nikujaga", "Unagi no kabayaki", "Shabu Shabu", "Onigiri", "Gyoza", "Takoyaki", "aiseki ryori", "Edamame", "Yakisoba", "Chawanmushi", "Wagashi"], france: ["Foie gras", "Huîtres", "Cassoulet", "Poulet basquaise", "Escargots au beurre persillé", "Mouclade charentaise", "Galettes bretonnes", "Flemish carbonnade", "Quiche lorraine", "Raclette", "Cheese fondue", "Beef fondue", "Gratin dauphinois", "Tartiflette", "Bouillabaisse", "Ratatouille", "Boeuf bourguignon", "Blanquette de veau", "Pot-au-feu", "Coq-au-vin", "Hachis parmentier", "Steak tartare", "Choucroute", "Soufflé au fromage", "Cuisses de grenouilles", "Soupe à l’oignon", "Baguette", "Croissant", "French cheeses", "Fondant au chocolat", "Tarte tatin", "Macarons", "Crème brûlée", "Île flottante", "Profiteroles", "Pain au chocolat"], lebanon: ["Kibbeh", "Kafta", "Kanafeh", "Hummus", "Rice pilaf", "Fattoush", "Manakish", "Tabbouleh", "Sfeeha", "Fattoush", "Labneh", "Muhammara", "Lahm bi ajin", "Kaak", "Chanklich", "Mssabaha", "Shawarma", "Kebbe", "Falafel", "Halewit el jeben", "Namoura", "Maamoul", "Foul mdammas", "Balila", "Kawarma", "Fattouch"], thailand: ["Pad kra pao moo", "Tom kha gai", "Khao Pad", "Chicken pad Thai", "Vegetable pad Thai", "Moo satay", "Tom yum goong", "Khao niew mamuang", "Kai yad sai", "Khao soi", "Pad see ew", "Laab moo", "Gaeng panang", "Gai pad med ma muang", "Som tam", "Poh pia tod", "Gaeng massaman", "Pla kapung nueng manao", "Tod mun pla", "Gaeng ped", "Gaeng garee", "Gaeng keow wan", "Moo ping", "Durian", "Sai ooah", "Hoy tod", "Kuay teow reua", "Mu kratha", "Kao ka moo", "Yam nua"], greece: ["Moussaka", "Papoutsakia", "Pastitsio", "Souvlaki", "Soutzoukakia", "Stifado", "Tomatokeftedes", "Tzatziki", "Kolokithokeftedes", "Giouvetsi", "Choriatiki", "Kleftiko", "Gemista", "Fasolada", "Bougatsa", "Tiropita", "Spanakopita", "Feta Cheese with Honey", "Horta", "Tirokroketes", "Briam", "Saganaki", "Gigantes", "Dolmades", "Fasolatha", "Koulouri", "Loukoumades", "Gyros", "Galaktoboureko", "Baklava"], turkey: ["Şiş kebap", "Döner", "Köfte", "Pide", "Kumpir", "Meze", "Mantı", "Lahmacun", "Menemen", "Şiş kebap", "İskender kebab", "Corba", "Kuzu tandir", "Çiğ Köfte", "Pilav", "Yaprak sarma", "Dolma", "İmam bayıldı", "Borek", "Durum", "Kumpir", "Balik ekmek", "Simit", "Kunefe", "Baklava", "Lokum", "Halva", "Mozzaik pasta", "Güllaç", "Mercimek Köftesi", "Haydari", "Tursu suyu", "Kahvalti", "Kazan dibi", "Hunkar begendi", "Islak burgers", "Salep", "Yogurtlu kebab"], spain: ["Tortilla de patatas", "Fabada asturiana", "Calçots", "Boquerones al vinagre", "Empanada gallega", "Paella", "Gazpacho", "Gachas", "Migas", "Bocadillo de calamares", "Pulpo a feira", "Caldo gallego", "Lentejas con chorizo", "Cocido madrileño", "Cachopo", "Caracoles"], venezuela: ["Pabellón criollo", "Arepa", "Mondongo", "Empanadas", "Quesillo", "Chicha andina", "Tequeños", "Cachapa", "Hallaca", "Perico", "Pasticho", "Mandocas", "Caraotas negras", "Patacones", "Dulce de leche", "Pan de Jamón"], chile: ["Humitas", "Empanadas", "Porotos con riendas", "Completos", "Manjar", "Cordero al palo", "Pastel de choclo", "Mote con huesillos", "Sopaipillas", "Curanto"], argentina: ["Milanesas", "Empanadas", "Pizza fugazeta", "Asado", "Choripan", "Bondiola", "Bife de chorizo"], colombia: ["Bandeja paisa", "Chuleta valluna", "Sancocho trifásico", "Empanada valluna", "Salpicon de frutas", "Pastel de garbanzo", "Ajiaco", "Arepas", "Arroz de lisa", "Sancocho", "Pan de bono", "Cuchuco", "Oblea", "Cazuela de mariscos", "Pan de yuca", "Bollo Limpio", "Almojábana", "Empanadas", "Arroz con Coco", "Sopa de mondongo", "Cazuela de Mariscos", "Arroz con Pollo", "Arepa de Huevo", "Mote de Queso"], ecuador: ["Encebollado", "Ceviche", "Tigrillo", "Bolon de verde", "Llapingacho", "Mote pillo", "Locro de papa", "Churrasco"], peru: ["Ceviche", "Arroz con pollo", "Aji de gallina", "Llunca de gallina"], "el salvador": ["Pupusa", "Sopa de patas", "Rigua", "Flor de izote con huevo", "Gallo en chicha"], romania: ["Sarmale", "Mici", "Pomana porcului", "Ciorbă de fasole cu ciolan", "Ciorbă de burtă", "Ciorbă rădăuțeană", "Plăcintă cu brânză", "Ciorbă de potroace", "Mămăligă cu brânză și smântână", "Tochitură", "Piftie", "Iahnie de fasole", "Slănină afumată", "Cârnați afumați", "Varză a la Cluj", "Gulaș de cartofi cu afumătură", "Cozonac de casă", "Ciorbă ardelenească de porc", "Mucenici moldovenești", "Salată de boeuf", "Dovleac copt", "Papanași cu brânză de vacă și afine", "Drob de miel", "Pârjoale moldovenești", "Zacuscă de vinete", "Zacuscă de fasole", "Turtă dulce", "Clătitele cu gem", "Clătitele cu brânza de vacă", "Balmoș", "Cozonac", "Chiftele"] }, A6;
(A6 = Object.keys(wbt)) == null || A6.length;
const EZ = 50;
function Pbt(e) {
  const t = CZ({ min: 1, max: 10, fraction: 0 });
  return t === 1 || e === EZ ? "." : t === 2 ? "," : "";
}
function D6(e) {
  return jd(() => {
    let t = x6({ capitalize: !0 }), n = 1;
    for (; n < EZ; ) {
      const r = x6();
      let i = "";
      if (n++, n > 3 && (i = Pbt(n)), t += ` ${r}${i}`, i === ".") break;
    }
    return t;
  }, e);
}
function kbt(e) {
  const r = /* @__PURE__ */ new Date(), i = new Date(r.getTime() - 31536e6);
  return jd(() => Sbt({ from: i, to: r }), e);
}
function Obt(e) {
  if (isNaN(10)) throw "Character count must be greater than 0";
  return jd(() => {
    let n = D6();
    for (; n.length < 10; ) n += ` ${D6()}`;
    return n = n.substring(0, 8), n += `${Ebt()}.`, n;
  }, e);
}
function e0(e) {
  if (Array.isArray(e.type)) {
    const t = e.type[vp({ min: 0, max: e.type.length - 1 })];
    return e0({ ...e, type: t });
  }
  if (e.enum)
    return e.enum[vp({ min: 0, max: e.enum.length - 1 })];
  if (e.type === "object" && e.properties)
    return Object.keys(e.properties).reduce(
      (t, n) => {
        var r;
        return t[n] = e0((r = e.properties) == null ? void 0 : r[n]), t;
      },
      {}
    );
  if (e.type === "array" && e.items) {
    if (Array.isArray(e.items))
      return Array.from(
        new Set(
          Array.from({ length: vp({ min: 1, max: 5 }) }).map(() => {
            if (Array.isArray(e.items))
              return e0(
                e.items[vp({ min: 0, max: e.items.length - 1 })]
              );
          })
        )
      );
    const t = e.items;
    return Array.from(
      new Set(Array.from({ length: vp({ min: 1, max: 5 }) }).map(() => e0(t)))
    );
  }
  switch (e.type) {
    case "string":
      return e.format === "date" ? kbt().toISOString().split("T")[0] : Obt();
    case "number":
    case "integer":
      return vp();
    case "boolean":
      return Tbt();
    case "null":
      return null;
  }
}
const Tr = {
  enableDebuggingKey: "rf-debugging",
  formDataPrefillKey: "rf-debugging-form-data-prefill",
  formDataPrefillFormUuidKey: "rf-debugging-form-data-form-uuid",
  formDataPrefillOverrideKey: "rf-debugging-form-data-prefill-override-autosave",
  compactModeOverrideKey: "rf-debugging-compact-mode",
  disableAutosaveKey: "rf-debugging-disable-autosave"
}, Ibt = () => localStorage.getItem(Tr.formDataPrefillKey), Fbt = () => localStorage.getItem(Tr.formDataPrefillOverrideKey), oM = () => {
  localStorage.removeItem(Tr.formDataPrefillKey), localStorage.removeItem(Tr.formDataPrefillOverrideKey), window.location.reload();
}, $bt = (e, t, n = !1) => {
  localStorage.setItem(Tr.formDataPrefillFormUuidKey, t), localStorage.setItem(Tr.formDataPrefillKey, JSON.stringify(e)), localStorage.setItem(Tr.formDataPrefillOverrideKey, `${n}`);
}, Nbt = (e) => {
  const { getFormContext: t, formUuid: n } = e, r = ($) => wN($, {
    parser: "json",
    plugins: [Ypt, tbt],
    semi: !0,
    singleQuote: !0
  }).then((L) => L).catch((L) => {
    console.error("Formatting error:", L);
  }), i = ($) => {
    try {
      return JSON.parse($), !0;
    } catch {
      return !1;
    }
  }, o = Ibt() || JSON.stringify(t().data) || "", s = i(o), a = Fbt() === "true", { open: u, handleClose: c } = e, [d, f] = Et(o), [h, m] = Et(s), [v, x] = Et(a);
  rn(() => {
    r(o).then(($) => {
      $ && f($);
    });
  }, [o]);
  const C = ($) => {
    m(i($));
  }, E = ($) => {
    C($), f($);
  }, S = () => {
    oM(), window.location.reload();
  }, w = () => {
    d && r(d).then(($) => {
      $ && f($);
    });
  }, O = () => {
    w();
  }, A = () => {
    let $;
    if (d) {
      try {
        $ = JSON.parse(d);
      } catch {
        console.error("nope");
        return;
      }
      $bt($, n, v), c(), window.location.reload();
    }
  }, I = () => {
    const $ = JSON.stringify(e0(t().schema));
    f($);
  };
  return /* @__PURE__ */ P.jsxs(Zb, { open: u, onClose: c, fullScreen: !0, scroll: "paper", children: [
    /* @__PURE__ */ P.jsx(zE, { children: "Set Form Data Prefill" }),
    /* @__PURE__ */ P.jsxs(tv, { dividers: !0, children: [
      /* @__PURE__ */ P.jsxs(
        Ar,
        {
          sx: {
            textAlign: "right",
            paddingBottom: "0.5rem",
            display: "flex",
            flexFlow: "row nowrap",
            gap: "1rem",
            justifyContent: "flex-end"
          },
          children: [
            /* @__PURE__ */ P.jsx(Nr, { onClick: I, variant: "outlined", size: "small", children: "Generate Random Data" }),
            /* @__PURE__ */ P.jsx(Nr, { onClick: O, variant: "outlined", size: "small", children: "Format Code" })
          ]
        }
      ),
      /* @__PURE__ */ P.jsxs(hi, { fullWidth: !0, children: [
        /* @__PURE__ */ P.jsx(cJ, { value: d || "", width: "100%", extensions: [Iut()], onChange: E }),
        /* @__PURE__ */ P.jsx(gn, { error: !h, children: !h && /* @__PURE__ */ P.jsx(P.Fragment, { children: "Invalid JSON" }) })
      ] })
    ] }),
    /* @__PURE__ */ P.jsxs(ev, { children: [
      /* @__PURE__ */ P.jsx(hi, { sx: { display: "flex", flexFlow: "row nowrap", justifyContent: "center", gap: 0 }, children: /* @__PURE__ */ P.jsx(
        Ps,
        {
          control: /* @__PURE__ */ P.jsx(rc, { checked: v, onChange: () => x(!v) }),
          label: /* @__PURE__ */ P.jsxs(P.Fragment, { children: [
            "Override Autosave",
            " ",
            /* @__PURE__ */ P.jsx(
              io,
              {
                sx: { verticalAlign: "middle" },
                title: "Check this box to override autosave values. Without this checked, any fields that exist in prefill/autosave will be override data entered in this utility.",
                children: /* @__PURE__ */ P.jsx(nbt, {})
              }
            )
          ] })
        }
      ) }),
      /* @__PURE__ */ P.jsx(Nr, { onClick: c, children: "Cancel" }),
      /* @__PURE__ */ P.jsx(Nr, { variant: "outlined", onClick: S, children: "Clear Form Data" }),
      /* @__PURE__ */ P.jsx(Nr, { variant: "contained", onClick: A, disabled: !h, children: "Set Form Data" })
    ] })
  ] });
}, TZ = () => {
  localStorage.removeItem(Tr.enableDebuggingKey), localStorage.removeItem(Tr.formDataPrefillKey), localStorage.removeItem(Tr.formDataPrefillOverrideKey), localStorage.removeItem(Tr.disableAutosaveKey), window.location.reload();
}, _T = () => localStorage.getItem(Tr.enableDebuggingKey) === "true", ns = (e, ...t) => {
  _T() && console.log(`%c === [DEBUG] ===
`, "color:green;", e, ...t);
}, C6 = localStorage.getItem(Tr.compactModeOverrideKey), sM = (e) => {
  e === "clear" && (localStorage.removeItem(Tr.compactModeOverrideKey), ns("Compact mode override cleared")), e === "on" && (localStorage.setItem(Tr.compactModeOverrideKey, "on"), ns("Compact mode override: ON")), e === "off" && (localStorage.setItem(Tr.compactModeOverrideKey, "off"), ns("Compact mode override: OFF")), typeof e > "u" && (!localStorage.getItem(Tr.compactModeOverrideKey) || localStorage.getItem(Tr.compactModeOverrideKey) === "off" ? (localStorage.setItem(Tr.compactModeOverrideKey, "on"), ns("Compact mode override: ON")) : (localStorage.setItem(Tr.compactModeOverrideKey, "off"), ns("Compact mode override: OFF"))), window.location.reload();
}, bb = () => _T() && localStorage.getItem(Tr.disableAutosaveKey) === "true", Mbt = (e) => {
  if (!bb()) {
    localStorage.setItem(Tr.disableAutosaveKey, "true"), ns("Autosave disabled"), window.location.reload();
    return;
  }
  if (bb()) {
    localStorage.removeItem(Tr.disableAutosaveKey), ns("Autosave enabled"), window.location.reload();
    return;
  }
}, Rbt = () => {
  TZ();
}, _bt = () => {
  sM();
}, Lbt = () => {
  sM("clear");
}, Bbt = (e) => {
  const [t, n] = Et(!1), [r, i] = Et(bb()), { getFormContext: o, formUuid: s } = e, a = () => {
    n(!0);
  }, u = () => {
    n(!1);
  }, c = () => {
    Mbt(), i(!r);
  };
  return /* @__PURE__ */ P.jsxs(Yb, { position: "sticky", color: "primary", sx: { top: "auto", bottom: 0, mt: 2 }, children: [
    /* @__PURE__ */ P.jsxs(pg, { children: [
      /* @__PURE__ */ P.jsx(Nr, { onClick: a, size: "small", variant: "outlined", color: "inherit", sx: { mr: 2 }, children: "Set Form Data Prefill" }),
      /* @__PURE__ */ P.jsx(Nr, { onClick: _bt, size: "small", variant: "outlined", color: "inherit", sx: { mr: 2 }, children: "Toggle Compact" }),
      /* @__PURE__ */ P.jsx(Nr, { onClick: Lbt, size: "small", variant: "outlined", color: "inherit", sx: { mr: 2 }, children: "Clear Compact Override" }),
      /* @__PURE__ */ P.jsx(Nr, { onClick: c, size: "small", variant: "outlined", color: "inherit", sx: { mr: 2 }, children: r ? "Enable Autosave" : "Disable Autosave" }),
      /* @__PURE__ */ P.jsx(Ar, { sx: { flexGrow: 1 } }),
      /* @__PURE__ */ P.jsx(Nr, { onClick: Rbt, size: "small", variant: "outlined", color: "inherit", sx: { mr: 2 }, children: "Disable Debugging" })
    ] }),
    /* @__PURE__ */ P.jsx(
      Nbt,
      {
        open: t,
        handleClose: u,
        getFormContext: o,
        formUuid: s
      }
    )
  ] });
}, jbt = ({ autosaveCallback: e, autosaveDate: t }) => {
  if (!e)
    return /* @__PURE__ */ P.jsx(P.Fragment, {});
  const n = (r) => {
    const i = /* @__PURE__ */ new Date(), o = new Date(i.getFullYear(), i.getMonth(), i.getDate()), s = new Date(o);
    s.setDate(o.getDate() - 1);
    const a = r >= o, u = r >= s && r < o, c = (d) => {
      const f = d.getHours(), h = d.getMinutes(), m = f >= 12 ? "pm" : "am", v = f % 12 || 12, x = h < 10 ? "0" + h : h;
      return `${v}:${x}${m}`;
    };
    if (a)
      return `Today, ${c(r)}.`;
    if (u)
      return `Yesterday, ${c(r)}.`;
    {
      const d = r.getDate(), f = r.toLocaleString("default", { month: "short" }), h = r.getFullYear();
      return `${d} ${f}, ${h}, ${c(r)}.`;
    }
  };
  return /* @__PURE__ */ P.jsx(Yb, { position: "sticky", color: "primary", sx: { top: "auto", bottom: 0, mt: 2 }, children: /* @__PURE__ */ P.jsxs(pg, { variant: "dense", children: [
    /* @__PURE__ */ P.jsxs(cn, { variant: "subtitle2", component: "div", sx: { flexGrow: 1, textAlign: "right", mr: 2 }, children: [
      "Last saved: ",
      n(t || /* @__PURE__ */ new Date())
    ] }),
    /* @__PURE__ */ P.jsx(Nr, { onClick: e, size: "small", variant: "outlined", color: "inherit", children: "Save progress" })
  ] }) });
}, Vbt = [
  // For OT/PT- Objective Tests and Measures
  {
    dataPath: "otherData",
    key: "typeA220",
    type: "array",
    condition: {
      case: "NOT_EQUAL",
      key: "test",
      target: "testName",
      value: "other"
    }
  },
  //  For SLP - Objective Tests and Measures
  {
    dataPath: "otherData",
    key: "input531",
    type: "array",
    condition: {
      case: "NOT_EQUAL",
      key: "testOrMeasure",
      target: "testName",
      value: "other"
    }
  }
], zbt = (e) => (e != null && e.data && Vbt.map((t) => {
  const { dataPath: n, key: r, type: i, condition: o } = t;
  if (e != null && e.data[n] && (e != null && e.data[n][r])) {
    const s = e == null ? void 0 : e.data[n][r];
    i === "array" ? s.map((a) => {
      o.case === "NOT_EQUAL" && a[o.key] && a[o.key].toLowerCase() !== o.value && (a[o.target] = ""), o.case === "EQUAL" && a[o.key] && a[o.key].toLowerCase() === o.value && (a[o.target] = "");
    }) : i === "object" && (o.case === "NOT_EQUAL" && s[o.key] && s[o.key].toLowerCase() !== o.value && (s[o.value] = ""), o.case === "EQUAL" && s[o.key] && s[o.key].toLowerCase() === o.value && (s[o.value] = ""));
  }
}), e), Ubt = "jsonforms/INIT", Wbt = "jsonforms/UPDATE_CORE", Hbt = (e, t, n) => {
  const r = n(e, t);
  switch (t.type) {
    case Ubt:
    case Wbt:
      return zbt(r);
    default:
      return r;
  }
}, qbt = (e, t, n) => {
  const r = [];
  return e.forEach((i) => {
    i.params.uischema ? Ed(i.params.uischema, t, "", n) && r.push(i) : r.push(i);
  }), r;
}, Gbt = () => /* @__PURE__ */ P.jsx(
  CU,
  {
    variant: "filled",
    severity: "warning",
    action: /* @__PURE__ */ P.jsx(
      Nr,
      {
        variant: "outlined",
        color: "inherit",
        size: "small",
        sx: { marginTop: "-2px" },
        onClick: () => {
          oM();
        },
        children: "Clear Data Override"
      }
    ),
    children: /* @__PURE__ */ P.jsx(EU, { sx: { marginTop: 0, marginBottom: 0 }, children: "Data override enabled in debugging tools." })
  }
), Ybt = () => (e) => {
  const t = (n, r, i) => n === 1 ? r : i;
  switch (e.keyword) {
    case "required":
      return "This field is required.";
    case "type":
      return "Please enter a valid value.";
    case "minLength":
      return `Please enter at least ${e.params.limit} ${t(e.params.limit, "character", "characters")}.`;
    case "maxLength":
      return `Please enter no more than ${e.params.limit} ${t(e.params.limit, "character", "characters")}.`;
    case "minimum":
      return `Please enter a number that is ${e.params.limit} or higher.`;
    case "maximum":
      return `Please enter a number that is ${e.params.limit} or lower.`;
    case "pattern":
      return "Please follow the required format.";
    case "format":
      return `Please enter a valid ${e.params.format}.`;
    case "multipleOf":
      return `Please enter a number that is a multiple of ${e.params.multipleOf}.`;
    case "enum":
      return "Please select from one of the supplied options.";
    case "const":
      return "This value must be exactly as specified.";
    case "minItems":
      return "This field is required.";
    case "maxItems":
      return `Please select no more than ${e.params.limit} ${t(e.params.limit, "option", "options")}.`;
    case "uniqueItems":
      return "Please make sure all selected options are unique.";
    case "additionalProperties":
      return "Some unexpected information was provided.";
    case "dependencies":
      return `This field requires ${e.params.property} to be filled out as well.`;
    case "oneOf":
      return "Please enter a value that matches one of the allowed options.";
    case "anyOf":
      return "Please enter a value that matches at least one of the allowed options.";
    case "allOf":
      return "Please enter a value that meets all the required conditions.";
    case "not":
      return "This value is not allowed.";
    default:
      return e.message || "Invalid input.";
  }
}, Kbt = (e, t) => {
  if (!e || !t || typeof e != "object")
    return e;
  const n = { ...e }, r = [], i = (o, s) => {
    !o.properties || typeof s != "object" || Object.keys(o.properties).forEach((a) => {
      var d;
      const u = (d = o.properties) == null ? void 0 : d[a], c = s[a];
      if (c !== void 0 && u) {
        if (u.enum && Array.isArray(u.enum)) {
          const f = u.enum.map((h) => typeof h == "string" ? h.toLowerCase() : h);
          if (typeof c == "string") {
            const h = f.indexOf(c.toLowerCase());
            h !== -1 ? (r.push({ key: a, reason: "casing", value: c }), s[a] = u.enum[h]) : (r.push({ key: a, reason: "invalid enum", value: c, expectedEnum: u.enum }), delete s[a]);
          } else u.enum.includes(c) || (r.push({ key: a, reason: "invalid enum", value: c, expectedEnum: u.enum }), delete s[a]);
        }
        if (u.type && c !== void 0) {
          const f = u.type;
          f === "string" && typeof c == "string" || f === "number" && typeof c == "number" || f === "integer" && Number.isInteger(c) || f === "boolean" && typeof c == "boolean" || f === "object" && typeof c == "object" || f === "array" && Array.isArray(c) || f === "null" && c === null || Array.isArray(f) && f.includes("string") && typeof c == "string" || Array.isArray(f) && f.includes("number") && typeof c == "number" || Array.isArray(f) && f.includes("integer") && Number.isInteger(c) || Array.isArray(f) && f.includes("boolean") && typeof c == "boolean" || Array.isArray(f) && f.includes("object") && typeof c == "object" || Array.isArray(f) && f.includes("array") && Array.isArray(c) || Array.isArray(f) && f.includes("null") && c === null || (r.push({ key: a, reason: "type mismatch", value: c, expectedType: f, valueType: typeof c }), delete s[a]);
        }
        u.type === "object" && typeof s[a] == "object" && i(u, s[a]), u.type === "array" && Array.isArray(s[a]) && u.items && (s[a] = s[a].map((f) => (typeof f == "object" && typeof u.items < "u" && !Array.isArray(u.items) && i(u.items, f), f)).filter((f) => f !== void 0));
      }
    });
  };
  return i(t, n), r.length > 0 ? ns("Data cleaned during preprocessing:", r) : ns("No data cleaned during preprocessing"), n;
}, Jbt = () => _T() && localStorage.getItem(Tr.formDataPrefillKey) !== null, SZ = (e, t) => {
  if (!e)
    return t;
  if (!t)
    return e;
  for (const n in t)
    Array.isArray(t[n]) ? e[n] = Array.isArray(e[n]) ? e[n].concat(t[n]) : [...t[n]] : typeof t[n] == "object" && t[n] !== null ? ((!e[n] || typeof e[n] != "object" || Array.isArray(e[n])) && (e[n] = {}), SZ(e[n], t[n])) : e[n] = t[n];
  return e;
}, Xbt = (e) => {
  const t = localStorage.getItem(Tr.formDataPrefillKey);
  if (!t)
    return ns("Form Data Prefill not set"), {};
  const n = localStorage.getItem(Tr.formDataPrefillOverrideKey) === "true", r = JSON.parse(t);
  return n ? r : SZ(r, e);
}, Qbt = (e) => {
  const t = localStorage.getItem(Tr.formDataPrefillFormUuidKey);
  !localStorage.getItem(Tr.formDataPrefillOverrideKey) && !localStorage.getItem(Tr.formDataPrefillKey) || t !== e && (ns("formUuid missmatch, clearing prefill", t, e), oM());
}, Zbt = _T(), E6 = Jbt(), evt = (e) => {
  const { schema: t, uiSchema: n, initialData: r, submitCallback: i, autosaveCallback: o, autosaveThrottle: s, autosaveDate: a, formUuid: u } = e, c = E6 ? Xbt(r) : r, [d, f] = Et(Kbt(c, t)), [h, m] = Et([]), [v, x] = Et(a || /* @__PURE__ */ new Date()), C = rs(!1), E = rs(""), S = rs(null), w = s || 30, O = LP(), A = Ybt(), { additionalErrors: I } = Dg(), $ = qbt(I, d, O), L = h.length <= 0 && $.length <= 0, B = LP({ useDefaults: !0 });
  mKe(B), ns("debugging info", {
    formUuid: u,
    schema: t,
    uiSchema: n,
    initialData: r,
    data: d,
    formValid: L,
    errors: h,
    additionalErrors: I,
    activeAdditionalErrors: $
  }), rn(() => {
    if (!d.RF_INITIAL_DATA) {
      const K = {
        ...d,
        RF_INITIAL_DATA: d
      };
      f(K);
    }
  }, [f, d]);
  const H = Cn(
    (G) => {
      !o || w === 0 || bb() || JSON.stringify(G) !== E.current && (E.current = JSON.stringify(G), ns("autosave", G), o(G).then((K) => {
        K === !0 && x(/* @__PURE__ */ new Date());
      }));
    },
    [w, o]
  );
  rn(() => {
    if (!(!d || bb()))
      return S.current = setInterval(() => {
        H(d);
      }, w * 1e3), () => {
        S.current && clearInterval(S.current);
      };
  }), Qbt(u);
  const q = (G) => {
    if (G.preventDefault(), !L) {
      alert("Validation errors detected");
      return;
    }
    const K = vo.cloneDeep(d), ee = gq(n, K, O);
    ee.RF_INITIAL_DATA && delete ee.RF_INITIAL_DATA, ns("form submit", {
      data: d,
      cleanedFields: ee
    }), i(ee);
  }, J = (G) => {
    w !== 0 && (C.current || (C.current = !0, H(G), setTimeout(() => {
      C.current = !1;
    }, w * 1e3)));
  }, X = (G, K) => {
    m(K), f(G), J(G);
  }, j = () => {
    o && (H(d), ns("manualautosave", d));
  }, U = () => ({
    schema: t,
    uiSchema: n,
    data: d
  });
  return /* @__PURE__ */ P.jsxs(P.Fragment, { children: [
    E6 && /* @__PURE__ */ P.jsx(Gbt, {}),
    /* @__PURE__ */ P.jsxs("form", { noValidate: !0, onSubmit: q, children: [
      /* @__PURE__ */ P.jsx(jbt, { autosaveCallback: j, autosaveDate: v }),
      /* @__PURE__ */ P.jsx(
        VFe,
        {
          schema: t,
          uischema: n,
          data: d,
          renderers: unt,
          cells: fKe,
          onChange: ({ errors: G, data: K }) => X(K, G),
          ajv: B,
          config: { allowDynamicCheck: !0 },
          additionalErrors: $,
          middleware: Hbt,
          i18n: { translateError: A }
        }
      ),
      /* @__PURE__ */ P.jsx(Ar, { sx: { padding: "1rem 0", display: "flex", flexFlow: "row nowrap", justifyContent: "flex-end" }, children: /* @__PURE__ */ P.jsx(Nr, { type: "submit", disabled: !L, variant: "contained", children: "Submit" }) })
    ] }),
    Zbt && /* @__PURE__ */ P.jsx(Bbt, { getFormContext: U, formUuid: u })
  ] });
}, tvt = () => ({
  fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji"',
  body1: {
    fontSize: "1rem",
    fontWeight: 400,
    lineHeight: 1.5
  },
  body2: {
    fontSize: "0.875rem",
    fontWeight: 400,
    lineHeight: 1.57
  },
  button: {
    fontWeight: 600
  },
  caption: {
    fontSize: "0.75rem",
    fontWeight: 500,
    lineHeight: 1.66
  },
  subtitle1: {
    fontSize: "1rem",
    fontWeight: 500,
    lineHeight: 1.57
  },
  subtitle2: {
    fontSize: "0.875rem",
    fontWeight: 500,
    lineHeight: 1.57
  },
  overline: {
    fontSize: "0.75rem",
    fontWeight: 600,
    letterSpacing: "0.5px",
    lineHeight: 2.5,
    textTransform: "uppercase"
  },
  h1: {
    fontFamily: "'Plus Jakarta Sans', sans-serif",
    fontWeight: 700,
    fontSize: "3.5rem",
    lineHeight: 1.2
  },
  h2: {
    fontFamily: "'Plus Jakarta Sans', sans-serif",
    fontWeight: 700,
    fontSize: "3rem",
    lineHeight: 1.2
  },
  h3: {
    fontFamily: "'Plus Jakarta Sans', sans-serif",
    fontWeight: 700,
    fontSize: "2.25rem",
    lineHeight: 1.2
  },
  h4: {
    fontFamily: "'Plus Jakarta Sans', sans-serif",
    fontWeight: 700,
    fontSize: "2rem",
    lineHeight: 1.2
  },
  h5: {
    fontFamily: "'Plus Jakarta Sans', sans-serif",
    fontWeight: 700,
    fontSize: "1.5rem",
    lineHeight: 1.2
  },
  h6: {
    fontFamily: "'Plus Jakarta Sans', sans-serif",
    fontWeight: 700,
    fontSize: "1.125rem",
    lineHeight: 1.2
  },
  customHeading: {
    fontFamily: "'Plus Jakarta Sans', sans-serif",
    fontWeight: 700,
    fontSize: "1.125rem",
    lineHeight: 1.2
  },
  captionText: {
    fontWeight: 500,
    fontSize: "12px",
    fontStyle: "normal",
    color: "#6C737F",
    lineHeight: "19.92px"
  },
  caption2Text: {
    fontWeight: 400,
    fontSize: "14px",
    fontStyle: "normal",
    color: "#6C737F",
    lineHeight: "19.92px"
  },
  caption3Text: {
    fontWeight: 400,
    fontSize: "14px",
    fontStyle: "normal",
    color: "#111927",
    lineHeight: "19.92px"
  },
  buttonText: {
    fontSize: "13px",
    fontWeight: 600,
    letterSpacing: "0.2px",
    lineHeight: 2.2
  },
  paragraphHeading: {
    fontSize: "12px",
    fontWeight: 600,
    letterSpacing: "0.2px",
    lineHeight: 2.2,
    textTransform: "uppercase"
  },
  boldText: {
    fontSize: "13px",
    fontWeight: 500,
    letterSpacing: "0.2px",
    lineHeight: 2.2,
    color: "#111927"
  },
  label: {
    fontSize: "10px",
    fontWeight: 500,
    letterSpacing: "0.2px",
    lineHeight: 1.4,
    color: "#9E9E9E"
  },
  h7: {
    fontWeight: 600,
    fontSize: "16px",
    fontStyle: "normal",
    color: "#111927",
    lineHeight: "25.12px"
  }
}), T6 = Hb(), nvt = () => ({
  MuiAccordion: {
    defaultProps: {
      TransitionProps: {
        unmountOnExit: !0
      }
    }
  },
  MuiAvatar: {
    styleOverrides: {
      root: {
        fontSize: 14,
        fontWeight: 600,
        letterSpacing: 0
      }
    }
  },
  MuiButton: {
    styleOverrides: {
      root: {
        borderRadius: "12px",
        textTransform: "none"
      },
      sizeSmall: {
        padding: "6px 16px"
      },
      sizeMedium: {
        padding: "8px 20px"
      },
      sizeLarge: {
        padding: "11px 24px"
      },
      textSizeSmall: {
        padding: "7px 12px"
      },
      textSizeMedium: {
        padding: "9px 16px"
      },
      textSizeLarge: {
        padding: "12px 16px"
      }
    }
  },
  MuiCard: {
    styleOverrides: {
      root: {
        borderRadius: 20
      }
    }
  },
  MuiCardContent: {
    styleOverrides: {
      root: {
        padding: "32px 24px",
        "&:last-child": {
          paddingBottom: "32px"
        }
      }
    }
  },
  MuiCardHeader: {
    defaultProps: {
      titleTypographyProps: {
        variant: "h6"
      },
      subheaderTypographyProps: {
        variant: "body2"
      }
    },
    styleOverrides: {
      root: {
        padding: "32px 24px 16px"
      }
    }
  },
  MuiCheckbox: {
    defaultProps: {
      checkedIcon: /* @__PURE__ */ P.jsx("svg", { fill: "none", height: "24", viewBox: "0 0 24 24", width: "24", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ P.jsx(
        "path",
        {
          clipRule: "evenodd",
          d: "M9 3.5C5.68629 3.5 3 6.18629 3 9.5V15.5C3 18.8137 5.68629 21.5 9 21.5H15C18.3137 21.5 21 18.8137 21 15.5V9.5C21 6.18629 18.3137 3.5 15 3.5H9ZM16.7179 10.1961C17.1024 9.79966 17.0926 9.16657 16.6961 8.7821C16.2997 8.39763 15.6666 8.40737 15.2821 8.80385L10.6667 13.5635L8.7179 11.5539C8.33343 11.1574 7.70034 11.1476 7.30385 11.5321C6.90737 11.9166 6.89763 12.5497 7.2821 12.9461L9.94877 15.6961C10.1371 15.8904 10.3961 16 10.6667 16C10.9372 16 11.1962 15.8904 11.3846 15.6961L16.7179 10.1961Z",
          fill: "currentColor",
          fillRule: "evenodd"
        }
      ) }),
      color: "primary",
      icon: /* @__PURE__ */ P.jsx("svg", { fill: "none", height: "24", viewBox: "0 0 24 24", width: "24", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ P.jsx("rect", { height: "16", rx: "5", stroke: "currentColor", strokeWidth: "2", width: "16", x: "4", y: "4.5" }) }),
      indeterminateIcon: /* @__PURE__ */ P.jsx("svg", { fill: "none", height: "24", viewBox: "0 0 24 24", width: "24", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ P.jsx(
        "path",
        {
          clipRule: "evenodd",
          d: "M9 5.5H15C17.2091 5.5 19 7.29086 19 9.5V15.5C19 17.7091 17.2091 19.5 15 19.5H9C6.79086 19.5 5 17.7091 5 15.5V9.5C5 7.29086 6.79086 5.5 9 5.5ZM3 9.5C3 6.18629 5.68629 3.5 9 3.5H15C18.3137 3.5 21 6.18629 21 9.5V15.5C21 18.8137 18.3137 21.5 15 21.5H9C5.68629 21.5 3 18.8137 3 15.5V9.5ZM8 11.5C7.44772 11.5 7 11.9477 7 12.5C7 13.0523 7.44772 13.5 8 13.5H16C16.5523 13.5 17 13.0523 17 12.5C17 11.9477 16.5523 11.5 16 11.5H8Z",
          fill: "currentColor",
          fillRule: "evenodd"
        }
      ) })
    }
  },
  MuiChip: {
    styleOverrides: {
      root: {
        fontWeight: 500
      }
    }
  },
  MuiCssBaseline: {
    styleOverrides: {
      "*": {
        boxSizing: "border-box"
      },
      html: {
        MozOsxFontSmoothing: "grayscale",
        WebkitFontSmoothing: "antialiased",
        display: "flex",
        flexDirection: "column",
        minHeight: "100%",
        width: "100%"
      },
      body: {
        display: "flex",
        flex: "1 1 auto",
        flexDirection: "column",
        minHeight: "100%",
        width: "100%"
      },
      "& .Mui-disabled": {
        cursor: "not-allowed",
        "& *": {
          cursor: "not-allowed !important"
        }
      },
      "#root, #__next": {
        display: "flex",
        flex: "1 1 auto",
        flexDirection: "column",
        height: "100%",
        width: "100%"
      },
      "#nprogress": {
        pointerEvents: "none"
      },
      "#nprogress .bar": {
        height: 3,
        left: 0,
        position: "fixed",
        top: 0,
        width: "100%",
        zIndex: 2e3
      }
    }
  },
  MuiIconButton: {
    styleOverrides: {
      sizeSmall: {
        padding: 4
      }
    }
  },
  MuiInputBase: {
    styleOverrides: {
      input: {
        "&::placeholder": {
          opacity: 1
        }
      }
    }
  },
  MuiInput: {
    styleOverrides: {
      input: {
        fontSize: 14,
        fontWeight: 500,
        lineHeight: "24px"
      }
    }
  },
  MuiFilledInput: {
    styleOverrides: {
      root: {
        backgroundColor: "transparent",
        borderRadius: 8,
        borderStyle: "solid",
        borderWidth: 1,
        overflow: "hidden",
        transition: T6.transitions.create(["border-color", "box-shadow"]),
        "&:before": {
          display: "none"
        },
        "&:after": {
          display: "none"
        }
      },
      input: {
        fontSize: 14,
        fontWeight: 500,
        lineHeight: "24px"
      }
    }
  },
  MuiOutlinedInput: {
    styleOverrides: {
      input: {
        fontSize: 14,
        fontWeight: 500,
        lineHeight: "24px"
      },
      notchedOutline: {
        transition: T6.transitions.create(["border-color", "box-shadow"])
      }
    }
  },
  MuiFormLabel: {
    styleOverrides: {
      root: {
        fontSize: 14,
        fontWeight: 500,
        [`&.${Yl.filled}`]: {
          transform: "translate(12px, 18px) scale(1)"
        },
        [`&.${Yl.shrink}`]: {
          [`&.${Yl.standard}`]: {
            transform: "translate(0, -1.5px) scale(0.85)"
          },
          [`&.${Yl.filled}`]: {
            transform: "translate(12px, 6px) scale(0.85)"
          },
          [`&.${Yl.outlined}`]: {
            transform: "translate(14px, -9px) scale(0.85)"
          }
        }
      }
    }
  },
  MuiLinearProgress: {
    styleOverrides: {
      root: {
        borderRadius: 3,
        overflow: "hidden"
      }
    }
  },
  MuiLink: {
    defaultProps: {
      underline: "hover"
    }
  },
  MuiListItemIcon: {
    styleOverrides: {
      root: {
        marginRight: "16px",
        minWidth: "unset"
      }
    }
  },
  MuiPaper: {
    styleOverrides: {
      root: {
        backgroundImage: "none"
      }
    }
  },
  MuiPopover: {
    defaultProps: {
      elevation: 16
    }
  },
  MuiRadio: {
    defaultProps: {
      disableRipple: !0,
      color: "primary"
    }
  },
  MuiSwitch: {
    defaultProps: {
      color: "primary"
    }
  },
  MuiTab: {
    styleOverrides: {
      root: {
        fontSize: 14,
        fontWeight: 500,
        lineHeight: 1.71,
        minWidth: "auto",
        paddingLeft: 0,
        paddingRight: 0,
        textTransform: "none",
        "& + &": {
          marginLeft: 24
        }
      }
    }
  },
  MuiTableCell: {
    styleOverrides: {
      root: {
        padding: "15px 16px"
      }
    }
  },
  MuiTableHead: {
    styleOverrides: {
      root: {
        borderBottom: "none",
        [`& .${Xp.root}`]: {
          borderBottom: "none",
          fontSize: 12,
          fontWeight: 600,
          lineHeight: 1,
          letterSpacing: 0.5,
          textTransform: "uppercase"
        },
        [`& .${Xp.paddingCheckbox}`]: {
          paddingTop: 4,
          paddingBottom: 4
        }
      }
    }
  },
  MuiTextField: {
    defaultProps: {
      variant: "filled"
    }
  },
  MuiFormHelperText: {
    styleOverrides: {
      root: {
        minHeight: "1.25em"
      }
    }
  },
  MuiDivider: {
    styleOverrides: {
      root: {
        borderWidth: "1px",
        margin: "1rem 0"
      }
    }
  }
}), rvt = (e) => {
  const { direction: t = "ltr" } = e;
  return {
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 900,
        lg: 1200,
        xl: 1440
      }
    },
    components: nvt(),
    direction: t,
    shape: {
      borderRadius: 8
    },
    typography: tvt()
  };
}, ivt = () => ({
  fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji"',
  body1: {
    fontSize: "0.875rem",
    fontWeight: 400,
    lineHeight: 1.25
  },
  body2: {
    fontSize: "0.75rem",
    fontWeight: 400,
    lineHeight: 1.125
  },
  button: {
    fontWeight: 600
  },
  caption: {
    fontSize: "0.6275rem",
    fontWeight: 500,
    lineHeight: 1.5
  },
  subtitle1: {
    fontSize: "0.875rem",
    fontWeight: 500,
    lineHeight: 1.125
  },
  subtitle2: {
    fontSize: "0.75rem",
    fontWeight: 500,
    lineHeight: 1.25
  },
  overline: {
    fontSize: "0.6275rem",
    fontWeight: 600,
    letterSpacing: "0.5px",
    lineHeight: 2,
    textTransform: "uppercase"
  },
  h1: {
    fontFamily: "'Plus Jakarta Sans', sans-serif",
    fontWeight: 700,
    fontSize: "3rem",
    lineHeight: 1
  },
  h2: {
    fontFamily: "'Plus Jakarta Sans', sans-serif",
    fontWeight: 700,
    fontSize: "2.25rem",
    lineHeight: 1
  },
  h3: {
    fontFamily: "'Plus Jakarta Sans', sans-serif",
    fontWeight: 700,
    fontSize: "2rem",
    lineHeight: 1
  },
  h4: {
    fontFamily: "'Plus Jakarta Sans', sans-serif",
    fontWeight: 700,
    fontSize: "1.5rem",
    lineHeight: 1
  },
  h5: {
    fontFamily: "'Plus Jakarta Sans', sans-serif",
    fontWeight: 700,
    fontSize: "1.125rem",
    lineHeight: 1
  },
  h6: {
    fontFamily: "'Plus Jakarta Sans', sans-serif",
    fontWeight: 700,
    fontSize: "1.125rem",
    lineHeight: 1
  },
  customHeading: {
    fontFamily: "'Plus Jakarta Sans', sans-serif",
    fontWeight: 700,
    fontSize: "1.125rem",
    lineHeight: 1.2
  },
  captionText: {
    fontWeight: 500,
    fontSize: "10px",
    fontStyle: "normal",
    color: "#6C737F",
    lineHeight: "16px"
  },
  caption2Text: {
    fontWeight: 400,
    fontSize: "12px",
    fontStyle: "normal",
    color: "#6C737F",
    lineHeight: "16px"
  },
  caption3Text: {
    fontWeight: 400,
    fontSize: "12px",
    fontStyle: "normal",
    color: "#111927",
    lineHeight: "16px"
  },
  buttonText: {
    fontSize: "11px",
    fontWeight: 600,
    letterSpacing: "0.2px",
    lineHeight: 2
  },
  paragraphHeading: {
    fontSize: "10px",
    fontWeight: 600,
    letterSpacing: "0.2px",
    lineHeight: 2,
    textTransform: "uppercase"
  },
  boldText: {
    fontSize: "11px",
    fontWeight: 500,
    letterSpacing: "0.2px",
    lineHeight: 2,
    color: "#111927"
  },
  label: {
    fontSize: "10px",
    fontWeight: 500,
    letterSpacing: "0.2px",
    lineHeight: 1.2,
    color: "#9E9E9E"
  },
  h7: {
    fontWeight: 600,
    fontSize: "14px",
    fontStyle: "normal",
    color: "#111927",
    lineHeight: "20px"
  }
}), S6 = Hb(), ovt = () => ({
  MuiAccordion: {
    defaultProps: {
      TransitionProps: {
        unmountOnExit: !0
      }
    }
  },
  MuiAccordionSummary: {
    styleOverrides: {
      root: {
        minHeight: "36px",
        [`& .${Op.content}`]: {
          margin: "8px 0"
        }
      }
    }
  },
  MuiAvatar: {
    styleOverrides: {
      root: {
        fontSize: 14,
        fontWeight: 600,
        letterSpacing: 0
      }
    }
  },
  MuiButton: {
    styleOverrides: {
      root: {
        borderRadius: "10px",
        textTransform: "none"
      },
      sizeSmall: {
        padding: "4px 12px"
      },
      sizeMedium: {
        padding: "6px 16px"
      },
      sizeLarge: {
        padding: "8px 20px"
      },
      textSizeSmall: {
        padding: "5px 10px"
      },
      textSizeMedium: {
        padding: "7px 12px"
      },
      textSizeLarge: {
        padding: "9px 16px"
      }
    }
  },
  MuiCard: {
    styleOverrides: {
      root: {
        borderRadius: 20
      }
    }
  },
  MuiCardContent: {
    styleOverrides: {
      root: {
        padding: "10px 15px",
        "&:last-child": {
          paddingBottom: "10px"
        }
      }
    }
  },
  MuiCardHeader: {
    defaultProps: {
      titleTypographyProps: {
        variant: "h6"
      },
      subheaderTypographyProps: {
        variant: "body2"
      }
    }
  },
  MuiCheckbox: {
    styleOverrides: {
      root: {
        padding: "2px",
        margin: "3px 3px 3px 9px",
        width: "20px",
        height: "20px",
        "& svg": {
          width: "20px",
          height: "20px"
        }
      }
    },
    defaultProps: {
      checkedIcon: /* @__PURE__ */ P.jsx("svg", { fill: "none", height: "16", viewBox: "0 0 16 16", width: "16", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ P.jsx(
        "path",
        {
          clipRule: "evenodd",
          d: "M9 3.5C5.68629 3.5 3 6.18629 3 9.5V15.5C3 18.8137 5.68629 21.5 9 21.5H15C18.3137 21.5 21 18.8137 21 15.5V9.5C21 6.18629 18.3137 3.5 15 3.5H9ZM16.7179 10.1961C17.1024 9.79966 17.0926 9.16657 16.6961 8.7821C16.2997 8.39763 15.6666 8.40737 15.2821 8.80385L10.6667 13.5635L8.7179 11.5539C8.33343 11.1574 7.70034 11.1476 7.30385 11.5321C6.90737 11.9166 6.89763 12.5497 7.2821 12.9461L9.94877 15.6961C10.1371 15.8904 10.3961 16 10.6667 16C10.9372 16 11.1962 15.8904 11.3846 15.6961L16.7179 10.1961Z",
          fill: "currentColor",
          fillRule: "evenodd"
        }
      ) }),
      color: "primary",
      icon: /* @__PURE__ */ P.jsx("svg", { fill: "none", height: "16", viewBox: "0 0 16 16", width: "16", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ P.jsx("rect", { height: "16", rx: "5", stroke: "currentColor", strokeWidth: "2", width: "16", x: "4", y: "4.5" }) }),
      indeterminateIcon: /* @__PURE__ */ P.jsx("svg", { fill: "none", height: "16", viewBox: "0 0 16 16", width: "16", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ P.jsx(
        "path",
        {
          clipRule: "evenodd",
          d: "M9 5.5H15C17.2091 5.5 19 7.29086 19 9.5V15.5C19 17.7091 17.2091 19.5 15 19.5H9C6.79086 19.5 5 17.7091 5 15.5V9.5C5 7.29086 6.79086 5.5 9 5.5ZM3 9.5C3 6.18629 5.68629 3.5 9 3.5H15C18.3137 3.5 21 6.18629 21 9.5V15.5C21 18.8137 18.3137 21.5 15 21.5H9C5.68629 21.5 3 18.8137 3 15.5V9.5ZM8 11.5C7.44772 11.5 7 11.9477 7 12.5C7 13.0523 7.44772 13.5 8 13.5H16C16.5523 13.5 17 13.0523 17 12.5C17 11.9477 16.5523 11.5 16 11.5H8Z",
          fill: "currentColor",
          fillRule: "evenodd"
        }
      ) })
    }
  },
  MuiChip: {
    styleOverrides: {
      root: {
        fontWeight: 500
      }
    }
  },
  MuiCssBaseline: {
    styleOverrides: {
      "*": {
        boxSizing: "border-box"
      },
      html: {
        MozOsxFontSmoothing: "grayscale",
        WebkitFontSmoothing: "antialiased",
        display: "flex",
        flexDirection: "column",
        minHeight: "100%",
        width: "100%"
      },
      body: {
        display: "flex",
        flex: "1 1 auto",
        flexDirection: "column",
        minHeight: "100%",
        width: "100%"
      },
      "& .Mui-disabled": {
        cursor: "not-allowed",
        "& *": {
          cursor: "not-allowed !important"
        }
      },
      "#root, #__next": {
        display: "flex",
        flex: "1 1 auto",
        flexDirection: "column",
        height: "100%",
        width: "100%"
      },
      "#nprogress": {
        pointerEvents: "none"
      },
      "#nprogress .bar": {
        height: 3,
        left: 0,
        position: "fixed",
        top: 0,
        width: "100%",
        zIndex: 2e3
      }
    }
  },
  MuiIconButton: {
    styleOverrides: {
      sizeSmall: {
        padding: 4
      }
    }
  },
  MuiInputBase: {
    defaultProps: {
      margin: "dense"
    },
    styleOverrides: {
      input: {
        "&::placeholder": {
          opacity: 1
        }
      }
    }
  },
  MuiInput: {
    defaultProps: {
      size: "small"
    },
    styleOverrides: {
      input: {
        fontSize: 14,
        fontWeight: 500,
        lineHeight: "16px"
      }
    }
  },
  MuiInputLabel: {
    defaultProps: {
      margin: "dense"
    }
  },
  MuiFilledInput: {
    defaultProps: {
      margin: "dense"
    },
    styleOverrides: {
      root: {
        backgroundColor: "transparent",
        borderRadius: 8,
        borderStyle: "solid",
        borderWidth: 1,
        overflow: "hidden",
        transition: S6.transitions.create(["border-color", "box-shadow"]),
        "&:before": {
          display: "none"
        },
        "&:after": {
          display: "none"
        }
      },
      input: {
        fontSize: 12,
        fontWeight: 500,
        lineHeight: "14px"
      }
    }
  },
  MuiOutlinedInput: {
    defaultProps: {
      margin: "dense"
    },
    styleOverrides: {
      input: {
        fontSize: 12,
        fontWeight: 500,
        lineHeight: "14px"
      },
      notchedOutline: {
        transition: S6.transitions.create(["border-color", "box-shadow"])
      }
    }
  },
  MuiFormControl: {
    defaultProps: {
      margin: "dense"
    }
  },
  MuiFormLabel: {
    styleOverrides: {
      root: {
        fontSize: 12,
        fontWeight: 500,
        lineHeight: 1,
        [`&.${Yl.filled}`]: {
          transform: "translate(12px, 18px) scale(1)"
        },
        [`&.${Yl.shrink}`]: {
          [`&.${Yl.standard}`]: {
            transform: "translate(0, -1.5px) scale(0.85)"
          },
          [`&.${Yl.filled}`]: {
            transform: "translate(12px, 6px) scale(0.85)"
          },
          [`&.${Yl.outlined}`]: {
            transform: "translate(14px, -9px) scale(0.85)"
          }
        }
      }
    }
  },
  MuiLinearProgress: {
    styleOverrides: {
      root: {
        borderRadius: 3,
        overflow: "hidden"
      }
    }
  },
  MuiLink: {
    defaultProps: {
      underline: "hover"
    }
  },
  MuiListItemIcon: {
    styleOverrides: {
      root: {
        marginRight: "16px",
        minWidth: "unset"
      }
    }
  },
  MuiPaper: {
    styleOverrides: {
      root: {
        backgroundImage: "none"
      }
    }
  },
  MuiPopover: {
    defaultProps: {
      elevation: 16
    }
  },
  MuiRadio: {
    styleOverrides: {
      root: {
        padding: "2px",
        margin: "3px 3px 3px 9px",
        width: "20px",
        height: "20px",
        "& svg": {
          width: "20px",
          height: "20px"
        }
      }
    }
  },
  MuiSwitch: {
    defaultProps: {
      color: "primary"
    }
  },
  MuiTab: {
    styleOverrides: {
      root: {
        fontSize: 12,
        fontWeight: 500,
        lineHeight: 1.5,
        minWidth: "auto",
        paddingLeft: 0,
        paddingRight: 0,
        textTransform: "none",
        "& + &": {
          marginLeft: 16
        }
      }
    }
  },
  MuiTableCell: {
    styleOverrides: {
      root: {
        padding: "12px 14px"
      }
    }
  },
  MuiTableHead: {
    styleOverrides: {
      root: {
        borderBottom: "none",
        [`& .${Xp.root}`]: {
          borderBottom: "none",
          fontSize: 10,
          fontWeight: 600,
          lineHeight: 1,
          letterSpacing: 0.5,
          textTransform: "uppercase"
        },
        [`& .${Xp.paddingCheckbox}`]: {
          paddingTop: 4,
          paddingBottom: 4
        }
      }
    }
  },
  MuiTextField: {
    defaultProps: {
      margin: "dense",
      variant: "filled"
    }
  },
  MuiFormHelperText: {
    styleOverrides: {
      root: {
        minHeight: "0.625em",
        margin: "3px 14px 5px"
      }
    }
  },
  MuiDivider: {
    styleOverrides: {
      root: {
        borderWidth: "1px",
        margin: "10px 0"
      }
    }
  }
}), svt = (e) => {
  const { direction: t = "ltr" } = e;
  return {
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 900,
        lg: 1200,
        xl: 1440
      }
    },
    components: ovt(),
    direction: t,
    shape: {
      borderRadius: 8
    },
    typography: ivt(),
    spacing: 5
  };
}, avt = ({ palette: e }) => ({
  MuiAvatar: {
    styleOverrides: {
      root: {
        backgroundColor: e.neutral[300],
        color: mu.black
      }
    }
  },
  MuiBackdrop: {
    styleOverrides: {
      root: {
        [`&:not(.${jU.invisible})`]: {
          backgroundColor: Yt(mu.black, 0.5)
        }
      }
    }
  },
  MuiCard: {
    styleOverrides: {
      root: {
        [`&.${bU.elevation1}`]: {
          boxShadow: "0px 5px 22px rgba(0, 0, 0, 0.08), 0px 0px 0px 0.5px rgba(0, 0, 0, 0.06)"
        }
      }
    }
  },
  MuiChip: {
    styleOverrides: {
      icon: {
        color: e.action.active
      },
      root: {
        borderColor: e.neutral[700]
      }
    }
  },
  MuiCssBaseline: {
    styleOverrides: {
      "#nprogress .bar": {
        backgroundColor: e.primary.main
      },
      ".slick-dots li button": {
        "&:before": {
          fontSize: 10,
          color: e.primary.main
        }
      },
      ".slick-dots li.slick-active button": {
        "&:before": {
          color: e.primary.main
        }
      }
    }
  },
  MuiInputBase: {
    styleOverrides: {
      input: {
        "&::placeholder": {
          color: e.text.secondary
        }
      }
    }
  },
  MuiFilledInput: {
    styleOverrides: {
      root: {
        borderColor: e.divider,
        "&:hover": {
          backgroundColor: e.action.hover
        },
        [`&.${wi.disabled}`]: {
          backgroundColor: "transparent"
        },
        [`&.${wi.focused}`]: {
          backgroundColor: "transparent",
          borderColor: e.primary.main,
          boxShadow: `${e.primary.main} 0 0 0 2px`
        },
        [`&.${wi.error}`]: {
          borderColor: e.error.main,
          boxShadow: `${e.error.main} 0 0 0 2px`
        }
      }
    }
  },
  MuiOutlinedInput: {
    styleOverrides: {
      root: {
        "&:hover": {
          backgroundColor: e.action.hover,
          [`& .${Vi.notchedOutline}`]: {
            borderColor: e.divider
          }
        },
        [`&.${Vi.focused}`]: {
          backgroundColor: "transparent",
          [`& .${Vi.notchedOutline}`]: {
            borderColor: e.primary.main,
            borderWidth: "3px"
          }
        },
        [`&.${wi.error}`]: {
          [`& .${Vi.notchedOutline}`]: {
            borderColor: e.error.main,
            borderWidth: "3px"
          }
        }
      },
      notchedOutline: {
        borderColor: e.divider
      }
    }
  },
  MuiSwitch: {
    styleOverrides: {
      switchBase: {
        color: e.neutral[500]
      },
      track: {
        backgroundColor: e.neutral[400],
        opacity: 1
      }
    }
  },
  MuiTableCell: {
    styleOverrides: {
      root: {
        borderBottomColor: e.divider
      }
    }
  },
  MuiTableHead: {
    styleOverrides: {
      root: {
        [`& .${Xp.root}`]: {
          backgroundColor: e.neutral[800],
          color: e.neutral[400]
        }
      }
    }
  },
  // @ts-expect-error This is temporary and needs resolved here and in Provider Portal
  MuiTimelineConnector: {
    styleOverrides: {
      root: {
        backgroundColor: e.divider
      }
    }
  },
  MuiTooltip: {
    styleOverrides: {
      tooltip: {
        backdropFilter: "blur(6px)",
        background: Yt(e.neutral[900], 0.8)
      }
    }
  }
}), AZ = (e) => {
  switch (e) {
    case "blue":
      return Sj;
    case "green":
      return $Ke;
    case "indigo":
      return NKe;
    case "purple":
      return MKe;
    default:
      return console.error('Invalid color preset, accepted values: "blue", "green", "indigo" or "purple"".'), Sj;
  }
}, lvt = (e) => {
  const { colorPreset: t, contrast: n } = e;
  return {
    action: {
      active: ji[500],
      disabled: Yt(ji[100], 0.38),
      disabledBackground: Yt(ji[100], 0.12),
      focus: Yt(ji[100], 0.16),
      hover: Yt(ji[100], 0.04),
      selected: Yt(ji[100], 0.12)
    },
    background: {
      default: n === "high" ? "#0B0F19" : "#0E1320",
      paper: ji[900]
    },
    divider: "#2D3748",
    error: Ua,
    info: vq,
    mode: "dark",
    neutral: ji,
    primary: AZ(t),
    success: bq,
    text: {
      primary: "#EDF2F7",
      secondary: "#A0AEC0",
      disabled: "rgba(255, 255, 255, 0.48)"
    },
    warning: xq
  };
}, uvt = () => [
  "none",
  "0px 1px 2px rgba(0, 0, 0, 0.24)",
  "0px 1px 2px rgba(0, 0, 0, 0.24)",
  "0px 1px 4px rgba(0, 0, 0, 0.24)",
  "0px 1px 5px rgba(0, 0, 0, 0.24)",
  "0px 1px 6px rgba(0, 0, 0, 0.24)",
  "0px 2px 6px rgba(0, 0, 0, 0.24)",
  "0px 3px 6px rgba(0, 0, 0, 0.24)",
  "0px 4px 6px rgba(0, 0, 0, 0.24)",
  "0px 5px 12px rgba(0, 0, 0, 0.24)",
  "0px 5px 14px rgba(0, 0, 0, 0.24)",
  "0px 5px 15px rgba(0, 0, 0, 0.24)",
  "0px 6px 15px rgba(0, 0, 0, 0.24)",
  "0px 7px 15px rgba(0, 0, 0, 0.24)",
  "0px 8px 15px rgba(0, 0, 0, 0.24)",
  "0px 9px 15px rgba(0, 0, 0, 0.24)",
  "0px 10px 15px rgba(0, 0, 0, 0.24)",
  "0px 12px 22px rgba(0, 0, 0, 0.24)",
  "0px 13px 22px rgba(0, 0, 0, 0.24)",
  "0px 14px 24px rgba(0, 0, 0, 0.24)",
  "0px 20px 25px rgba(0, 0, 0, 0.24)",
  "0px 25px 50px rgba(0, 0, 0, 0.24)",
  "0px 25px 50px rgba(0, 0, 0, 0.24)",
  "0px 25px 50px rgba(0, 0, 0, 0.24)",
  "0px 25px 50px rgba(0, 0, 0, 0.24)"
], cvt = (e) => {
  const { colorPreset: t, contrast: n } = e, r = lvt({ colorPreset: t, contrast: n }), i = avt({ palette: r }), o = uvt();
  return {
    components: i,
    palette: r,
    shadows: o
  };
}, dvt = ({ palette: e }) => ({
  MuiAvatar: {
    styleOverrides: {
      root: {
        backgroundColor: e.neutral[200],
        color: mu.black
      }
    }
  },
  MuiBackdrop: {
    styleOverrides: {
      root: {
        [`&:not(.${jU.invisible})`]: {
          backgroundColor: Yt(e.neutral[900], 0.75)
        }
      }
    }
  },
  MuiCard: {
    styleOverrides: {
      root: {
        [`&.${bU.elevation1}`]: {
          boxShadow: "0px 5px 22px rgba(0, 0, 0, 0.04), 0px 0px 0px 0.5px rgba(0, 0, 0, 0.03)"
        }
      }
    }
  },
  MuiChip: {
    styleOverrides: {
      icon: {
        color: e.action.active
      },
      root: {
        borderColor: e.neutral[200]
      }
    }
  },
  MuiCssBaseline: {
    styleOverrides: {
      "#nprogress .bar": {
        backgroundColor: e.primary.main
      },
      ".slick-dots li button": {
        "&:before": {
          fontSize: 10,
          color: e.primary.main
        }
      },
      ".slick-dots li.slick-active button": {
        "&:before": {
          color: e.primary.main
        }
      }
    }
  },
  MuiInputBase: {
    styleOverrides: {
      input: {
        "&::placeholder": {
          color: e.text.secondary
        }
      }
    }
  },
  MuiFilledInput: {
    styleOverrides: {
      root: {
        borderColor: e.neutral[200],
        "&:hover": {
          backgroundColor: e.action.hover
        },
        [`&.${wi.disabled}`]: {
          backgroundColor: "rgba(0, 0, 0, 0.075)"
        },
        [`&.${wi.focused}`]: {
          backgroundColor: "transparent",
          borderColor: e.primary.main,
          boxShadow: `${e.primary.main} 0 0 0 2px`
        },
        [`&.${wi.error}`]: {
          borderColor: e.error.main,
          boxShadow: `${e.error.main} 0 0 0 2px`
        }
      }
    }
  },
  MuiOutlinedInput: {
    styleOverrides: {
      root: {
        "&:hover": {
          backgroundColor: e.action.hover,
          [`& .${Vi.notchedOutline}`]: {
            borderColor: e.neutral[200]
          }
        },
        [`&.${Vi.disabled}`]: {
          backgroundColor: "rgba(0, 0, 0, 0.075)"
        },
        [`&.${Vi.focused}`]: {
          backgroundColor: "transparent",
          [`& .${Vi.notchedOutline}`]: {
            borderColor: e.primary.main,
            borderWidth: "3px"
          }
        },
        [`&.${wi.error}`]: {
          [`& .${Vi.notchedOutline}`]: {
            borderColor: e.error.main,
            borderWidth: "3px"
          }
        }
      },
      notchedOutline: {
        borderColor: e.neutral[200]
      }
    }
  },
  MuiSwitch: {
    styleOverrides: {
      switchBase: {
        color: e.neutral[500]
      },
      track: {
        backgroundColor: e.neutral[400],
        opacity: 1
      }
    }
  },
  MuiTableCell: {
    styleOverrides: {
      root: {
        borderBottomColor: e.divider
      }
    }
  },
  MuiTableHead: {
    styleOverrides: {
      root: {
        [`& .${Xp.root}`]: {
          backgroundColor: e.neutral[50],
          color: e.neutral[700]
        }
      }
    }
  },
  // @ts-expect-error This is temporary and needs resolved here and in Provider Portal
  MuiTimelineConnector: {
    styleOverrides: {
      root: {
        backgroundColor: e.divider
      }
    }
  },
  MuiTooltip: {
    styleOverrides: {
      tooltip: {
        backdropFilter: "blur(6px)",
        background: Yt(e.neutral[900], 0.8)
      }
    }
  }
}), pvt = (e) => {
  const { colorPreset: t, contrast: n } = e;
  return {
    action: {
      active: ji[500],
      disabled: Yt(ji[900], 0.38),
      disabledBackground: Yt(ji[900], 0.12),
      focus: Yt(ji[900], 0.16),
      hover: Yt(ji[900], 0.04),
      selected: Yt(ji[900], 0.12)
    },
    background: {
      default: n === "high" ? ji[50] : mu.white,
      paper: mu.white
    },
    divider: "#F2F4F7",
    error: Ua,
    info: vq,
    mode: "light",
    neutral: ji,
    primary: AZ(t),
    success: bq,
    text: {
      primary: ji[900],
      secondary: ji[500],
      disabled: Yt(ji[900], 0.38)
    },
    warning: xq
  };
}, fvt = () => [
  "none",
  "0px 1px 2px rgba(0, 0, 0, 0.08)",
  "0px 1px 5px rgba(0, 0, 0, 0.08)",
  "0px 1px 8px rgba(0, 0, 0, 0.08)",
  "0px 1px 10px rgba(0, 0, 0, 0.08)",
  "0px 1px 14px rgba(0, 0, 0, 0.08)",
  "0px 1px 18px rgba(0, 0, 0, 0.08)",
  "0px 2px 16px rgba(0, 0, 0, 0.08)",
  "0px 3px 14px rgba(0, 0, 0, 0.08)",
  "0px 3px 16px rgba(0, 0, 0, 0.08)",
  "0px 4px 18px rgba(0, 0, 0, 0.08)",
  "0px 4px 20px rgba(0, 0, 0, 0.08)",
  "0px 5px 22px rgba(0, 0, 0, 0.08)",
  "0px 5px 24px rgba(0, 0, 0, 0.08)",
  "0px 5px 26px rgba(0, 0, 0, 0.08)",
  "0px 6px 28px rgba(0, 0, 0, 0.08)",
  "0px 6px 30px rgba(0, 0, 0, 0.08)",
  "0px 6px 32px rgba(0, 0, 0, 0.08)",
  "0px 7px 34px rgba(0, 0, 0, 0.08)",
  "0px 7px 36px rgba(0, 0, 0, 0.08)",
  "0px 8px 38px rgba(0, 0, 0, 0.08)",
  "0px 8px 40px rgba(0, 0, 0, 0.08)",
  "0px 8px 42px rgba(0, 0, 0, 0.08)",
  "0px 9px 44px rgba(0, 0, 0, 0.08)",
  "0px 9px 46px rgba(0, 0, 0, 0.08)"
], hvt = ({ colorPreset: e, contrast: t }) => {
  const n = pvt({ colorPreset: e, contrast: t }), r = dvt({ palette: n }), i = fvt();
  return {
    components: r,
    palette: n,
    shadows: i
  };
}, mvt = (e) => {
  let t = Hb(
    // Base options available for both dark and light palette modes
    e.compact === !0 ? svt({
      direction: e.direction
    }) : rvt({
      direction: e.direction
    }),
    // Options based on selected palette mode, color preset and contrast
    e.paletteMode === "dark" ? cvt({
      colorPreset: e.colorPreset,
      contrast: e.contrast
    }) : hvt({
      colorPreset: e.colorPreset,
      contrast: e.contrast
    })
  );
  return t = rRe(t), {
    ...t,
    compactEnabled: e.compact === !0
  };
}, gvt = () => {
  localStorage.setItem(Tr.enableDebuggingKey, "true"), window.location.reload();
}, Mvt = (e) => {
  const n = mvt({
    colorPreset: "indigo",
    contrast: "normal",
    direction: "ltr",
    paletteMode: "light",
    responsiveFontSizes: !0,
    compact: C6 === "off" ? !1 : !!(C6 === "on" || e.compact)
  }), { apiUrl: r, discipline: i, facilityId: o, getAccessToken: s, realm: a } = e, u = () => {
    const c = {};
    function d(f) {
      for (const h in f)
        if (typeof f[h] == "object" && f[h] !== null) {
          if (f[h].type === "CollapsibleSection") {
            const m = f[h].collapseGroup, v = f[h].groupId, x = f[h].defaultExpanded;
            c[m] ? x && (c[m] = v) : c[m] = v;
          }
          d(f[h]);
        }
    }
    return d(e.uiSchema), c;
  };
  return /* @__PURE__ */ P.jsxs(ise, { theme: n, children: [
    /* @__PURE__ */ P.jsx("div", { id: "top" }),
    /* @__PURE__ */ P.jsx(HU, {}),
    /* @__PURE__ */ P.jsx(
      Ktt,
      {
        getAccessToken: s,
        apiUrl: r,
        realm: a,
        facilityId: o,
        discipline: i,
        children: /* @__PURE__ */ P.jsx(RKe, { initialCollapse: u(), children: /* @__PURE__ */ P.jsx(WKe, { children: /* @__PURE__ */ P.jsx(Het, { children: /* @__PURE__ */ P.jsx(evt, { ...e }) }) }) })
      }
    )
  ] });
};
window.enableDebugging = gvt;
window.disableDebugging = TZ;
window.toggleCompactMode = sM;
export {
  Mvt as default
};
